function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("ffza4", function(module, exports) {
    $parcel$export(module.exports, "LazyAtlassianNavigation", ()=>$772c987a24839dcf$export$4caed23aa0274abb);
    var $fDtbf;
    var $2SVPM;
    var $kxZPA;
    const $772c987a24839dcf$export$4caed23aa0274abb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        const bundleReady = (parcelRequire("2KdiI"));
        if (!false) bundleReady.then(()=>{
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return bundleReady;
    }, {
        moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/index.tsx"
    });
});
parcelRegister("2SVPM", function(module, exports) {
    $parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", ()=>$b3ae4dfcfbbe07cd$export$15ca6669ae356831);
    $parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", ()=>$b3ae4dfcfbbe07cd$export$ab75d59423c060f4);
    $parcel$export(module.exports, "measureInitialPageLoadTiming", ()=>$b3ae4dfcfbbe07cd$export$e18462760bac553c);
    $parcel$export(module.exports, "setProductBundleReadyForInitialRender", ()=>$b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65);
    var $jI6pi;
    var $21pfT;
    const $b3ae4dfcfbbe07cd$var$safeMeasure = (name, start, stop)=>{
        try {
            performance.measure(name, start, stop);
        } catch (_err) {}
    };
    const $b3ae4dfcfbbe07cd$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
        if (false) return;
        $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stop);
        (0, (0, parcelRequire("21pfT")).browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
        (0, (0, parcelRequire("jI6pi")).addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
    };
    const $b3ae4dfcfbbe07cd$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
        if (false) return;
        const stopMark = `${name}__stop_mark$`;
        performance.mark(stopMark);
        $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stopMark);
        (0, (0, parcelRequire("21pfT")).browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
        (0, (0, parcelRequire("jI6pi")).addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
    };
    const $b3ae4dfcfbbe07cd$export$e18462760bac553c = (name, fn)=>{
        if (false) return fn();
        const startMark = `${name}__start_mark$`;
        const stopMark = `${name}__stop_mark$`;
        performance.mark(startMark);
        const result = fn();
        performance.mark(stopMark);
        $b3ae4dfcfbbe07cd$var$safeMeasure(name, startMark, stopMark);
        (0, (0, parcelRequire("21pfT")).browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
        (0, (0, parcelRequire("jI6pi")).addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
        return result;
    };
    const $b3ae4dfcfbbe07cd$export$53038a2e9d597818 = async (name, fn)=>{
        if (false) return fn();
        const startMark = `${name}__start_mark$`;
        const stopMark = `${name}__stop_mark$`;
        performance.mark(startMark);
        const result = await fn();
        performance.mark(stopMark);
        (0, (0, parcelRequire("21pfT")).browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
        (0, (0, parcelRequire("jI6pi")).addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
        return result;
    };
    const $b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65 = ()=>{
        if (false) return;
        $b3ae4dfcfbbe07cd$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
    };
});
parcelRegister("jI6pi", function(module, exports) {
    $parcel$export(module.exports, "addTimingFromPerformanceMark", ()=>$0d5c580691017430$export$758b9a33800fa436);
    $parcel$export(module.exports, "getTimings", ()=>$0d5c580691017430$export$6d488733a547304);
    const $0d5c580691017430$var$timings = [];
    function $0d5c580691017430$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
        $0d5c580691017430$var$timings.push({
            name: name,
            startMark: startMark,
            stopMark: stopMark,
            cleanStart: cleanStart,
            cleanStop: cleanStop
        });
    }
    function $0d5c580691017430$export$6d488733a547304() {
        const reportedTimingsObj = {};
        $0d5c580691017430$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
            const startEntryList = performance.getEntriesByName(startMark);
            const stopEntryList = performance.getEntriesByName(stopMark);
            if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
                const startEntry = startEntryList[startEntryList.length - 1];
                const stopEntry = stopEntryList[stopEntryList.length - 1];
                const { startTime: startTime } = startEntry;
                const duration = stopEntry.startTime - startTime;
                const timing = {
                    startTime: Math.round(startTime),
                    duration: Math.round(duration)
                };
                reportedTimingsObj[name] = timing;
            }
            if (cleanStart) performance.clearMarks(startMark);
            if (cleanStop) performance.clearMarks(stopMark);
        });
        return reportedTimingsObj;
    }
});
parcelRegister("2KdiI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kV4Fy")
    ]).then(()=>parcelRequire('jC2al'));
});
parcelRegister("7XYc4", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$d8879edec083173e$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $d8879edec083173e$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("ibkIl", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsLayout", ()=>$3eb51436f6201a33$export$e6aef6083548e882);
    var $2BrOV;
    var $1XrjK;
    const $3eb51436f6201a33$export$e6aef6083548e882 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout));
});
parcelRegister("2BrOV", function(module, exports) {
    $parcel$export(module.exports, "globalLayout", ()=>$6d4ecb0834e594e8$export$929cb72e7acb7fd9);
    var $1XrjK;
    const $6d4ecb0834e594e8$var$rightSidebars = ()=>[];
    const $6d4ecb0834e594e8$export$929cb72e7acb7fd9 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        rightSidebars: $6d4ecb0834e594e8$var$rightSidebars()
    });
});
parcelRegister("1XrjK", function(module, exports) {
    $parcel$export(module.exports, "coalesce", ()=>$3b8b9d6fe762babb$export$6e5538615c060df7);
    $parcel$export(module.exports, "renderGlobalComponents", ()=>$3b8b9d6fe762babb$export$fc28c9563350e5b8);
    $parcel$export(module.exports, "createLayout", ()=>$3b8b9d6fe762babb$export$3dd437ade36ede40);
    $parcel$export(module.exports, "composeLayouts", ()=>$3b8b9d6fe762babb$export$6c041b39c370853f);
    $parcel$export(module.exports, "withProjectContext", ()=>$3b8b9d6fe762babb$export$e97a7da67a5b8ce4);
    var $5uXOq = parcelRequire("5uXOq");
    var $lpwtK;
    var $lfTZh;
    const $3b8b9d6fe762babb$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
    const $3b8b9d6fe762babb$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
            const { displayName: displayName, name: name } = Component;
            const key = $3b8b9d6fe762babb$export$6e5538615c060df7(displayName) ?? $3b8b9d6fe762babb$export$6e5538615c060df7(name) ?? i;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: key?.toString(),
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
                key: key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null)));
        });
    const $3b8b9d6fe762babb$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
            isChromeless: isChromeless,
            globalComponents: Array.from(new Set(globalComponents)),
            rightSidebars: Array.from(new Set(rightSidebars))
        });
    const $3b8b9d6fe762babb$export$6c041b39c370853f = (...layouts)=>{
        if (layouts.length === 1) return $3b8b9d6fe762babb$export$3dd437ade36ede40(layouts[0]);
        const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
                isChromeless: isChromeless,
                globalComponents: [
                    ...l.globalComponents,
                    ...globalComponents
                ],
                rightSidebars: [
                    ...l.rightSidebars,
                    ...rightSidebars
                ]
            }), {
            globalComponents: [],
            rightSidebars: [],
            isChromeless: false
        });
        return $3b8b9d6fe762babb$export$3dd437ade36ede40(layout);
    };
    const $3b8b9d6fe762babb$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    const $3b8b9d6fe762babb$var$formatPrefix = (style, type)=>{
        if (!style && !type) return 'Empty';
        if (style === 'any' && type === 'any') return 'Any';
        const formattedStyle = $3b8b9d6fe762babb$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
        if (type === 'any') return formattedStyle;
        const formattedType = $3b8b9d6fe762babb$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
        if (style === 'any') return formattedType;
        return `${formattedStyle}${formattedType}`;
    };
    const $3b8b9d6fe762babb$export$e97a7da67a5b8ce4 = (Component, options)=>{
        const { project: expectedProject } = options;
        const ScopedComponent = ()=>{
            const { data: project, loading: loading } = (0, (0, parcelRequire("lpwtK")).useProject)();
            if (loading) return null;
            if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null);
        };
        const name = $3b8b9d6fe762babb$export$6e5538615c060df7(Component.displayName) ?? $3b8b9d6fe762babb$export$6e5538615c060df7(Component.name) ?? 'Component';
        const prefix = $3b8b9d6fe762babb$var$formatPrefix(expectedProject?.style, expectedProject?.type);
        ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
        return ScopedComponent;
    };
});
parcelRegister("lpwtK", function(module, exports) {
    $parcel$export(module.exports, "useProject", ()=>$f3d7644b5666677d$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bsuuc;
    var $1J3t1;
    const $f3d7644b5666677d$export$51b1383ef8844a7 = (customContext)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)(customContext);
        const project = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("bsuuc")).extractData)(data), [
            data
        ]);
        return {
            data: project,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("bsuuc", function(module, exports) {
    $parcel$export(module.exports, "getStyle", ()=>$36c780ae7e3dc8c8$export$3d2f074408bd1b82);
    $parcel$export(module.exports, "extractData", ()=>$36c780ae7e3dc8c8$export$9df5fa0a366163d2);
    var $2vSU6;
    const $36c780ae7e3dc8c8$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, (0, parcelRequire("2vSU6")).ProjectStyle).NEXT_GEN : (0, (0, parcelRequire("2vSU6")).ProjectStyle).CLASSIC;
    const $36c780ae7e3dc8c8$var$getProject = (project)=>({
            avatarUrl: project.avatarUrls['48x48'],
            id: Number(project.id),
            isSimplified: project.simplified,
            key: project.key,
            name: project.name,
            style: $36c780ae7e3dc8c8$export$3d2f074408bd1b82(project.simplified),
            type: project.projectTypeKey
        });
    const $36c780ae7e3dc8c8$export$9df5fa0a366163d2 = (data)=>{
        const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
        switch(projectType){
            case 'jira_work_management':
                return jiraWorkManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraWorkManagementNavData.project) : null;
            case 'jira_software':
                return jiraSoftwareNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraSoftwareNavData.project) : null;
            case 'jira_service_management':
            case 'jira_customer_service':
                return jiraServiceManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraServiceManagementNavData.project) : null;
            case 'jira_product_discovery':
                return jiraProductDiscoveryNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraProductDiscoveryNavData.project) : null;
            case null:
            default:
                return null;
        }
    };
});
parcelRegister("1J3t1", function(module, exports) {
    $parcel$export(module.exports, "useProjectSidebarNavigation", ()=>$bb292f58b8ec7804$export$5a85006c180fb373);
    $parcel$export(module.exports, "useProjectSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$2bed15cd7d167db5);
    $parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$a9d05fc2c1d94895);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$d48e3c3556894533);
    $parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", ()=>$bb292f58b8ec7804$export$24a781cd863077aa);
    $parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", ()=>$bb292f58b8ec7804$export$e16ecd2512eb0dc7);
    $parcel$export(module.exports, "useJiraSoftwareProjectNavigation", ()=>$bb292f58b8ec7804$export$68dc0ecbea8211d2);
    $parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", ()=>$bb292f58b8ec7804$export$5cf90b625d0e1248);
    $parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", ()=>$bb292f58b8ec7804$export$d63d92edebe543d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $b2pl3;
    var $6zFAI;
    var $gcI3W;
    var $loy04;
    var $ggg5j;
    var $324W5;
    var $dIdda = parcelRequire("dIdda");
    var $727Q1;
    const $bb292f58b8ec7804$export$5a85006c180fb373 = (customContext)=>{
        const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), customContext);
        const memoizedResponse = (0, $5uXOq.useMemo)(()=>navResponse, [
            navResponse
        ]);
        (0, (0, parcelRequire("727Q1")).useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
        return {
            data: memoizedResponse,
            loading: memoizedResponse != null ? false : loading,
            refresh: refresh,
            clearAll: clearAll,
            error: error,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$2bed15cd7d167db5 = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$a9d05fc2c1d94895 = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$d48e3c3556894533 = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$24a781cd863077aa = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("b2pl3")).staticJSMProjectConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$e16ecd2512eb0dc7 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraWorkManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$68dc0ecbea8211d2 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraSoftwareNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$5cf90b625d0e1248 = (customContext)=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373(customContext);
        const response = data?.jiraServiceManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$d63d92edebe543d9 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraProductDiscoveryNavData || null;
        return {
            data: response,
            ...rest
        };
    };
});
parcelRegister("b2pl3", function(module, exports) {
    $parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", ()=>$565682b770797f58$export$fab84295e18e9246);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $jAGOQ;
    const $565682b770797f58$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $565682b770797f58$export$fab84295e18e9246 = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
        getKey: ({ match: match, query: query })=>$565682b770797f58$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $565682b770797f58$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("1nb22", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyId", ()=>$061afadfbcc74f44$export$1f7213d0f9054f06);
    const $061afadfbcc74f44$export$1f7213d0f9054f06 = (match, query)=>{
        const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
        const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
        return {
            projectKey: projectKey,
            projectId: projectId
        };
    };
});
parcelRegister("jAGOQ", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", ()=>$45e9310ad65e3e88$export$b15f9f5cf6db359e);
    var $eusud;
    const $45e9310ad65e3e88$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
        if (projectKeyOrId == null) throw new Error('invalid identifier specified');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
    };
});
parcelRegister("eusud", function(module, exports) {
    $parcel$export(module.exports, "transformValidationErrorFromServer", ()=>$3637c0f7edbd2bb4$export$8e9baed7697e4959);
    $parcel$export(module.exports, "applyErrorHandling", ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff);
    $parcel$export(module.exports, "performGetRequest", ()=>$3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
    $parcel$export(module.exports, "performPutRequest", ()=>$3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
    $parcel$export(module.exports, "performPostRequest", ()=>$3637c0f7edbd2bb4$export$692a4d9808143175);
    $parcel$export(module.exports, "performDeleteRequest", ()=>$3637c0f7edbd2bb4$export$8ef51cba9d28f819);
    $parcel$export(module.exports, "performPatchRequest", ()=>$3637c0f7edbd2bb4$export$52be6ab13d7e758d);
    $parcel$export(module.exports, "performGetRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$659b5ee69e6eb976);
    $parcel$export(module.exports, "performPutRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$d7b48b2904a5d812);
    $parcel$export(module.exports, "performPostRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$a5717cbee13f28b7);
    var $aDvGo;
    var $co1wz;
    var $jQsty;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    var $6b2ko;
    var $iwPwz;
    const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
                field: field,
                error: fieldErrors[field]
            }));
    const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
        const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
        const fieldErrorsJson = json.errors ?? json.fieldErrors;
        const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
        return new (0, (0, parcelRequire("jJZqs")).ValidationError)(message, fieldErrors, statusCode, traceId, json);
    };
    const $3637c0f7edbd2bb4$var$putOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PUT'
    };
    const $3637c0f7edbd2bb4$var$postOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'POST'
    };
    const $3637c0f7edbd2bb4$var$deleteOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'DELETE'
    };
    const $3637c0f7edbd2bb4$var$patchOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PATCH'
    };
    const $3637c0f7edbd2bb4$var$handleNetworkErrors = (err)=>{
        if (err instanceof TypeError) throw new Error('Failed to fetch', {
            cause: err
        });
        throw err;
    };
    const $3637c0f7edbd2bb4$var$handleErrors = (response)=>{
        const traceId = (0, (0, parcelRequire("iwPwz")).getTraceId)(response);
        if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, (0, parcelRequire("co1wz")).ff)('issue.details.hard-limits.milestone-1') && (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
            throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
        });
        if (!response.ok) {
            if (traceId !== undefined && traceId.length > 0) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, traceId, response);
            else throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, undefined, response);
        }
        return response;
    };
    const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
        if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
        const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
        const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, requestOptions)));
        if ((0, (0, parcelRequire("jQsty")).default)('platform_fetch_retries')) return executeRequest();
        return (0, (0, parcelRequire("6b2ko")).retryOnError)(executeRequest, {
            retryFunc: executeRequest,
            retryPredicate: retryPredicate,
            retryAttempts: retryAttempts,
            onRetry: onRetry
        });
    };
    const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$putOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$postOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$deleteOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$patchOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        });
    const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$putOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$postOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$deleteOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$patchOptions,
            ...options
        });
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("6b2ko", function(module, exports) {
    $parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", ()=>$6910b563ec955346$export$81189edc9b923717);
    $parcel$export(module.exports, "retryOnError", ()=>$6910b563ec955346$export$f859c88bfac2cf2c);
    const $6910b563ec955346$export$81189edc9b923717 = 1;
    const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
        const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
        const execute = async (getPromise, retryAttempt = 0)=>{
            try {
                return await getPromise();
            } catch (error) {
                const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
                if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                    onRetry && onRetry(error, retryAttempt + 1);
                    return execute(retryFunc, retryAttempt + 1);
                }
                throw error;
            }
        };
        return execute(initialPromiseGetter);
    };
});
parcelRegister("6zFAI", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", ()=>$ee61b377cbb3343f$export$b8c6e2666f12f4bb);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $jAGOQ;
    const $ee61b377cbb3343f$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $ee61b377cbb3343f$export$b8c6e2666f12f4bb = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$ee61b377cbb3343f$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $ee61b377cbb3343f$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const projectHomeAddonNavInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
            return projectHomeAddonNavInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("gcI3W", function(module, exports) {
    $parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", ()=>$e60f9280597d4f0e$export$b662f3f877add30d);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $jAGOQ;
    const $e60f9280597d4f0e$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $e60f9280597d4f0e$export$b662f3f877add30d = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$e60f9280597d4f0e$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $e60f9280597d4f0e$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("loy04", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$c5a0b9808c0c3182$export$e4bf33528101348c);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$c5a0b9808c0c3182$export$2d5a704ae6f6b050);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $jAGOQ;
    const $c5a0b9808c0c3182$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $c5a0b9808c0c3182$export$e4bf33528101348c = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$c5a0b9808c0c3182$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $c5a0b9808c0c3182$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
            return navInfo;
        },
        maxAge: 300000
    });
    const $c5a0b9808c0c3182$export$2d5a704ae6f6b050 = ()=>(0, $dIdda.useResource)($c5a0b9808c0c3182$export$e4bf33528101348c);
});
parcelRegister("ggg5j", function(module, exports) {
    $parcel$export(module.exports, "getIdentifier", ()=>$3ec7290d9b237c27$export$adb27ddab077e944);
    $parcel$export(module.exports, "staticProjectSidebarNavigationResource", ()=>$3ec7290d9b237c27$export$f2dfc0f7b2d92691);
    $parcel$export(module.exports, "useSidebarNavigationResource", ()=>$3ec7290d9b237c27$export$b692cfadccf4e047);
    var $65Ltd;
    var $95bh0;
    var $8YTna;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $gDyED;
    const $3ec7290d9b237c27$export$adb27ddab077e944 = (routeName, match, query)=>{
        if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR) || query['servicedesk.serviceDeskId']) {
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId
            });
        }
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
        return (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId,
            boardId: boardId
        });
    };
    const $3ec7290d9b237c27$var$getRouterKey = (routeName, match, query)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = $3ec7290d9b237c27$export$adb27ddab077e944(routeName, match, query);
        if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
        return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
    };
    const $3ec7290d9b237c27$export$f2dfc0f7b2d92691 = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
        getKey: ({ match: match, query: query, route: { name: name } })=>$3ec7290d9b237c27$var$getRouterKey(name, match, query),
        getData: async ({ match: match, query: query, route: { name: name } })=>{
            const scopeIdentifier = $3ec7290d9b237c27$export$adb27ddab077e944(name, match, query);
            if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
            const navInfo = await (0, (0, parcelRequire("gDyED")).fetchProjectSidebarNavInfo)(scopeIdentifier);
            return navInfo;
        },
        maxAge: 300000
    });
    const $3ec7290d9b237c27$export$b692cfadccf4e047 = ()=>(0, $dIdda.useResource)($3ec7290d9b237c27$export$f2dfc0f7b2d92691);
});
parcelRegister("65Ltd", function(module, exports) {
    $parcel$export(module.exports, "ROUTE_GROUPS_ARCHIVE_ISSUES", ()=>$d90d8ce15e0e3233$export$1ba937db1fe6ef01);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$bbf08d4d25df5504);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_SOFTWARE", ()=>$d90d8ce15e0e3233$export$e3e759b7f50aaee1);
    $parcel$export(module.exports, "ROUTE_GROUPS_COMPONENTS", ()=>$d90d8ce15e0e3233$export$89337611b52bc9a3);
    $parcel$export(module.exports, "ROUTE_GROUPS_CONNECT", ()=>$d90d8ce15e0e3233$export$3d7937b12eb9e5d5);
    $parcel$export(module.exports, "ROUTE_GROUPS_DASHBOARD", ()=>$d90d8ce15e0e3233$export$7a3d181d86fce9e6);
    $parcel$export(module.exports, "ROUTE_GROUPS_DEVOPS", ()=>$d90d8ce15e0e3233$export$7a22726acd7d6021);
    $parcel$export(module.exports, "ROUTE_GROUPS_DIRECTORIES", ()=>$d90d8ce15e0e3233$export$f3f4a9f53ba00861);
    $parcel$export(module.exports, "ROUTE_GROUPS_EOC", ()=>$d90d8ce15e0e3233$export$112d69653b2f1d8b);
    $parcel$export(module.exports, "ROUTE_GROUPS_ERRORS", ()=>$d90d8ce15e0e3233$export$74e0426b66571086);
    $parcel$export(module.exports, "ROUTE_GROUPS_GLOBAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$c2e20e142c95c1ce);
    $parcel$export(module.exports, "ROUTE_GROUPS_HELP_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$f8cea29bebf098c);
    $parcel$export(module.exports, "ROUTE_GROUPS_HOME", ()=>$d90d8ce15e0e3233$export$5801ef8dfc9a2f70);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE", ()=>$d90d8ce15e0e3233$export$7246838143f848f3);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$54f96702980a2f87);
    $parcel$export(module.exports, "ROUTE_GROUPS_LEGACY", ()=>$d90d8ce15e0e3233$export$5566db8fbd042fc4);
    $parcel$export(module.exports, "ROUTE_GROUPS_MARKETPLACE", ()=>$d90d8ce15e0e3233$export$656d0cc2c67b2708);
    $parcel$export(module.exports, "ROUTE_GROUPS_PEOPLE_PROFILES", ()=>$d90d8ce15e0e3233$export$bfdbcebc4c81b043);
    $parcel$export(module.exports, "ROUTE_GROUPS_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$82021d71ad19e227);
    $parcel$export(module.exports, "ROUTE_GROUPS_PLAN_SETTINGS", ()=>$d90d8ce15e0e3233$export$6f266218a6973848);
    $parcel$export(module.exports, "ROUTE_GROUPS_POLARIS", ()=>$d90d8ce15e0e3233$export$a846fcaeeea8e0ff);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROFORMA", ()=>$d90d8ce15e0e3233$export$6c87a9dff4e7a2de);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC", ()=>$d90d8ce15e0e3233$export$ab79970dcfac06a1);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CORE", ()=>$d90d8ce15e0e3233$export$d1a70f80bb22f18a);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$bd925e9fcb6ce37f);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE", ()=>$d90d8ce15e0e3233$export$86509a1baabd62ee);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE_BOARDS", ()=>$d90d8ce15e0e3233$export$98823ed9eedfc756);
    $parcel$export(module.exports, "ROUTE_GROUPS_REDIRECTS", ()=>$d90d8ce15e0e3233$export$da8d13fe1ccd5c09);
    $parcel$export(module.exports, "ROUTE_GROUPS_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$78fb2f6176b7c6b8);
    $parcel$export(module.exports, "ROUTE_GROUPS_SOFTWARE", ()=>$d90d8ce15e0e3233$export$26efaec7a7a8b361);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY", ()=>$d90d8ce15e0e3233$export$88041353cc69458d);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$f88d57dcb03ba452);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$e8aa63af071c2da9);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK", ()=>$d90d8ce15e0e3233$export$b114d0da2ebcff6c);
    $parcel$export(module.exports, "ROUTE_NAMES_BOARDS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$29cc94b8cea5c920);
    $parcel$export(module.exports, "ROUTE_NAMES_BROWSE_PROJECT_REDIRECT", ()=>$d90d8ce15e0e3233$export$4d1b45005cdcfb39);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_BOARD", ()=>$d90d8ce15e0e3233$export$a42ea04fdf53eeaf);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS", ()=>$d90d8ce15e0e3233$export$ca4c5f5b3e2daa18);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_REPORTS", ()=>$d90d8ce15e0e3233$export$d58a5411a2ac6260);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED", ()=>$d90d8ce15e0e3233$export$24514ee19772b5af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR", ()=>$d90d8ce15e0e3233$export$ec333dd1d6a8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT", ()=>$d90d8ce15e0e3233$export$ed495fbad44791af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY", ()=>$d90d8ce15e0e3233$export$5281552f8109b7c0);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE", ()=>$d90d8ce15e0e3233$export$6e8473713ed4557a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS", ()=>$d90d8ce15e0e3233$export$cbdd5c24d69b2cb1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS", ()=>$d90d8ce15e0e3233$export$e7f012f402be01ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD", ()=>$d90d8ce15e0e3233$export$b34d3882b42d660d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED", ()=>$d90d8ce15e0e3233$export$ed869c60c6a56182);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR", ()=>$d90d8ce15e0e3233$export$5013269f29c75b37);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$fc8b48319e993d43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM", ()=>$d90d8ce15e0e3233$export$d6e60a2059f028d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$3d589aae17a00bc9);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT", ()=>$d90d8ce15e0e3233$export$bd92ef03b23dd672);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED", ()=>$d90d8ce15e0e3233$export$fa7fc44c718fc850);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST", ()=>$d90d8ce15e0e3233$export$1dffaf831e01e2b4);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED", ()=>$d90d8ce15e0e3233$export$5f8187412dd60f35);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING", ()=>$d90d8ce15e0e3233$export$3d2c1c04d18f6c43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT", ()=>$d90d8ce15e0e3233$export$cd22a5d8f560a1d8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY", ()=>$d90d8ce15e0e3233$export$cad1b1aa5ce26bbc);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED", ()=>$d90d8ce15e0e3233$export$ee073463b4144367);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE", ()=>$d90d8ce15e0e3233$export$ea034943499772ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED", ()=>$d90d8ce15e0e3233$export$19bc888bcf37d22d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT", ()=>$d90d8ce15e0e3233$export$e0746183e11767fb);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE", ()=>$d90d8ce15e0e3233$export$3e2d215ce157adc8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS", ()=>$d90d8ce15e0e3233$export$8a8485bb05daf40b);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$a2799b01de5bb62);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES", ()=>$d90d8ce15e0e3233$export$2d4f89c4b1ee3640);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$d90d8ce15e0e3233$export$75609d3416c31f79);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$79793dc26e0b7b1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE", ()=>$d90d8ce15e0e3233$export$2eda7466fbfdef43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$d90d8ce15e0e3233$export$417297669917ee1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$8c79f3309ac0737);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$ef71a22e7befd35c);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS", ()=>$d90d8ce15e0e3233$export$62ba1e294f5007c1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS", ()=>$d90d8ce15e0e3233$export$a4315324546ecc89);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN", ()=>$d90d8ce15e0e3233$export$a653cf6d478b3df1);
    $parcel$export(module.exports, "ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS", ()=>$d90d8ce15e0e3233$export$b0f268fe53a03e98);
    $parcel$export(module.exports, "ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS", ()=>$d90d8ce15e0e3233$export$f4160b48e4ab8f39);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL", ()=>$d90d8ce15e0e3233$export$608f359cf8b08d2e);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_INVALID", ()=>$d90d8ce15e0e3233$export$8bfbf790fe89f8d3);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT", ()=>$d90d8ce15e0e3233$export$d7011d1ed949f970);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$bd2506db44585db6);
    $parcel$export(module.exports, "ROUTE_NAMES_CREATE_PROJECT", ()=>$d90d8ce15e0e3233$export$200fa5ad16f8c112);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD", ()=>$d90d8ce15e0e3233$export$a296bb962bea95b5);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$b9960c143c0414eb);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE", ()=>$d90d8ce15e0e3233$export$411171d2fcaefaea);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$ee104ed514f63003);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_SELECTED", ()=>$d90d8ce15e0e3233$export$9233f9ddcecd3062);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW", ()=>$d90d8ce15e0e3233$export$b3240ec044a6c70f);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW_EMBED", ()=>$d90d8ce15e0e3233$export$2463c779e12367e3);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_WALLBOARD", ()=>$d90d8ce15e0e3233$export$dd3e5187eae2abe9);
    $parcel$export(module.exports, "ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT", ()=>$d90d8ce15e0e3233$export$38ca7e07048a5bfd);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING", ()=>$d90d8ce15e0e3233$export$48749e87cc44a5a5);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE", ()=>$d90d8ce15e0e3233$export$21c230ef79df9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL", ()=>$d90d8ce15e0e3233$export$d2d813dd057a8352);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_API_KEY_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$54ed2374d14a7e88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES", ()=>$d90d8ce15e0e3233$export$58368fe796f5ecb4);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_AUTOMATIONS", ()=>$d90d8ce15e0e3233$export$bbb4032f8f259109);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_CUSTOM_ROLES", ()=>$d90d8ce15e0e3233$export$5b17b30c2dd69cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERTS", ()=>$d90d8ce15e0e3233$export$d18d0b9a9e85e59c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL", ()=>$d90d8ce15e0e3233$export$5126a481501fc518);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL", ()=>$d90d8ce15e0e3233$export$40e720d8c26e6804);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE", ()=>$d90d8ce15e0e3233$export$dc8ac1f7e9373a32);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORTS", ()=>$d90d8ce15e0e3233$export$8ca3e3f0326ba27f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD", ()=>$d90d8ce15e0e3233$export$c3d17be12795c864);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_HEARTBEATS", ()=>$d90d8ce15e0e3233$export$9cd1c70eda5cae15);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL", ()=>$d90d8ce15e0e3233$export$99f769b27f537a72);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL", ()=>$d90d8ce15e0e3233$export$5c5fe79d3f9ec214);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATIONS", ()=>$d90d8ce15e0e3233$export$901b974cf0954c88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_CREATE", ()=>$d90d8ce15e0e3233$export$b2dd23a345bd5cb3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_DETAIL", ()=>$d90d8ce15e0e3233$export$8ae7cbc0a73f9351);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LIST", ()=>$d90d8ce15e0e3233$export$8057ebe7fb7f7f8d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LOG", ()=>$d90d8ce15e0e3233$export$a22387b9744e62e3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_MAINTENANCE", ()=>$d90d8ce15e0e3233$export$f6fefa9d2e5bbda1);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL", ()=>$d90d8ce15e0e3233$export$e6de4aa6c719d2b);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL_REDIRECT", ()=>$d90d8ce15e0e3233$export$b195ada84b7e695f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW", ()=>$d90d8ce15e0e3233$export$1800d32171b754a6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS", ()=>$d90d8ce15e0e3233$export$d22a153bfcbaaaa0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$a9a41c76994b6ae9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_POLICIES", ()=>$d90d8ce15e0e3233$export$5bd6f2569c3cfd5c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS", ()=>$d90d8ce15e0e3233$export$dc70eff53ff26c70);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_TEAM", ()=>$d90d8ce15e0e3233$export$1fe2ca96b360df19);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE", ()=>$d90d8ce15e0e3233$export$1ff01e77517a80b0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$de3f8f3198f8213a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL", ()=>$d90d8ce15e0e3233$export$b2cb569d360db382);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_SCHEDULES", ()=>$d90d8ce15e0e3233$export$a0d9033eb64fd80f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERTS", ()=>$d90d8ce15e0e3233$export$da985e953465731f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS", ()=>$d90d8ce15e0e3233$export$b7eee2afd0a5c6b9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING", ()=>$d90d8ce15e0e3233$export$9b6c84986db47d98);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE", ()=>$d90d8ce15e0e3233$export$89276f76fdd700d6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL", ()=>$d90d8ce15e0e3233$export$ea64769f19da8c95);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS", ()=>$d90d8ce15e0e3233$export$4a584839d9a9eb6f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD", ()=>$d90d8ce15e0e3233$export$27d27c817eeb97cc);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL", ()=>$d90d8ce15e0e3233$export$9f533c13cfb48a8f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATIONS", ()=>$d90d8ce15e0e3233$export$6889e571e5aa6ba6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE", ()=>$d90d8ce15e0e3233$export$bdd811277711c53d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL", ()=>$d90d8ce15e0e3233$export$c7b51c0e8ad6f77a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST", ()=>$d90d8ce15e0e3233$export$a348fc7f3b4cfe34);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG", ()=>$d90d8ce15e0e3233$export$a4eff769c94da831);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_POLICIES", ()=>$d90d8ce15e0e3233$export$7c928ca9c9822772);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_UNLOCK_OPERATIONS", ()=>$d90d8ce15e0e3233$export$b48311a8f24f4b63);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_WHO_IS_ON_CALL", ()=>$d90d8ce15e0e3233$export$20649eac204f7661);
    $parcel$export(module.exports, "ROUTE_NAMES_ERRORS_NOT_FOUND", ()=>$d90d8ce15e0e3233$export$62170875a111d729);
    $parcel$export(module.exports, "ROUTE_NAMES_EXTERNAL_IMPORT", ()=>$d90d8ce15e0e3233$export$2928f3d69e7ac609);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$259e18cafd820487);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY_SECURE", ()=>$d90d8ce15e0e3233$export$4b8f333757e638a4);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN", ()=>$d90d8ce15e0e3233$export$ac4f65a14002f892);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN_SETTINGS", ()=>$d90d8ce15e0e3233$export$c73ddc4b44ccb359);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$7ad826b482229119);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_GLOBAL", ()=>$d90d8ce15e0e3233$export$3df864df9b639033);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_PROJECT", ()=>$d90d8ce15e0e3233$export$7d67bf4077ebe18d);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE", ()=>$d90d8ce15e0e3233$export$5ff797dfd5df551f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG", ()=>$d90d8ce15e0e3233$export$8a66ba1da5efa2c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$eadf5aff28def565);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT", ()=>$d90d8ce15e0e3233$export$8f9c045e8fd449b7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_MAIL_SETTINGS", ()=>$d90d8ce15e0e3233$export$1bf439327974644b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR", ()=>$d90d8ce15e0e3233$export$e2a9d163770d0d46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$21b497c57bcd299a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$df5ca261227a6052);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE", ()=>$d90d8ce15e0e3233$export$9f2f4303259b8508);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT", ()=>$d90d8ce15e0e3233$export$7fd53fe07eecc273);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE", ()=>$d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$e05a6c9e9b9b0c48);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST", ()=>$d90d8ce15e0e3233$export$f9759b206b651b1f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES", ()=>$d90d8ce15e0e3233$export$7a337a2687b5d5e3);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS", ()=>$d90d8ce15e0e3233$export$a41998c1a3572e41);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$2c9fe9e6005a9c36);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY", ()=>$d90d8ce15e0e3233$export$5d8d82ff1de3586e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES", ()=>$d90d8ce15e0e3233$export$8a0ed100d885c17c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$1c7041445acf79e8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$e4712523d95125f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$7401274ad357ff94);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$6984b21077857555);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY", ()=>$d90d8ce15e0e3233$export$5a2dae98f768aedf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW", ()=>$d90d8ce15e0e3233$export$5eef1c6eb1388ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS", ()=>$d90d8ce15e0e3233$export$69bcf2c26d45e030);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$ba1417cf5de80f81);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES", ()=>$d90d8ce15e0e3233$export$fdcfcb2e2eb16afd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE", ()=>$d90d8ce15e0e3233$export$5d3e6bffd6b5abfe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE", ()=>$d90d8ce15e0e3233$export$5c676bbb7e3aae9e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE", ()=>$d90d8ce15e0e3233$export$8bb013ced097489a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT", ()=>$d90d8ce15e0e3233$export$e384ae6a87fadedd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH", ()=>$d90d8ce15e0e3233$export$8f55a911c4bd95bf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW", ()=>$d90d8ce15e0e3233$export$d7b98892cb31fba5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD", ()=>$d90d8ce15e0e3233$export$8be4b203f526b2cd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE", ()=>$d90d8ce15e0e3233$export$df09947903c514c4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT", ()=>$d90d8ce15e0e3233$export$cf4a57a81e0bfbca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD", ()=>$d90d8ce15e0e3233$export$bc64365bbb09c05e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE", ()=>$d90d8ce15e0e3233$export$5b12571311ebe766);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT", ()=>$d90d8ce15e0e3233$export$56dc46fe1de63994);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW", ()=>$d90d8ce15e0e3233$export$65af0e5a36d4b4e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES", ()=>$d90d8ce15e0e3233$export$dec448f9d2e50c90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$9ff4144e1dcf9fa4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$8aab6fb9a62dda95);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$9f804a2650117f51);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES", ()=>$d90d8ce15e0e3233$export$7dd4b916600f670);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE", ()=>$d90d8ce15e0e3233$export$c1b40a8a70c0aafa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT", ()=>$d90d8ce15e0e3233$export$ff10d812380db045);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$8deeffdf8dfed878);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES", ()=>$d90d8ce15e0e3233$export$561687f2fa9b9cc9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS", ()=>$d90d8ce15e0e3233$export$691d30818c14141c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT", ()=>$d90d8ce15e0e3233$export$8fa58495105f8fb0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE", ()=>$d90d8ce15e0e3233$export$8304c57494d82ffd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT", ()=>$d90d8ce15e0e3233$export$353609deec72a2ba);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$1cb56e4c132ac8fd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT", ()=>$d90d8ce15e0e3233$export$5fe3eec0a6bda09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD", ()=>$d90d8ce15e0e3233$export$12b56880d6fb7ac7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE", ()=>$d90d8ce15e0e3233$export$9986e8be82998857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT", ()=>$d90d8ce15e0e3233$export$3280ec16231916af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES", ()=>$d90d8ce15e0e3233$export$54885d105d1e2b37);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$f34d87c870f3bf43);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$4108ebf71e36e461);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$d42ec33a6e69686e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES", ()=>$d90d8ce15e0e3233$export$8d2cfabd01e2feaa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$d0fe3726dffeca80);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE", ()=>$d90d8ce15e0e3233$export$b4aa4b2b8fb7267a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT", ()=>$d90d8ce15e0e3233$export$3743711165f5dd4f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES", ()=>$d90d8ce15e0e3233$export$5df6f81deab9567c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$a03360d8b616ef34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$336e54edc189df7f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$53572e9a81205523);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM", ()=>$d90d8ce15e0e3233$export$b71f2ef452117a2a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS", ()=>$d90d8ce15e0e3233$export$f79745fee583cd62);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY", ()=>$d90d8ce15e0e3233$export$2281663e19f399c1);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE", ()=>$d90d8ce15e0e3233$export$38c52d8c5e5dad29);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT", ()=>$d90d8ce15e0e3233$export$10babc3f11b4e6e2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY", ()=>$d90d8ce15e0e3233$export$adf2f51c41b4e22a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT", ()=>$d90d8ce15e0e3233$export$11b217754d4c7d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS", ()=>$d90d8ce15e0e3233$export$3414f0d81f1c11d);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE", ()=>$d90d8ce15e0e3233$export$5574c73a9a5878ca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT", ()=>$d90d8ce15e0e3233$export$cb2626c385b72992);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$fa7aa7cabc3ec459);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING", ()=>$d90d8ce15e0e3233$export$8b0450672651ef67);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$ef510a15f840e437);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE", ()=>$d90d8ce15e0e3233$export$bc159fa4984a907f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT", ()=>$d90d8ce15e0e3233$export$47bfbce13af95d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES", ()=>$d90d8ce15e0e3233$export$c8cb78e94cd3f83c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY", ()=>$d90d8ce15e0e3233$export$4496279df22177be);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$afdfef5d17c56988);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$ac9b4b1136300033);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES", ()=>$d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$c56f5509b93eba68);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$dd9462e97e11637a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$11f8c53e10f63cfb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$758ad3ad6916c9f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY", ()=>$d90d8ce15e0e3233$export$9d65a754315eb617);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$564b665f6ca740dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW", ()=>$d90d8ce15e0e3233$export$256fc89c38c1b9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT", ()=>$d90d8ce15e0e3233$export$ddeae77164bfac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES", ()=>$d90d8ce15e0e3233$export$fa2b355372963545);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$45511e437e54fa02);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION", ()=>$d90d8ce15e0e3233$export$ad76895f03f27a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES", ()=>$d90d8ce15e0e3233$export$1c291d65a59b1636);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD", ()=>$d90d8ce15e0e3233$export$d9bb14d665bfeea5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE", ()=>$d90d8ce15e0e3233$export$8b44cb3da7b8f857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME", ()=>$d90d8ce15e0e3233$export$9ca6a09e1518d3bb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD", ()=>$d90d8ce15e0e3233$export$4c211b3188348679);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE", ()=>$d90d8ce15e0e3233$export$24757bb1837e33af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL", ()=>$d90d8ce15e0e3233$export$95b5d0bd29a3a076);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW", ()=>$d90d8ce15e0e3233$export$d55d4330b58683da);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP", ()=>$d90d8ce15e0e3233$export$f4d5833f0b40a26b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR", ()=>$d90d8ce15e0e3233$export$c78577545f514ca8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES", ()=>$d90d8ce15e0e3233$export$253eb3db7152d010);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS", ()=>$d90d8ce15e0e3233$export$16b4392a63a3eacf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS", ()=>$d90d8ce15e0e3233$export$b2d5a7bc804ed9c9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL", ()=>$d90d8ce15e0e3233$export$f870832f94ca5009);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE", ()=>$d90d8ce15e0e3233$export$8b3a1b2e8e954dc2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE", ()=>$d90d8ce15e0e3233$export$15603150075c3d64);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT", ()=>$d90d8ce15e0e3233$export$92536fe760c41862);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW", ()=>$d90d8ce15e0e3233$export$3f4d05032349dae0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS", ()=>$d90d8ce15e0e3233$export$8ff94a2e5f98315f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER", ()=>$d90d8ce15e0e3233$export$c906c6946fef5d99);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER", ()=>$d90d8ce15e0e3233$export$a1916b723e186494);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS", ()=>$d90d8ce15e0e3233$export$5070b4c974017f28);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS", ()=>$d90d8ce15e0e3233$export$bee7f9f93cb74124);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD", ()=>$d90d8ce15e0e3233$export$efe4008073ab3b69);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE", ()=>$d90d8ce15e0e3233$export$9e40228f1c62d4d9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT", ()=>$d90d8ce15e0e3233$export$223f8094878fea34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$2f589c572415c043);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES", ()=>$d90d8ce15e0e3233$export$8cc394a1f5ca4ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS", ()=>$d90d8ce15e0e3233$export$a11311cd333dae90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL", ()=>$d90d8ce15e0e3233$export$2b2f159267202dcc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS", ()=>$d90d8ce15e0e3233$export$c5a6874288d2e609);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS", ()=>$d90d8ce15e0e3233$export$55dd30b027c838fe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$aee9c7dbf672403c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER", ()=>$d90d8ce15e0e3233$export$75f2fbd33e76028e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT", ()=>$d90d8ce15e0e3233$export$ca57c3dfefb2c826);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT", ()=>$d90d8ce15e0e3233$export$8f2e6f133c022a59);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV", ()=>$d90d8ce15e0e3233$export$bcd741cf5a35ece8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON", ()=>$d90d8ce15e0e3233$export$bfd8ab4625d5c275);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO", ()=>$d90d8ce15e0e3233$export$750a33c4058af733);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS", ()=>$d90d8ce15e0e3233$export$1b66c7594340363f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER", ()=>$d90d8ce15e0e3233$export$fe2fa966509db649);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL", ()=>$d90d8ce15e0e3233$export$373b97e8d136f558);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL", ()=>$d90d8ce15e0e3233$export$64909bb6f2181592);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL", ()=>$d90d8ce15e0e3233$export$53d6ade2eaa2ae84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD", ()=>$d90d8ce15e0e3233$export$e49d7a1ddf301d09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES", ()=>$d90d8ce15e0e3233$export$9469cfde1d14fcac);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS", ()=>$d90d8ce15e0e3233$export$be2e231547dca6dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS", ()=>$d90d8ce15e0e3233$export$ad6f28bbfe57d0a0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS", ()=>$d90d8ce15e0e3233$export$2fb73d5c1c0e7186);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE", ()=>$d90d8ce15e0e3233$export$46b4f43d6ece38fc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT", ()=>$d90d8ce15e0e3233$export$49d1c20d84d46735);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE", ()=>$d90d8ce15e0e3233$export$265062715b11a1ef);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS", ()=>$d90d8ce15e0e3233$export$e9f5eae9444c9b46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG", ()=>$d90d8ce15e0e3233$export$e19bf9459d6eba56);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER", ()=>$d90d8ce15e0e3233$export$40097704c31872d8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$dcdf0405aa7e2078);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL", ()=>$d90d8ce15e0e3233$export$fb75113636566d39);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY", ()=>$d90d8ce15e0e3233$export$e27baa0c7747e67f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS", ()=>$d90d8ce15e0e3233$export$40d189100899f572);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$341933b279728599);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$ae4b815061537207);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL", ()=>$d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE", ()=>$d90d8ce15e0e3233$export$bee46016693b19dc);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_FORMS", ()=>$d90d8ce15e0e3233$export$ca253bc3d237c17f);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_FORM_EDIT", ()=>$d90d8ce15e0e3233$export$a4cba48257cb118a);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_WEB_PORTAL", ()=>$d90d8ce15e0e3233$export$2e90ab5aa3463c0d);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_ONBOARDING_REDIRECT", ()=>$d90d8ce15e0e3233$export$d70320ae3b4d9e43);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_REDIRECT", ()=>$d90d8ce15e0e3233$export$b2b57cde1fa39bf5);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE", ()=>$d90d8ce15e0e3233$export$e8e3b3a04b70a016);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_CREATE_EMBED", ()=>$d90d8ce15e0e3233$export$1a3116351e4f3550);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_EMBED", ()=>$d90d8ce15e0e3233$export$6e2629d41c380b47);
    $parcel$export(module.exports, "ROUTE_NAMES_JIRA_SEARCH", ()=>$d90d8ce15e0e3233$export$ced38e55e6d33a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES", ()=>$d90d8ce15e0e3233$export$d61d16755cb40ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR", ()=>$d90d8ce15e0e3233$export$bb6392f1b2e80781);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY", ()=>$d90d8ce15e0e3233$export$6fd25e722e91a0d8);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES", ()=>$d90d8ce15e0e3233$export$18f32f825e7a5a6f);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES", ()=>$d90d8ce15e0e3233$export$b17f22f274f4cd5e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE", ()=>$d90d8ce15e0e3233$export$285854ec33f7cc);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY", ()=>$d90d8ce15e0e3233$export$77cf9c44bbdaa05b);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE", ()=>$d90d8ce15e0e3233$export$d6f1b92110a16f2a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS", ()=>$d90d8ce15e0e3233$export$fea47b97c6086336);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS", ()=>$d90d8ce15e0e3233$export$264d0a2b60d052cd);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_LANDING", ()=>$d90d8ce15e0e3233$export$991ba0c465b48539);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH", ()=>$d90d8ce15e0e3233$export$904b472d57dee40d);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES", ()=>$d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SETUP", ()=>$d90d8ce15e0e3233$export$8cfdaccf43a32440);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_ALL_REPORTS", ()=>$d90d8ce15e0e3233$export$37bd400c00057d64);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BACKLOG", ()=>$d90d8ce15e0e3233$export$eb66bd587b5f093d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BOARD", ()=>$d90d8ce15e0e3233$export$521baa72494c2a67);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_GENERAL", ()=>$d90d8ce15e0e3233$export$ca255c93be51d5bc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$51e45f736a60769b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CUSTOM_REPORT", ()=>$d90d8ce15e0e3233$export$e64c3c8f45d7eb28);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_FALLBACK", ()=>$d90d8ce15e0e3233$export$5475ba822739444a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN", ()=>$d90d8ce15e0e3233$export$8483f5c57513e386);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_ISSUE", ()=>$d90d8ce15e0e3233$export$93c4d1960660bdb3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH", ()=>$d90d8ce15e0e3233$export$a5421dcc88027406);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS", ()=>$d90d8ce15e0e3233$export$81d5ef2e5cb06446);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_CUSTOMERS", ()=>$d90d8ce15e0e3233$export$77f5621cd10b53c5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED", ()=>$d90d8ce15e0e3233$export$41008c2b014795bf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION", ()=>$d90d8ce15e0e3233$export$3001841111579cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE", ()=>$d90d8ce15e0e3233$export$28dc2fac9c08502e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES", ()=>$d90d8ce15e0e3233$export$4487dfcd6dce7088);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE", ()=>$d90d8ce15e0e3233$export$c344587fa7092e8c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS", ()=>$d90d8ce15e0e3233$export$3fbd487079a23c0f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM", ()=>$d90d8ce15e0e3233$export$d6822df31c37b21a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK", ()=>$d90d8ce15e0e3233$export$d39bcac6fced7707);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE", ()=>$d90d8ce15e0e3233$export$da975f212e8a3e43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES", ()=>$d90d8ce15e0e3233$export$6e6feddeb62a0825);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_WIDGETS", ()=>$d90d8ce15e0e3233$export$d7df906c2ffbeab4);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PIN", ()=>$d90d8ce15e0e3233$export$c71836085985a7d3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES", ()=>$d90d8ce15e0e3233$export$a17a19a9de903839);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO", ()=>$d90d8ce15e0e3233$export$e66c1e847a52ebb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE", ()=>$d90d8ce15e0e3233$export$f0254c80025ed0fc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG", ()=>$d90d8ce15e0e3233$export$1d4a64220d5b474d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS", ()=>$d90d8ce15e0e3233$export$8af215d394bc18c1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD", ()=>$d90d8ce15e0e3233$export$b6b536a795b08b39);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP", ()=>$d90d8ce15e0e3233$export$59cde094247fca1a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW", ()=>$d90d8ce15e0e3233$export$d27bf19e22921164);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG", ()=>$d90d8ce15e0e3233$export$3467807847c0a87d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$1996eeee6a067f1c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE", ()=>$d90d8ce15e0e3233$export$ec7cb9394e8994c9);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV", ()=>$d90d8ce15e0e3233$export$f01730982626c4af);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT", ()=>$d90d8ce15e0e3233$export$9d1758ddc1563e90);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS", ()=>$d90d8ce15e0e3233$export$ecff223feb9d08be);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$487bc26cddb34312);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$d90d8ce15e0e3233$export$118290072826cd87);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY", ()=>$d90d8ce15e0e3233$export$e5994b7b1acebe82);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$84b0e53f785e02cf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$d58992a667105ce8);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$bb1cea2d23743f65);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$76dac5f55ab3705e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$a7c4adb03bc6e997);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE", ()=>$d90d8ce15e0e3233$export$2dc565d0b2334780);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE", ()=>$d90d8ce15e0e3233$export$28687a1181a7676f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$2e74a7026073fa54);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$58fdfc78d176c564);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS", ()=>$d90d8ce15e0e3233$export$cb8548f16119b181);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$66e3f6af203a567f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY", ()=>$d90d8ce15e0e3233$export$658e7e21f1c7b69b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS", ()=>$d90d8ce15e0e3233$export$1fa628a4527d424c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$c2989c5c00f9f64b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REDIRECT", ()=>$d90d8ce15e0e3233$export$2d21e5416485b195);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE", ()=>$d90d8ce15e0e3233$export$e514491aa85dd54a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CONFIG", ()=>$d90d8ce15e0e3233$export$d9662297242bfcb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED", ()=>$d90d8ce15e0e3233$export$2a53516b15393945);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD", ()=>$d90d8ce15e0e3233$export$62e00190aa938a43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_PIE", ()=>$d90d8ce15e0e3233$export$22a3924a6eab79ab);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED", ()=>$d90d8ce15e0e3233$export$677cf3d89d18bb74);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME", ()=>$d90d8ce15e0e3233$export$7eef86163449ad98);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY", ()=>$d90d8ce15e0e3233$export$8f56061e1403fa5a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE", ()=>$d90d8ce15e0e3233$export$adeb429de8df1e02);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT", ()=>$d90d8ce15e0e3233$export$931d6222073b5708);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD", ()=>$d90d8ce15e0e3233$export$2106f1ac8ba807e1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE", ()=>$d90d8ce15e0e3233$export$36678521a86f620b);
    $parcel$export(module.exports, "ROUTE_NAMES_LOGIN_EMBED", ()=>$d90d8ce15e0e3233$export$55248356780fc584);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE", ()=>$d90d8ce15e0e3233$export$cd84c5a333c8d16a);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC", ()=>$d90d8ce15e0e3233$export$624af6f61b05f55);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_APP_REQUESTS", ()=>$d90d8ce15e0e3233$export$2ed9525182145b82);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_INDEX", ()=>$d90d8ce15e0e3233$export$7fb2b42fc4e7df8b);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_MANAGE_APPS", ()=>$d90d8ce15e0e3233$export$fa962db82ae571b2);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_PROMOTIONS", ()=>$d90d8ce15e0e3233$export$e145bf76b1aef705);
    $parcel$export(module.exports, "ROUTE_NAMES_NOTIFICATION_LOGS", ()=>$d90d8ce15e0e3233$export$8febbfb647e4c8b9);
    $parcel$export(module.exports, "ROUTE_NAMES_OPSGENIE_SCHEDULE", ()=>$d90d8ce15e0e3233$export$4b34f3d336f4ccd2);
    $parcel$export(module.exports, "ROUTE_NAMES_PEOPLE_INDEX", ()=>$d90d8ce15e0e3233$export$a979a5c1f5e3631c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$ffcbf91dfadffd0);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL", ()=>$d90d8ce15e0e3233$export$1807a39cc63b856c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$2be8d3c6fedd5276);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$6268da7263eb670d);
    $parcel$export(module.exports, "ROUTE_NAMES_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$93bd4a896a0fc581);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_EDIT", ()=>$d90d8ce15e0e3233$export$2b9b1bfb538ab810);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LIST", ()=>$d90d8ce15e0e3233$export$d1217085321b2648);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_COLLECTIONS", ()=>$d90d8ce15e0e3233$export$39624171b7c8a10a);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_IDEAS", ()=>$d90d8ce15e0e3233$export$1654cd6813e90e6b);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_INSIGHTS", ()=>$d90d8ce15e0e3233$export$33059cd02df2febd);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ONBOARDING", ()=>$d90d8ce15e0e3233$export$1d746ff2bc48ceb4);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_PLAYS", ()=>$d90d8ce15e0e3233$export$145c578104a45fd2);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ROOMS", ()=>$d90d8ce15e0e3233$export$a51df1bc877c58e5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_ACCESS", ()=>$d90d8ce15e0e3233$export$45208fff8de46880);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS", ()=>$d90d8ce15e0e3233$export$c710a35d40378fa5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_UNLICENSED", ()=>$d90d8ce15e0e3233$export$15d6b93ff5273ce3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS", ()=>$d90d8ce15e0e3233$export$e26f2863c7ccd504);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS", ()=>$d90d8ce15e0e3233$export$496da9aa0fe819ff);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE", ()=>$d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$53ce69fb34f6d286);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS", ()=>$d90d8ce15e0e3233$export$b6e861786143eb1b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS", ()=>$d90d8ce15e0e3233$export$f7e3d3b413c017e1);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE", ()=>$d90d8ce15e0e3233$export$b84d34b8175abde5);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS", ()=>$d90d8ce15e0e3233$export$50e4e3e5231fb74f);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS", ()=>$d90d8ce15e0e3233$export$39d913ae557ba8f3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$a2d9bcceac584c93);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS", ()=>$d90d8ce15e0e3233$export$eb2e5f1608ec8b32);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$9ac90b948c53bf58);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$bb5665894498893f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$fc61479fdfdd263a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$5ae82b891e42770e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE", ()=>$d90d8ce15e0e3233$export$8dcc46e162f2235b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$a934caa57ac0ac0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$25a4e6c77f91c259);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE", ()=>$d90d8ce15e0e3233$export$2a9a9bab313fd713);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$82ad2da638fc34d8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$ff67cffdbd881a41);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE", ()=>$d90d8ce15e0e3233$export$c41c7d73df3fc08c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$65f234e4799edddc);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$215ea4e7405fa88c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE", ()=>$d90d8ce15e0e3233$export$927b1972180d9cc4);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$ff1365ce4d652337);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA", ()=>$d90d8ce15e0e3233$export$79b30013cbfdee04);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE", ()=>$d90d8ce15e0e3233$export$33c2dcc7c7abc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_REDIRECT", ()=>$d90d8ce15e0e3233$export$a6ef20aa08a533b1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_COMPONENTS", ()=>$d90d8ce15e0e3233$export$5908e15483da8a45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT", ()=>$d90d8ce15e0e3233$export$a3812f6f4e60d897);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$3c8c119f40a061a9);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC", ()=>$d90d8ce15e0e3233$export$47e034646abefdb2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE", ()=>$d90d8ce15e0e3233$export$f36f4cf8b17f250f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_NOT_FOUND", ()=>$d90d8ce15e0e3233$export$841e880a0d425b3e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_PAGES", ()=>$d90d8ce15e0e3233$export$1fde4a6e7df24a97);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION", ()=>$d90d8ce15e0e3233$export$69335bf8b709edc7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS", ()=>$d90d8ce15e0e3233$export$946b472f7559a889);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS", ()=>$d90d8ce15e0e3233$export$373fdf6888021ed0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT", ()=>$d90d8ce15e0e3233$export$d6a5f13a3d30923c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS", ()=>$d90d8ce15e0e3233$export$adfff93b0b015409);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS", ()=>$d90d8ce15e0e3233$export$404de4ddea701cff);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$596e1f6f6f4997b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION", ()=>$d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$d610a17dff3a01fa);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT", ()=>$d90d8ce15e0e3233$export$284db5107f3db516);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS", ()=>$d90d8ce15e0e3233$export$fbce46826eefc586);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS", ()=>$d90d8ce15e0e3233$export$c86b29c76317ac6f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$3160b86e1b5dc391);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$690c0080c930fca);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW", ()=>$d90d8ce15e0e3233$export$171ba8c33c05c4ef);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$e2f2c23286c3255c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$5a262d40e10207a1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$ab790cb87175797e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$db780b39656c673a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS", ()=>$d90d8ce15e0e3233$export$a77cb4dafc511d3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$253fd82874264ee4);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN", ()=>$d90d8ce15e0e3233$export$eaf9ab4ec0c25813);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$574bcdf6b73fcf1f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT", ()=>$d90d8ce15e0e3233$export$a14853dfff8da872);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$ba8fd0e6db8d3e08);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$1c74da1e52e6d212);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS", ()=>$d90d8ce15e0e3233$export$d416059b17fe7d4e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS", ()=>$d90d8ce15e0e3233$export$d5a3a037d2760bb7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN", ()=>$d90d8ce15e0e3233$export$eb187d42a7448d45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS", ()=>$d90d8ce15e0e3233$export$688de32d31fc70f5);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$13d770f8814d480a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$3a628f9376166ffb);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$649dafa225625f30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$dbfe76dd37018b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$20db7bb9d1bd8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$a1fa8e6e125780ae);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$fc6b949fd2bc782d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$c940f866ac7760a0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$184d4979f6f9fe7e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$959f50de166cc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$b13b8c8bb4e30a75);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS", ()=>$d90d8ce15e0e3233$export$40d6fc2b9a4f09d2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$cc1af211e3feda50);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_AUTOMATION", ()=>$d90d8ce15e0e3233$export$3873539001f5aed7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD", ()=>$d90d8ce15e0e3233$export$89fcbafce559080b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM", ()=>$d90d8ce15e0e3233$export$c3f05da9e4e13249);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS", ()=>$d90d8ce15e0e3233$export$619694ab37142384);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS", ()=>$d90d8ce15e0e3233$export$cb89b516b9cf418b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES", ()=>$d90d8ce15e0e3233$export$50680f54e95bb859);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS", ()=>$d90d8ce15e0e3233$export$194c2b4da7e38757);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT", ()=>$d90d8ce15e0e3233$export$962d838817f090f8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP", ()=>$d90d8ce15e0e3233$export$eacbdb340a470309);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES", ()=>$d90d8ce15e0e3233$export$6a7782d87a21425d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE", ()=>$d90d8ce15e0e3233$export$c2f56336162e799e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$ba419378ad70624e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$d90d8ce15e0e3233$export$62f38c589a73d386);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS", ()=>$d90d8ce15e0e3233$export$77c8066c0822f152);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FEATURES", ()=>$d90d8ce15e0e3233$export$90900ebfa6f48861);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$93ff02c205edd1a8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$db7f5d93be70ee30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$432229516b7f82da);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$8f554d4ef9f084c0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE", ()=>$d90d8ce15e0e3233$export$6b2b99b0055772a3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN", ()=>$d90d8ce15e0e3233$export$83c7a51057be6264);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS", ()=>$d90d8ce15e0e3233$export$46706d786aab3829);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_VERSIONS", ()=>$d90d8ce15e0e3233$export$b690025ef7e3cf6c);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD", ()=>$d90d8ce15e0e3233$export$ea48cc6bf1183d11);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG", ()=>$d90d8ce15e0e3233$export$930e4881302bbd54);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED", ()=>$d90d8ce15e0e3233$export$375801b708576466);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD", ()=>$d90d8ce15e0e3233$export$5b1e8463bd590143);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED", ()=>$d90d8ce15e0e3233$export$1606662a398a24be);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT", ()=>$d90d8ce15e0e3233$export$c5b19a37e49ceb28);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_REPORT", ()=>$d90d8ce15e0e3233$export$c46680afe70295f3);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_UIF_BACKLOG", ()=>$d90d8ce15e0e3233$export$831fc7eba98b58c9);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG", ()=>$d90d8ce15e0e3233$export$4061c0c586f3b7c8);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BOARD", ()=>$d90d8ce15e0e3233$export$99e0abd8ba1de289);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_REPORT", ()=>$d90d8ce15e0e3233$export$cd96a6a0cc4831ab);
    $parcel$export(module.exports, "ROUTE_NAMES_ROVO_DEMAND_TESTS", ()=>$d90d8ce15e0e3233$export$36e61e70347174cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS", ()=>$d90d8ce15e0e3233$export$db1b3d2fee80859);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY", ()=>$d90d8ce15e0e3233$export$b0f3f3214ab1b150);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_BOARDS", ()=>$d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR", ()=>$d90d8ce15e0e3233$export$8c8f03e75b6708ac);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR", ()=>$d90d8ce15e0e3233$export$3c3d8caf61c9aa0c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS", ()=>$d90d8ce15e0e3233$export$f9cc808094ce0ddd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$9bde4a0b155f2972);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT", ()=>$d90d8ce15e0e3233$export$a52f5ffbbe135078);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA", ()=>$d90d8ce15e0e3233$export$e6773bf0fbccdb9c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$8e3dd8487a7b65bd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$258b44fcc29a5961);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS", ()=>$d90d8ce15e0e3233$export$ea1146ebce07be6d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT", ()=>$d90d8ce15e0e3233$export$53731240ce2d3b76);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE", ()=>$d90d8ce15e0e3233$export$956eb40834ddee22);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT", ()=>$d90d8ce15e0e3233$export$9057470ebf41169);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME", ()=>$d90d8ce15e0e3233$export$c42e107c5275b36);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE", ()=>$d90d8ce15e0e3233$export$3e7c6a54a9d2267a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE", ()=>$d90d8ce15e0e3233$export$c3e2697b35a149c4);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT", ()=>$d90d8ce15e0e3233$export$288c7dd61dd0c291);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA", ()=>$d90d8ce15e0e3233$export$37161a981d69c891);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$cfe61aa92a4d585d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$9ed512ab4c81669c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$37a9bdd8513f462d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT", ()=>$d90d8ce15e0e3233$export$f01162415f3a2ee3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2", ()=>$d90d8ce15e0e3233$export$860dd13b1e836ed8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS", ()=>$d90d8ce15e0e3233$export$5eaf1dce55090ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS", ()=>$d90d8ce15e0e3233$export$1fe309e7cdbd1c1);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS", ()=>$d90d8ce15e0e3233$export$fcd9750494ff0236);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM", ()=>$d90d8ce15e0e3233$export$ad856b38e93b93b2);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE", ()=>$d90d8ce15e0e3233$export$a833209ca71d2e56);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INCIDENTS", ()=>$d90d8ce15e0e3233$export$829d1776460a6ad3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INDEX", ()=>$d90d8ce15e0e3233$export$d30ab2da08d8b7b9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUE", ()=>$d90d8ce15e0e3233$export$3c71889849aeaa08);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUES", ()=>$d90d8ce15e0e3233$export$354bf2df81f6ffb0);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE", ()=>$d90d8ce15e0e3233$export$f8880b461acd270d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION", ()=>$d90d8ce15e0e3233$export$876055c0ede2f8df);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS", ()=>$d90d8ce15e0e3233$export$bf493c66e34711c8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE", ()=>$d90d8ce15e0e3233$export$212f6e2c7c2a53bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$7c28c6e8d8a6545);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE", ()=>$d90d8ce15e0e3233$export$8d55b6ef2cd92f8c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS", ()=>$d90d8ce15e0e3233$export$f7fbe9a4717b7a50);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS", ()=>$d90d8ce15e0e3233$export$8c800f176d079d28);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2", ()=>$d90d8ce15e0e3233$export$1c5fbcbfc0923176);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE", ()=>$d90d8ce15e0e3233$export$59644e5d8d69a016);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT", ()=>$d90d8ce15e0e3233$export$c7074ebe0ca83f98);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE", ()=>$d90d8ce15e0e3233$export$2b4737953287a354);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING", ()=>$d90d8ce15e0e3233$export$e7a8d6d534c5e2fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW", ()=>$d90d8ce15e0e3233$export$5dcba309e2bfa88b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW", ()=>$d90d8ce15e0e3233$export$2d961b0101f8733e);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION", ()=>$d90d8ce15e0e3233$export$195fe2558f1a8591);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON", ()=>$d90d8ce15e0e3233$export$1b3cf68be370a45b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE", ()=>$d90d8ce15e0e3233$export$45c35381e5da2232);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT", ()=>$d90d8ce15e0e3233$export$d479ba53b9bf65a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE", ()=>$d90d8ce15e0e3233$export$ccd12890649c59cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING", ()=>$d90d8ce15e0e3233$export$8c84064031188e80);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW", ()=>$d90d8ce15e0e3233$export$46c6fef035fbe8ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_NEW", ()=>$d90d8ce15e0e3233$export$6fb23ec5a12d5c24);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REDIRECT", ()=>$d90d8ce15e0e3233$export$156b2dfbd87d576f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS", ()=>$d90d8ce15e0e3233$export$6961f1ed0407cb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM", ()=>$d90d8ce15e0e3233$export$ba284efd679bf637);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE", ()=>$d90d8ce15e0e3233$export$e48a3df597407767);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT", ()=>$d90d8ce15e0e3233$export$c73718d4a6efea1d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE", ()=>$d90d8ce15e0e3233$export$ed454783ba1bacb9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$48f6285d4729ca9d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION", ()=>$d90d8ce15e0e3233$export$8066418cead2d2ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE", ()=>$d90d8ce15e0e3233$export$b3db7857ac710a89);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$d574810e3edad044);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY", ()=>$d90d8ce15e0e3233$export$be4b2ffade787316);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE", ()=>$d90d8ce15e0e3233$export$3caf79b5f4be02d7);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD", ()=>$d90d8ce15e0e3233$export$29bc361328055683);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES", ()=>$d90d8ce15e0e3233$export$a4a5a333fe874d97);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_NEW", ()=>$d90d8ce15e0e3233$export$2193b681ac1ae132);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT", ()=>$d90d8ce15e0e3233$export$f1bfd5b3918619a9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS", ()=>$d90d8ce15e0e3233$export$a4c4f7898d6b914a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW", ()=>$d90d8ce15e0e3233$export$6cffae90b9277bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT", ()=>$d90d8ce15e0e3233$export$17e76ebd53424ed5);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT", ()=>$d90d8ce15e0e3233$export$b1329dc26a81a277);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW", ()=>$d90d8ce15e0e3233$export$e1cba0bfe330f5c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS", ()=>$d90d8ce15e0e3233$export$8e68c55c334de101);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICES", ()=>$d90d8ce15e0e3233$export$5cb7cfba189a0240);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS", ()=>$d90d8ce15e0e3233$export$d28aab4a6d6f1d0d);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_AUTOMATION", ()=>$d90d8ce15e0e3233$export$1cf56e2d6c4edb35);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG", ()=>$d90d8ce15e0e3233$export$27c1770584d7e3fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS", ()=>$d90d8ce15e0e3233$export$22e0ebdea08537f7);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_RECOMMENDATIONS", ()=>$d90d8ce15e0e3233$export$4db732436e4edfaf);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$e832418dbed0717e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS", ()=>$d90d8ce15e0e3233$export$ee09be798f0e4471);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT", ()=>$d90d8ce15e0e3233$export$653bf90ae3578f21);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT", ()=>$d90d8ce15e0e3233$export$9da4125a0c62444d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP", ()=>$d90d8ce15e0e3233$export$fbcc0fd9b402bb12);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES", ()=>$d90d8ce15e0e3233$export$e74fe5bd41e23fbd);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT", ()=>$d90d8ce15e0e3233$export$1a93e63ddbe4aa06);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR", ()=>$d90d8ce15e0e3233$export$3b6dbbe49882589d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS", ()=>$d90d8ce15e0e3233$export$eb01394789016fd4);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT", ()=>$d90d8ce15e0e3233$export$f17f4523583fa8e5);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$eaa4d6eec75a6778);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT", ()=>$d90d8ce15e0e3233$export$dcc96e4abbdc0d39);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG", ()=>$d90d8ce15e0e3233$export$9eaf39ba5a56c72a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED", ()=>$d90d8ce15e0e3233$export$495be3320b67814a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS", ()=>$d90d8ce15e0e3233$export$25752eb5bb5e3d32);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS_EMBED", ()=>$d90d8ce15e0e3233$export$f116716aedb35e10);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR", ()=>$d90d8ce15e0e3233$export$36fffb6b49d9f31d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC", ()=>$d90d8ce15e0e3233$export$a6d07be4ff318f84);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$a9a43f1114df1ad9);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$3a4c7a521a900b4d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT", ()=>$d90d8ce15e0e3233$export$9dcf51a9040a4fd6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED", ()=>$d90d8ce15e0e3233$export$a74f9f6bd0d4fb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE", ()=>$d90d8ce15e0e3233$export$f8cb86acf6b74661);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE_CLASSIC", ()=>$d90d8ce15e0e3233$export$2d3d850c64058bfb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS", ()=>$d90d8ce15e0e3233$export$af6b51164f66908b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$12efc96fc9c9fb34);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM", ()=>$d90d8ce15e0e3233$export$6ab1901e04e623ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_CLASSIC", ()=>$d90d8ce15e0e3233$export$bccc7d0812737c4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$458fb992f2637a20);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC", ()=>$d90d8ce15e0e3233$export$c9c9c64f68ba51e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT", ()=>$d90d8ce15e0e3233$export$50264cbc90a39f19);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC", ()=>$d90d8ce15e0e3233$export$b9d0cbe0888fa72e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS", ()=>$d90d8ce15e0e3233$export$b8045610416fa8ca);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC", ()=>$d90d8ce15e0e3233$export$8e80136ad13099e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS", ()=>$d90d8ce15e0e3233$export$b5fe44c0bc324494);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$7a4f52d9060a20d2);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$d6a9e4695952522e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST", ()=>$d90d8ce15e0e3233$export$deab88d0814c564b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC", ()=>$d90d8ce15e0e3233$export$906faff110f898ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$ab3f2a34a3b0db87);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_EMBED", ()=>$d90d8ce15e0e3233$export$4ed84a2011fdc400);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT", ()=>$d90d8ce15e0e3233$export$f7b286b39bf6051b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING", ()=>$d90d8ce15e0e3233$export$6c4337c0332c8c7f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED", ()=>$d90d8ce15e0e3233$export$e7c78887745b2326);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE", ()=>$d90d8ce15e0e3233$export$3805e4f07dca7584);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC", ()=>$d90d8ce15e0e3233$export$f77254983320e888);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR", ()=>$d90d8ce15e0e3233$export$2e784832f1c6bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$7f97fa79520a4c5b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES", ()=>$d90d8ce15e0e3233$export$9e53cdb1ac02195c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED", ()=>$d90d8ce15e0e3233$export$58bd507904dc221c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT", ()=>$d90d8ce15e0e3233$export$7a821e22be2c2f14);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED", ()=>$d90d8ce15e0e3233$export$ca8966ef80bfafc6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS", ()=>$d90d8ce15e0e3233$export$e7423156dba31a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_RELEASES", ()=>$d90d8ce15e0e3233$export$cba7e383b2409c7b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER", ()=>$d90d8ce15e0e3233$export$d5378fb71d5242c0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$4b16b72c72da8833);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES", ()=>$d90d8ce15e0e3233$export$10114d78cefb1f53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE", ()=>$d90d8ce15e0e3233$export$92fe23ed30100817);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES", ()=>$d90d8ce15e0e3233$export$e824495554c83069);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$8df2e9efdd625a44);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO", ()=>$d90d8ce15e0e3233$export$aeb4d3006e298033);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS", ()=>$d90d8ce15e0e3233$export$e15d3c40985c4b53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES", ()=>$d90d8ce15e0e3233$export$1d8c84454fd2d571);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS", ()=>$d90d8ce15e0e3233$export$db61a12efb59745c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS", ()=>$d90d8ce15e0e3233$export$2da67fb5bd6bc2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING", ()=>$d90d8ce15e0e3233$export$182e0167fd960de6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY", ()=>$d90d8ce15e0e3233$export$2d9e2484ee02e7da);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED", ()=>$d90d8ce15e0e3233$export$b7fff19fd89b617f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TEAMS", ()=>$d90d8ce15e0e3233$export$ea23f150f64e8a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE", ()=>$d90d8ce15e0e3233$export$116338bd93f78ad0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED", ()=>$d90d8ce15e0e3233$export$c9cd65a78227cf18);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_RELEASE_NOTES", ()=>$d90d8ce15e0e3233$export$d75d93e5d44182cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS", ()=>$d90d8ce15e0e3233$export$cc3027ae3767801);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN", ()=>$d90d8ce15e0e3233$export$3492ce83b8884e0e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP", ()=>$d90d8ce15e0e3233$export$b4798b7e62733393);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL", ()=>$d90d8ce15e0e3233$export$388685c701d6e0d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE", ()=>$d90d8ce15e0e3233$export$5ff4d2d4257ea2b0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME", ()=>$d90d8ce15e0e3233$export$fa83895c1eac55e7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC", ()=>$d90d8ce15e0e3233$export$5c82bb95a06a1846);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY", ()=>$d90d8ce15e0e3233$export$c725b9c7e11dd69e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC", ()=>$d90d8ce15e0e3233$export$90594f89c675ba05);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY", ()=>$d90d8ce15e0e3233$export$ae0d999dd2bdd59b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS", ()=>$d90d8ce15e0e3233$export$43bbf6935a91d277);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$92e23977438282b2);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP", ()=>$d90d8ce15e0e3233$export$296115eb5b7129d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC", ()=>$d90d8ce15e0e3233$export$17574f41c3925d64);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT", ()=>$d90d8ce15e0e3233$export$955692fbfe35fc16);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY", ()=>$d90d8ce15e0e3233$export$30af3a767b8ad2d8);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC", ()=>$d90d8ce15e0e3233$export$f47d664298c2c2f0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SUMMARY", ()=>$d90d8ce15e0e3233$export$2d1ed852d9885250);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC", ()=>$d90d8ce15e0e3233$export$312796fc15876480);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE", ()=>$d90d8ce15e0e3233$export$1714b5ad9b672bc7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC", ()=>$d90d8ce15e0e3233$export$c9634bf15518a3a1);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL", ()=>$d90d8ce15e0e3233$export$3b5eb3ea8cbeeed);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED", ()=>$d90d8ce15e0e3233$export$118bb1785acc3d0b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT", ()=>$d90d8ce15e0e3233$export$c29d90ae9a4b648e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH", ()=>$d90d8ce15e0e3233$export$8f2717a951373c25);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$831acb5098f5706d);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$d218cda46c433fe1);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK", ()=>$d90d8ce15e0e3233$export$61147168ac2833f9);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$9fe0117c0fd486a8);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$a49474778d15635d);
    $parcel$export(module.exports, "ROUTE_NAMES_USER_SEGMENTATION", ()=>$d90d8ce15e0e3233$export$af3296e54e7fb362);
    $parcel$export(module.exports, "ROUTE_NAMES_YOUR_WORK", ()=>$d90d8ce15e0e3233$export$281f2e01ee9e4977);
    const $d90d8ce15e0e3233$export$1ba937db1fe6ef01 = 'archive-issues';
    const $d90d8ce15e0e3233$export$3fd002e197e83a30 = 'arj-settings';
    const $d90d8ce15e0e3233$export$bbf08d4d25df5504 = 'classic-business';
    const $d90d8ce15e0e3233$export$e3e759b7f50aaee1 = 'classic-software';
    const $d90d8ce15e0e3233$export$89337611b52bc9a3 = 'components';
    const $d90d8ce15e0e3233$export$3d7937b12eb9e5d5 = 'connect';
    const $d90d8ce15e0e3233$export$7a3d181d86fce9e6 = 'dashboard';
    const $d90d8ce15e0e3233$export$294c878a3842c859 = 'dashboards';
    const $d90d8ce15e0e3233$export$7a22726acd7d6021 = 'devops';
    const $d90d8ce15e0e3233$export$f3f4a9f53ba00861 = 'directories';
    const $d90d8ce15e0e3233$export$112d69653b2f1d8b = 'eoc';
    const $d90d8ce15e0e3233$export$74e0426b66571086 = 'errors';
    const $d90d8ce15e0e3233$export$c2e20e142c95c1ce = 'global-settings';
    const $d90d8ce15e0e3233$export$f8cea29bebf098c = 'helpcenter-settings';
    const $d90d8ce15e0e3233$export$5801ef8dfc9a2f70 = 'home';
    const $d90d8ce15e0e3233$export$7246838143f848f3 = 'issue';
    const $d90d8ce15e0e3233$export$54f96702980a2f87 = 'issue-navigator';
    const $d90d8ce15e0e3233$export$5566db8fbd042fc4 = 'legacy';
    const $d90d8ce15e0e3233$export$20344ad17b5fca86 = 'legacy-jsd-settings';
    const $d90d8ce15e0e3233$export$656d0cc2c67b2708 = 'marketplace';
    const $d90d8ce15e0e3233$export$bfdbcebc4c81b043 = 'people-profiles';
    const $d90d8ce15e0e3233$export$82021d71ad19e227 = 'personal-settings';
    const $d90d8ce15e0e3233$export$6f266218a6973848 = 'plan-settings';
    const $d90d8ce15e0e3233$export$a846fcaeeea8e0ff = 'polaris';
    const $d90d8ce15e0e3233$export$6c87a9dff4e7a2de = 'proforma';
    const $d90d8ce15e0e3233$export$ab79970dcfac06a1 = 'project-settings-classic';
    const $d90d8ce15e0e3233$export$d1a70f80bb22f18a = 'project-settings-core';
    const $d90d8ce15e0e3233$export$bd925e9fcb6ce37f = 'project-settings-servicedesk';
    const $d90d8ce15e0e3233$export$86509a1baabd62ee = 'project-settings-software';
    const $d90d8ce15e0e3233$export$98823ed9eedfc756 = 'project-settings-software-boards';
    const $d90d8ce15e0e3233$export$da8d13fe1ccd5c09 = 'redirects';
    const $d90d8ce15e0e3233$export$78fb2f6176b7c6b8 = 'servicedesk';
    const $d90d8ce15e0e3233$export$d4a2a2e87da2135a = 'services';
    const $d90d8ce15e0e3233$export$26efaec7a7a8b361 = 'software';
    const $d90d8ce15e0e3233$export$db781fb68c08f7e2 = 'versions';
    const $d90d8ce15e0e3233$export$88041353cc69458d = 'archived-issues-directory';
    const $d90d8ce15e0e3233$export$f88d57dcb03ba452 = 'archived-plans-directory';
    const $d90d8ce15e0e3233$export$e8aa63af071c2da9 = 'archived-projects-directory';
    const $d90d8ce15e0e3233$export$b114d0da2ebcff6c = 'archived-project-direct-link';
    const $d90d8ce15e0e3233$export$29cc94b8cea5c920 = 'boards-directory';
    const $d90d8ce15e0e3233$export$4d1b45005cdcfb39 = 'browse-project-redirect';
    const $d90d8ce15e0e3233$export$a42ea04fdf53eeaf = 'next-gen-business-board';
    const $d90d8ce15e0e3233$export$ca4c5f5b3e2daa18 = 'business-classic-reports';
    const $d90d8ce15e0e3233$export$d58a5411a2ac6260 = 'next-gen-business-reports';
    const $d90d8ce15e0e3233$export$24514ee19772b5af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-onboarding-get-started`;
    const $d90d8ce15e0e3233$export$ec333dd1d6a8b38 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-calendar`;
    const $d90d8ce15e0e3233$export$ed495fbad44791af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-redirect`;
    const $d90d8ce15e0e3233$export$5281552f8109b7c0 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-summary`;
    const $d90d8ce15e0e3233$export$6e8473713ed4557a = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-timeline`;
    const $d90d8ce15e0e3233$export$cbdd5c24d69b2cb1 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-approvals`;
    const $d90d8ce15e0e3233$export$e7f012f402be01ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-attachments`;
    const $d90d8ce15e0e3233$export$b34d3882b42d660d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board`;
    const $d90d8ce15e0e3233$export$ed869c60c6a56182 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board-embed`;
    const $d90d8ce15e0e3233$export$5013269f29c75b37 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar`;
    const $d90d8ce15e0e3233$export$fc8b48319e993d43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar-embed`;
    const $d90d8ce15e0e3233$export$40903feb5b038923 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-files`;
    const $d90d8ce15e0e3233$export$d6e60a2059f028d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form`;
    const $d90d8ce15e0e3233$export$3d589aae17a00bc9 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-builder`;
    const $d90d8ce15e0e3233$export$bd92ef03b23dd672 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit`;
    const $d90d8ce15e0e3233$export$fa7fc44c718fc850 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit-embed`;
    const $d90d8ce15e0e3233$export$1dffaf831e01e2b4 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list`;
    const $d90d8ce15e0e3233$export$5f8187412dd60f35 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list-embed`;
    const $d90d8ce15e0e3233$export$3d2c1c04d18f6c43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-sample-onboarding`;
    const $d90d8ce15e0e3233$export$cd22a5d8f560a1d8 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-shortcut`;
    const $d90d8ce15e0e3233$export$cad1b1aa5ce26bbc = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary`;
    const $d90d8ce15e0e3233$export$ee073463b4144367 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary-embed`;
    const $d90d8ce15e0e3233$export$ea034943499772ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline`;
    const $d90d8ce15e0e3233$export$19bc888bcf37d22d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline-embed`;
    const $d90d8ce15e0e3233$export$e0746183e11767fb = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-redirect`;
    const $d90d8ce15e0e3233$export$3e2d215ce157adc8 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-code`;
    const $d90d8ce15e0e3233$export$8a8485bb05daf40b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$a2799b01de5bb62 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-data-classifications`;
    const $d90d8ce15e0e3233$export$1bc2b66dcb07293a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
    const $d90d8ce15e0e3233$export$2d4f89c4b1ee3640 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-features`;
    const $d90d8ce15e0e3233$export$75609d3416c31f79 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-issue-layout`;
    const $d90d8ce15e0e3233$export$79793dc26e0b7b1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$2eda7466fbfdef43 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-link-opsgenie`;
    const $d90d8ce15e0e3233$export$417297669917ee1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
    const $d90d8ce15e0e3233$export$8c79f3309ac0737 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications`;
    const $d90d8ce15e0e3233$export$ef71a22e7befd35c = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$62ba1e294f5007c1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-edit-forms`;
    const $d90d8ce15e0e3233$export$a4315324546ecc89 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$a653cf6d478b3df1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-company-managed`;
    const $d90d8ce15e0e3233$export$b0f268fe53a03e98 = 'compass-product-settings';
    const $d90d8ce15e0e3233$export$f4160b48e4ab8f39 = 'confluence-product-settings';
    const $d90d8ce15e0e3233$export$608f359cf8b08d2e = 'connect-general';
    const $d90d8ce15e0e3233$export$8bfbf790fe89f8d3 = 'connect-general-invalid';
    const $d90d8ce15e0e3233$export$d7011d1ed949f970 = 'connect-general-service-desk-project';
    const $d90d8ce15e0e3233$export$bd2506db44585db6 = 'connect-project';
    const $d90d8ce15e0e3233$export$200fa5ad16f8c112 = 'create-project';
    const $d90d8ce15e0e3233$export$21702f145fe1bbb0 = 'customer-service-accounts';
    const $d90d8ce15e0e3233$export$a296bb962bea95b5 = 'dashboard';
    const $d90d8ce15e0e3233$export$b9960c143c0414eb = 'dashboards-directory';
    const $d90d8ce15e0e3233$export$411171d2fcaefaea = 'dashboards-directory-secure';
    const $d90d8ce15e0e3233$export$ee104ed514f63003 = 'dashboard-edit';
    const $d90d8ce15e0e3233$export$9233f9ddcecd3062 = 'dashboard-selected';
    const $d90d8ce15e0e3233$export$b3240ec044a6c70f = 'dashboard-view';
    const $d90d8ce15e0e3233$export$2463c779e12367e3 = 'dashboard-view-embed';
    const $d90d8ce15e0e3233$export$dd3e5187eae2abe9 = 'dashboard-wallboard';
    const $d90d8ce15e0e3233$export$38ca7e07048a5bfd = 'devops-connected-project';
    const $d90d8ce15e0e3233$export$a9044bbb0247378d = 'eoc-alerts';
    const $d90d8ce15e0e3233$export$ae7376e552380ac0 = 'eoc-alert-detail';
    const $d90d8ce15e0e3233$export$48749e87cc44a5a5 = 'eoc-alert-issue-syncing';
    const $d90d8ce15e0e3233$export$21c230ef79df9e9 = 'eoc-alert-issue-syncing-create';
    const $d90d8ce15e0e3233$export$d2d813dd057a8352 = 'eoc-alert-issue-syncing-detail';
    const $d90d8ce15e0e3233$export$54ed2374d14a7e88 = 'eoc-api-key-management';
    const $d90d8ce15e0e3233$export$58368fe796f5ecb4 = 'eoc-assign-custom-roles';
    const $d90d8ce15e0e3233$export$bbb4032f8f259109 = 'eoc-automations';
    const $d90d8ce15e0e3233$export$5b17b30c2dd69cf2 = 'eoc-custom-roles';
    const $d90d8ce15e0e3233$export$d18d0b9a9e85e59c = 'eoc-global-alerts';
    const $d90d8ce15e0e3233$export$5126a481501fc518 = 'eoc-global-alert-detail';
    const $d90d8ce15e0e3233$export$40e720d8c26e6804 = 'eoc-global-group-detail';
    const $d90d8ce15e0e3233$export$dc8ac1f7e9373a32 = 'eoc-global-maintenance';
    const $d90d8ce15e0e3233$export$8ca3e3f0326ba27f = 'eoc-global-reports';
    const $d90d8ce15e0e3233$export$c3d17be12795c864 = 'eoc-global-report-dashboard';
    const $d90d8ce15e0e3233$export$9cd1c70eda5cae15 = 'eoc-heartbeats';
    const $d90d8ce15e0e3233$export$99f769b27f537a72 = 'eoc-incoming-call';
    const $d90d8ce15e0e3233$export$5c5fe79d3f9ec214 = 'eoc-incoming-call-detail';
    const $d90d8ce15e0e3233$export$901b974cf0954c88 = 'eoc-integrations';
    const $d90d8ce15e0e3233$export$b2dd23a345bd5cb3 = 'eoc-integration-create';
    const $d90d8ce15e0e3233$export$8ae7cbc0a73f9351 = 'eoc-integration-detail';
    const $d90d8ce15e0e3233$export$8057ebe7fb7f7f8d = 'eoc-integration-list';
    const $d90d8ce15e0e3233$export$a22387b9744e62e3 = 'eoc-integration-log';
    const $d90d8ce15e0e3233$export$f6fefa9d2e5bbda1 = 'eoc-maintenance';
    const $d90d8ce15e0e3233$export$e6de4aa6c719d2b = 'eoc-on-call';
    const $d90d8ce15e0e3233$export$b195ada84b7e695f = `${$d90d8ce15e0e3233$export$e6de4aa6c719d2b}-redirect`;
    const $d90d8ce15e0e3233$export$1800d32171b754a6 = 'eoc-overview';
    const $d90d8ce15e0e3233$export$d22a153bfcbaaaa0 = 'eoc-overview-all-teams';
    const $d90d8ce15e0e3233$export$a9a41c76994b6ae9 = 'eoc-permissions';
    const $d90d8ce15e0e3233$export$5bd6f2569c3cfd5c = 'eoc-policies';
    const $d90d8ce15e0e3233$export$dc70eff53ff26c70 = 'eoc-reports';
    const $d90d8ce15e0e3233$export$1fe2ca96b360df19 = 'eoc-reports-team';
    const $d90d8ce15e0e3233$export$1ff01e77517a80b0 = 'eoc-reports-unsubscribe';
    const $d90d8ce15e0e3233$export$de3f8f3198f8213a = 'eoc-role-based-notifications';
    const $d90d8ce15e0e3233$export$b2cb569d360db382 = 'eoc-role-based-notifications-detail';
    const $d90d8ce15e0e3233$export$a0d9033eb64fd80f = 'eoc-schedules';
    const $d90d8ce15e0e3233$export$c4531cbbea51b6a1 = 'eoc-settings';
    const $d90d8ce15e0e3233$export$da985e953465731f = 'eoc-team-alerts';
    const $d90d8ce15e0e3233$export$b7eee2afd0a5c6b9 = 'eoc-team-alert-detail';
    const $d90d8ce15e0e3233$export$9b6c84986db47d98 = 'eoc-team-alert-issue-syncing';
    const $d90d8ce15e0e3233$export$89276f76fdd700d6 = 'eoc-team-alert-issue-syncing-create';
    const $d90d8ce15e0e3233$export$ea64769f19da8c95 = 'eoc-team-alert-issue-syncing-detail';
    const $d90d8ce15e0e3233$export$4a584839d9a9eb6f = 'eoc-team-customer-logs';
    const $d90d8ce15e0e3233$export$27d27c817eeb97cc = 'eoc-team-customer-logs-download';
    const $d90d8ce15e0e3233$export$9f533c13cfb48a8f = 'eoc-team-group-detail';
    const $d90d8ce15e0e3233$export$6889e571e5aa6ba6 = 'eoc-team-integrations';
    const $d90d8ce15e0e3233$export$bdd811277711c53d = 'eoc-team-integration-create';
    const $d90d8ce15e0e3233$export$c7b51c0e8ad6f77a = 'eoc-team-integration-detail';
    const $d90d8ce15e0e3233$export$a348fc7f3b4cfe34 = 'eoc-team-integration-list';
    const $d90d8ce15e0e3233$export$a4eff769c94da831 = 'eoc-team-integration-log';
    const $d90d8ce15e0e3233$export$7c928ca9c9822772 = 'eoc-team-policies';
    const $d90d8ce15e0e3233$export$b48311a8f24f4b63 = 'eoc-unlock-operations';
    const $d90d8ce15e0e3233$export$20649eac204f7661 = 'eoc-who-is-on-call';
    const $d90d8ce15e0e3233$export$62170875a111d729 = 'errors-not-found';
    const $d90d8ce15e0e3233$export$2928f3d69e7ac609 = 'external-import';
    const $d90d8ce15e0e3233$export$259e18cafd820487 = 'filters-directory';
    const $d90d8ce15e0e3233$export$4b8f333757e638a4 = 'filters-directory-secure';
    const $d90d8ce15e0e3233$export$ac4f65a14002f892 = 'forge-spa-admin';
    const $d90d8ce15e0e3233$export$c73ddc4b44ccb359 = 'forge-spa-admin-settings';
    const $d90d8ce15e0e3233$export$7ad826b482229119 = 'forge-spa-field-context-config';
    const $d90d8ce15e0e3233$export$3df864df9b639033 = 'forge-spa-global';
    const $d90d8ce15e0e3233$export$7d67bf4077ebe18d = 'forge-spa-project';
    const $d90d8ce15e0e3233$export$5ff797dfd5df551f = 'forge-spa-servicedesk-queue';
    const $d90d8ce15e0e3233$export$8a66ba1da5efa2c = 'global-admin-helper-email-notifications-log';
    const $d90d8ce15e0e3233$export$eadf5aff28def565 = 'global-issue-navigator';
    const $d90d8ce15e0e3233$export$8f9c045e8fd449b7 = 'global-issue-navigator-browse-issue-redirect';
    const $d90d8ce15e0e3233$export$1bf439327974644b = 'global-mail-settings';
    const $d90d8ce15e0e3233$export$e2a9d163770d0d46 = 'global-settings-contact-administrator';
    const $d90d8ce15e0e3233$export$21b497c57bcd299a = 'global-settings-issues-custom-fields-view';
    const $d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4 = 'global-settings-issues-custom-fields-associate';
    const $d90d8ce15e0e3233$export$df5ca261227a6052 = 'global-settings-issues-custom-fields-config';
    const $d90d8ce15e0e3233$export$9f2f4303259b8508 = 'global-settings-issues-custom-fields-delete';
    const $d90d8ce15e0e3233$export$7fd53fe07eecc273 = 'global-settings-issues-custom-fields-edit';
    const $d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2 = 'global-settings-issues-custom-fields-manage';
    const $d90d8ce15e0e3233$export$e05a6c9e9b9b0c48 = 'global-settings-issues-custom-fields-translate';
    const $d90d8ce15e0e3233$export$f9759b206b651b1f = 'global-settings-issues-explicit-field-association-project-list';
    const $d90d8ce15e0e3233$export$7a337a2687b5d5e3 = 'global-settings-issues-edit-permissions-schemes';
    const $d90d8ce15e0e3233$export$a41998c1a3572e41 = 'global-settings-issues-fieldlayouts-view';
    const $d90d8ce15e0e3233$export$2c9fe9e6005a9c36 = 'global-settings-issues-fieldview';
    const $d90d8ce15e0e3233$export$5d8d82ff1de3586e = 'global-settings-issues-fieldlayouts-copy';
    const $d90d8ce15e0e3233$export$8a0ed100d885c17c = 'global-settings-issues-fieldlayouts-schemes-view';
    const $d90d8ce15e0e3233$export$1c7041445acf79e8 = 'global-settings-issues-fieldlayouts-schemes-config';
    const $d90d8ce15e0e3233$export$e4712523d95125f6 = 'global-settings-issues-fieldlayouts-schemes-copy';
    const $d90d8ce15e0e3233$export$7401274ad357ff94 = 'global-settings-issues-fieldlayouts-schemes-delete';
    const $d90d8ce15e0e3233$export$6984b21077857555 = 'global-settings-issues-fieldlayouts-schemes-edit';
    const $d90d8ce15e0e3233$export$5a2dae98f768aedf = 'global-settings-issues-fieldlayouts-schemes-entity';
    const $d90d8ce15e0e3233$export$5eef1c6eb1388ac0 = 'global-settings-issues-fieldlayouts-config';
    const $d90d8ce15e0e3233$export$69bcf2c26d45e030 = 'global-settings-issues-form-data-connections';
    const $d90d8ce15e0e3233$export$ba1417cf5de80f81 = 'global-settings-global-permissions';
    const $d90d8ce15e0e3233$export$fdcfcb2e2eb16afd = 'global-settings-issues-linktypes-view';
    const $d90d8ce15e0e3233$export$5d3e6bffd6b5abfe = 'global-settings-issues-linktypes-activate';
    const $d90d8ce15e0e3233$export$5c676bbb7e3aae9e = 'global-settings-issues-linktypes-deactivate';
    const $d90d8ce15e0e3233$export$8bb013ced097489a = 'global-settings-issues-linktypes-delete';
    const $d90d8ce15e0e3233$export$e384ae6a87fadedd = 'global-settings-issues-linktypes-edit';
    const $d90d8ce15e0e3233$export$8f55a911c4bd95bf = 'global-settings-issues-new-issue-search';
    const $d90d8ce15e0e3233$export$d7b98892cb31fba5 = 'global-settings-issues-new-issue-view';
    const $d90d8ce15e0e3233$export$8be4b203f526b2cd = 'global-settings-issues-notification-add';
    const $d90d8ce15e0e3233$export$df09947903c514c4 = 'global-settings-issues-notification-delete';
    const $d90d8ce15e0e3233$export$cf4a57a81e0bfbca = 'global-settings-issues-notification-edit';
    const $d90d8ce15e0e3233$export$bc64365bbb09c05e = 'global-settings-issues-notification-scheme-add';
    const $d90d8ce15e0e3233$export$5b12571311ebe766 = 'global-settings-issues-notification-scheme-delete';
    const $d90d8ce15e0e3233$export$56dc46fe1de63994 = 'global-settings-issues-notification-scheme-edit';
    const $d90d8ce15e0e3233$export$65af0e5a36d4b4e9 = 'global-settings-issues-notification-view';
    const $d90d8ce15e0e3233$export$dec448f9d2e50c90 = 'global-settings-issues-permissions-schemes-view';
    const $d90d8ce15e0e3233$export$9ff4144e1dcf9fa4 = 'global-settings-issues-permissions-schemes-add';
    const $d90d8ce15e0e3233$export$8aab6fb9a62dda95 = 'global-settings-issues-permissions-schemes-delete';
    const $d90d8ce15e0e3233$export$9f804a2650117f51 = 'global-settings-issues-permissions-schemes-edit';
    const $d90d8ce15e0e3233$export$7dd4b916600f670 = 'global-settings-issues-priorities';
    const $d90d8ce15e0e3233$export$c1b40a8a70c0aafa = 'global-settings-issues-priorities-delete';
    const $d90d8ce15e0e3233$export$ff10d812380db045 = 'global-settings-issues-priorities-edit';
    const $d90d8ce15e0e3233$export$8deeffdf8dfed878 = 'global-settings-issues-priorities-translations';
    const $d90d8ce15e0e3233$export$561687f2fa9b9cc9 = 'global-settings-issues-priority-schemes';
    const $d90d8ce15e0e3233$export$691d30818c14141c = 'global-settings-issues-resolutions';
    const $d90d8ce15e0e3233$export$8fa58495105f8fb0 = 'global-settings-issues-resolutions-default';
    const $d90d8ce15e0e3233$export$8304c57494d82ffd = 'global-settings-issues-resolutions-delete';
    const $d90d8ce15e0e3233$export$353609deec72a2ba = 'global-settings-issues-resolutions-edit';
    const $d90d8ce15e0e3233$export$1cb56e4c132ac8fd = 'global-settings-issues-resolutions-translations';
    const $d90d8ce15e0e3233$export$5fe3eec0a6bda09 = 'global-settings-issues-security-edit';
    const $d90d8ce15e0e3233$export$12b56880d6fb7ac7 = 'global-settings-issues-security-level-add';
    const $d90d8ce15e0e3233$export$9986e8be82998857 = 'global-settings-issues-security-level-delete';
    const $d90d8ce15e0e3233$export$3280ec16231916af = 'global-settings-issues-security-level-edit';
    const $d90d8ce15e0e3233$export$54885d105d1e2b37 = 'global-settings-issues-security-schemes';
    const $d90d8ce15e0e3233$export$f34d87c870f3bf43 = 'global-settings-issues-security-schemes-add';
    const $d90d8ce15e0e3233$export$4108ebf71e36e461 = 'global-settings-issues-security-schemes-delete';
    const $d90d8ce15e0e3233$export$d42ec33a6e69686e = 'global-settings-issues-security-schemes-edit';
    const $d90d8ce15e0e3233$export$8d2cfabd01e2feaa = 'global-settings-issues-statuses';
    const $d90d8ce15e0e3233$export$d0fe3726dffeca80 = 'global-settings-issues-statuses-translations';
    const $d90d8ce15e0e3233$export$b4aa4b2b8fb7267a = 'global-settings-issues-field-configure';
    const $d90d8ce15e0e3233$export$3743711165f5dd4f = 'global-settings-issues-field-configure-edit';
    const $d90d8ce15e0e3233$export$5df6f81deab9567c = 'global-settings-issues-field-schemes-view';
    const $d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4 = 'global-settings-issues-field-schemes-add';
    const $d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84 = 'global-settings-issues-field-schemes-configure';
    const $d90d8ce15e0e3233$export$a03360d8b616ef34 = 'global-settings-issues-field-schemes-copy';
    const $d90d8ce15e0e3233$export$336e54edc189df7f = 'global-settings-issues-field-schemes-delete';
    const $d90d8ce15e0e3233$export$53572e9a81205523 = 'global-settings-issues-field-schemes-edit';
    const $d90d8ce15e0e3233$export$b71f2ef452117a2a = 'global-settings-issues-field-schemes-edit-item';
    const $d90d8ce15e0e3233$export$f79745fee583cd62 = 'global-settings-issues-field-screens';
    const $d90d8ce15e0e3233$export$2281663e19f399c1 = 'global-settings-issues-field-copy';
    const $d90d8ce15e0e3233$export$38c52d8c5e5dad29 = 'global-settings-issues-field-delete';
    const $d90d8ce15e0e3233$export$10babc3f11b4e6e2 = 'global-settings-issues-field-edit';
    const $d90d8ce15e0e3233$export$adf2f51c41b4e22a = 'global-settings-issues-hierarchy-view';
    const $d90d8ce15e0e3233$export$11b217754d4c7d24 = 'global-settings-issues-hierarchy-redirect';
    const $d90d8ce15e0e3233$export$3414f0d81f1c11d = 'global-settings-issues-subtasks-manage';
    const $d90d8ce15e0e3233$export$5574c73a9a5878ca = 'global-settings-issues-subtasks-disable';
    const $d90d8ce15e0e3233$export$cb2626c385b72992 = 'global-settings-issues-subtasks-edit';
    const $d90d8ce15e0e3233$export$fa7aa7cabc3ec459 = 'global-settings-issues-subtasks-tranlations';
    const $d90d8ce15e0e3233$export$8b0450672651ef67 = 'global-settings-issues-time-tracking';
    const $d90d8ce15e0e3233$export$ef510a15f840e437 = 'global-settings-issues-types-view';
    const $d90d8ce15e0e3233$export$bc159fa4984a907f = 'global-settings-issues-types-delete';
    const $d90d8ce15e0e3233$export$47bfbce13af95d24 = 'global-settings-issues-types-edit';
    const $d90d8ce15e0e3233$export$c8cb78e94cd3f83c = 'global-settings-issues-types-schemes-manage';
    const $d90d8ce15e0e3233$export$4496279df22177be = 'global-settings-issues-types-schemes-option';
    const $d90d8ce15e0e3233$export$afdfef5d17c56988 = 'global-settings-issues-types-schemes-associate-default';
    const $d90d8ce15e0e3233$export$ac9b4b1136300033 = 'global-settings-issues-types-schemes-option-delete';
    const $d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee = 'global-settings-issues-types-screen-schemes-view';
    const $d90d8ce15e0e3233$export$c56f5509b93eba68 = 'global-settings-issues-types-screen-schemes-configure';
    const $d90d8ce15e0e3233$export$dd9462e97e11637a = 'global-settings-issues-types-screen-schemes-copy';
    const $d90d8ce15e0e3233$export$11f8c53e10f63cfb = 'global-settings-issues-types-screen-schemes-delete';
    const $d90d8ce15e0e3233$export$758ad3ad6916c9f6 = 'global-settings-issues-types-screen-schemes-edit';
    const $d90d8ce15e0e3233$export$9d65a754315eb617 = 'global-settings-issues-types-screen-schemes-entity';
    const $d90d8ce15e0e3233$export$564b665f6ca740dd = 'global-settings-issues-types-translations';
    const $d90d8ce15e0e3233$export$256fc89c38c1b9e9 = 'global-settings-issues-workflows-pages';
    const $d90d8ce15e0e3233$export$ddeae77164bfac0 = 'global-settings-issues-workflow-edit';
    const $d90d8ce15e0e3233$export$fa2b355372963545 = 'global-settings-issues-workflows-schemes-view';
    const $d90d8ce15e0e3233$export$45511e437e54fa02 = 'global-settings-issues-workflows-schemes-edit';
    const $d90d8ce15e0e3233$export$ad76895f03f27a7c = 'global-settings-issues-workflow-transition';
    const $d90d8ce15e0e3233$export$1c291d65a59b1636 = 'global-settings-issues-workflow-transition-meta-attributes';
    const $d90d8ce15e0e3233$export$d9bb14d665bfeea5 = 'global-settings-migrations-dashboard';
    const $d90d8ce15e0e3233$export$8b44cb3da7b8f857 = 'global-settings-migrations-focus-page';
    const $d90d8ce15e0e3233$export$9ca6a09e1518d3bb = 'global-settings-migrations-home';
    const $d90d8ce15e0e3233$export$4c211b3188348679 = 'global-settings-performance-custom-field';
    const $d90d8ce15e0e3233$export$24757bb1837e33af = 'global-settings-performance-issue';
    const $d90d8ce15e0e3233$export$95b5d0bd29a3a076 = 'global-settings-performance-metric-detail';
    const $d90d8ce15e0e3233$export$d55d4330b58683da = 'global-settings-performance-overview';
    const $d90d8ce15e0e3233$export$f4d5833f0b40a26b = 'global-settings-performance-project-cleanup';
    const $d90d8ce15e0e3233$export$c78577545f514ca8 = 'global-settings-performance-project-role-actor';
    const $d90d8ce15e0e3233$export$253eb3db7152d010 = 'global-settings-permissions-schemes';
    const $d90d8ce15e0e3233$export$16b4392a63a3eacf = 'global-settings-products-applinks';
    const $d90d8ce15e0e3233$export$b2d5a7bc804ed9c9 = 'global-settings-products-dvcs';
    const $d90d8ce15e0e3233$export$f870832f94ca5009 = 'global-settings-products-sdmail';
    const $d90d8ce15e0e3233$export$8b3a1b2e8e954dc2 = 'global-settings-products-jsd-status';
    const $d90d8ce15e0e3233$export$15603150075c3d64 = 'global-settings-projects-categories-delete';
    const $d90d8ce15e0e3233$export$92536fe760c41862 = 'global-settings-projects-categories-edit';
    const $d90d8ce15e0e3233$export$3f4d05032349dae0 = 'global-settings-projects-categories-view';
    const $d90d8ce15e0e3233$export$8ff94a2e5f98315f = 'global-settings-system-shared-dashboards';
    const $d90d8ce15e0e3233$export$c906c6946fef5d99 = 'global-settings-system-helper-notification';
    const $d90d8ce15e0e3233$export$a1916b723e186494 = 'global-settings-system-helper-permission';
    const $d90d8ce15e0e3233$export$5070b4c974017f28 = 'global-settings-system-attachments';
    const $d90d8ce15e0e3233$export$bee7f9f93cb74124 = 'global-settings-system-events';
    const $d90d8ce15e0e3233$export$efe4008073ab3b69 = 'global-settings-system-events-add';
    const $d90d8ce15e0e3233$export$9e40228f1c62d4d9 = 'global-settings-system-events-delete';
    const $d90d8ce15e0e3233$export$223f8094878fea34 = 'global-settings-system-events-edit';
    const $d90d8ce15e0e3233$export$2f589c572415c043 = 'global-settings-system-lexorank';
    const $d90d8ce15e0e3233$export$8cc394a1f5ca4ac0 = 'global-settings-system-services';
    const $d90d8ce15e0e3233$export$a11311cd333dae90 = 'global-settings-system-webhooks';
    const $d90d8ce15e0e3233$export$2b2f159267202dcc = 'global-settings-system-bulk-mail';
    const $d90d8ce15e0e3233$export$c5a6874288d2e609 = 'global-settings-system-application-advanced';
    const $d90d8ce15e0e3233$export$55dd30b027c838fe = 'global-settings-system-application-edit';
    const $d90d8ce15e0e3233$export$aee9c7dbf672403c = 'global-settings-system-global-permissions';
    const $d90d8ce15e0e3233$export$75f2fbd33e76028e = 'global-settings-system-export';
    const $d90d8ce15e0e3233$export$ca57c3dfefb2c826 = 'global-settings-system-import-cloud';
    const $d90d8ce15e0e3233$export$8f2e6f133c022a59 = 'global-settings-system-import-external';
    const $d90d8ce15e0e3233$export$bcd741cf5a35ece8 = 'global-settings-system-import-csv';
    const $d90d8ce15e0e3233$export$bfd8ab4625d5c275 = 'global-settings-system-import-json';
    const $d90d8ce15e0e3233$export$750a33c4058af733 = 'global-settings-system-import-trello';
    const $d90d8ce15e0e3233$export$1b66c7594340363f = 'global-settings-system-collectors';
    const $d90d8ce15e0e3233$export$fe2fa966509db649 = 'global-settings-system-delete-mail-handler';
    const $d90d8ce15e0e3233$export$373b97e8d136f558 = 'global-settings-system-mail-incoming';
    const $d90d8ce15e0e3233$export$64909bb6f2181592 = 'global-settings-system-mail-outgoing';
    const $d90d8ce15e0e3233$export$53d6ade2eaa2ae84 = 'global-settings-system-mail-send';
    const $d90d8ce15e0e3233$export$e49d7a1ddf301d09 = 'global-settings-system-permissions';
    const $d90d8ce15e0e3233$export$9469cfde1d14fcac = 'global-settings-system-roles-view';
    const $d90d8ce15e0e3233$export$be2e231547dca6dd = 'global-settings-system-roles-actors';
    const $d90d8ce15e0e3233$export$ad6f28bbfe57d0a0 = 'global-settings-system-roles-actors-groups';
    const $d90d8ce15e0e3233$export$2fb73d5c1c0e7186 = 'global-settings-system-roles-actors-users';
    const $d90d8ce15e0e3233$export$46b4f43d6ece38fc = 'global-settings-system-roles-delete';
    const $d90d8ce15e0e3233$export$49d1c20d84d46735 = 'global-settings-system-roles-edit';
    const $d90d8ce15e0e3233$export$265062715b11a1ef = 'global-settings-system-roles-usage';
    const $d90d8ce15e0e3233$export$e9f5eae9444c9b46 = 'global-settings-system-shared-filters';
    const $d90d8ce15e0e3233$export$e19bf9459d6eba56 = 'global-settings-system-auditing';
    const $d90d8ce15e0e3233$export$40097704c31872d8 = 'global-settings-system-ui-announcement-banner';
    const $d90d8ce15e0e3233$export$dcdf0405aa7e2078 = 'global-settings-system-ui-dashboard-edit';
    const $d90d8ce15e0e3233$export$fb75113636566d39 = 'global-settings-system-look';
    const $d90d8ce15e0e3233$export$e27baa0c7747e67f = 'global-settings-system-ui-default-user-preferences-apply';
    const $d90d8ce15e0e3233$export$40d189100899f572 = 'global-settings-system-default-settings';
    const $d90d8ce15e0e3233$export$341933b279728599 = $d90d8ce15e0e3233$export$f8cea29bebf098c;
    const $d90d8ce15e0e3233$export$ae4b815061537207 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-customer-notifications`;
    const $d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-email`;
    const $d90d8ce15e0e3233$export$bee46016693b19dc = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-kb`;
    const $d90d8ce15e0e3233$export$ca253bc3d237c17f = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-forms`;
    const $d90d8ce15e0e3233$export$a4cba48257cb118a = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-form-edit`;
    const $d90d8ce15e0e3233$export$2e90ab5aa3463c0d = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-web-portal`;
    const $d90d8ce15e0e3233$export$d70320ae3b4d9e43 = 'home-onboarding-redirect';
    const $d90d8ce15e0e3233$export$b2b57cde1fa39bf5 = 'home-redirect';
    const $d90d8ce15e0e3233$export$e8e3b3a04b70a016 = 'issue';
    const $d90d8ce15e0e3233$export$1a3116351e4f3550 = 'issue-create-embed';
    const $d90d8ce15e0e3233$export$6e2629d41c380b47 = 'issue-embed';
    const $d90d8ce15e0e3233$export$ced38e55e6d33a4e = 'jira-search';
    const $d90d8ce15e0e3233$export$d61d16755cb40ff3 = 'knowledge-hub-all-articles';
    const $d90d8ce15e0e3233$export$bb6392f1b2e80781 = 'kb-article-embed-editor';
    const $d90d8ce15e0e3233$export$6fd25e722e91a0d8 = 'knowledge-hub-article-in-category';
    const $d90d8ce15e0e3233$export$18f32f825e7a5a6f = 'knowledge-hub-browse-all-articles';
    const $d90d8ce15e0e3233$export$b17f22f274f4cd5e = 'knowledge-hub-browse-all-categories';
    const $d90d8ce15e0e3233$export$285854ec33f7cc = 'knowledge-hub-browse-view-article';
    const $d90d8ce15e0e3233$export$77cf9c44bbdaa05b = 'knowledge-hub-category';
    const $d90d8ce15e0e3233$export$d6f1b92110a16f2a = 'knowledge-hub-category-page';
    const $d90d8ce15e0e3233$export$fea47b97c6086336 = 'knowledge-hub-drafts';
    const $d90d8ce15e0e3233$export$264d0a2b60d052cd = 'knowledge-hub-suggested-topics';
    const $d90d8ce15e0e3233$export$991ba0c465b48539 = 'knowledge-hub-landing';
    const $d90d8ce15e0e3233$export$904b472d57dee40d = 'knowledge-hub-search';
    const $d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a = 'knowledge-hub-search-articles';
    const $d90d8ce15e0e3233$export$8cfdaccf43a32440 = 'knowledge-hub-setup';
    const $d90d8ce15e0e3233$export$37bd400c00057d64 = 'legacy-all-reports';
    const $d90d8ce15e0e3233$export$eb66bd587b5f093d = 'legacy-backlog';
    const $d90d8ce15e0e3233$export$521baa72494c2a67 = 'legacy-board';
    const $d90d8ce15e0e3233$export$ca255c93be51d5bc = 'legacy-connect-general';
    const $d90d8ce15e0e3233$export$51e45f736a60769b = 'legacy-connect-project';
    const $d90d8ce15e0e3233$export$2da88c0583f7fff0 = 'legacy-core-reports';
    const $d90d8ce15e0e3233$export$e64c3c8f45d7eb28 = 'legacy-custom-report';
    const $d90d8ce15e0e3233$export$5475ba822739444a = 'legacy-fallback';
    const $d90d8ce15e0e3233$export$8483f5c57513e386 = 'legacy-gin';
    const $d90d8ce15e0e3233$export$93c4d1960660bdb3 = 'legacy-gin-issue';
    const $d90d8ce15e0e3233$export$a5421dcc88027406 = 'legacy-gin-quicksearch';
    const $d90d8ce15e0e3233$export$81d5ef2e5cb06446 = 'legacy-gin-subscriptions';
    const $d90d8ce15e0e3233$export$bf4001a5c23bef67 = 'legacy-issue';
    const $d90d8ce15e0e3233$export$77f5621cd10b53c5 = 'legacy-jsd-customers';
    const $d90d8ce15e0e3233$export$93a199a38574778b = 'legacy-jsd-customer-permissions';
    const $d90d8ce15e0e3233$export$41008c2b014795bf = 'legacy-jsd-getting-started';
    const $d90d8ce15e0e3233$export$3001841111579cf2 = 'legacy-jsd-jira-automation';
    const $d90d8ce15e0e3233$export$28dc2fac9c08502e = 'legacy-jsd-knowledge';
    const $d90d8ce15e0e3233$export$4487dfcd6dce7088 = 'legacy-jsd-queues';
    const $d90d8ce15e0e3233$export$c344587fa7092e8c = 'legacy-jsd-queues-manage';
    const $d90d8ce15e0e3233$export$3fbd487079a23c0f = 'legacy-jsd-reports';
    const $d90d8ce15e0e3233$export$d6822df31c37b21a = 'legacy-jsd-reports-custom';
    const $d90d8ce15e0e3233$export$d39bcac6fced7707 = 'legacy-jsd-settings-fallback';
    const $d90d8ce15e0e3233$export$da975f212e8a3e43 = 'legacy-jsd-settings-language';
    const $d90d8ce15e0e3233$export$6e6feddeb62a0825 = 'legacy-jsd-settings-language-pages';
    const $d90d8ce15e0e3233$export$d3822e148f92bddb = 'legacy-jsd-settings-portal-pages';
    const $d90d8ce15e0e3233$export$d7df906c2ffbeab4 = 'legacy-jsd-widgets';
    const $d90d8ce15e0e3233$export$c71836085985a7d3 = 'legacy-pin';
    const $d90d8ce15e0e3233$export$a17a19a9de903839 = 'legacy-project-releases';
    const $d90d8ce15e0e3233$export$e66c1e847a52ebb5 = 'legacy-project-releases-bamboo';
    const $d90d8ce15e0e3233$export$f0254c80025ed0fc = 'legacy-project-releases-note';
    const $d90d8ce15e0e3233$export$1d4a64220d5b474d = 'legacy-project-releases-note-config';
    const $d90d8ce15e0e3233$export$8af215d394bc18c1 = 'legacy-project-settings-collectors';
    const $d90d8ce15e0e3233$export$b6b536a795b08b39 = 'legacy-project-settings-collectors-add';
    const $d90d8ce15e0e3233$export$59cde094247fca1a = 'legacy-project-settings-collectors-help';
    const $d90d8ce15e0e3233$export$d27bf19e22921164 = 'legacy-project-settings-collectors-view';
    const $d90d8ce15e0e3233$export$3467807847c0a87d = 'legacy-project-settings-config';
    const $d90d8ce15e0e3233$export$1996eeee6a067f1c = 'project-settings-classic-data-classifications';
    const $d90d8ce15e0e3233$export$ec7cb9394e8994c9 = 'legacy-project-settings-delete';
    const $d90d8ce15e0e3233$export$f01730982626c4af = 'legacy-project-settings-dev';
    const $d90d8ce15e0e3233$export$9d1758ddc1563e90 = 'legacy-project-settings-edit';
    const $d90d8ce15e0e3233$export$ecff223feb9d08be = 'legacy-project-settings-fields';
    const $d90d8ce15e0e3233$export$487bc26cddb34312 = 'legacy-project-settings-fields-associate';
    const $d90d8ce15e0e3233$export$118290072826cd87 = 'legacy-project-settings-issue-layout';
    const $d90d8ce15e0e3233$export$e5994b7b1acebe82 = 'legacy-project-settings-issue-security';
    const $d90d8ce15e0e3233$export$84b0e53f785e02cf = 'legacy-project-settings-issue-security-associate';
    const $d90d8ce15e0e3233$export$d58992a667105ce8 = 'legacy-project-settings-issue-types';
    const $d90d8ce15e0e3233$export$bb1cea2d23743f65 = 'legacy-project-settings-issue-types-associate';
    const $d90d8ce15e0e3233$export$76dac5f55ab3705e = 'legacy-project-settings-notifications';
    const $d90d8ce15e0e3233$export$a7c4adb03bc6e997 = 'legacy-project-settings-notifications-associate';
    const $d90d8ce15e0e3233$export$2dc565d0b2334780 = 'legacy-project-settings-opsgenie';
    const $d90d8ce15e0e3233$export$28687a1181a7676f = 'legacy-project-settings-people';
    const $d90d8ce15e0e3233$export$2e74a7026073fa54 = 'legacy-project-settings-permissions';
    const $d90d8ce15e0e3233$export$58fdfc78d176c564 = 'legacy-project-settings-permissions-associate';
    const $d90d8ce15e0e3233$export$cb8548f16119b181 = 'legacy-project-settings-screens';
    const $d90d8ce15e0e3233$export$66e3f6af203a567f = 'legacy-project-settings-screens-associate';
    const $d90d8ce15e0e3233$export$658e7e21f1c7b69b = 'legacy-project-settings-summary';
    const $d90d8ce15e0e3233$export$1fa628a4527d424c = 'legacy-project-settings-workflows';
    const $d90d8ce15e0e3233$export$c2989c5c00f9f64b = 'legacy-project-settings-workflows-associate';
    const $d90d8ce15e0e3233$export$2d21e5416485b195 = 'legacy-redirect';
    const $d90d8ce15e0e3233$export$e514491aa85dd54a = 'legacy-reports-average-age-report';
    const $d90d8ce15e0e3233$export$d9662297242bfcb5 = 'legacy-reports-configure';
    const $d90d8ce15e0e3233$export$2a53516b15393945 = 'legacy-reports-created-vs-resolved-report';
    const $d90d8ce15e0e3233$export$62e00190aa938a43 = 'legacy-reports-developer-workload-report';
    const $d90d8ce15e0e3233$export$22a3924a6eab79ab = 'legacy-reports-pie-report';
    const $d90d8ce15e0e3233$export$677cf3d89d18bb74 = 'legacy-reports-recently-created-report';
    const $d90d8ce15e0e3233$export$7eef86163449ad98 = 'legacy-reports-resolution-time-report';
    const $d90d8ce15e0e3233$export$8f56061e1403fa5a = 'legacy-reports-single-level-group-by-report';
    const $d90d8ce15e0e3233$export$adeb429de8df1e02 = 'legacy-reports-time-since-report';
    const $d90d8ce15e0e3233$export$931d6222073b5708 = 'legacy-reports-time-tracking-report';
    const $d90d8ce15e0e3233$export$2106f1ac8ba807e1 = 'legacy-reports-version-workload-report';
    const $d90d8ce15e0e3233$export$36678521a86f620b = 'legacy-reports-workload-pie-report';
    const $d90d8ce15e0e3233$export$55248356780fc584 = 'login-embed';
    const $d90d8ce15e0e3233$export$cd84c5a333c8d16a = 'global-settings-addons-emcee';
    const $d90d8ce15e0e3233$export$624af6f61b05f55 = 'addons-emcee-public';
    const $d90d8ce15e0e3233$export$2ed9525182145b82 = 'marketplace-app-requests';
    const $d90d8ce15e0e3233$export$7fb2b42fc4e7df8b = 'marketplace-index';
    const $d90d8ce15e0e3233$export$fa962db82ae571b2 = 'global-settings-addons-upm';
    const $d90d8ce15e0e3233$export$e145bf76b1aef705 = 'marketplace-promotions';
    const $d90d8ce15e0e3233$export$8febbfb647e4c8b9 = 'notification-logs';
    const $d90d8ce15e0e3233$export$4b34f3d336f4ccd2 = 'opsgenie-schedule';
    const $d90d8ce15e0e3233$export$a979a5c1f5e3631c = 'people-index';
    const $d90d8ce15e0e3233$export$ffcbf91dfadffd0 = 'personal-settings';
    const $d90d8ce15e0e3233$export$1807a39cc63b856c = 'personal-settings-general';
    const $d90d8ce15e0e3233$export$2be8d3c6fedd5276 = 'personal-settings-notifications';
    const $d90d8ce15e0e3233$export$6268da7263eb670d = 'personal-settings-ops-notifications';
    const $d90d8ce15e0e3233$export$93bd4a896a0fc581 = 'plans-directory';
    const $d90d8ce15e0e3233$export$2b9b1bfb538ab810 = 'project-settings-playbooks-edit';
    const $d90d8ce15e0e3233$export$d1217085321b2648 = 'project-settings-playbooks-list';
    const $d90d8ce15e0e3233$export$39624171b7c8a10a = 'polaris-collections';
    const $d90d8ce15e0e3233$export$1654cd6813e90e6b = 'polaris-ideas';
    const $d90d8ce15e0e3233$export$33059cd02df2febd = 'polaris-insights';
    const $d90d8ce15e0e3233$export$1d746ff2bc48ceb4 = 'polaris-onboarding';
    const $d90d8ce15e0e3233$export$145c578104a45fd2 = 'polaris-plays';
    const $d90d8ce15e0e3233$export$a51df1bc877c58e5 = 'polaris-rooms';
    const $d90d8ce15e0e3233$export$45208fff8de46880 = 'polaris-settings-access';
    const $d90d8ce15e0e3233$export$c710a35d40378fa5 = 'polaris-settings-global-fields';
    const $d90d8ce15e0e3233$export$15d6b93ff5273ce3 = 'polaris-unlicensed';
    const $d90d8ce15e0e3233$export$e26f2863c7ccd504 = 'products-jsm-authentication-settings';
    const $d90d8ce15e0e3233$export$496da9aa0fe819ff = 'products-jsm-chatops-and-videos-tools';
    const $d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b = 'products-jsm-compliance';
    const $d90d8ce15e0e3233$export$53ce69fb34f6d286 = 'products-jsm-configuration';
    const $d90d8ce15e0e3233$export$b6e861786143eb1b = 'products-jsm-customer-access';
    const $d90d8ce15e0e3233$export$f7e3d3b413c017e1 = 'products-jsm-email-requests';
    const $d90d8ce15e0e3233$export$b84d34b8175abde5 = 'products-jsm-feature-usage';
    const $d90d8ce15e0e3233$export$50e4e3e5231fb74f = 'products-jsm-global-ops-reports';
    const $d90d8ce15e0e3233$export$39d913ae557ba8f3 = 'products-jsm-incident-management-tools';
    const $d90d8ce15e0e3233$export$a2d9bcceac584c93 = 'products-jsm-kb-permissions';
    const $d90d8ce15e0e3233$export$eb2e5f1608ec8b32 = 'products-jsm-organizations';
    const $d90d8ce15e0e3233$export$9ac90b948c53bf58 = 'products-jsw-configuration';
    const $d90d8ce15e0e3233$export$bb5665894498893f = 'products-jsw-storage-management';
    const $d90d8ce15e0e3233$export$fc61479fdfdd263a = 'classic-business-proforma-export';
    const $d90d8ce15e0e3233$export$5ae82b891e42770e = 'servicedesk-proforma-export';
    const $d90d8ce15e0e3233$export$8dcc46e162f2235b = 'software-proforma-export';
    const $d90d8ce15e0e3233$export$a934caa57ac0ac0b = 'classic-business-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$25a4e6c77f91c259 = 'servicedesk-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$2a9a9bab313fd713 = 'software-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$82ad2da638fc34d8 = 'classic-business-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$ff67cffdbd881a41 = 'servicedesk-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$c41c7d73df3fc08c = 'software-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$65f234e4799edddc = 'classic-business-proforma-issue-forms-general';
    const $d90d8ce15e0e3233$export$215ea4e7405fa88c = 'servicedesk-proforma-issue-forms-general';
    const $d90d8ce15e0e3233$export$927b1972180d9cc4 = 'software-proforma-issue-forms-general';
    const $d90d8ce15e0e3233$export$ff1365ce4d652337 = 'projects-directory';
    const $d90d8ce15e0e3233$export$79b30013cbfdee04 = 'projects-directory-legacy-path-spa';
    const $d90d8ce15e0e3233$export$33c2dcc7c7abc45e = 'projects-directory-manage';
    const $d90d8ce15e0e3233$export$a6ef20aa08a533b1 = 'projects-redirect';
    const $d90d8ce15e0e3233$export$5908e15483da8a45 = 'project-components';
    const $d90d8ce15e0e3233$export$a3812f6f4e60d897 = 'project-directory-redirect';
    const $d90d8ce15e0e3233$export$3c8c119f40a061a9 = 'issue-navigator';
    const $d90d8ce15e0e3233$export$47e034646abefdb2 = 'issue-navigator-classic';
    const $d90d8ce15e0e3233$export$f36f4cf8b17f250f = 'issue-navigator-core';
    const $d90d8ce15e0e3233$export$841e880a0d425b3e = 'project-not-found';
    const $d90d8ce15e0e3233$export$1fde4a6e7df24a97 = 'project-pages';
    const $d90d8ce15e0e3233$export$69335bf8b709edc7 = 'project-settings-automation';
    const $d90d8ce15e0e3233$export$946b472f7559a889 = 'project-settings-components';
    const $d90d8ce15e0e3233$export$373fdf6888021ed0 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access`;
    const $d90d8ce15e0e3233$export$d6a5f13a3d30923c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access-redirect`;
    const $d90d8ce15e0e3233$export$adfff93b0b015409 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-approvals`;
    const $d90d8ce15e0e3233$export$404de4ddea701cff = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps`;
    const $d90d8ce15e0e3233$export$596e1f6f6f4997b2 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps-fields`;
    const $d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-automation`;
    const $d90d8ce15e0e3233$export$d610a17dff3a01fa = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-data-classifications`;
    const $d90d8ce15e0e3233$export$284db5107f3db516 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-redirect`;
    const $d90d8ce15e0e3233$export$fbce46826eefc586 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-details`;
    const $d90d8ce15e0e3233$export$c86b29c76317ac6f = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-fields`;
    const $d90d8ce15e0e3233$export$3160b86e1b5dc391 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-forge-apps`;
    const $d90d8ce15e0e3233$export$690c0080c930fca = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes`;
    const $d90d8ce15e0e3233$export$171ba8c33c05c4ef = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes-workflow`;
    const $d90d8ce15e0e3233$export$e2f2c23286c3255c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications`;
    const $d90d8ce15e0e3233$export$5a262d40e10207a1 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$ab790cb87175797e = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$db780b39656c673a = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-jira-form-builder`;
    const $d90d8ce15e0e3233$export$a77cb4dafc511d3 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$253fd82874264ee4 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-forge-apps`;
    const $d90d8ce15e0e3233$export$eaf9ab4ec0c25813 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-forge`;
    const $d90d8ce15e0e3233$export$574bcdf6b73fcf1f = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-apps-fields`;
    const $d90d8ce15e0e3233$export$a14853dfff8da872 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-chat`;
    const $d90d8ce15e0e3233$export$ba8fd0e6db8d3e08 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-notifications`;
    const $d90d8ce15e0e3233$export$1c74da1e52e6d212 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-permissions`;
    const $d90d8ce15e0e3233$export$d416059b17fe7d4e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-email`;
    const $d90d8ce15e0e3233$export$d5a3a037d2760bb7 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-widget`;
    const $d90d8ce15e0e3233$export$eb187d42a7448d45 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-internal-notifications-nextGen`;
    const $d90d8ce15e0e3233$export$688de32d31fc70f5 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-details`;
    const $d90d8ce15e0e3233$export$13d770f8814d480a = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-forge-apps`;
    const $d90d8ce15e0e3233$export$3a628f9376166ffb = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-types-config`;
    const $d90d8ce15e0e3233$export$649dafa225625f30 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$dbfe76dd37018b2 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications`;
    const $d90d8ce15e0e3233$export$20db7bb9d1bd8b38 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$a1fa8e6e125780ae = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notification-email`;
    const $d90d8ce15e0e3233$export$fc6b949fd2bc782d = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-portal-settings`;
    const $d90d8ce15e0e3233$export$c940f866ac7760a0 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-types-config`;
    const $d90d8ce15e0e3233$export$184d4979f6f9fe7e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$959f50de166cc45e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-types-config`;
    const $d90d8ce15e0e3233$export$b13b8c8bb4e30a75 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$40d6fc2b9a4f09d2 = 'project-settings-software-access';
    const $d90d8ce15e0e3233$export$cc1af211e3feda50 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-fields`;
    const $d90d8ce15e0e3233$export$3873539001f5aed7 = 'project-settings-software-automation';
    const $d90d8ce15e0e3233$export$89fcbafce559080b = 'project-settings-software-boards-card';
    const $d90d8ce15e0e3233$export$c3f05da9e4e13249 = 'project-settings-software-boards-csm';
    const $d90d8ce15e0e3233$export$619694ab37142384 = 'project-settings-software-boards-custom-filters';
    const $d90d8ce15e0e3233$export$cb89b516b9cf418b = 'project-settings-software-boards-details';
    const $d90d8ce15e0e3233$export$50680f54e95bb859 = 'project-settings-software-boards-features';
    const $d90d8ce15e0e3233$export$194c2b4da7e38757 = 'project-settings-software-boards-insights';
    const $d90d8ce15e0e3233$export$962d838817f090f8 = 'project-settings-software-boards-redirect';
    const $d90d8ce15e0e3233$export$eacbdb340a470309 = 'project-settings-software-boards-roadmap';
    const $d90d8ce15e0e3233$export$6a7782d87a21425d = 'project-settings-software-boards-swimlanes';
    const $d90d8ce15e0e3233$export$c2f56336162e799e = 'project-settings-software-boards-timeline';
    const $d90d8ce15e0e3233$export$ba419378ad70624e = 'project-settings-software-data-classifications';
    const $d90d8ce15e0e3233$export$62f38c589a73d386 = 'project-settings-software-details';
    const $d90d8ce15e0e3233$export$77c8066c0822f152 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-fields`;
    const $d90d8ce15e0e3233$export$90900ebfa6f48861 = 'project-settings-software-next-gen-features';
    const $d90d8ce15e0e3233$export$93ff02c205edd1a8 = 'project-settings-software-issuetypes';
    const $d90d8ce15e0e3233$export$db7f5d93be70ee30 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications`;
    const $d90d8ce15e0e3233$export$432229516b7f82da = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$8f554d4ef9f084c0 = 'project-settings-software-notifications-notification-email';
    const $d90d8ce15e0e3233$export$6b2b99b0055772a3 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-link-opsgenie`;
    const $d90d8ce15e0e3233$export$83c7a51057be6264 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-team-managed`;
    const $d90d8ce15e0e3233$export$46706d786aab3829 = 'project-settings-versions';
    const $d90d8ce15e0e3233$export$b690025ef7e3cf6c = 'project-versions';
    const $d90d8ce15e0e3233$export$ea48cc6bf1183d11 = 'rapidboard';
    const $d90d8ce15e0e3233$export$930e4881302bbd54 = 'rapidboard-backlog';
    const $d90d8ce15e0e3233$export$375801b708576466 = 'rapidboard-backlog-embed';
    const $d90d8ce15e0e3233$export$5b1e8463bd590143 = 'rapidboard-board';
    const $d90d8ce15e0e3233$export$1606662a398a24be = 'rapidboard-board-embed';
    const $d90d8ce15e0e3233$export$83a890b48b63829a = 'rapidboard-board-pretty-url-redirect';
    const $d90d8ce15e0e3233$export$c5b19a37e49ceb28 = 'rapidboard-last-visited-project-redirect';
    const $d90d8ce15e0e3233$export$c46680afe70295f3 = 'rapidboard-report';
    const $d90d8ce15e0e3233$export$831fc7eba98b58c9 = 'rapidboard-uif-backlog';
    const $d90d8ce15e0e3233$export$4061c0c586f3b7c8 = 'rapidboard-user-backlog';
    const $d90d8ce15e0e3233$export$99e0abd8ba1de289 = 'rapidboard-user-board';
    const $d90d8ce15e0e3233$export$cd96a6a0cc4831ab = 'rapidboard-user-report';
    const $d90d8ce15e0e3233$export$36e61e70347174cc = 'rovo-demand-tests';
    const $d90d8ce15e0e3233$export$db1b3d2fee80859 = 'servicedesk-atlassian-analytics';
    const $d90d8ce15e0e3233$export$b0f3f3214ab1b150 = 'servicedesk-project-summary';
    const $d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f = 'servicedesk-boards';
    const $d90d8ce15e0e3233$export$8c8f03e75b6708ac = 'servicedesk-calendar';
    const $d90d8ce15e0e3233$export$3c3d8caf61c9aa0c = 'servicedesk-change-calendar';
    const $d90d8ce15e0e3233$export$f9cc808094ce0ddd = 'servicedesk-cmdb-assets';
    const $d90d8ce15e0e3233$export$9bde4a0b155f2972 = 'servicedesk-cmdb-configure';
    const $d90d8ce15e0e3233$export$a52f5ffbbe135078 = 'servicedesk-cmdb-object';
    const $d90d8ce15e0e3233$export$e6773bf0fbccdb9c = 'servicedesk-cmdb-object-schema';
    const $d90d8ce15e0e3233$export$8e3dd8487a7b65bd = 'servicedesk-cmdb-object-schema-configuration';
    const $d90d8ce15e0e3233$export$258b44fcc29a5961 = 'servicedesk-cmdb-object-type-configuration';
    const $d90d8ce15e0e3233$export$ea1146ebce07be6d = 'servicedesk-cmdb-assets-reports';
    const $d90d8ce15e0e3233$export$53731240ce2d3b76 = 'servicedesk-cmdb-assets-reports-default-redirect';
    const $d90d8ce15e0e3233$export$956eb40834ddee22 = 'servicedesk-cmdb-assets-reports-unsubscribe';
    const $d90d8ce15e0e3233$export$9057470ebf41169 = 'servicedesk-cmdb-manage-object-schemas';
    const $d90d8ce15e0e3233$export$c42e107c5275b36 = 'servicedesk-cmdb-insight';
    const $d90d8ce15e0e3233$export$3e7c6a54a9d2267a = 'servicedesk-cmdb-configure';
    const $d90d8ce15e0e3233$export$c3e2697b35a149c4 = 'servicedesk-cmdb-landing-page';
    const $d90d8ce15e0e3233$export$288c7dd61dd0c291 = 'servicedesk-cmdb-object';
    const $d90d8ce15e0e3233$export$37161a981d69c891 = 'servicedesk-cmdb-object-schema';
    const $d90d8ce15e0e3233$export$cfe61aa92a4d585d = 'servicedesk-cmdb-object-schema-configuration';
    const $d90d8ce15e0e3233$export$9ed512ab4c81669c = 'servicedesk-cmdb-object-type-configuration';
    const $d90d8ce15e0e3233$export$37a9bdd8513f462d = 'servicedesk-connect-project';
    const $d90d8ce15e0e3233$export$f01162415f3a2ee3 = 'servicedesk-create-project';
    const $d90d8ce15e0e3233$export$860dd13b1e836ed8 = 'servicedesk-customers-v2';
    const $d90d8ce15e0e3233$export$5eaf1dce55090ff3 = 'servicedesk-customer-details';
    const $d90d8ce15e0e3233$export$1fe309e7cdbd1c1 = 'servicedesk-customer-service-escalations';
    const $d90d8ce15e0e3233$export$fcd9750494ff0236 = 'servicedesk-customer-service-products';
    const $d90d8ce15e0e3233$export$ad856b38e93b93b2 = 'servicedesk-early-access-itsm';
    const $d90d8ce15e0e3233$export$a833209ca71d2e56 = 'servicedesk-getting-started-page';
    const $d90d8ce15e0e3233$export$829d1776460a6ad3 = 'servicedesk-incidents';
    const $d90d8ce15e0e3233$export$d30ab2da08d8b7b9 = 'servicedesk-index';
    const $d90d8ce15e0e3233$export$3c71889849aeaa08 = 'servicedesk-issue';
    const $d90d8ce15e0e3233$export$354bf2df81f6ffb0 = 'servicedesk-issues';
    const $d90d8ce15e0e3233$export$f8880b461acd270d = 'servicedesk-itsm-sample-space';
    const $d90d8ce15e0e3233$export$876055c0ede2f8df = 'servicedesk-automation';
    const $d90d8ce15e0e3233$export$bf493c66e34711c8 = 'servicedesk-kb-requests-reports';
    const $d90d8ce15e0e3233$export$212f6e2c7c2a53bb = 'servicedesk-kb-requests-reports-time-scale-issue';
    const $d90d8ce15e0e3233$export$7c28c6e8d8a6545 = 'servicedesk-kb-requests-reports-time-scale';
    const $d90d8ce15e0e3233$export$8d55b6ef2cd92f8c = 'servicedesk-oncall-schedule';
    const $d90d8ce15e0e3233$export$f7fbe9a4717b7a50 = 'servicedesk-organizations';
    const $d90d8ce15e0e3233$export$8c800f176d079d28 = 'servicedesk-organization-details';
    const $d90d8ce15e0e3233$export$1c5fbcbfc0923176 = 'servicedesk-organization_v2';
    const $d90d8ce15e0e3233$export$59644e5d8d69a016 = 'servicedesk-practice-custom-and-issue';
    const $d90d8ce15e0e3233$export$c7074ebe0ca83f98 = 'servicedesk-practice-edit';
    const $d90d8ce15e0e3233$export$2b4737953287a354 = 'servicedesk-practice-issue';
    const $d90d8ce15e0e3233$export$e7a8d6d534c5e2fe = 'servicedesk-practice-landing';
    const $d90d8ce15e0e3233$export$5dcba309e2bfa88b = 'servicedesk-practice-manage-view';
    const $d90d8ce15e0e3233$export$2d961b0101f8733e = 'servicedesk-practice-new';
    const $d90d8ce15e0e3233$export$195fe2558f1a8591 = 'servicedesk-project-conversion';
    const $d90d8ce15e0e3233$export$1b3cf68be370a45b = 'servicedesk-queues-addon';
    const $d90d8ce15e0e3233$export$45c35381e5da2232 = 'servicedesk-queues-custom-and-issue';
    const $d90d8ce15e0e3233$export$d479ba53b9bf65a = 'servicedesk-queues-edit';
    const $d90d8ce15e0e3233$export$ccd12890649c59cc = 'servicedesk-queues-issue';
    const $d90d8ce15e0e3233$export$8c84064031188e80 = 'servicedesk-queues-landing';
    const $d90d8ce15e0e3233$export$46c6fef035fbe8ba = 'servicedesk-queues-manage-view';
    const $d90d8ce15e0e3233$export$6fb23ec5a12d5c24 = 'servicedesk-queues-new';
    const $d90d8ce15e0e3233$export$156b2dfbd87d576f = 'servicedesk-redirect';
    const $d90d8ce15e0e3233$export$6961f1ed0407cb26 = 'servicedesk-reports';
    const $d90d8ce15e0e3233$export$ba284efd679bf637 = 'servicedesk-reports-custom';
    const $d90d8ce15e0e3233$export$e48a3df597407767 = 'servicedesk-reports-custom-create';
    const $d90d8ce15e0e3233$export$c73718d4a6efea1d = 'servicedesk-reports-custom-edit';
    const $d90d8ce15e0e3233$export$ed454783ba1bacb9 = 'servicedesk-reports-custom-time-scale-issue';
    const $d90d8ce15e0e3233$export$48f6285d4729ca9d = 'servicedesk-reports-custom-time-scale';
    const $d90d8ce15e0e3233$export$8066418cead2d2ef = 'servicedesk-reports-satisfaction';
    const $d90d8ce15e0e3233$export$b3db7857ac710a89 = 'servicedesk-reports-satisfaction-time-scale-issue';
    const $d90d8ce15e0e3233$export$d574810e3edad044 = 'servicedesk-reports-satisfaction-time-scale';
    const $d90d8ce15e0e3233$export$be4b2ffade787316 = 'servicedesk-reports-summary';
    const $d90d8ce15e0e3233$export$3caf79b5f4be02d7 = 'servicedesk-reports-type';
    const $d90d8ce15e0e3233$export$29bc361328055683 = 'servicedesk-reports-workload';
    const $d90d8ce15e0e3233$export$a4a5a333fe874d97 = 'servicedesk-services';
    const $d90d8ce15e0e3233$export$2193b681ac1ae132 = 'servicedesk-services-new';
    const $d90d8ce15e0e3233$export$f1bfd5b3918619a9 = 'servicedesk-services-without-project';
    const $d90d8ce15e0e3233$export$a4c4f7898d6b914a = 'servicedesk-service-details';
    const $d90d8ce15e0e3233$export$6cffae90b9277bb = 'servicedesk-service-details-new';
    const $d90d8ce15e0e3233$export$17e76ebd53424ed5 = 'servicedesk-service-details-without-project';
    const $d90d8ce15e0e3233$export$b1329dc26a81a277 = 'servicedesk-service-modal-edit';
    const $d90d8ce15e0e3233$export$e1cba0bfe330f5c = 'servicedesk-service-modal-new';
    const $d90d8ce15e0e3233$export$8e68c55c334de101 = 'servicedesk-sla-settings';
    const $d90d8ce15e0e3233$export$5cb7cfba189a0240 = 'service-hub-services';
    const $d90d8ce15e0e3233$export$d28aab4a6d6f1d0d = 'service-hub-service-details';
    const $d90d8ce15e0e3233$export$1cf56e2d6c4edb35 = 'global-automation';
    const $d90d8ce15e0e3233$export$27c1770584d7e3fe = 'global-settings-issues-cmdb-field-config';
    const $d90d8ce15e0e3233$export$22e0ebdea08537f7 = 'admin-oauth-credentials';
    const $d90d8ce15e0e3233$export$4db732436e4edfaf = 'recommendations';
    const $d90d8ce15e0e3233$export$e832418dbed0717e = 'view-custom-fields';
    const $d90d8ce15e0e3233$export$ee09be798f0e4471 = 'software-advanced-roadmaps';
    const $d90d8ce15e0e3233$export$653bf90ae3578f21 = 'software-advanced-roadmaps-getting-started-redirect';
    const $d90d8ce15e0e3233$export$9da4125a0c62444d = 'software-advanced-roadmaps-redirect';
    const $d90d8ce15e0e3233$export$fbcc0fd9b402bb12 = 'software-advanced-roadmaps-setup';
    const $d90d8ce15e0e3233$export$e74fe5bd41e23fbd = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies`;
    const $d90d8ce15e0e3233$export$1a93e63ddbe4aa06 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies-redirect`;
    const $d90d8ce15e0e3233$export$3b6dbbe49882589d = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-financial-year`;
    const $d90d8ce15e0e3233$export$eb01394789016fd4 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits`;
    const $d90d8ce15e0e3233$export$f17f4523583fa8e5 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits-redirect`;
    const $d90d8ce15e0e3233$export$eaa4d6eec75a6778 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions`;
    const $d90d8ce15e0e3233$export$dcc96e4abbdc0d39 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions-redirect`;
    const $d90d8ce15e0e3233$export$9eaf39ba5a56c72a = 'software-backlog';
    const $d90d8ce15e0e3233$export$495be3320b67814a = 'software-backlog-embed';
    const $d90d8ce15e0e3233$export$25752eb5bb5e3d32 = 'software-boards';
    const $d90d8ce15e0e3233$export$f116716aedb35e10 = 'software-boards-embed';
    const $d90d8ce15e0e3233$export$36fffb6b49d9f31d = 'software-calendar';
    const $d90d8ce15e0e3233$export$a6d07be4ff318f84 = 'software-calendar-classic';
    const $d90d8ce15e0e3233$export$a9a43f1114df1ad9 = 'software-calendar-classic-embed';
    const $d90d8ce15e0e3233$export$3a4c7a521a900b4d = 'software-calendar-embed';
    const $d90d8ce15e0e3233$export$9dcf51a9040a4fd6 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct`;
    const $d90d8ce15e0e3233$export$a74f9f6bd0d4fb26 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct-embed`;
    const $d90d8ce15e0e3233$export$f8cb86acf6b74661 = 'software-code';
    const $d90d8ce15e0e3233$export$2d3d850c64058bfb = 'software-code-classic';
    const $d90d8ce15e0e3233$export$af6b51164f66908b = 'software-deployments';
    const $d90d8ce15e0e3233$export$12efc96fc9c9fb34 = 'software-deployments-classic';
    const $d90d8ce15e0e3233$export$6ab1901e04e623ba = 'software-form';
    const $d90d8ce15e0e3233$export$bccc7d0812737c4e = 'software-form-classic';
    const $d90d8ce15e0e3233$export$458fb992f2637a20 = 'software-form-builder';
    const $d90d8ce15e0e3233$export$c9c9c64f68ba51e3 = 'software-form-builder-classic';
    const $d90d8ce15e0e3233$export$50264cbc90a39f19 = 'software-form-submit';
    const $d90d8ce15e0e3233$export$b9d0cbe0888fa72e = 'software-form-submit-classic';
    const $d90d8ce15e0e3233$export$b8045610416fa8ca = 'software-goals';
    const $d90d8ce15e0e3233$export$8e80136ad13099e3 = 'software-goals-classic';
    const $d90d8ce15e0e3233$export$b5fe44c0bc324494 = 'software-incidents';
    const $d90d8ce15e0e3233$export$7a4f52d9060a20d2 = 'software-incidents-classic';
    const $d90d8ce15e0e3233$export$d6a9e4695952522e = 'software-issue-navigator';
    const $d90d8ce15e0e3233$export$deab88d0814c564b = 'software-list';
    const $d90d8ce15e0e3233$export$906faff110f898ef = 'software-list-classic';
    const $d90d8ce15e0e3233$export$ab3f2a34a3b0db87 = 'software-list-classic-embed';
    const $d90d8ce15e0e3233$export$4ed84a2011fdc400 = 'software-list-embed';
    const $d90d8ce15e0e3233$export$f7b286b39bf6051b = 'software-nextgen-redirect';
    const $d90d8ce15e0e3233$export$6c4337c0332c8c7f = 'software-onboarding';
    const $d90d8ce15e0e3233$export$e7c78887745b2326 = 'software-onboarding-get-started';
    const $d90d8ce15e0e3233$export$3805e4f07dca7584 = 'software-periscope';
    const $d90d8ce15e0e3233$export$f77254983320e888 = 'software-periscope-classic';
    const $d90d8ce15e0e3233$export$2e784832f1c6bb = 'software-plan-calendar';
    const $d90d8ce15e0e3233$export$7f97fa79520a4c5b = 'software-plan-calendar-embed';
    const $d90d8ce15e0e3233$export$9e53cdb1ac02195c = 'software-plan-dependencies';
    const $d90d8ce15e0e3233$export$58bd507904dc221c = 'software-plan-dependencies-embed';
    const $d90d8ce15e0e3233$export$7a821e22be2c2f14 = 'software-plan-increment';
    const $d90d8ce15e0e3233$export$ca8966ef80bfafc6 = 'software-plan-increment-embed';
    const $d90d8ce15e0e3233$export$e7423156dba31a7c = 'software-plan-increments';
    const $d90d8ce15e0e3233$export$cba7e383b2409c7b = 'software-plan-releases';
    const $d90d8ce15e0e3233$export$d5378fb71d5242c0 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-auto-scheduler`;
    const $d90d8ce15e0e3233$export$4b16b72c72da8833 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-custom-fields`;
    const $d90d8ce15e0e3233$export$10114d78cefb1f53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-exclusion-rules`;
    const $d90d8ce15e0e3233$export$92fe23ed30100817 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-find-your-issue`;
    const $d90d8ce15e0e3233$export$e824495554c83069 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-issue-sources`;
    const $d90d8ce15e0e3233$export$8df2e9efdd625a44 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-permissions`;
    const $d90d8ce15e0e3233$export$aeb4d3006e298033 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-plan-info`;
    const $d90d8ce15e0e3233$export$e15d3c40985c4b53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-program-boards`;
    const $d90d8ce15e0e3233$export$1d8c84454fd2d571 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-removed-issues`;
    const $d90d8ce15e0e3233$export$db61a12efb59745c = `${$d90d8ce15e0e3233$export$6f266218a6973848}-saved-views`;
    const $d90d8ce15e0e3233$export$2da67fb5bd6bc2ee = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scenarios`;
    const $d90d8ce15e0e3233$export$182e0167fd960de6 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scheduling`;
    const $d90d8ce15e0e3233$export$2d9e2484ee02e7da = 'software-plan-summary';
    const $d90d8ce15e0e3233$export$b7fff19fd89b617f = 'software-plan-summary-embed';
    const $d90d8ce15e0e3233$export$ea23f150f64e8a4e = 'software-plan-teams';
    const $d90d8ce15e0e3233$export$116338bd93f78ad0 = 'software-plan-timeline';
    const $d90d8ce15e0e3233$export$c9cd65a78227cf18 = 'software-advanced-roadmaps-embed';
    const $d90d8ce15e0e3233$export$d75d93e5d44182cc = 'software-release-notes';
    const $d90d8ce15e0e3233$export$cc3027ae3767801 = 'software-reports';
    const $d90d8ce15e0e3233$export$3492ce83b8884e0e = 'software-reports-burndown';
    const $d90d8ce15e0e3233$export$b4798b7e62733393 = 'software-reports-burnup';
    const $d90d8ce15e0e3233$export$388685c701d6e0d3 = 'software-reports-control';
    const $d90d8ce15e0e3233$export$5ff4d2d4257ea2b0 = 'software-reports-cumulative';
    const $d90d8ce15e0e3233$export$fa83895c1eac55e7 = 'software-reports-cycle-time';
    const $d90d8ce15e0e3233$export$5c82bb95a06a1846 = 'software-reports-cycle-time-classic';
    const $d90d8ce15e0e3233$export$c725b9c7e11dd69e = 'software-reports-deployment-frequency';
    const $d90d8ce15e0e3233$export$90594f89c675ba05 = 'software-reports-deployment-frequency-classic';
    const $d90d8ce15e0e3233$export$ae0d999dd2bdd59b = 'software-reports-velocity';
    const $d90d8ce15e0e3233$export$43bbf6935a91d277 = 'software-requests';
    const $d90d8ce15e0e3233$export$92e23977438282b2 = 'software-requests-classic';
    const $d90d8ce15e0e3233$export$296115eb5b7129d3 = 'software-roadmap';
    const $d90d8ce15e0e3233$export$17574f41c3925d64 = 'software-roadmap-classic';
    const $d90d8ce15e0e3233$export$955692fbfe35fc16 = 'software-roadmap-redirect';
    const $d90d8ce15e0e3233$export$30af3a767b8ad2d8 = 'software-security';
    const $d90d8ce15e0e3233$export$f47d664298c2c2f0 = 'software-security-classic';
    const $d90d8ce15e0e3233$export$2d1ed852d9885250 = 'software-summary';
    const $d90d8ce15e0e3233$export$312796fc15876480 = 'software-summary-classic';
    const $d90d8ce15e0e3233$export$a16645495fb1d5ef = 'software-staffing';
    const $d90d8ce15e0e3233$export$1714b5ad9b672bc7 = 'software-timeline';
    const $d90d8ce15e0e3233$export$c9634bf15518a3a1 = 'software-timeline-classic';
    const $d90d8ce15e0e3233$export$3b5eb3ea8cbeeed = 'software-version-detail';
    const $d90d8ce15e0e3233$export$118bb1785acc3d0b = 'software-version-detail-embed';
    const $d90d8ce15e0e3233$export$c29d90ae9a4b648e = 'software-version-detail-legacy-redirect';
    const $d90d8ce15e0e3233$export$8f2717a951373c25 = 'software-version-detail-no-tab-path';
    const $d90d8ce15e0e3233$export$831acb5098f5706d = 'system-configuration-general';
    const $d90d8ce15e0e3233$export$d218cda46c433fe1 = 'system-dashboard-edit';
    const $d90d8ce15e0e3233$export$61147168ac2833f9 = 'trashed-plan-direct-link';
    const $d90d8ce15e0e3233$export$9fe0117c0fd486a8 = 'trash-plans-directory';
    const $d90d8ce15e0e3233$export$a49474778d15635d = 'trash-projects-directory';
    const $d90d8ce15e0e3233$export$af3296e54e7fb362 = 'user-segmentation';
    const $d90d8ce15e0e3233$export$281f2e01ee9e4977 = 'your-work';
});
parcelRegister("95bh0", function(module, exports) {
    $parcel$export(module.exports, "getScopeIdentifier", ()=>$4cc145d0cf66273c$export$68278f7cf66944f9);
    const $4cc145d0cf66273c$export$68278f7cf66944f9 = (scope)=>{
        const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
        let identifierType = null;
        if (scope.boardId) identifierType = (0, $87844bbe4c23d937$export$929d50f83189406c);
        else if (scope.projectKey) identifierType = (0, $87844bbe4c23d937$export$b5a308a17bc991f3);
        else if (scope.projectId) identifierType = (0, $87844bbe4c23d937$export$da6f46390e1a426f);
        return {
            identifierValue: identifierValue,
            identifierType: identifierType
        };
    };
});
const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';
parcelRegister("8YTna", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$f7f12dfb24bc320d$export$557c2f222778cea6);
    const $f7f12dfb24bc320d$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];
});
parcelRegister("gDyED", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarNavInfo", ()=>$b6d61a4c2e3b518c$export$8a51470472777e11);
    var $eusud;
    const $b6d61a4c2e3b518c$export$8a51470472777e11 = (scopeIdentifier)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
        if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
        let queryParam = '';
        switch(identifierType){
            case 'boardId':
                queryParam = `boardId=${identifierValue}`;
                break;
            case 'projectKey':
            case 'projectId':
                queryParam = `projectIdOrKey=${identifierValue}`;
                break;
            default:
                break;
        }
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
    };
});
parcelRegister("324W5", function(module, exports) {
    $parcel$export(module.exports, "useResourceWithCustomRouterContext", ()=>$0c2698427b7aacc1$export$61dad767cf446185);
    var $e5wyW;
    var $4R6GH;
    var $dIdda = parcelRequire("dIdda");
    var $geWXd;
    const $0c2698427b7aacc1$var$DUMMY_ROUTE = {
        name: 'DUMMY_ROUTE_NAME',
        path: '/projects/:projectKey/dummyroute'
    };
    const $0c2698427b7aacc1$var$useResourceWithCustomRouterContextOld = (resource, customRouterContext, _ = {})=>{
        let useResourceArgCustomContext;
        if (customRouterContext) {
            const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
                routerContext: (0, $dIdda.createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const resourceResponse = (0, $dIdda.useResource)(resource, useResourceArgCustomContext);
        (0, (0, parcelRequire("geWXd")).useInitFetchResource)(resourceResponse, !customRouterContext);
        return resourceResponse;
    };
    function $0c2698427b7aacc1$var$useResourceWithCustomRouterContextWithOptions(resource, customRouterContext, options = {}) {
        let resourceOptions;
        if (customRouterContext) {
            const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
                routerContext: (0, $dIdda.createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const { shouldPrefetch: shouldPrefetch } = options;
        const resourceResponse = (0, $dIdda.useResource)(resource, resourceOptions);
        (0, (0, parcelRequire("geWXd")).usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
        return resourceResponse;
    }
    const $0c2698427b7aacc1$export$61dad767cf446185 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('fix_useinitresource_data_bug'), $0c2698427b7aacc1$var$useResourceWithCustomRouterContextWithOptions, $0c2698427b7aacc1$var$useResourceWithCustomRouterContextOld);
});
parcelRegister("e5wyW", function(module, exports) {
    $parcel$export(module.exports, "functionWithCondition", ()=>$12199147dc0ae1fa$export$af3c0e82a18fc057);
    $parcel$export(module.exports, "functionUnionWithCondition", ()=>$12199147dc0ae1fa$export$c41c28c1d883fcd5);
    function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
        const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
        return fnWithCondition;
    }
    function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
        return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
    }
});
parcelRegister("geWXd", function(module, exports) {
    $parcel$export(module.exports, "useInitFetchResource", ()=>$b632b0c18495344b$export$5b98692301d8680);
    $parcel$export(module.exports, "usePrefetchableResource", ()=>$b632b0c18495344b$export$99f17ace416cfe75);
    var $5uXOq = parcelRequire("5uXOq");
    const $b632b0c18495344b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
        const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
        (0, $5uXOq.useEffect)(()=>{
            if (skipInitFetch) return;
            if (!data && !loading && !error && refresh) refresh();
        }, []);
        return {
            data: data,
            loading: loading,
            error: error,
            refresh: refresh,
            ...rest
        };
    };
    function $b632b0c18495344b$export$99f17ace416cfe75(resource, shouldPrefetch) {
        (0, $5uXOq.useEffect)(()=>{
            if (!shouldPrefetch) return;
            if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
        }, []);
    }
});
parcelRegister("727Q1", function(module, exports) {
    $parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", ()=>$5300bc04c6e3c00f$export$780174995da89d60);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $ggg5j;
    var $dIdda = parcelRequire("dIdda");
    const $5300bc04c6e3c00f$export$90dbde7e33e6e21 = ()=>null;
    const $5300bc04c6e3c00f$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $dIdda.createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/:projectKey/dummyroute',
            component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
        }, {
            params: {
                projectKey: projectKey
            }
        }) : undefined;
    const $5300bc04c6e3c00f$export$19001bab9e4b7f8f = (projectKey)=>{
        const { data: data, update: update } = (0, $dIdda.useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), {
            routerContext: $5300bc04c6e3c00f$export$d647718555c2fdd8(projectKey)
        });
        return {
            data: data,
            update: update
        };
    };
    const $5300bc04c6e3c00f$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $dIdda.createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
            component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
        }, {
            params: {
                boardId: `${boardId}`
            }
        }) : undefined;
    const $5300bc04c6e3c00f$export$e2bb7877e6cec3eb = (boardId)=>{
        const { data: data, update: update } = (0, $dIdda.useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), {
            routerContext: $5300bc04c6e3c00f$export$23dc6491016cabdc(boardId)
        });
        return {
            data: data,
            update: update
        };
    };
    const $5300bc04c6e3c00f$export$780174995da89d60 = (latestNavInfo)=>{
        const [{ match: match, query: query, route: { name: name } }] = (0, $dIdda.useRouter)();
        const isOnBoardBasedRoute = (0, (0, parcelRequire("ggg5j")).getIdentifier)(name, match, query)?.identifierType === 'boardId';
        const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
        const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
        const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
        const { data: projectRouteNavInfo, update: updateProjectRoute } = $5300bc04c6e3c00f$export$19001bab9e4b7f8f(pKey);
        const { data: boardRouteNavInfo, update: updateBoardRoute } = $5300bc04c6e3c00f$export$e2bb7877e6cec3eb(boardId);
        (0, $5uXOq.useEffect)(()=>{
            if (latestNavInfo != null && isSoftwareCMP) {
                if (isOnBoardBasedRoute && !(0, ($parcel$interopDefault($ajpes)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
                else if (!(0, ($parcel$interopDefault($ajpes)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
            }
        }, [
            isOnBoardBasedRoute,
            latestNavInfo,
            updateProjectRoute,
            updateBoardRoute,
            projectRouteNavInfo,
            boardRouteNavInfo,
            isSoftwareCMP
        ]);
    };
});
parcelRegister("lmyls", function(module, exports) {
    $parcel$export(module.exports, "ADDON_ID", ()=>$ee51d260cb059727$export$6c4866a933650d1d);
    $parcel$export(module.exports, "MENU_ID", ()=>$ee51d260cb059727$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$ee51d260cb059727$export$adf978edbdfaf080);
    const $ee51d260cb059727$export$6c4866a933650d1d = {
        DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
    };
    const $ee51d260cb059727$export$d4cd258d01c03112 = {
        ADDONS: 'ADDONS',
        APP_SWITCHER: 'APP_SWITCHER',
        DASHBOARDS: 'DASHBOARDS',
        FILTERS: 'FILTERS',
        HELP: 'HELP',
        HOME: 'HOME',
        INSIGHT: 'INSIGHT',
        NOTIFICATIONS: 'NOTIFICATIONS',
        PEOPLE: 'PEOPLE',
        PLANS: 'PLANS',
        PROFILE: 'PROFILE',
        PROJECTS: 'PROJECTS',
        ROADMAPS: 'ROADMAPS',
        SEARCH: 'SEARCH',
        SERVICE_HUB: 'SERVICE_HUB',
        SETTINGS: 'SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
    const $ee51d260cb059727$export$adf978edbdfaf080 = {
        BOARD_SETTINGS: 'BOARD_SETTINGS',
        GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
        GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
        GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
        GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
        GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        PLAN_SETTINGS: 'PLAN_SETTINGS',
        PROJECT_SETTINGS: 'PROJECT_SETTINGS'
    };
});
parcelRegister("cOg46", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18dc7dd640caeb91$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("2YlLB")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
    });
    const $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalSystemSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar, null)));
    $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
    var $18dc7dd640caeb91$export$2e2bcd8739ae039 = $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar;
});
parcelRegister("dZQxE", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$e39fc1e1d73100a0$export$1edc778464f08256);
    var $5uXOq = parcelRequire("5uXOq");
    var $azzrO;
    var $5e7oM;
    var $lfTZh;
    var $5Hj3V;
    var $acDan;
    var $lGo7j;
    const $e39fc1e1d73100a0$export$1edc778464f08256 = ({ children: children, id: id })=>{
        const onFail = (0, (0, parcelRequire("acDan")).useSidebarFail)();
        const onSuccess = (0, (0, parcelRequire("acDan")).useSidebarSuccess)();
        const onError = (0, $5uXOq.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
            else onFail(location, error);
        }, [
            onFail,
            onSuccess
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Hj3V")).SidebarErrorBoundary), {
            id: id,
            packageName: "jiraSpaAppsSidebarCommon",
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav-sidebar",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            })
        }, children));
    };
});
parcelRegister("azzrO", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", ()=>$4d07bc740e316cc0$export$8df02628d98cae7e);
    $parcel$export(module.exports, "pageSegmentStore", ()=>$4d07bc740e316cc0$export$26cadbe0bcaabcde);
    $parcel$export(module.exports, "useNavPerformanceMetrics", ()=>$4d07bc740e316cc0$export$906025848d54198d);
    $parcel$export(module.exports, "NavTopPerformanceMark", ()=>$4d07bc740e316cc0$export$b7f4caa65b0906fc);
    $parcel$export(module.exports, "NavTopSSRPerformanceMark", ()=>$4d07bc740e316cc0$export$2c4a101f2cde4fc2);
    $parcel$export(module.exports, "NavTopPerformanceReport", ()=>$4d07bc740e316cc0$export$c64b31449a6177d);
    $parcel$export(module.exports, "NavSidebarPerformanceMark", ()=>$4d07bc740e316cc0$export$35b2aeea5cbc963e);
    $parcel$export(module.exports, "NavSidebarSSRPerformanceMark", ()=>$4d07bc740e316cc0$export$14f711a2cb6a655a);
    $parcel$export(module.exports, "NavSidebarPerformanceReport", ()=>$4d07bc740e316cc0$export$a018e347341b3640);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $dGrdR;
    var $cfDZ3;
    var $5M3R9;
    var $5e7oM;
    const $4d07bc740e316cc0$var$createTopNavPageSegment = ()=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME),
            timings: [
                {
                    key: 'ttic',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'bundle-load',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).bundleLoadStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderStart
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $4d07bc740e316cc0$export$8df02628d98cae7e = {
        ADDONS: (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: 'navigation-top.addons-dropdown-opened'
        })
    };
    const $4d07bc740e316cc0$var$createSidebarPageSegment = ()=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME),
            timings: [
                {
                    key: 'renderAttempt',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt
                },
                {
                    key: 'ttic',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'load',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadEnd
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $4d07bc740e316cc0$export$26cadbe0bcaabcde = (()=>{
        const segmentConstructors = {
            [(0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createTopNavPageSegment,
            [(0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createSidebarPageSegment
        };
        const segments = {};
        return {
            getSegment: (key)=>{
                if (!segments[key]) {
                    if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                    segments[key] = segmentConstructors[key]();
                }
                return segments[key];
            }
        };
    })();
    const $4d07bc740e316cc0$export$906025848d54198d = (segmentKey = (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME))=>{
        const startedRef = (0, $5uXOq.useRef)(false);
        const segment = (0, $5uXOq.useRef)($4d07bc740e316cc0$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
        if (!false && !startedRef.current) {
            segment && segment.startFromPageLoad();
            startedRef.current = true;
        }
        return (0, $5uXOq.useMemo)(()=>Object.assign(segment, {
                markSSR: (metricKey)=>{
                    const tmpSsrMetricKey = `${(0, (0, parcelRequire("5e7oM")).NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                    if (window.SPA_STATE) {
                        const { startTime: startTime = 0, duration: duration = 0 } = (0, ($parcel$interopDefault($9XE6b)))((0, (0, parcelRequire("5M3R9")).getRenderTraceFromSSRGlobal)(), [
                            'traces',
                            `render/${tmpSsrMetricKey}`
                        ]) || {};
                        const markTime = startTime + duration;
                        markTime && markTime > 0 && segment.mark(metricKey, markTime);
                    }
                }
            }), [
            segment
        ]);
    };
    const $4d07bc740e316cc0$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>navSegment.mark(metricKey), []);
        return null;
    };
    const $4d07bc740e316cc0$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const tmpSsrMetricKey = `${(0, (0, parcelRequire("5e7oM")).NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>navSegment.markSSR(metricKey), []);
        return false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: tmpSsrMetricKey
        }) : null;
    };
    const $4d07bc740e316cc0$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>{
            navSegment.stop({
                customData: {
                    ...customData,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                }
            });
            navSegment.clear();
        }, []);
        return null;
    };
    const $4d07bc740e316cc0$export$b7f4caa65b0906fc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$2c4a101f2cde4fc2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$c64b31449a6177d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$35b2aeea5cbc963e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$14f711a2cb6a655a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$a018e347341b3640 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
});
parcelRegister("5M3R9", function(module, exports) {
    $parcel$export(module.exports, "RenderTracerMark", ()=>$ca67b9a5090b457c$export$54c89059bb435049);
    $parcel$export(module.exports, "getRenderTraceFromSSRGlobal", ()=>$ca67b9a5090b457c$export$345f21b0287f67e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Csk1 = parcelRequire("6Csk1");
    var $9XE6b = parcelRequire("9XE6b");
    var $jR67t;
    var $7JoAD = parcelRequire("7JoAD");
    const $ca67b9a5090b457c$var$initialState = {
        start: undefined,
        traces: {}
    };
    let $ca67b9a5090b457c$var$currentTraces = {};
    const $ca67b9a5090b457c$export$2365ecd8218e21c7 = ()=>$ca67b9a5090b457c$var$currentTraces;
    const $ca67b9a5090b457c$export$5c757eaa1990d0d7 = (key)=>{
        if ($ca67b9a5090b457c$var$currentTraces[key]) return;
        $ca67b9a5090b457c$var$currentTraces[key] = {
            startTime: (0, (0, parcelRequire("jR67t")).performance).now()
        };
    };
    const $ca67b9a5090b457c$export$16854dc18f8d976 = (key)=>{
        if (!$ca67b9a5090b457c$var$currentTraces[key] || $ca67b9a5090b457c$var$currentTraces[key].duration != null) return;
        $ca67b9a5090b457c$var$currentTraces[key].duration = (0, (0, parcelRequire("jR67t")).performance).now() - $ca67b9a5090b457c$var$currentTraces[key].startTime;
    };
    const $ca67b9a5090b457c$var$actions = {
        startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                if (traces[key]) return;
                setState({
                    traces: (0, ($parcel$interopDefault($6Csk1)))({}, traces, {
                        [key]: {
                            startTime: time
                        }
                    })
                });
            },
        endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                const trace = traces[key] || {
                    startTime: 0
                };
                setState({
                    traces: (0, ($parcel$interopDefault($6Csk1)))({}, traces, {
                        [key]: {
                            ...trace,
                            duration: time - trace.startTime
                        }
                    })
                });
                $ca67b9a5090b457c$var$currentTraces = Object.assign($ca67b9a5090b457c$var$currentTraces, getState().traces);
            }
    };
    const $ca67b9a5090b457c$var$Store = (0, $7JoAD.createStore)({
        name: 'jira-render-tracer',
        initialState: $ca67b9a5090b457c$var$initialState,
        actions: $ca67b9a5090b457c$var$actions
    });
    const $ca67b9a5090b457c$var$RenderTracerActions = (0, $7JoAD.createSubscriber)($ca67b9a5090b457c$var$Store, {
        selector: null
    });
    const $ca67b9a5090b457c$export$719a95758870be58 = (0, $7JoAD.createHook)($ca67b9a5090b457c$var$Store, {
        selector: null
    });
    const $ca67b9a5090b457c$var$RenderTracerContainerBase = (0, $7JoAD.createContainer)($ca67b9a5090b457c$var$Store, {
        onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
                setState({
                    start: startTime,
                    traces: {
                        [startKey]: {
                            startTime: (0, (0, parcelRequire("jR67t")).performance).now()
                        }
                    }
                });
            }
    });
    const $ca67b9a5090b457c$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerContainerBase, {
            startKey: startKey,
            startTime: startTime
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$export$54c89059bb435049, {
            traceKey: startKey,
            type: "end"
        }));
    const $ca67b9a5090b457c$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
            if (type === 'start') startTrace(traceKey, (0, (0, parcelRequire("jR67t")).performance).now());
            else if (type === 'end') endTrace(traceKey, (0, (0, parcelRequire("jR67t")).performance).now());
            return null;
        });
    const $ca67b9a5090b457c$export$cba8addc8743389c = (appName = 'unknown', traces = $ca67b9a5090b457c$var$currentTraces)=>({
            [(0, $eb0760a6ada94ab6$export$3c96fa14fb694e11)]: {
                data: {
                    traces: traces,
                    routeName: appName
                }
            }
        });
    const $ca67b9a5090b457c$export$345f21b0287f67e5 = ()=>(0, ($parcel$interopDefault($9XE6b)))(window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
            (0, $eb0760a6ada94ab6$export$3c96fa14fb694e11),
            'data'
        ], {});
});
parcelRegister("jR67t", function(module, exports) {
    $parcel$export(module.exports, "performance", ()=>$c026bc7061377d6e$export$f2d2284f5fec51f8);
    const $c026bc7061377d6e$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
    class $c026bc7061377d6e$export$9a0dbed22cbf63be {
        start() {
            if (false) this.startAt = $c026bc7061377d6e$var$now();
        }
        now() {
            if (false) return $c026bc7061377d6e$var$now() - this.startAt;
            return $c026bc7061377d6e$var$now();
        }
        constructor(){
            this.startAt = $c026bc7061377d6e$var$now();
        }
    }
    const $c026bc7061377d6e$export$f2d2284f5fec51f8 = new $c026bc7061377d6e$export$9a0dbed22cbf63be();
});
const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';
parcelRegister("5e7oM", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", ()=>$83022b592d1d8567$export$6635720e40ea7a7a);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", ()=>$83022b592d1d8567$export$1d3c3cb357af0e86);
    $parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", ()=>$83022b592d1d8567$export$e7a14fa81b3c6488);
    $parcel$export(module.exports, "NAVIGATION_TOP_MARKS", ()=>$83022b592d1d8567$export$ad760bb9734bf93f);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", ()=>$83022b592d1d8567$export$1d10ee0c85c3cb21);
    const $83022b592d1d8567$export$6635720e40ea7a7a = 'navigation.top';
    const $83022b592d1d8567$export$1d3c3cb357af0e86 = 'navigation.sidebar';
    const $83022b592d1d8567$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
    const $83022b592d1d8567$export$ad760bb9734bf93f = {
        renderStart: 'navigation-top.render.start',
        renderEnd: 'navigation-top.render.end',
        renderSsrStart: 'navigation-top.render.ssr.start',
        renderSsrEnd: 'navigation-top.render.ssr.end',
        bundleLoadStart: 'navigation-top.bundle-load.start'
    };
    const $83022b592d1d8567$export$1d10ee0c85c3cb21 = {
        renderAttempt: 'navigation-sidebar.render.attempt',
        renderStart: 'navigation-sidebar.render.start',
        renderEnd: 'navigation-sidebar.render.end',
        renderSsrStart: 'navigation-sidebar.render.ssr.start',
        renderSsrEnd: 'navigation-sidebar.render.ssr.end',
        loadStart: 'navigation-sidebar.load.start',
        loadEnd: 'navigation-sidebar.load.end'
    };
});
parcelRegister("5Hj3V", function(module, exports) {
    $parcel$export(module.exports, "SidebarErrorBoundary", ()=>$c3958cf153a091e2$export$62853c5766dad0c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $cfDZ3;
    var $kqzba;
    const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
        const userLocation = (0, (0, parcelRequire("cfDZ3")).getUserLocation)();
        const extraEventData = (0, $5uXOq.useMemo)(()=>({
                ...props.extraEventData,
                userLocation: userLocation
            }), [
            props.extraEventData,
            userLocation
        ]);
        const fallback = (0, $5uXOq.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kqzba")).Fallback), {
                error: error
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            ...props,
            extraEventData: extraEventData,
            fallback: fallback
        });
    };
});
parcelRegister("kqzba", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$790c5d1c3d335eca$export$fb8d7f40caaeea67);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $kobfu;
    var $koVbs;
    var $evbHg = parcelRequire("evbHg");
    var $h8OaL;
    const $790c5d1c3d335eca$var$styles = {
        wrapper: "_bfhk1jdc _syaz1mjl _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc _1e0c1txw _2lx21bp4",
        error: "_2rko9j3y _1wybqk37 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
        image: "_4t3i12am"
    };
    const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
        const { error: error } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.wrapper
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            alt: "",
            src: (0, ($parcel$interopDefault($evbHg))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.image
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("h8OaL")).default).errorHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("h8OaL")).default).errorBody)), (0, ($parcel$interopDefault($5uXOq))).createElement("code", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.error
            ])
        }, "ERROR: ", (0, (0, parcelRequire("kobfu")).getErrorHash)(error)));
    };
});
parcelRegister("evbHg", function(module, exports) {
    module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();
});
parcelRegister("h8OaL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7c8a71ff5065c1e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorHeading: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("acDan", function(module, exports) {
    $parcel$export(module.exports, "SidebarStart", ()=>$b5a3a4467dac2130$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarRenderStart", ()=>$b5a3a4467dac2130$export$ba19e3624956e66);
    $parcel$export(module.exports, "SidebarReady", ()=>$b5a3a4467dac2130$export$a06ecbbe5820282);
    $parcel$export(module.exports, "useSidebarFail", ()=>$b5a3a4467dac2130$export$661ed14c8f75da9f);
    $parcel$export(module.exports, "useSidebarSuccess", ()=>$b5a3a4467dac2130$export$ddb17534fdfb7dc6);
    var $5uXOq = parcelRequire("5uXOq");
    var $azzrO;
    var $5e7oM;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $4QcD9;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $6IzHB;
    var $dIdda = parcelRequire("dIdda");
    var $kvHKs;
    const { useValue: $b5a3a4467dac2130$var$useSidebarId } = (0, (0, parcelRequire("4QcD9")).createValueController)('sidebar-id');
    const $b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
        experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE),
        attributes: {
            sidebar: 'v3'
        }
    };
    const $b5a3a4467dac2130$export$6738d1299dc79710 = ()=>{
        const [{ route: route, match: match }] = (0, $dIdda.useRouter)();
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        const startRef = (0, $5uXOq.useRef)(Date.now());
        const onStartExperience = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experienceId: pageId,
            experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE),
            analyticsSource: 'Sidebar'
        });
        (0, $5uXOq.useMemo)(()=>{
            if (route.isRedirect ?? false) return;
            onStartExperience();
            startRef.current = Date.now();
        }, [
            route,
            match
        ]);
        return null;
    };
    const $b5a3a4467dac2130$export$ba19e3624956e66 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderStart
        });
    const $b5a3a4467dac2130$export$a06ecbbe5820282 = ({ id: id })=>{
        const [, setSidebarId] = $b5a3a4467dac2130$var$useSidebarId();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const onSuccess = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
        (0, $5uXOq.useEffect)(()=>{
            setSidebarId(id);
            return ()=>setSidebarId();
        }, [
            setSidebarId,
            id
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (route.isRedirect ?? false) return;
            onSuccess();
        }, [
            onSuccess,
            route
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            window.__POLLINATOR__ = {
                ...window.__POLLINATOR__,
                routeName: routeName
            };
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            routeName
        ]);
        const customData = (0, $5uXOq.useMemo)(()=>({
                route: routeName,
                sidebarId: id
            }), [
            routeName,
            id
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceReport), {
            customData: customData
        }));
    };
    const $b5a3a4467dac2130$export$661ed14c8f75da9f = ()=>{
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE)
        });
        return (0, $5uXOq.useCallback)((location, error)=>{
            onFail(location, error);
        }, [
            onFail
        ]);
    };
    const $b5a3a4467dac2130$export$ddb17534fdfb7dc6 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
});
parcelRegister("93jKl", function(module, exports) {
    $parcel$export(module.exports, "useExperienceFail", ()=>$e2626e1ab0692489$export$606da7704d8eaf06);
    var $5uXOq = parcelRequire("5uXOq");
    var $fZneA;
    var $bCf8q;
    var $l9g16;
    const $e2626e1ab0692489$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const self = (0, $5uXOq.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $5uXOq.useCallback)((location, error, extraAttributes = {})=>{
            const { current: current } = self;
            if ((0, (0, parcelRequire("bCf8q")).isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return;
            current.experienceTracker.fail({
                name: current.name,
                error: error,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes,
                    location: location
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("l9g16", function(module, exports) {
    $parcel$export(module.exports, "useExperienceContext", ()=>$79f23c22d88dd8d5$export$be8ec22ac9208049);
    var $5uXOq = parcelRequire("5uXOq");
    var $bSOOm;
    const $79f23c22d88dd8d5$export$be8ec22ac9208049 = ()=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext));
        return context;
    };
});
parcelRegister("kaHBi", function(module, exports) {
    $parcel$export(module.exports, "useExperienceStart", ()=>$e1187df33c58b997$export$675e0d25df38d426);
    $parcel$export(module.exports, "ExperienceStart", ()=>$e1187df33c58b997$export$f20b867e738a222c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $l9g16;
    const $e1187df33c58b997$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
        const self = (0, $5uXOq.useRef)({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            experienceTracker: experienceTracker,
            disableSli: disableSli,
            userLocation: userLocation,
            collect: collect
        });
        self.current.experienceId = experienceId;
        self.current.experience = experience;
        self.current.timeout = timeout;
        self.current.analyticsSource = analyticsSource;
        self.current.application = application;
        self.current.edition = edition;
        self.current.experienceTracker = experienceTracker;
        self.current.userLocation = userLocation;
        self.current.collect = collect;
        return (0, $5uXOq.useCallback)(()=>{
            const { current: current } = self;
            current.experienceTracker.start({
                id: current.experienceId,
                name: current.experience,
                timeout: current.timeout,
                attributes: {
                    analyticsSource: current.analyticsSource,
                    experience: current.experience,
                    experienceId: current.experienceId,
                    application: current.application,
                    edition: current.edition,
                    disableSli: current.disableSli,
                    userLocation: current.userLocation
                },
                collect: current.collect,
                onSuccess: ()=>undefined
            });
        }, [
            self
        ]);
    };
    const $e1187df33c58b997$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
        const onStart = $e1187df33c58b997$export$675e0d25df38d426({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            disableSli: disableSli,
            collect: collect
        });
        (0, $5uXOq.useMemo)(()=>{
            onStart();
        }, [
            onStart,
            experienceId,
            experience,
            timeout,
            analyticsSource,
            application,
            edition,
            disableSli,
            collect
        ]);
        return null;
    };
});
parcelRegister("6jY6G", function(module, exports) {
    $parcel$export(module.exports, "useCurrentRoute", ()=>$dda4cada2257eb1d$export$c4b7ea2942f2d0e);
    $parcel$export(module.exports, "useRouteByName", ()=>$dda4cada2257eb1d$export$d69a946e2d0a1c12);
    $parcel$export(module.exports, "usePreviousRouterState", ()=>$dda4cada2257eb1d$export$1e5fb68306bd0b92);
    var $dIdda = parcelRequire("dIdda");
    var $cfDZ3;
    const $dda4cada2257eb1d$export$c4b7ea2942f2d0e = (0, $dIdda.createRouterSelector)((state)=>state.route);
    const $dda4cada2257eb1d$export$d69a946e2d0a1c12 = (0, $dIdda.createRouterSelector)((state, routeName)=>state.routes.find(({ name: name })=>name === routeName) ?? null);
    const $dda4cada2257eb1d$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
            name: name,
            path: path,
            query: query,
            exact: exact
        });
    const $dda4cada2257eb1d$export$1e5fb68306bd0b92 = ()=>{
        (0, $dIdda.useRouter)();
        return (0, (0, parcelRequire("cfDZ3")).getPreviousRouterState)();
    };
});
parcelRegister("3bQtK", function(module, exports) {
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$f46ca4b214d7cdb6$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$f46ca4b214d7cdb6$export$4962f3898bd5c829);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $l9g16;
    const $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT = {};
    const $f46ca4b214d7cdb6$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const self = (0, $5uXOq.useRef)({
            experience: experience,
            attributes: attributes,
            experienceTracker: experienceTracker,
            route: route
        });
        self.current.route = route;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        self.current.experience = experience;
        return (0, $5uXOq.useCallback)((extraAttributes = {})=>{
            const { current: current } = self;
            if (current.route && current.route.isRedirect === true) return;
            current.experienceTracker.succeed({
                name: current.experience,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
    const $f46ca4b214d7cdb6$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
        const onExperienceSuccess = $f46ca4b214d7cdb6$export$e94f0da4fc0603c6({
            experience: experience,
            attributes: attributes
        });
        (0, $5uXOq.useEffect)(()=>{
            onExperienceSuccess();
        }, [
            attributes,
            onExperienceSuccess
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (false) onExperienceSuccess();
        }, [
            onExperienceSuccess
        ]);
        return null;
    };
});
parcelRegister("4QcD9", function(module, exports) {
    $parcel$export(module.exports, "createValueController", ()=>$3f293f209341d999$export$ff0ab9dd4ceb4a93);
    var $7JoAD = parcelRequire("7JoAD");
    const $3f293f209341d999$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
        const actions = {
            setValue: (value)=>({ setState: setState })=>setState({
                        value: value
                    })
        };
        const initialState = {
            value: defaultValue
        };
        const store = (0, $7JoAD.createStore)({
            name: name,
            initialState: initialState,
            actions: actions
        });
        const ValueContainer = (0, $7JoAD.createContainer)(store);
        const selector = (state)=>state.value;
        const useValueInternal = (0, $7JoAD.createHook)(store, {
            selector: selector
        });
        const useValue = ()=>{
            const [value, { setValue: setValue }] = useValueInternal();
            return [
                value,
                setValue
            ];
        };
        return {
            ValueContainer: ValueContainer,
            useValue: useValue
        };
    };
});
parcelRegister("6IzHB", function(module, exports) {
    $parcel$export(module.exports, "usePageId", ()=>$57184c749af08735$export$3434ba5eadb360dc);
    var $7JoAD = parcelRequire("7JoAD");
    var $7w9eZ;
    const $57184c749af08735$var$useSweetStatePageId = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: (state)=>state.currentPage.uuid
    });
    const $57184c749af08735$export$3434ba5eadb360dc = ()=>{
        const [pageId] = $57184c749af08735$var$useSweetStatePageId();
        return pageId;
    };
});
parcelRegister("7w9eZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85db42238a8acf29$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $7JoAD = parcelRequire("7JoAD");
    var $6Bj8c;
    const $85db42238a8acf29$export$d4c72bab9d6cc13a = {
        transitionCheckTimestamp: -1,
        currentPage: {
            uuid: false ? '' : (0, ($parcel$interopDefault($7Jxgt))).v4(),
            startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
            apps: {},
            userLocation: ''
        },
        visitedPages: [],
        navigation: {
            isCollapsed: false,
            viewId: 'noView',
            viewType: '',
            projectType: null,
            isInitialEventSent: false,
            pageId: null,
            nextViewId: ''
        }
    };
    const $85db42238a8acf29$var$store = (0, $7JoAD.createStore)({
        name: 'spa-state',
        initialState: $85db42238a8acf29$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("6Bj8c"))
    });
    var $85db42238a8acf29$export$2e2bcd8739ae039 = $85db42238a8acf29$var$store;
});
parcelRegister("6Bj8c", function(module, exports) {
    $parcel$export(module.exports, "setAppStart", ()=>(parcelRequire("fI6Pg")).setAppStart);
    $parcel$export(module.exports, "setAppReady", ()=>(parcelRequire("fI6Pg")).setAppReady);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>(parcelRequire("fI6Pg")).setAppStartWithAppId);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>(parcelRequire("fI6Pg")).setAppReadyWithAppId);
    $parcel$export(module.exports, "setAppErrorReady", ()=>(parcelRequire("fI6Pg")).setAppErrorReady);
    $parcel$export(module.exports, "setTimeoutReady", ()=>(parcelRequire("fI6Pg")).setTimeoutReady);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>(parcelRequire("fI6Pg")).setTimeoutReadyWithAppId);
    $parcel$export(module.exports, "resetCurrentPage", ()=>(parcelRequire("fI6Pg")).resetCurrentPage);
    $parcel$export(module.exports, "setResourceMetrics", ()=>(parcelRequire("fI6Pg")).setResourceMetrics);
    var $fI6Pg;
});
parcelRegister("fI6Pg", function(module, exports) {
    $parcel$export(module.exports, "resetCurrentPage", ()=>$4a986cd3487bf863$export$5639685a1fb81722);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>$4a986cd3487bf863$export$8a98548dad2fa97b);
    $parcel$export(module.exports, "setTimeoutReady", ()=>$4a986cd3487bf863$export$b9cc4378ea785421);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>$4a986cd3487bf863$export$9d528722f2ff2999);
    $parcel$export(module.exports, "setAppStart", ()=>$4a986cd3487bf863$export$71192061050856ad);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>$4a986cd3487bf863$export$6a25429a42d30f9a);
    $parcel$export(module.exports, "setAppReady", ()=>$4a986cd3487bf863$export$fc59cc4ed9bba7cd);
    $parcel$export(module.exports, "setAppErrorReady", ()=>$4a986cd3487bf863$export$aff63c1e41443b6a);
    $parcel$export(module.exports, "setResourceMetrics", ()=>$4a986cd3487bf863$export$8ad155d489dcf34d);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1ciso;
    var $21pfT;
    var $co1wz;
    var $cfDZ3;
    var $1AZST;
    const $4a986cd3487bf863$export$7bd623b29ec8e1eb = 10000;
    const $4a986cd3487bf863$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            performance.mark('resetCurrentPage');
            (0, (0, parcelRequire("21pfT")).browserMetrics).startPageLoad({
                isInitial: false
            });
            (0, (0, parcelRequire("1ciso")).default)(nextRouteUfoName, nextRouteName);
            if ((0, (0, parcelRequire("co1wz")).ff)('uip.ufo')) {
                (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).abort({
                    force: true
                });
                (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
            }
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
                currentPage: {
                    uuid: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                    apps: {},
                    startTime: Date.now(),
                    userLocation: ''
                },
                visitedPages: [
                    ...currentState.visitedPages,
                    {
                        ...currentState.currentPage
                    }
                ],
                transitionCheckTimestamp: 0
            });
        };
    const $4a986cd3487bf863$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
                const apps = {
                    ...currentPage.apps
                };
                if (apps[appId] && apps[appId].expectingTimeout) {
                    const updatedPage = {
                        ...currentPage,
                        apps: {
                            ...apps,
                            [appId]: {
                                ...apps[appId],
                                timeoutTime: timeoutTime,
                                expectingTimeout: 0
                            }
                        }
                    };
                    setState({
                        currentPage: updatedPage
                    });
                }
            }
        };
    const $4a986cd3487bf863$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId, timeoutTime));
        };
    const $4a986cd3487bf863$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
                const timeoutId = setTimeout(()=>{
                    dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId));
                }, $4a986cd3487bf863$export$7bd623b29ec8e1eb);
                const updatedPage = {
                    ...currentPage,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)(),
                    apps: {
                        ...currentPage.apps,
                        [appId]: {
                            startTime: startTime,
                            expectingTimeout: timeoutId
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$9d528722f2ff2999(appId, startTime));
        };
    const $4a986cd3487bf863$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
                const apps = {
                    ...currentPage.apps
                };
                clearTimeout(currentPage.apps[appId].expectingTimeout);
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            endTime: endTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$6a25429a42d30f9a(appId, endTime));
        };
    const $4a986cd3487bf863$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        'error-page': {
                            endTime: Date.now()
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            setState({
                currentPage: {
                    ...currentState.currentPage,
                    resources: [
                        ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                        resourceMetrics
                    ]
                }
            });
        };
});
parcelRegister("kvHKs", function(module, exports) {
    $parcel$export(module.exports, "REPO_TYPE", ()=>$f1419662a60c783a$export$399c7e6858236b4);
    $parcel$export(module.exports, "LINK_TYPE", ()=>$f1419662a60c783a$export$58125ce2bb1c3378);
    $parcel$export(module.exports, "EMOJI_REGEX", ()=>$f1419662a60c783a$export$c79ed2783644934c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", ()=>$f1419662a60c783a$export$25ae65041c800c9);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", ()=>$f1419662a60c783a$export$e03c9beea817d44b);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", ()=>$f1419662a60c783a$export$3d575bdf28c0d17c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", ()=>$f1419662a60c783a$export$af84baced6970a17);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", ()=>$f1419662a60c783a$export$c767f253046b1ea7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", ()=>$f1419662a60c783a$export$265b9384cc2dfbd4);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$2de77b357e71c7a7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$7de7abb92169d6c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$fd7df8bd7600c65c);
    $parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", ()=>$f1419662a60c783a$export$dde074e512e80dff);
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$f1419662a60c783a$export$1f70a76cb421b107);
    $parcel$export(module.exports, "SIDEBAR_EXPERIENCE", ()=>$f1419662a60c783a$export$71aaf2625ee54d10);
    $parcel$export(module.exports, "staticLegacyIds", ()=>$f1419662a60c783a$export$f57650e6e7be03dc);
    const $f1419662a60c783a$export$399c7e6858236b4 = 'source.code.link';
    const $f1419662a60c783a$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
    const $f1419662a60c783a$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
    const $f1419662a60c783a$export$25ae65041c800c9 = 'pin-filter-myopenissues';
    const $f1419662a60c783a$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
    const $f1419662a60c783a$export$3d575bdf28c0d17c = 'pin-filter-allissues';
    const $f1419662a60c783a$export$af84baced6970a17 = 'pin-filter-allopenissues';
    const $f1419662a60c783a$export$c767f253046b1ea7 = 'pin-filter-doneissues';
    const $f1419662a60c783a$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
    const $f1419662a60c783a$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
    const $f1419662a60c783a$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
    const $f1419662a60c783a$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
    const $f1419662a60c783a$export$dde074e512e80dff = 'global-create-spotlight';
    const $f1419662a60c783a$export$1f70a76cb421b107 = {
        REPORTS_ADDONS: 'sd-reports-addons'
    };
    const $f1419662a60c783a$export$83016cff6318a5dd = Object.freeze({
        CODE_TAB: 'CODE_TAB',
        ONCALL_TAB: 'ONCALL_TAB',
        PAGES_TAB: 'PAGES_TAB'
    });
    const $f1419662a60c783a$export$f371b4c263b142af = {
        [$f1419662a60c783a$export$83016cff6318a5dd.CODE_TAB]: 'code',
        [$f1419662a60c783a$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
        [$f1419662a60c783a$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
    };
    const $f1419662a60c783a$export$b66c40cadee12a0b = 'project/agility/index';
    const $f1419662a60c783a$export$6f454e69bce3a691 = 'project/business/index';
    const $f1419662a60c783a$export$3a0f7f7a8a0b306b = 'project/ops/index';
    const $f1419662a60c783a$export$1346c9aa3cbb477d = 'project/software/index';
    const $f1419662a60c783a$export$4598dd67943205cf = 'project/software/issues';
    const $f1419662a60c783a$export$8f36e85c5afae5 = 'project/software/reports';
    const $f1419662a60c783a$export$8151e5564c0016a1 = 'attachments';
    const $f1419662a60c783a$export$4acd0d06a25e56b5 = 'eventtypes';
    const $f1419662a60c783a$export$211ab01804585e09 = 'webhooks-admin';
    const $f1419662a60c783a$export$294b9ab8545a9f36 = 'services';
    const $f1419662a60c783a$export$665efe695022359b = 'greenhopper-lexorank-manage';
    const $f1419662a60c783a$export$47fbefc73055eb9d = 'admin-helper-admin-section';
    const $f1419662a60c783a$export$76e6bd729450de52 = 'advanced_section';
    const $f1419662a60c783a$export$ac928a90c0d3daa8 = 'collectors';
    const $f1419662a60c783a$export$309ac0136b7d5dfa = 'dark_features';
    const $f1419662a60c783a$export$998f1706a6ca29b = 'general_configuration';
    const $f1419662a60c783a$export$e9af81a594543847 = 'import_export_section';
    const $f1419662a60c783a$export$bbf19cc23216c6b = 'mail_section';
    const $f1419662a60c783a$export$693dd06b18660b78 = 'security_section';
    const $f1419662a60c783a$export$c6d1221ea0bce75e = 'shared_section';
    const $f1419662a60c783a$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
    const $f1419662a60c783a$export$af156d8e27fc5458 = 'user_interface';
    const $f1419662a60c783a$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
    const $f1419662a60c783a$export$f57650e6e7be03dc = [
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ];
});
parcelRegister("lGo7j", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$0c703bf4651638aa$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $gjTBi;
    var $bWqXX;
    const $0c703bf4651638aa$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "sidebar-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$BackgroundedWrapper, null, isFull && (0, ($parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$HeadingWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }))));
    const $0c703bf4651638aa$var$BackgroundedWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tem _1yt4s5g3",
                __cmplp.className
            ])
        });
    });
    const $0c703bf4651638aa$var$HeadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41k9c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gjTBi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab78cae21894a64c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9UCCQ;
    var $jsTfk;
    var $j9VTE;
    const $ab78cae21894a64c$var$Section = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return props.children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            ...props,
            ref: ref,
            overrides: {
                HeadingItem: {
                    cssFn: (0, (0, parcelRequire("jsTfk")).sectionHeaderSpacingStyles)
                }
            }
        });
    });
    var $ab78cae21894a64c$export$2e2bcd8739ae039 = $ab78cae21894a64c$var$Section;
});
parcelRegister("jsTfk", function(module, exports) {
    $parcel$export(module.exports, "overrideStyleFunction", ()=>$0d8b3d5d608d86de$export$505cedac1a39aacf);
    $parcel$export(module.exports, "baseSideNavItemStyle", ()=>$0d8b3d5d608d86de$export$aed216a85ec468ac);
    $parcel$export(module.exports, "sectionHeaderSpacingStyles", ()=>$0d8b3d5d608d86de$export$a5c27bed78cfecb9);
    const $0d8b3d5d608d86de$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
        return (state)=>{
            return [
                baseStyle(state),
                newStyle(state)
            ];
        };
    };
    const $0d8b3d5d608d86de$var$defaultStyles = {
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:active': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
        }
    };
    const $0d8b3d5d608d86de$var$selectedStyles = {
        backgroundColor: `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        ':visited': {
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        }
    };
    const $0d8b3d5d608d86de$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
        return {
            paddingBlock: "var(--ds-space-100, 8px)",
            paddingInline: "var(--ds-space-100, 8px)",
            borderRadius: "var(--ds-border-radius, 3px)",
            backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
            ...!isDisabled && !isSelected && $0d8b3d5d608d86de$var$defaultStyles,
            ...!isDisabled && isSelected && $0d8b3d5d608d86de$var$selectedStyles,
            ['& [data-item-elem-before]']: {
                height: '1.5rem',
                width: '1.5rem'
            }
        };
    };
    const $0d8b3d5d608d86de$export$a5c27bed78cfecb9 = ()=>{
        return {
            paddingInline: "var(--ds-space-100, 8px)"
        };
    };
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("bWqXX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c4e822429ecf69c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iwwXK;
    var $jsTfk;
    var $j9VTE;
    const $9c4e822429ecf69c$var$SkeletonItem = (props)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            cssFn: ()=>({
                    ...(0, (0, parcelRequire("jsTfk")).sectionHeaderSpacingStyles)(),
                    '&&::before': {
                        height: '1.5rem',
                        marginRight: "var(--ds-space-200, 16px)",
                        width: '1.5rem'
                    }
                }),
            ...props
        });
    };
    var $9c4e822429ecf69c$export$2e2bcd8739ae039 = $9c4e822429ecf69c$var$SkeletonItem;
});
parcelRegister("gbGmI", function(module, exports) {
    $parcel$export(module.exports, "setPerformanceMarkLoadStart", ()=>$46c186c6902de7dc$export$4166241bf9111f66);
    $parcel$export(module.exports, "setPerformanceMarkLoadEnd", ()=>$46c186c6902de7dc$export$edbd543f308bbef5);
    var $azzrO;
    var $5e7oM;
    const $46c186c6902de7dc$export$4166241bf9111f66 = ()=>{
        const sideBarSegment = (0, (0, parcelRequire("azzrO")).pageSegmentStore).getSegment((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadStart);
    };
    const $46c186c6902de7dc$export$edbd543f308bbef5 = ()=>{
        const sideBarSegment = (0, (0, parcelRequire("azzrO")).pageSegmentStore).getSegment((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadEnd);
    };
});
parcelRegister("2YlLB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("gQZpl")
    ]).then(()=>parcelRequire('6Pefo'));
});
parcelRegister("2G9Bk", function(module, exports) {
    $parcel$export(module.exports, "createEntry", ()=>$2b838b47862d019e$export$344b9c9ab5e66c9a);
    const $2b838b47862d019e$export$344b9c9ab5e66c9a = (baseRoute, opts)=>{
        baseRoute.lazyOpts = opts;
        return baseRoute;
    };
});
parcelRegister("3RJkv", function(module, exports) {
    $parcel$export(module.exports, "getModernIssueTransitionResources", ()=>$4f455891fb36bf50$export$e1afa08027b1e44b);
    $parcel$export(module.exports, "getNavigationResources", ()=>$4f455891fb36bf50$export$75cffd1aaecf4a2c);
    $parcel$export(module.exports, "getUserBoardNavigationResources", ()=>$4f455891fb36bf50$export$c57dc1ea7f76f91f);
    $parcel$export(module.exports, "getNavigationSidebarProjectResource", ()=>$4f455891fb36bf50$export$c4cf7264f95bae78);
    $parcel$export(module.exports, "getNavigationSidebarPlanResources", ()=>$4f455891fb36bf50$export$af2259a87f79645d);
    $parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", ()=>$4f455891fb36bf50$export$a103e99ad51f7bc3);
    $parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", ()=>$4f455891fb36bf50$export$808691f5a412afa3);
    var $5kYzp;
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $8uKLe;
    var $7xTO3;
    var $c1N9v;
    var $6zFAI;
    var $loy04;
    var $ggg5j;
    var $iEUaw;
    var $2fwuR;
    var $3HwlS;
    var $h9iZl;
    var $2eyDn;
    var $drGWM;
    var $kMiZJ;
    var $bHhiy;
    var $aA974;
    var $f5nIZ;
    var $hZhhj;
    var $9MiT2;
    var $fNOVA;
    var $14XJw;
    var $kJQXA;
    var $atU1t;
    var $c34Wf;
    var $eOlBz;
    var $3X1Xr;
    var $dxCvy;
    var $kkNtb;
    var $7GnDe;
    var $2Ql51;
    var $9vlEn;
    var $gNStA;
    const $4f455891fb36bf50$var$getNewIssueTransitionExperienceInJiraLabsVariation = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', [
            'OFF',
            'BY_DEFAULT_USER_OPT_IN',
            'BY_DEFAULT_USER_OPT_OUT'
        ]);
    const $4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled = ()=>{
        const variation = $4f455891fb36bf50$var$getNewIssueTransitionExperienceInJiraLabsVariation();
        return variation !== 'OFF';
    };
    const $4f455891fb36bf50$var$conditionalGicOptInStatusResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('project.config.pce.modern.global-issue-create'), (0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
    const $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)($4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled, (0, (0, parcelRequire("fNOVA")).issueTransitionOptInStatusResource));
    const $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('gic-smart-fields-jira-labs_8uwvr') || (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs'), (0, (0, parcelRequire("aA974")).gicSmartFieldsFeatureResource));
    const $4f455891fb36bf50$var$conditionalConsentBannerUserPreferencesResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2'), (0, (0, parcelRequire("2eyDn")).consentBannerUserPreferencesResource));
    const $4f455891fb36bf50$export$e1afa08027b1e44b = ()=>[
            $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource,
            (0, (0, parcelRequire("9MiT2")).issueTransitionChangeboardingPreferencesResource)
        ];
    const $4f455891fb36bf50$var$dedupableConditionalResources = [
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("kMiZJ")).consolidationUserStateResource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("2fwuR")).sidebarNav4Resource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("2fwuR")).sidebarNav4UiStateResource))
    ];
    const $4f455891fb36bf50$export$75cffd1aaecf4a2c = ()=>[
            (0, (0, parcelRequire("c34Wf")).navigationUiStateResource),
            (0, (0, parcelRequire("h9iZl")).navigationPlansVisibilityResource),
            (0, (0, parcelRequire("9vlEn")).userHomepageResource),
            $4f455891fb36bf50$var$conditionalGicOptInStatusResource,
            (0, (0, parcelRequire("5kYzp")).announcementBannerSettingsV4Resource),
            $4f455891fb36bf50$var$conditionalConsentBannerUserPreferencesResource,
            ...$4f455891fb36bf50$var$dedupableConditionalResources,
            (0, (0, parcelRequire("14XJw")).organizationIdResource),
            (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
            ...$4f455891fb36bf50$export$e1afa08027b1e44b(),
            (0, (0, parcelRequire("3X1Xr")).persistentIssueCreateModalViewResource),
            $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource,
            (0, (0, parcelRequire("hZhhj")).incomingMailServerExpiryStatusResource),
            (0, (0, parcelRequire("kkNtb")).rovoEntitlementResource)
        ];
    const $4f455891fb36bf50$export$c57dc1ea7f76f91f = ()=>[
            (0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource)
        ];
    const $4f455891fb36bf50$export$c4cf7264f95bae78 = ()=>[
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
        ];
    const $4f455891fb36bf50$export$af2259a87f79645d = ()=>[
            (0, (0, parcelRequire("c1N9v")).staticPlanSidebarNavigationResource)
        ];
    const $4f455891fb36bf50$export$a103e99ad51f7bc3 = ()=>[
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
            (0, (0, parcelRequire("drGWM")).checkApiKeyManagementKeysResource)()
        ];
    const $4f455891fb36bf50$export$808691f5a412afa3 = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("kJQXA")).navigationSidebarAutomationLegacyEnabledResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource),
            (0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource)
        ];
});
parcelRegister("5kYzp", function(module, exports) {
    $parcel$export(module.exports, "announcementBannerSettingsV4Resource", ()=>$76a68e4d8702ab58$export$8fbe7f8de07afffd);
    $parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", ()=>$76a68e4d8702ab58$export$6fb72f4a0c177494);
    var $dIdda = parcelRequire("dIdda");
    var $4AdUG;
    var $2EmJy;
    var $9UEf0;
    const $76a68e4d8702ab58$export$2a421cd16fa9a95a = (0, $dIdda.createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, (0, parcelRequire("2EmJy")).get)(),
                (0, (0, parcelRequire("9UEf0")).get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $76a68e4d8702ab58$export$8fbe7f8de07afffd = (0, $dIdda.createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, (0, parcelRequire("4AdUG")).get)(),
                (0, (0, parcelRequire("9UEf0")).get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $76a68e4d8702ab58$export$43d4950a3e443fd3 = ()=>(0, $dIdda.useResource)($76a68e4d8702ab58$export$2a421cd16fa9a95a);
    const $76a68e4d8702ab58$export$6fb72f4a0c177494 = ()=>(0, $dIdda.useResource)($76a68e4d8702ab58$export$8fbe7f8de07afffd);
});
parcelRegister("4AdUG", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$90a9ae99ea774144$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$90a9ae99ea774144$export$adaa4cf7ef1b65be);
    var $jcw0u;
    var $eusud;
    const $90a9ae99ea774144$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/4/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                content: '',
                bgColor: 'grey',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'settingsV4Get',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
    const $90a9ae99ea774144$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/4/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'settingsV4Set',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
});
parcelRegister("2EmJy", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$02ac2f2e29fd92e6$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$02ac2f2e29fd92e6$export$adaa4cf7ef1b65be);
    var $jcw0u;
    var $eusud;
    const $02ac2f2e29fd92e6$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/3/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                message: '',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'settingsGet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/3/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'settingsSet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
const $981adbf91eeefd26$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $981adbf91eeefd26$export$5e0c0e8c940630f8 = 'private';
const $981adbf91eeefd26$export$1d5a5b6462188eb3 = 'public';
parcelRegister("9UEf0", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$0fff4d2d98ff5692$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$0fff4d2d98ff5692$export$adaa4cf7ef1b65be);
    var $89SaW;
    var $jcw0u;
    const $0fff4d2d98ff5692$var$key = 'announcementBannerDismissedLast';
    const $0fff4d2d98ff5692$export$3988ae62b71be9a3 = async (accoundId)=>{
        try {
            return accoundId != null ? (await (0, (0, parcelRequire("89SaW")).getUserProperty)(accoundId, $0fff4d2d98ff5692$var$key)).hashId : null;
        } catch (error) {
            if (error.statusCode === 404) return null;
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'userDismissGet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $0fff4d2d98ff5692$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
        try {
            return await (0, (0, parcelRequire("89SaW")).setUserProperties)(accoundId, $0fff4d2d98ff5692$var$key, JSON.stringify({
                hashId: hashId
            }));
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'userDismissSet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
parcelRegister("89SaW", function(module, exports) {
    $parcel$export(module.exports, "getUserPropertiesUrl", ()=>$646571db30c23ce6$export$f474e53c8191800a);
    $parcel$export(module.exports, "setUserProperties", ()=>$646571db30c23ce6$export$d0e176862bf869b8);
    $parcel$export(module.exports, "getUserProperty", ()=>$646571db30c23ce6$export$b3126db2ef6e34ed);
    var $gHS8W;
    var $jJZqs;
    const $646571db30c23ce6$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
    const $646571db30c23ce6$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), {
            ...(0, (0, parcelRequire("gHS8W")).default),
            method: 'PUT',
            body: data
        });
    const $646571db30c23ce6$export$b3126db2ef6e34ed = (accountId, propertyKey)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), (0, (0, parcelRequire("gHS8W")).default)).then((res)=>{
            if (res.status === 200) return res.json();
            return res.text().then((errResp)=>{
                throw new (0, (0, parcelRequire("jJZqs")).default)(res.status, errResp);
            });
        }).then((data)=>data.value);
});
parcelRegister("gHS8W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33c6318209de3901$export$2e2bcd8739ae039);
    const $33c6318209de3901$var$defaultOptions = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    var $33c6318209de3901$export$2e2bcd8739ae039 = $33c6318209de3901$var$defaultOptions;
});
parcelRegister("5bkvv", function(module, exports) {
    $parcel$export(module.exports, "forgeAdminModuleV1Resource", ()=>$3d515a0fe8e87c81$export$168ac1f97221e90b);
    $parcel$export(module.exports, "forgeAdminModuleV2Resource", ()=>$3d515a0fe8e87c81$export$536a08360f048bac);
    $parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", ()=>$3d515a0fe8e87c81$export$dcc98f4b36ce9223);
    $parcel$export(module.exports, "forgeProjectModuleV1Resource", ()=>$3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
    $parcel$export(module.exports, "forgeProjectModuleV2Resource", ()=>$3d515a0fe8e87c81$export$1a17680eb0746291);
    $parcel$export(module.exports, "forgeProjectModuleResource", ()=>$3d515a0fe8e87c81$export$72db683c2914a65e);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV1Resource", ()=>$3d515a0fe8e87c81$export$fa67d109c2a45864);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV2Resource", ()=>$3d515a0fe8e87c81$export$23c2bb87c561c9db);
    $parcel$export(module.exports, "forgeProjectSettingsModuleResource", ()=>$3d515a0fe8e87c81$export$7a928d209faf75f);
    $parcel$export(module.exports, "useForgeProjectSettingsModuleResource", ()=>$3d515a0fe8e87c81$export$e81e11bbc3239153);
    $parcel$export(module.exports, "forgeGlobalModuleV1Resource", ()=>$3d515a0fe8e87c81$export$60e774d0427b56fc);
    $parcel$export(module.exports, "forgeGlobalModuleV2Resource", ()=>$3d515a0fe8e87c81$export$75f594fe5ce76af);
    $parcel$export(module.exports, "getNavigationForgeGlobalPageResources", ()=>$3d515a0fe8e87c81$export$80b2f91dabb3dd65);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV1Resource", ()=>$3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV2Resource", ()=>$3d515a0fe8e87c81$export$d2d6bc2f3bd0f942);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", ()=>$3d515a0fe8e87c81$export$ebf5369e4dcfad00);
    $parcel$export(module.exports, "forgeCustomFieldTypeResource", ()=>$3d515a0fe8e87c81$export$e6be2f0ca0849869);
    var $8O7FC;
    var $4R6GH;
    var $k2DRb;
    var $iVaKa;
    var $5vSAE;
    var $dK8AG;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    var $47m5i;
    var $1yLrr;
    const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
        const isModuleWithAccessNarrowing = [
            (0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
        ].includes(moduleName);
        const projectIdOrKey = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(params);
        if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
            projectIdOrKey: projectIdOrKey
        };
        return null;
    };
    const $3d515a0fe8e87c81$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
            const { match: params } = route;
            const dataClassification = $3d515a0fe8e87c81$export$eb46cc3d7c1a6649(params, moduleName);
            const contextIds = typeof createContextIds === 'function' && createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }) || undefined;
            return (0, (0, parcelRequire("47m5i")).fetchForgeModule)({
                cloudId: cloudId,
                moduleName: moduleName,
                dataClassification: dataClassification,
                shouldReturnANExtensions: shouldReturnANExtensions,
                contextIds: contextIds,
                locale: locale
            });
        };
    const $3d515a0fe8e87c81$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
    const $3d515a0fe8e87c81$export$168ac1f97221e90b = (0, $dIdda.createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$536a08360f048bac = (0, $dIdda.createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE)
                ],
                context: {},
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).adminPageFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$var$forgeAdminModuleResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$536a08360f048bac, $3d515a0fe8e87c81$export$168ac1f97221e90b);
    const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
            $3d515a0fe8e87c81$var$forgeAdminModuleResource
        ];
    const $3d515a0fe8e87c81$export$ad95e2d07d6fa1a = (0, $dIdda.createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$1a17680eb0746291 = (0, $dIdda.createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$1a17680eb0746291, $3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
    const $3d515a0fe8e87c81$export$fa67d109c2a45864 = (0, $dIdda.createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$23c2bb87c561c9db = (0, $dIdda.createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$23c2bb87c561c9db, $3d515a0fe8e87c81$export$fa67d109c2a45864);
    const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, $dIdda.useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
    const $3d515a0fe8e87c81$export$60e774d0427b56fc = (0, $dIdda.createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$75f594fe5ce76af = (0, $dIdda.createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE)
                ],
                context: {},
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$var$forgeGlobalModuleResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$75f594fe5ce76af, $3d515a0fe8e87c81$export$60e774d0427b56fc);
    const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
            $3d515a0fe8e87c81$var$forgeGlobalModuleResource
        ];
    const $3d515a0fe8e87c81$export$b555dc3ff28ae9cc = (0, $dIdda.createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942 = (0, $dIdda.createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942, $3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
    const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, $dIdda.createResource)({
        type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
        getKey: ()=>'extensions',
        getData: (_route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_NAVIGATION)
            }).then((modules)=>modules[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE]) : (0, (0, parcelRequire("iVaKa")).default)(cloudId, [
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)
            ], null, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_NAVIGATION), $3d515a0fe8e87c81$var$createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }), locale).then((modules)=>modules.extensions.jiraCustomFieldType),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
        return filter(modules).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title));
    }
});
parcelRegister("8O7FC", function(module, exports) {
    $parcel$export(module.exports, "alphabeticalSort", ()=>$7c4745a46edf6307$export$89a1f01f2a7cb2a1);
    var $dJl1T;
    const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
        if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
            numeric: true,
            caseFirst: 'upper'
        });
        const typeOfA = a === null ? 'null' : typeof a;
        const typeOfB = b === null ? 'null' : typeof b;
        const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
        return 1;
    };
});
parcelRegister("k2DRb", function(module, exports) {
    $parcel$export(module.exports, "STAGING_ENVIRONMENT", ()=>$e80aa4d4aac5b0dc$export$71acbd662c478c42);
    $parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", ()=>$e80aa4d4aac5b0dc$export$978072fd3fd149);
    $parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", ()=>$e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
    $parcel$export(module.exports, "ISSUE_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
    $parcel$export(module.exports, "ISSUE_GLANCE_MODULE", ()=>$e80aa4d4aac5b0dc$export$259bab989b0129d0);
    $parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", ()=>$e80aa4d4aac5b0dc$export$75f224942f595e13);
    $parcel$export(module.exports, "ISSUE_PANEL_MODULE", ()=>$e80aa4d4aac5b0dc$export$ba0968f9752844);
    $parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", ()=>$e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
    $parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", ()=>$e80aa4d4aac5b0dc$export$9069d4b945c3d532);
    $parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", ()=>$e80aa4d4aac5b0dc$export$811b7f067a43b422);
    $parcel$export(module.exports, "CUSTOM_FIELD_MODULE", ()=>$e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
    $parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", ()=>$e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
    $parcel$export(module.exports, "ADMIN_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
    $parcel$export(module.exports, "PROJECT_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$151b03356f566603);
    $parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
    $parcel$export(module.exports, "GLOBAL_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
    $parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", ()=>$e80aa4d4aac5b0dc$export$353acf28daa75c79);
    $parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", ()=>$e80aa4d4aac5b0dc$export$25627f012b21b0b9);
    $parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", ()=>$e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
    $parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", ()=>$e80aa4d4aac5b0dc$export$a7186e5a73395db4);
    $parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
    $parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$8af4cb794979f60d);
    $parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", ()=>$e80aa4d4aac5b0dc$export$5592ab836d562168);
    $parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", ()=>$e80aa4d4aac5b0dc$export$842eb4236828ac9);
    $parcel$export(module.exports, "SUPPORTED_MODULES", ()=>$e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
    $parcel$export(module.exports, "ENTRY_POINT_EDIT", ()=>$e80aa4d4aac5b0dc$export$2b8aeda236486576);
    $parcel$export(module.exports, "ENTRY_POINT_VIEW", ()=>$e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
    $parcel$export(module.exports, "ENTRY_POINT_CREATE", ()=>$e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
    $parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", ()=>$e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
    $parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", ()=>$e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
    $parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", ()=>$e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", ()=>$e80aa4d4aac5b0dc$export$8e96118a698216cb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", ()=>$e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", ()=>$e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
    $parcel$export(module.exports, "SOURCE_UNKNOWN", ()=>$e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
    $parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", ()=>$e80aa4d4aac5b0dc$export$61d882aa7aba51c);
    $parcel$export(module.exports, "SOURCE_ISSUE_VIEW", ()=>$e80aa4d4aac5b0dc$export$46cb92762d68a048);
    $parcel$export(module.exports, "SOURCE_NAVIGATION", ()=>$e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
    $parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", ()=>$e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
    $parcel$export(module.exports, "SOURCE_ROUTER", ()=>$e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
    $parcel$export(module.exports, "SOURCE_LEGACY", ()=>$e80aa4d4aac5b0dc$export$ac11ee191d09688f);
    $parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", ()=>$e80aa4d4aac5b0dc$export$4346e4e240c84319);
    $parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", ()=>$e80aa4d4aac5b0dc$export$d719bb340dc354e4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", ()=>$e80aa4d4aac5b0dc$export$4b6228758e800433);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", ()=>$e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", ()=>$e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
    $parcel$export(module.exports, "getEmptyExtensionsObject", ()=>$e80aa4d4aac5b0dc$export$218a328f66b86f7d);
    $parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$3193d714ab54ee26);
    $parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$df7774a415710cce);
    $parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$51ab2784839ce348);
    const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
    const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
    const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
    const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
    const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
    const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
    const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
    const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
    const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
    const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
    const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
    const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
    const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
    const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
    const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
    const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
    const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
    const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
    const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
    const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
    const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
    const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
    const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
    const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
    const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
    const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
        $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
        $e80aa4d4aac5b0dc$export$259bab989b0129d0,
        $e80aa4d4aac5b0dc$export$75f224942f595e13,
        $e80aa4d4aac5b0dc$export$ba0968f9752844,
        $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
        $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
        $e80aa4d4aac5b0dc$export$811b7f067a43b422,
        $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
        $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
        $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
        $e80aa4d4aac5b0dc$export$151b03356f566603,
        $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
        $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
        $e80aa4d4aac5b0dc$export$353acf28daa75c79,
        $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
        $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
        $e80aa4d4aac5b0dc$export$5592ab836d562168,
        $e80aa4d4aac5b0dc$export$842eb4236828ac9,
        $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
        $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
        $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
    ];
    const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
    const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
    const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
    const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
    const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
    const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
    const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
    const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
    const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
    const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
    const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
    const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
    const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
    const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
    const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
    const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
    const $e80aa4d4aac5b0dc$export$6d00582aa947900f = 'workflow-list';
    const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
    const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
    const $e80aa4d4aac5b0dc$export$bf75cf7720bd8fde = 'transition-view';
    const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
    const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
    const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
    const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
        jiraIssueAction: [],
        jiraIssueContext: [],
        jiraIssueGlance: [],
        jiraIssuePanel: [],
        jiraIssueActivity: [],
        jiraIssueViewBackgroundScript: [],
        jiraCustomField: [],
        jiraCustomFieldType: [],
        jiraUiModifications: [],
        jiraAdminPage: [],
        jiraGlobalPage: [],
        jiraProjectPage: [],
        jiraProjectSettingsPage: [],
        jiraDashboardBackgroundScript: [],
        jiraDashboardGadget: [],
        jiraServiceManagementQueuePage: [],
        jiraServiceManagementOrganizationPanel: [],
        jiraServiceManagementAssetsImportType: [],
        jiraWorkflowValidator: [],
        jiraWorkflowCondition: [],
        jiraWorkflowPostFunction: []
    };
    const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
        ...$e80aa4d4aac5b0dc$export$a48dade1864725a
    };
    const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
            ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
        });
    const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
    const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
    const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;
});
parcelRegister("iVaKa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b1a9656c7bb4ee4$export$2e2bcd8739ae039);
    var $e4eHl = parcelRequire("e4eHl");
    var $fn8B5 = parcelRequire("fn8B5");
    var $cuHs1 = parcelRequire("cuHs1");
    var $1UikQ = parcelRequire("1UikQ");
    var $4R6GH;
    var $eusud;
    var $bPtOr;
    var $dYScp;
    var $hBuqR;
    var $bOLUk;
    var $k2DRb;
    var $d5W4H;
    var $1MlDe;
    var $lG6pQ;
    var $ioGTN;
    var $dnsCJ;
    var $eIGUr;
    const $1b1a9656c7bb4ee4$var$moduleToVariableKey = (module)=>(0, ($parcel$interopDefault($e4eHl)))(module);
    const $1b1a9656c7bb4ee4$export$3361e9be8093ddcc = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key));
        return (0, ($parcel$interopDefault($1UikQ)))(groupedExtensionsWithMappedKeys, (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
    };
    const $1b1a9656c7bb4ee4$export$44097e02a91cd11a = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($1UikQ)))((0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key)), (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
        const filteredOutDuplicatedExtensions = (0, (0, parcelRequire("1MlDe")).filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
        const allowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        const accessNarrowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
            const allowedExtensionsMap = new Map();
            const accessNarrowedExtensionsMap = new Map();
            module.forEach((moduleItem)=>{
                if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
                else allowedExtensionsMap.set(moduleItem.id, moduleItem);
            });
            allowedExtensions[key] = [
                ...allowedExtensionsMap.values()
            ];
            accessNarrowedExtensions[key] = [
                ...accessNarrowedExtensionsMap.values()
            ];
        });
        return {
            extensions: allowedExtensions,
            accessNarrowedExtensions: accessNarrowedExtensions
        };
    };
    const $1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES = [
        (0, (0, parcelRequire("bPtOr")).FAILED_TO_FETCH),
        (0, (0, parcelRequire("bPtOr")).AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)
    ];
    const $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source, locale)=>{
        if (modules.length === 0) throw new Error('No modules to fetch provided');
        const dataClassificationTags = await (0, (0, parcelRequire("lG6pQ")).getDataClassification)(dataClassification, source);
        const includeConfig = extras?.include || {};
        const query = (0, (0, parcelRequire("eIGUr")).buildForgeQuery)(includeConfig);
        const variables = {
            contextIds: contextIds || [
                `ari:cloud:jira::site/${cloudId}`
            ],
            extensionsFilter: [
                {
                    type: 'EXTENSION_TYPE',
                    value: modules
                }
            ],
            dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`),
            locale: (0, (0, parcelRequire("4R6GH")).fg)('forge-ui-i18n-locale-enabled') ? locale : undefined
        };
        const { data: data, errors: errors, extensions: extensions } = await (0, (0, parcelRequire("dYScp")).measureExecutionTimeMetrics)(()=>(0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: variables
                }),
                method: 'POST'
            }));
        const traceId = (0, (0, parcelRequire("dnsCJ")).getTraceIdFromExtensions)({
            extensions: extensions
        });
        if (errors) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
        if (!data) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)('No data returned', traceId, errors);
        if (data.extensionContexts.length < 1) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)('No extensionContext returned', traceId, errors);
        return {
            data: data,
            traceId: traceId
        };
    };
    var $1b1a9656c7bb4ee4$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, (0, parcelRequire("k2DRb")).SOURCE_UNKNOWN), contextIds, locale)=>{
        try {
            if (!(0, (0, parcelRequire("d5W4H")).canFetchForgeModules)()) return {
                extensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)()
            };
            const { data: data, traceId: traceId } = await $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source, locale);
            if (Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE)) (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFinishedEvent)(source, {
                traceId: traceId
            });
            return $1b1a9656c7bb4ee4$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
        } catch (error) {
            const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            const traceId = (0, (0, parcelRequire("dnsCJ")).getTraceIdFromError)(error);
            (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error,
                traceId: traceId
            });
            if ($1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
                extensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)()
            };
            throw error;
        }
    };
});
parcelRegister("bPtOr", function(module, exports) {
    $parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", ()=>$e4bddb38a31390d9$export$23de3198bfe70090);
    $parcel$export(module.exports, "FAILED_TO_FETCH", ()=>$e4bddb38a31390d9$export$f52aa41ccd776f01);
    $parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", ()=>$e4bddb38a31390d9$export$31d2ab0be67934f0);
    $parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", ()=>$e4bddb38a31390d9$export$89a175d4190df42e);
    $parcel$export(module.exports, "userConsentErrorRegex", ()=>$e4bddb38a31390d9$export$dddade71b333c01d);
    $parcel$export(module.exports, "getErrorType", ()=>$e4bddb38a31390d9$export$e19f9f08a6d79fd2);
    var $fZneA;
    var $bCf8q;
    const $e4bddb38a31390d9$var$commonErrors = {
        MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
        OPERATION_ABORTED: 'The operation was aborted. ',
        CANCELLED: 'cancelled',
        UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
        NETWORK_CONNECTION_LOST: 'The network connection was lost.',
        TIMEOUT: 'The request timed out.',
        AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
        GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
        GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
    };
    const $e4bddb38a31390d9$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
    const $e4bddb38a31390d9$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
    const $e4bddb38a31390d9$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
    const $e4bddb38a31390d9$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
    const $e4bddb38a31390d9$export$89a175d4190df42e = 'Invoke value functions failed:';
    const $e4bddb38a31390d9$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
    const $e4bddb38a31390d9$export$8a5d666d6e5b82fc = (error)=>{
        if ((0, (0, parcelRequire("bCf8q")).isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
        const KNOWN_NETWORK_ERRORS = [
            'Failed to fetch dynamically imported module',
            'error loading dynamically imported module',
            'Importing a module script failed'
        ];
        const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>message.includes(networkErrorMessage));
        return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
    };
    const $e4bddb38a31390d9$export$e19f9f08a6d79fd2 = (_error)=>{
        if (_error == null) return 'NULL_OR_UNDEFINED';
        const error = _error;
        const message = String(error instanceof Error ? error.message : error).trim();
        const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
        if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
        const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
        if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
        const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
        const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
        if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
        const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
        if (serverErrorRegex.test(message)) {
            const match = message.match(serverErrorRegex);
            const statusCode = match ? match[1] : 'NO_STATUS_CODE';
            return `ERROR_SERVER_RESPONSE_${statusCode}`;
        }
        const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
        if (aggGiraServerErrorRegex.test(message)) {
            const match = message.match(aggGiraServerErrorRegex);
            const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
            return `AGG_GIRA_ERROR_${statusCode}`;
        }
        const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
        const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
        if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $e4bddb38a31390d9$export$23de3198bfe70090;
        if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
        const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
        if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
        if ($e4bddb38a31390d9$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
        const appValueFunction = new RegExp("The app's value function failed", 'i');
        const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
        const invokeValueFunctionFailed = new RegExp($e4bddb38a31390d9$export$89a175d4190df42e, 'i');
        const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977);
        const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2);
        if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
        const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
        if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
        const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
        if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
        if ($e4bddb38a31390d9$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
        if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
        if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
        if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
        const entry = Object.entries($e4bddb38a31390d9$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
        if (entry) return entry[0];
        if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return $e4bddb38a31390d9$export$f52aa41ccd776f01;
        return 'OTHER';
    };
});
parcelRegister("dYScp", function(module, exports) {
    $parcel$export(module.exports, "measureExecutionTimeMetrics", ()=>$d79aabebae5ffeb3$export$a859f6866f4653e0);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $hBuqR;
    var $8kVg1;
    const $d79aabebae5ffeb3$export$a859f6866f4653e0 = async (action)=>{
        const concurrentId = (0, ($parcel$interopDefault($7Jxgt)))();
        const shouldSendTimeMetric = Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE);
        if ((0, (0, parcelRequire("4R6GH")).fg)('ditto-fcf_forge_fetch_time_metric_fix')) try {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).cancel();
            throw error;
        }
        else try {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).cancel();
            throw error;
        }
    };
});
parcelRegister("hBuqR", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME_GASV3", ()=>$bbc089ab376d4a7b$export$f892f621fb508154);
    $parcel$export(module.exports, "MODULE_TYPE_TRIGGER", ()=>$bbc089ab376d4a7b$export$ed63b053e04e26df);
    $parcel$export(module.exports, "MODULE_TYPE_EXTENSION", ()=>$bbc089ab376d4a7b$export$725bacc669333eef);
    $parcel$export(module.exports, "FORGE_SAMPLING_RATE", ()=>$bbc089ab376d4a7b$export$d920cee73ec094d0);
    $parcel$export(module.exports, "PERFORMANCE_KEYS", ()=>$bbc089ab376d4a7b$export$f048d91ccaf92408);
    $parcel$export(module.exports, "UI_ACTIONS", ()=>$bbc089ab376d4a7b$export$2b7367f125154866);
    $parcel$export(module.exports, "OPERATIONAL_ACTIONS", ()=>$bbc089ab376d4a7b$export$42bcca5cae2ce90b);
    $parcel$export(module.exports, "TRACK_ACTIONS", ()=>$bbc089ab376d4a7b$export$2af0438304d7c4b2);
    const $bbc089ab376d4a7b$export$f892f621fb508154 = 'jiraForgeUi';
    const $bbc089ab376d4a7b$export$273f5980517336e2 = 'jiraforgeui';
    const $bbc089ab376d4a7b$export$ed63b053e04e26df = 'trigger';
    const $bbc089ab376d4a7b$export$725bacc669333eef = 'extension';
    const $bbc089ab376d4a7b$export$d920cee73ec094d0 = 10;
    const $bbc089ab376d4a7b$export$f048d91ccaf92408 = {
        FORGE_MODULES: {
            FETCH_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.fetch-time`,
            LOAD_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.load-time`
        },
        REAL_TIME_ISSUE_EVENTS: {
            INVOKE_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.real-time-issue-events.invoke-time`
        },
        MARKS: {
            TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
            TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
        }
    };
    const $bbc089ab376d4a7b$export$2b7367f125154866 = {
        CLICKED: 'clicked',
        SELECTED: 'selected',
        CANCELED: 'canceled',
        ACTION_CLICKED: 'action clicked',
        COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
        REMOVE_CLICKED: 'remove clicked'
    };
    const $bbc089ab376d4a7b$export$42bcca5cae2ce90b = {
        FAILED: 'failed',
        INITIALIZED: 'initialized',
        EDIT_FAILED: 'edit failed',
        ACTION_FAILED: 'action failed',
        SAVE_FAILED: 'save failed',
        REMOVE_FAILED: 'remove failed',
        UPDATE_FAILED: 'update failed'
    };
    const $bbc089ab376d4a7b$export$2af0438304d7c4b2 = {
        EDITED: 'edited',
        SAVED: 'saved',
        REMOVED: 'removed',
        ACTION_SUCCEED: 'action succeed',
        UPDATE_SUCCEED: 'update succeed'
    };
});
parcelRegister("8kVg1", function(module, exports) {
    $parcel$export(module.exports, "forgeModulesFetchTime", ()=>$f1fed22795d0c676$export$cd129f3639657eae);
    $parcel$export(module.exports, "forgeModulesConcurrentFetchTime", ()=>$f1fed22795d0c676$export$c3d8833fbea3e976);
    $parcel$export(module.exports, "forgeModulesConcurrentLoadTime", ()=>$f1fed22795d0c676$export$292f3b557281044f);
    $parcel$export(module.exports, "realTimeIssueEventInvokeTime", ()=>$f1fed22795d0c676$export$89ace7e2bb7d7685);
    $parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", ()=>$f1fed22795d0c676$export$94f65f3b2556df23);
    $parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", ()=>$f1fed22795d0c676$export$116d5e25caf0018d);
    $parcel$export(module.exports, "customFieldPageSegmentLoadMetric", ()=>$f1fed22795d0c676$export$3bd38623c2543fc0);
    $parcel$export(module.exports, "customFieldInteractionMetric", ()=>$f1fed22795d0c676$export$a318f99472db73c8);
    var $dGrdR;
    var $6RCeq;
    var $atdLB;
    var $duUGa;
    var $hBuqR;
    const $f1fed22795d0c676$export$cd129f3639657eae = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $f1fed22795d0c676$export$c3d8833fbea3e976 = (0, (0, parcelRequire("dGrdR")).metrics).concurrent.custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $f1fed22795d0c676$export$292f3b557281044f = (0, (0, parcelRequire("dGrdR")).metrics).concurrent.custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
    });
    const $f1fed22795d0c676$export$89ace7e2bb7d7685 = new (0, (0, parcelRequire("duUGa")).UFOExperience)((0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    });
    async function $f1fed22795d0c676$export$94f65f3b2556df23(startMark, endMark, fn) {
        if (false || (0, (0, parcelRequire("6RCeq")).default).getEntriesByName(startMark).length > 0 || (0, (0, parcelRequire("6RCeq")).default).getEntriesByName(endMark).length > 0) return fn();
        (0, (0, parcelRequire("6RCeq")).default).mark(startMark);
        const result = await fn();
        (0, (0, parcelRequire("6RCeq")).default).mark(endMark);
        return result;
    }
    const $f1fed22795d0c676$export$116d5e25caf0018d = (metric, additionalTimings)=>{
        additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
                ...(0, (0, parcelRequire("6RCeq")).default).getEntriesByName(startMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: cleanStart,
                        cleanEnd: undefined
                    })),
                ...(0, (0, parcelRequire("6RCeq")).default).getEntriesByName(endMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: undefined,
                        cleanEnd: cleanEnd
                    }))
            ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
            metric.mark(name, startTime);
            if (cleanStart || cleanEnd) (0, (0, parcelRequire("6RCeq")).default).clearMarks(name);
        });
    };
    const $f1fed22795d0c676$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings,
                {
                    key: 'tti',
                    startMark: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.TTI_START,
                    endMark: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.TTI_END
                }
            ]
        });
    const $f1fed22795d0c676$export$a318f99472db73c8 = (additionalTimings = [])=>(0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings
            ]
        });
});
parcelRegister("bOLUk", function(module, exports) {
    $parcel$export(module.exports, "fireInitializationFetchFinishedEvent", ()=>$2f4555f4bd0f0eef$export$132ca822850e455f);
    $parcel$export(module.exports, "fireInitializationFetchFailedEvent", ()=>$2f4555f4bd0f0eef$export$b5ca88b1053f1ad0);
    $parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", ()=>$2f4555f4bd0f0eef$export$e914f7df1e4ad79b);
    $parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", ()=>$2f4555f4bd0f0eef$export$b274c658390b491b);
    var $4R6GH;
    var $6yg2S;
    var $8uOa6;
    const $2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS = {
        STARTED: 'started',
        FINISHED: 'finished',
        FAILED: 'failed'
    };
    const $2f4555f4bd0f0eef$export$917d0643b0111a02 = (0, (0, parcelRequire("6yg2S")).toEventId)('issueViewInitialization');
    const $2f4555f4bd0f0eef$export$43e875fd63e64525 = (0, (0, parcelRequire("6yg2S")).toEventId)('fetchModulesInitialization');
    const $2f4555f4bd0f0eef$export$132ca822850e455f = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$e914f7df1e4ad79b = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$b274c658390b491b = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
});
parcelRegister("6yg2S", function(module, exports) {
    $parcel$export(module.exports, "toEventId", ()=>$cb46d7d052e3d68d$export$75e84ef5a3771f9a);
    const $cb46d7d052e3d68d$export$75e84ef5a3771f9a = (value)=>value;
});
parcelRegister("8uOa6", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalEvent", ()=>$73635d33815c9f98$export$a1fb57756f0de62b);
    $parcel$export(module.exports, "fireUiEvent", ()=>$73635d33815c9f98$export$bed7f228c94e5f2a);
    $parcel$export(module.exports, "fireTrackEvent", ()=>$73635d33815c9f98$export$574d2f19a52d67ca);
    $parcel$export(module.exports, "fireInitializationEvent", ()=>$73635d33815c9f98$export$390a62413962e4f0);
    var $fjcgS;
    var $hBuqR;
    var $6MtPV;
    var $7yD9b;
    var $eGXs2;
    const $73635d33815c9f98$var$createAnalyticsProps = ({ id: id, source: source = 'unknownSource', action: action, attributes: attributes })=>({
            actionSubject: `${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${id}`,
            attributes: (0, (0, parcelRequire("6MtPV")).createAttributes)(attributes),
            source: source,
            action: action
        });
    const $73635d33815c9f98$var$getAnalyticsClient = async ()=>(await (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)()).getInstance();
    const $73635d33815c9f98$var$sendOperationalEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendOperationalEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$var$sendUiEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendUIEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$var$sendTrackEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendTrackEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendOperationalEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendUiEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendTrackEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
            $73635d33815c9f98$export$a1fb57756f0de62b(action, {
                id: id,
                attributes: attributes,
                source: source
            }),
            attributes?.error && (0, (0, parcelRequire("7yD9b")).logError)((0, (0, parcelRequire("7yD9b")).ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, (0, parcelRequire("eGXs2")).isSynthetic)().toString()}, id=${id}, source=${(0, (0, parcelRequire("6MtPV")).parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
        ]);
});
parcelRegister("6MtPV", function(module, exports) {
    $parcel$export(module.exports, "parseSource", ()=>$31dca5b0e1651a2f$export$e98201ef9a88ba70);
    $parcel$export(module.exports, "createAttributes", ()=>$31dca5b0e1651a2f$export$c7c9603a6b1fd815);
    var $84Tib = parcelRequire("84Tib");
    var $9uiWt;
    var $bPtOr;
    var $eGXs2;
    const $31dca5b0e1651a2f$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
    const $31dca5b0e1651a2f$export$78c6267359db7e73 = (error)=>({
            ...error,
            stack: error.stack,
            message: error?.message
        });
    const $31dca5b0e1651a2f$export$c7c9603a6b1fd815 = (rawAttributes)=>{
        const attributes = {
            isSynthetic: (0, (0, parcelRequire("eGXs2")).isSynthetic)(),
            isOverridingFragments: (0, (0, parcelRequire("9uiWt")).isOverridingFragments)(),
            isSSR: false
        };
        if (rawAttributes) {
            const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
            if (source) attributes.source = $31dca5b0e1651a2f$export$e98201ef9a88ba70(source);
            if (error) {
                attributes.error = $31dca5b0e1651a2f$export$78c6267359db7e73(error);
                attributes.errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            }
            if ((0, ($parcel$interopDefault($84Tib)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
        }
        return {
            ...rawAttributes,
            ...attributes
        };
    };
});
parcelRegister("9uiWt", function(module, exports) {
    $parcel$export(module.exports, "isOverridingFragments", ()=>$c677f4c9cc5e982f$export$1d1321d2b374d697);
    const $c677f4c9cc5e982f$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
});
parcelRegister("eGXs2", function(module, exports) {
    $parcel$export(module.exports, "isSynthetic", ()=>$58ae13ec31f88266$export$947749d756ccb0a);
    var $4R6GH;
    var $j8DrX;
    const $58ae13ec31f88266$export$947749d756ccb0a = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("4R6GH")).fg)('forge_ui_synthetic_check');
});
parcelRegister("7yD9b", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_UTIL", ()=>$187fc325525eefe3$export$d1e4f308040bb0d5);
    $parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", ()=>$187fc325525eefe3$export$36f315a5c6daf40b);
    $parcel$export(module.exports, "logError", ()=>$187fc325525eefe3$export$58da9968c3170cb1);
    var $dJl1T;
    var $hBuqR;
    const $187fc325525eefe3$export$e31edcd35abe3bb1 = 'environment-mapping';
    const $187fc325525eefe3$export$d1e4f308040bb0d5 = 'analytics';
    const $187fc325525eefe3$export$36f315a5c6daf40b = 'custom-field-object-type';
    const $187fc325525eefe3$export$6ee8198f29fffdb4 = {
        [$187fc325525eefe3$export$d1e4f308040bb0d5]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.utils.analytics`,
        [$187fc325525eefe3$export$e31edcd35abe3bb1]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
        [$187fc325525eefe3$export$36f315a5c6daf40b]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
    };
    const $187fc325525eefe3$export$58da9968c3170cb1 = (key, message, event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($187fc325525eefe3$export$6ee8198f29fffdb4[key], message, event);
    };
});
parcelRegister("d5W4H", function(module, exports) {
    $parcel$export(module.exports, "canFetchForgeModules", ()=>$f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08);
    var $4Pf62;
    const $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08 = ()=>{
        const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (String(cloudId) === 'bob') return false;
        return !isAnonymous;
    };
});
parcelRegister("1MlDe", function(module, exports) {
    $parcel$export(module.exports, "filterOutDuplicatedExtensions", ()=>$11a6461020d3329a$export$e0393e97f15a28a5);
    var $lbWm4 = parcelRequire("lbWm4");
    var $k2DRb;
    const $11a6461020d3329a$export$e0393e97f15a28a5 = (modules)=>{
        const filteredModules = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        (0, ($parcel$interopDefault($lbWm4)))(modules, (module, propName)=>{
            const moduleExtensions = new Map();
            (0, ($parcel$interopDefault($lbWm4)))(module, (moduleItem)=>{
                const moduleExtension = moduleExtensions.get(moduleItem.id);
                const appVersion = moduleItem?.appVersion || '0.0.0';
                const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
                if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
            });
            filteredModules[propName] = [
                ...moduleExtensions.values()
            ];
        });
        return filteredModules;
    };
});
parcelRegister("lG6pQ", function(module, exports) {
    $parcel$export(module.exports, "getDataClassification", ()=>$013c8a0b6d7ef450$export$1635afa94064952c);
    var $eusud;
    var $bPtOr;
    var $bOLUk;
    var $dqtU7;
    var $6P5IG;
    const $013c8a0b6d7ef450$var$handleError = (err, source)=>{
        const errorMessage = err instanceof Error ? err.message : String(err);
        const error = Error(`Data classification request failed: ${errorMessage}`);
        const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
        if (errorType === (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)) throw error;
        (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        return [];
    };
    async function $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).get(`${(0, (0, parcelRequire("6P5IG")).issueKeyPrefix)}-${props.issueKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, (0, parcelRequire("6P5IG")).TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
                (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).set(`${(0, (0, parcelRequire("6P5IG")).issueKeyPrefix)}-${props.issueKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $013c8a0b6d7ef450$var$handleError(err, source);
        }
    }
    async function $013c8a0b6d7ef450$var$getDataClassificationProject(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).get(`${(0, (0, parcelRequire("6P5IG")).projectKeyPrefix)}-${props.projectIdOrKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, (0, parcelRequire("6P5IG")).TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
                (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).set(`${(0, (0, parcelRequire("6P5IG")).projectKeyPrefix)}-${props.projectIdOrKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $013c8a0b6d7ef450$var$handleError(err, source);
        }
    }
    const $013c8a0b6d7ef450$export$1635afa94064952c = async (props, source)=>{
        if (props !== null) {
            if ((0, (0, parcelRequire("dqtU7")).hasPrefetchedData)(props)) return props.tags;
            if ((0, (0, parcelRequire("dqtU7")).hasProjectIdOrKey)(props)) {
                const tags = await $013c8a0b6d7ef450$var$getDataClassificationProject(props, source);
                return tags;
            }
            if ((0, (0, parcelRequire("dqtU7")).hasIssueKey)(props)) {
                const tags = await $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source);
                return tags;
            }
        }
        return [];
    };
});
parcelRegister("dqtU7", function(module, exports) {
    $parcel$export(module.exports, "hasPrefetchedData", ()=>$3920146879a40338$export$c19d255b92c7c2da);
    $parcel$export(module.exports, "hasProjectIdOrKey", ()=>$3920146879a40338$export$494434246e5dea0d);
    $parcel$export(module.exports, "hasIssueKey", ()=>$3920146879a40338$export$b1490cfc7a90c75b);
    var $8LQ84 = parcelRequire("8LQ84");
    const $3920146879a40338$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, ($parcel$interopDefault($8LQ84)))(props.tags);
    const $3920146879a40338$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
    const $3920146879a40338$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;
});
parcelRegister("6P5IG", function(module, exports) {
    $parcel$export(module.exports, "TTL", ()=>$ca591e08be1a6f54$export$6ebb1381174e92a7);
    $parcel$export(module.exports, "issueKeyPrefix", ()=>$ca591e08be1a6f54$export$a040db2850f159b0);
    $parcel$export(module.exports, "projectKeyPrefix", ()=>$ca591e08be1a6f54$export$df256a06d24ff906);
    $parcel$export(module.exports, "DataClassificationTagsCache", ()=>$ca591e08be1a6f54$export$b7adc37405b5ff0d);
    const $ca591e08be1a6f54$export$6ebb1381174e92a7 = 60000;
    const $ca591e08be1a6f54$export$a040db2850f159b0 = 'issue';
    const $ca591e08be1a6f54$export$df256a06d24ff906 = 'project';
    const $ca591e08be1a6f54$export$b7adc37405b5ff0d = new Map();
});
parcelRegister("ioGTN", function(module, exports) {
    $parcel$export(module.exports, "ForgeFetchError", ()=>$03e8a2344fd340fa$export$2e3b53e53bafa);
    class $03e8a2344fd340fa$export$2e3b53e53bafa extends Error {
        constructor(message, traceId, errors){
            super(message);
            this.name = $03e8a2344fd340fa$export$2e3b53e53bafa.name;
            this.traceId = traceId;
            this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, $03e8a2344fd340fa$export$2e3b53e53bafa);
        }
    }
});
parcelRegister("dnsCJ", function(module, exports) {
    $parcel$export(module.exports, "getTraceIdFromExtensions", ()=>$06cecb1cf20a09b8$export$eefb7f54c3b07211);
    $parcel$export(module.exports, "getTraceIdFromError", ()=>$06cecb1cf20a09b8$export$9955d05ba83067ba);
    var $jJZqs;
    var $ioGTN;
    const $06cecb1cf20a09b8$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
        const traceId = extensions?.gateway?.request_id;
        if (traceId && typeof traceId === 'string') return traceId;
        return undefined;
    };
    const $06cecb1cf20a09b8$export$9955d05ba83067ba = (error)=>{
        if (error instanceof (0, (0, parcelRequire("ioGTN")).ForgeFetchError) || error instanceof (0, (0, parcelRequire("jJZqs")).default)) return error.traceId;
        return undefined;
    };
});
parcelRegister("eIGUr", function(module, exports) {
    $parcel$export(module.exports, "buildForgeQuery", ()=>$5112ddb3344b355d$export$497b2dc04db7bd76);
    var $co1wz;
    const $5112ddb3344b355d$export$497b2dc04db7bd76 = (include)=>{
        const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
        const scopesField = include.scopes === true ? 'scopes' : '';
        const capabilitySetField = (0, (0, parcelRequire("co1wz")).ff)('platform.forge-ui.license-capability-set') ? 'capabilitySet' : '';
        const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
		    ${capabilitySetField}
    }`;
        return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!, $locale: String) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter, locale: $locale) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }
            }
        }
    }`;
    };
});
parcelRegister("5vSAE", function(module, exports) {
    $parcel$export(module.exports, "fetchModules", ()=>$f16089506a319d17$export$24d8e11b15325c53);
    var $gPjkL;
    var $8Uumt = parcelRequire("8Uumt");
    var $bPtOr;
    var $dYScp;
    var $hBuqR;
    var $bOLUk;
    var $k2DRb;
    var $5yJb9;
    var $d5W4H;
    var $dyPNS;
    const $f16089506a319d17$export$24d8e11b15325c53 = async (params)=>{
        const { types: types, source: source = (0, (0, parcelRequire("k2DRb")).SOURCE_UNKNOWN) } = params;
        if (!(0, (0, parcelRequire("d5W4H")).canFetchForgeModules)()) return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, []);
        try {
            const extensions = await (0, (0, parcelRequire("dYScp")).measureExecutionTimeMetrics)(()=>$f16089506a319d17$export$8ff66c70be1c563a(params));
            if (Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE)) (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFinishedEvent)(source);
            return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, extensions);
        } catch (error) {
            const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error
            });
            if ($f16089506a319d17$export$458cbcb6374269d2.includes(errorType)) return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, []);
            throw error;
        }
    };
    function $f16089506a319d17$export$8ff66c70be1c563a(props) {
        const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
        if (types.length === 0) throw new Error('No modules to fetch provided');
        return (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("gPjkL")).default), {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes
        }).toPromise().then((response)=>{
            return response.jira.forge.extensions.concat();
        });
    }
    const $f16089506a319d17$export$458cbcb6374269d2 = [
        (0, (0, parcelRequire("bPtOr")).FAILED_TO_FETCH),
        (0, (0, parcelRequire("bPtOr")).AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)
    ];
});
parcelRegister("gPjkL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13cd104237d48c31$export$2e2bcd8739ae039);
    const $13cd104237d48c31$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeScopes"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }, v5 = {
            "kind": "ScalarField",
            "name": "type"
        }, v6 = {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "condition": "includeHidden",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hiddenBy"
                        }
                    ]
                },
                {
                    "condition": "includeScopes",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "scopes"
                        }
                    ]
                },
                v5,
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "properties"
                },
                {
                    "concreteType": "JiraForgeAppEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        v5
                    ]
                },
                {
                    "concreteType": "JiraForgeExtensionLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        v5,
                        {
                            "kind": "ScalarField",
                            "name": "supportEntitlementNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        }
                    ]
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "fetchModulesV2Query",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraForgeQuery",
                                        "kind": "LinkedField",
                                        "name": "forge",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v6,
                                                "action": "THROW",
                                                "path": "jira.forge.extensions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.forge"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v4,
                    v2,
                    v3
                ],
                "kind": "Operation",
                "name": "fetchModulesV2Query",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraForgeQuery",
                                "kind": "LinkedField",
                                "name": "forge",
                                "plural": false,
                                "selections": [
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "7ec904788346b73ef73ba8d21a8d7a83b02cd5e8d03190f3c9f31995997aab05",
                "metadata": {},
                "name": "fetchModulesV2Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $13cd104237d48c31$var$node.hash = "7d0cf33c9221c468dec00db8d99ae484";
    var $13cd104237d48c31$export$2e2bcd8739ae039 = $13cd104237d48c31$var$node;
});
parcelRegister("5yJb9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    var $aWXMn;
    let $0dfb67cb8d2ba29a$var$relayEnvironment;
    function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
        if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
            const environmentConfig = (0, (0, parcelRequire("aWXMn")).getRelayEnvironmentConfig)();
            $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
        }
        return $0dfb67cb8d2ba29a$var$relayEnvironment;
    }
});
parcelRegister("aWXMn", function(module, exports) {
    $parcel$export(module.exports, "getRelayEnvironmentConfig", ()=>$eb7981c11bea2531$export$a451c85db2d1cda3);
    var $4XQuR;
    var $d89yU;
    var $6LmWt;
    const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, (0, parcelRequire("6LmWt")).getDefaultRelayEnvironmentConfig)({
            network: (0, (0, parcelRequire("d89yU")).getNetwork)(),
            log: (0, (0, parcelRequire("4XQuR")).default),
            requiredFieldLogger: (0, parcelRequire("4XQuR")).requiredFieldLogger
        });
});
parcelRegister("4XQuR", function(module, exports) {
    $parcel$export(module.exports, "requiredFieldLogger", ()=>$50b0aa0805b37d6d$export$1ab8b98d209afe85);
    $parcel$export(module.exports, "default", ()=>$50b0aa0805b37d6d$export$2e2bcd8739ae039);
    var $bFU4G;
    var $dJl1T;
    var $jQsty;
    const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
    const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
    const $50b0aa0805b37d6d$var$requests = {};
    const $50b0aa0805b37d6d$var$queries = {};
    const $50b0aa0805b37d6d$var$resources = {};
    const $50b0aa0805b37d6d$var$executes = {};
    const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000;
    const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
            kind: event.kind,
            owner: event.owner,
            fieldPath: event.fieldPath,
            message: event.kind === 'relay_resolver.error' ? event.error?.message : null
        });
    };
    const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
        if (resp.data === undefined) return 0;
        try {
            return JSON.stringify(resp.data).length;
        } catch (e) {
            return 0;
        }
    };
    function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
        if ((0, (0, parcelRequire("jQsty")).default)('relay_log')) return;
        switch(event.name){
            case 'network.start':
                {
                    const networkStart = performance.now();
                    const { networkRequestId: networkRequestId } = event;
                    const { name: name } = event.params;
                    const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                    if (requestInfo == null) {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: networkStart,
                            networkStart: networkStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                        setTimeout(()=>{
                            delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                            delete $50b0aa0805b37d6d$var$queries[name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    } else requestInfo.networkStart = networkStart;
                    break;
                }
            case 'network.next':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    if (requestInfo != null) {
                        const { response: response } = event;
                        const addFlush = (resp)=>{
                            if (resp.data !== null) {
                                const res = resp;
                                const flush = {
                                    label: res.label != null ? res.label : 'root',
                                    time: performance.now(),
                                    size: $50b0aa0805b37d6d$var$getResponseSize(res)
                                };
                                requestInfo.flushes?.push(flush);
                            }
                        };
                        Array.isArray(response) ? response.forEach(addFlush) : addFlush(response);
                    }
                    break;
                }
            case 'network.error':
                {
                    const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    if (info != null) info.error = event.error;
                    break;
                }
            case 'network.info':
                break;
            case 'network.complete':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    const networkComplete = performance.now();
                    if (requestInfo != null) {
                        const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                        requestInfo.size = size;
                        requestInfo.networkComplete = networkComplete;
                        requestInfo.flushes = [];
                        (0, (0, parcelRequire("bFU4G")).addSpanToAll)('relay', requestInfo.name, [
                            {
                                name: 'network'
                            }
                        ], requestInfo.start, requestInfo.networkComplete, size);
                    }
                    break;
                }
            case 'network.unsubscribe':
                break;
            case 'suspense.fragment':
                break;
            case 'suspense.query':
                break;
            case 'queryresource.fetch':
                {
                    const { node: node } = event.operation.root;
                    const fetchStart = performance.now();
                    if (node.name != null) {
                        const { name: name } = node;
                        const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                        if (requestInfo != null) {
                            requestInfo.fetchStart = fetchStart;
                            $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                        } else {
                            const newRequestInfo = {
                                name: name,
                                flushes: [],
                                start: fetchStart,
                                fetchStart: fetchStart
                            };
                            $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                            $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                            setTimeout(()=>{
                                delete $50b0aa0805b37d6d$var$queries[node.name];
                            }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                        }
                        setTimeout(()=>{
                            delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    break;
                }
            case 'queryresource.retain':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                    if (requestInfo != null && event.profilerContext != null) {
                        requestInfo.end = performance.now();
                        const context = event.profilerContext;
                        context?.retainQuery?.(requestInfo);
                    }
                    break;
                }
            case 'execute.start':
                $50b0aa0805b37d6d$var$executes[event.executeId] = {
                    name: event.params.name,
                    kind: event.params.operationKind,
                    start: performance.now(),
                    duration: 0
                };
                break;
            case 'execute.next':
                $50b0aa0805b37d6d$var$executes[event.executeId].duration += event.duration;
                break;
            case 'execute.async.module':
                break;
            case 'execute.flight.payload_deserialize':
                break;
            case 'execute.error':
                delete $50b0aa0805b37d6d$var$executes[event.executeId];
                break;
            case 'execute.complete':
                {
                    const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                    if (op != null) {
                        op.end = performance.now();
                        delete $50b0aa0805b37d6d$var$executes[event.executeId];
                    }
                    break;
                }
            case 'store.publish':
                break;
            case 'store.snapshot':
                break;
            case 'store.restore':
                break;
            case 'store.gc':
                break;
            case 'store.notify.start':
                break;
            case 'store.notify.complete':
                break;
            case 'store.notify.subscription':
                break;
            case 'entrypoint.root.consume':
                break;
            default:
                break;
        }
    }
});
parcelRegister("d89yU", function(module, exports) {
    $parcel$export(module.exports, "getNetwork", ()=>$7997274d03790a98$export$7de4970ebfd8206d);
    var $eiowN = parcelRequire("eiowN");
    var $gIJXH;
    var $k1TrK;
    var $fwvto;
    const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
        if ((0, (0, parcelRequire("fwvto")).isSSR)()) (0, $eiowN.Network).create((0, (0, parcelRequire("gIJXH")).fetch));
        return (0, $eiowN.Network).create((0, (0, parcelRequire("gIJXH")).fetch), (0, (0, parcelRequire("k1TrK")).subscribe));
    };
});
parcelRegister("gIJXH", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);
    var $hGgHi = parcelRequire("hGgHi");
    var $1UikQ = parcelRequire("1UikQ");
    var $eiowN = parcelRequire("eiowN");
    var $kTK0a;
    var $2I8bw;
    var $aDvGo;
    var $jJZqs;
    var $eusud;
    var $6b2ko;
    var $4tcSU;
    var $5a0Nh;
    var $gwtGO;
    var $kipqU;
    var $7pVV3;
    var $ajjqZ;
    var $4pgHP;
    var $eCZ6m;
    var $5Wobd;
    var $lKFKm;
    var $7isEg;
    let $2963ed038d5e3581$var$redirecting = false;
    const $2963ed038d5e3581$var$redirect = ()=>{
        const identity = (0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id');
        const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
        window.location.href = redirectUrl;
    };
    const $2963ed038d5e3581$var$blocklist = [
        'issueAggQuery'
    ];
    const $2963ed038d5e3581$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
        if (operationKind === 'query') return 0, (0, parcelRequire("6b2ko")).RETRY_ATTEMPTS_LIMIT;
        return 0;
    };
    const $2963ed038d5e3581$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
        if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') return extensions.gateway.request_id;
        return undefined;
    };
    const $2963ed038d5e3581$var$generateOptions = (options = {})=>{
        const csrfToken = !false ? (0, (0, parcelRequire("4tcSU")).default)() : undefined;
        const csrfTokenHeader = (0, ($parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
            'atl-xsrf-token': csrfToken
        };
        return (0, ($parcel$interopDefault($1UikQ)))({}, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        }, {
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, (0, parcelRequire("gwtGO")).default).join(','),
                ...csrfTokenHeader
            }
        });
    };
    const $2963ed038d5e3581$var$checkAuthentication = ()=>{
        if (!false && !$2963ed038d5e3581$var$redirecting) {
            const heartbeatService = (0, (0, parcelRequire("2I8bw")).getInstance)();
            if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
                $2963ed038d5e3581$var$redirect();
                $2963ed038d5e3581$var$redirecting = true;
            }
        }
    };
    const $2963ed038d5e3581$export$7bfea3c3d460ecd8 = (error)=>{
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) return [
            502,
            503,
            504
        ].includes(error.statusCode);
        return false;
    };
    const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
        $2963ed038d5e3581$var$checkAuthentication();
        if ($2963ed038d5e3581$var$redirecting) return (0, $eiowN.Observable).from(new Promise(()=>{}));
        const { name: queryName, operationKind: operationKind } = request;
        const earlyScriptPromise = !false && (0, (0, parcelRequire("ajjqZ")).claimEarlyScriptPromise)((0, (0, parcelRequire("ajjqZ")).getEarlyScriptPromiseKey)(request, variables)) || undefined;
        const loggingMetadata = {
            queryName: queryName,
            operationKind: operationKind
        };
        const loggingAndMetrics = (0, (0, parcelRequire("7isEg")).getLoggingAndMetricsHelper)(loggingMetadata);
        return (0, $eiowN.Observable).create((sink)=>{
            try {
                const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
                const endpoint = (0, (0, parcelRequire("eCZ6m")).getAggEndpoint)(request, cacheConfig);
                const body = (0, (0, parcelRequire("eCZ6m")).getRequestBody)(request, variables);
                let ssrCache = null;
                if (!false && requestID != null) ssrCache = (0, (0, parcelRequire("7pVV3")).QueryResponseCache).get(requestID, variables);
                if (!false && !(0, ($parcel$interopDefault($hGgHi)))(ssrCache)) {
                    sink.next(ssrCache);
                    if (requestID != null) (0, (0, parcelRequire("7pVV3")).QueryResponseCache).delete(requestID, variables);
                    sink.complete();
                    return;
                }
                const wrappedEarlyScriptPromise = earlyScriptPromise && (0, (0, parcelRequire("6b2ko")).retryOnError)(()=>(0, (0, parcelRequire("eusud")).applyErrorHandling)(earlyScriptPromise), {
                    retryFunc: ()=>(0, (0, parcelRequire("eusud")).performPostRequest)(endpoint, $2963ed038d5e3581$var$generateOptions({
                            body: body
                        })),
                    retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                    retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                });
                const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, (0, parcelRequire("eusud")).performPostRequestWithRetry)(endpoint, {
                    ...$2963ed038d5e3581$var$generateOptions({
                        body: body
                    }),
                    retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                    retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: (error, attempt)=>{
                        loggingAndMetrics.logErrorRetry(error, attempt);
                    }
                }));
                promise.then((response)=>{
                    (0, (0, parcelRequire("5Wobd")).addTraceId)(queryName, $2963ed038d5e3581$var$getTraceIdFromExtensions(response));
                    (0, (0, parcelRequire("4pgHP")).putExtensions)(queryName, response.extensions);
                    const errors = response.errors || undefined;
                    if (errors != null) {
                        const requestId = response?.extensions?.gateway?.request_id;
                        if (!$2963ed038d5e3581$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                        (0, (0, parcelRequire("5a0Nh")).captureErrors)(errors, {
                            operationName: queryName,
                            requestId: requestId
                        });
                        if ((0, (0, parcelRequire("5a0Nh")).isUnauthenticated)(errors)) {
                            (0, (0, parcelRequire("lKFKm")).showUnauthenticatedFlag)(queryName);
                            return;
                        }
                    }
                    if (response.data && (response.data.jira === null || response.data.customerService === null)) response.data = null;
                    if (false && requestID != null) (0, (0, parcelRequire("7pVV3")).QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                    sink.next(response);
                    sink.complete();
                }).catch((error)=>{
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                });
                if (requestID != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).set(requestID, promise);
            } catch (error) {
                loggingAndMetrics.logError(error);
                sink.error(error);
            }
        });
    };
});
parcelRegister("5a0Nh", function(module, exports) {
    $parcel$export(module.exports, "startCaptureGraphQlErrors", ()=>$cf86a52470c84b66$export$c211170518c6d0f6);
    $parcel$export(module.exports, "stopCaptureGraphQlErrors", ()=>$cf86a52470c84b66$export$e0491a0d974dadfa);
    $parcel$export(module.exports, "captureErrors", ()=>$cf86a52470c84b66$export$7a973c0ff390eb47);
    $parcel$export(module.exports, "isUnauthenticated", ()=>$cf86a52470c84b66$export$1724ecfee73c4768);
    var $7Jxgt = parcelRequire("7Jxgt");
    const $cf86a52470c84b66$var$errorCollector = new Map();
    const $cf86a52470c84b66$export$da396ad2a542b095 = 120000;
    const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
        setTimeout(()=>{
            $cf86a52470c84b66$var$errorCollector.delete(key);
        }, $cf86a52470c84b66$export$da396ad2a542b095);
    };
    const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, ($parcel$interopDefault($7Jxgt))).v4())=>{
        $cf86a52470c84b66$var$errorCollector.set(key, []);
        $cf86a52470c84b66$var$scheduleCleanup(key);
        return key;
    };
    const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
        const errors = $cf86a52470c84b66$var$errorCollector.get(key);
        $cf86a52470c84b66$var$errorCollector.delete(key);
        return errors || [];
    };
    const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
        if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
            $cf86a52470c84b66$var$errorCollector.set(key, [
                ...value,
                {
                    errors: errors,
                    meta: meta
                }
            ]);
        });
    };
    const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
        if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
        return false;
    };
});
parcelRegister("gwtGO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1019e315ad42f34a$export$2e2bcd8739ae039);
    var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
        'ariGraph',
        'boardCardMove',
        'deleteCard',
        'JiraJqlBuilder',
        'SoftwareCardTypeTransitions',
        'jira-releases-v0',
        'JiraDevOps',
        'JiraDevOpsProviders',
        'createCustomFilter',
        'updateCustomFilter',
        'deleteCustomFilter',
        'customFilters',
        'PermissionScheme',
        'JiraIssue',
        'projectStyle',
        'startSprintPrototype',
        'AddIssuesToFixVersion',
        'JiraVersionResult',
        'JiraIssueConnectionJql',
        'JiraFieldOptionSearching',
        'JiraIssueFieldMutations',
        'JiraIssueDevInfoDetails',
        'JiraIssueDevSummaryCache',
        'JiraVersionWarningConfig',
        'JiraReleaseNotesConfiguration',
        'JiraUpdateReleaseNotesConfiguration',
        'ReleaseNotes',
        'ReleaseNotesOptions',
        'DeploymentsFeaturePrecondition',
        'UpdateVersionWarningConfig',
        'UpdateVersionName',
        'UpdateVersionDescription',
        'UpdateVersionStartDate',
        'UpdateVersionReleaseDate',
        'VersionsForProject',
        'RelatedWork',
        'SuggestedRelatedWorkCategories',
        'setIssueMediaVisibility',
        'toggleBoardFeature',
        'DevOpsProvider',
        'DevOpsSummarisedDeployments',
        'JiraProject',
        'DevOpsSummarisedEntities',
        'RoadmapsMutation',
        'RoadmapsQuery',
        'JiraApplicationProperties',
        'JiraIssueSearch',
        'JiraFilter',
        'featureGroups',
        'setBoardEstimationType',
        'devOps',
        'softwareBoards',
        'name',
        'AddRelatedWorkToVersion',
        'RemoveRelatedWorkFromVersion',
        'admins',
        'canAdministerBoard',
        'jql',
        'globalCardCreateAdditionalFields',
        'GlobalTimeTrackingSettings',
        'ReleaseNotesOptions',
        'search-experience',
        'MoveOrRemoveIssuesToFixVersion',
        'compass-beta',
        'JiraIssueSearchStatus',
        'Townsquare',
        'JiraNavigationItems',
        'JiraVersionsForProjects',
        'columnConfigs'
    ];
});
parcelRegister("kipqU", function(module, exports) {
    $parcel$export(module.exports, "QueryPromisesMap", ()=>$f428f7f15822f637$export$607b80f5bc6e396d);
    const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();
});
parcelRegister("7pVV3", function(module, exports) {
    $parcel$export(module.exports, "QueryResponseCache", ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d);
    var $jqONe = parcelRequire("jqONe");
    var $9XE6b = parcelRequire("9XE6b");
    var $eiowN = parcelRequire("eiowN");
    var $dJl1T;
    var $4R6GH;
    var $jJZqs;
    var $kizcd;
    function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
        return JSON.stringify((0, $eiowN.stableCopy)({
            queryID: queryID,
            variables: variables
        }));
    }
    function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
        return JSON.parse(cacheKey).queryID;
    }
    class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
        constructor({ cacheName: cacheName, size: size, ttl: ttl }){
            super({
                size: size,
                ttl: ttl
            });
            let cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
            if (!false && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')) cachedData = window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
            this.cacheName = cacheName;
            this.requestMetadata = new Map(cachedData.requestMetadata);
            this._responses = new Map(cachedData.responses);
            if (!false) setTimeout(()=>{
                this.logUnusedPayloadErrors();
                this.requestMetadata.clear();
                this._responses.clear();
            }, 60000);
        }
        logUnusedPayloadErrors() {
            const loggedQueries = new Set();
            this._responses.forEach((response, key)=>{
                const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
                const metadata = this.requestMetadata.get(queryID);
                const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                    queryName: 'unknown',
                    operationKind: 'unknown'
                };
                if (!loggedQueries.has(queryName)) {
                    loggedQueries.add(queryName);
                    const error = new (0, (0, parcelRequire("kizcd")).UnusedRelayResponseError)(queryID);
                    const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'statusCode'
                    ], null);
                    const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                        message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                        errorType: errorType,
                        statusCode: statusCode,
                        queryName: queryName,
                        operationKind: operationKind,
                        errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                            'name'
                        ], null)
                    });
                }
            });
        }
        setWithMetadata(queryID, variables, payload, metadata) {
            this.requestMetadata.set(queryID, metadata);
            this.set(queryID, variables, payload);
        }
        delete(queryID, variables) {
            const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
            return this._responses.delete(cacheKey);
        }
        serialize() {
            return {
                [this.cacheName]: {
                    requestMetadata: Array.from(this.requestMetadata.entries()),
                    responses: Array.from(this._responses.entries())
                }
            };
        }
    }
    const $675c7f0a9d659efe$export$688bd21be71b9e5d = new $675c7f0a9d659efe$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    });
    const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d.serialize();
});
parcelRegister("kizcd", function(module, exports) {
    $parcel$export(module.exports, "UnusedRelayResponseError", ()=>$f174935352f053b0$export$8431e42d062de453);
    class $f174935352f053b0$export$8431e42d062de453 extends Error {
        constructor(queryID){
            super(`Relay Query ${queryID} was made during SSR but never used in the browser`);
            this.name = 'UnusedRelayResponseError';
        }
    }
});
parcelRegister("ajjqZ", function(module, exports) {
    $parcel$export(module.exports, "getEarlyScriptPromiseKey", ()=>$383b599fde987e1e$export$1102c06c7da91223);
    $parcel$export(module.exports, "claimEarlyScriptPromise", ()=>$383b599fde987e1e$export$828ac0325bce4536);
    $parcel$export(module.exports, "putEarlyScriptPromise", ()=>$383b599fde987e1e$export$e1336d32be02faf4);
    $parcel$export(module.exports, "earlyFetch", ()=>$383b599fde987e1e$export$5b55058781674413);
    var $tcn7E;
    var $l83Uu;
    var $eKonk;
    var $eCZ6m;
    const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
    const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
    const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
    const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
        const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
        const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
        return `${params.name}|${String(queryId)}|${serializedVariables}`;
    };
    const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
        const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
        if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
        return result;
    };
    const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
        if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
    };
    const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
        (0, (0, parcelRequire("l83Uu")).setMark)('jira.fe-spa.early-preload:start');
        const endpoint = (0, (0, parcelRequire("eCZ6m")).getAggEndpoint)(compiledQuery.params);
        const body = (0, (0, parcelRequire("eCZ6m")).getRequestBody)(compiledQuery.params, variables);
        const capabilityHeader = (0, (0, parcelRequire("eKonk")).getEnhancedCapabilityHeader)(capability ?? null);
        $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
            credentials: 'same-origin',
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'Content-Type': 'application/json',
                Accept: 'application/json,text/javascript,*/*',
                'X-ExperimentalApi': experimentalApis.join(','),
                ...(0, (0, parcelRequire("tcn7E")).getActiveTraceHttpRequestHeaders)(endpoint),
                ...capabilityHeader ? {
                    [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
                } : {}
            },
            method: 'POST',
            body: body
        }).then((response)=>{
            (0, (0, parcelRequire("l83Uu")).setMark)('jira.fe-spa.early-preload:end');
            return response;
        }));
    };
});
parcelRegister("l83Uu", function(module, exports) {
    $parcel$export(module.exports, "setMark", ()=>$ef655a7b07a35675$export$f7a1fb90d8604165);
    $parcel$export(module.exports, "getTraceId", ()=>$ef655a7b07a35675$export$e88cb5bfb57ce9c4);
    const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
        if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
        performance.mark(mark);
    };
    const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
    const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
    const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);
});
parcelRegister("lKFKm", function(module, exports) {
    $parcel$export(module.exports, "showUnauthenticatedFlag", ()=>$42cb6e1c2fdc593e$export$758fcc357484571e);
    var $pa9q9;
    var $fjcgS;
    var $8iiwm;
    const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
    const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            analyticsClient.sendTrackEvent({
                action: 'showed',
                actionSubject: 'unauthorizedFlag',
                attributes: {
                    operation: operationName
                },
                source: 'jiraRelayFetch'
            });
        });
    };
    const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
        (0, (0, parcelRequire("pa9q9")).showFlag)({
            type: 'error',
            title: (0, (0, parcelRequire("8iiwm")).default).title,
            description: (0, (0, parcelRequire("8iiwm")).default).description,
            actions: [
                {
                    content: (0, (0, parcelRequire("8iiwm")).default).login,
                    onClick: $42cb6e1c2fdc593e$var$reloadPage
                }
            ]
        });
        $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
    };
});
parcelRegister("pa9q9", function(module, exports) {
    $parcel$export(module.exports, "showFlag", ()=>$00ff685527f9e8c1$export$e12b2cc6b75b006b);
    $parcel$export(module.exports, "dismissFlag", ()=>$00ff685527f9e8c1$export$900a08a292ad23cd);
    $parcel$export(module.exports, "flagService", ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0);
    $parcel$export(module.exports, "useFlagsService", ()=>$00ff685527f9e8c1$export$eee61a1aafe3884);
    $parcel$export(module.exports, "useFlagService", ()=>$00ff685527f9e8c1$export$dc4f8132c3090b32);
    $parcel$export(module.exports, "isDismissFlag", ()=>$00ff685527f9e8c1$export$14b1864d9cf0809f);
    $parcel$export(module.exports, "isFlagComponent", ()=>$00ff685527f9e8c1$export$d84ce5adcee46025);
    $parcel$export(module.exports, "isBatchAction", ()=>$00ff685527f9e8c1$export$c126d8b307b8ab86);
    var $fHfPB;
    var $gEdnQ;
    var $01A9Z;
    var $7HGHK;
    const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, (0, parcelRequire("gEdnQ")).default)((0, (0, parcelRequire("01A9Z")).store).dispatch);
    const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, (0, parcelRequire("fHfPB")).default)((0, (0, parcelRequire("01A9Z")).store).dispatch);
    const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
        $00ff685527f9e8c1$export$900a08a292ad23cd((0, (0, parcelRequire("fHfPB")).dismissFlag)(id));
    };
    const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, (0, parcelRequire("01A9Z")).store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
    const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
    };
    const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
            showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
            dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
            hasFlag: $00ff685527f9e8c1$var$hasFlag
        });
    const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
    const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND);
    const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
    const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
    const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
    const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);
});
parcelRegister("fHfPB", function(module, exports) {
    $parcel$export(module.exports, "dismissFlag", ()=>$8eb241d1a1f5d9b7$export$900a08a292ad23cd);
    $parcel$export(module.exports, "default", ()=>$8eb241d1a1f5d9b7$export$2e2bcd8739ae039);
    var $d6YjM;
    var $7HGHK;
    const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
            command: (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND),
            id: flagId
        });
    var $8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
            dispatch((0, (0, parcelRequire("d6YjM")).dismissFlagAction)(action.id));
        };
});
parcelRegister("d6YjM", function(module, exports) {
    $parcel$export(module.exports, "SHOW", ()=>$07f19e2fef34903b$export$9d04158a25ce4cd);
    $parcel$export(module.exports, "show", ()=>$07f19e2fef34903b$export$57bf213be019eeb0);
    $parcel$export(module.exports, "DISMISS_INSTANCE", ()=>$07f19e2fef34903b$export$b31a07d2e6382678);
    $parcel$export(module.exports, "dismiss", ()=>$07f19e2fef34903b$export$abf286bbe7073aba);
    $parcel$export(module.exports, "DISMISS_FLAG", ()=>$07f19e2fef34903b$export$1eb56620df104bf);
    $parcel$export(module.exports, "dismissFlagAction", ()=>$07f19e2fef34903b$export$4818b3c52448050d);
    $parcel$export(module.exports, "RESET", ()=>$07f19e2fef34903b$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$07f19e2fef34903b$export$aad8462122ac592b);
    const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
    const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
            type: $07f19e2fef34903b$export$9d04158a25ce4cd,
            payload: payload
        });
    const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
    const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
            type: $07f19e2fef34903b$export$b31a07d2e6382678,
            payload: payload
        });
    const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
    const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
            type: $07f19e2fef34903b$export$1eb56620df104bf,
            payload: payload
        });
    const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
    const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
            type: $07f19e2fef34903b$export$4a991c87e640ef77
        });
});
parcelRegister("7HGHK", function(module, exports) {
    $parcel$export(module.exports, "DISMISS_COMMAND", ()=>$9deb2cdefe93babb$export$e705274c5e156b93);
    $parcel$export(module.exports, "toFlagId", ()=>$9deb2cdefe93babb$export$8184bc29de2aea90);
    $parcel$export(module.exports, "fromFlagId", ()=>$9deb2cdefe93babb$export$188cdb77b72629d7);
    const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
    const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
    const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();
});
parcelRegister("gEdnQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c019df33694ffbe1$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $d6YjM;
    var $7HGHK;
    var $c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
            if (typeof flag === 'function') {
                dispatch((0, (0, parcelRequire("d6YjM")).show)(flag));
                return undefined;
            }
            const flagId = flag.id || (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt))).v4());
            const newFlag = {
                ...flag,
                id: flagId
            };
            dispatch((0, (0, parcelRequire("d6YjM")).show)(newFlag));
            return flagId;
        };
});
parcelRegister("01A9Z", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$5787309a6ab0ba9c$export$6f57813fe9f31bf9);
    var $imvpl;
    const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("imvpl")).createStore)();
});
parcelRegister("imvpl", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$6bbcd4b408b9a94e$export$f51a9068ac82ea43);
    var $F2Mxm;
    var $gG398;
    const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'flags',
            rootReducer: (0, parcelRequire("gG398")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("F2Mxm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fca77440264e922e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $aB8eX = parcelRequire("aB8eX");
    var $e1AU2 = parcelRequire("e1AU2");
    var $iGv2H;
    var $hkadP;
    var $i9gPl;
    var $fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
        const actionListenerMiddleware = new (0, (0, parcelRequire("i9gPl")).default)();
        middlewares.push(actionListenerMiddleware.perform);
        if ((0, (0, parcelRequire("iGv2H")).debugEnabled)('redux-logger')) {
            const { logger: logger } = (parcelRequire("korqb"));
            middlewares.push(logger);
        }
        if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
            dependencies: rootEpicDependencies
        } : undefined));
        const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, (0, parcelRequire("hkadP")).default)({
            name: appName,
            serialize: {
                replacer: (key, value)=>{
                    if ((0, $5uXOq.isValidElement)(value)) {
                        if (value.type && value.type.displayName) return `React Element <${value.type.displayName}>`;
                        return 'React Element';
                    }
                    if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                    return value;
                }
            }
        })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
        store.addActionListener = actionListenerMiddleware.add;
        store.removeActionListener = actionListenerMiddleware.remove;
        return store;
    };
});
parcelRegister("iGv2H", function(module, exports) {
    $parcel$export(module.exports, "debugEnabled", ()=>$a4079cece44c0fab$export$342c99cc1e9bc5c6);
    const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);
});
parcelRegister("hkadP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$607c98afd3082218$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
        const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        const config = {
            ...devtoolsConfig
        };
        if (config.name != null && config.instanceId == null) config.instanceId = config.name;
        return 0, $3f2cs.compose;
    };
});
parcelRegister("i9gPl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$330df53c22ed8aaf$export$2e2bcd8739ae039);
    class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
        constructor(){
            this.listeners = [];
            this.add = (listener)=>{
                this.listeners.push(listener);
            };
            this.remove = (listener)=>{
                this.listeners = this.listeners.filter((l)=>l !== listener);
            };
            this.perform = (api)=>(next)=>(action)=>{
                        const result = next(action);
                        this.listeners.forEach((listener)=>listener(action, api.getState()));
                        return result;
                    };
        }
    }
});
parcelRegister("gG398", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1feeabef4760da78$export$2e2bcd8739ae039);
    var $ifg6x = parcelRequire("ifg6x");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $d6YjM;
    const $1feeabef4760da78$var$defaultState = {
        flags: []
    };
    var $1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("d6YjM")).SHOW:
                {
                    const [lowPriorityFlags, highPriorityFlags] = (0, ($parcel$interopDefault($ifg6x)))([
                        {
                            id: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                            flag: action.payload
                        },
                        ...state.flags
                    ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                    const flags = [
                        ...highPriorityFlags,
                        ...lowPriorityFlags
                    ];
                    return {
                        ...state,
                        flags: flags
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).DISMISS_INSTANCE:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).DISMISS_FLAG:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>{
                            if (flagInstance.flag.id) return flagInstance.flag.id !== id;
                            return true;
                        })
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).RESET:
                return $1feeabef4760da78$var$defaultState;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("8iiwm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c7ec0f26423b786$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "relay-fetch.services.error-flags.title",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "relay-fetch.services.error-flags.description",
            "defaultMessage": "Looks like you've been signed out. Try logging in again. "
        },
        login: {
            "id": "relay-fetch.services.error-flags.login",
            "defaultMessage": "Log in"
        }
    });
});
parcelRegister("7isEg", function(module, exports) {
    $parcel$export(module.exports, "getLoggingAndMetricsHelper", ()=>$6c554999a424d172$export$726e1df8186bb981);
    var $jqONe = parcelRequire("jqONe");
    var $9XE6b = parcelRequire("9XE6b");
    var $hGgHi = parcelRequire("hGgHi");
    var $dJl1T;
    var $jJZqs;
    const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
    const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
        const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
        return {
            logNonBreakingErrors: (errors, requestId)=>{
                if (false || (0, ($parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
                errors.forEach((error)=>{
                    error && (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                        queryName: queryName,
                        operationKind: operationKind,
                        errorType: 'graphql',
                        message: error.message,
                        requestId: requestId
                    });
                });
            },
            logError: (error)=>{
                const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            },
            logErrorRetry: (error, retryAttempt)=>{
                const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null),
                    retryAttempt: retryAttempt
                });
            }
        };
    };
});
parcelRegister("k1TrK", function(module, exports) {
    $parcel$export(module.exports, "subscribe", ()=>$4ced6779db298dc0$export$ec068583843480e7);
    var $eiowN = parcelRequire("eiowN");
    var $jcw0u;
    var $lWhTC;
    var $1Uhm6;
    var $cfDZ3;
    const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
            const client = (0, (0, parcelRequire("lWhTC")).getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id
                }
            };
            let requestId;
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    const aggRequestId = value?.extensions?.agg?.request_id;
                    requestId = aggRequestId ?? requestId;
                    sink.next(value);
                },
                error: (sinkError)=>{
                    const errorInfo = (0, (0, parcelRequire("1Uhm6")).getSinkError)(sinkError);
                    const attributes = {
                        operationName: operationName,
                        requestId: requestId,
                        userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                    };
                    sink.error(errorInfo);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'subscription',
                            packageName: 'jiraRelaySubscription',
                            teamName: 'uip-graphql'
                        },
                        error: errorInfo,
                        attributes: attributes,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        });
});
parcelRegister("lWhTC", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$2a46eca1e9133707$export$6bb76d6eba7e258c);
    var $4U1PW;
    var $jQsty;
    var $gwtGO;
    var $hoQbP;
    let $2a46eca1e9133707$var$client;
    const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
        if ((0, (0, parcelRequire("hoQbP")).isSSR)() || (0, (0, parcelRequire("jQsty")).default)('graphql_subscriptions')) return null;
        if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, (0, parcelRequire("4U1PW")).createClient)({
            url: (0, (0, parcelRequire("hoQbP")).getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
            retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, (0, parcelRequire("gwtGO")).default).join(',')
            }
        });
        return $2a46eca1e9133707$var$client;
    };
    const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
        $2a46eca1e9133707$var$client = null;
    };
});
const $37d1b046897e548f$export$8b012b965402e06a = 580000;
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000;
parcelRegister("hoQbP", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$9e6d9986231c3fe5$export$48d7c418edadb60c);
    $parcel$export(module.exports, "getAggSubscriptionEndpoint", ()=>$9e6d9986231c3fe5$export$29a72e89601dfc59);
    const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
    const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
});
parcelRegister("1Uhm6", function(module, exports) {
    $parcel$export(module.exports, "getSinkError", ()=>$db2d4e9951ebaa0f$export$ece4736473c28965);
    const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
        let errorInfo;
        if (Array.isArray(error)) [errorInfo] = error;
        else if (error instanceof Error) errorInfo = error;
        else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
        else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
        else errorInfo = new Error(`Unknown sink error: ${error}`);
        return errorInfo;
    };
});
parcelRegister("fwvto", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$c5bf640417859136$export$48d7c418edadb60c);
    const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;
});
parcelRegister("dyPNS", function(module, exports) {
    $parcel$export(module.exports, "toMappedExtensions", ()=>$12d1a959cf63073a$export$e073e0c0d1c23345);
    function $12d1a959cf63073a$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
        const result = Object.fromEntries(requestedModules.map((type)=>[
                type,
                []
            ]));
        returnedExtensions.forEach((extension)=>{
            result[extension.type]?.push(extension);
        });
        return result;
    }
});
parcelRegister("dK8AG", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyOrId", ()=>$9ffe1ab8f180b628$export$43cde151f667c69e);
    $parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", ()=>$9ffe1ab8f180b628$export$b87af5b274141bd6);
    var $1nb22;
    const $9ffe1ab8f180b628$export$43cde151f667c69e = (match)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, match.query);
        return projectKey || projectId || '';
    };
    const $9ffe1ab8f180b628$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
});
parcelRegister("gNStA", function(module, exports) {
    $parcel$export(module.exports, "resourceWithCondition", ()=>$4fbc57fe7e788209$export$cac04afc5a06c544);
    $parcel$export(module.exports, "resourceWithCondition2", ()=>$4fbc57fe7e788209$export$78488a529a07cd46);
    $parcel$export(module.exports, "browserOnlyResourceWithCondition", ()=>$4fbc57fe7e788209$export$5284559c6d2f1a7b);
    var $kbVA4;
    const $4fbc57fe7e788209$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
            get type () {
                return conditionGetter() ? resourceTrue.type : (0, (0, parcelRequire("kbVA4")).RESOURCE_TYPE_NOOP);
            },
            getKey: resourceTrue.getKey,
            get maxAge () {
                return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
            },
            getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
            maxCache: resourceTrue.maxCache,
            get isBrowserOnly () {
                return resourceTrue.isBrowserOnly;
            },
            get depends () {
                return resourceTrue.depends;
            },
            get skipBrowser () {
                return resourceTrue.skipBrowser;
            }
        };
    const $4fbc57fe7e788209$export$fbf6681b373be4c4 = (resource, amendments = {})=>resource && Object.defineProperties({}, {
            ...Object.getOwnPropertyDescriptors(resource),
            ...Object.getOwnPropertyDescriptors(amendments)
        });
    const $4fbc57fe7e788209$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $4fbc57fe7e788209$export$fbf6681b373be4c4(itemTrue, {
        getKey: ()=>'DEGENERATE_KEY',
        getData: ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER
    }))=>itemTrue && Object.defineProperties({}, Object.fromEntries([
            ...Object.keys(itemTrue),
            ...Object.keys(itemFalse)
        ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
                key,
                {
                    configurable: false,
                    enumerable: true,
                    get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
                }
            ])));
    const $4fbc57fe7e788209$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
            ...resource,
            get isBrowserOnly () {
                return !!conditionGetter();
            }
        };
});
parcelRegister("kbVA4", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_NOOP", ()=>$513d12eeb22c04a1$export$eb37f5d331ea4de4);
    $parcel$export(module.exports, "MIN_MAX_AGE", ()=>$513d12eeb22c04a1$export$5664a170ac5a9781);
    const $513d12eeb22c04a1$export$eb37f5d331ea4de4 = 'NOOP';
    const $513d12eeb22c04a1$export$5664a170ac5a9781 = 5000;
});
parcelRegister("47m5i", function(module, exports) {
    $parcel$export(module.exports, "fetchForgeModule", ()=>$9024d8f047e9df37$export$e1683e15cedb5f17);
    var $e4eHl = parcelRequire("e4eHl");
    var $8O7FC;
    var $k2DRb;
    var $iVaKa;
    var $g5X3G;
    var $gLloR;
    const $9024d8f047e9df37$var$dataClassificatedModulesConfig = {
        names: new Set(),
        request: Promise.resolve({})
    };
    const $9024d8f047e9df37$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds, locale: locale })=>{
        $9024d8f047e9df37$var$dataClassificatedModulesConfig.names.add(moduleName);
        await new Promise((resolve)=>setTimeout(resolve, 0));
        const moduleNamesToFetch = Array.from($9024d8f047e9df37$var$dataClassificatedModulesConfig.names);
        let extensions = [];
        let accessNarrowedExtensions = [];
        if (moduleNamesToFetch.length > 0) {
            $9024d8f047e9df37$var$dataClassificatedModulesConfig.names = new Set();
            $9024d8f047e9df37$var$dataClassificatedModulesConfig.request = (0, (0, parcelRequire("iVaKa")).default)((0, (0, parcelRequire("g5X3G")).toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP), contextIds, locale).then((extensionsMap)=>extensionsMap);
        }
        const result = await $9024d8f047e9df37$var$dataClassificatedModulesConfig.request;
        extensions = result.extensions[(0, ($parcel$interopDefault($e4eHl)))(moduleName)];
        if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, ($parcel$interopDefault($e4eHl)))(moduleName)];
        const getExtensionsFilter = (fullPageModuleName)=>{
            switch(fullPageModuleName){
                case 0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE:
                    return 0, (0, parcelRequire("gLloR")).adminPageFilter;
                default:
                    return 0, (0, parcelRequire("gLloR")).uniqueExtensionsFilter;
            }
        };
        return {
            extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title)),
            accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title))
        };
    };
});
parcelRegister("gLloR", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$11790a142fe832e3$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$11790a142fe832e3$export$1eefd1d9cde49fd5);
    var $3JOCw = parcelRequire("3JOCw");
    var $e0AC8;
    const $11790a142fe832e3$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $11790a142fe832e3$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        const adminExtensions = extensions;
        return [
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("e0AC8", function(module, exports) {
    $parcel$export(module.exports, "parseExtensionId", ()=>$d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b);
    $parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", ()=>$d4c89d40e0b3eaac$export$a92b17288693d366);
    const $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b = (extensionId)=>{
        const [, appId, envId] = extensionId.split('/');
        return {
            appId: appId,
            envId: envId
        };
    };
    const $d4c89d40e0b3eaac$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');
});
parcelRegister("1yLrr", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$8bb90f56b7c2b78a$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);
    var $3JOCw = parcelRequire("3JOCw");
    var $e0AC8;
    const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        return [
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("8uKLe", function(module, exports) {
    $parcel$export(module.exports, "staticSoftwareProjectHorizontalNavResource", ()=>$ee0fa1168e64c074$export$c5680a2101ae5345);
    var $k24Fu;
    var $ljMDN;
    var $95bh0;
    var $dJl1T;
    var $3HwlS;
    var $eM91u;
    var $ao2h1;
    var $aqYy6;
    var $8YTna;
    var $1nb22;
    var $gNStA;
    const $ee0fa1168e64c074$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.software-horizontal-navigation', 'Failed to get project ari');
            return '';
        }
    };
    const $ee0fa1168e64c074$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        let scope;
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        if (isTMPBoardRoute) scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
        else scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId,
            boardId: boardId
        });
        const boardAri = scope.identifierType === 'boardId' ? (0, (0, parcelRequire("k24Fu")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: String(match.params.boardId)
        }).toString() : null;
        const projectAri = $ee0fa1168e64c074$var$getProjectAri(projectId, tenantContext.cloudId);
        const containerNavigationInput = boardAri || projectAri ? {
            scopeId: String(boardAri || projectAri)
        } : {
            projectKeyQuery: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey
            }
        };
        const boardAriTemp = boardId ? (0, (0, parcelRequire("k24Fu")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: boardId
        }).toString() : (0, (0, parcelRequire("k24Fu")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: '0'
        }).toString();
        return {
            parameters: (0, (0, parcelRequire("aqYy6")).default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey,
                projectAri: projectAri,
                boardId: boardAriTemp,
                containerNavigationInput: containerNavigationInput,
                first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                useProjectKey: Boolean(projectKey),
                useProjectAri: Boolean(projectAri),
                hasBoardId: Boolean(boardId),
                isTmpRoute: Boolean(isTMPBoardRoute)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    };
    const $ee0fa1168e64c074$export$c5680a2101ae5345 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)(), (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'HORIZONTAL_NAVIGATION_PROJECT_QUERY',
        getQuery: $ee0fa1168e64c074$export$71eec30d9db46a56
    }));
});
parcelRegister("3HwlS", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4", ()=>$30254f1a9a5ebb1a$export$f1ce4aa22fe8768a);
    var $4R6GH;
    var $c0dQj;
    var $ifO6r;
    var $9qXgw;
    const $30254f1a9a5ebb1a$export$f1ce4aa22fe8768a = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && ((0, (0, parcelRequire("ifO6r")).getWillShowNav4ForDogfooding)() || (0, (0, parcelRequire("9qXgw")).getWillShowNav4ForEap)() || (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)());
});
parcelRegister("c0dQj", function(module, exports) {
    $parcel$export(module.exports, "isMobileAndInMVPExperiment", ()=>$7275e40842570ace$export$f29d7974ab92d702);
    $parcel$export(module.exports, "MobileWebExperimentExposure", ()=>$7275e40842570ace$export$b93f740e619fc842);
    var $bCdIp;
    var $6s1PB;
    var $4R6GH;
    const $7275e40842570ace$export$f29d7974ab92d702 = ()=>{
        const [mobileWebConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp');
        return ((0, (0, parcelRequire("4R6GH")).fg)('jira_mobile_web_mvp_feature_gate') && (0, (0, parcelRequire("bCdIp")).default)() && mobileWebConfig.get('isEnabled', false));
    };
    const $7275e40842570ace$export$b93f740e619fc842 = ()=>{
        const [, manuallyFireExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp');
        if ((0, (0, parcelRequire("bCdIp")).default)()) manuallyFireExposure();
        return null;
    };
});
parcelRegister("6s1PB", function(module, exports) {
    $parcel$export(module.exports, "expVal", ()=>$d0d3e1363a65fa96$export$9db1624a8af791a4);
    $parcel$export(module.exports, "expValEquals", ()=>$d0d3e1363a65fa96$export$45abdb3f977b5b14);
    $parcel$export(module.exports, "UNSAFE_noExposureExp", ()=>$d0d3e1363a65fa96$export$677f9fa2e1ae6fec);
    var $5IPCv;
    var $gSA3s;
    var $40Gox;
    function $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, defaultValue) {
        (0, (0, parcelRequire("40Gox")).UNSAFE_initIfNeeded)();
        const value = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue(experimentName, param, defaultValue);
        (0, (0, parcelRequire("gSA3s")).addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
        return value;
    }
    function $d0d3e1363a65fa96$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
        return $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
    }
    class $d0d3e1363a65fa96$var$ExperimentConfig {
        constructor(experimentName, config){
            this._experimentName = experimentName;
            this._config = config;
        }
        get(key, defaultValue, typeGuard) {
            const value = this._config.get(key, defaultValue, typeGuard);
            (0, (0, parcelRequire("gSA3s")).addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
            return value;
        }
    }
    const $d0d3e1363a65fa96$var$cache = new Map();
    function $d0d3e1363a65fa96$export$677f9fa2e1ae6fec(experimentName) {
        let instance = $d0d3e1363a65fa96$var$cache.get(experimentName);
        if (instance == null) {
            (0, (0, parcelRequire("40Gox")).UNSAFE_initIfNeeded)();
            const config = (0, (0, parcelRequire("5IPCv")).default).getExperiment(experimentName, {
                fireExperimentExposure: false
            });
            const fireExposure = ()=>(0, (0, parcelRequire("5IPCv")).default).manuallyLogExperimentExposure(experimentName);
            instance = [
                new $d0d3e1363a65fa96$var$ExperimentConfig(experimentName, config),
                fireExposure
            ];
            $d0d3e1363a65fa96$var$cache.set(experimentName, instance);
        }
        return instance;
    }
});
parcelRegister("ifO6r", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForDogfooding", ()=>$b6db23b0cddd1764$export$9ca0d92d31816d4f);
    var $4R6GH;
    var $1MhR0;
    var $8MTso;
    const $b6db23b0cddd1764$export$9ca0d92d31816d4f = ()=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')) return false;
        const phase1 = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1');
        const phase2 = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2');
        const phase3 = !(phase1 || phase2);
        return phase3 || phase2 && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() || phase1 && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() && !(0, (0, parcelRequire("8MTso")).getIsRouteExcludedForDogfoodingPhase1)();
    };
});
parcelRegister("1MhR0", function(module, exports) {
    $parcel$export(module.exports, "getMetaBoolean", ()=>$039259847fa24143$export$9683360b0ae70629);
    $parcel$export(module.exports, "getIsNav4UserOptOut", ()=>$039259847fa24143$export$3fbfe0fdf05e0f9f);
    var $gJBT6 = parcelRequire("gJBT6");
    var $j8DrX;
    var $7qZOo;
    const $039259847fa24143$export$9683360b0ae70629 = (0, ($parcel$interopDefault($gJBT6)))((name)=>(0, (0, parcelRequire("j8DrX")).default)(`ajs-${name}`) === 'true');
    const $039259847fa24143$export$7d046765d192af80 = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_ADMIN));
    const $039259847fa24143$export$ba89637357392be6 = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_NAV4_USER_OPT_IN));
    const $039259847fa24143$export$3fbfe0fdf05e0f9f = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_NAV4_USER_OPT_OUT));
});
parcelRegister("7qZOo", function(module, exports) {
    $parcel$export(module.exports, "IS_ADMIN", ()=>$92928f70e02753a5$export$4261d5d429e288ec);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_IN", ()=>$92928f70e02753a5$export$153ded4d539b820d);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_OUT", ()=>$92928f70e02753a5$export$9c962957701a4fe8);
    $parcel$export(module.exports, "NAV4_ROLLOUT_NONE", ()=>$92928f70e02753a5$export$3b602cac1f385c06);
    $parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", ()=>$92928f70e02753a5$export$e748a16828d2f61f);
    const $92928f70e02753a5$export$4261d5d429e288ec = 'is-admin';
    const $92928f70e02753a5$export$153ded4d539b820d = 'is-nav4-user-opt-in';
    const $92928f70e02753a5$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';
    const $92928f70e02753a5$export$3b602cac1f385c06 = {
        stage: 'none'
    };
    const $92928f70e02753a5$export$e748a16828d2f61f = {
        stage: 'mobile'
    };
    const $92928f70e02753a5$export$9cd4b8dc5f7153b8 = {
        NONE: 'none',
        DOGFOODING: 'dogfooding',
        EAP: 'eap',
        BETA: 'beta',
        GA: 'ga'
    };
});
parcelRegister("8MTso", function(module, exports) {
    $parcel$export(module.exports, "getIsRouteExcludedForDogfoodingPhase1", ()=>$5866baf2a5010361$export$f0abfe25b95778e3);
    var $4R6GH;
    const $5866baf2a5010361$var$JPD_COLLECTIONS_OVERVIEW_REGEX = new RegExp('^/jira/polaris/roadmaps(/)*$');
    const $5866baf2a5010361$export$f0abfe25b95778e3 = ()=>{
        if (false) return false;
        const pathname = $5866baf2a5010361$var$getPathname();
        if (pathname.includes('/jira/polaris/roadmaps')) {
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jpd-sidebar-v4-for-roadmaps')) {
                const isJpdCollectionsOverview = $5866baf2a5010361$var$JPD_COLLECTIONS_OVERVIEW_REGEX.test(pathname);
                if (isJpdCollectionsOverview && (0, (0, parcelRequire("4R6GH")).fg)('jpd-sidebar-v4-for-roadmaps-overview')) return false;
                return true;
            }
        }
        return false;
    };
    const $5866baf2a5010361$var$getPathname = ()=>window.location.pathname;
});
parcelRegister("9qXgw", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForEap", ()=>$77cd593041adc2b6$export$393f53ae320de085);
    var $4R6GH;
    var $1MhR0;
    const $77cd593041adc2b6$export$393f53ae320de085 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
});
parcelRegister("eM91u", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", ()=>$8ade7fd740dbd607$export$4653cda61a4943d6);
    $parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", ()=>$8ade7fd740dbd607$export$d1b9ea3245b6a5de);
    $parcel$export(module.exports, "TAB_HEIGHT", ()=>$8ade7fd740dbd607$export$d07bba395c9390f1);
    $parcel$export(module.exports, "TAB_HEIGHT_REFRESH", ()=>$8ade7fd740dbd607$export$7795e1ec8bf78852);
    $parcel$export(module.exports, "TAB_GAP", ()=>$8ade7fd740dbd607$export$b61e6f89a9db76de);
    const $8ade7fd740dbd607$export$4653cda61a4943d6 = 75;
    const $8ade7fd740dbd607$export$d1b9ea3245b6a5de = 2;
    const $8ade7fd740dbd607$export$d07bba395c9390f1 = 36;
    const $8ade7fd740dbd607$export$7795e1ec8bf78852 = 56;
    const $8ade7fd740dbd607$export$29911ec08ab2ca2d = 5;
    const $8ade7fd740dbd607$export$b61e6f89a9db76de = 12;
    const $8ade7fd740dbd607$export$7fd2e391116c6ef5 = 9;
    const $8ade7fd740dbd607$export$e1633e494d305bfb = 'MORE';
});
parcelRegister("ao2h1", function(module, exports) {
    $parcel$export(module.exports, "RELAY_RESOURCE_TYPE", ()=>$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54);
    $parcel$export(module.exports, "createRelayResource", ()=>$5f6ac21695ec30bb$export$1cc887c62079ea32);
    $parcel$export(module.exports, "useRelayResource", ()=>$5f6ac21695ec30bb$export$42ca7b248c7aaee);
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $x9xyg;
    var $4R6GH;
    var $5yJb9;
    var $5a0Nh;
    var $kipqU;
    var $dIdda = parcelRequire("dIdda");
    var $5Wobd;
    const $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
    const $5f6ac21695ec30bb$var$getDataOld = async ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const query = parameters ?? await loadParameters?.();
        const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables || {}, options));
        if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
        if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
            (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $5f6ac21695ec30bb$var$getDataNew = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), parameters, variables || {}, options));
        if (false && queryReference.id != null) {
            const promise = (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            if (promise) return promise.then(()=>{
                (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
                (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
                if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
                if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
                return queryReference;
            });
        }
        if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
            (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $5f6ac21695ec30bb$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $dIdda.createResource)({
            type: `${$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54}_${type}`,
            getKey: (routerContext, customContext)=>{
                const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
                if (!preloadableRequest) return JSON.stringify(variables || {});
                let queryId;
                let params;
                if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                    const preloadableConcreteRequest = preloadableRequest;
                    ({ params: params } = preloadableConcreteRequest);
                    ({ id: queryId } = params);
                } else {
                    const graphQlTaggedNode = preloadableRequest;
                    const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                    params = request.params;
                    queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
                }
                return `${String(queryId)}${JSON.stringify(variables || {})}`;
            },
            getData: (routerContext, customContext)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('blu-3813-improve-ssr-hydration-of-relay')) return $5f6ac21695ec30bb$var$getDataNew({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
                return $5f6ac21695ec30bb$var$getDataOld({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    loadParameters: loadParameters,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
            },
            maxAge: 0,
            isBrowserOnly: isBrowserOnly
        });
    const $5f6ac21695ec30bb$export$1cc887c62079ea32 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
    const $5f6ac21695ec30bb$export$bbe949b85c06f763 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
    const $5f6ac21695ec30bb$export$42ca7b248c7aaee = (resource, options)=>{
        const { data: queryReference, loading: loading, promise: promise } = (0, $dIdda.useResource)(resource);
        if (options?.suspendWhenLoading && loading) throw promise;
        return {
            queryReference: queryReference
        };
    };
});
parcelRegister("aqYy6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea1c475e7aa0ff0f$export$2e2bcd8739ae039);
    const $ea1c475e7aa0ff0f$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hasBoardId"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTmpRoute"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v8 = {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "useContainerNavigation"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectAri"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectKey"
        }, v11 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "containerNavigationInput"
            }
        ], v12 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v13 = {
            "kind": "ScalarField",
            "name": "scopeId"
        }, v14 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            }
        ], v15 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v16 = [
            v15,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v17 = {
            "kind": "ScalarField",
            "name": "name"
        }, v18 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v19 = {
            "kind": "ScalarField",
            "name": "projectType"
        }, v20 = {
            "kind": "ScalarField",
            "name": "projectStyle"
        }, v21 = {
            "kind": "ScalarField",
            "name": "key"
        }, v22 = {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }, v23 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v24 = {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v23,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }, v25 = {
            "alias": "canViewProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v23,
            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
        }, v26 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }, v27 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v28 = [
            {
                "kind": "FragmentSpread",
                "name": "extraComponentsFar_horizontalNavHeader"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTmpRoute",
                        "variableName": "isTmpRoute"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "boardHeader_horizontalNavHeader_projectFragment"
            },
            {
                "kind": "FragmentSpread",
                "name": "projectHeader_horizontalNavHeader_projectFragment"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_navigationKitTabList_TabList_projectFragment"
            },
            v17,
            v18,
            v19,
            v20,
            v21,
            v22,
            v24,
            v25,
            v26,
            v27
        ], v29 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v30 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v31 = {
            "kind": "ScalarField",
            "name": "id"
        }, v32 = {
            "kind": "ScalarField",
            "name": "label"
        }, v33 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v34 = {
            "kind": "ScalarField",
            "name": "url"
        }, v35 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v36 = {
            "kind": "InlineFragment",
            "selections": [
                v31
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v37 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v38 = {
            "kind": "ScalarField",
            "name": "boardType"
        }, v39 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v40 = [
            v30,
            {
                "kind": "InlineFragment",
                "selections": [
                    v37,
                    v17,
                    v12,
                    v38,
                    {
                        "concreteType": "JiraFavouriteValue",
                        "kind": "LinkedField",
                        "name": "favouriteValue",
                        "plural": false,
                        "selections": [
                            v39,
                            v31
                        ]
                    },
                    v27
                ],
                "type": "JiraBoard"
            },
            v36
        ], v41 = [
            {
                "kind": "LinkedField",
                "name": "mostRecentlyViewedBoard",
                "plural": false,
                "selections": v40
            },
            v31
        ], v42 = [
            {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            v17,
            v18,
            v20,
            v19,
            v26,
            v24,
            v25,
            v21,
            v31,
            v39,
            {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            v22,
            v27,
            {
                "condition": "useContainerNavigation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "navigationMetadata",
                        "plural": false,
                        "selections": [
                            v30,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v37,
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSimpleBoard"
                                    },
                                    v31
                                ],
                                "type": "JiraSoftwareProjectNavigationMetadata"
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v30,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v37,
                                    v38
                                ],
                                "type": "JiraBoard"
                            },
                            v36
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10
                ],
                "kind": "Fragment",
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v11,
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitTabList_TabList_containerFragment"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitAddTab_AddTab"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v12,
                                                    v13,
                                                    {
                                                        "args": v14,
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "ui_navigationKitTabList_TabList_tabsFragment"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.containerNavigation"
                                },
                                {
                                    "condition": "isTmpRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                },
                                                v15,
                                                {
                                                    "kind": "Variable",
                                                    "name": "hasBoardId",
                                                    "variableName": "hasBoardId"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "projectAri",
                                                    "variableName": "projectAri"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "projectKey",
                                                    "variableName": "projectKey"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "useProjectAri",
                                                    "variableName": "useProjectAri"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "useProjectKey",
                                                    "variableName": "useProjectKey"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "boardHeader_horizontalNavHeader_boardFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "projectDataByKey",
                                                "args": v16,
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "jiraProjectByKey",
                                                "plural": false,
                                                "selections": v28
                                            },
                                            "action": "THROW",
                                            "path": "jira.projectDataByKey"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "condition": "useProjectAri",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "alias": "projectDataById",
                                                        "args": v29,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProject",
                                                        "plural": false,
                                                        "selections": v28
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.projectDataById"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0,
                    v7,
                    v6,
                    v3,
                    v2,
                    v10,
                    v9,
                    v4,
                    v5,
                    v8
                ],
                "kind": "Operation",
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v11,
                                "kind": "LinkedField",
                                "name": "containerNavigation",
                                "plural": false,
                                "selections": [
                                    v30,
                                    {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isJiraContainerNavigationResult"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v31,
                                            v12,
                                            v13,
                                            {
                                                "args": v14,
                                                "concreteType": "JiraNavigationItemConnection",
                                                "kind": "LinkedField",
                                                "name": "navigationItems",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraNavigationItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v30,
                                                                    v31,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "isDefault"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "typeKey"
                                                                    },
                                                                    {
                                                                        "kind": "TypeDiscriminator",
                                                                        "abstractKey": "__isJiraNavigationItem"
                                                                    },
                                                                    v32,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canRemove"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canSetAsDefault"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "appId"
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraAppSection",
                                                                                "kind": "LinkedField",
                                                                                "name": "sections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v32,
                                                                                    {
                                                                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "links",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v32,
                                                                                            v33,
                                                                                            v34,
                                                                                            v35
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v34,
                                                                            v33,
                                                                            v35,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "appType"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "envLabel"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v27
                                                                                ],
                                                                                "type": "JiraNavigationItem",
                                                                                "abstractKey": "__isJiraNavigationItem"
                                                                            }
                                                                        ],
                                                                        "type": "JiraAppNavigationItem"
                                                                    },
                                                                    v27
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraContainerNavigation"
                                    },
                                    v36
                                ]
                            },
                            {
                                "condition": "isTmpRoute",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "condition": "hasBoardId",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "boardId"
                                                    }
                                                ],
                                                "kind": "LinkedField",
                                                "name": "jiraBoard",
                                                "plural": false,
                                                "selections": v40
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "useProjectKey",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "condition": "hasBoardId",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "alias": "projectDataByKey",
                                                        "args": v16,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProjectByKey",
                                                        "plural": false,
                                                        "selections": v41
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "useProjectAri",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "condition": "hasBoardId",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "alias": "projectDataById",
                                                        "args": v29,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProject",
                                                        "plural": false,
                                                        "selections": v41
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v16,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v42
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "condition": "useProjectAri",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "alias": "projectDataById",
                                                "args": v29,
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "jiraProject",
                                                "plural": false,
                                                "selections": v42
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "def638e25db2f065a6ceadbb38f6d4bc613cca840e95dc29820c6275054f606e",
                "metadata": {},
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $ea1c475e7aa0ff0f$var$node.hash = "ef8c67db61c955d779206c3b78af3d1e";
    var $ea1c475e7aa0ff0f$export$2e2bcd8739ae039 = $ea1c475e7aa0ff0f$var$node;
});
parcelRegister("7xTO3", function(module, exports) {
    $parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", ()=>$7371ef5d04dd1248$export$5839dd8142de842e);
    var $dJl1T;
    var $8YTna;
    var $dIdda = parcelRequire("dIdda");
    var $55UpE;
    const $7371ef5d04dd1248$export$5839dd8142de842e = (0, $dIdda.createResource)({
        type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            if (boardId == null) return null;
            try {
                const response = await (0, (0, parcelRequire("55UpE")).fetchUserBoardNavigationData)(boardId);
                return response;
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
                return null;
            }
        },
        maxAge: 300000
    });
});
parcelRegister("55UpE", function(module, exports) {
    $parcel$export(module.exports, "fetchUserBoardNavigationData", ()=>$e577b36e40c022cb$export$306fb49fca60b34);
    var $eusud;
    const $e577b36e40c022cb$export$306fb49fca60b34 = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
    };
});
parcelRegister("c1N9v", function(module, exports) {
    $parcel$export(module.exports, "staticPlanSidebarNavigationResource", ()=>$4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7);
    var $dIdda = parcelRequire("dIdda");
    var $ijN6s;
    const $4a8a43738dc54d5c$var$getRouterKey = (match)=>{
        if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
        return 'none';
    };
    const $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7 = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
        getKey: ({ match: match })=>$4a8a43738dc54d5c$var$getRouterKey(match),
        getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
            if (planId == null || scenarioId == null) return null;
            return (0, (0, parcelRequire("ijN6s")).fetchPlanSidebarNavInfo)(planId, scenarioId);
        },
        maxAge: 300000
    });
});
parcelRegister("ijN6s", function(module, exports) {
    $parcel$export(module.exports, "fetchPlanSidebarNavInfo", ()=>$b2d0559c1bc2bb35$export$a49729698cfc5310);
    var $eusud;
    const $b2d0559c1bc2bb35$var$requestSideBarInfo = (planId, scenarioId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
    const $b2d0559c1bc2bb35$export$a49729698cfc5310 = (planId, scenarioId)=>{
        if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
        if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
        return $b2d0559c1bc2bb35$var$requestSideBarInfo(planId, scenarioId);
    };
});
parcelRegister("iEUaw", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarShortcutsResource", ()=>$681ca3c44ff39b04$export$4847c29b4786b3b4);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $bskkv;
    const $681ca3c44ff39b04$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $681ca3c44ff39b04$export$4847c29b4786b3b4 = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
        getKey: ({ match: match, query: query })=>$681ca3c44ff39b04$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $681ca3c44ff39b04$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const shortcuts = await (0, (0, parcelRequire("bskkv")).fetchShortcuts)(projectKeyOrId);
            return shortcuts;
        },
        maxAge: 300000
    });
});
parcelRegister("bskkv", function(module, exports) {
    $parcel$export(module.exports, "fetchShortcuts", ()=>$b1e90e13aab5fe84$export$49d696bf2525d700);
    var $jcw0u;
    var $7f4tk;
    const $b1e90e13aab5fe84$export$49d696bf2525d700 = (projectKeyOrId)=>{
        try {
            return (0, (0, parcelRequire("7f4tk")).default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'fetchProjectShortcuts',
                packageName: 'jiraNavigationAppsResources'
            });
            throw error;
        }
    };
});
parcelRegister("2fwuR", function(module, exports) {
    $parcel$export(module.exports, "sidebarNav4Resource", ()=>$692dbcae1edae2a1$export$7648dc6f76f4f83d);
    $parcel$export(module.exports, "sidebarNav4UiStateResource", ()=>$692dbcae1edae2a1$export$a46129bd512544d7);
    var $jhS4y;
    var $3Jbkp;
    var $fMcVX;
    var $ao2h1;
    var $2OeZv;
    var $fZBia;
    const $692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
    const $692dbcae1edae2a1$export$7648dc6f76f4f83d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${$692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
        getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
            const initialSelectedPath = (0, (0, parcelRequire("3Jbkp")).getInitialSelectedPath)(routerContext);
            return {
                parameters: (0, (0, parcelRequire("2OeZv")).default),
                variables: {
                    cloudId: cloudId,
                    isAppsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)),
                    isDashboardsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)),
                    isFiltersExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)),
                    isPlansExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)),
                    isProjectsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)),
                    isOperationsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)),
                    isOverviewsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS))
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $692dbcae1edae2a1$export$a46129bd512544d7 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
        getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
                parameters: (0, (0, parcelRequire("fZBia")).default),
                variables: {
                    cloudId: cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("jhS4y", function(module, exports) {
    $parcel$export(module.exports, "CONFIGURABLE_MENU_ID", ()=>$d66e3a3484b422c6$export$7838b734e4cd5e8d);
    $parcel$export(module.exports, "ENTITY_ID", ()=>$d66e3a3484b422c6$export$103ff18fe29ee1b);
    $parcel$export(module.exports, "MENU_ID_APPS", ()=>$d66e3a3484b422c6$export$441cd608ea3204f4);
    $parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", ()=>$d66e3a3484b422c6$export$5baa9c2e3c3931c5);
    $parcel$export(module.exports, "MENU_ID_ASSETS", ()=>$d66e3a3484b422c6$export$75c65bfc98b3a6e1);
    $parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", ()=>$d66e3a3484b422c6$export$8a0af92d49f1d13d);
    $parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", ()=>$d66e3a3484b422c6$export$a09300d15acc958a);
    $parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$4d718fbd418eef5c);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS", ()=>$d66e3a3484b422c6$export$dd009509c2dabb5e);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$d3da0455b4200fb2);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$b9dd2b5309d19763);
    $parcel$export(module.exports, "MENU_ID_FILTERS", ()=>$d66e3a3484b422c6$export$3d81af172a8e3c57);
    $parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", ()=>$d66e3a3484b422c6$export$1e2599eaf0039a97);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$53d274d993c9d5b5);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$7661ea763be69cfa);
    $parcel$export(module.exports, "MENU_ID_GOALS", ()=>$d66e3a3484b422c6$export$47c6ce6a83a59eab);
    $parcel$export(module.exports, "MENU_ID_OPERATIONS", ()=>$d66e3a3484b422c6$export$ef89639b7d9c162a);
    $parcel$export(module.exports, "MENU_ID_OPS_ALERTS", ()=>$d66e3a3484b422c6$export$af4ab6d4e920522a);
    $parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", ()=>$d66e3a3484b422c6$export$25c40acb2c53a294);
    $parcel$export(module.exports, "MENU_ID_OPS_REPORTS", ()=>$d66e3a3484b422c6$export$c7d8892f1628b844);
    $parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", ()=>$d66e3a3484b422c6$export$bb19a52e3df99541);
    $parcel$export(module.exports, "MENU_ID_OVERVIEWS", ()=>$d66e3a3484b422c6$export$3bd12c092f8db11b);
    $parcel$export(module.exports, "MENU_ID_PLANS", ()=>$d66e3a3484b422c6$export$f2533da33c749933);
    $parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$8468c5b6648f4f1f);
    $parcel$export(module.exports, "MENU_ID_PROJECT_APPS", ()=>$d66e3a3484b422c6$export$fed17b4c0866b97d);
    $parcel$export(module.exports, "MENU_ID_PROJECTS", ()=>$d66e3a3484b422c6$export$9c5278bd360a285);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$85389c606bb641dd);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$4a1974b63c858e9c);
    $parcel$export(module.exports, "MENU_ID_RECENT", ()=>$d66e3a3484b422c6$export$692b796030a796f3);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS", ()=>$d66e3a3484b422c6$export$cdc80d4b5ce0c6a);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$7606c0134aabf3d7);
    $parcel$export(module.exports, "MENU_ID_STARRED", ()=>$d66e3a3484b422c6$export$5637ca42a4d77f32);
    $parcel$export(module.exports, "MENU_ID_TEAMS", ()=>$d66e3a3484b422c6$export$d4f6fcf571f9c50);
    $parcel$export(module.exports, "MENU_ID_YOUR_WORK", ()=>$d66e3a3484b422c6$export$80dc576e446bdb6b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", ()=>$d66e3a3484b422c6$export$79c15668ed799a1b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", ()=>$d66e3a3484b422c6$export$e299bb06c4370c0d);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", ()=>$d66e3a3484b422c6$export$713b9b0a69a79cf9);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", ()=>$d66e3a3484b422c6$export$f1d9c0f27216aa1c);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", ()=>$d66e3a3484b422c6$export$45763fa331781074);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", ()=>$d66e3a3484b422c6$export$6ee20c845dbab3e3);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", ()=>$d66e3a3484b422c6$export$b3815dd180ce5e61);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", ()=>$d66e3a3484b422c6$export$100a1a639a0db980);
    const $d66e3a3484b422c6$export$7838b734e4cd5e8d = {
        APPS: 'jira.sidebar.apps',
        ASSETS: 'jira.sidebar.assets',
        DASHBOARDS: 'jira.sidebar.dashboards',
        FILTERS: 'jira.sidebar.filters',
        GOALS: 'jira.sidebar.goals',
        OPERATIONS: 'jira.sidebar.operations',
        OVERVIEWS: 'jira.sidebar.overviews',
        PLANS: 'jira.sidebar.plans',
        PROJECTS: 'jira.sidebar.projects',
        RECENT: 'jira.sidebar.recent',
        STARRED: 'jira.sidebar.starred',
        TEAMS: 'jira.sidebar.teams',
        ROADMAPS: 'jira.sidebar.roadmaps'
    };
    const $d66e3a3484b422c6$export$103ff18fe29ee1b = {
        ALARM_QUEUE: (id)=>`alrm_${id}`,
        APP: (id)=>`app_${id}`,
        BOARD: (id)=>`boar_${id}`,
        DASHBOARD: (id)=>`dash_${id}`,
        FILTER: (id)=>`filt_${id}`,
        FORM: (id)=>`form_${id}`,
        OVERVIEW: (id)=>`over_${id}`,
        PLAN: (id)=>`plan_${id}`,
        PROJECT: (id)=>`proj_${id}`,
        PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
        PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
        PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
        PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
        PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
        PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
        PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
        PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
        PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
        PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
        PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
        PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
        PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
        PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
        PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
        PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
        ROADMAP: (id)=>`roadmap_${id}`,
        QUEUE: (id)=>`queu_${id}`
    };
    const $d66e3a3484b422c6$export$441cd608ea3204f4 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.APPS;
    const $d66e3a3484b422c6$export$5baa9c2e3c3931c5 = 'app_mrkt';
    const $d66e3a3484b422c6$export$75c65bfc98b3a6e1 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ASSETS;
    const $d66e3a3484b422c6$export$8a0af92d49f1d13d = 'asst_schm';
    const $d66e3a3484b422c6$export$a09300d15acc958a = 'asst_rprt';
    const $d66e3a3484b422c6$export$4d718fbd418eef5c = 'board-view-all';
    const $d66e3a3484b422c6$export$dd009509c2dabb5e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.DASHBOARDS;
    const $d66e3a3484b422c6$export$d3da0455b4200fb2 = 'dash-view';
    const $d66e3a3484b422c6$export$b9dd2b5309d19763 = 'dash-view-starred';
    const $d66e3a3484b422c6$export$3d81af172a8e3c57 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.FILTERS;
    const $d66e3a3484b422c6$export$1e2599eaf0039a97 = 'filt-search';
    const $d66e3a3484b422c6$export$53d274d993c9d5b5 = 'filt-view-all';
    const $d66e3a3484b422c6$export$7661ea763be69cfa = 'filt-view-starred';
    const $d66e3a3484b422c6$export$47c6ce6a83a59eab = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GOALS;
    const $d66e3a3484b422c6$export$ef89639b7d9c162a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OPERATIONS;
    const $d66e3a3484b422c6$export$af4ab6d4e920522a = 'ops-alrt';
    const $d66e3a3484b422c6$export$25c40acb2c53a294 = 'ops-over';
    const $d66e3a3484b422c6$export$c7d8892f1628b844 = 'ops-rprt';
    const $d66e3a3484b422c6$export$bb19a52e3df99541 = 'ops-oncl';
    const $d66e3a3484b422c6$export$3bd12c092f8db11b = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OVERVIEWS;
    const $d66e3a3484b422c6$export$f2533da33c749933 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PLANS;
    const $d66e3a3484b422c6$export$8468c5b6648f4f1f = 'plan-view-all';
    const $d66e3a3484b422c6$export$fed17b4c0866b97d = 'proj-app';
    const $d66e3a3484b422c6$export$e682260eda678e61 = 'proj-dir';
    const $d66e3a3484b422c6$export$9c5278bd360a285 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PROJECTS;
    const $d66e3a3484b422c6$export$85389c606bb641dd = 'proj-view-all';
    const $d66e3a3484b422c6$export$4a1974b63c858e9c = 'proj-view-starred';
    const $d66e3a3484b422c6$export$692b796030a796f3 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.RECENT;
    const $d66e3a3484b422c6$export$cdc80d4b5ce0c6a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ROADMAPS;
    const $d66e3a3484b422c6$export$7606c0134aabf3d7 = 'roadmaps-view-all';
    const $d66e3a3484b422c6$export$5637ca42a4d77f32 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.STARRED;
    const $d66e3a3484b422c6$export$d4f6fcf571f9c50 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.TEAMS;
    const $d66e3a3484b422c6$export$80dc576e446bdb6b = 'yrwk';
    const $d66e3a3484b422c6$export$79c15668ed799a1b = 'sd-sett-acc';
    const $d66e3a3484b422c6$export$e299bb06c4370c0d = 'sd-sett-req-man';
    const $d66e3a3484b422c6$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
    const $d66e3a3484b422c6$export$f1d9c0f27216aa1c = 'sd-sett-aut';
    const $d66e3a3484b422c6$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
    const $d66e3a3484b422c6$export$6ee20c845dbab3e3 = 'sd-sett-not';
    const $d66e3a3484b422c6$export$b3815dd180ce5e61 = 'sd-sett-apps';
    const $d66e3a3484b422c6$export$100a1a639a0db980 = 'sd-sett-ops';
});
parcelRegister("3Jbkp", function(module, exports) {
    $parcel$export(module.exports, "getInitialSelectedPath", ()=>$e52131b0b61339d3$export$39f409bc5f59c5e);
    var $bxYf9 = parcelRequire("bxYf9");
    var $7Ckoi;
    const $e52131b0b61339d3$export$39f409bc5f59c5e = (0, ($parcel$interopDefault($bxYf9)))((0, (0, parcelRequire("7Ckoi")).routeToSelectedPath));
});
parcelRegister("7Ckoi", function(module, exports) {
    $parcel$export(module.exports, "routeToSelectedPath", ()=>$551cdf5d088747a1$export$a92474c098a1fd13);
    var $4R6GH;
    var $fBDpl;
    var $ezq2z;
    var $j3mSh;
    var $1RoZ2;
    var $hdJn1;
    var $2m3Yb;
    var $3weqe;
    var $c6hlO;
    var $3lNyZ;
    var $8bXrC;
    var $eReVn;
    function $551cdf5d088747a1$export$a92474c098a1fd13(routeContext) {
        const routeName = routeContext.route.name;
        if ((0, (0, parcelRequire("2m3Yb")).topLevelConverter).routes.has(routeName)) return (0, (0, parcelRequire("2m3Yb")).topLevelConverter).convert(routeContext);
        if ((0, (0, parcelRequire("fBDpl")).appsConverter).routes.has(routeName)) return (0, (0, parcelRequire("fBDpl")).appsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("ezq2z")).assetsConverter).routes.has(routeName)) return (0, (0, parcelRequire("ezq2z")).assetsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("j3mSh")).dashboardsConverter).routes.has(routeName)) return (0, (0, parcelRequire("j3mSh")).dashboardsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("1RoZ2")).filtersConverter).routes.has(routeName)) return (0, (0, parcelRequire("1RoZ2")).filtersConverter).convert(routeContext);
        if ((0, (0, parcelRequire("hdJn1")).operationsConverter).routes.has(routeName)) return (0, (0, parcelRequire("hdJn1")).operationsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3weqe")).overviewsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3weqe")).overviewsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3weqe")).overviewsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3weqe")).overviewsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("c6hlO")).plansConverter).routes.has(routeName)) return (0, (0, parcelRequire("c6hlO")).plansConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3lNyZ")).projectsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3lNyZ")).projectsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("8bXrC")).roadmapsConverter).routes.has(routeName)) return (0, (0, parcelRequire("8bXrC")).roadmapsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')) {
            if ((0, (0, parcelRequire("eReVn")).serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, (0, parcelRequire("eReVn")).serviceManagementProjectSettingsConverter).convert(routeContext);
        }
        return [];
    }
});
parcelRegister("fBDpl", function(module, exports) {
    $parcel$export(module.exports, "appsConverter", ()=>$55a8ac7f9c56fb94$export$d017a63045c88c47);
    var $65Ltd;
    var $jhS4y;
    const $55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT)
    ];
    const $55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX)
    ];
    const $55a8ac7f9c56fb94$export$66b32f6f30eb4b4 = new Set([
        ...$55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES,
        ...$55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES
    ]);
    function $55a8ac7f9c56fb94$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_APP_MARKETPLACE_DISCOVER));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL:
                path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP(match.url.replace(/\/$/, '')));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT:
                {
                    const { projectKey: projectKey } = match.params;
                    return [
                        (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                        (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT:
                {
                    const { projectKey: projectKey } = query;
                    return [
                        (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                        (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            default:
                break;
        }
        return path;
    }
    const $55a8ac7f9c56fb94$export$d017a63045c88c47 = {
        routes: $55a8ac7f9c56fb94$export$66b32f6f30eb4b4,
        convert: $55a8ac7f9c56fb94$var$convert
    };
});
parcelRegister("ezq2z", function(module, exports) {
    $parcel$export(module.exports, "assetsConverter", ()=>$bdd6509d07f3cefb$export$6cfeba0849032a84);
    var $65Ltd;
    var $jhS4y;
    const $bdd6509d07f3cefb$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION)
    ]);
    function $bdd6509d07f3cefb$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_REPORTS));
                break;
            default:
                break;
        }
        return path;
    }
    const $bdd6509d07f3cefb$export$6cfeba0849032a84 = {
        routes: $bdd6509d07f3cefb$var$routes,
        convert: $bdd6509d07f3cefb$var$convert
    };
});
parcelRegister("j3mSh", function(module, exports) {
    $parcel$export(module.exports, "dashboardsConverter", ()=>$257dabfdf8711aa2$export$6468819b4be328b1);
    var $65Ltd;
    var $jhS4y;
    const $257dabfdf8711aa2$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD)
    ]);
    function $257dabfdf8711aa2$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD:
                query.dashboardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(query.dashboardId));
                break;
            default:
                {
                    const dashboardId = match.params.dashboardId;
                    if (dashboardId === 'last-visited') path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL));
                    else dashboardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(dashboardId));
                    break;
                }
        }
        return path;
    }
    const $257dabfdf8711aa2$export$6468819b4be328b1 = {
        routes: $257dabfdf8711aa2$var$routes,
        convert: $257dabfdf8711aa2$var$convert
    };
});
parcelRegister("1RoZ2", function(module, exports) {
    $parcel$export(module.exports, "filtersConverter", ()=>$c2ae3b230f933dc6$export$6e91331b5debb7c8);
    var $65Ltd;
    var $jhS4y;
    const $c2ae3b230f933dc6$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS)
    ]);
    function $c2ae3b230f933dc6$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query, match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId) path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId));
                    else if (match.params?.issueKey) {
                        const [projectKey] = (match.params?.issueKey || '').split('-');
                        return [
                            (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                            (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey)
                        ];
                    }
                    break;
                }
            default:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId === undefined) path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_SEARCH));
                    else path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId));
                    break;
                }
        }
        return path;
    }
    const $c2ae3b230f933dc6$export$6e91331b5debb7c8 = {
        routes: $c2ae3b230f933dc6$var$routes,
        convert: $c2ae3b230f933dc6$var$convert
    };
});
parcelRegister("hdJn1", function(module, exports) {
    $parcel$export(module.exports, "operationsConverter", ()=>$9b181cf5d70a46b3$export$7fc92455d5020e1);
    var $65Ltd;
    var $jhS4y;
    const $9b181cf5d70a46b3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_CUSTOM_ROLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL)
    ]);
    function $9b181cf5d70a46b3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ON_CALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL:
                {
                    path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ALERTS));
                    const { query: alarmQueue = '', view: view } = query;
                    view && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).ALARM_QUEUE(alarmQueue));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_REPORTS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_OVERVIEW));
                break;
            default:
                break;
        }
        return path;
    }
    const $9b181cf5d70a46b3$export$7fc92455d5020e1 = {
        routes: $9b181cf5d70a46b3$var$routes,
        convert: $9b181cf5d70a46b3$var$convert
    };
});
parcelRegister("2m3Yb", function(module, exports) {
    $parcel$export(module.exports, "topLevelConverter", ()=>$c60c27b55fbcd9c5$export$a33f2d74a674bf8a);
    var $65Ltd;
    var $jhS4y;
    const $c60c27b55fbcd9c5$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX)
    ]);
    function $c60c27b55fbcd9c5$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_YOUR_WORK));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_TEAMS));
                break;
            default:
        }
        return path;
    }
    const $c60c27b55fbcd9c5$export$a33f2d74a674bf8a = {
        routes: $c60c27b55fbcd9c5$var$routes,
        convert: $c60c27b55fbcd9c5$var$convert
    };
});
parcelRegister("3weqe", function(module, exports) {
    $parcel$export(module.exports, "overviewsConverter", ()=>$b8a10fc0a37e731b$export$5469f6c6536ca9c5);
    var $65Ltd;
    var $jhS4y;
    const $b8a10fc0a37e731b$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE)
    ]);
    function $b8a10fc0a37e731b$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS)
        ];
        routeName;
        {
            const { overviewId: overviewId } = match.params;
            overviewId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).OVERVIEW(overviewId));
        }
        return path;
    }
    const $b8a10fc0a37e731b$export$5469f6c6536ca9c5 = {
        routes: $b8a10fc0a37e731b$var$routes,
        convert: $b8a10fc0a37e731b$var$convert
    };
});
parcelRegister("c6hlO", function(module, exports) {
    $parcel$export(module.exports, "plansConverter", ()=>$a783e1b6f52291a3$export$3bde637b58016d1);
    var $65Ltd;
    var $jhS4y;
    const $a783e1b6f52291a3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK)
    ]);
    function $a783e1b6f52291a3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK:
                break;
            default:
                {
                    const { planId: planId } = match.params;
                    planId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PLAN(planId));
                }
        }
        return path;
    }
    const $a783e1b6f52291a3$export$3bde637b58016d1 = {
        routes: $a783e1b6f52291a3$var$routes,
        convert: $a783e1b6f52291a3$var$convert
    };
});
parcelRegister("3lNyZ", function(module, exports) {
    $parcel$export(module.exports, "projectsConverter", ()=>$6eaade1a69d23d1d$export$c41b724886e5872b);
    var $65Ltd;
    var $jhS4y;
    const $6eaade1a69d23d1d$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_ALL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_NOT_FOUND),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REQUESTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED)
    ]);
    function $6eaade1a69d23d1d$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING:
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE:
                {
                    const { projectKey: projectKey, appId: appId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECT_APPS));
                    appId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP(appId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_SUMMARY(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS:
                {
                    const { projectKey: projectKey, boardId: boardId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_VIEWS(projectKey));
                    boardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).BOARD(boardId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_VIEWS(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_CALENDAR(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_REPORTS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES:
                {
                    const { projectKey: projectKey } = match.params;
                    const filterId = query.filter || query.filterId;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    if (projectKey && filterId) {
                        path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_FILTERS(projectKey));
                        path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                    }
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW:
                {
                    const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && practiceType && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                    queueId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW:
                {
                    const { projectKey: projectKey, queueId: queueId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_QUEUES(projectKey));
                    queueId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_SERVICES(projectKey));
                    break;
                }
            default:
                {
                    const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    boardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).BOARD(boardId));
                    formId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FORM(formId));
                }
        }
        return path;
    }
    const $6eaade1a69d23d1d$export$c41b724886e5872b = {
        routes: $6eaade1a69d23d1d$var$routes,
        convert: $6eaade1a69d23d1d$var$convert
    };
});
parcelRegister("8bXrC", function(module, exports) {
    $parcel$export(module.exports, "roadmapsConverter", ()=>$8c39d6aa787bb969$export$5761942b1e0c2dd0);
    var $65Ltd;
    var $jhS4y;
    const $8c39d6aa787bb969$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS)
    ]);
    function $8c39d6aa787bb969$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS:
                {
                    const collectionId = match.params.collectionUUID;
                    if (collectionId) path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).ROADMAP(collectionId));
                    else path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS_VIEW_ALL));
                    break;
                }
            default:
        }
        return path;
    }
    const $8c39d6aa787bb969$export$5761942b1e0c2dd0 = {
        routes: $8c39d6aa787bb969$var$routes,
        convert: $8c39d6aa787bb969$var$convert
    };
});
parcelRegister("eReVn", function(module, exports) {
    $parcel$export(module.exports, "serviceManagementProjectSettingsConverter", ()=>$59806d8088c642c3$export$dd307ede503fe0e);
    var $65Ltd;
    var $2VkCP;
    var $bOhA4;
    var $2nb5R;
    var $040pa;
    var $YXuQ6;
    var $iQZ89;
    var $jhS4y;
    const $59806d8088c642c3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsLegacyAutomationRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAccessRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFeedbackRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFieldsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChatRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskEmailRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskExternalLinksRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskWidgetRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChangeManagementRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskClassicAppsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsVirtualAgentSettingsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsChatRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name,
        (0, (0, parcelRequire("2VkCP")).virtualAgentConversationsRoute).name,
        (0, (0, parcelRequire("2VkCP")).virtualAgentIntentsRoute).name,
        (0, (0, parcelRequire("2VkCP")).virtualAgentSettingsRoute).name,
        (0, (0, parcelRequire("2VkCP")).virtualAgentStandardFlowsRoute).name,
        (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsEmailRoute).name,
        (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name,
        (0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name,
        (0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
        (0, (0, parcelRequire("2nb5R")).routeGroupsProjectSettingsServicedeskKbRoute).name,
        (0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name,
        (0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
        (0, (0, parcelRequire("iQZ89")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIssuetypesRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name,
        (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskAutomationRoute).name,
        (0, (0, parcelRequire("040pa")).servicedeskSlaSettingsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name
    ]);
    function $59806d8088c642c3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAccessRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_ACCESS));
                break;
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name:
            case (0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
                break;
            case (0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS:
            case (0, (0, parcelRequire("iQZ89")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS:
            case (0, (0, parcelRequire("040pa")).servicedeskSlaSettingsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFeedbackRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIssuetypesRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFieldsRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsLegacyAutomationRoute).name:
            case (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskAutomationRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_AUTOMATION));
                break;
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskEmailRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChatRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskWidgetRoute).name:
            case (0, (0, parcelRequire("2nb5R")).routeGroupsProjectSettingsServicedeskKbRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskExternalLinksRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsChatRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsVirtualAgentSettingsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).virtualAgentIntentsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).virtualAgentStandardFlowsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).virtualAgentConversationsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).virtualAgentSettingsRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
                break;
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChangeManagementRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_OPERATIONS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS:
            case (0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
            case (0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsEmailRoute).name:
            case (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_NOTIFICATIONS));
                break;
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskClassicAppsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_APPS));
                break;
            default:
                break;
        }
        return path;
    }
    const $59806d8088c642c3$export$dd307ede503fe0e = {
        routes: $59806d8088c642c3$var$routes,
        convert: $59806d8088c642c3$var$convert
    };
});
parcelRegister("2VkCP", function(module, exports) {
    $parcel$export(module.exports, "getJsmProjectSettingsUrl", ()=>$2a557627656b882a$export$b7cec47cdf9c76f1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesRoute", ()=>$2a557627656b882a$export$666cdeccf1f430a6);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute", ()=>$2a557627656b882a$export$5ed718db41f9c966);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory", ()=>$2a557627656b882a$export$60b14f135c03f9c7);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFieldsRoute", ()=>$2a557627656b882a$export$87914ccacd42ab35);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAppsFieldsRoute", ()=>$2a557627656b882a$export$e382068c2b8a7b9f);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskApps1Route", ()=>$2a557627656b882a$export$7ae67c73ac5367a8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDetailsRoute", ()=>$2a557627656b882a$export$b237f4f6820b26e9);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRoute", ()=>$2a557627656b882a$export$f7e149bf217bbb2c);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRedirectRoute", ()=>$2a557627656b882a$export$eb1177fbc6c41b97);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute", ()=>$2a557627656b882a$export$f919d82b98f9257a);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute", ()=>$2a557627656b882a$export$ce59d5cb98345f8e);
    $parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", ()=>$2a557627656b882a$export$1a2228d5e07202a0);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDataClassificationsRoute", ()=>$2a557627656b882a$export$1596046a0b047934);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskClassicAppsRoute", ()=>$2a557627656b882a$export$3ab501c22b91462b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmFeaturesRoute", ()=>$2a557627656b882a$export$324e5a618f1ac5a1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute", ()=>$2a557627656b882a$export$e6f711e47860f891);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute", ()=>$2a557627656b882a$export$4ef3eecacde57780);
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", ()=>$2a557627656b882a$export$40539cb16771014e);
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", ()=>$2a557627656b882a$export$1f37a1aff4f594af);
    $parcel$export(module.exports, "projectSettingsServicedeskNotifications1Route", ()=>$2a557627656b882a$export$18c6f3890d9fd8b8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguageKeyRoute", ()=>$2a557627656b882a$export$d195c572a6155c05);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguage1Route", ()=>$2a557627656b882a$export$8152b460f5961d94);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute", ()=>$2a557627656b882a$export$e184fa302b6981b6);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute", ()=>$2a557627656b882a$export$dd22cfc45fe86c35);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute", ()=>$2a557627656b882a$export$b03f0a1a580a902f);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskEmailRoute", ()=>$2a557627656b882a$export$d29fa1140db9296d);
    $parcel$export(module.exports, "routeGroupsProjectSettingsLegacyAutomationRoute", ()=>$2a557627656b882a$export$abc6508b4dce2d9b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsVirtualAgentSettingsRoute", ()=>$2a557627656b882a$export$680ccfe6e5af63a8);
    $parcel$export(module.exports, "virtualAgentIntentsRoute", ()=>$2a557627656b882a$export$1e70273fc2a407f5);
    $parcel$export(module.exports, "virtualAgentStandardFlowsRoute", ()=>$2a557627656b882a$export$f45c942ecfcc5682);
    $parcel$export(module.exports, "virtualAgentConversationsRoute", ()=>$2a557627656b882a$export$837f003bb6f40f9);
    $parcel$export(module.exports, "virtualAgentSettingsRoute", ()=>$2a557627656b882a$export$80422a49e17dfd6b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPortalRoute", ()=>$2a557627656b882a$export$394d5ca6ce9e5949);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPortalSettingsRoute", ()=>$2a557627656b882a$export$e856498dc02e46e8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskExternalLinksRoute", ()=>$2a557627656b882a$export$d0198d2da30de212);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsWidgetRoute", ()=>$2a557627656b882a$export$fe54e02c94ff5613);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskWidgetRoute", ()=>$2a557627656b882a$export$164572fb58075291);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChangeManagementRoute", ()=>$2a557627656b882a$export$10089d339d8e30d1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIncidentManagementRoute", ()=>$2a557627656b882a$export$ff20eaee6cf19401);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsChatRoute", ()=>$2a557627656b882a$export$8e2543080acfc7c2);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChatRoute", ()=>$2a557627656b882a$export$3a3e70b8651d8d57);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannels5Route", ()=>$2a557627656b882a$export$77d19d35e71558b3);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFeedbackRoute", ()=>$2a557627656b882a$export$cd46cad965f517e2);
    $parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", ()=>$2a557627656b882a$export$10bafd1256118bb8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRedirectRoute", ()=>$2a557627656b882a$export$43b5b901d4988763);
    var $65Ltd;
    const $2a557627656b882a$var$SERVICE_DESK_PRODUCT = 'servicedesk';
    const $2a557627656b882a$export$b7cec47cdf9c76f1 = (projectKey)=>`/jira/${$2a557627656b882a$var$SERVICE_DESK_PRODUCT}/projects/${projectKey || ':projectKey'}/settings`;
    const $2a557627656b882a$var$jsmProjectSettingsUrl = $2a557627656b882a$export$b7cec47cdf9c76f1();
    const $2a557627656b882a$export$666cdeccf1f430a6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId?`,
        exact: true
    };
    const $2a557627656b882a$export$5ed718db41f9c966 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes-workflow`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId/:initialSection(workflow)`,
        exact: true
    };
    const $2a557627656b882a$export$60b14f135c03f9c7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-request-types-work-category`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/request-types/category/:practice`,
        exact: true
    };
    const $2a557627656b882a$export$87914ccacd42ab35 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-fields`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/fields`,
        exact: true
    };
    const $2a557627656b882a$export$e382068c2b8a7b9f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps-fields`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/app-fields`,
        exact: true
    };
    const $2a557627656b882a$export$7ae67c73ac5367a8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/:appId?`,
        exact: true
    };
    const $2a557627656b882a$export$b237f4f6820b26e9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/details`,
        exact: true
    };
    const $2a557627656b882a$export$f7e149bf217bbb2c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/access`,
        exact: true
    };
    const $2a557627656b882a$export$eb1177fbc6c41b97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access-redirect`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/people`,
        exact: true
    };
    const $2a557627656b882a$export$f919d82b98f9257a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-project-forms`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/forms`,
        exact: true
    };
    const $2a557627656b882a$export$ce59d5cb98345f8e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-jira-form-builder`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/forms/form/:templateFormId/edit`,
        exact: true
    };
    const $2a557627656b882a$export$1a2228d5e07202a0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/automate`
    };
    const $2a557627656b882a$export$1596046a0b047934 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-data-classifications`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/data-classifications`,
        exact: true
    };
    const $2a557627656b882a$export$3ab501c22b91462b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-classic-apps`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps`,
        exact: true
    };
    const $2a557627656b882a$export$324e5a618f1ac5a1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-features`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/itsm-features`,
        exact: true
    };
    const $2a557627656b882a$export$e6f711e47860f891 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-internal-notifications`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications/internal-notifications`
    };
    const $2a557627656b882a$export$4ef3eecacde57780 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/internal-notifications`
    };
    const $2a557627656b882a$export$40539cb16771014e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications/notification-email`,
        exact: true
    };
    const $2a557627656b882a$export$1f37a1aff4f594af = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notification-email`,
        exact: true
    };
    const $2a557627656b882a$export$18c6f3890d9fd8b8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications`,
        exact: true
    };
    const $2a557627656b882a$export$d195c572a6155c05 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language-key`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/language/:languageKey/:sidebarItemKey?`
    };
    const $2a557627656b882a$export$8152b460f5961d94 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/language`,
        exact: true
    };
    const $2a557627656b882a$export$e184fa302b6981b6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-permissions-next-gen`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/customer-permissions`,
        exact: true
    };
    const $2a557627656b882a$export$dd22cfc45fe86c35 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/customer-permissions`,
        exact: true
    };
    const $2a557627656b882a$export$b03f0a1a580a902f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-email-next-gen`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/email`,
        exact: true
    };
    const $2a557627656b882a$export$d29fa1140db9296d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/email`,
        exact: true
    };
    const $2a557627656b882a$export$abc6508b4dce2d9b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/automation`,
        exact: true
    };
    const $2a557627656b882a$export$680ccfe6e5af63a8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent`,
        exact: true
    };
    const $2a557627656b882a$export$1e70273fc2a407f5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-intents`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/intents`,
        exact: true
    };
    const $2a557627656b882a$export$f45c942ecfcc5682 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-standard-flows`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/standard-flows`,
        exact: true
    };
    const $2a557627656b882a$export$837f003bb6f40f9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-conversations`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/conversations`,
        exact: true
    };
    const $2a557627656b882a$export$80422a49e17dfd6b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-settings`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/settings`,
        exact: true
    };
    const $2a557627656b882a$export$394d5ca6ce9e5949 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-portal`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/portal-settings`,
        exact: true
    };
    const $2a557627656b882a$export$e856498dc02e46e8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/portal-settings/:subPath(portal-groups)?`,
        exact: true
    };
    const $2a557627656b882a$export$d0198d2da30de212 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-external-links`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/external-links`,
        exact: true
    };
    const $2a557627656b882a$export$fe54e02c94ff5613 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-widget`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/widget`,
        exact: true
    };
    const $2a557627656b882a$export$164572fb58075291 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/widget`,
        exact: true
    };
    const $2a557627656b882a$export$10089d339d8e30d1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-change-management`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/change-management`,
        exact: true
    };
    const $2a557627656b882a$export$ff20eaee6cf19401 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-incident-management`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/incident-management`,
        exact: true
    };
    const $2a557627656b882a$export$8e2543080acfc7c2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-chat`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/chat`,
        exact: true
    };
    const $2a557627656b882a$export$3a3e70b8651d8d57 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/chat`,
        exact: true
    };
    const $2a557627656b882a$export$77d19d35e71558b3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels`,
        exact: true
    };
    const $2a557627656b882a$export$cd46cad965f517e2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-feedback`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/feedback-settings`
    };
    const $2a557627656b882a$export$10bafd1256118bb8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/:appId/:envId/:route?`
    };
    const $2a557627656b882a$export$43b5b901d4988763 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-redirect`,
        path: $2a557627656b882a$var$jsmProjectSettingsUrl
    };
});
parcelRegister("bOhA4", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute", ()=>$2d3fa729818e1379$export$7fc567ce6cdc6b52);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute", ()=>$2d3fa729818e1379$export$688d2c8abd7b3661);
    var $65Ltd;
    const $2d3fa729818e1379$export$5575497f0592ee94 = 'servicedesk';
    const $2d3fa729818e1379$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $2d3fa729818e1379$export$7fc567ce6cdc6b52 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS),
        path: `${$2d3fa729818e1379$var$projectSettingsUrl($2d3fa729818e1379$export$5575497f0592ee94)}/customer-notifications`
    };
    const $2d3fa729818e1379$export$688d2c8abd7b3661 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-customer-notifications`,
        path: `${$2d3fa729818e1379$var$projectSettingsUrl($2d3fa729818e1379$export$5575497f0592ee94)}/notifications/customer-notifications`
    };
});
parcelRegister("2nb5R", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskKbRoute", ()=>$787a3748538c85bb$export$8855316927afaed1);
    var $65Ltd;
    const $787a3748538c85bb$export$5575497f0592ee94 = 'servicedesk';
    const $787a3748538c85bb$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $787a3748538c85bb$export$8855316927afaed1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-kb`,
        path: `${$787a3748538c85bb$var$projectSettingsUrl($787a3748538c85bb$export$5575497f0592ee94)}/confluence-kb`,
        exact: true
    };
});
parcelRegister("040pa", function(module, exports) {
    $parcel$export(module.exports, "servicedeskSlaSettingsRoute", ()=>$b24230704c8d21b6$export$bfbf66468910573e);
    var $65Ltd;
    const $b24230704c8d21b6$export$5575497f0592ee94 = 'servicedesk';
    const $b24230704c8d21b6$export$bfbf66468910573e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
    };
});
parcelRegister("YXuQ6", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute", ()=>$810950199d0bd223$export$cd0f363eecbc2379);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmTicketTypesConfigRoute", ()=>$810950199d0bd223$export$96fd54e139924473);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute", ()=>$810950199d0bd223$export$1eebd582a7db1c90);
    var $65Ltd;
    const $810950199d0bd223$export$5575497f0592ee94 = 'servicedesk';
    const $810950199d0bd223$export$cd0f363eecbc2379 = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-types-config`,
        path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned`
    };
    const $810950199d0bd223$export$96fd54e139924473 = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-types-config`,
        path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice`
    };
    const $810950199d0bd223$export$1eebd582a7db1c90 = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-types-config`,
        path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types`
    };
});
parcelRegister("iQZ89", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsWorkflowSchemeConfigRoute", ()=>$c6b26f9ea53dbefe$export$ad30542ae2fd7196);
    var $65Ltd;
    const $c6b26f9ea53dbefe$export$ad30542ae2fd7196 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-workflow-scheme-config`,
        path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
        exact: true
    };
});
parcelRegister("fMcVX", function(module, exports) {
    $parcel$export(module.exports, "isSelectedPath", ()=>$ad785f9726254880$export$cdcd6885320eec31);
    var $lhMtU;
    function $ad785f9726254880$export$cdcd6885320eec31(path, ...args) {
        const next = (menuId)=>{
            return (0, (0, parcelRequire("lhMtU")).isMenuIdList)(menuId) ? (0, (0, parcelRequire("lhMtU")).toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
        };
        if (args.length === 0) return next;
        return next(args[0]);
    }
});
parcelRegister("lhMtU", function(module, exports) {
    $parcel$export(module.exports, "toMenuIdFromMenuIdList", ()=>$dc9d941dfadd4b5a$export$253323efd0c41e72);
    $parcel$export(module.exports, "isMenuIdList", ()=>$dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed);
    $parcel$export(module.exports, "toMenuIdList", ()=>$dc9d941dfadd4b5a$export$d8e017f58178e379);
    const $dc9d941dfadd4b5a$var$MENU_ID_DELIM = '   ';
    function $dc9d941dfadd4b5a$export$253323efd0c41e72(menuIds) {
        return menuIds.join($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
    }
    function $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
        return maybeMenuIdList.indexOf($dc9d941dfadd4b5a$var$MENU_ID_DELIM) !== -1;
    }
    function $dc9d941dfadd4b5a$export$d8e017f58178e379(menuIdList) {
        return menuIdList.split($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
    }
});
parcelRegister("2OeZv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70949048397986dd$export$2e2bcd8739ae039);
    const $70949048397986dd$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isAppsExpanded"
        }, v2 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDashboardsExpanded"
        }, v3 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isFiltersExpanded"
        }, v4 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOperationsExpanded"
        }, v5 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOverviewsExpanded"
        }, v6 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPlansExpanded"
        }, v7 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isProjectsExpanded"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9
        ], v11 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v12 = {
            "kind": "ScalarField",
            "name": "label"
        }, v13 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v14 = {
            "kind": "ScalarField",
            "name": "url"
        }, v15 = {
            "order": "DESC"
        }, v16 = {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }, v17 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v18 = {
            "kind": "ScalarField",
            "name": "name"
        }, v19 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v20 = {
            "kind": "InlineFragment",
            "selections": [
                v8
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v21 = [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ], v22 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v23 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v24 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "alias": "projectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "large"
                                    }
                                ]
                            },
                            v18,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            v19,
                            {
                                "kind": "LinkedField",
                                "name": "defaultNavigationItem",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "typeKey"
                                            }
                                        ],
                                        "type": "JiraNavigationItem",
                                        "abstractKey": "__isJiraNavigationItem"
                                    },
                                    v20
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "navigationMetadata",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "boardId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isSimpleBoard"
                                            },
                                            v8
                                        ],
                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                    }
                                ]
                            },
                            {
                                "alias": "editProjectConfig",
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            },
                            {
                                "alias": "canEditProjectConfig",
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "alias": "canViewProjectConfig",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CONFIG"
                                    }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                            },
                            v23,
                            {
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "softwareBoardCount"
                            }
                        ],
                        "type": "JiraProject"
                    },
                    v20
                ]
            }
        ], v25 = {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }, v26 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v27 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        v11,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v8
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }, v29 = {
            "kind": "ScalarField",
            "name": "title"
        }, v30 = {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                v19,
                v8
            ]
        }, v31 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "kind": "ScalarField",
                                "name": "planId"
                            },
                            v29,
                            {
                                "kind": "ScalarField",
                                "name": "isReadOnly"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "planStatus"
                            },
                            v30,
                            {
                                "concreteType": "JiraScenario",
                                "kind": "LinkedField",
                                "name": "scenario",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scenarioId"
                                    },
                                    v8
                                ]
                            }
                        ],
                        "type": "JiraPlan"
                    },
                    v20
                ]
            }
        ], v32 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "kind": "ScalarField",
                                "name": "dashboardId"
                            },
                            v29,
                            v30
                        ],
                        "type": "JiraDashboard"
                    },
                    v20
                ]
            }
        ], v33 = [
            v8,
            v18,
            {
                "kind": "ScalarField",
                "name": "alertSearchQuery"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ConfigurableMenuItems"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v6,
                    v7,
                    v4,
                    v5
                ],
                "kind": "Operation",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudID",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "navKey",
                                        "value": "NAV_SIDEBAR"
                                    }
                                ],
                                "concreteType": "JiraUserNavigationConfiguration",
                                "kind": "LinkedField",
                                "name": "userNavigationConfiguration",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfigurableNavigationItem",
                                        "kind": "LinkedField",
                                        "name": "navItems",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "menuId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isVisible"
                                            }
                                        ]
                                    },
                                    v8
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "canCreateProject",
                                "args": [
                                    v9,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "CREATE_PROJECT"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            {
                                "condition": "isAppsExpanded",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "globalAppNavigationItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v12,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appType"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "envLabel"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "iconUrl"
                                                                    },
                                                                    v13,
                                                                    {
                                                                        "concreteType": "JiraAppSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "sections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v12,
                                                                                    v14,
                                                                                    v13
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "settingsUrl"
                                                                    },
                                                                    v14
                                                                ],
                                                                "type": "JiraAppNavigationItem"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v10,
                                "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                "kind": "LinkedField",
                                "name": "jwmOverviews",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v10,
                                "concreteType": "JiraAdvancedRoadmapsNavigation",
                                "kind": "LinkedField",
                                "name": "advancedRoadmapsNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasEditPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasCreateSamplePlanPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasGlobalPlansAdminPermissions"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isProjectsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v24
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentProjects",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PROJECT"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v24
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "args": v10,
                                        "concreteType": "JiraWorkManagementLicensing",
                                        "kind": "LinkedField",
                                        "name": "jwmLicensing",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "currentUserSeatEdition"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isFiltersExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteFilters",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "FILTER"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v26,
                                                                    v18,
                                                                    v8,
                                                                    v19,
                                                                    v27,
                                                                    v28
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            },
                                                            v20
                                                        ]
                                                    }
                                                ]
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentFilters",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "FILTER"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v26,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v18,
                                                                            v8,
                                                                            v19,
                                                                            v27,
                                                                            v28
                                                                        ],
                                                                        "type": "JiraFilter",
                                                                        "abstractKey": "__isJiraFilter"
                                                                    }
                                                                ],
                                                                "type": "JiraCustomFilter"
                                                            },
                                                            v20
                                                        ]
                                                    }
                                                ]
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "args": v10,
                                        "concreteType": "JiraSystemFilterConnection",
                                        "kind": "LinkedField",
                                        "name": "systemFilters",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilterEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraSystemFilter",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v26,
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v18,
                                                                    v11,
                                                                    v19,
                                                                    v27,
                                                                    v28
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isPlansExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouritePlans",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "PLAN"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentPlans",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PLAN"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v23
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isDashboardsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "dashboardFavourites",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "DASHBOARD"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "dashboardRecents",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "DASHBOARD"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            v23
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOperationsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "OpsgenieQuery",
                                "kind": "LinkedField",
                                "name": "opsgenie",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "OpsgenieSavedSearches",
                                        "kind": "LinkedField",
                                        "name": "savedSearches",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "sharedWithMe",
                                                "plural": true,
                                                "selections": v33
                                            },
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "createdByMe",
                                                "plural": true,
                                                "selections": v33
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOverviewsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                        "kind": "LinkedField",
                                        "name": "jwmOverviews",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraWorkManagementGiraOverview",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v18
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5ad34dbd3295f1e92b107036d33e96821560910a345245b86b33d7a7034dd31b",
                "metadata": {},
                "name": "L1MenuItemsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $70949048397986dd$var$node.hash = "3924b1f11b61ac6cf33dddcea40b965b";
    var $70949048397986dd$export$2e2bcd8739ae039 = $70949048397986dd$var$node;
});
parcelRegister("fZBia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c8513a288fea00$export$2e2bcd8739ae039);
    const $79c8513a288fea00$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "isLeftSidebarCollapsed"
        }, v3 = {
            "kind": "ScalarField",
            "name": "leftSidebarWidth"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.leftSidebarWidth"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8",
                "metadata": {},
                "name": "sidebarSelectorQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $79c8513a288fea00$var$node.hash = "e5c64c6d4b80524f3da4efcb8ecca3f4";
    var $79c8513a288fea00$export$2e2bcd8739ae039 = $79c8513a288fea00$var$node;
});
parcelRegister("h9iZl", function(module, exports) {
    $parcel$export(module.exports, "navigationPlansVisibilityResource", ()=>$66eb980ebca35ddf$export$fa475a9581133779);
    $parcel$export(module.exports, "useNavigationPlansVisibility", ()=>$66eb980ebca35ddf$export$4524245d4e74edb2);
    $parcel$export(module.exports, "useNavigationViewPlansPermission", ()=>$66eb980ebca35ddf$export$98eef08fd4586a4);
    $parcel$export(module.exports, "useNavigationEditPlansPermission", ()=>$66eb980ebca35ddf$export$525db876ed776e0d);
    $parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", ()=>$66eb980ebca35ddf$export$54805a2120a31ad0);
    var $dJl1T;
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    const $66eb980ebca35ddf$export$fa475a9581133779 = (0, $dIdda.createResource)({
        type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return false;
                const response = await (0, (0, parcelRequire("7f4tk")).default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
                return response;
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
            }
            return false;
        },
        maxAge: Infinity
    });
    const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isVisible = false;
        if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
        return [
            isVisible
        ];
    };
    const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let hasEditOrViewPermissions = false;
        if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
        return [
            hasEditOrViewPermissions
        ];
    };
    const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let canEditPlans = false;
        if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
        return canEditPlans;
    };
    const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isAdvancedRoadmapsTrial = false;
        if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
        return isAdvancedRoadmapsTrial;
    };
});
const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';
parcelRegister("2eyDn", function(module, exports) {
    $parcel$export(module.exports, "consentBannerUserPreferencesResource", ()=>$7912ae5bd04d670f$export$785c22104b6f2285);
    $parcel$export(module.exports, "useConsentBannerUserPreferencesResource", ()=>$7912ae5bd04d670f$export$5bc7e83e85567fb4);
    var $e7OnS;
    var $3TzYp;
    var $4R6GH;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $7912ae5bd04d670f$export$785c22104b6f2285 = (0, $dIdda.createResource)({
        type: (0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b),
        getKey: ()=>(0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155),
        getData: async ()=>{
            const consentToken = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_COOKIE_KEY));
            const fallbackConsentToken = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if ((0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-browser-storage-bump-3')) {
                if (consentToken) return {
                    consentToken: consentToken,
                    fallbackConsentToken: fallbackConsentToken
                };
            } else {
                const currentLocale = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
                if (consentToken && currentLocale) return {
                    consentToken: consentToken,
                    currentLocale: currentLocale,
                    fallbackConsentToken: fallbackConsentToken
                };
            }
            const data = await (0, (0, parcelRequire("eusud")).performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
            return data;
        },
        maxAge: 900000,
        isBrowserOnly: true
    });
    const $7912ae5bd04d670f$export$5bc7e83e85567fb4 = ()=>(0, $dIdda.useResource)($7912ae5bd04d670f$export$785c22104b6f2285);
});
parcelRegister("e7OnS", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", ()=>$a488cd5ca5197429$export$10d7db8e1a856fd8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", ()=>$a488cd5ca5197429$export$435de28e5b000487);
    $parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", ()=>$a488cd5ca5197429$export$4b17acc0e875ba2a);
    $parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", ()=>$a488cd5ca5197429$export$f57af01b64fc97b8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", ()=>$a488cd5ca5197429$export$23a1e02c3c0b0d08);
    $parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", ()=>$a488cd5ca5197429$export$37073d560ecebada);
    $parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", ()=>$a488cd5ca5197429$export$b28b5d760fe14a21);
    $parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", ()=>$a488cd5ca5197429$export$4a12f9e99971760a);
    $parcel$export(module.exports, "DEFAULT_PREFERENCES", ()=>$a488cd5ca5197429$export$f0fd1d13ec1d48f2);
    $parcel$export(module.exports, "V001_SCHEMA_KEY", ()=>$a488cd5ca5197429$export$f95182b7aa141c57);
    $parcel$export(module.exports, "V002_SCHEMA_KEY", ()=>$a488cd5ca5197429$export$1f25427b34f9c405);
    $parcel$export(module.exports, "V003_SCHEMA_KEY", ()=>$a488cd5ca5197429$export$31deaeaebce525bb);
    var $iG1qD;
    const $a488cd5ca5197429$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
    const $a488cd5ca5197429$export$435de28e5b000487 = 'atl-bsc-consent-token';
    const $a488cd5ca5197429$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
    const $a488cd5ca5197429$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
    const $a488cd5ca5197429$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
    const $a488cd5ca5197429$export$37073d560ecebada = 'atl-testing-consents';
    const $a488cd5ca5197429$export$b28b5d760fe14a21 = {
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]: true
    };
    const $a488cd5ca5197429$export$4a12f9e99971760a = {
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]: false,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]: false,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]: false,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]: false
    };
    const $a488cd5ca5197429$export$f0fd1d13ec1d48f2 = {
        ...$a488cd5ca5197429$export$4a12f9e99971760a,
        [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentsAreDefault]: true,
        [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).UserIsAuthenticated]: false,
        [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable]: true
    };
    const $a488cd5ca5197429$export$f95182b7aa141c57 = '001';
    const $a488cd5ca5197429$export$1f25427b34f9c405 = '002';
    const $a488cd5ca5197429$export$31deaeaebce525bb = '003';
});
parcelRegister("iG1qD", function(module, exports) {
    $parcel$export(module.exports, "PreferenceCategory", ()=>$d98d41ec52002465$export$ba064dbfe4bb66d7);
    $parcel$export(module.exports, "ConsentPreferenceV2", ()=>$d98d41ec52002465$export$cdef20bac194f235);
    $parcel$export(module.exports, "ContextualConsentProperty", ()=>$d98d41ec52002465$export$fac80ad19b60e313);
    $parcel$export(module.exports, "PrefetchedPreferenceState", ()=>$d98d41ec52002465$export$5d6594a0bba4ab8a);
    $parcel$export(module.exports, "CachedKeysDataProperty", ()=>$d98d41ec52002465$export$cd5dd043a4a3cfee);
    $parcel$export(module.exports, "Status", ()=>$d98d41ec52002465$export$96e9906d6d93a972);
    let $d98d41ec52002465$export$ba064dbfe4bb66d7 = function(PreferenceCategory) {
        PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
        PreferenceCategory["Functional"] = "FUNCTIONAL";
        PreferenceCategory["Marketing"] = "MARKETING";
        PreferenceCategory["Analytics"] = "ANALYTICS";
        PreferenceCategory["Unknown"] = "UNKNOWN";
        return PreferenceCategory;
    }({});
    let $d98d41ec52002465$export$cdef20bac194f235 = function(ConsentPreferenceV2) {
        ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
        ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
        ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
        ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
        ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
        return ConsentPreferenceV2;
    }({});
    let $d98d41ec52002465$export$fac80ad19b60e313 = function(ContextualConsentProperty) {
        ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
        ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
        ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
        return ContextualConsentProperty;
    }({});
    let $d98d41ec52002465$export$5d6594a0bba4ab8a = function(PrefetchedPreferenceState) {
        PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
        return PrefetchedPreferenceState;
    }({});
    let $d98d41ec52002465$export$cd5dd043a4a3cfee = function(CachedKeysDataProperty) {
        CachedKeysDataProperty["LocalStorage"] = "localStorageKeys";
        CachedKeysDataProperty["SessionStorage"] = "sessionStorageKeys";
        CachedKeysDataProperty["Cookies"] = "keys";
        CachedKeysDataProperty["ThirdParty"] = "thirdPartyKeys";
        return CachedKeysDataProperty;
    }({});
    let $d98d41ec52002465$export$96e9906d6d93a972 = function(Status) {
        Status["SUCCESS"] = "SUCCESS";
        Status["BLOCKED"] = "BLOCKED";
        Status["FAILED"] = "FAILED";
        return Status;
    }({});
});
const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';
parcelRegister("drGWM", function(module, exports) {
    $parcel$export(module.exports, "checkApiKeyManagementKeysResource", ()=>$ea67ffb8a72e0299$export$b16eaa5246afc9b6);
    var $j74qU;
    var $3H5ry;
    var $dIdda = parcelRequire("dIdda");
    const $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
        if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
    };
    const $ea67ffb8a72e0299$export$b16eaa5246afc9b6 = ()=>(0, $dIdda.createResource)({
            type: (0, $9b8f6422d397a375$export$5879151f0d972f18),
            getKey: ()=>'check-api-key-management-keys',
            getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
                const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
                const isTransitioning = (0, (0, parcelRequire("3H5ry")).checkIsTransitioning)(tenantInfo);
                return $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
            },
            maxAge: Infinity,
            isBrowserOnly: true,
            depends: [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]
        });
});
parcelRegister("j74qU", function(module, exports) {
    $parcel$export(module.exports, "eocFetch", ()=>$e038c50dbacfc9f4$export$212b9c60150b5a0a);
    var $bFU4G;
    var $aI12f;
    var $030R0;
    const $e038c50dbacfc9f4$export$212b9c60150b5a0a = (input, init)=>{
        let headers = init?.headers ?? {};
        let body = init?.body;
        if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
            body = JSON.stringify(body);
            headers['Content-Type'] = 'application/json';
        }
        if (typeof input === 'string') input = (0, (0, parcelRequire("030R0")).withPrefix)(input, init);
        else input = {
            ...input,
            url: (0, (0, parcelRequire("030R0")).withPrefix)(input.url, init)
        };
        const errorTransformer = init?.errorTransformer ?? (0, (0, parcelRequire("030R0")).defaultErrorTransformer);
        const startTime = performance.now();
        return fetch(input, {
            headers: headers,
            ...init,
            body: body
        }).catch((error)=>{
            throw new (0, (0, parcelRequire("aI12f")).NetworkError)(error.name, error);
        }).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("aI12f")).HTTPError)(response);
            const sanitizedUrl = (0, (0, parcelRequire("030R0")).sanitizeUrlString)((0, (0, parcelRequire("030R0")).getRequestUrl)(input));
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now());
            switch(init?.responseType){
                case undefined:
                case 'json':
                    return response.json();
                case 'blob':
                    return response.blob();
                case 'text':
                    return response.text();
                case 'headers':
                    return response;
            }
        }).catch((error)=>{
            if ((0, (0, parcelRequire("aI12f")).isNetworkError)(error)) {
                const transformerResult = errorTransformer(error);
                if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                    throw finalError;
                });
                else throw transformerResult;
            }
            throw error;
        });
    };
});
parcelRegister("aI12f", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$c2cf5dfa0e96b9de$export$bae979e68e4dc802);
    $parcel$export(module.exports, "HTTPError", ()=>$c2cf5dfa0e96b9de$export$aa9d629c530f62a7);
    $parcel$export(module.exports, "StreamedHTTPError", ()=>$c2cf5dfa0e96b9de$export$c30b5b02747d791c);
    $parcel$export(module.exports, "isHTTPError", ()=>$c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f);
    $parcel$export(module.exports, "isNetworkError", ()=>$c2cf5dfa0e96b9de$export$476aa014e2fd89d5);
    $parcel$export(module.exports, "isStreamedHTTPError", ()=>$c2cf5dfa0e96b9de$export$4f52fcea95c8f97d);
    var $60Rff;
    class $c2cf5dfa0e96b9de$export$bae979e68e4dc802 extends Error {
        constructor(name, cause){
            super('Network Error!');
            this.name = name;
            this.cause = cause;
        }
    }
    class $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 extends $c2cf5dfa0e96b9de$export$bae979e68e4dc802 {
        constructor(response){
            super((0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError);
            this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
            this.response = response;
        }
    }
    class $c2cf5dfa0e96b9de$export$c30b5b02747d791c extends $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 {
        constructor(cause, data, message){
            super(cause.response);
            this.cause = cause;
            this.data = data;
            this.message = message;
            this.message = message;
            this.name = (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError;
        }
    }
    const $c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 || [
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError
        ].includes(candidate.name);
    const $c2cf5dfa0e96b9de$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$bae979e68e4dc802 || [
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).NetworkError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError
        ].includes(candidate.name);
    const $c2cf5dfa0e96b9de$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$c30b5b02747d791c || candidate?.name === (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError;
});
parcelRegister("60Rff", function(module, exports) {
    $parcel$export(module.exports, "ERROR_NAMES", ()=>$3500a6ac498ab4f6$export$daceac3b97803ce1);
    var $3500a6ac498ab4f6$export$daceac3b97803ce1;
    (function(ERROR_NAMES) {
        ERROR_NAMES["HTTPError"] = "HTTPError";
        ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
        ERROR_NAMES["NetworkError"] = "NetworkError";
    })($3500a6ac498ab4f6$export$daceac3b97803ce1 || ($3500a6ac498ab4f6$export$daceac3b97803ce1 = {}));
});
parcelRegister("030R0", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$bc491f1610486b68$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "withPrefix", ()=>$bc491f1610486b68$export$44188c5f179c4553);
    $parcel$export(module.exports, "defaultErrorTransformer", ()=>$bc491f1610486b68$export$270fcc0e5df09fdd);
    $parcel$export(module.exports, "jsmErrorTransformer", ()=>$bc491f1610486b68$export$994cc82144d28ded);
    $parcel$export(module.exports, "getRequestUrl", ()=>$bc491f1610486b68$export$14619c0eed01a470);
    $parcel$export(module.exports, "sanitizeUrlString", ()=>$bc491f1610486b68$export$ceb09b958e605eff);
    var $gIuON;
    var $aI12f;
    let $bc491f1610486b68$var$metaCloudId;
    let $bc491f1610486b68$var$isJSMAvailable = true;
    function $bc491f1610486b68$export$c47913ca32a5c6f7(name) {
        const globalVariable = window ?? $parcel$global;
        if ((0, (0, parcelRequire("gIuON")).isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
        if ($bc491f1610486b68$var$metaCloudId) return $bc491f1610486b68$var$metaCloudId;
        if ($bc491f1610486b68$var$isJSMAvailable) {
            const element = document.querySelector(`meta[name="${name}"]`);
            $bc491f1610486b68$var$metaCloudId = element?.getAttribute('content') ?? undefined;
            $bc491f1610486b68$var$isJSMAvailable = !!$bc491f1610486b68$var$metaCloudId;
        }
        return $bc491f1610486b68$var$metaCloudId;
    }
    function $bc491f1610486b68$export$5a75f4aeb58ba80f(id) {
        $bc491f1610486b68$var$metaCloudId = id;
    }
    function $bc491f1610486b68$export$44188c5f179c4553(input, init) {
        if (init?.exactUrl) return input;
        if (window.__OG__) return '/webapi' + input;
        const cloudId = $bc491f1610486b68$export$c47913ca32a5c6f7('ajs-cloud-id');
        if (cloudId) return (0, $2021409bef50eca5$export$3414665826fa030e) + cloudId + input;
        return input;
    }
    const $bc491f1610486b68$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
    const $bc491f1610486b68$export$270fcc0e5df09fdd = (e)=>{
        if (e instanceof (0, (0, parcelRequire("aI12f")).HTTPError)) {
            const contentType = e.response.headers.get('Content-Type');
            if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
            return e.response.text().then((message)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, message, message));
        }
        return e;
    };
    const $bc491f1610486b68$export$994cc82144d28ded = (error)=>{
        if (error instanceof (0, (0, parcelRequire("aI12f")).HTTPError)) {
            const contentType = error.response.headers.get('Content-Type');
            if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(error, data, data.errorMessages.join(',')));
            return error.response.text().then((message)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(error, message, message));
        }
        return error;
    };
    const $bc491f1610486b68$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
    const $bc491f1610486b68$export$ceb09b958e605eff = (url)=>{
        const urlWithoutQueryParams = url.replace(/\?.*$/, '');
        const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
        return urlWithoutUUIDs;
    };
});
parcelRegister("gIuON", function(module, exports) {
    $parcel$export(module.exports, "isServer", ()=>$a110d4649f6250fb$export$6acf61af03e62db);
    const $a110d4649f6250fb$export$6acf61af03e62db = ()=>{
        try {
            return false;
        } catch (error) {
            return globalThis.false ?? false;
        }
    };
});
const $2021409bef50eca5$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';
parcelRegister("3H5ry", function(module, exports) {
    $parcel$export(module.exports, "checkShouldUseJSM", ()=>$bc03080c674ccba2$export$5e0f3a0d8463fa21);
    $parcel$export(module.exports, "checkIsTransitioning", ()=>$bc03080c674ccba2$export$d2f281fd4bf10855);
    $parcel$export(module.exports, "checkIsConsolidated", ()=>$bc03080c674ccba2$export$57f75aebff17dd1e);
    $parcel$export(module.exports, "checkIsTransitioned", ()=>$bc03080c674ccba2$export$b6461b23ee0e1471);
    $parcel$export(module.exports, "checkIsTransitionEligible", ()=>$bc03080c674ccba2$export$24040115cac5fdc3);
    $parcel$export(module.exports, "checkShouldAccessUnlockOperations", ()=>$bc03080c674ccba2$export$cd227238525e8d57);
    var $bgC2H;
    const $bc03080c674ccba2$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED;
    };
    const $bc03080c674ccba2$export$d2f281fd4bf10855 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONING;
    };
    const $bc03080c674ccba2$export$57f75aebff17dd1e = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED;
    };
    const $bc03080c674ccba2$export$b6461b23ee0e1471 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONED;
    };
    const $bc03080c674ccba2$export$24040115cac5fdc3 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1);
    };
    const $bc03080c674ccba2$export$cd227238525e8d57 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$a101f3562b5f0742));
    };
});
parcelRegister("bgC2H", function(module, exports) {
    $parcel$export(module.exports, "ConsolidationState", ()=>$927cd31b0e0ee4e8$export$9ef498b0a11fd37d);
    const $927cd31b0e0ee4e8$export$9ef498b0a11fd37d = {
        NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
        TRANSITIONING: 'TRANSITIONING',
        TRANSITIONED: 'TRANSITIONED',
        CONSOLIDATED: 'CONSOLIDATED'
    };
});
const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';
const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';
const $9b8f6422d397a375$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';
parcelRegister("kMiZJ", function(module, exports) {
    $parcel$export(module.exports, "consolidationUserStateResource", ()=>$1e0457dbe68ab17d$export$4b870505c49999ef);
    var $jcw0u;
    var $dIdda = parcelRequire("dIdda");
    var $9QTNT;
    const $1e0457dbe68ab17d$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
    const $1e0457dbe68ab17d$export$4b870505c49999ef = (0, $dIdda.createResource)({
        type: $1e0457dbe68ab17d$var$RESOURCE_KEY,
        getKey: ()=>$1e0457dbe68ab17d$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, (0, parcelRequire("9QTNT")).getOgConsolidationUserState)(accountId).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'consolidationUserStateResource',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }),
        maxAge: Infinity
    });
});
parcelRegister("9QTNT", function(module, exports) {
    $parcel$export(module.exports, "getOgConsolidationUserState", ()=>$1a9945d1ee35f024$export$df7594d56c9ebe57);
    var $89SaW;
    var $jcw0u;
    var $jJZqs;
    var $iXaZ3;
    const $1a9945d1ee35f024$export$df7594d56c9ebe57 = (accountId)=>{
        if (!accountId) return Promise.resolve((0, (0, parcelRequire("iXaZ3")).ERROR_CONSOLIDATION_USER_STATE));
        return (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, (0, parcelRequire("iXaZ3")).OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
            if (!val || typeof val !== 'object') {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getUserProperty',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: new (0, (0, parcelRequire("jJZqs")).ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return 0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE;
            }
            if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
                ...(0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE),
                ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE), key)))
            };
            if (!Object.keys((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) return {
                ...(0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE),
                ...val
            };
            return val;
        }).catch((error)=>{
            if (error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.statusCode === 404) return 0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE;
            throw error;
        });
    };
});
parcelRegister("iXaZ3", function(module, exports) {
    $parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", ()=>$58f10b27bad0d860$export$1980758e2622af02);
    $parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", ()=>$58f10b27bad0d860$export$51d9907e9d716d);
    $parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", ()=>$58f10b27bad0d860$export$23da4710c3a29eae);
    const $58f10b27bad0d860$export$1980758e2622af02 = 'eoc_consolidation_user_state';
    const $58f10b27bad0d860$export$51d9907e9d716d = {
        isPromotionBannerDismissed: false,
        isWelcomeModalDisplayed: false,
        isTransitionHomeHidden: false,
        isTransitionBannerDismissed: false,
        isBroadcastWidgetDismissed: false,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: false
    };
    const $58f10b27bad0d860$export$23da4710c3a29eae = {
        isPromotionBannerDismissed: true,
        isWelcomeModalDisplayed: true,
        isTransitionHomeHidden: true,
        isTransitionBannerDismissed: true,
        isBroadcastWidgetDismissed: true,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: true
    };
});
parcelRegister("bHhiy", function(module, exports) {
    $parcel$export(module.exports, "getConsolidationStateResource", ()=>$cd33a435a46904ef$export$a6cf5054d4f9f5dd);
    var $j74qU;
    var $co1wz;
    var $4R6GH;
    var $dIdda = parcelRequire("dIdda");
    var $bgC2H;
    const $cd33a435a46904ef$export$de6c19ae237c1eb9 = (cloudId, appPermissions)=>{
        let url = '/internal/v1/customers/tenant-info';
        if (cloudId) url = `${url}/${cloudId}`;
        else throw new Error('No tenant info exists.');
        let promise;
        if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
            promise = new Promise((resolve)=>{
                resolve({
                    consolidationState: (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED
                });
            });
            return promise;
        }
        if (false) promise = (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            exactUrl: true,
            headers: {
                'x-ssr-service-name': (0, (0, parcelRequire("4R6GH")).fg)('tenant-info-issuer-change') ? 'og-customer-int-api' : 'og-apigw-atlassian-gw'
            }
        });
        else promise = (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/customers/tenant-info').then(({ data: data })=>data);
        if ((0, (0, parcelRequire("co1wz")).ff)('eoc-tenant-info-hook_dq6ke')) return promise;
        return promise.then((response)=>response.consolidationState);
    };
    const $cd33a435a46904ef$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $dIdda.createResource)({
            type: (0, $5a94e356f9d5e220$export$25ee35b01de9d734),
            getKey: ()=>'tenantInformation',
            getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions } })=>$cd33a435a46904ef$export$de6c19ae237c1eb9(cloudId, appPermissions),
            maxAge: Infinity,
            isBrowserOnly: forceBrowser
        });
});
parcelRegister("aA974", function(module, exports) {
    $parcel$export(module.exports, "gicSmartFieldsFeatureResource", ()=>$d18db694553f5610$export$ee94bb1f59b07e35);
    $parcel$export(module.exports, "useIsSmartFieldsOptIn", ()=>$d18db694553f5610$export$3870b1ff1b155c73);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $aHuqL;
    var $dIdda = parcelRequire("dIdda");
    const $d18db694553f5610$export$ee94bb1f59b07e35 = (0, $dIdda.createResource)({
        type: (0, $814b0a0376a60368$export$6f0555de4f60e84e),
        getKey: ()=>(0, $814b0a0376a60368$export$7e7d7930e22ba39f),
        getData: async ()=>{
            try {
                const data = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $814b0a0376a60368$export$b94951a11282ae6a));
                if (!data) return {
                    hasUserOptedOut: false,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
                };
                return data;
            } catch (error) {
                if (error.statusCode === 404) return {
                    hasUserOptedOut: false,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'gicSmartFieldsFeatureResource',
                        packageName: (0, $814b0a0376a60368$export$b8b9d90f9e5bd72b),
                        teamName: 'deliveroo'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $d18db694553f5610$export$3870b1ff1b155c73 = ()=>{
        const { data: data, update: update, loading: loading } = (0, $dIdda.useResource)($d18db694553f5610$export$ee94bb1f59b07e35);
        const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
        const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
        const currentDismissedGicOnboarding = (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false : undefined;
        const dismissReadMore = (0, $5uXOq.useCallback)(()=>{
            update((previousData)=>({
                    ...previousData?.hasUserOptedOut ? {
                        hasUserOptedOut: previousData.hasUserOptedOut
                    } : {
                        hasUserOptedOut: false
                    },
                    hasUserDismissedReadMore: true,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? previousData?.hasUserDismissedGicOnboarding ? {
                        hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                    } : {
                        hasUserDismissedGicOnboarding: false
                    } : {}
                }));
        }, [
            update
        ]);
        const dismissGicOnboarding = (0, $5uXOq.useCallback)(()=>{
            update((previousData)=>({
                    ...previousData?.hasUserOptedOut ? {
                        hasUserOptedOut: previousData.hasUserOptedOut
                    } : {
                        hasUserOptedOut: false
                    },
                    ...previousData?.hasUserDismissedReadMore ? {
                        hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                    } : {
                        hasUserDismissedReadMore: false
                    },
                    hasUserDismissedGicOnboarding: true
                }));
        }, [
            update
        ]);
        return {
            isSmartFieldsOptIn: loading ? null : currentOptInStatus,
            isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
            isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
            dismissReadMore: dismissReadMore,
            dismissGicOnboarding: dismissGicOnboarding,
            loading: loading
        };
    };
});
parcelRegister("aHuqL", function(module, exports) {
    $parcel$export(module.exports, "userPreferenceAPI", ()=>$0f87ed1c6d708024$export$4f7929ca6b50a436);
    var $eusud;
    const $0f87ed1c6d708024$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
    const $0f87ed1c6d708024$var$get = async (key)=>{
        try {
            const result = await (0, (0, parcelRequire("eusud")).performGetRequest)($0f87ed1c6d708024$var$url(key));
            return result?.value;
        } catch (error) {
            if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
            throw error;
        }
    };
    const $0f87ed1c6d708024$var$set = (key, value)=>(0, (0, parcelRequire("eusud")).performPutRequest)($0f87ed1c6d708024$var$url(key), {
            body: JSON.stringify({
                value: value
            })
        });
    const $0f87ed1c6d708024$var$remove = (key)=>(0, (0, parcelRequire("eusud")).performDeleteRequest)($0f87ed1c6d708024$var$url(key));
    const $0f87ed1c6d708024$export$4f7929ca6b50a436 = {
        get: $0f87ed1c6d708024$var$get,
        set: $0f87ed1c6d708024$var$set,
        remove: $0f87ed1c6d708024$var$remove
    };
});
const $814b0a0376a60368$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $814b0a0376a60368$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key';
const $814b0a0376a60368$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $814b0a0376a60368$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';
parcelRegister("f5nIZ", function(module, exports) {
    $parcel$export(module.exports, "gicOptInStatusResources", ()=>$1dd3138bca6cac05$export$14c89b6b6a261524);
    var $dJl1T;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $1dd3138bca6cac05$export$14c89b6b6a261524 = (0, $dIdda.createResource)({
        type: (0, $8e5bc4e5db4905c7$export$fe522736b61f6709),
        getKey: ()=>'gic_optin_status',
        getData: async ()=>{
            let gicOptInStatus = null;
            try {
                gicOptInStatus = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
            } catch (e) {
                if (e.statusCode !== 404) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
            }
            return {
                gicOptInStatus: gicOptInStatus ?? {
                    isEnabled: false
                }
            };
        },
        maxAge: Number.MAX_VALUE
    });
});
const $8e5bc4e5db4905c7$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';
parcelRegister("hZhhj", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RESPONSE", ()=>$0f1ada479bbc578a$export$32d9db53927095d3);
    $parcel$export(module.exports, "incomingMailServerExpiryStatusResource", ()=>$0f1ada479bbc578a$export$369caf52ed1ad2b1);
    $parcel$export(module.exports, "useIncomingMailExpiryStatus", ()=>$0f1ada479bbc578a$export$283aa034b7d4e2a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, $b9c933d7a799fa71$export$5bf8eb915287f5f4));
    const $0f1ada479bbc578a$export$32d9db53927095d3 = {
        isAdmin: false,
        showBanner: true,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $0f1ada479bbc578a$export$369caf52ed1ad2b1 = (0, $dIdda.createResource)({
        type: (0, $b9c933d7a799fa71$export$3b9494e0dfc4de09),
        getKey: ()=>(0, $b9c933d7a799fa71$export$f2f2f265ccc09f82),
        getData: async ()=>{
            let incomingMailServerExpiryStatus = null;
            try {
                incomingMailServerExpiryStatus = await $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus();
            } catch (error) {
                if (error.statusCode === 404) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'incomingMailServerExpiryStatus',
                        packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                        teamName: 'maverick'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0f1ada479bbc578a$export$32d9db53927095d3
            };
        },
        maxAge: 3600000
    });
    const $0f1ada479bbc578a$export$283aa034b7d4e2a0 = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $dIdda.useResource)($0f1ada479bbc578a$export$369caf52ed1ad2b1);
        const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $5uXOq.useState)(()=>{
            if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
            return $0f1ada479bbc578a$export$32d9db53927095d3;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.incomingMailServerExpiryStatus) {
                setResponseStatusGet('success');
                setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.incomingMailServerExpiryStatus
        ]);
        return {
            responseStatus: responseStatusGet,
            state: incomingMailServerExpiryStatus
        };
    };
});
const $b9c933d7a799fa71$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $b9c933d7a799fa71$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $b9c933d7a799fa71$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';
parcelRegister("9MiT2", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", ()=>$2d6f7831c4394a60$export$1b6468a6eb7d9b09);
    $parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", ()=>$2d6f7831c4394a60$export$e21c345b2538e96e);
    var $5uXOq = parcelRequire("5uXOq");
    var $561FV = parcelRequire("561FV");
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    var $erLlC;
    const $2d6f7831c4394a60$export$1b6468a6eb7d9b09 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("erLlC")).RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
        getKey: ()=>(0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
        getData: async ()=>{
            let modalViewCount = 0;
            try {
                const apiResult = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
                if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                    if (!(0, ($parcel$interopDefault($561FV)))(apiResult, 'value') || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'benefitsModalValue')) {
                        const error = new Error('Invalid preference value');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'issueTransitionChangeboardingPreferencesResource',
                                packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                    return {
                        numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                        benefitsModal: {
                            isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                            nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                        }
                    };
                }
                if (typeof apiResult !== 'object' || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'value')) {
                    const error = new Error('Invalid preference value');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                } else {
                    modalViewCount = Number(apiResult.value);
                    return {
                        numberOfTimesUserHasSeenChangeboarding: modalViewCount
                    };
                }
            } catch (error) {
                if (error.statusCode === 404) {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return {
                        numberOfTimesUserHasSeenChangeboarding: 0,
                        benefitsModal: {
                            isDisabled: false,
                            nextDateToShowBenefitsModal: null
                        }
                    };
                    return {
                        numberOfTimesUserHasSeenChangeboarding: 0
                    };
                }
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                numberOfTimesUserHasSeenChangeboarding: modalViewCount,
                benefitsModal: {
                    isDisabled: true,
                    nextDateToShowBenefitsModal: null
                }
            };
        }
    });
    const $2d6f7831c4394a60$export$e21c345b2538e96e = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $dIdda.useResource)($2d6f7831c4394a60$export$1b6468a6eb7d9b09);
        const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $5uXOq.useState)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return {
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
            return 0, (0, parcelRequire("erLlC")).USER_SEEN_CARDINALITY_UNKNOWN;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
        const updateIssueTranstitionChangeboardingPreferences = (0, $5uXOq.useCallback)(async (updates)=>{
            let response = 'loading';
            setResponseStatusPut('loading');
            const body = typeof updates !== 'number' && (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal') ? {
                value: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled,
                    nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
                }
            } : {
                value: updates
            };
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                    body: JSON.stringify(body)
                });
                setResponseStatusPut('success');
                let updateData;
                if (typeof updates !== 'number' && (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                    numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                    benefitsModal: {
                        isDisabled: updates?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                    }
                };
                if (typeof updates === 'number') updateData = {
                    numberOfTimesUserHasSeenChangeboarding: updates
                };
                update(()=>updateData);
                response = 'success';
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesUpdate',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setResponseStatusPut('error');
                response = 'error';
            }
            return response;
        }, [
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                setResponseStatusGet('success');
                setIssueTransitionChangeboardingPreference({
                    numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                    benefitsModal: {
                        isDisabled: data?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                    }
                });
                return;
            }
            if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
                setResponseStatusGet('success');
                setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.numberOfTimesUserHasSeenChangeboarding,
            data?.benefitsModal?.isDisabled,
            data?.benefitsModal?.nextDateToShowBenefitsModal
        ]);
        return {
            stateGet: {
                responseStatus: responseStatusGet,
                state: issueTransitionChangeboardingPreference
            },
            stateUpdate: {
                responseStatus: responseStatusPut,
                setState: updateIssueTranstitionChangeboardingPreferences
            }
        };
    };
});
parcelRegister("erLlC", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", ()=>$ca7314633d486db1$export$d66d4b761db3d20f);
    $parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", ()=>$ca7314633d486db1$export$79fd70b908f71ddd);
    $parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", ()=>$ca7314633d486db1$export$e5007258addba8aa);
    $parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", ()=>$ca7314633d486db1$export$91880069e7e73b18);
    $parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", ()=>$ca7314633d486db1$export$9ccdfd91f2512a27);
    const $ca7314633d486db1$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
    const $ca7314633d486db1$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
    const $ca7314633d486db1$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
    const $ca7314633d486db1$export$91880069e7e73b18 = -1;
    const $ca7314633d486db1$export$9ccdfd91f2512a27 = 14;
});
parcelRegister("fNOVA", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionOptInStatusResource", ()=>$cf959888902c771b$export$5fbcf4d7a6d9c477);
    $parcel$export(module.exports, "useIssueTransitionLabsOptIn", ()=>$cf959888902c771b$export$bc11d4816053db5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    var $dO2g2;
    const $cf959888902c771b$var$fetchGetIssueTransitionOptInState = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca));
    const $cf959888902c771b$export$5fbcf4d7a6d9c477 = (0, $dIdda.createResource)({
        type: (0, $267ed65766cf1bd0$export$eb01e12fc3db65c0),
        getKey: ()=>(0, $267ed65766cf1bd0$export$a964df7bc15d81e),
        getData: async ()=>{
            let issueTransitionOptInStatus = null;
            const isModernIssueTransitionSRBCohort = (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
            const isModernITSRenderEnabled = (0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
            if (!isModernITSRenderEnabled) return {
                issueTransitionOptInStatus: {
                    isEnabled: false,
                    expiryTime: -1
                }
            };
            if (isModernIssueTransitionSRBCohort) return {
                issueTransitionOptInStatus: {
                    isEnabled: true
                }
            };
            try {
                issueTransitionOptInStatus = await $cf959888902c771b$var$fetchGetIssueTransitionOptInState();
            } catch (error) {
                if (error.statusCode === 404) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'issueTransitionOptInStatusResource',
                        packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, (0, parcelRequire("dO2g2")).default)()
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $cf959888902c771b$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, (0, parcelRequire("eusud")).performPutRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca), {
            body: JSON.stringify(payload)
        });
    const $cf959888902c771b$export$bc11d4816053db5c = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $dIdda.useResource)($cf959888902c771b$export$5fbcf4d7a6d9c477);
        const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $5uXOq.useState)(()=>{
            if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
            return (0, (0, parcelRequire("dO2g2")).default)();
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
        const updateIssueTransitionOptInStatus = (0, $5uXOq.useCallback)(async (updates)=>{
            let response = 'loading';
            setResponseStatusPut('loading');
            try {
                const updatedPreferences = await $cf959888902c771b$var$fetchModifyIssueTransitionOptInState(updates);
                setResponseStatusPut('success');
                update(()=>({
                        issueTransitionOptInStatus: updatedPreferences
                    }));
                response = 'success';
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: err,
                    meta: {
                        id: 'issueTransitionOptInStatusUpdate',
                        packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setResponseStatusPut('error');
                response = 'error';
            }
            return response;
        }, [
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.issueTransitionOptInStatus) {
                setResponseStatusGet('success');
                setIssueTransitionOptInState(data.issueTransitionOptInStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.issueTransitionOptInStatus
        ]);
        return {
            stateGet: {
                responseStatus: responseStatusGet,
                state: issueTransitionLabsOptInState
            },
            stateUpdate: {
                responseStatus: responseStatusPut,
                setState: updateIssueTransitionOptInStatus
            }
        };
    };
});
const $267ed65766cf1bd0$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $267ed65766cf1bd0$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $267ed65766cf1bd0$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $267ed65766cf1bd0$export$880a78695d76498e = 8;
parcelRegister("dO2g2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fa107364a5021d3$export$2e2bcd8739ae039);
    var $aIZdc;
    var $co1wz;
    var $4R6GH;
    const $8fa107364a5021d3$var$FF_POSSIBLE_VALUES = [
        'OFF',
        'BY_DEFAULT_USER_OPT_IN',
        'BY_DEFAULT_USER_OPT_OUT'
    ];
    const $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState = ()=>{
        const isModernITSRenderEnabled = (0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            isEnabled: false,
            expiryTime: -1
        };
        const isModernIssueTransitionSRBCohort = (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
        if (isModernIssueTransitionSRBCohort) return {
            isEnabled: true
        };
        const isExplicitlyUseTurnedOff = (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', $8fa107364a5021d3$var$FF_POSSIBLE_VALUES) === 'BY_DEFAULT_USER_OPT_OUT';
        return isExplicitlyUseTurnedOff ? {
            isEnabled: false,
            expiryTime: -1
        } : {
            isEnabled: true
        };
    };
    var $8fa107364a5021d3$export$2e2bcd8739ae039 = $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState;
});
parcelRegister("kJQXA", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", ()=>$273ba0463e1e3cac$export$fa191d7d71460a98);
    var $4Pf62;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $273ba0463e1e3cac$export$fa191d7d71460a98 = (0, $dIdda.createResource)({
        type: (0, $b830026e722fc8e6$export$fd4fc70ec71927d1),
        getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
        getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
            const defaultValue = {
                enabled: true
            };
            if (!licensedProducts || !licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
            const { enabled: enabled } = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
            return {
                enabled: enabled
            };
        },
        maxAge: Infinity
    });
});
const $b830026e722fc8e6$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';
parcelRegister("atU1t", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarGlobalResource", ()=>$587727b78e9bd173$export$44e7ad3c66a3f25f);
    var $3NIpU;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $587727b78e9bd173$export$44e7ad3c66a3f25f = (0, $dIdda.createResource)({
        type: (0, $f9d36ddc532997a4$export$fa5743fc6a1da5d8),
        getKey: ({ match: match, query: query })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return projectKey || projectId || '__state';
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { baseUrl: baseUrl } = tenantContext;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const scope = {
                projectKey: projectKey,
                projectId: projectId
            };
            const response = await (0, (0, parcelRequire("3NIpU")).fetchSidebarConfig)(baseUrl, scope, false);
            return {
                response: response,
                scope: scope
            };
        },
        maxAge: 300000
    });
});
parcelRegister("3NIpU", function(module, exports) {
    $parcel$export(module.exports, "fetchSidebarConfig", ()=>$8ba40d865239bafe$export$d1d13c4b972a22f1);
    var $dJl1T;
    var $7f4tk;
    const $8ba40d865239bafe$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';
    const $8ba40d865239bafe$var$fetchUsingProtobuf = async (url)=>{
        try {
            const fetchProtobuf = await (parcelRequire("aOyKS"));
            if (!fetchProtobuf) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
            return fetchProtobuf.default(url);
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
            throw err;
        }
    };
    const $8ba40d865239bafe$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
        const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
        const params = {
            exclude: [
                'webItems.reports',
                'webItems.home',
                'webItems.gin',
                exclude
            ].filter(Boolean).join(',')
        };
        let path = '';
        if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
        else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
        else if (identifierValue != null) path = `project/${identifierValue}`;
        else {
            path = 'product';
            const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
            const projectIdOrKey = projectId || projectKey;
            if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
        }
        const queryString = [
            new URLSearchParams(params).toString(),
            queryParams
        ].filter(Boolean).join('&');
        return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
    };
    const $8ba40d865239bafe$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
        if (isServer) {
            const protoUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
            return $8ba40d865239bafe$var$fetchUsingProtobuf(protoUrl);
        }
        const sidebarUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
        return (0, (0, parcelRequire("7f4tk")).default)(sidebarUrl);
    };
});
parcelRegister("aOyKS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7erVk").then(()=>parcelRequire('g4I8Z'));
});
const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';
parcelRegister("c34Wf", function(module, exports) {
    $parcel$export(module.exports, "navigationUiStateResource", ()=>$976a0f933d5d0ba8$export$14c178691841b423);
    var $8QpSo;
    var $dIdda = parcelRequire("dIdda");
    var $kJPyG;
    const $976a0f933d5d0ba8$var$getNavigationUiStateMemoized = (0, (0, parcelRequire("8QpSo")).default)((atlassianAccountId)=>(0, (0, parcelRequire("kJPyG")).getNavigationUiState)({
            tenantContext: {
                atlassianAccountId: atlassianAccountId
            }
        }));
    const $976a0f933d5d0ba8$export$14c178691841b423 = (0, $dIdda.createResource)({
        type: 'RESOURCE_TYPE_NAVIGATION_UI',
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$976a0f933d5d0ba8$var$getNavigationUiStateMemoized(atlassianAccountId),
        maxAge: Infinity
    });
});
parcelRegister("kJPyG", function(module, exports) {
    $parcel$export(module.exports, "getNavigationUiState", ()=>$a5efaf793a61ef5e$export$29999268b070c9bd);
    var $89SaW;
    var $1yqku;
    const $a5efaf793a61ef5e$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
        const { atlassianAccountId: accountId } = tenantContext;
        let uiState = await (0, (0, parcelRequire("1yqku")).queryLocalStorage)();
        if (uiState || !accountId) return uiState;
        try {
            uiState = await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
            (0, (0, parcelRequire("1yqku")).updateLocalStorageData)(uiState);
        } catch (e) {}
        return uiState;
    };
});
const $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $2ed2f0cf8ecb933e$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';
parcelRegister("1yqku", function(module, exports) {
    $parcel$export(module.exports, "queryLocalStorage", ()=>$fa4273588466a1c1$export$e192dcb908272d5);
    $parcel$export(module.exports, "updateLocalStorageData", ()=>$fa4273588466a1c1$export$ec13c725e067146a);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dJl1T;
    const $fa4273588466a1c1$export$e7db3fa51c63bc5c = ()=>{
        if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
        return {
            setItem: (0, ($parcel$interopDefault($8Rkzz))),
            getItem: (0, ($parcel$interopDefault($8Rkzz)))
        };
    };
    const $fa4273588466a1c1$var$queryLocalStorageSync = ()=>{
        const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
        const item = localStorage.getItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
        if (!false && item) try {
            return JSON.parse(item);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $2ed2f0cf8ecb933e$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
        }
    };
    const $fa4273588466a1c1$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
            const item = $fa4273588466a1c1$var$queryLocalStorageSync();
            resolve(item);
        });
    const $fa4273588466a1c1$export$ec13c725e067146a = (data)=>{
        const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
        localStorage.setItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data));
    };
});
parcelRegister("eOlBz", function(module, exports) {
    $parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", ()=>$4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
    $parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", ()=>$4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2);
    $parcel$export(module.exports, "useNewIssueViewLockedInStatus", ()=>$4e2e5fcdbf62dfaf$export$3b09097f2a423abd);
    var $dIdda = parcelRequire("dIdda");
    const $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c = (0, $dIdda.createResource)({
        type: (0, $103a13dfd187b85c$export$fdb92aeacda42553),
        getKey: ()=>'newIssueViewTransitionLockingStatus',
        getDataLoader: ()=>(parcelRequire("l81Mv")),
        maxAge: Number.MAX_VALUE
    });
    const $4e2e5fcdbf62dfaf$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$3b09097f2a423abd = ()=>(0, $dIdda.useResource)($4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
});
const $103a13dfd187b85c$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';
parcelRegister("l81Mv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bDo1N").then(()=>parcelRequire('2RVA3'));
});
parcelRegister("3X1Xr", function(module, exports) {
    $parcel$export(module.exports, "persistentIssueCreateModalViewResource", ()=>$950f2f2a5a65ba3f$export$266a039a005e8314);
    var $dIdda = parcelRequire("dIdda");
    const $950f2f2a5a65ba3f$export$266a039a005e8314 = (0, $dIdda.createResource)({
        type: (0, $fa76c7a777da2375$export$f658cfd591eb583e),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("cptV5")),
        maxAge: Number.MAX_VALUE
    });
});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';
parcelRegister("cptV5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Kt13").then(()=>parcelRequire('8FYIq'));
});
parcelRegister("dxCvy", function(module, exports) {
    $parcel$export(module.exports, "projectContextResource", ()=>$fb0493b5a465ed74$export$27ad0d75c619be68);
    $parcel$export(module.exports, "projectContextResourceWithCache", ()=>$fb0493b5a465ed74$export$d75816e37af81473);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $fb0493b5a465ed74$var$getDataLoader = ()=>(parcelRequire("2VAeN"));
    const $fb0493b5a465ed74$export$27ad0d75c619be68 = (0, $dIdda.createResource)({
        type: (0, $0f463a88567f1621$export$80a60a092d9ab81),
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return projectKey || projectId;
        },
        getDataLoader: $fb0493b5a465ed74$var$getDataLoader,
        maxAge: 1800000
    });
    const $fb0493b5a465ed74$export$d75816e37af81473 = $fb0493b5a465ed74$export$27ad0d75c619be68;
});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';
parcelRegister("2VAeN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7UkBG").then(()=>parcelRequire('fsLhR'));
});
parcelRegister("kkNtb", function(module, exports) {
    $parcel$export(module.exports, "rovoEntitlementResource", ()=>$10274390833bf523$export$a0974cf24d16bc5d);
    $parcel$export(module.exports, "useRovoEntitlementResource", ()=>$10274390833bf523$export$b9cee3799212b85a);
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
    const $10274390833bf523$var$fetchRovoEntitlement = async (cloudId)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $34f68d752b7fdd6c$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.errors) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesRovoEntitlement',
                    teamName: 'ai-mate'
                },
                error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                isRovoEnabled: response.data?.jira?.isRovoEnabled ?? null
            };
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesRovoEntitlement',
                    teamName: 'ai-mate'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            isRovoEnabled: null
        };
    };
    const $10274390833bf523$export$a0974cf24d16bc5d = (0, $dIdda.createResource)({
        type: $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
        getKey: ()=>$10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
        getData: (_, { tenantContext: { cloudId: cloudId } })=>$10274390833bf523$var$fetchRovoEntitlement(cloudId),
        maxAge: Infinity
    });
    const $10274390833bf523$export$b9cee3799212b85a = ()=>(0, $dIdda.useResource)($10274390833bf523$export$a0974cf24d16bc5d);
});
const $34f68d752b7fdd6c$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;
parcelRegister("7GnDe", function(module, exports) {
    $parcel$export(module.exports, "incidentsInitialPageChecksResource", ()=>$08a008dcde68e650$export$b2b94ce8ba590cc8);
    $parcel$export(module.exports, "incidentsCustomFieldIdResource", ()=>$08a008dcde68e650$export$e81d7afef87ae597);
    $parcel$export(module.exports, "incidentExperimentTraitResource", ()=>$08a008dcde68e650$export$31c6945718067be3);
    var $dIdda = parcelRequire("dIdda");
    const $08a008dcde68e650$export$b2b94ce8ba590cc8 = (0, $dIdda.createResource)({
        type: (0, $0ec4f2aa733ae93d$export$9018fdf9116edd9b),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("1Y6Un"))
    });
    const $08a008dcde68e650$export$e81d7afef87ae597 = (0, $dIdda.createResource)({
        type: (0, $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("7F1l2"))
    });
    const $08a008dcde68e650$export$31c6945718067be3 = (0, $dIdda.createResource)({
        type: (0, $0ec4f2aa733ae93d$export$1d954e05e596a51e),
        getKey: ()=>'incident_experiment_traits',
        getDataLoader: ()=>(parcelRequire("7I42N")),
        maxAge: Number.MAX_SAFE_INTEGER
    });
});
const $0ec4f2aa733ae93d$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $0ec4f2aa733ae93d$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';
parcelRegister("1Y6Un", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jEfvB").then(()=>parcelRequire('8lQN4'));
});
parcelRegister("7F1l2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8rk6s").then(()=>parcelRequire('i0mY9'));
});
parcelRegister("7I42N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ajWVH").then(()=>parcelRequire('iwLnj'));
});
parcelRegister("2Ql51", function(module, exports) {
    $parcel$export(module.exports, "themePreferenceResource", ()=>$14feb59df5995657$export$e5a423d1eb1cf1d0);
    $parcel$export(module.exports, "useThemePreference", ()=>$14feb59df5995657$export$3416635c8aeb5bab);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $dIdda = parcelRequire("dIdda");
    var $Y0b1l;
    const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("7QoEx"));
    const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, $dIdda.createResource)({
        type: 'RESOURCE_THEME_PREFERENCE',
        getKey: ()=>'state',
        getDataLoader: $14feb59df5995657$var$getDataLoader,
        maxAge: 300000
    });
    const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
        const { data: data, update: updateThemePreferenceResource } = (0, $dIdda.useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
            const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            const analyticsEvent = createAnalyticsEvent({
                action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
                actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                newPreference: next,
                oldPreference: current,
                OStheme: OStheme
            });
        }, [
            createAnalyticsEvent
        ]);
        const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
            updateThemePreferenceResource(()=>({
                    theme: theme
                }));
            if (data?.theme !== theme) {
                fireThemeAnalytics(data?.theme, theme);
                await (0, (0, parcelRequire("Y0b1l")).setThemePreference)(theme);
            }
        }, [
            data?.theme,
            updateThemePreferenceResource,
            fireThemeAnalytics
        ]);
        return {
            theme: data?.theme,
            setTheme: setTheme
        };
    };
});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';
parcelRegister("Y0b1l", function(module, exports) {
    $parcel$export(module.exports, "setThemePreference", ()=>$fb319b2ef1da4e47$export$a6b84eebd33787e2);
    $parcel$export(module.exports, "getThemePreference", ()=>$fb319b2ef1da4e47$export$2f7a12048d96237);
    var $b9op4;
    var $jcw0u;
    var $aHuqL;
    const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'put',
                    errName: String(error.name),
                    statusCode: error.statusCode,
                    param: `to:${theme}`
                }
            });
        });
        return promise;
    };
    const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'get',
                    errName: String(error.name),
                    statusCode: error.statusCode
                }
            });
        });
        promise.then((theme)=>{
            if (theme && !(0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme)) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: new Error('Unrecognized theme!'),
                attributes: {
                    op: 'get',
                    theme: theme,
                    errName: 'unrecognized value!'
                }
            });
        });
        const theme = await promise;
        return theme && (0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme) ? theme : undefined;
    };
});
parcelRegister("b9op4", function(module, exports) {
    $parcel$export(module.exports, "ThemeOptions", ()=>$a1d11c8212b90b3e$export$abe7936539cefefe);
    $parcel$export(module.exports, "DEFAULT_THEME", ()=>$a1d11c8212b90b3e$export$2faeed762aac6741);
    const $a1d11c8212b90b3e$export$abe7936539cefefe = [
        'light',
        'dark',
        'auto'
    ];
    const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';
});
parcelRegister("7QoEx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5DvFw")
    ]).then(()=>parcelRequire('jyeNt'));
});
parcelRegister("9vlEn", function(module, exports) {
    $parcel$export(module.exports, "userHomepageResource", ()=>$ea929e6a42e03883$export$16320dd0d1e6c145);
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $ea929e6a42e03883$export$16320dd0d1e6c145 = (0, $dIdda.createResource)({
        type: (0, $a4d0f361741078de$export$2026a6db44b15de7),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
            const { homepagePreference: homepagePreference } = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
            return {
                homepagePreference: homepagePreference
            };
        },
        maxAge: Infinity
    });
});
const $a4d0f361741078de$export$2026a6db44b15de7 = 'USER_HOMEPAGE';
parcelRegister("5lsNZ", function(module, exports) {
    $parcel$export(module.exports, "LazyNotFoundErrorPage", ()=>$5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7);
    $parcel$export(module.exports, "default", ()=>$5ed1828a3f7dd5a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("iKEJ8")), {
        moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
    });
    var $5ed1828a3f7dd5a7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7,
            pageId: "errors-404",
            shouldShowSpinner: false
        });
});
parcelRegister("5j7Th", function(module, exports) {
    $parcel$export(module.exports, "LazyPage", ()=>$63937a96c08aaddb$export$a18c9c3dd309b8e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $dJl1T;
    var $lfTZh;
    var $6jY6G;
    var $7LpuY;
    var $dZw8H;
    const $63937a96c08aaddb$var$LOCATION = 'lazy-page';
    const $63937a96c08aaddb$export$fb85bbdbfb3e6869 = ()=>null;
    const $63937a96c08aaddb$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const Skeleton = route.skeleton || (shouldShowSpinner ? (0, (0, parcelRequire("kb4zh")).default) : $63937a96c08aaddb$export$fb85bbdbfb3e6869);
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData($63937a96c08aaddb$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
        }, [
            route.isRedirect,
            route.name
        ]);
        return route.isRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazy_page_redirect",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LpuY")).default), {
            pageId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateContainer), {
            isGlobal: true,
            appId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateAppStartWithMatchCheck), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazy_page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null))));
    };
});
parcelRegister("kb4zh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c26967b2e10d397c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $eZJjh;
    function $c26967b2e10d397c$export$2e2bcd8739ae039({ testId: testId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "legacy-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            testId: testId
        }))));
    }
    const $c26967b2e10d397c$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $c26967b2e10d397c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7LpuY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c62dfc18679e80c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUU4G;
    var $x9xyg;
    var $bNvU3;
    var $7N30e;
    var $6b6Tk;
    var $8Qrwl;
    var $hXKq5;
    class $6c62dfc18679e80c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { children: children, pageId: pageId } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Qrwl")).default).Provider, {
                value: {
                    pageId: pageId,
                    onReady: this.onReady,
                    onCustomMark: this.onCustomMark
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: this.onStart,
                args: [
                    pageId
                ]
            }), children));
        }
        constructor(...args){
            super(...args);
            this.customMarks = [];
            this.onStart = ()=>{
                (0, (0, parcelRequire("kUU4G")).default)((0, $ce556f125dee8174$export$56940a9488e85199));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$45c4b6bf7935c69a));
            };
            this.onCustomMark = (markName)=>{
                (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)(markName));
                this.customMarks.push(markName);
            };
            this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
                metric.stop({
                    customData: extra
                });
                if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
            };
        }
    }
});
parcelRegister("kUU4G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cb4d2f8b5a69f79$export$2e2bcd8739ae039);
    var $6RCeq;
    var $6cb4d2f8b5a69f79$export$2e2bcd8739ae039 = (prefix)=>{
        if ((0, (0, parcelRequire("6RCeq")).default) && (0, (0, parcelRequire("6RCeq")).default).getEntries && (0, (0, parcelRequire("6RCeq")).default).clearMarks) return (0, (0, parcelRequire("6RCeq")).default).getEntries().filter((mark)=>mark.name.startsWith(prefix)).map((mark)=>{
            (0, (0, parcelRequire("6RCeq")).default).clearMarks(mark.name);
            return mark;
        });
        return [];
    };
});
parcelRegister("bNvU3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c14e3adf575574$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    class $96c14e3adf575574$var$OpTrigger extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        shouldComponentUpdate(nextProps) {
            return !(0, ($parcel$interopDefault($ajpes)))(this.props.args, nextProps.args);
        }
        componentDidUpdate() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $96c14e3adf575574$export$2e2bcd8739ae039 = $96c14e3adf575574$var$OpTrigger;
});
parcelRegister("7N30e", function(module, exports) {
    $parcel$export(module.exports, "stopLowPriorityEventDelay", ()=>$5d68e3874efadecb$export$a928755af449867);
    $parcel$export(module.exports, "startLowPriorityEventDelay", ()=>$5d68e3874efadecb$export$8bb8df5a93e9525);
    $parcel$export(module.exports, "default", ()=>$5d68e3874efadecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUU4G;
    var $x9xyg;
    var $3vBBc;
    var $fjcgS;
    var $lsa9q;
    var $6b6Tk;
    const $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT = 10000;
    let $5d68e3874efadecb$var$stopDelayTimeout;
    let $5d68e3874efadecb$var$lastDelayActionPromise = (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
    const $5d68e3874efadecb$export$a928755af449867 = ()=>{
        $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
            if (!(0, (0, parcelRequire("3vBBc")).isEventDelayActive)()) return client;
            clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
            (0, (0, parcelRequire("x9xyg")).setMark)((0, $2eb1df3f82c48b0d$export$2d91d3eed1108e72));
            (0, (0, parcelRequire("3vBBc")).setEventDelayActive)(false);
            client.stopLowPriorityEventDelay();
            return client;
        });
    };
    const $5d68e3874efadecb$export$8bb8df5a93e9525 = ()=>{
        $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
            if (!(0, (0, parcelRequire("3vBBc")).isEventDelayActive)()) {
                (0, (0, parcelRequire("kUU4G")).default)((0, $2eb1df3f82c48b0d$export$358721a9d6125914));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $2eb1df3f82c48b0d$export$b2122dce85a27912));
            }
            client.startLowPriorityEventDelay();
            (0, (0, parcelRequire("3vBBc")).setEventDelayActive)(true);
            clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
            $5d68e3874efadecb$var$stopDelayTimeout = setTimeout($5d68e3874efadecb$export$a928755af449867, $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT);
            return client;
        });
    };
    const $5d68e3874efadecb$export$778ebe2a4fab1ba7 = ()=>$5d68e3874efadecb$var$lastDelayActionPromise;
    const $5d68e3874efadecb$var$EventDelayController = ()=>{
        const [loadedState] = (0, (0, parcelRequire("lsa9q")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (!loadedState.hasLoaded && (0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) $5d68e3874efadecb$export$8bb8df5a93e9525();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    var $5d68e3874efadecb$export$2e2bcd8739ae039 = $5d68e3874efadecb$var$EventDelayController;
});
parcelRegister("3vBBc", function(module, exports) {
    $parcel$export(module.exports, "setEventDelayActive", ()=>$63f3b8c0745d0500$export$9a4add6d6ddcc1a);
    $parcel$export(module.exports, "isEventDelayActive", ()=>$63f3b8c0745d0500$export$3536b0184fa98d19);
    let $63f3b8c0745d0500$var$eventDelayActive = false;
    const $63f3b8c0745d0500$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
        $63f3b8c0745d0500$var$eventDelayActive = isEventDelayActive;
    };
    const $63f3b8c0745d0500$export$3536b0184fa98d19 = ()=>$63f3b8c0745d0500$var$eventDelayActive;
});
parcelRegister("lsa9q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f20cb56a66aca22$export$2e2bcd8739ae039);
    var $7JoAD = parcelRequire("7JoAD");
    var $7w9eZ;
    const $4f20cb56a66aca22$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        const determineHasLoaded = ()=>{
            if (appIds.length === 1 && appIds[0] === (0, $146ecce9d079a34d$export$3a54edb6ba4daa82)) return !__SPA__;
            return appIds.length ? appIds.filter((id)=>id !== (0, $146ecce9d079a34d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
        };
        const hasLoaded = determineHasLoaded();
        return {
            hasLoaded: hasLoaded
        };
    };
    const $4f20cb56a66aca22$var$usePageLoadedSubscriber = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $4f20cb56a66aca22$export$4a361c7505f72f5c
    });
    var $4f20cb56a66aca22$export$2e2bcd8739ae039 = $4f20cb56a66aca22$var$usePageLoadedSubscriber;
});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';
const $2eb1df3f82c48b0d$export$358721a9d6125914 = 'event-delay-controller.';
const $2eb1df3f82c48b0d$export$b2122dce85a27912 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}start`;
const $2eb1df3f82c48b0d$export$2d91d3eed1108e72 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}end`;
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("8Qrwl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d87d05828c384551$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d87d05828c384551$var$contextName = 'SpaApdexAnalytics';
    var $d87d05828c384551$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($d87d05828c384551$var$contextName);
});
parcelRegister("hXKq5", function(module, exports) {
    $parcel$export(module.exports, "getPrefixedMarkName", ()=>$f6cddc52a08e036c$export$c8f0e9837e7e9425);
    const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;
});
parcelRegister("dZw8H", function(module, exports) {
    $parcel$export(module.exports, "SpaStateContainer", ()=>$b1cd152eb196251c$export$e9a92b877fe80e80);
    $parcel$export(module.exports, "SpaStateAppStart", ()=>$b1cd152eb196251c$export$d18dd27183a635c);
    $parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", ()=>$b1cd152eb196251c$export$95a2912d76fb5433);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$b1cd152eb196251c$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$b1cd152eb196251c$export$41e70078eeddaddc);
    $parcel$export(module.exports, "SpaStatePageErrorReady", ()=>$b1cd152eb196251c$export$2583aa269898885c);
    $parcel$export(module.exports, "getSpaStateLastUserLocation", ()=>$b1cd152eb196251c$export$6e9ab893e97cccef);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $dIdda = parcelRequire("dIdda");
    var $7JoAD = parcelRequire("7JoAD");
    var $4oDnX;
    var $7w9eZ;
    const $b1cd152eb196251c$export$e9a92b877fe80e80 = (0, $7JoAD.createContainer)((0, (0, parcelRequire("7w9eZ")).default));
    const $b1cd152eb196251c$export$d18dd27183a635c = ()=>{
        const startRef = (0, $5uXOq.useRef)(Date.now());
        const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, (0, parcelRequire("4oDnX")).useSpaState)();
        (0, $5uXOq.useMemo)(()=>{
            startRef.current = Date.now();
        }, [
            visitedPages
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setAppStart(startRef.current);
        }, [
            setAppStart,
            visitedPages
        ]);
        return null;
    };
    const $b1cd152eb196251c$var$useRouterMatchSelector = (0, $dIdda.createRouterSelector)((state)=>state.match);
    const $b1cd152eb196251c$var$useSpaStatePagesCount = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: ({ visitedPages: visitedPages })=>visitedPages.length
    });
    const $b1cd152eb196251c$export$95a2912d76fb5433 = ()=>{
        const match = $b1cd152eb196251c$var$useRouterMatchSelector();
        const [count, { setAppStart: setAppStart }] = $b1cd152eb196251c$var$useSpaStatePagesCount();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b1cd152eb196251c$export$ada7e0ec445851a2, {
            visitedPagesLength: count,
            onSetAppStart: setAppStart,
            match: match
        });
    };
    const $b1cd152eb196251c$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady
            }));
    const $b1cd152eb196251c$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady,
                args: comparer
            }));
    const $b1cd152eb196251c$export$2583aa269898885c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppErrorReady
            }));
    class $b1cd152eb196251c$export$ada7e0ec445851a2 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
            const matchHasChanged = props.match !== state.match;
            const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
            if (setAppStart) props.onSetAppStart(Date.now());
            if (setAppStart || !visitedPageLengthHasChanged) return {
                started: true,
                visitedPagesLength: props.visitedPagesLength,
                match: props.match
            };
            return state;
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args);
            this.state = {
                visitedPagesLength: 0,
                started: false,
                match: null
            };
        }
    }
    const $b1cd152eb196251c$export$6e9ab893e97cccef = ()=>{
        const { visitedPages: visitedPages } = (0, $7JoAD.defaultRegistry).getStore((0, (0, parcelRequire("7w9eZ")).default)).storeState.getState();
        return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
    };
});
parcelRegister("4oDnX", function(module, exports) {
    $parcel$export(module.exports, "SpaStateSubscriber", ()=>$363cd3235a9267e4$export$fd52daf2a3c1ec68);
    $parcel$export(module.exports, "SpaStateActionsSubscriber", ()=>$363cd3235a9267e4$export$3dfa91988c213fbc);
    $parcel$export(module.exports, "useSpaState", ()=>$363cd3235a9267e4$export$a57865516f6345d1);
    $parcel$export(module.exports, "useSpaStateActions", ()=>$363cd3235a9267e4$export$b134752525935b78);
    var $7JoAD = parcelRequire("7JoAD");
    var $7w9eZ;
    const $363cd3235a9267e4$export$fd52daf2a3c1ec68 = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("7w9eZ")).default));
    const $363cd3235a9267e4$export$3dfa91988c213fbc = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: null
    });
    const $363cd3235a9267e4$export$a57865516f6345d1 = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default));
    const $363cd3235a9267e4$export$b134752525935b78 = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: null
    });
});
parcelRegister("iKEJ8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8uqRL")
    ]).then(()=>parcelRequire('6iSaB'));
});
parcelRegister("7yO8g", function(module, exports) {
    $parcel$export(module.exports, "markAsProductBundleReady", ()=>$beda9c6123873bbb$export$ff83c57004505abd);
    var $2SVPM;
    const $beda9c6123873bbb$export$ff83c57004505abd = (importedBundle)=>{
        if (!false) importedBundle.then(()=>{
            (0, (0, parcelRequire("2SVPM")).setProductBundleReadyForInitialRender)();
        });
        return importedBundle;
    };
});
parcelRegister("fpTnr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("fRrgV")
    ]).then(()=>parcelRequire('iKp4O'));
});
parcelRegister("4T776", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hHeRE")
    ]).then(()=>parcelRequire('kTuYj'));
});
parcelRegister("l0fbZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gx7r5")
    ]).then(()=>parcelRequire('2YNDR'));
});
parcelRegister("8iyFV", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalNavPlans", ()=>$ee88d7a7192b9e04$export$84e1a5f003939496);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $ee88d7a7192b9e04$var$LazyHorizontalPlansNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aNUpj")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
    });
    const $ee88d7a7192b9e04$export$84e1a5f003939496 = ({ store: store })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-software-plans-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ee88d7a7192b9e04$var$LazyHorizontalPlansNav, {
            store: store
        }));
});
parcelRegister("aNUpj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gnY34")),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("aqH3P")
    ]).then(()=>parcelRequire('fYibJ'));
});
parcelRegister("aMHR6", function(module, exports) {
    "use strict";
    var $g1Pp8 = parcelRequire("g1Pp8");
    module.exports = $g1Pp8(function(bundle) {
        return new Promise(function(resolve, reject) {
            var existingLinks = document.getElementsByTagName('link');
            if ([].concat(existingLinks).some(function isCurrentBundle(link) {
                return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
            })) {
                resolve();
                return;
            }
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = bundle;
            link.onerror = function(e) {
                link.onerror = link.onload = null;
                link.remove();
                reject(e);
            };
            link.onload = function() {
                link.onerror = link.onload = null;
                resolve();
            };
            document.getElementsByTagName('head')[0].appendChild(link);
        });
    });
});
parcelRegister("g1Pp8", function(module, exports) {
    "use strict";
    var $bab49d2fea43af49$var$cachedBundles = {};
    var $bab49d2fea43af49$var$cachedPreloads = {};
    var $bab49d2fea43af49$var$cachedPrefetches = {};
    function $bab49d2fea43af49$var$getCache(type) {
        switch(type){
            case 'preload':
                return $bab49d2fea43af49$var$cachedPreloads;
            case 'prefetch':
                return $bab49d2fea43af49$var$cachedPrefetches;
            default:
                return $bab49d2fea43af49$var$cachedBundles;
        }
    }
    module.exports = function(loader, type) {
        return function(bundle) {
            var cache = $bab49d2fea43af49$var$getCache(type);
            if (cache[bundle]) return cache[bundle];
            return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
                delete cache[bundle];
                throw e;
            });
        };
    };
});
parcelRegister("937TY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$375ae1bde651f684$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $375ae1bde651f684$var$LazyPlanSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("9Kv1r")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
    });
    const $375ae1bde651f684$var$PlanSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "Plan"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($375ae1bde651f684$var$LazyPlanSidebar, null)));
    $375ae1bde651f684$var$PlanSidebar.displayName = 'PlanSidebar';
    var $375ae1bde651f684$export$2e2bcd8739ae039 = $375ae1bde651f684$var$PlanSidebar;
});
parcelRegister("9Kv1r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("fRQHe")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("exGqx")
    ]).then(()=>parcelRequire('5q8CD'));
});
parcelRegister("BXMfg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9iCqI").then(()=>parcelRequire('ikoZN'));
});
parcelRegister("c3WQb", function(module, exports) {
    $parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", ()=>$20c66b93015d9910$export$6ca262338f199e4b);
    $parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", ()=>$20c66b93015d9910$export$aec847b4ce72891);
    $parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", ()=>$20c66b93015d9910$export$7431e46c7ad56c3d);
    $parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", ()=>$20c66b93015d9910$export$bf0c5395c73cc255);
    $parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", ()=>$20c66b93015d9910$export$f5b159e1fb19e04e);
    var $hGgHi = parcelRequire("hGgHi");
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $20c66b93015d9910$export$6ca262338f199e4b = (0, $dIdda.createResource)({
        type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
        getKey: ({ match: match })=>{
            const { params: params, query: query } = match;
            if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
            if (params.reportId != null) return params.reportId;
            if (query.r != null) return query.r;
            throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
        },
        getData: async ()=>undefined,
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$aec847b4ce72891 = (0, $dIdda.createResource)({
        type: (0, $025c2a539475c8ec$export$a0893d695ebee984),
        getKey: ({ query: query })=>`scenarioId_${query.id}`,
        getData: async ({ query: query })=>{
            const planId = query.id;
            const { id: id } = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
            return {
                scenarioId: id
            };
        },
        maxAge: 0
    });
    const $20c66b93015d9910$export$7431e46c7ad56c3d = (0, $dIdda.createResource)({
        type: (0, $025c2a539475c8ec$export$68390102872336b6),
        getKey: ({ match: match })=>{
            const { planId: planId, scenarioId: scenarioId } = match.params;
            return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
        },
        getData: async ({ match: match })=>{
            const { planId: planId, scenarioId: scenarioId } = match.params;
            if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
            let url = `/rest/jpo/1.0/plans/${planId}/checks`;
            if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            return response;
        },
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$bf0c5395c73cc255 = (0, $dIdda.createResource)({
        type: (0, $025c2a539475c8ec$export$a00e869cafd63140),
        getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
        getData: async ({ match: match })=>{
            const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
            delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
            if (initialPlanChecksPromise) {
                const response = await initialPlanChecksPromise;
                return response;
            }
            const { reportId: reportId } = match.params;
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
            return response;
        },
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$f5b159e1fb19e04e = (0, $dIdda.createResource)({
        type: (0, $025c2a539475c8ec$export$179a0d35e95a4d61),
        getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
        getData: async ({ match: match })=>{
            const RETRIES = 3;
            const DELAY = 500;
            const attemptFetch = async (remainingRetries)=>{
                const currentPlanId = match.params.planId;
                if (!(0, ($parcel$interopDefault($hGgHi)))(currentPlanId)) {
                    const defaultBoardIdResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                    if (defaultBoardIdResponse === null) return {
                        boardId: null
                    };
                    const { id: id } = defaultBoardIdResponse;
                    return {
                        boardId: id
                    };
                }
                if (remainingRetries > 0) {
                    await new Promise((resolve)=>setTimeout(resolve, DELAY));
                    return attemptFetch(remainingRetries - 1);
                }
                throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
            };
            return attemptFetch(RETRIES);
        },
        maxAge: Infinity
    });
});
const $025c2a539475c8ec$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $025c2a539475c8ec$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';
parcelRegister("lv9xW", function(module, exports) {
    $parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", ()=>$f87ae7e2901ac155$export$f9061628830b5175);
    $parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", ()=>$f87ae7e2901ac155$export$2dfe99460dae6bc6);
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    var $5m5rT;
    const $f87ae7e2901ac155$var$getQueryParams = (routerQuery)=>{
        if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
        return routerQuery;
    };
    const $f87ae7e2901ac155$export$f9061628830b5175 = (0, $dIdda.createResource)({
        type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
        getKey: ({ match: match })=>{
            const { params: params } = match;
            if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
            return 'none';
        },
        getData: async ({ match: match, query: query })=>{
            if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
                const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
                window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
                return response;
            }
            const { params: params } = match;
            return $f87ae7e2901ac155$export$2dfe99460dae6bc6(params, query, (0, (0, parcelRequire("5m5rT")).AVAILABLE_CHARTS));
        },
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $f87ae7e2901ac155$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
        if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
        const { startDate: startDate, endDate: endDate } = $f87ae7e2901ac155$var$getQueryParams(query);
        const customDateRangeParams = startDate && endDate ? {
            startDate: startDate,
            endDate: endDate
        } : {};
        const data = await (0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/summary/data', {
            method: 'POST',
            body: JSON.stringify({
                planId: params.planId,
                scenarioId: params.scenarioId,
                chartTypes: chartTypes,
                ...customDateRangeParams
            })
        });
        return data;
    };
});
parcelRegister("5m5rT", function(module, exports) {
    $parcel$export(module.exports, "CHART_TYPES", ()=>$d315f648a94f47c0$export$3251435144ca69e2);
    $parcel$export(module.exports, "AVAILABLE_CHARTS", ()=>$d315f648a94f47c0$export$79cf9c14f738d70b);
    $parcel$export(module.exports, "SCHEDULING_MODES", ()=>$d315f648a94f47c0$export$92daf59e30346cd2);
    $parcel$export(module.exports, "CAPACITY_UNIT", ()=>$d315f648a94f47c0$export$494e761f17fc60a9);
    $parcel$export(module.exports, "SPRINT_STATE", ()=>$d315f648a94f47c0$export$38e437924c2adbda);
    const $d315f648a94f47c0$export$3251435144ca69e2 = {
        statusCategory: 'STATUS_CATEGORY',
        issueProgress: 'ISSUE_PROGRESS',
        teamProgress: 'TEAM_PROGRESS',
        teamCapacity: 'TEAM_CAPACITY',
        blockers: 'BLOCKERS',
        highestPriority: 'HIGHEST_PRIORITY',
        unassignedIssues: 'UNASSIGNED_ISSUES',
        overlappingBlockers: 'OVERLAPPING_BLOCKERS',
        overdue: 'OVERDUE'
    };
    const $d315f648a94f47c0$export$79cf9c14f738d70b = [
        $d315f648a94f47c0$export$3251435144ca69e2.statusCategory,
        $d315f648a94f47c0$export$3251435144ca69e2.issueProgress,
        $d315f648a94f47c0$export$3251435144ca69e2.teamProgress,
        $d315f648a94f47c0$export$3251435144ca69e2.teamCapacity,
        $d315f648a94f47c0$export$3251435144ca69e2.blockers,
        $d315f648a94f47c0$export$3251435144ca69e2.highestPriority,
        $d315f648a94f47c0$export$3251435144ca69e2.unassignedIssues,
        $d315f648a94f47c0$export$3251435144ca69e2.overlappingBlockers,
        $d315f648a94f47c0$export$3251435144ca69e2.overdue
    ];
    const $d315f648a94f47c0$export$92daf59e30346cd2 = {
        SCRUM: 'Scrum',
        KANBAN: 'Kanban'
    };
    const $d315f648a94f47c0$export$494e761f17fc60a9 = {
        HOURS: 'HOURS',
        POINTS: 'STORY_POINTS',
        DAYS: 'DAYS'
    };
    const $d315f648a94f47c0$export$38e437924c2adbda = {
        CLOSED: 'CLOSED',
        ACTIVE: 'ACTIVE',
        FUTURE: 'FUTURE'
    };
});
parcelRegister("9UjCT", function(module, exports) {
    $parcel$export(module.exports, "softwareAdvancedRoadmapsRoute", ()=>$6df62a94d3e772ef$export$21d57208bfbf7e92);
    $parcel$export(module.exports, "softwarePlanDependenciesRoute", ()=>$6df62a94d3e772ef$export$ad8296aa5394f696);
    $parcel$export(module.exports, "softwarePlanSummaryRoute", ()=>$6df62a94d3e772ef$export$25a8cf27557a612d);
    $parcel$export(module.exports, "softwarePlanCalendarRoute", ()=>$6df62a94d3e772ef$export$ca4c39d60ec156a2);
    $parcel$export(module.exports, "softwarePlanReleasesRoute", ()=>$6df62a94d3e772ef$export$850236b64b0aa28b);
    $parcel$export(module.exports, "softwarePlanTimelineRoute", ()=>$6df62a94d3e772ef$export$61abeb6a03d23dd3);
    $parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", ()=>$6df62a94d3e772ef$export$6734c29372722a5e);
    $parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", ()=>$6df62a94d3e772ef$export$a0fec30f475e8756);
    $parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", ()=>$6df62a94d3e772ef$export$3d54c48a91a178c0);
    $parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", ()=>$6df62a94d3e772ef$export$76e6bdc959f6fa97);
    $parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", ()=>$6df62a94d3e772ef$export$a215ef374dd2a8a9);
    $parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", ()=>$6df62a94d3e772ef$export$d32efeefb944c6b7);
    $parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", ()=>$6df62a94d3e772ef$export$e44088b2cc0206cf);
    $parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", ()=>$6df62a94d3e772ef$export$2634cd63c73f7a35);
    $parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", ()=>$6df62a94d3e772ef$export$358b0ca69a4bd731);
    $parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", ()=>$6df62a94d3e772ef$export$fa18324265e4400c);
    $parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", ()=>$6df62a94d3e772ef$export$ab61883f74eb27c2);
    $parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", ()=>$6df62a94d3e772ef$export$8b77532ba9798e64);
    $parcel$export(module.exports, "softwarePlanTeamsRoute", ()=>$6df62a94d3e772ef$export$fc66f5c0de18ddc7);
    $parcel$export(module.exports, "softwareAdvancedRoadmaps1Route", ()=>$6df62a94d3e772ef$export$a3686c51bf984ef9);
    $parcel$export(module.exports, "softwareAdvancedRoadmapsRedirectRoute", ()=>$6df62a94d3e772ef$export$cc2401df741549fe);
    $parcel$export(module.exports, "softwareAdvancedRoadmaps3Route", ()=>$6df62a94d3e772ef$export$bd0ed90cfd1c0a55);
    $parcel$export(module.exports, "softwareAdvancedRoadmapsRedirect1Route", ()=>$6df62a94d3e772ef$export$264157b237e791ea);
    $parcel$export(module.exports, "softwareAdvancedRoadmaps5Route", ()=>$6df62a94d3e772ef$export$158bfed3a17a3f80);
    $parcel$export(module.exports, "softwareAdvancedRoadmapsSetupRoute", ()=>$6df62a94d3e772ef$export$442daaf7ae9abf13);
    $parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", ()=>$6df62a94d3e772ef$export$38c76ea9ddc85b3);
    var $65Ltd;
    const $6df62a94d3e772ef$export$21d57208bfbf7e92 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId/scenarios/:scenarioId'
    };
    const $6df62a94d3e772ef$export$ad8296aa5394f696 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
    };
    const $6df62a94d3e772ef$export$25a8cf27557a612d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
        path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
    };
    const $6df62a94d3e772ef$export$ca4c39d60ec156a2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
        path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
    };
    const $6df62a94d3e772ef$export$850236b64b0aa28b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
    };
    const $6df62a94d3e772ef$export$61abeb6a03d23dd3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
        path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
    };
    const $6df62a94d3e772ef$export$6734c29372722a5e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
    };
    const $6df62a94d3e772ef$export$a0fec30f475e8756 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
    };
    const $6df62a94d3e772ef$export$3d54c48a91a178c0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
    };
    const $6df62a94d3e772ef$export$76e6bdc959f6fa97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
    };
    const $6df62a94d3e772ef$export$a215ef374dd2a8a9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
    };
    const $6df62a94d3e772ef$export$d32efeefb944c6b7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
    };
    const $6df62a94d3e772ef$export$e44088b2cc0206cf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
    };
    const $6df62a94d3e772ef$export$2634cd63c73f7a35 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
    };
    const $6df62a94d3e772ef$export$358b0ca69a4bd731 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
    };
    const $6df62a94d3e772ef$export$fa18324265e4400c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
    };
    const $6df62a94d3e772ef$export$ab61883f74eb27c2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
    };
    const $6df62a94d3e772ef$export$8b77532ba9798e64 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
    };
    const $6df62a94d3e772ef$export$fc66f5c0de18ddc7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
    };
    const $6df62a94d3e772ef$export$a3686c51bf984ef9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId(\\d+)'
    };
    const $6df62a94d3e772ef$export$cc2401df741549fe = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
        path: '/secure/PortfolioPlanView.jspa'
    };
    const $6df62a94d3e772ef$export$bd0ed90cfd1c0a55 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/reports/:reportId'
    };
    const $6df62a94d3e772ef$export$264157b237e791ea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
        path: '/secure/PortfolioReportView.jspa'
    };
    const $6df62a94d3e772ef$export$158bfed3a17a3f80 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/export'
    };
    const $6df62a94d3e772ef$export$442daaf7ae9abf13 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
        path: '/jira/plans/:planId/setup'
    };
    const $6df62a94d3e772ef$export$38c76ea9ddc85b3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
        path: '/secure/PortfolioGettingStarted.jspa'
    };
});
parcelRegister("4zCFt", function(module, exports) {
    $parcel$export(module.exports, "planIncrementsRoute", ()=>$e7d023757e398cfb$export$d0986e4bd9568b30);
    $parcel$export(module.exports, "planIncrementRoute", ()=>$e7d023757e398cfb$export$ef33a75556fde209);
    $parcel$export(module.exports, "archivedPlansRoute", ()=>$e7d023757e398cfb$export$29647353386ad146);
    $parcel$export(module.exports, "trashedPlansRoute", ()=>$e7d023757e398cfb$export$b1d2299a57fca83a);
    $parcel$export(module.exports, "trashedPlanDirectLinkRoute", ()=>$e7d023757e398cfb$export$1a9edb72cd49ca79);
    $parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", ()=>$e7d023757e398cfb$export$7208300f00a36a5f);
    var $65Ltd;
    const $e7d023757e398cfb$export$d0986e4bd9568b30 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program'
    };
    const $e7d023757e398cfb$export$ef33a75556fde209 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId'
    };
    const $e7d023757e398cfb$export$29647353386ad146 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY),
        path: '/jira/plans/settings/archive'
    };
    const $e7d023757e398cfb$export$b1d2299a57fca83a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PLANS_DIRECTORY),
        path: '/jira/plans/settings/trash'
    };
    const $e7d023757e398cfb$export$1a9edb72cd49ca79 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK),
        path: '/jira/plans/plan-trashed',
        exact: true
    };
    const $e7d023757e398cfb$export$7208300f00a36a5f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR),
        path: '/jira/plans/settings/financial-year'
    };
});
parcelRegister("2r2vQ", function(module, exports) {
    $parcel$export(module.exports, "softwareArjSettingsDependenciesRoute", ()=>$9433f6efcfaf833c$export$e657c8aeaaf0932c);
    $parcel$export(module.exports, "softwareArjSettingsDependenciesRedirectRoute", ()=>$9433f6efcfaf833c$export$b55de156ac5f7c1b);
    $parcel$export(module.exports, "softwareArjSettingsLoadingLimitsRoute", ()=>$9433f6efcfaf833c$export$21eaa019c724fc9a);
    $parcel$export(module.exports, "softwareArjSettingsLoadingLimitsRedirectRoute", ()=>$9433f6efcfaf833c$export$c72a1b9971af07d9);
    $parcel$export(module.exports, "softwareArjSettingsPermissionsRoute", ()=>$9433f6efcfaf833c$export$6372897c47d731c0);
    $parcel$export(module.exports, "softwareArjSettingsPermissionsRedirectRoute", ()=>$9433f6efcfaf833c$export$4523847db2f1a42e);
    var $65Ltd;
    const $9433f6efcfaf833c$export$e657c8aeaaf0932c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES),
        path: '/jira/plans/settings/dependencies'
    };
    const $9433f6efcfaf833c$export$b55de156ac5f7c1b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT),
        path: '/secure/PortfolioDependencySettings.jspa'
    };
    const $9433f6efcfaf833c$export$21eaa019c724fc9a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS),
        path: '/jira/plans/settings/loading-limits'
    };
    const $9433f6efcfaf833c$export$c72a1b9971af07d9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT),
        path: '/secure/PortfolioLoadingLimits.jspa'
    };
    const $9433f6efcfaf833c$export$6372897c47d731c0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS),
        path: '/jira/plans/settings/permissions'
    };
    const $9433f6efcfaf833c$export$4523847db2f1a42e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT),
        path: '/secure/PortfolioPermissions.jspa'
    };
});
parcelRegister("7OYJs", function(module, exports) {
    $parcel$export(module.exports, "ScreenRedirect", ()=>$49ac470f4c9a751a$export$fdd3e60cd227c2f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $49ac470f4c9a751a$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
        const [{ route: route, location: location, query: query }] = (0, $dIdda.useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ isInitialRender: isInitial }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!route || !eventRef.current) return;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            route,
            isInitial
        ]);
        if (Array.isArray(persistSearchParams)) {
            const persistParams = Object.keys(query).reduce((result, currentKey)=>{
                const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
                if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
                return result;
            }, []).join('&');
            if (persistParams !== '') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `${to}?${persistParams}`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: to
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${to}${persistSearchParams ? location.search : ''}`
        });
    };
});
parcelRegister("bVDE5", function(module, exports) {
    $parcel$export(module.exports, "useSpaStateTransition", ()=>$1f866bb77da3c907$export$4d1974344641a2c9);
    $parcel$export(module.exports, "default", ()=>$1f866bb77da3c907$export$2e2bcd8739ae039);
    var $6RCeq;
    var $7JoAD = parcelRequire("7JoAD");
    var $7w9eZ;
    const $1f866bb77da3c907$var$getNavigationStart = ()=>{
        const timestamp = (0, (0, parcelRequire("6RCeq")).default) && (0, (0, parcelRequire("6RCeq")).default).timing && (0, (0, parcelRequire("6RCeq")).default).timing.navigationStart;
        return timestamp ? new Date(timestamp).toISOString() : undefined;
    };
    const $1f866bb77da3c907$var$getLastTransition = (currentPage, visitedPages)=>{
        if (visitedPages.length === 0) return undefined;
        const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
        const appNamesToStr = (appNames)=>appNames.join('+') || '?';
        const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
        const currPage = appNamesToStr(collectAppNames(currentPage));
        return `${prevPage} > ${currPage}`;
    };
    const $1f866bb77da3c907$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
        if (visitedPages.length === 0) return undefined;
        return currentPage.startTime;
    };
    const $1f866bb77da3c907$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
            isInitialRender: visitedPages.length === 0,
            transitionsCount: visitedPages.length,
            lastTransition: $1f866bb77da3c907$var$getLastTransition(currentPage, visitedPages),
            lastTransitionStartTime: $1f866bb77da3c907$var$getLastTransitionStartTime(currentPage, visitedPages),
            navigationStart: $1f866bb77da3c907$var$getNavigationStart(),
            currentPageId: currentPage.uuid
        });
    const $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("7w9eZ")).default), {
        displayName: 'SpaStateTransitionStateSubscriber',
        selector: $1f866bb77da3c907$export$aea217a45095ce11
    });
    const $1f866bb77da3c907$export$4d1974344641a2c9 = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $1f866bb77da3c907$export$aea217a45095ce11
    });
    var $1f866bb77da3c907$export$2e2bcd8739ae039 = $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber;
});
parcelRegister("is7uC", function(module, exports) {
    $parcel$export(module.exports, "CalendarSkeleton", ()=>$7431abe7c0a30442$export$ebc7c47cc535837e);
    $parcel$export(module.exports, "CalendarEmbedSkeleton", ()=>$7431abe7c0a30442$export$bf543fe31d33292e);
    $parcel$export(module.exports, "CalendarNoHeaderSkeleton", ()=>$7431abe7c0a30442$export$504e7b05f3c54bf2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $3a8Pq = parcelRequire("3a8Pq");
    var $eqvk7 = parcelRequire("eqvk7");
    var $hbVDT = parcelRequire("hbVDT");
    const $7431abe7c0a30442$var$customCssStyles = null;
    const $7431abe7c0a30442$export$ebc7c47cc535837e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($3a8Pq)))
        });
    const $7431abe7c0a30442$export$bf543fe31d33292e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eqvk7)))
        });
    const $7431abe7c0a30442$export$504e7b05f3c54bf2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($hbVDT))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("gnABE", function(module, exports) {
    $parcel$export(module.exports, "AppSkeletonImage", ()=>$93b95cd5afe27e51$export$45b107c5dc7b51a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $koVbs;
    var $d0Ozr;
    const $93b95cd5afe27e51$var$skeletonImageStyles = null;
    const $93b95cd5afe27e51$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "app-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($93b95cd5afe27e51$var$SkeletonWrapper, {
            style: containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: src,
            alt: `${formatMessage((0, (0, parcelRequire("d0Ozr")).default).loading)}...`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
                className
            ])
        })));
    };
    const $93b95cd5afe27e51$var$SkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d0Ozr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6abc81adadf77f72$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loading: {
            "id": "skeletons.common.loading",
            "defaultMessage": "Loading"
        }
    });
});
parcelRegister("3a8Pq", function(module, exports) {
    module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();
});
parcelRegister("eqvk7", function(module, exports) {
    module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();
});
parcelRegister("hbVDT", function(module, exports) {
    module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();
});
parcelRegister("5W2CW", function(module, exports) {
    $parcel$export(module.exports, "ErrorScreen", ()=>$50454f3b2d1014d6$export$42f84e610f279c31);
    var $5uXOq = parcelRequire("5uXOq");
    var $38Y30;
    var $6AaZy;
    var $1v2QX;
    var $jMY1T;
    const $50454f3b2d1014d6$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
        delete window.__ARJ_BACKLOG_PROMISE__;
        delete window.__ARJ_INFO_METADATA_PROMISE__;
        switch(errorMessage){
            case 0, $b31dd89598859846$export$aa64437890e7b596:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
            case 0, $b31dd89598859846$export$3fe2400c9d24940d:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6AaZy")).AsyncLicenseViolationErrorPage), {
                    isEmbedded: isEmbedded
                });
            case 0, $b31dd89598859846$export$4589763db20bfd7f:
            case 0, $b31dd89598859846$export$7e6358a0c21dff8c:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jMY1T")).AsyncNotFoundErrorPage), {
                    entity: (0, $b31dd89598859846$export$c303e491e026ebc6),
                    isEmbedded: isEmbedded
                });
            case 0, $b31dd89598859846$export$6519152a5f0e081:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jMY1T")).AsyncNotFoundErrorPage), {
                    entity: (0, $b31dd89598859846$export$9b928fc5e710e864),
                    isEmbedded: isEmbedded,
                    planId: planId
                });
            case 0, $b31dd89598859846$export$6128dc888243fa0a:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1v2QX")).AsyncNoPlanPermissionErrorPage), {
                    isEmbedded: isEmbedded
                });
            default:
                return null;
        }
    };
});
parcelRegister("38Y30", function(module, exports) {
    $parcel$export(module.exports, "RedirectToLoginPage", ()=>$08f8c3f776d557a9$export$938182bd3fddc3a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>(0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            dangerouslySetInnerHTML: {
                __html: `window.location.assign("${to}")`
            }
        });
    $08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
    const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
        const [{ location: { pathname: pathname, search: search } }] = (0, $dIdda.useRouter)();
        const redirectUrl = pathname + search;
        const encodedRedirectUrl = encodeURIComponent(redirectUrl);
        let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
        const parentProductQueryName = 'parentProduct';
        const [parentProduct] = (0, $dIdda.useQueryParam)(parentProductQueryName);
        if (pathname.endsWith('/embed')) {
            const searchParams = new URLSearchParams(search);
            searchParams.delete(parentProductQueryName);
            let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
            if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
            const encodedParentProduct = encodeURIComponent(parentProduct || '');
            path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
        }
        return false ? (0, ($parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
            to: path
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: path
        });
    };
});
const $b31dd89598859846$export$aa64437890e7b596 = 'permission-violation';
const $b31dd89598859846$export$3fe2400c9d24940d = 'license-violation';
const $b31dd89598859846$export$4589763db20bfd7f = 'plan-not-found';
const $b31dd89598859846$export$6519152a5f0e081 = 'scenario-not-found';
const $b31dd89598859846$export$7e6358a0c21dff8c = 'report-not-found';
const $b31dd89598859846$export$6128dc888243fa0a = 'no-plan-permission';
const $b31dd89598859846$export$c303e491e026ebc6 = 'PLAN';
const $b31dd89598859846$export$9b928fc5e710e864 = 'SCENARIO';
parcelRegister("6AaZy", function(module, exports) {
    $parcel$export(module.exports, "AsyncLicenseViolationErrorPage", ()=>$05d56fdddce8137e$export$f5d9764f07badc4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $05d56fdddce8137e$var$LazyLicenseViolationErrorPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eidU9")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
    });
    const $05d56fdddce8137e$export$f5d9764f07badc4d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-license-violation-page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($05d56fdddce8137e$var$LazyLicenseViolationErrorPage, props));
});
parcelRegister("eidU9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("ikYJz")
    ]).then(()=>parcelRequire('cGdIS'));
});
parcelRegister("1v2QX", function(module, exports) {
    $parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", ()=>$d08fb773ac6c1816$export$e595d2c5dfcb1d5a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6Qy3Y")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
    });
    const $d08fb773ac6c1816$export$e595d2c5dfcb1d5a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-no-plan-permission",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage, props));
});
parcelRegister("6Qy3Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("db3ID")
    ]).then(()=>parcelRequire('dycHB'));
});
parcelRegister("jMY1T", function(module, exports) {
    $parcel$export(module.exports, "AsyncNotFoundErrorPage", ()=>$900bf2ccc30cc7be$export$8f6c907860218fdc);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $900bf2ccc30cc7be$var$LazyNotFoundErrorPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("Fac9v")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
    });
    const $900bf2ccc30cc7be$export$8f6c907860218fdc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-not-found-page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($900bf2ccc30cc7be$var$LazyNotFoundErrorPage, props));
});
parcelRegister("Fac9v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("4cS57")
    ]).then(()=>parcelRequire('3jte6'));
});
parcelRegister("adY3A", function(module, exports) {
    $parcel$export(module.exports, "topNavigationEntryPoint", ()=>$e6a45c27809ae082$export$f780be9e138f456f);
    var $eufEc;
    var $fEDBv;
    const $e6a45c27809ae082$export$f780be9e138f456f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("lesge")), {
            moduleId: "1f1265b4"
        }),
        getPreloadProps: (extraProps)=>({
                extraProps: extraProps
            })
    });
});
parcelRegister("lesge", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1eG9i")
    ]).then(()=>parcelRequire('9DfkH'));
});
parcelRegister("cSD7y", function(module, exports) {
    $parcel$export(module.exports, "componentWithFG", ()=>$9b560cafc84bf9e8$export$cf56d0f54cfcce4);
    var $7XYc4;
    var $4R6GH;
    const $9b560cafc84bf9e8$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)(gateName), ComponentTrue, ComponentFalse);
});
parcelRegister("98rs3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("axKNq")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gsa5D")
    ]).then(()=>parcelRequire('5zu1k'));
});
parcelRegister("5wS2n", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5ubvA")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b7hCy")
    ]).then(()=>parcelRequire('8ipiN'));
});
parcelRegister("fQisF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4XDQa")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8czeq")
    ]).then(()=>parcelRequire('9WfFd'));
});
parcelRegister("35mct", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("bxjtM")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jcetw")
    ]).then(()=>parcelRequire('f3Kyg'));
});
parcelRegister("cP24C", function(module, exports) {
    $parcel$export(module.exports, "useAdvancedRoadmapsSummaryDataResource", ()=>$d012d2ead08788e3$export$263a4c831540778e);
    $parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", ()=>(parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource);
    var $dIdda = parcelRequire("dIdda");
    var $lv9xW;
    var $gZ6zR;
    const $d012d2ead08788e3$export$263a4c831540778e = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource));
});
parcelRegister("gZ6zR", function(module, exports) {
    $parcel$export(module.exports, "IssueStatus", ()=>$ad83cd0410dc011b$export$559eb15a98685419);
    $parcel$export(module.exports, "BlockType", ()=>$ad83cd0410dc011b$export$48808c686fe495c4);
    const $ad83cd0410dc011b$export$559eb15a98685419 = {
        TODO: 'TODO',
        IN_PROGRESS: 'IN_PROGRESS',
        DONE: 'DONE'
    };
    const $ad83cd0410dc011b$export$de194318c6dccbc1 = {
        INITIATIVE: 'INITIATIVE',
        EPIC: 'EPIC'
    };
    const $ad83cd0410dc011b$export$48808c686fe495c4 = {
        DELAY_WORK: 'DELAY_WORK',
        CRITICAL_PATH: 'CRITICAL_PATH',
        BLOCK_WORK: 'BLOCK_WORK'
    };
});
parcelRegister("63ju8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("8kWVn")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("83FIe")
    ]).then(()=>parcelRequire('3Wpua'));
});
parcelRegister("q7sYD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("6uHGD")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("29Kha")
    ]).then(()=>parcelRequire('iL9n8'));
});
parcelRegister("2Fj5v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9ddf603830cf6c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("5qELD")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
    });
    const $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalProductsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar, null)));
    $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
    var $a9ddf603830cf6c5$export$2e2bcd8739ae039 = $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar;
});
parcelRegister("5qELD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3FDyC")
    ]).then(()=>parcelRequire('hTSvC'));
});
parcelRegister("3DNgf", function(module, exports) {
    $parcel$export(module.exports, "issueLinkInformationResource", ()=>$8163e55c16e335dc$export$8d8544ca08d98837);
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $8163e55c16e335dc$var$body = {
        providers: [
            'issueLinks',
            'dependencySettings'
        ]
    };
    const $8163e55c16e335dc$var$url = '/rest/jpo/1.0/info/query';
    const $8163e55c16e335dc$var$fetchIssueLinkInformation = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)($8163e55c16e335dc$var$url, {
            body: JSON.stringify($8163e55c16e335dc$var$body)
        });
    const $8163e55c16e335dc$export$8d8544ca08d98837 = (0, $dIdda.createResource)({
        type: 'ISSUE_LINK_INFORMATION',
        getKey: ()=>'issue-link-information',
        getData: async ()=>$8163e55c16e335dc$var$fetchIssueLinkInformation(),
        maxAge: 0
    });
});
parcelRegister("ar2Tl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bLzp5")
    ]).then(()=>parcelRequire('1Ba8D'));
});
parcelRegister("azWKH", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsLoadingLimitsResource", ()=>$a9399ce8867d02dc$export$c9e47fa9b57975f5);
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    const $a9399ce8867d02dc$export$c9e47fa9b57975f5 = (0, $dIdda.createResource)({
        type: (0, $a9d74ae4a12ce55b$export$cd7bb91dd2e30684),
        getKey: ()=>'loading-limits-information',
        getData: async ()=>(0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/configuration'),
        maxAge: 0
    });
});
const $a9d74ae4a12ce55b$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';
parcelRegister("fvcVN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("7EBJU")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bDZ6z")
    ]).then(()=>parcelRequire('ieFCi'));
});
parcelRegister("1aR84", function(module, exports) {
    $parcel$export(module.exports, "grantedPermissionsResource", ()=>$d675e556a71c706a$export$aa3daf3280e2a2d7);
    $parcel$export(module.exports, "permissionGroupsResource", ()=>$d675e556a71c706a$export$950060d83722e3bd);
    $parcel$export(module.exports, "getGlobalPermissionPageResources", ()=>$d675e556a71c706a$export$a09a91246a866817);
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $d675e556a71c706a$var$fetchGrantedPermissions = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)('/rest/roadmaps/1.0/info/query', {
            body: JSON.stringify({
                providers: [
                    'permissions'
                ]
            })
        });
    const $d675e556a71c706a$var$fetchPermissionGroups = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)('/rest/jpo/1.0/groupsandusers', {
            body: JSON.stringify({
                includeUsers: false,
                excludedGroups: [],
                excludedUsers: [],
                query: ''
            })
        });
    const $d675e556a71c706a$export$aa3daf3280e2a2d7 = (0, $dIdda.createResource)({
        type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
        getKey: ()=>'arj-granted-permissions',
        getData: async ()=>$d675e556a71c706a$var$fetchGrantedPermissions(),
        maxAge: 0
    });
    const $d675e556a71c706a$export$950060d83722e3bd = (0, $dIdda.createResource)({
        type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
        getKey: ()=>'arj-permission-groups',
        getData: async ()=>$d675e556a71c706a$var$fetchPermissionGroups(),
        maxAge: 0
    });
    const $d675e556a71c706a$export$a09a91246a866817 = ()=>[
            $d675e556a71c706a$export$aa3daf3280e2a2d7,
            $d675e556a71c706a$export$950060d83722e3bd
        ];
});
parcelRegister("julIg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("31VzL")
    ]).then(()=>parcelRequire('luimD'));
});
parcelRegister("7j3uW", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsFinancialYearResource", ()=>$59a235170c0d382a$export$da45020eede4a793);
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    const $59a235170c0d382a$export$da45020eede4a793 = (0, $dIdda.createResource)({
        type: (0, $b242b5aa0787944c$export$e8e0384e95388aa3),
        getKey: ()=>'financial-year-information',
        getData: async ()=>(0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/fiscalYear'),
        maxAge: 0
    });
});
const $b242b5aa0787944c$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';
parcelRegister("3YFhg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("19M8q")
    ]).then(()=>parcelRequire('14EEk'));
});
parcelRegister("4JKpA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("64R0p")),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8elb9")
    ]).then(()=>parcelRequire('laRNy'));
});
parcelRegister("9LXXc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("573g9")
    ]).then(()=>parcelRequire('95BjK'));
});
parcelRegister("hf3HX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hCaEC")
    ]).then(()=>parcelRequire('7bDNN'));
});
parcelRegister("1VgiI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1U1DX").then(()=>parcelRequire('kIqMQ'));
});
parcelRegister("5WOuA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("ioM1b")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("LIqdo")
    ]).then(()=>parcelRequire('ecw8s'));
});
parcelRegister("2n942", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("auj8r")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aEaZR")
    ]).then(()=>parcelRequire('1rmO9'));
});
parcelRegister("lBp9O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gWdbV")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gF51l")
    ]).then(()=>parcelRequire('9UXSF'));
});
parcelRegister("2cXwo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5TMh3")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kssvB")
    ]).then(()=>parcelRequire('9U7wJ'));
});
parcelRegister("cVT1A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4NK3n")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1osJI")
    ]).then(()=>parcelRequire('j09X0'));
});
parcelRegister("b5b81", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("krPFv")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cQMR4")
    ]).then(()=>parcelRequire('8InOA'));
});
parcelRegister("hy8Qs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("jGDgV")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("fi5lj")
    ]).then(()=>parcelRequire('ZLjUl'));
});
parcelRegister("4A9Do", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("h4JBs")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9lRZr")
    ]).then(()=>parcelRequire('1GCm8'));
});
parcelRegister("elgx3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("cSV9k")),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fHQhR")
    ]).then(()=>parcelRequire('dx76p'));
});
parcelRegister("El4ba", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("deC5G")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8REMF")
    ]).then(()=>parcelRequire('8aOgd'));
});
parcelRegister("i7FRg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("1QmTP")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6qkFP")
    ]).then(()=>parcelRequire('cckoo'));
});
parcelRegister("3Wjz9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4f2RV")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("5hVzx")
    ]).then(()=>parcelRequire('mRA5P'));
});
parcelRegister("vcVXi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4IywT")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("81iXg")
    ]).then(()=>parcelRequire('k5TsF'));
});
parcelRegister("jxqka", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("a8N0m")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dZydx")
    ]).then(()=>parcelRequire('iF2yt'));
});
parcelRegister("1yuH3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5gjrg")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("X6lWy")
    ]).then(()=>parcelRequire('j3U5Q'));
});
parcelRegister("7z32m", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("g1QGP")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("itwp0")
    ]).then(()=>parcelRequire('j7IwW'));
});
parcelRegister("38bH9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("aRh7g")
    ]).then(()=>parcelRequire('bF4NR'));
});
parcelRegister("aKeDz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aLLse").then(()=>parcelRequire('hCnfn'));
});
parcelRegister("4jMkc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb7b1354cffbd527$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("2n134")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
    });
    const $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalProjectsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar, null)));
    $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
    var $bb7b1354cffbd527$export$2e2bcd8739ae039 = $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar;
});
parcelRegister("2n134", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lhVk0")
    ]).then(()=>parcelRequire('1tunp'));
});
parcelRegister("eoLhh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8Dqf0")
    ]).then(()=>parcelRequire('jOclj'));
});
parcelRegister("l71WK", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalProjectNav", ()=>$7e6dac351b79a914$export$862dd1c0126bb181);
    $parcel$export(module.exports, "AsyncHorizontalOverviewNav", ()=>$7e6dac351b79a914$export$beabdf5c49f01377);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $7e6dac351b79a914$var$LazyHorizontalProjectNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("h16ll")), {
        moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
    });
    const $7e6dac351b79a914$export$862dd1c0126bb181 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalProjectNav, null));
    const $7e6dac351b79a914$var$LazyHorizontalOverviewNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("exvyI")), {
        moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
    });
    const $7e6dac351b79a914$export$beabdf5c49f01377 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-overview-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalOverviewNav, null));
});
parcelRegister("h16ll", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4RRJO")
    ]).then(()=>parcelRequire('bwmXM'));
});
parcelRegister("exvyI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hTo1l")
    ]).then(()=>parcelRequire('bNzBR'));
});
parcelRegister("9QpK7", function(module, exports) {
    $parcel$export(module.exports, "componentWithFF", ()=>$4adaf4a620447263$export$377d327ec8da8be);
    var $co1wz;
    var $7XYc4;
    const $4adaf4a620447263$export$377d327ec8da8be = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)(featureFlagName), ComponentTrue, ComponentFalse);
});
parcelRegister("gyYxw", function(module, exports) {
    $parcel$export(module.exports, "genericProjectLayout", ()=>$177735c975452188$export$85dad8e9886563f6);
    var $18N1t;
    var $1XrjK;
    var $6Z2mh;
    var $e7bC3;
    var $9Y3Lc;
    const $177735c975452188$export$85dad8e9886563f6 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, (0, parcelRequire("18N1t")).coreProjectLayout), (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("9Y3Lc")).userBoardLayout));
});
parcelRegister("18N1t", function(module, exports) {
    $parcel$export(module.exports, "coreProjectLayout", ()=>$32b20434a17da609$export$3c06ced9943ca671);
    var $1Du13;
    var $1XrjK;
    const $32b20434a17da609$export$3c06ced9943ca671 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
});
parcelRegister("1Du13", function(module, exports) {
    $parcel$export(module.exports, "projectLayout", ()=>$08491b76212b7395$export$204149bac601d20c);
    var $fpzhz;
    var $1XrjK;
    var $kxZPA;
    var $hMrxB;
    const $08491b76212b7395$var$withAnyProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: 'any'
            }
        });
    const $08491b76212b7395$var$ProjectTrackers = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8RliR")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
    });
    const $08491b76212b7395$var$ProjectFavicon = ()=>{
        (0, (0, parcelRequire("hMrxB")).useProjectFavicon)();
        return null;
    };
    const $08491b76212b7395$var$rightSidebars = ()=>[];
    const $08491b76212b7395$var$globalComponents = [
        $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectFavicon),
        $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectTrackers),
        $08491b76212b7395$var$withAnyProjectContext((0, (0, parcelRequire("fpzhz")).ProjectRouteListener))
    ];
    const $08491b76212b7395$export$204149bac601d20c = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: $08491b76212b7395$var$globalComponents,
        rightSidebars: $08491b76212b7395$var$rightSidebars()
    });
});
parcelRegister("fpzhz", function(module, exports) {
    $parcel$export(module.exports, "ProjectRouteListener", ()=>$a96b9050ddfb05f9$export$159f09d701320911);
    var $5uXOq = parcelRequire("5uXOq");
    var $dxCvy;
    var $itmJb;
    var $dIdda = parcelRequire("dIdda");
    var $hVf1M;
    const $a96b9050ddfb05f9$export$159f09d701320911 = ()=>{
        const isSiteAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { data: data, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        (0, $5uXOq.useEffect)(()=>{
            if (isSiteAdmin) (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: true
            });
            else if (data != null) (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: data.isProjectAdmin
            });
            else (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: loading,
                isProjectAdmin: null
            });
        }, [
            data,
            loading,
            isSiteAdmin
        ]);
        (0, $5uXOq.useEffect)(()=>()=>(0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                    loading: false,
                    isProjectAdmin: null
                }), []);
        return null;
    };
});
parcelRegister("itmJb", function(module, exports) {
    $parcel$export(module.exports, "useIsAdmin", ()=>$dfb6d33a8a8c98ed$export$99a5e4bc80d231ca);
    var $9OXo1;
    const $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isAdmin || false;
    };
});
parcelRegister("hVf1M", function(module, exports) {
    $parcel$export(module.exports, "getIsProjectAdmin", ()=>$d8c128d9b214e073$export$34ff06260ad17f2b);
    $parcel$export(module.exports, "setIsProjectAdmin", ()=>$d8c128d9b214e073$export$d53e6d79d3fa5f31);
    let $d8c128d9b214e073$var$projectAdmin = null;
    const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
        if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
        if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
        return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
    };
    const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
        $d8c128d9b214e073$var$projectAdmin = projectAdminState;
    };
});
parcelRegister("hMrxB", function(module, exports) {
    $parcel$export(module.exports, "useProjectFavicon", ()=>$6ee68e956a566e2d$export$32abcb1f939de016);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    var $lpwtK;
    const $6ee68e956a566e2d$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const iconEle = document.querySelector("link[rel='shortcut icon']");
        const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
            iconEle
        ]);
        const enabled = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-favicon-use-projecticon') === 'true', []);
        (0, $5uXOq.useEffect)(()=>{
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }, [
            project,
            iconEle,
            defaultFavicon,
            enabled
        ]);
    };
});
parcelRegister("8RliR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("gw9ua")
    ]).then(()=>parcelRequire('8DuT4'));
});
parcelRegister("6Z2mh", function(module, exports) {
    $parcel$export(module.exports, "serviceProjectLayout", ()=>$0836cf39cca1e468$export$e321cb31c875d1ba);
    $parcel$export(module.exports, "rightSidebarsLayout", ()=>$0836cf39cca1e468$export$820f9bb834280408);
    var $2vSU6;
    var $2BrOV;
    var $i90UH;
    var $1Du13;
    var $1XrjK;
    var $ln7rs;
    var $kxZPA;
    const $0836cf39cca1e468$var$withServiceProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)
            }
        });
    const $0836cf39cca1e468$var$ProjectBuilder = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9p3bS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/index.tsx"
    });
    const $0836cf39cca1e468$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hqzS2")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
    });
    const $0836cf39cca1e468$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("dyNBT")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $0836cf39cca1e468$export$e321cb31c875d1ba = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout), {
        globalComponents: [
            $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$Onboarding),
            ...(0, (0, parcelRequire("ln7rs")).serviceProjectFirstImpressionsLayout).globalComponents.map($0836cf39cca1e468$var$withServiceProjectContext),
            $0836cf39cca1e468$var$withServiceProjectContext((0, (0, parcelRequire("i90UH")).AsyncJsmCustomDomainChangeBoardingFlag)),
            $0836cf39cca1e468$var$ProjectBuilder
        ],
        rightSidebars: [
            $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$RightSidebars),
            ...(0, (0, parcelRequire("ln7rs")).serviceProjectFirstImpressionsLayout).rightSidebars.map($0836cf39cca1e468$var$withServiceProjectContext)
        ]
    });
    const $0836cf39cca1e468$export$820f9bb834280408 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), {
        rightSidebars: [
            $0836cf39cca1e468$var$RightSidebars
        ]
    });
});
parcelRegister("i90UH", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", ()=>$3ba5f01428db990d$export$b1ef5e3da6e1959d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fPVwK")), {
        moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
    });
    const $3ba5f01428db990d$export$b1ef5e3da6e1959d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-jsm-custom-domain-change-boarding-flag",
            packageName: "jira-help-center-custom-domain-change-boarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-custom-domain-change-boarding-flag",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));
});
parcelRegister("fPVwK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("fgCot")
    ]).then(()=>parcelRequire('9d42Z'));
});
parcelRegister("ln7rs", function(module, exports) {
    $parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", ()=>$f6f2168537ade4c7$export$2562b2d784eadc10);
    var $5uXOq = parcelRequire("5uXOq");
    var $4YIAU;
    var $1XrjK;
    var $kxZPA;
    const $f6f2168537ade4c7$var$withServiceProjectAccess = (Component)=>{
        const ScopedComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YIAU")).default), {
                hasServiceDeskAccess: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null));
        const name = (0, (0, parcelRequire("1XrjK")).coalesce)(Component.displayName) ?? (0, (0, parcelRequire("1XrjK")).coalesce)(Component.name) ?? 'Component';
        ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
        return ScopedComponent;
    };
    const $f6f2168537ade4c7$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("4IHta")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
    });
    const $f6f2168537ade4c7$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hfniT")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/index.tsx"
    });
    const $f6f2168537ade4c7$export$2562b2d784eadc10 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$Onboarding)
        ],
        rightSidebars: [
            $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$RightSidebars)
        ]
    });
});
parcelRegister("4YIAU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d82237ab91dce08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $1Yett;
    const $8d82237ab91dce08$var$AppPermissionsCheck = (props)=>{
        const { appPermissions: appPermissions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
            if ((0, (0, parcelRequire("1Yett")).isDevelopmentEnv)()) console.warn('AppPermissionsCheck should have defined at least one of access prop');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        }
        return null;
    };
    $8d82237ab91dce08$var$AppPermissionsCheck.defaultProps = {
        hasCoreAccess: undefined,
        hasSoftwareAccess: undefined,
        hasServiceDeskAccess: undefined
    };
    var $8d82237ab91dce08$export$2e2bcd8739ae039 = $8d82237ab91dce08$var$AppPermissionsCheck;
});
parcelRegister("1Yett", function(module, exports) {
    $parcel$export(module.exports, "isDevelopmentEnv", ()=>$7b47955f7b675219$export$48e5fb80244b95c5);
    const $7b47955f7b675219$export$48e5fb80244b95c5 = ()=>false;
});
parcelRegister("4IHta", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lBhEF")
    ]).then(()=>parcelRequire('fY1ne'));
});
parcelRegister("hfniT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("jlA2G")
    ]).then(()=>parcelRequire('lBfZ6'));
});
parcelRegister("9p3bS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b77bX").then(()=>parcelRequire('fT1Vy'));
});
parcelRegister("hqzS2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eZivQ")
    ]).then(()=>parcelRequire('dOvA3'));
});
parcelRegister("dyNBT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8Ww2s")
    ]).then(()=>parcelRequire('4D7Qi'));
});
parcelRegister("e7bC3", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareProjectLayout", ()=>$43d4c7537a1fee65$export$3791efdd32024063);
    $parcel$export(module.exports, "softwareProjectLayout", ()=>$43d4c7537a1fee65$export$9a918616afa3328c);
    $parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", ()=>$43d4c7537a1fee65$export$ada52b1309832862);
    $parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", ()=>$43d4c7537a1fee65$export$6c1958653c44ba37);
    $parcel$export(module.exports, "softwareProjectLayoutCode", ()=>$43d4c7537a1fee65$export$ab7e607e8441dc61);
    var $2vSU6;
    var $1Du13;
    var $1XrjK;
    var $kxZPA;
    const $43d4c7537a1fee65$var$withAnySoftwareProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)
            }
        });
    const $43d4c7537a1fee65$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8vADS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
    });
    const $43d4c7537a1fee65$var$OnboardingCode = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("nvZ7o")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/index.tsx"
    });
    const $43d4c7537a1fee65$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9Md0O")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $43d4c7537a1fee65$var$RightSidebarsCode = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("eDMeh")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/index.tsx"
    });
    const $43d4c7537a1fee65$var$SoftWareOnboarding = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$Onboarding);
    const $43d4c7537a1fee65$var$SoftWareOnboardingCode = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$OnboardingCode);
    const $43d4c7537a1fee65$var$nonSettingsRightSidebars = [
        $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebars)
    ];
    const $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode = [
        $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebarsCode)
    ];
    const $43d4c7537a1fee65$var$sharedSoftwareProjectLayout = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout), {});
    const $43d4c7537a1fee65$export$3791efdd32024063 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboarding
        ]
    });
    const $43d4c7537a1fee65$export$9a918616afa3328c = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboarding
        ]
    });
    const $43d4c7537a1fee65$export$ada52b1309832862 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
    const $43d4c7537a1fee65$export$6c1958653c44ba37 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
    const $43d4c7537a1fee65$export$ab7e607e8441dc61 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboardingCode
        ]
    });
});
parcelRegister("8vADS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("5zn1B")
    ]).then(()=>parcelRequire('67mQl'));
});
parcelRegister("nvZ7o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9CFKR")
    ]).then(()=>parcelRequire('c0mAV'));
});
parcelRegister("9Md0O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("29qdR")
    ]).then(()=>parcelRequire('fHATI'));
});
parcelRegister("eDMeh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8pyxb")
    ]).then(()=>parcelRequire('3YyXe'));
});
parcelRegister("9Y3Lc", function(module, exports) {
    $parcel$export(module.exports, "userBoardLayout", ()=>$1760a1663e36faa5$export$7092b4ee86ae0b71);
    var $1XrjK;
    const $1760a1663e36faa5$export$7092b4ee86ae0b71 = (0, (0, parcelRequire("1XrjK")).createLayout)();
});
parcelRegister("dmKXV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac63d95d52d9688b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ac63d95d52d9688b$var$LazyCoreProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return Promise.resolve((parcelRequire("8rIQt"))).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
    });
    const $ac63d95d52d9688b$var$CoreProjectSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "coreProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac63d95d52d9688b$var$LazyCoreProjectSidebar, null));
    var $ac63d95d52d9688b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($ac63d95d52d9688b$var$CoreProjectSidebar);
});
parcelRegister("koWFd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73e9a7a50d60fc40$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("ioGL3")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
    });
    const $73e9a7a50d60fc40$var$SoftwareProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "softwareProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar, null)));
    $73e9a7a50d60fc40$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
    var $73e9a7a50d60fc40$export$2e2bcd8739ae039 = $73e9a7a50d60fc40$var$SoftwareProjectSidebar;
});
parcelRegister("ioGL3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4OI1j")
    ]).then(()=>parcelRequire('4WgKv'));
});
parcelRegister("h0bZU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca3f1b5dd616f02b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ca3f1b5dd616f02b$export$5b9febabdab63fba = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("in19N")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
    });
    const $ca3f1b5dd616f02b$var$ServicedeskSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "servicedeskProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$5b9febabdab63fba, null)));
    $ca3f1b5dd616f02b$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
    var $ca3f1b5dd616f02b$export$2e2bcd8739ae039 = $ca3f1b5dd616f02b$var$ServicedeskSidebar;
});
parcelRegister("in19N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aOxtZ")
    ]).then(()=>parcelRequire('eufGV'));
});
parcelRegister("9s3j1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed71aad279526f75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("fXenH")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
    });
    const $ed71aad279526f75$var$ClassicSoftwareProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "classicSoftwareProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar, null)));
    $ed71aad279526f75$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
    var $ed71aad279526f75$export$2e2bcd8739ae039 = $ed71aad279526f75$var$ClassicSoftwareProjectSidebar;
});
parcelRegister("fXenH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hXBFn")
    ]).then(()=>parcelRequire('dydBa'));
});
parcelRegister("lNicp", function(module, exports) {
    $parcel$export(module.exports, "getBusinessProjectResources", ()=>$492115de1a4c9f28$export$20e8c2951e444b08);
    $parcel$export(module.exports, "getProjectViewResources", ()=>$492115de1a4c9f28$export$fcbe882e18ee4a35);
    $parcel$export(module.exports, "getOverviewViewResources", ()=>$492115de1a4c9f28$export$21c5527b459d56fe);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dAmbh;
    var $g4ZHz;
    var $iNzEe;
    var $1E3vT;
    var $jrO9m;
    var $l2N2a;
    var $9yEpR;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $7GnDe;
    const $492115de1a4c9f28$var$commonResources = [
        (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
        (0, (0, parcelRequire("iNzEe")).navigationResource)
    ];
    const $492115de1a4c9f28$export$20e8c2951e444b08 = ()=>[
            ...$492115de1a4c9f28$var$commonResources,
            (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
            (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
            (0, (0, parcelRequire("1E3vT")).navigationItemsResource)
        ];
    const $492115de1a4c9f28$export$46471673e66df5c1 = ()=>[
            ...$492115de1a4c9f28$var$commonResources,
            (0, (0, parcelRequire("jrO9m")).overviewDetailsResource)
        ];
    const $492115de1a4c9f28$export$fcbe882e18ee4a35 = ()=>[
            ...$492115de1a4c9f28$export$20e8c2951e444b08(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
    const $492115de1a4c9f28$export$21c5527b459d56fe = ()=>[
            ...$492115de1a4c9f28$export$46471673e66df5c1(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
});
parcelRegister("dAmbh", function(module, exports) {
    $parcel$export(module.exports, "configurationResource", ()=>$43ad736dfc62d10f$export$5c4ad441346dc154);
    $parcel$export(module.exports, "useRankField", ()=>$43ad736dfc62d10f$export$fffa1172af8de100);
    $parcel$export(module.exports, "useStartDateField", ()=>$43ad736dfc62d10f$export$bf78b0881400efef);
    $parcel$export(module.exports, "useIsLinkingEnabled", ()=>$43ad736dfc62d10f$export$76fc5a1eecec5a35);
    $parcel$export(module.exports, "useIsSubtasksEnabled", ()=>$43ad736dfc62d10f$export$dca58a051cb58f03);
    var $dIdda = parcelRequire("dIdda");
    var $58BMJ;
    const $43ad736dfc62d10f$var$RESOURCE_KEY = 'BUSINESS_CONFIGURATION';
    const $43ad736dfc62d10f$export$5c4ad441346dc154 = (0, $dIdda.createResource)({
        type: $43ad736dfc62d10f$var$RESOURCE_KEY,
        getKey: ()=>$43ad736dfc62d10f$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("58BMJ")).fetchConfiguration)(cloudId),
        maxAge: Infinity
    });
    const $43ad736dfc62d10f$export$b629b793d58e3884 = ()=>(0, $dIdda.useResource)($43ad736dfc62d10f$export$5c4ad441346dc154);
    const $43ad736dfc62d10f$export$fffa1172af8de100 = ()=>{
        const { data: data, loading: loading, error: error } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return {
            data: data?.rankField ?? null,
            loading: loading,
            error: error
        };
    };
    const $43ad736dfc62d10f$export$bf78b0881400efef = ()=>{
        const { data: data, loading: loading, error: error } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return {
            data: data?.startDateField ?? null,
            loading: loading,
            error: error
        };
    };
    const $43ad736dfc62d10f$export$76fc5a1eecec5a35 = ()=>{
        const { data: data } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return data?.isLinkingEnabled ?? false;
    };
    const $43ad736dfc62d10f$export$dca58a051cb58f03 = ()=>{
        const { data: data } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return data?.isSubtasksEnabled ?? false;
    };
});
parcelRegister("58BMJ", function(module, exports) {
    $parcel$export(module.exports, "fetchConfiguration", ()=>$1cb1e84b048c3101$export$9911e92fcb5c83c0);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $lKH3S;
    const $1cb1e84b048c3101$export$9911e92fcb5c83c0 = async (cloudId)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JiraBusinessConfiguration', {
                body: JSON.stringify({
                    query: (0, $5c0554031841947d$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId
                    }
                })
            });
            if (response.data == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            return (0, (0, parcelRequire("lKH3S")).transformData)(response);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessConfiguration', 'Something went wrong while fetching business configuration');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'configurationResource',
                    packageName: 'jiraRouterResourcesBusinessConfiguration',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    };
});
parcelRegister("jlq4V", function(module, exports) {
    $parcel$export(module.exports, "GraphQLErrors", ()=>$503bc83696833cc0$export$89c202e66b2de2b6);
    var $7hpBk = parcelRequire("7hpBk");
    var $8LQ84 = parcelRequire("8LQ84");
    const $503bc83696833cc0$var$generateErrorMessage = (err)=>{
        let message = '';
        if ((0, ($parcel$interopDefault($8LQ84)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
            const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += `${errorMessage}\n`;
        });
        message = message.replace(/\n$/, '');
        return message;
    };
    class $503bc83696833cc0$export$89c202e66b2de2b6 extends Error {
        constructor(graphQLErrors){
            super();
            this.graphQLErrors = graphQLErrors != null ? (0, ($parcel$interopDefault($7hpBk)))(graphQLErrors) : [];
            this.message = $503bc83696833cc0$var$generateErrorMessage(this);
            this.cause = this.graphQLErrors?.[0];
            this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
            this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
        }
    }
});
parcelRegister("7hpBk", function(module, exports) {
    var $8LQ84 = parcelRequire("8LQ84");
    function $54cdfac2bc83c2a9$var$castArray() {
        if (!arguments.length) return [];
        var value = arguments[0];
        return $8LQ84(value) ? value : [
            value
        ];
    }
    module.exports = $54cdfac2bc83c2a9$var$castArray;
});
const $5c0554031841947d$export$2b91517d6d5b4365 = `
query JiraBusinessConfiguration($cloudId: ID!) {
  jira {
    rankField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: RANK) {
      fieldId
      name
    }
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) {
      totalCount
    }
    isSubtasksEnabled(cloudId: $cloudId)
  }
}
`;
parcelRegister("lKH3S", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$0ad069c9956cd674$export$3ceb62baab058c6b);
    const $0ad069c9956cd674$export$3ceb62baab058c6b = (response)=>{
        let rankField = null;
        const rankFieldNode = response.data?.jira?.rankField;
        if (rankFieldNode != null) rankField = {
            id: rankFieldNode.fieldId,
            name: rankFieldNode.name
        };
        let startDateField = null;
        const startDateFieldNode = response.data?.jira?.startDateField;
        if (startDateFieldNode != null) startDateField = {
            id: startDateFieldNode.fieldId,
            name: startDateFieldNode.name
        };
        const isLinkingEnabled = (response.data?.jira?.issueLinkTypes?.totalCount ?? 0) !== 0;
        const isSubtasksEnabled = response.data?.jira?.isSubtasksEnabled ?? false;
        return {
            rankField: rankField,
            startDateField: startDateField,
            isLinkingEnabled: isLinkingEnabled,
            isSubtasksEnabled: isSubtasksEnabled
        };
    };
});
parcelRegister("g4ZHz", function(module, exports) {
    $parcel$export(module.exports, "fieldsResource", ()=>$410efef54f79d33f$export$8bca6c1954ae9308);
    $parcel$export(module.exports, "useFieldsResource", ()=>$410efef54f79d33f$export$c0cd85886917fe89);
    var $jlq4V;
    var $dXq4S;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $ljySl;
    var $kig09;
    const $410efef54f79d33f$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
    const $410efef54f79d33f$var$handleProjectResponse = async (promise)=>{
        const response = await promise;
        if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        return (0, (0, parcelRequire("kig09")).transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
    };
    const $410efef54f79d33f$var$handleOverviewResponse = async (promise)=>{
        const response = await promise;
        if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        return (0, (0, parcelRequire("kig09")).transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
    };
    const $410efef54f79d33f$export$8bca6c1954ae9308 = (0, $dIdda.createResource)({
        type: $410efef54f79d33f$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            if (matchedRoute.match.params.overviewId) return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
            if (match.params.overviewId) return (0, (0, parcelRequire("ljySl")).fetchFields)((0, $8441414a9e015afb$export$c378ca4a0e2c9fec), $410efef54f79d33f$var$handleOverviewResponse, {
                overviewAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'project-overview',
                    resourceId: match.params.overviewId,
                    activationId: activationId
                })
            });
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, (0, parcelRequire("ljySl")).fetchFields)((0, $8441414a9e015afb$export$4d41378da3f70f0f), $410efef54f79d33f$var$handleProjectResponse, {
                cloudId: cloudId,
                jqlContext: `project = '${projectIdOrKey}'`
            });
        },
        maxAge: 3600000
    });
    const $410efef54f79d33f$export$c0cd85886917fe89 = ()=>(0, $dIdda.useResource)($410efef54f79d33f$export$8bca6c1954ae9308);
});
parcelRegister("dXq4S", function(module, exports) {
    $parcel$export(module.exports, "isAri", ()=>$5c4418bd595ae8cf$export$8e68286aef4c3a8b);
    $parcel$export(module.exports, "createAri", ()=>$5c4418bd595ae8cf$export$594d18a0ad2e0e57);
    $parcel$export(module.exports, "toAri", ()=>$5c4418bd595ae8cf$export$24b47820a324e614);
    $parcel$export(module.exports, "toAriOrDefault", ()=>$5c4418bd595ae8cf$export$e2789192113e8b07);
    $parcel$export(module.exports, "parseAri", ()=>$5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
    $parcel$export(module.exports, "getAriConfig", ()=>$5c4418bd595ae8cf$export$3d8d7031a11613fd);
    const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
    const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
    const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
        if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
        if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
        return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
    };
    const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
        if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
        return undefined;
    };
    const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
    const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
        if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
            const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
            if (parts?.groups) {
                const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
                return {
                    resourceOwner: resourceOwner,
                    cloudId: cloudId,
                    resourceType: resourceType,
                    workspaceId: workspaceId,
                    resourceId: resourceId,
                    activationId: activationId
                };
            }
        }
        return undefined;
    };
    const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
        const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
        if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
        return config;
    };
});
parcelRegister("ljySl", function(module, exports) {
    $parcel$export(module.exports, "fetchFields", ()=>$90e7c5e5920e8507$export$f3ddd735c360919);
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    const $90e7c5e5920e8507$var$PAGE_SIZE = 100;
    const $90e7c5e5920e8507$export$f3ddd735c360919 = async (query, handler, params)=>{
        try {
            const promise = (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: {
                        first: $90e7c5e5920e8507$var$PAGE_SIZE,
                        ...params
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            });
            return await handler(promise);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fieldsResource',
                    packageName: 'jiraRouterResourcesBusinessFields',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    };
});
const $8441414a9e015afb$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $8441414a9e015afb$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;
parcelRegister("kig09", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$3d209f684c72dca4$export$3ceb62baab058c6b);
    const $3d209f684c72dca4$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);
});
parcelRegister("iNzEe", function(module, exports) {
    $parcel$export(module.exports, "navigationResource", ()=>$6b942b0827824c4b$export$62940941ee574cdc);
    $parcel$export(module.exports, "useNavigationResource", ()=>$6b942b0827824c4b$export$c17011c09e042a31);
    $parcel$export(module.exports, "useIsPremiumUserSeat", ()=>$6b942b0827824c4b$export$90749419e9042370);
    $parcel$export(module.exports, "useTriggerOverviewChangeboarding", ()=>$6b942b0827824c4b$export$30f6f0b00bf4f2f8);
    var $gccSB = parcelRequire("gccSB");
    var $dXq4S;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $geiy6;
    const $6b942b0827824c4b$export$62940941ee574cdc = (0, $dIdda.createResource)({
        type: 'BUSINESS_NAVIGATION',
        getKey: ()=>'BUSINESS_NAVIGATION',
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return null;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            if (!(0, ($parcel$interopDefault($gccSB)))(projectKey)) return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
                cloudId: cloudId,
                projectKey: projectKey
            });
            if (!(0, ($parcel$interopDefault($gccSB)))(projectId)) return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
                cloudId: cloudId,
                projectId: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'project',
                    resourceId: projectId
                })
            });
            return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
                cloudId: cloudId
            });
        },
        maxAge: Infinity
    });
    const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, $dIdda.useResource)($6b942b0827824c4b$export$62940941ee574cdc);
    const $6b942b0827824c4b$export$90749419e9042370 = ()=>{
        const { data: data } = $6b942b0827824c4b$export$c17011c09e042a31();
        if (data === 'NOT_APPLICABLE') return false;
        return Boolean(data?.isPremiumUserSeat);
    };
    const $6b942b0827824c4b$export$30f6f0b00bf4f2f8 = ()=>{
        const { data: data } = $6b942b0827824c4b$export$c17011c09e042a31();
        if (data === 'NOT_APPLICABLE') return false;
        return Boolean(data?.showPlansOnboarding);
    };
});
parcelRegister("geiy6", function(module, exports) {
    $parcel$export(module.exports, "fetchNavigation", ()=>$446f8b979bebb841$export$1fc5fff73d9a570c);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $ifwpM;
    const $446f8b979bebb841$var$EMPTY_RESPONSE = {
        recents: [],
        favorites: [],
        hasMoreFavorite: false,
        overviews: [],
        overviewsError: null,
        isPremiumUserSeat: false,
        showPlansOnboarding: false,
        shouldHideOverviews: false
    };
    const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: {
                        first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                        ...params
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response.data?.jira?.navigation === undefined) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            let areOverviewsGone = false;
            if (Array.isArray(response.errors)) areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
            return (0, (0, parcelRequire("ifwpM")).transformData)(response.data.jira.navigation, areOverviewsGone);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesBusinessNavigation',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $446f8b979bebb841$var$EMPTY_RESPONSE;
    };
});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';
parcelRegister("ifwpM", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$9031e5290b70d3d6$export$3ceb62baab058c6b);
    var $6cG4N;
    var $027FQ;
    const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
    const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite,
            permissions: {
                viewIssues: node.viewIssues.canPerform
            },
            defaultView: node.defaultView?.typeKey?.toLowerCase()
        });
    const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
            id: node.id,
            name: node.name,
            theme: node?.theme ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
        });
    const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
        if (navigation == null) return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
        let overviews = [];
        let overviewsError = null;
        const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
        if (isPremiumUserSeat) {
            if (navigation.overviews?.__typename === (0, (0, parcelRequire("027FQ")).OVERVIEWS_SUCCESS_RESPONSE_TYPE)) overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
            else overviewsError = navigation.overviews ?? new Error('Unknown overviews error');
        }
        let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
        const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
        recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
        const showPlansOnboarding = Boolean(navigation.jwmOverviewPlanMigrationState?.changeboardingActive);
        const shouldHideOverviews = areOverviewsGone && !showPlansOnboarding;
        return {
            recents: recents,
            favorites: favorites,
            hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
            overviews: overviews,
            overviewsError: overviewsError,
            isPremiumUserSeat: isPremiumUserSeat,
            showPlansOnboarding: showPlansOnboarding,
            shouldHideOverviews: shouldHideOverviews
        };
    };
});
parcelRegister("6cG4N", function(module, exports) {
    $parcel$export(module.exports, "STAR_ICON_COLOR", ()=>$cd302866fea6f361$export$9e0962e0cb41695d);
    $parcel$export(module.exports, "Variables", ()=>$cd302866fea6f361$export$8bb9d79ea938efc9);
    $parcel$export(module.exports, "Tokens", ()=>$cd302866fea6f361$export$8e1e81ac145e31be);
    $parcel$export(module.exports, "BASE_THEME", ()=>$cd302866fea6f361$export$8a6e9b3370a0f87a);
    $parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", ()=>$cd302866fea6f361$export$f286efa6bd1e8f9d);
    $parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", ()=>$cd302866fea6f361$export$97cb21c6432e07e8);
    $parcel$export(module.exports, "GRADIENT_THEME", ()=>$cd302866fea6f361$export$b124f62a6aab972);
    $parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$9441e0d8f766c59a);
    $parcel$export(module.exports, "NO_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$4c351ec1dc290344);
    $parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", ()=>$cd302866fea6f361$export$34373eced7ee212e);
    $parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", ()=>$cd302866fea6f361$export$5ddfadab7b1e12c1);
    $parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", ()=>$cd302866fea6f361$export$349e5dbeac874253);
    $parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", ()=>$cd302866fea6f361$export$242b2d2213fedf27);
    $parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", ()=>$cd302866fea6f361$export$fe05a238062e2c3d);
    $parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$cab9d853866386f2);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$cd302866fea6f361$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", ()=>$cd302866fea6f361$export$8e357501548afe78);
    $parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$baaf8255c30ea280);
    $parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$d9035bc768f8226d);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$4810531e30462f89);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$1c0b806722927549);
    $parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$2af5673c2fa63c55);
    $parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$5771162cdeebfb85);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$a1626d6d785092a2);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$410e3d6221a052e);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$8588194807a0ca4b);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$254a8b23553b7df3);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$41cffad47189e5bd);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$ef343e01db40c562);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", ()=>$cd302866fea6f361$export$77cdace62a821419);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", ()=>$cd302866fea6f361$export$3efe68325dd9dc02);
    var $22jFS;
    var $44v1T;
    const $cd302866fea6f361$export$9e0962e0cb41695d = '#FFAB00';
    const $cd302866fea6f361$export$8bb9d79ea938efc9 = {
        BACKDROP_FILTER: '--project-backdrop-filter',
        COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
        COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
        COLOR_BACKGROUND_INPUT: '--project-background-input',
        COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
        COLOR_BACKGROUND_SELECTED: '--project-background-selected',
        COLOR_BORDER: '--project-color-border',
        COLOR_BORDER_INPUT: '--project-color-border-input',
        COLOR_BORDER_INVERSE: '--project-color-border-inverse',
        COLOR_BORDER_SELECTED: '--project-color-border-selected',
        COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
        COLOR_ICON_DANGER: '--project-color-icon-danger',
        COLOR_ICON_INFORMATION: '--project-color-icon-information',
        COLOR_ICON_SUCCESS: '--project-color-icon-success',
        COLOR_ICON_WARNING: '--project-color-icon-warning',
        COLOR_LINK: '--project-color-link',
        COLOR_LINK_PRESSED: '--project-color-link-pressed',
        COLOR_SKELETON: '--project-skeleton',
        COLOR_TEXT: '--project-color-text',
        COLOR_TEXT_DISABLED: '--project-color-text-disabled',
        COLOR_TEXT_INVERSE: '--project-color-text-inverse',
        COLOR_TEXT_SELECTED: '--project-color-text-selected',
        COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
        COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
        CONTENT_HEIGHT: '--project-content-height',
        CONTENT_WIDTH: '--project-content-width',
        ELEVATION_SURFACE: '--project-elevation-surface',
        ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
        ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
        WRAPPER_BACKGROUND: '--project-wrapper-background',
        WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
        WRAPPER_HEIGHT: '--project-wrapper-height',
        WRAPPER_PADDING: '--project-wrapper-padding',
        WRAPPER_WIDTH: '--project-wrapper-width'
    };
    const $cd302866fea6f361$export$8e1e81ac145e31be = {
        BACKDROP_FILTER: 'var(--project-backdrop-filter)',
        COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
        COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
        COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
        COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
        COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
        COLOR_BORDER: 'var(--project-color-border)',
        COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
        COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
        COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
        COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
        COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
        COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
        COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
        COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
        COLOR_LINK: 'var(--project-color-link)',
        COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
        COLOR_SKELETON: 'var(--project-skeleton)',
        COLOR_TEXT: 'var(--project-color-text)',
        COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
        COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
        COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
        COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
        COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
        CONTENT_HEIGHT: 'var(--project-content-height)',
        CONTENT_WIDTH: 'var(--project-content-width)',
        ELEVATION_SURFACE: 'var(--project-elevation-surface)',
        ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
        ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
        WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
        WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
        WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
        WRAPPER_PADDING: 'var(--project-wrapper-padding)',
        WRAPPER_WIDTH: 'var(--project-wrapper-width)'
    };
    const $cd302866fea6f361$export$8a6e9b3370a0f87a = {
        'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
        'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
        'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
        'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
        'color.background.input': `var(--ds-background-input, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.background.neutral': `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N30A})`,
        'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$exports).N50A})`,
        'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$exports).N50A})`,
        'color.background.selected': `var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.elevation.surface': `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.border': `var(--ds-border, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.border.input': "var(--ds-border-input, #091E4224)",
        'color.border.inverse': `var(--ds-border-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.border.selected': `var(--ds-border-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.icon.danger': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R200})`,
        'color.icon.information': `var(--ds-icon-information, ${(0, $829f609a65d26a98$exports).B200})`,
        'color.icon.success': `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G200})`,
        'color.icon.warning': `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y200})`,
        'color.link': "var(--ds-link, #0c66e4)",
        'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
        'color.skeleton': `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`,
        'color.text': `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
        'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
        'color.text.inverse': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.text.selected': `var(--ds-text-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.text.subtle': `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
        'elevation.surface.contrast': 'transparent',
        'elevation.surface.contrast.bolder': 'transparent'
    };
    const $cd302866fea6f361$export$f286efa6bd1e8f9d = {
        'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
        'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
        'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
        'color.background.input': 'rgba(255, 255, 255, 0.8)',
        'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.text.selected': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
    };
    const $cd302866fea6f361$export$97cb21c6432e07e8 = {
        'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
        'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
        'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
        'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
        'color.background.input': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
        'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
        'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
        'color.background.selected': 'rgba(255, 255, 255, 0.6)',
        'color.elevation.surface': '#172b4d',
        'color.border': 'rgba(255, 255, 255, 0.14)',
        'color.border.input': 'rgba(255, 255, 255, 0.3)',
        'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
        'color.border.selected': (0, $829f609a65d26a98$exports).N0,
        'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
        'color.icon.information': (0, $829f609a65d26a98$exports).N0,
        'color.icon.success': (0, $829f609a65d26a98$exports).N0,
        'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
        'color.skeleton': 'rgba(255,255,255,0.08)',
        'color.text': (0, $829f609a65d26a98$exports).N0,
        'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
        'color.text.inverse': '#172B4D',
        'color.text.selected': '#172B4D',
        'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
        'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
    };
    const $cd302866fea6f361$export$b124f62a6aab972 = {
        'color.link': '#CCE0FF',
        'color.link.pressed': '#E9F2FF'
    };
    const $cd302866fea6f361$export$9441e0d8f766c59a = {
        name: 'image',
        brightness: 'high',
        theme: {
            light: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
                'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
                'color.text.selected': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
                'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`
            },
            dark: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.background.input': 'rgba(34, 39, 43, 0.8)',
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.elevation.surface': '#172b4d',
                'color.border': 'rgba(255, 255, 255, 0.14)',
                'color.border.input': 'rgba(255, 255, 255, 0.3)',
                'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
                'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
                'color.icon.information': (0, $829f609a65d26a98$exports).N0,
                'color.icon.success': (0, $829f609a65d26a98$exports).N0,
                'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
                'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
                'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
                'color.skeleton': 'rgba(255,255,255,0.8)',
                'color.text': (0, $829f609a65d26a98$exports).N0,
                'color.text.selected': "var(--ds-text-inverse, #1D2125)",
                'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
                'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
            }
        }
    };
    const $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG = {
        name: 'white'
    };
    const $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
        name: 'light-purple'
    };
    const $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
        name: 'light-blue'
    };
    const $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
        name: 'light-teal'
    };
    const $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
        name: 'light-green'
    };
    const $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
        name: 'light-yellow'
    };
    const $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG = {
        name: 'light-red'
    };
    const $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
        name: 'light-magenta'
    };
    const $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
        name: 'light-orange'
    };
    const $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG = {
        name: 'dark'
    };
    const $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG = {
        name: 'purple'
    };
    const $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG = {
        name: 'blue'
    };
    const $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG = {
        name: 'teal'
    };
    const $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG = {
        name: 'green'
    };
    const $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG = {
        name: 'yellow'
    };
    const $cd302866fea6f361$var$RED_BACKGROUND_CONFIG = {
        name: 'red'
    };
    const $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG = {
        name: 'magenta'
    };
    const $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG = {
        name: 'orange'
    };
    const $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG = {
        name: 'darker-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
        name: 'darker-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG = {
        name: 'darker-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG = {
        name: 'darker-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG = {
        name: 'darker-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG = {
        name: 'darker-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
        name: 'darker-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
        name: 'darker-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG = {
        name: 'darker-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darker-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
        name: 'darkest-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'darkest-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
        name: 'darkest-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
        name: 'darkest-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
        name: 'darkest-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG = {
        name: 'darkest-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'darkest-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'darkest-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG = {
        name: 'darkest-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darkest-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
        name: 'lightest-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F1F2F4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'lightest-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F3F0FF',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
        name: 'lightest-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E9F2FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
        name: 'lightest-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E7F9FF',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
        name: 'lightest-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCFFF1',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
        name: 'lightest-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#EFFFD6',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'lightest-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF7D6',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'lightest-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF3EB',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
        name: 'lightest-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECEB',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lightest-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECF8',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
        name: 'lighter-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCDFE4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
        name: 'lighter-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DFD8FD',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
        name: 'lighter-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#CCE0FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
        name: 'lighter-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#C6EDFB',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
        name: 'lighter-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#BAF3DB',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
        name: 'lighter-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#D3F1A7',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
        name: 'lighter-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F8E6A0',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
        name: 'lighter-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FEDEC8',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG = {
        name: 'lighter-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFD5D2',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lighter-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FDD0EC',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$export$4c351ec1dc290344 = {
        name: 'no-background',
        brightness: 'high',
        theme: {
            light: $cd302866fea6f361$export$8a6e9b3370a0f87a,
            dark: $cd302866fea6f361$export$8a6e9b3370a0f87a
        }
    };
    const $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META = {
        name: 'gradient-gray-to-black',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
        name: 'gradient-dark-to-medium-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
        name: 'gradient-light-to-dark-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META = {
        name: 'gradient-blue-to-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
        name: 'gradient-purple-to-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
        name: 'gradient-magenta-to-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
        name: 'gradient-dark-to-light-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
        name: 'gradient-dark-to-light-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
        name: 'gradient-dark-green-to-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
        name: 'gradient-dark-to-medium-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            }
        }
    };
    const $cd302866fea6f361$export$34373eced7ee212e = [
        $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG
    ];
    const $cd302866fea6f361$export$5ddfadab7b1e12c1 = [
        $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
    ];
    const $cd302866fea6f361$export$349e5dbeac874253 = [
        ...$cd302866fea6f361$export$5ddfadab7b1e12c1,
        $cd302866fea6f361$export$4c351ec1dc290344
    ];
    const $cd302866fea6f361$export$242b2d2213fedf27 = [
        $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META,
        $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META,
        $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
        $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
        $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META,
        $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META
    ];
    const $cd302866fea6f361$export$8f118a95a310853a = [
        ...$cd302866fea6f361$export$242b2d2213fedf27,
        ...$cd302866fea6f361$export$349e5dbeac874253
    ];
    const $cd302866fea6f361$export$fe05a238062e2c3d = {
        white: $cd302866fea6f361$export$4c351ec1dc290344,
        'light-purple': $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        'light-blue': $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        'light-teal': $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        'light-green': $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        'light-yellow': $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        'light-orange': $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        'light-red': $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        'light-magenta': $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        dark: $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        purple: $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        blue: $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
        teal: $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
        green: $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
        yellow: $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        orange: $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        red: $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
        magenta: $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG
    };
    const $cd302866fea6f361$export$cab9d853866386f2 = $cd302866fea6f361$export$4c351ec1dc290344;
    const $cd302866fea6f361$export$ed7cc0d417ee89e = '--jwm-banner-height';
    const $cd302866fea6f361$export$7009ab5fba189797 = `var(${$cd302866fea6f361$export$ed7cc0d417ee89e}, 0px)`;
    const $cd302866fea6f361$export$8e357501548afe78 = 24;
    const $cd302866fea6f361$export$baaf8255c30ea280 = 95;
    const $cd302866fea6f361$export$d9035bc768f8226d = `calc(${$cd302866fea6f361$export$baaf8255c30ea280}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$4810531e30462f89 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d})`;
    const $cd302866fea6f361$export$1c0b806722927549 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$2af5673c2fa63c55 = 126;
    const $cd302866fea6f361$export$5771162cdeebfb85 = `calc(${$cd302866fea6f361$export$2af5673c2fa63c55}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$a1626d6d785092a2 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85})`;
    const $cd302866fea6f361$export$410e3d6221a052e = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$8588194807a0ca4b = 146;
    const $cd302866fea6f361$export$254a8b23553b7df3 = `calc(${$cd302866fea6f361$export$8588194807a0ca4b}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$41cffad47189e5bd = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3})`;
    const $cd302866fea6f361$export$ef343e01db40c562 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$77cdace62a821419 = `calc(100vw - ${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH)}) !important`;
    const $cd302866fea6f361$export$3efe68325dd9dc02 = `calc(100vw - ${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH)} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px) !important`;
});
parcelRegister("22jFS", function(module, exports) {
    $parcel$export(module.exports, "VAR_LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$cbfb0f5b2869b17b);
    $parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$a30f2e00489a8957);
    $parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$c103b605cd368aed);
    $parcel$export(module.exports, "VAR_RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$fa34f417972d6341);
    $parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$3a6a779d9181047c);
    $parcel$export(module.exports, "VAR_BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$bcd94a6a792e7f96);
    $parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", ()=>$565cb8192fc4e070$export$b6744d31294864fd);
    $parcel$export(module.exports, "DIMENSIONS", ()=>$565cb8192fc4e070$export$d67ac355184b7646);
    $parcel$export(module.exports, "LEFT_PANEL", ()=>$565cb8192fc4e070$export$344062f7cfc9528e);
    $parcel$export(module.exports, "RIGHT_PANEL", ()=>$565cb8192fc4e070$export$c7139cc2d6110b5f);
    $parcel$export(module.exports, "BANNER", ()=>$565cb8192fc4e070$export$238d30785c4bca84);
    $parcel$export(module.exports, "TOP_NAVIGATION", ()=>$565cb8192fc4e070$export$bec6dca2e63de4ae);
    $parcel$export(module.exports, "CONTENT", ()=>$565cb8192fc4e070$export$d1213e82613ff4df);
    $parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$be83e7118304b28e);
    $parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$4a98ee0bd1ae362);
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$539e68c09584883a);
    $parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$b92df8810d2fcd01);
    $parcel$export(module.exports, "DEFAULT_RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$c3e41153b9288bcf);
    $parcel$export(module.exports, "DEFAULT_LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$c4d6152f86ea28f6);
    $parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$46acf8758e9e2636);
    $parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$70740f5ad8360a78);
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$991d5285ad765a3d);
    $parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", ()=>$565cb8192fc4e070$export$6949d4f32b161684);
    $parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$d6e7e8af042815bb);
    $parcel$export(module.exports, "TRANSITION_DURATION", ()=>$565cb8192fc4e070$export$3749e1104328fde4);
    $parcel$export(module.exports, "FLYOUT_DELAY", ()=>$565cb8192fc4e070$export$1074d925b0b82be5);
    $parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", ()=>$565cb8192fc4e070$export$451e84a45a9e4a75);
    $parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", ()=>$565cb8192fc4e070$export$802bb2c050f3db5c);
    $parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", ()=>$565cb8192fc4e070$export$5e5e1875c3fd8f4f);
    $parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", ()=>$565cb8192fc4e070$export$70c702a8c5895f03);
    $parcel$export(module.exports, "GRAB_AREA_SELECTOR", ()=>$565cb8192fc4e070$export$48a43f91e4becf4e);
    $parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", ()=>$565cb8192fc4e070$export$dac2fb31a9f6844d);
    $parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", ()=>$565cb8192fc4e070$export$9ecd22db14e6c70e);
    $parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", ()=>$565cb8192fc4e070$export$5253dd9707b8c3ba);
    $parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", ()=>$565cb8192fc4e070$export$206a08f7f8beb554);
    $parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", ()=>$565cb8192fc4e070$export$659ee746b31b360d);
    $parcel$export(module.exports, "LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$f963aecf2d4465bd);
    $parcel$export(module.exports, "RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$750459958906793);
    $parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$f897e1ed9f8ed251);
    $parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$b44ab66843c05a69);
    $parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$aeff86a16f13529);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$d2fa14f05b61e66);
    const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
    const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
    const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
    const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
    const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
    const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
    const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
    const $565cb8192fc4e070$export$d67ac355184b7646 = [
        $565cb8192fc4e070$export$cbfb0f5b2869b17b,
        $565cb8192fc4e070$export$fa34f417972d6341,
        $565cb8192fc4e070$export$bcd94a6a792e7f96,
        $565cb8192fc4e070$export$3a6a779d9181047c,
        $565cb8192fc4e070$export$a30f2e00489a8957,
        $565cb8192fc4e070$export$c103b605cd368aed
    ];
    const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
    const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
    const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
    const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
    const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
    const $565cb8192fc4e070$export$2d8180803f50fc5 = 'main';
    const $565cb8192fc4e070$export$50ea883ba6f28ff5 = 'left-sidebar';
    const $565cb8192fc4e070$export$7bf43119a6b49ddb = 'right-sidebar';
    const $565cb8192fc4e070$export$be83e7118304b28e = 56;
    const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
    const $565cb8192fc4e070$export$539e68c09584883a = 240;
    const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
    const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
    const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
    const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
    const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
    const $565cb8192fc4e070$export$f562af313cda0684 = 80;
    const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
    const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
    const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
    const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
    const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
    const $565cb8192fc4e070$export$24d54fc362d78805 = 'expandedLeftSidebarWidth';
    const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
    const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
    const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
    const $565cb8192fc4e070$export$60b3bc5d4ac00d5e = 'data-is-flyout-open';
    const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
    const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
    const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
    const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
    const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
    const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
    const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
    const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
    const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
    const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
    const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
    const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
    const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
    const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;
});
parcelRegister("44v1T", function(module, exports) {
    $parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", ()=>$81918a2ef6db1f93$export$d60454526e2281af);
    var $22jFS;
    const $81918a2ef6db1f93$export$d60454526e2281af = `(${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)})`;
});
parcelRegister("027FQ", function(module, exports) {
    $parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", ()=>$fd4c320fd9ec6c35$export$ddf2fc82885279d);
    const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
    const $fd4c320fd9ec6c35$export$39284f7325536558 = {
        ServiceDesk: 'SERVICE_DESK',
        Business: 'BUSINESS',
        Software: 'SOFTWARE'
    };
    const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
        TeamManagedProject: 'TEAM_MANAGED_PROJECT',
        CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
    };
});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
  jwmOverviewPlanMigrationState {
    ... on JiraOverviewPlanMigrationState {
      changeboardingActive
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
parcelRegister("1E3vT", function(module, exports) {
    $parcel$export(module.exports, "navigationItemsResource", ()=>$4f364072ed560b43$export$8446b129b5aba359);
    var $ljMDN;
    var $dJl1T;
    var $3HwlS;
    var $eM91u;
    var $ao2h1;
    var $6SGt4;
    var $1nb22;
    const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
    const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
            return '';
        }
    };
    const $4f364072ed560b43$export$8446b129b5aba359 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const { cloudId: cloudId } = tenantContext;
            const projectIdOrKey = projectKey || projectId;
            const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
            return {
                parameters: (0, (0, parcelRequire("6SGt4")).default),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                    containerNavigationInput: scopeId ? {
                        scopeId: scopeId
                    } : {
                        projectKeyQuery: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    },
                    useContainerNavigation: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
                    useNewProjectHeader: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
                    projectKey: projectKey,
                    projectAri: scopeId,
                    useProjectKey: Boolean(projectKey)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
});
parcelRegister("6SGt4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fed7f561d3a05da6$export$2e2bcd8739ae039);
    const $fed7f561d3a05da6$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useContainerNavigation"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useNewProjectHeader"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectKey"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v11 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }, v12 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v13 = {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        }, v14 = {
            "kind": "ScalarField",
            "name": "name"
        }, v15 = {
            "condition": "useNewProjectHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectBoardHeader_horizontalNavHeader_projectFragment"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "projectHeader_horizontalNavHeader_projectFragment"
                }
            ]
        }, v16 = {
            "kind": "FragmentSpread",
            "name": "tabs_businessHorizontalNav_TabsContent_projectFragment"
        }, v17 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v18 = {
            "args": [
                v9
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                }
            ]
        }, v19 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v20 = [
            v9,
            v19,
            {
                "kind": "Variable",
                "name": "projectIdOrKey",
                "variableName": "projectIdOrKey"
            }
        ], v21 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v22 = {
            "kind": "ScalarField",
            "name": "id"
        }, v23 = {
            "kind": "ScalarField",
            "name": "label"
        }, v24 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v25 = {
            "kind": "ScalarField",
            "name": "url"
        }, v26 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v27 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v28 = {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v21,
                v22,
                {
                    "kind": "ScalarField",
                    "name": "isDefault"
                },
                {
                    "kind": "ScalarField",
                    "name": "typeKey"
                },
                {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v23,
                {
                    "kind": "ScalarField",
                    "name": "canRemove"
                },
                {
                    "kind": "ScalarField",
                    "name": "canSetAsDefault"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appId"
                        },
                        {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                                v23,
                                {
                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        v23,
                                        v24,
                                        v25,
                                        v26
                                    ]
                                }
                            ]
                        },
                        v25,
                        v24,
                        v26,
                        {
                            "kind": "ScalarField",
                            "name": "appType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "envLabel"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v27
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                        }
                    ],
                    "type": "JiraAppNavigationItem"
                },
                v27
            ]
        }, v29 = [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v21,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    }
                ]
            }
        ], v30 = {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": v29
        }, v31 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v32 = {
            "kind": "InlineFragment",
            "selections": [
                v22
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v33 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v34 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v35 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v36 = [
            v11,
            v12,
            v13,
            v14,
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            v22,
            {
                "condition": "useNewProjectHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v33,
                    {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "status"
                    },
                    {
                        "alias": "canEditProjectConfig",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v34,
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                    },
                    {
                        "alias": "canViewProjectConfig",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "VIEW_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v34,
                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "softwareBoardCount"
                    },
                    {
                        "concreteType": "JiraBoardConnection",
                        "kind": "LinkedField",
                        "name": "boards",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraBoardEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraBoard",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v35,
                                            {
                                                "concreteType": "JiraFavouriteValue",
                                                "kind": "LinkedField",
                                                "name": "favouriteValue",
                                                "plural": false,
                                                "selections": [
                                                    v33,
                                                    v22
                                                ]
                                            },
                                            v31,
                                            v22,
                                            v27
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v27
                ]
            },
            {
                "condition": "useContainerNavigation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "navigationMetadata",
                        "plural": false,
                        "selections": [
                            v21,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v35,
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSimpleBoard"
                                    },
                                    v22
                                ],
                                "type": "JiraSoftwareProjectNavigationMetadata"
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v21,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v35,
                                    {
                                        "kind": "ScalarField",
                                        "name": "boardType"
                                    }
                                ],
                                "type": "JiraBoard"
                            },
                            v32
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8
                ],
                "kind": "Fragment",
                "name": "projectNavigation_horizontalNavigationQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "tabs_businessHorizontalNav_TabsContent_jiraQueryFragment"
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "projectDataByKey",
                                            "args": v10,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": [
                                                v11,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v12,
                                                    "action": "THROW",
                                                    "path": "jira.projectDataByKey.projectId"
                                                },
                                                v13,
                                                v14,
                                                v15,
                                                v16
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectDataById",
                                            "args": v17,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProject",
                                            "plural": false,
                                            "selections": [
                                                v11,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v12,
                                                    "action": "THROW",
                                                    "path": "jira.projectDataById.projectId"
                                                },
                                                v13,
                                                v14,
                                                v15,
                                                v16
                                            ]
                                        }
                                    ]
                                },
                                v18
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v4,
                    v2,
                    v1,
                    v6,
                    v5,
                    v3,
                    v8,
                    v7
                ],
                "kind": "Operation",
                "name": "projectNavigation_horizontalNavigationQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v18,
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "navigationItems",
                                        "args": v20,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "jwmSavedViewsByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v28,
                                                    v21,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    }
                                                ]
                                            },
                                            v30,
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "alias": "navigationItems",
                                        "args": v20,
                                        "filters": [
                                            "cloudId",
                                            "projectIdOrKey"
                                        ],
                                        "handle": "connection",
                                        "key": "tabs_jiraNavigation__navigationItems",
                                        "kind": "LinkedHandle",
                                        "name": "jwmSavedViewsByProject"
                                    }
                                ]
                            },
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "input",
                                                "variableName": "containerNavigationInput"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraContainerNavigationResult"
                                            },
                                            v21,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v22,
                                                    v31,
                                                    {
                                                        "args": [
                                                            v19
                                                        ],
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    v28,
                                                                    v21
                                                                ]
                                                            },
                                                            v30
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v29,
                                                "type": "QueryError"
                                            },
                                            v32
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v10,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v36
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v17,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": v36
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "cb36e10a41a601f964c936292686a838726dc5b8430eb652166a8c310914baac",
                "metadata": {},
                "name": "projectNavigation_horizontalNavigationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $fed7f561d3a05da6$var$node.hash = "6bc22acbcf8f31d68defc8a8e42e4678";
    var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;
});
parcelRegister("jrO9m", function(module, exports) {
    $parcel$export(module.exports, "overviewDetailsResource", ()=>$e1715b61e2fa96e9$export$cd57aa046b167312);
    $parcel$export(module.exports, "useOverview", ()=>$e1715b61e2fa96e9$export$626541a5c6f2cfa1);
    var $dIdda = parcelRequire("dIdda");
    var $hFi7P;
    const $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
    const $e1715b61e2fa96e9$export$cd57aa046b167312 = (0, $dIdda.createResource)({
        type: $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY,
        getKey: ({ match: match })=>`${$e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
        getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, (0, parcelRequire("hFi7P")).fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
        maxAge: 3600000
    });
    const $e1715b61e2fa96e9$export$626541a5c6f2cfa1 = ()=>(0, $dIdda.useResource)($e1715b61e2fa96e9$export$cd57aa046b167312);
});
parcelRegister("hFi7P", function(module, exports) {
    $parcel$export(module.exports, "fetchOverviewDetails", ()=>$692d3aa28ecf0a74$export$f0395142dbdd6c61);
    var $63wRx;
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $dXq4S;
    var $dpLxG;
    const $692d3aa28ecf0a74$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
        if (!overviewId) return null;
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("dpLxG")).QUERY),
                    variables: {
                        id: (0, (0, parcelRequire("dXq4S")).createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'project-overview',
                            resourceId: overviewId,
                            activationId: activationId
                        })
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response?.data?.jira?.overview?.__typename === (0, $4bd5c695609ae115$export$62a5da7e3fa5ff88)) return (0, (0, parcelRequire("63wRx")).mapOverviewFragment)(response.data.jira.overview);
            throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response?.data?.jira?.overview ?? response.errors);
        } catch (error) {
            if (error?.statusCode === 410) throw error;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'overviewDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return null;
    };
});
parcelRegister("63wRx", function(module, exports) {
    $parcel$export(module.exports, "mapOverviewFragment", ()=>$bc1a4d4cd369fa52$export$e79bf238de33eabb);
    const $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $bc1a4d4cd369fa52$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
            const { node: node } = edge || {};
            if (node == null) return null;
            return {
                key: node.key,
                id: Number(node.projectId),
                avatarUrl: node.avatar?.large ?? '',
                name: node.name,
                type: node.projectType.toLowerCase(),
                isSimplified: node.projectStyle === $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE,
                isFavorite: node.isFavourite === true,
                permissions: {
                    administerProject: node.administerProject.canPerform,
                    createIssues: node.createIssues.canPerform,
                    deleteIssues: node.deleteIssues.canPerform,
                    editIssues: node.editIssues.canPerform,
                    linkIssues: node.linkIssues.canPerform,
                    scheduleIssues: node.scheduleIssues.canPerform,
                    transitionIssues: node.transitionIssues?.canPerform === true,
                    viewIssues: node.viewIssues.canPerform
                }
            };
        }).filter((project)=>project);
    const $bc1a4d4cd369fa52$export$e79bf238de33eabb = (overview)=>{
        const { id: id, name: name, theme: theme, projects: projectsData } = overview;
        const projects = $bc1a4d4cd369fa52$var$mapProjectsNode(projectsData.edges);
        const unreachableProjectsCount = projectsData.edges.length - projects.length;
        return {
            id: id,
            name: name,
            theme: theme,
            projects: projects,
            unreachableProjectsCount: unreachableProjectsCount
        };
    };
});
parcelRegister("dpLxG", function(module, exports) {
    $parcel$export(module.exports, "QUERY", ()=>$42259e945f9fd88b$export$2b91517d6d5b4365);
    const $42259e945f9fd88b$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892)}
`;
});
const $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;
const $4bd5c695609ae115$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';
parcelRegister("l2N2a", function(module, exports) {
    $parcel$export(module.exports, "projectDetailsResource", ()=>$a72df1053ff3c9a0$export$e541d9eb202b4972);
    $parcel$export(module.exports, "useProject", ()=>$a72df1053ff3c9a0$export$51b1383ef8844a7);
    $parcel$export(module.exports, "useMediaConfiguration", ()=>$a72df1053ff3c9a0$export$ab5cf8327e07f046);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $8s4PA;
    const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
    const $a72df1053ff3c9a0$export$e541d9eb202b4972 = (0, $dIdda.createResource)({
        type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("8s4PA")).fetchProjectDetails)(cloudId, projectKey, projectId);
        },
        maxAge: 3600000
    });
    const $a72df1053ff3c9a0$export$51b1383ef8844a7 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
        return {
            data: data?.currentProject ?? null,
            loading: loading,
            error: error
        };
    };
    const $a72df1053ff3c9a0$export$ab5cf8327e07f046 = ()=>{
        const { data: data } = (0, $dIdda.useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
        return data?.media ?? null;
    };
});
parcelRegister("8s4PA", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectDetails", ()=>$3400333a67b09775$export$78aa221476efa1c6);
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $dXq4S;
    var $2D9kr;
    const $3400333a67b09775$var$EMPTY_VALUE = {
        themeSetting: null,
        media: null
    };
    const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
        const projectIdOrKey = projectId || projectKey;
        if (!projectIdOrKey) return null;
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
                body: JSON.stringify({
                    query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        usingProjectKey: projectId == null,
                        projectId: projectId != null ? (0, (0, parcelRequire("dXq4S")).createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'project',
                            resourceId: projectId
                        }) : ''
                    }
                })
            });
            return (0, (0, parcelRequire("2D9kr")).transformData)(response.data, projectIdOrKey);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'projectDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessProjectDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return $3400333a67b09775$var$EMPTY_VALUE;
    };
});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;
parcelRegister("2D9kr", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$a9016a2d391e1663$export$3ceb62baab058c6b);
    const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            status: node.status,
            isSimplified: node.simplified,
            isFavorite: node.favorite === true,
            permissions: {
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                transitionIssues: node.transitionIssues.canPerform,
                viewIssues: node.viewIssues.canPerform
            }
        };
    };
    const $a9016a2d391e1663$var$parseThemeSetting = (data)=>{
        const theme = data?.jwmSidebar?.theme;
        if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
            type: 'color',
            value: theme.colorValue
        };
        if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
            type: 'color',
            value: theme.gradientValue
        };
        if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
            const { customBackground: customBackground } = theme;
            const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
            return {
                type: 'image',
                value: 'image',
                id: id,
                mediaApiFileId: mediaApiFileId,
                mediaReadToken: mediaReadToken,
                sourceType: sourceType,
                sourceIdentifier: sourceIdentifier,
                altText: altText
            };
        }
        return null;
    };
    const $a9016a2d391e1663$var$parseMediaConfiguration = (data)=>{
        const clientId = data?.jira?.mediaClientId;
        const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
        if (clientId == null || externalEndpointUrl == null) return null;
        return {
            clientId: clientId,
            externalEndpointUrl: externalEndpointUrl
        };
    };
    const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
            themeSetting: $a9016a2d391e1663$var$parseThemeSetting(data),
            currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
            projectIdOrKey: projectIdOrKey,
            media: $a9016a2d391e1663$var$parseMediaConfiguration(data)
        });
});
parcelRegister("9yEpR", function(module, exports) {
    $parcel$export(module.exports, "storageDetailsResource", ()=>$920f9d6e578a6c36$export$76c871115d0c70a1);
    $parcel$export(module.exports, "useStorageDetails", ()=>$920f9d6e578a6c36$export$8c295c187914aac1);
    var $dIdda = parcelRequire("dIdda");
    var $6Z2DE;
    const $920f9d6e578a6c36$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_INSTANCE_STORAGE';
    const $920f9d6e578a6c36$export$76c871115d0c70a1 = (0, $dIdda.createResource)({
        type: $920f9d6e578a6c36$var$RESOURCE_TYPE_KEY,
        getKey: ()=>$920f9d6e578a6c36$var$RESOURCE_TYPE_KEY,
        getData: async (_, { tenantContext: { appEditions: appEditions } })=>(0, (0, parcelRequire("6Z2DE")).fetchStorageDetails)(appEditions),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $920f9d6e578a6c36$export$8c295c187914aac1 = ()=>(0, $dIdda.useResource)($920f9d6e578a6c36$export$76c871115d0c70a1);
});
parcelRegister("6Z2DE", function(module, exports) {
    $parcel$export(module.exports, "fetchStorageDetails", ()=>$6e4752d8c4202fab$export$576d1c3de6af9760);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $ldyPw;
    const $6e4752d8c4202fab$export$576d1c3de6af9760 = async (appEditions)=>{
        try {
            if (appEditions?.core !== (0, (0, parcelRequire("ldyPw")).FREE_EDITION)) return null;
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/latest?query', {
                body: JSON.stringify({
                    query: (0, $3d489d21cba189e7$export$2b91517d6d5b4365),
                    variables: {
                        productKey: 'jira-core'
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.errors != null) {
                const error = response.errors?.[0];
                const isClientError = error?.extensions?.statusCode >= 400 && error?.extensions?.statusCode < 500;
                if (!isClientError) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            }
            const usageLimit = response?.data?.attachmentStorage;
            if (usageLimit && usageLimit?.allowed) {
                const percentageUsed = Math.round(usageLimit?.used / usageLimit.allowed * 100);
                return percentageUsed;
            }
            return null;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getStorageAmountService', 'Something went wrong while fetching storage amount');
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getStorageAmountService',
                    packageName: 'jiraRouterResourcesBusinessStorageDetails',
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $3d489d21cba189e7$export$2b91517d6d5b4365 = `
query Storage($productKey: String!) {
  attachmentStorage(productKey: $productKey) {
    used
    allowed
    isUnlimited
  }
}`;
parcelRegister("aFVvc", function(module, exports) {
    $parcel$export(module.exports, "projectCreatePermissionsResource", ()=>$9880b75bed11d4d0$export$f6c05eaea53ab4ae);
    $parcel$export(module.exports, "useProjectCreatePermissionsResource", ()=>$9880b75bed11d4d0$export$2bd0d3b374549a68);
    var $dIdda = parcelRequire("dIdda");
    const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("axsKz"));
    const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, $dIdda.createResource)({
        type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
        getKey: ()=>'state',
        getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
        maxAge: Infinity
    });
    const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, $dIdda.useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);
});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';
parcelRegister("axsKz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bqWWL").then(()=>parcelRequire('5Yzmr'));
});
parcelRegister("5PD5h", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", ()=>$a816ddf70513a004$export$128d5d79815580ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gMULe")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
    });
    const $a816ddf70513a004$export$128d5d79815580ca = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-software-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav, null));
});
parcelRegister("gMULe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("djQ7G")
    ]).then(()=>parcelRequire('1f09g'));
});
parcelRegister("b39Ju", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2y2gh")
    ]).then(()=>parcelRequire('f45ZV'));
});
parcelRegister("hBv66", function(module, exports) {
    $parcel$export(module.exports, "genericProjectSidebars", ()=>$0b920001492d0ef4$export$d88d2d25355bc89a);
    $parcel$export(module.exports, "classicBoardSidebars", ()=>$0b920001492d0ef4$export$c04daf123cec1f1e);
    $parcel$export(module.exports, "genericConnectSidebars", ()=>$0b920001492d0ef4$export$844d342b575ead35);
    var $cin8p;
    var $dmKXV;
    var $iHiHz;
    var $cOg46;
    var $koWFd;
    var $h0bZU;
    var $9s3j1;
    var $2IHt2;
    const $0b920001492d0ef4$export$d88d2d25355bc89a = [
        (0, (0, parcelRequire("dmKXV")).default),
        (0, (0, parcelRequire("koWFd")).default),
        (0, (0, parcelRequire("h0bZU")).default),
        (0, (0, parcelRequire("9s3j1")).default),
        (0, (0, parcelRequire("2IHt2")).default)
    ];
    const $0b920001492d0ef4$export$c04daf123cec1f1e = [
        (0, (0, parcelRequire("9s3j1")).default),
        (0, (0, parcelRequire("2IHt2")).default)
    ];
    const $0b920001492d0ef4$export$844d342b575ead35 = [
        ...$0b920001492d0ef4$export$d88d2d25355bc89a,
        (0, (0, parcelRequire("cin8p")).default),
        (0, (0, parcelRequire("iHiHz")).default),
        (0, (0, parcelRequire("cOg46")).default)
    ];
});
parcelRegister("cin8p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$760a63d3e4200cc2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $760a63d3e4200cc2$var$LazyConnectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("bxwfY")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
    });
    const $760a63d3e4200cc2$var$ConnectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "connect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($760a63d3e4200cc2$var$LazyConnectSidebar, null)));
    $760a63d3e4200cc2$var$ConnectSidebar.displayName = 'ConnectSidebar';
    var $760a63d3e4200cc2$export$2e2bcd8739ae039 = $760a63d3e4200cc2$var$ConnectSidebar;
});
parcelRegister("bxwfY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("a8u2l")
    ]).then(()=>parcelRequire('caET0'));
});
parcelRegister("iHiHz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$883820dc444dc59c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("6xFyF")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
    });
    const $883820dc444dc59c$var$GlobalAppsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalAppsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar, null)));
    $883820dc444dc59c$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
    var $883820dc444dc59c$export$2e2bcd8739ae039 = $883820dc444dc59c$var$GlobalAppsSettingsSidebar;
});
parcelRegister("6xFyF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3EO4A")
    ]).then(()=>parcelRequire('kO26e'));
});
parcelRegister("2IHt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8627747b0236ab96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $8627747b0236ab96$var$LazyUserSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("j9Afm")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
    });
    const $8627747b0236ab96$var$UserSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "user"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8627747b0236ab96$var$LazyUserSidebar, null)));
    $8627747b0236ab96$var$UserSidebar.displayName = 'UserSidebar';
    var $8627747b0236ab96$export$2e2bcd8739ae039 = $8627747b0236ab96$var$UserSidebar;
});
parcelRegister("j9Afm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("36IoX")
    ]).then(()=>parcelRequire('3AQ56'));
});
parcelRegister("1WlLE", function(module, exports) {
    $parcel$export(module.exports, "queuesNavigationItems", ()=>$c68314f43531feff$export$4fed8be571897bef);
    $parcel$export(module.exports, "priorityGroupResource", ()=>$c68314f43531feff$export$1f9ab301771fe42e);
    $parcel$export(module.exports, "issueListSsrResource", ()=>$c68314f43531feff$export$3d03cbaac8581e65);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $8w6CZ;
    const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("kuvqU"));
    const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("jyy5p"));
    const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("9mhm7"));
    const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, ($parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
    const $c68314f43531feff$export$4fed8be571897bef = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $c68314f43531feff$var$getDataLoader,
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS)
    });
    const $c68314f43531feff$export$1f9ab301771fe42e = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS),
        isBrowserOnly: true
    });
    const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
        getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
        getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
        maxAge: 0,
        skipBrowser: true
    });
});
parcelRegister("8w6CZ", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", ()=>$a4c66eaf20e13a4d$export$a401e6d6b205c72b);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", ()=>$a4c66eaf20e13a4d$export$2064262c540606ba);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", ()=>$a4c66eaf20e13a4d$export$2733615da5b906f0);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$a4c66eaf20e13a4d$export$5a00268156ea5027);
    const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
    const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
    const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
    const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;
});
parcelRegister("kuvqU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fYHqp").then(()=>parcelRequire('lini2'));
});
parcelRegister("jyy5p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2mLKW").then(()=>parcelRequire('etJR3'));
});
parcelRegister("9mhm7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jmkWj").then(()=>parcelRequire('bmzqI'));
});
parcelRegister("lsCQw", function(module, exports) {
    $parcel$export(module.exports, "browseProjectRedirectRoute", ()=>$8f408b6bf8b1e91d$export$f9cac37753487f39);
    var $65Ltd;
    const $8f408b6bf8b1e91d$export$f9cac37753487f39 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        path: '/browse/:projectKey([^-/]+)',
        exact: true,
        isRedirect: true
    };
});
parcelRegister("7MCPm", function(module, exports) {
    $parcel$export(module.exports, "RedirectToLastVisitedProjectPage", ()=>$4c121c4cc7d1faa6$export$86041af020f4c959);
    var $5uXOq = parcelRequire("5uXOq");
    var $hqxtv;
    const $4c121c4cc7d1faa6$export$86041af020f4c959 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqxtv")).default), null);
});
parcelRegister("hqxtv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bda9d95137e1a17a$export$2e2bcd8739ae039);
    var $dIdda = parcelRequire("dIdda");
    var $aNBa3;
    var $bda9d95137e1a17a$export$2e2bcd8739ae039 = (0, $dIdda.withRouter)((0, (0, parcelRequire("aNBa3")).default));
});
parcelRegister("aNBa3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d9c467899b3389b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $ebyGx = parcelRequire("ebyGx");
    var $fNobW;
    var $fDtbf;
    var $kUU4G;
    var $4Pf62;
    var $dJl1T;
    var $7f4tk;
    var $ebbSc;
    const $8d9c467899b3389b$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
    const $8d9c467899b3389b$var$allowListedSearchParams = [
        (0, $0592ef8772eedefd$export$29d3926e3d72cfb),
        (0, $0592ef8772eedefd$export$b3233b76460c1e7c)
    ];
    const $8d9c467899b3389b$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
        const destination = `/projects/${projectKey}/issues/?filter=allissues`;
        history.replace(destination);
        (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
            requestTime: (0, (0, parcelRequire("ebbSc")).getNow)() - startTime,
            destination: destination
        });
    };
    const $8d9c467899b3389b$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$8d9c467899b3389b$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $0592ef8772eedefd$export$29d3926e3d72cfb))));
    const $8d9c467899b3389b$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
        const queryKeys = new URLSearchParams(searchQuery).toString();
        return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
    };
    class $8d9c467899b3389b$export$bf8d1fdc3b47a835 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { history: history, location: location, query: query, match: { params: params } } = this.props;
            const { initial: initial } = query;
            (0, (0, parcelRequire("kUU4G")).default)((0, (0, parcelRequire("fDtbf")).SPA_SSR_RENDERED_MARK));
            const startTime = (0, (0, parcelRequire("ebbSc")).getNow)();
            const projectKey = params.projectKey || (0, ($parcel$interopDefault($ebyGx))).parse((0, ($parcel$interopDefault($9XE6b)))(location, 'search', {})).projectKey;
            if (!params.projectKey) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'queryString', {
                duration: (0, (0, parcelRequire("ebbSc")).getNow)() - startTime
            });
            if (projectKey) (0, (0, parcelRequire("7f4tk")).default)($8d9c467899b3389b$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
                const endTime = (0, (0, parcelRequire("ebbSc")).getNow)();
                let searchQueryParams = '';
                const searchQuery = $8d9c467899b3389b$export$c79af62ad7a1fe8a(query);
                const queryInitializer = response.data.url.includes('?') ? '&' : '?';
                searchQueryParams = $8d9c467899b3389b$export$283f1587d7a5369f(searchQuery, queryInitializer);
                const destination = response.data.url + searchQueryParams;
                history.replace(destination);
                (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered', {
                    requestTime: endTime - startTime,
                    destination: destination
                });
            }, (error)=>{
                const endTime = (0, (0, parcelRequire("ebbSc")).getNow)();
                if ((0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $8d9c467899b3389b$var$redirectForAnonymousUser(projectKey, history, startTime);
                else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
            });
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
                name: "last-visited-project-page-redirect"
            });
        }
    }
    var $8d9c467899b3389b$export$2e2bcd8739ae039 = $8d9c467899b3389b$export$bf8d1fdc3b47a835;
});
const $0592ef8772eedefd$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $0592ef8772eedefd$export$29d3926e3d72cfb = 'search';
const $0592ef8772eedefd$export$b3233b76460c1e7c = 'showProjectBuilder';
parcelRegister("ebbSc", function(module, exports) {
    $parcel$export(module.exports, "getNow", ()=>$fa5a995d36ebfbde$export$3991332aae1fc754);
    const $fa5a995d36ebfbde$export$3991332aae1fc754 = ()=>Date.now();
});
parcelRegister("XNjnS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8VawK")
    ]).then(()=>parcelRequire('3PxNF'));
});
parcelRegister("2HD9l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("b2COn")
    ]).then(()=>parcelRequire('lktzL'));
});
parcelRegister("aVFIE", function(module, exports) {
    $parcel$export(module.exports, "ThemedLazySkeleton", ()=>$136611be2ae39444$export$ddeb5d943c4f17e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $lob44;
    const $136611be2ae39444$export$ddeb5d943c4f17e3 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($136611be2ae39444$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "themed-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lob44")).ThemedSpinner), null))));
    const $136611be2ae39444$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lob44", function(module, exports) {
    $parcel$export(module.exports, "ThemedSpinner", ()=>$150e941eee16207a$export$271c7b154ad6c401);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $150e941eee16207a$export$271c7b154ad6c401 = (0, $5uXOq.memo)((props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($150e941eee16207a$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            ...props,
            testId: "project-theme-components.ui.themed-spinner"
        })));
    const $150e941eee16207a$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1xjgvy9e",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d8VYe", function(module, exports) {
    $parcel$export(module.exports, "workflowIssuesResource", ()=>$6a9e21653771d63a$export$49027035af709702);
    $parcel$export(module.exports, "useWorkflowIssues", ()=>$6a9e21653771d63a$export$86b7de71bf71360d);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $9YrR3;
    const $6a9e21653771d63a$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';
    const $6a9e21653771d63a$export$49027035af709702 = (0, $dIdda.createResource)({
        type: $6a9e21653771d63a$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$6a9e21653771d63a$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getDataLoader: ()=>Promise.resolve((parcelRequire("9YrR3"))),
        getData: (0, (0, parcelRequire("9YrR3")).default),
        maxAge: 1000,
        isBrowserOnly: true
    });
    const $6a9e21653771d63a$export$86b7de71bf71360d = ()=>(0, $dIdda.useResource)($6a9e21653771d63a$export$49027035af709702);
});
parcelRegister("9YrR3", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$465154b480a996b2$export$2e2bcd8739ae039);
    var $7juH2;
    var $x9xyg;
    var $jJZqs;
    var $8PRuf;
    var $iR3GG;
    const $465154b480a996b2$var$EMPTY_DATA = {
        workflows: [],
        lastChangedTime: null
    };
    function $465154b480a996b2$var$getEarlyPreload() {
        if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
            const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
            window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
            return earlyPreloadPromise.then((response)=>{
                if (!response.success) {
                    if (response.error.status === 304) throw new (0, (0, parcelRequire("7juH2")).Unchanged)('Workflow issues have not changed since the last request');
                    throw new (0, (0, parcelRequire("jJZqs")).default)(response.error.status);
                }
                return {
                    workflows: response.workflows,
                    lastChangedTime: null
                };
            });
        }
        return null;
    }
    function $465154b480a996b2$var$fetchData(projectKey) {
        const earlyPreload = $465154b480a996b2$var$getEarlyPreload();
        if (earlyPreload !== null) return earlyPreload;
        return (0, (0, parcelRequire("7juH2")).fetchWorkflowIssues)(projectKey);
    }
    async function $465154b480a996b2$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return $465154b480a996b2$var$EMPTY_DATA;
        try {
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiStartMark));
            const workflows = await $465154b480a996b2$var$fetchData(match.params.projectKey ?? '');
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiReadyMark));
            return workflows;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.business.board-workflows.getData',
                message: 'An error was thrown while prefetching board data',
                name: 'ResourceError'
            }, error);
        }
    }
});
parcelRegister("7juH2", function(module, exports) {
    $parcel$export(module.exports, "Unchanged", ()=>$16e71a1b1f979cb0$export$eccd6db33b8f6a89);
    $parcel$export(module.exports, "fetchWorkflowIssues", ()=>$16e71a1b1f979cb0$export$17e2e8212d93f58d);
    var $gKZoD;
    var $gN11a;
    var $aDvGo;
    var $jJZqs;
    class $16e71a1b1f979cb0$export$eccd6db33b8f6a89 extends Error {
    }
    const $16e71a1b1f979cb0$export$17e2e8212d93f58d = async (projectKey, ifChangedSince)=>{
        (0, (0, parcelRequire("gKZoD")).di)(fetch);
        try {
            (0, (0, parcelRequire("gN11a")).markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            const url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
            const response = await fetch(url, {
                ...(0, (0, parcelRequire("aDvGo")).default),
                headers: ifChangedSince ? {
                    'x-aif-changed-since': ifChangedSince
                } : undefined
            });
            if (!response.ok) {
                if (response.status === 304) throw new $16e71a1b1f979cb0$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
                throw new (0, (0, parcelRequire("jJZqs")).default)(response.status);
            }
            const lastChangedTime = response.headers.get('x-alast-changed-time');
            const workflows = await response.json();
            return {
                workflows: workflows.data,
                lastChangedTime: lastChangedTime
            };
        } finally{
            (0, (0, parcelRequire("gN11a")).markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        }
    };
});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';
parcelRegister("gN11a", function(module, exports) {
    $parcel$export(module.exports, "pageLoadMetrics", ()=>$f9c6206c3cbbca63$export$2878bf482e539059);
    $parcel$export(module.exports, "markViewMetric", ()=>$f9c6206c3cbbca63$export$8d15b4fb25f90514);
    var $dGrdR;
    const $f9c6206c3cbbca63$var$slo = {
        fmp: {
            initial: {
                threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
            },
            transition: {
                threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
            }
        },
        tti: {
            initial: {
                threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
            },
            transition: {
                threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
            }
        }
    };
    const $f9c6206c3cbbca63$var$timings = [
        {
            key: (0, $a286480ec63fa4c8$export$540ffd289e5e0562),
            startMark: (0, $a286480ec63fa4c8$export$23e322eb7c526958),
            endMark: (0, $a286480ec63fa4c8$export$83ca21a50372ea3b)
        },
        {
            key: (0, $a286480ec63fa4c8$export$821ca6ff41f300ec),
            startMark: (0, $a286480ec63fa4c8$export$7b887ee35f2b465e),
            endMark: (0, $a286480ec63fa4c8$export$ac953882305d6102)
        },
        {
            key: (0, $a286480ec63fa4c8$export$7f7f60b5526c5ee3),
            startMark: (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4),
            endMark: (0, $a286480ec63fa4c8$export$88ea1e280513690f)
        }
    ];
    const $f9c6206c3cbbca63$export$2878bf482e539059 = {
        'approvals-view': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.approvals-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        summary: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.summary-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'summary-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.summary-view-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        list: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.list-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'list-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.list-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-list': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jsw.list-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-list-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jsw.list-view-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        timeline: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.timeline-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'timeline-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.timeline-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        calendar: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.calendar-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'calendar-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.calendar-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        form: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.form-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-submit': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.form-submit-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-submit-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.form-submit-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-directory': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.form-directory-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        board: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.board-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-board': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.jwm-board',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-board-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.jwm-board-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-pages': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.jwm-pages',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-plan-calendar': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jsw.plan-calendar-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        })
    };
    const $f9c6206c3cbbca63$var$startedMarks = {};
    const $f9c6206c3cbbca63$export$8d15b4fb25f90514 = (view, mark)=>{
        const markKey = `${view}-${mark}`;
        if ($f9c6206c3cbbca63$var$startedMarks[markKey]) return;
        $f9c6206c3cbbca63$var$startedMarks[markKey] = true;
        const metric = $f9c6206c3cbbca63$export$2878bf482e539059[view];
        metric?.mark(mark);
    };
});
parcelRegister("8PRuf", function(module, exports) {
    $parcel$export(module.exports, "appBundleReadyMark", ()=>$0ec5205bf4957ca4$export$7e50945a65dd40e);
    $parcel$export(module.exports, "prefetchApiReadyMark", ()=>$0ec5205bf4957ca4$export$17cbe723d23101d8);
    $parcel$export(module.exports, "prefetchApiStartMark", ()=>$0ec5205bf4957ca4$export$887fadb22e7c7735);
    $parcel$export(module.exports, "jswRenderStartMark", ()=>$0ec5205bf4957ca4$export$bd099c0a906f4b3f);
    $parcel$export(module.exports, "jswCreateReduxStoreStartMark", ()=>$0ec5205bf4957ca4$export$d23ef9e7633e30e7);
    $parcel$export(module.exports, "jswCreateReduxStoreEndMark", ()=>$0ec5205bf4957ca4$export$319da6d901948a6d);
    $parcel$export(module.exports, "jswTransformCriticalDataStartMark", ()=>$0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
    $parcel$export(module.exports, "jswTransformCriticalDataEndMark", ()=>$0ec5205bf4957ca4$export$37e82663aa1e79a8);
    $parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", ()=>$0ec5205bf4957ca4$export$21146514eacceb12);
    $parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", ()=>$0ec5205bf4957ca4$export$4eb8d44ddb14424a);
    var $hXKq5;
    const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
    const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
    const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
    const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
    const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
    const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
    const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
    const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
    const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
    const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));
});
parcelRegister("iR3GG", function(module, exports) {
    $parcel$export(module.exports, "createResourceError", ()=>$d895341acba1e817$export$13487d18466bc8a5);
    var $dJl1T;
    class $d895341acba1e817$var$ResourceErrorClass extends Error {
        constructor(message, options){
            super(message);
            this.name = options.name || 'ResourceError';
            this.skipSentry = options.skipSentry;
        }
    }
    const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, errorOverride)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(component, message, errorOverride);
        if (errorOverride) return errorOverride;
        return new $d895341acba1e817$var$ResourceErrorClass(message, {
            name: name,
            skipSentry: skipSentry
        });
    };
});
parcelRegister("kqhaB", function(module, exports) {
    $parcel$export(module.exports, "activityFeedResource", ()=>$1609d8a65ae37e85$export$928ea152e5c5de54);
    $parcel$export(module.exports, "useActivityFeed", ()=>$1609d8a65ae37e85$export$ee1fe267047f502f);
    var $4NbWL;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
    const $1609d8a65ae37e85$var$EMPTY_DATA = {
        data: [],
        pageInfo: {
            hasNextPage: false,
            endCursor: ''
        }
    };
    const $1609d8a65ae37e85$export$928ea152e5c5de54 = (0, $dIdda.createResource)({
        type: $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$1609d8a65ae37e85$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return $1609d8a65ae37e85$var$EMPTY_DATA;
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("4NbWL")).fetchActivityFeed)(null, projectKey);
        },
        maxAge: 5000,
        isBrowserOnly: true
    });
    const $1609d8a65ae37e85$export$ee1fe267047f502f = ()=>(0, $dIdda.useResource)($1609d8a65ae37e85$export$928ea152e5c5de54);
});
parcelRegister("4NbWL", function(module, exports) {
    $parcel$export(module.exports, "fetchActivityFeed", ()=>$72e600639fed107e$export$967c92ed76f908b6);
    var $gKZoD;
    var $jJZqs;
    var $a8I18;
    const $72e600639fed107e$var$PAGE_SIZE = 10;
    const $72e600639fed107e$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
    const $72e600639fed107e$var$STREAM_PROVIDERS = 'thirdparty issues';
    const $72e600639fed107e$export$967c92ed76f908b6 = (after, projectKey)=>{
        (0, (0, parcelRequire("gKZoD")).di)(fetch);
        const firstIndex = after != null ? Number(after) : 0;
        const maxResults = firstIndex + $72e600639fed107e$var$PAGE_SIZE;
        return fetch(`/plugins/servlet/streams?${new URLSearchParams({
            maxResults: maxResults,
            relativeLinks: true,
            streams: `key IS ${projectKey}`,
            providers: $72e600639fed107e$var$STREAM_PROVIDERS
        }).toString()}`, {
            headers: {
                'content-type': $72e600639fed107e$var$CONTENT_TYPE
            }
        }).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`);
            return response.text();
        }).then((rawResponse)=>{
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
            const entries = (0, (0, parcelRequire("a8I18")).transformData)(xmlDoc);
            return {
                data: entries,
                pageInfo: {
                    hasNextPage: entries.length >= maxResults,
                    endCursor: String(entries.length)
                }
            };
        });
    };
});
parcelRegister("a8I18", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$26b06333cc6e5e1f$export$3ceb62baab058c6b);
    const $26b06333cc6e5e1f$export$3ceb62baab058c6b = (xmlDoc)=>{
        const result = [];
        for (const entry of xmlDoc.querySelectorAll('entry')){
            const id = entry.querySelector('id')?.textContent ?? '';
            const published = entry.querySelector('published')?.textContent ?? '';
            const name = entry.querySelector('author > name')?.textContent ?? '';
            const title = entry.querySelector('title')?.textContent ?? '';
            const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
            const content = entry.querySelector('content')?.textContent;
            const feedItem = {
                id: id,
                author: {
                    name: name,
                    avatarUrl: ''
                },
                published: published,
                title: title,
                iconUrl: iconUrl,
                content: content
            };
            entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
                if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
            });
            result.push(feedItem);
        }
        return result;
    };
});
parcelRegister("3zj3N", function(module, exports) {
    $parcel$export(module.exports, "summaryDataResource", ()=>$acdbc5801b5f9bec$export$cdfee963587c1ea4);
    $parcel$export(module.exports, "useSummaryData", ()=>$acdbc5801b5f9bec$export$c82acf736eaa253c);
    var $aR4Ot;
    var $iR3GG;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY = 'BUSINESS_SUMMARY_DATA';
    const $acdbc5801b5f9bec$var$EMPTY_DATA = {
        overviewItems: null,
        issuesByStatus: null,
        issuesByPriority: null,
        issuesByAssignee: null,
        issuesByType: null,
        workflowsCount: null
    };
    const $acdbc5801b5f9bec$export$cdfee963587c1ea4 = (0, $dIdda.createResource)({
        type: $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return $acdbc5801b5f9bec$var$EMPTY_DATA;
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const jqlContext = `project = "${projectKey}"`;
            try {
                return await (0, (0, parcelRequire("aR4Ot")).fetchSummaryPageData)({
                    cloudId: cloudId,
                    jqlContext: jqlContext,
                    projectKey: projectKey
                });
            } catch (error) {
                const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
                throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                    component: 'spa.view.routes.business.summary-data.getData',
                    message: `An error was thrown while prefetching the summary data. Status code: ${error?.statusCode}. Message: ${error?.message}`,
                    name: 'ResourceError',
                    skipSentry: isClientError
                });
            }
        },
        maxAge: 5000,
        isBrowserOnly: true
    });
    const $acdbc5801b5f9bec$export$c82acf736eaa253c = ()=>(0, $dIdda.useResource)($acdbc5801b5f9bec$export$cdfee963587c1ea4);
});
parcelRegister("aR4Ot", function(module, exports) {
    $parcel$export(module.exports, "fetchSummaryPageData", ()=>$86d3799d8fb43b74$export$a3fa5b61d6f8cf86);
    var $jlq4V;
    var $6s1PB;
    var $4R6GH;
    var $eusud;
    var $6FqTo;
    var $7P4vu;
    const $86d3799d8fb43b74$var$QUERY_NAME = 'SummaryPageData';
    const $86d3799d8fb43b74$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext, projectKey: projectKey })=>{
        const [expInlineStatusConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
        const isExperimentSummaryPageInlineStatusEnabled = expInlineStatusConfig.get('isInlineStatusChangeEnabled', false);
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/gira/1/?operation=${$86d3799d8fb43b74$var$QUERY_NAME}`, {
            body: JSON.stringify({
                query: (0, (0, parcelRequire("6FqTo")).SUMMARY_PAGE_DATA_QUERY),
                variables: {
                    cloudId: cloudId,
                    jqlContext: jqlContext,
                    projectKey: projectKey,
                    doneThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$d5aac1de7fafa2b0)}`,
                    updatedThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$b10a33c38cc20983)}`,
                    createdThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$48eb4b4c930c6378)}`,
                    dueThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$2573f5b8014b4068)}`,
                    issuesByStatusJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$8cca17e1017ba894)}`,
                    issuesByPriorityJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    issuesByAssigneeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    issuesByTypeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    pagedDataPageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                    isWorkflowsCountEnabled: isExperimentSummaryPageInlineStatusEnabled,
                    isIssueTypeCountEnabled: isExperimentSummaryPageInlineStatusEnabled && !(0, (0, parcelRequire("4R6GH")).fg)('fun-1257_remove_max_issue_type_check'),
                    isStatusIdEnabled: isExperimentSummaryPageInlineStatusEnabled || (0, (0, parcelRequire("4R6GH")).fg)('fun-1257_remove_max_issue_type_check')
                }
            })
        });
        if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        if (response.data == null) throw new Error('GraphQL response has no data');
        return (0, (0, parcelRequire("7P4vu")).transformData)(response.data);
    };
});
const $cd053842fd66588d$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $cd053842fd66588d$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $cd053842fd66588d$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $cd053842fd66588d$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $cd053842fd66588d$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $cd053842fd66588d$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $cd053842fd66588d$export$c0ecd9bd08a86184 = 8;
const $cd053842fd66588d$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $cd053842fd66588d$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;
parcelRegister("6FqTo", function(module, exports) {
    $parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", ()=>$7511339abc68f96a$export$7ea8f81ff5bf6361);
    const $7511339abc68f96a$export$7ea8f81ff5bf6361 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!, $projectKey: String!, $isWorkflowsCountEnabled: Boolean!, $isIssueTypeCountEnabled: Boolean!, $isStatusIdEnabled: Boolean!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      projectIssueTypesCount: jiraProjectByKey(key: $projectKey, cloudId: $cloudId) @include(if: $isIssueTypeCountEnabled) {
        issueTypes {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId @include(if: $isStatusIdEnabled)
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
    workflowsCount: jwmWorkflowWithIssueTypes(projectIdOrKey: $projectKey) @include(if: $isWorkflowsCountEnabled) {
      totalCount
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;
});
parcelRegister("7P4vu", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$583dacb5a6b553e9$export$3ceb62baab058c6b);
    var $6s1PB;
    var $egekd;
    const $583dacb5a6b553e9$export$3ceb62baab058c6b = (data)=>{
        const [expInlineStatusConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
        const isExperimentSummaryPageInlineStatusEnabled = expInlineStatusConfig.get('isInlineStatusChangeEnabled', false);
        return {
            overviewItems: {
                doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
                updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
                createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
                dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
            },
            issuesByStatus: data.issuesByStatus?.nodes.map((node)=>({
                    id: node.id,
                    count: node.totalCount,
                    status: {
                        name: node.field.name,
                        statusId: isExperimentSummaryPageInlineStatusEnabled ? node.field.statusId : '',
                        jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                        category: {
                            key: node.field.category.key
                        }
                    }
                })) ?? null,
            issuesByPriority: data.issuesByPriority?.nodes.map((node)=>({
                    id: node.id,
                    count: node.totalCount,
                    priority: {
                        name: node.field.name,
                        iconUrl: node.field.iconUrl
                    }
                })) ?? null,
            issuesByAssignee: data.issuesByAssignee ? {
                ...(0, (0, parcelRequire("egekd")).transformIssuesByAssigneeData)(data.issuesByAssignee),
                totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
            } : null,
            issuesByType: data.issuesByType ? {
                ...(0, (0, parcelRequire("egekd")).transformIssuesByTypeData)(data.issuesByType),
                totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
            } : null,
            projectIssueTypesCount: data?.jira?.projectIssueTypesCount?.issueTypes?.totalCount ?? null,
            workflowsCount: data?.workflowsCount?.totalCount ?? null
        };
    };
});
parcelRegister("egekd", function(module, exports) {
    $parcel$export(module.exports, "transformIssuesByAssigneeData", ()=>$0d59c4e7b34bf6f1$export$cef1c6c4edf3287b);
    $parcel$export(module.exports, "transformIssuesByTypeData", ()=>$0d59c4e7b34bf6f1$export$bc7f7d59cba70a26);
    const $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b = (data)=>({
            pageInfo: {
                hasNextPage: data.pageInfo.hasNextPage,
                endCursor: data.pageInfo.endCursor
            },
            data: data.nodes.map((node)=>({
                    id: node.id,
                    user: node.field.userValue ? {
                        avatarUrl: node.field.userValue.avatarUrl ?? '',
                        displayName: node.field.userValue.displayName,
                        accountId: node.field.userValue.accountId
                    } : null,
                    count: node.totalCount
                }))
        });
    const $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26 = (data)=>({
            pageInfo: {
                hasNextPage: data.pageInfo.hasNextPage,
                endCursor: data.pageInfo.endCursor
            },
            data: data.nodes.map((node)=>({
                    id: node.id,
                    issueType: node.field ? {
                        iconUrl: node.field.iconUrl,
                        name: node.field.name,
                        id: node.field.id
                    } : null,
                    count: node.totalCount
                }))
        });
});
parcelRegister("lGGIs", function(module, exports) {
    $parcel$export(module.exports, "markAsBentoBundleReady", ()=>$7671cdebcdce4d73$export$d9ff0b3329728986);
    var $fDtbf;
    var $2SVPM;
    let $7671cdebcdce4d73$var$reportedBentoBundleReady = false;
    const $7671cdebcdce4d73$export$d9ff0b3329728986 = (importedBundle)=>{
        if (!false) importedBundle.then(()=>{
            if ($7671cdebcdce4d73$var$reportedBentoBundleReady) return;
            $7671cdebcdce4d73$var$reportedBentoBundleReady = true;
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
                break;
            }
        });
        return importedBundle;
    };
});
parcelRegister("3r24n", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("2Lfdl"),
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4GOBq")
    ]).then(()=>parcelRequire('kW74N'));
});
parcelRegister("82uFl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("4NxWn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c6aDa").then(()=>parcelRequire('4n6tJ'));
});
parcelRegister("c5wMB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("3xlWT")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iL8G9")
    ]).then(()=>parcelRequire('ac4Ca'));
});
parcelRegister("9v9ib", function(module, exports) {
    $parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", ()=>$21f2029296bcfd0c$export$73b60789ceb8e1eb);
    $parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", ()=>$21f2029296bcfd0c$export$5ab0e07528c31349);
    var $65Ltd;
    const $21f2029296bcfd0c$export$73b60789ceb8e1eb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        path: '/jira/core/projects/:projectKey',
        exact: true,
        isRedirect: true
    };
    const $21f2029296bcfd0c$export$5ab0e07528c31349 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        path: '/jira/core/overviews/:overviewId',
        exact: true,
        isRedirect: true
    };
});
parcelRegister("3tPe4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5NrjM")
    ]).then(()=>parcelRequire('zU4ax'));
});
parcelRegister("hx3VP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8VzxY")
    ]).then(()=>parcelRequire('j5uWP'));
});
parcelRegister("axkjN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bZeJi")
    ]).then(()=>parcelRequire('iJtUd'));
});
parcelRegister("evIjU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hg0ML")
    ]).then(()=>parcelRequire('hLT0c'));
});
parcelRegister("32mSj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("hUhek")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fRBgo")
    ]).then(()=>parcelRequire('azXNC'));
});
parcelRegister("8BtoG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kkvf2")
    ]).then(()=>parcelRequire('jJF0P'));
});
parcelRegister("jPhO0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fBNW3")
    ]).then(()=>parcelRequire('425eT'));
});
parcelRegister("ieQKQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1IlDx")
    ]).then(()=>parcelRequire('icB4w'));
});
parcelRegister("aWQgu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jA7gz").then(()=>parcelRequire('4qzdE'));
});
parcelRegister("9QELA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4nk9B")
    ]).then(()=>parcelRequire('fU1n9'));
});
parcelRegister("eanHo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("d9GTB")
    ]).then(()=>parcelRequire('hcjUE'));
});
parcelRegister("ePboY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("lY6ya")
    ]).then(()=>parcelRequire('7H3bY'));
});
parcelRegister("3yT5r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lOtTG")
    ]).then(()=>parcelRequire('ik71Z'));
});
parcelRegister("jyTiP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fukyz")
    ]).then(()=>parcelRequire('UcTEy'));
});
parcelRegister("hchJ9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6hewl")
    ]).then(()=>parcelRequire('6QJpB'));
});
parcelRegister("3THqq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8IHqF")
    ]).then(()=>parcelRequire('ge8BQ'));
});
parcelRegister("9ZUr6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lKmFv")
    ]).then(()=>parcelRequire('719qB'));
});
parcelRegister("jvCkt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("lkM4h")
    ]).then(()=>parcelRequire('ePHET'));
});
parcelRegister("hKI24", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dczku")
    ]).then(()=>parcelRequire('7WItf'));
});
parcelRegister("3k1Pf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4uhfd")
    ]).then(()=>parcelRequire('kB5po'));
});
parcelRegister("30tb6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bvt9E")
    ]).then(()=>parcelRequire('2sFVY'));
});
parcelRegister("iBRfX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d88J6")
    ]).then(()=>parcelRequire('fm6i9'));
});
parcelRegister("1NY07", function(module, exports) {
    $parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", ()=>$904f4088ba13256f$export$952eefa1907e877a);
    var $65Ltd;
    const $904f4088ba13256f$export$952eefa1907e877a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS),
        path: '/plugins/servlet/project-config/:projectKey/data-classifications',
        exact: true
    };
});
parcelRegister("2igd7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6ibtl")
    ]).then(()=>parcelRequire('9iqsx'));
});
parcelRegister("61LFA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6BhXI")
    ]).then(()=>parcelRequire('8SAZe'));
});
parcelRegister("e2ctp", function(module, exports) {
    $parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", ()=>$f36666704bcc2bab$export$137d6d169f402a59);
    $parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", ()=>$f36666704bcc2bab$export$ad16a91905cefb0a);
    const $f36666704bcc2bab$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
    const $f36666704bcc2bab$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
    const $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
    const $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
    const $f36666704bcc2bab$export$137d6d169f402a59 = [
        $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX
    ];
    const $f36666704bcc2bab$export$ad16a91905cefb0a = [
        $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$COMMON_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX
    ];
});
parcelRegister("lfnsv", function(module, exports) {
    $parcel$export(module.exports, "boardDetailsResource", ()=>$d78990d38f225e07$export$6c6984c55b171c5d);
    $parcel$export(module.exports, "getBoardDetailsResource", ()=>$d78990d38f225e07$export$b67eabcfc08e7c62);
    var $jcw0u;
    var $co1wz;
    var $7f4tk;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $d78990d38f225e07$export$90ce361a5838e31e = async (boardId)=>{
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/agile/1.0/board/${boardId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getBoardDetailsRequest',
                    packageName: 'jiraRouterResourcesClassicProjects',
                    teamName: 'a4t-pandora'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $d78990d38f225e07$export$6c6984c55b171c5d = (0, $dIdda.createResource)({
        type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
        getKey: (routerContext)=>routerContext.query?.config ? 'cmp-board-settings' : 'not-cmp-board-setting',
        getData: async (routerContext)=>{
            const boardId = routerContext.match.params?.boardId ?? '';
            if (routerContext.query?.config) return $d78990d38f225e07$export$90ce361a5838e31e(boardId);
            return null;
        }
    });
    const $d78990d38f225e07$export$b67eabcfc08e7c62 = ()=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('simplified-boards-milestone-2_07hbk'), $d78990d38f225e07$export$6c6984c55b171c5d);
});
parcelRegister("lJ1FP", function(module, exports) {
    $parcel$export(module.exports, "editModelResource", ()=>$16cc53c7df259df5$export$ab9a4786826fd2d);
    $parcel$export(module.exports, "getEditModelResource", ()=>$16cc53c7df259df5$export$5b9bac2cc4bf4511);
    var $jcw0u;
    var $co1wz;
    var $7f4tk;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $16cc53c7df259df5$export$ddbb511f9111736a = async (boardId)=>{
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getEditModelRequest',
                    packageName: 'jiraRouterResourcesClassicProjects',
                    teamName: 'a4t-pandora'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $16cc53c7df259df5$export$ab9a4786826fd2d = (0, $dIdda.createResource)({
        type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
        getKey: (routerContext)=>routerContext.query?.config ? 'edit-model' : 'not-edit-model',
        getData: async (routerContext)=>{
            if (routerContext.query?.config) {
                const boardId = routerContext.match.params?.boardId ?? '';
                return $16cc53c7df259df5$export$ddbb511f9111736a(boardId);
            }
            return null;
        }
    });
    const $16cc53c7df259df5$export$5b9bac2cc4bf4511 = ()=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('simplified-boards-milestone-2_07hbk') && !(0, (0, parcelRequire("co1wz")).ff)('board-settings-graphql-refactor_cyvz9'), $16cc53c7df259df5$export$ab9a4786826fd2d);
});
parcelRegister("f5kpo", function(module, exports) {
    $parcel$export(module.exports, "shouldLoadUIFBoardResources", ()=>$e96bf35f407138bb$export$d8d4641986a9ac7f);
    $parcel$export(module.exports, "getRapidboardResources", ()=>$e96bf35f407138bb$export$3a5e56bd5231a56b);
    $parcel$export(module.exports, "getRapidBoardDataResource", ()=>$e96bf35f407138bb$export$1c63de7f548f965f);
    $parcel$export(module.exports, "getUIFBacklogDataResource", ()=>$e96bf35f407138bb$export$ee826506b3baa13a);
    var $co1wz;
    var $4R6GH;
    var $5Nutl;
    var $gNStA;
    var $3R260;
    var $i6CNv;
    var $kdyVI;
    var $5jCaw;
    var $gQ2J4;
    var $fox5Q;
    const $e96bf35f407138bb$export$d8d4641986a9ac7f = ()=>!false;
    const $e96bf35f407138bb$export$462ca08d6ce67848 = ()=>!$e96bf35f407138bb$export$d8d4641986a9ac7f();
    const $e96bf35f407138bb$export$3a5e56bd5231a56b = ()=>[
            (0, (0, parcelRequire("fox5Q")).wrmBundleResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.classic.board.api-calls.modern-frontend'), (0, (0, parcelRequire("i6CNv")).boardConfigApiResource), (0, (0, parcelRequire("3R260")).boardConfigResource)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)($e96bf35f407138bb$export$462ca08d6ce67848, (0, (0, parcelRequire("gQ2J4")).rapidboardResource))
        ];
    const $e96bf35f407138bb$export$1c63de7f548f965f = ()=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.classic.board.api-calls.modern-frontend'), (0, (0, parcelRequire("kdyVI")).boardDataResource), (0, (0, parcelRequire("5jCaw")).initialAllDataResource));
    const $e96bf35f407138bb$export$ee826506b3baa13a = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && !(0, (0, parcelRequire("4R6GH")).fg)('indexeddb_cache_for_backlog'), (0, (0, parcelRequire("5Nutl")).uifBacklogResourceOld)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, (0, parcelRequire("4R6GH")).fg)('indexeddb_cache_for_backlog'), (0, (0, parcelRequire("5Nutl")).uifBacklogResource))
        ];
});
parcelRegister("5Nutl", function(module, exports) {
    $parcel$export(module.exports, "uifBacklogResourceOld", ()=>$9905b3c28d313f7e$export$db83ef0443397b85);
    $parcel$export(module.exports, "uifBacklogResource", ()=>$9905b3c28d313f7e$export$c182dffb98985208);
    var $dIdda = parcelRequire("dIdda");
    const $9905b3c28d313f7e$export$db83ef0443397b85 = (0, $dIdda.createResource)({
        type: (0, $2fdbe99f6cbea4f1$export$8f9824ba4409b537),
        getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>[
                'uif-backlog-data'
            ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
        getDataLoader: ()=>(parcelRequire("6b32i")),
        maxAge: 0
    });
    const $9905b3c28d313f7e$export$c182dffb98985208 = (0, $dIdda.createResource)({
        type: (0, $2fdbe99f6cbea4f1$export$d15ce4feabd76ea),
        getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>[
                'uif-backlog-data'
            ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
        getDataLoader: ()=>(parcelRequire("6zLm4")),
        maxAge: 0
    });
});
const $2fdbe99f6cbea4f1$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $2fdbe99f6cbea4f1$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';
parcelRegister("6b32i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hgAfI").then(()=>parcelRequire('gTjY8'));
});
parcelRegister("6zLm4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8723H").then(()=>parcelRequire('cpSf8'));
});
parcelRegister("3R260", function(module, exports) {
    $parcel$export(module.exports, "boardConfigResource", ()=>$2e0f91ad67d4bd03$export$5d16d5f1340da88f);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $2e0f91ad67d4bd03$export$5d16d5f1340da88f = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("it1fP")),
        maxAge: Number.MAX_VALUE,
        isBrowserOnly: true
    });
});
parcelRegister("1odlY", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", ()=>$fa7f7a1583a8dcf1$export$88e2a0b89be042c1);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", ()=>$fa7f7a1583a8dcf1$export$ba075d0985968d1c);
    $parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", ()=>$fa7f7a1583a8dcf1$export$395f77888d07f2e0);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", ()=>$fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", ()=>$fa7f7a1583a8dcf1$export$3328c8e71fda97bb);
    $parcel$export(module.exports, "WRM_RESOURCES_ARRAY", ()=>$fa7f7a1583a8dcf1$export$ef21257df3d71188);
    $parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$ccd0929652c235de);
    $parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$1d16bdcc94a40107);
    $parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$1f599d2eef0a7281);
    const $fa7f7a1583a8dcf1$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
    const $fa7f7a1583a8dcf1$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
    const $fa7f7a1583a8dcf1$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
    const $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
    const $fa7f7a1583a8dcf1$export$75dfa03544a19422 = 'ROADMAP';
    const $fa7f7a1583a8dcf1$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
    const $fa7f7a1583a8dcf1$export$ef21257df3d71188 = [
        '_super',
        'wrc!greenhopper-rapid-non-gadget',
        'wrc!gh-rapid',
        'wrc!jira.global',
        'wrc!jira.general',
        'wrc!atl.global',
        'wrc!jira.webresources:header',
        'wrc!jira.webresources:calendar',
        'wrc!jira.webresources:calendar-en',
        'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
        'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
        'wrc!gh-rapid-config',
        'wrc!gh-rapid-analytics',
        'wrc!gh-rapid-charts',
        'wrc!jira.webresources:mentions-feature',
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
    ];
    const $fa7f7a1583a8dcf1$export$ccd0929652c235de = [];
    const $fa7f7a1583a8dcf1$export$1d16bdcc94a40107 = [
        'wrc!gh-rapid-lwf-board-fhd',
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:feature-flags',
        'wrc!com.atlassian.auiplugin:aui-spinner',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!com.atlassian.analytics.analytics-client:js-events'
    ];
    const $fa7f7a1583a8dcf1$export$1f599d2eef0a7281 = [
        'wrc!gh-rapid-backlog-fhd',
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:header',
        'wrc!jira.webresources:feature-flags',
        'wrc!com.atlassian.auiplugin:aui-spinner',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!com.atlassian.analytics.analytics-client:js-events'
    ];
});
parcelRegister("it1fP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fEbPN").then(()=>parcelRequire('2M4Kz'));
});
parcelRegister("i6CNv", function(module, exports) {
    $parcel$export(module.exports, "boardConfigApiResource", ()=>$8a55ba0bef7e0e2a$export$dd9dec064acb0c4e);
    var $co1wz;
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $8a55ba0bef7e0e2a$var$configResourceCacheTime = ()=>(0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('jsw.classic.board.api-calls.config-cache-time', 0);
    const $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
        getKey: ({ match: match, query: query })=>{
            const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
            return `rapidViewConfig-${boardId}`;
        },
        getDataLoader: ()=>(parcelRequire("ifUKB")),
        maxAge: false ? 0 : $8a55ba0bef7e0e2a$var$configResourceCacheTime() * 1000,
        isBrowserOnly: true
    });
});
parcelRegister("ifUKB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dz3p9").then(()=>parcelRequire('aCQV9'));
});
parcelRegister("kdyVI", function(module, exports) {
    $parcel$export(module.exports, "boardDataResource", ()=>$18aa0ee73b651f62$export$138fa635416978f7);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    var $9g2vH;
    const $18aa0ee73b651f62$export$138fa635416978f7 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
        getKey: ({ match: match, query: query, route: route })=>{
            const { name: name = '' } = route || {};
            const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
            const { config: config } = query;
            const hasConfig = Boolean(config);
            let key = 'rapidBoardData';
            if ((0, (0, parcelRequire("9g2vH")).isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
            else if ((0, (0, parcelRequire("9g2vH")).isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
            return key;
        },
        getDataLoader: ()=>(parcelRequire("bnQeN")),
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("9g2vH", function(module, exports) {
    $parcel$export(module.exports, "isBoardRoute", ()=>$ccbac8c858ea0da2$export$437d4d6e25681588);
    $parcel$export(module.exports, "isBacklogRoute", ()=>$ccbac8c858ea0da2$export$bcb853db5e3e8054);
    var $65Ltd;
    const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS);
    const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED);
});
parcelRegister("bnQeN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("75jqm").then(()=>parcelRequire('iW9CS'));
});
parcelRegister("5jCaw", function(module, exports) {
    $parcel$export(module.exports, "initialAllDataResource", ()=>$df03d49e5d06a603$export$4680aabd39eb6d1c);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $df03d49e5d06a603$export$4680aabd39eb6d1c = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("69EhV")),
        maxAge: Number.MAX_VALUE,
        isBrowserOnly: true
    });
});
parcelRegister("69EhV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9aQb5").then(()=>parcelRequire('GLfv4'));
});
parcelRegister("gQ2J4", function(module, exports) {
    $parcel$export(module.exports, "rapidboardResource", ()=>$b172ecb4db4f1d22$export$d0f42a55e7c5752c);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $b172ecb4db4f1d22$export$d0f42a55e7c5752c = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
        getKey: ({ match: match })=>match.query.rapidView || '',
        getDataLoader: ()=>(parcelRequire("4ajRG")),
        maxAge: Number.MAX_VALUE,
        isBrowserOnly: true
    });
});
parcelRegister("4ajRG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hq4Ox").then(()=>parcelRequire('LP66E'));
});
parcelRegister("fox5Q", function(module, exports) {
    $parcel$export(module.exports, "wrmBundleResource", ()=>$bb15c3971b88e6fc$export$f199d15b7cd18df1);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $bb15c3971b88e6fc$export$f199d15b7cd18df1 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("8kiyc")),
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
parcelRegister("8kiyc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3c33e").then(()=>parcelRequire('bdOyr'));
});
parcelRegister("2GkDw", function(module, exports) {
    $parcel$export(module.exports, "devOpsProviderResource", ()=>$3640b01f63c1fd17$export$19e58e21b24ae0d8);
    var $dIdda = parcelRequire("dIdda");
    const $3640b01f63c1fd17$export$19e58e21b24ae0d8 = (0, $dIdda.createResource)({
        type: (0, $e9cf201ab81d4288$export$5f92e516f4b78544),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("f6n3Y")),
        maxAge: 60000
    });
    const $3640b01f63c1fd17$export$b80f5852c41a5ca8 = ()=>(0, $dIdda.useResource)($3640b01f63c1fd17$export$19e58e21b24ae0d8);
});
const $e9cf201ab81d4288$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $e9cf201ab81d4288$export$d7f081d6dd0e72fc = 'bitbucket';
const $e9cf201ab81d4288$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $e9cf201ab81d4288$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';
parcelRegister("f6n3Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7G5IV").then(()=>parcelRequire('2MQ7j'));
});
parcelRegister("hJAri", function(module, exports) {
    $parcel$export(module.exports, "classicRoadmapResource", ()=>$b200b290d50f82d3$export$e755913caca1ab8e);
    var $dIdda = parcelRequire("dIdda");
    const $b200b290d50f82d3$export$e755913caca1ab8e = (0, $dIdda.createResource)({
        type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("2Pkdr")),
        isBrowserOnly: true
    });
});
const $87d7efe6336d8b83$export$75dfa03544a19422 = 'ROADMAP';
const $87d7efe6336d8b83$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';
parcelRegister("2Pkdr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8MG8R").then(()=>parcelRequire('g52eJ'));
});
parcelRegister("iZ82x", function(module, exports) {
    $parcel$export(module.exports, "codePageResource", ()=>$06e9ff5230710b90$export$642ce64cf3689406);
    var $65Ltd;
    var $ao2h1;
    var $euUUL;
    var $6mT2K;
    let $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
    const $06e9ff5230710b90$export$642ce64cf3689406 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $96625f88cf395132$export$94a43d2ac55ac375),
        getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
            const isCodeRoute = name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE) || name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC);
            if (!$06e9ff5230710b90$var$numPullRequestsToFetch && isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = (0, (0, parcelRequire("6mT2K")).getNumPullRequestsToFetch)(query);
            if (!isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
            return {
                parameters: (0, (0, parcelRequire("euUUL")).default),
                options: {
                    fetchPolicy: 'store-and-network'
                },
                variables: {
                    cloudId: cloudId,
                    projectKey: params.projectKey ?? '',
                    pullRequestsUpdatedFrom: (0, (0, parcelRequire("6mT2K")).getPullRequestsUpdatedFromDate)(),
                    numPullRequestsToFetch: $06e9ff5230710b90$var$numPullRequestsToFetch,
                    siteAri: `ari:cloud:jira::site/${cloudId}`
                }
            };
        }
    });
});
parcelRegister("euUUL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1914e75096664626$export$2e2bcd8739ae039);
    var $h8xcT;
    const $1914e75096664626$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numPullRequestsToFetch"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pullRequestsUpdatedFrom"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteAri"
        }, v5 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "siteAri"
            },
            {
                "kind": "Literal",
                "name": "providerTypes",
                "value": [
                    "DEV_INFO"
                ]
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ScalarField",
            "name": "name"
        }, v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9
        ], v11 = {
            "kind": "ScalarField",
            "name": "status"
        }, v12 = {
            "concreteType": "JiraConfigStateConnection",
            "kind": "LinkedField",
            "name": "config",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraConfigState",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appId"
                        },
                        v11
                    ]
                }
            ]
        }, v13 = [
            v12
        ], v14 = [
            v8
        ], v15 = [
            {
                "kind": "Literal",
                "name": "appId",
                "value": "bitbucket"
            },
            v9
        ], v16 = [
            v9,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v17 = [
            {
                "kind": "Literal",
                "name": "sort",
                "value": {
                    "lastModified": {
                        "direction": "DESC",
                        "priority": 1
                    }
                }
            }
        ], v18 = [
            v12,
            v6
        ], v19 = {
            "kind": "ScalarField",
            "name": "lastUpdated"
        }, v20 = {
            "kind": "ScalarField",
            "name": "url"
        }, v21 = [
            v8,
            {
                "kind": "ScalarField",
                "name": "accountId"
            },
            v7,
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v6
        ], v22 = [
            v6
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "mainCodeInJiraUpdatedQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOps",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5,
                                        "concreteType": "DevOpsProviders",
                                        "kind": "LinkedField",
                                        "name": "providers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "DevOpsDevInfoProvider",
                                                "kind": "LinkedField",
                                                "name": "devInfoProviders",
                                                "plural": true,
                                                "selections": [
                                                    v6,
                                                    v7,
                                                    v8,
                                                    {
                                                        "args": v10,
                                                        "concreteType": "JiraAppConfigState",
                                                        "kind": "LinkedField",
                                                        "name": "configState",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "devOps.providers"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOps"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v10,
                            "concreteType": "CodeInJira",
                            "kind": "LinkedField",
                            "name": "codeInJira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CodeInJiraUserConfiguration",
                                        "kind": "LinkedField",
                                        "name": "userConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                                    "kind": "LinkedField",
                                                    "name": "ownedBitbucketWorkspaces",
                                                    "plural": true,
                                                    "selections": v14
                                                },
                                                "action": "THROW",
                                                "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "codeInJira.userConfiguration"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "codeInJira"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraDevOpsQuery",
                                "kind": "LinkedField",
                                "name": "devOps",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v15,
                                        "concreteType": "JiraAppConfigState",
                                        "kind": "LinkedField",
                                        "name": "configState",
                                        "plural": false,
                                        "selections": v13
                                    }
                                ]
                            },
                            {
                                "args": v16,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v17,
                                        "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                        "kind": "LinkedField",
                                        "name": "repositories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v14
                                            }
                                        ],
                                        "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_MainPage"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_Header"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_ConnectionPage"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v2,
                    v1,
                    v3,
                    v4,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcimprovecodepageemptystaterelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "mainCodeInJiraUpdatedQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v5,
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsDevInfoProvider",
                                        "kind": "LinkedField",
                                        "name": "devInfoProviders",
                                        "plural": true,
                                        "selections": [
                                            v6,
                                            v7,
                                            v8,
                                            {
                                                "args": v10,
                                                "concreteType": "JiraAppConfigState",
                                                "kind": "LinkedField",
                                                "name": "configState",
                                                "plural": false,
                                                "selections": v18
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "homeUrl"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "namespace"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": v10,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CodeInJiraUserConfiguration",
                                "kind": "LinkedField",
                                "name": "userConfiguration",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CodeInJiraBitbucketWorkspace",
                                        "kind": "LinkedField",
                                        "name": "ownedBitbucketWorkspaces",
                                        "plural": true,
                                        "selections": [
                                            v8,
                                            {
                                                "kind": "ScalarField",
                                                "name": "uuid"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "slug"
                                            },
                                            v7
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraDevOpsQuery",
                                "kind": "LinkedField",
                                "name": "devOps",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v15,
                                        "concreteType": "JiraAppConfigState",
                                        "kind": "LinkedField",
                                        "name": "configState",
                                        "plural": false,
                                        "selections": v18
                                    }
                                ]
                            },
                            {
                                "args": v16,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v17,
                                        "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                        "kind": "LinkedField",
                                        "name": "repositories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v8,
                                                    v6,
                                                    v19,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "providerId"
                                                                    },
                                                                    v7,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "avatarUrl"
                                                                    },
                                                                    v20
                                                                ],
                                                                "type": "DevOpsRepository"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                    },
                                    v6,
                                    {
                                        "args": [
                                            {
                                                "fields": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "updatedFrom",
                                                        "variableName": "pullRequestsUpdatedFrom"
                                                    }
                                                ],
                                                "kind": "ObjectValue",
                                                "name": "filter"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "first",
                                                "variableName": "numPullRequestsToFetch"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": {
                                                    "lastUpdatedSortDirection": "DESC"
                                                }
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "type",
                                                "value": "project-associated-pr"
                                            }
                                        ],
                                        "concreteType": "AriGraphRelationshipConnection",
                                        "kind": "LinkedField",
                                        "name": "devOpsEntityRelationships",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "AriGraphRelationshipEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationship",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationshipNode",
                                                                "kind": "LinkedField",
                                                                "name": "to",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "data",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v8,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v11,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryName"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "author",
                                                                                        "plural": false,
                                                                                        "selections": v21
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "DevOpsReviewer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "reviewers",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v21
                                                                                            },
                                                                                            v8,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "approvalStatus"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "userId"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "title"
                                                                                    },
                                                                                    v6,
                                                                                    v19,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "commentCount"
                                                                                    },
                                                                                    v20,
                                                                                    {
                                                                                        "concreteType": "DevOpsBranchInfo",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "destinationBranch",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v7,
                                                                                            v20
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "pullRequestInternalId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryUrl"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "authorId"
                                                                                    }
                                                                                ],
                                                                                "type": "DevOpsPullRequestDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "Node",
                                                                                "abstractKey": "__isNode"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "ConfluencePage"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "ConfluenceSpace"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsFeatureFlag"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsComponentDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsIncidentDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsRepository"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsSecurityVulnerabilityDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraConfluenceRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraCustomRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraIssueRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraWebRemoteIssueLink"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v6
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "133ff17ae88c722ba1d91f8fc407b9e8f0d1a640a4c93ec27cfe43dd6ef0142b",
                "metadata": {},
                "name": "mainCodeInJiraUpdatedQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcimprovecodepageemptystaterelayprovider": (0, (0, parcelRequire("h8xcT")).default)
                }
            }
        };
    }();
    $1914e75096664626$var$node.hash = "02f9224d53652182a109e4936760d09f";
    var $1914e75096664626$export$2e2bcd8739ae039 = $1914e75096664626$var$node;
});
parcelRegister("h8xcT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f9ec23850e5424c$export$2e2bcd8739ae039);
    var $6s1PB;
    var $7f9ec23850e5424c$export$2e2bcd8739ae039 = {
        get () {
            const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_improve_scm_onboarding');
            return expConfig.get('isEnabled', false);
        }
    };
});
parcelRegister("6mT2K", function(module, exports) {
    $parcel$export(module.exports, "isBitbucketProvider", ()=>$e46b745b21c77b2f$export$1f508885be28c4e);
    $parcel$export(module.exports, "codeErrorBoundaryAttributes", ()=>$e46b745b21c77b2f$export$ea10bb8bdf2072e5);
    $parcel$export(module.exports, "toSanitizedUrl", ()=>$e46b745b21c77b2f$export$36fdccbdcd093523);
    $parcel$export(module.exports, "useIsOverflowWidth", ()=>$e46b745b21c77b2f$export$2dcd60313c8d761b);
    $parcel$export(module.exports, "getPullRequestsUpdatedFromDate", ()=>$e46b745b21c77b2f$export$3784bdf6b4807521);
    $parcel$export(module.exports, "getNumPullRequestsToFetch", ()=>$e46b745b21c77b2f$export$a837c7c9c7670570);
    var $5uXOq = parcelRequire("5uXOq");
    var $5kchp = parcelRequire("5kchp");
    var $it1wb;
    var $gn1v9;
    var $eY2eW;
    var $1tSBh;
    const $e46b745b21c77b2f$export$36ebc9cd52c6b517 = (repository)=>repository === (0, (0, parcelRequire("1tSBh")).RepositoryTypes).REPO_BITBUCKET;
    const $e46b745b21c77b2f$export$1f508885be28c4e = (providerId)=>providerId === (0, (0, parcelRequire("eY2eW")).VcsProviderIds).BITBUCKET || providerId === (0, (0, parcelRequire("eY2eW")).DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, (0, parcelRequire("eY2eW")).DataDepotProviderIds).BITBUCKET_STG;
    const $e46b745b21c77b2f$var$shouldCountToReliability = (error)=>{
        const okayErrors = [
            ...(0, (0, parcelRequire("eY2eW")).nonCriticalGqlErrors),
            ...(0, (0, parcelRequire("eY2eW")).nonReliabilityCriticalErrors)
        ];
        return !okayErrors.includes(error.message);
    };
    const $e46b745b21c77b2f$export$ea10bb8bdf2072e5 = (error)=>{
        if (error instanceof Error) return {
            countToReliability: $e46b745b21c77b2f$var$shouldCountToReliability(error)
        };
        return {
            countToReliability: true
        };
    };
    const $e46b745b21c77b2f$export$36fdccbdcd093523 = (url)=>(0, $5kchp.sanitizeUrl)(url);
    const $e46b745b21c77b2f$export$2dcd60313c8d761b = (ref, callback)=>{
        const [isOverflow, setIsOverflow] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const { current: current } = ref;
            const trigger = ()=>{
                const hasOverflow = current.scrollWidth > current.clientWidth;
                setIsOverflow(hasOverflow);
                if (callback) callback(hasOverflow);
            };
            if (current) {
                if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
                trigger();
            }
        }, [
            callback,
            ref
        ]);
        return isOverflow;
    };
    const $e46b745b21c77b2f$export$3784bdf6b4807521 = ()=>(0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("gn1v9")).default)(new Date(), {
            days: (0, (0, parcelRequire("eY2eW")).PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
        })).toISOString();
    const $e46b745b21c77b2f$export$a837c7c9c7670570 = (queryParams)=>{
        const hasFilterOrSortQueryParam = Object.entries(queryParams).some(([key, value])=>(0, (0, parcelRequire("eY2eW")).queryParamsToWatch).includes(key) && value !== '');
        return hasFilterOrSortQueryParam ? (0, (0, parcelRequire("eY2eW")).MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, (0, parcelRequire("eY2eW")).PULL_REQUESTS_TABLE_PAGE_SIZE);
    };
});
parcelRegister("5kchp", function(module, exports) {
    'use strict';
    var $3e0858899f98084b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
    var $3e0858899f98084b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
    var $3e0858899f98084b$var$urlSchemeRegex = /^([^:]+):/gm;
    var $3e0858899f98084b$var$relativeFirstCharacters = [
        '.',
        '/'
    ];
    function $3e0858899f98084b$var$isRelativeUrl(url) {
        return $3e0858899f98084b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
    }
    function $3e0858899f98084b$var$sanitizeUrl(url) {
        if (!url) return 'about:blank';
        var urlScheme, urlSchemeParseResults;
        var sanitizedUrl = url.replace($3e0858899f98084b$var$ctrlCharactersRegex, '');
        if ($3e0858899f98084b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
        urlSchemeParseResults = sanitizedUrl.match($3e0858899f98084b$var$urlSchemeRegex);
        if (!urlSchemeParseResults) return 'about:blank';
        urlScheme = urlSchemeParseResults[0];
        if ($3e0858899f98084b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
        return sanitizedUrl;
    }
    module.exports = {
        sanitizeUrl: $3e0858899f98084b$var$sanitizeUrl
    };
});
parcelRegister("eY2eW", function(module, exports) {
    $parcel$export(module.exports, "nonCriticalGqlErrors", ()=>$a2f3556545768e94$export$4b1abe4db5ed7515);
    $parcel$export(module.exports, "nonReliabilityCriticalErrors", ()=>$a2f3556545768e94$export$687544614e0812da);
    $parcel$export(module.exports, "cardBoxShadow", ()=>$a2f3556545768e94$export$7527a73da794030d);
    $parcel$export(module.exports, "cardBoxHoverShadow", ()=>$a2f3556545768e94$export$2ecfdc24b216c295);
    $parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", ()=>$a2f3556545768e94$export$f84c6b6609a3dd30);
    $parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", ()=>$a2f3556545768e94$export$ea15b38f3901f518);
    $parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", ()=>$a2f3556545768e94$export$2b8b0a4489f9147b);
    $parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", ()=>$a2f3556545768e94$export$3b8f88133d28aaa6);
    $parcel$export(module.exports, "REPOSITORIES_HEADER_ID", ()=>$a2f3556545768e94$export$256a9f141103f328);
    $parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", ()=>$a2f3556545768e94$export$b0d4e90e40369b80);
    $parcel$export(module.exports, "featureIdToHelpMap", ()=>$a2f3556545768e94$export$1de4eaccc23a8747);
    $parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", ()=>$a2f3556545768e94$export$5c00a6bedc2037c8);
    $parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$f70ce14ba902adcb);
    $parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", ()=>$a2f3556545768e94$export$19381ed4387aa05b);
    $parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", ()=>$a2f3556545768e94$export$f3e116f999d4c5c1);
    $parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", ()=>$a2f3556545768e94$export$c28f1cd40ae0394c);
    $parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", ()=>$a2f3556545768e94$export$f69d7aa9c5e17d55);
    $parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", ()=>$a2f3556545768e94$export$4ed9a8a7faf641f);
    $parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", ()=>$a2f3556545768e94$export$c5322e755fd1028d);
    $parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", ()=>$a2f3556545768e94$export$72fcd104fde041d6);
    $parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$d8f600a480a9c2d4);
    $parcel$export(module.exports, "STATUS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$9d9ab707c4e446cc);
    $parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$4da3056fdbfaf111);
    $parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", ()=>$a2f3556545768e94$export$e1134688b6a1032);
    $parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", ()=>$a2f3556545768e94$export$143249aa50321d51);
    $parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", ()=>$a2f3556545768e94$export$a46febdd3fe90de0);
    $parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", ()=>$a2f3556545768e94$export$333db4cac7ee017);
    $parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", ()=>$a2f3556545768e94$export$5cbae081959768bd);
    $parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$4939c117ba49bc9e);
    $parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$5a92d7579dac6294);
    $parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$a77ea162c15f0290);
    $parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$b7477204cae64b46);
    $parcel$export(module.exports, "QUERY_PARAM_SUMMARY", ()=>$a2f3556545768e94$export$39983b6fb040a5eb);
    $parcel$export(module.exports, "QUERY_PARAM_AUTHORS", ()=>$a2f3556545768e94$export$3d96f5f9ccd35be6);
    $parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", ()=>$a2f3556545768e94$export$8a8927c29ab32b10);
    $parcel$export(module.exports, "QUERY_PARAM_STATUS", ()=>$a2f3556545768e94$export$3e8168848b996f7);
    $parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", ()=>$a2f3556545768e94$export$4adc519ba40b72a6);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", ()=>$a2f3556545768e94$export$6da773286c35ef41);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", ()=>$a2f3556545768e94$export$810a1f7ed2facfcb);
    $parcel$export(module.exports, "queryParamsToWatch", ()=>$a2f3556545768e94$export$ba75fb5089c0eb0b);
    $parcel$export(module.exports, "VcsProviderIds", ()=>$a2f3556545768e94$export$7d5c3d28df5f438a);
    $parcel$export(module.exports, "DataDepotProviderIds", ()=>$a2f3556545768e94$export$7912a169c18abe9d);
    $parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", ()=>$a2f3556545768e94$export$74189cec821240a6);
    $parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", ()=>$a2f3556545768e94$export$3f3fc252f5066c72);
    $parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", ()=>$a2f3556545768e94$export$9ce5b1bba5f17875);
    const $a2f3556545768e94$export$4b1abe4db5ed7515 = [
        'HTTP status [403] while retrieving Bitbucket repository.',
        'HTTP status [404] while retrieving Bitbucket repository.',
        "Failed to retrieve Bitbucket repository because the user wasn't authorized."
    ];
    const $a2f3556545768e94$export$687544614e0812da = [
        'HTTP status [429] while retrieving Bitbucket repository.',
        "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
        'The user does not have admin permission for the site, Jira, project or the project does not exist.',
        'Unable to get providers when contacting Jira due to 401 Unauthorized'
    ];
    const $a2f3556545768e94$export$7527a73da794030d = "var(--ds-shadow-overflow, 0 1px 1px rgb(9 30 66 / 25%), 0 0 1px 1px rgb(9 30 66 / 13%))";
    const $a2f3556545768e94$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, rgba(9, 30, 66, 0.31) 0px 0px 1px 0px, rgba(9, 30, 66, 0.25) 0px 8px 16px -6px)";
    const $a2f3556545768e94$export$f84c6b6609a3dd30 = 1000;
    const $a2f3556545768e94$export$ea15b38f3901f518 = 12;
    const $a2f3556545768e94$export$2b8b0a4489f9147b = 30;
    const $a2f3556545768e94$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
    const $a2f3556545768e94$export$256a9f141103f328 = 'repository-list-header';
    const $a2f3556545768e94$export$b0d4e90e40369b80 = 'repository-list-description';
    const $a2f3556545768e94$export$1de4eaccc23a8747 = {
        'repository-list.pull-requests.empty-state': {
            helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
            href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
        },
        'repository-list.pull-requests.description': {
            helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
            href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
        }
    };
    const $a2f3556545768e94$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
    const $a2f3556545768e94$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
    const $a2f3556545768e94$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
    const $a2f3556545768e94$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
    const $a2f3556545768e94$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
    const $a2f3556545768e94$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
    const $a2f3556545768e94$export$4ed9a8a7faf641f = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.title-link`;
    const $a2f3556545768e94$export$c5322e755fd1028d = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.target-branch-link`;
    const $a2f3556545768e94$export$72fcd104fde041d6 = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.repository-link`;
    const $a2f3556545768e94$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
    const $a2f3556545768e94$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
    const $a2f3556545768e94$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
    const $a2f3556545768e94$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
    const $a2f3556545768e94$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
    const $a2f3556545768e94$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
    const $a2f3556545768e94$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
    const $a2f3556545768e94$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
    const $a2f3556545768e94$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
    const $a2f3556545768e94$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
    const $a2f3556545768e94$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
    const $a2f3556545768e94$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
    const $a2f3556545768e94$export$39983b6fb040a5eb = 'summaryFilter';
    const $a2f3556545768e94$export$3d96f5f9ccd35be6 = 'authorsFilter';
    const $a2f3556545768e94$export$8a8927c29ab32b10 = 'reviewersFilter';
    const $a2f3556545768e94$export$3e8168848b996f7 = 'statusFilter';
    const $a2f3556545768e94$export$4adc519ba40b72a6 = 'repositoriesFilter';
    const $a2f3556545768e94$export$6da773286c35ef41 = 'sortKey';
    const $a2f3556545768e94$export$810a1f7ed2facfcb = 'sortOrder';
    const $a2f3556545768e94$export$ba75fb5089c0eb0b = [
        $a2f3556545768e94$export$39983b6fb040a5eb,
        $a2f3556545768e94$export$3d96f5f9ccd35be6,
        $a2f3556545768e94$export$8a8927c29ab32b10,
        $a2f3556545768e94$export$3e8168848b996f7,
        $a2f3556545768e94$export$4adc519ba40b72a6,
        $a2f3556545768e94$export$6da773286c35ef41,
        $a2f3556545768e94$export$810a1f7ed2facfcb
    ];
    const $a2f3556545768e94$export$7d5c3d28df5f438a = {
        BITBUCKET: 'bitbucket'
    };
    const $a2f3556545768e94$export$7912a169c18abe9d = {
        BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
        BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
        GITHUB_PROD: 'com.github.integration.production',
        GITHUB_STG: 'com.github.integration.staging'
    };
    const $a2f3556545768e94$export$74189cec821240a6 = 'jsw.code.page.header';
    const $a2f3556545768e94$export$3f3fc252f5066c72 = [
        'NOT_CONFIGURED',
        'NOT_SET',
        'PARTIALLY_CONFIGURED'
    ];
    const $a2f3556545768e94$export$9ce5b1bba5f17875 = [
        'CONFIGURED',
        'PROVIDER_ACTION_CONFIGURED',
        'PROVIDER_ACTION_NOT_CONFIGURED'
    ];
});
parcelRegister("1tSBh", function(module, exports) {
    $parcel$export(module.exports, "numberToTimestamp", ()=>$dbe340acf3f0dbdc$export$9a7be8324d19a048);
    $parcel$export(module.exports, "toProjectAri", ()=>$dbe340acf3f0dbdc$export$9429718a5f74f761);
    $parcel$export(module.exports, "RepositoryTypes", ()=>$dbe340acf3f0dbdc$export$b5ab924fb433d9ea);
    const $dbe340acf3f0dbdc$export$9a7be8324d19a048 = (time)=>{
        if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
        return time;
    };
    const $dbe340acf3f0dbdc$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
    const $dbe340acf3f0dbdc$export$b5ab924fb433d9ea = {
        REPO_BITBUCKET: 'REPO_BITBUCKET',
        REPO_GITHUB: 'REPO_GITHUB',
        REPO_GITLAB: 'REPO_GITLAB'
    };
    const $dbe340acf3f0dbdc$export$60dabe06d83cf844 = {
        CLASSIC: 'classic',
        OAUTH: 'oauth',
        BITBUCKET: 'bitbucket'
    };
});
const $96625f88cf395132$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';
parcelRegister("bMz5r", function(module, exports) {
    $parcel$export(module.exports, "softwareRoadmapClassicRoute", ()=>$49eecc6e153fb76e$export$79089e2853f04197);
    $parcel$export(module.exports, "softwareTimelineClassicRoute", ()=>$49eecc6e153fb76e$export$ce5173f7e8fa932b);
    $parcel$export(module.exports, "softwareCalendarClassicRoute", ()=>$49eecc6e153fb76e$export$f2c3b99639d54eb8);
    $parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", ()=>$49eecc6e153fb76e$export$ced2612fe5124ff8);
    $parcel$export(module.exports, "softwareListClassicRoute", ()=>$49eecc6e153fb76e$export$1bf758507ca6b2);
    $parcel$export(module.exports, "softwareSummaryClassicRoute", ()=>$49eecc6e153fb76e$export$b5046fccf399983f);
    $parcel$export(module.exports, "softwareListEmbedClassicRoute", ()=>$49eecc6e153fb76e$export$de5fcecec40b3c98);
    $parcel$export(module.exports, "softwareFormBuilderClassicRoute", ()=>$49eecc6e153fb76e$export$f6cfee0232aa1e);
    $parcel$export(module.exports, "softwareFormSubmitClassicRoute", ()=>$49eecc6e153fb76e$export$91d6851bf27349);
    $parcel$export(module.exports, "softwareFormClassicRoute", ()=>$49eecc6e153fb76e$export$ae560ee5b676193d);
    $parcel$export(module.exports, "softwareGoalsClassicRoute", ()=>$49eecc6e153fb76e$export$d12f3924cf53b545);
    $parcel$export(module.exports, "rapidboardBacklogRoute", ()=>$49eecc6e153fb76e$export$9e1d275c8078512e);
    $parcel$export(module.exports, "rapidboardBacklogEmbedRoute", ()=>$49eecc6e153fb76e$export$8c354886c7c664ea);
    $parcel$export(module.exports, "rapidboardReportRoute", ()=>$49eecc6e153fb76e$export$d37f637b09fb9fda);
    $parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", ()=>$49eecc6e153fb76e$export$1e5e610e11119ea7);
    $parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", ()=>$49eecc6e153fb76e$export$92f34907c6bf7007);
    $parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", ()=>$49eecc6e153fb76e$export$16987cdd084cceba);
    $parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", ()=>$49eecc6e153fb76e$export$312c410cb3b49afe);
    $parcel$export(module.exports, "rapidboardUserBacklogRoute", ()=>$49eecc6e153fb76e$export$79c2d9718e914f91);
    $parcel$export(module.exports, "rapidboardUserReportRoute", ()=>$49eecc6e153fb76e$export$7b85bca17717def6);
    $parcel$export(module.exports, "rapidboardBacklog1Route", ()=>$49eecc6e153fb76e$export$ff874528b0b33a61);
    $parcel$export(module.exports, "rapidboardReport1Route", ()=>$49eecc6e153fb76e$export$d27f9ad2fc277ff9);
    $parcel$export(module.exports, "softwareCodeClassicRoute", ()=>$49eecc6e153fb76e$export$d92cd77785d00ff);
    $parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", ()=>$49eecc6e153fb76e$export$991b1be164057e91);
    $parcel$export(module.exports, "projectDirectoryRedirectRoute", ()=>$49eecc6e153fb76e$export$3913c8bee519225c);
    var $65Ltd;
    const $49eecc6e153fb76e$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?';
    const $49eecc6e153fb76e$export$79089e2853f04197 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
    };
    const $49eecc6e153fb76e$export$ce5173f7e8fa932b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
    };
    const $49eecc6e153fb76e$export$f2c3b99639d54eb8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar',
        queries: [
            'date?'
        ]
    };
    const $49eecc6e153fb76e$export$ced2612fe5124ff8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
        queries: [
            'date?'
        ]
    };
    const $49eecc6e153fb76e$export$1bf758507ca6b2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/list'
    };
    const $49eecc6e153fb76e$export$b5046fccf399983f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/summary'
    };
    const $49eecc6e153fb76e$export$de5fcecec40b3c98 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED),
        path: '/jira/software/c/projects/:projectKey/list/embed'
    };
    const $49eecc6e153fb76e$export$f6cfee0232aa1e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form/:formId/builder'
    };
    const $49eecc6e153fb76e$export$91d6851bf27349 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form/:formId'
    };
    const $49eecc6e153fb76e$export$ae560ee5b676193d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form'
    };
    const $49eecc6e153fb76e$export$d12f3924cf53b545 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/goals'
    };
    const $49eecc6e153fb76e$export$9e1d275c8078512e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
    };
    const $49eecc6e153fb76e$export$8c354886c7c664ea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
    };
    const $49eecc6e153fb76e$export$d37f637b09fb9fda = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
    };
    const $49eecc6e153fb76e$export$1e5e610e11119ea7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/reports/cycle-time'
    };
    const $49eecc6e153fb76e$export$92f34907c6bf7007 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
        path: `/jira/software/c/${$49eecc6e153fb76e$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    const $49eecc6e153fb76e$export$16987cdd084cceba = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED),
        path: `/jira/software/c/${$49eecc6e153fb76e$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
    const $49eecc6e153fb76e$export$312c410cb3b49afe = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency'
    };
    const $49eecc6e153fb76e$export$79c2d9718e914f91 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
        path: '/jira/people/:accountId/boards/:boardId/backlog'
    };
    const $49eecc6e153fb76e$export$7b85bca17717def6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_REPORT),
        path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
    };
    const $49eecc6e153fb76e$export$ff874528b0b33a61 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView',
            'view=(planning|planning.nodetail)'
        ]
    };
    const $49eecc6e153fb76e$export$d27f9ad2fc277ff9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView',
            'view=reporting',
            'chart'
        ]
    };
    const $49eecc6e153fb76e$export$d92cd77785d00ff = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/code'
    };
    const $49eecc6e153fb76e$export$991b1be164057e91 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT),
        path: '/secure/RapidBoard.jspa',
        query: [
            'projectKey'
        ]
    };
    const $49eecc6e153fb76e$export$3913c8bee519225c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT),
        path: '/secure/RapidBoard.jspa'
    };
});
parcelRegister("drVya", function(module, exports) {
    $parcel$export(module.exports, "IncidentsPageSkeleton", ()=>$e5e4ca592020286c$export$3105d59d9ca899bd);
    $parcel$export(module.exports, "IncidentsTableSkeleton", ()=>$e5e4ca592020286c$export$7092b8ea63ebf9be);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $c1yjJ = parcelRequire("c1yjJ");
    var $80wl3 = parcelRequire("80wl3");
    const $e5e4ca592020286c$var$incidentsPageSkeletonStyles = null;
    const $e5e4ca592020286c$var$incidentsTableSkeletonStyles = null;
    const $e5e4ca592020286c$export$3105d59d9ca899bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($c1yjJ)))
        }));
    const $e5e4ca592020286c$export$7092b8ea63ebf9be = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($80wl3)))
        }));
});
parcelRegister("c1yjJ", function(module, exports) {
    module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();
});
parcelRegister("80wl3", function(module, exports) {
    module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();
});
parcelRegister("6R6ro", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cRbOs")
    ]).then(()=>parcelRequire('cwNeR'));
});
parcelRegister("d6qce", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9C5Ze")
    ]).then(()=>parcelRequire('8c2Ir'));
});
parcelRegister("ipmBb", function(module, exports) {
    $parcel$export(module.exports, "nextBestTaskFeatureResource", ()=>$b97b42683de1c9b3$export$5d472f7d515300ca);
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $b97b42683de1c9b3$export$5d472f7d515300ca = (0, $dIdda.createResource)({
        type: (0, $167b031bfd6a6b6e$export$6f0555de4f60e84e),
        getKey: ()=>(0, $167b031bfd6a6b6e$export$7e7d7930e22ba39f),
        getData: async ()=>{
            try {
                return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $167b031bfd6a6b6e$export$b94951a11282ae6a)}`);
            } catch (error) {
                const initialValueNeverSet = error.statusCode === 404;
                if (initialValueNeverSet) return {
                    hasUserOptedIn: true
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $167b031bfd6a6b6e$export$7f111648ca05f056),
                        packageName: (0, $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasUserOptedIn: false
            };
        },
        maxAge: Number.MAX_VALUE
    });
});
const $167b031bfd6a6b6e$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $167b031bfd6a6b6e$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key';
const $167b031bfd6a6b6e$export$b94951a11282ae6a = 'next-best-task-feature';
const $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $167b031bfd6a6b6e$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';
parcelRegister("f7Y15", function(module, exports) {
    $parcel$export(module.exports, "uifBoardResource", ()=>$6f8724e78df4e830$export$b65bcbbccad354ac);
    var $dIdda = parcelRequire("dIdda");
    const $6f8724e78df4e830$export$b65bcbbccad354ac = (0, $dIdda.createResource)({
        type: (0, $16d4c226f5e6f5f8$export$cfae566ecf2855f8),
        getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
            if (config) return `uif-board::${routeName}::config`;
            if (boardId == null) return `uif-board::${routeName}::not-found`;
            return `uif-board::${routeName}::${boardId}`;
        },
        getDataLoader: ()=>(parcelRequire("8SSc2")),
        maxAge: 0
    });
});
const $16d4c226f5e6f5f8$export$cfae566ecf2855f8 = 'UIF_BOARD';
parcelRegister("8SSc2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bLcEa").then(()=>parcelRequire('1HjYz'));
});
parcelRegister("k7fxM", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareBoardRoute", ()=>$b2c149f7138f811f$export$131d51ca54849e97);
    $parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", ()=>$b2c149f7138f811f$export$122afcef7dfd252);
    var $65Ltd;
    const $b2c149f7138f811f$export$131d51ca54849e97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId',
        ufoName: 'classic-board'
    };
    const $b2c149f7138f811f$export$122afcef7dfd252 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed',
        ufoName: 'classic-board-embed'
    };
});
parcelRegister("evG1K", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("427Sh")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dc2I")
    ]).then(()=>parcelRequire('dnhKp'));
});
parcelRegister("1vlac", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1QTgA")
    ]).then(()=>parcelRequire('1Xeln'));
});
parcelRegister("42ppS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4phaX")
    ]).then(()=>parcelRequire('5su1b'));
});
parcelRegister("5ERDu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("5OUMf")
    ]).then(()=>parcelRequire('Gk4RP'));
});
parcelRegister("eFW1U", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bcehj").then(()=>parcelRequire('73mZu'));
});
parcelRegister("g87MG", function(module, exports) {
    $parcel$export(module.exports, "issueHierarchyPageResource", ()=>$6f06dee5876402c3$export$98d50a2e19509817);
    var $ao2h1;
    var $7a4aR;
    const $6f06dee5876402c3$export$98d50a2e19509817 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'RESOURCE1',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("7a4aR")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                }
            })
    });
});
parcelRegister("7a4aR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ea8bf05e90a48f8$export$2e2bcd8739ae039);
    const $0ea8bf05e90a48f8$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "name"
        }, v3 = {
            "kind": "ScalarField",
            "name": "level"
        }, v4 = [
            {
                "concreteType": "JiraIssueTypeHierarchyLevel",
                "kind": "LinkedField",
                "name": "hierarchyLevel",
                "plural": false,
                "selections": [
                    v2,
                    v3
                ]
            },
            {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "cmpIssueTypes",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "description"
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "small"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v5 = {
            "concreteType": "JiraHierarchyConfigError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "code"
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }, v6 = {
            "args": v1,
            "concreteType": "JiraIssueHierarchyConfigurationQuery",
            "kind": "LinkedField",
            "name": "issueHierarchyConfig",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueHierarchyConfigData",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": v4
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                v5
            ]
        }, v7 = {
            "args": v1,
            "concreteType": "JiraIssueHierarchyLimits",
            "kind": "LinkedField",
            "name": "issueHierarchyLimits",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "maxLevels"
                },
                {
                    "kind": "ScalarField",
                    "name": "nameLength"
                }
            ]
        }, v8 = {
            "args": v1,
            "kind": "ScalarField",
            "name": "lockedIssueTypeIds"
        }, v9 = {
            "concreteType": "JiraIssueHierarchyConfigData",
            "kind": "LinkedField",
            "name": "issueHierarchyConfig",
            "plural": true,
            "selections": v4
        }, v10 = {
            "concreteType": "JiraLongRunningTaskProgress",
            "kind": "LinkedField",
            "name": "taskProgress",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "progress"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "mainIssueHierarchyQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v6,
                            v7,
                            v8,
                            {
                                "args": v1,
                                "concreteType": "JiraHierarchyConfigTask",
                                "kind": "LinkedField",
                                "name": "issueHierarchyConfigUpdateTask",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v10,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "saveButton_adminPagesIssueHierarchyDirectory"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "saveDialog_adminPagesIssueHierarchyDirectory"
                                    },
                                    v5
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "mainIssueHierarchyQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v6,
                            v7,
                            v8,
                            {
                                "args": v1,
                                "concreteType": "JiraHierarchyConfigTask",
                                "kind": "LinkedField",
                                "name": "issueHierarchyConfigUpdateTask",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v10,
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
                "metadata": {},
                "name": "mainIssueHierarchyQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0ea8bf05e90a48f8$var$node.hash = "e780e64aedcd2278004df68a042f1343";
    var $0ea8bf05e90a48f8$export$2e2bcd8739ae039 = $0ea8bf05e90a48f8$var$node;
});
parcelRegister("aJzGl", function(module, exports) {
    $parcel$export(module.exports, "NextGenBacklogSkeleton", ()=>$4eeb5ef1c1c47608$export$33cd465913cf178f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $dCm1o;
    var $gnABE;
    var $bOdHA = parcelRequire("bOdHA");
    const $4eeb5ef1c1c47608$export$433c2e8574f2e911 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bOdHA)))
        });
    const $4eeb5ef1c1c47608$export$88189b56881f213e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($4eeb5ef1c1c47608$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bOdHA)))
        }));
    const $4eeb5ef1c1c47608$export$33cd465913cf178f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $4eeb5ef1c1c47608$export$88189b56881f213e, $4eeb5ef1c1c47608$export$433c2e8574f2e911);
    const $4eeb5ef1c1c47608$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dCm1o", function(module, exports) {
    $parcel$export(module.exports, "isVisualRefreshEnabled", ()=>$322f7f27e3ad3058$export$48345cb467db19b6);
    var $4R6GH;
    var $1MhR0;
    const $322f7f27e3ad3058$var$DUMMY_CONDITION = true;
    const $322f7f27e3ad3058$export$48345cb467db19b6 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh') && ($322f7f27e3ad3058$var$isVisualRefreshInDogfooding() || $322f7f27e3ad3058$var$isVisualRefreshInEAP() || $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta());
    const $322f7f27e3ad3058$var$isVisualRefreshInDogfooding = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-dogfood') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    const $322f7f27e3ad3058$var$isVisualRefreshInEAP = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-eap') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    const $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta = ()=>$322f7f27e3ad3058$var$DUMMY_CONDITION && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-open-beta');
});
parcelRegister("bOdHA", function(module, exports) {
    module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();
});
parcelRegister("ibA3M", function(module, exports) {
    $parcel$export(module.exports, "useSelectedConfigTab", ()=>$a2554898b8aa72da$export$9b386f1a3e61b385);
    const $a2554898b8aa72da$export$9b386f1a3e61b385 = ()=>{
        const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
        const getSelectedConfigTab = ()=>localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
        const setSelectedConfigTab = (newConfigTab)=>localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
        return {
            getSelectedConfigTab: getSelectedConfigTab,
            setSelectedConfigTab: setSelectedConfigTab
        };
    };
});
parcelRegister("b4koY", function(module, exports) {
    $parcel$export(module.exports, "deploymentPreconditionRelayResource", ()=>$b79457e490ba4467$export$50e4eedb9e6127c8);
    var $ao2h1;
    var $ajgeO;
    var $dIdda = parcelRequire("dIdda");
    const $b79457e490ba4467$export$a1c09d7f7318f85c = (0, $dIdda.createResource)({
        type: (0, $c47c39dbdbc02648$export$2171160371fac588),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("hM28Z")),
        maxAge: 60000
    });
    const $b79457e490ba4467$export$50e4eedb9e6127c8 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $c47c39dbdbc02648$export$a969d0487e348031),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("ajgeO")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    projectKey: String(match.params.projectKey)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("ajgeO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0f41d4aeb9b6b93$export$2e2bcd8739ae039);
    const $e0f41d4aeb9b6b93$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            }
        ], v1 = {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                }
            ],
            "kind": "ScalarField",
            "name": "deploymentsFeaturePreconditionByProjectKey"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v1,
                                    "action": "THROW",
                                    "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v1
                        ]
                    }
                ]
            },
            "params": {
                "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
                "metadata": {},
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e0f41d4aeb9b6b93$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
    var $e0f41d4aeb9b6b93$export$2e2bcd8739ae039 = $e0f41d4aeb9b6b93$var$node;
});
const $c47c39dbdbc02648$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $c47c39dbdbc02648$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';
parcelRegister("hM28Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f0to4").then(()=>parcelRequire('96xO4'));
});
parcelRegister("kfztd", function(module, exports) {
    $parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", ()=>$064393a36b21cb6e$export$18bfef4995ec57b7);
    var $aIZdc;
    var $eIXQk;
    const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, (0, parcelRequire("eIXQk")).isDisableDevopsFeaturesInFedRampEnvEnabled)() && (0, (0, parcelRequire("aIZdc")).isFedRamp)();
});
parcelRegister("eIXQk", function(module, exports) {
    $parcel$export(module.exports, "isDisableDevopsFeaturesInFedRampEnvEnabled", ()=>$4ce1ad45498aedfa$export$a803c452d83c73b6);
    var $co1wz;
    const $4ce1ad45498aedfa$export$a803c452d83c73b6 = ()=>(0, (0, parcelRequire("co1wz")).ff)('core-x-fedramp-m1-disable-devops-features_ag5zy');
});
parcelRegister("8awia", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cBa2R")
    ]).then(()=>parcelRequire('5EQGR'));
});
parcelRegister("lHhzD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kWlGu")
    ]).then(()=>parcelRequire('jM2sL'));
});
parcelRegister("9bKt5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("636Ie").then(()=>parcelRequire('jqjLM'));
});
parcelRegister("g0oJP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9z4nz")
    ]).then(()=>parcelRequire('6SZAm'));
});
parcelRegister("ajKFd", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$b9eb4b3f312b449f$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "InsightsSkeleton", ()=>$b9eb4b3f312b449f$export$dd0b74c715df3275);
    $parcel$export(module.exports, "SuggestionsSkeleton", ()=>$b9eb4b3f312b449f$export$91f27b306afd627b);
    $parcel$export(module.exports, "WorkItemsSkeleton", ()=>$b9eb4b3f312b449f$export$1660f3159b79b22b);
    $parcel$export(module.exports, "WorkItemsVulnTabSkeleton", ()=>$b9eb4b3f312b449f$export$5aea7d4ed03d6ea6);
    $parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", ()=>$b9eb4b3f312b449f$export$ff38ee81427877e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $koVbs;
    var $hWIK7;
    var $29cNf;
    const $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $b9eb4b3f312b449f$var$MainContainerStyles,
            "data-testId": "software-periscope-periscope-page.ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).labelNonFinal),
            gap: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $b9eb4b3f312b449f$var$leftColumnStyles,
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeInsightsSkeleton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeWorkItemsSkeleton), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $b9eb4b3f312b449f$var$rightColumnStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeSuggestionsSkeleton), null))));
    };
    const $b9eb4b3f312b449f$export$dd0b74c715df3275 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles,
            "data-testId": "software-periscope-periscope-page.insights-ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).insightsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeInsightsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$91f27b306afd627b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles,
            "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).suggestionsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeSuggestionsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$1660f3159b79b22b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeWorkItemsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsVulnTabLabelNonFinal)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).DevelopmentPageWorkItemsVulnTabSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$ff38ee81427877e9 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsDeploymentTabLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
    };
    const $b9eb4b3f312b449f$var$MainContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
    const $b9eb4b3f312b449f$var$leftColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: '2 1 0'
    });
    const $b9eb4b3f312b449f$var$rightColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: '1 1 0'
    });
    const $b9eb4b3f312b449f$var$SuggestionsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        overflow: 'hidden',
        height: '650px',
        boxSizing: 'border-box'
    });
    const $b9eb4b3f312b449f$var$InsightsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        width: '100%',
        height: '385px',
        boxSizing: 'border-box'
    });
    const $b9eb4b3f312b449f$var$WorkItemsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '600px',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
    const $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '420px',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
});
parcelRegister("hWIK7", function(module, exports) {
    $parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", ()=>$730ffbc9c8197f60$export$176dfe4c14771136);
    $parcel$export(module.exports, "PeriscopeInsightsSkeleton", ()=>$730ffbc9c8197f60$export$afb44f298901be44);
    $parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", ()=>$730ffbc9c8197f60$export$298a6b6a251923c2);
    $parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", ()=>$730ffbc9c8197f60$export$8940e0b80e4066d6);
    $parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", ()=>$730ffbc9c8197f60$export$2f5ed71a7df2d4e6);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $2vpp7 = parcelRequire("2vpp7");
    var $47suu = parcelRequire("47suu");
    var $aR5hR = parcelRequire("aR5hR");
    var $bIAib = parcelRequire("bIAib");
    var $gqrFB = parcelRequire("gqrFB");
    var $2aQWX = parcelRequire("2aQWX");
    const $730ffbc9c8197f60$var$PeriscopePageSkeletonStyles = null;
    const $730ffbc9c8197f60$export$4aecc030c4d69f74 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aR5hR)))
        }));
    const $730ffbc9c8197f60$export$176dfe4c14771136 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bIAib)))
        }));
    const $730ffbc9c8197f60$export$afb44f298901be44 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($47suu)))
        }));
    const $730ffbc9c8197f60$export$298a6b6a251923c2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($2aQWX)))
        }));
    const $730ffbc9c8197f60$export$8940e0b80e4066d6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gqrFB)))
        }));
    const $730ffbc9c8197f60$export$2f5ed71a7df2d4e6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($2vpp7)))
        }));
});
parcelRegister("2vpp7", function(module, exports) {
    module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();
});
parcelRegister("47suu", function(module, exports) {
    module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();
});
parcelRegister("aR5hR", function(module, exports) {
    module.exports = new URL("periscope-page-full-layout.tpl.243222d7.svg", import.meta.url).toString();
});
parcelRegister("bIAib", function(module, exports) {
    module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();
});
parcelRegister("gqrFB", function(module, exports) {
    module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();
});
parcelRegister("2aQWX", function(module, exports) {
    module.exports = new URL("work-items.tpl.4ee9e4f3.svg", import.meta.url).toString();
});
parcelRegister("29cNf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34a050fcfbf5d355$export$2e2bcd8739ae039);
    var $7VHMR;
    var $34a050fcfbf5d355$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        labelNonFinal: {
            "id": "periscope.skeleton.label-non-final",
            "defaultMessage": "Loading"
        },
        suggestionsLabelNonFinal: {
            "id": "periscope.suggestions-skeleton.label-non-final",
            "defaultMessage": "Suggestions loading"
        },
        insightsLabelNonFinal: {
            "id": "periscope.insights-skeleton.label-non-final",
            "defaultMessage": "Developer insights loading"
        },
        workItemsLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-label-non-final",
            "defaultMessage": "Work items loading"
        },
        workItemsVulnTabLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-vuln-tab-label-non-final",
            "defaultMessage": "Work items vulnerability tab loading"
        },
        workItemsDeploymentTabLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-deployment-tab-label-non-final",
            "defaultMessage": "Work items deployment tab loading"
        }
    });
});
parcelRegister("9w6V0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("WP2Js")
    ]).then(()=>parcelRequire('k9ngM'));
});
parcelRegister("bwLf9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7ec252b6b084884$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a7ec252b6b084884$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
        const ComponentWithCondition = (props)=>conditionGetter() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, props) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, props);
        if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
        return ComponentWithCondition;
    };
});
parcelRegister("en8e6", function(module, exports) {
    $parcel$export(module.exports, "securityPageResource", ()=>$ae0f760fa9a80a3f$export$2c5e3c161b8fe98);
    var $65Ltd;
    var $dXq4S;
    var $ao2h1;
    var $1UBcC;
    var $ac0bf;
    const $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
    const $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch = ()=>100;
    let $ae0f760fa9a80a3f$var$filters;
    const $ae0f760fa9a80a3f$export$2c5e3c161b8fe98 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $0a72320b8bc3a1aa$export$f24db22c3c834cb1),
        getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
            const isSecRoute = name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY) || name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC);
            if (!$ae0f760fa9a80a3f$var$filters && isSecRoute) {
                const connectionAri = (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'security-container',
                    cloudId: cloudId,
                    activationId: activationId,
                    resourceId: ''
                });
                $ae0f760fa9a80a3f$var$filters = (0, (0, parcelRequire("ac0bf")).getGqlFiltersFromQueryParams)(query, connectionAri);
            }
            if (!isSecRoute) $ae0f760fa9a80a3f$var$filters = undefined;
            return {
                parameters: (0, (0, parcelRequire("1UBcC")).default),
                options: {
                    fetchPolicy: 'store-and-network'
                },
                variables: {
                    cloudAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira',
                        resourceType: 'site',
                        resourceId: cloudId
                    }),
                    cloudId: cloudId,
                    projectKey: params.projectKey ?? '',
                    numberOfVulnsToFetch: $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch(),
                    getContainers: false,
                    numberOfContainersToFetch: $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch(),
                    filter: $ae0f760fa9a80a3f$var$filters
                }
            };
        }
    });
});
parcelRegister("1UBcC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511d4548ae93769f$export$2e2bcd8739ae039);
    const $511d4548ae93769f$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "getContainers"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numberOfContainersToFetch"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numberOfVulnsToFetch"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v7 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v8 = {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }, v9 = {
            "kind": "ScalarField",
            "name": "totalLinkedSecurityContainerCount"
        }, v10 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "numberOfContainersToFetch"
            }
        ], v11 = {
            "kind": "ScalarField",
            "name": "providerId"
        }, v12 = [
            v11
        ], v13 = {
            "kind": "InlineFragment",
            "selections": v12,
            "type": "ThirdPartySecurityContainer"
        }, v14 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v15 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfVulnsToFetch"
        }, v16 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": {
                    "and": {
                        "lastUpdated": {
                            "sort": {
                                "order": "ASC",
                                "priority": 1
                            }
                        }
                    }
                }
            },
            v15
        ], v17 = {
            "kind": "ScalarField",
            "name": "id"
        }, v18 = {
            "kind": "ScalarField",
            "name": "name"
        }, v19 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v20 = {
            "concreteType": "DevOps",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        },
                        {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                                "SECURITY"
                            ]
                        }
                    ],
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsSecurityProvider",
                            "kind": "LinkedField",
                            "name": "securityProviders",
                            "plural": true,
                            "selections": [
                                v17,
                                {
                                    "kind": "ScalarField",
                                    "name": "appInstallationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "logoUrl"
                                },
                                v18,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedWorkspaces",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v19
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedWorkspaces(first:100)"
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v21 = [
            v17
        ], v22 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "Node",
            "abstractKey": "__isNode"
        }, v23 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "ConfluencePage"
        }, v24 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "ConfluenceSpace"
        }, v25 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsFeatureFlag"
        }, v26 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsComponentDetails"
        }, v27 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsIncidentDetails"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsPostIncidentReviewDetails"
        }, v29 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsPullRequestDetails"
        }, v30 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsRepository"
        }, v31 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsSecurityVulnerabilityDetails"
        }, v32 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraConfluenceRemoteIssueLink"
        }, v33 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraCustomRemoteIssueLink"
        }, v34 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraIssueRemoteIssueLink"
        }, v35 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraWebRemoteIssueLink"
        }, v36 = [
            v8,
            v15
        ], v37 = {
            "kind": "ScalarField",
            "name": "url"
        }, v38 = {
            "kind": "ScalarField",
            "name": "key"
        }, v39 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v40 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6
                ],
                "kind": "Fragment",
                "name": "mainSecurityInJiraQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v8,
                                                {
                                                    "kind": "Variable",
                                                    "name": "getContainers",
                                                    "variableName": "getContainers"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "numberOfContainersToFetch",
                                                    "variableName": "numberOfContainersToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "main_softwareSecurityPage_MainPage"
                                        },
                                        v9,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v10,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "linkedSecurityContainers",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationshipEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationship",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                        "kind": "LinkedField",
                                                                        "name": "to",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "condition": "getContainers",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "data",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v13
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v14
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                        },
                                        {
                                            "alias": "linkedVulnsForAnalytics",
                                            "args": v16,
                                            "concreteType": "GraphJiraVulnerabilityConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityVulnerabilitiesByProject",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerabilityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphJiraVulnerability",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                            "kind": "LinkedField",
                                                                            "name": "vulnerability",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartySecurityContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "securityContainer",
                                                                                    "plural": false,
                                                                                    "selections": v12
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    v20
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v6,
                    v5,
                    v3,
                    v4,
                    v2
                ],
                "kind": "Operation",
                "name": "mainSecurityInJiraQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v17,
                                    {
                                        "args": v10,
                                        "concreteType": "AriGraphRelationshipConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityContainers",
                                        "plural": false,
                                        "selections": [
                                            v14,
                                            {
                                                "concreteType": "AriGraphRelationshipEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationship",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationshipNode",
                                                                "kind": "LinkedField",
                                                                "name": "to",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "condition": "getContainers",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "data",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v19,
                                                                                    v13,
                                                                                    v22,
                                                                                    v23,
                                                                                    v24,
                                                                                    v25,
                                                                                    v26,
                                                                                    v27,
                                                                                    v28,
                                                                                    v29,
                                                                                    v30,
                                                                                    v31,
                                                                                    v32,
                                                                                    v33,
                                                                                    v34,
                                                                                    v35
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v17
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            v8
                                        ],
                                        "kind": "ScalarField",
                                        "name": "totalLinkedSecurityVulnerabilityCount"
                                    },
                                    {
                                        "args": v36,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                "kind": "LinkedField",
                                                                "name": "vulnerability",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "title"
                                                                    },
                                                                    {
                                                                        "condition": "getContainers",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v17,
                                                                                    v18,
                                                                                    v37
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                        "kind": "LinkedField",
                                                                        "name": "identifiers",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "displayName"
                                                                            },
                                                                            v37
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                        "kind": "LinkedField",
                                                                        "name": "additionalInfo",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "content"
                                                                            },
                                                                            v37
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "status"
                                                                    },
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "linkedJiraIssues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "AriGraphRelationship",
                                                                                "kind": "LinkedField",
                                                                                "name": "nodes",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "to",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v17,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "data",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v19,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "args": [
                                                                                                                    {
                                                                                                                        "kind": "Literal",
                                                                                                                        "name": "idsOrAliases",
                                                                                                                        "value": [
                                                                                                                            "summary",
                                                                                                                            "assignee",
                                                                                                                            "status",
                                                                                                                            "issuetype"
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "fieldsByIdOrAlias",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v19,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraStatus",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "status",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v18,
                                                                                                                                    v17,
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraStatusCategory",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "statusCategory",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            v38,
                                                                                                                                            v17
                                                                                                                                        ]
                                                                                                                                    }
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraStatusField"
                                                                                                                    },
                                                                                                                    v17,
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "fieldId"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "text"
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "user",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v19,
                                                                                                                                    v18,
                                                                                                                                    {
                                                                                                                                        "kind": "ScalarField",
                                                                                                                                        "name": "picture"
                                                                                                                                    },
                                                                                                                                    v17
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraIssueType",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "issueType",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v18,
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraAvatar",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "avatar",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "small"
                                                                                                                                            }
                                                                                                                                        ]
                                                                                                                                    },
                                                                                                                                    v17
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraIssueTypeField"
                                                                                                                    }
                                                                                                                ],
                                                                                                                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "issueId"
                                                                                                            },
                                                                                                            v38,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "webUrl"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraIssue"
                                                                                                    },
                                                                                                    v22,
                                                                                                    v23,
                                                                                                    v24,
                                                                                                    v25,
                                                                                                    v26,
                                                                                                    v27,
                                                                                                    v28,
                                                                                                    v29,
                                                                                                    v30,
                                                                                                    v31,
                                                                                                    v32,
                                                                                                    v33,
                                                                                                    v34,
                                                                                                    v35
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v14
                                                                        ]
                                                                    },
                                                                    v17,
                                                                    v37,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "introducedDate"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "providerVulnerabilityId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "securityContainerId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "severity"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "description"
                                                                    }
                                                                ]
                                                            },
                                                            v17,
                                                            v19
                                                        ]
                                                    },
                                                    v39
                                                ]
                                            },
                                            v40
                                        ]
                                    },
                                    {
                                        "args": v36,
                                        "filters": [
                                            "filter"
                                        ],
                                        "handle": "connection",
                                        "key": "security__linkedSecurityVulnerabilitiesByProject",
                                        "kind": "LinkedHandle",
                                        "name": "linkedSecurityVulnerabilitiesByProject"
                                    },
                                    {
                                        "alias": "projectHaveVulnerabilityCheck",
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 1
                                            }
                                        ],
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                "kind": "LinkedField",
                                                                "name": "vulnerability",
                                                                "plural": false,
                                                                "selections": [
                                                                    v19,
                                                                    v17
                                                                ]
                                                            },
                                                            v17
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v11,
                                                                                    v17
                                                                                ]
                                                                            },
                                                                            v17
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v17
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "getContainers",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v10,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "linkedSecurityContainers",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationshipEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationship",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                        "kind": "LinkedField",
                                                                        "name": "to",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "data",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v19,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v18,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "icon"
                                                                                            },
                                                                                            v37,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "providerName"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "lastUpdated"
                                                                                            },
                                                                                            v14,
                                                                                            v17
                                                                                        ],
                                                                                        "type": "ThirdPartySecurityContainer"
                                                                                    },
                                                                                    v22,
                                                                                    v23,
                                                                                    v24,
                                                                                    v25,
                                                                                    v26,
                                                                                    v27,
                                                                                    v28,
                                                                                    v29,
                                                                                    v30,
                                                                                    v31,
                                                                                    v32,
                                                                                    v33,
                                                                                    v34,
                                                                                    v35
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v19
                                                                ]
                                                            },
                                                            v39
                                                        ]
                                                    },
                                                    v40
                                                ]
                                            },
                                            {
                                                "args": v10,
                                                "handle": "connection",
                                                "key": "security__linkedSecurityContainers",
                                                "kind": "LinkedHandle",
                                                "name": "linkedSecurityContainers"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v20
                ]
            },
            "params": {
                "id": "a1a80f3ccfe8934408165144c558b877d997fe187322dd28b0da2044aa214fed",
                "metadata": {},
                "name": "mainSecurityInJiraQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $511d4548ae93769f$var$node.hash = "e0029e5d1d9e6e62c9b62d69cc3a9f72";
    var $511d4548ae93769f$export$2e2bcd8739ae039 = $511d4548ae93769f$var$node;
});
parcelRegister("ac0bf", function(module, exports) {
    $parcel$export(module.exports, "getGqlFiltersFromQueryParams", ()=>$526907709998fa0b$export$2af359d48d48e5f1);
    var $5eeaw;
    var $3zFAD;
    var $3o4IF;
    const $526907709998fa0b$var$getFilterValue = (values, fieldStortKey, sortKey = (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).sortKey, sortOrder = (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).sortOrder)=>({
            ...values.length > 0 ? {
                values: values
            } : {},
            ...sortKey === fieldStortKey && {
                sort: {
                    priority: 2,
                    order: (0, (0, parcelRequire("3o4IF")).parseSortDirection)(sortOrder, (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC)
                }
            }
        });
    const $526907709998fa0b$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
    const $526907709998fa0b$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
        const containerValues = $526907709998fa0b$var$getOrDefault((0, (0, parcelRequire("3o4IF")).connectionQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).connectionFilter);
        const statusQueryParams = (0, (0, parcelRequire("3o4IF")).arrayQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_VULN_STATUS]);
        return {
            and: [
                {
                    lastUpdated: {
                        sort: {
                            priority: 1,
                            order: (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC
                        }
                    },
                    to_severity: $526907709998fa0b$var$getFilterValue($526907709998fa0b$var$getOrDefault((0, (0, parcelRequire("3o4IF")).arrayQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SEVERITY]).map((0, (0, parcelRequire("3o4IF")).parseSeverity)).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY], queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER]),
                    to_status: $526907709998fa0b$var$getFilterValue(statusQueryParams.includes((0, (0, parcelRequire("3zFAD")).NO_FILTER_VULN_STATUS)) ? [] : $526907709998fa0b$var$getOrDefault(statusQueryParams.map((0, (0, parcelRequire("3o4IF")).parseStatus)).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY], queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER]),
                    createdAt: {
                        ...queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY] === 'introduced' && {
                            sort: {
                                priority: 2,
                                order: (0, (0, parcelRequire("3o4IF")).parseSortDirection)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER], (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC)
                            }
                        }
                    },
                    to_container: {
                        containerAri: {
                            value: {
                                ...containerValues.length > 0 ? {
                                    values: containerValues
                                } : {}
                            }
                        }
                    }
                }
            ]
        };
    };
});
parcelRegister("5eeaw", function(module, exports) {
    $parcel$export(module.exports, "AriGraphSortOrderInput", ()=>$f98addb8b52ad07a$export$3b69903df4cd6048);
    const $f98addb8b52ad07a$export$3b69903df4cd6048 = {
        ASC: 'ASC',
        DESC: 'DESC'
    };
});
parcelRegister("3zFAD", function(module, exports) {
    $parcel$export(module.exports, "QUERY_PARAM_SEARCH", ()=>$d1be2b44eb126533$export$a181206198b7f50c);
    $parcel$export(module.exports, "QUERY_PARAM_CONTAINER", ()=>$d1be2b44eb126533$export$3873b20ffa21b004);
    $parcel$export(module.exports, "QUERY_PARAM_SEVERITY", ()=>$d1be2b44eb126533$export$af01a3d59250f3d3);
    $parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", ()=>$d1be2b44eb126533$export$c315695f017955dc);
    $parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", ()=>$d1be2b44eb126533$export$2e69a24fe65d4109);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", ()=>$d1be2b44eb126533$export$6da773286c35ef41);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", ()=>$d1be2b44eb126533$export$810a1f7ed2facfcb);
    $parcel$export(module.exports, "NO_FILTER_VULN_STATUS", ()=>$d1be2b44eb126533$export$d8115099d465de4c);
    $parcel$export(module.exports, "initialVulnerabilityTableOptions", ()=>$d1be2b44eb126533$export$e9b4ea84d666c490);
    const $d1be2b44eb126533$export$a181206198b7f50c = 'search';
    const $d1be2b44eb126533$export$3873b20ffa21b004 = 'container';
    const $d1be2b44eb126533$export$af01a3d59250f3d3 = 'severity';
    const $d1be2b44eb126533$export$c315695f017955dc = 'vulnerabilityStatus';
    const $d1be2b44eb126533$export$2e69a24fe65d4109 = 'issueStatus';
    const $d1be2b44eb126533$export$6da773286c35ef41 = 'sortKey';
    const $d1be2b44eb126533$export$810a1f7ed2facfcb = 'sortOrder';
    const $d1be2b44eb126533$export$d8115099d465de4c = 'NO-FILTERS';
    const $d1be2b44eb126533$export$afbc65bcea0cf17e = {
        searchFilter: '',
        connectionFilter: [],
        severityFilter: [],
        statusFilter: [
            'OPEN'
        ],
        jiraIssueStatusFilter: []
    };
    const $d1be2b44eb126533$export$e9b4ea84d666c490 = {
        sortKey: 'severity',
        sortOrder: 'DESC',
        ...$d1be2b44eb126533$export$afbc65bcea0cf17e
    };
});
parcelRegister("3o4IF", function(module, exports) {
    $parcel$export(module.exports, "arrayQueryParamToFilter", ()=>$dbe4482e2428caff$export$7500862c6689a767);
    $parcel$export(module.exports, "arrayFilterToQueryParam", ()=>$dbe4482e2428caff$export$b0dee3c5bfc7249e);
    $parcel$export(module.exports, "connectionFilterToQueryParam", ()=>$dbe4482e2428caff$export$a6950ca4fdc8498f);
    $parcel$export(module.exports, "connectionQueryParamToFilter", ()=>$dbe4482e2428caff$export$1040034504af5b41);
    $parcel$export(module.exports, "parseSeverity", ()=>$dbe4482e2428caff$export$3551b8a2cbdb5162);
    $parcel$export(module.exports, "parseStatus", ()=>$dbe4482e2428caff$export$2188844eb84f7f06);
    $parcel$export(module.exports, "parseSortDirection", ()=>$dbe4482e2428caff$export$85cf5c73b48a482e);
    var $chc6P = parcelRequire("chc6P");
    var $80afZ = parcelRequire("80afZ");
    var $5eeaw;
    var $i3r1A;
    const $dbe4482e2428caff$var$DELIMITER = ',';
    const $dbe4482e2428caff$var$ENCODED_DELIMITER = encodeURIComponent($dbe4482e2428caff$var$DELIMITER);
    const $dbe4482e2428caff$var$encodeDelimiter = (input)=>{
        const regex = new RegExp($dbe4482e2428caff$var$DELIMITER, 'g');
        return input.replace(regex, $dbe4482e2428caff$var$ENCODED_DELIMITER);
    };
    const $dbe4482e2428caff$var$decodeDelimiter = (input)=>{
        const regex = new RegExp($dbe4482e2428caff$var$ENCODED_DELIMITER, 'g');
        return input.replace(regex, $dbe4482e2428caff$var$DELIMITER);
    };
    const $dbe4482e2428caff$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($dbe4482e2428caff$var$DELIMITER)?.map($dbe4482e2428caff$var$decodeDelimiter) ?? [];
    const $dbe4482e2428caff$export$b0dee3c5bfc7249e = (filterArray)=>{
        if (filterArray.length === 0) return undefined;
        return filterArray.map((entity)=>$dbe4482e2428caff$var$encodeDelimiter(entity)).join($dbe4482e2428caff$var$DELIMITER);
    };
    const $dbe4482e2428caff$export$a6950ca4fdc8498f = (connectionArray)=>{
        if (connectionArray.length === 0) return undefined;
        const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
            const [, , , , securityParts] = connection.split(':');
            const [, , , appKey, ...containerId] = securityParts.split('/');
            if (!acc[appKey]) acc[appKey] = [];
            acc[appKey].push(containerId.join('/'));
            return acc;
        }, {});
        return JSON.stringify(groupedConnectionsByAppKey);
    };
    const $dbe4482e2428caff$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
        if (!queryParamString) return [];
        const groupedConnectionsByAppKey = JSON.parse(queryParamString);
        return (0, ($parcel$interopDefault($chc6P)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, ($parcel$interopDefault($80afZ)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
    };
    const $dbe4482e2428caff$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
        switch(maybeSeverity?.toUpperCase()){
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).CRITICAL;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).HIGH.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).HIGH;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).LOW.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).LOW;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).MEDIUM;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).UNKNOWN;
            default:
                return undefined;
        }
    };
    const $dbe4482e2428caff$export$2188844eb84f7f06 = (maybeStatus)=>{
        switch(maybeStatus?.toUpperCase()){
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).OPEN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).OPEN;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).UNKNOWN;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).CLOSED.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).CLOSED;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).IGNORED.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).IGNORED;
            default:
                return undefined;
        }
    };
    const $dbe4482e2428caff$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).ASC.toUpperCase():
                return (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).ASC;
            case (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC.toUpperCase():
                return (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC;
            default:
                return defaultValue;
        }
    };
});
parcelRegister("chc6P", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $80afZ = parcelRequire("80afZ");
    function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
        return $ekcP3($80afZ(collection, iteratee), 1);
    }
    module.exports = $8f007734a6a4d9ac$var$flatMap;
});
parcelRegister("80afZ", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $bxDef = parcelRequire("bxDef");
    var $jXnVG = parcelRequire("jXnVG");
    var $8LQ84 = parcelRequire("8LQ84");
    function $5d3647a04b83e8d6$var$map(collection, iteratee) {
        var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
        return func(collection, $bxDef(iteratee, 3));
    }
    module.exports = $5d3647a04b83e8d6$var$map;
});
parcelRegister("i3r1A", function(module, exports) {
    $parcel$export(module.exports, "VulnerabilitySeverityEnums", ()=>$e40f3ad586d15bb3$export$c1a102938d8dc10);
    $parcel$export(module.exports, "VulnerabilityStatusEnums", ()=>$e40f3ad586d15bb3$export$2d6749bded378262);
    const $e40f3ad586d15bb3$export$c1a102938d8dc10 = {
        CRITICAL: 'CRITICAL',
        HIGH: 'HIGH',
        LOW: 'LOW',
        MEDIUM: 'MEDIUM',
        UNKNOWN: 'UNKNOWN'
    };
    const $e40f3ad586d15bb3$export$2d6749bded378262 = {
        CLOSED: 'CLOSED',
        IGNORED: 'IGNORED',
        OPEN: 'OPEN',
        UNKNOWN: 'UNKNOWN'
    };
    const $e40f3ad586d15bb3$export$abf926511a2b65de = {
        DAST: 'DAST',
        SAST: 'SAST',
        SCA: 'SCA',
        UNKNOWN: 'UNKNOWN'
    };
});
const $0a72320b8bc3a1aa$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';
parcelRegister("csz4l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eHlvD")
    ]).then(()=>parcelRequire('jbq29'));
});
parcelRegister("5fsUP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4VHZG")
    ]).then(()=>parcelRequire('iPGiI'));
});
parcelRegister("5mLQj", function(module, exports) {
    $parcel$export(module.exports, "userBoardRoute", ()=>$94b3bd76047e314a$export$57a2a0fe739f16);
    var $65Ltd;
    var $e2ctp;
    const $94b3bd76047e314a$export$57a2a0fe739f16 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
        path: '/jira/people/:accountId/boards/:boardId',
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
    };
});
parcelRegister("lm7AC", function(module, exports) {
    $parcel$export(module.exports, "RoadmapSkeleton", ()=>$eff6f905ab2e2dc3$export$66a1e8bb48359566);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $4R6GH;
    var $3HwlS;
    var $dCm1o;
    var $gnABE;
    var $7jB1k = parcelRequire("7jB1k");
    var $aIPZQ = parcelRequire("aIPZQ");
    const $eff6f905ab2e2dc3$var$customCssStyles = null;
    const $eff6f905ab2e2dc3$export$66a1e8bb48359566 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($eff6f905ab2e2dc3$var$AppSkeletonImageContainer, null, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7jB1k))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aIPZQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        }));
    const $eff6f905ab2e2dc3$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
                __cmplp.className
            ])
        });
    });
    const $eff6f905ab2e2dc3$var$AppSkeletonImageContainer = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2'), ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($eff6f905ab2e2dc3$var$Wrapper, null, children), (0, $5uXOq.Fragment));
});
parcelRegister("7jB1k", function(module, exports) {
    module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();
});
parcelRegister("aIPZQ", function(module, exports) {
    module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();
});
parcelRegister("48Ij3", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarJSWReportsResource", ()=>$d94d5098764be5f8$export$5910307042ab3f6f);
    var $8YTna;
    var $dIdda = parcelRequire("dIdda");
    var $7xeIG;
    const $d94d5098764be5f8$export$5910307042ab3f6f = (0, $dIdda.createResource)({
        type: 'JIRA_SOFTWARE_REPORTS',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            if (boardId == null) return null;
            const response = await (0, (0, parcelRequire("7xeIG")).fetchJSWReports)(boardId);
            return response?.reports;
        },
        maxAge: 300000
    });
});
parcelRegister("7xeIG", function(module, exports) {
    $parcel$export(module.exports, "fetchJSWReports", ()=>$61400f9195fc4c28$export$a93a577d6971da2c);
    var $eusud;
    const $61400f9195fc4c28$export$a93a577d6971da2c = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
    };
});
parcelRegister("4Bwc0", function(module, exports) {
    $parcel$export(module.exports, "devOpsReportPreconditionResource", ()=>$5073d432665dfcf8$export$96cb0eae1b3413f4);
    $parcel$export(module.exports, "useDevOpsReportPreconditionResource", ()=>$5073d432665dfcf8$export$e9adc6103e9ed514);
    var $dIdda = parcelRequire("dIdda");
    const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, $dIdda.createResource)({
        type: (0, $16165c7eb855363c$export$14c5ce449424c281),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("fUjXk")),
        maxAge: 60000
    });
    const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, $dIdda.useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);
});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';
parcelRegister("fUjXk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("goFaC").then(()=>parcelRequire('5aldt'));
});
parcelRegister("6Aupt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hG41q").then(()=>parcelRequire('ksDNa'));
});
parcelRegister("9xG8v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jmhtg")
    ]).then(()=>parcelRequire('izbAs'));
});
parcelRegister("jDCWS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("a0moB")
    ]).then(()=>parcelRequire('4RuJw'));
});
parcelRegister("i1VgZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("39IYm")
    ]).then(()=>parcelRequire('9PBZj'));
});
parcelRegister("fntlm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iePIJ")
    ]).then(()=>parcelRequire('71XRW'));
});
parcelRegister("492p0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("donBI")
    ]).then(()=>parcelRequire('6LEOw'));
});
parcelRegister("5AKg6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("62r1i")
    ]).then(()=>parcelRequire('ycm07'));
});
parcelRegister("5lA3L", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("haEOE")
    ]).then(()=>parcelRequire('6xPmp'));
});
parcelRegister("8ZMAu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6uzq3")
    ]).then(()=>parcelRequire('iX103'));
});
parcelRegister("2yRGG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1pebU")
    ]).then(()=>parcelRequire('6pwND'));
});
parcelRegister("bTLzO", function(module, exports) {
    $parcel$export(module.exports, "compassProductSettingsResource", ()=>$cfea6057f91373db$export$d18ff068d6c25455);
    $parcel$export(module.exports, "useCompassProductSettingsResource", ()=>$cfea6057f91373db$export$6cbcbd11d26ae36f);
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $cfea6057f91373db$export$d18ff068d6c25455 = (0, $dIdda.createResource)({
        type: (0, $0e2163be65099f64$export$6f0555de4f60e84e),
        getKey: ()=>'state',
        getData: async ()=>{
            try {
                const isCompassEnabledForNewProjects = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/application-properties?key=${(0, $0e2163be65099f64$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
                return {
                    isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
                };
            } catch (error) {
                if (error?.statusCode === 404) return {
                    isCompassEnabledForNewProjects: true
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'compassProductSettingsResource',
                        packageName: 'jiraRouterResourcesCompassProductSettings',
                        teamName: 'compass-lodestone'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
    });
    const $cfea6057f91373db$export$6cbcbd11d26ae36f = ()=>(0, $dIdda.useResource)($cfea6057f91373db$export$d18ff068d6c25455);
});
const $0e2163be65099f64$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $0e2163be65099f64$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';
parcelRegister("2nW1S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8asz0")
    ]).then(()=>parcelRequire('lIMc4'));
});
parcelRegister("eGzdH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("di7zh")
    ]).then(()=>parcelRequire('6AMhj'));
});
parcelRegister("hz6Yb", function(module, exports) {
    $parcel$export(module.exports, "connectGeneralResources", ()=>$07e636c36bc19b52$export$f34ab0d904621847);
    $parcel$export(module.exports, "useConnectGeneralResource", ()=>$07e636c36bc19b52$export$53479840ec6d4024);
    var $dIdda = parcelRequire("dIdda");
    const $07e636c36bc19b52$export$f34ab0d904621847 = (0, $dIdda.createResource)({
        type: (0, $1130bd470474fe6f$export$d5eed449bb62d4c1),
        getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
            if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        getDataLoader: ()=>(parcelRequire("bBygl"))
    });
    const $07e636c36bc19b52$export$53479840ec6d4024 = ()=>(0, $dIdda.useResource)($07e636c36bc19b52$export$f34ab0d904621847);
});
const $1130bd470474fe6f$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';
parcelRegister("bBygl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("W2aDd").then(()=>parcelRequire('6LiLg'));
});
parcelRegister("9UABi", function(module, exports) {
    $parcel$export(module.exports, "connectProjectResources", ()=>$fce046ce7cfaa8c3$export$7d2d082a4b91a6c7);
    var $8Vh1q;
    var $ggg5j;
    var $dIdda = parcelRequire("dIdda");
    const $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7 = (0, $dIdda.createResource)({
        type: (0, $35b0c7feb103121f$export$da32d27651782c3),
        getKey: ({ query: query })=>{
            const { addonKey: addonKey, moduleKey: moduleKey } = (0, (0, parcelRequire("8Vh1q")).transformUrlToAddonAndModuleKeys)(query);
            if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        depends: [
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource).type
        ],
        getDataLoader: ()=>(parcelRequire("actZ1"))
    });
});
parcelRegister("8Vh1q", function(module, exports) {
    $parcel$export(module.exports, "transformResponse", ()=>$beff5be7f4728df2$export$3361e9be8093ddcc);
    $parcel$export(module.exports, "extractContext", ()=>$beff5be7f4728df2$export$efdbd45f3e77a161);
    $parcel$export(module.exports, "transformQueryParams", ()=>$beff5be7f4728df2$export$9e3c3f47fc3ab3d0);
    $parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", ()=>$beff5be7f4728df2$export$752ef5ab3d7ab15f);
    var $dJl1T;
    var $6VnTH;
    var $bsuuc;
    const $beff5be7f4728df2$export$3361e9be8093ddcc = (response)=>{
        try {
            const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
            const structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
            const context = {
                productContext: productContext,
                structuredContext: structuredContext,
                productCtx: productContext
            };
            return {
                ...response,
                ...context,
                isFullPage: response.general === '1',
                user: {
                    timeZone: response.timeZone,
                    uid: response.uid || undefined,
                    ukey: response.ukey || undefined,
                    fullName: response.fullName || undefined
                },
                targets: {
                    env: {
                        resize: 'both'
                    }
                },
                history: {
                    state: ''
                },
                autoresize: true,
                ns: response.uniqueKey,
                containerId: `embedded-${response.uniqueKey}`,
                contextPath: response.cp,
                width: response.w || response.width,
                height: response.h || response.height
            };
        } catch (error) {
            const location = 'connect-iframe.transformer';
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
            return {
                autoresize: true,
                productCtx: undefined,
                structuredContext: undefined,
                isFullPage: true,
                history: {
                    state: ''
                },
                targets: {
                    env: {
                        resize: 'both'
                    }
                }
            };
        }
    };
    const $beff5be7f4728df2$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
        const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
        return newValue !== null ? {
            [newName]: newValue
        } : null;
    };
    const $beff5be7f4728df2$export$1f8eea5a5a32169f = (contextData)=>{
        const scope = contextData && contextData.scope || null;
        const project = contextData && contextData.project || null;
        const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
        const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
        const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
        const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
        return {
            ...projectId,
            ...projectKey,
            ...boardType,
            ...boardId
        };
    };
    const $beff5be7f4728df2$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
        const project = projectSidebarNavInfo && (0, (0, parcelRequire("bsuuc")).extractData)(projectSidebarNavInfo) || null;
        const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, (0, parcelRequire("6VnTH")).extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
        const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
        const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
        const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'type', 'board.type');
        const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'id', 'board.id');
        return {
            ...projectId,
            ...projectKey,
            ...boardType,
            ...boardId
        };
    };
    const $beff5be7f4728df2$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
        const context = $beff5be7f4728df2$export$1f8eea5a5a32169f(contextData);
        return {
            ...query,
            ...context
        };
    };
    const $beff5be7f4728df2$export$752ef5ab3d7ab15f = (query)=>{
        const { selectedItem: selectedItem } = query;
        let addonKey = '';
        let moduleKey = '';
        if (selectedItem) {
            const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
            [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
        }
        return {
            addonKey: addonKey,
            moduleKey: moduleKey
        };
    };
});
parcelRegister("6VnTH", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$4d73b10ca351bbb3$export$9df5fa0a366163d2);
    $parcel$export(module.exports, "extractUserBoard", ()=>$4d73b10ca351bbb3$export$67db9e2d1b6ed865);
    const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
        if (jiraSoftwareNavData.boardInfo == null) return null;
        const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
        return {
            id: id,
            type: type,
            name: name,
            isProjectBoard: true
        };
    };
    const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
        const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
        return {
            id: id,
            type: type,
            name: name,
            isProjectBoard: false
        };
    };
});
const $35b0c7feb103121f$export$da32d27651782c3 = 'CONNECT_PROJECT';
parcelRegister("actZ1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g7yss").then(()=>parcelRequire('4ECv0'));
});
parcelRegister("fpjJX", function(module, exports) {
    $parcel$export(module.exports, "getServiceDeskNavigationResources", ()=>$491f4fde535ee8ab$export$bc0bd65e6da57c1f);
    $parcel$export(module.exports, "getServiceDeskNavigationSingleResources", ()=>$491f4fde535ee8ab$export$41a9145ddbba28e5);
    $parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", ()=>$491f4fde535ee8ab$export$2c543d6accc1eb9b);
    $parcel$export(module.exports, "getServiceDeskSettingsResources", ()=>$491f4fde535ee8ab$export$7bb3c4a2f6b127fb);
    $parcel$export(module.exports, "getServicedeskPageContextResources", ()=>$491f4fde535ee8ab$export$a8b852f03a310dc0);
    $parcel$export(module.exports, "getQueuesResources", ()=>$491f4fde535ee8ab$export$70b97995f4d5ef9f);
    $parcel$export(module.exports, "getIssueListSsrResource", ()=>$491f4fde535ee8ab$export$e1016cce62543991);
    $parcel$export(module.exports, "getKnowledgeBaseResources", ()=>$491f4fde535ee8ab$export$ed87d3b71544c4ef);
    $parcel$export(module.exports, "getInsightResources", ()=>$491f4fde535ee8ab$export$9e0cf1fab0581096);
    var $aIZdc;
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $b2pl3;
    var $gS5PF;
    var $6zFAI;
    var $gcI3W;
    var $ggg5j;
    var $iEUaw;
    var $bjZiV;
    var $3RJkv;
    var $dxCvy;
    var $8H3A4;
    var $cAofY;
    var $eUvlM;
    var $lbaDt;
    var $1WlLE;
    var $2cxgG;
    var $6sNnq;
    var $7GnDe;
    var $gNStA;
    var $gRzZD;
    const $491f4fde535ee8ab$export$bc0bd65e6da57c1f = ()=>[
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...$491f4fde535ee8ab$export$41a9145ddbba28e5()
        ];
    const $491f4fde535ee8ab$export$41a9145ddbba28e5 = ()=>[
            ...$491f4fde535ee8ab$export$9c1c5e389bd00e56(),
            ...$491f4fde535ee8ab$export$2c543d6accc1eb9b()
        ];
    const $491f4fde535ee8ab$export$9c1c5e389bd00e56 = ()=>[
            (0, (0, parcelRequire("1WlLE")).priorityGroupResource),
            (0, (0, parcelRequire("6sNnq")).featuresResource),
            (0, (0, parcelRequire("gS5PF")).staticSidebarJsmReportsResource)
        ];
    const $491f4fde535ee8ab$export$2c543d6accc1eb9b = ()=>[
            (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar'), (0, (0, parcelRequire("lbaDt")).requiredProjectProperties)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar'), (0, (0, parcelRequire("lbaDt")).requiredFrontendProperties)),
            (0, (0, parcelRequire("5bkvv")).forgeServiceDeskQueueModuleResource),
            (0, (0, parcelRequire("b2pl3")).staticJSMProjectConnectAddonsNavigationResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $491f4fde535ee8ab$export$7bb3c4a2f6b127fb = ()=>[
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
            (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
            (0, (0, parcelRequire("8H3A4")).serviceDeskAnalyticsContextResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("2cxgG")).virtualAgentOnboardingResource))
        ];
    const $491f4fde535ee8ab$export$a8b852f03a310dc0 = ()=>[
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
            (0, (0, parcelRequire("8H3A4")).serviceDeskAnalyticsContextResource)
        ];
    const $491f4fde535ee8ab$export$70b97995f4d5ef9f = ()=>[
            ...$491f4fde535ee8ab$export$a8b852f03a310dc0(),
            ...$491f4fde535ee8ab$export$bc0bd65e6da57c1f(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource))
        ];
    const $491f4fde535ee8ab$export$e1016cce62543991 = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_view_queues_issuelist'), (0, (0, parcelRequire("1WlLE")).issueListSsrResource))
        ];
    const $491f4fde535ee8ab$export$ed87d3b71544c4ef = ()=>[
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $491f4fde535ee8ab$export$9e0cf1fab0581096 = ()=>[
            (0, (0, parcelRequire("gRzZD")).workspaceResource)
        ];
});
parcelRegister("gS5PF", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarJsmReportsResource", ()=>$e7e607725980fdf6$export$ec28065a31cce4ce);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $cQGRH;
    const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
        getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            return (0, (0, parcelRequire("cQGRH")).fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
        },
        maxAge: 300000
    });
});
parcelRegister("cQGRH", function(module, exports) {
    $parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", ()=>$ed2ba0d649a8d8eb$export$c1dd51127051647d);
    var $eusud;
    const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
        if (projectIdOrKey == null) throw new Error('invalid project id or key');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
    };
});
parcelRegister("bjZiV", function(module, exports) {
    $parcel$export(module.exports, "kbConfluenceContextResource", ()=>$450040dc63d5cc0e$export$8b58be1423986d17);
    var $dIdda = parcelRequire("dIdda");
    const $450040dc63d5cc0e$var$getDataLoader = ()=>(parcelRequire("f43qF"));
    const $450040dc63d5cc0e$export$8b58be1423986d17 = (0, $dIdda.createResource)({
        type: (0, $3139e13cdf89be01$export$54b5a0d1e8c78de6),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: $450040dc63d5cc0e$var$getDataLoader,
        maxAge: Infinity
    });
});
const $3139e13cdf89be01$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';
parcelRegister("f43qF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2CTCs").then(()=>parcelRequire('2SeLy'));
});
parcelRegister("8H3A4", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskAnalyticsContextResource", ()=>$4d76b3bac8f2b7c8$export$d6f4f0483916919f);
    $parcel$export(module.exports, "useServiceDeskAnalyticsContext", ()=>$4d76b3bac8f2b7c8$export$bc2de1c42df30b10);
    var $5uXOq = parcelRequire("5uXOq");
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $4d76b3bac8f2b7c8$var$getDataLoader = ()=>(parcelRequire("9YBmF"));
    const $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS = 86400000;
    const $4d76b3bac8f2b7c8$export$d6f4f0483916919f = (0, $dIdda.createResource)({
        type: (0, $3b4b6bf0bbdfa955$export$285b47583a5bdd0f),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $4d76b3bac8f2b7c8$var$getDataLoader,
        maxAge: $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS
    });
    const $4d76b3bac8f2b7c8$export$bc2de1c42df30b10 = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($4d76b3bac8f2b7c8$export$d6f4f0483916919f);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
});
const $3b4b6bf0bbdfa955$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';
parcelRegister("9YBmF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3rvO2").then(()=>parcelRequire('btHFe'));
});
parcelRegister("cAofY", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskContextResource", ()=>$9c517de0cdc23225$export$5eaaf465969a9171);
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("jxdf6"));
    const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $dIdda.createResource)({
        type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrIdFromMatchAndQuery)({
                match: match,
                query: query
            }),
        getDataLoader: $9c517de0cdc23225$var$getDataLoader,
        maxAge: Infinity
    });
});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';
parcelRegister("jxdf6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iNITq").then(()=>parcelRequire('g4PUK'));
});
parcelRegister("eUvlM", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPracticesResource", ()=>$9479f477b801290f$export$2ae319305481e7de);
    $parcel$export(module.exports, "useWorkCategoriesQueueSupported", ()=>$9479f477b801290f$export$a86ac771006f14b3);
    $parcel$export(module.exports, "useWorkCategoriesAllSupported", ()=>$9479f477b801290f$export$fe081b1a59d3c818);
    $parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", ()=>$9479f477b801290f$export$4d46346ef0bdc6b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dK8AG;
    var $oCMSG;
    var $dIdda = parcelRequire("dIdda");
    const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("bvW9G"));
    const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
    const $9479f477b801290f$export$2ae319305481e7de = (0, $dIdda.createResource)({
        type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $9479f477b801290f$var$getDataLoader,
        maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
    });
    const $9479f477b801290f$var$queuesOrder = [
        ...(0, (0, parcelRequire("oCMSG")).WORK_CATEGORIES_QUEUE_SUPPORTED)
    ];
    const $9479f477b801290f$var$workCategoryOrder = [
        ...$9479f477b801290f$var$queuesOrder,
        (0, (0, parcelRequire("oCMSG")).DEVELOPER_ESCALATION)
    ];
    const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
        if (!data?.practices) return null;
        return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
    };
    const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
        if (!data?.practices) return null;
        return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
    };
    const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
        const { data: data, loading: loading, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformItsmPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
    const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
        const { data: data, loading: loading, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
    const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
        const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && !data && !error) refreshPractices();
        }, [
            data,
            error,
            loading,
            refreshPractices
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
});
parcelRegister("oCMSG", function(module, exports) {
    $parcel$export(module.exports, "CHANGES", ()=>$4f9c4406e75c8aa5$export$8598196f74460271);
    $parcel$export(module.exports, "INCIDENTS", ()=>$4f9c4406e75c8aa5$export$a50b49a533b5f7bc);
    $parcel$export(module.exports, "PROBLEMS", ()=>$4f9c4406e75c8aa5$export$ceba70db1edb1def);
    $parcel$export(module.exports, "SERVICE_REQUEST", ()=>$4f9c4406e75c8aa5$export$3d1cda9bd50505e8);
    $parcel$export(module.exports, "POST_INCIDENT_REVIEWS", ()=>$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f);
    $parcel$export(module.exports, "DEVELOPER_ESCALATION", ()=>$4f9c4406e75c8aa5$export$81e62964cc725098);
    $parcel$export(module.exports, "NO_CATEGORY", ()=>$4f9c4406e75c8aa5$export$485b1216c42d8d4);
    $parcel$export(module.exports, "NO_PRACTICE", ()=>$4f9c4406e75c8aa5$export$52bf3f16b7812704);
    $parcel$export(module.exports, "SHORT_FORM_CHANGES", ()=>$4f9c4406e75c8aa5$export$a50185c8e9fb007e);
    $parcel$export(module.exports, "SHORT_FORM_INCIDENTS", ()=>$4f9c4406e75c8aa5$export$a54a30a3c3cce634);
    $parcel$export(module.exports, "SHORT_FORM_PROBLEMS", ()=>$4f9c4406e75c8aa5$export$354f3a4c6ac0c903);
    $parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", ()=>$4f9c4406e75c8aa5$export$335d3ac0c367f03f);
    $parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", ()=>$4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f);
    $parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", ()=>$4f9c4406e75c8aa5$export$cb41b99ca54e6bd);
    $parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", ()=>$4f9c4406e75c8aa5$export$a2b1f8f055150f02);
    $parcel$export(module.exports, "ItsmPracticeToShortForm", ()=>$4f9c4406e75c8aa5$export$56c57f7ad650c45c);
    $parcel$export(module.exports, "PRACTICE_LABEL_MAP", ()=>$4f9c4406e75c8aa5$export$fbf0dfd01228e38d);
    $parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", ()=>$4f9c4406e75c8aa5$export$45ba5f49e9509c4d);
    $parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", ()=>$4f9c4406e75c8aa5$export$45952424a7f29b99);
    $parcel$export(module.exports, "CHANGES_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$6c24c440228eac9c);
    $parcel$export(module.exports, "INCIDENTS_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$5b65d27ec2d28d18);
    $parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$3f757c5e00588ffd);
    $parcel$export(module.exports, "practiceKeyJqlNameMapping", ()=>$4f9c4406e75c8aa5$export$b78213db77524b5b);
    var $7c0in;
    var $kVZSN;
    const $4f9c4406e75c8aa5$export$8598196f74460271 = 'change-management';
    const $4f9c4406e75c8aa5$export$a50b49a533b5f7bc = 'incident-management';
    const $4f9c4406e75c8aa5$export$ceba70db1edb1def = 'problem-management';
    const $4f9c4406e75c8aa5$export$3d1cda9bd50505e8 = 'service-request';
    const $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f = 'post-incident-review';
    const $4f9c4406e75c8aa5$export$81e62964cc725098 = 'developer-escalation';
    const $4f9c4406e75c8aa5$export$485b1216c42d8d4 = 'no-category';
    const $4f9c4406e75c8aa5$export$f929a394dd190451 = 'no-category-new';
    const $4f9c4406e75c8aa5$export$52bf3f16b7812704 = 'no-practice';
    const $4f9c4406e75c8aa5$export$a50185c8e9fb007e = 'changes';
    const $4f9c4406e75c8aa5$export$a54a30a3c3cce634 = 'incidents';
    const $4f9c4406e75c8aa5$export$354f3a4c6ac0c903 = 'problems';
    const $4f9c4406e75c8aa5$export$335d3ac0c367f03f = 'service-requests';
    const $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
    const $4f9c4406e75c8aa5$export$cb41b99ca54e6bd = 'developer-escalations';
    const $4f9c4406e75c8aa5$export$a613d808168c7b25 = [
        $4f9c4406e75c8aa5$export$8598196f74460271,
        $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
        $4f9c4406e75c8aa5$export$ceba70db1edb1def,
        $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
        $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f,
        $4f9c4406e75c8aa5$export$81e62964cc725098
    ];
    const $4f9c4406e75c8aa5$export$a2b1f8f055150f02 = [
        $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
        $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
        $4f9c4406e75c8aa5$export$ceba70db1edb1def,
        $4f9c4406e75c8aa5$export$8598196f74460271,
        $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f
    ];
    const $4f9c4406e75c8aa5$export$5a9122a4028fb8ef = [
        ...$4f9c4406e75c8aa5$export$a2b1f8f055150f02,
        $4f9c4406e75c8aa5$export$485b1216c42d8d4
    ];
    const $4f9c4406e75c8aa5$export$f1b813cd23817ade = [
        $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
        $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
        $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
        $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
        $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
        $4f9c4406e75c8aa5$export$cb41b99ca54e6bd
    ];
    const $4f9c4406e75c8aa5$export$56c57f7ad650c45c = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: $4f9c4406e75c8aa5$export$f929a394dd190451
    };
    const $4f9c4406e75c8aa5$export$fbf0dfd01228e38d = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, (0, parcelRequire("kVZSN")).default).changes,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, (0, parcelRequire("kVZSN")).default).serviceRequests,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, (0, parcelRequire("kVZSN")).default).problems,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, (0, parcelRequire("kVZSN")).default).incidents,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, (0, parcelRequire("kVZSN")).default).postIncidentReviews,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, (0, parcelRequire("kVZSN")).default).queues,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, (0, parcelRequire("kVZSN")).default).developerEscalation,
        [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, (0, parcelRequire("kVZSN")).default).noCategory
    };
    const $4f9c4406e75c8aa5$export$45ba5f49e9509c4d = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, (0, parcelRequire("kVZSN")).default).changesLower,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, (0, parcelRequire("kVZSN")).default).serviceRequestsLower,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, (0, parcelRequire("kVZSN")).default).problemsLower,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, (0, parcelRequire("kVZSN")).default).incidentsLower,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, (0, parcelRequire("kVZSN")).default).postIncidentReviewsLower,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, (0, parcelRequire("kVZSN")).default).queuesLower,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, (0, parcelRequire("kVZSN")).default).developerEscalationLower,
        [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, (0, parcelRequire("kVZSN")).default).noCategoryLower
    };
    const $4f9c4406e75c8aa5$export$45952424a7f29b99 = (0, (0, parcelRequire("7c0in")).getTypedKeys)($4f9c4406e75c8aa5$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
        const queueKey = $4f9c4406e75c8aa5$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
        if (queueKey) acc[queueKey] = $4f9c4406e75c8aa5$export$fbf0dfd01228e38d[labelMapKey];
        return acc;
    }, {});
    const $4f9c4406e75c8aa5$export$6c24c440228eac9c = 'Changes';
    const $4f9c4406e75c8aa5$export$5b65d27ec2d28d18 = 'Incidents';
    const $4f9c4406e75c8aa5$export$51618dc8334072b = 'Problems';
    const $4f9c4406e75c8aa5$export$a34586940ac9c374 = 'Service requests';
    const $4f9c4406e75c8aa5$export$5497b62b513b7853 = 'Post-incident reviews';
    const $4f9c4406e75c8aa5$export$3f757c5e00588ffd = 'Developer escalation';
    const $4f9c4406e75c8aa5$export$b78213db77524b5b = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$6c24c440228eac9c,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$5b65d27ec2d28d18,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$51618dc8334072b,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$a34586940ac9c374,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$5497b62b513b7853,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: $4f9c4406e75c8aa5$export$3f757c5e00588ffd
    };
});
parcelRegister("7c0in", function(module, exports) {
    $parcel$export(module.exports, "hasProp", ()=>$2dc9189f096b533d$export$dd642ef726dcde21);
    $parcel$export(module.exports, "getTypedKeys", ()=>$2dc9189f096b533d$export$5206d47972fefe20);
    const $2dc9189f096b533d$export$dd642ef726dcde21 = (data, prop)=>prop in data;
    const $2dc9189f096b533d$export$5206d47972fefe20 = (obj)=>{
        return Object.keys(obj);
    };
});
parcelRegister("kVZSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d218b9a030da8fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5d218b9a030da8fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        queues: {
            "id": "work-category.common.queues",
            "defaultMessage": "Queues"
        },
        serviceRequests: {
            "id": "work-category.common.service-requests",
            "defaultMessage": "Service requests"
        },
        incidents: {
            "id": "work-category.common.incidents",
            "defaultMessage": "Incidents"
        },
        changes: {
            "id": "work-category.common.changes",
            "defaultMessage": "Changes"
        },
        problems: {
            "id": "work-category.common.problems",
            "defaultMessage": "Problems"
        },
        postIncidentReviews: {
            "id": "work-category.common.post-incident-reviews",
            "defaultMessage": "Post-incident reviews"
        },
        noCategory: {
            "id": "work-category.common.no-category",
            "defaultMessage": "General"
        },
        queuesLower: {
            "id": "work-category.common.queues-lower",
            "defaultMessage": "queues"
        },
        serviceRequestsLower: {
            "id": "work-category.common.service-requests-lower",
            "defaultMessage": "service requests"
        },
        incidentsLower: {
            "id": "work-category.common.incidents-lower",
            "defaultMessage": "incidents"
        },
        changesLower: {
            "id": "work-category.common.changes-lower",
            "defaultMessage": "changes"
        },
        problemsLower: {
            "id": "work-category.common.problems-lower",
            "defaultMessage": "problems"
        },
        postIncidentReviewsLower: {
            "id": "work-category.common.post-incident-reviews-lower",
            "defaultMessage": "post-incident reviews"
        },
        noCategoryLower: {
            "id": "work-category.common.no-category-lower",
            "defaultMessage": "general"
        },
        developerEscalation: {
            "id": "work-category.common.developer-escalation",
            "defaultMessage": "Developer escalations"
        },
        developerEscalationLower: {
            "id": "work-category.common.developer-escalation-lower",
            "defaultMessage": "developer escalations"
        }
    });
});
const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';
parcelRegister("bvW9G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jhLKO").then(()=>parcelRequire('8khb6'));
});
parcelRegister("lbaDt", function(module, exports) {
    $parcel$export(module.exports, "requiredProjectProperties", ()=>$3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
    $parcel$export(module.exports, "requiredFrontendProperties", ()=>$3477ceb4f9b98b2e$export$47241956725e3029);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $13HHi;
    const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("gssgh"));
    const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];
    const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("13HHi")).RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES),
        getKey: $3477ceb4f9b98b2e$var$getKey,
        getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader
    });
    const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("fTSMy"));
    const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("13HHi")).RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES),
        getKey: $3477ceb4f9b98b2e$var$getKey,
        getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
        maxAge: (0, (0, parcelRequire("13HHi")).ONE_DAY_IN_MILLIS)
    });
});
parcelRegister("13HHi", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES", ()=>$e7877c2ea997c7d8$export$54b53cba12671494);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES", ()=>$e7877c2ea997c7d8$export$7d9318d6cfb0a4df);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$e7877c2ea997c7d8$export$5a00268156ea5027);
    const $e7877c2ea997c7d8$export$54b53cba12671494 = 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES';
    const $e7877c2ea997c7d8$export$7d9318d6cfb0a4df = 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES';
    const $e7877c2ea997c7d8$export$5a00268156ea5027 = 86400000;
});
parcelRegister("gssgh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7aPU6").then(()=>parcelRequire('d4USv'));
});
parcelRegister("fTSMy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4Lrpj").then(()=>parcelRequire('7UDgf'));
});
parcelRegister("2cxgG", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentOnboardingResource", ()=>$e9d51fb7135f5412$export$d39827c053fda3aa);
    var $ao2h1;
    var $2j6fy;
    const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
        isBrowserOnly: true,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("2j6fy")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    key: match.params.projectKey || ''
                }
            })
    });
});
parcelRegister("2j6fy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45b605658e5ce20d$export$2e2bcd8739ae039);
    var $7oHmH;
    const $45b605658e5ce20d$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "f9088e152f36ba09b78f1e067be176d1d2e7e1bab920efd3620300fc8bf9722e",
            "metadata": {},
            "name": "mainVirtualAgentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;
});
parcelRegister("7oHmH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f0ef421b1798a33$export$2e2bcd8739ae039);
    var $4R6GH;
    var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('require_ai_enabled_for_jsm_virtual_agent');
        }
    };
});
parcelRegister("6sNnq", function(module, exports) {
    $parcel$export(module.exports, "featuresResource", ()=>$d0a02e466fb63798$export$16f81cc9da2c6c47);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $d0a02e466fb63798$var$getDataLoader = ()=>(parcelRequire("8wbKs"));
    const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
    const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $dIdda.createResource)({
        type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $d0a02e466fb63798$var$getDataLoader,
        maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
    });
});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';
parcelRegister("8wbKs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aOISr").then(()=>parcelRequire('frQmB'));
});
parcelRegister("gRzZD", function(module, exports) {
    $parcel$export(module.exports, "workspaceResource", ()=>$d68afc54033ea939$export$2f02c3f971168d17);
    var $dIdda = parcelRequire("dIdda");
    var $ahEft;
    const $d68afc54033ea939$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
    const $d68afc54033ea939$export$2f02c3f971168d17 = (0, $dIdda.createResource)({
        type: $d68afc54033ea939$export$9b3a4d71d46e5ee7,
        getKey: ()=>'state',
        getData: async (_, routerContext)=>{
            const workspaceId = await (0, (0, parcelRequire("ahEft")).default)(_, routerContext);
            return workspaceId;
        },
        maxAge: Infinity
    });
});
parcelRegister("ahEft", function(module, exports) {
    $parcel$export(module.exports, "isPremiumInstance", ()=>$b8bed038f2dce149$export$abb609d3bcbb74f6);
    $parcel$export(module.exports, "isLicensedPremiumUser", ()=>$b8bed038f2dce149$export$d7b4c32773b1c643);
    $parcel$export(module.exports, "default", ()=>$b8bed038f2dce149$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $ktP1V;
    var $5Ny9E;
    var $ldyPw;
    const $b8bed038f2dce149$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
    const $b8bed038f2dce149$export$abb609d3bcbb74f6 = (tenantContext)=>{
        const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
        const isPremium = serviceDeskAppEdition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
        return isPremium;
    };
    const $b8bed038f2dce149$export$d7b4c32773b1c643 = (tenantContext)=>{
        const { appPermissions: appPermissions } = tenantContext;
        const isPremium = $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext);
        const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
        return isPremium && isLicensedUser;
    };
    const $b8bed038f2dce149$var$transformResponse = (response)=>{
        const ids = response.results ?? [];
        return ids.length ? (0, (0, parcelRequire("5Ny9E")).toWorkspaceId)(ids[0].id) : null;
    };
    const $b8bed038f2dce149$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        if ($b8bed038f2dce149$export$d7b4c32773b1c643(tenantContext) === false || !(0, (0, parcelRequire("ktP1V")).isCMDBEnabledInEnvironment)()) return null;
        return (0, (0, parcelRequire("eusud")).performGetRequest)($b8bed038f2dce149$export$530f260cc76f04ff(baseUrl)).then($b8bed038f2dce149$var$transformResponse).catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
            return null;
        });
    };
    var $b8bed038f2dce149$export$2e2bcd8739ae039 = $b8bed038f2dce149$export$e1d718dfe6dad973;
});
parcelRegister("ktP1V", function(module, exports) {
    $parcel$export(module.exports, "isCMDBEnabledInEnvironment", ()=>$84a32a7226f836c4$export$6dbfb62369f79a64);
    var $aIZdc;
    const $84a32a7226f836c4$export$6dbfb62369f79a64 = ()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)();
});
parcelRegister("5Ny9E", function(module, exports) {
    $parcel$export(module.exports, "toSchemaId", ()=>$a330a4171d28d64c$export$d577b7f3b832f656);
    $parcel$export(module.exports, "toCmdbObjectId", ()=>$a330a4171d28d64c$export$1ba342595bc7be13);
    $parcel$export(module.exports, "toCmdbObjectTypeId", ()=>$a330a4171d28d64c$export$b46e25afa2bab6a);
    $parcel$export(module.exports, "toObjectCommentId", ()=>$a330a4171d28d64c$export$ece2917434bb0a8c);
    $parcel$export(module.exports, "toWorkspaceId", ()=>$a330a4171d28d64c$export$d002b8d7821b6b59);
    $parcel$export(module.exports, "toObjectTypeAttributeId", ()=>$a330a4171d28d64c$export$cfd92c18cee8add7);
    const $a330a4171d28d64c$export$d577b7f3b832f656 = (id)=>id;
    const $a330a4171d28d64c$export$1ba342595bc7be13 = (id)=>id;
    const $a330a4171d28d64c$export$b46e25afa2bab6a = (id)=>id;
    const $a330a4171d28d64c$export$ece2917434bb0a8c = (id)=>id;
    const $a330a4171d28d64c$export$d002b8d7821b6b59 = (id)=>id;
    const $a330a4171d28d64c$export$cfd92c18cee8add7 = (id)=>id;
});
parcelRegister("iGYap", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cTtOi").then(()=>parcelRequire('crFp4'));
});
parcelRegister("dwmMO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6lBjo").then(()=>parcelRequire('2GYK9'));
});
parcelRegister("1OvmD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("p91SI").then(()=>parcelRequire('6cT2s'));
});
parcelRegister("8o619", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7t741").then(()=>parcelRequire('bjmK5'));
});
parcelRegister("3d3Of", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("b3iUB")
    ]).then(()=>parcelRequire('dsKht'));
});
parcelRegister("9lbpO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9RY0k")
    ]).then(()=>parcelRequire('cKcai'));
});
parcelRegister("gh1hi", function(module, exports) {
    $parcel$export(module.exports, "dashboardConfigAndWRMResource", ()=>$ca62b878c99c7128$export$2853c0e656e89346);
    $parcel$export(module.exports, "useDashboardResource", ()=>$ca62b878c99c7128$export$e5e5b3f462d6a4cb);
    $parcel$export(module.exports, "useMultiDashboardsResource", ()=>$ca62b878c99c7128$export$6a46406b05d8d13c);
    $parcel$export(module.exports, "dashboardAMDModulesResource", ()=>$ca62b878c99c7128$export$ef3fa55626812fa4);
    $parcel$export(module.exports, "useDashboardAMDModulesResource", ()=>$ca62b878c99c7128$export$efe0eb9a44e08d38);
    $parcel$export(module.exports, "dashboardReactGadgetsResource", ()=>$ca62b878c99c7128$export$39804ce8cc42cd04);
    $parcel$export(module.exports, "useDashboardReactGadgetsResource", ()=>$ca62b878c99c7128$export$31b430e01a1caab5);
    $parcel$export(module.exports, "dashboardForgeResource", ()=>$ca62b878c99c7128$export$4e0719e53da01e93);
    $parcel$export(module.exports, "gadgetDirectoryResource", ()=>$ca62b878c99c7128$export$36c9632be21fbb06);
    $parcel$export(module.exports, "useGadgetDirectoryResource", ()=>$ca62b878c99c7128$export$27f4c12e781b4572);
    $parcel$export(module.exports, "useDashboardForgeResource", ()=>$ca62b878c99c7128$export$75ca1b431898fd09);
    var $4R6GH;
    var $k2DRb;
    var $iVaKa;
    var $5vSAE;
    var $dIdda = parcelRequire("dIdda");
    var $3Yd87;
    var $abozY;
    var $04Brv;
    var $3cb5I;
    var $aVFmC;
    var $3Zhqx;
    var $8oOn8;
    const $ca62b878c99c7128$export$2853c0e656e89346 = (0, $dIdda.createResource)({
        type: (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16),
        getKey: (0, parcelRequire("abozY")).getKey,
        getData: (0, (0, parcelRequire("3cb5I")).default),
        maxAge: Infinity
    });
    const $ca62b878c99c7128$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
    const $ca62b878c99c7128$export$e5e5b3f462d6a4cb = ()=>{
        const resourceResponse = $ca62b878c99c7128$export$6a46406b05d8d13c();
        const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
        const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                    getNewData(a)
                ]);
        if (loading) return {
            ...rest,
            error: null,
            data: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
            loading: true,
            update: extractFirstUpdate
        };
        if (error) return {
            ...rest,
            error: error,
            data: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
            loading: false,
            update: extractFirstUpdate
        };
        if (data && !error) return {
            ...rest,
            loading: false,
            update: extractFirstUpdate,
            data: data[0],
            error: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs)
        };
        return {
            ...rest,
            loading: false,
            error: error,
            data: null,
            promise: null,
            update: extractFirstUpdate
        };
    };
    const $ca62b878c99c7128$export$6a46406b05d8d13c = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$2853c0e656e89346);
    const $ca62b878c99c7128$export$ef3fa55626812fa4 = (0, (0, parcelRequire("3Yd87")).createDependentResource)({
        type: (0, $e03099b7bef7f4cd$export$e239393fd4e2bc85),
        getKey: (0, parcelRequire("abozY")).getKey,
        depends: [
            (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
        ],
        mapToSharedValue: (0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((data)=>{
            const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                    gadgets: prev.gadgets.concat(curr.gadgets),
                    preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
                }), {
                gadgets: [],
                preloadedModuleNames: []
            });
            const moduleNames = (0, (0, parcelRequire("8oOn8")).gadgetsToUniqueSortedAmdModules)(gadgets);
            const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
            return {
                moduleNames: moduleNames,
                isPreloaded: isPreloaded
            };
        }, (x)=>x),
        shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
        getData: (0, (0, parcelRequire("04Brv")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$efe0eb9a44e08d38 = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$ef3fa55626812fa4);
    const $ca62b878c99c7128$export$39804ce8cc42cd04 = (0, (0, parcelRequire("3Yd87")).createDependentResource)({
        type: (0, $e03099b7bef7f4cd$export$9e5db01432b13b67),
        getKey: (0, parcelRequire("abozY")).getKey,
        depends: [
            (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
        ],
        mapToSharedValue: (0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((data)=>{
            const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
            return {
                reactGadgets: (0, (0, parcelRequire("8oOn8")).gadgetsToSortedReactGadgets)(gadgets)
            };
        }, (x)=>x),
        shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
        getData: (0, (0, parcelRequire("3Zhqx")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$31b430e01a1caab5 = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$39804ce8cc42cd04);
    const $ca62b878c99c7128$export$4e0719e53da01e93 = (0, $dIdda.createResource)({
        type: (0, $e03099b7bef7f4cd$export$bce41807cc929d0f),
        getKey: (0, parcelRequire("abozY")).getKey,
        getData: async (_, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
                const modules = await (0, (0, parcelRequire("5vSAE")).fetchModules)({
                    cloudId: cloudId,
                    types: [
                        (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
                        (0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE)
                    ],
                    context: {},
                    includeHidden: false,
                    source: (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER)
                });
                return {
                    gadgets: modules[0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE],
                    backgroundScripts: modules[0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE]
                };
            }
            const contextIds = [
                `ari:cloud:jira:${cloudId}:workspace/${activationId}`
            ];
            const { extensions: extensions } = await (0, (0, parcelRequire("iVaKa")).default)(cloudId, [
                (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
                (0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ], null, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER), contextIds, locale);
            return {
                gadgets: extensions.jiraDashboardGadget,
                backgroundScripts: extensions.jiraDashboardBackgroundScript
            };
        },
        maxAge: Infinity
    });
    const $ca62b878c99c7128$export$36c9632be21fbb06 = (0, $dIdda.createResource)({
        type: (0, $e03099b7bef7f4cd$export$c07a25ebb6af1e84),
        getKey: ()=>'gadgetDirectoryItems',
        getData: (0, (0, parcelRequire("aVFmC")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$27f4c12e781b4572 = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$36c9632be21fbb06);
    const $ca62b878c99c7128$export$75ca1b431898fd09 = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$4e0719e53da01e93);
});
parcelRegister("3Yd87", function(module, exports) {
    $parcel$export(module.exports, "withEitherDataOrError", ()=>$3e606a4e02c14aae$export$54e973088fdd59a1);
    $parcel$export(module.exports, "createDependentResource", ()=>$3e606a4e02c14aae$export$7f8dd41bdfd85a47);
    $parcel$export(module.exports, "SharedValueAggregateError", ()=>$3e606a4e02c14aae$export$36d5102d613df7c6);
    var $dIdda = parcelRequire("dIdda");
    const $3e606a4e02c14aae$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
            const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
            return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
        };
    const $3e606a4e02c14aae$export$fcdc85dfc621ec7a = (dependencies, type)=>{
        const { [type]: resourceSlice } = dependencies;
        if (!resourceSlice) throw new (0, $dIdda.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
        return resourceSlice.data;
    };
    const $3e606a4e02c14aae$export$bee6a631bfb54474 = (dependencies, type)=>{
        const { [type]: resourceSlice } = dependencies;
        if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
        const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
        return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
    };
    const $3e606a4e02c14aae$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $dIdda.createResource)({
            ...rest,
            type: type,
            depends: [
                ...depends,
                type
            ],
            getData: (dataContext, storeContext)=>{
                const { dependencies: dependencies } = dataContext;
                const prevValue = $3e606a4e02c14aae$export$fcdc85dfc621ec7a(dependencies, type);
                const valuesOrPromises = depends.map((d)=>$3e606a4e02c14aae$export$bee6a631bfb54474(dependencies, d));
                const implementation = (depDataOrErrorOrNull)=>{
                    const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                    return prevValue == null || prevValue instanceof Error || shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, storeContext) : prevValue;
                };
                return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
            }
        });
    class $3e606a4e02c14aae$export$36d5102d613df7c6 extends Error {
        constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
            super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
            this.skipSentry = true;
        }
    }
});
parcelRegister("abozY", function(module, exports) {
    $parcel$export(module.exports, "getKey", ()=>$707c98c2b1b4b40d$export$a47fb462a08de82f);
    var $65Ltd;
    var $JIPqS;
    const $707c98c2b1b4b40d$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)) return 0, (0, parcelRequire("JIPqS")).SYSTEM_DASHBOARD_ID;
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD)) return query.dashboardId?.split(',')[0];
        return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
    };
});
parcelRegister("JIPqS", function(module, exports) {
    $parcel$export(module.exports, "GADGET_DISPLAY", ()=>$6c7fd970bbaee123$export$d7e1dfcefcde2410);
    $parcel$export(module.exports, "MAXIMIZED_PARAM", ()=>$6c7fd970bbaee123$export$86eaa19ea940a4f5);
    $parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", ()=>$6c7fd970bbaee123$export$a1baea8b97610fd);
    $parcel$export(module.exports, "WEB_RESOURCE_MAP", ()=>$6c7fd970bbaee123$export$c6d360a8456d120a);
    $parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", ()=>$6c7fd970bbaee123$export$30b970d16c2f5e0a);
    $parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", ()=>$6c7fd970bbaee123$export$50eac80bcbebc737);
    $parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", ()=>$6c7fd970bbaee123$export$e11ffd0409aa6522);
    $parcel$export(module.exports, "FOOTER_MARGIN", ()=>$6c7fd970bbaee123$export$4d708f4c16ae3a73);
    $parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", ()=>$6c7fd970bbaee123$export$255117c9adec50a5);
    $parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", ()=>$6c7fd970bbaee123$export$e281465c09f561d4);
    $parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", ()=>$6c7fd970bbaee123$export$46dd0168a7875b47);
    $parcel$export(module.exports, "COLOR_MAP", ()=>$6c7fd970bbaee123$export$1468aefba37090f9);
    $parcel$export(module.exports, "COLOR_NAME_MAP", ()=>$6c7fd970bbaee123$export$5d9e688e192a63ae);
    $parcel$export(module.exports, "COLOR_CHECKMARK_MAP", ()=>$6c7fd970bbaee123$export$6906a4beef307ac4);
    $parcel$export(module.exports, "MODAL_ID", ()=>$6c7fd970bbaee123$export$ebdd5a8e5b1c2de5);
    $parcel$export(module.exports, "LAYOUTS", ()=>$6c7fd970bbaee123$export$87e50aced9c52ebb);
    $parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", ()=>$6c7fd970bbaee123$export$b0234a47b1a4a515);
    $parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", ()=>$6c7fd970bbaee123$export$9674cd14c20d1c89);
    $parcel$export(module.exports, "GADGET_METRICS_TYPE", ()=>$6c7fd970bbaee123$export$46b6c8eb53069613);
    $parcel$export(module.exports, "PAGE_READY_METRIC_KEY", ()=>$6c7fd970bbaee123$export$464d2a6bcb398791);
    $parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$4f74f1f13671c49d);
    $parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$3853fce65645c557);
    $parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", ()=>$6c7fd970bbaee123$export$c8c77659771c38b9);
    $parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$707702c47e5b9648);
    $parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$efbab4efa7252143);
    $parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", ()=>$6c7fd970bbaee123$export$7b6f3ec1189de156);
    $parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", ()=>$6c7fd970bbaee123$export$f0e105144716a420);
    $parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", ()=>$6c7fd970bbaee123$export$5ba84cd082269cd5);
    $parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", ()=>$6c7fd970bbaee123$export$6c84c6099fed3c23);
    $parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$3b17b4f7f722b1ae);
    $parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", ()=>$6c7fd970bbaee123$export$c8900d7e874d42ca);
    $parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", ()=>$6c7fd970bbaee123$export$bac5a3e9d008da59);
    $parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", ()=>$6c7fd970bbaee123$export$18b54b2c53cf6acd);
    $parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$a3d5b76ea0c8f4ca);
    $parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", ()=>$6c7fd970bbaee123$export$7254246f25b4cbc8);
    $parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$40c4d345e57fce2d);
    $parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$43fb10a4d8374f1a);
    $parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", ()=>$6c7fd970bbaee123$export$2f961c74af6d8735);
    $parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", ()=>$6c7fd970bbaee123$export$dab1096b356df1cc);
    $parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", ()=>$6c7fd970bbaee123$export$32f0edca4eebb9c7);
    $parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", ()=>$6c7fd970bbaee123$export$791f7067c41dc5b1);
    $parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", ()=>$6c7fd970bbaee123$export$eba1a497984af3ae);
    $parcel$export(module.exports, "COPY_DASHBOARD", ()=>$6c7fd970bbaee123$export$3578044b625436f9);
    $parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", ()=>$6c7fd970bbaee123$export$48bb59a846d62ea0);
    $parcel$export(module.exports, "DELETE_DASHBOARD", ()=>$6c7fd970bbaee123$export$e7dfbcf33cf2b19a);
    $parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$fabf79b25b44377f);
    $parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", ()=>$6c7fd970bbaee123$export$abba919f32a1a776);
    $parcel$export(module.exports, "GADGET_ERROR_TYPE", ()=>$6c7fd970bbaee123$export$768dad6811159849);
    $parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", ()=>$6c7fd970bbaee123$export$ada294d471e7dfc3);
    $parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", ()=>$6c7fd970bbaee123$export$f4280aaeba4d1d08);
    $parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", ()=>$6c7fd970bbaee123$export$685171fdf5112bc4);
    $parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", ()=>$6c7fd970bbaee123$export$4d8c12b9aaeac619);
    $parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", ()=>$6c7fd970bbaee123$export$f07dac7b8de3bda);
    $parcel$export(module.exports, "DEPRECATED_GADGETS_MAP", ()=>$6c7fd970bbaee123$export$4ac59ce79d9e7591);
    $parcel$export(module.exports, "DEPRECATION_BANNER_V1", ()=>$6c7fd970bbaee123$export$b5d0f99a1924c478);
    var $gwIPs;
    var $cKw8Y;
    const $6c7fd970bbaee123$export$d7e1dfcefcde2410 = {
        MAXIMIZED: 'maximized',
        NORMAL: 'normal',
        HIDDEN: 'hidden'
    };
    const $6c7fd970bbaee123$export$86eaa19ea940a4f5 = 'maximized';
    const $6c7fd970bbaee123$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
    const $6c7fd970bbaee123$export$c6d360a8456d120a = {
        'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
        'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
        'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
        'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
        'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
        'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
        'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
        'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
        'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
        'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
        'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
        'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
        'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
        'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
        'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
        'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
        'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
        'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
        'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
        'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
        'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
        'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
        'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
        'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
        'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
        'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
        'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
        'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
        'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
        'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
        'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
        'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
    };
    const $6c7fd970bbaee123$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
    const $6c7fd970bbaee123$export$50eac80bcbebc737 = '10000';
    const $6c7fd970bbaee123$export$e11ffd0409aa6522 = (0, (0, parcelRequire("gwIPs")).gridSize) * 10;
    const $6c7fd970bbaee123$export$4d708f4c16ae3a73 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $6c7fd970bbaee123$export$504bf5c8f7d402e9 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $6c7fd970bbaee123$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
    const $6c7fd970bbaee123$export$e281465c09f561d4 = 'dashboard-data';
    const $6c7fd970bbaee123$export$46dd0168a7875b47 = 160;
    const $6c7fd970bbaee123$var$COLOR_BLUE = '#2684ff';
    const $6c7fd970bbaee123$var$COLOR_RED = '#ff5630';
    const $6c7fd970bbaee123$var$COLOR_YELLOW = '#ffab00';
    const $6c7fd970bbaee123$var$COLOR_GREEN = '#36b37e';
    const $6c7fd970bbaee123$var$COLOR_TEAL = '#00b8d9';
    const $6c7fd970bbaee123$var$COLOR_PURPLE = '#6554c0';
    const $6c7fd970bbaee123$var$COLOR_GRAY = '#97a0af';
    const $6c7fd970bbaee123$var$COLOR_WHITE = '#ffffff';
    const $6c7fd970bbaee123$export$1468aefba37090f9 = {
        color1: $6c7fd970bbaee123$var$COLOR_BLUE,
        color2: $6c7fd970bbaee123$var$COLOR_RED,
        color3: $6c7fd970bbaee123$var$COLOR_YELLOW,
        color4: $6c7fd970bbaee123$var$COLOR_GREEN,
        color5: $6c7fd970bbaee123$var$COLOR_TEAL,
        color6: $6c7fd970bbaee123$var$COLOR_PURPLE,
        color7: $6c7fd970bbaee123$var$COLOR_GRAY,
        color8: $6c7fd970bbaee123$var$COLOR_WHITE
    };
    const $6c7fd970bbaee123$export$5d9e688e192a63ae = {
        [$6c7fd970bbaee123$var$COLOR_BLUE]: (0, (0, parcelRequire("cKw8Y")).default).blue,
        [$6c7fd970bbaee123$var$COLOR_RED]: (0, (0, parcelRequire("cKw8Y")).default).red,
        [$6c7fd970bbaee123$var$COLOR_YELLOW]: (0, (0, parcelRequire("cKw8Y")).default).yellow,
        [$6c7fd970bbaee123$var$COLOR_GREEN]: (0, (0, parcelRequire("cKw8Y")).default).green,
        [$6c7fd970bbaee123$var$COLOR_TEAL]: (0, (0, parcelRequire("cKw8Y")).default).teal,
        [$6c7fd970bbaee123$var$COLOR_PURPLE]: (0, (0, parcelRequire("cKw8Y")).default).purple,
        [$6c7fd970bbaee123$var$COLOR_GRAY]: (0, (0, parcelRequire("cKw8Y")).default).gray,
        [$6c7fd970bbaee123$var$COLOR_WHITE]: (0, (0, parcelRequire("cKw8Y")).default).white
    };
    const $6c7fd970bbaee123$export$6906a4beef307ac4 = {
        color1: (0, $829f609a65d26a98$exports).N10,
        color2: (0, $829f609a65d26a98$exports).N10,
        color3: (0, $829f609a65d26a98$exports).N500,
        color4: (0, $829f609a65d26a98$exports).N10,
        color5: (0, $829f609a65d26a98$exports).N500,
        color6: (0, $829f609a65d26a98$exports).N10,
        color7: (0, $829f609a65d26a98$exports).N10,
        color8: (0, $829f609a65d26a98$exports).N500
    };
    const $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5 = {
        EDIT_LAYOUT: 'edit-layout',
        DASHBOARD_COPY: 'dashboard-copy',
        AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
        DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
        DASHBOARD_DELETE: 'dashboard-delete',
        CONFIGURE_WALLBOARD: 'configure-wallboard',
        DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
    };
    const $6c7fd970bbaee123$export$87e50aced9c52ebb = [
        'A',
        'AA',
        'AAA',
        'BA',
        'AB'
    ];
    const $6c7fd970bbaee123$export$b0234a47b1a4a515 = 350;
    const $6c7fd970bbaee123$export$9674cd14c20d1c89 = 250;
    const $6c7fd970bbaee123$export$46b6c8eb53069613 = {
        REPORT: 'REPORT_GADGET_METRICS',
        TIMEOUT: 'TIMEOUT_GADGET_METRICS'
    };
    const $6c7fd970bbaee123$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
    const $6c7fd970bbaee123$export$4f74f1f13671c49d = 'delete-dashboard';
    const $6c7fd970bbaee123$export$3853fce65645c557 = 'copy-dashboard';
    const $6c7fd970bbaee123$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
    const $6c7fd970bbaee123$export$707702c47e5b9648 = 'rename-or-share-dashboard';
    const $6c7fd970bbaee123$export$efbab4efa7252143 = 'create-dashboard';
    const $6c7fd970bbaee123$export$7b6f3ec1189de156 = 'view-dashboard-editable';
    const $6c7fd970bbaee123$export$f0e105144716a420 = 'view-dashboard-readonly';
    const $6c7fd970bbaee123$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
    const $6c7fd970bbaee123$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
    const $6c7fd970bbaee123$export$3b17b4f7f722b1ae = 'add-gadget';
    const $6c7fd970bbaee123$export$c8900d7e874d42ca = 'save-amd-gadget-config';
    const $6c7fd970bbaee123$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
    const $6c7fd970bbaee123$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
    const $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
    const $6c7fd970bbaee123$export$7254246f25b4cbc8 = 'change-layout';
    const $6c7fd970bbaee123$export$40c4d345e57fce2d = 'delete-gadget';
    const $6c7fd970bbaee123$export$43fb10a4d8374f1a = 'view-react-gadget';
    const $6c7fd970bbaee123$export$2f961c74af6d8735 = 'dashboardView';
    const $6c7fd970bbaee123$export$dab1096b356df1cc = 'dashboardViewEmbed';
    const $6c7fd970bbaee123$export$32f0edca4eebb9c7 = 'dashboardEdit';
    const $6c7fd970bbaee123$export$791f7067c41dc5b1 = 'dashboardWallboardView';
    const $6c7fd970bbaee123$export$eba1a497984af3ae = 'systemDashboardEdit';
    const $6c7fd970bbaee123$export$3578044b625436f9 = 'copyDashboard';
    const $6c7fd970bbaee123$export$48bb59a846d62ea0 = 'automaticRefresh';
    const $6c7fd970bbaee123$export$e7dfbcf33cf2b19a = 'deleteDashboard';
    const $6c7fd970bbaee123$export$fabf79b25b44377f = 'duplicateGadget';
    const $6c7fd970bbaee123$export$abba919f32a1a776 = 'renameOrShareDashboard';
    const $6c7fd970bbaee123$export$768dad6811159849 = {
        VIEW_ERROR: 'viewError',
        EDIT_ERROR: 'editError',
        CONFIG_ERROR: 'configError',
        NOT_SUPPORTED_ERROR: 'notSupportedError'
    };
    const $6c7fd970bbaee123$export$f8e04d62c0b5d07e = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
    const $6c7fd970bbaee123$export$ada294d471e7dfc3 = 1000;
    const $6c7fd970bbaee123$export$f4280aaeba4d1d08 = 30000;
    const $6c7fd970bbaee123$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
    const $6c7fd970bbaee123$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
    const $6c7fd970bbaee123$export$f07dac7b8de3bda = [
        'issuetype',
        'issuekey',
        'summary',
        'priority'
    ];
    const $6c7fd970bbaee123$export$4ac59ce79d9e7591 = {
        'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item',
        'jira-dashboard-items/heat-map': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
        'jira-dashboard-items/projects': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
        'jira-dashboard-items/labels': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:labels-gadget/gadgets/labels-gadget.xml',
        'jira-dashboard-items/roadmap': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml'
    };
    const $6c7fd970bbaee123$export$b5d0f99a1924c478 = 'deprecatedGadgetBannerDismissedV1';
});
parcelRegister("gwIPs", function(module, exports) {
    $parcel$export(module.exports, "gridSize", ()=>$80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
    $parcel$export(module.exports, "borderRadius", ()=>$80d528dbc2b11cbc$export$7a57f79000377ca2);
    $parcel$export(module.exports, "fontSize", ()=>$80d528dbc2b11cbc$export$85e3c3ca0c6fb93);
    $parcel$export(module.exports, "fontFamily", ()=>$80d528dbc2b11cbc$export$a5975749f0374264);
    $parcel$export(module.exports, "codeFontFamily", ()=>$80d528dbc2b11cbc$export$356129969ee49c55);
    $parcel$export(module.exports, "contentHorizontalSpacing", ()=>$80d528dbc2b11cbc$export$22dec01f2c854397);
    $parcel$export(module.exports, "layers", ()=>$80d528dbc2b11cbc$export$7be255094ccdc533);
    $parcel$export(module.exports, "layout", ()=>$80d528dbc2b11cbc$export$b3219800bda33a1f);
    var $k5uoT;
    const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, (0, parcelRequire("k5uoT")).borderRadius)();
    const $80d528dbc2b11cbc$export$85e3c3ca0c6fb93 = (0, (0, parcelRequire("k5uoT")).fontSize)();
    const $80d528dbc2b11cbc$export$a5975749f0374264 = (0, (0, parcelRequire("k5uoT")).fontFamily)();
    const $80d528dbc2b11cbc$export$356129969ee49c55 = (0, (0, parcelRequire("k5uoT")).codeFontFamily)();
    const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
    const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
    const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
        banner: (0, (0, parcelRequire("k5uoT")).layers).navigation(),
        card: (0, (0, parcelRequire("k5uoT")).layers).card(),
        dialog: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        navigation: (0, (0, parcelRequire("k5uoT")).layers).navigation(),
        leftSidebar: (0, (0, parcelRequire("k5uoT")).layers).navigation() - 1,
        rightSidebar: (0, (0, parcelRequire("k5uoT")).layers).navigation() - 1,
        layer: (0, (0, parcelRequire("k5uoT")).layers).layer(),
        blanket: (0, (0, parcelRequire("k5uoT")).layers).blanket(),
        modal: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        flag: (0, (0, parcelRequire("k5uoT")).layers).flag(),
        spotlight: (0, (0, parcelRequire("k5uoT")).layers).spotlight(),
        tooltip: (0, (0, parcelRequire("k5uoT")).layers).tooltip(),
        mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
    };
    const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
        issueIconSize: $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 * 2
    };
});
parcelRegister("cKw8Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81c05dd6e2dcad70$export$2e2bcd8739ae039);
    var $7VHMR;
    var $81c05dd6e2dcad70$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        blue: {
            "id": "dashboard-common.blue",
            "defaultMessage": "Blue"
        },
        red: {
            "id": "dashboard-common.red",
            "defaultMessage": "Red"
        },
        yellow: {
            "id": "dashboard-common.yellow",
            "defaultMessage": "Yellow"
        },
        green: {
            "id": "dashboard-common.green",
            "defaultMessage": "Green"
        },
        teal: {
            "id": "dashboard-common.teal",
            "defaultMessage": "Teal"
        },
        purple: {
            "id": "dashboard-common.purple",
            "defaultMessage": "Purple"
        },
        gray: {
            "id": "dashboard-common.gray",
            "defaultMessage": "Gray"
        },
        white: {
            "id": "dashboard-common.white",
            "defaultMessage": "White"
        }
    });
});
const $e03099b7bef7f4cd$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $e03099b7bef7f4cd$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $e03099b7bef7f4cd$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $e03099b7bef7f4cd$export$dd4bac16c565acb1 = 'DASHBOARD_FORGE_GADGETS';
const $e03099b7bef7f4cd$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $e03099b7bef7f4cd$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';
const $e03099b7bef7f4cd$export$58e1e8808435e4be = 'AVP_DASHBOARD';
parcelRegister("04Brv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff7f8eda58c85578$export$2e2bcd8739ae039);
    var $4su49;
    var $3Yd87;
    var $1IY2I;
    var $ff7f8eda58c85578$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
            if (!sharedValue || sharedValue instanceof Error) throw new (0, (0, parcelRequire("3Yd87")).SharedValueAggregateError)({
                sharedValue: sharedValue,
                isPrefetch: isPrefetch,
                name: 'AMD modules resource'
            });
            return (async ()=>{
                const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
                const maybePromiseAmdModules = isPreloaded || await (0, (0, parcelRequire("1IY2I")).loadAmdModules)((0, (0, parcelRequire("4su49")).asyncWrmRequire), moduleNames) ? (0, (0, parcelRequire("1IY2I")).evalAmdModules)(moduleNames) : null;
                const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
                return {
                    sharedValue: sharedValue,
                    amdModules: amdModules
                };
            })();
        };
});
parcelRegister("4su49", function(module, exports) {
    $parcel$export(module.exports, "asyncWrmRequire", ()=>$ae90ef6541667ecb$export$1024fe099ca05f05);
    $parcel$export(module.exports, "asyncWrmRequireWithPrefetch", ()=>$ae90ef6541667ecb$export$3ca0de203efa570e);
    var $8JNtu;
    var $5Ik5Y;
    const $ae90ef6541667ecb$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, (0, parcelRequire("8JNtu")).wrmRequire)(resourcesToRequire);
    const $ae90ef6541667ecb$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, (0, parcelRequire("5Ik5Y")).wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);
});
parcelRegister("8JNtu", function(module, exports) {
    $parcel$export(module.exports, "wrmRequire", ()=>$17e2d7d864398bad$export$cc9d8f51375ef66a);
    var $fVOHM;
    var $fqWWz;
    const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
});
parcelRegister("fVOHM", function(module, exports) {
    $parcel$export(module.exports, "loadWrmResources", ()=>$0c0552c7bb135144$export$6cda16b6eff75f59);
    var $wRU6t;
    var $294PS;
    var $9B86Q;
    var $fqWWz;
    const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
        const isPrefetch = 'batchUrl' in options;
        let newWrmKeys = wrmKeys;
        try {
            const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
            const wrmRequireModule = await (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            });
            const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
            newWrmKeys = (0, (0, parcelRequire("294PS")).prependSuperBatchDepsOnce)(wrmKeys);
            if (isPrefetch) return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
            return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
                isSpa: __SPA__,
                wrmKeys: JSON.stringify(newWrmKeys),
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error('Unable to load wrm resource', {
                cause: error
            });
        }
    };
});
parcelRegister("wRU6t", function(module, exports) {
    $parcel$export(module.exports, "safeStringify", ()=>$7e2bd894031d4476$export$56831a8b9cb27763);
    const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
        if (!object) return '';
        if (object instanceof Error) return object.stack || object.message;
        return JSON.stringify(object, Object.getOwnPropertyNames(object));
    };
});
parcelRegister("294PS", function(module, exports) {
    $parcel$export(module.exports, "prependSuperBatchDepsOnce", ()=>$a437264dd6b89021$export$93d9db5fbabad1b0);
    var $1r4rO;
    let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
    const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
        const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
        const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
        const { pathname: pathname } = window.location;
        return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || window.location.href.includes('secure/RapidBoard.jspa');
    };
    const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
        if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
        $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
        return (0, (0, parcelRequire("1r4rO")).jiraSuperBatchDependencies).concat(wrmKeys);
    };
});
parcelRegister("1r4rO", function(module, exports) {
    $parcel$export(module.exports, "jiraSuperBatchDependencies", ()=>$e87d6a02e2466ae8$export$f14a6b583ce9e077);
    const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:util-lite',
        'wrc!jira.webresources:util',
        'wrc!jira.webresources:feature-flags',
        'wrc!jira.webresources:dialogs',
        'wrc!jira.webresources:jira-global',
        'wrc!com.atlassian.auiplugin:aui-spinner'
    ];
});
parcelRegister("9B86Q", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeWeak", ()=>$61b2a5aa3a2a1160$export$3cefda82396756a1);
    var $ifVVd;
    let $61b2a5aa3a2a1160$var$pollingSingleton = null;
    const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
        const getter = $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, (0, parcelRequire("ifVVd")).createPollingCollection)((v)=>window.require(v), 100);
        $61b2a5aa3a2a1160$var$pollingSingleton = getter;
        return getter(name);
    };
});
parcelRegister("ifVVd", function(module, exports) {
    $parcel$export(module.exports, "createPollingCollection", ()=>$60e6b0d4bc46beac$export$f163446a982a8077);
    var $gKZoD;
    var $aePFs;
    const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
        (0, (0, parcelRequire("gKZoD")).di)(setTimeout);
        let isPolling = false;
        const deferredMap = new Map();
        const promiseMap = new Map();
        const evaluateForKey = (key)=>{
            let result;
            try {
                result = fn(key);
            } catch (error) {
                return;
            }
            const deferred = deferredMap.get(key);
            if (deferred instanceof (0, (0, parcelRequire("aePFs")).default)) {
                deferred.resolve(result);
                deferredMap.delete(key);
            }
        };
        const maybePoll = ()=>{
            if (!isPolling && deferredMap.size > 0) {
                isPolling = true;
                setTimeout(()=>{
                    isPolling = false;
                    [
                        ...deferredMap.keys()
                    ].forEach(evaluateForKey);
                    maybePoll();
                }, timeout);
            }
        };
        const getter = (key)=>{
            if (!promiseMap.has(key)) {
                const deferred = new (0, (0, parcelRequire("aePFs")).default)();
                const promise = deferred.then((v)=>v);
                deferredMap.set(key, deferred);
                promiseMap.set(key, promise);
                evaluateForKey(key);
                maybePoll();
            }
            return promiseMap.get(key);
        };
        return getter;
    };
});
parcelRegister("aePFs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02f3c6551bf5b1ff$export$2e2bcd8739ae039);
    class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
        static resolve(v) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.resolve(v);
            return instance;
        }
        static reject(e) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.reject(e);
            return instance;
        }
        constructor(){
            const [fn] = Array.prototype.slice.call(arguments);
            const callbacks = [];
            super(fn ?? callbacks.push.bind(callbacks));
            this.#resolve = callbacks[0];
            this.#reject = callbacks[1];
        }
        #resolve;
        #reject;
        resolve(v) {
            this.#resolve?.(v);
        }
        reject(e) {
            this.#reject?.(e);
        }
    }
});
parcelRegister("fqWWz", function(module, exports) {
    $parcel$export(module.exports, "safeErrorWithoutCustomerData", ()=>$71bf66166926d1dc$export$f19a2d31722e3428);
    $parcel$export(module.exports, "MAX_RETRIES", ()=>$71bf66166926d1dc$export$1f86472c1374185a);
    $parcel$export(module.exports, "DEFAULT_TIMEOUT", ()=>$71bf66166926d1dc$export$7bd623b29ec8e1eb);
    $parcel$export(module.exports, "SHOULD_LOG_ERROR", ()=>$71bf66166926d1dc$export$37f20f0ff732fcd7);
    var $dJl1T;
    const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, (0, parcelRequire("dJl1T")).default);
    const $71bf66166926d1dc$export$1f86472c1374185a = 40;
    const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
    const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;
});
parcelRegister("5Ik5Y", function(module, exports) {
    $parcel$export(module.exports, "wrmRequireWithPrefetch", ()=>$a1df1daee76d40f7$export$e53a5db19a39ed2f);
    var $fVOHM;
    var $fqWWz;
    const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError,
            batchUrl: batchUrl
        });
});
parcelRegister("1IY2I", function(module, exports) {
    $parcel$export(module.exports, "loadAmdModules", ()=>$d6efeb87a1192ef7$export$2c79895bd69a8d54);
    $parcel$export(module.exports, "evalAmdModules", ()=>$d6efeb87a1192ef7$export$d74eab33af9baaea);
    var $dJl1T;
    var $JIPqS;
    class $d6efeb87a1192ef7$var$ConnectDashboardItem {
        render() {}
        renderEdit() {}
    }
    const $d6efeb87a1192ef7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
        try {
            if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
            return window.require(moduleName);
        } catch (error) {
            if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
                if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$d6efeb87a1192ef7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
            }
            throw error;
        }
    };
    const $d6efeb87a1192ef7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
        if (moduleNames.length === 0) return false;
        const prefixedAmdResources = moduleNames.map((amdModule)=>(0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
        try {
            await wrmRequire(prefixedAmdResources);
            return true;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
            return false;
        }
    };
    const $d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
    const $d6efeb87a1192ef7$export$d74eab33af9baaea = (amdModuleNames)=>{
        const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
            try {
                const module = amdModuleName === (0, (0, parcelRequire("JIPqS")).CONNECT_ITEM_AMD_MODULE) ? $d6efeb87a1192ef7$var$ConnectDashboardItem : $d6efeb87a1192ef7$export$3bf37adbbdcafcc8(amdModuleName);
                return module instanceof Promise ? module.then((v)=>[
                        amdModuleName,
                        v
                    ]) : [
                    amdModuleName,
                    module
                ];
            } catch (error) {
                return Promise.reject(error);
            }
        });
        const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
        if (!hasPromise) {
            (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
            return Object.fromEntries(tuplesOrPromises);
        }
        return Promise.allSettled(tuplesOrPromises).then((results)=>{
            const tuples = results.map((result, i)=>{
                if (result.status === 'fulfilled') return result.value;
                const { reason: error } = result;
                const amdModuleName = amdModuleNames[i];
                const message = error instanceof Error ? error.message : String(error);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
                return [
                    amdModuleName,
                    null
                ];
            });
            const failedTuples = tuples.filter((module)=>module[1] === null);
            failedTuples.length > 0 ? (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
            return Object.fromEntries(tuples);
        });
    };
});
parcelRegister("3cb5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f465c16c9ac91f45$export$2e2bcd8739ae039);
    var $65Ltd;
    var $7RGnr;
    var $2j5ho;
    var $1LNzH;
    var $hoLk6;
    var $6T8HZ;
    var $abozY;
    var $8oOn8;
    const $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
        const gadgets = configs.flatMap((config)=>config.gadgets);
        const preloadedModuleNames = (0, (0, parcelRequire("8oOn8")).gadgetsToUniqueSortedAmdModules)(gadgets);
        const wrmBundleDescriptor = await (0, (0, parcelRequire("1LNzH")).default)(preloadedModuleNames);
        return configs.map((config)=>{
            const scriptTags = [
                wrmBundleDescriptor ? (0, (0, parcelRequire("6T8HZ")).default)(wrmBundleDescriptor) : null,
                (0, (0, parcelRequire("hoLk6")).default)(config)
            ].filter(Boolean).join('\n') || null;
            return {
                ...config,
                scriptTags: scriptTags,
                preloadedModuleNames: preloadedModuleNames
            };
        });
    };
    var $f465c16c9ac91f45$export$2e2bcd8739ae039 = async (context)=>{
        const { route: route, query: query } = context;
        const originalConfigs = route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD) ? await (0, (0, parcelRequire("2j5ho")).getDashboardsConfig)(query.dashboardId) : [
            await (0, (0, parcelRequire("2j5ho")).default)((0, (0, parcelRequire("abozY")).getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, (0, parcelRequire("7RGnr")).mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames(configs);
    };
});
parcelRegister("7RGnr", function(module, exports) {
    $parcel$export(module.exports, "mapToReactGadgets", ()=>$119a071fe5fec8f8$export$c90615c5eb218d50);
    var $4R6GH;
    const $119a071fe5fec8f8$export$c90615c5eb218d50 = (gadgets)=>{
        const gadgetMapping = {
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_filter_results_gadget') ? {
                'jira-dashboard-items/filter-results': 'react/filter-results'
            } : {},
            'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_assigned_to_me_gadget') ? {
                'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_issues_in_progress_gadget') ? {
                'jira-dashboard-items/in-progress': 'react/issues-in-progress'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_voted_issues_gadget') ? {
                'jira-dashboard-items/voted': 'react/voted-issues'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_watched_issues_gadget') ? {
                'jira-dashboard-items/watched': 'react/watched-issues'
            } : {}
        };
        const isMapped = (module)=>module !== undefined && module in gadgetMapping;
        return gadgets.map((gadget)=>{
            if (isMapped(gadget.amdModule)) return {
                ...gadget,
                reactKey: gadgetMapping[gadget.amdModule],
                amdModule: undefined,
                configurable: false,
                inlineHtml: undefined
            };
            return gadget;
        });
    };
});
parcelRegister("2j5ho", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ef874ace7c3cd69$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getDashboardsConfig", ()=>$3ef874ace7c3cd69$export$1264b6af3adf5084);
    var $7f4tk;
    var $3ef874ace7c3cd69$export$2e2bcd8739ae039 = (id)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/dashboards/1.0/${id}.json`);
    const $3ef874ace7c3cd69$export$1264b6af3adf5084 = (idsCsv)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
});
parcelRegister("1LNzH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e5794ac0c0d1780$export$2e2bcd8739ae039);
    var $JIPqS;
    var $7f4tk;
    const $1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES = [
        'jira.webresources:util',
        'jira.webresources:feature-flags',
        'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
    ];
    const $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
    var $1e5794ac0c0d1780$export$2e2bcd8739ae039 = async (moduleNames)=>{
        if (moduleNames.length === 0) return Promise.resolve(null);
        const contextsToRequire = moduleNames.map((amdModule)=>(0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)[amdModule]);
        const payload = {
            r: [],
            c: [
                ...$1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES,
                ...contextsToRequire
            ],
            xc: [
                $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH
            ],
            xr: []
        };
        return (0, (0, parcelRequire("7f4tk")).default)('/rest/webResources/1.0/resources', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };
});
parcelRegister("hoLk6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9b2d88076d11343$export$2e2bcd8739ae039);
    var $JIPqS;
    var $83oax;
    var $d9b2d88076d11343$export$2e2bcd8739ae039 = (dashboardConfig)=>{
        if (dashboardConfig.gadgets.length === 0) return null;
        const prefetches = (0, (0, parcelRequire("83oax")).getPrefetches)(dashboardConfig);
        const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
        const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
        if (preloadLinks != null && syncPrefetchUrls.length > 0) {
            const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, (0, parcelRequire("JIPqS")).PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, (0, parcelRequire("JIPqS")).PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
            return preloadLinks + fetchScript;
        }
        return preloadLinks;
    };
});
parcelRegister("83oax", function(module, exports) {
    $parcel$export(module.exports, "getPrefetches", ()=>$6e3ee08c53b7707c$export$3144db3718ad5e57);
    var $bT0sh;
    const $6e3ee08c53b7707c$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
        const lookup = (0, (0, parcelRequire("bT0sh")).getPrefetchDict)();
        return gadgets.flatMap((gadget)=>{
            const identifier = gadget.amdModule;
            const prefechProp = identifier != null ? lookup[identifier] : undefined;
            if (!prefechProp || !prefechProp.enabled) return [];
            const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
            return func(gadget).map((url)=>({
                    url: url,
                    priority: priority,
                    isSyncLoadingSupported: isSyncLoadingSupported
                }));
        });
    };
});
parcelRegister("bT0sh", function(module, exports) {
    $parcel$export(module.exports, "getPrefetchDict", ()=>$e3f3a590c57f26d7$export$244cea94cab19e07);
    var $4R6GH;
    var $ltNbR;
    var $8lc67;
    var $cdUf4;
    const $e3f3a590c57f26d7$export$244cea94cab19e07 = ()=>({
            'jira-dashboard-items/activitystream': {
                func: (0, (0, parcelRequire("8lc67")).getActivityStreamPrefetchLink),
                priority: (0, (0, parcelRequire("ltNbR")).LOADING_PRIORITY).HIGH,
                enabled: true,
                isSyncLoadingSupported: ()=>false
            },
            'jira-dashboard-items/filter-results': {
                func: (0, (0, parcelRequire("cdUf4")).getFilterResultsPrefetchLink),
                priority: (0, (0, parcelRequire("ltNbR")).LOADING_PRIORITY).LOW,
                enabled: !(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_filter_results_gadget'),
                isSyncLoadingSupported: ()=>true
            }
        });
});
parcelRegister("ltNbR", function(module, exports) {
    $parcel$export(module.exports, "LOADING_PRIORITY", ()=>$5a106311215627b2$export$cb9b1f2232733c1b);
    const $5a106311215627b2$export$cb9b1f2232733c1b = {
        HIGH: 'preload',
        LOW: 'prefetch'
    };
});
parcelRegister("8lc67", function(module, exports) {
    $parcel$export(module.exports, "getActivityStreamPrefetchLink", ()=>$cadf517d0dd42b8b$export$360928f5bf059a9e);
    var $ebyGx = parcelRequire("ebyGx");
    const $cadf517d0dd42b8b$var$replacer = (match, part1)=>String.fromCharCode(part1);
    const $cadf517d0dd42b8b$var$getDateValue = (dateValue, operatorLower)=>{
        const dateStr = `${dateValue}`;
        const operator = operatorLower.toUpperCase();
        let dateArr;
        if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
        else if (operator === 'BETWEEN') dateArr = [
            dateValue,
            dateValue
        ];
        else dateArr = [
            dateValue
        ];
        return dateArr.map((date, index)=>{
            const dateInt = parseInt(date, 10);
            if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1;
            return dateInt;
        }).join(' ');
    };
    const $cadf517d0dd42b8b$var$handleSpecialCases = (rule)=>{
        let { value: value, operator: operator } = rule;
        const { type: type } = rule;
        if (Array.isArray(value)) {
            const encodedValues = [];
            value.forEach((val)=>{
                encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
            });
            value = encodedValues.join(' ');
        }
        if (type === 'date') {
            if (operator === 'is') operator = 'between';
            value = $cadf517d0dd42b8b$var$getDateValue(value, operator);
            if (value.indexOf('NaN') !== -1) return {};
        } else if (type === 'list' || type === 'user') {
            value = value.replace(/,/g, ' ');
            value = value.replace(/_/g, '\\_');
        }
        return {
            value: value,
            operator: operator
        };
    };
    const $cadf517d0dd42b8b$var$getParamsFromRules = (rules)=>{
        const params = {};
        const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $cadf517d0dd42b8b$var$replacer)))?.providers || [];
        const enabledProviders = [];
        providers.forEach((provider)=>{
            const providerKey = provider.provider;
            const { rules: providerRules } = provider;
            const stringifiedRules = [];
            if (!provider.disabled) {
                if (providerKey !== 'streams') enabledProviders.push(providerKey);
                providerRules.forEach((rule)=>{
                    const modifiedRuleObj = $cadf517d0dd42b8b$var$handleSpecialCases(rule);
                    const { operator: operator, value: value } = modifiedRuleObj;
                    if (operator && value) stringifiedRules.push([
                        rule.rule,
                        operator.toUpperCase(),
                        value
                    ].join(' '));
                });
                params[providerKey] = stringifiedRules;
            }
        });
        if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
        return params;
    };
    const $cadf517d0dd42b8b$export$3d7deb7cf8a9de04 = (gadget)=>{
        const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
                field.name,
                field.value
            ]) ?? []);
        const params = {
            maxResults: prefs.numofentries ?? 25,
            relativeLinks: true,
            ...prefs.rules ? $cadf517d0dd42b8b$var$getParamsFromRules(prefs.rules) : {}
        };
        return (0, ($parcel$interopDefault($ebyGx))).stringify(params).replace(/%20/g, '+');
    };
    const $cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
    const $cadf517d0dd42b8b$export$360928f5bf059a9e = (gadgetData)=>{
        const paramStr = $cadf517d0dd42b8b$export$3d7deb7cf8a9de04(gadgetData);
        return [
            `/${$cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
        ];
    };
});
parcelRegister("cdUf4", function(module, exports) {
    $parcel$export(module.exports, "getFilterResultsPrefetchLink", ()=>$7e69dbaeb4189994$export$947cd90004054337);
    var $ebyGx = parcelRequire("ebyGx");
    const $7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
    const $7e69dbaeb4189994$export$947cd90004054337 = (gadgetData)=>{
        const { properties: properties } = gadgetData.context.dashboardItem;
        const data = {
            num: properties.num,
            tableContext: 'jira.table.cols.dashboard',
            addDefault: false,
            columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
            enableSorting: true,
            paging: true,
            showActions: true,
            filterId: undefined,
            jql: undefined,
            sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
            startIndex: properties.startIndex ? properties.startIndex : 0
        };
        let queryType = '';
        if (properties.filterId) {
            queryType = 'filter';
            Object.assign(data, {
                filterId: properties.filterId
            });
        } else if (properties.jql) {
            queryType = 'jql';
            Object.assign(data, {
                jql: properties.jql
            });
        }
        const paramStr = (0, ($parcel$interopDefault($ebyGx))).stringify(data, {
            sort: false
        }).replace(/%20/g, '+');
        const preloadUrl = `/${$7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
        return [
            preloadUrl
        ];
    };
});
parcelRegister("6T8HZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c547330881220e9$export$2e2bcd8739ae039);
    var $8c547330881220e9$export$2e2bcd8739ae039 = (response)=>{
        let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
        response.resources.forEach((resource)=>{
            const { url: url, resourceType: resourceType, key: key } = resource;
            if (resourceType === 'CSS') {
                const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
                resourceHtml += cssResource;
            } else {
                const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
                resourceHtml += jsResource;
            }
        });
        return resourceHtml;
    };
});
parcelRegister("8oOn8", function(module, exports) {
    $parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", ()=>$d83f51a78c4f458b$export$598e0ea2a7525181);
    $parcel$export(module.exports, "gadgetsToSortedReactGadgets", ()=>$d83f51a78c4f458b$export$f98787198c197952);
    var $JIPqS;
    var $kspzT;
    const $d83f51a78c4f458b$export$598e0ea2a7525181 = (gadgets)=>gadgets.map(({ amdModule: amdModule })=>amdModule).filter(Boolean).filter((amdModule)=>amdModule in (0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
    const $d83f51a78c4f458b$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
            if (!(0, (0, parcelRequire("kspzT")).isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
            gadgetsAccumulator.push({
                reactKey: gadget.reactKey,
                id: gadget.id,
                userPrefs: gadget.userPrefs
            });
            return gadgetsAccumulator;
        }, []).sort((a, b)=>a.id.localeCompare(b.id));
});
parcelRegister("kspzT", function(module, exports) {
    $parcel$export(module.exports, "isReactKey", ()=>$7a81ea406ace6c08$export$6acd06c99f745b49);
    $parcel$export(module.exports, "default", ()=>$7a81ea406ace6c08$export$2e2bcd8739ae039);
    var $9zbBl;
    var $kvkwL;
    var $26UOd;
    const $7a81ea406ace6c08$var$GADGETS_DEFINITION = {
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).FILTER_RESULTS]: (0, (0, parcelRequire("kvkwL")).FILTER_RESULTS_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).ASSIGNED_TO_ME]: (0, (0, parcelRequire("kvkwL")).ASSIGNED_TO_ME_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).ISSUES_IN_PROGRESS]: (0, (0, parcelRequire("kvkwL")).ISSUES_IN_PROGRESS_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).VOTED_ISSUES]: (0, (0, parcelRequire("kvkwL")).VOTED_ISSUES_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).WATCHED_ISSUES]: (0, (0, parcelRequire("kvkwL")).WATCHED_ISSUES_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).CUSTOM_REPORT]: (0, (0, parcelRequire("9zbBl")).default)
    };
    function $7a81ea406ace6c08$export$6acd06c99f745b49(key) {
        return !!(key && Object.values((0, (0, parcelRequire("26UOd")).REACT_KEY)).includes(key));
    }
    var $7a81ea406ace6c08$export$2e2bcd8739ae039 = $7a81ea406ace6c08$var$GADGETS_DEFINITION;
});
parcelRegister("9zbBl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$088534adc4ba7ffc$export$2e2bcd8739ae039);
    var $cDOH2;
    var $jUheV;
    var $gM7kh;
    const $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION = {
        componentView: (0, (0, parcelRequire("jUheV")).LazyCustomReportGadgetView),
        componentEdit: (0, (0, parcelRequire("cDOH2")).LazyCustomReportGadgetEdit),
        getInitialState: (0, parcelRequire("gM7kh")).default,
        preload: (0, parcelRequire("jUheV")).preload
    };
    var $088534adc4ba7ffc$export$2e2bcd8739ae039 = $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION;
});
parcelRegister("cDOH2", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomReportGadgetEdit", ()=>$e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116);
    var $kxZPA;
    const $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8CO5O")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
    });
});
parcelRegister("8CO5O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("3Na4y")
    ]).then(()=>parcelRequire('chhAm'));
});
parcelRegister("jUheV", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomReportGadgetView", ()=>$e43675722e4e42c6$export$27df795d4f3ff173);
    $parcel$export(module.exports, "preload", ()=>$e43675722e4e42c6$export$513ccb98c53b8039);
    var $kxZPA;
    const $e43675722e4e42c6$export$27df795d4f3ff173 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5b6PY")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
    });
    const { preload: $e43675722e4e42c6$export$513ccb98c53b8039 } = $e43675722e4e42c6$export$27df795d4f3ff173;
});
parcelRegister("5b6PY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fBPHr").then(()=>parcelRequire('e2l8c'));
});
parcelRegister("gM7kh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1132aa73a645b93$export$2e2bcd8739ae039);
    const $d1132aa73a645b93$var$getInitialState = ()=>Promise.resolve({
            intervalValue: '1',
            isCustom: 'false',
            projectValue: '0',
            refresh: 'false',
            reportValue: '0',
            gadgetContentTitle: ''
        });
    var $d1132aa73a645b93$export$2e2bcd8739ae039 = $d1132aa73a645b93$var$getInitialState;
});
parcelRegister("kvkwL", function(module, exports) {
    $parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", ()=>$676d00abfb59f2ab$export$3581891d04da6bb8);
    $parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", ()=>$676d00abfb59f2ab$export$652d5a9cc2c18d2e);
    $parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", ()=>$676d00abfb59f2ab$export$54b46348d1ed5d22);
    $parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", ()=>$676d00abfb59f2ab$export$ea96ce30d34ce354);
    $parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", ()=>$676d00abfb59f2ab$export$5109728db227eae);
    var $5uXOq = parcelRequire("5uXOq");
    var $2egG3;
    var $eZ5lN;
    var $kdIR9;
    var $dzPNh;
    var $9KhHm;
    var $5ALJk;
    var $hfHPa;
    const $676d00abfb59f2ab$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                state: props.state ? {
                    ...props.state,
                    ...additionalStateProps
                } : null
            });
    const $676d00abfb59f2ab$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                state: props.state ? {
                    ...props.state,
                    ...additionalStateProps
                } : null
            });
    const $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG = {
        testId: 'react-issue-table-gadgets.filter-results.view'
    };
    const $676d00abfb59f2ab$export$3581891d04da6bb8 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
        componentEdit: (0, (0, parcelRequire("eZ5lN")).FilterResultsGadgetEdit),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG = {
        predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
        defaultSortPrefs: {
            field: 'priority',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.assigned-to-me.view'
    };
    const $676d00abfb59f2ab$export$652d5a9cc2c18d2e = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("2egG3")).AssignedToMeGadgetEdit), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG = {
        predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
        defaultSortPrefs: {
            field: 'priority',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.issues-in-progress.view'
    };
    const $676d00abfb59f2ab$export$54b46348d1ed5d22 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("kdIR9")).IssuesInProgressGadgetEdit), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG = {
        predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
        predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
        defaultSortPrefs: {
            field: 'votes',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.voted-issues.view'
    };
    const $676d00abfb59f2ab$export$ea96ce30d34ce354 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("9KhHm")).VotedIssuesGadgetEdit), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG = {
        predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
        predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
        defaultSortPrefs: {
            field: 'watchers',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.watched-issues.view'
    };
    const $676d00abfb59f2ab$export$5109728db227eae = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("5ALJk")).WatchedIssuesGadgetEdit), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
});
parcelRegister("2egG3", function(module, exports) {
    $parcel$export(module.exports, "AssignedToMeGadgetEdit", ()=>$91d75e80303bba8c$export$3ae3568d16dc8f35);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("40Sx2")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
    });
    const $91d75e80303bba8c$export$3ae3568d16dc8f35 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "assigned-to-me-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit, props));
    const { preload: $91d75e80303bba8c$export$513ccb98c53b8039 } = $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit;
});
parcelRegister("834mM", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsEditSkeleton", ()=>$92b82de956011a8a$export$e10d91ce257e7374);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $cuyZg = parcelRequire("cuyZg");
    const $92b82de956011a8a$var$customCssStyles = null;
    const $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
    const $92b82de956011a8a$export$e10d91ce257e7374 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($cuyZg))),
            containerStyles: {
                height: $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("cuyZg", function(module, exports) {
    module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();
});
parcelRegister("40Sx2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("a1jim")
    ]).then(()=>parcelRequire('1SEAb'));
});
parcelRegister("eZ5lN", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsGadgetEdit", ()=>$fa7c1c640e166488$export$6dfceca003c43832);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9Plb0")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
    });
    const $fa7c1c640e166488$export$6dfceca003c43832 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "filter-results-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fa7c1c640e166488$var$LazyFilterResultsGadgetEdit, props));
    const { preload: $fa7c1c640e166488$export$513ccb98c53b8039 } = $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit;
});
parcelRegister("9Plb0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2WaJa")
    ]).then(()=>parcelRequire('eKgKX'));
});
parcelRegister("kdIR9", function(module, exports) {
    $parcel$export(module.exports, "IssuesInProgressGadgetEdit", ()=>$04f85077310bce7f$export$199fec410a0f70a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gK4xy")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
    });
    const $04f85077310bce7f$export$199fec410a0f70a2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issues-in-progress-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit, props));
    const { preload: $04f85077310bce7f$export$513ccb98c53b8039 } = $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit;
});
parcelRegister("gK4xy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("lNlvX")
    ]).then(()=>parcelRequire('dk51x'));
});
parcelRegister("dzPNh", function(module, exports) {
    $parcel$export(module.exports, "IssueTableGadgetView", ()=>$0c0c24e495111ec5$export$da0765a3c10e16a3);
    $parcel$export(module.exports, "preload", ()=>$0c0c24e495111ec5$export$513ccb98c53b8039);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $lfTZh;
    var $dNZVN;
    var $kxZPA;
    const $0c0c24e495111ec5$var$LazyIssueTableGadgetView = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4J2zw")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
    });
    const $0c0c24e495111ec5$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "filter-results-gadget-view",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dNZVN")).FilterResultsIssueTableSkeleton), {
                height: `${customSkeletonHeightInPx ?? (0, (0, parcelRequire("JIPqS")).GADGET_DEFAULT_HEIGHT)}px`
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0c0c24e495111ec5$var$LazyIssueTableGadgetView, {
            customSkeletonHeightInPx: customSkeletonHeightInPx,
            ...props
        }));
    const { preload: $0c0c24e495111ec5$export$513ccb98c53b8039 } = $0c0c24e495111ec5$var$LazyIssueTableGadgetView;
});
parcelRegister("dNZVN", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsIssueTableSkeleton", ()=>$a73c71eae267b518$export$35d754053deeac73);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $dCGjE = parcelRequire("dCGjE");
    const $a73c71eae267b518$var$customCssStyles = null;
    const $a73c71eae267b518$export$35d754053deeac73 = ({ height: height })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($dCGjE))),
            containerStyles: {
                height: height
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("dCGjE", function(module, exports) {
    module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();
});
parcelRegister("4J2zw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kLRoU")
    ]).then(()=>parcelRequire('dfMo9'));
});
parcelRegister("9KhHm", function(module, exports) {
    $parcel$export(module.exports, "VotedIssuesGadgetEdit", ()=>$0ca7bf6a0d6f5346$export$7650b85a7a54914);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2Bzr9")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
    });
    const $0ca7bf6a0d6f5346$export$7650b85a7a54914 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "voted-issues-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit, props));
    const { preload: $0ca7bf6a0d6f5346$export$513ccb98c53b8039 } = $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit;
});
parcelRegister("2Bzr9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bNNoR")
    ]).then(()=>parcelRequire('irHWu'));
});
parcelRegister("5ALJk", function(module, exports) {
    $parcel$export(module.exports, "WatchedIssuesGadgetEdit", ()=>$278dbe55a7acf378$export$a53864bd0bf8a85f);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lGwmd")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
    });
    const $278dbe55a7acf378$export$a53864bd0bf8a85f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "watched-issues-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit, props));
    const { preload: $278dbe55a7acf378$export$513ccb98c53b8039 } = $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit;
});
parcelRegister("lGwmd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("h7Bte")
    ]).then(()=>parcelRequire('iLll9'));
});
parcelRegister("hfHPa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f27ae6f4005fc53$export$2e2bcd8739ae039);
    var $fJpBG;
    var $lgZ6q;
    var $8rq2P;
    var $jyMtv;
    const $9f27ae6f4005fc53$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
            if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
            const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
            const validUserPrefs = (0, (0, parcelRequire("jyMtv")).transformToValidUserPrefs)((0, (0, parcelRequire("fJpBG")).decodeUserPreferences)(userPrefs));
            if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
            const sortPrefs = (()=>{
                if (validUserPrefs.sortField) return {
                    sortField: validUserPrefs.sortField,
                    sortDirection: validUserPrefs.sortDirection
                };
                if (defaultSortPrefs) return {
                    sortField: defaultSortPrefs.field,
                    sortDirection: defaultSortPrefs.direction
                };
            })();
            const includeResolved = validUserPrefs.showResolved;
            const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
            const queryReference = await (0, (0, parcelRequire("8rq2P")).loadQueryWithUserPrefs)({
                ...validUserPrefs,
                ...sortPrefs
            }, (0, (0, parcelRequire("lgZ6q")).default), cloudId, activationId, 'store-and-network', jql);
            return {
                queryReference: queryReference,
                predeterminedJql: predeterminedJql,
                defaultSortPrefs: defaultSortPrefs,
                testId: testId
            };
        };
    var $9f27ae6f4005fc53$export$2e2bcd8739ae039 = $9f27ae6f4005fc53$var$createGetInitialState;
});
parcelRegister("fJpBG", function(module, exports) {
    $parcel$export(module.exports, "getUserPreferences", ()=>$a6145919a3771254$export$ae3f5fa351e2f57a);
    $parcel$export(module.exports, "decodeUserPreferences", ()=>$a6145919a3771254$export$ebdfc6c2778ef8e2);
    var $7f4tk;
    const $a6145919a3771254$var$isBooleanString = (str)=>[
            'true',
            'false'
        ].includes(str.toLowerCase().trim());
    const $a6145919a3771254$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
    const $a6145919a3771254$export$ae3f5fa351e2f57a = (action)=>(0, (0, parcelRequire("7f4tk")).default)(action);
    const $a6145919a3771254$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
                ...output,
                [name]: $a6145919a3771254$var$isBooleanString(value) ? $a6145919a3771254$var$stringToBoolean(value) : value
            }), {});
});
parcelRegister("lgZ6q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$328d775330990290$export$2e2bcd8739ae039);
    var $hLeia;
    var $6nwMW;
    var $1ZvTA;
    var $G39h7;
    var $6vKPN;
    var $1kHcz;
    const $328d775330990290$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "amountOfColumns"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldSetIds"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterId"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isNotFilterFetch"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueTypeId"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "namespace"
        }, v11 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }, v12 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryFieldSetsById"
        }, v13 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewId"
        }, v14 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v15 = {
            "kind": "ScalarField",
            "name": "key"
        }, v16 = {
            "kind": "ScalarField",
            "name": "id"
        }, v17 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v18 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v19 = {
            "kind": "ScalarField",
            "name": "statusCategoryId"
        }, v20 = {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v19,
                v16
            ]
        }, v21 = {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        }, v22 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }, v23 = {
            "kind": "ScalarField",
            "name": "type"
        }, v24 = {
            "kind": "ScalarField",
            "name": "fieldSetId"
        }, v25 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJiraIssueField"
        }, v26 = {
            "kind": "ScalarField",
            "name": "name"
        }, v27 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceConnection",
                    "kind": "LinkedField",
                    "name": "selectedAffectedServicesConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedServiceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraAffectedService",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "serviceId"
                                        },
                                        v26,
                                        v16
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraAffectedServicesField"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectConnection",
                    "kind": "LinkedField",
                    "name": "selectedCmdbObjectsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraCmdbObject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "objectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "concreteType": "JiraCmdbAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                            "kind": "LinkedField",
                                                            "name": "mediaClientConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "clientId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaBaseUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaJwtToken"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url48"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraCMDBField"
        }, v29 = [
            v26,
            v16
        ], v30 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraComponentConnection",
                    "kind": "LinkedField",
                    "name": "selectedComponentsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraComponentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraComponent",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v29
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraComponentsField"
        }, v31 = {
            "kind": "ScalarField",
            "name": "date"
        }, v32 = {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }, v33 = {
            "kind": "ScalarField",
            "name": "lazyIsEditableInIssueView"
        }, v34 = {
            "kind": "ClientExtension",
            "selections": [
                v33
            ]
        }, v35 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }, v36 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraEpic",
                    "kind": "LinkedField",
                    "name": "epic",
                    "plural": false,
                    "selections": [
                        v15,
                        {
                            "kind": "ScalarField",
                            "name": "summary"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        v16
                    ]
                }
            ],
            "type": "JiraEpicLinkField"
        }, v37 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "renderedFieldHtml"
                }
            ],
            "type": "JiraFallbackField"
        }, v38 = {
            "kind": "ScalarField",
            "name": "text"
        }, v39 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        v26,
                        v19,
                        v16
                    ]
                }
            ],
            "type": "JiraStatusCategoryField"
        }, v40 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        v26,
                        {
                            "kind": "ScalarField",
                            "name": "statusId"
                        },
                        v20,
                        v16
                    ]
                }
            ],
            "type": "JiraStatusField"
        }, v41 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v42 = {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "selectedLabelsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraLabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraLabel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v26
                            ]
                        }
                    ]
                },
                v41
            ],
            "storageKey": "selectedLabelsConnection(first:1000)"
        }, v43 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        },
                        v26,
                        v16
                    ]
                }
            ],
            "type": "JiraIssueTypeField"
        }, v44 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v45 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "parentIssue",
                    "plural": false,
                    "selections": [
                        v15,
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "summaryField",
                            "plural": false,
                            "selections": [
                                v38,
                                v16
                            ]
                        },
                        v16,
                        {
                            "concreteType": "JiraColorField",
                            "kind": "LinkedField",
                            "name": "issueColorField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraColor",
                                    "kind": "LinkedField",
                                    "name": "color",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorKey"
                                        },
                                        v16
                                    ]
                                },
                                v16
                            ]
                        },
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v44,
                                        v26,
                                        v16
                                    ]
                                },
                                v16
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraParentIssueField"
        }, v46 = {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                v26,
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                v16
            ]
        }, v47 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        v26,
                        v15,
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        v16
                    ]
                }
            ],
            "type": "JiraProjectField"
        }, v48 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraResolution",
                    "kind": "LinkedField",
                    "name": "resolution",
                    "plural": false,
                    "selections": v29
                }
            ],
            "type": "JiraResolutionField"
        }, v49 = {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v16,
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                v26,
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v50 = {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v17,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                v26,
                v16,
                {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                }
            ]
        }, v51 = {
            "kind": "InlineFragment",
            "selections": [
                v26,
                {
                    "concreteType": "JiraVersionConnection",
                    "kind": "LinkedField",
                    "name": "selectedVersionsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraVersionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v29
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraMultipleVersionPickerField"
        }, v52 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "richText",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraADF",
                            "kind": "LinkedField",
                            "name": "adfValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "json"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraRichTextField"
        }, v53 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraServiceManagementRequestType",
                    "kind": "LinkedField",
                    "name": "requestType",
                    "plural": false,
                    "selections": [
                        v26,
                        v44,
                        v16
                    ]
                }
            ],
            "type": "JiraServiceManagementRequestTypeField"
        }, v54 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                        }
                    ],
                    "concreteType": "JiraIssueLinkConnection",
                    "kind": "LinkedField",
                    "name": "issueLinkConnection",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v41
                            ]
                        },
                        {
                            "concreteType": "JiraIssueLinkEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v15,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "statusCategory"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v20
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        v16
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                },
                                                v16
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "relationName"
                                        },
                                        v16
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraIssueLinkField"
        }, v55 = {
            "kind": "ScalarField",
            "name": "isStoryPointField"
        }, v56 = {
            "kind": "ScalarField",
            "name": "number"
        }, v57 = [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v23,
                            v24,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v17,
                                                    v18,
                                                    v23,
                                                    v25,
                                                    v16,
                                                    v27,
                                                    v28,
                                                    v30,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v31,
                                                            v26,
                                                            v32,
                                                            v34
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    v35,
                                                    v36,
                                                    v37,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v38,
                                                            v26,
                                                            v34
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    v39,
                                                    v40,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v42,
                                                            v26,
                                                            v34
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    v43,
                                                    v45,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v46,
                                                            v26,
                                                            v34
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    v47,
                                                    v48,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49,
                                                            v26,
                                                            v34
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v50,
                                                            v26,
                                                            v32,
                                                            v34
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    v51,
                                                    v52,
                                                    v53,
                                                    v54,
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v55,
                                                                    v56,
                                                                    v26,
                                                                    v34
                                                                ],
                                                                "type": "JiraNumberField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v58 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        v21,
                        v22
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsById",
                    "plural": false,
                    "selections": v57
                }
            ]
        }, v59 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "issueType",
                                            "variableName": "issueTypeId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "project",
                                            "variableName": "projectId"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "projectContext"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "filterId",
                            "variableName": "filterId"
                        },
                        v22,
                        {
                            "kind": "Variable",
                            "name": "namespace",
                            "variableName": "namespace"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsForIssueSearchView",
                    "plural": false,
                    "selections": v57
                }
            ]
        }, v60 = [
            {
                "kind": "ScalarField",
                "name": "cursor"
            },
            {
                "kind": "ScalarField",
                "name": "pageNumber"
            },
            {
                "kind": "ScalarField",
                "name": "isCurrent"
            }
        ], v61 = {
            "kind": "ScalarField",
            "name": "displayName"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13
                ],
                "kind": "Fragment",
                "name": "issueTableViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "issueTableView_reactIssueTableGadgets"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v8,
                    v10,
                    v13,
                    v1,
                    v3,
                    v12,
                    v0,
                    v6,
                    v4,
                    v7,
                    v5,
                    v9,
                    v11,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "issueTableViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "after",
                                        "variableName": "after"
                                    },
                                    v14,
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "first"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issueSearchStable",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v15,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "issueId"
                                                    },
                                                    v16,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isResolved"
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "ids",
                                                                "value": [
                                                                    "status"
                                                                ]
                                                            }
                                                        ],
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v17,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v18,
                                                                                    {
                                                                                        "concreteType": "JiraStatus",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "status",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v20,
                                                                                            v16
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraStatusField"
                                                                            },
                                                                            v16
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"status\"])"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasChildren"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            v58,
                                                            v59
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            v58,
                                                            v59,
                                                            {
                                                                "kind": "ClientExtension",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueFieldSetConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueRowFieldSets",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldSetEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldSet",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v23,
                                                                                            v24,
                                                                                            {
                                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "fields",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "edges",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v17,
                                                                                                                    v18,
                                                                                                                    v23,
                                                                                                                    v25,
                                                                                                                    v16,
                                                                                                                    v27,
                                                                                                                    v28,
                                                                                                                    v30,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v31,
                                                                                                                            v33,
                                                                                                                            v26,
                                                                                                                            v32
                                                                                                                        ],
                                                                                                                        "type": "JiraDatePickerField"
                                                                                                                    },
                                                                                                                    v35,
                                                                                                                    v36,
                                                                                                                    v37,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v38,
                                                                                                                            v33,
                                                                                                                            v26
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                                    },
                                                                                                                    v39,
                                                                                                                    v40,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v42,
                                                                                                                            v33,
                                                                                                                            v26
                                                                                                                        ],
                                                                                                                        "type": "JiraLabelsField"
                                                                                                                    },
                                                                                                                    v43,
                                                                                                                    v45,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v33,
                                                                                                                            v46,
                                                                                                                            v26
                                                                                                                        ],
                                                                                                                        "type": "JiraPriorityField"
                                                                                                                    },
                                                                                                                    v47,
                                                                                                                    v48,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v33,
                                                                                                                            v49,
                                                                                                                            v26
                                                                                                                        ],
                                                                                                                        "type": "JiraSprintField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v50,
                                                                                                                            v33,
                                                                                                                            v26,
                                                                                                                            v32
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                                                    },
                                                                                                                    v51,
                                                                                                                    v52,
                                                                                                                    v53,
                                                                                                                    v54,
                                                                                                                    {
                                                                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                                                                        "kind": "Condition",
                                                                                                                        "passingValue": true,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "InlineFragment",
                                                                                                                                "selections": [
                                                                                                                                    v55,
                                                                                                                                    v56,
                                                                                                                                    v33,
                                                                                                                                    v26
                                                                                                                                ],
                                                                                                                                "type": "JiraNumberField"
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isHighlightedIssueRow"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v17
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalIssueSearchResultCount"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isCappingIssueSearchResult"
                                    },
                                    {
                                        "concreteType": "JiraIssueNavigatorPageInfo",
                                        "kind": "LinkedField",
                                        "name": "issueNavigatorPageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "firstIssuePosition"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "lastIssuePosition"
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "maxCursors",
                                                "value": 7
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "pageSize",
                                                "variableName": "first"
                                            }
                                        ],
                                        "concreteType": "JiraPageCursors",
                                        "kind": "LinkedField",
                                        "name": "pageCursors",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "first",
                                                "plural": false,
                                                "selections": v60
                                            },
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "around",
                                                "plural": true,
                                                "selections": v60
                                            },
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "last",
                                                "plural": false,
                                                "selections": v60
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v14,
                                    v21
                                ],
                                "concreteType": "JiraIssueSearchFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSetsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueSearchFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueSearchFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v24,
                                                    v23,
                                                    v61,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jqlTerm"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isSortable"
                                                    },
                                                    {
                                                        "concreteType": "JiraFieldSetPreferences",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSetPreferences",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "width"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraFieldType",
                                                        "kind": "LinkedField",
                                                        "name": "fieldType",
                                                        "plural": false,
                                                        "selections": [
                                                            v61
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v41
                                ]
                            },
                            {
                                "condition": "isNotFilterFetch",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "filterAri"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "filter",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            v26,
                                            {
                                                "kind": "ScalarField",
                                                "name": "jql"
                                            },
                                            v16
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "d0173260fc5c9f16207ffc07716b612993e694a5d18686ade83d1b9ffb9244bc",
                "metadata": {},
                "name": "issueTableViewQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, (0, parcelRequire("6nwMW")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, (0, parcelRequire("6vKPN")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, (0, parcelRequire("1kHcz")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider": (0, (0, parcelRequire("hLeia")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, (0, parcelRequire("G39h7")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, (0, parcelRequire("1ZvTA")).default)
                }
            }
        };
    }();
    $328d775330990290$var$node.hash = "8891cc5970ec5dda89c557d11236c0df";
    var $328d775330990290$export$2e2bcd8739ae039 = $328d775330990290$var$node;
});
parcelRegister("hLeia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a923685b3e947cff$export$2e2bcd8739ae039);
    var $4R6GH;
    const $a923685b3e947cff$export$8a1714fad3e3d003 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('cmdb_field_avatar_issue_table_from_media');
        }
    };
    var $a923685b3e947cff$export$2e2bcd8739ae039 = $a923685b3e947cff$export$8a1714fad3e3d003;
});
parcelRegister("6nwMW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f1a5d4fbd61a98a$export$2e2bcd8739ae039);
    var $4R6GH;
    var $7f1a5d4fbd61a98a$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jsc_-_m2_hierarchy_api_updates');
        }
    };
});
parcelRegister("1ZvTA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d6cdb57bd1e2ae2$export$2e2bcd8739ae039);
    var $4R6GH;
    var $2d6cdb57bd1e2ae2$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nin-issue-links-entry-point') ? 1 : 1000;
        }
    };
});
parcelRegister("G39h7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21fc1eb961f329e9$export$2e2bcd8739ae039);
    var $4R6GH;
    var $21fc1eb961f329e9$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nin-issue-links-entry-point');
        }
    };
});
parcelRegister("6vKPN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea3753541dd030fd$export$2e2bcd8739ae039);
    var $4R6GH;
    var $ea3753541dd030fd$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jira_spreadsheet_component_m1_api_updates');
        }
    };
});
parcelRegister("1kHcz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f1be49b7b7e3e3c$export$2e2bcd8739ae039);
    var $4R6GH;
    var $9f1be49b7b7e3e3c$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nike_chin_story_points_inline_edit');
        }
    };
});
parcelRegister("8rq2P", function(module, exports) {
    $parcel$export(module.exports, "loadQueryWithUserPrefs", ()=>$3de2b9db429d32f1$export$700e212b8b5c678f);
    var $8Uumt = parcelRequire("8Uumt");
    var $5yJb9;
    var $kipqU;
    var $2mSjU;
    async function $3de2b9db429d32f1$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
        const { variables: variables } = await (0, (0, parcelRequire("2mSjU")).transformToVariables)({
            userPrefs: {
                filterId: filterId,
                columnNames: columnNames,
                num: num,
                sortField: sortField,
                sortDirection: sortDirection
            },
            cloudId: cloudId,
            activationId: activationId,
            jql: jql
        });
        const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables, {
            fetchPolicy: fetchPolicy
        });
        if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});
parcelRegister("2mSjU", function(module, exports) {
    $parcel$export(module.exports, "transformToVariables", ()=>$1eea58ad38e5fdd1$export$a5cefa50115212b3);
    var $axGKd;
    var $czfFt;
    var $t3Q07;
    var $796ok;
    const $1eea58ad38e5fdd1$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
        const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
        const filterAri = !jql && filterId ? (0, (0, parcelRequire("axGKd")).JiraFilterAri).create({
            filterId: filterId,
            siteId: cloudId,
            activationId: activationId
        }).toString() : '';
        const variables = {
            cloudId: cloudId,
            issueSearchInput: {
                ...jql ? {
                    jql: jql
                } : {
                    filterId: filterId
                }
            },
            after: null,
            first: num,
            fieldSetIds: columnNames,
            amountOfColumns: (0, (0, parcelRequire("czfFt")).MAX_COLUMNS),
            shouldQueryFieldSetsById: true,
            isNotFilterFetch: !filterAri,
            filterAri: filterAri
        };
        let fieldToJqlTermMap = new Map();
        if (!sortField || !sortDirection || ![
            'ASC',
            'DESC'
        ].includes(sortDirection)) return {
            variables: variables,
            fieldToJqlTermMap: fieldToJqlTermMap
        };
        let jqlToModify = jql;
        if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
            const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
            fieldToJqlTermMap = result.fieldToJqlTermMap;
            jqlToModify = result.searchJql;
        }
        if (!jqlToModify) return {
            variables: variables,
            fieldToJqlTermMap: fieldToJqlTermMap
        };
        const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
            (parcelRequire("aH9Ys")),
            (parcelRequire("dbjD6")),
            (parcelRequire("6nHQF"))
        ]);
        const jqlUtils = new JqlUtils();
        const jqlTermForSortField = (0, (0, parcelRequire("796ok")).getJqlTermForField)(sortField, fieldToJqlTermMap);
        const modifiedJql = jqlUtils.jql(jqlToModify);
        const oldPrimarySortField = modifiedJql.getPrimarySortField();
        if (oldPrimarySortField) {
            const aliases = (0, (0, parcelRequire("t3Q07")).getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
            const inclusiveAliases = Array.from(new Set([
                ...aliases,
                oldPrimarySortField
            ]));
            modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
        } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
        let finalJql = modifiedJql.jqlString;
        if (showResolved) {
            const jast = modifiedJql.jast;
            if (jast) {
                const statusClause = findClauseInAst(jast, 'statusCategory');
                if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
            }
        }
        return {
            variables: {
                ...variables,
                issueSearchInput: {
                    jql: finalJql
                }
            },
            fieldToJqlTermMap: fieldToJqlTermMap
        };
    };
});
parcelRegister("czfFt", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$7f8ee02f08da8eac$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$7f8ee02f08da8eac$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "SORT_ASC", ()=>$7f8ee02f08da8eac$export$88956207daf9a17e);
    $parcel$export(module.exports, "SORT_DESC", ()=>$7f8ee02f08da8eac$export$bc14f97913aaf2a);
    $parcel$export(module.exports, "SORT_NONE", ()=>$7f8ee02f08da8eac$export$9c424bf3e8ffe64e);
    $parcel$export(module.exports, "MODIFY_COLUMNS", ()=>$7f8ee02f08da8eac$export$1f921c78ce6d243c);
    $parcel$export(module.exports, "REORDER_COLUMNS", ()=>$7f8ee02f08da8eac$export$83371d6c41a974aa);
    $parcel$export(module.exports, "MOVE_COLUMN_FIRST", ()=>$7f8ee02f08da8eac$export$957d455bb65919d8);
    $parcel$export(module.exports, "MOVE_COLUMN_LEFT", ()=>$7f8ee02f08da8eac$export$2082861c970802b0);
    $parcel$export(module.exports, "MOVE_COLUMN_RIGHT", ()=>$7f8ee02f08da8eac$export$21847d308b0769ad);
    $parcel$export(module.exports, "MOVE_COLUMN_LAST", ()=>$7f8ee02f08da8eac$export$c32913bc261af82d);
    $parcel$export(module.exports, "ROW_HEIGHT", ()=>$7f8ee02f08da8eac$export$88e6c5bab2ff80e8);
    $parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", ()=>$7f8ee02f08da8eac$export$de4c02b525d877fa);
    $parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", ()=>$7f8ee02f08da8eac$export$c3266da279aa6b84);
    $parcel$export(module.exports, "COLUMN_ID_CHECKBOX", ()=>$7f8ee02f08da8eac$export$66b2a4a5f67468ac);
    $parcel$export(module.exports, "ACTION_COLUMNS", ()=>$7f8ee02f08da8eac$export$3dbdc5c16825be4d);
    $parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", ()=>$7f8ee02f08da8eac$export$a1c171a82c45d53f);
    $parcel$export(module.exports, "EXPAND_CELL_PADDING", ()=>$7f8ee02f08da8eac$export$9c5dd6078b37aac2);
    $parcel$export(module.exports, "MAX_COLUMNS", ()=>$7f8ee02f08da8eac$export$7ec4af037f372df4);
    $parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", ()=>$7f8ee02f08da8eac$export$d2372dfbd4e91a11);
    $parcel$export(module.exports, "KNOWN_COLUMN_TYPES", ()=>$7f8ee02f08da8eac$export$bbc2e8c301f97f97);
    $parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", ()=>$7f8ee02f08da8eac$export$1adf7afff96bbf16);
    $parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", ()=>$7f8ee02f08da8eac$export$10016003aa27fa67);
    $parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$5575b9e0ed3ff59f);
    $parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$7c3f559e2ca95fa);
    $parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$e1a42c2fefb5af25);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", ()=>$7f8ee02f08da8eac$export$bfe09a9186b98f8f);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", ()=>$7f8ee02f08da8eac$export$f2540f34b796306d);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", ()=>$7f8ee02f08da8eac$export$954afb0fcf5a326);
    $parcel$export(module.exports, "COLUMN_OPERATION_REORDER", ()=>$7f8ee02f08da8eac$export$93758649595b2d58);
    $parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", ()=>$7f8ee02f08da8eac$export$cad8c6a0b6e78898);
    $parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", ()=>$7f8ee02f08da8eac$export$754b76ac8fa63350);
    $parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", ()=>$7f8ee02f08da8eac$export$fa5c7dad7ee16383);
    $parcel$export(module.exports, "DENSITY_COMPACT", ()=>$7f8ee02f08da8eac$export$6c0a5a77457ca62);
    $parcel$export(module.exports, "DENSITY_FULL", ()=>$7f8ee02f08da8eac$export$119d8ab9a5bc4b2);
    $parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", ()=>$7f8ee02f08da8eac$export$9ef77944c441ad07);
    $parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", ()=>$7f8ee02f08da8eac$export$c1f680390b97c9e1);
    $parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$e03155205bf92428);
    $parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$311c64c0d94dcdf3);
    $parcel$export(module.exports, "ANALYTICS_SOURCE", ()=>$7f8ee02f08da8eac$export$f7109619a5e9e0d6);
    const $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
    const $7f8ee02f08da8eac$export$d57b6b390e78d90f = 'empanada';
    const $7f8ee02f08da8eac$export$88956207daf9a17e = 'ASC';
    const $7f8ee02f08da8eac$export$bc14f97913aaf2a = 'DESC';
    const $7f8ee02f08da8eac$export$9c424bf3e8ffe64e = 'NONE';
    const $7f8ee02f08da8eac$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
    const $7f8ee02f08da8eac$export$83371d6c41a974aa = 'REORDER_COLUMNS';
    const $7f8ee02f08da8eac$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
    const $7f8ee02f08da8eac$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
    const $7f8ee02f08da8eac$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
    const $7f8ee02f08da8eac$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
    const $7f8ee02f08da8eac$export$e2bd4c1faded7921 = '1px';
    const $7f8ee02f08da8eac$export$cdb7fd9d999c7168 = 40;
    const $7f8ee02f08da8eac$export$88e6c5bab2ff80e8 = 40;
    const $7f8ee02f08da8eac$export$d5120333bf67ced2 = ()=>"var(--ds-space-300, 24px)";
    const $7f8ee02f08da8eac$export$a3c854b50595c804 = ()=>"var(--ds-space-050, 4px)";
    const $7f8ee02f08da8eac$export$de4c02b525d877fa = '__issuetable_internal_meatball';
    const $7f8ee02f08da8eac$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
    const $7f8ee02f08da8eac$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
    const $7f8ee02f08da8eac$export$3dbdc5c16825be4d = [
        $7f8ee02f08da8eac$export$c3266da279aa6b84,
        $7f8ee02f08da8eac$export$de4c02b525d877fa
    ];
    const $7f8ee02f08da8eac$export$a1c171a82c45d53f = 24;
    const $7f8ee02f08da8eac$export$9c5dd6078b37aac2 = 16;
    const $7f8ee02f08da8eac$export$7ec4af037f372df4 = 500;
    const $7f8ee02f08da8eac$export$d2372dfbd4e91a11 = 50;
    const $7f8ee02f08da8eac$export$bbc2e8c301f97f97 = {
        ASSIGNEE: 'assignee',
        CHECKBOX: '__issuetable_internal_checkbox',
        DESCRIPTION: 'description',
        ENVIRONMENT: 'environment',
        EXPAND_BUTTON: '__issuetable_internal_expand_button',
        ISSUE_KEY: 'issuekey',
        ISSUE_OPERATIONS: '__issuetable_internal_meatball',
        STATUS: 'status',
        SUMMARY: 'summary',
        ISSUE_TYPE: 'issuetype',
        RESOLUTION: 'resolution',
        PARENT: 'parent',
        LABELS: 'labels',
        COMPONENTS: 'components',
        FIX_VERSIONS: 'fixVersions',
        STATUS_CATEGORY: 'statusCategory',
        PROJECT: 'project',
        READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
        SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
        TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
        EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
        CREATED: 'created',
        RESOLUTION_DATE: 'resolutiondate',
        TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
        UPDATED: 'updated',
        DUE_DATE: 'duedate',
        REPORTER: 'reporter',
        CREATOR: 'creator',
        PRIORITY: 'priority',
        AFFECTS_VERSIONS: 'versions',
        REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
        NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
        STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points'
    };
    const $7f8ee02f08da8eac$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $7f8ee02f08da8eac$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $7f8ee02f08da8eac$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
    const $7f8ee02f08da8eac$export$10016003aa27fa67 = 40;
    const $7f8ee02f08da8eac$export$5575b9e0ed3ff59f = 69;
    const $7f8ee02f08da8eac$export$7c3f559e2ca95fa = 170;
    const $7f8ee02f08da8eac$export$e1a42c2fefb5af25 = 999;
    const $7f8ee02f08da8eac$export$bfe09a9186b98f8f = 400;
    const $7f8ee02f08da8eac$export$f2540f34b796306d = 300;
    const $7f8ee02f08da8eac$export$954afb0fcf5a326 = 450;
    const $7f8ee02f08da8eac$export$93758649595b2d58 = 'reorder';
    const $7f8ee02f08da8eac$export$cad8c6a0b6e78898 = 'resize';
    const $7f8ee02f08da8eac$export$754b76ac8fa63350 = 'FULL_HEIGHT';
    const $7f8ee02f08da8eac$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
    const $7f8ee02f08da8eac$export$6c0a5a77457ca62 = 'COMPACT';
    const $7f8ee02f08da8eac$export$119d8ab9a5bc4b2 = 'FULL';
    const $7f8ee02f08da8eac$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
    const $7f8ee02f08da8eac$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
    const $7f8ee02f08da8eac$export$e03155205bf92428 = 'loadChildItems';
    const $7f8ee02f08da8eac$export$311c64c0d94dcdf3 = 'LoadMoreChildItems';
    const $7f8ee02f08da8eac$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
});
parcelRegister("t3Q07", function(module, exports) {
    $parcel$export(module.exports, "getAliasesForField", ()=>$a3816529ae558e1d$export$94d69942fbe58a01);
    const $a3816529ae558e1d$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
        let term = fieldToJqlTermMap.get(field);
        if (term === undefined) {
            for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
                term = keyValuePair[1];
                break;
            }
        }
        if (term === undefined) return [];
        const set = new Set();
        set.add(term);
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
        return Array.from(set);
    };
});
parcelRegister("796ok", function(module, exports) {
    $parcel$export(module.exports, "getJqlTermForField", ()=>$ad837b869bddcad8$export$ef4e8b2c9bc7bd4d);
    var $bCU3R;
    const $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
        const convertedField = (0, (0, parcelRequire("bCU3R")).convertFieldToJqlTerm)(field);
        const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
        return jqlTermForField;
    };
});
parcelRegister("bCU3R", function(module, exports) {
    $parcel$export(module.exports, "convertFieldToJqlTerm", ()=>$1e1011370a3a12e2$export$29f734dc2c61ea9d);
    const $1e1011370a3a12e2$export$29f734dc2c61ea9d = (fieldName)=>{
        if (/^customfield_\d+$/.test(fieldName)) {
            const customFieldId = fieldName.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        return fieldName;
    };
});
parcelRegister("aH9Ys", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dsheJ").then(()=>parcelRequire('aWG9Z'));
});
parcelRegister("dbjD6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OMFw").then(()=>parcelRequire('eWn4R'));
});
parcelRegister("6nHQF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kK5xY").then(()=>parcelRequire('ajrrh'));
});
parcelRegister("jyMtv", function(module, exports) {
    $parcel$export(module.exports, "transformToValidUserPrefs", ()=>$8cfaebab7e294873$export$e9345b021afd3cc3);
    var $hwva3;
    var $Z4X9T;
    var $hCluT;
    const $8cfaebab7e294873$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
        const pageSize = parseInt(rawUserPrefs.num, 10);
        const fieldSetIds = (0, (0, parcelRequire("hwva3")).convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
        const stringifiedFilterId = `${rawUserPrefs.filterId}`;
        const { sortDirection: sortDirection, sortField: sortField } = (0, (0, parcelRequire("Z4X9T")).getSortFieldAndDirection)(rawUserPrefs.sortBy);
        const showResolved = !!rawUserPrefs.showResolved;
        return {
            filterId: (0, (0, parcelRequire("hCluT")).isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
            columnNames: fieldSetIds,
            num: !Number.isNaN(pageSize) ? pageSize : 10,
            sortDirection: sortDirection,
            sortField: sortField,
            showResolved: showResolved
        };
    };
});
parcelRegister("hwva3", function(module, exports) {
    $parcel$export(module.exports, "convertUserPrefsToColumnNames", ()=>$ffa5f3be2fc11704$export$6e5cdc232ebb20cf);
    var $JIPqS;
    const $ffa5f3be2fc11704$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $e997f85ca70fa8bf$export$952287cc7aef3a4c), (0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d))) : (0, (0, parcelRequire("JIPqS")).ISSUE_SEARCH_DEFAULT_COLUMNS);
});
const $e997f85ca70fa8bf$export$dd03181e30c7d559 = 5;
const $e997f85ca70fa8bf$export$a3d4af30107c4f4d = '|';
const $e997f85ca70fa8bf$export$952287cc7aef3a4c = '%7C';
parcelRegister("Z4X9T", function(module, exports) {
    $parcel$export(module.exports, "getSortFieldAndDirection", ()=>$834bd6f85e4a1e0d$export$e535bb2dfaa4d10b);
    const $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
        const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
        if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
        return {
            sortField: sortField,
            sortDirection: sortDirection
        };
    };
});
parcelRegister("hCluT", function(module, exports) {
    $parcel$export(module.exports, "isFilterId", ()=>$39fbd6b125bd3cbf$export$23be85030bd58047);
    const $39fbd6b125bd3cbf$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);
});
parcelRegister("26UOd", function(module, exports) {
    $parcel$export(module.exports, "REACT_KEY", ()=>$c373d1a6bf5d7ef6$export$e0e89108956f58f6);
    const $c373d1a6bf5d7ef6$export$c8ae0b83405368ed = 'react/filter-results';
    const $c373d1a6bf5d7ef6$export$d473668bb8826dfe = 'react/assigned-to-me';
    const $c373d1a6bf5d7ef6$export$e079ced6d62149e8 = 'react/issues-in-progress';
    const $c373d1a6bf5d7ef6$export$28c72363adc3f53a = 'react/voted-issues';
    const $c373d1a6bf5d7ef6$export$99faee4082b644a = 'react/watched-issues';
    const $c373d1a6bf5d7ef6$export$25f168992476ecb5 = 'react/custom-report';
    const $c373d1a6bf5d7ef6$export$e0e89108956f58f6 = {
        FILTER_RESULTS: $c373d1a6bf5d7ef6$export$c8ae0b83405368ed,
        ASSIGNED_TO_ME: $c373d1a6bf5d7ef6$export$d473668bb8826dfe,
        ISSUES_IN_PROGRESS: $c373d1a6bf5d7ef6$export$e079ced6d62149e8,
        VOTED_ISSUES: $c373d1a6bf5d7ef6$export$28c72363adc3f53a,
        WATCHED_ISSUES: $c373d1a6bf5d7ef6$export$99faee4082b644a,
        CUSTOM_REPORT: $c373d1a6bf5d7ef6$export$25f168992476ecb5
    };
});
parcelRegister("aVFmC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31463ce0406b73cb$export$2e2bcd8739ae039);
    var $eusud;
    var $31463ce0406b73cb$export$2e2bcd8739ae039 = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/config/1.0/directoryitems.json');
});
parcelRegister("3Zhqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1c788e303134293$export$2e2bcd8739ae039);
    var $5IKQ6;
    var $kspzT;
    var $3Yd87;
    var $kGR9w;
    var $b1c788e303134293$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
            if (!sharedValue || sharedValue instanceof Error) throw new (0, (0, parcelRequire("3Yd87")).SharedValueAggregateError)({
                sharedValue: sharedValue,
                isPrefetch: isPrefetch,
                name: 'AMD modules resource'
            });
            return (async ()=>{
                const { reactGadgets: nextGadgets } = sharedValue;
                const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
                const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
                const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                    const isConfigurable = !!(0, (0, parcelRequire("kspzT")).default)[gadget.reactKey].componentEdit;
                    const isUnconfigured = isConfigurable && !(0, (0, parcelRequire("5IKQ6")).isGadgetConfigured)(gadget.userPrefs);
                    return !prev[gadget.id] && !isUnconfigured;
                });
                const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
                const reactGadgetsState = {
                    ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                            id,
                            prev[id]
                        ])),
                    ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                            id,
                            {}
                        ])),
                    ...await (0, (0, parcelRequire("kGR9w")).loadReactGadgets)(gadgetsToLoad, spaContext)
                };
                return {
                    sharedValue: sharedValue,
                    reactGadgetsState: reactGadgetsState
                };
            })();
        };
});
parcelRegister("5IKQ6", function(module, exports) {
    $parcel$export(module.exports, "isGadgetConfigured", ()=>$ce7e823be599a5b0$export$b625fae487818738);
    const $ce7e823be599a5b0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;
});
parcelRegister("kGR9w", function(module, exports) {
    $parcel$export(module.exports, "loadReactGadgets", ()=>$ae0204181dcaff49$export$7e1a3455761184a2);
    var $kspzT;
    const $ae0204181dcaff49$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
            (0, (0, parcelRequire("kspzT")).default)[reactKey].preload();
        });
    const $ae0204181dcaff49$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
        const distinctReactKeys = [
            ...new Set(gadgets.map((gadget)=>gadget.reactKey))
        ];
        $ae0204181dcaff49$var$preloadGadgetBundles(distinctReactKeys);
        return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>(0, (0, parcelRequire("kspzT")).default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                    id,
                    state
                ], (error)=>[
                    id,
                    error
                ]))));
    };
});
parcelRegister("94QFg", function(module, exports) {
    $parcel$export(module.exports, "dashboardRoute", ()=>$0f4773b5d6aa4f26$export$3bf0ecb39349b6ef);
    $parcel$export(module.exports, "selectedDashboardRoute", ()=>$0f4773b5d6aa4f26$export$b32070ee9554c3fb);
    $parcel$export(module.exports, "dashboardEditRoute", ()=>$0f4773b5d6aa4f26$export$b6e00d2cd7369fbd);
    $parcel$export(module.exports, "dashboardWallboardRoute", ()=>$0f4773b5d6aa4f26$export$eaa33c953ab9ca63);
    $parcel$export(module.exports, "dashboardViewRoute", ()=>$0f4773b5d6aa4f26$export$24f1b2ff97b9d3e6);
    $parcel$export(module.exports, "dashboardViewEmbedRoute", ()=>$0f4773b5d6aa4f26$export$258b5e3f294617d2);
    $parcel$export(module.exports, "systemDashboardEditRoute", ()=>$0f4773b5d6aa4f26$export$7367fb465296c7dd);
    var $65Ltd;
    const $0f4773b5d6aa4f26$export$3bf0ecb39349b6ef = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD),
        path: '/secure/Dashboard.jspa'
    };
    const $0f4773b5d6aa4f26$export$b32070ee9554c3fb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_SELECTED),
        path: '/secure/Dashboard.jspa',
        query: [
            'selectPageId'
        ]
    };
    const $0f4773b5d6aa4f26$export$b6e00d2cd7369fbd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_EDIT),
        path: '/jira/dashboards/:dashboardId(\\d+)/edit',
        query: [
            'maximized?'
        ],
        exact: true
    };
    const $0f4773b5d6aa4f26$export$eaa33c953ab9ca63 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD),
        path: '/jira/dashboards/wallboard',
        query: [
            'dashboardId',
            'cyclePeriod?',
            'transitionFx?',
            'random?'
        ],
        exact: true
    };
    const $0f4773b5d6aa4f26$export$24f1b2ff97b9d3e6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW),
        path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
        query: [
            'maximized?'
        ],
        exact: true
    };
    const $0f4773b5d6aa4f26$export$258b5e3f294617d2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW_EMBED),
        path: '/jira/dashboards/:dashboardId(\\d+)/embed',
        query: [],
        exact: true
    };
    const $0f4773b5d6aa4f26$export$7367fb465296c7dd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT),
        path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
        query: [
            'maximized?'
        ]
    };
});
parcelRegister("5lVAv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gsMi3")
    ]).then(()=>parcelRequire('iqENN'));
});
parcelRegister("dtemB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hXx3W")
    ]).then(()=>parcelRequire('9aF4A'));
});
parcelRegister("2yGxE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("luD3r")
    ]).then(()=>parcelRequire('7ykDM'));
});
parcelRegister("ixqoJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9VuHS")
    ]).then(()=>parcelRequire('7AfLj'));
});
parcelRegister("atP20", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8AY7a")
    ]).then(()=>parcelRequire('3VYlm'));
});
parcelRegister("3cUWj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aS4l7")
    ]).then(()=>parcelRequire('kGKHk'));
});
parcelRegister("bPjHb", function(module, exports) {
    $parcel$export(module.exports, "boardsDirectoryResource", ()=>$817f387e86427323$export$2646f173fa2c14f2);
    var $kbVA4;
    var $dIdda = parcelRequire("dIdda");
    const $817f387e86427323$export$2646f173fa2c14f2 = (0, $dIdda.createResource)({
        type: (0, $ee6731a28d0b2341$export$87526c4bd9c78abc),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("4stqG")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $ee6731a28d0b2341$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';
parcelRegister("4stqG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5815h").then(()=>parcelRequire('goVIR'));
});
parcelRegister("4s7hB", function(module, exports) {
    $parcel$export(module.exports, "boardsDirectoryRoute", ()=>$77dc14d95c28fe1d$export$f0fc6f4e8be87e85);
    $parcel$export(module.exports, "boardsDirectoryRedirectRoute", ()=>$77dc14d95c28fe1d$export$a4fba1ebd6ba91ee);
    var $65Ltd;
    const $77dc14d95c28fe1d$export$f0fc6f4e8be87e85 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY),
        path: '/jira/boards'
    };
    const $77dc14d95c28fe1d$export$a4fba1ebd6ba91ee = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY)}-redirect`,
        path: '/secure/ManageRapidViews.jspa'
    };
});
parcelRegister("3iOSp", function(module, exports) {
    $parcel$export(module.exports, "BoardsDirectorySkeleton", ()=>$05eb234c240fc9e8$export$8194d6e87709f042);
    $parcel$export(module.exports, "DashboardsDirectorySkeleton", ()=>$05eb234c240fc9e8$export$75ef2bfed3801fb1);
    $parcel$export(module.exports, "FiltersDirectorySkeleton", ()=>$05eb234c240fc9e8$export$e76f94817327da1);
    $parcel$export(module.exports, "ProjectsDirectorySkeleton", ()=>$05eb234c240fc9e8$export$d94befb0e231760c);
    $parcel$export(module.exports, "PlansDirectorySkeleton", ()=>$05eb234c240fc9e8$export$6cd26a09efd6d158);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $5SWcj = parcelRequire("5SWcj");
    var $8Ta6q = parcelRequire("8Ta6q");
    var $4vyYK = parcelRequire("4vyYK");
    var $4653I = parcelRequire("4653I");
    const $05eb234c240fc9e8$export$8194d6e87709f042 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($5SWcj)))
        });
    const $05eb234c240fc9e8$export$75ef2bfed3801fb1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8Ta6q)))
        });
    const $05eb234c240fc9e8$export$e76f94817327da1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4vyYK)))
        });
    const $05eb234c240fc9e8$export$d94befb0e231760c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4653I)))
        });
    const $05eb234c240fc9e8$export$6cd26a09efd6d158 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4653I)))
        });
});
parcelRegister("5SWcj", function(module, exports) {
    module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();
});
parcelRegister("8Ta6q", function(module, exports) {
    module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();
});
parcelRegister("4vyYK", function(module, exports) {
    module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();
});
parcelRegister("4653I", function(module, exports) {
    module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();
});
parcelRegister("1Xk9t", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("as2Yi")
    ]).then(()=>parcelRequire('3geiu'));
});
parcelRegister("4yCf0", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryResource", ()=>$c9ec3cc3b6c0608d$export$1cf6c7815471c2a2);
    var $kbVA4;
    var $dIdda = parcelRequire("dIdda");
    const $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';
    const $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2 = (0, $dIdda.createResource)({
        type: $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("heoI0")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
parcelRegister("heoI0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("yne3O").then(()=>parcelRequire('ciD6c'));
});
parcelRegister("3zTeb", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryRoute", ()=>$ce3faeb59dd926fb$export$41bba408475cab16);
    $parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", ()=>$ce3faeb59dd926fb$export$b96f6fb3c35a6fe5);
    var $65Ltd;
    const $ce3faeb59dd926fb$export$41bba408475cab16 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        path: '/jira/dashboards'
    };
    const $ce3faeb59dd926fb$export$b96f6fb3c35a6fe5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
        path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
    };
});
parcelRegister("bEh2s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("e9jXk")
    ]).then(()=>parcelRequire('76rrf'));
});
parcelRegister("dRl24", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryResource", ()=>$8b127055fac893b8$export$53f99086c62225b6);
    var $kbVA4;
    var $dIdda = parcelRequire("dIdda");
    const $8b127055fac893b8$export$53f99086c62225b6 = (0, $dIdda.createResource)({
        type: (0, $6d3ffd6df613c846$export$79e191bf6cb15284),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("1EVqG")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $6d3ffd6df613c846$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';
parcelRegister("1EVqG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8fxmU").then(()=>parcelRequire('cK9UE'));
});
parcelRegister("13DBR", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryRoute", ()=>$4b1900cd8840fb6b$export$6350f52c8b40042d);
    $parcel$export(module.exports, "filtersDirectoryRedirectRoute", ()=>$4b1900cd8840fb6b$export$f4f86e1ddc30a625);
    $parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", ()=>$4b1900cd8840fb6b$export$50796f2aecd63181);
    var $65Ltd;
    const $4b1900cd8840fb6b$export$6350f52c8b40042d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        path: '/jira/filters'
    };
    const $4b1900cd8840fb6b$export$f4f86e1ddc30a625 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY)}-redirect`,
        path: '/ManageFilters.jspa'
    };
    const $4b1900cd8840fb6b$export$50796f2aecd63181 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY_SECURE)}-redirect`,
        path: '/secure/ManageFilters.jspa'
    };
});
parcelRegister("4D5lh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7rph3")
    ]).then(()=>parcelRequire('3Zqmb'));
});
parcelRegister("4TyVn", function(module, exports) {
    $parcel$export(module.exports, "plansDirectoryRoute", ()=>$ed241e9e9a1b449e$export$143b4a1ef2ffc051);
    var $65Ltd;
    const $ed241e9e9a1b449e$export$143b4a1ef2ffc051 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY),
        path: '/jira/plans'
    };
});
parcelRegister("lBR19", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5XLCy")
    ]).then(()=>parcelRequire('flZBd'));
});
parcelRegister("hsmeR", function(module, exports) {
    $parcel$export(module.exports, "useActiveRightSidebarState", ()=>$39a48ee662f10943$export$ba763ab7661c3103);
    $parcel$export(module.exports, "useRightSidebarState", ()=>$39a48ee662f10943$export$d1828e7f46a4960b);
    $parcel$export(module.exports, "useRightSidebarController", ()=>$39a48ee662f10943$export$ebe5e907fb0bb63a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7JoAD = parcelRequire("7JoAD");
    var $byk51;
    var $5e5zm;
    const $39a48ee662f10943$var$useActiveRightSidebar = (0, $7JoAD.createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>{
            const rightSidebarState = (0, (0, parcelRequire("byk51")).selectCurrentRightSidebar)(state.content.rightSidebar);
            if (!rightSidebarState) return null;
            return {
                ...rightSidebarState,
                shouldRender: !state.isChromeless
            };
        }
    });
    const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
        const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
        return rightSidebar;
    };
    const $39a48ee662f10943$var$useRightSidebar = (0, $7JoAD.createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.content.rightSidebar
    });
    const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
        const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
        return rightSidebarState;
    };
    const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
        const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        return (0, $5uXOq.useMemo)(()=>({
                setRightSidebarState: setRightSidebarState,
                closeRightSidebar: closeRightSidebar,
                openRightSidebar: openRightSidebar,
                closeCurrentRightSidebar: closeCurrentRightSidebar,
                closeAllRightSidebar: closeAllRightSidebar,
                minimiseRightSidebar: minimiseRightSidebar
            }), [
            closeAllRightSidebar,
            closeCurrentRightSidebar,
            closeRightSidebar,
            openRightSidebar,
            setRightSidebarState,
            minimiseRightSidebar
        ]);
    };
});
parcelRegister("byk51", function(module, exports) {
    $parcel$export(module.exports, "selectCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$57758d0cfaeec2c);
    $parcel$export(module.exports, "setRightSidebarState", ()=>$4dabd377b098e1a2$export$f5584170a8c1db02);
    $parcel$export(module.exports, "closeAllRightSidebar", ()=>$4dabd377b098e1a2$export$d91a6e55d52aa3e9);
    $parcel$export(module.exports, "closeCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$a9a5075d3d1b2165);
    $parcel$export(module.exports, "closeRightSidebar", ()=>$4dabd377b098e1a2$export$d7149233c76efb32);
    $parcel$export(module.exports, "minimiseRightSidebar", ()=>$4dabd377b098e1a2$export$4eedf7fa26a2749a);
    $parcel$export(module.exports, "openRightSidebar", ()=>$4dabd377b098e1a2$export$c8dafe074328c4ca);
    var $ajpes = parcelRequire("ajpes");
    const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
        const arrayCopy = [
            ...array
        ];
        const f = arrayCopy.splice(oldIndex, 1)[0];
        arrayCopy.splice(newIndex, 0, f);
        return arrayCopy;
    };
    const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
        const visited = {};
        return stackState.filter((item)=>{
            if (visited[item.panelId]) return false;
            visited[item.panelId] = true;
            return true;
        });
    };
    const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
        if (state.stackState.length === 1) return state.stackState[0];
        return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
    };
    const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: []
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            if (!currentStack.length) return;
            const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
            if (!currentRightSidebar) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.filter((item)=>item.panelId !== panelId)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.map((item)=>{
                            if (item.panelId !== panelId) return item;
                            return {
                                ...item,
                                isMinimised: true
                            };
                        })
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
                ...content.rightSidebar.stackState.map((item)=>{
                    if (item.panelId === panelId) return {
                        ...item,
                        isMinimised: isMinimised,
                        width: width
                    };
                    return item;
                })
            ] : [];
            const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
            if (matchedPanelIndex >= 0) {
                const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
                tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
                tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
                const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
                newRightSidebarStackStateValue[nextIdx].width = width;
                setState({
                    content: {
                        ...content,
                        rightSidebar: {
                            stackState: newRightSidebarStackStateValue
                        }
                    }
                });
                return;
            }
            const newRightSidebarStackStateValue = toTop ? [
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                },
                ...tempRightSidebarStackStateValue
            ] : [
                ...tempRightSidebarStackStateValue,
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                }
            ];
            if ((0, ($parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
        };
});
parcelRegister("5e5zm", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$0c99a19d69d506cf$export$539e68c09584883a);
    $parcel$export(module.exports, "layoutStore", ()=>$0c99a19d69d506cf$export$b8cdfd44cddaf07);
    $parcel$export(module.exports, "useLayoutStoreActions", ()=>$0c99a19d69d506cf$export$6136bc3b9858cff4);
    $parcel$export(module.exports, "useDetailPanelWidth", ()=>$0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
    $parcel$export(module.exports, "useDetailPanelActions", ()=>$0c99a19d69d506cf$export$99e05a60cac05e86);
    var $7JoAD = parcelRequire("7JoAD");
    var $8CM3x;
    const $0c99a19d69d506cf$export$539e68c09584883a = 240;
    const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
    const $0c99a19d69d506cf$var$initialState = {
        isChromeless: false,
        isFullscreen: false,
        banner: {
            height: 0,
            activeBanner: null
        },
        topNavigation: {
            isVisible: true
        },
        leftPanel: {
            isVisible: true,
            width: 0
        },
        rightPanel: {
            isVisible: true,
            width: 0
        },
        bottomRightCorner: {
            container: undefined,
            portals: []
        },
        content: {
            leftSidebar: {
                width: $0c99a19d69d506cf$export$539e68c09584883a,
                isCollapsed: true,
                isVisible: true,
                isFlyoutOpen: false
            },
            rightSidebar: {
                stackState: []
            }
        }
    };
    const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $7JoAD.createStore)({
        initialState: $0c99a19d69d506cf$var$initialState,
        actions: (0, parcelRequire("8CM3x")).actions,
        name: 'JiraLayoutStore'
    });
    const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $7JoAD.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
        selector: null
    });
    const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $7JoAD.createStore)({
        name: 'detailPanelWidth',
        initialState: {
            width: 0
        },
        actions: {
            setWidth: (value)=>({ setState: setState })=>{
                    setState({
                        width: value
                    });
                }
        }
    });
    const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $7JoAD.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
    const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $7JoAD.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
});
parcelRegister("8CM3x", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$939ad82f8ddcb8d9$export$e324594224ef24da);
    var $4oU0I;
    var $flhve;
    var $f5TQt;
    var $hPsAX;
    var $gqQUV;
    var $byk51;
    const $939ad82f8ddcb8d9$export$e324594224ef24da = {
        setIsChromeless: (0, parcelRequire("f5TQt")).setIsChromeless,
        setIsFullscreen: (0, parcelRequire("hPsAX")).setIsFullscreen,
        showBanner: (0, parcelRequire("4oU0I")).showBanner,
        dismissCurrentBanner: (0, parcelRequire("4oU0I")).dismissCurrentBanner,
        setLeftSidebarState: (0, parcelRequire("gqQUV")).setLeftSidebarState,
        setRightSidebarState: (0, parcelRequire("byk51")).setRightSidebarState,
        openRightSidebar: (0, parcelRequire("byk51")).openRightSidebar,
        closeRightSidebar: (0, parcelRequire("byk51")).closeRightSidebar,
        closeAllRightSidebar: (0, parcelRequire("byk51")).closeAllRightSidebar,
        closeCurrentRightSidebar: (0, parcelRequire("byk51")).closeCurrentRightSidebar,
        minimiseRightSidebar: (0, parcelRequire("byk51")).minimiseRightSidebar,
        registerBottomRightCornerContainer: (0, parcelRequire("flhve")).registerBottomRightCornerContainer,
        insertBottomRightCornerPortal: (0, parcelRequire("flhve")).insertBottomRightCornerPortal,
        removeBottomRightCornerPortal: (0, parcelRequire("flhve")).removeBottomRightCornerPortal
    };
});
parcelRegister("4oU0I", function(module, exports) {
    $parcel$export(module.exports, "showBanner", ()=>$820929f36789bf81$export$f5c0eb035ef26e87);
    $parcel$export(module.exports, "dismissCurrentBanner", ()=>$820929f36789bf81$export$a45bccc0cc9ac424);
    const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
            setState({
                banner: newState
            });
        };
    const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
            dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
                height: 0,
                activeBanner: null
            }));
        };
});
parcelRegister("flhve", function(module, exports) {
    $parcel$export(module.exports, "registerBottomRightCornerContainer", ()=>$560ff4740e75fa9e$export$2992ecf780497763);
    $parcel$export(module.exports, "insertBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$3ed25a6bee272520);
    $parcel$export(module.exports, "removeBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$928bf7e228ce06d2);
    const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    container: ref ?? undefined
                }
            });
        };
    const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            const sorted = [
                item,
                ...portals
            ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
            const index = sorted.findIndex((portal)=>portal.id === item.id);
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: sorted
                }
            });
            return index;
        };
    const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: portals.filter((portal)=>portal.id !== id)
                }
            });
        };
});
parcelRegister("f5TQt", function(module, exports) {
    $parcel$export(module.exports, "setIsChromeless", ()=>$0389a2d5715d1f25$export$1998c4816ad37edb);
    const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
            setState({
                isChromeless: isChromeless
            });
        };
});
parcelRegister("hPsAX", function(module, exports) {
    $parcel$export(module.exports, "setIsFullscreen", ()=>$e3c9e6899dc6b3f0$export$9c73b2f282069160);
    const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
            setState({
                isFullscreen: isFullscreen
            });
        };
});
parcelRegister("gqQUV", function(module, exports) {
    $parcel$export(module.exports, "setLeftSidebarState", ()=>$54ca906cbb882b25$export$3e0fd2d894ef83c8);
    const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    leftSidebar: {
                        ...content.leftSidebar,
                        ...newState
                    }
                }
            });
        };
});
parcelRegister("7XluA", function(module, exports) {
    $parcel$export(module.exports, "JiraEntryPointContainer", ()=>$f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
    $parcel$export(module.exports, "NestedEntryPointContainer", ()=>$f4c300dcb0cbacff$export$54db9e88249c9162);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Bm0k;
    var $c5vfY;
    const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
        const entryPointReference = (0, (0, parcelRequire("8Bm0k")).useEntryPointSubscription)(entryPointReferenceSubject);
        return entryPointReference ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            placeholderName: "jira-entry-point-container"
        }) : null;
    };
    const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer);
});
parcelRegister("8Bm0k", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointSubscription", ()=>$0458c70c3d6616bf$export$3cd1c81e13390c49);
    var $5uXOq = parcelRequire("5uXOq");
    const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
        const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = subject.subscribe(setEntryPointReference);
            setEntryPointReference(subject.getValue());
            return unsubscribe;
        }, [
            subject
        ]);
        return entryPointReference;
    };
});
parcelRegister("c5vfY", function(module, exports) {
    $parcel$export(module.exports, "InternalEntryPointContainer", ()=>$df42b2d5b5551f77$export$5d4dc37edd8a3adb);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $39xOx;
    var $lfTZh;
    var $l8ruj;
    const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: id,
            packageName: packageName,
            teamName: teamName,
            attributes: errorAttributes,
            fallback: errorFallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: placeholderName ?? packageName ?? 'internal-entry-point-container',
            fallback: fallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: runtimeProps
        }))));
});
parcelRegister("l8ruj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6056b4460d0127e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $1tcYS;
    var $bFU4G;
    var $8Ec39;
    var $cEm1b;
    function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
        const interactionContext = (0, (0, parcelRequire("1tcYS")).useInteractionContext)();
        const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
                getInteractionContext: ()=>interactionContext,
                wrapPrepareQueryResource (cb) {
                    return cb();
                },
                retainQuery (info) {
                    this.getInteractionContext().retainQuery(info);
                }
            }), [
            interactionContext
        ]);
        const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
            const moduleLoadingRequests = {};
            return {
                current: {
                    getInteractionContext () {
                        return interactionContext;
                    },
                    onPreload (moduleId, _priority) {
                        this.getInteractionContext().addPreload((0, (0, parcelRequire("bFU4G")).extractModuleName)(moduleId), performance.now());
                    },
                    onLoadStart (info) {
                        const timeoutId = setTimeout(()=>{
                            delete moduleLoadingRequests[info.identifier];
                        }, 30000);
                        const request = {
                            start: performance.now(),
                            timeoutId: timeoutId
                        };
                        moduleLoadingRequests[info.identifier] = request;
                    },
                    onLoadComplete (info) {
                        const request = moduleLoadingRequests[info.identifier];
                        if (request) {
                            clearTimeout(request.timeoutId);
                            delete moduleLoadingRequests[info.identifier];
                            this.getInteractionContext()?.addLoad((0, (0, parcelRequire("bFU4G")).extractModuleName)(info.identifier), request.start, performance.now());
                        }
                    },
                    placeholderFallBackMounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                    },
                    placeholderFallBackUnmounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                    }
                }
            };
        }, [
            interactionContext
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
            value: relayProfilerContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEm1b")).ProfilerContext).Provider, {
            value: reactLooselyLazyContext
        }, children));
    }
    function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ec39")).default), {
            name: segmentName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
    }
});
parcelRegister("4mO32", function(module, exports) {
    $parcel$export(module.exports, "useEntryPoint", ()=>$f8987436643ccece$export$338256068bc140fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $c8WsS;
    var $9CqsK;
    var $j1gA4;
    var $bzXq1;
    const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS))=>{
        const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, (0, parcelRequire("j1gA4")).useEntryPointLoadManager)(entryPoint, entryPointParams);
        const { startMetric: startMetric, stopMetric: stopMetric } = (0, (0, parcelRequire("bzXq1")).useMetricLogger)(metric);
        const entryPointActions = (0, (0, parcelRequire("9CqsK")).useEntryPointActions)(loadActions, options, startMetric);
        return (0, $5uXOq.useMemo)(()=>({
                entryPointActions: entryPointActions,
                entryPointReferenceSubject: entryPointReferenceSubject,
                stopMetric: stopMetric
            }), [
            entryPointActions,
            entryPointReferenceSubject,
            stopMetric
        ]);
    };
});
parcelRegister("c8WsS", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_OPTIONS", ()=>$34664e57314d5c26$export$93ca5d3f8675ae4c);
    const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
        preloadMaxAge: 2000,
        timeToIntent: 200
    };
});
parcelRegister("9CqsK", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointActions", ()=>$7bc2afeacf23b901$export$90681c8c3a56f09a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jQsty;
    var $c8WsS;
    const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
    const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
        const preloadIntentTimeout = (0, $5uXOq.useRef)();
        const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
        const preloadLastRequested = (0, $5uXOq.useRef)(0);
        const cancelPreload = (0, $5uXOq.useCallback)(()=>{
            if (!(0, (0, parcelRequire("jQsty")).default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
                clearTimeout(preloadIntentTimeout.current);
                clearTimeout(preloadMaxAgeTimeout.current);
            }
        }, []);
        const load = (0, $5uXOq.useCallback)(()=>{
            cancelPreload();
            startMetric(preloadLastRequested.current);
            if (preloadLastRequested.current > 0) commitPreload();
            else loadEntryPoint();
            preloadLastRequested.current = 0;
        }, [
            cancelPreload,
            commitPreload,
            loadEntryPoint,
            startMetric
        ]);
        const preload = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("jQsty")).default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
            cancelPreload();
            preloadIntentTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = Date.now();
                loadEntryPoint({
                    isPreload: true
                });
                preloadMaxAgeTimeout.current = setTimeout(()=>{
                    preloadLastRequested.current = 0;
                }, preloadMaxAge);
            }, timeToIntent);
        }, [
            cancelPreload,
            loadEntryPoint,
            preloadMaxAge,
            timeToIntent
        ]);
        (0, $5uXOq.useEffect)(()=>cancelPreload, [
            cancelPreload
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                cancelPreload: cancelPreload,
                load: load,
                preload: preload,
                unload: unloadEntryPoint
            }), [
            cancelPreload,
            load,
            preload,
            unloadEntryPoint
        ]);
    };
});
parcelRegister("j1gA4", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointLoadManager", ()=>$d6e83c6db8fa388b$export$bfae318f9651db2f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fiv1r;
    var $iU8T2;
    const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
        const environmentProvider = (0, (0, parcelRequire("fiv1r")).useJiraRelayEnvironmentProvider)();
        const canLoad = (0, $5uXOq.useRef)(true);
        const timer = (0, $5uXOq.useRef)();
        const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
        const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, (0, parcelRequire("iU8T2")).useEntryPointReferenceSubject)();
        const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
            setEntryPointReference(nextEntryPointReference);
            timer.current = setTimeout(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, (0, parcelRequire("iU8T2")).removeAll)(currentQueue) : (0, (0, parcelRequire("iU8T2")).removeInactiveLoads)(currentQueue);
            }, 0);
        }, [
            setEntryPointReference
        ]);
        const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
            isPreload: false
        })=>{
            if (canLoad.current) {
                const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
                entryPointReferenceQueue.current.unshift({
                    value: reference,
                    isPreload: isPreload
                });
                if (isPreload) entryPointReferenceQueue.current = (0, (0, parcelRequire("iU8T2")).removeRedundantPreloads)(entryPointReferenceQueue.current);
                else setNextUpdate(reference);
            }
        }, [
            entryPoint,
            entryPointParams,
            environmentProvider,
            setNextUpdate
        ]);
        const unload = (0, $5uXOq.useCallback)(()=>{
            setNextUpdate(null);
        }, [
            setNextUpdate
        ]);
        const commitPreload = (0, $5uXOq.useCallback)(()=>{
            const [firstItem] = entryPointReferenceQueue.current;
            if (firstItem?.isPreload) {
                firstItem.isPreload = false;
                setNextUpdate(firstItem.value);
            }
        }, [
            setNextUpdate
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearTimeout(timer.current);
                canLoad.current = false;
                entryPointReferenceQueue.current = (0, (0, parcelRequire("iU8T2")).removeAll)(entryPointReferenceQueue.current);
            }, []);
        return {
            entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                    getValue: getValue,
                    subscribe: subscribe
                }), [
                getValue,
                subscribe
            ]),
            loadEntryPoint: load,
            unloadEntryPoint: unload,
            commitPreload: commitPreload
        };
    };
});
parcelRegister("fiv1r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41dee5a929ec50c3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useJiraRelayEnvironmentProvider", ()=>$41dee5a929ec50c3$export$83fb48644dee72f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $5yJb9;
    function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
            environment: (0, (0, parcelRequire("5yJb9")).default)()
        }, children);
    }
    function $41dee5a929ec50c3$export$83fb48644dee72f0() {
        const environment = (0, $8Uumt.useRelayEnvironment)();
        return (0, $5uXOq.useMemo)(()=>({
                getEnvironment () {
                    return environment;
                }
            }), [
            environment
        ]);
    }
});
parcelRegister("iU8T2", function(module, exports) {
    $parcel$export(module.exports, "removeRedundantPreloads", ()=>$011b3d8d407c2901$export$a5b3b808f05fede2);
    $parcel$export(module.exports, "removeInactiveLoads", ()=>$011b3d8d407c2901$export$ae329fe3ea179cb4);
    $parcel$export(module.exports, "removeAll", ()=>$011b3d8d407c2901$export$1cfc7aad5cb1833b);
    $parcel$export(module.exports, "useEntryPointReferenceSubject", ()=>$011b3d8d407c2901$export$322c8997d351da6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
        const [, ...potentialRedundantItems] = queue;
        potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
            if (isPreload) value.dispose();
        });
        return queue.filter(({ value: value })=>!value.isDisposed);
    };
    const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
        if (queue.length === 0) return [];
        const [activeItem, ...redundantItems] = queue;
        redundantItems.forEach(({ value: value })=>{
            value.dispose();
        });
        return [
            activeItem
        ];
    };
    const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
        queue.forEach(({ value: value })=>{
            value.dispose();
        });
        return [];
    };
    const $011b3d8d407c2901$export$322c8997d351da6a = ()=>{
        const value = (0, $5uXOq.useRef)(null);
        const subscribers = (0, $5uXOq.useRef)();
        const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
            if (!subscribers.current) subscribers.current = new Set();
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current?.delete(subscriber);
            };
        }, []);
        const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
            value.current = entryPointReference;
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        }, []);
        const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
        (0, $5uXOq.useEffect)(()=>()=>{
                subscribers.current?.clear();
            }, []);
        return {
            getValue: getValue,
            setEntryPointReference: setEntryPointReference,
            subscribe: subscribe
        };
    };
});
parcelRegister("bzXq1", function(module, exports) {
    $parcel$export(module.exports, "useMetricLogger", ()=>$25198ca8fad8a13c$export$f291ec7cea728e1);
    var $5uXOq = parcelRequire("5uXOq");
    const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
        const preloadStartTime = (0, $5uXOq.useRef)(0);
        const loadStartTime = (0, $5uXOq.useRef)(0);
        const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
            if (metric) {
                metric.start();
                preloadStartTime.current = preloadTime;
                loadStartTime.current = Date.now();
            }
        }, [
            metric
        ]);
        const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
            if (metric) {
                const preloadData = preloadStartTime.current > 0 ? {
                    preloadToStartDuration: loadStartTime.current - preloadStartTime.current
                } : undefined;
                const metricData = preloadData || additionalCustomData ? {
                    customData: {
                        ...preloadData,
                        ...additionalCustomData
                    }
                } : undefined;
                metric.stop(metricData);
            }
        }, [
            metric
        ]);
        return {
            startMetric: startMetric,
            stopMetric: stopMetric
        };
    };
});
parcelRegister("gwZ1O", function(module, exports) {
    $parcel$export(module.exports, "ProjectListSidebarSkeleton", ()=>$b3acbd60cf8d3dfa$export$808c25bcc6102427);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $d8ped = parcelRequire("d8ped");
    const $b3acbd60cf8d3dfa$var$customCssStyles = null;
    const $b3acbd60cf8d3dfa$var$sidebarCssStyles = null;
    const $b3acbd60cf8d3dfa$export$808c25bcc6102427 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1bsb1gwv _1yt41ejb _t6vdt94y _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($d8ped))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_t6vdidpf _hr4jidpf"
            ])
        }));
});
parcelRegister("d8ped", function(module, exports) {
    module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();
});
parcelRegister("koeKL", function(module, exports) {
    $parcel$export(module.exports, "useCloudId", ()=>$559e3c14e9652b55$export$9da0f7c65f28ed16);
    var $9OXo1;
    const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.cloudId;
    };
});
parcelRegister("aOBfa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hTT5V")
    ]).then(()=>parcelRequire('1sO0m'));
});
parcelRegister("7Hq8b", function(module, exports) {
    $parcel$export(module.exports, "SIDEBAR_WIDTH", ()=>$995a11da0cd37d3a$export$780035d9fe48eb32);
    $parcel$export(module.exports, "PANEL_ID", ()=>$995a11da0cd37d3a$export$e1d562d81d0e502d);
    $parcel$export(module.exports, "PROJECT_CREATE_SOURCE", ()=>$995a11da0cd37d3a$export$280536374592bda3);
    $parcel$export(module.exports, "PROJECT_TYPE_TARGETS_MAP", ()=>$995a11da0cd37d3a$export$990484f4e8c06c90);
    $parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", ()=>$995a11da0cd37d3a$export$29629758934356a6);
    var $941eD = parcelRequire("941eD");
    var $iDfVE;
    const $995a11da0cd37d3a$export$780035d9fe48eb32 = 365;
    const $995a11da0cd37d3a$export$e1d562d81d0e502d = 'recommendationsInProjectList';
    const $995a11da0cd37d3a$export$675d6d49067be942 = 'recommendationsInProjectListHoverAnchor';
    const $995a11da0cd37d3a$export$280536374592bda3 = 'recommendationsInProjectList';
    const $995a11da0cd37d3a$export$990484f4e8c06c90 = {
        BUSINESS: (0, $941eD.Targets).JIRA_CORE,
        SOFTWARE: (0, $941eD.Targets).JIRA_SOFTWARE,
        SERVICE_DESK: (0, $941eD.Targets).JIRA_SERVICE_DESK,
        PRODUCT_DISCOVERY: (0, $941eD.Targets).JIRA_PRODUCT_DISCOVERY
    };
    const $995a11da0cd37d3a$export$29629758934356a6 = (environment)=>{
        const env = environment === 'prod' ? 'prod' : 'staging';
        return {
            BUSINESS: (0, (0, parcelRequire("iDfVE")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
            SOFTWARE: (0, (0, parcelRequire("iDfVE")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
            SERVICE_DESK: (0, (0, parcelRequire("iDfVE")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
            PRODUCT_DISCOVERY: (0, (0, parcelRequire("iDfVE")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
        };
    };
});
parcelRegister("02QCV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4hxxI")
    ]).then(()=>parcelRequire('cf0PW'));
});
parcelRegister("hW253", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryPageResource", ()=>$4c805bc331263d5b$export$aabb201a7f7100c5);
    var $8Uumt = parcelRequire("8Uumt");
    var $65Ltd;
    var $4R6GH;
    var $gkT9B;
    var $8pIiT;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $lVQ0r;
    var $dIdda = parcelRequire("dIdda");
    const $4c805bc331263d5b$export$aabb201a7f7100c5 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $ce818d5819645fe8$export$2150caade62dc875)}`,
        getKey: ()=>'projects-directory-relay',
        getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
            const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
            if (false && isAnonymous) return null;
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("lVQ0r")).default), {
                cloudId: tenantContext.cloudId,
                filter: (0, (0, parcelRequire("8pIiT")).mapQueryToFilter)((0, (0, parcelRequire("gkT9B")).filterInitialState), {
                    cloudId: cloudId,
                    query: (0, (0, parcelRequire("8pIiT")).sanitizeLegacyQuery)(query),
                    aliases: (0, (0, parcelRequire("gkT9B")).filterAliasMap)
                }),
                first: query?.page ? (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT),
                last: (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT),
                isAdminSettingsContext: route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
                isAnonymous: isAnonymous,
                skipShouldShowRightSidebar: isAnonymous || (0, (0, parcelRequire("4R6GH")).fg)('server_render_projects_directory_sidebar'),
                isImporterDiscoveryExperimentEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_importer_projects_directory_cta_gate')
            }, {
                fetchPolicy: 'network-only'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        }
    });
});
parcelRegister("gkT9B", function(module, exports) {
    $parcel$export(module.exports, "TableColumns", ()=>$4e4ac97bc1b1894b$export$b0e68791ad9c52df);
    $parcel$export(module.exports, "SortableColumns", ()=>$4e4ac97bc1b1894b$export$f9e740ef44a4c43a);
    $parcel$export(module.exports, "FilterFields", ()=>$4e4ac97bc1b1894b$export$e38c2fbdcbc20613);
    $parcel$export(module.exports, "filterAliasMap", ()=>$4e4ac97bc1b1894b$export$5bc0ad9873e5cd89);
    $parcel$export(module.exports, "filterInitialState", ()=>$4e4ac97bc1b1894b$export$fcb7b3e474e67781);
    $parcel$export(module.exports, "DEFAULT_LIMIT", ()=>$4e4ac97bc1b1894b$export$ebc5ec3267fbcf57);
    $parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", ()=>$4e4ac97bc1b1894b$export$7c1bd7128901e2c4);
    $parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", ()=>$4e4ac97bc1b1894b$export$72fb94bf1b8ec849);
    var $7OwSg;
    const $4e4ac97bc1b1894b$export$b0e68791ad9c52df = {
        Favourites: 'favourite',
        Key: 'key',
        Name: 'name',
        Type: 'type',
        Lead: 'lead',
        Category: 'category',
        LastIssueUpdate: 'last_issue_updated_time',
        Url: 'url',
        Action: 'actions'
    };
    const $4e4ac97bc1b1894b$export$f9e740ef44a4c43a = [
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Favourites,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Key,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Lead,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Category,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.LastIssueUpdate
    ];
    const $4e4ac97bc1b1894b$export$e38c2fbdcbc20613 = {
        Keyword: 'keyword',
        ProjectType: 'types',
        ProjectTypeLabel: 'ProjectTypeLabel',
        ProjectCategoryId: 'projectCategoryId',
        ProjectCategoryLabel: 'projectCategoryLabel',
        ...(0, (0, parcelRequire("7OwSg")).DefaultFilterFields)
    };
    const $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89 = {
        contains: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword,
        selectedProjectType: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType,
        selectedCategory: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId
    };
    const $4e4ac97bc1b1894b$export$fcb7b3e474e67781 = {
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortKey]: $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Page]: '1'
    };
    const $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57 = 25;
    const $4e4ac97bc1b1894b$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
    const $4e4ac97bc1b1894b$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';
});
parcelRegister("7OwSg", function(module, exports) {
    $parcel$export(module.exports, "DefaultFilterFields", ()=>$30cd11272c627f6b$export$7ecdd4b6ae40e139);
    $parcel$export(module.exports, "createUseFilter", ()=>$30cd11272c627f6b$export$ef79d9c1dcb09f8f);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $7JoAD = parcelRequire("7JoAD");
    const $30cd11272c627f6b$export$7ecdd4b6ae40e139 = {
        SortOrder: 'sortOrder',
        SortKey: 'sortKey',
        Page: 'page'
    };
    const $30cd11272c627f6b$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
        const actions = {
            updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                    const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                        [nameOrFilter]: value
                    };
                    setState({
                        ...getState(),
                        [$30cd11272c627f6b$export$7ecdd4b6ae40e139.Page]: 1,
                        ...newFilter
                    });
                    onUpdate(getState());
                },
            forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
        };
        const Store = (0, $7JoAD.createStore)({
            initialState: {},
            actions: actions,
            name: storeName
        });
        const useFilter = (0, $7JoAD.createHook)(Store);
        const useScopedFilter = (0, $7JoAD.createHook)(Store, {
            selector: (state, name)=>state[name]
        });
        const FilterContainer = (0, $7JoAD.createContainer)(Store, {
            onInit: ()=>({ setState: setState })=>{
                    try {
                        const routeQuery = (0, ($parcel$interopDefault($ebyGx))).parse(window.location.search);
                        setState(getInitialState({
                            routeQuery: routeQuery
                        }));
                    } catch (error) {
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'createUseFilter',
                                packageName: 'jiraDirectoryBaseV3',
                                teamName: 'jira-cosmos'
                            }
                        });
                    }
                },
            onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                        routeQuery: {}
                    }))
        });
        return {
            useFilter: useFilter,
            useScopedFilter: useScopedFilter,
            FilterContainer: FilterContainer
        };
    };
});
parcelRegister("8pIiT", function(module, exports) {
    $parcel$export(module.exports, "sanitizeLegacyQuery", ()=>$ddc7efe5cefc2e09$export$b6d5141c3209bd35);
    $parcel$export(module.exports, "mapQueryToFilter", ()=>$ddc7efe5cefc2e09$export$2274cd5f35844a96);
    var $2vSU6;
    var $dZhZb;
    var $dXq4S;
    var $gkT9B;
    const $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE = 'all';
    const $ddc7efe5cefc2e09$export$b6d5141c3209bd35 = (query)=>({
            ...query,
            selectedProjectType: query.selectedProjectType === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectType] : query.selectedProjectType,
            selectedCategory: query.selectedCategory === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectCategoryId] : query.selectedCategory
        });
    const $ddc7efe5cefc2e09$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
        const variables = {};
        const { [(0, (0, parcelRequire("gkT9B")).FilterFields).Keyword]: keyword, [(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectCategoryId]: projectCategoryId, [(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectType]: types, [(0, (0, parcelRequire("gkT9B")).FilterFields).SortOrder]: sortOrder, [(0, (0, parcelRequire("gkT9B")).FilterFields).SortKey]: sortKey } = aliases && query ? (0, (0, parcelRequire("dZhZb")).matchAliases)(filter, query, aliases) : filter;
        if (keyword) variables.keyword = keyword;
        if (projectCategoryId) variables.projectCategoryId = (0, (0, parcelRequire("dXq4S")).isAri)(projectCategoryId) ? projectCategoryId : (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
        if (sortKey || sortOrder) {
            const sortByValue = sortKey && (0, (0, parcelRequire("gkT9B")).SortableColumns).includes(sortKey) ? sortKey : (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).SortKey];
            variables.sortBy = {
                order: [
                    'ASC',
                    'DESC'
                ].includes(sortOrder) ? sortOrder : (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).SortOrder],
                sortBy: sortByValue.toUpperCase()
            };
        }
        if (types && typeof types === 'string') variables.types = types.split(',').filter((type)=>(0, (0, parcelRequire("2vSU6")).PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
        return variables;
    };
});
parcelRegister("dZhZb", function(module, exports) {
    $parcel$export(module.exports, "matchAliases", ()=>$e41b5d91b7cfd8ce$export$55f686d7a3507dbe);
    $parcel$export(module.exports, "serializeSelectOptions", ()=>$e41b5d91b7cfd8ce$export$74a705e0bee1565b);
    $parcel$export(module.exports, "serializeSelectOptionsLabel", ()=>$e41b5d91b7cfd8ce$export$eed751fcc55ddadd);
    $parcel$export(module.exports, "matchValueToSelectOptions", ()=>$e41b5d91b7cfd8ce$export$17e142fa55464467);
    var $ggSx2 = parcelRequire("ggSx2");
    var $cuHs1 = parcelRequire("cuHs1");
    const $e41b5d91b7cfd8ce$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
            const alias = aliases[key];
            const queryValue = query[key];
            const hasInitialValue = filter[key] !== undefined;
            if (hasInitialValue && queryValue) {
                filter[key] = queryValue;
                return filter;
            }
            if (!alias || !queryValue) return filter;
            filter[alias] = queryValue;
            return filter;
        }, {
            ...filterState
        });
    const $e41b5d91b7cfd8ce$export$40bf1812f0f07002 = (data, aliases)=>{
        const invertedAliases = (0, ($parcel$interopDefault($ggSx2)))(aliases);
        return (0, ($parcel$interopDefault($cuHs1)))(data, (_, key)=>invertedAliases[key] || key);
    };
    const $e41b5d91b7cfd8ce$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
    const $e41b5d91b7cfd8ce$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
    const $e41b5d91b7cfd8ce$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];
});
parcelRegister("ggSx2", function(module, exports) {
    var $cxSdl = parcelRequire("cxSdl");
    var $fxKlj = parcelRequire("fxKlj");
    var $etyzk = parcelRequire("etyzk");
    var $bd8870e21c3833a0$var$objectProto = Object.prototype;
    var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
    var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
        if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
        result[value] = key;
    }, $cxSdl($etyzk));
    module.exports = $bd8870e21c3833a0$var$invert;
});
parcelRegister("fxKlj", function(module, exports) {
    var $d1nCg = parcelRequire("d1nCg");
    function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
        return function(object, iteratee) {
            return $d1nCg(object, setter, toIteratee(iteratee), {});
        };
    }
    module.exports = $b50de2cb57eb155c$var$createInverter;
});
parcelRegister("d1nCg", function(module, exports) {
    var $hDnyx = parcelRequire("hDnyx");
    function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
        $hDnyx(object, function(value, key, object) {
            setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
    }
    module.exports = $97adb007e27dc709$var$baseInverter;
});
parcelRegister("lVQ0r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0264f0fee7e7a1be$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $0264f0fee7e7a1be$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isImporterDiscoveryExperimentEnabled"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipShouldShowRightSidebar"
        }, v8 = {
            "kind": "Variable",
            "name": "isAnonymous",
            "variableName": "isAnonymous"
        }, v9 = [
            v8
        ], v10 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v11 = {
            "alias": "canBrowseProjects",
            "args": [
                v10,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "BROWSE_PROJECTS"
                }
            ],
            "concreteType": "JiraPermission",
            "kind": "LinkedField",
            "name": "permission",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasPermission"
                }
            ]
        }, v12 = [
            v10
        ], v13 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v14 = {
            "kind": "ScalarField",
            "name": "id"
        }, v15 = {
            "kind": "ScalarField",
            "name": "name"
        }, v16 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v17 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v18 = {
            "kind": "ScalarField",
            "name": "key"
        }, v19 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v20 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v21 = {
            "kind": "ScalarField",
            "name": "projectListRightPanelState"
        }, v22 = {
            "alias": "sidebarExperimentTemplates",
            "args": [
                v10,
                {
                    "kind": "Literal",
                    "name": "experimentKey",
                    "value": "sidebarExperiment"
                }
            ],
            "concreteType": "JiraProjectListViewTemplateConnection",
            "kind": "LinkedField",
            "name": "projectListViewTemplates",
            "plural": false,
            "selections": [
                v20
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "selections": [
                    {
                        "args": [
                            v8,
                            {
                                "kind": "Variable",
                                "name": "isImporterDiscoveryExperimentEnabled",
                                "variableName": "isImporterDiscoveryExperimentEnabled"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "header_projectsDirectoryV3"
                    },
                    {
                        "args": v9,
                        "kind": "FragmentSpread",
                        "name": "refinementBar_projectsDirectoryV3_Filters"
                    },
                    {
                        "args": v9,
                        "kind": "FragmentSpread",
                        "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isAdminSettingsContext",
                                "variableName": "isAdminSettingsContext"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "emptyView_projectsDirectoryV3"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "noPermissionViews_projectsDirectoryV3"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v11
                        ]
                    },
                    {
                        "condition": "skipShouldShowRightSidebar",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "rightPanel_projectsDirectoryV3_ShouldShowRightSidebar"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v6,
                    v3,
                    v4,
                    v7,
                    v5
                ],
                "kind": "Operation",
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "canCreateProject",
                                "args": [
                                    v10,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "CREATE_PROJECT"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            {
                                "args": v12,
                                "concreteType": "JiraWorkManagementLicensing",
                                "kind": "LinkedField",
                                "name": "jwmLicensing",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "currentUserSeatEdition"
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v10,
                                    {
                                        "kind": "Variable",
                                        "name": "filter",
                                        "variableName": "filter"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "first"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "last",
                                        "variableName": "last"
                                    }
                                ],
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": "canViewIssue",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "VIEW_ISSUES"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v13,
                                                        "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                    },
                                                    v14,
                                                    v15,
                                                    v16,
                                                    {
                                                        "concreteType": "JiraFavouriteValue",
                                                        "kind": "LinkedField",
                                                        "name": "favouriteValue",
                                                        "plural": false,
                                                        "selections": [
                                                            v16,
                                                            v17,
                                                            v14
                                                        ]
                                                    },
                                                    v18,
                                                    {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "medium"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectStyle"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "navigationMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            v19,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "boardId"
                                                                    },
                                                                    v14
                                                                ],
                                                                "type": "JiraSoftwareProjectNavigationMetadata"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "queueId"
                                                                    }
                                                                ],
                                                                "type": "JiraServiceManagementProjectNavigationMetadata"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectType"
                                                    },
                                                    {
                                                        "concreteType": "JiraProjectCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v15,
                                                            v14
                                                        ]
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "lead",
                                                        "plural": false,
                                                        "selections": [
                                                            v19,
                                                            {
                                                                "kind": "TypeDiscriminator",
                                                                "abstractKey": "__isUser"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "accountId"
                                                            },
                                                            v15,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "picture"
                                                            },
                                                            v14
                                                        ]
                                                    },
                                                    {
                                                        "condition": "isAdminSettingsContext",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "alias": "lastUpdatedToolTipDate",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "format",
                                                                        "value": "COMPLETE_DATETIME_FORMAT"
                                                                    }
                                                                ],
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdatedFormatted",
                                                                "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                            },
                                                            {
                                                                "alias": "lastUpdatedDisplayDate",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "format",
                                                                        "value": "RELATIVE"
                                                                    }
                                                                ],
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdatedFormatted",
                                                                "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectUrl"
                                                    },
                                                    {
                                                        "alias": "canEdit",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "EDIT_PROJECT_CONFIG"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v13,
                                                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                    },
                                                    {
                                                        "alias": "canViewProjectConfig",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "VIEW_PROJECT_CONFIG"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v13,
                                                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                    },
                                                    {
                                                        "alias": "jiraProjectType",
                                                        "kind": "ScalarField",
                                                        "name": "projectType"
                                                    },
                                                    {
                                                        "alias": "jiraProjectName",
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v20,
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isHasTotal"
                                    }
                                ]
                            },
                            {
                                "alias": "canContactAdmin",
                                "args": [
                                    v10,
                                    {
                                        "kind": "Literal",
                                        "name": "keys",
                                        "value": "jira.show.contact.administrators.form"
                                    }
                                ],
                                "concreteType": "JiraApplicationProperty",
                                "kind": "LinkedField",
                                "name": "applicationPropertiesByKey",
                                "plural": true,
                                "selections": [
                                    v18,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    v14
                                ]
                            },
                            v11,
                            {
                                "condition": "isAnonymous",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": v12,
                                        "concreteType": "JiraUserPreferences",
                                        "kind": "LinkedField",
                                        "name": "userPreferences",
                                        "plural": false,
                                        "selections": [
                                            v21,
                                            v17
                                        ]
                                    },
                                    v22,
                                    {
                                        "args": v12,
                                        "concreteType": "JiraProjectCategoryConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraProjectCategories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectCategoryEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v19
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "isAnonymous",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": v12,
                                        "concreteType": "JiraProjectCategoryConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraProjectCategories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectCategoryEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v19,
                                                    {
                                                        "concreteType": "JiraProjectCategory",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v14,
                                                            v15
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v12,
                                "concreteType": "JiraProjectTypeDetailsConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjectTypes",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectTypeDetailsEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectTypeDetails",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v18,
                                                    v14
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "skipShouldShowRightSidebar",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v12,
                                        "concreteType": "JiraUserPreferences",
                                        "kind": "LinkedField",
                                        "name": "userPreferences",
                                        "plural": false,
                                        "selections": [
                                            v21
                                        ]
                                    },
                                    v22
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "c5bf480cfcc7e1667e0f3ca7923ae0e7fb82b6dc49abd4df64797411cc629cfd",
                "metadata": {},
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0264f0fee7e7a1be$var$node.hash = "44419374ddb19dca6c3a1596b677f976";
    (0, $eiowN.PreloadableQueryRegistry).set($0264f0fee7e7a1be$var$node.params.id, $0264f0fee7e7a1be$var$node);
    var $0264f0fee7e7a1be$export$2e2bcd8739ae039 = $0264f0fee7e7a1be$var$node;
});
const $ce818d5819645fe8$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';
parcelRegister("1xIol", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryRoute", ()=>$4b60f76eec2e5934$export$74114064f06cd71b);
    $parcel$export(module.exports, "manageProjectsDirectoryRoute", ()=>$4b60f76eec2e5934$export$281a4490a0f8fb4c);
    $parcel$export(module.exports, "projectsDirectoryRedirectRoute", ()=>$4b60f76eec2e5934$export$d44f1be3782f0fde);
    $parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", ()=>$4b60f76eec2e5934$export$c713f57300a82898);
    $parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", ()=>$4b60f76eec2e5934$export$dbd3b6c012e8b6dc);
    $parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", ()=>$4b60f76eec2e5934$export$4531e3b2e25fad23);
    var $65Ltd;
    const $4b60f76eec2e5934$export$74114064f06cd71b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        path: '/jira/projects',
        exact: true
    };
    const $4b60f76eec2e5934$export$281a4490a0f8fb4c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
        path: '/jira/settings/projects/manage'
    };
    const $4b60f76eec2e5934$export$d44f1be3782f0fde = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY)}-redirect`,
        path: '/projects',
        exact: true
    };
    const $4b60f76eec2e5934$export$c713f57300a82898 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA)}-redirect`,
        path: '/secure/BrowseProjects.jspa'
    };
    const $4b60f76eec2e5934$export$dbd3b6c012e8b6dc = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-redirect`,
        path: '/secure/project/ViewProjects.jspa'
    };
    const $4b60f76eec2e5934$export$4531e3b2e25fad23 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-root-redirect`,
        path: '/jira/settings/projects',
        exact: true
    };
});
parcelRegister("4nnZF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5jhjf")
    ]).then(()=>parcelRequire('j3Lmi'));
});
parcelRegister("3C1eN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fFisX")
    ]).then(()=>parcelRequire('eBOH6'));
});
parcelRegister("6YWw1", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$89b6fb9884e4755e$export$bc99aaabaf7b70a7);
    var $7fV7n;
    var $1YfAT;
    var $7J53H;
    var $eyLtQ;
    const $89b6fb9884e4755e$export$bc99aaabaf7b70a7 = {
        configuredSyncsResource: (0, parcelRequire("7fV7n")).configuredSyncsResource,
        userAccessRightsResource: (0, parcelRequire("eyLtQ")).userAccessRightsResource,
        getTeamResource: (0, parcelRequire("7J53H")).getTeamResource,
        isCurrentSiteSyncEnabledResource: (0, parcelRequire("1YfAT")).isCurrentSiteSyncEnabledResource
    };
});
parcelRegister("7fV7n", function(module, exports) {
    $parcel$export(module.exports, "configuredSyncsResource", ()=>$780664dfd818f1ba$export$333c290f4a1ec41c);
    var $dIdda = parcelRequire("dIdda");
    var $l116g;
    var $fCcRT;
    const $780664dfd818f1ba$export$333c290f4a1ec41c = (0, $dIdda.createResource)({
        type: 'configuredSyncsResource',
        getKey: ({ query: query, match: match })=>{
            const teamId = match.params.teamId ?? query['teamId'];
            const keyword = query['keyword'];
            const type = query['type'];
            const page = query['page'] || '1';
            const status = query['status'];
            return (0, (0, parcelRequire("l116g")).UrlHelper)('configuredSyncsResource', {
                page: page,
                keyword: keyword,
                type: type,
                status: status,
                teamId: teamId
            });
        },
        getData: (routerContext)=>(0, (0, parcelRequire("fCcRT")).default).getSyncs(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("l116g", function(module, exports) {
    $parcel$export(module.exports, "UrlHelper", ()=>$2539490b962657de$export$bacbc496e850c0a4);
    const $2539490b962657de$export$bacbc496e850c0a4 = (path, params = {})=>{
        const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
                k,
                v.toString()
            ] : undefined).filter((v)=>!!v);
        const qs = new URLSearchParams(q).toString();
        return `${path}${qs ? `?${qs}` : ''}`;
    };
});
parcelRegister("fCcRT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4cc94b3364931bb$export$2e2bcd8739ae039);
    var $j74qU;
    var $l116g;
    const $a4cc94b3364931bb$var$getSyncs = async (query, pathParamTeamId)=>{
        const page = parseInt(query['page']) || 1;
        const offset = (page - 1) * (0, $85d01ad7b2541e2c$export$31ecae7225aecec6);
        const queryParams = query ? {
            teamId: pathParamTeamId ?? query.teamId,
            type: query.type,
            keyword: query.keyword,
            status: query.status
        } : {};
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("l116g")).UrlHelper)('/v1/entity-sync/unified', {
            ...queryParams,
            offset: offset.toString(),
            limit: (0, $85d01ad7b2541e2c$export$31ecae7225aecec6)
        })).then((response)=>({
                data: response.data.integrations,
                pageCount: Math.ceil(response.data.count / (0, $85d01ad7b2541e2c$export$31ecae7225aecec6)),
                itemCount: response.data.count
            }));
    };
    const $a4cc94b3364931bb$var$patchSync = async (syncId, syncType, body, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("l116g")).UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
            type: syncType,
            teamId: teamId
        }), {
            method: 'PATCH',
            body: body
        }).then((response)=>response.data);
    const $a4cc94b3364931bb$var$deleteSync = async (syncId, syncType, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("l116g")).UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
            type: syncType,
            teamId: teamId
        }), {
            method: 'DELETE',
            responseType: 'headers'
        });
    var $a4cc94b3364931bb$export$2e2bcd8739ae039 = {
        getSyncs: $a4cc94b3364931bb$var$getSyncs,
        patchSync: $a4cc94b3364931bb$var$patchSync,
        deleteSync: $a4cc94b3364931bb$var$deleteSync
    };
});
const $85d01ad7b2541e2c$export$31ecae7225aecec6 = 20;
parcelRegister("1YfAT", function(module, exports) {
    $parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", ()=>$53dacb41f1b977c2$export$94465df791bf80);
    var $dIdda = parcelRequire("dIdda");
    var $9d6Ve;
    const $53dacb41f1b977c2$export$94465df791bf80 = (0, $dIdda.createResource)({
        type: 'isCurrentSiteSyncEnabledResource',
        getKey: ()=>`isCurrentSiteSyncEnabledResource`,
        getData: (0, (0, parcelRequire("9d6Ve")).getIsCurrentSiteSyncEnabled),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("9d6Ve", function(module, exports) {
    $parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", ()=>$84b302591901e719$export$93fc09e39edf63d0);
    var $j74qU;
    const $84b302591901e719$export$93fc09e39edf63d0 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);
});
parcelRegister("7J53H", function(module, exports) {
    $parcel$export(module.exports, "getTeamResource", ()=>$3559e86ca19d1712$export$50271c9e7f21f10e);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $7n8Dv;
    const $3559e86ca19d1712$export$50271c9e7f21f10e = (0, $dIdda.createResource)({
        type: 'getSyncTeamResource',
        getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
            const result = await (0, (0, parcelRequire("7n8Dv")).getTeam)(teamId);
            return result ?? null;
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("hmVmJ", function(module, exports) {
    $parcel$export(module.exports, "assert", ()=>$e903ea4af1073086$export$a7a9523472993e97);
    var $dH6Pi;
    const $e903ea4af1073086$export$a7a9523472993e97 = function(condition, err) {
        if (!condition) throw err;
    };
});
parcelRegister("dH6Pi", function(module, exports) {
    $parcel$export(module.exports, "AssertionError", ()=>$51d685c1b4e62326$export$7750cdfb4db2c3d);
    class $51d685c1b4e62326$export$7750cdfb4db2c3d extends Error {
        constructor(id, message){
            super(`[${id}] ${message}`);
            this.id = id;
        }
    }
});
parcelRegister("7n8Dv", function(module, exports) {
    $parcel$export(module.exports, "getTeam", ()=>$5f911005aed87c97$export$491fe77f22ab2b51);
    var $j74qU;
    const $5f911005aed87c97$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));
});
parcelRegister("eyLtQ", function(module, exports) {
    $parcel$export(module.exports, "userAccessRightsResource", ()=>$85ca4565e2692c52$export$69ddc7cc64ae9a02);
    var $dIdda = parcelRequire("dIdda");
    var $3mt67;
    const $85ca4565e2692c52$export$69ddc7cc64ae9a02 = (0, $dIdda.createResource)({
        type: 'userAccessRightsResource',
        getKey: ()=>'userAccessRightsResource',
        getData: (routerContext)=>(0, (0, parcelRequire("3mt67")).getUserRights)(routerContext.match.params.teamId),
        maxAge: 600000,
        isBrowserOnly: true
    });
});
parcelRegister("3mt67", function(module, exports) {
    $parcel$export(module.exports, "getUserRights", ()=>$565f7a833d907135$export$84e2ed279bc4e64e);
    var $j74qU;
    var $l116g;
    const $565f7a833d907135$export$84e2ed279bc4e64e = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("l116g")).UrlHelper)(`/v1/entity-sync/unified/rights`, {
            teamId: teamId
        })).then((response)=>response.data.userAccessRights);
    };
});
parcelRegister("2r8fH", function(module, exports) {
    $parcel$export(module.exports, "teamResource", ()=>$77662e91dfb33ae6$export$87453d709b90ccdf);
    $parcel$export(module.exports, "sidebarRightsResource", ()=>$77662e91dfb33ae6$export$3b3b9a5b0eddde66);
    $parcel$export(module.exports, "resources", ()=>$77662e91dfb33ae6$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $5iPTg;
    const $77662e91dfb33ae6$export$87453d709b90ccdf = (0, $dIdda.createResource)({
        type: 'teamResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-dashboard/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
            return (0, (0, parcelRequire("5iPTg")).getTeamByIdEndpoint)(teamId);
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
    const $77662e91dfb33ae6$export$3b3b9a5b0eddde66 = (0, $dIdda.createResource)({
        type: 'sidebarRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
            return (0, (0, parcelRequire("5iPTg")).getSidebarRightsEndpoint)(teamId);
        },
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $77662e91dfb33ae6$export$bc99aaabaf7b70a7 = [
        $77662e91dfb33ae6$export$87453d709b90ccdf,
        $77662e91dfb33ae6$export$3b3b9a5b0eddde66
    ];
});
parcelRegister("5iPTg", function(module, exports) {
    $parcel$export(module.exports, "getTeamByIdEndpoint", ()=>$03a26ab2fa346c2e$export$bcb25b347f39b3f3);
    $parcel$export(module.exports, "getSidebarRightsEndpoint", ()=>$03a26ab2fa346c2e$export$6f1f62156c62eb91);
    var $j74qU;
    const $03a26ab2fa346c2e$export$bcb25b347f39b3f3 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
    const $03a26ab2fa346c2e$export$6f1f62156c62eb91 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/menu-rights`);
    };
});
parcelRegister("gR2RM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dXWqK")
    ]).then(()=>parcelRequire('hMnGK'));
});
parcelRegister("hbBAJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2AP6O")
    ]).then(()=>parcelRequire('fBQfD'));
});
parcelRegister("atcAs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("69byx")
    ]).then(()=>parcelRequire('10YpK'));
});
parcelRegister("cQXYd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iRSLc").then(()=>parcelRequire('c3FF8'));
});
parcelRegister("8cAy7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g3ZhW").then(()=>parcelRequire('dSHkM'));
});
parcelRegister("agiQP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fBjqh")
    ]).then(()=>parcelRequire('gAySz'));
});
parcelRegister("2T8SP", function(module, exports) {
    $parcel$export(module.exports, "apiKeysResource", ()=>$78235b6a5aa26e7e$export$a98d5421eda11f29);
    $parcel$export(module.exports, "resources", ()=>$78235b6a5aa26e7e$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    parcelRequire("jxRF2");
    var $ldKOT;
    var $3do1I;
    const $78235b6a5aa26e7e$export$a98d5421eda11f29 = (0, $dIdda.createResource)({
        type: 'api-key-management',
        getKey: ()=>'api-key-management',
        getData: async ({ dependencies: dependencies })=>{
            const data = await dependencies[(0, (0, parcelRequire("ldKOT")).eocUserResource).type]?.promise;
            return (0, (0, parcelRequire("3do1I")).fetchKeys)(data.accountId);
        },
        isBrowserOnly: true,
        maxCache: 0,
        maxAge: 0,
        depends: [
            (0, (0, parcelRequire("ldKOT")).eocUserResource).type
        ]
    });
    const $78235b6a5aa26e7e$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("ldKOT")).eocUserResource),
        $78235b6a5aa26e7e$export$a98d5421eda11f29
    ];
});
parcelRegister("jxRF2", function(module, exports) {
    $parcel$export(module.exports, "eocCommonResources", ()=>$9675469e92ce170a$export$8977bbbf2f7167d2);
    $parcel$export(module.exports, "eocUserResource", ()=>(parcelRequire("ldKOT")).eocUserResource);
    var $ldKOT;
    const $9675469e92ce170a$export$8977bbbf2f7167d2 = ()=>[
            (0, (0, parcelRequire("ldKOT")).eocUserResource)
        ];
});
parcelRegister("ldKOT", function(module, exports) {
    $parcel$export(module.exports, "eocUserResource", ()=>$0e22e6fd8475b5e0$export$3a08a0bdeef86956);
    var $dIdda = parcelRequire("dIdda");
    var $jonVZ;
    const $0e22e6fd8475b5e0$export$3a08a0bdeef86956 = (0, $dIdda.createResource)({
        type: 'create-user-resource',
        getKey: ()=>'create-user-resource',
        getData: async ()=>(0, (0, parcelRequire("jonVZ")).fetchJsmUserInfo)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("jonVZ", function(module, exports) {
    $parcel$export(module.exports, "fetchJsmUserInfo", ()=>$189024051479d227$export$7d750310098b5a7);
    var $j74qU;
    var $030R0;
    const $189024051479d227$var$JSM_BASE_URL = '/rest/api/3/myself';
    const $189024051479d227$export$7d750310098b5a7 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)($189024051479d227$var$JSM_BASE_URL, {
            exactUrl: true,
            errorTransformer: (0, (0, parcelRequire("030R0")).jsmErrorTransformer)
        });
    };
});
parcelRegister("3do1I", function(module, exports) {
    $parcel$export(module.exports, "fetchKeys", ()=>$064b2b209b19aeee$export$a0d93e1b78b8e70b);
    $parcel$export(module.exports, "deleteApiKey", ()=>$064b2b209b19aeee$export$d2f8649a375a4113);
    var $j74qU;
    const $064b2b209b19aeee$export$a0d93e1b78b8e70b = async (accountId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/api-keys/web?accountId=' + accountId);
    };
    const $064b2b209b19aeee$export$d2f8649a375a4113 = async (key, accountId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
            method: 'DELETE'
        });
    };
});
parcelRegister("ck880", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("e41T5")
    ]).then(()=>parcelRequire('95iLR'));
});
parcelRegister("jqlWU", function(module, exports) {
    $parcel$export(module.exports, "rolesResource", ()=>$662177b4cdfd6303$export$52e29d5915d5f674);
    $parcel$export(module.exports, "resources", ()=>$662177b4cdfd6303$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $c4XwU;
    const $662177b4cdfd6303$export$52e29d5915d5f674 = (0, $dIdda.createResource)({
        type: 'rolesResource',
        getKey: ()=>'rolesResource',
        getData: (0, (0, parcelRequire("c4XwU")).getRolesEndpoint),
        isBrowserOnly: true
    });
    const $662177b4cdfd6303$export$bc99aaabaf7b70a7 = [
        $662177b4cdfd6303$export$52e29d5915d5f674
    ];
});
parcelRegister("c4XwU", function(module, exports) {
    $parcel$export(module.exports, "getUsersEndpoint", ()=>$3d7f15d2403fdf59$export$d372f7d69e481dba);
    $parcel$export(module.exports, "getFilteredUsersEndpoint", ()=>$3d7f15d2403fdf59$export$d8f86d9603f031c0);
    $parcel$export(module.exports, "getRolesEndpoint", ()=>$3d7f15d2403fdf59$export$7d0bc1a3c689fc74);
    $parcel$export(module.exports, "updateRoleOfUserEndpoint", ()=>$3d7f15d2403fdf59$export$a0b296dc0259976f);
    var $j74qU;
    var $3m952;
    const $3d7f15d2403fdf59$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
        const [_, query] = queryKey;
        let url = new (0, (0, parcelRequire("3m952")).URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url);
    };
    const $3d7f15d2403fdf59$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
        const [_, ...filters] = queryKey;
        if (filters.length === 0) return Promise.resolve({
            lastEvaluatedToken: '',
            values: []
        });
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/users/roles/filter', {
            method: 'POST',
            body: {
                limit: limit,
                roles: filters,
                offset: lastEvaluatedToken || 0
            }
        });
    };
    const $3d7f15d2403fdf59$export$7d0bc1a3c689fc74 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/users/roles');
    };
    const $3d7f15d2403fdf59$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles/assign`, {
            method: 'PATCH',
            body: {
                accountId: accountId,
                roleId: roleId
            }
        });
    };
});
parcelRegister("3m952", function(module, exports) {
    $parcel$export(module.exports, "URLBuilder", ()=>$3c9748f3251c69d7$export$61d2e8db329a11f8);
    class $3c9748f3251c69d7$export$61d2e8db329a11f8 {
        constructor(url){
            this.url = url;
            this.params = {};
        }
        withQueryParam(key, value) {
            this.params[key] = value;
            return this;
        }
        build() {
            const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                    key,
                    value && value.toString()
                ]);
            const queryInstance = new URLSearchParams(filteredParams);
            const queryParams = queryInstance.toString();
            if (queryParams === '') return `${this.url}`;
            if (queryParams) return `${this.url}?${queryParams}`;
            return this.url;
        }
    }
});
parcelRegister("79kmP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ligT4")
    ]).then(()=>parcelRequire('i3AK8'));
});
parcelRegister("d6ThE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9mAAJ")
    ]).then(()=>parcelRequire('j6Qxa'));
});
parcelRegister("7ygGB", function(module, exports) {
    $parcel$export(module.exports, "customRolesResource", ()=>$010682625a4b0c54$export$7140716a1b1b8e7a);
    $parcel$export(module.exports, "resources", ()=>$010682625a4b0c54$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $hnjQD;
    const $010682625a4b0c54$export$7140716a1b1b8e7a = (0, $dIdda.createResource)({
        type: 'rolesResource',
        getKey: ()=>'rolesResource',
        getData: (0, (0, parcelRequire("hnjQD")).getCustomRolesListEndpoint),
        isBrowserOnly: true
    });
    const $010682625a4b0c54$export$bc99aaabaf7b70a7 = [
        $010682625a4b0c54$export$7140716a1b1b8e7a
    ];
});
parcelRegister("hnjQD", function(module, exports) {
    $parcel$export(module.exports, "getPermissionsEndpoint", ()=>$32ca3dc706b725ff$export$f97b589720c51ce1);
    $parcel$export(module.exports, "createCustomRoleEndpoint", ()=>$32ca3dc706b725ff$export$5a7187e04c844900);
    $parcel$export(module.exports, "editCustomRoleEndpoint", ()=>$32ca3dc706b725ff$export$304735a80b86192e);
    $parcel$export(module.exports, "deleteCustomRoleEndpoint", ()=>$32ca3dc706b725ff$export$e12995ccad013f65);
    $parcel$export(module.exports, "getCustomRolesListEndpoint", ()=>$32ca3dc706b725ff$export$3619edac53aa59fd);
    var $j74qU;
    const $32ca3dc706b725ff$export$f97b589720c51ce1 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/permissions`);
    const $32ca3dc706b725ff$export$5a7187e04c844900 = (newCustomRole)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles`, {
            method: 'POST',
            body: newCustomRole
        });
    const $32ca3dc706b725ff$export$304735a80b86192e = (updatedCustomRole)=>{
        const { id: id } = updatedCustomRole;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles/${id}`, {
            method: 'PATCH',
            body: updatedCustomRole
        });
    };
    const $32ca3dc706b725ff$export$e12995ccad013f65 = (id)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles/${id}`, {
            method: 'DELETE'
        });
    };
    const $32ca3dc706b725ff$export$3619edac53aa59fd = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles`);
});
parcelRegister("7yJdu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("47IHZ")
    ]).then(()=>parcelRequire('WACar'));
});
parcelRegister("en1L8", function(module, exports) {
    $parcel$export(module.exports, "alertDetailResource", ()=>$0fd209d54dcee973$export$f918335771807ac4);
    $parcel$export(module.exports, "logTypesResource", ()=>$0fd209d54dcee973$export$f9c57ab4d5f63686);
    $parcel$export(module.exports, "entityRelationTypesResource", ()=>$0fd209d54dcee973$export$a5515392cb45b9f8);
    $parcel$export(module.exports, "responderStatesResource", ()=>$0fd209d54dcee973$export$c3b70747662e5932);
    $parcel$export(module.exports, "resources", ()=>$0fd209d54dcee973$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $4EUyI;
    var $hmVmJ;
    var $dH6Pi;
    var $jxRF2;
    var $4sBoT;
    const $0fd209d54dcee973$export$f918335771807ac4 = (0, $dIdda.createResource)({
        type: 'alertDetailResource',
        getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!alertId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
            return (0, (0, parcelRequire("4sBoT")).getAlertDetail)(alertId);
        },
        isBrowserOnly: true
    });
    const $0fd209d54dcee973$export$f9c57ab4d5f63686 = (0, $dIdda.createResource)({
        type: 'logTypesResource',
        getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
        getData: async ()=>{
            return (0, (0, parcelRequire("4sBoT")).getAlertLogTypesEndpoint)();
        },
        isBrowserOnly: true
    });
    const $0fd209d54dcee973$export$a5515392cb45b9f8 = (0, $dIdda.createResource)({
        type: 'entityRelationTypesResource',
        getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!alertId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
            return (0, (0, parcelRequire("4sBoT")).getEntityRelationTypesEndpoint)(alertId);
        },
        isBrowserOnly: true
    });
    const $0fd209d54dcee973$export$c3b70747662e5932 = (0, $dIdda.createResource)({
        type: 'responderStatesResource',
        getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!alertId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('responderStatesResource', 'alertId should be set to fetch responder states'));
            return (0, (0, parcelRequire("4sBoT")).getResponderStatesEndpoint)(alertId);
        },
        isBrowserOnly: true
    });
    const $0fd209d54dcee973$export$bc99aaabaf7b70a7 = [
        $0fd209d54dcee973$export$f918335771807ac4,
        $0fd209d54dcee973$export$f9c57ab4d5f63686,
        $0fd209d54dcee973$export$c3b70747662e5932,
        $0fd209d54dcee973$export$a5515392cb45b9f8,
        (0, (0, parcelRequire("4EUyI")).relatedAlertGroupResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
});
parcelRegister("4EUyI", function(module, exports) {
    $parcel$export(module.exports, "relatedAlertGroupResource", ()=>$ba8a2335e3265c9e$export$35df14c9f0cfb113);
    var $dIdda = parcelRequire("dIdda");
    var $VSDnB;
    var $hmVmJ;
    var $dH6Pi;
    var $3jET5;
    const $ba8a2335e3265c9e$export$35df14c9f0cfb113 = (0, $dIdda.createResource)({
        type: 'relatedAlertGroupResource',
        getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            if (!(0, (0, parcelRequire("VSDnB")).fg)('aiops-related-alert-group')) return null;
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!alertId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
            return (0, (0, parcelRequire("3jET5")).getRelatedAlertGroup)(alertId);
        },
        isBrowserOnly: true
    });
});
parcelRegister("3jET5", function(module, exports) {
    $parcel$export(module.exports, "getRelatedAlertGroup", ()=>$0f60bd06765f80ba$export$665e34f20aad273a);
    var $j74qU;
    var $4ttsA;
    const $0f60bd06765f80ba$export$665e34f20aad273a = (alertId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("4ttsA")).withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
            exactUrl: true
        });
});
parcelRegister("4ttsA", function(module, exports) {
    $parcel$export(module.exports, "withAIOpsDomainPrefix", ()=>$8fd10dbbabf74295$export$81c70e0016508593);
    var $VSDnB;
    var $030R0;
    const $8fd10dbbabf74295$export$81c70e0016508593 = (input)=>{
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("VSDnB")).fg)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
});
parcelRegister("4sBoT", function(module, exports) {
    $parcel$export(module.exports, "getAlertDetail", ()=>$440b6c9ebfdc99cb$export$436b6d88c1865c54);
    $parcel$export(module.exports, "getAlertLogTypesEndpoint", ()=>$440b6c9ebfdc99cb$export$97200f7e7a7d1479);
    $parcel$export(module.exports, "getResponderStatesEndpoint", ()=>$440b6c9ebfdc99cb$export$498d1a9ea659d430);
    $parcel$export(module.exports, "getEntityRelationTypesEndpoint", ()=>$440b6c9ebfdc99cb$export$8f96130abdd7549d);
    var $j74qU;
    const $440b6c9ebfdc99cb$export$436b6d88c1865c54 = (alertId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/${alertId}`);
    const $440b6c9ebfdc99cb$export$97200f7e7a7d1479 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/logs/types`);
    const $440b6c9ebfdc99cb$export$498d1a9ea659d430 = (alertId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/${alertId}/responder-states`);
    const $440b6c9ebfdc99cb$export$8f96130abdd7549d = (alertId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
                relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
            }));
});
parcelRegister("6hGfG", function(module, exports) {
    $parcel$export(module.exports, "alertGroupingStateResource", ()=>$9de427fa65011ef0$export$722cc8285202ce44);
    var $dIdda = parcelRequire("dIdda");
    var $3dV2P;
    const $9de427fa65011ef0$var$emptyAlertGroupingState = {
        isEnabled: false,
        reason: null
    };
    const $9de427fa65011ef0$export$722cc8285202ce44 = (0, $dIdda.createResource)({
        type: 'alertGroupingStateResource',
        getKey: ()=>'alertGroupingStateResource',
        getData: async ()=>{
            try {
                const response = await (0, (0, parcelRequire("3dV2P")).getGroupFeatureStatus)();
                return response;
            } catch (e) {
                return $9de427fa65011ef0$var$emptyAlertGroupingState;
            }
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("3dV2P", function(module, exports) {
    $parcel$export(module.exports, "getGroupFeatureStatus", ()=>$c990dc5854960610$export$48deee62d9dfb365);
    var $1Dhlz;
    var $j74qU;
    var $1Z10l;
    const $c990dc5854960610$export$48deee62d9dfb365 = ()=>{
        const url = new (0, (0, parcelRequire("1Dhlz")).URLBuilder)((0, (0, parcelRequire("1Z10l")).withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            exactUrl: true
        });
    };
});
parcelRegister("1Dhlz", function(module, exports) {
    $parcel$export(module.exports, "URLBuilder", ()=>$3d24b3de45ba1bce$export$61d2e8db329a11f8);
    class $3d24b3de45ba1bce$export$61d2e8db329a11f8 {
        constructor(url){
            this.url = url;
            this.params = {};
        }
        withQueryParam(key, value) {
            this.params[key] = value;
            return this;
        }
        build() {
            const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
            const queryInstance = new URLSearchParams(filteredParams);
            const queryParams = queryInstance.toString();
            if (queryParams) return `${this.url}?${queryParams}`;
            return this.url;
        }
    }
});
parcelRegister("1Z10l", function(module, exports) {
    $parcel$export(module.exports, "validateTimeInput", ()=>$63876a0dc22d7edb$export$8880da3ae4274888);
    $parcel$export(module.exports, "validateBetweenInput", ()=>$63876a0dc22d7edb$export$57c3e855fbf300fa);
    $parcel$export(module.exports, "isInvalidDateValue", ()=>$63876a0dc22d7edb$export$f18cd4bc58b99a27);
    $parcel$export(module.exports, "removeQuotes", ()=>$63876a0dc22d7edb$export$dd2bdf5049bf0915);
    $parcel$export(module.exports, "withQuote", ()=>$63876a0dc22d7edb$export$8708814d32e406db);
    $parcel$export(module.exports, "calculateTimes", ()=>$63876a0dc22d7edb$export$b362bc6892126b7a);
    $parcel$export(module.exports, "getDefaultFilterQuery", ()=>$63876a0dc22d7edb$export$16cce822d8159876);
    $parcel$export(module.exports, "isResponderAlert", ()=>$63876a0dc22d7edb$export$78656db4ffc3ccd8);
    $parcel$export(module.exports, "isGroupAlert", ()=>$63876a0dc22d7edb$export$be2243d4df51c704);
    $parcel$export(module.exports, "withAIOpsDomainPrefix", ()=>$63876a0dc22d7edb$export$81c70e0016508593);
    $parcel$export(module.exports, "getCloudIdForDevEnvironment", ()=>$63876a0dc22d7edb$export$fc6ce7ac2248d7f5);
    var $jovBr;
    var $eZDAP;
    var $gn1v9;
    var $VSDnB;
    var $030R0;
    var $j6OA2;
    var $39KIs;
    var $5F4Xi;
    var $6cAn5 = parcelRequire("6cAn5");
    const $63876a0dc22d7edb$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
        if (!timeDigits) return;
        const timeDigitsNumber = parseInt(timeDigits);
        if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).validNumber);
        if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).hoursNotInRange);
        if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).daysNotInRange);
        if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).weeksNotInRange);
        if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).monthsNotInRange);
        if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).yearsNotInRange);
    };
    const $63876a0dc22d7edb$export$57c3e855fbf300fa = (intl, value)=>{
        if (value) {
            const { startDate: startDate, endDate: endDate } = value;
            if (!startDate && !endDate) return;
            if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).validationMessageBeforeGreaterThanAfter);
            if (value && (startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(startDate)) || endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(endDate)))) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).validationMessageInvalidDateFormat);
        }
        return;
    };
    const $63876a0dc22d7edb$export$f18cd4bc58b99a27 = (value)=>{
        return !(0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(value)) && value !== '';
    };
    const $63876a0dc22d7edb$export$dd2bdf5049bf0915 = (value)=>{
        return value.replace(/^"(.*)"$/, '$1');
    };
    const $63876a0dc22d7edb$export$d4aae9ad13afd6c = (data)=>{
        return {
            ...data,
            label: data.name,
            value: data.id
        };
    };
    const $63876a0dc22d7edb$export$8708814d32e406db = (value)=>{
        if ((0, (0, parcelRequire("j6OA2")).hasSpaceRegEx).test(value) || (0, (0, parcelRequire("j6OA2")).hasColonRegex).test(value)) return `${0, (0, parcelRequire("39KIs")).STRING_LITERAL_DOUBLE_QUOTE}${value}${0, (0, parcelRequire("39KIs")).STRING_LITERAL_DOUBLE_QUOTE}`;
        else return value;
    };
    const $63876a0dc22d7edb$export$b362bc6892126b7a = (time)=>{
        if (!time) return {
            from: undefined,
            to: undefined
        };
        if (time.range === 'all') return {
            from: undefined,
            to: undefined
        };
        if (time.range === 'custom') return {
            from: time.from,
            to: time.to
        };
        const now = new Date();
        const subAmount = {
            [time.range]: time.value
        };
        return {
            from: (0, (0, parcelRequire("gn1v9")).default)(now, subAmount).getTime(),
            to: now.getTime()
        };
    };
    const $63876a0dc22d7edb$export$16cce822d8159876 = (query, teamId)=>{
        if (teamId) {
            if (query) return `${0, (0, parcelRequire("39KIs")).IDENTIFIER_RESPONDERS}: ${teamId} ${0, (0, parcelRequire("39KIs")).LOGICAL_OPERATOR_AND} ${query}`;
            return `${0, (0, parcelRequire("39KIs")).IDENTIFIER_RESPONDERS}: ${teamId}`;
        }
        return query;
    };
    const $63876a0dc22d7edb$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
    const $63876a0dc22d7edb$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
    const $63876a0dc22d7edb$export$81c70e0016508593 = (input)=>{
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("VSDnB")).fg)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
    const $63876a0dc22d7edb$var$isDevEnvironment = ()=>{
        return typeof $6cAn5 !== 'undefined' && ($6cAn5?.env?.STORYBOOK === 'true' || $6cAn5?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
    };
    const $63876a0dc22d7edb$export$fc6ce7ac2248d7f5 = ()=>{
        if ($63876a0dc22d7edb$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
        return undefined;
    };
});
parcelRegister("j6OA2", function(module, exports) {
    $parcel$export(module.exports, "TAB_KEY", ()=>$2bdcdc7877436b61$export$da8c7facc28740b1);
    $parcel$export(module.exports, "ENTER_KEY", ()=>$2bdcdc7877436b61$export$4162dbd8c730437);
    $parcel$export(module.exports, "ESCAPE_KEY", ()=>$2bdcdc7877436b61$export$728705b4513abbb5);
    $parcel$export(module.exports, "SPACE_KEY", ()=>$2bdcdc7877436b61$export$a47625ee19580f99);
    $parcel$export(module.exports, "LEFT_KEY", ()=>$2bdcdc7877436b61$export$ba950c21a0561bed);
    $parcel$export(module.exports, "UP_KEY", ()=>$2bdcdc7877436b61$export$16859d5882a95fea);
    $parcel$export(module.exports, "RIGHT_KEY", ()=>$2bdcdc7877436b61$export$4b96cad863d88376);
    $parcel$export(module.exports, "DOWN_KEY", ()=>$2bdcdc7877436b61$export$fc0cf2556509233e);
    $parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", ()=>$2bdcdc7877436b61$export$87b2b08fc4c97f78);
    $parcel$export(module.exports, "hasSpaceRegEx", ()=>$2bdcdc7877436b61$export$a07ca273fbeffcb8);
    $parcel$export(module.exports, "hasStartingQuotesRegex", ()=>$2bdcdc7877436b61$export$a3aaedcec21ac282);
    $parcel$export(module.exports, "hasEndingQuotesRegex", ()=>$2bdcdc7877436b61$export$e5ad519d04ef012a);
    $parcel$export(module.exports, "hasNewLinesRegex", ()=>$2bdcdc7877436b61$export$7645e556e9948ecd);
    $parcel$export(module.exports, "EMAIL_REGEX", ()=>$2bdcdc7877436b61$export$7b7637218245c8a);
    $parcel$export(module.exports, "hasColonRegex", ()=>$2bdcdc7877436b61$export$65a2b373cb60e599);
    const $2bdcdc7877436b61$export$da8c7facc28740b1 = 'Tab';
    const $2bdcdc7877436b61$export$4162dbd8c730437 = 'Enter';
    const $2bdcdc7877436b61$export$728705b4513abbb5 = 'Escape';
    const $2bdcdc7877436b61$export$a47625ee19580f99 = ' ';
    const $2bdcdc7877436b61$export$ba950c21a0561bed = 'ArrowLeft';
    const $2bdcdc7877436b61$export$16859d5882a95fea = 'ArrowUp';
    const $2bdcdc7877436b61$export$4b96cad863d88376 = 'ArrowRight';
    const $2bdcdc7877436b61$export$fc0cf2556509233e = 'ArrowDown';
    const $2bdcdc7877436b61$export$87b2b08fc4c97f78 = 28;
    const $2bdcdc7877436b61$export$a07ca273fbeffcb8 = /\s/;
    const $2bdcdc7877436b61$export$8866d083cd03ffd7 = /^\s|\s$/;
    const $2bdcdc7877436b61$export$a3aaedcec21ac282 = /^('|")/;
    const $2bdcdc7877436b61$export$e5ad519d04ef012a = /('|")$/;
    const $2bdcdc7877436b61$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
    const $2bdcdc7877436b61$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const $2bdcdc7877436b61$export$65a2b373cb60e599 = /:/;
});
parcelRegister("39KIs", function(module, exports) {
    $parcel$export(module.exports, "TOKEN_TYPES", ()=>$8a97fa493a4d7e02$export$e92b897d610f2aba);
    $parcel$export(module.exports, "LEFT_PARENTHESIS", ()=>$8a97fa493a4d7e02$export$9ce7f372949a1546);
    $parcel$export(module.exports, "RIGHT_PARENTHESIS", ()=>$8a97fa493a4d7e02$export$bbbb3f477a9839e0);
    $parcel$export(module.exports, "OPERATOR_EQUAL_TO", ()=>$8a97fa493a4d7e02$export$ea7497008076d6d2);
    $parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", ()=>$8a97fa493a4d7e02$export$e75c84803c67e1f4);
    $parcel$export(module.exports, "LOGICAL_OPERATOR_AND", ()=>$8a97fa493a4d7e02$export$61308b2610174a70);
    $parcel$export(module.exports, "LOGICAL_OPERATOR_OR", ()=>$8a97fa493a4d7e02$export$1de654320eb3e523);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", ()=>$8a97fa493a4d7e02$export$ff7eed6ac2251302);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", ()=>$8a97fa493a4d7e02$export$4b436fec6f13b741);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", ()=>$8a97fa493a4d7e02$export$8cbc171ac4843075);
    $parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", ()=>$8a97fa493a4d7e02$export$347c7cb6285a1d61);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", ()=>$8a97fa493a4d7e02$export$910131ff5cd3d496);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", ()=>$8a97fa493a4d7e02$export$2aa0d26cb4549272);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", ()=>$8a97fa493a4d7e02$export$572cec90aa166025);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", ()=>$8a97fa493a4d7e02$export$f94109650ec67751);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", ()=>$8a97fa493a4d7e02$export$3a3a37e9da45a2a4);
    $parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", ()=>$8a97fa493a4d7e02$export$9ef3f42fa10fce44);
    $parcel$export(module.exports, "NULL_LITERAL", ()=>$8a97fa493a4d7e02$export$c2b6d31a7a2d40ba);
    $parcel$export(module.exports, "IDENTIFIER_ALIAS", ()=>$8a97fa493a4d7e02$export$21c480ed86e9d13);
    $parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", ()=>$8a97fa493a4d7e02$export$534c195089710c34);
    $parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", ()=>$8a97fa493a4d7e02$export$4699ad3805947d4d);
    $parcel$export(module.exports, "IDENTIFIER_ENTITY", ()=>$8a97fa493a4d7e02$export$2a30b5099ba66c99);
    $parcel$export(module.exports, "IDENTIFIER_IS_SEEN", ()=>$8a97fa493a4d7e02$export$7926b4c2836db847);
    $parcel$export(module.exports, "IDENTIFIER_MESSAGE", ()=>$8a97fa493a4d7e02$export$5a8895646b1d5248);
    $parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", ()=>$8a97fa493a4d7e02$export$4047502bdab1e205);
    $parcel$export(module.exports, "IDENTIFIER_PRIORITY", ()=>$8a97fa493a4d7e02$export$5922c06b76ebb57d);
    $parcel$export(module.exports, "IDENTIFIER_COMPONENTS", ()=>$8a97fa493a4d7e02$export$1122634b5d555f05);
    $parcel$export(module.exports, "IDENTIFIER_SERVICES", ()=>$8a97fa493a4d7e02$export$ec912454cd7d858a);
    $parcel$export(module.exports, "IDENTIFIER_RESPONDERS", ()=>$8a97fa493a4d7e02$export$44673ddac1790242);
    $parcel$export(module.exports, "IDENTIFIER_SOURCE", ()=>$8a97fa493a4d7e02$export$f250d53474e801dc);
    $parcel$export(module.exports, "IDENTIFIER_STATUS", ()=>$8a97fa493a4d7e02$export$43181828ba8680e4);
    $parcel$export(module.exports, "IDENTIFIER_TAG", ()=>$8a97fa493a4d7e02$export$8242733866920892);
    $parcel$export(module.exports, "IDENTIFIER_TINY_ID", ()=>$8a97fa493a4d7e02$export$c833829cf31052f0);
    $parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", ()=>$8a97fa493a4d7e02$export$5f1e5c89a704810f);
    $parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", ()=>$8a97fa493a4d7e02$export$89d93eb7117999c0);
    $parcel$export(module.exports, "IDENTIFIER_TEAMS", ()=>$8a97fa493a4d7e02$export$a79eb1864dd7b745);
    $parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", ()=>$8a97fa493a4d7e02$export$888a9cda49b5e18c);
    $parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", ()=>$8a97fa493a4d7e02$export$60745b712d37edf9);
    $parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", ()=>$8a97fa493a4d7e02$export$b38df7dc61d42293);
    $parcel$export(module.exports, "splitToTokensRegex", ()=>$8a97fa493a4d7e02$export$28041d1d2a85f002);
    $parcel$export(module.exports, "isKeywordRegex", ()=>$8a97fa493a4d7e02$export$290f3472231a2ca1);
    $parcel$export(module.exports, "isModifierRegex", ()=>$8a97fa493a4d7e02$export$56079d3966b6b26c);
    $parcel$export(module.exports, "isComplexOperatorRegex", ()=>$8a97fa493a4d7e02$export$3f6ac43c2355116b);
    $parcel$export(module.exports, "isWSRegex", ()=>$8a97fa493a4d7e02$export$b1b0fc0dc5c83a12);
    $parcel$export(module.exports, "isIdentifierRegex", ()=>$8a97fa493a4d7e02$export$218cf3eb73c65394);
    $parcel$export(module.exports, "isLogicalOperatorRegex", ()=>$8a97fa493a4d7e02$export$a46484930d6fa80f);
    $parcel$export(module.exports, "isOperatorRegex", ()=>$8a97fa493a4d7e02$export$d48805fc5b137dc9);
    const $8a97fa493a4d7e02$export$e92b897d610f2aba = [
        'WHITE_SPACE',
        'SEPARATOR',
        'IDENTIFIER',
        'MODIFIER',
        'KEYWORD',
        'LOGICAL_OPERATOR',
        'STRING_LITERAL',
        'NUMBER_LITERAL',
        'BOOLEAN_LITERAL',
        'NULL_LITERAL',
        'OPERATOR'
    ];
    const $8a97fa493a4d7e02$export$9ce7f372949a1546 = '(';
    const $8a97fa493a4d7e02$export$bbbb3f477a9839e0 = ')';
    const $8a97fa493a4d7e02$export$adbc66edc544fda9 = '=';
    const $8a97fa493a4d7e02$export$fbd271ef020db0c = '!=';
    const $8a97fa493a4d7e02$export$ea7497008076d6d2 = ':';
    const $8a97fa493a4d7e02$export$6d44219c9e0c2567 = '!:';
    const $8a97fa493a4d7e02$export$f8636d23c210043c = '<';
    const $8a97fa493a4d7e02$export$1892bd0c818db570 = '<=';
    const $8a97fa493a4d7e02$export$386b1ae18a32d690 = '>';
    const $8a97fa493a4d7e02$export$44a62afa61d82568 = '>=';
    const $8a97fa493a4d7e02$export$e75c84803c67e1f4 = [
        $8a97fa493a4d7e02$export$adbc66edc544fda9,
        $8a97fa493a4d7e02$export$f8636d23c210043c,
        $8a97fa493a4d7e02$export$1892bd0c818db570,
        $8a97fa493a4d7e02$export$386b1ae18a32d690,
        $8a97fa493a4d7e02$export$44a62afa61d82568
    ];
    const $8a97fa493a4d7e02$export$61308b2610174a70 = 'AND';
    const $8a97fa493a4d7e02$export$1de654320eb3e523 = 'OR';
    const $8a97fa493a4d7e02$export$184522872a5410fc = 'not';
    const $8a97fa493a4d7e02$export$ff7eed6ac2251302 = 'true';
    const $8a97fa493a4d7e02$export$4b436fec6f13b741 = 'false';
    const $8a97fa493a4d7e02$export$8cbc171ac4843075 = [
        $8a97fa493a4d7e02$export$ff7eed6ac2251302,
        $8a97fa493a4d7e02$export$4b436fec6f13b741
    ];
    const $8a97fa493a4d7e02$export$347c7cb6285a1d61 = '"';
    const $8a97fa493a4d7e02$export$d84ab70dc909b702 = "'";
    const $8a97fa493a4d7e02$export$910131ff5cd3d496 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}open${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
    const $8a97fa493a4d7e02$export$2aa0d26cb4549272 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}closed${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
    const $8a97fa493a4d7e02$export$572cec90aa166025 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}acknowledged${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
    const $8a97fa493a4d7e02$export$f94109650ec67751 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}snoozed${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
    const $8a97fa493a4d7e02$export$3a3a37e9da45a2a4 = [
        $8a97fa493a4d7e02$export$910131ff5cd3d496,
        $8a97fa493a4d7e02$export$2aa0d26cb4549272,
        $8a97fa493a4d7e02$export$572cec90aa166025,
        $8a97fa493a4d7e02$export$f94109650ec67751
    ];
    const $8a97fa493a4d7e02$export$928c1edd572e94f0 = 'P1';
    const $8a97fa493a4d7e02$export$22202070e5f64c55 = 'P2';
    const $8a97fa493a4d7e02$export$537865d58d2072a3 = 'P3';
    const $8a97fa493a4d7e02$export$3d5cfea3feefee83 = 'P4';
    const $8a97fa493a4d7e02$export$fe945cac89cd21a5 = 'P5';
    const $8a97fa493a4d7e02$export$9ef3f42fa10fce44 = [
        $8a97fa493a4d7e02$export$928c1edd572e94f0,
        $8a97fa493a4d7e02$export$22202070e5f64c55,
        $8a97fa493a4d7e02$export$537865d58d2072a3,
        $8a97fa493a4d7e02$export$3d5cfea3feefee83,
        $8a97fa493a4d7e02$export$fe945cac89cd21a5
    ];
    const $8a97fa493a4d7e02$export$c2b6d31a7a2d40ba = 'null';
    const $8a97fa493a4d7e02$export$5a484b762b542c13 = 'actions';
    const $8a97fa493a4d7e02$export$21c480ed86e9d13 = 'alias';
    const $8a97fa493a4d7e02$export$534c195089710c34 = 'closedBy';
    const $8a97fa493a4d7e02$export$4699ad3805947d4d = 'count';
    const $8a97fa493a4d7e02$export$7c3401d7874d69f5 = 'createdAt';
    const $8a97fa493a4d7e02$export$afffcbd5b444e040 = 'description';
    const $8a97fa493a4d7e02$export$e1e61c3bf43fff11 = 'details.key';
    const $8a97fa493a4d7e02$export$aa35da9746edbfe2 = 'details.value';
    const $8a97fa493a4d7e02$export$b620b7163533b409 = 'detailsPair';
    const $8a97fa493a4d7e02$export$2a30b5099ba66c99 = 'entity';
    const $8a97fa493a4d7e02$export$2bfb49435a331d16 = 'integration.name';
    const $8a97fa493a4d7e02$export$feced558810f4b3e = 'integration.type';
    const $8a97fa493a4d7e02$export$7926b4c2836db847 = 'isSeen';
    const $8a97fa493a4d7e02$export$5a8895646b1d5248 = 'message';
    const $8a97fa493a4d7e02$export$4047502bdab1e205 = 'owner';
    const $8a97fa493a4d7e02$export$5922c06b76ebb57d = 'priority';
    const $8a97fa493a4d7e02$export$1122634b5d555f05 = 'components';
    const $8a97fa493a4d7e02$export$ec912454cd7d858a = 'services';
    const $8a97fa493a4d7e02$export$44673ddac1790242 = 'responders';
    const $8a97fa493a4d7e02$export$f250d53474e801dc = 'source';
    const $8a97fa493a4d7e02$export$43181828ba8680e4 = 'status';
    const $8a97fa493a4d7e02$export$a1959e1b76e880dd = 'sync.name';
    const $8a97fa493a4d7e02$export$8417ff61f7a57db6 = 'sync.type';
    const $8a97fa493a4d7e02$export$8242733866920892 = 'tags';
    const $8a97fa493a4d7e02$export$c833829cf31052f0 = 'tinyId';
    const $8a97fa493a4d7e02$export$78d4faf48faf13c2 = 'updatedAt';
    const $8a97fa493a4d7e02$export$5f1e5c89a704810f = 'acknowledged';
    const $8a97fa493a4d7e02$export$89d93eb7117999c0 = 'acknowledgedBy';
    const $8a97fa493a4d7e02$export$1ee0ad656333fc23 = 'aggregatorIds';
    const $8a97fa493a4d7e02$export$d42da2034504d6de = 'alertId';
    const $8a97fa493a4d7e02$export$8464a15b62fb09bb = 'alertType';
    const $8a97fa493a4d7e02$export$2f7ba2848fc019c6 = 'encrypted';
    const $8a97fa493a4d7e02$export$86e4b68c61c8cca5 = 'encryptionId';
    const $8a97fa493a4d7e02$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
    const $8a97fa493a4d7e02$export$8508b76d4c14d7e = 'notify';
    const $8a97fa493a4d7e02$export$e73ddf8d219f28b7 = 'snoozedUntil';
    const $8a97fa493a4d7e02$export$a79eb1864dd7b745 = 'teams';
    const $8a97fa493a4d7e02$export$888a9cda49b5e18c = [
        $8a97fa493a4d7e02$export$5f1e5c89a704810f,
        $8a97fa493a4d7e02$export$89d93eb7117999c0,
        $8a97fa493a4d7e02$export$1ee0ad656333fc23,
        $8a97fa493a4d7e02$export$d42da2034504d6de,
        $8a97fa493a4d7e02$export$8464a15b62fb09bb,
        $8a97fa493a4d7e02$export$2f7ba2848fc019c6,
        $8a97fa493a4d7e02$export$86e4b68c61c8cca5,
        $8a97fa493a4d7e02$export$cd9dc7ab4d04d11c,
        $8a97fa493a4d7e02$export$8508b76d4c14d7e,
        $8a97fa493a4d7e02$export$e73ddf8d219f28b7,
        $8a97fa493a4d7e02$export$a79eb1864dd7b745,
        $8a97fa493a4d7e02$export$5a484b762b542c13,
        $8a97fa493a4d7e02$export$21c480ed86e9d13,
        $8a97fa493a4d7e02$export$534c195089710c34,
        $8a97fa493a4d7e02$export$4699ad3805947d4d,
        $8a97fa493a4d7e02$export$7c3401d7874d69f5,
        $8a97fa493a4d7e02$export$afffcbd5b444e040,
        $8a97fa493a4d7e02$export$e1e61c3bf43fff11,
        $8a97fa493a4d7e02$export$aa35da9746edbfe2,
        $8a97fa493a4d7e02$export$b620b7163533b409,
        $8a97fa493a4d7e02$export$2a30b5099ba66c99,
        $8a97fa493a4d7e02$export$2bfb49435a331d16,
        $8a97fa493a4d7e02$export$feced558810f4b3e,
        $8a97fa493a4d7e02$export$7926b4c2836db847,
        $8a97fa493a4d7e02$export$5a8895646b1d5248,
        $8a97fa493a4d7e02$export$4047502bdab1e205,
        $8a97fa493a4d7e02$export$5922c06b76ebb57d,
        $8a97fa493a4d7e02$export$44673ddac1790242,
        $8a97fa493a4d7e02$export$1122634b5d555f05,
        $8a97fa493a4d7e02$export$ec912454cd7d858a,
        $8a97fa493a4d7e02$export$f250d53474e801dc,
        $8a97fa493a4d7e02$export$43181828ba8680e4,
        $8a97fa493a4d7e02$export$a1959e1b76e880dd,
        $8a97fa493a4d7e02$export$8417ff61f7a57db6,
        $8a97fa493a4d7e02$export$8242733866920892,
        $8a97fa493a4d7e02$export$c833829cf31052f0,
        $8a97fa493a4d7e02$export$78d4faf48faf13c2
    ];
    const $8a97fa493a4d7e02$export$60745b712d37edf9 = [
        $8a97fa493a4d7e02$export$5f1e5c89a704810f,
        $8a97fa493a4d7e02$export$7926b4c2836db847
    ];
    const $8a97fa493a4d7e02$export$b38df7dc61d42293 = [
        ...$8a97fa493a4d7e02$export$888a9cda49b5e18c
    ];
    const $8a97fa493a4d7e02$var$splitToTokensCases = [
        ...[
            $8a97fa493a4d7e02$export$d84ab70dc909b702,
            $8a97fa493a4d7e02$export$347c7cb6285a1d61
        ].map((i)=>`(${i}.*?${i})`),
        ...[
            $8a97fa493a4d7e02$export$d84ab70dc909b702,
            $8a97fa493a4d7e02$export$347c7cb6285a1d61
        ].map((i)=>`(${i}.*)`),
        ...[
            $8a97fa493a4d7e02$export$9ce7f372949a1546,
            $8a97fa493a4d7e02$export$bbbb3f477a9839e0,
            $8a97fa493a4d7e02$export$adbc66edc544fda9,
            $8a97fa493a4d7e02$export$fbd271ef020db0c,
            $8a97fa493a4d7e02$export$ea7497008076d6d2,
            $8a97fa493a4d7e02$export$6d44219c9e0c2567,
            $8a97fa493a4d7e02$export$44a62afa61d82568,
            $8a97fa493a4d7e02$export$386b1ae18a32d690,
            $8a97fa493a4d7e02$export$1892bd0c818db570,
            $8a97fa493a4d7e02$export$f8636d23c210043c
        ].map((i)=>`(\\${i})`),
        ...[
            $8a97fa493a4d7e02$export$61308b2610174a70,
            $8a97fa493a4d7e02$export$1de654320eb3e523,
            $8a97fa493a4d7e02$export$ff7eed6ac2251302,
            $8a97fa493a4d7e02$export$4b436fec6f13b741,
            $8a97fa493a4d7e02$export$184522872a5410fc,
            `is\\s*null`,
            `is\\s*not\\s*null`
        ].map((i)=>`(\\b${i}(?=\\s|$))`),
        '(\\s+)'
    ];
    const $8a97fa493a4d7e02$export$28041d1d2a85f002 = new RegExp($8a97fa493a4d7e02$var$splitToTokensCases.join('|'), 'gi');
    const $8a97fa493a4d7e02$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
    const $8a97fa493a4d7e02$export$56079d3966b6b26c = /^not$/i;
    const $8a97fa493a4d7e02$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
    const $8a97fa493a4d7e02$export$b1b0fc0dc5c83a12 = /^\s+$/;
    const $8a97fa493a4d7e02$export$218cf3eb73c65394 = new RegExp($8a97fa493a4d7e02$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
    const $8a97fa493a4d7e02$export$a46484930d6fa80f = /^and$|^or$/i;
    const $8a97fa493a4d7e02$export$d48805fc5b137dc9 = /^[=:<>]$/;
});
parcelRegister("5F4Xi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e43ae1f84d6f7300$export$2e2bcd8739ae039);
    var $7VHMR;
    const $e43ae1f84d6f7300$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        validationMessageBeforeGreaterThanAfter: {
            id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
            defaultMessage: "'Before' field cannot be later than 'After' field.",
            description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
        },
        validationMessageInvalidDateFormat: {
            id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
            defaultMessage: 'Invalid date format.',
            description: 'Invalid date format.'
        },
        validNumber: {
            id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
            defaultMessage: 'Enter a valid number.',
            description: 'The error message that shown when user write different chars other than numeric chars.'
        },
        hoursNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-99999.',
            description: 'Message displayed to the user when hours value is not in range'
        },
        daysNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-9999.',
            description: 'Message displayed to the user when days value is not in range'
        },
        weeksNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-999.',
            description: 'Message displayed to the user when weeks value is not in range'
        },
        monthsNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-99.',
            description: 'Message displayed to the user when months value is not in range'
        },
        yearsNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-9.',
            description: 'Message displayed to the user when years value is not in range'
        }
    });
    var $e43ae1f84d6f7300$export$2e2bcd8739ae039 = $e43ae1f84d6f7300$var$messages;
});
parcelRegister("gQ8M0", function(module, exports) {
    $parcel$export(module.exports, "compressionRatioResource", ()=>$e8d6c20659375806$export$8c912e73f758af2);
    var $dIdda = parcelRequire("dIdda");
    var $5AHJS;
    const $e8d6c20659375806$var$emptyCompressionBanner = {
        compressionRatio: 0,
        uniqueGroupCount: 0,
        rollingWindow: 0
    };
    const $e8d6c20659375806$export$8c912e73f758af2 = (0, $dIdda.createResource)({
        type: 'compressionRatioResource',
        getKey: ()=>'compressionRatioResource',
        getData: async ()=>{
            try {
                const response = await (0, (0, parcelRequire("5AHJS")).getCompressionRatio)();
                return response;
            } catch (e) {
                return $e8d6c20659375806$var$emptyCompressionBanner;
            }
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("5AHJS", function(module, exports) {
    $parcel$export(module.exports, "getCompressionRatio", ()=>$c815f27666ee738a$export$4991457f359db4f7);
    var $j74qU;
    var $1Z10l;
    const $c815f27666ee738a$export$4991457f359db4f7 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("1Z10l")).withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
            exactUrl: true
        });
    };
});
parcelRegister("oacWJ", function(module, exports) {
    $parcel$export(module.exports, "savedSearchesResource", ()=>$2aab5bfe07b93543$export$d915b849e6dd786b);
    var $dIdda = parcelRequire("dIdda");
    var $6IJKZ;
    const $2aab5bfe07b93543$export$d915b849e6dd786b = (0, $dIdda.createResource)({
        type: 'savedSearchesResource',
        getKey: ()=>'savedSearchesResource',
        getData: ()=>(0, (0, parcelRequire("6IJKZ")).getSavedSearchesEndpoint)(),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("6IJKZ", function(module, exports) {
    $parcel$export(module.exports, "getSavedSearchesEndpoint", ()=>$2b3a64f0a6563850$export$3b7b44889eb94cd0);
    $parcel$export(module.exports, "createSavedSearchEndpoint", ()=>$2b3a64f0a6563850$export$4976332c0ec66407);
    $parcel$export(module.exports, "deleteSearchEndpoint", ()=>$2b3a64f0a6563850$export$401da4a793944201);
    var $j74qU;
    const $2b3a64f0a6563850$export$3b7b44889eb94cd0 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/alerts/saved-searches');
    };
    const $2b3a64f0a6563850$export$4976332c0ec66407 = (data)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/alerts/saved-searches', {
            method: 'POST',
            body: data
        });
    };
    const $2b3a64f0a6563850$export$401da4a793944201 = (id)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/saved-searches/${id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
});
parcelRegister("dqLIo", function(module, exports) {
    $parcel$export(module.exports, "uiPreferencesResource", ()=>$f86ed58750791981$export$4e143f0fe4b2e025);
    var $dIdda = parcelRequire("dIdda");
    var $fY9nC;
    const $f86ed58750791981$export$4e143f0fe4b2e025 = (0, $dIdda.createResource)({
        type: 'uiPreferencesResource',
        getKey: ()=>'uiPreferencesResource',
        getData: ()=>(0, (0, parcelRequire("fY9nC")).getUiPreferencesEndpoint)(),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("fY9nC", function(module, exports) {
    $parcel$export(module.exports, "getUiPreferencesEndpoint", ()=>$838fb476cee34593$export$afa4854419ed2fc8);
    $parcel$export(module.exports, "updateUiPreferencesEndpoint", ()=>$838fb476cee34593$export$4990793476d8f783);
    var $j74qU;
    const $838fb476cee34593$export$afa4854419ed2fc8 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/alerts/ui-preferences');
    };
    const $838fb476cee34593$export$4990793476d8f783 = (data)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/alerts/ui-preferences', {
            method: 'PATCH',
            body: data
        });
    };
});
parcelRegister("E6d9p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("39Zx1")
    ]).then(()=>parcelRequire('2kjD7'));
});
parcelRegister("5CJ70", function(module, exports) {
    $parcel$export(module.exports, "eocGlobalAlertDetailRoute", ()=>$f4309291528957cf$export$4c5c22da74ff47b1);
    $parcel$export(module.exports, "eocGlobalAlertListRoute", ()=>$f4309291528957cf$export$29721341dde2ed3d);
    var $65Ltd;
    const $f4309291528957cf$export$4c5c22da74ff47b1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
        path: '/jira/ops/alerts/:id',
        exact: true
    };
    const $f4309291528957cf$export$29721341dde2ed3d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS),
        path: '/jira/ops/alerts',
        exact: true
    };
});
parcelRegister("d8hKi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1Z4yj")
    ]).then(()=>parcelRequire('cHlJB'));
});
parcelRegister("eYyoJ", function(module, exports) {
    $parcel$export(module.exports, "groupHeaderResource", ()=>$3cd6727337445c45$export$e6ba56f6b67069c8);
    $parcel$export(module.exports, "aiSuggestionsResource", ()=>$3cd6727337445c45$export$94675faef1d4568b);
    $parcel$export(module.exports, "resources", ()=>$3cd6727337445c45$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $2LFOe;
    const $3cd6727337445c45$export$e6ba56f6b67069c8 = (0, $dIdda.createResource)({
        type: 'groupHeaderResource',
        getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const groupId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!groupId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
            return (0, (0, parcelRequire("2LFOe")).getHeaderDetails)(groupId);
        },
        isBrowserOnly: true
    });
    const $3cd6727337445c45$export$94675faef1d4568b = (0, $dIdda.createResource)({
        type: 'aiSuggestionsResource',
        getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const groupId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!groupId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
            return (0, (0, parcelRequire("2LFOe")).getAISuggestions)(groupId);
        },
        isBrowserOnly: true
    });
    const $3cd6727337445c45$export$bc99aaabaf7b70a7 = [
        $3cd6727337445c45$export$e6ba56f6b67069c8,
        $3cd6727337445c45$export$94675faef1d4568b
    ];
});
parcelRegister("2LFOe", function(module, exports) {
    $parcel$export(module.exports, "getHeaderDetails", ()=>$1301a416506333ce$export$c0f2e4bfcbff05d1);
    $parcel$export(module.exports, "getAISuggestions", ()=>$1301a416506333ce$export$34bb7a15a54039a5);
    $parcel$export(module.exports, "addGroupAssignee", ()=>$1301a416506333ce$export$bd5bdebdb6d9abb);
    $parcel$export(module.exports, "actionOnGroup", ()=>$1301a416506333ce$export$5353a5d2604523c0);
    $parcel$export(module.exports, "getAlertCountForGroupAction", ()=>$1301a416506333ce$export$b47efb0a9602f0c8);
    var $j74qU;
    var $iZjKh;
    const $1301a416506333ce$export$c0f2e4bfcbff05d1 = (groupId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
            exactUrl: true
        });
    const $1301a416506333ce$export$34bb7a15a54039a5 = (groupId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
            exactUrl: true
        });
    const $1301a416506333ce$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
            method: 'PUT',
            exactUrl: true
        });
    const $1301a416506333ce$export$5353a5d2604523c0 = (groupId, action, payload = {})=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/alert-insights/bulk-action`), {
            method: 'PUT',
            exactUrl: true,
            body: {
                groupId: groupId,
                actionType: action,
                ...payload
            }
        });
    };
    const $1301a416506333ce$export$b47efb0a9602f0c8 = (groupId, action)=>{
        const urlSearchParams = new URLSearchParams();
        urlSearchParams.set('actionType', action);
        urlSearchParams.set('groupId', groupId);
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/alert-insights/check-all-action?${urlSearchParams}`), {
            exactUrl: true
        });
    };
});
parcelRegister("iZjKh", function(module, exports) {
    $parcel$export(module.exports, "withAIOpsPrefix", ()=>$1bb9bc334d3aa5dc$export$5ad74397753c99a2);
    var $VSDnB;
    var $030R0;
    const $1bb9bc334d3aa5dc$export$5ad74397753c99a2 = (input)=>{
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("VSDnB")).getBooleanFF)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
});
parcelRegister("115sl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dTpji")
    ]).then(()=>parcelRequire('9kpiP'));
});
parcelRegister("90XDC", function(module, exports) {
    $parcel$export(module.exports, "heartbeatsResource", ()=>$ba57cdfcb9409883$export$dd38e2aa5cfda9c9);
    $parcel$export(module.exports, "heartbeatsUserRightsResource", ()=>$ba57cdfcb9409883$export$b5d9a0bcdfa848ce);
    $parcel$export(module.exports, "resources", ()=>$ba57cdfcb9409883$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $6dFjI;
    const $ba57cdfcb9409883$export$dd38e2aa5cfda9c9 = (0, $dIdda.createResource)({
        type: 'heartbeatsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `heartbeats/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return;
            return (0, (0, parcelRequire("6dFjI")).getHeartbeatsEndpoint)(teamId);
        },
        isBrowserOnly: true
    });
    const $ba57cdfcb9409883$export$b5d9a0bcdfa848ce = (0, $dIdda.createResource)({
        type: 'heartbeatsUserRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `heartbeats-user-rights/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("6dFjI")).getHeartbeatsUserRights)(teamId);
        },
        isBrowserOnly: true
    });
    const $ba57cdfcb9409883$export$bc99aaabaf7b70a7 = [
        $ba57cdfcb9409883$export$dd38e2aa5cfda9c9,
        $ba57cdfcb9409883$export$b5d9a0bcdfa848ce
    ];
});
parcelRegister("6dFjI", function(module, exports) {
    $parcel$export(module.exports, "getHeartbeatsEndpoint", ()=>$9fd5e861ed04ddb5$export$c322dad372dcb08b);
    $parcel$export(module.exports, "validateHeartbeatNameEndpoint", ()=>$9fd5e861ed04ddb5$export$676f6aee59f124b0);
    $parcel$export(module.exports, "createHeartbeatEndpoint", ()=>$9fd5e861ed04ddb5$export$891ea85cc6973b32);
    $parcel$export(module.exports, "updateHeartbeatEndpoint", ()=>$9fd5e861ed04ddb5$export$7311481b59e02e06);
    $parcel$export(module.exports, "switchHeartbeatEndpoint", ()=>$9fd5e861ed04ddb5$export$5df993f1c74d7e8e);
    $parcel$export(module.exports, "deleteHeartbeatEndpoint", ()=>$9fd5e861ed04ddb5$export$716e365975fc2cd1);
    $parcel$export(module.exports, "getHeartbeatsUserRights", ()=>$9fd5e861ed04ddb5$export$26eaca11f3b4e506);
    $parcel$export(module.exports, "updateAutoCreationEndpoint", ()=>$9fd5e861ed04ddb5$export$38097aade6a3b234);
    var $j74qU;
    const $9fd5e861ed04ddb5$export$c322dad372dcb08b = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'GET'
        });
    const $9fd5e861ed04ddb5$export$676f6aee59f124b0 = (teamId, heartbeatName)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
            method: 'GET',
            responseType: 'headers'
        });
    const $9fd5e861ed04ddb5$export$891ea85cc6973b32 = (teamId, heartbeat)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'POST',
            body: heartbeat
        });
    const $9fd5e861ed04ddb5$export$7311481b59e02e06 = (teamId, heartbeat)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'PUT',
            body: heartbeat
        });
    const $9fd5e861ed04ddb5$export$5df993f1c74d7e8e = (teamId, enable, name)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
            method: 'PATCH'
        });
    const $9fd5e861ed04ddb5$export$716e365975fc2cd1 = (teamId, name)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats?name=${encodeURIComponent(name)}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    const $9fd5e861ed04ddb5$export$26eaca11f3b4e506 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/rights`);
    };
    const $9fd5e861ed04ddb5$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
            method: 'POST',
            responseType: 'headers'
        });
});
parcelRegister("8074j", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5jEdq")
    ]).then(()=>parcelRequire('4uAlQ'));
});
parcelRegister("ffEPd", function(module, exports) {
    $parcel$export(module.exports, "detailResource", ()=>$d2ad11d314356b50$export$13d78d45f8054f1e);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $bKopM;
    const $d2ad11d314356b50$export$13d78d45f8054f1e = (0, $dIdda.createResource)({
        type: 'getDetailResource',
        getKey: ()=>'getDetailResource',
        getData: async (routerContext)=>{
            const id = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!id, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
            return (0, (0, parcelRequire("bKopM")).getDetail)(id);
        },
        isBrowserOnly: true
    });
});
parcelRegister("bKopM", function(module, exports) {
    $parcel$export(module.exports, "getDetail", ()=>$3e9eec2aa2136224$export$d6c3faeb2ce9d297);
    var $j74qU;
    var $7PepW;
    const $3e9eec2aa2136224$export$d6c3faeb2ce9d297 = (id)=>{
        const endpoint = `${(0, (0, parcelRequire("7PepW")).urls).incomingCall.detail.url(id)}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(endpoint);
    };
});
parcelRegister("7PepW", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$5edaa37a3b09374b$export$bcae9ba627f604b6);
    const $5edaa37a3b09374b$export$bcae9ba627f604b6 = Object.freeze({
        incomingCall: {
            url: ()=>`/v1/incoming-call`,
            detail: {
                url: (incomingCallId = ':incomingCallId')=>`${$5edaa37a3b09374b$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
            }
        }
    });
});
parcelRegister("3zzQS", function(module, exports) {
    $parcel$export(module.exports, "listResource", ()=>$c316e599070576e5$export$5ee018e9baf9d633);
    var $eURsm;
    var $9FZzU;
    const $c316e599070576e5$export$5ee018e9baf9d633 = (0, (0, parcelRequire("eURsm")).createPaginatedResource)({
        type: 'getListResource',
        getKey: ()=>'getListResource',
        getData: ()=>(0, (0, parcelRequire("9FZzU")).getList),
        isBrowserOnly: true
    });
});
parcelRegister("eURsm", function(module, exports) {
    $parcel$export(module.exports, "createPaginatedResource", ()=>$9723334731b55493$export$561b032e4d26d1e8);
    var $dIdda = parcelRequire("dIdda");
    const $9723334731b55493$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
        return (0, $dIdda.createResource)({
            ...arg,
            getKey: (routerContext, customContext)=>{
                const { query: query } = routerContext;
                const page = query['page'] || '1';
                const key = `${getKey(routerContext, customContext)}#${page}`;
                return key;
            },
            getData: (routerContext, customContext)=>{
                const { query: query } = routerContext;
                const page = parseInt(query['page']) || 1;
                return getData(routerContext, customContext)({
                    page: page
                });
            }
        });
    };
});
parcelRegister("9FZzU", function(module, exports) {
    $parcel$export(module.exports, "getList", ()=>$3bbdbabf459bda32$export$73fffd6dda5144e);
    $parcel$export(module.exports, "addIncomingCall", ()=>$3bbdbabf459bda32$export$cdae09ff00c893b2);
    var $j74qU;
    var $7PepW;
    const $3bbdbabf459bda32$export$73fffd6dda5144e = ({ page: page })=>{
        const limit = 20;
        const offset = (page - 1) * limit;
        const params = new URLSearchParams({
            offset: `${offset}`,
            limit: `${limit}`,
            sortBy: 'name',
            sort: 'asc'
        });
        const endpoint = `${(0, (0, parcelRequire("7PepW")).urls).incomingCall.url()}?${params.toString()}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(endpoint).then(({ data: data, count: count })=>{
            return {
                data: data,
                count: Math.ceil(count / limit)
            };
        });
    };
    const $3bbdbabf459bda32$export$cdae09ff00c893b2 = (params)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("7PepW")).urls).incomingCall.url(), {
            method: 'POST',
            body: params
        });
    };
});
parcelRegister("4DnHd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dXV8c")
    ]).then(()=>parcelRequire('8oycJ'));
});
parcelRegister("cekVR", function(module, exports) {
    $parcel$export(module.exports, "byokInformationResource", ()=>$3c6fb796f140225d$export$c6b84cb74d1ed3b9);
    var $dIdda = parcelRequire("dIdda");
    var $kymuO;
    const $3c6fb796f140225d$export$c6b84cb74d1ed3b9 = (0, $dIdda.createResource)({
        type: 'byok-information-resource',
        getKey: ()=>'byok-information-resource',
        getData: async ()=>(0, (0, parcelRequire("kymuO")).fetchByokInformation)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("kymuO", function(module, exports) {
    $parcel$export(module.exports, "fetchByokInformation", ()=>$bccedcaa672f11fe$export$5244b5a582b643da);
    var $j74qU;
    const $bccedcaa672f11fe$export$5244b5a582b643da = async ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/customers/byok-setting');
    };
});
parcelRegister("k5TFj", function(module, exports) {
    $parcel$export(module.exports, "downloadAuditLogsResource", ()=>$62049603e7f7b61b$export$304da75014b88b78);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $kg5A9;
    const $62049603e7f7b61b$export$304da75014b88b78 = (0, $dIdda.createResource)({
        type: 'download-audit-logs-resource',
        getKey: ()=>'download-audit-logs-resource',
        getData: async (routerContext)=>{
            const uniqueKey = routerContext.match.params.exportUniqueKey;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!uniqueKey, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
            return (0, (0, parcelRequire("kg5A9")).fetchDownloadLinkEndpoint)(uniqueKey);
        },
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("kg5A9", function(module, exports) {
    $parcel$export(module.exports, "fetchDownloadLinkEndpoint", ()=>$7bc9ff634e8ba041$export$c8df7e5942ba1d96);
    var $j74qU;
    const $7bc9ff634e8ba041$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
            responseType: 'text'
        });
    };
});
parcelRegister("8qZNT", function(module, exports) {
    $parcel$export(module.exports, "logsResource", ()=>$37d900392ed354d4$export$fd88b4310d3f52ff);
    var $dIdda = parcelRequire("dIdda");
    var $kWKaa;
    const $37d900392ed354d4$export$fd88b4310d3f52ff = (0, $dIdda.createResource)({
        type: 'ui-get-logs',
        getKey: (routerContext)=>{
            const integrationId = routerContext.match.params.integrationId;
            const urlParam = new URLSearchParams();
            Object.entries(routerContext.query).forEach(([key, value])=>{
                if (value) urlParam.set(key, value);
            });
            return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
        },
        getData: async (routerContext)=>{
            return (0, (0, parcelRequire("kWKaa")).fetchLogs)({
                fromUnit: routerContext.query?.fromUnit,
                fromValue: routerContext.query?.fromValue,
                startTimestamp: routerContext.query?.startTimestamp,
                endTimestamp: routerContext.query?.endTimestamp,
                eventCategories: routerContext.query?.eventCategories,
                levels: routerContext.query?.levels,
                size: routerContext.query?.size ?? 30,
                insertedAt: routerContext.query?.insertedAt,
                searchString: routerContext.query?.searchString,
                pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
                integrationId: routerContext.match.params.integrationId
            });
        },
        maxAge: 60000,
        isBrowserOnly: true
    });
});
parcelRegister("kWKaa", function(module, exports) {
    $parcel$export(module.exports, "fetchLogs", ()=>$ccc9d84c3a4ba264$export$b9fcc8145a518db4);
    var $j74qU;
    var $7sija;
    const $ccc9d84c3a4ba264$export$b9fcc8145a518db4 = async (params)=>{
        const urlParams = (0, (0, parcelRequire("7sija")).generateLogParams)(params);
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, (0, parcelRequire("7sija")).postProcessLogsSearch)(urlParams, response));
    };
});
parcelRegister("7sija", function(module, exports) {
    $parcel$export(module.exports, "isValidTimePeriodFormat", ()=>$102956f839e5f725$export$2214112898027187);
    $parcel$export(module.exports, "getBetweenErrorMessage", ()=>$102956f839e5f725$export$b29a6f1d6d345720);
    $parcel$export(module.exports, "isValidBetweenInput", ()=>$102956f839e5f725$export$7b619dd534dac336);
    $parcel$export(module.exports, "isInvalidDateValue", ()=>$102956f839e5f725$export$f18cd4bc58b99a27);
    $parcel$export(module.exports, "checkQueryIncludesValue", ()=>$102956f839e5f725$export$792d5c0a6d15a15e);
    $parcel$export(module.exports, "parseGroupOptionQuery", ()=>$102956f839e5f725$export$f344cca10df5ca13);
    $parcel$export(module.exports, "parseOptionQuery", ()=>$102956f839e5f725$export$100c2d7fc380fbfa);
    $parcel$export(module.exports, "collectQueryParamsFromOptions", ()=>$102956f839e5f725$export$4db9080fab1bce85);
    $parcel$export(module.exports, "calculateTimeBetween", ()=>$102956f839e5f725$export$42dac873831f0e2);
    $parcel$export(module.exports, "generateLogParams", ()=>$102956f839e5f725$export$85293a2f3995ddcc);
    $parcel$export(module.exports, "fromUnitConverter", ()=>$102956f839e5f725$export$ae02811946c03a4b);
    $parcel$export(module.exports, "createBaseQuery", ()=>$102956f839e5f725$export$9a8301702bf003c4);
    $parcel$export(module.exports, "calculateNewStartAndEndTimestamp", ()=>$102956f839e5f725$export$b06db0f8b326b929);
    $parcel$export(module.exports, "isDetailsSectionEmpty", ()=>$102956f839e5f725$export$74cb10c4b9924e49);
    $parcel$export(module.exports, "generateParamsForOneMonthInterval", ()=>$102956f839e5f725$export$130612b33e678a37);
    $parcel$export(module.exports, "calculateWidthAccordingToLevel", ()=>$102956f839e5f725$export$e083dc64e00e053b);
    $parcel$export(module.exports, "getSourceStringFromUrl", ()=>$102956f839e5f725$export$c6631e198cf7c0f4);
    $parcel$export(module.exports, "makeMarkup", ()=>$102956f839e5f725$export$59302306c6f78677);
    $parcel$export(module.exports, "postProcessLogsSearch", ()=>$102956f839e5f725$export$9a858fe3837c0be0);
    var $5uXOq = parcelRequire("5uXOq");
    var $grR0x;
    var $jj52j;
    var $jovBr;
    var $eZDAP;
    var $gn1v9;
    var $gccSB = parcelRequire("gccSB");
    var $hGgHi = parcelRequire("hGgHi");
    var $hmVmJ;
    var $dH6Pi;
    var $2VsTe;
    var $0yCO3;
    var $hu2ZI;
    var $9Pdtb;
    const $102956f839e5f725$var$isNumeric = (value)=>/^\d+$/.test(value);
    const $102956f839e5f725$export$2214112898027187 = (timeDigits, timeUnit)=>{
        return timeDigits === '' || timeDigits !== undefined && $102956f839e5f725$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, (0, parcelRequire("0yCO3")).RANGE_OPTIONS).includes(timeUnit);
    };
    const $102956f839e5f725$export$b29a6f1d6d345720 = (intl, value)=>{
        if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, (0, parcelRequire("9Pdtb")).default).validationMessageAtLeastOneValue);
        if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, (0, parcelRequire("9Pdtb")).default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.endDate)))) return intl.formatMessage((0, (0, parcelRequire("9Pdtb")).default).validationMessageInvalidDateFormat);
        return undefined;
    };
    const $102956f839e5f725$export$7b619dd534dac336 = (value)=>{
        if (!value?.startDate && !value?.endDate) return false;
        if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
        if (value && (value?.startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.endDate)))) return false;
        return true;
    };
    const $102956f839e5f725$export$f18cd4bc58b99a27 = (value)=>{
        return !(0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(value)) && value !== '';
    };
    const $102956f839e5f725$export$760bb1b75585fb94 = (value)=>{
        return value.map((event)=>event.value).join(',');
    };
    const $102956f839e5f725$export$792d5c0a6d15a15e = (query, value)=>{
        return query?.includes(value.toString()) ?? false;
    };
    const $102956f839e5f725$export$f344cca10df5ca13 = (query, options)=>{
        if (!query) return [];
        const labels = [];
        options.map((option)=>{
            option.options.map((item)=>labels.push(item));
        });
        return labels.filter(({ value: value })=>$102956f839e5f725$export$792d5c0a6d15a15e(query, value));
    };
    const $102956f839e5f725$export$100c2d7fc380fbfa = (query, options)=>{
        if (!query) return [];
        return options.filter((label)=>query.includes(label.value.toString()));
    };
    const $102956f839e5f725$export$422789958d8174dd = (unit)=>(0, (0, parcelRequire("0yCO3")).RANGE_OPTIONS).includes(unit);
    const $102956f839e5f725$export$4db9080fab1bce85 = (options)=>{
        return options.map((option)=>option.value).join(',');
    };
    const $102956f839e5f725$var$isTimeQueryParamsValid = (params)=>{
        if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
        else if (params.has('fromUnit') && params.has('fromValue')) return true;
        return false;
    };
    const $102956f839e5f725$export$42dac873831f0e2 = (params)=>{
        const now = new Date();
        if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
            const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
            switch(params.get('fromUnit')){
                case 'HOUR':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        hours: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'DAY':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        days: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'WEEK':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        weeks: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'MONTH':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        months: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
            }
            params.delete('fromUnit');
            params.delete('fromValue');
        }
        return params;
    };
    const $102956f839e5f725$export$85293a2f3995ddcc = (params)=>{
        const urlParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value])=>{
            if (value) urlParams.append(key, decodeURI(value));
        });
        if (!$102956f839e5f725$var$isTimeQueryParamsValid(urlParams)) {
            urlParams.delete('fromUnit');
            urlParams.delete('fromValue');
            urlParams.delete('startTimestamp');
            urlParams.delete('endTimestamp');
            urlParams.append('fromUnit', 'DAY');
            urlParams.append('fromValue', '1');
        }
        return $102956f839e5f725$export$42dac873831f0e2(urlParams);
    };
    const $102956f839e5f725$var$calculateTimeDifference = (startDate, endDate)=>{
        const minutesDiff = (0, (0, parcelRequire("grR0x")).default)(endDate, startDate);
        if (minutesDiff < 60) return {
            hours: 1,
            days: 0,
            weeks: 0,
            months: 0,
            years: 0
        };
        const hoursDiff = minutesDiff / 60;
        const daysDiff = minutesDiff / 60 / 24;
        const weeksDiff = minutesDiff / 60 / 24 / 7;
        const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
        return {
            hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
            days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
            weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
            months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
        };
    };
    const $102956f839e5f725$export$ae02811946c03a4b = (startDate, endDate)=>{
        const parsedStartDate = (0, (0, parcelRequire("eZDAP")).default)(startDate);
        const parsedEndDate = (0, (0, parcelRequire("eZDAP")).default)(endDate);
        const timeDifference = $102956f839e5f725$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
        if (timeDifference.months > 0) return {
            timeUnit: 'MONTH',
            timeDigits: timeDifference.months.toString()
        };
        else if (timeDifference.weeks > 0) return {
            timeUnit: 'WEEK',
            timeDigits: timeDifference.weeks.toString()
        };
        else if (timeDifference.days > 0) return {
            timeUnit: 'DAY',
            timeDigits: timeDifference.days.toString()
        };
        else return {
            timeUnit: 'HOUR',
            timeDigits: timeDifference.hours.toString()
        };
    };
    const $102956f839e5f725$export$9a8301702bf003c4 = (query)=>{
        let searchQuery = {};
        if (query.searchString) searchQuery = {
            ...searchQuery,
            searchString: query.searchString
        };
        if (query.startTimestamp && query.endTimestamp) searchQuery = {
            ...searchQuery,
            startTimestamp: query.startTimestamp,
            endTimestamp: query.endTimestamp
        };
        if (query.timeType) searchQuery = {
            ...searchQuery,
            timeType: query.timeType
        };
        if (query.eventCategories) searchQuery = {
            ...searchQuery,
            eventCategories: query.eventCategories
        };
        if (query.levels) searchQuery = {
            ...searchQuery,
            levels: query.levels
        };
        if (query.size) searchQuery = {
            ...searchQuery,
            size: query.size
        };
        return searchQuery;
    };
    function $102956f839e5f725$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
        const startDateIntValue = parseInt(startTimestamp) / (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND);
        const endDateIntValue = parseInt(endTimestamp) / (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND);
        const { timeDigits: fromValue, timeUnit: fromUnit } = $102956f839e5f725$export$ae02811946c03a4b((0, (0, parcelRequire("jj52j")).default)(startDateIntValue), (0, (0, parcelRequire("jj52j")).default)(endDateIntValue));
        const params = $102956f839e5f725$export$42dac873831f0e2(new URLSearchParams({
            fromValue: fromValue,
            fromUnit: fromUnit
        }));
        const startTimestampParams = params.get('startTimestamp');
        const endTimestampParams = params.get('endTimestamp');
        (0, (0, parcelRequire("hmVmJ")).assert)(!(0, ($parcel$interopDefault($hGgHi)))(startTimestampParams) && !(0, ($parcel$interopDefault($hGgHi)))(endTimestampParams), new (0, (0, parcelRequire("dH6Pi")).AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
        return {
            startTimestamp: startTimestampParams,
            endTimestamp: endTimestampParams
        };
    }
    const $102956f839e5f725$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
        if (!importantField || !raw) return true;
        const parsedImportantField = JSON.parse(importantField);
        const parsedRaw = JSON.parse(raw);
        return ((0, ($parcel$interopDefault($gccSB)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, ($parcel$interopDefault($gccSB)))(parsedRaw);
    };
    const $102956f839e5f725$export$130612b33e678a37 = ()=>{
        const params = $102956f839e5f725$export$42dac873831f0e2(new URLSearchParams({
            fromUnit: 'MONTH',
            fromValue: '1'
        }));
        const startDate = params.get('startTimestamp');
        const endDate = params.get('endTimestamp');
        (0, (0, parcelRequire("hmVmJ")).assert)(!!startDate && !!endDate, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
        return {
            dateTimeValue: {
                startDate: startDate,
                endDate: endDate
            },
            timeType: (0, (0, parcelRequire("2VsTe")).TimeRadioOptions).WITHIN_THE_LAST
        };
    };
    const $102956f839e5f725$export$e083dc64e00e053b = (level)=>{
        const BASE_OFFSET = 18;
        return `${(0, (0, parcelRequire("hu2ZI")).DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
    };
    const $102956f839e5f725$export$c6631e198cf7c0f4 = (search)=>{
        const splittedSearch = search.split(/source=/i);
        if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
        return '';
    };
    function $102956f839e5f725$export$59302306c6f78677(fragment, key) {
        const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
        if (nodeType === Node.TEXT_NODE) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: key
        }, textContent);
        const children = [];
        childNodes.forEach((childNode, i)=>{
            const markup = $102956f839e5f725$export$59302306c6f78677(childNode, String(i));
            if (markup) children.push(markup);
        });
        switch(nodeName){
            case 'B':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("b", {
                    key: key
                }, children);
            case 'I':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("i", {
                    key: key
                }, children);
            case 'STRONG':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("strong", {
                    key: key
                }, children);
            case 'EM':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("em", {
                    key: key
                }, children);
            case 'CODE':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("code", {
                    key: key
                }, children);
        }
        if (children.length === 1) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: key
        }, children[0]);
        if (children.length) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            key: key
        }, children);
        return null;
    }
    const $102956f839e5f725$export$9a858fe3837c0be0 = (urlParams, response)=>{
        if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
            ...response,
            data: {
                ...response.data,
                pagination: {
                    ...response.data.pagination,
                    calcStartDate: urlParams.get('startTimestamp'),
                    calcEndDate: urlParams.get('endTimestamp')
                }
            }
        };
        return response;
    };
});
parcelRegister("2VsTe", function(module, exports) {
    $parcel$export(module.exports, "TimeRadioOptions", ()=>$4e8f12ca8572dc61$export$ff1338756af30600);
    var $4e8f12ca8572dc61$export$ff1338756af30600;
    (function(TimeRadioOptions) {
        TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
        TimeRadioOptions["BETWEEN"] = "between";
    })($4e8f12ca8572dc61$export$ff1338756af30600 || ($4e8f12ca8572dc61$export$ff1338756af30600 = {}));
});
parcelRegister("0yCO3", function(module, exports) {
    $parcel$export(module.exports, "RANGE_OPTIONS", ()=>$928210b867587e62$export$a0f3448347834e6b);
    const $928210b867587e62$export$a0f3448347834e6b = [
        'HOUR',
        'DAY',
        'WEEK',
        'MONTH'
    ];
});
parcelRegister("hu2ZI", function(module, exports) {
    $parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", ()=>$96911fb41d45d626$export$4b254bc84a71033a);
    $parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", ()=>$96911fb41d45d626$export$753f41e31eccb6d7);
    $parcel$export(module.exports, "getHeaderWidths", ()=>$96911fb41d45d626$export$8aa6dbdb947f7df1);
    $parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", ()=>$96911fb41d45d626$export$1220f90483bde21);
    var $VSDnB;
    const $96911fb41d45d626$export$4b254bc84a71033a = 'size';
    const $96911fb41d45d626$export$753f41e31eccb6d7 = 1000000;
    const $96911fb41d45d626$export$8aa6dbdb947f7df1 = (params)=>{
        const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH, ACTOR_HEADER_WIDTH: ACTOR_HEADER_WIDTH } = params.showEventCategoryField ? {
            DATE_HEADER_WIDTH: 16,
            CATEGORY_HEADER_WIDTH: 16,
            TYPE_HEADER_WIDTH: 10,
            ACTOR_HEADER_WIDTH: 16
        } : {
            DATE_HEADER_WIDTH: 14,
            CATEGORY_HEADER_WIDTH: 0,
            TYPE_HEADER_WIDTH: 12,
            ACTOR_HEADER_WIDTH: 22
        };
        const columnsToShow = [
            DATE_HEADER_WIDTH,
            CATEGORY_HEADER_WIDTH,
            TYPE_HEADER_WIDTH,
            ...(0, (0, parcelRequire("VSDnB")).getBooleanFF)('platform.pun.audit-logs-actor-column_sxmw6') ? [
                ACTOR_HEADER_WIDTH
            ] : []
        ];
        let sum = 0;
        columnsToShow.forEach((width)=>{
            sum += width;
        });
        return {
            DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
            CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
            TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
            ACTOR_HEADER_WIDTH: `${ACTOR_HEADER_WIDTH}%`,
            CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
        };
    };
    const $96911fb41d45d626$export$1220f90483bde21 = 250;
});
parcelRegister("9Pdtb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8183616acbf6d3e8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $8183616acbf6d3e8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        validationMessageBeforeGreaterThanAfter: {
            id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
            defaultMessage: 'Specify a valid time range.',
            description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
        },
        validationMessageInvalidDateFormat: {
            id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
            defaultMessage: 'Invalid date format.',
            description: 'Invalid date format.'
        },
        validationMessageAtLeastOneValue: {
            id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
            defaultMessage: 'Select at least one value.',
            description: 'Message displayed to the user when there is no selected before and end date together'
        }
    });
    var $8183616acbf6d3e8$export$2e2bcd8739ae039 = $8183616acbf6d3e8$var$messages;
});
parcelRegister("lCbSp", function(module, exports) {
    $parcel$export(module.exports, "uiSettingsResource", ()=>$efebb20f6ad5236b$export$f2b33518cf31cd40);
    var $dIdda = parcelRequire("dIdda");
    var $7xYVv;
    const $efebb20f6ad5236b$export$f2b33518cf31cd40 = (0, $dIdda.createResource)({
        type: 'ui-settings-resource',
        getKey: ()=>'ui-settings-resource',
        getData: async ()=>(0, (0, parcelRequire("7xYVv")).fetchUiSettingsEndpoint)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("7xYVv", function(module, exports) {
    $parcel$export(module.exports, "fetchUiSettingsEndpoint", ()=>$7bc4e87c807af8e2$export$ea2f12bcbdce2020);
    var $j74qU;
    const $7bc4e87c807af8e2$export$ea2f12bcbdce2020 = async ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/logs');
    };
});
parcelRegister("g9g6m", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$97e7bbf09fde8a26$export$bc99aaabaf7b70a7);
    var $5WVG8;
    var $hVeqx;
    var $h4DSB;
    const $97e7bbf09fde8a26$export$bc99aaabaf7b70a7 = {
        configuredIntegrationsResource: (0, parcelRequire("5WVG8")).configuredIntegrationsResource,
        integrationListResource: (0, parcelRequire("hVeqx")).integrationListResource,
        userAccessRightsResource: (0, parcelRequire("h4DSB")).userAccessRightsResource
    };
});
parcelRegister("5WVG8", function(module, exports) {
    $parcel$export(module.exports, "configuredIntegrationsResource", ()=>$83d54f0caf3b9996$export$4136019b80be5917);
    var $dIdda = parcelRequire("dIdda");
    var $6nRK2;
    var $7suNB;
    const $83d54f0caf3b9996$export$4136019b80be5917 = (0, $dIdda.createResource)({
        type: 'configuredIntegrationsResource',
        getKey: ({ query: query, match: match })=>{
            const teamId = match.params.teamId ?? query['teamId'];
            const group = query['group'];
            const keyword = query['keyword'];
            const status = query['status'];
            const page = query['page'] || '1';
            return (0, (0, parcelRequire("6nRK2")).UrlHelper)((0, $cf8709d20bdba1b1$export$bc7daa294a7c75e4), {
                [(0, $cf8709d20bdba1b1$export$d26137cf824a9e53)]: page,
                [(0, $cf8709d20bdba1b1$export$299579ccbdd63cbc)]: keyword,
                [(0, $cf8709d20bdba1b1$export$d7415cfdee4bffc8)]: group,
                [(0, $cf8709d20bdba1b1$export$ce2c93e90dda8613)]: status,
                [(0, $cf8709d20bdba1b1$export$4e0ddb4dc97eb573)]: teamId
            });
        },
        getData: (routerContext)=>(0, (0, parcelRequire("7suNB")).default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("6nRK2", function(module, exports) {
    $parcel$export(module.exports, "UrlHelper", ()=>$15b449f9b21b0a2a$export$bacbc496e850c0a4);
    const $15b449f9b21b0a2a$export$bacbc496e850c0a4 = (path, params = {})=>{
        const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
                k,
                v.toString()
            ] : undefined).filter((v)=>!!v);
        const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
        return `${path}${qs ? `?${qs}` : ''}`;
    };
});
parcelRegister("7suNB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6c9b0fd99b09a25$export$2e2bcd8739ae039);
    var $j74qU;
    var $6nRK2;
    const $f6c9b0fd99b09a25$var$getIntegrations = async (query, pathParamTeamId)=>{
        const page = parseInt(query['page']) || 1;
        const offset = (page - 1) * (0, $38fc251fc66fc98a$export$31ecae7225aecec6);
        const queryParams = query ? {
            teamId: pathParamTeamId ?? query.teamId,
            group: query.group,
            keyword: query.keyword,
            status: query.status
        } : {};
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)('/v3/integrations/unified', {
            ...queryParams,
            offset: offset.toString(),
            limit: (0, $38fc251fc66fc98a$export$31ecae7225aecec6)
        })).then((response)=>({
                data: response.data.integrations,
                pageCount: Math.ceil(response.data.count / (0, $38fc251fc66fc98a$export$31ecae7225aecec6)),
                itemCount: response.data.count,
                platformTeamId: response.data.platformTeamId
            }));
    };
    const $f6c9b0fd99b09a25$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
            type: integrationType,
            teamId: teamId
        }), {
            method: 'PATCH',
            body: body
        }).then((response)=>response.data);
    const $f6c9b0fd99b09a25$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
            type: integrationType,
            teamId: teamId
        }), {
            method: 'DELETE',
            responseType: 'headers'
        });
    var $f6c9b0fd99b09a25$export$2e2bcd8739ae039 = {
        getIntegrations: $f6c9b0fd99b09a25$var$getIntegrations,
        patchIntegration: $f6c9b0fd99b09a25$var$patchIntegration,
        deleteIntegration: $f6c9b0fd99b09a25$var$deleteIntegration
    };
});
const $38fc251fc66fc98a$export$31ecae7225aecec6 = 20;
const $cf8709d20bdba1b1$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $cf8709d20bdba1b1$export$d26137cf824a9e53 = 'page';
const $cf8709d20bdba1b1$export$299579ccbdd63cbc = 'keyword';
const $cf8709d20bdba1b1$export$d7415cfdee4bffc8 = 'group';
const $cf8709d20bdba1b1$export$ce2c93e90dda8613 = 'status';
const $cf8709d20bdba1b1$export$4e0ddb4dc97eb573 = 'teamId';
parcelRegister("hVeqx", function(module, exports) {
    $parcel$export(module.exports, "integrationListResource", ()=>$d497f8a5feefb0d5$export$f60a40a11a6e0ee4);
    var $dIdda = parcelRequire("dIdda");
    var $jYQAI;
    const $d497f8a5feefb0d5$export$f60a40a11a6e0ee4 = (0, $dIdda.createResource)({
        type: 'integrationListResource',
        getKey: ({ query: query })=>{
            const group = query['group'];
            const keyword = query['keyword'];
            return `integrationListResource?group=${group}&keyword=${keyword}`;
        },
        getData: async (routerContext)=>await (0, (0, parcelRequire("jYQAI")).default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("jYQAI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e286a884592e027$export$2e2bcd8739ae039);
    var $j74qU;
    var $6nRK2;
    const $1e286a884592e027$var$getIntegrationList = (query, teamId)=>{
        const { keyword: keyword, group: group } = query ?? {};
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
            keyword: keyword,
            group: group,
            teamId: teamId
        })).then((response)=>{
            const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
            return {
                labels: labels,
                availableGroups: availableGroups,
                allTypes: allTypes,
                platformTeamId: platformTeamId
            };
        });
    };
    const $1e286a884592e027$var$getIntegrationTypes = (integrationType, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
            teamId: teamId
        })).then((response)=>response.data.map((integrationType)=>({
                    ...integrationType,
                    value: integrationType.type,
                    label: integrationType.displayName
                })));
    var $1e286a884592e027$export$2e2bcd8739ae039 = {
        getIntegrationList: $1e286a884592e027$var$getIntegrationList,
        getIntegrationTypes: $1e286a884592e027$var$getIntegrationTypes
    };
});
parcelRegister("h4DSB", function(module, exports) {
    $parcel$export(module.exports, "userAccessRightsResource", ()=>$955f19580ff30efa$export$69ddc7cc64ae9a02);
    var $dIdda = parcelRequire("dIdda");
    var $ifvD2;
    const $955f19580ff30efa$export$69ddc7cc64ae9a02 = (0, $dIdda.createResource)({
        type: 'userAccessRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params.teamId;
            return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
        },
        getData: (routerContext)=>(0, (0, parcelRequire("ifvD2")).getUserRights)(routerContext.match.params.teamId),
        maxAge: 3600000,
        isBrowserOnly: true
    });
});
parcelRegister("ifvD2", function(module, exports) {
    $parcel$export(module.exports, "getUserRights", ()=>$82efdac2c3d222dc$export$84e2ed279bc4e64e);
    var $j74qU;
    var $6nRK2;
    const $82efdac2c3d222dc$export$84e2ed279bc4e64e = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/rights`, {
            teamId: teamId
        })).then((response)=>response.data);
    };
});
parcelRegister("hvjO3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4EsQl")
    ]).then(()=>parcelRequire('5QWfc'));
});
parcelRegister("iBsI0", function(module, exports) {
    $parcel$export(module.exports, "maintenanceResource", ()=>$b472cee8aa78ea18$export$5486c78261efb2c3);
    $parcel$export(module.exports, "maintenanceUserRightsResource", ()=>$b472cee8aa78ea18$export$e4c92d8948e3625);
    $parcel$export(module.exports, "resources", ()=>$b472cee8aa78ea18$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $jxRF2;
    var $czDcW;
    const $b472cee8aa78ea18$export$5486c78261efb2c3 = (0, $dIdda.createResource)({
        type: 'maintenanceResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `maintenance/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("czDcW")).getMaintenance)(teamId);
        },
        isBrowserOnly: true
    });
    const $b472cee8aa78ea18$export$e4c92d8948e3625 = (0, $dIdda.createResource)({
        type: 'maintenanceUserRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `maintenance-user-rights/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("czDcW")).getMaintenanceUserRights)(teamId);
        },
        isBrowserOnly: true
    });
    const $b472cee8aa78ea18$export$bc99aaabaf7b70a7 = [
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)(),
        $b472cee8aa78ea18$export$5486c78261efb2c3,
        $b472cee8aa78ea18$export$e4c92d8948e3625
    ];
});
parcelRegister("czDcW", function(module, exports) {
    $parcel$export(module.exports, "getMaintenance", ()=>$b4a2c16b626eeb32$export$9cc878e1852c5ee1);
    $parcel$export(module.exports, "deleteMaintenance", ()=>$b4a2c16b626eeb32$export$f64242288df38e86);
    $parcel$export(module.exports, "cancelMaintenance", ()=>$b4a2c16b626eeb32$export$2d4a5362bda1b3c1);
    $parcel$export(module.exports, "changeDateAndTime", ()=>$b4a2c16b626eeb32$export$2162fcbd04e23a3d);
    $parcel$export(module.exports, "getMaintenanceUserRights", ()=>$b4a2c16b626eeb32$export$60048f3b7e7bf9b9);
    $parcel$export(module.exports, "createMaintenance", ()=>$b4a2c16b626eeb32$export$602dd976bd963418);
    $parcel$export(module.exports, "updateMaintenance", ()=>$b4a2c16b626eeb32$export$fa55cd063e1b15c2);
    var $j74qU;
    const $b4a2c16b626eeb32$export$9cc878e1852c5ee1 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
    };
    const $b4a2c16b626eeb32$export$f64242288df38e86 = (teamId, id)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
    const $b4a2c16b626eeb32$export$2d4a5362bda1b3c1 = (teamId, id)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
            method: 'PATCH'
        });
    };
    const $b4a2c16b626eeb32$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
            method: 'PATCH',
            body: {
                endDate: endDate
            }
        });
    };
    const $b4a2c16b626eeb32$export$60048f3b7e7bf9b9 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
    };
    const $b4a2c16b626eeb32$export$602dd976bd963418 = (payload, teamId)=>{
        const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            method: 'POST',
            body: payload
        });
    };
    const $b4a2c16b626eeb32$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
        const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            method: 'PUT',
            body: payload
        });
    };
});
parcelRegister("auNeJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9feTp")
    ]).then(()=>parcelRequire('iqyJK'));
});
parcelRegister("iufIe", function(module, exports) {
    $parcel$export(module.exports, "getTeamResource", ()=>$e31238735315794c$export$50271c9e7f21f10e);
    $parcel$export(module.exports, "resources", ()=>$e31238735315794c$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $8SpRt;
    var $6RRyp;
    var $4Igwk;
    const $e31238735315794c$export$50271c9e7f21f10e = (0, $dIdda.createResource)({
        type: 'getTeamResource',
        getKey: ()=>'getTeamResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
            return (0, (0, parcelRequire("4Igwk")).getTeam)(teamId);
        },
        isBrowserOnly: true
    });
    const $e31238735315794c$export$bc99aaabaf7b70a7 = [
        ...(0, (0, parcelRequire("6RRyp")).resources),
        (0, (0, parcelRequire("8SpRt")).routingRulesResource),
        $e31238735315794c$export$50271c9e7f21f10e
    ];
});
parcelRegister("8SpRt", function(module, exports) {
    $parcel$export(module.exports, "routingRulesResource", ()=>$8308d404e93181e1$export$7f38c73dca88500e);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $eQugF;
    const $8308d404e93181e1$export$7f38c73dca88500e = (0, $dIdda.createResource)({
        type: 'routingRulesResource',
        getKey: ()=>'routingRulesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
            return (0, (0, parcelRequire("eQugF")).getRoutingRules)(teamId);
        },
        isBrowserOnly: true
    });
});
parcelRegister("eQugF", function(module, exports) {
    $parcel$export(module.exports, "getRoutingRules", ()=>$2cc350f95d05e13d$export$425c24c86196521);
    var $j74qU;
    const $2cc350f95d05e13d$export$425c24c86196521 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/routing-rules`);
});
parcelRegister("6RRyp", function(module, exports) {
    $parcel$export(module.exports, "getSchedulesResource", ()=>$00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2);
    $parcel$export(module.exports, "getUiPreferencesResource", ()=>$00ff222f7fbbe6c1$export$5c6454d866055bdd);
    $parcel$export(module.exports, "getScheduleRightsResource", ()=>$00ff222f7fbbe6c1$export$9d9ecb8586783931);
    $parcel$export(module.exports, "getScheduleTimeTemplatesResource", ()=>$00ff222f7fbbe6c1$export$90251855f07c54b4);
    $parcel$export(module.exports, "resources", ()=>$00ff222f7fbbe6c1$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $jxRF2;
    var $dmLt8;
    var $1IQ7I;
    var $6CGrT;
    var $6bC8A;
    var $6FjDf;
    var $c0fyU;
    const $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2 = (0, $dIdda.createResource)({
        type: 'getSchedulesResource',
        getKey: ()=>'getSchedulesResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("6bC8A")).endpoints).getScheduleList((0, (0, parcelRequire("1IQ7I")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $00ff222f7fbbe6c1$export$5c6454d866055bdd = (0, $dIdda.createResource)({
        type: 'getSchedulePreferencesResource',
        getKey: ()=>'getSchedulePreferencesResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("6FjDf")).endpoints).getUiPreferences((0, (0, parcelRequire("1IQ7I")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $00ff222f7fbbe6c1$export$9d9ecb8586783931 = (0, $dIdda.createResource)({
        type: 'getScheduleRightsResource',
        getKey: ()=>'getScheduleRightsResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("c0fyU")).endpoints).getScheduleRights((0, (0, parcelRequire("1IQ7I")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $00ff222f7fbbe6c1$export$90251855f07c54b4 = (0, $dIdda.createResource)({
        type: 'getScheduleTimeTemplatesResource',
        getKey: ()=>'getScheduleTimeTemplatesResourceurce',
        isBrowserOnly: true,
        getData: async ()=>(0, (0, parcelRequire("6CGrT")).endpoints).getScheduleTimeTemplates()
    });
    const $00ff222f7fbbe6c1$export$bc99aaabaf7b70a7 = [
        $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2,
        $00ff222f7fbbe6c1$export$5c6454d866055bdd,
        $00ff222f7fbbe6c1$export$9d9ecb8586783931,
        $00ff222f7fbbe6c1$export$90251855f07c54b4,
        ...(0, (0, parcelRequire("dmLt8")).resources),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
});
parcelRegister("dmLt8", function(module, exports) {
    $parcel$export(module.exports, "getTimezonesResource", ()=>$6776e3cf1d2006c9$export$7524ea9fda8149c6);
    $parcel$export(module.exports, "resources", ()=>$6776e3cf1d2006c9$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $8EQhZ;
    const $6776e3cf1d2006c9$export$7524ea9fda8149c6 = (0, $dIdda.createResource)({
        type: 'getEocTimezonesResource',
        getKey: ()=>'getEocTimezonesResource',
        isBrowserOnly: true,
        getData: async ()=>(0, (0, parcelRequire("8EQhZ")).endpoints).getTimezones()
    });
    const $6776e3cf1d2006c9$export$bc99aaabaf7b70a7 = [
        $6776e3cf1d2006c9$export$7524ea9fda8149c6
    ];
});
parcelRegister("8EQhZ", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$6f3fefc2f4704aa0$export$3a2536d80ecc00e7);
    var $j74qU;
    var $lVRaA;
    const $6f3fefc2f4704aa0$var$getTimezones = async ()=>{
        const response = await (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("lVRaA")).urls).customers.timezones.url(), {
            method: 'GET'
        });
        const adjusted = response.timezones.map((timezone)=>({
                ...timezone,
                offset: timezone.offset * 60000,
                currentOffset: timezone.currentOffset * 60000
            }));
        return {
            ...response,
            timezones: adjusted
        };
    };
    const $6f3fefc2f4704aa0$var$getTimeTemplates = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("lVRaA")).urls).schedules.timeTemplates.rotation.url(), {
            method: 'GET'
        });
    };
    const $6f3fefc2f4704aa0$export$3a2536d80ecc00e7 = {
        getTimezones: $6f3fefc2f4704aa0$var$getTimezones,
        getTimeTemplates: $6f3fefc2f4704aa0$var$getTimeTemplates
    };
});
parcelRegister("lVRaA", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$e7a5202f26785602$export$bcae9ba627f604b6);
    const $e7a5202f26785602$export$bcae9ba627f604b6 = Object.freeze({
        alerts: {
            responders: {
                names: {
                    url: ()=>'/v1/alerts/responders/names'
                },
                autoComplete: {
                    url: ()=>'/v1/alerts/responders/auto-complete'
                }
            }
        },
        schedules: {
            url: ()=>`/v1/schedules`,
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}`,
                clone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/clone`
                },
                name: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/name`
                },
                timezone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timezone`
                },
                enable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/enable`
                },
                disable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/disable`
                },
                webCalendarUrl: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/web-calendar-url`
                },
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timeline`
                },
                overrides: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides`,
                    alias: {
                        url: ({ scheduleId: scheduleId, alias: alias } = {
                            scheduleId: ':scheduleId',
                            alias: ':alias'
                        })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                    },
                    bulk: {
                        url: ({ scheduleId: scheduleId } = {
                            scheduleId: ':scheduleId'
                        })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                    }
                },
                rotations: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/rotations`,
                    rotationId: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                        order: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                        },
                        name: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                        }
                    }
                }
            },
            timeTemplates: {
                rotation: {
                    url: ()=>'/v1/schedules/time-templates/rotation'
                }
            }
        },
        customers: {
            timezones: {
                url: ()=>'/v1/customers/timezones'
            }
        }
    });
});
parcelRegister("1IQ7I", function(module, exports) {
    $parcel$export(module.exports, "getTeamIdFromContext", ()=>$0269d115dae63a78$export$3ea727bebc3792bb);
    var $hmVmJ;
    var $dH6Pi;
    var $lCzwW;
    const $0269d115dae63a78$export$3ea727bebc3792bb = (routerContext)=>{
        const teamId = (0, (0, parcelRequire("lCzwW")).getSafe)(()=>routerContext.match.params.teamId, null);
        (0, (0, parcelRequire("hmVmJ")).assert)(!(0, (0, parcelRequire("lCzwW")).isEmpty)(teamId), new (0, (0, parcelRequire("dH6Pi")).AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
        return teamId;
    };
});
parcelRegister("lCzwW", function(module, exports) {
    $parcel$export(module.exports, "getSafe", ()=>$cb4f511f313ca560$export$fedb900c0ea4e699);
    $parcel$export(module.exports, "isEmpty", ()=>$cb4f511f313ca560$export$dd1bc94b04021eeb);
    $parcel$export(module.exports, "isNullOrUndefined", ()=>$cb4f511f313ca560$export$bedb7023a7733221);
    $parcel$export(module.exports, "noLeadingOrTrailingSpaces", ()=>$cb4f511f313ca560$export$5fc068d42db64a99);
    var $jkGAf;
    const $cb4f511f313ca560$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
        try {
            return fn();
        } catch  {
            return defaultValue;
        }
    };
    const $cb4f511f313ca560$export$dd1bc94b04021eeb = (input)=>{
        if (input !== 0 && input !== false && !input) return true;
        if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
        return false;
    };
    const $cb4f511f313ca560$export$bedb7023a7733221 = (input)=>{
        return input === null || input === undefined;
    };
    const $cb4f511f313ca560$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
                if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, (0, parcelRequire("jkGAf")).messages).nameSpaceValidationError);
            };
});
parcelRegister("jkGAf", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1ca05faf5e97d101$export$defe85febe8b728c);
    var $7VHMR;
    const $1ca05faf5e97d101$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOne: {
            id: 'eoc-schedule.common.no-one',
            defaultMessage: 'No one',
            description: 'Name of the user whose type is no-one.'
        },
        error: {
            id: 'eoc-schedule.common.error',
            defaultMessage: 'Error',
            description: 'Just simple error message.'
        },
        tryAgain: {
            id: 'eoc-schedule.common.try-again',
            defaultMessage: 'Try again',
            description: 'Try again message when an error occurs.'
        },
        cancel: {
            id: 'eoc-schedule.common.cancel',
            defaultMessage: 'Cancel',
            description: 'A cancel button.'
        },
        confirm: {
            id: 'eoc-schedule.common.confirm',
            defaultMessage: 'Confirm',
            description: 'A confirm button.'
        },
        addOverride: {
            id: 'eoc-schedule.common.add-override',
            defaultMessage: 'Add override',
            description: 'Adding override for a period item.'
        },
        overrideButton: {
            id: 'eoc-schedule.common.override',
            defaultMessage: 'Override',
            description: 'A override button.'
        },
        saveButton: {
            id: 'eoc-schedule.common.save',
            defaultMessage: 'Save',
            description: 'A save button.'
        },
        edit: {
            id: 'eoc-schedule.common.edit',
            defaultMessage: 'Edit',
            description: 'Button for editing schedule.'
        },
        turnOff: {
            id: 'eoc-schedule.common.turn-off',
            defaultMessage: 'Turn off',
            description: 'Button for turn-offing schedule.'
        },
        turnOn: {
            id: 'eoc-schedule.common.turn-on',
            defaultMessage: 'Turn on',
            description: 'Button for turn-on schedule.'
        },
        delete: {
            id: 'eoc-schedule.common.delete',
            defaultMessage: 'Delete',
            description: 'Button for deleting schedule or rotation.'
        },
        duplicate: {
            id: 'eoc-schedule.common.duplicate',
            defaultMessage: 'Duplicate',
            description: 'Button for duplicating schedule or rotation.'
        },
        remove: {
            id: 'eoc-schedule.common.remove',
            defaultMessage: 'Remove',
            description: 'Button for removing participant.'
        },
        start: {
            id: 'eoc-schedule.common.start',
            defaultMessage: 'Start',
            description: 'Label for start time and date.'
        },
        end: {
            id: 'eoc-schedule.common.end',
            defaultMessage: 'End',
            description: 'Label for end time and date.'
        },
        startTime: {
            id: 'eoc-schedule.common.start-time',
            defaultMessage: 'Start time',
            description: 'Label for start time and date.'
        },
        endTime: {
            id: 'eoc-schedule.common.end-time',
            defaultMessage: 'End time',
            description: 'Label for end time and date.'
        },
        startDate: {
            id: 'eoc-schedule.common.start-date',
            defaultMessage: 'Start date',
            description: 'Label for start time and date.'
        },
        endDate: {
            id: 'eoc-schedule.common.end-date',
            defaultMessage: 'End date',
            description: 'Label for end time and date.'
        },
        team: {
            id: 'eoc-schedule.common.team',
            defaultMessage: 'Team',
            description: 'Label that indicates responder is of type: Team'
        },
        escalation: {
            id: 'eoc-schedule.common.escalation',
            defaultMessage: 'Escalation',
            description: 'Label that indicates responder is of type: Escalation'
        },
        schedule: {
            id: 'eoc-schedule.common.schedule',
            defaultMessage: 'Schedule',
            description: 'Label that indicates responder is of type: Schedule'
        },
        selectionCount: {
            id: 'eoc-schedule.common.selection-count',
            defaultMessage: '{count} shifts selected',
            description: 'Indicates how many shifts are selected for override.'
        },
        quickOverrideTitle: {
            id: 'eoc-schedule.common.quick-override-title',
            defaultMessage: 'OVERRIDE',
            description: 'Title for quick override card.'
        },
        search: {
            id: 'eoc-schedule.common.search',
            defaultMessage: 'Search',
            description: 'Label of search icon that shown inside search participant field'
        },
        replaceWith: {
            id: 'eoc-schedule.common.replace-with',
            defaultMessage: 'Replace with',
            description: 'A button for opening popup for replacing a participant.'
        },
        participants: {
            id: 'eoc-schedule.common.participants',
            defaultMessage: 'Participants',
            description: 'Label for participants.'
        },
        addParticipants: {
            id: 'eoc-schedule.common.add-participants',
            defaultMessage: 'Add people, teams, and escalation policies',
            description: 'Placeholder text for auto complete field for participants (responders).'
        },
        select: {
            id: 'eoc-schedule.common.select',
            defaultMessage: 'Select',
            description: 'Label that indicates selecting.'
        },
        teamDeleted: {
            id: 'eoc-schedule.common.team-deleted',
            defaultMessage: 'Team deleted',
            description: 'Fallback responder name that suggest team is deleted.'
        },
        deletedSchedule: {
            id: 'eoc-schedule.common.deleted-schedule',
            defaultMessage: 'Deleted schedule',
            description: 'Fallback responder name that suggest schedule is deleted.'
        },
        deletedEscalation: {
            id: 'eoc-schedule.common.deleted-escalation',
            defaultMessage: 'Deleted escalation',
            description: 'Fallback responder name that suggest escalation is deleted.'
        },
        formerUser: {
            id: 'eoc-schedule.common.former-user',
            defaultMessage: 'Former user',
            description: 'Fallback responder name that suggest user is deactivated or deleted.'
        },
        discard: {
            id: 'eoc-schedule.common.discard',
            defaultMessage: 'Discard',
            description: 'Button for discarding.'
        },
        confirmProceed: {
            id: 'eoc-schedule.common.confirm-proceed',
            defaultMessage: 'Are you sure to proceed?',
            description: 'A confirmation for proceeding.'
        },
        required: {
            id: 'eoc-schedule.common.required',
            defaultMessage: 'This field is required.',
            description: 'A text that informs users that field should be filled.'
        },
        noSpaceAtEndOrStart: {
            id: 'eoc-schedule.common.no-space-at-end-or-start',
            defaultMessage: 'Field cannot contain spaces at start or end.',
            description: 'A text that informs users that field cannot start or end with spaces.'
        },
        maxLength: {
            id: 'eoc-schedule.common.max-length',
            defaultMessage: 'Field cannot be longer than {max} characters.',
            description: 'A text that informs users that field should be shorter than certain length.'
        },
        maxValue: {
            id: 'eoc-schedule.common.max-value',
            defaultMessage: 'Field should be less than {max}.',
            description: 'A text that informs users that field should be less than certain value.'
        },
        minValue: {
            id: 'eoc-schedule.common.min-value',
            defaultMessage: 'Enter digit 1 or more.',
            description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
        },
        timePast: {
            id: 'eoc-schedule.common.time-past',
            defaultMessage: 'Time should be later than current time.',
            description: 'Validation error that indicates time values is in past.'
        },
        startLaterEnd: {
            id: 'eoc-schedule.common.start-later-end',
            defaultMessage: 'Start time should be earlier than the end time.',
            description: 'Validation error that indicates start time is later than the end time.'
        },
        endEarlierStart: {
            id: 'eoc-schedule.common.end-earlier-start',
            defaultMessage: 'End time should be later than the start time.',
            description: 'Validation error that indicates end time is earlier than the start time.'
        },
        startEndSame: {
            id: 'eoc-schedule.common.start-end-same',
            defaultMessage: 'Start and end time cannot be same.',
            description: 'Validation error that indicates start and end time should be different.'
        },
        thirtyMinuteInterval: {
            id: 'eoc-schedule.common.thirty-minute-intervals',
            defaultMessage: 'Time should be defined as 30 minute intervals.',
            description: 'Validation error that indicates time can be in 30 minutes intervals.'
        },
        nameSpaceValidationError: {
            id: 'eoc-schedule.common.name-space-validation-error',
            defaultMessage: 'The name cannot start or end with a space.',
            description: 'Error message for name validation when it starts or ends with a space'
        }
    });
});
parcelRegister("6CGrT", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$fe0104c8713239aa$export$3a2536d80ecc00e7);
    var $j74qU;
    var $cB5Mt;
    const $fe0104c8713239aa$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.rotationId.order.url({
            rotationId: rotationId,
            scheduleId: scheduleId
        }), {
            method: 'PATCH',
            body: {
                after: after
            }
        });
    };
    const $fe0104c8713239aa$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: rotationId
        }), {
            method: 'GET'
        });
    };
    const $fe0104c8713239aa$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: rotationId
        }), {
            method: 'DELETE'
        });
    };
    const $fe0104c8713239aa$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.url({
            scheduleId: scheduleId
        }), {
            method: 'POST',
            body: {
                name: name,
                responders: responders,
                restrictions: restrictions,
                rotationType: rotationType,
                timeTemplateId: timeTemplateId,
                timingType: timingType,
                rotationPeriod: rotationPeriod,
                startTimeRaw: startTimeRaw,
                endTimeRaw: endTimeRaw,
                hasEndTime: hasEndTime
            }
        });
    };
    const $fe0104c8713239aa$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: id
        }), {
            method: 'PUT',
            body: {
                id: id,
                name: name,
                responders: responders,
                restrictions: restrictions,
                rotationType: rotationType,
                rotationPeriod: rotationPeriod,
                timeTemplateId: timeTemplateId,
                timingType: timingType,
                startTimeRaw: startTimeRaw,
                endTimeRaw: endTimeRaw,
                hasEndTime: hasEndTime
            }
        });
    };
    const $fe0104c8713239aa$var$getScheduleTimeTemplates = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.timeTemplates.rotation.url(), {
            method: 'GET'
        });
    };
    const $fe0104c8713239aa$export$3a2536d80ecc00e7 = {
        deleteRotation: $fe0104c8713239aa$var$deleteRotation,
        getRotation: $fe0104c8713239aa$var$getRotation,
        orderRotation: $fe0104c8713239aa$var$orderRotation,
        addRotation: $fe0104c8713239aa$var$addRotation,
        editRotation: $fe0104c8713239aa$var$editRotation,
        getScheduleTimeTemplates: $fe0104c8713239aa$var$getScheduleTimeTemplates
    };
});
parcelRegister("cB5Mt", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$09cb24bcb900cd8c$export$bcae9ba627f604b6);
    const $09cb24bcb900cd8c$export$bcae9ba627f604b6 = Object.freeze({
        alerts: {
            responders: {
                names: {
                    url: ()=>'/v1/alerts/responders/names'
                },
                autoComplete: {
                    url: ()=>'/v1/alerts/responders/auto-complete'
                }
            }
        },
        schedules: {
            url: ()=>`/v1/schedules`,
            teams: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}`,
                    rights: {
                        url: ({ teamId: teamId } = {
                            teamId: ':teamId'
                        })=>`/v1/schedules/teams/${teamId}/rights`
                    }
                }
            },
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}`,
                clone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/clone`
                },
                name: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/name`
                },
                timezone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timezone`
                },
                enable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/enable`
                },
                disable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/disable`
                },
                webCalendarUrl: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/web-calendar-url`
                },
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timeline`
                },
                overrides: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides`,
                    alias: {
                        url: ({ scheduleId: scheduleId, alias: alias } = {
                            scheduleId: ':scheduleId',
                            alias: ':alias'
                        })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                    },
                    bulk: {
                        url: ({ scheduleId: scheduleId } = {
                            scheduleId: ':scheduleId'
                        })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                    }
                },
                rotations: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/rotations`,
                    rotationId: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                        order: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                        },
                        name: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                        }
                    }
                }
            },
            timeTemplates: {
                rotation: {
                    url: ()=>'/v1/schedules/time-templates/rotation'
                }
            }
        },
        customers: {
            timezones: {
                url: ()=>'/v1/customers/timezones'
            }
        },
        uiPreference: {
            schedule: {
                team: {
                    teamId: {
                        url: ({ teamId: teamId } = {
                            teamId: ':teamId'
                        })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                    }
                }
            }
        },
        onboarding: {
            completeTask: {
                url: ()=>'/v1/onboarding/complete-task'
            }
        }
    });
});
parcelRegister("6bC8A", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$94e539ffc0ded8a5$export$3a2536d80ecc00e7);
    var $j74qU;
    var $cB5Mt;
    const $94e539ffc0ded8a5$var$getScheduleList = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.teams.teamId.url({
            teamId: teamId
        }));
    };
    const $94e539ffc0ded8a5$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.url({
            scheduleId: scheduleId
        }), {
            method: 'PATCH',
            body: {
                description: description,
                name: name,
                enabled: enabled,
                timezone: timezone
            }
        });
    };
    const $94e539ffc0ded8a5$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.url({
            scheduleId: scheduleId
        }), {
            method: 'DELETE'
        });
    };
    const $94e539ffc0ded8a5$export$3a2536d80ecc00e7 = {
        deleteSchedule: $94e539ffc0ded8a5$var$deleteSchedule,
        getScheduleList: $94e539ffc0ded8a5$var$getScheduleList,
        updateSchedule: $94e539ffc0ded8a5$var$updateSchedule
    };
});
parcelRegister("6FjDf", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$4c5802ac60e7f752$export$3a2536d80ecc00e7);
    var $j74qU;
    var $cB5Mt;
    const $4c5802ac60e7f752$var$getUiPreferences = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).uiPreference.schedule.team.teamId.url({
            teamId: teamId
        }));
    };
    const $4c5802ac60e7f752$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).uiPreference.schedule.team.teamId.url({
            teamId: teamId
        }), {
            method: 'PATCH',
            body: {
                [key]: value
            }
        });
    };
    const $4c5802ac60e7f752$export$3a2536d80ecc00e7 = {
        getUiPreferences: $4c5802ac60e7f752$var$getUiPreferences,
        updateUiPreferences: $4c5802ac60e7f752$var$updateUiPreferences
    };
});
parcelRegister("c0fyU", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$7066040345150142$export$3a2536d80ecc00e7);
    var $j74qU;
    var $cB5Mt;
    const $7066040345150142$var$getScheduleRights = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.teams.teamId.rights.url({
            teamId: teamId
        }));
    };
    const $7066040345150142$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.url(), {
            method: 'POST',
            body: {
                description: description,
                name: name,
                teamId: teamId,
                timezone: timezone,
                enabled: true
            }
        });
    };
    const $7066040345150142$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.clone.url({
            scheduleId: scheduleId
        }), {
            method: 'POST',
            body: {
                description: description,
                name: name,
                enabled: enabled,
                timezone: timezone,
                teamId: teamId
            }
        });
    };
    const $7066040345150142$export$3a2536d80ecc00e7 = {
        createSchedule: $7066040345150142$var$createSchedule,
        getScheduleRights: $7066040345150142$var$getScheduleRights,
        cloneSchedule: $7066040345150142$var$cloneSchedule
    };
});
parcelRegister("4Igwk", function(module, exports) {
    $parcel$export(module.exports, "getTeam", ()=>$54c26d3a47aeeed9$export$491fe77f22ab2b51);
    var $j74qU;
    const $54c26d3a47aeeed9$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        });
});
parcelRegister("4uLc4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b0ycI")
    ]).then(()=>parcelRequire('38rnw'));
});
parcelRegister("5OcAv", function(module, exports) {
    $parcel$export(module.exports, "getTeamsResource", ()=>$221e2d1c864e815a$export$27d854bd39923fc7);
    var $9qm0o;
    var $8NtOA;
    var $dIdda = parcelRequire("dIdda");
    const $221e2d1c864e815a$export$27d854bd39923fc7 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8NtOA")).getTeamsResource).type,
        getKey: (0, (0, parcelRequire("8NtOA")).getTeamsResource).getKey,
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
            if (!atlassianAccountId) return null;
            const shouldSeeAllTeams = isSiteAdmin || isAdmin;
            return (0, (0, parcelRequire("9qm0o")).getTeams)({
                queryParams: {
                    accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                    showAvatar: true
                }
            });
        },
        isBrowserOnly: true,
        maxAge: 0
    });
});
parcelRegister("9qm0o", function(module, exports) {
    $parcel$export(module.exports, "getTeams", ()=>$66ba5008bb81f78a$export$5a622455e94bac3);
    var $j74qU;
    const $66ba5008bb81f78a$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
        const params = new URLSearchParams();
        if (queryParams.keyword) params.append('keyword', queryParams.keyword);
        if (queryParams.size) params.append('size', queryParams.size.toString());
        if (queryParams.offset) params.append('offset', queryParams.offset.toString());
        if (queryParams.accountId) params.append('memberId', queryParams.accountId);
        if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
        if (url) return (0, (0, parcelRequire("j74qU")).eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
            exactUrl: true
        });
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
    };
});
parcelRegister("8NtOA", function(module, exports) {
    $parcel$export(module.exports, "getTeamsResource", ()=>$61e1720e70cf825e$export$27d854bd39923fc7);
    var $dIdda = parcelRequire("dIdda");
    var $9qm0o;
    const $61e1720e70cf825e$export$27d854bd39923fc7 = (0, $dIdda.createResource)({
        type: 'getTeamsResource',
        getKey: ()=>'overview',
        getData: async ()=>{
            throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
        },
        isBrowserOnly: true
    });
});
parcelRegister("9oNUK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("92gV4")
    ]).then(()=>parcelRequire('hTI3Y'));
});
parcelRegister("8tAz8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hbHCQ")
    ]).then(()=>parcelRequire('jMqXq'));
});
parcelRegister("j4Jjv", function(module, exports) {
    $parcel$export(module.exports, "pageAccessResource", ()=>$0ef99385700ea410$export$b0d36f8262140e35);
    $parcel$export(module.exports, "memberRolesResource", ()=>$0ef99385700ea410$export$5c4885c1f1a535b);
    $parcel$export(module.exports, "getTeamResource", ()=>$0ef99385700ea410$export$50271c9e7f21f10e);
    $parcel$export(module.exports, "customTeamRolesResource", ()=>$0ef99385700ea410$export$ed1eb48699cf7893);
    $parcel$export(module.exports, "resources", ()=>$0ef99385700ea410$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $cN8Qq;
    const $0ef99385700ea410$var$mapStatus = (status, userAccessLevel)=>{
        if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
        if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
        if (status === 'ACCESS_EXISTS') return 'member';
        if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
        if (status === '' || status === undefined) return 'member';
        return 'invite';
    };
    const $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
        let isAuthorizedToSeeMemberRolesPage = false;
        if (dependencies[$0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE]) {
            const data = await dependencies[$0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
            isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
        }
        return isAuthorizedToSeeMemberRolesPage;
    };
    const $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
    const $0ef99385700ea410$export$b0d36f8262140e35 = (0, $dIdda.createResource)({
        type: $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE,
        getKey: ()=>'pageAccessResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
            return (0, (0, parcelRequire("cN8Qq")).getMemberRolesPageAccess)(teamId);
        },
        isBrowserOnly: true
    });
    const $0ef99385700ea410$export$5c4885c1f1a535b = (0, $dIdda.createResource)({
        type: 'memberRolesResource',
        getKey: ()=>'memberRolesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            const dependencies = routerContext.dependencies;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
            const isAuthorizedToSeeMemberRolesPage = await $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency(dependencies);
            if (!isAuthorizedToSeeMemberRolesPage) return null;
            const gqlResponse = await (0, (0, parcelRequire("cN8Qq")).getMembers)(teamId);
            let members = [];
            members = gqlResponse?.data.team.teamV2.members.edges.map((edge)=>edge.node.member);
            const teamMembers = await (0, (0, parcelRequire("cN8Qq")).getRoleAndJSMLicenseInfoEndpoint)({
                platformTeamId: teamId,
                accountIds: members.map((member)=>member.accountId)
            }).then((res)=>{
                const users = members.map((user)=>{
                    const userWithRole = res.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
                    return {
                        ...user,
                        role: userWithRole?.roleId || 'user',
                        jsmLicense: userWithRole?.jsmLicense || false,
                        jiraAdmin: userWithRole?.jiraAdmin || false,
                        invitationStatus: 'member'
                    };
                });
                return users;
            });
            const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
            if (membersWithoutJSMLicense.length > 0) {
                const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
                const membersWithFullInfo = await (0, (0, parcelRequire("cN8Qq")).getJSMInvitationStatusInfoEndpoint)({
                    accountIds: accountIds
                }).then((res)=>{
                    const users = teamMembers.map((user)=>{
                        const userWithInvitationStatus = res.embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                        return {
                            ...user,
                            invitationStatus: $0ef99385700ea410$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                        };
                    });
                    return users;
                }).catch((err)=>{
                    return teamMembers;
                });
                return membersWithFullInfo;
            }
            return teamMembers;
        },
        isBrowserOnly: true,
        depends: [
            $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE
        ]
    });
    const $0ef99385700ea410$export$50271c9e7f21f10e = (0, $dIdda.createResource)({
        type: 'getTeamResource',
        getKey: ()=>'getTeamResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
            return (0, (0, parcelRequire("cN8Qq")).getTeam)(teamId);
        },
        isBrowserOnly: true
    });
    const $0ef99385700ea410$export$ed1eb48699cf7893 = (0, $dIdda.createResource)({
        type: 'customTeamRolesResource',
        getKey: ()=>'customRolesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            const dependencies = routerContext.dependencies;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
            const isAuthorizedToSeeMemberRolesPage = await $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency(dependencies);
            if (!isAuthorizedToSeeMemberRolesPage) return null;
            return (0, (0, parcelRequire("cN8Qq")).getCustomTeamRolesEndpoint)(teamId);
        },
        isBrowserOnly: true,
        depends: [
            $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE
        ]
    });
    const $0ef99385700ea410$export$bc99aaabaf7b70a7 = [
        $0ef99385700ea410$export$5c4885c1f1a535b,
        $0ef99385700ea410$export$50271c9e7f21f10e,
        $0ef99385700ea410$export$ed1eb48699cf7893
    ];
});
parcelRegister("cN8Qq", function(module, exports) {
    $parcel$export(module.exports, "getMembers", ()=>$33127c313f2bb6a1$export$f4931e6f9feb30c5);
    $parcel$export(module.exports, "getMemberRolesPageAccess", ()=>$33127c313f2bb6a1$export$95d4c4e762437fdd);
    $parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", ()=>$33127c313f2bb6a1$export$38ab389cb64a5000);
    $parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", ()=>$33127c313f2bb6a1$export$fd43007da8683026);
    $parcel$export(module.exports, "getTeam", ()=>$33127c313f2bb6a1$export$491fe77f22ab2b51);
    $parcel$export(module.exports, "getCustomTeamRolesEndpoint", ()=>$33127c313f2bb6a1$export$ebfa293eb1ef42f5);
    var $VSDnB;
    var $j74qU;
    var $030R0;
    const $33127c313f2bb6a1$var$operationName = 'memberRolesTeamMembersQuery';
    const $33127c313f2bb6a1$export$f4931e6f9feb30c5 = (teamId)=>{
        const queryUrl = '/gateway/api/graphql';
        const teamAri = `ari:cloud:identity::team/${teamId}`;
        const siteId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${(0, (0, parcelRequire("VSDnB")).fg)('platform_increase_limit_of_members_query') ? '(first: 300)' : ''}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
				}
			}
		}
	}
	`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(queryUrl, {
            method: 'POST',
            body: JSON.stringify({
                operationName: $33127c313f2bb6a1$var$operationName,
                query: membersQueryV2,
                variables: {
                    teamId: teamAri,
                    siteId: siteId
                }
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-ExperimentalApi': 'teams-beta, team-members-beta'
            },
            exactUrl: true
        });
    };
    const $33127c313f2bb6a1$export$95d4c4e762437fdd = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
    const $33127c313f2bb6a1$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/members`, {
            method: 'POST',
            body: {
                platformTeamId: platformTeamId,
                accountIds: accountIds
            }
        });
    const $33127c313f2bb6a1$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
            method: 'GET'
        });
    const $33127c313f2bb6a1$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        });
    const $33127c313f2bb6a1$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${platformTeamId}/roles`);
});
parcelRegister("90Y3w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gZDDu")
    ]).then(()=>parcelRequire('6Zxu7'));
});
parcelRegister("f4VN0", function(module, exports) {
    $parcel$export(module.exports, "teamPolicyResource", ()=>$f22ff5b7b8e8fefe$export$10d7fa513f08ef83);
    $parcel$export(module.exports, "notificationPolicyResource", ()=>$f22ff5b7b8e8fefe$export$6d5f23d9118ad678);
    $parcel$export(module.exports, "globalPolicyResource", ()=>$f22ff5b7b8e8fefe$export$7aed80da979a5112);
    $parcel$export(module.exports, "resources", ()=>$f22ff5b7b8e8fefe$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $11dmp;
    const $f22ff5b7b8e8fefe$export$10d7fa513f08ef83 = (0, $dIdda.createResource)({
        type: 'teamPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-policy/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return null;
            return (0, (0, parcelRequire("11dmp")).getTeamPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $f22ff5b7b8e8fefe$export$6d5f23d9118ad678 = (0, $dIdda.createResource)({
        type: 'notificationPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `notification-policy/${teamId}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return;
            return (0, (0, parcelRequire("11dmp")).getNotificationPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $f22ff5b7b8e8fefe$export$7aed80da979a5112 = (0, $dIdda.createResource)({
        type: 'globalPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (teamId) return `global-policy/${teamId}`;
            return 'global-policy';
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("11dmp")).getGlobalPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $f22ff5b7b8e8fefe$export$4cb385c2db8b1e99 = (0, $dIdda.createResource)({
        type: 'policyMaintenanceRightsResource',
        getKey: ()=>'policy-maintenance-rights-resource',
        getData: async ()=>{
            return (0, (0, parcelRequire("11dmp")).getPolicyMaintenanceRights)();
        },
        isBrowserOnly: true
    });
    const $f22ff5b7b8e8fefe$export$bc99aaabaf7b70a7 = [
        $f22ff5b7b8e8fefe$export$10d7fa513f08ef83,
        $f22ff5b7b8e8fefe$export$7aed80da979a5112,
        $f22ff5b7b8e8fefe$export$4cb385c2db8b1e99,
        $f22ff5b7b8e8fefe$export$6d5f23d9118ad678
    ];
});
parcelRegister("11dmp", function(module, exports) {
    $parcel$export(module.exports, "getTeamPolicies", ()=>$970bb189ad752795$export$fead0944caa1c797);
    $parcel$export(module.exports, "getGlobalPolicies", ()=>$970bb189ad752795$export$17fc7fbef061a8c3);
    $parcel$export(module.exports, "getNotificationPolicies", ()=>$970bb189ad752795$export$342525d9423e55ad);
    $parcel$export(module.exports, "getPolicyMaintenanceRights", ()=>$970bb189ad752795$export$f630cbf5586dce0a);
    $parcel$export(module.exports, "updateUIPreferenceEndpoint", ()=>$970bb189ad752795$export$6a437b43ab11275d);
    $parcel$export(module.exports, "changePolicyOrderEndpoint", ()=>$970bb189ad752795$export$57186d786c96b52a);
    $parcel$export(module.exports, "enablePolicyEndpoint", ()=>$970bb189ad752795$export$6fecd226d8e55346);
    $parcel$export(module.exports, "disablePolicyEndpoint", ()=>$970bb189ad752795$export$8c0cd218e00b7d9b);
    $parcel$export(module.exports, "deletePolicyEndpoint", ()=>$970bb189ad752795$export$f9feac6c1dcc516f);
    $parcel$export(module.exports, "createPolicyEndpoint", ()=>$970bb189ad752795$export$b0108c51b962e788);
    $parcel$export(module.exports, "updatePolicyEndpoint", ()=>$970bb189ad752795$export$8eabce250a2dd205);
    var $j74qU;
    const $970bb189ad752795$export$fead0944caa1c797 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
    };
    const $970bb189ad752795$export$17fc7fbef061a8c3 = (teamId)=>{
        if (teamId) return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/policies`);
    };
    const $970bb189ad752795$export$342525d9423e55ad = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
    };
    const $970bb189ad752795$export$f630cbf5586dce0a = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
    };
    const $970bb189ad752795$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
        let url = `/v1/alerts/ui-preferences/policies`;
        if (teamId) url = `${url}?teamId=${teamId}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            method: 'PATCH',
            body: payload,
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$57186d786c96b52a = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
            method: 'PATCH',
            body: {
                after: payload.after
            },
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$6fecd226d8e55346 = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
            method: 'POST',
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$8c0cd218e00b7d9b = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
            method: 'POST',
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$f9feac6c1dcc516f = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$b0108c51b962e788 = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
            method: 'POST',
            body: payload
        });
    };
    const $970bb189ad752795$export$8eabce250a2dd205 = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
            method: 'PUT',
            body: payload
        });
    };
});
parcelRegister("9A51b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d7ZnT")
    ]).then(()=>parcelRequire('3IgJn'));
});
parcelRegister("dY89w", function(module, exports) {
    $parcel$export(module.exports, "opsReportsResource", ()=>$adcf91cb99206588$export$8498311fc7a4ab48);
    $parcel$export(module.exports, "opsReportsPermissionResource", ()=>$adcf91cb99206588$export$c432f280d76e2acf);
    $parcel$export(module.exports, "resources", ()=>$adcf91cb99206588$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $5oSMF;
    var $QF2yk;
    const $adcf91cb99206588$export$8498311fc7a4ab48 = (0, $dIdda.createResource)({
        type: 'opsReportsResource',
        getKey: ()=>'opsReportsResource',
        getData: async ()=>{
            const settings = await (0, (0, parcelRequire("QF2yk")).getReportSettings)();
            const api = (0, (0, parcelRequire("QF2yk")).getDashboards);
            return {
                settings: settings,
                dashboards: settings.showReportingMaintenance ? null : await api()
            };
        },
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $adcf91cb99206588$export$c432f280d76e2acf = (0, $dIdda.createResource)({
        type: 'opsReportsPermissionResource',
        getKey: ({ match: match })=>{
            return `opsReportsPermissionResource-${match.params?.teamId}`;
        },
        getData: async (routerContext)=>{
            const isTeamDashboard = (0, (0, parcelRequire("5oSMF")).isTeamReportsUrl)(routerContext.match.url);
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!isTeamDashboard || !!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
            return (0, (0, parcelRequire("QF2yk")).getReportRights)(teamId);
        },
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $adcf91cb99206588$export$bc99aaabaf7b70a7 = [
        $adcf91cb99206588$export$8498311fc7a4ab48,
        $adcf91cb99206588$export$c432f280d76e2acf
    ];
});
parcelRegister("5oSMF", function(module, exports) {
    $parcel$export(module.exports, "withReportingPrefix", ()=>$8aa539155af4c630$export$c0f073d636267c44);
    $parcel$export(module.exports, "isTeamReportsUrl", ()=>$8aa539155af4c630$export$f923ac475871fcad);
    var $030R0;
    function $8aa539155af4c630$export$c0f073d636267c44(input) {
        if (window.__OG__) return '/webapi' + input;
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
        return input;
    }
    const $8aa539155af4c630$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');
});
parcelRegister("QF2yk", function(module, exports) {
    $parcel$export(module.exports, "getDashboards", ()=>$de64900aae3821f4$export$8e4b6d6c4fec08f3);
    $parcel$export(module.exports, "getReportSettings", ()=>$de64900aae3821f4$export$9114b8a872caf5d8);
    $parcel$export(module.exports, "getSsoEmbedUrlEndpoint", ()=>$de64900aae3821f4$export$8384a95746267bd8);
    $parcel$export(module.exports, "getReportRights", ()=>$de64900aae3821f4$export$f4a61c3c8c619f12);
    $parcel$export(module.exports, "getAVPEmbedTokens", ()=>$de64900aae3821f4$export$fb46892f83504a42);
    var $j74qU;
    var $5oSMF;
    var $7IcT2;
    const $de64900aae3821f4$export$8e4b6d6c4fec08f3 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)('/v5/reports/dashboards'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    const $de64900aae3821f4$export$e69121e90ce0231b = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)('/v3/reports/dashboards'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    const $de64900aae3821f4$export$9114b8a872caf5d8 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)('/v3/reports/index'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    const $de64900aae3821f4$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
        const queryParam = teamId ? {
            theme: isDarkMode ? 'DarkMode' : '',
            dashboardId: dashboardId,
            teamId: teamId,
            _: Date.now().toString()
        } : {
            theme: isDarkMode ? 'DarkMode' : '',
            dashboardId: dashboardId,
            _: Date.now().toString()
        };
        const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)(url), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    };
    const $de64900aae3821f4$export$f4a61c3c8c619f12 = (teamId)=>{
        let url = '/v3/reports/rights';
        if (teamId) url += `?teamId=${teamId}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)(url), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    };
    const $de64900aae3821f4$export$fb46892f83504a42 = (dashboardId, teamId)=>{
        let url = '/v3/reports/embed-token';
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)(url), {
            exactUrl: true,
            method: 'POST',
            body: {
                dashboardId: dashboardId,
                teamId: teamId
            },
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    };
});
parcelRegister("7IcT2", function(module, exports) {
    $parcel$export(module.exports, "opsReportsErrorTransformer", ()=>$726849c36404771c$export$b170750bd4489531);
    var $aI12f;
    const $726849c36404771c$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
    const $726849c36404771c$export$b170750bd4489531 = (e)=>{
        if ((0, (0, parcelRequire("aI12f")).isHTTPError)(e)) {
            const contentType = e.response.headers.get('Content-Type');
            if (contentType && $726849c36404771c$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, data, data.message));
            return e.response.text().then((message)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, message, message));
        }
        return e;
    };
});
parcelRegister("jubOI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("1I1Wy")),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4Hqzh")
    ]).then(()=>parcelRequire('eHCOd'));
});
parcelRegister("hZVks", function(module, exports) {
    $parcel$export(module.exports, "roleBasedNotificationsResource", ()=>$a9efe5455286a2a7$export$9a716bf20d804ec3);
    $parcel$export(module.exports, "notificationDetailResource", ()=>$a9efe5455286a2a7$export$8ad8a0a20fd0ed5a);
    $parcel$export(module.exports, "resources", ()=>$a9efe5455286a2a7$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $hmVmJ;
    var $dH6Pi;
    var $5V1Ip;
    const $a9efe5455286a2a7$export$9a716bf20d804ec3 = (0, $dIdda.createResource)({
        type: 'roleBasedNotificationsResource',
        getKey: ()=>'roleBasedNotificationsResource',
        getData: (0, (0, parcelRequire("5V1Ip")).getRoleBasedNotificationsEndpoint),
        isBrowserOnly: true,
        maxAge: 300000
    });
    const $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a = (0, $dIdda.createResource)({
        type: 'notificationDetailResource',
        getKey: ({ match: match })=>{
            const settingId = match.params['id'];
            return `notificationDetailResource-id=${settingId}`;
        },
        getData: ({ match: match })=>{
            const settingId = match.params['id'];
            (0, (0, parcelRequire("hmVmJ")).assert)(!!settingId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('notificationDetailResource', 'settingId is required'));
            return (0, (0, parcelRequire("5V1Ip")).getRoleBasedNotificationDetailEndpoint)(settingId);
        },
        isBrowserOnly: true
    });
    const $a9efe5455286a2a7$export$bc99aaabaf7b70a7 = [
        $a9efe5455286a2a7$export$9a716bf20d804ec3,
        $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a
    ];
});
parcelRegister("5V1Ip", function(module, exports) {
    $parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", ()=>$c1906554d85d7a30$export$db67dfe9fe98cd49);
    $parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", ()=>$c1906554d85d7a30$export$5522446e6d3ee73);
    var $j74qU;
    const $c1906554d85d7a30$export$db67dfe9fe98cd49 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/role-based-notifications`);
    const $c1906554d85d7a30$export$5522446e6d3ee73 = (settingId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/role-based-notifications/${settingId}`);
});
parcelRegister("e2wkZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3aNwp")
    ]).then(()=>parcelRequire('2ddPE'));
});
parcelRegister("aSaEv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9nnOd")
    ]).then(()=>parcelRequire('94AYi'));
});
parcelRegister("jSpQ7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cVwzB")
    ]).then(()=>parcelRequire('ecO2s'));
});
parcelRegister("ieJ0b", function(module, exports) {
    $parcel$export(module.exports, "transitioningDetailsResource", ()=>$86a5b96e0cefda11$export$850d76e0c9ffbdeb);
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $86a5b96e0cefda11$export$7985153d37586c9a = (cloudId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getTransitioningDetails',
                    packageName: 'jiraRouterResourcesEocUnlockOperations',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    const $86a5b96e0cefda11$export$850d76e0c9ffbdeb = (0, $dIdda.createResource)({
        type: 'EOC_UNLOCK_OPERATIONS',
        getKey: ()=>'eoc-unlock-operations',
        getData: async (_, { tenantContext: { cloudId: cloudId } })=>$86a5b96e0cefda11$export$7985153d37586c9a(cloudId),
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("8Piip", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("laeSv")
    ]).then(()=>parcelRequire('1lA3p'));
});
parcelRegister("vla3y", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$21f951fdce1763c0$export$bc99aaabaf7b70a7);
    $parcel$export(module.exports, "widgetResources", ()=>$21f951fdce1763c0$export$bce3244764eac6e6);
    $parcel$export(module.exports, "createMyTeamsResource", ()=>(parcelRequire("kCVY8")).createMyTeamsResource);
    $parcel$export(module.exports, "createStatusResource", ()=>(parcelRequire("5IZS8")).createStatusResource);
    $parcel$export(module.exports, "createUserTimelineResource", ()=>(parcelRequire("izTEw")).createUserTimelineResource);
    $parcel$export(module.exports, "createSchedulesResource", ()=>(parcelRequire("dlTDC")).createSchedulesResource);
    parcelRequire("jxRF2");
    var $ldKOT;
    var $kCVY8;
    var $jfpRV;
    var $dlTDC;
    var $5IZS8;
    var $izTEw;
    const $21f951fdce1763c0$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("ldKOT")).eocUserResource),
        (0, (0, parcelRequire("kCVY8")).createMyTeamsResource)(),
        (0, (0, parcelRequire("5IZS8")).createStatusResource)(),
        (0, (0, parcelRequire("jfpRV")).createOpsTeamsResource)()
    ];
    const $21f951fdce1763c0$export$bce3244764eac6e6 = [
        ()=>(0, (0, parcelRequire("ldKOT")).eocUserResource),
        (callback, depends)=>(0, (0, parcelRequire("kCVY8")).createMyTeamsResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("5IZS8")).createStatusResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("izTEw")).createUserTimelineResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("dlTDC")).createSchedulesResource)(callback, depends)
    ];
});
parcelRegister("kCVY8", function(module, exports) {
    $parcel$export(module.exports, "createMyTeamsResource", ()=>$cad624fc2ff7cfd6$export$bf86fb90d0661bcb);
    var $dIdda = parcelRequire("dIdda");
    var $6OdRW;
    const $cad624fc2ff7cfd6$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'myTeamsResource',
            getKey: ()=>'myTeamsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("6OdRW")).getMyTeamsEndpoint)();
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("6OdRW", function(module, exports) {
    $parcel$export(module.exports, "getMyTeamsEndpoint", ()=>$8d7771bc195a7eba$export$abe46da7d1f191a7);
    var $j74qU;
    const $8d7771bc195a7eba$export$abe46da7d1f191a7 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/suggested`);
    };
});
parcelRegister("jfpRV", function(module, exports) {
    $parcel$export(module.exports, "createOpsTeamsResource", ()=>$8fdf339b714e66ed$export$99505a9d792f516c);
    var $dIdda = parcelRequire("dIdda");
    var $6LUYW;
    const $8fdf339b714e66ed$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'opsTeamsResource',
            getKey: ()=>'opsTeamsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("6LUYW")).getOpsTeamsEndpoint)().then((response)=>{
                    return response.values;
                });
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("6LUYW", function(module, exports) {
    $parcel$export(module.exports, "getOpsTeamsEndpoint", ()=>$da0ecde7fda1bab3$export$7498ba30158c16cd);
    var $j74qU;
    var $68pYM;
    const $da0ecde7fda1bab3$export$7498ba30158c16cd = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("68pYM")).urls).teams.url());
    };
});
parcelRegister("68pYM", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$d4c8bf52c3691263$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "SPOTLIGHT_NAMES", ()=>$d4c8bf52c3691263$export$a7c923252528b255);
    $parcel$export(module.exports, "SPOTLIGHT_TOURS", ()=>$d4c8bf52c3691263$export$38c46ed7a5bc80a0);
    $parcel$export(module.exports, "WhoIsOnCallHandler", ()=>$d4c8bf52c3691263$export$1e7191618d5d4548);
    $parcel$export(module.exports, "WhoIsOnCallWidgetHandler", ()=>$d4c8bf52c3691263$export$d05bbb1ada0e07c4);
    const $d4c8bf52c3691263$export$bcae9ba627f604b6 = Object.freeze({
        schedules: {
            url: ()=>`/v1/schedules`,
            user: {
                url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/user`,
                timeline: {
                    url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                    export: {
                        url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                    }
                },
                userId: {
                    url: ({ userId: userId } = {
                        userId: ':userId'
                    })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
                }
            },
            onCalls: {
                url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/on-calls`
            },
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.scheduleId.url({
                            scheduleId: scheduleId
                        })}/timeline`
                }
            }
        },
        wioc: {
            status: {
                url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
            }
        },
        teams: {
            url: ()=>`/v1/teams`
        }
    });
    const $d4c8bf52c3691263$export$a7c923252528b255 = {
        firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
    };
    const $d4c8bf52c3691263$export$38c46ed7a5bc80a0 = {
        overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
    };
    class $d4c8bf52c3691263$export$1e7191618d5d4548 {
        handler(message, context) {
            throw new Error('Not implemented');
        }
    }
    class $d4c8bf52c3691263$export$d05bbb1ada0e07c4 {
        handler(message, context) {
            throw new Error('Not implemented');
        }
    }
});
parcelRegister("dlTDC", function(module, exports) {
    $parcel$export(module.exports, "createSchedulesResource", ()=>$10cde28570610d7a$export$b5e65ca3f82b01c5);
    var $dIdda = parcelRequire("dIdda");
    var $ajrLe;
    const $10cde28570610d7a$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'schedulesResource',
            getKey: ()=>'schedulesResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("ajrLe")).getSchedulesEndpoint)();
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("ajrLe", function(module, exports) {
    $parcel$export(module.exports, "getSchedulesEndpoint", ()=>$1a931852d60ab07d$export$e8e940098db1b988);
    var $j74qU;
    var $68pYM;
    const $1a931852d60ab07d$export$e8e940098db1b988 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`${(0, (0, parcelRequire("68pYM")).urls).schedules.onCalls.url()}`);
    };
});
parcelRegister("5IZS8", function(module, exports) {
    $parcel$export(module.exports, "createStatusResource", ()=>$c6e09a482698443b$export$3d1c353e2693418c);
    var $dIdda = parcelRequire("dIdda");
    var $iyzC0;
    var $41Gqg;
    const $c6e09a482698443b$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'statusResource',
            getKey: ()=>'statusResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("iyzC0")).getStatus)().then((0, (0, parcelRequire("41Gqg")).transformStatusResponse));
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("iyzC0", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$d83203ae0be7e9b4$export$b70265791d2079d4);
    var $j74qU;
    var $68pYM;
    const $d83203ae0be7e9b4$export$b70265791d2079d4 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("68pYM")).urls).wioc.status.url(), {
            method: 'GET'
        });
    };
});
parcelRegister("41Gqg", function(module, exports) {
    $parcel$export(module.exports, "transformStatusResponse", ()=>$8a21b756a892d7eb$export$44a749c89534e42c);
    const $8a21b756a892d7eb$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
        return {
            currentDate: currentTimeUtcMillis,
            currentShiftEnd: onCallUntilUtcMillis,
            currentShiftEndOffset: onCallUntilOffsetMillis,
            isOnCall: isCurrentOnCall,
            isParticipantOfAnyRotation: isParticipantOfAnyRotation,
            nextEndDate: nextOnCallEndUtcMillis,
            nextEndOffset: nextOnCallEndOffsetMillis,
            nextStartDate: nextOnCallStartUtcMillis,
            nextStartOffset: nextOnCallStartOffsetMillis
        };
    };
});
parcelRegister("izTEw", function(module, exports) {
    $parcel$export(module.exports, "createUserTimelineResource", ()=>$3f4c51b6b015af14$export$a479dcc35c33def1);
    var $dIdda = parcelRequire("dIdda");
    parcelRequire("jxRF2");
    var $ldKOT;
    var $5rGi1;
    const $3f4c51b6b015af14$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'userTimelineResource',
            getKey: ()=>'userTimelineResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                const data = await dependencies[(0, (0, parcelRequire("ldKOT")).eocUserResource).type]?.promise;
                const accountId = data?.accountId;
                const timezone = data?.timeZone;
                if (!accountId || !timezone) return null;
                return (0, (0, parcelRequire("5rGi1")).getWidgetTimeline)(accountId);
            },
            isBrowserOnly: true,
            depends: [
                ...depends ? depends : [],
                (0, (0, parcelRequire("ldKOT")).eocUserResource).type
            ]
        });
});
parcelRegister("5rGi1", function(module, exports) {
    $parcel$export(module.exports, "getWidgetTimeline", ()=>$2c4955dde7aaf4da$export$bd80cae08a85b1f0);
    var $eYLkf;
    var $j74qU;
    var $68pYM;
    var $8PqA1;
    const $2c4955dde7aaf4da$export$bd80cae08a85b1f0 = (accountId)=>{
        const formattedCurrent = (0, (0, parcelRequire("eYLkf")).default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
        const urlParams = new URLSearchParams({
            currentDate: formattedCurrent,
            accountId: accountId,
            mode: 'timeline',
            timelineType: '6'
        });
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`${(0, (0, parcelRequire("68pYM")).urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
            method: 'GET'
        }).then((0, (0, parcelRequire("8PqA1")).transformUserTimelineResponse));
    };
});
parcelRegister("eYLkf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae7b6125506491b3$export$2e2bcd8739ae039);
    var $fwbX5;
    var $iwG2X;
    var $jAT0D;
    function $ae7b6125506491b3$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
        var extendedOptions = (0, ($parcel$interopDefault((0, parcelRequire("fwbX5")))))(options);
        extendedOptions.timeZone = timeZone;
        extendedOptions.originalDate = date;
        return (0, (0, parcelRequire("iwG2X")).default)((0, (0, parcelRequire("jAT0D")).default)(date, timeZone), formatStr, extendedOptions);
    }
});
parcelRegister("fwbX5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $b4c31d9870379ac2$var$cloneObject;
    var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
    function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
        return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
    }
    module.exports = module.exports.default;
});
parcelRegister("cpl5v", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $90882d6ff669df4d$var$assign;
    function $90882d6ff669df4d$var$assign(target, dirtyObject) {
        if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
        dirtyObject = dirtyObject || {};
        for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
        return target;
    }
    module.exports = module.exports.default;
});
parcelRegister("iwG2X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7cbd4ba80af9369$export$2e2bcd8739ae039);
    var $aR9Qf;
    var $dBimx;
    var $gUUmE;
    var $d7cbd4ba80af9369$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function $d7cbd4ba80af9369$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var matches = formatStr.match($d7cbd4ba80af9369$var$tzFormattingTokensRegExp);
        if (matches) {
            var date = (0, (0, parcelRequire("gUUmE")).default)(options.originalDate || dirtyDate, options);
            formatStr = matches.reduce(function(result, token) {
                if (token[0] === "'") return result;
                var pos = result.indexOf(token);
                var precededByQuotedSection = result[pos - 1] === "'";
                var replaced = result.replace(token, "'" + (0, (0, parcelRequire("dBimx")).default)[token[0]](date, token, null, options) + "'");
                return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
            }, formatStr);
        }
        return (0, ($parcel$interopDefault((0, parcelRequire("aR9Qf")))))(dirtyDate, formatStr, options);
    }
});
parcelRegister("aR9Qf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7e767cfeba790ebe$var$format;
    var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));
    var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));
    var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));
    var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));
    var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));
    var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));
    var $5qguX;
    var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
    var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
    var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
    function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
        (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        if (!locale.localize) throw new RangeError('locale must contain localize property');
        if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
        var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
        if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
        var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
        var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
        var formatterOptions = {
            firstWeekContainsDate: firstWeekContainsDate,
            weekStartsOn: weekStartsOn,
            locale: locale,
            _originalDate: originalDate
        };
        var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
            var firstCharacter = substring[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
                var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
                return longFormatter(substring, locale.formatLong, formatterOptions);
            }
            return substring;
        }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
            if (substring === "''") return "'";
            var firstCharacter = substring[0];
            if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
            var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
            if (formatter) {
                if (!options.useAdditionalWeekYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedWeekYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                if (!options.useAdditionalDayOfYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedDayOfYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                return formatter(utcDate, substring, locale.localize, formatterOptions);
            }
            if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
            return substring;
        }).join('');
        return result;
    }
    function $7e767cfeba790ebe$var$cleanEscapedString(input) {
        return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
    }
    module.exports = module.exports.default;
});
parcelRegister("ck8JK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8f8e2146dfa1d727$var$isValid;
    var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
        (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
        var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
        return !isNaN(date);
    }
    module.exports = module.exports.default;
});
parcelRegister("2pWQP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $1c2b912e6615b0b5$var$toDate;
    var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $1c2b912e6615b0b5$var$toDate(argument) {
        (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
        var argStr = Object.prototype.toString.call(argument);
        if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
        else {
            if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
                console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
                console.warn(new Error().stack);
            }
            return new Date(NaN);
        }
    }
    module.exports = module.exports.default;
});
parcelRegister("6eBfj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
    function $48a0f126c2293ab3$var$requiredArgs(required, args) {
        if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
    }
    module.exports = module.exports.default;
});
parcelRegister("kvNR5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));
    var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));
    var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));
    var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));
    var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
    function $eeed6020e120f946$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $eeed6020e120f946$var$locale = {
        code: 'en-US',
        formatDistance: $eeed6020e120f946$var$_index.default,
        formatLong: $eeed6020e120f946$var$_index2.default,
        formatRelative: $eeed6020e120f946$var$_index3.default,
        localize: $eeed6020e120f946$var$_index4.default,
        match: $eeed6020e120f946$var$_index5.default,
        options: {
            weekStartsOn: 0,
            firstWeekContainsDate: 1
        }
    };
    var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
    module.exports.default = $eeed6020e120f946$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("5u9TK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
    var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
        lessThanXSeconds: {
            one: 'less than a second',
            other: 'less than {{count}} seconds'
        },
        xSeconds: {
            one: '1 second',
            other: '{{count}} seconds'
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
            one: 'less than a minute',
            other: 'less than {{count}} minutes'
        },
        xMinutes: {
            one: '1 minute',
            other: '{{count}} minutes'
        },
        aboutXHours: {
            one: 'about 1 hour',
            other: 'about {{count}} hours'
        },
        xHours: {
            one: '1 hour',
            other: '{{count}} hours'
        },
        xDays: {
            one: '1 day',
            other: '{{count}} days'
        },
        aboutXWeeks: {
            one: 'about 1 week',
            other: 'about {{count}} weeks'
        },
        xWeeks: {
            one: '1 week',
            other: '{{count}} weeks'
        },
        aboutXMonths: {
            one: 'about 1 month',
            other: 'about {{count}} months'
        },
        xMonths: {
            one: '1 month',
            other: '{{count}} months'
        },
        aboutXYears: {
            one: 'about 1 year',
            other: 'about {{count}} years'
        },
        xYears: {
            one: '1 year',
            other: '{{count}} years'
        },
        overXYears: {
            one: 'over 1 year',
            other: 'over {{count}} years'
        },
        almostXYears: {
            one: 'almost 1 year',
            other: 'almost {{count}} years'
        }
    };
    function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
        options = options || {};
        var result;
        if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
        else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
        else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
        if (options.addSuffix) {
            if (options.comparison > 0) return 'in ' + result;
            else return result + ' ago';
        }
        return result;
    }
    module.exports = module.exports.default;
});
parcelRegister("e7AgV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
    function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $a47ddb0366100c31$var$dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
    };
    var $a47ddb0366100c31$var$timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
    };
    var $a47ddb0366100c31$var$dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
    };
    var $a47ddb0366100c31$var$formatLong = {
        date: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateFormats,
            defaultWidth: 'full'
        }),
        time: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$timeFormats,
            defaultWidth: 'full'
        }),
        dateTime: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateTimeFormats,
            defaultWidth: 'full'
        })
    };
    var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
    module.exports.default = $a47ddb0366100c31$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("4raqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
    function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
        return function() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var width = options.width ? String(options.width) : args.defaultWidth;
            var format = args.formats[width] || args.formats[args.defaultWidth];
            return format;
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("8U2eY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
    var $67b54aa1e07b4b42$var$formatRelativeLocale = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: 'P'
    };
    function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
        return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
    }
    module.exports = module.exports.default;
});
parcelRegister("b9d75", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
    function $81dab50370972ecd$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $81dab50370972ecd$var$eraValues = {
        narrow: [
            'B',
            'A'
        ],
        abbreviated: [
            'BC',
            'AD'
        ],
        wide: [
            'Before Christ',
            'Anno Domini'
        ]
    };
    var $81dab50370972ecd$var$quarterValues = {
        narrow: [
            '1',
            '2',
            '3',
            '4'
        ],
        abbreviated: [
            'Q1',
            'Q2',
            'Q3',
            'Q4'
        ],
        wide: [
            '1st quarter',
            '2nd quarter',
            '3rd quarter',
            '4th quarter'
        ]
    };
    var $81dab50370972ecd$var$monthValues = {
        narrow: [
            'J',
            'F',
            'M',
            'A',
            'M',
            'J',
            'J',
            'A',
            'S',
            'O',
            'N',
            'D'
        ],
        abbreviated: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        wide: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
    };
    var $81dab50370972ecd$var$dayValues = {
        narrow: [
            'S',
            'M',
            'T',
            'W',
            'T',
            'F',
            'S'
        ],
        short: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        abbreviated: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        wide: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ]
    };
    var $81dab50370972ecd$var$dayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        }
    };
    var $81dab50370972ecd$var$formattingDayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        }
    };
    function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;
        if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
            case 1:
                return number + 'st';
            case 2:
                return number + 'nd';
            case 3:
                return number + 'rd';
        }
        return number + 'th';
    }
    var $81dab50370972ecd$var$localize = {
        ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
        era: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$eraValues,
            defaultWidth: 'wide'
        }),
        quarter: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$quarterValues,
            defaultWidth: 'wide',
            argumentCallback: function(quarter) {
                return Number(quarter) - 1;
            }
        }),
        month: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$monthValues,
            defaultWidth: 'wide'
        }),
        day: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayValues,
            defaultWidth: 'wide'
        }),
        dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayPeriodValues,
            defaultWidth: 'wide',
            formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
            defaultFormattingWidth: 'wide'
        })
    };
    var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
    module.exports.default = $81dab50370972ecd$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("llBmH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
    function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
        return function(dirtyIndex, dirtyOptions) {
            var options = dirtyOptions || {};
            var context = options.context ? String(options.context) : 'standalone';
            var valuesArray;
            if (context === 'formatting' && args.formattingValues) {
                var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
                var width = options.width ? String(options.width) : defaultWidth;
                valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
            } else {
                var _defaultWidth = args.defaultWidth;
                var _width = options.width ? String(options.width) : args.defaultWidth;
                valuesArray = args.values[_width] || args.values[_defaultWidth];
            }
            var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
            return valuesArray[index];
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("hHwuU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));
    var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
    function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
    var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
    var $ce2fa922bf4a591b$var$matchEraPatterns = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
    };
    var $ce2fa922bf4a591b$var$parseEraPatterns = {
        any: [
            /^b/i,
            /^(a|c)/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
        any: [
            /1/i,
            /2/i,
            /3/i,
            /4/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    var $ce2fa922bf4a591b$var$parseMonthPatterns = {
        narrow: [
            /^j/i,
            /^f/i,
            /^m/i,
            /^a/i,
            /^m/i,
            /^j/i,
            /^j/i,
            /^a/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ],
        any: [
            /^ja/i,
            /^f/i,
            /^mar/i,
            /^ap/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^au/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    var $ce2fa922bf4a591b$var$parseDayPatterns = {
        narrow: [
            /^s/i,
            /^m/i,
            /^t/i,
            /^w/i,
            /^t/i,
            /^f/i,
            /^s/i
        ],
        any: [
            /^su/i,
            /^m/i,
            /^tu/i,
            /^w/i,
            /^th/i,
            /^f/i,
            /^sa/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
        any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i
        }
    };
    var $ce2fa922bf4a591b$var$match = {
        ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
            matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
            parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
            valueCallback: function(value) {
                return parseInt(value, 10);
            }
        }),
        era: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
            defaultParseWidth: 'any'
        }),
        quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
            defaultParseWidth: 'any',
            valueCallback: function(index) {
                return index + 1;
            }
        }),
        month: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
            defaultParseWidth: 'any'
        }),
        day: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
            defaultParseWidth: 'any'
        }),
        dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
            defaultMatchWidth: 'any',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
            defaultParseWidth: 'any'
        })
    };
    var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
    module.exports.default = $ce2fa922bf4a591b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("1IY7t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
    function $141888fa04c95812$var$buildMatchPatternFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var matchResult = string.match(args.matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parseResult = string.match(args.parsePattern);
            if (!parseResult) return null;
            var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("liduU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
    function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var width = options.width;
            var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
            var matchResult = string.match(matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
            var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            });
            var value;
            value = args.valueCallback ? args.valueCallback(key) : key;
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
        for(var key in object){
            if (object.hasOwnProperty(key) && predicate(object[key])) return key;
        }
        return undefined;
    }
    function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
        for(var key = 0; key < array.length; key++){
            if (predicate(array[key])) return key;
        }
        return undefined;
    }
    module.exports = module.exports.default;
});
parcelRegister("bQkcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;
    var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));
    var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
        (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
        var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
        return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("aSksP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
    function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
        if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
        var number = Number(dirtyNumber);
        if (isNaN(number)) return number;
        return number < 0 ? Math.ceil(number) : Math.floor(number);
    }
    module.exports = module.exports.default;
});
parcelRegister("7f9OM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;
    var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
        (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
        var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
        var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
        return new Date(timestamp + amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("3ckvK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));
    var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));
    var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));
    var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));
    var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2542672a600cd2b8$var$dayPeriodEnum = {
        am: 'am',
        pm: 'pm',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    };
    var $2542672a600cd2b8$var$formatters = {
        G: function(date, token, localize) {
            var era = date.getUTCFullYear() > 0 ? 1 : 0;
            switch(token){
                case 'G':
                case 'GG':
                case 'GGG':
                    return localize.era(era, {
                        width: 'abbreviated'
                    });
                case 'GGGGG':
                    return localize.era(era, {
                        width: 'narrow'
                    });
                case 'GGGG':
                default:
                    return localize.era(era, {
                        width: 'wide'
                    });
            }
        },
        y: function(date, token, localize) {
            if (token === 'yo') {
                var signedYear = date.getUTCFullYear();
                var year = signedYear > 0 ? signedYear : 1 - signedYear;
                return localize.ordinalNumber(year, {
                    unit: 'year'
                });
            }
            return $2542672a600cd2b8$var$_index.default.y(date, token);
        },
        Y: function(date, token, localize, options) {
            var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options);
            var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
            if (token === 'YY') {
                var twoDigitYear = weekYear % 100;
                return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
            }
            if (token === 'Yo') return localize.ordinalNumber(weekYear, {
                unit: 'year'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
        },
        R: function(date, token) {
            var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date);
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
        },
        u: function(date, token) {
            var year = date.getUTCFullYear();
            return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
        },
        Q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'Q':
                    return String(quarter);
                case 'QQ':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'Qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'QQQ':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'QQQQQ':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQ':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'q':
                    return String(quarter);
                case 'qq':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'qqq':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'qqqqq':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqq':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        M: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'M':
                case 'MM':
                    return $2542672a600cd2b8$var$_index.default.M(date, token);
                case 'Mo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'MMM':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'MMMMM':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMM':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        L: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'L':
                    return String(month + 1);
                case 'LL':
                    return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
                case 'Lo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'LLL':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'LLLLL':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLL':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        w: function(date, token, localize, options) {
            var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
            if (token === 'wo') return localize.ordinalNumber(week, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
        },
        I: function(date, token, localize) {
            var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
            if (token === 'Io') return localize.ordinalNumber(isoWeek, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
        },
        d: function(date, token, localize) {
            if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
                unit: 'date'
            });
            return $2542672a600cd2b8$var$_index.default.d(date, token);
        },
        D: function(date, token, localize) {
            var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
            if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
                unit: 'dayOfYear'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
        },
        E: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            switch(token){
                case 'E':
                case 'EE':
                case 'EEE':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'EEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'EEEE':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        e: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'e':
                    return String(localDayOfWeek);
                case 'ee':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
                case 'eo':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'eee':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'eeeee':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeeee':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'eeee':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        c: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'c':
                    return String(localDayOfWeek);
                case 'cc':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
                case 'co':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'ccc':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'ccccc':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccccc':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'standalone'
                    });
                case 'cccc':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        i: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
            switch(token){
                case 'i':
                    return String(isoDayOfWeek);
                case 'ii':
                    return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
                case 'io':
                    return localize.ordinalNumber(isoDayOfWeek, {
                        unit: 'day'
                    });
                case 'iii':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'iiiii':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'iiiiii':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'iiii':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        a: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'aaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'aaaaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        b: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
            else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
            else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'b':
                case 'bb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'bbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'bbbbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        B: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
            else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
            else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
            else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        h: function(date, token, localize) {
            if (token === 'ho') {
                var hours = date.getUTCHours() % 12;
                if (hours === 0) hours = 12;
                return localize.ordinalNumber(hours, {
                    unit: 'hour'
                });
            }
            return $2542672a600cd2b8$var$_index.default.h(date, token);
        },
        H: function(date, token, localize) {
            if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
                unit: 'hour'
            });
            return $2542672a600cd2b8$var$_index.default.H(date, token);
        },
        K: function(date, token, localize) {
            var hours = date.getUTCHours() % 12;
            if (token === 'Ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        k: function(date, token, localize) {
            var hours = date.getUTCHours();
            if (hours === 0) hours = 24;
            if (token === 'ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        m: function(date, token, localize) {
            if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
                unit: 'minute'
            });
            return $2542672a600cd2b8$var$_index.default.m(date, token);
        },
        s: function(date, token, localize) {
            if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
                unit: 'second'
            });
            return $2542672a600cd2b8$var$_index.default.s(date, token);
        },
        S: function(date, token) {
            return $2542672a600cd2b8$var$_index.default.S(date, token);
        },
        X: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'x':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'zzzz':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        t: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = Math.floor(originalDate.getTime() / 1000);
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        },
        T: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = originalDate.getTime();
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        }
    };
    function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
    }
    function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
        }
        return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
    }
    function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
        var delimiter = dirtyDelimiter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
        var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
        return sign + hours + delimiter + minutes;
    }
    var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
    module.exports.default = $2542672a600cd2b8$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("kFGp1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $f0c88744bd108133$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $f0c88744bd108133$var$formatters = {
        y: function(date, token) {
            var signedYear = date.getUTCFullYear();
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
        },
        M: function(date, token) {
            var month = date.getUTCMonth();
            return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
        },
        d: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
        },
        a: function(date, token) {
            var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return dayPeriodEnumValue.toUpperCase();
                case 'aaa':
                    return dayPeriodEnumValue;
                case 'aaaaa':
                    return dayPeriodEnumValue[0];
                case 'aaaa':
                default:
                    return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
            }
        },
        h: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
        },
        H: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
        },
        m: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
        },
        s: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
        },
        S: function(date, token) {
            var numberOfDigits = token.length;
            var milliseconds = date.getUTCMilliseconds();
            var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
            return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
        }
    };
    var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
    module.exports.default = $f0c88744bd108133$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("bQ2eo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
    function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    module.exports = module.exports.default;
});
parcelRegister("3xdEO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;
    var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000;
    function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
        (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
        var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
        var timestamp = date.getTime();
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
        var startOfYearTimestamp = date.getTime();
        var difference = timestamp - startOfYearTimestamp;
        return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6Falt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;
    var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));
    var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000;
    function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
        (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
        var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
        var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime();
        return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6nDqw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;
    var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4a53796a96b58804$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
        (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
        var weekStartsOn = 1;
        var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("hI2kM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;
    var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $ce485b424b643216$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
        (0, $ce485b424b643216$var$_index3.default)(1, arguments);
        var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setUTCFullYear(year, 0, 4);
        fourthOfJanuary.setUTCHours(0, 0, 0, 0);
        var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("gUvh1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;
    var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
        (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
        var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
        var year = date.getUTCFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("46m4m", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;
    var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));
    var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000;
    function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
        (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
        var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
        var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime();
        return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("clhRK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;
    var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
        (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("cbqvD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;
    var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
        var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
        var firstWeek = new Date(0);
        firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setUTCHours(0, 0, 0, 0);
        var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("3ihh3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;
    var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
        var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
        var year = date.getUTCFullYear();
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("awKAW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'P':
                return formatLong.date({
                    width: 'short'
                });
            case 'PP':
                return formatLong.date({
                    width: 'medium'
                });
            case 'PPP':
                return formatLong.date({
                    width: 'long'
                });
            case 'PPPP':
            default:
                return formatLong.date({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'p':
                return formatLong.time({
                    width: 'short'
                });
            case 'pp':
                return formatLong.time({
                    width: 'medium'
                });
            case 'ppp':
                return formatLong.time({
                    width: 'long'
                });
            case 'pppp':
            default:
                return formatLong.time({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
        var matchResult = pattern.match(/(P+)(p+)?/);
        var datePattern = matchResult[1];
        var timePattern = matchResult[2];
        if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
        var dateTimeFormat;
        switch(datePattern){
            case 'P':
                dateTimeFormat = formatLong.dateTime({
                    width: 'short'
                });
                break;
            case 'PP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'medium'
                });
                break;
            case 'PPP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'long'
                });
                break;
            case 'PPPP':
            default:
                dateTimeFormat = formatLong.dateTime({
                    width: 'full'
                });
                break;
        }
        return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
    }
    var $7aa109506ceedd4b$var$longFormatters = {
        p: $7aa109506ceedd4b$var$timeLongFormatter,
        P: $7aa109506ceedd4b$var$dateTimeLongFormatter
    };
    var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
    module.exports.default = $7aa109506ceedd4b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("jGQTC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
    function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
        var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        utcDate.setUTCFullYear(date.getFullYear());
        return date.getTime() - utcDate.getTime();
    }
    module.exports = module.exports.default;
});
parcelRegister("5qguX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
    module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
    module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
    var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
        'D',
        'DD'
    ];
    var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
        'YY',
        'YYYY'
    ];
    function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
        return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
        return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
        if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    }
});
parcelRegister("dBimx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e6cf97ea11d4595$export$2e2bcd8739ae039);
    var $kbEJb = parcelRequire("kbEJb");
    var $i6fIb = parcelRequire("i6fIb");
    var $9e6cf97ea11d4595$var$MILLISECONDS_IN_MINUTE = 60000;
    var $9e6cf97ea11d4595$var$formatters = {
        X: function(date, token, localize, options) {
            var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, localize, options) {
            var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'x':
                    return $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, localize, options) {
            var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $9e6cf97ea11d4595$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, localize, options) {
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return (0, $kbEJb.default)('short', date, options);
                case 'zzzz':
                default:
                    return (0, $kbEJb.default)('long', date, options);
            }
        }
    };
    function $9e6cf97ea11d4595$var$getTimeZoneOffset(timeZone, originalDate) {
        var timeZoneOffset = timeZone ? (0, $i6fIb.default)(timeZone, originalDate, true) / $9e6cf97ea11d4595$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
        if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
        return timeZoneOffset;
    }
    function $9e6cf97ea11d4595$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    function $9e6cf97ea11d4595$var$formatTimezone(offset, dirtyDelimeter) {
        var delimeter = dirtyDelimeter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = $9e6cf97ea11d4595$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
        var minutes = $9e6cf97ea11d4595$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
        return sign + hours + delimeter + minutes;
    }
    function $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + $9e6cf97ea11d4595$var$addLeadingZeros(Math.abs(offset) / 60, 2);
        }
        return $9e6cf97ea11d4595$var$formatTimezone(offset, dirtyDelimeter);
    }
    function $9e6cf97ea11d4595$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + $9e6cf97ea11d4595$var$addLeadingZeros(minutes, 2);
    }
    var $9e6cf97ea11d4595$export$2e2bcd8739ae039 = $9e6cf97ea11d4595$var$formatters;
});
parcelRegister("kbEJb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb246d6cdcaaeca4$export$2e2bcd8739ae039);
    function $eb246d6cdcaaeca4$export$2e2bcd8739ae039(length, date, options) {
        var dtf = $eb246d6cdcaaeca4$var$getDTF(length, options.timeZone, options.locale);
        return dtf.formatToParts ? $eb246d6cdcaaeca4$var$partsTimeZone(dtf, date) : $eb246d6cdcaaeca4$var$hackyTimeZone(dtf, date);
    }
    function $eb246d6cdcaaeca4$var$partsTimeZone(dtf, date) {
        var formatted = dtf.formatToParts(date);
        for(var i = formatted.length - 1; i >= 0; --i){
            if (formatted[i].type === 'timeZoneName') return formatted[i].value;
        }
    }
    function $eb246d6cdcaaeca4$var$hackyTimeZone(dtf, date) {
        var formatted = dtf.format(date).replace(/\u200E/g, '');
        var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
        return tzNameMatch ? tzNameMatch[0].substr(1) : '';
    }
    function $eb246d6cdcaaeca4$var$getDTF(length, timeZone, locale) {
        if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
        return new Intl.DateTimeFormat(locale ? [
            locale.code,
            'en-US'
        ] : undefined, {
            timeZone: timeZone,
            timeZoneName: length
        });
    }
});
parcelRegister("i6fIb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2d4f98f2ab6c303$export$2e2bcd8739ae039);
    var $hb3mZ = parcelRequire("hb3mZ");
    var $e86X7 = parcelRequire("e86X7");
    var $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR = 3600000;
    var $d2d4f98f2ab6c303$var$MILLISECONDS_IN_MINUTE = 60000;
    var $d2d4f98f2ab6c303$var$patterns = {
        timezone: /([Z+-].*)$/,
        timezoneZ: /^(Z)$/,
        timezoneHH: /^([+-]\d{2})$/,
        timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
    };
    function $d2d4f98f2ab6c303$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
        var token;
        var absoluteOffset;
        if (!timezoneString) return 0;
        token = $d2d4f98f2ab6c303$var$patterns.timezoneZ.exec(timezoneString);
        if (token) return 0;
        var hours;
        token = $d2d4f98f2ab6c303$var$patterns.timezoneHH.exec(timezoneString);
        if (token) {
            hours = parseInt(token[1], 10);
            if (!$d2d4f98f2ab6c303$var$validateTimezone(hours)) return NaN;
            return -(hours * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR);
        }
        token = $d2d4f98f2ab6c303$var$patterns.timezoneHHMM.exec(timezoneString);
        if (token) {
            hours = parseInt(token[2], 10);
            var minutes = parseInt(token[3], 10);
            if (!$d2d4f98f2ab6c303$var$validateTimezone(hours, minutes)) return NaN;
            absoluteOffset = Math.abs(hours) * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR + minutes * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_MINUTE;
            return token[1] === '+' ? -absoluteOffset : absoluteOffset;
        }
        if ($d2d4f98f2ab6c303$var$isValidTimezoneIANAString(timezoneString)) {
            date = new Date(date || Date.now());
            var utcDate = isUtcDate ? date : $d2d4f98f2ab6c303$var$toUtcDate(date);
            var offset = $d2d4f98f2ab6c303$var$calcOffset(utcDate, timezoneString);
            var fixedOffset = isUtcDate ? offset : $d2d4f98f2ab6c303$var$fixOffset(date, offset, timezoneString);
            return -fixedOffset;
        }
        return NaN;
    }
    function $d2d4f98f2ab6c303$var$toUtcDate(date) {
        return (0, $e86X7.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function $d2d4f98f2ab6c303$var$calcOffset(date, timezoneString) {
        var tokens = (0, $hb3mZ.default)(date, timezoneString);
        var asUTC = (0, $e86X7.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
        var asTS = date.getTime();
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return asUTC - asTS;
    }
    function $d2d4f98f2ab6c303$var$fixOffset(date, offset, timezoneString) {
        var localTS = date.getTime();
        var utcGuess = localTS - offset;
        var o2 = $d2d4f98f2ab6c303$var$calcOffset(new Date(utcGuess), timezoneString);
        if (offset === o2) return offset;
        utcGuess -= o2 - offset;
        var o3 = $d2d4f98f2ab6c303$var$calcOffset(new Date(utcGuess), timezoneString);
        if (o2 === o3) return o2;
        return Math.max(o2, o3);
    }
    function $d2d4f98f2ab6c303$var$validateTimezone(hours, minutes) {
        return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var $d2d4f98f2ab6c303$var$validIANATimezoneCache = {};
    function $d2d4f98f2ab6c303$var$isValidTimezoneIANAString(timeZoneString) {
        if ($d2d4f98f2ab6c303$var$validIANATimezoneCache[timeZoneString]) return true;
        try {
            new Intl.DateTimeFormat(undefined, {
                timeZone: timeZoneString
            });
            $d2d4f98f2ab6c303$var$validIANATimezoneCache[timeZoneString] = true;
            return true;
        } catch (error) {
            return false;
        }
    }
});
parcelRegister("hb3mZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c81613eb8d87ac5c$export$2e2bcd8739ae039);
    function $c81613eb8d87ac5c$export$2e2bcd8739ae039(date, timeZone) {
        var dtf = $c81613eb8d87ac5c$var$getDateTimeFormat(timeZone);
        return dtf.formatToParts ? $c81613eb8d87ac5c$var$partsOffset(dtf, date) : $c81613eb8d87ac5c$var$hackyOffset(dtf, date);
    }
    var $c81613eb8d87ac5c$var$typeToPos = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    };
    function $c81613eb8d87ac5c$var$partsOffset(dtf, date) {
        try {
            var formatted = dtf.formatToParts(date);
            var filled = [];
            for(var i = 0; i < formatted.length; i++){
                var pos = $c81613eb8d87ac5c$var$typeToPos[formatted[i].type];
                if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
            }
            return filled;
        } catch (error) {
            if (error instanceof RangeError) return [
                NaN
            ];
            throw error;
        }
    }
    function $c81613eb8d87ac5c$var$hackyOffset(dtf, date) {
        var formatted = dtf.format(date);
        var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
        return [
            parsed[3],
            parsed[1],
            parsed[2],
            parsed[4],
            parsed[5],
            parsed[6]
        ];
    }
    var $c81613eb8d87ac5c$var$dtfCache = {};
    function $c81613eb8d87ac5c$var$getDateTimeFormat(timeZone) {
        if (!$c81613eb8d87ac5c$var$dtfCache[timeZone]) {
            var testDateFormatted = new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).format(new Date('2014-06-25T04:00:00.123Z'));
            var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
            $c81613eb8d87ac5c$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }) : new Intl.DateTimeFormat('en-US', {
                hour12: false,
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        return $c81613eb8d87ac5c$var$dtfCache[timeZone];
    }
});
parcelRegister("e86X7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a49734b25d97733d$export$2e2bcd8739ae039);
    function $a49734b25d97733d$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
        var utcDate = new Date(0);
        utcDate.setUTCFullYear(fullYear, month, day);
        utcDate.setUTCHours(hour, minute, second, millisecond);
        return utcDate;
    }
});
parcelRegister("gUUmE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c50d991cbda2c596$export$2e2bcd8739ae039);
    var $aSksP;
    var $jGQTC;
    var $i6fIb = parcelRequire("i6fIb");
    var $crHgC = parcelRequire("crHgC");
    var $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR = 3600000;
    var $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE = 60000;
    var $c50d991cbda2c596$var$DEFAULT_ADDITIONAL_DIGITS = 2;
    var $c50d991cbda2c596$var$patterns = {
        dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
        datePattern: /^([0-9W+-]+)(.*)/,
        plainTime: /:/,
        YY: /^(\d{2})$/,
        YYY: [
            /^([+-]\d{2})$/,
            /^([+-]\d{3})$/,
            /^([+-]\d{4})$/
        ],
        YYYY: /^(\d{4})/,
        YYYYY: [
            /^([+-]\d{4})/,
            /^([+-]\d{5})/,
            /^([+-]\d{6})/
        ],
        MM: /^-(\d{2})$/,
        DDD: /^-?(\d{3})$/,
        MMDD: /^-?(\d{2})-?(\d{2})$/,
        Www: /^-?W(\d{2})$/,
        WwwD: /^-?W(\d{2})-?(\d{1})$/,
        HH: /^(\d{2}([.,]\d*)?)$/,
        HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        timeZone: (0, $crHgC.default)
    };
    function $c50d991cbda2c596$export$2e2bcd8739ae039(argument, dirtyOptions) {
        if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
        if (argument === null) return new Date(NaN);
        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? $c50d991cbda2c596$var$DEFAULT_ADDITIONAL_DIGITS : (0, ($parcel$interopDefault((0, parcelRequire("aSksP")))))(options.additionalDigits);
        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
        if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
        else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
        var dateStrings = $c50d991cbda2c596$var$splitDateString(argument);
        var parseYearResult = $c50d991cbda2c596$var$parseYear(dateStrings.date, additionalDigits);
        var year = parseYearResult.year;
        var restDateString = parseYearResult.restDateString;
        var date = $c50d991cbda2c596$var$parseDate(restDateString, year);
        if (isNaN(date)) return new Date(NaN);
        if (date) {
            var timestamp = date.getTime();
            var time = 0;
            var offset;
            if (dateStrings.time) {
                time = $c50d991cbda2c596$var$parseTime(dateStrings.time);
                if (isNaN(time)) return new Date(NaN);
            }
            if (dateStrings.timeZone || options.timeZone) {
                offset = (0, $i6fIb.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
                if (isNaN(offset)) return new Date(NaN);
            } else {
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time));
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time + offset));
            }
            return new Date(timestamp + time + offset);
        } else return new Date(NaN);
    }
    function $c50d991cbda2c596$var$splitDateString(dateString) {
        var dateStrings = {};
        var parts = $c50d991cbda2c596$var$patterns.dateTimePattern.exec(dateString);
        var timeString;
        if (!parts) {
            parts = $c50d991cbda2c596$var$patterns.datePattern.exec(dateString);
            if (parts) {
                dateStrings.date = parts[1];
                timeString = parts[2];
            } else {
                dateStrings.date = null;
                timeString = dateString;
            }
        } else {
            dateStrings.date = parts[1];
            timeString = parts[3];
        }
        if (timeString) {
            var token = $c50d991cbda2c596$var$patterns.timeZone.exec(timeString);
            if (token) {
                dateStrings.time = timeString.replace(token[1], '');
                dateStrings.timeZone = token[1].trim();
            } else dateStrings.time = timeString;
        }
        return dateStrings;
    }
    function $c50d991cbda2c596$var$parseYear(dateString, additionalDigits) {
        var patternYYY = $c50d991cbda2c596$var$patterns.YYY[additionalDigits];
        var patternYYYYY = $c50d991cbda2c596$var$patterns.YYYYY[additionalDigits];
        var token;
        token = $c50d991cbda2c596$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            var yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        token = $c50d991cbda2c596$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            var centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
        return {
            year: null
        };
    }
    function $c50d991cbda2c596$var$parseDate(dateString, year) {
        if (year === null) return null;
        var token;
        var date;
        var month;
        var week;
        if (dateString.length === 0) {
            date = new Date(0);
            date.setUTCFullYear(year);
            return date;
        }
        token = $c50d991cbda2c596$var$patterns.MM.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            if (!$c50d991cbda2c596$var$validateDate(year, month)) return new Date(NaN);
            date.setUTCFullYear(year, month);
            return date;
        }
        token = $c50d991cbda2c596$var$patterns.DDD.exec(dateString);
        if (token) {
            date = new Date(0);
            var dayOfYear = parseInt(token[1], 10);
            if (!$c50d991cbda2c596$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
            date.setUTCFullYear(year, 0, dayOfYear);
            return date;
        }
        token = $c50d991cbda2c596$var$patterns.MMDD.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            var day = parseInt(token[2], 10);
            if (!$c50d991cbda2c596$var$validateDate(year, month, day)) return new Date(NaN);
            date.setUTCFullYear(year, month, day);
            return date;
        }
        token = $c50d991cbda2c596$var$patterns.Www.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            if (!$c50d991cbda2c596$var$validateWeekDate(year, week)) return new Date(NaN);
            return $c50d991cbda2c596$var$dayOfISOWeekYear(year, week);
        }
        token = $c50d991cbda2c596$var$patterns.WwwD.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            var dayOfWeek = parseInt(token[2], 10) - 1;
            if (!$c50d991cbda2c596$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
            return $c50d991cbda2c596$var$dayOfISOWeekYear(year, week, dayOfWeek);
        }
        return null;
    }
    function $c50d991cbda2c596$var$parseTime(timeString) {
        var token;
        var hours;
        var minutes;
        token = $c50d991cbda2c596$var$patterns.HH.exec(timeString);
        if (token) {
            hours = parseFloat(token[1].replace(',', '.'));
            if (!$c50d991cbda2c596$var$validateTime(hours)) return NaN;
            return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR;
        }
        token = $c50d991cbda2c596$var$patterns.HHMM.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseFloat(token[2].replace(',', '.'));
            if (!$c50d991cbda2c596$var$validateTime(hours, minutes)) return NaN;
            return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR + minutes * $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE;
        }
        token = $c50d991cbda2c596$var$patterns.HHMMSS.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseInt(token[2], 10);
            var seconds = parseFloat(token[3].replace(',', '.'));
            if (!$c50d991cbda2c596$var$validateTime(hours, minutes, seconds)) return NaN;
            return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR + minutes * $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
        }
        return null;
    }
    function $c50d991cbda2c596$var$dayOfISOWeekYear(isoWeekYear, week, day) {
        week = week || 0;
        day = day || 0;
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
    }
    var $c50d991cbda2c596$var$DAYS_IN_MONTH = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    var $c50d991cbda2c596$var$DAYS_IN_MONTH_LEAP_YEAR = [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    function $c50d991cbda2c596$var$isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function $c50d991cbda2c596$var$validateDate(year, month, date) {
        if (month < 0 || month > 11) return false;
        if (date != null) {
            if (date < 1) return false;
            var isLeapYear = $c50d991cbda2c596$var$isLeapYearIndex(year);
            if (isLeapYear && date > $c50d991cbda2c596$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
            if (!isLeapYear && date > $c50d991cbda2c596$var$DAYS_IN_MONTH[month]) return false;
        }
        return true;
    }
    function $c50d991cbda2c596$var$validateDayOfYearDate(year, dayOfYear) {
        if (dayOfYear < 1) return false;
        var isLeapYear = $c50d991cbda2c596$var$isLeapYearIndex(year);
        if (isLeapYear && dayOfYear > 366) return false;
        if (!isLeapYear && dayOfYear > 365) return false;
        return true;
    }
    function $c50d991cbda2c596$var$validateWeekDate(year, week, day) {
        if (week < 0 || week > 52) return false;
        if (day != null && (day < 0 || day > 6)) return false;
        return true;
    }
    function $c50d991cbda2c596$var$validateTime(hours, minutes, seconds) {
        if (hours != null && (hours < 0 || hours >= 25)) return false;
        if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
        if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
        return true;
    }
});
parcelRegister("crHgC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90f991911d90bed8$export$2e2bcd8739ae039);
    var $90f991911d90bed8$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var $90f991911d90bed8$export$2e2bcd8739ae039 = $90f991911d90bed8$var$tzPattern;
});
parcelRegister("jAT0D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e43c0cd241603813$export$2e2bcd8739ae039);
    var $i6fIb = parcelRequire("i6fIb");
    var $gUUmE;
    function $e43c0cd241603813$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
        var date = (0, (0, parcelRequire("gUUmE")).default)(dirtyDate, options);
        var offsetMilliseconds = (0, $i6fIb.default)(timeZone, date, true);
        var d = new Date(date.getTime() - offsetMilliseconds);
        var resultDate = new Date(0);
        resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
        return resultDate;
    }
});
parcelRegister("8PqA1", function(module, exports) {
    $parcel$export(module.exports, "transformUserTimelineResponse", ()=>$8a23480b7911491d$export$78049913b79774a2);
    var $hz3Fg;
    const $8a23480b7911491d$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
        return {
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            nowEpoch: currentTime,
            startOffset: startOffsetMillis,
            endOffset: endOffsetMillis,
            nowOffset: utcTimeOffsetMillis,
            data: {
                ...data,
                periods: periods.map((0, (0, parcelRequire("hz3Fg")).fromMergedPeriodResponseToClusterPeriod))
            }
        };
    };
});
parcelRegister("hz3Fg", function(module, exports) {
    $parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", ()=>$0fe8fc9a353d2f1e$export$9b0bac75f135bd57);
    const $0fe8fc9a353d2f1e$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
        const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
        const clusterPeriod = {
            id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            isTrueStartTime: isTrueStartTime,
            isTrueEndTime: isTrueEndTime,
            startOffset: periodStartOffsetMillis,
            endOffset: periodEndOffsetMillis,
            overlaps: overlappingPeriods.map($0fe8fc9a353d2f1e$var$fromOverlappingPeriodResponseToOverlappingPeriod)
        };
        return clusterPeriod;
    };
    const $0fe8fc9a353d2f1e$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
        const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
        const overlappingPeriod = {
            id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            startOffset: periodStartOffsetMillis,
            endOffset: periodEndOffsetMillis,
            overlaps: overlappingRotations,
            isTrueStartTime: isTrueStartTime,
            isTrueEndTime: isTrueEndTime
        };
        return overlappingPeriod;
    };
});
parcelRegister("5Dlsd", function(module, exports) {
    $parcel$export(module.exports, "whoIsOnCallRoute", ()=>$d411783403a09613$export$26b06efd7311586b);
    var $65Ltd;
    const $d411783403a09613$export$26b06efd7311586b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL),
        path: '/jira/ops/who-is-on-call',
        exact: true
    };
});
parcelRegister("c2Cr1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("g1eRw")
    ]).then(()=>parcelRequire('eV5T9'));
});
parcelRegister("iFaFr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b86720f4c83cfbb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("l65XP")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
    });
    const $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "forgeGlobalPage"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar, null)));
    $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
    var $b86720f4c83cfbb5$export$2e2bcd8739ae039 = $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar;
});
parcelRegister("l65XP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6eoVI")
    ]).then(()=>parcelRequire('4opkK'));
});
parcelRegister("78U7j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f593a4193eb44f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("jCoeB")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
    });
    const $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalIssuesSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar, null)));
    var $4f593a4193eb44f7$export$2e2bcd8739ae039 = $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar;
});
parcelRegister("jCoeB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jkFzD").then(()=>parcelRequire('dZptX'));
});
parcelRegister("2YqLE", function(module, exports) {
    $parcel$export(module.exports, "fieldContextConfigPageResource", ()=>$2520f99c62492240$export$686a607053a18611);
    var $dIdda = parcelRequire("dIdda");
    const $2520f99c62492240$export$686a607053a18611 = (0, $dIdda.createResource)({
        type: (0, $714c31c1c770eaf3$export$4b80522d38222ad),
        getKey: ()=>'data',
        getDataLoader: ()=>(parcelRequire("gAT5i")),
        maxAge: 5000
    });
});
const $714c31c1c770eaf3$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';
parcelRegister("gAT5i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ftzT3").then(()=>parcelRequire('ei6Pl'));
});
parcelRegister("5bXwS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f8cIm").then(()=>parcelRequire('bqE5a'));
});
parcelRegister("32VdM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5CiUy").then(()=>parcelRequire('jBnrF'));
});
parcelRegister("98CQn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("erHCa").then(()=>parcelRequire('eZUti'));
});
parcelRegister("9ORLZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cBmhJ").then(()=>parcelRequire('kGkpN'));
});
parcelRegister("74XPL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2GKln").then(()=>parcelRequire('6Ue2s'));
});
parcelRegister("dMnMc", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$fe24052863a91d57$export$557c2f222778cea6);
    $parcel$export(module.exports, "default", ()=>$fe24052863a91d57$export$2e2bcd8739ae039);
    var $aZsz6 = parcelRequire("aZsz6");
    var $95bh0;
    var $556I0;
    var $79s9E;
    var $5PyNy;
    const $fe24052863a91d57$var$projectScopeDataMap = {
        routes: [
            /[&?]projectKey=(\w+)/i,
            /\/projects\/(\w+)/i,
            /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
            /\/plugins\/servlet\/project-config\/(\w+)/i,
            /\/servicedesk\/admin\/(\w+)/i,
            /\/browse\/(\w+)\/?(\?.*)?$/i
        ],
        meta: [
            'ghx-project-key',
            'projectKey',
            'ajs-project-key'
        ]
    };
    const $fe24052863a91d57$var$getProjectId = (url)=>{
        const projectIdRoutes = [
            /[&?]selectedProjectId=(\w+)/i,
            /[&?]pid=(\w+)/i,
            /[&?]projectId=(\w+)/i,
            /[&?]project\.id=(\w+)/i
        ];
        return projectIdRoutes.reduce((foundId, route)=>{
            if (foundId) return foundId;
            const match = url.match(route);
            if (match != null) {
                const [, projectId] = match;
                if (projectId) return projectId;
            }
            return null;
        }, null);
    };
    const $fe24052863a91d57$var$getProjectKey = (url, getMeta)=>{
        let projectKey = null;
        $fe24052863a91d57$var$projectScopeDataMap.meta.forEach((tagName)=>{
            const value = getMeta(tagName);
            if (value && projectKey == null) projectKey = value;
        });
        $fe24052863a91d57$var$projectScopeDataMap.routes.forEach((route)=>{
            const match = url.match(route);
            if (match != null && projectKey == null) [, projectKey] = match;
        });
        return projectKey || undefined;
    };
    const $fe24052863a91d57$export$557c2f222778cea6 = (url)=>{
        try {
            const parsed = (0, ($parcel$interopDefault($aZsz6)))(url, true);
            let boardId = parsed.query ? parsed.query.rapidView : null;
            if (boardId == null) {
                const match = url.match(/\/boards\/(\d+)/i);
                boardId = match ? match[1] : null;
            }
            return boardId;
        } catch (err) {
            return null;
        }
    };
    const $fe24052863a91d57$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, (0, parcelRequire("556I0")).default).some((regex)=>regex.test(url)) || (0, (0, parcelRequire("5PyNy")).default).some((regex)=>regex.test(url));
    const $fe24052863a91d57$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
        const isProject = ()=>{
            const routes = [
                /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
                /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
                /\/secure\/ReleaseNote.jspa.+projectId/i,
                /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
            ];
            return $fe24052863a91d57$var$isProjectSettingsConnectRoute({
                getMeta: getMeta,
                url: url
            }) || routes.some((regex)=>regex.test(url));
        };
        return projectKey || projectId && isProject();
    };
    const $fe24052863a91d57$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, (0, parcelRequire("79s9E")).default).some((route)=>url.match(route)) || $fe24052863a91d57$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        });
    const $fe24052863a91d57$var$getProjectPageType = (getMeta, url)=>{
        if ($fe24052863a91d57$var$isProjectSettingsPage({
            getMeta: getMeta,
            url: url
        })) return 'settings';
        const decorator = getMeta('decorator');
        const isSettings = getMeta('is-settings-page') === 'true';
        return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
    };
    var $fe24052863a91d57$export$2e2bcd8739ae039 = (url, getMeta)=>{
        const extractedData = {};
        const boardId = $fe24052863a91d57$export$557c2f222778cea6(url);
        if (boardId) extractedData.boardId = boardId;
        const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fe24052863a91d57$var$getProjectKey(url, getMeta);
        if (projectKey) extractedData.projectKey = projectKey;
        const projectId = $fe24052863a91d57$var$getProjectId(url);
        if (projectId) extractedData.projectId = projectId;
        const isProject = $fe24052863a91d57$var$isProjectPage({
            getMeta: getMeta,
            projectId: projectId,
            projectKey: projectKey,
            url: url
        });
        extractedData.pageType = isProject ? $fe24052863a91d57$var$getProjectPageType(getMeta, url) : undefined;
        const identifier = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            boardId: boardId,
            projectKey: projectKey,
            projectId: isProject ? projectId : null
        });
        return {
            ...extractedData,
            ...identifier
        };
    };
});
parcelRegister("556I0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2aff61bbf8b5a2cf$export$2e2bcd8739ae039);
    var $2aff61bbf8b5a2cf$export$2e2bcd8739ae039 = [
        /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
    ];
});
parcelRegister("79s9E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efe7a2022eaf0f59$export$2e2bcd8739ae039);
    var $5PyNy;
    const $efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes = [
        /\/plugins\/servlet\/project-config/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
        /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
        /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
        /\/plugins\/servlet\/project-config\/.+\/fields/i,
        /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
        /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
        /\/plugins\/servlet\/project-config\/.+\/notifications/i,
        /\/plugins\/servlet\/project-config\/.+\/permissions/i,
        /\/plugins\/servlet\/project-config\/.+\/screens/i,
        /\/plugins\/servlet\/project-config\/.+\/workflows/i,
        /\/project\/DeleteProject!default\.jspa/i,
        /\/secure\/project\/EditProject!default\.jspa/i,
        /\/secure\/AddCollector/i,
        /\/secure\/InsertCollectorHelp/i,
        /\/ViewCollector!default\.jspa\?projectKey=/i,
        /\/ViewCollectors!default\.jspa\?projectKey=/i,
        /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
        /\/InstallHipChat\.jspa\?projectKey=/i,
        /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
    ];
    var $efe7a2022eaf0f59$export$2e2bcd8739ae039 = [
        ...$efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes,
        /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
        ...(0, (0, parcelRequire("5PyNy")).default),
        /\/servicedesk\/admin\/(\w+)/i,
        /\/projects\/\w+\/settings(\/\w+)*/i
    ];
});
parcelRegister("5PyNy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d489e15712c5e17$export$2e2bcd8739ae039);
    var $5d489e15712c5e17$export$2e2bcd8739ae039 = [
        /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
        /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
    ];
});
parcelRegister("34Vv8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$827c4d80e4d41b48$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                flagService: (0, (0, parcelRequire("pa9q9")).flagService)
            });
    };
    var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;
});
parcelRegister("7OdtI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8yfIj")
    ]).then(()=>parcelRequire('7ROZZ'));
});
parcelRegister("cpdjw", function(module, exports) {
    $parcel$export(module.exports, "customFieldsDirectoryResource", ()=>$dcd1379dc352c4e2$export$3d783f106e15b01a);
    var $dIdda = parcelRequire("dIdda");
    const $dcd1379dc352c4e2$export$3d783f106e15b01a = (0, $dIdda.createResource)({
        type: (0, $d558514bbbbc39cd$export$f237bae095c310e7),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("2qCzi"))
    });
});
const $d558514bbbbc39cd$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';
parcelRegister("2qCzi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8mAnw").then(()=>parcelRequire('fFz2g'));
});
parcelRegister("kI1WL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2lIOR")
    ]).then(()=>parcelRequire('4ZT30'));
});
parcelRegister("51f7x", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", ()=>$9651cb580c71c297$export$5519b86c9ea602e1);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $1RJbT;
    var $aYyVm;
    const $9651cb580c71c297$export$5519b86c9ea602e1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1RJbT")).globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            component: (0, (0, parcelRequire("aYyVm")).LazyExplicitFieldsProjectListPage),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("aYyVm")).LazyExplicitFieldsProjectListPromise)
            ]
        }));
});
parcelRegister("1RJbT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", ()=>$e49bb87876b98a92$export$4f2c2d125c2b811a);
    var $65Ltd;
    const $e49bb87876b98a92$export$4f2c2d125c2b811a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST),
        path: '/jira/settings/issues/explicit-field-association'
    };
});
parcelRegister("aYyVm", function(module, exports) {
    $parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", ()=>$95736e1c9d4aba6e$export$7b11685155ada84d);
    $parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", ()=>$95736e1c9d4aba6e$export$e81c180c4f4833e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $95736e1c9d4aba6e$export$7b11685155ada84d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        return (0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7wmre")).then((bundle)=>bundle.ExplicitFieldAssociationProjectListApp));
    }, {
        moduleId: "./src/packages/admin-pages/explicit-field-association/project-list/src/index.tsx"
    });
    const $95736e1c9d4aba6e$export$e81c180c4f4833e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $95736e1c9d4aba6e$export$7b11685155ada84d,
            pageId: "jira-admin-pages-explicit-field-association-project-list",
            shouldShowSpinner: true
        });
});
parcelRegister("7wmre", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3r4bl")
    ]).then(()=>parcelRequire('61Yus'));
});
parcelRegister("5oFIy", function(module, exports) {
    $parcel$export(module.exports, "FireUiAnalytics", ()=>$3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
    $parcel$export(module.exports, "FireTrackAnalytics", ()=>$3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
    $parcel$export(module.exports, "FireOperationalAnalytics", ()=>$3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
    $parcel$export(module.exports, "FireScreenAnalytics", ()=>$3ea3e1dfbcd8cda6$export$2ccf161b817b43b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $8zOmE;
    class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
            if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
            if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
            const eventNameSplit = eventName ? eventName.split(' ') : [];
            const action = actionProps || eventNameSplit[1];
            const actionSubject = actionSubjectProps || eventNameSplit[0];
            if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
            const actionSubjectId = actionSubjectIdProps || componentName;
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: action
            });
            (0, (0, parcelRequire("8zOmE")).fireAnalytics)(analyticsEvent, type, {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        }
        render() {
            return null;
        }
    }
    const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, (0, parcelRequire("cb25w")).default)()($3ea3e1dfbcd8cda6$var$FireComponent);
    const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
        });
    const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
        });
    const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$12346a674644c156)
        });
    const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
            eventName: "screen viewed"
        });
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("9NiTW", function(module, exports) {
    $parcel$export(module.exports, "checkAuthentication", ()=>$ad297a7f2ce81084$export$b8dbb7d6029c5413);
    $parcel$export(module.exports, "AuthenticationCheck", ()=>$ad297a7f2ce81084$export$e9b9096e887386fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $38Y30;
    const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
    const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
        });
});
parcelRegister("6QVTY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4KqZA")
    ]).then(()=>parcelRequire('5tdjr'));
});
parcelRegister("1FeCu", function(module, exports) {
    $parcel$export(module.exports, "smartRepliesOptInStatusResources", ()=>$420bb98aaad6bbf4$export$d9a3116994d66cfc);
    $parcel$export(module.exports, "useSmartRepliesPreferencesResources", ()=>$420bb98aaad6bbf4$export$8d607fdbd07ed6ca);
    var $dJl1T;
    var $jcw0u;
    var $aHuqL;
    var $dIdda = parcelRequire("dIdda");
    const $420bb98aaad6bbf4$export$d9a3116994d66cfc = (0, $dIdda.createResource)({
        type: (0, $258f696a148ea88e$export$ea895d05049da93c),
        getKey: ()=>(0, $258f696a148ea88e$export$92a8ee31fa2d5df3),
        getData: async ()=>{
            let smartRepliesOptInStatus = null;
            try {
                smartRepliesOptInStatus = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $258f696a148ea88e$export$92a8ee31fa2d5df3));
            } catch (error) {
                if (error.statusCode !== 404) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $258f696a148ea88e$export$92a8ee31fa2d5df3), (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b), error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'smartRepliesOptInStatusResources',
                        packageName: (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b),
                        teamName: 'jira-warepil'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                smartRepliesOptInStatus: smartRepliesOptInStatus
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $420bb98aaad6bbf4$export$8d607fdbd07ed6ca = ()=>{
        const { data: data, refresh: refresh, loading: loading } = (0, $dIdda.useResource)($420bb98aaad6bbf4$export$d9a3116994d66cfc);
        return {
            isSmartRepliesPreferenceEnabled: data?.smartRepliesOptInStatus?.isEnabled ?? true,
            loading: loading,
            refreshData: refresh
        };
    };
});
const $258f696a148ea88e$export$92a8ee31fa2d5df3 = 'jira.user.smart_replies_feature.status';
const $258f696a148ea88e$export$ea895d05049da93c = 'RESOURCE_TYPE_ISSUE_SMART_REPLIES_STATUS';
const $258f696a148ea88e$export$b8b9d90f9e5bd72b = 'jiraIssueSmartRepliesPreferences';
parcelRegister("7DqiA", function(module, exports) {
    $parcel$export(module.exports, "EmbedModeContext", ()=>$208612f70b1dde3d$export$5eb07b3c7c0b0771);
    $parcel$export(module.exports, "EmbedModeProvider", ()=>$208612f70b1dde3d$export$9daaf42d62e1c430);
    var $5uXOq = parcelRequire("5uXOq");
    const $208612f70b1dde3d$export$5eb07b3c7c0b0771 = (0, $5uXOq.createContext)(false);
    const { Provider: $208612f70b1dde3d$var$Provider } = $208612f70b1dde3d$export$5eb07b3c7c0b0771;
    const $208612f70b1dde3d$var$handleEmbedLinkClick = (e)=>{
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') eventTarget.target = '_blank';
    };
    const $208612f70b1dde3d$var$DarkModeMonolithStyleOverride = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, white)"};
                    }
                `
            }
        });
    const $208612f70b1dde3d$export$9daaf42d62e1c430 = ({ children: children })=>{
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick, true);
            return ()=>{
                window.removeEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick);
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$DarkModeMonolithStyleOverride, null), (0, ($parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$Provider, {
            value: true
        }, children));
    };
});
parcelRegister("93Yeu", function(module, exports) {
    $parcel$export(module.exports, "useProjectKey", ()=>$5f0f9360597cdbd8$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useProjectContextActions", ()=>$5f0f9360597cdbd8$export$bd73624ca941f105);
    $parcel$export(module.exports, "useProjectType", ()=>$5f0f9360597cdbd8$export$6de29d851c914935);
    $parcel$export(module.exports, "useProjectContext", ()=>$5f0f9360597cdbd8$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useApplication", ()=>$5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
    $parcel$export(module.exports, "useEdition", ()=>$5f0f9360597cdbd8$export$d56c02945cf5a9e5);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$5f0f9360597cdbd8$export$524ef4f6102ed540);
    $parcel$export(module.exports, "useIsClassicProject", ()=>$5f0f9360597cdbd8$export$e2cf96f40a8867ce);
    $parcel$export(module.exports, "useProjectId", ()=>$5f0f9360597cdbd8$export$16d1475ed6c26568);
    $parcel$export(module.exports, "useProjectStatus", ()=>$5f0f9360597cdbd8$export$30f16f2782a4113b);
    $parcel$export(module.exports, "useProjectConfiguration", ()=>$5f0f9360597cdbd8$export$af19ad68b52fa1a6);
    $parcel$export(module.exports, "useProjectIssueTypes", ()=>$5f0f9360597cdbd8$export$80bef597b440cf71);
    var $5uXOq = parcelRequire("5uXOq");
    var $efvDm;
    var $ldyPw;
    var $g5X3G;
    var $9OXo1;
    var $buby4;
    var $1daUm;
    const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
    const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
        const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, (0, parcelRequire("buby4")).useProjectContextActionStore)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectContext: setProjectContext,
                mergeProjectProperty: mergeProjectProperty
            }), [
            setProjectContext,
            mergeProjectProperty
        ]);
        return [
            null,
            actions
        ];
    };
    const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
        const [projectType] = (0, (0, parcelRequire("buby4")).useProjectContextProjectTypeStore)({
            projectKey: projectKey
        });
        return projectType;
    };
    const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext;
    };
    const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
        const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
        if (projectType === undefined) {
            if (failSafely) return undefined;
            throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
        }
        return (0, (0, parcelRequire("efvDm")).getApplicationForProject)(projectType);
    };
    const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
        const { appEditions: appEditions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
        if (!application) return undefined;
        return (0, (0, parcelRequire("ldyPw")).getEdition)(application, appEditions);
    };
    const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.isSimplified || false;
    };
    const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return !projectContext?.isSimplified;
    };
    const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectId;
    };
    const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectStatus;
    };
    const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
        const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
        const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
        return (0, (0, parcelRequire("1daUm")).getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        });
    };
    const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
        const [projectName] = (0, (0, parcelRequire("buby4")).useProjectContextProjectNameStore)({
            projectKey: projectKey
        });
        return projectName;
    };
    const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
        const [issueTypes] = (0, (0, parcelRequire("buby4")).useProjectContextIssueTypesStore)({
            projectKey: projectKey
        });
        return issueTypes;
    };
});
parcelRegister("buby4", function(module, exports) {
    $parcel$export(module.exports, "useProjectContextActionStore", ()=>$42c27dedc1310bb2$export$9afb89c1fe103bbe);
    $parcel$export(module.exports, "useProjectContextStore", ()=>$42c27dedc1310bb2$export$8b09478b33186ec);
    $parcel$export(module.exports, "useProjectContextProjectTypeStore", ()=>$42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
    $parcel$export(module.exports, "useProjectContextProjectNameStore", ()=>$42c27dedc1310bb2$export$9469fde70658518);
    $parcel$export(module.exports, "useProjectContextIssueTypesStore", ()=>$42c27dedc1310bb2$export$f73e9904779f6be5);
    var $7JoAD = parcelRequire("7JoAD");
    var $aDpiK;
    const $42c27dedc1310bb2$var$initialState = {};
    const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
        name: 'project-context',
        initialState: $42c27dedc1310bb2$var$initialState,
        actions: (0, parcelRequire("aDpiK"))
    });
    const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
    const $42c27dedc1310bb2$export$8b09478b33186ec = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectContext
    });
    const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectType;
    };
    const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectType
    });
    const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectName;
    };
    const $42c27dedc1310bb2$export$9469fde70658518 = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectName
    });
    const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.issueTypes;
    };
    const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getIssueTypes
    });
});
parcelRegister("aDpiK", function(module, exports) {
    $parcel$export(module.exports, "setProjectContext", ()=>$ad16c28ce51d4ccf$export$d64151aab9ae5f09);
    $parcel$export(module.exports, "mergeProjectProperty", ()=>$ad16c28ce51d4ccf$export$78f1c6052937615f);
    const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
            setState({
                [key]: projectContext
            });
        };
    const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const currentProjectContext = currentState[key];
            const newProjectContext = {
                ...currentProjectContext,
                ...projectContext
            };
            setState({
                [key]: newProjectContext
            });
        };
});
parcelRegister("1daUm", function(module, exports) {
    $parcel$export(module.exports, "getIssueConfiguration", ()=>$7afb7a15cd46bd62$export$902f6c5cc939598a);
    var $65mz3;
    var $2vSU6;
    const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
    const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
    const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).CORE_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SOFTWARE_ISSUE,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SIMPLE_SOFTWARE_BOARD,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
                $7afb7a15cd46bd62$export$c161a774ec2e7e56
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).STANDARD_ROADMAP_ISSUE,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).BITBUCKET_ISSUE,
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).MOBILE_ISSUE,
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SERVICE_DESK,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
        if (config) switch(config.projectType){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
                return $7afb7a15cd46bd62$export$27e0678365e5dcff();
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return $7afb7a15cd46bd62$export$381ce08838c53afa();
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return $7afb7a15cd46bd62$export$db1115186532f6d5();
            default:
                return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        }
        return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    };
});
parcelRegister("65mz3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7178ba5d31d0f054$export$2e2bcd8739ae039);
    const $7178ba5d31d0f054$var$keys = {
        CONNECT_ISSUE: 'connect-issue',
        BITBUCKET_ISSUE: 'bitbucket-issue',
        CORE_ISSUE: 'core-issue',
        MOBILE_ISSUE: 'mobile-issue',
        SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
        SOFTWARE_ISSUE: 'software-issue',
        STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
        SERVICE_DESK: 'service-desk',
        EMPTY_APPLICATION_KEY: ''
    };
    var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;
});
parcelRegister("dAfqg", function(module, exports) {
    $parcel$export(module.exports, "useProjectContext", ()=>$0baaa0dcf730951a$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$0baaa0dcf730951a$export$524ef4f6102ed540);
    $parcel$export(module.exports, "ProjectContextProvider", ()=>$0baaa0dcf730951a$export$a85f6b5857d2176);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
        const { data: data, error: error, loading: loading, update: update, key: key } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache), customContext);
        const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
            update
        ]);
        return {
            data: data,
            error: error,
            loading: loading,
            updateCache: updateCache,
            key: key
        };
    };
    const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
        const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
        return data?.simplified || false;
    };
    const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
        const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
        return children(projectContext);
    };
});
parcelRegister("8ZUng", function(module, exports) {
    $parcel$export(module.exports, "issueViewRelayResource", ()=>$e05b8d0e5bf08042$export$55131006e6699c0a);
    $parcel$export(module.exports, "useIssueViewRelayRouteResource", ()=>$e05b8d0e5bf08042$export$252bdba8c8e5f066);
    var $itCwG;
    var $k3PbQ;
    var $6yLM4;
    var $ao2h1;
    var $la3vp;
    var $2Yhep;
    var $dIdda = parcelRequire("dIdda");
    var $5XgeZ;
    const $e05b8d0e5bf08042$var$getDataLoader = ()=>(parcelRequire("3fjvV"));
    const $e05b8d0e5bf08042$export$5ce473a762cc813e = (0, $dIdda.createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_AGG_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getDataLoader: $e05b8d0e5bf08042$var$getDataLoader,
        maxAge: (0, (0, parcelRequire("5XgeZ")).MIN_MAX_AGE),
        isBrowserOnly: true
    }));
    const $e05b8d0e5bf08042$export$55131006e6699c0a = (0, (0, parcelRequire("5XgeZ")).createRelayResourceDeprecated)({
        type: 'ISSUE_RELAY_DATA',
        isBrowserOnly: true,
        captureErrors: true,
        captureTraceIds: !false,
        getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
            const { match: match } = routerContext;
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            const siteAri = (0, (0, parcelRequire("itCwG")).JiraSiteAri).create({
                siteId: cloudId
            }).toString();
            const projectKey = issueKey ? (0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey) : '';
            const queryVariables = {
                cloudId: cloudId,
                issueKey: issueKey || '',
                projectKey: projectKey,
                siteAri: siteAri
            };
            return {
                parameters: (0, (0, parcelRequire("la3vp")).default),
                variables: {
                    ...queryVariables,
                    ...(0, (0, parcelRequire("6yLM4")).getMainIssueViewAggQueryVariables)()
                },
                keyVariables: {
                    ...queryVariables,
                    ...(0, (0, parcelRequire("6yLM4")).getMainIssueViewAggQueryFeatureFlagVariables)()
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $e05b8d0e5bf08042$export$252bdba8c8e5f066 = (options)=>(0, (0, parcelRequire("ao2h1")).useRelayResource)($e05b8d0e5bf08042$export$55131006e6699c0a, options);
});
parcelRegister("itCwG", function(module, exports) {
    $parcel$export(module.exports, "JiraSiteAri", ()=>$d738d1f097eb5aa6$export$6c0f81f222d09301);
    var $gQC3n;
    var $fe7YR;
    var $224I1;
    var $d738d1f097eb5aa6$var$jiraSiteAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^$"),
        resourceOwner: (0, (0, parcelRequire("gQC3n")).JiraSiteAriResourceOwner),
        resourceType: (0, (0, parcelRequire("gQC3n")).JiraSiteAriResourceType),
        resourceIdSlug: "{siteId}",
        resourceIdSegmentFormats: {
            siteId: /[a-zA-Z0-9\-]+/
        }
    };
    var $d738d1f097eb5aa6$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, (0, parcelRequire("fe7YR")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.resourceIdSegmentValues.siteId;
        }
        get siteId() {
            return this._siteId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $d738d1f097eb5aa6$var$jiraSiteAriStaticOpts.qualifier,
                platformQualifier: $d738d1f097eb5aa6$var$jiraSiteAriStaticOpts.platformQualifier,
                cloudId: void 0,
                resourceOwner: $d738d1f097eb5aa6$var$jiraSiteAriStaticOpts.resourceOwner,
                resourceType: $d738d1f097eb5aa6$var$jiraSiteAriStaticOpts.resourceType,
                resourceId: `${opts.siteId}`,
                resourceIdSegmentValues: {
                    siteId: opts.siteId
                }
            }, ariOpts = (0, (0, parcelRequire("224I1")).AriParser).fromOpts(derivedOpts, $d738d1f097eb5aa6$var$jiraSiteAriStaticOpts);
            return new _JiraSiteAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("224I1")).AriParser).fromString(maybeAri, $d738d1f097eb5aa6$var$jiraSiteAriStaticOpts);
            return new _JiraSiteAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId
            };
        }
    };
});
parcelRegister("gQC3n", function(module, exports) {
    $parcel$export(module.exports, "JiraSiteAriResourceOwner", ()=>$032a4e897fcecef5$export$b7d590981b504412);
    $parcel$export(module.exports, "JiraSiteAriResourceType", ()=>$032a4e897fcecef5$export$886165a991f21644);
    var $032a4e897fcecef5$export$b7d590981b504412 = "jira", $032a4e897fcecef5$export$886165a991f21644 = "site";
});
parcelRegister("k3PbQ", function(module, exports) {
    $parcel$export(module.exports, "extractProjectKey", ()=>$bfdd97e245e93328$export$f1a2e4721b127828);
    var $g5X3G;
    const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
});
parcelRegister("6yLM4", function(module, exports) {
    $parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", ()=>$bbb83ac7c9853fc8$export$3dd406718c5846c6);
    $parcel$export(module.exports, "getMainIssueViewAggQueryVariables", ()=>$bbb83ac7c9853fc8$export$5896c8dc13246fe2);
    var $f9Owr;
    var $6tI1D;
    const $bbb83ac7c9853fc8$export$3dd406718c5846c6 = ()=>({
            issueViewRelayCascadingSelectFlag: (0, (0, parcelRequire("f9Owr")).ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration'),
            isCompassComponentsEnabled: (0, (0, parcelRequire("f9Owr")).ff)('compass-components-in-jira-components_xw42u', false),
            giraAGGMigrationAttachmentsFlag: (0, (0, parcelRequire("f9Owr")).ff)('issue.details.gira-agg-migration-attachments_ecebe'),
            giraAGGMigrationCommentsFlag: (0, (0, parcelRequire("f9Owr")).ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9', false) || (0, (0, parcelRequire("f9Owr")).ff)('issue-jiv-14530-comments-consistency-check_x716d', false),
            jsmSentimentCustomFieldFlag: true,
            isJPDPanelEnabled: (0, (0, parcelRequire("f9Owr")).ff)('polaris.jpd-panel-in-issue-view', false),
            issueViewRelayPriorityFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-priority_ri9vi', false),
            issueViewRelayAssigneeFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-assignee-ld', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-reporter_jfzs2', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-user', false),
            issueViewRelayNumberFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-number_q0em4', false),
            issueViewRelaySprintFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-sprint_jozpu', false),
            issueViewRelayAttachmentsFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-view-attachments', false),
            issueViewRelaySingleLineTextFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text_in6w6', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text-message', false),
            issueViewRelayDateFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-date_ptj72', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false),
            issueViewRelayParentFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false),
            issueViewRelayProjectFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-project-select_w0xem', false),
            issueViewRelayDateTimeFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-date-time_eaqd2', false),
            issueViewRelayMetadataFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-metadata_d42b0', false),
            issueViewDesignsPanelFlag: (0, (0, parcelRequire("f9Owr")).ff)('make_designs_panel_in_issue_view_synchronous'),
            isJPDDeliveryLinkTypeFilteringEnabled: (0, (0, parcelRequire("f9Owr")).ff)('polaris.jpd-panel-filter-by-delivery-link-type', false),
            issueViewImproveIssueDropdownFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false),
            issueViewRelayUrlFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-url_ob8uu', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-assignee-ld', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-reporter_jfzs2', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-user', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-checkbox-select_ytl5n', false),
            issueViewRelaySummaryFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-summary_eog1v', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-original-estimate_eb4wv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text-message', false),
            issueViewRelayColorFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-color_wrbay', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-time-tracking_eefh0', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-people', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-approvers', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-votes_nsbqd', false),
            issueViewRelayHeaders: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-votes_nsbqd'),
            issueViewRelayPeopleAndApproversFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-people', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-approvers', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-components-select_prpz1', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsteamrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-team-field-next_nctbt', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-user', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-participants', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-user', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-participants', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-request-participants_itocm', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-request-participants_itocm', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-resolution_86iya', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-multi-line-text_w69oo', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-group-picker', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-group-picker', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-status_qg82c', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-resolution_86iya', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-status_qg82c', false),
            issueViewRelayTimeTrackingFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-time-tracking_eefh0', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-radio_6gqb3', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-restrictions_yudid', false)
        });
    const $bbb83ac7c9853fc8$export$5896c8dc13246fe2 = ()=>({
            ...$bbb83ac7c9853fc8$export$3dd406718c5846c6(),
            ...$bbb83ac7c9853fc8$export$afa6e4ae995b8926(),
            isPinFieldConfigurabilityEnabled: (0, (0, parcelRequire("f9Owr")).ff)('pin_field_exp_launch_darkly_flag_ef4mc')
        });
    const $bbb83ac7c9853fc8$export$afa6e4ae995b8926 = ()=>({
            commentTargetId: (0, (0, parcelRequire("f9Owr")).ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9') || (0, (0, parcelRequire("f9Owr")).ff)('issue-jiv-14530-comments-consistency-check_x716d') ? (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).COMMENTS)) || null : null
        });
});
parcelRegister("6tI1D", function(module, exports) {
    $parcel$export(module.exports, "COMMENTS", ()=>$ac458c74e4b12b29$export$4cab9dfa8fc858f4);
    $parcel$export(module.exports, "WORKLOG", ()=>$ac458c74e4b12b29$export$df36fc05622c402);
    $parcel$export(module.exports, "getAllUrlParams", ()=>$ac458c74e4b12b29$export$dca91ad250f6b082);
    $parcel$export(module.exports, "getPermalinkId", ()=>$ac458c74e4b12b29$export$bf42dbba4c31080e);
    var $dJl1T;
    const $ac458c74e4b12b29$export$b18d061fc042df1a = {
        COMMENTS: 'focusedCommentId',
        WORKLOG: 'focusedWorklogId'
    };
    const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
    const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
    const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
        let queryString = window.location.search.slice(1);
        const obj = {};
        if (queryString) {
            queryString = queryString.split('#')[0];
            const arr = queryString.split('&');
            for(let i = 0; i < arr.length; i += 1){
                const a = arr[i].split('=');
                const paramName = a[0];
                try {
                    const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                    obj[paramName] = paramValue;
                } catch (error) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
                }
            }
        }
        return obj;
    };
    const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
        if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
        const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
        return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
    };
});
parcelRegister("la3vp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d1e3365ed212162$export$2e2bcd8739ae039);
    var $asT4T;
    var $hBTVA;
    var $9OzGv;
    var $33qJ8;
    var $5pSyb;
    var $cKVMM;
    var $5mEVc;
    var $ef20f;
    var $84KW9;
    var $3wM25;
    var $ipyFC;
    var $kT0rw;
    var $d6bux;
    var $bdIYk;
    var $hjJTo;
    var $jDqgH;
    var $iwPkC;
    var $krohK;
    var $6NR1m;
    var $3E2yq;
    var $6sYK2;
    var $fmbEw;
    var $hSNvs;
    var $qPPmw;
    var $8Y9hN;
    var $4yni1;
    var $ejqaS;
    var $eXeEx;
    const $7d1e3365ed212162$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "c0dd097ebdeb03fc609217f8faa634b182560eec280554159b38b21037cb3fd0",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "issueByKey",
                            "attachments"
                        ]
                    }
                ]
            },
            "name": "mainIssueAggQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, (0, parcelRequire("d6bux")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, (0, parcelRequire("8Y9hN")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, (0, parcelRequire("9OzGv")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider": (0, (0, parcelRequire("33qJ8")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider": (0, (0, parcelRequire("kT0rw")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider": (0, (0, parcelRequire("3wM25")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider": (0, (0, parcelRequire("5pSyb")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider": (0, (0, parcelRequire("84KW9")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsteamrelayprovider": (0, (0, parcelRequire("qPPmw")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider": (0, (0, parcelRequire("hjJTo")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider": (0, (0, parcelRequire("6NR1m")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider": (0, (0, parcelRequire("ipyFC")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider": (0, (0, parcelRequire("iwPkC")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider": (0, (0, parcelRequire("bdIYk")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider": (0, (0, parcelRequire("asT4T")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider": (0, (0, parcelRequire("6sYK2")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, (0, parcelRequire("hBTVA")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider": (0, (0, parcelRequire("jDqgH")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider": (0, (0, parcelRequire("4yni1")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, (0, parcelRequire("cKVMM")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider": (0, (0, parcelRequire("eXeEx")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider": (0, (0, parcelRequire("3E2yq")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider": (0, (0, parcelRequire("ejqaS")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider": (0, (0, parcelRequire("5mEVc")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, (0, parcelRequire("ef20f")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, (0, parcelRequire("krohK")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, (0, parcelRequire("hSNvs")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider": (0, (0, parcelRequire("fmbEw")).default)
            }
        }
    };
    var $7d1e3365ed212162$export$2e2bcd8739ae039 = $7d1e3365ed212162$var$node;
});
parcelRegister("asT4T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$587bfe0115b03c48$export$2e2bcd8739ae039);
    var $co1wz;
    var $587bfe0115b03c48$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-approvers');
        }
    };
});
parcelRegister("hBTVA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$317518afb86d429d$export$2e2bcd8739ae039);
    var $co1wz;
    var $317518afb86d429d$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-assignee-ld');
        }
    };
});
parcelRegister("9OzGv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68a7d680b4f7aa31$export$2e2bcd8739ae039);
    var $co1wz;
    var $68a7d680b4f7aa31$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-checkbox-select_ytl5n');
        }
    };
});
parcelRegister("33qJ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a066af595fad6e31$export$2e2bcd8739ae039);
    var $co1wz;
    var $a066af595fad6e31$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-components-select_prpz1');
        }
    };
});
parcelRegister("5pSyb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46b71e3be8dfea7a$export$2e2bcd8739ae039);
    var $co1wz;
    var $46b71e3be8dfea7a$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-group-picker');
        }
    };
});
parcelRegister("cKVMM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7153ac791d0f4b40$export$2e2bcd8739ae039);
    var $co1wz;
    var $7153ac791d0f4b40$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-security-level_7y5uv') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-watchers_iqhn4') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-votes_nsbqd');
        }
    };
});
parcelRegister("5mEVc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dba981d8b012adb8$export$2e2bcd8739ae039);
    var $co1wz;
    var $dba981d8b012adb8$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-restrictions_yudid');
        }
    };
});
parcelRegister("ef20f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dac75eea754d44b$export$2e2bcd8739ae039);
    var $co1wz;
    var $5dac75eea754d44b$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt');
        }
    };
});
parcelRegister("84KW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78c1aa824cd21c11$export$2e2bcd8739ae039);
    var $co1wz;
    var $78c1aa824cd21c11$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-group-picker');
        }
    };
});
parcelRegister("3wM25", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4f763f7ab8915ff$export$2e2bcd8739ae039);
    var $co1wz;
    var $b4f763f7ab8915ff$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-user') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-participants') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm');
        }
    };
});
parcelRegister("ipyFC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de9ca17802c9cba7$export$2e2bcd8739ae039);
    var $co1wz;
    var $de9ca17802c9cba7$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-user') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-participants');
        }
    };
});
parcelRegister("kT0rw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cdff8c37120a188$export$2e2bcd8739ae039);
    var $co1wz;
    var $4cdff8c37120a188$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-original-estimate_eb4wv');
        }
    };
});
parcelRegister("d6bux", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d9e6f2a33f8172f$export$2e2bcd8739ae039);
    var $co1wz;
    var $4d9e6f2a33f8172f$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-parent_5p1ac');
        }
    };
});
parcelRegister("bdIYk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3216c683ee81b04$export$2e2bcd8739ae039);
    var $co1wz;
    var $d3216c683ee81b04$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-people');
        }
    };
});
parcelRegister("hjJTo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8a929bbaac9d588$export$2e2bcd8739ae039);
    var $co1wz;
    var $c8a929bbaac9d588$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-radio_6gqb3');
        }
    };
});
parcelRegister("jDqgH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$144d769a6379ff4e$export$2e2bcd8739ae039);
    var $co1wz;
    var $144d769a6379ff4e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-reporter_jfzs2');
        }
    };
});
parcelRegister("iwPkC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb870d58c524b581$export$2e2bcd8739ae039);
    var $co1wz;
    var $cb870d58c524b581$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm');
        }
    };
});
parcelRegister("krohK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ee92d752c596813$export$2e2bcd8739ae039);
    var $co1wz;
    var $7ee92d752c596813$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-resolution_86iya');
        }
    };
});
parcelRegister("6NR1m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$851058f7192cd7ee$export$2e2bcd8739ae039);
    var $co1wz;
    var $851058f7192cd7ee$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-multi-line-text_w69oo');
        }
    };
});
parcelRegister("3E2yq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$847675c0acc8db9e$export$2e2bcd8739ae039);
    var $co1wz;
    var $847675c0acc8db9e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-security-level_7y5uv');
        }
    };
});
parcelRegister("6sYK2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab91eec7ddbe8f3e$export$2e2bcd8739ae039);
    var $co1wz;
    var $ab91eec7ddbe8f3e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-single-line-text-message');
        }
    };
});
parcelRegister("fmbEw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afb9a48dda30cc33$export$2e2bcd8739ae039);
    var $co1wz;
    var $afb9a48dda30cc33$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-resolution_86iya', false) || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c', false);
        }
    };
});
parcelRegister("hSNvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efddcea96d8714d0$export$2e2bcd8739ae039);
    var $co1wz;
    var $efddcea96d8714d0$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c');
        }
    };
});
parcelRegister("qPPmw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0786657423f5409$export$2e2bcd8739ae039);
    var $co1wz;
    var $e0786657423f5409$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-team-field-next_nctbt');
        }
    };
});
parcelRegister("8Y9hN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb6d2edf34e99bba$export$2e2bcd8739ae039);
    var $co1wz;
    var $eb6d2edf34e99bba$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-time-tracking_eefh0');
        }
    };
});
parcelRegister("4yni1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5243bedb3fa46125$export$2e2bcd8739ae039);
    var $co1wz;
    var $5243bedb3fa46125$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-user');
        }
    };
});
parcelRegister("ejqaS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7323747132cbc58$export$2e2bcd8739ae039);
    var $co1wz;
    var $c7323747132cbc58$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-votes_nsbqd');
        }
    };
});
parcelRegister("eXeEx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$acfad9d58e7d968c$export$2e2bcd8739ae039);
    var $co1wz;
    var $acfad9d58e7d968c$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-watchers_iqhn4');
        }
    };
});
parcelRegister("2Yhep", function(module, exports) {
    $parcel$export(module.exports, "getIssueKey", ()=>$05d1e79edcc0dc56$export$4a030f6192bebe03);
    const $05d1e79edcc0dc56$export$4a030f6192bebe03 = (match)=>{
        const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
        return fromMatch;
    };
});
parcelRegister("5XgeZ", function(module, exports) {
    $parcel$export(module.exports, "MIN_MAX_AGE", ()=>$36d3fb93786ec5e2$export$5664a170ac5a9781);
    $parcel$export(module.exports, "withResourceEarlyData", ()=>$36d3fb93786ec5e2$export$22da5fb8c8200986);
    $parcel$export(module.exports, "createRelayResourceDeprecated", ()=>$36d3fb93786ec5e2$export$2e279339bedcd427);
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $x9xyg;
    var $co1wz;
    var $5yJb9;
    var $5a0Nh;
    var $kipqU;
    var $dIdda = parcelRequire("dIdda");
    var $5Wobd;
    const $36d3fb93786ec5e2$export$5664a170ac5a9781 = 5000;
    const $36d3fb93786ec5e2$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
        const getData = (...args)=>{
            performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
            if (!false && type in window) {
                const promise = window[type];
                delete window[type];
                getDataLoader && promise.then(getDataLoader);
                return promise;
            }
            if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
            return next && next(...args);
        };
        return {
            ...rest,
            type: type,
            getData: getData
        };
    };
    const $36d3fb93786ec5e2$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
    const $36d3fb93786ec5e2$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $dIdda.createResource)({
            type: `${$36d3fb93786ec5e2$export$c6c8c12c0f1d8e54}_${type}`,
            getKey: (routerContext, customContext)=>{
                const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, customContext);
                const variables = (0, (0, parcelRequire("co1wz")).ff)('issue-jiv-14530-comments-consistency-check_x716d') || (0, (0, parcelRequire("co1wz")).ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9') ? keyVariables || queryVariables : queryVariables;
                if (!preloadableRequest) return JSON.stringify(variables || {});
                let queryId;
                let params;
                if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                    const preloadableConcreteRequest = preloadableRequest;
                    ({ params: params } = preloadableConcreteRequest);
                    ({ id: queryId } = params);
                } else {
                    const graphQlTaggedNode = preloadableRequest;
                    const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                    params = request.params;
                    queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
                }
                return `${String(queryId)}${JSON.stringify(variables || {})}`;
            },
            getData: async (routerContext, customContext)=>{
                const measureName = `relay_resource_get_data:${type}`;
                const startMark = `relay_resource_get_data:${type}:start`;
                const endMark = `relay_resource_get_data:${type}:end`;
                (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
                const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
                const query = parameters ?? await loadParameters?.();
                const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables || {}, options));
                if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
                if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
                    (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
                });
                if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
                if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
                return queryReference;
            },
            maxAge: 0,
            isBrowserOnly: isBrowserOnly
        });
    const $36d3fb93786ec5e2$export$2e279339bedcd427 = $36d3fb93786ec5e2$var$createRelayResourceImpl;
});
parcelRegister("3fjvV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aT8lA").then(()=>parcelRequire('jj7my'));
});
parcelRegister("5CPDv", function(module, exports) {
    $parcel$export(module.exports, "issueForgeDataResource", ()=>$82acf7aa3865e452$export$e28b79684fb81535);
    var $2Yhep;
    var $dIdda = parcelRequire("dIdda");
    var $jj8CY;
    const $82acf7aa3865e452$export$e28b79684fb81535 = (0, $dIdda.createResource)({
        type: 'ISSUE_FORGE_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("jj8CY")).default)(...args),
        isBrowserOnly: true
    });
});
parcelRegister("jj8CY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a39eb6eca9b1263$export$2e2bcd8739ae039);
    var $4R6GH;
    var $hpuF5;
    var $iR3GG;
    var $2Yhep;
    var $3a39eb6eca9b1263$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const { cloudId: cloudId, activationId: activationId, locale: locale } = tenantContext;
            const data = (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? await (0, (0, parcelRequire("hpuF5")).fetchIssueForgeDataV2)(cloudId, issueKey) : await (0, (0, parcelRequire("hpuF5")).fetchIssueForgeDataV1)(cloudId, issueKey, activationId, locale);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.forge.getData',
                message: 'An error was thrown while prefetching issue Forge data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("hpuF5", function(module, exports) {
    $parcel$export(module.exports, "fetchIssueForgeDataV1", ()=>$b0a1cdd28321d25a$export$e286ab7be9b90b73);
    $parcel$export(module.exports, "fetchIssueForgeDataV2", ()=>$b0a1cdd28321d25a$export$2a07b9ab3de7be30);
    var $k2DRb;
    var $5cmSg;
    var $iVaKa;
    var $5vSAE;
    var $7kNct;
    const $b0a1cdd28321d25a$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
    const $b0a1cdd28321d25a$export$e286ab7be9b90b73 = async (cloudId, issueKey, activationId, locale)=>{
        const modulesToFetch = [
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE)
        ];
        const contextIds = [
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
        const result = await (0, (0, parcelRequire("iVaKa")).default)(cloudId, modulesToFetch, {
            issueKey: issueKey
        }, {
            include: {
                scopes: true
            }
        }, (0, (0, parcelRequire("k2DRb")).SOURCE_ISSUE_VIEW), contextIds, locale);
        const { extensions: extensions, accessNarrowedExtensions: accessNarrowedExtensions } = result;
        const mappedResult = {
            issueAction: extensions.jiraIssueAction || [],
            issueGlance: extensions.jiraIssueGlance || [],
            issueContext: extensions.jiraIssueContext || [],
            issuePanel: extensions.jiraIssuePanel || [],
            issueActivity: extensions.jiraIssueActivity || [],
            customField: extensions.jiraCustomField || [],
            customFieldType: extensions.jiraCustomFieldType || [],
            issueViewBackgroundScript: extensions.jiraIssueViewBackgroundScript || [],
            uiModifications: extensions.jiraUiModifications || [],
            blockedExtensions: {
                issueAction: accessNarrowedExtensions.jiraIssueAction || [],
                issueGlance: accessNarrowedExtensions.jiraIssueGlance || [],
                issueContext: accessNarrowedExtensions.jiraIssueContext || [],
                issuePanel: accessNarrowedExtensions.jiraIssuePanel || [],
                issueActivity: accessNarrowedExtensions.jiraIssueActivity || [],
                customField: accessNarrowedExtensions.jiraCustomField || [],
                customFieldType: accessNarrowedExtensions.jiraCustomFieldType || [],
                issueViewBackgroundScript: accessNarrowedExtensions.jiraIssueViewBackgroundScript || [],
                uiModifications: accessNarrowedExtensions.jiraUiModifications || []
            }
        };
        return (0, (0, parcelRequire("7kNct")).dedupeContextAndGlance)(mappedResult);
    };
    const $b0a1cdd28321d25a$export$2a07b9ab3de7be30 = async (cloudId, issueKey)=>{
        const extensions = await (0, (0, parcelRequire("5vSAE")).fetchModules)({
            cloudId: cloudId,
            types: [
                (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
                (0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE)
            ],
            context: {
                issueKey: issueKey
            },
            includeHidden: true,
            includeScopes: true,
            source: (0, (0, parcelRequire("k2DRb")).SOURCE_ISSUE_VIEW)
        });
        const getFilteredExtensions = (filterFn)=>({
                issueAction: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE].filter(filterFn),
                issueGlance: [],
                issueContext: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE].filter(filterFn),
                issuePanel: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE].filter(filterFn),
                issueActivity: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE].filter(filterFn),
                customField: extensions[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE].filter(filterFn),
                customFieldType: extensions[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE].filter(filterFn),
                issueViewBackgroundScript: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE].filter(filterFn),
                uiModifications: extensions[0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE].filter(filterFn)
            });
        return {
            ...getFilteredExtensions((extension)=>!(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)(extension)),
            blockedExtensions: {
                ...getFilteredExtensions((extension)=>(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)(extension))
            }
        };
    };
});
parcelRegister("5cmSg", function(module, exports) {
    $parcel$export(module.exports, "isExtensionVisible", ()=>$30771269db74e480$export$41e48b53c2cc2013);
    $parcel$export(module.exports, "isExtensionHidden", ()=>$30771269db74e480$export$3f5b3e61d567ef3);
    $parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", ()=>$30771269db74e480$export$5c38dfa9d1f96e61);
    $parcel$export(module.exports, "isExtensionHiddenByDisplayConditions", ()=>$30771269db74e480$export$3cc53b8cca25d64);
    const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
    const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
    const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
    const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';
});
parcelRegister("7kNct", function(module, exports) {
    $parcel$export(module.exports, "dedupeContextAndGlance", ()=>$4e352c29f229bbb8$export$17503ba1adfac304);
    const $4e352c29f229bbb8$export$17503ba1adfac304 = (forgeData)=>{
        const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
        const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
        return {
            ...forgeData,
            issueGlance: newGlanceItems
        };
    };
});
parcelRegister("9XjL6", function(module, exports) {
    $parcel$export(module.exports, "issueGiraDataResource", ()=>$94d751405759debc$export$37badecd288c49f4);
    var $2Yhep;
    var $dIdda = parcelRequire("dIdda");
    var $5XgeZ;
    var $1UEZY;
    const $94d751405759debc$export$37badecd288c49f4 = (0, $dIdda.createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_GIRA_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("1UEZY")).default)(...args),
        isBrowserOnly: true
    }));
});
parcelRegister("1UEZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48e4146cd1317713$export$2e2bcd8739ae039);
    var $ePyEO;
    var $iR3GG;
    var $2Yhep;
    var $48e4146cd1317713$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const { baseUrl: baseUrl } = tenantContext;
            const data = await (0, (0, parcelRequire("ePyEO")).default)(baseUrl, issueKey);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.gira.getData',
                message: 'An error was thrown while prefetching issue gira data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("ePyEO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef212fbaef309294$export$2e2bcd8739ae039);
    var $dGrdR;
    var $k3PbQ;
    var $fqpdr;
    var $9kbEN;
    var $iBOrg;
    const $ef212fbaef309294$var$ISSUE_GIRA_DATA = 'issue-gira-data';
    const $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: $ef212fbaef309294$var$ISSUE_GIRA_DATA
    });
    var $ef212fbaef309294$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
        const projectKey = (0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey);
        const variables = {
            issueKey: issueKey,
            projectKey: projectKey
        };
        const payload = {
            query: (0, (0, parcelRequire("fqpdr")).buildIssueQuery)(),
            variables: variables,
            operationName: (0, (0, parcelRequire("fqpdr")).ISSUE_VIEW_INTERACTIVE_QUERY)
        };
        if ((0, (0, parcelRequire("9kbEN")).isInSample)()) $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.start();
        try {
            const response = await (0, (0, parcelRequire("iBOrg")).getClient)(baseUrl).query(payload);
            const issueId = response.data?.viewIssue?.issueId;
            $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.stop({
                customData: issueId ? {
                    issueId: issueId
                } : null
            });
            return response;
        } catch (error) {
            $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.cancel();
            throw error;
        }
    };
});
parcelRegister("fqpdr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", ()=>$3789cf83eed10ddd$export$1780a132c0453fee);
    $parcel$export(module.exports, "getGiraUrl", ()=>$3789cf83eed10ddd$export$aefb19023b2eda55);
    $parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", ()=>$3789cf83eed10ddd$export$79eba9bf6dc9960d);
    $parcel$export(module.exports, "buildIssueQuery", ()=>$3789cf83eed10ddd$export$222ae9aca08830f0);
    $parcel$export(module.exports, "getGiraRequestOptions", ()=>$3789cf83eed10ddd$export$e1542dc7ff749de8);
    var $f9Owr;
    var $96nmc;
    var $92ECu;
    var $eggqf;
    var $EJMEI;
    var $8TkIN;
    var $e2Vt6;
    var $6QL4r;
    var $5Pqa3;
    var $b1RJj;
    var $1HCMp;
    var $8JI9I;
    var $kNriQ;
    var $cRP2d;
    const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
    const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
    const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, (0, parcelRequire("96nmc")).appendOperationQuery)(operation)}`;
    const $3789cf83eed10ddd$var$viewIssueQuery = ()=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${(0, (0, parcelRequire("EJMEI")).default)({
            maxResults: (0, (0, parcelRequire("92ECu")).NUM_INITIAL_COMMENTS_TO_LOAD),
            startAt: 0,
            orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
            commentAmount: Math.floor((0, (0, parcelRequire("92ECu")).NUM_INITIAL_COMMENTS_TO_LOAD)),
            hydrateData: false
        })}
        ${(0, (0, parcelRequire("cRP2d")).default)({
            startAt: 0,
            worklogAmount: Math.floor((0, (0, parcelRequire("92ECu")).NUM_INITIAL_WORKLOGS_TO_LOAD))
        })}
        ${(0, (0, parcelRequire("e2Vt6")).getEcosystemQuery)()}
        ${(0, (0, parcelRequire("8TkIN")).getContentPanelsQuery)()}
        ${(0, (0, parcelRequire("e2Vt6")).getLegacyRightWebPanelsQuery)()}
        ${(0, (0, parcelRequire("f9Owr")).ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'totalAttachmentsCount' : (0, (0, parcelRequire("eggqf")).default)()}
        ${(0, (0, parcelRequire("5Pqa3")).getContainersByTypeQuery)()}
        ${(0, (0, parcelRequire("kNriQ")).getRemoteLinksQuery)()}
    }
`;
    const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
    const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
    const $3789cf83eed10ddd$export$222ae9aca08830f0 = ()=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, (0, parcelRequire("b1RJj")).default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery()}
        ${(0, (0, parcelRequire("6QL4r")).getJiraSettingsQuery)()}
        ${(0, (0, parcelRequire("1HCMp")).default)()}
        ${(0, (0, parcelRequire("8JI9I")).default)()}
    }

`;
    const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey)=>{
        const payload = {
            operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
            query: $3789cf83eed10ddd$export$222ae9aca08830f0(),
            variables: {
                issueKey: issueKey,
                projectKey: projectKey
            }
        };
        return {
            method: 'POST',
            body: JSON.stringify(payload)
        };
    };
});
parcelRegister("96nmc", function(module, exports) {
    $parcel$export(module.exports, "appendOperationQuery", ()=>$8119dcf59ebfcad5$export$69694c3add0f6058);
    const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';
});
parcelRegister("92ECu", function(module, exports) {
    $parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", ()=>$9387aa2a419a55f9$export$c46d621c29194aa4);
    $parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", ()=>$9387aa2a419a55f9$export$b2e398ce246f55b3);
    $parcel$export(module.exports, "gqlTagGira", ()=>$9387aa2a419a55f9$export$aeae6fc40846cf9f);
    const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
    const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
    const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
    const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
    const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
        let result = '';
        substitutions.forEach((key, i)=>{
            result += literals[i];
            result += key.toString();
        });
        result += literals[literals.length - 1];
        return result;
    };
});
parcelRegister("eggqf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50ccccb1a3d66c60$export$2e2bcd8739ae039);
    var $50ccccb1a3d66c60$export$2e2bcd8739ae039 = ()=>`attachments(orderDirection: DESC, orderField: CREATED, maxResults: 12) {
        nodes {
          id
          filename
          mimetype
          mediaApiFileId
          createdDate
          filesize
          parentName
          author {
              accountId
          }
          parentId
          hasRestrictedParent
        }
        totalCount
        deletableCount
      }
`;
});
parcelRegister("EJMEI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01ae9b8d951a6992$export$2e2bcd8739ae039);
    var $co1wz;
    var $6tI1D;
    var $9F91P;
    var $01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, hydrateData: hydrateData = true })=>{
        const commentPermalinkId = (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).COMMENTS));
        const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
        const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
        const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
        const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
        const commentSourceParameter = (0, (0, parcelRequire("co1wz")).ff)('jira_threaded_comments_prereq_631yd') ? ', requestSource: "web"' : '';
        const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
        if ((0, (0, parcelRequire("co1wz")).ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9') && !(0, (0, parcelRequire("co1wz")).ff)('issue-jiv-14530-comments-consistency-check_x716d') && !hydrateData) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
            startIndex
        }
    `;
        return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}${commentSourceParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
				${(0, (0, parcelRequire("co1wz")).ff)('jira_threaded_comments_prereq_631yd') ? 'isDeleted' : ''}
                ${(0, (0, parcelRequire("co1wz")).ff)('jira_threaded_comments_prereq_631yd') ? 'parentId' : ''}
                ${(0, (0, parcelRequire("co1wz")).ff)('jira_threaded_comments_prereq_631yd') ? 'replies' : ''}
                ${(0, (0, parcelRequire("9F91P")).isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''}
                ${(0, (0, parcelRequire("9F91P")).isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
            }
            totalCount
            startIndex
			${(0, (0, parcelRequire("co1wz")).ff)('jira_threaded_comments_prereq_631yd') ? 'rootCommentsCount' : ''}
        }
    `;
    };
});
parcelRegister("9F91P", function(module, exports) {
    $parcel$export(module.exports, "isJsmTimelineEnabled", ()=>$38d603c6864a4cb1$export$575e1bf822db15b5);
    var $f9Owr;
    const $38d603c6864a4cb1$export$575e1bf822db15b5 = ()=>(0, (0, parcelRequire("f9Owr")).ff)('jsm-timelines-phase-2_70gja', false);
});
parcelRegister("8TkIN", function(module, exports) {
    $parcel$export(module.exports, "getContentPanelsQuery", ()=>$09fdc8c72c341092$export$e6f14eac549b679d);
    const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
    const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
    const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
    const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;
});
parcelRegister("e2Vt6", function(module, exports) {
    $parcel$export(module.exports, "getEcosystemQuery", ()=>$1771eed42c62eeca$export$edefef8c65e08bd2);
    $parcel$export(module.exports, "getLegacyRightWebPanelsQuery", ()=>$1771eed42c62eeca$export$92c9a3dc7076af51);
    var $f9Owr;
    const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
    const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      ${!(0, (0, parcelRequire("f9Owr")).ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? `
      operations {
        name
        url: href
        icon {
          url
        }
        tooltip
        styleClass
      }` : ''}
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }    
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
    const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;
});
parcelRegister("6QL4r", function(module, exports) {
    $parcel$export(module.exports, "getJiraSettingsQuery", ()=>$10470e592ba8e782$export$191f50c0f86b85ec);
    const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
    const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
    const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;
});
parcelRegister("5Pqa3", function(module, exports) {
    $parcel$export(module.exports, "getContainersByTypeQuery", ()=>$85e2f5a62f1697d1$export$63131b2831854cc);
    const $85e2f5a62f1697d1$export$63131b2831854cc = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
});
parcelRegister("b1RJj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42429f0fa15c54ae$export$2e2bcd8739ae039);
    var $9wuCE;
    var $42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, (0, parcelRequire("9wuCE")).getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;
});
parcelRegister("9wuCE", function(module, exports) {
    $parcel$export(module.exports, "getMaxTokenLength", ()=>$ebb491dcc11e8362$export$e40f2acaf1a50b00);
    const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
    const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;
});
parcelRegister("1HCMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ea17df757c74c46$export$2e2bcd8739ae039);
    var $co1wz;
    const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
            'ADMINISTER_PROJECTS',
            'ASSIGN_ISSUES',
            'EDIT_ISSUES',
            'SCHEDULE_ISSUES',
            'ADD_COMMENTS',
            'DELETE_ALL_COMMENTS',
            'DELETE_OWN_COMMENTS',
            'EDIT_ALL_COMMENTS',
            'EDIT_OWN_COMMENTS',
            'CREATE_ISSUES',
            'DELETE_ISSUES',
            'MOVE_ISSUES',
            'MODIFY_REPORTER',
            'CREATE_ATTACHMENTS',
            'DELETE_ALL_ATTACHMENTS',
            'DELETE_OWN_ATTACHMENTS',
            'WORK_ON_ISSUES',
            'ASSIGNABLE_USER',
            'LINK_ISSUES',
            'VIEW_VOTERS_AND_WATCHERS',
            'MANAGE_WATCHERS',
            'EDIT_ALL_WORKLOGS',
            'EDIT_OWN_WORKLOGS',
            'DELETE_ALL_WORKLOGS',
            'DELETE_OWN_WORKLOGS',
            'VIEW_DEV_TOOLS',
            'SERVICEDESK_AGENT',
            'RESOLVE_ISSUES',
            'CLONE_ISSUE'
        ];
    const $0ea17df757c74c46$export$f5ff20e9116b53bc = ()=>{
        const permissionKeysForArchival = [
            'ARCHIVE_ISSUES',
            'UNARCHIVE_ISSUES'
        ];
        const permissionKeys = $0ea17df757c74c46$export$9fc40cb6f3529ef();
        if (!(0, (0, parcelRequire("co1wz")).ff)('issue-unarchival_wdpb9')) return permissionKeys;
        return [
            ...permissionKeys,
            ...permissionKeysForArchival
        ];
    };
    var $0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$f5ff20e9116b53bc().join('","')}"]) {
        key
        havePermission
    }
`;
});
parcelRegister("8JI9I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2232e63ddd04bbb1$export$2e2bcd8739ae039);
    var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;
});
parcelRegister("kNriQ", function(module, exports) {
    $parcel$export(module.exports, "getRemoteLinksQuery", ()=>$e19ca26272d1dd4d$export$6bbc6b72b0b57f25);
    const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }            
`;
});
parcelRegister("cRP2d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$354b7c85b873ab44$export$2e2bcd8739ae039);
    var $6tI1D;
    var $354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount })=>{
        const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
        const worklogPermalinkId = (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).WORKLOG));
        if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
        const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
        const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
        return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
    };
});
parcelRegister("9kbEN", function(module, exports) {
    $parcel$export(module.exports, "isInSample", ()=>$b9c2013a86366ec0$export$a994c91d08ead5ff);
    const $b9c2013a86366ec0$export$a994c91d08ead5ff = (sampleRate = (0, $670519621927ccc4$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;
});
const $670519621927ccc4$export$9fc1f2d681a9e609 = 100;
parcelRegister("iBOrg", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$3d6ab2890da8f9df$export$6bb76d6eba7e258c);
    var $7f4tk;
    var $fqpdr;
    const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
            query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("fqpdr")).getGiraUrl)(baseUrl, operationName), {
                    method: 'POST',
                    body: JSON.stringify({
                        query: query,
                        variables: variables,
                        operationName: operationName
                    }),
                    signal: signal
                })
        });
    let $3d6ab2890da8f9df$var$client;
    const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
        if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
        return $3d6ab2890da8f9df$var$client;
    };
});
parcelRegister("lCj8l", function(module, exports) {
    $parcel$export(module.exports, "issueGiraNonCriticalDataResource", ()=>$74422abbcf73f635$export$2d81f7bddf10f49e);
    var $2Yhep;
    var $dIdda = parcelRequire("dIdda");
    var $5XgeZ;
    var $cvOMs;
    const $74422abbcf73f635$export$2d81f7bddf10f49e = (0, $dIdda.createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("cvOMs")).default)(...args),
        isBrowserOnly: true
    }));
});
parcelRegister("cvOMs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07364a38d1410c3f$export$2e2bcd8739ae039);
    var $1O6Hj;
    var $iR3GG;
    var $2Yhep;
    var $07364a38d1410c3f$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const data = await (0, (0, parcelRequire("1O6Hj")).fetchIssueGiraNonCriticalData)(issueKey);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.gira-non-critical.getData',
                message: 'An error was thrown while prefetching issue gira non critical data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("1O6Hj", function(module, exports) {
    $parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", ()=>$6bf108f87308d37b$export$f382deefb24f95ae);
    $parcel$export(module.exports, "fetchIssueGiraNonCriticalData", ()=>$6bf108f87308d37b$export$58a9221a6c5306db);
    var $jJZqs;
    var $c6dax;
    var $gXz4p;
    var $iBOrg;
    const $6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
        const errorMessageItem = errorMessage != null ? {
            errorMessage: errorMessage
        } : {};
        const traceIdItem = traceId != null ? {
            traceId: traceId
        } : {};
        return {
            experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
            wasExperienceSuccesful: wasExperienceSuccessful,
            analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
            additionalAttributes: {
                method: 'GET',
                ...errorMessageItem,
                ...traceIdItem
            },
            application: null,
            edition: null
        };
    };
    const $6bf108f87308d37b$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
        (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)($6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription({
            wasExperienceSuccessful: wasExperienceSuccessful,
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.message != null ? {
                errorMessage: error.message
            } : {},
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.traceId != null ? {
                traceId: error.traceId
            } : {},
            isEarlyFetch: isEarlyFetch
        }));
    };
    const $6bf108f87308d37b$export$58a9221a6c5306db = async (issueKey)=>{
        const variables = {
            issueKey: issueKey
        };
        const payload = {
            query: (0, (0, parcelRequire("c6dax")).buildNonCriticalGiraQuery)(),
            variables: variables,
            operationName: (0, (0, parcelRequire("c6dax")).ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
        };
        try {
            const response = await (0, (0, parcelRequire("iBOrg")).getClient)('').query(payload);
            $6bf108f87308d37b$export$f382deefb24f95ae({
                wasExperienceSuccessful: true,
                isEarlyFetch: false
            });
            return response;
        } catch (error) {
            $6bf108f87308d37b$export$f382deefb24f95ae({
                wasExperienceSuccessful: false,
                isEarlyFetch: false,
                error: error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : undefined
            });
            throw error;
        }
    };
});
parcelRegister("c6dax", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", ()=>$b74efd74d6a135cc$export$857f1602ca5b9d99);
    $parcel$export(module.exports, "buildNonCriticalGiraQuery", ()=>$b74efd74d6a135cc$export$df3c3aa9d6d3f431);
    $parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", ()=>$b74efd74d6a135cc$export$555194bfc9159fa3);
    var $f9Owr;
    var $jzVvW;
    const $b74efd74d6a135cc$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
    const $b74efd74d6a135cc$export$df3c3aa9d6d3f431 = ()=>`
query ${$b74efd74d6a135cc$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, (0, parcelRequire("jzVvW")).getEcosystemQuery)()}
        ${(0, (0, parcelRequire("f9Owr")).ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'deletableAttachmentsCount' : ''}
    }
}`;
    const $b74efd74d6a135cc$export$555194bfc9159fa3 = (issueKey)=>({
            method: 'POST',
            body: JSON.stringify({
                operationName: $b74efd74d6a135cc$export$857f1602ca5b9d99,
                query: $b74efd74d6a135cc$export$df3c3aa9d6d3f431(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
});
parcelRegister("jzVvW", function(module, exports) {
    $parcel$export(module.exports, "getEcosystemQuery", ()=>$8b485783ca3ced28$export$edefef8c65e08bd2);
    const $8b485783ca3ced28$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }
  }
`;
});
parcelRegister("gXz4p", function(module, exports) {
    $parcel$export(module.exports, "sendExperienceAnalytics", ()=>$b28eb6b892a8c2f7$export$4a95ada1b8228562);
    var $1UikQ = parcelRequire("1UikQ");
    var $gSA3s;
    var $hh0bW;
    var $j8DrX;
    const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
        const additionalContext = {};
        const shard = (0, (0, parcelRequire("j8DrX")).default)('ajs-shard');
        const region = (0, (0, parcelRequire("j8DrX")).default)('ajs-region');
        Object.assign(additionalContext, {
            shard: shard,
            region: region
        });
        const enabledFeatureFlags = Object.fromEntries([
            ...(0, (0, parcelRequire("gSA3s")).allFeatureFlagsAccessed)
        ].filter(([, value])=>value));
        Object.assign(additionalContext, {
            enabledFeatureFlags: enabledFeatureFlags
        });
        const synthetics = {
            additionalAttributes: {
                synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
                ...additionalContext
            }
        };
        (0, ($parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
        (0, (0, parcelRequire("hh0bW")).default)(experienceDescription);
    }
});
parcelRegister("hh0bW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8a1e19e7613048$export$2e2bcd8739ae039);
    var $fjcgS;
    var $efvDm;
    var $ldyPw;
    const $6c8a1e19e7613048$var$transformApplication = (application)=>{
        switch(application){
            case 0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE:
                return 'jira-software';
            case 0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, (0, parcelRequire("efvDm")).JIRA_CORE:
                return 'jira-core';
            case 0, (0, parcelRequire("efvDm")).JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $6c8a1e19e7613048$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, (0, parcelRequire("ldyPw")).FREE_EDITION:
                return 'jedi';
            case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                return 'standard';
            case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                return 'premium';
            case 0, (0, parcelRequire("ldyPw")).UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $6c8a1e19e7613048$var$transformAction = (action, wasExperienceSuccesful)=>{
        if (action !== undefined) return action;
        return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
    };
    const $6c8a1e19e7613048$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: $6c8a1e19e7613048$var$transformAction(action, wasExperienceSuccesful),
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                ...location ? {
                    reason: location
                } : {},
                ...field ? {
                    field: field
                } : {},
                ...typeof hasEdit === 'boolean' ? {
                    hasEdit: hasEdit
                } : {},
                analyticsSource: analyticsSource,
                application: $6c8a1e19e7613048$var$transformApplication(application),
                edition: $6c8a1e19e7613048$var$transformEdition(edition)
            }
        });
    var $6c8a1e19e7613048$export$2e2bcd8739ae039 = (experienceDescription)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const event = $6c8a1e19e7613048$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
});
parcelRegister("1aAOt", function(module, exports) {
    $parcel$export(module.exports, "fetchFeatureDataResource", ()=>$3095ecb31c5b9ef2$export$ec991c565cf31550);
    $parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", ()=>$3095ecb31c5b9ef2$export$d08a9fee651d30b2);
    var $co1wz;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $3095ecb31c5b9ef2$var$getDataLoader = ()=>(parcelRequire("hPMz6"));
    const $3095ecb31c5b9ef2$export$ec991c565cf31550 = (0, $dIdda.createResource)({
        type: (0, $2e493fb3532188a0$export$23978b67a6b2068f),
        getKey: ()=>'state',
        getDataLoader: $3095ecb31c5b9ef2$var$getDataLoader,
        maxAge: 1800000
    });
    const $3095ecb31c5b9ef2$export$d08a9fee651d30b2 = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu'), $3095ecb31c5b9ef2$export$ec991c565cf31550)
        ];
});
const $2e493fb3532188a0$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';
parcelRegister("hPMz6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fsHbN").then(()=>parcelRequire('8OVUQ'));
});
parcelRegister("eTWbh", function(module, exports) {
    $parcel$export(module.exports, "browseIssueRoute", ()=>$0b3b47786149d38f$export$2c9c7e50a88e588b);
    $parcel$export(module.exports, "browseIssueEmbedRoute", ()=>$0b3b47786149d38f$export$240aeec71c480594);
    var $65Ltd;
    var $e2ctp;
    const $0b3b47786149d38f$export$2c9c7e50a88e588b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
        query: [
            'filter?!=(.*)',
            'jql?!=(.*)'
        ],
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
    };
    const $0b3b47786149d38f$export$240aeec71c480594 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED),
        path: '/browse/:issueKey(\\w+-\\d+)/embed',
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
    };
});
parcelRegister("c65JB", function(module, exports) {
    $parcel$export(module.exports, "IssueViewSkeleton", ()=>$10d0ed34bb3215dd$export$49addbcdecb6e6ff);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iMqhh;
    var $gnABE;
    var $gERis = parcelRequire("gERis");
    const $10d0ed34bb3215dd$var$fullpageStyles = null;
    const $10d0ed34bb3215dd$var$modalStyles = null;
    const $10d0ed34bb3215dd$var$customSpacingStyles = null;
    const $10d0ed34bb3215dd$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
        const customCss = [
            $10d0ed34bb3215dd$var$customSpacingStyles,
            isEmbedView !== true && isModalView !== true ? $10d0ed34bb3215dd$var$fullpageStyles : null,
            isModalView === true ? $10d0ed34bb3215dd$var$modalStyles : null
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iMqhh")).CompactModeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gERis))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
                isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
                isModalView === true && "_19pk10j7"
            ])
        }));
    };
});
parcelRegister("iMqhh", function(module, exports) {
    $parcel$export(module.exports, "CompactModeContext", ()=>$db79d17d45755de5$export$37eeac5cc5245b18);
    $parcel$export(module.exports, "CompactModeProvider", ()=>$db79d17d45755de5$export$10cf42790e523b8e);
    $parcel$export(module.exports, "CompactModeConsumer", ()=>$db79d17d45755de5$export$20feb77b5b617e44);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8kj45;
    var $dIdda = parcelRequire("dIdda");
    var $hhMVP;
    const $db79d17d45755de5$export$37eeac5cc5245b18 = (0, $5uXOq.createContext)(false);
    const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
    const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
    const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
    function $db79d17d45755de5$var$useRouteKey() {
        const [routeState] = (0, $dIdda.useRouter)();
        const { match: { path: path, params: params } } = routeState;
        const hasIssueKey = params?.issueKey !== undefined;
        return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
    }
    const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
        const key = $db79d17d45755de5$var$useRouteKey();
        (0, (0, parcelRequire("hhMVP")).invalidateCacheIfRouteChanged)(key);
        let defaultState = (0, (0, parcelRequire("hhMVP")).getCachedIsCompactValue)(key);
        if (defaultState === undefined) {
            defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
            (0, (0, parcelRequire("hhMVP")).setCachedIsCompactValue)(defaultState, key);
        }
        const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8kj45")).ContainerQueryObserver), {
            query: $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
            onChange: (state)=>{
                (0, (0, parcelRequire("hhMVP")).setCachedIsCompactValue)(state, key);
                setIsCompact(state);
            },
            defaultState: defaultState
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
            value: isCompact
        }, children));
    };
    const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
    const $db79d17d45755de5$var$StyledWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;
parcelRegister("8kj45", function(module, exports) {
    $parcel$export(module.exports, "ContainerQueryObserver", ()=>$ed10e3c030ea0408$export$e9574287678b8467);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ed10e3c030ea0408$var$QueryContext = (0, $5uXOq.createContext)(undefined);
    let $ed10e3c030ea0408$var$currentIdSeed = 0;
    function $ed10e3c030ea0408$var$generateAttributeValue() {
        return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
    }
    function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
        const [active, setActive] = (0, $5uXOq.useState)(defaultState);
        const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
            onChange?.(isContainerQueryActive);
            setActive(isContainerQueryActive);
        }, [
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
            value: active
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
            query: query,
            notifyIntersectionStatusChanged: handleQueryStatusChange
        }), children);
    }
    function $ed10e3c030ea0408$export$b66a67697973e01() {
        const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
        if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
        return currentState;
    }
    function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
        const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
        const spanRef = (0, $5uXOq.useRef)(null);
        const containerRef = (0, $5uXOq.useRef)(null);
        const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
        (0, $5uXOq.useLayoutEffect)(()=>{
            const queryStatusChangedCallback = (entries)=>{
                if (!containerRef.current || containerRef.current.clientWidth === 0) return;
                if (entries.length > 0) {
                    const isContainerQueryActive = entries[0].isIntersecting;
                    if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
                }
            };
            const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
            const spanElement = spanRef.current;
            spanElement && intersectionObserver.observe(spanElement);
            return ()=>{
                spanElement && intersectionObserver.unobserve(spanElement);
                intersectionObserver.disconnect();
            };
        }, [
            currentState,
            handleChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
            ref: containerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            type: "text/css"
        }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ref: spanRef,
            "data-container-query-indicator-id": attributeValue
        }));
    }
    const $ed10e3c030ea0408$var$ContainerToBeQueried = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hhMVP", function(module, exports) {
    $parcel$export(module.exports, "getCachedIsCompactValue", ()=>$cd61c7d28b4f2500$export$c47621d55d10906c);
    $parcel$export(module.exports, "setCachedIsCompactValue", ()=>$cd61c7d28b4f2500$export$568b2dd75c2027b4);
    $parcel$export(module.exports, "invalidateCacheIfRouteChanged", ()=>$cd61c7d28b4f2500$export$a81477a3594bcaab);
    const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
    let $cd61c7d28b4f2500$var$previousRouteKey;
    function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
        return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
    }
    function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
        $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
    }
    function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
        if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
            $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
            delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
        }
    }
});
parcelRegister("gERis", function(module, exports) {
    module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();
});
parcelRegister("kumTR", function(module, exports) {
    $parcel$export(module.exports, "projectIssueNavigatorRoute", ()=>$3108d9738994971d$export$126b16ec65343bf);
    $parcel$export(module.exports, "softwareIssueNavigatorRoute", ()=>$3108d9738994971d$export$ccfb6c4a189316bc);
    $parcel$export(module.exports, "projectIssueNavigatorClassicRoute", ()=>$3108d9738994971d$export$fa71d22b1c44463b);
    $parcel$export(module.exports, "servicedeskIssuesRoute", ()=>$3108d9738994971d$export$4be84a96ac761ab0);
    $parcel$export(module.exports, "projectIssueNavigatorCoreRoute", ()=>$3108d9738994971d$export$e961cccd2405cdd0);
    $parcel$export(module.exports, "globalIssueNavigatorRoute", ()=>$3108d9738994971d$export$f4c8e8bc55cd2008);
    $parcel$export(module.exports, "globalIssueNavigator1Route", ()=>$3108d9738994971d$export$2dfbbe89ed354013);
    $parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", ()=>$3108d9738994971d$export$34695dccebecc6bc);
    var $65Ltd;
    const $3108d9738994971d$export$126b16ec65343bf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        path: '/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$ccfb6c4a189316bc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        path: '/jira/software/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$fa71d22b1c44463b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$4be84a96ac761ab0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES),
        path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$e961cccd2405cdd0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        path: '/jira/core/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$f4c8e8bc55cd2008 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        path: '/issues/:issueKey?'
    };
    const $3108d9738994971d$export$2dfbbe89ed354013 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        path: '/jira/issues/:issueKey?'
    };
    const $3108d9738994971d$export$34695dccebecc6bc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
        path: '/browse/:issueKey?',
        query: [
            'jql|filter'
        ]
    };
});
parcelRegister("1gXMV", function(module, exports) {
    $parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", ()=>$c87e28c0f4513050$export$51681996374b2585);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $3hk93 = parcelRequire("3hk93");
    const $c87e28c0f4513050$var$customCssStyles = null;
    const $c87e28c0f4513050$export$51681996374b2585 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($3hk93))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1zwfg _slt8zwfg _1od57vkz"
            ])
        });
});
parcelRegister("3hk93", function(module, exports) {
    module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();
});
parcelRegister("lHYIV", function(module, exports) {
    $parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", ()=>$8afa09f5da2bc6b1$export$112138f5f732a994);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $hDeVo = parcelRequire("hDeVo");
    const $8afa09f5da2bc6b1$var$customCssStyles = null;
    const $8afa09f5da2bc6b1$export$112138f5f732a994 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($hDeVo))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1zwfg _slt8zwfg _1od57vkz"
            ])
        });
});
parcelRegister("hDeVo", function(module, exports) {
    module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();
});
parcelRegister("96w9D", function(module, exports) {
    $parcel$export(module.exports, "sidebarFiltersGlobalResource", ()=>$4afb52221e3a3f09$export$7e0b804085f0470d);
    var $ao2h1;
    var $gBXKh;
    var $6YG83;
    const $4afb52221e3a3f09$export$7e0b804085f0470d = (0, (0, parcelRequire("6YG83")).withGiraAggAnonSsrFix)((0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("gBXKh")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("gBXKh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0f1ab872360a786$export$2e2bcd8739ae039);
    const $a0f1ab872360a786$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = [
            v1
        ], v3 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v4 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v5 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2,
                                    "kind": "FragmentSpread",
                                    "name": "starredFiltersList_navigationAppsSidebarCommon"
                                },
                                {
                                    "args": v2,
                                    "kind": "FragmentSpread",
                                    "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "favouriteFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v3,
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isJiraFilter"
                                                    },
                                                    v4,
                                                    v5,
                                                    v6,
                                                    v7,
                                                    v8
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "isFavourite",
                                        "value": false
                                    }
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilter",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v8,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v4,
                                                            v5,
                                                            v6,
                                                            v7
                                                        ],
                                                        "type": "JiraFilter",
                                                        "abstractKey": "__isJiraFilter"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88",
                "metadata": {},
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $a0f1ab872360a786$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
    var $a0f1ab872360a786$export$2e2bcd8739ae039 = $a0f1ab872360a786$var$node;
});
parcelRegister("6YG83", function(module, exports) {
    $parcel$export(module.exports, "withGiraAggAnonSsrFix", ()=>$895edd6ed19f0aa8$export$f4b29e78f4c0a526);
    const $895edd6ed19f0aa8$export$f4b29e78f4c0a526 = (resource)=>{
        if (!resource || !resource.getData) return resource;
        const originalGetData = resource.getData;
        resource.getData = (routerContext, customContext)=>{
            if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
            return originalGetData(routerContext, customContext);
        };
        return resource;
    };
});
parcelRegister("8Wi6S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c9fa7b304f828b3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "AsyncSidebarFiltersGlobal", ()=>$7c9fa7b304f828b3$export$1af88ebe65f50e73);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $7c9fa7b304f828b3$var$LazySidebarFiltersLegacy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("d3UTn")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
    });
    const $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersLegacy, null)));
    var $7c9fa7b304f828b3$export$2e2bcd8739ae039 = $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy;
    const $7c9fa7b304f828b3$var$LazySidebarFiltersGlobal = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("8GB8S")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle.SidebarFiltersGlobal;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
    });
    const $7c9fa7b304f828b3$export$1af88ebe65f50e73 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "filters-global"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersGlobal, null)));
});
parcelRegister("d3UTn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iTs3w")
    ]).then(()=>parcelRequire('7T8w9'));
});
parcelRegister("8GB8S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("2dpYI")
    ]).then(()=>parcelRequire('hcPI1'));
});
parcelRegister("8CVvd", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav3", ()=>$5acda4891dbe9afe$export$23a7d978e17f1720);
    var $3HwlS;
    const $5acda4891dbe9afe$export$23a7d978e17f1720 = ()=>!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
});
parcelRegister("bATyw", function(module, exports) {
    $parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", ()=>$a818348721ae6866$export$3f6390b4131d761b);
    var $dIdda = parcelRequire("dIdda");
    const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("b9fyS"));
    const $a818348721ae6866$export$3f6390b4131d761b = (0, $dIdda.createResource)({
        type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
        getKey: ()=>'ninGlobalScopeEnrolment',
        getDataLoader: $a818348721ae6866$var$getDataLoader
    });
});
parcelRegister("b9fyS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f9qz1").then(()=>parcelRequire('dIecw'));
});
parcelRegister("89kiv", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorRelayResource", ()=>$93f22f98fd07bff0$export$b4096f516fb93159);
    $parcel$export(module.exports, "issueNavigatorFilterRelayResource", ()=>$93f22f98fd07bff0$export$44ca3a0b25f38d83);
    $parcel$export(module.exports, "issueNavigatorHydrationRelayResource", ()=>$93f22f98fd07bff0$export$967ef0cfbd1cc946);
    var $8Uumt = parcelRequire("8Uumt");
    var $axGKd;
    var $9Nvh7;
    var $6UAdF;
    var $dXq4S;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $16Yit;
    var $kvekU;
    var $hTvlq;
    var $dIdda = parcelRequire("dIdda");
    var $5bSAg;
    var $aBKbA;
    const $93f22f98fd07bff0$export$b4096f516fb93159 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
        getKey: ()=>'issue-navigator-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const jqlOrFilterId = (0, (0, parcelRequire("aBKbA")).getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            const maxIssuesPerPage = (0, (0, parcelRequire("6UAdF")).getMaxIssuesPerPage)();
            const variables = {
                cloudId: tenantContext.cloudId,
                first: issueKey == null ? maxIssuesPerPage : null,
                issueSearchInput: jqlOrFilterId,
                namespace: (0, (0, parcelRequire("6UAdF")).ISSUE_SEARCH_NAMESPACE),
                after: null,
                options: {
                    issueKey: issueKey
                },
                fieldSetIds: [],
                shouldQueryFieldSetsById: false,
                filterId: Boolean(filter) && (0, (0, parcelRequire("9Nvh7")).isCustomFilter)(filter) ? filter : null,
                amountOfColumns: (0, (0, parcelRequire("6UAdF")).MAX_AMOUNT_OF_COLUMNS),
                atlassianIntelligenceProductFeature: (0, (0, parcelRequire("6UAdF")).NATURAL_LANGUAGE_TO_JQL)
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("hTvlq")).default), variables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
    const $93f22f98fd07bff0$export$44ca3a0b25f38d83 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
        getKey: ()=>'issue-navigator-filter-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const includeFilter = Boolean(filter) && (0, (0, parcelRequire("9Nvh7")).isFilterId)(filter);
            const variables = {
                includeFilter: includeFilter,
                filterAri: includeFilter ? (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'filter',
                    resourceId: filter,
                    activationId: tenantContext.activationId
                }) : ''
            };
            const options = {
                fetchPolicy: includeFilter ? 'network-only' : 'store-only'
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("kvekU")).default), variables, options);
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
    const $93f22f98fd07bff0$export$967ef0cfbd1cc946 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
        getKey: ()=>'issue-navigator-hydration-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const jqlOrFilterId = (0, (0, parcelRequire("aBKbA")).getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            const variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: 'filterId' in jqlOrFilterId,
                jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
                filterAri: 'filterId' in jqlOrFilterId && (0, (0, parcelRequire("axGKd")).JiraFilterAri).create({
                    siteId: tenantContext.cloudId,
                    filterId: filter,
                    activationId: tenantContext.activationId
                }).toString() || '',
                isNinShowOutOfContextFieldsAsOnlyUnselectable: true,
                viewContext: null
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("16Yit")).default), variables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("9Nvh7", function(module, exports) {
    $parcel$export(module.exports, "isCustomFilter", ()=>$08e78f523b28c02b$export$31180e7f1db565e5);
    $parcel$export(module.exports, "isFilterId", ()=>$08e78f523b28c02b$export$23be85030bd58047);
    const $08e78f523b28c02b$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
    const $08e78f523b28c02b$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
    const $08e78f523b28c02b$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);
});
parcelRegister("6UAdF", function(module, exports) {
    $parcel$export(module.exports, "sortDirections", ()=>$8e65b6d66c73d810$export$73034536b9adc928);
    $parcel$export(module.exports, "FilterTypes", ()=>$8e65b6d66c73d810$export$ad2e3f13451a5d44);
    $parcel$export(module.exports, "SearchInputTypes", ()=>$8e65b6d66c73d810$export$75a31bc7c097ba4b);
    $parcel$export(module.exports, "views", ()=>$8e65b6d66c73d810$export$d0079916fe6800ac);
    $parcel$export(module.exports, "defaultOrderFields", ()=>$8e65b6d66c73d810$export$2bd49f8f262d7cbb);
    $parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", ()=>$8e65b6d66c73d810$export$de2495608df10495);
    $parcel$export(module.exports, "DEFAULT_ORDER_FIELD", ()=>$8e65b6d66c73d810$export$393cb330f31d305c);
    $parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", ()=>$8e65b6d66c73d810$export$8ea18fa9e35fdf25);
    $parcel$export(module.exports, "DEFAULT_VIEW_ID", ()=>$8e65b6d66c73d810$export$500b5c379b5c7f2e);
    $parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b);
    $parcel$export(module.exports, "getMaxIssuesPerPage", ()=>$8e65b6d66c73d810$export$8c67ad1f64ab5a9c);
    $parcel$export(module.exports, "ANALYTICS_SOURCE", ()=>$8e65b6d66c73d810$export$f7109619a5e9e0d6);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$8e65b6d66c73d810$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$8e65b6d66c73d810$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "EXPERIENCE_NAME", ()=>$8e65b6d66c73d810$export$52919046b94109dc);
    $parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", ()=>$8e65b6d66c73d810$export$81d9767bc5c1549e);
    $parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", ()=>$8e65b6d66c73d810$export$524ae4278a57eea2);
    $parcel$export(module.exports, "LIST_VIEW_ID", ()=>$8e65b6d66c73d810$export$af225181779390f4);
    $parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", ()=>$8e65b6d66c73d810$export$608eeb3a32afef02);
    $parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", ()=>$8e65b6d66c73d810$export$ce9e2d7c178a9557);
    $parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", ()=>$8e65b6d66c73d810$export$1adf7afff96bbf16);
    $parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", ()=>$8e65b6d66c73d810$export$55628b4c44d1522a);
    $parcel$export(module.exports, "supportedOrderFields", ()=>$8e65b6d66c73d810$export$3630aa1c4c69277f);
    $parcel$export(module.exports, "getSupportedFieldForAlias", ()=>$8e65b6d66c73d810$export$eaadab3243bf458);
    var $032ey;
    var $czfFt;
    const $8e65b6d66c73d810$export$73034536b9adc928 = {
        ASC: 'ASC',
        DESC: 'DESC',
        NONE: 'NONE'
    };
    const $8e65b6d66c73d810$export$3f42f49c284d5b58 = {
        TODO: 2,
        COMPLETE: 3,
        IN_PROGRESS: 4
    };
    const $8e65b6d66c73d810$export$ad2e3f13451a5d44 = {
        ID: 'filterId',
        JQL: 'filterJql'
    };
    const $8e65b6d66c73d810$export$75a31bc7c097ba4b = {
        JQL: 'jql',
        FILTER: 'filter',
        FILTER_AND_JQL: 'filterAndJql'
    };
    const $8e65b6d66c73d810$export$d0079916fe6800ac = {
        list: 'list-view',
        detail: 'split-view'
    };
    const $8e65b6d66c73d810$export$2bd49f8f262d7cbb = {
        created: 'created',
        lastviewed: 'lastviewed',
        updated: 'updated'
    };
    const $8e65b6d66c73d810$export$92a576f896a9bf72 = {
        myopenissues: Symbol('myopenissues'),
        reportedbyme: Symbol('reportedbyme'),
        allopenissues: Symbol('allopenissues'),
        doneissues: Symbol('doneissues'),
        recentlyviewed: Symbol('recentlyviewed'),
        resolvedrecently: Symbol('resolvedrecently'),
        updatedrecently: Symbol('updatedrecently'),
        allissues: Symbol('allissues')
    };
    const $8e65b6d66c73d810$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
    const $8e65b6d66c73d810$export$66816805c55e43b7 = 'jira.issues.preferred.layout.key';
    const $8e65b6d66c73d810$export$393cb330f31d305c = $8e65b6d66c73d810$export$2bd49f8f262d7cbb.created;
    const $8e65b6d66c73d810$export$8ea18fa9e35fdf25 = $8e65b6d66c73d810$export$73034536b9adc928.DESC;
    const $8e65b6d66c73d810$export$500b5c379b5c7f2e = 'list_default';
    const $8e65b6d66c73d810$export$f88f58d1a4b2078b = 50;
    const $8e65b6d66c73d810$export$8c67ad1f64ab5a9c = ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b;
    const $8e65b6d66c73d810$export$9d7b852b1c962aa3 = 1000;
    const $8e65b6d66c73d810$export$f7109619a5e9e0d6 = 'issue-navigator-next';
    const $8e65b6d66c73d810$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
    const $8e65b6d66c73d810$export$d57b6b390e78d90f = 'empanada';
    const $8e65b6d66c73d810$export$52919046b94109dc = 'showPinIssueList';
    const $8e65b6d66c73d810$export$81d9767bc5c1549e = 'issueNavigatorListView';
    const $8e65b6d66c73d810$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
    const $8e65b6d66c73d810$export$af478702fa9b9a17 = 'user.search.mode';
    const $8e65b6d66c73d810$export$84f45d3374492a7c = 'BLANK';
    const $8e65b6d66c73d810$export$e1eb2ddab803c5ec = (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC);
    const $8e65b6d66c73d810$export$af225181779390f4 = 'list_default';
    const $8e65b6d66c73d810$export$608eeb3a32afef02 = (0, (0, parcelRequire("czfFt")).MAX_COLUMNS);
    const $8e65b6d66c73d810$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $8e65b6d66c73d810$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $8e65b6d66c73d810$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
    const $8e65b6d66c73d810$export$3630aa1c4c69277f = {
        created: {
            jqlTerm: 'created',
            fieldType: 'created',
            aliases: []
        },
        key: {
            jqlTerm: 'key',
            fieldType: 'issuekey',
            aliases: [
                'issuekey'
            ]
        },
        lastviewed: {
            jqlTerm: 'lastviewed',
            fieldType: 'lastviewed',
            aliases: []
        },
        priority: {
            jqlTerm: 'priority',
            fieldType: 'priority',
            aliases: []
        },
        resolved: {
            jqlTerm: 'resolved',
            fieldType: 'resolutiondate',
            aliases: []
        },
        status: {
            jqlTerm: 'status',
            fieldType: 'status',
            aliases: []
        },
        updated: {
            jqlTerm: 'updated',
            fieldType: 'updated',
            aliases: []
        },
        issuetype: {
            jqlTerm: 'issuetype',
            fieldType: 'issuetype',
            aliases: [
                'type'
            ]
        },
        assignee: {
            jqlTerm: 'assignee',
            fieldType: 'assignee',
            aliases: []
        },
        duedate: {
            jqlTerm: 'duedate',
            fieldType: 'duedate',
            aliases: []
        },
        reporter: {
            jqlTerm: 'reporter',
            fieldType: 'reporter',
            aliases: []
        },
        summary: {
            jqlTerm: 'summary',
            fieldType: 'summary',
            aliases: []
        }
    };
    const $8e65b6d66c73d810$export$eaadab3243bf458 = (alias)=>Object.keys($8e65b6d66c73d810$export$3630aa1c4c69277f).find((key)=>$8e65b6d66c73d810$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
});
parcelRegister("032ey", function(module, exports) {
    $parcel$export(module.exports, "SEARCH_MODE_BASIC", ()=>$e090bb7ab54db3ef$export$f963d14b266e4d2e);
    $parcel$export(module.exports, "SEARCH_MODE_ADVANCED", ()=>$e090bb7ab54db3ef$export$aad1d9eb9b751555);
    $parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", ()=>$e090bb7ab54db3ef$export$87c41a6b3123c00f);
    $parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", ()=>$e090bb7ab54db3ef$export$a7a000706ebc3ba8);
    $parcel$export(module.exports, "DEFAULT_SEARCH_MODE", ()=>$e090bb7ab54db3ef$export$e1eb2ddab803c5ec);
    $parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", ()=>$e090bb7ab54db3ef$export$70c8f980e4a50682);
    $parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", ()=>$e090bb7ab54db3ef$export$4dab29e715a4e6fb);
    $parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", ()=>$e090bb7ab54db3ef$export$59848395da0b4bcb);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$e090bb7ab54db3ef$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$e090bb7ab54db3ef$export$d57b6b390e78d90f);
    const $e090bb7ab54db3ef$export$f963d14b266e4d2e = 'basic';
    const $e090bb7ab54db3ef$export$aad1d9eb9b751555 = 'advanced';
    const $e090bb7ab54db3ef$export$87c41a6b3123c00f = 'BASIC';
    const $e090bb7ab54db3ef$export$a7a000706ebc3ba8 = 'ADVANCED';
    const $e090bb7ab54db3ef$export$e1eb2ddab803c5ec = $e090bb7ab54db3ef$export$f963d14b266e4d2e;
    const $e090bb7ab54db3ef$export$70c8f980e4a50682 = {
        [$e090bb7ab54db3ef$export$f963d14b266e4d2e]: $e090bb7ab54db3ef$export$f963d14b266e4d2e,
        [$e090bb7ab54db3ef$export$aad1d9eb9b751555]: 'JQL'
    };
    const $e090bb7ab54db3ef$export$4dab29e715a4e6fb = 'Left';
    const $e090bb7ab54db3ef$export$59848395da0b4bcb = 'Right';
    const $e090bb7ab54db3ef$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
    const $e090bb7ab54db3ef$export$d57b6b390e78d90f = 'empanada';
});
parcelRegister("16Yit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$296a6f030570708c$export$2e2bcd8739ae039);
    const $296a6f030570708c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeJira"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeUser"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilter"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isNinShowOutOfContextFieldsAsOnlyUnselectable"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewContext"
        }, v9 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v10 = {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }, v11 = [
            {
                "kind": "Variable",
                "name": "query",
                "variableName": "jql"
            },
            v10
        ], v12 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v13 = [
            v12
        ], v14 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "filterAri"
            },
            v10
        ], v15 = {
            "kind": "ScalarField",
            "name": "id"
        }, v16 = [
            v12,
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v15
        ], v17 = {
            "kind": "ScalarField",
            "name": "jqlTerm"
        }, v18 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v19 = {
            "kind": "ScalarField",
            "name": "key"
        }, v20 = [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorName"
                    },
                    v15
                ]
            }
        ], v21 = {
            "kind": "ScalarField",
            "name": "optionId"
        }, v22 = [
            v12,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jql"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                            v12,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v17,
                                    {
                                        "concreteType": "JiraJqlField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            v18,
                                            {
                                                "concreteType": "JiraJqlSearchTemplate",
                                                "kind": "LinkedField",
                                                "name": "searchTemplate",
                                                "plural": false,
                                                "selections": [
                                                    v19
                                                ]
                                            },
                                            {
                                                "condition": "isNinShowOutOfContextFieldsAsOnlyUnselectable",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "shouldShowInContext"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "operators"
                                            },
                                            {
                                                "concreteType": "JiraFieldType",
                                                "kind": "LinkedField",
                                                "name": "fieldType",
                                                "plural": false,
                                                "selections": [
                                                    v18
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                            v12,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v17,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "values",
                                                        "plural": true,
                                                        "selections": [
                                                            v12,
                                                            v17,
                                                            v18,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v19,
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "small"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlProjectFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v20,
                                                                "type": "JiraJqlStatusFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v20,
                                                                "type": "JiraJqlStatusCategoryFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "xsmall"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": v16
                                                                    }
                                                                ],
                                                                "type": "JiraJqlUserFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "iconUrl"
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlPriorityFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fields",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v12,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "text"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                    },
                                                                                                    v15
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "sprint",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "state"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "boardName"
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlSprintFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v21,
                                                                    {
                                                                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v18,
                                                                            v17,
                                                                            v21
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlCascadingOptionFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedValue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v17,
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "error",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedError"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraJqlQueryHydratedField"
                            }
                        ]
                    }
                ],
                "type": "JiraJqlHydratedQuery"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "message"
                    }
                ],
                "type": "QueryError"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8
                ],
                "kind": "Fragment",
                "name": "hydrateJqlBuilderQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useHydratedValues"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useQuery"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useHydratedValues_cascadeSelectPicker"
                    },
                    {
                        "condition": "includeJira",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9,
                                        "concreteType": "JiraJqlBuilder",
                                        "kind": "LinkedField",
                                        "name": "jqlBuilder",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "args": v11,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQuery",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ]
                                            },
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": v14,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQueryForFilter",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v4,
                    v3,
                    v7,
                    v6,
                    v8,
                    v5,
                    v2
                ],
                "kind": "Operation",
                "name": "hydrateJqlBuilderQuery",
                "selections": [
                    {
                        "condition": "includeUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "accountId",
                                        "variableName": "accountId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": v16
                            }
                        ]
                    },
                    {
                        "condition": "includeJira",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9,
                                        "concreteType": "JiraJqlBuilder",
                                        "kind": "LinkedField",
                                        "name": "jqlBuilder",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "args": v11,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQuery",
                                                        "plural": false,
                                                        "selections": v22
                                                    }
                                                ]
                                            },
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": v14,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQueryForFilter",
                                                        "plural": false,
                                                        "selections": v22
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "2b9a5d2ee5abe9af1719751bca7766699a66994c17bd0771bb1457a53c717bba",
                "metadata": {},
                "name": "hydrateJqlBuilderQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $296a6f030570708c$var$node.hash = "c0c7d28e17786c2301b149d4cb764ad1";
    var $296a6f030570708c$export$2e2bcd8739ae039 = $296a6f030570708c$var$node;
});
parcelRegister("kvekU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d76682723f87707c$export$2e2bcd8739ae039);
    const $d76682723f87707c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includeFilter"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_FilterQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigator_filterQuery"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_FilterQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "includeFilter",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "filterAri"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "filter",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraFilter"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "jql"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isEditable"
                                                    }
                                                ],
                                                "type": "JiraCustomFilter"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "filterId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isFavourite"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
                "metadata": {},
                "name": "main_FilterQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $d76682723f87707c$var$node.hash = "181bb07a6bafd05a2033750384a06766";
    var $d76682723f87707c$export$2e2bcd8739ae039 = $d76682723f87707c$var$node;
});
parcelRegister("hTvlq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff9dfb30fc1873c4$export$2e2bcd8739ae039);
    var $hLeia;
    var $6nwMW;
    var $5oQtH;
    var $1q6lK;
    var $1ZvTA;
    var $G39h7;
    var $6vKPN;
    var $5y5Fx;
    var $1kHcz;
    const $ff9dfb30fc1873c4$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "amountOfColumns"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianIntelligenceProductFeature"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "before"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldSetIds"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterId"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueTypeId"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }, v11 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "namespace"
        }, v12 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "options"
        }, v13 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }, v14 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryFieldSetsById"
        }, v15 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewId"
        }, v16 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v17 = [
            v16
        ], v18 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v19 = [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "feature",
                        "variableName": "atlassianIntelligenceProductFeature"
                    }
                ],
                "kind": "ObjectValue",
                "name": "atlassianIntelligenceProductFeatureInput"
            },
            v16
        ], v20 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v21 = {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        }, v22 = {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        }, v23 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v24 = {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }, v25 = {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        }, v26 = [
            v21,
            v22,
            v16,
            v23,
            v24,
            v25,
            {
                "kind": "Variable",
                "name": "options",
                "variableName": "options"
            }
        ], v27 = {
            "kind": "ScalarField",
            "name": "key"
        }, v28 = {
            "kind": "ScalarField",
            "name": "id"
        }, v29 = {
            "kind": "ScalarField",
            "name": "issueId"
        }, v30 = {
            "kind": "ScalarField",
            "name": "isResolved"
        }, v31 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v32 = {
            "kind": "ScalarField",
            "name": "statusCategoryId"
        }, v33 = {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v32,
                v28
            ]
        }, v34 = {
            "args": [
                {
                    "kind": "Literal",
                    "name": "ids",
                    "value": [
                        "status"
                    ]
                }
            ],
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fieldsById",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v20,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v31,
                                        {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                v33,
                                                v28
                                            ]
                                        }
                                    ],
                                    "type": "JiraStatusField"
                                },
                                v28
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "fieldsById(ids:[\"status\"])"
        }, v35 = {
            "kind": "Variable",
            "name": "filterId",
            "variableName": "filterId"
        }, v36 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }, v37 = {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        }, v38 = {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }, v39 = [
            {
                "fields": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "issueType",
                                "variableName": "issueTypeId"
                            },
                            {
                                "kind": "Variable",
                                "name": "project",
                                "variableName": "projectId"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "projectContext"
                    }
                ],
                "kind": "ObjectValue",
                "name": "context"
            },
            v35,
            v36,
            v37,
            v38
        ], v40 = {
            "kind": "ScalarField",
            "name": "name"
        }, v41 = {
            "kind": "ScalarField",
            "name": "text"
        }, v42 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v43 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "small"
                }
            ]
        }, v44 = {
            "args": v39,
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsForIssueSearchView",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v20,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v31,
                                                                v40,
                                                                v41
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        },
                                                        v28,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v31,
                                                                v40,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20,
                                                                        v40,
                                                                        v42,
                                                                        v28
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v31,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v40,
                                                                        v43,
                                                                        v28
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueTypeField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v31,
                                                                v33
                                                            ],
                                                            "type": "JiraStatusCategoryField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v45 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasChildren"
                }
            ]
        }, v46 = {
            "kind": "ScalarField",
            "name": "type"
        }, v47 = {
            "kind": "ScalarField",
            "name": "fieldSetId"
        }, v48 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJiraIssueField"
        }, v49 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceConnection",
                    "kind": "LinkedField",
                    "name": "selectedAffectedServicesConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedServiceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraAffectedService",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "serviceId"
                                        },
                                        v40,
                                        v28
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraAffectedServicesField"
        }, v50 = {
            "kind": "ScalarField",
            "name": "message"
        }, v51 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectConnection",
                    "kind": "LinkedField",
                    "name": "selectedCmdbObjectsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraCmdbObject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "objectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "concreteType": "JiraCmdbAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                            "kind": "LinkedField",
                                                            "name": "mediaClientConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "clientId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaBaseUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaJwtToken"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url48"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v50
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraCMDBField"
        }, v52 = [
            v40,
            v28
        ], v53 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraComponentConnection",
                    "kind": "LinkedField",
                    "name": "selectedComponentsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraComponentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraComponent",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v52
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraComponentsField"
        }, v54 = {
            "kind": "ScalarField",
            "name": "date"
        }, v55 = {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }, v56 = {
            "kind": "ScalarField",
            "name": "lazyIsEditableInIssueView"
        }, v57 = {
            "kind": "ClientExtension",
            "selections": [
                v56
            ]
        }, v58 = {
            "kind": "InlineFragment",
            "selections": [
                v54,
                v40,
                v55,
                v57
            ],
            "type": "JiraDatePickerField"
        }, v59 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }, v60 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraEpic",
                    "kind": "LinkedField",
                    "name": "epic",
                    "plural": false,
                    "selections": [
                        v27,
                        {
                            "kind": "ScalarField",
                            "name": "summary"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        v28
                    ]
                }
            ],
            "type": "JiraEpicLinkField"
        }, v61 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "renderedFieldHtml"
                }
            ],
            "type": "JiraFallbackField"
        }, v62 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        v40,
                        v32,
                        v28
                    ]
                }
            ],
            "type": "JiraStatusCategoryField"
        }, v63 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        v40,
                        {
                            "kind": "ScalarField",
                            "name": "statusId"
                        },
                        v33,
                        v28
                    ]
                }
            ],
            "type": "JiraStatusField"
        }, v64 = [
            v40
        ], v65 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v66 = {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "selectedLabelsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraLabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraLabel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v64
                        }
                    ]
                },
                v65
            ],
            "storageKey": "selectedLabelsConnection(first:1000)"
        }, v67 = {
            "kind": "InlineFragment",
            "selections": [
                v66,
                v40,
                v57
            ],
            "type": "JiraLabelsField"
        }, v68 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        v43,
                        v40,
                        v28
                    ]
                }
            ],
            "type": "JiraIssueTypeField"
        }, v69 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v70 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "parentIssue",
                    "plural": false,
                    "selections": [
                        v27,
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "summaryField",
                            "plural": false,
                            "selections": [
                                v41,
                                v28
                            ]
                        },
                        v28,
                        {
                            "concreteType": "JiraColorField",
                            "kind": "LinkedField",
                            "name": "issueColorField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraColor",
                                    "kind": "LinkedField",
                                    "name": "color",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorKey"
                                        },
                                        v28
                                    ]
                                },
                                v28
                            ]
                        },
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v69,
                                        v40,
                                        v28
                                    ]
                                },
                                v28
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraParentIssueField"
        }, v71 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v72 = {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                v40,
                v71,
                v28
            ]
        }, v73 = {
            "kind": "InlineFragment",
            "selections": [
                v72,
                v40,
                v57
            ],
            "type": "JiraPriorityField"
        }, v74 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        v40,
                        v27,
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        v28
                    ]
                }
            ],
            "type": "JiraProjectField"
        }, v75 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraResolution",
                    "kind": "LinkedField",
                    "name": "resolution",
                    "plural": false,
                    "selections": v52
                }
            ],
            "type": "JiraResolutionField"
        }, v76 = {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v28,
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                v40,
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v77 = {
            "kind": "InlineFragment",
            "selections": [
                v76,
                v40,
                v57
            ],
            "type": "JiraSprintField"
        }, v78 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v79 = {
            "kind": "ScalarField",
            "name": "accountStatus"
        }, v80 = {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v20,
                v78,
                v42,
                v40,
                v28,
                v79
            ]
        }, v81 = {
            "kind": "InlineFragment",
            "selections": [
                v40,
                {
                    "concreteType": "JiraVersionConnection",
                    "kind": "LinkedField",
                    "name": "selectedVersionsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraVersionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v52
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraMultipleVersionPickerField"
        }, v82 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "richText",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraADF",
                            "kind": "LinkedField",
                            "name": "adfValue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAdfToConvertedPlainText",
                                    "kind": "LinkedField",
                                    "name": "convertedPlainText",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "plainText"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraRichTextField"
        }, v83 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraServiceManagementRequestType",
                    "kind": "LinkedField",
                    "name": "requestType",
                    "plural": false,
                    "selections": [
                        v40,
                        v69,
                        v28
                    ]
                }
            ],
            "type": "JiraServiceManagementRequestTypeField"
        }, v84 = {
            "kind": "ScalarField",
            "name": "hasNextPage"
        }, v85 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                        }
                    ],
                    "concreteType": "JiraIssueLinkConnection",
                    "kind": "LinkedField",
                    "name": "issueLinkConnection",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v84
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v65
                            ]
                        },
                        {
                            "concreteType": "JiraIssueLinkEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v27,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "statusCategory"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v33
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        v28
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                },
                                                v28
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "relationName"
                                        },
                                        v28
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraIssueLinkField"
        }, v86 = {
            "kind": "ScalarField",
            "name": "isStoryPointField"
        }, v87 = {
            "kind": "ScalarField",
            "name": "number"
        }, v88 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v86,
                        v87,
                        v40,
                        v57
                    ],
                    "type": "JiraNumberField"
                }
            ]
        }, v89 = [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v46,
                            v47,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v20,
                                                    v31,
                                                    v46,
                                                    v48,
                                                    v28,
                                                    v49,
                                                    v51,
                                                    v53,
                                                    v58,
                                                    v59,
                                                    v60,
                                                    v61,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v41,
                                                            v40,
                                                            v57
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    v62,
                                                    v63,
                                                    v67,
                                                    v68,
                                                    v70,
                                                    v73,
                                                    v74,
                                                    v75,
                                                    v77,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v80,
                                                            v40,
                                                            v55,
                                                            v57
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    v81,
                                                    v82,
                                                    v83,
                                                    v85,
                                                    v88
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v90 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "fieldSetIds",
                            "variableName": "fieldSetIds"
                        },
                        v36
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsById",
                    "plural": false,
                    "selections": v89
                }
            ]
        }, v91 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": v39,
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsForIssueSearchView",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v46,
                                        v47,
                                        {
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fields",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v31,
                                                                v46,
                                                                v48,
                                                                v49,
                                                                v51,
                                                                v53,
                                                                v58,
                                                                v59,
                                                                v60,
                                                                v61,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46,
                                                                        v57
                                                                    ],
                                                                    "type": "JiraSingleLineTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": v64
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                },
                                                                v63,
                                                                v67,
                                                                v70,
                                                                v73,
                                                                v74,
                                                                v75,
                                                                v77,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v78,
                                                                                v79
                                                                            ]
                                                                        },
                                                                        v55,
                                                                        v57
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                v81,
                                                                v82,
                                                                v83,
                                                                v85,
                                                                v88
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v92 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                v90,
                v91
            ]
        }, v93 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "issueRowFieldSets",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v46,
                                        v47,
                                        {
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fields",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v20,
                                                                v31,
                                                                v46,
                                                                v48,
                                                                v28,
                                                                v49,
                                                                v51,
                                                                v53,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v54,
                                                                        v56,
                                                                        v40,
                                                                        v55
                                                                    ],
                                                                    "type": "JiraDatePickerField"
                                                                },
                                                                v59,
                                                                v60,
                                                                v61,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v41,
                                                                        v56,
                                                                        v40
                                                                    ],
                                                                    "type": "JiraSingleLineTextField"
                                                                },
                                                                v62,
                                                                v63,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v66,
                                                                        v56,
                                                                        v40
                                                                    ],
                                                                    "type": "JiraLabelsField"
                                                                },
                                                                v68,
                                                                v70,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v56,
                                                                        v72,
                                                                        v40
                                                                    ],
                                                                    "type": "JiraPriorityField"
                                                                },
                                                                v74,
                                                                v75,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v56,
                                                                        v76,
                                                                        v40
                                                                    ],
                                                                    "type": "JiraSprintField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v80,
                                                                        v56,
                                                                        v40,
                                                                        v55
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                v81,
                                                                v82,
                                                                v83,
                                                                v85,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v86,
                                                                                v87,
                                                                                v56,
                                                                                v40
                                                                            ],
                                                                            "type": "JiraNumberField"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v94 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                v90,
                v91,
                v93
            ]
        }, v95 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                }
            ]
        }, v96 = {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        }, v97 = [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ], v98 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v99 = {
            "kind": "ScalarField",
            "name": "isCurrent"
        }, v100 = {
            "kind": "ScalarField",
            "name": "pageNumber"
        }, v101 = [
            v100,
            v98,
            v99
        ], v102 = {
            "concreteType": "JiraPageCursor",
            "kind": "LinkedField",
            "name": "last",
            "plural": false,
            "selections": v101
        }, v103 = {
            "concreteType": "JiraPageCursor",
            "kind": "LinkedField",
            "name": "first",
            "plural": false,
            "selections": [
                v98,
                v100,
                v99
            ]
        }, v104 = {
            "kind": "ScalarField",
            "name": "firstIssuePosition"
        }, v105 = {
            "kind": "ScalarField",
            "name": "lastIssuePosition"
        }, v106 = {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                v20,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v50,
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }, v107 = {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }, v108 = [
            v16,
            v35,
            v37,
            v38
        ], v109 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJiraIssueSearchViewResult"
        }, v110 = {
            "kind": "ScalarField",
            "name": "viewId"
        }, v111 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": {
                    "fieldSetSelectedState": "SELECTED"
                }
            },
            v36
        ], v112 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v113 = {
            "concreteType": "JiraIssueSearchFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v47,
                        v46,
                        v112,
                        {
                            "kind": "ScalarField",
                            "name": "jqlTerm"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSortable"
                        },
                        {
                            "concreteType": "JiraFieldSetPreferences",
                            "kind": "LinkedField",
                            "name": "fieldSetPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraFieldType",
                            "kind": "LinkedField",
                            "name": "fieldType",
                            "plural": false,
                            "selections": [
                                v112
                            ]
                        }
                    ]
                }
            ]
        }, v114 = {
            "kind": "ScalarField",
            "name": "hasDefaultFieldSets"
        }, v115 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHierarchyEnabled"
                },
                v18
            ]
        }, v116 = {
            "kind": "InlineFragment",
            "selections": [
                v50,
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        v20,
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                }
            ],
            "type": "QueryError"
        }, v117 = {
            "kind": "InlineFragment",
            "selections": [
                v28
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v118 = {
            "kind": "ScalarField",
            "name": "endCursor"
        }, v119 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v120 = {
            "kind": "ScalarField",
            "name": "fieldType"
        }, v121 = {
            "kind": "ScalarField",
            "name": "issueCount"
        }, v122 = {
            "kind": "LinkedField",
            "name": "fieldValue",
            "plural": false,
            "selections": [
                v20,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v112,
                        {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                                v71,
                                v28
                            ]
                        }
                    ],
                    "type": "JiraJqlPriorityFieldValue"
                }
            ]
        }, v123 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 50
            }
        ], v124 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": v39,
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsForIssueSearchView",
                    "plural": false,
                    "selections": v89
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15
                ],
                "kind": "Fragment",
                "name": "main_IssueNavigatorQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigator_issueQuery"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v17,
                                "concreteType": "JiraUserPreferences",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigator_jira"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v4,
                    v8,
                    v7,
                    v10,
                    v3,
                    v0,
                    v11,
                    v15,
                    v12,
                    v6,
                    v5,
                    v14,
                    v1,
                    v2,
                    v9,
                    v13,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "main_IssueNavigatorQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v17,
                                "concreteType": "JiraUserPreferences",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "jqlBuilderSearchMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isNaturalLanguageSpotlightTourEnabled"
                                    },
                                    v18
                                ]
                            },
                            {
                                "args": v19,
                                "kind": "ScalarField",
                                "name": "shouldShowAtlassianIntelligence"
                            },
                            {
                                "args": v19,
                                "kind": "LinkedField",
                                "name": "atlassianIntelligenceAction",
                                "plural": false,
                                "selections": [
                                    v20,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "isAccessible"
                                            }
                                        ],
                                        "type": "JiraAccessAtlassianIntelligenceFeature"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "link"
                                            }
                                        ],
                                        "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v26,
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issueSearchStable",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v27,
                                                            v28,
                                                            v29,
                                                            v30,
                                                            v34,
                                                            v44,
                                                            v45,
                                                            v92,
                                                            v94,
                                                            v95
                                                        ]
                                                    },
                                                    v20,
                                                    v18
                                                ]
                                            },
                                            v96,
                                            {
                                                "args": v97,
                                                "concreteType": "JiraPageCursors",
                                                "kind": "LinkedField",
                                                "name": "pageCursors",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraPageCursor",
                                                        "kind": "LinkedField",
                                                        "name": "around",
                                                        "plural": true,
                                                        "selections": [
                                                            v98,
                                                            v99,
                                                            v100
                                                        ]
                                                    },
                                                    v102,
                                                    v103
                                                ],
                                                "storageKey": "pageCursors(maxCursors:7)"
                                            },
                                            {
                                                "concreteType": "JiraIssueNavigatorPageInfo",
                                                "kind": "LinkedField",
                                                "name": "issueNavigatorPageInfo",
                                                "plural": false,
                                                "selections": [
                                                    v104,
                                                    v105,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "firstIssueKeyFromNextPage"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "lastIssueKeyFromPreviousPage"
                                                    }
                                                ]
                                            },
                                            v106,
                                            v107,
                                            v18
                                        ]
                                    },
                                    {
                                        "args": v108,
                                        "kind": "LinkedField",
                                        "name": "issueSearchViewResult",
                                        "plural": false,
                                        "selections": [
                                            v20,
                                            v109,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v110,
                                                    {
                                                        "args": v111,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            v113,
                                                            v65,
                                                            v18
                                                        ]
                                                    },
                                                    v28,
                                                    v114,
                                                    v115
                                                ],
                                                "type": "JiraIssueSearchView"
                                            },
                                            v116,
                                            v117
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v26,
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issueSearch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v98,
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v20,
                                                            v28,
                                                            v27,
                                                            v29,
                                                            v30,
                                                            v34,
                                                            v44,
                                                            v45,
                                                            v92,
                                                            v94,
                                                            v95
                                                        ]
                                                    },
                                                    v20
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueNavigatorPageInfo",
                                                "kind": "LinkedField",
                                                "name": "issueNavigatorPageInfo",
                                                "plural": false,
                                                "selections": [
                                                    v104,
                                                    v105
                                                ]
                                            },
                                            {
                                                "args": v97,
                                                "concreteType": "JiraPageCursors",
                                                "kind": "LinkedField",
                                                "name": "pageCursors",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraPageCursor",
                                                        "kind": "LinkedField",
                                                        "name": "around",
                                                        "plural": true,
                                                        "selections": v101
                                                    },
                                                    v102,
                                                    v103
                                                ],
                                                "storageKey": "pageCursors(maxCursors:7)"
                                            },
                                            v96,
                                            v106,
                                            v107,
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    v118,
                                                    v84,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasPreviousPage"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "startCursor"
                                                    }
                                                ]
                                            },
                                            v18
                                        ]
                                    },
                                    {
                                        "args": v26,
                                        "filters": [
                                            "cloudId",
                                            "issueSearchInput",
                                            "options"
                                        ],
                                        "handle": "connection",
                                        "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                                        "kind": "LinkedHandle",
                                        "name": "issueSearch"
                                    },
                                    {
                                        "args": v108,
                                        "kind": "LinkedField",
                                        "name": "issueSearchViewResult",
                                        "plural": false,
                                        "selections": [
                                            v20,
                                            v109,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v110,
                                                    v28,
                                                    v114,
                                                    {
                                                        "args": v111,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            v65,
                                                            v113,
                                                            v18
                                                        ]
                                                    },
                                                    v115
                                                ],
                                                "type": "JiraIssueSearchView"
                                            },
                                            v116,
                                            v117
                                        ]
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v108,
                                                "kind": "LinkedField",
                                                "name": "jiraIssueSearchView",
                                                "plural": false,
                                                "selections": [
                                                    v20,
                                                    v28,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": [
                                                                    v21,
                                                                    v22,
                                                                    v23,
                                                                    v24,
                                                                    v25
                                                                ],
                                                                "concreteType": "JiraSpreadsheetGroupConnection",
                                                                "kind": "LinkedField",
                                                                "name": "groups",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSpreadsheetGroup",
                                                                        "kind": "LinkedField",
                                                                        "name": "firstGroup",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v28,
                                                                            v119,
                                                                            v120,
                                                                            v121,
                                                                            v122,
                                                                            {
                                                                                "args": v123,
                                                                                "concreteType": "JiraIssueConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "issues",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v20,
                                                                                            v98,
                                                                                            {
                                                                                                "concreteType": "JiraIssue",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v20,
                                                                                                    v28,
                                                                                                    v27,
                                                                                                    v29,
                                                                                                    v30,
                                                                                                    v34,
                                                                                                    v45,
                                                                                                    {
                                                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                                                                        "kind": "Condition",
                                                                                                        "passingValue": false,
                                                                                                        "selections": [
                                                                                                            v90,
                                                                                                            v124
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                                                                        "kind": "Condition",
                                                                                                        "passingValue": true,
                                                                                                        "selections": [
                                                                                                            v90,
                                                                                                            v124,
                                                                                                            v93
                                                                                                        ]
                                                                                                    },
                                                                                                    v95
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "PageInfo",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "pageInfo",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v118,
                                                                                            v84
                                                                                        ]
                                                                                    },
                                                                                    v18
                                                                                ],
                                                                                "storageKey": "issues(first:50)"
                                                                            },
                                                                            {
                                                                                "args": v123,
                                                                                "handle": "connection",
                                                                                "key": "firstGroupSection_nativeIssueTable__issues",
                                                                                "kind": "LinkedHandle",
                                                                                "name": "issues"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraSpreadsheetGroupEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSpreadsheetGroup",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v28,
                                                                                    v120,
                                                                                    v121,
                                                                                    v119,
                                                                                    v122
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v18
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraGroupedListView"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "7b607de43cc70a9c361b035a8d1e03db9d5dad5938d8b5af50188d8d245e451b",
                "metadata": {},
                "name": "main_IssueNavigatorQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, (0, parcelRequire("5oQtH")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, (0, parcelRequire("6nwMW")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, (0, parcelRequire("6vKPN")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, (0, parcelRequire("1kHcz")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider": (0, (0, parcelRequire("hLeia")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, (0, parcelRequire("G39h7")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, (0, parcelRequire("1ZvTA")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider": (0, (0, parcelRequire("5y5Fx")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": (0, (0, parcelRequire("1q6lK")).default)
                }
            }
        };
    }();
    $ff9dfb30fc1873c4$var$node.hash = "ad05a88027f7cf0b44b467f5d310c31d";
    var $ff9dfb30fc1873c4$export$2e2bcd8739ae039 = $ff9dfb30fc1873c4$var$node;
});
parcelRegister("5oQtH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63783baa7e252f12$export$2e2bcd8739ae039);
    var $6s1PB;
    var $63783baa7e252f12$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("6s1PB")).expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false);
        }
    };
});
parcelRegister("1q6lK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$181eac5504cd1c95$export$2e2bcd8739ae039);
    var $4R6GH;
    var $181eac5504cd1c95$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('refactor_nin_to_jira_view_schema');
        }
    };
});
parcelRegister("5y5Fx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59ea24ee5943008b$export$2e2bcd8739ae039);
    var $4R6GH;
    const $59ea24ee5943008b$var$JscM2ApiUpdatesRelayProvider = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jsc_-_m2_hierarchy_api_updates');
        }
    };
    var $59ea24ee5943008b$export$2e2bcd8739ae039 = $59ea24ee5943008b$var$JscM2ApiUpdatesRelayProvider;
});
parcelRegister("5bSAg", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", ()=>$2134dee38b024167$export$c300d3b7f3dc697d);
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", ()=>$2134dee38b024167$export$b99d8b4e19091835);
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", ()=>$2134dee38b024167$export$1b65799bbeba8a33);
    $parcel$export(module.exports, "defaultOrderFields", ()=>$2134dee38b024167$export$2bd49f8f262d7cbb);
    $parcel$export(module.exports, "sortDirections", ()=>$2134dee38b024167$export$73034536b9adc928);
    const $2134dee38b024167$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
    const $2134dee38b024167$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
    const $2134dee38b024167$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
    const $2134dee38b024167$export$2bd49f8f262d7cbb = {
        created: 'created',
        lastviewed: 'lastviewed',
        updated: 'updated'
    };
    const $2134dee38b024167$export$73034536b9adc928 = {
        ASC: 'ASC',
        DESC: 'DESC',
        NONE: 'NONE'
    };
});
parcelRegister("aBKbA", function(module, exports) {
    $parcel$export(module.exports, "getDefaultJqlGin", ()=>$b87185164056f069$export$8780b1523384f42d);
    $parcel$export(module.exports, "getParams", ()=>$b87185164056f069$export$ec161d740909e39d);
    $parcel$export(module.exports, "getJqlOrFilterId", ()=>$b87185164056f069$export$b968a035fc2aa57b);
    var $9Nvh7;
    var $g5X3G;
    var $8zzKy;
    var $5bSAg;
    const $b87185164056f069$export$8780b1523384f42d = ()=>`ORDER BY ${(0, (0, parcelRequire("5bSAg")).defaultOrderFields).created} ${(0, (0, parcelRequire("5bSAg")).sortDirections).DESC}`;
    const $b87185164056f069$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
        const { projectKey: projectKey, issueKey: issueKey } = params;
        const { filter: filter, jql: jql } = query;
        const defaultJql = projectKey !== null && projectKey !== undefined ? (0, (0, parcelRequire("8zzKy")).getDefaultJql)((0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey)) : $b87185164056f069$export$8780b1523384f42d();
        return {
            page: 1,
            jql: jql,
            issueKey: issueKey,
            projectKey: projectKey,
            filter: filter,
            defaultJql: defaultJql
        };
    };
    const $b87185164056f069$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
        if (typeof jqlParam === 'string') return {
            jql: jqlParam
        };
        if (typeof filter === 'string' && filter !== '') {
            if ((0, (0, parcelRequire("9Nvh7")).isFilterId)(filter)) return {
                filterId: filter
            };
            const filterJql = projectKey !== null && projectKey !== undefined ? (0, (0, parcelRequire("8zzKy")).mapFilterToJql)(projectKey, filter) : undefined;
            if (filterJql !== undefined) return {
                jql: filterJql
            };
        }
        return {
            jql: defaultJql
        };
    };
});
parcelRegister("8zzKy", function(module, exports) {
    $parcel$export(module.exports, "isFilterKey", ()=>$f8caace292c4edec$export$2cad587bb603edda);
    $parcel$export(module.exports, "mapFilterToJql", ()=>$f8caace292c4edec$export$1d71dda738f608f);
    $parcel$export(module.exports, "getDefaultJql", ()=>$f8caace292c4edec$export$346d50fe8350b1d0);
    $parcel$export(module.exports, "getUrlPrefix", ()=>$f8caace292c4edec$export$821d4141d135e0d0);
    var $ebyGx = parcelRequire("ebyGx");
    var $6UAdF;
    var $2s5Ei;
    const $f8caace292c4edec$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, (0, parcelRequire("2s5Ei")).Filters);
    const $f8caace292c4edec$export$1d71dda738f608f = (projectKey, filter)=>{
        if (!$f8caace292c4edec$export$2cad587bb603edda(filter)) return undefined;
        const clauses = [
            `project = "${projectKey}"`
        ];
        let order = (0, (0, parcelRequire("6UAdF")).DEFAULT_ORDER_FIELD);
        const direction = (0, (0, parcelRequire("6UAdF")).DEFAULT_SORT_DIRECTION);
        switch((0, (0, parcelRequire("2s5Ei")).Filters)[filter]){
            case (0, (0, parcelRequire("2s5Ei")).Filters).myopenissues:
                clauses.push('assignee IN (currentUser())');
                clauses.push(`statusCategory IN (${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).TO_DO}, ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).IN_PROGRESS})`);
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).reportedbyme:
                clauses.push('reporter IN (currentUser())');
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).allopenissues:
                clauses.push(`statusCategory IN (${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).TO_DO}, ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).IN_PROGRESS})`);
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).doneissues:
                clauses.push(`statusCategory = ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).DONE}`);
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).recentlyviewed:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).lastviewed;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).resolvedrecently:
                clauses.push('resolved >= -1w');
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).updatedrecently:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).allissues:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).created;
                break;
            default:
        }
        return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
    };
    const $f8caace292c4edec$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, (0, parcelRequire("6UAdF")).DEFAULT_ORDER_FIELD} ${0, (0, parcelRequire("6UAdF")).DEFAULT_SORT_DIRECTION}`;
    const $f8caace292c4edec$export$e5b4f9d05e643346 = (search, match)=>({
            ...(0, $ebyGx.parse)(search),
            ...match && match.params
        });
    const $f8caace292c4edec$export$821d4141d135e0d0 = (url)=>{
        const match = url.match(/^(.*)\/projects.*$/);
        return (match && match[1]) ?? '';
    };
});
parcelRegister("2s5Ei", function(module, exports) {
    $parcel$export(module.exports, "Filters", ()=>$ff462caa91749c6a$export$92a576f896a9bf72);
    $parcel$export(module.exports, "StatusCategoryValues", ()=>$ff462caa91749c6a$export$72d6e2acce8f36fd);
    const $ff462caa91749c6a$export$92a576f896a9bf72 = {
        myopenissues: Symbol('myopenissues'),
        reportedbyme: Symbol('reportedbyme'),
        allopenissues: Symbol('allopenissues'),
        doneissues: Symbol('doneissues'),
        recentlyviewed: Symbol('recentlyviewed'),
        resolvedrecently: Symbol('resolvedrecently'),
        updatedrecently: Symbol('updatedrecently'),
        allissues: Symbol('allissues')
    };
    const $ff462caa91749c6a$export$72d6e2acce8f36fd = {
        TO_DO: '"To Do"',
        DONE: '"Done"',
        IN_PROGRESS: '"In Progress"'
    };
});
parcelRegister("1b36n", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", ()=>$f0c33588b62c7651$export$d3efe54a881807bf);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $elyZV;
    const $f0c33588b62c7651$export$d3efe54a881807bf = (0, $dIdda.createResource)({
        type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
        getKey: ({ match: match, query: query })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return projectKey || 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            if (projectKey == null) return null;
            return (0, (0, parcelRequire("elyZV")).fetchDefaultPINFiltersNavData)(projectKey);
        },
        maxAge: 300000
    });
});
parcelRegister("elyZV", function(module, exports) {
    $parcel$export(module.exports, "fetchDefaultPINFiltersNavData", ()=>$88433d457c0f5220$export$268c1bcb44a0ddd3);
    var $eusud;
    const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
    const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
        if (projectKey == null) throw new Error('invalid project id or key');
        const result = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
        const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
        return {
            hasMyOpenIssues: filterNavIds.has('myopenissues'),
            hasReportedByMe: filterNavIds.has('reportedbyme'),
            hasAllIssues: filterNavIds.has('allissues'),
            hasAllOpenIssues: filterNavIds.has('allopenissues'),
            hasDoneIssues: filterNavIds.has('doneissues'),
            hasViewedRecently: filterNavIds.has('recentlyviewed'),
            hasCreatedRecently: filterNavIds.has('addedrecently'),
            hasResolvedRecently: filterNavIds.has('resolvedrecently'),
            hasUpdatedRecently: filterNavIds.has('updatedrecently')
        };
    };
});
parcelRegister("a3OKn", function(module, exports) {
    $parcel$export(module.exports, "sidebarProjectIssuesResource", ()=>$b491cf2963738bcf$export$be31dd7adcfd2297);
    var $ao2h1;
    var $59JDz;
    var $6YG83;
    const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, (0, parcelRequire("6YG83")).withGiraAggAnonSsrFix)((0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("59JDz")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("59JDz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bc7247f574fad09$export$2e2bcd8739ae039);
    const $6bc7247f574fad09$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "kind": "FragmentSpread",
                                    "name": "starredFiltersList_navigationAppsSidebarCommon"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "favouriteFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "filterId"
                                                    },
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isJiraFilter"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isFavourite"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jql"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isEditable"
                                                            }
                                                        ],
                                                        "type": "JiraCustomFilter"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
                "metadata": {},
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
    var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;
});
parcelRegister("1kQCU", function(module, exports) {
    $parcel$export(module.exports, "useGlobalScopeOptOutFlow", ()=>$d96a4352cc61ecaf$export$f39dd0211cb78bcf);
    $parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", ()=>$d96a4352cc61ecaf$export$f45d1a4e873cac44);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $6s1PB;
    var $co1wz;
    var $pa9q9;
    var $VILOn;
    var $7SHTM;
    var $bATyw;
    var $bVDE5;
    var $cZpsT;
    var $dIdda = parcelRequire("dIdda");
    var $aK1ba;
    var $cnynt;
    const $d96a4352cc61ecaf$export$f39dd0211cb78bcf = (href)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const redirectToGin = (0, $5uXOq.useCallback)(()=>{
            if (href) window.location.assign(href);
            else window.location.reload();
        }, [
            href
        ]);
        const { renderFeedbackDialog: renderFeedbackDialog } = (0, (0, parcelRequire("aK1ba")).default)({
            onClose: redirectToGin,
            isAdminSettingsModal: false
        });
        return (0, $5uXOq.useCallback)(async (preventDefault)=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8') || !(0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
            preventDefault && preventDefault();
            try {
                !isAnonymous && await (0, (0, parcelRequire("7SHTM")).setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
                (0, (0, parcelRequire("VILOn")).setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
                renderFeedbackDialog();
                sessionStorage.setItem('showGinOptOutFlag', 'true');
            } catch (error) {
                showFlag({
                    type: 'error',
                    title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cnynt")).default).errorOptOutTitleIssueTermRefresh : (0, (0, parcelRequire("cnynt")).default).errorOptOutTitle,
                    description: (0, (0, parcelRequire("cnynt")).default).errorOptOutDesc,
                    testId: 'issue-navigator-action-meatball-menu.ui.error-flag'
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'optOutOfNin',
                        packageName: 'jiraIssueNavigatorChangeboarding',
                        teamName: 'empanada'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    error: error
                });
            }
        }, [
            isAnonymous,
            renderFeedbackDialog,
            showFlag
        ]);
    };
    const $d96a4352cc61ecaf$export$f45d1a4e873cac44 = ()=>{
        const [localStorageData] = (0, $5uXOq.useState)((0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
        const { data: resourceData } = (0, $dIdda.useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource));
        const [{ isInitialRender: isInitialRender }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        let isNinGlobalScopeEnrolmentEnabled;
        if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
        else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
        else isNinGlobalScopeEnrolmentEnabled = resourceData;
        return [
            isNinGlobalScopeEnrolmentEnabled,
            resourceData
        ];
    };
});
parcelRegister("VILOn", function(module, exports) {
    $parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", ()=>$5dc42c779a970b72$export$55632339cd4dae9c);
    $parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", ()=>$5dc42c779a970b72$export$7b78bfe0a111cecf);
    $parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", ()=>$5dc42c779a970b72$export$82b2633cf7498c5e);
    $parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", ()=>$5dc42c779a970b72$export$458eda2352a1e223);
    var $bSSG7;
    var $dJl1T;
    const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
    const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
    const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('nin-changeboarding');
    const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
        try {
            $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
            $5dc42c779a970b72$export$34434fbbe40a8047();
        }
    };
    const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
        try {
            $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
        }
    };
});
parcelRegister("bSSG7", function(module, exports) {
    $parcel$export(module.exports, "createLocalStorageProvider", ()=>$63804f80e89e547d$export$697e65b1658f821b);
    $parcel$export(module.exports, "createLocalExpirableStorageProvider", ()=>$63804f80e89e547d$export$59acef2b3ab1df90);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $dEJQ9;
    const $63804f80e89e547d$export$697e65b1658f821b = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("dEJQ9")).makeLocalStore)()));
    const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("dEJQ9")).makeLocalExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("fNVZf", function(module, exports) {
    $parcel$export(module.exports, "plugins", ()=>$04caddce42518619$export$8b3ca321c77fdea6);
    $parcel$export(module.exports, "createStorageProvider", ()=>$04caddce42518619$export$8441605555fbd60c);
    var $fKgem = parcelRequire("fKgem");
    var $c7J1U;
    const $04caddce42518619$export$8b3ca321c77fdea6 = [
        (0, ($parcel$interopDefault($fKgem))),
        (0, (0, parcelRequire("c7J1U")).default)
    ];
    const $04caddce42518619$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);
});
parcelRegister("c7J1U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99d922a6a243a194$export$2e2bcd8739ae039);
    var $jcw0u;
    var $cuNKJ;
    function $99d922a6a243a194$var$cleanUpPlugin() {
        const self = this;
        const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, (0, parcelRequire("cuNKJ")).NAMESPACE));
        function set(superFn, key, val) {
            try {
                if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.set(key, Date.now());
                superFn();
            } catch (e) {
                if (e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'browserLocalStorageFullError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            namespace: self._namespacePrefix
                        },
                        error: e,
                        skipSentry: true
                    });
                    if (self.cleanWhenFull()) self.set(superFn, key, val);
                } else {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'storageCleanupPluginError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            isLegacyFunction: false
                        },
                        error: e
                    });
                    throw e;
                }
            }
        }
        function remove(superFn, key) {
            if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.remove(key);
            return superFn();
        }
        function getTotalCount() {
            let count = 0;
            self.each(()=>{
                count += 1;
            });
            return count;
        }
        function cleanWhenFull(superFn, minAge = (0, (0, parcelRequire("cuNKJ")).FOUR_WEEKS)) {
            const currTime = Date.now();
            const numKeysBefore = self.getTotalCount();
            self.each((_value, key)=>{
                const created = !self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE)) ? timestamps.get(key) : null;
                if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
            });
            const itemsRemovedCount = numKeysBefore - self.getTotalCount();
            if (!itemsRemovedCount && minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK) >= (0, (0, parcelRequire("cuNKJ")).ONE_WEEK)) return self.cleanWhenFull(minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK));
            return itemsRemovedCount === 0;
        }
        return {
            set: set,
            remove: remove,
            cleanWhenFull: cleanWhenFull,
            getTotalCount: getTotalCount
        };
    }
    var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;
});
parcelRegister("cuNKJ", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE", ()=>$d21613ddd27d5bbf$export$6aad947bda0f3f46);
    $parcel$export(module.exports, "ONE_WEEK", ()=>$d21613ddd27d5bbf$export$8187f416f1cc43d8);
    $parcel$export(module.exports, "FOUR_WEEKS", ()=>$d21613ddd27d5bbf$export$6e952fa7d47190cf);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$da99ebca8f453abd);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$ea28dfd9333cda2d);
    const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
    const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
    const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
    const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
    const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;
});
parcelRegister("dEJQ9", function(module, exports) {
    $parcel$export(module.exports, "makeLocalStore", ()=>$dcae70c06981fc99$export$b2631085fe8db7af);
    $parcel$export(module.exports, "makeLocalExpirableStore", ()=>$dcae70c06981fc99$export$cf816b43e73de947);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $4Zgux = parcelRequire("4Zgux");
    var $2NjNT = parcelRequire("2NjNT");
    var $fNVZf;
    const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
parcelRegister("7SHTM", function(module, exports) {
    $parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", ()=>$a1fa570fc83fd392$export$2fc59b10f256dbee);
    $parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", ()=>$a1fa570fc83fd392$export$89f09c81b642e3c7);
    var $jcw0u;
    var $eusud;
    const $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
    const $a1fa570fc83fd392$var$setGlobalScopeUserPreference = async (input)=>{
        const result = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
                variables: {
                    input: input
                }
            })
        });
        if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
            cause: result.errors?.[0]
        });
    };
    const $a1fa570fc83fd392$export$2fc59b10f256dbee = async (value)=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
            key: 'jira.user.nin.global.scope.enrolment',
            value: value ? 'nin' : 'gin'
        });
    const $a1fa570fc83fd392$export$89f09c81b642e3c7 = async ()=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
            key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
            value: false
        }).catch((error)=>(0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'resetGlobalScopeGinFlag',
                    packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                    teamName: 'empanada'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            }));
});
parcelRegister("cZpsT", function(module, exports) {
    $parcel$export(module.exports, "useIsAnonymous", ()=>$5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);
    var $9OXo1;
    const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isAnonymous;
    };
});
parcelRegister("aK1ba", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$106d1fc5065910b3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $6s1PB;
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $6jY6G;
    var $bw7Gm;
    var $4DPZY;
    var $9OXo1;
    var $g7SDw;
    const $106d1fc5065910b3$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
    const $106d1fc5065910b3$var$unknownAttributeValue = 'unknown';
    const $106d1fc5065910b3$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).LOCATION,
                value: (0, (0, parcelRequire("bw7Gm")).default)(window.location.href)
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).REFERER,
                value: document.referrer ? (0, (0, parcelRequire("bw7Gm")).default)(document.referrer) : ''
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).USER_AGENT,
                value: navigator.userAgent
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).SCREEN_RESOLUTION,
                value: `${window.screen.width} x ${window.screen.height}`
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_NAME,
                value: routeName
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_GROUP,
                value: routeGroup
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: isProjectSimplified.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                value: isSiteAdmin.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).PROJECT_TYPE,
                value: projectType
            },
            {
                id: 'cloud-id',
                value: cloudId
            }
        ];
    const $106d1fc5065910b3$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const titleDetails = isAdminSettingsModal ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).titleDetailsAdminIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).titleDetailsAdmin) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).titleDetailsUserIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).titleDetailsUser);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, titleDetails));
    };
    const $106d1fc5065910b3$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const [{ data: projectData }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const routeGroup = route.group ?? $106d1fc5065910b3$var$unknownAttributeValue;
        const routeName = route.name ?? $106d1fc5065910b3$var$unknownAttributeValue;
        let projectType = $106d1fc5065910b3$var$unknownAttributeValue;
        let isProjectSimplified = false;
        if (projectData && 'project' in projectData && projectData.project) {
            projectType = projectData.project.type;
            isProjectSimplified = projectData.project.isSimplified;
        }
        const renderFeedbackDialog = (0, $5uXOq.useCallback)(()=>{
            openFeedbackCollector({
                feedbackGroupId: $106d1fc5065910b3$export$3fe286306fb8ddfb,
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
                onClose: onClose,
                feedbackContext: $106d1fc5065910b3$export$b028e515f8f652e0({
                    isSiteAdmin: isSiteAdmin,
                    cloudId: cloudId,
                    routeGroup: routeGroup,
                    routeName: routeName,
                    projectType: projectType,
                    isProjectSimplified: isProjectSimplified
                }),
                feedbackTitle: formatMessage((0, (0, parcelRequire("g7SDw")).default).title),
                feedbackTitleDetails: (0, ($parcel$interopDefault($5uXOq))).createElement($106d1fc5065910b3$export$3a73a4e2115ebf73, {
                    isAdminSettingsModal: isAdminSettingsModal
                }),
                selectLabel: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).reasonTitleIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).reasonTitle),
                summaryPlaceholder: ' ',
                submitButtonLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).submitCaption),
                cancelButtonLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).cancelCaption),
                feedbackGroupLabels: {
                    empty: {
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonPlaceholder)
                    },
                    bug: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonBug)
                    },
                    comment: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonSpeed)
                    },
                    suggestion: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonOthers)
                    },
                    question: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonParity)
                    }
                }
            });
        }, [
            openFeedbackCollector,
            onClose,
            isSiteAdmin,
            cloudId,
            routeGroup,
            routeName,
            projectType,
            isProjectSimplified,
            formatMessage,
            isAdminSettingsModal
        ]);
        return {
            renderFeedbackDialog: renderFeedbackDialog
        };
    };
    var $106d1fc5065910b3$export$2e2bcd8739ae039 = $106d1fc5065910b3$var$useFeedbackDialog;
    const $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.050'
    });
});
parcelRegister("7iULw", function(module, exports) {
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", ()=>$384a8a865c8f714d$export$baea5c8192e79adc);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", ()=>$384a8a865c8f714d$export$4eda1e3a4a311d13);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", ()=>$384a8a865c8f714d$export$5fb38521eb7ad63c);
    $parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", ()=>$384a8a865c8f714d$export$345c45dd28f28a32);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", ()=>$384a8a865c8f714d$export$8962f2e618411469);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", ()=>$384a8a865c8f714d$export$7d7f2319141db3c5);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", ()=>$384a8a865c8f714d$export$4725635e6fe1907a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", ()=>$384a8a865c8f714d$export$3a50f2efd6cfd6f3);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", ()=>$384a8a865c8f714d$export$5bd148c13bb23f7a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", ()=>$384a8a865c8f714d$export$b4de0744c1fd450d);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", ()=>$384a8a865c8f714d$export$1a7c42187130faf9);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", ()=>$384a8a865c8f714d$export$e84c34a7e1dbcf78);
    $parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", ()=>$384a8a865c8f714d$export$23f6d7b16d2210c1);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", ()=>$384a8a865c8f714d$export$1b65c2053cba0686);
    $parcel$export(module.exports, "EntryKeys", ()=>$384a8a865c8f714d$export$12d01b6c311a909a);
    const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
    const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
    const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
    const $384a8a865c8f714d$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
    const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
    const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
    const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
    const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
    const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
    const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
    const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
    const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
    const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
    const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
    const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
    const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
        CLOUD_ID: 'cloud-id',
        OPT_OUT: 'Opt-out',
        REASON: 'reason',
        FEELING: 'feeling',
        IS_ADMIN: 'is-admin',
        IS_SITE_ADMIN: 'is-site-admin',
        IS_PROJECT_SETTINGS: 'is-project-settings',
        INLINE_FEEDBACK_ID: 'inlineFeedbackId',
        IS_JSD_EVALUATOR: 'is-jsd-evaluator',
        IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
        SUPPORTED_PROJECT_TYPES: 'supported-project-types',
        FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
        FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
        FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
        LOCATION: 'Location',
        PROJECT_TYPE: 'project-type',
        BOARD_TYPE: 'board-type',
        REFERER: 'Referer',
        ROUTE_GROUP: 'route-group',
        ROUTE_NAME: 'route-name',
        USER_AGENT: 'User-Agent',
        SCREEN_RESOLUTION: 'Screen Resolution',
        SOURCE: 'Source',
        SUB_PRODUCT: 'Sub-product',
        JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
        JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
        DEPLOYMENT_PROVIDERS: 'deployment-providers',
        JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
        VERSION_CONTROL_PROVIDERS: 'version-control-providers',
        DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
        CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
        SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
        INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
        IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
        FEEDBACK_GROUP_ID: 'feedback-group-id',
        EDITION: 'edition',
        ENV: 'environment',
        SMART_REPLIES: 'smart-replies'
    });
});
parcelRegister("dseDh", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$c996142feb877ddb$export$4be696be8a3bff13);
    $parcel$export(module.exports, "useFeedbackCollectorActions", ()=>$c996142feb877ddb$export$dfb2ee2d9e73fa48);
    $parcel$export(module.exports, "FeedbackActionsSubscriber", ()=>$c996142feb877ddb$export$c35dbf16ebe9df04);
    var $7JoAD = parcelRequire("7JoAD");
    const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
        isFeedbackCollectorOpen: false,
        entrypointId: undefined,
        email: undefined,
        additionalFields: undefined,
        feedbackTitle: undefined,
        feedbackContext: undefined,
        feedbackCollectorId: undefined,
        showTypeField: true,
        submitButtonLabel: undefined,
        canBeContactedLabel: undefined,
        summaryPlaceholder: undefined,
        feedbackGroupLabels: undefined,
        onClose: undefined,
        feedbackTitleDetails: undefined,
        triggerRef: undefined,
        renderCustomContent: undefined,
        customFeedbackOptions: []
    };
    const $c996142feb877ddb$export$e324594224ef24da = {
        openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
                dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
                setState({
                    ...feedbackCollectorProps,
                    isFeedbackCollectorOpen: true
                });
            },
        closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
                const { triggerRef: triggerRef } = getState();
                if (triggerRef) setTimeout(()=>triggerRef.current?.focus(), 50);
                setState({
                    isFeedbackCollectorOpen: false,
                    triggerRef: undefined
                });
            },
        resetFeedbackCollectorState: ()=>({ setState: setState })=>{
                setState({
                    ...$c996142feb877ddb$export$d4c72bab9d6cc13a
                });
            },
        updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
                setState({
                    renderCustomContent: updatedCustomRenderContent
                });
            },
        updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
                setState({
                    additionalFields: updatedAdditionalFields
                });
            }
    };
    const $c996142feb877ddb$var$Store = (0, $7JoAD.createStore)({
        name: 'feedback-collector',
        initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
        actions: $c996142feb877ddb$export$e324594224ef24da
    });
    const $c996142feb877ddb$export$4be696be8a3bff13 = (0, $7JoAD.createHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, $7JoAD.createActionsHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, $7JoAD.createSubscriber)($c996142feb877ddb$var$Store, {
        selector: null
    });
});
parcelRegister("4DPZY", function(module, exports) {
    $parcel$export(module.exports, "useContainerContext", ()=>$a65e0c39573f7437$export$c7066c2d215990cf);
    $parcel$export(module.exports, "ContainerContextSubscriber", ()=>$a65e0c39573f7437$export$5b87a78c45d5dd17);
    var $5uXOq = parcelRequire("5uXOq");
    var $7xTO3;
    var $ggg5j;
    var $dIdda = parcelRequire("dIdda");
    var $6SkQo;
    const $a65e0c39573f7437$var$useProjectContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource));
        const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getProjectContext)(data), [
            data
        ]);
        return [
            {
                data: projectContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)((0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource));
        const userContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getUserContext)(data), [
            data
        ]);
        return [
            {
                data: userContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
        const projectContext = $a65e0c39573f7437$var$useProjectContext();
        const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
        if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
        return projectContext;
    };
    const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
        const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
        return props.children(data, actions);
    };
    $a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';
});
parcelRegister("6SkQo", function(module, exports) {
    $parcel$export(module.exports, "getUserContext", ()=>$84cf60e2c9c0e289$export$114c35c2c23732ab);
    $parcel$export(module.exports, "getProjectContext", ()=>$84cf60e2c9c0e289$export$d17fffd59c7b3c60);
    var $2vSU6;
    var $bsuuc;
    const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
        const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
        return {
            contextType: 'user',
            user: {
                id: owner.id,
                name: owner.name,
                avatarUrl: owner.avatarUrl,
                profileUrl: owner.profileUrl,
                accountId: owner.accountId
            },
            scope: {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            }
        };
    };
    const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
        if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
            const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
            return {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            };
        }
        return undefined;
    };
    const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
        switch(projectType){
            case 'business':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'software':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'service_desk':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'product_discovery':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
        const project = (0, (0, parcelRequire("bsuuc")).extractData)(projectNavInfo);
        const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
        if (project) {
            const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
            if (projectType) return {
                contextType: 'project',
                project: {
                    key: project.key,
                    id: project.id,
                    name: project.name,
                    type: projectType,
                    isSimplified: project.isSimplified,
                    avatarUrl: project.avatarUrl,
                    style: (0, (0, parcelRequire("bsuuc")).getStyle)(project.isSimplified)
                },
                scope: scope
            };
        }
        return null;
    };
});
parcelRegister("g7SDw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fa18157d389278a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5fa18157d389278a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
            "defaultMessage": "Let us know why you're moving"
        },
        titleDetailsAdmin: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
            "defaultMessage": "You and your users will be able to use the old issue search temporarily."
        },
        titleDetailsUser: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
            "defaultMessage": "You'll be able to use the old issue search temporarily."
        },
        submitCaption: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
            "defaultMessage": "Send feedback"
        },
        cancelCaption: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
            "defaultMessage": "Skip"
        },
        reasonTitle: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
            "defaultMessage": "What is your reason to go back to the old issue search?"
        },
        reasonPlaceholder: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
            "defaultMessage": "Select an option"
        },
        reasonParity: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
            "defaultMessage": "Features are missing"
        },
        reasonSpeed: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
            "defaultMessage": "It's slow"
        },
        reasonBug: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
            "defaultMessage": "There's a bug"
        },
        reasonOthers: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
            "defaultMessage": "Others"
        },
        reasonQuestion: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
            "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
        },
        titleDetailsAdminIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh",
            "defaultMessage": "You and your users will be able to use the old issue search temporarily."
        },
        titleDetailsUserIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh",
            "defaultMessage": "You'll be able to use the old issue search temporarily."
        },
        reasonTitleIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh",
            "defaultMessage": "What is your reason to go back to the old issue search?"
        }
    });
    var $5fa18157d389278a$export$2e2bcd8739ae039 = $5fa18157d389278a$var$messages;
});
parcelRegister("cnynt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c37d0c1deb4d01ea$export$2e2bcd8739ae039);
    var $7VHMR;
    const $c37d0c1deb4d01ea$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorOptOutTitle: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
            "defaultMessage": "We couldn't switch to the old issue search"
        },
        errorOptOutDesc: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
            "defaultMessage": "Refresh and try again."
        },
        errorOptOutTitleIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh",
            "defaultMessage": "We couldn't switch to the old issue search"
        }
    });
    var $c37d0c1deb4d01ea$export$2e2bcd8739ae039 = $c37d0c1deb4d01ea$var$messages;
});
parcelRegister("1UnUc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iIfyN")
    ]).then(()=>parcelRequire('jABZI'));
});
parcelRegister("90rvf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("azMOH")
    ]).then(()=>parcelRequire('iUdxh'));
});
parcelRegister("l9RBL", function(module, exports) {
    $parcel$export(module.exports, "jiraHomePageRightSidePanelResource", ()=>$eed57b2562d325e4$export$9cba342d9ec5384d);
    var $ao2h1;
    var $a4BhB;
    var $jKXj9;
    const $eed57b2562d325e4$var$isBroadcastWidgetEnabled = ()=>false;
    const $eed57b2562d325e4$export$9cba342d9ec5384d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, (0, parcelRequire("jKXj9")).JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("a4BhB")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    broadcastWidgetEnabled: $eed57b2562d325e4$var$isBroadcastWidgetEnabled()
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("a4BhB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$616ef8e6ff77d43c$export$2e2bcd8739ae039);
    const $616ef8e6ff77d43c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "broadcastWidgetEnabled"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "main_rightSidePanel_RootQuery",
                "selections": [
                    {
                        "condition": "broadcastWidgetEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "main_homeBroadcastWidget_Widget"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "main_rightSidePanel_RootQuery",
                "selections": [
                    {
                        "condition": "broadcastWidgetEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "cloudId",
                                                "variableName": "cloudId"
                                            }
                                        ],
                                        "concreteType": "JiraUserBroadcastMessageConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraUserBroadcastMessages",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraUserBroadcastMessageEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraUserBroadcastMessage",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "shouldDisplay"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
                "metadata": {},
                "name": "main_rightSidePanel_RootQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $616ef8e6ff77d43c$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
    var $616ef8e6ff77d43c$export$2e2bcd8739ae039 = $616ef8e6ff77d43c$var$node;
});
parcelRegister("jKXj9", function(module, exports) {
    $parcel$export(module.exports, "RIGHT_PANEL_WIDTH", ()=>$64d3bec226f7ff92$export$750459958906793);
    $parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", ()=>$64d3bec226f7ff92$export$2eb41e47cfa429b7);
    $parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", ()=>$64d3bec226f7ff92$export$6c783d91630ece21);
    var $gwIPs;
    const $64d3bec226f7ff92$export$750459958906793 = (0, (0, parcelRequire("gwIPs")).gridSize) * 49;
    const $64d3bec226f7ff92$export$2eb41e47cfa429b7 = {
        experience: 'jiraHomeRightSidePanel',
        experienceId: undefined,
        analyticsSource: 'jira-home'
    };
    const $64d3bec226f7ff92$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';
});
parcelRegister("aILzD", function(module, exports) {
    $parcel$export(module.exports, "jiraHomeResourceWithCache", ()=>$9f71890db935ba06$export$1da15dc2d924240c);
    var $dIdda = parcelRequire("dIdda");
    const $9f71890db935ba06$export$1da15dc2d924240c = (0, $dIdda.createResource)({
        type: (0, $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2),
        getKey: ()=>'jira-home',
        getDataLoader: ()=>(parcelRequire("klVCQ")),
        maxAge: Infinity
    });
});
const $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';
parcelRegister("klVCQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7kTIJ")
    ]).then(()=>parcelRequire('fvAUD'));
});
parcelRegister("kbked", function(module, exports) {
    $parcel$export(module.exports, "jiraHomeRoute", ()=>$aa927057995152d9$export$11ebbd6d4e57759c);
    var $65Ltd;
    const $aa927057995152d9$export$11ebbd6d4e57759c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HOME),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        path: '/jira/your-work'
    };
});
parcelRegister("7sjxl", function(module, exports) {
    $parcel$export(module.exports, "YourWorkSkeleton", ()=>$8865bd588e4a0ff3$export$62cf62fa23284b71);
    $parcel$export(module.exports, "YourWorkItemListSkeleton", ()=>$8865bd588e4a0ff3$export$31cebe1052db844);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $6L7Ws = parcelRequire("6L7Ws");
    var $aN3q5 = parcelRequire("aN3q5");
    const $8865bd588e4a0ff3$export$62cf62fa23284b71 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($6L7Ws)))
        });
    const $8865bd588e4a0ff3$export$31cebe1052db844 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aN3q5))),
            containerStyles: {
                maxHeight: '30em'
            }
        });
});
parcelRegister("6L7Ws", function(module, exports) {
    module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();
});
parcelRegister("aN3q5", function(module, exports) {
    module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();
});
parcelRegister("pC8Oc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eLhUl")
    ]).then(()=>parcelRequire('jyj7M'));
});
parcelRegister("35DJb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bt202").then(()=>parcelRequire('8LbPV'));
});
parcelRegister("4zecE", function(module, exports) {
    $parcel$export(module.exports, "findAppsRoute", ()=>$75d0c5179e224132$export$e264ef643451c60a);
    $parcel$export(module.exports, "appRequestRoute", ()=>$75d0c5179e224132$export$e5429b8cad3b4991);
    $parcel$export(module.exports, "promotionsRoute", ()=>$75d0c5179e224132$export$45df65bfacbf9a2a);
    var $65Ltd;
    const $75d0c5179e224132$export$e264ef643451c60a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX),
        path: '/jira/marketplace'
    };
    const $75d0c5179e224132$export$e5429b8cad3b4991 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_APP_REQUESTS),
        path: '/jira/marketplace/manage/app-requests'
    };
    const $75d0c5179e224132$export$45df65bfacbf9a2a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_PROMOTIONS),
        path: '/jira/marketplace/manage/promotions'
    };
});
parcelRegister("azvSc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jfNVT")
    ]).then(()=>parcelRequire('lA7ML'));
});
parcelRegister("aN2bG", function(module, exports) {
    $parcel$export(module.exports, "backlogRelayResource", ()=>$41127204b5cff3a5$export$ad514b81f9e160d0);
    $parcel$export(module.exports, "conditionalBacklogRelayResource", ()=>$41127204b5cff3a5$export$4a013be7938fa775);
    var $co1wz;
    var $dXq4S;
    var $ao2h1;
    var $loNZB;
    var $gNStA;
    const $41127204b5cff3a5$export$ad514b81f9e160d0 = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $fe839261f35d1611$export$463905a04a9a75ce),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("loNZB")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    }),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-or-network'
                }
            }),
        captureErrors: true
    }));
    const $41127204b5cff3a5$export$4a013be7938fa775 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.perf.critical-backlog-with-relay'), $41127204b5cff3a5$export$ad514b81f9e160d0);
});
parcelRegister("loNZB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92280695afeb1d20$export$2e2bcd8739ae039);
    const $92280695afeb1d20$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = [
            {
                "kind": "Literal",
                "name": "state",
                "value": [
                    "ACTIVE",
                    "FUTURE"
                ]
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        }, v5 = {
            "kind": "ScalarField",
            "name": "goal"
        }, v6 = {
            "kind": "ScalarField",
            "name": "startDate"
        }, v7 = {
            "kind": "ScalarField",
            "name": "endDate"
        }, v8 = {
            "kind": "ScalarField",
            "name": "daysRemaining"
        }, v9 = {
            "kind": "ScalarField",
            "name": "key"
        }, v10 = {
            "kind": "ScalarField",
            "name": "summary"
        }, v11 = {
            "kind": "ScalarField",
            "name": "labels"
        }, v12 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v13 = {
            "kind": "ScalarField",
            "name": "category"
        }, v14 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v15 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v16 = {
            "kind": "ScalarField",
            "name": "flagged"
        }, v17 = {
            "kind": "ScalarField",
            "name": "done"
        }, v18 = {
            "kind": "ScalarField",
            "name": "parentId"
        }, v19 = {
            "kind": "ScalarField",
            "name": "storyPoints"
        }, v20 = {
            "kind": "ScalarField",
            "name": "value"
        }, v21 = {
            "kind": "ScalarField",
            "name": "valueAsText"
        }, v22 = {
            "kind": "ScalarField",
            "name": "dueDate"
        }, v23 = {
            "kind": "ScalarField",
            "name": "complete"
        }, v24 = {
            "kind": "ScalarField",
            "name": "total"
        }, v25 = {
            "kind": "ScalarField",
            "name": "fixVersionsIds"
        }, v26 = {
            "kind": "ScalarField",
            "name": "sprintState"
        }, v27 = {
            "kind": "ScalarField",
            "name": "boardIssueListKey"
        }, v28 = {
            "kind": "ScalarField",
            "name": "requestColumnMigration"
        }, v29 = {
            "kind": "ScalarField",
            "name": "rankCustomFieldId"
        }, v30 = {
            "kind": "ScalarField",
            "name": "color"
        }, v31 = {
            "kind": "ScalarField",
            "name": "permissions"
        }, v32 = {
            "kind": "ScalarField",
            "name": "hierarchyLevelType"
        }, v33 = {
            "kind": "ScalarField",
            "name": "hasRequiredFields"
        }, v34 = {
            "kind": "ScalarField",
            "name": "status"
        }, v35 = {
            "concreteType": "CurrentEstimation",
            "kind": "LinkedField",
            "name": "current",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "customFieldId"
                }
            ]
        }, v36 = {
            "kind": "ScalarField",
            "name": "statisticFieldId"
        }, v37 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v38 = {
            "kind": "ScalarField",
            "name": "defaultUnit"
        }, v39 = {
            "kind": "ScalarField",
            "name": "workingDaysPerWeek"
        }, v40 = {
            "kind": "ScalarField",
            "name": "workingHoursPerDay"
        }, v41 = {
            "kind": "ScalarField",
            "name": "defaultFormat"
        }, v42 = [
            v3,
            v4,
            v12
        ], v43 = {
            "concreteType": "SoftwareCard",
            "kind": "LinkedField",
            "name": "cards",
            "plural": true,
            "selections": [
                v3,
                v9,
                v10,
                v11,
                {
                    "concreteType": "CardType",
                    "kind": "LinkedField",
                    "name": "type",
                    "plural": false,
                    "selections": v42
                },
                {
                    "concreteType": "CardStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        v3,
                        v4,
                        v13
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v14,
                        v4,
                        v15,
                        v3
                    ]
                },
                v16,
                v17,
                v18,
                {
                    "concreteType": "Estimate",
                    "kind": "LinkedField",
                    "name": "estimate",
                    "plural": false,
                    "selections": [
                        v19,
                        {
                            "concreteType": "OriginalEstimate",
                            "kind": "LinkedField",
                            "name": "originalEstimate",
                            "plural": false,
                            "selections": [
                                v20,
                                v21
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "CardPriority",
                    "kind": "LinkedField",
                    "name": "priority",
                    "plural": false,
                    "selections": [
                        v4,
                        v12
                    ]
                },
                v22,
                {
                    "concreteType": "ChildCardsMetadata",
                    "kind": "LinkedField",
                    "name": "childCardsMetadata",
                    "plural": false,
                    "selections": [
                        v23,
                        v24
                    ]
                },
                v25
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "aggBacklogDataQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "BoardScope",
                            "kind": "LinkedField",
                            "name": "boardScope",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "Sprint",
                                        "kind": "LinkedField",
                                        "name": "sprints",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v3,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.id"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v4,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.name"
                                            },
                                            v5,
                                            v6,
                                            v7,
                                            v8,
                                            {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v11,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.labels"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v12,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.status.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.status.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v13,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.status.category"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.status"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v14,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v15,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.done"
                                                    },
                                                    v18,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v19,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v20,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.sprints.cards.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.sprints.cards.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v22,
                                                    {
                                                        "concreteType": "ChildCardsMetadata",
                                                        "kind": "LinkedField",
                                                        "name": "childCardsMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v23,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.childCardsMetadata.complete"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v24,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.childCardsMetadata.total"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v25,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.fixVersionsIds"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v26,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.sprintState"
                                            }
                                        ],
                                        "storageKey": "sprints(state:[\"ACTIVE\",\"FUTURE\"])"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.sprints"
                                },
                                {
                                    "concreteType": "Backlog",
                                    "kind": "LinkedField",
                                    "name": "backlog",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v27,
                                            "action": "THROW",
                                            "path": "boardScope.backlog.boardIssueListKey"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v28,
                                            "action": "THROW",
                                            "path": "boardScope.backlog.requestColumnMigration"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v11,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.labels"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v12,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.status.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.status.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v13,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.status.category"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.status"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v14,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v15,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.done"
                                                    },
                                                    v18,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v19,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v20,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.backlog.cards.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.backlog.cards.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v22,
                                                    {
                                                        "concreteType": "ChildCardsMetadata",
                                                        "kind": "LinkedField",
                                                        "name": "childCardsMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v23,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.childCardsMetadata.complete"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v24,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.childCardsMetadata.total"
                                                            }
                                                        ]
                                                    },
                                                    v25
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.backlog.cards"
                                        }
                                    ]
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "SoftwareBoard",
                                        "kind": "LinkedField",
                                        "name": "board",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "SoftwareCard",
                                                    "kind": "LinkedField",
                                                    "name": "cards",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v3,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.id"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v9,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.key"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v10,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.summary"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v11,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.labels"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "CardType",
                                                                "kind": "LinkedField",
                                                                "name": "type",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v3,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.type.id"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.type.name"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v12,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.type.iconUrl"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.type"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "CardStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v3,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.status.id"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.status.name"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v13,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.status.category"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.status"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "assignee",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v14,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.assignee.accountId"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.assignee.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v15,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.assignee.picture"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v16,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.flagged"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v17,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.done"
                                                        },
                                                        v18,
                                                        {
                                                            "concreteType": "Estimate",
                                                            "kind": "LinkedField",
                                                            "name": "estimate",
                                                            "plural": false,
                                                            "selections": [
                                                                v19,
                                                                {
                                                                    "concreteType": "OriginalEstimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "originalEstimate",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v20,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.cards.estimate.originalEstimate.value"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v21,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.cards.estimate.originalEstimate.valueAsText"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "CardPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.priority.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v12,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.priority.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        v22,
                                                        {
                                                            "concreteType": "ChildCardsMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "childCardsMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v23,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.childCardsMetadata.complete"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v24,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.childCardsMetadata.total"
                                                                }
                                                            ]
                                                        },
                                                        v25
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "boardScope.board.cards"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v29,
                                                "action": "THROW",
                                                "path": "boardScope.board.rankCustomFieldId"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.board"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CardParent",
                                        "kind": "LinkedField",
                                        "name": "cardParents",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v3,
                                                "action": "THROW",
                                                "path": "boardScope.cardParents.id"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "boardScope.cardParents.key"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v10,
                                                "action": "THROW",
                                                "path": "boardScope.cardParents.summary"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CardType",
                                                    "kind": "LinkedField",
                                                    "name": "cardType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v3,
                                                            "action": "THROW",
                                                            "path": "boardScope.cardParents.cardType.id"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4,
                                                            "action": "THROW",
                                                            "path": "boardScope.cardParents.cardType.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12,
                                                            "action": "THROW",
                                                            "path": "boardScope.cardParents.cardType.iconUrl"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "boardScope.cardParents.cardType"
                                            },
                                            v30
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.cardParents"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CurrentUser",
                                        "kind": "LinkedField",
                                        "name": "currentUser",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v31,
                                                "action": "THROW",
                                                "path": "boardScope.currentUser.permissions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.currentUser"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "SoftwareProject",
                                        "kind": "LinkedField",
                                        "name": "projectLocation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v3,
                                                "action": "THROW",
                                                "path": "boardScope.projectLocation.id"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "boardScope.projectLocation.key"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v4,
                                                "action": "THROW",
                                                "path": "boardScope.projectLocation.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CardType",
                                                    "kind": "LinkedField",
                                                    "name": "cardTypes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v3,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.id"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.iconUrl"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v32,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.hierarchyLevelType"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v33,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.hasRequiredFields"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "boardScope.projectLocation.cardTypes"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.projectLocation"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "BoardFeature",
                                        "kind": "LinkedField",
                                        "name": "features",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "boardScope.features.key"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v34,
                                                "action": "THROW",
                                                "path": "boardScope.features.status"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.features"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "EstimationConfig",
                                        "kind": "LinkedField",
                                        "name": "estimation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v35,
                                                "action": "THROW",
                                                "path": "boardScope.estimation.current"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "AvailableEstimations",
                                                    "kind": "LinkedField",
                                                    "name": "available",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v36,
                                                            "action": "THROW",
                                                            "path": "boardScope.estimation.available.statisticFieldId"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "boardScope.estimation.available"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.estimation"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v37,
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "globalTimeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v38,
                                                "action": "THROW",
                                                "path": "jira.globalTimeTrackingSettings.defaultUnit"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v39,
                                                "action": "THROW",
                                                "path": "jira.globalTimeTrackingSettings.workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v40,
                                                "action": "THROW",
                                                "path": "jira.globalTimeTrackingSettings.workingHoursPerDay"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v41,
                                                "action": "THROW",
                                                "path": "jira.globalTimeTrackingSettings.defaultFormat"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.globalTimeTrackingSettings"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "aggBacklogDataQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "Sprint",
                                "kind": "LinkedField",
                                "name": "sprints",
                                "plural": true,
                                "selections": [
                                    v3,
                                    v4,
                                    v5,
                                    v6,
                                    v7,
                                    v8,
                                    v43,
                                    v26
                                ],
                                "storageKey": "sprints(state:[\"ACTIVE\",\"FUTURE\"])"
                            },
                            {
                                "concreteType": "Backlog",
                                "kind": "LinkedField",
                                "name": "backlog",
                                "plural": false,
                                "selections": [
                                    v27,
                                    v28,
                                    v43
                                ]
                            },
                            {
                                "concreteType": "SoftwareBoard",
                                "kind": "LinkedField",
                                "name": "board",
                                "plural": false,
                                "selections": [
                                    v43,
                                    v29,
                                    v3
                                ]
                            },
                            {
                                "concreteType": "CardParent",
                                "kind": "LinkedField",
                                "name": "cardParents",
                                "plural": true,
                                "selections": [
                                    v3,
                                    v9,
                                    v10,
                                    {
                                        "concreteType": "CardType",
                                        "kind": "LinkedField",
                                        "name": "cardType",
                                        "plural": false,
                                        "selections": v42
                                    },
                                    v30
                                ]
                            },
                            {
                                "concreteType": "CurrentUser",
                                "kind": "LinkedField",
                                "name": "currentUser",
                                "plural": false,
                                "selections": [
                                    v31
                                ]
                            },
                            {
                                "concreteType": "SoftwareProject",
                                "kind": "LinkedField",
                                "name": "projectLocation",
                                "plural": false,
                                "selections": [
                                    v3,
                                    v9,
                                    v4,
                                    {
                                        "concreteType": "CardType",
                                        "kind": "LinkedField",
                                        "name": "cardTypes",
                                        "plural": true,
                                        "selections": [
                                            v3,
                                            v4,
                                            v12,
                                            v32,
                                            v33
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "BoardFeature",
                                "kind": "LinkedField",
                                "name": "features",
                                "plural": true,
                                "selections": [
                                    v9,
                                    v34
                                ]
                            },
                            {
                                "concreteType": "EstimationConfig",
                                "kind": "LinkedField",
                                "name": "estimation",
                                "plural": false,
                                "selections": [
                                    v35,
                                    {
                                        "concreteType": "AvailableEstimations",
                                        "kind": "LinkedField",
                                        "name": "available",
                                        "plural": true,
                                        "selections": [
                                            v36
                                        ]
                                    }
                                ]
                            },
                            v3
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v37,
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "globalTimeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    v38,
                                    v39,
                                    v40,
                                    v41
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "f0265750b202c0ceda593f31130e4808462f54c3702123d91fff9c415016144e",
                "metadata": {},
                "name": "aggBacklogDataQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $92280695afeb1d20$var$node.hash = "5066bdc9703e345e9762320044e879c8";
    var $92280695afeb1d20$export$2e2bcd8739ae039 = $92280695afeb1d20$var$node;
});
const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';
const $fe839261f35d1611$export$463905a04a9a75ce = 'NEXTGEN_BACKLOG_RELAY';
parcelRegister("bAB30", function(module, exports) {
    $parcel$export(module.exports, "backlogResource", ()=>$d3029439c7d3b0b0$export$31d171ba71468137);
    $parcel$export(module.exports, "conditionalBacklogResource", ()=>$d3029439c7d3b0b0$export$c77659376558c168);
    var $co1wz;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $d3029439c7d3b0b0$export$31d171ba71468137 = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, $dIdda.createResource)({
        type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("h0LF7")),
        maxAge: 3600000
    }));
    const $d3029439c7d3b0b0$export$c77659376558c168 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("co1wz")).ff)('jsw.perf.critical-backlog-with-relay'), $d3029439c7d3b0b0$export$31d171ba71468137);
});
parcelRegister("h0LF7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k5lf7").then(()=>parcelRequire('lq5RB'));
});
parcelRegister("9SRRO", function(module, exports) {
    $parcel$export(module.exports, "customFiltersResource", ()=>$87093d7252240507$export$3e390340716755de);
    var $dXq4S;
    var $ao2h1;
    var $aYacW;
    var $gNStA;
    const $87093d7252240507$export$3e390340716755de = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $fe839261f35d1611$export$faa68b3df5415bcb),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("aYacW")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            }),
        captureErrors: true
    }));
});
parcelRegister("aYacW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16318ecaa49178e6$export$2e2bcd8739ae039);
    const $16318ecaa49178e6$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "viewBacklogCustomFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "kind": "FragmentSpread",
                        "name": "customFilter_softwareFilters_CustomFilterRelay"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "viewBacklogCustomFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CustomFilter",
                                "kind": "LinkedField",
                                "name": "customFilters",
                                "plural": true,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            },
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
                "metadata": {},
                "name": "viewBacklogCustomFiltersQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $16318ecaa49178e6$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
    var $16318ecaa49178e6$export$2e2bcd8739ae039 = $16318ecaa49178e6$var$node;
});
parcelRegister("hziQo", function(module, exports) {
    $parcel$export(module.exports, "softwareBacklogRoute", ()=>$4f240af7c8d4803a$export$fb454ec14936c0ab);
    $parcel$export(module.exports, "softwareBacklogEmbedRoute", ()=>$4f240af7c8d4803a$export$bc022a39c42aba2f);
    var $65Ltd;
    const $4f240af7c8d4803a$export$fb454ec14936c0ab = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
    };
    const $4f240af7c8d4803a$export$bc022a39c42aba2f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED),
        path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
        exact: true
    };
});
parcelRegister("5qQ9I", function(module, exports) {
    $parcel$export(module.exports, "boardResource", ()=>$21d99b29ea940c83$export$286b76e0f2661cfb);
    $parcel$export(module.exports, "customFiltersResource", ()=>$21d99b29ea940c83$export$3e390340716755de);
    $parcel$export(module.exports, "boardRelayResource", ()=>$21d99b29ea940c83$export$81ac23db76b1f935);
    var $dXq4S;
    var $ao2h1;
    var $6mTNg;
    var $9fgCw;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $21d99b29ea940c83$export$286b76e0f2661cfb = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, $dIdda.createResource)({
        type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("4WcEM")),
        maxAge: 3600000
    }));
    const $21d99b29ea940c83$export$3e390340716755de = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $a00fc8fb83f2948a$export$b48bcc76a0105016),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("9fgCw")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
    const $21d99b29ea940c83$export$81ac23db76b1f935 = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $a00fc8fb83f2948a$export$5cef388780439aec),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("6mTNg")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("6mTNg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddc6b6eeb5cc2255$export$2e2bcd8739ae039);
    const $ddc6b6eeb5cc2255$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
            "metadata": {},
            "name": "boardWithRouterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $ddc6b6eeb5cc2255$export$2e2bcd8739ae039 = $ddc6b6eeb5cc2255$var$node;
});
parcelRegister("9fgCw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59a4f75157ae0306$export$2e2bcd8739ae039);
    const $59a4f75157ae0306$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
            "metadata": {},
            "name": "viewBoardCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $59a4f75157ae0306$export$2e2bcd8739ae039 = $59a4f75157ae0306$var$node;
});
const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
parcelRegister("4WcEM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jxTcV").then(()=>parcelRequire('11pNz'));
});
parcelRegister("2gnjX", function(module, exports) {
    $parcel$export(module.exports, "softwareBoardRoute", ()=>$3dfae82cef4e3065$export$9ae2c0a566d4e0f6);
    $parcel$export(module.exports, "softwareBoardEmbedRoute", ()=>$3dfae82cef4e3065$export$f55626b64e3fcb4f);
    var $65Ltd;
    const $3dfae82cef4e3065$export$9ae2c0a566d4e0f6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        exact: true,
        path: '/jira/software/projects/:projectKey/boards/:boardId'
    };
    const $3dfae82cef4e3065$export$f55626b64e3fcb4f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS_EMBED),
        exact: true,
        path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
    };
});
parcelRegister("6awMq", function(module, exports) {
    $parcel$export(module.exports, "NextGenBoardSkeleton", ()=>$65aec8795a513038$export$25a9d0fbcb127c90);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $d69qo = parcelRequire("d69qo");
    const $65aec8795a513038$var$customCssStyles = null;
    const $65aec8795a513038$export$25a9d0fbcb127c90 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($d69qo))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        });
});
parcelRegister("d69qo", function(module, exports) {
    module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();
});
parcelRegister("ifLyg", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorRelayResource", ()=>$4dcf5ef0b4493f61$export$b4096f516fb93159);
    $parcel$export(module.exports, "issueNavigatorFilterRelayResource", ()=>$4dcf5ef0b4493f61$export$44ca3a0b25f38d83);
    var $8Uumt = parcelRequire("8Uumt");
    var $9Nvh7;
    var $6UAdF;
    var $dXq4S;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $kvekU;
    var $hTvlq;
    var $dIdda = parcelRequire("dIdda");
    var $eqdHS;
    var $bS4S3;
    const $4dcf5ef0b4493f61$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY = 'REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY';
    const $4dcf5ef0b4493f61$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_RELAY = 'REQUEST_TAB_ISSUE_NAVIGATOR_RELAY';
    const $4dcf5ef0b4493f61$export$b4096f516fb93159 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${$4dcf5ef0b4493f61$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_RELAY}`,
        getKey: ()=>'request-tab-issue-navigator-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            let projectKey = '';
            try {
                const response = await (0, (0, parcelRequire("bS4S3")).getLatestJSMProjectRequest)();
                projectKey = response?.values?.[0]?.key;
            } catch (error) {
                console.log(error);
            }
            const { issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, (0, parcelRequire("eqdHS")).getParams)(routerContext, projectKey);
            const jqlOrFilterId = (0, (0, parcelRequire("eqdHS")).getJqlOrFilterId)(projectKey, defaultJql, jqlParam, filter);
            const maxIssuesPerPage = (0, (0, parcelRequire("6UAdF")).getMaxIssuesPerPage)();
            const variables = {
                cloudId: tenantContext.cloudId,
                first: issueKey == null ? maxIssuesPerPage : null,
                issueSearchInput: jqlOrFilterId,
                namespace: (0, (0, parcelRequire("6UAdF")).ISSUE_SEARCH_NAMESPACE),
                after: null,
                options: {
                    issueKey: issueKey
                },
                fieldSetIds: [],
                shouldQueryFieldSetsById: false,
                viewId: (0, (0, parcelRequire("6UAdF")).LIST_VIEW_ID),
                amountOfColumns: (0, (0, parcelRequire("6UAdF")).MAX_AMOUNT_OF_COLUMNS),
                atlassianIntelligenceProductFeature: (0, (0, parcelRequire("6UAdF")).NATURAL_LANGUAGE_TO_JQL)
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("hTvlq")).default), variables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
    const $4dcf5ef0b4493f61$export$44ca3a0b25f38d83 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${$4dcf5ef0b4493f61$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY}`,
        getKey: ()=>'request-tab-issue-navigator-filter-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            let projectKey = '';
            try {
                const response = await (0, (0, parcelRequire("bS4S3")).getLatestJSMProjectRequest)();
                projectKey = response?.values?.[0]?.key;
            } catch (error) {
                console.log(error);
            }
            const { filter: filter } = (0, (0, parcelRequire("eqdHS")).getParams)(routerContext, projectKey);
            const includeFilter = Boolean(filter) && (0, (0, parcelRequire("9Nvh7")).isFilterId)(filter);
            const variables = {
                includeFilter: includeFilter,
                filterAri: includeFilter ? (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'filter',
                    resourceId: filter,
                    activationId: tenantContext.activationId
                }) : ''
            };
            const options = {
                fetchPolicy: includeFilter ? 'network-only' : 'store-only'
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("kvekU")).default), variables, options);
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
});
parcelRegister("eqdHS", function(module, exports) {
    $parcel$export(module.exports, "getParams", ()=>$f6e98a15759e1b83$export$ec161d740909e39d);
    $parcel$export(module.exports, "getJqlOrFilterId", ()=>$f6e98a15759e1b83$export$b968a035fc2aa57b);
    var $9Nvh7;
    var $g5X3G;
    var $8zzKy;
    const $f6e98a15759e1b83$export$ec161d740909e39d = ({ match: { params: params }, query: query }, projectKey)=>{
        const { issueKey: issueKey } = params;
        const { filter: filter, jql: jql } = query;
        const defaultJql = (0, (0, parcelRequire("8zzKy")).getDefaultJql)((0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey));
        return {
            page: 1,
            jql: jql,
            issueKey: issueKey,
            projectKey: projectKey,
            filter: filter,
            defaultJql: defaultJql
        };
    };
    const $f6e98a15759e1b83$export$b968a035fc2aa57b = (projectKey, defaultJql, jqlParam, filter)=>{
        if (typeof jqlParam === 'string') return {
            jql: jqlParam
        };
        if (typeof filter === 'string' && filter !== '') {
            if ((0, (0, parcelRequire("9Nvh7")).isFilterId)(filter)) return {
                filterId: filter
            };
            const filterJql = (0, (0, parcelRequire("8zzKy")).mapFilterToJql)(projectKey, filter);
            if (filterJql !== undefined) return {
                jql: filterJql
            };
        }
        return {
            jql: defaultJql
        };
    };
});
parcelRegister("bS4S3", function(module, exports) {
    $parcel$export(module.exports, "getLatestJSMProjectRequest", ()=>$7fc07189608a8a75$export$9cbf5320d7abb785);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $eusud;
    const $7fc07189608a8a75$export$9cbf5320d7abb785 = async ()=>{
        try {
            const queryParams = (0, ($parcel$interopDefault($ebyGx))).stringify({
                maxResults: '1',
                orderBy: 'lastIssueUpdatedTime',
                typeKey: 'service_desk'
            });
            const response = await (0, (0, parcelRequire("eusud")).performGetRequestWithRetry)(`/rest/api/3/project/search?${queryParams}`);
            return response;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getLatestJSMProjectRequest',
                    packageName: 'jiraRouterResourcesSoftwareRequests'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("fuWlC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("giGBa")
    ]).then(()=>parcelRequire('enu17'));
});
parcelRegister("jsFU4", function(module, exports) {
    $parcel$export(module.exports, "nextGenRoadmapResource", ()=>$0b5ed5206b5a609e$export$2750f87d68dfb02a);
    var $dIdda = parcelRequire("dIdda");
    const $0b5ed5206b5a609e$export$2750f87d68dfb02a = (0, $dIdda.createResource)({
        type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("O4yt4")),
        maxAge: 3600000,
        isBrowserOnly: true
    });
});
parcelRegister("O4yt4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8Fxs8").then(()=>parcelRequire('d0ZST'));
});
parcelRegister("gFf95", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7pA40")
    ]).then(()=>parcelRequire('9ImcE'));
});
parcelRegister("kt0pG", function(module, exports) {
    $parcel$export(module.exports, "versionDetailsRelayResourceCustom", ()=>$57dfad429d4f47cb$export$c56c5b19da4d0fd1);
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $dXq4S;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $dvgjB;
    var $kfztd;
    var $20fNh;
    var $9NiTW;
    var $dIdda = parcelRequire("dIdda");
    const $57dfad429d4f47cb$export$c56c5b19da4d0fd1 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $afc34106ac722f11$export$9fe575a15a87a796)}`,
        getKey: ({ match: match })=>{
            const { versionId: versionId } = match.params;
            const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
            return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { versionId: versionId } = match.params;
            const { filters: filters, sortBy: sortBy } = (0, (0, parcelRequire("20fNh")).toVersionIssuesGraphQLVariables)(query);
            const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
            const variables = {
                cloudAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: tenantContext.cloudId
                }),
                versionAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'version/activation',
                    resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
                }),
                sortBy: sortBy,
                filters: filters,
                skip: !(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
                isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)(),
                isIssueSummarisedDeploymentsMigratedToAgs: (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                shouldIncludeDevOpsFieldsViaAgs: !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re')
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("dvgjB")).default), variables, {
                fetchPolicy: 'store-or-network'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
});
parcelRegister("dvgjB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ecc7304dc73fa0e$export$2e2bcd8739ae039);
    const $8ecc7304dc73fa0e$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "82741647e71f2cf9a8f9e0329b8b9192cd671f81a20c453bd333c79575469f60",
            "metadata": {},
            "name": "uiVersionDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $8ecc7304dc73fa0e$export$2e2bcd8739ae039 = $8ecc7304dc73fa0e$var$node;
});
parcelRegister("20fNh", function(module, exports) {
    $parcel$export(module.exports, "toVersionIssuesGraphQLVariables", ()=>$3e331943907e0f7c$export$72df1c7780b3e8e2);
    $parcel$export(module.exports, "useVersionIssuesGraphQLVariables", ()=>$3e331943907e0f7c$export$3d12d3ffbce57135);
    var $3hGWp;
    var $jPgXx;
    var $3dG8c;
    const $3e331943907e0f7c$var$accountIdToAriStr = (accountIds)=>{
        if (accountIds == null) return null;
        return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
    };
    const $3e331943907e0f7c$export$72df1c7780b3e8e2 = (queryParams)=>{
        const parsedQueryParams = (0, (0, parcelRequire("3dG8c")).parseQueryParams)(queryParams);
        return {
            filters: {
                searchStr: parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] ?? null,
                epicIds: parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] ?? null,
                statusCategories: parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null ? parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].filter((0, (0, parcelRequire("jPgXx")).isVersionStatusCategory)) : null,
                warningCategories: parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] ?? null,
                assigneeAccountIds: $3e331943907e0f7c$var$accountIdToAriStr(parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2])
            },
            sortBy: {
                sortByField: parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6] ?? 'CREATED',
                order: parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb] ?? 'ASC'
            }
        };
    };
    const $3e331943907e0f7c$export$3d12d3ffbce57135 = ()=>{
        const [queryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)((0, $5d187be87424268f$export$e39925d10cebc0b), (0, $5d187be87424268f$export$b98a7875ddbefaac), (0, $5d187be87424268f$export$c307007520232013), (0, $5d187be87424268f$export$2552faed9df6a2cd), (0, $5d187be87424268f$export$f78d8c81fcad32a2), (0, $5d187be87424268f$export$13d5b2891ca65cd6), (0, $5d187be87424268f$export$810a1f7ed2facfcb));
        return $3e331943907e0f7c$export$72df1c7780b3e8e2(queryParams);
    };
});
parcelRegister("3hGWp", function(module, exports) {
    $parcel$export(module.exports, "useQueryParams", ()=>$afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $hGgHi = parcelRequire("hGgHi");
    var $9xWGk = parcelRequire("9xWGk");
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
        const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $dIdda.useRouter)();
        const queryParamsRef = (0, $5uXOq.useRef)({});
        const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
            const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
                accumulator[currentValue] = query[currentValue] || undefined;
                return accumulator;
            }, {});
            if (!(0, ($parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
            return queryParamsRef.current;
        }, [
            query,
            queryParamsToWatch
        ]);
        const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
            const parsedSearch = (0, ($parcel$interopDefault($9xWGk)))({
                ...query,
                ...newQueryParams
            }, (value)=>(0, ($parcel$interopDefault($hGgHi)))(value));
            const { updateType: updateType, ...stringifyOptions } = options ?? {};
            const strSearch = (0, ($parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
            const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
            updateType === 'replace' ? replace(url) : push(url);
        }, [
            pathname,
            push,
            replace,
            query
        ]);
        return [
            parsedQueryParams,
            setQueryParams
        ];
    };
});
const $5d187be87424268f$export$e39925d10cebc0b = 'text';
const $5d187be87424268f$export$b98a7875ddbefaac = 'epics';
const $5d187be87424268f$export$c307007520232013 = 'statusCategory';
const $5d187be87424268f$export$2552faed9df6a2cd = 'warnings';
const $5d187be87424268f$export$f78d8c81fcad32a2 = 'assignee';
const $5d187be87424268f$export$13d5b2891ca65cd6 = 'sortBy';
const $5d187be87424268f$export$810a1f7ed2facfcb = 'sortOrder';
parcelRegister("jPgXx", function(module, exports) {
    $parcel$export(module.exports, "isWarningsFilterValue", ()=>$1bd9df170beee33d$export$5c25bcf27380084);
    $parcel$export(module.exports, "toWarningsFilterValue", ()=>$1bd9df170beee33d$export$ac3017cd78edb8a1);
    $parcel$export(module.exports, "isVersionStatusCategory", ()=>$1bd9df170beee33d$export$3af93bbba0d4241a);
    $parcel$export(module.exports, "isSortBy", ()=>$1bd9df170beee33d$export$472650e4cbd40b70);
    $parcel$export(module.exports, "isSortOrder", ()=>$1bd9df170beee33d$export$dfece8cb679d32a3);
    var $gULOk;
    const $1bd9df170beee33d$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
    const $1bd9df170beee33d$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($1bd9df170beee33d$export$5c25bcf27380084);
    const $1bd9df170beee33d$export$3af93bbba0d4241a = (val)=>val === (0, (0, parcelRequire("gULOk")).TODO) || val === (0, (0, parcelRequire("gULOk")).IN_PROGRESS) || val === (0, (0, parcelRequire("gULOk")).DONE);
    const $1bd9df170beee33d$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
    const $1bd9df170beee33d$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';
});
parcelRegister("gULOk", function(module, exports) {
    $parcel$export(module.exports, "UNDEFINED", ()=>$e77315bf13f8b83b$export$6db089fe7b26f5b6);
    $parcel$export(module.exports, "TODO", ()=>$e77315bf13f8b83b$export$aa456a5030160740);
    $parcel$export(module.exports, "IN_PROGRESS", ()=>$e77315bf13f8b83b$export$5a9ac66c2785cc13);
    $parcel$export(module.exports, "DONE", ()=>$e77315bf13f8b83b$export$71efb3495f6084f2);
    $parcel$export(module.exports, "STATUS_CATEGORIES", ()=>$e77315bf13f8b83b$export$d9119300f9d9a815);
    $parcel$export(module.exports, "StatusCategoryTypes", ()=>$e77315bf13f8b83b$export$5d42a08d46cffe7);
    $parcel$export(module.exports, "StatusCategoryIds", ()=>$e77315bf13f8b83b$export$3f42f49c284d5b58);
    $parcel$export(module.exports, "statusCategoryKeys", ()=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb);
    $parcel$export(module.exports, "statusCategoryForId", ()=>$e77315bf13f8b83b$export$3e9e3002956ff4fb);
    $parcel$export(module.exports, "categoryIdForStatusCategory", ()=>$e77315bf13f8b83b$export$7b16b0022aac2d46);
    $parcel$export(module.exports, "isValidStatusCategoryKey", ()=>$e77315bf13f8b83b$export$d928f247c903643a);
    const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
    const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
    const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
    const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
    const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
        $e77315bf13f8b83b$export$6db089fe7b26f5b6,
        $e77315bf13f8b83b$export$aa456a5030160740,
        $e77315bf13f8b83b$export$5a9ac66c2785cc13,
        $e77315bf13f8b83b$export$71efb3495f6084f2
    ];
    const $e77315bf13f8b83b$var$statusCategories = [
        {
            id: '1',
            statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
        },
        {
            id: '2',
            statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
        },
        {
            id: '4',
            statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
        },
        {
            id: '3',
            statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
        }
    ];
    const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
        NEW: 'new',
        INDETERMINATE: 'indeterminate',
        DONE: 'done',
        UNDEFINED: 'undefined'
    });
    const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
    });
    const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
    const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
        const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
        return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
    };
    const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
        const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
        return Number(value ? value.id : '1');
    };
    const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);
});
parcelRegister("3dG8c", function(module, exports) {
    $parcel$export(module.exports, "isAnyFilterApplied", ()=>$89761db99e7e0304$export$e6b3ec1d09429da8);
    $parcel$export(module.exports, "parseQueryParams", ()=>$89761db99e7e0304$export$67c4cee80a3410cd);
    var $g5X3G;
    var $jPgXx;
    const $89761db99e7e0304$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] != null && parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null && parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2].length > 0;
    const $89761db99e7e0304$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, (0, parcelRequire("g5X3G")).toIssueId));
    const $89761db99e7e0304$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, (0, parcelRequire("jPgXx")).isVersionStatusCategory));
    const $89761db99e7e0304$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, (0, parcelRequire("jPgXx")).toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
    const $89761db99e7e0304$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, (0, parcelRequire("g5X3G")).toAccountId)(str.trim()));
    const $89761db99e7e0304$export$67c4cee80a3410cd = (paramsRaw)=>{
        const result = {};
        result[0, $5d187be87424268f$export$e39925d10cebc0b] = paramsRaw[0, $5d187be87424268f$export$e39925d10cebc0b];
        result[0, $5d187be87424268f$export$b98a7875ddbefaac] = $89761db99e7e0304$export$2a2e94972ab280d4(paramsRaw[0, $5d187be87424268f$export$b98a7875ddbefaac]);
        result[0, $5d187be87424268f$export$c307007520232013] = $89761db99e7e0304$export$fb136b568c6d78b5(paramsRaw[0, $5d187be87424268f$export$c307007520232013]);
        result[0, $5d187be87424268f$export$2552faed9df6a2cd] = $89761db99e7e0304$export$5cb324c621ca24e8(paramsRaw[0, $5d187be87424268f$export$2552faed9df6a2cd]);
        result[0, $5d187be87424268f$export$f78d8c81fcad32a2] = $89761db99e7e0304$export$6c8eda0352c7cf5(paramsRaw[0, $5d187be87424268f$export$f78d8c81fcad32a2]);
        result[0, $5d187be87424268f$export$13d5b2891ca65cd6] = paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] && (0, (0, parcelRequire("jPgXx")).isSortBy)(paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6]) ? paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] : 'CREATED';
        result[0, $5d187be87424268f$export$810a1f7ed2facfcb] = paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] && (0, (0, parcelRequire("jPgXx")).isSortOrder)(paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb]) ? paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] : 'ASC';
        return result;
    };
});
const $afc34106ac722f11$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';
parcelRegister("aE7PK", function(module, exports) {
    $parcel$export(module.exports, "softwareVersionDetailRoute", ()=>$9ca6f67dcea727c8$export$eb3633614d0521b0);
    $parcel$export(module.exports, "softwareVersionDetailRouteEmbed", ()=>$9ca6f67dcea727c8$export$56f4dbe2a66a0830);
    var $65Ltd;
    const $9ca6f67dcea727c8$export$eb3633614d0521b0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
        path: '/projects/:projectKey/versions/:versionId/tab/:tab',
        ufoName: 'software.version-details-page'
    };
    const $9ca6f67dcea727c8$export$56f4dbe2a66a0830 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED),
        path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
        exact: true,
        ufoName: 'software.version-details-page-embed'
    };
    const $9ca6f67dcea727c8$export$f22288f2d2f1b9ea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        path: '/projects/:projectKey/versions/:versionId'
    };
    const $9ca6f67dcea727c8$export$3fc8dbcec208bca0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT),
        path: '/browse/:projectKey/fixforversion/:versionId'
    };
});
parcelRegister("hvTZA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cnMnO")
    ]).then(()=>parcelRequire('2WNCY'));
});
parcelRegister("2rEkP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("72D8w")
    ]).then(()=>parcelRequire('68CUZ'));
});
parcelRegister("4W8bb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7R4iz")
    ]).then(()=>parcelRequire('e2Cll'));
});
parcelRegister("fdH6B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("jdpLP")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gTfme")
    ]).then(()=>parcelRequire('gcELT'));
});
parcelRegister("fYO6O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8KQmP")
    ]).then(()=>parcelRequire('ejLY3'));
});
parcelRegister("eQoM0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6EDMQ").then(()=>parcelRequire('iZwfI'));
});
parcelRegister("h3sjI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iTOtj")
    ]).then(()=>parcelRequire('59dUe'));
});
parcelRegister("8xFuS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bVWcI")
    ]).then(()=>parcelRequire('dz9Sq'));
});
parcelRegister("54b5G", function(module, exports) {
    $parcel$export(module.exports, "peopleProfilesRoute", ()=>$9c4266ad8ee353d0$export$1338132568be849);
    var $65Ltd;
    const $9c4266ad8ee353d0$export$1338132568be849 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PEOPLE_PROFILES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX),
        path: '/jira/people/:subPath?'
    };
});
parcelRegister("2Qbtr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2vt1O")
    ]).then(()=>parcelRequire('3sora'));
});
parcelRegister("1Xcuw", function(module, exports) {
    $parcel$export(module.exports, "createNotificationPreferencesResource", ()=>$adb36d8860d29889$export$731980bd233a4797);
    $parcel$export(module.exports, "createContactsResource", ()=>$adb36d8860d29889$export$b9ca444b0be3df97);
    $parcel$export(module.exports, "createMuteResource", ()=>$adb36d8860d29889$export$c849cfac68bc6e80);
    $parcel$export(module.exports, "createQuietHoursResource", ()=>$adb36d8860d29889$export$efc5e8690061f9cc);
    $parcel$export(module.exports, "createForwardingRulesResource", ()=>$adb36d8860d29889$export$5314dca65b4e5888);
    var $dIdda = parcelRequire("dIdda");
    parcelRequire("jxRF2");
    var $ldKOT;
    var $4wOw1;
    const $adb36d8860d29889$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'notificationPreferencesResource',
            getKey: ()=>'notificationPreferencesResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("4wOw1")).getNotificationPreferences)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $adb36d8860d29889$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'contactsResource',
            getKey: ()=>'contactsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                const data = await (0, (0, parcelRequire("4wOw1")).getContact)();
                return data.contacts;
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $adb36d8860d29889$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'muteResource',
            getKey: ()=>'muteResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("4wOw1")).getMuteDetail)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $adb36d8860d29889$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'quietHoursResource',
            getKey: ()=>'quietHoursResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("4wOw1")).getQuietHoursDetail)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $adb36d8860d29889$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'forwardingRulesResource',
            getKey: ()=>'forwardingRulesResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("4wOw1")).getForwardingRules)().then(({ values: values })=>values);
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("4wOw1", function(module, exports) {
    $parcel$export(module.exports, "getNotificationPreferences", ()=>$05fff912cf0441ba$export$60e139c3026f21bc);
    $parcel$export(module.exports, "getContact", ()=>$05fff912cf0441ba$export$52411745da118fc8);
    $parcel$export(module.exports, "getMuteDetail", ()=>$05fff912cf0441ba$export$80a4e62998a806a6);
    $parcel$export(module.exports, "getQuietHoursDetail", ()=>$05fff912cf0441ba$export$44a94c74f358d02f);
    $parcel$export(module.exports, "getForwardingRules", ()=>$05fff912cf0441ba$export$2161af98e3d645a5);
    var $j74qU;
    const $05fff912cf0441ba$export$60e139c3026f21bc = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/notification-preferences`);
    const $05fff912cf0441ba$export$52411745da118fc8 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/contact`);
    const $05fff912cf0441ba$export$80a4e62998a806a6 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/notifications/mute`);
    const $05fff912cf0441ba$export$44a94c74f358d02f = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/quiet-hours/details`);
    const $05fff912cf0441ba$export$2161af98e3d645a5 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/notifications/forwarding-rules`);
});
parcelRegister("gzRSC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("gMZ9X")
    ]).then(()=>parcelRequire('6re9h'));
});
parcelRegister("1C2yb", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$b468ccdb67523656);
    $parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$693b70d1bcef8627);
    $parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$21946ea4c58fd4c9);
    $parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$2321c59d517801c8);
    $parcel$export(module.exports, "getGeneralPersonalSettingsPath", ()=>$63706130a90445cd$export$db9e3ccc1e5e3317);
    $parcel$export(module.exports, "getNotificationsPersonalSettingsPath", ()=>$63706130a90445cd$export$64a672523a583594);
    var $co1wz;
    const $63706130a90445cd$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
    const $63706130a90445cd$export$a974f4af282a75ba = '/jira/settings/personal';
    const $63706130a90445cd$export$693b70d1bcef8627 = `${$63706130a90445cd$export$a974f4af282a75ba}/general`;
    const $63706130a90445cd$export$21946ea4c58fd4c9 = `${$63706130a90445cd$export$a974f4af282a75ba}/notifications`;
    const $63706130a90445cd$export$2321c59d517801c8 = `${$63706130a90445cd$export$a974f4af282a75ba}/alert-notifications`;
    function $63706130a90445cd$export$db9e3ccc1e5e3317() {
        return $63706130a90445cd$export$693b70d1bcef8627;
    }
    function $63706130a90445cd$export$88a45ae8c4b1c664() {
        return $63706130a90445cd$export$2321c59d517801c8;
    }
    function $63706130a90445cd$export$64a672523a583594() {
        if ((0, (0, parcelRequire("co1wz")).ff)('sea-1973-notifications-hub')) return $63706130a90445cd$export$21946ea4c58fd4c9;
        return $63706130a90445cd$export$693b70d1bcef8627;
    }
});
parcelRegister("cojyC", function(module, exports) {
    $parcel$export(module.exports, "legacyPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$dd556eb586bb36b8);
    $parcel$export(module.exports, "generalPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$7a6c9715a86f906b);
    $parcel$export(module.exports, "notificationsPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$55ab09b9d6beb8be);
    $parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$68ebdd4eccb7b383);
    $parcel$export(module.exports, "getGeneralPersonalSettingsRouteForLink", ()=>$e797a93ba9e40aac$export$cbf079e07fb96768);
    $parcel$export(module.exports, "getNotificationsPersonalSettingsRouteForLink", ()=>$e797a93ba9e40aac$export$9b4c78a3c84b549f);
    var $65Ltd;
    var $co1wz;
    var $1C2yb;
    var $3zMaf;
    const $e797a93ba9e40aac$export$dd556eb586bb36b8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS),
        path: (0, (0, parcelRequire("1C2yb")).LEGACY_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$7a6c9715a86f906b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL),
        path: (0, (0, parcelRequire("1C2yb")).GENERAL_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$55ab09b9d6beb8be = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS),
        path: (0, (0, parcelRequire("1C2yb")).NOTIFICATIONS_PERSONAL_SETTINGS_PATH),
        skeleton: (0, (0, parcelRequire("3zMaf")).PersonalSettingsNotificationsAppSkeleton)
    };
    const $e797a93ba9e40aac$export$68ebdd4eccb7b383 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS),
        path: (0, (0, parcelRequire("1C2yb")).OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$cbf079e07fb96768 = ()=>{
        return $e797a93ba9e40aac$export$7a6c9715a86f906b;
    };
    const $e797a93ba9e40aac$export$9b4c78a3c84b549f = ()=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('sea-1973-notifications-hub')) return $e797a93ba9e40aac$export$55ab09b9d6beb8be;
        return $e797a93ba9e40aac$export$7a6c9715a86f906b;
    };
});
parcelRegister("3zMaf", function(module, exports) {
    $parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", ()=>$cd52272f9c2fac90$export$b542eb2d3193b983);
    $parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", ()=>$cd52272f9c2fac90$export$d58f6bbbc1838cb2);
    $parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", ()=>$cd52272f9c2fac90$export$8cb773cb6fc17338);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gnABE;
    var $bSzQR = parcelRequire("bSzQR");
    var $D73Nc = parcelRequire("D73Nc");
    var $eVLyC = parcelRequire("eVLyC");
    var $8z1qR = parcelRequire("8z1qR");
    const $cd52272f9c2fac90$var$maxWidthCssStyles = null;
    const $cd52272f9c2fac90$var$customCssStyles = null;
    const $cd52272f9c2fac90$export$b542eb2d3193b983 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eVLyC))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f8stt _19pkidpf _2hwx1wug _otyridpf _18u01wug"
            ])
        });
    const $cd52272f9c2fac90$export$d58f6bbbc1838cb2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cd52272f9c2fac90$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bSzQR))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $cd52272f9c2fac90$export$46fc11a564484c9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cd52272f9c2fac90$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($D73Nc))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $cd52272f9c2fac90$export$8cb773cb6fc17338 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cd52272f9c2fac90$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8z1qR))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $cd52272f9c2fac90$var$SkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71ldgin _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bSzQR", function(module, exports) {
    module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();
});
parcelRegister("D73Nc", function(module, exports) {
    module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();
});
parcelRegister("eVLyC", function(module, exports) {
    module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();
});
parcelRegister("8z1qR", function(module, exports) {
    module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();
});
parcelRegister("7P45F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49af4b582b9c7470$export$2e2bcd8739ae039);
    var $jA1kf;
    var $aRLRj;
    const $49af4b582b9c7470$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = [
            v1
        ], v3 = [
            v1,
            {
                "kind": "Literal",
                "name": "first",
                "value": 50
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = [
            v4,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "xsmall"
                    }
                ]
            }
        ], v6 = [
            {
                "kind": "ScalarField",
                "name": "channel"
            },
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ], v7 = [
            v4,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "JiraNotificationChannel",
                "kind": "LinkedField",
                "name": "emailChannel",
                "plural": false,
                "selections": v6
            },
            {
                "concreteType": "JiraNotificationChannel",
                "kind": "LinkedField",
                "name": "inProductChannel",
                "plural": false,
                "selections": v6
            },
            {
                "kind": "ScalarField",
                "name": "category"
            }
        ], v8 = {
            "concreteType": "JiraNotificationPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "miscellaneousIssueEventCombined",
                    "plural": false,
                    "selections": v7
                }
            ]
        }, v9 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0
                ],
                "kind": "Fragment",
                "name": "ui_NotificationsPageAndProjectQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "JiraNotificationGlobalPreference",
                                        "kind": "LinkedField",
                                        "name": "notificationGlobalPreference",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTable_allPreferencesData"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew_allPreferencesData"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraNotificationOptions",
                                                    "kind": "LinkedField",
                                                    "name": "options",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.notificationGlobalPreference.options"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.notificationGlobalPreference"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneousissueeventscombinedtyperelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "ui_NotificationsPageAndProjectQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraNotificationProjectPreferenceConnection",
                                "kind": "LinkedField",
                                "name": "allNotificationProjectPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectNotificationPreferenceEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNotificationProjectPreferences",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": v5
                                                    },
                                                    v8,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v9
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    v9
                                ]
                            },
                            {
                                "args": v3,
                                "filters": [
                                    "cloudId"
                                ],
                                "handle": "connection",
                                "key": "projects_allNotificationProjectPreferences",
                                "kind": "LinkedHandle",
                                "name": "allNotificationProjectPreferences"
                            },
                            {
                                "args": v2,
                                "concreteType": "JiraNotificationGlobalPreference",
                                "kind": "LinkedField",
                                "name": "notificationGlobalPreference",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraNotificationOptions",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "isEmailNotificationEnabled"
                                            },
                                            v4,
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyWhenRoleAssigneeEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyWhenRoleReporterEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyOwnChangesEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "batchWindow"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "dailyBatchLocalTime"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "emailMimeType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isEmailMimeTypeEditable"
                                            }
                                        ]
                                    },
                                    v8
                                ]
                            },
                            {
                                "alias": "allJiraProjectsForModal",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "notificationConfigurationState": "DEFAULT",
                                            "sortBy": {
                                                "sortBy": "NAME"
                                            }
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 5
                                    }
                                ],
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": v5
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "53f3d60954200f154c88e73ebc6b1de039499c465fe34dd17387911de4878f3c",
                "metadata": {},
                "name": "ui_NotificationsPageAndProjectQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, (0, parcelRequire("jA1kf")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneousissueeventscombinedtyperelayprovider": (0, (0, parcelRequire("aRLRj")).default)
                }
            }
        };
    }();
    $49af4b582b9c7470$var$node.hash = "1621d2a295f8f96a16a6e0ec0a3befd7";
    var $49af4b582b9c7470$export$2e2bcd8739ae039 = $49af4b582b9c7470$var$node;
});
parcelRegister("jA1kf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$349f2b9cab96c314$export$2e2bcd8739ae039);
    var $349f2b9cab96c314$export$2e2bcd8739ae039 = {
        get () {
            return true;
        }
    };
});
parcelRegister("aRLRj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511f4f2fc3e0f0f3$export$2e2bcd8739ae039);
    var $511f4f2fc3e0f0f3$export$2e2bcd8739ae039 = {
        get () {
            return true;
        }
    };
});
parcelRegister("fSgLp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5d5n9")
    ]).then(()=>parcelRequire('4DJNq'));
});
parcelRegister("jwMPq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("64osF")
    ]).then(()=>parcelRequire('3hooO'));
});
parcelRegister("1QXuJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dsU72")
    ]).then(()=>parcelRequire('6keru'));
});
parcelRegister("9Rv37", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dsjz")
    ]).then(()=>parcelRequire('aV66n'));
});
parcelRegister("dWQF5", function(module, exports) {
    $parcel$export(module.exports, "useIsViewPermissionsEnabled", ()=>$901349e77566565e$export$a94405ffcb20c356);
    $parcel$export(module.exports, "useIsCrossProjectViewsEnabled", ()=>$901349e77566565e$export$34d097b1cd6f89c1);
    var $co1wz;
    var $efvDm;
    var $ldyPw;
    var $9OXo1;
    const $901349e77566565e$export$8aa8a7878fd61770 = ()=>{
        const { appEditions: appEditions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const jpdEdition = (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY), appEditions);
        return jpdEdition === (0, (0, parcelRequire("ldyPw")).toEdition)((0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION));
    };
    const $901349e77566565e$export$a94405ffcb20c356 = ()=>{
        const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
        return isPremium && (0, (0, parcelRequire("co1wz")).ff)('polaris.view-permissions_plaoi');
    };
    const $901349e77566565e$export$34d097b1cd6f89c1 = ()=>{
        const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
        return isPremium;
    };
});
parcelRegister("bQinH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4iOXD")
    ]).then(()=>parcelRequire('jaSwr'));
});
parcelRegister("jecZ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ZyA4")
    ]).then(()=>parcelRequire('glCkY'));
});
parcelRegister("lqC9u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("5kvjN")
    ]).then(()=>parcelRequire('2PQGe'));
});
parcelRegister("3K3ey", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6iZL1")
    ]).then(()=>parcelRequire('ab4oe'));
});
parcelRegister("2mQtY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jhjZS")
    ]).then(()=>parcelRequire('b26tT'));
});
parcelRegister("i4r4O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c1qtf")
    ]).then(()=>parcelRequire('5KpQH'));
});
parcelRegister("jrDYR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("g6LyJ")
    ]).then(()=>parcelRequire('1H43T'));
});
parcelRegister("rdcLu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cbWbk")
    ]).then(()=>parcelRequire('dxuco'));
});
parcelRegister("jkggo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("76E7u")
    ]).then(()=>parcelRequire('14xmF'));
});
parcelRegister("9yb6w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("245Fj")
    ]).then(()=>parcelRequire('c81zX'));
});
parcelRegister("Sfb3W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4vv1Q")
    ]).then(()=>parcelRequire('g4KKw'));
});
parcelRegister("ajzu3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("Z8lzP")
    ]).then(()=>parcelRequire('joBQW'));
});
parcelRegister("kWvsB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2dsVz")
    ]).then(()=>parcelRequire('glk23'));
});
parcelRegister("38BXB", function(module, exports) {
    $parcel$export(module.exports, "jsmEmailDomainsListResource", ()=>$02fee81a891a3dc1$export$8e956348e5d47a3c);
    var $dIdda = parcelRequire("dIdda");
    const $02fee81a891a3dc1$export$8e956348e5d47a3c = (0, $dIdda.createResource)({
        type: (0, $fb7ceb315fdf5327$export$2bde433b962efbdd),
        getKey: ()=>'email-domains-list',
        isBrowserOnly: true,
        getDataLoader: ()=>(parcelRequire("kAcB4"))
    });
});
const $fb7ceb315fdf5327$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';
parcelRegister("kAcB4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bY8Ab").then(()=>parcelRequire('bHzRo'));
});
parcelRegister("7CBZS", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationDetailsResource", ()=>$d8ebe0a210bfc926$export$ccda79811a15bf5);
    var $dIdda = parcelRequire("dIdda");
    const $d8ebe0a210bfc926$export$ccda79811a15bf5 = (0, $dIdda.createResource)({
        type: (0, $1b34d67fee3735c4$export$52408f1a0f23569a),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("7ouAH"))
    });
});
const $1b34d67fee3735c4$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';
parcelRegister("7ouAH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2PPIk").then(()=>parcelRequire('dXKCD'));
});
parcelRegister("6nu63", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationMembersResource", ()=>$36d00fa173b898da$export$65c7941bd3e14d00);
    var $dIdda = parcelRequire("dIdda");
    const $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS = 10000;
    const $36d00fa173b898da$export$65c7941bd3e14d00 = (0, $dIdda.createResource)({
        type: (0, $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac),
        getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
        getDataLoader: ()=>(parcelRequire("hMnTg")),
        maxAge: $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS
    });
});
const $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';
parcelRegister("hMnTg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Veo5").then(()=>parcelRequire('kx7O4'));
});
parcelRegister("esddG", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationListResource", ()=>$ad899c035903db82$export$3e38a27ad406d7f7);
    var $dIdda = parcelRequire("dIdda");
    const $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS = 10000;
    const $ad899c035903db82$export$3e38a27ad406d7f7 = (0, $dIdda.createResource)({
        type: (0, $5073c414a8292ea0$export$50de2841b08b875f),
        getKey: (routerContext)=>routerContext.query.page,
        getDataLoader: ()=>(parcelRequire("eX5Nx")),
        maxAge: $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS
    });
});
const $5073c414a8292ea0$export$27676104f3192a88 = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST_LEGACY';
const $5073c414a8292ea0$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';
parcelRegister("eX5Nx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hlkXx").then(()=>parcelRequire('v9BTs'));
});
parcelRegister("h6rJc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eZECP")
    ]).then(()=>parcelRequire('dgpeW'));
});
parcelRegister("jSPp3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1t34o")
    ]).then(()=>parcelRequire('hfcIv'));
});
parcelRegister("hwXlc", function(module, exports) {
    $parcel$export(module.exports, "productsJswConfigurationResource", ()=>$3248841597f2b624$export$b6a5741c2b47fb17);
    var $dIdda = parcelRequire("dIdda");
    const $3248841597f2b624$export$b6a5741c2b47fb17 = (0, $dIdda.createResource)({
        type: (0, $8b1aa0975152cf4f$export$73be8e1edd21e2d),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("kr4uP"))
    });
});
const $8b1aa0975152cf4f$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';
parcelRegister("kr4uP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2WYZL").then(()=>parcelRequire('bX4Lv'));
});
parcelRegister("1vQWT", function(module, exports) {
    $parcel$export(module.exports, "productsJswStorageManagementResource", ()=>$20cc0f4a1ad53cba$export$2cd668845b3478bd);
    var $dIdda = parcelRequire("dIdda");
    const $20cc0f4a1ad53cba$export$2cd668845b3478bd = (0, $dIdda.createResource)({
        type: (0, $593b84e85768ae60$export$1ac222647be3baf8),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("u9ZMa"))
    });
});
const $593b84e85768ae60$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';
parcelRegister("u9ZMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jkZvt").then(()=>parcelRequire('a5z0r'));
});
parcelRegister("6xaw5", function(module, exports) {
    $parcel$export(module.exports, "productsJswConfigurationRoute", ()=>$d216b5e2d2bdeeff$export$decdad53ba9b97af);
    $parcel$export(module.exports, "productsJswConfigurationStorageManagementRoute", ()=>$d216b5e2d2bdeeff$export$6e126b0e7eabff82);
    var $65Ltd;
    const $d216b5e2d2bdeeff$export$decdad53ba9b97af = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION),
        path: '/jira/settings/products/jira-software-configuration',
        exact: true
    };
    const $d216b5e2d2bdeeff$export$6e126b0e7eabff82 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT),
        path: '/jira/settings/products/jira-software-configuration/storage-management',
        exact: true
    };
});
parcelRegister("fW9gA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1Xl7E")
    ]).then(()=>parcelRequire('1eYnA'));
});
parcelRegister("9WQFp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gWzc8")
    ]).then(()=>parcelRequire('2i4Yq'));
});
parcelRegister("a8m8q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dw3QA")
    ]).then(()=>parcelRequire('dtDoN'));
});
parcelRegister("k5RCi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4lyh8")
    ]).then(()=>parcelRequire('28Pju'));
});
parcelRegister("xNRJ9", function(module, exports) {
    $parcel$export(module.exports, "projectsComponentsResource", ()=>$e6f1f6e8951a4819$export$557cc3eff8939b3);
    var $kbVA4;
    var $dIdda = parcelRequire("dIdda");
    const $e6f1f6e8951a4819$export$557cc3eff8939b3 = (0, $dIdda.createResource)({
        type: (0, $7f7620b307267b7d$export$ae1b86a8daeb387d),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("5qUfp")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $7f7620b307267b7d$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';
parcelRegister("5qUfp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bUZ7U").then(()=>parcelRequire('77Eyd'));
});
parcelRegister("8IENq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dRI4W")
    ]).then(()=>parcelRequire('2NjcZ'));
});
parcelRegister("kI4TI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d3O83").then(()=>parcelRequire('L9JRT'));
});
parcelRegister("5mCC5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dqRu")
    ]).then(()=>parcelRequire('8nMC7'));
});
parcelRegister("dQmaR", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsComponentsRoute", ()=>$d95fb97e443a9f50$export$79cbce13eeecd53);
    var $65Ltd;
    const $d95fb97e443a9f50$export$79cbce13eeecd53 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
        path: '/plugins/servlet/project-config/:projectKey/administer-components'
    };
});
parcelRegister("bC7QJ", function(module, exports) {
    $parcel$export(module.exports, "projectVersionsRelayResource", ()=>$d194483d3a062e97$export$7e8aa1360f86345c);
    var $8Uumt = parcelRequire("8Uumt");
    var $e8T8A;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $lqMPx;
    var $dIdda = parcelRequire("dIdda");
    const $d194483d3a062e97$export$7e8aa1360f86345c = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $92b865e141ed2a4f$export$59aa73792ad9507a)}`,
        getKey: ({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            return `project-version-query-relay-${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const variables = {
                initialLoadCount: 20,
                cloudId: tenantContext.cloudId,
                projectKey: match.params.projectKey,
                filter: (0, (0, parcelRequire("e8T8A")).transformStatusFromParam)(query[0, $6868fc0fce0c2912$export$3e8168848b996f7]),
                searchString: query[0, $6868fc0fce0c2912$export$a181206198b7f50c] || '',
                sortBy: {
                    sortByField: (0, (0, parcelRequire("e8T8A")).transformSortFieldFromParam)(query[0, $6868fc0fce0c2912$export$a3482d3a8df0e725]),
                    order: (0, (0, parcelRequire("e8T8A")).transformSortOrderFromParam)(query[0, $6868fc0fce0c2912$export$71089821f361e881])
                }
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("lqMPx")).default), variables, {
                fetchPolicy: 'store-or-network'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
});
const $6868fc0fce0c2912$export$a181206198b7f50c = 'contains';
const $6868fc0fce0c2912$export$3e8168848b996f7 = 'status';
const $6868fc0fce0c2912$export$71089821f361e881 = 'orderDirection';
const $6868fc0fce0c2912$export$a3482d3a8df0e725 = 'orderField';
const $6868fc0fce0c2912$export$3c5e605ca7ade9f2 = 'NAME';
const $6868fc0fce0c2912$export$50241fe906e4f94e = 'RELEASE_DATE';
const $6868fc0fce0c2912$export$99a467bcc22b8df9 = 'START_DATE';
const $6868fc0fce0c2912$export$d44826c816b5619b = 'DESCRIPTION';
const $6868fc0fce0c2912$export$34694f8d8b23ee2a = 'SEQUENCE';
const $6868fc0fce0c2912$export$cb638d1fae624fbf = 20;
const $6868fc0fce0c2912$export$bbcbc202f2dfa28c = 3;
const $6868fc0fce0c2912$export$b983f2cb1f658a55 = 'RELEASED';
const $6868fc0fce0c2912$export$cb459d726a8530a5 = 'UNRELEASED';
const $6868fc0fce0c2912$export$c936349447a77fe0 = 'ARCHIVED';
const $6868fc0fce0c2912$export$c5ed97509d0e2aaf = 'projectVersions';
parcelRegister("e8T8A", function(module, exports) {
    $parcel$export(module.exports, "transformStatusFromParam", ()=>$b959dd84148d7436$export$5760f9690301cdb);
    $parcel$export(module.exports, "transformStatusToParam", ()=>$b959dd84148d7436$export$46595832dd863016);
    $parcel$export(module.exports, "transformSortOrderFromParam", ()=>$b959dd84148d7436$export$1945e6d2f31e09e6);
    $parcel$export(module.exports, "transformSortFieldFromParam", ()=>$b959dd84148d7436$export$f842a0d1846d319d);
    $parcel$export(module.exports, "transformStatusToDropdownSelection", ()=>$b959dd84148d7436$export$7dad705635760cfe);
    $parcel$export(module.exports, "getUpdatedDisplayedStatuses", ()=>$b959dd84148d7436$export$ce4c948ba1d53df4);
    $parcel$export(module.exports, "getFormattedVersionDate", ()=>$b959dd84148d7436$export$5a6eeb16be7dd21d);
    var $1O7Kb;
    var $brjCS;
    const $b959dd84148d7436$export$5760f9690301cdb = (input)=>{
        switch(input){
            case 'no-filter':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            case 'all':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            default:
                {
                    const params = (input || '').split('-');
                    const result = [
                        ...params.includes('released') ? [
                            (0, (0, parcelRequire("brjCS")).RELEASED)
                        ] : [],
                        ...params.includes('unreleased') ? [
                            (0, (0, parcelRequire("brjCS")).UNRELEASED)
                        ] : [],
                        ...params.includes('archived') ? [
                            (0, (0, parcelRequire("brjCS")).ARCHIVED)
                        ] : []
                    ];
                    return result.length ? result : [
                        (0, (0, parcelRequire("brjCS")).UNRELEASED)
                    ];
                }
        }
    };
    const $b959dd84148d7436$export$46595832dd863016 = (input)=>{
        if (input) {
            if (input.length === 0) return 'no-filter';
            if (input.length > 2) return 'all';
            return [
                input.includes((0, (0, parcelRequire("brjCS")).RELEASED)) && [
                    'released'
                ],
                input.includes((0, (0, parcelRequire("brjCS")).UNRELEASED)) && [
                    'unreleased'
                ],
                input.includes((0, (0, parcelRequire("brjCS")).ARCHIVED)) && [
                    'archived'
                ]
            ].filter(Boolean).join('-');
        }
        return undefined;
    };
    const $b959dd84148d7436$export$1945e6d2f31e09e6 = (input)=>{
        switch(input){
            case 'ASC':
                return 0, $2a9e000a443b1a95$export$1dee026a19752d6b;
            case 'DESC':
                return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
            default:
                return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
        }
    };
    const $b959dd84148d7436$export$f842a0d1846d319d = (input)=>{
        switch(input){
            case 'NAME':
                return 0, $6868fc0fce0c2912$export$3c5e605ca7ade9f2;
            case 'RELEASEDATE':
                return 0, $6868fc0fce0c2912$export$50241fe906e4f94e;
            case 'STARTDATE':
                return 0, $6868fc0fce0c2912$export$99a467bcc22b8df9;
            case 'DESCRIPTION':
                return 0, $6868fc0fce0c2912$export$d44826c816b5619b;
            case 'SEQUENCE':
                return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
            default:
                return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
        }
    };
    const $b959dd84148d7436$export$7dad705635760cfe = (input)=>{
        switch(input){
            case 'no-filter':
                return [];
            case 'all':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            default:
                {
                    const params = (input || '').split('-');
                    const result = [
                        ...params.includes('released') ? [
                            (0, (0, parcelRequire("brjCS")).RELEASED)
                        ] : [],
                        ...params.includes('unreleased') ? [
                            (0, (0, parcelRequire("brjCS")).UNRELEASED)
                        ] : [],
                        ...params.includes('archived') ? [
                            (0, (0, parcelRequire("brjCS")).ARCHIVED)
                        ] : []
                    ];
                    return result.length ? result : [
                        (0, (0, parcelRequire("brjCS")).UNRELEASED)
                    ];
                }
        }
    };
    const $b959dd84148d7436$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
        if (displayedStatuses.length === (0, $6868fc0fce0c2912$export$bbcbc202f2dfa28c)) {
            if (!selectedStatuses.length) return [
                newStatus
            ];
            return displayedStatuses.filter((status)=>status !== newStatus);
        }
        return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
            ...displayedStatuses,
            newStatus
        ];
    };
    const $b959dd84148d7436$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
            timeZone: (0, (0, parcelRequire("1O7Kb")).VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        }) : '';
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("1O7Kb", function(module, exports) {
    $parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", ()=>$db4b27c65287280e$export$d54c0d576c2caef5);
    const $db4b27c65287280e$export$d54c0d576c2caef5 = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
});
parcelRegister("brjCS", function(module, exports) {
    $parcel$export(module.exports, "RELEASED", ()=>$96a1491cb0f9d4eb$export$b983f2cb1f658a55);
    $parcel$export(module.exports, "UNRELEASED", ()=>$96a1491cb0f9d4eb$export$cb459d726a8530a5);
    $parcel$export(module.exports, "ARCHIVED", ()=>$96a1491cb0f9d4eb$export$c936349447a77fe0);
    const $96a1491cb0f9d4eb$export$b983f2cb1f658a55 = 'RELEASED';
    const $96a1491cb0f9d4eb$export$cb459d726a8530a5 = 'UNRELEASED';
    const $96a1491cb0f9d4eb$export$c936349447a77fe0 = 'ARCHIVED';
    var $96a1491cb0f9d4eb$export$2e2bcd8739ae039 = [
        $96a1491cb0f9d4eb$export$b983f2cb1f658a55,
        $96a1491cb0f9d4eb$export$cb459d726a8530a5,
        $96a1491cb0f9d4eb$export$c936349447a77fe0
    ];
});
parcelRegister("lqMPx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08cc25b93689af36$export$2e2bcd8739ae039);
    const $08cc25b93689af36$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "initialLoadCount"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sortBy"
        }, v6 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v7 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "name"
        }, v9 = {
            "kind": "ScalarField",
            "name": "key"
        }, v10 = {
            "alias": "jiraProjectType",
            "kind": "ScalarField",
            "name": "projectType"
        }, v11 = {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }, v12 = {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }, v13 = {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }, v14 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v15 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v16 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v17 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v18 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v19 = [
            v11,
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "initialLoadCount"
            },
            v12,
            v13
        ], v20 = {
            "kind": "ScalarField",
            "name": "id"
        }, v21 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v22 = [
            v21
        ], v23 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": "DONE"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "uiProjectVersionsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v6,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v7,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.projectId"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v8,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.key"
                                            },
                                            v10,
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "alias": "versions",
                                                    "args": [
                                                        v11,
                                                        v12,
                                                        v13
                                                    ],
                                                    "concreteType": "JiraVersionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "__uiProject__versions_connection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v14,
                                                                v15,
                                                                {
                                                                    "concreteType": "JiraVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "extensions",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v16
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17,
                                                        v18
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.versions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    },
                    {
                        "args": v19,
                        "kind": "FragmentSpread",
                        "name": "table_projectVersions"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v1,
                    v4,
                    v5,
                    v0,
                    v3
                ],
                "kind": "Operation",
                "name": "uiProjectVersionsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v6,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v7,
                                    v8,
                                    v9,
                                    v10,
                                    {
                                        "args": v19,
                                        "concreteType": "JiraVersionConnection",
                                        "kind": "LinkedField",
                                        "name": "versions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v14,
                                                    v15,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v14,
                                                            v20,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "status"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "description"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "startDate"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "releaseDate"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "overdue"
                                                            },
                                                            {
                                                                "alias": "allIssues",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "ALL"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"ALL\")"
                                                            },
                                                            {
                                                                "alias": "doneIssues",
                                                                "args": v23,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"DONE\")"
                                                            },
                                                            {
                                                                "alias": "done",
                                                                "args": v23,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"DONE\")"
                                                            },
                                                            {
                                                                "alias": "inProgress",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "IN_PROGRESS"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                            },
                                                            {
                                                                "alias": "toDo",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "TODO"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"TODO\")"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "versionId"
                                                            },
                                                            v8,
                                                            v18
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "QueryError",
                                                "kind": "LinkedField",
                                                "name": "errors",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "extensions",
                                                        "plural": true,
                                                        "selections": [
                                                            v14,
                                                            v16
                                                        ]
                                                    }
                                                ]
                                            },
                                            v17,
                                            v18,
                                            v21
                                        ]
                                    },
                                    {
                                        "args": v19,
                                        "filters": [
                                            "filter",
                                            "searchString",
                                            "sortBy"
                                        ],
                                        "handle": "connection",
                                        "key": "uiProject__versions",
                                        "kind": "LinkedHandle",
                                        "name": "versions"
                                    },
                                    v20,
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectType"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a6e359ecda35492174250b1c105fa73cbd222dbbdae576ab9b3b84813585a559",
                "metadata": {
                    "connection": [
                        {
                            "count": "initialLoadCount",
                            "cursor": null,
                            "direction": "forward",
                            "path": [
                                "jira",
                                "jiraProjectByKey",
                                "versions"
                            ]
                        }
                    ]
                },
                "name": "uiProjectVersionsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $08cc25b93689af36$var$node.hash = "3bed4070fd244faac23cfc6a62e64f6c";
    var $08cc25b93689af36$export$2e2bcd8739ae039 = $08cc25b93689af36$var$node;
});
const $92b865e141ed2a4f$export$59aa73792ad9507a = 'PROJECT_VERSIONS';
parcelRegister("94kpz", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsVersionsRoute", ()=>$703d543a7ad60312$export$cc9450e5d7579b99);
    var $65Ltd;
    const $703d543a7ad60312$export$cc9450e5d7579b99 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
        path: '/plugins/servlet/project-config/:projectKey/administer-versions'
    };
});
parcelRegister("7J051", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("guRgf")
    ]).then(()=>parcelRequire('5E2pR'));
});
parcelRegister("4HPds", function(module, exports) {
    $parcel$export(module.exports, "projectsRedirectRoute", ()=>$0def52f3c20b06e9$export$e6bc3ea427ddafb8);
    var $65Ltd;
    const $0def52f3c20b06e9$export$e6bc3ea427ddafb8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_REDIRECT),
        path: '/projects/:projectKey',
        query: [
            'selectedItem!=(.+)'
        ],
        exact: true
    };
});
parcelRegister("4OVrg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Nk6X").then(()=>parcelRequire('8ImNC'));
});
parcelRegister("e4B7v", function(module, exports) {
    $parcel$export(module.exports, "componentFilterResource", ()=>$ff0131666c555211$export$306e389909032632);
    $parcel$export(module.exports, "useComponentFilterResource", ()=>$ff0131666c555211$export$e13868d6ab2288af);
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $ff0131666c555211$var$getDataLoader = ()=>(parcelRequire("6JIaQ"));
    const $ff0131666c555211$export$306e389909032632 = (0, $dIdda.createResource)({
        type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $ff0131666c555211$var$getDataLoader
    });
    const $ff0131666c555211$export$e13868d6ab2288af = ()=>(0, $dIdda.useResource)($ff0131666c555211$export$306e389909032632);
});
parcelRegister("6JIaQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2IGml").then(()=>parcelRequire('hXg9m'));
});
parcelRegister("7fRd9", function(module, exports) {
    $parcel$export(module.exports, "priorityFilterResource", ()=>$1ec7e880e057744a$export$ca03c5f9fc44703e);
    $parcel$export(module.exports, "usePriorityFilterResource", ()=>$1ec7e880e057744a$export$3654f46b6bb12558);
    var $4R6GH;
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $1ec7e880e057744a$var$getDataLoader = ()=>(parcelRequire("j4Bjz"));
    const $1ec7e880e057744a$export$ca03c5f9fc44703e = (0, $dIdda.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $1ec7e880e057744a$var$getDataLoader
    });
    const $1ec7e880e057744a$export$3654f46b6bb12558 = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? $1ec7e880e057744a$export$ca03c5f9fc44703e : (0, $dIdda.createResource)({
            type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
            getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
            getDataLoader: $1ec7e880e057744a$var$getDataLoader
        }));
});
parcelRegister("j4Bjz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cfFsf").then(()=>parcelRequire('ejgJG'));
});
parcelRegister("h4Vg7", function(module, exports) {
    $parcel$export(module.exports, "escalationsRoute", ()=>$d065d46729096355$export$3d91b36833b7ddb9);
    var $65Ltd;
    const $d065d46729096355$export$3d91b36833b7ddb9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
        path: '/jira/servicedesk/projects/:projectKey/escalations',
        exact: true
    };
});
parcelRegister("e9YVH", function(module, exports) {
    $parcel$export(module.exports, "APP_NAMES", ()=>$26ff993b947c317f$export$4116f3d0d9d6bed7);
    $parcel$export(module.exports, "toPackageName", ()=>$26ff993b947c317f$export$f31a652635bd75fe);
    const $26ff993b947c317f$export$4116f3d0d9d6bed7 = {
        ACCOUNTS: 'servicedesk.accounts',
        APP_DISCOVERY: 'servicedesk.app-discovery',
        ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
        AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
        AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
        AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
        BOARD: 'servicedesk.board',
        BOARD_SETTINGS: 'servicedesk.board-settings',
        CALENDAR: 'servicedesk.calendar',
        PROJECT_SUMMARY: 'servicedesk.project-summary',
        CHANGE_CALENDAR: 'servicedesk.change-calendar',
        CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
        CREATE_PROJECT: 'servicedesk.create-project',
        CSAT_CONFIG: 'servicedesk.csat-configuration',
        CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
        CONTACTS: 'servicedesk.contacts',
        CUSTOMERS: 'servicedesk.customers',
        CUSTOMER_DETAILS: 'servicedesk.customer-details',
        CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
        CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
        INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
        ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
        ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
        ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
        JOURNEYS: 'servicedesk.journeys',
        JOURNEY_CONFIG: 'servicedesk.journey-config',
        GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
        KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
        KB_CATEGORY: 'servicedesk.knowledge-base.category',
        KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
        KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
        KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
        KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
        KB_LANDING: 'servicedesk.knowledge-base.landing',
        KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
        KB_SEARCH: 'servicedesk.knowledge-base.search',
        KB_SETTINGS: 'servicedesk.knowledge.settings',
        KB_SETUP: 'servicedesk.knowledge-base.setup',
        KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
        ORGANIZATION: 'servicedesk.organization',
        ORGANIZATIONS: 'servicedesk.organizations',
        ORGANIZATION_DETAILS: 'servicedesk.organization-details',
        PORTAL_SETTINGS: 'servicedesk.portal-settings',
        QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
        QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
        QUEUES_MAIN: 'servicedesk.queues.main',
        REPORTS_CUSTOM: 'servicedesk.reports.custom',
        REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
        REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
        REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
        REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
        REPORTS_WORKLOAD: 'servicedesk.reports.workload',
        REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
        REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
        SLA_SETTINGS: 'servicedesk.sla-settings',
        VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
        VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
        VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
        VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
        VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
        VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
        VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
        PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
        CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
        UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
        LANGUAGE_SETTINGS: 'servicedesk.language-settings',
        LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
        INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
        INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
        INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
        INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
        INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
        INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
        INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
        INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
        INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
        CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
        CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
        CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
        CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
        CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
        SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
        SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
        WIDGET_SETTINGS: 'servicedesk.widget-settings'
    };
    const $26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES = {
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings'
    };
    const $26ff993b947c317f$export$f31a652635bd75fe = (appName)=>$26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES[appName];
});
parcelRegister("dEz0W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("74akO")
    ]).then(()=>parcelRequire('81cgT'));
});
parcelRegister("4P2oj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gpMCn").then(()=>parcelRequire('emSF0'));
});
parcelRegister("7yABM", function(module, exports) {
    $parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", ()=>$cbdcceb1886ba86d$export$9e59a0b3e9d74a99);
    $parcel$export(module.exports, "customerServiceProductsQueryResource", ()=>$cbdcceb1886ba86d$export$f9257217f5333b1a);
    var $ao2h1;
    var $aPLvO;
    const $cbdcceb1886ba86d$export$9e59a0b3e9d74a99 = 50;
    const $cbdcceb1886ba86d$export$f9257217f5333b1a = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("aPLvO")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    first: $cbdcceb1886ba86d$export$9e59a0b3e9d74a99
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("aPLvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06c174000e8c134e$export$2e2bcd8739ae039);
    const $06c174000e8c134e$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v3 = [
            v2
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "srcCustomerServiceProductsQuery",
                "selections": [
                    {
                        "args": [
                            v1,
                            v2
                        ],
                        "kind": "FragmentSpread",
                        "name": "productsPage_servicedeskCustomerServiceProducts"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "srcCustomerServiceProductsQuery",
                "selections": [
                    {
                        "args": [
                            v1
                        ],
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "entitlementsCount"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v3,
                                "handle": "connection",
                                "key": "customerServiceProducts_productConnections",
                                "kind": "LinkedHandle",
                                "name": "productConnections"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
                "metadata": {},
                "name": "srcCustomerServiceProductsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $06c174000e8c134e$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
    var $06c174000e8c134e$export$2e2bcd8739ae039 = $06c174000e8c134e$var$node;
});
parcelRegister("giJhw", function(module, exports) {
    $parcel$export(module.exports, "productsRoute", ()=>$1d2598756cc9eba4$export$7d9d0206a326c6b5);
    var $65Ltd;
    const $1d2598756cc9eba4$export$7d9d0206a326c6b5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
        path: '/jira/servicedesk/projects/:projectKey/products',
        exact: true
    };
});
parcelRegister("9N9XD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("itg0z")
    ]).then(()=>parcelRequire('fSKfx'));
});
parcelRegister("9P7lL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bCJgs").then(()=>parcelRequire('b0ztm'));
});
parcelRegister("9F4l4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("HYkbB")
    ]).then(()=>parcelRequire('gXCe1'));
});
parcelRegister("ldGiq", function(module, exports) {
    $parcel$export(module.exports, "adminOauthCredentialsResource", ()=>$b7e65fd0b40325af$export$870d7919c1ca4482);
    var $dIdda = parcelRequire("dIdda");
    const $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';
    const $b7e65fd0b40325af$export$870d7919c1ca4482 = (0, $dIdda.createResource)({
        type: $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("6bf0E"))
    });
});
parcelRegister("6bf0E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gaQPp").then(()=>parcelRequire('8EYbC'));
});
parcelRegister("kmNep", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1cBTL")
    ]).then(()=>parcelRequire('imW3j'));
});
parcelRegister("c4yut", function(module, exports) {
    $parcel$export(module.exports, "jswOnboardingResource", ()=>$1ebe6dd05980f4f8$export$be21a2d8a350a80);
    $parcel$export(module.exports, "useJswOnboardingResource", ()=>$1ebe6dd05980f4f8$export$83f546a45ad58d0a);
    var $dIdda = parcelRequire("dIdda");
    const $1ebe6dd05980f4f8$export$be21a2d8a350a80 = (0, $dIdda.createResource)({
        type: (0, $156934826e437e4d$export$692203fca66f4d77),
        getKey: ()=>'jsw_onboarding',
        getDataLoader: ()=>(parcelRequire("528PX"))
    });
    const $1ebe6dd05980f4f8$export$83f546a45ad58d0a = ()=>(0, $dIdda.useResource)($1ebe6dd05980f4f8$export$be21a2d8a350a80);
});
const $156934826e437e4d$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';
parcelRegister("528PX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("knzjr").then(()=>parcelRequire('4W57j'));
});
parcelRegister("3aW4r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("epspQ")
    ]).then(()=>parcelRequire('iCmWy'));
});
parcelRegister("3YmAs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lRXx5")
    ]).then(()=>parcelRequire('dN3qt'));
});
parcelRegister("8xD9Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4t5t3")
    ]).then(()=>parcelRequire('lYlbz'));
});
parcelRegister("6SBG5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eCiAS")
    ]).then(()=>parcelRequire('jL0w0'));
});
parcelRegister("anXSE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$286d76c503aa7d78$export$2e2bcd8739ae039);
    const $286d76c503aa7d78$var$applyLazyOpts = (route)=>{
        if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
            const hydratedRoute = {
                ...route,
                ...route.lazyOpts()
            };
            delete hydratedRoute.lazyOpts;
            return hydratedRoute;
        }
        return route;
    };
    var $286d76c503aa7d78$export$2e2bcd8739ae039 = $286d76c503aa7d78$var$applyLazyOpts;
});
parcelRegister("kClDI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("9xZgu")
    ]).then(()=>parcelRequire('dnrkU'));
});
parcelRegister("dmx0y", function(module, exports) {
    $parcel$export(module.exports, "systemConfigurationGeneralResource", ()=>$3e822b05b84662f2$export$b622f7400bfafd0d);
    var $dIdda = parcelRequire("dIdda");
    const $3e822b05b84662f2$export$b622f7400bfafd0d = (0, $dIdda.createResource)({
        type: (0, $3d90c62269ed88a0$export$e780b172f774b673),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("u6D6H"))
    });
});
const $3d90c62269ed88a0$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';
parcelRegister("u6D6H", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6L998").then(()=>parcelRequire('khTCh'));
});
parcelRegister("7Z4b7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3HpMo")
    ]).then(()=>parcelRequire('ktpmL'));
});
parcelRegister("hPbJ3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jH0q0")
    ]).then(()=>parcelRequire('lBo8Z'));
});
parcelRegister("kiD5R", function(module, exports) {
    $parcel$export(module.exports, "globalPermissionsResource", ()=>$896d1d986bb0ea74$export$9a5d1bc1ff678482);
    var $ao2h1;
    var $5Uo2r;
    const $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
    const $896d1d986bb0ea74$export$9a5d1bc1ff678482 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("5Uo2r")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("5Uo2r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed1cca93794a5156$export$2e2bcd8739ae039);
    const $ed1cca93794a5156$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "name"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_globalPermissionsAndGrantsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "globalPermissionsAndGrants",
                                        "args": v1,
                                        "kind": "LinkedField",
                                        "name": "getGlobalPermissionsAndGrants",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "globalPermissionsTable_globalPermissions"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "grantPermissionDialog_globalPermissions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.globalPermissionsAndGrants"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_globalPermissionsAndGrantsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "globalPermissionsAndGrants",
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "getGlobalPermissionsAndGrants",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraGlobalPermissionGrants",
                                                "kind": "LinkedField",
                                                "name": "globalPermissionGrants",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraGlobalPermission",
                                                        "kind": "LinkedField",
                                                        "name": "permission",
                                                        "plural": false,
                                                        "selections": [
                                                            v2,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "description"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "key"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isManagedByJira"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraGroup",
                                                        "kind": "LinkedField",
                                                        "name": "groups",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "groupId"
                                                            },
                                                            v2,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraGlobalPermissionGrantsList"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
                "metadata": {},
                "name": "main_globalPermissionsAndGrantsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $ed1cca93794a5156$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
    var $ed1cca93794a5156$export$2e2bcd8739ae039 = $ed1cca93794a5156$var$node;
});
parcelRegister("lvXmc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("asO3X")
    ]).then(()=>parcelRequire('csGky'));
});
parcelRegister("6oOqs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b64e685bc951c633$export$2e2bcd8739ae039);
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    var $8yNp1;
    const $b64e685bc951c633$var$issueTypeSchemeResource = (0, $dIdda.createResource)({
        type: (0, $e899d40884b470a8$export$1d678052bb5ae54d),
        getKey: ({ query: query })=>`${0, $e899d40884b470a8$export$41cf50ee50d5da20}-${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`,
        maxAge: 0,
        getData: async ({ query: query })=>(0, (0, parcelRequire("8yNp1")).getIssueTypeSchemes)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
    var $b64e685bc951c633$export$2e2bcd8739ae039 = $b64e685bc951c633$var$issueTypeSchemeResource;
});
parcelRegister("8yNp1", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeSchemes", ()=>$b3d43746aaf616dc$export$2844cac611eecaa7);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $eusud;
    var $7vF3l;
    var $bLpq9;
    const $b3d43746aaf616dc$export$2844cac611eecaa7 = async (qs)=>{
        const filter = (0, (0, parcelRequire("bLpq9")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("bLpq9")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getIssueTypesRequest',
                    packageName: (0, (0, parcelRequire("7vF3l")).PACKAGE_NAME),
                    teamName: 'morphinecake'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("7vF3l", function(module, exports) {
    $parcel$export(module.exports, "SOURCE_NAME", ()=>$72a1bf464873d379$export$a3821bc63538b210);
    $parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", ()=>$72a1bf464873d379$export$91570d508c93485d);
    $parcel$export(module.exports, "ORDER", ()=>$72a1bf464873d379$export$11e75bce9f7ea886);
    $parcel$export(module.exports, "MAX_RESULTS", ()=>$72a1bf464873d379$export$f6b2881bc1090cea);
    $parcel$export(module.exports, "defaultIssueTypeSchemesFilter", ()=>$72a1bf464873d379$export$625de46796f967ae);
    $parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", ()=>$72a1bf464873d379$export$81a0343467d0e9a9);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$72a1bf464873d379$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", ()=>$72a1bf464873d379$export$9ac56b2484c2d4e9);
    const $72a1bf464873d379$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
    const $72a1bf464873d379$export$91570d508c93485d = 'issueTypeSchemesTable';
    const $72a1bf464873d379$export$11e75bce9f7ea886 = Object.freeze({
        ASC: 'asc',
        DESC: 'desc'
    });
    const $72a1bf464873d379$export$f6b2881bc1090cea = 10;
    const $72a1bf464873d379$export$625de46796f967ae = {
        pageNumber: 1,
        pageSize: $72a1bf464873d379$export$f6b2881bc1090cea,
        expand: [
            'projects',
            'issueTypes'
        ],
        orderBy: 'name',
        sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    };
    const $72a1bf464873d379$export$52adcbea6a93900f = {
        startAt: 0,
        maxResults: $72a1bf464873d379$export$f6b2881bc1090cea,
        values: [],
        total: 0,
        isLast: true
    };
    const $72a1bf464873d379$export$81a0343467d0e9a9 = {
        startAt: 0,
        maxResults: 10,
        values: [],
        total: 0,
        isLast: true
    };
    const $72a1bf464873d379$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
    const $72a1bf464873d379$export$9ac56b2484c2d4e9 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'filterSearch'
    });
});
parcelRegister("bLpq9", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$90d499beb7e9cb88$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$90d499beb7e9cb88$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$90d499beb7e9cb88$export$fb15afa686993f11);
    var $dfl35 = parcelRequire("dfl35");
    var $aud83;
    var $7vF3l;
    var $lL6pH;
    const $90d499beb7e9cb88$export$5b9f8ed2c34be88a = (filter)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
        return {
            pageNumber: pageNumber,
            searchFilter: searchFilter,
            orderBy: orderBy
        };
    };
    const $90d499beb7e9cb88$export$bec67ef860c0d0e1 = (params)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
        const parsedNumber = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageNumber)) ? (0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter).pageNumber : (0, (0, parcelRequire("aud83")).number).parse(pageNumber);
        const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
        return {
            ...(0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter),
            pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
            searchFilter: searchFilter,
            orderBy: parsedOrderBy
        };
    };
    const $90d499beb7e9cb88$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = (0, ($parcel$interopDefault($dfl35)))({}, filter, (0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter));
        let requestParams = {
            maxResults: (0, (0, parcelRequire("7vF3l")).MAX_RESULTS),
            startAt: (fullFilter.pageNumber - 1) * (0, (0, parcelRequire("7vF3l")).MAX_RESULTS),
            orderBy: fullFilter.orderBy,
            queryString: (0, (0, parcelRequire("lL6pH")).trimSearchFilter)(fullFilter.searchFilter)
        };
        if (fullFilter.expand != null) requestParams = {
            ...requestParams,
            expand: fullFilter.expand.join(',')
        };
        return requestParams;
    };
});
parcelRegister("dfl35", function(module, exports) {
    var $g7i7g = parcelRequire("g7i7g");
    var $dGT4U = parcelRequire("dGT4U");
    var $4rDUz = parcelRequire("4rDUz");
    var $lbyKY = parcelRequire("lbyKY");
    var $9a4d00e997b9e158$var$objectProto = Object.prototype;
    var $9a4d00e997b9e158$var$hasOwnProperty = $9a4d00e997b9e158$var$objectProto.hasOwnProperty;
    var $9a4d00e997b9e158$var$defaults = $g7i7g(function(object, sources) {
        object = Object(object);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined;
        if (guard && $4rDUz(sources[0], sources[1], guard)) length = 1;
        while(++index < length){
            var source = sources[index];
            var props = $lbyKY(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while(++propsIndex < propsLength){
                var key = props[propsIndex];
                var value = object[key];
                if (value === undefined || $dGT4U(value, $9a4d00e997b9e158$var$objectProto[key]) && !$9a4d00e997b9e158$var$hasOwnProperty.call(object, key)) object[key] = source[key];
            }
        }
        return object;
    });
    module.exports = $9a4d00e997b9e158$var$defaults;
});
parcelRegister("aud83", function(module, exports) {
    $parcel$export(module.exports, "string", ()=>$b7c0843f761cef5f$export$22b082955e083ec3);
    $parcel$export(module.exports, "bool", ()=>$b7c0843f761cef5f$export$87b259aa03e3d267);
    $parcel$export(module.exports, "array", ()=>$b7c0843f761cef5f$export$2f23118c22fb2630);
    $parcel$export(module.exports, "multiple", ()=>$b7c0843f761cef5f$export$939ddaa3205df08e);
    $parcel$export(module.exports, "number", ()=>$b7c0843f761cef5f$export$98e628dec113755e);
    var $etyzk = parcelRequire("etyzk");
    const $b7c0843f761cef5f$export$22b082955e083ec3 = {
        stringify: (0, ($parcel$interopDefault($etyzk))),
        parse: (0, ($parcel$interopDefault($etyzk)))
    };
    const $b7c0843f761cef5f$export$87b259aa03e3d267 = {
        stringify: (value)=>String(value),
        parse: (value)=>{
            if (value === 'true') return true;
            if (value === 'false') return false;
            return undefined;
        }
    };
    const $b7c0843f761cef5f$export$2f23118c22fb2630 = {
        stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
        parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
    };
    const $b7c0843f761cef5f$export$939ddaa3205df08e = {
        stringify: (value)=>{
            if (!value || !Array.isArray(value)) return undefined;
            return value.length === 1 ? value[0] : value;
        },
        parse: (value)=>value && Array.isArray(value) ? value : [
                String(value)
            ]
    };
    const $b7c0843f761cef5f$export$98e628dec113755e = {
        stringify: (value)=>`${value}`,
        parse: (value)=>Number(value)
    };
});
parcelRegister("lL6pH", function(module, exports) {
    $parcel$export(module.exports, "trimSearchFilter", ()=>$8bfdbd5ef20cefa5$export$ed1722f41c23aaaf);
    const $8bfdbd5ef20cefa5$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
    const $8bfdbd5ef20cefa5$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
    const $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
const $e899d40884b470a8$export$1d678052bb5ae54d = 'ISSUE_TYPE_SCHEME_TABLE';
const $e899d40884b470a8$export$41cf50ee50d5da20 = 'ISSUE_TYPE_SCHEME_TABLE_KEY';
parcelRegister("hjmEZ", function(module, exports) {
    $parcel$export(module.exports, "issueTypesResource", ()=>$0c72c798ed369d5b$export$614e9d897c1ef917);
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    var $kXy4X;
    const $0c72c798ed369d5b$export$614e9d897c1ef917 = (0, $dIdda.createResource)({
        type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
        getKey: ()=>'issue types',
        getData: async ({ query: query })=>(0, (0, parcelRequire("kXy4X")).getIssueTypes)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
});
parcelRegister("kXy4X", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypes", ()=>$8b29c26e18cf4514$export$4cf4b24b88599615);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $7f4tk;
    var $6tPCs;
    const $8b29c26e18cf4514$export$4cf4b24b88599615 = async (qs)=>{
        const filter = (0, (0, parcelRequire("6tPCs")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("6tPCs")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/internal/3/issuetype/search?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getIssueTypesRequest',
                    packageName: (0, $f4edca700b2e0273$export$4adfbb237b083187),
                    teamName: 'morphinecake'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $f4edca700b2e0273$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';
parcelRegister("6tPCs", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$ddf87573da5ca99a$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$ddf87573da5ca99a$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toSearchFilterQsTransformer", ()=>$ddf87573da5ca99a$export$bcd1ab210547e2f5);
    $parcel$export(module.exports, "toSortFieldFilterQsTransformer", ()=>$ddf87573da5ca99a$export$c114848fa733e5c4);
    $parcel$export(module.exports, "toSortDirectionFilterQsTransformer", ()=>$ddf87573da5ca99a$export$c5d2609f8b4048d3);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$ddf87573da5ca99a$export$fb15afa686993f11);
    var $dfl35 = parcelRequire("dfl35");
    var $ebyGx = parcelRequire("ebyGx");
    var $aud83;
    var $eou7E;
    var $iPfOK;
    const $ddf87573da5ca99a$var$sortDirectionMap = {
        [(0, $2a9e000a443b1a95$export$1dee026a19752d6b).toLowerCase()]: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    };
    const $ddf87573da5ca99a$var$sortFieldMap = {
        [(0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2),
        [(0, $b140ee73c9ccd026$export$7673664bdc3ae979).toLowerCase()]: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
    };
    const $ddf87573da5ca99a$export$5b9f8ed2c34be88a = (filter)=>filter ? {
            page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
            sortDirection: (0, (0, parcelRequire("eou7E")).fieldToParam)(filter.sortDirection),
            sortField: (0, (0, parcelRequire("eou7E")).fieldToParam)(filter.sortField),
            searchFilter: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(filter.searchFilter)
        } : {};
    const $ddf87573da5ca99a$export$bec67ef860c0d0e1 = (params)=>({
            page: Math.floor(Number((0, (0, parcelRequire("aud83")).number).parse(params.page))) || undefined,
            searchFilter: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(params.searchFilter),
            sortDirection: (0, (0, parcelRequire("eou7E")).fieldFromParam)($ddf87573da5ca99a$var$sortDirectionMap, params.sortDirection),
            sortField: (0, (0, parcelRequire("eou7E")).fieldFromParam)($ddf87573da5ca99a$var$sortFieldMap, params.sortField)
        });
    const $ddf87573da5ca99a$export$bcd1ab210547e2f5 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.searchFilter ? parsed.searchFilter : '';
    };
    const $ddf87573da5ca99a$export$c114848fa733e5c4 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.sortField && parsed.sortField === 'name' ? (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2) : (0, $b140ee73c9ccd026$export$7673664bdc3ae979);
    };
    const $ddf87573da5ca99a$export$c5d2609f8b4048d3 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $2a9e000a443b1a95$export$1dee026a19752d6b) : (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65);
    };
    const $ddf87573da5ca99a$var$apiSortByMap = {
        [(0, $2a9e000a443b1a95$export$1dee026a19752d6b)]: '',
        [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)]: '-'
    };
    const $ddf87573da5ca99a$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = (0, ($parcel$interopDefault($dfl35)))({}, filter, (0, (0, parcelRequire("iPfOK")).DEFAULT_FILTER));
        const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
        return {
            maxResults: (0, (0, parcelRequire("iPfOK")).MAX_RESULTS),
            startAt: (fullFilter.page - 1) * (0, (0, parcelRequire("iPfOK")).MAX_RESULTS),
            query: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(fullFilter.searchFilter),
            orderBy: `${$ddf87573da5ca99a$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
        };
    };
});
const $b140ee73c9ccd026$export$3c5e605ca7ade9f2 = 'name';
const $b140ee73c9ccd026$export$d44826c816b5619b = 'description';
const $b140ee73c9ccd026$export$b87f371cbc396fcf = 'type';
const $b140ee73c9ccd026$export$7673664bdc3ae979 = 'hierarchy-level';
const $b140ee73c9ccd026$export$68e97ee499f7c743 = 'related-schemes';
const $b140ee73c9ccd026$export$92a1a3b7554e9387 = 'actions';
const $b140ee73c9ccd026$export$23ba45d5f8d54fed = 'level-number';
const $b140ee73c9ccd026$export$1dc71bc9f1a3749a = 'arrow';
const $b140ee73c9ccd026$export$8be5a31a21d0c723 = 'level-name';
const $b140ee73c9ccd026$export$6ad51af4785d6548 = 'jira-issue-types';
const $b140ee73c9ccd026$export$20068afc6f8c1737 = 'label-space';
parcelRegister("eou7E", function(module, exports) {
    $parcel$export(module.exports, "fieldToParam", ()=>$56517d5895d07b39$export$7341f299e7b93e87);
    $parcel$export(module.exports, "fieldFromParam", ()=>$56517d5895d07b39$export$c876451e094c0060);
    $parcel$export(module.exports, "trimSearchFilter", ()=>$56517d5895d07b39$export$ed1722f41c23aaaf);
    const $56517d5895d07b39$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
    const $56517d5895d07b39$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
    const $56517d5895d07b39$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
parcelRegister("iPfOK", function(module, exports) {
    $parcel$export(module.exports, "MAX_RESULTS", ()=>$68af332912f0171f$export$f6b2881bc1090cea);
    $parcel$export(module.exports, "DEFAULT_FILTER", ()=>$68af332912f0171f$export$6deee0e4f2fb784e);
    const $68af332912f0171f$export$f6b2881bc1090cea = 15;
    const $68af332912f0171f$export$6deee0e4f2fb784e = {
        page: 1,
        sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65),
        sortField: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
    };
});
parcelRegister("eAsaT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", ()=>$f07ed7244cb7546a$export$2c220ed11ae62e14);
    $parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", ()=>$f07ed7244cb7546a$export$6236a41e09bb858a);
    $parcel$export(module.exports, "globalSettingsIssueTypesRoute", ()=>$f07ed7244cb7546a$export$7358263a3bbb38b1);
    $parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", ()=>$f07ed7244cb7546a$export$2aba97aa663f43b3);
    var $65Ltd;
    const $f07ed7244cb7546a$export$2c220ed11ae62e14 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY),
        path: '/jira/settings/issues/issue-hierarchy'
    };
    const $f07ed7244cb7546a$export$6236a41e09bb858a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT),
        path: '/secure/PortfolioHierarchy.jspa'
    };
    const $f07ed7244cb7546a$export$7358263a3bbb38b1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES),
        path: '/jira/settings/issues/issue-types'
    };
    const $f07ed7244cb7546a$export$2aba97aa663f43b3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES),
        path: '/jira/settings/issues/issue-type-schemes'
    };
});
parcelRegister("l44QS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6rF46")
    ]).then(()=>parcelRequire('7PW51'));
});
parcelRegister("j6iNi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cfCwZ").then(()=>parcelRequire('1dsYb'));
});
parcelRegister("6pB0J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bg3Kg")
    ]).then(()=>parcelRequire('g8Lpc'));
});
parcelRegister("jKASa", function(module, exports) {
    $parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", ()=>$3f20045f00d71d00$export$73134c05a3c27bd);
    var $dIdda = parcelRequire("dIdda");
    var $8Pbm3;
    const $3f20045f00d71d00$export$73134c05a3c27bd = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8Pbm3")).RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
        getKey: ()=>'settings',
        getDataLoader: ()=>(parcelRequire("hmSnU")),
        maxAge: (0, (0, parcelRequire("8Pbm3")).ONE_DAY_IN_MILLIS)
    });
});
parcelRegister("8Pbm3", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", ()=>$bbe3b013803e2d85$export$6a2799d78d98b915);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$bbe3b013803e2d85$export$5a00268156ea5027);
    const $bbe3b013803e2d85$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
    const $bbe3b013803e2d85$export$5a00268156ea5027 = 86400000;
});
parcelRegister("hmSnU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hLF9k").then(()=>parcelRequire('7xEnC'));
});
parcelRegister("k66vx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("atQhk")
    ]).then(()=>parcelRequire('8YmLU'));
});
parcelRegister("6IgbX", function(module, exports) {
    $parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", ()=>$da9f8bab48dab68f$export$f27acbd4701f5dfe);
    var $dIdda = parcelRequire("dIdda");
    const $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS = 86400000;
    const $da9f8bab48dab68f$export$f27acbd4701f5dfe = (0, $dIdda.createResource)({
        type: (0, $700dba149c7972be$export$341f26dde034af5b),
        getKey: ()=>'affected-projects',
        getDataLoader: ()=>(parcelRequire("kaxeY")),
        maxAge: $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS
    });
});
const $700dba149c7972be$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $700dba149c7972be$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';
parcelRegister("kaxeY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3iYiJ").then(()=>parcelRequire('8QdIc'));
});
parcelRegister("cuwqc", function(module, exports) {
    $parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", ()=>$ab848c99e9d2daf7$export$b1a50ad717b4ca61);
    var $dIdda = parcelRequire("dIdda");
    const $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS = 86400000;
    const $ab848c99e9d2daf7$export$b1a50ad717b4ca61 = (0, $dIdda.createResource)({
        type: (0, $700dba149c7972be$export$eb7818fb178a80b4),
        getKey: ()=>'settings',
        getDataLoader: ()=>(parcelRequire("ikGcK")),
        maxAge: $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS
    });
});
parcelRegister("ikGcK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jTKK6").then(()=>parcelRequire('4pG8m'));
});
parcelRegister("9y0dD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("iTi1A")
    ]).then(()=>parcelRequire('faXQs'));
});
parcelRegister("d7PBt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9iFSf")
    ]).then(()=>parcelRequire('7sYTD'));
});
parcelRegister("d8FBC", function(module, exports) {
    $parcel$export(module.exports, "SidebarGlobalSettingsSystem", ()=>$6ea6596802956a9d$export$52af3150b9f64726);
    var $5uXOq = parcelRequire("5uXOq");
    var $fobme;
    var $acDan;
    var $hcbSm;
    const $6ea6596802956a9d$export$52af3150b9f64726 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarRenderStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcbSm")).Menu), null), !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarReady), {
            id: (0, (0, parcelRequire("fobme")).SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
        }));
});
parcelRegister("fobme", function(module, exports) {
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$4b9be639c0c7f77b$export$adf978edbdfaf080);
    const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
        CONNECT: 'CONNECT',
        CORE: 'CORE',
        FILTERS: 'FILTERS',
        FILTERS_GLOBAL: 'FILTERS_GLOBAL',
        FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
        GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
        GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
        GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
        GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
        GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
        JSM: 'JSM',
        JSW_CLASSIC: 'JSW_CLASSIC',
        JSW_NEXT_GEN: 'JSW_NEXT_GEN',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        EOC_OPERATIONS: 'EOC_OPERATIONS',
        POLARIS: 'POLARIS',
        USER: 'USER',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
});
parcelRegister("hcbSm", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$e261d6c9e28d2ed4$export$d9b273488cd8ce6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $kzjuk;
    var $g2EiV;
    var $9btdk;
    var $gZEU1;
    var $bWqXX;
    var $65Ltd;
    var $co1wz;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $juTur;
    var $17bH5;
    var $4OCke;
    var $3tHFY;
    var $6jY6G;
    var $eaZ4X;
    var $jMBA3;
    var $aVTmi;
    var $cip1u;
    var $8wyB3;
    var $230Wm;
    var $je2KE;
    var $iAlf2;
    var $fwlYA;
    var $9O5DC;
    var $1y2CG;
    var $71ORT;
    var $3jrxv;
    const $e261d6c9e28d2ed4$var$calculateStack = (route)=>{
        const routeName = route && route.name || '';
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE)
        ].includes(routeName)) return [
            (0, (0, parcelRequire("eaZ4X")).SECTION_ID).MIGRATE_TO_CLOUD_SITE
        ];
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE)
        ].includes(routeName)) return [
            (0, (0, parcelRequire("eaZ4X")).SECTION_ID).PERFORMANCE_AND_SCALE
        ];
        return [];
    };
    const $e261d6c9e28d2ed4$export$d9b273488cd8ce6f = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems } = (0, (0, parcelRequire("jMBA3")).useGlobalSettingsSystemConnectItems)();
        const [stack, setStack] = (0, $5uXOq.useState)($e261d6c9e28d2ed4$var$calculateStack(route));
        (0, $5uXOq.useEffect)(()=>{
            setStack($e261d6c9e28d2ed4$var$calculateStack(route));
        }, [
            route
        ]);
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        const generalConfigurationPath = navigationPath.generalConfiguration;
        if (features == null || connectItems == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const navigationContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, features.hasGeneralConfiguration && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'general-configuration'
            },
            href: generalConfigurationPath,
            selectedOn: (0, (0, parcelRequire("3jrxv")).isGeneralConfigurationSelected)
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).generalConfiguration)), features.hasDarkFeatures && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'dark-features'
            },
            href: navigationPath.darkFeatures,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).darkFeatures)), features.hasTroubleshootingAndSupportSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1y2CG")).TroubleshootingAndSupportSection), null), features.hasSecuritySection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fwlYA")).SecuritySection), null), features.hasCollectors && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'collectors'
            },
            href: navigationPath.issueCollectors,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).issueCollectors)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8wyB3")).AutomationSection), null), features.hasUserInterfaceSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71ORT")).UserInterfaceSection), null), features.hasImportExportSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("230Wm")).ImportExportSection), {
            stack: stack
        }), features.hasMailSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("je2KE")).MailSection), null), features.hasAdminHelperSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVTmi")).AdminHelperSection), null), features.hasSharedSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9O5DC")).SharedSection), null), features.hasAdvancedSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cip1u")).AdvancedSection), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3tHFY")).ConnectMenu), {
            items: connectItems,
            overrides: {
                BackMenuItem: {
                    href: '/jira/settings/system/general-configuration',
                    title: formatMessage((0, (0, parcelRequire("iAlf2")).default).systemGroup)
                }
            }
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: "global-settings/system",
            stack: stack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZEU1")).default), {
            label: formatMessage((0, (0, parcelRequire("iAlf2")).default).globalSettingsSystemSidebarLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g2EiV")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("iAlf2")).default).systemGroup))), (0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            stack: stack,
            onChange: setStack
        }, navigationContent) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kzjuk")).default), null, navigationContent)));
    };
});
parcelRegister("kzjuk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfdf97ddffeccb81$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cw1vL;
    var $j9VTE;
    var $dwoqU;
    const $dfdf97ddffeccb81$var$NavigationContent = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        const scrollbar = (0, (0, parcelRequire("cw1vL")).default)();
        if (!shouldRender) return children;
        const typedRef = ref;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: typedRef,
            css: (0, (0, parcelRequire("dwoqU")).outerContainerCSS)({
                showTopScrollIndicator: showTopScrollIndicator,
                scrollbarWidth: scrollbar.width
            }),
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: scrollbar.ref,
            css: (0, (0, parcelRequire("dwoqU")).innerContainerCSS)({
                showTopScrollIndicator: showTopScrollIndicator
            })
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("dwoqU")).containerCSS)({
                showTopScrollIndicator: showTopScrollIndicator
            })
        }, children)));
    });
    var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;
});
parcelRegister("cw1vL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a03f8a420074f68d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a03f8a420074f68d$export$2e2bcd8739ae039() {
        const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
        const elementRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!elementRef.current) return;
            const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
            if (width === scrollbarWidth) return;
            setScrollbarWidth(width);
        });
        return {
            width: scrollbarWidth,
            ref: elementRef
        };
    }
});
parcelRegister("dwoqU", function(module, exports) {
    $parcel$export(module.exports, "outerContainerCSS", ()=>$f51a063900e7895a$export$3ff462c0176a504f);
    $parcel$export(module.exports, "innerContainerCSS", ()=>$f51a063900e7895a$export$4d1aec15cfcfc2a4);
    $parcel$export(module.exports, "containerCSS", ()=>$f51a063900e7895a$export$949392aeaf7d2e3a);
    var $3RZIb;
    const $f51a063900e7895a$var$scrollIndicatorMaskZIndex = 2;
    const $f51a063900e7895a$var$scrollIndicatorZIndex = 1;
    const $f51a063900e7895a$var$scrollIndicatorHeight = 2;
    const $f51a063900e7895a$var$scrollIndicatorBorderRadius = '1px';
    const $f51a063900e7895a$var$containerPadding = 8;
    const $f51a063900e7895a$var$itemHeadingContentHeight = (0, (0, parcelRequire("3RZIb")).headingSizes).h100.lineHeight;
    const $f51a063900e7895a$var$skeletonHeadingHeight = $f51a063900e7895a$var$containerPadding;
    const $f51a063900e7895a$var$skeletonHeadingMarginOffset = 3;
    const $f51a063900e7895a$var$skeletonHeadingTopMargin = $f51a063900e7895a$var$containerPadding * 2.5 + ($f51a063900e7895a$var$itemHeadingContentHeight - $f51a063900e7895a$var$skeletonHeadingHeight) - $f51a063900e7895a$var$skeletonHeadingMarginOffset;
    const $f51a063900e7895a$var$skeletonHeadingBottomMargin = $f51a063900e7895a$var$containerPadding * 0.75 + $f51a063900e7895a$var$skeletonHeadingMarginOffset;
    const $f51a063900e7895a$export$3ff462c0176a504f = (opts)=>({
            display: 'flex',
            height: '100%',
            overflow: 'hidden',
            position: 'relative',
            '&::before': {
                content: "''",
                display: 'block',
                left: "var(--ds-space-100, 8px)",
                right: $f51a063900e7895a$var$containerPadding + opts.scrollbarWidth,
                height: $f51a063900e7895a$var$scrollIndicatorHeight,
                borderRadius: `var(--ds-border-radius-050, ${$f51a063900e7895a$var$scrollIndicatorBorderRadius})`,
                backgroundColor: `var(${0, $9521c0a2bf229f61$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`})`,
                position: 'absolute',
                zIndex: $f51a063900e7895a$var$scrollIndicatorZIndex
            },
            '&::after': {
                content: "''",
                position: 'absolute',
                display: 'block',
                borderRadius: `var(--ds-border-radius-050, ${$f51a063900e7895a$var$scrollIndicatorBorderRadius})`,
                flexShrink: 0,
                height: $f51a063900e7895a$var$scrollIndicatorHeight,
                left: "var(--ds-space-100, 8px)",
                right: $f51a063900e7895a$var$containerPadding + opts.scrollbarWidth,
                bottom: 0,
                zIndex: $f51a063900e7895a$var$scrollIndicatorZIndex,
                backgroundColor: `var(${0, $9521c0a2bf229f61$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`})`
            }
        });
    const $f51a063900e7895a$export$4d1aec15cfcfc2a4 = (opts)=>({
            display: 'flex',
            overflow: 'auto',
            width: '100%',
            position: 'relative',
            boxSizing: 'border-box',
            flexDirection: 'column',
            ...!opts.showTopScrollIndicator && {
                '&::before': {
                    borderRadius: `var(--ds-border-radius-050, ${$f51a063900e7895a$var$scrollIndicatorBorderRadius})`,
                    content: "''",
                    left: 0,
                    right: 0,
                    height: $f51a063900e7895a$var$scrollIndicatorHeight,
                    backgroundColor: `var(${0, $9521c0a2bf229f61$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`})`,
                    position: 'absolute',
                    display: 'block',
                    zIndex: $f51a063900e7895a$var$scrollIndicatorMaskZIndex
                }
            },
            '&::after': {
                borderRadius: `var(--ds-border-radius-050, ${$f51a063900e7895a$var$scrollIndicatorBorderRadius})`,
                content: "''",
                display: 'block',
                flexShrink: 0,
                height: $f51a063900e7895a$var$scrollIndicatorHeight,
                marginTop: 'auto',
                position: 'relative',
                zIndex: $f51a063900e7895a$var$scrollIndicatorMaskZIndex,
                backgroundColor: `var(${0, $9521c0a2bf229f61$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`})`
            }
        });
    const $f51a063900e7895a$export$949392aeaf7d2e3a = (opts)=>({
            marginTop: opts.showTopScrollIndicator ? $f51a063900e7895a$var$scrollIndicatorHeight : 0,
            marginLeft: "var(--ds-space-100, 8px)",
            marginRight: "var(--ds-space-100, 8px)",
            position: 'relative',
            '& [data-ds--menu--heading-item]': {
                marginBottom: "var(--ds-space-075, 6px)",
                marginTop: "var(--ds-space-200, 16px)"
            },
            '& [data-ds--menu--skeleton-heading-item]': {
                marginTop: $f51a063900e7895a$var$skeletonHeadingTopMargin,
                marginBottom: $f51a063900e7895a$var$skeletonHeadingBottomMargin
            }
        });
});
const $9521c0a2bf229f61$export$e8e7f51e033d4cb2 = '--ds-menu-seperator-color';
const $9521c0a2bf229f61$export$49e4dd5760b312e0 = '--ds-menu-scroll-indicator-color';
parcelRegister("g2EiV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8d4c6f37fa43791$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    const $f8d4c6f37fa43791$var$navigationFooterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'block',
        padding: 'space.100',
        paddingBlockStart: 'space.300'
    });
    const $f8d4c6f37fa43791$var$NavigationHeader = (props)=>{
        const { children: children } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f8d4c6f37fa43791$var$navigationFooterStyles,
            "data-navheader": true
        }, children);
    };
    var $f8d4c6f37fa43791$export$2e2bcd8739ae039 = $f8d4c6f37fa43791$var$NavigationHeader;
});
parcelRegister("9btdk", function(module, exports) {
    $parcel$export(module.exports, "ROOT_ID", ()=>$1598986e4d07c239$export$ec71a3379b43ae5c);
    $parcel$export(module.exports, "default", ()=>$1598986e4d07c239$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $35XSW;
    var $6XySk;
    var $8UO8z;
    var $9zCCP;
    var $j9VTE;
    var $cfT4M;
    function $1598986e4d07c239$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1598986e4d07c239$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
    const $1598986e4d07c239$var$nestableNavigationContentStyles = {
        name: "hxjswn",
        styles: "height:100%;position:relative;outline:none"
    };
    const $1598986e4d07c239$var$nestingRootStyles = {
        name: "1klp5xc",
        styles: "display:flex;width:100%;height:100%;position:absolute;flex-direction:column"
    };
    const $1598986e4d07c239$var$NestableNavigationContent = (props)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator } = props;
        const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
        const controlledStack = stack || undefined;
        const currentStackId = committedStack[committedStack.length - 1] || $1598986e4d07c239$export$ec71a3379b43ae5c;
        const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
        const backTestId = testId && `${testId}--go-back-item`;
        const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6XySk")).default), props, "Go back");
        const { childIdsRef: childIdsRef } = (0, (0, parcelRequire("9zCCP")).useChildIds)(currentStackId, committedStack, onUnknownNest);
        const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
            onChange && onChange(committedStack.concat(layerId));
            if (controlledStack) return;
            setTransition('nesting');
            requestAnimationFrame(()=>{
                setCommittedStack((prev)=>{
                    const newStack = prev.concat(layerId);
                    return newStack;
                });
            });
        }, [
            controlledStack,
            onChange,
            committedStack
        ]);
        const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
            onChange && onChange(committedStack.slice(0, committedStack.length - 1));
            if (controlledStack) return;
            setTransition('unnesting');
            requestAnimationFrame(()=>{
                setCommittedStack((prev)=>{
                    const newStack = prev.slice(0, prev.length - 1);
                    return newStack;
                });
            });
        }, [
            controlledStack,
            onChange,
            committedStack
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!controlledStack) return;
            if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) return;
            if (controlledStack.length < committedStack.length) setTransition('unnesting');
            else setTransition('nesting');
            requestAnimationFrame(()=>{
                setCommittedStack(controlledStack);
            });
        }, [
            committedStack,
            controlledStack
        ]);
        const backButton = renderGoBackItem({
            onClick: onUnNestHandler,
            testId: backTestId
        });
        const context = (0, $5uXOq.useMemo)(()=>({
                currentStackId: currentStackId,
                backButton: backButton,
                stack: committedStack,
                onNest: onNestHandler,
                onUnNest: onUnNestHandler,
                parentId: $1598986e4d07c239$export$ec71a3379b43ae5c,
                childIds: childIdsRef,
                forceShowTopScrollIndicator: showTopScrollIndicator
            }), [
            currentStackId,
            backButton,
            committedStack,
            onNestHandler,
            onUnNestHandler,
            childIdsRef,
            showTopScrollIndicator
        ]);
        const manageFocus = (event)=>{
            const triggeredByKeyboard = event.nativeEvent.detail === 0;
            if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $1598986e4d07c239$var$nestableNavigationContentStyles,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("35XSW")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cfT4M")).NestingMotion), {
            key: currentStackId,
            enterFrom: transition === 'nesting' ? 'right' : 'left',
            exitTo: transition === 'nesting' ? 'left' : 'right',
            testId: testId && `${testId}-anim`
        }, (motion)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $1598986e4d07c239$var$nestingRootStyles,
                ...motion
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j9VTE")).NestedContext).Provider, {
                value: context
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8UO8z")).default), {
                title: "",
                id: $1598986e4d07c239$export$ec71a3379b43ae5c
            }, children)))))));
    };
    var $1598986e4d07c239$export$2e2bcd8739ae039 = $1598986e4d07c239$var$NestableNavigationContent;
});
parcelRegister("6XySk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$acf862f964b3fe45$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d2gYe;
    var $ayWDM;
    const $acf862f964b3fe45$var$GoBackItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d2gYe"))))), {
        color: "currentColor",
        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        label: ""
    }), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
        const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
        const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
            if (isInteracted) return;
            setIsInteracted(true);
            onClick && onClick(e);
        }, [
            onClick,
            isInteracted
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ayWDM")).default), {
            isSelected: isSelected,
            cssFn: cssFn,
            iconBefore: iconBefore,
            onClick: onClickHandler,
            ref: ref,
            ...rest
        });
    });
    var $acf862f964b3fe45$export$2e2bcd8739ae039 = $acf862f964b3fe45$var$GoBackItem;
});
parcelRegister("d2gYe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $97d8a03a9ac2bd8e$var$_react = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $97d8a03a9ac2bd8e$var$_arrowLeft = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("ctqwA")));
    var $97d8a03a9ac2bd8e$var$_arrowLeftCircle = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("g9uZe")));
    function $97d8a03a9ac2bd8e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $97d8a03a9ac2bd8e$var$ArrowLeftIcon = (props)=>$97d8a03a9ac2bd8e$var$_react.default.createElement($97d8a03a9ac2bd8e$var$_arrowLeft.default, Object.assign({
            LEGACY_fallbackIcon: $97d8a03a9ac2bd8e$var$_arrowLeftCircle.default
        }, props));
    $97d8a03a9ac2bd8e$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
    var $97d8a03a9ac2bd8e$var$_default = module.exports.default = $97d8a03a9ac2bd8e$var$ArrowLeftIcon;
});
parcelRegister("g9uZe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
    function $bc2585eb44f99538$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>$bc2585eb44f99538$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
        }, props, {
            newIcon: $bc2585eb44f99538$var$_arrowLeft.default
        }));
    $bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
    var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;
});
parcelRegister("ayWDM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$860cc941614c9e62$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kJpBP;
    var $jsTfk;
    var $j9VTE;
    const $860cc941614c9e62$var$ButtonItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, ...rest }, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssOverride = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)((0, (0, parcelRequire("jsTfk")).baseSideNavItemStyle), cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            ref: ref,
            cssFn: cssOverride,
            ...rest
        });
    });
    var $860cc941614c9e62$export$2e2bcd8739ae039 = $860cc941614c9e62$var$ButtonItem;
});
parcelRegister("8UO8z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0599b2a9b08db47e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $bh9nY;
    var $dC5iT;
    var $8CUq3;
    var $jsTfk;
    var $ayWDM;
    var $jSfqD;
    var $kzjuk;
    var $9btdk;
    var $j9VTE;
    var $9zCCP;
    var $5n9uX;
    const $0599b2a9b08db47e$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline'
    });
    const $0599b2a9b08db47e$var$NestingItem = (props)=>{
        const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
        const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator } = (0, (0, parcelRequire("j9VTE")).useNestedContext)();
        const mergedStyles = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)((0, (0, parcelRequire("5n9uX")).nestingItemStyle), cssFn);
        const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
        const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
            onClick: onUnNest,
            testId: testId && `${testId}--go-back-item`
        }) || contextualBackButton;
        const context = (0, $5uXOq.useMemo)(()=>({
                stack: stack,
                currentStackId: currentStackId,
                onNest: onNest,
                onUnNest: onUnNest,
                backButton: backButton,
                parentId: id,
                childIds: childIds,
                forceShowTopScrollIndicator: forceShowTopScrollIndicator
            }), [
            stack,
            currentStackId,
            onNest,
            onUnNest,
            backButton,
            id,
            childIds,
            forceShowTopScrollIndicator
        ]);
        (0, (0, parcelRequire("9zCCP")).useChildIdsEffect)(childIds, id);
        const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
        const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
            if (isInteracted) return;
            if (isNormalClick(e)) {
                setIsInteracted(true);
                onNest(id);
            }
            onClick && onClick(e);
        }, [
            isInteracted,
            onClick,
            onNest,
            id
        ]);
        if (currentStackId === id) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j9VTE")).NestedContext).Provider, {
            value: context
        }, stack.length >= 1 && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlock: "space.075",
            paddingInline: "space.100"
        }, backButton), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kzjuk")).default), {
            testId: testId,
            showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1
        }, children));
        if ([
            (0, (0, parcelRequire("9btdk")).ROOT_ID),
            ...stack
        ].includes(id)) return children;
        const componentProps = {
            iconAfter: (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, iconAfter ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $0599b2a9b08db47e$var$iconContainerStyles,
                "data-custom-icon": true,
                as: "span"
            }, iconAfter) : null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                "data-right-arrow": true,
                xcss: $0599b2a9b08db47e$var$iconContainerStyles,
                as: "span"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bh9nY"))))), {
                testId: testId && `${testId}--item--right-arrow`,
                color: "currentColor",
                LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
                label: ""
            }))),
            onClick: onClickHandler,
            isSelected: isSelected,
            testId: testId && `${testId}--item`,
            ...rest,
            children: title,
            cssFn: mergedStyles
        };
        if (component) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSfqD")).default), {
            ...componentProps,
            component: component
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ayWDM")).default), componentProps);
    };
    var $0599b2a9b08db47e$export$2e2bcd8739ae039 = $0599b2a9b08db47e$var$NestingItem;
});
parcelRegister("bh9nY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $835890081946c47e$var$_react = $835890081946c47e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $835890081946c47e$var$_arrowRight = $835890081946c47e$var$_interopRequireDefault((parcelRequire("h1TKi")));
    var $835890081946c47e$var$_arrowRightCircle = $835890081946c47e$var$_interopRequireDefault((parcelRequire("1zw66")));
    function $835890081946c47e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $835890081946c47e$var$ArrowRightIcon = (props)=>$835890081946c47e$var$_react.default.createElement($835890081946c47e$var$_arrowRight.default, Object.assign({
            LEGACY_fallbackIcon: $835890081946c47e$var$_arrowRightCircle.default
        }, props));
    $835890081946c47e$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
    var $835890081946c47e$var$_default = module.exports.default = $835890081946c47e$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("1zw66", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1251f532550be707$var$_react = $1251f532550be707$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1251f532550be707$var$_arrowRight = $1251f532550be707$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $1251f532550be707$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1251f532550be707$var$ArrowRightCircleIcon = (props)=>$1251f532550be707$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
        }, props, {
            newIcon: $1251f532550be707$var$_arrowRight.default
        }));
    $1251f532550be707$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
    var $1251f532550be707$var$_default = module.exports.default = $1251f532550be707$var$ArrowRightCircleIcon;
});
parcelRegister("jSfqD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e63733262ea805c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1aogK;
    var $jsTfk;
    var $j9VTE;
    const $0e63733262ea805c$var$CustomItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, ...rest }, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssOverride = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)((0, (0, parcelRequire("jsTfk")).baseSideNavItemStyle), cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            ref: ref,
            cssFn: cssOverride,
            ...rest
        });
    });
    var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;
});
parcelRegister("9zCCP", function(module, exports) {
    $parcel$export(module.exports, "useChildIds", ()=>$edc749a9b64f215e$export$61b3ef4f009a9474);
    $parcel$export(module.exports, "useChildIdsEffect", ()=>$edc749a9b64f215e$export$ea18c2b5f0e24612);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    const $edc749a9b64f215e$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
        const childIdsRef = (0, $5uXOq.useRef)(new Set());
        (0, $5uXOq.useEffect)(()=>{
            if (currentStackId === (0, (0, parcelRequire("9btdk")).ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
            onUnknownNest(committedStack || [
                currentStackId
            ]);
        }, [
            currentStackId,
            committedStack,
            onUnknownNest
        ]);
        return {
            childIdsRef: childIdsRef
        };
    };
    const $edc749a9b64f215e$export$ea18c2b5f0e24612 = (childIds, id)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (!childIds || !childIds.current) return;
            if (!childIds.current.has(id)) childIds.current.add(id);
            return ()=>{
                childIds.current.delete(id);
            };
        }, [
            id
        ]);
    };
});
parcelRegister("5n9uX", function(module, exports) {
    $parcel$export(module.exports, "nestingItemStyle", ()=>$1433420fe651ac2a$export$38e770f85519b259);
    const $1433420fe651ac2a$export$4c36b5b1b67ee1e8 = {
        ['&:hover [data-custom-icon]']: {
            display: 'none'
        },
        ['&:active [data-custom-icon]']: {
            display: 'none'
        },
        ['&:focus [data-custom-icon]']: {
            display: 'none'
        },
        ['& [data-custom-icon]']: {
            display: 'inherit'
        },
        ['&:hover [data-right-arrow]']: {
            display: 'inherit'
        },
        ['&:active [data-right-arrow]']: {
            display: 'inherit'
        },
        ['&:focus [data-right-arrow]']: {
            display: 'inherit'
        },
        ['& [data-right-arrow]']: {
            display: 'none'
        }
    };
    const $1433420fe651ac2a$var$disabledCSS = {
        ['[data-item-elem-after]']: {
            opacity: 0
        },
        ['& [data-right-arrow]']: {
            display: 'none'
        }
    };
    const $1433420fe651ac2a$export$38e770f85519b259 = (state)=>{
        return {
            ...state.isDisabled ? $1433420fe651ac2a$var$disabledCSS : $1433420fe651ac2a$export$4c36b5b1b67ee1e8
        };
    };
});
parcelRegister("cfT4M", function(module, exports) {
    $parcel$export(module.exports, "NestingMotion", ()=>$0051a7791f96d83a$export$9e743a8c2a6b450e);
    var $f8Sb3;
    var $8Sbj3;
    const $0051a7791f96d83a$export$9e743a8c2a6b450e = (props)=>{
        const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8Sbj3")).default), {
            exitTo: exitTo,
            enterFrom: enterFrom,
            animationTimingFunction: (_)=>(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)
        }, (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            }));
    };
});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("gZEU1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb2dd47d2fa741f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $j7LBE;
    const $eb2dd47d2fa741f7$var$sidebarMinWidth = '240px';
    const $eb2dd47d2fa741f7$var$sideNavStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '100%',
        minWidth: $eb2dd47d2fa741f7$var$sidebarMinWidth,
        height: '100%',
        position: 'relative',
        flexDirection: 'column',
        backgroundColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        overflow: 'hidden'
    });
    const $eb2dd47d2fa741f7$var$SideNavigation = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, label: label } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("nav", {
            ref: ref,
            "data-testid": testId,
            "aria-label": label,
            css: $eb2dd47d2fa741f7$var$sideNavStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j7LBE")).SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch"
        }, children));
    });
    var $eb2dd47d2fa741f7$export$2e2bcd8739ae039 = $eb2dd47d2fa741f7$var$SideNavigation;
});
parcelRegister("k0ZZ2", function(module, exports) {
    $parcel$export(module.exports, "MenuItem", ()=>$5e6269ab5deb76fb$export$2ce376c2cc3355c8);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $jSfqD;
    var $dIdda = parcelRequire("dIdda");
    var $fpoBX;
    var $4UcF0;
    var $jvqf4;
    const $5e6269ab5deb76fb$var$WrapperComponent = (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: useButtonLink, ...props }, ref)=>{
        const commonProps = {
            ...props,
            children: children,
            className: `${className ?? ''} ${legacyClassName ?? ''}`
        };
        return href != null || to != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            ...commonProps,
            href: href,
            to: to,
            target: target,
            ref: ref,
            type: useButtonLink ? 'button' : 'a'
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($5e6269ab5deb76fb$var$ButtonItem, {
            ...commonProps,
            type: "button",
            ref: ref
        });
    });
    const $5e6269ab5deb76fb$var$customCssFn = (currentState = {})=>({
            '[data-item-title]': {
                lineHeight: 1.2
            },
            ...currentState.isSelected && {
                '& [data-item-title]': {
                    color: "var(--ds-text-selected, rgb(12, 102, 228))"
                }
            },
            '&:focus, &:visited, &:active': {
                textDecoration: 'inherit',
                outline: 0
            },
            '&:active': {
                backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)",
                boxShadow: "var(--ds-shadow-overlay, transparent)",
                '& [data-item-title]': {
                    color: "var(--ds-text, rgb(66, 82, 110))"
                }
            },
            '&:focus': {
                boxShadow: `${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`} 0 0 0 2px inset`
            },
            '&[data-rbd-draggable-id]': {
                cursor: 'pointer'
            }
        });
    const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, cssFn: outsideCssFn, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
        const onClickHandler = (0, (0, parcelRequire("jvqf4")).useOnClick)({
            onClick: onClick,
            analytics: analytics
        });
        const [{ route: route, query: query, location: location }] = (0, $dIdda.useRouter)();
        let isSelected;
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected && ref?.current != null) setTimeout(()=>{
                ref && ref.current != null && ref.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            });
        }, [
            selectedOn,
            ref,
            isSelected
        ]);
        if (typeof selectedOn === 'function') isSelected = route != null && selectedOn({
            ...location,
            query: query
        }, (0, ($parcel$interopDefault($aZsz6)))(href || '/', true));
        else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useCallback)((currentState)=>({
                ...outsideCssFn && outsideCssFn(currentState),
                ...$5e6269ab5deb76fb$var$customCssFn(currentState),
                ...(0, (0, parcelRequire("4UcF0")).getCustomThemeCss)(theme)
            }), [
            theme,
            outsideCssFn
        ]);
        const customProps = {
            ...rest,
            component: $5e6269ab5deb76fb$var$WrapperComponent,
            cssFn: cssFn,
            href: href,
            isSelected: isSelected,
            onClick: onClickHandler,
            overrides: overrides,
            ref: ref,
            useButtonLink: useButtonLink,
            'aria-current': isSelected ? 'page' : undefined
        };
        return overrides?.CustomItem?.render(customProps) || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jSfqD")).default), customProps);
    });
    const $5e6269ab5deb76fb$var$ButtonItem = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk18uv _19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fpoBX", function(module, exports) {
    $parcel$export(module.exports, "SidebarThemeProvider", ()=>$c9116269ddc1accc$export$92cd68117b68bf5f);
    $parcel$export(module.exports, "useSidebarTheme", ()=>$c9116269ddc1accc$export$b1a81b4626bc52c3);
    var $5uXOq = parcelRequire("5uXOq");
    const $c9116269ddc1accc$var$ThemeContext = (0, $5uXOq.createContext)(null);
    const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
            value: theme
        }, children);
    const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);
});
parcelRegister("4UcF0", function(module, exports) {
    $parcel$export(module.exports, "getCustomThemeCss", ()=>$2dc9c92255b2fb1d$export$cc5a98b66b3e9306);
    const $2dc9c92255b2fb1d$export$cc5a98b66b3e9306 = (theme)=>{
        if (theme?.navigation) {
            const { navigation: { item: item, icon: icon } } = theme;
            return {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '& [data-item-title]': {
                    color: item?.color?.default ?? undefined
                },
                '&:hover': {
                    color: item?.color?.hover ?? undefined,
                    backgroundColor: item?.background?.hover ?? undefined
                },
                '&:focus, &:visited': {
                    color: item?.color?.default
                },
                '&:active': {
                    color: item?.color?.active ?? undefined,
                    backgroundColor: item?.background?.active ?? undefined
                },
                '&:active [data-item-title]': {
                    color: item?.color?.active ?? undefined
                },
                '&:active [data-item-elem-before]': {
                    color: item?.color?.active ?? undefined
                },
                '&:focus': {
                    boxShadow: item?.color?.active != null ? `${item?.color?.active} 0 0 0 2px inset` : undefined
                },
                '&[aria-current="page"]': {
                    position: 'relative',
                    backgroundColor: item?.background?.active ?? undefined,
                    color: item?.color?.active ?? undefined
                },
                '&[aria-current="page"]:before': {
                    background: item?.color?.active ?? undefined
                },
                '& [data-item-elem-after]': {
                    color: icon?.secondary?.color?.hover ?? undefined
                }
            };
        }
        return {};
    };
});
parcelRegister("jvqf4", function(module, exports) {
    $parcel$export(module.exports, "useOnClick", ()=>$568e03d72b926f2a$export$a81c45382e7253ac);
    var $8zOmE;
    var $2NMNM;
    const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationItem'
            });
            if (analytics) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
            else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'sidebar');
            onClick && onClick(event);
        };
    };
});
parcelRegister("3OGaE", function(module, exports) {
    $parcel$export(module.exports, "TitleHeader", ()=>$09f1bcc415909488$export$de3705f3d2162955);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $juVrZ;
    var $fpoBX;
    var $7ic3S;
    const $09f1bcc415909488$var$overrideStyles = (currentStyles)=>({
            ...currentStyles,
            '[data-item-title]': {
                ...currentStyles['[data-item-title]'],
                whiteSpace: 'normal',
                lineHeight: 'initial'
            }
        });
    const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($basmW)))([
                (0, (0, parcelRequire("7ic3S")).generateCustomThemeCssFn)(theme),
                $09f1bcc415909488$var$overrideStyles
            ]), [
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juVrZ")).default), {
            cssFn: cssFn
        }, children);
    };
});
parcelRegister("juVrZ", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$c46eefd51badc16b$export$42a852a2b6b56249);
    $parcel$export(module.exports, "default", ()=>$c46eefd51badc16b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jsTfk;
    var $jSfqD;
    function $c46eefd51badc16b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c46eefd51badc16b$var$containerStyles = {
        name: "4bgdod",
        styles: "display:block;position:relative"
    };
    const $c46eefd51badc16b$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
        const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
                className: className,
                onClick: onClick,
                onMouseDown: onMouseDown,
                onDragStart: onDragStart,
                draggable: draggable,
                ref: ref,
                tabIndex: tabIndex,
                disabled: disabled
            }))(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $c46eefd51badc16b$var$containerStyles,
            ...safeProps
        }, children);
    };
    const $c46eefd51badc16b$var$Header = (0, $5uXOq.forwardRef)((props, ref)=>{
        const cssFn = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)(()=>({
                userSelect: 'auto',
                ['[data-item-title]']: {
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                },
                'div&:hover': {
                    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                    cursor: 'default'
                },
                'div&:active': {
                    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                    color: `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                }
            }), props.cssFn);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSfqD")).default), {
            ...props,
            ref: ref,
            component: props.component || $c46eefd51badc16b$export$42a852a2b6b56249,
            cssFn: cssFn,
            overrides: {
                Title: {
                    render: (_, { children: children, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("h2", props, children)
                }
            }
        });
    });
    var $c46eefd51badc16b$export$2e2bcd8739ae039 = $c46eefd51badc16b$var$Header;
});
parcelRegister("7ic3S", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$6cb72e96c74982ff$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $6cb72e96c74982ff$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    backgroundColor: item?.background?.default ?? undefined,
                    color: item?.color?.default ?? undefined,
                    '&:hover': {
                        color: item?.color?.hover ?? undefined,
                        backgroundColor: item?.background?.hover ?? undefined
                    },
                    '[data-item-title]': {
                        color: item?.color?.default ?? undefined
                    }
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("ai0LF", function(module, exports) {
    $parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", ()=>$2bb346e8dcf8bbae$export$3f662b014fa1806e);
    function $2bb346e8dcf8bbae$export$3f662b014fa1806e(fn) {
        return fn;
    }
    function $2bb346e8dcf8bbae$export$17f32e2573d62daa(fn) {
        return fn;
    }
    const $2bb346e8dcf8bbae$export$91011a0a572ef910 = {
        CONNECTED: 'CONNECTED',
        INCOMPLETE: 'INCOMPLETE',
        INITIAL: 'INITIAL',
        SEEN: 'SEEN',
        UNCONNECTED: 'UNCONNECTED'
    };
});
parcelRegister("juTur", function(module, exports) {
    $parcel$export(module.exports, "ContextualAnalyticsData", ()=>$ffb2d49dc0e79e64$export$198470770171c65);
    $parcel$export(module.exports, "IssuesContextualAnalyticsData", ()=>$ffb2d49dc0e79e64$export$bc7f6eebc16e6127);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $iXVV6;
    var $lpwtK;
    var $3d1up;
    const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            ...rest,
            attributes: {
                navVersion: '3',
                viewId: (0, (0, parcelRequire("3d1up")).generateViewId)(menuId, ...stack),
                navigationLayer: 'container',
                ...attributes
            }
        });
    const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, (0, parcelRequire("lpwtK")).useProject), ...rest })=>{
        const { data: project } = useProject();
        const projectConfig = (project?.isSimplified ? (0, (0, parcelRequire("2vSU6")).ProjectStyle).NEXT_GEN : (0, (0, parcelRequire("2vSU6")).ProjectStyle).CLASSIC) || undefined;
        const projectType = project?.type || undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            ...rest,
            attributes: {
                ...attributes,
                projectConfig: projectConfig,
                projectType: projectType,
                navigatorScope: navigatorScope
            }
        });
    };
});
parcelRegister("3d1up", function(module, exports) {
    $parcel$export(module.exports, "generateViewId", ()=>$2f6f53381b1f04e0$export$5b5545ed894dc47a);
    const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');
});
parcelRegister("17bH5", function(module, exports) {
    $parcel$export(module.exports, "getSystemNavigationPaths", ()=>$0ac95c37050f315f$export$76c5f80c8d9bdb0e);
    var $4R6GH;
    const $0ac95c37050f315f$export$76c5f80c8d9bdb0e = ()=>({
            generalConfiguration: '/jira/settings/system/general-configuration',
            darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
            issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
            globalAutomation: '/jira/settings/automation',
            troubleshootingAuditLog: '/auditing/view',
            troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
            troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
            troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
            troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
            troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
            troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
            troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
            securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
            securityGlobalPermissions: (0, (0, parcelRequire("4R6GH")).fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
            userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
            userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
            userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
            userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
            userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
            importSectionBackupManager: '/secure/admin/CloudExport.jspa',
            importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
            importSectionExternalImportNew: '/jira/settings/system/external-import',
            importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
            importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
            importSectionMigrateCloud: '/jira/settings/system/migration/home',
            mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
            mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
            mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
            mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
            adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
            adminHelperNotificationHelper: '/secure/admin/NotificationHelperAdmin.jspa',
            adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
            sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
            sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
            advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
            advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
            advancedSectionWebHooks: '/plugins/servlet/webhooks',
            advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
            advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
        });
});
parcelRegister("4OCke", function(module, exports) {
    $parcel$export(module.exports, "matchPathname", ()=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
    $parcel$export(module.exports, "matchUrlPathname", ()=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
    $parcel$export(module.exports, "matchPartialUrlPathname", ()=>$cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
    $parcel$export(module.exports, "matchUrlExact", ()=>$cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
    $parcel$export(module.exports, "matchUrlParams", ()=>$cf3ce1d2a79b8e17$export$63fdecce99465869);
    var $f8l56 = parcelRequire("f8l56");
    const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
    const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
    const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
    const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
    const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, ($parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
    const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);
});
parcelRegister("3tHFY", function(module, exports) {
    $parcel$export(module.exports, "ConnectMenu", ()=>$1b0be5b9936240ae$export$19d0925d424b864a);
    var $5uXOq = parcelRequire("5uXOq");
    var $au6nA;
    var $fh2pW;
    const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
        const filteredItems = (0, (0, parcelRequire("au6nA")).useFilteredItems)(items || null, shouldFilter);
        if (filteredItems == null || !filteredItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fh2pW")).ConnectItem), {
                item: item,
                key: item.id,
                index: index,
                overrides: overrides,
                showIcons: showIcons,
                submenuId: submenuId
            })));
    };
});
parcelRegister("au6nA", function(module, exports) {
    $parcel$export(module.exports, "useFilteredItems", ()=>$cb371d7d8e582719$export$79762159776e61da);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvHKs;
    const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
            if (!shouldFilter) return items || [];
            return items?.filter((item)=>!(0, (0, parcelRequire("kvHKs")).staticLegacyIds).includes(item.id)) || [];
        }, [
            items,
            shouldFilter
        ]);
});
parcelRegister("fh2pW", function(module, exports) {
    $parcel$export(module.exports, "ConnectItem", ()=>$f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $apKqz;
    var $gjTBi;
    var $3TzYp;
    var $iUo88;
    var $jjUR3;
    var $hrlU6;
    var $4R6GH;
    var $k0ZZ2;
    var $eYDk7;
    var $3OGaE;
    var $kZj7F;
    var $4OCke;
    const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
        const { addNew: addNew } = (0, (0, parcelRequire("jjUR3")).useConnectItemClickHistory)();
        const isDialog = item.styleClass && (0, (0, parcelRequire("hrlU6")).isConnectDialogWebItem)(item.styleClass) && (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api');
        const webItemRef = (0, $5uXOq.useRef)(null);
        const BackMenuItem = {
            ...overrides.BackMenuItem,
            onClick: (ev)=>{
                if (submenuId != null) {
                    const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                    let parsedCookieData = null;
                    try {
                        parsedCookieData = JSON.parse(cookieData);
                    } catch  {
                        parsedCookieData = {
                            submenuActive: false,
                            expanded: false
                        };
                    }
                    const newCookieData = {
                        ...parsedCookieData,
                        submenuActive: false
                    };
                    (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
                }
                if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
                overrides.BackMenuItem?.onClick?.(ev);
            }
        };
        const icon = (0, $5uXOq.useMemo)(()=>{
            if (showIcons !== true) return null;
            return item.iconUrl != null && item.iconUrl.trim().length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
                src: item.iconUrl,
                alt: ""
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("apKqz"))))), {
                label: ""
            });
        }, [
            showIcons,
            item.iconUrl
        ]);
        const onItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (overrides?.ParentMenuItem?.onClick && isNested) overrides.ParentMenuItem.onClick(event);
            if (isDialog) (0, (0, parcelRequire("hrlU6")).withConnectHost)((connectHost)=>{
                if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
            });
            else item.url != null && addNew(item.url);
        }, [
            addNew,
            isDialog,
            isNested,
            item.styleClass,
            item.url,
            overrides
        ]);
        const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (submenuId != null) {
                const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                if (cookieData != null) (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                    ...JSON.parse(cookieData),
                    submenuActive: true
                }));
            }
            if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(event);
            return ()=>null;
        }, [
            overrides,
            submenuId
        ]);
        if (item.section === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: item.name,
            hasSeparator: Boolean(index)
        }, (item.items || []).map((si, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
                key: si.id,
                item: si,
                overrides: {
                    ...overrides,
                    BackMenuItem: BackMenuItem
                },
                index: idx,
                isNested: isNested
            })));
        if (item.items) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            id: item.id,
            analytics: {
                itemId: item.id
            },
            iconBefore: icon,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            title: item.name,
            onClick: onNestedMenuItemClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYDk7")).NavigationContentWrapper), {
            submenuActive: true,
            nestedMenuOpen: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
                key: si.id,
                item: si,
                index: nestIndex,
                overrides: {
                    ...overrides,
                    BackMenuItem: {
                        href: item.url,
                        title: si.name,
                        onClick: (ev)=>ev.preventDefault()
                    }
                },
                isNested: true
            })))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: item.id
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)(),
            iconBefore: icon,
            href: isDialog ? undefined : item.url,
            legacyClassName: (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api') ? undefined : item.styleClass,
            onClick: onItemClick,
            ref: (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api') ? webItemRef : (0, $5uXOq.createRef)()
        }, item.name);
    };
    const $f2bd062d7c8c5e44$var$ConnectIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbgktf _4t3igktf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iUo88", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryCookie", ()=>$89b5b8a4b358ad27$export$93509ff9a62ee022);
    var $GjM2o;
    const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
        (0, (0, parcelRequire("GjM2o")).setStrictlyNecessaryCookie)(key, value, attributes);
    };
});
parcelRegister("GjM2o", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryCookie", ()=>$07f3430601091fbe$export$93509ff9a62ee022);
    var $eYli8 = parcelRequire("eYli8");
    var $VSDnB;
    var $aGNyr;
    var $cala7;
    const $07f3430601091fbe$export$93509ff9a62ee022 = (key, value, attributes)=>{
        try {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls')) (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                action: 'usedSetStrictlyNecessaryCookie',
                attributes: {
                    cookieKey: key
                }
            });
            (0, ($parcel$interopDefault($eYli8))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'usedSetStrictlyNecessaryCookieError',
                attributes: {
                    cookieKey: key
                },
                message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
            });
        }
    };
});
parcelRegister("jjUR3", function(module, exports) {
    $parcel$export(module.exports, "useConnectItemClickHistory", ()=>$c499ec49965fe6fe$export$c251e3fda1cce4a3);
    var $5uXOq = parcelRequire("5uXOq");
    const $c499ec49965fe6fe$var$history = {
        unique: []
    };
    const $c499ec49965fe6fe$export$c251e3fda1cce4a3 = ()=>{
        const addNew = (0, $5uXOq.useCallback)((historyItem)=>{
            if (window.location.href.endsWith(historyItem) === false) $c499ec49965fe6fe$var$history.unique.push(historyItem);
        }, []);
        return (0, $5uXOq.useMemo)(()=>({
                history: $c499ec49965fe6fe$var$history,
                addNew: addNew
            }), [
            addNew
        ]);
    };
    const $c499ec49965fe6fe$export$ef04cd58bebb0345 = ()=>{
        $c499ec49965fe6fe$var$history.unique.length = 0;
    };
});
parcelRegister("hrlU6", function(module, exports) {
    $parcel$export(module.exports, "withConnectHost", ()=>$9316db67541b8a94$export$970e2411dd8601c8);
    $parcel$export(module.exports, "getConnectHost", ()=>$9316db67541b8a94$export$186d423c00af146c);
    $parcel$export(module.exports, "isConnectDialogWebItem", ()=>$9316db67541b8a94$export$920fb4b46d4f2eec);
    var $dJZWD;
    const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
        const connectHost = await (0, (0, parcelRequire("dJZWD")).setupConnectJs)();
        action(connectHost);
    };
    const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
    const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');
});
parcelRegister("dJZWD", function(module, exports) {
    $parcel$export(module.exports, "setupConnectJs", ()=>$762ba9fa524ea8e6$export$891414b605e5f038);
    var $6BZYo;
    var $dH9DT;
    const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
        await (0, (0, parcelRequire("dH9DT")).waitForJQuery)();
        const loader = await (parcelRequire("gRUhY"));
        await loader.performSideEffects();
        return window.connectHost;
    };
    let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
    const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
        if (window.__SPA__) {
            if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
            return $762ba9fa524ea8e6$var$installConnectJsPromise;
        }
        await (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: 'ac/create',
            wrmKeys: [
                'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
            ]
        });
        return window.connectHost;
    };
});
parcelRegister("6BZYo", function(module, exports) {
    $parcel$export(module.exports, "loadBridge", ()=>$ce95ee3fd66207c7$export$df8409da353bde5a);
    $parcel$export(module.exports, "loadBridgeStrict", ()=>(parcelRequire("7T84i")).loadBridgeStrict);
    var $fqWWz;
    var $3GASE;
    var $ig88W;
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $8JNtu;
    var $5Ik5Y;
    const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, (0, parcelRequire("fqWWz")).MAX_RETRIES), timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        if (wrmKeys != null) return (0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
            name: name,
            wrmKeys: [].concat(wrmKeys),
            shouldLogError: shouldLogError
        });
        if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
        if (tentatives <= 1) return (0, (0, parcelRequire("3GASE")).loadBridgeBail)({
            name: name,
            shouldLogError: shouldLogError
        });
        return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError,
            timeout: (tentatives - 1) * timeout
        });
    };
});
parcelRegister("3GASE", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeBail", ()=>$e512b6cc4a8702e5$export$a036f92c2465504e);
    var $wRU6t;
    var $fqWWz;
    const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        try {
            return window.require(name);
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, (0, parcelRequire("wRU6t")).safeStringify)(error) ?? ''}`, {
                isSpa: __SPA__,
                name: name,
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error(`Unable to load bridge "${name}"`, {
                cause: error
            });
        }
    };
});
parcelRegister("ig88W", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeRace", ()=>$64f1dbae1ea314ee$export$20c32b4579d78b92);
    var $3GASE;
    var $9B86Q;
    var $fqWWz;
    const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>Promise.race([
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            }),
            new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, (0, parcelRequire("3GASE")).loadBridgeBail)({
                    name: name,
                    shouldLogError: shouldLogError
                }))
        ]);
});
parcelRegister("7T84i", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeStrict", ()=>$89a95eb8b151782d$export$eba600d28decc4ac);
    var $c56lL;
    var $ig88W;
    var $fVOHM;
    var $fqWWz;
    const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        (0, (0, parcelRequire("c56lL")).saveStats)(name, wrmKeys);
        try {
            return window.require(name);
        } catch (error) {
            await (0, (0, parcelRequire("fVOHM")).loadWrmResources)({
                wrmKeys: wrmKeys,
                shouldLogError: shouldLogError
            });
            return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
                name: name,
                shouldLogError: shouldLogError
            });
        }
    };
});
parcelRegister("c56lL", function(module, exports) {
    $parcel$export(module.exports, "saveStats", ()=>$6c875a5034ae8433$export$9ea3ff7978093559);
    const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
        if (stats[resource] == null) stats[resource] = 1;
        else stats[resource] += 1;
    };
    const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
            requests: 0,
            amdModules: {},
            wrmKeys: {}
        });
    const $6c875a5034ae8433$var$initStats = ()=>{
        if (window.__WRM_INTERNAL_STATS__ == null) window.__WRM_INTERNAL_STATS__ = {
            loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
        };
        else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
        return window.__WRM_INTERNAL_STATS__.loadBridge;
    };
    const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
    const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
        try {
            const stats = $6c875a5034ae8433$var$initStats();
            if ($6c875a5034ae8433$var$isPageInteractive()) return;
            stats.requests += 1;
            $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
            if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
            else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
        } catch (e) {}
    };
});
parcelRegister("cQZXC", function(module, exports) {
    $parcel$export(module.exports, "waitForHeritage", ()=>$90def0f7a7aa11d6$export$c61060338d026f78);
    var $aePFs;
    const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
        if (false) return null;
        if (!__SPA__) return Promise.resolve();
        if (!window.__WAIT_FOR_HERITAGE__) window.__WAIT_FOR_HERITAGE__ = new (0, (0, parcelRequire("aePFs")).default)();
        return window.__WAIT_FOR_HERITAGE__;
    };
});
parcelRegister("dH9DT", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$a78c52ec7ed5d025$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "getJQuery", ()=>$a78c52ec7ed5d025$export$7232a6dc780f9887);
    $parcel$export(module.exports, "getGlobalAP", ()=>$a78c52ec7ed5d025$export$fbc82125a6bd8012);
    $parcel$export(module.exports, "isObject", ()=>$a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "escapeSelector", ()=>$a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
    $parcel$export(module.exports, "waitForJQuery", ()=>$a78c52ec7ed5d025$export$97214de9c546981c);
    $parcel$export(module.exports, "ErrorDebugAddonKeys", ()=>$a78c52ec7ed5d025$export$d690da9bc8146677);
    var $jcw0u;
    const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
        const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
        return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
    };
    const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
    const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>window._AP;
    const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
    const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
        if (!s) throw new Error('No selector to escape');
        return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
    };
    const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
    const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
            const interval = setInterval(()=>{
                if (window.AJS?.$) {
                    clearInterval(interval);
                    resolve();
                }
            }, 10);
            setTimeout(()=>{
                clearInterval(interval);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'connect-jquery-timeout',
                        packageName: 'jiraConnect'
                    },
                    error: new Error('Timeout when waiting for jQuery to be available on the page'),
                    skipSentry: true
                });
                reject();
            }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
        });
    const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
    const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
    const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
        $a78c52ec7ed5d025$export$cb954c21735b28e4,
        $a78c52ec7ed5d025$export$7315c38dc71bd41f
    ];
});
parcelRegister("gRUhY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aVR4N").then(()=>parcelRequire('8vJyT'));
});
parcelRegister("eYDk7", function(module, exports) {
    $parcel$export(module.exports, "NavigationHeaderWrapper", ()=>$eea5dc8ebf00d36e$export$bae9b35e967353d5);
    $parcel$export(module.exports, "NavigationExpandableContentWrapper", ()=>$eea5dc8ebf00d36e$export$4e88508e6904469e);
    $parcel$export(module.exports, "NavigationContentWrapper", ()=>$eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
    $parcel$export(module.exports, "NextGenIssueTypesWrapper", ()=>$eea5dc8ebf00d36e$export$f094f7aad76e4268);
    $parcel$export(module.exports, "ExpandableProjectSettingsWrapper", ()=>$eea5dc8ebf00d36e$export$e38bb288d890ec2f);
    $parcel$export(module.exports, "ShortCutsAndAppsWrapper", ()=>$eea5dc8ebf00d36e$export$337add4342ee7986);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
        const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
            nestedAppOpen: nestedAppOpen,
            submenuActive: submenuActive
        }, children);
    };
    const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
            navModuleLabelsHidden: props.navModuleLabelsHidden,
            nestedAppOpen: props.nestedAppOpen,
            context: props.context,
            submenuActive: props.submenuActive,
            nestedMenuOpen: props.nestedMenuOpen,
            "data-component-selector": "NavigationContentWrapperContainer"
        }, props.children);
    const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
    const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _1s541012 _1lfu1012",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_ykp9lh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
                "--_1qrlsbv": (0, (0, parcelRequire("lD23V")).default)(Math.round((0, (0, parcelRequire("gwIPs")).borderRadius) * 1.333), "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
                __cmplp.submenuActive && "_4t3i1qw7",
                __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_6w8gix": (0, (0, parcelRequire("lD23V")).default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, (0, parcelRequire("gwIPs")).gridSize), "px"),
                "--_1qrlsbv": (0, (0, parcelRequire("lD23V")).default)(Math.round((0, (0, parcelRequire("gwIPs")).borderRadius) * 1.333), "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
                __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
                __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
                __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wtppxbi _df5vpxbi",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _14tk72c6 _t3zc183y _1so4jjyb _1thc1skh _a6avqslr _dnyv1skh",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kZj7F", function(module, exports) {
    $parcel$export(module.exports, "NestingMenuItem", ()=>$2fbfde7c900477f4$export$4c594f24f8e4128a);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $1UikQ = parcelRequire("1UikQ");
    var $g9uZe;
    var $8UO8z;
    var $5Hj3V;
    var $k0ZZ2;
    var $hg4VT;
    var $kZ5sr;
    var $fpoBX;
    var $ai0LF;
    var $kavsL;
    const $2fbfde7c900477f4$var$customCssFn = (0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
        const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
        const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
        const newStyle = {
            ...(0, (0, parcelRequire("kZ5sr")).cssFn)(currentStateAndStyles),
            '&:visited, &:focus, &:active': {
                textDecoration: 'inherit',
                outline: 0
            },
            '&:active': {
                color: activeColor
            },
            '&:visited, &:focus': {
                color: baseColor
            },
            '& [data-item-title]': {
                color: baseColor
            }
        };
        return (0, ($parcel$interopDefault($1UikQ)))(currentStateAndStyles, newStyle);
    });
    const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", props, props.children);
    const $2fbfde7c900477f4$export$4c594f24f8e4128a = (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const backButtonCssFn = (0, (0, parcelRequire("hg4VT")).generateBackButtonCssFn)(theme);
        const { BackMenuItem: BackMenuItem = {} } = overrides;
        const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem;
        const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                ...backItemProps,
                analytics: {
                    itemId: 'back'
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("g9uZe"))))), {
                    label: ""
                }),
                onClick: (ev)=>{
                    if ((0, (0, parcelRequire("kavsL")).isNormalClick)(ev)) {
                        onClick();
                        backItemProps.onClick?.(ev);
                    }
                },
                cssFn: backButtonCssFn
            }, backTitle)), [
            WrapperComponent,
            backItemProps,
            backButtonCssFn,
            backTitle
        ]);
        const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8UO8z")).default), {
                ...props,
                id: id,
                component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
                onClick: (ev)=>{
                    if (props.isSelected === true) ev.preventDefault();
                    onClick && onClick(ev);
                },
                overrides: {
                    GoBackItem: {
                        render: renderBackItem
                    }
                },
                title: itemTitle,
                cssFn: customItemCssFn ? (0, ($parcel$interopDefault($basmW)))([
                    customItemCssFn,
                    $2fbfde7c900477f4$var$customCssFn
                ]) : $2fbfde7c900477f4$var$customCssFn
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Hj3V")).SidebarErrorBoundary), {
                id: `${id}Nesting`,
                packageName: "jiraSpaAppsSidebarCommon"
            }, children)), [
            children,
            id,
            reloadOnNavigationToNesting,
            renderBackItem
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            ...rest,
            ref: ref,
            overrides: {
                CustomItem: {
                    render: renderCustomItem
                }
            }
        }, title);
    });
});
parcelRegister("hg4VT", function(module, exports) {
    $parcel$export(module.exports, "generateBackButtonCssFn", ()=>$1e5fb9a53caeb1aa$export$56644251c3f2ea82);
    const $1e5fb9a53caeb1aa$export$56644251c3f2ea82 = (theme)=>()=>{
            if (theme?.navigation) {
                const { icon: icon } = theme.navigation;
                return {
                    '& [data-item-elem-before], &:active span[data-item-elem-before]': {
                        color: icon?.secondary?.color?.active ?? undefined
                    }
                };
            }
            return {};
        };
});
parcelRegister("kZ5sr", function(module, exports) {
    $parcel$export(module.exports, "cssFn", ()=>$399c9dca906145c0$export$d722961e96b459c5);
    var $1UikQ = parcelRequire("1UikQ");
    var $gwIPs;
    var $ai0LF;
    const $399c9dca906145c0$export$d722961e96b459c5 = (0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        const newStyle = {
            '[data-item-elem-after] [data-right-arrow]': {
                display: 'none'
            },
            '&:hover [data-item-elem-after]': {
                '& > :not([data-right-arrow])': {
                    display: 'none'
                },
                '& [data-right-arrow]': {
                    display: 'flex'
                }
            },
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 5.5}px`
        };
        return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, newStyle);
    });
});
parcelRegister("kavsL", function(module, exports) {
    $parcel$export(module.exports, "isNormalClick", ()=>$e059487e30c8155a$export$729f3684d5c2b9b9);
    const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
});
parcelRegister("eaZ4X", function(module, exports) {
    $parcel$export(module.exports, "SECTION_ID", ()=>$b36275c07d465a0e$export$501955bd67991a25);
    const $b36275c07d465a0e$export$501955bd67991a25 = {
        MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
        PERFORMANCE_AND_SCALE: 'performance-and-scale'
    };
});
parcelRegister("jMBA3", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$4023bf6b28a8dc58$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", ()=>$4023bf6b28a8dc58$export$f601efaceb0636f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $aUDLa;
    var $7OqB4;
    var $awp39;
    var $9OXo1;
    var $gJkov;
    const $4023bf6b28a8dc58$export$4a39035bacc4ed76 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)(()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const { isDevMode: isDevMode, isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("gJkov")).extractData)(data, isDevMode, isAdmin, isSiteAdmin), [
            data,
            isDevMode,
            isAdmin,
            isSiteAdmin
        ]);
        return {
            data: extractedData,
            loading: loading,
            error: error
        };
    });
    const $4023bf6b28a8dc58$export$f601efaceb0636f4 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("awp39")).useGlobalSettingsSystemConnectItems));
});
parcelRegister("aUDLa", function(module, exports) {
    $parcel$export(module.exports, "useNavigationGlobalResource", ()=>$dbad5a19b82e4911$export$1e1c317ed5b99faa);
    var $5uXOq = parcelRequire("5uXOq");
    var $atU1t;
    var $dIdda = parcelRequire("dIdda");
    const $dbad5a19b82e4911$export$1e1c317ed5b99faa = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource));
        const response = (0, $5uXOq.useMemo)(()=>data && data.response, [
            data
        ]);
        return {
            data: response,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("7OqB4", function(module, exports) {
    $parcel$export(module.exports, "withThrowOnError", ()=>$f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
    var $gKZoD;
    const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
    function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
        return (...args)=>{
            (0, (0, parcelRequire("gKZoD")).di)(theHook);
            const result = theHook(...args);
            if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
            return result;
        };
    }
});
parcelRegister("awp39", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", ()=>$6ac80db07eab2a1e$export$f601efaceb0636f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $6ac80db07eab2a1e$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'admin_system_menu'
        ], {
            skipFilter: true
        }).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter(Boolean));
    const $6ac80db07eab2a1e$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $6ac80db07eab2a1e$export$f601efaceb0636f4 = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $6ac80db07eab2a1e$var$getItemsMemo(data), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $6ac80db07eab2a1e$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("7tsV0", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$93fa8c16baad19b1$export$751e2e6237002565);
    var $ajpes = parcelRequire("ajpes");
    var $k0iPT;
    const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
            const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("k0iPT", function(module, exports) {
    $parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", ()=>$c82776b15970ab04$export$a8aac2ba4dc1f57);
    $parcel$export(module.exports, "CONNECT_ROUTES_SET", ()=>$c82776b15970ab04$export$c47bf667d3008c53);
    var $65Ltd;
    const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT)
    ]);
    const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL)
    ]);
});
parcelRegister("4gymV", function(module, exports) {
    $parcel$export(module.exports, "getLinks", ()=>$6dc7ee8ba2a1371f$export$8054dcb2b42da45c);
    var $83mn0;
    var $7NH5Y;
    const $6dc7ee8ba2a1371f$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
        const acc = [];
        locations.forEach((location)=>{
            const links = (0, (0, parcelRequire("83mn0")).getLinksFromSidebar)(sidebarConfig, location);
            if (omitSections === true) {
                Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
                return;
            }
            Array.prototype.push.apply(acc, links);
        });
        return acc.filter((item)=>{
            if (!item) return false;
            if (skipFilter === true) return true;
            const hasConnectPrefix = item.id && item.id.includes((0, (0, parcelRequire("7NH5Y")).connectPrefix));
            if (hasConnectPrefix) return true;
            const isConnectSection = (0, (0, parcelRequire("7NH5Y")).connectSections).includes(item.id);
            if (isConnectSection) return true;
            const isJsdConnectSection = item.id && item.id.includes((0, (0, parcelRequire("7NH5Y")).jsdConnectPrefix));
            if (isJsdConnectSection) return true;
            return false;
        });
    };
});
parcelRegister("83mn0", function(module, exports) {
    $parcel$export(module.exports, "hasItemInSidebar", ()=>$90215f5482fce08d$export$57dd40eec4c64521);
    $parcel$export(module.exports, "getLinksFromSidebar", ()=>$90215f5482fce08d$export$9b7e0e4dd8bfade8);
    const $90215f5482fce08d$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
        if (!Array.isArray(arrayOfLinks)) return undefined;
        for(let i = 0; i < arrayOfLinks.length; i += 1){
            const link = arrayOfLinks[i];
            if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
            if (link.id === legacyId) return link;
            if (link.links) {
                const linkFound = $90215f5482fce08d$var$findLink(link.links, legacyId, partialMatch);
                if (linkFound) return linkFound;
            }
        }
        return undefined;
    };
    const $90215f5482fce08d$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $90215f5482fce08d$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
    const $90215f5482fce08d$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($90215f5482fce08d$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
    const $90215f5482fce08d$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
            if (item.id === legacyId) return item.links;
            return item.links && $90215f5482fce08d$var$findChildLinks(item.links, legacyId);
        }).find(Boolean);
    const $90215f5482fce08d$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
        const links = legacyId != null ? $90215f5482fce08d$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
        return links || [];
    };
});
parcelRegister("7NH5Y", function(module, exports) {
    $parcel$export(module.exports, "connectPrefix", ()=>$a36a125359bfc961$export$196d83ebd873fb40);
    $parcel$export(module.exports, "jsdConnectPrefix", ()=>$a36a125359bfc961$export$7fac8f726f52d70);
    $parcel$export(module.exports, "connectSections", ()=>$a36a125359bfc961$export$b1c2c1fc5d10280);
    var $kvHKs;
    const $a36a125359bfc961$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
    const $a36a125359bfc961$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
    const $a36a125359bfc961$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
    const $a36a125359bfc961$var$jsdQueuesConnectSection = 'sd-queues-addons';
    const $a36a125359bfc961$export$b1c2c1fc5d10280 = [
        $a36a125359bfc961$var$legacyAddonPanelLinkId,
        (0, (0, parcelRequire("kvHKs")).REPORTS_IDS).REPORTS_ADDONS,
        $a36a125359bfc961$var$jsdQueuesConnectSection
    ];
});
parcelRegister("5W6pd", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$1efacbf40a7b73c8$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$1efacbf40a7b73c8$export$27267b6b6650eaa5);
    const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("gJkov", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$63e1d07edc3ef769$export$9df5fa0a366163d2);
    var $aIZdc;
    var $co1wz;
    var $83mn0;
    const $63e1d07edc3ef769$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin, isSiteAdmin)=>({
            hasGeneralConfiguration: isAdmin,
            hasDarkFeatures: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'dark_features'),
            hasTroubleshootingAndSupportSection: isAdmin,
            hasViewAuditing: isAdmin,
            hasPluginViewer: isDevMode && isAdmin,
            hasModulesViewer: isDevMode && isAdmin,
            hasSystemInfo: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'system_info'),
            hasIntegrityChecker: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'integrity_checker'),
            hasLoggingProfiling: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'logging_profiling'),
            hasSchedulerDetails: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'scheduler_details'),
            hasSecuritySection: isAdmin,
            hasProjectRoles: isAdmin,
            hasGlobalPermissions: isAdmin,
            hasCollectors: isAdmin,
            hasUserInterfaceSection: isAdmin,
            hasUserDefaults: isAdmin,
            hasEditDefaultDashboard: isAdmin,
            hasLookAndFeel: isAdmin,
            hasPasAdmin: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
            hasImportExportSection: isAdmin,
            hasBackupManager: isAdmin,
            hasExternalImport: isAdmin,
            hasRestoreSystem: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import'),
            hasCloudImport: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
            hasServerImport: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import_jira_server'),
            hasC2CMigration: isSiteAdmin && (0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration') && !(0, (0, parcelRequire("aIZdc")).isFedRamp)(),
            hasMailSection: isAdmin,
            hasGlobalMailSettings: isAdmin,
            hasOutgoingMail: isAdmin,
            hasIncomingMail: isAdmin,
            hasSendMail: isAdmin,
            hasAdminHelperSection: isAdmin,
            hasPermissionHelper: isAdmin,
            hasNotificationHelper: isAdmin && !(0, (0, parcelRequire("co1wz")).ff)('sea-1973-notifications-hub'),
            hasSharedSection: isAdmin,
            hasManageDashboards: isAdmin,
            hasManageFilters: isAdmin,
            hasEmailNotificationsLogHelper: (0, (0, parcelRequire("co1wz")).ff)('platform.jlove-pulsar.jlovep-423-jsw-notification-logs-ui'),
            hasAdvancedSection: isAdmin,
            hasAttachments: isAdmin,
            hasEvents: isAdmin,
            hasWebHooks: isAdmin,
            hasServices: isAdmin,
            hasLexoRankManagement: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
        });
});
parcelRegister("aVTmi", function(module, exports) {
    $parcel$export(module.exports, "AdminHelperSection", ()=>$f6a1ba8c0486741e$export$4855b2d78f0d666a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZ4fr;
    var $5Fk4Z;
    var $dC5iT;
    var $8CUq3;
    var $gjTBi;
    var $bWqXX;
    var $co1wz;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $3B8mV;
    const $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
    const $f6a1ba8c0486741e$export$4855b2d78f0d666a = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("3B8mV")).default).adminHelper)
        }, features.hasPermissionHelper && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'permission-helper'
            },
            href: navigationPath.adminHelperPermissionHelper,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("3B8mV")).default).permissionHelper)), features.hasNotificationHelper && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'notification-helper'
            },
            href: navigationPath.adminHelperNotificationHelper,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("3B8mV")).default).notificationHelper)), features.hasEmailNotificationsLogHelper && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'email-notifications-log'
            },
            href: navigationPath.adminHelperEmailNotificationsLogHelper,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles
        }, (0, (0, parcelRequire("co1wz")).ff)('platform.jlove-pulsar.jlovep-1538-notification-email-log-filters_4p0s1') ? formatMessage((0, (0, parcelRequire("3B8mV")).default).adminEmailAuditNotificationsLog) : formatMessage((0, (0, parcelRequire("3B8mV")).default).emailNotificationsLog))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            engagementId: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
        })));
    };
    const $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'space-between'
    });
});
parcelRegister("3B8mV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82b0a510e0e13823$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82b0a510e0e13823$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        adminHelper: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
            "defaultMessage": "Admin helper"
        },
        permissionHelper: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
            "defaultMessage": "Permission helper"
        },
        notificationHelper: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.notification-helper",
            "defaultMessage": "Notification helper"
        },
        emailNotificationsLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.email-notifications-log",
            "defaultMessage": "Unblock user invites"
        },
        adminEmailAuditNotificationsLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
            "defaultMessage": "Admin email audit"
        }
    });
});
parcelRegister("cip1u", function(module, exports) {
    $parcel$export(module.exports, "AdvancedSection", ()=>$55fa8f6cf375a533$export$32bea920eaad7efb);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $68MUk;
    const $55fa8f6cf375a533$export$32bea920eaad7efb = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("68MUk")).default).advanced)
        }, features.hasAttachments && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'attachments'
            },
            href: navigationPath.advancedSectionAttachments,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).attachments)), features.hasEvents && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'events'
            },
            href: navigationPath.advancedSectionEvents,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).events)), features.hasWebHooks && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'webhooks'
            },
            href: navigationPath.advancedSectionWebHooks,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).webhooks)), features.hasLexoRankManagement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'lexorank-management'
            },
            href: navigationPath.advancedLexoRankManagement,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).lexorankManagement)));
    };
});
parcelRegister("68MUk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24a7ac619834e463$export$2e2bcd8739ae039);
    var $7VHMR;
    var $24a7ac619834e463$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        advanced: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
            "defaultMessage": "Advanced"
        },
        attachments: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
            "defaultMessage": "Attachments"
        },
        events: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
            "defaultMessage": "Events"
        },
        webhooks: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
            "defaultMessage": "WebHooks"
        },
        lexorankManagement: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
            "defaultMessage": "LexoRank management"
        }
    });
});
parcelRegister("8wyB3", function(module, exports) {
    $parcel$export(module.exports, "AutomationSection", ()=>$ae233f5e809ec072$export$5fa01e4d25d8e6ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $65Ltd;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $6tKa8;
    const $ae233f5e809ec072$export$5fa01e4d25d8e6ec = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("6tKa8")).default).automationGroup)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            href: navigationPath.globalAutomation,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_AUTOMATION)
            ]
        }, formatMessage((0, (0, parcelRequire("6tKa8")).default).globalAutomation)));
    };
});
parcelRegister("6tKa8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1b0e49ecb7c48dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b1b0e49ecb7c48dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        automationGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
            "defaultMessage": "Automation"
        },
        globalAutomation: {
            "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
            "defaultMessage": "Global automation"
        }
    });
});
parcelRegister("230Wm", function(module, exports) {
    $parcel$export(module.exports, "ImportExportSection", ()=>$45f1c30d97953942$export$2e4cb1dc5b398447);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $2vSU6;
    var $co1wz;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $3SzZi;
    var $4OCke;
    var $9OXo1;
    var $eaZ4X;
    var $jMBA3;
    var $8136S;
    var $bK0J9;
    const $45f1c30d97953942$export$2e4cb1dc5b398447 = ({ stack: stack })=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin, licensedProducts: licensedProducts } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const hasSupportedLicense = licensedProducts[(0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)((0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT))] || licensedProducts[(0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT))];
        const showNewExternalImport = hasSupportedLicense && (isSiteAdmin || !isAdmin || (0, (0, parcelRequire("co1wz")).ff)('enable-product-admin-for-x2c-migration_zmlsv'));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("8136S")).default).importExportGroup)
        }, features.hasBackupManager && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'cloud-export'
            },
            href: navigationPath.importSectionBackupManager,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).backupManager)), features.hasExternalImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'external-import'
            },
            href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
            selectedOn: (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
        }, formatMessage((0, (0, parcelRequire("8136S")).default).externalImport)), features.hasCloudImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'cloud-import'
            },
            href: navigationPath.importSectionCloudImport,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).importJiraCloud)), features.hasServerImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'server-import'
            },
            href: navigationPath.importSectionServerImport,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).importJiraServer)), (0, (0, parcelRequire("3SzZi")).shouldRenderNesting)(features.hasC2CMigration, stack, (0, (0, parcelRequire("eaZ4X")).SECTION_ID).MIGRATE_TO_CLOUD_SITE) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bK0J9")).MigrateCloudSiteMenuItem), null));
    };
});
parcelRegister("3SzZi", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderNesting", ()=>$956cef61e43b05f1$export$a35baff1c4efd3da);
    const $956cef61e43b05f1$export$a35baff1c4efd3da = (condition, stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));
});
parcelRegister("8136S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e31be53e6f399aac$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e31be53e6f399aac$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        importExportGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
            "defaultMessage": "Import and export"
        },
        backupManager: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
            "defaultMessage": "Backup manager"
        },
        externalImport: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
            "defaultMessage": "External System Import"
        },
        restoreSystem: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
            "defaultMessage": "Restore system"
        },
        importJiraCloud: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
            "defaultMessage": "Import Jira Cloud"
        },
        importJiraServer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
            "defaultMessage": "Import Jira Server"
        }
    });
});
parcelRegister("bK0J9", function(module, exports) {
    $parcel$export(module.exports, "MigrateCloudSiteMenuItem", ()=>$4c7a6e794a4b89f4$export$48e579c481d74aac);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $co1wz;
    var $koVbs;
    var $kZj7F;
    var $17bH5;
    var $eaZ4X;
    var $dtw3L;
    var $5wReO;
    var $4gDi8;
    const $4c7a6e794a4b89f4$export$48e579c481d74aac = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { release: release } = (0, (0, parcelRequire("dtw3L")).useReleaseVersion)();
        const BackMenuItem = {
            href: '/jira/settings/system/general-configuration',
            title: formatMessage((0, (0, parcelRequire("5wReO")).messages).itemBack)
        };
        const isBeta = (0, (0, parcelRequire("co1wz")).ff)('jira-frontend-c2c-migrations-ga-release') ? release === 'BETA' : true;
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'migrate-to-cloud-site'
            },
            href: navigationPath.importSectionMigrateCloud,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("5wReO")).messages).migration), ' ', isBeta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                appearance: "new"
            }, formatMessage((0, (0, parcelRequire("5wReO")).messages).migrationBetaLabel))),
            overrides: {
                BackMenuItem: BackMenuItem
            },
            id: (0, (0, parcelRequire("eaZ4X")).SECTION_ID).MIGRATE_TO_CLOUD_SITE
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4gDi8")).MigrationsMenu), null));
    };
});
parcelRegister("dtw3L", function(module, exports) {
    $parcel$export(module.exports, "useReleaseVersion", ()=>$c58df78fc0d0b4fc$export$4ea0c46c431d5d34);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    const $c58df78fc0d0b4fc$export$1a5772dc2221d2a5 = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/migration/c2c_rollout_phase');
    const $c58df78fc0d0b4fc$export$4ea0c46c431d5d34 = ()=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [release, setRelease] = (0, $5uXOq.useState)('GA');
        const [error, setError] = (0, $5uXOq.useState)();
        const fetch = async ()=>{
            try {
                setLoading(true);
                setError(undefined);
                const data = await $c58df78fc0d0b4fc$export$1a5772dc2221d2a5();
                setRelease(data.release);
                setLoading(false);
            } catch (apiError) {
                setLoading(false);
                setError(apiError);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: apiError,
                    meta: {
                        id: 'useReleaseVersion',
                        packageName: 'jiraNavigationAppsSidebarGlobalSettingsSystem',
                        teamName: 'navigation'
                    }
                });
            }
        };
        (0, $5uXOq.useEffect)(()=>{
            fetch();
        }, []);
        return {
            loading: loading,
            release: release,
            error: error
        };
    };
});
parcelRegister("5wReO", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1058bfeeb1474c8c$export$defe85febe8b728c);
    var $7VHMR;
    const $1058bfeeb1474c8c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        migration: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migration",
            "defaultMessage": "Migrate cloud site"
        },
        migrationBetaLabel: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migration-beta-label",
            "defaultMessage": "Beta"
        },
        itemBack: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.item-back",
            "defaultMessage": "Back to system"
        }
    });
});
parcelRegister("4gDi8", function(module, exports) {
    $parcel$export(module.exports, "MigrationsMenu", ()=>$c1e3be64f0bee0e2$export$9a2d2cb9bbe36e75);
    var $5uXOq = parcelRequire("5uXOq");
    var $17Ngn;
    var $gjTBi;
    var $aIZdc;
    var $5P4hV;
    var $f9Owr;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $4OCke;
    var $koeKL;
    var $dEAUf;
    const $c1e3be64f0bee0e2$export$9a2d2cb9bbe36e75 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [{ data: data }, { fetchCohortDetails: fetchCohortDetails }] = (0, (0, parcelRequire("5P4hV")).useCohortDetails)();
        const baseMigrateCloudUrl = '/jira/settings/system/migration';
        (0, $5uXOq.useEffect)(()=>{
            fetchCohortDetails(cloudId);
        }, [
            fetchCohortDetails,
            cloudId
        ]);
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return;
        if (data?.isCohortEnabled && (data?.cohortType === 'NEVER_USED_C2C_JIRA' || data?.cohortType === 'NOT_USED_C2C_JIRA_IN_3_MONTHS' || data?.hasOptedIn || data?.status === 'IN_PROGRESS' || data?.status === 'FAILED' || (0, (0, parcelRequire("f9Owr")).ff)('change-management-cohort-4-ff_4bpld'))) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'migration-home'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseMigrateCloudUrl}/home`
        }, formatMessage((0, (0, parcelRequire("dEAUf")).messages).title));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("dEAUf")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'migration-home'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseMigrateCloudUrl}/home`
        }, formatMessage((0, (0, parcelRequire("dEAUf")).messages).migrationOverview)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'plan-your-migration'
            },
            href: "https://support.atlassian.com/migration/docs/cloud-to-cloud-migration/",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))), {
                size: "small",
                label: ""
            }),
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("dEAUf")).messages).planYourMigration)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'manage-migrations'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseMigrateCloudUrl}/dashboard`
        }, formatMessage((0, (0, parcelRequire("dEAUf")).messages).manageMigrations))));
    };
});
parcelRegister("5P4hV", function(module, exports) {
    $parcel$export(module.exports, "useCohortDetails", ()=>$d555d3765bbcba03$export$79c60a355eee7756);
    var $7JoAD = parcelRequire("7JoAD");
    var $e4Ne3;
    var $k0VTl;
    const $d555d3765bbcba03$var$Store = (0, $7JoAD.createStore)({
        initialState: (0, (0, parcelRequire("k0VTl")).COHORT_DETAILS_DEFAULT_STATE),
        actions: (0, parcelRequire("e4Ne3")).default,
        name: 'Migrations - Cohort details'
    });
    const $d555d3765bbcba03$export$79c60a355eee7756 = (0, $7JoAD.createHook)($d555d3765bbcba03$var$Store);
});
parcelRegister("e4Ne3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5b68a618d6978ef$export$2e2bcd8739ae039);
    var $jcw0u;
    var $eusud;
    var $k0VTl;
    var $kgW7E;
    const $d5b68a618d6978ef$export$343d10549fb4d411 = async (cloudId)=>{
        const fetchUrl = (0, (0, parcelRequire("kgW7E")).getCohortStatusUrl)(cloudId);
        return (0, (0, parcelRequire("eusud")).performGetRequest)(fetchUrl).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchCohortDetails',
                    packageName: 'jiraC2CMigrationsCommonUtils',
                    teamName: 'jira-c2c-migration'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
    const $d5b68a618d6978ef$export$c9cf692e1e990743 = (cloudId)=>{
        return async ({ setState: setState, getState: getState })=>{
            const showOptInButton = (0, (0, parcelRequire("kgW7E")).getOptInModalStatus)();
            setState({
                showOptInButton: showOptInButton
            });
            if (getState().data || getState().loading) return undefined;
            try {
                setState({
                    loading: true
                });
                const data = await $d5b68a618d6978ef$export$343d10549fb4d411(cloudId);
                const derivedOptInButtonStatus = !data.hasOptedIn && data.status !== 'NEVER' || showOptInButton;
                (0, (0, parcelRequire("kgW7E")).setOptInModalStatus)(derivedOptInButtonStatus);
                setState({
                    data: data,
                    loading: false,
                    showOptInButton: derivedOptInButtonStatus
                });
                return {
                    data: data
                };
            } catch (error) {
                setState({
                    error: error,
                    loading: false
                });
                return undefined;
            }
        };
    };
    const $d5b68a618d6978ef$export$e64b646bfdf4078e = (showOptInButton)=>({ setState: setState })=>{
            (0, (0, parcelRequire("kgW7E")).setOptInModalStatus)(showOptInButton);
            setState({
                showOptInButton: showOptInButton
            });
        };
    const $d5b68a618d6978ef$export$aad8462122ac592b = ()=>({ setState: setState })=>{
            setState({
                ...(0, (0, parcelRequire("k0VTl")).COHORT_DETAILS_DEFAULT_STATE),
                data: undefined,
                error: undefined
            });
        };
    var $d5b68a618d6978ef$export$2e2bcd8739ae039 = {
        fetchCohortDetails: $d5b68a618d6978ef$export$c9cf692e1e990743,
        updateShowOptInButton: $d5b68a618d6978ef$export$e64b646bfdf4078e,
        reset: $d5b68a618d6978ef$export$aad8462122ac592b
    };
});
parcelRegister("k0VTl", function(module, exports) {
    $parcel$export(module.exports, "COHORT_DETAILS_DEFAULT_STATE", ()=>$98cc956cfe48207f$export$7108825eea599cbc);
    $parcel$export(module.exports, "SESSION_STORAGE_KEY", ()=>$98cc956cfe48207f$export$5200514808277ba7);
    const $98cc956cfe48207f$export$7108825eea599cbc = {
        loading: false,
        showOptInButton: false
    };
    const $98cc956cfe48207f$export$5200514808277ba7 = 'C2C.MIGRATION.ADMIN.HUB.OPT.IN.BUTTON';
});
parcelRegister("kgW7E", function(module, exports) {
    $parcel$export(module.exports, "getOptInModalStatus", ()=>$3ef4b516c1de88ac$export$e69da0941df3caa9);
    $parcel$export(module.exports, "setOptInModalStatus", ()=>$3ef4b516c1de88ac$export$687080e399c5c65f);
    $parcel$export(module.exports, "getCohortStatusUrl", ()=>$3ef4b516c1de88ac$export$66a62d4e6369f93e);
    var $k0VTl;
    const $3ef4b516c1de88ac$export$e69da0941df3caa9 = ()=>JSON.parse(sessionStorage.getItem((0, (0, parcelRequire("k0VTl")).SESSION_STORAGE_KEY)) || 'false');
    const $3ef4b516c1de88ac$export$687080e399c5c65f = (value)=>sessionStorage.setItem((0, (0, parcelRequire("k0VTl")).SESSION_STORAGE_KEY), String(value));
    const $3ef4b516c1de88ac$export$66a62d4e6369f93e = (cloudId)=>`/gateway/api/migrations/c2c/v1/change-management/cloud-id/${cloudId}/status`;
});
parcelRegister("dEAUf", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$94f7f834fbebc537$export$defe85febe8b728c);
    var $7VHMR;
    const $94f7f834fbebc537$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.title",
            "defaultMessage": "Migrate cloud site"
        },
        migrationOverview: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.migration-overview",
            "defaultMessage": "Migration overview"
        },
        manageMigrations: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.manage-migrations",
            "defaultMessage": "Migration dashboard"
        },
        planYourMigration: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.plan-your-migration",
            "defaultMessage": "Plan your migration"
        }
    });
});
parcelRegister("je2KE", function(module, exports) {
    $parcel$export(module.exports, "MailSection", ()=>$6a76fa07c85a01a9$export$6e0cda39522c0aa7);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $1c6JR;
    var $gb7H7;
    const $6a76fa07c85a01a9$export$6e0cda39522c0aa7 = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("1c6JR")).default).mailGroup)
        }, features.hasGlobalMailSettings && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'global-mail-settings'
            },
            href: navigationPath.mailSectionGlobalMailSettings,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).globalMailSettings)), features.hasOutgoingMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'outgoing-mail'
            },
            href: navigationPath.mailSectionOutgoingMail,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).outgoingMail)), features.hasIncomingMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'incoming-mail'
            },
            href: navigationPath.mailSectionIncomingMail,
            selectedOn: (0, (0, parcelRequire("gb7H7")).isIncomingMailSelected)
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).incomingMail)), features.hasSendMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'send-email'
            },
            href: navigationPath.mailSectionSendMail,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).sendEmail)));
    };
});
parcelRegister("1c6JR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa5900167b5101d6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fa5900167b5101d6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        mailGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
            "defaultMessage": "Mail"
        },
        globalMailSettings: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
            "defaultMessage": "Global Mail Settings"
        },
        outgoingMail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
            "defaultMessage": "Outgoing Mail"
        },
        incomingMail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
            "defaultMessage": "Incoming Mail"
        },
        sendEmail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
            "defaultMessage": "Send email"
        }
    });
});
parcelRegister("gb7H7", function(module, exports) {
    $parcel$export(module.exports, "isIncomingMailSelected", ()=>$d695081436bd6a1d$export$3f53f72603975cb0);
    var $4OCke;
    const $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
    const $d695081436bd6a1d$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("iAlf2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$979d16a4bf22949b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $979d16a4bf22949b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        systemGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
            "defaultMessage": "System"
        },
        generalConfiguration: {
            "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
            "defaultMessage": "General configuration"
        },
        darkFeatures: {
            "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
            "defaultMessage": "Dark features"
        },
        issueCollectors: {
            "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
            "defaultMessage": "Issue collectors"
        },
        globalSettingsSystemSidebarLabel: {
            "id": "spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label",
            "defaultMessage": "Side"
        }
    });
});
parcelRegister("fwlYA", function(module, exports) {
    $parcel$export(module.exports, "SecuritySection", ()=>$76b3d515542acad4$export$4f16aec1633bed7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $eTPZ8;
    var $icmgW;
    const $76b3d515542acad4$export$4f16aec1633bed7d = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const globalPermissionsPath = navigationPath.securityGlobalPermissions;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("eTPZ8")).default).securityGroup)
        }, features.hasProjectRoles && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'project-roles'
            },
            href: navigationPath.securityProjectRoles,
            selectedOn: (0, (0, parcelRequire("icmgW")).isProjectRolesSelected)
        }, formatMessage((0, (0, parcelRequire("eTPZ8")).default).projectRoles)), features.hasGlobalPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'global-permissions'
            },
            href: globalPermissionsPath,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("eTPZ8")).default).globalPermissions)));
    };
});
parcelRegister("eTPZ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db51b59205472bbf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $db51b59205472bbf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        securityGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
            "defaultMessage": "Security"
        },
        projectRoles: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
            "defaultMessage": "Project roles"
        },
        globalPermissions: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
            "defaultMessage": "Global permissions"
        }
    });
});
parcelRegister("icmgW", function(module, exports) {
    $parcel$export(module.exports, "isProjectRolesSelected", ()=>$f6a84fa88243c239$export$ca9501e7fedfce90);
    var $4OCke;
    const $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
    const $f6a84fa88243c239$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("9O5DC", function(module, exports) {
    $parcel$export(module.exports, "SharedSection", ()=>$440640fab2704f98$export$230e518497f06fdc);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $hw0ew;
    const $440640fab2704f98$export$230e518497f06fdc = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("hw0ew")).default).sharedItems)
        }, features.hasManageFilters && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'manage-filters'
            },
            href: navigationPath.sharedSectionManageFilters,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("hw0ew")).default).filters)), features.hasManageDashboards && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'manage-dashboards'
            },
            href: navigationPath.sharedManageDashboards,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("hw0ew")).default).dashboards)));
    };
});
parcelRegister("hw0ew", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a51482729945d2e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4a51482729945d2e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sharedItems: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
            "defaultMessage": "Shared Items"
        },
        sharedFilters: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
            "defaultMessage": "Shared filters"
        },
        sharedDashboards: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
            "defaultMessage": "Shared dashboards"
        },
        filters: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
            "defaultMessage": "Filters"
        },
        dashboards: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
            "defaultMessage": "Dashboards"
        }
    });
});
parcelRegister("1y2CG", function(module, exports) {
    $parcel$export(module.exports, "TroubleshootingAndSupportSection", ()=>$5fd448f06aadda25$export$dad01649916e6a2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $fRwoF;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $4oL80;
    var $81Iv5;
    var $ie4oV;
    const $5fd448f06aadda25$export$dad01649916e6a2d = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, (0, parcelRequire("fRwoF")).useSiteOptimizerCheck)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("4oL80")).default).troubleshootingGroup)
        }, features.hasViewAuditing && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'view-auditing'
            },
            href: navigationPath.troubleshootingAuditLog,
            selectedOn: (0, (0, parcelRequire("ie4oV")).isViewAuditingSelected)
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).auditLog)), features.hasPluginViewer && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'plugin-viewer'
            },
            href: navigationPath.troubleshootingPluginViewer,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).pluginViewer)), features.hasModulesViewer && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'modules-viewer'
            },
            href: navigationPath.troubleshootingModulesViewer,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).modulesViewer)), features.hasSystemInfo && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'system-info'
            },
            href: navigationPath.troubleshootingSystemInfo,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).systemInfo)), features.hasIntegrityChecker && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'integrity-checker'
            },
            href: navigationPath.troubleshootingIntegrityChecker,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).integrityChecker)), features.hasLoggingProfiling && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'logging-profiling'
            },
            href: navigationPath.troubleshootingLoggingProfiling,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).loggingProfiling)), features.hasSchedulerDetails && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'scheduler-details'
            },
            href: navigationPath.troubleshootingSchedulerDetails,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).schedulerDetails)), hasSiteOptimizerEntitlement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81Iv5")).PerformanceMenuItem), null));
    };
});
parcelRegister("fRwoF", function(module, exports) {
    $parcel$export(module.exports, "useSiteOptimizerCheck", ()=>$31e8f2ad3b3f051f$export$7df80afc329cd61);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $eusud;
    const $31e8f2ad3b3f051f$export$e9921a980669184 = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/psi/latest/licence/check');
    const $31e8f2ad3b3f051f$export$7df80afc329cd61 = ()=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [hasEntitlement, setHasEntitlement] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)();
        const fetch = async ()=>{
            try {
                setLoading(true);
                setError(undefined);
                if ((0, (0, parcelRequire("co1wz")).ff)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
                else {
                    const data = await $31e8f2ad3b3f051f$export$e9921a980669184();
                    setHasEntitlement(data?.isVisible ?? false);
                }
                setLoading(false);
            } catch (apiError) {
                setLoading(false);
                setError(apiError);
            }
        };
        (0, $5uXOq.useEffect)(()=>{
            fetch();
        }, []);
        return {
            loading: loading,
            hasSiteOptimizerEntitlement: hasEntitlement,
            error: error
        };
    };
});
parcelRegister("4oL80", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ca98bc392d099f0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ca98bc392d099f0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        troubleshootingGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
            "defaultMessage": "Troubleshooting and Support"
        },
        auditLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
            "defaultMessage": "Audit Log"
        },
        pluginViewer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
            "defaultMessage": "Plugin Viewer"
        },
        modulesViewer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
            "defaultMessage": "Modules Viewer"
        },
        systemInfo: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
            "defaultMessage": "System info"
        },
        integrityChecker: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
            "defaultMessage": "Integrity checker"
        },
        loggingProfiling: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
            "defaultMessage": "Logging profiling"
        },
        schedulerDetails: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
            "defaultMessage": "Scheduler details"
        }
    });
});
parcelRegister("81Iv5", function(module, exports) {
    $parcel$export(module.exports, "PerformanceMenuItem", ()=>$ca611bfc0be59ae0$export$b4e98631ff0b3fb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $imZsD;
    var $5Fk4Z;
    var $1QiBP;
    var $dC5iT;
    var $kgoHi;
    var $koVbs;
    var $kZj7F;
    var $17bH5;
    var $8zOmE;
    var $ehdJY;
    var $90yGq;
    var $eaZ4X;
    var $1ssva;
    var $iWjQg;
    var $fM231;
    const $ca611bfc0be59ae0$export$b4e98631ff0b3fb5 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $5uXOq.useState)(false);
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        const BackMenuItem = {
            href: '/jira/settings/system/general-configuration',
            title: formatMessage((0, (0, parcelRequire("1ssva")).default).itemBack)
        };
        const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
            if (accountId != null) {
                const response = await (0, (0, parcelRequire("fM231")).hasSeenSiteOptimiserSpotlight)(accountId);
                setIsOptimiserSpotlightActive(!response);
            }
        }, [
            accountId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchSpotlightState();
        }, [
            fetchSpotlightState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "site-optimiser-spotlight"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'performance-and-scale'
            },
            href: navigationPath.troubleshootingPerformanceAndScale,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                gap: "space.050",
                justifyContent: "start",
                alignItems: "center"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, formatMessage((0, (0, parcelRequire("1ssva")).default).performanceAndScale)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                appearance: "new"
            }, formatMessage((0, (0, parcelRequire("1ssva")).default).beta))),
            overrides: {
                BackMenuItem: BackMenuItem
            },
            id: (0, (0, parcelRequire("eaZ4X")).SECTION_ID).PERFORMANCE_AND_SCALE
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iWjQg")).PerformanceAndScaleMenu), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, isOptimiserSpotlightActive && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            actions: [
                {
                    onClick: (_, analyticsEvent)=>{
                        setIsOptimiserSpotlightActive(false);
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                    },
                    text: formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightAction)
                }
            ],
            heading: formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightHeading),
            target: "site-optimiser-spotlight",
            key: "site-optimiser-spotlight",
            targetRadius: 3,
            targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            dialogPlacement: "right top",
            messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
            messageType: "engagement"
        }, formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightBody))));
    };
});
parcelRegister("ehdJY", function(module, exports) {
    $parcel$export(module.exports, "JiraSpotlight", ()=>$61a8dc1ff1116911$export$e209c6be9ab8c4f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7gs1W;
    var $10xFf;
    var $5NHqU;
    const $61a8dc1ff1116911$export$e209c6be9ab8c4f4 = (props)=>{
        if ((0, (0, parcelRequire("10xFf")).shouldBeChoreographed)(props)) {
            const { messageType: messageType, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5NHqU")).ChoreographerSpotlight), rest);
        }
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7gs1W")).default), rest);
    };
});
parcelRegister("10xFf", function(module, exports) {
    $parcel$export(module.exports, "shouldBeChoreographed", ()=>$36201c75b4df20a7$export$a8ba9111c7eec9ac);
    $parcel$export(module.exports, "environmentToEnvType", ()=>$36201c75b4df20a7$export$e2cf19200849be9e);
    var $iZhen;
    var $t6tX9;
    function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
        return !!props?.messageType && (0, (0, parcelRequire("t6tX9")).IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
    }
    function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
        switch(environment){
            case 'dev':
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            case 'staging':
                return (0, (0, parcelRequire("iZhen")).envType).STAGING;
            case 'prod':
                return (0, (0, parcelRequire("iZhen")).envType).PROD;
            default:
                return (0, (0, parcelRequire("iZhen")).envType).LOCAL;
        }
    }
});
parcelRegister("t6tX9", function(module, exports) {
    $parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", ()=>$b5642a17fa90b00d$export$dbe9e38c9d6f26d0);
    const $b5642a17fa90b00d$export$94e85cf3348f045a = {
        ENGAGEMENT: 'engagement',
        MARKETING: 'marketing',
        TRANSACTIONAL: 'transactional'
    };
    const $b5642a17fa90b00d$export$dbe9e38c9d6f26d0 = [
        $b5642a17fa90b00d$export$94e85cf3348f045a.ENGAGEMENT,
        $b5642a17fa90b00d$export$94e85cf3348f045a.MARKETING
    ];
});
parcelRegister("5NHqU", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerSpotlight", ()=>$b7d2a49fe3b12822$export$e01943d134357d00);
    var $7gs1W;
    var $cSWNW;
    const $b7d2a49fe3b12822$export$e01943d134357d00 = (0, (0, parcelRequire("cSWNW")).withChoreographedRender)((0, (0, parcelRequire("7gs1W")).default));
});
parcelRegister("cSWNW", function(module, exports) {
    $parcel$export(module.exports, "withChoreographedRender", ()=>$620c1a9f3fec1a68$export$c1160fdac17030e);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    function $620c1a9f3fec1a68$export$c1160fdac17030e(Component, options) {
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
            const shouldRender = (0, (0, parcelRequire("fG5AJ")).useChoreographedRender)({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props);
            if (options && options.toggleableProp) {
                const toggleableComponentProps = {
                    ...props,
                    [options.toggleableProp]: false
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, toggleableComponentProps);
            }
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    }
});
parcelRegister("fG5AJ", function(module, exports) {
    $parcel$export(module.exports, "getPendoPlugin", ()=>$596f0fde3f3a2d5a$export$3d3a86b2d636214b);
    $parcel$export(module.exports, "useChoreographer", ()=>$596f0fde3f3a2d5a$export$9f0e2488ffd90f11);
    $parcel$export(module.exports, "ChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    $parcel$export(module.exports, "useChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$2eb1efa814fe4a);
    $parcel$export(module.exports, "useChoreographedRender", ()=>$596f0fde3f3a2d5a$export$2cfd68294be82811);
    var $5uXOq = parcelRequire("5uXOq");
    var $4zICj;
    var $8r6xd;
    var $TTRxY;
    var $j8DrX;
    var $7qPn9;
    const $596f0fde3f3a2d5a$var$environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment')) ?? 'prod';
    const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
        if (false) return {
            useChoreographer: (..._)=>({
                    startMessage: ()=>Promise.resolve(''),
                    stopMessage: ()=>{}
                })
        };
        return (0, (0, parcelRequire("4zICj")).choreographerFactory)((0, (0, parcelRequire("TTRxY")).ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
    };
    let $596f0fde3f3a2d5a$var$pendoPlugin;
    function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
        if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, (0, parcelRequire("8r6xd")).PendoChoreographerPlugin)(env, {
            sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
        });
        return $596f0fde3f3a2d5a$var$pendoPlugin;
    }
    const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11 } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
    const $596f0fde3f3a2d5a$export$3ff96dbefca6b00d = (0, $5uXOq.createContext)({
        isAlreadyChoreographedAtAncestor: false
    });
    const $596f0fde3f3a2d5a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $596f0fde3f3a2d5a$export$2eb1efa814fe4a();
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
            start: ()=>setShouldRender(true)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isAlreadyChoreographedAtAncestor) {
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                startMessageAsync();
                return ()=>{
                    stopMessage();
                };
            }
        }, [
            onMessageDisposition,
            startMessage,
            stopMessage,
            isAlreadyChoreographedAtAncestor
        ]);
        return shouldRender || isAlreadyChoreographedAtAncestor;
    };
});
parcelRegister("90yGq", function(module, exports) {
    $parcel$export(module.exports, "useAccountId", ()=>$903db0de2618ef6c$export$e72033e0f5baa3e);
    var $9OXo1;
    const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.atlassianAccountId || null;
    };
});
parcelRegister("1ssva", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46da0b37092f9f6a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $46da0b37092f9f6a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        performanceAndScale: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
            "defaultMessage": "Site optimizer"
        },
        itemBack: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
            "defaultMessage": "Back to system"
        },
        spotlightHeading: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
            "defaultMessage": "Clean up your site"
        },
        spotlightBody: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
            "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
        },
        spotlightAction: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
            "defaultMessage": "Ok"
        },
        beta: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
            "defaultMessage": "Beta"
        }
    });
});
parcelRegister("iWjQg", function(module, exports) {
    $parcel$export(module.exports, "PerformanceAndScaleMenu", ()=>$4bb22b80a7726eba$export$442d4ccb0d25fc50);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $gjTBi;
    var $lzUDm;
    var $fgWYz;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $4OCke;
    var $etuUp;
    var $jWIOc;
    const $4bb22b80a7726eba$export$442d4ccb0d25fc50 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const basePerformanceUrl = '/jira/settings/system/performance';
        const allVisibleMetrics = (0, (0, parcelRequire("fgWYz")).getAllVisibleMetrics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("etuUp")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'performance-overview'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${basePerformanceUrl}/overview`
        }, formatMessage((0, (0, parcelRequire("etuUp")).default).overview))), allVisibleMetrics.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("etuUp")).default).allReports)
        }, allVisibleMetrics.map((metric)=>{
            if (metric.key === (0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP_KEY)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: "project-cleanup-item"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                name: (0, (0, parcelRequire("jWIOc")).PROJECT_CLEANUP_SPOTLIGHT_NAME)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: `performance-metric-${metric.key}`
                },
                href: `${basePerformanceUrl}/metrics/${metric.key}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                key: metric.key
            }, formatMessage(metric.name))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWIOc")).ProjectCleanupSpotlight), null));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: `performance-metric-${metric.key}`
                },
                href: `${basePerformanceUrl}/metrics/${metric.key}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                key: metric.key
            }, formatMessage(metric.name));
        })));
    };
});
parcelRegister("lzUDm", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_CLEANUP_KEY", ()=>$3bfe695ee69b7be4$export$4e9bf1d386c2f0c);
    $parcel$export(module.exports, "PROJECT_CLEANUP", ()=>$3bfe695ee69b7be4$export$761acf34bef3a717);
    var $iHO6d;
    const $3bfe695ee69b7be4$export$4e9bf1d386c2f0c = 'projectcleanup';
    const $3bfe695ee69b7be4$export$761acf34bef3a717 = {
        key: $3bfe695ee69b7be4$export$4e9bf1d386c2f0c,
        visible: true,
        name: (0, (0, parcelRequire("iHO6d")).default).nameNonFinal,
        description: (0, (0, parcelRequire("iHO6d")).default).descriptionNonFinal,
        tabLabels: [
            (0, (0, parcelRequire("iHO6d")).default).analysisNonFinal,
            (0, (0, parcelRequire("iHO6d")).default).activityLogNonFinal
        ],
        warningMessage: (0, (0, parcelRequire("iHO6d")).default).warningNonFinal,
        exceededMessage: (0, (0, parcelRequire("iHO6d")).default).exceededNonFinal,
        risks: [],
        mitigations: [],
        currentValueLabel: (0, (0, parcelRequire("iHO6d")).default).currentValueLabel,
        cleanupValueLabel: (0, (0, parcelRequire("iHO6d")).default).cleanupValueLabel,
        graphHeader: (0, (0, parcelRequire("iHO6d")).default).graphHeader,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
        recommendationUrlText: (0, (0, parcelRequire("iHO6d")).default).recommendationUrlText
    };
});
parcelRegister("iHO6d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$622f291bdb5f6890$export$2e2bcd8739ae039);
    var $7VHMR;
    const $622f291bdb5f6890$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $622f291bdb5f6890$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
    const $622f291bdb5f6890$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $622f291bdb5f6890$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $622f291bdb5f6890$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $622f291bdb5f6890$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
    const $622f291bdb5f6890$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $622f291bdb5f6890$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $622f291bdb5f6890$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        nameNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
            "defaultMessage": "Projects"
        },
        descriptionNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
            "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
            "defaultMessage": "See how we identify these projects."
        },
        analysisNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
            "defaultMessage": "Analysis"
        },
        activityLogNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
            "defaultMessage": "Activity log"
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
            "defaultMessage": "Projects over time"
        },
        warningNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
            "defaultMessage": "The number of projects is nearing our recommended threshold."
        },
        exceededNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
            "defaultMessage": "There are some project..."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
            "defaultMessage": "Projects in your site"
        },
        cleanupValueLabel: {
            "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
            "defaultMessage": "Recommended for cleanup"
        }
    });
});
parcelRegister("fgWYz", function(module, exports) {
    $parcel$export(module.exports, "getAllVisibleMetrics", ()=>$2cc6642f29a0adee$export$e6140fda06493d18);
    $parcel$export(module.exports, "getMetric", ()=>$2cc6642f29a0adee$export$ed0dc1178a679c67);
    $parcel$export(module.exports, "getAllVisibleMetricKeys", ()=>$2cc6642f29a0adee$export$1f2abf3e170d35d2);
    $parcel$export(module.exports, "assertNever", ()=>$2cc6642f29a0adee$export$cbadc5a7223772a8);
    var $4R6GH;
    var $8MHQY;
    var $cOrKR;
    var $lzUDm;
    var $3AEMX;
    var $gtb9f;
    class $2cc6642f29a0adee$export$9419457073a1750 {
        constructor(metrics){
            this.metrics = metrics;
        }
        getMetric(key) {
            return this.metrics.find((m)=>m.key === key);
        }
        getAllVisibleMetrics() {
            return this.metrics.filter((metric)=>metric.visible && $2cc6642f29a0adee$export$898df584445641cf(metric.key));
        }
        getAllVisibleMetricsKeys() {
            return $2cc6642f29a0adee$export$e6140fda06493d18().map((m)=>m.key);
        }
    }
    const $2cc6642f29a0adee$var$REGISTRY = new $2cc6642f29a0adee$export$9419457073a1750((0, (0, parcelRequire("gtb9f")).METRICS));
    const $2cc6642f29a0adee$export$ed0dc1178a679c67 = $2cc6642f29a0adee$var$REGISTRY.getMetric.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$export$e6140fda06493d18 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetrics.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$export$1f2abf3e170d35d2 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetricsKeys.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$export$898df584445641cf = (metricKey)=>{
        switch(metricKey){
            case 0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP_KEY:
                return (0, (0, parcelRequire("4R6GH")).fg)('site-optimizer-project-cleanup');
            case 0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR_KEY:
            case 0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS_KEY:
            case 0, (0, parcelRequire("cOrKR")).ISSUE_KEY:
                return true;
            default:
                return false;
        }
    };
    const $2cc6642f29a0adee$export$cbadc5a7223772a8 = (_, message)=>{
        throw new Error(message);
    };
});
parcelRegister("8MHQY", function(module, exports) {
    $parcel$export(module.exports, "CUSTOM_FIELDS_KEY", ()=>$1dd393ebccb36050$export$d214286a7039b004);
    $parcel$export(module.exports, "CUSTOM_FIELDS", ()=>$1dd393ebccb36050$export$459112111ad5b136);
    var $9TSwz;
    const $1dd393ebccb36050$export$d214286a7039b004 = 'customField';
    const $1dd393ebccb36050$export$459112111ad5b136 = {
        key: $1dd393ebccb36050$export$d214286a7039b004,
        visible: true,
        name: (0, (0, parcelRequire("9TSwz")).default).name,
        description: (0, (0, parcelRequire("9TSwz")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("9TSwz")).default).chart,
            (0, (0, parcelRequire("9TSwz")).default).reviewAndAnalyze
        ],
        warningMessage: (0, (0, parcelRequire("9TSwz")).default).warning,
        exceededMessage: (0, (0, parcelRequire("9TSwz")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("9TSwz")).default).risk1
        ],
        mitigations: [],
        currentValueLabel: (0, (0, parcelRequire("9TSwz")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("9TSwz")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("9TSwz")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("9TSwz")).default).thresholdValueAriaLabel,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
        recommendationUrlText: (0, (0, parcelRequire("9TSwz")).default).recommendationUrlText,
        graphHeader: (0, (0, parcelRequire("9TSwz")).default).graphHeader
    };
});
parcelRegister("9TSwz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb4cda92a9b67081$export$2e2bcd8739ae039);
    var $7VHMR;
    const $eb4cda92a9b67081$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $eb4cda92a9b67081$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $eb4cda92a9b67081$var$CHART_DESC = 'A tab label of Custom Field Tabs, to show custom fields chart';
    const $eb4cda92a9b67081$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Custom Field Tabs, to show custom fields review and analyze';
    const $eb4cda92a9b67081$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $eb4cda92a9b67081$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $eb4cda92a9b67081$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $eb4cda92a9b67081$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $eb4cda92a9b67081$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $eb4cda92a9b67081$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $eb4cda92a9b67081$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $eb4cda92a9b67081$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $eb4cda92a9b67081$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.custom-fields.name",
            "defaultMessage": "Custom fields"
        },
        description: {
            "id": "admin-pages-performance.common.assets.custom-fields.description",
            "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
        },
        chart: {
            "id": "admin-pages-performance.common.assets.custom-fields.chart",
            "defaultMessage": "Overview"
        },
        reviewAndAnalyze: {
            "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
            "defaultMessage": "Analysis"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.custom-fields.warning",
            "defaultMessage": "The number of custom fields is nearing our recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
            "defaultMessage": "There are more custom fields than our recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
            "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
            "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
            "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
            "defaultMessage": "Custom fields in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
            "defaultMessage": "Recommended maximum number of custom fields"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
            "defaultMessage": "{number} custom fields in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of custom fields"
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
            "defaultMessage": "See how we identify these fields."
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
            "defaultMessage": "Custom fields over time"
        }
    });
});
parcelRegister("cOrKR", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_KEY", ()=>$a0748d951ae09b9b$export$5daa28d10e23592);
    $parcel$export(module.exports, "ISSUE", ()=>$a0748d951ae09b9b$export$76a449e52fa0e1e8);
    var $jWT6h;
    const $a0748d951ae09b9b$export$5daa28d10e23592 = 'issue';
    const $a0748d951ae09b9b$export$76a449e52fa0e1e8 = {
        key: $a0748d951ae09b9b$export$5daa28d10e23592,
        visible: true,
        name: (0, (0, parcelRequire("jWT6h")).default).name,
        description: (0, (0, parcelRequire("jWT6h")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("jWT6h")).default).reviewAndAnalyze,
            (0, (0, parcelRequire("jWT6h")).default).activityLog
        ],
        warningMessage: (0, (0, parcelRequire("jWT6h")).default).warning,
        exceededMessage: (0, (0, parcelRequire("jWT6h")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("jWT6h")).default).risk1
        ],
        mitigations: [
            (0, (0, parcelRequire("jWT6h")).default).mitigation1,
            (0, (0, parcelRequire("jWT6h")).default).mitigation2,
            (0, (0, parcelRequire("jWT6h")).default).mitigation3
        ],
        currentValueLabel: (0, (0, parcelRequire("jWT6h")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("jWT6h")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("jWT6h")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("jWT6h")).default).thresholdValueAriaLabel,
        graphHeader: (0, (0, parcelRequire("jWT6h")).default).graphHeader
    };
});
parcelRegister("jWT6h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5991724b8695ea5$export$2e2bcd8739ae039);
    var $7VHMR;
    const $a5991724b8695ea5$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $a5991724b8695ea5$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $a5991724b8695ea5$var$CHART_DESC = 'A tab label of Issue Tabs, to show Issue chart';
    const $a5991724b8695ea5$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Issue Tabs, to show issue review and analyze';
    const $a5991724b8695ea5$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $a5991724b8695ea5$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $a5991724b8695ea5$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $a5991724b8695ea5$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $a5991724b8695ea5$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $a5991724b8695ea5$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $a5991724b8695ea5$var$ACTIVITY_LOG_DESC = 'A tab label of Activity Log Tabs, to show Issue Archival past operations';
    const $a5991724b8695ea5$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $a5991724b8695ea5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.issue.name",
            "defaultMessage": "Issues"
        },
        description: {
            "id": "admin-pages-performance.common.assets.issue.description",
            "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
        },
        chart: {
            "id": "admin-pages-performance.common.assets.issue.chart",
            "defaultMessage": "Overview"
        },
        reviewAndAnalyze: {
            "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
            "defaultMessage": "Analysis"
        },
        activityLog: {
            "id": "admin-pages-performance.common.assets.issue.activity-log",
            "defaultMessage": "Activity log"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.issue.warning",
            "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.issue.exceeded",
            "defaultMessage": "There are more issues in the system than our recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.issue.risk-1",
            "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-1",
            "defaultMessage": "Delete any projects that are no longer required."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-2",
            "defaultMessage": "Disable Jira integrations that create issues you don't need."
        },
        mitigation3: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-3",
            "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.issue.current-value-label",
            "defaultMessage": "Total current issues in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
            "defaultMessage": "Recommended maximum number of issues"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
            "defaultMessage": "{number} total current issues in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of issues"
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.issue.graph-header",
            "defaultMessage": "Issues over time"
        }
    });
});
parcelRegister("3AEMX", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", ()=>$c7627c0e6530f4b1$export$a570ca3f6cc5e280);
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR", ()=>$c7627c0e6530f4b1$export$fc3d2ee6c3fb3908);
    var $j0D55;
    const $c7627c0e6530f4b1$export$a570ca3f6cc5e280 = 'projectroleactor';
    const $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908 = {
        key: $c7627c0e6530f4b1$export$a570ca3f6cc5e280,
        visible: true,
        name: (0, (0, parcelRequire("j0D55")).default).name,
        description: (0, (0, parcelRequire("j0D55")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("j0D55")).default).analysis,
            (0, (0, parcelRequire("j0D55")).default).activityLog
        ],
        warningMessage: (0, (0, parcelRequire("j0D55")).default).warning,
        exceededMessage: (0, (0, parcelRequire("j0D55")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("j0D55")).default).risk1
        ],
        mitigations: [
            (0, (0, parcelRequire("j0D55")).default).mitigation1,
            (0, (0, parcelRequire("j0D55")).default).mitigation2,
            (0, (0, parcelRequire("j0D55")).default).mitigation3
        ],
        currentValueLabel: (0, (0, parcelRequire("j0D55")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("j0D55")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("j0D55")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("j0D55")).default).thresholdValueAriaLabel,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
        recommendationUrlText: (0, (0, parcelRequire("j0D55")).default).recommendationUrlText,
        graphHeader: (0, (0, parcelRequire("j0D55")).default).graphHeader
    };
});
parcelRegister("j0D55", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6549fa32a8352dcb$export$2e2bcd8739ae039);
    var $7VHMR;
    const $6549fa32a8352dcb$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $6549fa32a8352dcb$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $6549fa32a8352dcb$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $6549fa32a8352dcb$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $6549fa32a8352dcb$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $6549fa32a8352dcb$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $6549fa32a8352dcb$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $6549fa32a8352dcb$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $6549fa32a8352dcb$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $6549fa32a8352dcb$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $6549fa32a8352dcb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.project-role-actor.name",
            "defaultMessage": "Project role permissions"
        },
        description: {
            "id": "admin-pages-performance.common.assets.project-role-actor.description",
            "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
        },
        analysis: {
            "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
            "defaultMessage": "Analysis"
        },
        activityLog: {
            "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
            "defaultMessage": "Activity log"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.project-role-actor.warning",
            "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
            "defaultMessage": "Your number of project role memberships is over the recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
            "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
            "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
            "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
        },
        mitigation3: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
            "defaultMessage": "Use the default project role members in your permission scheme."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
            "defaultMessage": "Current project role permissions in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
            "defaultMessage": "Recommended maximum number of permissions"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
            "defaultMessage": "{number} current project role permissions in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of permissions"
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
            "defaultMessage": "Learn more about optimizing your project role memberships."
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
            "defaultMessage": "Project role permissions over time"
        }
    });
});
parcelRegister("gtb9f", function(module, exports) {
    $parcel$export(module.exports, "METRICS", ()=>$713364f722667f6e$export$3f0e99ae6e0ec541);
    $parcel$export(module.exports, "RUN_ANALYSIS", ()=>$713364f722667f6e$export$769b1a9477352cf9);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS", ()=>$713364f722667f6e$export$e7e31b14c32e055a);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", ()=>$713364f722667f6e$export$d96fe00ff2b38bae);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", ()=>$713364f722667f6e$export$3d4bb5f187c6844e);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", ()=>$713364f722667f6e$export$5c1079e323f5d5bd);
    $parcel$export(module.exports, "TAB_CLICKED", ()=>$713364f722667f6e$export$d358fc12daa9f606);
    $parcel$export(module.exports, "RECOMMENDATIONS_LOADED", ()=>$713364f722667f6e$export$60cc0c61c99a5b81);
    $parcel$export(module.exports, "METRIC_CARD_CLICKED", ()=>$713364f722667f6e$export$71794f4d197278dc);
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", ()=>$713364f722667f6e$export$9e34afbf86922b4a);
    $parcel$export(module.exports, "projectRoleActorAttributes", ()=>$713364f722667f6e$export$d6761557c91eea50);
    $parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", ()=>$713364f722667f6e$export$4e4b9391f7936ba2);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", ()=>$713364f722667f6e$export$70525d18051240f4);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", ()=>$713364f722667f6e$export$4951e0e034b50b9c);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", ()=>$713364f722667f6e$export$108288df7758f60c);
    $parcel$export(module.exports, "VIEW_ISSUES", ()=>$713364f722667f6e$export$972d5a8da0d9f4c3);
    $parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", ()=>$713364f722667f6e$export$b920363d50bcf753);
    $parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", ()=>$713364f722667f6e$export$a84a5210fbad774);
    $parcel$export(module.exports, "JQL_SEARCH", ()=>$713364f722667f6e$export$5c2df36fdd8476f7);
    $parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", ()=>$713364f722667f6e$export$77f23f1b921d5321);
    $parcel$export(module.exports, "issueAnalyticsAttributes", ()=>$713364f722667f6e$export$c62a52f3f7d80ec3);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", ()=>$713364f722667f6e$export$8daffc99348bf555);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", ()=>$713364f722667f6e$export$20f13a04bc3e5d74);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", ()=>$713364f722667f6e$export$ed285e0e924b673c);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", ()=>$713364f722667f6e$export$26f5d7eae10db511);
    $parcel$export(module.exports, "customFieldAttributes", ()=>$713364f722667f6e$export$33989f74b6ba0674);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", ()=>$713364f722667f6e$export$d39b24a650c6c79d);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", ()=>$713364f722667f6e$export$eca4028936acf763);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", ()=>$713364f722667f6e$export$9ba0a5caedb0ff37);
    $parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", ()=>$713364f722667f6e$export$7b6bf63452d40db8);
    $parcel$export(module.exports, "DOWNLOAD_CSV", ()=>$713364f722667f6e$export$efdb93c7210090d1);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", ()=>$713364f722667f6e$export$6c650be5c2b4774f);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", ()=>$713364f722667f6e$export$6493dd0e190d3f58);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", ()=>$713364f722667f6e$export$422673ba1cec4aed);
    $parcel$export(module.exports, "PROJECT_CLEAN_UP", ()=>$713364f722667f6e$export$3a7186fc63c9e188);
    $parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", ()=>$713364f722667f6e$export$8e0b8859a3cbd9e6);
    $parcel$export(module.exports, "ACTION_TRASH", ()=>$713364f722667f6e$export$342d8b9804e407c7);
    $parcel$export(module.exports, "ACTION_ARCHIVE", ()=>$713364f722667f6e$export$b685f2109baf2b4f);
    $parcel$export(module.exports, "ACTION_UNARCHIVE", ()=>$713364f722667f6e$export$3ac60b381ed426ca);
    var $8MHQY;
    var $cOrKR;
    var $lzUDm;
    var $3AEMX;
    const $713364f722667f6e$export$3f0e99ae6e0ec541 = [
        (0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS),
        (0, (0, parcelRequire("cOrKR")).ISSUE),
        (0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR),
        (0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP)
    ];
    const $713364f722667f6e$export$769b1a9477352cf9 = 'runAnalysis';
    const $713364f722667f6e$export$e7e31b14c32e055a = 'deleteRecommendations';
    const $713364f722667f6e$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
    const $713364f722667f6e$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
    const $713364f722667f6e$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
    const $713364f722667f6e$export$d358fc12daa9f606 = 'psiTab';
    const $713364f722667f6e$export$60cc0c61c99a5b81 = 'recommendations loaded';
    const $713364f722667f6e$export$71794f4d197278dc = 'mitigationMetricCard';
    const $713364f722667f6e$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
    const $713364f722667f6e$export$d6761557c91eea50 = {
        metric: (0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR_KEY)
    };
    const $713364f722667f6e$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
    const $713364f722667f6e$export$70525d18051240f4 = 'restoreIssueArchival';
    const $713364f722667f6e$export$4951e0e034b50b9c = 'restoreIssueCancel';
    const $713364f722667f6e$export$108288df7758f60c = 'restoreIssueTryAgain';
    const $713364f722667f6e$export$972d5a8da0d9f4c3 = 'viewIssues';
    const $713364f722667f6e$export$b920363d50bcf753 = 'stopIssueArchival';
    const $713364f722667f6e$export$a84a5210fbad774 = 'restoreIssueArchival completed';
    const $713364f722667f6e$export$5c2df36fdd8476f7 = 'jqlSearch';
    const $713364f722667f6e$export$77f23f1b921d5321 = 'defaultQuerySelected';
    const $713364f722667f6e$export$c62a52f3f7d80ec3 = {
        metric: (0, (0, parcelRequire("cOrKR")).ISSUE_KEY)
    };
    const $713364f722667f6e$export$8daffc99348bf555 = 'customFieldMoveToTrash';
    const $713364f722667f6e$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
    const $713364f722667f6e$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
    const $713364f722667f6e$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
    const $713364f722667f6e$export$33989f74b6ba0674 = {
        metric: (0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS).key
    };
    const $713364f722667f6e$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
    const $713364f722667f6e$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
    const $713364f722667f6e$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
    const $713364f722667f6e$export$7b6bf63452d40db8 = 'restoreActivityLog';
    const $713364f722667f6e$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
    const $713364f722667f6e$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
    const $713364f722667f6e$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
    const $713364f722667f6e$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
    const $713364f722667f6e$export$3a7186fc63c9e188 = 'projectCleanUp';
    const $713364f722667f6e$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
    const $713364f722667f6e$export$342d8b9804e407c7 = 'TRASH';
    const $713364f722667f6e$export$b685f2109baf2b4f = 'ARCHIVE';
    const $713364f722667f6e$export$3ac60b381ed426ca = 'UNARCHIVE';
});
parcelRegister("etuUp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df7d950b94f108ee$export$2e2bcd8739ae039);
    var $7VHMR;
    var $df7d950b94f108ee$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
            "defaultMessage": "Site optimizer"
        },
        overview: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
            "defaultMessage": "Overview"
        },
        allReports: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
            "defaultMessage": "All reports"
        }
    });
});
parcelRegister("jWIOc", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", ()=>$fa0cf627da3f1f38$export$4150c6a7c9be0102);
    $parcel$export(module.exports, "ProjectCleanupSpotlight", ()=>$fa0cf627da3f1f38$export$6dc8afd0c00f9525);
    var $5uXOq = parcelRequire("5uXOq");
    var $1QiBP;
    var $koVbs;
    var $ehdJY;
    var $k43Y2;
    var $8881D;
    const $fa0cf627da3f1f38$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
    const $fa0cf627da3f1f38$export$6dc8afd0c00f9525 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, (0, parcelRequire("k43Y2")).useProjectCleanupSpotlight)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, isProjectCleanupSpotlightActive && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            actions: [
                {
                    onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                    text: formatMessage((0, (0, parcelRequire("8881D")).default).spotlightAction)
                }
            ],
            heading: formatMessage((0, (0, parcelRequire("8881D")).default).spotlightHeading),
            target: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
            key: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "right top",
            messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
            messageType: "engagement"
        }, formatMessage((0, (0, parcelRequire("8881D")).default).spotlightDescription)));
    });
});
parcelRegister("k43Y2", function(module, exports) {
    $parcel$export(module.exports, "useProjectCleanupSpotlight", ()=>$249ebdaf0c0fc22c$export$780bcf6e3ebf2d12);
    var $5uXOq = parcelRequire("5uXOq");
    var $iyJxC;
    var $90yGq;
    const $249ebdaf0c0fc22c$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
    const $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $5uXOq.useState)(false);
        const getHasSeenProjectCleanupSpotlight = async (id)=>{
            const response = await (0, (0, parcelRequire("iyJxC")).getUserProperty)({
                accountId: id,
                propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                defaultValue: false
            });
            if (!response.value) {
                await (0, (0, parcelRequire("iyJxC")).setUserProperty)({
                    accountId: id,
                    propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                    propertyValue: true
                });
                return false;
            }
            return true;
        };
        const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
            if (accountId !== null) {
                const response = await getHasSeenProjectCleanupSpotlight(accountId);
                setIsProjectCleanupSpotlightActive(!response);
            }
        }, [
            accountId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchSpotlightState();
        }, [
            fetchSpotlightState
        ]);
        return [
            isProjectCleanupSpotlightActive,
            setIsProjectCleanupSpotlightActive
        ];
    };
});
parcelRegister("iyJxC", function(module, exports) {
    $parcel$export(module.exports, "getUserProperty", ()=>$5455121d227e33bb$export$b3126db2ef6e34ed);
    $parcel$export(module.exports, "setUserProperty", ()=>$5455121d227e33bb$export$ba821ce5e177c7ef);
    var $jcw0u;
    var $eusud;
    const $5455121d227e33bb$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
    const $5455121d227e33bb$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
        const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
        try {
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 404) return {
                key: propertyKey,
                value: defaultValue
            };
            if (response.ok) return await response.json();
            throw new Error(`Fetching ${propertyKey} user property failed.`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraAdminPagesPerformance',
                    teamName: 'cherenkov'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                key: propertyKey,
                value: defaultValue
            };
        }
    };
    const $5455121d227e33bb$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
        const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
        try {
            await (0, (0, parcelRequire("eusud")).performPutRequest)(url, {
                body: JSON.stringify(propertyValue)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'setUserProperty',
                    packageName: 'jiraAdminPagesPerformance',
                    teamName: 'cherenkov'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("8881D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86d0877c08ff02be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $86d0877c08ff02be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        spotlightHeading: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
            "defaultMessage": "Clean out unused projects"
        },
        spotlightDescription: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
            "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
        },
        spotlightAction: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
            "defaultMessage": "Ok"
        }
    });
});
parcelRegister("fM231", function(module, exports) {
    $parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", ()=>$879944d685aae4de$export$3ed4e8541d8ba40);
    var $iyJxC;
    const $879944d685aae4de$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
    const $879944d685aae4de$export$3ed4e8541d8ba40 = async (accountId)=>{
        const response = await (0, (0, parcelRequire("iyJxC")).getUserProperty)({
            accountId: accountId,
            propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
            defaultValue: false
        });
        if (!response.value) {
            await (0, (0, parcelRequire("iyJxC")).setUserProperty)({
                accountId: accountId,
                propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
});
parcelRegister("ie4oV", function(module, exports) {
    $parcel$export(module.exports, "isViewAuditingSelected", ()=>$84aa4044b145a05a$export$6da8ca04904513f9);
    var $4OCke;
    const $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
    const $84aa4044b145a05a$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("71ORT", function(module, exports) {
    $parcel$export(module.exports, "UserInterfaceSection", ()=>$4dae17d9419cb38f$export$c4128359313d3f58);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $65Ltd;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $itmJb;
    var $jMBA3;
    var $jDUf4;
    const $4dae17d9419cb38f$export$c4128359313d3f58 = ()=>{
        const isJiraAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("jDUf4")).default).userInterface)
        }, features.hasUserDefaults && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'user-defaults'
            },
            href: navigationPath.userInterfacesUserDefaults,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).userDefaults)), features.hasEditDefaultDashboard && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'edit-default-dashboard'
            },
            href: navigationPath.userInterfacesEditDefaultDashboard,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).systemDashboard)), features.hasLookAndFeel && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'look-and-feel'
            },
            href: navigationPath.userInterfacesLookAndFeel,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).lookAndFeel)), features.hasPasAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'pas-admin-link-jira'
            },
            href: navigationPath.userInterfacesPasAdmin,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).pasAdmin)), isJiraAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'announcement-banner'
            },
            href: navigationPath.userInterfacesSiteAdmin,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER)
            ]
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).announcementBanner)));
    };
});
parcelRegister("jDUf4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f12d9a643fcf4ed$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6f12d9a643fcf4ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        userInterface: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
            "defaultMessage": "User Interface"
        },
        userDefaults: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
            "defaultMessage": "Default user preferences"
        },
        systemDashboard: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
            "defaultMessage": "Default dashboard"
        },
        lookAndFeel: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
            "defaultMessage": "Look and feel"
        },
        pasAdmin: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
            "defaultMessage": "Public Announcement Service"
        },
        announcementBanner: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
            "defaultMessage": "Announcement banner"
        }
    });
});
parcelRegister("3jrxv", function(module, exports) {
    $parcel$export(module.exports, "isGeneralConfigurationSelected", ()=>$e6139421bb00cae6$export$ba31cfa97c56eefd);
    var $4OCke;
    const $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
    const $e6139421bb00cae6$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("fg3s6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h9UUp").then(()=>parcelRequire('8Z6uP'));
});
parcelRegister("clE6J", function(module, exports) {
    $parcel$export(module.exports, "metricsOverviewPageResource", ()=>$624fad9c7a7951b4$export$ac0b4ef4ec4987ae);
    var $ao2h1;
    var $hOOQr;
    const $624fad9c7a7951b4$export$ac0b4ef4ec4987ae = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("hOOQr")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("hOOQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69a9f121a9ac63a8$export$2e2bcd8739ae039);
    const $69a9f121a9ac63a8$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_adminPagesPerformance_Overview_Query",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "JiraResourceUsageMetricConnection",
                                        "kind": "LinkedField",
                                        "name": "resourceUsageMetrics",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "main_adminPagesPerformance_OverviewPage"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.resourceUsageMetrics"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_adminPagesPerformance_Overview_Query",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraResourceUsageMetricConnection",
                                "kind": "LinkedField",
                                "name": "resourceUsageMetrics",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraResourceUsageMetric",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "currentValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "warningValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "thresholdValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cleanupValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "d2fe73ca0b47245563666951f775b77a3a261da2aeb574c289b15d04a8a13008",
                "metadata": {},
                "name": "main_adminPagesPerformance_Overview_Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $69a9f121a9ac63a8$var$node.hash = "65285ab59e67a0f62edb54671f986ddd";
    var $69a9f121a9ac63a8$export$2e2bcd8739ae039 = $69a9f121a9ac63a8$var$node;
});
parcelRegister("6WmO9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kZEdw")
    ]).then(()=>parcelRequire('PZuxA'));
});
parcelRegister("h0LCj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kbq0s")
    ]).then(()=>parcelRequire('9HctW'));
});
parcelRegister("jaOdX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7gdHv")
    ]).then(()=>parcelRequire('fJoHG'));
});
parcelRegister("8bORg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7u0xh")
    ]).then(()=>parcelRequire('eQgAh'));
});
parcelRegister("4Vh5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8auDC")
    ]).then(()=>parcelRequire('aJlr3'));
});
parcelRegister("1Sn7L", function(module, exports) {
    $parcel$export(module.exports, "editPermissionSchemePageResource", ()=>$c133ac01577799ff$export$2b6bb2f543863b53);
    var $ao2h1;
    var $eZzoq;
    const $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
    const $c133ac01577799ff$export$2b6bb2f543863b53 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("eZzoq")).default),
                variables: {
                    schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                    first: 50
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("eZzoq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95d709337e778f61$export$2e2bcd8739ae039);
    const $95d709337e778f61$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }, v2 = {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }, v3 = [
            v2
        ], v4 = {
            "kind": "ScalarField",
            "name": "isEditable"
        }, v5 = {
            "concreteType": "JiraPermissionSchemeConfiguration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                v4
            ]
        }, v6 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            },
            v2
        ], v7 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "ScalarField",
            "name": "name"
        }, v10 = {
            "kind": "ScalarField",
            "name": "key"
        }, v11 = {
            "kind": "ScalarField",
            "name": "description"
        }, v12 = {
            "kind": "ScalarField",
            "name": "text"
        }, v13 = {
            "kind": "ScalarField",
            "name": "id"
        }, v14 = [
            v8,
            v9,
            v13
        ], v15 = [
            v9,
            v13
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3,
                                    "kind": "LinkedField",
                                    "name": "viewPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "PermissionCategories"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_editPermissionScheme"
                                                },
                                                v5
                                            ],
                                            "type": "JiraPermissionSchemeView"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.viewPermissionScheme"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "getProjectsByPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7,
                                                                    "action": "LOG",
                                                                    "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                                }
                                                            ]
                                                        },
                                                        "action": "LOG",
                                                        "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                    }
                                                ]
                                            },
                                            "action": "LOG",
                                            "path": "jira.getProjectsByPermissionScheme.edges"
                                        }
                                    ]
                                },
                                "action": "LOG",
                                "path": "jira.getProjectsByPermissionScheme"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    v8,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraPermissionSchemeGrantGroup",
                                                "kind": "LinkedField",
                                                "name": "grantGroups",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraProjectPermissionCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v9,
                                                            v10
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraPermissionGrantHolder",
                                                        "kind": "LinkedField",
                                                        "name": "grantHolders",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProjectPermission",
                                                                "kind": "LinkedField",
                                                                "name": "permission",
                                                                "plural": false,
                                                                "selections": [
                                                                    v9,
                                                                    v11,
                                                                    v10
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "configuration",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "tag"
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionMessageExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "message",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "type"
                                                                            },
                                                                            v12
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionDocumentationExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "documentation",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "url"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v4
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionGrants",
                                                                "kind": "LinkedField",
                                                                "name": "grants",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraGrantTypeKey",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v10,
                                                                            v9
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionGrantValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantValues",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "value",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v8,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v9
                                                                                        ],
                                                                                        "type": "JiraDefaultGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v14
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraUserGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraGroup",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "group",
                                                                                                "plural": false,
                                                                                                "selections": v15
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraGroupGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraRole",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "role",
                                                                                                "plural": false,
                                                                                                "selections": v15
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraProjectRoleGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "field",
                                                                                                "plural": false,
                                                                                                "selections": v14
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraIssueFieldGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v13
                                                                                        ],
                                                                                        "type": "Node",
                                                                                        "abstractKey": "__isNode"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v13
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "totalCount"
                                                                    },
                                                                    v8
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ClientExtension",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__id"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraPermissionScheme",
                                                "kind": "LinkedField",
                                                "name": "scheme",
                                                "plural": false,
                                                "selections": [
                                                    v9,
                                                    v11,
                                                    v13
                                                ]
                                            },
                                            v5
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            {
                                "args": v6,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v13
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1",
                "metadata": {},
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $95d709337e778f61$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
    var $95d709337e778f61$export$2e2bcd8739ae039 = $95d709337e778f61$var$node;
});
parcelRegister("bFrLw", function(module, exports) {
    $parcel$export(module.exports, "permissionSchemePageResource", ()=>$b39d37deff00f918$export$58d9013f694fc9d0);
    var $ao2h1;
    var $kf7Zr;
    const $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
    const $b39d37deff00f918$export$58d9013f694fc9d0 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("kf7Zr")).default),
                variables: {
                    schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("kf7Zr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$667e2dd268ebb83a$export$2e2bcd8739ae039);
    const $667e2dd268ebb83a$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "schemeId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "schemeId",
                "variableName": "schemeId"
            }
        ], v2 = {
            "concreteType": "JiraPermissionSchemeConfiguration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }, v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        }, v5 = {
            "kind": "ScalarField",
            "name": "description"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ScalarField",
            "name": "key"
        }, v8 = [
            v3,
            v4,
            v6
        ], v9 = [
            v4,
            v6
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1,
                                    "kind": "LinkedField",
                                    "name": "viewPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_permissionScheme"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "PermissionsTable"
                                                },
                                                v2
                                            ],
                                            "type": "JiraPermissionSchemeView"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.viewPermissionScheme"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraPermissionScheme",
                                                "kind": "LinkedField",
                                                "name": "scheme",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v5,
                                                    v6
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraPermissionSchemeGrantGroup",
                                                "kind": "LinkedField",
                                                "name": "grantGroups",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraProjectPermissionCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v4
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraPermissionGrantHolder",
                                                        "kind": "LinkedField",
                                                        "name": "grantHolders",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProjectPermission",
                                                                "kind": "LinkedField",
                                                                "name": "permission",
                                                                "plural": false,
                                                                "selections": [
                                                                    v7,
                                                                    v4,
                                                                    v5
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionGrants",
                                                                "kind": "LinkedField",
                                                                "name": "grants",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraGrantTypeKey",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v7,
                                                                            v4
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionGrantValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantValues",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "value",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v3,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            v4
                                                                                        ],
                                                                                        "type": "JiraDefaultGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v8
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraUserGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "concreteType": "JiraGroup",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "group",
                                                                                                "plural": false,
                                                                                                "selections": v9
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraGroupGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "field",
                                                                                                "plural": false,
                                                                                                "selections": v8
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraIssueFieldGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "concreteType": "JiraRole",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "role",
                                                                                                "plural": false,
                                                                                                "selections": v9
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraProjectRoleGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6
                                                                                        ],
                                                                                        "type": "Node",
                                                                                        "abstractKey": "__isNode"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v6
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v2
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
                "metadata": {},
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $667e2dd268ebb83a$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
    var $667e2dd268ebb83a$export$2e2bcd8739ae039 = $667e2dd268ebb83a$var$node;
});
parcelRegister("8PQYZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2s3c1")
    ]).then(()=>parcelRequire('hZT3b'));
});
parcelRegister("iqkTm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ibJV0")
    ]).then(()=>parcelRequire('cHxvv'));
});
parcelRegister("bV6im", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", ()=>$712cde19d1c09667$export$185af30f53271c10);
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", ()=>$712cde19d1c09667$export$518516cdf6b7cd83);
    var $65Ltd;
    const $712cde19d1c09667$export$185af30f53271c10 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES),
        path: '/jira/settings/issues/priority-schemes'
    };
    const $712cde19d1c09667$export$518516cdf6b7cd83 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES),
        path: '/jira/settings/issues/priorities'
    };
});
parcelRegister("fhPlz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dRzJO")
    ]).then(()=>parcelRequire('7oC7C'));
});
parcelRegister("fKkNZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7MbJW")
    ]).then(()=>parcelRequire('4bg9b'));
});
parcelRegister("hKhMf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jKdTq")
    ]).then(()=>parcelRequire('jSKfU'));
});
parcelRegister("3itkj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jTAHY")
    ]).then(()=>parcelRequire('5K98P'));
});
parcelRegister("in6By", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("FB5JX")
    ]).then(()=>parcelRequire('bwE6o'));
});
parcelRegister("3tVs3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8WK9x")
    ]).then(()=>parcelRequire('lgmh3'));
});
parcelRegister("1ZpQo", function(module, exports) {
    $parcel$export(module.exports, "systemConfigurationRoute", ()=>$f2ea4006e0777885$export$6823cb5626e61bc7);
    $parcel$export(module.exports, "routeNamesSystemConfigurationRedirectRoute", ()=>$f2ea4006e0777885$export$23418d655258dbfa);
    var $65Ltd;
    const $f2ea4006e0777885$export$6823cb5626e61bc7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_CONFIGURATION),
        path: '/jira/settings/system/general-configuration',
        exact: true
    };
    const $f2ea4006e0777885$export$23418d655258dbfa = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_CONFIGURATION)}-redirect`,
        path: '/secure/admin/ViewApplicationProperties.jspa',
        exact: true
    };
});
parcelRegister("gtlim", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aUVUi")
    ]).then(()=>parcelRequire('7S4i0'));
});
parcelRegister("lD0Ke", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1eCvc")
    ]).then(()=>parcelRequire('e7RG2'));
});
parcelRegister("3aIZg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9146315a1662307e$export$2e2bcd8739ae039);
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    var $AdkCT;
    const $9146315a1662307e$var$workFlowsResource = (0, $dIdda.createResource)({
        type: (0, $5c95bdf76715894f$export$b11854972ecaecc7),
        getKey: ({ query: query })=>`${0, $5c95bdf76715894f$export$6602c5404301813f}-${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`,
        maxAge: 0,
        getData: async ({ query: query })=>(0, (0, parcelRequire("AdkCT")).getListWorkFlows)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
    var $9146315a1662307e$export$2e2bcd8739ae039 = $9146315a1662307e$var$workFlowsResource;
});
parcelRegister("AdkCT", function(module, exports) {
    $parcel$export(module.exports, "getListWorkFlows", ()=>$bd8703d90d89a06c$export$952f5d693c3c0d4e);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $eusud;
    var $lNKJm;
    var $9KDge;
    const $bd8703d90d89a06c$export$952f5d693c3c0d4e = async (qs)=>{
        const filter = (0, (0, parcelRequire("9KDge")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("9KDge")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/workflow/search?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getWorkflowsSearchAPI',
                    packageName: (0, (0, parcelRequire("lNKJm")).PACKAGE_NAME),
                    teamName: 'helix'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("lNKJm", function(module, exports) {
    $parcel$export(module.exports, "SOURCE_NAME", ()=>$51adf94ab22e1863$export$a3821bc63538b210);
    $parcel$export(module.exports, "WORKFLOW_NAME", ()=>$51adf94ab22e1863$export$a69699c3acbd94ca);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$51adf94ab22e1863$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "WORKFLOWS_ACTIONS", ()=>$51adf94ab22e1863$export$f3ab46ae5f3c01ad);
    $parcel$export(module.exports, "WORKFLOWS_SCHEME", ()=>$51adf94ab22e1863$export$81c9aaf617cb2f01);
    $parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", ()=>$51adf94ab22e1863$export$615f1d8b29794ae);
    $parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", ()=>$51adf94ab22e1863$export$fccd4c1ce5f0896f);
    $parcel$export(module.exports, "DEFAULT_PAGE_SIZE", ()=>$51adf94ab22e1863$export$5716e8bcb003888d);
    $parcel$export(module.exports, "defaultListWorkFlowsFilter", ()=>$51adf94ab22e1863$export$dc5aae53031515c);
    $parcel$export(module.exports, "ORDER", ()=>$51adf94ab22e1863$export$11e75bce9f7ea886);
    $parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", ()=>$51adf94ab22e1863$export$9ac56b2484c2d4e9);
    $parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", ()=>$51adf94ab22e1863$export$e6613a3c77896936);
    $parcel$export(module.exports, "API_PREFIX", ()=>$51adf94ab22e1863$export$a3f6840410eb0571);
    const $51adf94ab22e1863$export$a3821bc63538b210 = 'listWorkflows';
    const $51adf94ab22e1863$export$a69699c3acbd94ca = 'workflowName';
    const $51adf94ab22e1863$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
    const $51adf94ab22e1863$export$f3ab46ae5f3c01ad = 'workflowsActions';
    const $51adf94ab22e1863$export$81c9aaf617cb2f01 = 'workflowScheme';
    const $51adf94ab22e1863$export$615f1d8b29794ae = 'jira';
    const $51adf94ab22e1863$export$fccd4c1ce5f0896f = 'Builds Workflow';
    const $51adf94ab22e1863$export$5716e8bcb003888d = 10;
    const $51adf94ab22e1863$export$f6e7f4d903fd7165 = 'ADD_WORKFLOWS';
    const $51adf94ab22e1863$export$dc5aae53031515c = {
        pageNumber: 1,
        pageSize: $51adf94ab22e1863$export$5716e8bcb003888d,
        expand: [
            'default',
            'hasDraftWorkflow',
            'schemes',
            'operations',
            'projects'
        ],
        orderBy: 'name',
        sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        isActive: true
    };
    const $51adf94ab22e1863$export$11e75bce9f7ea886 = Object.freeze({
        ASC: 'asc',
        DESC: 'desc'
    });
    const $51adf94ab22e1863$export$3c5e605ca7ade9f2 = 'NAME';
    const $51adf94ab22e1863$export$b87f371cbc396fcf = 'TYPE';
    const $51adf94ab22e1863$export$9ac56b2484c2d4e9 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'filterSearch'
    });
    const $51adf94ab22e1863$export$e6613a3c77896936 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'pageSize'
    });
    const $51adf94ab22e1863$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';
});
parcelRegister("9KDge", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$f0642d0f1e447d39$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$f0642d0f1e447d39$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$f0642d0f1e447d39$export$fb15afa686993f11);
    var $aud83;
    var $lNKJm;
    var $lgmUP;
    const $f0642d0f1e447d39$export$5b9f8ed2c34be88a = (filter)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
        return {
            pageNumber: pageNumber,
            searchFilter: searchFilter,
            orderBy: orderBy,
            isActive: isActive,
            pageSize: pageSize
        };
    };
    const $f0642d0f1e447d39$export$bec67ef860c0d0e1 = (params)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
        const parsedNumber = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageNumber)) ? (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).pageNumber : (0, (0, parcelRequire("aud83")).number).parse(pageNumber);
        const parsedSize = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageSize)) ? (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).pageSize : (0, (0, parcelRequire("aud83")).number).parse(pageSize);
        const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
        const isActiveFinal = isActive != null ? isActive === 'true' : (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).isActive;
        return {
            ...(0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter),
            pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
            pageSize: parsedSize != null ? Number(parsedSize) : undefined,
            searchFilter: searchFilter,
            orderBy: parsedOrderBy,
            isActive: isActiveFinal
        };
    };
    const $f0642d0f1e447d39$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = {
            ...(0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter),
            ...filter
        };
        const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, (0, parcelRequire("lNKJm")).DEFAULT_PAGE_SIZE) } = fullFilter;
        let requestParams = {
            maxResults: pageSize,
            startAt: (pageNumber - 1) * pageSize,
            orderBy: fullFilter.orderBy,
            queryString: (0, (0, parcelRequire("lgmUP")).trimSearchFilter)(fullFilter.searchFilter),
            isActive: fullFilter.isActive
        };
        if (fullFilter.expand != null) requestParams = {
            ...requestParams,
            expand: fullFilter.expand.join(',')
        };
        return requestParams;
    };
});
parcelRegister("lgmUP", function(module, exports) {
    $parcel$export(module.exports, "trimSearchFilter", ()=>$d92ccc09aa62d68e$export$ed1722f41c23aaaf);
    const $d92ccc09aa62d68e$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
    const $d92ccc09aa62d68e$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
    const $d92ccc09aa62d68e$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
const $5c95bdf76715894f$export$b11854972ecaecc7 = 'WORKFLOWS_TABLE';
const $5c95bdf76715894f$export$6602c5404301813f = 'WORKFLOWS_TABLE_KEY';
parcelRegister("atF3J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1hdHP")
    ]).then(()=>parcelRequire('c8ahc'));
});
parcelRegister("9VrFM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Lhq3").then(()=>parcelRequire('b9R9h'));
});
parcelRegister("dbmHR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fQbJ3").then(()=>parcelRequire('5NHpB'));
});
parcelRegister("7D8h0", function(module, exports) {
    $parcel$export(module.exports, "formsResource", ()=>$8beb5bc3f227e13c$export$dbd8dbd978e7427);
    $parcel$export(module.exports, "useFormsResource", ()=>$8beb5bc3f227e13c$export$efd3ca9d66f19a97);
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $8beb5bc3f227e13c$var$getDataLoader = ()=>(parcelRequire("4ewnA"));
    const $8beb5bc3f227e13c$export$dbd8dbd978e7427 = (0, $dIdda.createResource)({
        type: 'HELP_CENTER_FORMS_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $8beb5bc3f227e13c$var$getDataLoader
    });
    const $8beb5bc3f227e13c$export$efd3ca9d66f19a97 = ()=>(0, $dIdda.useResource)($8beb5bc3f227e13c$export$dbd8dbd978e7427);
});
parcelRegister("4ewnA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gphZc").then(()=>parcelRequire('bEbHX'));
});
parcelRegister("9czCW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1Aiz0")
    ]).then(()=>parcelRequire('7QYfj'));
});
parcelRegister("dB8mZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("aUqEr")
    ]).then(()=>parcelRequire('7r8zn'));
});
parcelRegister("acxar", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("f3edP")
    ]).then(()=>parcelRequire('3XNgZ'));
});
parcelRegister("iB2rz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gZjef")
    ]).then(()=>parcelRequire('a6kDH'));
});
parcelRegister("4Ftk1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7gB9a")
    ]).then(()=>parcelRequire('5bGBK'));
});
parcelRegister("8rIQt", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$17427f16dde00e98$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fobme;
    var $acDan;
    var $8snXd;
    var $hFFWh;
    const $17427f16dde00e98$var$MultiProjectSidebarCore = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarRenderStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceMark), {
            id: (0, (0, parcelRequire("8snXd")).RENDER_START_MARK)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hFFWh")).default), null), !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarReady), {
            id: (0, (0, parcelRequire("fobme")).SIDEBAR_ID).CORE
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceMark), {
            id: (0, (0, parcelRequire("8snXd")).RENDER_END_MARK)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceReport), null)));
    var $17427f16dde00e98$export$2e2bcd8739ae039 = $17427f16dde00e98$var$MultiProjectSidebarCore;
});
parcelRegister("8snXd", function(module, exports) {
    $parcel$export(module.exports, "RENDER_START_MARK", ()=>$5e4f397416a402e4$export$8f8203e04f80aed);
    $parcel$export(module.exports, "RENDER_END_MARK", ()=>$5e4f397416a402e4$export$dc795f9b21e2778a);
    $parcel$export(module.exports, "PerformanceMark", ()=>$5e4f397416a402e4$export$b8228db3a01d9a76);
    $parcel$export(module.exports, "PerformanceReport", ()=>$5e4f397416a402e4$export$c97ab321326d29f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGrdR;
    const $5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME = 'jwm.sidebar';
    const $5e4f397416a402e4$export$8f8203e04f80aed = `${$5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME}.render.start`;
    const $5e4f397416a402e4$export$dc795f9b21e2778a = `${$5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME}.render.end`;
    const $5e4f397416a402e4$var$segment = (0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
        key: $5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME,
        timings: [
            {
                key: 'tti',
                endMark: $5e4f397416a402e4$export$dc795f9b21e2778a
            }
        ]
    });
    const $5e4f397416a402e4$export$b8228db3a01d9a76 = ({ id: id })=>{
        const startedRef = (0, $5uXOq.useRef)(false);
        if (!false && !startedRef.current) {
            $5e4f397416a402e4$var$segment.startFromPageLoad();
            startedRef.current = true;
        }
        (0, $5uXOq.useEffect)(()=>$5e4f397416a402e4$var$segment.mark(id), [
            id
        ]);
        return null;
    };
    const $5e4f397416a402e4$export$c97ab321326d29f7 = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            $5e4f397416a402e4$var$segment.stop();
        }, []);
        return null;
    };
});
parcelRegister("hFFWh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af0c023251a98909$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8e8QT;
    var $4R6GH;
    var $koVbs;
    var $cE2Qr;
    var $8zOmE;
    var $2NMNM;
    var $iNzEe;
    var $cZpsT;
    var $dIdda = parcelRequire("dIdda");
    var $6tzEU;
    var $aueMW;
    var $iZNik;
    var $NCdt4;
    var $dCGEg;
    var $6KeQr;
    var $k5gug;
    const $af0c023251a98909$var$MultiProjectMenu = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { currentProject: currentProject, recents: recents, favorites: favorites, hasMoreFavorite: hasMoreFavorite, onFavoriteToggle: onFavoriteToggle, overviews: overviews, overviewsError: overviewsError, shouldHideOverviews: shouldHideOverviews, loading: loading } = (0, (0, parcelRequire("6tzEU")).useSidebarData)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const [projectState] = (0, (0, parcelRequire("cE2Qr")).useProjectState)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, $dIdda.useRouter)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebar viewed', {
                starredProjectsCount: favorites.length,
                recentProjectsCount: recents.length,
                overviewsCount: overviews.length
            });
        }, []);
        const currentProjectKey = projectKey ?? currentProject?.key;
        const shouldDisplayOverviews = isPremiumUserSeat && !isAnonymous && !shouldHideOverviews;
        const projectsContent = (0, ($parcel$interopDefault($5uXOq))).createElement("section", null, favorites.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KeQr")).default), {
            sectionId: "starred",
            projects: favorites,
            onFavoriteToggle: onFavoriteToggle,
            currentProjectKey: currentProjectKey,
            showViewAllProjects: hasMoreFavorite,
            viewAllProjectsLabel: formatMessage((0, (0, parcelRequire("NCdt4")).default).viewAllStarred)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KeQr")).default), {
            sectionId: "recent",
            projects: recents,
            onFavoriteToggle: onFavoriteToggle,
            currentProjectKey: currentProjectKey,
            showViewAllProjects: true
        }));
        const isShowingCTA = projectState?.isSampleProject === true;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SidebarWrapper, {
            "aria-label": formatMessage((0, (0, parcelRequire("NCdt4")).default).navigationLabel),
            isCrossProjectView: true
        }, shouldDisplayOverviews && (loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$OverviewsSkeleton, null) : (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dCGEg")).default), {
            overviews: overviews,
            hasError: Boolean(overviewsError)
        }))), loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ProjectsSkeleton, null) : (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k5gug")).default), null), projectsContent), !loading && isShowingCTA && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aueMW")).CreateProjectCta), null)), (0, (0, parcelRequire("4R6GH")).fg)('jwm_mobile_discovery') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8e8QT")).AsyncMobileDownloadPrompt), null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Footer, {
            hasMargin: true
        }, currentProject != null && (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Type, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-type"
        }, currentProject.isSimplified ? formatMessage((0, (0, parcelRequire("NCdt4")).default).teamManagedProject) : formatMessage((0, (0, parcelRequire("NCdt4")).default).companyManagedProject)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iZNik")).default), null)));
    };
    const $af0c023251a98909$var$ItemSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemAvatarSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonBase, null));
    const $af0c023251a98909$var$OverviewsSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SectionHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null));
    const $af0c023251a98909$var$ProjectsSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SectionHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$CollapsibleHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$CollapsibleHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null));
    const $af0c023251a98909$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _11q7vuon",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SidebarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isCrossProjectView: isCrossProjectView, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdpxbi _19bvpxbi _u5f3pxbi _19pkr5cr _otyridpf _18u0idpf _2hwxidpf _1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _11q71mi8 _12vemgnk _1lrwy1fe _qmxj4ebz _qjkj6grs _azbnu2gc",
                __cmplp.isCrossProjectView ? "_ca0qpxbi" : "_ca0q1b66",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SkeletonBase = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7iw92 _4t3i1crf _1bsbqkoa _2rko1y44 _otyrutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SkeletonSection = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ejb",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SectionHeaderSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb68cl _4t3i7vkz",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$ItemSkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$ItemAvatarSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _18u0utpp _2hwxutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$CollapsibleHeaderSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbys9h _18u0u2gc _19pkutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$Footer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { hasMargin: hasMargin, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.hasMargin && "_18s8u2gc",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$Type = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81vlj _y3gn1h6o _18s8swc3 _1tke7vkz _syaz1rc1",
                __cmplp.className
            ])
        });
    });
    var $af0c023251a98909$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($af0c023251a98909$var$MultiProjectMenu);
});
parcelRegister("8e8QT", function(module, exports) {
    $parcel$export(module.exports, "AsyncMobileDownloadPrompt", ()=>$7f26c5865794a560$export$64ca7d64bb703770);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $12nJ9;
    const $7f26c5865794a560$var$runtimeProps = {};
    const $7f26c5865794a560$var$entryPointParams = {};
    const $7f26c5865794a560$export$64ca7d64bb703770 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("12nJ9")).downloadMobilePromptEntryPoint), $7f26c5865794a560$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jiraBusinessDownloadMobilePrompt",
            packageName: (0, $244834d5fcf707c7$export$b8b9d90f9e5bd72b),
            teamName: "frontier",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $7f26c5865794a560$var$runtimeProps,
            errorFallback: "unmount"
        });
    };
});
const $244834d5fcf707c7$export$b8b9d90f9e5bd72b = 'jiraBusinessMobileDownloadPrompt';
parcelRegister("12nJ9", function(module, exports) {
    $parcel$export(module.exports, "downloadMobilePromptEntryPoint", ()=>$15bca80131d9ba79$export$66f4c5613c7e964);
    var $eufEc;
    var $fEDBv;
    const $15bca80131d9ba79$export$66f4c5613c7e964 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("jyTpt")), {
            moduleId: "c94481ab"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("jyTpt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kpbiP").then(()=>parcelRequire('2ea9U'));
});
parcelRegister("cE2Qr", function(module, exports) {
    $parcel$export(module.exports, "useJswOnboarding", ()=>$796be817ff5bbbfa$export$7d91c0af4772787a);
    $parcel$export(module.exports, "useOpenTask", ()=>$796be817ff5bbbfa$export$594f006fa6a1b2e5);
    $parcel$export(module.exports, "useNudgeStep", ()=>$796be817ff5bbbfa$export$c5e63e44ad178ae8);
    $parcel$export(module.exports, "useQuickstartActions", ()=>$796be817ff5bbbfa$export$2c3cd14fff9d6e43);
    $parcel$export(module.exports, "useShouldShowNudge", ()=>$796be817ff5bbbfa$export$b0db7e46e369e1d9);
    $parcel$export(module.exports, "useInviteToProject", ()=>$796be817ff5bbbfa$export$71de79653346a1ea);
    $parcel$export(module.exports, "useShowVideoCards", ()=>$796be817ff5bbbfa$export$61185a9266f1f57a);
    $parcel$export(module.exports, "useProjectState", ()=>$796be817ff5bbbfa$export$ef4747ba36826d6a);
    $parcel$export(module.exports, "useQuickstartUiStatus", ()=>$796be817ff5bbbfa$export$522993b46d9f8266);
    $parcel$export(module.exports, "useIsLoaded", ()=>$796be817ff5bbbfa$export$aa4ba29241532382);
    $parcel$export(module.exports, "useIsFocusedOn", ()=>$796be817ff5bbbfa$export$ed5c755b733bf2b1);
    $parcel$export(module.exports, "useIsDismissed", ()=>$796be817ff5bbbfa$export$35fe0366802512dd);
    $parcel$export(module.exports, "useCompletedTaskList", ()=>$796be817ff5bbbfa$export$a41ee0d3b6938099);
    $parcel$export(module.exports, "useAllTasksCompleted", ()=>$796be817ff5bbbfa$export$4ae7b465b076be9);
    $parcel$export(module.exports, "useMountedNudges", ()=>$796be817ff5bbbfa$export$bf6e646c0476acad);
    $parcel$export(module.exports, "useHasEverSeen", ()=>$796be817ff5bbbfa$export$6b706bff94798d11);
    $parcel$export(module.exports, "useRoadmapState", ()=>$796be817ff5bbbfa$export$c98db656edc5b3e1);
    $parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", ()=>$796be817ff5bbbfa$export$a823278ac9d1112b);
    $parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", ()=>$796be817ff5bbbfa$export$cb9e0e8fe4df8490);
    $parcel$export(module.exports, "useHasNudgeActive", ()=>$796be817ff5bbbfa$export$521909e3dc7ab811);
    $parcel$export(module.exports, "QUICKSTART_UI_STATUS", ()=>(parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);
    var $58GFP;
    var $4R6GH;
    var $7JoAD = parcelRequire("7JoAD");
    var $8Bc5A;
    var $6RAg1;
    var $ieqoN;
    var $cGE52;
    var $3B5jO;
    var $4ji4w;
    const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
        name: 'jsw-onboarding-quickstart',
        initialState: (0, parcelRequire("cGE52")).initialState,
        actions: (0, parcelRequire("6RAg1"))
    });
    const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, $7JoAD.createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
    const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
    const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, $7JoAD.createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
    const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
        const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state)] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN && itemNames.includes(state.openTask);
        return commonConditionsToShowNudge && state.hasNudgeActive;
    };
    const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
    const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
    });
    const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
    const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$a943afa434e9487a
    });
    const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: null
    });
    const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$9d731f44f82af09f
    });
    const $796be817ff5bbbfa$export$71de79653346a1ea = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
    });
    const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            if (!state.projectState) return false;
            const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
            return Boolean(isNextGen && (userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN || userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN || isProjectAdmin));
        }
    });
    const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.projectState
    });
    const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            if (state.shouldRenderComponent === false) return (0, (0, parcelRequire("4ji4w")).getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED;
            return state.visibility[quickstartType];
        }
    });
    const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.isQuickstartLoaded
    });
    const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.isFocusedOn
    });
    const $796be817ff5bbbfa$export$35fe0366802512dd = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            const visibility = state.visibility[(0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state)];
            return visibility === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED && (0, (0, parcelRequire("4R6GH")).fg)('jsw-perf-async-add-people-modal-load');
        }
    });
    const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.completedTaskList
    });
    const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            if (!state.tasks) return null;
            return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
        }
    });
    const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.mountedNudges
    });
    const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.hasEverSeenRoute
    });
    const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>({
                roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
                roadmapIsListEmpty: state.roadmapIsListEmpty
            })
    });
    const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, (0, parcelRequire("58GFP")).SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN)
    });
    const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, (0, parcelRequire("58GFP")).KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN && !state.completedTaskList.includes((0, (0, parcelRequire("8Bc5A")).KANBAN_ONBOARDING_TASK)))
    });
    const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.hasNudgeActive
    });
    const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
    });
});
parcelRegister("58GFP", function(module, exports) {
    $parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$f40a08fc76eb112d);
    $parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$e3844688f2693533);
    $parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$e3cec071fcb2fbd3);
    $parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$21783d461e3ef6d);
    $parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$6cd1c1b2ba0f6e2d);
    $parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$57d877f2e01e0029);
    $parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$6f4213a3addc3fdb);
    $parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", ()=>$c364c398187f9175$export$7492b6cc3ef89883);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$7d9a4e0ef5194fe1);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$477ca3550da12e43);
    $parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$b5ab111fb8825075);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$14139f0ec41d437e);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$ebf7af45376deb8b);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$7b6945581ccdab4a);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$310a9ac5c28d65f6);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$4d29ee0c00eb5df4);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$6278b41164dbde6c);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$17a2f771efabf02f);
    $parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$bd14946bcde77195);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", ()=>$c364c398187f9175$export$e8df553a3f519284);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$c364c398187f9175$export$97fc32bd703bb4d1);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", ()=>$c364c398187f9175$export$8eecdf6acea9494);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$c364c398187f9175$export$ff16be7794ed4222);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$9917830b560a2f4);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$b0928b02ffab3875);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$fd75f6abc7861439);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$fb658bddae7f81bb);
    $parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$2bc7db2da3df8313);
    $parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", ()=>$c364c398187f9175$export$87a8fff98b5bc81);
    $parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$7c567eb725bd36f);
    $parcel$export(module.exports, "getIsJsmBlankProjectTemplate", ()=>$c364c398187f9175$export$73fd025e86012868);
    $parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", ()=>$c364c398187f9175$export$a062badd78c9993);
    const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
    const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
    const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
    const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
    const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
    const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
    const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
    const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
    const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
    const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
    const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
    const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
    const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
    const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
    const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
    const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
    const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
    const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
    const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
    const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
    const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
    const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
    const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
    const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
    const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
    const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
    const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
    const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
    const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
    const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
    const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
    const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
    const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
    const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
    const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
    const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
    const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
    const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
    const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
    const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
    const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
    const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
    const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
    const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
    const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
    const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
    const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
    const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
    const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
    const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
    const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
    const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
    const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
    const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
    const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
    const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
    const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
    const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
    const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
    const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
    const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
    const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
    const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
    const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
    const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
    const $c364c398187f9175$export$a062badd78c9993 = {
        [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
        [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
        [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
        [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
    };
});
parcelRegister("8Bc5A", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "PACKAGE_TEAM_NAME", ()=>$5f07ce956337ba8b$export$2b3151a089bc8780);
    $parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", ()=>$5f07ce956337ba8b$export$6826d33e9a2c0119);
    $parcel$export(module.exports, "ROOT_TASK", ()=>$5f07ce956337ba8b$export$b580da85daad7757);
    $parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", ()=>$5f07ce956337ba8b$export$5eef19b26a4bbe70);
    $parcel$export(module.exports, "QUICKSTART_TYPE", ()=>$5f07ce956337ba8b$export$c57d251ae83aff51);
    $parcel$export(module.exports, "getBackendVisibilityKey", ()=>$5f07ce956337ba8b$export$d9df7fd23ab00c49);
    $parcel$export(module.exports, "KEY_OPEN", ()=>$5f07ce956337ba8b$export$93a67c1026e8cb7c);
    $parcel$export(module.exports, "KEY_DISMISSED", ()=>$5f07ce956337ba8b$export$a7dcb0b5013e932b);
    $parcel$export(module.exports, "KEY_TASK_GROUP", ()=>$5f07ce956337ba8b$export$f962b14e410d598f);
    $parcel$export(module.exports, "KEY_OPEN_TASK", ()=>$5f07ce956337ba8b$export$21e8355b28449456);
    $parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", ()=>$5f07ce956337ba8b$export$536a90031123e004);
    $parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", ()=>$5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
    $parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", ()=>$5f07ce956337ba8b$export$e5b557e3bbb7ec52);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$5f07ce956337ba8b$export$9957974f8b4d8f74);
    $parcel$export(module.exports, "SOURCE", ()=>$5f07ce956337ba8b$export$83c8d7110915321e);
    $parcel$export(module.exports, "KEY_JSW_ONBOARDING", ()=>$5f07ce956337ba8b$export$8b9bd2a9275b0187);
    $parcel$export(module.exports, "convertToHaveSeenItTask", ()=>$5f07ce956337ba8b$export$ec43e7bf5973b10f);
    $parcel$export(module.exports, "ADD_COLUMNS_TASK", ()=>$5f07ce956337ba8b$export$cbeb719208f32c8a);
    $parcel$export(module.exports, "CREATE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$88c918f2cfaff86);
    $parcel$export(module.exports, "CREATE_ISSUE_TASK", ()=>$5f07ce956337ba8b$export$abbbea7c37c93cb5);
    $parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", ()=>$5f07ce956337ba8b$export$2a0253cb20f48a8);
    $parcel$export(module.exports, "INVITE_TEAMMATES_TASK", ()=>$5f07ce956337ba8b$export$f97428bb4b1991ec);
    $parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", ()=>$5f07ce956337ba8b$export$45eaf4204fcc7);
    $parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", ()=>$5f07ce956337ba8b$export$af57685e201438e8);
    $parcel$export(module.exports, "FIND_HELP_TASK", ()=>$5f07ce956337ba8b$export$d6c67e9aab4e2b26);
    $parcel$export(module.exports, "SET_UP_BOARD_TASK", ()=>$5f07ce956337ba8b$export$3de8c242d2b82f26);
    $parcel$export(module.exports, "GET_MOBILE_APP_TASK", ()=>$5f07ce956337ba8b$export$a01fa44f793dbfac);
    $parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", ()=>$5f07ce956337ba8b$export$6a4507e462fd41da);
    $parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", ()=>$5f07ce956337ba8b$export$e64c1dced6ac4458);
    $parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", ()=>$5f07ce956337ba8b$export$63b0e55f9c6454ac);
    $parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", ()=>$5f07ce956337ba8b$export$c1effb1c8979fe22);
    $parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", ()=>$5f07ce956337ba8b$export$d97d31d934dbb194);
    $parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", ()=>$5f07ce956337ba8b$export$cafb5bd13b02056b);
    $parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", ()=>$5f07ce956337ba8b$export$e55c18b809946e72);
    $parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", ()=>$5f07ce956337ba8b$export$de5640b9ae8140a7);
    $parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", ()=>$5f07ce956337ba8b$export$540b5c3c4b6ce459);
    $parcel$export(module.exports, "CHANGE_CONTROL_TASK", ()=>$5f07ce956337ba8b$export$6f71dff531ff592);
    $parcel$export(module.exports, "AUTOMATIONS_TASK", ()=>$5f07ce956337ba8b$export$83255ab79e45f34f);
    $parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", ()=>$5f07ce956337ba8b$export$b57d172af9ad7647);
    $parcel$export(module.exports, "USER_MANAGEMENT_TASK", ()=>$5f07ce956337ba8b$export$ff4c933c1fe90b68);
    $parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$3e2776d61f3662dc);
    $parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", ()=>$5f07ce956337ba8b$export$9048315f2c03fd9d);
    $parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", ()=>$5f07ce956337ba8b$export$a333714599f14a6);
    $parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", ()=>$5f07ce956337ba8b$export$4145c2cec2da6f9b);
    $parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$4957a1ad203cf6dd);
    $parcel$export(module.exports, "CALENDAR_VIEW_TASK", ()=>$5f07ce956337ba8b$export$190b5dd0a1322552);
    $parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", ()=>$5f07ce956337ba8b$export$501166b25f254aab);
    $parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$94ad6507a703f4eb);
    $parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", ()=>$5f07ce956337ba8b$export$be1c522400a1bd7c);
    $parcel$export(module.exports, "JWM_CALENDAR_TASK", ()=>$5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
    $parcel$export(module.exports, "JWM_TIMELINE_TASK", ()=>$5f07ce956337ba8b$export$f3b53199b07af2a1);
    $parcel$export(module.exports, "JWM_BUILD_FORM_TASK", ()=>$5f07ce956337ba8b$export$d37415ffddcf2142);
    $parcel$export(module.exports, "JWM_FEEDBACK_TASK", ()=>$5f07ce956337ba8b$export$2ae00586da7cb606);
    $parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$b86266e6594a97bb);
    $parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$20bc3dc137ac1c38);
    $parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$77071b77e2801b18);
    $parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$9c89f946f05d884a);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", ()=>$5f07ce956337ba8b$export$b52a7c936684cfc5);
    $parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", ()=>$5f07ce956337ba8b$export$b5555f24061f9fb);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", ()=>$5f07ce956337ba8b$export$ff25449f34b8abf);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", ()=>$5f07ce956337ba8b$export$3380e677209260fe);
    $parcel$export(module.exports, "GET_STARTED_LIST_TASK", ()=>$5f07ce956337ba8b$export$7a2fcaad1564e6b7);
    $parcel$export(module.exports, "OPS_JTBD_1_LIST", ()=>$5f07ce956337ba8b$export$da23b72d32bfad9e);
    $parcel$export(module.exports, "OPS_JTBD_2_BOARD", ()=>$5f07ce956337ba8b$export$4b064659282e0238);
    $parcel$export(module.exports, "OPS_JTBD_2_FORMS", ()=>$5f07ce956337ba8b$export$3ab51851f6d823e);
    $parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", ()=>$5f07ce956337ba8b$export$e4a1a37a9a1350ad);
    $parcel$export(module.exports, "OPS_JTBD_3_LIST", ()=>$5f07ce956337ba8b$export$b7f7da5e795f0327);
    $parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", ()=>$5f07ce956337ba8b$export$80a401c1aa47a377);
    $parcel$export(module.exports, "OPS_JTBD_3_PAGES", ()=>$5f07ce956337ba8b$export$934ac7a251b26dc7);
    $parcel$export(module.exports, "OPS_JTBD_4_LIST", ()=>$5f07ce956337ba8b$export$4634f6395df3ebbe);
    $parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", ()=>$5f07ce956337ba8b$export$768fb41107a1e8d7);
    $parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", ()=>$5f07ce956337ba8b$export$d797a81bace17184);
    $parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", ()=>$5f07ce956337ba8b$export$746102c94db9df1f);
    $parcel$export(module.exports, "OPS_JTBD_5_LIST", ()=>$5f07ce956337ba8b$export$5f1efd797d65e349);
    $parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", ()=>$5f07ce956337ba8b$export$cccc812ccafbf11f);
    $parcel$export(module.exports, "OPS_JTBD_5_PAGES", ()=>$5f07ce956337ba8b$export$64822db87abd8a47);
    $parcel$export(module.exports, "OPS_JTBD_6_PAGES", ()=>$5f07ce956337ba8b$export$64f764d8be495c82);
    $parcel$export(module.exports, "OPS_JTBD_7_LIST", ()=>$5f07ce956337ba8b$export$24eae23dc1c68bbd);
    $parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", ()=>$5f07ce956337ba8b$export$50fa92eba6f82feb);
    $parcel$export(module.exports, "OPS_JTBD_0_LIST", ()=>$5f07ce956337ba8b$export$4155d22fe3f14cd6);
    $parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", ()=>$5f07ce956337ba8b$export$76813cbead887191);
    $parcel$export(module.exports, "OPS_JTBD_0_PAGES", ()=>$5f07ce956337ba8b$export$90aab2ff89daf770);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", ()=>$5f07ce956337ba8b$export$a2bc0cbad2e6e605);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", ()=>$5f07ce956337ba8b$export$f90872a1280728bb);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", ()=>$5f07ce956337ba8b$export$bce644e96518cbd2);
    $parcel$export(module.exports, "MKT_JTBD_1_LIST", ()=>$5f07ce956337ba8b$export$241aaebffac0a3e5);
    $parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", ()=>$5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
    $parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", ()=>$5f07ce956337ba8b$export$79759e9e62fb9312);
    $parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", ()=>$5f07ce956337ba8b$export$992d1e0dce255d19);
    $parcel$export(module.exports, "MKT_JTBD_2_PAGES", ()=>$5f07ce956337ba8b$export$d28c1b0e5b3e768);
    $parcel$export(module.exports, "MKT_JTBD_3_PAGES", ()=>$5f07ce956337ba8b$export$ca714ee197bed4ec);
    $parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", ()=>$5f07ce956337ba8b$export$faae55ceea4b6073);
    $parcel$export(module.exports, "MKT_JTBD_4_LIST", ()=>$5f07ce956337ba8b$export$200bc24cd120667e);
    $parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", ()=>$5f07ce956337ba8b$export$a0d784a48b4e886c);
    $parcel$export(module.exports, "MKT_JTBD_4_PAGES", ()=>$5f07ce956337ba8b$export$baf5bd09b4b33b8a);
    $parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", ()=>$5f07ce956337ba8b$export$4702007eedbca8ab);
    $parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", ()=>$5f07ce956337ba8b$export$aa9d2d635ea63898);
    $parcel$export(module.exports, "MKT_JTBD_6_FORMS", ()=>$5f07ce956337ba8b$export$2ea449225c1f6cac);
    $parcel$export(module.exports, "MKT_JTBD_0_LIST", ()=>$5f07ce956337ba8b$export$deb8b557e735e26a);
    $parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", ()=>$5f07ce956337ba8b$export$d45754df44e4c309);
    $parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", ()=>$5f07ce956337ba8b$export$78b2913b550edbb);
    $parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", ()=>$5f07ce956337ba8b$export$71243272608c58ab);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", ()=>$5f07ce956337ba8b$export$39a08f215c33bc39);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", ()=>$5f07ce956337ba8b$export$d2377f6a6fa3b49c);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", ()=>$5f07ce956337ba8b$export$befa8f6533309779);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", ()=>$5f07ce956337ba8b$export$736b40db8701ba6c);
    $parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", ()=>$5f07ce956337ba8b$export$99b0e09ff6f00490);
    $parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", ()=>$5f07ce956337ba8b$export$2a82344eb273eeff);
    $parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", ()=>$5f07ce956337ba8b$export$1de5766b7e640d6b);
    $parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$8ab0859f5b30b013);
    $parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", ()=>$5f07ce956337ba8b$export$d1f6d18c6698104c);
    $parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", ()=>$5f07ce956337ba8b$export$e6ee159eee7adc1c);
    $parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", ()=>$5f07ce956337ba8b$export$dd267ca1e3cd3bad);
    $parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", ()=>$5f07ce956337ba8b$export$f14c8bffc35200d3);
    $parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", ()=>$5f07ce956337ba8b$export$36cc22c9997d92a);
    $parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", ()=>$5f07ce956337ba8b$export$d651cc94a46ff383);
    $parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", ()=>$5f07ce956337ba8b$export$11c0696d49e68c93);
    $parcel$export(module.exports, "ACCOUNT_ID", ()=>$5f07ce956337ba8b$export$c8ab6996f562d0db);
    $parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$2b5f951ad8e70cfe);
    $parcel$export(module.exports, "QUICKSTART_UI_STATUS", ()=>$5f07ce956337ba8b$export$5703447487aaccdf);
    $parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", ()=>$5f07ce956337ba8b$export$e0197e09cccd4e50);
    $parcel$export(module.exports, "PROJECT_SETTING_PAGES", ()=>$5f07ce956337ba8b$export$f779bbfe667acddc);
    $parcel$export(module.exports, "JSM_BUSINESS_TASKS", ()=>$5f07ce956337ba8b$export$38fbac7a5bf4aa33);
    $parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", ()=>$5f07ce956337ba8b$export$7578902c7f420a3);
    var $65Ltd;
    var $g5X3G;
    const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
    const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
    const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
    const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
    const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
    const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
        JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
        OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
    };
    const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
    const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
    const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
    const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
    const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
    const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
    const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
    const $5f07ce956337ba8b$export$e5b557e3bbb7ec52 = 'isDevopsProject';
    const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
    const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
    const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
    const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
    const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
    const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
    const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
    const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
    const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
    const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
    const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
    const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
    const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
    const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
    const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
    const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
    const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
    const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
    const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
    const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
    const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
    const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
    const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
    const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
    const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
    const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
    const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
    const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
    const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
    const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
    const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
    const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
    const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
    const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
    const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
    const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
    const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
    const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
    const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
    const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
    const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
    const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
    const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
    const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
    const $5f07ce956337ba8b$export$ce8b25442735839a = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-boards');
    const $5f07ce956337ba8b$export$31015cf4e430c94d = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-cards');
    const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
    const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
    const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
    const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
    const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
    const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
    const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
    const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
    const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
    const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
    const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
    const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
    const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
    const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
    const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
    const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
    const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
    const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
    const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
    const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
    const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
    const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
    const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
    const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
    const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
    const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
    const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
    const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
    const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
    const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
    const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
    const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
    const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
    const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
    const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
    const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
    const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
    const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
    const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
    const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
    const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
    const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
    const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
    const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
    const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
    const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
    const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
    const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
    const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
    const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
    const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
    const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
    const $5f07ce956337ba8b$export$8ab0859f5b30b013 = $5f07ce956337ba8b$var$completeDevopsTaskName('welcome-to-your-project-task');
    const $5f07ce956337ba8b$export$d1f6d18c6698104c = $5f07ce956337ba8b$var$completeDevopsTaskName('get-to-know-jira-task');
    const $5f07ce956337ba8b$export$e6ee159eee7adc1c = $5f07ce956337ba8b$var$completeDevopsTaskName('navigate-your-tools-task');
    const $5f07ce956337ba8b$export$dd267ca1e3cd3bad = $5f07ce956337ba8b$var$completeDevopsTaskName('capture-integrations-task');
    const $5f07ce956337ba8b$export$f14c8bffc35200d3 = $5f07ce956337ba8b$var$completeDevopsTaskName('create-automation-rules-task');
    const $5f07ce956337ba8b$export$36cc22c9997d92a = $5f07ce956337ba8b$var$completeDevopsTaskName('invite-teammates-task');
    const $5f07ce956337ba8b$export$d651cc94a46ff383 = $5f07ce956337ba8b$var$completeDevopsTaskName('find-help-task');
    const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
    const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, (0, parcelRequire("g5X3G")).toAccountId)('accountId');
    const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
    const $5f07ce956337ba8b$export$5703447487aaccdf = {
        NOT_LOADED: 'NOT_LOADED',
        OPEN: 'OPEN',
        MINIMIZED: 'MINIMIZED',
        DISMISSED: 'DISMISSED'
    };
    const $5f07ce956337ba8b$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
    const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
    const $5f07ce956337ba8b$export$f779bbfe667acddc = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)
    ];
    const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
        $5f07ce956337ba8b$export$2a82344eb273eeff,
        $5f07ce956337ba8b$export$99b0e09ff6f00490,
        $5f07ce956337ba8b$export$1de5766b7e640d6b
    ];
    const $5f07ce956337ba8b$export$7578902c7f420a3 = [
        $5f07ce956337ba8b$export$88c918f2cfaff86,
        $5f07ce956337ba8b$export$6a4507e462fd41da,
        $5f07ce956337ba8b$export$e64c1dced6ac4458,
        $5f07ce956337ba8b$export$63b0e55f9c6454ac,
        $5f07ce956337ba8b$export$c1effb1c8979fe22,
        $5f07ce956337ba8b$export$cbeb719208f32c8a,
        $5f07ce956337ba8b$export$abbbea7c37c93cb5,
        $5f07ce956337ba8b$export$2a0253cb20f48a8,
        $5f07ce956337ba8b$export$f97428bb4b1991ec,
        $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
        $5f07ce956337ba8b$export$3de8c242d2b82f26,
        $5f07ce956337ba8b$export$a01fa44f793dbfac,
        $5f07ce956337ba8b$export$45eaf4204fcc7,
        $5f07ce956337ba8b$export$af57685e201438e8,
        $5f07ce956337ba8b$export$d97d31d934dbb194,
        $5f07ce956337ba8b$export$cafb5bd13b02056b,
        $5f07ce956337ba8b$export$e55c18b809946e72,
        $5f07ce956337ba8b$export$de5640b9ae8140a7,
        $5f07ce956337ba8b$export$540b5c3c4b6ce459,
        $5f07ce956337ba8b$export$6f71dff531ff592,
        $5f07ce956337ba8b$export$83255ab79e45f34f,
        $5f07ce956337ba8b$export$b57d172af9ad7647,
        $5f07ce956337ba8b$export$ff4c933c1fe90b68,
        $5f07ce956337ba8b$export$77071b77e2801b18,
        $5f07ce956337ba8b$export$94ad6507a703f4eb,
        $5f07ce956337ba8b$export$501166b25f254aab,
        $5f07ce956337ba8b$export$be1c522400a1bd7c,
        $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
        $5f07ce956337ba8b$export$f3b53199b07af2a1,
        $5f07ce956337ba8b$export$d37415ffddcf2142,
        $5f07ce956337ba8b$export$2ae00586da7cb606,
        $5f07ce956337ba8b$export$9c89f946f05d884a,
        $5f07ce956337ba8b$export$20bc3dc137ac1c38,
        $5f07ce956337ba8b$export$b52a7c936684cfc5,
        $5f07ce956337ba8b$export$b5555f24061f9fb,
        $5f07ce956337ba8b$export$ff25449f34b8abf,
        $5f07ce956337ba8b$export$3380e677209260fe,
        $5f07ce956337ba8b$export$b86266e6594a97bb,
        $5f07ce956337ba8b$export$8ab0859f5b30b013,
        $5f07ce956337ba8b$export$d1f6d18c6698104c,
        $5f07ce956337ba8b$export$e6ee159eee7adc1c,
        $5f07ce956337ba8b$export$dd267ca1e3cd3bad,
        $5f07ce956337ba8b$export$f14c8bffc35200d3,
        $5f07ce956337ba8b$export$36cc22c9997d92a,
        $5f07ce956337ba8b$export$d651cc94a46ff383,
        $5f07ce956337ba8b$export$3e2776d61f3662dc,
        $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
        $5f07ce956337ba8b$export$9048315f2c03fd9d,
        $5f07ce956337ba8b$export$a333714599f14a6,
        $5f07ce956337ba8b$export$4145c2cec2da6f9b,
        $5f07ce956337ba8b$export$4957a1ad203cf6dd,
        $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
        $5f07ce956337ba8b$export$190b5dd0a1322552,
        $5f07ce956337ba8b$export$da23b72d32bfad9e,
        $5f07ce956337ba8b$export$4b064659282e0238,
        $5f07ce956337ba8b$export$3ab51851f6d823e,
        $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
        $5f07ce956337ba8b$export$b7f7da5e795f0327,
        $5f07ce956337ba8b$export$80a401c1aa47a377,
        $5f07ce956337ba8b$export$934ac7a251b26dc7,
        $5f07ce956337ba8b$export$4634f6395df3ebbe,
        $5f07ce956337ba8b$export$768fb41107a1e8d7,
        $5f07ce956337ba8b$export$d797a81bace17184,
        $5f07ce956337ba8b$export$746102c94db9df1f,
        $5f07ce956337ba8b$export$5f1efd797d65e349,
        $5f07ce956337ba8b$export$cccc812ccafbf11f,
        $5f07ce956337ba8b$export$64822db87abd8a47,
        $5f07ce956337ba8b$export$64f764d8be495c82,
        $5f07ce956337ba8b$export$24eae23dc1c68bbd,
        $5f07ce956337ba8b$export$50fa92eba6f82feb,
        $5f07ce956337ba8b$export$4155d22fe3f14cd6,
        $5f07ce956337ba8b$export$76813cbead887191,
        $5f07ce956337ba8b$export$90aab2ff89daf770,
        $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
        $5f07ce956337ba8b$export$f90872a1280728bb,
        $5f07ce956337ba8b$export$bce644e96518cbd2,
        $5f07ce956337ba8b$export$241aaebffac0a3e5,
        $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
        $5f07ce956337ba8b$export$79759e9e62fb9312,
        $5f07ce956337ba8b$export$992d1e0dce255d19,
        $5f07ce956337ba8b$export$d28c1b0e5b3e768,
        $5f07ce956337ba8b$export$ca714ee197bed4ec,
        $5f07ce956337ba8b$export$faae55ceea4b6073,
        $5f07ce956337ba8b$export$200bc24cd120667e,
        $5f07ce956337ba8b$export$a0d784a48b4e886c,
        $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
        $5f07ce956337ba8b$export$4702007eedbca8ab,
        $5f07ce956337ba8b$export$aa9d2d635ea63898,
        $5f07ce956337ba8b$export$2ea449225c1f6cac,
        $5f07ce956337ba8b$export$deb8b557e735e26a,
        $5f07ce956337ba8b$export$d45754df44e4c309,
        $5f07ce956337ba8b$export$78b2913b550edbb,
        $5f07ce956337ba8b$export$71243272608c58ab,
        $5f07ce956337ba8b$export$39a08f215c33bc39,
        $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
        $5f07ce956337ba8b$export$befa8f6533309779,
        $5f07ce956337ba8b$export$736b40db8701ba6c
    ];
});
parcelRegister("6RAg1", function(module, exports) {
    $parcel$export(module.exports, "changeTaskGroupParent", ()=>(parcelRequire("6fSBR")).nextChangeTaskGroupParent);
    $parcel$export(module.exports, "goBackToPreviousTaskGroup", ()=>(parcelRequire("6fSBR")).nextGoBackToPreviousTaskGroup);
    $parcel$export(module.exports, "setIsOpen", ()=>(parcelRequire("j6wxT")).setIsOpen);
    $parcel$export(module.exports, "refreshAppState", ()=>(parcelRequire("7mZ3t")).refreshAppState);
    $parcel$export(module.exports, "setNudgeStep", ()=>(parcelRequire("8UXiA")).setNudgeStep);
    $parcel$export(module.exports, "addMountedNudge", ()=>(parcelRequire("3iEb4")).addMountedNudge);
    $parcel$export(module.exports, "removeMountedNudge", ()=>(parcelRequire("3iEb4")).removeMountedNudge);
    $parcel$export(module.exports, "setShouldRenderComponent", ()=>(parcelRequire("7yDu9")).setShouldRenderComponent);
    $parcel$export(module.exports, "setProjectState", ()=>(parcelRequire("5UBG2")).setProjectState);
    $parcel$export(module.exports, "setHasNudgeActive", ()=>(parcelRequire("lHcRB")).setHasNudgeActive);
    $parcel$export(module.exports, "forceHideNudge", ()=>(parcelRequire("eiyXc")).forceHideNudge);
    $parcel$export(module.exports, "setHasEverSeenRoute", ()=>(parcelRequire("jZvbN")).setHasEverSeenRoute);
    $parcel$export(module.exports, "setRoadmapIsCreateEnabled", ()=>(parcelRequire("azcAL")).setRoadmapIsCreateEnabled);
    $parcel$export(module.exports, "setRoadmapIsListEmpty", ()=>(parcelRequire("azcAL")).setRoadmapIsListEmpty);
    $parcel$export(module.exports, "openNextTask", ()=>(parcelRequire("gbXQ5")).openNextTask);
    $parcel$export(module.exports, "resetIsQuickstartLoaded", ()=>(parcelRequire("iZuFy")).resetIsQuickstartLoaded);
    $parcel$export(module.exports, "refreshAppStateUiStatusOnly", ()=>(parcelRequire("70Fss")).refreshAppStateUiStatusOnly);
    $parcel$export(module.exports, "nextMarkAsCompletedTask", ()=>(parcelRequire("erLQY")).nextMarkAsCompletedTask);
    $parcel$export(module.exports, "nextSetChecklistItemSeen", ()=>(parcelRequire("dQPsy")).nextSetChecklistItemSeen);
    $parcel$export(module.exports, "nextSetChecklistIsDismissed", ()=>(parcelRequire("abQXL")).nextSetChecklistIsDismissed);
    $parcel$export(module.exports, "nextSetChecklistIsOpen", ()=>(parcelRequire("4VXxO")).nextSetChecklistIsOpen);
    $parcel$export(module.exports, "nextOpenTask", ()=>(parcelRequire("cUGWT")).nextOpenTask);
    $parcel$export(module.exports, "nextAutoExpand", ()=>(parcelRequire("boV1S")).nextAutoExpand);
    $parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", ()=>(parcelRequire("4Viq4")).nextShouldShowNudgeAfterNavigation);
    $parcel$export(module.exports, "nextGetTasks", ()=>(parcelRequire("jIoq4")).nextGetTasks);
    $parcel$export(module.exports, "syncVisibilityWithLocal", ()=>(parcelRequire("75A1x")).syncVisibilityWithLocal);
    var $6fSBR;
    var $j6wxT;
    var $7mZ3t;
    var $8UXiA;
    var $3iEb4;
    var $7yDu9;
    var $5UBG2;
    var $lHcRB;
    var $eiyXc;
    var $jZvbN;
    var $azcAL;
    var $gbXQ5;
    var $iZuFy;
    var $70Fss;
    var $erLQY;
    var $dQPsy;
    var $abQXL;
    var $4VXxO;
    var $cUGWT;
    var $boV1S;
    var $4Viq4;
    var $jIoq4;
    var $75A1x;
});
parcelRegister("6fSBR", function(module, exports) {
    $parcel$export(module.exports, "nextChangeTaskGroupParent", ()=>$0f1566e1d3fc2987$export$76708cce5888039a);
    $parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", ()=>$0f1566e1d3fc2987$export$57534cbc400a434c);
    var $8Bc5A;
    var $1ftPQ;
    const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
            setState({
                ...taskGroup,
                openTask: ''
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP),
                value: {
                    taskGroup: taskGroup
                }
            });
        };
    const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
            const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
            if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) return;
            previousTaskGroupParents.push(currentTaskGroupParent);
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newCurrentTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        };
    const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, (0, parcelRequire("8Bc5A")).ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        };
});
parcelRegister("1ftPQ", function(module, exports) {
    $parcel$export(module.exports, "pushToBackend", ()=>$d3dd40bf54ad27bf$export$583b2d2422a6757f);
    var $89SaW;
    var $4Pf62;
    var $jcw0u;
    var $jJZqs;
    const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
        const { atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
        return atlassianAccountId;
    };
    const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, (0, parcelRequire("89SaW")).setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, response.statusText);
        });
    const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
        try {
            await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'pushToBackend',
                    packageName: 'jiraOnboardingQuickstartCore',
                    teamName: 'jlove-makkuro'
                },
                attributes: {
                    action: 'pushToBackend',
                    actionSubject: 'jiraOnboardingChecklistCore',
                    attemptCount: attemptCount,
                    key: props.key,
                    reason: error && error.message
                },
                error: error
            });
            return false;
        }
        return true;
    };
    const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
        const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
        if (!success) await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
    };
});
parcelRegister("j6wxT", function(module, exports) {
    $parcel$export(module.exports, "setIsOpen", ()=>$eefde484654068e9$export$dcf23146e0a40195);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            if (isOpen === currentIsOpen) return;
            const quickstartStatus = isOpen ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                }
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: isOpen
            });
        };
    var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;
});
parcelRegister("3B5jO", function(module, exports) {
    $parcel$export(module.exports, "getQuickstartTypeSelector", ()=>$47424244d57f6abc$export$eae834ce0286017a);
    var $2vSU6;
    var $8Bc5A;
    const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
    const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
        if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
        return (0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
    };
});
parcelRegister("7mZ3t", function(module, exports) {
    $parcel$export(module.exports, "refreshAppState", ()=>$ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);
    var $4R6GH;
    var $8fqy8;
    var $8zOmE;
    var $bfWlw;
    var $ldyPw;
    var $8Bc5A;
    var $6yhDy;
    var $1ftPQ;
    var $52Vcw;
    var $ljzlb;
    var $3ORcf;
    var $6ypzr;
    var $4ji4w;
    var $abQXL;
    var $4VXxO;
    var $erLQY;
    var $6fSBR;
    const $ecf6e94ad9c4f8d6$var$allTasks = [
        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
        ...(0, (0, parcelRequire("8Bc5A")).JSM_BUSINESS_TASKS)
    ];
    const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const updatedState = {};
            const hasSeenTasks = [
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)),
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK))
            ];
            const { projectState: projectState = null } = getState();
            updatedState.isOpen = true;
            updatedState.isDismissed = false;
            updatedState.quickstartStateProjectType = projectType;
            let backendVisibilityKeys = [];
            let jsmTaskProjectKeys = [];
            updatedState.visibility = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, {});
            backendVisibilityKeys = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).map((type)=>(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type));
            if (projectState?.projectId) jsmTaskProjectKeys = (0, (0, parcelRequire("8Bc5A")).JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
            const backendState = await (0, (0, parcelRequire("6yhDy")).pollBackend)({
                keys: [
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                    (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                    (0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP),
                    (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                    (0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING),
                    (0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED),
                    ...$ecf6e94ad9c4f8d6$var$allTasks,
                    ...hasSeenTasks,
                    ...backendVisibilityKeys,
                    ...jsmTaskProjectKeys
                ]
            });
            if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, (0, parcelRequire("3ORcf")).getIsDevOpsProject)(projectState.projectKey);
            const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
            if (backendStateExists) {
                updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
                        ...jsmTaskProjectKeys
                    ].includes(key) && backendState[key] === true);
                updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
                Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).forEach((type)=>{
                    if ((0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type)];
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState && backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED]) updatedState.visibility[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN] ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
                    (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
                });
                if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP) in backendState) {
                    updatedState.currentTaskGroupParent = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                    updatedState.previousTaskGroupParents = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
                }
                if ((0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING) in backendState) {
                    if (typeof backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] === 'object' && backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
                }
            }
            setState(updatedState);
            if ((updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) {
                dispatch((0, (0, parcelRequire("6fSBR")).nextGoBackToPreviousTaskGroup)());
                const analyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
            }
            if (!(backendStateExists && (0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState)) try {
                const skipApplicationProperty = await (0, (0, parcelRequire("6ypzr")).getOnboardingSkipApplicationProperty)();
                if (skipApplicationProperty.quickstart) dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(true));
            } catch (error) {
                (0, (0, parcelRequire("52Vcw")).fireAPIErrorAnalytics)(error, 'skipOnboarding');
            }
            const jswTrackDeferSitenameSiteTrait = await (0, (0, parcelRequire("8fqy8")).getJswTrackDeferSitenameSiteTrait)(cloudId, {
                packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
            });
            setState({
                isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
            });
            const setPremiumCardAudienceTrait = async (accountId)=>{
                if (accountId === null) return;
                const trait = await (0, (0, parcelRequire("ljzlb")).getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
                setState({
                    isCrossProjectBoardToPlanUpsell: trait?.value === true || false
                });
            };
            if (appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
            const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
            let isReverseTrialForJSW;
            if (isTargetedForReverseTrials && (0, (0, parcelRequire("4R6GH")).fg)('jsw_reverse_trials_feature_gate')) {
                const isOnboardingPremiumTrial = await (0, (0, parcelRequire("bfWlw")).getOnboardingPremiumTrial)();
                isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
            }
            if (!isReverseTrialForJSW && appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED]) {
                dispatch((0, (0, parcelRequire("4VXxO")).nextSetChecklistIsOpen)(true));
                dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(false));
                const taskToDispatch = isAdmin ? (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK) : (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
                dispatch((0, (0, parcelRequire("erLQY")).nextMarkAsCompletedTask)(taskToDispatch));
                dispatch((0, (0, parcelRequire("6fSBR")).nextChangeTaskGroupParent)(taskToDispatch));
                await (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                    key: (0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED),
                    value: true
                });
                const analyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                    isAdmin: isAdmin
                });
            }
            setState({
                canEditPlans: canEditPlans
            });
            setState({
                isQuickstartLoaded: true
            });
        };
});
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
parcelRegister("8fqy8", function(module, exports) {
    $parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", ()=>$77364531dfabe700$export$686752df505238be);
    $parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", ()=>$77364531dfabe700$export$6da79f996c267010);
    var $jcw0u;
    var $eusud;
    const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
    const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
    const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
    const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
    const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
    const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
            try {
                const url = endpoint + id;
                return await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'onboarding',
                        teamName: 'jlove-makkuro',
                        ...meta
                    },
                    attributes: {
                        subject: subject
                    },
                    error: error
                });
                return undefined;
            }
        };
    const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
            const personalization = await fetch(id, meta);
            return personalization?.attributes?.find((att)=>att.name === traitName);
        };
    const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
    const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);
});
parcelRegister("bfWlw", function(module, exports) {
    $parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", ()=>$a55f3307b43c0521$export$d9a9dd6206da5bef);
    $parcel$export(module.exports, "getOnboardingPremiumTrial", ()=>$a55f3307b43c0521$export$ef676f7f369f74fe);
    var $jcw0u;
    var $eusud;
    var $6c7t9;
    const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
    const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
        try {
            const localStorageOnboardingPremiumTrial = (0, (0, parcelRequire("6c7t9")).localStorageGetOnboardingPremiumTrial)();
            const localStorageOnboardingPremiumTrialCohort = (0, (0, parcelRequire("6c7t9")).localStorageGetOnboardingPremiumTrialCohort)();
            if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
                premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
                reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
            };
            const response = await (0, (0, parcelRequire("eusud")).performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
            const premiumTrialOnSignup = response?.premiumTrialOnSignup;
            const reverseTrialCohort = response?.reverseTrialCohort;
            if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
                (0, (0, parcelRequire("6c7t9")).localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
                (0, (0, parcelRequire("6c7t9")).localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
                return {
                    premiumTrialOnSignup: premiumTrialOnSignup,
                    reverseTrialCohort: reverseTrialCohort
                };
            }
            throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getOnboardingPremiumTrialWithRethrow',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
        try {
            return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
        } catch (e) {}
    };
});
parcelRegister("6c7t9", function(module, exports) {
    $parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", ()=>$fab9df2877e9db77$export$782df5489e5cfd1e);
    $parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", ()=>$fab9df2877e9db77$export$c3378895d06b5528);
    $parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", ()=>$fab9df2877e9db77$export$f83a7a49524e74ad);
    $parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", ()=>$fab9df2877e9db77$export$f389f8ca168b4a3a);
    var $bSSG7;
    var $jcw0u;
    const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
    const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
    const $fab9df2877e9db77$var$localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
    const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
        try {
            const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
            return value;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageGetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        }
    };
    const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
        try {
            const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
            return value;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageGetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        }
    };
    const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
        try {
            $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageSetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
        try {
            $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageSetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("6yhDy", function(module, exports) {
    $parcel$export(module.exports, "pollBackend", ()=>$760653e5a4f27459$export$8420ef0cee98de);
    var $1sYcL;
    var $g5X3G;
    var $8Bc5A;
    const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
        const { user: user } = await (0, (0, parcelRequire("1sYcL")).get)((0, (0, parcelRequire("g5X3G")).toBaseUrl)(''), {
            userProperties: keys,
            consumerMeta: {
                id: 'fetchUserProperties',
                packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
            }
        });
        return user;
    };
});
parcelRegister("1sYcL", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$7fc92c544211ac93$export$3988ae62b71be9a3);
    var $lbWm4 = parcelRequire("lbWm4");
    var $3T6Xo = parcelRequire("3T6Xo");
    var $jcw0u;
    var $4R6GH;
    var $fZneA;
    var $eusud;
    var $fjcgS;
    var $atdLB;
    var $duUGa;
    let $7fc92c544211ac93$var$ufoExperiencesMap = {};
    const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
        if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, (0, parcelRequire("duUGa")).UFOExperience)(key, {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
        });
        return $7fc92c544211ac93$var$ufoExperiencesMap[key];
    };
    const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
        $7fc92c544211ac93$var$ufoExperiencesMap = {};
    };
    const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
        const params = new URLSearchParams();
        userProperties && params.append('user', userProperties.join(','));
        projectId !== undefined && params.append('projectId', projectId);
        projectProperties && params.append('project', projectProperties.join(','));
        instanceProperties && params.append('instance', instanceProperties.join(','));
        return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
    };
    const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, (0, parcelRequire("4R6GH")).fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, ($parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
            try {
                response[propertiesPath][prop] = JSON.parse(value);
            } catch (error) {
                if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
                else throw error;
            }
        });
    const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
        const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, ($parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, ($parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
        try {
            ufoExperience?.start();
            const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(baseUrl, options);
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            if (response === null) (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    action: 'succeeded',
                    actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                    source: 'frontendConfigProperties',
                    attributes: {
                        package: consumerMeta.packageName,
                        id: consumerMeta.id,
                        isNullResponse: true
                    }
                };
                client.getInstance().sendOperationalEvent(payload);
            });
            $7fc92c544211ac93$var$patchProperties(response, 'user');
            $7fc92c544211ac93$var$patchProperties(response, 'instance');
            $7fc92c544211ac93$var$patchProperties(response, 'project');
            const { consumerMeta: consumerMeta } = options;
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    source: 'frontendConfigProperties',
                    action: 'success',
                    actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
                };
                client.getInstance().sendOperationalEvent(payload);
            });
            ufoExperience?.success();
            return (0, (0, parcelRequire("4R6GH")).fg)('handle_null_response_for_fe_config_properties_call') ? response || {
                user: {},
                instance: {},
                project: {}
            } : response;
        } catch (error) {
            const { consumerMeta: consumerMeta } = options;
            !(0, (0, parcelRequire("fZneA")).isClientFetchError)(error) && (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: consumerMeta.id,
                    packageName: consumerMeta.packageName,
                    teamName: consumerMeta.teamName
                },
                sendToPrivacyUnsafeSplunk: true
            });
            ufoExperience?.failure();
            throw error;
        }
    };
});
parcelRegister("52Vcw", function(module, exports) {
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", ()=>$5dab66e6da9554ae$export$c98a6ee6aadb8055);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", ()=>$5dab66e6da9554ae$export$45d8c76e0490b3ec);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", ()=>$5dab66e6da9554ae$export$b1be4ae35a43115d);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", ()=>$5dab66e6da9554ae$export$fa4f266bd2444d14);
    $parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", ()=>$5dab66e6da9554ae$export$a68a2e5a69c8cd74);
    $parcel$export(module.exports, "fireAPIErrorAnalytics", ()=>$5dab66e6da9554ae$export$a4d7f1a52677d339);
    $parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", ()=>$5dab66e6da9554ae$export$160bb78a3b11a5a9);
    $parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", ()=>$5dab66e6da9554ae$export$6ccbe54cd3a5a12);
    $parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", ()=>$5dab66e6da9554ae$export$6c39ca65ca354e59);
    var $jcw0u;
    var $8zOmE;
    var $8Bc5A;
    var $izv86;
    const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
        analyticsEvent.update({
            action: 'closed',
            actionSubject: 'button'
        });
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button closed', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), attributes);
    };
    const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
        if (source === 'button') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
        else if (source === 'checklist') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
    };
    const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
    };
    const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(completedTaskId), {
            taskId: completedTaskId
        });
    };
    const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                error: error.message,
                endpointSource: endpointSource
            }
        });
    };
    const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
});
parcelRegister("izv86", function(module, exports) {
    $parcel$export(module.exports, "getProductType", ()=>$4725f5ccfabd2231$export$27e53caf66bae1d);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectId", ()=>$4725f5ccfabd2231$export$3b914201960fa7a6);
    var $e4eHl = parcelRequire("e4eHl");
    var $2vSU6;
    const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
        [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'workManagement',
        [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'serviceManagement'
    };
    const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
        if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, ($parcel$interopDefault($e4eHl)))(projectType);
        return null;
    };
    const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
        if (!taskId) return '';
        return (0, ($parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
    };
});
parcelRegister("ljzlb", function(module, exports) {
    $parcel$export(module.exports, "getCrossProjectBoardTrait", ()=>$9217b5bb53dd29c2$export$7f2186c37a3d095d);
    var $jcw0u;
    var $co1wz;
    var $eusud;
    var $8zOmE;
    var $8Bc5A;
    var $k9OK8;
    const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
    const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
    const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
    const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
        try {
            const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
            const result = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
                synthetic: (0, (0, parcelRequire("co1wz")).ff)('jsw.pollinator.tenants')
            });
            return result;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'quickstartApiError',
                    packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                    teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
                },
                attributes: {
                    error: error.message,
                    endpointSource: 'getJSWCrossProjectBoardTrait',
                    synthetic: (0, (0, parcelRequire("co1wz")).ff)('jsw.pollinator.tenants')
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                attributes: []
            };
        }
    };
    const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
        const { get: get, persist: persist } = (0, (0, parcelRequire("k9OK8")).crossProjectBoardTraitSessionStorageProvider)();
        const sessionStorage = get();
        if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
                synthetic: (0, (0, parcelRequire("co1wz")).ff)('jsw.pollinator.tenants')
            });
            return sessionStorage.attribute;
        }
        const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
        const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
        if (attribute !== undefined) persist({
            attribute: attribute,
            date: Date.now(),
            userId: userId,
            siteId: siteId
        });
        return attribute;
    };
});
parcelRegister("k9OK8", function(module, exports) {
    $parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", ()=>$ee27e8acf854e0ab$export$99f3e48748c2a8c3);
    var $eNf8a;
    const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
        const persist = (toPersist)=>{
            $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
        };
        const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
        return {
            get: get,
            persist: persist
        };
    };
});
parcelRegister("eNf8a", function(module, exports) {
    $parcel$export(module.exports, "createSessionStorageProvider", ()=>$b98f887ad675a269$export$a922b987e648d2fa);
    $parcel$export(module.exports, "createSessionExpirableStorageProvider", ()=>$b98f887ad675a269$export$e0a2e9a062c6a695);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $j9Vq5;
    const $b98f887ad675a269$export$a922b987e648d2fa = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("j9Vq5")).makeSessionStore)()));
    const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("j9Vq5")).makeSessionExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("j9Vq5", function(module, exports) {
    $parcel$export(module.exports, "makeSessionStore", ()=>$93ac2abe604287b3$export$fb690882d627b3b5);
    $parcel$export(module.exports, "makeSessionExpirableStore", ()=>$93ac2abe604287b3$export$a8f626c8ded9a06c);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $2NjNT = parcelRequire("2NjNT");
    var $c74za = parcelRequire("c74za");
    var $fNVZf;
    const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';
parcelRegister("3ORcf", function(module, exports) {
    $parcel$export(module.exports, "getIsDevOpsProject", ()=>$d5d39abfab8df073$export$88ee873472aa9bb7);
    var $8Bc5A;
    const $d5d39abfab8df073$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, (0, parcelRequire("8Bc5A")).KEY_IS_DEVOPS_PROJECT}`;
    const $d5d39abfab8df073$export$88ee873472aa9bb7 = async (projectKey)=>{
        const url = $d5d39abfab8df073$var$projectPropertyUrl(projectKey);
        const response = await fetch(url);
        if (response.ok) {
            const result = await response.json();
            return result.value;
        }
        return false;
    };
});
parcelRegister("6ypzr", function(module, exports) {
    $parcel$export(module.exports, "getOnboardingSkipApplicationProperty", ()=>$98fe78eb4dc2e758$export$980c26b6f100081d);
    var $eusud;
    const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/onboarding/1.0/skip');
});
parcelRegister("4ji4w", function(module, exports) {
    $parcel$export(module.exports, "getNextNonCompleteTask", ()=>$af696889329ec63a$export$b61dc70e2ed3fae3);
    $parcel$export(module.exports, "getNextTask", ()=>$af696889329ec63a$export$404421ce8f3cbf9a);
    $parcel$export(module.exports, "setLocalStorageItem", ()=>$af696889329ec63a$export$5aa524d86254b4f);
    $parcel$export(module.exports, "getLocalStorageItem", ()=>$af696889329ec63a$export$93d719890ad66653);
    var $bSSG7;
    var $aFsRe;
    const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
        const taskPosition = (0, (0, parcelRequire("aFsRe")).getTaskIndex)(tasks, openTask);
        const start = taskPosition === -1 ? 0 : taskPosition;
        const len = tasks.length;
        for(let i = start; i < start + len; i += 1){
            const ind = i % len;
            if (!completed.includes(tasks[ind])) return tasks[ind];
        }
        return null;
    };
    const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
        const taskPosition = (0, (0, parcelRequire("aFsRe")).getTaskIndex)(tasks, openTask);
        const ind = taskPosition === -1 ? 0 : taskPosition;
        return tasks[ind] ? tasks[ind] : null;
    };
    const $af696889329ec63a$var$store = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('quickstart');
    const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
        $af696889329ec63a$var$store.set(key, value);
    };
    const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);
});
parcelRegister("aFsRe", function(module, exports) {
    $parcel$export(module.exports, "getTaskIndex", ()=>$856e0575daef172f$export$9ba3adcb1954c00);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", ()=>$856e0575daef172f$export$9711f11998d5795c);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", ()=>$856e0575daef172f$export$995248f3b43d8505);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", ()=>$856e0575daef172f$export$293f6b2affa6ea5a);
    var $izv86;
    const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
        if (!taskList || taskId === null) return -1;
        return taskList.indexOf(taskId) + 1;
    };
    const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
    const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}Link`;
    const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}Cta`;
});
parcelRegister("abQXL", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistIsDismissed", ()=>$dc09dffee9419aae$export$f24c05f83b880547);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    var $4ji4w;
    const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsDismissed = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
            if (isDismissed === currentIsDismissed) return;
            const quickstartStatus = isDismissed ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                isFocusedOn: !isDismissed
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
            if (isDismissed === false) (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: true
            });
            else (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: false
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                value: isDismissed
            });
        };
});
parcelRegister("4VXxO", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistIsOpen", ()=>$7815e3bf96163d46$export$4249eabbb34e2e69);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    var $4ji4w;
    const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            const currentIsMinimised = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) return;
            const quickstartStatus = isOpen ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                hasNudgeActive: false,
                isFocusedOn: isOpen
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: isOpen
            });
        };
});
parcelRegister("erLQY", function(module, exports) {
    $parcel$export(module.exports, "nextMarkAsCompletedTask", ()=>$f082da41253fd664$export$d6628d41a3bec42d);
    var $1ftPQ;
    const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
            const { completedTaskList: completedTaskList } = getState();
            if (completedTaskList.includes(taskId)) return;
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: taskId,
                value: true
            });
            setState({
                completedTaskList: [
                    ...completedTaskList,
                    taskId
                ]
            });
        };
});
parcelRegister("8UXiA", function(module, exports) {
    $parcel$export(module.exports, "setNudgeStep", ()=>$2d15900fae273e3c$export$4debc323813b6997);
    const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { nudgeStep: nudgeStep } = getState();
            if (nudge === nudgeStep) return;
            setState({
                nudgeStep: nudge
            });
        };
    var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;
});
parcelRegister("3iEb4", function(module, exports) {
    $parcel$export(module.exports, "addMountedNudge", ()=>$d23aba2b0749d2be$export$92a89c32d0ea3943);
    $parcel$export(module.exports, "removeMountedNudge", ()=>$d23aba2b0749d2be$export$748f4cda8ab98c91);
    const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { mountedNudges: mountedNudges } = getState();
            if (mountedNudges.includes(nudge)) return;
            setState({
                mountedNudges: [
                    ...mountedNudges,
                    nudge
                ]
            });
        };
    const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { mountedNudges: mountedNudges } = getState();
            if (!mountedNudges.includes(nudge)) return;
            setState({
                mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
            });
        };
});
parcelRegister("7yDu9", function(module, exports) {
    $parcel$export(module.exports, "setShouldRenderComponent", ()=>$e7988e1b8f7782bd$export$1f9c6770ed938b6e);
    const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
            const { shouldRenderComponent: currentShouldRenderComponent } = getState();
            if (shouldRenderComponent === currentShouldRenderComponent) return;
            setState({
                shouldRenderComponent: shouldRenderComponent
            });
        };
    var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;
});
parcelRegister("5UBG2", function(module, exports) {
    $parcel$export(module.exports, "setProjectState", ()=>$72dc29ca0b198f0e$export$1ba498e440c0a1e4);
    const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
            setState({
                projectState: projectState
            });
        };
    var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;
});
parcelRegister("lHcRB", function(module, exports) {
    $parcel$export(module.exports, "setHasNudgeActive", ()=>$4ecbca1b06d3bc5e$export$497c281e6eb0786e);
    const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
            const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
            if (hasNudgeActive === currentHasNudgeActive) return;
            if (hasNudgeActive === false && itemName !== openTask) return;
            setState({
                hasNudgeActive: hasNudgeActive
            });
        };
    var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;
});
parcelRegister("eiyXc", function(module, exports) {
    $parcel$export(module.exports, "forceHideNudge", ()=>$7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
    const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
            setState({
                hasNudgeActive: false
            });
        };
});
parcelRegister("jZvbN", function(module, exports) {
    $parcel$export(module.exports, "setHasEverSeenRoute", ()=>$bde38543b00c29f3$export$28e0a4314a1ce52f);
    var $8Bc5A;
    var $1ftPQ;
    const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
            const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
            const somethingHasBeenUpdated = Object.keys(update).some((key)=>update[key] !== currentHasEverSeenRoute[key]);
            if (!somethingHasBeenUpdated) return;
            const newHasEverSeenRoute = {
                ...currentHasEverSeenRoute,
                ...update
            };
            setState({
                hasEverSeenRoute: newHasEverSeenRoute
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                value: newHasEverSeenRoute
            });
        };
    var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;
});
parcelRegister("azcAL", function(module, exports) {
    $parcel$export(module.exports, "setRoadmapIsCreateEnabled", ()=>$f19987e3027503ab$export$35ea35d1a8e07307);
    $parcel$export(module.exports, "setRoadmapIsListEmpty", ()=>$f19987e3027503ab$export$932967764e7a0b31);
    const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
            const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
            if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
            setState({
                roadmapIsCreateEnabled: roadmapIsCreateEnabled
            });
        };
    const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
            const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
            if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
            setState({
                roadmapIsListEmpty: roadmapIsListEmpty
            });
        };
});
parcelRegister("gbXQ5", function(module, exports) {
    $parcel$export(module.exports, "openNextTask", ()=>$460159056a360dfc$export$867dbb6d61569ae9);
    var $4ji4w;
    var $cUGWT;
    const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
            const { openTask: openTask, tasks: tasks } = getState();
            if (!tasks) return;
            const { items: items } = tasks;
            const taskIdToExpand = (0, (0, parcelRequire("4ji4w")).getNextTask)(items, openTask);
            if (taskIdToExpand === null) return;
            dispatch((0, (0, parcelRequire("cUGWT")).nextOpenTask)(taskIdToExpand));
        };
});
parcelRegister("cUGWT", function(module, exports) {
    $parcel$export(module.exports, "nextOpenTask", ()=>$f8b3135a172025f8$export$5deb889489d2f989);
    $parcel$export(module.exports, "nextAutoOpenTask", ()=>$f8b3135a172025f8$export$cc5f3544a6cb2922);
    var $8Bc5A;
    var $1ftPQ;
    var $8UXiA;
    var $lHcRB;
    const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
            setState({
                openTask: taskId
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                value: taskId
            });
        };
    const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($f8b3135a172025f8$var$openTask(taskId));
            const { completedTaskList: completedTaskList } = getState();
            const taskIsCompleted = completedTaskList.includes(taskId);
            const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
            if (closeNudge) dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(false, taskId));
            else dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
            if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
            else if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).KANBAN_ONBOARDING_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
            else if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
            else dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)(''));
        };
    const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
            dispatch($f8b3135a172025f8$var$openTask(taskId));
            dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(false, taskId));
            dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)(''));
        };
});
parcelRegister("iZuFy", function(module, exports) {
    $parcel$export(module.exports, "resetIsQuickstartLoaded", ()=>$b50ce46f86d3e3d7$export$bda085a823763e5a);
    var $8Bc5A;
    var $3B5jO;
    const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED
                },
                hasNudgeActive: false,
                isQuickstartLoaded: false
            });
        };
});
parcelRegister("70Fss", function(module, exports) {
    $parcel$export(module.exports, "refreshAppStateUiStatusOnly", ()=>$f0fdda8951af3bde$export$87fe8079a4ed9766);
    var $8Bc5A;
    var $6yhDy;
    var $52Vcw;
    var $6ypzr;
    var $abQXL;
    const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const updatedState = {};
            const { projectState: projectState } = getState();
            if (!projectState) return;
            updatedState.isOpen = true;
            updatedState.isDismissed = false;
            updatedState.quickstartStateProjectType = projectState.projectType;
            let backendVisibilityKeys = [];
            updatedState.visibility = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, {});
            backendVisibilityKeys = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).map((type)=>(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type));
            const backendState = await (0, (0, parcelRequire("6yhDy")).pollBackend)({
                keys: [
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                    (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                    (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                    (0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING),
                    ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
                    ...backendVisibilityKeys
                ]
            });
            const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
            if (backendStateExists) {
                updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks)
                    ].includes(key) && backendState[key] === true);
                Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).forEach((type)=>{
                    if ((0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type)];
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState && backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED]) updatedState.visibility[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN] ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
                });
                if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP) in backendState) {
                    updatedState.currentTaskGroupParent = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                    updatedState.previousTaskGroupParents = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
                }
                if ((0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING) in backendState) {
                    if (typeof backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] === 'object' && backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
                }
            }
            setState(updatedState);
            if (!(backendStateExists && (0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState)) try {
                const skipApplicationProperty = await (0, (0, parcelRequire("6ypzr")).getOnboardingSkipApplicationProperty)();
                if (skipApplicationProperty.quickstart) dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(true));
            } catch (error) {
                (0, (0, parcelRequire("52Vcw")).fireAPIErrorAnalytics)(error, 'skipOnboarding');
            }
            setState({
                taskList: taskList
            });
            setState({
                isQuickstartLoaded: true
            });
        };
});
parcelRegister("dQPsy", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistItemSeen", ()=>$82a74350685dcd25$export$4eac017dcde0be8f);
    var $8Bc5A;
    var $1ftPQ;
    const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
            const hasSeenTaskId = (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)(taskId);
            const { hasSeenTasks: hasSeenTasks } = getState();
            if (hasSeenTasks.includes(hasSeenTaskId)) return;
            setState({
                hasSeenTasks: [
                    ...hasSeenTasks,
                    hasSeenTaskId
                ]
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)(taskId),
                value: true
            });
        };
});
parcelRegister("boV1S", function(module, exports) {
    $parcel$export(module.exports, "nextAutoExpand", ()=>$35a410a5fb89f79b$export$3d24e97d30cfd09e);
    var $8Bc5A;
    var $984bX;
    var $4ji4w;
    var $cUGWT;
    const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
            const hasNudgeToShowAfterNavigation = (0, (0, parcelRequire("984bX")).localStorageProvider)().get({
                accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK)
            });
            if (hasNudgeToShowAfterNavigation) return;
            const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
            if (!tasks) return;
            const { items: items } = tasks;
            if (items.includes(openTask) && !completedTaskList.includes(openTask)) return;
            const taskIdToExpand = (0, (0, parcelRequire("4ji4w")).getNextNonCompleteTask)(items, completedTaskList, openTask);
            if (taskIdToExpand === null) return;
            dispatch((0, (0, parcelRequire("cUGWT")).nextAutoOpenTask)(taskIdToExpand));
        };
});
parcelRegister("984bX", function(module, exports) {
    $parcel$export(module.exports, "localStorageProvider", ()=>$a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
    $parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", ()=>$a6d0a6873aa6f7aa$export$f2666fae743fa5f);
    var $eNf8a;
    var $jcw0u;
    var $8Bc5A;
    const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
    const $a6d0a6873aa6f7aa$var$DAY = 86400000;
    const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
    const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
        const now = Date.now();
        return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
    };
    let $a6d0a6873aa6f7aa$var$localStorage;
    const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
        if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
        const provider = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
        try {
            provider.removeExpiredKeys();
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'localStorageProviderKeyRemoval',
                    packageName: 'jiraOnboardingQuickstartCore'
                },
                error: e
            });
        }
        const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }));
        const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
        const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }));
        $a6d0a6873aa6f7aa$var$localStorage = {
            provider: provider,
            remove: remove,
            get: get,
            set: set
        };
        return $a6d0a6873aa6f7aa$var$localStorage;
    };
    const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
        $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
            accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
            key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK),
            value: value
        });
    };
});
parcelRegister("4Viq4", function(module, exports) {
    $parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", ()=>$0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
    var $8Bc5A;
    var $984bX;
    var $lHcRB;
    const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
            const nudgeToShowAfterNavigationKeyPair = {
                accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK)
            };
            const shouldShowNudge = (0, (0, parcelRequire("984bX")).localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
            if (shouldShowNudge) {
                dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(true));
                (0, (0, parcelRequire("984bX")).localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
            }
        };
});
parcelRegister("jIoq4", function(module, exports) {
    $parcel$export(module.exports, "nextGetTasks", ()=>$034f263b888956c9$export$15d877e1f3abf489);
    var $ikZFc;
    const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
            const { taskList: taskList } = getState();
            const tasks = (0, (0, parcelRequire("ikZFc")).getAllTasks)({
                ...props,
                taskList: taskList
            });
            setState({
                tasks: tasks
            });
        };
});
parcelRegister("ikZFc", function(module, exports) {
    $parcel$export(module.exports, "getAllTasks", ()=>$cb6c1b1dc7b1b225$export$d1f442602a91e7cc);
    var $aIZdc;
    var $65Ltd;
    var $co1wz;
    var $4R6GH;
    var $ldyPw;
    var $8Bc5A;
    var $1ffS1;
    var $ieqoN;
    var $h3PyW;
    var $3Iaiu;
    var $aHo1U;
    var $5yUqp;
    var $5zzQl;
    var $jJca1;
    const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
        if (variants.includes((0, (0, parcelRequire("aHo1U")).JSW).experiment.jswReverseTrial)) {
            const { title: title, items: items } = taskList[taskGroupParent === (0, (0, parcelRequire("8Bc5A")).ROOT_TASK) ? (0, (0, parcelRequire("8Bc5A")).REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, (0, parcelRequire("8Bc5A")).REVERSE_TRIAL_ROOT_TASK];
            return {
                title: title,
                items: (0, (0, parcelRequire("5zzQl")).getTasks)(variants, taskVariants, items)
            };
        }
        const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, (0, parcelRequire("8Bc5A")).ROOT_TASK];
        return {
            title: title,
            items: (0, (0, parcelRequire("5zzQl")).getTasks)(variants, taskVariants, items)
        };
    };
    const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
        const variants = new Set();
        const isTmpScrumWithSprintPermission = mountedNudges.includes((0, (0, parcelRequire("8Bc5A")).BACKLOG_CREATE_SPRINT_NUDGE_ID));
        const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experience.fedRamp);
        if (premiumTrialOnSignup && (0, (0, parcelRequire("4R6GH")).fg)('jsw_reverse_trials_feature_gate')) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.jswReverseTrial);
        if (isCustomerTemplateProject) variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectProperties.isCreatedFromCustomerTemplate);
        if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.scrumOnboarding);
        if (isCrossProjectBoardToPlanUpsell) variants.add((0, (0, parcelRequire("aHo1U")).JSW).trait.crossProjectBoardToPlanUpsell);
        if (canEditPlans) variants.add((0, (0, parcelRequire("aHo1U")).JSW).permissions.hasPlanEditPermissions);
        if (isEligibleForKanbanTour || routeName !== (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experience.kanbanOnboarding);
        if (canCreateProject === false) variants.add((0, (0, parcelRequire("aHo1U")).JSW).permissions.notCanCreateProject);
        if (projectState?.isNextGen) variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectStyle.teamManaged);
        else variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectStyle.companyManaged);
        if (projectState?.isProjectAdmin) variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) {
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.jiraAdmin);
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.admin);
        }
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) {
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.siteAdmin);
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.admin);
        }
        if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).FREE_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.free);
        else if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.standard);
        else if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.premium);
        if ((0, (0, parcelRequire("1ffS1")).isRoadmapRoute)(routeName)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareRoadmap);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareBacklog);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareBoard);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareList);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.projectSettingsSoftwareAccess);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.issue);
        else if ((0, (0, parcelRequire("co1wz")).ff)('jsw-calendar-view-onboarding_q3bvy') && (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC))) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareCalendar);
        if (isEligibleToUpdateSitename) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.customizeSiteName);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: Array.from(variants.values()),
            taskVariants: (0, (0, parcelRequire("aHo1U")).JSW).taskVariants,
            taskList: (0, (0, parcelRequire("aHo1U")).JSW).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createJwmTasks = (projectState, taskGroupParent, taskList = (0, (0, parcelRequire("5yUqp")).JWM).taskList)=>{
        const variants = [];
        variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.projectTheming);
        if (projectState?.isProjectAdmin) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.jiraAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.siteAdmin);
        if (projectState?.isSampleProject) variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.isSampleProject);
        else variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.isNotSampleProject);
        if (projectState?.isTrelloCrossflow) variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.trelloCrossflow);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("5yUqp")).JWM).taskVariants,
            taskList: taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
        const variants = [];
        variants.push((0, (0, parcelRequire("3Iaiu")).JSM).experiments.projectTheming);
        if (projectState?.isProjectAdmin) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.jiraAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.siteAdmin);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("3Iaiu")).JSM).taskVariants,
            taskList: (0, (0, parcelRequire("3Iaiu")).JSM).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createDevopsTasks = (taskGroupParent)=>{
        const variants = [];
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("h3PyW")).DEVOPS).taskVariants,
            taskList: (0, (0, parcelRequire("h3PyW")).DEVOPS).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList })=>{
        if ((0, (0, parcelRequire("jJca1")).isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks(projectState, taskGroupParent, taskList);
        if ((0, (0, parcelRequire("jJca1")).isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
        if (isDevOpsProject) return $cb6c1b1dc7b1b225$var$createDevopsTasks(taskGroupParent);
        return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
    };
});
parcelRegister("1ffS1", function(module, exports) {
    $parcel$export(module.exports, "isRoadmapRoute", ()=>$ee93e5dd18635f6d$export$d1fa67c1ffb68871);
    var $65Ltd;
    const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
        if (routeName === undefined) return false;
        return routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC);
    };
});
parcelRegister("ieqoN", function(module, exports) {
    $parcel$export(module.exports, "USER_ROLE", ()=>$353950c3dd35bbc6$export$8eeb199b23203523);
    const $353950c3dd35bbc6$export$8eeb199b23203523 = {
        END_USER: 'end-user',
        SITE_ADMIN: 'site-admin',
        JIRA_ADMIN: 'jira-admin'
    };
});
parcelRegister("h3PyW", function(module, exports) {
    $parcel$export(module.exports, "DEVOPS", ()=>$866b9189a2842e55$export$bb75b6064c92010c);
    var $j6cCw;
    const $866b9189a2842e55$export$bb75b6064c92010c = {
        taskList: (0, (0, parcelRequire("j6cCw")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("j6cCw")).TASK_VARIANTS),
        experiment: (0, (0, parcelRequire("j6cCw")).Experiment)
    };
});
parcelRegister("j6cCw", function(module, exports) {
    $parcel$export(module.exports, "Experiment", ()=>$7149b1f98b73c1fd$export$4e0ab25c8a7e4009);
    $parcel$export(module.exports, "TASK_LIST", ()=>$7149b1f98b73c1fd$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$7149b1f98b73c1fd$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $1AiUr;
    const $7149b1f98b73c1fd$export$4e0ab25c8a7e4009 = {};
    const $7149b1f98b73c1fd$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("1AiUr")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_GET_TO_KNOW_JIRA_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_CAPTURE_INTEGRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_CREATE_AUTOMATION_RULES_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_INVITE_TEAMMATES_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_FIND_HELP_TASK)
            ]
        }
    });
    const $7149b1f98b73c1fd$export$36f4d47dfe11b613 = {
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_INVITE_TEAMMATES_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_FIND_HELP_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: true
            }
        }
    };
});
parcelRegister("1AiUr", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6eae5132e152d792$export$defe85febe8b728c);
    var $7VHMR;
    const $6eae5132e152d792$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("3Iaiu", function(module, exports) {
    $parcel$export(module.exports, "JSM", ()=>$56a077523ddf70fb$export$63f289f2da861d35);
    var $58IQc;
    const $56a077523ddf70fb$export$63f289f2da861d35 = {
        taskList: (0, (0, parcelRequire("58IQc")).JSM_TASK_LIST),
        taskVariants: (0, (0, parcelRequire("58IQc")).JSM_TASK_VARIANTS),
        userRole: (0, (0, parcelRequire("58IQc")).UserRole),
        experiments: (0, (0, parcelRequire("58IQc")).Experiments)
    };
});
parcelRegister("58IQc", function(module, exports) {
    $parcel$export(module.exports, "JSM_TASK_LIST", ()=>$3c13225c81ad4b5c$export$6c6c561944d49bcb);
    $parcel$export(module.exports, "Experiments", ()=>$3c13225c81ad4b5c$export$c8d6ffd15214553a);
    $parcel$export(module.exports, "UserRole", ()=>$3c13225c81ad4b5c$export$eb3485a690c2f0b8);
    $parcel$export(module.exports, "JSM_TASK_VARIANTS", ()=>$3c13225c81ad4b5c$export$5b68aef408c932d9);
    var $8Bc5A;
    var $kTSRm;
    const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("kTSRm")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).JSM_REVIEW_YOUR_CHANNELS_TASK),
                (0, (0, parcelRequire("8Bc5A")).JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
                (0, (0, parcelRequire("8Bc5A")).JSM_INVITE_YOUR_TEAM_TASK)
            ]
        }
    });
    const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
        projectTheming: 'projectTheming'
    };
    const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
        projectAdmin: 'projectAdmin',
        jiraAdmin: 'jiraAdmin',
        siteAdmin: 'siteAdmin'
    };
    const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
        [(0, (0, parcelRequire("8Bc5A")).JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
            position: {
                default: 1
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JSM_INVITE_YOUR_TEAM_TASK)]: {
            position: {
                default: 2
            },
            visibility: {
                default: true
            }
        }
    };
});
parcelRegister("kTSRm", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f1f6142c4170f38e$export$defe85febe8b728c);
    var $7VHMR;
    const $f1f6142c4170f38e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("aHo1U", function(module, exports) {
    $parcel$export(module.exports, "JSW", ()=>$563027753d017a60$export$4cfe6e52f2e72a54);
    var $8VfDj;
    const $563027753d017a60$export$4cfe6e52f2e72a54 = {
        taskList: (0, (0, parcelRequire("8VfDj")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("8VfDj")).TASK_VARIANTS),
        experiment: (0, (0, parcelRequire("8VfDj")).Experiment),
        experience: (0, (0, parcelRequire("8VfDj")).Experience),
        projectStyle: (0, (0, parcelRequire("8VfDj")).ProjectStyle),
        projectProperties: (0, (0, parcelRequire("8VfDj")).ProjectProperties),
        userRole: (0, (0, parcelRequire("8VfDj")).UserRole),
        edition: (0, (0, parcelRequire("8VfDj")).Edition),
        route: (0, (0, parcelRequire("8VfDj")).Route),
        permissions: (0, (0, parcelRequire("8VfDj")).Permissions),
        trait: (0, (0, parcelRequire("8VfDj")).Trait)
    };
});
parcelRegister("8VfDj", function(module, exports) {
    $parcel$export(module.exports, "Experiment", ()=>$ea3903bb15047c3b$export$4e0ab25c8a7e4009);
    $parcel$export(module.exports, "Experience", ()=>$ea3903bb15047c3b$export$c90b54e658fc4d7c);
    $parcel$export(module.exports, "ProjectStyle", ()=>$ea3903bb15047c3b$export$1f66f9f05afa05a8);
    $parcel$export(module.exports, "ProjectProperties", ()=>$ea3903bb15047c3b$export$543c19ee8dba9252);
    $parcel$export(module.exports, "UserRole", ()=>$ea3903bb15047c3b$export$eb3485a690c2f0b8);
    $parcel$export(module.exports, "Edition", ()=>$ea3903bb15047c3b$export$6f4a0f769e61929);
    $parcel$export(module.exports, "Route", ()=>$ea3903bb15047c3b$export$e7b0ac011bb776c6);
    $parcel$export(module.exports, "Permissions", ()=>$ea3903bb15047c3b$export$2d41982586bbb6be);
    $parcel$export(module.exports, "Trait", ()=>$ea3903bb15047c3b$export$2d08cfa40d69142e);
    $parcel$export(module.exports, "TASK_LIST", ()=>$ea3903bb15047c3b$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$ea3903bb15047c3b$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $ciLFO;
    const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
        scrumOnboarding: 'experiment.scrumOnboarding',
        customizeSiteName: 'experiment.customizeSiteName',
        jswReverseTrial: 'experiment.jswReverseTrial'
    };
    const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
        kanbanOnboarding: 'experience.kanbanOnboarding',
        fedRamp: 'experience.fedRamp'
    };
    const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
        teamManaged: 'projectStyle.teamManaged',
        companyManaged: 'projectStyle.companyManaged'
    };
    const $ea3903bb15047c3b$export$543c19ee8dba9252 = {
        isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
    };
    const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
        siteAdmin: 'userRole.siteAdmin',
        jiraAdmin: 'userRole.jiraAdmin',
        admin: 'userRole.admin',
        projectAdmin: 'userRole.projectAdmin'
    };
    const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
        free: 'productEdition.free',
        standard: 'productEdition.standard',
        premium: 'productEdition.premium'
    };
    const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
        softwareRoadmap: 'route.softwareRoadmap',
        softwareBacklog: 'route.softwareBacklog',
        softwareBoard: 'route.softwareBoard',
        softwareList: 'route.softwareList',
        projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
        issue: 'route.issue',
        softwareCalendar: 'route.softwareCalendar'
    };
    const $ea3903bb15047c3b$export$2d41982586bbb6be = {
        notCanCreateProject: 'permissions.notCanCreateProject',
        hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
    };
    const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
        crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
    };
    const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
        (0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_PROJECT_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK_SIMPLIFIED),
        (0, (0, parcelRequire("8Bc5A")).TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
        (0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_TASK),
        (0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_VIDEO_TASK),
        (0, (0, parcelRequire("8Bc5A")).CAPTURE_INTEGRATIONS_TASK),
        (0, (0, parcelRequire("8Bc5A")).FIND_HELP_TASK),
        (0, (0, parcelRequire("8Bc5A")).SET_UP_BOARD_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_MOBILE_APP_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
        (0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK),
        (0, (0, parcelRequire("8Bc5A")).MAP_OUT_YOUR_PROJECT_GOALS_TASK),
        (0, (0, parcelRequire("8Bc5A")).IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
        (0, (0, parcelRequire("8Bc5A")).MONITOR_MANAGE_RISK_TASK),
        (0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK),
        (0, (0, parcelRequire("8Bc5A")).CUSTOMIZE_SITE_NAME_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_TO_KNOW_YOUR_TEMPLATE_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK),
        (0, (0, parcelRequire("8Bc5A")).CALENDAR_VIEW_TASK)
    ];
    const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("ciLFO")).messages).rootTitle,
            items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
        },
        reverseTrialRoot: {
            title: (0, (0, parcelRequire("ciLFO")).messages).reverseTrialRootTitle,
            items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).reverseTrialCardTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).premiumPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).premiumPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).standardPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK)
            ]
        }
    });
    const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK)]: {
            position: {
                default: 105
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK)]: {
            position: {
                default: 110
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)]: {
            position: {
                default: 115
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK)]: {
            position: {
                default: 120
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK)]: {
            position: {
                default: 125
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
    const $ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
        [(0, (0, parcelRequire("8Bc5A")).GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
    const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
        ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
        ...$ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
        [(0, (0, parcelRequire("8Bc5A")).CREATE_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CUSTOMIZE_SITE_NAME_TASK)]: {
            position: {
                default: 50
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CALENDAR_VIEW_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        value: true,
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                        ]
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK)]: {
            position: {
                default: 150
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
            position: {
                default: 150
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
            position: {
                default: 151
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MONITOR_MANAGE_RISK_TASK)]: {
            position: {
                default: 152
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SET_UP_BOARD_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK_SIMPLIFIED)]: {
            position: {
                default: 300
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK)]: {
            position: {
                default: 310
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK)]: {
            position: {
                default: 320
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
            position: {
                default: 350
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_VIDEO_TASK)]: {
            position: {
                default: 400,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: 600
                    }
                ]
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CAPTURE_INTEGRATIONS_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_MOBILE_APP_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).FIND_HELP_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
            position: {
                default: 800
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        }
    };
});
parcelRegister("ciLFO", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$609e253829546460$export$defe85febe8b728c);
    var $7VHMR;
    const $609e253829546460$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
            "defaultMessage": "Quickstart"
        },
        premiumPlanTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
            "defaultMessage": "Included in your Premium plan"
        },
        standardPlanTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
            "defaultMessage": "Your Standard plan"
        },
        reverseTrialRootTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
            "defaultMessage": "Your 30-day Premium trial"
        },
        reverseTrialCardTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
            "defaultMessage": "Included in your Premium trial"
        }
    });
});
parcelRegister("5yUqp", function(module, exports) {
    $parcel$export(module.exports, "JWM", ()=>$80382801c7786de6$export$3ff26c80cb588e12);
    var $82B5j;
    var $8jC8d;
    var $5PFhq;
    const $80382801c7786de6$export$3ff26c80cb588e12 = {
        taskList: (0, (0, parcelRequire("82B5j")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("82B5j")).TASK_VARIANTS),
        userRole: (0, (0, parcelRequire("5PFhq")).UserRole),
        experiments: (0, (0, parcelRequire("8jC8d")).Experiments)
    };
});
parcelRegister("82B5j", function(module, exports) {
    $parcel$export(module.exports, "TASK_LIST", ()=>$3b1179694682c8c8$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$3b1179694682c8c8$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $8jC8d;
    var $aQMWP;
    var $5PFhq;
    const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("aQMWP")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
                (0, (0, parcelRequire("8Bc5A")).JWM_SUMMARY_AND_REPORTS_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_SAMPLE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_PROJECT_SUMMARY_TASK),
                (0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_CALENDAR_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TIMELINE_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_BUILD_FORM_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_BACKGROUND_COLOR_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_SHARE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_YOUR_OWN_PROJECT_TASK)
            ]
        }
    });
    const $3b1179694682c8c8$export$db06b8e338ba9c65 = {
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_LIST)]: {
            position: {
                default: 100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_CALENDAR)]: {
            position: {
                default: 200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_PAGES)]: {
            position: {
                default: 300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_LIST)]: {
            position: {
                default: 400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_CALENDAR)]: {
            position: {
                default: 500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_TIMELINE)]: {
            position: {
                default: 600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_SUMMARY)]: {
            position: {
                default: 700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_LIST)]: {
            position: {
                default: 800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_TIMELINE)]: {
            position: {
                default: 900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_PAGES)]: {
            position: {
                default: 1000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_7_LIST)]: {
            position: {
                default: 1100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_7_CALENDAR)]: {
            position: {
                default: 1200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_BOARD)]: {
            position: {
                default: 1300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_FORMS)]: {
            position: {
                default: 1400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_SUMMARY)]: {
            position: {
                default: 1500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_1_LIST)]: {
            position: {
                default: 1600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_6_PAGES)]: {
            position: {
                default: 1700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_LIST)]: {
            position: {
                default: 1800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_TIMELINE)]: {
            position: {
                default: 1900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_PAGES)]: {
            position: {
                default: 2000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_LIST)]: {
            position: {
                default: 2100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_BOARD)]: {
            position: {
                default: 2200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_INVITES)]: {
            position: {
                default: 2300
            }
        }
    };
    const $3b1179694682c8c8$export$bda7075f98246874 = {
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_LIST)]: {
            position: {
                default: 100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_CALENDAR)]: {
            position: {
                default: 200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_TIMELINE)]: {
            position: {
                default: 300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_2_CALENDAR)]: {
            position: {
                default: 400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_2_PAGES)]: {
            position: {
                default: 500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_3_PAGES)]: {
            position: {
                default: 600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_3_TIMELINE)]: {
            position: {
                default: 700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_LIST)]: {
            position: {
                default: 800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_SUMMARY)]: {
            position: {
                default: 900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_PAGES)]: {
            position: {
                default: 1000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_5_TIMELINE)]: {
            position: {
                default: 1100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_5_SUMMARY)]: {
            position: {
                default: 1200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_6_FORMS)]: {
            position: {
                default: 1300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_LIST)]: {
            position: {
                default: 1400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_CALENDAR)]: {
            position: {
                default: 1500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_TIMELINE)]: {
            position: {
                default: 1600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_SUMMARY)]: {
            position: {
                default: 1700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_LIST)]: {
            position: {
                default: 1800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_BOARD)]: {
            position: {
                default: 1900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_PROJECT)]: {
            position: {
                default: 2000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_INVITES)]: {
            position: {
                default: 2100
            }
        }
    };
    const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
        ...$3b1179694682c8c8$export$db06b8e338ba9c65,
        ...$3b1179694682c8c8$export$bda7075f98246874,
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
            position: {
                default: 15
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
            position: {
                default: 40
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_PROJECT_SUMMARY_TASK)]: {
            position: {
                default: 50
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CALENDAR_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TIMELINE_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_BUILD_FORM_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
            position: {
                default: 425
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_SUMMARY_AND_REPORTS_TASK)]: {
            position: {
                default: 450
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_BACKGROUND_COLOR_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).jiraAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).projectAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_SHARE_PROJECT_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
            position: {
                default: 650
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
            position: {
                default: 800
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).jiraAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).projectAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
});
parcelRegister("8jC8d", function(module, exports) {
    $parcel$export(module.exports, "Experiments", ()=>$6cd173da51fb2ca8$export$c8d6ffd15214553a);
    const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
        projectTheming: 'projectTheming',
        isSampleProject: 'isSampleProject',
        isNotSampleProject: 'isNotSampleProject',
        trelloCrossflow: 'trelloCrossflow'
    };
});
parcelRegister("aQMWP", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$40755a70921f89dd$export$defe85febe8b728c);
    var $7VHMR;
    const $40755a70921f89dd$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("5PFhq", function(module, exports) {
    $parcel$export(module.exports, "UserRole", ()=>$637dacd99a3a1727$export$eb3485a690c2f0b8);
    const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
        projectAdmin: 'projectAdmin',
        jiraAdmin: 'jiraAdmin',
        siteAdmin: 'siteAdmin'
    };
});
parcelRegister("5zzQl", function(module, exports) {
    $parcel$export(module.exports, "getTasks", ()=>$f17c108f7b3045ad$export$20b82b4a32771893);
    var $fNtu3;
    const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, (0, parcelRequire("fNtu3")).getConditional)(visibility, variants) : true;
    const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, (0, parcelRequire("fNtu3")).getConditional)(position, variants);
    const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));
});
parcelRegister("fNtu3", function(module, exports) {
    $parcel$export(module.exports, "getConditional", ()=>$8978a3b25f57d9ac$export$fe3161cde0106bba);
    const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
        if (conditions === undefined) return defaultValue;
        const variantsIncludesCondition = (c)=>variants.includes(c);
        const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
        return conditionObj ? conditionObj.value : defaultValue;
    };
});
parcelRegister("jJca1", function(module, exports) {
    $parcel$export(module.exports, "isJwmProject", ()=>$6249819f9bc2846f$export$ea2e5a5c1a1a6748);
    $parcel$export(module.exports, "isJsmProject", ()=>$6249819f9bc2846f$export$a972ed853ed1d469);
    var $2vSU6;
    const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT);
    const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
});
parcelRegister("75A1x", function(module, exports) {
    $parcel$export(module.exports, "syncVisibilityWithLocal", ()=>$f9427b1514e1931c$export$4aab9a98fc53b894);
    var $3B5jO;
    var $4ji4w;
    const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const visibilityLocal = (0, (0, parcelRequire("4ji4w")).getLocalStorageItem)(`${quickstartType}.visibility`);
            if (visibilityLocal === state.visibility[quickstartType]) return;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: visibilityLocal
                }
            });
        };
});
parcelRegister("cGE52", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$d175a7a443e10f6d$export$d4c72bab9d6cc13a);
    var $8Bc5A;
    const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
        shouldRenderComponent: false,
        completedTaskList: [],
        hasSeenTasks: [],
        isDismissed: true,
        isOpen: false,
        isFocusedOn: false,
        openTask: '',
        projectState: null,
        hasNudgeActive: false,
        isQuickstartLoaded: false,
        isDevOpsProject: false,
        nudgeStep: '',
        mountedNudges: [],
        hasEverSeenRoute: {
            'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
        },
        roadmapIsCreateEnabled: false,
        roadmapIsListEmpty: true,
        previousTaskGroupParents: [],
        currentTaskGroupParent: (0, (0, parcelRequire("8Bc5A")).ROOT_TASK),
        selectedProjectTemplateKeyFromOnboarding: undefined,
        isEligibleToUpdateSitename: false,
        isCrossProjectBoardToPlanUpsell: false,
        canEditPlans: false,
        visibility: {
            [(0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED,
            [(0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED
        }
    };
});
parcelRegister("6tzEU", function(module, exports) {
    $parcel$export(module.exports, "useSidebarData", ()=>$530d739908e5dec3$export$f9257874e114985c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $hecDf;
    var $4041n;
    var $iNzEe;
    var $4fCE7;
    const $530d739908e5dec3$export$f9257874e114985c = ()=>{
        const { project: currentProject } = (0, (0, parcelRequire("hecDf")).useNavigationProject)();
        const { data: data, update: update, refresh: refresh, loading: loading } = (0, (0, parcelRequire("iNzEe")).useNavigationResource)();
        const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, (0, parcelRequire("4041n")).useChangeFavorite)();
        const isRefreshingFavorites = (0, $5uXOq.useRef)(false);
        const hasRefreshedOnce = (0, $5uXOq.useRef)(false);
        const onFavoriteToggle = (0, $5uXOq.useCallback)((project)=>{
            changeFavorite({
                id: String(project.id),
                type: 'projects',
                value: !project.isFavorite
            });
        }, [
            changeFavorite
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($gccSB)))(changedItems) && !Object.values(changedItems).some(({ pending: pending })=>pending)) {
                isRefreshingFavorites.current = true;
                refresh();
            }
        }, [
            changedItems,
            refresh
        ]);
        (0, $5uXOq.useEffect)(()=>{
            isRefreshingFavorites.current = false;
        }, [
            data
        ]);
        let recents;
        let favorites;
        let hasMoreFavorite;
        let overviews;
        let overviewsError;
        let isPremiumUserSeat;
        let showPlansOnboarding;
        let shouldHideOverviews;
        if (data == null || data === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
            if (data === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71) && !hasRefreshedOnce.current) {
                hasRefreshedOnce.current = true;
                refresh();
            }
            recents = [];
            favorites = [];
            hasMoreFavorite = false;
            overviews = [];
            overviewsError = null;
            isPremiumUserSeat = false;
            showPlansOnboarding = false;
            shouldHideOverviews = false;
        } else {
            recents = data.recents;
            favorites = data.favorites;
            hasMoreFavorite = data.hasMoreFavorite;
            overviews = data.overviews;
            overviewsError = data.overviewsError;
            isPremiumUserSeat = data.isPremiumUserSeat;
            showPlansOnboarding = data.showPlansOnboarding;
            shouldHideOverviews = data.shouldHideOverviews;
        }
        if (currentProject != null && !recents.some((project)=>project.id === currentProject.id) && !favorites.some((project)=>project.id === currentProject.id)) {
            recents = (0, (0, parcelRequire("4fCE7")).prependProject)(currentProject, recents);
            const newRecents = recents;
            update(()=>({
                    recents: newRecents,
                    favorites: favorites,
                    hasMoreFavorite: hasMoreFavorite,
                    overviews: overviews,
                    overviewsError: overviewsError,
                    isPremiumUserSeat: isPremiumUserSeat,
                    showPlansOnboarding: showPlansOnboarding,
                    shouldHideOverviews: shouldHideOverviews
                }));
        }
        if (!(0, ($parcel$interopDefault($gccSB)))(changedItems)) {
            recents = recents.map((project)=>(0, (0, parcelRequire("4fCE7")).mapProjectChanges)(project, changedItems));
            favorites = favorites.map((project)=>(0, (0, parcelRequire("4fCE7")).mapProjectChanges)(project, changedItems));
        }
        return {
            currentProject: currentProject,
            recents: recents,
            favorites: favorites,
            hasMoreFavorite: hasMoreFavorite,
            onFavoriteToggle: onFavoriteToggle,
            overviews: overviews,
            overviewsError: overviewsError,
            shouldHideOverviews: shouldHideOverviews,
            loading: loading && !isRefreshingFavorites.current
        };
    };
});
parcelRegister("hecDf", function(module, exports) {
    $parcel$export(module.exports, "useNavigationProject", ()=>$46378552d09cbbed$export$befd5d7ebc77f264);
    var $iNzEe;
    var $l2N2a;
    var $dIdda = parcelRequire("dIdda");
    const $46378552d09cbbed$export$befd5d7ebc77f264 = ()=>{
        const { data: currentProject, loading: currentProjectLoading } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { data: navigationData, loading: navigationDataLoading } = (0, (0, parcelRequire("iNzEe")).useNavigationResource)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, $dIdda.useRouter)();
        if (currentProject != null) return {
            project: currentProject,
            loading: currentProjectLoading
        };
        if (projectKey != null && navigationData != null && navigationData !== (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
            const project = navigationData.favorites.find((proj)=>proj.key === projectKey) ?? navigationData.recents.find((proj)=>proj.key === projectKey) ?? null;
            return {
                project: project,
                loading: navigationDataLoading
            };
        }
        return {
            project: null,
            loading: currentProjectLoading || navigationDataLoading
        };
    };
});
parcelRegister("4041n", function(module, exports) {
    $parcel$export(module.exports, "FavoriteChangeContext", ()=>$e574e5c3227b76f4$export$a5d258b9665ce94b);
    $parcel$export(module.exports, "FavoriteChangeProvider", ()=>$e574e5c3227b76f4$export$b06b5ce59fd5e408);
    $parcel$export(module.exports, "FavoriteChangeConsumer", ()=>$e574e5c3227b76f4$export$f227cdfbb355444a);
    $parcel$export(module.exports, "useChangeFavorite", ()=>$e574e5c3227b76f4$export$cfa169f3278459e8);
    var $kZupY;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $jcw0u;
    var $dXq4S;
    var $8zOmE;
    var $koeKL;
    var $iJZ8l;
    var $j6ttF;
    var $7lK06;
    var $eXQym;
    var $5c9oS;
    var $7SIuT;
    const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
                ...state,
                [item.type]: {
                    ...state[item.type],
                    [item.id]: item
                }
            });
    const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
                ...state,
                items: {
                    ...state.items,
                    [item.type]: {
                        ...state.items[item.type],
                        [item.id]: item
                    }
                }
            });
    const $e574e5c3227b76f4$export$b212ddc707077772 = {
        items: {
            boards: {},
            filters: {},
            issues: {},
            dashboards: {},
            projects: {},
            queues: {},
            plans: {}
        },
        changeFavorite: ()=>new Promise((0, ($parcel$interopDefault($8Rkzz)))),
        changeFavoriteMutation: (0, ($parcel$interopDefault($8Rkzz))),
        emitChangedFavorite: (0, ($parcel$interopDefault($8Rkzz))),
        emitChangedFavoriteMutation: (0, ($parcel$interopDefault($8Rkzz))),
        updateFavoriteState: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $e574e5c3227b76f4$export$a5d258b9665ce94b = (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
    const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
            if (type === (0, (0, parcelRequire("eXQym")).PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
                const ari = (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'project',
                    resourceId: id,
                    cloudId: cloudId
                });
                const projectRecordId = (0, (0, parcelRequire("iJZ8l")).default)({
                    id: ari
                }, 'JiraProject');
                if (projectRecordId) {
                    const projectRecord = store.get(projectRecordId);
                    const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(value, 'isFavourite');
                }
            });
        }, [
            cloudId,
            environment
        ]);
        return {
            commitUpdate: commitUpdate
        };
    };
    const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
        const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
        const [items, setItems] = (0, $5uXOq.useState)({
            boards: {},
            filters: {},
            dashboards: {},
            issues: {},
            projects: {},
            queues: {},
            plans: {}
        });
        const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: true
            }));
        }, []);
        const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
            if (analyticsEvent) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
        }, []);
        const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                value: !item.value,
                pending: false
            }));
            if (onShowFlag) onShowFlag((0, (0, parcelRequire("7SIuT")).errorFlag)());
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: analyticsId,
                    packageName: 'jiraFavouriteChangeProvider',
                    teamName: 'empanada'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onShowFlag
        ]);
        const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
            const performChange = async ()=>{
                onChangeStart(item);
                try {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: item.value
                    });
                    await (0, (0, parcelRequire("5c9oS")).default)(item);
                    const typename = (0, (0, parcelRequire("j6ttF")).favoriteTypeToTypename)(item.type, item.id);
                    if (typename) (0, (0, parcelRequire("7lK06")).publishFavorite)(typename, {
                        type: 'REST',
                        entityId: item.id,
                        isFavourite: item.value
                    });
                    onChangeSuccess(item, analyticsEvent);
                } catch (error) {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: !item.value
                    });
                    onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
                }
            };
            return performChange();
        }, [
            commitUpdate,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const [commitMutation] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("kZupY")).default));
        const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
            const dataId = (0, (0, parcelRequire("iJZ8l")).default)({
                id: payload.id
            }, payload.typename);
            const restItem = (0, (0, parcelRequire("j6ttF")).favoriteMutationToRestPayload)(payload);
            const onUpdate = (store, isOptimistic)=>{
                if (!dataId) return;
                (0, (0, parcelRequire("7lK06")).publishFavorite)(payload.typename, {
                    type: 'MUTATION',
                    store: store,
                    dataId: dataId,
                    entityId: payload.id,
                    isFavourite: payload.value,
                    isOptimistic: isOptimistic
                });
                const record = store.get(dataId);
                if (record) {
                    if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                    if (isOptimistic) {
                        const favoriteRecord = record.getLinkedRecord('favouriteValue');
                        favoriteRecord?.setValue(payload.value, 'isFavourite');
                    }
                }
            };
            onChangeStart(restItem);
            commitMutation({
                variables: {
                    input: {
                        entityId: payload.id,
                        isFavourite: payload.value,
                        beforeEntityId: payload.beforeEntity?.id ?? null
                    }
                },
                optimisticUpdater: (store)=>{
                    onUpdate(store, true);
                },
                updater: (store, response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
                },
                onCompleted: (response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                    else onChangeFail(restItem, 'changeFavoriteMutation');
                },
                onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
            });
        }, [
            commitMutation,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
        }, []);
        const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
            onChangeSuccess(payload, analyticsEvent);
            const typeName = (0, (0, parcelRequire("j6ttF")).favoriteTypeToTypename)(payload.type, payload.id);
            if (typeName) (0, (0, parcelRequire("7lK06")).publishFavorite)(typeName, {
                type: 'REST',
                entityId: payload.id,
                isFavourite: payload.value
            });
        }, [
            onChangeSuccess
        ]);
        const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)((payload, store, analyticsEvent)=>{
            const dataId = (0, (0, parcelRequire("iJZ8l")).default)({
                id: payload.id
            }, payload.typename) ?? '';
            const restItem = (0, (0, parcelRequire("j6ttF")).favoriteMutationToRestPayload)(payload);
            onChangeSuccess(restItem, analyticsEvent);
            (0, (0, parcelRequire("7lK06")).publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: false
            });
        }, [
            onChangeSuccess
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>({
                items: items,
                changeFavorite: changeFavorite,
                changeFavoriteMutation: changeFavoriteMutation,
                emitChangedFavorite: emitChangedFavorite,
                emitChangedFavoriteMutation: emitChangedFavoriteMutation,
                updateFavoriteState: updateFavoriteState
            }), [
            items,
            changeFavorite,
            changeFavoriteMutation,
            emitChangedFavorite,
            emitChangedFavoriteMutation,
            updateFavoriteState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
            value: providerValue
        }, children);
    };
    const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
    const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
        const WithFavoriteChangeConsumer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    favoriteChangeContext: favoriteChangeContext
                }));
        const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
        return WithFavoriteChangeConsumer;
    };
    const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);
});
parcelRegister("kZupY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d64781493fbfe6b0$export$2e2bcd8739ae039);
    const $d64781493fbfe6b0$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraSetIsFavouritePayload",
                        "kind": "LinkedField",
                        "name": "setEntityIsFavourite",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "viewSetFavouriteMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "viewSetFavouriteMutation",
                "selections": v1
            },
            "params": {
                "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
                "metadata": {},
                "name": "viewSetFavouriteMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
    var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;
});
parcelRegister("j6ttF", function(module, exports) {
    $parcel$export(module.exports, "favoriteTypeToTypename", ()=>$b9c3378eb0d73712$export$b98f76d96728a853);
    $parcel$export(module.exports, "favoriteMutationToRestPayload", ()=>$b9c3378eb0d73712$export$717886a1047f1287);
    var $1zWF7;
    var $k24Fu;
    var $7sE1A;
    var $axGKd;
    var $fByX6;
    var $ljMDN;
    function $b9c3378eb0d73712$var$assertUnreachable(_) {
        throw new Error('Unexpected entity type');
    }
    const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
    const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
        switch(type){
            case 'projects':
                return 'JiraProject';
            case 'filters':
                return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
            case 'dashboards':
                return 'JiraDashboard';
            case 'plans':
                return 'JiraPlan';
            case 'boards':
                return 'JiraBoard';
            case 'queues':
                return 'JiraServiceManagementQueue';
            default:
                return undefined;
        }
    };
    const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
        switch(typename){
            case 'JiraProject':
                return (0, (0, parcelRequire("ljMDN")).JiraProjectAri).parse(ari).projectId;
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return (0, (0, parcelRequire("axGKd")).JiraFilterAri).parse(ari).filterId;
            case 'JiraDashboard':
                return (0, (0, parcelRequire("7sE1A")).JiraDashboardAri).parse(ari).dashboardId;
            case 'JiraPlan':
                return (0, (0, parcelRequire("fByX6")).JiraPlanAri).parse(ari).planId;
            case 'JiraBoard':
                return (0, (0, parcelRequire("k24Fu")).JiraSoftwareBoardAri).parse(ari).boardId;
            case 'JiraServiceManagementQueue':
                return (0, (0, parcelRequire("1zWF7")).JiraServicedeskQueueAri).parse(ari).queueId;
            default:
                $b9c3378eb0d73712$var$assertUnreachable(typename);
        }
    };
    const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
        switch(typename){
            case 'JiraProject':
                return 'projects';
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return 'filters';
            case 'JiraDashboard':
                return 'dashboards';
            case 'JiraPlan':
                return 'plans';
            case 'JiraBoard':
                return 'boards';
            case 'JiraServiceManagementQueue':
                return 'queues';
            default:
                $b9c3378eb0d73712$var$assertUnreachable(typename);
        }
    };
    const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
            id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
            value: value,
            beforeEntity: beforeEntity ? {
                id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
                type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
            } : undefined
        });
});
parcelRegister("7lK06", function(module, exports) {
    $parcel$export(module.exports, "publishFavorite", ()=>$703ce7b9c2eadfdd$export$229a24253fb568e1);
    $parcel$export(module.exports, "useSubscribeToFavorite", ()=>$703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);
    var $5uXOq = parcelRequire("5uXOq");
    class $703ce7b9c2eadfdd$var$FavoritePubSub {
        constructor(){
            this.subscribers = {};
            this.subscribe = (typename, subscriber)=>{
                this.subscribers[typename] = [
                    ...this.subscribers[typename] ?? [],
                    subscriber
                ];
                return ()=>{
                    this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
                };
            };
            this.publish = (typename, payload)=>{
                this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
            };
        }
    }
    const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
    const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
    const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
        (0, $5uXOq.useEffect)(()=>{
            const typenames = Array.isArray(typename) ? typename : [
                typename
            ];
            const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
            return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
        }, [
            typename,
            subscriber
        ]);
    };
});
parcelRegister("eXQym", function(module, exports) {
    $parcel$export(module.exports, "BOARDS_ITEM_TYPE", ()=>$6c76a5a290814989$export$aade82542e73ffc8);
    $parcel$export(module.exports, "FILTERS_ITEM_TYPE", ()=>$6c76a5a290814989$export$a448ebfa10cebc74);
    $parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", ()=>$6c76a5a290814989$export$f8099f229527572c);
    $parcel$export(module.exports, "ISSUES_ITEM_TYPE", ()=>$6c76a5a290814989$export$8e58083dcbb878d);
    $parcel$export(module.exports, "PLANS_ITEM_TYPE", ()=>$6c76a5a290814989$export$2fd44a6cb58b66cb);
    $parcel$export(module.exports, "PROJECTS_ITEM_TYPE", ()=>$6c76a5a290814989$export$8e2cd98172988d7e);
    $parcel$export(module.exports, "QUEUES_ITEM_TYPE", ()=>$6c76a5a290814989$export$6b0c8e47d2c7f1d9);
    $parcel$export(module.exports, "VALID_ITEM_TYPES", ()=>$6c76a5a290814989$export$9c8cfad65800ddfb);
    $parcel$export(module.exports, "VALID_ITEM_TYPENAMES", ()=>$6c76a5a290814989$export$2d63a9c2e78633c8);
    const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
    const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
    const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
    const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
    const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
    const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
    const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
    const $6c76a5a290814989$export$9c8cfad65800ddfb = [
        $6c76a5a290814989$export$aade82542e73ffc8,
        $6c76a5a290814989$export$f8099f229527572c,
        $6c76a5a290814989$export$a448ebfa10cebc74,
        $6c76a5a290814989$export$8e58083dcbb878d,
        $6c76a5a290814989$export$2fd44a6cb58b66cb,
        $6c76a5a290814989$export$8e2cd98172988d7e,
        $6c76a5a290814989$export$6b0c8e47d2c7f1d9
    ];
    const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
        'JiraProject',
        'JiraCustomFilter',
        'JiraSystemFilter',
        'JiraDashboard',
        'JiraPlan',
        'JiraBoard',
        'JiraServiceManagementQueue'
    ];
});
parcelRegister("5c9oS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9559749111f2eca$export$2e2bcd8739ae039);
    var $7eYK2;
    var $f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, (0, parcelRequire("7eYK2")).updateFavorite)(request);
});
parcelRegister("7eYK2", function(module, exports) {
    $parcel$export(module.exports, "updateFavorite", ()=>$16085bb5bdb7219b$export$8c2f00130cc945dc);
    var $eusud;
    const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
        if (request.value) return (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/2/favourites', {
            body: JSON.stringify({
                entity: {
                    id: request.id,
                    type: request.type
                },
                beforeEntityPosition: request.beforeEntity || null
            })
        });
        return (0, (0, parcelRequire("eusud")).performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
    };
});
parcelRegister("7SIuT", function(module, exports) {
    $parcel$export(module.exports, "errorFlag", ()=>$7252fdcfc0e15292$export$b9a7f1ebeaa76953);
    var $0YlRJ;
    const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
            type: 'error',
            ...(0, (0, parcelRequire("0YlRJ")).default)
        });
});
parcelRegister("0YlRJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87ad72b3da53041c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
            "defaultMessage": "Something\u2019s gone wrong"
        },
        description: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
            "defaultMessage": "You cannot star items right now due to an error."
        }
    });
});
parcelRegister("4fCE7", function(module, exports) {
    $parcel$export(module.exports, "prependProject", ()=>$5da6154530b9fc4e$export$9e33a1a4f95ad56f);
    $parcel$export(module.exports, "mapProjectChanges", ()=>$5da6154530b9fc4e$export$6cb16ed8ac180dfc);
    const $5da6154530b9fc4e$export$9e33a1a4f95ad56f = (project, projects)=>[
            project,
            ...projects
        ].slice(0, (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd));
    const $5da6154530b9fc4e$export$6cb16ed8ac180dfc = (project, changedItems)=>project.id in changedItems ? {
            ...project,
            isFavorite: changedItems[project.id].value
        } : project;
});
parcelRegister("aueMW", function(module, exports) {
    $parcel$export(module.exports, "CreateProjectCta", ()=>$a1b8ae763ebf57fa$export$f49a4235d24dbad0);
    var $5uXOq = parcelRequire("5uXOq");
    var $4RjZC;
    var $7XluA;
    var $4mO32;
    const $a1b8ae763ebf57fa$var$runtimeProps = {};
    const $a1b8ae763ebf57fa$var$entryPointParams = {};
    const $a1b8ae763ebf57fa$export$f49a4235d24dbad0 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("4RjZC")).createProjectCtaEntryPoint), $a1b8ae763ebf57fa$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira-business-create-project-cta-entrypoint",
            packageName: "@atlassian/jira-business-create-project-cta",
            teamName: "jira-werewolves",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $a1b8ae763ebf57fa$var$runtimeProps,
            errorFallback: "unmount"
        });
    };
});
parcelRegister("4RjZC", function(module, exports) {
    $parcel$export(module.exports, "createProjectCtaEntryPoint", ()=>$877fbe84ca72e3fe$export$7dadecc7d161da03);
    var $eufEc;
    var $fEDBv;
    const $877fbe84ca72e3fe$export$7dadecc7d161da03 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("lEuJq")), {
            moduleId: "0c73c6d1"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("lEuJq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hlxM5")
    ]).then(()=>parcelRequire('3u5Rs'));
});
parcelRegister("iZNik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$17c51fb57bea1a65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $2mVws;
    var $cgL5K;
    var $jPxJ7;
    var $koVbs;
    var $g8I5C;
    var $ajOhG;
    var $Fmgai;
    const $17c51fb57bea1a65$var$FEEDBACK_GROUP_ID = 'jbus-feedback';
    const $17c51fb57bea1a65$var$FeedbackButton = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const openFeedbackModal = (0, (0, parcelRequire("jPxJ7")).useFeedbackCollector)();
        const buttonRef = (0, $5uXOq.useRef)(null);
        const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ajOhG")).FeedbackNudgeAsync), null, children), []);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            openFeedbackModal($17c51fb57bea1a65$var$FEEDBACK_GROUP_ID, (0, ($parcel$interopDefault($8Rkzz))), buttonRef);
        }, [
            openFeedbackModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g8I5C")).QuickstartNudge), {
            renderWrapper: renderNudgeWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: buttonRef,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2mVws"))))), {
                label: "",
                size: "small"
            }),
            appearance: "subtle-link",
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "span",
            size: "UNSAFE_small",
            weight: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("Fmgai")).default).feedback))));
    };
    var $17c51fb57bea1a65$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($17c51fb57bea1a65$var$FeedbackButton);
});
parcelRegister("2mVws", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1b9a41a3ba9d94ab$var$_react = $1b9a41a3ba9d94ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1b9a41a3ba9d94ab$var$_feedback = $1b9a41a3ba9d94ab$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $1b9a41a3ba9d94ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1b9a41a3ba9d94ab$var$EditorFeedbackIcon = (props)=>$1b9a41a3ba9d94ab$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M10.922 14.517 5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654zM6 14.227l2 .728V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009zm11.224-4.78a.5.5 0 1 1-.448-.894l2-1a.5.5 0 1 1 .448.894zm-.448 4a.5.5 0 0 1 .448-.894l2 1a.5.5 0 0 1-.448.894zM17 11.5a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1z"/></svg>`
        }, props, {
            newIcon: $1b9a41a3ba9d94ab$var$_feedback.default
        }));
    $1b9a41a3ba9d94ab$var$EditorFeedbackIcon.displayName = 'EditorFeedbackIcon';
    var $1b9a41a3ba9d94ab$var$_default = module.exports.default = $1b9a41a3ba9d94ab$var$EditorFeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("jPxJ7", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$11c0bec8448c2614$export$4be696be8a3bff13);
    var $5uXOq = parcelRequire("5uXOq");
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $6jY6G;
    var $dAfqg;
    var $itmJb;
    var $9OXo1;
    var $5XRYo;
    var $5Dn32;
    const $11c0bec8448c2614$export$698ff856156a88fe = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("5XRYo")).default).canContactPrompt), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, (0, parcelRequire("5XRYo")).default).canContactPromptLink)));
    });
    const $11c0bec8448c2614$export$4f77effad9540593 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("5XRYo")).default).enrollInResearchPrompt, {
            link: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: "https://www.atlassian.com/research-group",
                target: "_blank",
                rel: "noopener noreferrer"
            }, formatMessage((0, (0, parcelRequire("5XRYo")).default).enrollInResearchLink))
        }));
    });
    const $11c0bec8448c2614$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const { licensedProducts: licensedProducts } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const getFeedbackContext = (0, $5uXOq.useCallback)((feedbackGroupId)=>{
            const baseFeedbackContext = [
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).INLINE_FEEDBACK_ID,
                    value: feedbackGroupId
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_NAME,
                    value: route.name ?? 'unknown'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_GROUP,
                    value: route.group ?? 'unknown'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                    value: isAdmin
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).PROJECT_TYPE,
                    value: project?.projectType || projectType
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).SUPPORTED_PROJECT_TYPES,
                    value: (0, (0, parcelRequire("5Dn32")).licensedProductsToString)(licensedProducts)
                }
            ];
            if (project) baseFeedbackContext.push({
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: project.simplified
            });
            return baseFeedbackContext;
        }, [
            isAdmin,
            licensedProducts,
            project,
            projectType,
            route.group,
            route.name
        ]);
        return (0, $5uXOq.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
            const feedbackContext = getFeedbackContext(feedbackGroupId);
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_PLATFORM),
                feedbackGroupId: feedbackGroupId,
                canBeContactedLabel: (0, ($parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$698ff856156a88fe, null),
                enrolInResearchLabel: (0, ($parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$4f77effad9540593, null),
                feedbackContext: feedbackContext,
                onClose: onClose,
                ...triggerRef != null ? {
                    triggerRef: triggerRef
                } : {}
            });
        }, [
            getFeedbackContext,
            openFeedbackCollector
        ]);
    };
});
parcelRegister("5XRYo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c924dc8de5075ae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6c924dc8de5075ae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        canContactPrompt: {
            "id": "business-feedback-collector.can-contact-prompt",
            "defaultMessage": "Atlassian may contact me about this feedback."
        },
        canContactPromptLink: {
            "id": "business-feedback-collector.can-contact-prompt-link",
            "defaultMessage": "Privacy policy"
        },
        enrollInResearchPrompt: {
            "id": "business-feedback-collector.enroll-in-research-prompt",
            "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
        },
        enrollInResearchLink: {
            "id": "business-feedback-collector.enroll-in-research-link",
            "defaultMessage": "Atlassian Research Group"
        }
    });
});
parcelRegister("5Dn32", function(module, exports) {
    $parcel$export(module.exports, "licensedProductsToString", ()=>$0dd3b476597799f0$export$f57a7f1d32485807);
    const $0dd3b476597799f0$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');
});
parcelRegister("g8I5C", function(module, exports) {
    $parcel$export(module.exports, "QuickstartNudge", ()=>$0174d522ba9dfb06$export$bd61ee610c74db6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6OJ73;
    var $axUP7;
    const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
        const isFullyExpanded = (0, (0, parcelRequire("6OJ73")).useIsFullyExpanded)();
        return isFullyExpanded ? renderWrapper(children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    });
});
parcelRegister("6OJ73", function(module, exports) {
    $parcel$export(module.exports, "useIsFullyExpanded", ()=>$c20291d4f7970c77$export$7212b6b01271f5d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    const $c20291d4f7970c77$var$TIMEOUT = 500;
    const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
        const [ready, setReady] = (0, $5uXOq.useState)(false);
        const { isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            const timeoutId = setTimeout(()=>{
                setReady(!isCollapsed);
            }, $c20291d4f7970c77$var$TIMEOUT);
            return ()=>clearTimeout(timeoutId);
        }, [
            isCollapsed
        ]);
        return ready && !isCollapsed;
    };
});
parcelRegister("gPQRI", function(module, exports) {
    $parcel$export(module.exports, "useLeftSidebarState", ()=>$b19712b3cdd78134$export$610d81e163a897b3);
    $parcel$export(module.exports, "useLeftSidebarController", ()=>$b19712b3cdd78134$export$900f29014a48fb23);
    var $5uXOq = parcelRequire("5uXOq");
    var $iqLcb;
    var $7JoAD = parcelRequire("7JoAD");
    var $5e5zm;
    const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $7JoAD.createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>({
                ...state.content.leftSidebar,
                shouldRender: !state.isChromeless
            })
    });
    const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
        const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
        return leftSidebar;
    };
    const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
        const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, (0, parcelRequire("iqLcb")).usePageLayoutResize)();
        return (0, $5uXOq.useMemo)(()=>({
                collapseLeftSidebar: collapseLeftSidebar,
                expandLeftSidebar: expandLeftSidebar
            }), [
            collapseLeftSidebar,
            expandLeftSidebar
        ]);
    };
});
parcelRegister("iqLcb", function(module, exports) {
    $parcel$export(module.exports, "PageLayout", ()=>$3d7d84f3bc65155e$export$6d1402fb58384e4f);
    $parcel$export(module.exports, "Banner", ()=>$3d7d84f3bc65155e$export$3b4e64e77073e307);
    $parcel$export(module.exports, "TopNavigation", ()=>$3d7d84f3bc65155e$export$8a421bddecb2bf5b);
    $parcel$export(module.exports, "LeftPanel", ()=>$3d7d84f3bc65155e$export$110709f040143804);
    $parcel$export(module.exports, "LeftSidebarWithoutResize", ()=>$3d7d84f3bc65155e$export$43ae342508cf8cc9);
    $parcel$export(module.exports, "LeftSidebar", ()=>$3d7d84f3bc65155e$export$3cabf771c4f2de);
    $parcel$export(module.exports, "Main", ()=>$3d7d84f3bc65155e$export$861edd1ccea2f746);
    $parcel$export(module.exports, "Content", ()=>$3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "RightSidebar", ()=>$3d7d84f3bc65155e$export$84d58c19c21f637f);
    $parcel$export(module.exports, "RightPanel", ()=>$3d7d84f3bc65155e$export$364a989a35814102);
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$3d7d84f3bc65155e$export$94561f6055639ef7);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$3d7d84f3bc65155e$export$10c7104037a7af62);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", ()=>$3d7d84f3bc65155e$export$991ef8098f87814a);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", ()=>$3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", ()=>$3d7d84f3bc65155e$export$e95b388ca8c92019);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", ()=>$3d7d84f3bc65155e$export$2ab8b83eed76656c);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", ()=>$3d7d84f3bc65155e$export$ac017575d43f5da);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", ()=>$3d7d84f3bc65155e$export$d697087c06fd5e25);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $4ZIaA;
    var $22jFS;
    var $c8E4X;
    var $eX4XX;
    var $aKz2G;
    var $aj7M6;
    var $kUAkd;
    var $3WK4F;
    var $4CWca;
    var $9xmqY;
    var $31ERv;
    var $cIcFn;
    var $j3yGs;
    var $4R6GH;
    var $3HwlS;
    var $2MLVq;
    var $jjRN8;
    var $hOWCC;
    var $ZlCus;
    var $1EWMr;
    var $kTus1;
    var $fod7Z;
    function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1EWMr")).Root), {
            UNSAFE_dangerouslyHoistSlotSizes: true,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3WK4F")).default), props);
    }
    function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjRN8")).Banner), {
            UNSAFE_height: props.height,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ZIaA")).default), props);
    }
    function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fod7Z")).TopBar), {
            UNSAFE_height: props.height,
            testId: props.testId,
            UNSAFE_theme: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_theming') ? props.theme : undefined
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("31ERv")).default), props);
    }
    function $3d7d84f3bc65155e$export$110709f040143804(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eX4XX")).default), props);
    }
    function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTus1")).SideNav), {
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aj7M6")).default), props);
    }
    function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTus1")).SideNav), {
            defaultCollapsed: props.collapsedState === 'collapsed',
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKz2G")).default), props);
    }
    function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hOWCC")).Main), {
            isFixed: props.isFixed,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kUAkd")).default), props);
    }
    function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? props.children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8E4X")).default), props);
    }
    function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2MLVq")).Aside), {
            isFixed: props.isFixed,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9xmqY")).default), props);
    }
    function $3d7d84f3bc65155e$export$364a989a35814102(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZlCus")).Panel), {
            xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4CWca")).default), props);
    }
    const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? {} : (0, (0, parcelRequire("cIcFn")).useCustomSkipLink)(id, title, index);
    const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? {} : (0, (0, parcelRequire("j3yGs")).useLeftSidebarFlyoutLock)();
    const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, ($parcel$interopDefault($8Rkzz))),
        collapseLeftSidebar: (0, ($parcel$interopDefault($8Rkzz))),
        leftSidebarState: {
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        },
        setLeftSidebarState: (0, ($parcel$interopDefault($8Rkzz))),
        toggleLeftSidebar: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : (0, (0, parcelRequire("j3yGs")).usePageLayoutResize)();
    const $3d7d84f3bc65155e$var$rightPanelStyles = {
        root: "_bfhk1bhr"
    };
    const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, (0, parcelRequire("22jFS")).BANNER_HEIGHT);
    const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH);
    const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH);
    const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH);
    const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH);
    const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT);
});
parcelRegister("4ZIaA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$046aa419aa6d0212$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    const $046aa419aa6d0212$var$bannerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: (0, (0, parcelRequire("22jFS")).BANNER_HEIGHT),
        gridArea: (0, (0, parcelRequire("22jFS")).BANNER)
    });
    const $046aa419aa6d0212$var$bannerFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'fixed',
        zIndex: 2,
        insetBlockStart: 0,
        insetInlineEnd: (0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH),
        insetInlineStart: (0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)
    });
    const $046aa419aa6d0212$var$Banner = (props)=>{
        const { children: children, height: height = (0, (0, parcelRequire("22jFS")).DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
        const bannerHeight = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_BANNER_HEIGHT), height, shouldPersistHeight);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_BANNER_HEIGHT)]: bannerHeight
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_BANNER_HEIGHT)]: 0
                });
            };
        }, [
            bannerHeight
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $046aa419aa6d0212$var$bannerStyles,
                    isFixed && $046aa419aa6d0212$var$bannerFixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('banner')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_BANNER_HEIGHT),
                value: bannerHeight
            }), children));
    };
    var $046aa419aa6d0212$export$2e2bcd8739ae039 = $046aa419aa6d0212$var$Banner;
});
parcelRegister("8XpIo", function(module, exports) {
    $parcel$export(module.exports, "mergeGridStateIntoStorage", ()=>$45f0612699d6a600$export$f8355a2df0f4a946);
    $parcel$export(module.exports, "getGridStateFromStorage", ()=>$45f0612699d6a600$export$d95e99d8116d17dc);
    $parcel$export(module.exports, "removeFromGridStateInStorage", ()=>$45f0612699d6a600$export$17e3760e0b35f1cd);
    $parcel$export(module.exports, "resolveDimension", ()=>$45f0612699d6a600$export$74732e47915c7839);
    $parcel$export(module.exports, "getLeftPanelWidth", ()=>$45f0612699d6a600$export$b089e01213f07bd);
    $parcel$export(module.exports, "getLeftSidebarPercentage", ()=>$45f0612699d6a600$export$2bca58b6ee823bf7);
    $parcel$export(module.exports, "getPageLayoutSlotSelector", ()=>$45f0612699d6a600$export$e895e3e8b708ae2a);
    $parcel$export(module.exports, "getPageLayoutSlotCSSSelector", ()=>$45f0612699d6a600$export$218ece2c32b7db0e);
    var $22jFS;
    var $1Dapo;
    const $45f0612699d6a600$export$576dabd404a1ed99 = (0, (0, parcelRequire("22jFS")).DIMENSIONS).reduce((acc, currentValue)=>({
            ...acc,
            [currentValue]: 0
        }), {});
    const $45f0612699d6a600$export$f8355a2df0f4a946 = (key, value)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("1Dapo")).default)().getItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY)) || '{}');
        if (value !== null && typeof value === 'object') storageValue[key] = {
            ...storageValue[key],
            ...value
        };
        else storageValue[key] = value;
        (0, (0, parcelRequire("1Dapo")).default)().setItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
    };
    const $45f0612699d6a600$export$d95e99d8116d17dc = (key)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("1Dapo")).default)().getItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY)) || '{}');
        return storageValue[key];
    };
    const $45f0612699d6a600$export$17e3760e0b35f1cd = (key, secondKey)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("1Dapo")).default)().getItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY)) || '{}');
        if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
        else delete storageValue[key];
        (0, (0, parcelRequire("1Dapo")).default)().setItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
    };
    const $45f0612699d6a600$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
        if (shouldPersist) {
            const cachedGridState = $45f0612699d6a600$export$d95e99d8116d17dc('gridState');
            return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
        }
        return dimension;
    };
    const $45f0612699d6a600$export$b089e01213f07bd = ()=>{
        if (typeof window === 'undefined') return 0;
        return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)}`), 10) || 0;
    };
    const $45f0612699d6a600$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
        const total = (currentWidth - (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        if (total < 0) return 0;
        if (total > 1) return 100;
        return Math.floor(total * 100);
    };
    const $45f0612699d6a600$export$e895e3e8b708ae2a = (slotName)=>({
            [(0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
        });
    const $45f0612699d6a600$export$218ece2c32b7db0e = (slotName)=>`[${0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;
});
parcelRegister("1Dapo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8542dfb7c79e1b98$export$2e2bcd8739ae039);
    const $8542dfb7c79e1b98$var$isLocalStorageSupported = ()=>{
        try {
            const testKey = `__test_${Date.now()}__`;
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    };
    const $8542dfb7c79e1b98$var$safeLocalStorage = ()=>{
        if ($8542dfb7c79e1b98$var$isLocalStorageSupported()) return localStorage;
        if (typeof window === 'undefined') return {
            getItem: (_key)=>null,
            setItem: (_key, _value)=>null,
            removeItem: (_key)=>null,
            clear: ()=>null,
            key: (_index)=>null,
            get length () {
                return 0;
            }
        };
        if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
        const storageAPI = {
            getItem: (key)=>{
                if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
                return null;
            },
            setItem: (key, value)=>{
                window.__localStorageFallback[key] = String(value);
            },
            removeItem: (key)=>{
                delete window.__localStorageFallback[key];
            },
            clear: ()=>{
                for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
            },
            get length () {
                if (!window.__localStorageFallback) return 0;
                return Object.keys(window.__localStorageFallback).length;
            }
        };
        window.__localStorageFallback = Object.create(storageAPI);
        return window.__localStorageFallback;
    };
    var $8542dfb7c79e1b98$export$2e2bcd8739ae039 = $8542dfb7c79e1b98$var$safeLocalStorage;
});
parcelRegister("2Pb5D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69aa5d485af555af$export$2e2bcd8739ae039);
    var $8XpIo;
    const $69aa5d485af555af$var$publishGridState = (gridState)=>{
        Object.entries(gridState).forEach(([slotName, value])=>{
            if (!value) {
                document.documentElement.style.removeProperty(`--${slotName}`);
                (0, (0, parcelRequire("8XpIo")).removeFromGridStateInStorage)('gridState', slotName);
                return;
            }
            document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
            (0, (0, parcelRequire("8XpIo")).mergeGridStateIntoStorage)('gridState', {
                [slotName]: value
            });
        });
    };
    var $69aa5d485af555af$export$2e2bcd8739ae039 = $69aa5d485af555af$var$publishGridState;
});
parcelRegister("amcy7", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContext", ()=>$9d139aaa63675775$export$4c5cc3b14c7678a);
    $parcel$export(module.exports, "useSkipLinks", ()=>$9d139aaa63675775$export$c9d9cb2ee9590f87);
    $parcel$export(module.exports, "useSkipLink", ()=>$9d139aaa63675775$export$89d9323301efc7d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $9d139aaa63675775$export$4c5cc3b14c7678a = (0, $5uXOq.createContext)({
        skipLinksData: [],
        registerSkipLink: (0, (0, parcelRequire("eGmKJ")).default),
        unregisterSkipLink: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $9d139aaa63675775$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($9d139aaa63675775$export$4c5cc3b14c7678a);
    const $9d139aaa63675775$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $9d139aaa63675775$export$c9d9cb2ee9590f87();
        (0, $5uXOq.useEffect)(()=>{
            if (id && skipLinkTitle) registerSkipLink({
                id: id,
                skipLinkTitle: skipLinkTitle
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            skipLinkTitle,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("fZqMW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be1b215f3de827c6$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $be1b215f3de827c6$var$focusStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':focus': {
            outline: 'none',
            '> div': {
                boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
                outline: 'none'
            }
        }
    });
    const $be1b215f3de827c6$var$sidebarFocusStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':focus': {
            outline: 'none',
            '> div > div': {
                boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
                outline: 'none'
            }
        }
    });
    const $be1b215f3de827c6$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>children({
                className: isSidebar ? css($be1b215f3de827c6$var$sidebarFocusStyles) : css($be1b215f3de827c6$var$focusStyles)
            }));
    };
    var $be1b215f3de827c6$export$2e2bcd8739ae039 = $be1b215f3de827c6$var$SlotFocusRing;
});
parcelRegister("jUxG6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16bb67776ddc8896$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $h9kUS;
    const $16bb67776ddc8896$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
        let style = `:root{--${variableName}:${value}px;}`;
        if (mobileValue) style += ` ${(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", null, style));
    };
    var $16bb67776ddc8896$export$2e2bcd8739ae039 = $16bb67776ddc8896$var$SlotDimensions;
});
parcelRegister("c8E4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a355cc90b3ba1759$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $22jFS;
    const $a355cc90b3ba1759$var$contentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'relative',
        gridArea: (0, (0, parcelRequire("22jFS")).CONTENT)
    });
    const $a355cc90b3ba1759$var$Content = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $a355cc90b3ba1759$var$contentStyles
        }, children);
    };
    var $a355cc90b3ba1759$export$2e2bcd8739ae039 = $a355cc90b3ba1759$var$Content;
});
parcelRegister("eX4XX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0feeff252d3697c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    const $0feeff252d3697c9$var$leftPanelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gridArea: (0, (0, parcelRequire("22jFS")).LEFT_PANEL)
    });
    const $0feeff252d3697c9$var$leftPanelFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    });
    const $0feeff252d3697c9$var$LeftPanel = (props)=>{
        const { children: children, isFixed: isFixed, width: width = (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const leftPanelWidth = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_LEFT_PANEL_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_LEFT_PANEL_WIDTH)]: leftPanelWidth
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_PANEL_WIDTH)]: 0
                });
            };
        }, [
            leftPanelWidth
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $0feeff252d3697c9$var$leftPanelStyles,
                    isFixed && $0feeff252d3697c9$var$leftPanelFixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('left-panel')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_LEFT_PANEL_WIDTH),
                value: leftPanelWidth
            }), children));
    };
    var $0feeff252d3697c9$export$2e2bcd8739ae039 = $0feeff252d3697c9$var$LeftPanel;
});
parcelRegister("aKz2G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24d471261e665f40$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $71YXv;
    var $oGXFy;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $j3yGs;
    var $amcy7;
    var $b8DIB;
    var $2QObc;
    var $aY3ai;
    var $1hxaZ;
    var $jUxG6;
    const $24d471261e665f40$var$openBackdropStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`,
        opacity: 1
    });
    const $24d471261e665f40$var$hiddenBackdropStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0,
        transition: `opacity ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    });
    const $24d471261e665f40$var$LeftSidebar = (props)=>{
        const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
        const flyoutTimerRef = (0, $5uXOq.useRef)();
        const mouseOverEventRef = (0, $5uXOq.useRef)();
        const leftSideBarRef = (0, $5uXOq.useRef)(null);
        const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("j3yGs")).SidebarResizeContext));
        const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth } = leftSidebarState;
        const isLocked = flyoutLockCount > 0;
        const isLockedRef = (0, $5uXOq.useRef)(isLocked);
        const mouseXRef = (0, $5uXOq.useRef)(0);
        const handlerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            isLockedRef.current = isLocked;
            if (isLocked && !handlerRef.current) {
                handlerRef.current = (event)=>{
                    mouseXRef.current = event.clientX;
                };
                document.addEventListener('mousemove', handlerRef.current);
            }
            if (!isLocked && handlerRef.current) {
                if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                document.removeEventListener('mousemove', handlerRef.current);
                handlerRef.current = null;
            }
            return ()=>{
                if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
            };
        }, [
            isLocked,
            lastLeftSidebarWidth,
            setLeftSidebarState
        ]);
        const _width = Math.max(width || 0, (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        const collapsedStateOverrideOpen = collapsedState === 'expanded';
        let leftSidebarWidthOnMount;
        if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
        else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH);
        else leftSidebarWidthOnMount = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, (0, parcelRequire("8XpIo")).getGridStateFromStorage)('isLeftSidebarCollapsed'));
        (0, $5uXOq.useEffect)(()=>{
            const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, (0, parcelRequire("8XpIo")).getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
            const cachedGridState = (0, (0, parcelRequire("8XpIo")).getGridStateFromStorage)('gridState') || {};
            let leftSidebarWidth = !width && cachedGridState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT], (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
            const lastLeftSidebarWidth = !width && cachedGridState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT], (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
            if (cachedCollapsedState) leftSidebarWidth = (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH);
            setLeftSidebarState({
                isFlyoutOpen: false,
                isResizing: isResizing,
                isLeftSidebarCollapsed: cachedCollapsedState,
                leftSidebarWidth: leftSidebarWidth,
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                flyoutLockCount: 0,
                isFixed: isFixed
            });
        }, []);
        const notFirstRun = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (notFirstRun.current) {
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
                });
                (0, (0, parcelRequire("8XpIo")).mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
            }
            if (!notFirstRun.current) notFirstRun.current = true;
            return ()=>{
                removeMouseOverListener();
            };
        }, [
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            id
        ]);
        const onMouseOver = (event)=>{
            const isMouseOnResizeButton = event.target.matches(`[${(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)}] *`);
            if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
            event.persist();
            flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
            if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
                const leftSidebar = leftSideBarRef.current;
                if (leftSidebar === null || isLockedRef.current) return;
                if (!leftSidebar.contains(event.target)) {
                    flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                    onFlyoutCollapse && onFlyoutCollapse();
                    setLeftSidebarState((current)=>({
                            ...current,
                            isFlyoutOpen: false
                        }));
                    removeMouseOverListener();
                }
            };
            document.addEventListener('mouseover', mouseOverEventRef.current, {
                capture: true,
                passive: true
            });
            flyoutTimerRef.current = setTimeout(()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: true
                    }));
                onFlyoutExpand && onFlyoutExpand();
            }, (0, (0, parcelRequire("22jFS")).FLYOUT_DELAY));
        };
        const removeMouseOverListener = ()=>{
            mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
                capture: true,
                passive: true
            });
        };
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        const onMouseLeave = (event)=>{
            const isMouseOnResizeButton = event.target.matches(`[${(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)}] *`);
            if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
            onFlyoutCollapse && onFlyoutCollapse();
            setTimeout(()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
            }, (0, (0, parcelRequire("22jFS")).FLYOUT_DELAY));
        };
        const mobileMediaQuery = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm');
        const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
            if (!mobileMediaQuery?.matches) return;
            setLeftSidebarState((current)=>{
                if (current.isFlyoutOpen) return current;
                return {
                    ...current,
                    isFlyoutOpen: true
                };
            });
        }, [
            setLeftSidebarState,
            mobileMediaQuery
        ]);
        const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
            if (!mobileMediaQuery?.matches) return;
            setLeftSidebarState((current)=>{
                if (!current.isFlyoutOpen) return current;
                return {
                    ...current,
                    isFlyoutOpen: false
                };
            });
        }, [
            setLeftSidebarState,
            mobileMediaQuery
        ]);
        (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm', (event)=>{
            setLeftSidebarState((current)=>{
                if (event.matches && !current.isLeftSidebarCollapsed) return {
                    ...current,
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: current.leftSidebarWidth,
                    isFlyoutOpen: true
                };
                else if (!event.matches && current.isFlyoutOpen) return {
                    ...current,
                    isResizing: false,
                    isLeftSidebarCollapsed: false,
                    leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)),
                    isFlyoutOpen: false
                };
                return current;
            });
        });
        (0, (0, parcelRequire("71YXv")).default)({
            onClose: closeMobileFlyout,
            isDisabled: !isFlyoutOpen
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $24d471261e665f40$var$hiddenBackdropStyles,
                isFlyoutOpen && $24d471261e665f40$var$openBackdropStyles
            ],
            onClick: closeMobileFlyout
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aY3ai")).default), {
            ref: leftSideBarRef,
            testId: testId,
            onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
            onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
            onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
            id: id,
            isFixed: isFixed
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
            variableName: (0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH),
            value: notFirstRun.current ? leftSidebarWidth : leftSidebarWidthOnMount,
            mobileValue: (0, (0, parcelRequire("22jFS")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2QObc")).default), {
            isFixed: isFixed,
            isFlyoutOpen: isFlyoutOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1hxaZ")).default), {
            isFlyoutOpen: isFlyoutOpen,
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            hasCollapsedState: !notFirstRun.current && collapsedState === 'collapsed',
            testId: testId && `${testId}-resize-children-wrapper`
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b8DIB")).default), {
            testId: testId,
            valueTextLabel: valueTextLabel,
            resizeGrabAreaLabel: resizeGrabAreaLabel,
            resizeButtonLabel: resizeButtonLabel,
            overrides: overrides,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd
        }))));
    };
    var $24d471261e665f40$export$2e2bcd8739ae039 = $24d471261e665f40$var$LeftSidebar;
});
parcelRegister("j3yGs", function(module, exports) {
    $parcel$export(module.exports, "SidebarResizeContext", ()=>$423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$423fcd7a7dc715d5$export$10c7104037a7af62);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$423fcd7a7dc715d5$export$94561f6055639ef7);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $423fcd7a7dc715d5$var$leftSidebarState = {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    };
    const $423fcd7a7dc715d5$export$aa5a712eea4c2ae8 = (0, $5uXOq.createContext)({
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, (0, parcelRequire("eGmKJ")).default),
        collapseLeftSidebar: (0, (0, parcelRequire("eGmKJ")).default),
        leftSidebarState: $423fcd7a7dc715d5$var$leftSidebarState,
        setLeftSidebarState: (0, (0, parcelRequire("eGmKJ")).default),
        toggleLeftSidebar: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $423fcd7a7dc715d5$export$10c7104037a7af62 = ()=>{
        const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
        return context;
    };
    const $423fcd7a7dc715d5$export$94561f6055639ef7 = ()=>{
        const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
        (0, $5uXOq.useEffect)(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount + 1
                }));
            return ()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        flyoutLockCount: current.flyoutLockCount - 1
                    }));
            };
        }, [
            setLeftSidebarState
        ]);
    };
});
parcelRegister("b8DIB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$035100f87b948476$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $7nRxN;
    var $oGXFy;
    var $22jFS;
    var $8XpIo;
    var $j3yGs;
    var $gYx5U;
    var $7nOWs;
    var $3bMab;
    function $035100f87b948476$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $035100f87b948476$var$cssSelector = {
        [(0, (0, parcelRequire("22jFS")).RESIZE_CONTROL_SELECTOR)]: true
    };
    const $035100f87b948476$var$resizeControlStyles = {
        name: "ow3ovp",
        styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
    };
    const $035100f87b948476$var$showResizeButtonStyles = {
        name: "1a6byq5",
        styles: "--ds--resize-button--opacity:1"
    };
    const $035100f87b948476$var$globalResizingStyles = {
        name: "e4avm6",
        styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
    };
    const $035100f87b948476$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
        const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("j3yGs")).SidebarResizeContext));
        const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
        const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH]);
        const offset = (0, $5uXOq.useRef)(0);
        const keyboardEventTimeout = (0, $5uXOq.useRef)();
        const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
        const unbindEvents = (0, $5uXOq.useRef)(null);
        const mobileMediaQuery = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm');
        const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
        (0, $5uXOq.useEffect)(()=>{
            stableSidebarState.current = leftSidebarState;
        }, [
            leftSidebarState
        ]);
        const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
            event?.stopPropagation();
            toggleLeftSidebar();
        }, [
            toggleLeftSidebar
        ]);
        const onMouseDown = (event)=>{
            if (isLeftSidebarCollapsed) return;
            if (event.button !== 0) return;
            if (leftSidebarState.isResizing) return;
            offset.current = event.clientX - leftSidebarState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH] - (0, (0, parcelRequire("8XpIo")).getLeftPanelWidth)();
            unbindEvents.current = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
                {
                    type: 'mousemove',
                    listener: function(event) {
                        onUpdateResize({
                            clientX: event.clientX
                        });
                    }
                },
                {
                    type: 'mouseup',
                    listener: onFinishResizing
                },
                {
                    type: 'mousedown',
                    listener: (()=>{
                        let hasFramePassed = false;
                        requestAnimationFrame(()=>{
                            hasFramePassed = true;
                        });
                        return function listener() {
                            if (hasFramePassed) onFinishResizing();
                        };
                    })()
                },
                {
                    type: 'visibilitychange',
                    listener: onFinishResizing
                },
                {
                    type: 'click',
                    listener: onFinishResizing
                },
                {
                    type: 'keydown',
                    listener: (event)=>{
                        if (event.key === 'Escape') {
                            sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH));
                            document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                            onFinishResizing();
                        }
                    }
                }
            ]);
            document.documentElement.setAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING), 'true');
            const newLeftbarState = {
                ...leftSidebarState,
                isResizing: true
            };
            setLeftSidebarState(newLeftbarState);
            onResizeStart && onResizeStart(newLeftbarState);
        };
        const onResizeOffLeftOfScreen = ()=>{
            onUpdateResize.cancel();
            unbindEvents.current?.();
            unbindEvents.current = null;
            document.documentElement.removeAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING));
            offset.current = 0;
            collapseLeftSidebar(undefined, true);
        };
        const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("7nRxN")).default)(({ clientX: clientX })=>{
                const maxWidth = Math.round(window.innerWidth / 2);
                const leftPanelWidth = (0, (0, parcelRequire("8XpIo")).getLeftPanelWidth)();
                const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
                const hasResizedOffLeftOfScreen = clientX < 0;
                if (hasResizedOffLeftOfScreen) {
                    onResizeOffLeftOfScreen();
                    return;
                }
                const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
                sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH));
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
            }));
        const onFinishResizing = ()=>{
            if (isLeftSidebarCollapsed) return;
            document.documentElement.removeAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING));
            let updatedLeftSidebarState = null;
            if (sidebarWidth.current < (0, (0, parcelRequire("22jFS")).MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
                collapseLeftSidebar(undefined, true);
            } else if (sidebarWidth.current > (0, (0, parcelRequire("22jFS")).MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
                updatedLeftSidebarState = {
                    ...leftSidebarState,
                    isResizing: false,
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)
                };
                setLeftSidebarState(updatedLeftSidebarState);
            } else {
                updatedLeftSidebarState = {
                    ...leftSidebarState,
                    isResizing: false,
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                    lastLeftSidebarWidth: sidebarWidth.current
                };
                setLeftSidebarState(updatedLeftSidebarState);
            }
            unbindEvents.current?.();
            unbindEvents.current = null;
            onUpdateResize.cancel();
            sidebarWidth.current = 0;
            offset.current = 0;
            requestAnimationFrame(()=>{
                setIsGrabAreaFocused(false);
                onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
            });
        };
        const onKeyDown = (event)=>{
            if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
            const { key: key } = event;
            const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
            const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
            const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
            if (isSpaceOrEnter) {
                toggleSideBar(event);
                event.preventDefault();
            }
            if (isLeftOrTopArrow || isRightOrBottomArrow) {
                event.preventDefault();
                onResizeStart && onResizeStart(leftSidebarState);
                const step = 10;
                const stepValue = isLeftOrTopArrow ? -step : step;
                const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
                const maxWidth = Math.round(window.innerWidth / 2) - (0, (0, parcelRequire("8XpIo")).getLeftPanelWidth)();
                const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
                let width = leftSidebarWidth + stepValue;
                if (width <= (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                    width = (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH);
                    document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
                } else if (width > maxWidth) {
                    width = maxWidth;
                    document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
                } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH);
                requestAnimationFrame(()=>{
                    keyboardEventTimeout.current = window.setTimeout(()=>{
                        keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                        document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                        const updatedLeftSidebarState = {
                            ...leftSidebarState,
                            [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: width,
                            lastLeftSidebarWidth: width
                        };
                        setLeftSidebarState(updatedLeftSidebarState);
                        onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                    }, 50);
                });
            }
        };
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            setIsGrabAreaFocused(true);
        }, []);
        const onBlur = (0, $5uXOq.useCallback)(()=>{
            setIsGrabAreaFocused(false);
        }, []);
        const resizeButton = {
            render: (Component, props)=>(0, (0, parcelRequire("f8Sb3")).jsx)(Component, props),
            ...overrides && overrides.ResizeButton
        };
        const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
            const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
            return Math.round(innerWidth / 2) - (0, (0, parcelRequire("8XpIo")).getLeftPanelWidth)();
        }, []);
        const leftSidebarPercentageExpanded = (0, (0, parcelRequire("8XpIo")).getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...$035100f87b948476$var$cssSelector,
            css: [
                $035100f87b948476$var$resizeControlStyles,
                (isGrabAreaFocused || isLeftSidebarCollapsed) && $035100f87b948476$var$showResizeButtonStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bMab")).default), {
            testId: testId && `${testId}-shadow`
        }), !mobileMediaQuery?.matches && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gYx5U")).default), {
            isDisabled: isLeftSidebarCollapsed,
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            label: resizeGrabAreaLabel,
            valueTextLabel: valueTextLabel,
            leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            testId: testId && `${testId}-grab-area`
        }), resizeButton.render((0, (0, parcelRequire("7nOWs")).default), {
            isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
            label: resizeButtonLabel,
            onClick: toggleSideBar,
            testId: testId && `${testId}-resize-button`
        })), leftSidebarState.isResizing ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).Global), {
            styles: $035100f87b948476$var$globalResizingStyles
        }) : null);
    };
    var $035100f87b948476$export$2e2bcd8739ae039 = $035100f87b948476$var$ResizeControl;
});
parcelRegister("gYx5U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$859a4bb5bdb6af39$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $22jFS;
    function $859a4bb5bdb6af39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $859a4bb5bdb6af39$var$varLineColor = '--ds-line';
    const $859a4bb5bdb6af39$var$grabAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: "var(--ds-space-200, 16px)",
        height: '100%',
        padding: 0,
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'ew-resize',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:focus': {
            outline: 0
        },
        '&:enabled:hover, &:enabled:focus, &:enabled:active': {
            [$859a4bb5bdb6af39$var$varLineColor]: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
        }
    });
    const $859a4bb5bdb6af39$var$grabAreaCollapsedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
        padding: 0,
        position: 'absolute',
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'default',
        insetBlockEnd: 0
    });
    const $859a4bb5bdb6af39$var$lineStyles = {
        name: "w4swnc",
        styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
    };
    const $859a4bb5bdb6af39$var$grabAreaLineSelector = {
        [(0, (0, parcelRequire("22jFS")).GRAB_AREA_LINE_SELECTOR)]: true
    };
    const $859a4bb5bdb6af39$var$grabAreaSelector = {
        [(0, (0, parcelRequire("22jFS")).GRAB_AREA_SELECTOR)]: true
    };
    const $859a4bb5bdb6af39$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            ...$859a4bb5bdb6af39$var$grabAreaSelector,
            "aria-label": label,
            "data-testid": testId,
            disabled: isDisabled,
            "aria-hidden": isLeftSidebarCollapsed,
            type: "button",
            role: "slider",
            css: [
                $859a4bb5bdb6af39$var$grabAreaStyles,
                isLeftSidebarCollapsed && $859a4bb5bdb6af39$var$grabAreaCollapsedStyles
            ],
            "aria-orientation": "vertical",
            "aria-valuenow": leftSidebarPercentageExpanded,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            onFocus: onFocus,
            onBlur: onBlur,
            ...rest
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $859a4bb5bdb6af39$var$lineStyles,
            ...$859a4bb5bdb6af39$var$grabAreaLineSelector
        }));
    var $859a4bb5bdb6af39$export$2e2bcd8739ae039 = $859a4bb5bdb6af39$var$GrabArea;
});
parcelRegister("7nOWs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ee2fadf0239ec76$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $hWZau;
    var $lObw7;
    var $h9kUS;
    var $22jFS;
    function $8ee2fadf0239ec76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8ee2fadf0239ec76$var$increaseHitAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'absolute',
        insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
        insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
        insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
        insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
    });
    const $8ee2fadf0239ec76$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            opacity: 1
        }
    });
    const $8ee2fadf0239ec76$var$resizeIconButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 24,
        height: 24,
        padding: "var(--ds-space-0, 0px)",
        position: 'absolute',
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        border: 0,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        boxShadow: `0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}`,
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        cursor: 'pointer',
        insetBlockStart: "var(--ds-space-400, 32px)",
        insetInlineStart: 0,
        opacity: `var(--ds--resize-button--opacity,0)`,
        outline: 0,
        transform: 'translateX(-50%)',
        transition: `
    background-color ${(0, (0, parcelRequire("lObw7")).smallDurationMs)}ms linear,
    color ${(0, (0, parcelRequire("lObw7")).smallDurationMs)}ms linear,
    opacity ${(0, (0, parcelRequire("lObw7")).mediumDurationMs)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}
  `,
        ':hover': {
            backgroundColor: `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            opacity: 1
        },
        ':active, :focus': {
            backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            opacity: 1
        }
    });
    const $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles = {
        name: "1bl2513",
        styles: "transform:rotate(180deg);transform-origin:7px"
    };
    const $8ee2fadf0239ec76$var$preventDefault = (event)=>event.preventDefault();
    const $8ee2fadf0239ec76$var$cssSelector = {
        [(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)]: true
    };
    const $8ee2fadf0239ec76$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            ...$8ee2fadf0239ec76$var$cssSelector,
            "aria-expanded": !isLeftSidebarCollapsed,
            "aria-label": label,
            type: "button",
            css: [
                $8ee2fadf0239ec76$var$resizeIconButtonStyles,
                $8ee2fadf0239ec76$var$mobileStyles,
                !isLeftSidebarCollapsed && $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles
            ],
            "data-testid": testId,
            onMouseDown: $8ee2fadf0239ec76$var$preventDefault,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
            label: "",
            color: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $8ee2fadf0239ec76$var$increaseHitAreaStyles
        }));
    var $8ee2fadf0239ec76$export$2e2bcd8739ae039 = $8ee2fadf0239ec76$var$ResizeButton;
});
parcelRegister("3bMab", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31b1337ced2d81f3$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dwLzP;
    const $31b1337ced2d81f3$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
    const $31b1337ced2d81f3$var$direction = 'to left';
    const $31b1337ced2d81f3$var$transitionDuration = '0.22s';
    const $31b1337ced2d81f3$var$shadowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 3,
        position: 'absolute',
        background: `var(--ds-border, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: -1,
        opacity: 0.5,
        pointerEvents: 'none',
        transitionDuration: $31b1337ced2d81f3$var$transitionDuration,
        transitionProperty: 'left, opacity, width',
        transitionTimingFunction: (0, $eba99f58997c09b3$export$57636bb43b1ccbb0)
    });
    const $31b1337ced2d81f3$var$draggingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 6,
        background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
        insetInlineStart: "var(--ds-space-negative-075, -6px)",
        opacity: 0.8
    });
    const $31b1337ced2d81f3$var$Shadow = ({ testId: testId })=>{
        const isDragging = (0, (0, parcelRequire("dwLzP")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $31b1337ced2d81f3$var$shadowStyles,
                isDragging && $31b1337ced2d81f3$var$draggingStyles
            ]
        });
    };
    var $31b1337ced2d81f3$export$2e2bcd8739ae039 = $31b1337ced2d81f3$var$Shadow;
});
parcelRegister("dwLzP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe6bed85a32a6108$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $22jFS;
    const $fe6bed85a32a6108$var$getIsDragging = ()=>{
        if (typeof document === 'undefined') return false;
        return document.documentElement.getAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING)) === 'true';
    };
    const $fe6bed85a32a6108$var$useIsSidebarDragging = ()=>{
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)($fe6bed85a32a6108$var$getIsDragging);
        (0, $5uXOq.useEffect)(()=>{
            const observer = new MutationObserver(()=>{
                setIsDragging($fe6bed85a32a6108$var$getIsDragging);
            });
            observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING)
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }, []);
        return isDragging;
    };
    var $fe6bed85a32a6108$export$2e2bcd8739ae039 = $fe6bed85a32a6108$var$useIsSidebarDragging;
});
parcelRegister("2QObc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd36b127ab52f290$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dWt6p;
    var $h9kUS;
    var $22jFS;
    var $dwLzP;
    function $fd36b127ab52f290$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fd36b127ab52f290$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $fd36b127ab52f290$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            width: `${(0, (0, parcelRequire("22jFS")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
            position: 'fixed',
            insetBlockEnd: 0,
            insetBlockStart: `calc(${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)})`,
            insetInlineStart: `${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)}`,
            transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
        }
    });
    const $fd36b127ab52f290$var$mobileInnerFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            width: `min(90vw, ${(0, (0, parcelRequire("22jFS")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
            maxWidth: (0, (0, parcelRequire("22jFS")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
        }
    });
    const $fd36b127ab52f290$var$fixedInnerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)}`,
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: `calc(${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)})`,
        insetInlineStart: `${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)}`,
        transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    });
    const $fd36b127ab52f290$var$fixedInnerFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_FLYOUT_WIDTH)
    });
    const $fd36b127ab52f290$var$staticInnerStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $fd36b127ab52f290$var$draggingStyles = {
        name: "jlx54q",
        styles: "cursor:ew-resize;transition:none"
    };
    const $fd36b127ab52f290$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
        const isDragging = (0, (0, parcelRequire("dwLzP")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $fd36b127ab52f290$var$mobileStyles,
                isFlyoutOpen && $fd36b127ab52f290$var$mobileInnerFlyoutStyles,
                !isFixed && $fd36b127ab52f290$var$staticInnerStyles,
                isFixed && $fd36b127ab52f290$var$fixedInnerStyles,
                isFixed && isFlyoutOpen && $fd36b127ab52f290$var$fixedInnerFlyoutStyles,
                isDragging && $fd36b127ab52f290$var$draggingStyles,
                $fd36b127ab52f290$var$prefersReducedMotionStyles
            ]
        }, children);
    };
    var $fd36b127ab52f290$export$2e2bcd8739ae039 = $fd36b127ab52f290$var$LeftSidebarInner;
});
parcelRegister("aY3ai", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$579ca93715ca9047$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dWt6p;
    var $h9kUS;
    var $22jFS;
    var $dwLzP;
    var $8XpIo;
    var $j3yGs;
    var $fZqMW;
    function $579ca93715ca9047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $579ca93715ca9047$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $579ca93715ca9047$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            width: (0, (0, parcelRequire("22jFS")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
            cursor: 'pointer',
            opacity: 1,
            transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
            '&::after': {
                display: 'inline-block',
                maxWidth: (0, (0, parcelRequire("22jFS")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
                content: "''"
            }
        }
    });
    const $579ca93715ca9047$var$mobileFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            cursor: 'revert'
        }
    });
    const $579ca93715ca9047$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH),
        position: 'relative',
        zIndex: 1,
        marginInlineStart: "var(--ds-space-0, 0px)",
        transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
        ':hover': {
            '--ds--resize-button--opacity': 1
        }
    });
    const $579ca93715ca9047$var$draggingStyles = {
        name: "jlx54q",
        styles: "cursor:ew-resize;transition:none"
    };
    const $579ca93715ca9047$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '::after': {
            display: 'inline-block',
            width: `${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)}`,
            content: "''"
        }
    });
    const $579ca93715ca9047$var$flyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_FLYOUT_WIDTH)
    });
    const $579ca93715ca9047$var$flyoutFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH)
    });
    const $579ca93715ca9047$var$selector = (0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('left-sidebar');
    const $579ca93715ca9047$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
        const isDragging = (0, (0, parcelRequire("dwLzP")).default)();
        const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, (0, parcelRequire("j3yGs")).SidebarResizeContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), {
            isSidebar: true
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $579ca93715ca9047$var$mobileStyles,
                    isFlyoutOpen && $579ca93715ca9047$var$mobileFlyoutStyles,
                    $579ca93715ca9047$var$outerStyles,
                    isFixed && $579ca93715ca9047$var$fixedStyles,
                    isFlyoutOpen && $579ca93715ca9047$var$flyoutStyles,
                    isFlyoutOpen && isFixed && $579ca93715ca9047$var$flyoutFixedStyles,
                    isDragging && $579ca93715ca9047$var$draggingStyles,
                    $579ca93715ca9047$var$prefersReducedMotionStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                onMouseOver: onMouseOver,
                onMouseLeave: onMouseLeave,
                onClick: onClick,
                ref: ref,
                ...$579ca93715ca9047$var$selector
            }, children));
    };
    const $579ca93715ca9047$var$LeftSidebarOuter = (0, $5uXOq.forwardRef)($579ca93715ca9047$var$LeftSidebarOuterComponent);
    var $579ca93715ca9047$export$2e2bcd8739ae039 = $579ca93715ca9047$var$LeftSidebarOuter;
});
parcelRegister("1hxaZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2beb7a521c0e059$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dWt6p;
    var $22jFS;
    var $2qAWW;
    function $b2beb7a521c0e059$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2beb7a521c0e059$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0,
        transition: `opacity 0ms linear, visibility 0ms linear`,
        transitionDelay: `${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION) - 100}ms`,
        visibility: 'hidden'
    });
    const $b2beb7a521c0e059$var$resizableChildrenWrapperStyles = {
        name: "xz78rr",
        styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
    };
    const $b2beb7a521c0e059$var$fixedChildrenWrapperStyles = {
        name: "ax3w45",
        styles: "min-width:240px;height:100%"
    };
    const $b2beb7a521c0e059$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
        const isCollapsing = (0, (0, parcelRequire("2qAWW")).default)();
        const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
        const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2beb7a521c0e059$var$resizableChildrenWrapperStyles,
                isHidden && $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles,
                $b2beb7a521c0e059$var$prefersReducedMotionStyles
            ],
            "aria-hidden": isHidden,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b2beb7a521c0e059$var$fixedChildrenWrapperStyles
        }, children));
    };
    var $b2beb7a521c0e059$export$2e2bcd8739ae039 = $b2beb7a521c0e059$var$ResizableChildrenWrapper;
});
parcelRegister("2qAWW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed1c7c9bc9db6ce1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $22jFS;
    const $ed1c7c9bc9db6ce1$var$getIsCollapsing = ()=>{
        if (typeof document === 'undefined') return false;
        return document.documentElement.getAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_COLLAPSING)) === 'true';
    };
    const $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing = ()=>{
        const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($ed1c7c9bc9db6ce1$var$getIsCollapsing);
        (0, $5uXOq.useEffect)(()=>{
            const observer = new MutationObserver(()=>{
                setIsCollapsing($ed1c7c9bc9db6ce1$var$getIsCollapsing);
            });
            observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, (0, parcelRequire("22jFS")).IS_SIDEBAR_COLLAPSING)
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }, []);
        return isCollapsing;
    };
    var $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039 = $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing;
});
parcelRegister("aj7M6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c26851ff0e51eadd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $2QObc;
    var $aY3ai;
    var $jUxG6;
    const $c26851ff0e51eadd$var$LeftSidebarWithoutResize = (props)=>{
        const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
        const leftSidebarWidth = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: 0
                });
            };
        }, [
            leftSidebarWidth
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aY3ai")).default), {
            id: id,
            testId: testId,
            isFixed: isFixed
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
            variableName: (0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH),
            value: leftSidebarWidth
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2QObc")).default), {
            isFixed: isFixed
        }, children));
    };
    var $c26851ff0e51eadd$export$2e2bcd8739ae039 = $c26851ff0e51eadd$var$LeftSidebarWithoutResize;
});
parcelRegister("kUAkd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8aae2c1ff30f289$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dWt6p;
    var $22jFS;
    var $dwLzP;
    var $8XpIo;
    var $j3yGs;
    var $amcy7;
    var $fZqMW;
    function $e8aae2c1ff30f289$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e8aae2c1ff30f289$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $e8aae2c1ff30f289$var$mainStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        flexGrow: 1,
        marginInlineStart: 0,
        transition: `margin-left ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    });
    const $e8aae2c1ff30f289$var$draggingStyles = {
        name: "1wx2bp",
        styles: "transition:none"
    };
    const $e8aae2c1ff30f289$var$flyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginInlineStart: `calc(-1 * var(--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
    });
    const $e8aae2c1ff30f289$var$Main = (props)=>{
        const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        const isDragging = (0, (0, parcelRequire("dwLzP")).default)();
        const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, (0, parcelRequire("j3yGs")).SidebarResizeContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("main", {
                "data-testid": testId,
                css: [
                    $e8aae2c1ff30f289$var$mainStyles,
                    isDragging && $e8aae2c1ff30f289$var$draggingStyles,
                    isFlyoutOpen && !isFixed && $e8aae2c1ff30f289$var$flyoutStyles,
                    $e8aae2c1ff30f289$var$prefersReducedMotionStyles
                ],
                className: className,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('main')
            }, children));
    };
    var $e8aae2c1ff30f289$export$2e2bcd8739ae039 = $e8aae2c1ff30f289$var$Main;
});
parcelRegister("3WK4F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$864a3c4908a9e1b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $h9kUS;
    var $22jFS;
    var $hhjNo;
    var $ln2Pp;
    var $crY4K;
    const $864a3c4908a9e1b7$var$pageLayoutSelector = {
        [(0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
    };
    const $864a3c4908a9e1b7$var$gridTemplateAreasMobile = `
${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).BANNER)}"
  ${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION)}"
  ${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).CONTENT)}"
 `;
    const $864a3c4908a9e1b7$var$gridTemplateAreas = `
${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).BANNER)} ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL)}"
  ${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION)} ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL)}"
${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).CONTENT)} ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL)}"
 `;
    const $864a3c4908a9e1b7$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        height: '100%',
        gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreas,
        gridTemplateColumns: `${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)}`,
        gridTemplateRows: `${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)} ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)} auto`,
        outline: 'none'
    });
    const $864a3c4908a9e1b7$var$gridStylesMobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreasMobile,
            gridTemplateColumns: `${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
        }
    });
    const $864a3c4908a9e1b7$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, (0, parcelRequire("22jFS")).DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ln2Pp")).SkipLinksController), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("crY4K")).SkipLinkWrapper), {
            skipLinksLabel: skipLinksLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...$864a3c4908a9e1b7$var$pageLayoutSelector,
            "data-testid": testId,
            css: [
                $864a3c4908a9e1b7$var$gridStyles,
                $864a3c4908a9e1b7$var$gridStylesMobileStyles
            ],
            tabIndex: -1,
            "data-vc": "page-layout"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hhjNo")).SidebarResizeController), {
            onLeftSidebarCollapse: onLeftSidebarCollapse,
            onLeftSidebarExpand: onLeftSidebarExpand
        }, children))));
    };
    var $864a3c4908a9e1b7$export$2e2bcd8739ae039 = $864a3c4908a9e1b7$var$PageLayout;
});
parcelRegister("hhjNo", function(module, exports) {
    $parcel$export(module.exports, "SidebarResizeController", ()=>$592e749dad0a6cf7$export$850bd1bba41f1448);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $eGmKJ;
    var $dWt6p;
    var $oGXFy;
    var $22jFS;
    var $8XpIo;
    var $j3yGs;
    const $592e749dad0a6cf7$var$handleDataAttributesAndCb = (callback = (0, (0, parcelRequire("eGmKJ")).default), leftSidebarState)=>{
        document.documentElement.removeAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_COLLAPSING));
        callback(leftSidebarState);
    };
    const $592e749dad0a6cf7$var$leftSidebarSelector = (0, (0, parcelRequire("8XpIo")).getPageLayoutSlotCSSSelector)('left-sidebar');
    const $592e749dad0a6cf7$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
        const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        });
        const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen } = leftSidebarState;
        const stableRef = (0, $5uXOq.useRef)({
            onExpand: onExpand,
            onCollapse: onCollapse
        });
        (0, $5uXOq.useEffect)(()=>{
            stableRef.current = {
                onExpand: onExpand,
                onCollapse: onCollapse
            };
        }, [
            onExpand,
            onCollapse
        ]);
        const transition = (0, $5uXOq.useRef)(null);
        const mobileMediaQuery = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm');
        const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
        const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
            if (isOpen) return;
            if (mobileMediaQuery?.matches) {
                const flyoutOpenSidebarState = {
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: leftSidebarWidth,
                    isFlyoutOpen: true,
                    flyoutLockCount: 0,
                    isFixed: isFixed
                };
                setLeftSidebarState(flyoutOpenSidebarState);
                transition.current?.complete();
                $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
                return;
            }
            if (isResizing || !isLeftSidebarCollapsed || transition.current?.action === 'expand') return;
            transition.current?.complete();
            const width = Math.max(lastLeftSidebarWidth, (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH));
            const updatedLeftSidebarState = {
                isLeftSidebarCollapsed: false,
                isFlyoutOpen: false,
                leftSidebarWidth: width,
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isResizing: isResizing,
                flyoutLockCount: flyoutLockCount,
                isFixed: isFixed
            };
            setLeftSidebarState(updatedLeftSidebarState);
            function finish() {
                $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
            }
            const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
            if ((0, (0, parcelRequire("dWt6p")).isReducedMotion)() || !sidebar) {
                finish();
                return;
            }
            const unbindEvent = (0, (0, parcelRequire("cBeZP")).bind)(sidebar, {
                type: 'transitionend',
                listener (event) {
                    if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
                }
            });
            const value = {
                action: 'expand',
                complete: ()=>{
                    value.abort();
                    finish();
                },
                abort: ()=>{
                    unbindEvent();
                    transition.current = null;
                }
            };
            transition.current = value;
        }, [
            isOpen,
            mobileMediaQuery,
            isResizing,
            isLeftSidebarCollapsed,
            lastLeftSidebarWidth,
            flyoutLockCount,
            isFixed,
            leftSidebarWidth
        ]);
        const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
            if (!isOpen) return;
            if (mobileMediaQuery?.matches) {
                const flyoutCloseSidebarState = {
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: lastLeftSidebarWidth,
                    isFlyoutOpen: false,
                    flyoutLockCount: 0,
                    isFixed: isFixed
                };
                setLeftSidebarState(flyoutCloseSidebarState);
                transition.current?.complete();
                $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
                return;
            }
            if (isResizing || isLeftSidebarCollapsed || transition.current?.action === 'collapse') return;
            transition.current?.complete();
            document.documentElement.setAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_COLLAPSING), 'true');
            const updatedLeftSidebarState = {
                isLeftSidebarCollapsed: true,
                isFlyoutOpen: false,
                leftSidebarWidth: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isResizing: isResizing,
                flyoutLockCount: flyoutLockCount,
                isFixed: isFixed
            };
            setLeftSidebarState(updatedLeftSidebarState);
            function finish() {
                $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
            }
            const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
            if (collapseWithoutTransition || (0, (0, parcelRequire("dWt6p")).isReducedMotion)() || !sidebar) {
                finish();
                return;
            }
            const unbindEvent = (0, (0, parcelRequire("cBeZP")).bind)(sidebar, {
                type: 'transitionend',
                listener (event) {
                    if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
                }
            });
            const value = {
                action: 'collapse',
                complete: ()=>{
                    value.abort();
                    finish();
                },
                abort: ()=>{
                    unbindEvent();
                    transition.current = null;
                }
            };
            transition.current = value;
        }, [
            isOpen,
            mobileMediaQuery,
            isResizing,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            flyoutLockCount,
            isFixed,
            lastLeftSidebarWidth
        ]);
        const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
            if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
            else expandLeftSidebar();
        }, [
            isOpen,
            expandLeftSidebar,
            collapseLeftSidebar
        ]);
        (0, $5uXOq.useEffect)(function mount() {
            return function unmount() {
                transition.current?.abort();
            };
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                isLeftSidebarCollapsed: !isOpen,
                expandLeftSidebar: expandLeftSidebar,
                collapseLeftSidebar: collapseLeftSidebar,
                leftSidebarState: leftSidebarState,
                setLeftSidebarState: setLeftSidebarState,
                toggleLeftSidebar: toggleLeftSidebar
            }), [
            isOpen,
            expandLeftSidebar,
            collapseLeftSidebar,
            leftSidebarState,
            toggleLeftSidebar
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j3yGs")).SidebarResizeContext).Provider, {
            value: context
        }, children);
    };
});
parcelRegister("ln2Pp", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksController", ()=>$66b4ac88f2caca0d$export$da7be99d6a868f3d);
    var $5uXOq = parcelRequire("5uXOq");
    var $22jFS;
    var $amcy7;
    const $66b4ac88f2caca0d$var$byDOMOrder = (a, b)=>{
        const elems = Array.from(document.querySelectorAll(`[${(0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_SLOT_SELECTOR)}]`));
        const elemA = document.getElementById(a.id);
        const elemB = document.getElementById(b.id);
        const indexA = a.listIndex ?? elems.indexOf(elemA);
        const indexB = b.listIndex ?? elems.indexOf(elemB);
        if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
    const $66b4ac88f2caca0d$export$da7be99d6a868f3d = ({ children: children })=>{
        const [links, setLinks] = (0, $5uXOq.useState)([]);
        const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($66b4ac88f2caca0d$var$byDOMOrder);
            });
        });
        const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
            setLinks((links)=>links.filter((link)=>link.id !== id));
        });
        const context = {
            registerSkipLink: registerSkipLink.current,
            skipLinksData: links,
            unregisterSkipLink: unregisterSkipLink.current
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("amcy7")).SkipLinksContext).Provider, {
            value: context
        }, children);
    };
});
parcelRegister("crY4K", function(module, exports) {
    $parcel$export(module.exports, "SkipLinkWrapper", ()=>$c39a22bbdce5fcea$export$4241a460557ba901);
    var $f8Sb3;
    var $e4yMr;
    var $dWt6p;
    var $22jFS;
    var $amcy7;
    function $c39a22bbdce5fcea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c39a22bbdce5fcea$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $c39a22bbdce5fcea$var$skipLinkStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: "var(--ds-space-250, 10px)",
        padding: '0.8rem 1rem',
        position: 'fixed',
        zIndex: -1,
        background: "var(--ds-surface-overlay, white)",
        border: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 10px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        insetInlineStart: -999999,
        opacity: 0,
        transform: 'translateY(-50%)',
        transition: `transform 0.3s ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}`,
        '&:focus-within': {
            zIndex: 2147483640,
            insetInlineStart: 0,
            opacity: 1,
            transform: 'translateY(0%)'
        }
    });
    const $c39a22bbdce5fcea$var$skipLinkHeadingStyles = {
        name: "16ceglb",
        styles: "font-weight:600"
    };
    const $c39a22bbdce5fcea$var$skipLinkListStyles = {
        name: "1xay72g",
        styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
    };
    const $c39a22bbdce5fcea$var$skipLinkListItemStyles = {
        name: "19m435s",
        styles: "margin-block-start:0"
    };
    const $c39a22bbdce5fcea$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $c39a22bbdce5fcea$var$assignIndex(num + 1, arr);
    };
    const $c39a22bbdce5fcea$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
        const { skipLinksData: skipLinksData } = (0, (0, parcelRequire("amcy7")).useSkipLinks)();
        if (skipLinksData.length === 0) return null;
        const sortSkipLinks = (arr)=>{
            const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
            if (customLinks.length === 0) return arr;
            const usedIndexes = customLinks.map((a)=>a.listIndex);
            const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
                const listIndex = $c39a22bbdce5fcea$var$assignIndex(idx, usedIndexes);
                usedIndexes.push(listIndex);
                return {
                    ...link,
                    listIndex: listIndex
                };
            });
            return [
                ...customLinks,
                ...regularLinksWithIdx
            ].sort((a, b)=>a.listIndex - b.listIndex);
        };
        const escapeHandler = (event)=>{
            if (event.keyCode === 27) {
                const container = document.querySelector(`[${(0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
                if (container !== null) container.focus();
            }
        };
        const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
        const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
        const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
        const label = skipLinksLabel || (0, (0, parcelRequire("22jFS")).DEFAULT_I18N_PROPS_SKIP_LINKS);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onFocus: attachEscHandler,
            onBlur: removeEscHandler,
            css: [
                $c39a22bbdce5fcea$var$skipLinkStyles,
                $c39a22bbdce5fcea$var$prefersReducedMotionStyles
            ],
            "data-skip-link-wrapper": true
        }, emptyLabelOverride ? null : (0, (0, parcelRequire("f8Sb3")).jsx)("p", {
            css: $c39a22bbdce5fcea$var$skipLinkHeadingStyles
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("ol", {
            css: $c39a22bbdce5fcea$var$skipLinkListStyles
        }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>(0, (0, parcelRequire("f8Sb3")).jsx)($c39a22bbdce5fcea$export$ef95c37428582a65, {
                key: id,
                href: `#${id}`,
                isFocusable: true
            }, skipLinkTitle))));
    };
    const $c39a22bbdce5fcea$var$handleBlur = (event)=>{
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
    };
    const $c39a22bbdce5fcea$var$focusTargetRef = (href)=>(event)=>{
            event.preventDefault();
            const targetRef = document.querySelector(href);
            const key = event.which || event.keycode;
            if (key && key !== 13 && key !== 32) return;
            if (targetRef) {
                targetRef.setAttribute('tabindex', '-1');
                targetRef.addEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
                targetRef.focus();
                document.activeElement && document.activeElement.scrollIntoView({
                    behavior: 'smooth'
                });
                window.scrollTo(0, 0);
            }
            return false;
        };
    const $c39a22bbdce5fcea$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("li", {
            css: $c39a22bbdce5fcea$var$skipLinkListItemStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e4yMr")).default), {
            tabIndex: isFocusable ? 0 : -1,
            href: href,
            onClick: $c39a22bbdce5fcea$var$focusTargetRef(href)
        }, children));
    };
});
parcelRegister("4CWca", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9295d31affd013c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    const $d9295d31affd013c$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gridArea: (0, (0, parcelRequire("22jFS")).RIGHT_PANEL)
    });
    const $d9295d31affd013c$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineEnd: 0
    });
    const $d9295d31affd013c$var$RightPanel = (props)=>{
        const { children: children, isFixed: isFixed, width: width = (0, (0, parcelRequire("22jFS")).DEFAULT_RIGHT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const rightPanelWidth = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_RIGHT_PANEL_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_RIGHT_PANEL_WIDTH)]: rightPanelWidth
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_RIGHT_PANEL_WIDTH)]: 0
                });
            };
        }, [
            rightPanelWidth
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $d9295d31affd013c$var$baseStyles,
                    isFixed && $d9295d31affd013c$var$fixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('right-panel')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_RIGHT_PANEL_WIDTH),
                value: rightPanelWidth
            }), children));
    };
    var $d9295d31affd013c$export$2e2bcd8739ae039 = $d9295d31affd013c$var$RightPanel;
});
parcelRegister("9xmqY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a07a1808f1030823$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    function $a07a1808f1030823$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a07a1808f1030823$var$fixedInnerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: `calc(${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)})`,
        insetInlineEnd: `calc(${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)})`
    });
    const $a07a1808f1030823$var$staticInnerStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $a07a1808f1030823$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH)
    });
    const $a07a1808f1030823$var$fixedOuterStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::after': {
            display: 'inline-block',
            width: (0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH),
            content: "''"
        }
    });
    const $a07a1808f1030823$var$RightSidebar = (props)=>{
        const { children: children, width: width = (0, (0, parcelRequire("22jFS")).DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const rightSidebarWidth = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_RIGHT_SIDEBAR_WIDTH)]: 0
                });
            };
        }, [
            rightSidebarWidth,
            id
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), {
            isSidebar: true
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testid": testId,
                css: [
                    $a07a1808f1030823$var$outerStyles,
                    isFixed && $a07a1808f1030823$var$fixedOuterStyles
                ],
                className: className,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('right-sidebar')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_RIGHT_SIDEBAR_WIDTH),
                value: rightSidebarWidth
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    isFixed && $a07a1808f1030823$var$fixedInnerStyles,
                    !isFixed && $a07a1808f1030823$var$staticInnerStyles
                ]
            }, children)));
    };
    var $a07a1808f1030823$export$2e2bcd8739ae039 = $a07a1808f1030823$var$RightSidebar;
});
parcelRegister("31ERv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bf5fc6d75e2417f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    const $7bf5fc6d75e2417f$var$topNavigationStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: (0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT),
        gridArea: (0, (0, parcelRequire("22jFS")).TOP_NAVIGATION)
    });
    const $7bf5fc6d75e2417f$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'fixed',
        zIndex: 2,
        insetBlockStart: (0, (0, parcelRequire("22jFS")).BANNER_HEIGHT),
        insetInlineEnd: (0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH),
        insetInlineStart: (0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)
    });
    const $7bf5fc6d75e2417f$var$TopNavigation = (props)=>{
        const { children: children, height: height = (0, (0, parcelRequire("22jFS")).DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const topNavigationHeight = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_TOP_NAVIGATION_HEIGHT)]: 0
                });
            };
        }, [
            topNavigationHeight
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $7bf5fc6d75e2417f$var$topNavigationStyles,
                    isFixed && $7bf5fc6d75e2417f$var$fixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('top-navigation')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_TOP_NAVIGATION_HEIGHT),
                value: topNavigationHeight
            }), children));
    };
    var $7bf5fc6d75e2417f$export$2e2bcd8739ae039 = $7bf5fc6d75e2417f$var$TopNavigation;
});
parcelRegister("cIcFn", function(module, exports) {
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$a8132564ed4ca271$export$ee6b12c2613bdf8e);
    var $5uXOq = parcelRequire("5uXOq");
    var $amcy7;
    const $a8132564ed4ca271$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, (0, parcelRequire("amcy7")).useSkipLinks)();
        (0, $5uXOq.useEffect)(()=>{
            registerSkipLink({
                id: id,
                skipLinkTitle: skipLinkTitle,
                listIndex: listIndex
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            listIndex,
            skipLinkTitle,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("2MLVq", function(module, exports) {
    $parcel$export(module.exports, "Aside", ()=>$77d6f7adcd563578$export$ac3bdfe4cb17f64e);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $lp9re;
    var $h9kUS;
    var $585q9;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $fVO1C;
    var $l9xvw;
    const $77d6f7adcd563578$var$panelSplitterResizingVar = '--n_asdRsz';
    const $77d6f7adcd563578$var$asideWidthSlotBounds = {
        min: '0px',
        max: '50vw'
    };
    const $77d6f7adcd563578$var$asideWidthResizeBounds = {
        min: '120px',
        max: '50vw'
    };
    const $77d6f7adcd563578$var$styles = {
        root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
        fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
    };
    function $77d6f7adcd563578$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', testId: testId, id: id }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        const ref = (0, $5uXOq.useRef)(null);
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const previousWidthProp = (0, (0, parcelRequire("lp9re")).default)(defaultWidth);
        (0, $5uXOq.useEffect)(()=>{
            setWidth(defaultWidth);
        }, [
            defaultWidth
        ]);
        (0, $5uXOq.useEffect)(()=>{}, [
            defaultWidth,
            previousWidthProp
        ]);
        const asideVariableWidth = `clamp(${$77d6f7adcd563578$var$asideWidthSlotBounds.min}, ${width}px, ${$77d6f7adcd563578$var$asideWidthSlotBounds.max})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("aside", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $77d6f7adcd563578$var$styles.root,
                xcss
            ]),
            style: {
                [(0, (0, parcelRequire("ilnvx")).asideVar)]: asideVariableWidth
            },
            "data-testid": testId,
            ref: ref
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_asideLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("h9kUS")).media).above.md,
            responsiveValue: asideVariableWidth
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVO1C")).PanelSplitterProvider), {
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $77d6f7adcd563578$var$asideWidthResizeBounds,
            resizingCssVar: $77d6f7adcd563578$var$panelSplitterResizingVar,
            position: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isFixed && $77d6f7adcd563578$var$styles.fixedContentArea
            ])
        }, children)));
    }
});
parcelRegister("585q9", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContext", ()=>$ac664e290f9d7ee4$export$4c5cc3b14c7678a);
    $parcel$export(module.exports, "useSkipLink", ()=>$ac664e290f9d7ee4$export$89d9323301efc7d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $ac664e290f9d7ee4$export$4c5cc3b14c7678a = (0, $5uXOq.createContext)({
        registerSkipLink: (0, (0, parcelRequire("eGmKJ")).default),
        unregisterSkipLink: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $ac664e290f9d7ee4$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($ac664e290f9d7ee4$export$4c5cc3b14c7678a);
    const $ac664e290f9d7ee4$export$89d9323301efc7d6 = (id, label, listIndex)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $ac664e290f9d7ee4$export$c9d9cb2ee9590f87();
        (0, $5uXOq.useEffect)(()=>{
            registerSkipLink({
                id: id,
                label: label,
                listIndex: listIndex
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            label,
            listIndex,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("ilnvx", function(module, exports) {
    $parcel$export(module.exports, "sideNavVar", ()=>$7e0cfbaebce245b0$export$951bf5156e86d974);
    $parcel$export(module.exports, "asideVar", ()=>$7e0cfbaebce245b0$export$594e6a30db7c057e);
    $parcel$export(module.exports, "panelVar", ()=>$7e0cfbaebce245b0$export$db0c2e1d744fb281);
    $parcel$export(module.exports, "bannerMountedVar", ()=>$7e0cfbaebce245b0$export$515a0b1baafe906c);
    $parcel$export(module.exports, "topBarMountedVar", ()=>$7e0cfbaebce245b0$export$a96e934b2a1eeee);
    $parcel$export(module.exports, "UNSAFE_topBarVar", ()=>$7e0cfbaebce245b0$export$f4afb213f937404c);
    $parcel$export(module.exports, "UNSAFE_bannerVar", ()=>$7e0cfbaebce245b0$export$26354f9814213292);
    $parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", ()=>$7e0cfbaebce245b0$export$6bfc931a04ec5741);
    $parcel$export(module.exports, "UNSAFE_asideLayoutVar", ()=>$7e0cfbaebce245b0$export$bbbace2ff0c7ae1b);
    $parcel$export(module.exports, "UNSAFE_panelLayoutVar", ()=>$7e0cfbaebce245b0$export$753bf7651b25db91);
    $parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", ()=>$7e0cfbaebce245b0$export$6460bd6a2446260);
    $parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", ()=>$7e0cfbaebce245b0$export$3055529fab2b4edf);
    $parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", ()=>$7e0cfbaebce245b0$export$166d8fd766c3eb92);
    const $7e0cfbaebce245b0$export$951bf5156e86d974 = '--n_sNvw';
    const $7e0cfbaebce245b0$export$594e6a30db7c057e = '--n_asDw';
    const $7e0cfbaebce245b0$export$db0c2e1d744fb281 = '--n_pnlW';
    const $7e0cfbaebce245b0$export$515a0b1baafe906c = '--n_bnrM';
    const $7e0cfbaebce245b0$export$a96e934b2a1eeee = '--n_tbrM';
    const $7e0cfbaebce245b0$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
    const $7e0cfbaebce245b0$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
    const $7e0cfbaebce245b0$export$f4afb213f937404c = '--topNavigationHeight';
    const $7e0cfbaebce245b0$export$26354f9814213292 = '--bannerHeight';
    const $7e0cfbaebce245b0$export$6bfc931a04ec5741 = '--leftSidebarWidth';
    const $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
    const $7e0cfbaebce245b0$export$753bf7651b25db91 = '--rightPanelWidth';
    const $7e0cfbaebce245b0$export$6460bd6a2446260 = `calc(var(${$7e0cfbaebce245b0$export$26354f9814213292}, 0px) + var(${$7e0cfbaebce245b0$export$f4afb213f937404c}, 0px))`;
    const $7e0cfbaebce245b0$export$3055529fab2b4edf = `var(${$7e0cfbaebce245b0$export$6bfc931a04ec5741}, 0px)`;
    const $7e0cfbaebce245b0$export$166d8fd766c3eb92 = `calc(var(${$7e0cfbaebce245b0$export$bbbace2ff0c7ae1b}, 0px) + var(${$7e0cfbaebce245b0$export$753bf7651b25db91}, 0px))`;
    const $7e0cfbaebce245b0$export$61156ceb1a99f6a0 = {
        topBar: 4,
        banner: 4,
        topBarBorder: 3,
        sideNav: 2,
        contentBlockBorder: 2,
        contentInlineBorder: 1,
        panelSmallViewports: 1
    };
});
parcelRegister("8oF23", function(module, exports) {
    $parcel$export(module.exports, "DangerouslyHoistSlotSizes", ()=>$1ee0f763875d3fec$export$66e2c1a0115af861);
    var $5uXOq = parcelRequire("5uXOq");
    const $1ee0f763875d3fec$export$66e2c1a0115af861 = (0, $5uXOq.createContext)(false);
});
parcelRegister("2WR37", function(module, exports) {
    $parcel$export(module.exports, "HoistCssVarToLocalGrid", ()=>$cbb560d7ba4917d9$export$cfa3cd08d675e56e);
    $parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", ()=>$cbb560d7ba4917d9$export$9f45a1325e3cdfb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $1EWMr;
    const $cbb560d7ba4917d9$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", null, `#${(0, (0, parcelRequire("1EWMr")).gridRootId)} { ${variableName}: ${value}px }`);
    const $cbb560d7ba4917d9$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
    const $cbb560d7ba4917d9$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
        let style = `:root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(value)} }`;
        if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(responsiveValue)} } }`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", null, style));
    };
});
parcelRegister("1EWMr", function(module, exports) {
    $parcel$export(module.exports, "gridRootId", ()=>$f4db93acd3b1ab5b$export$a6d827031bcb31d1);
    $parcel$export(module.exports, "Root", ()=>$f4db93acd3b1ab5b$export$be92b6f5f03c0fe9);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iuUiD;
    var $df6Ex;
    var $ivVtd;
    var $8oF23;
    var $k3SPh;
    var $jDR0c;
    var $UTmRP;
    const $f4db93acd3b1ab5b$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
    const $f4db93acd3b1ab5b$var$styles = {
        root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
    };
    function $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            var child;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("UTmRP")).SideNavVisibilityProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDR0c")).SideNavToggleButtonProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3SPh")).SideNavFlyoutLockProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("df6Ex")).HomeActionsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes).Provider, {
            value: UNSAFE_dangerouslyHoistSlotSizes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivVtd")).SkipLinksProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuUiD")).SkipLinksContainer), {
            label: skipLinksLabel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f4db93acd3b1ab5b$var$styles.root,
                xcss
            ]),
            id: $f4db93acd3b1ab5b$export$a6d827031bcb31d1,
            "data-testid": testId
        }, children)))))));
    }
});
parcelRegister("iuUiD", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContainer", ()=>$8a6fecf6d9ada26f$export$fce25a0c32fbc1e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cgL5K;
    var $4SKIy;
    var $hgvjm;
    const $8a6fecf6d9ada26f$var$styles = {
        root: "_18s8v47k _1rjcu2gc _18zr12x7 _kqsw1n9t _1pby1mrw _bfhk1bhr _2rkoglpi _16qs1cd0 _1e02qkuk _tzy4idpf _t9ec1i34 _1digjh3g _gtjaze3t _1mygkb7n _66dk1kli",
        skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozgze3t"
    };
    const $8a6fecf6d9ada26f$var$handleBlur = (event)=>{
        if (!(event.target instanceof Element)) return;
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $8a6fecf6d9ada26f$var$handleBlur);
    };
    const $8a6fecf6d9ada26f$var$escapeHandler = (event)=>{
        if (event.key === 'Escape') {
            const activeElement = document.activeElement;
            if (activeElement !== null) activeElement.blur();
        }
    };
    const $8a6fecf6d9ada26f$var$attachEscHandler = ()=>window.addEventListener('keydown', $8a6fecf6d9ada26f$var$escapeHandler, false);
    const $8a6fecf6d9ada26f$var$removeEscHandler = ()=>window.removeEventListener('keydown', $8a6fecf6d9ada26f$var$escapeHandler, false);
    const $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1 = ({ label: label })=>{
        const sortedSkipLinks = (0, (0, parcelRequire("4SKIy")).useSortedSkipLinks)();
        if (sortedSkipLinks.length === 0) return null;
        const emptyLabelOverride = !!label?.match(/^\s+$/);
        return $5uXOq.createElement("div", {
            onFocus: $8a6fecf6d9ada26f$var$attachEscHandler,
            onBlur: $8a6fecf6d9ada26f$var$removeEscHandler,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $8a6fecf6d9ada26f$var$styles.root
            ])
        }, emptyLabelOverride ? null : $5uXOq.createElement((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium"
        }, label), $5uXOq.createElement("ol", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $8a6fecf6d9ada26f$var$styles.skipLinkList
            ])
        }, sortedSkipLinks.map(({ id: id, label: label })=>$5uXOq.createElement((0, (0, parcelRequire("hgvjm")).SkipLink), {
                key: id,
                href: `#${id}`,
                isFocusable: true
            }, label))));
    };
});
parcelRegister("4SKIy", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksDataContext", ()=>$a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
    $parcel$export(module.exports, "useSortedSkipLinks", ()=>$a6322a25f6b08ecb$export$b0b0d4fc1b356759);
    var $5uXOq = parcelRequire("5uXOq");
    const $a6322a25f6b08ecb$export$e9ab38ce6147d3d2 = (0, $5uXOq.createContext)([]);
    const $a6322a25f6b08ecb$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $a6322a25f6b08ecb$var$assignIndex(num + 1, arr);
    };
    const $a6322a25f6b08ecb$var$sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
            const listIndex = $a6322a25f6b08ecb$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const $a6322a25f6b08ecb$export$b0b0d4fc1b356759 = ()=>{
        const skipLinksData = (0, $5uXOq.useContext)($a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
        return (0, $5uXOq.useMemo)(()=>{
            return $a6322a25f6b08ecb$var$sortSkipLinks(skipLinksData);
        }, [
            skipLinksData
        ]);
    };
});
parcelRegister("hgvjm", function(module, exports) {
    $parcel$export(module.exports, "SkipLink", ()=>$ca929d4ef6b95820$export$ef95c37428582a65);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jhmo0;
    const $ca929d4ef6b95820$var$styles = {
        skipLinkListItem: "_1pfhze3t"
    };
    const $ca929d4ef6b95820$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $ca929d4ef6b95820$var$assignIndex(num + 1, arr);
    };
    const $ca929d4ef6b95820$var$handleBlur = (event)=>{
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $ca929d4ef6b95820$var$handleBlur);
    };
    const $ca929d4ef6b95820$var$focusTargetRef = (href)=>(event)=>{
            event.preventDefault();
            const targetRef = document.querySelector(href);
            const key = event.which || event.keycode;
            if (key && key !== 13 && key !== 32) return;
            if (targetRef) {
                targetRef.setAttribute('tabindex', '-1');
                targetRef.addEventListener('blur', $ca929d4ef6b95820$var$handleBlur);
                targetRef.focus();
                document.activeElement && document.activeElement.scrollIntoView({
                    behavior: 'smooth'
                });
                window.scrollTo(0, 0);
            }
            return false;
        };
    const $ca929d4ef6b95820$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
        return $5uXOq.createElement("li", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $ca929d4ef6b95820$var$styles.skipLinkListItem
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("jhmo0")).default), {
            tabIndex: isFocusable ? 0 : -1,
            href: href,
            onClick: $ca929d4ef6b95820$var$focusTargetRef(href)
        }, children));
    };
});
parcelRegister("df6Ex", function(module, exports) {
    $parcel$export(module.exports, "HomeActionsProvider", ()=>$311e667ddca00164$export$8b9089606266983e);
    var $5uXOq = parcelRequire("5uXOq");
    var $c4wuJ;
    const $311e667ddca00164$export$8b9089606266983e = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4wuJ")).HomeActionsElement).Provider, {
            value: element
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4wuJ")).HomeActionsAttachRef).Provider, {
            value: setElement
        }, children));
    };
});
parcelRegister("c4wuJ", function(module, exports) {
    $parcel$export(module.exports, "HomeActionsElement", ()=>$e31dc6e30458fc76$export$4128169e0878a41d);
    $parcel$export(module.exports, "HomeActionsAttachRef", ()=>$e31dc6e30458fc76$export$762fcfeaa67873eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $e31dc6e30458fc76$export$4128169e0878a41d = (0, $5uXOq.createContext)(null);
    const $e31dc6e30458fc76$export$762fcfeaa67873eb = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
});
parcelRegister("ivVtd", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksProvider", ()=>$04aeed0b84d4da87$export$fe514f9f7b03d46f);
    var $5uXOq = parcelRequire("5uXOq");
    var $585q9;
    var $4SKIy;
    const $04aeed0b84d4da87$var$getByDomOrderSortFunction = ()=>{
        const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
        return (a, b)=>{
            const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
            const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
            if (indexA === indexB) {
                if (a.listIndex !== undefined) return -1;
                else return 1;
            }
            return indexA - indexB;
        };
    };
    const $04aeed0b84d4da87$export$fe514f9f7b03d46f = ({ children: children })=>{
        const [links, setLinks] = (0, $5uXOq.useState)([]);
        const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($04aeed0b84d4da87$var$getByDomOrderSortFunction());
            });
        }, []);
        const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
            setLinks((links)=>links.filter((link)=>link.id !== id));
        }, []);
        const contextValue = (0, $5uXOq.useMemo)(()=>{
            const data = {
                registerSkipLink: registerSkipLink,
                unregisterSkipLink: unregisterSkipLink
            };
            return data;
        }, [
            registerSkipLink,
            unregisterSkipLink
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("585q9")).SkipLinksContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4SKIy")).SkipLinksDataContext).Provider, {
            value: links
        }, children));
    };
});
parcelRegister("k3SPh", function(module, exports) {
    $parcel$export(module.exports, "SideNavFlyoutLockProvider", ()=>$4d4c2cd4cedcc93a$export$7003dd76deb92ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $1ma7Z;
    const $4d4c2cd4cedcc93a$export$7003dd76deb92ad = ({ children: children })=>{
        const [flyoutLock, setFlyoutLock] = (0, $5uXOq.useState)(0);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ma7Z")).FlyoutLockCount).Provider, {
            value: flyoutLock
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ma7Z")).SetFlyoutLockCount).Provider, {
            value: setFlyoutLock
        }, children));
    };
});
parcelRegister("1ma7Z", function(module, exports) {
    $parcel$export(module.exports, "FlyoutLockCount", ()=>$b049cb649a0db0a3$export$962eb1e8d553c86f);
    $parcel$export(module.exports, "SetFlyoutLockCount", ()=>$b049cb649a0db0a3$export$52e873d56b3942a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $b049cb649a0db0a3$export$962eb1e8d553c86f = (0, $5uXOq.createContext)(0);
    const $b049cb649a0db0a3$export$52e873d56b3942a3 = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
});
parcelRegister("jDR0c", function(module, exports) {
    $parcel$export(module.exports, "SideNavToggleButtonProvider", ()=>$e430d141e8d30234$export$ceb8e60e9790fc0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZOeM;
    const $e430d141e8d30234$export$ceb8e60e9790fc0f = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZOeM")).SideNavToggleButtonElement).Provider, {
            value: element
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZOeM")).SideNavToggleButtonAttachRef).Provider, {
            value: setElement
        }, children));
    };
});
parcelRegister("eZOeM", function(module, exports) {
    $parcel$export(module.exports, "SideNavToggleButtonElement", ()=>$42ecc156c1fc66f0$export$9c1768094bef896);
    $parcel$export(module.exports, "SideNavToggleButtonAttachRef", ()=>$42ecc156c1fc66f0$export$fb8fa9a80240785e);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $42ecc156c1fc66f0$export$9c1768094bef896 = (0, $5uXOq.createContext)(null);
    const $42ecc156c1fc66f0$export$fb8fa9a80240785e = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
});
parcelRegister("UTmRP", function(module, exports) {
    $parcel$export(module.exports, "SideNavVisibilityProvider", ()=>$2510be1036df6cd8$export$aac8e996360f6ad9);
    var $5uXOq = parcelRequire("5uXOq");
    var $b0CFU;
    const $2510be1036df6cd8$export$aac8e996360f6ad9 = ({ children: children })=>{
        const [visibleOnDesktop, setVisibleOnDesktop] = (0, $5uXOq.useState)(null);
        const [visibleOnMobile, setVisibleOnMobile] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0CFU")).SideNavDesktopVisibility).Provider, {
            value: visibleOnDesktop
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0CFU")).SetSideNavDesktopVisibility).Provider, {
            value: setVisibleOnDesktop
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0CFU")).SideNavMobileVisibility).Provider, {
            value: visibleOnMobile
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0CFU")).SetSideNavMobileVisibility).Provider, {
            value: setVisibleOnMobile
        }, children))));
    };
});
parcelRegister("b0CFU", function(module, exports) {
    $parcel$export(module.exports, "SideNavDesktopVisibility", ()=>$4ad787a6949993a9$export$1771e3b63861d206);
    $parcel$export(module.exports, "SideNavMobileVisibility", ()=>$4ad787a6949993a9$export$c5f483eeea865395);
    $parcel$export(module.exports, "SetSideNavDesktopVisibility", ()=>$4ad787a6949993a9$export$5edca135c5bde4af);
    $parcel$export(module.exports, "SetSideNavMobileVisibility", ()=>$4ad787a6949993a9$export$64be6ca751606276);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $4ad787a6949993a9$export$1771e3b63861d206 = (0, $5uXOq.createContext)(null);
    const $4ad787a6949993a9$export$c5f483eeea865395 = (0, $5uXOq.createContext)(false);
    const $4ad787a6949993a9$export$5edca135c5bde4af = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
    const $4ad787a6949993a9$export$64be6ca751606276 = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
});
parcelRegister("fVO1C", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitterProvider", ()=>$0739b5288fba2b3a$export$f662bfb764348932);
    var $5uXOq = parcelRequire("5uXOq");
    var $9NI3h;
    const $0739b5288fba2b3a$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
        const portalRef = (0, $5uXOq.useRef)(null);
        const context = (0, $5uXOq.useMemo)(()=>({
                panelWidth: panelWidth,
                onCompleteResize: onCompleteResize,
                resizeBounds: resizeBounds,
                portalRef: portalRef,
                resizingCssVar: resizingCssVar,
                position: position,
                panelRef: panelRef,
                isEnabled: isEnabled
            }), [
            isEnabled,
            onCompleteResize,
            panelRef,
            panelWidth,
            position,
            resizeBounds,
            resizingCssVar
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NI3h")).PanelSplitterContext).Provider, {
            value: context
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: portalRef
        }));
    };
});
parcelRegister("9NI3h", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitterContext", ()=>$ec571489384d3ca6$export$7a4054f2c546f2cd);
    var $5uXOq = parcelRequire("5uXOq");
    const $ec571489384d3ca6$export$7a4054f2c546f2cd = (0, $5uXOq.createContext)(null);
});
parcelRegister("l9xvw", function(module, exports) {
    $parcel$export(module.exports, "usePrefixedUID", ()=>$93943d3b0eb37778$export$86433d4fd18455f4);
    var $9KnKW;
    const $93943d3b0eb37778$export$86433d4fd18455f4 = (prefix = 'element')=>`${prefix}-${(0, (0, parcelRequire("9KnKW")).useId)()}`;
});
parcelRegister("jjRN8", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$365358079a8d32db$export$3b4e64e77073e307);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $585q9;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $l9xvw;
    const $365358079a8d32db$var$styles = {
        root: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat _1reo15vq _18m915vq"
    };
    function $365358079a8d32db$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, label: label = 'Banner', testId: testId, id: id }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: CID,
            role: "banner",
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $365358079a8d32db$var$styles.root,
                xcss
            ]),
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).HoistCssVarToLocalGrid), {
            variableName: (0, (0, parcelRequire("ilnvx")).bannerMountedVar),
            value: UNSAFE_height
        }), dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_bannerVar),
            value: UNSAFE_height
        }), children);
    }
});
parcelRegister("hOWCC", function(module, exports) {
    $parcel$export(module.exports, "Main", ()=>$325f1d6156df91d8$export$861edd1ccea2f746);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $585q9;
    var $l9xvw;
    var $2GcIE;
    const $325f1d6156df91d8$var$conditionalCurvedBorderRadiusCSSSelector = 'html:not(:has([data-private-do-not-show-curved-border-on-main="true"])):has([data-private-request-curved-border-on-main="true"]) &';
    const $325f1d6156df91d8$var$conditionalBorderInlineStartCSSSelector = 'html:has([data-private-show-inline-start-border-on-main="true"]) &';
    const $325f1d6156df91d8$var$mainElementStyles = {
        root: "_nd5l1gzg _19121cl4 _qwfh1wug",
        mainCurvedCorner: "_z0yti2wt",
        fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
    };
    const $325f1d6156df91d8$var$contentBorderStyles = {
        largeViewportTop: "_vchhusvi _h7aloyrj _mqm2zgxb _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbycs5v _1e0cglyw _jnn7i2wt _dm2518uv",
        largeViewportLeft: "_vchhusvi _izbqoyrj _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbykb7n _1e0cglyw _jnn7i2wt _ml4lzgxb _dm2518uv"
    };
    function $325f1d6156df91d8$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, label: label = 'Main Content', testId: testId, id: id }) {
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $325f1d6156df91d8$var$mainElementStyles.root,
                $325f1d6156df91d8$var$mainElementStyles.mainCurvedCorner,
                isFixed && $325f1d6156df91d8$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2GcIE")).MainStickyContext).Provider, {
            value: Boolean(isFixed)
        }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $325f1d6156df91d8$var$contentBorderStyles.largeViewportLeft
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $325f1d6156df91d8$var$contentBorderStyles.largeViewportTop
            ])
        }));
    }
});
parcelRegister("2GcIE", function(module, exports) {
    $parcel$export(module.exports, "MainStickyContext", ()=>$7ccaf10616775f74$export$3b369e2c6c1ec840);
    var $5uXOq = parcelRequire("5uXOq");
    const $7ccaf10616775f74$export$3b369e2c6c1ec840 = (0, $5uXOq.createContext)(false);
});
parcelRegister("ZlCus", function(module, exports) {
    $parcel$export(module.exports, "Panel", ()=>$05534568732462ab$export$2ddb90ad54e5f587);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $h9kUS;
    var $585q9;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $fVO1C;
    var $l9xvw;
    const $05534568732462ab$var$panelSplitterResizingVar = '--n_pnlRsz';
    const $05534568732462ab$var$panelWidthSlotBounds = {
        min: '0px',
        max: '50vw'
    };
    const $05534568732462ab$var$panelWidthResizeBounds = {
        min: '120px',
        max: '50vw'
    };
    const $05534568732462ab$var$styles = {
        root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
        scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
        hidden: "_1e0cglyw"
    };
    function $05534568732462ab$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', testId: testId, id: id, xcss: xcss }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        const ref = (0, $5uXOq.useRef)(null);
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
        (0, $5uXOq.useEffect)(()=>{
            if (defaultWidthRef.current === defaultWidth) return;
            defaultWidthRef.current = defaultWidth;
            setWidth(defaultWidth);
        }, [
            defaultWidth
        ]);
        const panelVariableWidth = `clamp(${$05534568732462ab$var$panelWidthSlotBounds.min}, ${width}px, ${$05534568732462ab$var$panelWidthSlotBounds.max})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $05534568732462ab$var$styles.root,
                defaultWidth === 0 && $05534568732462ab$var$styles.hidden,
                xcss
            ]),
            style: {
                [(0, (0, parcelRequire("ilnvx")).panelVar)]: panelVariableWidth
            },
            "data-testid": testId,
            ref: ref
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_panelLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("h9kUS")).media).above.lg,
            responsiveValue: panelVariableWidth
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVO1C")).PanelSplitterProvider), {
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $05534568732462ab$var$panelWidthResizeBounds,
            resizingCssVar: $05534568732462ab$var$panelSplitterResizingVar,
            position: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $05534568732462ab$var$styles.scrollContainer
            ])
        }, children)));
    }
});
parcelRegister("kTus1", function(module, exports) {
    $parcel$export(module.exports, "SideNav", ()=>$be4966f89908f895$export$1a35787d6353cf6a);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $dlnxJ;
    var $e4cTf;
    var $h9kUS;
    var $c4wuJ;
    var $585q9;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $fVO1C;
    var $l9xvw;
    var $eZOeM;
    var $ecbZX;
    var $27t8Q;
    var $6qnkT;
    const $be4966f89908f895$var$panelSplitterResizingVar = '--n_snvRsz';
    const $be4966f89908f895$var$widthResizeBounds = {
        min: '240px',
        max: '50vw'
    };
    const $be4966f89908f895$var$sideNavFlyoutCloseDelayMs = 400;
    const $be4966f89908f895$var$getSideNavState = ({ visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, isFlyoutVisible: isFlyoutVisible })=>{
        if (visibleOnDesktop && visibleOnMobile) return 'visible-all';
        if (!visibleOnMobile && visibleOnDesktop) return 'hidden-mobile-only';
        if (!visibleOnDesktop && isFlyoutVisible) return 'flyout';
        if (visibleOnMobile && !visibleOnDesktop) return 'hidden-desktop-only';
        return 'hidden-mobile-and-desktop';
    };
    const $be4966f89908f895$var$styles = {
        root: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _4ap3vuon _scbpglyw _qilnk0mc",
        flyout: "_4ap31bhr _scbp1cd0 _qiln1gzg",
        interactionSurface: "_1bsb1osq _4t3i1osq",
        flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
        hiddenMobileAndDesktop: "_1e0cglyw",
        hiddenMobileOnly: "_1e0cglyw _dm2518uv",
        hiddenDesktopOnly: "_dm25glyw"
    };
    function $be4966f89908f895$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        const { visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, setVisibleOnDesktop: setVisibleOnDesktop } = (0, (0, parcelRequire("ecbZX")).useSideNavVisibility)({
            defaultCollapsed: defaultCollapsed
        });
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const clampedWidth = `clamp(${$be4966f89908f895$var$widthResizeBounds.min}, ${width}px, ${$be4966f89908f895$var$widthResizeBounds.max})`;
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const navRef = (0, $5uXOq.useRef)(null);
        const toggleButtonElement = (0, $5uXOq.useContext)((0, (0, parcelRequire("eZOeM")).SideNavToggleButtonElement));
        const homeActionsElement = (0, $5uXOq.useContext)((0, (0, parcelRequire("c4wuJ")).HomeActionsElement));
        const devTimeOnlyAttributes = {};
        const [isFlyoutVisible, setIsFlyoutVisible] = (0, $5uXOq.useState)(false);
        const openLayerObserver = (0, (0, parcelRequire("e4cTf")).useOpenLayerObserver)();
        const flyoutStateRef = (0, $5uXOq.useRef)({
            type: 'not-active'
        });
        const sideNavState = $be4966f89908f895$var$getSideNavState({
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            isFlyoutVisible: isFlyoutVisible
        });
        const updateFlyoutState = (0, $5uXOq.useCallback)((action)=>{
            if (action === 'open') {
                if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
                flyoutStateRef.current = {
                    type: 'open'
                };
                setIsFlyoutVisible(true);
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, $be4966f89908f895$var$sideNavFlyoutCloseDelayMs);
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                if (openLayerObserver.getCount() === 0) {
                    flyoutStateRef.current = {
                        type: 'not-active'
                    };
                    setIsFlyoutVisible(false);
                }
                return;
            }
            if (action === 'force-close') {
                flyoutStateRef.current = {
                    type: 'not-active'
                };
                setIsFlyoutVisible(false);
                return;
            }
        }, [
            openLayerObserver
        ]);
        const toggleVisibility = (0, (0, parcelRequire("6qnkT")).useToggleSideNav)();
        (0, $5uXOq.useEffect)(()=>{
            setVisibleOnDesktop(visibleOnDesktop);
        }, [
            setVisibleOnDesktop,
            visibleOnDesktop
        ]);
        const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            onExpand?.({
                screen: screen
            });
            updateFlyoutState('force-close');
        }, [
            onExpand,
            updateFlyoutState
        ]);
        const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            onCollapse?.({
                screen: screen
            });
            updateFlyoutState('force-close');
        }, [
            onCollapse,
            updateFlyoutState
        ]);
        (0, (0, parcelRequire("27t8Q")).useSideNavVisibilityCallbacks)({
            onExpand: handleExpand,
            onCollapse: handleCollapse,
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile
        });
        (0, $5uXOq.useEffect)(()=>{
            const mediaQueryList = window.matchMedia('(min-width: 64rem)');
            return (0, (0, parcelRequire("cBeZP")).bind)(mediaQueryList, {
                type: 'change',
                listener () {
                    if (mediaQueryList.matches) {
                        if (visibleOnMobile && !visibleOnDesktop) toggleVisibility();
                    }
                }
            });
        }, [
            toggleVisibility,
            visibleOnDesktop,
            visibleOnMobile
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(toggleButtonElement, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop) return;
                    const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                    if (matches) updateFlyoutState('open');
                }
            });
        }, [
            updateFlyoutState,
            toggleButtonElement,
            visibleOnDesktop
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(toggleButtonElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            isFlyoutVisible,
            toggleButtonElement,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(navRef.current, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    updateFlyoutState('open');
                }
            });
        }, [
            isFlyoutVisible,
            updateFlyoutState,
            visibleOnDesktop
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(navRef.current, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            isFlyoutVisible,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!homeActionsElement || !toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(homeActionsElement, {
                type: 'mouseover',
                listener (event) {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    if (event.target === homeActionsElement) {
                        updateFlyoutState('open');
                        return;
                    }
                    if (event.target instanceof Element && toggleButtonElement.contains(event.target)) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            homeActionsElement,
            isFlyoutVisible,
            toggleButtonElement,
            visibleOnDesktop,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!homeActionsElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(homeActionsElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            homeActionsElement,
            isFlyoutVisible,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return openLayerObserver.onChange(function onChange({ count: count }) {
                if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) {
                    setIsFlyoutVisible(false);
                    flyoutStateRef.current = {
                        type: 'not-active'
                    };
                }
            });
        }, [
            openLayerObserver,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return function cleanupPendingFlyoutClose() {
                if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("nav", {
            id: CID,
            ...devTimeOnlyAttributes,
            "data-layout-slot": true,
            "data-private-request-curved-border-on-main": sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only' ? true : undefined,
            "data-private-show-inline-start-border-on-main": sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only' ? true : undefined,
            "aria-label": label,
            style: {
                [(0, (0, parcelRequire("ilnvx")).sideNavVar)]: clampedWidth
            },
            ref: navRef,
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $be4966f89908f895$var$styles.root,
                sideNavState === 'hidden-mobile-only' && $be4966f89908f895$var$styles.hiddenMobileOnly,
                sideNavState === 'hidden-desktop-only' && $be4966f89908f895$var$styles.hiddenDesktopOnly,
                sideNavState === 'hidden-mobile-and-desktop' && $be4966f89908f895$var$styles.hiddenMobileAndDesktop,
                sideNavState === 'flyout' && $be4966f89908f895$var$styles.flyout
            ])
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_sideNavLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("h9kUS")).media).above.md,
            responsiveValue: visibleOnDesktop ? clampedWidth : 0
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVO1C")).PanelSplitterProvider), {
            panelRef: navRef,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $be4966f89908f895$var$widthResizeBounds,
            resizingCssVar: $be4966f89908f895$var$panelSplitterResizingVar,
            isEnabled: sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $be4966f89908f895$var$styles.flexContainer
            ])
        }, children)));
    }
    function $be4966f89908f895$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dlnxJ")).OpenLayerObserver), null, (0, ($parcel$interopDefault($5uXOq))).createElement($be4966f89908f895$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id
        }, children));
    }
});
parcelRegister("dlnxJ", function(module, exports) {
    $parcel$export(module.exports, "OpenLayerObserver", ()=>$db6ff2d140327fd6$export$97afddda23bcd287);
    var $5uXOq = parcelRequire("5uXOq");
    var $kEhTY;
    function $db6ff2d140327fd6$var$createInternalAPI() {
        let count = 0;
        const registry = new Set();
        function onChange(listener) {
            function wrapped(...args) {
                listener(...args);
            }
            registry.add(wrapped);
            return function unsubscribe() {
                registry.delete(wrapped);
            };
        }
        function increment() {
            count += 1;
            Array.from(registry).forEach((listener)=>listener({
                    count: count
                }));
        }
        function decrement() {
            count -= 1;
            Array.from(registry).forEach((listener)=>listener({
                    count: count
                }));
        }
        return {
            getCount () {
                return count;
            },
            onChange: onChange,
            increment: increment,
            decrement: decrement
        };
    }
    function $db6ff2d140327fd6$export$97afddda23bcd287({ children: children }) {
        const [internalAPI] = (0, $5uXOq.useState)(()=>$db6ff2d140327fd6$var$createInternalAPI());
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kEhTY")).OpenLayerObserverContext));
        const increment = (0, $5uXOq.useCallback)(()=>{
            internalAPI.increment();
            if (parentContext !== null) parentContext.increment();
        }, [
            internalAPI,
            parentContext
        ]);
        const decrement = (0, $5uXOq.useCallback)(()=>{
            internalAPI.decrement();
            if (parentContext !== null) parentContext.decrement();
        }, [
            internalAPI,
            parentContext
        ]);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                getCount: internalAPI.getCount,
                onChange: internalAPI.onChange,
                increment: increment,
                decrement: decrement
            }), [
            decrement,
            increment,
            internalAPI.getCount,
            internalAPI.onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kEhTY")).OpenLayerObserverContext).Provider, {
            value: contextValue
        }, children);
    }
});
parcelRegister("e4cTf", function(module, exports) {
    $parcel$export(module.exports, "useOpenLayerObserver", ()=>$ea3ab92c791f0d5d$export$750f5b0d6c51617e);
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    var $kEhTY;
    function $ea3ab92c791f0d5d$export$750f5b0d6c51617e() {
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("kEhTY")).OpenLayerObserverContext));
        (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
        const publicAPI = (0, $5uXOq.useMemo)(()=>({
                getCount: context.getCount,
                onChange: context.onChange
            }), [
            context.getCount,
            context.onChange
        ]);
        return publicAPI;
    }
});
parcelRegister("ecbZX", function(module, exports) {
    $parcel$export(module.exports, "useSideNavVisibility", ()=>$251628ab22f05abd$export$4a602ad7e09bdb2c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $b0CFU;
    const $251628ab22f05abd$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
        const visibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SideNavDesktopVisibility));
        const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavDesktopVisibility));
        const visibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SideNavMobileVisibility));
        const setVisibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavMobileVisibility));
        const [isSideNavVisible, setIsSideNavVisible] = (0, $5uXOq.useState)(!defaultCollapsed);
        (0, $5uXOq.useEffect)(()=>{
            const isSideNavVisibleOnDesktop = visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop;
            const mediaQueryList = window.matchMedia('(min-width: 64rem)');
            setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
            return (0, (0, parcelRequire("cBeZP")).bind)(mediaQueryList, {
                type: 'change',
                listener () {
                    setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
                }
            });
        }, [
            defaultCollapsed,
            visibleOnDesktop,
            visibleOnMobile
        ]);
        const showSideNav = (0, $5uXOq.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            matches ? setVisibleOnDesktop(true) : setVisibleOnMobile(true);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return {
            visibleOnDesktop: visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            setVisibleOnDesktop: setVisibleOnDesktop,
            setVisibleOnMobile: setVisibleOnMobile,
            isSideNavVisible: isSideNavVisible,
            showSideNav: showSideNav
        };
    };
});
parcelRegister("27t8Q", function(module, exports) {
    $parcel$export(module.exports, "useSideNavVisibilityCallbacks", ()=>$cb86acb1b056338b$export$1904b8f2577aba9a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lp9re;
    function $cb86acb1b056338b$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile }) {
        const onExpandRef = (0, $5uXOq.useRef)(onExpand);
        const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
        (0, $5uXOq.useEffect)(()=>{
            onExpandRef.current = onExpand;
            onCollapseRef.current = onCollapse;
        }, [
            onExpand,
            onCollapse
        ]);
        const previousVisibleOnDesktop = (0, (0, parcelRequire("lp9re")).default)(visibleOnDesktop);
        (0, $5uXOq.useEffect)(()=>{
            if (previousVisibleOnDesktop === undefined || previousVisibleOnDesktop === visibleOnDesktop) return;
            if (visibleOnDesktop) onExpandRef.current?.({
                screen: 'desktop'
            });
            else onCollapseRef.current?.({
                screen: 'desktop'
            });
        }, [
            previousVisibleOnDesktop,
            visibleOnDesktop
        ]);
        const previousVisibleOnMobile = (0, (0, parcelRequire("lp9re")).default)(visibleOnMobile);
        (0, $5uXOq.useEffect)(()=>{
            if (previousVisibleOnMobile === undefined || previousVisibleOnMobile === visibleOnMobile) return;
            if (visibleOnMobile) onExpandRef.current?.({
                screen: 'mobile'
            });
            else onCollapseRef.current?.({
                screen: 'mobile'
            });
        }, [
            previousVisibleOnMobile,
            visibleOnMobile
        ]);
    }
});
parcelRegister("6qnkT", function(module, exports) {
    $parcel$export(module.exports, "useToggleSideNav", ()=>$0e2ff6e3f286dc0d$export$477ee35601a0a8ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $b0CFU;
    function $0e2ff6e3f286dc0d$export$477ee35601a0a8ce() {
        const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavDesktopVisibility));
        const setVisibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavMobileVisibility));
        const toggleSideNav = (0, $5uXOq.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            if (matches) setVisibleOnDesktop((prev)=>!prev);
            else setVisibleOnMobile((prev)=>!prev);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return toggleSideNav;
    }
});
parcelRegister("fod7Z", function(module, exports) {
    $parcel$export(module.exports, "TopBar", ()=>$474d185125d63dcd$export$c4e96258f3b6511);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $585q9;
    var $7K1Hj;
    var $C93Ef;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $l9xvw;
    const $474d185125d63dcd$var$styles = {
        root: "_1e0c11p5 _yv0e1mfv _zulpu2gc _nd5l8cbt _18zrutpp _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1rqtc57g"
    };
    const $474d185125d63dcd$var$contentBorderStyles = {
        smallViewportTop: "_nd5l8cbt _179rzgxb _152t1nws _lcxvglyw _kqsw1if8 _t9ec2nsj _1pby11wp _dm25glyw"
    };
    function $474d185125d63dcd$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, label: label = 'Top Bar', testId: testId, id: id, UNSAFE_theme: UNSAFE_theme }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        const customTheme = (0, (0, parcelRequire("C93Ef")).useCustomTheme)(UNSAFE_theme);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K1Hj")).HasCustomThemeContext).Provider, {
            value: customTheme.isEnabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("header", {
            id: CID,
            "data-layout-slot": true,
            "data-private-do-not-show-curved-border-on-main": customTheme.isEnabled ? true : undefined,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $474d185125d63dcd$var$styles.root,
                xcss
            ]),
            "data-testid": testId,
            style: customTheme.isEnabled ? customTheme.style : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).HoistCssVarToLocalGrid), {
            variableName: (0, (0, parcelRequire("ilnvx")).topBarMountedVar),
            value: UNSAFE_height
        }), dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_topBarVar),
            value: UNSAFE_height
        }), children), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $474d185125d63dcd$var$contentBorderStyles.smallViewportTop
            ])
        }));
    }
});
parcelRegister("C93Ef", function(module, exports) {
    $parcel$export(module.exports, "useCustomTheme", ()=>$7d674db87d8ae404$export$c0c5f5b297b77726);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $408XH;
    function $7d674db87d8ae404$export$c0c5f5b297b77726(theme) {
        const value = (0, $5uXOq.useMemo)(()=>{
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_nav4_top_bar_theming')) return {
                isEnabled: false
            };
            if (!theme?.backgroundColor || !theme?.highlightColor) return {
                isEnabled: false
            };
            const value = {
                backgroundColor: theme.backgroundColor,
                highlightColor: theme.highlightColor
            };
            const style = (0, (0, parcelRequire("408XH")).getCustomThemeStyles)(value);
            return {
                isEnabled: true,
                style: style
            };
        }, [
            theme?.backgroundColor,
            theme?.highlightColor
        ]);
        return value;
    }
});
parcelRegister("408XH", function(module, exports) {
    $parcel$export(module.exports, "getCustomThemeStyles", ()=>$0ea127ed833ce03d$export$3986d75fe2da3239);
    var $g8Ctp;
    var $65VCl;
    var $kuLvb;
    var $3ysBv;
    var $al2bB;
    const $0ea127ed833ce03d$var$buttonStyles = {
        light: {
            [(0, (0, parcelRequire("65VCl")).themedButtonBackground)]: 'transparent',
            [(0, (0, parcelRequire("65VCl")).themedButtonBackgroundHovered)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral200A,
            [(0, (0, parcelRequire("65VCl")).themedButtonBackgroundPressed)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonBorder)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackground)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackgroundHovered)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral400A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackgroundPressed)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral500A,
            [(0, (0, parcelRequire("65VCl")).themedButtonDisabledText)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral400A,
            [(0, (0, parcelRequire("65VCl")).themedButtonDisabledBackground)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral100A
        },
        dark: {
            [(0, (0, parcelRequire("65VCl")).themedButtonBackground)]: 'transparent',
            [(0, (0, parcelRequire("65VCl")).themedButtonBackgroundHovered)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral200A,
            [(0, (0, parcelRequire("65VCl")).themedButtonBackgroundPressed)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonBorder)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackground)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackgroundHovered)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral400A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackgroundPressed)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral500A,
            [(0, (0, parcelRequire("65VCl")).themedButtonDisabledText)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral400A,
            [(0, (0, parcelRequire("65VCl")).themedButtonDisabledBackground)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral100A
        }
    };
    const $0ea127ed833ce03d$var$logoStyles = {
        light: {
            [(0, (0, parcelRequire("g8Ctp")).themedLogoIcon)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral0,
            [(0, (0, parcelRequire("g8Ctp")).themedLogoText)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral0
        },
        dark: {
            [(0, (0, parcelRequire("g8Ctp")).themedLogoIcon)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral0,
            [(0, (0, parcelRequire("g8Ctp")).themedLogoText)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral0
        }
    };
    function $0ea127ed833ce03d$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
        const backgroundRgb = (0, (0, parcelRequire("kuLvb")).hexToRGB)(backgroundColor);
        const highlightRgb = (0, (0, parcelRequire("kuLvb")).hexToRGB)(highlightColor);
        const textColor = (0, (0, parcelRequire("kuLvb")).getTextColor)(backgroundRgb);
        const colorMode = (0, (0, parcelRequire("kuLvb")).getColorMode)(backgroundRgb);
        const highlightTextColor = (0, (0, parcelRequire("kuLvb")).getTextColor)(highlightRgb);
        return {
            backgroundColor: backgroundColor,
            color: textColor.hex,
            ...$0ea127ed833ce03d$var$buttonStyles[colorMode],
            ...$0ea127ed833ce03d$var$logoStyles[colorMode],
            ...$0ea127ed833ce03d$var$getSelectedStyles({
                backgroundColor: backgroundRgb,
                colorMode: colorMode
            }),
            [(0, (0, parcelRequire("al2bB")).themedSearchBorder)]: (0, (0, parcelRequire("kuLvb")).toRGBAString)({
                ...textColor.rgb,
                a: 0.5
            }),
            [(0, (0, parcelRequire("al2bB")).themedSearchBorderFocused)]: (0, (0, parcelRequire("kuLvb")).toRGBAString)({
                ...highlightRgb,
                a: 0.8
            }),
            [(0, (0, parcelRequire("65VCl")).themedButtonPrimaryBackground)]: highlightColor,
            [(0, (0, parcelRequire("65VCl")).themedButtonPrimaryBackgroundHovered)]: (0, (0, parcelRequire("kuLvb")).toRGBAString)({
                ...highlightRgb,
                a: 0.8
            }),
            [(0, (0, parcelRequire("65VCl")).themedButtonPrimaryBackgroundPressed)]: (0, (0, parcelRequire("kuLvb")).toRGBAString)({
                ...highlightRgb,
                a: 0.65
            }),
            [(0, (0, parcelRequire("65VCl")).themedButtonPrimaryText)]: highlightTextColor.hex
        };
    }
    const $0ea127ed833ce03d$var$selectedBackgroundRGBA = {
        light: (0, (0, parcelRequire("kuLvb")).hexToRGBA)($0ea127ed833ce03d$var$buttonStyles.light[0, (0, parcelRequire("65VCl")).themedButtonSelectedBackground]),
        dark: (0, (0, parcelRequire("kuLvb")).hexToRGBA)($0ea127ed833ce03d$var$buttonStyles.dark[0, (0, parcelRequire("65VCl")).themedButtonSelectedBackground])
    };
    function $0ea127ed833ce03d$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
        const foregroundColor = $0ea127ed833ce03d$var$selectedBackgroundRGBA[colorMode];
        const blendedBackground = (0, (0, parcelRequire("kuLvb")).simpleAlphaComposite)({
            background: backgroundColor,
            foreground: foregroundColor
        });
        return {
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedText)]: (0, (0, parcelRequire("kuLvb")).getTextColor)(blendedBackground).hex,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBorder)]: (0, (0, parcelRequire("kuLvb")).isLight)(blendedBackground) ? (0, (0, parcelRequire("3ysBv")).palette).Neutral1100 : (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral1100
        };
    }
});
parcelRegister("kuLvb", function(module, exports) {
    $parcel$export(module.exports, "toRGBAString", ()=>$1acf112c63636f80$export$b597d7418f37d50a);
    $parcel$export(module.exports, "hexToRGBA", ()=>$1acf112c63636f80$export$7229be6d7219ee6a);
    $parcel$export(module.exports, "hexToRGB", ()=>$1acf112c63636f80$export$848d71df1f759bc);
    $parcel$export(module.exports, "isLight", ()=>$1acf112c63636f80$export$44af652f4cca9039);
    $parcel$export(module.exports, "getColorMode", ()=>$1acf112c63636f80$export$5573a5bab3e074b5);
    $parcel$export(module.exports, "getTextColor", ()=>$1acf112c63636f80$export$5357fe757c335c0d);
    $parcel$export(module.exports, "simpleAlphaComposite", ()=>$1acf112c63636f80$export$e5e64c30bee1469b);
    const $1acf112c63636f80$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
    const $1acf112c63636f80$var$isValidHexNoAlpha = (hex)=>/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
    function $1acf112c63636f80$export$b597d7418f37d50a({ r: r, g: g, b: b, a: a }) {
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }
    function $1acf112c63636f80$export$7229be6d7219ee6a(hex) {
        if (!$1acf112c63636f80$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let channels;
        if (hex.length <= 5) channels = {
            r: hex[1].repeat(2),
            g: hex[2].repeat(2),
            b: hex[3].repeat(2),
            a: hex[4]?.repeat(2) ?? 'FF'
        };
        else channels = {
            r: hex.slice(1, 3),
            g: hex.slice(3, 5),
            b: hex.slice(5, 7),
            a: hex.slice(7, 9) || 'FF'
        };
        return {
            r: parseInt(channels.r, 16),
            g: parseInt(channels.g, 16),
            b: parseInt(channels.b, 16),
            a: parseInt(channels.a, 16) / 255
        };
    }
    function $1acf112c63636f80$export$848d71df1f759bc(hex) {
        if (!$1acf112c63636f80$var$isValidHexNoAlpha(hex)) throw new Error('Invalid HEX');
        const { r: r, g: g, b: b } = $1acf112c63636f80$export$7229be6d7219ee6a(hex);
        return {
            r: r,
            g: g,
            b: b
        };
    }
    function $1acf112c63636f80$var$linearizeRGBChannel(channel) {
        return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    function $1acf112c63636f80$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
        const normal = {
            r: r / 255,
            g: g / 255,
            b: b / 255
        };
        const linear = {
            r: $1acf112c63636f80$var$linearizeRGBChannel(normal.r),
            g: $1acf112c63636f80$var$linearizeRGBChannel(normal.g),
            b: $1acf112c63636f80$var$linearizeRGBChannel(normal.b)
        };
        const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
        return L;
    }
    function $1acf112c63636f80$export$d061e26956a60b0a({ background: background, foreground: foreground }) {
        const foregroundLuminance = $1acf112c63636f80$var$relativeLuminanceW3C(foreground);
        const backgroundLuminance = $1acf112c63636f80$var$relativeLuminanceW3C(background);
        const brightest = Math.max(foregroundLuminance, backgroundLuminance);
        const darkest = Math.min(foregroundLuminance, backgroundLuminance);
        return (brightest + 0.05) / (darkest + 0.05);
    }
    const $1acf112c63636f80$var$flipLuminance = 0.179129;
    function $1acf112c63636f80$export$44af652f4cca9039(color) {
        return $1acf112c63636f80$var$relativeLuminanceW3C(color) >= $1acf112c63636f80$var$flipLuminance;
    }
    function $1acf112c63636f80$export$5573a5bab3e074b5(backgroundColor) {
        if ($1acf112c63636f80$var$relativeLuminanceW3C(backgroundColor) >= $1acf112c63636f80$var$flipLuminance) return 'light';
        return 'dark';
    }
    const $1acf112c63636f80$var$textColor = {
        light: {
            hex: '#000',
            rgb: {
                r: 0,
                g: 0,
                b: 0
            }
        },
        dark: {
            hex: '#FFF',
            rgb: {
                r: 255,
                g: 255,
                b: 255
            }
        }
    };
    function $1acf112c63636f80$export$5357fe757c335c0d(backgroundColor) {
        const colorMode = $1acf112c63636f80$export$5573a5bab3e074b5(backgroundColor);
        return $1acf112c63636f80$var$textColor[colorMode];
    }
    function $1acf112c63636f80$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
        return {
            r: foreground.a * foreground.r + background.r * (1 - foreground.a),
            g: foreground.a * foreground.g + background.g * (1 - foreground.a),
            b: foreground.a * foreground.b + background.b * (1 - foreground.a)
        };
    }
});
parcelRegister("3ysBv", function(module, exports) {
    $parcel$export(module.exports, "palette", ()=>$7460df5260aa7edf$export$eaad8caa32d2521d);
    const $7460df5260aa7edf$export$eaad8caa32d2521d = {
        'DarkNeutral-100': '#111213',
        'DarkNeutral-100A': '#01040475',
        DarkNeutral0: '#18191A',
        DarkNeutral100: '#1F1F21',
        DarkNeutral100A: '#BDBDBD0A',
        DarkNeutral200: '#242528',
        DarkNeutral200A: '#CECED912',
        DarkNeutral250: '#2B2C2F',
        DarkNeutral250A: '#D9DAE71A',
        DarkNeutral300: '#303134',
        DarkNeutral300A: '#E3E4F21F',
        DarkNeutral350: '#3D3F43',
        DarkNeutral350A: '#E8EDFD2E',
        DarkNeutral400: '#4B4D51',
        DarkNeutral400A: '#E5E9F640',
        DarkNeutral500: '#63666B',
        DarkNeutral500A: '#E9F0FB5C',
        DarkNeutral600: '#7E8188',
        DarkNeutral700: '#96999E',
        DarkNeutral800: '#A9ABAF',
        DarkNeutral900: '#BFC1C4',
        DarkNeutral1000: '#CECFD2',
        DarkNeutral1100: '#E2E3E4',
        Neutral0: '#FFFFFF',
        Neutral100: '#F8F8F8',
        Neutral100A: '#17171708',
        Neutral200: '#F0F1F2',
        Neutral200A: '#0515240F',
        Neutral300: '#DDDEE1',
        Neutral300A: '#0B120E24',
        Neutral400: '#B7B9BE',
        Neutral400A: '#080F214A',
        Neutral500: '#8C8F97',
        Neutral500A: '#050C1F75',
        Neutral600: '#7D818A',
        Neutral700: '#6B6E76',
        Neutral800: '#505258',
        Neutral900: '#3B3D42',
        Neutral1000: '#292A2E',
        Neutral1100: '#1E1F21'
    };
});
parcelRegister("axUP7", function(module, exports) {
    $parcel$export(module.exports, "withNestingOptimisation", ()=>$c861ce2b697701b9$export$ee1cb2a8280d8710);
    var $5uXOq = parcelRequire("5uXOq");
    var $j9VTE;
    var $9sGI6;
    const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
        const WithNestingOptimisation = (0, $5uXOq.forwardRef)((props, ref)=>{
            const children = typeof props === 'object' && props != null ? props.children : null;
            return (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)().shouldRender && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ref: ref
            }) : children;
        });
        WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, (0, parcelRequire("9sGI6")).getDisplayName)(Component)})`;
        return WithNestingOptimisation;
    };
});
parcelRegister("9sGI6", function(module, exports) {
    $parcel$export(module.exports, "getDisplayName", ()=>$0d4ebae82d1d47ab$export$be63e0664592e141);
    $parcel$export(module.exports, "default", ()=>$0d4ebae82d1d47ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
        if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
        if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
        return 'Component';
    };
    const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
        const WithInjectedProps = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...injectedProps,
                ...props
            });
        WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
        return WithInjectedProps;
    };
    var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;
});
parcelRegister("ajOhG", function(module, exports) {
    $parcel$export(module.exports, "FeedbackNudgeAsync", ()=>$9b3ebbbcc2dff472$export$be3f2958452e7be9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $9b3ebbbcc2dff472$var$FeedbackNudgeLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("7u4Dj")).then((exportedModule)=>exportedModule.FeedbackNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
    });
    const $9b3ebbbcc2dff472$export$be3f2958452e7be9 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "feedback-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9b3ebbbcc2dff472$var$FeedbackNudgeLazy, null, children)));
    $9b3ebbbcc2dff472$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';
});
parcelRegister("bBbEG", function(module, exports) {
    $parcel$export(module.exports, "OnboardingNudgeErrorBoundary", ()=>$383be1d115a6551b$export$3915a8814b99f0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkem5;
    var $8Bc5A;
    const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
        const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkem5")).ErrorBoundaryWithChunkErrorLogging), {
            id: id,
            packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
            render: ()=>fallback,
            attributes: attributes
        }, children);
    };
});
parcelRegister("lkem5", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", ()=>$3df8b034ebbd68e5$export$9171acf2e93b7d4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $30rnQ;
    const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
        const { attributes: attributes, children: children, ...rest } = props;
        const addErrorBoundaryAnalyticsAttributes = (0, (0, parcelRequire("30rnQ")).useAddErrorBoundaryAnalyticsAttributes)(attributes);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            ...rest,
            attributes: addErrorBoundaryAnalyticsAttributes
        }, children);
    };
});
parcelRegister("30rnQ", function(module, exports) {
    $parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", ()=>$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
    $parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", ()=>$53c68ff9a9edd0fe$export$807be5f3f1ea996);
    var $5uXOq = parcelRequire("5uXOq");
    var $bCf8q;
    const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
            chunkLoadError: (0, (0, parcelRequire("bCf8q")).isLoaderError)(error)
        });
    const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
                ...attributes,
                ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
            }), [
            attributes
        ]);
});
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
parcelRegister("7u4Dj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eSNL6").then(()=>parcelRequire('5YJ1A'));
});
parcelRegister("Fmgai", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c642b7880215349a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c642b7880215349a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        feedback: {
            "id": "spa-apps-sidebar-core.multi-project-menu.feedback-button.feedback",
            "defaultMessage": "Give feedback"
        }
    });
});
parcelRegister("NCdt4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b005747d8914d3b0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b005747d8914d3b0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        companyManagedProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.company-managed-project",
            "defaultMessage": "You're in a company-managed project"
        },
        navigationLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.navigation-label",
            "defaultMessage": "Side"
        },
        teamManagedProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.team-managed-project",
            "defaultMessage": "You're in a team-managed project"
        },
        viewAllStarred: {
            "id": "spa-apps-sidebar-core.multi-project-menu.view-all-starred",
            "defaultMessage": "View all starred projects"
        }
    });
});
parcelRegister("dCGEg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$230ddc65e16732f3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $i8Qvm;
    var $i5shE;
    var $7yUJn;
    var $N0aCi;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $iNzEe;
    var $dIdda = parcelRequire("dIdda");
    var $gb5lQ;
    var $iuAuR;
    var $6hYaZ;
    var $2kAEg;
    var $imgTm;
    const $230ddc65e16732f3$var$Overviews = ({ overviews: overviews, hasError: hasError })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const refresh = (0, $5uXOq.useCallback)(()=>typeof window !== 'undefined' && window.location.reload(), []);
        const [{ match: match, route: route }] = (0, $dIdda.useRouter)();
        const routeOverviewId = match.params?.overviewId;
        const [isCreateModalOpen, setIsCreateModalOpen] = (0, $5uXOq.useState)(false);
        const openCreateModal = (0, $5uXOq.useCallback)(()=>{
            setIsCreateModalOpen(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createOverview');
        }, [
            createAnalyticsEvent
        ]);
        const closeCreateModal = (0, $5uXOq.useCallback)(()=>setIsCreateModalOpen(false), []);
        const showOverviewChangeboarding = (0, (0, parcelRequire("iNzEe")).useTriggerOverviewChangeboarding)();
        if (showOverviewChangeboarding) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("2kAEg")).default).overviewsHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("N0aCi")).AsyncMigrationMessage), null));
        let content;
        if (hasError) content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$ErrorWrapper, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$ErrorMessage, null, formatMessage((0, (0, parcelRequire("2kAEg")).default).errorMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            onClick: refresh
        }, formatMessage((0, (0, parcelRequire("2kAEg")).default).refreshPage)));
        else if (overviews.length === 0) content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$EmptyState, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.empty-state"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: openCreateModal
        }, formatMessage((0, (0, parcelRequire("2kAEg")).default).createOverview)));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$List, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-list"
        }, overviews.map((overview)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: overview.id
            }, routeOverviewId === overview.id ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imgTm")).default), {
                overview: overview,
                to: (0, (0, parcelRequire("i5shE")).getOverviewUrl)(overview),
                isActive: true
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imgTm")).default), {
                overview: overview,
                to: (0, (0, parcelRequire("i5shE")).getOverviewUrl)(overview, route)
            }))));
        const hasReachedLimit = overviews?.length >= (0, (0, parcelRequire("gb5lQ")).OVERVIEW_MAX_LIMIT);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("2kAEg")).default).overviewsHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6hYaZ")).default), {
            onClick: openCreateModal,
            hasReachedLimit: hasReachedLimit
        })), content, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isCreateModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yUJn")).default), {
            onClose: closeCreateModal
        })));
    };
    var $230ddc65e16732f3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($230ddc65e16732f3$var$Overviews);
    const $230ddc65e16732f3$var$EmptyState = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$List = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$ErrorWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$ErrorMessage = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s85axq _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i5shE", function(module, exports) {
    $parcel$export(module.exports, "getOverviewUrl", ()=>$b5027b2ddff99a4d$export$e314405e3f098e61);
    var $65Ltd;
    const $b5027b2ddff99a4d$export$e314405e3f098e61 = (overview, currentRoute)=>{
        switch(currentRoute?.name){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY:
                return `/jira/core/overviews/${overview.id}/summary`;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR:
                return `/jira/core/overviews/${overview.id}/calendar`;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE:
                return `/jira/core/overviews/${overview.id}/timeline`;
            default:
                return `/jira/core/overviews/${overview.id}`;
        }
    };
});
parcelRegister("7yUJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2eb121a7f5478dbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cm8b5;
    var $lfTZh;
    var $kxZPA;
    var $bTIks;
    const $2eb121a7f5478dbf$var$LazyCreateOverviewModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fmp5H")), {
        ssr: false,
        moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
    });
    var $2eb121a7f5478dbf$export$2e2bcd8739ae039 = ({ onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("bTIks")).CREATE_OVERVIEW_EXPERIENCE),
            fallback: "unmount",
            shouldStartExperience: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "overview-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2eb121a7f5478dbf$var$LazyCreateOverviewModal, {
            onClose: onClose
        })));
});
parcelRegister("cm8b5", function(module, exports) {
    $parcel$export(module.exports, "useExperienceStart", ()=>$aca94fc714dddc77$export$675e0d25df38d426);
    $parcel$export(module.exports, "useExperienceAbort", ()=>$aca94fc714dddc77$export$cc92b7ce453f4403);
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$aca94fc714dddc77$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "useExperienceFail", ()=>$aca94fc714dddc77$export$606da7704d8eaf06);
    $parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", ()=>$aca94fc714dddc77$export$8ca25d6ff1437be3);
    $parcel$export(module.exports, "ExperienceStart", ()=>$aca94fc714dddc77$export$f20b867e738a222c);
    $parcel$export(module.exports, "ExperienceFailed", ()=>$aca94fc714dddc77$export$ae65a9e09c4516b3);
    $parcel$export(module.exports, "ExperienceErrorBoundary", ()=>$aca94fc714dddc77$export$139c4a4ad101c3c5);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$aca94fc714dddc77$export$4962f3898bd5c829);
    $parcel$export(module.exports, "ExperienceAbort", ()=>$aca94fc714dddc77$export$c9b6bcd70239a39c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Wswo;
    var $8UpTw;
    var $39xOx;
    var $jcw0u;
    var $8dXDG;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $4R6GH;
    var $jJZqs;
    const $aca94fc714dddc77$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: experience,
            experienceId: experienceId,
            analyticsSource: packageName
        });
    const $aca94fc714dddc77$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, (0, parcelRequire("8dXDG")).useExperienceAbort)({
            experience: experience,
            attributes: attributes
        });
    const $aca94fc714dddc77$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: experience
        });
    const $aca94fc714dddc77$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
        const onExperienceFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: experience
        });
        const onFail = (0, $5uXOq.useCallback)((location, error, extraAttributes)=>{
            const relevantError = error?.networkError ?? error;
            if ((0, (0, parcelRequire("4R6GH")).fg)('fun-1253_fix_error_message_failed_experience') && relevantError instanceof (0, (0, parcelRequire("jJZqs")).ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
            extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `experience-tracker-${experienceId ?? experience}`,
                    packageName: packageName,
                    teamName: teamName
                },
                attributes: {
                    location: location
                },
                error: relevantError,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onExperienceFail,
            experienceId,
            experience,
            packageName,
            teamName
        ]);
        return onFail;
    };
    const $aca94fc714dddc77$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
        const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(loading);
        const [hasCompleted, setHasCompleted] = (0, $5uXOq.useState)(false);
        const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $5uXOq.useState)(false);
        const startExperience = $aca94fc714dddc77$export$675e0d25df38d426(experience);
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        const onSuccess = $aca94fc714dddc77$export$e94f0da4fc0603c6(experience);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldStartExperience === true) startExperience();
        }, [
            shouldStartExperience
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasStarted === false && loading === true) setHasStarted(true);
            if (hasStarted === true && loading === false) {
                setHasCompleted(true);
                setHasExperienceBeenTracked(false);
            }
        }, [
            hasStarted,
            loading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasCompleted && !hasExperienceBeenTracked) {
                setHasExperienceBeenTracked(true);
                if (typeof error !== 'undefined') {
                    onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, (0, parcelRequire("8Wswo")).getGraphqlErrorAttributes)(error));
                    return;
                }
                onSuccess({
                    loaded: true
                });
            }
        }, [
            error,
            experience,
            hasCompleted,
            hasExperienceBeenTracked,
            onFail,
            onSuccess
        ]);
    };
    const $aca94fc714dddc77$export$f20b867e738a222c = (0, $5uXOq.memo)(({ experience: experience })=>{
        const start = $aca94fc714dddc77$export$675e0d25df38d426(experience);
        (0, $5uXOq.useEffect)(()=>{
            start();
        }, [
            start
        ]);
        return null;
    });
    const $aca94fc714dddc77$export$ae65a9e09c4516b3 = (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        (0, $5uXOq.useEffect)(()=>{
            onFail(experience.experience, error, attributes);
        }, [
            attributes,
            error,
            experience,
            onFail
        ]);
        return null;
    });
    const $aca94fc714dddc77$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, (0, parcelRequire("8UpTw")).ErrorPage), children: children })=>{
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            packageName: experience.packageName,
            teamName: experience.teamName,
            id: experience.experience,
            onError: onFail,
            fallback: fallback
        }, shouldStartExperience === true && (0, ($parcel$interopDefault($5uXOq))).createElement($aca94fc714dddc77$export$f20b867e738a222c, {
            experience: experience
        }), children);
    };
    const $aca94fc714dddc77$export$4962f3898bd5c829 = (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: experience.experience,
            attributes: {
                ...experience.experienceId == null ? undefined : {
                    experienceId: experience.experienceId
                },
                ...attributes
            }
        }));
    const $aca94fc714dddc77$export$c9b6bcd70239a39c = (0, $5uXOq.memo)(({ experience: experience, error: error })=>{
        const onAbort = $aca94fc714dddc77$export$cc92b7ce453f4403(experience);
        (0, $5uXOq.useEffect)(()=>{
            onAbort(experience.experience, {
                error: error.message
            });
        }, [
            error,
            experience,
            onAbort
        ]);
        return null;
    });
});
parcelRegister("8Wswo", function(module, exports) {
    $parcel$export(module.exports, "shouldHandleTheError", ()=>$6f94bc39289ec711$export$47770c8b6d645cdb);
    $parcel$export(module.exports, "getGraphqlErrorAttributes", ()=>$6f94bc39289ec711$export$b19e649eafc62480);
    var $e3a3O;
    const $6f94bc39289ec711$var$errorWhitelist = [
        'EXPERIENCE_UNAVAILABLE',
        'FIELD_UNAVAILABLE'
    ];
    const $6f94bc39289ec711$export$47770c8b6d645cdb = (error)=>{
        if (error?.networkError) return true;
        const filterIssueLinksDisabledErrors = (graphQLError)=>{
            const isWhitelisted = $6f94bc39289ec711$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
            return !isWhitelisted;
        };
        const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
        return errorsToShow.length > 0;
    };
    const $6f94bc39289ec711$export$b19e649eafc62480 = (error)=>{
        const isApolloError = error instanceof (0, (0, parcelRequire("e3a3O")).ApolloError);
        if (!isApolloError) return {};
        const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
            const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
            return JSON.stringify(errors);
        };
        return {
            statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
            errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
        };
    };
});
parcelRegister("e3a3O", function(module, exports) {
    $parcel$export(module.exports, "NetworkStatus", ()=>$02a3c2aebc919401$export$bd096ddbd246c79c);
    $parcel$export(module.exports, "ApolloError", ()=>$02a3c2aebc919401$export$26a337512320b8c6);
    $parcel$export(module.exports, "ApolloClient", ()=>$02a3c2aebc919401$export$13f5a5f0f1dbab88);
    $parcel$export(module.exports, "default", ()=>$02a3c2aebc919401$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $clSzL;
    var $aS6b9;
    var $ebaCz = parcelRequire("ebaCz");
    var $1DiV8 = parcelRequire("1DiV8");
    var $12QNw;
    var $02a3c2aebc919401$export$bd096ddbd246c79c;
    (function(NetworkStatus) {
        NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
        NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
        NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
        NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
        NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
        NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
        NetworkStatus[NetworkStatus["error"] = 8] = "error";
    })($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
    function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
        return networkStatus < 7;
    }
    var $02a3c2aebc919401$var$Observable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Observable, _super);
        function Observable() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Observable.prototype[0, $ebaCz.default] = function() {
            return this;
        };
        Observable.prototype['@@observable'] = function() {
            return this;
        };
        return Observable;
    }((0, (0, parcelRequire("aS6b9")).default));
    function $02a3c2aebc919401$var$isNonEmptyArray(value) {
        return Array.isArray(value) && value.length > 0;
    }
    function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
        return err.hasOwnProperty('graphQLErrors');
    }
    var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
        var message = '';
        if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
            var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
        if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
        message = message.replace(/\n$/, '');
        return message;
    };
    var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ApolloError, _super);
        function ApolloError(_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
            var _this = _super.call(this, errorMessage) || this;
            _this.graphQLErrors = graphQLErrors || [];
            _this.networkError = networkError || null;
            if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
            else _this.message = errorMessage;
            _this.extraInfo = extraInfo;
            _this.__proto__ = ApolloError.prototype;
            return _this;
        }
        return ApolloError;
    }(Error);
    var $02a3c2aebc919401$export$160bafb6ac1e0641;
    (function(FetchType) {
        FetchType[FetchType["normal"] = 1] = "normal";
        FetchType[FetchType["refetch"] = 2] = "refetch";
        FetchType[FetchType["poll"] = 3] = "poll";
    })($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
    var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
        if (policy === void 0) policy = 'none';
        return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
    };
    var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ObservableQuery, _super);
        function ObservableQuery(_a) {
            var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
            var _this = _super.call(this, function(observer) {
                return _this.onSubscribe(observer);
            }) || this;
            _this.observers = new Set();
            _this.subscriptions = new Set();
            _this.isTornDown = false;
            _this.options = options;
            _this.variables = options.variables || {};
            _this.queryId = queryManager.generateQueryId();
            _this.shouldSubscribe = shouldSubscribe;
            var opDef = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(options.query);
            _this.queryName = opDef && opDef.name && opDef.name.value;
            _this.queryManager = queryManager;
            return _this;
        }
        ObservableQuery.prototype.result = function() {
            var _this = this;
            return new Promise(function(resolve, reject) {
                var observer = {
                    next: function(result) {
                        resolve(result);
                        _this.observers.delete(observer);
                        if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                        setTimeout(function() {
                            subscription.unsubscribe();
                        }, 0);
                    },
                    error: reject
                };
                var subscription = _this.subscribe(observer);
            });
        };
        ObservableQuery.prototype.currentResult = function() {
            var result = this.getCurrentResult();
            if (result.data === undefined) result.data = {};
            return result;
        };
        ObservableQuery.prototype.getCurrentResult = function() {
            if (this.isTornDown) {
                var lastResult = this.lastResult;
                return {
                    data: !this.lastError && lastResult && lastResult.data || void 0,
                    error: this.lastError,
                    loading: false,
                    networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
                };
            }
            var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
            var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
            var result;
            var fetchPolicy = this.options.fetchPolicy;
            var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
            if (queryStoreValue) {
                var networkStatus = queryStoreValue.networkStatus;
                if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                    data: void 0,
                    loading: false,
                    networkStatus: networkStatus,
                    error: new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError
                    })
                };
                if (queryStoreValue.variables) {
                    this.options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options.variables), queryStoreValue.variables);
                    this.variables = this.options.variables;
                }
                result = {
                    data: data,
                    loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                    networkStatus: networkStatus
                };
                if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
            } else {
                var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
                result = {
                    data: data,
                    loading: loading,
                    networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
                };
            }
            if (!partial) this.updateLastResult((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                stale: false
            }));
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                partial: partial
            });
        };
        ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
            var snapshot = this.lastResultSnapshot;
            return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
        };
        ObservableQuery.prototype.getLastResult = function() {
            return this.lastResult;
        };
        ObservableQuery.prototype.getLastError = function() {
            return this.lastError;
        };
        ObservableQuery.prototype.resetLastResults = function() {
            delete this.lastResult;
            delete this.lastResultSnapshot;
            delete this.lastError;
            this.isTornDown = false;
        };
        ObservableQuery.prototype.resetQueryStoreErrors = function() {
            var queryStore = this.queryManager.queryStore.get(this.queryId);
            if (queryStore) {
                queryStore.networkError = null;
                queryStore.graphQLErrors = [];
            }
        };
        ObservableQuery.prototype.refetch = function(variables) {
            var fetchPolicy = this.options.fetchPolicy;
            if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
            if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
            if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.variables), variables);
            if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options.variables), this.variables);
            return this.queryManager.fetchQuery(this.queryId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), {
                fetchPolicy: fetchPolicy
            }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
        };
        ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
            var _this = this;
            (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
            var combinedOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), fetchMoreOptions), {
                variables: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.variables), fetchMoreOptions.variables)
            })), {
                fetchPolicy: 'network-only'
            });
            var qid = this.queryManager.generateQueryId();
            return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
                _this.updateQuery(function(previousResult) {
                    return fetchMoreOptions.updateQuery(previousResult, {
                        fetchMoreResult: fetchMoreResult.data,
                        variables: combinedOptions.variables
                    });
                });
                _this.queryManager.stopQuery(qid);
                return fetchMoreResult;
            }, function(error) {
                _this.queryManager.stopQuery(qid);
                throw error;
            });
        };
        ObservableQuery.prototype.subscribeToMore = function(options) {
            var _this = this;
            var subscription = this.queryManager.startGraphQLSubscription({
                query: options.document,
                variables: options.variables
            }).subscribe({
                next: function(subscriptionData) {
                    var updateQuery = options.updateQuery;
                    if (updateQuery) _this.updateQuery(function(previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables
                        });
                    });
                },
                error: function(err) {
                    if (options.onError) {
                        options.onError(err);
                        return;
                    }
                }
            });
            this.subscriptions.add(subscription);
            return function() {
                if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
            };
        };
        ObservableQuery.prototype.setOptions = function(opts) {
            var oldFetchPolicy = this.options.fetchPolicy;
            this.options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), opts);
            if (opts.pollInterval) this.startPolling(opts.pollInterval);
            else if (opts.pollInterval === 0) this.stopPolling();
            var fetchPolicy = opts.fetchPolicy;
            return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
        };
        ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
            if (tryFetch === void 0) tryFetch = false;
            if (fetchResults === void 0) fetchResults = true;
            this.isTornDown = false;
            variables = variables || this.variables;
            if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
            this.variables = this.options.variables = variables;
            if (!this.observers.size) return Promise.resolve();
            return this.queryManager.fetchQuery(this.queryId, this.options);
        };
        ObservableQuery.prototype.updateQuery = function(mapFn) {
            var queryManager = this.queryManager;
            var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
            var newResult = (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                return mapFn(previousResult, {
                    variables: variables
                });
            });
            if (newResult) {
                queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
                queryManager.broadcastQueries();
            }
        };
        ObservableQuery.prototype.stopPolling = function() {
            this.queryManager.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
        };
        ObservableQuery.prototype.startPolling = function(pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            this.options.pollInterval = pollInterval;
            this.queryManager.startPollingQuery(this.options, this.queryId);
        };
        ObservableQuery.prototype.updateLastResult = function(newResult) {
            var previousResult = this.lastResult;
            this.lastResult = newResult;
            this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, (0, parcelRequire("jojW6")).cloneDeep)(newResult);
            return previousResult;
        };
        ObservableQuery.prototype.onSubscribe = function(observer) {
            var _this = this;
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !this.observers.size;
            this.observers.add(observer);
            if (observer.next && this.lastResult) observer.next(this.lastResult);
            if (observer.error && this.lastError) observer.error(this.lastError);
            if (first) this.setUpQuery();
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        };
        ObservableQuery.prototype.setUpQuery = function() {
            var _this = this;
            var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
            if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
            if (this.options.pollInterval) {
                $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
                queryManager.startPollingQuery(this.options, queryId);
            }
            var onError = function(error) {
                _this.updateLastResult((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, _this.lastResult), {
                    errors: error.graphQLErrors,
                    networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                    loading: false
                }));
                $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
            };
            queryManager.observeQuery(queryId, this.options, {
                next: function(result) {
                    if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                        var previousResult_1 = _this.updateLastResult(result);
                        var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                        if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                            var previousVariables = _this.variables;
                            _this.variables = _this.options.variables = variables;
                            if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                            else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                        });
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    }
                },
                error: onError
            }).catch(onError);
        };
        ObservableQuery.prototype.tearDownQuery = function() {
            var queryManager = this.queryManager;
            this.isTornDown = true;
            queryManager.stopPollingQuery(this.queryId);
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this.subscriptions.clear();
            queryManager.removeObservableQuery(this.queryId);
            queryManager.stopQuery(this.queryId);
            this.observers.clear();
        };
        return ObservableQuery;
    }($02a3c2aebc919401$var$Observable);
    function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
    function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
        var observersWithMethod = [];
        observers.forEach(function(obs) {
            return obs[method] && observersWithMethod.push(obs);
        });
        observersWithMethod.forEach(function(obs) {
            return obs[method](argument);
        });
    }
    function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
        var fetchPolicy = obsQuery.options.fetchPolicy;
        (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
    }
    var $02a3c2aebc919401$var$MutationStore = function() {
        function MutationStore() {
            this.store = {};
        }
        MutationStore.prototype.getStore = function() {
            return this.store;
        };
        MutationStore.prototype.get = function(mutationId) {
            return this.store[mutationId];
        };
        MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
            this.store[mutationId] = {
                mutation: mutation,
                variables: variables || {},
                loading: true,
                error: null
            };
        };
        MutationStore.prototype.markMutationError = function(mutationId, error) {
            var mutation = this.store[mutationId];
            if (mutation) {
                mutation.loading = false;
                mutation.error = error;
            }
        };
        MutationStore.prototype.markMutationResult = function(mutationId) {
            var mutation = this.store[mutationId];
            if (mutation) {
                mutation.loading = false;
                mutation.error = null;
            }
        };
        MutationStore.prototype.reset = function() {
            this.store = {};
        };
        return MutationStore;
    }();
    var $02a3c2aebc919401$var$QueryStore = function() {
        function QueryStore() {
            this.store = {};
        }
        QueryStore.prototype.getStore = function() {
            return this.store;
        };
        QueryStore.prototype.get = function(queryId) {
            return this.store[queryId];
        };
        QueryStore.prototype.initQuery = function(query) {
            var previousQuery = this.store[query.queryId];
            (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
            var isSetVariables = false;
            var previousVariables = null;
            if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
                if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                    isSetVariables = true;
                    previousVariables = previousQuery.variables;
                }
            }
            var networkStatus;
            if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
            else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
            else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
            else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
            var graphQLErrors = [];
            if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
            this.store[query.queryId] = {
                document: query.document,
                variables: query.variables,
                previousVariables: previousVariables,
                networkError: null,
                graphQLErrors: graphQLErrors,
                networkStatus: networkStatus,
                metadata: query.metadata
            };
            if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
        };
        QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
            if (!this.store || !this.store[queryId]) return;
            this.store[queryId].networkError = null;
            this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
            this.store[queryId].previousVariables = null;
            this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
            if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        };
        QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
            if (!this.store || !this.store[queryId]) return;
            this.store[queryId].networkError = error;
            this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
            if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
        };
        QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
            var storeValue = this.store && this.store[queryId];
            if (storeValue) {
                storeValue.networkError = null;
                storeValue.previousVariables = null;
                if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
            }
        };
        QueryStore.prototype.stopQuery = function(queryId) {
            delete this.store[queryId];
        };
        QueryStore.prototype.reset = function(observableQueryIds) {
            var _this = this;
            Object.keys(this.store).forEach(function(queryId) {
                if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
                else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
            });
        };
        return QueryStore;
    }();
    function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    var $02a3c2aebc919401$var$LocalState = function() {
        function LocalState(_a) {
            var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
            this.cache = cache;
            if (client) this.client = client;
            if (resolvers) this.addResolvers(resolvers);
            if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
        }
        LocalState.prototype.addResolvers = function(resolvers) {
            var _this = this;
            this.resolvers = this.resolvers || {};
            if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
                _this.resolvers = (0, (0, parcelRequire("jojW6")).mergeDeep)(_this.resolvers, resolverGroup);
            });
            else this.resolvers = (0, (0, parcelRequire("jojW6")).mergeDeep)(this.resolvers, resolvers);
        };
        LocalState.prototype.setResolvers = function(resolvers) {
            this.resolvers = {};
            this.addResolvers(resolvers);
        };
        LocalState.prototype.getResolvers = function() {
            return this.resolvers || {};
        };
        LocalState.prototype.runResolvers = function(_a) {
            var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_c) {
                    if (document) return [
                        2,
                        this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, remoteResult), {
                                data: localResult.result
                            });
                        })
                    ];
                    return [
                        2,
                        remoteResult
                    ];
                });
            });
        };
        LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
            this.fragmentMatcher = fragmentMatcher;
        };
        LocalState.prototype.getFragmentMatcher = function() {
            return this.fragmentMatcher;
        };
        LocalState.prototype.clientQuery = function(document) {
            if ((0, (0, parcelRequire("jojW6")).hasDirectives)([
                'client'
            ], document)) {
                if (this.resolvers) return document;
            }
            return null;
        };
        LocalState.prototype.serverQuery = function(document) {
            return this.resolvers ? (0, (0, parcelRequire("jojW6")).removeClientSetsFromDocument)(document) : document;
        };
        LocalState.prototype.prepareContext = function(context) {
            if (context === void 0) context = {};
            var cache = this.cache;
            var newContext = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                cache: cache,
                getCacheKey: function(obj) {
                    if (cache.config) return cache.config.dataIdFromObject(obj);
                    else (0, $1DiV8.invariant)(false, 6);
                }
            });
            return newContext;
        };
        LocalState.prototype.addExportedVariables = function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    if (document) return [
                        2,
                        this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, variables), data.exportedVariables);
                        })
                    ];
                    return [
                        2,
                        (0, (0, parcelRequire("3VFsf")).__assign)({}, variables)
                    ];
                });
            });
        };
        LocalState.prototype.shouldForceResolvers = function(document) {
            var forceResolvers = false;
            (0, (0, parcelRequire("12QNw")).visit)(document, {
                Directive: {
                    enter: function(node) {
                        if (node.name.value === 'client' && node.arguments) {
                            forceResolvers = node.arguments.some(function(arg) {
                                return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                            });
                            if (forceResolvers) return 0, (0, parcelRequire("12QNw")).BREAK;
                        }
                    }
                }
            });
            return forceResolvers;
        };
        LocalState.prototype.buildRootValueFromCache = function(document, variables) {
            return this.cache.diff({
                query: (0, (0, parcelRequire("jojW6")).buildQueryFromSelectionSet)(document),
                variables: variables,
                returnPartialData: true,
                optimistic: false
            }).result;
        };
        LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                    mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(document);
                    fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document);
                    fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
                    definitionOperation = mainDefinition.operation;
                    defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                    _a = this, cache = _a.cache, client = _a.client;
                    execContext = {
                        fragmentMap: fragmentMap,
                        context: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                            cache: cache,
                            client: client
                        }),
                        variables: variables,
                        fragmentMatcher: fragmentMatcher,
                        defaultOperationType: defaultOperationType,
                        exportedVariables: {},
                        onlyRunForcedResolvers: onlyRunForcedResolvers
                    };
                    return [
                        2,
                        this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                            return {
                                result: result,
                                exportedVariables: execContext.exportedVariables
                            };
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var fragmentMap, context, variables, resultsToMerge, execute;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                    resultsToMerge = [
                        rootValue
                    ];
                    execute = function(selection) {
                        return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                            var fragment, typeCondition;
                            return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return [
                                    2
                                ];
                                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) return [
                                    2,
                                    this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                        var _a;
                                        if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                                    })
                                ];
                                if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                                else {
                                    fragment = fragmentMap[selection.name.value];
                                    (0, $1DiV8.invariant)(fragment, 7);
                                }
                                if (fragment && fragment.typeCondition) {
                                    typeCondition = fragment.typeCondition.name.value;
                                    if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                        2,
                                        this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                            resultsToMerge.push(fragmentResult);
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                            });
                        });
                    };
                    return [
                        2,
                        Promise.all(selectionSet.selections.map(execute)).then(function() {
                            return (0, (0, parcelRequire("jojW6")).mergeDeepArray)(resultsToMerge);
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveField = function(field, rootValue, execContext) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    variables = execContext.variables;
                    fieldName = field.name.value;
                    aliasedFieldName = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field);
                    aliasUsed = fieldName !== aliasedFieldName;
                    defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                    resultPromise = Promise.resolve(defaultResult);
                    if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                        resolverType = rootValue.__typename || execContext.defaultOperationType;
                        resolverMap = this.resolvers && this.resolvers[resolverType];
                        if (resolverMap) {
                            resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                            if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables), execContext.context, {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }));
                        }
                    }
                    return [
                        2,
                        resultPromise.then(function(result) {
                            if (result === void 0) result = defaultResult;
                            if (field.directives) field.directives.forEach(function(directive) {
                                if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                    if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                                });
                            });
                            if (!field.selectionSet) return result;
                            if (result == null) return result;
                            if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
            var _this = this;
            return Promise.all(result.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
                if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }));
        };
        return LocalState;
    }();
    function $02a3c2aebc919401$var$multiplex(inner) {
        var observers = new Set();
        var sub = null;
        return new $02a3c2aebc919401$var$Observable(function(observer) {
            observers.add(observer);
            sub = sub || inner.subscribe({
                next: function(value) {
                    observers.forEach(function(obs) {
                        return obs.next && obs.next(value);
                    });
                },
                error: function(error) {
                    observers.forEach(function(obs) {
                        return obs.error && obs.error(error);
                    });
                },
                complete: function() {
                    observers.forEach(function(obs) {
                        return obs.complete && obs.complete();
                    });
                }
            });
            return function() {
                if (observers.delete(observer) && !observers.size && sub) {
                    sub.unsubscribe();
                    sub = null;
                }
            };
        });
    }
    function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
        return new $02a3c2aebc919401$var$Observable(function(observer) {
            var next = observer.next, error = observer.error, complete = observer.complete;
            var activeNextCount = 0;
            var completed = false;
            var handler = {
                next: function(value) {
                    ++activeNextCount;
                    new Promise(function(resolve) {
                        resolve(mapFn(value));
                    }).then(function(result) {
                        --activeNextCount;
                        next && next.call(observer, result);
                        completed && handler.complete();
                    }, function(e) {
                        --activeNextCount;
                        error && error.call(observer, e);
                    });
                },
                error: function(e) {
                    error && error.call(observer, e);
                },
                complete: function() {
                    completed = true;
                    if (!activeNextCount) complete && complete.call(observer);
                }
            };
            var sub = observable.subscribe(handler);
            return function() {
                return sub.unsubscribe();
            };
        });
    }
    var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $02a3c2aebc919401$var$QueryManager = function() {
        function QueryManager(_a) {
            var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
                return undefined;
            } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
            this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
            this.queryStore = new $02a3c2aebc919401$var$QueryStore();
            this.clientAwareness = {};
            this.idCounter = 1;
            this.queries = new Map();
            this.fetchQueryRejectFns = new Map();
            this.transformCache = new ((0, (0, parcelRequire("jojW6")).canUseWeakMap) ? WeakMap : Map)();
            this.inFlightLinkObservables = new Map();
            this.pollingInfoByQueryId = new Map();
            this.link = link;
            this.queryDeduplication = queryDeduplication;
            this.dataStore = store;
            this.onBroadcast = onBroadcast;
            this.clientAwareness = clientAwareness;
            this.localState = localState || new $02a3c2aebc919401$var$LocalState({
                cache: store.getCache()
            });
            this.ssrMode = ssrMode;
            this.assumeImmutableResults = !!assumeImmutableResults;
        }
        QueryManager.prototype.stop = function() {
            var _this = this;
            this.queries.forEach(function(_info, queryId) {
                _this.stopQueryNoBroadcast(queryId);
            });
            this.fetchQueryRejectFns.forEach(function(reject) {
                reject(new (0, $1DiV8.InvariantError)(8));
            });
        };
        QueryManager.prototype.mutate = function(_a) {
            var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var mutationId, generateUpdateQueriesInfo, self;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            (0, $1DiV8.invariant)(mutation, 9);
                            (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                            mutationId = this.generateQueryId();
                            mutation = this.transform(mutation).document;
                            this.setQuery(mutationId, function() {
                                return {
                                    document: mutation
                                };
                            });
                            variables = this.getVariables(mutation, variables);
                            if (!this.transform(mutation).hasClientExports) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.localState.addExportedVariables(mutation, variables, context)
                            ];
                        case 1:
                            variables = _f.sent();
                            _f.label = 2;
                        case 2:
                            generateUpdateQueriesInfo = function() {
                                var ret = {};
                                if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                    var observableQuery = _a.observableQuery;
                                    if (observableQuery) {
                                        var queryName = observableQuery.queryName;
                                        if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                            updater: updateQueriesByName[queryName],
                                            query: _this.queryStore.get(queryId)
                                        };
                                    }
                                });
                                return ret;
                            };
                            this.mutationStore.initMutation(mutationId, mutation, variables);
                            this.dataStore.markMutationInit({
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                updateQueries: generateUpdateQueriesInfo(),
                                update: updateWithProxyFn,
                                optimisticResponse: optimisticResponse
                            });
                            this.broadcastQueries();
                            self = this;
                            return [
                                2,
                                new Promise(function(resolve, reject) {
                                    var storeResult;
                                    var error;
                                    self.getObservableFromLink(mutation, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                                        optimisticResponse: optimisticResponse
                                    }), variables, false).subscribe({
                                        next: function(result) {
                                            if ((0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result) && errorPolicy === 'none') {
                                                error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                    graphQLErrors: result.errors
                                                });
                                                return;
                                            }
                                            self.mutationStore.markMutationResult(mutationId);
                                            if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                updateQueries: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn
                                            });
                                            storeResult = result;
                                        },
                                        error: function(err) {
                                            self.mutationStore.markMutationError(mutationId, err);
                                            self.dataStore.markMutationComplete({
                                                mutationId: mutationId,
                                                optimisticResponse: optimisticResponse
                                            });
                                            self.broadcastQueries();
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                                networkError: err
                                            }));
                                        },
                                        complete: function() {
                                            if (error) self.mutationStore.markMutationError(mutationId, error);
                                            self.dataStore.markMutationComplete({
                                                mutationId: mutationId,
                                                optimisticResponse: optimisticResponse
                                            });
                                            self.broadcastQueries();
                                            if (error) {
                                                reject(error);
                                                return;
                                            }
                                            if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                            var refetchQueryPromises = [];
                                            if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                                if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                    var observableQuery = _a.observableQuery;
                                                    if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                                });
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only'
                                                    };
                                                    if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                            Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                                self.setQuery(mutationId, function() {
                                                    return {
                                                        document: null
                                                    };
                                                });
                                                if (errorPolicy === 'ignore' && storeResult && (0, (0, parcelRequire("jojW6")).graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                                resolve(storeResult);
                                            });
                                        }
                                    });
                                })
                            ];
                    }
                });
            });
        };
        QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                            query = this.transform(options.query).document;
                            variables = this.getVariables(query, options.variables);
                            if (!this.transform(query).hasClientExports) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.localState.addExportedVariables(query, variables, context)
                            ];
                        case 1:
                            variables = _e.sent();
                            _e.label = 2;
                        case 2:
                            options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                                variables: variables
                            });
                            isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                            needToFetch = isNetworkOnly;
                            if (!isNetworkOnly) {
                                _d = this.dataStore.getCache().diff({
                                    query: query,
                                    variables: variables,
                                    returnPartialData: true,
                                    optimistic: false
                                }), complete = _d.complete, result = _d.result;
                                needToFetch = !complete || fetchPolicy === 'cache-and-network';
                                storeResult = result;
                            }
                            shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                            if ((0, (0, parcelRequire("jojW6")).hasDirectives)([
                                'live'
                            ], query)) shouldFetch = true;
                            requestId = this.idCounter++;
                            cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                            this.setQuery(queryId, function() {
                                return {
                                    document: query,
                                    lastRequestId: requestId,
                                    invalidated: true,
                                    cancel: cancel
                                };
                            });
                            this.invalidate(fetchMoreForQueryId);
                            this.queryStore.initQuery({
                                queryId: queryId,
                                document: query,
                                storePreviousVariables: shouldFetch,
                                variables: variables,
                                isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                                isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                                metadata: metadata,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            });
                            this.broadcastQueries();
                            if (shouldFetch) {
                                networkResult = this.fetchRequest({
                                    requestId: requestId,
                                    queryId: queryId,
                                    document: query,
                                    options: options,
                                    fetchMoreForQueryId: fetchMoreForQueryId
                                }).catch(function(error) {
                                    if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                    else {
                                        if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                            _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                            _this.invalidate(queryId);
                                            _this.invalidate(fetchMoreForQueryId);
                                            _this.broadcastQueries();
                                        }
                                        throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: error
                                        });
                                    }
                                });
                                if (fetchPolicy !== 'cache-and-network') return [
                                    2,
                                    networkResult
                                ];
                                networkResult.catch(function() {});
                            }
                            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                            this.invalidate(queryId);
                            this.invalidate(fetchMoreForQueryId);
                            if (this.transform(query).hasForcedResolvers) return [
                                2,
                                this.localState.runResolvers({
                                    document: query,
                                    remoteResult: {
                                        data: storeResult
                                    },
                                    context: context,
                                    variables: variables,
                                    onlyRunForcedResolvers: true
                                }).then(function(result) {
                                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                    _this.broadcastQueries();
                                    return result;
                                })
                            ];
                            this.broadcastQueries();
                            return [
                                2,
                                {
                                    data: storeResult
                                }
                            ];
                    }
                });
            });
        };
        QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
            var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
            if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
                return {
                    newData: {
                        result: result.data,
                        complete: true
                    }
                };
            });
            else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
        };
        QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
            var _this = this;
            function invoke(method, argument) {
                if (observer[method]) try {
                    observer[method](argument);
                } catch (e) {}
                else method;
            }
            return function(queryStoreValue, newData) {
                _this.invalidate(queryId, false);
                if (!queryStoreValue) return;
                var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
                var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
                if (fetchPolicy === 'standby') return;
                var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
                var lastResult = observableQuery && observableQuery.getLastResult();
                var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
                var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
                if (loading && !shouldNotifyIfLoading) return;
                var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
                var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
                if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                }));
                try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                            return {
                                newData: null
                            };
                        });
                        data = newData.result;
                        isMissing = !newData.complete;
                    } else {
                        var lastError = observableQuery && observableQuery.getLastError();
                        var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                        if (lastResult && lastResult.data && !errorStatusChanged) {
                            data = lastResult.data;
                            isMissing = false;
                        } else {
                            var diffResult = _this.dataStore.getCache().diff({
                                query: document,
                                variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                                returnPartialData: true,
                                optimistic: true
                            });
                            data = diffResult.result;
                            isMissing = !diffResult.complete;
                        }
                    }
                    var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                    var resultFromStore = {
                        data: stale ? lastResult && lastResult.data : data,
                        loading: loading,
                        networkStatus: queryStoreValue.networkStatus,
                        stale: stale
                    };
                    if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                    invoke('next', resultFromStore);
                } catch (networkError) {
                    invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                        networkError: networkError
                    }));
                }
            };
        };
        QueryManager.prototype.transform = function(document) {
            var transformCache = this.transformCache;
            if (!transformCache.has(document)) {
                var cache = this.dataStore.getCache();
                var transformed = cache.transformDocument(document);
                var forLink = (0, (0, parcelRequire("jojW6")).removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
                var clientQuery = this.localState.clientQuery(transformed);
                var serverQuery = this.localState.serverQuery(forLink);
                var cacheEntry_1 = {
                    document: transformed,
                    hasClientExports: (0, (0, parcelRequire("jojW6")).hasClientExports)(transformed),
                    hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                    clientQuery: clientQuery,
                    serverQuery: serverQuery,
                    defaultVars: (0, (0, parcelRequire("jojW6")).getDefaultValues)((0, (0, parcelRequire("jojW6")).getOperationDefinition)(transformed))
                };
                var add = function(doc) {
                    if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
                };
                add(document);
                add(transformed);
                add(clientQuery);
                add(serverQuery);
            }
            return transformCache.get(document);
        };
        QueryManager.prototype.getVariables = function(document, variables) {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.transform(document).defaultVars), variables);
        };
        QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
            if (shouldSubscribe === void 0) shouldSubscribe = true;
            (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
            options.variables = this.getVariables(options.query, options.variables);
            if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
            var transformedOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, options);
            return new $02a3c2aebc919401$export$6c1b56eac59c9584({
                queryManager: this,
                options: transformedOptions,
                shouldSubscribe: shouldSubscribe
            });
        };
        QueryManager.prototype.query = function(options) {
            var _this = this;
            (0, $1DiV8.invariant)(options.query, 12);
            (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
            (0, $1DiV8.invariant)(!options.returnPartialData, 14);
            (0, $1DiV8.invariant)(!options.pollInterval, 15);
            return new Promise(function(resolve, reject) {
                var watchedQuery = _this.watchQuery(options, false);
                _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
                watchedQuery.result().then(resolve, reject).then(function() {
                    return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
                });
            });
        };
        QueryManager.prototype.generateQueryId = function() {
            return String(this.idCounter++);
        };
        QueryManager.prototype.stopQueryInStore = function(queryId) {
            this.stopQueryInStoreNoBroadcast(queryId);
            this.broadcastQueries();
        };
        QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
            this.stopPollingQuery(queryId);
            this.queryStore.stopQuery(queryId);
            this.invalidate(queryId);
        };
        QueryManager.prototype.addQueryListener = function(queryId, listener) {
            this.setQuery(queryId, function(_a) {
                var listeners = _a.listeners;
                listeners.add(listener);
                return {
                    invalidated: false
                };
            });
        };
        QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
            var _this = this;
            var cancel = this.getQuery(queryId).cancel;
            if (cancel) cancel();
            var previousResult = function() {
                var previousResult = null;
                var observableQuery = _this.getQuery(queryId).observableQuery;
                if (observableQuery) {
                    var lastResult = observableQuery.getLastResult();
                    if (lastResult) previousResult = lastResult.data;
                }
                return previousResult;
            };
            return this.dataStore.getCache().watch({
                query: document,
                variables: options.variables,
                optimistic: true,
                previousResult: previousResult,
                callback: function(newData) {
                    _this.setQuery(queryId, function() {
                        return {
                            invalidated: true,
                            newData: newData
                        };
                    });
                }
            });
        };
        QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
            this.setQuery(queryId, function() {
                return {
                    observableQuery: observableQuery
                };
            });
        };
        QueryManager.prototype.removeObservableQuery = function(queryId) {
            var cancel = this.getQuery(queryId).cancel;
            this.setQuery(queryId, function() {
                return {
                    observableQuery: null
                };
            });
            if (cancel) cancel();
        };
        QueryManager.prototype.clearStore = function() {
            this.fetchQueryRejectFns.forEach(function(reject) {
                reject(new (0, $1DiV8.InvariantError)(16));
            });
            var resetIds = [];
            this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                if (observableQuery) resetIds.push(queryId);
            });
            this.queryStore.reset(resetIds);
            this.mutationStore.reset();
            return this.dataStore.reset();
        };
        QueryManager.prototype.resetStore = function() {
            var _this = this;
            return this.clearStore().then(function() {
                return _this.reFetchObservableQueries();
            });
        };
        QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
            var _this = this;
            if (includeStandby === void 0) includeStandby = false;
            var observableQueryPromises = [];
            this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                if (observableQuery) {
                    var fetchPolicy = observableQuery.options.fetchPolicy;
                    observableQuery.resetLastResults();
                    if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                    _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    _this.invalidate(queryId);
                }
            });
            this.broadcastQueries();
            return Promise.all(observableQueryPromises);
        };
        QueryManager.prototype.observeQuery = function(queryId, options, observer) {
            this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
            return this.fetchQuery(queryId, options);
        };
        QueryManager.prototype.startQuery = function(queryId, options, listener) {
            this.addQueryListener(queryId, listener);
            this.fetchQuery(queryId, options).catch(function() {
                return undefined;
            });
            return queryId;
        };
        QueryManager.prototype.startGraphQLSubscription = function(_a) {
            var _this = this;
            var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
            query = this.transform(query).document;
            variables = this.getVariables(query, variables);
            var makeObservable = function(variables) {
                return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                    if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                        _this.dataStore.markSubscriptionResult(result, query, variables);
                        _this.broadcastQueries();
                    }
                    if ((0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: result.errors
                    });
                    return result;
                });
            };
            if (this.transform(query).hasClientExports) {
                var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
                return new $02a3c2aebc919401$var$Observable(function(observer) {
                    var sub = null;
                    observablePromise_1.then(function(observable) {
                        return sub = observable.subscribe(observer);
                    }, observer.error);
                    return function() {
                        return sub && sub.unsubscribe();
                    };
                });
            }
            return makeObservable(variables);
        };
        QueryManager.prototype.stopQuery = function(queryId) {
            this.stopQueryNoBroadcast(queryId);
            this.broadcastQueries();
        };
        QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
            this.stopQueryInStoreNoBroadcast(queryId);
            this.removeQuery(queryId);
        };
        QueryManager.prototype.removeQuery = function(queryId) {
            this.fetchQueryRejectFns.delete("query:" + queryId);
            this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
            this.getQuery(queryId).subscriptions.forEach(function(x) {
                return x.unsubscribe();
            });
            this.queries.delete(queryId);
        };
        QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
            if (optimistic === void 0) optimistic = true;
            var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
            var lastResult = observableQuery.getLastResult();
            var newData = this.getQuery(observableQuery.queryId).newData;
            if (newData && newData.complete) return {
                data: newData.result,
                partial: false
            };
            if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
                data: undefined,
                partial: false
            };
            var _b = this.dataStore.getCache().diff({
                query: query,
                variables: variables,
                previousResult: lastResult ? lastResult.data : undefined,
                returnPartialData: true,
                optimistic: optimistic
            }), result = _b.result, complete = _b.complete;
            return {
                data: complete || returnPartialData ? result : void 0,
                partial: !complete
            };
        };
        QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
            var observableQuery;
            if (typeof queryIdOrObservable === 'string') {
                var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
                (0, $1DiV8.invariant)(foundObserveableQuery, 17);
                observableQuery = foundObserveableQuery;
            } else observableQuery = queryIdOrObservable;
            var _a = observableQuery.options, variables = _a.variables, query = _a.query;
            return {
                previousResult: this.getCurrentQueryResult(observableQuery, false).data,
                variables: variables,
                document: query
            };
        };
        QueryManager.prototype.broadcastQueries = function() {
            var _this = this;
            this.onBroadcast();
            this.queries.forEach(function(info, id) {
                if (info.invalidated) info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
            });
        };
        QueryManager.prototype.getLocalState = function() {
            return this.localState;
        };
        QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
            var _this = this;
            if (deduplication === void 0) deduplication = this.queryDeduplication;
            var observable;
            var serverQuery = this.transform(query).serverQuery;
            if (serverQuery) {
                var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
                var operation = {
                    query: serverQuery,
                    variables: variables,
                    operationName: (0, (0, parcelRequire("jojW6")).getOperationName)(serverQuery) || void 0,
                    context: this.prepareContext((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                        forceFetch: !deduplication
                    }))
                };
                context = operation.context;
                if (deduplication) {
                    var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                    inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                    var varJson_1 = JSON.stringify(variables);
                    observable = byVariables_1.get(varJson_1);
                    if (!observable) {
                        byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, (0, parcelRequire("clSzL")).execute)(link, operation)));
                        var cleanup = function() {
                            byVariables_1.delete(varJson_1);
                            if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                            cleanupSub_1.unsubscribe();
                        };
                        var cleanupSub_1 = observable.subscribe({
                            next: cleanup,
                            error: cleanup,
                            complete: cleanup
                        });
                    }
                } else observable = $02a3c2aebc919401$var$multiplex((0, (0, parcelRequire("clSzL")).execute)(link, operation));
            } else {
                observable = $02a3c2aebc919401$var$Observable.of({
                    data: {}
                });
                context = this.prepareContext(context);
            }
            var clientQuery = this.transform(query).clientQuery;
            if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables
                });
            });
            return observable;
        };
        QueryManager.prototype.fetchRequest = function(_a) {
            var _this = this;
            var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
            var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
            var resultFromStore;
            var errorsFromStore;
            return new Promise(function(resolve, reject) {
                var observable = _this.getObservableFromLink(document, options.context, variables);
                var fqrfId = "fetchRequest:" + queryId;
                _this.fetchQueryRejectFns.set(fqrfId, reject);
                var cleanup = function() {
                    _this.fetchQueryRejectFns.delete(fqrfId);
                    _this.setQuery(queryId, function(_a) {
                        var subscriptions = _a.subscriptions;
                        subscriptions.delete(subscription);
                    });
                };
                var subscription = observable.map(function(result) {
                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                        _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                        _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                        _this.invalidate(queryId);
                        _this.invalidate(fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: result.errors
                    }));
                    if (errorPolicy === 'all') errorsFromStore = result.errors;
                    if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                    else {
                        var _a = _this.dataStore.getCache().diff({
                            variables: variables,
                            query: document,
                            optimistic: false,
                            returnPartialData: true
                        }), result_1 = _a.result, complete = _a.complete;
                        if (complete || options.returnPartialData) resultFromStore = result_1;
                    }
                }).subscribe({
                    error: function(error) {
                        cleanup();
                        reject(error);
                    },
                    complete: function() {
                        cleanup();
                        resolve({
                            data: resultFromStore,
                            errors: errorsFromStore,
                            loading: false,
                            networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                            stale: false
                        });
                    }
                });
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.add(subscription);
                });
            });
        };
        QueryManager.prototype.getQuery = function(queryId) {
            return this.queries.get(queryId) || {
                listeners: new Set(),
                invalidated: false,
                document: null,
                newData: null,
                lastRequestId: 1,
                observableQuery: null,
                subscriptions: new Set()
            };
        };
        QueryManager.prototype.setQuery = function(queryId, updater) {
            var prev = this.getQuery(queryId);
            var newInfo = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, prev), updater(prev));
            this.queries.set(queryId, newInfo);
        };
        QueryManager.prototype.invalidate = function(queryId, invalidated) {
            if (invalidated === void 0) invalidated = true;
            if (queryId) this.setQuery(queryId, function() {
                return {
                    invalidated: invalidated
                };
            });
        };
        QueryManager.prototype.prepareContext = function(context) {
            if (context === void 0) context = {};
            var newContext = this.localState.prepareContext(context);
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, newContext), {
                clientAwareness: this.clientAwareness
            });
        };
        QueryManager.prototype.checkInFlight = function(queryId) {
            var query = this.queryStore.get(queryId);
            return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        };
        QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
            var _this = this;
            var pollInterval = options.pollInterval;
            (0, $1DiV8.invariant)(pollInterval, 18);
            if (!this.ssrMode) {
                var info = this.pollingInfoByQueryId.get(queryId);
                if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
                info.interval = pollInterval;
                info.options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                    fetchPolicy: 'network-only'
                });
                var maybeFetch_1 = function() {
                    var info = _this.pollingInfoByQueryId.get(queryId);
                    if (info) {
                        if (_this.checkInFlight(queryId)) poll_1();
                        else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                    }
                };
                var poll_1 = function() {
                    var info = _this.pollingInfoByQueryId.get(queryId);
                    if (info) {
                        clearTimeout(info.timeout);
                        info.timeout = setTimeout(maybeFetch_1, info.interval);
                    }
                };
                if (listener) this.addQueryListener(queryId, listener);
                poll_1();
            }
            return queryId;
        };
        QueryManager.prototype.stopPollingQuery = function(queryId) {
            this.pollingInfoByQueryId.delete(queryId);
        };
        return QueryManager;
    }();
    var $02a3c2aebc919401$var$DataStore = function() {
        function DataStore(initialCache) {
            this.cache = initialCache;
        }
        DataStore.prototype.getCache = function() {
            return this.cache;
        };
        DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
            if (ignoreErrors === void 0) ignoreErrors = false;
            var writeWithErrors = !(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result);
            if (ignoreErrors && (0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result) && result.data) writeWithErrors = true;
            if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables
            });
        };
        DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
            if (!(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result)) this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables
            });
        };
        DataStore.prototype.markMutationInit = function(mutation) {
            var _this = this;
            if (mutation.optimisticResponse) {
                var optimistic_1;
                if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
                else optimistic_1 = mutation.optimisticResponse;
                this.cache.recordOptimisticTransaction(function(c) {
                    var orig = _this.cache;
                    _this.cache = c;
                    try {
                        _this.markMutationResult({
                            mutationId: mutation.mutationId,
                            result: {
                                data: optimistic_1
                            },
                            document: mutation.document,
                            variables: mutation.variables,
                            updateQueries: mutation.updateQueries,
                            update: mutation.update
                        });
                    } finally{
                        _this.cache = orig;
                    }
                }, mutation.mutationId);
            }
        };
        DataStore.prototype.markMutationResult = function(mutation) {
            var _this = this;
            if (!(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(mutation.result)) {
                var cacheWrites_1 = [
                    {
                        result: mutation.result.data,
                        dataId: 'ROOT_MUTATION',
                        query: mutation.document,
                        variables: mutation.variables
                    }
                ];
                var updateQueries_1 = mutation.updateQueries;
                if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                    var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (complete) {
                        var nextQueryResult = (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                            return updater(currentQueryResult, {
                                mutationResult: mutation.result,
                                queryName: (0, (0, parcelRequire("jojW6")).getOperationName)(query.document) || undefined,
                                queryVariables: query.variables
                            });
                        });
                        if (nextQueryResult) cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables
                        });
                    }
                });
                this.cache.performTransaction(function(c) {
                    cacheWrites_1.forEach(function(write) {
                        return c.write(write);
                    });
                    var update = mutation.update;
                    if (update) (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                        return update(c, mutation.result);
                    });
                });
            }
        };
        DataStore.prototype.markMutationComplete = function(_a) {
            var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
            if (optimisticResponse) this.cache.removeOptimistic(mutationId);
        };
        DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
            this.cache.write({
                result: newResult,
                dataId: 'ROOT_QUERY',
                variables: variables,
                query: document
            });
        };
        DataStore.prototype.reset = function() {
            return this.cache.reset();
        };
        return DataStore;
    }();
    var $02a3c2aebc919401$var$version = "2.6.10";
    var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
    var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
        function ApolloClient(options) {
            var _this = this;
            this.defaultOptions = {};
            this.resetStoreCallbacks = [];
            this.clearStoreCallbacks = [];
            var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
            var link = options.link;
            if (!link && resolvers) link = (0, (0, parcelRequire("clSzL")).ApolloLink).empty();
            if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
            this.link = link;
            this.cache = cache;
            this.store = new $02a3c2aebc919401$var$DataStore(cache);
            this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
            this.queryDeduplication = queryDeduplication;
            this.defaultOptions = defaultOptions || {};
            this.typeDefs = typeDefs;
            if (ssrForceFetchDelay) setTimeout(function() {
                return _this.disableNetworkFetches = false;
            }, ssrForceFetchDelay);
            this.watchQuery = this.watchQuery.bind(this);
            this.query = this.query.bind(this);
            this.mutate = this.mutate.bind(this);
            this.resetStore = this.resetStore.bind(this);
            this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
            var defaultConnectToDevTools = false;
            if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
            this.version = $02a3c2aebc919401$var$version;
            this.localState = new $02a3c2aebc919401$var$LocalState({
                cache: cache,
                client: this,
                resolvers: resolvers,
                fragmentMatcher: fragmentMatcher
            });
            this.queryManager = new $02a3c2aebc919401$var$QueryManager({
                link: this.link,
                store: this.store,
                queryDeduplication: queryDeduplication,
                ssrMode: ssrMode,
                clientAwareness: {
                    name: clientAwarenessName,
                    version: clientAwarenessVersion
                },
                localState: this.localState,
                assumeImmutableResults: assumeImmutableResults,
                onBroadcast: function() {
                    if (_this.devToolsHookCb) _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore()
                        },
                        dataWithOptimisticResults: _this.cache.extract(true)
                    });
                }
            });
        }
        ApolloClient.prototype.stop = function() {
            this.queryManager.stop();
        };
        ApolloClient.prototype.watchQuery = function(options) {
            if (this.defaultOptions.watchQuery) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.watchQuery), options);
            if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                fetchPolicy: 'cache-first'
            });
            return this.queryManager.watchQuery(options);
        };
        ApolloClient.prototype.query = function(options) {
            if (this.defaultOptions.query) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.query), options);
            (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
            if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                fetchPolicy: 'cache-first'
            });
            return this.queryManager.query(options);
        };
        ApolloClient.prototype.mutate = function(options) {
            if (this.defaultOptions.mutate) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.mutate), options);
            return this.queryManager.mutate(options);
        };
        ApolloClient.prototype.subscribe = function(options) {
            return this.queryManager.startGraphQLSubscription(options);
        };
        ApolloClient.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.cache.readQuery(options, optimistic);
        };
        ApolloClient.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.cache.readFragment(options, optimistic);
        };
        ApolloClient.prototype.writeQuery = function(options) {
            var result = this.cache.writeQuery(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.writeFragment = function(options) {
            var result = this.cache.writeFragment(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.writeData = function(options) {
            var result = this.cache.writeData(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.__actionHookForDevTools = function(cb) {
            this.devToolsHookCb = cb;
        };
        ApolloClient.prototype.__requestRaw = function(payload) {
            return (0, (0, parcelRequire("clSzL")).execute)(this.link, payload);
        };
        ApolloClient.prototype.initQueryManager = function() {
            return this.queryManager;
        };
        ApolloClient.prototype.resetStore = function() {
            var _this = this;
            return Promise.resolve().then(function() {
                return _this.queryManager.clearStore();
            }).then(function() {
                return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                    return fn();
                }));
            }).then(function() {
                return _this.reFetchObservableQueries();
            });
        };
        ApolloClient.prototype.clearStore = function() {
            var _this = this;
            return Promise.resolve().then(function() {
                return _this.queryManager.clearStore();
            }).then(function() {
                return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                    return fn();
                }));
            });
        };
        ApolloClient.prototype.onResetStore = function(cb) {
            var _this = this;
            this.resetStoreCallbacks.push(cb);
            return function() {
                _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                    return c !== cb;
                });
            };
        };
        ApolloClient.prototype.onClearStore = function(cb) {
            var _this = this;
            this.clearStoreCallbacks.push(cb);
            return function() {
                _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                    return c !== cb;
                });
            };
        };
        ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
            return this.queryManager.reFetchObservableQueries(includeStandby);
        };
        ApolloClient.prototype.extract = function(optimistic) {
            return this.cache.extract(optimistic);
        };
        ApolloClient.prototype.restore = function(serializedState) {
            return this.cache.restore(serializedState);
        };
        ApolloClient.prototype.addResolvers = function(resolvers) {
            this.localState.addResolvers(resolvers);
        };
        ApolloClient.prototype.setResolvers = function(resolvers) {
            this.localState.setResolvers(resolvers);
        };
        ApolloClient.prototype.getResolvers = function() {
            return this.localState.getResolvers();
        };
        ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
            this.localState.setFragmentMatcher(fragmentMatcher);
        };
        return ApolloClient;
    }();
    var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;
});
parcelRegister("jojW6", function(module, exports) {
    $parcel$export(module.exports, "storeKeyNameFromField", ()=>$e1dfb923a27ca793$export$54be8689c65f3b56);
    $parcel$export(module.exports, "getStoreKeyName", ()=>$e1dfb923a27ca793$export$3cdb6c178b88cabe);
    $parcel$export(module.exports, "argumentsObjectFromField", ()=>$e1dfb923a27ca793$export$3f5a60fb6a781b4f);
    $parcel$export(module.exports, "resultKeyNameFromField", ()=>$e1dfb923a27ca793$export$7d1ad22471852218);
    $parcel$export(module.exports, "isField", ()=>$e1dfb923a27ca793$export$fb56ad75dd311c12);
    $parcel$export(module.exports, "isInlineFragment", ()=>$e1dfb923a27ca793$export$22a1cdafaf27bcff);
    $parcel$export(module.exports, "isIdValue", ()=>$e1dfb923a27ca793$export$e33b89a9aa87695);
    $parcel$export(module.exports, "toIdValue", ()=>$e1dfb923a27ca793$export$b124f125e34d720a);
    $parcel$export(module.exports, "isJsonValue", ()=>$e1dfb923a27ca793$export$226c1c6d1a5b660a);
    $parcel$export(module.exports, "getDirectiveInfoFromField", ()=>$e1dfb923a27ca793$export$2a7f471142984a91);
    $parcel$export(module.exports, "shouldInclude", ()=>$e1dfb923a27ca793$export$3dc388a5f013b4a5);
    $parcel$export(module.exports, "hasDirectives", ()=>$e1dfb923a27ca793$export$2dafb573e282fe8d);
    $parcel$export(module.exports, "hasClientExports", ()=>$e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
    $parcel$export(module.exports, "getFragmentQueryDocument", ()=>$e1dfb923a27ca793$export$abbf37c7cf644e41);
    $parcel$export(module.exports, "assign", ()=>$e1dfb923a27ca793$export$e6e34fd1f2686227);
    $parcel$export(module.exports, "checkDocument", ()=>$e1dfb923a27ca793$export$a7d0d8111d2386df);
    $parcel$export(module.exports, "getOperationDefinition", ()=>$e1dfb923a27ca793$export$7a5b1fa979d2c158);
    $parcel$export(module.exports, "getOperationName", ()=>$e1dfb923a27ca793$export$41bca9dc6871dd4e);
    $parcel$export(module.exports, "getFragmentDefinitions", ()=>$e1dfb923a27ca793$export$5320a7ba9466a3df);
    $parcel$export(module.exports, "getQueryDefinition", ()=>$e1dfb923a27ca793$export$d96b2213c1b9d3a9);
    $parcel$export(module.exports, "getMainDefinition", ()=>$e1dfb923a27ca793$export$f431198736b7f96d);
    $parcel$export(module.exports, "createFragmentMap", ()=>$e1dfb923a27ca793$export$193789b4c8246dd4);
    $parcel$export(module.exports, "getDefaultValues", ()=>$e1dfb923a27ca793$export$84c19026e616569e);
    $parcel$export(module.exports, "removeDirectivesFromDocument", ()=>$e1dfb923a27ca793$export$e5ae0530da5fe96c);
    $parcel$export(module.exports, "addTypenameToDocument", ()=>$e1dfb923a27ca793$export$43b332f87950a467);
    $parcel$export(module.exports, "removeConnectionDirectiveFromDocument", ()=>$e1dfb923a27ca793$export$74985f3324559867);
    $parcel$export(module.exports, "buildQueryFromSelectionSet", ()=>$e1dfb923a27ca793$export$57c368c23873f32b);
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$e1dfb923a27ca793$export$8eae69e876ee321e);
    $parcel$export(module.exports, "canUseWeakMap", ()=>$e1dfb923a27ca793$export$772fbc04a0ad4ce9);
    $parcel$export(module.exports, "cloneDeep", ()=>$e1dfb923a27ca793$export$629a2bd3f5a49ecc);
    $parcel$export(module.exports, "isProduction", ()=>$e1dfb923a27ca793$export$f15d00aa73aafac4);
    $parcel$export(module.exports, "isTest", ()=>$e1dfb923a27ca793$export$410cbc2864fa25b5);
    $parcel$export(module.exports, "tryFunctionOrLogError", ()=>$e1dfb923a27ca793$export$50a91acae4904909);
    $parcel$export(module.exports, "graphQLResultHasError", ()=>$e1dfb923a27ca793$export$b4df399e879e53ab);
    $parcel$export(module.exports, "mergeDeep", ()=>$e1dfb923a27ca793$export$dd702b3c8240390c);
    $parcel$export(module.exports, "mergeDeepArray", ()=>$e1dfb923a27ca793$export$160070228be94b08);
    var $12QNw;
    var $1DiV8 = parcelRequire("1DiV8");
    var $3VFsf;
    var $fkrBp = parcelRequire("fkrBp");
    var $bqMzA = parcelRequire("bqMzA");
    var $6cAn5 = parcelRequire("6cAn5");
    function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
        return [
            'StringValue',
            'BooleanValue',
            'EnumValue'
        ].indexOf(value.kind) > -1;
    }
    function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
        return [
            'IntValue',
            'FloatValue'
        ].indexOf(value.kind) > -1;
    }
    function $e1dfb923a27ca793$var$isStringValue(value) {
        return value.kind === 'StringValue';
    }
    function $e1dfb923a27ca793$var$isBooleanValue(value) {
        return value.kind === 'BooleanValue';
    }
    function $e1dfb923a27ca793$var$isIntValue(value) {
        return value.kind === 'IntValue';
    }
    function $e1dfb923a27ca793$var$isFloatValue(value) {
        return value.kind === 'FloatValue';
    }
    function $e1dfb923a27ca793$var$isVariable(value) {
        return value.kind === 'Variable';
    }
    function $e1dfb923a27ca793$var$isObjectValue(value) {
        return value.kind === 'ObjectValue';
    }
    function $e1dfb923a27ca793$var$isListValue(value) {
        return value.kind === 'ListValue';
    }
    function $e1dfb923a27ca793$var$isEnumValue(value) {
        return value.kind === 'EnumValue';
    }
    function $e1dfb923a27ca793$var$isNullValue(value) {
        return value.kind === 'NullValue';
    }
    function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
        if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
        else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
        else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
            var nestedArgObj_1 = {};
            value.fields.map(function(obj) {
                return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
            });
            argObj[name.value] = nestedArgObj_1;
        } else if ($e1dfb923a27ca793$var$isVariable(value)) {
            var variableValue = (variables || {})[value.name.value];
            argObj[name.value] = variableValue;
        } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
            var nestedArgArrayObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
        else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
        else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
        else throw new (0, $1DiV8.InvariantError)(17);
    }
    function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
        var directivesObj = null;
        if (field.directives) {
            directivesObj = {};
            field.directives.forEach(function(directive) {
                directivesObj[directive.name.value] = {};
                if (directive.arguments) directive.arguments.forEach(function(_a) {
                    var name = _a.name, value = _a.value;
                    return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
                });
            });
        }
        var argObj = null;
        if (field.arguments && field.arguments.length) {
            argObj = {};
            field.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
            });
        }
        return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
    }
    var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
        'connection',
        'include',
        'skip',
        'client',
        'rest',
        'export'
    ];
    function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
        if (directives && directives['connection'] && directives['connection']['key']) {
            if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
                var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
                filterKeys.sort();
                var queryArgs_1 = args;
                var filteredArgs_1 = {};
                filterKeys.forEach(function(key) {
                    filteredArgs_1[key] = queryArgs_1[key];
                });
                return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
            } else return directives['connection']['key'];
        }
        var completeFieldName = fieldName;
        if (args) {
            var stringifiedArgs = (0, ($parcel$interopDefault($fkrBp)))(args);
            completeFieldName += "(" + stringifiedArgs + ")";
        }
        if (directives) Object.keys(directives).forEach(function(key) {
            if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
            if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            else completeFieldName += "@" + key;
        });
        return completeFieldName;
    }
    function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
        if (field.arguments && field.arguments.length) {
            var argObj_1 = {};
            field.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
            });
            return argObj_1;
        }
        return null;
    }
    function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
        return field.alias ? field.alias.value : field.name.value;
    }
    function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
        return selection.kind === 'Field';
    }
    function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
        return selection.kind === 'InlineFragment';
    }
    function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
        return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
    }
    function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
        if (generated === void 0) generated = false;
        return (0, (0, parcelRequire("3VFsf")).__assign)({
            type: 'id',
            generated: generated
        }, typeof idConfig === 'string' ? {
            id: idConfig,
            typename: undefined
        } : idConfig);
    }
    function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
        return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
    }
    function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
        throw new (0, $1DiV8.InvariantError)(18);
    }
    function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
        if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
        switch(node.kind){
            case 'Variable':
                return onVariable(node);
            case 'NullValue':
                return null;
            case 'IntValue':
                return parseInt(node.value, 10);
            case 'FloatValue':
                return parseFloat(node.value);
            case 'ListValue':
                return node.values.map(function(v) {
                    return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
                });
            case 'ObjectValue':
                var value = {};
                for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                    var field = _a[_i];
                    value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
                }
                return value;
            default:
                return node.value;
        }
    }
    function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
        if (field.directives && field.directives.length) {
            var directiveObj_1 = {};
            field.directives.forEach(function(directive) {
                directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
            });
            return directiveObj_1;
        }
        return null;
    }
    function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
        if (variables === void 0) variables = {};
        return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
            var directive = _a.directive, ifArgument = _a.ifArgument;
            var evaledValue = false;
            if (ifArgument.value.kind === 'Variable') {
                evaledValue = variables[ifArgument.value.name.value];
                (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
            } else evaledValue = ifArgument.value.value;
            return directive.name.value === 'skip' ? !evaledValue : evaledValue;
        });
    }
    function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
        var names = [];
        (0, (0, parcelRequire("12QNw")).visit)(doc, {
            Directive: function(node) {
                names.push(node.name.value);
            }
        });
        return names;
    }
    function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
        return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
            return names.indexOf(name) > -1;
        });
    }
    function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
        return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
            'client'
        ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
            'export'
        ], document);
    }
    function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
        var value = _a.name.value;
        return value === 'skip' || value === 'include';
    }
    function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
        return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
            var ifArgument = directiveArguments[0];
            (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
            var ifValue = ifArgument.value;
            (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
            return {
                directive: directive,
                ifArgument: ifArgument
            };
        }) : [];
    }
    function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
        var actualFragmentName = fragmentName;
        var fragments = [];
        document.definitions.forEach(function(definition) {
            if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
            if (definition.kind === 'FragmentDefinition') fragments.push(definition);
        });
        if (typeof actualFragmentName === 'undefined') {
            (0, $1DiV8.invariant)(fragments.length === 1, 12);
            actualFragmentName = fragments[0].name.value;
        }
        var query = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, document), {
            definitions: (0, (0, parcelRequire("3VFsf")).__spreadArrays)([
                {
                    kind: 'OperationDefinition',
                    operation: 'query',
                    selectionSet: {
                        kind: 'SelectionSet',
                        selections: [
                            {
                                kind: 'FragmentSpread',
                                name: {
                                    kind: 'Name',
                                    value: actualFragmentName
                                }
                            }
                        ]
                    }
                }
            ], document.definitions)
        });
        return query;
    }
    function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
        var sources = [];
        for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
        sources.forEach(function(source) {
            if (typeof source === 'undefined' || source === null) return;
            Object.keys(source).forEach(function(key) {
                target[key] = source[key];
            });
        });
        return target;
    }
    function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        var mutationDef = doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
        })[0];
        (0, $1DiV8.invariant)(mutationDef, 1);
        return mutationDef;
    }
    function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
        (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
        var operations = doc.definitions.filter(function(d) {
            return d.kind !== 'FragmentDefinition';
        }).map(function(definition) {
            if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
            return definition;
        });
        (0, $1DiV8.invariant)(operations.length <= 1, 4);
        return doc;
    }
    function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition';
        })[0];
    }
    function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
        var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
        (0, $1DiV8.invariant)(def, 5);
        return def;
    }
    function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition' && definition.name;
        }).map(function(x) {
            return x.name.value;
        })[0] || null;
    }
    function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'FragmentDefinition';
        });
    }
    function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
        var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
        (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
        return queryDef;
    }
    function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
        (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
        (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
        var fragmentDef = doc.definitions[0];
        (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
        return fragmentDef;
    }
    function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
        var fragmentDefinition;
        for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
            var definition = _a[_i];
            if (definition.kind === 'OperationDefinition') {
                var operation = definition.operation;
                if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
            }
            if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
        }
        if (fragmentDefinition) return fragmentDefinition;
        throw new (0, $1DiV8.InvariantError)(10);
    }
    function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
        if (fragments === void 0) fragments = [];
        var symTable = {};
        fragments.forEach(function(fragment) {
            symTable[fragment.name.value] = fragment;
        });
        return symTable;
    }
    function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
        if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
            var defaultValues = definition.variableDefinitions.filter(function(_a) {
                var defaultValue = _a.defaultValue;
                return defaultValue;
            }).map(function(_a) {
                var variable = _a.variable, defaultValue = _a.defaultValue;
                var defaultValueObj = {};
                $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
                return defaultValueObj;
            });
            return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, (0, parcelRequire("3VFsf")).__spreadArrays)([
                {}
            ], defaultValues));
        }
        return {};
    }
    function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
        var names = new Set();
        if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
        return names;
    }
    function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
        var target = 0;
        array.forEach(function(elem, i) {
            if (test.call(this, elem, i, array)) array[target++] = elem;
        }, context);
        array.length = target;
        return array;
    }
    var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
        kind: 'Field',
        name: {
            kind: 'Name',
            value: '__typename'
        }
    };
    function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
        return op.selectionSet.selections.every(function(selection) {
            return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
        });
    }
    function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
        return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
    }
    function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
        return function directiveMatcher(directive) {
            return directives.some(function(dir) {
                return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
            });
        };
    }
    function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
        var variablesInUse = Object.create(null);
        var variablesToRemove = [];
        var fragmentSpreadsInUse = Object.create(null);
        var fragmentSpreadsToRemove = [];
        var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            Variable: {
                enter: function(node, _key, parent) {
                    if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
                }
            },
            Field: {
                enter: function(node) {
                    if (directives && node.directives) {
                        var shouldRemoveField = directives.some(function(directive) {
                            return directive.remove;
                        });
                        if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                            if (node.arguments) node.arguments.forEach(function(arg) {
                                if (arg.value.kind === 'Variable') variablesToRemove.push({
                                    name: arg.value.name.value
                                });
                            });
                            if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value
                                });
                            });
                            return null;
                        }
                    }
                }
            },
            FragmentSpread: {
                enter: function(node) {
                    fragmentSpreadsInUse[node.name.value] = true;
                }
            },
            Directive: {
                enter: function(node) {
                    if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
                }
            }
        }));
        if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
            return !variablesInUse[v.name];
        }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
        if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
            return !fragmentSpreadsInUse[fs.name];
        }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
        return modifiedDoc;
    }
    function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
        return (0, (0, parcelRequire("12QNw")).visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
            SelectionSet: {
                enter: function(node, _key, parent) {
                    if (parent && parent.kind === 'OperationDefinition') return;
                    var selections = node.selections;
                    if (!selections) return;
                    var skip = selections.some(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                    });
                    if (skip) return;
                    var field = parent;
                    if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                        return d.name.value === 'export';
                    })) return;
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        selections: (0, (0, parcelRequire("3VFsf")).__spreadArrays)(selections, [
                            $e1dfb923a27ca793$var$TYPENAME_FIELD
                        ])
                    });
                }
            }
        });
    }
    var $e1dfb923a27ca793$var$connectionRemoveConfig = {
        test: function(directive) {
            var willRemove = directive.name.value === 'connection';
            if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
                return arg.name.value === 'key';
            });
            return willRemove;
        }
    };
    function $e1dfb923a27ca793$export$74985f3324559867(doc) {
        return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
            $e1dfb923a27ca793$var$connectionRemoveConfig
        ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
    }
    function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
        if (nestedCheck === void 0) nestedCheck = true;
        return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
        });
    }
    function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
        if (nestedCheck === void 0) nestedCheck = true;
        if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
        if (!selection.directives) return false;
        return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
    }
    function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        var parentPath;
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            SelectionSet: {
                enter: function(node, _key, _parent, path) {
                    var currentPath = path.join('-');
                    if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                        if (node.selections) {
                            var selectionsWithDirectives = node.selections.filter(function(selection) {
                                return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                            });
                            if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                                selections: selectionsWithDirectives
                            });
                        } else return null;
                    }
                }
            }
        }));
    }
    function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
        return function argumentMatcher(argument) {
            return config.some(function(aConfig) {
                return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
            });
        };
    }
    function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
        var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            OperationDefinition: {
                enter: function(node) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return !config.some(function(arg) {
                                return arg.name === varDef.variable.name.value;
                            });
                        })
                    });
                }
            },
            Field: {
                enter: function(node) {
                    var shouldRemoveField = config.some(function(argConfig) {
                        return argConfig.remove;
                    });
                    if (shouldRemoveField) {
                        var argMatchCount_1 = 0;
                        node.arguments.forEach(function(arg) {
                            if (argMatcher(arg)) argMatchCount_1 += 1;
                        });
                        if (argMatchCount_1 === 1) return null;
                    }
                }
            },
            Argument: {
                enter: function(node) {
                    if (argMatcher(node)) return null;
                }
            }
        }));
    }
    function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
        function enter(node) {
            if (config.some(function(def) {
                return def.name === node.name.value;
            })) return null;
        }
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            FragmentSpread: {
                enter: enter
            },
            FragmentDefinition: {
                enter: enter
            }
        }));
    }
    function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
        var allFragments = [];
        selectionSet.selections.forEach(function(selection) {
            if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
                return allFragments.push(frag);
            });
            else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
        });
        return allFragments;
    }
    function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
        var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
        var definitionOperation = definition.operation;
        if (definitionOperation === 'query') return document;
        var modifiedDoc = (0, (0, parcelRequire("12QNw")).visit)(document, {
            OperationDefinition: {
                enter: function(node) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        operation: 'query'
                    });
                }
            }
        });
        return modifiedDoc;
    }
    function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
        var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
            {
                test: function(directive) {
                    return directive.name.value === 'client';
                },
                remove: true
            }
        ], document);
        if (modifiedDoc) modifiedDoc = (0, (0, parcelRequire("12QNw")).visit)(modifiedDoc, {
            FragmentDefinition: {
                enter: function(node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                            return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) return null;
                    }
                }
            }
        });
        return modifiedDoc;
    }
    var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
    var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
    function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
        return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
    }
    function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
        switch($e1dfb923a27ca793$var$toString.call(val)){
            case "[object Array]":
                if (seen.has(val)) return seen.get(val);
                var copy_1 = val.slice(0);
                seen.set(val, copy_1);
                copy_1.forEach(function(child, i) {
                    copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
                });
                return copy_1;
            case "[object Object]":
                if (seen.has(val)) return seen.get(val);
                var copy_2 = Object.create(Object.getPrototypeOf(val));
                seen.set(val, copy_2);
                Object.keys(val).forEach(function(key) {
                    copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
                });
                return copy_2;
            default:
                return val;
        }
    }
    function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
        if (typeof $6cAn5 !== 'undefined' && "production") return "production";
        return 'development';
    }
    function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
        return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
    }
    function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
    }
    function $e1dfb923a27ca793$export$df77466336fe5355() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
    }
    function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
    }
    function $e1dfb923a27ca793$export$50a91acae4904909(f) {
        try {
            return f();
        } catch (e) {
            if (console.error) console.error(e);
        }
    }
    function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
        return result.errors && result.errors.length;
    }
    function $e1dfb923a27ca793$var$deepFreeze(o) {
        Object.freeze(o);
        Object.getOwnPropertyNames(o).forEach(function(prop) {
            if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
        });
        return o;
    }
    function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
        if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
            var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
            if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
        }
        return obj;
    }
    var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    function $e1dfb923a27ca793$export$dd702b3c8240390c() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
        return $e1dfb923a27ca793$export$160070228be94b08(sources);
    }
    function $e1dfb923a27ca793$export$160070228be94b08(sources) {
        var target = sources[0] || {};
        var count = sources.length;
        if (count > 1) {
            var pastCopies = [];
            target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
            for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
        }
        return target;
    }
    function $e1dfb923a27ca793$var$isObject(obj) {
        return obj !== null && typeof obj === 'object';
    }
    function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
        if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
            if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
            Object.keys(source).forEach(function(sourceKey) {
                var sourceValue = source[sourceKey];
                if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                } else target[sourceKey] = sourceValue;
            });
            return target;
        }
        return source;
    }
    function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
        if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
            if (Array.isArray(value)) value = value.slice(0);
            else value = (0, (0, parcelRequire("3VFsf")).__assign)({
                __proto__: Object.getPrototypeOf(value)
            }, value);
            pastCopies.push(value);
        }
        return value;
    }
    var $e1dfb923a27ca793$var$haveWarned = Object.create({});
    function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
        if (type === void 0) type = 'warn';
        if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
            if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
            if (type === 'error') console.error(msg);
            else console.warn(msg);
        }
    }
    function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
        return JSON.parse(JSON.stringify(data));
    }
});
parcelRegister("1DiV8", function(module, exports) {
    $parcel$export(module.exports, "InvariantError", ()=>$13081c324be1f9ab$export$cea12affaee22fe8);
    $parcel$export(module.exports, "invariant", ()=>$13081c324be1f9ab$export$f5708dca728d7177);
    var $3VFsf;
    var $6cAn5 = parcelRequire("6cAn5");
    var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
    var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
        obj.__proto__ = proto;
        return obj;
    } : $13081c324be1f9ab$var$_a;
    var $13081c324be1f9ab$export$cea12affaee22fe8 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InvariantError, _super);
        function InvariantError(message) {
            if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
            var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
            _this.framesToPop = 1;
            _this.name = $13081c324be1f9ab$var$genericMessage;
            $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
            return _this;
        }
        return InvariantError;
    }(Error);
    function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
        if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
    }
    function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
        return function() {
            return console[method].apply(console, arguments);
        };
    }
    (function(invariant) {
        invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
        invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
    })($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
    var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
        env: {}
    };
    if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
    else try {
        Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
    } catch (atLeastWeTried) {}
    var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
    var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;
});
parcelRegister("fkrBp", function(module, exports) {
    'use strict';
    module.exports = function(data, opts) {
        if (!opts) opts = {};
        if (typeof opts === 'function') opts = {
            cmp: opts
        };
        var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
        var cmp = opts.cmp && function(f) {
            return function(node) {
                return function(a, b) {
                    var aobj = {
                        key: a,
                        value: node[a]
                    };
                    var bobj = {
                        key: b,
                        value: node[b]
                    };
                    return f(aobj, bobj);
                };
            };
        }(opts.cmp);
        var seen = [];
        return function stringify(node) {
            if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
            if (node === undefined) return;
            if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
            if (typeof node !== 'object') return JSON.stringify(node);
            var i, out;
            if (Array.isArray(node)) {
                out = '[';
                for(i = 0; i < node.length; i++){
                    if (i) out += ',';
                    out += stringify(node[i]) || 'null';
                }
                return out + ']';
            }
            if (node === null) return 'null';
            if (seen.indexOf(node) !== -1) {
                if (cycles) return JSON.stringify('__cycle__');
                throw new TypeError('Converting circular structure to JSON');
            }
            var seenIndex = seen.push(node) - 1;
            var keys = Object.keys(node).sort(cmp && cmp(node));
            out = '';
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                var value = stringify(node[key]);
                if (!value) continue;
                if (out) out += ',';
                out += JSON.stringify(key) + ':' + value;
            }
            seen.splice(seenIndex, 1);
            return '{' + out + '}';
        }(data);
    };
});
parcelRegister("bqMzA", function(module, exports) {
    $parcel$export(module.exports, "equal", ()=>$8527cd05038b1b96$export$411ce8e5a71e3069);
    var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
    var $8527cd05038b1b96$var$previousComparisons = new Map();
    function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
        try {
            return $8527cd05038b1b96$var$check(a, b);
        } finally{
            $8527cd05038b1b96$var$previousComparisons.clear();
        }
    }
    function $8527cd05038b1b96$var$check(a, b) {
        if (a === b) return true;
        var aTag = $8527cd05038b1b96$var$toString.call(a);
        var bTag = $8527cd05038b1b96$var$toString.call(b);
        if (aTag !== bTag) return false;
        switch(aTag){
            case '[object Array]':
                if (a.length !== b.length) return false;
            case '[object Object]':
                if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
                var aKeys = Object.keys(a);
                var bKeys = Object.keys(b);
                var keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                for(var k = 0; k < keyCount; ++k){
                    if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                for(var k = 0; k < keyCount; ++k){
                    var key = aKeys[k];
                    if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
                }
                return true;
            case '[object Error]':
                return a.name === b.name && a.message === b.message;
            case '[object Number]':
                if (a !== a) return b !== b;
            case '[object Boolean]':
            case '[object Date]':
                return +a === +b;
            case '[object RegExp]':
            case '[object String]':
                return a == "" + b;
            case '[object Map]':
            case '[object Set]':
                if (a.size !== b.size) return false;
                if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
                var aIterator = a.entries();
                var isMap = aTag === '[object Map]';
                while(true){
                    var info = aIterator.next();
                    if (info.done) break;
                    var _a = info.value, aKey = _a[0], aValue = _a[1];
                    if (!b.has(aKey)) return false;
                    if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
        }
        return false;
    }
    function $8527cd05038b1b96$var$previouslyCompared(a, b) {
        var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
        if (bSet) {
            if (bSet.has(b)) return true;
        } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
        bSet.add(b);
        return false;
    }
    var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;
});
parcelRegister("clSzL", function(module, exports) {
    $parcel$export(module.exports, "makePromise", ()=>makePromise);
    $parcel$export(module.exports, "fromError", ()=>fromError);
    $parcel$export(module.exports, "ApolloLink", ()=>ApolloLink);
    $parcel$export(module.exports, "from", ()=>from);
    $parcel$export(module.exports, "split", ()=>split);
    $parcel$export(module.exports, "execute", ()=>execute);
    $parcel$export(module.exports, "Observable", ()=>(parcelRequire("aS6b9")).default);
    var $aS6b9;
    var $1DiV8 = parcelRequire("1DiV8");
    var $3VFsf;
    var $jojW6;
    function validateOperation(operation) {
        var OPERATION_FIELDS = [
            'query',
            'operationName',
            'variables',
            'extensions',
            'context'
        ];
        for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
            var key = _a[_i];
            if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
        }
        return operation;
    }
    var LinkError = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LinkError, _super);
        function LinkError(message, link) {
            var _this = _super.call(this, message) || this;
            _this.link = link;
            return _this;
        }
        return LinkError;
    }(Error);
    function isTerminating(link) {
        return link.request.length <= 1;
    }
    function toPromise(observable) {
        var completed = false;
        return new Promise(function(resolve, reject) {
            observable.subscribe({
                next: function(data) {
                    if (completed) ;
                    else {
                        completed = true;
                        resolve(data);
                    }
                },
                error: reject
            });
        });
    }
    var makePromise = toPromise;
    function fromPromise(promise) {
        return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
            promise.then(function(value) {
                observer.next(value);
                observer.complete();
            }).catch(observer.error.bind(observer));
        });
    }
    function fromError(errorValue) {
        return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
            observer.error(errorValue);
        });
    }
    function transformOperation(operation) {
        var transformedOperation = {
            variables: operation.variables || {},
            extensions: operation.extensions || {},
            operationName: operation.operationName,
            query: operation.query
        };
        if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, (0, parcelRequire("jojW6")).getOperationName)(transformedOperation.query) : '';
        return transformedOperation;
    }
    function createOperation(starting, operation) {
        var context = (0, (0, parcelRequire("3VFsf")).__assign)({}, starting);
        var setContext = function(next) {
            if (typeof next === 'function') context = (0, (0, parcelRequire("3VFsf")).__assign)({}, context, next(context));
            else context = (0, (0, parcelRequire("3VFsf")).__assign)({}, context, next);
        };
        var getContext = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)({}, context);
        };
        Object.defineProperty(operation, 'setContext', {
            enumerable: false,
            value: setContext
        });
        Object.defineProperty(operation, 'getContext', {
            enumerable: false,
            value: getContext
        });
        Object.defineProperty(operation, 'toKey', {
            enumerable: false,
            value: function() {
                return getKey(operation);
            }
        });
        return operation;
    }
    function getKey(operation) {
        var query = operation.query, variables = operation.variables, operationName = operation.operationName;
        return JSON.stringify([
            operationName,
            query,
            variables
        ]);
    }
    function passthrough(op, forward) {
        return forward ? forward(op) : (0, (0, parcelRequire("aS6b9")).default).of();
    }
    function toLink(handler) {
        return typeof handler === 'function' ? new ApolloLink(handler) : handler;
    }
    function empty() {
        return new ApolloLink(function() {
            return (0, (0, parcelRequire("aS6b9")).default).of();
        });
    }
    function from(links) {
        if (links.length === 0) return empty();
        return links.map(toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    }
    function split(test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, (0, parcelRequire("aS6b9")).default).of() : rightLink.request(operation) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, (0, parcelRequire("aS6b9")).default).of() : rightLink.request(operation, forward) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
    }
    var concat = function(first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) return firstLink;
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, (0, parcelRequire("aS6b9")).default).of();
            }) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, (0, parcelRequire("aS6b9")).default).of();
            }) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
    };
    var ApolloLink = function() {
        function ApolloLink(request) {
            if (request) this.request = request;
        }
        ApolloLink.prototype.split = function(test, left, right) {
            return this.concat(split(test, left, right || new ApolloLink(passthrough)));
        };
        ApolloLink.prototype.concat = function(next) {
            return concat(this, next);
        };
        ApolloLink.prototype.request = function(operation, forward) {
            throw new (0, $1DiV8.InvariantError)(1);
        };
        ApolloLink.empty = empty;
        ApolloLink.from = from;
        ApolloLink.split = split;
        ApolloLink.execute = execute;
        return ApolloLink;
    }();
    function execute(link, operation) {
        return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, (0, parcelRequire("aS6b9")).default).of();
    }
});
parcelRegister("aS6b9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ea3bd7f736c1eb4$export$2e2bcd8739ae039);
    var $4osjv = parcelRequire("4osjv");
    var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, ($parcel$interopDefault($4osjv)));
    var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;
});
parcelRegister("4osjv", function(module, exports) {
    module.exports = (parcelRequire("k0hXK")).Observable;
});
parcelRegister("k0hXK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Observable = void 0;
    function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var $e901bdc1c9a5edd7$var$hasSymbols = function() {
        return typeof Symbol === 'function';
    };
    var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
        return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
    };
    var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
        return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
    };
    if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
    var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
    var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
    var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species');
    function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
        var value = obj[key];
        if (value == null) return undefined;
        if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
        return value;
    }
    function $e901bdc1c9a5edd7$var$getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== undefined) {
            ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
            if (ctor === null) ctor = undefined;
        }
        return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
    }
    function $e901bdc1c9a5edd7$var$isObservable(x) {
        return x instanceof $e901bdc1c9a5edd7$var$Observable;
    }
    function $e901bdc1c9a5edd7$var$hostReportError(e) {
        if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
        else setTimeout(function() {
            throw e;
        });
    }
    function $e901bdc1c9a5edd7$var$enqueue(fn) {
        Promise.resolve().then(function() {
            try {
                fn();
            } catch (e) {
                $e901bdc1c9a5edd7$var$hostReportError(e);
            }
        });
    }
    function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
        var cleanup = subscription._cleanup;
        if (cleanup === undefined) return;
        subscription._cleanup = undefined;
        if (!cleanup) return;
        try {
            if (typeof cleanup === 'function') cleanup();
            else {
                var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
                if (unsubscribe) unsubscribe.call(cleanup);
            }
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    }
    function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
        subscription._observer = undefined;
        subscription._queue = undefined;
        subscription._state = 'closed';
    }
    function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
        var queue = subscription._queue;
        if (!queue) return;
        subscription._queue = undefined;
        subscription._state = 'ready';
        for(var i = 0; i < queue.length; ++i){
            $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
            if (subscription._state === 'closed') break;
        }
    }
    function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
        subscription._state = 'running';
        var observer = subscription._observer;
        try {
            var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
            switch(type){
                case 'next':
                    if (m) m.call(observer, value);
                    break;
                case 'error':
                    $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                    if (m) m.call(observer, value);
                    else throw value;
                    break;
                case 'complete':
                    $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                    if (m) m.call(observer);
                    break;
            }
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
        if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
        else if (subscription._state === 'running') subscription._state = 'ready';
    }
    function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
        if (subscription._state === 'closed') return;
        if (subscription._state === 'buffering') {
            subscription._queue.push({
                type: type,
                value: value
            });
            return;
        }
        if (subscription._state !== 'ready') {
            subscription._state = 'buffering';
            subscription._queue = [
                {
                    type: type,
                    value: value
                }
            ];
            $e901bdc1c9a5edd7$var$enqueue(function() {
                return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
            });
            return;
        }
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
    }
    var $e901bdc1c9a5edd7$var$Subscription = function() {
        function Subscription(observer, subscriber) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
            this._cleanup = undefined;
            this._observer = observer;
            this._queue = undefined;
            this._state = 'initializing';
            var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
            try {
                this._cleanup = subscriber.call(undefined, subscriptionObserver);
            } catch (e) {
                subscriptionObserver.error(e);
            }
            if (this._state === 'initializing') this._state = 'ready';
        }
        $e901bdc1c9a5edd7$var$_createClass(Subscription, [
            {
                key: "unsubscribe",
                value: function unsubscribe() {
                    if (this._state !== 'closed') {
                        $e901bdc1c9a5edd7$var$closeSubscription(this);
                        $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                    }
                }
            },
            {
                key: "closed",
                get: function() {
                    return this._state === 'closed';
                }
            }
        ]);
        return Subscription;
    }();
    var $e901bdc1c9a5edd7$var$SubscriptionObserver = function() {
        function SubscriptionObserver(subscription) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
            this._subscription = subscription;
        }
        $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
            {
                key: "next",
                value: function next(value) {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
                }
            },
            {
                key: "error",
                value: function error(value) {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
                }
            },
            {
                key: "complete",
                value: function complete() {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
                }
            },
            {
                key: "closed",
                get: function() {
                    return this._subscription._state === 'closed';
                }
            }
        ]);
        return SubscriptionObserver;
    }();
    var $e901bdc1c9a5edd7$var$Observable = function() {
        function Observable(subscriber) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
            if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
            if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
            this._subscriber = subscriber;
        }
        $e901bdc1c9a5edd7$var$_createClass(Observable, [
            {
                key: "subscribe",
                value: function subscribe(observer) {
                    if (typeof observer !== 'object' || observer === null) observer = {
                        next: observer,
                        error: arguments[1],
                        complete: arguments[2]
                    };
                    return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
                }
            },
            {
                key: "forEach",
                value: function forEach(fn) {
                    var _this = this;
                    return new Promise(function(resolve, reject) {
                        if (typeof fn !== 'function') {
                            reject(new TypeError(fn + ' is not a function'));
                            return;
                        }
                        function done() {
                            subscription.unsubscribe();
                            resolve();
                        }
                        var subscription = _this.subscribe({
                            next: function(value) {
                                try {
                                    fn(value, done);
                                } catch (e) {
                                    reject(e);
                                    subscription.unsubscribe();
                                }
                            },
                            error: reject,
                            complete: resolve
                        });
                    });
                }
            },
            {
                key: "map",
                value: function map(fn) {
                    var _this2 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        return _this2.subscribe({
                            next: function(value) {
                                try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "filter",
                value: function filter(fn) {
                    var _this3 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        return _this3.subscribe({
                            next: function(value) {
                                try {
                                    if (!fn(value)) return;
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "reduce",
                value: function reduce(fn) {
                    var _this4 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    var hasSeed = arguments.length > 1;
                    var hasValue = false;
                    var seed = arguments[1];
                    var acc = seed;
                    return new C(function(observer) {
                        return _this4.subscribe({
                            next: function(value) {
                                var first = !hasValue;
                                hasValue = true;
                                if (!first || hasSeed) try {
                                    acc = fn(acc, value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                else acc = value;
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                                observer.next(acc);
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "concat",
                value: function concat() {
                    var _this5 = this;
                    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        var subscription;
                        var index = 0;
                        function startNext(next) {
                            subscription = next.subscribe({
                                next: function(v) {
                                    observer.next(v);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    if (index === sources.length) {
                                        subscription = undefined;
                                        observer.complete();
                                    } else startNext(C.from(sources[index++]));
                                }
                            });
                        }
                        startNext(_this5);
                        return function() {
                            if (subscription) {
                                subscription.unsubscribe();
                                subscription = undefined;
                            }
                        };
                    });
                }
            },
            {
                key: "flatMap",
                value: function flatMap(fn) {
                    var _this6 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        var subscriptions = [];
                        var outer = _this6.subscribe({
                            next: function(value) {
                                if (fn) try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                var inner = C.from(value).subscribe({
                                    next: function(value) {
                                        observer.next(value);
                                    },
                                    error: function(e) {
                                        observer.error(e);
                                    },
                                    complete: function() {
                                        var i = subscriptions.indexOf(inner);
                                        if (i >= 0) subscriptions.splice(i, 1);
                                        completeIfDone();
                                    }
                                });
                                subscriptions.push(inner);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                completeIfDone();
                            }
                        });
                        function completeIfDone() {
                            if (outer.closed && subscriptions.length === 0) observer.complete();
                        }
                        return function() {
                            subscriptions.forEach(function(s) {
                                return s.unsubscribe();
                            });
                            outer.unsubscribe();
                        };
                    });
                }
            },
            {
                key: $e901bdc1c9a5edd7$var$SymbolObservable,
                value: function() {
                    return this;
                }
            }
        ], [
            {
                key: "from",
                value: function from(x) {
                    var C = typeof this === 'function' ? this : Observable;
                    if (x == null) throw new TypeError(x + ' is not an object');
                    var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                    if (method) {
                        var observable = method.call(x);
                        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                        if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                        return new C(function(observer) {
                            return observable.subscribe(observer);
                        });
                    }
                    if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                        method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                        if (method) return new C(function(observer) {
                            $e901bdc1c9a5edd7$var$enqueue(function() {
                                if (observer.closed) return;
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;
                                try {
                                    for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _item = _step.value;
                                        observer.next(_item);
                                        if (observer.closed) return;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                    } finally{
                                        if (_didIteratorError) throw _iteratorError;
                                    }
                                }
                                observer.complete();
                            });
                        });
                    }
                    if (Array.isArray(x)) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            for(var i = 0; i < x.length; ++i){
                                observer.next(x[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        });
                    });
                    throw new TypeError(x + ' is not observable');
                }
            },
            {
                key: "of",
                value: function of() {
                    for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                    var C = typeof this === 'function' ? this : Observable;
                    return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            for(var i = 0; i < items.length; ++i){
                                observer.next(items[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        });
                    });
                }
            },
            {
                key: $e901bdc1c9a5edd7$var$SymbolSpecies,
                get: function() {
                    return this;
                }
            }
        ]);
        return Observable;
    }();
    module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
    if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
        value: {
            symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
            hostReportError: $e901bdc1c9a5edd7$var$hostReportError
        },
        configurable: true
    });
});
parcelRegister("8UpTw", function(module, exports) {
    $parcel$export(module.exports, "ErrorPage", ()=>$5a72c35b5a5b98e9$export$c120a0e80fd44ca6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $beRD7;
    const $5a72c35b5a5b98e9$export$c120a0e80fd44ca6 = ({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement($5a72c35b5a5b98e9$var$ErrorWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).JSErrorPageAsync), {
            error: error
        }));
    const $5a72c35b5a5b98e9$var$ErrorWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _syaz1fxt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8dXDG", function(module, exports) {
    $parcel$export(module.exports, "useExperienceAbort", ()=>$2df1decadd95b490$export$cc92b7ce453f4403);
    var $5uXOq = parcelRequire("5uXOq");
    var $l9g16;
    const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const self = (0, $5uXOq.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
            const { current: current } = self;
            current.experienceTracker.abort({
                name: current.name,
                reason: reason,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("bTIks", function(module, exports) {
    $parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$9b5e8e07ff330ef2);
    $parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$a58227116ceb8b81);
    $parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$e17a11e4247a14f7);
    $parcel$export(module.exports, "MODAL_WIDTH", ()=>$43e56627abfe9003$export$3d931b64f46140b3);
    var $gwIPs;
    const $43e56627abfe9003$export$b8b9d90f9e5bd72b = 'jiraBusinessEntityOverview';
    const $43e56627abfe9003$export$9b5e8e07ff330ef2 = {
        experience: 'create-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$a58227116ceb8b81 = {
        experience: 'edit-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$e17a11e4247a14f7 = {
        experience: 'delete-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$d03d4e78ea5b909a = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $43e56627abfe9003$export$57ee5df6bad94642 = 400;
    const $43e56627abfe9003$export$5785b84269e3e763 = 340;
    const $43e56627abfe9003$export$7c9c92ba6b198ac4 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $43e56627abfe9003$export$c4232794452dc6e3 = 480;
    const $43e56627abfe9003$export$3d931b64f46140b3 = $43e56627abfe9003$export$c4232794452dc6e3 + $43e56627abfe9003$export$57ee5df6bad94642 + $43e56627abfe9003$export$7c9c92ba6b198ac4 * 2 + $43e56627abfe9003$export$d03d4e78ea5b909a * 2;
    const $43e56627abfe9003$var$MODAL_DIALOG_MARGIN = 120;
    const $43e56627abfe9003$export$68bc124b0fa13de0 = $43e56627abfe9003$export$3d931b64f46140b3 + $43e56627abfe9003$var$MODAL_DIALOG_MARGIN;
});
parcelRegister("fmp5H", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7Thkj")
    ]).then(()=>parcelRequire('6gB2z'));
});
parcelRegister("N0aCi", function(module, exports) {
    $parcel$export(module.exports, "AsyncMigrationMessage", ()=>$5d4d7ee59ef3aa52$export$93794b6cb00009c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $7EVVm;
    const $5d4d7ee59ef3aa52$var$runtimeProps = {};
    const $5d4d7ee59ef3aa52$var$entryPointParams = {};
    const $5d4d7ee59ef3aa52$export$93794b6cb00009c5 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7EVVm")).migrationMessageEntrypoint), $5d4d7ee59ef3aa52$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "overviews-plans-onboarding-migration-message",
            packageName: "jiraBusinessOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $5d4d7ee59ef3aa52$var$runtimeProps
        });
    };
});
parcelRegister("7EVVm", function(module, exports) {
    $parcel$export(module.exports, "migrationMessageEntrypoint", ()=>$7918607ddc510d1a$export$2dea5f3fdc0ae86);
    var $eufEc;
    var $fEDBv;
    const $7918607ddc510d1a$export$2dea5f3fdc0ae86 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("d2RL6")).then((module)=>module.MigrationMessage), {
            moduleId: "cb473cb0"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("d2RL6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8GMFE")
    ]).then(()=>parcelRequire('h5qXI'));
});
parcelRegister("gb5lQ", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$3a1993d4527e7f44$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "MENU_ID", ()=>$3a1993d4527e7f44$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SECTION_ID", ()=>$3a1993d4527e7f44$export$501955bd67991a25);
    $parcel$export(module.exports, "REPORTS_ROUTES_SET", ()=>$3a1993d4527e7f44$export$f746f9acd7a66bdb);
    $parcel$export(module.exports, "SETTINGS_ROUTES_SET", ()=>$3a1993d4527e7f44$export$e8d6319ab0eb2a27);
    $parcel$export(module.exports, "ISSUES_ROUTES_SET", ()=>$3a1993d4527e7f44$export$6ca9a18cdf1b5a79);
    $parcel$export(module.exports, "FORGE_ROUTES_SET", ()=>$3a1993d4527e7f44$export$6ad6f0faae6ab404);
    $parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", ()=>$3a1993d4527e7f44$export$75d31ae45b00712c);
    $parcel$export(module.exports, "LOCATION", ()=>$3a1993d4527e7f44$export$87d0ca22edb7493a);
    $parcel$export(module.exports, "OVERVIEW_MAX_LIMIT", ()=>$3a1993d4527e7f44$export$96f465f51836d3a2);
    var $65Ltd;
    var $gwIPs;
    const $3a1993d4527e7f44$export$b8b9d90f9e5bd72b = 'jira.navigation.sidebar.core';
    const $3a1993d4527e7f44$export$d4cd258d01c03112 = 'project/core';
    const $3a1993d4527e7f44$export$501955bd67991a25 = {
        ISSUES: 'issues',
        REPORTS: 'reports',
        SETTINGS: 'settings',
        ISSUE_TYPES: 'issuetypes'
    };
    const $3a1993d4527e7f44$export$f746f9acd7a66bdb = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_ALL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_CONFIG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_PIE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE)
    ]);
    const $3a1993d4527e7f44$export$e8d6319ab0eb2a27 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV)
    ]);
    const $3a1993d4527e7f44$export$6ca9a18cdf1b5a79 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PIN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE)
    ]);
    const $3a1993d4527e7f44$export$6ad6f0faae6ab404 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS)
    ]);
    const $3a1993d4527e7f44$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
    const $3a1993d4527e7f44$export$33abecf3eb4ba30b = (0, (0, parcelRequire("gwIPs")).gridSize) * 5;
    const $3a1993d4527e7f44$export$76ca6e18b275dcad = 24;
    const $3a1993d4527e7f44$export$87d0ca22edb7493a = 'jwmNavigationCreateProject';
    const $3a1993d4527e7f44$export$96f465f51836d3a2 = 10;
});
parcelRegister("iuAuR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eeba495724dfd3ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $eeba495724dfd3ed$var$SectionHeader = ({ children: children, title: title })=>(0, ($parcel$interopDefault($5uXOq))).createElement($eeba495724dfd3ed$export$960a49cc3d27a090, null, (0, ($parcel$interopDefault($5uXOq))).createElement($eeba495724dfd3ed$export$8b251419efc915eb, null, title), children);
    var $eeba495724dfd3ed$export$2e2bcd8739ae039 = $eeba495724dfd3ed$var$SectionHeader;
    const $eeba495724dfd3ed$export$960a49cc3d27a090 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4zamj _1e0c1txw _1bah1yb4 _zulpu2gc _4cvr1h6o _1tke1tcg _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $eeba495724dfd3ed$export$8b251419efc915eb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1kw7 _19pkidpf _11c81bk4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6hYaZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c7b20fc56e6a13a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $koVbs;
    var $3MXKI;
    var $8ltGH;
    var $9rljV;
    const $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview';
    const $5c7b20fc56e6a13a$var$CreateOverview = ({ onClick: onClick, hasReachedLimit: hasReachedLimit })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isWarningOpen, setIsWarningOpen] = (0, $5uXOq.useState)(false);
        if (hasReachedLimit) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            placement: "bottom-start",
            isOpen: isWarningOpen,
            onClose: ()=>setIsWarningOpen(false),
            trigger: ({ ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
                    ...triggerProps,
                    onClick: ()=>setIsWarningOpen((isOpen)=>!isOpen),
                    label: formatMessage((0, (0, parcelRequire("8ltGH")).default).createOverviewLabel),
                    testId: $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID,
                    ref: ref
                }),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9rljV")).default), null)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
            onClick: onClick,
            label: formatMessage((0, (0, parcelRequire("8ltGH")).default).createOverviewLabel),
            testId: $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID
        });
    };
    var $5c7b20fc56e6a13a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5c7b20fc56e6a13a$var$CreateOverview);
});
parcelRegister("3MXKI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdc099922ed453c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $9lMrf;
    var $dIWbq;
    var $3bDjY;
    var $dCm1o;
    var $fQ7LC;
    const $cdc099922ed453c2$var$RoundCreateButton = (0, $5uXOq.forwardRef)(({ label: label, onClick: onClick, testId: testId, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            hideTooltipOnClick: true
        }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            testId: testId,
            onClick: onClick,
            spacing: "compact",
            appearance: "default",
            shape: "circle",
            label: label,
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))), {
                    label: "",
                    color: "var(--ds-text, #172B4D)"
                })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fQ7LC")).StyledButton), {
            ...props,
            ref: ref,
            testId: testId,
            spacing: "compact",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: label,
                primaryColor: "var(--ds-text, #172B4D)",
                size: "small"
            }),
            onClick: onClick
        })));
    var $cdc099922ed453c2$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cdc099922ed453c2$var$RoundCreateButton);
});
parcelRegister("dIWbq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9fdc846ce7ffa27e$var$_react = $9fdc846ce7ffa27e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9fdc846ce7ffa27e$var$_UNSAFE_baseNew = $9fdc846ce7ffa27e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9fdc846ce7ffa27e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9fdc846ce7ffa27e$var$AddIcon = (props)=>$9fdc846ce7ffa27e$var$_react.default.createElement($9fdc846ce7ffa27e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M6 6h5M6 6H1m5 0V1m0 5v5"/>`,
            type: 'utility'
        }, props));
    $9fdc846ce7ffa27e$var$AddIcon.displayName = 'AddIcon';
    var $9fdc846ce7ffa27e$var$_default = module.exports.default = $9fdc846ce7ffa27e$var$AddIcon;
});
parcelRegister("fQ7LC", function(module, exports) {
    $parcel$export(module.exports, "StyledButton", ()=>$fe56d18bd5b0d04a$export$2d5d2ba3c7c8c40b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    const $fe56d18bd5b0d04a$export$2d5d2ba3c7c8c40b = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1njd _1pbykb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8ltGH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eb84096f9d3de7a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5eb84096f9d3de7a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createOverviewLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.create-overview-label",
            "defaultMessage": "Create overview"
        }
    });
});
parcelRegister("9rljV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$724e26e8635dbe63$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bU3PY;
    var $cgL5K;
    var $koVbs;
    var $gb5lQ;
    var $6h1VX;
    const $724e26e8635dbe63$var$OverviewLimitPopup = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($724e26e8635dbe63$export$e6dfd72ab29f8598, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
            label: "",
            color: "var(--ds-icon-warning, #ffab00)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("6h1VX")).default).overviewLimitReached, {
            overviewMaxLimit: (0, (0, parcelRequire("gb5lQ")).OVERVIEW_MAX_LIMIT)
        })));
    };
    var $724e26e8635dbe63$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($724e26e8635dbe63$var$OverviewLimitPopup);
    const $724e26e8635dbe63$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc _1yt44ar7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6h1VX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a804cbdeb9da3577$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a804cbdeb9da3577$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        overviewLimitReached: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.overview-limit-popup.overview-limit-reached",
            "defaultMessage": "You've reached the limit of {overviewMaxLimit, plural, one {# overview} other {# overviews}}"
        }
    });
});
parcelRegister("2kAEg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$882af03f312c51f3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $882af03f312c51f3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createOverview: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview",
            "defaultMessage": "Create an overview"
        },
        overviewsHeader: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.overviews-header",
            "defaultMessage": "Overviews"
        },
        errorMessage: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.error-message",
            "defaultMessage": "We couldn't load overviews"
        },
        refreshPage: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.refresh-page",
            "defaultMessage": "Refresh page"
        }
    });
});
parcelRegister("imgTm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a3e3fe210dbf9b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5TTho;
    var $8zOmE;
    var $2NMNM;
    var $eEqSc;
    var $e1jn1;
    var $jzhSN;
    const $5a3e3fe210dbf9b0$var$OverviewLink = ({ overview: overview, to: to, isActive: isActive = false })=>{
        const { name: name, theme: theme } = overview;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            to: to,
            isActive: isActive,
            prefetch: "hover",
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'overviewLink')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5a3e3fe210dbf9b0$export$399e54fcdf2a48ec, {
            size: "small",
            themeName: theme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e1jn1")).default), null, name));
        return isActive ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eEqSc")).default), null, content) : content;
    };
    var $5a3e3fe210dbf9b0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5a3e3fe210dbf9b0$var$OverviewLink);
    const $5a3e3fe210dbf9b0$export$399e54fcdf2a48ec = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("5TTho")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5TTho", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ece6799ec0a6037$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $guOIy;
    var $6cG4N;
    var $52Mvi;
    const $3ece6799ec0a6037$var$OverviewIcon = ({ size: size = 'medium', className: className, themeName: themeName })=>{
        const theme = themeName ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name;
        const Wrapper = (0, (0, parcelRequire("52Mvi")).WRAPPER)[size][theme];
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            className: className,
            "data-testid": "business-entity-overview.common.ui.overview-icon"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("guOIy"))))), {
            label: "",
            LEGACY_size: size,
            color: "currentColor"
        }));
    };
    var $3ece6799ec0a6037$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($3ece6799ec0a6037$var$OverviewIcon);
});
parcelRegister("guOIy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c026ca20e9e43a09$var$_react = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c026ca20e9e43a09$var$_globe = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("9x5pH")));
    var $c026ca20e9e43a09$var$_world = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("4GsX0")));
    function $c026ca20e9e43a09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c026ca20e9e43a09$var$GlobeIcon = (props)=>$c026ca20e9e43a09$var$_react.default.createElement($c026ca20e9e43a09$var$_globe.default, Object.assign({
            LEGACY_fallbackIcon: $c026ca20e9e43a09$var$_world.default
        }, props));
    $c026ca20e9e43a09$var$GlobeIcon.Name = 'GlobeIconMigration';
    var $c026ca20e9e43a09$var$_default = module.exports.default = $c026ca20e9e43a09$var$GlobeIcon;
});
parcelRegister("9x5pH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6f0b6523520f8759$var$_react = $6f0b6523520f8759$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6f0b6523520f8759$var$_UNSAFE_baseNew = $6f0b6523520f8759$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $6f0b6523520f8759$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6f0b6523520f8759$var$GlobeIcon = (props)=>$6f0b6523520f8759$var$_react.default.createElement($6f0b6523520f8759$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 0 1 8 15.25M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H.75M8 15.25A7.25 7.25 0 0 1 .75 8M8 15.25c1.657 0 3-3.246 3-7.25S9.657.75 8 .75m0 14.5c-1.657 0-3-3.246-3-7.25S6.343.75 8 .75M.75 8A7.25 7.25 0 0 1 8 .75"/>`
        }, props));
    $6f0b6523520f8759$var$GlobeIcon.displayName = 'GlobeIcon';
    var $6f0b6523520f8759$var$_default = module.exports.default = $6f0b6523520f8759$var$GlobeIcon;
});
parcelRegister("4GsX0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36918aadf9f6e08c$var$_react = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36918aadf9f6e08c$var$_globe = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("9x5pH")));
    function $36918aadf9f6e08c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36918aadf9f6e08c$var$WorldIcon = (props)=>$36918aadf9f6e08c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
        }, props, {
            newIcon: $36918aadf9f6e08c$var$_globe.default
        }));
    $36918aadf9f6e08c$var$WorldIcon.displayName = 'WorldIcon';
    var $36918aadf9f6e08c$var$_default = module.exports.default = $36918aadf9f6e08c$var$WorldIcon;
});
parcelRegister("52Mvi", function(module, exports) {
    $parcel$export(module.exports, "WRAPPER", ()=>$02db9db1e823edfb$export$20b8431be300f03e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gwIPs;
    const $02db9db1e823edfb$var$iconWrapperStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        borderRadius: `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px`,
        border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N20A})`}`
    };
    const $02db9db1e823edfb$var$smallIconWrapperStyles = {
        ...$02db9db1e823edfb$var$iconWrapperStyles,
        width: '24px',
        height: '24px'
    };
    const $02db9db1e823edfb$var$mediumIconWrapperStyles = {
        ...$02db9db1e823edfb$var$iconWrapperStyles,
        width: '32px',
        height: '32px'
    };
    const $02db9db1e823edfb$var$WhiteSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightPurpleSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazhbpo _bfhk63rr",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightBlueSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazynhg _bfhk1mdm",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightTealSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazig9t _bfhk16io",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightGreenSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz15qz _bfhkuuj7",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightLimeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazz2ec _bfhktde4",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightYellowSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz13jf _bfhk1v42",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightRedSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz58wa _bfhkr8k0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightMagentaSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz5ct2 _bfhku2x1",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightOrangeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazmfbj _bfhkdpo0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$DarkSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$PurpleSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz63rr _bfhkhbpo",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$BlueSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1mdm _bfhkynhg",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$TealSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz16io _bfhkig9t",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$GreenSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazuuj7 _bfhk15qz",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LimeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaztde4 _bfhkz2ec",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$YellowSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1v42 _bfhk13jf",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$RedSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazr8k0 _bfhk58wa",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$MagentaSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazu2x1 _bfhk5ct2",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$OrangeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazdpo0 _bfhkmfbj",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$WhiteMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightPurpleMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazhbpo _bfhk63rr",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightBlueMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazynhg _bfhk1mdm",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightTealMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazig9t _bfhk16io",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightGreenMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz15qz _bfhkuuj7",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightLimeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazz2ec _bfhktde4",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightYellowMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz13jf _bfhk1v42",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightRedMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz58wa _bfhkr8k0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightMagentaMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz5ct2 _bfhku2x1",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightOrangeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazmfbj _bfhkdpo0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$DarkMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$PurpleMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz63rr _bfhkhbpo",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$BlueMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1mdm _bfhkynhg",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$TealMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz16io _bfhkig9t",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$GreenMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazuuj7 _bfhk15qz",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LimeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaztde4 _bfhkz2ec",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$YellowMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1v42 _bfhk13jf",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$RedMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazr8k0 _bfhk58wa",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$MagentaMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazu2x1 _bfhk5ct2",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$OrangeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazdpo0 _bfhkmfbj",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$export$20b8431be300f03e = {
        small: {
            white: $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'light-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'light-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'light-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'light-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'light-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'light-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'light-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'light-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            dark: $02db9db1e823edfb$var$DarkSmallIconWrapper,
            purple: $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            blue: $02db9db1e823edfb$var$BlueSmallIconWrapper,
            teal: $02db9db1e823edfb$var$TealSmallIconWrapper,
            green: $02db9db1e823edfb$var$GreenSmallIconWrapper,
            yellow: $02db9db1e823edfb$var$YellowSmallIconWrapper,
            red: $02db9db1e823edfb$var$RedSmallIconWrapper,
            magenta: $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            orange: $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'lightest-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'lightest-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'lightest-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'lightest-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'lightest-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'lightest-lime': $02db9db1e823edfb$var$LightLimeSmallIconWrapper,
            'lightest-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'lightest-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            'lightest-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'lightest-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'lighter-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'lighter-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'lighter-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'lighter-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'lighter-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'lighter-lime': $02db9db1e823edfb$var$LightLimeSmallIconWrapper,
            'lighter-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'lighter-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            'lighter-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'lighter-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'darker-gray': $02db9db1e823edfb$var$DarkSmallIconWrapper,
            'darker-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            'darker-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
            'darker-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
            'darker-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
            'darker-lime': $02db9db1e823edfb$var$LimeSmallIconWrapper,
            'darker-yellow': $02db9db1e823edfb$var$YellowSmallIconWrapper,
            'darker-orange': $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'darker-red': $02db9db1e823edfb$var$RedSmallIconWrapper,
            'darker-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            'darkest-gray': $02db9db1e823edfb$var$DarkSmallIconWrapper,
            'darkest-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            'darkest-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
            'darkest-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
            'darkest-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
            'darkest-lime': $02db9db1e823edfb$var$LimeSmallIconWrapper,
            'darkest-yellow': $02db9db1e823edfb$var$YellowSmallIconWrapper,
            'darkest-orange': $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'darkest-red': $02db9db1e823edfb$var$RedSmallIconWrapper,
            'darkest-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            'no-background': $02db9db1e823edfb$var$WhiteSmallIconWrapper
        },
        medium: {
            white: $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'light-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'light-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'light-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'light-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'light-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'light-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'light-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'light-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            dark: $02db9db1e823edfb$var$DarkMediumIconWrapper,
            purple: $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            blue: $02db9db1e823edfb$var$BlueMediumIconWrapper,
            teal: $02db9db1e823edfb$var$TealMediumIconWrapper,
            green: $02db9db1e823edfb$var$GreenMediumIconWrapper,
            yellow: $02db9db1e823edfb$var$YellowMediumIconWrapper,
            red: $02db9db1e823edfb$var$RedMediumIconWrapper,
            magenta: $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            orange: $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'lightest-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'lightest-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'lightest-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'lightest-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'lightest-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'lightest-lime': $02db9db1e823edfb$var$LightLimeMediumIconWrapper,
            'lightest-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'lightest-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            'lightest-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'lightest-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'lighter-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'lighter-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'lighter-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'lighter-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'lighter-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'lighter-lime': $02db9db1e823edfb$var$LightLimeMediumIconWrapper,
            'lighter-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'lighter-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            'lighter-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'lighter-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'darker-gray': $02db9db1e823edfb$var$DarkMediumIconWrapper,
            'darker-purple': $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            'darker-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
            'darker-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
            'darker-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
            'darker-lime': $02db9db1e823edfb$var$LimeMediumIconWrapper,
            'darker-yellow': $02db9db1e823edfb$var$YellowMediumIconWrapper,
            'darker-orange': $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'darker-red': $02db9db1e823edfb$var$RedMediumIconWrapper,
            'darker-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            'darkest-gray': $02db9db1e823edfb$var$DarkMediumIconWrapper,
            'darkest-purple': $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            'darkest-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
            'darkest-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
            'darkest-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
            'darkest-lime': $02db9db1e823edfb$var$LimeMediumIconWrapper,
            'darkest-yellow': $02db9db1e823edfb$var$YellowMediumIconWrapper,
            'darkest-orange': $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'darkest-red': $02db9db1e823edfb$var$RedMediumIconWrapper,
            'darkest-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            'no-background': $02db9db1e823edfb$var$WhiteMediumIconWrapper
        }
    };
});
parcelRegister("eEqSc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eade14dd496994be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $eade14dd496994be$var$ActiveItem = ({ children: children, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement($eade14dd496994be$var$ActiveItemWrapper, {
            "data-testid": testId
        }, children);
    const $eade14dd496994be$var$ActiveItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1sit _bfhkiw92",
                __cmplp.className
            ])
        });
    });
    var $eade14dd496994be$export$2e2bcd8739ae039 = $eade14dd496994be$var$ActiveItem;
});
parcelRegister("e1jn1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1030b7620e8fb1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $a1030b7620e8fb1d$var$LinkLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h _1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _k48p1wq8 _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    var $a1030b7620e8fb1d$export$2e2bcd8739ae039 = $a1030b7620e8fb1d$var$LinkLabel;
});
parcelRegister("jzhSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90049e6de285b9de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dIdda = parcelRequire("dIdda");
    const $90049e6de285b9de$var$SidebarLink = ({ children: children, elemAfter: elemAfter, className: className, testId: testId, isActive: isActive = false, ...other })=>(0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$Wrapper, {
            isActive: isActive,
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$StyledLink, {
            "aria-current": isActive ? 'page' : undefined,
            ...other
        }, children), elemAfter && (0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$ElementAfterWrapper, {
            "data-component-selector": "sidebar-link-elem-after"
        }, elemAfter));
    const $90049e6de285b9de$var$showElementAfter = {
        width: 'inherit !important',
        opacity: 1
    };
    const $90049e6de285b9de$var$ElementAfterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _1bsbgrf3 _tzy4idpf _2hwxu2gc _195pjdj5 _1mygkb7n",
                __cmplp.className
            ])
        });
    });
    const $90049e6de285b9de$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isActive: isActive, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1b30gsy": (0, (0, parcelRequire("lD23V")).default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`),
                "--_dpi1qg": (0, (0, parcelRequire("lD23V")).default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2rko1sit _4t3i1ylp _v5649dqc _1bqoyh40 _rhjqnqa1 _boy0v77o _i9oi194a _ylp5tjc1 _irr3tjc1 _7gg8jdj5 _7ih6kb7n _gnguyh40 _1bv6nqa1 _ygb3v77o _1qtp194a _sbojjewh",
                __cmplp.className
            ])
        });
    });
    const $90049e6de285b9de$var$StyledLink = (0, $5uXOq.forwardRef)(({ as: C = (0, $dIdda.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _1yt4u2gc _1e0c1txw _4cvr1h6o _syazjjyb _1q5t1r31 _nt751r31 _mizu1r31 _1dit1r31 _1ohyglyw _49pcglyw _ra3xglyw _ksodglyw _1r9x1o36 _1hvw1o36 _128m1o36 _4hz81o36 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
                __cmplp.className
            ])
        });
    });
    var $90049e6de285b9de$export$2e2bcd8739ae039 = $90049e6de285b9de$var$SidebarLink;
});
parcelRegister("6KeQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7979212ccba7a92c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $c8Oei;
    var $dWvae;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $1zqLm;
    var $hVL5W;
    var $1tFZj;
    var $cUsQ8;
    const $7979212ccba7a92c$var$PROJECT_LINK_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.project-link';
    const $7979212ccba7a92c$var$getDefaultProjectUrl = (project)=>project.defaultView ? `/jira/core/projects/${project.key}/${project.defaultView}` : `/jira/core/projects/${project.key}`;
    const $7979212ccba7a92c$var$ProjectGroup = ({ sectionId: sectionId, projects: projects, onFavoriteToggle: onFavoriteToggle, currentProjectKey: currentProjectKey, showViewAllProjects: showViewAllProjects = false, viewAllProjectsLabel: viewAllProjectsLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const title = sectionId === 'starred' ? formatMessage((0, (0, parcelRequire("1tFZj")).default).favorites) : formatMessage((0, (0, parcelRequire("1tFZj")).default).recents);
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
        const onToggleExpand = (0, $5uXOq.useCallback)(()=>{
            setIsExpanded(!isExpanded);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'section toggled', 'sidebar', {
                sectionId: sectionId,
                collapse: isExpanded
            });
        }, [
            createAnalyticsEvent,
            isExpanded,
            sectionId
        ]);
        const chevronIcon = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$var$IconWrapper, {
                isExpanded: isExpanded,
                visualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                label: formatMessage(isExpanded ? (0, (0, parcelRequire("1tFZj")).default).collapseSection : (0, (0, parcelRequire("1tFZj")).default).expandSection, {
                    section: title
                }),
                color: "var(--ds-text-subtlest, #626F86)"
            })), [
            formatMessage,
            isExpanded,
            title
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$7d436a88869873b5, {
            "data-testid": `navigation-apps-sidebar-core.ui.multi-project-menu.project-group.${sectionId}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$dca3dbf057c88c5f, {
            "aria-expanded": isExpanded,
            "aria-controls": `multi-project-menu-project-group-${sectionId}`,
            onClick: onToggleExpand,
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-group.toggle"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            iconBefore: chevronIcon
        }), title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dWvae")).Collapsible), {
            id: `multi-project-menu-project-group-${sectionId}`,
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$99bffacbdbcb5195, null, projects.map((project)=>project.key === currentProjectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: project.key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hVL5W")).default), {
                project: project,
                to: $7979212ccba7a92c$var$getDefaultProjectUrl(project),
                onFavoriteToggle: ()=>onFavoriteToggle(project)
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: project.key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1zqLm")).default), {
                project: project,
                to: $7979212ccba7a92c$var$getDefaultProjectUrl(project),
                onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                        projectId: project.id,
                        starred: project.isFavorite,
                        current: false
                    }),
                onFavoriteToggle: ()=>onFavoriteToggle(project),
                prefetch: "hover",
                testId: $7979212ccba7a92c$var$PROJECT_LINK_TEST_ID
            }))), showViewAllProjects && (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cUsQ8")).default), {
            label: viewAllProjectsLabel
        })))));
    };
    var $7979212ccba7a92c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($7979212ccba7a92c$var$ProjectGroup);
    const $7979212ccba7a92c$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isExpanded: isExpanded, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_v5641b1u _k8m01e03",
                __cmplp.isExpanded ? "_t9ec1ul7" : "_t9ec2i46",
                __cmplp.visualRefresh && "_1yt412x7",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$7d436a88869873b5 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _18s83l1n _onzypxbi",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$dca3dbf057c88c5f = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _1e0c1txw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4otz2 _4cvr1h6o _80omtlke _1p1dangw _11c816g6 _zulptij8",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$99bffacbdbcb5195 = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41b66 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dWvae", function(module, exports) {
    $parcel$export(module.exports, "Collapsible", ()=>$fa509c31ea2f76e0$export$6eb0f7ddcda6131f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eNZwU;
    const $fa509c31ea2f76e0$export$6eb0f7ddcda6131f = ({ children: children, id: id, isExpanded: isExpanded, animationDuration: animationDuration = 250 })=>{
        const didMountRef = (0, $5uXOq.useRef)(false);
        const [containerHeight, setContainerHeight] = (0, $5uXOq.useState)(isExpanded ? null : 0);
        const [isRendered, setIsRendered] = (0, $5uXOq.useState)(isExpanded);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const contentRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (isExpanded) {
                setIsRendered(true);
                requestAnimationFrame(()=>{
                    setContainerHeight(contentRef.current?.offsetHeight ?? null);
                    Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setContainerHeight(null);
                    });
                });
            } else {
                setContainerHeight(contentRef.current?.offsetHeight ?? null);
                requestAnimationFrame(()=>{
                    setContainerHeight(0);
                    Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setIsRendered(false);
                    });
                });
            }
        }, [
            contentRef,
            isExpanded
        ]);
        if (!isRendered) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eNZwU")).CollapsibleWrapper), {
            animationDuration: animationDuration,
            containerHeight: containerHeight,
            id: id,
            ref: wrapperRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: contentRef
        }, children));
    };
});
parcelRegister("eNZwU", function(module, exports) {
    $parcel$export(module.exports, "CollapsibleWrapper", ()=>$da05f67abbfb4827$export$417956c58046108f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $da05f67abbfb4827$export$417956c58046108f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { animationDuration: animationDuration, containerHeight: containerHeight, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_3opy9g": (0, (0, parcelRequire("lD23V")).default)(`max-height ${__cmplp.animationDuration}ms ease-in-out`),
                "--_3k6n1g": (0, (0, parcelRequire("lD23V")).default)(__cmplp.containerHeight, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _v564plo1",
                __cmplp.containerHeight != null ? "_c71ld5na" : "_c71ln7od",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1zqLm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47f581e43f4f1b3b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bVfxn;
    var $jzhSN;
    const $47f581e43f4f1b3b$var$ProjectItem = ({ project: project, onClick: onClick, onFavoriteToggle: onFavoriteToggle, to: to, isActive: isActive, className: className, testId: testId, prefetch: prefetch })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            to: to,
            onClick: onClick,
            isActive: isActive,
            elemAfter: project.permissions.viewIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bVfxn")).default), {
                project: project,
                onToggle: onFavoriteToggle
            }),
            className: className,
            testId: testId,
            prefetch: prefetch
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($47f581e43f4f1b3b$var$Avatar, {
            src: project.avatarUrl,
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($47f581e43f4f1b3b$var$ProjectName, null, project.name));
    var $47f581e43f4f1b3b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($47f581e43f4f1b3b$var$ProjectItem);
    const $47f581e43f4f1b3b$var$ProjectName = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _y3gn1e5h _1e0c1ule _o5721q9c _1bto1l2s _k48p1wq8",
                __cmplp.className
            ])
        });
    });
    const $47f581e43f4f1b3b$var$Avatar = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3i1tcg _1bsb1tcg _2hwxutpp _2rko1l7b",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bVfxn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5957c6a2c0f9f04$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5IcUR;
    var $7piTm;
    var $dC5iT;
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $79Jog;
    var $bDKMx;
    const $b5957c6a2c0f9f04$var$FavoriteButton = ({ project: project, onToggle: onToggle })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const label = project.isFavorite ? formatMessage((0, (0, parcelRequire("79Jog")).default).unstar) : formatMessage((0, (0, parcelRequire("79Jog")).default).star);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            const star = !project.isFavorite;
            onToggle(star);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'project starred', 'sidebar', {
                projectId: project.id,
                star: star
            });
        }, [
            project,
            onToggle,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            padding: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            hideTooltipOnClick: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bDKMx")).Button), {
            isFavorite: project.isFavorite ?? false,
            onClick: onClick,
            "data-testid": "navigation-apps-sidebar-core.common.ui.favorite-button"
        }, project.isFavorite ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5IcUR"))))), {
            color: "currentColor",
            label: label
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7piTm"))))), {
            color: "currentColor",
            label: label
        }))));
    };
    var $b5957c6a2c0f9f04$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b5957c6a2c0f9f04$var$FavoriteButton);
});
parcelRegister("5IcUR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $428b14ab8e8af837$var$_react = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $428b14ab8e8af837$var$_starStarred = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("dm1qi")));
    var $428b14ab8e8af837$var$_starFilled = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("bH1hf")));
    function $428b14ab8e8af837$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $428b14ab8e8af837$var$StarStarredIcon = (props)=>$428b14ab8e8af837$var$_react.default.createElement($428b14ab8e8af837$var$_starStarred.default, Object.assign({
            LEGACY_fallbackIcon: $428b14ab8e8af837$var$_starFilled.default
        }, props));
    $428b14ab8e8af837$var$StarStarredIcon.Name = 'StarStarredIconMigration';
    var $428b14ab8e8af837$var$_default = module.exports.default = $428b14ab8e8af837$var$StarStarredIcon;
});
parcelRegister("7piTm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $564985c3728d4aa2$var$_react = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $564985c3728d4aa2$var$_starUnstarred = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("dAf5R")));
    var $564985c3728d4aa2$var$_star = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5oTeF")));
    function $564985c3728d4aa2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $564985c3728d4aa2$var$StarUnstarredIcon = (props)=>$564985c3728d4aa2$var$_react.default.createElement($564985c3728d4aa2$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $564985c3728d4aa2$var$_star.default
        }, props));
    $564985c3728d4aa2$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $564985c3728d4aa2$var$_default = module.exports.default = $564985c3728d4aa2$var$StarUnstarredIcon;
});
parcelRegister("79Jog", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dbb204157c9a073$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2dbb204157c9a073$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        star: {
            "id": "spa-apps-sidebar-core.common.favorite-button.star",
            "defaultMessage": "Add to Starred"
        },
        unstar: {
            "id": "spa-apps-sidebar-core.common.favorite-button.unstar",
            "defaultMessage": "Remove from Starred"
        }
    });
});
parcelRegister("bDKMx", function(module, exports) {
    $parcel$export(module.exports, "Button", ()=>$d9386e07e1778b0a$export$353f5b6fc5456de1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $d9386e07e1778b0a$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4v77o _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $d9386e07e1778b0a$export$353f5b6fc5456de1 = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFavorite: isFavorite, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _11q7glyw _80omtlke _2rko1sit _1spjglyw _157zglyw",
                __cmplp.isFavorite ? "_syazkizl" : "_syazjjyb",
                __cmplp.isFavorite ? "_f8pj1ov0 _30l31ov0 _17051ov0" : "_f8pj1wmz _30l31wmz _17051wmz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hVL5W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4b65956d11fea1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $eEqSc;
    var $1zqLm;
    var $fqbZF;
    const $e4b65956d11fea1d$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.current-project';
    const $e4b65956d11fea1d$var$ActiveProject = ({ project: project, to: to, onFavoriteToggle: onFavoriteToggle })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                projectId: project.id,
                starred: project.isFavorite,
                current: true
            });
        }, [
            createAnalyticsEvent,
            project
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eEqSc")).default), {
            testId: $e4b65956d11fea1d$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1zqLm")).default), {
            project: project,
            to: to,
            isActive: true,
            onClick: onClick,
            onFavoriteToggle: onFavoriteToggle
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fqbZF")).default), null));
    };
    var $e4b65956d11fea1d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e4b65956d11fea1d$var$ActiveProject);
});
parcelRegister("fqbZF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44c9fe648224cdc5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $65Ltd;
    var $k0iPT;
    var $juTur;
    var $231OU;
    var $6jY6G;
    var $gb5lQ;
    var $lPApw;
    var $74Yye;
    var $iCrgB;
    var $2U3dG;
    var $boE05;
    var $chejP;
    var $9nNLl;
    const $44c9fe648224cdc5$var$calculateStack = (route, connectStack, forgeStack)=>{
        const routeName = route && route.name || '';
        if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(routeName) && forgeStack) return forgeStack;
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName) && connectStack) return connectStack;
        return [];
    };
    const $44c9fe648224cdc5$var$ProjectMenu = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("74Yye")).default)();
        const { data: features, loading: isFeaturesLoading } = (0, (0, parcelRequire("lPApw")).useFeatures)();
        const { stack: connectProjectStack } = (0, (0, parcelRequire("lPApw")).useProjectConnectItems)();
        const { stack: connectReportsStack } = (0, (0, parcelRequire("lPApw")).useProjectReportsConnectItems)();
        const { stack: connectSettingsStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsConnectItems)();
        const connectStack = connectProjectStack || connectReportsStack || connectSettingsStack;
        const { loading: projectForgeAppsLoading, stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$44c9fe648224cdc5$var$calculateStack(route, connectStack, forgeStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($44c9fe648224cdc5$var$calculateStack(route, connectStack, forgeStack));
        }, [
            route,
            connectStack,
            forgeStack
        ]);
        if (project == null || isFeaturesLoading || features == null || projectForgeAppsLoading) return null;
        let content = null;
        if ((0, (0, parcelRequire("gb5lQ")).ISSUES_ROUTES_SET).has(route.name)) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("boE05")).default), {
            project: project
        });
        else if ((0, (0, parcelRequire("gb5lQ")).REPORTS_ROUTES_SET).has(route.name) || connectReportsStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chejP")).default), null);
        else if ((0, (0, parcelRequire("gb5lQ")).SETTINGS_ROUTES_SET).has(route.name) || route?.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE) || connectSettingsStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9nNLl")).default), {
            project: project
        });
        else if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(route.name) || forgeStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2U3dG")).default), null);
        else if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) || connectProjectStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iCrgB")).default), {
            stack: stack,
            onStackChange: setStack,
            project: project
        });
        else return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("gb5lQ")).MENU_ID),
            stack: stack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($44c9fe648224cdc5$export$42a852a2b6b56249, null, content));
    };
    const $44c9fe648224cdc5$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4 _fshqh2mm _10p2glyw",
                __cmplp.className
            ])
        });
    });
    var $44c9fe648224cdc5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($44c9fe648224cdc5$var$ProjectMenu);
});
parcelRegister("231OU", function(module, exports) {
    $parcel$export(module.exports, "useProjectForgeApps", ()=>$1a247d2d1d6e7cdf$export$338edd25edcf3648);
    $parcel$export(module.exports, "useProjectForgeAppsNav4", ()=>$1a247d2d1d6e7cdf$export$80e84933a3e2f677);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $dAfqg;
    var $324W5;
    var $kKdpt;
    const $1a247d2d1d6e7cdf$var$useProjectForgeAppsV1 = (routeName, projectKey)=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)(projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV1Resource), projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const projectData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.accessNarrowedExtensions || null, [
            data
        ]);
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(projectData, routeName);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType,
                isProjectAdmin: projectContext.isProjectAdmin,
                isProjectArchived: projectContext.isProjectArchived
            } : {}, [
            projectContext
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectData ? projectData.filter((extension)=>(0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context)) : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error,
                stack: stack
            }), [
            projectData,
            accessNarrowedData,
            loading,
            error,
            stack,
            context
        ]);
    };
    const $1a247d2d1d6e7cdf$var$useProjectForgeAppsV2 = (routeName, projectKey)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV2Resource), projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)(projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType,
                isProjectAdmin: projectContext.isProjectAdmin,
                isProjectArchived: projectContext.isProjectArchived
            } : {}, [
            projectContext
        ]);
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, context, 'project-forge-apps-hook');
        const projectData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)) || null, [
            data
        ]);
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(projectData, routeName);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectData,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error,
                stack: stack
            }), [
            projectData,
            accessNarrowedData,
            loading,
            error,
            stack
        ]);
    };
    const $1a247d2d1d6e7cdf$export$338edd25edcf3648 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $1a247d2d1d6e7cdf$var$useProjectForgeAppsV2, $1a247d2d1d6e7cdf$var$useProjectForgeAppsV1);
    const $1a247d2d1d6e7cdf$export$80e84933a3e2f677 = (projectKey)=>$1a247d2d1d6e7cdf$export$338edd25edcf3648(undefined, projectKey);
});
parcelRegister("awp3q", function(module, exports) {
    $parcel$export(module.exports, "useDoesExtensionMeetConditions", ()=>$bd52741229b769de$export$642911220fb6609f);
    $parcel$export(module.exports, "doesExtensionMeetConditions", ()=>$bd52741229b769de$export$b1e4ed7044e85aa3);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvQVg = parcelRequire("kvQVg");
    var $4Pf62;
    var $daoB1;
    var $9OXo1;
    const $bd52741229b769de$export$642911220fb6609f = ()=>{
        const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        return (0, $5uXOq.useCallback)((extension, extraContext)=>{
            const { displayConditions: displayConditions } = extension.properties;
            if (displayConditions == null) return true;
            const context = {
                ...extraContext,
                isAdmin: isAdmin,
                isLoggedIn: !isAnonymous,
                isSiteAdmin: isSiteAdmin,
                hasCoreAccess: hasCoreAccess,
                hasServiceManagementAccess: hasServiceManagementAccess,
                hasSoftwareAccess: hasSoftwareAccess
            };
            return (0, $kvQVg.doesMeetConditions)(displayConditions, context);
        }, [
            hasCoreAccess,
            hasServiceManagementAccess,
            hasSoftwareAccess,
            isAdmin,
            isAnonymous,
            isSiteAdmin
        ]);
    };
    const $bd52741229b769de$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const context = {
            ...extraContext,
            isAdmin: isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasSoftwareAccess: hasSoftwareAccess,
            hasServiceManagementAccess: hasServiceDeskAccess,
            hasCoreAccess: hasCoreAccess
        };
        return displayConditions ? (0, $kvQVg.doesMeetConditions)(displayConditions, context) : true;
    };
});
parcelRegister("daoB1", function(module, exports) {
    $parcel$export(module.exports, "ApplicationPermissionsSubscriber", ()=>$77add4b5420e5058$export$d8c76f7e52d0a856);
    $parcel$export(module.exports, "useApplicationPermissions", ()=>$77add4b5420e5058$export$4d9cadb4042acc1b);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $7JoAD = parcelRequire("7JoAD");
    var $2gywT;
    var $9OXo1;
    const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
            data: {
                applicationPermissions: applicationPermissions
            }
        }));
    const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("2gywT")).default), {
        displayName: 'ApplicationPermissionsSubscriber',
        selector: $77add4b5420e5058$var$selector
    });
    const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appPermissions;
    };
});
parcelRegister("dvdr4", function(module, exports) {
    $parcel$export(module.exports, "useDisplayConditionsConsistencyCheck", ()=>$79a96011350576c4$export$cd62caf01a15f56b);
    $parcel$export(module.exports, "checkDisplayConditionsConsistency", ()=>$79a96011350576c4$export$4169695e1a68bda7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $dJl1T;
    var $4R6GH;
    var $awp3q;
    var $5cmSg;
    const $79a96011350576c4$export$cd62caf01a15f56b = (data, context = {}, consumer)=>{
        const memoizedContext = $79a96011350576c4$var$useMemoizedStateObject(context);
        const memoizedData = $79a96011350576c4$var$useMemoizedStateObject(data);
        (0, $5uXOq.useEffect)(()=>{
            $79a96011350576c4$export$4169695e1a68bda7(memoizedData, memoizedContext, consumer);
        }, [
            memoizedContext,
            memoizedData,
            consumer
        ]);
    };
    const $79a96011350576c4$export$4169695e1a68bda7 = (data, context = {}, consumer)=>{
        if (data == null) return;
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
            if ('extensions' in data) {
                (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called with a data from the old query', {
                    consumer: consumer
                });
                return;
            }
        } else {
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called while the FG is being turned off', {
                consumer: consumer
            });
            return;
        }
        const falsePositives = new Set();
        const falseNegatives = new Set();
        data.forEach((extension)=>{
            const perClient = (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context);
            const perServer = !(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByDisplayConditions)(extension);
            if (perClient !== perServer) {
                if (perServer) falsePositives.add(extension);
                else falseNegatives.add(extension);
            }
        });
        if (falsePositives.size || falseNegatives.size) (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'Display conditions evaluation is not consistent', {
            consumer: consumer,
            context: JSON.stringify(context),
            falsePositives_count: falsePositives.size,
            falsePositives_data: falsePositives.size ? JSON.stringify(Array.from(falsePositives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null,
            falseNegatives_count: falseNegatives.size,
            falseNegatives_data: falseNegatives.size ? JSON.stringify(Array.from(falseNegatives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null
        });
    };
    const $79a96011350576c4$var$useMemoizedStateObject = (data, equalityCheck = (0, ($parcel$interopDefault($ajpes))))=>{
        const memoizedData = (0, $5uXOq.useRef)(data);
        return (0, $5uXOq.useMemo)(()=>{
            if (!equalityCheck(data, memoizedData.current)) {
                memoizedData.current = data;
                return data;
            }
            return memoizedData.current;
        }, [
            data,
            equalityCheck
        ]);
    };
});
parcelRegister("kKdpt", function(module, exports) {
    $parcel$export(module.exports, "useForgeItemStack", ()=>$dac9c7c54c5ccbb1$export$462f82a278743d46);
    var $5uXOq = parcelRequire("5uXOq");
    var $c70gQ;
    var $dIdda = parcelRequire("dIdda");
    var $7Tlti;
    const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
        const [{ match: match, route: route }] = (0, $dIdda.useRouter)();
        const matchedExtension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (route.name !== routeName) return null;
            if (matchedExtension && (0, (0, parcelRequire("7Tlti")).toSections)(matchedExtension).length) {
                const stackId = `${matchedExtension.id}-subpages`;
                return parentStack ? [
                    ...parentStack,
                    stackId
                ] : [
                    stackId
                ];
            }
            if (matchedExtension && parentStack) return parentStack;
            return null;
        }, [
            matchedExtension,
            parentStack,
            route.name,
            routeName
        ]);
    };
});
parcelRegister("c70gQ", function(module, exports) {
    $parcel$export(module.exports, "useMatchedExtension", ()=>$b661f1f04cec9385$export$13375c0abccaf6f6);
    $parcel$export(module.exports, "useExtensionBasePath", ()=>$b661f1f04cec9385$export$25abed85383f0fbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $e0AC8;
    const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
                const parsedExtensionId = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(app.id);
                return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
            }), [
            modules,
            match.params.appId,
            match.params.envId
        ]);
    const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');
});
parcelRegister("7Tlti", function(module, exports) {
    $parcel$export(module.exports, "toSections", ()=>$25b31557e9750c03$export$29678d1e04c0e8c4);
    var $8QpSo;
    const $25b31557e9750c03$var$normalizeSection = (section)=>({
            header: section?.header,
            pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                    icon: page?.icon,
                    route: page?.route,
                    title: page?.title
                })) : []
        });
    const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, (0, parcelRequire("8QpSo")).default)((extension)=>{
        const { properties: properties } = extension;
        if (typeof properties.resource !== 'string') return [];
        if (typeof properties.pages !== 'undefined' && properties.pages?.length) return [
            {
                pages: properties.pages
            }
        ].map($25b31557e9750c03$var$normalizeSection);
        if (typeof properties.sections !== 'undefined' && properties.sections?.length) return properties.sections.map($25b31557e9750c03$var$normalizeSection);
        return [];
    });
});
parcelRegister("lPApw", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$fd44cc0bd2bece63$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useProjectConnectItems", ()=>$fd44cc0bd2bece63$export$f23d0c24c77d7608);
    $parcel$export(module.exports, "useProjectReportsConnectItems", ()=>$fd44cc0bd2bece63$export$a1c75c386c088992);
    $parcel$export(module.exports, "useProjectSettingsConnectItems", ()=>$fd44cc0bd2bece63$export$41a50100db18b578);
    $parcel$export(module.exports, "useProjectSettingsForgeItems", ()=>$fd44cc0bd2bece63$export$84761bbf25a4f51f);
    var $18FbX;
    var $7OqB4;
    var $hWtQt;
    var $jfqNX;
    var $gZbSF;
    var $6hMYg;
    var $bkw8F;
    const $fd44cc0bd2bece63$export$4a39035bacc4ed76 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useFeatures));
    const $fd44cc0bd2bece63$export$f23d0c24c77d7608 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("gZbSF")).useProjectConnectItems));
    const $fd44cc0bd2bece63$export$a1c75c386c088992 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("hWtQt")).useProjectReportsConnectItems));
    const $fd44cc0bd2bece63$export$41a50100db18b578 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("jfqNX")).useProjectSettingsConnectItems));
    const $fd44cc0bd2bece63$export$84761bbf25a4f51f = (0, (0, parcelRequire("6hMYg")).useProjectSettingsForgeAppsForMenu);
    const $fd44cc0bd2bece63$export$96e8a0c1f4717705 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("18FbX")).useJiraWorkManagementProjectPagesLink));
});
parcelRegister("18FbX", function(module, exports) {
    $parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", ()=>$066b0551287c1b35$export$50628ae0ad1a35f2);
    $parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", ()=>$066b0551287c1b35$export$96e8a0c1f4717705);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $1J3t1;
    const $066b0551287c1b35$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/projects/1.0/pageslink/${projectKey}`;
    const $066b0551287c1b35$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
    const $066b0551287c1b35$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
    const $066b0551287c1b35$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, (0, parcelRequire("eusud")).performPutRequest)($066b0551287c1b35$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, (0, parcelRequire("eusud")).performPutRequest)($066b0551287c1b35$var$disablePagesLinkUrl(baseUrl, projectKey));
    const $066b0551287c1b35$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const $066b0551287c1b35$export$50628ae0ad1a35f2 = ()=>{
        const { data: data, loading: loading, refresh: refresh, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
            await $066b0551287c1b35$var$setPagesLinkService(...args);
            await refresh();
        }, [
            refresh
        ]);
        return {
            data: {
                isEnabled: data?.hasPages === true,
                canEdit: data?.permissionInfo != null && $066b0551287c1b35$var$isProjectOrJiraAdmin(data.permissionInfo),
                pending: loading,
                setPagesLink: setPagesLink
            },
            loading: loading,
            error: error
        };
    };
    const $066b0551287c1b35$export$96e8a0c1f4717705 = ()=>{
        const { loading: loading, refresh: refresh, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
            await $066b0551287c1b35$var$setPagesLinkService(...args);
            await refresh();
        }, [
            refresh
        ]);
        return {
            data: {
                isEnabled: true,
                canEdit: false,
                pending: loading,
                setPagesLink: setPagesLink
            },
            loading: loading,
            error: error
        };
    };
});
parcelRegister("hWtQt", function(module, exports) {
    $parcel$export(module.exports, "useProjectReportsConnectItems", ()=>$a740427f233367ba$export$a1c75c386c088992);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $5W6pd;
    const $a740427f233367ba$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectReportsSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean) : [], [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
                'reports'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            error: error,
            loading: loading,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("jfqNX", function(module, exports) {
    $parcel$export(module.exports, "useProjectSettingsConnectItems", ()=>$662340ab1e9d2787$export$41a50100db18b578);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $5W6pd;
    const $662340ab1e9d2787$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSettingsSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
                'settings'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("gZbSF", function(module, exports) {
    $parcel$export(module.exports, "useProjectConnectItems", ()=>$fcf7bc53994ae8f3$export$f23d0c24c77d7608);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $5W6pd;
    const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("6hMYg", function(module, exports) {
    $parcel$export(module.exports, "useProjectSettingsForgeApps", ()=>$2106846b1818d2e6$export$bef2e514007d2f07);
    $parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", ()=>$2106846b1818d2e6$export$b741e3e3cfb39b82);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $e5wyW;
    var $4R6GH;
    var $k2DRb;
    var $e0AC8;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $dAfqg;
    var $itmJb;
    var $cNd4s;
    var $9OXo1;
    var $dIdda = parcelRequire("dIdda");
    var $kKdpt;
    var $7Tlti;
    const $2106846b1818d2e6$export$3c509d6dc1f63bbe = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleV1Resource));
        const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.accessNarrowedExtensions || null, [
            data
        ]);
        const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
            isAdmin,
            isSiteAdmin,
            projectContext?.isProjectAdmin
        ]);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType
            } : {}, [
            projectContext
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectSettingsData ? projectSettingsData.filter((extension)=>hasPermissions && (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context)) : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error
            }), [
            projectSettingsData,
            accessNarrowedData,
            loading,
            error,
            hasPermissions,
            context
        ]);
    };
    const $2106846b1818d2e6$export$5aac3b333ac18e0d = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleV2Resource));
        const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)) || null, [
            data
        ]);
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
            isAdmin,
            isSiteAdmin,
            projectContext?.isProjectAdmin
        ]);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType
            } : {}, [
            projectContext
        ]);
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, context, 'project-settings-forge-apps-hook');
        return (0, $5uXOq.useMemo)(()=>({
                data: projectSettingsData ? hasPermissions && projectSettingsData || [] : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error
            }), [
            projectSettingsData,
            accessNarrowedData,
            loading,
            error,
            hasPermissions
        ]);
    };
    const $2106846b1818d2e6$export$bef2e514007d2f07 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $2106846b1818d2e6$export$5aac3b333ac18e0d, $2106846b1818d2e6$export$3c509d6dc1f63bbe);
    const $2106846b1818d2e6$var$appsProjectTypeRouteMap = {
        tmp: {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: undefined,
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: undefined
        },
        cmp: {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software/c',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: undefined,
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: undefined
        }
    };
    const $2106846b1818d2e6$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/${$2106846b1818d2e6$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
    };
    const $2106846b1818d2e6$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = $2106846b1818d2e6$export$bef2e514007d2f07();
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(data, routeName, parentStack);
        const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
        return (0, $5uXOq.useMemo)(()=>({
                data: data ? data.map((extension)=>({
                        id: extension.id,
                        url: $2106846b1818d2e6$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                        name: extension.properties.title,
                        iconUrl: extension.properties.icon,
                        environmentType: extension.environmentType,
                        environmentKey: extension.environmentKey,
                        moduleName: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
                        sections: (0, (0, parcelRequire("7Tlti")).toSections)(extension)
                    })) : null,
                loading: loading,
                error: error,
                stack: stack
            }), [
            data,
            loading,
            error,
            stack,
            projectType,
            projectKey,
            isSimplified
        ]);
    };
});
parcelRegister("cNd4s", function(module, exports) {
    $parcel$export(module.exports, "useIsSiteAdmin", ()=>$3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);
    var $9OXo1;
    const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isSiteAdmin || false;
    };
});
parcelRegister("bkw8F", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$7fc2f0545f0a83ac$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useSettingFeatures", ()=>$7fc2f0545f0a83ac$export$56022a3b83c8ed6a);
    $parcel$export(module.exports, "useReportFeatures", ()=>$7fc2f0545f0a83ac$export$4adaea9828b7ff13);
    var $5uXOq = parcelRequire("5uXOq");
    var $1J3t1;
    var $jIwth;
    var $iNzEe;
    var $daoB1;
    var $d4FZj;
    const $7fc2f0545f0a83ac$export$4a39035bacc4ed76 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraData)(data, isPremiumUserSeat), [
            data,
            isPremiumUserSeat
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
    const $7fc2f0545f0a83ac$export$56022a3b83c8ed6a = ()=>{
        const hasActiveSoftwareAccess = (0, (0, parcelRequire("jIwth")).useHasActiveSoftwareAccess)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraSettingsData)(data, hasActiveSoftwareAccess), [
            data,
            hasActiveSoftwareAccess
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
    const $7fc2f0545f0a83ac$export$4adaea9828b7ff13 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const { hasSoftwareAccess: hasSoftwareAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraReportData)(hasSoftwareAccess), [
            data,
            hasSoftwareAccess
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("jIwth", function(module, exports) {
    $parcel$export(module.exports, "useHasActiveSoftwareAccess", ()=>$c3adde43a433f1b5$export$895f9b38ce00671e);
    var $k9JTq;
    var $daoB1;
    const $c3adde43a433f1b5$export$895f9b38ce00671e = ()=>{
        const { software: software } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { hasSoftwareAccess: hasSoftwareAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        return software !== 'UNLICENSED' && hasSoftwareAccess === true;
    };
});
parcelRegister("k9JTq", function(module, exports) {
    $parcel$export(module.exports, "useAppEditions", ()=>$dde261c9da85268a$export$92ed15881fc090d7);
    var $9OXo1;
    const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appEditions;
    };
});
parcelRegister("d4FZj", function(module, exports) {
    $parcel$export(module.exports, "getExtraData", ()=>$acf9418ce967848e$export$6c55c6c980ed2046);
    $parcel$export(module.exports, "getExtraSettingsData", ()=>$acf9418ce967848e$export$b77a5597b7177cfb);
    $parcel$export(module.exports, "getExtraReportData", ()=>$acf9418ce967848e$export$be58a1e7b06d1d3);
    var $co1wz;
    var $4R6GH;
    const $acf9418ce967848e$export$6c55c6c980ed2046 = (data, isPremium)=>{
        const { permissionInfo: permissionInfo, hasComponents: hasComponents = false, project: project } = data;
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
        const isProjectOrJiraAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true || isAdmin;
        const isSimplifiedProject = project.simplified;
        const hasSettings = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS || projectPermissionsQueried.EDIT_ISSUE_LAYOUT || projectPermissionsQueried.EDIT_WORKFLOW;
        return {
            hasVersions: true,
            hasSettings: (0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5') ? hasSettings : isProjectOrJiraAdmin,
            hasBoard: true,
            hasReports: true,
            hasAddItem: isProjectOrJiraAdmin,
            hasComponents: hasComponents,
            hasIssues: true,
            hasSummary: true,
            hasPages: true,
            hasChangeTheme: isProjectOrJiraAdmin,
            hasApprovals: isSimplifiedProject && (isPremium || isProjectOrJiraAdmin)
        };
    };
    const $acf9418ce967848e$export$b77a5597b7177cfb = (data, hasActiveSoftwareAccess)=>{
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = data.permissionInfo;
        const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
        const isProjectOrJiraAdmin = isProjectAdmin || isAdmin;
        const isCMPProject = !data.project.simplified;
        const hasEditWorkflowPermissions = projectPermissionsQueried.EDIT_WORKFLOW === true;
        const hasIssueLayoutPermissions = projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
        const hasDetails = isProjectOrJiraAdmin;
        const hasPeople = isProjectOrJiraAdmin;
        const hasIssueTypes = isAdmin;
        let hasAutomation = true;
        let hasSummary = true;
        let hasWorkflows = true;
        let hasScreens = true;
        let hasSystemFieldsConfiguration = true;
        let hasProjectEfaFields = false;
        let hasVersions = true;
        let hasComponents = true;
        let hasPermissions = true;
        let hasIssueSecurity = true;
        let hasNotifications = true;
        let hasIssueCollectors = true;
        let hasIssueLayout = true;
        const hasDevtools = isProjectAdmin && hasActiveSoftwareAccess;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            hasAutomation = isProjectOrJiraAdmin;
            hasSummary = isProjectOrJiraAdmin;
            hasWorkflows = hasEditWorkflowPermissions || isProjectOrJiraAdmin;
            hasScreens = isProjectOrJiraAdmin;
            hasSystemFieldsConfiguration = isCMPProject && isProjectOrJiraAdmin;
            hasVersions = isProjectOrJiraAdmin;
            hasComponents = isProjectOrJiraAdmin;
            hasPermissions = isProjectOrJiraAdmin;
            hasIssueSecurity = isProjectOrJiraAdmin;
            hasNotifications = isProjectOrJiraAdmin;
            hasIssueCollectors = isProjectOrJiraAdmin;
            hasIssueLayout = hasIssueLayoutPermissions || isProjectOrJiraAdmin;
        }
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_fields_page_for_tmp_-_mvp')) hasProjectEfaFields = !isCMPProject && isProjectOrJiraAdmin && !!data.hasExplicitFieldAssociationsEnabled;
        return {
            hasAutomation: hasAutomation,
            hasProjectGroupOneSection: hasDetails || hasPeople || hasSummary,
            hasIssueConfigSection: hasIssueTypes,
            hasProjectGroupTwoSection: hasWorkflows || hasScreens || hasSystemFieldsConfiguration,
            hasProjectGroupThreeSection: hasVersions || hasComponents,
            hasProjectGroupFourSection: hasPermissions || hasIssueSecurity || hasNotifications,
            hasgetIssueCollectorSection: hasIssueCollectors,
            hasComponents: hasComponents,
            hasDetails: hasDetails,
            hasSystemFieldsConfiguration: hasSystemFieldsConfiguration,
            hasProjectEfaFields: hasProjectEfaFields,
            hasIssueCollectors: hasIssueCollectors,
            hasIssueSecurity: hasIssueSecurity,
            hasIssueTypes: hasIssueTypes,
            hasNotifications: hasNotifications,
            hasPeople: hasPeople,
            hasPermissions: hasPermissions,
            hasScreens: hasScreens,
            hasSummary: hasSummary,
            hasVersions: hasVersions,
            hasWorkflows: hasWorkflows,
            hasDevtools: hasDevtools,
            hasIssueLayout: hasIssueLayout
        };
    };
    const $acf9418ce967848e$export$be58a1e7b06d1d3 = (hasSoftwareAccess)=>({
            hasDeveloperWorkload: true,
            hasForcastSection: true,
            hasTimeTracking: true,
            hasVersionWorkloadReport: hasSoftwareAccess
        });
});
parcelRegister("74Yye", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d2a068828302038$export$2e2bcd8739ae039);
    var $lpwtK;
    var $7OqB4;
    const $3d2a068828302038$var$useProject = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    var $3d2a068828302038$export$2e2bcd8739ae039 = $3d2a068828302038$var$useProject;
});
parcelRegister("iCrgB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$116dde1e3871ac6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    var $gjTBi;
    var $koVbs;
    var $3tHFY;
    var $gZbSF;
    var $8yg0C;
    var $cqRWX;
    const $116dde1e3871ac6a$var$ConnectAppMenu = ({ stack: stack, project: project, onStackChange: onStackChange })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const { data: connectItems, stack: connectStack, selected: selectedConnectApp } = (0, (0, parcelRequire("gZbSF")).useProjectConnectItems)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectKey = String(project?.key);
        const getBackMenuItem = (0, $5uXOq.useCallback)(()=>({
                href: `/jira/core/projects/${projectKey}`,
                title: formatMessage((0, (0, parcelRequire("cqRWX")).messages).itemBack)
            }), [
            formatMessage,
            projectKey
        ]);
        if (connectStack != null && connectStack.length > 0 && selectedConnectApp != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            stack: stack,
            onChange: onStackChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3tHFY")).ConnectMenu), {
            items: connectItems,
            showIcons: true,
            overrides: {
                BackMenuItem: getBackMenuItem(),
                navigateOnBackMenuItemClick: true
            }
        })));
        return null;
    };
    var $116dde1e3871ac6a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($116dde1e3871ac6a$var$ConnectAppMenu);
});
parcelRegister("8yg0C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$389170a5379f53c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    const $389170a5379f53c2$var$useAutoExpandSidebar = ()=>{
        const { expandLeftSidebar: expandLeftSidebar } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarController)();
        const { isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const sidebarExpandedRef = (0, $5uXOq.useRef)(!isCollapsed);
        (0, $5uXOq.useEffect)(()=>{
            if (!sidebarExpandedRef.current && isCollapsed) {
                expandLeftSidebar();
                sidebarExpandedRef.current = true;
            }
        }, [
            expandLeftSidebar,
            isCollapsed
        ]);
    };
    var $389170a5379f53c2$export$2e2bcd8739ae039 = $389170a5379f53c2$var$useAutoExpandSidebar;
});
parcelRegister("cqRWX", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$dd966ae40fe1732a$export$defe85febe8b728c);
    var $7VHMR;
    const $dd966ae40fe1732a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.connect-app-menu.item-back",
            "defaultMessage": "Back to project"
        }
    });
});
parcelRegister("2U3dG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46153d687d6c578f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $7XYc4;
    var $4R6GH;
    var $5cmSg;
    var $5bkvv;
    var $ih1Yr;
    var $231OU;
    var $8zgGo;
    var $6jY6G;
    var $dIdda = parcelRequire("dIdda");
    var $8yg0C;
    const $46153d687d6c578f$var$ForgeMenuV1 = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: forgeResourceData } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV1Resource));
        const projectData = (0, $5uXOq.useMemo)(()=>forgeResourceData?.extensions || null, [
            forgeResourceData
        ]);
        const selectedForgeApp = (0, (0, parcelRequire("ih1Yr")).useForgeSelectedApp)(projectData, route.name);
        const { stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8zgGo")).ForgeProjectSection), {
            overrides: {
                showSelectedAppMenuOnly: true,
                selectedApp: selectedForgeApp
            }
        });
        return null;
    };
    const $46153d687d6c578f$var$ForgeMenuV2 = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: forgeResourceData } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV2Resource));
        const projectData = (0, $5uXOq.useMemo)(()=>forgeResourceData?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            forgeResourceData
        ]);
        const selectedForgeApp = (0, (0, parcelRequire("ih1Yr")).useForgeSelectedApp)(projectData, route.name);
        const { stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8zgGo")).ForgeProjectSection), {
            overrides: {
                showSelectedAppMenuOnly: true,
                selectedApp: selectedForgeApp
            }
        });
        return null;
    };
    const $46153d687d6c578f$var$ForgeMenu = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $46153d687d6c578f$var$ForgeMenuV2, $46153d687d6c578f$var$ForgeMenuV1);
    var $46153d687d6c578f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($46153d687d6c578f$var$ForgeMenu);
});
parcelRegister("ih1Yr", function(module, exports) {
    $parcel$export(module.exports, "useForgeSelectedApp", ()=>$b1393ffdd951bcc8$export$e6dee8b777476118);
    var $c70gQ;
    var $dIdda = parcelRequire("dIdda");
    const $b1393ffdd951bcc8$export$e6dee8b777476118 = (modules, routeName)=>{
        const [{ match: match, route: route }] = (0, $dIdda.useRouter)();
        const matchedExtension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        if (route.name !== routeName || matchedExtension == null) return null;
        return matchedExtension;
    };
});
parcelRegister("8zgGo", function(module, exports) {
    $parcel$export(module.exports, "ForgeProjectSection", ()=>$4cec53abbd9c3c33$export$fb7da191295a7e22);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $2vSU6;
    var $1rTGO;
    var $bXK4r;
    var $k2DRb;
    var $e0AC8;
    var $koVbs;
    var $dAfqg;
    var $k51JQ;
    var $7Tlti;
    var $231OU;
    var $kBPYs;
    const $4cec53abbd9c3c33$var$projectTypeRouteMap = {
        [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
        [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk'
    };
    const $4cec53abbd9c3c33$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/${$4cec53abbd9c3c33$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
    };
    const $4cec53abbd9c3c33$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
        const { data: data } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)();
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filteredForgeAppsData = (0, $5uXOq.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
                overrides.selectedApp
            ] : data || [], [
            data,
            overrides
        ]);
        if (!data?.length || !projectContextData) return null;
        const { projectKey: projectKey, projectType: projectType } = projectContextData;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bXK4r")).TriggerAnalyticsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, (0, parcelRequire("kBPYs")).messages).forgeSectionTitle)
        }, filteredForgeAppsData.map((extension)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                key: extension.id,
                id: extension.id,
                environmentType: extension.environmentType,
                environmentKey: extension.environmentKey,
                url: $4cec53abbd9c3c33$export$ed6342e0e28465a6(extension, projectType, projectKey),
                name: extension.properties.title,
                sections: (0, (0, parcelRequire("7Tlti")).toSections)(extension),
                moduleName: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
                iconUrl: extension.properties.icon,
                showIcon: true,
                nestedMenuActive: nestedMenuActive,
                overrides: overrides
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
            attributes: {
                moduleType: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE)
            }
        })));
    };
});
parcelRegister("1rTGO", function(module, exports) {
    $parcel$export(module.exports, "ForgeScreenEvent", ()=>$abbdb580491d9d09$export$92d758d83665314b);
    $parcel$export(module.exports, "ForgeOperationaFailedEvent", ()=>$abbdb580491d9d09$export$a238c3c13f29c134);
    $parcel$export(module.exports, "ForgeErrorBoundary", ()=>$abbdb580491d9d09$export$ac7e7464cefab440);
    $parcel$export(module.exports, "ForgeAnalyticsWrapper", ()=>$abbdb580491d9d09$export$ad2a5d9127152fb8);
    $parcel$export(module.exports, "withMetrics", ()=>$abbdb580491d9d09$export$14e56d7f5d3f917c);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $k2DRb;
    var $3mOWa;
    var $eOGyv;
    var $iXVV6;
    var $8zOmE;
    var $5oFIy;
    var $isuse;
    var $hBuqR;
    var $9BrHy;
    var $6MtPV;
    var $dd7Uh;
    var $2RhPB;
    var $8kVg1;
    const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: (0, (0, parcelRequire("6MtPV")).createAttributes)(attributes)
        });
    const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
        (0, (0, parcelRequire("dd7Uh")).fireOperationalFailedEvent)({
            eventId: eventId,
            attributes: attributes
        });
        return null;
    };
    const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
        const hasForgeAccess = (0, (0, parcelRequire("eOGyv")).useHasForgeAccess)();
        const analyticsAttributes = (0, (0, parcelRequire("6MtPV")).createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        });
        const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, (0, (0, parcelRequire("9BrHy")).getEventActionName)(eventId, action), analyticsAttributes);
        }, [
            eventId,
            action,
            analyticsAttributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: fireEvent
        });
    };
    const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.${eventId}`
        }, children);
    const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
        const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
            errorFallback
        ]);
        const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, (0, parcelRequire("6MtPV")).createAttributes)({
                ...attributes,
                error: error
            }), [
            attributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: eventId,
            packageName: (0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3),
            teamName: "smite",
            fallback: fallback,
            attributes: getAttributes,
            onError: onError,
            resetCaughtError: resetCaughtError
        }, children);
    };
    const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
        const eventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
            module: module,
            moduleType: moduleType,
            entryPoint: entryPoint
        });
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6MtPV")).createAttributes)(attributes), [
            attributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
            eventId: eventId,
            attributes: analyticsAttributes,
            errorFallback: errorFallback,
            resetCaughtError: resetCaughtError
        }, shouldFireInitializedEvent && (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
            eventId: eventId,
            action: "initialized",
            attributes: analyticsAttributes
        }), children));
    };
    function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
        if ((extensionModule === (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE) || extensionModule === (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
        if (extensionModule === (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
        return [
            (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
        ].includes(extensionModule);
    }
    const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
            const startTime = (0, $5uXOq.useRef)(performance.now());
            const isCustomUI = (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(props.extension, props.entryPoint);
            const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
            const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
            const extensionId = props.extension?.id;
            const eventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
                module: module,
                entryPoint: entryPoint
            });
            const browserMetricsEventId = (0, (0, parcelRequire("9BrHy")).getBrowserMetricsEventId)({
                module: module,
                entryPoint: entryPoint,
                forgeUiType: (0, (0, parcelRequire("3mOWa")).getForgeUIType)(extension, entryPoint)
            });
            const attributes = (0, $5uXOq.useMemo)(()=>({
                    ...analyticsAttributes,
                    ...(0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(extension, entryPoint)
                }), [
                analyticsAttributes,
                entryPoint,
                extension.id,
                isCustomUI
            ]);
            (0, $5uXOq.useEffect)(()=>{
                if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).start({
                    startTime: startTime.current
                });
            }, []);
            const onError = (0, $5uXOq.useCallback)(()=>{
                extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).cancel();
            }, [
                extensionId
            ]);
            const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
                onInitialRender && onInitialRender(payload);
                if (payload?.error == null) {
                    const stopTimeDeduction = payload?.appTime || 0;
                    setExtensionRendered(true);
                    extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).stop({
                        stopTime: performance.now() - stopTimeDeduction,
                        customData: {
                            eventId: browserMetricsEventId
                        }
                    });
                } else {
                    onError();
                    (0, (0, parcelRequire("dd7Uh")).fireOperationalFailedEvent)({
                        eventId: eventId,
                        attributes: {
                            error: new Error(payload.error),
                            ...attributes
                        }
                    });
                }
            }, [
                onInitialRender,
                extensionId,
                browserMetricsEventId,
                onError,
                eventId,
                attributes
            ]);
            const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
                onLoad && onLoad();
                setExtensionRendered(true);
                extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now(),
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            }, [
                analyticsAttributes,
                extensionId,
                localId,
                onLoad
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
                eventId: eventId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ...isCustomUI ? {
                    onLoad: onLoadCustomUiWithMetrics
                } : {
                    onInitialRender: onInitialRenderUiKitWithMetrics
                }
            }), isExtensionRendered && (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
                attributes: attributes
            }));
        };
});
parcelRegister("3mOWa", function(module, exports) {
    $parcel$export(module.exports, "getForgeUIType", ()=>$e79bbc527e600bd1$export$aed4d8a86badbf61);
    $parcel$export(module.exports, "isCustomUIExtension", ()=>$e79bbc527e600bd1$export$edb00cfe4962b026);
    $parcel$export(module.exports, "isNativeUiExtension", ()=>$e79bbc527e600bd1$export$2ecba06e617fea0a);
    $parcel$export(module.exports, "overrideExtension", ()=>$e79bbc527e600bd1$export$42b85bc9b386c977);
    var $gccSB = parcelRequire("gccSB");
    const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
        const { render: render, resource: resource } = extension.properties;
        if (entryPoint && extension.properties[entryPoint]) {
            const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
            if (entryPointResource == null) return 'ui-kit';
            if (entryPointRender === 'native') return 'native-ui';
            return 'custom-ui';
        }
        if (resource == null) return 'ui-kit';
        if (render === 'native') return 'native-ui';
        return 'custom-ui';
    };
    const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
    const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
    const $e79bbc527e600bd1$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
        if (extension == null) return extension;
        if ((0, ($parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
        const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
        const extensionCopy = {
            ...extension,
            properties: {
                ...extension.properties
            },
            requiresUserConsent: requiresUserConsent
        };
        if (resource != null) extensionCopy.properties.resource = resource;
        return extensionCopy;
    };
});
parcelRegister("eOGyv", function(module, exports) {
    $parcel$export(module.exports, "useHasForgeAccess", ()=>$5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);
    var $cZpsT;
    const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        return !isAnonymous;
    };
});
parcelRegister("isuse", function(module, exports) {
    $parcel$export(module.exports, "MountEvent", ()=>$1df0619a43ad69d9$export$2c6963927dbc68f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'mounted'
            });
            if (this.props.onMount) this.props.onMount(analyticsEvent);
        }
        render() {
            return null;
        }
    }
    const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, (0, parcelRequire("cb25w")).default)()($1df0619a43ad69d9$var$MountEventComponent);
});
parcelRegister("9BrHy", function(module, exports) {
    $parcel$export(module.exports, "getEventId", ()=>$10bc2a9e37d5a5bb$export$5639f6a927500d9);
    $parcel$export(module.exports, "getBrowserMetricsEventId", ()=>$10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
    $parcel$export(module.exports, "getEventActionName", ()=>$10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);
    var $k2DRb;
    var $6yg2S;
    var $hBuqR;
    const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
    const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
    const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
    const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, (0, parcelRequire("k2DRb")).SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
    const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
        const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
        return (0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
    };
    const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
    const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${eventId} ${action}`;
});
parcelRegister("dd7Uh", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalFailedEvent", ()=>$7d829a81d29f9e72$export$add44f896fb31ba3);
    var $hBuqR;
    var $8uOa6;
    const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
        (0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).FAILED, {
            id: eventId,
            attributes: attributes
        });
    };
});
parcelRegister("2RhPB", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsAttributesFromExtension", ()=>$3fba0b567cec1fe0$export$5d3b06ab08af139e);
    var $3mOWa;
    var $e0AC8;
    const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return {
            appId: appId,
            envId: envId,
            forgeType: (0, (0, parcelRequire("3mOWa")).getForgeUIType)(extension, entryPoint),
            envType: extension?.environmentType
        };
    };
});
parcelRegister("bXK4r", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$488beba58e0bb189$export$c794eb4124961145);
    $parcel$export(module.exports, "TriggerAnalyticsWrapper", ()=>$488beba58e0bb189$export$e1a79e3d472c925a);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    var $hBuqR;
    const $488beba58e0bb189$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $488beba58e0bb189$export$e1a79e3d472c925a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
            ...props
        });
});
parcelRegister("k51JQ", function(module, exports) {
    $parcel$export(module.exports, "ForgeSubpagesView", ()=>$b3f0da209e047dcf$export$9711365f685f75c0);
    $parcel$export(module.exports, "ForgeItem", ()=>$b3f0da209e047dcf$export$26a5287439a1d287);
    var $5uXOq = parcelRequire("5uXOq");
    var $apKqz;
    var $gjTBi;
    var $gwIPs;
    var $8kVg1;
    var $fl3Yy;
    var $k0ZZ2;
    var $jv9Yy;
    var $8iQMc;
    var $kZj7F;
    var $4OCke;
    var $6ucD2;
    const $b3f0da209e047dcf$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
    const $b3f0da209e047dcf$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ucD2")).ForgeIcon), {
            alt: "",
            src: url
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("apKqz"))))), {
            label: ""
        });
    const $b3f0da209e047dcf$export$df3259e43d89ee7b = (props)=>{
        const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
        if (overrides?.showSelectedAppMenuOnly) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                url: iconUrl
            }) : null,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
                environmentType: environmentType
            }),
            href: url,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchPartialUrlPathname)(),
            analytics: {
                itemId: itemId,
                itemType: 'forge',
                module: moduleName
            },
            onClick: ()=>{
                (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey));
    };
    const $b3f0da209e047dcf$var$nestedHeaderAlignmentFix = ()=>({
            paddingLeft: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2.625}px`
        });
    const $b3f0da209e047dcf$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, (0, parcelRequire("8iQMc")).ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ForgePageHeader, {
            avatarUrl: iconUrl || '',
            name: name,
            environmentType: environmentType,
            environmentKey: environmentKey,
            cssFn: typeof nestedMenuActive === 'boolean' && Boolean(nestedMenuActive) ? $b3f0da209e047dcf$var$nestedHeaderAlignmentFix : undefined
        });
    const $b3f0da209e047dcf$export$9711365f685f75c0 = (props)=>{
        const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
        const selectedOn = (0, $5uXOq.useCallback)((route)=>[
                '',
                '/'
            ].includes(String(route || '').trim()) ? (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, (0, parcelRequire("4OCke")).matchPartialUrlPathname)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ucD2")).ForgeSubpagesContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$961eebe0deda9ad3, props), sections?.map((section, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
                key: index
            }, typeof section.header === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jv9Yy")).SectionHeader), null, section.header) : null, section.pages.map((page)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                    key: page.route,
                    iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                        url: page.icon
                    }) : null,
                    href: $b3f0da209e047dcf$export$9ffb311b483a1e2b(url, page.route),
                    selectedOn: selectedOn(page.route),
                    analytics: {
                        itemId: itemId,
                        itemType: 'forge',
                        module: moduleName
                    },
                    onClick: ()=>{
                        (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(itemId).start({
                            startTime: performance.now()
                        });
                    }
                }, page.title)))));
    };
    const $b3f0da209e047dcf$export$26a5287439a1d287 = (props)=>{
        const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
        const selectedOn = (0, $5uXOq.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
            url
        ]);
        const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(event);
        }, [
            overrides
        ]);
        if (!sections?.length) return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$df3259e43d89ee7b, props);
        if (overrides?.showSelectedAppMenuOnly) return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'subpages'
            },
            id: `${itemId}-subpages`,
            iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                url: iconUrl
            }) : null,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
                environmentType: environmentType
            }),
            title: (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey),
            selectedOn: selectedOn,
            onClick: onNestedMenuItemClick,
            overrides: overrides
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props));
    };
});
parcelRegister("fl3Yy", function(module, exports) {
    $parcel$export(module.exports, "EnvironmentLozenge", ()=>$730173a4987fa3e4$export$278f8e01799d0418);
    $parcel$export(module.exports, "nameWithCustomEnvironment", ()=>$730173a4987fa3e4$export$f9338c21ba7c7334);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $k2DRb;
    var $ousew;
    var $8Je4V;
    const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
        switch(environmentType){
            case 0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT:
                return (0, (0, parcelRequire("8Je4V")).messages).developmentEnvironmentLozenge;
            case 0, (0, parcelRequire("k2DRb")).STAGING_ENVIRONMENT:
                return (0, (0, parcelRequire("8Je4V")).messages).stagingEnvironmentLozenge;
            default:
                return null;
        }
    };
    const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
        const { environmentType: environmentType } = props;
        const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
        return labelKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
            appearance: environmentType === (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), labelKey)) : null;
    };
    const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
        if (environmentType === (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, (0, parcelRequire("k2DRb")).DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
        return name;
    };
});
parcelRegister("8Je4V", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$838ac71f7259b5ef$export$defe85febe8b728c);
    var $7VHMR;
    const $838ac71f7259b5ef$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        developmentEnvironmentLozenge: {
            "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
            "defaultMessage": "DEV"
        },
        stagingEnvironmentLozenge: {
            "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
            "defaultMessage": "STG"
        }
    });
});
parcelRegister("jv9Yy", function(module, exports) {
    $parcel$export(module.exports, "SectionHeader", ()=>$c634a42deba697de$export$8adb256d999cd5a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2V4l;
    var $fpoBX;
    var $2WgzA;
    const $c634a42deba697de$export$8adb256d999cd5a0 = ({ children: children })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("2WgzA")).generateCustomThemeCssFn)(theme), [
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2V4l")).default), {
            cssFn: cssFn
        }, children);
    };
});
parcelRegister("c2V4l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6289355db2eea81d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mNf3;
    var $jsTfk;
    var $j9VTE;
    const $6289355db2eea81d$var$HeadingItem = (props)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssFn = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)((0, (0, parcelRequire("jsTfk")).sectionHeaderSpacingStyles), props.cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4mNf3")).default), {
            ...props,
            cssFn: cssFn
        });
    };
    var $6289355db2eea81d$export$2e2bcd8739ae039 = $6289355db2eea81d$var$HeadingItem;
});
parcelRegister("2WgzA", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$e23e3f934bc5813e$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $e23e3f934bc5813e$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    color: item?.color?.default,
                    opacity: item?.opacity
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("8iQMc", function(module, exports) {
    $parcel$export(module.exports, "ForgePageHeader", ()=>$5bbfd34eb4e2a6d6$export$a4f83f6df17decd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $ujWmd;
    var $apKqz;
    var $juVrZ;
    var $fl3Yy;
    var $fpoBX;
    var $2gYaQ;
    var $146Nh;
    const $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, (0, parcelRequire("ujWmd")).default), AddonIcon: AddonIcon = (0, ($parcel$interopDefault((0, parcelRequire("apKqz"))))), CssFixContainer: CssFixContainer = (0, (0, parcelRequire("146Nh")).CssFixContainerDI), Header: Header = (0, (0, parcelRequire("juVrZ")).default), cssFn: cssFn, EnvironmentLozenge: EnvironmentLozenge = (0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const headerCssFn = (0, $5uXOq.useMemo)(()=>cssFn ? (0, ($parcel$interopDefault($basmW)))([
                cssFn,
                (0, (0, parcelRequire("2gYaQ")).generateCustomThemeCssFn)(theme)
            ]) : (0, (0, parcelRequire("2gYaQ")).generateCustomThemeCssFn)(theme), [
            cssFn,
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(CssFixContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Header, {
            cssFn: headerCssFn,
            iconBefore: avatarUrl?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement(Avatar, {
                appearance: "square",
                borderColor: "transparent",
                size: "small",
                src: `${avatarUrl}?size=xxlarge`
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(AddonIcon, {
                label: "",
                size: "medium"
            }),
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement(EnvironmentLozenge, {
                environmentType: environmentType
            })
        }, (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey)));
    };
});
parcelRegister("2gYaQ", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$8e94d1e3a18b3b00$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $8e94d1e3a18b3b00$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    backgroundColor: item?.background?.default ?? undefined,
                    color: item?.color?.default ?? undefined,
                    '[data-item-title]': {
                        color: item?.color?.default ?? undefined
                    },
                    '[data-item-description]': {
                        color: item?.color?.default ?? undefined
                    }
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("146Nh", function(module, exports) {
    $parcel$export(module.exports, "CssFixContainerDI", ()=>$839ef628ec3ac6e5$export$eee12c3955319ddc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $839ef628ec3ac6e5$export$eee12c3955319ddc = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1lfu1kw7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6ucD2", function(module, exports) {
    $parcel$export(module.exports, "ForgeIcon", ()=>$8f7b3d92c79c1fad$export$fe0464db4dc93ab4);
    $parcel$export(module.exports, "ForgeSubpagesContainer", ()=>$8f7b3d92c79c1fad$export$682ee8eb4890e553);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $8f7b3d92c79c1fad$export$fe0464db4dc93ab4 = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbgktf _4t3igktf",
                __cmplp.className
            ])
        });
    });
    const $8f7b3d92c79c1fad$export$682ee8eb4890e553 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_14tkpxbi _t3zcv47k _1so4jjyb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kBPYs", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$3e1e8355c24b18f2$export$defe85febe8b728c);
    var $7VHMR;
    const $3e1e8355c24b18f2$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        forgeSectionTitle: {
            "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
            "defaultMessage": "Apps"
        }
    });
});
parcelRegister("boE05", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8fbdf556ad4d3a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    var $gjTBi;
    var $koVbs;
    var $juTur;
    var $jsI7v;
    var $8yg0C;
    var $k6yFu;
    const $e8fbdf556ad4d3a9$var$EMPTY_STACK = [];
    const $e8fbdf556ad4d3a9$var$IssuesMenu = ({ project: project })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            initialStack: $e8fbdf556ad4d3a9$var$EMPTY_STACK
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).IssuesContextualAnalyticsData), {
            navigatorScope: "project"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jsI7v")).Issues), {
            projectKey: project.key,
            pinUrl: `/jira/core/projects/${project.key}/issues/?filter=`,
            titleHeaderText: formatMessage((0, (0, parcelRequire("k6yFu")).default).issues)
        }))));
    };
    var $e8fbdf556ad4d3a9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e8fbdf556ad4d3a9$var$IssuesMenu);
});
parcelRegister("jsI7v", function(module, exports) {
    $parcel$export(module.exports, "Issues", ()=>$e89a82dba74cf1ac$export$1cb51167b20548a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ebyGx = parcelRequire("ebyGx");
    var $gjTBi;
    var $bWqXX;
    var $bwLf9;
    var $39xOx;
    var $6s1PB;
    var $co1wz;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $kvHKs;
    var $k0ZZ2;
    var $iL2Ly;
    var $6KxGW;
    var $3OGaE;
    var $8kM72;
    var $4OCke;
    var $5w5Kh;
    var $2q4IS;
    var $hnmuM;
    var $4KUQv;
    const $e89a82dba74cf1ac$var$IssuesNew = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
        const { data: features } = (0, (0, parcelRequire("8kM72")).useDefaultPinFilters)();
        if (features === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
        const StyleOverrideWrapper = (0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8') ? $e89a82dba74cf1ac$var$CompiledWrapper : (0, $5uXOq.Fragment);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(StyleOverrideWrapper, {
            renderDividerBefore: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5w5Kh")).DefaultFilters), {
            pinUrl: pinUrl,
            projectKey: projectKey,
            features: features,
            titleHeaderText: titleHeaderText
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            packageName: "jira-navigation-apps-sidebar-common",
            id: "issues.starred-filters-section",
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KxGW")).StarredFiltersErrorFallback), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(StyleOverrideWrapper, {
            renderDividerAfter: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL2Ly")).StarredFiltersContainer), {
            pinUrl: pinUrl,
            projectKey: projectKey
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement(StyleOverrideWrapper, {
            renderDividerBefore: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnmuM")).FiltersFooter), {
            hasFilters: hasFilters
        })));
    };
    const $e89a82dba74cf1ac$export$9bf0cad7d37c4925 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ match: match, location: location }] = (0, $dIdda.useRouter)();
        const { jql: jql } = (0, $ebyGx.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const { data: features } = (0, (0, parcelRequire("8kM72")).useDefaultPinFilters)();
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
        const shouldUseNinLayout = !isOnLegacyPinRoute;
        const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
        const hasSomeFilters = features.hasAllIssues || features.hasMyOpenIssues;
        const allOpenIssuesSelector = !shouldUseNinLayout ? (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, (0, parcelRequire("4OCke")).matchUrlParams)([
            'filter'
        ], false);
        const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, isOnLegacyPinRoute || titleHeaderText === null || titleHeaderText === undefined ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).issuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).issues) : titleHeaderText), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (...args)=>(0, (0, parcelRequire("2q4IS")).isInAllFiltersState)(undefined, '') || (!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false)(...args) : false),
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).allIssues)), features.hasMyOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}myopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).myOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).myOpenIssues)), features.hasReportedByMe && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}reportedbyme`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).allIssues)), features.hasAllOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? allOpenIssuesSelector : ()=>false,
            href: `${pinUrlPrefix}allopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).allOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).allOpenIssues)), features.hasDoneIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}doneissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).doneIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).doneIssues)), features.hasViewedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}recentlyviewed`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
            },
            selectedOn: !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}addedrecently`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).createdRecently)), features.hasResolvedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}resolvedrecently`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).resolvedRecently)), features.hasUpdatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}updatedrecently`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).updatedRecently))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: hasSomeFilters
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'pin-manage-filters'
            },
            selectedOn: !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: "/secure/ManageFilters.jspa"
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).viewAllFilters))));
    };
    const $e89a82dba74cf1ac$export$1cb51167b20548a0 = (0, (0, parcelRequire("bwLf9")).default)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), $e89a82dba74cf1ac$var$IssuesNew, $e89a82dba74cf1ac$export$9bf0cad7d37c4925);
    const $e89a82dba74cf1ac$var$CompiledWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1xlv12x7 _1rqn1fxt",
                __cmplp.renderDividerBefore && "_175u1crf",
                __cmplp.renderDividerAfter && "_1we51crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iL2Ly", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersContainer", ()=>$1ec2742e0426c5a8$export$f5b4503a4a7ca418);
    var $59JDz;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $bWqXX;
    var $co1wz;
    var $VILOn;
    var $a3OKn;
    var $lfTZh;
    var $ao2h1;
    var $59JDz;
    var $bATyw;
    var $koeKL;
    var $dIdda = parcelRequire("dIdda");
    var $aV2yn;
    var $8Jljs;
    const $1ec2742e0426c5a8$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
        const [localStorageData] = (0, $5uXOq.useState)((0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
        const { data: resourceData } = (0, $dIdda.useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource));
        let isNinGlobalScopeEnrolmentEnabled;
        if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
        else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
        const baseHref = (0, (0, parcelRequire("aV2yn")).getStarredFilterLink)({
            projectKey: projectKey,
            pinUrl: pinUrl,
            shouldStayProjectScope: (0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8') && isNinGlobalScopeEnrolmentEnabled
        });
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("59JDz")).default), queryReference);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Jljs")).StarredFiltersList), {
            baseHref: baseHref,
            jiraQuery: data.jira,
            onFavouritesChanged: onFavouritesChanged
        });
    };
    const $1ec2742e0426c5a8$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
        const { queryReference: resourceQueryRef } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("a3OKn")).sidebarProjectIssuesResource));
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("59JDz")).default), resourceQueryRef);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const loadSidebarData = (0, $5uXOq.useCallback)(()=>{
            loadQuery({
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-and-network'
            });
        }, [
            cloudId,
            loadQuery
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!queryReference) loadSidebarData();
        }, [
            loadSidebarData,
            queryReference
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "starred-filters",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null)
        }, queryReference ? (0, ($parcel$interopDefault($5uXOq))).createElement($1ec2742e0426c5a8$export$3be6ba2fb4838e7e, {
            queryReference: queryReference,
            onFavouritesChanged: loadSidebarData,
            pinUrl: pinUrl,
            projectKey: projectKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null));
    };
});
parcelRegister("aV2yn", function(module, exports) {
    $parcel$export(module.exports, "getStarredFilterLink", ()=>$a754d4f1af7bcc7d$export$7082c02465d0ecd4);
    const $a754d4f1af7bcc7d$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
        if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
        const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
        return shouldStayProjectScope ? craftedPinUrl : '/issues/';
    };
});
parcelRegister("8Jljs", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersList", ()=>$0208f837fc89d8ec$export$b7f4b26a8737eee0);
    var $47bDC = parcelRequire("47bDC");
    var $jUReQ;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $gjTBi;
    var $co1wz;
    var $koVbs;
    var $b2GBS;
    var $kZDjT;
    var $4ABV3;
    var $0208f837fc89d8ec$var$_StyledSection = (0, $47bDC.default)((0, (0, parcelRequire("gjTBi")).default)).withConfig({
        componentId: "sc-8ugvpc-0"
    })`${(p)=>p._css}`;
    const $0208f837fc89d8ec$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jUReQ")).default), jiraQuery);
        (0, (0, parcelRequire("b2GBS")).useFavoritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
            if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
        });
        const starredFilterEdges = data.favouriteFilters?.edges || [];
        if (!starredFilterEdges.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0208f837fc89d8ec$var$_StyledSection, {
            title: formatMessage((0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8') ? (0, (0, parcelRequire("4ABV3")).messages).newStarredFiltersHeader : (0, (0, parcelRequire("4ABV3")).messages).starredFiltersHeader),
            _css: sectionCustomCss
        }, starredFilterEdges.map((edge)=>edge?.node ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZDjT")).FilterItem), {
                key: edge.node.filterId,
                baseHref: baseHref,
                filter: edge.node,
                customAnalytics: {
                    isStarred: true
                }
            }) : null));
    };
});
parcelRegister("jUReQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9363fe5268fd6910$export$2e2bcd8739ae039);
    const $9363fe5268fd6910$var$node = {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "starredFiltersList_navigationAppsSidebarCommon",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "JiraFilterConnection",
                "kind": "LinkedField",
                "name": "favouriteFilters",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFilterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "filterId"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "filterItem_navigationAppsSidebarCommon"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
    $9363fe5268fd6910$var$node.hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";
    var $9363fe5268fd6910$export$2e2bcd8739ae039 = $9363fe5268fd6910$var$node;
});
parcelRegister("b2GBS", function(module, exports) {
    $parcel$export(module.exports, "useFavoritesChangeEffect", ()=>$0fca8b6d7b43f931$export$659f59218fc5dd14);
    var $5uXOq = parcelRequire("5uXOq");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $4041n;
    var $1XJ20;
    const $0fca8b6d7b43f931$export$659f59218fc5dd14 = (type, effect)=>{
        const { items: items } = (0, $5uXOq.useContext)((0, (0, parcelRequire("4041n")).FavoriteChangeContext));
        const typeItems = items[type];
        const pendingChanges = (0, ($parcel$interopDefault($4f8Oj)))(typeItems, (item)=>item.pending);
        const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
        const previousHasPendingChanges = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(hasPendingChanges);
        (0, $5uXOq.useEffect)(()=>{
            effect(hasPendingChanges, previousHasPendingChanges);
        }, [
            effect,
            hasPendingChanges,
            previousHasPendingChanges
        ]);
    };
});
parcelRegister("1XJ20", function(module, exports) {
    $parcel$export(module.exports, "usePrevious", ()=>$011794d66b906d20$export$5cae361ad82dce8b);
    $parcel$export(module.exports, "usePreviousWithInitial", ()=>$011794d66b906d20$export$23fbbb2e62c4a911);
    var $5uXOq = parcelRequire("5uXOq");
    const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
        const ref = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
        const ref = (0, $5uXOq.useRef)(value);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
});
parcelRegister("kZDjT", function(module, exports) {
    $parcel$export(module.exports, "FilterItem", ()=>$f981c975abc56594$export$3cf161fcd24b6b4f);
    var $lE53e;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $k0ZZ2;
    const $f981c975abc56594$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
    const $f981c975abc56594$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
        const { filterId: filterId, name: name } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("lE53e")).default), filter);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                ...customAnalytics || {},
                itemId: `filter-${filterId}`
            }), [
            customAnalytics,
            filterId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            key: filterId,
            analytics: analyticsAttributes,
            selectedOn: $f981c975abc56594$var$selectedOn,
            href: `${baseHref}?filter=${filterId}`
        }, name);
    };
});
parcelRegister("lE53e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$251d70d9349441ea$export$2e2bcd8739ae039);
    const $251d70d9349441ea$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "filterItem_navigationAppsSidebarCommon",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "ScalarField",
                "name": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ],
                "type": "JiraCustomFilter"
            }
        ],
        "type": "JiraFilter",
        "abstractKey": "__isJiraFilter"
    };
    $251d70d9349441ea$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
    var $251d70d9349441ea$export$2e2bcd8739ae039 = $251d70d9349441ea$var$node;
});
parcelRegister("4ABV3", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f94c0f775539d45d$export$defe85febe8b728c);
    var $7VHMR;
    const $f94c0f775539d45d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        starredFiltersHeader: {
            "id": "spa-apps-sidebar-common.common.starred-filters-list.starred-filters-header",
            "defaultMessage": "Starred global filters"
        },
        newStarredFiltersHeader: {
            "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
            "defaultMessage": "Starred filters"
        }
    });
});
parcelRegister("6KxGW", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersErrorFallback", ()=>$48c59f757828f109$export$70765d6359132b82);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $92Z2l;
    var $gjTBi;
    var $koVbs;
    var $b1xML;
    const $48c59f757828f109$export$70765d6359132b82 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($48c59f757828f109$var$SectionWrapper, {
            title: formatMessage((0, (0, parcelRequire("b1xML")).default).starredFiltersHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("b1xML")).default).errorMessage, {
            link: (linkText)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: ()=>window.location.reload()
                }, linkText)
        })));
    };
    const $48c59f757828f109$var$SectionWrapper = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("gjTBi")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt3i2wt _euf41fxt _1qdg1crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("92Z2l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a97355a0cc6aeb06$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $3HeRx;
    const $a97355a0cc6aeb06$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        borderRadius: 'border.radius'
    });
    const $a97355a0cc6aeb06$var$bleedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginBlock: 'space.negative.025'
    });
    const $a97355a0cc6aeb06$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $a97355a0cc6aeb06$var$SectionMessage = (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
        const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, (0, parcelRequire("3HeRx")).getAppearanceIconStyles)(appearance, icon);
        const actionElements = actions && actions.type === (0, ($parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
        const actionsArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "section",
            backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
            padding: "space.200",
            testId: testId,
            ref: ref,
            xcss: $a97355a0cc6aeb06$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.200",
            alignBlock: "stretch"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a97355a0cc6aeb06$var$bleedStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            size: "medium",
            primaryColor: primaryColor,
            secondaryColor: secondaryColor
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            testId: testId && `${testId}--content`
        }, !!title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "h2",
            size: "small"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a97355a0cc6aeb06$var$contentStyles
        }, children), actionsArray.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            shouldWrap: true,
            testId: testId && `${testId}--actions`,
            separator: "\xb7",
            space: "space.100",
            rowSpace: "space.0",
            role: "list"
        }, actionsArray.map((action, id)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                role: "listitem",
                key: id
            }, action))))));
    });
    const $a97355a0cc6aeb06$var$appearanceMap = {
        information: 'color.background.information',
        warning: 'color.background.warning',
        error: 'color.background.danger',
        success: 'color.background.success',
        discovery: 'color.background.discovery'
    };
    $a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
    var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;
});
parcelRegister("3HeRx", function(module, exports) {
    $parcel$export(module.exports, "getAppearanceIconStyles", ()=>$d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);
    var $5uXOq = parcelRequire("5uXOq");
    var $btivG;
    var $7nnPp;
    var $2hXfb;
    var $eJS47;
    var $gtreQ;
    const $d1d7dced94bb00f5$export$faa35441caff5bb6 = {
        information: {
            backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))),
            primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        },
        warning: {
            backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))),
            primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
        },
        error: {
            backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))),
            primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
        },
        success: {
            backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("btivG"))))),
            primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
        },
        discovery: {
            backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))),
            primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
        }
    };
    function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
        const appearanceIconStyles = $d1d7dced94bb00f5$export$faa35441caff5bb6[appearance] || $d1d7dced94bb00f5$export$faa35441caff5bb6.information;
        const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>(0, ($parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
                size: size,
                primaryColor: primaryColor,
                secondaryColor: secondaryColor,
                label: appearance
            });
        const Icon = icon || AppearanceIcon;
        return {
            ...appearanceIconStyles,
            Icon: Icon
        };
    }
});
parcelRegister("btivG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $85a0c2d39fdb2976$var$_react = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $85a0c2d39fdb2976$var$_success = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $85a0c2d39fdb2976$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $85a0c2d39fdb2976$var$CheckCircleIcon = (props)=>$85a0c2d39fdb2976$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $85a0c2d39fdb2976$var$_success.default
        }));
    $85a0c2d39fdb2976$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $85a0c2d39fdb2976$var$_default = module.exports.default = $85a0c2d39fdb2976$var$CheckCircleIcon;
});
parcelRegister("b0JGA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8043220a46fa3485$var$_UNSAFE_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8043220a46fa3485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8043220a46fa3485$var$SuccessIcon = (props)=>$8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;
});
parcelRegister("b1xML", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc624d55e9cb181d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dc624d55e9cb181d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorMessage: {
            "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
            "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
        },
        starredFiltersHeader: {
            "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
            "defaultMessage": "Starred filters"
        }
    });
});
parcelRegister("8kM72", function(module, exports) {
    $parcel$export(module.exports, "useDefaultPinFilters", ()=>$42363ac07745a31e$export$3c69152f8409a017);
    var $5uXOq = parcelRequire("5uXOq");
    var $1b36n;
    var $dIdda = parcelRequire("dIdda");
    const $42363ac07745a31e$export$3c69152f8409a017 = ()=>{
        const { data: data, loading: loading, refresh: refresh, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("1b36n")).staticSidebarDefaultPINFiltersResource));
        (0, $5uXOq.useEffect)(()=>{
            if (data == null && error == null && loading === false) refresh();
        }, [
            data,
            error,
            loading,
            refresh
        ]);
        return {
            data: data,
            loading: loading
        };
    };
});
parcelRegister("5w5Kh", function(module, exports) {
    $parcel$export(module.exports, "DefaultFilters", ()=>$68067cb39e642d05$export$5df36bcfaa4d1f9d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $gjTBi;
    var $6s1PB;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $k0ZZ2;
    var $4OCke;
    var $irHAa;
    var $2q4IS;
    const $68067cb39e642d05$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ match: match, location: location }] = (0, $dIdda.useRouter)();
        const { jql: jql } = (0, $ebyGx.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
        const shouldUseNinLayout = !isOnLegacyPinRoute;
        const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
        const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).issuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).issues) : titleHeaderText;
        const allOpenIssuesSelector = !shouldUseNinLayout ? (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, (0, parcelRequire("4OCke")).matchUrlParams)([
            'filter'
        ], false);
        const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: title
        }, shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).ninLayoutAllIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).ninLayoutAllIssues.selectedOn(jql),
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allIssues)), features.hasMyOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).myOpenIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).myOpenIssues.selectedOn(jql),
            href: `${pinUrlPrefix}myopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).myOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).myOpenIssues)), features.hasReportedByMe && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).reportedByMe.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).reportedByMe.selectedOn(jql),
            href: `${pinUrlPrefix}reportedbyme`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).notNinLayoutAllIssues.analytics,
            selectedOn: (0, (0, parcelRequire("2q4IS")).itemMap).notNinLayoutAllIssues.selectedOn(jql),
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allIssues)), features.hasAllOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).allOpenIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
            href: `${pinUrlPrefix}allopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allOpenIssues)), features.hasDoneIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).doneIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).doneIssues.selectedOn(jql),
            href: `${pinUrlPrefix}doneissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).doneIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).doneIssues)), features.hasViewedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).viewedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).viewedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}recentlyviewed`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).createdRecently.analytics,
            selectedOn: (0, (0, parcelRequire("2q4IS")).itemMap).createdRecently.selectedOn(jql),
            href: `${pinUrlPrefix}addedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).createdRecently)), features.hasResolvedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).resolvedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).resolvedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}resolvedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).resolvedRecently)), features.hasUpdatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).updatedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).updatedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}updatedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).updatedRecently)));
    };
});
parcelRegister("irHAa", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$87feacba5b057fbf$export$defe85febe8b728c);
    var $7VHMR;
    const $87feacba5b057fbf$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues",
            "defaultMessage": "Issues and filters"
        },
        issuesFilters: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
            "defaultMessage": "My open issues"
        },
        reportedByMe: {
            "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
            "defaultMessage": "Reported by me"
        },
        allIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
            "defaultMessage": "All issues"
        },
        allOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
            "defaultMessage": "Open issues"
        },
        doneIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
            "defaultMessage": "Done issues"
        },
        viewedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
            "defaultMessage": "Viewed recently"
        },
        createdRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
            "defaultMessage": "Created recently"
        },
        resolvedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
            "defaultMessage": "Resolved recently"
        },
        updatedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
            "defaultMessage": "Updated recently"
        },
        issuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-issue-term-refresh",
            "defaultMessage": "Issues and filters"
        },
        issuesFiltersIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters-issue-term-refresh",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues-issue-term-refresh",
            "defaultMessage": "My open issues"
        },
        allIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-issues-issue-term-refresh",
            "defaultMessage": "All issues"
        },
        allOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues-issue-term-refresh",
            "defaultMessage": "Open issues"
        },
        doneIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.done-issues-issue-term-refresh",
            "defaultMessage": "Done issues"
        }
    });
});
parcelRegister("2q4IS", function(module, exports) {
    $parcel$export(module.exports, "isInAllFiltersState", ()=>$414ee2dbecb9ba58$export$1596c397510d46b1);
    $parcel$export(module.exports, "itemMap", ()=>$414ee2dbecb9ba58$export$1072457701b9918d);
    var $kvHKs;
    var $4OCke;
    const $414ee2dbecb9ba58$export$1596c397510d46b1 = (filter, jql)=>{
        if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
        if (filter != null && filter !== 'allissues') return false;
        if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
        return false;
    };
    const $414ee2dbecb9ba58$export$1072457701b9918d = {
        ninLayoutAllIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: (jql)=>(...args)=>$414ee2dbecb9ba58$export$1596c397510d46b1(undefined, '') || (!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                        'filter'
                    ], false)(...args) : false)
        },
        myOpenIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        reportedByMe: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        notNinLayoutAllIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        allOpenIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
            },
            selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
        },
        doneIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        viewedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        createdRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        resolvedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        updatedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        }
    };
});
parcelRegister("hnmuM", function(module, exports) {
    $parcel$export(module.exports, "FiltersFooter", ()=>$ca4a87e5b79a11b5$export$c131ccfc44bcd85c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $koVbs;
    var $k0ZZ2;
    var $fcEY2;
    const $ca4a87e5b79a11b5$var$analyticsPayload = {
        itemId: 'pin-manage-filters'
    };
    const $ca4a87e5b79a11b5$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: hasFilters
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: $ca4a87e5b79a11b5$var$analyticsPayload,
            href: "/jira/filters"
        }, formatMessage((0, (0, parcelRequire("fcEY2")).messages).viewAllFilters)));
    };
});
parcelRegister("fcEY2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$905189d98c72b841$export$defe85febe8b728c);
    var $7VHMR;
    const $905189d98c72b841$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllFilters: {
            "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
            "defaultMessage": "View all filters"
        }
    });
});
parcelRegister("4KUQv", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4304d3acdfe7b54a$export$defe85febe8b728c);
    var $7VHMR;
    const $4304d3acdfe7b54a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "spa-apps-sidebar-common.issues.issues",
            "defaultMessage": "Issues and filters"
        },
        issuesFilters: {
            "id": "spa-apps-sidebar-common.issues.issues-filters",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.my-open-issues",
            "defaultMessage": "My open issues"
        },
        reportedByMe: {
            "id": "spa-apps-sidebar-common.issues.reported-by-me",
            "defaultMessage": "Reported by me"
        },
        allIssues: {
            "id": "spa-apps-sidebar-common.issues.all-issues",
            "defaultMessage": "All issues"
        },
        allOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.all-open-issues",
            "defaultMessage": "Open issues"
        },
        doneIssues: {
            "id": "spa-apps-sidebar-common.issues.done-issues",
            "defaultMessage": "Done issues"
        },
        viewedRecently: {
            "id": "spa-apps-sidebar-common.issues.viewed-recently",
            "defaultMessage": "Viewed recently"
        },
        createdRecently: {
            "id": "spa-apps-sidebar-common.issues.created-recently",
            "defaultMessage": "Created recently"
        },
        resolvedRecently: {
            "id": "spa-apps-sidebar-common.issues.resolved-recently",
            "defaultMessage": "Resolved recently"
        },
        updatedRecently: {
            "id": "spa-apps-sidebar-common.issues.updated-recently",
            "defaultMessage": "Updated recently"
        },
        viewAllFilters: {
            "id": "spa-apps-sidebar-common.issues.view-all-filters",
            "defaultMessage": "View all filters"
        },
        issuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.issues-issue-term-refresh",
            "defaultMessage": "Issues and filters"
        },
        issuesFiltersIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.issues-filters-issue-term-refresh",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.my-open-issues-issue-term-refresh",
            "defaultMessage": "My open issues"
        },
        allIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.all-issues-issue-term-refresh",
            "defaultMessage": "All issues"
        },
        allOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.all-open-issues-issue-term-refresh",
            "defaultMessage": "Open issues"
        },
        doneIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.done-issues-issue-term-refresh",
            "defaultMessage": "Done issues"
        }
    });
});
parcelRegister("k6yFu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$073d14daf21d9ee8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $073d14daf21d9ee8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues",
            "defaultMessage": "Issues"
        }
    });
    var $073d14daf21d9ee8$export$2e2bcd8739ae039 = $073d14daf21d9ee8$var$messages;
});
parcelRegister("chejP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5de49251f2394688$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    var $gjTBi;
    var $k0iPT;
    var $6jY6G;
    var $gb5lQ;
    var $lPApw;
    var $8yg0C;
    var $jxrFe;
    const $5de49251f2394688$var$calculateStack = (route, connectStack)=>{
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) && connectStack) {
            const [first, ...other] = connectStack;
            if ((0, (0, parcelRequire("gb5lQ")).SECTION_ID).REPORTS === first) return other;
            return connectStack;
        }
        return [];
    };
    const $5de49251f2394688$var$ReportsMenu = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems, stack: connectStack } = (0, (0, parcelRequire("lPApw")).useProjectReportsConnectItems)();
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$5de49251f2394688$var$calculateStack(route, connectStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($5de49251f2394688$var$calculateStack(route, connectStack));
        }, [
            route,
            connectStack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            stack: stack,
            onChange: setStack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxrFe")).Reports), {
            connectItems: connectItems
        })));
    };
    var $5de49251f2394688$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5de49251f2394688$var$ReportsMenu);
});
parcelRegister("jxrFe", function(module, exports) {
    $parcel$export(module.exports, "Reports", ()=>$345de988b64525a0$export$883262dc952d8f59);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $jv9Yy;
    var $lpwtK;
    var $7OqB4;
    var $4OCke;
    var $3tHFY;
    var $9h6Pc;
    var $eA5Jb;
    var $bkw8F;
    var $9GoDt;
    const $345de988b64525a0$var$useThrowDefaultReportItemsDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("eA5Jb")).useDefaultReportItems));
    const $345de988b64525a0$var$useThrowProjectDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $345de988b64525a0$var$useThrowReportFeaturesDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useReportFeatures));
    const $345de988b64525a0$export$883262dc952d8f59 = ({ ConnectMenu: ConnectMenu = (0, (0, parcelRequire("3tHFY")).ConnectMenu), MenuItem: MenuItem = (0, (0, parcelRequire("k0ZZ2")).MenuItem), Section: Section = (0, (0, parcelRequire("gjTBi")).default), SkeletonItem: SkeletonItem = (0, (0, parcelRequire("bWqXX")).default), connectItems: connectItems, SectionHeader: SectionHeader = (0, (0, parcelRequire("jv9Yy")).SectionHeader), matchUrlParams: matchUrlParams = (0, (0, parcelRequire("4OCke")).matchUrlParams), useDefaultReportItems: useDefaultReportItems = $345de988b64525a0$var$useThrowDefaultReportItemsDI, useIntl: useIntl = (0, (0, parcelRequire("koVbs")).default), useProject: useProject = $345de988b64525a0$var$useThrowProjectDI, useReportFeatures: useReportFeatures = $345de988b64525a0$var$useThrowReportFeaturesDI })=>{
        const baseUrl = '';
        const { data: defaultItems } = useDefaultReportItems();
        const { data: features } = useReportFeatures();
        const { formatMessage: formatMessage } = useIntl();
        const { data: project } = useProject();
        if (project == null || features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
        const createReportUrl = (0, (0, parcelRequire("9h6Pc")).createReportUrlFunc)({
            baseUrl: baseUrl,
            project: project
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, defaultItems && defaultItems.items.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement(Section, {
            id: defaultItems.id,
            key: defaultItems.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, defaultItems.name), defaultItems.items && defaultItems.items.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                key: item.id,
                analytics: {
                    itemId: item.id
                },
                selectedOn: matchUrlParams([
                    'reportKey'
                ]),
                href: item.url
            }, item.name != null ? item.name : null))), features && features.hasForcastSection && (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).forecastAndManagement)), features.hasTimeTracking && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'time-tracking'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:time-tracking'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).timeTracking)), features.hasDeveloperWorkload && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'developer-workload'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:developer-workload'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).userWorkload)), features.hasVersionWorkloadReport && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'version-workload'
            },
            href: createReportUrl('com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).versionWorkload))), (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).other)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'workloadpie'
            },
            href: createReportUrl('com.atlassian.jira.ext.charting:workloadpie-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).workloadPieChart)), (0, ($parcel$interopDefault($5uXOq))).createElement(ConnectMenu, {
            items: connectItems,
            overrides: {
                BackMenuItem: {
                    href: `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`,
                    title: formatMessage((0, (0, parcelRequire("9GoDt")).default).itemBack)
                }
            }
        })));
    };
});
parcelRegister("9h6Pc", function(module, exports) {
    $parcel$export(module.exports, "createReportUrlFunc", ()=>$14ad3153b403c86e$export$fe91ad5e718e4335);
    const $14ad3153b403c86e$export$fe91ad5e718e4335 = ({ baseUrl: baseUrl, project: project })=>(reportKey)=>`${baseUrl}/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=${reportKey}`;
});
parcelRegister("eA5Jb", function(module, exports) {
    $parcel$export(module.exports, "useDefaultReportItems", ()=>$b47a0bfc5b0d2f58$export$ab2e8832e8916e83);
    var $koVbs;
    var $lpwtK;
    var $9h6Pc;
    var $cnn8W;
    const $b47a0bfc5b0d2f58$export$ab2e8832e8916e83 = ()=>{
        const baseUrl = '';
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("lpwtK")).useProject)();
        let defaultIssueAnalysisSection = null;
        if (project) {
            const createReportUrl = (0, (0, parcelRequire("9h6Pc")).createReportUrlFunc)({
                baseUrl: baseUrl,
                project: project
            });
            defaultIssueAnalysisSection = {
                name: formatMessage((0, (0, parcelRequire("cnn8W")).default).issueAnalysis),
                id: 'issue-analysis-sidebar-links',
                items: [
                    {
                        id: 'averageage-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:averageage-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).averageAgeReport)
                    },
                    {
                        id: 'createdvsresolved-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:createdvsresolved-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).createdResolvedIssuesReport)
                    },
                    {
                        id: 'pie-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:pie-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).pieChart)
                    },
                    {
                        id: 'recentlycreated-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:recentlycreated-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).recentlyCreatedIssues)
                    },
                    {
                        id: 'resolutiontime-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:resolutiontime-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).resolutionTime)
                    },
                    {
                        id: 'singlelevelgroupby',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:singlelevelgroupby'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).singleLevelGroup)
                    },
                    {
                        id: 'timesince-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:timesince-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).timeSinceIssues)
                    }
                ]
            };
        }
        return {
            data: defaultIssueAnalysisSection,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("cnn8W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f93c3dbd2e4c3a6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7f93c3dbd2e4c3a6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueAnalysis: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis",
            "defaultMessage": "Issue analysis"
        },
        averageAgeReport: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.average-age-report",
            "defaultMessage": "Average Age Report"
        },
        createdResolvedIssuesReport: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report",
            "defaultMessage": "Created vs Resolved Issues Report"
        },
        pieChart: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.pie-chart",
            "defaultMessage": "Pie Chart Report"
        },
        recentlyCreatedIssues: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues",
            "defaultMessage": "Recently Created Issues Report"
        },
        resolutionTime: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.resolution-time",
            "defaultMessage": "Resolution Time Report"
        },
        singleLevelGroup: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.single-level-group",
            "defaultMessage": "Single Level Group By Report"
        },
        timeSinceIssues: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues",
            "defaultMessage": "Time Since Issues Report"
        }
    });
});
parcelRegister("9GoDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98779022895d106f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $98779022895d106f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        forecastAndManagement: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.forecast-and-management",
            "defaultMessage": "Forecast & management"
        },
        timeTracking: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.time-tracking",
            "defaultMessage": "Time Tracking Report"
        },
        userWorkload: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.user-workload",
            "defaultMessage": "User Workload Report"
        },
        versionWorkload: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.version-workload",
            "defaultMessage": "Version Workload Report"
        },
        workloadPieChart: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.workload-pie-chart",
            "defaultMessage": "Workload Pie Chart Report"
        },
        other: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.other",
            "defaultMessage": "Other"
        },
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.item-back",
            "defaultMessage": "Back to reports"
        }
    });
});
parcelRegister("9nNLl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90a0ff13f8a11c35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    var $gjTBi;
    var $65Ltd;
    var $k0iPT;
    var $6jY6G;
    var $gb5lQ;
    var $lPApw;
    var $8yg0C;
    var $3wt3Q;
    var $4rn3K;
    const $90a0ff13f8a11c35$var$EMPTY_STACK = [];
    const $90a0ff13f8a11c35$var$adjustAppStack = (appStack)=>{
        const [first, ...other] = appStack;
        if ((0, (0, parcelRequire("gb5lQ")).SECTION_ID).SETTINGS === first) return other;
        return appStack;
    };
    const $90a0ff13f8a11c35$var$calculateStack = (route, connectStack, forgeStack)=>{
        if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(route.name) && forgeStack) return $90a0ff13f8a11c35$var$adjustAppStack(forgeStack);
        if (route.name.includes((0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE))) {
            const [view] = route.name.replace(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE)}-`, '').split('-');
            return view === 'issuetypes' ? [
                view
            ] : $90a0ff13f8a11c35$var$EMPTY_STACK;
        }
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) && connectStack) return $90a0ff13f8a11c35$var$adjustAppStack(connectStack);
        return $90a0ff13f8a11c35$var$EMPTY_STACK;
    };
    const $90a0ff13f8a11c35$var$SettingsMenu = ({ project: project })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems, stack: connectStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsConnectItems)();
        const { data: forgeItems, stack: forgeStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsForgeItems)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS), $90a0ff13f8a11c35$var$EMPTY_STACK);
        const ecosystemItems = (0, $5uXOq.useMemo)(()=>({
                forge: forgeItems,
                connect: connectItems
            }), [
            forgeItems,
            connectItems
        ]);
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$90a0ff13f8a11c35$var$calculateStack(route, connectStack, forgeStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($90a0ff13f8a11c35$var$calculateStack(route, connectStack, forgeStack));
        }, [
            route,
            connectStack,
            forgeStack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            stack: stack,
            onChange: setStack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, project.isSimplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wt3Q")).SettingsMenu), {
            stack: stack
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4rn3K")).Settings), {
            ecosystemItems: ecosystemItems
        }))));
    };
    var $90a0ff13f8a11c35$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($90a0ff13f8a11c35$var$SettingsMenu);
});
parcelRegister("3wt3Q", function(module, exports) {
    $parcel$export(module.exports, "SettingsMenu", ()=>$26eff467887b13fc$export$1d7840d5cdc861d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $2vSU6;
    var $co1wz;
    var $4R6GH;
    var $koVbs;
    var $xc3fY;
    var $k0ZZ2;
    var $3OGaE;
    var $lpwtK;
    var $kZj7F;
    var $71bFU;
    var $3SzZi;
    var $7OqB4;
    var $4OCke;
    var $02Psx;
    var $j9iVo;
    var $iNzEe;
    var $daoB1;
    var $6EZeH;
    var $gb5lQ;
    var $bkw8F;
    var $9DEd8;
    var $7OvX8;
    var $1tmBf;
    var $17zko;
    const $26eff467887b13fc$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $26eff467887b13fc$var$DisplayNotificationsOptions = ({ hasCoreAccess: hasCoreAccess, formatMessage: formatMessage, baseSettingsUrl: baseSettingsUrl, projectId: projectId })=>{
        if (!hasCoreAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'notifications'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("17zko")).messages).itemNotifications),
            forceExpand: true,
            submenuId: "core-notifications-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71bFU")).NotificationsSubMenu), {
            settingsUrl: `${baseSettingsUrl}/notifications`,
            issueLogsUrl: `${baseSettingsUrl}/notifications/issue-logs?projectId=${projectId}`
        }));
    };
    const $26eff467887b13fc$export$c72f6eaae7b9adff = ({ stack: stack })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project } = $26eff467887b13fc$export$a4007dc4843ca7f6();
        const { hasCoreAccess: hasCoreAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const hasDlpEnabled = (0, (0, parcelRequire("6EZeH")).useDlpEntitlement)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const { data: settingFeatures } = (0, (0, parcelRequire("bkw8F")).useSettingFeatures)();
        const [{ data: connectAppsData }, { fetch: fetchConnectApps }] = (0, (0, parcelRequire("j9iVo")).useConnectApps)();
        (0, $5uXOq.useEffect)(()=>{
            if (project && !connectAppsData) fetchConnectApps(project.key);
        }, [
            connectAppsData,
            fetchConnectApps,
            project
        ]);
        if (project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), project.key);
        const showCoreForms = (0, (0, parcelRequire("co1wz")).ff)('proforma-mvp-jwm-project-settings_5edja') && hasCoreAccess;
        const BackMenuItem = {
            href: baseSettingsUrl,
            title: formatMessage((0, (0, parcelRequire("17zko")).messages).title)
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("17zko")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'details'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/details`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemDetails)), hasCoreAccess && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'access'
            },
            href: `${baseSettingsUrl}/access`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemAccess)), (0, ($parcel$interopDefault($5uXOq))).createElement($26eff467887b13fc$var$DisplayNotificationsOptions, {
            hasCoreAccess: hasCoreAccess,
            formatMessage: formatMessage,
            baseSettingsUrl: baseSettingsUrl,
            projectId: project.id
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/automation`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).automation)), hasCoreAccess && settingFeatures?.hasProjectEfaFields && (0, (0, parcelRequire("4R6GH")).fg)('project_fields_page_for_tmp_-_mvp') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'fields'
            },
            href: `${baseSettingsUrl}/fields`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemFieldsNonFinal)), (0, (0, parcelRequire("3SzZi")).shouldRenderNesting)(hasCoreAccess, stack, (0, (0, parcelRequire("gb5lQ")).SECTION_ID).ISSUE_TYPES) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'issuetypes'
            },
            href: `${baseSettingsUrl}/issuetypes`,
            id: (0, (0, parcelRequire("gb5lQ")).SECTION_ID).ISSUE_TYPES,
            overrides: {
                BackMenuItem: BackMenuItem
            },
            title: formatMessage((0, (0, parcelRequire("17zko")).messages).itemIssueTypes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1tmBf")).IssueTypes), null)), isPremiumUserSeat && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'approvals'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/approvals`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemApprovals)), showCoreForms && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'proforma-forms'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/forms`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemAdvancedForms)), (0, (0, parcelRequire("3SzZi")).shouldRenderNesting)(hasCoreAccess, stack, 'apps') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'apps'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("7OvX8")).messages).apps),
            forceExpand: true,
            submenuId: "nextgen-apps-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9DEd8")).EcosystemAppsMenu), null)), hasDlpEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'data-classification'
            },
            href: `${baseSettingsUrl}/data-classifications`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).dataClassificationNonFinal))));
    };
    const $26eff467887b13fc$export$1d7840d5cdc861d5 = (props)=>{
        const { data: project } = $26eff467887b13fc$export$a4007dc4843ca7f6();
        if (project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9iVo")).ConnectAppsContainer), {
            onError: undefined,
            scope: project.key
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($26eff467887b13fc$export$c72f6eaae7b9adff, props)));
    };
});
parcelRegister("xc3fY", function(module, exports) {
    $parcel$export(module.exports, "ExpandableSubmenuItem", ()=>$dec8d2ea50472f86$export$16ba9a3b96f3ac6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3TzYp;
    var $iUo88;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $fXJBp;
    var $k0ZZ2;
    const $dec8d2ea50472f86$var$defaultExpandMenuState = {
        submenuActive: false,
        expanded: false
    };
    const $dec8d2ea50472f86$export$e5a6b8291f2460bc = ()=>{
        const getExpandableState = (submenuId)=>{
            const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            let parsedCookieData = null;
            try {
                parsedCookieData = JSON.parse(cookieData);
            } catch  {
                parsedCookieData = $dec8d2ea50472f86$var$defaultExpandMenuState;
            }
            return parsedCookieData;
        };
        const setExpandedState = (submenuId, newExpandedState)=>{
            if (submenuId != null) (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
        };
        return {
            getExpandableState: getExpandableState,
            setExpandedState: setExpandedState
        };
    };
    const $dec8d2ea50472f86$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $dec8d2ea50472f86$export$e5a6b8291f2460bc();
        const [subMenuActive, setSubMenuActive] = (0, $5uXOq.useState)(false);
        const [currentCookieData] = (0, $5uXOq.useState)(getExpandableState(submenuId));
        const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
        const [expanded, setExpanded] = (0, $5uXOq.useState)(currentCookieData?.expanded || (0, (0, parcelRequire("4R6GH")).fg)('jsm_simplified_project_settings_navigation') ? forceExpand : false);
        const expandableMenuItemRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jsm_simplified_project_settings_navigation') && forceExpand) setExpanded(true);
        }, [
            forceExpand
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (currentCookieData?.expanded) {
                setExpanded(currentCookieData.expanded);
                setSubMenuActive(currentCookieData.submenuActive);
            }
        }, [
            currentCookieData
        ]);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (submenuId != null) setExpandedState(submenuId, {
                submenuActive: false,
                expanded: !expanded
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
                expandMenuId: analytics?.itemId,
                expanded: !expanded
            });
            setExpanded(!expanded);
            requestAnimationFrame(()=>{
                expandableMenuItemRef?.current?.focus();
            });
        }, [
            analytics,
            createAnalyticsEvent,
            expanded,
            setExpandedState,
            submenuId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuWrapper, {
            isExpanded: subMenuActive
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: analytics,
            href: href,
            useButtonLink: useButtonLink,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fXJBp")).ExpandButton), {
                id: expandButtonId,
                label: expandButtonLabel,
                isActive: true,
                isExpanded: expanded,
                size: "medium"
            }), iconBefore),
            onClick: onClick,
            "data-test-id": testId,
            ref: expandableMenuItemRef,
            tabIndex: -1
        }, menuItemLabel), expanded && (0, ($parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper, {
            noListStyle: noListStyle
        }, children));
    };
    const $dec8d2ea50472f86$var$ExpandableSubmenuWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
                __cmplp.isExpanded && "_4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fXJBp", function(module, exports) {
    $parcel$export(module.exports, "ExpandButton", ()=>$a3120c1c485e5e18$export$5663c8f5aeb8c1c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6Ingq;
    var $ebd3R;
    var $hORKG;
    var $3dGN0;
    var $dC5iT;
    var $dCm1o;
    const $a3120c1c485e5e18$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: tabIndex = null })=>{
        const ChevronOld = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))) : (0, ($parcel$interopDefault((0, parcelRequire("ebd3R")))));
        const ChevronIcon = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))) : (0, ($parcel$interopDefault((0, parcelRequire("3dGN0")))));
        const onKeydown = (0, $5uXOq.useCallback)((event)=>{
            if ([
                13,
                32
            ].includes(event.keyCode)) {
                event.preventDefault();
                onClick();
            }
        }, [
            onClick
        ]);
        const chevronElement = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            padding: "space.075",
            paddingBlockStart: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ChevronIcon, {
            testId: `sidebar.expand-button.container-${id}`,
            color: "var(--ds-icon, #44546F)",
            label: label
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement(ChevronOld, {
            testId: `sidebar.expand-button.container-${id}`,
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            label: label,
            size: size
        });
        if (!isActive) return chevronElement;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3120c1c485e5e18$var$Container, {
            role: "button",
            "aria-expanded": isExpanded,
            onClick: onClick,
            onKeyDown: onKeydown,
            isVisible: isVisible,
            removeCaret: removeCaret,
            size: size,
            tabIndex: tabIndex
        }, chevronElement);
    };
    const $a3120c1c485e5e18$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _1spjglyw _1ejj12vo _19lvkb7n",
                __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
                __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
                __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("71bFU", function(module, exports) {
    $parcel$export(module.exports, "NotificationsSubMenu", ()=>$4606ea7b05b7e72d$export$f80567459a5e304a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZ4fr;
    var $lj8SI;
    var $5Fk4Z;
    var $dC5iT;
    var $8CUq3;
    var $bWqXX;
    var $aWse0;
    var $k0ZZ2;
    var $lpwtK;
    var $7OqB4;
    var $4OCke;
    var $icKiA;
    const $4606ea7b05b7e72d$export$51b1383ef8844a7 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY = 'issue-email-log-spotlight';
    const $4606ea7b05b7e72d$export$f80567459a5e304a = ({ settingsUrl: settingsUrl, issueLogsUrl: issueLogsUrl, displayLozenge: displayLozenge = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { data: project, loading: projectLoading } = $4606ea7b05b7e72d$export$51b1383ef8844a7();
        if (projectLoading || !project) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'notifications-settings'
            },
            href: settingsUrl,
            ref: (0, $5uXOq.createRef)(),
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).itemSettings)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'notifications-issue-logs'
            },
            href: issueLogsUrl,
            ref: (0, $5uXOq.createRef)(),
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4606ea7b05b7e72d$var$issueLogsContainerStyles
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).itemProjectEmailAuditLogs), displayLozenge && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "new"
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).newLozenge)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            engagementId: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, content);
    };
    const $4606ea7b05b7e72d$var$issueLogsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'space-between'
    });
});
parcelRegister("aWse0", function(module, exports) {
    $parcel$export(module.exports, "useIntlV2", ()=>$6b28e3c9e1c89fbd$export$d82607073b68786);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
        const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, (0, parcelRequire("koVbs")).default)();
        const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
            const modifiedIntl = {
                messages: messages,
                locale: locale,
                formats: formats,
                formatDate: formatDate,
                formatMessage: formatMessage,
                formatNumber: formatNumber,
                formatPlural: formatPlural,
                formatTime: formatTime
            };
            return modifiedIntl;
        }, [
            formatDate,
            formatMessage,
            formatPlural,
            formatTime,
            formatNumber,
            formats,
            locale,
            messages
        ]);
        return memoisedIntl;
    };
});
parcelRegister("icKiA", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0ac4b8c96850fb1d$export$defe85febe8b728c);
    var $7VHMR;
    const $0ac4b8c96850fb1d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        itemSettings: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.item-settings",
            "defaultMessage": "Settings"
        },
        itemProjectEmailAuditLogs: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.item-project-email-audit-logs",
            "defaultMessage": "Project email audit"
        },
        newLozenge: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.new-lozenge",
            "defaultMessage": "New"
        }
    });
});
parcelRegister("02Psx", function(module, exports) {
    $parcel$export(module.exports, "getNextgenSettingsUrl", ()=>$a59737cd16881573$export$26432406821aa7bf);
    $parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", ()=>$a59737cd16881573$export$defee92e506aa306);
    $parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", ()=>$a59737cd16881573$export$9133e09a98a043dc);
    $parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", ()=>$a59737cd16881573$export$b0d20d18e0230e83);
    $parcel$export(module.exports, "getClassicJSWSettingsUrl", ()=>$a59737cd16881573$export$ff0a17aa36a000df);
    $parcel$export(module.exports, "getProjectSettingsDetailsUrl", ()=>$a59737cd16881573$export$16d52b9357bb73ab);
    $parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", ()=>$a59737cd16881573$export$d531a9788343348f);
    $parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", ()=>$a59737cd16881573$export$dad567762dae162e);
    $parcel$export(module.exports, "getJcsRequestTypeLayoutSettingsUrl", ()=>$a59737cd16881573$export$8b304050f4836b59);
    var $2vSU6;
    var $3XO6n;
    var $gl0PU;
    var $1RLjE;
    const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
        const products = {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
        };
        const product = products[projectType];
        if (!product) {
            (0, (0, parcelRequire("1RLjE")).logError)((0, (0, parcelRequire("3XO6n")).PACKAGE_NAME), (0, (0, parcelRequire("gl0PU")).toErrorId)('urls'), (0, (0, parcelRequire("gl0PU")).toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
            return `/projects/${projectKey}/settings`;
        }
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
        return `/jira/${product}/projects/${projectKey}/settings`;
    };
    const $a59737cd16881573$var$serializeBackLink = (backLink)=>{
        if (backLink == null) return '';
        const { url: url, title: title } = backLink;
        return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
    };
    const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
        return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    };
    const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
        return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
    };
    const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey)}/automation`;
    const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
    const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
        const urlBase = projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
        return `${urlBase}/details`;
    };
    const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    const $a59737cd16881573$export$8b304050f4836b59 = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/helpcenter/projects/${projectKey}/settings/request-types/unassigned/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
});
parcelRegister("3XO6n", function(module, exports) {
    $parcel$export(module.exports, "TASK", ()=>$594ec5369f29a734$export$9355e489ad16f98e);
    $parcel$export(module.exports, "BUG", ()=>$594ec5369f29a734$export$bcf558c186108044);
    $parcel$export(module.exports, "STORY", ()=>$594ec5369f29a734$export$1ea39a3ae330045);
    $parcel$export(module.exports, "EPIC", ()=>$594ec5369f29a734$export$3cb4a99a332e4186);
    $parcel$export(module.exports, "SUB_TASK", ()=>$594ec5369f29a734$export$a06f889861f6537d);
    $parcel$export(module.exports, "CUSTOM", ()=>$594ec5369f29a734$export$952581bc40160893);
    $parcel$export(module.exports, "TEMPLATES_WHITELIST", ()=>$594ec5369f29a734$export$dff1da4a9bab6d3e);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$594ec5369f29a734$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", ()=>$594ec5369f29a734$export$56eae1056efd4899);
    $parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", ()=>$594ec5369f29a734$export$ca61f05d869b2ea3);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", ()=>$594ec5369f29a734$export$2ec42920a0df6b9a);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", ()=>$594ec5369f29a734$export$40c10ba35ceb5c6b);
    $parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", ()=>$594ec5369f29a734$export$a11dccbf88784c62);
    $parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", ()=>$594ec5369f29a734$export$f35dc2e6deb1692e);
    $parcel$export(module.exports, "JIRA_APP_NAME", ()=>$594ec5369f29a734$export$ec5d0e43836cb3c7);
    $parcel$export(module.exports, "toPackageName", ()=>$594ec5369f29a734$export$f31a652635bd75fe);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$594ec5369f29a734$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", ()=>$594ec5369f29a734$export$a2231d79966e0ccc);
    $parcel$export(module.exports, "RADIO_FIELD_TYPE", ()=>$594ec5369f29a734$export$28a4bdf7d9b6f9);
    $parcel$export(module.exports, "USERPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$9d758b3e8c6e0ed1);
    $parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$b0e37d421e006913);
    $parcel$export(module.exports, "SELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$d77765147749db6b);
    $parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$42ef68d6bd555a8d);
    $parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$4db6eb15b3c529cf);
    $parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", ()=>$594ec5369f29a734$export$ee975373b7797e8a);
    $parcel$export(module.exports, "TEXT_FIELD_TYPE", ()=>$594ec5369f29a734$export$aa99342cc6a8ced5);
    $parcel$export(module.exports, "NUMBER_FIELD_TYPE", ()=>$594ec5369f29a734$export$6f327bf99e20320);
    $parcel$export(module.exports, "DATETIME_FIELD_TYPE", ()=>$594ec5369f29a734$export$dc64bdfdf9660a05);
    $parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$e6d73ed745b9a04);
    $parcel$export(module.exports, "DATE_FIELD_TYPE", ()=>$594ec5369f29a734$export$d8b50f59220c7580);
    $parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$3a6f0a44478f1d2);
    $parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$68b76ef93df5a880);
    $parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$e7773fccbeec45e6);
    $parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$b45487b145c52a37);
    $parcel$export(module.exports, "VERSION_FIELD_TYPE", ()=>$594ec5369f29a734$export$48548129a6d117f5);
    $parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", ()=>$594ec5369f29a734$export$722c271a9e11cb94);
    $parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", ()=>$594ec5369f29a734$export$33dbe2a903610aa1);
    $parcel$export(module.exports, "emptyTenantContext", ()=>$594ec5369f29a734$export$ac655f5b3ff7b929);
    var $lzeFL;
    var $5fc53;
    var $ldyPw;
    var $g5X3G;
    var $ef5Xn;
    var $7qPn9;
    const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
    const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
    const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
    const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
    const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
    const $594ec5369f29a734$export$952581bc40160893 = 'custom';
    const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
        $594ec5369f29a734$export$9355e489ad16f98e,
        $594ec5369f29a734$export$bcf558c186108044,
        $594ec5369f29a734$export$1ea39a3ae330045,
        $594ec5369f29a734$export$3cb4a99a332e4186
    ];
    const $594ec5369f29a734$export$39cd48613b53ce2f = (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE);
    const $594ec5369f29a734$export$56eae1056efd4899 = (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE);
    const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, (0, parcelRequire("5fc53")).ENVIRONMENT_TYPE);
    const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
    const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
    const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
    const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
        $594ec5369f29a734$export$56eae1056efd4899,
        $594ec5369f29a734$export$39cd48613b53ce2f,
        $594ec5369f29a734$export$ca61f05d869b2ea3
    ];
    const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
    const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
    const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
    const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
    const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
    const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
    const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
    const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
    const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
    const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
    const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
    const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
    const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
    const $594ec5369f29a734$export$d77765147749db6b = 'select';
    const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
    const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
    const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
    const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
    const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
    const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
    const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
    const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
    const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
    const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
    const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
    const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
    const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
    const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
    const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
    const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
            appEditions: (0, (0, parcelRequire("ldyPw")).populateApplicationEditions)(),
            appPermissions: (0, (0, parcelRequire("7qPn9")).populateApplicationPermissions)(),
            applicationKey: null,
            areProductSuggestionsEnabled: false,
            appUpdatesAvailable: null,
            atlassianAccountId: null,
            baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(''),
            cloudId: (0, (0, parcelRequire("g5X3G")).toCloudId)(''),
            activationId: (0, (0, parcelRequire("g5X3G")).toActivationId)(''),
            cloudName: (0, (0, parcelRequire("g5X3G")).toCloudName)(''),
            devopsProjectSignupSource: (0, (0, parcelRequire("g5X3G")).toDevopsProjectSignupSource)(''),
            environment: null,
            fabricActivityUrl: null,
            fabricNotificationLogUrl: null,
            fabricPfDirUrl: null,
            firstActivationDateMs: null,
            isAdmin: false,
            isAnonymous: false,
            isDevMode: false,
            isDevopsProjectCreationScenario: false,
            isMarketingOptOut: false,
            isSiteAdmin: false,
            languageTag: null,
            licenseStates: (0, (0, parcelRequire("ef5Xn")).populateApplicationLicenseStates)(),
            licensedProducts: {},
            locale: (0, (0, parcelRequire("lzeFL")).defaultLocale),
            loggedInUser: null,
            productCrossSellConfig: 'unknown',
            productEntitlementDetails: null,
            productPermissionGated: {
                core: false,
                software: false,
                serviceDesk: false,
                productDiscovery: false
            },
            siteAdminStatus: 'unknown',
            userFullname: null,
            xsrfToken: null,
            hasDlpEnabled: false,
            avpWorkspaceId: null
        });
});
parcelRegister("5fc53", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_LINK_SEARCH", ()=>$81f079589240b9b7$export$b144116dae474c88);
    $parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$bc917bc699b25f75);
    $parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", ()=>$81f079589240b9b7$export$5f26ca419fdffbe7);
    $parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$ce9bfd823c7e1a6d);
    $parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$346b72b1f7cd6d5a);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$b20fbcacd7942c2a);
    $parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", ()=>$81f079589240b9b7$export$a2e8554bffc61ece);
    $parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$f25cd4907cbb25b9);
    $parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5600354b43577e17);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$5dbc9917f72d0d2a);
    $parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$253649f07fb55948);
    $parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", ()=>$81f079589240b9b7$export$eb39592ba5247ee7);
    $parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", ()=>$81f079589240b9b7$export$f48a9be226105736);
    $parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$42e2e93fc721df5d);
    $parcel$export(module.exports, "APPROVALS_PANEL_TYPE", ()=>$81f079589240b9b7$export$7773375e72c953ed);
    $parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", ()=>$81f079589240b9b7$export$80ad0037098f3919);
    $parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", ()=>$81f079589240b9b7$export$6875c7efa3a5e380);
    $parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", ()=>$81f079589240b9b7$export$7c1a5c7d37b8f968);
    $parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$c5931a5d7dbfb40b);
    $parcel$export(module.exports, "BOOLEAN_GQL_FIELD", ()=>$81f079589240b9b7$export$c979d9c548c05133);
    $parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ff25e7412c4ae9c7);
    $parcel$export(module.exports, "CHECKBOX_GQL_FIELD", ()=>$81f079589240b9b7$export$16dbdf57e34e8d63);
    $parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$1bf8bec92e6e84df);
    $parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$c32f5d822fe5ea95);
    $parcel$export(module.exports, "CMDB_GQL_FIELD", ()=>$81f079589240b9b7$export$b0deb225eed90fbd);
    $parcel$export(module.exports, "COLOR_GQL_FIELD", ()=>$81f079589240b9b7$export$add3775cfea8fde3);
    $parcel$export(module.exports, "COMPONENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9631d4098abab3eb);
    $parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$ee42bc16c09ee564);
    $parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$fbcebbdce821f712);
    $parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$41dd2eb1f33d3042);
    $parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$f4e3e72a3be84e5b);
    $parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$d6738c8a6d1a735d);
    $parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$79a75502a3f0c4c4);
    $parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$ed2eabcf0931df31);
    $parcel$export(module.exports, "DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$1f17904e959f2f0b);
    $parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", ()=>$81f079589240b9b7$export$6d8da4497234455);
    $parcel$export(module.exports, "FLAG_GQL_FIELD", ()=>$81f079589240b9b7$export$9bcfac568e4fa59c);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", ()=>$81f079589240b9b7$export$dd84cd6c957c6f5e);
    $parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5cc7c39d7d1cf6d5);
    $parcel$export(module.exports, "LABEL_GQL_FIELD", ()=>$81f079589240b9b7$export$810709f0c5c2e9db);
    $parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$82cb6735134c23a2);
    $parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$85e04e9a3a81ee1);
    $parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$24c916a8a33ed20c);
    $parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$c049920d930c3b8a);
    $parcel$export(module.exports, "NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$3b6d7fc1833bf7da);
    $parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", ()=>$81f079589240b9b7$export$bd3e2fe853319c13);
    $parcel$export(module.exports, "PARENT_GQL_FIELD", ()=>$81f079589240b9b7$export$6dfd3fc78bc751a0);
    $parcel$export(module.exports, "PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$31aea7548807c6b5);
    $parcel$export(module.exports, "PRIORITY_GQL_FIELD", ()=>$81f079589240b9b7$export$e89fbbf3983c0219);
    $parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", ()=>$81f079589240b9b7$export$f5e2fb1022ff7912);
    $parcel$export(module.exports, "PROJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$12f54499c6252188);
    $parcel$export(module.exports, "RADIO_GQL_FIELD", ()=>$81f079589240b9b7$export$8e4293d806f435e0);
    $parcel$export(module.exports, "REPORTER_GQL_FIELD", ()=>$81f079589240b9b7$export$c69486dd643dfb69);
    $parcel$export(module.exports, "RESOLUTION_GQL_FIELD", ()=>$81f079589240b9b7$export$1e4faa0d6dc58a81);
    $parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$37f4daaa7b409554);
    $parcel$export(module.exports, "SECURITY_GQL_FIELD", ()=>$81f079589240b9b7$export$ca57cccd6d7bf97c);
    $parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$bea889616fd5bdab);
    $parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ab5cecc580898d1c);
    $parcel$export(module.exports, "SPRINT_GQL_FIELD", ()=>$81f079589240b9b7$export$bb63813d13e8eaf7);
    $parcel$export(module.exports, "STATUS_GQL_FIELD", ()=>$81f079589240b9b7$export$e40f819979b3881d);
    $parcel$export(module.exports, "TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$6c243704a22baffe);
    $parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", ()=>$81f079589240b9b7$export$6c32429bac235203);
    $parcel$export(module.exports, "TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$61b514b470cbbf07);
    $parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", ()=>$81f079589240b9b7$export$e4bcb1729da5683);
    $parcel$export(module.exports, "URL_GQL_FIELD", ()=>$81f079589240b9b7$export$37ccd11f08a93ccb);
    $parcel$export(module.exports, "USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$abf1bf8c1106ba7d);
    $parcel$export(module.exports, "VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$b55604041ae7179e);
    $parcel$export(module.exports, "VOTES_GQL_FIELD", ()=>$81f079589240b9b7$export$c8bf66d62e74cdd2);
    $parcel$export(module.exports, "WATCHES_GQL_FIELD", ()=>$81f079589240b9b7$export$aa815aaa741ae18);
    $parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", ()=>$81f079589240b9b7$export$e805f89b15d2abf4);
    $parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$5bfd36acd96f04c2);
    $parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", ()=>$81f079589240b9b7$export$695423a2bc8a9ac4);
    $parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", ()=>$81f079589240b9b7$export$d29b0ba0d80bc129);
    $parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", ()=>$81f079589240b9b7$export$ac6c7b30703608d6);
    $parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$478b546dccd33e1e);
    $parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", ()=>$81f079589240b9b7$export$f90c042e9eb983e7);
    $parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", ()=>$81f079589240b9b7$export$753ca4fb34ff3f2b);
    $parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$b7aed9efb4a9154b);
    $parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", ()=>$81f079589240b9b7$export$1763713d718f7ef0);
    $parcel$export(module.exports, "FORGE_USER_GQL_FIELD", ()=>$81f079589240b9b7$export$ebb0caa2a98dcf9e);
    $parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", ()=>$81f079589240b9b7$export$671131ba12d94144);
    $parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", ()=>$81f079589240b9b7$export$c48132adab502d6b);
    $parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", ()=>$81f079589240b9b7$export$6cd83226f31c7072);
    $parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$7de726bd6d97a9a7);
    $parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$8e4b538f77340a05);
    $parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", ()=>$81f079589240b9b7$export$10ba8c0d74470907);
    $parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", ()=>$81f079589240b9b7$export$1756bb4eff1cc3c6);
    $parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5876b4be3c4407b);
    $parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", ()=>$81f079589240b9b7$export$e7fe49e6f36c7154);
    $parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", ()=>$81f079589240b9b7$export$aeed3395a6bca18b);
    $parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9b725a1eafd02e4f);
    $parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", ()=>$81f079589240b9b7$export$699805cbca2c41d);
    $parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", ()=>$81f079589240b9b7$export$f658d5c0f0b5dbc2);
    $parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", ()=>$81f079589240b9b7$export$e469bcb2060000af);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", ()=>$81f079589240b9b7$export$f10e53e8928b61bd);
    $parcel$export(module.exports, "GOALS_GQL_FIELD", ()=>$81f079589240b9b7$export$bfcb1a91094f113a);
    $parcel$export(module.exports, "DURATION_GQL_FIELD", ()=>$81f079589240b9b7$export$db0bd6c04eb7d04a);
    $parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", ()=>$81f079589240b9b7$export$798d2f5814884447);
    $parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", ()=>$81f079589240b9b7$export$269d70c1b1c9fb80);
    $parcel$export(module.exports, "APPROVALS_CF_TYPE", ()=>$81f079589240b9b7$export$f0f17ef462331df4);
    $parcel$export(module.exports, "CATEGORY_TYPE", ()=>$81f079589240b9b7$export$3c7d8923295a5199);
    $parcel$export(module.exports, "PEOPLE_CF_TYPE", ()=>$81f079589240b9b7$export$fb431e758c9252df);
    $parcel$export(module.exports, "NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$c7faa96db185cfc6);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", ()=>$81f079589240b9b7$export$492b0fa4fe201a22);
    $parcel$export(module.exports, "URL_CF_TYPE", ()=>$81f079589240b9b7$export$60f0bd6e4b582fe6);
    $parcel$export(module.exports, "TEXT_CF_TYPE", ()=>$81f079589240b9b7$export$68c7e01d5460d298);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$81f079589240b9b7$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", ()=>$81f079589240b9b7$export$977db5973ce73e44);
    $parcel$export(module.exports, "LABELS_CF_TYPE", ()=>$81f079589240b9b7$export$ad4eb83f78528e13);
    $parcel$export(module.exports, "DATE_CF_TYPE", ()=>$81f079589240b9b7$export$ff745f432984005d);
    $parcel$export(module.exports, "DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$42d097f7b1622ef1);
    $parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", ()=>$81f079589240b9b7$export$65524be5675e57e6);
    $parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", ()=>$81f079589240b9b7$export$5280e5501a801dc0);
    $parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c5d13ea26562d57a);
    $parcel$export(module.exports, "SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$22ac48a51c014e4b);
    $parcel$export(module.exports, "EPIC_STATUS_TYPE", ()=>$81f079589240b9b7$export$6769c2c97b828e11);
    $parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$39866626496bbfc8);
    $parcel$export(module.exports, "VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$24382b4e8c58336b);
    $parcel$export(module.exports, "GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b075907882e80160);
    $parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b600addfa3355c57);
    $parcel$export(module.exports, "USER_CF_TYPE", ()=>$81f079589240b9b7$export$c491a4b98394028e);
    $parcel$export(module.exports, "MULTI_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5365f2d3fac5261a);
    $parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$cc8ffff49170b0f4);
    $parcel$export(module.exports, "FLAGGED_CF_TYPE", ()=>$81f079589240b9b7$export$b7178f601d7373f9);
    $parcel$export(module.exports, "TEAM_CF_TYPE", ()=>$81f079589240b9b7$export$eb1f1dca13a0f02d);
    $parcel$export(module.exports, "PARENT_CF_TYPE", ()=>$81f079589240b9b7$export$3e71e11f80203acb);
    $parcel$export(module.exports, "BASELINE_START_CF_TYPE", ()=>$81f079589240b9b7$export$d10d66823a65e688);
    $parcel$export(module.exports, "BASELINE_END_CF_TYPE", ()=>$81f079589240b9b7$export$dfc6da4a9963d5dc);
    $parcel$export(module.exports, "COLOR_CF_TYPE", ()=>$81f079589240b9b7$export$b4a1fbc1cf0059cf);
    $parcel$export(module.exports, "EPIC_COLOR_TYPE", ()=>$81f079589240b9b7$export$4838a8a8d62a64fd);
    $parcel$export(module.exports, "ASSETS_CF_TYPE", ()=>$81f079589240b9b7$export$ed2de20ab8b7ad3d);
    $parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", ()=>$81f079589240b9b7$export$b755e97dbfa92610);
    $parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$1be1ecd4dfc06fab);
    $parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", ()=>$81f079589240b9b7$export$34317c2d84a93553);
    $parcel$export(module.exports, "ORGANIZATION_CF_TYPE", ()=>$81f079589240b9b7$export$c1e26582406f77ec);
    $parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", ()=>$81f079589240b9b7$export$555b4f35f98a3210);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", ()=>$81f079589240b9b7$export$1f2859a3ef701a14);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$68f62eb762e4157f);
    $parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", ()=>$81f079589240b9b7$export$6da975fce1fbd38e);
    $parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", ()=>$81f079589240b9b7$export$c6dd874aae21e51f);
    $parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c3c9f8a8a8dc0b30);
    $parcel$export(module.exports, "RANK_CF_TYPE", ()=>$81f079589240b9b7$export$af89c0396aaf23e3);
    $parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$3b5a62bb34372404);
    $parcel$export(module.exports, "READ_ONLY_CF_TYPE", ()=>$81f079589240b9b7$export$247829aef464243f);
    $parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", ()=>$81f079589240b9b7$export$65a6076c0927d413);
    $parcel$export(module.exports, "RESPONDERS_CF_TYPE", ()=>$81f079589240b9b7$export$bcf83e1d934501c9);
    $parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", ()=>$81f079589240b9b7$export$ae0eeec12e90a01e);
    $parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23f6b40da18371a);
    $parcel$export(module.exports, "SENTIMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23cfbdf83daa90d);
    $parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", ()=>$81f079589240b9b7$export$21dda64db57e4883);
    $parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", ()=>$81f079589240b9b7$export$45700f3bf92a003a);
    $parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", ()=>$81f079589240b9b7$export$2d75b47d12efc812);
    $parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", ()=>$81f079589240b9b7$export$7b79405842547ccb);
    $parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", ()=>$81f079589240b9b7$export$96201d0ae03ca323);
    $parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$fc276d6ccf118a14);
    $parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", ()=>$81f079589240b9b7$export$8b0718167d092603);
    $parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", ()=>$81f079589240b9b7$export$904b40dd2afd17a2);
    $parcel$export(module.exports, "GOALS_CF_TYPE", ()=>$81f079589240b9b7$export$2bbb7f69c97ea279);
    $parcel$export(module.exports, "ASSIGNEE_TYPE", ()=>$81f079589240b9b7$export$fba8634fd401ba8b);
    $parcel$export(module.exports, "REPORTER_TYPE", ()=>$81f079589240b9b7$export$a91aea2438afcce8);
    $parcel$export(module.exports, "DUE_DATE_TYPE", ()=>$81f079589240b9b7$export$b159f8b8f27aae4c);
    $parcel$export(module.exports, "PRIORITY_TYPE", ()=>$81f079589240b9b7$export$34740f8d07d23ac0);
    $parcel$export(module.exports, "LABELS_TYPE", ()=>$81f079589240b9b7$export$43b6e33ec70f2272);
    $parcel$export(module.exports, "CREATED", ()=>$81f079589240b9b7$export$ff39ebd4bb12b718);
    $parcel$export(module.exports, "UPDATED", ()=>$81f079589240b9b7$export$cd8e68094cb5c3cb);
    $parcel$export(module.exports, "RESOLUTION_DATE", ()=>$81f079589240b9b7$export$6a052efb0b4ec5d2);
    $parcel$export(module.exports, "COMPONENTS_TYPE", ()=>$81f079589240b9b7$export$37abf56f13f61ec5);
    $parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", ()=>$81f079589240b9b7$export$aef0c22aecd16996);
    $parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", ()=>$81f079589240b9b7$export$cff5b6d1e7135679);
    $parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", ()=>$81f079589240b9b7$export$791007408faf42f4);
    $parcel$export(module.exports, "DEV_SUMMARY_TYPE", ()=>$81f079589240b9b7$export$827a1c600bac12a3);
    $parcel$export(module.exports, "RELEASES_TYPE", ()=>$81f079589240b9b7$export$e9ba671d077969f8);
    $parcel$export(module.exports, "SPRINT_TYPE", ()=>$81f079589240b9b7$export$3d37701ba6fb68ec);
    $parcel$export(module.exports, "STORY_POINTS_TYPE", ()=>$81f079589240b9b7$export$36fd22f47020f37b);
    $parcel$export(module.exports, "EPIC_TYPE", ()=>$81f079589240b9b7$export$9f2fedcd916d2a79);
    $parcel$export(module.exports, "EPIC_NAME_TYPE", ()=>$81f079589240b9b7$export$dfc63737b8c0150d);
    $parcel$export(module.exports, "FIX_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$a5c9f63aadcb220);
    $parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$94009605902e4fe5);
    $parcel$export(module.exports, "DESCRIPTION_TYPE", ()=>$81f079589240b9b7$export$5e7324042f1d6b31);
    $parcel$export(module.exports, "ENVIRONMENT_TYPE", ()=>$81f079589240b9b7$export$113281d03e6830ef);
    $parcel$export(module.exports, "WATCHES_TYPE", ()=>$81f079589240b9b7$export$5ff798870a3dffbf);
    $parcel$export(module.exports, "SUMMARY_TYPE", ()=>$81f079589240b9b7$export$907219511d14ba3d);
    $parcel$export(module.exports, "PROFORMA_FORMS", ()=>$81f079589240b9b7$export$d09aa6a4f3538063);
    $parcel$export(module.exports, "RESOLUTION_TYPE", ()=>$81f079589240b9b7$export$3aca8c91b58a42e2);
    $parcel$export(module.exports, "TIME_TRACKING_TYPE", ()=>$81f079589240b9b7$export$ccb5ffefbf8b987c);
    $parcel$export(module.exports, "TIME_ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$c8bedad98a5e7f5f);
    $parcel$export(module.exports, "STATUS_TYPE", ()=>$81f079589240b9b7$export$358267065be1e);
    $parcel$export(module.exports, "STATUS_CATEGORY_TYPE", ()=>$81f079589240b9b7$export$dcaa788c7ada56de);
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$81f079589240b9b7$export$ebb48b08205007c5);
    $parcel$export(module.exports, "ISSUE_KEY_TYPE", ()=>$81f079589240b9b7$export$5e91047fe9955d0e);
    $parcel$export(module.exports, "CHILDREN_ISSUES", ()=>$81f079589240b9b7$export$3b3d0889022c85b3);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$335851d83a79891);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$7b76bbcb87d41695);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$297b67ac63f09f72);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$ae87161126086be);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$6a88420fc2f6901d);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$ef1a0421bd42c0e4);
    $parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$dd695c8c5ab62f9d);
    $parcel$export(module.exports, "SLA_PANEL_TYPE", ()=>$81f079589240b9b7$export$7b3d247435a784fa);
    $parcel$export(module.exports, "LINKED_ALERTS_TYPE", ()=>$81f079589240b9b7$export$17b7080ed1fe8cfd);
    $parcel$export(module.exports, "CHAT_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$29fe745131dad7ba);
    $parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$9c245100c3091ec3);
    $parcel$export(module.exports, "ZOOM_MEETING_TYPE", ()=>$81f079589240b9b7$export$51eb15cea47a37ba);
    $parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", ()=>$81f079589240b9b7$export$c7ae0622b0bd5d56);
    $parcel$export(module.exports, "CONFERENCE_CALL_TYPE", ()=>$81f079589240b9b7$export$f7dcde9e9e88aff2);
    $parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", ()=>$81f079589240b9b7$export$b5358afda8ff335e);
    $parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", ()=>$81f079589240b9b7$export$63cf6f392da16c25);
    $parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", ()=>$81f079589240b9b7$export$22f61ccc2730431f);
    $parcel$export(module.exports, "SUBTASKS_TYPE", ()=>$81f079589240b9b7$export$8bbb446f57294715);
    $parcel$export(module.exports, "VOTES_TYPE", ()=>$81f079589240b9b7$export$34fcd7cb291a1e4d);
    $parcel$export(module.exports, "PARENT_TYPE", ()=>$81f079589240b9b7$export$5e93f2a57cc4ca3a);
    $parcel$export(module.exports, "PROJECT_TYPE", ()=>$81f079589240b9b7$export$91a9dba2d38d9a6f);
    $parcel$export(module.exports, "TIME_SPENT_TYPE", ()=>$81f079589240b9b7$export$ede0a4c20124ec85);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", ()=>$81f079589240b9b7$export$3eeb79d48fb5f667);
    $parcel$export(module.exports, "SENTIMENT_TYPE", ()=>$81f079589240b9b7$export$45e72c9a63ab61ab);
    $parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", ()=>$81f079589240b9b7$export$99ad62164189f781);
    $parcel$export(module.exports, "FORGE_GLANCE_TYPE", ()=>$81f079589240b9b7$export$7719ef6e9283671);
    $parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$bfebea5ce2e1887a);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", ()=>$81f079589240b9b7$export$84e5674890d55030);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE", ()=>$81f079589240b9b7$export$326a5522a485e43d);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", ()=>$81f079589240b9b7$export$c9f3f01e2c535302);
    $parcel$export(module.exports, "TEAM_TYPE", ()=>$81f079589240b9b7$export$66519f3bbff1796a);
    $parcel$export(module.exports, "ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$a4ee0bca77cc8463);
    $parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", ()=>$81f079589240b9b7$export$fed53408e89e0497);
    $parcel$export(module.exports, "TARGET_START_TYPE", ()=>$81f079589240b9b7$export$d53c26f9ce31f56b);
    $parcel$export(module.exports, "TARGET_END_TYPE", ()=>$81f079589240b9b7$export$48f82d653f85e459);
    $parcel$export(module.exports, "START_DATE_TYPE", ()=>$81f079589240b9b7$export$ea5a888f39f722c7);
    $parcel$export(module.exports, "COLOR_TYPE", ()=>$81f079589240b9b7$export$f245bbec12cc0e40);
    $parcel$export(module.exports, "ATTACHMENT_TYPE", ()=>$81f079589240b9b7$export$aed630b4b7114a59);
    $parcel$export(module.exports, "ISSUE_LINKS_TYPE", ()=>$81f079589240b9b7$export$b50c1a8fef07104);
    $parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", ()=>$81f079589240b9b7$export$ea3d72f4bb7738ba);
    $parcel$export(module.exports, "COMMENT_TYPE", ()=>$81f079589240b9b7$export$a4cab0124760d860);
    $parcel$export(module.exports, "WORK_LOG_TYPE", ()=>$81f079589240b9b7$export$734929aef118d7e2);
    $parcel$export(module.exports, "PARENT_FIELD_TYPE", ()=>$81f079589240b9b7$export$ffbacacb07c1d46d);
    $parcel$export(module.exports, "getLayoutFieldTypes", ()=>$81f079589240b9b7$export$3c3e26aadbfa2c32);
    var $8QpSo;
    var $4R6GH;
    const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
    const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
    const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
    const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
    const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
    const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
    const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option';
    const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
    const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
    const $81f079589240b9b7$export$5600354b43577e17 = 'user';
    const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
    const $81f079589240b9b7$export$253649f07fb55948 = 'object';
    const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
    const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
    const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
    const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues';
    const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
    const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
    const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
    const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
    const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
    const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
    const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
    const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
    const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
    const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
    const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
    const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
    const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
    const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
    const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
    const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
    const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
    const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
    const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
    const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
    const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
    const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
    const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
    const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
    const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
    const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
    const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
    const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
    const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
    const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
    const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
    const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
    const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
    const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
    const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
    const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
    const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
    const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
    const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
    const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
    const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
    const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
    const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
    const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
    const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
    const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
    const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
    const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
    const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
    const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
    const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
    const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
    const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
    const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
    const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
    const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
    const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
    const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
    const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
    const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
    const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
    const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
    const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
    const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
    const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
    const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
    const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
    const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
    const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
    const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
    const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
    const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
    const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
    const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
    const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
    const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
    const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
    const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
    const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
    const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
    const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
    const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
    const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
    const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
    const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
    const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
    const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
    const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
    const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
    const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
    const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
    const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
    const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
    const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
    const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
    const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
    const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
    const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
    const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
    const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
    const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
    const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
    const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
    const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
    const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
    const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
    const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
    const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
    const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
    const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
    const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
    const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
    const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
    const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
    const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
    const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
    const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
    const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
    const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
    const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
    const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
    const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
    const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
    const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
    const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
    const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
    const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
    const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
    const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
    const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
    const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
    const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
    const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
    const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
    const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
    const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
    const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
    const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
    const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
    const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
    const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
    const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
    const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
    const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
    const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
    const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
    const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
    const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
    const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
    const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
    const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
    const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
    const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
    const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
    const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
    const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
    const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
    const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
    const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
    const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
    const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
    const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
    const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
    const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
    const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
    const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
    const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
    const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
    const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
    const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
    const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
    const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
    const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
    const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
    const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
    const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
    const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
    const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
    const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
    const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
    const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
    const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
    const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
    const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
    const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
    const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
    const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
    const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
    const $81f079589240b9b7$export$358267065be1e = 'status';
    const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
    const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
    const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
    const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
    const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
    const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
    const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
    const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
    const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
    const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
    const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
    const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
    const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
    const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
    const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
    const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
    const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
    const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
    const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
    const $81f079589240b9b7$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
    const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
    const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
    const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
    const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
    const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
    const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
    const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue';
    const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
    const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
    const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
    const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
    const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
    const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
    const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
    const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
    const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
    const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
    const $81f079589240b9b7$export$326a5522a485e43d = 'security';
    const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
    const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
    const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
    const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
    const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
    const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
    const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
    const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
    const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
    const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
    const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
    const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
    const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
    const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
    const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
    const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
    const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
    const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
    const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
    const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
    const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
    const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
        const types = {
            ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
            DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
            PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
            REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
            DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
            LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
            COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
            SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
            STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
            TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
            FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
            AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
            TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
            TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
            ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
            DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
            APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
            KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
            SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
            LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
            CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
            MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
            ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
            MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
            CONFERENCE_CALL_TYPE: $81f079589240b9b7$export$f7dcde9e9e88aff2,
            ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
            RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
            MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
            COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
            EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
            RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
            BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
            BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
            LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
            TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
            MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
            PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
            URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
            NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
            STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
            SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
            EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
            MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
            ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
            FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
            ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
            ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
            ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
            FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
            TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
            MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
            VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
            DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
            GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
            MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
            USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
            DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
            MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
            RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
            TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
            ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
            ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
            ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
            ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
            ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
            REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
            SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
            REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
            ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
            REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
            PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
            REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
            ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
            APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
            CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
            PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
            CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
            READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
            MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
            MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
            EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
            ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
            CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
            ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
            GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
            PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a
        };
        Object.assign(types, {
            FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsm-sentiment-analysis')) Object.assign(types, {
            SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
        });
        Object.assign(types, {
            SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
        });
        if (!(0, (0, parcelRequire("4R6GH")).fg)('remove_epic_link_and_parent_link_from_issue_view')) {
            Object.assign(types, {
                EPIC_TYPE: $81f079589240b9b7$export$9f2fedcd916d2a79
            });
            Object.assign(types, {
                PARENT_CF_TYPE: $81f079589240b9b7$export$3e71e11f80203acb
            });
        }
        if ((0, (0, parcelRequire("4R6GH")).fg)('jcs_issue_layout_eap')) Object.assign(types, {
            ORGANIZATION_CF_TYPE: $81f079589240b9b7$export$c1e26582406f77ec
        });
        return types;
    };
    const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, (0, parcelRequire("8QpSo")).default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);
});
parcelRegister("gl0PU", function(module, exports) {
    $parcel$export(module.exports, "toErrorId", ()=>$b5e194c6e2cc34cd$export$706bbe4209d93dfe);
    $parcel$export(module.exports, "toErrorMessage", ()=>$b5e194c6e2cc34cd$export$95506c204c060a3);
    const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
    const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;
});
parcelRegister("1RLjE", function(module, exports) {
    $parcel$export(module.exports, "logError", ()=>$b0fc9ceb76f86c8e$export$58da9968c3170cb1);
    var $dJl1T;
    var $jcw0u;
    const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: packageName,
                id: errorId,
                teamName: 'morphinecake'
            },
            attributes: {
                ...attributes,
                message: message
            },
            error: error
        });
        const location = `${packageName}.${errorId}`;
        (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, message, error);
    };
});
parcelRegister("j9iVo", function(module, exports) {
    $parcel$export(module.exports, "ConnectAppsSubscriber", ()=>$1d2a37fb0b2cedf7$export$2646f920b0e2e4de);
    $parcel$export(module.exports, "useConnectApps", ()=>$1d2a37fb0b2cedf7$export$4864478dcab77643);
    $parcel$export(module.exports, "ConnectAppsContainer", ()=>$1d2a37fb0b2cedf7$export$ac845603c8c91acd);
    var $7JoAD = parcelRequire("7JoAD");
    var $7YSUx;
    const $1d2a37fb0b2cedf7$export$2646f920b0e2e4de = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("7YSUx")).default), {
        displayName: 'ConnectAppsSubscriber'
    });
    const $1d2a37fb0b2cedf7$export$4864478dcab77643 = (0, $7JoAD.createHook)((0, (0, parcelRequire("7YSUx")).default));
    const $1d2a37fb0b2cedf7$export$ac845603c8c91acd = (0, $7JoAD.createContainer)((0, (0, parcelRequire("7YSUx")).default));
});
parcelRegister("7YSUx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3bdb3f5fb2a260df$export$2e2bcd8739ae039);
    var $7JoAD = parcelRequire("7JoAD");
    var $76t3Y;
    const $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a = {
        data: null,
        loading: false,
        error: null,
        hasFirstError: false
    };
    var $3bdb3f5fb2a260df$export$2e2bcd8739ae039 = (0, $7JoAD.createStore)({
        name: 'connect-apps',
        initialState: $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("76t3Y")).actions
    });
});
parcelRegister("76t3Y", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$183a508abf4e51e7$export$e324594224ef24da);
    var $8VvCU;
    const $183a508abf4e51e7$export$e324594224ef24da = {
        fetch: (0, parcelRequire("8VvCU")).default
    };
});
parcelRegister("8VvCU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b005bb27151e101$export$2e2bcd8739ae039);
    var $2FYaA;
    var $3b005bb27151e101$export$2e2bcd8739ae039 = (projectKey)=>async ({ setState: setState, getState: getState }, { onError: onError })=>{
            const currentState = getState();
            if (!projectKey || currentState.loading) return;
            setState({
                loading: true,
                error: null
            });
            try {
                const data = await (0, (0, parcelRequire("2FYaA")).default)(projectKey);
                setState({
                    data: data,
                    loading: false,
                    error: null
                });
            } catch (err) {
                const { hasFirstError: hasFirstError, data: data } = getState();
                const isFirstError = !hasFirstError && data === null;
                setState({
                    error: err,
                    loading: false,
                    hasFirstError: hasFirstError || isFirstError
                });
                if (onError) onError(isFirstError);
            }
        };
});
parcelRegister("2FYaA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27cd0e7e45645bce$export$2e2bcd8739ae039);
    var $7f4tk;
    var $gl0PU;
    var $koFzm;
    var $lVlV8;
    const $27cd0e7e45645bce$export$43bc37ac3360968f = (projectKey)=>`/rest/internal/2/connectprojectconfig/${projectKey}`;
    var $27cd0e7e45645bce$export$2e2bcd8739ae039 = (projectKey)=>{
        const fetchPromise = (0, (0, parcelRequire("koFzm")).famaCatchAndLogFetchError)((0, (0, parcelRequire("7f4tk")).default)($27cd0e7e45645bce$export$43bc37ac3360968f(projectKey)), (0, (0, parcelRequire("lVlV8")).PACKAGE_NAME), (0, (0, parcelRequire("gl0PU")).toErrorId)('getConnectApps'), (0, (0, parcelRequire("gl0PU")).toErrorMessage)('Failed to fetch connect apps for a project'));
        return fetchPromise.then((response)=>response.map((app)=>{
                const options = JSON.parse(app.iframe.options);
                const myApp = {
                    title: app.title,
                    id: options.uniqueKey,
                    connectIframeProps: {
                        addon_key: app.iframe.addonKey,
                        key: app.iframe.moduleKey,
                        url: options.url,
                        options: {
                            ...options,
                            productContext: JSON.parse(options.productCtx),
                            structuredContext: JSON.parse(options.structuredContext),
                            user: {
                                uid: options.uid,
                                ukey: options.ukey,
                                timeZone: options.timeZone
                            }
                        }
                    }
                };
                return myApp;
            }));
    };
});
parcelRegister("koFzm", function(module, exports) {
    $parcel$export(module.exports, "famaCatchAndLogFetchError", ()=>$eb8b95f475174133$export$c3948fffb56ff7bb);
    $parcel$export(module.exports, "default", ()=>$eb8b95f475174133$export$2e2bcd8739ae039);
    var $dJl1T;
    var $jJZqs;
    var $1RLjE;
    const $eb8b95f475174133$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
    const $eb8b95f475174133$var$getStatusCodeGroup = (error)=>{
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
            const { statusCode: statusCode } = error;
            if (statusCode >= 100 && statusCode <= 199) return '1xx';
            if (statusCode >= 300 && statusCode <= 399) return '3xx';
            if (statusCode >= 400 && statusCode <= 499) return '4xx';
            if (statusCode >= 500 && statusCode <= 599) return '5xx';
        }
        if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) return '4xx';
        return 'unknown';
    };
    const $eb8b95f475174133$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($eb8b95f475174133$var$HTTP_LOCATION, message, error);
            throw error;
        });
    const $eb8b95f475174133$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
            const statusCodeGroup = $eb8b95f475174133$var$getStatusCodeGroup(error);
            (0, (0, parcelRequire("1RLjE")).logError)(packageName, errorId, message, error, {
                http: true,
                statusCodeGroup: statusCodeGroup
            });
            throw error;
        });
    var $eb8b95f475174133$export$2e2bcd8739ae039 = $eb8b95f475174133$var$catchAndLogFetchError;
});
parcelRegister("lVlV8", function(module, exports) {
    $parcel$export(module.exports, "APP_ID", ()=>$418c76e16c63cf92$export$d76071d5de2774fc);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$418c76e16c63cf92$export$b8b9d90f9e5bd72b);
    var $3XO6n;
    const $418c76e16c63cf92$export$d76071d5de2774fc = 'project-settings/connect-apps';
    const $418c76e16c63cf92$export$b8b9d90f9e5bd72b = (0, (0, parcelRequire("3XO6n")).toPackageName)('jiraProjectSettingsAppsConnectApps');
});
parcelRegister("6EZeH", function(module, exports) {
    $parcel$export(module.exports, "useDlpEntitlement", ()=>$c4c8661954b324b0$export$4472465702535e7);
    var $9OXo1;
    const $c4c8661954b324b0$export$4472465702535e7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.hasDlpEnabled || false;
    };
});
parcelRegister("9DEd8", function(module, exports) {
    $parcel$export(module.exports, "EcosystemAppsMenu", ()=>$865dc24bed436cec$export$e583660e6ee09caf);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWqXX;
    var $2vSU6;
    var $1rTGO;
    var $aHv3X;
    var $k2DRb;
    var $koVbs;
    var $k0ZZ2;
    var $lpwtK;
    var $4OCke;
    var $k51JQ;
    var $6hMYg;
    var $02Psx;
    var $j9iVo;
    var $gb5lQ;
    var $7OvX8;
    const $865dc24bed436cec$export$c62cfdba33f43c7e = ({ baseSettingsUrl: baseSettingsUrl = '', projectKey: projectKey })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ data: connectAppsData, loading: connectLoading }] = (0, (0, parcelRequire("j9iVo")).useConnectApps)();
        const { data: forgeApps, loading: forgeLoading } = (0, (0, parcelRequire("6hMYg")).useProjectSettingsForgeAppsForMenu)();
        const filteredConnectAppsData = (0, $5uXOq.useMemo)(()=>connectAppsData?.filter((app)=>app?.connectIframeProps?.addon_key !== (0, (0, parcelRequire("gb5lQ")).JIRA_AUTOMATION_ADDON_KEY)), [
            connectAppsData
        ]);
        const sortedApps = (0, $5uXOq.useMemo)(()=>[
                ...(forgeApps || []).map((app)=>({
                        type: 'forge',
                        name: app.name,
                        app: app
                    })),
                ...(filteredConnectAppsData || []).map((app)=>({
                        type: 'connect',
                        name: app.title,
                        app: app
                    }))
            ].sort((a, b)=>a.name.localeCompare(b.name)), [
            forgeApps,
            filteredConnectAppsData
        ]);
        const overrides = (0, $5uXOq.useMemo)(()=>({
                BackMenuItem: {
                    href: `/jira/core/projects/${projectKey}/settings`,
                    title: formatMessage((0, (0, parcelRequire("7OvX8")).messages).backItem),
                    onClick: (ev)=>ev.preventDefault()
                }
            }), [
            projectKey,
            formatMessage
        ]);
        if (connectLoading || forgeLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'app-fields'
            },
            href: `${baseSettingsUrl}/apps/app-fields`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("7OvX8")).messages).appFields)), sortedApps.map((ecosystemItem)=>{
            const { type: type, app: app } = ecosystemItem;
            if (type === 'forge') {
                const item = app;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                    key: item.id,
                    ...item,
                    showIcon: false,
                    overrides: overrides
                });
            }
            const connectApp = app;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: connectApp.id
                },
                key: connectApp.id,
                href: `${baseSettingsUrl}/apps/${connectApp.id}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
            }, connectApp.title);
        }), forgeApps?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
            attributes: {
                moduleType: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
            }
        }) : null);
    };
    const $865dc24bed436cec$export$e583660e6ee09caf = (props)=>{
        const { children: children } = props;
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectKey = project && project.key || '';
        const baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), projectKey);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aHv3X")).TriggerAnalyticsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9iVo")).ConnectAppsContainer), {
            onError: undefined,
            scope: projectKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($865dc24bed436cec$export$c62cfdba33f43c7e, {
            baseSettingsUrl: baseSettingsUrl,
            projectKey: projectKey
        }), children != null && children));
    };
});
parcelRegister("aHv3X", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$de4af379e202f62d$export$c794eb4124961145);
    $parcel$export(module.exports, "TriggerAnalyticsWrapper", ()=>$de4af379e202f62d$export$e1a79e3d472c925a);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    var $hBuqR;
    const $de4af379e202f62d$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $de4af379e202f62d$export$e1a79e3d472c925a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
            ...props
        });
});
parcelRegister("7OvX8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$43a11d7b95b850bb$export$defe85febe8b728c);
    var $7VHMR;
    const $43a11d7b95b850bb$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        apps: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.apps",
            "defaultMessage": "Apps"
        },
        appFields: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.app-fields",
            "defaultMessage": "App fields"
        },
        backItem: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.back-item",
            "defaultMessage": "Back"
        }
    });
});
parcelRegister("1tmBf", function(module, exports) {
    $parcel$export(module.exports, "IssueTypes", ()=>$b746059f9b32cf5c$export$15fef796fc6acc30);
    var $5uXOq = parcelRequire("5uXOq");
    var $7ymNM;
    var $gjTBi;
    var $3bDjY;
    var $2vSU6;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $lpwtK;
    var $h9XlT;
    var $lGo7j;
    var $7OqB4;
    var $4ya5m;
    var $02Psx;
    var $kIafm;
    var $afIXj;
    const $b746059f9b32cf5c$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $b746059f9b32cf5c$export$15fef796fc6acc30 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ asyncState: asyncState, topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel, addIssueTypeTooltip: addIssueTypeTooltip, isAddIssueTypeDisabled: isAddIssueTypeDisabled }] = (0, (0, parcelRequire("kIafm")).useIssueTypesNavigationItems)();
        const [, addIssueTypesContextActions] = (0, (0, parcelRequire("4ya5m")).useAddIssueTypeContext)();
        const { data: project } = $b746059f9b32cf5c$export$a4007dc4843ca7f6();
        let baseSettingsUrl = '';
        if (project !== null) baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), project.key);
        const hasAnyIssueTypes = topLevel.length > 0 || baseLevel.length > 0 || bottomLevel.length > 0;
        const isReady = asyncState === 'SUCCESS' || hasAnyIssueTypes;
        if (!project || !isReady) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("afIXj")).default).issueTypes)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: false,
            navigationItems: topLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: true,
            navigationItems: baseLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: true,
            navigationItems: bottomLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (()=>{
            const addItem = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: 'add-issue-type'
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                    label: formatMessage((0, (0, parcelRequire("afIXj")).default).addIssueType)
                }),
                isDisabled: isAddIssueTypeDisabled,
                onClick: isAddIssueTypeDisabled ? undefined : addIssueTypesContextActions.openAddIssueTypeModal
            }, formatMessage((0, (0, parcelRequire("afIXj")).default).addIssueType));
            return addIssueTypeTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: addIssueTypeTooltip
            }, addItem) : addItem;
        })()));
    };
});
parcelRegister("7ymNM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
    function $57fd655943aa23fe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $57fd655943aa23fe$var$AddIcon = (props)=>$57fd655943aa23fe$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
        }, props, {
            newIcon: $57fd655943aa23fe$var$_add.default
        }));
    $57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
    var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;
});
parcelRegister("h9XlT", function(module, exports) {
    $parcel$export(module.exports, "IssueTypesGroup", ()=>$f4e999d453ca906b$export$5bc39a07c26525ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $gjTBi;
    var $k0ZZ2;
    var $4OCke;
    const $f4e999d453ca906b$export$5bc39a07c26525ad = ({ MenuItem: MenuItem = (0, (0, parcelRequire("k0ZZ2")).MenuItem), Section: Section = (0, (0, parcelRequire("gjTBi")).default), baseSettingsUrl: baseSettingsUrl, hasSeparator: hasSeparator, navigationItems: navigationItems })=>{
        if (!navigationItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Section, {
            hasSeparator: hasSeparator
        }, navigationItems.map((issueType)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                key: String(issueType.id),
                analytics: {
                    itemId: String(issueType.id)
                },
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                href: `${baseSettingsUrl}/issuetypes/${issueType.id}`,
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    appearance: "square",
                    size: "small",
                    src: issueType.icon,
                    borderColor: "transparent"
                })
            }, issueType.name)));
    };
});
parcelRegister("4ya5m", function(module, exports) {
    $parcel$export(module.exports, "useAddIssueTypeContext", ()=>$018a92cfc5e17302$export$40493c3e9059110a);
    var $7JoAD = parcelRequire("7JoAD");
    const $018a92cfc5e17302$var$initialState = {
        isActive: false
    };
    const $018a92cfc5e17302$var$openAddIssueTypeModal = ()=>({ setState: setState })=>{
            setState({
                isActive: true
            });
        };
    const $018a92cfc5e17302$var$closeAddIssueTypeModal = ()=>({ setState: setState })=>{
            setState({
                isActive: false
            });
        };
    const $018a92cfc5e17302$var$actions = {
        openAddIssueTypeModal: $018a92cfc5e17302$var$openAddIssueTypeModal,
        closeAddIssueTypeModal: $018a92cfc5e17302$var$closeAddIssueTypeModal
    };
    const $018a92cfc5e17302$var$STORE_NAME = 'jira-project-settings-apps-add-issue-type-context';
    const $018a92cfc5e17302$var$Store = (0, $7JoAD.createStore)({
        name: $018a92cfc5e17302$var$STORE_NAME,
        initialState: $018a92cfc5e17302$var$initialState,
        actions: $018a92cfc5e17302$var$actions
    });
    const $018a92cfc5e17302$export$40493c3e9059110a = (0, $7JoAD.createHook)($018a92cfc5e17302$var$Store);
    const $018a92cfc5e17302$export$a0f296f941567e3d = (0, $7JoAD.createSubscriber)($018a92cfc5e17302$var$Store);
    const $018a92cfc5e17302$var$storeInstance = {
        state: $018a92cfc5e17302$var$initialState,
        actions: null
    };
    const $018a92cfc5e17302$export$f1a20ca23c90093e = ()=>{
        const [issueTypeContextState, issueTypeContextActions] = $018a92cfc5e17302$export$40493c3e9059110a();
        $018a92cfc5e17302$var$storeInstance.state = issueTypeContextState;
        $018a92cfc5e17302$var$storeInstance.actions = issueTypeContextActions;
        return null;
    };
    const $018a92cfc5e17302$export$605f542240ea8e19 = ()=>$018a92cfc5e17302$var$storeInstance.actions;
});
parcelRegister("kIafm", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypesNavigationItems", ()=>$117ff49c1fb0e68b$export$8facf5695da03580);
    $parcel$export(module.exports, "useIssueTypesNavigationItemsActions", ()=>$117ff49c1fb0e68b$export$502d4d04702890ce);
    var $6wesA;
    var $7JoAD = parcelRequire("7JoAD");
    var $kXBJP;
    var $bI4Ju;
    const $117ff49c1fb0e68b$export$d4c72bab9d6cc13a = {
        projectId: null,
        asyncState: (0, (0, parcelRequire("6wesA")).INIT),
        data: {
            limitPerProject: null,
            issueTypes: []
        },
        addIssueTypeTooltipMessage: ''
    };
    const $117ff49c1fb0e68b$var$load = (projectId, productFeatures, intl)=>async ({ setState: setState, getState: getState })=>{
            try {
                const currentState = getState();
                if (currentState.asyncState === (0, (0, parcelRequire("6wesA")).LOADING) && projectId === currentState.projectId) return;
                setState({
                    ...projectId === currentState.projectId ? currentState : $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
                    projectId: projectId,
                    asyncState: (0, (0, parcelRequire("6wesA")).LOADING)
                });
                const result = await (0, (0, parcelRequire("kXBJP")).queryIssueTypesNavigationItems)(projectId, productFeatures);
                if (getState().projectId !== projectId) return;
                const { limitPerProject: limitPerProject, data: data } = result.data.simplifiedProject.issueTypeCollection;
                setState({
                    projectId: projectId,
                    asyncState: (0, (0, parcelRequire("6wesA")).SUCCESS),
                    data: {
                        limitPerProject: limitPerProject,
                        issueTypes: data
                    },
                    addIssueTypeTooltipMessage: intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltip, {
                        limit: limitPerProject
                    })
                });
            } catch (error) {
                setState({
                    asyncState: (0, (0, parcelRequire("6wesA")).FAILURE)
                });
            }
        };
    const $117ff49c1fb0e68b$var$remove = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS)) return;
            setState({
                ...state,
                data: {
                    ...state.data,
                    issueTypes: state.data.issueTypes.filter(({ id: id })=>id !== issueTypeId)
                }
            });
        };
    const $117ff49c1fb0e68b$var$update = (layoutOwners)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS)) return;
            const newDataById = {};
            for(let i = 0; i < layoutOwners.length; i += 1){
                const { data: data } = layoutOwners[i];
                newDataById[data.id] = {
                    name: data.name,
                    avatarId: data.avatarId,
                    icon: data.iconUrl
                };
            }
            const issueTypes = state.data.issueTypes.map((issueType)=>{
                if (!newDataById[issueType.id]) return issueType;
                const { name: name, avatarId: avatarId } = newDataById[issueType.id];
                return {
                    ...issueType,
                    name: name,
                    avatarId: avatarId || issueType.avatarId
                };
            });
            setState({
                ...state,
                data: {
                    ...state.data,
                    issueTypes: issueTypes
                }
            });
        };
    const $117ff49c1fb0e68b$export$e324594224ef24da = {
        load: $117ff49c1fb0e68b$var$load,
        remove: $117ff49c1fb0e68b$var$remove,
        update: $117ff49c1fb0e68b$var$update
    };
    const $117ff49c1fb0e68b$export$94d3eea6047656ad = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
        const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
        const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, (0, parcelRequire("bI4Ju")).getIssueTypeNavigationItemsLevels)(issueTypes);
        const isIssueTypeLimitReached = (0, (0, parcelRequire("bI4Ju")).getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
        const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
        return {
            asyncState: asyncState,
            projectId: projectId,
            isAddIssueTypeDisabled: asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS) || isIssueTypeLimitReached,
            addIssueTypeTooltip: addIssueTypeTooltip,
            topLevel: topLevel,
            baseLevel: baseLevel,
            bottomLevel: bottomLevel
        };
    };
    const $117ff49c1fb0e68b$var$STORE_NAME = 'issue-type-page-navigation-items-new';
    const $117ff49c1fb0e68b$var$Store = (0, $7JoAD.createStore)({
        name: $117ff49c1fb0e68b$var$STORE_NAME,
        initialState: $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
        actions: $117ff49c1fb0e68b$export$e324594224ef24da
    });
    const $117ff49c1fb0e68b$export$8facf5695da03580 = (0, $7JoAD.createHook)($117ff49c1fb0e68b$var$Store, {
        selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
    });
    const $117ff49c1fb0e68b$export$502d4d04702890ce = (0, $7JoAD.createActionsHook)($117ff49c1fb0e68b$var$Store);
    const $117ff49c1fb0e68b$export$313f907c8e339d1b = (0, $7JoAD.createSubscriber)($117ff49c1fb0e68b$var$Store, {
        selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
    });
});
parcelRegister("6wesA", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$a553a914b9b6f7c9$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "INACTIVE_LIST", ()=>$a553a914b9b6f7c9$export$d7fec05af6b928f7);
    $parcel$export(module.exports, "FIELD_TYPE_LIST", ()=>$a553a914b9b6f7c9$export$de26d0d1ef96d0ed);
    $parcel$export(module.exports, "DELETE_DROPPABLE_ID", ()=>$a553a914b9b6f7c9$export$a155cb9d82798d65);
    $parcel$export(module.exports, "IGNORE_CLICK_OUTSIDE_CLASS_NAME", ()=>$a553a914b9b6f7c9$export$8191ccc97ff9885c);
    $parcel$export(module.exports, "DO_NOT_ANIMATE_WIDTH", ()=>$a553a914b9b6f7c9$export$c77ecc59e9e91e60);
    $parcel$export(module.exports, "JSD_FIELD_HELPTEXT", ()=>$a553a914b9b6f7c9$export$663476c4863d5014);
    $parcel$export(module.exports, "ID_REQUEST_OWNER_PROPERTY_KEY", ()=>$a553a914b9b6f7c9$export$9be9f574874c9a2f);
    $parcel$export(module.exports, "NAME_REQUEST_OWNER_PROPERTY_KEY", ()=>$a553a914b9b6f7c9$export$b320c6b352dcb101);
    $parcel$export(module.exports, "SUGGESTED_GROUP", ()=>$a553a914b9b6f7c9$export$e66b34cc29932bbf);
    $parcel$export(module.exports, "ASSETS_GROUP", ()=>$a553a914b9b6f7c9$export$c87c7df18254969e);
    $parcel$export(module.exports, "DATES_GROUP", ()=>$a553a914b9b6f7c9$export$fa8c310a8ac47d47);
    $parcel$export(module.exports, "LABELS_GROUP", ()=>$a553a914b9b6f7c9$export$5b2dd1b457037e13);
    $parcel$export(module.exports, "NUMBER_GROUP", ()=>$a553a914b9b6f7c9$export$2c2f344ca2ba1c03);
    $parcel$export(module.exports, "PEOPLE_GROUP", ()=>$a553a914b9b6f7c9$export$1441c9d524a8c0f2);
    $parcel$export(module.exports, "SELECT_GROUP", ()=>$a553a914b9b6f7c9$export$d3e4788fc90e5f8f);
    $parcel$export(module.exports, "SYSTEM_GROUP", ()=>$a553a914b9b6f7c9$export$724e0d23ac7e9b03);
    $parcel$export(module.exports, "TEXT_GROUP", ()=>$a553a914b9b6f7c9$export$bd76d204d15f4c6a);
    $parcel$export(module.exports, "VERSION_GROUP", ()=>$a553a914b9b6f7c9$export$33d3fa5e989ba460);
    $parcel$export(module.exports, "ADVANCED_GROUP", ()=>$a553a914b9b6f7c9$export$c58a10f3e3456974);
    $parcel$export(module.exports, "OTHER_GROUP", ()=>$a553a914b9b6f7c9$export$591e195d295fd27e);
    $parcel$export(module.exports, "RESTRICTED_GROUP", ()=>$a553a914b9b6f7c9$export$14785d7afcf55619);
    $parcel$export(module.exports, "AI_SUGGESTED_GROUP", ()=>$a553a914b9b6f7c9$export$df593ebd3e7c9c2d);
    $parcel$export(module.exports, "INIT", ()=>$a553a914b9b6f7c9$export$d788bc089976c004);
    $parcel$export(module.exports, "LOADING", ()=>$a553a914b9b6f7c9$export$26d55645375ca9a);
    $parcel$export(module.exports, "SUCCESS", ()=>$a553a914b9b6f7c9$export$638cc6e36b2a737a);
    $parcel$export(module.exports, "FAILURE", ()=>$a553a914b9b6f7c9$export$5b1e245d5eac107);
    $parcel$export(module.exports, "classicFieldTypesMap", ()=>$a553a914b9b6f7c9$export$369c1f8ac37104ce);
    $parcel$export(module.exports, "ngFieldTypesMap", ()=>$a553a914b9b6f7c9$export$b361664c16c2ea91);
    $parcel$export(module.exports, "SWIFT_VERSION_M2", ()=>$a553a914b9b6f7c9$export$527472231e0f6045);
    var $5fc53;
    var $3XO6n;
    const $a553a914b9b6f7c9$export$b8b9d90f9e5bd72b = (0, (0, parcelRequire("3XO6n")).toPackageName)('jiraProjectSettingsAppsIssueTypePageProductFeatures');
    const $a553a914b9b6f7c9$export$d7fec05af6b928f7 = 'inactive-list';
    const $a553a914b9b6f7c9$export$de26d0d1ef96d0ed = 'field-type-list';
    const $a553a914b9b6f7c9$export$a155cb9d82798d65 = 'delete-droppable-id';
    const $a553a914b9b6f7c9$export$8191ccc97ff9885c = '9|.^=*D(riA_=lUv787iQ7hwW5HIz=}t/OdJy%q';
    const $a553a914b9b6f7c9$export$c77ecc59e9e91e60 = 'DO_NOT_ANIMATE_WIDTH';
    const $a553a914b9b6f7c9$export$88ecd73c50643906 = 'swift_searchPreviouslyCreatedFields';
    const $a553a914b9b6f7c9$export$663476c4863d5014 = 'jsd.field.helpText';
    const $a553a914b9b6f7c9$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
    const $a553a914b9b6f7c9$export$9be9f574874c9a2f = 'jsm.issue.type.id';
    const $a553a914b9b6f7c9$export$b320c6b352dcb101 = 'jsm.issue.type.name';
    const $a553a914b9b6f7c9$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
    const $a553a914b9b6f7c9$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
    const $a553a914b9b6f7c9$export$27366eb417850f7c = [
        $a553a914b9b6f7c9$export$aefba859678f04a,
        $a553a914b9b6f7c9$export$b320c6b352dcb101,
        $a553a914b9b6f7c9$export$97bca9c51480133e,
        $a553a914b9b6f7c9$export$b540ee71bad36b8b
    ];
    const $a553a914b9b6f7c9$export$e66b34cc29932bbf = 'suggestedGroup';
    const $a553a914b9b6f7c9$export$c87c7df18254969e = 'assetsGroup';
    const $a553a914b9b6f7c9$export$fa8c310a8ac47d47 = 'datesGroup';
    const $a553a914b9b6f7c9$export$5b2dd1b457037e13 = 'labelsGroup';
    const $a553a914b9b6f7c9$export$2c2f344ca2ba1c03 = 'numberGroup';
    const $a553a914b9b6f7c9$export$1441c9d524a8c0f2 = 'peopleGroup';
    const $a553a914b9b6f7c9$export$d3e4788fc90e5f8f = 'selectGroup';
    const $a553a914b9b6f7c9$export$724e0d23ac7e9b03 = 'systemGroup';
    const $a553a914b9b6f7c9$export$bd76d204d15f4c6a = 'textGroup';
    const $a553a914b9b6f7c9$export$33d3fa5e989ba460 = 'versionGroup';
    const $a553a914b9b6f7c9$export$c58a10f3e3456974 = 'advancedGroup';
    const $a553a914b9b6f7c9$export$591e195d295fd27e = 'otherGroup';
    const $a553a914b9b6f7c9$export$14785d7afcf55619 = 'restrictedGroup';
    const $a553a914b9b6f7c9$export$df593ebd3e7c9c2d = 'aiSuggestedGroup';
    const $a553a914b9b6f7c9$export$d788bc089976c004 = 'INIT';
    const $a553a914b9b6f7c9$export$26d55645375ca9a = 'LOADING';
    const $a553a914b9b6f7c9$export$638cc6e36b2a737a = 'SUCCESS';
    const $a553a914b9b6f7c9$export$5b1e245d5eac107 = 'FAILURE';
    const $a553a914b9b6f7c9$export$369c1f8ac37104ce = {
        assetspicker: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        date: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        datetime: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        labelpicker: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
        number: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
        multiuserpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        userpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        checkbox: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        radio: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        cascadingselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        multiselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        select: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        attachment: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        textarea: $a553a914b9b6f7c9$export$bd76d204d15f4c6a
    };
    const $a553a914b9b6f7c9$export$b361664c16c2ea91 = {
        [(0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
        people: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03
    };
    const $a553a914b9b6f7c9$export$8e333612d4b83b0e = 'M1';
    const $a553a914b9b6f7c9$export$527472231e0f6045 = 'M2';
});
parcelRegister("kXBJP", function(module, exports) {
    $parcel$export(module.exports, "queryIssueTypesNavigationItems", ()=>$e8107a8cce63320f$export$d7f9b965a8cdf6ce);
    var $7f4tk;
    var $1JUEq;
    const $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery = (projectId)=>`query IssueTypesNavigationItems {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
            }
        }
    }
  }`;
    const $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery = (projectId, keys)=>`query IssueTypesNavigationItemsWithProperties {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
                properties(keys: ${JSON.stringify(keys)})
            }
        }
    }
  }`;
    const $e8107a8cce63320f$export$d7f9b965a8cdf6ce = (projectId, productFeatures)=>{
        const propertyKeys = (0, (0, parcelRequire("1JUEq")).getAllPropertiesKeys)(productFeatures);
        const query = propertyKeys.length ? $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery(projectId, propertyKeys) : $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery(projectId);
        return (0, (0, parcelRequire("7f4tk")).default)('/rest/gira/latest/?issue-type-page-navigation', {
            method: 'POST',
            body: JSON.stringify({
                query: query
            })
        });
    };
});
parcelRegister("1JUEq", function(module, exports) {
    $parcel$export(module.exports, "getAllPropertiesKeys", ()=>$fec81b5fddfaba4b$export$481a21941383de83);
    const $fec81b5fddfaba4b$export$481a21941383de83 = (features)=>{
        const { issueTypeHelpText: issueTypeHelpText } = features;
        const allPropertiesKeys = [
            (0, $052efe0fea3c4d67$export$97806a3c861a8076),
            (0, $052efe0fea3c4d67$export$5a53542e76b69730)
        ];
        return issueTypeHelpText ? allPropertiesKeys : [];
    };
});
const $052efe0fea3c4d67$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $052efe0fea3c4d67$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';
const $052efe0fea3c4d67$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $052efe0fea3c4d67$export$663476c4863d5014 = 'jsd.field.helpText';
const $052efe0fea3c4d67$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $052efe0fea3c4d67$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';
parcelRegister("bI4Ju", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeNavigationItemsLevels", ()=>$a611b4a47ee97f87$export$fcf99cb11372431f);
    $parcel$export(module.exports, "getIsIssueTypeLimitReached", ()=>$a611b4a47ee97f87$export$f9ef03d331bca3e6);
    var $g4tDr;
    var $4cS2K;
    const $a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
    const $a611b4a47ee97f87$export$fcf99cb11372431f = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
            const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
            const issueTypeNavigationItem = {
                id: id,
                name: name,
                avatarId: avatarId,
                operations: operations,
                icon: (0, (0, parcelRequire("4cS2K")).getProjectAvatarUrl)(avatarId)
            };
            if ((0, (0, parcelRequire("g4tDr")).isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
            else if ((0, (0, parcelRequire("g4tDr")).isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
            else if ((0, (0, parcelRequire("g4tDr")).isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
            return acc;
        }, {
            topLevel: [],
            baseLevel: [],
            bottomLevel: []
        });
    const $a611b4a47ee97f87$export$f9ef03d331bca3e6 = (limitPerProject, numberOfIssueTypes)=>limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;
});
parcelRegister("g4tDr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", ()=>$03dd5f7faa501890$export$2294cfc7730248df);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", ()=>$03dd5f7faa501890$export$961a1d6da881600c);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", ()=>$03dd5f7faa501890$export$e11dea67b88ee556);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", ()=>$03dd5f7faa501890$export$9ad20e435294162a);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", ()=>$03dd5f7faa501890$export$a454b3474c5ee5f5);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", ()=>$03dd5f7faa501890$export$b69c1b48ce8f83de);
    $parcel$export(module.exports, "BASE_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$ba7c785763a2a58f);
    $parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$e09d07f2dcff2603);
    $parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$1165245f61159842);
    $parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$8a96a83b3f957e58);
    $parcel$export(module.exports, "toHierarchyLevel", ()=>$03dd5f7faa501890$export$c0c893ca5ccae9dd);
    $parcel$export(module.exports, "isBaseHierarchyLevel", ()=>$03dd5f7faa501890$export$bcf91a9d8c5b0f58);
    $parcel$export(module.exports, "isEpicHierarchyLevel", ()=>$03dd5f7faa501890$export$e415cf60723c7aae);
    $parcel$export(module.exports, "isSubtaskHierarchyLevel", ()=>$03dd5f7faa501890$export$41f00a40e2ebd6e8);
    $parcel$export(module.exports, "getHierarchyLevelType", ()=>$03dd5f7faa501890$export$556b686fea6fb229);
    $parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", ()=>$03dd5f7faa501890$export$638ac52227e67c8);
    const $03dd5f7faa501890$export$2294cfc7730248df = 4;
    const $03dd5f7faa501890$export$961a1d6da881600c = 3;
    const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
    const $03dd5f7faa501890$export$9ad20e435294162a = 1;
    const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
    const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
    const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
    const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
    const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
    const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
    const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
    const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return true;
        return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
    };
    const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
    };
    const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
    };
    const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
    const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
        if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
});
parcelRegister("4cS2K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a2a115a4d046ac6$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getProjectAvatarUrl", ()=>$9a2a115a4d046ac6$export$65a50dd1fe88e116);
    $parcel$export(module.exports, "normaliseSavedAvatar", ()=>$9a2a115a4d046ac6$export$b11f6166803b3fff);
    var $9a2a115a4d046ac6$export$2e2bcd8739ae039 = (rawAvatars)=>rawAvatars.system.concat(rawAvatars.custom).map((raw)=>({
                id: Number(raw.id),
                uri: raw.urls['48x48'],
                fileName: raw.fileName
            }));
    const $9a2a115a4d046ac6$export$65a50dd1fe88e116 = (avatarId)=>`/secure/viewavatar?avatarId=${avatarId}&avatarType=issuetype`;
    const $9a2a115a4d046ac6$export$b11f6166803b3fff = (avatar)=>({
            id: parseInt(avatar.id, 10),
            uri: $9a2a115a4d046ac6$export$65a50dd1fe88e116(parseInt(avatar.id, 10)),
            fileName: avatar.fileName
        });
});
parcelRegister("afIXj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b52c5d7d436e6cd4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b52c5d7d436e6cd4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types",
            "defaultMessage": "Issue types"
        },
        addIssueType: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type",
            "defaultMessage": "Add issue type"
        }
    });
});
parcelRegister("17zko", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$333939f1c0a6953d$export$defe85febe8b728c);
    var $7VHMR;
    const $333939f1c0a6953d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.title",
            "defaultMessage": "Project settings"
        },
        itemDetails: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-details",
            "defaultMessage": "Details"
        },
        itemAccess: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-access",
            "defaultMessage": "Access"
        },
        itemFieldsNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-fields-non-final",
            "defaultMessage": "Fields"
        },
        itemIssueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types",
            "defaultMessage": "Issue types"
        },
        itemAdvancedForms: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-advanced-forms",
            "defaultMessage": "Advanced Forms"
        },
        newLozenge: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.new-lozenge",
            "defaultMessage": "New"
        },
        automation: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.automation",
            "defaultMessage": "Automation"
        },
        itemNotifications: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-notifications",
            "defaultMessage": "Notifications"
        },
        itemApprovals: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-approvals",
            "defaultMessage": "Approvals"
        },
        dataClassificationNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.data-classification-non-final",
            "defaultMessage": "Data classification"
        }
    });
});
parcelRegister("4rn3K", function(module, exports) {
    $parcel$export(module.exports, "useThrowSettingFeatures", ()=>$d5d4618f8b440044$export$154ecbb867fd48f0);
    $parcel$export(module.exports, "Settings", ()=>$d5d4618f8b440044$export$c72f6eaae7b9adff);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $gOS29;
    var $2vSU6;
    var $65Ltd;
    var $co1wz;
    var $k2DRb;
    var $koVbs;
    var $2MtwW;
    var $xc3fY;
    var $2Uv55;
    var $k0ZZ2;
    var $2gP8z;
    var $3OGaE;
    var $lpwtK;
    var $71bFU;
    var $7OqB4;
    var $4OCke;
    var $5xslo;
    var $eOlBz;
    var $g5X3G;
    var $6EZeH;
    var $bkw8F;
    var $69lKq;
    const $d5d4618f8b440044$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $d5d4618f8b440044$export$154ecbb867fd48f0 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useSettingFeatures));
    const $d5d4618f8b440044$export$17eaab3b8c213998 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("eOlBz")).useNewIssueViewLockedInStatus));
    const $d5d4618f8b440044$var$DisplayNotificationsOptions = ({ hasNotifications: hasNotifications, formatMessage: formatMessage, project: project })=>{
        if (!hasNotifications) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'notifications'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("69lKq")).default).notifications),
            forceExpand: true,
            submenuId: "core-notifications-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71bFU")).NotificationsSubMenu), {
            settingsUrl: `/plugins/servlet/project-config/${project.key}/notifications`,
            issueLogsUrl: `/jira/core/projects/${project.key}/settings/notifications/issue-logs?projectId=${project.id}`
        }));
    };
    const $d5d4618f8b440044$var$IssueLayoutOption = ({ isNewIssueViewLockedIn: isNewIssueViewLockedIn, hasIssueLayout: hasIssueLayout, formatMessage: formatMessage, project: project })=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) return hasIssueLayout && isNewIssueViewLockedIn && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-layout'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuelayout`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueLayout));
        return isNewIssueViewLockedIn && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-layout'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuelayout`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueLayout));
    };
    const $d5d4618f8b440044$export$c72f6eaae7b9adff = ({ ecosystemItems: ecosystemItems })=>{
        const { data: features } = $d5d4618f8b440044$export$154ecbb867fd48f0();
        const { data: status } = $d5d4618f8b440044$export$17eaab3b8c213998();
        const isNewIssueViewLockedIn = status?.newIssueViewTransitionLockingStatus !== (0, (0, parcelRequire("eOlBz")).DEFAULT_TO_OLD_ISSUE_VIEW);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project } = $d5d4618f8b440044$export$a4007dc4843ca7f6();
        const hasDlpEnabled = (0, (0, parcelRequire("6EZeH")).useDlpEntitlement)();
        if (features == null || project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("69lKq")).default).projectSettings)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, features.hasDetails && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'details'
            },
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS)
            ],
            href: `/jira/core/projects/${project.key}/settings/details`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).details)), features.hasPeople && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'people'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/people`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).people)), features.hasAutomation && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2gP8z")).SpotlightTarget), {
            name: "spotlight-sidebar-project-automation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: (0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)({
                isSimplified: project.isSimplified,
                projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(project.key),
                projectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            })
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).automation))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2MtwW")).EngagementSpotlight), {
            engagementId: "spotlight-sidebar-project-automation"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Uv55")).FireUiAnalytics), {
            actionSubject: "automationNavigationItem",
            action: "viewed"
        })), features.hasSummary && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'summary'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/summary`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).summary))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasIssueConfigSection || isNewIssueViewLockedIn || (0, (0, parcelRequire("co1wz")).ff)('proforma-mvp-jwm-project-settings_5edja')
        }, features.hasIssueTypes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-types'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuetypes`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueTypes)), (0, ($parcel$interopDefault($5uXOq))).createElement($d5d4618f8b440044$var$IssueLayoutOption, {
            isNewIssueViewLockedIn: isNewIssueViewLockedIn,
            hasIssueLayout: features.hasIssueLayout,
            formatMessage: formatMessage,
            project: project
        }), (0, (0, parcelRequire("co1wz")).ff)('proforma-mvp-jwm-project-settings_5edja') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'proforma-forms'
            },
            href: `/jira/core/projects/${project.key}/settings/forms`,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS)
            ]
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).forms))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasProjectGroupTwoSection
        }, features.hasWorkflows && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'workflows'
            },
            href: `/plugins/servlet/project-config/${project.key}/workflows`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).workflows)), features.hasScreens && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'screens'
            },
            href: `/plugins/servlet/project-config/${project.key}/screens`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).screens)), features.hasSystemFieldsConfiguration && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'fields'
            },
            href: `/plugins/servlet/project-config/${project.key}/fields`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).fields))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasProjectGroupThreeSection
        }, features.hasVersions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS)
            ],
            analytics: {
                itemId: 'versions'
            },
            href: `/plugins/servlet/project-config/${project.key}/administer-versions`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).versions)), features.hasComponents && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS)
            ],
            analytics: {
                itemId: 'components'
            },
            href: `/plugins/servlet/project-config/${project.key}/administer-components`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).components))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasProjectGroupFourSection
        }, features.hasPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'permissions'
            },
            href: `/plugins/servlet/project-config/${project.key}/permissions`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).permissions)), features.hasIssueSecurity && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-security'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuesecurity`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueSecurity)), (0, ($parcel$interopDefault($5uXOq))).createElement($d5d4618f8b440044$var$DisplayNotificationsOptions, {
            hasNotifications: features.hasNotifications,
            formatMessage: formatMessage,
            project: project
        }), features.hasDevtools && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'devtools'
            },
            href: `/secure/ConfigureDevStatus.jspa?projectKey=${project.key}`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).devtools))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasgetIssueCollectorSection
        }, features.hasIssueCollectors && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS)
            ],
            analytics: {
                itemId: 'issue-collectors'
            },
            href: `/secure/ViewCollectors!default.jspa?projectKey=${project.key}`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueCollectors))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5xslo")).default), {
            hasSeparator: true,
            items: ecosystemItems,
            forgeModule: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            overrides: {
                BackMenuItem: {
                    href: `/plugins/servlet/project-config/${project.key}`,
                    title: formatMessage((0, (0, parcelRequire("69lKq")).default).itemBack)
                }
            }
        }), hasDlpEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'data-classifications'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/data-classifications`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).dataClassificationsNonFinal))));
    };
});
parcelRegister("gOS29", function(module, exports) {
    $parcel$export(module.exports, "getBaseAutomationUrl", ()=>$b61a7afc01657dc2$export$8e479e490e1e69bc);
    const $b61a7afc01657dc2$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
        if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    };
});
parcelRegister("2MtwW", function(module, exports) {
    $parcel$export(module.exports, "EngagementSpotlight", ()=>$0e9acf1f50def63d$export$f14689466e4eca7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZ4fr;
    var $6OJ73;
    var $axUP7;
    const $0e9acf1f50def63d$export$f14689466e4eca7a = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)(({ engagementId: engagementId })=>{
        const isFullyExpanded = (0, (0, parcelRequire("6OJ73")).useIsFullyExpanded)();
        return isFullyExpanded && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            engagementId: engagementId
        });
    });
});
parcelRegister("2Uv55", function(module, exports) {
    $parcel$export(module.exports, "FireUiAnalytics", ()=>$c81bbbeeb609506c$export$5a67e7291fd4569e);
    var $5oFIy;
    var $axUP7;
    const $c81bbbeeb609506c$export$5a67e7291fd4569e = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)((0, (0, parcelRequire("5oFIy")).FireUiAnalytics));
});
parcelRegister("2gP8z", function(module, exports) {
    $parcel$export(module.exports, "SpotlightTarget", ()=>$bac5b90628bba66f$export$e29577842f211e22);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $axUP7;
    const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-test-id": `ak-spotlight-target-${props.name}`
        }, children));
    const $bac5b90628bba66f$export$e29577842f211e22 = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);
});
parcelRegister("5xslo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f574dcd99762a8d6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1rTGO;
    var $hBuqR;
    var $au6nA;
    var $fh2pW;
    var $k51JQ;
    const $f574dcd99762a8d6$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
        const forgeItems = (0, $5uXOq.useMemo)(()=>items.forge || [], [
            items.forge
        ]);
        const connectItems = (0, (0, parcelRequire("au6nA")).useFilteredItems)(items.connect, shouldFilter);
        const sortedItems = (0, $5uXOq.useMemo)(()=>[
                ...forgeItems.map((item)=>({
                        type: 'forge',
                        item: item
                    })),
                ...connectItems.map((item)=>({
                        type: 'connect',
                        item: item
                    }))
            ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
            connectItems,
            forgeItems
        ]);
        if (!sortedItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
            if (type === 'forge') {
                const forgeItem = item;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                    key: forgeItem.id,
                    ...forgeItem,
                    overrides: overrides,
                    showIcon: showIcons,
                    nestedMenuActive: nestedMenuActive
                });
            }
            const connectItem = item;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fh2pW")).ConnectItem), {
                item: connectItem,
                key: connectItem.id,
                index: index,
                overrides: overrides,
                showIcons: showIcons,
                submenuId: submenuId
            });
        }), forgeItems.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), null) : null);
    };
    var $f574dcd99762a8d6$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: forgeModule,
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f574dcd99762a8d6$export$66569e9b4a285b16, restProps));
});
parcelRegister("69lKq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40a05b6299fc545f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $40a05b6299fc545f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectSettings: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.project-settings",
            "defaultMessage": "Project settings"
        },
        details: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.details",
            "defaultMessage": "Details"
        },
        people: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.people",
            "defaultMessage": "People"
        },
        summary: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.summary",
            "defaultMessage": "Summary"
        },
        deleteProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.delete-project",
            "defaultMessage": "Delete project"
        },
        issueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types",
            "defaultMessage": "Issue types"
        },
        issueLayout: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout",
            "defaultMessage": "Issue layout"
        },
        workflows: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.workflows",
            "defaultMessage": "Workflows"
        },
        screens: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.screens",
            "defaultMessage": "Screens"
        },
        fields: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.fields",
            "defaultMessage": "Fields"
        },
        versions: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.versions",
            "defaultMessage": "Versions"
        },
        components: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.components",
            "defaultMessage": "Components"
        },
        permissions: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.permissions",
            "defaultMessage": "Permissions"
        },
        issueSecurity: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security",
            "defaultMessage": "Issue security"
        },
        notifications: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications",
            "defaultMessage": "Notifications"
        },
        notificationsEmail: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications-email",
            "defaultMessage": "Notification email"
        },
        hipChat: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.hip-chat",
            "defaultMessage": "HipChat integration"
        },
        issueCollectors: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors",
            "defaultMessage": "Issue collectors"
        },
        new: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.new",
            "defaultMessage": "New"
        },
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.item-back",
            "defaultMessage": "Back to project settings"
        },
        automation: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.automation",
            "defaultMessage": "Automation"
        },
        devtools: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.devtools",
            "defaultMessage": "Development tools"
        },
        forms: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.forms",
            "defaultMessage": "Advanced Forms"
        },
        dataClassificationsNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.data-classifications-non-final",
            "defaultMessage": "Data classification"
        }
    });
});
parcelRegister("1tFZj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdfaa99512e485c7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bdfaa99512e485c7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        favorites: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.favorites",
            "defaultMessage": "Starred"
        },
        recents: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.recents",
            "defaultMessage": "Recent"
        },
        expandSection: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.expand-section",
            "defaultMessage": "Expand {section} projects"
        },
        collapseSection: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.collapse-section",
            "defaultMessage": "Collapse {section} projects"
        }
    });
});
parcelRegister("cUsQ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$898e57801e4e297c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $jzhSN;
    var $dPLwL;
    const $898e57801e4e297c$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';
    const $898e57801e4e297c$var$ViewAllProjects = ({ label: label })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            href: "/jira/projects?selectedProjectType=business",
            testId: $898e57801e4e297c$var$TEST_ID,
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $898e57801e4e297c$var$textStyle
        }, label ?? formatMessage((0, (0, parcelRequire("dPLwL")).messages).viewAllProjectsLabel)));
    };
    var $898e57801e4e297c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($898e57801e4e297c$var$ViewAllProjects);
    const $898e57801e4e297c$var$textStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: "var(--ds-font-weight-regular, 400)"
    });
});
parcelRegister("dPLwL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2a9ab6de28c59d3b$export$defe85febe8b728c);
    var $7VHMR;
    const $2a9ab6de28c59d3b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllProjectsLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.view-all-projects.view-all-projects-label",
            "defaultMessage": "View all projects"
        }
    });
});
parcelRegister("k5gug", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a74810dab45a4db8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $bKCrm;
    var $aFVvc;
    var $iuAuR;
    var $ekH8d;
    var $dcvwL;
    const $a74810dab45a4db8$var$ProjectsHeader = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: data } = (0, (0, parcelRequire("aFVvc")).useProjectCreatePermissionsResource)();
        const canCreateProject = Boolean(data?.canCreateProject);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("ekH8d")).messages).projectsHeader)
        }, canCreateProject && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dcvwL")).default), {
                openProjectCreateDrawer: open
            })));
    };
    var $a74810dab45a4db8$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a74810dab45a4db8$var$ProjectsHeader);
});
parcelRegister("bKCrm", function(module, exports) {
    $parcel$export(module.exports, "ProjectCreateDrawerProvider", ()=>$645a52f2fa143509$export$9a1c5dbd93c42bca);
    $parcel$export(module.exports, "ProjectCreateDrawerConsumer", ()=>$645a52f2fa143509$export$9a8662cd60931de1);
    $parcel$export(module.exports, "useProjectCreateDrawer", ()=>$645a52f2fa143509$export$8172ff4ed0f75a1e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $58GFP;
    var $8YEE2;
    var $dIdda = parcelRequire("dIdda");
    var $gL2cg;
    const $645a52f2fa143509$var$Context = (0, $5uXOq.createContext)({
        data: {
            shouldRenderDrawer: false,
            isOpen: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined
        },
        methods: {
            open: (0, ($parcel$interopDefault($8Rkzz))),
            close: (0, ($parcel$interopDefault($8Rkzz))),
            onSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onCreateStarted: (0, ($parcel$interopDefault($8Rkzz))),
            setOnCloseCallback: (0, ($parcel$interopDefault($8Rkzz))),
            clearOnCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
        }
    });
    const $645a52f2fa143509$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $5uXOq.Component) {
        render() {
            const { children: children } = this.props;
            const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$var$Context.Provider, {
                value: {
                    data: {
                        isOpen: isOpen,
                        isNextGen: isNextGen,
                        source: source,
                        showExperienceSelection: showExperienceSelection,
                        shouldRenderDrawer: shouldRenderDrawer,
                        recommendedTemplate: recommendedTemplate,
                        defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                        isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                        isImportProjectOpenInitially: isImportProjectOpenInitially,
                        selectedProjectType: selectedProjectType,
                        recommendationSessionId: recommendationSessionId
                    },
                    methods: {
                        open: this.open,
                        close: this.close,
                        onSuccess: this.onSuccess,
                        onCreateStarted: this.onCreateStarted,
                        setOnCloseCallback: this.setOnCloseCallback,
                        clearOnCloseCallback: this.clearOnCloseCallback
                    }
                }
            }, children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                isOpen: false,
                shouldRenderDrawer: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined,
                onCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
            };
            this.onSuccess = (projectKey)=>{
                if (projectKey) {
                    this.props.setLocation(projectKey.returnUrl);
                    this.close(true);
                } else this.close(false);
            };
            this.setOnCloseCallback = (callback)=>{
                this.setState({
                    onCloseCallback: callback
                });
            };
            this.clearOnCloseCallback = ()=>{
                this.setState({
                    onCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
                });
            };
            this.open = (attributes = {})=>{
                this.setState({
                    isOpen: true,
                    shouldRenderDrawer: true,
                    ...attributes
                });
            };
            this.close = (projectCreated)=>{
                const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    isImportProjectOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                if (callOnCloseCallBack) this.state.onCloseCallback();
            };
            this.closeOld = ()=>{
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                this.state.onCloseCallback();
            };
            this.onCreateStarted = (projectKey, templateKey)=>{
                if ((0, (0, parcelRequire("58GFP")).getIsJsmBlankProjectTemplate)(templateKey)) (0, (0, parcelRequire("8YEE2")).LazyComponent).preload();
                (0, (0, parcelRequire("gL2cg")).clearResourcesAssociatedWithProjectKey)(projectKey);
            };
        }
    };
    const $645a52f2fa143509$export$9a1c5dbd93c42bca = (props)=>{
        const { push: push } = (0, $dIdda.useRouterActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$export$839a70d8fbc9d356, {
            ...props,
            setLocation: push
        });
    };
    const { Consumer: $645a52f2fa143509$export$9a8662cd60931de1 } = $645a52f2fa143509$var$Context;
    $645a52f2fa143509$var$Context.displayName = 'ProjectCreateDrawerConsumer';
    const $645a52f2fa143509$export$8172ff4ed0f75a1e = ()=>{
        const projectCreateDrawer = (0, $5uXOq.useContext)($645a52f2fa143509$var$Context);
        if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
        return projectCreateDrawer;
    };
});
parcelRegister("8YEE2", function(module, exports) {
    $parcel$export(module.exports, "LazyComponent", ()=>$300188a98a9fded7$export$31f1740ae531af94);
    $parcel$export(module.exports, "AsyncProjectBuilderDrawer", ()=>$300188a98a9fded7$export$54a4eade9eae9473);
    $parcel$export(module.exports, "canUseProjectBuilder", ()=>$300188a98a9fded7$export$ff317c5d87147a19);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $9noxX;
    var $kxZPA;
    const $300188a98a9fded7$export$31f1740ae531af94 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("ikHTf")), {
        ssr: false,
        moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
    });
    const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "bundle-async-project-builder",
            packageName: "jira-servicedesk-project-builder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: null,
            name: "jsm-project-builder"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
            isOpenInitial: !!props.isOpenInitial,
            ...props
        }))));
    const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;
});
parcelRegister("9noxX", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskAnalyticsContext", ()=>$12b9024f66e7ef57$export$ac31f8f3368d6881);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $4DPZY;
    var $8H3A4;
    const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
        const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
        const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
        if ((0, $5uXOq.Children).count(children) > 0) {
            const loading = containerContextLoading || analyticsContextLoading;
            const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
            if (!shouldRenderChildren) return null;
            const context = {};
            if (containerContextData && containerContextData.project) {
                const { id: id, type: type } = containerContextData.project;
                context.containerType = 'project';
                context.containerId = `${id}`;
                context.containers = {
                    project: {
                        id: `${id}`,
                        type: type
                    }
                };
                if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), context, children);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    $12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
        forceRenderWhileLoading: false,
        useServiceDeskAnalyticsContext: (0, (0, parcelRequire("8H3A4")).useServiceDeskAnalyticsContext),
        useContainerContext: (0, (0, parcelRequire("4DPZY")).useContainerContext)
    };
});
parcelRegister("ikHTf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("kWrFZ"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c8LNs")
    ]).then(()=>parcelRequire('c9lEE'));
});
parcelRegister("gL2cg", function(module, exports) {
    $parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", ()=>$e1d0138bae1db723$export$c0c81c1828c7638c);
    var $jcw0u;
    var $dIdda = parcelRequire("dIdda");
    const $e1d0138bae1db723$export$c0c81c1828c7638c = (projectKey)=>{
        try {
            const { storeState: storeState } = (0, $dIdda.getResourceStore)();
            const prevState = storeState.getState();
            storeState.setState({
                ...prevState,
                data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                    const { [projectKey]: _, ...rest } = value;
                    return [
                        resourceType,
                        rest
                    ];
                }))
            });
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'clearResourcesAssociatedWithProjectKey',
                    packageName: 'jiraProjectCreateDrawerContext',
                    teamName: 'helix'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
            });
        }
    };
});
parcelRegister("ekH8d", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$de5b805401f88067$export$defe85febe8b728c);
    var $7VHMR;
    const $de5b805401f88067$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsHeader: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.projects-header",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("dcvwL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38d1fe81a75f8a8e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $5jbF3;
    var $hJE3l;
    const $38d1fe81a75f8a8e$export$ef99f99721eacc0f = (0, (0, parcelRequire("kxZPA")).lazy)(()=>Promise.resolve((parcelRequire("hJE3l"))), {
        ssr: false,
        moduleId: "./src/packages/business/navigation/sidebar/src/ui/multi-project-menu/projects-header/one-click-project/template-picker/index.tsx"
    });
    const $38d1fe81a75f8a8e$var$OneClickProject = ({ openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const renderContent = (0, $5uXOq.useCallback)((data, loading)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "sidebar-template-picker",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJE3l")).TemplatePickerFallback), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($38d1fe81a75f8a8e$export$ef99f99721eacc0f, {
                data: data,
                loading: loading,
                openProjectCreateDrawer: openProjectCreateDrawer
            })), [
            openProjectCreateDrawer
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5jbF3")).default), {
            renderContent: renderContent,
            openProjectCreateDrawer: openProjectCreateDrawer
        });
    };
    var $38d1fe81a75f8a8e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($38d1fe81a75f8a8e$var$OneClickProject);
});
parcelRegister("5jbF3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c00fe391b3045d6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $172CC;
    var $gPQRI;
    var $gb5lQ;
    var $3BbwT;
    var $8MKpg;
    const $5c00fe391b3045d6$var$OneClickProjectButton = ({ renderContent: renderContent, openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { data: data, loading: loading, error: error, fetch: fetchJwmTemplates } = (0, (0, parcelRequire("3BbwT")).useProjectTemplates)();
        const { isCollapsed: isLeftSidebarCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const { templates: templates, recommendationSessionId: recommendationSessionId } = data;
        const wasFetched = templates != null || loading || error != null;
        const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && !wasFetched) fetchJwmTemplates();
        }, [
            isOpen,
            wasFetched,
            fetchJwmTemplates
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isLeftSidebarCollapsed && isOpen) onClose();
        }, [
            isLeftSidebarCollapsed,
            isOpen,
            onClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error && isOpen) {
                openProjectCreateDrawer((0, (0, parcelRequire("172CC")).getJwmCreateProjectDrawerOptions)((0, (0, parcelRequire("gb5lQ")).LOCATION), recommendationSessionId));
                setIsOpen(false);
            }
        }, [
            error,
            isOpen,
            openProjectCreateDrawer,
            recommendationSessionId
        ]);
        const content = (0, $5uXOq.useCallback)(()=>renderContent(data, loading), [
            renderContent,
            data,
            loading
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8MKpg")).default), {
                onClick: ()=>setIsOpen(!isOpen)
            })), [
            isOpen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            placement: "right-start",
            onClose: onClose,
            content: content,
            trigger: trigger
        });
    };
    var $5c00fe391b3045d6$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5c00fe391b3045d6$var$OneClickProjectButton);
});
parcelRegister("172CC", function(module, exports) {
    $parcel$export(module.exports, "getJwmCreateProjectDrawerOptions", ()=>$30b27d3ea79ff2d5$export$c1785414279ee192);
    var $2vSU6;
    const $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED = 'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed';
    const $30b27d3ea79ff2d5$export$c1785414279ee192 = (source, recommendationSessionId)=>({
            isNextGen: true,
            selectedProjectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT),
            showExperienceSelection: false,
            defaultSelectedTemplateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
            recommendedTemplate: {
                templateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
                isSimplified: false
            },
            source: source,
            recommendationSessionId: recommendationSessionId
        });
});
parcelRegister("3BbwT", function(module, exports) {
    $parcel$export(module.exports, "useProjectTemplates", ()=>$f58c037e2d918746$export$45e810e42086790f);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $7f4tk;
    var $gb5lQ;
    var $annwf;
    const $f58c037e2d918746$var$initialState = {
        data: {
            templates: null
        },
        loading: false,
        error: null
    };
    const $f58c037e2d918746$export$45e810e42086790f = ()=>{
        const [{ loading: loading, data: data, error: error }, setState] = (0, $5uXOq.useState)($f58c037e2d918746$var$initialState);
        const fetch = (0, $5uXOq.useCallback)(async ()=>{
            setState({
                data: {
                    templates: null
                },
                loading: true,
                error: null
            });
            try {
                const url = (0, (0, parcelRequire("4R6GH")).fg)('grw-529_srtpmfy_experiment_kill_switch') ? '/rest/simplified/2.0/project-templates?recommendations&templateGallery' : '/rest/simplified/2.0/project-templates?recommendations';
                const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
                const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
                const jwmTemplates = shouldUseNewRecommendations ? (0, (0, parcelRequire("annwf")).getFilteredTemplatesNew)(response) : (0, (0, parcelRequire("annwf")).getFilteredTemplates)(response);
                setState({
                    data: {
                        templates: jwmTemplates,
                        recommendationSessionId: response.recommendationSessionId
                    },
                    loading: false,
                    error: null
                });
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useProjectTemplates',
                        packageName: (0, (0, parcelRequire("gb5lQ")).PACKAGE_NAME),
                        teamName: 'jira-warepil'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    data: {
                        templates: null
                    },
                    loading: false,
                    error: err
                });
            }
        }, []);
        return {
            data: data,
            loading: loading,
            error: error,
            fetch: fetch
        };
    };
});
parcelRegister("annwf", function(module, exports) {
    $parcel$export(module.exports, "getFilteredTemplates", ()=>$1ee17a992e26086f$export$e9643d22c03c3a30);
    $parcel$export(module.exports, "getFilteredTemplatesNew", ()=>$1ee17a992e26086f$export$126495c59883efa);
    const $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY = 4;
    const $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY_NEW = 5;
    const $1ee17a992e26086f$var$MADE_FOR_YOU_CATEGORY = 'made-for-you-category';
    const $1ee17a992e26086f$var$TEMPLATE_KEYS = new Set([
        'jwm.blank-project',
        'jwm.project-management',
        'jwm.personal-task-planner',
        'jwm.task-tracking'
    ]);
    const $1ee17a992e26086f$export$e9643d22c03c3a30 = (response)=>{
        const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey } = response;
        const lastUsedTemplates = [];
        const recommendedTemplates = [];
        const additionalTemplates = [];
        templates.forEach((template)=>{
            const { projectTypeTemplates: projectTypeTemplates, key: key, categoryTypes: categoryTypes } = template;
            if (lastUsedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey)) lastUsedTemplates.push({
                ...template,
                isLastUsed: true
            });
            else if (recommendedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey || categoryTypes.includes($1ee17a992e26086f$var$MADE_FOR_YOU_CATEGORY))) recommendedTemplates.push({
                ...template,
                isRecommended: true
            });
            else if ($1ee17a992e26086f$var$TEMPLATE_KEYS.has(key)) additionalTemplates.push(template);
        });
        const filteredTemplates = [
            ...lastUsedTemplates,
            ...recommendedTemplates,
            ...additionalTemplates
        ].slice(0, $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY);
        return filteredTemplates;
    };
    const $1ee17a992e26086f$export$126495c59883efa = (response)=>{
        const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey, recommendedTemplates: recommendedTemplateKeys } = response;
        const lastUsedTemplates = [];
        const recommendedTemplates = [];
        const additionalTemplates = [];
        recommendedTemplateKeys?.forEach((key, index)=>{
            const template = templates.find((t)=>t.key === key);
            if (template) {
                const { projectTypeTemplates: projectTypeTemplates } = template;
                if (index === 0 && lastUsedTemplateKey) {
                    const isLastUsed = lastUsedTemplateKey && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey);
                    lastUsedTemplates.push({
                        ...template,
                        ...isLastUsed && {
                            isLastUsed: isLastUsed
                        }
                    });
                    return;
                }
                const isRecommended = recommendedTemplateKey && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey);
                recommendedTemplates.push({
                    ...template,
                    ...isRecommended && {
                        isRecommended: isRecommended
                    }
                });
            }
        });
        if (lastUsedTemplates.length + recommendedTemplates.length < $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY) {
            const placeholderTemplateKeys = Array.from($1ee17a992e26086f$var$TEMPLATE_KEYS).filter((key)=>!lastUsedTemplates.some((t)=>t.key === key) && !recommendedTemplates.some((t)=>t.key === key));
            templates.forEach((template)=>{
                if (placeholderTemplateKeys.includes(template.key)) additionalTemplates.push(template);
            });
        }
        const filteredTemplates = [
            ...lastUsedTemplates,
            ...recommendedTemplates,
            ...additionalTemplates
        ].slice(0, $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY_NEW);
        return filteredTemplates;
    };
});
parcelRegister("8MKpg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f7880bbb09ab94b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $8zOmE;
    var $gb5lQ;
    var $3MXKI;
    var $acCqn;
    const $1f7880bbb09ab94b$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.create-project-button';
    const $1f7880bbb09ab94b$var$CreateProjectButton = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
            label: formatMessage((0, (0, parcelRequire("acCqn")).default).createProjectLabel),
            testId: $1f7880bbb09ab94b$var$TEST_ID,
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, (0, parcelRequire("gb5lQ")).LOCATION));
                onClick();
            }
        });
    };
    var $1f7880bbb09ab94b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1f7880bbb09ab94b$var$CreateProjectButton);
});
parcelRegister("acCqn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f0808b9a7f055d1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9f0808b9a7f055d1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createProjectLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.create-project-button.create-project-label",
            "defaultMessage": "Create project"
        }
    });
});
parcelRegister("hJE3l", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "TemplatePickerFallback", ()=>$47229cd857e246da$export$675ac63e0637d34d);
    $parcel$export(module.exports, "default", ()=>$47229cd857e246da$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lj8SI;
    var $kJpBP;
    var $h5xhD;
    var $9UCCQ;
    var $eZJjh;
    var $aIZdc;
    var $6s1PB;
    var $co1wz;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $itmJb;
    var $cNd4s;
    var $gb5lQ;
    var $2H5YM;
    const $47229cd857e246da$var$POPUP_WIDTH = 272;
    const $47229cd857e246da$export$675ac63e0637d34d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium"
        }));
    const $47229cd857e246da$var$TemplatePicker = ({ data: { templates: templates, recommendationSessionId: recommendationSessionId }, loading: loading, openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
        const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
        const handleTemplateClick = (0, $5uXOq.useCallback)((projectTypeTemplates, isLastUsed, isRecommended, templateType)=>()=>{
                openProjectCreateDrawer({
                    isNextGen: true,
                    selectedProjectType: 'business',
                    showExperienceSelection: false,
                    defaultSelectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                    source: (0, (0, parcelRequire("gb5lQ")).LOCATION),
                    ...shouldUseNewRecommendations && {
                        recommendationSessionId: recommendationSessionId
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateTemplate', {
                    selectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                    isLastUsed: isLastUsed,
                    isRecommended: isRecommended,
                    templateType: templateType,
                    recommendationSessionId: recommendationSessionId
                });
            }, [
            createAnalyticsEvent,
            openProjectCreateDrawer,
            recommendationSessionId,
            shouldUseNewRecommendations
        ]);
        const handleMoreTemplatesClick = (0, $5uXOq.useCallback)(()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                showExperienceSelection: false,
                source: (0, (0, parcelRequire("gb5lQ")).LOCATION)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateMoreTemplates');
        }, [
            createAnalyticsEvent,
            openProjectCreateDrawer
        ]);
        const handleImportButtonClick = (0, $5uXOq.useCallback)(()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                showExperienceSelection: false,
                source: (0, (0, parcelRequire("gb5lQ")).LOCATION),
                isImportProjectOpenInitially: true
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateImport');
        }, [
            createAnalyticsEvent,
            openProjectCreateDrawer
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h5xhD")).default), {
            minWidth: $47229cd857e246da$var$POPUP_WIDTH,
            testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.popup-menu-group"
        }, loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$export$675ac63e0637d34d, null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            title: formatMessage((0, (0, parcelRequire("2H5YM")).default).sectionTitle)
        }, Array.isArray(templates) && templates.map(({ iconUrl: iconUrl, key: key, projectTypeTemplates: projectTypeTemplates, title: title, isLastUsed: isLastUsed = false, isRecommended: isRecommended = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.button-item",
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$StyledImage, {
                    src: iconUrl,
                    alt: `${title.label} icon`
                }),
                key: key,
                onClick: handleTemplateClick(projectTypeTemplates, isLastUsed, isRecommended, key)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$ButtonText, null, title.label), isLastUsed && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, formatMessage((0, (0, parcelRequire("2H5YM")).default).lastCreated))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button",
            onClick: handleMoreTemplatesClick
        }, formatMessage((0, (0, parcelRequire("2H5YM")).default).moreTemplatesButtonText)), (isSiteAdmin || isAdmin && (0, (0, parcelRequire("co1wz")).ff)('enable-product-admin-for-x2c-migration_zmlsv') || !isAdmin) && !(0, (0, parcelRequire("aIZdc")).isFedRamp)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.import-button",
            onClick: handleImportButtonClick
        }, formatMessage((0, (0, parcelRequire("2H5YM")).default).importButtonText)))));
    };
    var $47229cd857e246da$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($47229cd857e246da$var$TemplatePicker);
    const $47229cd857e246da$var$StyledImage = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsbzwfg _5ral1dfr",
                __cmplp.className
            ])
        });
    });
    const $47229cd857e246da$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbclpc _1e0c1txw _4cvr1h6o _1bah1h6o _1yt4zu5n",
                __cmplp.className
            ])
        });
    });
    const $47229cd857e246da$var$ButtonText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxutpp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h5xhD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92a58bdbbfac4ce9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eZUJu;
    const $92a58bdbbfac4ce9$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZUJu")).default), {
            maxWidth: maxWidth,
            minWidth: minWidth,
            ...rest
        });
    var $92a58bdbbfac4ce9$export$2e2bcd8739ae039 = $92a58bdbbfac4ce9$var$PopupMenuGroup;
});
parcelRegister("2H5YM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ad55b7f9c6c06ab$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6ad55b7f9c6c06ab$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sectionTitle: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.section-title",
            "defaultMessage": "Start a new project"
        },
        moreTemplatesButtonText: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button-text",
            "defaultMessage": "More templates"
        },
        importButtonText: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.import-button-text",
            "defaultMessage": "Import"
        },
        lastCreated: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.last-created",
            "defaultMessage": "Last created"
        }
    });
});
parcelRegister("e7C7O", function(module, exports) {
    $parcel$export(module.exports, "fieldSettingsRelayResource", ()=>$424e18beff0a1aec$export$68b4e700e00bad7a);
    var $ao2h1;
    var $gF6UW;
    var $1nb22;
    const $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
    const $424e18beff0a1aec$export$68b4e700e00bad7a = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return {
                parameters: (0, (0, parcelRequire("gF6UW")).default),
                variables: {
                    projectKey: projectKey ?? '',
                    cloudId: tenantContext.cloudId ?? ''
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            };
        }
    });
});
parcelRegister("gF6UW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e41b4fca86430f4d$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $e41b4fca86430f4d$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v2 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v3 = [
            v2,
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ], v4 = [
            v2,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "isExplicitFieldAssociationsEnabled"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v8 = {
            "kind": "ScalarField",
            "name": "issueTypeId"
        }, v9 = {
            "kind": "ScalarField",
            "name": "id"
        }, v10 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 30
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "uiFieldsPageQuery",
                "selections": [
                    {
                        "args": v3,
                        "kind": "FragmentSpread",
                        "name": "fieldsTable_projectFields"
                    },
                    {
                        "args": v3,
                        "kind": "FragmentSpread",
                        "name": "pageHeader_projectFields_Header"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v5
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "uiFieldsPageQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v6,
                                    v7,
                                    {
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v6,
                                                            v7,
                                                            v9
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectId"
                                    },
                                    {
                                        "concreteType": "JiraProjectWithIssueTypeIds",
                                        "kind": "LinkedField",
                                        "name": "projectWithVisibleIssueTypeIds",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v10,
                                                "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldAssociationWithIssueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraField",
                                                                        "kind": "LinkedField",
                                                                        "name": "field",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "fieldId"
                                                                            },
                                                                            v9,
                                                                            v6,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "scope"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeKey"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeName"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "description"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraIssueTypeConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueTypeEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueType",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v6,
                                                                                            v7,
                                                                                            v9,
                                                                                            v8
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v9,
                                                                    {
                                                                        "concreteType": "JiraFieldOperation",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldOperation",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "canRemove"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "canAssociateInSettings"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__typename"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "cursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasNextPage"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "endCursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                            },
                                            {
                                                "args": v10,
                                                "handle": "connection",
                                                "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                                "kind": "LinkedHandle",
                                                "name": "fieldAssociationWithIssueTypes"
                                            }
                                        ]
                                    },
                                    v9,
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "31816b85a02e829f10efc97bdf585dcc27b5df92d9423ab67e54ec85079b9006",
                "metadata": {},
                "name": "uiFieldsPageQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e41b4fca86430f4d$var$node.hash = "72c7746a41a19b203b9890c0bf92671f";
    (0, $eiowN.PreloadableQueryRegistry).set($e41b4fca86430f4d$var$node.params.id, $e41b4fca86430f4d$var$node);
    var $e41b4fca86430f4d$export$2e2bcd8739ae039 = $e41b4fca86430f4d$var$node;
});
parcelRegister("d0oNj", function(module, exports) {
    $parcel$export(module.exports, "ProjectSettingsAccessSkeleton", ()=>$0aa0180a4506ead8$export$e6cc5ccd52c7fd63);
    $parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", ()=>$0aa0180a4506ead8$export$bd7fd4005b84aec9);
    $parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", ()=>$0aa0180a4506ead8$export$ec1cdd0c8335373c);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $7TlNQ = parcelRequire("7TlNQ");
    var $jTu83 = parcelRequire("jTu83");
    var $l6s4f = parcelRequire("l6s4f");
    const $0aa0180a4506ead8$var$customCssStyles = null;
    const $0aa0180a4506ead8$var$listOnlyStyles = null;
    const $0aa0180a4506ead8$export$e6cc5ccd52c7fd63 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7TlNQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
    const $0aa0180a4506ead8$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($jTu83))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
    const $0aa0180a4506ead8$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($l6s4f))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
});
parcelRegister("7TlNQ", function(module, exports) {
    module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();
});
parcelRegister("jTu83", function(module, exports) {
    module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();
});
parcelRegister("l6s4f", function(module, exports) {
    module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();
});
parcelRegister("kXKUX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1lXo2")
    ]).then(()=>parcelRequire('8gPdF'));
});
parcelRegister("1Nsfq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("k7BTo")
    ]).then(()=>parcelRequire('6ZR0a'));
});
parcelRegister("NWARb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eNxsN")
    ]).then(()=>parcelRequire('aRrWI'));
});
parcelRegister("l00Ww", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4a74D")
    ]).then(()=>parcelRequire('fEx2J'));
});
parcelRegister("RJn1w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYKQ3").then(()=>parcelRequire('79qwo'));
});
parcelRegister("9RXCH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7gKdX")
    ]).then(()=>parcelRequire('kO3mB'));
});
parcelRegister("kVevk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7Jjzg")
    ]).then(()=>parcelRequire('9vEjY'));
});
parcelRegister("b3T21", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gP6jR")
    ]).then(()=>parcelRequire('7N8D9'));
});
parcelRegister("2Js68", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dWKlO")
    ]).then(()=>parcelRequire('ciDU2'));
});
parcelRegister("9Saqg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iwPab")
    ]).then(()=>parcelRequire('1XLXC'));
});
parcelRegister("c32Mm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e61bl").then(()=>parcelRequire('ieTY5'));
});
parcelRegister("3oy92", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1gaf4")
    ]).then(()=>parcelRequire('giI7i'));
});
parcelRegister("bm5Zl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("kn4Lg")
    ]).then(()=>parcelRequire('d6iMp'));
});
parcelRegister("3kJhU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("414RV").then(()=>parcelRequire('ln9R3'));
});
parcelRegister("gmE3I", function(module, exports) {
    $parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", ()=>$ff8ead4f49d1e745$export$315b6278d34861b4);
    $parcel$export(module.exports, "useGitLabGatingResource", ()=>$ff8ead4f49d1e745$export$dd3715dce02ee460);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $dIdda = parcelRequire("dIdda");
    const $ff8ead4f49d1e745$var$getDataLoader = ()=>(parcelRequire("7Hzl8"));
    const $ff8ead4f49d1e745$export$315b6278d34861b4 = (0, $dIdda.createResource)({
        type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
        getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
        getDataLoader: $ff8ead4f49d1e745$var$getDataLoader,
        maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
    const $ff8ead4f49d1e745$export$dd3715dce02ee460 = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($ff8ead4f49d1e745$export$315b6278d34861b4);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('enable-gitlab-gating-frontend_k8rha')) return;
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data?.data,
                pending: loading,
                error: data?.error || error
            }), [
            data,
            loading,
            error
        ]);
    };
});
parcelRegister("7Hzl8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hzh3H").then(()=>parcelRequire('4y3Yq'));
});
parcelRegister("2pT4g", function(module, exports) {
    $parcel$export(module.exports, "jsmRepackagingBannerResource", ()=>$f325ae4fdb8711ab$export$760ca885f96dacb6);
    $parcel$export(module.exports, "useJsmRepackagingBannerResource", ()=>$f325ae4fdb8711ab$export$f1444ccc5653a5cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    var $daiqe;
    const $f325ae4fdb8711ab$var$getDataLoader = ()=>(parcelRequire("bjdPq"));
    const $f325ae4fdb8711ab$export$760ca885f96dacb6 = (0, $dIdda.createResource)({
        type: 'JSM_REPACKAGING_BANNER',
        getKey: ()=>'JSM_REPACKAGING_BANNER',
        getDataLoader: $f325ae4fdb8711ab$var$getDataLoader,
        maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
    const $f325ae4fdb8711ab$export$f1444ccc5653a5cb = (workCategory, accountId)=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($f325ae4fdb8711ab$export$760ca885f96dacb6);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            refresh,
            error
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            if (error || loading || !data || !accountId) return {
                show: false
            };
            const { bannerMeta: bannerMeta, bannerDismissState: bannerDismissState } = data;
            const workCategoryDismissState = bannerDismissState?.[workCategory];
            if (!bannerMeta.show || !(bannerMeta.type === 'info' || bannerMeta.type === 'warning')) return {
                show: false
            };
            if (!workCategoryDismissState) return {
                ...bannerDismissState,
                ...bannerMeta,
                refresh: refresh
            };
            if (workCategoryDismissState.packagingChangeDate !== bannerMeta.data.packagingChangeDate) {
                (0, (0, parcelRequire("daiqe")).deleteBannerDismissState)({
                    accountId: accountId
                });
                return {
                    ...bannerMeta,
                    refresh: refresh
                };
            }
            if (workCategoryDismissState.bannerHiddenUntil > Date.now()) return {
                show: false
            };
            return {
                ...bannerMeta,
                ...bannerDismissState,
                refresh: refresh
            };
        }, [
            data,
            loading,
            error,
            workCategory,
            accountId,
            refresh
        ]);
    };
});
parcelRegister("daiqe", function(module, exports) {
    $parcel$export(module.exports, "deleteBannerDismissState", ()=>$00907b0f6d0c25ed$export$e21bb99d98e8c8b4);
    var $jcw0u;
    var $eusud;
    async function $00907b0f6d0c25ed$export$e21bb99d98e8c8b4({ accountId: accountId }) {
        try {
            await (0, (0, parcelRequire("eusud")).performDeleteRequest)(`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'deleteBannerDismissState',
                    packageName: 'jiraRouterResourcesJsmRepackagingBanner',
                    teamName: 'jenga'
                },
                error: error
            });
        }
    }
});
parcelRegister("bjdPq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cVV3d").then(()=>parcelRequire('iKQCz'));
});
parcelRegister("10cgn", function(module, exports) {
    $parcel$export(module.exports, "customerPermissionsPageDataResource", ()=>$35508436fc3abfb3$export$ae3446385906310c);
    var $dIdda = parcelRequire("dIdda");
    const $35508436fc3abfb3$export$ae3446385906310c = (0, $dIdda.createResource)({
        type: (0, $9cf87aec7862b8b9$export$34a89f9aaa677bb5),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("6gDxz")),
        maxAge: Infinity
    });
});
const $9cf87aec7862b8b9$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';
parcelRegister("6gDxz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3ygSW").then(()=>parcelRequire('i9zBn'));
});
parcelRegister("8CwPO", function(module, exports) {
    $parcel$export(module.exports, "portalSettingsContextResource", ()=>$9dfc351c3ebf85b6$export$4a3e29f235f3320c);
    var $dIdda = parcelRequire("dIdda");
    const $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';
    const $9dfc351c3ebf85b6$export$4a3e29f235f3320c = (0, $dIdda.createResource)({
        type: $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("iwaKU"))
    });
});
parcelRegister("iwaKU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kQRxS").then(()=>parcelRequire('7wy1U'));
});
parcelRegister("2WHzH", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPlaybooksListRoute", ()=>$8e576e4dd5841bdc$export$cbed08b5b0671f5f);
    $parcel$export(module.exports, "servicedeskPlaybooksEditRoute", ()=>$8e576e4dd5841bdc$export$5920ce3a2ccf6e2b);
    var $65Ltd;
    const $8e576e4dd5841bdc$var$getProjectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $8e576e4dd5841bdc$export$5575497f0592ee94 = 'servicedesk';
    const $8e576e4dd5841bdc$export$cbed08b5b0671f5f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_LIST),
        path: `${$8e576e4dd5841bdc$var$getProjectSettingsUrl($8e576e4dd5841bdc$export$5575497f0592ee94)}/playbooks`,
        exact: true
    };
    const $8e576e4dd5841bdc$export$5920ce3a2ccf6e2b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_EDIT),
        path: `${$8e576e4dd5841bdc$var$getProjectSettingsUrl($8e576e4dd5841bdc$export$5575497f0592ee94)}/playbooks/:id`,
        exact: true
    };
});
parcelRegister("hfX5a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9YF2g")
    ]).then(()=>parcelRequire('79e1o'));
});
parcelRegister("8fDOc", function(module, exports) {
    $parcel$export(module.exports, "playbookListEntryPoint", ()=>$d77fb854f7f8e8b8$export$d7be5d3b24f1d526);
    var $eufEc;
    var $fEDBv;
    const $d77fb854f7f8e8b8$export$d7be5d3b24f1d526 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("jCfPa")), {
            moduleId: "97555e42"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                extraProps: {
                    cloudId: cloudId
                }
            })
    });
});
parcelRegister("jCfPa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lVFAL").then(()=>parcelRequire('iT2g5'));
});
parcelRegister("6YEEX", function(module, exports) {
    $parcel$export(module.exports, "playbookLogsEntryPoint", ()=>$60633bec6dffe3a8$export$7ebe0f850472ea07);
    var $eufEc;
    var $fEDBv;
    const $60633bec6dffe3a8$export$7ebe0f850472ea07 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("dOnuK")), {
            moduleId: "1ddad45d"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                extraProps: {
                    cloudId: cloudId
                }
            })
    });
});
parcelRegister("dOnuK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9ctOi").then(()=>parcelRequire('arpva'));
});
parcelRegister("8RxBf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("la2ji").then(()=>parcelRequire('6o22p'));
});
parcelRegister("9oaeI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kkgDQ")
    ]).then(()=>parcelRequire('9Qg7T'));
});
parcelRegister("jN2C0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7C5bc")
    ]).then(()=>parcelRequire('7uVkM'));
});
parcelRegister("gZF9U", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1PFOk")
    ]).then(()=>parcelRequire('44UJy'));
});
parcelRegister("eer4p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9udti")
    ]).then(()=>parcelRequire('6kXBX'));
});
parcelRegister("7zSGd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hKaWl")
    ]).then(()=>parcelRequire('5jbPW'));
});
parcelRegister("8WSu7", function(module, exports) {
    $parcel$export(module.exports, "getSettingsPath", ()=>$b4b4e7a1fd793539$export$67417cd3aaee582d);
    const $b4b4e7a1fd793539$export$67417cd3aaee582d = (path, isJCS)=>isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
});
parcelRegister("aTz47", function(module, exports) {
    $parcel$export(module.exports, "isHelpCenterSettingsPath", ()=>$1e0d45f36b27f85a$export$bf8b98b87d485657);
    var $4R6GH;
    const $1e0d45f36b27f85a$export$bf8b98b87d485657 = ()=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag')) return false;
        if (!false) return window.location.pathname.includes('jira/helpcenter/');
        return false;
    };
});
parcelRegister("jEJ7g", function(module, exports) {
    $parcel$export(module.exports, "useIsJCS", ()=>$db67bf04078e8532$export$927b5354181b3adf);
    $parcel$export(module.exports, "useAsyncIsJCS", ()=>$db67bf04078e8532$export$3894a8f24b665478);
    $parcel$export(module.exports, "isJCSTemplate", ()=>$db67bf04078e8532$export$afee907b7a66ef2b);
    var $e5wyW;
    var $4R6GH;
    var $O4MMs;
    const $db67bf04078e8532$var$useIsJCSUnderFF = ()=>{
        const { 'initial.project.template.name': initialProjectTemplate } = (0, (0, parcelRequire("O4MMs")).useProjectProperties)([
            'initial.project.template.name'
        ]);
        return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
    };
    const $db67bf04078e8532$export$927b5354181b3adf = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$useIsJCSUnderFF, ()=>false);
    const $db67bf04078e8532$var$useAsyncIsJCSUnderFF = ()=>{
        const { 'initial.project.template.name': initialProjectTemplate } = (0, (0, parcelRequire("O4MMs")).useProjectProperties)([
            'initial.project.template.name'
        ]);
        return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
    };
    const $db67bf04078e8532$export$3894a8f24b665478 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$useAsyncIsJCSUnderFF, ()=>false);
    const $db67bf04078e8532$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
    const $db67bf04078e8532$var$isJCSTemplateFallback = (template)=>false;
    const $db67bf04078e8532$export$afee907b7a66ef2b = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$isJCSTemplateUnderFF, $db67bf04078e8532$var$isJCSTemplateFallback);
});
parcelRegister("O4MMs", function(module, exports) {
    $parcel$export(module.exports, "useProjectProperties", ()=>$eccdf8f1b49d4032$export$58be98885c2d686a);
    var $5uXOq = parcelRequire("5uXOq");
    var $74ySO = parcelRequire("74ySO");
    var $ajpes = parcelRequire("ajpes");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $lpwtK;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $7JoAD = parcelRequire("7JoAD");
    var $dYZ0w;
    const $eccdf8f1b49d4032$export$d4c72bab9d6cc13a = {};
    const $eccdf8f1b49d4032$var$Store = (0, $7JoAD.createStore)({
        name: 'project-properties',
        initialState: $eccdf8f1b49d4032$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("dYZ0w")).actions
    });
    const $eccdf8f1b49d4032$export$eebf791068e870dd = (0, $7JoAD.createHook)($eccdf8f1b49d4032$var$Store);
    const $eccdf8f1b49d4032$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
        const { data: data } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
        const [state, { get: get }] = $eccdf8f1b49d4032$export$eebf791068e870dd();
        const prevPropertyKeys = (0, (0, parcelRequire("1XJ20")).usePrevious)(propertyKeys);
        (0, $5uXOq.useEffect)(()=>{
            if (projectId === undefined) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
            if ((0, ($parcel$interopDefault($ajpes)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
            if (projectId) get(projectId, propertyKeys);
        }, [
            projectId,
            propertyKeys,
            prevPropertyKeys,
            get,
            createAnalyticsEvent,
            projectIdOverride
        ]);
        return projectId !== undefined ? (0, ($parcel$interopDefault($4f8Oj)))(state[projectId], (_, key)=>(0, ($parcel$interopDefault($74ySO)))(propertyKeys, key)) : {};
    };
});
parcelRegister("74ySO", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    var $hTJwX = parcelRequire("hTJwX");
    var $agVdz = parcelRequire("agVdz");
    var $kPZpS = parcelRequire("kPZpS");
    var $dMEgP = parcelRequire("dMEgP");
    var $5263f72d78aeaf9c$var$nativeMax = Math.max;
    function $5263f72d78aeaf9c$var$includes(collection, value, fromIndex, guard) {
        collection = $hTJwX(collection) ? collection : $dMEgP(collection);
        fromIndex = fromIndex && !guard ? $kPZpS(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) fromIndex = $5263f72d78aeaf9c$var$nativeMax(length + fromIndex, 0);
        return $agVdz(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $2wwA6(collection, value, fromIndex) > -1;
    }
    module.exports = $5263f72d78aeaf9c$var$includes;
});
parcelRegister("agVdz", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $8LQ84 = parcelRequire("8LQ84");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $77a7c84c5ee0b808$var$stringTag = '[object String]';
    function $77a7c84c5ee0b808$var$isString(value) {
        return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
    }
    module.exports = $77a7c84c5ee0b808$var$isString;
});
parcelRegister("dYZ0w", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$d36e01b4b5883936$export$e324594224ef24da);
    var $9Tr6m;
    const $d36e01b4b5883936$export$e324594224ef24da = {
        get: (0, parcelRequire("9Tr6m")).get
    };
});
parcelRegister("9Tr6m", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$52dc90cc0afc52f4$export$3988ae62b71be9a3);
    var $k8IPx = parcelRequire("k8IPx");
    var $cjFoH = parcelRequire("cjFoH");
    var $66FNL = parcelRequire("66FNL");
    var $fUPWG;
    const $52dc90cc0afc52f4$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
            const currentProperties = getState()[projectId] || {};
            const missingProperties = (0, ($parcel$interopDefault($k8IPx)))(properties, (0, ($parcel$interopDefault($66FNL)))(currentProperties));
            missingProperties.length && (0, (0, parcelRequire("fUPWG")).default)({
                baseUrl: '',
                projectId: projectId,
                properties: missingProperties
            }).then((fetchedProperties)=>{
                const latestProperties = getState()[projectId] || {};
                setState({
                    [projectId]: {
                        ...latestProperties,
                        ...missingProperties.reduce((result, name)=>{
                            const reducedResult = result;
                            const fetchedProperty = fetchedProperties[name];
                            reducedResult[name] = (0, ($parcel$interopDefault($cjFoH)))(fetchedProperty) ? null : fetchedProperty;
                            return reducedResult;
                        }, {})
                    }
                });
            });
        };
});
parcelRegister("k8IPx", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $g7i7g = parcelRequire("g7i7g");
    var $f3SOL = parcelRequire("f3SOL");
    var $ea975459f1938a58$var$difference = $g7i7g(function(array, values) {
        return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true)) : [];
    });
    module.exports = $ea975459f1938a58$var$difference;
});
parcelRegister("55pzo", function(module, exports) {
    var $ijRUK = parcelRequire("ijRUK");
    var $fUP98 = parcelRequire("fUP98");
    var $dA3tP = parcelRequire("dA3tP");
    var $1nIHN = parcelRequire("1nIHN");
    var $cW28x = parcelRequire("cW28x");
    var $40I25 = parcelRequire("40I25");
    var $3b41410a547f22d2$var$LARGE_ARRAY_SIZE = 200;
    function $3b41410a547f22d2$var$baseDifference(array, values, iteratee, comparator) {
        var index = -1, includes = $fUP98, isCommon = true, length = array.length, result = [], valuesLength = values.length;
        if (!length) return result;
        if (iteratee) values = $1nIHN(values, $cW28x(iteratee));
        if (comparator) {
            includes = $dA3tP;
            isCommon = false;
        } else if (values.length >= $3b41410a547f22d2$var$LARGE_ARRAY_SIZE) {
            includes = $40I25;
            isCommon = false;
            values = new $ijRUK(values);
        }
        outer: while(++index < length){
            var value = array[index], computed = iteratee == null ? value : iteratee(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while(valuesIndex--){
                    if (values[valuesIndex] === computed) continue outer;
                }
                result.push(value);
            } else if (!includes(values, computed, comparator)) result.push(value);
        }
        return result;
    }
    module.exports = $3b41410a547f22d2$var$baseDifference;
});
parcelRegister("fUPWG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$573d8b462e0e2ec6$export$2e2bcd8739ae039);
    var $1sYcL;
    var $573d8b462e0e2ec6$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
        const { project: project } = await (0, (0, parcelRequire("1sYcL")).get)(baseUrl, {
            projectId: projectId,
            projectProperties: properties,
            consumerMeta: {
                id: 'remoteGet',
                packageName: 'jiraProjectPropertiesServices',
                teamName: 'jsd-shield'
            }
        });
        return project;
    };
});
parcelRegister("4fGkE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lxzGu")
    ]).then(()=>parcelRequire('jp5Rx'));
});
parcelRegister("3Yq3S", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskJourneysRoute", ()=>$a2dea3b6266893e0$export$94adf8e91b84b806);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskJourneyConfigurationRoute", ()=>$a2dea3b6266893e0$export$c0d493d5e7c848d0);
    var $65Ltd;
    const $a2dea3b6266893e0$export$94adf8e91b84b806 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-journeys`,
        path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
        exact: true
    };
    const $a2dea3b6266893e0$export$c0d493d5e7c848d0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-journey-configuration`,
        path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
        exact: true
    };
});
parcelRegister("gw7Fm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iUjK0")
    ]).then(()=>parcelRequire('aG5pa'));
});
parcelRegister("aUjwY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("g2xfa")
    ]).then(()=>parcelRequire('iSwlg'));
});
parcelRegister("8G8Xo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("84U6s").then(()=>parcelRequire('2fak7'));
});
parcelRegister("ippoi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2IJUz")
    ]).then(()=>parcelRequire('gCbsh'));
});
parcelRegister("4wBwP", function(module, exports) {
    $parcel$export(module.exports, "slaMetricsDataResource", ()=>$5bd842d236781a2e$export$6cdfca3e816e9661);
    var $dIdda = parcelRequire("dIdda");
    const $5bd842d236781a2e$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';
    const $5bd842d236781a2e$export$6cdfca3e816e9661 = (0, $dIdda.createResource)({
        type: $5bd842d236781a2e$export$c5fa03c9ad8df0e2,
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("c7Qcd")),
        maxAge: Infinity
    });
});
parcelRegister("c7Qcd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g759n").then(()=>parcelRequire('dxWU3'));
});
parcelRegister("h3FVt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gUg0Z")
    ]).then(()=>parcelRequire('1rjw0'));
});
parcelRegister("9isaY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9pCQy")
    ]).then(()=>parcelRequire('73hU9'));
});
parcelRegister("k8jl5", function(module, exports) {
    $parcel$export(module.exports, "servicedeskIssueTypesResource", ()=>$8b723afc89fdf36c$export$191ce50629f40dbe);
    var $dIdda = parcelRequire("dIdda");
    const $8b723afc89fdf36c$var$getDataLoader = ()=>(parcelRequire("7Al2u"));
    const $8b723afc89fdf36c$export$191ce50629f40dbe = (0, $dIdda.createResource)({
        type: (0, $30e9f90f7be7696a$export$1ed713fe52212251),
        getKey: ({ match: { params: params } })=>params.projectKey || '',
        getDataLoader: $8b723afc89fdf36c$var$getDataLoader
    });
});
const $30e9f90f7be7696a$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';
parcelRegister("7Al2u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lJYdj").then(()=>parcelRequire('lWPKX'));
});
parcelRegister("1cpsA", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPortalGroupsResource", ()=>$2ddee7630453f9bc$export$c7fb28234b909b2f);
    var $dIdda = parcelRequire("dIdda");
    const $2ddee7630453f9bc$var$getDataLoader = ()=>(parcelRequire("hyupy"));
    const $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS = 86400000;
    const $2ddee7630453f9bc$export$c7fb28234b909b2f = (0, $dIdda.createResource)({
        type: (0, $1e9c4adda1725c92$export$4160f2c498fcd32e),
        getKey: ({ match: { params: params } })=>params.projectKey || '',
        getDataLoader: $2ddee7630453f9bc$var$getDataLoader,
        maxAge: $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS
    });
});
const $1e9c4adda1725c92$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';
parcelRegister("hyupy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4lrTa").then(()=>parcelRequire('7sMSo'));
});
parcelRegister("i88kG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b1kaE")
    ]).then(()=>parcelRequire('7wKb0'));
});
parcelRegister("1kwFV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bTdk8")
    ]).then(()=>parcelRequire('dMvBS'));
});
parcelRegister("av9sZ", function(module, exports) {
    $parcel$export(module.exports, "ErrorDisplay", ()=>$09828373404eee09$export$d56b0569bceb92ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $hTEpF;
    var $7q5TP;
    var $iVgQf;
    var $koVbs;
    var $2zwTA;
    const $09828373404eee09$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: formatMessage((0, (0, parcelRequire("2zwTA")).default).errorDisplayHeading),
            description: formatMessage((0, (0, parcelRequire("2zwTA")).default).errorDisplayDescription),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("7q5TP")).default)),
            imageWidth: 160,
            maxImageHeight: 220,
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                onClick: refetch,
                appearance: "link"
            }, formatMessage((0, (0, parcelRequire("2zwTA")).default).reloadNowButtonText))
        });
    };
});
parcelRegister("7q5TP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc8d7b09135bd30b$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("8ODZY")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("b2nX8")))));
    var $dCLgq;
    var $b2nX8 = parcelRequire("b2nX8");
    var $8ODZY = parcelRequire("8ODZY");
    const $dc8d7b09135bd30b$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($8ODZY)),
        srcDark: ($parcel$interopDefault($b2nX8))
    });
    var $dc8d7b09135bd30b$export$2e2bcd8739ae039 = $dc8d7b09135bd30b$var$Illustration;
    const $dc8d7b09135bd30b$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        212
    ];
});
parcelRegister("dCLgq", function(module, exports) {
    $parcel$export(module.exports, "Illustration", ()=>$191b30bb5e9fa934$export$d43c2e2ca9b2c105);
    $parcel$export(module.exports, "createIllustration", ()=>$191b30bb5e9fa934$export$4d00e7be716a0093);
    var $5uXOq = parcelRequire("5uXOq");
    var $10ozQ;
    function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("10ozQ")).AsImg), props);
    }
    function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
                srcLight: srcLight,
                srcDark: srcDark,
                autoDark: autoDark,
                ...props
            });
    }
});
parcelRegister("10ozQ", function(module, exports) {
    $parcel$export(module.exports, "AsImg", ()=>$b5af8835f639f069$export$75e378065cb7d6c0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    const $b5af8835f639f069$var$defaultStyles = null;
    const $b5af8835f639f069$var$fillStyles = null;
    const $b5af8835f639f069$var$autoDarkModeStyles = null;
    function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: colorMode === 'dark' ? srcDark : srcLight,
            alt: alt,
            "data-testid": testId,
            ...imgProps,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
                fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
                colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
            ])
        });
    }
});
parcelRegister("b2nX8", function(module, exports) {
    module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();
});
parcelRegister("8ODZY", function(module, exports) {
    module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();
});
parcelRegister("iVgQf", function(module, exports) {
    $parcel$export(module.exports, "getAkEmptyStateRenderImageFn", ()=>$7affac5c7e698fc8$export$ebf64b9217c1b2a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $4Bpvs;
    function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, (0, parcelRequire("4Bpvs")).default)) {
        return ({ maxImageWidth: maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
            const Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
                    ...__cmplp,
                    style: {
                        ...__cmpls,
                        "--_yv3y2x": (0, (0, parcelRequire("lD23V")).default)(maxImageWidth, "px"),
                        "--_nq7wev": (0, (0, parcelRequire("lD23V")).default)(maxImageHeight, "px")
                    },
                    ref: __cmplr,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_1e0c1ule _p12f1x6a _c71lc3ce _18s81ixx",
                        __cmplp.className
                    ])
                });
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
                alt: "",
                role: "presentation",
                width: imageWidth || 'auto',
                height: imageHeight || 'auto'
            }));
        };
    }
});
parcelRegister("4Bpvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$029e22a35a3f42f7$export$2e2bcd8739ae039);
    var $dCLgq;
    var $kbo4z = parcelRequire("kbo4z");
    var $3uP2Y = parcelRequire("3uP2Y");
    const $029e22a35a3f42f7$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3uP2Y)),
        srcDark: ($parcel$interopDefault($kbo4z))
    });
    var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
    const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
        0,
        0,
        235,
        210
    ];
});
parcelRegister("kbo4z", function(module, exports) {
    module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();
});
parcelRegister("3uP2Y", function(module, exports) {
    module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();
});
parcelRegister("2zwTA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2ecc7c5e37557c1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b2ecc7c5e37557c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorDisplayHeading: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
            "defaultMessage": "We couldn\u2019t load intent templates"
        },
        errorDisplayDescription: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
            "defaultMessage": "Wait a moment and then try reloading."
        },
        reloadNowButtonText: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
            "defaultMessage": "Reload"
        }
    });
});
parcelRegister("ewTwY", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", ()=>$31edb55767749c70$export$444026e4d4f156e4);
    $parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", ()=>$31edb55767749c70$export$9dca41144a6398d2);
    $parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", ()=>$31edb55767749c70$export$538762e63d6466fe);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $eTe4L = parcelRequire("eTe4L");
    var $5IeeQ = parcelRequire("5IeeQ");
    var $8v6ku = parcelRequire("8v6ku");
    const $31edb55767749c70$var$customCssStyles = null;
    const $31edb55767749c70$export$444026e4d4f156e4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eTe4L))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    const $31edb55767749c70$export$9dca41144a6398d2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($5IeeQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    const $31edb55767749c70$export$538762e63d6466fe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8v6ku))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("eTe4L", function(module, exports) {
    module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();
});
parcelRegister("5IeeQ", function(module, exports) {
    module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();
});
parcelRegister("8v6ku", function(module, exports) {
    module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();
});
parcelRegister("d4rfp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b78ba3d71d6b015$export$2e2bcd8739ae039);
    var $4R6GH;
    var $2b78ba3d71d6b015$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('expose_channels_on_va_conversation_history');
        }
    };
});
parcelRegister("7HjzY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7F9PY")
    ]).then(()=>parcelRequire('azR8x'));
});
parcelRegister("b2GCz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dt4qH")
    ]).then(()=>parcelRequire('9r2hQ'));
});
parcelRegister("l7tra", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("kiA0q")
    ]).then(()=>parcelRequire('exMWS'));
});
parcelRegister("e1IHq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("atp96")
    ]).then(()=>parcelRequire('52WYW'));
});
parcelRegister("iEX30", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7SEHL")
    ]).then(()=>parcelRequire('byLJY'));
});
parcelRegister("83kJ4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jVj7l")
    ]).then(()=>parcelRequire('01RYz'));
});
parcelRegister("e6BUU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8avJm")
    ]).then(()=>parcelRequire('16gIP'));
});
parcelRegister("hQKui", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c6xj7")
    ]).then(()=>parcelRequire('3STzC'));
});
parcelRegister("ejiWA", function(module, exports) {
    $parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", ()=>$53ebb72294d46a1c$export$2413ba18ec38282d);
    var $dIdda = parcelRequire("dIdda");
    const $53ebb72294d46a1c$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';
    const $53ebb72294d46a1c$var$getDataLoader = ()=>(parcelRequire("kWcpx"));
    const $53ebb72294d46a1c$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
    const $53ebb72294d46a1c$export$2413ba18ec38282d = (0, $dIdda.createResource)({
        type: $53ebb72294d46a1c$export$c0636b6062501e0b,
        getKey: $53ebb72294d46a1c$var$getKey,
        getDataLoader: $53ebb72294d46a1c$var$getDataLoader,
        maxAge: Infinity
    });
});
parcelRegister("kWcpx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fIejC").then(()=>parcelRequire('k9qTQ'));
});
parcelRegister("7Txnp", function(module, exports) {
    $parcel$export(module.exports, "LoadingComponent", ()=>$42f73bbf4237dc1b$export$7db30d367db7d20a);
    $parcel$export(module.exports, "LazyCsatSettingsPage", ()=>$42f73bbf4237dc1b$export$32eb62914bae0e84);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $kxZPA;
    var $2RMCX;
    const $42f73bbf4237dc1b$export$7db30d367db7d20a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2RMCX")).SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        }));
    const $42f73bbf4237dc1b$export$32eb62914bae0e84 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hFEiH")), {
        moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
    });
});
parcelRegister("2RMCX", function(module, exports) {
    $parcel$export(module.exports, "SpinnerContainer", ()=>$9b09872937243424$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $9b09872937243424$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hFEiH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jT1Vf").then(()=>parcelRequire('hX8BJ'));
});
parcelRegister("k7tsS", function(module, exports) {
    $parcel$export(module.exports, "languageTranslationsResource", ()=>$ffad7a39054feef3$export$f51887e33895eab9);
    $parcel$export(module.exports, "outgoingEmailStateModelResource", ()=>$ffad7a39054feef3$export$c460156a7e6b85b2);
    var $dIdda = parcelRequire("dIdda");
    const $ffad7a39054feef3$export$9f529be3aeae01ea = 'JSM Language Translations';
    const $ffad7a39054feef3$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";
    const $ffad7a39054feef3$export$f51887e33895eab9 = (0, $dIdda.createResource)({
        type: 'Language Translations',
        getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$ffad7a39054feef3$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
        getDataLoader: ()=>(parcelRequire("1gRMI")),
        maxAge: Infinity
    });
    const $ffad7a39054feef3$export$c460156a7e6b85b2 = (0, $dIdda.createResource)({
        type: 'Outgoing Email State Model',
        getKey: ()=>`${$ffad7a39054feef3$export$ecd381e388e8c56f}`,
        getDataLoader: ()=>(parcelRequire("aL9AA")),
        maxAge: Infinity
    });
});
parcelRegister("1gRMI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4BYvo").then(()=>parcelRequire('3m5cp'));
});
parcelRegister("aL9AA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hn2iP").then(()=>parcelRequire('49aS0'));
});
parcelRegister("f8FqB", function(module, exports) {
    $parcel$export(module.exports, "LazyInternalNotificationSettingsPage", ()=>$c99d86239fe70688$export$501979bd6d492c43);
    var $kxZPA;
    const $c99d86239fe70688$export$501979bd6d492c43 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("asdjb")), {
        moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
    });
});
parcelRegister("asdjb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dBkhA")
    ]).then(()=>parcelRequire('ZHF20'));
});
parcelRegister("ghg5c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7mkmU")
    ]).then(()=>parcelRequire('jgXd4'));
});
parcelRegister("4q0cm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("d1IdH")
    ]).then(()=>parcelRequire('eh7Vf'));
});
parcelRegister("kXpVf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYnLU").then(()=>parcelRequire('k9vj7'));
});
parcelRegister("bixEU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("35rMy")
    ]).then(()=>parcelRequire('giHe4'));
});
parcelRegister("9J1LU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("gNC9e")
    ]).then(()=>parcelRequire('3eQYY'));
});
parcelRegister("1iNvP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7XRy3")
    ]).then(()=>parcelRequire('gu2ky'));
});
parcelRegister("lsb3L", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kEacZ")
    ]).then(()=>parcelRequire('7iBoV'));
});
parcelRegister("1824v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k8jhA").then(()=>parcelRequire('d3uR0'));
});
parcelRegister("3z8Kq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d8OHn")
    ]).then(()=>parcelRequire('gZiIg'));
});
parcelRegister("5WlEn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYiLE").then(()=>parcelRequire('apjAt'));
});
parcelRegister("5EQvM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ay8u5")
    ]).then(()=>parcelRequire('dWAhE'));
});
parcelRegister("5UxQx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3JNwJ").then(()=>parcelRequire('4yiYq'));
});
parcelRegister("bmBIM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7tltX")
    ]).then(()=>parcelRequire('kG5x5'));
});
parcelRegister("coLKx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6XeFg")
    ]).then(()=>parcelRequire('jQFbr'));
});
parcelRegister("ba8Ho", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7Qhcd")
    ]).then(()=>parcelRequire('dO6p9'));
});
parcelRegister("1xZqw", function(module, exports) {
    $parcel$export(module.exports, "cardCoverImageResource", ()=>$0fcabd2255a2311c$export$f37f52e28126ce75);
    var $dXq4S;
    var $ao2h1;
    var $eQDse;
    const $0fcabd2255a2311c$export$f37f52e28126ce75 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $b9b0da783aed9042$export$d9d248919fbd0611),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("eQDse")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("eQDse", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19be575ffa3b6370$export$2e2bcd8739ae039);
    const $19be575ffa3b6370$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "cardCoverSettingsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "BoardScope",
                            "kind": "LinkedField",
                            "name": "boardScope",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "SoftwareBoard",
                                        "kind": "LinkedField",
                                        "name": "board",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "toggle_boardSettingsCard_CardCoverToggle"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "cardPreview_boardSettingsCard"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.board"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "cardCoverSettingsQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SoftwareBoard",
                                "kind": "LinkedField",
                                "name": "board",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CardMediaConfig",
                                        "kind": "LinkedField",
                                        "name": "cardMedia",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "enabled"
                                            }
                                        ]
                                    },
                                    v2
                                ]
                            },
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc",
                "metadata": {},
                "name": "cardCoverSettingsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $19be575ffa3b6370$var$node.hash = "eb3068eeffbe9ec2fb99186c54005ea6";
    var $19be575ffa3b6370$export$2e2bcd8739ae039 = $19be575ffa3b6370$var$node;
});
const $b9b0da783aed9042$export$d9d248919fbd0611 = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';
parcelRegister("cD3jo", function(module, exports) {
    $parcel$export(module.exports, "customFiltersResource", ()=>$ca950ad823e84673$export$3e390340716755de);
    var $dXq4S;
    var $ao2h1;
    var $WcCM5;
    const $ca950ad823e84673$export$3e390340716755de = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $ad903674eb868bde$export$5917fd27c14066cd),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("WcCM5")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("WcCM5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5edc411e6b038299$export$2e2bcd8739ae039);
    const $5edc411e6b038299$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "customFiltersQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "BoardScope",
                            "kind": "LinkedField",
                            "name": "boardScope",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CustomFilter",
                                        "kind": "LinkedField",
                                        "name": "customFilters",
                                        "plural": true,
                                        "selections": [
                                            v2,
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "customFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CustomFilter",
                                "kind": "LinkedField",
                                "name": "customFilters",
                                "plural": true,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "description"
                                    },
                                    {
                                        "concreteType": "FilterQuery",
                                        "kind": "LinkedField",
                                        "name": "filterQuery",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "sanitisedJql"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "errors"
                                            }
                                        ]
                                    },
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            v3,
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
                "metadata": {},
                "name": "customFiltersQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5edc411e6b038299$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
    var $5edc411e6b038299$export$2e2bcd8739ae039 = $5edc411e6b038299$var$node;
});
const $ad903674eb868bde$export$5917fd27c14066cd = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';
parcelRegister("35Wvp", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsToolchainResource", ()=>$ed037648996bd812$export$182dfe2bc7c28567);
    var $ao2h1;
    var $avVgl;
    const $ed037648996bd812$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
    const $ed037648996bd812$export$182dfe2bc7c28567 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $ed037648996bd812$export$b8927fea69d9f414,
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("avVgl")).default),
                variables: {
                    cloudId: tenantContext?.cloudId || ''
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("avVgl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5afd24d8f370d3e2$export$2e2bcd8739ae039);
    const $5afd24d8f370d3e2$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "concreteType": "DvcsQuery",
                "kind": "LinkedField",
                "name": "dvcs",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            }
                        ],
                        "concreteType": "DvcsBitbucketWorkspaceConnection",
                        "kind": "LinkedField",
                        "name": "bitbucketWorkspacesLinkedToSite",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "DvcsBitbucketWorkspaceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ui_projectSettingsToolchainQuery",
                "selections": v1,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ui_projectSettingsToolchainQuery",
                "selections": v1
            },
            "params": {
                "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
                "metadata": {},
                "name": "ui_projectSettingsToolchainQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5afd24d8f370d3e2$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
    var $5afd24d8f370d3e2$export$2e2bcd8739ae039 = $5afd24d8f370d3e2$var$node;
});
parcelRegister("2FXLN", function(module, exports) {
    $parcel$export(module.exports, "roadmapSettingsResource", ()=>$265fc06fbb6443a3$export$7901a008bd73bf46);
    var $dXq4S;
    var $ao2h1;
    var $6VnEZ;
    const $265fc06fbb6443a3$export$7901a008bd73bf46 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $87d7efe6336d8b83$export$e905b9170ecbb599),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
            const { cloudId: cloudId } = tenantContext;
            return {
                parameters: (0, (0, parcelRequire("6VnEZ")).default),
                variables: {
                    sourceAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    }),
                    locationAri: undefined
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
});
parcelRegister("6VnEZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a28994bc59c1b6c$export$2e2bcd8739ae039);
    const $4a28994bc59c1b6c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locationAri"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "locationARI",
                "variableName": "locationAri"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceAri"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "isSprintsFeatureEnabled"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "roadmapSettingsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "RoadmapConfiguration",
                                            "kind": "LinkedField",
                                            "name": "roadmapConfiguration",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "RoadmapBoardConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "boardConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            v3,
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                                                            },
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "roadmapSettingsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "RoadmapBoardConfiguration",
                                                "kind": "LinkedField",
                                                "name": "boardConfiguration",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isChildIssuePlanningEnabled"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "childIssuePlanningMode"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
                "metadata": {},
                "name": "roadmapSettingsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $4a28994bc59c1b6c$var$node.hash = "31c20159daaa03716587a1ccbe27ab14";
    var $4a28994bc59c1b6c$export$2e2bcd8739ae039 = $4a28994bc59c1b6c$var$node;
});
parcelRegister("5Dbz7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jwlH1")
    ]).then(()=>parcelRequire('a0GzC'));
});
parcelRegister("haLpa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("fg4hm")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kPUyC")
    ]).then(()=>parcelRequire('jFUmz'));
});
parcelRegister("d6oA5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("3R5lB")
    ]).then(()=>parcelRequire('keIpy'));
});
parcelRegister("7rq9z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2h1uc")
    ]).then(()=>parcelRequire('7AMRE'));
});
parcelRegister("8DLRI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6IfzY")
    ]).then(()=>parcelRequire('2MwfB'));
});
parcelRegister("juWe0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("20nf9")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gldEF")
    ]).then(()=>parcelRequire('dgQTq'));
});
parcelRegister("hR0vX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kO7MH").then(()=>parcelRequire('5d39M'));
});
parcelRegister("2tVe2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("57yIp")
    ]).then(()=>parcelRequire('hX1AL'));
});
parcelRegister("kSJIO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("boaHK")
    ]).then(()=>parcelRequire('l1Z7j'));
});
parcelRegister("gAdgD", function(module, exports) {
    $parcel$export(module.exports, "jsmBoardRoute", ()=>$5c5a2553f427d19f$export$a192088aab559fa1);
    var $65Ltd;
    const $5c5a2553f427d19f$export$a192088aab559fa1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS),
        exact: true
    };
});
parcelRegister("40EFi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("341YM")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6Yvcg")
    ]).then(()=>parcelRequire('fnC5S'));
});
parcelRegister("gf8DN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iK5gX")
    ]).then(()=>parcelRequire('lWiJj'));
});
parcelRegister("jYeNO", function(module, exports) {
    $parcel$export(module.exports, "getCalendarFilterFieldsResource", ()=>$4dc70aab7904ddfa$export$5f02bf5f04197ed7);
    $parcel$export(module.exports, "useCalendarFilterResource", ()=>$4dc70aab7904ddfa$export$70361b748d216408);
    var $fZneA;
    var $eusud;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $3ezTL;
    var $30Hlr;
    const $4dc70aab7904ddfa$var$fetchFilterFields = async (cloudId, jqlContext)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $8c2713286c62bdd7$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        contextFieldsFilter: {
                            searchString: (0, (0, parcelRequire("3ezTL")).REQUEST_TYPE_FILTER)
                        },
                        jqlContext: jqlContext
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            });
            return (0, (0, parcelRequire("30Hlr")).transformAndReport)(response);
        } catch (error) {
            if (!(0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(error)) (0, (0, parcelRequire("30Hlr")).reportError)(error);
            return 0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS;
        }
    };
    const $4dc70aab7904ddfa$var$filterFieldsResource = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_FILTER_FIELD),
        getKey: ()=>(0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_FILTER_FIELD),
        getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            const jqlContext = `project = '${projectIdOrKey}'`;
            return $4dc70aab7904ddfa$var$fetchFilterFields(cloudId, jqlContext);
        },
        maxAge: Infinity
    });
    const $4dc70aab7904ddfa$export$5f02bf5f04197ed7 = ()=>$4dc70aab7904ddfa$var$filterFieldsResource;
    const $4dc70aab7904ddfa$export$70361b748d216408 = ()=>(0, $dIdda.useResource)($4dc70aab7904ddfa$var$filterFieldsResource);
});
parcelRegister("3ezTL", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_NAME", ()=>$2fdfca9bb2287268$export$186e93e8ef3f9358);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$2fdfca9bb2287268$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$2fdfca9bb2287268$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "REQUEST_TYPE_FILTER", ()=>$2fdfca9bb2287268$export$2c388650eabddf5e);
    $parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", ()=>$2fdfca9bb2287268$export$2019de80301f1da);
    $parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", ()=>$2fdfca9bb2287268$export$2912f30d4328fc00);
    const $2fdfca9bb2287268$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
    const $2fdfca9bb2287268$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
    const $2fdfca9bb2287268$export$d57b6b390e78d90f = 'jsd-shield';
    const $2fdfca9bb2287268$export$2c388650eabddf5e = 'request type';
    const $2fdfca9bb2287268$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
    const $2fdfca9bb2287268$export$2912f30d4328fc00 = [
        'status',
        'assignee'
    ];
});
const $8c2713286c62bdd7$export$2b91517d6d5b4365 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
parcelRegister("30Hlr", function(module, exports) {
    $parcel$export(module.exports, "TARGET_FILTER_TYPE", ()=>$f86becf4a18b4f1f$export$64f54b13b7aea793);
    $parcel$export(module.exports, "reportError", ()=>$f86becf4a18b4f1f$export$b33b857ad1d9900e);
    $parcel$export(module.exports, "transformAndReport", ()=>$f86becf4a18b4f1f$export$af2aa11c88c551af);
    var $jcw0u;
    var $3ezTL;
    const $f86becf4a18b4f1f$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
    const $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
    const $f86becf4a18b4f1f$export$b33b857ad1d9900e = (error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            meta: {
                id: (0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_NAME),
                packageName: (0, (0, parcelRequire("3ezTL")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("3ezTL")).TEAM_NAME)
            }
        });
    };
    const $f86becf4a18b4f1f$export$af2aa11c88c551af = (response)=>{
        const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
        const requestType = edges?.find((edge)=>edge?.node?.type === $f86becf4a18b4f1f$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
        if (!requestType) $f86becf4a18b4f1f$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
        return requestType ? [
            {
                ...requestType,
                searchTemplate: requestType.searchTemplate.key,
                fieldType: requestType.type
            },
            ...(0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS)
        ] : (0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS);
    };
});
parcelRegister("5H96Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1QoV7")
    ]).then(()=>parcelRequire('2hdB5'));
});
parcelRegister("9SdDk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ii98U")
    ]).then(()=>parcelRequire('6vvjk'));
});
parcelRegister("8obNZ", function(module, exports) {
    $parcel$export(module.exports, "servicedeskChangeCalendarRoute", ()=>$fbae9ba8fa6eccc0$export$3dbc16ae422c469);
    var $65Ltd;
    const $fbae9ba8fa6eccc0$export$3dbc16ae422c469 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
        path: '/jira/servicedesk/projects/:projectKey/change-calendar',
        exact: true
    };
});
parcelRegister("4uj5r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("41TKw")
    ]).then(()=>parcelRequire('4cmmO'));
});
parcelRegister("8ym2X", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fApFb").then(()=>parcelRequire('ejeJy'));
});
parcelRegister("6j0IA", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", ()=>$f0c74bdf86d6b898$export$58d2462746e91c7d);
    var $dIdda = parcelRequire("dIdda");
    const $f0c74bdf86d6b898$var$getDataLoader = ()=>(parcelRequire("aFxik"));
    const $f0c74bdf86d6b898$export$58d2462746e91c7d = (0, $dIdda.createResource)({
        type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
        getKey: ()=>'extensions',
        getDataLoader: $f0c74bdf86d6b898$var$getDataLoader,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
parcelRegister("aFxik", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("29sLe").then(()=>parcelRequire('jwVSb'));
});
parcelRegister("8naTI", function(module, exports) {
    $parcel$export(module.exports, "insightObjectResource", ()=>$2ad42c3dacc09c9e$export$215464c8085c5e35);
    var $dIdda = parcelRequire("dIdda");
    var $7JHOP;
    const $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
    const $2ad42c3dacc09c9e$export$215464c8085c5e35 = (0, $dIdda.createResource)({
        type: $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
        getKey: ({ match: match })=>match.params.objectId || '',
        getData: (0, parcelRequire("7JHOP")).default,
        isBrowserOnly: true
    });
});
parcelRegister("7JHOP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07f064c629fd32ba$export$2e2bcd8739ae039);
    var $x9xyg;
    var $dJl1T;
    var $jcw0u;
    var $4R6GH;
    var $7f4tk;
    var $8PRuf;
    var $iR3GG;
    var $eJOOa;
    var $ahEft;
    var $9NiTW;
    const $07f064c629fd32ba$var$fetchInsightObjectDetails = async (routeDataContext, routerContext)=>{
        try {
            const { match: { params: params } } = routeDataContext;
            const { objectId: objectId } = params;
            if (objectId == null) return null;
            const workspaceId = await (0, (0, parcelRequire("ahEft")).default)(routeDataContext, routerContext);
            if (workspaceId == null) return null;
            const data = await (0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("eJOOa")).getCmdbObjectByIdUrl)(workspaceId, objectId));
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiReadyMark));
            return data;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jiraServicedeskInsightObjectResource',
                    packageName: 'jiraSpa'
                },
                error: error
            });
            throw error;
        }
    };
    var $07f064c629fd32ba$export$2e2bcd8739ae039 = async (routeDataContext, routerContext)=>{
        const { tenantContext: tenantContext } = routerContext;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsm_throw_error_on_resource_auth_pre-check_failed')) {
            if (!(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext)) throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.servicedesk.cmdb-object.getData',
                message: 'Current user is not authenticated',
                name: 'AuthenticationError',
                skipSentry: true
            });
        } else if (!(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext)) return null;
        return $07f064c629fd32ba$var$fetchInsightObjectDetails(routeDataContext, routerContext);
    };
});
parcelRegister("eJOOa", function(module, exports) {
    $parcel$export(module.exports, "getCmdbObjectByIdUrl", ()=>$bba7f62e646e53a7$export$d33c3e25476d091d);
    $parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", ()=>$bba7f62e646e53a7$export$6ef8997552257871);
    $parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", ()=>$bba7f62e646e53a7$export$20c207abffb62450);
    $parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", ()=>$bba7f62e646e53a7$export$31df868d16d545f8);
    $parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", ()=>$bba7f62e646e53a7$export$5044a1e9fc201773);
    $parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", ()=>$bba7f62e646e53a7$export$d7f6dc1d4f622458);
    $parcel$export(module.exports, "getCmdbObjectCreateUrl", ()=>$bba7f62e646e53a7$export$9cdc19e8944d38cf);
    $parcel$export(module.exports, "getCmdbObjectNavlistUrl", ()=>$bba7f62e646e53a7$export$bf9c534c2cd21829);
    $parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", ()=>$bba7f62e646e53a7$export$b35334340ee827fa);
    $parcel$export(module.exports, "getCmdbObjectRecentUrl", ()=>$bba7f62e646e53a7$export$a0a7c6f22bebdef0);
    $parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", ()=>$bba7f62e646e53a7$export$ee74f95a469c4433);
    $parcel$export(module.exports, "getCmdbObjectSearchUrl", ()=>$bba7f62e646e53a7$export$1016ae73c04d9079);
    $parcel$export(module.exports, "getCmdbAttributeSearchUrl", ()=>$bba7f62e646e53a7$export$cb41514f2508b033);
    $parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", ()=>$bba7f62e646e53a7$export$84a34ee3f18e226);
    $parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", ()=>$bba7f62e646e53a7$export$878b627ac685384e);
    $parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", ()=>$bba7f62e646e53a7$export$8eb3a6b36886db0);
    $parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", ()=>$bba7f62e646e53a7$export$b02201bcaeb75291);
    $parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", ()=>$bba7f62e646e53a7$export$f4d68a6f0e3217b5);
    var $ebyGx = parcelRequire("ebyGx");
    var $klJ8b;
    const $bba7f62e646e53a7$var$getCmdbObjectUrl = (workspaceId)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/object`;
    const $bba7f62e646e53a7$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
        const path = $bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId);
        if (!includeExtendedInfo) return `${path}?${(0, $ebyGx.stringify)({
            includeExtendedInfo: includeExtendedInfo
        })}`;
        return path;
    };
    const $bba7f62e646e53a7$export$6ef8997552257871 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
    const $bba7f62e646e53a7$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
    const $bba7f62e646e53a7$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
    const $bba7f62e646e53a7$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
    const $bba7f62e646e53a7$export$9cdc19e8944d38cf = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/create`;
    const $bba7f62e646e53a7$export$bf9c534c2cd21829 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/navlist`;
    const $bba7f62e646e53a7$export$b35334340ee827fa = (workspaceId)=>`${$bba7f62e646e53a7$export$bf9c534c2cd21829(workspaceId)}/aql`;
    const $bba7f62e646e53a7$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$ee74f95a469c4433 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
    const $bba7f62e646e53a7$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$878b627ac685384e = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
    const $bba7f62e646e53a7$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$b02201bcaeb75291 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
    const $bba7f62e646e53a7$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;
});
parcelRegister("klJ8b", function(module, exports) {
    $parcel$export(module.exports, "getCmdbRestBaseUrl", ()=>$a22cc15ea8014e15$export$28b6c003daedf1c2);
    const $a22cc15ea8014e15$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;
});
parcelRegister("5Bl21", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("95JPD").then(()=>parcelRequire('cKWhs'));
});
parcelRegister("YkbdD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hloRW")
    ]).then(()=>parcelRequire('2lY4S'));
});
parcelRegister("5A72l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aHtXH")
    ]).then(()=>parcelRequire('cB0p5'));
});
parcelRegister("eOYiU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cTSd1")
    ]).then(()=>parcelRequire('9imjS'));
});
parcelRegister("8oQUA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8VYTt")
    ]).then(()=>parcelRequire('8V2Yz'));
});
parcelRegister("ylQhQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6kkfK")
    ]).then(()=>parcelRequire('ciybC'));
});
parcelRegister("c3dxs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jCYvk")
    ]).then(()=>parcelRequire('hEchH'));
});
parcelRegister("hpGQh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("i8SQL")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jluSR")
    ]).then(()=>parcelRequire('7Jr0E'));
});
parcelRegister("5tvXj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("838D9")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hWDKD")
    ]).then(()=>parcelRequire('imnQf'));
});
parcelRegister("3pzt9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("740y2").then(()=>parcelRequire('3hX8x'));
});
parcelRegister("fcMlY", function(module, exports) {
    $parcel$export(module.exports, "entitlementsCustomerQueryResource", ()=>$b3b86d13796012d4$export$78737979422d6907);
    var $ao2h1;
    var $3KdBC;
    const $b3b86d13796012d4$export$78737979422d6907 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ENTITLEMENTS_CUSTOMER_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("3KdBC")).default),
                variables: {
                    accountId: String(match.params.customerId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("3KdBC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$234ef4e6f5c8b134$export$2e2bcd8739ae039);
    const $234ef4e6f5c8b134$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v3 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v5 = [
            {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "ScalarField",
            "name": "id"
        }, v8 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v9 = [
            v7,
            v6
        ], v10 = {
            "kind": "InlineFragment",
            "selections": [
                v7
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "entitlementsCustomerQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v2,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v3,
                                        "concreteType": "CustomerServiceProductConnection",
                                        "kind": "LinkedField",
                                        "name": "productConnections",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CustomerServiceProductEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceProduct",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4
                                                            ]
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "customerService.productConnections.edges"
                                            }
                                        ],
                                        "storageKey": "productConnections(first:1)"
                                    },
                                    "action": "THROW",
                                    "path": "customerService.productConnections"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5,
                                        "kind": "LinkedField",
                                        "name": "individualByAccountId",
                                        "plural": false,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v6,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7,
                                                        "action": "THROW",
                                                        "path": "customerService.individualByAccountId.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CustomerServiceEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlementList",
                                                            "plural": true,
                                                            "selections": [
                                                                v7,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "includeEntityTypeName",
                                                                            "value": true
                                                                        }
                                                                    ],
                                                                    "kind": "FragmentSpread",
                                                                    "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "customerService.individualByAccountId.entitlementList"
                                                    },
                                                    v8
                                                ],
                                                "type": "CustomerServiceIndividual"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.individualByAccountId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "entitlementsCustomerQuery",
                "selections": [
                    {
                        "args": v2,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v7
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "productConnections(first:1)"
                            },
                            {
                                "args": v5,
                                "kind": "LinkedField",
                                "name": "individualByAccountId",
                                "plural": false,
                                "selections": [
                                    v4,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v6,
                                            v7,
                                            {
                                                "concreteType": "CustomerServiceEntitlement",
                                                "kind": "LinkedField",
                                                "name": "entitlementList",
                                                "plural": true,
                                                "selections": [
                                                    v7,
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "product",
                                                        "plural": false,
                                                        "selections": v9
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "entity",
                                                        "plural": false,
                                                        "selections": [
                                                            v4,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9,
                                                                "type": "CustomerServiceOrganization"
                                                            },
                                                            v10
                                                        ]
                                                    }
                                                ]
                                            },
                                            v8
                                        ],
                                        "type": "CustomerServiceIndividual"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v4,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "statusCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "errorType"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "QueryError"
                                    },
                                    v10
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
                "metadata": {},
                "name": "entitlementsCustomerQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $234ef4e6f5c8b134$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
    var $234ef4e6f5c8b134$export$2e2bcd8739ae039 = $234ef4e6f5c8b134$var$node;
});
parcelRegister("4lqmX", function(module, exports) {
    $parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", ()=>$bb7f2c1b84275683$export$d766b4bd7ad23814);
    var $ao2h1;
    var $bvCOc;
    const $bb7f2c1b84275683$export$d766b4bd7ad23814 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("bvCOc")).default),
                variables: {
                    accountId: String(match.params.customerId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("bvCOc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb866aea27d5a9be$export$2e2bcd8739ae039);
    const $eb866aea27d5a9be$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "1258d3244f4ada1c9a11aa7b81632c4706c41bef3110bbfaff26f94c93a1ee49",
            "metadata": {},
            "name": "uiCustomerDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $eb866aea27d5a9be$export$2e2bcd8739ae039 = $eb866aea27d5a9be$var$node;
});
parcelRegister("aqQrr", function(module, exports) {
    $parcel$export(module.exports, "servicedeskCustomersV2Route", ()=>$2cd6e21d82e9c391$export$89e9e350610ee31e);
    $parcel$export(module.exports, "servicedeskCustomerDetailsRoute", ()=>$2cd6e21d82e9c391$export$42c0f04d04ecd1f8);
    var $65Ltd;
    const $2cd6e21d82e9c391$export$89e9e350610ee31e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/customers',
        exact: true
    };
    const $2cd6e21d82e9c391$export$42c0f04d04ecd1f8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
        exact: true
    };
});
parcelRegister("22OMj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iWLC2")
    ]).then(()=>parcelRequire('dKNUD'));
});
parcelRegister("kEVl8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9m8WM")
    ]).then(()=>parcelRequire('eRp4S'));
});
parcelRegister("3e6VG", function(module, exports) {
    $parcel$export(module.exports, "projectServiceDeskRoute", ()=>$b4bfd79e01394a60$export$1cfc858068dd8718);
    var $65Ltd;
    const $b4bfd79e01394a60$export$1cfc858068dd8718 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REDIRECT),
        path: '/jira/servicedesk/projects/:projectKey',
        exact: true
    };
});
parcelRegister("em9Nv", function(module, exports) {
    $parcel$export(module.exports, "gspPageRoute", ()=>$668794df3079bf62$export$23f42abb017854bb);
    var $65Ltd;
    const $668794df3079bf62$export$23f42abb017854bb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
        path: '/jira/servicedesk/projects/:projectKey/getting-started',
        exact: true
    };
});
parcelRegister("kPaTc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("i3L0u")
    ]).then(()=>parcelRequire('8Xvm1'));
});
parcelRegister("6xxAH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1hp0c").then(()=>parcelRequire('5eXru'));
});
parcelRegister("jIAHH", function(module, exports) {
    $parcel$export(module.exports, "AsyncKbNav", ()=>$22359123c06ce2f3$export$223f755b7799fe02);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $22359123c06ce2f3$var$LazyKbNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aRGUb")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
    });
    const $22359123c06ce2f3$export$223f755b7799fe02 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-kb-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($22359123c06ce2f3$var$LazyKbNav, null));
});
parcelRegister("aRGUb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dqfnF").then(()=>parcelRequire('gaKUF'));
});
parcelRegister("cp8Sv", function(module, exports) {
    $parcel$export(module.exports, "getKnowledgeHubBaseUrl", ()=>$63e01e761a94856d$export$1fe78c01c9fe0ebd);
    $parcel$export(module.exports, "knowledgeHubLandingRoute", ()=>$63e01e761a94856d$export$239eaf6a202e0f54);
    $parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", ()=>$63e01e761a94856d$export$c8e99e3434791c0e);
    $parcel$export(module.exports, "knowledgeHubDraftsRoute", ()=>$63e01e761a94856d$export$670f3b59aa55b7ae);
    $parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", ()=>$63e01e761a94856d$export$256f841794b3f077);
    $parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", ()=>$63e01e761a94856d$export$54edf5cef1c6b21b);
    $parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", ()=>$63e01e761a94856d$export$ef8a9ec2979d1b10);
    $parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", ()=>$63e01e761a94856d$export$bd512c426b095693);
    $parcel$export(module.exports, "knowledgeHubAllArticlesRoute", ()=>$63e01e761a94856d$export$20e57a83f181da7b);
    $parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", ()=>$63e01e761a94856d$export$3afe8482ce820835);
    $parcel$export(module.exports, "knowledgeHubCategoryPageRoute", ()=>$63e01e761a94856d$export$79fb48a07e43639a);
    $parcel$export(module.exports, "knowledgeHubCategoryRoute", ()=>$63e01e761a94856d$export$69ed5b0214ea6ee5);
    $parcel$export(module.exports, "knowledgeHubSearchRoute", ()=>$63e01e761a94856d$export$a47c36fb081b544d);
    $parcel$export(module.exports, "knowledgeHubSetupRoute", ()=>$63e01e761a94856d$export$f20770545704547d);
    var $65Ltd;
    const $63e01e761a94856d$export$1fe78c01c9fe0ebd = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge`;
    const $63e01e761a94856d$export$239eaf6a202e0f54 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/knowledge',
        exact: true
    };
    const $63e01e761a94856d$export$c8e99e3434791c0e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
        exact: true
    };
    const $63e01e761a94856d$export$670f3b59aa55b7ae = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
        exact: true
    };
    const $63e01e761a94856d$export$256f841794b3f077 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
        exact: true
    };
    const $63e01e761a94856d$export$54edf5cef1c6b21b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
        exact: true
    };
    const $63e01e761a94856d$export$ef8a9ec2979d1b10 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
    };
    const $63e01e761a94856d$export$bd512c426b095693 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
        query: [
            'draftShareId?',
            'topicId?'
        ]
    };
    const $63e01e761a94856d$export$20e57a83f181da7b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
    };
    const $63e01e761a94856d$export$3afe8482ce820835 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
    };
    const $63e01e761a94856d$export$79fb48a07e43639a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
    };
    const $63e01e761a94856d$export$69ed5b0214ea6ee5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
    };
    const $63e01e761a94856d$export$a47c36fb081b544d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
    };
    const $63e01e761a94856d$export$f20770545704547d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
    };
});
parcelRegister("iBHYJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4ePds")
    ]).then(()=>parcelRequire('4uyp4'));
});
parcelRegister("fziFe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("aiUKx")
    ]).then(()=>parcelRequire('dseQM'));
});
parcelRegister("dOIFm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("aly08")
    ]).then(()=>parcelRequire('lE3ki'));
});
parcelRegister("jyJvE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7Lxlr")
    ]).then(()=>parcelRequire('kl4T5'));
});
parcelRegister("5mJ01", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("03OxI")
    ]).then(()=>parcelRequire('l54tv'));
});
parcelRegister("aMpsr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("lq9Le")
    ]).then(()=>parcelRequire('baJ3W'));
});
parcelRegister("b1HFH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1phgE")
    ]).then(()=>parcelRequire('gBJGI'));
});
parcelRegister("dChOr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("iFZBi")
    ]).then(()=>parcelRequire('hY7nq'));
});
parcelRegister("1bWBT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6afNs")
    ]).then(()=>parcelRequire('MNfxH'));
});
parcelRegister("jdXuV", function(module, exports) {
    $parcel$export(module.exports, "notificationLogsRoute", ()=>$1d2941a19072c80a$export$c947c80f138bc137);
    var $65Ltd;
    const $1d2941a19072c80a$export$c947c80f138bc137 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS),
        path: '/jira/servicedesk/projects/:projectKey/notification-logs',
        exact: true
    };
});
parcelRegister("kdN12", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("43uod")
    ]).then(()=>parcelRequire('9feT0'));
});
parcelRegister("ehdxd", function(module, exports) {
    $parcel$export(module.exports, "servicedeskOncallScheduleRoute", ()=>$8d97678b34cc700d$export$740e6e5e982b48a9);
    var $65Ltd;
    const $8d97678b34cc700d$export$e05c5e9dacfbd89d = '/jira/servicedesk/projects/:projectKey';
    const $8d97678b34cc700d$export$740e6e5e982b48a9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
        path: `${$8d97678b34cc700d$export$e05c5e9dacfbd89d}/on-call-schedule`,
        exact: true
    };
});
parcelRegister("7v5JQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("aVjGW")
    ]).then(()=>parcelRequire('gjKCT'));
});
parcelRegister("6x0wo", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", ()=>$8bc812ed070bb2a3$export$f3c46a19f3594363);
    var $dIdda = parcelRequire("dIdda");
    const $8bc812ed070bb2a3$var$getDataLoader = ()=>(parcelRequire("6TA4Z"));
    const $8bc812ed070bb2a3$export$f3c46a19f3594363 = (0, $dIdda.createResource)({
        type: (0, $b6a87c89b0762905$export$66d6e1e05866ee2f),
        getKey: ({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            return `extension-${projectKey}`;
        },
        getDataLoader: $8bc812ed070bb2a3$var$getDataLoader,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
const $b6a87c89b0762905$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';
parcelRegister("6TA4Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6fToZ").then(()=>parcelRequire('emXcY'));
});
parcelRegister("jNSqy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4SjA9")
    ]).then(()=>parcelRequire('3BhTj'));
});
parcelRegister("8XgXN", function(module, exports) {
    $parcel$export(module.exports, "entitlementsOrganizationQueryResource", ()=>$275795ce1e7f33fe$export$fead08d66d56688e);
    var $ao2h1;
    var $9NGHY;
    const $275795ce1e7f33fe$export$fead08d66d56688e = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("9NGHY")).default),
                variables: {
                    organizationId: String(match.params.organizationId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("9NGHY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42e659babe89c8d5$export$2e2bcd8739ae039);
    const $42e659babe89c8d5$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "organizationId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = [
            {
                "kind": "Variable",
                "name": "organizationId",
                "variableName": "organizationId"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "name"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "entitlementsOrganizationQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "CustomerServiceProductConnection",
                                        "kind": "LinkedField",
                                        "name": "productConnections",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CustomerServiceProductEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceProduct",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3
                                                            ]
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "customerService.productConnections.edges"
                                            }
                                        ],
                                        "storageKey": "productConnections(first:1)"
                                    },
                                    "action": "THROW",
                                    "path": "customerService.productConnections"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v4,
                                        "kind": "LinkedField",
                                        "name": "organizationByOrganizationId",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v5,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v6,
                                                        "action": "THROW",
                                                        "path": "customerService.organizationByOrganizationId.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CustomerServiceEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlementList",
                                                            "plural": true,
                                                            "selections": [
                                                                v6,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "includeEntityTypeName",
                                                                            "value": false
                                                                        }
                                                                    ],
                                                                    "kind": "FragmentSpread",
                                                                    "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "customerService.organizationByOrganizationId.entitlementList"
                                                    },
                                                    v7
                                                ],
                                                "type": "CustomerServiceOrganization"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.organizationByOrganizationId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "entitlementsOrganizationQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v6
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "productConnections(first:1)"
                            },
                            {
                                "args": v4,
                                "kind": "LinkedField",
                                "name": "organizationByOrganizationId",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5,
                                            v6,
                                            {
                                                "concreteType": "CustomerServiceEntitlement",
                                                "kind": "LinkedField",
                                                "name": "entitlementList",
                                                "plural": true,
                                                "selections": [
                                                    v6,
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "product",
                                                        "plural": false,
                                                        "selections": [
                                                            v6,
                                                            v5
                                                        ]
                                                    }
                                                ]
                                            },
                                            v7
                                        ],
                                        "type": "CustomerServiceOrganization"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "statusCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "errorType"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "QueryError"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v6
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
                "metadata": {},
                "name": "entitlementsOrganizationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $42e659babe89c8d5$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
    var $42e659babe89c8d5$export$2e2bcd8739ae039 = $42e659babe89c8d5$var$node;
});
parcelRegister("iTeMQ", function(module, exports) {
    $parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", ()=>$6f42d74340bbf820$export$ab65064827d1831d);
    var $ao2h1;
    var $hpIsM;
    const $6f42d74340bbf820$export$ab65064827d1831d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("hpIsM")).default),
                variables: {
                    organizationId: String(match.params.organizationId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("hpIsM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8caf12ab702db6$export$2e2bcd8739ae039);
    const $bc8caf12ab702db6$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "organizationId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = [
            {
                "kind": "Variable",
                "name": "organizationId",
                "variableName": "organizationId"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "ScalarField",
            "name": "identifier"
        }, v8 = {
            "kind": "ScalarField",
            "name": "message"
        }, v9 = {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3,
                v4,
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiOrganizationDetailsPageQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "organizationByOrganizationId",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "details",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "CustomerServiceOrganization"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "extensions",
                                                        "plural": true,
                                                        "selections": [
                                                            v4
                                                        ]
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.organizationByOrganizationId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiOrganizationDetailsPageQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "organizationByOrganizationId",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "details",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "CustomerServiceCustomDetailValue",
                                                                "kind": "LinkedField",
                                                                "name": "results",
                                                                "plural": true,
                                                                "selections": [
                                                                    v5,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canEdit"
                                                                    },
                                                                    v6,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "values"
                                                                    },
                                                                    {
                                                                        "concreteType": "CustomerServiceCustomDetailType",
                                                                        "kind": "LinkedField",
                                                                        "name": "type",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v6,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "options"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                        "kind": "LinkedField",
                                                                        "name": "config",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                                "kind": "LinkedField",
                                                                                "name": "styleConfiguration",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "options",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "optionValue"
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "style",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "backgroundColour"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "CustomerServiceCustomDetailValues"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v7,
                                                            v8,
                                                            v9
                                                        ],
                                                        "type": "QueryError"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "CustomerServiceOrganization"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9,
                                            v7,
                                            v8
                                        ],
                                        "type": "QueryError"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a225e51b1ca0507ed6d9b7fea04e9939f9f90322a81d41da48011ddeff62c4d3",
                "metadata": {},
                "name": "uiOrganizationDetailsPageQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $bc8caf12ab702db6$var$node.hash = "8781f4b4eca174196d95ee737ccdc3aa";
    var $bc8caf12ab702db6$export$2e2bcd8739ae039 = $bc8caf12ab702db6$var$node;
});
parcelRegister("9cIRM", function(module, exports) {
    $parcel$export(module.exports, "servicedeskOrganizationsRoute", ()=>$68bc8c78730a3759$export$d4a712c5bc3c3434);
    $parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", ()=>$68bc8c78730a3759$export$eacc4723293cbc36);
    var $65Ltd;
    const $68bc8c78730a3759$export$d4a712c5bc3c3434 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/organizations',
        exact: true
    };
    const $68bc8c78730a3759$export$eacc4723293cbc36 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
        exact: true
    };
});
parcelRegister("bOoEj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("h7cjl")
    ]).then(()=>parcelRequire('e2tYQ'));
});
parcelRegister("3bziv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3OcWv")
    ]).then(()=>parcelRequire('9LQpe'));
});
parcelRegister("2bP5L", function(module, exports) {
    $parcel$export(module.exports, "servicedeskProjectSummaryRoute", ()=>$9bf5e06985e86271$export$a23b752ff24027ae);
    var $65Ltd;
    const $9bf5e06985e86271$export$a23b752ff24027ae = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/summary',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY)
    };
});
parcelRegister("aObDz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gJl2n")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("nwI1a")
    ]).then(()=>parcelRequire('i6ZtS'));
});
parcelRegister("jlOGG", function(module, exports) {
    $parcel$export(module.exports, "newIssueViewLockInStatusResource", ()=>$951713022fad9069$export$647de7516d081bd8);
    $parcel$export(module.exports, "useNewIssueViewLockInStatus", ()=>$951713022fad9069$export$d8ba398930f2f5f);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $951713022fad9069$export$647de7516d081bd8 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("c6e4J")),
        maxAge: Number.MAX_VALUE
    });
    const $951713022fad9069$export$d8ba398930f2f5f = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($951713022fad9069$export$647de7516d081bd8);
        return {
            loading: loading,
            error: error,
            newIssueViewLockedIn: data && data.newIssueViewLockedIn
        };
    };
});
parcelRegister("c6e4J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("83I2X").then(()=>parcelRequire('7JV09'));
});
parcelRegister("aNLeB", function(module, exports) {
    $parcel$export(module.exports, "servicedeskIsItsmProjectResource", ()=>$31e43d0718118496$export$920308cef4e291b1);
    $parcel$export(module.exports, "useIsItsmTemplateProject", ()=>$31e43d0718118496$export$7bb46948fb84f164);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $324W5;
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $31e43d0718118496$var$getDataLoader = ()=>(parcelRequire("MZzq5"));
    const $31e43d0718118496$var$ONE_DAY_IN_MILLIS = 86400000;
    const $31e43d0718118496$export$920308cef4e291b1 = (0, $dIdda.createResource)({
        type: (0, $6249ccfa4eeeb82a$export$543a8644640f4092),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $31e43d0718118496$var$getDataLoader,
        maxAge: $31e43d0718118496$var$ONE_DAY_IN_MILLIS
    });
    const $31e43d0718118496$var$useIsItsmTemplateProjectNew = (projectKey)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($31e43d0718118496$export$920308cef4e291b1, projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined, {
            shouldPrefetch: true
        });
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
    const $31e43d0718118496$var$useIsItsmTemplateProjectOld = (_)=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($31e43d0718118496$export$920308cef4e291b1);
        (0, $5uXOq.useEffect)(()=>{
            if ((data === null || data === undefined) && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
    const $31e43d0718118496$export$7bb46948fb84f164 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('fix_useinitresource_data_bug'), $31e43d0718118496$var$useIsItsmTemplateProjectNew, $31e43d0718118496$var$useIsItsmTemplateProjectOld);
});
const $6249ccfa4eeeb82a$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';
parcelRegister("MZzq5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4CXUh").then(()=>parcelRequire('k9PUn'));
});
parcelRegister("aIkD8", function(module, exports) {
    $parcel$export(module.exports, "customQueueRoute", ()=>$4c49d5efc3cf0837$export$e1fac82ca0b0d637);
    $parcel$export(module.exports, "customPracticeQueueRoute", ()=>$4c49d5efc3cf0837$export$59d0bd42aa07faad);
    var $65Ltd;
    const $4c49d5efc3cf0837$export$e1fac82ca0b0d637 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey?',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $4c49d5efc3cf0837$export$59d0bd42aa07faad = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
});
parcelRegister("6SxPM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b8Jun")
    ]).then(()=>parcelRequire('6o1Xn'));
});
parcelRegister("ajfQi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("j8CYW")
    ]).then(()=>parcelRequire('jFMLI'));
});
parcelRegister("ifEQP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jX3BJ")
    ]).then(()=>parcelRequire('aQuyJ'));
});
parcelRegister("fseMQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("K7eQv")
    ]).then(()=>parcelRequire('3r23L'));
});
parcelRegister("9gDVS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3vo2B")
    ]).then(()=>parcelRequire('6qBzG'));
});
parcelRegister("6d9hm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eRCFp")
    ]).then(()=>parcelRequire('5ou2F'));
});
parcelRegister("diKh2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cFmpd")
    ]).then(()=>parcelRequire('htw0K'));
});
parcelRegister("gcllV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8QnWZ").then(()=>parcelRequire('blyWx'));
});
parcelRegister("hejqw", function(module, exports) {
    $parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", ()=>$ccd9a1a485573887$export$eb2deca89cf3fb61);
    var $dIdda = parcelRequire("dIdda");
    const $ccd9a1a485573887$var$getDataLoader = ()=>(parcelRequire("jfmG6"));
    const $ccd9a1a485573887$export$eb2deca89cf3fb61 = (0, $dIdda.createResource)({
        type: (0, $125270e59037c004$export$73cf43fb073ce577),
        getKey: ()=>'atlassian analytics',
        getDataLoader: $ccd9a1a485573887$var$getDataLoader,
        isBrowserOnly: true
    });
});
const $125270e59037c004$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';
parcelRegister("jfmG6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1fLqt").then(()=>parcelRequire('ghpmF'));
});
parcelRegister("jaWUd", function(module, exports) {
    $parcel$export(module.exports, "servicedeskReportsSummaryRoute", ()=>$6cd4d40658b63531$export$44647b0fd2271ddb);
    $parcel$export(module.exports, "servicedeskReports1Route", ()=>$6cd4d40658b63531$export$f5adfd681a4e85ad);
    $parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", ()=>$6cd4d40658b63531$export$399ef3a2d4288bba);
    $parcel$export(module.exports, "servicedeskReportsWorkloadRoute", ()=>$6cd4d40658b63531$export$ce9b409ccf53e93c);
    $parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", ()=>$6cd4d40658b63531$export$da606765550c7e7);
    $parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", ()=>$6cd4d40658b63531$export$64ae70b2d6b34c4e);
    $parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", ()=>$6cd4d40658b63531$export$22fd25b495033fdf);
    $parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", ()=>$6cd4d40658b63531$export$296aa46068d40f43);
    $parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", ()=>$6cd4d40658b63531$export$1585b6f8f1838e19);
    $parcel$export(module.exports, "servicedeskKbRequestsReports2Route", ()=>$6cd4d40658b63531$export$276e2ed89304d21c);
    $parcel$export(module.exports, "servicedeskReportsCustomEditRoute", ()=>$6cd4d40658b63531$export$3b6b3105a9ef9b83);
    $parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", ()=>$6cd4d40658b63531$export$333e623d5eb41af0);
    $parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", ()=>$6cd4d40658b63531$export$1cfe539c854438e8);
    $parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", ()=>$6cd4d40658b63531$export$eae9a65fe3f035ef);
    $parcel$export(module.exports, "servicedeskReportsCustom4Route", ()=>$6cd4d40658b63531$export$39325072940fb58c);
    $parcel$export(module.exports, "servicedeskReportsTypeRoute", ()=>$6cd4d40658b63531$export$b955ac7f09c5dbb);
    var $65Ltd;
    const $6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
    const $6cd4d40658b63531$var$WORKLOAD_ROUTE_SUFFIX = '/reports/workload';
    const $6cd4d40658b63531$var$ATLASSIAN_ANALYTICS_ROUTE_SUFFIX = '/reports/atlassian-analytics';
    const $6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX = '/reports/custom/:reportId';
    const $6cd4d40658b63531$var$REQUESTS_ROUTE_SUFFIX = '/reports/:reportId(kb-requests-resolved|kb-requests-deflected)';
    const $6cd4d40658b63531$var$TIME_SCALE = '/timescale/:timescaleId';
    const $6cd4d40658b63531$var$SATISFACTION_ROUTE_SUFFIX = '/reports/all-rating';
    const $6cd4d40658b63531$var$ISSUE_KEY = '/:issueKey';
    const $6cd4d40658b63531$export$44647b0fd2271ddb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY),
        path: '(/jira/servicedesk/projects/[^/]+/reports/.+)/summary',
        exact: true
    };
    const $6cd4d40658b63531$export$f5adfd681a4e85ad = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}/reports`,
        exact: true
    };
    const $6cd4d40658b63531$export$399ef3a2d4288bba = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$ATLASSIAN_ANALYTICS_ROUTE_SUFFIX}`,
        exact: true
    };
    const $6cd4d40658b63531$export$ce9b409ccf53e93c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$WORKLOAD_ROUTE_SUFFIX}`,
        exact: true
    };
    const $6cd4d40658b63531$export$da606765550c7e7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$SATISFACTION_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}${$6cd4d40658b63531$var$ISSUE_KEY}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $6cd4d40658b63531$export$64ae70b2d6b34c4e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$SATISFACTION_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}`
    };
    const $6cd4d40658b63531$export$22fd25b495033fdf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$SATISFACTION_ROUTE_SUFFIX}`
    };
    const $6cd4d40658b63531$export$296aa46068d40f43 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$REQUESTS_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}${$6cd4d40658b63531$var$ISSUE_KEY}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $6cd4d40658b63531$export$1585b6f8f1838e19 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$REQUESTS_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}`
    };
    const $6cd4d40658b63531$export$276e2ed89304d21c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$REQUESTS_ROUTE_SUFFIX}`
    };
    const $6cd4d40658b63531$export$3b6b3105a9ef9b83 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX}/edit`
    };
    const $6cd4d40658b63531$export$333e623d5eb41af0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}/reports/custom/new`
    };
    const $6cd4d40658b63531$export$1cfe539c854438e8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}${$6cd4d40658b63531$var$ISSUE_KEY}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $6cd4d40658b63531$export$eae9a65fe3f035ef = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}`
    };
    const $6cd4d40658b63531$export$39325072940fb58c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX}`
    };
    const $6cd4d40658b63531$export$b955ac7f09c5dbb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?`,
        query: [
            'oldIssueView?'
        ]
    };
});
parcelRegister("ldZL8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lssra")
    ]).then(()=>parcelRequire('dp6PR'));
});
parcelRegister("gPETo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ahZ5Q")
    ]).then(()=>parcelRequire('hUapH'));
});
parcelRegister("cRCTf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6sXwS")
    ]).then(()=>parcelRequire('gIY6j'));
});
parcelRegister("4r62a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1v184")
    ]).then(()=>parcelRequire('bYkUJ'));
});
parcelRegister("2EqEW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("hrAxT")
    ]).then(()=>parcelRequire('cOaoL'));
});
parcelRegister("7gVww", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("atEkV")
    ]).then(()=>parcelRequire('i1BaA'));
});
parcelRegister("lNm0S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8831k")
    ]).then(()=>parcelRequire('kXHaM'));
});
parcelRegister("il0ku", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ktADJ")
    ]).then(()=>parcelRequire('exkzN'));
});
parcelRegister("fLZPu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ijyfm")
    ]).then(()=>parcelRequire('hLsyG'));
});
parcelRegister("huJzT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gZXlE")
    ]).then(()=>parcelRequire('bQ0Tt'));
});
parcelRegister("HWK76", function(module, exports) {
    $parcel$export(module.exports, "servicedeskServicesRoute", ()=>$c1c2642725d7bc92$export$4a800381bda6d53c);
    $parcel$export(module.exports, "servicedeskServiceDetailsRoute", ()=>$c1c2642725d7bc92$export$fe5fe00b6d5eab87);
    $parcel$export(module.exports, "servicedeskServiceModalNewRoute", ()=>$c1c2642725d7bc92$export$5b5ea97286af2784);
    $parcel$export(module.exports, "servicedeskServiceModalEditRoute", ()=>$c1c2642725d7bc92$export$319fbbab5eb49cbf);
    $parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", ()=>$c1c2642725d7bc92$export$3210e7c54c21be97);
    $parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", ()=>$c1c2642725d7bc92$export$25e1d58db18a7c8b);
    var $65Ltd;
    const $c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
    const $c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT = '/jira/servicedesk';
    const $c1c2642725d7bc92$var$SERVICE_HASHED_ARI = '/:serviceAri';
    const $c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX = '/services';
    const $c1c2642725d7bc92$var$SERVICE_MODAL_ROUTE_SUFFIX = '/service-modal';
    const $c1c2642725d7bc92$export$4a800381bda6d53c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX}${$c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX}`,
        exact: true
    };
    const $c1c2642725d7bc92$export$fe5fe00b6d5eab87 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX}${$c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX}${$c1c2642725d7bc92$var$SERVICE_HASHED_ARI}`
    };
    const $c1c2642725d7bc92$export$5b5ea97286af2784 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$c1c2642725d7bc92$var$SERVICE_MODAL_ROUTE_SUFFIX}`,
        exact: true
    };
    const $c1c2642725d7bc92$export$319fbbab5eb49cbf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$c1c2642725d7bc92$var$SERVICE_MODAL_ROUTE_SUFFIX}${$c1c2642725d7bc92$var$SERVICE_HASHED_ARI}`
    };
    const $c1c2642725d7bc92$export$3210e7c54c21be97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX}`,
        exact: true,
        meta: {
            reporting: {
                id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT),
                packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    };
    const $c1c2642725d7bc92$export$25e1d58db18a7c8b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX}${$c1c2642725d7bc92$var$SERVICE_HASHED_ARI}`,
        meta: {
            reporting: {
                id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT),
                packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    };
});
parcelRegister("dPmqq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("biuin")
    ]).then(()=>parcelRequire('jBLt3'));
});
parcelRegister("4tHC0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gwvLC")
    ]).then(()=>parcelRequire('cIaZn'));
});
parcelRegister("c3xXH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kRkzv")
    ]).then(()=>parcelRequire('bWPI8'));
});
parcelRegister("3TJga", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6Zzbw")
    ]).then(()=>parcelRequire('9LJAj'));
});
parcelRegister("eOZlH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2tGNS")
    ]).then(()=>parcelRequire('6MNnt'));
});
parcelRegister("04A9b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("hAezd")
    ]).then(()=>parcelRequire('1QgiZ'));
});
parcelRegister("fr1K2", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $7MmCC = parcelRequire("7MmCC");
    var $ftdKz = parcelRequire("ftdKz");
    var $etAYC = parcelRequire("etAYC");
    var $4NkAS = parcelRequire("4NkAS");
    var $b2dLE = parcelRequire("b2dLE");
    var $9SRAA = parcelRequire("9SRAA");
    var $7GWAt = parcelRequire("7GWAt");
    var $b3caba7e25e0a917$var$CLONE_DEEP_FLAG = 1, $b3caba7e25e0a917$var$CLONE_FLAT_FLAG = 2, $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG = 4;
    var $b3caba7e25e0a917$var$omit = $9SRAA(function(object, paths) {
        var result = {};
        if (object == null) return result;
        var isDeep = false;
        paths = $1nIHN(paths, function(path) {
            path = $etAYC(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
        });
        $4NkAS(object, $7GWAt(object), result);
        if (isDeep) result = $7MmCC(result, $b3caba7e25e0a917$var$CLONE_DEEP_FLAG | $b3caba7e25e0a917$var$CLONE_FLAT_FLAG | $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG, $b2dLE);
        var length = paths.length;
        while(length--)$ftdKz(result, paths[length]);
        return result;
    });
    module.exports = $b3caba7e25e0a917$var$omit;
});
parcelRegister("ftdKz", function(module, exports) {
    var $etAYC = parcelRequire("etAYC");
    var $hYfgW = parcelRequire("hYfgW");
    var $8lSJl = parcelRequire("8lSJl");
    var $gzebZ = parcelRequire("gzebZ");
    function $b4343aeaece186b7$var$baseUnset(object, path) {
        path = $etAYC(path, object);
        object = $8lSJl(object, path);
        return object == null || delete object[$gzebZ($hYfgW(path))];
    }
    module.exports = $b4343aeaece186b7$var$baseUnset;
});
parcelRegister("8lSJl", function(module, exports) {
    var $fTwLR = parcelRequire("fTwLR");
    var $dM3Z8 = parcelRequire("dM3Z8");
    function $614abd39878e1d90$var$parent(object, path) {
        return path.length < 2 ? object : $fTwLR(object, $dM3Z8(path, 0, -1));
    }
    module.exports = $614abd39878e1d90$var$parent;
});
parcelRegister("b2dLE", function(module, exports) {
    var $1QOns = parcelRequire("1QOns");
    function $808a8f8fca7f9ff7$var$customOmitClone(value) {
        return $1QOns(value) ? undefined : value;
    }
    module.exports = $808a8f8fca7f9ff7$var$customOmitClone;
});
parcelRegister("3NMrl", function(module, exports) {
    var $i2e26 = parcelRequire("i2e26");
    var $9SRAA = parcelRequire("9SRAA");
    var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
        return object == null ? {} : $i2e26(object, paths);
    });
    module.exports = $2c4b85df1af41471$var$pick;
});
parcelRegister("i2e26", function(module, exports) {
    var $4gaCO = parcelRequire("4gaCO");
    var $fh9gH = parcelRequire("fh9gH");
    function $d2134c8f0f8064b1$var$basePick(object, paths) {
        return $4gaCO(object, paths, function(value, path) {
            return $fh9gH(object, path);
        });
    }
    module.exports = $d2134c8f0f8064b1$var$basePick;
});
parcelRegister("kUr4d", function(module, exports) {
    $parcel$export(module.exports, "createRoot", ()=>$f38e08888af96a1f$export$882461b6382ed46c, (v)=>$f38e08888af96a1f$export$882461b6382ed46c = v);
    var $f38e08888af96a1f$export$882461b6382ed46c;
    var $f38e08888af96a1f$export$757ceba2d55c277e;
    'use strict';
    var $7nsd3 = parcelRequire("7nsd3");
    var $f38e08888af96a1f$var$i;
    $f38e08888af96a1f$export$882461b6382ed46c = $7nsd3.createRoot;
    $f38e08888af96a1f$export$757ceba2d55c277e = $7nsd3.hydrateRoot;
});
parcelRegister("0z6W8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af450dab6fb30b5f$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "updatePageloadName", ()=>$af450dab6fb30b5f$export$d0f99433cd4f4028);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5gx4p;
    var $fe1wc;
    var $tcn7E;
    var $1u4q7;
    var $bFU4G;
    var $9AgLs;
    const $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
    function $af450dab6fb30b5f$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
        const activeInteraction = (0, (0, parcelRequire("bFU4G")).getActiveInteraction)();
        if (activeInteraction && !ufoName) return;
        (0, (0, parcelRequire("9AgLs")).default).current = routeName || null;
        const rate = ufoName ? (0, (0, parcelRequire("fe1wc")).getInteractionRate)(ufoName, 'page_load') : 1;
        const enabledBySamplingRate = (0, (0, parcelRequire("5gx4p")).default)(rate);
        if (enabledBySamplingRate && !activeInteraction) {
            const newId = (0, $7Jxgt.v4)();
            (0, (0, parcelRequire("1u4q7")).DefaultInteractionID).current = newId;
            (0, (0, parcelRequire("bFU4G")).addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, (0, parcelRequire("tcn7E")).getActiveTrace)());
            if (!ufoName) (0, (0, parcelRequire("bFU4G")).addHoldByID)(newId, [], $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME, true);
        } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') (0, (0, parcelRequire("bFU4G")).abort)(activeInteraction.id, 'excluded_by_sampling');
        else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
            (0, (0, parcelRequire("bFU4G")).updatePageLoadInteractionName)(ufoName, routeName);
            (0, (0, parcelRequire("bFU4G")).removeHoldByID)(activeInteraction.id, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME);
        }
    }
    function $af450dab6fb30b5f$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
        const interaction = (0, (0, parcelRequire("bFU4G")).getActiveInteraction)();
        if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
        if (ufoName) {
            const rate = (0, (0, parcelRequire("fe1wc")).getInteractionRate)(ufoName, 'page_load');
            (0, (0, parcelRequire("bFU4G")).updatePageLoadInteractionName)(ufoName, routeName);
            if ((0, (0, parcelRequire("5gx4p")).default)(rate)) (0, (0, parcelRequire("9AgLs")).default).current = ufoName;
            else (0, (0, parcelRequire("bFU4G")).abort)(interaction.id, 'excluded_by_sampling');
        }
        (0, (0, parcelRequire("bFU4G")).removeHoldByID)(interaction.id, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME);
    }
});
parcelRegister("8ApFP", function(module, exports) {
    $parcel$export(module.exports, "routeAnalyticsAttributes", ()=>$a83c9e8eeb3d40c2$export$c71778b3a4356b04);
    var $cfDZ3;
    var $hVf1M;
    const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
        routeName: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getRouteName)
        },
        userLocation: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getUserLocation)
        },
        previousSubProduct: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getPreviousSubProduct)
        },
        isProjectAdmin: {
            enumerable: true,
            get: (0, (0, parcelRequire("hVf1M")).getIsProjectAdmin)
        }
    });
});
parcelRegister("2YzDH", function(module, exports) {
    var $7JoAD = parcelRequire("7JoAD");
    if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
        (parcelRequire("2Geeh"));
        const isDevMode = false;
        (0, $7JoAD.defaults).devtools = isDevMode && (()=>({
                serialize: {
                    replacer: (key, value)=>value instanceof HTMLElement ? {
                            data: {
                                tagName: value.tagName,
                                className: value.className,
                                id: value.id,
                                __SANITIZED__: true
                            },
                            __serializedType__: 'HTMLElement'
                        } : value
                }
            }));
        (0, $7JoAD.defaults).batchUpdates = !false;
        Object.freeze((0, $7JoAD.defaults));
        $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
    }
});
parcelRegister("2Geeh", function(module, exports) {
    const $1f3a8aadd86b4cc5$var$style = document.createElement('style');
    $1f3a8aadd86b4cc5$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
    document.querySelector('head').appendChild($1f3a8aadd86b4cc5$var$style);
});
parcelRegister("frBVt", function(module, exports) {
    $parcel$export(module.exports, "getPlaceholdersFromHTML", ()=>$126443352ff757de$export$9e9f35acc3af3a9a);
    $parcel$export(module.exports, "EntryPointPlaceholderContext", ()=>$126443352ff757de$export$b5b377bb81310c48);
    $parcel$export(module.exports, "EntryPointPlaceholder", ()=>$126443352ff757de$export$db2828f683d11042);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    function $126443352ff757de$export$9e9f35acc3af3a9a() {
        const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
        return new Map(Array.from(placeholders, (el)=>[
                el.dataset.epPlaceholderId,
                el.innerHTML
            ]));
    }
    const $126443352ff757de$export$b5b377bb81310c48 = (0, $5uXOq.createContext)(new Map());
    function $126443352ff757de$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
        const { root: root } = entryPoint;
        const hasMounted = (0, $5uXOq.useRef)(false);
        const placeholders = (0, $5uXOq.useContext)($126443352ff757de$export$b5b377bb81310c48);
        const ssrFallback = placeholders.get(name);
        const [fallback, setFallback] = (0, $5uXOq.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: ssrFallback
            },
            "data-ep-placeholder-id": name
        }));
        const lastOriginalFallback = (0, $5uXOq.useRef)(originalFallback);
        lastOriginalFallback.current = originalFallback;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (hasMounted.current && placeholders.has(name)) {
                placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            }
        }, [
            entryPoint,
            name,
            placeholders,
            setFallback
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onComplete = ()=>{
                if (placeholders.has(name)) placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            };
            const unsubscribe = root.onComplete(onComplete, onComplete);
            return ()=>{
                unsubscribe();
                onComplete();
            };
        }, [
            name,
            placeholders,
            root
        ]);
        (0, $5uXOq.useEffect)(()=>{
            hasMounted.current = true;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: fallback,
            name: name,
            ...placeholderProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-ep-placeholder-id": name
        }, children));
    }
});
parcelRegister("7bkFJ", function(module, exports) {
    $parcel$export(module.exports, "initPlatformFeatureFlags", ()=>$fef4d3d4b4c51b47$export$2d291317456ada16);
    var $VSDnB;
    var $4R6GH;
    var $co1wz;
    const $fef4d3d4b4c51b47$export$2d291317456ada16 = ([isOverride, resolver])=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('fix_jira_ssr_platform_ff_oxim4')) (0, (0, parcelRequire("VSDnB")).setBooleanFeatureFlagResolver)((flagKey)=>isOverride(flagKey) ? resolver(flagKey) : (0, (0, parcelRequire("4R6GH")).fg)(flagKey) || (0, (0, parcelRequire("co1wz")).ff)(flagKey));
    };
});
parcelRegister("fz3fB", function(module, exports) {
    $parcel$export(module.exports, "NonCritical", ()=>$a1827329dcbac5c8$export$20fd89b1bf707b1a);
    $parcel$export(module.exports, "default", ()=>$a1827329dcbac5c8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $6yXtV;
    const $a1827329dcbac5c8$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
        const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (timerThreshold != null) setTimeout(()=>{
                setHasThresholdTimerExpired(true);
            }, timerThreshold);
        }, [
            timerThreshold
        ]);
        if (!isFirstRun || isReady || hasThresholdTimerExpired) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        }
        return null;
    };
    const $a1827329dcbac5c8$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$export$83d969795398ec56, props));
    const $a1827329dcbac5c8$var$NonCriticalComponent = (props)=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
        if (!isFirstRun || isReady) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        }
        return null;
    };
    const $a1827329dcbac5c8$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$var$NonCriticalComponent, props));
    var $a1827329dcbac5c8$export$2e2bcd8739ae039 = $a1827329dcbac5c8$var$NonCriticalComponent;
});
parcelRegister("6yXtV", function(module, exports) {
    $parcel$export(module.exports, "useSpaStatePageReady", ()=>$44de65c7edb80809$export$ea2491906b753456);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$44de65c7edb80809$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$44de65c7edb80809$export$41e70078eeddaddc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $7JoAD = parcelRequire("7JoAD");
    var $4oDnX;
    var $7w9eZ;
    const $44de65c7edb80809$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        return {
            isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
        };
    };
    const $44de65c7edb80809$export$ea2491906b753456 = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $44de65c7edb80809$export$e6897aa59ee7aee5
    });
    const $44de65c7edb80809$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady
            }));
    const $44de65c7edb80809$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady,
                args: comparer
            }));
});
parcelRegister("gAeCk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5368db3a32c0eb20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $x9xyg;
    const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
        const renderRef = (0, $5uXOq.useRef)(false);
        if (!renderRef.current) {
            renderRef.current = true;
            (0, (0, parcelRequire("x9xyg")).setMark)(metricKey);
            onSet && onSet();
        }
        return null;
    };
    var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;
});
parcelRegister("erCTW", function(module, exports) {
    $parcel$export(module.exports, "PageContainer", ()=>$a81b2dc7c8e9cabb$export$5f86df0ee0a255b5);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $gAeCk;
    var $39xOx;
    var $7XYc4;
    var $4R6GH;
    var $14V0U;
    var $g7crU;
    var $jHXUj;
    var $aKiiD;
    var $cPiXk;
    var $3HwlS;
    var $iqLcb;
    var $16YKp;
    var $cOwuh;
    var $iXVV6;
    var $3Uek9;
    var $6ncxj;
    var $2SVPM;
    var $gmCnE;
    var $kc9FZ;
    var $6DLIs;
    var $62C9r;
    var $4s15Z;
    var $eF0qp;
    var $gxCm0;
    var $lvpKt;
    var $8Ceqd;
    const $a81b2dc7c8e9cabb$var$mainWrapperStyles = {
        root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
        themed: "_11q7mmei _11q31r52"
    };
    const $a81b2dc7c8e9cabb$var$ROOT_TEST_ID = 'page-layout.root';
    const $a81b2dc7c8e9cabb$var$MAIN_TEST_ID = 'page-layout.main';
    const $a81b2dc7c8e9cabb$var$PageContainerNew = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
        const [isFullscreen] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        const { hasTheming: hasTheming } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, (0, parcelRequire("16YKp")).useBannerJsmPackagingUpdates)();
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
        }, []);
        const mainWrapper = (content)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Main), {
                isFixed: true,
                testId: $a81b2dc7c8e9cabb$var$MAIN_TEST_ID
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    $a81b2dc7c8e9cabb$var$mainWrapperStyles.root,
                    hasTheming && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themed
                ])
            }, isJsmPackagingUpdatesEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), content));
        const showBanner = !isChromeless && !isFullscreen;
        const showTopNav = !isChromeless && !isFullscreen;
        const showSidebar = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_remove_internal_sidenav_state_hook') ? !isChromeless && !isFullscreen : !isChromeless && ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') || !isFullscreen);
        const showHorizontalNav = !isChromeless;
        const showRightSidebar = !isChromeless && !isFullscreen;
        const showLayoutRemoteStateUpdater = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_remove_internal_sidenav_state_hook') ? !isChromeless && !isFullscreen : !isChromeless && ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') || !isFullscreen);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ceqd")).ThemeSetter), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DLIs")).GlobalContainers), {
            id: id,
            locale: locale,
            baseUrl: baseUrl,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
            onSet: pageContainerPerformanceTiming
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "navigationNext"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).PageLayout), {
            skipLinksLabel: "",
            testId: $a81b2dc7c8e9cabb$var$ROOT_TEST_ID
        }, showBanner && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "banner",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gmCnE")).Banner), null)), showTopNav && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "top-nav",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxCm0")).TopNav), null)), showSidebar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "sidebar",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF0qp")).Sidebar), null)), mainWrapper((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showHorizontalNav && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62C9r")).HorizontalNav), null), children)), showRightSidebar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "right-sidebar",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4s15Z")).RightSidebar), null)), showLayoutRemoteStateUpdater && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            packageName: "jiraPageContainerV2",
            id: "layout-remote-state-updater",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHXUj")).LayoutRemoteStateUpdater), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kc9FZ")).GlobalComponents), {
            sharedGlobalComponents: (0, (0, parcelRequire("6ncxj")).sharedLayout).globalComponents
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKiiD")).GlobalBottomRightCornerContainer), null))));
    };
    const $a81b2dc7c8e9cabb$var$PageContainerOld = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, (0, parcelRequire("16YKp")).useBannerJsmPackagingUpdates)();
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
        }, []);
        let contentChildren = isJsmPackagingUpdatesEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (HorizontalNavComponent != null) contentChildren = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62C9r")).HorizontalNavWrapper), {
            navComponent: HorizontalNavComponent
        }, isJsmPackagingUpdatesEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), children);
        const panelContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvpKt")).FullHeight), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).PageLayout), {
            skipLinksLabel: ""
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "banner",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gmCnE")).Banner), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "top-nav",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxCm0")).TopNav), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).LeftPanel), {
            width: 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Content), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "sidebar",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF0qp")).Sidebar), null)), contentChildren, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "right-sidebar",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4s15Z")).RightSidebar), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            packageName: "page-container",
            id: "layout-remote-state-updater",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHXUj")).LayoutRemoteStateUpdater), null)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kc9FZ")).GlobalComponents), {
            sharedGlobalComponents: (0, (0, parcelRequire("6ncxj")).sharedLayout).globalComponents
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKiiD")).GlobalBottomRightCornerContainer), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ceqd")).ThemeSetter), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DLIs")).GlobalContainers), {
            id: id,
            locale: locale,
            baseUrl: baseUrl,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
            onSet: pageContainerPerformanceTiming
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "navigationNext"
        }, panelContent)));
    };
    const $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $a81b2dc7c8e9cabb$var$PageContainerNew, $a81b2dc7c8e9cabb$var$PageContainerOld);
});
parcelRegister("14V0U", function(module, exports) {
    $parcel$export(module.exports, "useIsChromeless", ()=>$96950c90e73fdad9$export$c88b74884f5222ba);
    var $7JoAD = parcelRequire("7JoAD");
    var $5e5zm;
    const $96950c90e73fdad9$export$c88b74884f5222ba = (0, $7JoAD.createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.isChromeless
    });
});
parcelRegister("g7crU", function(module, exports) {
    $parcel$export(module.exports, "useIsFullscreen", ()=>$aa937e51388f56fd$export$d397eccea5f37b0a);
    var $7JoAD = parcelRequire("7JoAD");
    var $5e5zm;
    const $aa937e51388f56fd$export$d397eccea5f37b0a = (0, $7JoAD.createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.isFullscreen
    });
});
parcelRegister("jHXUj", function(module, exports) {
    $parcel$export(module.exports, "LayoutRemoteStateUpdater", ()=>$89937a782c6cb988$export$b9f3a70460995c32);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $7XYc4;
    var $cSD7y;
    var $3HwlS;
    var $iqLcb;
    var $c34Wf;
    var $90yGq;
    var $dIdda = parcelRequire("dIdda");
    var $5e5zm;
    var $cUwjE;
    var $gPQRI;
    var $hsmeR;
    var $2TwSO;
    const $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld = ()=>{
        const { leftSidebarState: leftSidebarState } = (0, (0, parcelRequire("iqLcb")).usePageLayoutResize)();
        const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
        const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, (0, parcelRequire("5e5zm")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
        const rightSidebarState = (0, (0, parcelRequire("hsmeR")).useRightSidebarState)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("c34Wf")).navigationUiStateResource));
        const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
        (0, $5uXOq.useEffect)(()=>{
            if (!isLayoutStateReady) return;
            if (error) return;
            setLeftSidebarState({
                width: resolvedLeftSidebarWidth,
                isCollapsed: isCollapsed,
                isFlyoutOpen: isFlyoutOpen,
                isVisible: true
            });
        }, [
            error,
            isCollapsed,
            isFlyoutOpen,
            isLayoutStateReady,
            resolvedLeftSidebarWidth,
            setLeftSidebarState
        ]);
        const updateData = (0, $5uXOq.useCallback)(async ()=>{
            if (loading) return;
            if (error) return;
            if (!isLayoutStateReady) return;
            const remoteData = {
                ...data,
                leftSidebar: {
                    width: resolvedLeftSidebarWidth,
                    isCollapsed: isLeftSidebarCollapsed
                },
                rightSidebar: rightSidebarState
            };
            if (accountId) try {
                await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e,
                    meta: {
                        id: 'updateServerLayoutState',
                        packageName: 'jiraLayoutController',
                        teamName: 'magma'
                    }
                });
            }
        }, [
            accountId,
            data,
            error,
            isLayoutStateReady,
            isLeftSidebarCollapsed,
            loading,
            resolvedLeftSidebarWidth,
            rightSidebarState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            updateData();
        }, [
            isLeftSidebarCollapsed,
            resolvedLeftSidebarWidth,
            updateData
        ]);
        return null;
    };
    const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew1 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const leftSidebar = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const rightSidebar = (0, (0, parcelRequire("hsmeR")).useRightSidebarState)();
        const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
        const leftSidebarWidth = leftSidebar.width;
        (0, $5uXOq.useEffect)(()=>{
            if (!accountId) return;
            (0, (0, parcelRequire("2TwSO")).setRemoteLayoutState)({
                accountId: accountId,
                state: {
                    rightSidebar: rightSidebar,
                    leftSidebar: {
                        isCollapsed: isLeftSidebarCollapsed,
                        width: leftSidebarWidth
                    }
                }
            });
        }, [
            accountId,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            rightSidebar
        ]);
        return null;
    };
    const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew2 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const leftSidebar = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const rightSidebar = (0, (0, parcelRequire("hsmeR")).useRightSidebarState)();
        const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
        const leftSidebarWidth = leftSidebar.width;
        const { shouldSyncToRemoteState: shouldSyncToRemoteState } = (0, (0, parcelRequire("cUwjE")).useSidebarVisibilitySync)();
        (0, $5uXOq.useEffect)(()=>{
            if (!shouldSyncToRemoteState) return;
            if (!accountId) return;
            (0, (0, parcelRequire("2TwSO")).setRemoteLayoutState)({
                accountId: accountId,
                state: {
                    rightSidebar: rightSidebar,
                    leftSidebar: {
                        isCollapsed: isLeftSidebarCollapsed,
                        width: leftSidebarWidth
                    }
                }
            });
        }, [
            accountId,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            rightSidebar,
            shouldSyncToRemoteState
        ]);
        return null;
    };
    const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_nav4_remove_internal_sidenav_state_hook', $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew1, (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_nav4_beta_drop_1', $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew2, $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew1));
    const $89937a782c6cb988$export$b9f3a70460995c32 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew, $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld);
});
parcelRegister("cUwjE", function(module, exports) {
    $parcel$export(module.exports, "useSidebarVisibilitySync", ()=>$d3d1c1c39150c4aa$export$244508671d733bf1);
    var $5uXOq = parcelRequire("5uXOq");
    var $ecbZX;
    var $g7crU;
    const $d3d1c1c39150c4aa$export$244508671d733bf1 = ()=>{
        const { visibleOnDesktop: visibleOnDesktop, setVisibleOnDesktop: setVisibleOnDesktop } = (0, (0, parcelRequire("ecbZX")).useSideNavVisibility)();
        const wasVisibleOnDesktop = (0, $5uXOq.useRef)(visibleOnDesktop);
        const [isFullscreenLayout] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isFullscreenLayout) wasVisibleOnDesktop.current = visibleOnDesktop;
        }, [
            visibleOnDesktop,
            isFullscreenLayout
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isFullscreenLayout && wasVisibleOnDesktop.current) {
                setVisibleOnDesktop(false);
                return ()=>{
                    setVisibleOnDesktop(true);
                };
            }
        }, [
            isFullscreenLayout,
            setVisibleOnDesktop
        ]);
        return {
            shouldSyncToRemoteState: !isFullscreenLayout && wasVisibleOnDesktop.current === visibleOnDesktop
        };
    };
});
parcelRegister("2TwSO", function(module, exports) {
    $parcel$export(module.exports, "setRemoteLayoutState", ()=>$9d3e8b8a199ea341$export$ad53b565e6cd4261);
    var $89SaW;
    var $jcw0u;
    async function $9d3e8b8a199ea341$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
        try {
            await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(state));
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'jfp-team'
                }
            });
        }
    }
});
parcelRegister("aKiiD", function(module, exports) {
    $parcel$export(module.exports, "GlobalBottomRightCornerContainer", ()=>$1ca472b9239dbdd7$export$715c8d5890c054bb);
    $parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", ()=>$1ca472b9239dbdd7$export$1e86e3484191597c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $l8ruj;
    var $hvrWv;
    var $hsmeR;
    var $5e5zm;
    function $1ca472b9239dbdd7$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
        const [{ width: width }] = (0, (0, parcelRequire("5e5zm")).useDetailPanelWidth)();
        const rightSidebar = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerActions)();
        const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
        const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$var$StyledContainer, {
            ref: registerBottomRightCornerContainer,
            "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
            style: {
                right: `calc(${width + rightOffset + rightSidebarWidth}px + ${"var(--ds-space-300, 24px)"})`,
                bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
            }
        });
    }
    const $1ca472b9239dbdd7$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "bottom-right-corner-container",
            packageName: "jira-bottom-right-corner-controller"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$e112b78171de7a6, {
            bottomOffset: bottomOffset,
            rightOffset: rightOffset
        }));
    const $1ca472b9239dbdd7$export$1e86e3484191597c = ({ children: children })=>{
        const container = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerContainer)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "global-bottom-right-corner"
        }, container && children, (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$715c8d5890c054bb, null));
    };
    const $1ca472b9239dbdd7$var$StyledContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1e0c1txw _1pbyfjpv _1reoewfl _18m9ewfl _4cvresu3 _lcxvglyw",
                __cmplp.className
            ])
        });
    });
    $1ca472b9239dbdd7$var$StyledContainer.displayName = 'StyledContainer';
});
parcelRegister("hvrWv", function(module, exports) {
    $parcel$export(module.exports, "useBottomRightCornerContainer", ()=>$4dcd4c0b25ba3fd4$export$84542488b6b6c309);
    $parcel$export(module.exports, "useBottomRightCornerActions", ()=>$4dcd4c0b25ba3fd4$export$de496fd0e0151c81);
    var $7JoAD = parcelRequire("7JoAD");
    var $5e5zm;
    const $4dcd4c0b25ba3fd4$export$84542488b6b6c309 = (0, $7JoAD.createStateHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.bottomRightCorner.container
    });
    const $4dcd4c0b25ba3fd4$export$de496fd0e0151c81 = (0, $7JoAD.createActionsHook)((0, (0, parcelRequire("5e5zm")).layoutStore));
});
parcelRegister("cPiXk", function(module, exports) {
    $parcel$export(module.exports, "useHorizontalNavComponent", ()=>$2edc33969f533189$export$205771a0e64e4c7c);
    var $l71WK;
    var $2vSU6;
    var $65Ltd;
    var $co1wz;
    var $4R6GH;
    var $14V0U;
    var $3HwlS;
    var $6jY6G;
    var $dAfqg;
    var $c1mlA;
    var $5PD5h;
    var $dIdda = parcelRequire("dIdda");
    const $2edc33969f533189$export$965942f8308cd740 = (0, $dIdda.createRouterSelector)((state)=>(0, (0, parcelRequire("c1mlA")).BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
    const $2edc33969f533189$export$205771a0e64e4c7c = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: projectData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const hasBoardSettingsPageQueryParam = $2edc33969f533189$export$965942f8308cd740();
        if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
            const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
            if (isChromeless) return null;
        }
        if (route.navigation?.horizontal == null) return null;
        if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)) {
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return null;
            switch(projectData?.projectType){
                case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                    return 0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav;
                default:
                    return null;
            }
        }
        if (route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE) && hasBoardSettingsPageQueryParam && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("co1wz")).ff)('simplified-boards-milestone-2_07hbk')) return null;
        if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)) switch(projectData?.projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return 0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav;
                return null;
            default:
                return null;
        }
        if ('onlyShowHorizontalOnNav4' in route.navigation && route.navigation.onlyShowHorizontalOnNav4) return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? route.navigation.horizontal : null;
        if ('horizontalFeatureFlag' in route.navigation) switch(route.navigation.horizontalFeatureFlag){
            case 'jsm_views_of_work_phase_1':
                return (0, (0, parcelRequire("4R6GH")).fg)('jsm_views_of_work_phase_1') ? route.navigation.horizontal : null;
            default:
                {
                    const exhaustiveCheck = route.navigation.horizontalFeatureFlag;
                    return exhaustiveCheck;
                }
        }
        return route.navigation.horizontal;
    };
});
parcelRegister("c1mlA", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", ()=>$4c8f71f257051803$export$128e24da52662cdd);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", ()=>$4c8f71f257051803$export$efdecbe4c9f1cd2c);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION", ()=>$4c8f71f257051803$export$1154ed64d0d99951);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", ()=>$4c8f71f257051803$export$7cadd2a48a9ff918);
    $parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", ()=>$4c8f71f257051803$export$a546b6d48878ce6f);
    $parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", ()=>$4c8f71f257051803$export$8cc83ae2b6885e0);
    $parcel$export(module.exports, "boardSettingsQueryConfigParamValues", ()=>$4c8f71f257051803$export$a9ebdab56bd9c0c3);
    $parcel$export(module.exports, "SETTINGS_CONFIG", ()=>$4c8f71f257051803$export$2a56ee2f9c41b5a7);
    $parcel$export(module.exports, "EDIT_BOARD_CONFIG", ()=>$4c8f71f257051803$export$b893894941c14e43);
    $parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", ()=>$4c8f71f257051803$export$d14d5a7c294329c5);
    $parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", ()=>$4c8f71f257051803$export$1e63b013f0e45de0);
    $parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", ()=>$4c8f71f257051803$export$68030ac1ea4abd4c);
    $parcel$export(module.exports, "BACKLOG_FEATURE_KEY", ()=>$4c8f71f257051803$export$e1671d3447ddd5ad);
    $parcel$export(module.exports, "SPRINTS_FEATURE_KEY", ()=>$4c8f71f257051803$export$46efc2c8d8106cff);
    $parcel$export(module.exports, "FEATURE_ENABLED_STATUS", ()=>$4c8f71f257051803$export$a1046f102eae498);
    const $4c8f71f257051803$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
    const $4c8f71f257051803$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
    const $4c8f71f257051803$export$1154ed64d0d99951 = 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
    const $4c8f71f257051803$export$7cadd2a48a9ff918 = `${$4c8f71f257051803$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
    const $4c8f71f257051803$export$a546b6d48878ce6f = 'Epic';
    const $4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
        'cardColors',
        'cardLayout',
        'columns',
        'default',
        'estimation',
        'filter',
        'swimlanes',
        'time',
        'timelineConfig',
        'quickFilters',
        'dateFields'
    ];
    const $4c8f71f257051803$export$8cc83ae2b6885e0 = new Set($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
    const $4c8f71f257051803$export$a9ebdab56bd9c0c3 = Object.fromEntries($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
            key,
            key
        ]));
    const $4c8f71f257051803$export$2a56ee2f9c41b5a7 = {
        default: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        filter: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        columns: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.columns,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        swimlanes: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.swimlanes,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        quickFilters: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.quickFilters,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        cardColors: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardColors,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        cardLayout: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardLayout,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        estimation: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.estimation,
            jsmAllowed: false,
            userLocatedBoardAllowed: true,
            kanbanAllowed: false
        },
        time: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.time,
            jsmAllowed: false,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        timelineConfig: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.timelineConfig,
            jsmAllowed: false,
            userLocatedBoardAllowed: false,
            kanbanAllowed: true
        },
        dateFields: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.dateFields,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        }
    };
    const $4c8f71f257051803$export$773ca4f5fb67778b = 60000;
    const $4c8f71f257051803$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
    const $4c8f71f257051803$export$d14d5a7c294329c5 = 'ADMINISTER_PARENT_PROJECT';
    const $4c8f71f257051803$export$1e63b013f0e45de0 = 'USER_PICKER';
    const $4c8f71f257051803$export$68030ac1ea4abd4c = 'ADMINISTER';
    const $4c8f71f257051803$export$e1671d3447ddd5ad = 'BACKLOG';
    const $4c8f71f257051803$export$46efc2c8d8106cff = 'SPRINTS';
    const $4c8f71f257051803$export$a1046f102eae498 = 'ENABLED';
    const $4c8f71f257051803$export$450e5ddc9f1ff901 = 'DISABLED';
});
const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';
const $9ccbd88c704da1ef$export$c9e16a15d65437 = 'navigationNext';
const $9ccbd88c704da1ef$export$b1534bc11f201efd = 'jiraPageContainer';
const $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7 = null;
const $9ccbd88c704da1ef$export$aa6008fe0169b864 = null;
const $9ccbd88c704da1ef$export$39418a21fbb51487 = null;
const $9ccbd88c704da1ef$export$7dfef0177e883b05 = 'entry.jira-spa';
const $9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $9ccbd88c704da1ef$export$7114284ca03133ee = `_${$9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK}.end`;
const $9ccbd88c704da1ef$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $9ccbd88c704da1ef$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $9ccbd88c704da1ef$export$e2bc63118050de32 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.start`;
const $9ccbd88c704da1ef$export$59f83d43fe209319 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.end`;
const $9ccbd88c704da1ef$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $9ccbd88c704da1ef$export$c20831be6f780cb5 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.start`;
const $9ccbd88c704da1ef$export$398df1bca49f9884 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.end`;
const $9ccbd88c704da1ef$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $9ccbd88c704da1ef$export$3c2d8af5c7577fe7 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.start`;
const $9ccbd88c704da1ef$export$aac77afee74c49d0 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.end`;
const $9ccbd88c704da1ef$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $9ccbd88c704da1ef$export$16e7ead3a8b5c366 = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.start`;
const $9ccbd88c704da1ef$export$c389f0b50840d5ca = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.end`;
parcelRegister("16YKp", function(module, exports) {
    $parcel$export(module.exports, "useBannerJsmPackagingUpdates", ()=>$32df9c26e8c82916$export$a0dde3f151a99607);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $4R6GH;
    var $6jY6G;
    var $dAfqg;
    var $gzrJT;
    var $90yGq;
    var $l2Uy7;
    const $32df9c26e8c82916$export$a0dde3f151a99607 = ()=>{
        const currentRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const isServiceProject = project?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        const isInJsmBoundary = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("l2Uy7")).isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
            isServiceProject,
            currentRoute.path
        ]);
        const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, (0, parcelRequire("gzrJT")).useJsmRepackagingAnnouncementResource)(accountId);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isInJsmBoundary && shouldShow && (0, (0, parcelRequire("4R6GH")).fg)('jsm-packaging-pricing-changes-announcement'),
                dismissAnnouncement: dismissAnnouncement
            }), [
            dismissAnnouncement,
            isInJsmBoundary,
            shouldShow
        ]);
    };
});
parcelRegister("gzrJT", function(module, exports) {
    $parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", ()=>$e073f4ec0b653e88$export$47d5fef12f2d184b);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $dIdda = parcelRequire("dIdda");
    var $hj0lE;
    const $e073f4ec0b653e88$var$getDataLoader = ()=>(parcelRequire("fjlZb"));
    const $e073f4ec0b653e88$export$750cb6ed3dfc6a3 = (0, $dIdda.createResource)({
        type: 'JSM_REPACKAGING_ANNOUNCEMENT',
        getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
        getDataLoader: $e073f4ec0b653e88$var$getDataLoader,
        maxAge: Infinity
    });
    const $e073f4ec0b653e88$export$47d5fef12f2d184b = (accountId)=>{
        const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $dIdda.useResource)($e073f4ec0b653e88$export$750cb6ed3dfc6a3);
        const loadingRef = (0, $5uXOq.useRef)(false);
        const errorRef = (0, $5uXOq.useRef)();
        const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
        errorRef.current = userPropertiesError || error;
        const dismissAnnouncement = (0, $5uXOq.useCallback)(()=>{
            const announcementDismissState = {
                shouldShow: false
            };
            update(()=>({
                    announcementDismissState: announcementDismissState
                }));
            if (accountId) {
                if (loadingRef.current) {
                    const err = new Error('User properties is loading');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                            teamName: '50cent'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setUserPropertiesError(err);
                    return Promise.reject(err);
                }
                loadingRef.current = true;
                return (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, (0, parcelRequire("hj0lE")).JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                    setUserPropertiesError(new Error('Error occured while setting user properties'));
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                            teamName: '50cent'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    loadingRef.current = false;
                });
            }
        }, [
            accountId,
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            refresh,
            error
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            if (errorRef.current || loading || !data || !accountId) return {
                shouldShow: false,
                dismissAnnouncement: dismissAnnouncement
            };
            const { announcementDismissState: announcementDismissState } = data;
            if (!announcementDismissState) return {
                shouldShow: false,
                dismissAnnouncement: dismissAnnouncement
            };
            return {
                ...announcementDismissState,
                dismissAnnouncement: dismissAnnouncement
            };
        }, [
            loading,
            data,
            accountId,
            dismissAnnouncement
        ]);
    };
});
parcelRegister("hj0lE", function(module, exports) {
    $parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", ()=>$4bad9f9efc7d29c0$export$d2137827dc00e559);
    $parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", ()=>$4bad9f9efc7d29c0$export$341176bfdf8c92);
    const $4bad9f9efc7d29c0$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
    const $4bad9f9efc7d29c0$export$341176bfdf8c92 = {
        shouldShow: true
    };
});
parcelRegister("fjlZb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("37oAo").then(()=>parcelRequire('lGYvJ'));
});
parcelRegister("l2Uy7", function(module, exports) {
    $parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", ()=>$257d172b6cc842a0$export$c28a66ae6d31a34b);
    const $257d172b6cc842a0$var$jsmGlobalSettingsPages = [
        '/jira/settings/products/jira-service-management-configuration',
        '/jira/settings/products/jira-service-management-email-requests',
        '/jira/settings/products/servicedesk/customer-access',
        '/jira/settings/products/servicedesk/authentication',
        '/jira/settings/products/servicedesk/organizations',
        '/jira/settings/products/jira-service-management-incident-management-tools',
        '/jira/settings/products/jira-service-management-compliance',
        '/jira/settings/products/servicedesk/feature-usage'
    ];
    const $257d172b6cc842a0$var$eocGlobalSettingsPages = [
        '/jira/settings/products/ops/roles',
        '/jira/settings/products/ops/role-assignment',
        '/jira/settings/products/ops/role-based-notifications',
        '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
        '/jira/settings/products/ops/integrations',
        '/jira/settings/products/ops/syncs',
        '/jira/settings/products/ops/policies',
        '/jira/settings/products/ops/maintenance',
        '/jira/settings/products/ops/incoming-call',
        '/jira/settings/products/ops/jira-service-management-audit-logs',
        '/jira/settings/products/ops/reports'
    ];
    const $257d172b6cc842a0$var$isJsmGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$jsmGlobalSettingsPages.includes(route);
    const $257d172b6cc842a0$var$isEocGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$eocGlobalSettingsPages.includes(route);
    const $257d172b6cc842a0$export$c28a66ae6d31a34b = (route)=>$257d172b6cc842a0$var$isJsmGlobalSettingsPage(route) || $257d172b6cc842a0$var$isEocGlobalSettingsPage(route);
});
parcelRegister("cOwuh", function(module, exports) {
    $parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", ()=>$5589b5a823eb55d2$export$76c6ab35aee49900);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $5589b5a823eb55d2$var$BannerTransition = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("boNJG")).then((module)=>module.BannerJsmPackagingUpdate), {
        moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
    });
    const $5589b5a823eb55d2$export$76c6ab35aee49900 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-banner-jsm-packaging-updates",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5589b5a823eb55d2$var$BannerTransition, null));
});
parcelRegister("boNJG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3lSYe").then(()=>parcelRequire('kuFA7'));
});
parcelRegister("3Uek9", function(module, exports) {
    $parcel$export(module.exports, "useProjectTheme", ()=>$241dc29db19bb69f$export$18084206b9430153);
    var $l71WK;
    var $65Ltd;
    var $8iyFV;
    var $cPiXk;
    var $3HwlS;
    var $6jY6G;
    var $5PD5h;
    const $241dc29db19bb69f$export$18084206b9430153 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        const isBusinessRouteGroup = route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS);
        const hasProjectViewNavigation = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? HorizontalNavComponent != null : HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans);
        const hasTheming = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav) || route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE) : hasProjectViewNavigation;
        const isInset = hasTheming && !isBusinessRouteGroup;
        return {
            isInset: isInset,
            hasTheming: hasTheming,
            hasProjectViewNavigation: hasProjectViewNavigation
        };
    };
});
parcelRegister("6ncxj", function(module, exports) {
    $parcel$export(module.exports, "sharedLayout", ()=>$1b12ea52aa3c0323$export$5f4dc7c98070d93e);
    var $5uXOq = parcelRequire("5uXOq");
    var $doxsH;
    var $2vSU6;
    var $8JIza;
    var $gmGW3;
    var $8NA5p;
    var $7kqCT;
    var $7jo2g;
    var $7XluA;
    var $4mO32;
    var $7N30e;
    var $6s1PB;
    var $co1wz;
    var $7XYc4;
    var $cSD7y;
    var $4R6GH;
    var $3lMZZ;
    var $7Lkcv;
    var $9YvQF;
    var $km1Z8;
    var $e1ETT;
    var $aqDVH;
    var $lpwtK;
    var $jElqQ;
    var $kKa8l;
    var $bmetd;
    var $izgL1;
    var $lyCmi;
    var $1XrjK;
    var $kgLzl;
    var $dYRe6;
    var $koeKL;
    var $dz0Q5;
    var $kXv2J;
    var $4p6rw;
    var $kxZPA;
    var $ec3NH;
    var $lDu2T;
    var $jnXgM;
    const $1b12ea52aa3c0323$var$isTrialEndLockScreenExperimentEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-trial-end-lock-screen-experiment_nowmr') || (0, (0, parcelRequire("co1wz")).ff)('jpd-trial-end-lock-screen-experiment');
    const $1b12ea52aa3c0323$var$isPendoIntegrationEnabled = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira-frontend-pendo-analytics_s6sj5');
    const $1b12ea52aa3c0323$var$Global = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("EgodS")), {
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
    });
    const $1b12ea52aa3c0323$var$Navigation = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("aQHAS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
    });
    const $1b12ea52aa3c0323$var$Trackers = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("i1RfD")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
    });
    const $1b12ea52aa3c0323$var$RemoteActions = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("iRWz9")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
    });
    const $1b12ea52aa3c0323$var$AfterPaintIssuePreEval = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("D2tCn")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/index.tsx"
    });
    const $1b12ea52aa3c0323$var$AsyncBrowserStorageControlsInit = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("lGCVr")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
    });
    const $1b12ea52aa3c0323$var$runtimeProps = {};
    const $1b12ea52aa3c0323$var$entryPointParams = {};
    const $1b12ea52aa3c0323$export$70b554b486395223 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kXv2J")).upgradeOnboardingExperimentEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.upgradeOnboardingExperiment",
            packageName: "issue-view",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
        });
    };
    const $1b12ea52aa3c0323$export$3859d35c5447350b = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kgLzl")).rovoVideoModalEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.rovoVideoPlayer",
            packageName: "rovo-video-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
        });
    };
    const $1b12ea52aa3c0323$export$3211958f96133af8 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aqDVH")).jiraLossAversionModalEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.jiraLossAversion",
            packageName: "jira-loss-aversion-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
        });
    };
    const $1b12ea52aa3c0323$export$bb0d8fff645668ce = ()=>{
        const cloudID = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project?.type) || null;
        const productKey = (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)(projectType);
        const deferEditionModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudID,
                productKey: productKey
            }), [
            cloudID,
            productKey
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7kqCT")).jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
        const onComplete = (0, $5uXOq.useCallback)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NA5p")).AsyncDeferEditionEPCheckWrapper), {
            onComplete: onComplete
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.jiraDeferEditionModal",
            packageName: "jira-defer-edition-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
        }));
    };
    const $1b12ea52aa3c0323$var$DeferEditionModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('cross-flow-defer-edition-communication-gate', $1b12ea52aa3c0323$export$bb0d8fff645668ce, ()=>null);
    const $1b12ea52aa3c0323$var$DeferRovoVideoModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('rovo_video_player_gate', $1b12ea52aa3c0323$export$3859d35c5447350b, ()=>null);
    const $1b12ea52aa3c0323$var$DeferJiraLossAversionModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_loss_aversion_standard_shared_layout_gate', $1b12ea52aa3c0323$export$3211958f96133af8, ()=>null);
    const $1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, (0, parcelRequire("lyCmi")).AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
    $1b12ea52aa3c0323$var$DeferEditionModal.displayName = 'DeferEditionModal';
    $1b12ea52aa3c0323$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
    $1b12ea52aa3c0323$var$DeferJiraLossAversionModal.displayName = 'DeferJiraLossAversionModal';
    $1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
    const $1b12ea52aa3c0323$var$sharedGlobalComponents = [
        ...false ? [] : [
            (0, (0, parcelRequire("kKa8l")).MatchedRouteListener),
            (0, (0, parcelRequire("bmetd")).PreviousRouterStateListener),
            (0, (0, parcelRequire("lDu2T")).LoadingPhaseManager),
            (0, (0, parcelRequire("3lMZZ")).LoadingBarUIController),
            (0, (0, parcelRequire("doxsH")).default),
            (0, (0, parcelRequire("ec3NH")).BreadcrumbAdapter),
            (0, (0, parcelRequire("izgL1")).default),
            (0, (0, parcelRequire("jElqQ")).PageDwellAnalyticsListener),
            (0, (0, parcelRequire("km1Z8")).ImperativeAPI),
            (0, (0, parcelRequire("jnXgM")).TrackClicksBeforeTTI),
            (0, (0, parcelRequire("dYRe6")).default),
            (0, (0, parcelRequire("dz0Q5")).AsyncUpflowIframeComponent),
            (0, (0, parcelRequire("4p6rw")).JiraHeritageLoader),
            $1b12ea52aa3c0323$var$AsyncBrowserStorageControlsInit,
            ...$1b12ea52aa3c0323$var$isPendoIntegrationEnabled() ? [
                (0, (0, parcelRequire("8JIza")).AsyncPendoAnalyticsWrapper)
            ] : [],
            (0, (0, parcelRequire("7N30e")).default),
            $1b12ea52aa3c0323$var$RemoteActions,
            ...$1b12ea52aa3c0323$var$isTrialEndLockScreenExperimentEnabled() ? [
                (0, (0, parcelRequire("e1ETT")).AsyncLockScreenExperimentSharedWrapper)
            ] : [],
            (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_upgrade_onboarding'), $1b12ea52aa3c0323$export$70b554b486395223, ()=>null),
            $1b12ea52aa3c0323$var$DeferEditionModal,
            $1b12ea52aa3c0323$var$DeferRovoVideoModal,
            $1b12ea52aa3c0323$var$DeferJiraLossAversionModal,
            (0, (0, parcelRequire("7jo2g")).AsyncEndOfTrialMessageSharedWrapper),
            $1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal
        ],
        $1b12ea52aa3c0323$var$Global,
        $1b12ea52aa3c0323$var$Navigation,
        $1b12ea52aa3c0323$var$Trackers,
        $1b12ea52aa3c0323$var$AfterPaintIssuePreEval
    ];
    const $1b12ea52aa3c0323$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
        return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9YvQF")).SafeEmbeddedConfluencePanel), null) : null;
    };
    const $1b12ea52aa3c0323$export$5f4dc7c98070d93e = (0, (0, parcelRequire("1XrjK")).createLayout)({
        rightSidebars: [
            (0, (0, parcelRequire("7Lkcv")).SafeHelpPanel),
            (0, (0, parcelRequire("gmGW3")).SafeConversationAssistantPanel),
            $1b12ea52aa3c0323$var$SafeEmbeddedConfluencePanelWithExperiments
        ],
        globalComponents: $1b12ea52aa3c0323$var$sharedGlobalComponents
    });
});
parcelRegister("doxsH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$899e926f09852ef7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $90yGq;
    var $1NZBJ;
    const $899e926f09852ef7$var$CacheRegistry = ()=>{
        const accountIdLoggedInUser = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1NZBJ")).default).set(accountIdLoggedInUser ?? 'anonymous');
        }, [
            accountIdLoggedInUser
        ]);
        return null;
    };
    var $899e926f09852ef7$export$2e2bcd8739ae039 = $899e926f09852ef7$var$CacheRegistry;
});
parcelRegister("1NZBJ", function(module, exports) {
    $parcel$export(module.exports, "CACHE_PREFIX", ()=>$e0fd77b45718946f$export$69ca515e4489d790);
    $parcel$export(module.exports, "scopeGuard", ()=>$e0fd77b45718946f$export$653cd03438bb0386);
    $parcel$export(module.exports, "default", ()=>$e0fd77b45718946f$export$2e2bcd8739ae039);
    var $bSSG7;
    let $e0fd77b45718946f$var$resolveCachePromise;
    const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
        $e0fd77b45718946f$var$resolveCachePromise = resolve;
    });
    const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
    const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
    const $e0fd77b45718946f$var$TIMEOUT = 10000;
    const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
        let id;
        const timeout = new Promise((resolve, reject)=>{
            id = setTimeout(()=>{
                const storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
                storage.clearAll();
                reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
            }, ms);
        });
        return Promise.race([
            promise,
            timeout
        ]).then((result)=>{
            clearTimeout(id);
            return result;
        });
    };
    const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
    const $e0fd77b45718946f$var$config = {
        devTools: false,
        scopes: {
            prev: null,
            current: null
        },
        set (scopeKey) {
            const storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
            if (this.scopes.prev === null && this.scopes.current === null) {
                if (scopeKeyInStorage) {
                    this.scopes.prev = scopeKeyInStorage;
                    this.scopes.current = scopeKeyInStorage;
                }
            }
            if (this.scopes.current !== scopeKey) {
                if (this.scopes.current !== null) storage.clearAll();
                this.scopes.prev = this.scopes.current;
                this.scopes.current = scopeKey;
                storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
            }
            $e0fd77b45718946f$var$resolveCachePromise();
        },
        get () {
            return this.scopes.current;
        }
    };
    var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;
});
parcelRegister("8JIza", function(module, exports) {
    $parcel$export(module.exports, "AsyncPendoAnalyticsWrapper", ()=>$5adeefc5ea77d534$export$1c388e7c464f3699);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $kxZPA;
    const $5adeefc5ea77d534$var$AsyncPendoAnalytics = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("iuS4J")).then(({ PendoAnalytics: PendoAnalytics })=>PendoAnalytics), {
        moduleId: "./src/packages/platform/services/pendo-analytics/src/index.tsx"
    });
    const $5adeefc5ea77d534$export$1c388e7c464f3699 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "jiraCommonPendoAnalyticsReportErrors",
            packageName: "jiraCommonPendoAnalytics"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: "martech",
            id: "jiraCommonPendoAnalyticsReportErrors",
            packageName: "jiraCommonPendoAnalytics"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5adeefc5ea77d534$var$AsyncPendoAnalytics, null)));
});
parcelRegister("iuS4J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4sJqf")
    ]).then(()=>parcelRequire('8bI7u'));
});
parcelRegister("gmGW3", function(module, exports) {
    $parcel$export(module.exports, "SafeConversationAssistantPanel", ()=>$836bcaaba692e6c5$export$453401d0b697d2db);
    var $5uXOq = parcelRequire("5uXOq");
    var $e8KHW = parcelRequire("e8KHW");
    var $39xOx;
    var $hsmeR;
    var $2NMNM;
    var $2vgok;
    const $836bcaaba692e6c5$var$PanelInLayout = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const panelId = rightSidebarCurrentState?.panelId;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, $1cb976721581e2e6$export$dffb4ed44e20ea9a)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                    createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'aiMatePanel',
                        source: 'AIMate',
                        tags: [
                            'atlaskit',
                            'aiMate'
                        ]
                    }).fire((0, $e8KHW.FabricChannel).aiMate);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            createAnalyticsEvent,
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, $1cb976721581e2e6$export$dffb4ed44e20ea9a)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2vgok")).JiraConversationAssistant), {
            onClosePanel: closeCurrentRightSidebar
        });
    };
    const $836bcaaba692e6c5$export$453401d0b697d2db = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-conversation-assistant-panel",
            packageName: "jiraConversationAssistant"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($836bcaaba692e6c5$var$PanelInLayout, null));
});
const $1cb976721581e2e6$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $1cb976721581e2e6$export$64aee74ba59709e5 = 439;
const $1cb976721581e2e6$export$1c07393c5bb1bc27 = 439;
const $1cb976721581e2e6$export$aa3478deee7adbeb = 350;
const $1cb976721581e2e6$export$21e515a86cd1733b = 'Chat';
parcelRegister("2vgok", function(module, exports) {
    $parcel$export(module.exports, "JiraConversationAssistant", ()=>$2321abcc17b38bef$export$da8473714271a41d);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $lIWNb;
    var $8Y08s;
    var $co1wz;
    var $j8DrX;
    var $hsmeR;
    var $8zOmE;
    var $2NMNM;
    var $14XJw;
    var $fY39E;
    var $koeKL;
    const $2321abcc17b38bef$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
    const $2321abcc17b38bef$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const isSyntheticTenant = (0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("co1wz")).ff)('jsw.pollinator.tenants');
        let baseUrl = '/gateway/api/assist';
        if ((0, (0, parcelRequire("co1wz")).ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai')) baseUrl = '/gateway/api/assist-kotlin';
        else if ((0, (0, parcelRequire("VSDnB")).getBooleanFF)('platform.jira.frontend.ai.mate_route_stargate_to_stg_west')) baseUrl = '/gateway/api/assist-tester';
        const config = (0, $5uXOq.useMemo)(()=>({
                displaySubmitFlag: true,
                siteId: cloudId,
                activationId: activationId,
                product: 'jira',
                orgId: orgId,
                experienceId: 'ai-mate',
                assistanceServiceConfig: {
                    headers: isSyntheticTenant ? {
                        [$2321abcc17b38bef$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                    } : {},
                    baseUrl: baseUrl
                }
            }), [
            cloudId,
            activationId,
            orgId,
            isSyntheticTenant,
            baseUrl
        ]);
        const handleResizeComplete = (0, $5uXOq.useCallback)((width)=>{
            openRightSidebar((0, $1cb976721581e2e6$export$dffb4ed44e20ea9a), width);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'resized',
                actionSubject: 'aiMatePanel'
            }));
        }, [
            openRightSidebar,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Y08s")).ResizeWrapper), {
            onResizeComplete: handleResizeComplete
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2321abcc17b38bef$var$conversationAssistantWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lIWNb")).default), {
            testId: "conversation-assistant.ui.conversation-assistant",
            onCloseChat: onClosePanel,
            config: config
        })));
    };
    const $2321abcc17b38bef$var$conversationAssistantWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
});
parcelRegister("lIWNb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2511a7ad08348805$export$2e2bcd8739ae039);
    var $4qBtX = parcelRequire("4qBtX");
    var $2511a7ad08348805$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("4OxRe")),
        loading: ()=>null
    });
});
parcelRegister("4qBtX", function(module, exports) {
    "use strict";
    var $3396aa4dae68f4b9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function $3396aa4dae68f4b9$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $3396aa4dae68f4b9$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $3396aa4dae68f4b9$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $3396aa4dae68f4b9$var$ALL_INITIALIZERS = [];
    var $3396aa4dae68f4b9$var$READY_INITIALIZERS = [];
    function $3396aa4dae68f4b9$var$isWebpackReady(getModuleIds) {
        if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $3396aa4dae68f4b9$var$_typeof(__webpack_modules__)) !== "object") return false;
        return getModuleIds().every(function(moduleId) {
            return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
        });
    }
    function $3396aa4dae68f4b9$var$load(loader) {
        var promise = loader();
        var state = {
            loading: true,
            loaded: null,
            error: null
        };
        state.promise = promise.then(function(loaded) {
            state.loading = false;
            state.loaded = loaded;
            return loaded;
        }).catch(function(err) {
            state.loading = false;
            state.error = err;
            throw err;
        });
        return state;
    }
    function $3396aa4dae68f4b9$var$loadMap(obj) {
        var state = {
            loading: false,
            loaded: {},
            error: null
        };
        var promises = [];
        try {
            Object.keys(obj).forEach(function(key) {
                var result = $3396aa4dae68f4b9$var$load(obj[key]);
                if (!result.loading) {
                    state.loaded[key] = result.loaded;
                    state.error = result.error;
                } else state.loading = true;
                promises.push(result.promise);
                result.promise.then(function(res) {
                    state.loaded[key] = res;
                }).catch(function(err) {
                    state.error = err;
                });
            });
        } catch (err) {
            state.error = err;
        }
        state.promise = Promise.all(promises).then(function(res) {
            state.loading = false;
            return res;
        }).catch(function(err) {
            state.loading = false;
            throw err;
        });
        return state;
    }
    function $3396aa4dae68f4b9$var$resolve(obj) {
        return obj && obj.__esModule ? obj.default : obj;
    }
    function $3396aa4dae68f4b9$var$render(loaded, props) {
        return $5uXOq.createElement($3396aa4dae68f4b9$var$resolve(loaded), props);
    }
    function $3396aa4dae68f4b9$var$createLoadableComponent(loadFn, options) {
        var _class, _temp;
        if (!options.loading) throw new Error("react-loadable requires a `loading` component");
        var opts = Object.assign({
            loader: null,
            loading: null,
            delay: 200,
            timeout: null,
            render: $3396aa4dae68f4b9$var$render,
            webpack: null,
            modules: null
        }, options);
        var res = null;
        function init() {
            if (!res) res = loadFn(opts.loader);
            return res.promise;
        }
        $3396aa4dae68f4b9$var$ALL_INITIALIZERS.push(init);
        if (typeof opts.webpack === "function") $3396aa4dae68f4b9$var$READY_INITIALIZERS.push(function() {
            if ($3396aa4dae68f4b9$var$isWebpackReady(opts.webpack)) return init();
        });
        return _temp = _class = function(_React$Component) {
            $3396aa4dae68f4b9$var$_inherits(LoadableComponent, _React$Component);
            function LoadableComponent(props) {
                $3396aa4dae68f4b9$var$_classCallCheck(this, LoadableComponent);
                var _this = $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
                _this.retry = function() {
                    _this.setState({
                        error: null,
                        loading: true,
                        timedOut: false
                    });
                    res = loadFn(opts.loader);
                    _this._loadModule();
                };
                init();
                _this.state = {
                    error: res.error,
                    pastDelay: false,
                    timedOut: false,
                    loading: res.loading,
                    loaded: res.loaded
                };
                return _this;
            }
            LoadableComponent.preload = function preload() {
                return init();
            };
            LoadableComponent.prototype.componentWillMount = function componentWillMount() {
                this._mounted = true;
                this._loadModule();
            };
            LoadableComponent.prototype._loadModule = function _loadModule() {
                var _this2 = this;
                if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                    _this2.context.loadable.report(moduleName);
                });
                if (!res.loading) return;
                if (typeof opts.delay === "number") {
                    if (opts.delay === 0) this.setState({
                        pastDelay: true
                    });
                    else this._delay = setTimeout(function() {
                        _this2.setState({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
                if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                    _this2.setState({
                        timedOut: true
                    });
                }, opts.timeout);
                var update = function update() {
                    if (!_this2._mounted) return;
                    _this2.setState({
                        error: res.error,
                        loaded: res.loaded,
                        loading: res.loading
                    });
                    _this2._clearTimeouts();
                };
                res.promise.then(function() {
                    update();
                }).catch(function(err) {
                    update();
                });
            };
            LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
                this._mounted = false;
                this._clearTimeouts();
            };
            LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            };
            LoadableComponent.prototype.render = function render() {
                if (this.state.loading || this.state.error) return $5uXOq.createElement(opts.loading, {
                    isLoading: this.state.loading,
                    pastDelay: this.state.pastDelay,
                    timedOut: this.state.timedOut,
                    error: this.state.error,
                    retry: this.retry
                });
                else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
                else return null;
            };
            return LoadableComponent;
        }($5uXOq.Component), _class.contextTypes = {
            loadable: (0, parcelRequire("8rCP3")).shape({
                report: (0, parcelRequire("8rCP3")).func.isRequired
            })
        }, _temp;
    }
    function $3396aa4dae68f4b9$var$Loadable(opts) {
        return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$load, opts);
    }
    function $3396aa4dae68f4b9$var$LoadableMap(opts) {
        if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
        return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$loadMap, opts);
    }
    $3396aa4dae68f4b9$var$Loadable.Map = $3396aa4dae68f4b9$var$LoadableMap;
    var $3396aa4dae68f4b9$var$Capture = function(_React$Component2) {
        $3396aa4dae68f4b9$var$_inherits(Capture, _React$Component2);
        function Capture() {
            $3396aa4dae68f4b9$var$_classCallCheck(this, Capture);
            return $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
        }
        Capture.prototype.getChildContext = function getChildContext() {
            return {
                loadable: {
                    report: this.props.report
                }
            };
        };
        Capture.prototype.render = function render() {
            return $5uXOq.Children.only(this.props.children);
        };
        return Capture;
    }($5uXOq.Component);
    $3396aa4dae68f4b9$var$Capture.propTypes = {
        report: (0, parcelRequire("8rCP3")).func.isRequired
    };
    $3396aa4dae68f4b9$var$Capture.childContextTypes = {
        loadable: (0, parcelRequire("8rCP3")).shape({
            report: (0, parcelRequire("8rCP3")).func.isRequired
        }).isRequired
    };
    $3396aa4dae68f4b9$var$Loadable.Capture = $3396aa4dae68f4b9$var$Capture;
    function $3396aa4dae68f4b9$var$flushInitializers(initializers) {
        var promises = [];
        while(initializers.length){
            var init = initializers.pop();
            promises.push(init());
        }
        return Promise.all(promises).then(function() {
            if (initializers.length) return $3396aa4dae68f4b9$var$flushInitializers(initializers);
        });
    }
    $3396aa4dae68f4b9$var$Loadable.preloadAll = function() {
        return new Promise(function(resolve, reject) {
            $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$ALL_INITIALIZERS).then(resolve, reject);
        });
    };
    $3396aa4dae68f4b9$var$Loadable.preloadReady = function() {
        return new Promise(function(resolve, reject) {
            $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$READY_INITIALIZERS).then(resolve, resolve);
        });
    };
    module.exports = $3396aa4dae68f4b9$var$Loadable;
});
parcelRegister("4OxRe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fls1N")
    ]).then(()=>parcelRequire('k2v4d'));
});
parcelRegister("8Y08s", function(module, exports) {
    $parcel$export(module.exports, "ResizeWrapper", ()=>$6bea494971fb78d2$export$c7990a6594835e51);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $22jFS;
    var $dC5iT;
    var $8CUq3;
    const $6bea494971fb78d2$var$rootStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        right: 'space.0',
        display: 'flex',
        position: 'fixed',
        height: `calc(100vh - ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)} - ${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)})`
    });
    const $6bea494971fb78d2$var$handleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'ew-resize',
        userSelect: 'none',
        position: 'absolute',
        top: 'space.200',
        bottom: 'space.0',
        left: 'space.0',
        width: '24px',
        borderTopLeftRadius: 'border.radius.200',
        transition: 'border 0.2s ease-in-out',
        borderLeft: '2px solid transparent',
        ':hover': {
            borderLeft: `2px solid ${"var(--ds-background-information-bold-hovered, #0055CC)"}`
        }
    });
    const $6bea494971fb78d2$var$handleSpacerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        position: 'absolute',
        display: 'block',
        left: '-24px',
        top: 'space.0',
        bottom: 'space.0'
    });
    const $6bea494971fb78d2$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $1cb976721581e2e6$export$64aee74ba59709e5), minWidth: minWidth = (0, $1cb976721581e2e6$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
        const [width, setWidth] = (0, $5uXOq.useState)(initialWidth);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const isDraggingRef = (0, $5uXOq.useRef)(false);
        const initialMousePositionRef = (0, $5uXOq.useRef)(0);
        const prevDistanceMovedRef = (0, $5uXOq.useRef)(0);
        const rafRef = (0, $5uXOq.useRef)(null);
        const getWrapperWidth = ()=>{
            return wrapperRef.current?.getBoundingClientRect()?.width || 0;
        };
        const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
            if (!isDraggingRef.current) return;
            const distanceMoved = event.clientX - initialMousePositionRef.current;
            let updatedWidth;
            const currentWidth = getWrapperWidth();
            if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
            prevDistanceMovedRef.current = distanceMoved;
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
            rafRef.current = requestAnimationFrame(()=>{
                if (distanceMoved < 0) {
                    updatedWidth = currentWidth + Math.abs(distanceMoved);
                    if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
                } else {
                    updatedWidth = currentWidth - distanceMoved;
                    if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
                }
                setWidth(updatedWidth);
                initialMousePositionRef.current = event.clientX;
            });
        }, [
            maxWidth,
            minWidth
        ]);
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            isDraggingRef.current = true;
            initialMousePositionRef.current = event.clientX;
        }, []);
        const handleMouseUp = (0, $5uXOq.useCallback)(()=>{
            if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
            isDraggingRef.current = false;
        }, [
            onResizeComplete,
            width
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const mouseMoveHandler = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'mousemove',
                listener: handleMouseMove
            });
            const mouseUpHandler = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'mouseup',
                listener: handleMouseUp
            });
            return ()=>{
                mouseMoveHandler();
                mouseUpHandler();
                if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
            };
        }, [
            handleMouseMove,
            handleMouseUp
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6bea494971fb78d2$var$rootStyles,
            ref: wrapperRef,
            role: "presentation",
            testId: "panel-resize-wrapper",
            style: {
                width: width,
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: "panel-resize-handle",
            onMouseDown: handleMouseDown,
            xcss: $6bea494971fb78d2$var$handleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6bea494971fb78d2$var$handleSpacerStyles
        })), children);
    };
});
parcelRegister("fY39E", function(module, exports) {
    $parcel$export(module.exports, "useActivationId", ()=>$d72c67677898c114$export$43686faa787c943);
    var $9OXo1;
    const $d72c67677898c114$export$43686faa787c943 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.activationId;
    };
});
parcelRegister("8NA5p", function(module, exports) {
    $parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", ()=>$2684c9c6a6fb887b$export$4fa5b26bccc7e3df);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $kxZPA;
    const $2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("cpWGf")).then(({ EPCheck: EPCheck })=>EPCheck), {
        ssr: false,
        moduleId: "./src/packages/growth/defer-edition-modal/src/async.tsx"
    });
    const $2684c9c6a6fb887b$export$4fa5b26bccc7e3df = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "defer-edition-ep-check-async",
            packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, $ac4f2a72f86d65c9$export$d57b6b390e78d90f),
            id: "defer-edition-ep-check-async",
            packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck, props)));
});
const $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $ac4f2a72f86d65c9$export$d57b6b390e78d90f = 'transmuters-growth';
const $ac4f2a72f86d65c9$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $ac4f2a72f86d65c9$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
parcelRegister("cpWGf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bVgxH")
    ]).then(()=>parcelRequire('1DysC'));
});
parcelRegister("7kqCT", function(module, exports) {
    $parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", ()=>$110a94ef04661997$export$51f384a783f47807);
    var $fiH7W;
    var $eufEc;
    var $fEDBv;
    const $110a94ef04661997$var$Fallback = ()=>null;
    const $110a94ef04661997$export$51f384a783f47807 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>{
            if (!false) return (parcelRequire("fscIg")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent);
            return $110a94ef04661997$var$Fallback;
        }, {
            moduleId: "fe342c6b"
        }),
        getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
                queries: {
                    deferEditionModal: {
                        parameters: (0, (0, parcelRequire("fiH7W")).default),
                        variables: {
                            cloudId: cloudId,
                            productKey: productKey
                        }
                    }
                }
            })
    });
});
parcelRegister("fiH7W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d18804309a0f9ffd$export$2e2bcd8739ae039);
    const $d18804309a0f9ffd$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac",
            "metadata": {},
            "name": "src_DeferEditionModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $d18804309a0f9ffd$export$2e2bcd8739ae039 = $d18804309a0f9ffd$var$node;
});
parcelRegister("fscIg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hmyGT")
    ]).then(()=>parcelRequire('8IIKL'));
});
parcelRegister("7jo2g", function(module, exports) {
    $parcel$export(module.exports, "AsyncEndOfTrialMessageSharedWrapper", ()=>$b603c0291b5c0134$export$ae154a7bf883999f);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $kxZPA;
    var $bZB1h;
    const $b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("doUe0")).then(({ EndOfTrialMessageSharedGlobalComponent: EndOfTrialMessageSharedGlobalComponent })=>EndOfTrialMessageSharedGlobalComponent), {
        moduleId: "./src/packages/growth/end-of-trial/end-of-trial-message-shared-global-component/src/index.tsx"
    });
    const $b603c0291b5c0134$export$ae154a7bf883999f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "end-of-trial-message-shared-async",
            packageName: (0, (0, parcelRequire("bZB1h")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, (0, parcelRequire("bZB1h")).TEAM_NAME),
            id: "end-of-trial-message-shared-async",
            packageName: (0, (0, parcelRequire("bZB1h")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent, null)));
});
parcelRegister("bZB1h", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$25fa48d758254005$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$25fa48d758254005$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "STARGATE_URL", ()=>$25fa48d758254005$export$c7e6a6b283196232);
    $parcel$export(module.exports, "END_OF_TRIAL_MESSAGE_AUDIENCES", ()=>$25fa48d758254005$export$1986890201f1a80);
    var $2vSU6;
    const $25fa48d758254005$export$b8b9d90f9e5bd72b = '@atlassian/jira-end-of-trial-message-shared-global-component';
    const $25fa48d758254005$export$d57b6b390e78d90f = 'transmuters-growth';
    const $25fa48d758254005$export$c7e6a6b283196232 = '/gateway/api';
    const $25fa48d758254005$export$1986890201f1a80 = {
        [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: [
            'jpd_standard_end_of_trial_message_day_14',
            'jpd_standard_end_of_trial_message_day_13',
            'jpd_standard_end_of_trial_message_day_12',
            'jpd_standard_end_of_trial_message_day_11',
            'jpd_standard_end_of_trial_message_day_10',
            'jpd_standard_end_of_trial_message_day_9',
            'jpd_standard_end_of_trial_message_day_8',
            'jpd_standard_end_of_trial_message_day_7',
            'jpd_standard_end_of_trial_message_day_6',
            'jpd_standard_end_of_trial_message_day_5',
            'jpd_standard_end_of_trial_message_day_4',
            'jpd_standard_end_of_trial_message_day_3',
            'jpd_standard_end_of_trial_message_day_2',
            'jpd_standard_end_of_trial_message_day_1'
        ],
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: [
            'jsm_standard_end_of_trial_message_day_14',
            'jsm_standard_end_of_trial_message_day_13',
            'jsm_standard_end_of_trial_message_day_12',
            'jsm_standard_end_of_trial_message_day_11',
            'jsm_standard_end_of_trial_message_day_10',
            'jsm_standard_end_of_trial_message_day_9',
            'jsm_standard_end_of_trial_message_day_8',
            'jsm_standard_end_of_trial_message_day_7',
            'jsm_standard_end_of_trial_message_day_6',
            'jsm_standard_end_of_trial_message_day_5',
            'jsm_standard_end_of_trial_message_day_4',
            'jsm_standard_end_of_trial_message_day_3',
            'jsm_standard_end_of_trial_message_day_2',
            'jsm_standard_end_of_trial_message_day_1'
        ]
    };
});
parcelRegister("doUe0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eXdJ6")
    ]).then(()=>parcelRequire('bOc3m'));
});
parcelRegister("3lMZZ", function(module, exports) {
    $parcel$export(module.exports, "LoadingBarUIController", ()=>$ade6fcbf7908cda7$export$39bdf67fc71ce8c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $d46Cs = parcelRequire("d46Cs");
    var $lsa9q;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    var $04unK;
    var $cYUbO;
    const $ade6fcbf7908cda7$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
        const [loadedState] = (0, (0, parcelRequire("lsa9q")).default)();
        (0, $5uXOq.useEffect)(()=>{
            startLoading();
            return ()=>{
                resetLoading();
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (loadedState.hasLoaded) finishLoading();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    const $ade6fcbf7908cda7$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
        const [actions, setActions] = (0, $5uXOq.useState)({});
        const sheetRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const loadingBarActions = (0, $d46Cs.createLoadingBarActionController)(sheetRef.current);
            setActions(loadingBarActions || {});
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            ref: sheetRef,
            dangerouslySetInnerHTML: {
                __html: `
                    ${(0, (0, parcelRequire("04unK")).LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, (0, parcelRequire("cYUbO")).generateLoadingBarStyles)(0, (0, (0, parcelRequire("04unK")).getLoadingBarColor)())}
                    }
                `
            }
        }), shouldRender && actions.START && (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$export$54128ad8de32b897, {
            key: routeIdentifier,
            startLoading: actions.START,
            resetLoading: actions.RESET,
            finishLoading: actions.FINISH
        }));
    };
    const $ade6fcbf7908cda7$export$e068deb20d61b035 = ()=>{
        let currentTransitionsCount = 0;
        let currentRouteIdentifier = '';
        let currentRouteMatch = '';
        let hasTransitioned = false;
        let key = 0;
        return (transitionsCount, routeIdentifier, routeMatch)=>{
            if (transitionsCount !== currentTransitionsCount) {
                currentTransitionsCount = transitionsCount;
                hasTransitioned = true;
            }
            if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
                currentRouteIdentifier = routeIdentifier;
                currentRouteMatch = routeMatch;
                if (hasTransitioned) {
                    hasTransitioned = false;
                    key = currentTransitionsCount;
                }
            }
            return key;
        };
    };
    const $ade6fcbf7908cda7$var$getUniqueTransitionKey = $ade6fcbf7908cda7$export$e068deb20d61b035();
    const $ade6fcbf7908cda7$export$39bdf67fc71ce8c8 = ()=>{
        const [routerState] = (0, $dIdda.useRouter)();
        const [{ transitionsCount: transitionsCount }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const currentRoute = routerState.route && routerState.route.name;
        const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
        const shouldRender = (0, (0, parcelRequire("04unK")).getAllowedRoutes)().includes(currentRoute);
        const routeIdentifier = (0, $5uXOq.useMemo)(()=>$ade6fcbf7908cda7$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
            transitionsCount,
            currentRoute,
            routerState.match
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldRender && loaderFailedInSSR) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
        }, [
            loaderFailedInSSR
        ]);
        if (loaderFailedInSSR) return (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$var$LoadingBarUI, {
            shouldRender: shouldRender,
            routeIdentifier: routeIdentifier
        });
        if (shouldRender && window.JIRA_LOADING_BAR) return (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$export$54128ad8de32b897, {
            key: routeIdentifier,
            startLoading: window.JIRA_LOADING_BAR.START,
            resetLoading: window.JIRA_LOADING_BAR.RESET,
            finishLoading: window.JIRA_LOADING_BAR.FINISH
        });
        return null;
    };
});
parcelRegister("d46Cs", function(module, exports) {
    $parcel$export(module.exports, "createLoadingBarActionController", ()=>$65545b2eb3978204$export$55d67d61d9d2ad3b);
    var $61WP1;
    const $65545b2eb3978204$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
    const $65545b2eb3978204$export$899393f3e23f724b = 15000;
    const $65545b2eb3978204$export$7868b416d8929c55 = 40000;
    const $65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
    const $65545b2eb3978204$var$EXIT_ANIMATION_SPEED = 300;
    const $65545b2eb3978204$export$99d4e8974a739853 = ()=>(0, (0, parcelRequire("61WP1")).getMeta)('ajs-lf-navigation-highlightcolour') || $65545b2eb3978204$export$53d51cc6d57e44da;
    const $65545b2eb3978204$export$4fb8742b05de9693 = (duration)=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
    const $65545b2eb3978204$export$5a43e0f09174e553 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$65545b2eb3978204$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
    const $65545b2eb3978204$export$6beef8c645a63156 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
    const $65545b2eb3978204$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
    const $65545b2eb3978204$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
    const $65545b2eb3978204$var$browserFocusCheck = (action)=>{
        if (document && document.hidden) action();
        else requestAnimationFrame(()=>{
            action();
        });
    };
    const $65545b2eb3978204$export$55d67d61d9d2ad3b = (stylesheet)=>{
        const { sheet: sheet } = stylesheet || {};
        if (!sheet) return undefined;
        let isRunning = false;
        let isDelayed = false;
        let exitAnimationTimer;
        let delayedAnimationTimer;
        let timeoutTimer;
        return {
            START: (duration = $65545b2eb3978204$export$899393f3e23f724b)=>{
                if (isRunning) return;
                isRunning = true;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$4fb8742b05de9693(duration), sheet.cssRules.length);
                });
                delayedAnimationTimer = setTimeout(()=>{
                    if (!isRunning) return;
                    isDelayed = true;
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$610cb442736abf53(), sheet.cssRules.length);
                        sheet.insertRule($65545b2eb3978204$export$959e9e99fba397f1($65545b2eb3978204$export$99d4e8974a739853()), sheet.cssRules.length);
                    });
                }, $65545b2eb3978204$export$899393f3e23f724b);
                timeoutTimer = setTimeout(()=>{
                    if (!isRunning) return;
                    isRunning = false;
                    isDelayed = false;
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(delayedAnimationTimer);
                    clearTimeout(timeoutTimer);
                }, $65545b2eb3978204$export$7868b416d8929c55);
            },
            FINISH: ()=>{
                if (!isRunning) return;
                isRunning = false;
                if (isDelayed) {
                    isDelayed = false;
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(timeoutTimer);
                    clearTimeout(delayedAnimationTimer);
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                    return;
                }
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$5a43e0f09174e553(), sheet.cssRules.length);
                });
                exitAnimationTimer = setTimeout(()=>{
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(timeoutTimer);
                    clearTimeout(delayedAnimationTimer);
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                }, $65545b2eb3978204$var$EXIT_ANIMATION_SPEED + 500);
            },
            RESET: ()=>{
                isRunning = false;
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }
        };
    };
    const $65545b2eb3978204$var$setupLoadingBarActionController = ()=>{
        const LOADER_STYLESHEET_ID = 'loaderStylesheet';
        const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
        if (!styleSheet || !styleSheet.sheet) return;
        window.JIRA_LOADING_BAR = $65545b2eb3978204$export$55d67d61d9d2ad3b(styleSheet);
        if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) window.JIRA_LOADING_BAR.START();
    };
    $65545b2eb3978204$var$setupLoadingBarActionController();
});
parcelRegister("61WP1", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$22b3d998cd498e5f$export$c47913ca32a5c6f7);
    const $22b3d998cd498e5f$export$c47913ca32a5c6f7 = (name)=>{
        const node = document.querySelector(`meta[name="${name}"]`);
        const metaValue = node && node.getAttribute('content');
        return metaValue !== undefined ? metaValue : null;
    };
});
parcelRegister("04unK", function(module, exports) {
    $parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", ()=>$ac75ec265428b4c8$export$2a3dd4ccb7b0a764);
    $parcel$export(module.exports, "LOADER_STYLESHEET_ID", ()=>$ac75ec265428b4c8$export$79456f717d4431da);
    $parcel$export(module.exports, "getAllowedRoutes", ()=>$ac75ec265428b4c8$export$c82eb262b97a76f1);
    $parcel$export(module.exports, "getLoadingBarColor", ()=>$ac75ec265428b4c8$export$cf3a5ed89e041425);
    var $8QpSo;
    var $65Ltd;
    var $j8DrX;
    const $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY_SECURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)
    ];
    const $ac75ec265428b4c8$export$2a3dd4ccb7b0a764 = 'body::before';
    const $ac75ec265428b4c8$export$79456f717d4431da = 'loaderStylesheet';
    const $ac75ec265428b4c8$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
    const $ac75ec265428b4c8$export$c82eb262b97a76f1 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const ALLOWED_ROUTES = $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES;
        return ALLOWED_ROUTES;
    });
    const $ac75ec265428b4c8$export$cf3a5ed89e041425 = (0, (0, parcelRequire("8QpSo")).default)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-lf-navigation-highlightcolour') || $ac75ec265428b4c8$export$53d51cc6d57e44da);
});
parcelRegister("cYUbO", function(module, exports) {
    $parcel$export(module.exports, "generateLoadingBarStyles", ()=>$e5278a73a699aa95$export$3036104bc81246b1);
    var $gwIPs;
    var $04unK;
    const $e5278a73a699aa95$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, (0, parcelRequire("gwIPs")).layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
    const $e5278a73a699aa95$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, (0, parcelRequire("04unK")).LOADER_STYLESHEET_ID}>
            ${0, (0, parcelRequire("04unK")).LOADER_STYLES_CSS_SELECTOR} {${$e5278a73a699aa95$export$3036104bc81246b1(initialProgressValue, (0, (0, parcelRequire("04unK")).getLoadingBarColor)())}}
        </style>`;
});
parcelRegister("7Lkcv", function(module, exports) {
    $parcel$export(module.exports, "SafeHelpPanel", ()=>$70a8cef9c47c5a71$export$cd2ada2fb14048fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $39xOx;
    var $6BNJk;
    var $kspz4;
    var $7dTw7;
    var $1SVH7;
    var $hsmeR;
    var $90yGq;
    const $70a8cef9c47c5a71$var$HelpPanel = ()=>{
        const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, (0, parcelRequire("kspz4")).useHelpPanel)();
        const { closeRightSidebar: closeRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>{
            const restoreReleaseNotesNotifications = async ()=>{
                if (accountId) try {
                    const { helpPanel: userPropertiesHelpPanelValue } = await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf));
                    setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
                } catch (err) {
                    setReleaseNotesNotifications(0);
                }
                else setReleaseNotesNotifications(0);
            };
            restoreReleaseNotesNotifications();
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7dTw7")).RemoteStateUpdater), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1SVH7")).LazyHelpPanel), {
            isOpen: !rightSidebarCurrentState?.isCollapsed,
            navigationData: navigationData,
            releaseNotesNotifications: releaseNotesNotifications,
            setNavigationData: setNavigationData,
            releaseNotesNotificationsSetter: setReleaseNotesNotifications,
            hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
            onCloseHelpPanel: closeRightSidebar
        }));
    };
    const $70a8cef9c47c5a71$var$HelpPanelInLayout = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const panelId = rightSidebarCurrentState?.panelId;
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanel, null);
    };
    const $70a8cef9c47c5a71$export$cd2ada2fb14048fc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-help-panel",
            packageName: "@atlassian/jira-help-panel-right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanelInLayout, null));
});
parcelRegister("6BNJk", function(module, exports) {
    $parcel$export(module.exports, "HELP_PANEL_VERSION", ()=>$20386d7da4313ff0$export$c43c7444da662fa1);
    $parcel$export(module.exports, "HELP_PANEL_ID", ()=>$20386d7da4313ff0$export$e99efa3985fa3c26);
    $parcel$export(module.exports, "HELP_PANEL_WIDTH", ()=>$20386d7da4313ff0$export$23aa6670f346c214);
    var $gwIPs;
    const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
    const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
    const $20386d7da4313ff0$export$23aa6670f346c214 = (0, (0, parcelRequire("gwIPs")).gridSize) * 46;
});
parcelRegister("kspz4", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanel", ()=>$aee6103177ce0723$export$3fe94d66377a53b8);
    $parcel$export(module.exports, "useHelpPanelActions", ()=>$aee6103177ce0723$export$c61f56f4797e22db);
    var $7JoAD = parcelRequire("7JoAD");
    var $jgGDm;
    const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $7JoAD.createHook)((0, (0, parcelRequire("jgGDm")).default));
    const $aee6103177ce0723$export$c61f56f4797e22db = (0, $7JoAD.createHook)((0, (0, parcelRequire("jgGDm")).default), {
        selector: null
    });
    const $aee6103177ce0723$export$513717a84f55db1a = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("jgGDm")).default), {
        displayName: 'HelpPanelSubscriber'
    });
    const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("jgGDm")).default), {
        displayName: 'HelpPanelActionsSubscriber',
        selector: null
    });
});
parcelRegister("jgGDm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$465615692863cce9$export$2e2bcd8739ae039);
    var $eNf8a;
    var $7JoAD = parcelRequire("7JoAD");
    var $958ua;
    const $465615692863cce9$var$iphStorage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('iph');
    const $465615692863cce9$var$initialState = {
        navigationData: {
            articleId: {
                id: '',
                type: 'HELP_ARTICLE'
            },
            history: $465615692863cce9$var$iphStorage.get('history') || []
        },
        releaseNotesNotifications: 100
    };
    var $465615692863cce9$export$2e2bcd8739ae039 = (0, $7JoAD.createStore)({
        name: 'help-panel',
        initialState: $465615692863cce9$var$initialState,
        actions: (0, parcelRequire("958ua"))
    });
});
parcelRegister("958ua", function(module, exports) {
    $parcel$export(module.exports, "setNavigationData", ()=>$177ac56c5a5bf49e$export$ab1b80f40ca898ed);
    $parcel$export(module.exports, "setReleaseNotesNotifications", ()=>$177ac56c5a5bf49e$export$cdabe01d01a8da1e);
    var $eNf8a;
    const $177ac56c5a5bf49e$var$iphStorage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('iph');
    const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                navigationData: {
                    articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                    history: navigationData.history ? navigationData.history : currentState.navigationData.history
                }
            });
            $177ac56c5a5bf49e$var$iphStorage.set('history', []);
        };
    const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
            setState({
                releaseNotesNotifications: releaseNotesNotifications
            });
        };
});
const $0971f751295a2324$export$783d7c02e3a0cbf = 'help_panel_ui_state';
parcelRegister("7dTw7", function(module, exports) {
    $parcel$export(module.exports, "RemoteStateUpdater", ()=>$52205ad66fbf5dd9$export$3db011870dd4330f);
    var $5uXOq = parcelRequire("5uXOq");
    var $laWvb;
    var $89SaW;
    var $jcw0u;
    var $90yGq;
    var $kspz4;
    const $52205ad66fbf5dd9$var$DEBOUNCE_TIME = 1000;
    const $52205ad66fbf5dd9$export$3db011870dd4330f = ()=>{
        const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, (0, parcelRequire("kspz4")).useHelpPanel)();
        const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $5uXOq.useState)(releaseNotesNotifications);
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [debouncedUpdateData] = (0, (0, parcelRequire("laWvb")).default)(async (newReleaseNotesNotifications)=>{
            const remoteData = {
                helpPanel: {
                    releaseNotesNotifications: newReleaseNotesNotifications
                }
            };
            if (accountId) try {
                await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e,
                    meta: {
                        id: 'updateServerHelpPanelState',
                        packageName: 'jiraHelpPanelServices',
                        teamName: 'self-help-experiences'
                    }
                });
            }
        }, $52205ad66fbf5dd9$var$DEBOUNCE_TIME);
        (0, $5uXOq.useEffect)(()=>{
            if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
                setReleaseNotesNotificationsTemp(releaseNotesNotifications);
                debouncedUpdateData(releaseNotesNotifications);
            }
        }, [
            debouncedUpdateData,
            releaseNotesNotifications,
            releaseNotesNotificationsTemp
        ]);
        return null;
    };
});
parcelRegister("laWvb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6a7e96a5e9b4bd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039(callback, delay, options) {
        if (options === void 0) options = {};
        var maxWait = options.maxWait;
        var maxWaitHandler = (0, $5uXOq.useRef)(null);
        var maxWaitArgs = (0, $5uXOq.useRef)([]);
        var leading = options.leading;
        var trailing = options.trailing === undefined ? true : options.trailing;
        var leadingCall = (0, $5uXOq.useRef)(false);
        var functionTimeoutHandler = (0, $5uXOq.useRef)(null);
        var isComponentUnmounted = (0, $5uXOq.useRef)(false);
        var debouncedFunction = (0, $5uXOq.useRef)(callback);
        debouncedFunction.current = callback;
        var cancelDebouncedCallback = (0, $5uXOq.useCallback)(function() {
            clearTimeout(functionTimeoutHandler.current);
            clearTimeout(maxWaitHandler.current);
            maxWaitHandler.current = null;
            maxWaitArgs.current = [];
            functionTimeoutHandler.current = null;
            leadingCall.current = false;
        }, []);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                isComponentUnmounted.current = true;
            };
        }, []);
        var debouncedCallback = (0, $5uXOq.useCallback)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            maxWaitArgs.current = args;
            clearTimeout(functionTimeoutHandler.current);
            if (leadingCall.current) leadingCall.current = false;
            if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
                debouncedFunction.current.apply(debouncedFunction, args);
                leadingCall.current = true;
            }
            functionTimeoutHandler.current = setTimeout(function() {
                var shouldCallFunction = true;
                if (leading && leadingCall.current) shouldCallFunction = false;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
            }, delay);
            if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
                var args = maxWaitArgs.current;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
            }, maxWait);
        }, [
            maxWait,
            delay,
            cancelDebouncedCallback,
            leading,
            trailing
        ]);
        var callPending = (0, $5uXOq.useCallback)(function() {
            if (!functionTimeoutHandler.current) return;
            debouncedFunction.current.apply(null, maxWaitArgs.current);
            cancelDebouncedCallback();
        }, [
            cancelDebouncedCallback
        ]);
        return [
            debouncedCallback,
            cancelDebouncedCallback,
            callPending
        ];
    }
});
parcelRegister("1SVH7", function(module, exports) {
    $parcel$export(module.exports, "LazyHelpPanel", ()=>$311d1a0e95633292$export$51c79455aef7d178);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $6s1PB;
    var $lfTZh;
    var $cYlk7;
    var $iXVV6;
    var $6Lg6A;
    var $jVpMq;
    var $7rrMi;
    var $4RupH;
    const $311d1a0e95633292$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
        const user = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "help-panel",
            packageName: "jiraHelpPanel",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jVpMq")).default), {
                    loadingArticle: articleId.id !== ''
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "root",
            packageName: "jiraHelpPanel",
            teamName: "self-help-experiences"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7rrMi")).SearchContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            tags: [
                'iph'
            ],
            sourceName: "jiraHelpPanel",
            sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
            attributes: {
                searchService: (0, (0, parcelRequire("6s1PB")).expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false) ? 'help-aggregator' : 'algolia',
                routeGroup: routeGroup,
                routeName: routeName,
                userId: user?.data?.user?.accountId
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Lg6A")).LazyWait), {
            until: hasBeenRendered
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-lazy-help-panel",
            fallback: isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jVpMq")).default), {
                loadingArticle: articleId.id !== ''
            }) : null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4RupH")).AsyncLazyHelpPanel), {
            navigationData: {
                articleId: articleId,
                history: history
            },
            releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
            releaseNotesNotifications: releaseNotesNotifications,
            setNavigationData: setNavigationData,
            isOpen: isOpen,
            onCloseHelpPanel: onCloseHelpPanel,
            routeGroup: routeGroup,
            routeName: routeName
        })))))));
    };
});
parcelRegister("cYlk7", function(module, exports) {
    $parcel$export(module.exports, "useCurrentUser", ()=>$cdd4ab536fcf9459$export$3901076af3749fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    var $leRCk;
    const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return (0, $5uXOq.useMemo)(()=>({
                data: {
                    user: {
                        accountId: tenantContext.atlassianAccountId,
                        isAdmin: tenantContext.isAdmin,
                        isAnonymous: tenantContext.isAnonymous,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        locale: tenantContext.locale || (0, (0, parcelRequire("lzeFL")).defaultLocale),
                        siteAdminStatus: tenantContext.siteAdminStatus,
                        userFullname: tenantContext.userFullname || ''
                    }
                },
                loading: false,
                error: null
            }), [
            tenantContext.atlassianAccountId,
            tenantContext.isAdmin,
            tenantContext.isAnonymous,
            tenantContext.isSiteAdmin,
            tenantContext.locale,
            tenantContext.siteAdminStatus,
            tenantContext.userFullname
        ]);
    };
    const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
        const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, (0, parcelRequire("leRCk")).useUserSubscriber)();
        (0, $5uXOq.useEffect)(()=>{
            tenantContext.atlassianAccountId && fetch({
                params: {
                    accountId: tenantContext.atlassianAccountId
                }
            }, false);
        }, [
            fetch,
            tenantContext.atlassianAccountId
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: {
                    ...dataBasic,
                    user: {
                        ...dataBasic.user,
                        ...data
                    }
                },
                loading: loading,
                error: error
            }), [
            data,
            dataBasic,
            error,
            loading
        ]);
    };
    const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, (0, parcelRequire("9OXo1")).useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull();
    const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
        const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
        return children(result);
    };
});
parcelRegister("leRCk", function(module, exports) {
    $parcel$export(module.exports, "UserContainer", ()=>$46a581f1f6efe569$export$7ff085589970ee0a);
    $parcel$export(module.exports, "useUserSubscriber", ()=>$46a581f1f6efe569$export$4e61bbf568682a96);
    var $7JoAD = parcelRequire("7JoAD");
    var $314C6;
    const $46a581f1f6efe569$var$initialState = {
        data: null,
        loading: false,
        error: null
    };
    const $46a581f1f6efe569$var$Store = (0, $7JoAD.createStore)({
        name: 'user',
        initialState: $46a581f1f6efe569$var$initialState,
        actions: (0, parcelRequire("314C6"))
    });
    const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $7JoAD.createContainer)($46a581f1f6efe569$var$Store);
    const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $7JoAD.createHook)($46a581f1f6efe569$var$Store);
});
parcelRegister("314C6", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
    var $iF3m5;
    const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (!params || currentState.loading || currentState.data && !forceRefetch) return;
            setState({
                loading: true
            });
            try {
                const data = await (0, (0, parcelRequire("iF3m5")).fetchData)({
                    params: params,
                    header: header
                });
                setState({
                    data: data,
                    loading: false,
                    error: null
                });
            } catch (err) {
                setState({
                    error: err,
                    loading: false
                });
            }
        };
});
parcelRegister("iF3m5", function(module, exports) {
    $parcel$export(module.exports, "fetchData", ()=>$d22d4c6d892f61f1$export$8134c072fddab6a5);
    var $ebyGx = parcelRequire("ebyGx");
    var $eusud;
    const $d22d4c6d892f61f1$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
        const queryParams = {
            ...params,
            expand: Object.keys(params.expand || {}).filter((key)=>params.expand && params.expand[key])
        };
        const query = (0, $ebyGx.stringify)(queryParams, {
            arrayFormat: 'none'
        });
        const queryString = query ? `?${query}` : '';
        const requestUrl = `/rest/api/2/user${queryString}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(requestUrl, header ? {
            headers: header
        } : {});
    };
});
parcelRegister("jVpMq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8bb188482996cb7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $5CrlE;
    const $b8bb188482996cb7$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5CrlE")).HelpPanelContainerV2), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "img",
            "aria-label": "help panel loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-250, 20px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "90%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "70%"
        })))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5CrlE")).HelpPanelContainerV2), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-500, 40px)",
            marginTop: "var(--ds-space-100, 8px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleList, {
            role: "img"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })))));
    var $b8bb188482996cb7$export$2e2bcd8739ae039 = $b8bb188482996cb7$var$HelpPanelLoading;
    const $b8bb188482996cb7$var$LoadingContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$HeaderLoading = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ixncg _bfhk10nm _n7zlxs90 _1bah1yb4 _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$shimmer = null;
    const $b8bb188482996cb7$var$LoadingRectangle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_l7mdyr": (0, (0, parcelRequire("lD23V")).default)(__cmplp.contentHeight),
                "--_1fj4wta": (0, (0, parcelRequire("lD23V")).default)(__cmplp.marginTop),
                "--_7n1eiw": (0, (0, parcelRequire("lD23V")).default)(__cmplp.contentWidth)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rkov77o _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk134c _1itk15g1 _12vemgnk",
                __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
                __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
                __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$LoadignArticleList = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _18s8v0yc _1yt4ze3t _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$LoadignArticleListItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _1bsb1osq _1yt4u2gc _vchhusvi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5CrlE", function(module, exports) {
    $parcel$export(module.exports, "HelpPanelContainer", ()=>$2dbd0534194918a8$export$37cd645d7678f7d4);
    $parcel$export(module.exports, "HelpPanelContainerV2", ()=>$2dbd0534194918a8$export$1df7e3ebfc4c9b06);
    $parcel$export(module.exports, "HelpPanelSectionMessageContainer", ()=>$2dbd0534194918a8$export$9f6251c714594f23);
    $parcel$export(module.exports, "HelpPanelContentContainer", ()=>$2dbd0534194918a8$export$1cdb922eed7271d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $2dbd0534194918a8$export$37cd645d7678f7d4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1kl71osx _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$1df7e3ebfc4c9b06 = (0, $5uXOq.forwardRef)(({ as: C = $2dbd0534194918a8$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1i8v _11q71bhr",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$9f6251c714594f23 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1yt41rfa _1bsb1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$1cdb922eed7271d1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7rrMi", function(module, exports) {
    $parcel$export(module.exports, "useSearchContext", ()=>$c0047fc735c61769$export$67b98b1b880a048b);
    $parcel$export(module.exports, "SearchContextProvider", ()=>$c0047fc735c61769$export$6bd70292443463a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $jFLAi;
    const [$c0047fc735c61769$export$67b98b1b880a048b, $c0047fc735c61769$export$70af50e847ce290a] = (0, (0, parcelRequire("jFLAi")).createCtx)();
    const $c0047fc735c61769$export$6bd70292443463a4 = ({ children: children })=>{
        const [searchContext, setSearchContext] = (0, $5uXOq.useState)({});
        const addClickedArticleIds = (0, $5uXOq.useCallback)((query, clickedArticleId)=>{
            setSearchContext((prev)=>({
                    ...prev,
                    [query]: {
                        ...prev[query],
                        clickedArticleIds: prev[query]?.clickedArticleIds ? [
                            ...prev[query].clickedArticleIds,
                            clickedArticleId
                        ] : [
                            clickedArticleId
                        ]
                    }
                }));
        }, []);
        const addFetchedArticleIds = (0, $5uXOq.useCallback)((query, fetchedArticles)=>{
            setSearchContext((prev)=>({
                    ...prev,
                    [query]: {
                        ...prev[query],
                        fetchedArticleIds: fetchedArticles
                    }
                }));
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c0047fc735c61769$export$70af50e847ce290a, {
            value: {
                searchContext: searchContext,
                addClickedArticleIds: addClickedArticleIds,
                addFetchedArticleIds: addFetchedArticleIds
            }
        }, children);
    };
});
parcelRegister("jFLAi", function(module, exports) {
    $parcel$export(module.exports, "createCtx", ()=>$b612e461f4fc901f$export$d653a1a643c9a98c);
    var $5uXOq = parcelRequire("5uXOq");
    function $b612e461f4fc901f$export$d653a1a643c9a98c() {
        const ctx = (0, $5uXOq.createContext)(undefined);
        function useCtx() {
            const c = (0, $5uXOq.useContext)(ctx);
            if (!c) throw new Error('useCtx must be inside a Provider with a value');
            return c;
        }
        return [
            useCtx,
            ctx.Provider
        ];
    }
});
parcelRegister("4RupH", function(module, exports) {
    $parcel$export(module.exports, "AsyncLazyHelpPanel", ()=>$4ce54108d7c5ac07$export$7ff46d33d0f13518);
    var $kxZPA;
    const $4ce54108d7c5ac07$export$7ff46d33d0f13518 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9Y8nX")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
    });
});
parcelRegister("9Y8nX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("cBrFc")
    ]).then(()=>parcelRequire('jj3on'));
});
parcelRegister("9YvQF", function(module, exports) {
    $parcel$export(module.exports, "SafeEmbeddedConfluencePanel", ()=>$3e89344d89118823$export$2d901a489872dd0d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $9KYrx;
    var $gXSrH;
    var $39xOx;
    var $hsmeR;
    var $9V9QO;
    const $3e89344d89118823$var$DELAY = 310;
    const $3e89344d89118823$export$2db0a2e0275af8b8 = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [{ panel: isOpen }] = (0, (0, parcelRequire("gXSrH")).useEmbeddedConfluenceSidePanel)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const panelId = rightSidebarCurrentState?.panelId;
        const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, (0, parcelRequire("9V9QO")).useEmbeddedPanelEntryPoint)();
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen) entryPointActions?.load();
        }, [
            isOpen,
            entryPointActions,
            localPanelId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, $3e89344d89118823$var$DELAY);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $3e89344d89118823$var$panelStyles
        }, entryPoint);
    };
    const $3e89344d89118823$export$2d901a489872dd0d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-embedded-confluence-panel",
            packageName: "jiraIssueCreateConfluenceContent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gXSrH")).EmbeddedConfluenceSidepanelContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($3e89344d89118823$export$2db0a2e0275af8b8, null)));
    const $3e89344d89118823$var$panelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.100',
        height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
    });
});
parcelRegister("9KYrx", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceFeatureKeys", ()=>$e486b17128606747$export$746d4746bf07dd70);
    $parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", ()=>$e486b17128606747$export$6247c7e19b71f4e);
    $parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", ()=>$e486b17128606747$export$e34c4c923d934e7a);
    $parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", ()=>$e486b17128606747$export$ffe60197eb59ca73);
    $parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", ()=>$e486b17128606747$export$8d0c4a26241944b8);
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", ()=>$e486b17128606747$export$a497288e64e9a343);
    const $e486b17128606747$export$746d4746bf07dd70 = {
        ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
        SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
        CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
        CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
    };
    const $e486b17128606747$export$6247c7e19b71f4e = 'confluence-integration-controls';
    const $e486b17128606747$export$e34c4c923d934e7a = 'user-confluence-access';
    const $e486b17128606747$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
    const $e486b17128606747$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
    const $e486b17128606747$export$a497288e64e9a343 = 'embedded-confluence-panel-container';
});
parcelRegister("gXSrH", function(module, exports) {
    $parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", ()=>$27a5db923b3bcebb$export$a5c1c168018f0f16);
    $parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", ()=>$27a5db923b3bcebb$export$518aeea31a00450e);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $2gCtH;
    var $hsmeR;
    var $7JoAD = parcelRequire("7JoAD");
    var $9KYrx;
    var $aQLD7;
    var $bvqNo;
    var $5labn;
    const $27a5db923b3bcebb$var$Container = (0, $7JoAD.createContainer)();
    const $27a5db923b3bcebb$var$DefaultStore = (0, $7JoAD.createStore)({
        actions: (0, parcelRequire("aQLD7")).actions,
        containedBy: $27a5db923b3bcebb$var$Container,
        initialState: (0, parcelRequire("aQLD7")).initialState,
        name: (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
    });
    const $27a5db923b3bcebb$var$NonContainerStore = (0, $7JoAD.createStore)({
        actions: (0, parcelRequire("aQLD7")).actions,
        initialState: (0, parcelRequire("aQLD7")).initialState,
        name: (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
    });
    const $27a5db923b3bcebb$export$a5c1c168018f0f16 = ({ children: children })=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($27a5db923b3bcebb$var$Container, {
            scope: `embedded-confluence-sidepanel-${issueKey}`
        }, children);
    };
    const $27a5db923b3bcebb$var$defaultStoreHook = (0, $7JoAD.createHook)($27a5db923b3bcebb$var$DefaultStore);
    const $27a5db923b3bcebb$var$nonContainerStoreHook = (0, $7JoAD.createHook)($27a5db923b3bcebb$var$NonContainerStore);
    const $27a5db923b3bcebb$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
        const [embedConfluenceSidepanelConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
        const isInExperiment = embedConfluenceSidepanelConfig.get('cohort', 'not-enrolled') === 'experiment';
        const [state, { closeSidePanel: closeSidePanelAction, openSidePanel: openSidePanelAction, setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceName: setDeferredSpaceName }] = isInExperiment ? $27a5db923b3bcebb$var$defaultStoreHook() : $27a5db923b3bcebb$var$nonContainerStoreHook();
        const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const openSidePanel = (0, $5uXOq.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
            const { initialWidth: initialWidth, displayType: displayType } = (0, (0, parcelRequire("5labn")).getDisplayInformation)();
            const shouldOpenPanel = displayType === (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL;
            if (shouldOpenPanel) {
                openSidePanelAction({
                    contentId: contentId,
                    contentType: contentType,
                    embeddedConfluenceSource: embeddedConfluenceSource,
                    data: data,
                    displayType: displayType,
                    initialWidth: initialWidth,
                    hostname: hostname,
                    isDraft: isDraft,
                    isLive: isLive,
                    mode: mode,
                    onLinkPage: onLinkPage,
                    onPublish: onPublish,
                    shouldOpenModal: !shouldOpenPanel,
                    url: url,
                    title: title
                });
                openRightSidebar((0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
            } else openInModal();
        }, [
            embeddedConfluenceSource,
            openRightSidebar,
            openSidePanelAction
        ]);
        const closeSidePanel = (0, $5uXOq.useCallback)(()=>{
            closeRightSidebar((0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
            closeSidePanelAction();
        }, [
            closeRightSidebar,
            closeSidePanelAction
        ]);
        return [
            state,
            {
                openSidePanel: openSidePanel,
                closeSidePanel: closeSidePanel,
                setDeferredSpaceName: setDeferredSpaceName,
                setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection
            }
        ];
    };
});
parcelRegister("2gCtH", function(module, exports) {
    $parcel$export(module.exports, "useChildIssuesLimit", ()=>$9e67f38435565e11$export$8d75f312eaa63aec);
    $parcel$export(module.exports, "useChildIssuesIssueLimitUrl", ()=>$9e67f38435565e11$export$65a59acd1ffc5bba);
    $parcel$export(module.exports, "useIsModal", ()=>$9e67f38435565e11$export$9ce8428ff198804a);
    $parcel$export(module.exports, "useIssueKey", ()=>$9e67f38435565e11$export$22108eca27445997);
    $parcel$export(module.exports, "useIssueId", ()=>$9e67f38435565e11$export$9df8176b5ffce5ab);
    $parcel$export(module.exports, "useIsArchived", ()=>$9e67f38435565e11$export$7cd1821433aafaee);
    $parcel$export(module.exports, "useIsClassifyEditEnabled", ()=>$9e67f38435565e11$export$b23b36ed5c42e920);
    $parcel$export(module.exports, "useProjectKey", ()=>$9e67f38435565e11$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useAnalyticsSource", ()=>$9e67f38435565e11$export$aad3917152559b87);
    $parcel$export(module.exports, "useIssueContextActions", ()=>$9e67f38435565e11$export$d6ec1293313f49ac);
    $parcel$export(module.exports, "useRapidViewMap", ()=>$9e67f38435565e11$export$4d204e800e4e0be7);
    $parcel$export(module.exports, "useEstimationStatistic", ()=>$9e67f38435565e11$export$5b20e30ee6db56e9);
    $parcel$export(module.exports, "useViewMode", ()=>$9e67f38435565e11$export$3a7c3e259b6adb93);
    $parcel$export(module.exports, "useBackButtonUrl", ()=>$9e67f38435565e11$export$cfe64a334903927c);
    $parcel$export(module.exports, "useIssueNavigatorData", ()=>$9e67f38435565e11$export$aa008a00bae7e7ab);
    $parcel$export(module.exports, "useOnIssueKeyChange", ()=>$9e67f38435565e11$export$52c975cf0b623556);
    $parcel$export(module.exports, "useRapidViewId", ()=>$9e67f38435565e11$export$b34d0ea0bf41fee);
    $parcel$export(module.exports, "useViewScreenId", ()=>$9e67f38435565e11$export$7c142b5701b4c3f9);
    $parcel$export(module.exports, "useHasSoftwareAccess", ()=>$9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
    $parcel$export(module.exports, "useIsFullPageIssueView", ()=>$9e67f38435565e11$export$2e131fc4108f9106);
    $parcel$export(module.exports, "useIsEmbedPageIssueView", ()=>$9e67f38435565e11$export$4596c26005fbb859);
    $parcel$export(module.exports, "useIsAiOptInEnabled", ()=>$9e67f38435565e11$export$b131d9f6da853161);
    $parcel$export(module.exports, "useIsAiEnabledForIssue", ()=>$9e67f38435565e11$export$db5174c7538abe4b);
    $parcel$export(module.exports, "useIsJiraIssue", ()=>$9e67f38435565e11$export$cf5fc815f761fb4b);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $4Pf62;
    var $93Yeu;
    var $g5X3G;
    var $ef5Xn;
    var $7trqb;
    var $hqBSi;
    var $koiRX;
    const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
        const [childIssuesLimit] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreChildIssuesLimit)();
        return childIssuesLimit;
    };
    const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
        const [childIssuesIssueLimitUrls] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreChildIssuesIssueLimitUrls)();
        return childIssuesIssueLimitUrls;
    };
    const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
        const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
        return childIssuesIssueLimitUrls?.[fieldId];
    };
    const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
        const [isModal] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsModal)();
        return isModal;
    };
    const $9e67f38435565e11$export$22108eca27445997 = ()=>{
        const [issueKey] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueKey)();
        return issueKey;
    };
    const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
        const [issueId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueId)();
        return issueId;
    };
    const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
        const [isArchived] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsArchived)();
        return isArchived;
    };
    const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
        const [isClassifyEditEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsClassifyEditEnabled)();
        return isClassifyEditEnabled;
    };
    const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
        const [issueKey] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueKey)();
        return (0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
    };
    const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
        const [analyticsSource] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreAnalyticsSource)();
        return analyticsSource;
    };
    const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
        const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setIssueContext: setIssueContext,
                mergeIssueContext: mergeIssueContext,
                getChildIssuesLimit: getChildIssuesLimit,
                getMaxTokenLength: getMaxTokenLength,
                getIsLoadedWithPage: getIsLoadedWithPage,
                getBackButtonUrl: getBackButtonUrl,
                getIsSpaEnabled: getIsSpaEnabled,
                getIssueKey: getIssueKey,
                setDetailViewAsModal: setDetailViewAsModal,
                setDetailViewAsSidebar: setDetailViewAsSidebar,
                resetDetailView: resetDetailView
            }), [
            setIssueContext,
            mergeIssueContext,
            getChildIssuesLimit,
            getMaxTokenLength,
            getIsLoadedWithPage,
            getBackButtonUrl,
            getIsSpaEnabled,
            getIssueKey,
            setDetailViewAsModal,
            setDetailViewAsSidebar,
            resetDetailView
        ]);
        return [
            undefined,
            actions
        ];
    };
    const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
        const [rapidViewMap] = (0, (0, parcelRequire("koiRX")).useIssueContextRapidViewMap)();
        return rapidViewMap;
    };
    const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
        const [maxTokenLength] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreMaxTokenLength)();
        return maxTokenLength;
    };
    const $9e67f38435565e11$export$b4199f923267161e = ()=>{
        const [isLoadedWithPage] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsLoadedWithPage)();
        return isLoadedWithPage;
    };
    const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
        const [estimationStatistic] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreEstimationStatistic)();
        return estimationStatistic;
    };
    const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
        const [isLoading] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsLoading)();
        return isLoading;
    };
    const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
        const [viewMode] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreViewMode)();
        return viewMode;
    };
    const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
        const [backButtonUrl] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBackButtonUrl)();
        return backButtonUrl;
    };
    const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
        const [issueNavigatorData] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueNavigatorData)();
        return issueNavigatorData;
    };
    const $9e67f38435565e11$export$b49754504c41149f = ()=>{
        const [boardId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBoardId)();
        return boardId;
    };
    const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
        const [boardType] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBoardType)();
        return boardType;
    };
    const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
        const [isSpaEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsSpaEnabled)();
        return isSpaEnabled;
    };
    const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
        const [loginRedirectUrl] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreLoginRedirctUrl)();
        return loginRedirectUrl;
    };
    const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
        const [onIssueKeyChange] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreOnIssueKeyChange)();
        return onIssueKeyChange;
    };
    const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
        const [rapidViewId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreRapidViewId)();
        return rapidViewId;
    };
    const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
        const [viewScreenId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreViewScreenId)();
        return viewScreenId;
    };
    const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const licenseStates = (0, (0, parcelRequire("7trqb")).useLicenseStates)();
        const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_ACTIVE);
        return licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
    };
    const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
        const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
        return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
    };
    const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
        const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
        return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
    };
    const $9e67f38435565e11$export$b131d9f6da853161 = ()=>{
        const [isAiOptInEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextIsAiOptInEnabled)();
        return isAiOptInEnabled;
    };
    const $9e67f38435565e11$export$db5174c7538abe4b = ()=>{
        const [isAiEnabledForIssue] = (0, (0, parcelRequire("koiRX")).useIssueContextIsAiEnabledForIssue)();
        return isAiEnabledForIssue;
    };
    const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
        const issueKey = $9e67f38435565e11$export$22108eca27445997();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        return [
            (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT),
            (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
        ].some((type)=>type === projectType);
    };
});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("7trqb", function(module, exports) {
    $parcel$export(module.exports, "useLicenseStates", ()=>$5fcaa3f734e9c444$export$268651a63abe408a);
    var $9OXo1;
    const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.licenseStates;
    };
});
parcelRegister("hqBSi", function(module, exports) {
    $parcel$export(module.exports, "useLicensedProducts", ()=>$7564850c0894983d$export$54d534cc91e54850);
    var $9OXo1;
    const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.licensedProducts || {};
    };
});
parcelRegister("koiRX", function(module, exports) {
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", ()=>$35da250daae5206d$export$abdbea56d86b4aac);
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", ()=>$35da250daae5206d$export$326ff2b963d51c5c);
    $parcel$export(module.exports, "useIssueContextStoreIssueKey", ()=>$35da250daae5206d$export$44bcaaabb74e402b);
    $parcel$export(module.exports, "useIssueContextStoreIssueId", ()=>$35da250daae5206d$export$332dcee0cf9f4e45);
    $parcel$export(module.exports, "useIssueContextStoreIsArchived", ()=>$35da250daae5206d$export$c940355b1fc6e1c4);
    $parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", ()=>$35da250daae5206d$export$b9eebaa1da421997);
    $parcel$export(module.exports, "useIssueContextStoreIsModal", ()=>$35da250daae5206d$export$daa47fd600e43a32);
    $parcel$export(module.exports, "useIssueContextStoreViewScreenId", ()=>$35da250daae5206d$export$ba2e9546ab5ba6f);
    $parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", ()=>$35da250daae5206d$export$74d38d6c437efc1b);
    $parcel$export(module.exports, "useIssueContextRapidViewMap", ()=>$35da250daae5206d$export$2092528ee170d9e7);
    $parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", ()=>$35da250daae5206d$export$57898374e6239a5a);
    $parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", ()=>$35da250daae5206d$export$ff0264ec4c015dc1);
    $parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", ()=>$35da250daae5206d$export$6c8b81f6dca8c23d);
    $parcel$export(module.exports, "useIssueContextStoreIsLoading", ()=>$35da250daae5206d$export$fe7085456138f0fc);
    $parcel$export(module.exports, "useIssueContextStoreViewMode", ()=>$35da250daae5206d$export$c339e36468c12443);
    $parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", ()=>$35da250daae5206d$export$ef3bfa2642bb98cd);
    $parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", ()=>$35da250daae5206d$export$8accd063c74cd455);
    $parcel$export(module.exports, "useIssueContextStoreBoardId", ()=>$35da250daae5206d$export$e7edffc2a20027e7);
    $parcel$export(module.exports, "useIssueContextStoreBoardType", ()=>$35da250daae5206d$export$48aaa3a6bc2085d7);
    $parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", ()=>$35da250daae5206d$export$4a4b96bcf5166327);
    $parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", ()=>$35da250daae5206d$export$bbd8ba0180545556);
    $parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", ()=>$35da250daae5206d$export$aaa89627762c7d00);
    $parcel$export(module.exports, "useIssueContextStoreRapidViewId", ()=>$35da250daae5206d$export$796589b0ec52848a);
    $parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", ()=>$35da250daae5206d$export$7e70ee570119a0a7);
    $parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", ()=>$35da250daae5206d$export$455ae7fd9d68b157);
    $parcel$export(module.exports, "IssueContextContainer", ()=>$35da250daae5206d$export$93db6a8f3342dddf);
    $parcel$export(module.exports, "useIssueContextStoreActions", ()=>$35da250daae5206d$export$965360ae27fcae98);
    var $g5X3G;
    var $7JoAD = parcelRequire("7JoAD");
    var $fMAcJ;
    var $iElCl;
    var $edJtc;
    const $35da250daae5206d$export$d4c72bab9d6cc13a = {
        childIssuesLimit: undefined,
        childIssuesIssueLimitUrls: undefined,
        issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(''),
        isArchived: false,
        isClassifyEditEnabled: false,
        isModal: false,
        maxTokenLength: 0,
        isLoadedWithPage: false,
        rapidViewMap: undefined,
        estimationStatistic: undefined,
        isLoading: false,
        viewMode: (0, (0, parcelRequire("edJtc")).getViewModeFromLocalStorage)(),
        analyticsSource: undefined,
        backButtonUrl: undefined,
        issueNavigatorData: undefined,
        boardId: undefined,
        boardType: undefined,
        isSpaEnabled: false,
        loginRedirectUrl: undefined,
        onIssueKeyChange: undefined,
        rapidViewId: undefined,
        viewScreenId: undefined,
        isAiOptInEnabled: false,
        isAiEnabledForIssue: false
    };
    const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
        name: 'issue-context',
        initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("fMAcJ")).actions
    });
    const $35da250daae5206d$var$getIssueContext = (state)=>state;
    const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
    const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
    const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
    const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
    const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
    const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
    const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
    const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
    const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
    const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
    const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
    const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
    const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
    const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
    const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
    const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
    const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
    const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
    const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
    const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
    const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
    const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
    const $35da250daae5206d$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
    const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueContext
    });
    const $35da250daae5206d$export$abdbea56d86b4aac = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("iElCl")).getChildIssuesLimit)
    });
    const $35da250daae5206d$export$326ff2b963d51c5c = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("iElCl")).getChildIssuesIssueLimitUrls)
    });
    const $35da250daae5206d$export$44bcaaabb74e402b = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueKey
    });
    const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueId
    });
    const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsArchived
    });
    const $35da250daae5206d$export$b9eebaa1da421997 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsClassifyEditEnabled
    });
    const $35da250daae5206d$export$daa47fd600e43a32 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsModal
    });
    const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getViewScreenId
    });
    const $35da250daae5206d$export$74d38d6c437efc1b = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getAnalyticsSource
    });
    const $35da250daae5206d$export$2092528ee170d9e7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getRapidViewMap
    });
    const $35da250daae5206d$export$57898374e6239a5a = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getMaxTokenLength
    });
    const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsLoadedWithPage
    });
    const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getEstimationStatistic
    });
    const $35da250daae5206d$export$fe7085456138f0fc = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsLoading
    });
    const $35da250daae5206d$export$c339e36468c12443 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getViewMode
    });
    const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBackButtonUrl
    });
    const $35da250daae5206d$export$8accd063c74cd455 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueNavigatorData
    });
    const $35da250daae5206d$export$e7edffc2a20027e7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBoardId
    });
    const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBoardType
    });
    const $35da250daae5206d$export$4a4b96bcf5166327 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsSpaEnabled
    });
    const $35da250daae5206d$export$bbd8ba0180545556 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getLoginRedirectUrl
    });
    const $35da250daae5206d$export$aaa89627762c7d00 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getOnIssueKeyChange
    });
    const $35da250daae5206d$export$796589b0ec52848a = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getRapidViewId
    });
    const $35da250daae5206d$export$7e70ee570119a0a7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsAiOptInEnabled
    });
    const $35da250daae5206d$export$455ae7fd9d68b157 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getisAiEnabledForIssue
    });
    const $35da250daae5206d$export$93db6a8f3342dddf = (0, $7JoAD.createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
    const $35da250daae5206d$export$965360ae27fcae98 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("fMAcJ", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$043cabfbcc6107f0$export$e324594224ef24da);
    var $7l48d;
    var $iElCl;
    var $edJtc;
    const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
                ...issueContext,
                issueId: undefined,
                viewMode: issueContext.viewMode || getState().viewMode
            });
            else setState({
                ...issueContext,
                viewMode: issueContext.viewMode || getState().viewMode
            });
        };
    const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
                ...getState(),
                ...partialIssueContext,
                issueId: undefined
            });
            else setState({
                ...getState(),
                ...partialIssueContext
            });
        };
    const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, (0, parcelRequire("iElCl")).getChildIssuesLimit)(getState());
    const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
    const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
    const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
    const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
    const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
    const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
    const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, (0, parcelRequire("7l48d")).localStorage).set((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY), 'MODAL');
            setState({
                viewMode: 'MODAL'
            });
        };
    const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, (0, parcelRequire("7l48d")).localStorage).set((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
            setState({
                viewMode: 'SIDEBAR'
            });
        };
    const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
            setState({
                viewMode: (0, (0, parcelRequire("edJtc")).getViewModeFromLocalStorage)()
            });
        };
    const $043cabfbcc6107f0$export$e324594224ef24da = {
        setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
        mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
        getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
        getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
        getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
        getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
        getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
        getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
        getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
        setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
        setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
        resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78
    };
});
parcelRegister("7l48d", function(module, exports) {
    $parcel$export(module.exports, "LOG_LOCATION", ()=>$e736233a6ed098e3$export$25a759e49d5049db);
    $parcel$export(module.exports, "localStorage", ()=>$e736233a6ed098e3$export$c2ed3351cac403d1);
    $parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", ()=>$e736233a6ed098e3$export$a13f7f627010bccd);
    var $bSSG7;
    const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
    const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_issue_view');
    const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';
});
parcelRegister("iElCl", function(module, exports) {
    $parcel$export(module.exports, "getChildIssuesLimit", ()=>$fde75c94a28741e3$export$89b6937a83edcaa6);
    $parcel$export(module.exports, "getChildIssuesIssueLimitUrls", ()=>$fde75c94a28741e3$export$8f43520910e8128c);
    var $dJl1T;
    var $7l48d;
    const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
    const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(`${(0, (0, parcelRequire("7l48d")).LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
        return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
    };
    const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
    const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;
});
parcelRegister("edJtc", function(module, exports) {
    $parcel$export(module.exports, "getViewModeFromLocalStorage", ()=>$75ce4ce78f606e67$export$cae7c4c591dcc261);
    var $7l48d;
    const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>(0, (0, parcelRequire("7l48d")).localStorage).get((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
});
parcelRegister("aQLD7", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "actions", ()=>$0ebe24e18a9cec5a$export$e324594224ef24da);
    var $gVnoy;
    var $bvqNo;
    const $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a = {
        confluenceData: {
            contentId: '',
            contentUrl: '',
            contentData: null,
            mode: (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            isDraft: false,
            isLive: false
        },
        contentActions: {},
        contentType: (0, (0, parcelRequire("bvqNo")).ConfluenceContentTypes).PAGE,
        embeddedConfluenceSource: '',
        displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL,
        panel: {
            initialWidth: 0,
            isOpen: false,
            isLoading: false
        },
        modal: {
            isOpen: false
        }
    };
    const $0ebe24e18a9cec5a$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
            setState({
                confluenceData: {
                    contentId: contentId,
                    contentUrl: url,
                    contentData: data,
                    hostname: hostname,
                    mode: mode,
                    isDraft: isDraft,
                    isLive: isLive,
                    title: title
                },
                contentActions: {
                    onLinkPage: onLinkPage,
                    onPublish: onPublish
                },
                embeddedConfluenceSource: embeddedConfluenceSource,
                contentType: contentType,
                displayType: displayType,
                panel: {
                    initialWidth: initialWidth,
                    isOpen: !shouldOpenModal
                },
                modal: {
                    isOpen: shouldOpenModal
                }
            });
        };
    const $0ebe24e18a9cec5a$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
            setState($0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
        };
    const $0ebe24e18a9cec5a$export$1a38f537b5932219 = (deferredSpaceName)=>({ setState: setState, getState: getState })=>{
            const { confluenceData: confluenceData, ...prevState } = getState();
            setState({
                confluenceData: {
                    ...confluenceData,
                    deferredSpaceName: deferredSpaceName
                },
                ...prevState
            });
        };
    const $0ebe24e18a9cec5a$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
            const { panel: panel, ...prevState } = getState();
            setState({
                ...prevState,
                isDeferSpaceSelection: isDeferSpaceSelection,
                panel: {
                    ...panel,
                    isLoading: isLoading
                }
            });
        };
    const $0ebe24e18a9cec5a$export$e324594224ef24da = {
        closeSidePanel: $0ebe24e18a9cec5a$export$e81b26ab493ca52a,
        setDeferredSpaceName: $0ebe24e18a9cec5a$export$1a38f537b5932219,
        openSidePanel: $0ebe24e18a9cec5a$export$aa5d06fef96639ba,
        setIsLoadingForDeferSpaceSelection: $0ebe24e18a9cec5a$export$db9852cd4946540a
    };
});
parcelRegister("gVnoy", function(module, exports) {
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", ()=>$7526d97b8e22777b$export$816ef638e478449a);
    var $7526d97b8e22777b$export$816ef638e478449a;
    (function(EMBEDDED_CONFLUENCE_MODE) {
        EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
        EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    })($7526d97b8e22777b$export$816ef638e478449a || ($7526d97b8e22777b$export$816ef638e478449a = {}));
});
parcelRegister("bvqNo", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceContentTypes", ()=>$ea031aa9e3d5ef89$export$b39616d00ee96d40);
    $parcel$export(module.exports, "DisplayTypes", ()=>$ea031aa9e3d5ef89$export$c294d3f3727c1a0);
    const $ea031aa9e3d5ef89$export$b39616d00ee96d40 = {
        WHITEBOARD: 'whiteboard',
        PAGE: 'page'
    };
    const $ea031aa9e3d5ef89$export$c294d3f3727c1a0 = {
        MODAL: 'modal',
        PANEL: 'panel'
    };
});
parcelRegister("5labn", function(module, exports) {
    $parcel$export(module.exports, "getDisplayInformation", ()=>$e7deee7a3cbc4953$export$ee79869f97207574);
    var $bvqNo;
    const $e7deee7a3cbc4953$export$37e31995727dc8d7 = 0.5;
    const $e7deee7a3cbc4953$export$ee79869f97207574 = ()=>{
        const screenWidth = window.innerWidth;
        if (screenWidth >= 1024) return {
            initialWidth: screenWidth * $e7deee7a3cbc4953$export$37e31995727dc8d7,
            displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL
        };
        return {
            initialWidth: 0,
            displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).MODAL
        };
    };
});
parcelRegister("9V9QO", function(module, exports) {
    $parcel$export(module.exports, "useEmbeddedPanelEntryPoint", ()=>$a6b6d10e82ec149e$export$75ef2f025ecbf1de);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $idTx8;
    var $gXSrH;
    var $7XluA;
    var $4mO32;
    var $co1wz;
    var $koVbs;
    var $2POIy;
    var $iwjqc;
    var $4TSh0;
    var $fvjUj;
    const $a6b6d10e82ec149e$var$entryPointParams = {};
    const $a6b6d10e82ec149e$export$75ef2f025ecbf1de = ()=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [state, actions] = (0, (0, parcelRequire("gXSrH")).useEmbeddedConfluenceSidePanel)();
        const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
        const parentProduct = (0, (0, parcelRequire("fvjUj")).useParentProduct)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("2POIy")).embeddedPanelEntrypoint), $a6b6d10e82ec149e$var$entryPointParams);
        const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
        const deferSpaceToast = (0, (0, parcelRequire("co1wz")).ff)('toast_defer_space_ntufi');
        const isTemplateBrowserEnabled = (0, (0, parcelRequire("co1wz")).ff)('jira.issue-view.create-confluence-page.template-browser');
        const fireAnalyticsEvent = (0, (0, parcelRequire("4TSh0")).useEmbeddedPageTracking)();
        const themeState = (0, (0, parcelRequire("hxoiH")).default)();
        const contentHostname = (0, (0, parcelRequire("iwjqc")).setHostnameForContent)(contentUrl, hostname);
        const onContentAction = (0, $5uXOq.useCallback)((action, eventName)=>{
            fireAnalyticsEvent({
                action: action,
                eventName: eventName,
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel
            });
        }, [
            fireAnalyticsEvent,
            embeddedConfluenceSourceForPanel
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: 'closeEmbeddedConfluencePanel',
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel
            });
            entryPointActions.unload();
            actions.closeSidePanel();
        }, [
            actions,
            fireAnalyticsEvent,
            entryPointActions,
            embeddedConfluenceSourceForPanel
        ]);
        const editAllowedFeatures = (0, $5uXOq.useMemo)(()=>[
                ...isDeferSpaceSelection ? [
                    'publish-modal'
                ] : [],
                ...isTemplateBrowserEnabled ? [
                    'template-browser'
                ] : []
            ], [
            isDeferSpaceSelection,
            isTemplateBrowserEnabled
        ]);
        const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
        const shouldOpenPanel = isOpen && contentUrl;
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                locale: locale,
                hasFooterLogo: false,
                isDraft: isDraft,
                isLive: isLive,
                hostname: contentHostname,
                panelTitle: title,
                navigationPolicy: undefined,
                onClose: onClose,
                onContentAction: onContentAction,
                parentProduct: parentProduct,
                spaceKey: (0, (0, parcelRequire("idTx8")).parseUrl)(contentUrl)?.spaceKey,
                themeState: themeState,
                url: contentUrl,
                mode: mode,
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
                contentId: contentId,
                contentType: contentType,
                ...deferSpaceToast && {
                    onPublish: actions.setDeferredSpaceName
                },
                allowedFeatures: {
                    view: [
                        'byline-contributors',
                        'byline-extensions',
                        'page-comments',
                        'page-reactions',
                        'inline-comments',
                        'non-licensed-share'
                    ],
                    ...shouldApplyEditFeatures && {
                        edit: editAllowedFeatures
                    }
                },
                linkConfluencePage: onLinkPage
            }), [
            actions.setDeferredSpaceName,
            contentId,
            contentType,
            contentUrl,
            deferSpaceToast,
            editAllowedFeatures,
            embeddedConfluenceSourceForPanel,
            contentHostname,
            isDraft,
            isLive,
            locale,
            title,
            mode,
            onClose,
            onContentAction,
            onLinkPage,
            parentProduct,
            themeState,
            shouldApplyEditFeatures
        ]);
        return shouldOpenPanel ? {
            entryPointActions: entryPointActions,
            entryPoint: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "epPanelEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: runtimeProps
            })
        } : {
            ref: undefined,
            entryPoint: null
        };
    };
});
parcelRegister("idTx8", function(module, exports) {
    $parcel$export(module.exports, "parsePageProps", ()=>$0293942286a77e0f$export$41eb0a358b69a9df);
    $parcel$export(module.exports, "parseUrl", ()=>$0293942286a77e0f$export$7a5253c0f62e0150);
    var $6vAaw = parcelRequire("6vAaw");
    var $70VoX;
    var $imVhc;
    var $39itI;
    var $gVnoy;
    var $jFSxp;
    function $0293942286a77e0f$export$41eb0a358b69a9df(props) {
        let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, ...passThroughProps } = props;
        const parsedAllowedFeatures = $0293942286a77e0f$export$350c411f568eceb9(allowedFeatures);
        if (!url) return {
            contentId: contentId,
            hostname: hostname,
            parentProduct: parentProduct,
            spaceKey: spaceKey,
            protocol: 'https:',
            mode: mode ?? (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            allowedFeatures: parsedAllowedFeatures,
            draftShareId: draftShareId,
            hash: hash,
            themeState: themeState,
            ...passThroughProps
        };
        const parsedProps = $0293942286a77e0f$export$7a5253c0f62e0150(url);
        if (!parsedProps) return {
            hostname: hostname,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct,
            mode: mode,
            protocol: 'https:',
            allowedFeatures: parsedAllowedFeatures,
            draftShareId: draftShareId,
            hash: hash,
            themeState: themeState,
            ...passThroughProps
        };
        const themeStateParsedObject = parsedProps.themeState ? (0, (0, parcelRequire("imVhc")).themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
        contentId = contentId || parsedProps.contentId;
        parentProduct = parentProduct || parsedProps.parentProduct;
        hostname = hostname || parsedProps.hostname || window.location.hostname;
        spaceKey = spaceKey || parsedProps.spaceKey;
        draftShareId = draftShareId || parsedProps.draftShareId;
        hash = hash || parsedProps.hash;
        themeState = themeState || themeStateParsedObject;
        let modeFromUrl;
        switch(parsedProps.route){
            case (0, (0, parcelRequire("jFSxp")).VIEW_PAGE).name:
            case (0, (0, parcelRequire("jFSxp")).VIEW_BLOG).name:
            case (0, (0, parcelRequire("jFSxp")).VIEW_BLOG_DATE_LEGACY).name:
                modeFromUrl = (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
                break;
            case (0, (0, parcelRequire("jFSxp")).EDIT_PAGE_EMBED).name:
            case (0, (0, parcelRequire("jFSxp")).EDIT_PAGE_V2).name:
                modeFromUrl = (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
        }
        return {
            allowedFeatures: $0293942286a77e0f$export$350c411f568eceb9(allowedFeatures),
            contentId: contentId,
            draftShareId: draftShareId,
            hash: hash,
            hostname: hostname,
            mode: mode || modeFromUrl,
            parentProduct: parentProduct,
            protocol: parsedProps.protocol,
            spaceKey: spaceKey,
            themeState: themeState,
            ...passThroughProps
        };
    }
    function $0293942286a77e0f$export$7a5253c0f62e0150(url) {
        if (!url) return null;
        const matchedRoute = $0293942286a77e0f$var$findAndMatchRoute((0, (0, parcelRequire("jFSxp")).namedRoutes), url);
        if (!matchedRoute) return null;
        const { routeName: routeName, ...match } = matchedRoute;
        return {
            route: routeName,
            hostname: match.host,
            protocol: match.protocol,
            contentId: match.params.contentId || '',
            spaceKey: match.params.spaceKey || '',
            hash: match.hash,
            parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
            draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
            themeState: match.query.themeState
        };
    }
    function $0293942286a77e0f$var$findAndMatchRoute(routes, url) {
        for (const routeName of Object.keys(routes)){
            const pattern = routes[routeName].pattern;
            const match = $0293942286a77e0f$var$matchUrl(pattern, url);
            if (match) return {
                routeName: routeName,
                ...match
            };
        }
    }
    function $0293942286a77e0f$var$matchUrl(pattern, url) {
        const parsed = (0, ($parcel$interopDefault($6vAaw))).parse(url, true);
        const pathname = parsed.pathname || '';
        let match = (0, (0, parcelRequire("70VoX")).default)(pathname, {
            path: pattern,
            exact: true
        });
        if (!match) match = (0, (0, parcelRequire("70VoX")).default)(`${pathname}${parsed.search}`, {
            path: pattern,
            exact: true
        });
        if (!match) return null;
        const decodedParams = {};
        if (match && match.params) for (const [key, value] of Object.entries(match.params))decodedParams[key] = value;
        return {
            url: url,
            protocol: parsed?.protocol || 'https:',
            host: parsed?.host || '',
            pathname: pathname,
            search: parsed.search || '',
            hash: parsed.hash || '',
            pattern: pattern,
            params: decodedParams,
            query: parsed.query || ''
        };
    }
    function $0293942286a77e0f$export$350c411f568eceb9(allowedFeatures) {
        let parsedAllowedFeatures = {
            view: allowedFeatures?.view,
            edit: allowedFeatures?.edit
        };
        if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
            ...(0, (0, parcelRequire("39itI")).DEFAULT_ALLOWED_FEATURES).view,
            'edit'
        ];
        else if (Array.isArray(allowedFeatures?.view)) parsedAllowedFeatures.view = [
            ...allowedFeatures?.view,
            'edit'
        ];
        return parsedAllowedFeatures;
    }
});
parcelRegister("70VoX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51b50f39010f1f0a$export$2e2bcd8739ae039);
    var $d4Ora = parcelRequire("d4Ora");
    var $51b50f39010f1f0a$var$patternCache = {};
    var $51b50f39010f1f0a$var$cacheLimit = 10000;
    var $51b50f39010f1f0a$var$cacheCount = 0;
    var $51b50f39010f1f0a$var$compilePath = function compilePath(pattern, options) {
        var cacheKey = "" + options.end + options.strict + options.sensitive;
        var cache = $51b50f39010f1f0a$var$patternCache[cacheKey] || ($51b50f39010f1f0a$var$patternCache[cacheKey] = {});
        if (cache[pattern]) return cache[pattern];
        var keys = [];
        var re = (0, ($parcel$interopDefault($d4Ora)))(pattern, keys, options);
        var compiledPattern = {
            re: re,
            keys: keys
        };
        if ($51b50f39010f1f0a$var$cacheCount < $51b50f39010f1f0a$var$cacheLimit) {
            cache[pattern] = compiledPattern;
            $51b50f39010f1f0a$var$cacheCount++;
        }
        return compiledPattern;
    };
    var $51b50f39010f1f0a$var$matchPath = function matchPath(pathname) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var parent = arguments[2];
        if (typeof options === "string") options = {
            path: options
        };
        var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
        if (path == null) return parent;
        var _compilePath = $51b50f39010f1f0a$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), re = _compilePath.re, keys = _compilePath.keys;
        var match = re.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === "/" && url === "" ? "/" : url,
            isExact: isExact,
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    };
    var $51b50f39010f1f0a$export$2e2bcd8739ae039 = $51b50f39010f1f0a$var$matchPath;
});
parcelRegister("d4Ora", function(module, exports) {
    var $oJ7gO = parcelRequire("oJ7gO");
    module.exports = $9852c5da38ba91d1$var$pathToRegexp;
    module.exports.parse = $9852c5da38ba91d1$var$parse;
    module.exports.compile = $9852c5da38ba91d1$var$compile;
    module.exports.tokensToFunction = $9852c5da38ba91d1$var$tokensToFunction;
    module.exports.tokensToRegExp = $9852c5da38ba91d1$var$tokensToRegExp;
    var $9852c5da38ba91d1$var$PATH_REGEXP = new RegExp([
        '(\\\\.)',
        '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
    ].join('|'), 'g');
    function $9852c5da38ba91d1$var$parse(str, options) {
        var tokens = [];
        var key = 0;
        var index = 0;
        var path = '';
        var defaultDelimiter = options && options.delimiter || '/';
        var res;
        while((res = $9852c5da38ba91d1$var$PATH_REGEXP.exec(str)) != null){
            var m = res[0];
            var escaped = res[1];
            var offset = res.index;
            path += str.slice(index, offset);
            index = offset + m.length;
            if (escaped) {
                path += escaped[1];
                continue;
            }
            var next = str[index];
            var prefix = res[2];
            var name = res[3];
            var capture = res[4];
            var group = res[5];
            var modifier = res[6];
            var asterisk = res[7];
            if (path) {
                tokens.push(path);
                path = '';
            }
            var partial = prefix != null && next != null && next !== prefix;
            var repeat = modifier === '+' || modifier === '*';
            var optional = modifier === '?' || modifier === '*';
            var delimiter = prefix || defaultDelimiter;
            var pattern = capture || group;
            var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
            tokens.push({
                name: name || key++,
                prefix: prefix || '',
                delimiter: delimiter,
                optional: optional,
                repeat: repeat,
                partial: partial,
                asterisk: !!asterisk,
                pattern: pattern ? $9852c5da38ba91d1$var$escapeGroup(pattern) : asterisk ? '.*' : $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText)
            });
        }
        if (index < str.length) path += str.substr(index);
        if (path) tokens.push(path);
        return tokens;
    }
    function $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText) {
        if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + ']+?';
        return $9852c5da38ba91d1$var$escapeString(prevText) + '|(?:(?!' + $9852c5da38ba91d1$var$escapeString(prevText) + ')[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + '])+?';
    }
    function $9852c5da38ba91d1$var$compile(str, options) {
        return $9852c5da38ba91d1$var$tokensToFunction($9852c5da38ba91d1$var$parse(str, options), options);
    }
    function $9852c5da38ba91d1$var$encodeURIComponentPretty(str) {
        return encodeURI(str).replace(/[\/?#]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    }
    function $9852c5da38ba91d1$var$encodeAsterisk(str) {
        return encodeURI(str).replace(/[?#]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    }
    function $9852c5da38ba91d1$var$tokensToFunction(tokens, options) {
        var matches = new Array(tokens.length);
        for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $9852c5da38ba91d1$var$flags(options));
        return function(obj, opts) {
            var path = '';
            var data = obj || {};
            var options = opts || {};
            var encode = options.pretty ? $9852c5da38ba91d1$var$encodeURIComponentPretty : encodeURIComponent;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (typeof token === 'string') {
                    path += token;
                    continue;
                }
                var value = data[token.name];
                var segment;
                if (value == null) {
                    if (token.optional) {
                        if (token.partial) path += token.prefix;
                        continue;
                    } else throw new TypeError('Expected "' + token.name + '" to be defined');
                }
                if ($oJ7gO(value)) {
                    if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                    if (value.length === 0) {
                        if (token.optional) continue;
                        else throw new TypeError('Expected "' + token.name + '" to not be empty');
                    }
                    for(var j = 0; j < value.length; j++){
                        segment = encode(value[j]);
                        if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                        path += (j === 0 ? token.prefix : token.delimiter) + segment;
                    }
                    continue;
                }
                segment = token.asterisk ? $9852c5da38ba91d1$var$encodeAsterisk(value) : encode(value);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
                path += token.prefix + segment;
            }
            return path;
        };
    }
    function $9852c5da38ba91d1$var$escapeString(str) {
        return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
    }
    function $9852c5da38ba91d1$var$escapeGroup(group) {
        return group.replace(/([=!:$\/()])/g, '\\$1');
    }
    function $9852c5da38ba91d1$var$attachKeys(re, keys) {
        re.keys = keys;
        return re;
    }
    function $9852c5da38ba91d1$var$flags(options) {
        return options && options.sensitive ? '' : 'i';
    }
    function $9852c5da38ba91d1$var$regexpToRegexp(path, keys) {
        var groups = path.source.match(/\((?!\?)/g);
        if (groups) for(var i = 0; i < groups.length; i++)keys.push({
            name: i,
            prefix: null,
            delimiter: null,
            optional: false,
            repeat: false,
            partial: false,
            asterisk: false,
            pattern: null
        });
        return $9852c5da38ba91d1$var$attachKeys(path, keys);
    }
    function $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options) {
        var parts = [];
        for(var i = 0; i < path.length; i++)parts.push($9852c5da38ba91d1$var$pathToRegexp(path[i], keys, options).source);
        var regexp = new RegExp('(?:' + parts.join('|') + ')', $9852c5da38ba91d1$var$flags(options));
        return $9852c5da38ba91d1$var$attachKeys(regexp, keys);
    }
    function $9852c5da38ba91d1$var$stringToRegexp(path, keys, options) {
        return $9852c5da38ba91d1$var$tokensToRegExp($9852c5da38ba91d1$var$parse(path, options), keys, options);
    }
    function $9852c5da38ba91d1$var$tokensToRegExp(tokens, keys, options) {
        if (!$oJ7gO(keys)) {
            options = keys || options;
            keys = [];
        }
        options = options || {};
        var strict = options.strict;
        var end = options.end !== false;
        var route = '';
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') route += $9852c5da38ba91d1$var$escapeString(token);
            else {
                var prefix = $9852c5da38ba91d1$var$escapeString(token.prefix);
                var capture = '(?:' + token.pattern + ')';
                keys.push(token);
                if (token.repeat) capture += '(?:' + prefix + capture + ')*';
                if (token.optional) {
                    if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                    else capture = prefix + '(' + capture + ')?';
                } else capture = prefix + '(' + capture + ')';
                route += capture;
            }
        }
        var delimiter = $9852c5da38ba91d1$var$escapeString(options.delimiter || '/');
        var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
        if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
        if (end) route += '$';
        else route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
        return $9852c5da38ba91d1$var$attachKeys(new RegExp('^' + route, $9852c5da38ba91d1$var$flags(options)), keys);
    }
    function $9852c5da38ba91d1$var$pathToRegexp(path, keys, options) {
        if (!$oJ7gO(keys)) {
            options = keys || options;
            keys = [];
        }
        options = options || {};
        if (path instanceof RegExp) return $9852c5da38ba91d1$var$regexpToRegexp(path, keys);
        if ($oJ7gO(path)) return $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options);
        return $9852c5da38ba91d1$var$stringToRegexp(path, keys, options);
    }
});
parcelRegister("oJ7gO", function(module, exports) {
    module.exports = Array.isArray || function(arr) {
        return Object.prototype.toString.call(arr) == '[object Array]';
    };
});
parcelRegister("39itI", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", ()=>$1f1e6a2159ff566d$export$a33327ada3a6ee4a);
    $parcel$export(module.exports, "getAllowedFeatures", ()=>$1f1e6a2159ff566d$export$3207c60940c4a9b0);
    var $6BeA7;
    var $gVnoy;
    var $1f1e6a2159ff566d$export$241b9888a4d565c9;
    (function(ALLOWED_FEATURES_TYPE) {
        ALLOWED_FEATURES_TYPE["VIEW"] = "view";
        ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
        ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    })($1f1e6a2159ff566d$export$241b9888a4d565c9 || ($1f1e6a2159ff566d$export$241b9888a4d565c9 = {}));
    const $1f1e6a2159ff566d$export$a3fda3dcee62e1cc = {
        view: [
            'byline-contributors',
            'byline-extensions',
            'delete',
            'edit',
            'inline-comments',
            'page-comments',
            'page-reactions',
            'sticky-header',
            'disable-login-flow',
            'disable-share',
            'non-licensed-share'
        ],
        edit: [
            'delete-draft',
            'disable-login-flow',
            'template-browser',
            'inline-comments'
        ],
        whiteboard: [
            'disable-login-flow',
            'copy',
            'favorite',
            'restrictions',
            'more-actions'
        ]
    };
    const $1f1e6a2159ff566d$export$a33327ada3a6ee4a = {
        view: [
            'byline-contributors',
            'byline-extensions',
            'page-comments',
            'page-reactions',
            'inline-comments'
        ],
        edit: [
            'inline-comments'
        ],
        whiteboard: [
            'copy',
            'favorite',
            'restrictions',
            'more-actions'
        ]
    };
    const $1f1e6a2159ff566d$var$pageAllowedFeatures = {
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.edit,
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.view
    };
    const $1f1e6a2159ff566d$var$blogPostAllowedFeatures = {
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.edit,
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.view
    };
    const $1f1e6a2159ff566d$var$whiteboardAllowedFeatures = {
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.whiteboard,
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.whiteboard
    };
    const $1f1e6a2159ff566d$var$contentTypeAllowedFeatures = {
        [(0, (0, parcelRequire("6BeA7")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $1f1e6a2159ff566d$var$pageAllowedFeatures,
        [(0, (0, parcelRequire("6BeA7")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $1f1e6a2159ff566d$var$blogPostAllowedFeatures,
        [(0, (0, parcelRequire("6BeA7")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $1f1e6a2159ff566d$var$whiteboardAllowedFeatures
    };
    const $1f1e6a2159ff566d$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$1f1e6a2159ff566d$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
});
parcelRegister("6BeA7", function(module, exports) {
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", ()=>$c56abe420938ba9a$export$942a5fac9b8c9dc2);
    var $c56abe420938ba9a$export$942a5fac9b8c9dc2;
    (function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    })($c56abe420938ba9a$export$942a5fac9b8c9dc2 || ($c56abe420938ba9a$export$942a5fac9b8c9dc2 = {}));
});
parcelRegister("jFSxp", function(module, exports) {
    $parcel$export(module.exports, "EDIT_PAGE_EMBED", ()=>$6edcdb1ec5605c32$export$e63a462ee45b57cf);
    $parcel$export(module.exports, "EDIT_PAGE_V2", ()=>$6edcdb1ec5605c32$export$7b1285e36c635f1f);
    $parcel$export(module.exports, "VIEW_PAGE", ()=>$6edcdb1ec5605c32$export$9257b5b55c8e2555);
    $parcel$export(module.exports, "VIEW_BLOG", ()=>$6edcdb1ec5605c32$export$91f49e7b30a9d34);
    $parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", ()=>$6edcdb1ec5605c32$export$bd2c9bb170b3681d);
    $parcel$export(module.exports, "namedRoutes", ()=>$6edcdb1ec5605c32$export$d4971375353d0454);
    $parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", ()=>$6edcdb1ec5605c32$export$5c59aa0922e65f1a);
    const $6edcdb1ec5605c32$export$e63a462ee45b57cf = {
        name: 'EDIT_PAGE_EMBED',
        pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$7b1285e36c635f1f = {
        name: 'EDIT_PAGE_V2',
        pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$65b723bb995d4fb6 = {
        name: 'SPACE_OVERVIEW',
        pattern: '/wiki/spaces/:spaceKey/overview'
    };
    const $6edcdb1ec5605c32$export$9257b5b55c8e2555 = {
        name: 'VIEW_PAGE',
        pattern: '/wiki/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$91f49e7b30a9d34 = {
        name: 'VIEW_BLOG',
        pattern: '/wiki/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$bd2c9bb170b3681d = {
        name: 'VIEW_BLOG_DATE_LEGACY',
        pattern: '/wiki/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$d4971375353d0454 = {
        EDIT_PAGE_EMBED: $6edcdb1ec5605c32$export$e63a462ee45b57cf,
        EDIT_PAGE_V2: $6edcdb1ec5605c32$export$7b1285e36c635f1f,
        SPACE_OVERVIEW: $6edcdb1ec5605c32$export$65b723bb995d4fb6,
        VIEW_PAGE: $6edcdb1ec5605c32$export$9257b5b55c8e2555,
        VIEW_BLOG: $6edcdb1ec5605c32$export$91f49e7b30a9d34,
        VIEW_BLOG_DATE_LEGACY: $6edcdb1ec5605c32$export$bd2c9bb170b3681d
    };
    const $6edcdb1ec5605c32$export$5c59aa0922e65f1a = {
        JSM_PORTAL: 'JSM-Portal',
        JSM: 'JSM',
        JSW: 'JSW',
        JWM: 'JWM'
    };
});
parcelRegister("2POIy", function(module, exports) {
    $parcel$export(module.exports, "embeddedPanelEntrypoint", ()=>$ae604dc9c27c8401$export$32561f984de7bece);
    var $eufEc;
    var $fEDBv;
    const $ae604dc9c27c8401$export$32561f984de7bece = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("eEEPC")), {
            moduleId: "293c24d0"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("eEEPC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("joESl")
    ]).then(()=>parcelRequire('k1Lui'));
});
parcelRegister("iwjqc", function(module, exports) {
    $parcel$export(module.exports, "createActivePageUrl", ()=>$5538d20fe7287eae$export$83c6318baef117fe);
    $parcel$export(module.exports, "getURLFromConfluencePageResponse", ()=>$5538d20fe7287eae$export$e87b28852220b5cd);
    $parcel$export(module.exports, "setHostnameForContent", ()=>$5538d20fe7287eae$export$8ccd4cc378896990);
    $parcel$export(module.exports, "constructUrlIfCustomDomain", ()=>$5538d20fe7287eae$export$a63ef4c6a1286e2a);
    $parcel$export(module.exports, "createLinkCreatePayload", ()=>$5538d20fe7287eae$export$af98278c506da0f4);
    var $Geeam;
    var $jg9TU;
    const $5538d20fe7287eae$export$f31b9480a5e4fdcf = (uri)=>{
        if (!uri || uri === '') return '';
        const matches = uri.match(/draftShareId=([^&])*/g);
        return matches ? matches[0].split('=')[1] : '';
    };
    const $5538d20fe7287eae$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
        if (!(url && spaceId && spaceKey)) return '';
        return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
    };
    const $5538d20fe7287eae$export$83c6318baef117fe = (createPayload)=>{
        const { data: data, url: url } = createPayload;
        const links = data?.links;
        const spaceKey = data?.spaceKey;
        const spaceId = data?.spaceId;
        const linkableUrl = $5538d20fe7287eae$export$be3b1ed3560ef0e6({
            url: url,
            spaceId: spaceId,
            spaceKey: spaceKey
        });
        if (data?.subType === 'live') return `${linkableUrl}`;
        return `${linkableUrl}?draftShareId=${$5538d20fe7287eae$export$f31b9480a5e4fdcf(links?.editui)}`;
    };
    const $5538d20fe7287eae$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
    const $5538d20fe7287eae$var$isUrlCustomDomain = (parentHost, url)=>{
        const hostname = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(url);
        return (0, (0, parcelRequire("jg9TU")).isCustomDomain)(parentHost) || hostname && (0, (0, parcelRequire("jg9TU")).isCustomDomain)(hostname);
    };
    const $5538d20fe7287eae$export$8ccd4cc378896990 = (url, hostname)=>{
        const parentHost = window?.location?.origin || '';
        const contentHost = hostname ?? (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(url);
        return $5538d20fe7287eae$var$isUrlCustomDomain(parentHost, url) ? (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(parentHost) : contentHost;
    };
    const $5538d20fe7287eae$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
        const currentHostname = window?.location?.origin || '';
        const hostnameFromUrl = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(originalDomain);
        const systemHostName = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(systemConfluenceAppLinkUrl);
        if (systemHostName !== hostnameFromUrl && $5538d20fe7287eae$var$isUrlCustomDomain(currentHostname, originalDomain)) return $5538d20fe7287eae$export$e87b28852220b5cd({
            id: id,
            spaceKey: spaceKey,
            hostname: currentHostname
        });
        return originalUrl;
    };
    const $5538d20fe7287eae$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
            url: url,
            ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
            objectId: createResponse.id,
            objectType: 'page',
            data: {
                spaceId: space.spaceId,
                spaceKey: space.spaceKey,
                spaceName: space.spaceName,
                status: createResponse.status,
                subType: createResponse.subType,
                links: createResponse._links
            }
        });
});
parcelRegister("Geeam", function(module, exports) {
    $parcel$export(module.exports, "getHostnameFromUrl", ()=>$43eec760bfcb2d7e$export$280e79c794cf814e);
    var $cN3DC;
    const $43eec760bfcb2d7e$export$280e79c794cf814e = (url)=>(0, (0, parcelRequire("cN3DC")).isValidUrl)(url) ? new URL(url)?.hostname : '';
});
parcelRegister("cN3DC", function(module, exports) {
    $parcel$export(module.exports, "isValidUrl", ()=>$8759602a30c2f837$export$bef94a5618bf18bf);
    const $8759602a30c2f837$export$bef94a5618bf18bf = (urlString)=>{
        if (typeof urlString !== 'string') return false;
        try {
            return Boolean(new URL(urlString));
        } catch (e) {
            return false;
        }
    };
});
parcelRegister("jg9TU", function(module, exports) {
    $parcel$export(module.exports, "isCustomDomain", ()=>$cbdd6bc245553e48$export$97f4c254b641e719);
    const $cbdd6bc245553e48$var$atlassianDomains = [
        '.atlassian.com',
        '.atlassian.net',
        '.jira-dev.com',
        '.jira.com',
        '.atlassian-stg-fedm.net',
        '.atlassian-us-gov-mod.net',
        '.atlassian-us-gov-mod.com'
    ];
    const $cbdd6bc245553e48$export$97f4c254b641e719 = (hostname)=>!$cbdd6bc245553e48$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));
});
parcelRegister("4TSh0", function(module, exports) {
    $parcel$export(module.exports, "useEmbeddedPageTracking", ()=>$391c3839ff18e3b3$export$9fcd107e4ed1de75);
    var $5uXOq = parcelRequire("5uXOq");
    var $2gCtH;
    var $2NMNM;
    var $9OXo1;
    var $gFmVN;
    var $kEkg3;
    const $391c3839ff18e3b3$export$9fcd107e4ed1de75 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const source = (0, (0, parcelRequire("2gCtH")).useAnalyticsSource)();
        const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, linkObjectType: linkObjectType, confluenceContentId: confluenceContentId })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject ?? `${eventName}`
            });
            const attributes = {
                parentProduct: (0, (0, parcelRequire("gFmVN")).getParentProduct)(projectType),
                tenantEditions: tenantContext?.appEditions,
                productEntitlementDetails: tenantContext?.productEntitlementDetails,
                embeddedConfluenceSource: embeddedConfluenceSource,
                jiraIssueSurfaceArea: source,
                userHasConfluenceAccess: userHasConfluenceAccess,
                tenantHasConfluence: tenantHasConfluence,
                crossJoinStatus: crossJoinStatus,
                originProduct: originProduct,
                requestedProduct: requestedProduct,
                isSiteAdmin: tenantContext?.isSiteAdmin,
                linkObjectType: linkObjectType,
                confluenceContentId: confluenceContentId
            };
            (0, (0, parcelRequire("kEkg3")).fireEmbeddedConfluenceAnalytics)({
                analyticsEvent: analyticsEvent,
                attributes: attributes,
                eventType: eventType,
                eventName: `${actionSubject ?? eventName} ${action}`
            });
        }, [
            source,
            tenantContext,
            createAnalyticsEvent
        ]);
        return trackEmbeddedConfluence;
    };
});
parcelRegister("gFmVN", function(module, exports) {
    $parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", ()=>$e40b1af8ddf646ed$export$b4e6d6efc113ca5);
    $parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", ()=>$e40b1af8ddf646ed$export$bf1e31028b579014);
    $parcel$export(module.exports, "ACCESS_DENIED_STATUSES", ()=>$e40b1af8ddf646ed$export$2fe5bb2d968b01fc);
    $parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", ()=>$e40b1af8ddf646ed$export$56360b096b4b4439);
    $parcel$export(module.exports, "getParentProduct", ()=>$e40b1af8ddf646ed$export$e873edb2560a07ef);
    var $2vSU6;
    const $e40b1af8ddf646ed$export$b4e6d6efc113ca5 = {
        ACCESS_GRANTED: 'ACCESS_GRANTED',
        ACCESS_EXISTS: 'ACCESS_EXISTS',
        DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
        DIRECT_ACCESS: 'DIRECT_ACCESS',
        FORBIDDEN: 'FORBIDDEN',
        PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
        REQUEST_ACCESS: 'REQUEST_ACCESS'
    };
    const $e40b1af8ddf646ed$export$bf1e31028b579014 = [
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_EXISTS,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_GRANTED,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
    ];
    const $e40b1af8ddf646ed$export$2fe5bb2d968b01fc = [
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.FORBIDDEN,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
    ];
    const $e40b1af8ddf646ed$export$56360b096b4b4439 = 'licence-exceeded';
    const $e40b1af8ddf646ed$export$e873edb2560a07ef = (projectType)=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return 'JSM';
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return 'JSW';
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 'JWM';
            default:
                return 'JSW';
        }
    };
});
parcelRegister("kEkg3", function(module, exports) {
    $parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", ()=>$502082c06cc8bb17$export$864bc2da9014e8e9);
    var $8zOmE;
    const $502082c06cc8bb17$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
        switch(eventType){
            case 'ui':
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
                break;
            case 'operational':
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
                break;
            case 'track':
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
                break;
            default:
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
                break;
        }
    };
});
parcelRegister("fvjUj", function(module, exports) {
    $parcel$export(module.exports, "useParentProduct", ()=>$af9df26010027d57$export$1b09c6e3737c8eb7);
    var $dAfqg;
    var $gFmVN;
    const $af9df26010027d57$export$1b09c6e3737c8eb7 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const projectType = data?.projectType;
        return (0, (0, parcelRequire("gFmVN")).getParentProduct)(projectType);
    };
});
parcelRegister("km1Z8", function(module, exports) {
    $parcel$export(module.exports, "ImperativeAPI", ()=>$b3ed488811f6683d$export$e2ad0ff52e7f8c84);
    var $5uXOq = parcelRequire("5uXOq");
    var $axSKo;
    var $jH6yN;
    const $b3ed488811f6683d$export$e2ad0ff52e7f8c84 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("axSKo")).Consumer), null, ({ getManager: getManager })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jH6yN")).ImperativeAPI), {
                getItemManager: getManager
            }));
});
parcelRegister("axSKo", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>$da7a6c3542bd9710$export$2881499e37b75b9a);
    $parcel$export(module.exports, "Consumer", ()=>$da7a6c3542bd9710$export$b3bffd4bb7da6b8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $fr1K2 = parcelRequire("fr1K2");
    var $itvk3;
    var $7KTvf;
    const $da7a6c3542bd9710$var$Context = (0, (0, parcelRequire("itvk3")).default)('ItemManagers');
    const $da7a6c3542bd9710$export$275138de3066e8b3 = 30000;
    class $da7a6c3542bd9710$export$2881499e37b75b9a extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($da7a6c3542bd9710$var$Context.Provider, {
                value: this.manager
            }, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                managers: {}
            };
            this.getManager = (managerKey)=>{
                const { managers: managers } = this.state;
                const manager = managers[managerKey];
                if (manager) return manager;
                return new Promise((resolve, reject)=>{
                    const message = `Timeout. "${(0, (0, parcelRequire("7KTvf")).fromManagerKey)(managerKey)}" wasn't registered after ${$da7a6c3542bd9710$export$275138de3066e8b3}ms`;
                    const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $da7a6c3542bd9710$export$275138de3066e8b3);
                    const { pendingManagers: pendingManagers } = this;
                    pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                    pendingManagers[managerKey].push((methods)=>{
                        clearTimeout(rejectTimeoutId);
                        resolve(methods);
                    });
                });
            };
            this.registerManager = (managerKey, methods)=>{
                this.setState((previousState)=>{
                    if (methods == null) return {
                        managers: (0, ($parcel$interopDefault($fr1K2)))(previousState.managers, managerKey)
                    };
                    const managerResolvers = this.pendingManagers[managerKey];
                    if (managerResolvers && managerResolvers.length) {
                        managerResolvers.forEach((resolve)=>resolve(methods));
                        managerResolvers.length = 0;
                    }
                    return {
                        managers: {
                            ...previousState.managers,
                            [managerKey]: Promise.resolve(methods)
                        }
                    };
                });
            };
            this.pendingManagers = {};
            this.manager = {
                getManager: this.getManager,
                registerManager: this.registerManager
            };
        }
    }
    const { Consumer: $da7a6c3542bd9710$export$b3bffd4bb7da6b8f } = $da7a6c3542bd9710$var$Context;
});
parcelRegister("itvk3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00b840b80ca03789$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $00b840b80ca03789$export$2e2bcd8739ae039 = (name)=>{
        const contextObjName = name || '';
        const defaultGetter = ()=>{
            throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
        };
        const Context = (0, $5uXOq.createContext)(defaultGetter);
        const ContextConsumer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Context.Consumer, null, (getValue)=>{
                const value = getValue();
                return props.children(value);
            });
        const ContextProvider = ({ value: value, children: children })=>{
            const getValue = ()=>value;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
                value: getValue
            }, children);
        };
        ContextProvider.displayName = `${contextObjName}SafeProvider`;
        ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
        return {
            Provider: ContextProvider,
            Consumer: ContextConsumer
        };
    };
});
parcelRegister("7KTvf", function(module, exports) {
    $parcel$export(module.exports, "fromManagerKey", ()=>$067bae373d6cebdd$export$fef172a673b3ef47);
    const $067bae373d6cebdd$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
    const $067bae373d6cebdd$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);
});
parcelRegister("jH6yN", function(module, exports) {
    $parcel$export(module.exports, "ImperativeAPI", ()=>$5d8d26c2e79a214b$export$e2ad0ff52e7f8c84);
    var $5uXOq = parcelRequire("5uXOq");
    var $9B86Q;
    var $dJl1T;
    var $7oGEb;
    var $1ADgn;
    var $gPQRI;
    var $1J3t1;
    var $jRCeJ;
    var $7KTvf;
    var $dIdda = parcelRequire("dIdda");
    var $fTkzd;
    const $5d8d26c2e79a214b$var$ERROR_LOCATION = 'legacy.imperative-api';
    const $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
        const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarController)();
        const { refresh: refresh } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)();
        const { push: push } = (0, $dIdda.useRouterActions)();
        const sidebarState = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const sidebarRef = (0, $5uXOq.useRef)(sidebarState);
        const refreshSidebarRef = (0, $5uXOq.useRef)(refresh);
        const imperativeAPIRef = (0, $5uXOq.useRef)({
            viewIds: (0, parcelRequire("fTkzd")).viewIds,
            itemIds: (0, parcelRequire("fTkzd")).itemIds,
            expand: expandLeftSidebar,
            collapse: collapseLeftSidebar,
            isCollapsed: ()=>sidebarRef.current.isCollapsed,
            onCollapse: ()=>undefined,
            onCollapseStart: ()=>undefined,
            onCollapseEnd: ()=>undefined,
            onExpand: ()=>undefined,
            onExpandStart: ()=>undefined,
            onExpandEnd: ()=>undefined,
            onItemClick: ()=>undefined,
            setView: ()=>undefined,
            updateActiveView: ()=>undefined,
            setProjectRootView: ()=>undefined,
            getActiveViewItems: ()=>[],
            isInProjectContext: ()=>false,
            updateContext: ()=>undefined,
            updateData: ()=>{
                refreshSidebarRef.current();
            },
            getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($5d8d26c2e79a214b$var$ERROR_LOCATION, `There was a problem getting "${(0, (0, parcelRequire("7KTvf")).fromManagerKey)(itemManagerKey)}" item manager`, e);
                    throw e;
                }),
            createBoard: ()=>{
                (0, (0, parcelRequire("1ADgn")).default)();
            },
            modalOpen: ()=>undefined,
            modalClose: ()=>undefined,
            navigate: (url)=>push(url)
        });
        sidebarRef.current = sidebarState;
        refreshSidebarRef.current = refresh;
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/navigation/bridge'
            }).then((bridge)=>{
                bridge(imperativeAPIRef.current);
            });
            (0, (0, parcelRequire("7oGEb")).provideNavigationApi)({
                navigate: push
            });
        }, [
            push
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRCeJ")).NavigationUIContainer), {
            isGlobal: true
        });
    };
});
parcelRegister("7oGEb", function(module, exports) {
    $parcel$export(module.exports, "provideNavigationApi", ()=>$6e1dad164f29ee43$export$26d28e8849b2805f);
    $parcel$export(module.exports, "isInIframe", ()=>$6e1dad164f29ee43$export$9f140ed41af5108c);
    $parcel$export(module.exports, "canSpaTransition", ()=>$6e1dad164f29ee43$export$59e771495885068f);
    $parcel$export(module.exports, "getContainerApi", ()=>$6e1dad164f29ee43$export$91ed870fd8df2bcb);
    $parcel$export(module.exports, "getNavigationApi", ()=>$6e1dad164f29ee43$export$da4e5a44286a0dd0);
    let $6e1dad164f29ee43$var$containerApi = null;
    let $6e1dad164f29ee43$var$navigationApi = null;
    const $6e1dad164f29ee43$export$3927fb5df700a968 = (api)=>{
        $6e1dad164f29ee43$var$containerApi = api;
    };
    const $6e1dad164f29ee43$export$26d28e8849b2805f = (api)=>{
        $6e1dad164f29ee43$var$navigationApi = api;
    };
    const $6e1dad164f29ee43$export$9f140ed41af5108c = ()=>$6e1dad164f29ee43$var$containerApi !== null;
    const $6e1dad164f29ee43$export$59e771495885068f = ()=>$6e1dad164f29ee43$var$navigationApi !== null;
    const $6e1dad164f29ee43$export$91ed870fd8df2bcb = ()=>$6e1dad164f29ee43$var$containerApi;
    const $6e1dad164f29ee43$export$da4e5a44286a0dd0 = ()=>$6e1dad164f29ee43$var$navigationApi;
    const $6e1dad164f29ee43$export$6ba42130b045ede1 = ()=>{
        $6e1dad164f29ee43$var$containerApi = null;
        $6e1dad164f29ee43$var$navigationApi = null;
    };
});
parcelRegister("1ADgn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a5ce13af6407cab$export$2e2bcd8739ae039);
    var $6BZYo;
    var $7T84i;
    var $4R6GH;
    const $7a5ce13af6407cab$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
    var $7a5ce13af6407cab$export$2e2bcd8739ae039 = async ()=>{
        let module;
        if ((0, (0, parcelRequire("4R6GH")).fg)('create_board_modal_replace_deprecated_load_bridge')) module = await (0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
            name: $7a5ce13af6407cab$var$amdModuleName,
            wrmKeys: [
                'wrc!com.pyxis.greenhopper.jira:gh-create-board'
            ]
        });
        else module = await (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: $7a5ce13af6407cab$var$amdModuleName
        });
        return module.openCreateBoardModal();
    };
});
parcelRegister("jRCeJ", function(module, exports) {
    $parcel$export(module.exports, "NavigationUISubscriber", ()=>$54656242ba3a5025$export$d3dc1c18cfde5ddd);
    $parcel$export(module.exports, "NavigationUIContainer", ()=>$54656242ba3a5025$export$339ec9ca159ad81f);
    var $7JoAD = parcelRequire("7JoAD");
    var $3h4uJ;
    const $54656242ba3a5025$export$d3dc1c18cfde5ddd = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("3h4uJ")).default), {
        displayName: 'NavigationUISubscriber',
        selector: null
    });
    const $54656242ba3a5025$export$339ec9ca159ad81f = (0, $7JoAD.createContainer)((0, (0, parcelRequire("3h4uJ")).default));
});
parcelRegister("3h4uJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ca73b0c81372577$export$2e2bcd8739ae039);
    var $7JoAD = parcelRequire("7JoAD");
    var $8pFbi;
    const $8ca73b0c81372577$var$initialState = {
        collapseStart: new Set(),
        collapseEnd: new Set(),
        expandStart: new Set(),
        expandEnd: new Set()
    };
    var $8ca73b0c81372577$export$2e2bcd8739ae039 = (0, $7JoAD.createStore)({
        name: 'navigation-ui',
        initialState: $8ca73b0c81372577$var$initialState,
        actions: (0, parcelRequire("8pFbi")).default
    });
});
parcelRegister("8pFbi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c96738f03994c2c6$export$2e2bcd8739ae039);
    var $cIPJW;
    var $aUW0i;
    var $44KUn;
    var $5UAf7;
    const $c96738f03994c2c6$var$actions = {
        collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('collapseStart', cb)),
        collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('collapseStart', cb)),
        collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('collapseStart')),
        collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('collapseStart')),
        collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('collapseEnd', cb)),
        collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('collapseEnd', cb)),
        collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('collapseEnd')),
        collapseEndRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('collapseEnd', cb)),
        expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('expandStart', cb)),
        expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('expandStart', cb)),
        expandStartClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('expandStart')),
        expandStartRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('expandStart', cb)),
        expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('expandEnd', cb)),
        expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('expandEnd', cb)),
        expandEndClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('expandEnd')),
        expandEndRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('expandEnd', cb)),
        clearAll: ()=>({ dispatch: dispatch })=>{
                dispatch($c96738f03994c2c6$var$actions.collapseStartClear());
                dispatch($c96738f03994c2c6$var$actions.collapseEndClear());
                dispatch($c96738f03994c2c6$var$actions.expandStartClear());
                dispatch($c96738f03994c2c6$var$actions.expandEndClear());
            }
    };
    var $c96738f03994c2c6$export$2e2bcd8739ae039 = $c96738f03994c2c6$var$actions;
});
parcelRegister("cIPJW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98a193bdf9026fb7$export$2e2bcd8739ae039);
    var $44KUn;
    var $98a193bdf9026fb7$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: new Set(getState()[key]).add(callback)
            });
            return ()=>dispatch((0, (0, parcelRequire("44KUn")).default)(key, callback));
        };
});
parcelRegister("44KUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cd1dd9b883bc2d4$export$2e2bcd8739ae039);
    var $4cd1dd9b883bc2d4$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
            if (!getState()[key]) return;
            const slice = new Set(getState()[key]);
            slice.delete(callback);
            setState({
                [key]: slice
            });
        };
});
parcelRegister("aUW0i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0765ad08a31511d2$export$2e2bcd8739ae039);
    var $0765ad08a31511d2$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>setState({
                [key]: new Set()
            });
});
parcelRegister("5UAf7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc474c9b594a3d77$export$2e2bcd8739ae039);
    var $dc474c9b594a3d77$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>(getState()[key] || new Set()).forEach((cb)=>cb(...args));
});
parcelRegister("fTkzd", function(module, exports) {
    $parcel$export(module.exports, "itemIds", ()=>$e0d97c8d376b70de$export$443ec49e59de3663);
    $parcel$export(module.exports, "viewIds", ()=>$e0d97c8d376b70de$export$8ee2fd038785d9dc);
    var $16J3A;
    const $e0d97c8d376b70de$var$ROOT = 'root/index';
    const $e0d97c8d376b70de$var$ISSUES = 'root/issues';
    const $e0d97c8d376b70de$var$DASHBOARDS = 'root/dashboards';
    const $e0d97c8d376b70de$var$PORTFOLIO = 'root/portfolio';
    const $e0d97c8d376b70de$var$WORK_SCRUM = 'work-scrum';
    const $e0d97c8d376b70de$var$PLAN_SCRUM = 'plan-scrum';
    const $e0d97c8d376b70de$var$WORK_KANBAN = 'work-kanban';
    const $e0d97c8d376b70de$var$PLAN_KANBAN = 'plan-kanban';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
    const $e0d97c8d376b70de$var$AGILITY = 'project/agility/index';
    const $e0d97c8d376b70de$var$BUSINESS = 'project/business/index';
    const $e0d97c8d376b70de$var$OPS = 'project/ops/index';
    const $e0d97c8d376b70de$var$SOFTWARE = 'project/software/index';
    const $e0d97c8d376b70de$var$SOFTWARE_ISSUES = 'project/software/issues';
    const $e0d97c8d376b70de$var$SOFTWARE_REPORTS = 'project/software/reports';
    const $e0d97c8d376b70de$var$USER = 'user/index';
    const $e0d97c8d376b70de$var$USER_REPORTS = 'user/reports';
    const $e0d97c8d376b70de$var$rootProjectViewIds = {
        AGILITY: $e0d97c8d376b70de$var$AGILITY,
        SERVICE_DESK: (0, parcelRequire("16J3A")).SERVICE_DESK,
        OPS: $e0d97c8d376b70de$var$OPS,
        BUSINESS: $e0d97c8d376b70de$var$BUSINESS,
        SOFTWARE: $e0d97c8d376b70de$var$SOFTWARE
    };
    const $e0d97c8d376b70de$var$rootViewIds = {
        ROOT: $e0d97c8d376b70de$var$ROOT,
        ISSUES: $e0d97c8d376b70de$var$ISSUES,
        DASHBOARDS: $e0d97c8d376b70de$var$DASHBOARDS,
        PORTFOLIO: $e0d97c8d376b70de$var$PORTFOLIO
    };
    const $e0d97c8d376b70de$export$443ec49e59de3663 = {
        WORK_SCRUM: $e0d97c8d376b70de$var$WORK_SCRUM,
        PLAN_SCRUM: $e0d97c8d376b70de$var$PLAN_SCRUM,
        WORK_KANBAN: $e0d97c8d376b70de$var$WORK_KANBAN,
        PLAN_KANBAN: $e0d97c8d376b70de$var$PLAN_KANBAN,
        PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
        ...(0, (0, parcelRequire("16J3A")).SERVICE_DESK_ITEMS)
    };
    const $e0d97c8d376b70de$export$8ee2fd038785d9dc = {
        ...$e0d97c8d376b70de$var$rootViewIds,
        ...$e0d97c8d376b70de$var$rootProjectViewIds,
        SOFTWARE_ISSUES: $e0d97c8d376b70de$var$SOFTWARE_ISSUES,
        SOFTWARE_REPORTS: $e0d97c8d376b70de$var$SOFTWARE_REPORTS,
        SERVICE_DESK_ISSUES: (0, parcelRequire("16J3A")).SERVICE_DESK_ISSUES,
        SERVICE_DESK_QUEUES: (0, parcelRequire("16J3A")).SERVICE_DESK_QUEUES,
        SERVICE_DESK_REPORTS: (0, parcelRequire("16J3A")).SERVICE_DESK_REPORTS,
        SERVICE_DESK_SETTINGS: (0, parcelRequire("16J3A")).SERVICE_DESK_SETTINGS,
        SERVICE_DESK_LANGUAGES: (0, parcelRequire("16J3A")).SERVICE_DESK_LANGUAGES,
        SERVICE_DESK_LEGACY_TICKET_TYPES: (0, parcelRequire("16J3A")).SERVICE_DESK_LEGACY_TICKET_TYPES,
        SERVICE_DESK_TRANSLATIONS: (0, parcelRequire("16J3A")).SERVICE_DESK_TRANSLATIONS,
        SERVICE_DESK_AUTOMATION_SUB_NAV: (0, parcelRequire("16J3A")).SERVICE_DESK_AUTOMATION_SUB_NAV,
        SERVICE_DESK_KNOWLEDGE_HUB: (0, parcelRequire("16J3A")).SERVICE_DESK_KNOWLEDGE_HUB,
        USER: $e0d97c8d376b70de$var$USER,
        USER_REPORTS: $e0d97c8d376b70de$var$USER_REPORTS
    };
});
parcelRegister("16J3A", function(module, exports) {
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$6fb2b1c825061655$export$1f70a76cb421b107);
    $parcel$export(module.exports, "HOME_ITEMS_IDS", ()=>$6fb2b1c825061655$export$9afbea2cbd37e16d);
    $parcel$export(module.exports, "PRACTICES_IDS", ()=>$6fb2b1c825061655$export$a37f4f7add086a3);
    $parcel$export(module.exports, "SERVICE_DESK_ITEMS", ()=>$6fb2b1c825061655$export$2108a7f32cd0bb12);
    $parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", ()=>$6fb2b1c825061655$export$712b4b205a2bcf1e);
    $parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", ()=>$6fb2b1c825061655$export$e2d46b728fe0a15a);
    $parcel$export(module.exports, "SERVICE_DESK", ()=>$6fb2b1c825061655$export$c8c1c8c3f8ddba61);
    $parcel$export(module.exports, "SERVICE_DESK_ISSUES", ()=>$6fb2b1c825061655$export$51fa1147c138a6ed);
    $parcel$export(module.exports, "SERVICE_DESK_QUEUES", ()=>$6fb2b1c825061655$export$456b3cfbf5e37bd8);
    $parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", ()=>$6fb2b1c825061655$export$9ccc8d85b210b219);
    $parcel$export(module.exports, "SERVICE_DESK_REPORTS", ()=>$6fb2b1c825061655$export$707771f2f7e60575);
    $parcel$export(module.exports, "SERVICE_DESK_SETTINGS", ()=>$6fb2b1c825061655$export$a87fc635598d2d50);
    $parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", ()=>$6fb2b1c825061655$export$b6bda26b77269209);
    $parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", ()=>$6fb2b1c825061655$export$776199f9e99c88e2);
    $parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", ()=>$6fb2b1c825061655$export$d70ba5c124463035);
    $parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", ()=>$6fb2b1c825061655$export$9a6deaa9c1af559f);
    const $6fb2b1c825061655$var$HOME_QUEUES = 'queues';
    const $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
    const $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
    const $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
    const $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS = 'service-requests';
    const $6fb2b1c825061655$var$HOME_INCIDENTS = 'incidents';
    const $6fb2b1c825061655$var$HOME_CHANGES = 'changes';
    const $6fb2b1c825061655$var$HOME_PROBLEMS = 'problems';
    const $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
    const $6fb2b1c825061655$var$HOME_CUSTOMERS = 'customers';
    const $6fb2b1c825061655$var$HOME_REPORTS = 'reports';
    const $6fb2b1c825061655$var$HOME_RAISE_REQUEST = 'raise-request';
    const $6fb2b1c825061655$var$HOME_ISSUES = 'issues';
    const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
    const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
    const $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
    const $6fb2b1c825061655$var$HOME_INVITE_TEAM = 'invite-team';
    const $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK = 'give-feedback';
    const $6fb2b1c825061655$var$HOME_SERVICES = 'services';
    const $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
    const $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
    const $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
    const $6fb2b1c825061655$export$1f70a76cb421b107 = {
        REPORTS_CUSTOM: 'sd-reports-custom',
        REPORTS_ADDONS: 'sd-reports-addons',
        REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
        REPORTS_NAV_TEAM: 'sd-reports-nav-team',
        REPORTS_NAV_KB: 'sd-reports-nav-kb'
    };
    const $6fb2b1c825061655$export$9afbea2cbd37e16d = {
        QUEUES: $6fb2b1c825061655$var$HOME_QUEUES,
        ALL_ITSM_QUEUES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
        ALL_TICKETS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT,
        TICKET_CATEGORIES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
        SERVICE_REQUEST: $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS,
        INCIDENTS: $6fb2b1c825061655$var$HOME_INCIDENTS,
        CHANGES: $6fb2b1c825061655$var$HOME_CHANGES,
        PROBLEMS: $6fb2b1c825061655$var$HOME_PROBLEMS,
        CUSTOMERS: $6fb2b1c825061655$var$HOME_CUSTOMERS,
        POST_INCIDENT_REVIEWS: $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS,
        REPORTS: $6fb2b1c825061655$var$HOME_REPORTS,
        RAISE_REQUEST: $6fb2b1c825061655$var$HOME_RAISE_REQUEST,
        ISSUES: $6fb2b1c825061655$var$HOME_ISSUES,
        CUSTOMER_CHANNELS: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS,
        CUSTOMER_CHANNELS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
        JSD_CHANNELS_DIALOG: $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG,
        KNOWLEDGE_BASE: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE,
        KNOWLEDGE_BASE_HUB: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB,
        KNOWLEDGE_BASE_HUB_NESTED: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
        INVITE_TEAM: $6fb2b1c825061655$var$HOME_INVITE_TEAM,
        GIVE_FEEDBACK: $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK,
        SERVICES: $6fb2b1c825061655$var$HOME_SERVICES,
        SERVICES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT,
        ALERTS_AND_ON_CALL_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
        CHANGE_CALENDAR_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
    };
    const $6fb2b1c825061655$export$304aefafb7155b23 = {
        TOP_ACTIONS: 'knowledge-hub-top-actions',
        ALL_ARTICLES: 'knowledge-hub-all-articles',
        CATEGORIES: 'knowledge-hub-categories',
        CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
        BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
        ADD_CATEGORY: 'knowledge-hub-new-category',
        LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
    };
    const $6fb2b1c825061655$export$5fd6685a693e1064 = {
        DETAILS: 'details',
        PEOPLE: 'people',
        ITSM_FEATURES: 'itsm-features',
        SUMMARY: 'summary',
        DELETE_PROJECT: 'delete-project',
        ISSUE_TYPES: 'issue-types',
        FEATURES: 'features',
        REQUEST_TYPES: 'sd-request-types',
        TICKET_TYPES: 'sd-ticket-types',
        CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
        LANGUAGE_SUPPORT: 'sd-language-support',
        PORTAL_SETTINGS: 'sd-portal-settings',
        EMAIL_REQUESTS: 'sd-email-requests',
        CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
        PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
        PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
        PROJECT_ASSETS_AD: 'sd-project-assets-ad',
        SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
        KNOWLEDGE_BASE: 'sd-knowledge-base',
        SLAS: 'sd-slas',
        AUTOMATION: 'sd-automation',
        PLAYBOOKS: 'playbooks',
        JIRA_AUTOMATION: 'jira-automation',
        AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
        JSD_APP_DISCOVERY: 'sd-app-discovery',
        JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
        JSD_CHANGE_MANAGEMENT: 'sd-change-management',
        WORKFLOWS: 'workflows',
        SCREENS: 'screens',
        FIELDS: 'fields',
        VERSIONS: 'versions',
        COMPONENTS: 'components',
        PERMISSIONS: 'permissions',
        ISSUE_SECURITY: 'issue-security',
        NOTIFICATIONS: 'notifications',
        HIPCHAT: 'hipchat',
        ISSUE_COLLECTORS: 'issue-collectors'
    };
    const $6fb2b1c825061655$export$50b1b8fc419aca98 = {
        QUEUE_NEW: 'queue-new',
        QUEUE_MANAGE: 'queue-manage',
        QUEUES_ADDONS: 'sd-queues-addons',
        QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
        SD_QUEUES_CUSTOM: 'sd-queues-custom'
    };
    const $6fb2b1c825061655$export$a37f4f7add086a3 = {
        ADDITIONAL_ITEMS: 'sd-practices-additional-items',
        CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
        CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
        INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
        INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
    };
    const $6fb2b1c825061655$export$2108a7f32cd0bb12 = {
        SERVICE_DESK: {
            HOME: $6fb2b1c825061655$export$9afbea2cbd37e16d,
            KNOWLEDGE_BASE: $6fb2b1c825061655$export$304aefafb7155b23,
            SETTINGS: $6fb2b1c825061655$export$5fd6685a693e1064,
            QUEUES: $6fb2b1c825061655$export$50b1b8fc419aca98,
            REPORTS: $6fb2b1c825061655$export$1f70a76cb421b107
        }
    };
    const $6fb2b1c825061655$export$712b4b205a2bcf1e = {
        PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
        UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
    };
    const $6fb2b1c825061655$export$aaffd3035e9d6c2d = 'jsm-team-priority-queue-admin-onboarding';
    const $6fb2b1c825061655$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
    const $6fb2b1c825061655$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
    const $6fb2b1c825061655$export$51fa1147c138a6ed = 'project/service-desk/issues';
    const $6fb2b1c825061655$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
    const $6fb2b1c825061655$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
    const $6fb2b1c825061655$export$707771f2f7e60575 = 'project/service-desk/reports';
    const $6fb2b1c825061655$export$a87fc635598d2d50 = 'project/service-desk/settings';
    const $6fb2b1c825061655$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
    const $6fb2b1c825061655$export$776199f9e99c88e2 = 'project/service-desk/languages';
    const $6fb2b1c825061655$export$d70ba5c124463035 = 'project/service-desk/translations';
    const $6fb2b1c825061655$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';
});
parcelRegister("e1ETT", function(module, exports) {
    $parcel$export(module.exports, "AsyncLockScreenExperimentSharedWrapper", ()=>$82a7a36c9e8ee7c8$export$129bdc881130bc9);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $kxZPA;
    const $82a7a36c9e8ee7c8$var$AsyncLockScreenExperimentShared = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("l6gsK")).then(({ LockScreenExperimentShared: LockScreenExperimentShared })=>LockScreenExperimentShared), {
        moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment-shared/src/index.tsx"
    });
    const $82a7a36c9e8ee7c8$export$129bdc881130bc9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "lock-screen-experiment-shared-async",
            packageName: (0, $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, $e113a6ff9475fdf6$export$d57b6b390e78d90f),
            id: "lock-screen-experiment-shared-async",
            packageName: (0, $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($82a7a36c9e8ee7c8$var$AsyncLockScreenExperimentShared, null)));
});
const $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b = '@atlassian/jira-lock-screen-experiment-shared';
const $e113a6ff9475fdf6$export$d57b6b390e78d90f = 'transmuters-growth';
parcelRegister("l6gsK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3slCJ").then(()=>parcelRequire('0FUnI'));
});
parcelRegister("aqDVH", function(module, exports) {
    $parcel$export(module.exports, "jiraLossAversionModalEntryPoint", ()=>$5bb417d947b6f1f3$export$e224c255d72cf9b5);
    var $eufEc;
    var $fEDBv;
    const $5bb417d947b6f1f3$export$e224c255d72cf9b5 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>(parcelRequire("2EAmB")).then(({ JiraLossAversionExperiment: JiraLossAversionExperiment })=>JiraLossAversionExperiment), {
            moduleId: "35d17363"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("2EAmB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eU8LY")
    ]).then(()=>parcelRequire('4VIPJ'));
});
parcelRegister("jElqQ", function(module, exports) {
    $parcel$export(module.exports, "PageDwellAnalyticsListener", ()=>$e847f78ebf17acd8$export$6cf89f098b551dad);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $dAfqg;
    var $6yXtV;
    var $hMvRp;
    const $e847f78ebf17acd8$var$WAIT_DURATION = 5000;
    const $e847f78ebf17acd8$export$6cf89f098b551dad = ()=>{
        const [hasFired, setHasFired] = (0, $5uXOq.useState)(false);
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const routeName = route.name;
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const isVisible = (0, (0, parcelRequire("hMvRp")).usePageVisibility)();
        const interval = (0, $5uXOq.useRef)(null);
        const { data: projectData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { isCollapsed: isLeftSidebarCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            setHasFired(false);
        }, [
            routeName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isReady) {
                interval.current = null;
                return;
            }
            if (isVisible && !hasFired) interval.current = setTimeout(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                    containerId: projectData?.projectId,
                    containerType: projectData?.projectType,
                    isLeftSidebarCollapsed: isLeftSidebarCollapsed
                });
                setHasFired(true);
            }, $e847f78ebf17acd8$var$WAIT_DURATION);
            return ()=>{
                interval.current = clearTimeout(interval.current);
            };
        }, [
            createAnalyticsEvent,
            hasFired,
            isReady,
            isVisible,
            routeName,
            projectData?.projectId,
            projectData?.projectType,
            isLeftSidebarCollapsed
        ]);
        return null;
    };
});
parcelRegister("hMvRp", function(module, exports) {
    $parcel$export(module.exports, "usePageVisibility", ()=>$124c6a08c4f63b4e$export$6c98eb2f12f4ec61);
    var $5uXOq = parcelRequire("5uXOq");
    var $laTox;
    const $124c6a08c4f63b4e$export$6c98eb2f12f4ec61 = ()=>{
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, (0, parcelRequire("laTox")).isPageVisible)());
        (0, $5uXOq.useEffect)(()=>{
            const onVisibilityChange = ()=>setIsVisible((0, (0, parcelRequire("laTox")).isPageVisible)());
            document.addEventListener('visibilitychange', onVisibilityChange);
            return ()=>{
                document.removeEventListener('visibilitychange', onVisibilityChange);
            };
        }, []);
        return isVisible;
    };
});
parcelRegister("laTox", function(module, exports) {
    $parcel$export(module.exports, "supportedVisiblityEvent", ()=>$845c75a1dcb2afb9$export$f7132cb36c80dad);
    $parcel$export(module.exports, "isPageVisible", ()=>$845c75a1dcb2afb9$export$ae4f9b990bc70f70);
    const $845c75a1dcb2afb9$var$visibilityMap = {
        hidden: 'visibilitychange',
        mozHidden: 'mozvisibilitychange',
        msHidden: 'msvisibilitychange',
        webkitHidden: 'webkitvisibilitychange'
    };
    const $845c75a1dcb2afb9$var$supportedHiddenKey = Object.keys($845c75a1dcb2afb9$var$visibilityMap).find((key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
    const $845c75a1dcb2afb9$export$f7132cb36c80dad = $845c75a1dcb2afb9$var$visibilityMap[$845c75a1dcb2afb9$var$supportedHiddenKey];
    const $845c75a1dcb2afb9$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$845c75a1dcb2afb9$var$supportedHiddenKey];
});
parcelRegister("kKa8l", function(module, exports) {
    $parcel$export(module.exports, "MatchedRouteListener", ()=>$6e59b41cd017c405$export$c6d9204abc182c3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cfDZ3;
    var $dIdda = parcelRequire("dIdda");
    const $6e59b41cd017c405$export$c6d9204abc182c3b = ()=>{
        const [{ route: route, match: match }] = (0, $dIdda.useRouter)();
        (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("cfDZ3")).setMatchedRoute)(route, match), [
            route,
            match
        ]);
        return null;
    };
});
parcelRegister("bmetd", function(module, exports) {
    $parcel$export(module.exports, "PreviousRouterStateListener", ()=>$0b73f894404a9cc2$export$49e28489f2124002);
    var $5uXOq = parcelRequire("5uXOq");
    var $1XJ20;
    var $cfDZ3;
    var $dIdda = parcelRequire("dIdda");
    const $0b73f894404a9cc2$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
        const previousRouterState = (0, (0, parcelRequire("1XJ20")).usePrevious)(routerState);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cfDZ3")).setPreviousRouterState)(previousRouterState ?? null);
        }, [
            previousRouterState
        ]);
        return null;
    };
    const $0b73f894404a9cc2$export$49e28489f2124002 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterSubscriber), null, (routerState)=>(0, ($parcel$interopDefault($5uXOq))).createElement($0b73f894404a9cc2$export$3fd5ddd6b8e9a200, {
                routerState: routerState
            })));
    $0b73f894404a9cc2$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';
});
parcelRegister("izgL1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33c092f8fb0732f9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $1u3Jv;
    var $7nE2n;
    var $iXVV6;
    var $5oFIy;
    var $dIdda = parcelRequire("dIdda");
    var $gKKyW;
    const $33c092f8fb0732f9$var$QueryStringNotifier = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "querystringNotifications"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7nE2n")).default), null, (flagService)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterSubscriber), null, ({ location: { search: search } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterActions), null, ({ replace: replace })=>{
                    const { showFlag: showFlag, ...query } = (0, ($parcel$interopDefault($ebyGx))).parse(search);
                    if (!showFlag) return null;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("gKKyW")).default)[showFlag] ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
                        eventName: "querystringNotification shown",
                        componentName: "flag",
                        attributes: {
                            showFlag: showFlag
                        }
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
                        eventName: "querystringNotification notFound",
                        componentName: "flag",
                        attributes: {
                            showFlag: showFlag
                        }
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
                        op: ()=>{
                            if ((0, (0, parcelRequire("gKKyW")).default)[showFlag]) flagService.showFlag((0, (0, parcelRequire("gKKyW")).default)[showFlag]);
                            replace(`?${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`);
                        }
                    }));
                }))));
    var $33c092f8fb0732f9$export$2e2bcd8739ae039 = $33c092f8fb0732f9$var$QueryStringNotifier;
});
parcelRegister("1u3Jv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4400becd9e439df4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $4400becd9e439df4$var$OpTrigger extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $4400becd9e439df4$export$2e2bcd8739ae039 = $4400becd9e439df4$var$OpTrigger;
});
parcelRegister("7nE2n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4855eee5a10070a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $4855eee5a10070a5$var$FlagServiceSubscriber = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children((0, (0, parcelRequire("pa9q9")).flagService)));
    var $4855eee5a10070a5$export$2e2bcd8739ae039 = $4855eee5a10070a5$var$FlagServiceSubscriber;
});
parcelRegister("gKKyW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fdf0672c10209bc$export$2e2bcd8739ae039);
    var $7HGHK;
    var $lVqGY;
    const $2fdf0672c10209bc$var$notificationMessages = {
        'jsw.board-not-found': {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)('jsw.board-not-found'),
            type: 'error',
            title: (0, (0, parcelRequire("lVqGY")).default).boardNotFound,
            description: (0, (0, parcelRequire("lVqGY")).default).boardNotFoundDescription
        },
        'jsw.project-not-found': {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)('jsw.project-not-found'),
            type: 'error',
            title: (0, (0, parcelRequire("lVqGY")).default).projectNotFound,
            description: (0, (0, parcelRequire("lVqGY")).default).projectNotFoundDescription
        }
    };
    var $2fdf0672c10209bc$export$2e2bcd8739ae039 = $2fdf0672c10209bc$var$notificationMessages;
});
parcelRegister("lVqGY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a629f5c887c4955a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $a629f5c887c4955a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        boardNotFound: {
            "id": "query-string-notifier.common.board-not-found",
            "defaultMessage": "Board not found"
        },
        boardNotFoundDescription: {
            "id": "query-string-notifier.common.board-not-found-description",
            "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
        },
        projectNotFound: {
            "id": "query-string-notifier.common.project-not-found",
            "defaultMessage": "Project not found"
        },
        projectNotFoundDescription: {
            "id": "query-string-notifier.common.project-not-found-description",
            "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
        }
    });
    var $a629f5c887c4955a$export$2e2bcd8739ae039 = $a629f5c887c4955a$var$messages;
});
parcelRegister("lyCmi", function(module, exports) {
    $parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", ()=>$881dabfa53ffbc01$export$2a43717c77dd3a56);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $kxZPA;
    var $gnleF;
    const $881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("191Yr")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
        moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
    });
    const $881dabfa53ffbc01$export$2a43717c77dd3a56 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "recommend-premium-to-standard-modal-async",
            packageName: (0, (0, parcelRequire("gnleF")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, (0, parcelRequire("gnleF")).TEAM_NAME),
            id: "recommend-premium-to-standard-modal-async",
            packageName: (0, (0, parcelRequire("gnleF")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent, null)));
    };
});
parcelRegister("gnleF", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$3413b320036771c2$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$3413b320036771c2$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", ()=>$3413b320036771c2$export$48e1d3fa57b0a2d5);
    $parcel$export(module.exports, "STARGATE_URL", ()=>$3413b320036771c2$export$c7e6a6b283196232);
    $parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", ()=>$3413b320036771c2$export$de9f5b160db96e26);
    const $3413b320036771c2$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
    const $3413b320036771c2$export$d57b6b390e78d90f = 'growth-tako';
    const $3413b320036771c2$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
    const $3413b320036771c2$export$c7e6a6b283196232 = '/gateway/api';
    const $3413b320036771c2$export$de9f5b160db96e26 = new Map([
        [
            5,
            'prj-grace-period-recc-standard-message-1'
        ],
        [
            3,
            'prj-grace-period-recc-standard-message-2'
        ],
        [
            1,
            'prj-grace-period-recc-standard-message-3'
        ]
    ]);
});
parcelRegister("191Yr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aIcwu").then(()=>parcelRequire('hxssF'));
});
parcelRegister("kgLzl", function(module, exports) {
    $parcel$export(module.exports, "rovoVideoModalEntryPoint", ()=>$1c7272db9b45cdb2$export$2f67fedc6d5555a5);
    var $eufEc;
    var $fEDBv;
    const $1c7272db9b45cdb2$export$2f67fedc6d5555a5 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>(parcelRequire("h5z99")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
            moduleId: "3a307b00"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("h5z99", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("l4e09")
    ]).then(()=>parcelRequire('14875'));
});
parcelRegister("dYRe6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05aa88b82a329166$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $5oFIy;
    var $dxCvy;
    var $dIdda = parcelRequire("dIdda");
    const $05aa88b82a329166$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), Redirect: Redirect = (0, $dIdda.Redirect), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter) })=>{
        const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
        const projectKey = params.projectKey ?? query.projectKey;
        const { data: projectContext } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        if (!projectKey || !projectContext?.projectKey) return null;
        if (projectKey === projectContext.projectKey) return null;
        const search = {
            ...query,
            ...query.projectKey ? {
                projectKey: projectContext.projectKey
            } : {}
        };
        const queryString = (0, $aZsz6.qs).stringify(search, Object.entries(search).length > 0);
        const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
        const to = `${path}${queryString}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(FireOperationalAnalytics, {
            eventName: "ProjectKeyRedirect loaded",
            componentName: "ProjectKeyRedirect",
            attributes: {
                location: location,
                projectContext: projectContext
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: to
        }));
    };
    var $05aa88b82a329166$export$2e2bcd8739ae039 = $05aa88b82a329166$var$ProjectKeyRedirect;
});
parcelRegister("dz0Q5", function(module, exports) {
    $parcel$export(module.exports, "AsyncUpflowIframeComponent", ()=>$aab5ccb109290e76$export$7f34679273a30171);
    var $kxZPA;
    const $aab5ccb109290e76$export$7f34679273a30171 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("it3EE")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
        ssr: false,
        moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
    });
});
parcelRegister("it3EE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1umXM").then(()=>parcelRequire('f7aUi'));
});
parcelRegister("kXv2J", function(module, exports) {
    $parcel$export(module.exports, "upgradeOnboardingExperimentEntryPoint", ()=>$49f1088be59356e0$export$94ad1b5fd850909f);
    var $eufEc;
    var $fEDBv;
    const $49f1088be59356e0$export$94ad1b5fd850909f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>(parcelRequire("gqztb")).then(({ UpgradeOnboardingExperiment: UpgradeOnboardingExperiment })=>UpgradeOnboardingExperiment), {
            moduleId: "86e9ce71"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("gqztb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8f5Ah")
    ]).then(()=>parcelRequire('a48Ze'));
});
parcelRegister("4p6rw", function(module, exports) {
    $parcel$export(module.exports, "JiraHeritageLoader", ()=>$da151c89e6acf066$export$9499deca9933db5b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cQZXC;
    var $1r4rO;
    var $6jY6G;
    var $6yXtV;
    var $4su49;
    var $kiABc;
    var $8Z3n8;
    const $da151c89e6acf066$export$9499deca9933db5b = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $5uXOq.useState)(false);
        (0, (0, parcelRequire("8Z3n8")).useWrmStatsEffects)();
        const loadJiraHeritageDependencies = (0, $5uXOq.useCallback)(()=>{
            setHasHeritageDownloaded(true);
            (0, (0, parcelRequire("4su49")).asyncWrmRequire)([
                ...(0, (0, parcelRequire("1r4rO")).jiraSuperBatchDependencies),
                ...(0, (0, parcelRequire("kiABc")).getJiraHeritageDependencies)()
            ]).then(()=>(0, (0, parcelRequire("cQZXC")).waitForHeritage)()?.resolve?.());
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
        }, [
            hasHeritageDownloaded,
            isReady,
            loadJiraHeritageDependencies,
            route
        ]);
        return null;
    };
    $da151c89e6acf066$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';
});
parcelRegister("kiABc", function(module, exports) {
    $parcel$export(module.exports, "getJiraHeritageDependencies", ()=>$0d81a9889d6c3d74$export$e8f6d7acd5817fa2);
    const $0d81a9889d6c3d74$export$e8f6d7acd5817fa2 = ()=>[
            'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
            'wrc!jira.webresources:key-commands',
            'wrc!jira.webresources:header',
            'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
            'wrc!jira.webresources:global-static',
            'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
            'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
            'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
            'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
            'wrc!com.atlassian.analytics.analytics-client:js-events',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
            'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
            'wrc!jira.webresources:spam-protection-flags',
            'wrc!com.atlassian.pas:pas-everypage-static',
            'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
            'wrc!com.atlassian.auiplugin:dialog2',
            'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
            'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
        ];
});
parcelRegister("8Z3n8", function(module, exports) {
    $parcel$export(module.exports, "useWrmStatsEffects", ()=>$b2fe1e724cbc12ec$export$7ff53723d9d2886d);
    var $5uXOq = parcelRequire("5uXOq");
    var $6yXtV;
    var $bVDE5;
    const $b2fe1e724cbc12ec$export$7ff53723d9d2886d = ()=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [{ transitionsCount: transitionsCount }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        (0, $5uXOq.useEffect)(()=>{
            if (isReady && window.__WRM_INTERNAL_STATS__ && !window.__WRM_INTERNAL_STATS__.isPageInteractive) window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
        }, [
            isReady
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (transitionsCount > 0) window.__WRM_INTERNAL_STATS__ = {};
        }, [
            transitionsCount
        ]);
    };
});
parcelRegister("ec3NH", function(module, exports) {
    $parcel$export(module.exports, "BreadcrumbAdapter", ()=>$ea76f165da82af61$export$2255367d5c9162b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $67Adx;
    const $ea76f165da82af61$export$2255367d5c9162b3 = ()=>{
        const baseUrl = '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("67Adx")).default), {
            baseUrl: baseUrl
        });
    };
});
parcelRegister("67Adx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fce4053be7c0ea3f$export$2e2bcd8739ae039);
    var $9sGI6;
    var $aYHuU;
    var $7GR7x;
    var $bQtVL;
    var $3XHss;
    var $1DFxi;
    var $fce4053be7c0ea3f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("aYHuU")).default), {
        LegacyApiBridge: (0, parcelRequire("7GR7x")).default,
        LegacyBreadcrumbConnector: (0, parcelRequire("bQtVL")).default,
        LegacyBreadcrumbState: (0, parcelRequire("1DFxi")).default,
        LegacyBreadcrumbRenderer: (0, parcelRequire("3XHss")).default
    });
});
parcelRegister("aYHuU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2640273d477c5ef9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jzjy1;
    var $heNNl;
    const $2640273d477c5ef9$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>(0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyApiBridge, {
                onInsertItem: api.insertItem,
                onRemoveItem: api.removeItem,
                onSetRenderTarget: api.setTargetElement
            }), state.targetElement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
                id: "legacy-breadcrumb-adapter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbConnector, {
                legacyTrail: state.trail
            }), (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbRenderer, {
                targetElement: state.targetElement
            }))));
    var $2640273d477c5ef9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('legacyBreadcrumbs', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($2640273d477c5ef9$var$LegacyBreadcrumbAdapter);
});
parcelRegister("jzjy1", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsSource", ()=>$578c443a5ba38dde$export$6890652a1aff7d1c);
    $parcel$export(module.exports, "AnalyticsSubject", ()=>$578c443a5ba38dde$export$ec9f54bd4341ceb);
    var $994MI;
    const $578c443a5ba38dde$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, (0, parcelRequire("994MI")).default)({
                source: `${name}${type}`
            })(WrappedComponent);
    const $578c443a5ba38dde$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, (0, parcelRequire("994MI")).default)({
                actionSubject: name,
                attributes: attributes
            })(WrappedComponent);
});
parcelRegister("7GR7x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1c2002ff619891e$export$2e2bcd8739ae039);
    var $1bJTy;
    var $9sGI6;
    var $hciGg;
    const $e1c2002ff619891e$var$analyticsEvents = {
        onInsertItemFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'insertItem'
                }
            }),
        onRemoveItemFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'removeItem'
                }
            }),
        onSetRenderTargetFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'render'
                }
            }),
        onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'onBreadCrumbsUpdate'
                }
            })
    };
    var $e1c2002ff619891e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("hciGg")).default), $e1c2002ff619891e$var$analyticsEvents);
});
parcelRegister("1bJTy", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalAnalytics", ()=>$065c8ba87a790756$export$79f423cc3fd39762);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $jcw0u;
    var $gvRPW;
    var $i4iBk;
    const $065c8ba87a790756$var$isNotUndefined = (a)=>a !== undefined;
    const $065c8ba87a790756$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $065c8ba87a790756$var$isNotUndefined);
    };
    const $065c8ba87a790756$export$79f423cc3fd39762 = (event, payload)=>{
        try {
            event.update({
                ...$065c8ba87a790756$var$mapPayload(payload),
                analyticsType: (0, (0, parcelRequire("gvRPW")).OPERATIONAL_EVENT_TYPE)
            }).fire();
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                event: event,
                error: e,
                meta: {
                    id: 'fireOperationalAnalytics',
                    packageName: 'jiraAnalyticsWebReact',
                    teamName: 'legacy-jfp-team-do-not-use'
                }
            });
        }
    };
});
parcelRegister("i4iBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a364fe632bf506b$export$2e2bcd8739ae039);
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $8a364fe632bf506b$export$2e2bcd8739ae039 = (payload)=>{
        const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
        return (0, ($parcel$interopDefault($9xWGk)))({
            tags: tags,
            containerId: containerId,
            containers: containers,
            containerType: containerType,
            objectId: objectId,
            objectType: objectType,
            attributes: attributes
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
});
parcelRegister("hciGg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$060d1d7061b6e3c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    var $8oe80;
    var $c1YJb;
    class $060d1d7061b6e3c1$var$LegacyApiBridge extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
            (0, (0, parcelRequire("c1YJb")).default)({
                insertItem: onInsertItem,
                removeItem: onRemoveItem,
                render: onSetRenderTarget,
                onBreadCrumbsUpdate: onBreadCrumbsUpdate
            });
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args);
            this.onInsertItem = (item)=>{
                const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
                onInsertItemFired();
                onInsertItem(item);
            };
            this.onRemoveItem = (itemId)=>{
                const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
                onRemoveItemFired();
                onRemoveItem(itemId);
            };
            this.onSetRenderTarget = (element)=>{
                const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
                onSetRenderTargetFired();
                onSetRenderTarget(element);
            };
            this.onBreadCrumbsUpdate = ()=>{
                const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
                onOnBreadCrumbsUpdateFired();
                return (0, $kVLXA.Observable).empty();
            };
        }
    }
    var $060d1d7061b6e3c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('legacyApiBridge', {
        onInsertItemFired: 'apiMethodCalled',
        onRemoveItemFired: 'apiMethodCalled',
        onSetRenderTargetFired: 'apiMethodCalled',
        onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
    })($060d1d7061b6e3c1$var$LegacyApiBridge);
});
parcelRegister("8oe80", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd6b229cbb45328e$export$2e2bcd8739ae039);
    var $994MI;
    var $cb25w;
    const $cd6b229cbb45328e$export$871de8747c9eaa88 = (props)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key]
                }
            }), {});
    function $cd6b229cbb45328e$var$componentWithAnalytics(componentName, eventActions) {
        return function(WrappedComponent) {
            return (0, (0, parcelRequire("994MI")).default)({
                componentName: componentName
            })((0, (0, parcelRequire("cb25w")).default)($cd6b229cbb45328e$export$871de8747c9eaa88(eventActions))(WrappedComponent));
        };
    }
    var $cd6b229cbb45328e$export$2e2bcd8739ae039 = $cd6b229cbb45328e$var$componentWithAnalytics;
});
parcelRegister("c1YJb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8c3f644565eaafc$export$2e2bcd8739ae039);
    var $9B86Q;
    var $dJl1T;
    var $a8c3f644565eaafc$export$2e2bcd8739ae039 = (legacyAPI)=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
            name: 'jira/globalnavigator/breadcrumbs/bridge'
        }).then((bridge)=>{
            bridge(legacyAPI);
        }).catch((err)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
});
parcelRegister("bQtVL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c34ce41a7e16e82$export$2e2bcd8739ae039);
    var $9sGI6;
    var $c2D8L;
    var $btYLD;
    var $gEFwt;
    var $75PvK;
    var $7OPFF;
    var $5fGpW;
    var $2c34ce41a7e16e82$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("7OPFF")).default), {
        Breadcrumb: (0, parcelRequire("c2D8L")).default,
        ProjectBreadcrumb: (0, parcelRequire("gEFwt")).default,
        BoardBreadcrumb: (0, parcelRequire("btYLD")).default,
        UserBreadcrumb: (0, parcelRequire("75PvK")).default,
        ContextProvider: (0, parcelRequire("5fGpW")).default
    });
});
parcelRegister("c2D8L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$904f5413e35195e5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $aIVNN;
    class $904f5413e35195e5$var$BreadcrumbOps extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.id = '';
            this.id = (0, ($parcel$interopDefault($7Jxgt))).v4();
            if (false) this.onPushBreadcrumb();
        }
        componentDidMount() {
            this.onPushBreadcrumb();
        }
        componentDidUpdate(prevProps) {
            const { breadcrumb: prevBreadcrumb } = prevProps;
            const { api: api, breadcrumb: breadcrumb } = this.props;
            if (!(0, ($parcel$interopDefault($ajpes)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
                id: this.id,
                ...breadcrumb
            });
        }
        componentWillUnmount() {
            const { api: api } = this.props;
            api.popBreadcrumb();
        }
        onPushBreadcrumb() {
            const { api: api, breadcrumb: breadcrumb } = this.props;
            api.pushBreadcrumb({
                id: this.id,
                ...breadcrumb
            });
        }
        render() {
            return null;
        }
    }
    const $904f5413e35195e5$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aIVNN")).BreadcrumbActions), null, (__, actions)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($904f5413e35195e5$var$BreadcrumbOps, {
                api: actions,
                breadcrumb: breadcrumb
            }), children));
    $904f5413e35195e5$var$Breadcrumb.defaultProps = {
        children: null
    };
    var $904f5413e35195e5$export$2e2bcd8739ae039 = $904f5413e35195e5$var$Breadcrumb;
});
parcelRegister("aIVNN", function(module, exports) {
    $parcel$export(module.exports, "useBreadcrumbs", ()=>$446946e3e8bfa528$export$8cefe241bd876ca0);
    $parcel$export(module.exports, "BreadcrumbActions", ()=>$446946e3e8bfa528$export$9862c338ec0a6884);
    $parcel$export(module.exports, "BreadcrumbContainer", ()=>$446946e3e8bfa528$export$c7432936d9c50db7);
    var $7JoAD = parcelRequire("7JoAD");
    const $446946e3e8bfa528$var$initialState = {
        trail: []
    };
    const $446946e3e8bfa528$export$e324594224ef24da = {
        pushBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
                setState({
                    trail: [
                        ...getState().trail,
                        breadcrumb
                    ]
                });
            },
        popBreadcrumb: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    trail: getState().trail.slice(0, -1)
                });
            },
        updateBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
                const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
                setState({
                    trail: newTrail
                });
            }
    };
    const $446946e3e8bfa528$var$Store = (0, $7JoAD.createStore)({
        initialState: $446946e3e8bfa528$var$initialState,
        actions: $446946e3e8bfa528$export$e324594224ef24da,
        name: 'BreadcrumbSweetState'
    });
    const $446946e3e8bfa528$var$_BreadcrumbSubscriber = (0, $7JoAD.createSubscriber)($446946e3e8bfa528$var$Store);
    const $446946e3e8bfa528$export$8cefe241bd876ca0 = (0, $7JoAD.createHook)($446946e3e8bfa528$var$Store);
    const $446946e3e8bfa528$export$9862c338ec0a6884 = (0, $7JoAD.createSubscriber)($446946e3e8bfa528$var$Store, {
        selector: null
    });
    const $446946e3e8bfa528$export$c7432936d9c50db7 = (0, $7JoAD.createContainer)($446946e3e8bfa528$var$Store);
});
parcelRegister("btYLD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97548d5fa76ccc5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $81ps3;
    const $97548d5fa76ccc5f$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
        const breadcrumb = {
            href: (0, (0, parcelRequire("81ps3")).createBoardUrl)(boardId),
            text: boardName,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: breadcrumb
        }, children);
    };
    $97548d5fa76ccc5f$var$BoardBreadcrumb.defaultProps = {
        children: null,
        isSimplifiedProject: false,
        projectId: undefined
    };
    var $97548d5fa76ccc5f$export$2e2bcd8739ae039 = $97548d5fa76ccc5f$var$BoardBreadcrumb;
});
parcelRegister("81ps3", function(module, exports) {
    $parcel$export(module.exports, "createProjectUrl", ()=>$e04610b9d6540e69$export$1bdb1f038c5a2a90);
    $parcel$export(module.exports, "createProjectSettingsUrl", ()=>$e04610b9d6540e69$export$c435fcb42a65af32);
    $parcel$export(module.exports, "createBoardUrl", ()=>$e04610b9d6540e69$export$7037e05c8c7af6dc);
    var $02Psx;
    const $e04610b9d6540e69$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
    const $e04610b9d6540e69$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
        if (isSimplified) return (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)(projectType, projectKey);
        return `/projects/${projectKey}/settings`;
    };
    const $e04610b9d6540e69$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;
});
parcelRegister("gEFwt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b024406020849893$export$2e2bcd8739ae039);
    var $az4zD;
    var $4V6Dv;
    var $b024406020849893$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("4V6Dv")).default));
});
parcelRegister("az4zD", function(module, exports) {
    $parcel$export(module.exports, "injectIntlV2", ()=>$90dc1bd887533804$export$440265f0ca78e98e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dY8Js = parcelRequire("dY8Js");
    var $koVbs;
    const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
    function $90dc1bd887533804$var$getDisplayName(Component) {
        if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) return Component.displayName;
        if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
        return 'Component';
    }
    const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
        const { withRef: withRef = false } = options || {};
        const WithIntl = (props)=>{
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            const intlRef = (0, $5uXOq.useRef)(null);
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatNumber: intl.formatNumber,
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            });
        };
        WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
        WithIntl.WrappedComponent = WrappedComponent;
        if (withRef) return (0, ($parcel$interopDefault($dY8Js)))((0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WithIntl, {
                ...props,
                forwardedRef: ref
            })), WrappedComponent);
        return (0, ($parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
    };
});
parcelRegister("4V6Dv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83ca195db24613ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $81ps3;
    var $bnbo9;
    const $83ca195db24613ad$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
        const ProjectsBreadcrumb = {
            href: '/jira/projects',
            text: formatMessage((0, (0, parcelRequire("bnbo9")).default).projectsTitle),
            type: 'projectsDirectory',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProjectsList'
            }
        };
        if (projectKey != null && projectName != null) {
            const breadcrumb = {
                href: (0, (0, parcelRequire("81ps3")).createProjectUrl)(projectKey),
                text: projectName,
                type: 'projectName',
                analyticsAttributes: {
                    nextGenProject: isSimplifiedProject,
                    projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
                },
                analyticsFields: {
                    name: 'navigateToProject',
                    containerId: projectId,
                    containerType: 'project'
                }
            };
            const ProjectNameBreadcrumb = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: breadcrumb
            }, children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: ProjectsBreadcrumb
            }, ProjectNameBreadcrumb);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: ProjectsBreadcrumb
        }, children);
    };
    $83ca195db24613ad$var$ProjectBreadcrumb.defaultProps = {
        children: null,
        isSimplifiedProject: false,
        projectId: undefined,
        projectKey: undefined,
        projectName: undefined
    };
    var $83ca195db24613ad$export$2e2bcd8739ae039 = $83ca195db24613ad$var$ProjectBreadcrumb;
});
parcelRegister("bnbo9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b60cdda05341e39$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1b60cdda05341e39$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsTitle: {
            "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("75PvK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc6b338da4258947$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    const $fc6b338da4258947$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
        const breadcrumb = {
            href: profileUrl,
            text: name,
            type: 'userName'
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: breadcrumb
        }, children);
    };
    var $fc6b338da4258947$export$2e2bcd8739ae039 = $fc6b338da4258947$var$UserBreadcrumb;
});
parcelRegister("7OPFF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$760c31310830da08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $760c31310830da08$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
            ...legacyCrumb,
            legacyId: id,
            type: 'legacy'
        });
    const $760c31310830da08$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ContextProvider, null, ({ data: data })=>{
            if (!data) return children;
            const boardBreadcrumb = data.scope ? (0, ($parcel$interopDefault($5uXOq))).createElement(BoardBreadcrumb, {
                boardId: data.scope.id,
                boardName: data.scope.name || 'Board'
            }, children) : children;
            return data.contextType === 'user' ? (0, ($parcel$interopDefault($5uXOq))).createElement(UserBreadcrumb, {
                profileUrl: data.user.profileUrl,
                name: data.user.name
            }, boardBreadcrumb) : (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectBreadcrumb, {
                projectKey: data.project.key,
                projectName: data.project.name,
                projectId: data.project.id,
                isSimplifiedProject: data.project.isSimplified
            }, boardBreadcrumb);
        });
    const $760c31310830da08$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
        const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Breadcrumb, {
                breadcrumb: currentCrumb
            }, accumulatedCrumbs);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($760c31310830da08$var$ContextBreadcrumbs, {
            BoardBreadcrumb: BoardBreadcrumb,
            ProjectBreadcrumb: ProjectBreadcrumb,
            UserBreadcrumb: UserBreadcrumb,
            ContextProvider: ContextProvider
        }, legacyTrail.map($760c31310830da08$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
    };
    var $760c31310830da08$export$2e2bcd8739ae039 = $760c31310830da08$var$LegacyBreadcrumbConnector;
});
parcelRegister("5fGpW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2cc7aa08354ae9ed$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $4DPZY;
    var $dIdda = parcelRequire("dIdda");
    const $2cc7aa08354ae9ed$export$9f27bc3417b4524d = ({ children: children })=>{
        const [boardId] = (0, $dIdda.usePathParam)('boardId');
        const [rapidView] = (0, $dIdda.useQueryParam)('rapidView');
        const [{ data: ctxData, loading: loading, error: error }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, ($parcel$interopDefault($fr1K2)))(ctxData, 'scope');
        return children({
            data: data,
            loading: loading,
            error: error
        });
    };
    var $2cc7aa08354ae9ed$export$2e2bcd8739ae039 = $2cc7aa08354ae9ed$export$9f27bc3417b4524d;
});
parcelRegister("3XHss", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65b3956e27a1612f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $dJl1T;
    var $jS4lj;
    const $65b3956e27a1612f$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
    class $65b3956e27a1612f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidCatch(error) {
            const { targetElement: targetElement } = this.props;
            const targetId = targetElement ? targetElement.id : 'not-found';
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($65b3956e27a1612f$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
        }
        render() {
            const { targetElement: targetElement } = this.props;
            return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null), targetElement);
        }
    }
});
parcelRegister("jS4lj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c6eafb2b612d104$export$2e2bcd8739ae039);
    var $1bJTy;
    var $9sGI6;
    var $9OXo1;
    var $0SW74;
    const $8c6eafb2b612d104$var$fireAnalytics = (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
            name: 'breadcrumbRendererMounted'
        });
    var $8c6eafb2b612d104$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("0SW74")).default), {
        onMount: $8c6eafb2b612d104$var$fireAnalytics,
        TenantContextSubscriber: (0, parcelRequire("9OXo1")).TenantContextSubscriber
    });
});
parcelRegister("0SW74", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa2b8169c8c69f79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8oe80;
    var $4R6GH;
    var $6lcpk;
    var $3HwlS;
    var $aIVNN;
    const $fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
                ...crumb,
                target: crumb.target || '_self'
            }));
    const $fa2b8169c8c69f79$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
        const [{ trail: trail }] = (0, (0, parcelRequire("aIVNN")).useBreadcrumbs)();
        const items = (0, $5uXOq.useMemo)(()=>$fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems(trail), [
            trail
        ]);
        (0, $5uXOq.useEffect)(onMount, []);
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')) return (0, ($parcel$interopDefault($5uXOq))).createElement($fa2b8169c8c69f79$var$BreadcrumbsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lcpk")).default), {
            isVisible: true,
            items: items
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fa2b8169c8c69f79$var$BreadcrumbsWrapperOld, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lcpk")).default), {
            isVisible: true,
            items: items
        }));
    };
    var $fa2b8169c8c69f79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('breadcrumbsRenderer', {
        onMount: 'mounted'
    })($fa2b8169c8c69f79$var$BreadcrumbRenderer);
    const $fa2b8169c8c69f79$var$BreadcrumbsWrapperOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1tcg",
                __cmplp.className
            ])
        });
    });
    const $fa2b8169c8c69f79$var$BreadcrumbsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1tcg _nwukvy9e _1o8h13fh",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6lcpk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$741d99934750459a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jD5no;
    var $j6iTu;
    function $741d99934750459a$export$2e2bcd8739ae039(props) {
        const { isVisible: isVisible, items: items } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j6iTu")).default), {
            isVisible: isVisible,
            items: items
        }));
    }
});
parcelRegister("j6iTu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5be1ac78992edda2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fuUnn;
    var $jbeEq;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $92r9l;
    var $2UzOj;
    const $5be1ac78992edda2$export$67abef37aa2929b0 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            ...props,
            ref: ref,
            type: "a"
        }));
    function $5be1ac78992edda2$export$2e2bcd8739ae039(props) {
        const { isVisible: isVisible, items: items } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return isVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jbeEq")).default), {
            onExpand: (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($gccSB)))(items) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), {
            text: "",
            "aria-label": formatMessage((0, (0, parcelRequire("2UzOj")).default).breadcrumbsLabel)
        }) : items.map((breadcrumb, index)=>{
            const breadcrumbItem = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92r9l")).default), {
                key: index,
                index: index,
                hasSeparator: true,
                text: breadcrumb.text,
                target: __SPA__ ? undefined : breadcrumb.target,
                href: breadcrumb.href,
                component: __SPA__ ? $5be1ac78992edda2$export$67abef37aa2929b0 : undefined,
                legacyId: breadcrumb.legacyId,
                type: breadcrumb.type,
                analyticsAttributes: breadcrumb.analyticsAttributes,
                analyticsFields: breadcrumb.analyticsFields
            });
            return breadcrumbItem;
        }))) : null;
    }
});
parcelRegister("fuUnn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fa85d0f49630632$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3bDjY;
    var $hVWqN;
    var $6hWJD;
    function $8fa85d0f49630632$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8fa85d0f49630632$var$itemWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        maxWidth: '100%',
        height: `${24 / 14}em`,
        margin: "var(--ds-space-0, 0px)",
        padding: "var(--ds-space-0, 0px)",
        flexDirection: 'row',
        '&:not(:last-child)::after': {
            width: '8px',
            flexShrink: 0,
            content: '"/"',
            paddingBlock: "var(--ds-space-025, 2px)",
            paddingInline: "var(--ds-space-100, 8px)",
            textAlign: 'center'
        }
    });
    const $8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
    const $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE = 24;
    const $8fa85d0f49630632$var$staticItemStyles = {
        name: "16sxe12",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
    };
    const $8fa85d0f49630632$var$staticItemWithTruncationStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `var(${$8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH})`
    });
    const $8fa85d0f49630632$var$staticItemWithoutTruncationStyles = {
        name: "1t1nv0p",
        styles: "min-width:0;flex-shrink:1"
    };
    const $8fa85d0f49630632$var$BreadcrumbsItem = (0, $5uXOq.memo)(({ analyticsContext: analyticsContext, component: component, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, ...rest })=>{
        const buttonRef = (0, $5uXOq.useRef)(null);
        let iconWidthAllowance = 0;
        if (iconBefore) iconWidthAllowance += $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE;
        if (iconAfter) iconWidthAllowance += $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE;
        const [hasOverflow, showTooltip] = (0, (0, parcelRequire("6hWJD")).default)(truncationWidth, buttonRef.current, iconWidthAllowance);
        const dynamicItemStyles = {
            [$8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
        };
        const step = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hVWqN")).default), {
            ...rest,
            analyticsContext: analyticsContext,
            component: component,
            hasOverflow: hasOverflow,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            ref: buttonRef,
            target: target,
            testId: testId,
            css: [
                $8fa85d0f49630632$var$staticItemStyles,
                truncationWidth ? $8fa85d0f49630632$var$staticItemWithTruncationStyles : $8fa85d0f49630632$var$staticItemWithoutTruncationStyles
            ],
            style: truncationWidth ? dynamicItemStyles : undefined
        }, text);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("li", {
            css: $8fa85d0f49630632$var$itemWrapperStyles
        }, showTooltip ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown
        }, step) : step);
    });
    var $8fa85d0f49630632$export$2e2bcd8739ae039 = $8fa85d0f49630632$var$BreadcrumbsItem;
});
parcelRegister("hVWqN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a95af0809bc014a8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $fVnbM;
    var $eGmKJ;
    const $a95af0809bc014a8$var$analyticsAttributes = {
        componentName: 'breadcrumbsItem',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $a95af0809bc014a8$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $a95af0809bc014a8$var$Step = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $a95af0809bc014a8$var$noop, target: target, testId: testId, ...props }, ref)=>{
        const handleClicked = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onClickProvided,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$a95af0809bc014a8$var$analyticsAttributes
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle-link",
            component: component,
            href: href,
            iconAfter: hasOverflow ? undefined : iconAfter,
            iconBefore: hasOverflow ? undefined : iconBefore,
            onClick: handleClicked,
            ref: ref,
            spacing: "none",
            target: target,
            testId: testId
        });
    });
    var $a95af0809bc014a8$export$2e2bcd8739ae039 = $a95af0809bc014a8$var$Step;
});
parcelRegister("6hWJD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39e9e81e9bc6c25a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $39e9e81e9bc6c25a$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
        const [hasOverflow, setOverflow] = (0, $5uXOq.useState)(true);
        const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (truncationWidth && buttonRefCurrent) {
                const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
                const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
                setOverflow(shouldOverflow);
                setShowTooltip(shouldShowTooltip);
            } else {
                setOverflow(false);
                setShowTooltip(false);
            }
        }, [
            truncationWidth,
            buttonRefCurrent,
            iconWidthAllowance
        ]);
        return [
            hasOverflow,
            showTooltip
        ];
    }
});
parcelRegister("jbeEq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f33b456747f6edef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $eGmKJ;
    var $iidvu;
    var $5djWe;
    function $f33b456747f6edef$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f33b456747f6edef$var$defaultMaxItems = 8;
    const $f33b456747f6edef$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
    const $f33b456747f6edef$var$defaultEllipsisLabel = 'Show more breadcrumbs';
    const { toArray: $f33b456747f6edef$var$toArray } = (0, ($parcel$interopDefault($5uXOq))).Children;
    const $f33b456747f6edef$var$analyticsAttributes = {
        componentName: 'breadcrumbs',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $f33b456747f6edef$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $f33b456747f6edef$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
    const $f33b456747f6edef$var$breadcrumbStyles = {
        name: "m6vsls",
        styles: "display:flex;margin:var(--ds-space-0, 0px);padding:var(--ds-space-0, 0px);flex-wrap:wrap"
    };
    const $f33b456747f6edef$var$InnerBreadcrumbs = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $f33b456747f6edef$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $f33b456747f6edef$var$noop, analyticsContext: analyticsContext, label: label = $f33b456747f6edef$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $f33b456747f6edef$var$defaultEllipsisLabel } = props;
        const [expanded, setExpanse] = (0, $5uXOq.useState)(defaultExpanded);
        const [isClickedBySpace, setExpansionTrigger] = (0, $5uXOq.useState)(false);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const isControlled = typeof isExpanded !== 'undefined';
        const isExpansionHandled = providedExpanse !== $f33b456747f6edef$var$noop;
        const shouldExpand = isControlled ? isExpanded : expanded;
        const focusFirstRevealed = ()=>{
            if (wrapperRef.current) {
                const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
                const interactiveElements = listItems.map((li)=>li.querySelector($f33b456747f6edef$var$interactiveElementSelector));
                const elementToFocus = interactiveElements[itemsBeforeCollapse];
                const firstInteractiveElement = interactiveElements[0];
                if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
                else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
                else wrapperRef.current.focus();
            }
            setExpansionTrigger(false);
        };
        (0, (0, parcelRequire("5djWe")).useOnRevealed)(focusFirstRevealed, {
            isExpanded: shouldExpand,
            isDisabled: !isClickedBySpace
        });
        const handleExpansion = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (!isControlled) setExpanse((expanded)=>!expanded);
                if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
                return providedExpanse(event, analyticsEvent);
            },
            action: 'expanded',
            analyticsData: analyticsContext,
            ...$f33b456747f6edef$var$analyticsAttributes
        });
        const childrenArray = $f33b456747f6edef$var$toArray(children);
        const breadcrumbsArray = (0, ($parcel$interopDefault($5uXOq))).Children.map(childrenArray, (child, index)=>{
            if (typeof child === 'string') return child;
            return childrenArray.length - 1 === index ? (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                'aria-current': 'page'
            }) : child;
        });
        const renderItemsWithEllipsis = ()=>{
            const allItems = breadcrumbsArray;
            if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
            const beforeItems = allItems.slice(0, itemsBeforeCollapse);
            const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
            return [
                ...beforeItems,
                (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iidvu")).default), {
                    key: "ellipsis",
                    testId: testId && `${testId}--breadcrumb-ellipsis`,
                    onClick: handleExpansion,
                    label: ellipsisLabel
                }),
                ...afterItems
            ];
        };
        const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
        const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("nav", {
            "aria-label": label,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("ol", {
            "data-testid": testId,
            css: $f33b456747f6edef$var$breadcrumbStyles,
            style: {
                color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
            }
        }, breadcrumbsItems));
    });
    const $f33b456747f6edef$var$Breadcrumbs = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f33b456747f6edef$var$InnerBreadcrumbs, {
            ...props,
            analyticsContext: analyticsContext,
            children: children,
            createAnalyticsEvent: createAnalyticsEvent,
            defaultExpanded: defaultExpanded,
            ellipsisLabel: ellipsisLabel,
            isExpanded: isExpanded,
            itemsAfterCollapse: itemsAfterCollapse,
            itemsBeforeCollapse: itemsBeforeCollapse,
            label: label,
            maxItems: maxItems,
            onExpand: onExpand,
            ref: ref,
            testId: testId
        })));
    var $f33b456747f6edef$export$2e2bcd8739ae039 = $f33b456747f6edef$var$Breadcrumbs;
});
parcelRegister("iidvu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3f2526167b8235c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fVnbM;
    var $eGmKJ;
    function $b3f2526167b8235c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b3f2526167b8235c$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $b3f2526167b8235c$var$itemWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        maxWidth: '100%',
        height: `${24 / 14}em`,
        margin: "var(--ds-space-0, 0px)",
        padding: "var(--ds-space-0, 0px)",
        flexDirection: 'row',
        '&:not(:last-child)::after': {
            width: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            content: '"/"',
            paddingBlock: "var(--ds-space-025, 2px)",
            paddingInline: "var(--ds-space-100, 8px)",
            textAlign: 'center'
        }
    });
    const $b3f2526167b8235c$var$staticItemStyles = {
        name: "16sxe12",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
    };
    const $b3f2526167b8235c$var$EllipsisItem = (0, $5uXOq.memo)(({ label: label, onClick: onClick = $b3f2526167b8235c$var$noop, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("li", {
            css: $b3f2526167b8235c$var$itemWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            "aria-label": label,
            css: $b3f2526167b8235c$var$staticItemStyles,
            onClick: onClick,
            spacing: "none",
            testId: testId
        }, "\u2026")));
    var $b3f2526167b8235c$export$2e2bcd8739ae039 = $b3f2526167b8235c$var$EllipsisItem;
});
parcelRegister("5djWe", function(module, exports) {
    $parcel$export(module.exports, "useOnRevealed", ()=>$16bf9036c9802d42$export$e9c4922b2ecf808a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lp9re;
    function $16bf9036c9802d42$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
        const prevExtended = (0, (0, parcelRequire("lp9re")).default)(isExpanded);
        (0, $5uXOq.useEffect)(()=>{
            const hasBeenRevealed = !prevExtended && isExpanded;
            if (!isDisabled && hasBeenRevealed) callback();
        }, [
            isExpanded,
            isDisabled,
            callback,
            prevExtended
        ]);
    }
});
parcelRegister("92r9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77e0cddbf99d95bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fuUnn;
    var $dOvpK;
    class $77e0cddbf99d95bf$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                href: undefined,
                legacyId: undefined,
                type: 'unspecified',
                analyticsAttributes: {},
                analyticsFields: {}
            };
        }
        render() {
            const { index: index, text: text, target: target, href: href, component: component } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), {
                key: index,
                text: text,
                onClick: this.onBreadCrumbClick,
                target: target,
                href: href,
                component: component
            });
        }
        constructor(...args){
            super(...args);
            this.onBreadCrumbClick = (event, analyticsEvent)=>{
                const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
                (0, (0, parcelRequire("dOvpK")).fireUiAnalytics)(analyticsEvent, {
                    name: '',
                    attributes: {
                        legacyId: legacyId,
                        depth: index + 1,
                        type: type,
                        ...analyticsAttributes
                    },
                    ...analyticsFields
                });
            };
        }
    }
});
parcelRegister("dOvpK", function(module, exports) {
    $parcel$export(module.exports, "fireUiAnalytics", ()=>$8c2abcc805e894f7$export$4909253b5bf1eed7);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $gvRPW;
    var $i4iBk;
    const $8c2abcc805e894f7$var$isNotUndefined = (a)=>a !== undefined;
    const $8c2abcc805e894f7$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $8c2abcc805e894f7$var$isNotUndefined);
    };
    const $8c2abcc805e894f7$export$4909253b5bf1eed7 = (event, payload)=>{
        event.update({
            ...$8c2abcc805e894f7$var$mapPayload(payload),
            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("2UzOj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e3ad53695e8cbba$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8e3ad53695e8cbba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        breadcrumbsLabel: {
            "id": "navigation-apps.breadcrumbs.aria-label",
            "defaultMessage": "Empty Breadcrumbs item"
        }
    });
});
parcelRegister("1DFxi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3b01c7b039743c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $9b3b01c7b039743c$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
    const $9b3b01c7b039743c$var$defaultInitialState = {
        trail: [],
        targetElement: null
    };
    class $9b3b01c7b039743c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                initialState: $9b3b01c7b039743c$var$defaultInitialState
            };
        }
        constructor(props){
            super(props);
            this.onInsertItem = (item)=>{
                this.setState((state)=>({
                        trail: [
                            ...state.trail,
                            item
                        ].sort($9b3b01c7b039743c$var$compareBreadcrumbs)
                    }));
            };
            this.onRemoveItem = (id)=>{
                this.setState((state)=>({
                        trail: state.trail.filter((b)=>b.id !== id)
                    }));
            };
            this.onTargetSet = (targetElement)=>{
                this.setState({
                    targetElement: targetElement
                });
            };
            this.api = {
                setTargetElement: this.onTargetSet,
                insertItem: this.onInsertItem,
                removeItem: this.onRemoveItem
            };
            this.state = props.initialState;
        }
        render() {
            const { children: children } = this.props;
            return children({
                state: this.state,
                api: this.api
            });
        }
    }
});
parcelRegister("lDu2T", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$c284a07391432f3b$export$6e4bfef9e80c7eb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $lsa9q;
    var $j7rCb;
    const $c284a07391432f3b$export$6e4bfef9e80c7eb0 = ()=>{
        const [{ hasLoaded: hasLoaded }] = (0, (0, parcelRequire("lsa9q")).default)();
        const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, (0, parcelRequire("j7rCb")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            if (hasLoaded) {
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            } else resetPhase();
        }, [
            hasLoaded,
            resetPhase,
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("jnXgM", function(module, exports) {
    $parcel$export(module.exports, "TrackClicksBeforeTTI", ()=>$0e1519f86dabd57c$export$2846c12b8c092470);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $6yXtV;
    const $0e1519f86dabd57c$var$cleanUrl = (pathname)=>{
        let url = pathname.replace(/\/$/, '');
        if (/\/browse\/\w+$/.test(url)) url = 'browse';
        if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
        return url;
    };
    const $0e1519f86dabd57c$export$2846c12b8c092470 = ()=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isReady) return;
            try {
                const sessionStorageItems = sessionStorage.getItem('clicks-before-tti');
                if (sessionStorageItems == null || sessionStorageItems === '') return;
                const items = JSON.parse(sessionStorageItems);
                items.forEach((item)=>{
                    let extras = {
                        elementId: item.dataId,
                        currentUrl: $0e1519f86dabd57c$var$cleanUrl(item.currentUrl),
                        bundleId: item.bundleId,
                        time: item.time
                    };
                    if (item.redirectUrl !== '') extras = {
                        ...extras,
                        redirectUrl: $0e1519f86dabd57c$var$cleanUrl(item.redirectUrl)
                    };
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                        action: 'clicked'
                    }), 'nonInteractiveElement clicked', '', extras);
                });
                sessionStorage.removeItem('clicks-before-tti');
            } catch (error) {
                console.error(error);
            }
        }, [
            createAnalyticsEvent,
            isReady
        ]);
        return null;
    };
});
parcelRegister("EgodS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bnKSn")
    ]).then(()=>parcelRequire('6kz4R'));
});
parcelRegister("aQHAS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kpDDc").then(()=>parcelRequire('a8CW2'));
});
parcelRegister("i1RfD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("humN1").then(()=>parcelRequire('7l6f4'));
});
parcelRegister("iRWz9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("pGAVo").then(()=>parcelRequire('hfEgP'));
});
parcelRegister("D2tCn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8f0xo").then(()=>parcelRequire('cDo25'));
});
parcelRegister("lGCVr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3TwVo").then(()=>parcelRequire('aUZKu'));
});
parcelRegister("gmCnE", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$08223c6bc94e2fa4$export$3b4e64e77073e307);
    var $5uXOq = parcelRequire("5uXOq");
    var $gwIPs;
    var $kfAVA;
    var $co1wz;
    var $7XYc4;
    var $4R6GH;
    var $asgRx;
    var $6ohPr;
    var $3HwlS;
    var $iqLcb;
    var $9L6Zg;
    var $gk4cG;
    var $c1ivz;
    var $iaN8D;
    var $14pJv;
    var $921us;
    var $9Cdg4;
    var $aAExw;
    var $9ylrc;
    var $l8ruj;
    var $dm0Uk;
    const $08223c6bc94e2fa4$var$TEST_ID = 'page-layout.banner';
    const $08223c6bc94e2fa4$export$496ffd8dda3bf451 = ()=>{
        const banner = (0, (0, parcelRequire("9L6Zg")).useBanner)();
        return banner.isEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "banner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Banner), {
            height: banner.height,
            testId: $08223c6bc94e2fa4$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
            bannerName: banner.name
        }))) : null;
    };
    const $08223c6bc94e2fa4$export$b5cfff585ada92ce = ()=>{
        const banner = (0, (0, parcelRequire("9L6Zg")).useBanner)();
        return banner.isEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "banner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dm0Uk")).ZIndexWrapper), {
            zIndex: (0, (0, parcelRequire("gwIPs")).layers).banner
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Banner), {
            height: banner.height
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
            bannerName: banner.name
        })))) : null;
    };
    const $08223c6bc94e2fa4$var$BannerContent = ({ bannerName: bannerName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, bannerName === (0, (0, parcelRequire("gk4cG")).NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1ivz")).BannerAnnouncementAsync), null), bannerName === (0, (0, parcelRequire("asgRx")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ohPr")).IPBlocklistingBannerAsync), null), bannerName === (0, (0, parcelRequire("aAExw")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ylrc")).ReturnToMobileBanner), null), bannerName === (0, $91be75e714d10b24$export$41956b146268af93) && (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-cookie-controls-banner-show') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kfAVA")).CookieConsentBannerAsync), null), (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && bannerName === (0, (0, parcelRequire("iaN8D")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("14pJv")).BannerTransitionAsync), null), bannerName === (0, (0, parcelRequire("921us")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Cdg4")).MailExpiryBannerAsync), null));
    const $08223c6bc94e2fa4$export$3b4e64e77073e307 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $08223c6bc94e2fa4$export$496ffd8dda3bf451, $08223c6bc94e2fa4$export$b5cfff585ada92ce);
});
const $91be75e714d10b24$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $91be75e714d10b24$export$ed7cc0d417ee89e = 74;
const $91be75e714d10b24$export$ff6e18f7d82b549c = 320;
parcelRegister("kfAVA", function(module, exports) {
    $parcel$export(module.exports, "CookieConsentBannerAsync", ()=>$cbbe578478bf6317$export$f110a9cbbbd3fa3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $cbbe578478bf6317$var$LazyCookieConsentBanner = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("bKpcl")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
        moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/index.tsx"
    });
    const $cbbe578478bf6317$export$f110a9cbbbd3fa3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $cbbe578478bf6317$var$boxStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-cookie-consent-banner",
            packageName: "jiraCookieConsentBanner",
            teamName: "Magma"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-cookie-consent-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cbbe578478bf6317$var$LazyCookieConsentBanner, null))));
    const $cbbe578478bf6317$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'elevation.surface.sunken',
        height: '100%'
    });
});
parcelRegister("bKpcl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6h9FI")
    ]).then(()=>parcelRequire('bwpT1'));
});
parcelRegister("asgRx", function(module, exports) {
    $parcel$export(module.exports, "bannerHeight", ()=>$692526aac37c19f2$export$86047f02632f9f5b);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$692526aac37c19f2$export$41956b146268af93);
    var $gwIPs;
    const $692526aac37c19f2$export$86047f02632f9f5b = (0, (0, parcelRequire("gwIPs")).gridSize) * 7;
    const $692526aac37c19f2$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';
});
parcelRegister("6ohPr", function(module, exports) {
    $parcel$export(module.exports, "IPBlocklistingBannerAsync", ()=>$f9467d6df1e451da$export$fafc306b802ab39d);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $f9467d6df1e451da$var$IPBlocklistingBannerComp = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("57iCZ")).then((m)=>m.IPBlocklistingBanner), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
    });
    const $f9467d6df1e451da$export$fafc306b802ab39d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-ip-block-listing-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f9467d6df1e451da$var$IPBlocklistingBannerComp, null));
});
parcelRegister("57iCZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("12K5T")
    ]).then(()=>parcelRequire('h9o9V'));
});
parcelRegister("9L6Zg", function(module, exports) {
    $parcel$export(module.exports, "useBanner", ()=>$83eb9a3cdcaec997$export$de40f69ba30f2376);
    var $5uXOq = parcelRequire("5uXOq");
    var $iPh5B;
    var $co1wz;
    var $4R6GH;
    var $iMzQW;
    var $14V0U;
    var $6RMJw;
    var $hESBP;
    var $2jAre;
    var $lrZro;
    const $83eb9a3cdcaec997$var$noBanner = {
        name: null,
        height: 0,
        isEnabled: false
    };
    const $83eb9a3cdcaec997$export$de40f69ba30f2376 = ()=>{
        const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
        const announcement = (0, (0, parcelRequire("6RMJw")).useBannerAnnouncement)();
        const transition = (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') ? (0, (0, parcelRequire("hESBP")).useBannerEocTransition)() : undefined;
        const returnToMobile = (0, (0, parcelRequire("lrZro")).useBannerReturnToMobile)();
        const IPBlocklisting = (0, (0, parcelRequire("iMzQW")).useBannerIPBlocklisting)();
        const cookieConsent = (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-cookie-controls-banner-show') ? (0, (0, parcelRequire("iPh5B")).useBannerCookieConsent)() : undefined;
        const mailExpiry = (0, (0, parcelRequire("2jAre")).useBannerMailExpiry)();
        return (0, $5uXOq.useMemo)(()=>{
            if (cookieConsent?.isEnabled) return cookieConsent;
            if (isChromeless) return $83eb9a3cdcaec997$var$noBanner;
            if (IPBlocklisting.isEnabled) return IPBlocklisting;
            if (returnToMobile.isEnabled) return returnToMobile;
            if (announcement.isEnabled) return announcement;
            if (transition?.isEnabled) return transition;
            if (mailExpiry?.isEnabled) return mailExpiry;
            return $83eb9a3cdcaec997$var$noBanner;
        }, [
            cookieConsent,
            isChromeless,
            IPBlocklisting,
            returnToMobile,
            announcement,
            transition,
            mailExpiry
        ]);
    };
});
parcelRegister("iPh5B", function(module, exports) {
    $parcel$export(module.exports, "useBannerCookieConsent", ()=>$e552544bdd302edb$export$c7a51b5ee06f5794);
    var $5uXOq = parcelRequire("5uXOq");
    var $e7OnS;
    var $1q8Xn;
    var $3TzYp;
    var $co1wz;
    var $e5wyW;
    var $2eyDn;
    var $gubdC;
    const $e552544bdd302edb$export$5503c67b1001ec45 = (data)=>{
        try {
            const shouldShowBannerBit = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
            const shouldShowBannerBitState = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
            return data && (0, (0, parcelRequire("1q8Xn")).shouldRenderBannerPrefetched)(data) || shouldShowBannerBitState;
        } catch (e) {
            return true;
        }
    };
    const $e552544bdd302edb$var$useBannerCookieConsentV2 = ()=>{
        const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, (0, parcelRequire("gubdC")).useCookieConsentBannerSettings)();
        const { data: data } = (0, (0, parcelRequire("2eyDn")).useConsentBannerUserPreferencesResource)();
        (0, $5uXOq.useEffect)(()=>{
            const shouldRender = $e552544bdd302edb$export$5503c67b1001ec45(data);
            if (shouldRender && !(0, (0, parcelRequire("gubdC")).isInIframe)()) onShow();
        }, [
            data,
            onShow
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: !isDismissed,
                name: (0, $91be75e714d10b24$export$41956b146268af93),
                height: height
            }), [
            isDismissed,
            height
        ]);
    };
    const $e552544bdd302edb$var$useBannerCookieConsentV1 = ()=>{
        const [{ isDismissed: isDismissed, height: height }] = (0, (0, parcelRequire("gubdC")).useCookieConsentBannerSettings)();
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: !isDismissed,
                name: (0, $91be75e714d10b24$export$41956b146268af93),
                height: height
            }), [
            isDismissed,
            height
        ]);
    };
    const $e552544bdd302edb$export$c7a51b5ee06f5794 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2'), $e552544bdd302edb$var$useBannerCookieConsentV2, $e552544bdd302edb$var$useBannerCookieConsentV1);
});
parcelRegister("1q8Xn", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderBannerPrefetched", ()=>$108f2ac081db59d2$export$6406464aa126433e);
    var $j78Eu;
    var $4qYnX;
    var $fIz84;
    const $108f2ac081db59d2$export$6406464aa126433e = (prefetchedPreferencesData)=>{
        if (!prefetchedPreferencesData) return true;
        if ('consentToken' in prefetchedPreferencesData) {
            const { isValid: isValid } = (0, (0, parcelRequire("4qYnX")).checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
            return isValid ? (0, (0, parcelRequire("fIz84")).getBannerVisibility)(prefetchedPreferencesData) : true;
        }
        const consentPrefsData = (0, (0, parcelRequire("j78Eu")).buildConsentPreferences)(prefetchedPreferencesData);
        return (0, (0, parcelRequire("fIz84")).getBannerVisibility)(consentPrefsData);
    };
});
parcelRegister("j78Eu", function(module, exports) {
    $parcel$export(module.exports, "buildConsentPreferences", ()=>$dea561e3ec632085$export$bd9f5bcbf9cd947c);
    $parcel$export(module.exports, "fetchConsentPreferences", ()=>$dea561e3ec632085$export$86467566615ab85e);
    $parcel$export(module.exports, "saveConsentPreferences", ()=>$dea561e3ec632085$export$f8422650c3dec8b2);
    var $cala7;
    var $7PdQG;
    const $dea561e3ec632085$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
    const $dea561e3ec632085$var$POST_CONSENTS_URL = `${$dea561e3ec632085$var$BASE_CONSENTS_URL}/user`;
    const $dea561e3ec632085$var$GET_CONSENTS_URL = `${$dea561e3ec632085$var$POST_CONSENTS_URL}/consents/cookies`;
    const $dea561e3ec632085$export$bd9f5bcbf9cd947c = (consentData)=>{
        if (consentData) {
            const serializedConsents = (0, (0, parcelRequire("7PdQG")).serializeConsents)(consentData);
            const consentTimestamp = (0, (0, parcelRequire("7PdQG")).getConsentTimestamp)(consentData);
            return {
                consentToken: serializedConsents,
                consentTimestamp: consentTimestamp
            };
        }
        return {
            consentToken: (0, (0, parcelRequire("7PdQG")).serializeConsents)({}),
            consentHubInaccessible: true
        };
    };
    const $dea561e3ec632085$export$86467566615ab85e = async ()=>{
        const { origin: origin } = window.location;
        const getFromConsentHubURL = `${origin}${$dea561e3ec632085$var$GET_CONSENTS_URL}`;
        try {
            const response = await fetch(getFromConsentHubURL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
            const consentData = await response.json();
            return $dea561e3ec632085$export$bd9f5bcbf9cd947c(consentData);
        } catch (err) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'fetchConsentPreferencesError',
                message: err.message || ''
            });
            return $dea561e3ec632085$export$bd9f5bcbf9cd947c();
        }
    };
    const $dea561e3ec632085$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
        const { origin: origin, pathname: pathname } = window.location;
        const deserializedConsents = (0, (0, parcelRequire("7PdQG")).deserializeConsents)(unpackedUserPreferences, displayedTextMap);
        const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
        const consentRequestBody = {
            action: action,
            consents: deserializedConsents,
            formUrl: `${origin}${pathname}`,
            locale: 'UNKNOWN',
            site: 'atlassian',
            source: 'COOKIE_PREFERENCES'
        };
        return JSON.stringify(consentRequestBody);
    };
    const $dea561e3ec632085$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
        const saveToConsentHubURL = `${window.location.origin}${$dea561e3ec632085$var$POST_CONSENTS_URL}`;
        try {
            const response = await fetch(saveToConsentHubURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: $dea561e3ec632085$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
            });
            if (!response.ok || response.status !== 202 && response.status !== 200) {
                const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
                const errWithStatusCode = new (0, (0, parcelRequire("7PdQG")).StatusCodeError)(errMsg, response.status);
                throw errWithStatusCode;
            }
        } catch (err) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'saveConsentPreferencesError',
                message: err.message || ''
            });
            throw err;
        }
    };
});
parcelRegister("7PdQG", function(module, exports) {
    $parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", ()=>$5b2809e72e2d850c$export$42b0ca8aba2631e4);
    $parcel$export(module.exports, "checkIfTokenIsDefault", ()=>$5b2809e72e2d850c$export$497a647f0eb30ef4);
    $parcel$export(module.exports, "serializeConsents", ()=>$5b2809e72e2d850c$export$92ba0b2fe50f90df);
    $parcel$export(module.exports, "deserializeConsents", ()=>$5b2809e72e2d850c$export$bfa0c91662787fb0);
    $parcel$export(module.exports, "getConsentTimestamp", ()=>$5b2809e72e2d850c$export$13e4cff933f26b03);
    $parcel$export(module.exports, "checkIfConsentsAreStale", ()=>$5b2809e72e2d850c$export$3387347b75450ae1);
    $parcel$export(module.exports, "StatusCodeError", ()=>$5b2809e72e2d850c$export$a79c0ea3d7c2444a);
    var $1Vlui;
    var $e7OnS;
    var $eMLDH;
    var $iG1qD;
    var $413OZ;
    const $5b2809e72e2d850c$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV2Schema = version === (0, (0, parcelRequire("e7OnS")).V002_SCHEMA_KEY);
        return isV2Schema;
    };
    const $5b2809e72e2d850c$var$isLegacyV1Token = (consentToken)=>{
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV1Schema = version === (0, (0, parcelRequire("e7OnS")).V001_SCHEMA_KEY);
        return isV1Schema;
    };
    const $5b2809e72e2d850c$export$42b0ca8aba2631e4 = (consentToken)=>{
        if ($5b2809e72e2d850c$var$isLegacyGeoTargetingV2Token(consentToken)) {
            const consentedUnderGDPR = consentToken[8] === '1';
            const consentedUnderCPRA = consentToken[9] === '1';
            const consentedUnderLGPD = consentToken[10] === '1';
            const consentedUnderFADP = consentToken[11] === '1';
            const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
            return hasConsentedPreviously;
        }
        return false;
    };
    const $5b2809e72e2d850c$export$497a647f0eb30ef4 = (consentToken)=>{
        const isLegacyV2ConsentToken = $5b2809e72e2d850c$var$isLegacyGeoTargetingV2Token(consentToken);
        const isLegacyV1ConsentToken = $5b2809e72e2d850c$var$isLegacyV1Token(consentToken);
        if (isLegacyV2ConsentToken) {
            const legacyTokenHasConsents = $5b2809e72e2d850c$export$42b0ca8aba2631e4(consentToken);
            return !legacyTokenHasConsents;
        }
        if (isLegacyV1ConsentToken) return false;
        const isDefaultToken = (0, (0, parcelRequire("1Vlui")).getBoolFromBitValue)(consentToken[7]);
        return isDefaultToken;
    };
    const $5b2809e72e2d850c$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
        const version = (0, (0, parcelRequire("e7OnS")).V003_SCHEMA_KEY);
        const serializedBits = Object.entries((0, (0, parcelRequire("e7OnS")).DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
            if (key === (0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary) return acc;
            if (key === (0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).UserIsAuthenticated) {
                const userIsAuthed = !consentsUnavailable;
                return acc + (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userIsAuthed);
            }
            if (key === (0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable) return acc + (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(!!consentsUnavailable);
            return acc + (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(val);
        }, '');
        return `${version}${serializedBits}`;
    };
    const $5b2809e72e2d850c$export$42a0b3fb1e53e7b9 = (consents)=>{
        var _consents$find, _consents$find2, _consents$find3, _consents$find4;
        const version = (0, (0, parcelRequire("e7OnS")).V003_SCHEMA_KEY);
        const functionalConsent = (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, (0, parcelRequire("413OZ")).ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
        const analyticsConsent = (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, (0, parcelRequire("413OZ")).ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
        const marketingConsent = (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, (0, parcelRequire("413OZ")).ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
        const unknownConsent = (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, (0, parcelRequire("413OZ")).ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
        const isDefaultToken = 0;
        const userIsAuthenticated = 1;
        const consentHubDataUnavailable = 0;
        return [
            version,
            functionalConsent,
            analyticsConsent,
            marketingConsent,
            unknownConsent,
            isDefaultToken,
            userIsAuthenticated,
            consentHubDataUnavailable
        ].join('');
    };
    const $5b2809e72e2d850c$export$92ba0b2fe50f90df = ({ consents: consents })=>{
        if (!consents) {
            const existingFallbackToken = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if (existingFallbackToken) return existingFallbackToken;
            return $5b2809e72e2d850c$export$c42e1a74e60f4d73(true);
        } else if (consents.length === 0) return $5b2809e72e2d850c$export$c42e1a74e60f4d73();
        else return $5b2809e72e2d850c$export$42a0b3fb1e53e7b9(consents);
    };
    const $5b2809e72e2d850c$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
        const validConsentHubCookieConsents = [
            (0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary,
            (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional,
            (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics,
            (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing,
            (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown
        ];
        const consentKeyMap = {
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary]: (0, (0, parcelRequire("413OZ")).ConsentHubKey).StrictlyNecessary,
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]: (0, (0, parcelRequire("413OZ")).ConsentHubKey).Functional,
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]: (0, (0, parcelRequire("413OZ")).ConsentHubKey).Analytics,
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]: (0, (0, parcelRequire("413OZ")).ConsentHubKey).Marketing,
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]: (0, (0, parcelRequire("413OZ")).ConsentHubKey).Unknown
        };
        const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
            const key = consentKeyMap[consentKey];
            return {
                key: key,
                granted: !!unpackedUserPreferences[consentKey],
                gatheredTs: new Date().toISOString(),
                displayedText: displayedTextMap[consentKey]
            };
        });
        return consentRecords;
    };
    const $5b2809e72e2d850c$export$13e4cff933f26b03 = ({ consents: consents })=>{
        if (consents && consents.length) {
            const timestamps = consents.map((consent)=>{
                return new Date(consent.updatedTs).getTime();
            });
            const maxTimestamp = Math.max(...timestamps);
            const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
            return mostRecentConsentTimestamp;
        }
    };
    const $5b2809e72e2d850c$export$3387347b75450ae1 = (consentTimestamp)=>{
        let consentedOverAYearAgo = false;
        if (consentTimestamp) {
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
            consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
        }
        return consentedOverAYearAgo;
    };
    class $5b2809e72e2d850c$export$a79c0ea3d7c2444a extends Error {
        constructor(message, status){
            super(message);
            this.status = status;
            Object.setPrototypeOf(this, $5b2809e72e2d850c$export$a79c0ea3d7c2444a.prototype);
            if (Error.captureStackTrace) Error.captureStackTrace(this, $5b2809e72e2d850c$export$a79c0ea3d7c2444a);
            this.name = 'StatusCodeError';
        }
    }
});
parcelRegister("1Vlui", function(module, exports) {
    $parcel$export(module.exports, "getBitValueFromBool", ()=>$166bc856fd06b60e$export$929f1500428a1fc8);
    $parcel$export(module.exports, "getBoolFromBitValue", ()=>$166bc856fd06b60e$export$27647458f3cf29d2);
    const $166bc856fd06b60e$export$929f1500428a1fc8 = (value)=>{
        return Number(value).toString();
    };
    const $166bc856fd06b60e$export$27647458f3cf29d2 = (bitValue)=>{
        if (bitValue) return !!Number(bitValue);
    };
});
parcelRegister("413OZ", function(module, exports) {
    $parcel$export(module.exports, "ConsentHubKey", ()=>$2eca384755b92c3c$export$31140359b1e505cf);
    let $2eca384755b92c3c$export$31140359b1e505cf = function(ConsentHubKey) {
        ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
        ConsentHubKey["Functional"] = "functionalCookies";
        ConsentHubKey["Analytics"] = "performanceCookies";
        ConsentHubKey["Marketing"] = "targetingCookies";
        ConsentHubKey["Unknown"] = "unknownCookies";
        return ConsentHubKey;
    }({});
});
parcelRegister("4qYnX", function(module, exports) {
    $parcel$export(module.exports, "checkTokenVersionValidity", ()=>$33a86e65aee8b4c4$export$64b31470e8522819);
    $parcel$export(module.exports, "packUserPreferences", ()=>$33a86e65aee8b4c4$export$3199823fec979bd1);
    $parcel$export(module.exports, "unpackUserPreferencesCookie", ()=>$33a86e65aee8b4c4$export$8d213cb390bab4fa);
    $parcel$export(module.exports, "initialPreferencesAreMissing", ()=>$33a86e65aee8b4c4$export$67f70eb55341bd29);
    $parcel$export(module.exports, "initializePreferencesData", ()=>$33a86e65aee8b4c4$export$7962405c3ca274b1);
    var $VSDnB;
    var $1Vlui;
    var $e7OnS;
    var $7PdQG;
    var $iG1qD;
    const $33a86e65aee8b4c4$export$64b31470e8522819 = (consentToken)=>{
        if (consentToken.length < 3) return {
            isValid: false,
            isV001: false,
            isV002: false,
            isV003: false
        };
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV001 = version === (0, (0, parcelRequire("e7OnS")).V001_SCHEMA_KEY) && consentToken.length === 7;
        const isV002 = version === (0, (0, parcelRequire("e7OnS")).V002_SCHEMA_KEY) && consentToken.length === 12;
        const isV003 = version === (0, (0, parcelRequire("e7OnS")).V003_SCHEMA_KEY) && consentToken.length === 10;
        const isSupportedVersion = [
            (0, (0, parcelRequire("e7OnS")).V001_SCHEMA_KEY),
            (0, (0, parcelRequire("e7OnS")).V002_SCHEMA_KEY),
            (0, (0, parcelRequire("e7OnS")).V003_SCHEMA_KEY)
        ].includes(version);
        const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
        return {
            isValid: isValid,
            isV001: isV001,
            isV002: isV002,
            isV003: isV003
        };
    };
    const $33a86e65aee8b4c4$var$packPrefsVersion001 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("e7OnS")).V001_SCHEMA_KEY);
        return [
            version,
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences.FUNCTIONAL),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences.ANALYTICS),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences.MARKETING),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences.UNKNOWN)
        ].join('');
    };
    const $33a86e65aee8b4c4$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
        if (userPreferencesCookie.length !== 7) return;
        return {
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary]: true,
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
        };
    };
    const $33a86e65aee8b4c4$var$packPrefsVersion002 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("e7OnS")).V003_SCHEMA_KEY);
        const hasConsentedPreviously = userPreferences[(0, (0, parcelRequire("iG1qD")).ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, (0, parcelRequire("iG1qD")).ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, (0, parcelRequire("iG1qD")).ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, (0, parcelRequire("iG1qD")).ConsentPreferenceV2).ConsentedUnderFADP];
        const isDefaultConsentBit = !hasConsentedPreviously;
        const existingConsentDataUnavailableBit = userPreferences[(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable];
        const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
        return [
            version,
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(isDefaultConsentBit),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userIsAuthenticatedBit),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(existingConsentDataUnavailableBit)
        ].join('');
    };
    const $33a86e65aee8b4c4$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
        const isADefaultConsentToken = (0, (0, parcelRequire("7PdQG")).checkIfTokenIsDefault)(userPreferencesCookie);
        const consentDataUnavailable = userPreferencesCookie[7] === '1';
        const userIsDeemedAuthenticated = !consentDataUnavailable;
        return {
            ...$33a86e65aee8b4c4$var$unpackPrefsVersion003(userPreferencesCookie),
            [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
            [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
            [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
        };
    };
    const $33a86e65aee8b4c4$var$packPrefsVersion003 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("e7OnS")).V003_SCHEMA_KEY);
        return [
            version,
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentsAreDefault]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).UserIsAuthenticated]),
            (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable])
        ].join('');
    };
    const $33a86e65aee8b4c4$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
        return {
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary]: true,
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
            [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
            [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
            [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
            [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
        };
    };
    const $33a86e65aee8b4c4$var$V002SpecificBitKeys = [
        (0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable,
        (0, (0, parcelRequire("iG1qD")).ConsentPreferenceV2).ConsentedUnderGDPR,
        (0, (0, parcelRequire("iG1qD")).ConsentPreferenceV2).ConsentedUnderCPRA,
        (0, (0, parcelRequire("iG1qD")).ConsentPreferenceV2).ConsentedUnderLGPD,
        (0, (0, parcelRequire("iG1qD")).ConsentPreferenceV2).ConsentedUnderFADP
    ];
    const $33a86e65aee8b4c4$var$V003SpecificBitKeys = [
        (0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentsAreDefault,
        (0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).UserIsAuthenticated,
        (0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable
    ];
    function $33a86e65aee8b4c4$export$3199823fec979bd1(userPreferences) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls-v2')) return $33a86e65aee8b4c4$var$packPrefsVersion001(userPreferences);
        const isV002 = $33a86e65aee8b4c4$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
        if (isV002) return $33a86e65aee8b4c4$var$packPrefsVersion002(userPreferences);
        const isV003 = $33a86e65aee8b4c4$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
        if (isV003) return $33a86e65aee8b4c4$var$packPrefsVersion003(userPreferences);
        return $33a86e65aee8b4c4$var$packPrefsVersion001(userPreferences);
    }
    function $33a86e65aee8b4c4$export$8d213cb390bab4fa(userPreferencesCookie) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls-v2')) {
            if (userPreferencesCookie.length < 3) return;
            const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
            if (version === (0, (0, parcelRequire("e7OnS")).V001_SCHEMA_KEY)) return $33a86e65aee8b4c4$var$unpackPrefsVersion001(userPreferencesCookie);
            return;
        }
        const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $33a86e65aee8b4c4$export$64b31470e8522819(userPreferencesCookie);
        if (!isValid) return;
        if (isV001) return $33a86e65aee8b4c4$var$unpackPrefsVersion001(userPreferencesCookie);
        if (isV002) return $33a86e65aee8b4c4$var$unpackPrefsVersion002(userPreferencesCookie);
        if (isV003) return $33a86e65aee8b4c4$var$unpackPrefsVersion003(userPreferencesCookie);
    }
    const $33a86e65aee8b4c4$export$67f70eb55341bd29 = (initialPreferences)=>{
        if (!initialPreferences) return true;
        const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
        return prefExistButAreEmpty;
    };
    const $33a86e65aee8b4c4$export$7962405c3ca274b1 = (initialPreferences)=>{
        if (initialPreferences !== (0, (0, parcelRequire("iG1qD")).PrefetchedPreferenceState).INTERNAL) {
            if ($33a86e65aee8b4c4$export$67f70eb55341bd29(initialPreferences)) return {
                prefs: undefined,
                isPrefetchedPrefsInternalState: true
            };
            const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
            if (consentToken) {
                const unpackedExistingPrefs = $33a86e65aee8b4c4$export$8d213cb390bab4fa(consentToken);
                return {
                    prefs: unpackedExistingPrefs,
                    isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
                };
            }
            if (initialPreferences && 'consents' in initialPreferences) {
                const serializedPrefetchedConsentToken = (0, (0, parcelRequire("7PdQG")).serializeConsents)(initialPreferences);
                const unpackedPrefetchedPrefs = $33a86e65aee8b4c4$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
                return {
                    prefs: unpackedPrefetchedPrefs,
                    isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
                };
            }
        }
        if (initialPreferences === (0, (0, parcelRequire("iG1qD")).PrefetchedPreferenceState).INTERNAL) return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: false
        };
    };
});
parcelRegister("fIz84", function(module, exports) {
    $parcel$export(module.exports, "getBannerVisibility", ()=>$b71636fc0a96ad84$export$bfdb9f82a9194c1e);
    var $3zdAw;
    var $1Vlui;
    var $e7OnS;
    var $7PdQG;
    var $eMLDH;
    var $4qYnX;
    const $b71636fc0a96ad84$var$getUserIsAuthenticatedBit = (consentToken)=>{
        const { isV002: isV002 } = (0, (0, parcelRequire("4qYnX")).checkTokenVersionValidity)(consentToken);
        let userIsAuthenticatedBit = consentToken[8];
        if (isV002) {
            const legacyV2ConsentDataUnavailableBit = consentToken[7];
            userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
        }
        return userIsAuthenticatedBit;
    };
    const $b71636fc0a96ad84$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
        if (fallbackConsentToken) {
            const fallbackUserIsAuthenticatedBit = $b71636fc0a96ad84$var$getUserIsAuthenticatedBit(fallbackConsentToken);
            const isLoggedOutFallbackConsents = !(0, (0, parcelRequire("1Vlui")).getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
            const fallbackTokenHasGenuineConsents = !(0, (0, parcelRequire("7PdQG")).checkIfTokenIsDefault)(fallbackConsentToken);
            const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
            if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
            const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
            if (loggedOutUserPreviouslyConsentedWhileLoggedIn) return false;
        }
        return true;
    };
    const $b71636fc0a96ad84$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
        const tokenIsADefaultConsent = !!(0, (0, parcelRequire("7PdQG")).checkIfTokenIsDefault)(consentToken);
        if (tokenIsADefaultConsent) return $b71636fc0a96ad84$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
        const localOnlyUserHasConsented = (0, (0, parcelRequire("7PdQG")).hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
        if (localOnlyUserHasConsented) return fallbackConsentToken ? false : true;
        return true;
    };
    const $b71636fc0a96ad84$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
        if (fallbackConsentToken) {
            const fallbackUserIsAuthenticatedBit = $b71636fc0a96ad84$var$getUserIsAuthenticatedBit(fallbackConsentToken);
            const isLoggedOutFallbackConsents = !(0, (0, parcelRequire("1Vlui")).getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
            const fallbackTokenHasGenuineConsents = !(0, (0, parcelRequire("7PdQG")).checkIfTokenIsDefault)(fallbackConsentToken);
            if (fallbackTokenHasGenuineConsents) {
                if (isLoggedOutFallbackConsents) return true;
                return false;
            }
            return true;
        }
        return true;
    };
    const $b71636fc0a96ad84$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
        const tokenIsADefaultConsent = !!(0, (0, parcelRequire("7PdQG")).checkIfTokenIsDefault)(consentToken);
        if (tokenIsADefaultConsent) return $b71636fc0a96ad84$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
        if (consentTimestamp) {
            const showBannerIfStale = (0, (0, parcelRequire("7PdQG")).checkIfConsentsAreStale)(consentTimestamp);
            return showBannerIfStale;
        }
        return fallbackConsentToken ? false : true;
    };
    const $b71636fc0a96ad84$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
        const fallbackConsentToken = (0, (0, parcelRequire("3zdAw")).isSSR)() ? fallbackConsents : fallbackConsents || (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        let userIsAuthenticatedBit = $b71636fc0a96ad84$var$getUserIsAuthenticatedBit(consentToken);
        const isLoggedOutConsentToken = !(0, (0, parcelRequire("1Vlui")).getBoolFromBitValue)(userIsAuthenticatedBit);
        let isBannerVisible = true;
        if (isLoggedOutConsentToken) isBannerVisible = $b71636fc0a96ad84$var$shouldShowBannerForLoggedOutUser({
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
        });
        else isBannerVisible = $b71636fc0a96ad84$var$shouldShowBannerForLoggedInUser({
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            consentTimestamp: consentTimestamp
        });
        return isBannerVisible;
    };
});
parcelRegister("gubdC", function(module, exports) {
    $parcel$export(module.exports, "isInIframe", ()=>$53f6acf0285fde21$export$9f140ed41af5108c);
    $parcel$export(module.exports, "useCookieConsentBannerSettings", ()=>$53f6acf0285fde21$export$ae97931560f092a4);
    $parcel$export(module.exports, "useCookieConsentBannerSettingsActions", ()=>$53f6acf0285fde21$export$ecbab4dc5f9ad844);
    var $eMLDH;
    var $e7OnS;
    var $co1wz;
    var $7JoAD = parcelRequire("7JoAD");
    function $53f6acf0285fde21$export$8d213cb390bab4fa(userPreferencesCookie) {
        if (userPreferencesCookie.length < 3) return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version !== '001') return;
        if (userPreferencesCookie.length !== 7) return;
        return {
            STRICTLY_NECESSARY: true,
            FUNCTIONAL: userPreferencesCookie[3] === '1',
            ANALYTICS: userPreferencesCookie[4] === '1',
            MARKETING: userPreferencesCookie[5] === '1',
            UNKNOWN: userPreferencesCookie[6] === '1'
        };
    }
    const $53f6acf0285fde21$export$1de6a888ae076ff8 = ()=>{
        if (false) return undefined;
        const packedPrefs = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return $53f6acf0285fde21$export$8d213cb390bab4fa(packedPrefs);
    };
    const $53f6acf0285fde21$export$9f140ed41af5108c = ()=>{
        if (false) return false;
        return window !== window.top;
    };
    const $53f6acf0285fde21$export$aa1483cc2e197f6e = ()=>{
        if (false) return false;
        if ((0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2')) return true;
        return $53f6acf0285fde21$export$1de6a888ae076ff8() !== undefined || $53f6acf0285fde21$export$9f140ed41af5108c();
    };
    const $53f6acf0285fde21$export$d4c72bab9d6cc13a = {
        isDismissed: $53f6acf0285fde21$export$aa1483cc2e197f6e(),
        height: 0
    };
    const $53f6acf0285fde21$export$e324594224ef24da = {
        onShow: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isDismissed: false
                });
            },
        onDismiss: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isDismissed: true
                });
            },
        setHeight: (height)=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    height: height
                });
            }
    };
    const $53f6acf0285fde21$var$Store = (0, $7JoAD.createStore)({
        name: 'cookie-consent-banner',
        initialState: $53f6acf0285fde21$export$d4c72bab9d6cc13a,
        actions: $53f6acf0285fde21$export$e324594224ef24da
    });
    const $53f6acf0285fde21$export$ae97931560f092a4 = (0, $7JoAD.createHook)($53f6acf0285fde21$var$Store);
    const $53f6acf0285fde21$export$ecbab4dc5f9ad844 = (0, $7JoAD.createActionsHook)($53f6acf0285fde21$var$Store);
});
parcelRegister("iMzQW", function(module, exports) {
    $parcel$export(module.exports, "useBannerIPBlocklisting", ()=>$014906e38669dbae$export$564412c1d9cd4ccc);
    var $5uXOq = parcelRequire("5uXOq");
    var $9B86Q;
    var $asgRx;
    const $014906e38669dbae$export$564412c1d9cd4ccc = ()=>{
        const [shouldShowBanner, setBannerState] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/global-components/ipblocklisting/bridge'
            }).then((bridge)=>{
                bridge({
                    showIPBlocklistBanner: ()=>setBannerState(true),
                    hideIPBlocklistBanner: ()=>setBannerState(false)
                });
            });
        }, []);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: shouldShowBanner,
                name: (0, (0, parcelRequire("asgRx")).BANNER_NAME),
                height: (0, (0, parcelRequire("asgRx")).bannerHeight)
            }), [
            shouldShowBanner
        ]);
    };
});
parcelRegister("6RMJw", function(module, exports) {
    $parcel$export(module.exports, "useBannerAnnouncement", ()=>$6710252c02f204b2$export$1e775b1ab04f2888);
    var $5uXOq = parcelRequire("5uXOq");
    var $5kYzp;
    var $cZpsT;
    var $gk4cG;
    const $6710252c02f204b2$export$1e775b1ab04f2888 = ()=>{
        const { data: data } = (0, (0, parcelRequire("5kYzp")).useAnnouncementBannerSettingsV4Resource)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
                name: (0, (0, parcelRequire("gk4cG")).NAME),
                height: (0, (0, parcelRequire("gk4cG")).HEIGHT)
            }), [
            data?.isDismissed,
            data?.isEnabled,
            data?.visibility,
            isAnonymous
        ]);
    };
});
parcelRegister("gk4cG", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$8ea828cd42179fda$export$809d2b099693a9a8);
    $parcel$export(module.exports, "NAME", ()=>$8ea828cd42179fda$export$3c5e605ca7ade9f2);
    var $gwIPs;
    const $8ea828cd42179fda$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 8;
    const $8ea828cd42179fda$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';
});
parcelRegister("hESBP", function(module, exports) {
    $parcel$export(module.exports, "useBannerEocTransition", ()=>$304370119e420b48$export$b6539a8209f95b48);
    var $5uXOq = parcelRequire("5uXOq");
    var $ez5GD;
    var $201IG;
    var $8J6rn;
    var $itmJb;
    var $cNd4s;
    var $iaN8D;
    const $304370119e420b48$export$b6539a8209f95b48 = ()=>{
        const { data: data, error: error } = (0, (0, parcelRequire("ez5GD")).useOgConsolidationUserState)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const isEnabled = Boolean((isAdmin || isSiteAdmin) && !tenantInfoError && isTransitionEligible && !error && data && (!data.isTransitionBannerDismissed || (0, (0, parcelRequire("201IG")).shouldRenderBenefitModal)({
            bannerDismissedAt: data.transitionBannerDismissedAt,
            isDismissed: data.isBenefitModalDismissed
        })));
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isEnabled,
                name: (0, (0, parcelRequire("iaN8D")).BANNER_NAME),
                height: data && (0, (0, parcelRequire("201IG")).shouldRenderBenefitModal)({
                    bannerDismissedAt: data.transitionBannerDismissedAt
                }) ? 0 : (0, (0, parcelRequire("iaN8D")).HEIGHT)
            }), [
            data,
            isEnabled
        ]);
    };
});
parcelRegister("ez5GD", function(module, exports) {
    $parcel$export(module.exports, "useOgConsolidationUserState", ()=>$e71f39314801737b$export$c35632c02599163f);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $iXaZ3;
    var $kMiZJ;
    var $9OXo1;
    var $dIdda = parcelRequire("dIdda");
    var $fLIp1;
    const $e71f39314801737b$export$c35632c02599163f = ()=>{
        const errorRef = (0, $5uXOq.useRef)();
        const loadingRef = (0, $5uXOq.useRef)(false);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $dIdda.useResource)((0, (0, parcelRequire("kMiZJ")).consolidationUserStateResource));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
        errorRef.current = userPropertiesError || transitionResourceError;
        const { atlassianAccountId: accountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const update = (0, $5uXOq.useCallback)((newState)=>{
            if (errorRef.current) return Promise.reject(errorRef.current);
            let updatedData = {};
            updateTransitionResource((oldState)=>{
                updatedData = {
                    ...oldState,
                    ...newState
                };
                return updatedData;
            });
            if (accountId) {
                if (loadingRef.current) {
                    const err = new Error('User properties is loading');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraEocChangeboarding',
                            teamName: 'alexstrasza'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setUserPropertiesError(err);
                    return Promise.reject(err);
                }
                loadingRef.current = true;
                return (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, (0, parcelRequire("iXaZ3")).OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                    setUserPropertiesError(new Error('Error occured while setting user properties'));
                    showFlag({
                        type: 'error',
                        isAutoDismiss: true,
                        title: formatMessage((0, (0, parcelRequire("fLIp1")).default).errorFlagTitle)
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraEocChangeboarding',
                            teamName: 'alexstrasza'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    loadingRef.current = false;
                });
            }
            return Promise.resolve();
        }, [
            updateTransitionResource,
            accountId,
            formatMessage,
            showFlag
        ]);
        const reopenTransitionLozenge = (0, $5uXOq.useCallback)(()=>{
            update({
                isTransitionHomeHidden: false
            });
        }, [
            update
        ]);
        return {
            data: data,
            update: update,
            error: errorRef.current,
            reopenTransitionLozenge: reopenTransitionLozenge
        };
    };
});
parcelRegister("fLIp1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19c9811268c2fa85$export$2e2bcd8739ae039);
    var $7VHMR;
    var $19c9811268c2fa85$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
            "defaultMessage": "Something went wrong while updating user properties."
        }
    });
});
parcelRegister("201IG", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderBenefitModal", ()=>$f068b5042603902f$export$25a52eb2dc74e2f9);
    const $f068b5042603902f$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
        if (!bannerDismissedAt || isDismissed) return false;
        return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
    };
});
parcelRegister("8J6rn", function(module, exports) {
    $parcel$export(module.exports, "useOgTenantInfo", ()=>$31f27587daf0b28f$export$990ea9ff15ca04f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $4R6GH;
    var $bHhiy;
    var $daoB1;
    var $dIdda = parcelRequire("dIdda");
    var $3H5ry;
    const $31f27587daf0b28f$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
        const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
        const isRefreshed = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
                refresh();
                isRefreshed.current = true;
            }
        }, [
            data,
            loading,
            refresh
        ]);
    };
    const $31f27587daf0b28f$export$990ea9ff15ca04f7 = ()=>{
        const tenantInfoResource = (0, $dIdda.useResource)((0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)());
        const applicationPermissions = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        $31f27587daf0b28f$var$useConsolidationStateResourceRefresh(tenantInfoResource);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
        return {
            loading: tenantInfoResource.loading,
            error: tenantInfoResource.error,
            shouldUseJSM: (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(tenantInfoResource.data),
            isConsolidated: (0, (0, parcelRequire("3H5ry")).checkIsConsolidated)(tenantInfoResource.data),
            isTransitioning: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, (0, parcelRequire("3H5ry")).checkIsTransitioning)(tenantInfoResource.data),
            isTransitioned: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, (0, parcelRequire("3H5ry")).checkIsTransitioned)(tenantInfoResource.data),
            isTransitionEligible: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, (0, parcelRequire("3H5ry")).checkIsTransitionEligible)(tenantInfoResource.data),
            shouldAccessUnlockOperations: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, (0, parcelRequire("3H5ry")).checkShouldAccessUnlockOperations)(tenantInfoResource.data),
            cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
        };
    };
});
parcelRegister("iaN8D", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$d45809d2691157ce$export$809d2b099693a9a8);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$d45809d2691157ce$export$41956b146268af93);
    var $gwIPs;
    const $d45809d2691157ce$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $d45809d2691157ce$export$41956b146268af93 = 'EOC_TRANSITION';
});
parcelRegister("2jAre", function(module, exports) {
    $parcel$export(module.exports, "useBannerMailExpiry", ()=>$85ae441f6f576caa$export$3906461ac9b87d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $hZhhj;
    var $921us;
    var $1cxlJ;
    const $85ae441f6f576caa$export$3906461ac9b87d2 = ()=>{
        const { responseStatus: responseStatus, state: state } = (0, (0, parcelRequire("hZhhj")).useIncomingMailExpiryStatus)();
        const { onStateFetch: onStateFetch } = (0, (0, parcelRequire("1cxlJ")).useBannerActions)();
        const { isBannerShown: isBannerShown } = (0, (0, parcelRequire("1cxlJ")).useBannerState)();
        (0, $5uXOq.useEffect)(()=>{
            if (responseStatus === 'error') {
                onStateFetch((0, (0, parcelRequire("hZhhj")).DEFAULT_RESPONSE));
                return;
            }
            if (responseStatus === 'success') onStateFetch(state);
        }, [
            onStateFetch,
            responseStatus,
            state
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isBannerShown,
                name: (0, (0, parcelRequire("921us")).BANNER_NAME),
                height: (0, (0, parcelRequire("921us")).HEIGHT)
            }), [
            isBannerShown
        ]);
    };
});
parcelRegister("921us", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$c8abb4ba3ebc926f$export$809d2b099693a9a8);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$c8abb4ba3ebc926f$export$41956b146268af93);
    var $gwIPs;
    const $c8abb4ba3ebc926f$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $c8abb4ba3ebc926f$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';
});
parcelRegister("1cxlJ", function(module, exports) {
    $parcel$export(module.exports, "useBannerActions", ()=>$b47a5e6c2ea18541$export$664f3e2467f0f5af);
    $parcel$export(module.exports, "useBannerState", ()=>$b47a5e6c2ea18541$export$fa4ffa872ee90bd0);
    var $7JoAD = parcelRequire("7JoAD");
    const $b47a5e6c2ea18541$export$d4c72bab9d6cc13a = {
        isBannerShown: false,
        isAdmin: false,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $b47a5e6c2ea18541$export$e324594224ef24da = {
        onDismiss: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isBannerShown: false
                });
            },
        onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
            'GMAIL_OAUTH'
        ] })=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isBannerShown: showBanner && isAdmin,
                    isAdmin: isAdmin,
                    OauthTypes: OauthTypes
                });
            }
    };
    const $b47a5e6c2ea18541$var$Store = (0, $7JoAD.createStore)({
        name: 'mail-expiry-banner',
        initialState: $b47a5e6c2ea18541$export$d4c72bab9d6cc13a,
        actions: $b47a5e6c2ea18541$export$e324594224ef24da
    });
    const $b47a5e6c2ea18541$export$664f3e2467f0f5af = (0, $7JoAD.createActionsHook)($b47a5e6c2ea18541$var$Store);
    const $b47a5e6c2ea18541$export$fa4ffa872ee90bd0 = (0, $7JoAD.createStateHook)($b47a5e6c2ea18541$var$Store);
});
parcelRegister("lrZro", function(module, exports) {
    $parcel$export(module.exports, "useBannerReturnToMobileState", ()=>$2d8151e19ddaa4d5$export$571311559507e90);
    $parcel$export(module.exports, "useBannerReturnToMobile", ()=>$2d8151e19ddaa4d5$export$a898dd7b7ec9917a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bCdIp;
    var $c0dQj;
    var $7JoAD = parcelRequire("7JoAD");
    var $aAExw;
    const $2d8151e19ddaa4d5$var$initialState = {
        isEnabled: (0, (0, parcelRequire("bCdIp")).shouldShowReturnToMobileBanner)()
    };
    const $2d8151e19ddaa4d5$var$actions = {
        disable: ()=>({ setState: setState })=>{
                setState({
                    isEnabled: false
                });
            }
    };
    const $2d8151e19ddaa4d5$var$store = (0, $7JoAD.createStore)({
        initialState: $2d8151e19ddaa4d5$var$initialState,
        actions: $2d8151e19ddaa4d5$var$actions
    });
    const $2d8151e19ddaa4d5$export$571311559507e90 = (0, $7JoAD.createHook)($2d8151e19ddaa4d5$var$store);
    const $2d8151e19ddaa4d5$export$a898dd7b7ec9917a = ()=>{
        const [{ isEnabled: isEnabledOriginal }] = $2d8151e19ddaa4d5$export$571311559507e90();
        const isEnabled = (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? isEnabledOriginal && (0, (0, parcelRequire("bCdIp")).shouldShowReturnToMobileBannerMobileMvp)() : isEnabledOriginal;
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isEnabled,
                name: (0, (0, parcelRequire("aAExw")).BANNER_NAME),
                height: (0, (0, parcelRequire("aAExw")).mobileBannerHeight)
            }), [
            isEnabled
        ]);
    };
});
parcelRegister("aAExw", function(module, exports) {
    $parcel$export(module.exports, "mobileBannerHeight", ()=>$61da032f64bef3a5$export$aa875602f5712b77);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$61da032f64bef3a5$export$41956b146268af93);
    $parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", ()=>$61da032f64bef3a5$export$698c82a2c8445300);
    var $gwIPs;
    const $61da032f64bef3a5$export$aa875602f5712b77 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $61da032f64bef3a5$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
    const $61da032f64bef3a5$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');
});
parcelRegister("c1ivz", function(module, exports) {
    $parcel$export(module.exports, "BannerAnnouncementAsync", ()=>$d10936fc02d4c9c5$export$aa03f7909e0828ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $d10936fc02d4c9c5$var$BannerAnnouncement = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("2cw99")).then((module)=>module.BannerAnnouncement), {
        ssr: true,
        moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/index.tsx"
    });
    const $d10936fc02d4c9c5$export$aa03f7909e0828ec = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-platform-ui-banners-announcement",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d10936fc02d4c9c5$var$BannerAnnouncement, null));
});
parcelRegister("2cw99", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eOo6L")
    ]).then(()=>parcelRequire('58JTH'));
});
parcelRegister("14pJv", function(module, exports) {
    $parcel$export(module.exports, "BannerTransitionAsync", ()=>$710b388646922007$export$8bf182764b9d2eb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $710b388646922007$var$BannerTransition = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("kUqkC")).then((module)=>module.BannerTransition), {
        moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
    });
    const $710b388646922007$export$8bf182764b9d2eb8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-banner-eoc-transition",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($710b388646922007$var$BannerTransition, null));
});
parcelRegister("kUqkC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OPKz").then(()=>parcelRequire('iGIQS'));
});
parcelRegister("9Cdg4", function(module, exports) {
    $parcel$export(module.exports, "MailExpiryBannerAsync", ()=>$9a323272de0aa4c0$export$11a26ffa2d1b48ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $9a323272de0aa4c0$var$LazyMailExpiryBanner = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("5S9xE")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
        moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
    });
    const $9a323272de0aa4c0$export$11a26ffa2d1b48ed = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-mail-expiry-banner",
            packageName: "jiraPlatformUiMailExpiryReminder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-mail-expiry-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9a323272de0aa4c0$var$LazyMailExpiryBanner, null)));
});
parcelRegister("5S9xE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hjh1F").then(()=>parcelRequire('4tHNi'));
});
parcelRegister("9ylrc", function(module, exports) {
    $parcel$export(module.exports, "ReturnToMobileBanner", ()=>$369ea7a3ed2830c2$export$81c4f1e869d5a87);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $369ea7a3ed2830c2$var$LazyReturnToMobileBanner = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("7jJzW")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
        moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/main.tsx"
    });
    const $369ea7a3ed2830c2$export$81c4f1e869d5a87 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-return-to-mobile-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($369ea7a3ed2830c2$var$LazyReturnToMobileBanner, null));
});
parcelRegister("7jJzW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("MUWFq")
    ]).then(()=>parcelRequire('4TzBF'));
});
parcelRegister("dm0Uk", function(module, exports) {
    $parcel$export(module.exports, "ZIndexWrapper", ()=>$1be350c372161cad$export$6bdda512681a5774);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $1be350c372161cad$export$6bdda512681a5774 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.zIndex),
                "--_1vj9tq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.top)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pby1fcb _kqswh2mm _154i1ter",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kc9FZ", function(module, exports) {
    $parcel$export(module.exports, "GlobalComponents", ()=>$87d424e5b411dd1e$export$461c2ed3163c74ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $39xOx;
    var $6jY6G;
    var $1XrjK;
    var $2SVPM;
    var $imS60;
    const $87d424e5b411dd1e$var$routeComponents = [];
    const $87d424e5b411dd1e$var$RouteGlobalComponents = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("1XrjK")).renderGlobalComponents)(route.layout?.globalComponents || $87d424e5b411dd1e$var$routeComponents));
    };
    const $87d424e5b411dd1e$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("1XrjK")).renderGlobalComponents)(sharedGlobalComponents));
    const $87d424e5b411dd1e$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
        const globalComponentsPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$fb9876ab4228d985), (0, $9ccbd88c704da1ef$export$c20831be6f780cb5), (0, $9ccbd88c704da1ef$export$398df1bca49f9884), true, true);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$c20831be6f780cb5)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-global-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "shared-global-components"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$SharedGlobalComponents, {
            sharedGlobalComponents: sharedGlobalComponents
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "route-global-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "route-global-components"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$RouteGlobalComponents, null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$398df1bca49f9884),
            onSet: globalComponentsPerformanceTiming
        }));
    };
});
parcelRegister("imS60", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6b7686623a2955e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $1tcYS;
    var $3aXpE;
    var $cEm1b;
    const $b6b7686623a2955e$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
            ...context,
            getInteractionContext: ()=>interactionContext
        };
    const $b6b7686623a2955e$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
    const $b6b7686623a2955e$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? (0, ($parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
                value: contextValue
            }, node) : node;
    function $b6b7686623a2955e$var$JiraUFOLabelWrapper({ children: children }) {
        const context = (0, (0, parcelRequire("1tcYS")).useInteractionContext)();
        const rllProfilerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("cEm1b")).ProfilerContext));
        const relayProfilerContext = (0, $5uXOq.useContext)((0, $8Uumt.ProfilerContext));
        const newRllProfilerContext = (0, $5uXOq.useMemo)(()=>({
                current: $b6b7686623a2955e$var$newContextWithUfoContext(rllProfilerContext?.current, context)
            }), [
            context,
            rllProfilerContext
        ]);
        const newRelayProfilerContext = (0, $5uXOq.useMemo)(()=>$b6b7686623a2955e$var$newContextWithUfoContext(relayProfilerContext, context), [
            context,
            relayProfilerContext
        ]);
        return $b6b7686623a2955e$var$flowRight([
            $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $8Uumt.ProfilerContext), newRelayProfilerContext),
            $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, (0, parcelRequire("cEm1b")).ProfilerContext), newRllProfilerContext)
        ])((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children));
    }
    function $b6b7686623a2955e$export$2e2bcd8739ae039({ name: name, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3aXpE")).default), {
            name: name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b6b7686623a2955e$var$JiraUFOLabelWrapper, null, children));
    }
});
parcelRegister("3aXpE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa69217d65efc8ae$export$2e2bcd8739ae039);
    var $jnjS3;
    var $fa69217d65efc8ae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jnjS3")).default);
});
parcelRegister("jnjS3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$095a4d1378115b65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    function $095a4d1378115b65$export$2e2bcd8739ae039({ name: name, children: children }) {
        const context = (0, (0, parcelRequire("1tcYS")).useInteractionContext)();
        const newContext = (0, $5uXOq.useMemo)(()=>{
            if (context) return {
                ...context,
                labelStack: context.labelStack == null ? [
                    {
                        name: name
                    }
                ] : [
                    ...context.labelStack,
                    {
                        name: name
                    }
                ]
            };
            else return context;
        }, [
            context,
            name
        ]);
        return context ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1tcYS")).default).Provider, {
            value: newContext
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
});
parcelRegister("6DLIs", function(module, exports) {
    $parcel$export(module.exports, "GlobalContainers", ()=>$1f7483f6f5b15b02$export$3b677a7048d7ae0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bKfXN;
    var $lRFpu;
    var $jD5no;
    var $2i4sA;
    var $gAeCk;
    var $5tsrJ;
    var $j8DrX;
    var $lJ5jf;
    var $3HwlS;
    var $8ApFP;
    var $4yEIl;
    var $iPMn1;
    var $fiv1r;
    var $14XJw;
    var $2SVPM;
    var $9OXo1;
    var $eKtC8;
    var $bAjl9;
    var $lvG9V;
    var $gPTB6;
    var $9kep9;
    var $eSznd;
    var $ivvwC;
    const $1f7483f6f5b15b02$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const globalContainersPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$4f341d86a3c214), (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366), (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca), true, true);
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$7048c99f32c60b34), (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7), (0, $9ccbd88c704da1ef$export$aac77afee74c49d0), true, true);
        }, []);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const MonolithStyleOverride = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
                dangerouslySetInnerHTML: {
                    __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, white)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
                }
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bAjl9")).IntlProviders), {
            messages: messages,
            locale: locale
        }, __SPA__ && (0, ($parcel$interopDefault($5uXOq))).createElement(MonolithStyleOverride, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRFpu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tsrJ")).default), {
            orgId: orgId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
            experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
            experienceId: (0, $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7),
            application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
            edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
            additionalAttributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKtC8")).ErrorBoundary), {
            id: id,
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(Router, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKfXN")).default), {
            UNSAFE_isThemingDisabled: true,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9kep9")).PageConfigContainers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvG9V")).MetricsContainers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiv1r")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPTB6")).NavigationContainers), {
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivvwC")).UserContainers), {
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eSznd")).UiManagers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4yEIl")).PostOfficeRouterListener), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            id: "page-container-v2.nav-v3.app-base",
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$aac77afee74c49d0),
            onSet: globalContainersPerformanceTiming
        }), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJ5jf")).SidebarNav4ControllerProvider), null, children) : children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iPMn1")).ScreenSpaceFlagsPlacement), null)))))))))))))));
    };
});
parcelRegister("bKfXN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c63904d4fd249f91$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $grjRA;
    var $4NS88;
    const $c63904d4fd249f91$var$InsideAppProviderContext = (0, $5uXOq.createContext)(false);
    function $c63904d4fd249f91$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
        const isInsideAppProvider = (0, $5uXOq.useContext)($c63904d4fd249f91$var$InsideAppProviderContext);
        if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
        const routerLinkProvider = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("grjRA")).default), {
            routerLinkComponent: routerLinkComponent
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c63904d4fd249f91$var$InsideAppProviderContext.Provider, {
            value: true
        }, UNSAFE_isThemingDisabled ? routerLinkProvider : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4NS88")).default), {
            defaultColorMode: defaultColorMode,
            defaultTheme: defaultTheme
        }, routerLinkProvider));
    }
    var $c63904d4fd249f91$export$2e2bcd8739ae039 = $c63904d4fd249f91$export$c7dacf3845253dcf;
});
parcelRegister("2i4sA", function(module, exports) {
    $parcel$export(module.exports, "ViewExperienceTrackingProvider", ()=>$c08cc6207a190361$export$a5efa46877be148f);
    $parcel$export(module.exports, "SubExperienceTrackingProvider", ()=>$c08cc6207a190361$export$e0241c84ce5db240);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $jNwWT;
    var $aD4Nm;
    var $ehKaJ;
    const $c08cc6207a190361$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehKaJ")).default), {
            isExperienceReady: isExperienceReady,
            experience: experience,
            experienceId: experienceId,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            additionalAttributes: additionalAttributes
        }, children);
    $c08cc6207a190361$export$a5efa46877be148f.defaultProps = {
        isExperienceReady: true,
        experienceId: null,
        additionalAttributes: {}
    };
    var $c08cc6207a190361$export$2e2bcd8739ae039 = $c08cc6207a190361$export$a5efa46877be148f;
    const $c08cc6207a190361$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNwWT")).default).Consumer, null, (context)=>{
            if (context == null) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
                return children;
            }
            const { experienceId: experienceId } = context;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aD4Nm")).ExperienceTracker), {
                location: location,
                parentProviders: parentProviders
            }, (trackerCallbacks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehKaJ")).default), {
                    parentTrackerCallbacks: trackerCallbacks,
                    experience: location,
                    experienceId: experienceId,
                    analyticsSource: null,
                    application: null,
                    edition: null,
                    isExperienceReady: true
                }, children));
        });
    $c08cc6207a190361$export$e0241c84ce5db240.defaultProps = {
        parentProviders: null
    };
});
parcelRegister("ehKaJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a267f2f54170b1c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hh0bW;
    var $jNwWT;
    class $a267f2f54170b1c1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                parentTrackerCallbacks: null,
                additionalAttributes: {}
            };
        }
        constructor(props){
            super(props);
            this.onPending = ()=>{
                this.pendingCount += 1;
                this.shouldTrackExperience = true;
                this.checkAndStartTimer();
            };
            this.onSuccess = ()=>{
                this.pendingCount -= 1;
                this.checkAndStartTimer();
            };
            this.onFailure = (location, additionalAttributes)=>{
                this.trackExperience({
                    wasExperienceSuccesful: false,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
            };
            this.onAbort = (location, additionalAttributes)=>{
                this.trackExperience({
                    wasExperienceSuccesful: false,
                    action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                    location: location,
                    additionalAttributes: additionalAttributes
                });
            };
            this.resetExperience();
        }
        componentDidMount() {
            this.checkAndStartTimer();
        }
        componentDidUpdate(prevProps) {
            if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
        }
        componentDidCatch(error) {
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: 'error-reached-provider',
                additionalAttributes: {
                    errorMessage: error.message,
                    errorName: error.name
                }
            });
            throw error;
        }
        componentWillUnmount() {
            clearTimeout(this.timerId);
        }
        checkAndStartTimer() {
            if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
        }
        startTimer() {
            clearTimeout(this.timerId);
            this.timerId = setTimeout(()=>{
                if (this.pendingCount === 0) this.trackExperience({
                    wasExperienceSuccesful: true
                });
            }, 1000);
        }
        resetExperience() {
            clearTimeout(this.timerId);
            this.timerId = undefined;
            this.shouldTrackExperience = false;
            this.hasTrackedExperience = false;
            this.pendingCount = 0;
            this.memoizedContext = {
                consumerCallbacks: {
                    onPending: this.onPending,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                    onAbort: this.onAbort
                },
                experienceId: this.props.experienceId,
                experience: this.props.experience
            };
        }
        trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
            if (this.hasTrackedExperience) return;
            this.hasTrackedExperience = true;
            const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
            if (parentTrackerCallbacks) {
                if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
                else parentTrackerCallbacks.onExperienceFailure(location, {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                });
            } else {
                const { experience: experience } = this.memoizedContext;
                const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
                analyticsSource && (0, (0, parcelRequire("hh0bW")).default)({
                    experience: experience,
                    action: action,
                    wasExperienceSuccesful: wasExperienceSuccesful,
                    location: location,
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: {
                        ...additionalAttributesFromProps,
                        ...additionalAttributes
                    }
                });
            }
        }
        checkExperienceIdForExperienceReset() {
            if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
        }
        render() {
            this.checkExperienceIdForExperienceReset();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNwWT")).default).Provider, {
                value: this.memoizedContext
            }, this.props.children);
        }
    }
});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';
parcelRegister("lJ5jf", function(module, exports) {
    $parcel$export(module.exports, "SidebarNav4ControllerProvider", ()=>$ba2af518cd3fa886$export$ec25d268893d889d);
    $parcel$export(module.exports, "useSidebarNav4Controller", ()=>$ba2af518cd3fa886$export$641950c86d73374);
    var $5uXOq = parcelRequire("5uXOq");
    var $fMcVX;
    const $ba2af518cd3fa886$var$SidebarNav4ControllerContext = (0, $5uXOq.createContext)(null);
    function $ba2af518cd3fa886$export$ec25d268893d889d(props) {
        const { children: children, controlledPath: initialControlledPath = null } = props;
        const [controlledPath, setControlledPath] = (0, $5uXOq.useState)(initialControlledPath);
        const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
                isControlledNav: controlledPath !== null,
                isControlledPath: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(controlledPath ?? []),
                setControlledPath: setControlledPath
            }), [
            controlledPath
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ba2af518cd3fa886$var$SidebarNav4ControllerContext.Provider, {
            value: sidebarNav4Controller
        }, children);
    }
    function $ba2af518cd3fa886$export$641950c86d73374() {
        const context = (0, $5uXOq.useContext)($ba2af518cd3fa886$var$SidebarNav4ControllerContext);
        if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
        return context;
    }
});
parcelRegister("4yEIl", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeProvider", ()=>$21214568f856c41e$export$fb465b6e855c1e85);
    $parcel$export(module.exports, "PostOfficeRouterListener", ()=>$21214568f856c41e$export$9f8d3084fd3d5fc0);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $4R6GH;
    var $jQsty;
    var $lpwtK;
    var $14XJw;
    var $fY39E;
    var $k9JTq;
    var $koeKL;
    var $2tT7R;
    var $cNd4s;
    var $DVljb;
    var $kyUrs;
    var $gsnWm;
    var $dIdda = parcelRequire("dIdda");
    var $adncp;
    const $21214568f856c41e$var$JiraPostOfficeProvider = ({ children: children })=>{
        const { data: data } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const editions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const subproduct = data?.type;
        const context = (0, $5uXOq.useMemo)(()=>{
            const edition = (0, (0, parcelRequire("adncp")).subproductToEdition)(subproduct, editions);
            return {
                current: {
                    ...(0, (0, parcelRequire("adncp")).tenantToPostOfficeContext)({
                        activationId: activationId,
                        cloudId: cloudId,
                        isSiteAdmin: isSiteAdmin,
                        locale: locale
                    }),
                    orgId: orgId,
                    productEdition: edition || undefined
                }
            };
        }, [
            cloudId,
            orgId,
            activationId,
            subproduct,
            isSiteAdmin,
            locale,
            editions
        ]);
        const env = (0, $5uXOq.useMemo)(()=>({
                env: (0, (0, parcelRequire("adncp")).transformJiraEnvToPostOfficeEnvironment)(environment)
            }), [
            environment
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kyUrs")).PostOfficeProvider), {
            context: context,
            environment: env
        }, children);
    };
    const $21214568f856c41e$export$fb465b6e855c1e85 = ({ children: children })=>{
        const isPostOfficeEnabled = !(0, (0, parcelRequire("jQsty")).default)('killswitch_post_office_in_jira');
        return isPostOfficeEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "postOfficeJiraProvider",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$JiraPostOfficeProvider, null, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $21214568f856c41e$var$ReactResourceRouterListener = ({ children: children })=>{
        const [route] = (0, $dIdda.useRouter)();
        (0, (0, parcelRequire("gsnWm")).usePostOfficeRouteUpdate)([
            route.basePath,
            route.location.pathname
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $21214568f856c41e$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
        const isPostOfficeEnabled = !(0, (0, parcelRequire("jQsty")).default)('killswitch_post_office_in_jira');
        return isPostOfficeEnabled && (0, (0, parcelRequire("4R6GH")).fg)('post-office-screen-space-overlay-jfe') ? (0, ($parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$ReactResourceRouterListener, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("2tT7R", function(module, exports) {
    $parcel$export(module.exports, "useEnvironment", ()=>$6bd66e47d4948917$export$ea7ed2425832167d);
    $parcel$export(module.exports, "useIsStagingOrDevOrLocal", ()=>$6bd66e47d4948917$export$b0d8f74f433a09c9);
    var $9OXo1;
    const $6bd66e47d4948917$var$ENVIRONMENT = {
        STAGING: 'staging',
        DEV: 'dev',
        LOCAL: 'local',
        PROD: 'prod'
    };
    const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
    };
    const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
        const env = $6bd66e47d4948917$export$ea7ed2425832167d();
        return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
    };
});
parcelRegister("DVljb", function(module, exports) {
    $parcel$export(module.exports, "useLocale", ()=>$7c760643dc748494$export$43bb16f9c6d9e3f7);
    $parcel$export(module.exports, "useNativeLocale", ()=>$7c760643dc748494$export$31652d9c30d7d3f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.locale || (0, (0, parcelRequire("lzeFL")).defaultLocale);
    };
    const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
        const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
        const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale), [
            locale
        ]);
        return standardizedLocale;
    };
});
parcelRegister("kyUrs", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeProvider", ()=>$55d824ce17788461$export$fb465b6e855c1e85);
    var $5uXOq = parcelRequire("5uXOq");
    var $gHZ4O;
    var $5MYiV;
    var $gsnWm;
    var $iTZyv;
    var $8uFbT;
    var $dmvPD;
    var $hWRix;
    var $6I1Fy;
    const $55d824ce17788461$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
        const stableEnvironment = (0, (0, parcelRequire("dmvPD")).useStableObject)((0, (0, parcelRequire("6I1Fy")).generateEnvironmentConfigWithOverrides)((0, (0, parcelRequire("5MYiV")).defaultEnvironmentValues), envWithOverrides));
        const stableContext = (0, (0, parcelRequire("dmvPD")).useStableObject)($55d824ce17788461$var$composeConfig((0, (0, parcelRequire("gHZ4O")).defaultPostOfficeContextValue), context.current));
        const memoizedMessagePlacementValues = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hWRix")).createMessagePlacementValues)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MYiV")).PostOfficeEnvironmentProvider), {
            value: stableEnvironment
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gHZ4O")).InternalPostOfficeContextProvider), {
            value: stableContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iTZyv")).PostOfficeScreenContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWRix")).MessagePlacementProvider), {
            value: memoizedMessagePlacementValues
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gsnWm")).RouteListenerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8uFbT")).TriggerContextProvider), null, children))))));
    };
    const $55d824ce17788461$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
            for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
            return {
                ...acc,
                ...v
            };
        }, {
            ...base
        });
});
parcelRegister("gHZ4O", function(module, exports) {
    $parcel$export(module.exports, "defaultPostOfficeContextValue", ()=>$5998490173f4f5b3$export$da5dc9062cba6715);
    $parcel$export(module.exports, "InternalPostOfficeContextProvider", ()=>$5998490173f4f5b3$export$3a10495c2cd2db0c);
    $parcel$export(module.exports, "PostOfficeContextProvider", ()=>$5998490173f4f5b3$export$b77983be89bb0a4e);
    $parcel$export(module.exports, "usePostOfficeContext", ()=>$5998490173f4f5b3$export$5bd9099e0ae94a43);
    var $5uXOq = parcelRequire("5uXOq");
    const $5998490173f4f5b3$export$da5dc9062cba6715 = {
        product: undefined,
        subproduct: undefined,
        locale: undefined,
        isSiteAdmin: undefined,
        tenantId: undefined,
        workspaceAri: 'no-workspace-ari-available',
        workspaceId: undefined,
        orgId: undefined,
        productEdition: undefined
    };
    const $5998490173f4f5b3$export$a228be81fcb77b42 = (0, $5uXOq.createContext)($5998490173f4f5b3$export$da5dc9062cba6715);
    const $5998490173f4f5b3$export$3a10495c2cd2db0c = $5998490173f4f5b3$export$a228be81fcb77b42.Provider;
    const $5998490173f4f5b3$export$b77983be89bb0a4e = $5998490173f4f5b3$export$3a10495c2cd2db0c;
    const $5998490173f4f5b3$export$5bd9099e0ae94a43 = ()=>(0, $5uXOq.useContext)($5998490173f4f5b3$export$a228be81fcb77b42);
});
parcelRegister("5MYiV", function(module, exports) {
    $parcel$export(module.exports, "defaultEnvironmentValues", ()=>$d283dbd21f6fbc74$export$b4ede87479bfcf09);
    $parcel$export(module.exports, "PostOfficeEnvironmentProvider", ()=>$d283dbd21f6fbc74$export$604607f913ef367c);
    $parcel$export(module.exports, "usePostOfficeEnvironment", ()=>$d283dbd21f6fbc74$export$877b97169cc75e8b);
    var $5uXOq = parcelRequire("5uXOq");
    const $d283dbd21f6fbc74$export$b4ede87479bfcf09 = {
        currentEnv: 'local',
        envConfigs: {
            test: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                    pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                    pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                    pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            }
        }
    };
    const $d283dbd21f6fbc74$export$fceca2c399b32565 = (0, $5uXOq.createContext)($d283dbd21f6fbc74$export$b4ede87479bfcf09);
    const $d283dbd21f6fbc74$export$604607f913ef367c = $d283dbd21f6fbc74$export$fceca2c399b32565.Provider;
    const $d283dbd21f6fbc74$export$877b97169cc75e8b = ()=>(0, $5uXOq.useContext)($d283dbd21f6fbc74$export$fceca2c399b32565);
});
var $154d3acab0ca1f4d$exports = {};
$parcel$export($154d3acab0ca1f4d$exports, "API_ORIGIN_LOCAL", ()=>$154d3acab0ca1f4d$export$1e9fed4c0197724c);
$parcel$export($154d3acab0ca1f4d$exports, "API_PATHNAME_LOCAL", ()=>$154d3acab0ca1f4d$export$919a9569bce66f17);
$parcel$export($154d3acab0ca1f4d$exports, "API_PATHNAME_STG_PROD", ()=>$154d3acab0ca1f4d$export$d4fe3482c88e73a8);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_LOCAL", ()=>$154d3acab0ca1f4d$export$67be2569ef5d7666);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_STG", ()=>$154d3acab0ca1f4d$export$b49738b89db261cd);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_PROD", ()=>$154d3acab0ca1f4d$export$bbd96cd490b0df63);
const $154d3acab0ca1f4d$export$1e9fed4c0197724c = 'http://localhost:8081';
const $154d3acab0ca1f4d$export$919a9569bce66f17 = '/api/v1/placements/';
const $154d3acab0ca1f4d$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $154d3acab0ca1f4d$export$67be2569ef5d7666 = 'http://localhost:9009';
const $154d3acab0ca1f4d$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $154d3acab0ca1f4d$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
parcelRegister("gsnWm", function(module, exports) {
    $parcel$export(module.exports, "usePostOfficeRouteUpdate", ()=>$05165220c9da3f7b$export$bb606326acdd1a64);
    $parcel$export(module.exports, "RouteListenerProvider", ()=>$05165220c9da3f7b$export$31986273b686f5ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $dM8xS;
    var $lwdce;
    const $05165220c9da3f7b$var$noop = ()=>{};
    const $05165220c9da3f7b$var$RouteListenerContext = (0, $5uXOq.createContext)({
        update: $05165220c9da3f7b$var$noop
    });
    const $05165220c9da3f7b$export$7a2084f4baac29a7 = ()=>(0, (0, parcelRequire("dM8xS")).createSimplePubSub)();
    const $05165220c9da3f7b$export$72fd8977abf03d60 = ()=>(0, $5uXOq.useContext)($05165220c9da3f7b$var$RouteListenerContext);
    const $05165220c9da3f7b$export$755edb1665399d41 = ()=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current) ref.current = $05165220c9da3f7b$export$7a2084f4baac29a7();
        const [routeSubscriber, updateRoute] = ref.current;
        const routeConfig = (0, $5uXOq.useMemo)(()=>({
                initialUrl: new URL(window.location.href),
                routeSubscriber: routeSubscriber
            }), [
            routeSubscriber
        ]);
        const routeUpdater = (0, $5uXOq.useMemo)(()=>({
                update: updateRoute
            }), [
            updateRoute
        ]);
        return [
            routeConfig,
            routeUpdater
        ];
    };
    const $05165220c9da3f7b$export$bb606326acdd1a64 = (deps)=>{
        const { update: update } = $05165220c9da3f7b$export$72fd8977abf03d60();
        (0, $5uXOq.useEffect)(()=>{
            if (typeof window === 'undefined') return;
            update({
                next: new URL(window.location.href)
            });
        }, deps);
    };
    const $05165220c9da3f7b$export$31986273b686f5ea = ({ children: children })=>{
        const [route, routeUpdater] = $05165220c9da3f7b$export$755edb1665399d41();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($05165220c9da3f7b$var$RouteListenerContext.Provider, {
            value: routeUpdater
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lwdce")).PostOfficeRouteProvider), route, children));
    };
});
parcelRegister("dM8xS", function(module, exports) {
    $parcel$export(module.exports, "createSimplePubSub", ()=>$8de249bc8411112f$export$92469b55607f005b);
    const $8de249bc8411112f$export$92469b55607f005b = ()=>{
        const subscribers = new Map();
        const subscribe = (subscriber)=>{
            subscribers.set(subscriber, subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const publish = (payload)=>{
            subscribers.forEach((callback)=>callback(payload));
        };
        return [
            subscribe,
            publish
        ];
    };
});
parcelRegister("lwdce", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeRouteContext", ()=>$de7edbbcb1faf7cf$export$f7f47a74e8b47b1f);
    $parcel$export(module.exports, "PostOfficeRouteProvider", ()=>$de7edbbcb1faf7cf$export$89eadc6b3e5f4e9e);
    $parcel$export(module.exports, "usePostOfficeRoute", ()=>$de7edbbcb1faf7cf$export$79301b66f7808cd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8tyNL = parcelRequire("8tyNL");
    var $dmvPD;
    const $de7edbbcb1faf7cf$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
        let state = $de7edbbcb1faf7cf$var$initializeState({
            initialUrl: initialUrl
        });
        const handleUpdate = (routeChange)=>{
            const next = routeChange.next?.toString();
            if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
            state = {
                previous: state.current,
                current: next,
                searchParams: routeChange.next?.searchParams
            };
        };
        const subscribe = (next)=>routeSubscriber((routeChange)=>{
                handleUpdate(routeChange);
                next();
            });
        const getSnapshot = ()=>{
            return state;
        };
        return {
            subscribe: subscribe,
            getSnapshot: getSnapshot
        };
    };
    const $de7edbbcb1faf7cf$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
        const route = (0, $8tyNL.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
        return (0, (0, parcelRequire("dmvPD")).useStableObject)(route);
    };
    const $de7edbbcb1faf7cf$var$initialState = {
        previous: undefined,
        current: undefined,
        searchParams: undefined
    };
    const $de7edbbcb1faf7cf$var$initializeState = ({ initialUrl: initialUrl })=>({
            ...$de7edbbcb1faf7cf$var$initialState,
            current: initialUrl ? initialUrl?.toString() : undefined,
            searchParams: initialUrl?.searchParams
        });
    const $de7edbbcb1faf7cf$export$f7f47a74e8b47b1f = (0, $5uXOq.createContext)($de7edbbcb1faf7cf$var$initialState);
    const $de7edbbcb1faf7cf$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current) ref.current = $de7edbbcb1faf7cf$export$98c77e1bd702ed15(props);
        const route = $de7edbbcb1faf7cf$var$usePostOfficeRouteStore(ref.current);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($de7edbbcb1faf7cf$export$f7f47a74e8b47b1f.Provider, {
            value: route
        }, children);
    };
    const $de7edbbcb1faf7cf$export$79301b66f7808cd8 = ()=>(0, $5uXOq.useContext)($de7edbbcb1faf7cf$export$f7f47a74e8b47b1f);
});
parcelRegister("dmvPD", function(module, exports) {
    $parcel$export(module.exports, "useStableObject", ()=>$2b1cba80f5ba3788$export$ed02d4adf2068b08);
    var $5uXOq = parcelRequire("5uXOq");
    function $2b1cba80f5ba3788$export$cdf98ded28406f69(obj) {
        return Object.entries(obj).sort().flatMap((v)=>v);
    }
    function $2b1cba80f5ba3788$export$ed02d4adf2068b08(obj) {
        return (0, $5uXOq.useMemo)(()=>obj, $2b1cba80f5ba3788$export$cdf98ded28406f69(obj));
    }
});
parcelRegister("iTZyv", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeScreenContextProvider", ()=>$83b0ce9f1ffe475b$export$ca77a8cbe94108fe);
    $parcel$export(module.exports, "usePostOfficeScreenPlacement", ()=>$83b0ce9f1ffe475b$export$f51d04a086368016);
    var $5uXOq = parcelRequire("5uXOq");
    var $1HWkH;
    const $83b0ce9f1ffe475b$var$initialPlacementState = {
        currentlyMounted: [],
        hasMounted: []
    };
    const $83b0ce9f1ffe475b$var$PostOfficeScreenContext = (0, $5uXOq.createContext)({
        placements: $83b0ce9f1ffe475b$var$initialPlacementState
    });
    const $83b0ce9f1ffe475b$export$70e19226ddeaf957 = ()=>(0, $5uXOq.useContext)($83b0ce9f1ffe475b$var$PostOfficeScreenContext);
    const $83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext = (0, $5uXOq.createContext)({
        placementMount: ()=>{},
        placementUnmount: ()=>{}
    });
    const $83b0ce9f1ffe475b$export$5d27c0ee02be2a23 = ()=>(0, $5uXOq.useContext)($83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext);
    const $83b0ce9f1ffe475b$export$ca77a8cbe94108fe = ({ children: children })=>{
        const [placements, setPlacements] = (0, $5uXOq.useState)($83b0ce9f1ffe475b$var$initialPlacementState);
        const placementMount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: (0, (0, parcelRequire("1HWkH")).uniqueArray)([
                        ...state.currentlyMounted,
                        placementId
                    ]),
                    hasMounted: (0, (0, parcelRequire("1HWkH")).uniqueArray)([
                        ...state.hasMounted,
                        placementId
                    ])
                }), []);
        const placementUnmount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
                }), []);
        const postOfficeScreenUpdateContext = (0, $5uXOq.useMemo)(()=>({
                placementMount: placementMount,
                placementUnmount: placementUnmount
            }), [
            placementMount,
            placementUnmount
        ]);
        const postOfficeScreenContext = (0, $5uXOq.useMemo)(()=>({
                placements: placements
            }), [
            placements
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext.Provider, {
            value: postOfficeScreenUpdateContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($83b0ce9f1ffe475b$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext
        }, children));
    };
    const $83b0ce9f1ffe475b$export$f51d04a086368016 = ({ placementId: placementId })=>{
        const { placementMount: placementMount, placementUnmount: placementUnmount } = $83b0ce9f1ffe475b$export$5d27c0ee02be2a23();
        (0, $5uXOq.useEffect)(()=>{
            if (!placementId) return;
            placementMount({
                placementId: placementId
            });
            return ()=>{
                placementUnmount({
                    placementId: placementId
                });
            };
        }, [
            placementId,
            placementMount,
            placementUnmount
        ]);
    };
});
parcelRegister("1HWkH", function(module, exports) {
    $parcel$export(module.exports, "uniqueArray", ()=>$1e088c20e501b022$export$bbd17ecb0679edd7);
    const $1e088c20e501b022$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
});
parcelRegister("8uFbT", function(module, exports) {
    $parcel$export(module.exports, "TriggerContextProvider", ()=>$30c451df5a2e0ecd$export$e80a5720bb4c8fe3);
    var $5uXOq = parcelRequire("5uXOq");
    const $30c451df5a2e0ecd$var$initialActiveTriggerState = {
        activeTriggerState: {
            activeTriggerId: undefined
        }
    };
    const $30c451df5a2e0ecd$var$initialTriggerDispatchState = {
        setTriggerState: ()=>{
            console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
        }
    };
    const $30c451df5a2e0ecd$var$TriggerContext = (0, ($parcel$interopDefault($5uXOq))).createContext($30c451df5a2e0ecd$var$initialActiveTriggerState);
    const $30c451df5a2e0ecd$var$TriggerDispatchContext = (0, ($parcel$interopDefault($5uXOq))).createContext($30c451df5a2e0ecd$var$initialTriggerDispatchState);
    const $30c451df5a2e0ecd$export$e80a5720bb4c8fe3 = ({ children: children })=>{
        const [activeTriggerState, setActiveTriggerState] = (0, $5uXOq.useState)($30c451df5a2e0ecd$var$initialActiveTriggerState.activeTriggerState);
        const setTriggerState = (0, $5uXOq.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
            setActiveTriggerState((current)=>{
                const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
                if (!hasStateChanged) return current;
                if (isActive) return {
                    activeTriggerId: triggerId
                };
                return {
                    activeTriggerId: undefined
                };
            });
        }, []);
        const triggerContextValue = (0, $5uXOq.useMemo)(()=>({
                activeTriggerState: activeTriggerState
            }), [
            activeTriggerState
        ]);
        const triggerContexDispatchValue = (0, $5uXOq.useMemo)(()=>({
                setTriggerState: setTriggerState
            }), [
            setTriggerState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($30c451df5a2e0ecd$var$TriggerContext.Provider, {
            value: triggerContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($30c451df5a2e0ecd$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue
        }, children));
    };
    const $30c451df5a2e0ecd$export$454c1d7c35958f5e = ()=>(0, $5uXOq.useContext)($30c451df5a2e0ecd$var$TriggerContext);
    const $30c451df5a2e0ecd$export$23cbf084e08bdb93 = ()=>(0, $5uXOq.useContext)($30c451df5a2e0ecd$var$TriggerDispatchContext);
    const $30c451df5a2e0ecd$export$3b196fe93a948c18 = (triggerId)=>{
        const { activeTriggerState: activeTriggerState } = $30c451df5a2e0ecd$export$454c1d7c35958f5e();
        return triggerId ? {
            isActive: activeTriggerState.activeTriggerId === triggerId
        } : {
            isActive: undefined
        };
    };
    const $30c451df5a2e0ecd$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
        const { setTriggerState: setContextTriggerState } = $30c451df5a2e0ecd$export$23cbf084e08bdb93();
        const fireTrigger = (0, $5uXOq.useCallback)(({ isActive: isActive })=>{
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        }, [
            setContextTriggerState,
            triggerId
        ]);
        return {
            fireTrigger: fireTrigger
        };
    };
});
parcelRegister("hWRix", function(module, exports) {
    $parcel$export(module.exports, "createMessagePlacementValues", ()=>$bb15f099f95e68b6$export$a28a0c048b24fc5a);
    $parcel$export(module.exports, "MessagePlacementProvider", ()=>$bb15f099f95e68b6$export$c7535f8ebc5b75a9);
    $parcel$export(module.exports, "useMessagePlacementHooks", ()=>$bb15f099f95e68b6$export$89f8e1f623d8f5ac);
    var $5uXOq = parcelRequire("5uXOq");
    const $bb15f099f95e68b6$var$createPubSub = ()=>{
        const subscribers = new Map();
        const subscribe = (subscriber)=>{
            subscribers.set(subscriber, subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const publish = (payload)=>{
            subscribers.forEach((cb)=>cb(payload));
        };
        return [
            subscribe,
            publish
        ];
    };
    const $bb15f099f95e68b6$export$a28a0c048b24fc5a = ()=>{
        const [onMessageSnooze, snoozeMessageFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        const [onMessageDismiss, dismissMessageFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        const [onMessageRead, markReadFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        const [onMessageViewed, markViewedFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        const [onMessageClicked, markClickedFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        return {
            onMessageSnooze: onMessageSnooze,
            snoozeMessageFromPlacement: snoozeMessageFromPlacement,
            onMessageDismiss: onMessageDismiss,
            dismissMessageFromPlacement: dismissMessageFromPlacement,
            onMessageRead: onMessageRead,
            markReadFromPlacement: markReadFromPlacement,
            onMessageViewed: onMessageViewed,
            markViewedFromPlacement: markViewedFromPlacement,
            onMessageClicked: onMessageClicked,
            markClickedFromPlacement: markClickedFromPlacement
        };
    };
    const $bb15f099f95e68b6$export$ea58328f3ceee4d4 = (0, $5uXOq.createContext)($bb15f099f95e68b6$export$a28a0c048b24fc5a());
    const $bb15f099f95e68b6$export$c7535f8ebc5b75a9 = $bb15f099f95e68b6$export$ea58328f3ceee4d4.Provider;
    const $bb15f099f95e68b6$export$c4b5cec0911af177 = ()=>({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($bb15f099f95e68b6$export$c7535f8ebc5b75a9, {
                value: $bb15f099f95e68b6$export$a28a0c048b24fc5a()
            }, children);
    const $bb15f099f95e68b6$export$89f8e1f623d8f5ac = ()=>(0, $5uXOq.useContext)($bb15f099f95e68b6$export$ea58328f3ceee4d4);
});
parcelRegister("6I1Fy", function(module, exports) {
    $parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", ()=>$f0574f278f9639f1$export$ae3dab16eb1fc2cc);
    const $f0574f278f9639f1$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
        const { env: env, overrides: overrides } = environmentWithOverrides;
        return {
            currentEnv: env,
            envConfigs: {
                ...defaultEnvironmentValues.envConfigs,
                [env]: {
                    remoteModule: {
                        origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                        pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                        searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                    },
                    api: {
                        origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                        pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                        searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                    }
                }
            }
        };
    };
});
parcelRegister("adncp", function(module, exports) {
    $parcel$export(module.exports, "tenantToPostOfficeContext", ()=>$8d0bdd2f51e19696$export$d8f2c334a0924146);
    $parcel$export(module.exports, "subproductToEdition", ()=>$8d0bdd2f51e19696$export$2d690d13b91ea44f);
    $parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", ()=>$8d0bdd2f51e19696$export$cfacfecb20987ff1);
    var $3qX4x;
    const $8d0bdd2f51e19696$var$JIRA_PRODUCT = 'jira';
    const $8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT = {
        product: $8d0bdd2f51e19696$var$JIRA_PRODUCT,
        locale: 'en'
    };
    const $8d0bdd2f51e19696$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
        return (0, (0, parcelRequire("3qX4x")).JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString();
    };
    const $8d0bdd2f51e19696$export$d8f2c334a0924146 = (tenantData)=>{
        const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale } = tenantData;
        const workspaceAri = $8d0bdd2f51e19696$var$getWorkspaceARI({
            activationId: activationId,
            cloudId: cloudId
        });
        return {
            ...$8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT,
            locale: locale,
            isSiteAdmin: isSiteAdmin,
            tenantId: cloudId,
            workspaceAri: workspaceAri,
            workspaceId: activationId,
            orgId: undefined,
            subproduct: undefined,
            productEdition: undefined
        };
    };
    const $8d0bdd2f51e19696$export$2d690d13b91ea44f = (subproduct, editions)=>{
        switch(subproduct){
            case 'core':
                return editions.core;
            case 'software':
                return editions.software;
            case 'customerService':
                return editions.customerService;
            case 'serviceDesk':
                return editions.serviceDesk;
            default:
                undefined;
        }
    };
    const $8d0bdd2f51e19696$export$cfacfecb20987ff1 = (environment)=>{
        switch(environment){
            case 'dev':
            case 'staging':
                return 'staging';
            case 'prod':
                return 'production';
            case 'local':
                return 'local';
            default:
                return 'local';
        }
    };
});
parcelRegister("3qX4x", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkspaceAri", ()=>$28019f51d977bb92$export$d4d0794234e3fd53);
    var $b1EkX;
    var $fe7YR;
    var $224I1;
    var $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
        resourceOwner: (0, (0, parcelRequire("b1EkX")).JiraWorkspaceAriResourceOwner),
        resourceType: (0, (0, parcelRequire("b1EkX")).JiraWorkspaceAriResourceType),
        resourceIdSlug: "{activationId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/
        }
    };
    var $28019f51d977bb92$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, (0, parcelRequire("fe7YR")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts.qualifier,
                platformQualifier: $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts.resourceOwner,
                resourceType: $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts.resourceType,
                resourceId: `${opts.activationId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId
                }
            }, ariOpts = (0, (0, parcelRequire("224I1")).AriParser).fromOpts(derivedOpts, $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts);
            return new _JiraWorkspaceAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("224I1")).AriParser).fromString(maybeAri, $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts);
            return new _JiraWorkspaceAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId
            };
        }
    };
});
parcelRegister("b1EkX", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", ()=>$806f13cc47cff352$export$e52ccdf6abac8896);
    $parcel$export(module.exports, "JiraWorkspaceAriResourceType", ()=>$806f13cc47cff352$export$669cd5f7b3746bb);
    var $806f13cc47cff352$export$e52ccdf6abac8896 = "jira", $806f13cc47cff352$export$669cd5f7b3746bb = "workspace";
});
parcelRegister("iPMn1", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagsPlacement", ()=>$3ba8955bb8ac2826$export$f6564e60882bdf90);
    var $5uXOq = parcelRequire("5uXOq");
    var $jgefF;
    var $4R6GH;
    var $jQsty;
    var $SfWIb;
    var $7sr84;
    const $3ba8955bb8ac2826$var$PLACEMENT_ID = 'screen-space-flags';
    const $3ba8955bb8ac2826$export$f6564e60882bdf90 = ()=>{
        return !false && !(0, (0, parcelRequire("jQsty")).default)((0, $d0ca21152325de6b$export$37d4bb5bc0e315db)) && (0, (0, parcelRequire("4R6GH")).fg)('post-office-screen-space-overlay-jfe') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7sr84")).ScreenSpaceFlagPlacementPreviewSwitcher), {
            isEnabled: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("SfWIb")).default), {
            placementId: $3ba8955bb8ac2826$var$PLACEMENT_ID,
            PlacementComponent: (0, (0, parcelRequire("jgefF")).default),
            disableInitialData: true
        })) : null;
    };
});
parcelRegister("jgefF", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagsPlacementComponent", ()=>$bde3999cf210ffea$export$c60b43809441c5b0);
    $parcel$export(module.exports, "default", ()=>$bde3999cf210ffea$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    var $5IPCv;
    var $eFjrB;
    var $hWRix;
    var $iXSVm;
    var $1mc52;
    var $7PgHB;
    var $92Slv;
    var $4rq6q;
    var $3p8Nq;
    const $bde3999cf210ffea$export$c60b43809441c5b0 = (0, (0, parcelRequire("3p8Nq")).withScreenSpaceFlagsIntlProvider)((0, (0, parcelRequire("iXSVm")).createPlacementComponent)((0, $f6721478b0b83c9a$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
        const [localMessageState, setLocalMessageState] = (0, $5uXOq.useState)();
        (0, (0, parcelRequire("1mc52")).useInitialData)(initialData);
        const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked } = (0, (0, parcelRequire("hWRix")).useMessagePlacementHooks)();
        const handleDismiss = ({ messageInstanceId: messageInstanceId })=>{
            setLocalMessageState((current)=>current ? current.filter((e)=>e.messageInstanceId !== messageInstanceId) : undefined);
        };
        (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleDismiss), [
            onMessageDismiss
        ]);
        (0, $5uXOq.useEffect)(()=>onMessageClicked(handleDismiss), [
            onMessageClicked
        ]);
        const activeScopes = (0, (0, parcelRequire("eFjrB")).usePostOfficeContextScope)({
            scopes: (0, parcelRequire("92Slv")).scopes
        });
        const messagesState = (0, (0, parcelRequire("7PgHB")).usePlacementApi)('/update-messages', {
            requestOptions: {
                method: 'POST',
                body: JSON.stringify(activeScopes)
            },
            throttleTime: 100,
            autoRefetch: {
                isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
                updateKey: activeScopes.updateKey ?? ''
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
        }, [
            messagesState.data
        ]);
        return (0, (0, parcelRequire("5IPCv")).default).checkGate('post-office-screen-space-flags-shadow') ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>(0, $5uXOq.createElement)((0, (0, parcelRequire("4rq6q")).MessageRenderer), {
                    ...props,
                    key: messageInstanceId,
                    id: messageInstanceId,
                    messageInstanceId: messageInstanceId,
                    onDismissed: ()=>setLocalMessageState([])
                }))
        }) : null;
    }));
    var $bde3999cf210ffea$export$2e2bcd8739ae039 = $bde3999cf210ffea$export$c60b43809441c5b0;
});
parcelRegister("2OMIu", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("iIkmJ"));
});
parcelRegister("iIkmJ", function(module, exports) {
    $parcel$export(module.exports, "Fragment", ()=>$d9fc223fda04f9ed$export$ffb0004e005737fa, (v)=>$d9fc223fda04f9ed$export$ffb0004e005737fa = v);
    $parcel$export(module.exports, "jsx", ()=>$d9fc223fda04f9ed$export$34b9dba7ce09269b, (v)=>$d9fc223fda04f9ed$export$34b9dba7ce09269b = v);
    $parcel$export(module.exports, "jsxs", ()=>$d9fc223fda04f9ed$export$25062201e9e25d76, (v)=>$d9fc223fda04f9ed$export$25062201e9e25d76 = v);
    var $d9fc223fda04f9ed$export$ffb0004e005737fa;
    var $d9fc223fda04f9ed$export$34b9dba7ce09269b;
    var $d9fc223fda04f9ed$export$25062201e9e25d76;
    'use strict';
    var $5uXOq = parcelRequire("5uXOq");
    var $d9fc223fda04f9ed$var$k = Symbol.for("react.element"), $d9fc223fda04f9ed$var$l = Symbol.for("react.fragment"), $d9fc223fda04f9ed$var$m = Object.prototype.hasOwnProperty, $d9fc223fda04f9ed$var$n = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d9fc223fda04f9ed$var$p = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function $d9fc223fda04f9ed$var$q(c, a, g) {
        var b, d = {}, e = null, h = null;
        void 0 !== g && (e = "" + g);
        void 0 !== a.key && (e = "" + a.key);
        void 0 !== a.ref && (h = a.ref);
        for(b in a)$d9fc223fda04f9ed$var$m.call(a, b) && !$d9fc223fda04f9ed$var$p.hasOwnProperty(b) && (d[b] = a[b]);
        if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
        return {
            $$typeof: $d9fc223fda04f9ed$var$k,
            type: c,
            key: e,
            ref: h,
            props: d,
            _owner: $d9fc223fda04f9ed$var$n.current
        };
    }
    $d9fc223fda04f9ed$export$ffb0004e005737fa = $d9fc223fda04f9ed$var$l;
    $d9fc223fda04f9ed$export$34b9dba7ce09269b = $d9fc223fda04f9ed$var$q;
    $d9fc223fda04f9ed$export$25062201e9e25d76 = $d9fc223fda04f9ed$var$q;
});
parcelRegister("eFjrB", function(module, exports) {
    $parcel$export(module.exports, "usePostOfficeContextScope", ()=>$3fdf392448c70ebb$export$daf66a67c26dc848);
    var $5uXOq = parcelRequire("5uXOq");
    var $kye0Q = parcelRequire("kye0Q");
    var $gHZ4O;
    var $lwdce;
    var $dM8xS;
    const $3fdf392448c70ebb$export$daf66a67c26dc848 = (config)=>{
        const scopeNames = $3fdf392448c70ebb$var$scopesNamesAsString(config.scopes);
        const matchScopes = (0, $5uXOq.useCallback)((input)=>$3fdf392448c70ebb$export$ec890b48cae4cc1c(config)(input), [
            scopeNames
        ]);
        const [state, setState] = (0, $5uXOq.useState)($3fdf392448c70ebb$var$initialState);
        const route = (0, (0, parcelRequire("lwdce")).usePostOfficeRoute)();
        const context = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const next = matchScopes({
            route: route,
            context: context
        });
        $3fdf392448c70ebb$var$usePostOfficeScopeSpy(state, config);
        (0, $5uXOq.useEffect)(()=>{
            if ($3fdf392448c70ebb$export$fcc046cb16c47539({
                next: next,
                state: state
            })) setState(({ current: current })=>({
                    updateKey: Math.random().toString(36).substring(2),
                    current: next,
                    previous: current
                }));
        }, [
            $3fdf392448c70ebb$var$scopesNamesAsString(next)
        ]);
        return state;
    };
    const $3fdf392448c70ebb$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
    const $3fdf392448c70ebb$var$initialState = {
        updateKey: undefined,
        current: [],
        previous: []
    };
    const $3fdf392448c70ebb$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
            const contextMatch = route?.current ? {
                route: $3fdf392448c70ebb$var$extractRelevantUrlFields(route.current),
                context: context
            } : {
                route: undefined,
                context: context
            };
            const inputMatch = input.when;
            return $3fdf392448c70ebb$var$matchScope({
                contextMatch: contextMatch,
                inputMatch: inputMatch
            });
        };
    const $3fdf392448c70ebb$var$extractRelevantUrlFields = (route)=>{
        const { hostname: hostname, pathname: pathname } = new URL(route);
        return {
            hostname: hostname,
            pathname: pathname
        };
    };
    const $3fdf392448c70ebb$var$matchScope = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, ($parcel$interopDefault($kye0Q)))(contextMatch, inputMatch, (contextValue, inputValue)=>$3fdf392448c70ebb$var$isValueMatchDeep({
                contextValue: contextValue,
                inputValue: inputValue
            }));
    const $3fdf392448c70ebb$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
        if (!contextValue || !inputValue) return false;
        if (typeof inputValue === 'string') return contextValue === inputValue;
        if (inputValue?.equals) return contextValue === inputValue.equals;
        if (!inputValue?.matches) return false;
        if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
        return new RegExp(inputValue.matches).test(contextValue);
    };
    const $3fdf392448c70ebb$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $3fdf392448c70ebb$var$matchScope({
            contextMatch: contextValue,
            inputMatch: inputValue
        }) : $3fdf392448c70ebb$var$isValueMatch({
            contextValue: contextValue,
            inputValue: inputValue
        });
    const $3fdf392448c70ebb$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($3fdf392448c70ebb$var$createMatchScope(input)).map((scope)=>({
                    name: scope.name
                }));
    const $3fdf392448c70ebb$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
        const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
        const nextSet = Array.from(new Set(next.map((e)=>e.name)));
        if (nextSet.length !== currentSet.length) return true;
        return !nextSet.every((e)=>currentSet.includes(e));
    };
    const $3fdf392448c70ebb$var$usePostOfficeScopeSpy = (state, config)=>{
        if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
            const [listen, update] = (0, (0, parcelRequire("dM8xS")).createSimplePubSub)();
            window.postOffice = {
                ...window.postOffice,
                scopes: {
                    [config?.consoleSpy.name]: {
                        listen: listen,
                        update: update,
                        list: config.scopes
                    }
                }
            };
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!config?.consoleSpy) return;
            if (!window.postOffice?.scopes) return;
            window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
        }, [
            $3fdf392448c70ebb$var$scopesNamesAsString(state.current)
        ]);
    };
});
parcelRegister("kye0Q", function(module, exports) {
    var $b1bUS = parcelRequire("b1bUS");
    var $2TGin = parcelRequire("2TGin");
    function $ef61da41fa345164$var$isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined;
        return $b1bUS(object, source, $2TGin(source), customizer);
    }
    module.exports = $ef61da41fa345164$var$isMatchWith;
});
parcelRegister("iXSVm", function(module, exports) {
    $parcel$export(module.exports, "createPlacementComponent", ()=>$6b6a90a3d180f695$export$8a57effc6307f916);
    var $2OMIu = parcelRequire("2OMIu");
    var $dmvPD;
    var $7ncVP;
    var $6WlcH;
    var $91kAg;
    var $7wONK;
    var $cMrkQ;
    const $6b6a90a3d180f695$export$eaeb39efb2b24b52 = (placementId, Component)=>(0, (0, parcelRequire("cMrkQ")).withErrorBoundary)((props)=>{
            const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
            const { postOfficeRoute: route, ...context } = contextWithRoute;
            const stableContext = (0, (0, parcelRequire("dmvPD")).useStableObject)(context);
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("91kAg")).PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("7wONK")).StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    children: (0, $2OMIu.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            });
        });
    const $6b6a90a3d180f695$export$8a57effc6307f916 = (placementId, Component)=>{
        const placement = $6b6a90a3d180f695$export$eaeb39efb2b24b52(placementId, Component);
        return (props)=>{
            const { onError: onError, fallbackRender: fallbackRender } = (0, (0, parcelRequire("6WlcH")).useComponentErrorHandling)(props);
            return placement({
                ...props,
                errorBoundaryLocation: (0, (0, parcelRequire("7ncVP")).ERROR_BOUNDARY_LOCATION),
                onError: onError,
                fallbackRender: fallbackRender
            });
        };
    };
});
parcelRegister("7ncVP", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_CONTEXT", ()=>$565ab85685242653$export$9c542858adf7dcd0);
    $parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", ()=>$565ab85685242653$export$71ff7382870ef1b0);
    const $565ab85685242653$export$9c542858adf7dcd0 = {
        isSiteAdmin: undefined,
        locale: undefined,
        product: undefined,
        subproduct: undefined,
        tenantId: undefined,
        workspaceAri: 'no-workspace-ari-available',
        workspaceId: undefined,
        orgId: undefined,
        productEdition: undefined
    };
    const $565ab85685242653$export$71ff7382870ef1b0 = 'create-placement-component';
});
parcelRegister("6WlcH", function(module, exports) {
    $parcel$export(module.exports, "useComponentErrorHandling", ()=>$1540e801d3c88295$export$3d127465d22fe4e5);
    var $5uXOq = parcelRequire("5uXOq");
    const $1540e801d3c88295$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
        const internalOnError = (0, $5uXOq.useCallback)((error, info)=>{
            onEvent?.({
                type: 'component-error',
                error: error
            });
            onError?.(error, info);
        }, [
            onEvent,
            onError
        ]);
        const internalFallbackRender = fallbackRender ?? errorFallback;
        return {
            onError: internalOnError,
            fallbackRender: internalFallbackRender
        };
    };
});
parcelRegister("91kAg", function(module, exports) {
    $parcel$export(module.exports, "PerformanceTracking", ()=>$aca6e70a98eb13dc$export$9a335a42ce02bdb8);
    var $2OMIu = parcelRequire("2OMIu");
    var $5IPCv;
    var $5H0An;
    var $k42Hu;
    var $6ywV7;
    const $aca6e70a98eb13dc$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
        const isUFOEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_ufo_tracking_in_post_office');
        const { isLoading: isLoading, onMount: onMount } = (0, (0, parcelRequire("6ywV7")).usePerformanceTracking)(props);
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.PLACEMENT,
            children: [
                isUFOEnabled && isLoading && (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOLoadHold, {
                    name: (0, (0, parcelRequire("5H0An")).UFOv2).HoldNames.PLACEMENT
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("k42Hu")).TrackMount), {
                    onMount: onMount,
                    children: children
                })
            ]
        });
    };
});
parcelRegister("5H0An", function(module, exports) {
    $parcel$export(module.exports, "UFOv2", ()=>$cbdc98b350424372$export$c91b09caa8ecbab1);
    var $fNobW;
    var $8Ec39;
    const $cbdc98b350424372$export$c91b09caa8ecbab1 = {
        SegmentNames: {
            REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
            PLACEMENT: 'post-office-placement',
            MESSAGE: 'post-office-message'
        },
        HoldNames: {
            REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
            PLACEMENT: 'post-office-placement-loading',
            MESSAGE: 'post-office-message-loading'
        },
        UFOLoadHold: (0, parcelRequire("fNobW")).default,
        UFOSegment: (0, parcelRequire("8Ec39")).default
    };
});
parcelRegister("k42Hu", function(module, exports) {
    $parcel$export(module.exports, "TrackMount", ()=>$50a67969103c2bfd$export$21b400a8c8ebc91a);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $50a67969103c2bfd$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
        (0, $5uXOq.useEffect)(()=>{
            const onUnmount = onMount();
            return onUnmount;
        }, []);
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("6ywV7", function(module, exports) {
    $parcel$export(module.exports, "usePerformanceTracking", ()=>$60c56bf5d2afa73f$export$317d52099614f316);
    var $5uXOq = parcelRequire("5uXOq");
    const $60c56bf5d2afa73f$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const onMount = (0, $5uXOq.useCallback)(()=>{
            return ()=>onEvent?.({
                    type: 'unmount'
                });
        }, [
            onEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (initialData) initialData.then(()=>{
                onEvent?.({
                    type: 'initial-data-complete'
                });
            }).catch((error)=>{
                onEvent?.({
                    type: 'initial-data-error',
                    error: error
                });
            }).finally(()=>{
                setIsLoading(false);
            });
            else setIsLoading(false);
        }, [
            initialData,
            onEvent
        ]);
        const onComponentError = (0, $5uXOq.useCallback)((error)=>{
            onEvent?.({
                type: 'component-error',
                error: error
            });
        }, [
            onEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isLoading === false) onEvent?.({
                type: 'component-ready'
            });
        }, [
            isLoading
        ]);
        return {
            onMount: onMount,
            isLoading: isLoading,
            onComponentError: onComponentError
        };
    };
});
parcelRegister("7wONK", function(module, exports) {
    $parcel$export(module.exports, "StableProviders", ()=>$55e436d1a4674431$export$2b6596bcb1383a71);
    var $2OMIu = parcelRequire("2OMIu");
    var $1Sj4e;
    var $04jsn;
    var $8IVWW;
    var $9P3TE;
    var $ggJMp;
    var $bDGqG;
    var $91kAg;
    const $55e436d1a4674431$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("9P3TE")).StableContextProvider), {
            context: context,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("ggJMp")).StablePlacementProvider), {
                placement: placement,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("bDGqG")).StableRouteProvider), {
                    route: route,
                    children: (0, $2OMIu.jsx)((0, (0, parcelRequire("04jsn")).StableAnaltyicsProvider), {
                        children: (0, $2OMIu.jsx)((0, (0, parcelRequire("8IVWW")).StableChoreographerProvider), {
                            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("1Sj4e")).RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        });
});
parcelRegister("1Sj4e", function(module, exports) {
    $parcel$export(module.exports, "RenderTrackerProvider", ()=>$8c48e8a04bfa2a64$export$2d84fd9af6c9e378);
    var $2OMIu = parcelRequire("2OMIu");
    var $h3mjV;
    var $5uXOq = parcelRequire("5uXOq");
    const $8c48e8a04bfa2a64$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
        'screen-space-flags'
    ];
    const $8c48e8a04bfa2a64$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if ($8c48e8a04bfa2a64$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
            fireAnalyticsEvent({
                eventType: 'track',
                action: 'rendered',
                actionSubject: 'placement'
            });
        }, [
            fireAnalyticsEvent,
            placementId
        ]);
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("h3mjV", function(module, exports) {
    $parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", ()=>$5bc838ac8c037623$export$57d19d18d6e255a5);
    var $2NMNM;
    var $5uXOq = parcelRequire("5uXOq");
    const $5bc838ac8c037623$export$85183a312807388d = 'postOffice';
    const $5bc838ac8c037623$export$57d19d18d6e255a5 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalyticsEvent = (0, $5uXOq.useCallback)((event, attributes)=>{
            createAnalyticsEvent({
                ...event,
                side: 'client',
                attributes: {
                    ...event.attributes,
                    ...attributes
                }
            }).fire($5bc838ac8c037623$export$85183a312807388d);
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireAnalyticsEvent: fireAnalyticsEvent
        };
    };
});
parcelRegister("04jsn", function(module, exports) {
    $parcel$export(module.exports, "StableAnaltyicsProvider", ()=>$710055c5ee12714f$export$5a66cdc9893b43e);
    var $2OMIu = parcelRequire("2OMIu");
    var $1PVpv = parcelRequire("1PVpv");
    const $710055c5ee12714f$var$postOfficeAnalyticsContextData = {
        attributes: {
            build: {
                c: undefined,
                b: undefined,
                t: undefined
            }
        }
    };
    const $710055c5ee12714f$export$5a66cdc9893b43e = ({ children: children })=>{
        return (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
            data: $710055c5ee12714f$var$postOfficeAnalyticsContextData,
            children: children
        });
    };
});
parcelRegister("8IVWW", function(module, exports) {
    $parcel$export(module.exports, "StableChoreographerProvider", ()=>$5cbaf6c43da97ba7$export$e68b2c75bfb5682a);
    $parcel$export(module.exports, "useChoreographerContext", ()=>$5cbaf6c43da97ba7$export$cab5a8adbabcee23);
    var $2OMIu = parcelRequire("2OMIu");
    var $gHZ4O;
    var $5MYiV;
    var $5uXOq = parcelRequire("5uXOq");
    var $8rxdt;
    const $5cbaf6c43da97ba7$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
    const $5cbaf6c43da97ba7$var$defaultContext = {
        choreographerEnabled: $5cbaf6c43da97ba7$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
        setChoreographerEnabled: ()=>{},
        factory: undefined
    };
    const $5cbaf6c43da97ba7$var$ChoreographerContext = (0, $5uXOq.createContext)($5cbaf6c43da97ba7$var$defaultContext);
    const $5cbaf6c43da97ba7$export$e68b2c75bfb5682a = ({ children: children })=>{
        const [choreographerEnabled, setChoreographerEnabled] = (0, $5uXOq.useState)($5cbaf6c43da97ba7$var$defaultContext.choreographerEnabled);
        const environmentContext = (0, (0, parcelRequire("5MYiV")).usePostOfficeEnvironment)();
        const context = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const choreographerFactory = new (0, (0, parcelRequire("8rxdt")).default)(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory();
        const stableChoreographerContext = (0, $5uXOq.useMemo)(()=>({
                factory: choreographerFactory,
                choreographerEnabled: choreographerEnabled,
                setChoreographerEnabled: setChoreographerEnabled
            }), [
            choreographerFactory,
            choreographerEnabled,
            setChoreographerEnabled
        ]);
        return (0, $2OMIu.jsx)($5cbaf6c43da97ba7$var$ChoreographerContext.Provider, {
            value: stableChoreographerContext,
            children: children
        });
    };
    const $5cbaf6c43da97ba7$export$cab5a8adbabcee23 = ()=>(0, $5uXOq.useContext)($5cbaf6c43da97ba7$var$ChoreographerContext);
});
parcelRegister("8rxdt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f823a5e69a4bdde1$export$2e2bcd8739ae039);
    var $4zICj;
    var $TTRxY;
    var $iZhen;
    const $f823a5e69a4bdde1$var$mapEnvToAnalyticsEnv = (env)=>{
        switch(env){
            case 'test':
            case 'local':
                return (0, (0, parcelRequire("iZhen")).envType).LOCAL;
            case 'dev':
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            case 'staging':
            case 'stg-fedm-east':
                return (0, (0, parcelRequire("iZhen")).envType).STAGING;
            case 'production':
            case 'prod-fedm-east':
                return (0, (0, parcelRequire("iZhen")).envType).PROD;
            default:
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
        }
    };
    class $f823a5e69a4bdde1$var$ChoreographerRegistry {
        constructor(product, environment){
            this.product = product;
            this.environment = environment;
        }
        getPostOfficeChoreographerFactory() {
            if (window.choreographerRegistry === undefined) window.choreographerRegistry = new Map();
            const maybeChoreographerFactory = window.choreographerRegistry.get((0, (0, parcelRequire("TTRxY")).ProductIds).POST_OFFICE);
            if (maybeChoreographerFactory) return maybeChoreographerFactory;
            const factory = (0, (0, parcelRequire("4zICj")).choreographerFactory)((0, (0, parcelRequire("TTRxY")).ProductIds).POST_OFFICE, $f823a5e69a4bdde1$var$mapEnvToAnalyticsEnv(this.environment), {
                sourceProductId: this.product
            });
            window.choreographerRegistry.set((0, (0, parcelRequire("TTRxY")).ProductIds).POST_OFFICE, factory);
            return factory;
        }
    }
    var $f823a5e69a4bdde1$export$2e2bcd8739ae039 = $f823a5e69a4bdde1$var$ChoreographerRegistry;
});
parcelRegister("9P3TE", function(module, exports) {
    $parcel$export(module.exports, "StableContextProvider", ()=>$6767a9a09c3fcd53$export$d4982c0a28b18f63);
    var $2OMIu = parcelRequire("2OMIu");
    var $gHZ4O;
    var $dmvPD;
    var $7ncVP;
    const $6767a9a09c3fcd53$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
        const stableContext = (0, (0, parcelRequire("dmvPD")).useStableObject)({
            ...(0, (0, parcelRequire("7ncVP")).DEFAULT_CONTEXT),
            ...context
        });
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("gHZ4O")).PostOfficeContextProvider), {
            value: stableContext,
            children: children
        });
    };
});
parcelRegister("ggJMp", function(module, exports) {
    $parcel$export(module.exports, "StablePlacementProvider", ()=>$272ba963095674d4$export$e9fd288527498af6);
    var $2OMIu = parcelRequire("2OMIu");
    var $dmvPD;
    var $9uYQQ;
    const $272ba963095674d4$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
        const stableValue = (0, (0, parcelRequire("dmvPD")).useStableObject)(placement);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("9uYQQ")).PlacementProvider), {
            value: stableValue,
            children: children
        });
    };
});
parcelRegister("9uYQQ", function(module, exports) {
    $parcel$export(module.exports, "PlacementProvider", ()=>$9a7fffcf8781b15b$export$6272e220478c7f1d);
    $parcel$export(module.exports, "usePlacementContext", ()=>$9a7fffcf8781b15b$export$4fc0446ee742ad80);
    var $2OMIu = parcelRequire("2OMIu");
    var $1PVpv = parcelRequire("1PVpv");
    var $iTZyv;
    var $5uXOq = parcelRequire("5uXOq");
    const $9a7fffcf8781b15b$export$6394bf86db095a8 = (0, $5uXOq.createContext)({
        placementId: undefined
    });
    const $9a7fffcf8781b15b$export$6272e220478c7f1d = ({ value: value, children: children })=>{
        const memoizedValue = (0, $5uXOq.useMemo)(()=>({
                placementId: value.placementId
            }), [
            value.placementId
        ]);
        (0, (0, parcelRequire("iTZyv")).usePostOfficeScreenPlacement)(memoizedValue);
        return (0, $2OMIu.jsx)($9a7fffcf8781b15b$export$6394bf86db095a8.Provider, {
            value: memoizedValue,
            children: (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
                data: memoizedValue,
                children: children
            })
        });
    };
    const $9a7fffcf8781b15b$export$4fc0446ee742ad80 = ()=>(0, $5uXOq.useContext)($9a7fffcf8781b15b$export$6394bf86db095a8);
});
parcelRegister("bDGqG", function(module, exports) {
    $parcel$export(module.exports, "StableRouteProvider", ()=>$0c781d2417991e36$export$ce13d00e696dfc96);
    var $2OMIu = parcelRequire("2OMIu");
    var $lwdce;
    var $dmvPD;
    var $21kSR;
    const $0c781d2417991e36$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
        const href = (0, (0, parcelRequire("21kSR")).useLocationHref)();
        const stableRoute = (0, (0, parcelRequire("dmvPD")).useStableObject)(route ?? {
            previous: href,
            current: href
        });
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("lwdce")).PostOfficeRouteContext).Provider, {
            value: stableRoute,
            children: children
        });
    };
});
parcelRegister("21kSR", function(module, exports) {
    $parcel$export(module.exports, "useLocationHref", ()=>$119e036a70bf0d4f$export$49fc3f3d8c7f99);
    const $119e036a70bf0d4f$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
    const $119e036a70bf0d4f$export$49fc3f3d8c7f99 = ()=>{
        return $119e036a70bf0d4f$var$isLocationAvailable() ? globalThis.location.href : undefined;
    };
});
parcelRegister("cMrkQ", function(module, exports) {
    $parcel$export(module.exports, "withErrorBoundary", ()=>$e8809641acc51790$export$f0c7a449e0cfaec7);
    var $2OMIu = parcelRequire("2OMIu");
    var $h3mjV;
    var $lilOZ;
    const $e8809641acc51790$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
            const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                    if (onError) onError(error, info);
                    fireAnalyticsEvent({
                        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                        action: 'caughtError',
                        actionSubject: 'PostOfficeErrorBoundary',
                        actionSubjectId: additionalAnalytics.errorBoundaryLocation
                    }, {
                        error: error,
                        info: info
                    });
                };
            const internalFallbackRender = (FallbackRender)=>(props)=>{
                    if (FallbackRender) return (0, $2OMIu.jsx)(FallbackRender, {
                        ...props
                    });
                    return null;
                };
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("lilOZ")).ErrorBoundary), {
                fallbackRender: internalFallbackRender(fallbackRender),
                onError: internalOnError({
                    errorBoundaryLocation: errorBoundaryLocation
                }, onError),
                children: (0, $2OMIu.jsx)(Component, {
                    ...data
                })
            });
        };
});
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';
parcelRegister("lilOZ", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$f80c34b0760a7119$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    'use client';
    const $f80c34b0760a7119$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
    const $f80c34b0760a7119$var$initialState = {
        didCatch: false,
        error: null
    };
    class $f80c34b0760a7119$export$e926676385687eaf extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
            this.state = $f80c34b0760a7119$var$initialState;
        }
        static getDerivedStateFromError(error) {
            return {
                didCatch: true,
                error: error
            };
        }
        resetErrorBoundary() {
            const { error: error } = this.state;
            if (error !== null) {
                var _this$props$onReset, _this$props;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                    args: args,
                    reason: "imperative-api"
                });
                this.setState($f80c34b0760a7119$var$initialState);
            }
        }
        componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
        }
        componentDidUpdate(prevProps, prevState) {
            const { didCatch: didCatch } = this.state;
            const { resetKeys: resetKeys } = this.props;
            if (didCatch && prevState.error !== null && $f80c34b0760a7119$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
                var _this$props$onReset2, _this$props3;
                (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                    next: resetKeys,
                    prev: prevProps.resetKeys,
                    reason: "keys"
                });
                this.setState($f80c34b0760a7119$var$initialState);
            }
        }
        render() {
            const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
            const { didCatch: didCatch, error: error } = this.state;
            let childToRender = children;
            if (didCatch) {
                const props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
                else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
                else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
                else throw error;
            }
            return (0, $5uXOq.createElement)($f80c34b0760a7119$export$b16d9fb1a22de840.Provider, {
                value: {
                    didCatch: didCatch,
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                }
            }, childToRender);
        }
    }
    function $f80c34b0760a7119$var$hasArrayChanged() {
        let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
    }
    function $f80c34b0760a7119$var$assertErrorBoundaryContext(value) {
        if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
    }
    function $f80c34b0760a7119$export$c052f6604b7d51fe() {
        const context = (0, $5uXOq.useContext)($f80c34b0760a7119$export$b16d9fb1a22de840);
        $f80c34b0760a7119$var$assertErrorBoundaryContext(context);
        const [state, setState] = (0, $5uXOq.useState)({
            error: null,
            hasError: false
        });
        const memoized = (0, $5uXOq.useMemo)(()=>({
                resetBoundary: ()=>{
                    context.resetErrorBoundary();
                    setState({
                        error: null,
                        hasError: false
                    });
                },
                showBoundary: (error)=>setState({
                        error: error,
                        hasError: true
                    })
            }), [
            context.resetErrorBoundary
        ]);
        if (state.hasError) throw state.error;
        return memoized;
    }
    function $f80c34b0760a7119$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
        const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($f80c34b0760a7119$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
                ...props,
                ref: ref
            })));
        const name = component.displayName || component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
        return Wrapped;
    }
});
parcelRegister("1mc52", function(module, exports) {
    $parcel$export(module.exports, "useInitialData", ()=>$40d2fd940b9d1c6e$export$5523c5f3222291d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5NGOu;
    const $40d2fd940b9d1c6e$export$5523c5f3222291d0 = (initialData)=>{
        const initialDataCallback = (0, $5uXOq.useMemo)(()=>{
            if (typeof initialData === 'undefined') return undefined;
            return ()=>initialData;
        }, [
            initialData
        ]);
        return (0, (0, parcelRequire("5NGOu")).useData)(initialDataCallback, {
            analytics: {
                name: 'initialData'
            }
        });
    };
});
parcelRegister("5NGOu", function(module, exports) {
    $parcel$export(module.exports, "AlreadyRunningError", ()=>$6f73ba24b9c26bf5$export$8c5224d3af2f3c8b);
    $parcel$export(module.exports, "useData", ()=>$6f73ba24b9c26bf5$export$c1cf1cf4c5d51937);
    var $h3mjV;
    var $lzG7s = parcelRequire("lzG7s");
    var $5uXOq = parcelRequire("5uXOq");
    var $azprR;
    class $6f73ba24b9c26bf5$export$8c5224d3af2f3c8b extends Error {
        constructor(){
            super('Request is already running.');
            this.name = 'AlreadyRunningError';
        }
    }
    const $6f73ba24b9c26bf5$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
        const [state, setState] = (0, $5uXOq.useState)((0, (0, parcelRequire("azprR")).toLoading)());
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
            name: 'unknown'
        };
        (0, $5uXOq.useEffect)(()=>{
            if (typeof promiseToResolve !== 'function') return;
            const abortController = new AbortController();
            const { signal: signal } = abortController;
            promiseToResolve({
                signal: signal
            }).then((0, (0, parcelRequire("azprR")).assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
                setState((0, (0, parcelRequire("azprR")).toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }).catch((err)=>{
                if (err instanceof $6f73ba24b9c26bf5$export$8c5224d3af2f3c8b || signal.aborted) return;
                const errorState = (0, (0, parcelRequire("azprR")).toError)(err);
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: errorState.error.name ?? 'unknown',
                        errorMessage: errorState.error.message ?? 'unknown'
                    }
                });
                setState(errorState);
            });
            return ()=>{
                abortController.abort();
            };
        }, [
            promiseToResolve
        ]);
        return state;
    };
});
parcelRegister("lzG7s", function(module, exports) {
    (function() {
        var undefined;
        var VERSION = '4.17.21';
        var LARGE_ARRAY_SIZE = 200;
        var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
        var HASH_UNDEFINED = '__lodash_hash_undefined__';
        var MAX_MEMOIZE_SIZE = 500;
        var PLACEHOLDER = '__lodash_placeholder__';
        var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
        var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
        var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
        var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
        var HOT_COUNT = 800, HOT_SPAN = 16;
        var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
        var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
        var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
        var wrapFlags = [
            [
                'ary',
                WRAP_ARY_FLAG
            ],
            [
                'bind',
                WRAP_BIND_FLAG
            ],
            [
                'bindKey',
                WRAP_BIND_KEY_FLAG
            ],
            [
                'curry',
                WRAP_CURRY_FLAG
            ],
            [
                'curryRight',
                WRAP_CURRY_RIGHT_FLAG
            ],
            [
                'flip',
                WRAP_FLIP_FLAG
            ],
            [
                'partial',
                WRAP_PARTIAL_FLAG
            ],
            [
                'partialRight',
                WRAP_PARTIAL_RIGHT_FLAG
            ],
            [
                'rearg',
                WRAP_REARG_FLAG
            ]
        ];
        var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
        var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
        var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
        var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
        var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
        var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
        var reTrimStart = /^\s+/;
        var reWhitespace = /\s/;
        var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
        var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
        var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
        var reEscapeChar = /\\(\\)?/g;
        var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
        var reFlags = /\w*$/;
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        var reIsBinary = /^0b[01]+$/i;
        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        var reIsOctal = /^0o[0-7]+$/i;
        var reIsUint = /^(?:0|[1-9]\d*)$/;
        var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        var reNoMatch = /($^)/;
        var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
        var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
        var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
        var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
            rsNonAstral,
            rsRegional,
            rsSurrPair
        ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
            rsDingbat,
            rsRegional,
            rsSurrPair
        ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
            rsNonAstral + rsCombo + '?',
            rsCombo,
            rsRegional,
            rsSurrPair,
            rsAstral
        ].join('|') + ')';
        var reApos = RegExp(rsApos, 'g');
        var reComboMark = RegExp(rsCombo, 'g');
        var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
        var reUnicodeWord = RegExp([
            rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
                rsBreak,
                rsUpper,
                '$'
            ].join('|') + ')',
            rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
                rsBreak,
                rsUpper + rsMiscLower,
                '$'
            ].join('|') + ')',
            rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
            rsUpper + '+' + rsOptContrUpper,
            rsOrdUpper,
            rsOrdLower,
            rsDigits,
            rsEmoji
        ].join('|'), 'g');
        var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
        var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
        var contextProps = [
            'Array',
            'Buffer',
            'DataView',
            'Date',
            'Error',
            'Float32Array',
            'Float64Array',
            'Function',
            'Int8Array',
            'Int16Array',
            'Int32Array',
            'Map',
            'Math',
            'Object',
            'Promise',
            'RegExp',
            'Set',
            'String',
            'Symbol',
            'TypeError',
            'Uint8Array',
            'Uint8ClampedArray',
            'Uint16Array',
            'Uint32Array',
            'WeakMap',
            '_',
            'clearTimeout',
            'isFinite',
            'parseInt',
            'setTimeout'
        ];
        var templateCounter = -1;
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        var cloneableTags = {};
        cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
        cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
        var deburredLetters = {
            '\xc0': 'A',
            '\xc1': 'A',
            '\xc2': 'A',
            '\xc3': 'A',
            '\xc4': 'A',
            '\xc5': 'A',
            '\xe0': 'a',
            '\xe1': 'a',
            '\xe2': 'a',
            '\xe3': 'a',
            '\xe4': 'a',
            '\xe5': 'a',
            '\xc7': 'C',
            '\xe7': 'c',
            '\xd0': 'D',
            '\xf0': 'd',
            '\xc8': 'E',
            '\xc9': 'E',
            '\xca': 'E',
            '\xcb': 'E',
            '\xe8': 'e',
            '\xe9': 'e',
            '\xea': 'e',
            '\xeb': 'e',
            '\xcc': 'I',
            '\xcd': 'I',
            '\xce': 'I',
            '\xcf': 'I',
            '\xec': 'i',
            '\xed': 'i',
            '\xee': 'i',
            '\xef': 'i',
            '\xd1': 'N',
            '\xf1': 'n',
            '\xd2': 'O',
            '\xd3': 'O',
            '\xd4': 'O',
            '\xd5': 'O',
            '\xd6': 'O',
            '\xd8': 'O',
            '\xf2': 'o',
            '\xf3': 'o',
            '\xf4': 'o',
            '\xf5': 'o',
            '\xf6': 'o',
            '\xf8': 'o',
            '\xd9': 'U',
            '\xda': 'U',
            '\xdb': 'U',
            '\xdc': 'U',
            '\xf9': 'u',
            '\xfa': 'u',
            '\xfb': 'u',
            '\xfc': 'u',
            '\xdd': 'Y',
            '\xfd': 'y',
            '\xff': 'y',
            '\xc6': 'Ae',
            '\xe6': 'ae',
            '\xde': 'Th',
            '\xfe': 'th',
            '\xdf': 'ss',
            '\u0100': 'A',
            '\u0102': 'A',
            '\u0104': 'A',
            '\u0101': 'a',
            '\u0103': 'a',
            '\u0105': 'a',
            '\u0106': 'C',
            '\u0108': 'C',
            '\u010a': 'C',
            '\u010c': 'C',
            '\u0107': 'c',
            '\u0109': 'c',
            '\u010b': 'c',
            '\u010d': 'c',
            '\u010e': 'D',
            '\u0110': 'D',
            '\u010f': 'd',
            '\u0111': 'd',
            '\u0112': 'E',
            '\u0114': 'E',
            '\u0116': 'E',
            '\u0118': 'E',
            '\u011a': 'E',
            '\u0113': 'e',
            '\u0115': 'e',
            '\u0117': 'e',
            '\u0119': 'e',
            '\u011b': 'e',
            '\u011c': 'G',
            '\u011e': 'G',
            '\u0120': 'G',
            '\u0122': 'G',
            '\u011d': 'g',
            '\u011f': 'g',
            '\u0121': 'g',
            '\u0123': 'g',
            '\u0124': 'H',
            '\u0126': 'H',
            '\u0125': 'h',
            '\u0127': 'h',
            '\u0128': 'I',
            '\u012a': 'I',
            '\u012c': 'I',
            '\u012e': 'I',
            '\u0130': 'I',
            '\u0129': 'i',
            '\u012b': 'i',
            '\u012d': 'i',
            '\u012f': 'i',
            '\u0131': 'i',
            '\u0134': 'J',
            '\u0135': 'j',
            '\u0136': 'K',
            '\u0137': 'k',
            '\u0138': 'k',
            '\u0139': 'L',
            '\u013b': 'L',
            '\u013d': 'L',
            '\u013f': 'L',
            '\u0141': 'L',
            '\u013a': 'l',
            '\u013c': 'l',
            '\u013e': 'l',
            '\u0140': 'l',
            '\u0142': 'l',
            '\u0143': 'N',
            '\u0145': 'N',
            '\u0147': 'N',
            '\u014a': 'N',
            '\u0144': 'n',
            '\u0146': 'n',
            '\u0148': 'n',
            '\u014b': 'n',
            '\u014c': 'O',
            '\u014e': 'O',
            '\u0150': 'O',
            '\u014d': 'o',
            '\u014f': 'o',
            '\u0151': 'o',
            '\u0154': 'R',
            '\u0156': 'R',
            '\u0158': 'R',
            '\u0155': 'r',
            '\u0157': 'r',
            '\u0159': 'r',
            '\u015a': 'S',
            '\u015c': 'S',
            '\u015e': 'S',
            '\u0160': 'S',
            '\u015b': 's',
            '\u015d': 's',
            '\u015f': 's',
            '\u0161': 's',
            '\u0162': 'T',
            '\u0164': 'T',
            '\u0166': 'T',
            '\u0163': 't',
            '\u0165': 't',
            '\u0167': 't',
            '\u0168': 'U',
            '\u016a': 'U',
            '\u016c': 'U',
            '\u016e': 'U',
            '\u0170': 'U',
            '\u0172': 'U',
            '\u0169': 'u',
            '\u016b': 'u',
            '\u016d': 'u',
            '\u016f': 'u',
            '\u0171': 'u',
            '\u0173': 'u',
            '\u0174': 'W',
            '\u0175': 'w',
            '\u0176': 'Y',
            '\u0177': 'y',
            '\u0178': 'Y',
            '\u0179': 'Z',
            '\u017b': 'Z',
            '\u017d': 'Z',
            '\u017a': 'z',
            '\u017c': 'z',
            '\u017e': 'z',
            '\u0132': 'IJ',
            '\u0133': 'ij',
            '\u0152': 'Oe',
            '\u0153': 'oe',
            '\u0149': "'n",
            '\u017f': 's'
        };
        var htmlEscapes = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        };
        var htmlUnescapes = {
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#39;': "'"
        };
        var stringEscapes = {
            '\\': '\\',
            "'": "'",
            '\n': 'n',
            '\r': 'r',
            '\u2028': 'u2028',
            '\u2029': 'u2029'
        };
        var freeParseFloat = parseFloat, freeParseInt = parseInt;
        var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function('return this')();
        var freeExports = exports && !exports.nodeType && exports;
        var freeModule = freeExports && true && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && freeGlobal.process;
        var nodeUtil = function() {
            try {
                var types = freeModule && freeModule.require && freeModule.require('util').types;
                if (types) return types;
                return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
        }();
        var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        function apply(func, thisArg, args) {
            switch(args.length){
                case 0:
                    return func.call(thisArg);
                case 1:
                    return func.call(thisArg, args[0]);
                case 2:
                    return func.call(thisArg, args[0], args[1]);
                case 3:
                    return func.call(thisArg, args[0], args[1], args[2]);
            }
            return func.apply(thisArg, args);
        }
        function arrayAggregator(array, setter, iteratee, accumulator) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                var value = array[index];
                setter(accumulator, value, iteratee(value), array);
            }
            return accumulator;
        }
        function arrayEach(array, iteratee) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        function arrayEachRight(array, iteratee) {
            var length = array == null ? 0 : array.length;
            while(length--){
                if (iteratee(array[length], length, array) === false) break;
            }
            return array;
        }
        function arrayEvery(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (!predicate(array[index], index, array)) return false;
            }
            return true;
        }
        function arrayFilter(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) result[resIndex++] = value;
            }
            return result;
        }
        function arrayIncludes(array, value) {
            var length = array == null ? 0 : array.length;
            return !!length && baseIndexOf(array, value, 0) > -1;
        }
        function arrayIncludesWith(array, value, comparator) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (comparator(value, array[index])) return true;
            }
            return false;
        }
        function arrayMap(array, iteratee) {
            var index = -1, length = array == null ? 0 : array.length, result = Array(length);
            while(++index < length)result[index] = iteratee(array[index], index, array);
            return result;
        }
        function arrayPush(array, values) {
            var index = -1, length = values.length, offset = array.length;
            while(++index < length)array[offset + index] = values[index];
            return array;
        }
        function arrayReduce(array, iteratee, accumulator, initAccum) {
            var index = -1, length = array == null ? 0 : array.length;
            if (initAccum && length) accumulator = array[++index];
            while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
            return accumulator;
        }
        function arrayReduceRight(array, iteratee, accumulator, initAccum) {
            var length = array == null ? 0 : array.length;
            if (initAccum && length) accumulator = array[--length];
            while(length--)accumulator = iteratee(accumulator, array[length], length, array);
            return accumulator;
        }
        function arraySome(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        var asciiSize = baseProperty('length');
        function asciiToArray(string) {
            return string.split('');
        }
        function asciiWords(string) {
            return string.match(reAsciiWord) || [];
        }
        function baseFindKey(collection, predicate, eachFunc) {
            var result;
            eachFunc(collection, function(value, key, collection) {
                if (predicate(value, key, collection)) {
                    result = key;
                    return false;
                }
            });
            return result;
        }
        function baseFindIndex(array, predicate, fromIndex, fromRight) {
            var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
            while(fromRight ? index-- : ++index < length){
                if (predicate(array[index], index, array)) return index;
            }
            return -1;
        }
        function baseIndexOf(array, value, fromIndex) {
            return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
        }
        function baseIndexOfWith(array, value, fromIndex, comparator) {
            var index = fromIndex - 1, length = array.length;
            while(++index < length){
                if (comparator(array[index], value)) return index;
            }
            return -1;
        }
        function baseIsNaN(value) {
            return value !== value;
        }
        function baseMean(array, iteratee) {
            var length = array == null ? 0 : array.length;
            return length ? baseSum(array, iteratee) / length : NAN;
        }
        function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        function basePropertyOf(object) {
            return function(key) {
                return object == null ? undefined : object[key];
            };
        }
        function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
            eachFunc(collection, function(value, index, collection) {
                accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
            });
            return accumulator;
        }
        function baseSortBy(array, comparer) {
            var length = array.length;
            array.sort(comparer);
            while(length--)array[length] = array[length].value;
            return array;
        }
        function baseSum(array, iteratee) {
            var result, index = -1, length = array.length;
            while(++index < length){
                var current = iteratee(array[index]);
                if (current !== undefined) result = result === undefined ? current : result + current;
            }
            return result;
        }
        function baseTimes(n, iteratee) {
            var index = -1, result = Array(n);
            while(++index < n)result[index] = iteratee(index);
            return result;
        }
        function baseToPairs(object, props) {
            return arrayMap(props, function(key) {
                return [
                    key,
                    object[key]
                ];
            });
        }
        function baseTrim(string) {
            return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
        }
        function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        function baseValues(object, props) {
            return arrayMap(props, function(key) {
                return object[key];
            });
        }
        function cacheHas(cache, key) {
            return cache.has(key);
        }
        function charsStartIndex(strSymbols, chrSymbols) {
            var index = -1, length = strSymbols.length;
            while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
            return index;
        }
        function charsEndIndex(strSymbols, chrSymbols) {
            var index = strSymbols.length;
            while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
            return index;
        }
        function countHolders(array, placeholder) {
            var length = array.length, result = 0;
            while(length--)if (array[length] === placeholder) ++result;
            return result;
        }
        var deburrLetter = basePropertyOf(deburredLetters);
        var escapeHtmlChar = basePropertyOf(htmlEscapes);
        function escapeStringChar(chr) {
            return '\\' + stringEscapes[chr];
        }
        function getValue(object, key) {
            return object == null ? undefined : object[key];
        }
        function hasUnicode(string) {
            return reHasUnicode.test(string);
        }
        function hasUnicodeWord(string) {
            return reHasUnicodeWord.test(string);
        }
        function iteratorToArray(iterator) {
            var data, result = [];
            while(!(data = iterator.next()).done)result.push(data.value);
            return result;
        }
        function mapToArray(map) {
            var index = -1, result = Array(map.size);
            map.forEach(function(value, key) {
                result[++index] = [
                    key,
                    value
                ];
            });
            return result;
        }
        function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        function replaceHolders(array, placeholder) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value === placeholder || value === PLACEHOLDER) {
                    array[index] = PLACEHOLDER;
                    result[resIndex++] = index;
                }
            }
            return result;
        }
        function setToArray(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = value;
            });
            return result;
        }
        function setToPairs(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = [
                    value,
                    value
                ];
            });
            return result;
        }
        function strictIndexOf(array, value, fromIndex) {
            var index = fromIndex - 1, length = array.length;
            while(++index < length){
                if (array[index] === value) return index;
            }
            return -1;
        }
        function strictLastIndexOf(array, value, fromIndex) {
            var index = fromIndex + 1;
            while(index--){
                if (array[index] === value) return index;
            }
            return index;
        }
        function stringSize(string) {
            return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
        }
        function stringToArray(string) {
            return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
        }
        function trimmedEndIndex(string) {
            var index = string.length;
            while(index-- && reWhitespace.test(string.charAt(index)));
            return index;
        }
        var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
        function unicodeSize(string) {
            var result = reUnicode.lastIndex = 0;
            while(reUnicode.test(string))++result;
            return result;
        }
        function unicodeToArray(string) {
            return string.match(reUnicode) || [];
        }
        function unicodeWords(string) {
            return string.match(reUnicodeWord) || [];
        }
        var runInContext = function runInContext(context) {
            context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
            var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
            var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
            var coreJsData = context['__core-js_shared__'];
            var funcToString = funcProto.toString;
            var hasOwnProperty = objectProto.hasOwnProperty;
            var idCounter = 0;
            var maskSrcKey = function() {
                var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
                return uid ? 'Symbol(src)_1.' + uid : '';
            }();
            var nativeObjectToString = objectProto.toString;
            var objectCtorString = funcToString.call(Object1);
            var oldDash = root._;
            var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
            var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
            var defineProperty = function() {
                try {
                    var func = getNative(Object1, 'defineProperty');
                    func({}, '', {});
                    return func;
                } catch (e) {}
            }();
            var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
            var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
            var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
            var metaMap = WeakMap && new WeakMap;
            var realNames = {};
            var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
            var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
            function lodash(value) {
                if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                    if (value instanceof LodashWrapper) return value;
                    if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
                }
                return new LodashWrapper(value);
            }
            var baseCreate = function() {
                function object() {}
                return function(proto) {
                    if (!isObject(proto)) return {};
                    if (objectCreate) return objectCreate(proto);
                    object.prototype = proto;
                    var result = new object;
                    object.prototype = undefined;
                    return result;
                };
            }();
            function baseLodash() {}
            function LodashWrapper(value, chainAll) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__chain__ = !!chainAll;
                this.__index__ = 0;
                this.__values__ = undefined;
            }
            lodash.templateSettings = {
                'escape': reEscape,
                'evaluate': reEvaluate,
                'interpolate': reInterpolate,
                'variable': '',
                'imports': {
                    '_': lodash
                }
            };
            lodash.prototype = baseLodash.prototype;
            lodash.prototype.constructor = lodash;
            LodashWrapper.prototype = baseCreate(baseLodash.prototype);
            LodashWrapper.prototype.constructor = LodashWrapper;
            function LazyWrapper(value) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__dir__ = 1;
                this.__filtered__ = false;
                this.__iteratees__ = [];
                this.__takeCount__ = MAX_ARRAY_LENGTH;
                this.__views__ = [];
            }
            function lazyClone() {
                var result = new LazyWrapper(this.__wrapped__);
                result.__actions__ = copyArray(this.__actions__);
                result.__dir__ = this.__dir__;
                result.__filtered__ = this.__filtered__;
                result.__iteratees__ = copyArray(this.__iteratees__);
                result.__takeCount__ = this.__takeCount__;
                result.__views__ = copyArray(this.__views__);
                return result;
            }
            function lazyReverse() {
                if (this.__filtered__) {
                    var result = new LazyWrapper(this);
                    result.__dir__ = -1;
                    result.__filtered__ = true;
                } else {
                    result = this.clone();
                    result.__dir__ *= -1;
                }
                return result;
            }
            function lazyValue() {
                var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
                if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
                var result = [];
                outer: while(length-- && resIndex < takeCount){
                    index += dir;
                    var iterIndex = -1, value = array[index];
                    while(++iterIndex < iterLength){
                        var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                        if (type == LAZY_MAP_FLAG) value = computed;
                        else if (!computed) {
                            if (type == LAZY_FILTER_FLAG) continue outer;
                            else break outer;
                        }
                    }
                    result[resIndex++] = value;
                }
                return result;
            }
            LazyWrapper.prototype = baseCreate(baseLodash.prototype);
            LazyWrapper.prototype.constructor = LazyWrapper;
            function Hash(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function hashClear() {
                this.__data__ = nativeCreate ? nativeCreate(null) : {};
                this.size = 0;
            }
            function hashDelete(key) {
                var result = this.has(key) && delete this.__data__[key];
                this.size -= result ? 1 : 0;
                return result;
            }
            function hashGet(key) {
                var data = this.__data__;
                if (nativeCreate) {
                    var result = data[key];
                    return result === HASH_UNDEFINED ? undefined : result;
                }
                return hasOwnProperty.call(data, key) ? data[key] : undefined;
            }
            function hashHas(key) {
                var data = this.__data__;
                return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
            }
            function hashSet(key, value) {
                var data = this.__data__;
                this.size += this.has(key) ? 0 : 1;
                data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                return this;
            }
            Hash.prototype.clear = hashClear;
            Hash.prototype['delete'] = hashDelete;
            Hash.prototype.get = hashGet;
            Hash.prototype.has = hashHas;
            Hash.prototype.set = hashSet;
            function ListCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function listCacheClear() {
                this.__data__ = [];
                this.size = 0;
            }
            function listCacheDelete(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) return false;
                var lastIndex = data.length - 1;
                if (index == lastIndex) data.pop();
                else splice.call(data, index, 1);
                --this.size;
                return true;
            }
            function listCacheGet(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                return index < 0 ? undefined : data[index][1];
            }
            function listCacheHas(key) {
                return assocIndexOf(this.__data__, key) > -1;
            }
            function listCacheSet(key, value) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) {
                    ++this.size;
                    data.push([
                        key,
                        value
                    ]);
                } else data[index][1] = value;
                return this;
            }
            ListCache.prototype.clear = listCacheClear;
            ListCache.prototype['delete'] = listCacheDelete;
            ListCache.prototype.get = listCacheGet;
            ListCache.prototype.has = listCacheHas;
            ListCache.prototype.set = listCacheSet;
            function MapCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function mapCacheClear() {
                this.size = 0;
                this.__data__ = {
                    'hash': new Hash,
                    'map': new (Map || ListCache),
                    'string': new Hash
                };
            }
            function mapCacheDelete(key) {
                var result = getMapData(this, key)['delete'](key);
                this.size -= result ? 1 : 0;
                return result;
            }
            function mapCacheGet(key) {
                return getMapData(this, key).get(key);
            }
            function mapCacheHas(key) {
                return getMapData(this, key).has(key);
            }
            function mapCacheSet(key, value) {
                var data = getMapData(this, key), size = data.size;
                data.set(key, value);
                this.size += data.size == size ? 0 : 1;
                return this;
            }
            MapCache.prototype.clear = mapCacheClear;
            MapCache.prototype['delete'] = mapCacheDelete;
            MapCache.prototype.get = mapCacheGet;
            MapCache.prototype.has = mapCacheHas;
            MapCache.prototype.set = mapCacheSet;
            function SetCache(values) {
                var index = -1, length = values == null ? 0 : values.length;
                this.__data__ = new MapCache;
                while(++index < length)this.add(values[index]);
            }
            function setCacheAdd(value) {
                this.__data__.set(value, HASH_UNDEFINED);
                return this;
            }
            function setCacheHas(value) {
                return this.__data__.has(value);
            }
            SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
            SetCache.prototype.has = setCacheHas;
            function Stack(entries) {
                var data = this.__data__ = new ListCache(entries);
                this.size = data.size;
            }
            function stackClear() {
                this.__data__ = new ListCache;
                this.size = 0;
            }
            function stackDelete(key) {
                var data = this.__data__, result = data['delete'](key);
                this.size = data.size;
                return result;
            }
            function stackGet(key) {
                return this.__data__.get(key);
            }
            function stackHas(key) {
                return this.__data__.has(key);
            }
            function stackSet(key, value) {
                var data = this.__data__;
                if (data instanceof ListCache) {
                    var pairs = data.__data__;
                    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                        pairs.push([
                            key,
                            value
                        ]);
                        this.size = ++data.size;
                        return this;
                    }
                    data = this.__data__ = new MapCache(pairs);
                }
                data.set(key, value);
                this.size = data.size;
                return this;
            }
            Stack.prototype.clear = stackClear;
            Stack.prototype['delete'] = stackDelete;
            Stack.prototype.get = stackGet;
            Stack.prototype.has = stackHas;
            Stack.prototype.set = stackSet;
            function arrayLikeKeys(value, inherited) {
                var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
                for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || isIndex(key, length)))) result.push(key);
                return result;
            }
            function arraySample(array) {
                var length = array.length;
                return length ? array[baseRandom(0, length - 1)] : undefined;
            }
            function arraySampleSize(array, n) {
                return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
            }
            function arrayShuffle(array) {
                return shuffleSelf(copyArray(array));
            }
            function assignMergeValue(object, key, value) {
                if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            function assignValue(object, key, value) {
                var objValue = object[key];
                if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            function assocIndexOf(array, key) {
                var length = array.length;
                while(length--){
                    if (eq(array[length][0], key)) return length;
                }
                return -1;
            }
            function baseAggregator(collection, setter, iteratee, accumulator) {
                baseEach(collection, function(value, key, collection) {
                    setter(accumulator, value, iteratee(value), collection);
                });
                return accumulator;
            }
            function baseAssign(object, source) {
                return object && copyObject(source, keys(source), object);
            }
            function baseAssignIn(object, source) {
                return object && copyObject(source, keysIn(source), object);
            }
            function baseAssignValue(object, key, value) {
                if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                    'configurable': true,
                    'enumerable': true,
                    'value': value,
                    'writable': true
                });
                else object[key] = value;
            }
            function baseAt(object, paths) {
                var index = -1, length = paths.length, result = Array1(length), skip = object == null;
                while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
                return result;
            }
            function baseClamp(number, lower, upper) {
                if (number === number) {
                    if (upper !== undefined) number = number <= upper ? number : upper;
                    if (lower !== undefined) number = number >= lower ? number : lower;
                }
                return number;
            }
            function baseClone(value, bitmask, customizer, key, object, stack) {
                var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
                if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
                if (result !== undefined) return result;
                if (!isObject(value)) return value;
                var isArr = isArray(value);
                if (isArr) {
                    result = initCloneArray(value);
                    if (!isDeep) return copyArray(value, result);
                } else {
                    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                    if (isBuffer(value)) return cloneBuffer(value, isDeep);
                    if (tag == objectTag || tag == argsTag || isFunc && !object) {
                        result = isFlat || isFunc ? {} : initCloneObject(value);
                        if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                    } else {
                        if (!cloneableTags[tag]) return object ? value : {};
                        result = initCloneByTag(value, tag, isDeep);
                    }
                }
                stack || (stack = new Stack);
                var stacked = stack.get(value);
                if (stacked) return stacked;
                stack.set(value, result);
                if (isSet(value)) value.forEach(function(subValue) {
                    result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
                });
                else if (isMap(value)) value.forEach(function(subValue, key) {
                    result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
                var props = isArr ? undefined : keysFunc(value);
                arrayEach(props || value, function(subValue, key) {
                    if (props) {
                        key = subValue;
                        subValue = value[key];
                    }
                    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                return result;
            }
            function baseConforms(source) {
                var props = keys(source);
                return function(object) {
                    return baseConformsTo(object, source, props);
                };
            }
            function baseConformsTo(object, source, props) {
                var length = props.length;
                if (object == null) return !length;
                object = Object1(object);
                while(length--){
                    var key = props[length], predicate = source[key], value = object[key];
                    if (value === undefined && !(key in object) || !predicate(value)) return false;
                }
                return true;
            }
            function baseDelay(func, wait, args) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return setTimeout(function() {
                    func.apply(undefined, args);
                }, wait);
            }
            function baseDifference(array, values, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
                if (!length) return result;
                if (iteratee) values = arrayMap(values, baseUnary(iteratee));
                if (comparator) {
                    includes = arrayIncludesWith;
                    isCommon = false;
                } else if (values.length >= LARGE_ARRAY_SIZE) {
                    includes = cacheHas;
                    isCommon = false;
                    values = new SetCache(values);
                }
                outer: while(++index < length){
                    var value = array[index], computed = iteratee == null ? value : iteratee(value);
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var valuesIndex = valuesLength;
                        while(valuesIndex--){
                            if (values[valuesIndex] === computed) continue outer;
                        }
                        result.push(value);
                    } else if (!includes(values, computed, comparator)) result.push(value);
                }
                return result;
            }
            var baseEach = createBaseEach(baseForOwn);
            var baseEachRight = createBaseEach(baseForOwnRight, true);
            function baseEvery(collection, predicate) {
                var result = true;
                baseEach(collection, function(value, index, collection) {
                    result = !!predicate(value, index, collection);
                    return result;
                });
                return result;
            }
            function baseExtremum(array, iteratee, comparator) {
                var index = -1, length = array.length;
                while(++index < length){
                    var value = array[index], current = iteratee(value);
                    if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
                }
                return result;
            }
            function baseFill(array, value, start, end) {
                var length = array.length;
                start = toInteger(start);
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end === undefined || end > length ? length : toInteger(end);
                if (end < 0) end += length;
                end = start > end ? 0 : toLength(end);
                while(start < end)array[start++] = value;
                return array;
            }
            function baseFilter(collection, predicate) {
                var result = [];
                baseEach(collection, function(value, index, collection) {
                    if (predicate(value, index, collection)) result.push(value);
                });
                return result;
            }
            function baseFlatten(array, depth, predicate, isStrict, result) {
                var index = -1, length = array.length;
                predicate || (predicate = isFlattenable);
                result || (result = []);
                while(++index < length){
                    var value = array[index];
                    if (depth > 0 && predicate(value)) {
                        if (depth > 1) baseFlatten(value, depth - 1, predicate, isStrict, result);
                        else arrayPush(result, value);
                    } else if (!isStrict) result[result.length] = value;
                }
                return result;
            }
            var baseFor = createBaseFor();
            var baseForRight = createBaseFor(true);
            function baseForOwn(object, iteratee) {
                return object && baseFor(object, iteratee, keys);
            }
            function baseForOwnRight(object, iteratee) {
                return object && baseForRight(object, iteratee, keys);
            }
            function baseFunctions(object, props) {
                return arrayFilter(props, function(key) {
                    return isFunction(object[key]);
                });
            }
            function baseGet(object, path) {
                path = castPath(path, object);
                var index = 0, length = path.length;
                while(object != null && index < length)object = object[toKey(path[index++])];
                return index && index == length ? object : undefined;
            }
            function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                var result = keysFunc(object);
                return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
            }
            function baseGetTag(value) {
                if (value == null) return value === undefined ? undefinedTag : nullTag;
                return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
            }
            function baseGt(value, other) {
                return value > other;
            }
            function baseHas(object, key) {
                return object != null && hasOwnProperty.call(object, key);
            }
            function baseHasIn(object, key) {
                return object != null && key in Object1(object);
            }
            function baseInRange(number, start, end) {
                return number >= nativeMin(start, end) && number < nativeMax(start, end);
            }
            function baseIntersection(arrays, iteratee, comparator) {
                var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
                while(othIndex--){
                    var array = arrays[othIndex];
                    if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                    maxLength = nativeMin(array.length, maxLength);
                    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
                }
                array = arrays[0];
                var index = -1, seen = caches[0];
                outer: while(++index < length && result.length < maxLength){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                        othIndex = othLength;
                        while(--othIndex){
                            var cache = caches[othIndex];
                            if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                        }
                        if (seen) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            function baseInverter(object, setter, iteratee, accumulator) {
                baseForOwn(object, function(value, key, object) {
                    setter(accumulator, iteratee(value), key, object);
                });
                return accumulator;
            }
            function baseInvoke(object, path, args) {
                path = castPath(path, object);
                object = parent(object, path);
                var func = object == null ? object : object[toKey(last(path))];
                return func == null ? undefined : apply(func, object, args);
            }
            function baseIsArguments(value) {
                return isObjectLike(value) && baseGetTag(value) == argsTag;
            }
            function baseIsArrayBuffer(value) {
                return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
            }
            function baseIsDate(value) {
                return isObjectLike(value) && baseGetTag(value) == dateTag;
            }
            function baseIsEqual(value, other, bitmask, customizer, stack) {
                if (value === other) return true;
                if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
                return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
            }
            function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
                var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
                objTag = objTag == argsTag ? objectTag : objTag;
                othTag = othTag == argsTag ? objectTag : othTag;
                var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
                if (isSameTag && isBuffer(object)) {
                    if (!isBuffer(other)) return false;
                    objIsArr = true;
                    objIsObj = false;
                }
                if (isSameTag && !objIsObj) {
                    stack || (stack = new Stack);
                    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                }
                if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                    if (objIsWrapped || othIsWrapped) {
                        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                        stack || (stack = new Stack);
                        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                    }
                }
                if (!isSameTag) return false;
                stack || (stack = new Stack);
                return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
            }
            function baseIsMap(value) {
                return isObjectLike(value) && getTag(value) == mapTag;
            }
            function baseIsMatch(object, source, matchData, customizer) {
                var index = matchData.length, length = index, noCustomizer = !customizer;
                if (object == null) return !length;
                object = Object1(object);
                while(index--){
                    var data = matchData[index];
                    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
                }
                while(++index < length){
                    data = matchData[index];
                    var key = data[0], objValue = object[key], srcValue = data[1];
                    if (noCustomizer && data[2]) {
                        if (objValue === undefined && !(key in object)) return false;
                    } else {
                        var stack = new Stack;
                        if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                    }
                }
                return true;
            }
            function baseIsNative(value) {
                if (!isObject(value) || isMasked(value)) return false;
                var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                return pattern.test(toSource(value));
            }
            function baseIsRegExp(value) {
                return isObjectLike(value) && baseGetTag(value) == regexpTag;
            }
            function baseIsSet(value) {
                return isObjectLike(value) && getTag(value) == setTag;
            }
            function baseIsTypedArray(value) {
                return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
            }
            function baseIteratee(value) {
                if (typeof value == 'function') return value;
                if (value == null) return identity;
                if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                return property(value);
            }
            function baseKeys(object) {
                if (!isPrototype(object)) return nativeKeys(object);
                var result = [];
                for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
                return result;
            }
            function baseKeysIn(object) {
                if (!isObject(object)) return nativeKeysIn(object);
                var isProto = isPrototype(object), result = [];
                for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
                return result;
            }
            function baseLt(value, other) {
                return value < other;
            }
            function baseMap(collection, iteratee) {
                var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
                baseEach(collection, function(value, key, collection) {
                    result[++index] = iteratee(value, key, collection);
                });
                return result;
            }
            function baseMatches(source) {
                var matchData = getMatchData(source);
                if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                return function(object) {
                    return object === source || baseIsMatch(object, source, matchData);
                };
            }
            function baseMatchesProperty(path, srcValue) {
                if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
                return function(object) {
                    var objValue = get(object, path);
                    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
                };
            }
            function baseMerge(object, source, srcIndex, customizer, stack) {
                if (object === source) return;
                baseFor(source, function(srcValue, key) {
                    stack || (stack = new Stack);
                    if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                    else {
                        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                        if (newValue === undefined) newValue = srcValue;
                        assignMergeValue(object, key, newValue);
                    }
                }, keysIn);
            }
            function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
                var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
                if (stacked) {
                    assignMergeValue(object, key, stacked);
                    return;
                }
                var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
                var isCommon = newValue === undefined;
                if (isCommon) {
                    var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                    newValue = srcValue;
                    if (isArr || isBuff || isTyped) {
                        if (isArray(objValue)) newValue = objValue;
                        else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                        else if (isBuff) {
                            isCommon = false;
                            newValue = cloneBuffer(srcValue, true);
                        } else if (isTyped) {
                            isCommon = false;
                            newValue = cloneTypedArray(srcValue, true);
                        } else newValue = [];
                    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                        newValue = objValue;
                        if (isArguments(objValue)) newValue = toPlainObject(objValue);
                        else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                    } else isCommon = false;
                }
                if (isCommon) {
                    stack.set(srcValue, newValue);
                    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                    stack['delete'](srcValue);
                }
                assignMergeValue(object, key, newValue);
            }
            function baseNth(array, n) {
                var length = array.length;
                if (!length) return;
                n += n < 0 ? length : 0;
                return isIndex(n, length) ? array[n] : undefined;
            }
            function baseOrderBy(collection, iteratees, orders) {
                if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                    if (isArray(iteratee)) return function(value) {
                        return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                    };
                    return iteratee;
                });
                else iteratees = [
                    identity
                ];
                var index = -1;
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                var result = baseMap(collection, function(value, key, collection) {
                    var criteria = arrayMap(iteratees, function(iteratee) {
                        return iteratee(value);
                    });
                    return {
                        'criteria': criteria,
                        'index': ++index,
                        'value': value
                    };
                });
                return baseSortBy(result, function(object, other) {
                    return compareMultiple(object, other, orders);
                });
            }
            function basePick(object, paths) {
                return basePickBy(object, paths, function(value, path) {
                    return hasIn(object, path);
                });
            }
            function basePickBy(object, paths, predicate) {
                var index = -1, length = paths.length, result = {};
                while(++index < length){
                    var path = paths[index], value = baseGet(object, path);
                    if (predicate(value, path)) baseSet(result, castPath(path, object), value);
                }
                return result;
            }
            function basePropertyDeep(path) {
                return function(object) {
                    return baseGet(object, path);
                };
            }
            function basePullAll(array, values, iteratee, comparator) {
                var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
                if (array === values) values = copyArray(values);
                if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
                while(++index < length){
                    var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                    while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                        if (seen !== array) splice.call(seen, fromIndex, 1);
                        splice.call(array, fromIndex, 1);
                    }
                }
                return array;
            }
            function basePullAt(array, indexes) {
                var length = array ? indexes.length : 0, lastIndex = length - 1;
                while(length--){
                    var index = indexes[length];
                    if (length == lastIndex || index !== previous) {
                        var previous = index;
                        if (isIndex(index)) splice.call(array, index, 1);
                        else baseUnset(array, index);
                    }
                }
                return array;
            }
            function baseRandom(lower, upper) {
                return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
            }
            function baseRange(start, end, step, fromRight) {
                var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
                while(length--){
                    result[fromRight ? length : ++index] = start;
                    start += step;
                }
                return result;
            }
            function baseRepeat(string, n) {
                var result = '';
                if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
                do {
                    if (n % 2) result += string;
                    n = nativeFloor(n / 2);
                    if (n) string += string;
                }while (n)
                return result;
            }
            function baseRest(func, start) {
                return setToString(overRest(func, start, identity), func + '');
            }
            function baseSample(collection) {
                return arraySample(values(collection));
            }
            function baseSampleSize(collection, n) {
                var array = values(collection);
                return shuffleSelf(array, baseClamp(n, 0, array.length));
            }
            function baseSet(object, path, value, customizer) {
                if (!isObject(object)) return object;
                path = castPath(path, object);
                var index = -1, length = path.length, lastIndex = length - 1, nested = object;
                while(nested != null && ++index < length){
                    var key = toKey(path[index]), newValue = value;
                    if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                    if (index != lastIndex) {
                        var objValue = nested[key];
                        newValue = customizer ? customizer(objValue, key, nested) : undefined;
                        if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                    }
                    assignValue(nested, key, newValue);
                    nested = nested[key];
                }
                return object;
            }
            var baseSetData = !metaMap ? identity : function(func, data) {
                metaMap.set(func, data);
                return func;
            };
            var baseSetToString = !defineProperty ? identity : function(func, string) {
                return defineProperty(func, 'toString', {
                    'configurable': true,
                    'enumerable': false,
                    'value': constant(string),
                    'writable': true
                });
            };
            function baseShuffle(collection) {
                return shuffleSelf(values(collection));
            }
            function baseSlice(array, start, end) {
                var index = -1, length = array.length;
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end > length ? length : end;
                if (end < 0) end += length;
                length = start > end ? 0 : end - start >>> 0;
                start >>>= 0;
                var result = Array1(length);
                while(++index < length)result[index] = array[index + start];
                return result;
            }
            function baseSome(collection, predicate) {
                var result;
                baseEach(collection, function(value, index, collection) {
                    result = predicate(value, index, collection);
                    return !result;
                });
                return !!result;
            }
            function baseSortedIndex(array, value, retHighest) {
                var low = 0, high = array == null ? low : array.length;
                if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                    while(low < high){
                        var mid = low + high >>> 1, computed = array[mid];
                        if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                        else high = mid;
                    }
                    return high;
                }
                return baseSortedIndexBy(array, value, identity, retHighest);
            }
            function baseSortedIndexBy(array, value, iteratee, retHighest) {
                var low = 0, high = array == null ? 0 : array.length;
                if (high === 0) return 0;
                value = iteratee(value);
                var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
                while(low < high){
                    var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                    if (valIsNaN) var setLow = retHighest || othIsReflexive;
                    else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                    else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                    else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                    else if (othIsNull || othIsSymbol) setLow = false;
                    else setLow = retHighest ? computed <= value : computed < value;
                    if (setLow) low = mid + 1;
                    else high = mid;
                }
                return nativeMin(high, MAX_ARRAY_INDEX);
            }
            function baseSortedUniq(array, iteratee) {
                var index = -1, length = array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    if (!index || !eq(computed, seen)) {
                        var seen = computed;
                        result[resIndex++] = value === 0 ? 0 : value;
                    }
                }
                return result;
            }
            function baseToNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                return +value;
            }
            function baseToString(value) {
                if (typeof value == 'string') return value;
                if (isArray(value)) return arrayMap(value, baseToString) + '';
                if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            function baseUniq(array, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
                if (comparator) {
                    isCommon = false;
                    includes = arrayIncludesWith;
                } else if (length >= LARGE_ARRAY_SIZE) {
                    var set = iteratee ? null : createSet(array);
                    if (set) return setToArray(set);
                    isCommon = false;
                    includes = cacheHas;
                    seen = new SetCache;
                } else seen = iteratee ? [] : result;
                outer: while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var seenIndex = seen.length;
                        while(seenIndex--){
                            if (seen[seenIndex] === computed) continue outer;
                        }
                        if (iteratee) seen.push(computed);
                        result.push(value);
                    } else if (!includes(seen, computed, comparator)) {
                        if (seen !== result) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            function baseUnset(object, path) {
                path = castPath(path, object);
                object = parent(object, path);
                return object == null || delete object[toKey(last(path))];
            }
            function baseUpdate(object, path, updater, customizer) {
                return baseSet(object, path, updater(baseGet(object, path)), customizer);
            }
            function baseWhile(array, predicate, isDrop, fromRight) {
                var length = array.length, index = fromRight ? length : -1;
                while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
                return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
            }
            function baseWrapperValue(value, actions) {
                var result = value;
                if (result instanceof LazyWrapper) result = result.value();
                return arrayReduce(actions, function(result, action) {
                    return action.func.apply(action.thisArg, arrayPush([
                        result
                    ], action.args));
                }, result);
            }
            function baseXor(arrays, iteratee, comparator) {
                var length = arrays.length;
                if (length < 2) return length ? baseUniq(arrays[0]) : [];
                var index = -1, result = Array1(length);
                while(++index < length){
                    var array = arrays[index], othIndex = -1;
                    while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
                }
                return baseUniq(baseFlatten(result, 1), iteratee, comparator);
            }
            function baseZipObject(props, values, assignFunc) {
                var index = -1, length = props.length, valsLength = values.length, result = {};
                while(++index < length){
                    var value = index < valsLength ? values[index] : undefined;
                    assignFunc(result, props[index], value);
                }
                return result;
            }
            function castArrayLikeObject(value) {
                return isArrayLikeObject(value) ? value : [];
            }
            function castFunction(value) {
                return typeof value == 'function' ? value : identity;
            }
            function castPath(value, object) {
                if (isArray(value)) return value;
                return isKey(value, object) ? [
                    value
                ] : stringToPath(toString(value));
            }
            var castRest = baseRest;
            function castSlice(array, start, end) {
                var length = array.length;
                end = end === undefined ? length : end;
                return !start && end >= length ? array : baseSlice(array, start, end);
            }
            var clearTimeout = ctxClearTimeout || function(id) {
                return root.clearTimeout(id);
            };
            function cloneBuffer(buffer, isDeep) {
                if (isDeep) return buffer.slice();
                var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
                buffer.copy(result);
                return result;
            }
            function cloneArrayBuffer(arrayBuffer) {
                var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
                new Uint8Array(result).set(new Uint8Array(arrayBuffer));
                return result;
            }
            function cloneDataView(dataView, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
                return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
            }
            function cloneRegExp(regexp) {
                var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
                result.lastIndex = regexp.lastIndex;
                return result;
            }
            function cloneSymbol(symbol) {
                return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
            }
            function cloneTypedArray(typedArray, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
                return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
            }
            function compareAscending(value, other) {
                if (value !== other) {
                    var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                    var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
                }
                return 0;
            }
            function compareMultiple(object, other, orders) {
                var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
                while(++index < length){
                    var result = compareAscending(objCriteria[index], othCriteria[index]);
                    if (result) {
                        if (index >= ordersLength) return result;
                        var order = orders[index];
                        return result * (order == 'desc' ? -1 : 1);
                    }
                }
                return object.index - other.index;
            }
            function composeArgs(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
                while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
                while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
                while(rangeLength--)result[leftIndex++] = args[argsIndex++];
                return result;
            }
            function composeArgsRight(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
                while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
                var offset = argsIndex;
                while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
                while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
                return result;
            }
            function copyArray(source, array) {
                var index = -1, length = source.length;
                array || (array = Array1(length));
                while(++index < length)array[index] = source[index];
                return array;
            }
            function copyObject(source, props, object, customizer) {
                var isNew = !object;
                object || (object = {});
                var index = -1, length = props.length;
                while(++index < length){
                    var key = props[index];
                    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                    if (newValue === undefined) newValue = source[key];
                    if (isNew) baseAssignValue(object, key, newValue);
                    else assignValue(object, key, newValue);
                }
                return object;
            }
            function copySymbols(source, object) {
                return copyObject(source, getSymbols(source), object);
            }
            function copySymbolsIn(source, object) {
                return copyObject(source, getSymbolsIn(source), object);
            }
            function createAggregator(setter, initializer) {
                return function(collection, iteratee) {
                    var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                    return func(collection, setter, getIteratee(iteratee, 2), accumulator);
                };
            }
            function createAssigner(assigner) {
                return baseRest(function(object, sources) {
                    var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                        customizer = length < 3 ? undefined : customizer;
                        length = 1;
                    }
                    object = Object1(object);
                    while(++index < length){
                        var source = sources[index];
                        if (source) assigner(object, source, index, customizer);
                    }
                    return object;
                });
            }
            function createBaseEach(eachFunc, fromRight) {
                return function(collection, iteratee) {
                    if (collection == null) return collection;
                    if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                    var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                    while(fromRight ? index-- : ++index < length){
                        if (iteratee(iterable[index], index, iterable) === false) break;
                    }
                    return collection;
                };
            }
            function createBaseFor(fromRight) {
                return function(object, iteratee, keysFunc) {
                    var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                    while(length--){
                        var key = props[fromRight ? length : ++index];
                        if (iteratee(iterable[key], key, iterable) === false) break;
                    }
                    return object;
                };
            }
            function createBind(func, bitmask, thisArg) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return fn.apply(isBind ? thisArg : this, arguments);
                }
                return wrapper;
            }
            function createCaseFirst(methodName) {
                return function(string) {
                    string = toString(string);
                    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                    return chr[methodName]() + trailing;
                };
            }
            function createCompounder(callback) {
                return function(string) {
                    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
                };
            }
            function createCtor(Ctor) {
                return function() {
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return new Ctor;
                        case 1:
                            return new Ctor(args[0]);
                        case 2:
                            return new Ctor(args[0], args[1]);
                        case 3:
                            return new Ctor(args[0], args[1], args[2]);
                        case 4:
                            return new Ctor(args[0], args[1], args[2], args[3]);
                        case 5:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                        case 6:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                        case 7:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                    }
                    var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                    return isObject(result) ? result : thisBinding;
                };
            }
            function createCurry(func, bitmask, arity) {
                var Ctor = createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                    while(index--)args[index] = arguments[index];
                    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                    length -= holders.length;
                    if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return apply(fn, this, args);
                }
                return wrapper;
            }
            function createFind(findIndexFunc) {
                return function(collection, predicate, fromIndex) {
                    var iterable = Object1(collection);
                    if (!isArrayLike(collection)) {
                        var iteratee = getIteratee(predicate, 3);
                        collection = keys(collection);
                        predicate = function(key) {
                            return iteratee(iterable[key], key, iterable);
                        };
                    }
                    var index = findIndexFunc(collection, predicate, fromIndex);
                    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
                };
            }
            function createFlow(fromRight) {
                return flatRest(function(funcs) {
                    var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                    if (fromRight) funcs.reverse();
                    while(index--){
                        var func = funcs[index];
                        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                        if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                    }
                    index = wrapper ? index : length;
                    while(++index < length){
                        func = funcs[index];
                        var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                        if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                        else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                    }
                    return function() {
                        var args = arguments, value = args[0];
                        if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                        var index = 0, result = length ? funcs[index].apply(this, args) : value;
                        while(++index < length)result = funcs[index].call(this, result);
                        return result;
                    };
                });
            }
            function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
                var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array1(length), index = length;
                    while(index--)args[index] = arguments[index];
                    if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                    if (partials) args = composeArgs(args, partials, holders, isCurried);
                    if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                    length -= holdersCount;
                    if (isCurried && length < arity) {
                        var newHolders = replaceHolders(args, placeholder);
                        return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                    }
                    var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                    length = args.length;
                    if (argPos) args = reorder(args, argPos);
                    else if (isFlip && length > 1) args.reverse();
                    if (isAry && ary < length) args.length = ary;
                    if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                    return fn.apply(thisBinding, args);
                }
                return wrapper;
            }
            function createInverter(setter, toIteratee) {
                return function(object, iteratee) {
                    return baseInverter(object, setter, toIteratee(iteratee), {});
                };
            }
            function createMathOperation(operator, defaultValue) {
                return function(value, other) {
                    var result;
                    if (value === undefined && other === undefined) return defaultValue;
                    if (value !== undefined) result = value;
                    if (other !== undefined) {
                        if (result === undefined) return other;
                        if (typeof value == 'string' || typeof other == 'string') {
                            value = baseToString(value);
                            other = baseToString(other);
                        } else {
                            value = baseToNumber(value);
                            other = baseToNumber(other);
                        }
                        result = operator(value, other);
                    }
                    return result;
                };
            }
            function createOver(arrayFunc) {
                return flatRest(function(iteratees) {
                    iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                    return baseRest(function(args) {
                        var thisArg = this;
                        return arrayFunc(iteratees, function(iteratee) {
                            return apply(iteratee, thisArg, args);
                        });
                    });
                });
            }
            function createPadding(length, chars) {
                chars = chars === undefined ? ' ' : baseToString(chars);
                var charsLength = chars.length;
                if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
                var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
                return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
            }
            function createPartial(func, bitmask, thisArg, partials) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                    while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                    return apply(fn, isBind ? thisArg : this, args);
                }
                return wrapper;
            }
            function createRange(fromRight) {
                return function(start, end, step) {
                    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                    start = toFinite(start);
                    if (end === undefined) {
                        end = start;
                        start = 0;
                    } else end = toFinite(end);
                    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                    return baseRange(start, end, step, fromRight);
                };
            }
            function createRelationalOperation(operator) {
                return function(value, other) {
                    if (!(typeof value == 'string' && typeof other == 'string')) {
                        value = toNumber(value);
                        other = toNumber(other);
                    }
                    return operator(value, other);
                };
            }
            function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
                var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
                bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
                bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
                if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    newPartials,
                    newHolders,
                    newPartialsRight,
                    newHoldersRight,
                    argPos,
                    ary,
                    arity
                ];
                var result = wrapFunc.apply(undefined, newData);
                if (isLaziable(func)) setData(result, newData);
                result.placeholder = placeholder;
                return setWrapToString(result, func, bitmask);
            }
            function createRound(methodName) {
                var func = Math[methodName];
                return function(number, precision) {
                    number = toNumber(number);
                    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                    if (precision && nativeIsFinite(number)) {
                        var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                        pair = (toString(value) + 'e').split('e');
                        return +(pair[0] + 'e' + (+pair[1] - precision));
                    }
                    return func(number);
                };
            }
            var createSet = !(Set && 1 / setToArray(new Set([
                ,
                -0
            ]))[1] == INFINITY) ? noop : function(values) {
                return new Set(values);
            };
            function createToPairs(keysFunc) {
                return function(object) {
                    var tag = getTag(object);
                    if (tag == mapTag) return mapToArray(object);
                    if (tag == setTag) return setToPairs(object);
                    return baseToPairs(object, keysFunc(object));
                };
            }
            function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
                var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
                if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var length = partials ? partials.length : 0;
                if (!length) {
                    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                    partials = holders = undefined;
                }
                ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
                arity = arity === undefined ? arity : toInteger(arity);
                length -= holders ? holders.length : 0;
                if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                    var partialsRight = partials, holdersRight = holders;
                    partials = holders = undefined;
                }
                var data = isBindKey ? undefined : getData(func);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    partials,
                    holders,
                    partialsRight,
                    holdersRight,
                    argPos,
                    ary,
                    arity
                ];
                if (data) mergeData(newData, data);
                func = newData[0];
                bitmask = newData[1];
                thisArg = newData[2];
                partials = newData[3];
                holders = newData[4];
                arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
                if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
                else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
                else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
                else result = createHybrid.apply(undefined, newData);
                var setter = data ? baseSetData : setData;
                return setWrapToString(setter(result, newData), func, bitmask);
            }
            function customDefaultsAssignIn(objValue, srcValue, key, object) {
                if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
                return objValue;
            }
            function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
                if (isObject(objValue) && isObject(srcValue)) {
                    stack.set(srcValue, objValue);
                    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                    stack['delete'](srcValue);
                }
                return objValue;
            }
            function customOmitClone(value) {
                return isPlainObject(value) ? undefined : value;
            }
            function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
                if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
                var arrStacked = stack.get(array);
                var othStacked = stack.get(other);
                if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
                var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
                stack.set(array, other);
                stack.set(other, array);
                while(++index < arrLength){
                    var arrValue = array[index], othValue = other[index];
                    if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                    if (compared !== undefined) {
                        if (compared) continue;
                        result = false;
                        break;
                    }
                    if (seen) {
                        if (!arraySome(other, function(othValue, othIndex) {
                            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                        })) {
                            result = false;
                            break;
                        }
                    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                        result = false;
                        break;
                    }
                }
                stack['delete'](array);
                stack['delete'](other);
                return result;
            }
            function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                switch(tag){
                    case dataViewTag:
                        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                        object = object.buffer;
                        other = other.buffer;
                    case arrayBufferTag:
                        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                        return true;
                    case boolTag:
                    case dateTag:
                    case numberTag:
                        return eq(+object, +other);
                    case errorTag:
                        return object.name == other.name && object.message == other.message;
                    case regexpTag:
                    case stringTag:
                        return object == other + '';
                    case mapTag:
                        var convert = mapToArray;
                    case setTag:
                        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                        convert || (convert = setToArray);
                        if (object.size != other.size && !isPartial) return false;
                        var stacked = stack.get(object);
                        if (stacked) return stacked == other;
                        bitmask |= COMPARE_UNORDERED_FLAG;
                        stack.set(object, other);
                        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                        stack['delete'](object);
                        return result;
                    case symbolTag:
                        if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
                }
                return false;
            }
            function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
                if (objLength != othLength && !isPartial) return false;
                var index = objLength;
                while(index--){
                    var key = objProps[index];
                    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
                }
                var objStacked = stack.get(object);
                var othStacked = stack.get(other);
                if (objStacked && othStacked) return objStacked == other && othStacked == object;
                var result = true;
                stack.set(object, other);
                stack.set(other, object);
                var skipCtor = isPartial;
                while(++index < objLength){
                    key = objProps[index];
                    var objValue = object[key], othValue = other[key];
                    if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                        result = false;
                        break;
                    }
                    skipCtor || (skipCtor = key == 'constructor');
                }
                if (result && !skipCtor) {
                    var objCtor = object.constructor, othCtor = other.constructor;
                    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
                }
                stack['delete'](object);
                stack['delete'](other);
                return result;
            }
            function flatRest(func) {
                return setToString(overRest(func, undefined, flatten), func + '');
            }
            function getAllKeys(object) {
                return baseGetAllKeys(object, keys, getSymbols);
            }
            function getAllKeysIn(object) {
                return baseGetAllKeys(object, keysIn, getSymbolsIn);
            }
            var getData = !metaMap ? noop : function(func) {
                return metaMap.get(func);
            };
            function getFuncName(func) {
                var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
                while(length--){
                    var data = array[length], otherFunc = data.func;
                    if (otherFunc == null || otherFunc == func) return data.name;
                }
                return result;
            }
            function getHolder(func) {
                var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
                return object.placeholder;
            }
            function getIteratee() {
                var result = lodash.iteratee || iteratee;
                result = result === iteratee ? baseIteratee : result;
                return arguments.length ? result(arguments[0], arguments[1]) : result;
            }
            function getMapData(map, key) {
                var data = map.__data__;
                return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
            }
            function getMatchData(object) {
                var result = keys(object), length = result.length;
                while(length--){
                    var key = result[length], value = object[key];
                    result[length] = [
                        key,
                        value,
                        isStrictComparable(value)
                    ];
                }
                return result;
            }
            function getNative(object, key) {
                var value = getValue(object, key);
                return baseIsNative(value) ? value : undefined;
            }
            function getRawTag(value) {
                var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
                try {
                    value[symToStringTag] = undefined;
                    var unmasked = true;
                } catch (e) {}
                var result = nativeObjectToString.call(value);
                if (unmasked) {
                    if (isOwn) value[symToStringTag] = tag;
                    else delete value[symToStringTag];
                }
                return result;
            }
            var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
                if (object == null) return [];
                object = Object1(object);
                return arrayFilter(nativeGetSymbols(object), function(symbol) {
                    return propertyIsEnumerable.call(object, symbol);
                });
            };
            var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
                var result = [];
                while(object){
                    arrayPush(result, getSymbols(object));
                    object = getPrototype(object);
                }
                return result;
            };
            var getTag = baseGetTag;
            if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
                var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
                if (ctorString) switch(ctorString){
                    case dataViewCtorString:
                        return dataViewTag;
                    case mapCtorString:
                        return mapTag;
                    case promiseCtorString:
                        return promiseTag;
                    case setCtorString:
                        return setTag;
                    case weakMapCtorString:
                        return weakMapTag;
                }
                return result;
            };
            function getView(start, end, transforms) {
                var index = -1, length = transforms.length;
                while(++index < length){
                    var data = transforms[index], size = data.size;
                    switch(data.type){
                        case 'drop':
                            start += size;
                            break;
                        case 'dropRight':
                            end -= size;
                            break;
                        case 'take':
                            end = nativeMin(end, start + size);
                            break;
                        case 'takeRight':
                            start = nativeMax(start, end - size);
                            break;
                    }
                }
                return {
                    'start': start,
                    'end': end
                };
            }
            function getWrapDetails(source) {
                var match = source.match(reWrapDetails);
                return match ? match[1].split(reSplitDetails) : [];
            }
            function hasPath(object, path, hasFunc) {
                path = castPath(path, object);
                var index = -1, length = path.length, result = false;
                while(++index < length){
                    var key = toKey(path[index]);
                    if (!(result = object != null && hasFunc(object, key))) break;
                    object = object[key];
                }
                if (result || ++index != length) return result;
                length = object == null ? 0 : object.length;
                return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
            }
            function initCloneArray(array) {
                var length = array.length, result = new array.constructor(length);
                if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                    result.index = array.index;
                    result.input = array.input;
                }
                return result;
            }
            function initCloneObject(object) {
                return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
            }
            function initCloneByTag(object, tag, isDeep) {
                var Ctor = object.constructor;
                switch(tag){
                    case arrayBufferTag:
                        return cloneArrayBuffer(object);
                    case boolTag:
                    case dateTag:
                        return new Ctor(+object);
                    case dataViewTag:
                        return cloneDataView(object, isDeep);
                    case float32Tag:
                    case float64Tag:
                    case int8Tag:
                    case int16Tag:
                    case int32Tag:
                    case uint8Tag:
                    case uint8ClampedTag:
                    case uint16Tag:
                    case uint32Tag:
                        return cloneTypedArray(object, isDeep);
                    case mapTag:
                        return new Ctor;
                    case numberTag:
                    case stringTag:
                        return new Ctor(object);
                    case regexpTag:
                        return cloneRegExp(object);
                    case setTag:
                        return new Ctor;
                    case symbolTag:
                        return cloneSymbol(object);
                }
            }
            function insertWrapDetails(source, details) {
                var length = details.length;
                if (!length) return source;
                var lastIndex = length - 1;
                details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
                details = details.join(length > 2 ? ', ' : ' ');
                return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
            }
            function isFlattenable(value) {
                return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
            }
            function isIndex(value, length) {
                var type = typeof value;
                length = length == null ? MAX_SAFE_INTEGER : length;
                return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
            }
            function isIterateeCall(value, index, object) {
                if (!isObject(object)) return false;
                var type = typeof index;
                if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
                return false;
            }
            function isKey(value, object) {
                if (isArray(value)) return false;
                var type = typeof value;
                if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
                return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
            }
            function isKeyable(value) {
                var type = typeof value;
                return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
            }
            function isLaziable(func) {
                var funcName = getFuncName(func), other = lodash[funcName];
                if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
                if (func === other) return true;
                var data = getData(other);
                return !!data && func === data[0];
            }
            function isMasked(func) {
                return !!maskSrcKey && maskSrcKey in func;
            }
            var isMaskable = coreJsData ? isFunction : stubFalse;
            function isPrototype(value) {
                var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
                return value === proto;
            }
            function isStrictComparable(value) {
                return value === value && !isObject(value);
            }
            function matchesStrictComparable(key, srcValue) {
                return function(object) {
                    if (object == null) return false;
                    return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
                };
            }
            function memoizeCapped(func) {
                var result = memoize(func, function(key) {
                    if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                    return key;
                });
                var cache = result.cache;
                return result;
            }
            function mergeData(data, source) {
                var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
                var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
                if (!(isCommon || isCombo)) return data;
                if (srcBitmask & WRAP_BIND_FLAG) {
                    data[2] = source[2];
                    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
                }
                var value = source[3];
                if (value) {
                    var partials = data[3];
                    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
                }
                value = source[5];
                if (value) {
                    partials = data[5];
                    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
                }
                value = source[7];
                if (value) data[7] = value;
                if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
                if (data[9] == null) data[9] = source[9];
                data[0] = source[0];
                data[1] = newBitmask;
                return data;
            }
            function nativeKeysIn(object) {
                var result = [];
                if (object != null) for(var key in Object1(object))result.push(key);
                return result;
            }
            function objectToString(value) {
                return nativeObjectToString.call(value);
            }
            function overRest(func, start, transform) {
                start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                return function() {
                    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                    while(++index < length)array[index] = args[start + index];
                    index = -1;
                    var otherArgs = Array1(start + 1);
                    while(++index < start)otherArgs[index] = args[index];
                    otherArgs[start] = transform(array);
                    return apply(func, this, otherArgs);
                };
            }
            function parent(object, path) {
                return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
            }
            function reorder(array, indexes) {
                var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
                while(length--){
                    var index = indexes[length];
                    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
                }
                return array;
            }
            function safeGet(object, key) {
                if (key === 'constructor' && typeof object[key] === 'function') return;
                if (key == '__proto__') return;
                return object[key];
            }
            var setData = shortOut(baseSetData);
            var setTimeout = ctxSetTimeout || function(func, wait) {
                return root.setTimeout(func, wait);
            };
            var setToString = shortOut(baseSetToString);
            function setWrapToString(wrapper, reference, bitmask) {
                var source = reference + '';
                return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
            }
            function shortOut(func) {
                var count = 0, lastCalled = 0;
                return function() {
                    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                    lastCalled = stamp;
                    if (remaining > 0) {
                        if (++count >= HOT_COUNT) return arguments[0];
                    } else count = 0;
                    return func.apply(undefined, arguments);
                };
            }
            function shuffleSelf(array, size) {
                var index = -1, length = array.length, lastIndex = length - 1;
                size = size === undefined ? length : size;
                while(++index < size){
                    var rand = baseRandom(index, lastIndex), value = array[rand];
                    array[rand] = array[index];
                    array[index] = value;
                }
                array.length = size;
                return array;
            }
            var stringToPath = memoizeCapped(function(string) {
                var result = [];
                if (string.charCodeAt(0) === 46) result.push('');
                string.replace(rePropName, function(match, number, quote, subString) {
                    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
                });
                return result;
            });
            function toKey(value) {
                if (typeof value == 'string' || isSymbol(value)) return value;
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            function toSource(func) {
                if (func != null) {
                    try {
                        return funcToString.call(func);
                    } catch (e) {}
                    try {
                        return func + '';
                    } catch (e) {}
                }
                return '';
            }
            function updateWrapDetails(details, bitmask) {
                arrayEach(wrapFlags, function(pair) {
                    var value = '_.' + pair[0];
                    if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
                });
                return details.sort();
            }
            function wrapperClone(wrapper) {
                if (wrapper instanceof LazyWrapper) return wrapper.clone();
                var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
                result.__actions__ = copyArray(wrapper.__actions__);
                result.__index__ = wrapper.__index__;
                result.__values__ = wrapper.__values__;
                return result;
            }
            function chunk(array, size, guard) {
                if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
                else size = nativeMax(toInteger(size), 0);
                var length = array == null ? 0 : array.length;
                if (!length || size < 1) return [];
                var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
                while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
                return result;
            }
            function compact(array) {
                var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index];
                    if (value) result[resIndex++] = value;
                }
                return result;
            }
            function concat() {
                var length = arguments.length;
                if (!length) return [];
                var args = Array1(length - 1), array = arguments[0], index = length;
                while(index--)args[index - 1] = arguments[index];
                return arrayPush(isArray(array) ? copyArray(array) : [
                    array
                ], baseFlatten(args, 1));
            }
            var difference = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
            });
            var differenceBy = baseRest(function(array, values) {
                var iteratee = last(values);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
            });
            var differenceWith = baseRest(function(array, values) {
                var comparator = last(values);
                if (isArrayLikeObject(comparator)) comparator = undefined;
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
            });
            function drop(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            function dropRight(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            function dropRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
            }
            function dropWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
            }
            function fill(array, value, start, end) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                    start = 0;
                    end = length;
                }
                return baseFill(array, value, start, end);
            }
            function findIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseFindIndex(array, getIteratee(predicate, 3), index);
            }
            function findLastIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = length - 1;
                if (fromIndex !== undefined) {
                    index = toInteger(fromIndex);
                    index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }
                return baseFindIndex(array, getIteratee(predicate, 3), index, true);
            }
            function flatten(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, 1) : [];
            }
            function flattenDeep(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, INFINITY) : [];
            }
            function flattenDepth(array, depth) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(array, depth);
            }
            function fromPairs(pairs) {
                var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
                while(++index < length){
                    var pair = pairs[index];
                    result[pair[0]] = pair[1];
                }
                return result;
            }
            function head(array) {
                return array && array.length ? array[0] : undefined;
            }
            function indexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseIndexOf(array, value, index);
            }
            function initial(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 0, -1) : [];
            }
            var intersection = baseRest(function(arrays) {
                var mapped = arrayMap(arrays, castArrayLikeObject);
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
            });
            var intersectionBy = baseRest(function(arrays) {
                var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
                if (iteratee === last(mapped)) iteratee = undefined;
                else mapped.pop();
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
            });
            var intersectionWith = baseRest(function(arrays) {
                var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                if (comparator) mapped.pop();
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
            });
            function join(array, separator) {
                return array == null ? '' : nativeJoin.call(array, separator);
            }
            function last(array) {
                var length = array == null ? 0 : array.length;
                return length ? array[length - 1] : undefined;
            }
            function lastIndexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = length;
                if (fromIndex !== undefined) {
                    index = toInteger(fromIndex);
                    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }
                return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
            }
            function nth(array, n) {
                return array && array.length ? baseNth(array, toInteger(n)) : undefined;
            }
            var pull = baseRest(pullAll);
            function pullAll(array, values) {
                return array && array.length && values && values.length ? basePullAll(array, values) : array;
            }
            function pullAllBy(array, values, iteratee) {
                return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
            }
            function pullAllWith(array, values, comparator) {
                return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
            }
            var pullAt = flatRest(function(array, indexes) {
                var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
                basePullAt(array, arrayMap(indexes, function(index) {
                    return isIndex(index, length) ? +index : index;
                }).sort(compareAscending));
                return result;
            });
            function remove(array, predicate) {
                var result = [];
                if (!(array && array.length)) return result;
                var index = -1, indexes = [], length = array.length;
                predicate = getIteratee(predicate, 3);
                while(++index < length){
                    var value = array[index];
                    if (predicate(value, index, array)) {
                        result.push(value);
                        indexes.push(index);
                    }
                }
                basePullAt(array, indexes);
                return result;
            }
            function reverse(array) {
                return array == null ? array : nativeReverse.call(array);
            }
            function slice(array, start, end) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                    start = 0;
                    end = length;
                } else {
                    start = start == null ? 0 : toInteger(start);
                    end = end === undefined ? length : toInteger(end);
                }
                return baseSlice(array, start, end);
            }
            function sortedIndex(array, value) {
                return baseSortedIndex(array, value);
            }
            function sortedIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
            }
            function sortedIndexOf(array, value) {
                var length = array == null ? 0 : array.length;
                if (length) {
                    var index = baseSortedIndex(array, value);
                    if (index < length && eq(array[index], value)) return index;
                }
                return -1;
            }
            function sortedLastIndex(array, value) {
                return baseSortedIndex(array, value, true);
            }
            function sortedLastIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
            }
            function sortedLastIndexOf(array, value) {
                var length = array == null ? 0 : array.length;
                if (length) {
                    var index = baseSortedIndex(array, value, true) - 1;
                    if (eq(array[index], value)) return index;
                }
                return -1;
            }
            function sortedUniq(array) {
                return array && array.length ? baseSortedUniq(array) : [];
            }
            function sortedUniqBy(array, iteratee) {
                return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
            }
            function tail(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 1, length) : [];
            }
            function take(array, n, guard) {
                if (!(array && array.length)) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            function takeRight(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            function takeRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
            }
            function takeWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
            }
            var union = baseRest(function(arrays) {
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
            });
            var unionBy = baseRest(function(arrays) {
                var iteratee = last(arrays);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
            });
            var unionWith = baseRest(function(arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
            });
            function uniq(array) {
                return array && array.length ? baseUniq(array) : [];
            }
            function uniqBy(array, iteratee) {
                return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
            }
            function uniqWith(array, comparator) {
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return array && array.length ? baseUniq(array, undefined, comparator) : [];
            }
            function unzip(array) {
                if (!(array && array.length)) return [];
                var length = 0;
                array = arrayFilter(array, function(group) {
                    if (isArrayLikeObject(group)) {
                        length = nativeMax(group.length, length);
                        return true;
                    }
                });
                return baseTimes(length, function(index) {
                    return arrayMap(array, baseProperty(index));
                });
            }
            function unzipWith(array, iteratee) {
                if (!(array && array.length)) return [];
                var result = unzip(array);
                if (iteratee == null) return result;
                return arrayMap(result, function(group) {
                    return apply(iteratee, undefined, group);
                });
            }
            var without = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, values) : [];
            });
            var xor = baseRest(function(arrays) {
                return baseXor(arrayFilter(arrays, isArrayLikeObject));
            });
            var xorBy = baseRest(function(arrays) {
                var iteratee = last(arrays);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
            });
            var xorWith = baseRest(function(arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
            });
            var zip = baseRest(unzip);
            function zipObject(props, values) {
                return baseZipObject(props || [], values || [], assignValue);
            }
            function zipObjectDeep(props, values) {
                return baseZipObject(props || [], values || [], baseSet);
            }
            var zipWith = baseRest(function(arrays) {
                var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
                iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
                return unzipWith(arrays, iteratee);
            });
            function chain(value) {
                var result = lodash(value);
                result.__chain__ = true;
                return result;
            }
            function tap(value, interceptor) {
                interceptor(value);
                return value;
            }
            function thru(value, interceptor) {
                return interceptor(value);
            }
            var wrapperAt = flatRest(function(paths) {
                var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                    return baseAt(object, paths);
                };
                if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
                value = value.slice(start, +start + (length ? 1 : 0));
                value.__actions__.push({
                    'func': thru,
                    'args': [
                        interceptor
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(value, this.__chain__).thru(function(array) {
                    if (length && !array.length) array.push(undefined);
                    return array;
                });
            });
            function wrapperChain() {
                return chain(this);
            }
            function wrapperCommit() {
                return new LodashWrapper(this.value(), this.__chain__);
            }
            function wrapperNext() {
                if (this.__values__ === undefined) this.__values__ = toArray(this.value());
                var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
                return {
                    'done': done,
                    'value': value
                };
            }
            function wrapperToIterator() {
                return this;
            }
            function wrapperPlant(value) {
                var result, parent = this;
                while(parent instanceof baseLodash){
                    var clone = wrapperClone(parent);
                    clone.__index__ = 0;
                    clone.__values__ = undefined;
                    if (result) previous.__wrapped__ = clone;
                    else result = clone;
                    var previous = clone;
                    parent = parent.__wrapped__;
                }
                previous.__wrapped__ = value;
                return result;
            }
            function wrapperReverse() {
                var value = this.__wrapped__;
                if (value instanceof LazyWrapper) {
                    var wrapped = value;
                    if (this.__actions__.length) wrapped = new LazyWrapper(this);
                    wrapped = wrapped.reverse();
                    wrapped.__actions__.push({
                        'func': thru,
                        'args': [
                            reverse
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(wrapped, this.__chain__);
                }
                return this.thru(reverse);
            }
            function wrapperValue() {
                return baseWrapperValue(this.__wrapped__, this.__actions__);
            }
            var countBy = createAggregator(function(result, value, key) {
                if (hasOwnProperty.call(result, key)) ++result[key];
                else baseAssignValue(result, key, 1);
            });
            function every(collection, predicate, guard) {
                var func = isArray(collection) ? arrayEvery : baseEvery;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, getIteratee(predicate, 3));
            }
            function filter(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, getIteratee(predicate, 3));
            }
            var find = createFind(findIndex);
            var findLast = createFind(findLastIndex);
            function flatMap(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), 1);
            }
            function flatMapDeep(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), INFINITY);
            }
            function flatMapDepth(collection, iteratee, depth) {
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(map(collection, iteratee), depth);
            }
            function forEach(collection, iteratee) {
                var func = isArray(collection) ? arrayEach : baseEach;
                return func(collection, getIteratee(iteratee, 3));
            }
            function forEachRight(collection, iteratee) {
                var func = isArray(collection) ? arrayEachRight : baseEachRight;
                return func(collection, getIteratee(iteratee, 3));
            }
            var groupBy = createAggregator(function(result, value, key) {
                if (hasOwnProperty.call(result, key)) result[key].push(value);
                else baseAssignValue(result, key, [
                    value
                ]);
            });
            function includes(collection, value, fromIndex, guard) {
                collection = isArrayLike(collection) ? collection : values(collection);
                fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
                var length = collection.length;
                if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
                return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
            }
            var invokeMap = baseRest(function(collection, path, args) {
                var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
                baseEach(collection, function(value) {
                    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
                });
                return result;
            });
            var keyBy = createAggregator(function(result, value, key) {
                baseAssignValue(result, key, value);
            });
            function map(collection, iteratee) {
                var func = isArray(collection) ? arrayMap : baseMap;
                return func(collection, getIteratee(iteratee, 3));
            }
            function orderBy(collection, iteratees, orders, guard) {
                if (collection == null) return [];
                if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                    iteratees
                ];
                orders = guard ? undefined : orders;
                if (!isArray(orders)) orders = orders == null ? [] : [
                    orders
                ];
                return baseOrderBy(collection, iteratees, orders);
            }
            var partition = createAggregator(function(result, value, key) {
                result[key ? 0 : 1].push(value);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function reduce(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
            }
            function reduceRight(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
            }
            function reject(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, negate(getIteratee(predicate, 3)));
            }
            function sample(collection) {
                var func = isArray(collection) ? arraySample : baseSample;
                return func(collection);
            }
            function sampleSize(collection, n, guard) {
                if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
                else n = toInteger(n);
                var func = isArray(collection) ? arraySampleSize : baseSampleSize;
                return func(collection, n);
            }
            function shuffle(collection) {
                var func = isArray(collection) ? arrayShuffle : baseShuffle;
                return func(collection);
            }
            function size(collection) {
                if (collection == null) return 0;
                if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
                var tag = getTag(collection);
                if (tag == mapTag || tag == setTag) return collection.size;
                return baseKeys(collection).length;
            }
            function some(collection, predicate, guard) {
                var func = isArray(collection) ? arraySome : baseSome;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, getIteratee(predicate, 3));
            }
            var sortBy = baseRest(function(collection, iteratees) {
                if (collection == null) return [];
                var length = iteratees.length;
                if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
                else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                    iteratees[0]
                ];
                return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
            });
            var now = ctxNow || function() {
                return root.Date.now();
            };
            function after(n, func) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n < 1) return func.apply(this, arguments);
                };
            }
            function ary(func, n, guard) {
                n = guard ? undefined : n;
                n = func && n == null ? func.length : n;
                return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
            }
            function before(n, func) {
                var result;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n > 0) result = func.apply(this, arguments);
                    if (n <= 1) func = undefined;
                    return result;
                };
            }
            var bind = baseRest(function(func, thisArg, partials) {
                var bitmask = WRAP_BIND_FLAG;
                if (partials.length) {
                    var holders = replaceHolders(partials, getHolder(bind));
                    bitmask |= WRAP_PARTIAL_FLAG;
                }
                return createWrap(func, bitmask, thisArg, partials, holders);
            });
            var bindKey = baseRest(function(object, key, partials) {
                var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
                if (partials.length) {
                    var holders = replaceHolders(partials, getHolder(bindKey));
                    bitmask |= WRAP_PARTIAL_FLAG;
                }
                return createWrap(key, bitmask, object, partials, holders);
            });
            function curry(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curry.placeholder;
                return result;
            }
            function curryRight(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curryRight.placeholder;
                return result;
            }
            function debounce(func, wait, options) {
                var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                wait = toNumber(wait) || 0;
                if (isObject(options)) {
                    leading = !!options.leading;
                    maxing = 'maxWait' in options;
                    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                function invokeFunc(time) {
                    var args = lastArgs, thisArg = lastThis;
                    lastArgs = lastThis = undefined;
                    lastInvokeTime = time;
                    result = func.apply(thisArg, args);
                    return result;
                }
                function leadingEdge(time) {
                    lastInvokeTime = time;
                    timerId = setTimeout(timerExpired, wait);
                    return leading ? invokeFunc(time) : result;
                }
                function remainingWait(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
                }
                function shouldInvoke(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
                }
                function timerExpired() {
                    var time = now();
                    if (shouldInvoke(time)) return trailingEdge(time);
                    timerId = setTimeout(timerExpired, remainingWait(time));
                }
                function trailingEdge(time) {
                    timerId = undefined;
                    if (trailing && lastArgs) return invokeFunc(time);
                    lastArgs = lastThis = undefined;
                    return result;
                }
                function cancel() {
                    if (timerId !== undefined) clearTimeout(timerId);
                    lastInvokeTime = 0;
                    lastArgs = lastCallTime = lastThis = timerId = undefined;
                }
                function flush() {
                    return timerId === undefined ? result : trailingEdge(now());
                }
                function debounced() {
                    var time = now(), isInvoking = shouldInvoke(time);
                    lastArgs = arguments;
                    lastThis = this;
                    lastCallTime = time;
                    if (isInvoking) {
                        if (timerId === undefined) return leadingEdge(lastCallTime);
                        if (maxing) {
                            clearTimeout(timerId);
                            timerId = setTimeout(timerExpired, wait);
                            return invokeFunc(lastCallTime);
                        }
                    }
                    if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                    return result;
                }
                debounced.cancel = cancel;
                debounced.flush = flush;
                return debounced;
            }
            var defer = baseRest(function(func, args) {
                return baseDelay(func, 1, args);
            });
            var delay = baseRest(function(func, wait, args) {
                return baseDelay(func, toNumber(wait) || 0, args);
            });
            function flip(func) {
                return createWrap(func, WRAP_FLIP_FLAG);
            }
            function memoize(func, resolver) {
                if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var memoized = function() {
                    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                    if (cache.has(key)) return cache.get(key);
                    var result = func.apply(this, args);
                    memoized.cache = cache.set(key, result) || cache;
                    return result;
                };
                memoized.cache = new (memoize.Cache || MapCache);
                return memoized;
            }
            memoize.Cache = MapCache;
            function negate(predicate) {
                if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return function() {
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return !predicate.call(this);
                        case 1:
                            return !predicate.call(this, args[0]);
                        case 2:
                            return !predicate.call(this, args[0], args[1]);
                        case 3:
                            return !predicate.call(this, args[0], args[1], args[2]);
                    }
                    return !predicate.apply(this, args);
                };
            }
            function once(func) {
                return before(2, func);
            }
            var overArgs = castRest(function(func, transforms) {
                transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
                var funcsLength = transforms.length;
                return baseRest(function(args) {
                    var index = -1, length = nativeMin(args.length, funcsLength);
                    while(++index < length)args[index] = transforms[index].call(this, args[index]);
                    return apply(func, this, args);
                });
            });
            var partial = baseRest(function(func, partials) {
                var holders = replaceHolders(partials, getHolder(partial));
                return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
            });
            var partialRight = baseRest(function(func, partials) {
                var holders = replaceHolders(partials, getHolder(partialRight));
                return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
            });
            var rearg = flatRest(function(func, indexes) {
                return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
            });
            function rest(func, start) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                start = start === undefined ? start : toInteger(start);
                return baseRest(func, start);
            }
            function spread(func, start) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                start = start == null ? 0 : nativeMax(toInteger(start), 0);
                return baseRest(function(args) {
                    var array = args[start], otherArgs = castSlice(args, 0, start);
                    if (array) arrayPush(otherArgs, array);
                    return apply(func, this, otherArgs);
                });
            }
            function throttle(func, wait, options) {
                var leading = true, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                if (isObject(options)) {
                    leading = 'leading' in options ? !!options.leading : leading;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                return debounce(func, wait, {
                    'leading': leading,
                    'maxWait': wait,
                    'trailing': trailing
                });
            }
            function unary(func) {
                return ary(func, 1);
            }
            function wrap(value, wrapper) {
                return partial(castFunction(wrapper), value);
            }
            function castArray() {
                if (!arguments.length) return [];
                var value = arguments[0];
                return isArray(value) ? value : [
                    value
                ];
            }
            function clone(value) {
                return baseClone(value, CLONE_SYMBOLS_FLAG);
            }
            function cloneWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
            }
            function cloneDeep(value) {
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
            }
            function cloneDeepWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
            }
            function conformsTo(object, source) {
                return source == null || baseConformsTo(object, source, keys(source));
            }
            function eq(value, other) {
                return value === other || value !== value && other !== other;
            }
            var gt = createRelationalOperation(baseGt);
            var gte = createRelationalOperation(function(value, other) {
                return value >= other;
            });
            var isArguments = baseIsArguments(function() {
                return arguments;
            }()) ? baseIsArguments : function(value) {
                return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
            };
            var isArray = Array1.isArray;
            var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
            function isArrayLike(value) {
                return value != null && isLength(value.length) && !isFunction(value);
            }
            function isArrayLikeObject(value) {
                return isObjectLike(value) && isArrayLike(value);
            }
            function isBoolean(value) {
                return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
            }
            var isBuffer = nativeIsBuffer || stubFalse;
            var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
            function isElement(value) {
                return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
            }
            function isEmpty(value) {
                if (value == null) return true;
                if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
                var tag = getTag(value);
                if (tag == mapTag || tag == setTag) return !value.size;
                if (isPrototype(value)) return !baseKeys(value).length;
                for(var key in value){
                    if (hasOwnProperty.call(value, key)) return false;
                }
                return true;
            }
            function isEqual(value, other) {
                return baseIsEqual(value, other);
            }
            function isEqualWith(value, other, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                var result = customizer ? customizer(value, other) : undefined;
                return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
            }
            function isError(value) {
                if (!isObjectLike(value)) return false;
                var tag = baseGetTag(value);
                return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
            }
            function isFinite(value) {
                return typeof value == 'number' && nativeIsFinite(value);
            }
            function isFunction(value) {
                if (!isObject(value)) return false;
                var tag = baseGetTag(value);
                return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
            }
            function isInteger(value) {
                return typeof value == 'number' && value == toInteger(value);
            }
            function isLength(value) {
                return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
            }
            function isObject(value) {
                var type = typeof value;
                return value != null && (type == 'object' || type == 'function');
            }
            function isObjectLike(value) {
                return value != null && typeof value == 'object';
            }
            var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
            function isMatch(object, source) {
                return object === source || baseIsMatch(object, source, getMatchData(source));
            }
            function isMatchWith(object, source, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseIsMatch(object, source, getMatchData(source), customizer);
            }
            function isNaN(value) {
                return isNumber(value) && value != +value;
            }
            function isNative(value) {
                if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
                return baseIsNative(value);
            }
            function isNull(value) {
                return value === null;
            }
            function isNil(value) {
                return value == null;
            }
            function isNumber(value) {
                return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
            }
            function isPlainObject(value) {
                if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
                var proto = getPrototype(value);
                if (proto === null) return true;
                var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
            }
            var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
            function isSafeInteger(value) {
                return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
            }
            var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
            function isString(value) {
                return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
            }
            function isSymbol(value) {
                return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
            }
            var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
            function isUndefined(value) {
                return value === undefined;
            }
            function isWeakMap(value) {
                return isObjectLike(value) && getTag(value) == weakMapTag;
            }
            function isWeakSet(value) {
                return isObjectLike(value) && baseGetTag(value) == weakSetTag;
            }
            var lt = createRelationalOperation(baseLt);
            var lte = createRelationalOperation(function(value, other) {
                return value <= other;
            });
            function toArray(value) {
                if (!value) return [];
                if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
                if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
                var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
                return func(value);
            }
            function toFinite(value) {
                if (!value) return value === 0 ? value : 0;
                value = toNumber(value);
                if (value === INFINITY || value === -INFINITY) {
                    var sign = value < 0 ? -1 : 1;
                    return sign * MAX_INTEGER;
                }
                return value === value ? value : 0;
            }
            function toInteger(value) {
                var result = toFinite(value), remainder = result % 1;
                return result === result ? remainder ? result - remainder : result : 0;
            }
            function toLength(value) {
                return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
            }
            function toNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                if (isObject(value)) {
                    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                    value = isObject(other) ? other + '' : other;
                }
                if (typeof value != 'string') return value === 0 ? value : +value;
                value = baseTrim(value);
                var isBinary = reIsBinary.test(value);
                return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
            }
            function toPlainObject(value) {
                return copyObject(value, keysIn(value));
            }
            function toSafeInteger(value) {
                return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
            }
            function toString(value) {
                return value == null ? '' : baseToString(value);
            }
            var assign = createAssigner(function(object, source) {
                if (isPrototype(source) || isArrayLike(source)) {
                    copyObject(source, keys(source), object);
                    return;
                }
                for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
            });
            var assignIn = createAssigner(function(object, source) {
                copyObject(source, keysIn(source), object);
            });
            var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
                copyObject(source, keysIn(source), object, customizer);
            });
            var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
                copyObject(source, keys(source), object, customizer);
            });
            var at = flatRest(baseAt);
            function create(prototype, properties) {
                var result = baseCreate(prototype);
                return properties == null ? result : baseAssign(result, properties);
            }
            var defaults = baseRest(function(object, sources) {
                object = Object1(object);
                var index = -1;
                var length = sources.length;
                var guard = length > 2 ? sources[2] : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
                while(++index < length){
                    var source = sources[index];
                    var props = keysIn(source);
                    var propsIndex = -1;
                    var propsLength = props.length;
                    while(++propsIndex < propsLength){
                        var key = props[propsIndex];
                        var value = object[key];
                        if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                    }
                }
                return object;
            });
            var defaultsDeep = baseRest(function(args) {
                args.push(undefined, customDefaultsMerge);
                return apply(mergeWith, undefined, args);
            });
            function findKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
            }
            function findLastKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
            }
            function forIn(object, iteratee) {
                return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
            }
            function forInRight(object, iteratee) {
                return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
            }
            function forOwn(object, iteratee) {
                return object && baseForOwn(object, getIteratee(iteratee, 3));
            }
            function forOwnRight(object, iteratee) {
                return object && baseForOwnRight(object, getIteratee(iteratee, 3));
            }
            function functions(object) {
                return object == null ? [] : baseFunctions(object, keys(object));
            }
            function functionsIn(object) {
                return object == null ? [] : baseFunctions(object, keysIn(object));
            }
            function get(object, path, defaultValue) {
                var result = object == null ? undefined : baseGet(object, path);
                return result === undefined ? defaultValue : result;
            }
            function has(object, path) {
                return object != null && hasPath(object, path, baseHas);
            }
            function hasIn(object, path) {
                return object != null && hasPath(object, path, baseHasIn);
            }
            var invert = createInverter(function(result, value, key) {
                if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
                result[value] = key;
            }, constant(identity));
            var invertBy = createInverter(function(result, value, key) {
                if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
                if (hasOwnProperty.call(result, value)) result[value].push(key);
                else result[value] = [
                    key
                ];
            }, getIteratee);
            var invoke = baseRest(baseInvoke);
            function keys(object) {
                return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
            }
            function keysIn(object) {
                return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
            }
            function mapKeys(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, iteratee(value, key, object), value);
                });
                return result;
            }
            function mapValues(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, key, iteratee(value, key, object));
                });
                return result;
            }
            var merge = createAssigner(function(object, source, srcIndex) {
                baseMerge(object, source, srcIndex);
            });
            var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
                baseMerge(object, source, srcIndex, customizer);
            });
            var omit = flatRest(function(object, paths) {
                var result = {};
                if (object == null) return result;
                var isDeep = false;
                paths = arrayMap(paths, function(path) {
                    path = castPath(path, object);
                    isDeep || (isDeep = path.length > 1);
                    return path;
                });
                copyObject(object, getAllKeysIn(object), result);
                if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
                var length = paths.length;
                while(length--)baseUnset(result, paths[length]);
                return result;
            });
            function omitBy(object, predicate) {
                return pickBy(object, negate(getIteratee(predicate)));
            }
            var pick = flatRest(function(object, paths) {
                return object == null ? {} : basePick(object, paths);
            });
            function pickBy(object, predicate) {
                if (object == null) return {};
                var props = arrayMap(getAllKeysIn(object), function(prop) {
                    return [
                        prop
                    ];
                });
                predicate = getIteratee(predicate);
                return basePickBy(object, props, function(value, path) {
                    return predicate(value, path[0]);
                });
            }
            function result(object, path, defaultValue) {
                path = castPath(path, object);
                var index = -1, length = path.length;
                if (!length) {
                    length = 1;
                    object = undefined;
                }
                while(++index < length){
                    var value = object == null ? undefined : object[toKey(path[index])];
                    if (value === undefined) {
                        index = length;
                        value = defaultValue;
                    }
                    object = isFunction(value) ? value.call(object) : value;
                }
                return object;
            }
            function set(object, path, value) {
                return object == null ? object : baseSet(object, path, value);
            }
            function setWith(object, path, value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseSet(object, path, value, customizer);
            }
            var toPairs = createToPairs(keys);
            var toPairsIn = createToPairs(keysIn);
            function transform(object, iteratee, accumulator) {
                var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
                iteratee = getIteratee(iteratee, 4);
                if (accumulator == null) {
                    var Ctor = object && object.constructor;
                    if (isArrLike) accumulator = isArr ? new Ctor : [];
                    else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                    else accumulator = {};
                }
                (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                    return iteratee(accumulator, value, index, object);
                });
                return accumulator;
            }
            function unset(object, path) {
                return object == null ? true : baseUnset(object, path);
            }
            function update(object, path, updater) {
                return object == null ? object : baseUpdate(object, path, castFunction(updater));
            }
            function updateWith(object, path, updater, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
            }
            function values(object) {
                return object == null ? [] : baseValues(object, keys(object));
            }
            function valuesIn(object) {
                return object == null ? [] : baseValues(object, keysIn(object));
            }
            function clamp(number, lower, upper) {
                if (upper === undefined) {
                    upper = lower;
                    lower = undefined;
                }
                if (upper !== undefined) {
                    upper = toNumber(upper);
                    upper = upper === upper ? upper : 0;
                }
                if (lower !== undefined) {
                    lower = toNumber(lower);
                    lower = lower === lower ? lower : 0;
                }
                return baseClamp(toNumber(number), lower, upper);
            }
            function inRange(number, start, end) {
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                number = toNumber(number);
                return baseInRange(number, start, end);
            }
            function random(lower, upper, floating) {
                if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
                if (floating === undefined) {
                    if (typeof upper == 'boolean') {
                        floating = upper;
                        upper = undefined;
                    } else if (typeof lower == 'boolean') {
                        floating = lower;
                        lower = undefined;
                    }
                }
                if (lower === undefined && upper === undefined) {
                    lower = 0;
                    upper = 1;
                } else {
                    lower = toFinite(lower);
                    if (upper === undefined) {
                        upper = lower;
                        lower = 0;
                    } else upper = toFinite(upper);
                }
                if (lower > upper) {
                    var temp = lower;
                    lower = upper;
                    upper = temp;
                }
                if (floating || lower % 1 || upper % 1) {
                    var rand = nativeRandom();
                    return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
                }
                return baseRandom(lower, upper);
            }
            var camelCase = createCompounder(function(result, word, index) {
                word = word.toLowerCase();
                return result + (index ? capitalize(word) : word);
            });
            function capitalize(string) {
                return upperFirst(toString(string).toLowerCase());
            }
            function deburr(string) {
                string = toString(string);
                return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
            }
            function endsWith(string, target, position) {
                string = toString(string);
                target = baseToString(target);
                var length = string.length;
                position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
                var end = position;
                position -= target.length;
                return position >= 0 && string.slice(position, end) == target;
            }
            function escape(string) {
                string = toString(string);
                return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
            }
            function escapeRegExp(string) {
                string = toString(string);
                return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
            }
            var kebabCase = createCompounder(function(result, word, index) {
                return result + (index ? '-' : '') + word.toLowerCase();
            });
            var lowerCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + word.toLowerCase();
            });
            var lowerFirst = createCaseFirst('toLowerCase');
            function pad(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                if (!length || strLength >= length) return string;
                var mid = (length - strLength) / 2;
                return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
            }
            function padEnd(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
            }
            function padStart(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
            }
            function parseInt1(string, radix, guard) {
                if (guard || radix == null) radix = 0;
                else if (radix) radix = +radix;
                return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
            }
            function repeat(string, n, guard) {
                if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
                else n = toInteger(n);
                return baseRepeat(toString(string), n);
            }
            function replace() {
                var args = arguments, string = toString(args[0]);
                return args.length < 3 ? string : string.replace(args[1], args[2]);
            }
            var snakeCase = createCompounder(function(result, word, index) {
                return result + (index ? '_' : '') + word.toLowerCase();
            });
            function split(string, separator, limit) {
                if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
                limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
                if (!limit) return [];
                string = toString(string);
                if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                    separator = baseToString(separator);
                    if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
                }
                return string.split(separator, limit);
            }
            var startCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + upperFirst(word);
            });
            function startsWith(string, target, position) {
                string = toString(string);
                position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
                target = baseToString(target);
                return string.slice(position, position + target.length) == target;
            }
            function template(string, options, guard) {
                var settings = lodash.templateSettings;
                if (guard && isIterateeCall(string, options, guard)) options = undefined;
                string = toString(string);
                options = assignInWith({}, options, settings, customDefaultsAssignIn);
                var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
                var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
                var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
                var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
                string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                    interpolateValue || (interpolateValue = esTemplateValue);
                    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                    if (escapeValue) {
                        isEscaping = true;
                        source += "' +\n__e(" + escapeValue + ") +\n'";
                    }
                    if (evaluateValue) {
                        isEvaluating = true;
                        source += "';\n" + evaluateValue + ";\n__p += '";
                    }
                    if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                    index = offset + match.length;
                    return match;
                });
                source += "';\n";
                var variable = hasOwnProperty.call(options, 'variable') && options.variable;
                if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
                else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
                source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
                source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
                var result = attempt(function() {
                    return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
                });
                result.source = source;
                if (isError(result)) throw result;
                return result;
            }
            function toLower(value) {
                return toString(value).toLowerCase();
            }
            function toUpper(value) {
                return toString(value).toUpperCase();
            }
            function trim(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return baseTrim(string);
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
                return castSlice(strSymbols, start, end).join('');
            }
            function trimEnd(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
                return castSlice(strSymbols, 0, end).join('');
            }
            function trimStart(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
                return castSlice(strSymbols, start).join('');
            }
            function truncate(string, options) {
                var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
                if (isObject(options)) {
                    var separator = 'separator' in options ? options.separator : separator;
                    length = 'length' in options ? toInteger(options.length) : length;
                    omission = 'omission' in options ? baseToString(options.omission) : omission;
                }
                string = toString(string);
                var strLength = string.length;
                if (hasUnicode(string)) {
                    var strSymbols = stringToArray(string);
                    strLength = strSymbols.length;
                }
                if (length >= strLength) return string;
                var end = length - stringSize(omission);
                if (end < 1) return omission;
                var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
                if (separator === undefined) return result + omission;
                if (strSymbols) end += result.length - end;
                if (isRegExp(separator)) {
                    if (string.slice(end).search(separator)) {
                        var match, substring = result;
                        if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                        separator.lastIndex = 0;
                        while(match = separator.exec(substring))var newEnd = match.index;
                        result = result.slice(0, newEnd === undefined ? end : newEnd);
                    }
                } else if (string.indexOf(baseToString(separator), end) != end) {
                    var index = result.lastIndexOf(separator);
                    if (index > -1) result = result.slice(0, index);
                }
                return result + omission;
            }
            function unescape(string) {
                string = toString(string);
                return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
            }
            var upperCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + word.toUpperCase();
            });
            var upperFirst = createCaseFirst('toUpperCase');
            function words(string, pattern, guard) {
                string = toString(string);
                pattern = guard ? undefined : pattern;
                if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                return string.match(pattern) || [];
            }
            var attempt = baseRest(function(func, args) {
                try {
                    return apply(func, undefined, args);
                } catch (e) {
                    return isError(e) ? e : new Error(e);
                }
            });
            var bindAll = flatRest(function(object, methodNames) {
                arrayEach(methodNames, function(key) {
                    key = toKey(key);
                    baseAssignValue(object, key, bind(object[key], object));
                });
                return object;
            });
            function cond(pairs) {
                var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
                pairs = !length ? [] : arrayMap(pairs, function(pair) {
                    if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    return [
                        toIteratee(pair[0]),
                        pair[1]
                    ];
                });
                return baseRest(function(args) {
                    var index = -1;
                    while(++index < length){
                        var pair = pairs[index];
                        if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                    }
                });
            }
            function conforms(source) {
                return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
            }
            function constant(value) {
                return function() {
                    return value;
                };
            }
            function defaultTo(value, defaultValue) {
                return value == null || value !== value ? defaultValue : value;
            }
            var flow = createFlow();
            var flowRight = createFlow(true);
            function identity(value) {
                return value;
            }
            function iteratee(func) {
                return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
            }
            function matches(source) {
                return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
            }
            function matchesProperty(path, srcValue) {
                return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
            }
            var method = baseRest(function(path, args) {
                return function(object) {
                    return baseInvoke(object, path, args);
                };
            });
            var methodOf = baseRest(function(object, args) {
                return function(path) {
                    return baseInvoke(object, path, args);
                };
            });
            function mixin(object, source, options) {
                var props = keys(source), methodNames = baseFunctions(source, props);
                if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                    options = source;
                    source = object;
                    object = this;
                    methodNames = baseFunctions(source, keys(source));
                }
                var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
                arrayEach(methodNames, function(methodName) {
                    var func = source[methodName];
                    object[methodName] = func;
                    if (isFunc) object.prototype[methodName] = function() {
                        var chainAll = this.__chain__;
                        if (chain || chainAll) {
                            var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                            actions.push({
                                'func': func,
                                'args': arguments,
                                'thisArg': object
                            });
                            result.__chain__ = chainAll;
                            return result;
                        }
                        return func.apply(object, arrayPush([
                            this.value()
                        ], arguments));
                    };
                });
                return object;
            }
            function noConflict() {
                if (root._ === this) root._ = oldDash;
                return this;
            }
            function noop() {}
            function nthArg(n) {
                n = toInteger(n);
                return baseRest(function(args) {
                    return baseNth(args, n);
                });
            }
            var over = createOver(arrayMap);
            var overEvery = createOver(arrayEvery);
            var overSome = createOver(arraySome);
            function property(path) {
                return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
            }
            function propertyOf(object) {
                return function(path) {
                    return object == null ? undefined : baseGet(object, path);
                };
            }
            var range = createRange();
            var rangeRight = createRange(true);
            function stubArray() {
                return [];
            }
            function stubFalse() {
                return false;
            }
            function stubObject() {
                return {};
            }
            function stubString() {
                return '';
            }
            function stubTrue() {
                return true;
            }
            function times(n, iteratee) {
                n = toInteger(n);
                if (n < 1 || n > MAX_SAFE_INTEGER) return [];
                var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
                iteratee = getIteratee(iteratee);
                n -= MAX_ARRAY_LENGTH;
                var result = baseTimes(length, iteratee);
                while(++index < n)iteratee(index);
                return result;
            }
            function toPath(value) {
                if (isArray(value)) return arrayMap(value, toKey);
                return isSymbol(value) ? [
                    value
                ] : copyArray(stringToPath(toString(value)));
            }
            function uniqueId(prefix) {
                var id = ++idCounter;
                return toString(prefix) + id;
            }
            var add = createMathOperation(function(augend, addend) {
                return augend + addend;
            }, 0);
            var ceil = createRound('ceil');
            var divide = createMathOperation(function(dividend, divisor) {
                return dividend / divisor;
            }, 1);
            var floor = createRound('floor');
            function max(array) {
                return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
            }
            function maxBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
            }
            function mean(array) {
                return baseMean(array, identity);
            }
            function meanBy(array, iteratee) {
                return baseMean(array, getIteratee(iteratee, 2));
            }
            function min(array) {
                return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
            }
            function minBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
            }
            var multiply = createMathOperation(function(multiplier, multiplicand) {
                return multiplier * multiplicand;
            }, 1);
            var round = createRound('round');
            var subtract = createMathOperation(function(minuend, subtrahend) {
                return minuend - subtrahend;
            }, 0);
            function sum(array) {
                return array && array.length ? baseSum(array, identity) : 0;
            }
            function sumBy(array, iteratee) {
                return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
            }
            lodash.after = after;
            lodash.ary = ary;
            lodash.assign = assign;
            lodash.assignIn = assignIn;
            lodash.assignInWith = assignInWith;
            lodash.assignWith = assignWith;
            lodash.at = at;
            lodash.before = before;
            lodash.bind = bind;
            lodash.bindAll = bindAll;
            lodash.bindKey = bindKey;
            lodash.castArray = castArray;
            lodash.chain = chain;
            lodash.chunk = chunk;
            lodash.compact = compact;
            lodash.concat = concat;
            lodash.cond = cond;
            lodash.conforms = conforms;
            lodash.constant = constant;
            lodash.countBy = countBy;
            lodash.create = create;
            lodash.curry = curry;
            lodash.curryRight = curryRight;
            lodash.debounce = debounce;
            lodash.defaults = defaults;
            lodash.defaultsDeep = defaultsDeep;
            lodash.defer = defer;
            lodash.delay = delay;
            lodash.difference = difference;
            lodash.differenceBy = differenceBy;
            lodash.differenceWith = differenceWith;
            lodash.drop = drop;
            lodash.dropRight = dropRight;
            lodash.dropRightWhile = dropRightWhile;
            lodash.dropWhile = dropWhile;
            lodash.fill = fill;
            lodash.filter = filter;
            lodash.flatMap = flatMap;
            lodash.flatMapDeep = flatMapDeep;
            lodash.flatMapDepth = flatMapDepth;
            lodash.flatten = flatten;
            lodash.flattenDeep = flattenDeep;
            lodash.flattenDepth = flattenDepth;
            lodash.flip = flip;
            lodash.flow = flow;
            lodash.flowRight = flowRight;
            lodash.fromPairs = fromPairs;
            lodash.functions = functions;
            lodash.functionsIn = functionsIn;
            lodash.groupBy = groupBy;
            lodash.initial = initial;
            lodash.intersection = intersection;
            lodash.intersectionBy = intersectionBy;
            lodash.intersectionWith = intersectionWith;
            lodash.invert = invert;
            lodash.invertBy = invertBy;
            lodash.invokeMap = invokeMap;
            lodash.iteratee = iteratee;
            lodash.keyBy = keyBy;
            lodash.keys = keys;
            lodash.keysIn = keysIn;
            lodash.map = map;
            lodash.mapKeys = mapKeys;
            lodash.mapValues = mapValues;
            lodash.matches = matches;
            lodash.matchesProperty = matchesProperty;
            lodash.memoize = memoize;
            lodash.merge = merge;
            lodash.mergeWith = mergeWith;
            lodash.method = method;
            lodash.methodOf = methodOf;
            lodash.mixin = mixin;
            lodash.negate = negate;
            lodash.nthArg = nthArg;
            lodash.omit = omit;
            lodash.omitBy = omitBy;
            lodash.once = once;
            lodash.orderBy = orderBy;
            lodash.over = over;
            lodash.overArgs = overArgs;
            lodash.overEvery = overEvery;
            lodash.overSome = overSome;
            lodash.partial = partial;
            lodash.partialRight = partialRight;
            lodash.partition = partition;
            lodash.pick = pick;
            lodash.pickBy = pickBy;
            lodash.property = property;
            lodash.propertyOf = propertyOf;
            lodash.pull = pull;
            lodash.pullAll = pullAll;
            lodash.pullAllBy = pullAllBy;
            lodash.pullAllWith = pullAllWith;
            lodash.pullAt = pullAt;
            lodash.range = range;
            lodash.rangeRight = rangeRight;
            lodash.rearg = rearg;
            lodash.reject = reject;
            lodash.remove = remove;
            lodash.rest = rest;
            lodash.reverse = reverse;
            lodash.sampleSize = sampleSize;
            lodash.set = set;
            lodash.setWith = setWith;
            lodash.shuffle = shuffle;
            lodash.slice = slice;
            lodash.sortBy = sortBy;
            lodash.sortedUniq = sortedUniq;
            lodash.sortedUniqBy = sortedUniqBy;
            lodash.split = split;
            lodash.spread = spread;
            lodash.tail = tail;
            lodash.take = take;
            lodash.takeRight = takeRight;
            lodash.takeRightWhile = takeRightWhile;
            lodash.takeWhile = takeWhile;
            lodash.tap = tap;
            lodash.throttle = throttle;
            lodash.thru = thru;
            lodash.toArray = toArray;
            lodash.toPairs = toPairs;
            lodash.toPairsIn = toPairsIn;
            lodash.toPath = toPath;
            lodash.toPlainObject = toPlainObject;
            lodash.transform = transform;
            lodash.unary = unary;
            lodash.union = union;
            lodash.unionBy = unionBy;
            lodash.unionWith = unionWith;
            lodash.uniq = uniq;
            lodash.uniqBy = uniqBy;
            lodash.uniqWith = uniqWith;
            lodash.unset = unset;
            lodash.unzip = unzip;
            lodash.unzipWith = unzipWith;
            lodash.update = update;
            lodash.updateWith = updateWith;
            lodash.values = values;
            lodash.valuesIn = valuesIn;
            lodash.without = without;
            lodash.words = words;
            lodash.wrap = wrap;
            lodash.xor = xor;
            lodash.xorBy = xorBy;
            lodash.xorWith = xorWith;
            lodash.zip = zip;
            lodash.zipObject = zipObject;
            lodash.zipObjectDeep = zipObjectDeep;
            lodash.zipWith = zipWith;
            lodash.entries = toPairs;
            lodash.entriesIn = toPairsIn;
            lodash.extend = assignIn;
            lodash.extendWith = assignInWith;
            mixin(lodash, lodash);
            lodash.add = add;
            lodash.attempt = attempt;
            lodash.camelCase = camelCase;
            lodash.capitalize = capitalize;
            lodash.ceil = ceil;
            lodash.clamp = clamp;
            lodash.clone = clone;
            lodash.cloneDeep = cloneDeep;
            lodash.cloneDeepWith = cloneDeepWith;
            lodash.cloneWith = cloneWith;
            lodash.conformsTo = conformsTo;
            lodash.deburr = deburr;
            lodash.defaultTo = defaultTo;
            lodash.divide = divide;
            lodash.endsWith = endsWith;
            lodash.eq = eq;
            lodash.escape = escape;
            lodash.escapeRegExp = escapeRegExp;
            lodash.every = every;
            lodash.find = find;
            lodash.findIndex = findIndex;
            lodash.findKey = findKey;
            lodash.findLast = findLast;
            lodash.findLastIndex = findLastIndex;
            lodash.findLastKey = findLastKey;
            lodash.floor = floor;
            lodash.forEach = forEach;
            lodash.forEachRight = forEachRight;
            lodash.forIn = forIn;
            lodash.forInRight = forInRight;
            lodash.forOwn = forOwn;
            lodash.forOwnRight = forOwnRight;
            lodash.get = get;
            lodash.gt = gt;
            lodash.gte = gte;
            lodash.has = has;
            lodash.hasIn = hasIn;
            lodash.head = head;
            lodash.identity = identity;
            lodash.includes = includes;
            lodash.indexOf = indexOf;
            lodash.inRange = inRange;
            lodash.invoke = invoke;
            lodash.isArguments = isArguments;
            lodash.isArray = isArray;
            lodash.isArrayBuffer = isArrayBuffer;
            lodash.isArrayLike = isArrayLike;
            lodash.isArrayLikeObject = isArrayLikeObject;
            lodash.isBoolean = isBoolean;
            lodash.isBuffer = isBuffer;
            lodash.isDate = isDate;
            lodash.isElement = isElement;
            lodash.isEmpty = isEmpty;
            lodash.isEqual = isEqual;
            lodash.isEqualWith = isEqualWith;
            lodash.isError = isError;
            lodash.isFinite = isFinite;
            lodash.isFunction = isFunction;
            lodash.isInteger = isInteger;
            lodash.isLength = isLength;
            lodash.isMap = isMap;
            lodash.isMatch = isMatch;
            lodash.isMatchWith = isMatchWith;
            lodash.isNaN = isNaN;
            lodash.isNative = isNative;
            lodash.isNil = isNil;
            lodash.isNull = isNull;
            lodash.isNumber = isNumber;
            lodash.isObject = isObject;
            lodash.isObjectLike = isObjectLike;
            lodash.isPlainObject = isPlainObject;
            lodash.isRegExp = isRegExp;
            lodash.isSafeInteger = isSafeInteger;
            lodash.isSet = isSet;
            lodash.isString = isString;
            lodash.isSymbol = isSymbol;
            lodash.isTypedArray = isTypedArray;
            lodash.isUndefined = isUndefined;
            lodash.isWeakMap = isWeakMap;
            lodash.isWeakSet = isWeakSet;
            lodash.join = join;
            lodash.kebabCase = kebabCase;
            lodash.last = last;
            lodash.lastIndexOf = lastIndexOf;
            lodash.lowerCase = lowerCase;
            lodash.lowerFirst = lowerFirst;
            lodash.lt = lt;
            lodash.lte = lte;
            lodash.max = max;
            lodash.maxBy = maxBy;
            lodash.mean = mean;
            lodash.meanBy = meanBy;
            lodash.min = min;
            lodash.minBy = minBy;
            lodash.stubArray = stubArray;
            lodash.stubFalse = stubFalse;
            lodash.stubObject = stubObject;
            lodash.stubString = stubString;
            lodash.stubTrue = stubTrue;
            lodash.multiply = multiply;
            lodash.nth = nth;
            lodash.noConflict = noConflict;
            lodash.noop = noop;
            lodash.now = now;
            lodash.pad = pad;
            lodash.padEnd = padEnd;
            lodash.padStart = padStart;
            lodash.parseInt = parseInt1;
            lodash.random = random;
            lodash.reduce = reduce;
            lodash.reduceRight = reduceRight;
            lodash.repeat = repeat;
            lodash.replace = replace;
            lodash.result = result;
            lodash.round = round;
            lodash.runInContext = runInContext;
            lodash.sample = sample;
            lodash.size = size;
            lodash.snakeCase = snakeCase;
            lodash.some = some;
            lodash.sortedIndex = sortedIndex;
            lodash.sortedIndexBy = sortedIndexBy;
            lodash.sortedIndexOf = sortedIndexOf;
            lodash.sortedLastIndex = sortedLastIndex;
            lodash.sortedLastIndexBy = sortedLastIndexBy;
            lodash.sortedLastIndexOf = sortedLastIndexOf;
            lodash.startCase = startCase;
            lodash.startsWith = startsWith;
            lodash.subtract = subtract;
            lodash.sum = sum;
            lodash.sumBy = sumBy;
            lodash.template = template;
            lodash.times = times;
            lodash.toFinite = toFinite;
            lodash.toInteger = toInteger;
            lodash.toLength = toLength;
            lodash.toLower = toLower;
            lodash.toNumber = toNumber;
            lodash.toSafeInteger = toSafeInteger;
            lodash.toString = toString;
            lodash.toUpper = toUpper;
            lodash.trim = trim;
            lodash.trimEnd = trimEnd;
            lodash.trimStart = trimStart;
            lodash.truncate = truncate;
            lodash.unescape = unescape;
            lodash.uniqueId = uniqueId;
            lodash.upperCase = upperCase;
            lodash.upperFirst = upperFirst;
            lodash.each = forEach;
            lodash.eachRight = forEachRight;
            lodash.first = head;
            mixin(lodash, function() {
                var source = {};
                baseForOwn(lodash, function(func, methodName) {
                    if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
                });
                return source;
            }(), {
                'chain': false
            });
            lodash.VERSION = VERSION;
            arrayEach([
                'bind',
                'bindKey',
                'curry',
                'curryRight',
                'partial',
                'partialRight'
            ], function(methodName) {
                lodash[methodName].placeholder = lodash;
            });
            arrayEach([
                'drop',
                'take'
            ], function(methodName, index) {
                LazyWrapper.prototype[methodName] = function(n) {
                    n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                    var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                    if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                    else result.__views__.push({
                        'size': nativeMin(n, MAX_ARRAY_LENGTH),
                        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                    });
                    return result;
                };
                LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                    return this.reverse()[methodName](n).reverse();
                };
            });
            arrayEach([
                'filter',
                'map',
                'takeWhile'
            ], function(methodName, index) {
                var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
                LazyWrapper.prototype[methodName] = function(iteratee) {
                    var result = this.clone();
                    result.__iteratees__.push({
                        'iteratee': getIteratee(iteratee, 3),
                        'type': type
                    });
                    result.__filtered__ = result.__filtered__ || isFilter;
                    return result;
                };
            });
            arrayEach([
                'head',
                'last'
            ], function(methodName, index) {
                var takeName = 'take' + (index ? 'Right' : '');
                LazyWrapper.prototype[methodName] = function() {
                    return this[takeName](1).value()[0];
                };
            });
            arrayEach([
                'initial',
                'tail'
            ], function(methodName, index) {
                var dropName = 'drop' + (index ? '' : 'Right');
                LazyWrapper.prototype[methodName] = function() {
                    return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
                };
            });
            LazyWrapper.prototype.compact = function() {
                return this.filter(identity);
            };
            LazyWrapper.prototype.find = function(predicate) {
                return this.filter(predicate).head();
            };
            LazyWrapper.prototype.findLast = function(predicate) {
                return this.reverse().find(predicate);
            };
            LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
                if (typeof path == 'function') return new LazyWrapper(this);
                return this.map(function(value) {
                    return baseInvoke(value, path, args);
                });
            });
            LazyWrapper.prototype.reject = function(predicate) {
                return this.filter(negate(getIteratee(predicate)));
            };
            LazyWrapper.prototype.slice = function(start, end) {
                start = toInteger(start);
                var result = this;
                if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
                if (start < 0) result = result.takeRight(-start);
                else if (start) result = result.drop(start);
                if (end !== undefined) {
                    end = toInteger(end);
                    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
                }
                return result;
            };
            LazyWrapper.prototype.takeRightWhile = function(predicate) {
                return this.reverse().takeWhile(predicate).reverse();
            };
            LazyWrapper.prototype.toArray = function() {
                return this.take(MAX_ARRAY_LENGTH);
            };
            baseForOwn(LazyWrapper.prototype, function(func, methodName) {
                var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
                if (!lodashFunc) return;
                lodash.prototype[methodName] = function() {
                    var value = this.__wrapped__, args = isTaker ? [
                        1
                    ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                    var interceptor = function(value) {
                        var result = lodashFunc.apply(lodash, arrayPush([
                            value
                        ], args));
                        return isTaker && chainAll ? result[0] : result;
                    };
                    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) isLazy = useLazy = false;
                    var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                    if (!retUnwrapped && useLazy) {
                        value = onlyLazy ? value : new LazyWrapper(this);
                        var result = func.apply(value, args);
                        result.__actions__.push({
                            'func': thru,
                            'args': [
                                interceptor
                            ],
                            'thisArg': undefined
                        });
                        return new LodashWrapper(result, chainAll);
                    }
                    if (isUnwrapped && onlyLazy) return func.apply(this, args);
                    result = this.thru(interceptor);
                    return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
                };
            });
            arrayEach([
                'pop',
                'push',
                'shift',
                'sort',
                'splice',
                'unshift'
            ], function(methodName) {
                var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
                lodash.prototype[methodName] = function() {
                    var args = arguments;
                    if (retUnwrapped && !this.__chain__) {
                        var value = this.value();
                        return func.apply(isArray(value) ? value : [], args);
                    }
                    return this[chainName](function(value) {
                        return func.apply(isArray(value) ? value : [], args);
                    });
                };
            });
            baseForOwn(LazyWrapper.prototype, function(func, methodName) {
                var lodashFunc = lodash[methodName];
                if (lodashFunc) {
                    var key = lodashFunc.name + '';
                    if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                    realNames[key].push({
                        'name': methodName,
                        'func': lodashFunc
                    });
                }
            });
            realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
                {
                    'name': 'wrapper',
                    'func': undefined
                }
            ];
            LazyWrapper.prototype.clone = lazyClone;
            LazyWrapper.prototype.reverse = lazyReverse;
            LazyWrapper.prototype.value = lazyValue;
            lodash.prototype.at = wrapperAt;
            lodash.prototype.chain = wrapperChain;
            lodash.prototype.commit = wrapperCommit;
            lodash.prototype.next = wrapperNext;
            lodash.prototype.plant = wrapperPlant;
            lodash.prototype.reverse = wrapperReverse;
            lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
            lodash.prototype.first = lodash.prototype.head;
            if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
            return lodash;
        };
        var _ = runInContext();
        if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
            root._ = _;
            define(function() {
                return _;
            });
        } else if (freeModule) {
            (freeModule.exports = _)._ = _;
            freeExports._ = _;
        } else root._ = _;
    }).call(this);
});
parcelRegister("azprR", function(module, exports) {
    $parcel$export(module.exports, "assertResponseIsOk", ()=>$cdf471401ddfc746$export$b3732c8ff6f9c463);
    $parcel$export(module.exports, "toLoading", ()=>$cdf471401ddfc746$export$f9a5bd0ffba29ffc);
    $parcel$export(module.exports, "toError", ()=>$cdf471401ddfc746$export$cc3b967c039ed3e7);
    $parcel$export(module.exports, "toData", ()=>$cdf471401ddfc746$export$24a6b176bdc41ce5);
    const $cdf471401ddfc746$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
            status: status,
            statusText: statusText
        });
    const $cdf471401ddfc746$export$b3732c8ff6f9c463 = (res)=>{
        if (res.ok) return res;
        throw new Error($cdf471401ddfc746$export$18a0019e5439b209(res));
    };
    const $cdf471401ddfc746$export$f9a5bd0ffba29ffc = ()=>({
            isLoading: true,
            data: undefined,
            error: undefined
        });
    const $cdf471401ddfc746$export$cc3b967c039ed3e7 = (error)=>({
            isLoading: false,
            error: error instanceof Error ? error : Error(String(error)),
            data: undefined
        });
    const $cdf471401ddfc746$export$24a6b176bdc41ce5 = (data)=>({
            isLoading: false,
            error: undefined,
            data: data
        });
});
parcelRegister("7PgHB", function(module, exports) {
    $parcel$export(module.exports, "usePlacementApi", ()=>$5453278665841f55$export$201bbce8187a6e3c);
    var $gHZ4O;
    var $fZeMt;
    var $03pZ8;
    var $9uYQQ;
    var $5uXOq = parcelRequire("5uXOq");
    const $5453278665841f55$export$201bbce8187a6e3c = (path, config)=>{
        const { placementId: placementId } = (0, (0, parcelRequire("9uYQQ")).usePlacementContext)();
        const context = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const fetcher = (0, (0, parcelRequire("fZeMt")).usePlacementFetchingContext)();
        const placementApi = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if (!placementId) return ()=>({
                    isLoading: false,
                    data: undefined,
                    error: new Error('No placementId found, make this is used as a child of PlacementProvider')
                });
            return (0, (0, parcelRequire("03pZ8")).createUsePlacement)(placementId, fetcher);
        }, [
            placementId,
            fetcher
        ]);
        return placementApi(path, context, config?.requestOptions, {
            throttleTime: config?.throttleTime,
            isEnabled: config?.autoRefetch?.isEnabled,
            deps: [
                config?.autoRefetch?.updateKey
            ]
        });
    };
});
parcelRegister("fZeMt", function(module, exports) {
    $parcel$export(module.exports, "usePlacementFetchingContext", ()=>$00e4cc9f3aa9cb20$export$e1e2cdb0425a9fa8);
    $parcel$export(module.exports, "PlacementFetchingProvider", ()=>$00e4cc9f3aa9cb20$export$5f25a6ddf0324fa8);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $00e4cc9f3aa9cb20$export$afec669dc416ee7e = (0, $5uXOq.createContext)({
        fetch: (...args)=>globalThis.fetch(...args)
    });
    const $00e4cc9f3aa9cb20$export$e1e2cdb0425a9fa8 = ()=>(0, $5uXOq.useContext)($00e4cc9f3aa9cb20$export$afec669dc416ee7e);
    const $00e4cc9f3aa9cb20$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                fetch: fetch
            }), [
            fetch
        ]);
        return (0, $2OMIu.jsx)($00e4cc9f3aa9cb20$export$afec669dc416ee7e.Provider, {
            value: value,
            children: children
        });
    };
});
parcelRegister("03pZ8", function(module, exports) {
    $parcel$export(module.exports, "createUsePlacement", ()=>$2f9421ba9832c4c5$export$ee1d67e435d25cb5);
    var $9WBRO;
    var $5uXOq = parcelRequire("5uXOq");
    var $5NGOu;
    const $2f9421ba9832c4c5$var$depsIsValid = (deps)=>Array.isArray(deps);
    const $2f9421ba9832c4c5$export$ee1d67e435d25cb5 = (placementId, fetcher = {
        fetch: (...args)=>globalThis.fetch(...args)
    })=>{
        if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
        return (path, context, requestOptions, config)=>{
            const dependencyList = $2f9421ba9832c4c5$var$depsIsValid(config?.deps) ? [
                ...config.deps,
                config?.isEnabled
            ] : [
                path,
                config?.isEnabled
            ];
            const timerRef = (0, $5uXOq.useRef)();
            const isRunningPromise = (0, $5uXOq.useRef)(false);
            (0, $5uXOq.useEffect)(()=>{
                return ()=>{
                    if (timerRef.current) clearTimeout(timerRef.current);
                };
            }, []);
            const promiseToResolve = (0, $5uXOq.useMemo)(()=>{
                if (config?.isEnabled === false) return undefined;
                return ({ signal: signal })=>{
                    if (isRunningPromise.current) return Promise.reject(new (0, (0, parcelRequire("5NGOu")).AlreadyRunningError)());
                    isRunningPromise.current = true;
                    timerRef.current = setTimeout(()=>{
                        isRunningPromise.current = false;
                    }, config?.throttleTime ?? 0);
                    return (0, (0, parcelRequire("9WBRO")).fetchPlacementData)(placementId, path, context, fetcher, {
                        ...requestOptions,
                        signal: signal
                    });
                };
            }, dependencyList);
            return (0, (0, parcelRequire("5NGOu")).useData)(promiseToResolve, {
                analytics: {
                    name: placementId,
                    path: path
                }
            });
        };
    };
});
parcelRegister("9WBRO", function(module, exports) {
    $parcel$export(module.exports, "fetchPlacementData", ()=>$c30f2183bae3b705$export$ce743d02f83ee521);
    const $c30f2183bae3b705$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
    const $c30f2183bae3b705$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
    const $c30f2183bae3b705$var$stringifyObjectValues = (input)=>{
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, value])=>$c30f2183bae3b705$var$isNotEmpty(value)).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    };
    const $c30f2183bae3b705$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
        const defaultHeaders = {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json'
        };
        const normalizedPath = `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
        const contextAsSearchParams = new URLSearchParams($c30f2183bae3b705$var$stringifyObjectValues(context)).toString();
        const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
        const url = encodeURI(`${$c30f2183bae3b705$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
        return fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...defaultHeaders,
                ...requestOptions?.headers
            }
        });
    };
});
parcelRegister("92Slv", function(module, exports) {
    $parcel$export(module.exports, "scopes", ()=>$55067e880e752544$export$54a06e3f4a159ad8);
    const $55067e880e752544$export$54a06e3f4a159ad8 = [
        {
            name: 'all',
            when: {
                route: {
                    pathname: {
                        matches: '.*'
                    }
                }
            }
        },
        {
            name: 'jira/all',
            when: {
                context: {
                    product: 'jira'
                }
            }
        },
        {
            name: 'jira/kanban',
            when: {
                context: {
                    product: 'jira'
                },
                route: {
                    pathname: {
                        matches: 'boards'
                    }
                }
            }
        },
        {
            name: 'confluence/all',
            when: {
                context: {
                    product: 'confluence'
                }
            }
        },
        {
            name: 'pop3/all',
            when: {
                context: {
                    product: 'pop3'
                }
            }
        },
        {
            name: 'admin/all',
            when: {
                context: {
                    product: 'admin'
                }
            }
        },
        {
            name: 'pop3/send-it',
            when: {
                context: {
                    product: 'pop3'
                },
                route: {
                    pathname: {
                        matches: 'send-it'
                    }
                }
            }
        },
        {
            name: 'admin/products',
            when: {
                context: {
                    product: 'admin'
                },
                route: {
                    pathname: {
                        matches: 'products'
                    }
                }
            }
        },
        {
            name: 'trello/all',
            when: {
                context: {
                    product: 'trello'
                }
            }
        }
    ];
});
parcelRegister("4rq6q", function(module, exports) {
    $parcel$export(module.exports, "MessageRenderer", ()=>$41d16ae43af486d7$export$2df1250b8f917a59);
    var $jOeT9;
    var $dEv4p;
    var $afxIx;
    var $5o9nW;
    const $41d16ae43af486d7$export$e30378e28ad3e6ab = {
        ...(0, (0, parcelRequire("dEv4p")).default),
        ...(0, (0, parcelRequire("afxIx")).default),
        ...(0, (0, parcelRequire("5o9nW")).default)
    };
    const { initializeMessageRenderer: $41d16ae43af486d7$export$bce4e5106d86e473, MessageRenderer: $41d16ae43af486d7$export$2df1250b8f917a59 } = (0, (0, parcelRequire("jOeT9")).asMessageRenderer)($41d16ae43af486d7$export$e30378e28ad3e6ab);
});
parcelRegister("jOeT9", function(module, exports) {
    $parcel$export(module.exports, "asMessageRenderer", ()=>$aac06bc7b75bd846$export$7b7e5a348ef9a7c1);
    var $2OMIu = parcelRequire("2OMIu");
    var $5IPCv;
    var $e8o2I;
    var $5H0An;
    var $7ldM3;
    var $11KUO;
    var $fSNBK = parcelRequire("fSNBK");
    var $eyw2y;
    var $5uXOq = parcelRequire("5uXOq");
    var $g0Qxc;
    var $emlqA;
    var $k42Hu;
    var $cMrkQ;
    const $aac06bc7b75bd846$export$14fe1fc3395b6e3f = ({ children: children })=>{
        const { messageViewed: messageViewed } = (0, $fSNBK.useMessageEvent)();
        const messageViewedVoidFunction = (0, $5uXOq.useCallback)(()=>{
            messageViewed();
        }, [
            messageViewed
        ]);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("k42Hu")).TrackMount), {
            onMount: messageViewedVoidFunction,
            children: children
        });
    };
    const $aac06bc7b75bd846$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
        const initializeMessageRenderer = ()=>{
            return ({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, ...data })=>{
                const isUFOEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_ufo_tracking_in_post_office');
                const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $5uXOq.useMemo)(()=>{
                    const messagePerformanceTracker = isUFOEnabled ? new (0, (0, parcelRequire("e8o2I")).UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                    const onMessageSuccess = ()=>{
                        messagePerformanceTracker?.markSuccess();
                    };
                    const markMessageFailed = (onError)=>(error, info)=>{
                            messagePerformanceTracker?.markFailure(error);
                            onError && onError(error, info);
                        };
                    return {
                        markMessageUnmounted: messagePerformanceTracker?.abort,
                        markMessageFailed: markMessageFailed,
                        messageSuccessComponent: (0, $2OMIu.jsx)((0, (0, parcelRequire("k42Hu")).TrackMount), {
                            onMount: onMessageSuccess
                        })
                    };
                }, [
                    messageTemplateId
                ]);
                (0, $5uXOq.useEffect)(()=>{
                    return ()=>{
                        markMessageUnmounted?.();
                    };
                }, [
                    markMessageUnmounted
                ]);
                const Core = ()=>{
                    const Component = messageComponents?.[messageTemplateId];
                    if (!Component) throw new (0, (0, parcelRequire("7ldM3")).InvalidMessageTemplateIdError)(JSON.stringify({
                        messageTemplateId: messageTemplateId,
                        messageInstanceId: messageInstanceId
                    }));
                    let validatedMessage;
                    if (messageValidator) {
                        validatedMessage = messageValidator(data);
                        if (!validatedMessage) throw new (0, (0, parcelRequire("7ldM3")).MessageRendererEmptyValidationResponseError)();
                    }
                    const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOLoadHold, {
                            name: (0, (0, parcelRequire("5H0An")).UFOv2).HoldNames.MESSAGE,
                            children: loadingFallback ?? null
                        }) : (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                            children: loadingFallback ?? null
                        }), [
                        loadingFallback,
                        isUFOEnabled
                    ]);
                    const componentProps = messageValidator ? validatedMessage : data;
                    if (!Component) return null;
                    return (0, $2OMIu.jsx)((0, (0, parcelRequire("g0Qxc")).ChoreographerWrapper), {
                        messageId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        children: (0, $2OMIu.jsx)($aac06bc7b75bd846$var$FeatureFlaggedUfoWrapper, {
                            messageTemplateId: messageTemplateId,
                            isEnabled: isUFOEnabled,
                            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("11KUO")).MessageContextProvider), {
                                value: {
                                    messageInstanceId: messageInstanceId,
                                    messageTemplateId: messageTemplateId,
                                    transactionAccountId: componentProps.transactionAccountId,
                                    analyticsDetails: postOffice?.analyticsDetails
                                },
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("eyw2y")).RecommendationProvider), {
                                    value: recommendationSession ?? {},
                                    children: (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                                        fallback: loadingComponent,
                                        children: (0, $2OMIu.jsx)((0, (0, parcelRequire("emlqA")).MessageAnalyticsContextProvider), {
                                            children: (0, $2OMIu.jsxs)($aac06bc7b75bd846$export$14fe1fc3395b6e3f, {
                                                children: [
                                                    messageSuccessComponent,
                                                    (0, $2OMIu.jsx)(Component, {
                                                        ...componentProps
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    });
                };
                return (0, (0, parcelRequire("cMrkQ")).withErrorBoundary)(Core)({
                    errorBoundaryLocation: 'placement-message-renderer-component',
                    fallbackRender: fallbackRender,
                    onError: markMessageFailed(onError)
                });
            };
        };
        return {
            initializeMessageRenderer: initializeMessageRenderer,
            MessageRenderer: initializeMessageRenderer()
        };
    };
    const $aac06bc7b75bd846$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
        if (isEnabled) return (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.MESSAGE,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
                name: `${(0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
                children: children
            })
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("e8o2I", function(module, exports) {
    $parcel$export(module.exports, "UFOv1", ()=>$a466d65029d54037$export$96236906ebaa7f87);
    var $l3Xnu;
    var $54QtS;
    const $a466d65029d54037$export$96236906ebaa7f87 = {
        MessagePerformanceTracker: (0, parcelRequire("l3Xnu")).MessagePerformanceTracker,
        PlacementPerformanceTracker: (0, parcelRequire("54QtS")).PlacementPerformanceTracker
    };
});
parcelRegister("l3Xnu", function(module, exports) {
    $parcel$export(module.exports, "MessagePerformanceTracker", ()=>$a3763ad05a43d408$export$ae5c73c7c4f454e6);
    var $atdLB;
    var $duUGa;
    var $eAOqW;
    class $a3763ad05a43d408$export$ae5c73c7c4f454e6 {
        constructor(messageTemplateId){
            this.metadata = {};
            this.markSuccess = ()=>{
                for (const experience of this.experiences)experience.success({
                    metadata: this.metadata
                });
            };
            this.markFailure = (error)=>{
                for (const experience of this.experiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.abort = ()=>{
                for (const experience of this.experiences)experience.abort({
                    metadata: this.metadata
                });
            };
            this.aggregatedExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)((0, (0, parcelRequire("eAOqW")).UFOExperienceNames).MESSAGE, {
                performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad,
                type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
                platform: {
                    component: (0, (0, parcelRequire("eAOqW")).POST_OFFICE_PLATFORM_NAME)
                }
            });
            this.messageSpecificExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)(`${(0, (0, parcelRequire("eAOqW")).UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
                performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad,
                type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
                platform: {
                    component: (0, (0, parcelRequire("eAOqW")).POST_OFFICE_PLATFORM_NAME)
                }
            });
            this.experiences = [
                this.aggregatedExperience,
                this.messageSpecificExperience
            ];
            this.experiences.forEach((experience)=>experience.start());
            this.metadata = {
                messageTemplateId: messageTemplateId
            };
        }
    }
});
parcelRegister("eAOqW", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceNames", ()=>$bb03824d593f40fc$export$cc7ddf8ca628f6f1);
    $parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", ()=>$bb03824d593f40fc$export$6d482cfa20c9d220);
    const $bb03824d593f40fc$export$cc7ddf8ca628f6f1 = {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    };
    const $bb03824d593f40fc$export$6d482cfa20c9d220 = 'post-office';
});
parcelRegister("54QtS", function(module, exports) {
    $parcel$export(module.exports, "PlacementPerformanceTracker", ()=>$7a667d0616a9ade0$export$8b48c2105ba0b35a);
    var $atdLB;
    var $duUGa;
    var $eAOqW;
    const $7a667d0616a9ade0$var$STEPS = {
        RML_FETCH: 'rml-fetch',
        RML_RENDER: 'rml-render',
        INITIAL_DATA: 'initial-data-load',
        COMPONENT_READY: 'component-ready'
    };
    const $7a667d0616a9ade0$var$UFO_EXPERIENCE_CONFIG = {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        platform: {
            component: (0, (0, parcelRequire("eAOqW")).POST_OFFICE_PLATFORM_NAME)
        },
        timings: [
            {
                key: `${$7a667d0616a9ade0$var$STEPS.RML_FETCH}-complete`,
                endMark: `${$7a667d0616a9ade0$var$STEPS.RML_FETCH}-complete`
            },
            {
                key: `${$7a667d0616a9ade0$var$STEPS.RML_RENDER}-complete`,
                endMark: `${$7a667d0616a9ade0$var$STEPS.RML_RENDER}-complete`
            },
            {
                key: `${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-complete`,
                endMark: `${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-complete`
            },
            {
                key: `${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-error`,
                endMark: `${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-error`
            }
        ]
    };
    class $7a667d0616a9ade0$export$8b48c2105ba0b35a {
        constructor(placementId, consumptionType = 'remote'){
            this.placementExperiences = [];
            this.metadata = {};
            this.markFetchComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$7a667d0616a9ade0$var$STEPS.RML_FETCH}-complete`);
            };
            this.markRenderComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$7a667d0616a9ade0$var$STEPS.RML_RENDER}-complete`);
            };
            this.markInitialDataComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-complete`);
            };
            this.markComponentReady = ()=>{
                for (const experience of this.placementExperiences)experience.success({
                    metadata: this.metadata
                });
            };
            this.markFetchFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $7a667d0616a9ade0$var$STEPS.RML_FETCH,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markRenderFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $7a667d0616a9ade0$var$STEPS.RML_RENDER,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markInitialDataFailure = (_)=>{
                for (const experience of this.placementExperiences)experience.mark(`${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-error`);
            };
            this.markComponentFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $7a667d0616a9ade0$var$STEPS.COMPONENT_READY,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markComponentAborted = ()=>{
                for (const experience of this.placementExperiences)experience.abort({
                    metadata: this.metadata
                });
            };
            this.aggregatedExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)((0, (0, parcelRequire("eAOqW")).UFOExperienceNames).PLACEMENT, $7a667d0616a9ade0$var$UFO_EXPERIENCE_CONFIG);
            this.placementSpecificExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)(`${(0, (0, parcelRequire("eAOqW")).UFOExperienceNames).PLACEMENT}.${placementId}`, $7a667d0616a9ade0$var$UFO_EXPERIENCE_CONFIG);
            this.placementExperiences = [
                this.aggregatedExperience,
                this.placementSpecificExperience
            ];
            for (const experience of this.placementExperiences)experience.start();
            this.metadata = {
                placementId: placementId,
                consumptionType: consumptionType
            };
        }
    }
});
parcelRegister("7ldM3", function(module, exports) {
    $parcel$export(module.exports, "InvalidMessageTemplateIdError", ()=>$f5a4f751215d8970$export$19cb89dd679394cb);
    $parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", ()=>$f5a4f751215d8970$export$3dfc27a8d3942f4d);
    var $f5a4f751215d8970$export$b9722560029694e7;
    (function(PostOfficeErrorCodes) {
        PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
        PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
        PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
        PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
        PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
        PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
        PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
        PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
        PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
        PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
        PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
        PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
        PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
        PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
        PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
        PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
        PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
        PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
        PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
        PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
        PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
        PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
        PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
        PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
        PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
        PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
        PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
        PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
        PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
        PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
        PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
        PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
        PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    })($f5a4f751215d8970$export$b9722560029694e7 || ($f5a4f751215d8970$export$b9722560029694e7 = {}));
    class $f5a4f751215d8970$export$46f86d28cd0a5d38 extends Error {
    }
    class $f5a4f751215d8970$export$627bc00a5ef5f6ae extends Error {
    }
    class $f5a4f751215d8970$export$d145ea5319863172 extends Error {
        constructor(message, code){
            super(message);
            this.code = code;
        }
    }
    class $f5a4f751215d8970$export$f649da38897d27f7 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "NotAbleToProcessRecipientExpansionInputError");
            this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$c2852c1c4d9aba3e extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "RecipientExpansionProcessingError");
            this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$4b7b4e09547e4bb3 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "RecipientExpansionMethodInvocationError");
            this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$360a094a97597d87 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "RecipientExpansionManagerError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$4d068b43eb55165b extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "NotAbleToProcessRecipientExpansionInputError");
            this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$ac007ee150add337 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "ReceiverInputValidationError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$b79ba63f8ae791e0 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "HandlerValidationError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$19cb89dd679394cb extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "InvalidMessageTemplateIdError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$78651662ad470cc5 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Message Template not found', "MessageTemplateNotFoundError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$913b8e68dc7ae8fe extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Placement not found', "PlacementNotFoundError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$3dfc27a8d3942f4d extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$e5ccdf8bbfead7a2 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Failed to send some events', "IngestionHandlerFailedSendError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$823733742d803ae6 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Failed to send some events', "OrchestrationHandlerFailedSendError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$a6f2aad8fa094b39 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(accountId){
            super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError");
            this.accountId = accountId;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$2f1e27130c2bf271 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, payloadSize){
            super(message, "InvalidPayloadError");
            this.name = this.constructor.name;
            this.payloadSize = payloadSize;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$d0dc094613469f2b extends $f5a4f751215d8970$export$46f86d28cd0a5d38 {
        constructor(message, workspaceId){
            super(message);
            this.name = this.constructor.name;
            this.workspaceId = workspaceId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$5603eab37ce562f5 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(fileType){
            super('The attachment file is not supported', "UnsupportedAttachmentType");
            this.name = this.constructor.name;
            this.fileType = fileType;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$b35ca1cf49054efc extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, email){
            super(message, "UnsupportedEmailError");
            this.name = this.constructor.name;
            this.email = email;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$e0e9aa0e9c6b37ff extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, error){
            super(message, "InvalidEmailRequestHeader");
            this.name = this.constructor.name;
            this.error = error;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$3ad818f64601e141 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "NonProdEmailDomainError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$25470bb6cba4fba0 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
            super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
            this.name = this.constructor.name;
            this.messageTemplateId = messageTemplateId;
            this.placementId = placementId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$ce14d445679448b6 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
            super(message, "HydrationFailureAtPlacementError");
            this.name = this.constructor.name;
            this.messageTemplateId = messageTemplateId;
            this.messageInstanceId = messageInstanceId;
            this.placementId = placementId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$8ab4fb362168b928 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$2afd69f57fe5285f extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Recipient expander not found for mapper', "UnusedValidateError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$7635d2b1a281d626 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, errors){
            super(message, "GrowthRecRecommendationsError");
            this.errors = errors;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$9e1c6d00e675bc86 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, recipient){
            super(message, "RichRecipientError");
            this.name = this.constructor.name;
            this.recipient = recipient;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$90bef7fa95eca3fa extends Error {
        constructor(status){
            super('Posting Mobile Notifications message failed');
            this.status = status;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$6d1a4929f6ff1a32 extends $f5a4f751215d8970$export$46f86d28cd0a5d38 {
        constructor(message){
            super(message);
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$89bf5f64fbf0698 extends $f5a4f751215d8970$export$46f86d28cd0a5d38 {
        constructor(message, error){
            super(message, {
                ...error ? {
                    cause: error
                } : {}
            });
            this.error = error;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$c19fc5e8aa4e064d extends Error {
        constructor(){
            super('Ingestion source is required when custom profile is specified');
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$2d3a68dab93b8cc4 extends Error {
        constructor(){
            super('A renderRedacted function is required when redactionLevel is set to a non-null value');
            this.name = this.constructor.name;
        }
    }
    class $f5a4f751215d8970$export$175c1dbb0d7c238a extends Error {
        constructor(status){
            super('Enqueueing email failed');
            this.status = status;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$23fab744b3076342 extends Error {
        constructor(message, status){
            super(message);
            this.message = message;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
});
parcelRegister("11KUO", function(module, exports) {
    $parcel$export(module.exports, "MessageContextProvider", ()=>$2682dcdca1a24b7e$export$42de33f7652dc3de);
    $parcel$export(module.exports, "useMessageContext", ()=>$2682dcdca1a24b7e$export$a5b6d14a2e25725a);
    var $5uXOq = parcelRequire("5uXOq");
    const $2682dcdca1a24b7e$var$initialValue = {};
    const $2682dcdca1a24b7e$export$b060d577040138d8 = (0, $5uXOq.createContext)($2682dcdca1a24b7e$var$initialValue);
    const $2682dcdca1a24b7e$export$42de33f7652dc3de = $2682dcdca1a24b7e$export$b060d577040138d8.Provider;
    const $2682dcdca1a24b7e$export$a5b6d14a2e25725a = ()=>(0, $5uXOq.useContext)($2682dcdca1a24b7e$export$b060d577040138d8);
});
parcelRegister("fSNBK", function(module, exports) {
    $parcel$export(module.exports, "useMessageEvent", ()=>$270b6426b92107fa$export$3cbbf1e81e2ecb39);
    var $hWRix;
    var $gHZ4O;
    var $11KUO;
    var $9uYQQ;
    var $eyw2y;
    var $cEPXa = parcelRequire("cEPXa");
    var $lFhz5 = parcelRequire("lFhz5");
    var $kS28O = parcelRequire("kS28O");
    const $270b6426b92107fa$export$3cbbf1e81e2ecb39 = ()=>{
        if (!window.postOfficeMessageEventClient) window.postOfficeMessageEventClient = new (0, $lFhz5.MessageEventClient)();
        const client = window.postOfficeMessageEventClient;
        const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, (0, parcelRequire("hWRix")).useMessagePlacementHooks)();
        const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, (0, parcelRequire("11KUO")).useMessageContext)();
        const { placementId: placementId } = (0, (0, parcelRequire("9uYQQ")).usePlacementContext)();
        const browserContext = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const recommendationContext = (0, (0, parcelRequire("eyw2y")).useRecommendationContext)();
        const context = {
            browser: browserContext,
            recommendation: recommendationContext
        };
        return {
            markAllAsRead: async (messages)=>{
                const messagesEventPostPayload = messages.map((message)=>{
                    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
                    if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                    return {
                        messageInstanceId: message['messageInstanceId'],
                        messageTemplateId: message['messageTemplateId'],
                        type: (0, $kS28O.InAppMessageEventType).Read,
                        placement: placementId,
                        createdAt: Date.now(),
                        analyticsDetails: analyticsDetails,
                        context: context
                    };
                });
                try {
                    await client.markAllAsReadEvent(messagesEventPostPayload);
                } catch (error) {
                    throw new (0, $cEPXa.MessageLifecycleClientError)();
                }
            },
            messageRead: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                markReadFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                try {
                    await client.sendEvent({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        type: (0, $kS28O.InAppMessageEventType).Read,
                        placement: placementId,
                        createdAt: Date.now(),
                        analyticsDetails: analyticsDetails,
                        context: context
                    });
                } catch (error) {
                    throw new (0, $cEPXa.MessageLifecycleClientError)();
                }
            },
            messageUnread: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                try {
                    await client.sendEvent({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        type: (0, $kS28O.InAppMessageEventType).Unread,
                        placement: placementId,
                        createdAt: Date.now(),
                        context: context,
                        analyticsDetails: analyticsDetails
                    });
                } catch (error) {
                    throw new (0, $cEPXa.MessageLifecycleClientError)();
                }
            },
            messageViewed: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                markViewedFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $kS28O.InAppMessageEventType).Viewed,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageClicked: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                markClickedFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $kS28O.InAppMessageEventType).Clicked,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageClickedSecondary: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $kS28O.InAppMessageEventType).ClickedSecondary,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageAcknowledged: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $kS28O.InAppMessageEventType).Acknowledged,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageDismissed: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                dismissMessageFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $kS28O.InAppMessageEventType).Dismissed,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageSnoozed: async (snoozeDays)=>{
                const MILLIS_IN_A_DAY = 86400000;
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
                snoozeMessageFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $kS28O.InAppMessageEventType).Snoozed,
                    placement: placementId,
                    createdAt: Date.now(),
                    statusExpiryTime: statusExpiryTime,
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            }
        };
    };
});
parcelRegister("eyw2y", function(module, exports) {
    $parcel$export(module.exports, "RecommendationProvider", ()=>$52375d85c83d9b1b$export$f60e87d7b5f59562);
    $parcel$export(module.exports, "useRecommendationContext", ()=>$52375d85c83d9b1b$export$3321c0b02f750bcc);
    var $2OMIu = parcelRequire("2OMIu");
    var $daJ0i;
    var $5uXOq = parcelRequire("5uXOq");
    const $52375d85c83d9b1b$export$ba2f44035effd9c1 = (0, $5uXOq.createContext)({
        sessionId: undefined,
        entityId: undefined
    });
    const $52375d85c83d9b1b$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
        return (0, $2OMIu.jsx)($52375d85c83d9b1b$export$ba2f44035effd9c1.Provider, {
            value: value,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("daJ0i")).default), {
                data: value,
                children: children
            })
        });
    };
    const $52375d85c83d9b1b$export$3321c0b02f750bcc = ()=>(0, $5uXOq.useContext)($52375d85c83d9b1b$export$ba2f44035effd9c1);
});
parcelRegister("cEPXa", function(module, exports) {
    $parcel$export(module.exports, "MessageLifecycleContextError", ()=>$42af47fd4a7ac700$export$12bb62b204112f55);
    $parcel$export(module.exports, "MessageLifecycleClientError", ()=>$42af47fd4a7ac700$export$44f397e2afeb89e0);
    class $42af47fd4a7ac700$export$12bb62b204112f55 extends Error {
        constructor(){
            super('useMessageLifecycle must be used inside a Message template render component.');
        }
    }
    class $42af47fd4a7ac700$export$44f397e2afeb89e0 extends Error {
        constructor(){
            super('API call to /messages failed due to an error');
        }
    }
});
parcelRegister("lFhz5", function(module, exports) {
    $parcel$export(module.exports, "MessageEventClient", ()=>$fb9d10d91fecaeaf$export$ae86a6dabe385178);
    const $fb9d10d91fecaeaf$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
    const $fb9d10d91fecaeaf$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
    const $fb9d10d91fecaeaf$var$MESSAGE_EVENTS_BATCH_SIZE = 250;
    if (typeof fetch === 'undefined') (parcelRequire("fS9d8"));
    class $fb9d10d91fecaeaf$export$ae86a6dabe385178 {
        async sendEvent(event) {
            const url = `${this.endpointUrl}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(event)
            });
            if (!response.ok) console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
        }
        batchSendEvent(event) {
            this.batchEvents.push(event);
            if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $fb9d10d91fecaeaf$var$FLUSH_BATCH_EVENTS_TIMEOUT);
        }
        async markAllAsReadEvent(messages) {
            this.batchEvents.push(...messages);
            await this.flushBatchEvents();
        }
        async sendMessageEvents(events) {
            const url = `${this.endpointUrl}/bulk`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(events)
            });
            if (!response.ok) console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
        }
        async flushBatchEvents() {
            if (this.batchEvents.length === 0) return;
            if (this.batchEvents.length > $fb9d10d91fecaeaf$var$MESSAGE_EVENTS_BATCH_SIZE) {
                const batch = this.batchEvents.slice(0, $fb9d10d91fecaeaf$var$MESSAGE_EVENTS_BATCH_SIZE);
                await this.sendMessageEvents(batch);
                if (this.scheduledTimeout !== null) window.clearTimeout(this.scheduledTimeout);
                this.batchEvents = this.batchEvents.slice($fb9d10d91fecaeaf$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
                this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $fb9d10d91fecaeaf$var$FLUSH_BATCH_EVENTS_TIMEOUT);
                return;
            }
            await this.sendMessageEvents(this.batchEvents);
            this.batchEvents = [];
            if (this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        }
        constructor(){
            this.endpointUrl = $fb9d10d91fecaeaf$var$DEFAULT_PATH;
            this.scheduledTimeout = null;
            this.batchEvents = [];
        }
    }
});
parcelRegister("fS9d8", function(module, exports) {
    $parcel$export(module.exports, "Headers", ()=>$b8e30b448f738d08$export$79b704688b15c0f4);
    $parcel$export(module.exports, "Request", ()=>$b8e30b448f738d08$export$7fa6c5b6f8193917);
    $parcel$export(module.exports, "Response", ()=>$b8e30b448f738d08$export$9f633d56d7ec90d3);
    $parcel$export(module.exports, "DOMException", ()=>$b8e30b448f738d08$export$fe58bcf938607f6a);
    $parcel$export(module.exports, "fetch", ()=>$b8e30b448f738d08$export$e7aa7bc5c1b3cfb3);
    var $b8e30b448f738d08$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global || {};
    var $b8e30b448f738d08$var$support = {
        searchParams: 'URLSearchParams' in $b8e30b448f738d08$var$g,
        iterable: 'Symbol' in $b8e30b448f738d08$var$g && 'iterator' in Symbol,
        blob: 'FileReader' in $b8e30b448f738d08$var$g && 'Blob' in $b8e30b448f738d08$var$g && function() {
            try {
                new Blob();
                return true;
            } catch (e) {
                return false;
            }
        }(),
        formData: 'FormData' in $b8e30b448f738d08$var$g,
        arrayBuffer: 'ArrayBuffer' in $b8e30b448f738d08$var$g
    };
    function $b8e30b448f738d08$var$isDataView(obj) {
        return obj && DataView.prototype.isPrototypeOf(obj);
    }
    if ($b8e30b448f738d08$var$support.arrayBuffer) {
        var $b8e30b448f738d08$var$viewClasses = [
            '[object Int8Array]',
            '[object Uint8Array]',
            '[object Uint8ClampedArray]',
            '[object Int16Array]',
            '[object Uint16Array]',
            '[object Int32Array]',
            '[object Uint32Array]',
            '[object Float32Array]',
            '[object Float64Array]'
        ];
        var $b8e30b448f738d08$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && $b8e30b448f738d08$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
    }
    function $b8e30b448f738d08$var$normalizeName(name) {
        if (typeof name !== 'string') name = String(name);
        if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
        return name.toLowerCase();
    }
    function $b8e30b448f738d08$var$normalizeValue(value) {
        if (typeof value !== 'string') value = String(value);
        return value;
    }
    function $b8e30b448f738d08$var$iteratorFor(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if ($b8e30b448f738d08$var$support.iterable) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function $b8e30b448f738d08$export$79b704688b15c0f4(headers) {
        this.map = {};
        if (headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4) headers.forEach(function(value, name) {
            this.append(name, value);
        }, this);
        else if (Array.isArray(headers)) headers.forEach(function(header) {
            if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
            this.append(header[0], header[1]);
        }, this);
        else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
        }, this);
    }
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.append = function(name, value) {
        name = $b8e30b448f738d08$var$normalizeName(name);
        value = $b8e30b448f738d08$var$normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ', ' + value : value;
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype['delete'] = function(name) {
        delete this.map[$b8e30b448f738d08$var$normalizeName(name)];
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.get = function(name) {
        name = $b8e30b448f738d08$var$normalizeName(name);
        return this.has(name) ? this.map[name] : null;
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.has = function(name) {
        return this.map.hasOwnProperty($b8e30b448f738d08$var$normalizeName(name));
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.set = function(name, value) {
        this.map[$b8e30b448f738d08$var$normalizeName(name)] = $b8e30b448f738d08$var$normalizeValue(value);
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
        for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push(name);
        });
        return $b8e30b448f738d08$var$iteratorFor(items);
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
            items.push(value);
        });
        return $b8e30b448f738d08$var$iteratorFor(items);
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
        });
        return $b8e30b448f738d08$var$iteratorFor(items);
    };
    if ($b8e30b448f738d08$var$support.iterable) $b8e30b448f738d08$export$79b704688b15c0f4.prototype[Symbol.iterator] = $b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries;
    function $b8e30b448f738d08$var$consumed(body) {
        if (body._noBody) return;
        if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
        body.bodyUsed = true;
    }
    function $b8e30b448f738d08$var$fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
            reader.onload = function() {
                resolve(reader.result);
            };
            reader.onerror = function() {
                reject(reader.error);
            };
        });
    }
    function $b8e30b448f738d08$var$readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
    }
    function $b8e30b448f738d08$var$readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
        var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
        var encoding = match ? match[1] : 'utf-8';
        reader.readAsText(blob, encoding);
        return promise;
    }
    function $b8e30b448f738d08$var$readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);
        for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
        return chars.join('');
    }
    function $b8e30b448f738d08$var$bufferClone(buf) {
        if (buf.slice) return buf.slice(0);
        else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
        }
    }
    function $b8e30b448f738d08$var$Body() {
        this.bodyUsed = false;
        this._initBody = function(body) {
            this.bodyUsed = this.bodyUsed;
            this._bodyInit = body;
            if (!body) {
                this._noBody = true;
                this._bodyText = '';
            } else if (typeof body === 'string') this._bodyText = body;
            else if ($b8e30b448f738d08$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
            else if ($b8e30b448f738d08$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
            else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
            else if ($b8e30b448f738d08$var$support.arrayBuffer && $b8e30b448f738d08$var$support.blob && $b8e30b448f738d08$var$isDataView(body)) {
                this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body.buffer);
                this._bodyInit = new Blob([
                    this._bodyArrayBuffer
                ]);
            } else if ($b8e30b448f738d08$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $b8e30b448f738d08$var$isArrayBufferView(body))) this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body);
            else this._bodyText = body = Object.prototype.toString.call(body);
            if (!this.headers.get('content-type')) {
                if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
        };
        if ($b8e30b448f738d08$var$support.blob) this.blob = function() {
            var rejected = $b8e30b448f738d08$var$consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                this._bodyArrayBuffer
            ]));
            else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
            else return Promise.resolve(new Blob([
                this._bodyText
            ]));
        };
        this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
                var isConsumed = $b8e30b448f738d08$var$consumed(this);
                if (isConsumed) return isConsumed;
                else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                else return Promise.resolve(this._bodyArrayBuffer);
            } else if ($b8e30b448f738d08$var$support.blob) return this.blob().then($b8e30b448f738d08$var$readBlobAsArrayBuffer);
            else throw new Error('could not read as ArrayBuffer');
        };
        this.text = function() {
            var rejected = $b8e30b448f738d08$var$consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return $b8e30b448f738d08$var$readBlobAsText(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve($b8e30b448f738d08$var$readArrayBufferAsText(this._bodyArrayBuffer));
            else if (this._bodyFormData) throw new Error('could not read FormData body as text');
            else return Promise.resolve(this._bodyText);
        };
        if ($b8e30b448f738d08$var$support.formData) this.formData = function() {
            return this.text().then($b8e30b448f738d08$var$decode);
        };
        this.json = function() {
            return this.text().then(JSON.parse);
        };
        return this;
    }
    var $b8e30b448f738d08$var$methods = [
        'CONNECT',
        'DELETE',
        'GET',
        'HEAD',
        'OPTIONS',
        'PATCH',
        'POST',
        'PUT',
        'TRACE'
    ];
    function $b8e30b448f738d08$var$normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return $b8e30b448f738d08$var$methods.indexOf(upcased) > -1 ? upcased : method;
    }
    function $b8e30b448f738d08$export$7fa6c5b6f8193917(input, options) {
        if (!(this instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        options = options || {};
        var body = options.body;
        if (input instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917) {
            if (input.bodyUsed) throw new TypeError('Already read');
            this.url = input.url;
            this.credentials = input.credentials;
            if (!options.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(input.headers);
            this.method = input.method;
            this.mode = input.mode;
            this.signal = input.signal;
            if (!body && input._bodyInit != null) {
                body = input._bodyInit;
                input.bodyUsed = true;
            }
        } else this.url = String(input);
        this.credentials = options.credentials || this.credentials || 'same-origin';
        if (options.headers || !this.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
        this.method = $b8e30b448f738d08$var$normalizeMethod(options.method || this.method || 'GET');
        this.mode = options.mode || this.mode || null;
        this.signal = options.signal || this.signal || function() {
            if ('AbortController' in $b8e30b448f738d08$var$g) {
                var ctrl = new AbortController();
                return ctrl.signal;
            }
        }();
        this.referrer = null;
        if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
        this._initBody(body);
        if (this.method === 'GET' || this.method === 'HEAD') {
            if (options.cache === 'no-store' || options.cache === 'no-cache') {
                var reParamSearch = /([?&])_=[^&]*/;
                if (reParamSearch.test(this.url)) this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                else {
                    var reQueryString = /\?/;
                    this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                }
            }
        }
    }
    $b8e30b448f738d08$export$7fa6c5b6f8193917.prototype.clone = function() {
        return new $b8e30b448f738d08$export$7fa6c5b6f8193917(this, {
            body: this._bodyInit
        });
    };
    function $b8e30b448f738d08$var$decode(body) {
        var form = new FormData();
        body.trim().split('&').forEach(function(bytes) {
            if (bytes) {
                var split = bytes.split('=');
                var name = split.shift().replace(/\+/g, ' ');
                var value = split.join('=').replace(/\+/g, ' ');
                form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
        });
        return form;
    }
    function $b8e30b448f738d08$var$parseHeaders(rawHeaders) {
        var headers = new $b8e30b448f738d08$export$79b704688b15c0f4();
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
        preProcessedHeaders.split('\r').map(function(header) {
            return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
        }).forEach(function(line) {
            var parts = line.split(':');
            var key = parts.shift().trim();
            if (key) {
                var value = parts.join(':').trim();
                try {
                    headers.append(key, value);
                } catch (error) {
                    console.warn('Response ' + error.message);
                }
            }
        });
        return headers;
    }
    $b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$7fa6c5b6f8193917.prototype);
    function $b8e30b448f738d08$export$9f633d56d7ec90d3(bodyInit, options) {
        if (!(this instanceof $b8e30b448f738d08$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        if (!options) options = {};
        this.type = 'default';
        this.status = options.status === undefined ? 200 : options.status;
        if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
        this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
        this.url = options.url || '';
        this._initBody(bodyInit);
    }
    $b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$9f633d56d7ec90d3.prototype);
    $b8e30b448f738d08$export$9f633d56d7ec90d3.prototype.clone = function() {
        return new $b8e30b448f738d08$export$9f633d56d7ec90d3(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new $b8e30b448f738d08$export$79b704688b15c0f4(this.headers),
            url: this.url
        });
    };
    $b8e30b448f738d08$export$9f633d56d7ec90d3.error = function() {
        var response = new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
            status: 200,
            statusText: ''
        });
        response.ok = false;
        response.status = 0;
        response.type = 'error';
        return response;
    };
    var $b8e30b448f738d08$var$redirectStatuses = [
        301,
        302,
        303,
        307,
        308
    ];
    $b8e30b448f738d08$export$9f633d56d7ec90d3.redirect = function(url, status) {
        if ($b8e30b448f738d08$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
        return new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
            status: status,
            headers: {
                location: url
            }
        });
    };
    var $b8e30b448f738d08$export$fe58bcf938607f6a = $b8e30b448f738d08$var$g.DOMException;
    try {
        new $b8e30b448f738d08$export$fe58bcf938607f6a();
    } catch (err) {
        $b8e30b448f738d08$export$fe58bcf938607f6a = function(message, name) {
            this.message = message;
            this.name = name;
            var error = Error(message);
            this.stack = error.stack;
        };
        $b8e30b448f738d08$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
        $b8e30b448f738d08$export$fe58bcf938607f6a.prototype.constructor = $b8e30b448f738d08$export$fe58bcf938607f6a;
    }
    function $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3(input, init) {
        return new Promise(function(resolve, reject) {
            var request = new $b8e30b448f738d08$export$7fa6c5b6f8193917(input, init);
            if (request.signal && request.signal.aborted) return reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            var xhr = new XMLHttpRequest();
            function abortXhr() {
                xhr.abort();
            }
            xhr.onload = function() {
                var options = {
                    statusText: xhr.statusText,
                    headers: $b8e30b448f738d08$var$parseHeaders(xhr.getAllResponseHeaders() || '')
                };
                if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                else options.status = xhr.status;
                options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                var body = 'response' in xhr ? xhr.response : xhr.responseText;
                setTimeout(function() {
                    resolve(new $b8e30b448f738d08$export$9f633d56d7ec90d3(body, options));
                }, 0);
            };
            xhr.onerror = function() {
                setTimeout(function() {
                    reject(new TypeError('Network request failed'));
                }, 0);
            };
            xhr.ontimeout = function() {
                setTimeout(function() {
                    reject(new TypeError('Network request timed out'));
                }, 0);
            };
            xhr.onabort = function() {
                setTimeout(function() {
                    reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
                }, 0);
            };
            function fixUrl(url) {
                try {
                    return url === '' && $b8e30b448f738d08$var$g.location.href ? $b8e30b448f738d08$var$g.location.href : url;
                } catch (e) {
                    return url;
                }
            }
            xhr.open(request.method, fixUrl(request.url), true);
            if (request.credentials === 'include') xhr.withCredentials = true;
            else if (request.credentials === 'omit') xhr.withCredentials = false;
            if ('responseType' in xhr) {
                if ($b8e30b448f738d08$var$support.blob) xhr.responseType = 'blob';
                else if ($b8e30b448f738d08$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
            }
            if (init && typeof init.headers === 'object' && !(init.headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4 || $b8e30b448f738d08$var$g.Headers && init.headers instanceof $b8e30b448f738d08$var$g.Headers)) {
                var names = [];
                Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    names.push($b8e30b448f738d08$var$normalizeName(name));
                    xhr.setRequestHeader(name, $b8e30b448f738d08$var$normalizeValue(init.headers[name]));
                });
                request.headers.forEach(function(value, name) {
                    if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                });
            } else request.headers.forEach(function(value, name) {
                xhr.setRequestHeader(name, value);
            });
            if (request.signal) {
                request.signal.addEventListener('abort', abortXhr);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                };
            }
            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
        });
    }
    $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3.polyfill = true;
    if (!$b8e30b448f738d08$var$g.fetch) {
        $b8e30b448f738d08$var$g.fetch = $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3;
        $b8e30b448f738d08$var$g.Headers = $b8e30b448f738d08$export$79b704688b15c0f4;
        $b8e30b448f738d08$var$g.Request = $b8e30b448f738d08$export$7fa6c5b6f8193917;
        $b8e30b448f738d08$var$g.Response = $b8e30b448f738d08$export$9f633d56d7ec90d3;
    }
});
parcelRegister("kS28O", function(module, exports) {
    $parcel$export(module.exports, "InAppMessageEventType", ()=>$dcec6730a4b87bfc$export$b31ffc6f7c85f1b);
    var $dcec6730a4b87bfc$export$b31ffc6f7c85f1b;
    (function(InAppMessageEventType) {
        InAppMessageEventType["Viewed"] = "viewed";
        InAppMessageEventType["Acknowledged"] = "acknowledged";
        InAppMessageEventType["Clicked"] = "clicked";
        InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
        InAppMessageEventType["Dismissed"] = "dismissed";
        InAppMessageEventType["Snoozed"] = "snoozed";
        InAppMessageEventType["Read"] = "read";
        InAppMessageEventType["Unread"] = "unread";
    })($dcec6730a4b87bfc$export$b31ffc6f7c85f1b || ($dcec6730a4b87bfc$export$b31ffc6f7c85f1b = {}));
});
parcelRegister("g0Qxc", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerWrapper", ()=>$cfeb2bccb040087b$export$8db7ba034addcd65);
    var $2OMIu = parcelRequire("2OMIu");
    var $5IPCv;
    var $h3mjV;
    var $5uXOq = parcelRequire("5uXOq");
    var $8IVWW;
    const $cfeb2bccb040087b$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
        const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const shouldRender = useChoreographedRender({
            messageId: messageId
        });
        if (shouldRender) return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
        return null;
    };
    const $cfeb2bccb040087b$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
        const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, (0, parcelRequire("8IVWW")).useChoreographerContext)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const isTrackingChoreographedPostOfficeMessagesEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_tracking_choreographed_post_office_messages');
            if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
                eventType: 'operational',
                action: 'maybeChoreographed',
                actionSubject: 'postOfficeMessage'
            }, {
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory
            });
        }, [
            fireAnalyticsEvent
        ]);
        const isChoreographedPostOfficeMessagesEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_choreographed_post_office_messages');
        if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && factory) {
            const { shouldBeChoreographed: shouldBeChoreographed } = factory;
            const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
            if (shouldBeChoreographed({
                messageType: messageType
            })) return (0, $2OMIu.jsx)($cfeb2bccb040087b$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: messageId,
                children: children
            });
        }
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("emlqA", function(module, exports) {
    $parcel$export(module.exports, "MessageAnalyticsContextProvider", ()=>$26dd6a326ae10221$export$1737ab199e83455e);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $26dd6a326ae10221$var$defaultMessageAnalyticsContextValue = {
        fireMessageViewedInMessageComponent: null,
        setFireMessageViewedInMessageComponent: ()=>{}
    };
    const $26dd6a326ae10221$export$c81717973c6c4a90 = (0, $5uXOq.createContext)($26dd6a326ae10221$var$defaultMessageAnalyticsContextValue);
    const $26dd6a326ae10221$export$1737ab199e83455e = ({ children: children })=>{
        const fireMessageViewedInMessageComponent = (0, $5uXOq.useRef)(false);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
                setFireMessageViewedInMessageComponent: (value)=>{
                    fireMessageViewedInMessageComponent.current = value;
                }
            }), [
            fireMessageViewedInMessageComponent
        ]);
        return (0, $2OMIu.jsx)($26dd6a326ae10221$export$c81717973c6c4a90.Provider, {
            value: contextValue,
            children: children
        });
    };
    const $26dd6a326ae10221$export$bb426ba114b64992 = ()=>(0, $5uXOq.useContext)($26dd6a326ae10221$export$c81717973c6c4a90);
});
parcelRegister("dEv4p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1928860e82ae4db6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1928860e82ae4db6$export$2e2bcd8739ae039 = {
        'marketing-screen-space-flag-contentful-usecase': (0, $5uXOq.lazy)(()=>(parcelRequire("hzf0p")))
    };
});
parcelRegister("hzf0p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("55CDW")
    ]).then(()=>parcelRequire('e8Z1Y'));
});
parcelRegister("afxIx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa7dbabece5cd8be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aa7dbabece5cd8be$export$2e2bcd8739ae039 = {
        'message-template-template': (0, $5uXOq.lazy)(()=>(parcelRequire("3gaC1")))
    };
});
parcelRegister("3gaC1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ehn1n").then(()=>parcelRequire('ilWOk'));
});
parcelRegister("5o9nW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$919ec0634b70ec5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $919ec0634b70ec5a$export$2e2bcd8739ae039 = {
        'test-message-inapp': (0, $5uXOq.lazy)(()=>(parcelRequire("95qcr"))),
        'test-message-inapp-implicit-pendo': (0, $5uXOq.lazy)(()=>(parcelRequire("2MtFK")))
    };
});
parcelRegister("95qcr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("93IDB").then(()=>parcelRequire('kM8wR'));
});
parcelRegister("2MtFK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("717m6").then(()=>parcelRequire('chIH8'));
});
const $f6721478b0b83c9a$export$a5cfae247d8360ef = 'screen-space-flags';
parcelRegister("3p8Nq", function(module, exports) {
    $parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", ()=>$12221ebf84dcb54e$export$b0eee5de066b2bf5);
    var $9AXHJ;
    var $2VBkk;
    var $6IoHP;
    var $6hVVf;
    const $12221ebf84dcb54e$var$loadMessagesByTeam = async (locale)=>{
        return Promise.allSettled([
            (0, (0, parcelRequire("2VBkk")).messagesLoader)(locale),
            (0, (0, parcelRequire("6IoHP")).messagesLoader)(locale),
            (0, (0, parcelRequire("6hVVf")).messagesLoader)(locale)
        ]).then((results)=>{
            return results.reduce((acc, result)=>{
                if (result.status === 'fulfilled') return {
                    messages: {
                        ...acc.messages,
                        ...result.value
                    },
                    errors: [
                        ...acc.errors
                    ]
                };
                else if (result.status === 'rejected') return {
                    messages: {
                        ...acc.messages
                    },
                    errors: [
                        ...acc.errors,
                        `Failed to load translations with ${result.reason}`
                    ]
                };
                return acc;
            }, {
                messages: {},
                errors: []
            });
        });
    };
    const $12221ebf84dcb54e$export$b0eee5de066b2bf5 = (Component)=>{
        return (0, (0, parcelRequire("9AXHJ")).withIntlProvider)({
            messagesLoader: $12221ebf84dcb54e$var$loadMessagesByTeam
        }, Component);
    };
});
parcelRegister("9AXHJ", function(module, exports) {
    $parcel$export(module.exports, "withIntlProvider", ()=>$e955fa14362f80b1$export$a5d940130f33be3f);
    var $2OMIu = parcelRequire("2OMIu");
    var $jeRgx;
    const $e955fa14362f80b1$export$a5d940130f33be3f = (intlProviderProps, Component)=>(props)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("jeRgx")).default), {
                ...intlProviderProps,
                children: (0, $2OMIu.jsx)(Component, {
                    ...props
                })
            });
});
parcelRegister("jeRgx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8801040350808fa1$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $h3mjV;
    var $i5FdW;
    var $koVbs;
    var $94Wuv;
    function $8801040350808fa1$var$useFetchLocale() {
        let locale = 'en';
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        try {
            const { locale: intlLocale } = (0, (0, parcelRequire("koVbs")).default)();
            locale = intlLocale;
        } catch (err) {
            fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlProvider',
                eventType: 'operational',
                attributes: {
                    errorMessage: err
                }
            });
        }
        return {
            locale: locale
        };
    }
    function $8801040350808fa1$export$2e2bcd8739ae039(props) {
        const { locale: locale } = $8801040350808fa1$var$useFetchLocale();
        const messages = (0, (0, parcelRequire("94Wuv")).useIntlMessages)(locale, props.messagesLoader);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("i5FdW")).default), {
            locale: locale,
            messages: messages,
            children: props.children
        });
    }
});
parcelRegister("94Wuv", function(module, exports) {
    $parcel$export(module.exports, "useIntlMessages", ()=>$7ff04099e58be4b7$export$2641ec9a2025a81f);
    var $h3mjV;
    var $5uXOq = parcelRequire("5uXOq");
    const $7ff04099e58be4b7$export$2641ec9a2025a81f = (locale, messageLoader)=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            messageLoader(locale).then((loadedMessages)=>{
                if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
                if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                    action: 'errored',
                    actionSubject: 'intlMessagesLoader',
                    eventType: 'operational',
                    attributes: {
                        locale: locale,
                        errorMessage: loadedMessages.errors
                    }
                });
            }).catch(console.error);
        }, [
            locale
        ]);
        return messages;
    };
});
parcelRegister("2VBkk", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$8c8eddab653b1a75$export$720676d8cac8fbb);
    var $bVbzx;
    var $euiLX;
    const $8c8eddab653b1a75$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("euiLX")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return (await (parcelRequire("8b0IF"))).default;
            case 'da':
                return (await (parcelRequire("5Y75d"))).default;
            case 'de':
                return (await (parcelRequire("dDxcV"))).default;
            case 'en-GB':
                return (await (parcelRequire("61jFB"))).default;
            case 'en-US':
                return (await (parcelRequire("3EkH2"))).default;
            case 'en-XA':
                return (await (parcelRequire("e6Skz"))).default;
            case 'en-XB':
                return (await (parcelRequire("eXG31"))).default;
            case 'en-ZZ':
                return (await (parcelRequire("3jJ8e"))).default;
            case 'en':
                return (await Promise.resolve((parcelRequire("bVbzx")))).default;
            case 'es':
                return (await (parcelRequire("598Uj"))).default;
            case 'et':
                return (await (parcelRequire("ds8cm"))).default;
            case 'fi':
                return (await (parcelRequire("1whY3"))).default;
            case 'fr':
                return (await (parcelRequire("fDmLN"))).default;
            case 'hu':
                return (await (parcelRequire("2B4F5"))).default;
            case 'it':
                return (await (parcelRequire("4BSvs"))).default;
            case 'ja':
                return (await (parcelRequire("9Elub"))).default;
            case 'ko':
                return (await (parcelRequire("mdX0k"))).default;
            case 'nb':
                return (await (parcelRequire("jaO95"))).default;
            case 'nl':
                return (await (parcelRequire("dMOYG"))).default;
            case 'pl':
                return (await (parcelRequire("6Gsvm"))).default;
            case 'pt-BR':
                return (await (parcelRequire("eCkkK"))).default;
            case 'ro':
                return (await (parcelRequire("W6EyM"))).default;
            case 'ru':
                return (await (parcelRequire("2snL7"))).default;
            case 'sv':
                return (await (parcelRequire("8dzkr"))).default;
            case 'th':
                return (await (parcelRequire("jdB93"))).default;
            case 'tr':
                return (await (parcelRequire("47O3M"))).default;
            case 'uk':
                return (await (parcelRequire("cdQVu"))).default;
            case 'vi':
                return (await (parcelRequire("4jWs9"))).default;
            case 'zh-CN':
                return (await (parcelRequire("jheo3"))).default;
            case 'zh-TW':
                return (await (parcelRequire("27r8n"))).default;
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("bVbzx"))));
        }
    };
});
parcelRegister("bVbzx", function(module, exports) {
    module.exports = JSON.parse("{\"post-office.components.in-app.step-context.default-next-button.main\":[{\"type\":0,\"value\":\"Next\"}],\"post-office.components.in-app.step-context.default-previous-button.main\":[{\"type\":0,\"value\":\"Back\"}],\"post-office.components.in-app.step-context.next-button.step-state\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");
});
parcelRegister("8b0IF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hc5RF").then(()=>parcelRequire('8mqjG'));
});
parcelRegister("5Y75d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OzF3").then(()=>parcelRequire('jMhDj'));
});
parcelRegister("dDxcV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fhoZv").then(()=>parcelRequire('37saP'));
});
parcelRegister("61jFB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k8Maf").then(()=>parcelRequire('ih0Zd'));
});
parcelRegister("3EkH2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ka4Zj").then(()=>parcelRequire('7glfV'));
});
parcelRegister("e6Skz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fKDnI").then(()=>parcelRequire('7vTP9'));
});
parcelRegister("eXG31", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ebvcb").then(()=>parcelRequire('6TjtY'));
});
parcelRegister("3jJ8e", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("abSwS").then(()=>parcelRequire('4oNEQ'));
});
parcelRegister("598Uj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5JmDT").then(()=>parcelRequire('kyM33'));
});
parcelRegister("ds8cm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Sm5d").then(()=>parcelRequire('6bkWH'));
});
parcelRegister("1whY3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ilfnk").then(()=>parcelRequire('aoAHS'));
});
parcelRegister("fDmLN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("71uxM").then(()=>parcelRequire('3MBkB'));
});
parcelRegister("2B4F5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eyrUE").then(()=>parcelRequire('5pE8G'));
});
parcelRegister("4BSvs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d0Pdj").then(()=>parcelRequire('as6ve'));
});
parcelRegister("9Elub", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jKeM3").then(()=>parcelRequire('fPj8Q'));
});
parcelRegister("mdX0k", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1aIVe").then(()=>parcelRequire('3wJyD'));
});
parcelRegister("jaO95", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hXjSJ").then(()=>parcelRequire('ephQP'));
});
parcelRegister("dMOYG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2mCCL").then(()=>parcelRequire('lsvvG'));
});
parcelRegister("6Gsvm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3yZih").then(()=>parcelRequire('eX12q'));
});
parcelRegister("eCkkK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("enFnZ").then(()=>parcelRequire('dFIAI'));
});
parcelRegister("W6EyM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("anuNI").then(()=>parcelRequire('jZfiR'));
});
parcelRegister("2snL7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gUMZN").then(()=>parcelRequire('9afPo'));
});
parcelRegister("8dzkr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9wWtx").then(()=>parcelRequire('daUsC'));
});
parcelRegister("jdB93", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h2kXR").then(()=>parcelRequire('ei7L7'));
});
parcelRegister("47O3M", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eyhw3").then(()=>parcelRequire('ahyTy'));
});
parcelRegister("cdQVu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("caAge").then(()=>parcelRequire('c14L5'));
});
parcelRegister("4jWs9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8ZIAm").then(()=>parcelRequire('7zIUv'));
});
parcelRegister("jheo3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f9GdA").then(()=>parcelRequire('aw2dk'));
});
parcelRegister("27r8n", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("O040l").then(()=>parcelRequire('iy5Tj'));
});
parcelRegister("6IoHP", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$92e2c6f96674df98$export$720676d8cac8fbb);
    var $jTlyZ;
    var $euiLX;
    const $92e2c6f96674df98$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("euiLX")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return (await (parcelRequire("f4WGN"))).default;
            case 'da':
                return (await (parcelRequire("jhduq"))).default;
            case 'de':
                return (await (parcelRequire("1rwEg"))).default;
            case 'en-GB':
                return (await (parcelRequire("lU8xk"))).default;
            case 'en-US':
                return (await (parcelRequire("9izs0"))).default;
            case 'en-XA':
                return (await (parcelRequire("cAfjU"))).default;
            case 'en-XB':
                return (await (parcelRequire("k2MDt"))).default;
            case 'en-ZZ':
                return (await (parcelRequire("fXn9W"))).default;
            case 'en':
                return (await Promise.resolve((parcelRequire("jTlyZ")))).default;
            case 'es':
                return (await (parcelRequire("21YPk"))).default;
            case 'et':
                return (await (parcelRequire("7yDHc"))).default;
            case 'fi':
                return (await (parcelRequire("7wOOy"))).default;
            case 'fr':
                return (await (parcelRequire("9NJ6f"))).default;
            case 'hu':
                return (await (parcelRequire("ijzxt"))).default;
            case 'it':
                return (await (parcelRequire("2VWKN"))).default;
            case 'ja':
                return (await (parcelRequire("eKy1p"))).default;
            case 'ko':
                return (await (parcelRequire("AT3FS"))).default;
            case 'nb':
                return (await (parcelRequire("3HZZI"))).default;
            case 'nl':
                return (await (parcelRequire("602Ah"))).default;
            case 'pl':
                return (await (parcelRequire("4uXmI"))).default;
            case 'pt-BR':
                return (await (parcelRequire("782rV"))).default;
            case 'ro':
                return (await (parcelRequire("2V8A9"))).default;
            case 'ru':
                return (await (parcelRequire("locCn"))).default;
            case 'sv':
                return (await (parcelRequire("e8E1Y"))).default;
            case 'th':
                return (await (parcelRequire("d9Za6"))).default;
            case 'tr':
                return (await (parcelRequire("lUeKF"))).default;
            case 'uk':
                return (await (parcelRequire("lwbGC"))).default;
            case 'vi':
                return (await (parcelRequire("1Mti3"))).default;
            case 'zh-CN':
                return (await (parcelRequire("8Rz5d"))).default;
            case 'zh-TW':
                return (await (parcelRequire("414mc"))).default;
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("jTlyZ"))));
        }
    };
});
parcelRegister("jTlyZ", function(module, exports) {
    module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");
});
parcelRegister("f4WGN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lHVL5").then(()=>parcelRequire('cOdtX'));
});
parcelRegister("jhduq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gmFsu").then(()=>parcelRequire('ehn1w'));
});
parcelRegister("1rwEg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4heQj").then(()=>parcelRequire('gUTAT'));
});
parcelRegister("lU8xk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1gRT0").then(()=>parcelRequire('j51AU'));
});
parcelRegister("9izs0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kkDB9").then(()=>parcelRequire('gAvT5'));
});
parcelRegister("cAfjU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1uZSJ").then(()=>parcelRequire('3UXio'));
});
parcelRegister("k2MDt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Y6zx").then(()=>parcelRequire('7swxR'));
});
parcelRegister("fXn9W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1GqWE").then(()=>parcelRequire('530uH'));
});
parcelRegister("21YPk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1RQcp").then(()=>parcelRequire('lHvSd'));
});
parcelRegister("7yDHc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8MNlN").then(()=>parcelRequire('jF3vn'));
});
parcelRegister("7wOOy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eDmn9").then(()=>parcelRequire('5RTMG'));
});
parcelRegister("9NJ6f", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3bISh").then(()=>parcelRequire('lFs8E'));
});
parcelRegister("ijzxt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jrCqD").then(()=>parcelRequire('229rK'));
});
parcelRegister("2VWKN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kxYfx").then(()=>parcelRequire('dQCwG'));
});
parcelRegister("eKy1p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jmIq9").then(()=>parcelRequire('glbrO'));
});
parcelRegister("AT3FS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a4UUJ").then(()=>parcelRequire('4Z6cs'));
});
parcelRegister("3HZZI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cG5Yc").then(()=>parcelRequire('2KZY1'));
});
parcelRegister("602Ah", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("i5XGe").then(()=>parcelRequire('6ZLBK'));
});
parcelRegister("4uXmI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("22Dpk").then(()=>parcelRequire('etrJu'));
});
parcelRegister("782rV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("edLMb").then(()=>parcelRequire('6QWjO'));
});
parcelRegister("2V8A9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9TiZ0").then(()=>parcelRequire('4uHll'));
});
parcelRegister("locCn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3a5et").then(()=>parcelRequire('2S1ZA'));
});
parcelRegister("e8E1Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bb4hU").then(()=>parcelRequire('1mvAC'));
});
parcelRegister("d9Za6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hF6jM").then(()=>parcelRequire('4oHMI'));
});
parcelRegister("lUeKF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5JRPO").then(()=>parcelRequire('2KsIL'));
});
parcelRegister("lwbGC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("629Lo").then(()=>parcelRequire('gNWij'));
});
parcelRegister("1Mti3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("955SR").then(()=>parcelRequire('5MBk8'));
});
parcelRegister("8Rz5d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("62Vsv").then(()=>parcelRequire('5jMKL'));
});
parcelRegister("414mc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bwU6c").then(()=>parcelRequire('4Kji8'));
});
parcelRegister("6hVVf", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$3413ebc4b93cf9f1$export$720676d8cac8fbb);
    var $cGnQ2;
    var $euiLX;
    const $3413ebc4b93cf9f1$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("euiLX")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return (await (parcelRequire("5auBH"))).default;
            case 'da':
                return (await (parcelRequire("6pKdb"))).default;
            case 'de':
                return (await (parcelRequire("j7zSY"))).default;
            case 'en-GB':
                return (await (parcelRequire("RXLpr"))).default;
            case 'en-US':
                return (await (parcelRequire("lcczF"))).default;
            case 'en-XA':
                return (await (parcelRequire("lR3kc"))).default;
            case 'en-XB':
                return (await (parcelRequire("2V8i0"))).default;
            case 'en-ZZ':
                return (await (parcelRequire("bMfdq"))).default;
            case 'en':
                return (await Promise.resolve((parcelRequire("cGnQ2")))).default;
            case 'es':
                return (await (parcelRequire("fgL2p"))).default;
            case 'et':
                return (await (parcelRequire("bxmvz"))).default;
            case 'fi':
                return (await (parcelRequire("30eqR"))).default;
            case 'fr':
                return (await (parcelRequire("72KWh"))).default;
            case 'hu':
                return (await (parcelRequire("gYJqW"))).default;
            case 'it':
                return (await (parcelRequire("dFTxP"))).default;
            case 'ja':
                return (await (parcelRequire("3K1VL"))).default;
            case 'ko':
                return (await (parcelRequire("fz41S"))).default;
            case 'nb':
                return (await (parcelRequire("66deW"))).default;
            case 'nl':
                return (await (parcelRequire("1gzyP"))).default;
            case 'pl':
                return (await (parcelRequire("6Fuvc"))).default;
            case 'pt-BR':
                return (await (parcelRequire("42L7s"))).default;
            case 'ro':
                return (await (parcelRequire("at9BV"))).default;
            case 'ru':
                return (await (parcelRequire("gE5sv"))).default;
            case 'sv':
                return (await (parcelRequire("7OUjU"))).default;
            case 'th':
                return (await (parcelRequire("cvMBB"))).default;
            case 'tr':
                return (await (parcelRequire("kaqjm"))).default;
            case 'uk':
                return (await (parcelRequire("GpvzN"))).default;
            case 'vi':
                return (await (parcelRequire("99JlG"))).default;
            case 'zh-CN':
                return (await (parcelRequire("iVMqV"))).default;
            case 'zh-TW':
                return (await (parcelRequire("5DASo"))).default;
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("cGnQ2"))));
        }
    };
});
parcelRegister("cGnQ2", function(module, exports) {
    module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");
});
parcelRegister("5auBH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1hE5w").then(()=>parcelRequire('k8z39'));
});
parcelRegister("6pKdb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("627oz").then(()=>parcelRequire('6UrsO'));
});
parcelRegister("j7zSY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6jCV8").then(()=>parcelRequire('8bqsn'));
});
parcelRegister("RXLpr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5O5cU").then(()=>parcelRequire('hJmwv'));
});
parcelRegister("lcczF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6JTH9").then(()=>parcelRequire('2uiq7'));
});
parcelRegister("lR3kc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2v2Nk").then(()=>parcelRequire('iHpg4'));
});
parcelRegister("2V8i0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hDbq3").then(()=>parcelRequire('fI8tg'));
});
parcelRegister("bMfdq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8eljG").then(()=>parcelRequire('kozgB'));
});
parcelRegister("fgL2p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7Ch5S").then(()=>parcelRequire('4wp5m'));
});
parcelRegister("bxmvz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lSnfb").then(()=>parcelRequire('lExpK'));
});
parcelRegister("30eqR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fHtYn").then(()=>parcelRequire('i0vin'));
});
parcelRegister("72KWh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hBRyE").then(()=>parcelRequire('hAKNc'));
});
parcelRegister("gYJqW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jqccl").then(()=>parcelRequire('6RGe9'));
});
parcelRegister("dFTxP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("khPZv").then(()=>parcelRequire('eUDxL'));
});
parcelRegister("3K1VL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5cbMq").then(()=>parcelRequire('5Tyyo'));
});
parcelRegister("fz41S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7Ms5V").then(()=>parcelRequire('gEKqD'));
});
parcelRegister("66deW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fbxh4").then(()=>parcelRequire('8h3N4'));
});
parcelRegister("1gzyP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7pABd").then(()=>parcelRequire('baBoX'));
});
parcelRegister("6Fuvc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("781xq").then(()=>parcelRequire('kuE02'));
});
parcelRegister("42L7s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5svak").then(()=>parcelRequire('gSSyD'));
});
parcelRegister("at9BV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dICtH").then(()=>parcelRequire('8PFu0'));
});
parcelRegister("gE5sv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2jnDS").then(()=>parcelRequire('f9UJM'));
});
parcelRegister("7OUjU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("htpfI").then(()=>parcelRequire('l5ru8'));
});
parcelRegister("cvMBB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dbrcM").then(()=>parcelRequire('36syK'));
});
parcelRegister("kaqjm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8pczK").then(()=>parcelRequire('hO7cZ'));
});
parcelRegister("GpvzN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hSwzA").then(()=>parcelRequire('9DvXk'));
});
parcelRegister("99JlG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dhLwH").then(()=>parcelRequire('lRZWr'));
});
parcelRegister("iVMqV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aH2IS").then(()=>parcelRequire('3Qt72'));
});
parcelRegister("5DASo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eXLRF").then(()=>parcelRequire('2LYB4'));
});
parcelRegister("SfWIb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb8d031c7e1e7737$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $dmvPD;
    var $7LDqC;
    var $iXSVm;
    var $5uXOq = parcelRequire("5uXOq");
    var $cPceA;
    const $fb8d031c7e1e7737$var$STABLE_OBJECT = {};
    const $fb8d031c7e1e7737$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, Fallback: Fallback = null, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
        const MemoizedPlacement = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("iXSVm")).createPlacementComponent)(placementId, PlacementComponent), [
            placementId,
            PlacementComponent
        ]);
        const stableLocalPlacementProps = (0, (0, parcelRequire("dmvPD")).useStableObject)(placementProps ?? $fb8d031c7e1e7737$var$STABLE_OBJECT);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("7LDqC")).default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("cPceA")).default), {
                    analyticsChannel: (0, $78e0a2ec69f009c2$export$85183a312807388d),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                        fallback: Fallback,
                        children: (0, $2OMIu.jsx)(MemoizedPlacement, {
                            initialData: initialData,
                            context: context,
                            errorFallback: ErrorFallback,
                            ...stableLocalPlacementProps,
                            children: children
                        })
                    })
                })
        });
    };
    var $fb8d031c7e1e7737$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($fb8d031c7e1e7737$var$Placement);
});
parcelRegister("7LDqC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c34cc6cf58be8aa$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $1PVpv = parcelRequire("1PVpv");
    var $5IPCv;
    var $gHZ4O;
    var $lwdce;
    var $dmvPD;
    var $e8o2I;
    var $5H0An;
    var $fZeMt;
    var $5uXOq = parcelRequire("5uXOq");
    var $3tkt7;
    var $fqlGT;
    var $ABMmQ;
    const $7c34cc6cf58be8aa$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
        const fetcher = (0, (0, parcelRequire("fZeMt")).usePlacementFetchingContext)();
        return (0, $5uXOq.useMemo)(()=>disableInitialData ? undefined : (0, (0, parcelRequire("3tkt7")).requestInitialData)(placementId, context, fetcher.fetch, {
                baseUrl: baseUrl,
                path: path
            }), [
            disableInitialData,
            baseUrl,
            path,
            placementId,
            context,
            fetcher.fetch
        ]);
    };
    const $7c34cc6cf58be8aa$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
        const isUFOEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_ufo_tracking_in_post_office');
        const postOfficeRoute = (0, (0, parcelRequire("lwdce")).usePostOfficeRoute)();
        const context = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const { baseUrl: baseUrl, path: path } = (0, (0, parcelRequire("fqlGT")).useBuildBasePath)();
        const stableContextWithRoute = (0, (0, parcelRequire("dmvPD")).useStableObject)({
            ...context,
            postOfficeRoute: postOfficeRoute
        });
        const ufoV1PlacementTracker = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? new (0, (0, parcelRequire("e8o2I")).UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
            isUFOEnabled,
            placementId,
            consumptionType
        ]);
        const remoteComponentOnEvent = (0, $5uXOq.useCallback)(({ type: type, error: error })=>{
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure(error);
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure(error);
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure(error);
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure(error);
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }, [
            placementOnEvent,
            ufoV1PlacementTracker
        ]);
        const initialData = $7c34cc6cf58be8aa$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
        const placementAnalyticsContext = (0, $5uXOq.useMemo)(()=>({
                source: (0, $9608316309c5ec9e$export$f7109619a5e9e0d6),
                componentName: `Placement`,
                attributes: {
                    placementId: placementId,
                    channel: 'in-app',
                    postOfficeFrontendVersion: (0, parcelRequire("ABMmQ")).version
                }
            }), [
            placementId
        ]);
        return (0, $2OMIu.jsx)($7c34cc6cf58be8aa$var$FeatureFlaggedUfoWrapper, {
            placementId: placementId,
            isEnabled: isUFOEnabled,
            children: (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
                data: placementAnalyticsContext,
                children: children({
                    initialData: initialData,
                    context: stableContextWithRoute,
                    onEvent: remoteComponentOnEvent
                })
            })
        });
    };
    var $7c34cc6cf58be8aa$export$2e2bcd8739ae039 = $7c34cc6cf58be8aa$var$Placement;
    const $7c34cc6cf58be8aa$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
        if (isEnabled) return (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.PLACEMENT,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
                name: `${(0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
                children: children
            })
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
const $9608316309c5ec9e$export$85183a312807388d = 'postOffice';
const $9608316309c5ec9e$export$f7109619a5e9e0d6 = 'post-office-frontend';
parcelRegister("3tkt7", function(module, exports) {
    $parcel$export(module.exports, "requestInitialData", ()=>$10a72e21f18f1ff1$export$c4c39037cc4b06ab);
    const $10a72e21f18f1ff1$var$defaultFetcher = (url)=>fetch(url, {
            headers: {
                credentials: 'include',
                mode: 'cors',
                'Content-Type': 'application/json'
            }
        });
    const $10a72e21f18f1ff1$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $10a72e21f18f1ff1$var$defaultFetcher, options)=>{
        const baseUrl = options.baseUrl;
        const path = options.path;
        const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
        function stringifyObjectValues(input) {
            const entries = Object.entries(input);
            const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                    key,
                    String(value)
                ]);
            return Object.fromEntries(stringifiedEntries);
        }
        const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
        contextAsSearchParams.sort();
        const url = encodeURI(`${requestUrl}${placementId}?${contextAsSearchParams.toString()}`);
        return fetcher(url);
    };
});
parcelRegister("fqlGT", function(module, exports) {
    $parcel$export(module.exports, "useBuildBasePath", ()=>$fe4b211ec6dd7c80$export$83d6c58b7ab7ae67);
    var $87o4H;
    var $5MYiV;
    var $5uXOq = parcelRequire("5uXOq");
    const $fe4b211ec6dd7c80$export$83d6c58b7ab7ae67 = ()=>{
        const postOfficeEnvironment = (0, (0, parcelRequire("5MYiV")).usePostOfficeEnvironment)();
        return (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("87o4H")).buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
            postOfficeEnvironment.currentEnv,
            postOfficeEnvironment.envConfigs
        ]);
    };
});
parcelRegister("87o4H", function(module, exports) {
    $parcel$export(module.exports, "buildBasePath", ()=>$e673525439adf1a3$export$e8b30f9c4a80230f);
    var $5MYiV;
    const $e673525439adf1a3$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, (0, parcelRequire("5MYiV")).defaultEnvironmentValues).envConfigs)=>{
        const baseUrl = envConfigs[currentEnv].api.origin;
        const path = envConfigs[currentEnv].api.pathname ?? (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8);
        return {
            baseUrl: baseUrl,
            path: path
        };
    };
});
parcelRegister("ABMmQ", function(module, exports) {
    module.exports = JSON.parse("{\"name\":\"@atlassian/post-office-placement-shared\",\"version\":\"0.3.0\",\"packageManager\":\"yarn@4.2.2\",\"sideEffects\":false,\"source\":\"./src/index.ts\",\"main\":\"./dist/cjs/index.js\",\"module\":\"./dist/esm/index.js\",\"types\":\"./dist/types/index.d.ts\",\"exports\":{\".\":\"./src/index.ts\",\"./request-initial-data\":\"./src/initialDataClient.ts\"},\"publishConfig\":{\"exports\":{\"import\":\"./dist/esm/index.js\",\"require\":\"./dist/cjs/index.js\",\"types\":\"./dist/types/index.d.ts\"}},\"repository\":{\"type\":\"git\",\"url\":\"git+https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/post-office.git\",\"directory\":\"packages/post-office-clients/post-office-placement-shared\"},\"files\":[\"README.md\",\"dist\"],\"scripts\":{\"prepack\":\"atlas packages permission grant && yarn exec parcel build\",\"publish:patch\":\"yarn version patch && yarn npm publish\",\"publish:minor\":\"yarn version minor && yarn npm publish\"},\"peerDependencies\":{\"react\":\"^16.8.0 || ^17.0.0 || ^18.2.0\",\"react-dom\":\"^16.8.0 || ^17.0.0 || ^18.2.0\"},\"dependencies\":{\"@atlaskit/analytics-namespaced-context\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlassian/post-office-context\":\"workspace:^\",\"@atlassian/post-office-frontend-performance-tracking\":\"workspace:^\",\"@atlassian/post-office-placement-data\":\"workspace:^\",\"@compiled/react\":\"^0.17.3\"},\"devDependencies\":{\"@testing-library/jest-dom\":\"^6.4.2\",\"@testing-library/react\":\"14.2.1\",\"@testing-library/react-hooks\":\"^8.0.1\",\"@types/node\":\"^20.11.27\",\"@types/react\":\"^18.2.33\",\"@types/react-dom\":\"^18.2.14\",\"eslint\":\"^8.57.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"npm-run-all2\":\"^5.0.0\",\"parcel\":\"^2.6.0\",\"react\":\"^18.2.0\",\"typescript\":\"~5.4.2\"},\"targets\":{\"main\":{\"optimize\":true},\"module\":{\"optimize\":true}}}");
});
parcelRegister("cPceA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53bcb23f511c4129$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $cb25w;
    var $5uXOq = parcelRequire("5uXOq");
    class $53bcb23f511c4129$var$ErrorBoundary extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        componentDidCatch(error, errorInfo) {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'handled',
                actionSubject: 'error',
                actionSubjectId: 'postOfficePlacementErrorBoundary',
                attributes: {
                    error: error?.message,
                    errorInfo: errorInfo,
                    placementId: this.props.placementId
                }
            });
            analyticsEvent.fire(this.props.analyticsChannel);
            this.props.onError({
                error: error,
                type: 'render-error'
            });
            this.setState({
                hasError: true
            });
        }
        render() {
            if (this.state.hasError) return this.props.fallback ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                children: this.props.fallback
            }) : null;
            return this.props.children;
        }
    }
    var $53bcb23f511c4129$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($53bcb23f511c4129$var$ErrorBoundary);
});
const $78e0a2ec69f009c2$export$85183a312807388d = 'postOffice';
parcelRegister("7sr84", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagPlacementPreviewSwitcher", ()=>$f67b989a93e4f4dd$export$46db7cd62b063064);
    var $2OMIu = parcelRequire("2OMIu");
    var $lwdce;
    var $5vZ80;
    var $jgefF;
    var $8igoP;
    var $SfWIb;
    const $f67b989a93e4f4dd$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("8igoP")).ErrorBoundary), {
            fallback: errorFallback,
            onError: onError,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("5vZ80")).PlacementPreviewProvider), {
                eligibleMessages: eligibleMessages,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("SfWIb")).default), {
                    PlacementComponent: PlacementComponent,
                    placementId: placementId
                })
            })
        });
    const $f67b989a93e4f4dd$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
        const { searchParams: searchParams } = (0, (0, parcelRequire("lwdce")).usePostOfficeRoute)();
        const previewId = searchParams?.get('contentfulPreviewId');
        const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
        const eligibleMessage = [
            {
                messageInstanceId: 'messageInstanceId',
                messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
                messageCategory: 'Engagement',
                context: {
                    id: previewId
                },
                createdAt: new Date().toString(),
                eventTime: new Date().toString()
            }
        ];
        if (isEnabled && hasPreviewType) return (0, $2OMIu.jsx)($f67b989a93e4f4dd$export$16e97e6603eadea, {
            placementId: "screen-space-flags",
            PlacementComponent: (0, (0, parcelRequire("jgefF")).ScreenSpaceFlagsPlacementComponent),
            eligibleMessages: eligibleMessage
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("5vZ80", function(module, exports) {
    $parcel$export(module.exports, "PlacementPreviewProvider", ()=>$a6dbbce22e4d11ac$export$52e362b70e115c68);
    var $fZeMt;
    var $5uXOq = parcelRequire("5uXOq");
    const $a6dbbce22e4d11ac$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
    const $a6dbbce22e4d11ac$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
    const $a6dbbce22e4d11ac$export$52e362b70e115c68 = ({ eligibleMessages: eligibleMessages, children: children })=>{
        const fetch = (0, $5uXOq.useMemo)(()=>$a6dbbce22e4d11ac$export$c05392ff95b4319d({
                eligibleMessages: eligibleMessages
            }), [
            eligibleMessages
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fZeMt")).PlacementFetchingProvider), {
            fetch: fetch
        }, children);
    };
    const $a6dbbce22e4d11ac$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
            const finalUrl = url.replace($a6dbbce22e4d11ac$export$e5ffd38dcf6e5c53, $a6dbbce22e4d11ac$export$85c4756977e87c75);
            const payload = {
                originalMethod: options?.method || 'GET',
                originalBody: $a6dbbce22e4d11ac$var$parseBody(options?.body),
                eligibleMessages: eligibleMessages
            };
            return globalThis.fetch(finalUrl, {
                ...options,
                method: 'POST',
                headers: {
                    ...options?.headers || {}
                },
                body: $a6dbbce22e4d11ac$var$stringifyPayload(payload)
            });
        };
    const $a6dbbce22e4d11ac$var$objectHasKeys = (input)=>!!Object.keys(input).length;
    const $a6dbbce22e4d11ac$var$parseBody = (body)=>{
        if (typeof body === 'undefined' || body === null) return undefined;
        try {
            const parsedBody = JSON.parse(body);
            if ($a6dbbce22e4d11ac$var$objectHasKeys(parsedBody)) return parsedBody;
            throw new Error();
        } catch  {
            throw new Error('Unable to parse preview body. Is it a valid object?');
        }
    };
    const $a6dbbce22e4d11ac$var$stringifyPayload = (payload)=>{
        try {
            return JSON.stringify(payload);
        } catch  {
            throw new Error('Unable to parse preview body. Is it a valid object?');
        }
    };
});
parcelRegister("8igoP", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$609cb9bed692cc37$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    'use client';
    const $609cb9bed692cc37$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
    const $609cb9bed692cc37$var$initialState = {
        didCatch: false,
        error: null
    };
    class $609cb9bed692cc37$export$e926676385687eaf extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
            this.state = $609cb9bed692cc37$var$initialState;
        }
        static getDerivedStateFromError(error) {
            return {
                didCatch: true,
                error: error
            };
        }
        resetErrorBoundary() {
            const { error: error } = this.state;
            if (error !== null) {
                var _this$props$onReset, _this$props;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                    args: args,
                    reason: "imperative-api"
                });
                this.setState($609cb9bed692cc37$var$initialState);
            }
        }
        componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
        }
        componentDidUpdate(prevProps, prevState) {
            const { didCatch: didCatch } = this.state;
            const { resetKeys: resetKeys } = this.props;
            if (didCatch && prevState.error !== null && $609cb9bed692cc37$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
                var _this$props$onReset2, _this$props3;
                (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                    next: resetKeys,
                    prev: prevProps.resetKeys,
                    reason: "keys"
                });
                this.setState($609cb9bed692cc37$var$initialState);
            }
        }
        render() {
            const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
            const { didCatch: didCatch, error: error } = this.state;
            let childToRender = children;
            if (didCatch) {
                const props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
                else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
                else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
                else throw error;
            }
            return (0, $5uXOq.createElement)($609cb9bed692cc37$export$b16d9fb1a22de840.Provider, {
                value: {
                    didCatch: didCatch,
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                }
            }, childToRender);
        }
    }
    function $609cb9bed692cc37$var$hasArrayChanged() {
        let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
    }
    function $609cb9bed692cc37$var$assertErrorBoundaryContext(value) {
        if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
    }
    function $609cb9bed692cc37$export$c052f6604b7d51fe() {
        const context = (0, $5uXOq.useContext)($609cb9bed692cc37$export$b16d9fb1a22de840);
        $609cb9bed692cc37$var$assertErrorBoundaryContext(context);
        const [state, setState] = (0, $5uXOq.useState)({
            error: null,
            hasError: false
        });
        const memoized = (0, $5uXOq.useMemo)(()=>({
                resetBoundary: ()=>{
                    context.resetErrorBoundary();
                    setState({
                        error: null,
                        hasError: false
                    });
                },
                showBoundary: (error)=>setState({
                        error: error,
                        hasError: true
                    })
            }), [
            context.resetErrorBoundary
        ]);
        if (state.hasError) throw state.error;
        return memoized;
    }
    function $609cb9bed692cc37$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
        const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($609cb9bed692cc37$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
                ...props,
                ref: ref
            })));
        const name = component.displayName || component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
        return Wrapped;
    }
});
const $d0ca21152325de6b$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';
parcelRegister("eKtC8", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$31b7f947593face8$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $heNNl;
    const $31b7f947593face8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
        if (false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: id
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: id,
            packageName: "jiraEntry",
            fallback: "page",
            withExperienceTracker: withExperienceTracker
        }, children);
    };
});
parcelRegister("bAjl9", function(module, exports) {
    $parcel$export(module.exports, "IntlProviders", ()=>$fad1cef37914a278$export$c9d8cd4516cc55a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $1nUas;
    const $fad1cef37914a278$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1nUas")).IntlProvider), {
            messages: messages,
            locale: (0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale)
        }, children);
});
parcelRegister("1nUas", function(module, exports) {
    $parcel$export(module.exports, "IntlProvider", ()=>$0264700d4de7e638$export$480518999dfc4151);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            ...props,
            defaultLocale: props.locale
        }, children);
});
parcelRegister("lvG9V", function(module, exports) {
    $parcel$export(module.exports, "MetricsContainers", ()=>$2bc2dec1250f1cf8$export$2d1617bc0040e5d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $jb5yn;
    var $8ApFP;
    var $iXVV6;
    var $kDdFQ;
    const $2bc2dec1250f1cf8$export$2d1617bc0040e5d9 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jb5yn")).ExperienceTrackerProvider), null, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "metrics-containers-subproduct-updater",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDdFQ")).SubProductUpdater), null)), children));
});
parcelRegister("jb5yn", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTrackerProvider", ()=>$bcd25bc85dfeb009$export$6f49c95a810d59fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $ha42n;
    var $bSOOm;
    var $9sAyK;
    const $bcd25bc85dfeb009$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
            callback
        ]);
    const $bcd25bc85dfeb009$export$6f49c95a810d59fa = ({ children: children })=>{
        const [experienceTracker] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("ha42n")).ExperienceTracker)());
        const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, (0, parcelRequire("9sAyK")).sliSubscriber)));
        const cleanup = (0, $5uXOq.useCallback)(()=>{
            cleanupSliSub();
        }, [
            cleanupSliSub
        ]);
        $bcd25bc85dfeb009$var$useUnmount(cleanup);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext).Provider, {
            value: experienceTracker
        }, children);
    };
});
parcelRegister("9sAyK", function(module, exports) {
    $parcel$export(module.exports, "sliSubscriber", ()=>$6b2f2360dd11edee$export$db0b99fe17114899);
    var $fjcgS;
    var $efvDm;
    var $ldyPw;
    const $6b2f2360dd11edee$var$transformApplication = (application)=>{
        switch(application){
            case 0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE:
                return 'jira-software';
            case 0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, (0, parcelRequire("efvDm")).JIRA_CORE:
                return 'jira-core';
            case 0, (0, parcelRequire("efvDm")).JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, (0, parcelRequire("ldyPw")).FREE_EDITION:
                return 'jedi';
            case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                return 'standard';
            case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                return 'premium';
            case 0, (0, parcelRequire("ldyPw")).UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: action,
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                reason: location,
                analyticsSource: analyticsSource,
                application: $6b2f2360dd11edee$var$transformApplication(application),
                edition: $6b2f2360dd11edee$var$transformEdition(edition),
                ...errorMessage && {
                    errorMessage: errorMessage
                }
            }
        });
    const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
    const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
        const { name: name, action: action } = event;
        const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
        if (disableSli) return;
        switch(action){
            case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    ...event.error && {
                        errorMessage: String(event.error)
                    },
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
                break;
            default:
        }
    };
});
parcelRegister("kDdFQ", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5dc03f10b4b74566$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $cfDZ3;
    var $16v4H;
    const $5dc03f10b4b74566$export$eb40d3df56aa5c53 = ()=>{
        const subProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cfDZ3")).setSubProduct)(subProduct);
        }, [
            subProduct
        ]);
        return null;
    };
});
parcelRegister("16v4H", function(module, exports) {
    $parcel$export(module.exports, "subProductFromProjectType", ()=>$f7eda04ad2dc7e84$export$246e1e2a5c86a633);
    $parcel$export(module.exports, "useSubProduct", ()=>$f7eda04ad2dc7e84$export$16aa2ad52cd8992a);
    var $4DPZY;
    const $f7eda04ad2dc7e84$export$246e1e2a5c86a633 = (projectType)=>{
        switch(projectType){
            case 'business':
                return 'core';
            case 'product_discovery':
            case 'software':
                return 'software';
            case 'service_desk':
                return 'serviceDesk';
            default:
                projectType;
                return 'unknown';
        }
    };
    const $f7eda04ad2dc7e84$export$16aa2ad52cd8992a = ()=>{
        const [{ data: data }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        if (!data?.project) return null;
        return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(data.project.type);
    };
});
parcelRegister("gPTB6", function(module, exports) {
    $parcel$export(module.exports, "NavigationContainers", ()=>$1720b620f5483501$export$36f9ed697cae18ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $8ploF;
    let $1720b620f5483501$var$Containers = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (!false) $1720b620f5483501$var$Containers = (0, (0, parcelRequire("8ploF")).ClientOnlyNavigationContainers);
    const $1720b620f5483501$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
        (0, (0, parcelRequire("gKZoD")).di)($1720b620f5483501$var$Containers);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1720b620f5483501$var$Containers, {
            baseUrl: baseUrl
        }, children);
    };
});
parcelRegister("8ploF", function(module, exports) {
    $parcel$export(module.exports, "ClientOnlyNavigationContainers", ()=>$f5cf024286957bf6$export$68d7c1e44acfd599);
    var $5uXOq = parcelRequire("5uXOq");
    var $axSKo;
    const $f5cf024286957bf6$export$68d7c1e44acfd599 = ({ children: children })=>{
        if (!false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("axSKo")).Provider), null, children);
        return null;
    };
});
parcelRegister("9kep9", function(module, exports) {
    $parcel$export(module.exports, "PageConfigContainers", ()=>$83e79f36d4d977db$export$9c661932489b4130);
    var $5uXOq = parcelRequire("5uXOq");
    var $9MAC1;
    var $j8DrX;
    var $6nkVm;
    var $aX7Cy;
    const $83e79f36d4d977db$export$9c661932489b4130 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MAC1")).ThemeContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleContainer), {
            titleSuffix: (0, (0, parcelRequire("aX7Cy")).ripTitleTemplateFromMeta)((0, (0, parcelRequire("j8DrX")).default))
        }, children));
});
parcelRegister("9MAC1", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$a1f770a9d49220c1$export$93d4e7f90805808f);
    $parcel$export(module.exports, "ThemeContainer", ()=>$a1f770a9d49220c1$export$11eb671888ed6e7d);
    var $7JoAD = parcelRequire("7JoAD");
    var $LtWMd;
    const $a1f770a9d49220c1$var$initialState = {
        navigationTheme: {
            shouldShowTitle: false,
            logoUrl: '',
            usesCustomColours: false,
            backgroundColor: '',
            highlightColor: ''
        }
    };
    const $a1f770a9d49220c1$var$Store = (0, $7JoAD.createStore)({
        name: 'theme',
        initialState: $a1f770a9d49220c1$var$initialState,
        actions: (0, parcelRequire("LtWMd"))
    });
    const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, $7JoAD.createSubscriber)($a1f770a9d49220c1$var$Store);
    const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, $7JoAD.createHook)($a1f770a9d49220c1$var$Store);
    const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, $7JoAD.createContainer)($a1f770a9d49220c1$var$Store, {
        onInit: (0, parcelRequire("LtWMd")).bootstrap
    });
});
parcelRegister("LtWMd", function(module, exports) {
    $parcel$export(module.exports, "bootstrap", ()=>$9594f0aa641d3463$export$36aff1fbb4f5dfc6);
    $parcel$export(module.exports, "update", ()=>$9594f0aa641d3463$export$722fbec263ad908a);
    const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
            const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
            const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
            const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $829f609a65d26a98$exports).N0 || ajsHighlightColor !== (0, $829f609a65d26a98$exports).B400);
            const navigationTheme = {
                shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
                logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
                usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
                backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$exports).N0})`,
                highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $829f609a65d26a98$exports).B400})`
            };
            if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
            setState({
                navigationTheme: navigationTheme
            });
        };
    const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
            const navigationTheme = {
                ...getState().navigationTheme,
                ...item
            };
            setState({
                navigationTheme: navigationTheme
            });
        };
});
parcelRegister("6nkVm", function(module, exports) {
    $parcel$export(module.exports, "useDocumentTitleActions", ()=>$301148c3154b34a4$export$57c0fda036e12d67);
    $parcel$export(module.exports, "DocumentTitleContainer", ()=>$301148c3154b34a4$export$1aad43993172f16f);
    $parcel$export(module.exports, "DocumentTitleSubscriber", ()=>$301148c3154b34a4$export$b88d5abf3e0bec8c);
    $parcel$export(module.exports, "DocumentTitleHelper", ()=>$301148c3154b34a4$export$573bf8d2ae7d60dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $7JoAD = parcelRequire("7JoAD");
    var $3Nww0;
    var $aX7Cy;
    const $301148c3154b34a4$var$initialState = {
        title: '',
        defaultTitle: '',
        contextArray: []
    };
    const $301148c3154b34a4$var$Store = (0, $7JoAD.createStore)({
        name: 'document-title',
        initialState: $301148c3154b34a4$var$initialState,
        actions: (0, parcelRequire("3Nww0"))
    });
    const $301148c3154b34a4$export$57c0fda036e12d67 = (0, $7JoAD.createActionsHook)($301148c3154b34a4$var$Store);
    const $301148c3154b34a4$export$1aad43993172f16f = (0, $7JoAD.createContainer)($301148c3154b34a4$var$Store, {
        displayName: 'DocumentTitleContainer'
    });
    const $301148c3154b34a4$export$b88d5abf3e0bec8c = (0, $7JoAD.createSubscriber)($301148c3154b34a4$var$Store, {
        displayName: 'DocumentTitleSubscriber'
    });
    class $301148c3154b34a4$export$573bf8d2ae7d60dc extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.myself = Symbol('document title identifier');
            this.props.addDocumentTitle(this.myself);
        }
        componentDidMount() {
            this.updateTitle();
        }
        componentDidUpdate() {
            this.updateTitle();
        }
        componentWillUnmount() {
            this.props.removeDocumentTitle(this.myself);
            this.updateTitle();
        }
        updateTitle() {
            if ((0, (0, parcelRequire("aX7Cy")).checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("3Nww0", function(module, exports) {
    $parcel$export(module.exports, "setTitle", ()=>(parcelRequire("9vNeL")).default);
    $parcel$export(module.exports, "addDocumentTitle", ()=>(parcelRequire("5Oj7f")).addDocumentTitle);
    $parcel$export(module.exports, "removeDocumentTitle", ()=>(parcelRequire("gJBAO")).removeDocumentTitle);
    var $9vNeL;
    var $5Oj7f;
    var $gJBAO;
});
parcelRegister("9vNeL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa0c91bbbd212a23$export$2e2bcd8739ae039);
    var $aX7Cy;
    var $aa0c91bbbd212a23$export$2e2bcd8739ae039 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
            const state = getState();
            const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
            const newTitle = (0, (0, parcelRequire("aX7Cy")).createTitleFromTemplate)(title, titleTemplate);
            document.title = newTitle;
            setState({
                ...state,
                title: newTitle
            });
        };
});
parcelRegister("aX7Cy", function(module, exports) {
    $parcel$export(module.exports, "createTitleFromTemplate", ()=>$45855f8363268b1b$export$3795256dd54a9c9d);
    $parcel$export(module.exports, "ripTitleTemplateFromMeta", ()=>$45855f8363268b1b$export$b7d18105f80195c);
    $parcel$export(module.exports, "checkDocumentTitle", ()=>$45855f8363268b1b$export$7f8be70a0bed1bae);
    const $45855f8363268b1b$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
    const $45855f8363268b1b$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
    const $45855f8363268b1b$export$7f8be70a0bed1bae = (title, contextArray)=>{
        if (contextArray[contextArray.length - 1] === title) return true;
        return false;
    };
});
parcelRegister("5Oj7f", function(module, exports) {
    $parcel$export(module.exports, "addDocumentTitle", ()=>$53f35561ab86eb34$export$a0c188c0ea474bb8);
    const $53f35561ab86eb34$export$a0c188c0ea474bb8 = (title)=>({ setState: setState, getState: getState })=>{
            const { contextArray: contextArray } = getState();
            contextArray.push(title);
            setState({
                contextArray: contextArray
            });
        };
});
parcelRegister("gJBAO", function(module, exports) {
    $parcel$export(module.exports, "removeDocumentTitle", ()=>$bcdbd43154f62b45$export$e844009b77f80a72);
    const $bcdbd43154f62b45$export$e844009b77f80a72 = (title)=>({ setState: setState, getState: getState })=>{
            const { contextArray: contextArray } = getState();
            setState({
                contextArray: contextArray.filter((symbol)=>symbol !== title)
            });
        };
});
parcelRegister("eSznd", function(module, exports) {
    $parcel$export(module.exports, "UiManagers", ()=>$ca023ab667a452ba$export$41286c339a88ca24);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $e0Brz;
    var $5zgk6;
    var $9rAvm;
    let $ca023ab667a452ba$var$ClientUiManagers = (0, $5uXOq.Fragment);
    if (!false) $ca023ab667a452ba$var$ClientUiManagers = (0, (0, parcelRequire("9rAvm")).ClientUiManagers);
    const $ca023ab667a452ba$export$41286c339a88ca24 = ({ children: children })=>{
        (0, (0, parcelRequire("gKZoD")).di)($ca023ab667a452ba$var$ClientUiManagers);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5zgk6")).LayoutManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement($ca023ab667a452ba$var$ClientUiManagers, null, children)));
    };
});
parcelRegister("e0Brz", function(module, exports) {
    $parcel$export(module.exports, "BreadcrumbManager", ()=>$e20dc5e8426041f9$export$cd5073909dd92c28);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIVNN;
    const $e20dc5e8426041f9$export$cd5073909dd92c28 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aIVNN")).BreadcrumbContainer), null, children);
});
parcelRegister("5zgk6", function(module, exports) {
    $parcel$export(module.exports, "LayoutManager", ()=>$20f0b1159f4863ef$export$4a04ad01c410b415);
    var $5uXOq = parcelRequire("5uXOq");
    var $c34Wf;
    var $dIdda = parcelRequire("dIdda");
    var $7JoAD = parcelRequire("7JoAD");
    var $8CM3x;
    var $5e5zm;
    const $20f0b1159f4863ef$var$LayoutContainer = (0, $7JoAD.createContainer)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        displayName: 'JiraLayoutContainer',
        onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setIsChromeless(isChromeless));
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setLeftSidebarState(leftSidebar));
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setRightSidebarState(rightSidebar));
            },
        onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setIsChromeless(isChromeless));
            }
    });
    const $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
        stackState: []
    };
    const $20f0b1159f4863ef$var$useIsChromeless = (0, $dIdda.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
    const $20f0b1159f4863ef$export$4a04ad01c410b415 = ({ children: children })=>{
        const { data: data } = (0, $dIdda.useResource)((0, (0, parcelRequire("c34Wf")).navigationUiStateResource));
        const isChromeless = $20f0b1159f4863ef$var$useIsChromeless();
        const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
        const leftSidebarWidth = data?.leftSidebar?.width ?? (0, (0, parcelRequire("5e5zm")).DEFAULT_LEFT_SIDEBAR_WIDTH);
        const leftSidebar = (0, $5uXOq.useMemo)(()=>({
                isVisible: true,
                isCollapsed: isLeftSidebarCollapsed,
                width: leftSidebarWidth,
                isFlyoutOpen: false
            }), [
            isLeftSidebarCollapsed,
            leftSidebarWidth
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($20f0b1159f4863ef$var$LayoutContainer, {
            isGlobal: true,
            isChromeless: isChromeless,
            leftSidebar: leftSidebar,
            rightSidebar: $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE
        }, children);
    };
});
parcelRegister("9rAvm", function(module, exports) {
    $parcel$export(module.exports, "ClientUiManagers", ()=>$2b5f3846e82b020b$export$d1db6ae5bf84e489);
    var $5uXOq = parcelRequire("5uXOq");
    var $imZsD;
    var $6pvrS;
    var $4041n;
    var $pa9q9;
    var $2HbP2;
    var $4yEIl;
    var $bKCrm;
    const $2b5f3846e82b020b$export$d1db6ae5bf84e489 = ({ children: children })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6pvrS")).CrossFlowProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4yEIl")).PostOfficeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4041n")).FavoriteChangeProvider), {
            onShowFlag: showFlag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2HbP2")).ModalContextProvider), null, children))))));
    };
});
parcelRegister("6pvrS", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowProvider", ()=>$2cd77fddb456dca8$export$d900e4062895cd7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $882vQ = parcelRequire("882vQ");
    var $fjcgS;
    var $9OXo1;
    var $g2XuF;
    var $5emZd;
    const $2cd77fddb456dca8$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
            sendUIEvent: ()=>{},
            sendOperationalEvent: ()=>{},
            sendTrackEvent: ()=>{},
            sendScreenEvent: ()=>{}
        }) : (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
    const $2cd77fddb456dca8$export$d900e4062895cd7c = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: { cloudId: cloudId, locale: locale } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $882vQ.default), {
                cloudId: cloudId,
                analyticsClient: $2cd77fddb456dca8$var$getAnalyticsInstance(),
                locale: locale,
                plugins: [
                    (0, (0, parcelRequire("g2XuF")).getContainersPlugin),
                    (0, (0, parcelRequire("5emZd")).getUsersPlugin)
                ]
            }, children));
});
parcelRegister("882vQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25c23a8ec43eecca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dao3I = parcelRequire("dao3I");
    var $941eD = parcelRequire("941eD");
    const $25c23a8ec43eecca$var$JiraProvider = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dao3I.CrossFlowProvider), {
            ...props,
            originProduct: "jira"
        });
    };
    var $25c23a8ec43eecca$export$2e2bcd8739ae039 = $25c23a8ec43eecca$var$JiraProvider;
});
parcelRegister("dao3I", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowProvider", ()=>$1615837ea7cb5623$export$d900e4062895cd7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bHpB9 = parcelRequire("bHpB9");
    var $cSyk1;
    var $5IPCv;
    var $82zEM = parcelRequire("82zEM");
    var $3lpON = parcelRequire("3lpON");
    var $3OuEq = parcelRequire("3OuEq");
    var $iVEiS = parcelRequire("iVEiS");
    var $5cLUX = parcelRequire("5cLUX");
    var $7TqdN = parcelRequire("7TqdN");
    var $h2lEj = parcelRequire("h2lEj");
    const $1615837ea7cb5623$var$IntegrationView = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("2PFSu")));
    const $1615837ea7cb5623$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
            const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
            const tblz852ExperimentCohort = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue('product_store_personal_use_case', 'cohort', 'not-enrolled', {
                fireExperimentExposure: false
            });
            const isInTblz852ExperimentCohort = tblz852ExperimentCohort === 'variation';
            const onCloseResolver = (0, $5uXOq.useRef)();
            const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $5uXOq.useState)(false);
            const fireEvent = (0, $5uXOq.useMemo)(()=>(0, $82zEM.analyticsWrapper)(analyticsClient), [
                analyticsClient
            ]);
            const [requestOptions, setRequestOptions] = (0, $5uXOq.useState)();
            const onAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
                const gasV3Event = (0, $3lpON.transformEvent)(payload);
                if (gasV3Event) {
                    const enrichedEvent = (0, $7TqdN.enrichWithRequestOptions)((0, $5cLUX.enrichWithPackageDetails)(gasV3Event), requestOptions);
                    fireEvent(enrichedEvent);
                }
            }, [
                fireEvent,
                requestOptions
            ]);
            const onHandShake = (0, $5uXOq.useCallback)((appName)=>{
                if (!firstHandshakeReceived) {
                    onAnalyticsEvent({
                        payload: {
                            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                            action: (0, $h2lEj.uiInitialized),
                            actionSubject: (0, $h2lEj.crossFlowActionSubject),
                            attributes: {
                                appName: appName
                            }
                        },
                        context: [
                            {
                                source: $h2lEj.source
                            }
                        ]
                    });
                    setFirstHandshakeReceived(true);
                }
            }, [
                firstHandshakeReceived,
                onAnalyticsEvent
            ]);
            const onOpen = (0, $5uXOq.useCallback)((options)=>{
                setFirstHandshakeReceived(false);
                const analyticsEvent = {
                    payload: (0, $7TqdN.enrichWithRequestOptions)({
                        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                        action: (0, $h2lEj.openInvoked),
                        actionSubject: (0, $h2lEj.crossFlowActionSubject)
                    }, options),
                    context: [
                        {
                            source: $h2lEj.source
                        }
                    ]
                };
                onAnalyticsEvent(analyticsEvent);
                if (options.journey === (0, $bHpB9.Journeys).GET_STARTED && redirectToWac) {
                    (0, $3OuEq.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                    const completionStatus = {};
                    return Promise.resolve(completionStatus);
                }
                const updatedExperimentalOptions = {
                    ...globalExperimentalOptions || {},
                    ...options.experimentalOptions || {}
                };
                options.experimentalOptions = updatedExperimentalOptions;
                setRequestOptions(options);
                return new Promise((resolve)=>{
                    onCloseResolver.current = resolve;
                });
            }, [
                onAnalyticsEvent,
                env,
                redirectToWac,
                globalExperimentalOptions
            ]);
            const onClose = (0, $5uXOq.useCallback)((completionStatus)=>{
                setFirstHandshakeReceived(false);
                setRequestOptions(undefined);
                onCloseResolver.current && onCloseResolver.current(completionStatus);
            }, []);
            const { colorMode: colorMode } = (0, (0, parcelRequire("cSyk1")).default)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bHpB9.BaseCrossFlowApiProvider), {
                onOpen: onOpen
            }, children, requestOptions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iVEiS.ErrorBoundary), {
                onAnalyticsEvent: onAnalyticsEvent,
                onError: onError
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(IntegrationView, {
                ...baseProviderProps,
                ...requestOptions,
                onAnalyticsEvent: onAnalyticsEvent,
                originProduct: originProduct,
                theme: colorMode,
                onClose: onClose,
                onHandShake: onHandShake,
                plugins: plugins,
                env: env,
                redirectToWac: redirectToWac,
                isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
                zIndex: requestOptions.zIndex ?? 1000
            }))));
        };
    const $1615837ea7cb5623$export$d900e4062895cd7c = $1615837ea7cb5623$export$79d79d8dd8574306($1615837ea7cb5623$var$IntegrationView);
});
parcelRegister("82zEM", function(module, exports) {
    $parcel$export(module.exports, "analyticsWrapper", ()=>$b24c5aab06626f3f$export$91b4dd3bfc301325);
    const $b24c5aab06626f3f$export$91b4dd3bfc301325 = (analyticsClient)=>{
        return (event)=>{
            return Promise.resolve(analyticsClient).then((client)=>{
                switch(event.eventType){
                    case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
                        client.sendUIEvent(event);
                        break;
                    case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
                        client.sendTrackEvent(event);
                        break;
                    case 0, $676c5e519aa5ba55$export$12346a674644c156:
                        client.sendOperationalEvent(event);
                        break;
                    case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
                        client.sendScreenEvent(event);
                        break;
                }
            });
        };
    };
});
parcelRegister("3lpON", function(module, exports) {
    $parcel$export(module.exports, "transformEvent", ()=>$3b1dc20af714f949$export$3f40e8c44448be30);
    const $3b1dc20af714f949$var$GROWTH_TAG = 'growth';
    const $3b1dc20af714f949$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
            propertyNames.forEach((propertyName)=>{
                const navContextProp = contextItem ? contextItem[propertyName] : null;
                acc.push(navContextProp || contextItem[propertyName]);
            });
            return acc;
        }, []).filter(Boolean);
    const $3b1dc20af714f949$var$getSources = (context)=>$3b1dc20af714f949$var$extractFromEventContext([
            'source'
        ], context);
    const $3b1dc20af714f949$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
            const newAttributes = {
                ...ans,
                ...contextProps
            };
            return attributes ? {
                ...newAttributes,
                ...attributes
            } : newAttributes;
        }, {});
    const $3b1dc20af714f949$var$getPackageInfo = (context)=>context.map((contextItem)=>({
                packageName: contextItem.packageName,
                packageVersion: contextItem.packageVersion
            })).filter((p)=>p.packageName);
    const $3b1dc20af714f949$var$last = (values)=>values[values.length - 1];
    const $3b1dc20af714f949$export$3f40e8c44448be30 = (event)=>{
        const { context: context, payload: payload } = event;
        if (!payload) return null;
        const sources = $3b1dc20af714f949$var$getSources(context);
        const source = $3b1dc20af714f949$var$last(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
        const extraAttributes = $3b1dc20af714f949$var$getExtraAttributes(context);
        const { packageName: packageName, packageVersion: packageVersion } = $3b1dc20af714f949$var$last($3b1dc20af714f949$var$getPackageInfo(context)) || {};
        const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
        const attributes = {
            packageName: packageName,
            packageVersion: packageVersion,
            ...extraAttributes,
            ...payloadAttributes
        };
        const tags = payload.tags || [];
        tags.push($3b1dc20af714f949$var$GROWTH_TAG);
        switch(eventType){
            case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
            case 0, $676c5e519aa5ba55$export$12346a674644c156:
            case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
                return {
                    eventType: eventType,
                    source: source,
                    actionSubject: actionSubject,
                    action: action,
                    actionSubjectId: actionSubjectId,
                    attributes: attributes,
                    tags: tags.slice(0)
                };
            case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
                return {
                    eventType: eventType,
                    name: name,
                    attributes: attributes,
                    source: source,
                    tags: tags.slice(0)
                };
            default:
                break;
        }
        return null;
    };
});
parcelRegister("3OuEq", function(module, exports) {
    $parcel$export(module.exports, "setProductSignUpLocation", ()=>$67a1e1e75aba157c$export$2827e2473cb9a346);
    var $jWY5k = parcelRequire("jWY5k");
    var $ADfeX = parcelRequire("ADfeX");
    const $67a1e1e75aba157c$var$utmCampaignMap = {
        'atlassian-switcher': (0, $ADfeX.UtmCampaign)['atlassian-switcher']
    };
    const $67a1e1e75aba157c$var$isBundledProduct = (productKey)=>{
        return [
            (0, $jWY5k.Targets).JIRA_SOFTWARE,
            (0, $jWY5k.Targets).JIRA_SERVICE_DESK,
            (0, $jWY5k.Targets).JIRA_CORE,
            (0, $jWY5k.Targets).CONFLUENCE
        ].includes(productKey);
    };
    const $67a1e1e75aba157c$var$getBundleSignUpParams = (productKey)=>{
        const bundles = {
            [(0, $jWY5k.Targets).JIRA_SOFTWARE]: 'jira-software',
            [(0, $jWY5k.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
            [(0, $jWY5k.Targets).JIRA_CORE]: 'jira-core',
            [(0, $jWY5k.Targets).CONFLUENCE]: 'confluence'
        };
        return `bundle=${bundles[productKey]}&edition=free`;
    };
    const $67a1e1e75aba157c$var$isProductWithCustomSignUpPath = (productKey)=>{
        return [
            (0, $jWY5k.Targets).OPSGENIE
        ].includes(productKey);
    };
    const $67a1e1e75aba157c$var$getProductCustomSignUpPath = (productKey)=>{
        const links = {
            [(0, $jWY5k.Targets).OPSGENIE]: (0, $e3b3c434f6296013$export$fb1e43fdafe12e9b)
        };
        return links[productKey];
    };
    const $67a1e1e75aba157c$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
        return Boolean($67a1e1e75aba157c$var$utmCampaignMap[sourceComponent]);
    };
    const $67a1e1e75aba157c$var$getUtmParams = (sourceComponent, sourceContext)=>{
        let utmParams = '';
        if (sourceComponent && $67a1e1e75aba157c$var$isSourceComponentWithUtmParams(sourceComponent)) {
            utmParams = utmParams + `utm_campaign=${$67a1e1e75aba157c$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
            if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
        }
        return utmParams;
    };
    const $67a1e1e75aba157c$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
        const wacUrl = env === 'staging' ? (0, $e3b3c434f6296013$export$c37558e5c67d2b01) : (0, $e3b3c434f6296013$export$f199baf8dfc7621e);
        const utmParams = $67a1e1e75aba157c$var$getUtmParams(sourceComponent, sourceContext);
        let queryParams = '';
        let bundleParams = '';
        let path = (0, $e3b3c434f6296013$export$2a45a00073911255);
        if ($67a1e1e75aba157c$var$isBundledProduct(productKey)) {
            path = (0, $e3b3c434f6296013$export$e6c04a1dd86d1c14);
            bundleParams = $67a1e1e75aba157c$var$getBundleSignUpParams(productKey);
        } else if ($67a1e1e75aba157c$var$isProductWithCustomSignUpPath(productKey)) path = $67a1e1e75aba157c$var$getProductCustomSignUpPath(productKey);
        if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
        if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
        return wacUrl + path + queryParams;
    };
    const $67a1e1e75aba157c$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
        const url = $67a1e1e75aba157c$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
        window.open(url, '_blank');
    };
});
const $e3b3c434f6296013$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $e3b3c434f6296013$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $e3b3c434f6296013$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $e3b3c434f6296013$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $e3b3c434f6296013$export$2a45a00073911255 = '/software';
parcelRegister("ADfeX", function(module, exports) {
    $parcel$export(module.exports, "UtmCampaign", ()=>$640d6f0c65fd4030$export$fc604aa353a97e10);
    var $640d6f0c65fd4030$export$fc604aa353a97e10;
    (function(UtmCampaign) {
        UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    })($640d6f0c65fd4030$export$fc604aa353a97e10 || ($640d6f0c65fd4030$export$fc604aa353a97e10 = {}));
});
parcelRegister("iVEiS", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$d3d63fce8596c929$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $h2lEj = parcelRequire("h2lEj");
    const $d3d63fce8596c929$var$name = "platform-pkg";
    const $d3d63fce8596c929$var$version = "0.0.0-use.local";
    const $d3d63fce8596c929$var$payload = {
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        action: (0, $h2lEj.errorBoundaryAction),
        actionSubject: (0, $h2lEj.errorBoundaryActionSubject)
    };
    const $d3d63fce8596c929$var$context = [
        {
            source: $h2lEj.source
        },
        {
            packageName: $d3d63fce8596c929$var$name,
            packageVersion: $d3d63fce8596c929$var$version
        }
    ];
    class $d3d63fce8596c929$export$e926676385687eaf extends (0, $5uXOq.Component) {
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        componentDidCatch(error) {
            this.props.onAnalyticsEvent({
                payload: $d3d63fce8596c929$var$payload,
                context: $d3d63fce8596c929$var$context
            });
            if (this.props.onError) this.props.onError(error);
        }
        render() {
            if (this.state.hasError) return null;
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.state = {
                hasError: false
            };
        }
    }
});
parcelRegister("h2lEj", function(module, exports) {
    $parcel$export(module.exports, "source", ()=>$9517cbf005e80ab1$export$b4d5da5f34fb77ad);
    $parcel$export(module.exports, "errorBoundaryAction", ()=>$9517cbf005e80ab1$export$9d8252a268f4fa72);
    $parcel$export(module.exports, "errorBoundaryActionSubject", ()=>$9517cbf005e80ab1$export$1045419caf49b395);
    $parcel$export(module.exports, "crossFlowActionSubject", ()=>$9517cbf005e80ab1$export$d54c183f56e39aa5);
    $parcel$export(module.exports, "uiInitialized", ()=>$9517cbf005e80ab1$export$e5c2c058fa8068a6);
    $parcel$export(module.exports, "openInvoked", ()=>$9517cbf005e80ab1$export$e67cdcb8867a3bd0);
    $parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", ()=>$676c5e519aa5ba55$export$12346a674644c156);
    const $9517cbf005e80ab1$export$b4d5da5f34fb77ad = 'crossFlowProvider';
    const $9517cbf005e80ab1$export$9d8252a268f4fa72 = 'errorCaught';
    const $9517cbf005e80ab1$export$1045419caf49b395 = 'errorBoundary';
    const $9517cbf005e80ab1$export$d54c183f56e39aa5 = 'crossFlowSupport';
    const $9517cbf005e80ab1$export$e5c2c058fa8068a6 = 'uiInitialized';
    const $9517cbf005e80ab1$export$e67cdcb8867a3bd0 = 'openInvoked';
});
parcelRegister("5cLUX", function(module, exports) {
    $parcel$export(module.exports, "enrichWithPackageDetails", ()=>$20ff5e7e37c2b429$export$59518efab336a8b5);
    const $20ff5e7e37c2b429$var$version = "0.0.0-use.local";
    const $20ff5e7e37c2b429$export$84f9cf7ef89d4c26 = {
        version: $20ff5e7e37c2b429$var$version
    };
    const $20ff5e7e37c2b429$export$59518efab336a8b5 = (event)=>{
        const attributes = {
            ...event.attributes || {},
            crossFlowSupport: $20ff5e7e37c2b429$export$84f9cf7ef89d4c26
        };
        return {
            ...event,
            attributes: attributes
        };
    };
});
parcelRegister("7TqdN", function(module, exports) {
    $parcel$export(module.exports, "enrichWithRequestOptions", ()=>$f9ac334198e2c83e$export$a5a156dc5df42f0);
    const $f9ac334198e2c83e$export$a5a156dc5df42f0 = (event, requestOptions)=>{
        if (!requestOptions) return event;
        const attributes = {
            ...requestOptions.extraAnalyticsAttributes || {},
            ...event.attributes || {},
            sourceComponent: requestOptions.sourceComponent,
            sourceContext: requestOptions.sourceContext
        };
        return {
            ...event,
            attributes: attributes
        };
    };
});
parcelRegister("2PFSu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("biYHu")
    ]).then(()=>parcelRequire('an4UX'));
});
parcelRegister("g2XuF", function(module, exports) {
    $parcel$export(module.exports, "getContainersPlugin", ()=>$014cd965663d7125$export$81d1d40061d190bc);
    parcelRequire("eZVkU");
    var $3DVw8 = parcelRequire("3DVw8");
    var $eZVkU = parcelRequire("eZVkU");
    var $4Pf62;
    const $014cd965663d7125$var$getCloudId = async ()=>{
        const { cloudName: cloudName, cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const containers = [
            {
                id: cloudId,
                displayName: cloudName,
                type: (0, $3DVw8.ContainerTypes).ATLASSIAN_CLOUD_ID
            }
        ];
        return {
            type: (0, $3DVw8.ContainerTypes).ATLASSIAN_CLOUD_ID,
            containers: containers
        };
    };
    const $014cd965663d7125$export$81d1d40061d190bc = (0, $eZVkU.createGetContainersPlugin)($014cd965663d7125$var$getCloudId);
});
parcelRegister("eZVkU", function(module, exports) {
    $parcel$export(module.exports, "createGetContainersPlugin", ()=>$b5c1d3bea11e821b$export$76378b0f825c024c);
    $parcel$export(module.exports, "createGetUsersPlugin", ()=>$b5c1d3bea11e821b$export$8feb7eae83cf8cd5);
    $parcel$export(module.exports, "ContainerTypes", ()=>(parcelRequire("3DVw8")).ContainerTypes);
    $parcel$export(module.exports, "UserIdTypes", ()=>(parcelRequire("3DVw8")).UserIdTypes);
    var $3DVw8 = parcelRequire("3DVw8");
    const $b5c1d3bea11e821b$export$76378b0f825c024c = (fetch)=>{
        return [
            (0, $3DVw8.PluginTypes).GetContainers,
            fetch
        ];
    };
    const $b5c1d3bea11e821b$export$8feb7eae83cf8cd5 = (fetch)=>{
        return [
            (0, $3DVw8.PluginTypes).GetUsers,
            fetch
        ];
    };
    const $b5c1d3bea11e821b$export$21d120847be2aff4 = (fetch)=>{
        return [
            (0, $3DVw8.PluginTypes).GetSuggestedSiteNames,
            fetch
        ];
    };
    const $b5c1d3bea11e821b$export$d7c1699c6a2ca18a = (fetch)=>{
        return [
            (0, $3DVw8.PluginTypes).GetAvailableSites,
            fetch
        ];
    };
});
parcelRegister("3DVw8", function(module, exports) {
    $parcel$export(module.exports, "PluginTypes", ()=>$f763104318ce258c$export$a235a73f7b906dce);
    $parcel$export(module.exports, "ContainerTypes", ()=>$f763104318ce258c$export$6e383182a26455ff);
    $parcel$export(module.exports, "UserIdTypes", ()=>$f763104318ce258c$export$e391bab95adb8396);
    const $f763104318ce258c$export$a235a73f7b906dce = {
        GetContainers: 'GetContainers',
        GetUsers: 'GetUsers',
        GetSuggestedSiteNames: 'GetSuggestedSiteNames',
        GetAvailableSites: 'GetAvailableSites'
    };
    const $f763104318ce258c$export$6e383182a26455ff = {
        BITBUCKET_WORKSPACE: 'bitbucket-workspace',
        ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
        JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
    };
    const $f763104318ce258c$export$e391bab95adb8396 = {
        ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
        TRELLO_ID: 'TRELLO_ID'
    };
    const $f763104318ce258c$export$4f378ba35c571906 = {
        JIRA_BUSINESS: 'JIRA_BUSINESS',
        JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
        JIRA_SOFTWARE: 'JIRA_SOFTWARE',
        CONFLUENCE: 'CONFLUENCE',
        OPSGENIE: 'OPSGENIE',
        BITBUCKET: 'BITBUCKET',
        STATUSPAGE: 'STATUSPAGE',
        TRELLO: 'TRELLO',
        COMPASS: 'COMPASS'
    };
});
parcelRegister("5emZd", function(module, exports) {
    $parcel$export(module.exports, "getUsersPlugin", ()=>$83dd2c216cba0381$export$7c44908d2777db01);
    var $eZVkU = parcelRequire("eZVkU");
    var $3DVw8 = parcelRequire("3DVw8");
    const $83dd2c216cba0381$var$getUsers = async (containerId)=>{
        const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
        try {
            const response = await fetch(getUsersUrl, {
                credentials: 'same-origin'
            });
            if (response.ok) {
                const data = await response.json();
                return data.map((value)=>({
                        id: value.id,
                        idType: (0, $3DVw8.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                        displayName: value.displayName
                    }));
            }
            throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
        } catch (error) {
            throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
        }
    };
    const $83dd2c216cba0381$export$7c44908d2777db01 = (0, $eZVkU.createGetUsersPlugin)($83dd2c216cba0381$var$getUsers);
});
parcelRegister("2HbP2", function(module, exports) {
    $parcel$export(module.exports, "ModalContextProvider", ()=>$d012230882eb31a4$export$7c9538f5f3c365e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $gJdig;
    function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
        const id = (0, $5uXOq.useRef)(1);
        const [modals, setModals] = (0, $5uXOq.useState)([]);
        const modalContext = (0, $5uXOq.useMemo)(()=>({
                openModal: (component)=>{
                    const key = String(id.current++);
                    const close = ()=>{
                        setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                    };
                    setModals((mdls)=>[
                            ...mdls,
                            {
                                close: close,
                                component: component,
                                key: key
                            }
                        ]);
                }
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gJdig")).ModalContext).Provider, {
            value: modalContext
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, modals.map((modal)=>(0, ($parcel$interopDefault($5uXOq))).createElement(modal.component, {
                key: modal.key,
                onClose: modal.close
            }))));
    }
});
parcelRegister("gJdig", function(module, exports) {
    $parcel$export(module.exports, "ModalContext", ()=>$308ba6e6ba886f08$export$ab57792b9b6974a6);
    var $5uXOq = parcelRequire("5uXOq");
    const $308ba6e6ba886f08$export$ab57792b9b6974a6 = (0, $5uXOq.createContext)({
        openModal: ()=>{}
    });
});
parcelRegister("ivvwC", function(module, exports) {
    $parcel$export(module.exports, "UserContainers", ()=>$0fd080febb09e205$export$c1b371eec908681a);
    var $5uXOq = parcelRequire("5uXOq");
    var $d9VAQ;
    var $leRCk;
    const $0fd080febb09e205$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("leRCk")).UserContainer), {
            isGlobal: true,
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9VAQ")).UserPreferencesContainer), {
            isGlobal: true
        }, children));
});
parcelRegister("d9VAQ", function(module, exports) {
    $parcel$export(module.exports, "UserPreferencesContainer", ()=>$3038471ea054300f$export$aa278641ded1adf);
    var $7JoAD = parcelRequire("7JoAD");
    var $eYegl;
    const $3038471ea054300f$export$be74e04eaea4530 = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("eYegl")).default), {
        displayName: 'UserPreferencesSubscriber'
    });
    const $3038471ea054300f$export$aa278641ded1adf = (0, $7JoAD.createContainer)((0, (0, parcelRequire("eYegl")).default));
});
parcelRegister("eYegl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc414d73e667f785$export$2e2bcd8739ae039);
    var $7JoAD = parcelRequire("7JoAD");
    var $7AJyg;
    const $bc414d73e667f785$var$initialState = {
        'issue-view-experiment': {
            data: {
                value: false
            },
            loading: false,
            error: null
        }
    };
    var $bc414d73e667f785$export$2e2bcd8739ae039 = (0, $7JoAD.createStore)({
        name: 'user-preference',
        initialState: $bc414d73e667f785$var$initialState,
        actions: (0, parcelRequire("7AJyg"))
    });
});
parcelRegister("7AJyg", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>(parcelRequire("g6Vt5")).default);
    $parcel$export(module.exports, "fetchIssueCreate", ()=>(parcelRequire("ePV4l")).default);
    $parcel$export(module.exports, "updateExperiment", ()=>(parcelRequire("8Lrq8")).default);
    var $g6Vt5;
    var $ePV4l;
    var $8Lrq8;
});
parcelRegister("g6Vt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a561c8a03710a3f2$export$2e2bcd8739ae039);
    var $goEOn;
    var $a561c8a03710a3f2$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
            const currentState = getState();
            if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
            setState({
                [preferenceKey]: {
                    data: currentState.data,
                    loading: true,
                    error: null
                }
            });
            try {
                const data = await (0, (0, parcelRequire("goEOn")).default)({
                    baseUrl: baseUrl,
                    preferenceKey: preferenceKey
                });
                setState({
                    [preferenceKey]: {
                        data: data,
                        loading: false,
                        error: null
                    }
                });
            } catch (err) {
                setState({
                    [preferenceKey]: {
                        data: getState().data,
                        loading: false,
                        error: err
                    }
                });
            }
        };
});
parcelRegister("goEOn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0be3c96b3fac1b7f$export$2e2bcd8739ae039);
    var $4Lzq2;
    var $0be3c96b3fac1b7f$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, preferenceKey: preferenceKey })=>{
        try {
            const result = await (0, (0, parcelRequire("4Lzq2")).default)(baseUrl, preferenceKey);
            return {
                value: result
            };
        } catch (e) {
            if (e.statusCode === 404) return {
                value: undefined
            };
            throw e;
        }
    };
});
parcelRegister("4Lzq2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efdd8b3604a0d493$export$2e2bcd8739ae039);
    var $eusud;
    var $efdd8b3604a0d493$export$2e2bcd8739ae039 = (baseUrl, key)=>{
        const requestUrl = `${baseUrl}/rest/api/3/mypreferences?key=${key}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(requestUrl);
    };
});
parcelRegister("ePV4l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01fcb0eb90bce4cf$export$2e2bcd8739ae039);
    var $g6Vt5;
    var $01fcb0eb90bce4cf$export$2e2bcd8739ae039 = ()=>(0, (0, parcelRequire("g6Vt5")).default)('issue-create');
});
parcelRegister("8Lrq8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aea442a302ef98b1$export$2e2bcd8739ae039);
    var $aea442a302ef98b1$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
            setState({
                [experimentKey]: {
                    data: {
                        value: value
                    },
                    loading: false,
                    error: null
                }
            });
        };
});
parcelRegister("62C9r", function(module, exports) {
    $parcel$export(module.exports, "HorizontalNav", ()=>$df8ca37c4f42ad24$export$3821fe730064297d);
    $parcel$export(module.exports, "HorizontalNavWrapper", ()=>$df8ca37c4f42ad24$export$8798384053a023ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cPiXk;
    var $cM67N;
    var $erBFB;
    const $df8ca37c4f42ad24$var$NavErrorBoundaryFallback = ()=>null;
    const $df8ca37c4f42ad24$export$3821fe730064297d = ()=>{
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        return HorizontalNavComponent && $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "spa-horizontal-nav",
            fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
        }, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "projectNavigationSkipLink",
            fallback: "unmount"
        }, $5uXOq.createElement((0, (0, parcelRequire("erBFB")).ProjectViewNavigationSkipLink), null)), $5uXOq.createElement(HorizontalNavComponent, null));
    };
    const $df8ca37c4f42ad24$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
        return $5uXOq.createElement($df8ca37c4f42ad24$var$ThemedContainer, null, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "spa-horizontal-nav",
            fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
        }, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "projectNavigationSkipLink",
            fallback: "unmount"
        }, $5uXOq.createElement((0, (0, parcelRequire("erBFB")).ProjectViewNavigationSkipLink), null)), $5uXOq.createElement(HorizontalNavComponent, null)), children);
    };
    const $df8ca37c4f42ad24$var$ThemedContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7mmei _11q31r52 _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cM67N", function(module, exports) {
    $parcel$export(module.exports, "NavErrorBoundary", ()=>$5ad940bec1d10db7$export$afc779e659fd533f);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $jcw0u;
    var $7XYc4;
    var $4R6GH;
    var $3HwlS;
    function $5ad940bec1d10db7$export$35c1e8d8e59e87e7() {
        return [
            [
                'jira_nav4',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4')
            ],
            [
                'jira_nav4_dogfooding',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')
            ],
            [
                'jira_nav4_dogfooding_phase-1',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1')
            ],
            [
                'jira_nav4_dogfooding_phase-2',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2')
            ]
        ];
    }
    const $5ad940bec1d10db7$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
    function $5ad940bec1d10db7$var$inferNavRevision() {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? 'v4' : 'v3';
    }
    function $5ad940bec1d10db7$var$getExtraAttributes(_error) {
        const attributes = {
            ffs: $5ad940bec1d10db7$export$35c1e8d8e59e87e7().filter(([, value])=>value).map(([key])=>key).join(),
            rev: $5ad940bec1d10db7$var$inferNavRevision()
        };
        return attributes;
    }
    function $5ad940bec1d10db7$var$getAnalyticsPayload(error, meta, navRevision) {
        const payload = {
            error: error,
            meta: {
                id: 'logic',
                packageName: 'JiraNav'
            },
            attributes: {
                ...$5ad940bec1d10db7$var$getExtraAttributes(error),
                pkg: meta.packageName,
                id: meta.id,
                ...navRevision && {
                    rev: navRevision
                }
            },
            skipSentry: true
        };
        return payload;
    }
    const $5ad940bec1d10db7$export$5ac21f1e947e70d6 = (props)=>{
        const { id: id, packageName: packageName, navRevision: navRevision } = props;
        const onError = (0, $5uXOq.useMemo)(()=>{
            const meta = {
                id: id,
                packageName: packageName
            };
            const _onError = (...args)=>{
                if ($5ad940bec1d10db7$export$1d1321d2b374d697()) return;
                const [_, error] = args;
                (0, (0, parcelRequire("jcw0u")).default)($5ad940bec1d10db7$var$getAnalyticsPayload(error, meta, navRevision));
            };
            return _onError;
        }, [
            id,
            packageName,
            navRevision
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            ...props,
            onError: onError
        });
    };
    const $5ad940bec1d10db7$export$afc779e659fd533f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5ad940bec1d10db7$export$5ac21f1e947e70d6, props), (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), props));
});
parcelRegister("erBFB", function(module, exports) {
    $parcel$export(module.exports, "TopNavigationSkipLink", ()=>$cd61d83e2e343ff1$export$47de2191d46337b7);
    $parcel$export(module.exports, "LeftSidebarSkipLink", ()=>$cd61d83e2e343ff1$export$46697df0d7c5e8be);
    $parcel$export(module.exports, "ProjectViewNavigationSkipLink", ()=>$cd61d83e2e343ff1$export$2e2fc9c237996c06);
    $parcel$export(module.exports, "MainContentSkipLink", ()=>$cd61d83e2e343ff1$export$b1498dd122ea3284);
    var $koVbs;
    var $iqLcb;
    var $lOt1w;
    const $cd61d83e2e343ff1$export$47de2191d46337b7 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-jira-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToJiraNavigation), 0);
        return null;
    };
    const $cd61d83e2e343ff1$export$46697df0d7c5e8be = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-side-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToSideNavigation), 1);
        return null;
    };
    const $cd61d83e2e343ff1$export$2e2fc9c237996c06 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToProjectViewNavigation), 2);
        return null;
    };
    const $cd61d83e2e343ff1$export$b1498dd122ea3284 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-main-content', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToMainContent), 3);
        return null;
    };
});
parcelRegister("lOt1w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d368a0de790f751$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2d368a0de790f751$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        skipToJiraNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
            "defaultMessage": "Skip to Jira Navigation"
        },
        skipToSideNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
            "defaultMessage": "Skip to Side Navigation"
        },
        skipToProjectViewNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
            "defaultMessage": "Skip to View Navigation"
        },
        skipToMainContent: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
            "defaultMessage": "Skip to Main Content"
        }
    });
});
parcelRegister("4s15Z", function(module, exports) {
    $parcel$export(module.exports, "RightSidebar", ()=>$ac6bd493ba1cffad$export$84d58c19c21f637f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $2Ioew;
    var $frBVt;
    var $39xOx;
    var $7XYc4;
    var $4R6GH;
    var $hsmeR;
    var $3HwlS;
    var $iqLcb;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $1XrjK;
    var $6ncxj;
    var $gwZ1O;
    var $l8ruj;
    const $ac6bd493ba1cffad$var$TEST_ID = 'page-layout.aside';
    const $ac6bd493ba1cffad$var$routeComponents = [];
    const $ac6bd493ba1cffad$var$SharedRightSidebars = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("1XrjK")).renderGlobalComponents)((0, (0, parcelRequire("6ncxj")).sharedLayout).rightSidebars));
    const $ac6bd493ba1cffad$var$RightSidebarRouteComponents = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("1XrjK")).renderGlobalComponents)(route.layout?.rightSidebars || $ac6bd493ba1cffad$var$routeComponents));
    };
    const $ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint = ()=>{
        const rightSideBarEntryPoint = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb));
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entrypoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
            route
        ]);
        if (!entrypoint || !rightSideBarEntryPoint) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar-through-entrypoint"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-through-entrypoint",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            name: "right-sidebar-through-entrypoint",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gwZ1O")).ProjectListSidebarSkeleton), null),
            entryPoint: entrypoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: rightSideBarEntryPoint,
            props: {}
        }))));
    };
    const $ac6bd493ba1cffad$var$NewRightSidebar = ()=>{
        const lastPanelIdRef = (0, $5uXOq.useRef)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
                panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
                isClosed: rightSidebarCurrentState?.panelId == null,
                isMinimised: !!rightSidebarCurrentState?.isMinimised,
                isCollapsed: !!rightSidebarCurrentState?.isCollapsed
            });
            lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
        }, [
            createAnalyticsEvent,
            rightSidebarCurrentState?.panelId,
            rightSidebarCurrentState?.isMinimised,
            rightSidebarCurrentState?.isCollapsed
        ]);
        if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
        const RightSideBarOrPanel = (0, (0, parcelRequire("4R6GH")).fg)('jira-side-bar-aside-or-panel') ? (0, (0, parcelRequire("iqLcb")).RightPanel) : (0, (0, parcelRequire("iqLcb")).RightSidebar);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(RightSideBarOrPanel, {
            width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
            testId: $ac6bd493ba1cffad$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-right-sidebars",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-route-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), (0, (0, parcelRequire("4R6GH")).fg)('server_render_projects_directory_sidebar') && (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null))));
    };
    const $ac6bd493ba1cffad$var$OldRightSidebar = ()=>{
        const lastPanelIdRef = (0, $5uXOq.useRef)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
                panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
                isClosed: rightSidebarCurrentState?.panelId == null,
                isMinimised: !!rightSidebarCurrentState?.isMinimised,
                isCollapsed: !!rightSidebarCurrentState?.isCollapsed
            });
            lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
        }, [
            createAnalyticsEvent,
            rightSidebarCurrentState?.panelId,
            rightSidebarCurrentState?.isMinimised,
            rightSidebarCurrentState?.isCollapsed
        ]);
        if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarPanelWrapper, {
            id: "right-sidebar-panel-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).RightSidebar), {
            width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-right-sidebars",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-route-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), (0, (0, parcelRequire("4R6GH")).fg)('server_render_projects_directory_sidebar') && (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null)))));
    };
    const $ac6bd493ba1cffad$var$RightSidebarPanelWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1ej2b4wl _iu1g1fl4",
                __cmplp.className
            ])
        });
    });
    const $ac6bd493ba1cffad$export$84d58c19c21f637f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $ac6bd493ba1cffad$var$NewRightSidebar, $ac6bd493ba1cffad$var$OldRightSidebar);
});
parcelRegister("2Ioew", function(module, exports) {
    $parcel$export(module.exports, "usePageLayoutEntryPoint", ()=>$dcf886ac39f7cfda$export$fe1c839e8baf4110);
    var $h22md;
    var $6jY6G;
    const $dcf886ac39f7cfda$export$fe1c839e8baf4110 = (layoutField)=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entryPointReference = (0, (0, parcelRequire("h22md")).useRouteEntryPoint)({
            route: route
        });
        return entryPointReference?.entryPoints[layoutField];
    };
});
parcelRegister("h22md", function(module, exports) {
    $parcel$export(module.exports, "useRouteEntryPoint", ()=>$4e1bc9edc261b42d$export$c96377f800cdddb4);
    var $3I4nj;
    const $4e1bc9edc261b42d$export$c96377f800cdddb4 = ({ route: route })=>{
        const [lastLoadedRoute] = (0, (0, parcelRequire("3I4nj")).useLastLoadedRoute)();
        if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
        return null;
    };
});
parcelRegister("3I4nj", function(module, exports) {
    $parcel$export(module.exports, "useLastLoadedRoute", ()=>$f09634e8d32626d1$export$895238443fc3eae4);
    $parcel$export(module.exports, "getEntryPointsStore", ()=>$f09634e8d32626d1$export$fe654a734624d17f);
    $parcel$export(module.exports, "getLastLoadedRoute", ()=>$f09634e8d32626d1$export$5763b2305b3056df);
    $parcel$export(module.exports, "getPrefetchingRoute", ()=>$f09634e8d32626d1$export$7e18f3e3cbd04326);
    var $7JoAD = parcelRequire("7JoAD");
    const $f09634e8d32626d1$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
            setState({
                lastLoadedRoute: {
                    route: route,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $f09634e8d32626d1$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
            setState({
                prefetchingRoute: {
                    routerContext: routerContext,
                    expiresAt: expiresAt,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $f09634e8d32626d1$var$actions = {
        setLastLoadedRoute: $f09634e8d32626d1$export$1cec83a23d40a9fa,
        setPrefetchingRoute: $f09634e8d32626d1$export$bb3dc9c55f78173e
    };
    const $f09634e8d32626d1$var$EntryPointsStore = (0, $7JoAD.createStore)({
        initialState: {
            lastLoadedRoute: null,
            prefetchingRoute: null
        },
        actions: $f09634e8d32626d1$var$actions,
        name: 'react-resource-router/entry-points'
    });
    const $f09634e8d32626d1$export$895238443fc3eae4 = (0, $7JoAD.createHook)($f09634e8d32626d1$var$EntryPointsStore, {
        selector: (state)=>state.lastLoadedRoute
    });
    const $f09634e8d32626d1$export$fe654a734624d17f = ()=>(0, $7JoAD.defaultRegistry).getStore($f09634e8d32626d1$var$EntryPointsStore);
    const $f09634e8d32626d1$export$b28ecd0e4705f6b7 = ()=>$f09634e8d32626d1$export$fe654a734624d17f().storeState.getState();
    const $f09634e8d32626d1$export$5763b2305b3056df = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().lastLoadedRoute;
    const $f09634e8d32626d1$export$7e18f3e3cbd04326 = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().prefetchingRoute;
});
const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
parcelRegister("eF0qp", function(module, exports) {
    $parcel$export(module.exports, "Sidebar", ()=>$803f61b5dea1399f$export$1ba59dacbcbf90fe);
    var $fZBia;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $ajpes = parcelRequire("ajpes");
    var $8Uumt = parcelRequire("8Uumt");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $5YdvQ;
    var $azzrO;
    var $5e7oM;
    var $gwIPs;
    var $39xOx;
    var $7XYc4;
    var $4R6GH;
    var $pa9q9;
    var $aWse0;
    var $gPQRI;
    var $5e5zm;
    var $2fwuR;
    var $acDan;
    var $c6x3L;
    var $3HwlS;
    var $jHUgj;
    var $4DrQd;
    var $eGkew;
    var $iqLcb;
    var $ht71P;
    var $lfTZh;
    var $6jY6G;
    var $ao2h1;
    var $5M3R9;
    var $4V52L;
    var $16v4H;
    var $cZpsT;
    var $l8ruj;
    var $3AWiS;
    var $kTus1;
    var $lsO24;
    var $erBFB;
    var $gxq4u;
    var $7x18A;
    const $803f61b5dea1399f$var$footerStyles = {
        root: "_bfhkhp5a"
    };
    const $803f61b5dea1399f$var$SidebarNew = ()=>{
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const { queryReference: queryReference } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("2fwuR")).sidebarNav4UiStateResource));
        if (isAnonymous) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar.anonymous"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "sidebar.anonymous"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalAnonymous, null)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "sidebar"
        }, queryReference ? (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternal, {
            queryReference: queryReference
        }) : null));
    };
    const $803f61b5dea1399f$var$SidebarInternalAnonymous = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const defaultCollapsed = false;
        const defaultWidth = 340;
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: false
            });
        }, [
            setLeftSidebarState
        ]);
        const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: true
            });
        }, [
            setLeftSidebarState
        ]);
        const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
            setLeftSidebarState({
                width: finalWidth
            });
        }, [
            setLeftSidebarState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c6x3L")).SidebarNav4ContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTus1")).SideNav), {
            testId: $803f61b5dea1399f$var$TEST_ID,
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            onExpand: onExpand,
            onCollapse: onCollapse
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHUgj")).SidebarSelector), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3AWiS")).PanelSplitter), {
            label: formatMessage((0, (0, parcelRequire("gxq4u")).messages).sideBarPanelSplitterLabel),
            onResizeEnd: onResizeEnd
        })));
    };
    const $803f61b5dea1399f$var$TEST_ID = 'page-layout.sidebar';
    const $803f61b5dea1399f$var$SidebarInternal = ({ queryReference: queryReference })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const subProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("fZBia")).default), queryReference);
        const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, (0, parcelRequire("4DrQd")).IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
        const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, (0, parcelRequire("4DrQd")).LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: false
            });
        }, [
            setLeftSidebarState
        ]);
        const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: true
            });
        }, [
            setLeftSidebarState
        ]);
        const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
            setLeftSidebarState({
                width: finalWidth
            });
        }, [
            setLeftSidebarState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c6x3L")).SidebarNav4ContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTus1")).SideNav), {
            testId: $803f61b5dea1399f$var$TEST_ID,
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            onExpand: onExpand,
            onCollapse: onCollapse
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHUgj")).SidebarSelector), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lsO24")).SideNavFooter), {
            xcss: $803f61b5dea1399f$var$footerStyles.root
        }, (0, (0, parcelRequire("4R6GH")).fg)('jira_global_invite_nav4') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $803f61b5dea1399f$var$globalInviteButtonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YdvQ")).GlobalInvite), {
            testId: "page-container-v2.common.ui.sidebar.global-invite",
            product: "jira",
            subProduct: subProduct ?? undefined,
            showFlag: showFlag
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4V52L")).SidebarFeedbackButton), null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4V52L")).SidebarFeedbackButton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3AWiS")).PanelSplitter), {
            label: formatMessage((0, (0, parcelRequire("gxq4u")).messages).sideBarPanelSplitterLabel),
            onResizeEnd: onResizeEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ht71P")).AsyncNudgeBundledUsersFlagContainer), null)));
    };
    const $803f61b5dea1399f$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
    const $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY = 'sidebar';
    const $803f61b5dea1399f$var$sidebarOverrides = {
        ResizeButton: {
            render: (Component, props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                    id: "sidebar-resize-tooltip",
                    packageName: "page-container",
                    fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, props)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                    name: "side_bar_button",
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7x18A")).AsyncResizeButtonTooltip), {
                    isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props))))
        }
    };
    const $803f61b5dea1399f$var$SidebarInternalOld = ({ sidebar: sidebar })=>{
        const { width: width, isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const shouldNotRenderSidebarInServerSide = false && isCollapsed;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "left-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarStyleOverrides, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "leftSidebarSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).LeftSidebarSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).LeftSidebar), {
            isFixed: true,
            width: width,
            testId: $803f61b5dea1399f$var$SIDEBAR_TEST_ID,
            resizeButtonLabel: intl.formatMessage((0, (0, parcelRequire("gxq4u")).messages).sidebarNavigation),
            collapsedState: isCollapsed ? 'collapsed' : 'expanded',
            overrides: $803f61b5dea1399f$var$sidebarOverrides,
            id: "ak-side-navigation"
        }, !shouldNotRenderSidebarInServerSide && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, route !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "start",
            traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
        })), sidebar, route !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
        }))))));
    };
    const $803f61b5dea1399f$var$SidebarInternalOldMemo = (0, $5uXOq.memo)($803f61b5dea1399f$var$SidebarInternalOld, (0, ($parcel$interopDefault($ajpes))));
    const $803f61b5dea1399f$var$renderChildren = (sidebar)=>sidebar !== null ? (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalOldMemo, {
            sidebar: sidebar
        }) : null;
    const $803f61b5dea1399f$var$SidebarOld = ()=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eGkew")).SidebarSelectorProvider), {
            sidebar: route.navigation?.sidebar ?? null
        }, $803f61b5dea1399f$var$renderChildren);
    };
    const $803f61b5dea1399f$export$1ba59dacbcbf90fe = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $803f61b5dea1399f$var$SidebarNew, $803f61b5dea1399f$var$SidebarOld);
    const $803f61b5dea1399f$var$SidebarStyleOverrides = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1d7w7yr": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("gwIPs")).layers).leftSidebar)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1pbyg9ti _14c1glyw",
                __cmplp.className
            ])
        });
    });
    const $803f61b5dea1399f$var$globalInviteButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexGrow: 1
    });
});
parcelRegister("5YdvQ", function(module, exports) {
    $parcel$export(module.exports, "GlobalInvite", ()=>$8db6209b69a4dd79$export$93cb436db3d27b7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $4pmnu;
    var $g9BbE;
    var $d04El;
    const $8db6209b69a4dd79$var$LazyGlobalInviteModalDialogContent = (0, $5uXOq.lazy)(()=>(parcelRequire("esu6B")).then((module)=>({
                default: module.ModalDialogContent
            })));
    function $8db6209b69a4dd79$var$AsyncGlobalInviteModalDialogContent(props) {
        return $5uXOq.createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallback: $5uXOq.createElement((0, (0, parcelRequire("4pmnu")).ErrorState), null)
        }, $5uXOq.createElement((0, $5uXOq.Suspense), {
            fallback: $5uXOq.createElement((0, (0, parcelRequire("g9BbE")).LoadingState), null)
        }, $5uXOq.createElement($8db6209b69a4dd79$var$LazyGlobalInviteModalDialogContent, props)));
    }
    const $8db6209b69a4dd79$export$93cb436db3d27b7e = (0, (0, parcelRequire("d04El")).withModalDialog)($8db6209b69a4dd79$var$AsyncGlobalInviteModalDialogContent);
});
parcelRegister("f4cXA", function(module, exports) {
    (function(global, factory) {
        factory(module.exports, (parcelRequire("5uXOq")));
    })(module.exports, function(exports1, React) {
        'use strict';
        function _interopNamespace(e) {
            if (e && e.__esModule) return e;
            var n = Object.create(null);
            if (e) Object.keys(e).forEach(function(k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function() {
                            return e[k];
                        }
                    });
                }
            });
            n["default"] = e;
            return Object.freeze(n);
        }
        var React__namespace = _interopNamespace(React);
        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return _setPrototypeOf(o, p);
        }
        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass);
        }
        var changedArray = function changedArray(a, b) {
            if (a === void 0) a = [];
            if (b === void 0) b = [];
            return a.length !== b.length || a.some(function(item, index) {
                return !Object.is(item, b[index]);
            });
        };
        var initialState = {
            error: null
        };
        var ErrorBoundary = function(_React$Component) {
            _inheritsLoose(ErrorBoundary, _React$Component);
            function ErrorBoundary() {
                var _this;
                for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(_args)) || this;
                _this.state = initialState;
                _this.resetErrorBoundary = function() {
                    var _this$props;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                    _this.reset();
                };
                return _this;
            }
            ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            };
            var _proto = ErrorBoundary.prototype;
            _proto.reset = function reset() {
                this.setState(initialState);
            };
            _proto.componentDidCatch = function componentDidCatch(error, info) {
                var _this$props$onError, _this$props2;
                (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
            };
            _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
                var error = this.state.error;
                var resetKeys = this.props.resetKeys;
                if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                    var _this$props$onResetKe, _this$props3;
                    (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                    this.reset();
                }
            };
            _proto.render = function render() {
                var error = this.state.error;
                var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
                if (error !== null) {
                    var _props = {
                        error: error,
                        resetErrorBoundary: this.resetErrorBoundary
                    };
                    if (React__namespace.isValidElement(fallback)) return fallback;
                    else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                    else if (FallbackComponent) return React__namespace.createElement(FallbackComponent, _props);
                    else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React__namespace.Component);
        function withErrorBoundary(Component, errorBoundaryProps) {
            var Wrapped = function Wrapped(props) {
                return React__namespace.createElement(ErrorBoundary, errorBoundaryProps, React__namespace.createElement(Component, props));
            };
            var name = Component.displayName || Component.name || 'Unknown';
            Wrapped.displayName = "withErrorBoundary(" + name + ")";
            return Wrapped;
        }
        function useErrorHandler(givenError) {
            var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
            if (givenError != null) throw givenError;
            if (error != null) throw error;
            return setError;
        }
        exports1.ErrorBoundary = ErrorBoundary;
        exports1.useErrorHandler = useErrorHandler;
        exports1.withErrorBoundary = withErrorBoundary;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    });
});
parcelRegister("4pmnu", function(module, exports) {
    $parcel$export(module.exports, "ErrorState", ()=>$12ac31c3f5776fed$export$c1ed4f415b9e7023);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $1dJ6S;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $cWIaC;
    const $12ac31c3f5776fed$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.1000',
        paddingInline: 'space.100',
        textAlign: 'center'
    });
    function $12ac31c3f5776fed$export$c1ed4f415b9e7023() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return $5uXOq.createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050",
            testId: "global-invite--error-state",
            xcss: $12ac31c3f5776fed$var$styles
        }, $5uXOq.createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("cWIaC")).messages).errorStateHeading)), $5uXOq.createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("cWIaC")).messages).errorStateDescription)));
    }
});
parcelRegister("cWIaC", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ab5f16cf436290aa$export$defe85febe8b728c);
    var $7VHMR;
    const $ab5f16cf436290aa$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorStateHeading: {
            id: 'navigation.global-invite.error-state-heading',
            description: "Heading of the error state UI indicating we couldn't load the invite people widget.",
            defaultMessage: "We can't load the invite list right now"
        },
        errorStateDescription: {
            id: 'navigation.global-invite.error-state-description',
            description: "Description of the error state UI indicating we couldn't load the invite people widget.",
            defaultMessage: 'Try refreshing the page or contact us if the problem persists.'
        }
    });
});
parcelRegister("g9BbE", function(module, exports) {
    $parcel$export(module.exports, "LoadingState", ()=>$de01f18621face07$export$62aa48085237e36f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $1DVhQ;
    var $jldZL;
    var $esr9c;
    const $de01f18621face07$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.500',
        paddingInline: 'space.300'
    });
    function $de01f18621face07$export$62aa48085237e36f() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const items = Array.from({
            length: 5
        }, (_, index)=>$5uXOq.createElement((0, (0, parcelRequire("1DVhQ")).default), {
                isShimmering: true,
                width: "100%",
                height: "var(--ds-space-200, 16px)",
                testId: "skeleton-shimmering",
                key: index
            }));
        return $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $de01f18621face07$var$styles,
            testId: "global-invite--loading-state"
        }, $5uXOq.createElement((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("esr9c")).messages).loadingLabel)), $5uXOq.createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            testId: "skeleton-group"
        }, items));
    }
});
parcelRegister("1DVhQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4b6b583e25d0959$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $k5uoT;
    const $d4b6b583e25d0959$var$shimmer = (0, (0, parcelRequire("k5uoT")).skeletonShimmer)();
    const $d4b6b583e25d0959$var$shimmerKeyframes = (0, (0, parcelRequire("f8Sb3")).keyframes)($d4b6b583e25d0959$var$shimmer.keyframes);
    const $d4b6b583e25d0959$var$skeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ...$d4b6b583e25d0959$var$shimmer.css
    });
    const $d4b6b583e25d0959$var$activeShimmerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        animationName: `${$d4b6b583e25d0959$var$shimmerKeyframes}`
    });
    const $d4b6b583e25d0959$var$getKeyframes = (fromColor, toColor)=>(0, (0, parcelRequire("f8Sb3")).keyframes)({
            from: {
                backgroundColor: fromColor
            },
            to: {
                backgroundColor: toColor
            }
        });
    const $d4b6b583e25d0959$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
        const groupDataAttribute = groupName && `data-${groupName}`;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $d4b6b583e25d0959$var$skeletonStyles,
                isShimmering && $d4b6b583e25d0959$var$activeShimmerStyles,
                {
                    width: width,
                    height: height,
                    borderRadius: borderRadius,
                    backgroundColor: color,
                    animationName: color && ShimmeringEndColor ? $d4b6b583e25d0959$var$getKeyframes(color, ShimmeringEndColor) : undefined
                }
            ],
            ...groupDataAttribute && {
                [groupDataAttribute]: 'true'
            }
        });
    };
    var $d4b6b583e25d0959$export$2e2bcd8739ae039 = $d4b6b583e25d0959$var$Skeleton;
});
parcelRegister("esr9c", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bf903bffddf301c6$export$defe85febe8b728c);
    var $7VHMR;
    const $bf903bffddf301c6$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadingLabel: {
            id: 'navigation.global-invite.loading-visually-hidden-label',
            description: 'Visually hidden text to indicate the invite people UI is loading.',
            defaultMessage: 'Loading'
        }
    });
});
parcelRegister("d04El", function(module, exports) {
    $parcel$export(module.exports, "withModalDialog", ()=>$961b14944ab8338e$export$2d7d84d397d9a585);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $eCeGD;
    var $1R1Ge;
    var $i8Qvm;
    var $kMruu;
    function $961b14944ab8338e$export$2d7d84d397d9a585(Content) {
        return function ModalDialog({ testId: testId = (0, $7d72a3ca9c13402e$export$bb76aeb9f599715c), ...props }) {
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const [isModalDialogOpen, setIsModalDialogOpen] = (0, $5uXOq.useState)(false);
            const openModalDialog = (0, $5uXOq.useCallback)(()=>{
                setIsModalDialogOpen(true);
            }, []);
            const closeModalDialog = (0, $5uXOq.useCallback)(()=>{
                setIsModalDialogOpen(false);
            }, []);
            const focusDialog = (0, $5uXOq.useCallback)((node)=>{
                node.focus();
            }, []);
            return $5uXOq.createElement("div", {
                "data-testid": testId
            }, $5uXOq.createElement((0, (0, parcelRequire("eCeGD")).default), {
                shouldFitContainer: true,
                onClick: openModalDialog,
                testId: `${testId}--${(0, $7d72a3ca9c13402e$export$1dab7caa4b20a4cc)}`
            }, formatMessage((0, (0, parcelRequire("kMruu")).messages).triggerElementLabel)), $5uXOq.createElement((0, (0, parcelRequire("i8Qvm")).default), null, isModalDialogOpen ? $5uXOq.createElement((0, (0, parcelRequire("1R1Ge")).default), {
                width: "small",
                shouldScrollInViewport: true,
                shouldReturnFocus: true,
                onClose: closeModalDialog,
                autoFocus: false,
                onOpenComplete: focusDialog,
                testId: `${testId}--${(0, $7d72a3ca9c13402e$export$7622d28bacf170d1)}`
            }, $5uXOq.createElement(Content, {
                closeModalDialog: closeModalDialog,
                ...props
            })) : null));
        };
    }
});
const $7d72a3ca9c13402e$export$bb76aeb9f599715c = 'global-invite';
const $7d72a3ca9c13402e$export$7622d28bacf170d1 = 'modal-dialog';
const $7d72a3ca9c13402e$export$1dab7caa4b20a4cc = 'trigger-element';
parcelRegister("kMruu", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$58ea59d0f979843d$export$defe85febe8b728c);
    var $7VHMR;
    const $58ea59d0f979843d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        triggerElementLabel: {
            id: 'navigation.global-invite.trigger-element-label',
            description: 'Text content of the button that triggers the modal dialog.',
            defaultMessage: 'Invite people'
        }
    });
});
parcelRegister("esu6B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("78hhz")
    ]).then(()=>parcelRequire('iDk8M'));
});
parcelRegister("c6x3L", function(module, exports) {
    $parcel$export(module.exports, "SidebarNav4ContextProvider", ()=>$313dc1bbe6a8339e$export$ebf7cdfc2e83bcef);
    $parcel$export(module.exports, "useSidebarNav4", ()=>$313dc1bbe6a8339e$export$dc46c14934833db2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    var $3Jbkp;
    var $fMcVX;
    var $7Ckoi;
    const $313dc1bbe6a8339e$var$SidebarNav4Context = (0, $5uXOq.createContext)(null);
    function $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef(props) {
        const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
        const [routerContext] = (0, $dIdda.useRouter)();
        const initialSelectedPath = (0, (0, parcelRequire("3Jbkp")).getInitialSelectedPath)(routerContext);
        const [selectedPath, setSelectedPath] = (0, $5uXOq.useState)(initialSelectedPath);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setSelectedPath((currentPath)=>{
                const newPath = (0, (0, parcelRequire("7Ckoi")).routeToSelectedPath)(routerContext);
                return currentPath.toString() === newPath.toString() ? currentPath : newPath;
            });
        }, [
            routerContext
        ]);
        const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
                isInitialSelectedPath: isInitialSelectedPath ?? (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath),
                isSelectedPath: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(selectedPath)
            }), [
            initialSelectedPath,
            isInitialSelectedPath,
            selectedPath
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($313dc1bbe6a8339e$var$SidebarNav4Context.Provider, {
            value: sidebarNav4Controller
        }, children);
    }
    function $313dc1bbe6a8339e$export$dc46c14934833db2() {
        const context = (0, $5uXOq.useContext)($313dc1bbe6a8339e$var$SidebarNav4Context);
        if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
        return context;
    }
});
parcelRegister("jHUgj", function(module, exports) {
    $parcel$export(module.exports, "SidebarSelector", ()=>$727f611db6c21522$export$7937e2d32a777fcb);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $65Ltd;
    var $8J6rn;
    var $co1wz;
    var $4R6GH;
    var $lmyls;
    var $3F9p6;
    var $jKa0E;
    var $3ed52;
    var $dOB7H;
    var $dEbXe;
    var $Tdcaw;
    var $fbami;
    var $bCaZu;
    var $gYSoA;
    var $ieEgo;
    var $kNJsg;
    var $aWnEG;
    var $2KXa8;
    var $hrRcW;
    var $lF3VU;
    var $bJJms;
    var $6ZLHo;
    var $7VBev;
    var $YiTdm;
    var $kqEpF;
    var $1G9rm;
    var $drQWa;
    var $2DtJE;
    var $cnyf1;
    var $iXVV6;
    var $dAfqg;
    var $c1mlA;
    var $dIdda = parcelRequire("dIdda");
    const $727f611db6c21522$var$ProjectSettingsSidebarSelector = ()=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        let sidebar = null;
        if (loading) sidebar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null);
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ZLHo")).default), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJJms")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnyf1")).default), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2DtJE")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("drQWa")).AsyncJsmTmpProjectSettingsSidebar), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1G9rm")).AsyncJsmCmpProjectSettingsSidebar), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) sidebar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kqEpF")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("drQWa")).AsyncJsmTmpProjectSettingsSidebar), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1G9rm")).AsyncJsmCmpProjectSettingsSidebar), {
            project: project
        });
        if (error) throw error;
        if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: project ? String(project.projectId) : undefined,
            containerType: "project"
        }, sidebar);
    };
    const $727f611db6c21522$var$BoardSettingsSidebar = ()=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dEbXe")).Skeleton), null);
        if (error) throw error;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: project ? String(project.projectId) : undefined,
            containerType: "project"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOB7H")).default), null));
    };
    const $727f611db6c21522$var$REDIRECT_ROUTES_NAMES = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REDIRECT)
    ]);
    const $727f611db6c21522$var$InternalSidebarSelector = ()=>{
        const [{ match: { params: params }, route: route, location: location, query: query }] = (0, $dIdda.useRouter)();
        const { saveCurrentRoute: saveCurrentRoute } = (0, (0, parcelRequire("jKa0E")).useNavigateBack)();
        const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, (0, parcelRequire("Tdcaw")).useGlobalAppsSettingsConnectItemActive)();
        const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, (0, parcelRequire("kNJsg")).useGlobalSystemSettingsConnectItemActive)();
        const { isActive: isProjectSettingsConnectAppActive } = (0, (0, parcelRequire("YiTdm")).useIsConnectAppActive)();
        const { shouldUseJSM: shouldUseJSM } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        switch(route.navigation?.sidebarId){
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lF3VU")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
                if (!location.pathname.includes('/discover')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fbami")).default), null);
                break;
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ieEgo")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bCaZu")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
                if (location.pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM && (0, (0, parcelRequire("4R6GH")).fg)('fix_chatops_new_nav_bug')) break;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYSoA")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWnEG")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hrRcW")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).HELP_CENTER_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KXa8")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$ProjectSettingsSidebarSelector, null);
            default:
                break;
        }
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS) && params.section === 'settings' || isProjectSettingsConnectAppActive) return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$ProjectSettingsSidebarSelector, null);
        if (route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE) && (0, (0, parcelRequire("c1mlA")).BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(query.config) && (0, (0, parcelRequire("co1wz")).ff)('simplified-boards-milestone-2_07hbk')) return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$BoardSettingsSidebar, null);
        if (isGlobalAppsSettingsConnectItemActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fbami")).default), null);
        if (isGlobalSystemSettingsConnectItemActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWnEG")).default), null);
        if ($727f611db6c21522$var$REDIRECT_ROUTES_NAMES.has(route.name) && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')) return null;
        saveCurrentRoute();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3ed52")).default), null);
    };
    const $727f611db6c21522$export$7937e2d32a777fcb = ()=>{
        const attributes = (0, $5uXOq.useMemo)(()=>({
                navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
                navigationContainer: (0, $68cb678dc917978e$export$2ee9e5a3556c1e43),
                navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
                stage: (0, (0, parcelRequire("3F9p6")).getNav4Rollout)().stage
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKa0E")).NavigateBackProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: attributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$InternalSidebarSelector, null)));
    };
});
const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';
const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';
parcelRegister("3F9p6", function(module, exports) {
    $parcel$export(module.exports, "getNav4Rollout", ()=>$826ce4e4d6cfd68d$export$84a05d3b37ec5d2);
    var $9glig = parcelRequire("9glig");
    var $cxSdl = parcelRequire("cxSdl");
    var $hMlwW = parcelRequire("hMlwW");
    var $4R6GH;
    var $c0dQj;
    var $7qZOo;
    var $8O1QZ;
    var $32Frn;
    const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, ($parcel$interopDefault($9glig)))([
        [
            ()=>!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4'),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_NONE))
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding'),
            (0, (0, parcelRequire("8O1QZ")).getNav4RolloutForDogfooding)
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap'),
            (0, (0, parcelRequire("32Frn")).getNav4RolloutForEap)
        ],
        [
            ()=>(0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)(),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_MOBILE))
        ],
        [
            (0, ($parcel$interopDefault($hMlwW))),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_NONE))
        ]
    ]);
});
parcelRegister("9glig", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $1nIHN = parcelRequire("1nIHN");
    var $bxDef = parcelRequire("bxDef");
    var $g7i7g = parcelRequire("g7i7g");
    var $6be62026d39b34ea$var$FUNC_ERROR_TEXT = 'Expected a function';
    function $6be62026d39b34ea$var$cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = $bxDef;
        pairs = !length ? [] : $1nIHN(pairs, function(pair) {
            if (typeof pair[1] != 'function') throw new TypeError($6be62026d39b34ea$var$FUNC_ERROR_TEXT);
            return [
                toIteratee(pair[0]),
                pair[1]
            ];
        });
        return $g7i7g(function(args) {
            var index = -1;
            while(++index < length){
                var pair = pairs[index];
                if ($hlchF(pair[0], this, args)) return $hlchF(pair[1], this, args);
            }
        });
    }
    module.exports = $6be62026d39b34ea$var$cond;
});
parcelRegister("hMlwW", function(module, exports) {
    function $cf179ed6624748c2$var$stubTrue() {
        return true;
    }
    module.exports = $cf179ed6624748c2$var$stubTrue;
});
parcelRegister("8O1QZ", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForDogfooding", ()=>$48ac6742e168ff29$export$f1e751a9a9d68fb5);
    var $9glig = parcelRequire("9glig");
    var $hMlwW = parcelRequire("hMlwW");
    var $4R6GH;
    var $1MhR0;
    const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
                stage: 'dogfooding',
                phase: phase,
                isUserOptOut: (0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)()
            } : {
                stage: 'dogfooding',
                phase: phase
            };
    const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, ($parcel$interopDefault($9glig)))([
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2'),
            $48ac6742e168ff29$var$dogfoodingPhase(2)
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1'),
            $48ac6742e168ff29$var$dogfoodingPhase(1)
        ],
        [
            (0, ($parcel$interopDefault($hMlwW))),
            $48ac6742e168ff29$var$dogfoodingPhase(3)
        ]
    ]);
});
parcelRegister("32Frn", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForEap", ()=>$d3197687d5551826$export$42dd8c002a342b8);
    var $1MhR0;
    const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
            stage: 'eap',
            isUserOptOut: (0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)()
        });
});
parcelRegister("jKa0E", function(module, exports) {
    $parcel$export(module.exports, "useNavigateBack", ()=>$e131d9d1fc634955$export$7ce1f551d78f9130);
    $parcel$export(module.exports, "NavigateBackProvider", ()=>$e131d9d1fc634955$export$e1e76f4ee7f8174d);
    var $5uXOq = parcelRequire("5uXOq");
    var $kbked;
    var $dIdda = parcelRequire("dIdda");
    var $bOr6i;
    const $e131d9d1fc634955$var$STORAGE_KEY = 'back-button-url';
    const $e131d9d1fc634955$var$NavigateBackContext = (0, $5uXOq.createContext)(undefined);
    const $e131d9d1fc634955$export$7ce1f551d78f9130 = ()=>{
        const context = (0, $5uXOq.useContext)($e131d9d1fc634955$var$NavigateBackContext);
        if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
        return context;
    };
    const $e131d9d1fc634955$export$e1e76f4ee7f8174d = ({ children: children })=>{
        const { push: push } = (0, $dIdda.useRouterActions)();
        const [previousUrl, setPreviousUrl] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("bOr6i")).storageProvider).get($e131d9d1fc634955$var$STORAGE_KEY));
        const saveCurrentRoute = (0, $5uXOq.useCallback)(()=>{
            const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
            setPreviousUrl(url);
            (0, (0, parcelRequire("bOr6i")).storageProvider).set($e131d9d1fc634955$var$STORAGE_KEY, url);
        }, []);
        const goBack = (0, $5uXOq.useCallback)(()=>push(previousUrl ?? (0, (0, parcelRequire("kbked")).jiraHomeRoute).path), [
            previousUrl,
            push
        ]);
        const value = (0, $5uXOq.useMemo)(()=>({
                saveCurrentRoute: saveCurrentRoute,
                goBack: goBack
            }), [
            saveCurrentRoute,
            goBack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e131d9d1fc634955$var$NavigateBackContext.Provider, {
            value: value
        }, children);
    };
});
parcelRegister("bOr6i", function(module, exports) {
    $parcel$export(module.exports, "storageProvider", ()=>$36fbcced1b17c587$export$ce7751641b93537d);
    var $eNf8a;
    const $36fbcced1b17c587$export$ce7751641b93537d = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('sidebar-navigation');
});
parcelRegister("3ed52", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2e015ea5d0812b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $kxZPA;
    const $a2e015ea5d0812b1$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8qGCQ")).then(({ SidebarContent: SidebarContent })=>SidebarContent), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/core/src/index.tsx"
    });
    const $a2e015ea5d0812b1$var$AsyncSidebarContent = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "asyncSidebarContent",
            packageName: "jiraNavigationAppsSidebarNav4SidebarContent",
            teamName: "jira-cosmos"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazySidebarContent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a2e015ea5d0812b1$var$LazySidebarContent, null))));
    $a2e015ea5d0812b1$var$AsyncSidebarContent.displayName = 'AsyncSidebarContent';
    var $a2e015ea5d0812b1$export$2e2bcd8739ae039 = $a2e015ea5d0812b1$var$AsyncSidebarContent;
});
parcelRegister("cljJ9", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$f6d5489447b9aa6b$export$1edc778464f08256);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $8dXDG;
    var $93jKl;
    var $cfDZ3;
    var $cKjfv;
    var $6Jt8x;
    const $f6d5489447b9aa6b$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName })=>{
        const { experience: experience, attributes: attributes } = (0, (0, parcelRequire("cKjfv")).useSidebarExperience)();
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: experience,
            attributes: attributes
        });
        const onAbort = (0, (0, parcelRequire("8dXDG")).useExperienceAbort)({
            experience: experience,
            attributes: attributes
        });
        const userLocation = (0, (0, parcelRequire("cfDZ3")).getUserLocation)();
        const isNotSSR = !false;
        const extraEventData = (0, $5uXOq.useMemo)(()=>({
                userLocation: userLocation
            }), [
            userLocation
        ]);
        const fallback = (0, $5uXOq.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Jt8x")).Fallback), {
                error: error
            }), []);
        const handleError = (0, $5uXOq.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
                error: error
            });
            else onFail(location, error);
        }, [
            onAbort,
            onFail
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: id,
            packageName: packageName,
            extraEventData: extraEventData,
            fallback: fallback,
            teamName: teamName,
            onError: handleError
        }, isNotSSR && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cKjfv")).SidebarStart), null), children);
    };
});
parcelRegister("cKjfv", function(module, exports) {
    $parcel$export(module.exports, "useSidebarExperience", ()=>$c4243e40cbbf3b86$export$d4fa533dfe4d7583);
    $parcel$export(module.exports, "SidebarStart", ()=>$c4243e40cbbf3b86$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarReady", ()=>$c4243e40cbbf3b86$export$a06ecbbe5820282);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $kaHBi;
    var $3bQtK;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $6IzHB;
    const $c4243e40cbbf3b86$export$d4fa533dfe4d7583 = ()=>{
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        return (0, $5uXOq.useMemo)(()=>({
                experience: 'viewSidebarNavigation',
                experienceId: pageId,
                analyticsSource: 'Sidebar',
                attributes: {
                    sidebar: 'v4'
                }
            }), [
            pageId
        ]);
    };
    const $c4243e40cbbf3b86$export$6738d1299dc79710 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
        const onStartExperience = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: experience,
            experienceId: experienceId,
            analyticsSource: analyticsSource
        });
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) return;
            onStartExperience();
        }, [
            onStartExperience,
            route
        ]);
        return null;
    };
    const $c4243e40cbbf3b86$export$a06ecbbe5820282 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { experience: experience, attributes: attributes } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
        const onSuccessfulExperience = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: experience,
            attributes: attributes
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const doNotRunEffects = route.isRedirect || false;
        const sidebarId = route.navigation?.sidebarId ?? 'default';
        (0, $5uXOq.useEffect)(()=>{
            if (doNotRunEffects) return;
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            doNotRunEffects,
            routeName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (doNotRunEffects) return;
            onSuccessfulExperience();
        }, [
            doNotRunEffects,
            onSuccessfulExperience,
            route
        ]);
        const customData = (0, $5uXOq.useMemo)(()=>({
                sidebarType: sidebarId
            }), [
            sidebarId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
            data: customData
        });
    };
});
parcelRegister("99gkn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a18f2c0b045372b$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "addUFOCustomData", ()=>$7a18f2c0b045372b$export$d12f56a472cdbe6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $7a18f2c0b045372b$export$2e2bcd8739ae039({ data: data }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        (0, $5uXOq.useMemo)(()=>{
            if (!interactionContext) return;
            interactionContext.addCustomData(data);
        }, [
            data,
            interactionContext
        ]);
        return null;
    }
    function $7a18f2c0b045372b$export$d12f56a472cdbe6c(data) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, (0, parcelRequire("bFU4G")).addCustomData)(currentInteractionId, [], data);
    }
});
parcelRegister("6Jt8x", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$d1b1aff7b337b0d4$export$fb8d7f40caaeea67);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $kobfu;
    var $7q5TP;
    var $koVbs;
    var $5Ntjt;
    const $d1b1aff7b337b0d4$var$styles = {
        wrapper: "_bfhkm7j4 _syaz1gjq _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc",
        error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
    };
    const $d1b1aff7b337b0d4$export$fb8d7f40caaeea67 = ({ error: error })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $d1b1aff7b337b0d4$var$styles.wrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7q5TP")).default), {
            width: "40px",
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("5Ntjt")).default).errorHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("5Ntjt")).default).errorBody)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d1b1aff7b337b0d4$var$styles.error
        }, "ERROR: ", (0, (0, parcelRequire("kobfu")).getErrorHash)(error)));
    };
});
parcelRegister("5Ntjt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ef9823ba7f6e404$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ef9823ba7f6e404$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorHeading: {
            "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("8qGCQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("3cwJf")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("c5OxX")
    ]).then(()=>parcelRequire('gyZtn'));
});
parcelRegister("dOB7H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$358df587d3e80a76$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $kxZPA;
    var $dEbXe;
    const $358df587d3e80a76$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8AK0s")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
    });
    const $358df587d3e80a76$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.board-settings",
            packageName: "jiraNavigationAppsSidebarNav4BoardSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.board-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dEbXe")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($358df587d3e80a76$var$LazySidebarContent, null)));
    var $358df587d3e80a76$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($358df587d3e80a76$var$AsyncSidebar);
});
parcelRegister("dEbXe", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$ff13cb96c7f2cede$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    const $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        })));
    const $ff13cb96c7f2cede$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.200'
    });
    const $ff13cb96c7f2cede$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $ff13cb96c7f2cede$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $ff13cb96c7f2cede$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("8AK0s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gS3ma")
    ]).then(()=>parcelRequire('gNcDN'));
});
parcelRegister("Tdcaw", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsConnectItems", ()=>$a54a68c44d0262b5$export$f0785b98c99d344c);
    $parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", ()=>$a54a68c44d0262b5$export$8dd86b1eb9fdf786);
    $parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", ()=>$a54a68c44d0262b5$export$83008eebb9fccef3);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $hWBtO;
    var $efOLn;
    var $bYoAQ;
    var $hz6Yb;
    var $dIdda = parcelRequire("dIdda");
    const $a54a68c44d0262b5$var$getItems = (d)=>(0, (0, parcelRequire("hWBtO")).getLinks)(d, [
            'admin_plugins_menu'
        ], {
            skipFilter: true
        }).filter((v)=>![
                'upm_section',
                'jpo-ws-admin'
            ].includes(v.id)).map((0, (0, parcelRequire("efOLn")).transformLink)).filter(Boolean);
    const $a54a68c44d0262b5$export$f0785b98c99d344c = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("bYoAQ")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $a54a68c44d0262b5$var$getItems(data), [
            data
        ]);
        return {
            data: items,
            loading: loading,
            error: error
        };
    };
    const $a54a68c44d0262b5$export$ae997bf97ec22b71 = new Set([
        'configurePage',
        'postInstallPage'
    ]);
    const $a54a68c44d0262b5$export$8dd86b1eb9fdf786 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("hz6Yb")).useConnectGeneralResource)();
        return {
            isActive: $a54a68c44d0262b5$export$ae997bf97ec22b71.has(data?.moduleType),
            loading: loading,
            error: error
        };
    };
    const $a54a68c44d0262b5$export$83008eebb9fccef3 = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = $a54a68c44d0262b5$export$f0785b98c99d344c();
        const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $a54a68c44d0262b5$export$8dd86b1eb9fdf786();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, (0, parcelRequire("8maDO")).findItemAndStack)(data, route.name, location)?.selected), [
            data,
            route,
            location
        ]);
        return {
            isActive: isActive || isAppsSettingsConnectAppModuleActive,
            loading: loading || isAppsSettingsConnectAppModuleLoading,
            error: error || isAppsSettingsConnectAppModuleError
        };
    };
});
parcelRegister("8maDO", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$c4af9df81f308e02$export$751e2e6237002565);
    var $ajpes = parcelRequire("ajpes");
    var $k0iPT;
    const $c4af9df81f308e02$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $c4af9df81f308e02$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $c4af9df81f308e02$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $c4af9df81f308e02$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $c4af9df81f308e02$var$splitRelevantQs(itemQs);
            const sameQuery = $c4af9df81f308e02$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $c4af9df81f308e02$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("hWBtO", function(module, exports) {
    $parcel$export(module.exports, "getLinks", ()=>$90a1a565c575dc5b$export$8054dcb2b42da45c);
    var $9KzPc;
    const $90a1a565c575dc5b$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
            if (item.id === legacyId) return item.links;
            return item.links && $90a1a565c575dc5b$var$findChildLinks(item.links, legacyId);
        }).find(Boolean);
    const $90a1a565c575dc5b$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
        const links = legacyId != null ? $90a1a565c575dc5b$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
        return links || [];
    };
    const $90a1a565c575dc5b$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
        const acc = [];
        locations.forEach((location)=>{
            const links = $90a1a565c575dc5b$var$getLinksFromSidebar(sidebarConfig, location);
            if (omitSections === true) {
                Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
                return;
            }
            Array.prototype.push.apply(acc, links);
        });
        return acc.filter((item)=>{
            if (!item) return false;
            if (skipFilter === true) return true;
            const hasConnectPrefix = item.id && item.id.includes((0, (0, parcelRequire("9KzPc")).connectPrefix));
            if (hasConnectPrefix) return true;
            const isConnectSection = (0, (0, parcelRequire("9KzPc")).connectSections).includes(item.id);
            if (isConnectSection) return true;
            const isJsdConnectSection = item.id && item.id.includes((0, (0, parcelRequire("9KzPc")).jsdConnectPrefix));
            if (isJsdConnectSection) return true;
            return false;
        });
    };
});
parcelRegister("9KzPc", function(module, exports) {
    $parcel$export(module.exports, "connectPrefix", ()=>$f13744297e4a8bc9$export$196d83ebd873fb40);
    $parcel$export(module.exports, "jsdConnectPrefix", ()=>$f13744297e4a8bc9$export$7fac8f726f52d70);
    $parcel$export(module.exports, "connectSections", ()=>$f13744297e4a8bc9$export$b1c2c1fc5d10280);
    var $16J3A;
    const $f13744297e4a8bc9$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
    const $f13744297e4a8bc9$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
    const $f13744297e4a8bc9$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
    const $f13744297e4a8bc9$var$jsdQueuesConnectSection = 'sd-queues-addons';
    const $f13744297e4a8bc9$export$b1c2c1fc5d10280 = [
        $f13744297e4a8bc9$var$legacyAddonPanelLinkId,
        (0, (0, parcelRequire("16J3A")).REPORTS_IDS).REPORTS_ADDONS,
        $f13744297e4a8bc9$var$jsdQueuesConnectSection
    ];
});
parcelRegister("efOLn", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$179f73798c754e8b$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$179f73798c754e8b$export$27267b6b6650eaa5);
    const $179f73798c754e8b$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($179f73798c754e8b$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $179f73798c754e8b$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($179f73798c754e8b$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("bYoAQ", function(module, exports) {
    $parcel$export(module.exports, "useNavigationGlobalResource", ()=>$37852a2b10dca6fc$export$1e1c317ed5b99faa);
    var $atU1t;
    var $dIdda = parcelRequire("dIdda");
    const $37852a2b10dca6fc$export$1e1c317ed5b99faa = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource));
        return {
            data: data && data.response,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("fbami", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f82a04fb3eb62635$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $f82a04fb3eb62635$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ajhZM")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
    });
    const $f82a04fb3eb62635$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.apps-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "apps"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.apps-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f82a04fb3eb62635$var$LazySidebarContent, null))));
    var $f82a04fb3eb62635$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f82a04fb3eb62635$var$AsyncSidebar);
});
parcelRegister("cnlm7", function(module, exports) {
    $parcel$export(module.exports, "SidebarContent", ()=>$eb45bd1b3d8207f6$export$49e8f7b58a4df4ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $koVbs;
    var $iI75Y;
    var $gSZmd;
    var $3yxBH;
    var $6DDUb;
    var $9GB5z;
    var $jDuwy;
    const $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DDUb")).SideNavHeader), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200",
            xcss: $eb45bd1b3d8207f6$var$headingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            grow: "hug",
            space: "space.100",
            testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iI75Y")).BackButton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("jDuwy")).default).heading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9GB5z")).AsyncPageSwitcher), {
            currentPageName: currentPageName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3yxBH")).SideNavContent), {
            testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, children)));
    };
    const $eb45bd1b3d8207f6$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.050'
    });
});
parcelRegister("iI75Y", function(module, exports) {
    $parcel$export(module.exports, "BackButton", ()=>$8c6efbfad9d4699a$export$e0d897ee21382f67);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $ctqwA;
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $jKa0E;
    var $dJXtD;
    const $8c6efbfad9d4699a$export$e0d897ee21382f67 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { goBack: goBack } = (0, (0, parcelRequire("jKa0E")).useNavigateBack)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("dJXtD")).default).tooltip),
            hideTooltipOnMouseDown: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("ctqwA"))))),
            label: formatMessage((0, (0, parcelRequire("dJXtD")).default).label),
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
                goBack();
            }
        }));
    };
});
parcelRegister("dJXtD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b400b92991a2960$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0b400b92991a2960$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltip: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
            "defaultMessage": "Go back"
        },
        label: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
            "defaultMessage": "Navigate back to the previous page"
        }
    });
});
parcelRegister("gSZmd", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$dfe52a3a6f12c8c9$export$d4c4e98c5044dc8);
    var $hEtBs;
    const $dfe52a3a6f12c8c9$export$d4c4e98c5044dc8 = (0, (0, parcelRequire("hEtBs")).List);
});
parcelRegister("hEtBs", function(module, exports) {
    $parcel$export(module.exports, "List", ()=>$fce0d2453e66ead9$export$54c2e3dc7acea9f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    function $fce0d2453e66ead9$var$_List({ children: children, xcss: xcss }, forwardedRef) {
        const internalRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            var child;
        }, []);
        const ref = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            forwardedRef
        ]);
        return ($5uXOq.createElement("div", {
            role: "list",
            ref: ref,
            className: xcss
        }, children));
    }
    const $fce0d2453e66ead9$export$54c2e3dc7acea9f5 = (0, $5uXOq.forwardRef)($fce0d2453e66ead9$var$_List);
    function $fce0d2453e66ead9$var$isValidChild(element) {
        if (element.tagName === 'STYLE' || element.tagName === 'SCRIPT') return true;
        if (element.tagName === 'DIV' && element.getAttribute('role') === null) return Array.from(element.children).every($fce0d2453e66ead9$var$isValidChild);
        return element.getAttribute('role') === 'listitem';
    }
});
parcelRegister("3yxBH", function(module, exports) {
    $parcel$export(module.exports, "SideNavContent", ()=>$0bf3573d8c099cfe$export$babe3c784778f3ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0bf3573d8c099cfe$export$babe3c784778f3ba = (0, $5uXOq.forwardRef)($0bf3573d8c099cfe$var$_SideNavContent);
    const $0bf3573d8c099cfe$var$styles = {
        scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
        paddingContainer: "_1yt4utpp"
    };
    function $0bf3573d8c099cfe$var$_SideNavContent({ children: children, testId: testId }, ref) {
        return $5uXOq.createElement("div", {
            ref: ref,
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $0bf3573d8c099cfe$var$styles.scrollContainer
            ])
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $0bf3573d8c099cfe$var$styles.paddingContainer
            ])
        }, children));
    }
});
parcelRegister("6DDUb", function(module, exports) {
    $parcel$export(module.exports, "SideNavHeader", ()=>$872964f12a4b72df$export$9d28ff3a0d89869c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $872964f12a4b72df$var$styles = {
        root: "_18zrutpp _1q51utpp _85i51b66"
    };
    const $872964f12a4b72df$export$9d28ff3a0d89869c = ({ children: children })=>{
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $872964f12a4b72df$var$styles.root
            ])
        }, children);
    };
});
parcelRegister("9GB5z", function(module, exports) {
    $parcel$export(module.exports, "AsyncPageSwitcher", ()=>$8f72ed6ff9af1bd8$export$3130bd98029942c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $lfTZh;
    var $kxZPA;
    const $8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8f72ed6ff9af1bd8$var$headingSkeleton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8f72ed6ff9af1bd8$var$dropdownSkeleton
        }));
    const $8f72ed6ff9af1bd8$var$LazyPageSwitcher = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("iPVb9")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
    });
    const $8f72ed6ff9af1bd8$export$3130bd98029942c = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.page-switcher",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$var$LazyPageSwitcher, props));
    const $8f72ed6ff9af1bd8$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: '50%',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100'
    });
    const $8f72ed6ff9af1bd8$var$dropdownSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("iPVb9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6XfVR")
    ]).then(()=>parcelRequire('8dyHT'));
});
parcelRegister("jDuwy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfdc401436033e3a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dfdc401436033e3a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
            "defaultMessage": "Jira admin settings"
        }
    });
});
parcelRegister("i8077", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$8a8cf6e18096ea33$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    const $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$sectionHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$sectionHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }));
    const $8a8cf6e18096ea33$var$sectionHeading = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: '50%',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100',
        marginTop: 'space.100'
    });
    const $8a8cf6e18096ea33$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("ajhZM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4HmNO")
    ]).then(()=>parcelRequire('6JIAx'));
});
parcelRegister("bCaZu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58b39e5bf0fb90a0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $58b39e5bf0fb90a0$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gxGwA")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
    });
    const $58b39e5bf0fb90a0$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.issues-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "issues"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.issues-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($58b39e5bf0fb90a0$var$LazySidebarContent, null))));
    var $58b39e5bf0fb90a0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($58b39e5bf0fb90a0$var$AsyncSidebar);
});
parcelRegister("gxGwA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hEv4j")
    ]).then(()=>parcelRequire('fUdDx'));
});
parcelRegister("gYSoA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$425ce2b571ab3ef5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $425ce2b571ab3ef5$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("f6lak")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
    });
    const $425ce2b571ab3ef5$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.products-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "products"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.products-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($425ce2b571ab3ef5$var$LazySidebarContent, null))));
    var $425ce2b571ab3ef5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($425ce2b571ab3ef5$var$AsyncSidebar);
});
parcelRegister("f6lak", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eOt8B")
    ]).then(()=>parcelRequire('864s3'));
});
parcelRegister("ieEgo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b88bb6161ed4902f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $b88bb6161ed4902f$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jLd8z")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
    });
    const $b88bb6161ed4902f$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.projects-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.projects-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b88bb6161ed4902f$var$LazySidebarContent, null))));
    var $b88bb6161ed4902f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b88bb6161ed4902f$var$AsyncSidebar);
});
parcelRegister("jLd8z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7bkDd")
    ]).then(()=>parcelRequire('fbdwm'));
});
parcelRegister("kNJsg", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", ()=>$90305fd4b8d90c67$export$68950d4e14439158);
    $parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", ()=>$90305fd4b8d90c67$export$5efb701a2106707a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $hWBtO;
    var $efOLn;
    var $fgeiD;
    var $bYoAQ;
    var $hz6Yb;
    var $dIdda = parcelRequire("dIdda");
    const $90305fd4b8d90c67$var$getItems = (d)=>(0, (0, parcelRequire("hWBtO")).getLinks)(d, [
            'admin_system_menu'
        ], {
            skipFilter: true
        }).map((0, (0, parcelRequire("efOLn")).transformLink)).filter(Boolean);
    const $90305fd4b8d90c67$export$68950d4e14439158 = (0, (0, parcelRequire("fgeiD")).withThrowOnError)(()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("bYoAQ")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $90305fd4b8d90c67$var$getItems(data), [
            data
        ]);
        return {
            data: items,
            loading: loading,
            error: error
        };
    });
    const $90305fd4b8d90c67$export$5efb701a2106707a = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = $90305fd4b8d90c67$export$68950d4e14439158();
        const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, (0, parcelRequire("hz6Yb")).useConnectGeneralResource)();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, (0, parcelRequire("8maDO")).findItemAndStack)(data, route.name, location)?.selected), [
            data,
            route,
            location
        ]);
        return {
            isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
            loading: loading || connectGeneralResourceLoading,
            error: error || connectGeneralResourceError
        };
    };
});
parcelRegister("fgeiD", function(module, exports) {
    $parcel$export(module.exports, "withThrowOnError", ()=>$f9ce174aaa2e063b$export$a018832f2ec4dc91);
    var $gKZoD;
    const $f9ce174aaa2e063b$var$isDataEmpty = (data)=>data == null;
    function $f9ce174aaa2e063b$export$a018832f2ec4dc91(theHook) {
        return (...args)=>{
            (0, (0, parcelRequire("gKZoD")).di)(theHook);
            const result = theHook(...args);
            if (!false && $f9ce174aaa2e063b$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
            return result;
        };
    }
});
parcelRegister("aWnEG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59776b430a24875d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $59776b430a24875d$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gsY8o")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
    });
    const $59776b430a24875d$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.system-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "system"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.system-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($59776b430a24875d$var$LazySidebarContent, null))));
    var $59776b430a24875d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($59776b430a24875d$var$AsyncSidebar);
});
parcelRegister("gsY8o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9yM86")
    ]).then(()=>parcelRequire('rQUQs'));
});
parcelRegister("2KXa8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5d93ac4546abf11$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $kxZPA;
    var $aUxXz;
    const $b5d93ac4546abf11$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("68Ad0")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
    });
    const $b5d93ac4546abf11$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.help-center-settings",
            packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.help-center-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aUxXz")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b5d93ac4546abf11$var$LazySidebarContent, null)));
    var $b5d93ac4546abf11$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b5d93ac4546abf11$var$AsyncSidebar);
});
parcelRegister("aUxXz", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$c42d7c14b1508227$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    const $c42d7c14b1508227$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        })));
    const $c42d7c14b1508227$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $c42d7c14b1508227$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $c42d7c14b1508227$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("68Ad0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jvUDk")
    ]).then(()=>parcelRequire('22iKv'));
});
parcelRegister("hrRcW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e7cdaae12475462$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $kxZPA;
    var $jUfLV;
    const $8e7cdaae12475462$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kgoik")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/personal/src/ui/main.tsx"
    });
    const $8e7cdaae12475462$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.personal-settings",
            packageName: "jiraNavigationAppsSidebarNav4PersonalSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.personal-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUfLV")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8e7cdaae12475462$var$LazySidebarContent, null)));
    var $8e7cdaae12475462$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($8e7cdaae12475462$var$AsyncSidebar);
});
parcelRegister("jUfLV", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$1cdf070fb698d8d2$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    const $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$menuItem
        })));
    const $1cdf070fb698d8d2$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.200'
    });
    const $1cdf070fb698d8d2$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $1cdf070fb698d8d2$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $1cdf070fb698d8d2$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("kgoik", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("6lHZh")
    ]).then(()=>parcelRequire('hox2O'));
});
parcelRegister("lF3VU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$442721cda4044790$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $bhcrK;
    const $442721cda4044790$var$LazyPlanSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("eNhKs")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/plan/src/ui/main.tsx"
    });
    const $442721cda4044790$var$AsyncSidebar = ({ store: store })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "asyncSidebarPlanSettings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bhcrK")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($442721cda4044790$var$LazyPlanSettingsSidebar, {
            store: store
        }));
    var $442721cda4044790$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($442721cda4044790$var$AsyncSidebar);
});
parcelRegister("bhcrK", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$d204c752b5086975$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    const $d204c752b5086975$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$titleSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })));
    const $d204c752b5086975$var$titleSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-800, 64px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $d204c752b5086975$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$subtitleItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-1000, 80px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("eNhKs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b8Lgd")
    ]).then(()=>parcelRequire('7UsxD'));
});
parcelRegister("bJJms", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cce9becc602ac5ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $cce9becc602ac5ad$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("h9v0v")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/company-managed/src/ui/main.tsx"
    });
    const $cce9becc602ac5ad$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.business.company-managed",
            packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.business.company-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cce9becc602ac5ad$var$LazySidebarContent, {
            project: project
        })));
    var $cce9becc602ac5ad$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cce9becc602ac5ad$var$AsyncSidebar);
});
parcelRegister("7VBev", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$af3b5ba721400353$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $bgrar;
    var $luBm6;
    var $8CUq3;
    const $af3b5ba721400353$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200",
            xcss: $af3b5ba721400353$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bgrar")).default), {
            columnGap: "space.100",
            rowGap: "space.050",
            alignItems: "center",
            templateAreas: [
                'avatar name',
                'avatar type'
            ],
            templateColumns: "min-content 1fr",
            xcss: $af3b5ba721400353$var$projectHeading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$projectAvatar,
            style: {
                gridArea: 'avatar'
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$projectName,
            style: {
                gridArea: 'name'
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$projectType,
            style: {
                gridArea: 'type'
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        })));
    const $af3b5ba721400353$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        padding: 'space.200'
    });
    const $af3b5ba721400353$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $af3b5ba721400353$var$projectHeading = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.100',
        marginBottom: 'space.100'
    });
    const $af3b5ba721400353$var$projectAvatar = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$projectName = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$projectType = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-100, 8px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("h9v0v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("f7rnD")
    ]).then(()=>parcelRequire('kaECc'));
});
parcelRegister("6ZLHo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b222bb97daacff3e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $b222bb97daacff3e$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3J9D1")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/team-managed/src/ui/main.tsx"
    });
    const $b222bb97daacff3e$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.business.team-managed",
            packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.business.team-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b222bb97daacff3e$var$LazySidebarContent, {
            project: project
        })));
    var $b222bb97daacff3e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b222bb97daacff3e$var$AsyncSidebar);
});
parcelRegister("3J9D1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("l1ol4")
    ]).then(()=>parcelRequire('v17He'));
});
parcelRegister("YiTdm", function(module, exports) {
    $parcel$export(module.exports, "useIsConnectAppActive", ()=>$c92d349d32b0fe9a$export$249b2e8512031cae);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $dIdda = parcelRequire("dIdda");
    var $eNZur;
    const $c92d349d32b0fe9a$export$249b2e8512031cae = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: connectApps, error: error, loading: loading } = (0, (0, parcelRequire("eNZur")).useConnectApps)();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean((0, (0, parcelRequire("8maDO")).findItemAndStack)(connectApps, route.name, location)?.selected), [
            connectApps,
            location,
            route.name
        ]);
        return {
            isActive: isActive,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("eNZur", function(module, exports) {
    $parcel$export(module.exports, "useConnectApps", ()=>$5ce3bcf534d9d0ea$export$4864478dcab77643);
    var $5uXOq = parcelRequire("5uXOq");
    var $loy04;
    var $efOLn;
    var $9MFH3;
    const $5ce3bcf534d9d0ea$export$4864478dcab77643 = ()=>{
        const { data: connectResourceItems, error: error, loading: loading } = (0, (0, parcelRequire("loy04")).useProjectSettingsSidebarConnectAddonsNavigationResource)();
        const connectApps = (0, $5uXOq.useMemo)(()=>{
            if (connectResourceItems == null) return [];
            const transformedConnectApps = [];
            for (const item of connectResourceItems){
                const transformedItem = (0, (0, parcelRequire("efOLn")).transformLinkV4)(item);
                if (transformedItem && !(0, (0, parcelRequire("9MFH3")).LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
            }
            return transformedConnectApps;
        }, [
            connectResourceItems
        ]);
        return {
            data: connectApps,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("9MFH3", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", ()=>$b25e3cd9691dd3ed$export$911a3d81a5d162b6);
    const $b25e3cd9691dd3ed$export$911a3d81a5d162b6 = new Set([
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ]);
});
parcelRegister("kqEpF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2c80e831fc4dee6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $c2c80e831fc4dee6$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lLMvP")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/product-discovery/src/ui/main.tsx"
    });
    const $c2c80e831fc4dee6$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.jpd-settings",
            packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.jpd-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c2c80e831fc4dee6$var$LazySidebarContent, {
            project: project
        })));
    var $c2c80e831fc4dee6$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c2c80e831fc4dee6$var$AsyncSidebar);
});
parcelRegister("lLMvP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9Dnuj")
    ]).then(()=>parcelRequire('aDwWR'));
});
parcelRegister("1G9rm", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", ()=>$5b1e7bac8593a90d$export$2ce6ad449436c545);
    var $5uXOq = parcelRequire("5uXOq");
    var $juTur;
    var $cljJ9;
    var $7VBev;
    var $84dyl;
    var $lfTZh;
    var $kxZPA;
    const $5b1e7bac8593a90d$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4CeCe")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/company-managed/src/main.tsx"
    });
    const $5b1e7bac8593a90d$var$analyticsAttributes = {
        projectStyle: 'cmp',
        navVersion: undefined,
        navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22)
    };
    const $5b1e7bac8593a90d$export$2ce6ad449436c545 = (0, $5uXOq.memo)(({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.jsm-cmp-project-settings",
            packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("84dyl")).MENU_ID_JSM_SETTINGS),
            attributes: $5b1e7bac8593a90d$var$analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5b1e7bac8593a90d$var$LazySidebarContent, {
            project: project
        })))));
});
parcelRegister("84dyl", function(module, exports) {
    $parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", ()=>$8fdaf51231934b8c$export$4c5fa21d31710030);
    $parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", ()=>$8fdaf51231934b8c$export$8092325c2fa271de);
    const $8fdaf51231934b8c$export$4c5fa21d31710030 = 'project/service-desk/settings';
    const $8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES = {
        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
        level: 1
    };
    const $8fdaf51231934b8c$export$8092325c2fa271de = {
        ...$8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES,
        actionSubjectId: (0, $d59b407ab907bf7b$export$13171e509c859bbf)
    };
});
const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';
parcelRegister("4CeCe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("k1zH8")
    ]).then(()=>parcelRequire('58Da3'));
});
parcelRegister("drQWa", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", ()=>$723c8db5701ca405$export$dadf0f8c840cb26d);
    var $5uXOq = parcelRequire("5uXOq");
    var $juTur;
    var $cljJ9;
    var $7VBev;
    var $84dyl;
    var $lfTZh;
    var $kxZPA;
    const $723c8db5701ca405$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2enEN")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/team-managed/src/main.tsx"
    });
    const $723c8db5701ca405$var$analyticsAttributes = {
        projectStyle: 'tmp',
        navVersion: undefined,
        navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22)
    };
    const $723c8db5701ca405$export$dadf0f8c840cb26d = (0, $5uXOq.memo)(({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.jsm-tmp-project-settings",
            packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("84dyl")).MENU_ID_JSM_SETTINGS),
            attributes: $723c8db5701ca405$var$analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($723c8db5701ca405$var$LazySidebarContent, {
            project: project
        })))));
});
parcelRegister("2enEN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("2ALx4")
    ]).then(()=>parcelRequire('dJT47'));
});
parcelRegister("2DtJE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd62495e40b7984d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $fd62495e40b7984d$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("218yI")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/company-managed/src/ui/main.tsx"
    });
    const $fd62495e40b7984d$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.software.company-managed",
            packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.software.company-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fd62495e40b7984d$var$LazySidebarContent, {
            project: project
        })));
    var $fd62495e40b7984d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($fd62495e40b7984d$var$AsyncSidebar);
});
parcelRegister("218yI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iNMXx")
    ]).then(()=>parcelRequire('cLlaG'));
});
parcelRegister("cnyf1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$713dabe47adbee45$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $713dabe47adbee45$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("h8vhS")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/team-managed/src/ui/main.tsx"
    });
    const $713dabe47adbee45$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.software.team-managed",
            packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.software.team-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($713dabe47adbee45$var$LazySidebarContent, {
            project: project
        })));
    var $713dabe47adbee45$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($713dabe47adbee45$var$AsyncSidebar);
});
parcelRegister("h8vhS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cxRoY")
    ]).then(()=>parcelRequire('4yoHz'));
});
parcelRegister("4DrQd", function(module, exports) {
    $parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", ()=>$e2413e530566d4f6$export$47f3715a07cde7e8);
    $parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", ()=>$e2413e530566d4f6$export$f5a7bd7eb586e4e8);
    $parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", ()=>$e2413e530566d4f6$export$6a976dc7193b8a18);
    $parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", ()=>$e2413e530566d4f6$export$9fcc53f3b36e0949);
    $parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", ()=>$e2413e530566d4f6$export$2eb8dda9e83d33ff);
    $parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", ()=>$e2413e530566d4f6$export$9cf873ba2e9a3ce0);
    $parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", ()=>$e2413e530566d4f6$export$a495ba70b16d4d90);
    $parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", ()=>$e2413e530566d4f6$export$89de709e88232646);
    var $1ZDWg;
    var $aUBhr;
    var $hyKRO;
    var $gsyzJ;
    var $jX361;
    var $iZgwT;
    var $9x5pH;
    var $4iV1e;
    var $dXQDI;
    var $ifnb0;
    var $llvRa;
    var $dAf5R;
    var $c781K;
    var $jhS4y;
    var $ih7ba;
    var $46Cti;
    const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
    const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
    const $e2413e530566d4f6$export$47f3715a07cde7e8 = 250;
    const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID));
    const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
    const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).apps,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("1ZDWg")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).goals,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("4iV1e")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).roadmaps,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("iZgwT")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).plans,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("ifnb0")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).projects,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("dXQDI")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).filters,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("jX361")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).dashboards,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("gsyzJ")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).overviews,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("9x5pH")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).operations,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("llvRa")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).assets,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("aUBhr")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).teams,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("c781K")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).RECENT]: {
            message: (0, (0, parcelRequire("ih7ba")).default).recent,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("hyKRO")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).STARRED]: {
            message: (0, (0, parcelRequire("ih7ba")).default).starred,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("dAf5R")))))
        }
    };
    const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240;
    const $e2413e530566d4f6$export$6621cd553335536a = 320;
    const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
    const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
    const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
    const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
    const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
    const $e2413e530566d4f6$export$89de709e88232646 = 25;
});
parcelRegister("aUBhr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7f1c0d6a2d8e7040$var$_react = $7f1c0d6a2d8e7040$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7f1c0d6a2d8e7040$var$_UNSAFE_baseNew = $7f1c0d6a2d8e7040$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $7f1c0d6a2d8e7040$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7f1c0d6a2d8e7040$var$AssetsIcon = (props)=>$7f1c0d6a2d8e7040$var$_react.default.createElement($7f1c0d6a2d8e7040$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.59 6.409a2.25 2.25 0 0 1 0 3.182m0-3.182a2.25 2.25 0 0 0-3.181 0m3.182 0 2.598-2.598M9.591 9.59a2.25 2.25 0 0 1-3.182 0m3.182 0 2.598 2.598M6.41 9.591a2.25 2.25 0 0 1 0-3.182m0 3.182-2.6 2.598m2.598-5.78L3.81 3.811m8.378 0a1.5 1.5 0 1 0 2.122-2.122 1.5 1.5 0 0 0-2.122 2.122Zm0 8.378a1.5 1.5 0 1 0 2.122 2.122 1.5 1.5 0 0 0-2.122-2.122ZM3.811 3.811a1.5 1.5 0 1 0-2.122-2.122 1.5 1.5 0 0 0 2.122 2.122Zm0 8.378a1.5 1.5 0 1 1-2.122 2.122 1.5 1.5 0 0 1 2.122-2.122Z"/>`
        }, props));
    $7f1c0d6a2d8e7040$var$AssetsIcon.displayName = 'AssetsIcon';
    var $7f1c0d6a2d8e7040$var$_default = module.exports.default = $7f1c0d6a2d8e7040$var$AssetsIcon;
});
parcelRegister("iZgwT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $dd2abeeb9b40523f$var$_react = $dd2abeeb9b40523f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $dd2abeeb9b40523f$var$_UNSAFE_baseNew = $dd2abeeb9b40523f$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $dd2abeeb9b40523f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $dd2abeeb9b40523f$var$FolderOpenIcon = (props)=>$dd2abeeb9b40523f$var$_react.default.createElement($dd2abeeb9b40523f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 14.25a1 1 0 0 1-1-1V3c0-.69.56-1.25 1.25-1.25h3.25L7 3.5h5c.69 0 1.25.56 1.25 1.25v2m-11.5 7.5 2.116-7.055a.625.625 0 0 1 .599-.445h8.785m-11.5 7.5h10.57a1.25 1.25 0 0 0 1.197-.89l1.742-5.805a.625.625 0 0 0-.599-.805h-1.41"/>`
        }, props));
    $dd2abeeb9b40523f$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
    var $dd2abeeb9b40523f$var$_default = module.exports.default = $dd2abeeb9b40523f$var$FolderOpenIcon;
});
parcelRegister("4iV1e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3225129c19adcd71$var$_react = $3225129c19adcd71$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3225129c19adcd71$var$_UNSAFE_baseNew = $3225129c19adcd71$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3225129c19adcd71$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3225129c19adcd71$var$GoalIcon = (props)=>$3225129c19adcd71$var$_react.default.createElement($3225129c19adcd71$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-width="1.5" d="M8 11.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"/>`
        }, props));
    $3225129c19adcd71$var$GoalIcon.displayName = 'GoalIcon';
    var $3225129c19adcd71$var$_default = module.exports.default = $3225129c19adcd71$var$GoalIcon;
});
parcelRegister("ifnb0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d48b9b12f073239d$var$_react = $d48b9b12f073239d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d48b9b12f073239d$var$_UNSAFE_baseNew = $d48b9b12f073239d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d48b9b12f073239d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d48b9b12f073239d$var$RoadmapIcon = (props)=>$d48b9b12f073239d$var$_react.default.createElement($d48b9b12f073239d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H2C1.31 6.25.75 5.69.75 5zm3 7c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"/>`
        }, props));
    $d48b9b12f073239d$var$RoadmapIcon.displayName = 'RoadmapIcon';
    var $d48b9b12f073239d$var$_default = module.exports.default = $d48b9b12f073239d$var$RoadmapIcon;
});
parcelRegister("llvRa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0402a646ff642134$var$_react = $0402a646ff642134$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0402a646ff642134$var$_UNSAFE_baseNew = $0402a646ff642134$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0402a646ff642134$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0402a646ff642134$var$ShieldIcon = (props)=>$0402a646ff642134$var$_react.default.createElement($0402a646ff642134$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 4.5S10.75 3.5 8 .75C5.25 3.5 1.75 4.5 1.75 4.5 1.75 12.75 8 15.125 8 15.125S14.25 12.75 14.25 4.5Z"/>`
        }, props));
    $0402a646ff642134$var$ShieldIcon.displayName = 'ShieldIcon';
    var $0402a646ff642134$var$_default = module.exports.default = $0402a646ff642134$var$ShieldIcon;
});
parcelRegister("ih7ba", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c16ecaa1449e546$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projects: {
            "id": "navigation-apps-sidebar-nav4-common.common.projects",
            "defaultMessage": "Projects"
        },
        filters: {
            "id": "navigation-apps-sidebar-nav4-common.common.filters",
            "defaultMessage": "Filters"
        },
        dashboards: {
            "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
            "defaultMessage": "Dashboards"
        },
        overviews: {
            "id": "navigation-apps-sidebar-nav4-common.common.overviews",
            "defaultMessage": "Overviews"
        },
        teams: {
            "id": "navigation-apps-sidebar-nav4-common.common.teams",
            "defaultMessage": "Teams"
        },
        assets: {
            "id": "navigation-apps-sidebar-nav4-common.common.assets",
            "defaultMessage": "Assets"
        },
        plans: {
            "id": "navigation-apps-sidebar-nav4-common.common.plans",
            "defaultMessage": "Plans"
        },
        apps: {
            "id": "navigation-apps-sidebar-nav4-common.common.apps",
            "defaultMessage": "Apps"
        },
        operations: {
            "id": "navigation-apps-sidebar-nav4-common.common.operations",
            "defaultMessage": "Operations"
        },
        goals: {
            "id": "navigation-apps-sidebar-nav4-common.common.goals",
            "defaultMessage": "Goals"
        },
        recent: {
            "id": "navigation-apps-sidebar-nav4-common.common.recent",
            "defaultMessage": "Recent"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-common.common.starred",
            "defaultMessage": "Starred"
        },
        roadmaps: {
            "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
            "defaultMessage": "Roadmaps"
        }
    });
});
parcelRegister("46Cti", function(module, exports) {
    $parcel$export(module.exports, "L1_MENU_ID", ()=>$2d5b83df0b5ff159$export$918aea3cf024d90b);
    var $jhS4y;
    const $2d5b83df0b5ff159$export$f263c05bb04cefc9 = {
        OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
        OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
    };
    const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
        ...(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID),
        BOARDS: 'jira.sidebar.boards',
        QUEUES: 'jira.sidebar.queues',
        ALL: 'jira.sidebar.all'
    };
    const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
        YOUR_WORK: 'jira.sidebar.yourWork',
        ...(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID),
        ...$2d5b83df0b5ff159$export$f263c05bb04cefc9
    };
});
parcelRegister("eGkew", function(module, exports) {
    $parcel$export(module.exports, "SidebarSelectorProvider", ()=>$8451f19a8196b45e$export$6af584355cfb32c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $2vSU6;
    var $lpwtK;
    var $lGo7j;
    var $cin8p;
    var $awp39;
    var $b69Lc;
    var $dlYil;
    var $jjzbO;
    var $hWtQt;
    var $jfqNX;
    var $gZbSF;
    var $dmKXV;
    var $iFaFr;
    var $4IWRY;
    var $hBv66;
    var $iHiHz;
    var $cOg46;
    var $7AyKX;
    var $koWFd;
    var $937TY;
    var $lgSL3;
    var $h0bZU;
    var $9s3j1;
    var $2IHt2;
    var $hz6Yb;
    var $dIdda = parcelRequire("dIdda");
    const $8451f19a8196b45e$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
            isFull: true
        });
        if (!project) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2IHt2")).default), null);
        switch(project.type){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h0bZU")).default), null);
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lgSL3")).default), null);
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (project.isSimplified) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koWFd")).default), null);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9s3j1")).default), null);
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dmKXV")).default), null);
            default:
                return null;
        }
    };
    const $8451f19a8196b45e$var$ProjectSidebar = (0, $5uXOq.memo)($8451f19a8196b45e$var$renderProjectSidebar, (0, ($parcel$interopDefault($ajpes))));
    const $8451f19a8196b45e$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
        const projectState = (0, (0, parcelRequire("lpwtK")).useProject)();
        const isInsightMenuSelected = (0, (0, parcelRequire("jjzbO")).useInsight)();
        const shouldRenderInsightObjectSchemaSidebar = (0, (0, parcelRequire("jjzbO")).useInsightObjectSchemaSidebar)();
        const { selected: pSelected, loading: pLoading } = (0, (0, parcelRequire("gZbSF")).useProjectConnectItems)();
        const { selected: prSelected, loading: prLoading } = (0, (0, parcelRequire("hWtQt")).useProjectReportsConnectItems)();
        const { selected: psSelected, loading: psLoading } = (0, (0, parcelRequire("jfqNX")).useProjectSettingsConnectItems)();
        const { selected: gSelected, loading: gLoading } = (0, (0, parcelRequire("dlYil")).useGlobalConnectItems)();
        const { selected: gsSelected, loading: gsLoading } = (0, (0, parcelRequire("b69Lc")).useGlobalSettingsConnectItems)();
        const { selected: gssSelected, loading: gssLoading } = (0, (0, parcelRequire("awp39")).useGlobalSettingsSystemConnectItems)();
        const { data: gresData, loading: gresLoading } = (0, $dIdda.useResource)((0, (0, parcelRequire("hz6Yb")).connectGeneralResources));
        const { sections: fgSections, loading: fgLoading } = (0, (0, parcelRequire("4IWRY")).useForgeGlobalPageItems)();
        if (shouldRenderInsightObjectSchemaSidebar) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7AyKX")).default), null));
        if (isInsightMenuSelected) return null;
        if (sidebar === (0, (0, parcelRequire("937TY")).default)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("937TY")).default), null));
        if (sidebar === (0, (0, parcelRequire("iFaFr")).default)) {
            if (fgLoading) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            }));
            if (fgSections?.length) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iFaFr")).default), null));
            return children(null);
        }
        if (!Array.isArray(sidebar)) {
            const Sidebar = sidebar;
            return children(Sidebar != null ? (0, ($parcel$interopDefault($5uXOq))).createElement(Sidebar, null) : null);
        }
        if (sidebar === (0, (0, parcelRequire("hBv66")).genericConnectSidebars)) {
            const foundInProject = pSelected || prSelected || psSelected || [
                'jiraProjectAdminTabPanels'
            ].includes(gresData?.moduleType);
            const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
            const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
            if (stillLoading && !foundSomewhere) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            }));
            if (foundInProject) {
                const projectSidebar = (0, ($parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
                return children(projectSidebar);
            }
            if (gSelected) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cin8p")).default), null));
            if (gsSelected || [
                'configurePage',
                'postInstallPage'
            ].includes(gresData?.moduleType)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHiHz")).default), null));
            if (gssSelected || [
                'adminPages'
            ].includes(gresData?.moduleType)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOg46")).default), null));
            return children(null);
        }
        const projectSidebar = (0, ($parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
        return children(projectSidebar);
    };
});
parcelRegister("b69Lc", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsConnectItems", ()=>$ba4edc5b901e34a6$export$f0785b98c99d344c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $ba4edc5b901e34a6$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'admin_plugins_menu'
        ], {
            skipFilter: true
        }).filter((v)=>![
                'upm_section',
                'jpo-ws-admin'
            ].includes(v.id)).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter(Boolean));
    const $ba4edc5b901e34a6$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $ba4edc5b901e34a6$export$f0785b98c99d344c = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $ba4edc5b901e34a6$var$getItemsMemo(data), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $ba4edc5b901e34a6$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("dlYil", function(module, exports) {
    $parcel$export(module.exports, "useGlobalConnectItems", ()=>$17cad8174f7acae6$export$ee355b2e42d6462b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $17cad8174f7acae6$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'global-navigation-product'
        ]).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter((item)=>item != null && item.items));
    const $17cad8174f7acae6$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $17cad8174f7acae6$export$ee355b2e42d6462b = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const sidebars = (0, $5uXOq.useMemo)(()=>data && $17cad8174f7acae6$var$getItemsMemo(data), [
            data
        ]);
        const searchResult = (0, $5uXOq.useMemo)(()=>{
            let result = {
                stack: [],
                selected: null,
                title: null,
                data: null
            };
            if (sidebars != null) sidebars.some((sidebar)=>{
                const { items: items } = sidebar || {};
                if (!sidebar || !route || items == null) return false;
                const found = $17cad8174f7acae6$var$findItemAndStackMemo(items, route.name, location);
                if (found) {
                    result = {
                        ...found,
                        title: sidebar.name,
                        data: items
                    };
                    return true;
                }
                return false;
            });
            return result;
        }, [
            sidebars,
            route,
            location
        ]);
        return {
            ...searchResult,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("jjzbO", function(module, exports) {
    $parcel$export(module.exports, "useInsight", ()=>$25e0b1dc21125803$export$e24dad0705701755);
    $parcel$export(module.exports, "useInsightObjectSchemaSidebar", ()=>$25e0b1dc21125803$export$1f0bd21403710fc);
    var $3HwlS;
    var $6jY6G;
    const $25e0b1dc21125803$export$e24dad0705701755 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if (route.navigation) return route.navigation.menuId === 'INSIGHT';
        return false;
    };
    const $25e0b1dc21125803$export$1f0bd21403710fc = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return false;
        return route.name === 'servicedesk-cmdb-object-schema';
    };
});
parcelRegister("4IWRY", function(module, exports) {
    $parcel$export(module.exports, "useForgeGlobalPageItems", ()=>$e660bc01a5db5a53$export$ff333fd2f0bf5254);
    var $5uXOq = parcelRequire("5uXOq");
    var $4NrfJ;
    var $7Tlti;
    var $c70gQ;
    var $dIdda = parcelRequire("dIdda");
    const $e660bc01a5db5a53$export$ff333fd2f0bf5254 = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const { data: modules, loading: loading, error: error } = (0, (0, parcelRequire("4NrfJ")).useGlobalForgeApps)();
        const extension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        const sections = (0, $5uXOq.useMemo)(()=>extension && (0, (0, parcelRequire("7Tlti")).toSections)(extension), [
            extension
        ]);
        return {
            extension: extension,
            sections: sections,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("4NrfJ", function(module, exports) {
    $parcel$export(module.exports, "getItemHref", ()=>$7a76aaaa3a23f02a$export$ed6342e0e28465a6);
    $parcel$export(module.exports, "useGlobalForgeApps", ()=>$7a76aaaa3a23f02a$export$f834c14187f80532);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $e0AC8;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $dIdda = parcelRequire("dIdda");
    const $7a76aaaa3a23f02a$export$ed6342e0e28465a6 = (extension)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/apps/${appId}/${envId}`;
    };
    const $7a76aaaa3a23f02a$var$useGlobalForgeAppsV1 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeGlobalModuleV1Resource));
        const globalPageData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: globalPageData ? globalPageData.filter((extension)=>(0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, {})) : null,
                loading: loading,
                error: error
            }), [
            globalPageData,
            loading,
            error
        ]);
    };
    const $7a76aaaa3a23f02a$var$useGlobalForgeAppsV2 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeGlobalModuleV2Resource));
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, {}, 'global-forge-apps-hook');
        return (0, $5uXOq.useMemo)(()=>({
                data: data ? data.filter((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) : null,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
    const $7a76aaaa3a23f02a$export$f834c14187f80532 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $7a76aaaa3a23f02a$var$useGlobalForgeAppsV2, $7a76aaaa3a23f02a$var$useGlobalForgeAppsV1);
});
parcelRegister("7AyKX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cf06d255b5e49f4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("5HCdM")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
    });
    const $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "insight-object-schema-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar, null)));
    $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
    var $6cf06d255b5e49f4$export$2e2bcd8739ae039 = $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar;
});
parcelRegister("5HCdM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("a8Tkc")
    ]).then(()=>parcelRequire('48ZOK'));
});
parcelRegister("lgSL3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$756fa7b51ff3cfd4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("9vvGA")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
    });
    const $756fa7b51ff3cfd4$var$PolarisProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "polarisProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar, null)));
    $756fa7b51ff3cfd4$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
    var $756fa7b51ff3cfd4$export$2e2bcd8739ae039 = $756fa7b51ff3cfd4$var$PolarisProjectSidebar;
});
parcelRegister("9vvGA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("blsmD")
    ]).then(()=>parcelRequire('aSh9m'));
});
parcelRegister("ht71P", function(module, exports) {
    $parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", ()=>$7676eec527946b59$export$30d9dff000fbaa2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $7676eec527946b59$var$NudgeBundledUsersFlagContainer = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("esy1S")).then((module)=>module.NudgeBundledUsersXflow), {
        ssr: false,
        moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
    });
    const $7676eec527946b59$export$30d9dff000fbaa2d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "nudgeBundledUserFlag",
            packageName: "nudgeBundledUsersToJoinConnie",
            fallback: "unmount",
            teamName: "confluenceOnboarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nudge-bundled-users-flag",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7676eec527946b59$var$NudgeBundledUsersFlagContainer, null)));
});
parcelRegister("esy1S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ev3ZS").then(()=>parcelRequire('6vucW'));
});
parcelRegister("4V52L", function(module, exports) {
    $parcel$export(module.exports, "SidebarFeedbackButton", ()=>$ea1c2dd9a94de02f$export$b270ed097d20c023);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    var $jpaiZ;
    var $e4yMr;
    var $3bDjY;
    var $cSD7y;
    var $4R6GH;
    var $7iULw;
    var $dseDh;
    var $ousew;
    var $koVbs;
    var $j5Q6Z;
    var $dkkQn;
    var $4DrQd;
    var $bw7Gm;
    var $koeKL;
    var $2tT7R;
    var $83YFz;
    var $6yESG;
    const $ea1c2dd9a94de02f$var$FGWrapper = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_nav4_beta_drop_1', (0, (0, parcelRequire("6yESG")).SpotlightableFeedbackButton), (0, $5uXOq.Fragment));
    function $ea1c2dd9a94de02f$export$b270ed097d20c023() {
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const onClickHandler = (0, $5uXOq.useCallback)(()=>{
            const showFeedbackTitleDetailsWithLink = (0, (0, parcelRequire("j5Q6Z")).getWillShowNav4UserOptIn)() || (0, (0, parcelRequire("dkkQn")).getWillShowNav4UserOptOut)();
            const formattedMessageNode = showFeedbackTitleDetailsWithLink ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("83YFz")).default).feedbackTitleDetailsWithLink,
                values: {
                    a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                            href: "/jira/settings/personal/general",
                            onClick: closeFeedbackCollector
                        }, chunks)
                }
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("83YFz")).default).feedbackTitleDetailsNoLink);
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_NAVIGATION_REFRESH),
                feedbackContext: [
                    {
                        id: 'environment',
                        value: environment
                    },
                    {
                        id: 'cloud-id',
                        value: cloudId
                    },
                    {
                        id: 'location',
                        value: (0, (0, parcelRequire("bw7Gm")).default)(window?.location?.href ?? '')
                    }
                ],
                feedbackGroupId: (0, (0, parcelRequire("4DrQd")).NAV4_GENERAL_FEEDBACK_GROUP_ID),
                feedbackTitle: formatMessage((0, (0, parcelRequire("83YFz")).default).feedbackTitle),
                feedbackTitleDetails: formattedMessageNode
            });
        }, [
            closeFeedbackCollector,
            cloudId,
            environment,
            formatMessage,
            openFeedbackCollector
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ea1c2dd9a94de02f$var$FGWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel),
            position: "top"
        }, (0, (0, parcelRequire("4R6GH")).fg)('jira_global_invite_nav4') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jpaiZ"))))),
            onClick: onClickHandler,
            label: formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel)
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            iconBefore: (0, ($parcel$interopDefault((0, parcelRequire("jpaiZ"))))),
            appearance: "subtle",
            onClick: onClickHandler
        }, formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel))));
    }
});
parcelRegister("jpaiZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e208588d898f6af2$var$_react = $e208588d898f6af2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e208588d898f6af2$var$_UNSAFE_baseNew = $e208588d898f6af2$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e208588d898f6af2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e208588d898f6af2$var$MegaphoneIcon = (props)=>$e208588d898f6af2$var$_react.default.createElement($e208588d898f6af2$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
        }, props));
    $e208588d898f6af2$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
    var $e208588d898f6af2$var$_default = module.exports.default = $e208588d898f6af2$var$MegaphoneIcon;
});
parcelRegister("j5Q6Z", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptIn", ()=>$13f1e9a404b61bdc$export$46a00895da9889a2);
    var $4R6GH;
    const $13f1e9a404b61bdc$export$46a00895da9889a2 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && $13f1e9a404b61bdc$var$getWillShowNav4UserOptInForExistingCustomers();
    const $13f1e9a404b61bdc$var$getWillShowNav4UserOptInForExistingCustomers = ()=>false;
});
parcelRegister("dkkQn", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOut", ()=>$1db1544bbdad6d19$export$acb346134ed05173);
    var $4R6GH;
    var $9Qkfw;
    var $d1JDF;
    const $1db1544bbdad6d19$export$acb346134ed05173 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && ((0, (0, parcelRequire("9Qkfw")).getWillShowNav4UserOptOutForDogfooding)() || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap')) || (0, (0, parcelRequire("d1JDF")).getWillShowNav4UserOptOutForVisualRefresh)();
});
parcelRegister("9Qkfw", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOutForDogfooding", ()=>$a6cd9fbcbab14454$export$9edbe3a98989e15b);
    var $4R6GH;
    const $a6cd9fbcbab14454$export$9edbe3a98989e15b = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding') && ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1') || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2'));
});
parcelRegister("d1JDF", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOutForVisualRefresh", ()=>$1ed6defa01bf1a51$export$17e35ae7beae962d);
    var $4R6GH;
    const $1ed6defa01bf1a51$export$17e35ae7beae962d = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh') && ((0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-dogfood') || (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-eap'));
});
parcelRegister("83YFz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$583ab6a643d91da5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $583ab6a643d91da5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sidebarFeedbackButtonLabel: {
            "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
            "defaultMessage": "Give feedback on the new navigation"
        },
        feedbackTitle: {
            "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
            "defaultMessage": "Help us improve the new navigation"
        },
        feedbackTitleDetailsWithLink: {
            "id": "sidebar-nav4-feedback-button.feedback-title-details",
            "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
        },
        feedbackTitleDetailsNoLink: {
            "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
            "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
        }
    });
});
parcelRegister("6yESG", function(module, exports) {
    $parcel$export(module.exports, "SpotlightableFeedbackButton", ()=>$6bd19e9dd2e5e23f$export$10b3cd4d233adf6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $g8I5C;
    var $8Bc5A;
    var $cE2Qr;
    var $ajOhG;
    var $heI7y;
    var $fD6iO;
    var $ecbZX;
    function $6bd19e9dd2e5e23f$export$10b3cd4d233adf6a({ children: children }) {
        const renderNudgeWrapper = (0, $5uXOq.useCallback)((kids)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ajOhG")).FeedbackNudgeAsync), null, kids), []);
        const [{ hasOpened: shouldShowNudge }] = (0, (0, parcelRequire("heI7y")).useHasOpened)();
        const [isUnloaded] = (0, (0, parcelRequire("cE2Qr")).useIsDismissed)();
        const { isSideNavVisible: isSideNavVisible, showSideNav: showSideNav } = (0, (0, parcelRequire("ecbZX")).useSideNavVisibility)();
        const expandSideNav = (0, (0, parcelRequire("fD6iO")).useExpandSideNav)();
        const [openTask] = (0, (0, parcelRequire("cE2Qr")).useOpenTask)();
        const [, { setHasNudgeActive: setHasNudgeActive }] = (0, (0, parcelRequire("cE2Qr")).useQuickstartActions)();
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_remove_internal_sidenav_state_hook')) {
                if (!isUnloaded && openTask === (0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_TASK) && shouldShowNudge) {
                    expandSideNav();
                    setHasNudgeActive(true);
                }
                return;
            }
            if (!isUnloaded && openTask === (0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_TASK) && shouldShowNudge && !isSideNavVisible) {
                showSideNav();
                setHasNudgeActive(true);
            }
        }, [
            isUnloaded,
            openTask,
            shouldShowNudge,
            setHasNudgeActive,
            expandSideNav,
            isSideNavVisible,
            showSideNav
        ]);
        return !false && shouldShowNudge ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g8I5C")).QuickstartNudge), {
            renderWrapper: renderNudgeWrapper
        }, children) : children;
    }
});
parcelRegister("heI7y", function(module, exports) {
    $parcel$export(module.exports, "useHasOpened", ()=>$c02ba9c4f48115f2$export$cbaabcded53b5c1f);
    var $7JoAD = parcelRequire("7JoAD");
    var $h97QA;
    const $c02ba9c4f48115f2$var$actions = {
        setHasOpened: (0, parcelRequire("h97QA")).setHasOpened
    };
    const $c02ba9c4f48115f2$var$initialState = {
        hasOpened: false
    };
    const $c02ba9c4f48115f2$var$Store = (0, $7JoAD.createStore)({
        initialState: $c02ba9c4f48115f2$var$initialState,
        actions: $c02ba9c4f48115f2$var$actions,
        name: 'jsw-onboarding-quickstart-has-opened'
    });
    const $c02ba9c4f48115f2$export$cbaabcded53b5c1f = (0, $7JoAD.createHook)($c02ba9c4f48115f2$var$Store);
});
parcelRegister("h97QA", function(module, exports) {
    $parcel$export(module.exports, "setHasOpened", ()=>$68011af9f70af395$export$c4743c64a7c42294);
    const $68011af9f70af395$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
            const { hasOpened: hasOpened } = getState();
            if (hasOpened === true) return;
            setState({
                hasOpened: true
            });
        };
    var $68011af9f70af395$export$2e2bcd8739ae039 = $68011af9f70af395$export$c4743c64a7c42294;
});
parcelRegister("fD6iO", function(module, exports) {
    $parcel$export(module.exports, "useExpandSideNav", ()=>$d44c9e93ca4d5bd6$export$e44b4744d8ff971a);
    var $5uXOq = parcelRequire("5uXOq");
    var $b0CFU;
    function $d44c9e93ca4d5bd6$export$e44b4744d8ff971a() {
        const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavDesktopVisibility));
        const setVisibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavMobileVisibility));
        const expandSideNav = (0, $5uXOq.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            if (matches) setVisibleOnDesktop(true);
            else setVisibleOnMobile(true);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return expandSideNav;
    }
});
parcelRegister("3AWiS", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitter", ()=>$f535d623adcb2c41$export$db67e3f8d3d6da0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7nsd3 = parcelRequire("7nsd3");
    var $3joPi = parcelRequire("3joPi");
    var $eGmKJ;
    var $VSDnB;
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    parcelRequire("4dYas");
    var $kLEEo = parcelRequire("kLEEo");
    parcelRequire("hjhoK");
    var $akFFC = parcelRequire("akFFC");
    parcelRequire("fmZmH");
    var $3C4FG = parcelRequire("3C4FG");
    var $5ILhZ;
    var $jldZL;
    var $9NI3h;
    var $fAx1P;
    var $1ICwz;
    const $f535d623adcb2c41$var$containerStyles = {
        root: "_1e0cglyw _kqswstnw _u7coidpf _152tidpf _12ji1r31 _1qu2glyw _12y31o36 _1pbykb7n _181n1ule",
        positionEnd: "_rjxpftgi",
        positionStart: "_1e02zeo2"
    };
    const $f535d623adcb2c41$var$buttonStyles = {
        grabArea: "_1bsbl52n _4t3i1osq _kqswstnw _1yt4ze3t _syaz3acm _bfhk18uv _v5645ge5 _1lww5cps _d0aluf7j _1gavfnf5 _v0vwaqb7 _30l3aqb7 _1gk412xp _o7ks12xp _9h8h16c2 _1gglglyw",
        content: "_1bsb1osq _4t3i1osq"
    };
    const $f535d623adcb2c41$var$lineStyles = {
        root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
    };
    const $f535d623adcb2c41$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>{
        const splitterRef = (0, $5uXOq.useRef)(null);
        const panelSplitterContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("9NI3h")).PanelSplitterContext));
        (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
        const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
        (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
        const direction = (0, (0, parcelRequire("1ICwz")).useTextDirection)(portalRef.current);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const splitter = splitterRef.current;
            (0, $3joPi.default)(splitter, 'Splitter ref must be set');
            return (0, $4hDdm.combine)((0, (0, parcelRequire("VSDnB")).fg)('jira_nav4_eap_drop_1') ? (0, $kLEEo.blockDraggingToIFrames)({
                element: splitter
            }) : (0, (0, parcelRequire("eGmKJ")).default), (0, $7gWdR.draggable)({
                element: splitter,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $akFFC.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $3C4FG.preventUnhandled).start();
                },
                getInitialData () {
                    (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                    return {
                        initialWidth: (0, (0, parcelRequire("fAx1P")).getPixelWidth)(panelRef.current)
                    };
                },
                onDragStart ({ source: source }) {
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    onResizeStart?.({
                        initialWidth: source.data.initialWidth
                    });
                },
                onDrag ({ location: location, source: source }) {
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, (0, parcelRequire("fAx1P")).getWidthFromDragLocation)({
                        initialWidth: source.data.initialWidth,
                        location: location,
                        direction: direction,
                        position: position
                    })}px, ${resizeBounds.max})`);
                },
                onDrop ({ source: source }) {
                    (0, $3C4FG.preventUnhandled).stop();
                    (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    const finalWidth = (0, (0, parcelRequire("fAx1P")).getPixelWidth)(panelRef.current);
                    onCompleteResize(finalWidth);
                    onResizeEnd?.({
                        initialWidth: source.data.initialWidth,
                        finalWidth: finalWidth
                    });
                    panelRef.current.style.removeProperty(resizingCssVar);
                }
            }));
        }, [
            onCompleteResize,
            onResizeStart,
            onResizeEnd,
            panelRef,
            resizingCssVar,
            panelWidth,
            resizeBounds,
            direction,
            position,
            isEnabled
        ]);
        if (!isEnabled) return null;
        return (0, $7nsd3.createPortal)($5uXOq.createElement("div", {
            "data-testid": testId ? `${testId}-container` : undefined,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f535d623adcb2c41$var$containerStyles.root,
                position === 'start' && $f535d623adcb2c41$var$containerStyles.positionStart,
                position === 'end' && $f535d623adcb2c41$var$containerStyles.positionEnd
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("5ILhZ")).default), {
            style: {
                outline: 'none'
            },
            ref: splitterRef,
            xcss: $f535d623adcb2c41$var$buttonStyles.grabArea,
            interactionName: interactionName,
            testId: testId
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f535d623adcb2c41$var$buttonStyles.content
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("jldZL")).default), null, label), $5uXOq.createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f535d623adcb2c41$var$lineStyles.root
            ])
        })))), portalRef.current);
    };
    const $f535d623adcb2c41$var$ClientOnly = ({ children: children })=>{
        const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setHasMounted(true);
        }, []);
        return $5uXOq.createElement((0, $5uXOq.Fragment), null, hasMounted ? children : null);
    };
    const $f535d623adcb2c41$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>$5uXOq.createElement($f535d623adcb2c41$var$ClientOnly, null, $5uXOq.createElement($f535d623adcb2c41$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            interactionName: interactionName,
            testId: testId
        }));
});
parcelRegister("4dYas", function(module, exports) {
    $parcel$export(module.exports, "blockDraggingToIFrames", ()=>(parcelRequire("kLEEo")).blockDraggingToIFrames);
    var $kLEEo = parcelRequire("kLEEo");
});
parcelRegister("kLEEo", function(module, exports) {
    $parcel$export(module.exports, "blockDraggingToIFrames", ()=>$85c97841a27447ca$export$6ae1d8fab001518c);
    var $40DDD = parcelRequire("40DDD");
    var $3zl3q = parcelRequire("3zl3q");
    function $85c97841a27447ca$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
        const originalValue = el.style.getPropertyValue(property);
        const originalPriority = el.style.getPropertyPriority(property);
        el.style.setProperty(property, rule, priority);
        return function cleanup() {
            el.style.setProperty(property, originalValue, originalPriority);
        };
    }
    let $85c97841a27447ca$var$isActive = false;
    function $85c97841a27447ca$var$tryStart() {
        if ($85c97841a27447ca$var$isActive) return;
        $85c97841a27447ca$var$isActive = true;
        const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$85c97841a27447ca$var$setStyle(iframe, {
                property: 'pointer-events',
                rule: 'none',
                priority: 'important'
            }));
        const cleanup = (0, $3zl3q.combine)(...iframeCleanups, (0, $40DDD.monitorForElements)({
            onDrop () {
                cleanup();
            }
        }), function release() {
            $85c97841a27447ca$var$isActive = false;
        });
    }
    function $85c97841a27447ca$export$6ae1d8fab001518c({ element: element }) {
        return (0, $40DDD.monitorForElements)({
            onGenerateDragPreview ({ source: source }) {
                if (source.element === element) $85c97841a27447ca$var$tryStart();
            }
        });
    }
});
parcelRegister("hjhoK", function(module, exports) {
    $parcel$export(module.exports, "disableNativeDragPreview", ()=>(parcelRequire("akFFC")).disableNativeDragPreview);
    var $akFFC = parcelRequire("akFFC");
});
parcelRegister("akFFC", function(module, exports) {
    $parcel$export(module.exports, "disableNativeDragPreview", ()=>$1774d76ee1100c7d$export$c588cb30ff3b876e);
    const $1774d76ee1100c7d$var$tinyTransparentImage = (()=>{
        if (typeof window === 'undefined') return null;
        const img = new Image();
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
        return img;
    })();
    function $1774d76ee1100c7d$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
        if (nativeSetDragImage && $1774d76ee1100c7d$var$tinyTransparentImage) nativeSetDragImage($1774d76ee1100c7d$var$tinyTransparentImage, 0, 0);
    }
});
parcelRegister("fmZmH", function(module, exports) {
    $parcel$export(module.exports, "preventUnhandled", ()=>(parcelRequire("3C4FG")).preventUnhandled);
    var $3C4FG = parcelRequire("3C4FG");
});
parcelRegister("3C4FG", function(module, exports) {
    $parcel$export(module.exports, "preventUnhandled", ()=>$bc1937186f99453b$export$453c0582481cc59d);
    var $cBeZP;
    var $h5V4I = parcelRequire("h5V4I");
    function $bc1937186f99453b$var$acceptDrop(event) {
        if (event.defaultPrevented) return;
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        event.preventDefault();
    }
    let $bc1937186f99453b$var$unbindEvents = null;
    function $bc1937186f99453b$var$start() {
        $bc1937186f99453b$var$cleanup();
        $bc1937186f99453b$var$unbindEvents = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'dragover',
                listener: $bc1937186f99453b$var$acceptDrop
            },
            {
                type: 'dragenter',
                listener: $bc1937186f99453b$var$acceptDrop
            },
            {
                type: 'drop',
                listener (event) {
                    event.preventDefault();
                    $bc1937186f99453b$var$cleanup();
                }
            },
            {
                type: 'dragend',
                listener: $bc1937186f99453b$var$cleanup
            },
            ...(0, $h5V4I.getBindingsForBrokenDrags)({
                onDragEnd: $bc1937186f99453b$var$cleanup
            })
        ], {
            capture: false
        });
    }
    function $bc1937186f99453b$var$cleanup() {
        $bc1937186f99453b$var$unbindEvents?.();
        $bc1937186f99453b$var$unbindEvents = null;
    }
    function $bc1937186f99453b$var$stop() {
        if (window.event?.type === 'drop') window.event?.preventDefault();
        $bc1937186f99453b$var$cleanup();
    }
    const $bc1937186f99453b$export$453c0582481cc59d = {
        start: $bc1937186f99453b$var$start,
        stop: $bc1937186f99453b$var$stop
    };
});
parcelRegister("fAx1P", function(module, exports) {
    $parcel$export(module.exports, "getWidthFromDragLocation", ()=>$e9a4e6873a340be1$export$e360234971cb95b8);
    $parcel$export(module.exports, "getPixelWidth", ()=>$e9a4e6873a340be1$export$d942790ad00c41f9);
    const $e9a4e6873a340be1$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
        const diffX = location.current.input.clientX - location.initial.input.clientX;
        if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
        return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
    };
    const $e9a4e6873a340be1$export$d942790ad00c41f9 = (element)=>{
        const { width: width } = window.getComputedStyle(element);
        return parseInt(width);
    };
});
parcelRegister("1ICwz", function(module, exports) {
    $parcel$export(module.exports, "useTextDirection", ()=>$19142174bc5bbe23$export$cf24a79f32f45545);
    var $5uXOq = parcelRequire("5uXOq");
    const $19142174bc5bbe23$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
            const { direction: direction } = window.getComputedStyle(element);
            return direction === 'rtl' ? 'rtl' : 'ltr';
        }, [
            element
        ]);
});
parcelRegister("lsO24", function(module, exports) {
    $parcel$export(module.exports, "SideNavFooter", ()=>$c6642da0d03c35b7$export$b773c4c9cf740fbe);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $c6642da0d03c35b7$var$styles = {
        root: "_1yt4utpp _7myae4h9 _1sw7nqa1 _qgnumuej"
    };
    const $c6642da0d03c35b7$export$b773c4c9cf740fbe = ({ children: children, xcss: xcss })=>{
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $c6642da0d03c35b7$var$styles.root,
                xcss
            ])
        }, children);
    };
});
parcelRegister("gxq4u", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$17a71abc75e8d96c$export$defe85febe8b728c);
    var $7VHMR;
    const $17a71abc75e8d96c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sidebarNavigation: {
            "id": "page-container-v2.common.sidebar.sidebar-navigation",
            "defaultMessage": "Sidebar navigation"
        },
        sideBarPanelSplitterLabel: {
            "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
            "defaultMessage": "Resize side navigation panel"
        }
    });
});
parcelRegister("7x18A", function(module, exports) {
    $parcel$export(module.exports, "AsyncResizeButtonTooltip", ()=>$15587b8ab3be3aba$export$e12f5b3a390577de);
    var $kxZPA;
    const $15587b8ab3be3aba$export$e12f5b3a390577de = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("gHSSC")), {
        ssr: false,
        moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
    });
});
parcelRegister("gHSSC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ikCLZ").then(()=>parcelRequire('iIrS6'));
});
parcelRegister("gxCm0", function(module, exports) {
    $parcel$export(module.exports, "TopNav", ()=>$5815562a2673ba2a$export$41d0d88a6b0e456f);
    var $5uXOq = parcelRequire("5uXOq");
    var $azzrO;
    var $5e7oM;
    var $Mp6qH;
    var $ghgbB;
    var $eoNiZ;
    var $e6AHy;
    var $44v1T;
    var $gwIPs;
    var $39xOx;
    var $93jKl;
    var $7XYc4;
    var $cSD7y;
    var $4R6GH;
    var $3bl6P;
    var $9aaiB;
    var $5X3WH;
    var $3HwlS;
    var $iqLcb;
    var $lfTZh;
    var $5M3R9;
    var $l8ruj;
    var $erBFB;
    var $dm0Uk;
    var $iIpJ6;
    const $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
    const $5815562a2673ba2a$var$LegacyPageNavigationStyles = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)}); } /* admin project dir hack */
                `
            }
        });
    const $5815562a2673ba2a$var$TEST_ID = 'page-layout.top-nav';
    function $5815562a2673ba2a$var$NewTopNavWithoutCustomTheming() {
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav4'
        });
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.topNav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            testId: $5815562a2673ba2a$var$TEST_ID
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainerV2",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null)))));
    }
    function $5815562a2673ba2a$var$NewTopNavWithCustomTheming() {
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        const theme = (0, (0, parcelRequire("eoNiZ")).useNav4Theme)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav4'
        });
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.topNav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            testId: $5815562a2673ba2a$var$TEST_ID,
            theme: theme
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainerV2",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null)))));
    }
    const $5815562a2673ba2a$var$NewTopNav = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_nav4_theming', $5815562a2673ba2a$var$NewTopNavWithCustomTheming, $5815562a2673ba2a$var$NewTopNavWithoutCustomTheming);
    const $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
    function $5815562a2673ba2a$var$OldTopNav() {
        const fullscreenRef = (0, $5uXOq.useRef)(null);
        const { isFullscreen: isFullscreen } = (0, (0, parcelRequire("3bl6P")).useIsFullscreen)(fullscreenRef.current);
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, (0, parcelRequire("Mp6qH")).EXPERIENCE_NAVIGATION_TOP_MAIN)
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav3'
        });
        const height = isFullscreen ? 0 : $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "top-navigation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dm0Uk")).ZIndexWrapper), {
            zIndex: (0, (0, parcelRequire("gwIPs")).layers).navigation,
            top: (0, (0, parcelRequire("iqLcb")).UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
            "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
            ref: fullscreenRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            height: height,
            id: "ak-jira-navigation"
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainer",
            fallback: "flag",
            onError: onFail
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).bundleLoadStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "start",
            traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
        }))))));
    }
    const $5815562a2673ba2a$export$41d0d88a6b0e456f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $5815562a2673ba2a$var$NewTopNav, $5815562a2673ba2a$var$OldTopNav);
});
parcelRegister("Mp6qH", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$d722fd8ef23adae6$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", ()=>$d722fd8ef23adae6$export$ea341e6cc435ed40);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", ()=>$d722fd8ef23adae6$export$cb66c02d110b1531);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", ()=>$d722fd8ef23adae6$export$22ea57e66775a6b2);
    $parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", ()=>$d722fd8ef23adae6$export$4766f0c4b6fe35dc);
    $parcel$export(module.exports, "NAVIGATION_ITEM_ID", ()=>$d722fd8ef23adae6$export$1a9b265c626e9d44);
    $parcel$export(module.exports, "MODAL_ID", ()=>$d722fd8ef23adae6$export$ebdd5a8e5b1c2de5);
    $parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$6037915bf3452cf3);
    $parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$286c2faa2103eb9c);
    $parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$c0d6ac131d4391b9);
    $parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$8d9442dfaec4086f);
    $parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", ()=>$d722fd8ef23adae6$export$3014c5ec440d8824);
    $parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", ()=>$d722fd8ef23adae6$export$69cbedccc0df48);
    $parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", ()=>$d722fd8ef23adae6$export$1935aad1d702494c);
    $parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", ()=>$d722fd8ef23adae6$export$cc578bc72d7a7308);
    const $d722fd8ef23adae6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
    const $d722fd8ef23adae6$export$ea341e6cc435ed40 = 15;
    const $d722fd8ef23adae6$export$8666f31c8873bff = 10;
    const $d722fd8ef23adae6$export$cb66c02d110b1531 = 10;
    const $d722fd8ef23adae6$export$22ea57e66775a6b2 = 5;
    const $d722fd8ef23adae6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
    const $d722fd8ef23adae6$export$1a9b265c626e9d44 = {
        ADDONS: 'apps',
        CREATE: 'createIssue',
        APP_SWITCHER: 'atlassianSwitcher',
        DASHBOARDS: 'dashboards',
        FILTERS: 'filters',
        HELP: 'help',
        HELP_BADGE: 'helpBadge',
        HOME: 'home',
        INSIGHT: 'insight',
        LOGO: 'productLogo',
        NOTIFICATIONS: 'notifications',
        PEOPLE: 'people',
        PLANS: 'plans',
        PROFILE: 'profile',
        PROJECTS: 'projects',
        ROADMAPS: 'roadmaps',
        SEARCH: 'search',
        SERVICE_HUB: 'services',
        SETTINGS: 'settings',
        SIGN_IN: 'signIn',
        YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
        CONVERSATION_ASSISTANT: 'conversationAssistant',
        ROVO_DEMAND_TESTS: 'rovoDemandTests'
    };
    const $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5 = {
        DASHBOARD_CREATE: 'DASHBOARD_CREATE',
        KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
        PROJECT_CREATE: 'PROJECT_CREATE'
    };
    const $d722fd8ef23adae6$export$6037915bf3452cf3 = 'profile-spotlight';
    const $d722fd8ef23adae6$export$286c2faa2103eb9c = 'help-spotlight';
    const $d722fd8ef23adae6$export$c0d6ac131d4391b9 = 'search-spotlight';
    const $d722fd8ef23adae6$export$8d9442dfaec4086f = 'projects-spotlight';
    const $d722fd8ef23adae6$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
    const $d722fd8ef23adae6$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
    const $d722fd8ef23adae6$export$1935aad1d702494c = {
        RECENT: 'RECENT',
        BOARDS: 'BOARDS',
        QUEUES: 'QUEUES',
        ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
        ADD_FILTER: 'ADD_FILTER',
        ALERTS: 'ALERTS'
    };
    const $d722fd8ef23adae6$export$bbaa49b5be375ff3 = 3;
    const $d722fd8ef23adae6$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
    const $d722fd8ef23adae6$export$9b8f5a607ecb9c5c = 'com.atlassian.jira.slack';
});
parcelRegister("ghgbB", function(module, exports) {
    $parcel$export(module.exports, "AtlassianNavigationStart", ()=>$d610646e169deef8$export$831e6a6e875b5ef8);
    var $5uXOq = parcelRequire("5uXOq");
    var $kaHBi;
    var $8CVvd;
    var $4oDnX;
    var $6IzHB;
    var $dIdda = parcelRequire("dIdda");
    var $Mp6qH;
    const $d610646e169deef8$export$831e6a6e875b5ef8 = ()=>{
        const [{ location: location }] = (0, $dIdda.useRouter)();
        const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, (0, parcelRequire("4oDnX")).useSpaStateActions)();
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        const startRef = (0, $5uXOq.useRef)({
            location: location,
            startTime: Date.now()
        });
        (0, $5uXOq.useMemo)(()=>{
            if (location !== startRef.current.location) startRef.current = {
                location: location,
                startTime: Date.now()
            };
        }, [
            location
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setAppStartWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82), startRef.current.startTime);
        }, [
            location,
            setAppStartWithAppId
        ]);
        return (0, (0, parcelRequire("8CVvd")).getWillShowNav3)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experience: (0, (0, parcelRequire("Mp6qH")).EXPERIENCE_NAVIGATION_TOP_MAIN),
            analyticsSource: "atlassian-navigation",
            experienceId: pageId
        });
    };
});
parcelRegister("eoNiZ", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$96d5309c36bfdfee$export$93d4e7f90805808f);
    $parcel$export(module.exports, "useNav4Theme", ()=>$96d5309c36bfdfee$export$b761e7abf0bdf352);
    var $5uXOq = parcelRequire("5uXOq");
    var $4sCvx;
    var $kTHGn;
    var $hxoiH;
    var $9MAC1;
    var $2Ql51;
    var $bt2pf;
    var $ihBhD;
    const $96d5309c36bfdfee$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
    const $96d5309c36bfdfee$var$calculateBackground = (backgroundColor, isDarkMode)=>{
        if ($96d5309c36bfdfee$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
            const fallback = isDarkMode ? '#1d2125' : '#ffffff';
            return (0, (0, parcelRequire("kTHGn")).default)('elevation.surface', fallback);
        }
        return isDarkMode ? (0, (0, parcelRequire("ihBhD")).capLightness)(backgroundColor, 35) : backgroundColor;
    };
    const $96d5309c36bfdfee$var$useIsDarkThemeResolver = ()=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const { theme: preference } = (0, (0, parcelRequire("2Ql51")).useThemePreference)();
        return false ? preference === 'dark' : colorMode === 'dark';
    };
    const $96d5309c36bfdfee$export$93d4e7f90805808f = ()=>{
        const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, (0, parcelRequire("9MAC1")).useTheme)();
        const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
        const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
            backgroundColor,
            isDarkMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("bt2pf")).addThemeColor)(bg);
        }, [
            bg
        ]);
        if (!usesCustomColours) return undefined;
        return (0, (0, parcelRequire("4sCvx")).generateTheme)({
            name: 'jira',
            backgroundColor: bg,
            highlightColor: highlightColor
        });
    };
    const $96d5309c36bfdfee$export$b761e7abf0bdf352 = ()=>{
        const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, (0, parcelRequire("9MAC1")).useTheme)();
        const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
        const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
            backgroundColor,
            isDarkMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("bt2pf")).addThemeColor)(bg);
        }, [
            bg
        ]);
        if (!usesCustomColours) return undefined;
        return {
            backgroundColor: bg,
            highlightColor: highlightColor
        };
    };
});
parcelRegister("bt2pf", function(module, exports) {
    $parcel$export(module.exports, "addThemeColor", ()=>$274a73c0f1d6297a$export$7b20d133831b2b0f);
    const $274a73c0f1d6297a$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
    const $274a73c0f1d6297a$var$getHead = ()=>document.head || document.querySelector('head');
    const $274a73c0f1d6297a$export$7b20d133831b2b0f = (content)=>{
        if (!content || typeof document === 'undefined' || false) return;
        const existingMeta = $274a73c0f1d6297a$var$getMetaNode('theme-color');
        const meta = document.createElement('meta');
        meta.name = 'theme-color';
        meta.content = content;
        if (existingMeta) existingMeta.replaceWith?.(meta);
        else {
            const head = $274a73c0f1d6297a$var$getHead();
            if (head) head.appendChild?.(meta);
        }
    };
});
parcelRegister("ihBhD", function(module, exports) {
    $parcel$export(module.exports, "capLightness", ()=>$dbd7508aaed6851f$export$8b5544bab97b10dd);
    const $dbd7508aaed6851f$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
    const $dbd7508aaed6851f$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
    const $dbd7508aaed6851f$var$rgbFromHex = (input)=>{
        const fullHex = $dbd7508aaed6851f$var$expandShorthandHex(input);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result === null ? null : {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    };
    const $dbd7508aaed6851f$var$rgbToHex = ({ r: r, g: g, b: b })=>{
        const convertComponent = (c)=>{
            const cBase16 = c.toString(16);
            return cBase16.length === 1 ? `0${cBase16}` : cBase16;
        };
        return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
    };
    const $dbd7508aaed6851f$var$rgbToXyz = (rgb)=>{
        const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
        const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
        const r = convertRgbComponent(rgb.r / 255);
        const g = convertRgbComponent(rgb.g / 255);
        const b = convertRgbComponent(rgb.b / 255);
        return {
            x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
            y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
            z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
        };
    };
    const $dbd7508aaed6851f$var$xyzToLab = ({ x: x, y: y, z: z })=>({
            l: Math.max(116 * y - 16, 0),
            a: 500 * (x - y),
            b: 200 * (y - z)
        });
    const $dbd7508aaed6851f$var$labToLch = ({ l: l, a: a, b: b })=>{
        let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
        const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
        if (Math.round(c * 10000) === 0) h = Number.NaN;
        return {
            l: l,
            c: c,
            h: h
        };
    };
    const $dbd7508aaed6851f$var$lchToLab = ({ l: l, c: c, h: h })=>{
        const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
        return {
            l: l,
            a: Math.cos(convertH) * c,
            b: Math.sin(convertH) * c
        };
    };
    const $dbd7508aaed6851f$var$labToXyz = ({ l: l, a: a, b: b })=>{
        const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
        const y = (l + 16) / 116;
        const x = a / 500 + y;
        const z = y - b / 200;
        return {
            x: convertComponent(x) * 0.95047,
            y: convertComponent(y),
            z: convertComponent(z) * 1.08883
        };
    };
    const $dbd7508aaed6851f$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
        const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
        return {
            r: $dbd7508aaed6851f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
            g: $dbd7508aaed6851f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
            b: $dbd7508aaed6851f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
        };
    };
    const $dbd7508aaed6851f$var$rgbToLch = (rgb)=>$dbd7508aaed6851f$var$labToLch($dbd7508aaed6851f$var$xyzToLab($dbd7508aaed6851f$var$rgbToXyz(rgb)));
    const $dbd7508aaed6851f$var$lchToRgb = (lch)=>$dbd7508aaed6851f$var$xyzToRgb($dbd7508aaed6851f$var$labToXyz($dbd7508aaed6851f$var$lchToLab(lch)));
    const $dbd7508aaed6851f$export$8b5544bab97b10dd = (color, capPercent)=>{
        const rgb = $dbd7508aaed6851f$var$rgbFromHex(color);
        if (rgb === null) return color;
        const lch = $dbd7508aaed6851f$var$rgbToLch(rgb);
        if (lch.l > capPercent) lch.l = $dbd7508aaed6851f$var$clamp(capPercent, 0, 100);
        return $dbd7508aaed6851f$var$rgbToHex($dbd7508aaed6851f$var$lchToRgb(lch));
    };
});
parcelRegister("e6AHy", function(module, exports) {
    $parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", ()=>$33751c6bf425b3ee$export$38e532bc6b824200);
    var $5uXOq = parcelRequire("5uXOq");
    var $f76p2;
    var $fNobW;
    var $eoNiZ;
    const $33751c6bf425b3ee$export$38e532bc6b824200 = ()=>{
        const theme = (0, (0, parcelRequire("eoNiZ")).useTheme)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "top-navigation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f76p2")).NavigationSkeleton), {
            theme: theme
        }));
    };
});
parcelRegister("f76p2", function(module, exports) {
    $parcel$export(module.exports, "NavigationSkeleton", ()=>$98921b5eaee337e6$export$ad5e8e6ace98cc2);
    var $f8Sb3;
    var $k2eCO;
    var $hBZh1;
    var $1Gcgr;
    var $29HUs;
    var $PCCxV;
    var $6tzyR;
    var $2yEsI;
    function $98921b5eaee337e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $98921b5eaee337e6$var$containerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        height: (0, $8acc83d90e579622$export$30fa7cc5f2690a43),
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
        paddingInlineEnd: "var(--ds-space-150, 12px)",
        paddingInlineStart: "var(--ds-space-150, 12px)"
    });
    const $98921b5eaee337e6$var$leftStyles = {
        name: "vtikxo",
        styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
    };
    const $98921b5eaee337e6$var$rightStyles = {
        name: "1mwlrd6",
        styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
    };
    const $98921b5eaee337e6$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, (0, parcelRequire("k2eCO")).defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hBZh1")).ThemeProvider), {
            value: theme
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.navigation,
            css: $98921b5eaee337e6$var$containerStyles,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $98921b5eaee337e6$var$leftStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Gcgr")).IconButtonSkeleton), {
            marginLeft: 0,
            marginRight: 5,
            size: 26
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("PCCxV")).ProductHomeSkeleton), {
            showSiteName: showSiteName
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("29HUs")).PrimaryItemsContainerSkeleton), {
            count: primaryItemsCount
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $98921b5eaee337e6$var$rightStyles
        }, shouldShowSearch && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2yEsI")).SearchSkeleton), null), Array.from({
            length: secondaryItemsCount
        }, (_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Gcgr")).IconButtonSkeleton), {
                key: index,
                marginLeft: 0,
                marginRight: 4,
                size: 26
            })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6tzyR")).ProfileSkeleton), null))));
    };
    var $98921b5eaee337e6$export$2e2bcd8739ae039 = $98921b5eaee337e6$export$ad5e8e6ace98cc2;
});
const $8acc83d90e579622$export$30fa7cc5f2690a43 = 56;
const $8acc83d90e579622$export$4033a111ca79977d = 1280;
const $8acc83d90e579622$export$24ec62cee78b7042 = 1130;
const $8acc83d90e579622$export$d8bde68ac946124f = '--ds--ans--fbc';
const $8acc83d90e579622$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $8acc83d90e579622$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $8acc83d90e579622$export$d81606c1fc5119bc = '--ds--ans--c';
const $8acc83d90e579622$export$65f656ad520ea71 = '--ds--ans--bc';
parcelRegister("1Gcgr", function(module, exports) {
    $parcel$export(module.exports, "IconButtonSkeleton", ()=>$6478e2d976c97e7a$export$7a24471cb6f25433);
    var $f8Sb3;
    var $gKAEK;
    function $6478e2d976c97e7a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6478e2d976c97e7a$var$buttonHeight = "var(--ds-space-400, 32px)";
    const $6478e2d976c97e7a$var$skeletonStyles = {
        name: "28gj0e",
        styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
    };
    const $6478e2d976c97e7a$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const dynamicStyles = {
            marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
            marginRight: typeof marginRight === 'number' ? marginRight : 0,
            width: typeof size === 'number' ? size : $6478e2d976c97e7a$var$buttonHeight,
            height: typeof size === 'number' ? size : $6478e2d976c97e7a$var$buttonHeight,
            ...theme.mode.skeleton
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: dynamicStyles,
            css: $6478e2d976c97e7a$var$skeletonStyles
        });
    };
});
parcelRegister("29HUs", function(module, exports) {
    $parcel$export(module.exports, "PrimaryItemsContainerSkeleton", ()=>$72ae9b7bbf3d0bc1$export$fdfc48d2117b79a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $bWIvF;
    function $72ae9b7bbf3d0bc1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $72ae9b7bbf3d0bc1$var$primaryButtonSkeletonStyles = {
        name: "yn5kop",
        styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
    };
    const $72ae9b7bbf3d0bc1$export$fdfc48d2117b79a8 = (0, $5uXOq.memo)(({ count: count })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, Array.from({
            length: count
        }, (_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bWIvF")).PrimaryButtonSkeleton), {
                key: index,
                css: $72ae9b7bbf3d0bc1$var$primaryButtonSkeletonStyles
            }))));
});
parcelRegister("bWIvF", function(module, exports) {
    $parcel$export(module.exports, "PrimaryButtonSkeleton", ()=>$4262bf91a1b82d55$export$4bc51fe36728414d);
    var $f8Sb3;
    var $gKAEK;
    const $4262bf91a1b82d55$var$paddingAll = 4;
    const $4262bf91a1b82d55$var$buttonHeight = 32;
    const $4262bf91a1b82d55$var$skeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        width: '68px',
        height: `${$4262bf91a1b82d55$var$buttonHeight - $4262bf91a1b82d55$var$paddingAll * 2.5}px`,
        borderRadius: "var(--ds-border-radius, 4px)",
        opacity: 0.15
    });
    const $4262bf91a1b82d55$export$4bc51fe36728414d = (props)=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $4262bf91a1b82d55$var$skeletonStyles,
            className: props.className
        });
    };
});
parcelRegister("PCCxV", function(module, exports) {
    $parcel$export(module.exports, "ProductHomeSkeleton", ()=>$10d6b00c8313b481$export$3e79e535d76cce4b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKAEK;
    var $3mMDm;
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
    const $10d6b00c8313b481$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
    const $10d6b00c8313b481$var$productHomeButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        background: 'none',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: 'inherit',
        cursor: 'pointer',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:first-of-type': {
            marginInlineStart: 0
        },
        '&:active': {
            backgroundColor: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
            boxShadow: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
            color: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
        },
        '&:focus': {
            backgroundColor: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
            boxShadow: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
            color: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
            outline: 0
        },
        '&:hover': {
            backgroundColor: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
            boxShadow: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
            color: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
        },
        'div&': {
            pointerEvents: 'none'
        },
        [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
            margin: `0 ${"var(--ds-space-100, 8px)"}`
        },
        [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $10d6b00c8313b481$var$productLogoStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: 120,
        maxWidth: 120,
        height: 24,
        maxHeight: 28,
        opacity: 0.15,
        '& > *': {
            maxHeight: 24
        },
        [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $10d6b00c8313b481$var$productIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: 28,
        height: 28,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        opacity: 0.15,
        '& > *': {
            maxHeight: 24
        },
        [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
            display: 'none'
        }
    });
    const $10d6b00c8313b481$var$siteTitleStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: "var(--ds-space-500, 40px)",
        alignItems: 'center',
        backgroundColor: 'transparent',
        marginInlineEnd: "var(--ds-space-050, 4px)",
        marginInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-200, 16px)",
        '&:after': {
            width: '100%',
            height: 14,
            backgroundColor: `var(${$10d6b00c8313b481$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
            borderRadius: "var(--ds-border-radius, 4px)",
            content: '""'
        }
    });
    const $10d6b00c8313b481$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const productHomeButtonDynamicStyles = (0, (0, parcelRequire("3mMDm")).stripEmptyProperties)({
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
            [$10d6b00c8313b481$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
        });
        const siteTitleDynamicStyles = {
            borderRight: theme.mode.productHome.borderRight,
            opacity: theme.mode.skeleton.opacity,
            [$10d6b00c8313b481$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: productHomeButtonDynamicStyles,
            css: $10d6b00c8313b481$var$productHomeButtonStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $10d6b00c8313b481$var$productLogoStyles
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $10d6b00c8313b481$var$productIconStyles
        })), showSiteName && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: siteTitleDynamicStyles,
            css: $10d6b00c8313b481$var$siteTitleStyles
        }));
    };
});
parcelRegister("6tzyR", function(module, exports) {
    $parcel$export(module.exports, "ProfileSkeleton", ()=>$46f0e835bedc74f2$export$2bab43fd33adda3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Gcgr;
    const $46f0e835bedc74f2$export$2bab43fd33adda3b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Gcgr")).IconButtonSkeleton), {
            marginLeft: 6,
            marginRight: 6,
            size: 26
        });
});
parcelRegister("2yEsI", function(module, exports) {
    $parcel$export(module.exports, "SearchSkeleton", ()=>$07e305720ddebdad$export$d8fbade3e5bbb8e0);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKAEK;
    var $1Gcgr;
    const $07e305720ddebdad$var$searchInputContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginRight: "var(--ds-space-100, 8px)",
        marginLeft: "var(--ds-space-250, 20px)",
        position: 'relative',
        [`@media (max-width: ${(0, $8acc83d90e579622$export$24ec62cee78b7042) - 1}px)`]: {
            display: 'none !important'
        }
    });
    const $07e305720ddebdad$var$searchInputSkeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        width: '220px',
        height: "var(--ds-space-400, 32px)",
        padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
        borderRadius: "var(--ds-border-radius-200, 6px)",
        opacity: 0.15
    });
    const $07e305720ddebdad$var$searchIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [`@media (min-width: ${0, $8acc83d90e579622$export$24ec62cee78b7042}px)`]: {
            display: 'none !important'
        }
    });
    const $07e305720ddebdad$export$d8fbade3e5bbb8e0 = ()=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $07e305720ddebdad$var$searchInputContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $07e305720ddebdad$var$searchInputSkeletonStyles
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Gcgr")).IconButtonSkeleton), {
            css: $07e305720ddebdad$var$searchIconStyles,
            marginRight: 5,
            size: 26
        }));
    };
});
parcelRegister("3bl6P", function(module, exports) {
    $parcel$export(module.exports, "useIsFullscreen", ()=>$0124d1f81a2437a4$export$d397eccea5f37b0a);
    var $5uXOq = parcelRequire("5uXOq");
    const $0124d1f81a2437a4$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
    const $0124d1f81a2437a4$export$d397eccea5f37b0a = (target)=>{
        const [isFullscreen, setIsFullscreen] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const handleFullscreen = ()=>{
                setIsFullscreen($0124d1f81a2437a4$var$fullscreenClassnameExists(target));
            };
            const mutationObserver = new MutationObserver(handleFullscreen);
            if (target) mutationObserver.observe(target, {
                attributes: true
            });
            return ()=>mutationObserver.disconnect();
        }, [
            target
        ]);
        return {
            isFullscreen: isFullscreen
        };
    };
});
parcelRegister("9aaiB", function(module, exports) {
    $parcel$export(module.exports, "useTopNavState", ()=>$dd484d7e2bde5991$export$bccbd45ab793bd09);
    var $7JoAD = parcelRequire("7JoAD");
    var $5e5zm;
    const $dd484d7e2bde5991$var$useTopNav = (0, $7JoAD.createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>({
                ...state.topNavigation,
                shouldRender: !state.isChromeless
            })
    });
    const $dd484d7e2bde5991$export$bccbd45ab793bd09 = ()=>{
        const [state] = $dd484d7e2bde5991$var$useTopNav();
        return state;
    };
});
parcelRegister("5X3WH", function(module, exports) {
    $parcel$export(module.exports, "sendNavExposure", ()=>$f4ce7b379b641f97$export$4d75b96ec704d87d);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fjcgS;
    const $f4ce7b379b641f97$export$4d75b96ec704d87d = (0, ($parcel$interopDefault($gJBT6)))($f4ce7b379b641f97$var$_sendNavExposure, (p)=>p.componentName);
    function $f4ce7b379b641f97$var$_sendNavExposure(params) {
        const { componentName: componentName } = params;
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.getInstance().sendTrackEvent({
                actionSubject: componentName,
                action: 'viewed',
                source: 'navExposure',
                attributes: {}
            });
        });
        return componentName;
    }
});
parcelRegister("iIpJ6", function(module, exports) {
    $parcel$export(module.exports, "AsyncAtlassianNavigation", ()=>$8c4a7263d22ebdbf$export$932edb7b1b20d079);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $adY3A;
    var $ffza4;
    var $e6AHy;
    var $fDtbf;
    var $2Ioew;
    var $frBVt;
    var $6jY6G;
    var $2SVPM;
    const $8c4a7263d22ebdbf$export$932edb7b1b20d079 = ()=>{
        const isUsingEntryPoint = Boolean((0, (0, parcelRequire("6jY6G")).useCurrentRoute)().entryPoint?.());
        const topNavEntryPointReference = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
        (0, $5uXOq.useState)(()=>{
            if (!false && isUsingEntryPoint) (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint).root.onComplete(()=>{
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
                const resources = performance.getEntriesByType('mark');
                for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                    (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                    break;
                }
            });
            return undefined;
        });
        return isUsingEntryPoint ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null),
            entryPoint: (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint)
        }, topNavEntryPointReference ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: topNavEntryPointReference,
            props: {}
        }) : null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation), null);
    };
});
parcelRegister("lvpKt", function(module, exports) {
    $parcel$export(module.exports, "FullHeight", ()=>$c63a700e8bea75a2$export$33e617ec5e4e4f76);
    var $5uXOq = parcelRequire("5uXOq");
    const $c63a700e8bea75a2$var$styleFullHeight = {
        height: '100vh'
    };
    const $c63a700e8bea75a2$export$33e617ec5e4e4f76 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: $c63a700e8bea75a2$var$styleFullHeight
        }, children);
});
parcelRegister("8Ceqd", function(module, exports) {
    $parcel$export(module.exports, "ThemeSetter", ()=>$5b61f4226ddd6087$export$ce1303eaa27a0d3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7TUFF;
    var $hxoiH;
    var $fjcgS;
    var $dZJHS;
    var $2Ql51;
    var $dIdda = parcelRequire("dIdda");
    const $5b61f4226ddd6087$var$darkThemeMediaMatchQuery = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    const $5b61f4226ddd6087$var$GlobalThemeSetter = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("2Ql51")).themePreferenceResource));
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $5uXOq.useState)(false);
        const setThemeWithToken = (0, $5uXOq.useCallback)(async (theme)=>{
            if (theme !== colorMode) {
                const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("hxMHI"));
                loadThemeTokens(theme);
            }
        }, [
            colorMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loading || error || !data) return undefined;
            if (data?.theme === 'auto') {
                setThemeWithToken($5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
                const handler = (e)=>{
                    setThemeWithToken(e.matches ? 'dark' : 'light');
                };
                $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
                return ()=>{
                    $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
                };
            }
            if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
            if (!data?.theme) {
                document.documentElement.removeAttribute('data-theme');
                document.documentElement.removeAttribute('data-color-mode');
            }
            return undefined;
        }, [
            data,
            loading,
            error,
            setThemeWithToken
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loading || error || !data) return;
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                if (data?.theme) client.setUIViewedAttributes({
                    theme: data.theme
                });
                else client.removeUIViewedAttribute('theme');
            });
        }, [
            data,
            loading,
            error
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                client.setUIViewedAttributes({
                    OStheme: $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
                });
            });
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
        }, []);
        if (!data?.theme || !data?.attrs || !data?.styles) return null;
        const ssrAutoScript = (0, (0, parcelRequire("7TUFF")).default)(data.theme);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
                key: theme.id,
                ...theme.attrs,
                dangerouslySetInnerHTML: {
                    __html: theme.css
                }
            })) : null, (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: Object.entries(data.attrs).map(([key, val])=>{
                    if (key === 'data-color-mode' && ssrAutoScript) return '';
                    return `document.documentElement.setAttribute("${key}", "${val}");`;
                }).join('\n')
            }
        }), ssrAutoScript ? (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: ssrAutoScript
            }
        }) : null);
    };
    const $5b61f4226ddd6087$export$ce1303eaa27a0d3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5b61f4226ddd6087$var$GlobalThemeSetter, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZJHS")).ThemeSetter), null));
});
parcelRegister("7TUFF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$359254c929f8c357$export$2e2bcd8739ae039);
    var $VSDnB;
    var $f8twK;
    var $caSeK;
    const $359254c929f8c357$var$getSSRAutoScript = (colorMode, contrastMode)=>{
        if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
        const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, (0, parcelRequire("caSeK")).darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, (0, parcelRequire("f8twK")).COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
        const setContrastMode = contrastMode === 'auto' && (0, (0, parcelRequire("VSDnB")).fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, (0, parcelRequire("caSeK")).moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, (0, parcelRequire("f8twK")).CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
        return `(() => {${setColorMode}${setContrastMode}})()`;
    };
    var $359254c929f8c357$export$2e2bcd8739ae039 = $359254c929f8c357$var$getSSRAutoScript;
});
parcelRegister("dZJHS", function(module, exports) {
    $parcel$export(module.exports, "ThemeSetter", ()=>$724d37049e8e9e6c$export$ce1303eaa27a0d3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7eveN;
    var $ceKVk;
    var $65Ltd;
    var $3HwlS;
    var $6jY6G;
    var $dC4s3;
    var $1MaBz;
    const $724d37049e8e9e6c$export$ce1303eaa27a0d3a = ()=>{
        const projectTheme = (0, (0, parcelRequire("ceKVk")).useProjectTheme)();
        const overviewTheme = (0, (0, parcelRequire("7eveN")).useOverviewTheme)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entityTheme = (0, $5uXOq.useMemo)(()=>{
            let result = projectTheme ?? overviewTheme;
            if (result != null) {
                const isFormSubmitView = route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT) || route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED);
                if (isFormSubmitView) result = {
                    ...result,
                    themeSetting: null
                };
            }
            return result;
        }, [
            projectTheme,
            overviewTheme,
            route.name
        ]);
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1MaBz")).ThemeContainer), {
            isGlobal: true,
            entityTheme: entityTheme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC4s3")).ThemeTokensSetter), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, entityTheme != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1MaBz")).ThemeContainerOld), {
            isGlobal: true,
            ...entityTheme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC4s3")).ThemeTokensSetter), null));
    };
});
parcelRegister("7eveN", function(module, exports) {
    $parcel$export(module.exports, "useOverviewTheme", ()=>$c0a2b1dfc34915dc$export$a55763fd17eab357);
    var $6cG4N;
    var $jrO9m;
    const $c0a2b1dfc34915dc$export$a55763fd17eab357 = ()=>{
        const { data: data } = (0, (0, parcelRequire("jrO9m")).useOverview)();
        if (data != null) return {
            themeSetting: {
                type: 'color',
                value: data.theme ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
            },
            entityId: `overview/${data.id}`
        };
        return null;
    };
});
parcelRegister("ceKVk", function(module, exports) {
    $parcel$export(module.exports, "useProjectTheme", ()=>$f0c1f93a3181b765$export$18084206b9430153);
    var $5uXOq = parcelRequire("5uXOq");
    var $6cG4N;
    var $l2N2a;
    var $dIdda = parcelRequire("dIdda");
    const $f0c1f93a3181b765$export$18084206b9430153 = ()=>{
        const { data: data } = (0, $dIdda.useResource)((0, (0, parcelRequire("l2N2a")).projectDetailsResource));
        return (0, $5uXOq.useMemo)(()=>{
            if (data != null) {
                const entityId = `project/${data.currentProject?.id}`;
                const themeSetting = data.themeSetting ?? {
                    type: 'color',
                    value: (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
                };
                return {
                    themeSetting: themeSetting,
                    entityId: entityId
                };
            }
            return null;
        }, [
            data
        ]);
    };
});
parcelRegister("dC4s3", function(module, exports) {
    $parcel$export(module.exports, "ThemeTokensSetter", ()=>$5026069bddf1adf4$export$41f41c7ff10d45cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $gwIPs;
    var $6cG4N;
    var $fHEdP;
    var $4R6GH;
    var $3HwlS;
    var $1MaBz;
    var $1r9V3;
    function $5026069bddf1adf4$var$mergeThemes(theme, ...partialThemes) {
        return (0, ($parcel$interopDefault($1UikQ)))({}, theme, ...partialThemes);
    }
    const $5026069bddf1adf4$var$buildHorizontalNavVariables = (theme)=>{
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return `${0, $5b25b2eb4e8be764$export$539c074adec2188a}: ${theme['color.link']};
${0, $5b25b2eb4e8be764$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $5b25b2eb4e8be764$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $5b25b2eb4e8be764$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $5b25b2eb4e8be764$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $5b25b2eb4e8be764$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $5b25b2eb4e8be764$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $5b25b2eb4e8be764$export$4cd72d361867c565}: ${theme['color.border']};
${0, $5b25b2eb4e8be764$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
        return '';
    };
    const $5026069bddf1adf4$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode)=>{
        const applicationColorMode = isDarkMode ? 'dark' : 'light';
        const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, (0, parcelRequire("6cG4N")).HIGH_BRIGHTNESS_THEME) : (0, (0, parcelRequire("6cG4N")).LOW_BRIGHTNESS_THEME);
        const isImageConfig = config.name === 'image';
        const isGradientConfig = (0, (0, parcelRequire("fHEdP")).themeManager).isGradientTheme(config.name);
        const theme = $5026069bddf1adf4$var$mergeThemes((0, (0, parcelRequire("6cG4N")).BASE_THEME), isImageConfig ? {} : brightnessOverrides, isGradientConfig ? (0, (0, parcelRequire("6cG4N")).GRADIENT_THEME) : {}, config.theme[applicationColorMode]);
        let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
        if (backgroundImageUrl) elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
        else if (applicationColorMode === 'dark') {
            if ((0, (0, parcelRequire("6cG4N")).NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig) elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #1D2125)"} 400px)`;
        }
        const withWrapper = config.name !== (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name;
        const wrapperBackground = withWrapper ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'unset';
        const wrapperBorderRadius = withWrapper ? `${0, (0, parcelRequire("gwIPs")).gridSize}px` : '0';
        const isNav4 = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const businessWrapperWithBackgroundHeight = isNav4 ? (0, (0, parcelRequire("4R6GH")).fg)('horizontal_navigation_increase_tab_height') ? (0, (0, parcelRequire("6cG4N")).NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, (0, parcelRequire("6cG4N")).NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
        const businessWrapperHeight = isNav4 ? (0, (0, parcelRequire("4R6GH")).fg)('horizontal_navigation_increase_tab_height') ? (0, (0, parcelRequire("6cG4N")).NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT) : (0, (0, parcelRequire("6cG4N")).NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_HEIGHT);
        const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
        const wrapperPadding = withWrapper ? `${0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_PADDING}px` : '0';
        const wrapperWidth = withWrapper ? (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WIDTH);
        return `
${(0, (0, parcelRequire("6cG4N")).Variables).BACKDROP_FILTER}: ${isImageConfig ? 'blur(8px)' : 'none'};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ELEVATION_SURFACE}: ${theme['color.elevation.surface']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_LINK}: ${theme['color.link']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, (0, parcelRequire("6cG4N")).Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, (0, parcelRequire("6cG4N")).Variables).CONTENT_WIDTH}: ${0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WIDTH};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$5026069bddf1adf4$var$buildHorizontalNavVariables(theme)}`;
    };
    const $5026069bddf1adf4$export$41f41c7ff10d45cd = (0, $5uXOq.memo)(()=>{
        const [{ themeSetting: themeSetting }] = (0, (0, parcelRequire("1MaBz")).useThemeHook)();
        const backgroundConfig = (0, (0, parcelRequire("fHEdP")).themeManager).get({
            themeSetting: themeSetting,
            enableImages: true
        });
        const backgroundImageUrl = (0, (0, parcelRequire("1r9V3")).useBackgroundImageUrl)(themeSetting);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `:root{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false)} }
        [data-color-mode=dark]{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true)} }`
            }
        }));
    });
});
parcelRegister("fHEdP", function(module, exports) {
    $parcel$export(module.exports, "themeManager", ()=>$a34e148e1f33a06a$export$aba92a7f3273f617);
    $parcel$export(module.exports, "generateMediaImageUrl", ()=>$a34e148e1f33a06a$export$fe2402bbc6ac3125);
    var $6cG4N;
    class $a34e148e1f33a06a$var$ThemeManager {
        init() {
            (0, (0, parcelRequire("6cG4N")).GRADIENT_BACKGROUND_CONFIGS).forEach((theme)=>{
                this.gradients.set(theme.name, theme);
                this.gradientNames.add(theme.name);
            });
            (0, (0, parcelRequire("6cG4N")).SOLID_COLOR_BACKGROUND_CONFIGS).forEach((theme)=>{
                this.colors.set(theme.name, theme);
                this.colorNames.add(theme.name);
            });
            (0, (0, parcelRequire("6cG4N")).BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
                this.oldColorNames.add(theme.name);
            });
        }
        isColorTheme(themeName) {
            return this.colorNames.has(themeName);
        }
        isOldColorTheme(themeName) {
            return this.oldColorNames.has(themeName);
        }
        isGradientTheme(themeName) {
            return this.gradientNames.has(themeName);
        }
        isImageTheme(themeSetting) {
            return themeSetting.type === 'image';
        }
        getGradient(themeName) {
            return this.gradients.get(themeName);
        }
        getColor(themeName) {
            return this.colors.get(themeName);
        }
        get({ themeSetting: themeSetting, enableImages: enableImages }) {
            if (!themeSetting) return 0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG;
            if (enableImages && themeSetting.type === 'image') return 0, (0, parcelRequire("6cG4N")).IMAGE_BACKGROUND_CONFIG;
            if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG);
            if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG);
            return ((0, (0, parcelRequire("6cG4N")).OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG));
        }
        constructor(){
            this.gradients = new Map();
            this.gradientNames = new Set();
            this.colors = new Map();
            this.colorNames = new Set();
            this.oldColorNames = new Set();
            this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
        }
    }
    const $a34e148e1f33a06a$export$aba92a7f3273f617 = new $a34e148e1f33a06a$var$ThemeManager();
    $a34e148e1f33a06a$export$aba92a7f3273f617.init();
    function $a34e148e1f33a06a$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
        const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
        url.searchParams.append('client', mediaClientId);
        Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
        return url.toString();
    }
});
parcelRegister("1MaBz", function(module, exports) {
    $parcel$export(module.exports, "ThemeContainerOld", ()=>$5ffb1b62a0c37aa6$export$c6e50a832af54243);
    $parcel$export(module.exports, "ThemeContainer", ()=>$5ffb1b62a0c37aa6$export$11eb671888ed6e7d);
    $parcel$export(module.exports, "useThemeHook", ()=>$5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb);
    $parcel$export(module.exports, "useThemeSetting", ()=>$5ffb1b62a0c37aa6$export$87d26f94ea053d38);
    $parcel$export(module.exports, "useSelectedThemeSetting", ()=>$5ffb1b62a0c37aa6$export$4ba6f9d407e18961);
    var $ajpes = parcelRequire("ajpes");
    var $fHEdP;
    var $7JoAD = parcelRequire("7JoAD");
    const $5ffb1b62a0c37aa6$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
            const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
            if ((0, (0, parcelRequire("fHEdP")).themeManager).isValidTheme(newTheme) && !(0, ($parcel$interopDefault($ajpes)))(themeSetting?.value, newTheme?.value)) setState({
                entityId: entityId,
                selectedThemeSetting: selectedThemeSetting,
                themeSetting: newTheme
            });
        };
    const $5ffb1b62a0c37aa6$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
            const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
            if (newTheme === null || (0, (0, parcelRequire("fHEdP")).themeManager).isValidTheme(newTheme) && !(0, ($parcel$interopDefault($ajpes)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
                entityId: entityId,
                themeSetting: themeSetting,
                selectedThemeSetting: newTheme
            });
        };
    const $5ffb1b62a0c37aa6$var$actions = {
        setTheme: $5ffb1b62a0c37aa6$var$setTheme,
        setSelectedThemeSetting: $5ffb1b62a0c37aa6$var$setSelectedThemeSetting
    };
    const $5ffb1b62a0c37aa6$var$initialState = {
        themeSetting: null,
        selectedThemeSetting: null,
        entityId: ''
    };
    const $5ffb1b62a0c37aa6$var$Store = (0, $7JoAD.createStore)({
        initialState: $5ffb1b62a0c37aa6$var$initialState,
        actions: $5ffb1b62a0c37aa6$var$actions,
        name: 'ProjectTheme'
    });
    const $5ffb1b62a0c37aa6$export$c6e50a832af54243 = (0, $7JoAD.createContainer)($5ffb1b62a0c37aa6$var$Store, {
        onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
        onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
    });
    const $5ffb1b62a0c37aa6$export$11eb671888ed6e7d = (0, $7JoAD.createContainer)($5ffb1b62a0c37aa6$var$Store, {
        onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
                setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
            },
        onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
                setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
            }
    });
    const $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb = (0, $7JoAD.createHook)($5ffb1b62a0c37aa6$var$Store);
    const $5ffb1b62a0c37aa6$var$getThemeSetting = (0, $7JoAD.createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
    const $5ffb1b62a0c37aa6$export$87d26f94ea053d38 = (0, $7JoAD.createHook)($5ffb1b62a0c37aa6$var$Store, {
        selector: $5ffb1b62a0c37aa6$var$getThemeSetting
    });
    const $5ffb1b62a0c37aa6$var$getSelectedThemeSetting = (0, $7JoAD.createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
    const $5ffb1b62a0c37aa6$export$4ba6f9d407e18961 = (0, $7JoAD.createHook)($5ffb1b62a0c37aa6$var$Store, {
        selector: $5ffb1b62a0c37aa6$var$getSelectedThemeSetting
    });
});
const $5b25b2eb4e8be764$export$d1b9ea3245b6a5de = 2;
const $5b25b2eb4e8be764$export$7f37240649d2a1e2 = 36;
const $5b25b2eb4e8be764$export$d07bba395c9390f1 = 56;
const $5b25b2eb4e8be764$export$29911ec08ab2ca2d = 5;
const $5b25b2eb4e8be764$export$b61e6f89a9db76de = 12;
const $5b25b2eb4e8be764$export$7fd2e391116c6ef5 = 9;
const $5b25b2eb4e8be764$export$e1633e494d305bfb = 'MORE';
const $5b25b2eb4e8be764$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $5b25b2eb4e8be764$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $5b25b2eb4e8be764$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $5b25b2eb4e8be764$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $5b25b2eb4e8be764$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $5b25b2eb4e8be764$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $5b25b2eb4e8be764$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $5b25b2eb4e8be764$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $5b25b2eb4e8be764$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $5b25b2eb4e8be764$export$cf26c31143daa350 = '--hn-yjlbv';
parcelRegister("1r9V3", function(module, exports) {
    $parcel$export(module.exports, "useBackgroundImageUrl", ()=>$e9bd8754684007f4$export$16f28a2a10ece447);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $YWuyq;
    var $fHEdP;
    var $jcw0u;
    var $fZneA;
    var $l2N2a;
    const $e9bd8754684007f4$export$16f28a2a10ece447 = (themeSetting)=>{
        (0, (0, parcelRequire("gKZoD")).di)(URL, fetch);
        const media = (0, (0, parcelRequire("l2N2a")).useMediaConfiguration)();
        const lowResUrl = (0, $5uXOq.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, (0, parcelRequire("fHEdP")).generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                token: themeSetting.mediaReadToken,
                mediaEndpoint: 'image',
                width: 1000,
                'max-age': Number.MAX_SAFE_INTEGER
            }) : null, [
            media,
            themeSetting
        ]);
        const [imageUrl, setImageUrl] = (0, $5uXOq.useState)(lowResUrl);
        const currentThemeId = (0, $5uXOq.useRef)(null);
        currentThemeId.current = themeSetting?.type === 'image' ? themeSetting.id : null;
        (0, $5uXOq.useEffect)(()=>{
            setImageUrl(lowResUrl);
            if (!media || themeSetting?.type !== 'image') return;
            const binaryUrl = (0, (0, parcelRequire("fHEdP")).generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                }
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                if (currentThemeId.current === themeSetting.id) {
                    setImageUrl(objectUrl);
                    if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, (0, parcelRequire("YWuyq")).unsplashTracker).trackImage(themeSetting.sourceIdentifier);
                }
            }).catch((error)=>{
                if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraProjectThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            themeSetting,
            media,
            lowResUrl
        ]);
        return imageUrl;
    };
});
parcelRegister("YWuyq", function(module, exports) {
    $parcel$export(module.exports, "unsplashTracker", ()=>$20589baa06c4bf13$export$1869e04dbed4c16c);
    var $azYnG = parcelRequire("azYnG");
    var $lFKmC = parcelRequire("lFKmC");
    const $20589baa06c4bf13$var$APP_ID = '7066';
    const $20589baa06c4bf13$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$20589baa06c4bf13$var$APP_ID}`;
    const $20589baa06c4bf13$var$MAX_URL_LENGTH = 2083;
    const $20589baa06c4bf13$var$ID_LENGTH = 12;
    const $20589baa06c4bf13$export$28219189b23a0628 = Math.floor($20589baa06c4bf13$var$MAX_URL_LENGTH / $20589baa06c4bf13$var$ID_LENGTH);
    class $20589baa06c4bf13$var$UnsplashTracker {
        send() {
            if (this.queue.size === 0) return;
            const imageIds = Array.from(this.queue);
            this.queue.clear();
            (0, ($parcel$interopDefault($azYnG)))(imageIds, $20589baa06c4bf13$export$28219189b23a0628).forEach((chunkIds)=>{
                const url = `${$20589baa06c4bf13$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
                const now = new Date();
                imageIds.forEach((imageId)=>{
                    this.trackedImages.set(imageId, now);
                });
                const handleFailure = ()=>{
                    imageIds.forEach((imageId)=>{
                        this.queue.add(imageId);
                        this.trackedImages.delete(imageId);
                    });
                };
                fetch(url).then((response)=>{
                    if (!response.ok) handleFailure();
                }).catch(()=>handleFailure());
            });
        }
        trackImage(sourceIdentifier) {
            const imageId = sourceIdentifier.split('-').pop();
            if (!imageId) return;
            const lastTracked = this.trackedImages.get(imageId);
            if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
            this.queue.add(imageId);
            this.sendDebounced();
        }
        trackWhileInViewport(element, sourceIdentifier) {
            let trackIntervalId = null;
            const observer = new IntersectionObserver((entry)=>{
                if (entry[0].isIntersecting && !trackIntervalId) {
                    $20589baa06c4bf13$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                    trackIntervalId = window.setInterval(()=>{
                        $20589baa06c4bf13$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                    }, this.trackingInterval + 10);
                } else if (trackIntervalId) window.clearInterval(trackIntervalId);
            }, {
                rootMargin: '0px',
                threshold: 1.0
            });
            observer.observe(element);
            return ()=>{
                observer.disconnect();
                if (trackIntervalId) window.clearInterval(trackIntervalId);
            };
        }
        static getInstance() {
            if (!$20589baa06c4bf13$var$UnsplashTracker.instance) $20589baa06c4bf13$var$UnsplashTracker.instance = new $20589baa06c4bf13$var$UnsplashTracker();
            return $20589baa06c4bf13$var$UnsplashTracker.instance;
        }
        constructor(){
            this.trackedImages = new Map();
            this.trackingInterval = 600000;
            this.queue = new Set();
            this.sendDebounced = (0, ($parcel$interopDefault($lFKmC)))(this.send, 1000);
        }
    }
    const $20589baa06c4bf13$export$1869e04dbed4c16c = $20589baa06c4bf13$var$UnsplashTracker.getInstance();
});
parcelRegister("azYnG", function(module, exports) {
    var $dM3Z8 = parcelRequire("dM3Z8");
    var $4rDUz = parcelRequire("4rDUz");
    var $kPZpS = parcelRequire("kPZpS");
    var $7b3c02adf390bcc6$var$nativeCeil = Math.ceil, $7b3c02adf390bcc6$var$nativeMax = Math.max;
    function $7b3c02adf390bcc6$var$chunk(array, size, guard) {
        if (guard ? $4rDUz(array, size, guard) : size === undefined) size = 1;
        else size = $7b3c02adf390bcc6$var$nativeMax($kPZpS(size), 0);
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) return [];
        var index = 0, resIndex = 0, result = Array($7b3c02adf390bcc6$var$nativeCeil(length / size));
        while(index < length)result[resIndex++] = $dM3Z8(array, index, index += size);
        return result;
    }
    module.exports = $7b3c02adf390bcc6$var$chunk;
});
parcelRegister("hxMHI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("OgDz0").then(()=>parcelRequire('gEdc8'));
});
parcelRegister("gk293", function(module, exports) {
    $parcel$export(module.exports, "ThemedContentLayout", ()=>$24fd52a828227843$export$c2c3c7c0b13a1f9d);
    $parcel$export(module.exports, "ProjectThemeWrapper", ()=>$24fd52a828227843$export$65c56727ada4372d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3HwlS;
    var $dCm1o;
    var $jtC5b;
    const $24fd52a828227843$var$styles = {
        rootOld: "_kqswh2mm",
        root: "_kqswh2mm _1pbyidpf",
        fullHeight: "_1tkeidpf _4t3i1osq",
        insetRoot: "_1yt4y9h4",
        insetRootVisualRefresh: "_ca0qv47k",
        insetContainer: "_2rko1gnp _bfhkp043"
    };
    const $24fd52a828227843$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>$5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && $24fd52a828227843$var$styles.root,
                !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && $24fd52a828227843$var$styles.rootOld,
                $24fd52a828227843$var$styles.fullHeight,
                appearance === 'inset' && $24fd52a828227843$var$styles.insetRoot,
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && appearance === 'inset' && $24fd52a828227843$var$styles.insetRootVisualRefresh
            ])
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $24fd52a828227843$var$styles.fullHeight,
                appearance === 'inset' && $24fd52a828227843$var$styles.insetContainer
            ])
        }, children));
    const $24fd52a828227843$export$65c56727ada4372d = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
        if (withWhiteBackground) return $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).OuterWrapperWithBackground), null, $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).InnerWrapperWithBackground), null, children));
        return $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).OuterWrapper), null, $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).InnerWrapper), null, children));
    };
});
parcelRegister("jtC5b", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$c37919f3b01a53ae$export$edaaad985a878983);
    $parcel$export(module.exports, "OuterWrapperWithBackground", ()=>$c37919f3b01a53ae$export$69c6ec128d3729c9);
    $parcel$export(module.exports, "InnerWrapper", ()=>$c37919f3b01a53ae$export$f185744748c379a7);
    $parcel$export(module.exports, "InnerWrapperWithBackground", ()=>$c37919f3b01a53ae$export$2e149d12a18af14b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $cSD7y;
    var $3HwlS;
    const $c37919f3b01a53ae$var$Nav3OuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1jzz",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$var$Nav4OuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154ieda8",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$var$Nav4HighTabOuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1f46",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$edaaad985a878983 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("cSD7y")).componentWithFG)('horizontal_navigation_increase_tab_height', $c37919f3b01a53ae$var$Nav4HighTabOuterWrapper, $c37919f3b01a53ae$var$Nav4OuterWrapper), $c37919f3b01a53ae$var$Nav3OuterWrapper);
    const $c37919f3b01a53ae$export$69c6ec128d3729c9 = (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4y9h4",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$f185744748c379a7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2d3f3q3i _japi1o48 _iu1g1fl4 _fok81wug _q7c11wug",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$2e149d12a18af14b = (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1gnp _bfhkp043 _2d3f15y4 _japizntk",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8Orxo", function(module, exports) {
    $parcel$export(module.exports, "addLeadingSlash", ()=>$66a85aa0db68ca7e$export$5b4913142e03bca8, (v)=>$66a85aa0db68ca7e$export$5b4913142e03bca8 = v);
    $parcel$export(module.exports, "hasBasename", ()=>$66a85aa0db68ca7e$export$10497c7ce66fcb84, (v)=>$66a85aa0db68ca7e$export$10497c7ce66fcb84 = v);
    $parcel$export(module.exports, "stripBasename", ()=>$66a85aa0db68ca7e$export$b69e3301ce081aa3, (v)=>$66a85aa0db68ca7e$export$b69e3301ce081aa3 = v);
    $parcel$export(module.exports, "stripTrailingSlash", ()=>$66a85aa0db68ca7e$export$d95b4586d238a081, (v)=>$66a85aa0db68ca7e$export$d95b4586d238a081 = v);
    $parcel$export(module.exports, "parsePath", ()=>$66a85aa0db68ca7e$export$8ccf933b0513f8d0, (v)=>$66a85aa0db68ca7e$export$8ccf933b0513f8d0 = v);
    $parcel$export(module.exports, "createPath", ()=>$66a85aa0db68ca7e$export$fe53371bee54353d, (v)=>$66a85aa0db68ca7e$export$fe53371bee54353d = v);
    var $66a85aa0db68ca7e$export$1e511d4a378977f5;
    var $66a85aa0db68ca7e$export$5b4913142e03bca8;
    var $66a85aa0db68ca7e$export$79c5b1569e3be9e6;
    var $66a85aa0db68ca7e$export$10497c7ce66fcb84;
    var $66a85aa0db68ca7e$export$b69e3301ce081aa3;
    var $66a85aa0db68ca7e$export$d95b4586d238a081;
    var $66a85aa0db68ca7e$export$8ccf933b0513f8d0;
    var $66a85aa0db68ca7e$export$fe53371bee54353d;
    'use strict';
    $66a85aa0db68ca7e$export$1e511d4a378977f5 = true;
    var $66a85aa0db68ca7e$var$addLeadingSlash = $66a85aa0db68ca7e$export$5b4913142e03bca8 = function addLeadingSlash(path) {
        return path.charAt(0) === '/' ? path : '/' + path;
    };
    var $66a85aa0db68ca7e$var$stripLeadingSlash = $66a85aa0db68ca7e$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
        return path.charAt(0) === '/' ? path.substr(1) : path;
    };
    var $66a85aa0db68ca7e$var$hasBasename = $66a85aa0db68ca7e$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
        return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
    };
    var $66a85aa0db68ca7e$var$stripBasename = $66a85aa0db68ca7e$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
        return $66a85aa0db68ca7e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
    };
    var $66a85aa0db68ca7e$var$stripTrailingSlash = $66a85aa0db68ca7e$export$d95b4586d238a081 = function stripTrailingSlash(path) {
        return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
    };
    var $66a85aa0db68ca7e$var$parsePath = $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = function parsePath(path) {
        var pathname = path || '/';
        var search = '';
        var hash = '';
        var hashIndex = pathname.indexOf('#');
        if (hashIndex !== -1) {
            hash = pathname.substr(hashIndex);
            pathname = pathname.substr(0, hashIndex);
        }
        var searchIndex = pathname.indexOf('?');
        if (searchIndex !== -1) {
            search = pathname.substr(searchIndex);
            pathname = pathname.substr(0, searchIndex);
        }
        return {
            pathname: pathname,
            search: search === '?' ? '' : search,
            hash: hash === '#' ? '' : hash
        };
    };
    var $66a85aa0db68ca7e$var$createPath = $66a85aa0db68ca7e$export$fe53371bee54353d = function createPath(location) {
        var pathname = location.pathname, search = location.search, hash = location.hash;
        var path = pathname || '/';
        if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
        if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
        return path;
    };
});
parcelRegister("vrkiK", function(module, exports) {
    $parcel$export(module.exports, "calcRapidBoardResetState", ()=>$fd0af9cf1691807e$export$2350ed3ff6c1a082);
    $parcel$export(module.exports, "getApdexMatchObject", ()=>$fd0af9cf1691807e$export$47e434f08768932b);
    $parcel$export(module.exports, "calcRapidBoardResetStateV2", ()=>$fd0af9cf1691807e$export$dbd9185166d0d04c);
    $parcel$export(module.exports, "isValidRoute", ()=>$fd0af9cf1691807e$export$9f3e656a7f6a3adc);
    var $65Ltd;
    const $fd0af9cf1691807e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [
                    (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)
                ];
                resetDone = true;
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    resetDone = false;
                    break;
                }
                if (!useStoredSettings && rapidBoardPaths.indexOf((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
                rapidBoardPaths = [];
                break;
            default:
                resetDone = false;
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $fd0af9cf1691807e$export$47e434f08768932b = (match, route)=>{
        let cleanMatch = {
            ...match,
            params: {
                ...match.params
            },
            query: {
                ...match.query
            }
        };
        if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
            const { params: params, query: query } = match;
            const paramKeys = params && Object.keys(params);
            const queryKeys = query && Object.keys(query);
            const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
            const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
            if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
            if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
        });
        if (match.query && match.query.view && match.query.view === 'detail') cleanMatch.query.view = undefined;
        if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
        cleanMatch = {
            ...cleanMatch,
            url: ''
        };
        return cleanMatch;
    };
    const $fd0af9cf1691807e$export$dbd9185166d0d04c = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [];
                resetDone = true;
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (rapidBoardPaths.includes((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) || rapidBoardPaths.includes('useStoredSettings')) {
                    resetDone = true;
                    rapidBoardPaths = [];
                    break;
                } else if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    break;
                } else {
                    rapidBoardPaths = [];
                    break;
                }
            default:
                if (rapidBoardPaths.includes((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT))) {
                    resetDone = true;
                    rapidBoardPaths = [];
                }
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $fd0af9cf1691807e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
        if (state) {
            const { currentPage: currentPage, visitedPages: visitedPages } = state;
            const visitedPageLength = visitedPages.length;
            if (currentPage && currentPage.apps[appId]) return true;
            if (visitedPageLength === 0 || searchDepth <= 0) return false;
            for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
                if (visitedPages[visitedPageLength - i].apps[appId]) return true;
            }
        }
        return false;
    };
    const $fd0af9cf1691807e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
        switch(routeToCheck.name){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES:
                return true;
            default:
                return false;
        }
    };
});
parcelRegister("5dFS4", function(module, exports) {
    $parcel$export(module.exports, "RemoteActionsContainer", ()=>$1e0d24cbb091f7c4$export$28c2e4c663a86266);
    $parcel$export(module.exports, "useRemoteActions", ()=>$1e0d24cbb091f7c4$export$333357b3de3e67a0);
    $parcel$export(module.exports, "useRemoteActionsData", ()=>$1e0d24cbb091f7c4$export$3cc006661ae2a759);
    $parcel$export(module.exports, "useMeta", ()=>$1e0d24cbb091f7c4$export$3fb9275d3845bd5a);
    $parcel$export(module.exports, "useRemoteActionsStoreActions", ()=>$1e0d24cbb091f7c4$export$3fd21eaf97df4718);
    var $7JoAD = parcelRequire("7JoAD");
    var $4zmoY;
    if (!Object.isFrozen((0, $7JoAD.defaults))) (0, $7JoAD.defaults).devtools = false;
    const $1e0d24cbb091f7c4$var$Store = (0, $7JoAD.createStore)({
        initialState: {
            meta: {},
            remoteActions: {},
            lastUpdatedAt: 0,
            isLoaded: false,
            product: undefined
        },
        actions: (0, parcelRequire("4zmoY")).actions,
        name: 'remoteActionsStore'
    });
    const $1e0d24cbb091f7c4$export$28c2e4c663a86266 = (0, $7JoAD.createContainer)($1e0d24cbb091f7c4$var$Store, {
        onInit: ()=>({ dispatch: dispatch })=>{
                dispatch((0, (0, parcelRequire("4zmoY")).actions).initStore());
            }
    });
    const $1e0d24cbb091f7c4$export$333357b3de3e67a0 = (selector)=>(0, $7JoAD.createHook)($1e0d24cbb091f7c4$var$Store, {
            selector: selector
        })();
    const $1e0d24cbb091f7c4$export$3cc006661ae2a759 = (0, $7JoAD.createStateHook)($1e0d24cbb091f7c4$var$Store, {
        selector: (state)=>state.remoteActions
    });
    const $1e0d24cbb091f7c4$export$3fb9275d3845bd5a = (0, $7JoAD.createStateHook)($1e0d24cbb091f7c4$var$Store, {
        selector: (state)=>state.meta
    });
    const $1e0d24cbb091f7c4$export$3fd21eaf97df4718 = (0, $7JoAD.createActionsHook)($1e0d24cbb091f7c4$var$Store);
});
parcelRegister("4zmoY", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$aaea61f326c14d61$export$e324594224ef24da);
    var $iVuAh;
    var $18IDi;
    var $9sXhr;
    var $5wOe3;
    const $aaea61f326c14d61$export$e324594224ef24da = {
        processRemoteActions: (0, parcelRequire("9sXhr")).processRemoteActions,
        saveActionPerformedAttempt: (0, parcelRequire("5wOe3")).saveActionPerformedAttempt,
        initStore: (0, parcelRequire("18IDi")).initStore,
        clearActionId: (0, parcelRequire("iVuAh")).clearActionId
    };
});
parcelRegister("iVuAh", function(module, exports) {
    $parcel$export(module.exports, "clearActionId", ()=>$713396201de9d9dc$export$8d8b492eefa9efba);
    var $jbSVM;
    const $713396201de9d9dc$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
            const { meta: meta } = getState();
            const newMeta = {
                ...meta
            };
            delete newMeta[actionId];
            setState({
                meta: newMeta
            });
            (0, (0, parcelRequire("jbSVM")).writeRemoteActionsMetasToLocalStorage)(product, meta);
        };
});
parcelRegister("jbSVM", function(module, exports) {
    $parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", ()=>$c376cbc81521c9c0$export$a221266a05084986);
    $parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", ()=>$c376cbc81521c9c0$export$7228aaade919a8b6);
    const $c376cbc81521c9c0$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
    const $c376cbc81521c9c0$export$a221266a05084986 = (product)=>{
        try {
            return JSON.parse(localStorage.getItem(`${$c376cbc81521c9c0$export$b9e25d3c75cffd71}.${product}`) || '{}');
        } catch (e) {
            console.warn('Could not load from localStorage', e);
            return {};
        }
    };
    const $c376cbc81521c9c0$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
        try {
            localStorage.setItem(`${$c376cbc81521c9c0$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
        } catch (e) {
            console.warn('Could not load from localStorage', e);
        }
    };
});
parcelRegister("18IDi", function(module, exports) {
    $parcel$export(module.exports, "initStore", ()=>$46b900e2f6990234$export$41f27b3823a442c6);
    var $jbSVM;
    const $46b900e2f6990234$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
            setState({
                meta: (0, (0, parcelRequire("jbSVM")).readRemoteActionsMetasFromLocalStorage)(product),
                isLoaded: true,
                product: product
            });
        };
});
parcelRegister("9sXhr", function(module, exports) {
    $parcel$export(module.exports, "processRemoteActions", ()=>$12ae2589bf32577c$export$15e69d1dd38ccaa3);
    var $hDuWL;
    const $12ae2589bf32577c$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
            const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
            if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) return;
            const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
                if ((0, (0, parcelRequire("hDuWL")).shouldProcessRemoteAction)(remoteAction)) {
                    const shouldAddAction = remoteAction.conditions.every((condition)=>(0, (0, parcelRequire("hDuWL")).isActionConditionSatisfied)(productData, condition));
                    if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
                }
                return updatedRemoteActions;
            }, {});
            setState({
                meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                    newMeta[id] = meta[id];
                    return newMeta;
                }, {}),
                remoteActions: remoteActions,
                lastUpdatedAt: Date.now()
            });
        };
});
parcelRegister("hDuWL", function(module, exports) {
    $parcel$export(module.exports, "isActionConditionSatisfied", ()=>$5301c54ab422cac2$export$9262d8191a70c677);
    $parcel$export(module.exports, "shouldProcessRemoteAction", ()=>$5301c54ab422cac2$export$c7cc93192d09a3d7);
    var $7DUy3;
    const $5301c54ab422cac2$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
    const $5301c54ab422cac2$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
    const $5301c54ab422cac2$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
        try {
            const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
            const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
            const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
            if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
            if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
        } catch (error) {
            console.warn('error while parsing a build key', error);
        }
        return false;
    };
    const $5301c54ab422cac2$export$9262d8191a70c677 = (productData, condition)=>{
        switch(condition.type){
            case (0, (0, parcelRequire("7DUy3")).ConditionType).buildRange:
                return $5301c54ab422cac2$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
            case (0, (0, parcelRequire("7DUy3")).ConditionType).featureFlag:
                return $5301c54ab422cac2$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
            case (0, (0, parcelRequire("7DUy3")).ConditionType).featureGate:
                return $5301c54ab422cac2$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
            default:
                return false;
        }
    };
    const $5301c54ab422cac2$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;
});
parcelRegister("7DUy3", function(module, exports) {
    $parcel$export(module.exports, "ConditionType", ()=>$8113f7b7a082b7e1$export$748d1c753cdf4bfd);
    var $8113f7b7a082b7e1$export$748d1c753cdf4bfd;
    (function(ConditionType) {
        ConditionType["featureFlag"] = "featureFlag";
        ConditionType["featureGate"] = "featureGate";
        ConditionType["buildRange"] = "buildRange";
    })($8113f7b7a082b7e1$export$748d1c753cdf4bfd || ($8113f7b7a082b7e1$export$748d1c753cdf4bfd = {}));
});
parcelRegister("5wOe3", function(module, exports) {
    $parcel$export(module.exports, "saveActionPerformedAttempt", ()=>$a54dff5e62ba5c12$export$e3144a2e886e0e77);
    var $jbSVM;
    const $a54dff5e62ba5c12$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
            const { meta: meta, product: product } = getState();
            const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
            const updatedMetas = {
                ...meta,
                [actionId]: {
                    lastPerformAttemptedAt: Date.now(),
                    attemptCounts: currentAttemptCount + 1
                }
            };
            setState({
                meta: updatedMetas
            });
            if (!product) throw new Error('Product is not defined.');
            (0, (0, parcelRequire("jbSVM")).writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
        };
});
parcelRegister("5eQ1m", function(module, exports) {
    $parcel$export(module.exports, "StrictMode", ()=>$64cfd661e498c7fe$export$5f8d39834fd61797);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    const $64cfd661e498c7fe$export$5f8d39834fd61797 = ({ children: children })=>{
        return (0, (0, parcelRequire("co1wz")).ff)('jfp.magma.enable-strict-mode') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).StrictMode, null, children) : children;
    };
});
parcelRegister("b7awD", function(module, exports) {
    $parcel$export(module.exports, "Router", ()=>$87aa2fd82c8be71a$export$55185c17a0fcbe46);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    var $d8orV;
    const $87aa2fd82c8be71a$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
        const pluginsWithOverride = (0, (0, parcelRequire("d8orV")).usePlugins)({
            resourceContext: props.resourceContext,
            resourceData: props.resourceData
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Router), {
            plugins: pluginsWithOverride,
            ...props
        }, children);
    };
});
parcelRegister("d8orV", function(module, exports) {
    $parcel$export(module.exports, "usePlugins", ()=>$0614c9d3afc2dd7f$export$c41e96fd89bc6106);
    var $5uXOq = parcelRequire("5uXOq");
    var $a2g00;
    var $5yJb9;
    var $9OXo1;
    var $8Y8sk;
    const $0614c9d3afc2dd7f$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [pluginsWithOverride] = (0, $5uXOq.useState)(()=>{
            const jiraPlugins = [];
            const resourcesPlugin = (0, (0, parcelRequire("8Y8sk")).createResourcesPlugin)({
                context: resourceContext,
                resourceData: resourceData
            });
            jiraPlugins.push(resourcesPlugin);
            jiraPlugins.push((0, (0, parcelRequire("a2g00")).createEntryPointsPlugin)({
                environment: (0, (0, parcelRequire("5yJb9")).default)(),
                entryPointParams: {
                    tenantContext: tenantContext
                }
            }));
            return jiraPlugins;
        });
        return pluginsWithOverride;
    };
});
parcelRegister("a2g00", function(module, exports) {
    $parcel$export(module.exports, "createEntryPointsPlugin", ()=>$e3cbf02360bc6f96$export$33586718f82f356f);
    var $8Uumt = parcelRequire("8Uumt");
    var $3gC8D;
    var $3I4nj;
    var $ktB2C;
    const $e3cbf02360bc6f96$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
            id: 'entry-points-plugin',
            routeLoad: ({ context: context })=>{
                const entryPoint = context.route.entryPoint?.();
                const prefetchingRoute = (0, (0, parcelRequire("3I4nj")).getPrefetchingRoute)();
                let entryPointReference = null;
                if (entryPoint) {
                    if (prefetchingRoute && (0, (0, parcelRequire("3gC8D")).isSameRouteMatch)({
                        prevContextMatch: prefetchingRoute.routerContext.match,
                        nextContextMatch: context.match
                    }) && !(0, (0, parcelRequire("3gC8D")).isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                    else entryPointReference = (0, $8Uumt.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: context,
                        ...entryPointParams
                    });
                }
                (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setLastLoadedRoute({
                    route: context.route,
                    entryPointReference: entryPointReference
                });
                return {
                    entryPoint: entryPointReference
                };
            },
            routePrefetch: ({ nextContext: nextContext })=>{
                const entryPoint = nextContext.route.entryPoint?.();
                if (entryPoint) {
                    const prevPrefetchingRoute = (0, (0, parcelRequire("3I4nj")).getPrefetchingRoute)();
                    if (prevPrefetchingRoute && (0, (0, parcelRequire("3gC8D")).isSameRouteMatch)({
                        prevContextMatch: prevPrefetchingRoute.routerContext.match,
                        nextContextMatch: nextContext.match
                    }) && !(0, (0, parcelRequire("3gC8D")).isExpired)(prevPrefetchingRoute.expiresAt)) return;
                    const entryPointReference = (0, $8Uumt.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: nextContext,
                        ...entryPointParams
                    });
                    (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setPrefetchingRoute({
                        routerContext: nextContext,
                        expiresAt: (0, (0, parcelRequire("3gC8D")).getExpiresAt)(),
                        entryPointReference: entryPointReference
                    });
                } else (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: 0,
                    entryPointReference: null
                });
            },
            waitForEntryPoint: ()=>{
                const lastLoadedRoute = (0, (0, parcelRequire("3I4nj")).getLastLoadedRoute)();
                const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
                if (entryPointReference) return (0, (0, parcelRequire("ktB2C")).waitForEntryPoint)(entryPointReference);
                return Promise.resolve();
            }
        });
});
parcelRegister("3gC8D", function(module, exports) {
    $parcel$export(module.exports, "getExpiresAt", ()=>$f48ce76f20803aec$export$b65d7ba7fbf150f1);
    $parcel$export(module.exports, "isExpired", ()=>$f48ce76f20803aec$export$57947cfd429801a2);
    $parcel$export(module.exports, "isSameRouteMatch", ()=>$f48ce76f20803aec$export$5997e70fc4543270);
    const $f48ce76f20803aec$export$37d3126be6549b13 = 10000;
    const $f48ce76f20803aec$export$b65d7ba7fbf150f1 = ()=>$f48ce76f20803aec$export$37d3126be6549b13 + Date.now();
    const $f48ce76f20803aec$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
    const $f48ce76f20803aec$var$isShallowEqual = (o1, o2)=>{
        const objKeys1 = Object.keys(o1);
        const objKeys2 = Object.keys(o2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>o1[key] === o2[key]);
    };
    const $f48ce76f20803aec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
});
parcelRegister("ktB2C", function(module, exports) {
    $parcel$export(module.exports, "waitForEntryPoint", ()=>$67d2b262678828c6$export$944f853f194e5dd5);
    var $kipqU;
    const $67d2b262678828c6$export$944f853f194e5dd5 = (entryPointConfig)=>{
        const promises = [];
        try {
            entryPointConfig.getComponent();
        } catch (err) {
            if (err instanceof Promise) promises.push(err);
            else throw err;
        }
        const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) {
                const queryPromise = (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(String(queries[key].id));
                if (queryPromise) promises.push(queryPromise);
            }
        });
        if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
            const nestedEntryPointPromise = $67d2b262678828c6$export$944f853f194e5dd5(entryPoints[key]);
            promises.push(nestedEntryPointPromise);
        });
        return Promise.allSettled(promises);
    };
});
parcelRegister("8Y8sk", function(module, exports) {
    $parcel$export(module.exports, "createResourcesPlugin", ()=>$d3b2f44f58ee61bb$export$23ed892c481a96fe);
    var $8fYaK;
    var $4CEu1;
    const $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c = 'resources-plugin';
    const $d3b2f44f58ee61bb$var$loadOnUrlChange = (context, prevContext)=>{
        const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
        const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
        return Promise.all(requestResources(nextResources, context, {}));
    };
    const $d3b2f44f58ee61bb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
        const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
        const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
        cleanExpiredResources(nextResources, nextContext);
    };
    const $d3b2f44f58ee61bb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
        let latestLoadedResources = Promise.resolve([]);
        (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.hydrate({
            resourceContext: initialResourceContext,
            resourceData: initialResourceData
        });
        return {
            id: $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c,
            beforeRouteLoad: $d3b2f44f58ee61bb$var$beforeLoad,
            routeLoad: ({ context: context, prevContext: prevContext })=>{
                const { route: route, match: match, query: query } = context;
                if (prevContext) latestLoadedResources = $d3b2f44f58ee61bb$var$loadOnUrlChange(context, prevContext);
                else latestLoadedResources = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.requestAllResources({
                    route: route,
                    match: match,
                    query: query
                }, {
                    timeout: timeout
                });
            },
            routePrefetch: ({ context: context, nextContext: nextContext })=>{
                const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
                const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
                return {
                    resources: prefetchResources(nextResources, nextContext, {})
                };
            },
            getLatestResources: ()=>latestLoadedResources,
            getSerializedResources: async ()=>{
                await latestLoadedResources;
                return (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.getSafeData();
            }
        };
    };
});
parcelRegister("4CEu1", function(module, exports) {
    $parcel$export(module.exports, "getResourcesForNextLocation", ()=>$448a0fea894dd469$export$7cbbc763e2f3d65d);
    var $9KbzN;
    var $dj41J;
    const $448a0fea894dd469$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
        const { route: prevRoute } = prevRouterStoreContext;
        const { resources: prevResources = [] } = prevRoute || {};
        const { route: nextRoute } = nextRouterStoreContext;
        const { resources: nextResources = [] } = nextRoute || {};
        if (!(0, (0, parcelRequire("dj41J")).routeHasResources)(nextRoute)) return [];
        if ((0, (0, parcelRequire("dj41J")).routeHasChanged)(prevRoute, nextRoute)) return nextResources;
        const prevResourceIdentifiers = (0, (0, parcelRequire("9KbzN")).getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
        return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, (0, parcelRequire("9KbzN")).getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
    };
});
parcelRegister("9KbzN", function(module, exports) {
    $parcel$export(module.exports, "getResourceIdentifier", ()=>$82cfa1d66d41fab5$export$c616b176adf9ad4a);
    $parcel$export(module.exports, "getResourceIdentifiers", ()=>$82cfa1d66d41fab5$export$cd7fbe7e979df558);
    const $82cfa1d66d41fab5$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
        const { type: type, getKey: getKey } = resource;
        const key = getKey(routerStoreContext, resourceStoreContext);
        return `${type}/${key}`;
    };
    const $82cfa1d66d41fab5$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$82cfa1d66d41fab5$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
});
parcelRegister("dj41J", function(module, exports) {
    $parcel$export(module.exports, "routeHasResources", ()=>$9c8422e0259b24f6$export$740886389191c640);
    $parcel$export(module.exports, "routeHasChanged", ()=>$9c8422e0259b24f6$export$221027ff1aa38f82);
    const $9c8422e0259b24f6$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
    const $9c8422e0259b24f6$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
});
parcelRegister("81ezV", function(module, exports) {
    $parcel$export(module.exports, "JiraRouterLinkConfiguration", ()=>$33ea5bfeb747665b$export$a580704a2f3cfca);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $33ea5bfeb747665b$export$a580704a2f3cfca = (0, $5uXOq.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
        if (!href || typeof href === 'string') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            ref: ref,
            href: href || '#',
            ...rest
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            ref: ref,
            href: href.href,
            to: href.to,
            replace: href.replace,
            params: href.params,
            query: href.query,
            prefetch: href.prefetch,
            ...rest
        }, children);
    });
});
parcelRegister("6YRTH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3bd6eeaf3add142$export$2e2bcd8739ae039);
    var $6vAaw = parcelRequire("6vAaw");
    var $fr1K2 = parcelRequire("fr1K2");
    var $e3bd6eeaf3add142$export$2e2bcd8739ae039 = (paramsToStrip)=>{
        try {
            const parsedUrl = (0, ($parcel$interopDefault($6vAaw))).parse(window.location.href, true);
            const strippedQuery = (0, ($parcel$interopDefault($fr1K2)))(parsedUrl.query || {}, paramsToStrip);
            let strippedUrl = (0, ($parcel$interopDefault($6vAaw))).format({
                ...parsedUrl,
                search: undefined,
                query: strippedQuery
            });
            const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(window.location.search);
            if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
            window.history.replaceState({}, '', strippedUrl);
        } catch (e) {}
    };
});
parcelRegister("TtQEC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8ee37fd26b4ccf1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $jzjy1;
    var $jD5no;
    var $l7nSX;
    const $c8ee37fd26b4ccf1$var$defaultSource = 'dwellComponent';
    const $c8ee37fd26b4ccf1$var$defaultActionSubject = 'dwellComponent';
    const $c8ee37fd26b4ccf1$var$getDwellComponent = (source, actionSubject)=>(0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("jzjy1")).AnalyticsSubject)(actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject), (0, (0, parcelRequire("jzjy1")).AnalyticsSource)(source || $c8ee37fd26b4ccf1$var$defaultSource, (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))((0, (0, parcelRequire("l7nSX")).default));
    class $c8ee37fd26b4ccf1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props) {
            const { data: data } = props;
            return {
                DwellTimeComponent: $c8ee37fd26b4ccf1$var$getDwellComponent(data.source, data.actionSubject)
            };
        }
        constructor(props){
            super(props);
            this.state = {
                DwellTimeComponent: null
            };
        }
        render() {
            const { sessionId: sessionId, data: data } = this.props;
            const { DwellTimeComponent: DwellTimeComponent } = this.state;
            const enrichedData = {
                ...data,
                source: data && data.source || $c8ee37fd26b4ccf1$var$defaultSource,
                actionSubject: data && data.actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject
            };
            if (sessionId && DwellTimeComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(DwellTimeComponent, {
                sessionId: sessionId,
                data: enrichedData
            }));
            return null;
        }
    }
});
parcelRegister("l7nSX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c5cee06f4a100e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9E7Uh;
    var $8oe80;
    var $hhweD;
    class $8c5cee06f4a100e3$export$1c7ccff61c195c75 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { data: data, sessionId: sessionId } = this.props;
            this.dwellHelper = new (0, (0, parcelRequire("9E7Uh")).default)(this.sendDwellEvent, data, sessionId);
            this.dwellHelper.start();
        }
        componentDidUpdate(oldProps) {
            if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) this.dwellHelper.newPage(this.props.data, this.props.sessionId);
        }
        componentWillUnmount() {
            if (this.dwellHelper) {
                this.dwellHelper.stop();
                this.dwellHelper.destroy();
            }
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.sendDwellEvent = (payload)=>(0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
        }
    }
    var $8c5cee06f4a100e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('dwellTime', {
        onDwell: 'dwelled'
    })($8c5cee06f4a100e3$export$1c7ccff61c195c75);
});
parcelRegister("hhweD", function(module, exports) {
    $parcel$export(module.exports, "fireTrackAnalytics", ()=>$a4297ed46523d116$export$13990ad4625571ed);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $gvRPW;
    var $i4iBk;
    const $a4297ed46523d116$var$isNotUndefined = (a)=>a !== undefined;
    const $a4297ed46523d116$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { action: action, actionSubjectId: actionSubjectId } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            action: action,
            actionSubjectId: actionSubjectId
        }, $a4297ed46523d116$var$isNotUndefined);
    };
    const $a4297ed46523d116$export$13990ad4625571ed = (event, payload)=>{
        event.update({
            ...$a4297ed46523d116$var$mapPayload(payload),
            analyticsType: (0, (0, parcelRequire("gvRPW")).TRACK_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("5Jsi2", function(module, exports) {
    $parcel$export(module.exports, "CLEAR_SEARCH_SESSION", ()=>$65e6525a854bf206$export$b669eaa3e4786d5c);
    $parcel$export(module.exports, "skipClearSessionURLs", ()=>$65e6525a854bf206$export$c092460ed33e0e35);
    const $65e6525a854bf206$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
    const $65e6525a854bf206$export$c092460ed33e0e35 = [
        /.*RapidBoard.jspa.*/,
        /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
        /\/jira\/people\/.*\/boards\/.*/
    ];
});
parcelRegister("bShz7", function(module, exports) {
    $parcel$export(module.exports, "setPrefetchStartMark", ()=>$fd73e472799b8227$export$405fde3eab8e39f6);
    $parcel$export(module.exports, "getPrefetchStartMark", ()=>$fd73e472799b8227$export$cbaceb7ffa84279);
    $parcel$export(module.exports, "clearPrefetchStartMarks", ()=>$fd73e472799b8227$export$d6b0928f07bafe57);
    const $fd73e472799b8227$var$prefetchTiming = new Map();
    const $fd73e472799b8227$export$405fde3eab8e39f6 = (match)=>{
        const currentMatch = JSON.stringify(match);
        if (!$fd73e472799b8227$var$prefetchTiming.has(currentMatch)) $fd73e472799b8227$var$prefetchTiming.set(currentMatch, {
            startPrefetchTime: Date.now()
        });
    };
    const $fd73e472799b8227$export$cbaceb7ffa84279 = (match)=>{
        const currentMatch = JSON.stringify(match);
        const { startPrefetchTime: startPrefetchTime } = $fd73e472799b8227$var$prefetchTiming.get(currentMatch) || {
            startPrefetchTime: null
        };
        return startPrefetchTime;
    };
    const $fd73e472799b8227$export$d6b0928f07bafe57 = (match)=>{
        if (!$fd73e472799b8227$var$prefetchTiming || !$fd73e472799b8227$var$prefetchTiming.keys) return;
        const currentMatch = JSON.stringify(match);
        const keys = Array.from($fd73e472799b8227$var$prefetchTiming.keys());
        keys.forEach((mark)=>{
            if (mark !== currentMatch && $fd73e472799b8227$var$prefetchTiming.has(mark)) $fd73e472799b8227$var$prefetchTiming.delete(mark);
        });
    };
});
parcelRegister("5HG6S", function(module, exports) {
    $parcel$export(module.exports, "getSpaRouterContext", ()=>$804f5602998bd8a4$export$1f61c5e3f6410afa);
    const $804f5602998bd8a4$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
            tenantContext: tenantContext
        });
});
parcelRegister("kKlrY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71f44f620ca2fe28$export$2e2bcd8739ae039);
    var $lANdF;
    var $bFU4G;
    var $auAY8;
    var $3vLAR;
    var $ievYU;
    var $cPbc1;
    var $co1wz;
    var $4R6GH;
    var $j8DrX;
    var $aZWa4;
    var $3dQJA;
    var $cEm1b;
    var $fJbQ9;
    var $itoGf;
    var $dQKfU;
    const $71f44f620ca2fe28$var$getUFOConfigFromFF = ()=>(0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('ufo.config', {});
    function $71f44f620ca2fe28$var$getAdditionalJiraFields(interaction) {
        try {
            return {
                jira: (0, (0, parcelRequire("3dQJA")).getJiraCustomData)(interaction)
            };
        } catch (error) {
            return {};
        }
    }
    function $71f44f620ca2fe28$var$loadJiraAnalyticsWebClient() {
        return Promise.resolve((parcelRequire("fjcgS")));
    }
    function $71f44f620ca2fe28$export$2e2bcd8739ae039() {
        const ufoConfigFromFF = $71f44f620ca2fe28$var$getUFOConfigFromFF();
        (0, (0, parcelRequire("aZWa4")).retrieveAndSetPageLoadTrace)((0, (0, parcelRequire("j8DrX")).default));
        (0, (0, parcelRequire("3vLAR")).configure)((0, (0, parcelRequire("itoGf")).jiraResourceTimingsConfig));
        (0, (0, parcelRequire("ievYU")).startResourceTimingBuffer)();
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-disable-ufo-bundle-eval-timings')) (0, (0, parcelRequire("lANdF")).configure)((0, (0, parcelRequire("fJbQ9")).jiraBundleEvalTimingsConfig));
        (0, (0, parcelRequire("cPbc1")).configure)((0, (0, parcelRequire("dQKfU")).jiraSsrConfig));
        (0, (0, parcelRequire("cEm1b")).GlobalReactLooselyLazyProfiler).current = (0, (0, parcelRequire("bFU4G")).ModuleLoadingProfiler);
        (0, (0, parcelRequire("auAY8")).init)($71f44f620ca2fe28$var$loadJiraAnalyticsWebClient(), {
            ...ufoConfigFromFF,
            enableSegmentHighlighting: (0, (0, parcelRequire("4R6GH")).fg)('ufo_enable_segment_highlighting_jira'),
            product: 'jira',
            region: (0, (0, parcelRequire("j8DrX")).default)('ajs-region') || 'unknown',
            additionalPayloadData: $71f44f620ca2fe28$var$getAdditionalJiraFields,
            postInteractionLog: {
                enabled: (0, (0, parcelRequire("4R6GH")).fg)('ufo_capture_late_rerenders_jira'),
                rates: {
                    'issue-view': 1,
                    'new-issue-navigator': 1,
                    'classic-board': 1,
                    'classic-backlog': 1,
                    'next-gen-board': 1,
                    'jwm.list-view': 1,
                    'jwm.jwm-board': 1,
                    'jwm.summary-view': 1,
                    dashboard: 1,
                    'software-issue-navigator': 1,
                    'global-new-issue-navigator': 1,
                    'issue-navigator': 1,
                    'issue-navigator-classic': 1,
                    'issue-navigator-core': 1,
                    'servicedesk-issues': 1
                }
            },
            manuallyTrackReactProfilerMounts: (0, (0, parcelRequire("4R6GH")).fg)('ufo-manually-track-segment-mount-phase-jira'),
            vc: {
                enabled: (0, (0, parcelRequire("co1wz")).ff)('uip.vc.partial', false),
                heatmapSize: 200,
                oldDomUpdates: false,
                devToolsEnabled: (0, (0, parcelRequire("co1wz")).ff)('uip.vc.devtools', false),
                selectorConfig: {
                    id: true,
                    role: true,
                    className: true,
                    testId: false
                },
                ssr: (0, (0, parcelRequire("co1wz")).ff)('uip.vc.ssr', false),
                stopVCAtInteractionFinish: (0, (0, parcelRequire("4R6GH")).fg)('stop_vc_at_interaction_finish')
            },
            enableBetterPageVisibilityApi: (0, (0, parcelRequire("co1wz")).ff)('uip.vc.better-page-visibility', false)
        });
    }
});
parcelRegister("lANdF", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$62d1dc5c906adae4$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getBundleEvalTimings", ()=>$62d1dc5c906adae4$export$2eda1519e91a4386);
    var $bdDDw;
    let $62d1dc5c906adae4$var$config = null;
    function $62d1dc5c906adae4$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
        $62d1dc5c906adae4$var$config = bundleEvalTimingConfiguration;
    }
    const $62d1dc5c906adae4$var$getPerformanceObject = ()=>(window ?? {}).performance;
    function $62d1dc5c906adae4$export$2eda1519e91a4386(interactionStartTime) {
        if ($62d1dc5c906adae4$var$config == null) return {};
        const started = {};
        const timings = {};
        const cachedConfig = $62d1dc5c906adae4$var$config;
        const performance = $62d1dc5c906adae4$var$getPerformanceObject();
        performance?.getEntriesByType('mark').forEach((mark)=>{
            const result = cachedConfig.mapPerformanceMark(mark.name);
            if (!result) return;
            const { type: type, name: name } = result;
            if (type === 'start' && mark.startTime >= interactionStartTime) {
                started[name] = mark;
                return;
            }
            if (type === 'end' && started[name]) {
                timings[name] = {
                    startTime: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(started[name].startTime - interactionStartTime),
                    duration: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(mark.startTime - started[name].startTime)
                };
                delete started[name];
            }
        });
        if (Object.keys(timings).length === 0) return {};
        return timings;
    }
});
parcelRegister("bdDDw", function(module, exports) {
    $parcel$export(module.exports, "roundEpsilon", ()=>$f25e0154c492e45e$export$56014375de40214b);
    const $f25e0154c492e45e$export$56014375de40214b = (num, places = 3)=>{
        const factor = Math.pow(10, places);
        return Math.round((num + Number.EPSILON) * factor) / factor;
    };
});
parcelRegister("auAY8", function(module, exports) {
    $parcel$export(module.exports, "init", ()=>$78c94c158b70469a$export$2cd8252107eb640b);
    var $gg6CF = parcelRequire("gg6CF");
    var $5DPhz;
    var $fe1wc;
    var $37gc9;
    var $bFU4G;
    var $a0hd6;
    let $78c94c158b70469a$var$initialized = false;
    function $78c94c158b70469a$var$sinkInteraction(instance, payloadPackage) {
        (0, (0, parcelRequire("bFU4G")).sinkInteractionHandler)((interactionId, interaction)=>{
            (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
                const payloads = payloadPackage.createPayloads(interactionId, interaction);
                payloads?.forEach((payload)=>{
                    instance.sendOperationalEvent(payload);
                });
            });
        });
    }
    function $78c94c158b70469a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
        (0, (0, parcelRequire("bFU4G")).sinkPostInteractionLogHandler)((logOutput)=>{
            (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
                const payload = createPostInteractionLogPayload(logOutput);
                if (payload) instance.sendOperationalEvent(payload);
            });
        });
    }
    const $78c94c158b70469a$export$2cd8252107eb640b = (analyticsWebClientAsync, config)=>{
        if ($78c94c158b70469a$var$initialized) return;
        (0, (0, parcelRequire("fe1wc")).setUFOConfig)(config);
        if (config.vc?.enabled) {
            const vcOptions = {
                heatmapSize: config.vc.heatmapSize,
                oldDomUpdates: config.vc.oldDomUpdates,
                devToolsEnabled: config.vc.devToolsEnabled,
                selectorConfig: config.vc.selectorConfig
            };
            (0, (0, parcelRequire("a0hd6")).getVCObserver)(vcOptions).start({
                startTime: 0
            });
            (0, (0, parcelRequire("bFU4G")).postInteractionLog).initializeVCObserver(vcOptions);
            (0, (0, parcelRequire("bFU4G")).postInteractionLog).startVCObserver({
                startTime: 0
            });
        }
        (0, (0, parcelRequire("37gc9")).setupHiddenTimingCapture)();
        (0, (0, parcelRequire("5DPhz")).startLighthouseObserver)();
        $78c94c158b70469a$var$initialized = true;
        Promise.all([
            analyticsWebClientAsync,
            (parcelRequire("aFpFt")),
            (parcelRequire("aKux0"))
        ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
            if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
                const instance = client.getInstance();
                $78c94c158b70469a$var$sinkInteraction(instance, payloadPackage);
                if (config.postInteractionLog?.enabled) $78c94c158b70469a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            });
            else if (awc.sendOperationalEvent) {
                $78c94c158b70469a$var$sinkInteraction(awc, payloadPackage);
                if (config.postInteractionLog?.enabled) $78c94c158b70469a$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            }
        });
    };
});
parcelRegister("5DPhz", function(module, exports) {
    $parcel$export(module.exports, "startLighthouseObserver", ()=>$0fa54be9bd80e4ab$export$5ecf2aafafee3e0);
    $parcel$export(module.exports, "getLighthouseMetrics", ()=>$0fa54be9bd80e4ab$export$b46cecdf698e4bb5);
    var $92xAz;
    var $jKaCJ;
    var $l7wnP;
    var $k0uhA;
    var $7cMne;
    function $0fa54be9bd80e4ab$export$5ecf2aafafee3e0() {
        (0, (0, parcelRequire("7cMne")).startLSObserver)();
        (0, (0, parcelRequire("7cMne")).startLTObserver)();
    }
    const $0fa54be9bd80e4ab$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
        const tbt = (0, (0, parcelRequire("l7wnP")).getTBT)(start, stop, (0, (0, parcelRequire("k0uhA")).EntriesBuffer)[(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask]);
        const cls = (0, (0, parcelRequire("92xAz")).getCLS)(start, stop, (0, (0, parcelRequire("k0uhA")).EntriesBuffer)[(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift]);
        return {
            'metric:tbt': Math.round(tbt.total),
            'metric:tbt:observed': Math.round(tbt.observed),
            'metric:cls': cls
        };
    };
});
parcelRegister("92xAz", function(module, exports) {
    $parcel$export(module.exports, "getCLS", ()=>$cb361e890ff4f9d8$export$fc6227831ee7c7);
    const $cb361e890ff4f9d8$export$fc6227831ee7c7 = (start, stop, buffer)=>{
        const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
        const sessionWindows = [];
        let currentWindow = null;
        for (const shift of layoutShifts){
            const { startTime: startTime } = shift;
            const endTime = shift.startTime + shift.duration;
            const score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
        const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
        return Math.round(maxScore * 10000) / 10000;
    };
});
parcelRegister("jKaCJ", function(module, exports) {
    $parcel$export(module.exports, "PerformanceObserverEntryTypes", ()=>$c867e70954b5231d$export$a4def92db6fc8e17);
    const $c867e70954b5231d$export$a4def92db6fc8e17 = {
        LayoutShift: 'layout-shift',
        LongTask: 'longtask'
    };
});
parcelRegister("l7wnP", function(module, exports) {
    $parcel$export(module.exports, "getTBT", ()=>$db26c18e70d86e5d$export$2d6e933b35bd3407);
    const $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
    const $db26c18e70d86e5d$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
            const longTaskStop = entry.startTime + entry.duration;
            const intersectStart = Math.max(entry.startTime + $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION, start);
            const intersectStop = Math.min(longTaskStop, stop);
            const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
            tbt.observed += entry.duration - $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION;
            tbt.total += longTaskIncluded;
            return tbt;
        }, {
            total: 0,
            observed: 0
        });
});
parcelRegister("k0uhA", function(module, exports) {
    $parcel$export(module.exports, "EntriesBuffer", ()=>$74df48ec3def97f8$export$f7dc16cbd16f7bbe);
    var $jKaCJ;
    class $74df48ec3def97f8$export$2c6e86519c9e8188 {
        constructor(maxLength = 1000){
            this.buffer = [];
            this.full = false;
            this.maxLength = maxLength;
        }
        push(item) {
            if (this.full || this.maxLength === this.buffer.length) {
                this.full = true;
                this.buffer.shift();
            }
            this.buffer.push(item);
        }
        getAll() {
            return this.buffer;
        }
    }
    const $74df48ec3def97f8$export$f7dc16cbd16f7bbe = {
        [(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask]: new $74df48ec3def97f8$export$2c6e86519c9e8188(),
        [(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift]: new $74df48ec3def97f8$export$2c6e86519c9e8188()
    };
});
parcelRegister("7cMne", function(module, exports) {
    $parcel$export(module.exports, "startLSObserver", ()=>$1e6ef4fbf892be45$export$768ccc3ab7bac3ea);
    $parcel$export(module.exports, "startLTObserver", ()=>$1e6ef4fbf892be45$export$54fb8b6aaf70ec9c);
    var $jKaCJ;
    var $k0uhA;
    let $1e6ef4fbf892be45$var$pe = null;
    const $1e6ef4fbf892be45$var$getObserver = ()=>{
        if ($1e6ef4fbf892be45$var$pe !== null) return $1e6ef4fbf892be45$var$pe;
        $1e6ef4fbf892be45$var$pe = new PerformanceObserver((list)=>{
            list.getEntries().forEach((entry)=>{
                if (entry.entryType === (0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift) (0, (0, parcelRequire("k0uhA")).EntriesBuffer)[(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift].push(entry);
                if (entry.entryType === (0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask) (0, (0, parcelRequire("k0uhA")).EntriesBuffer)[(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask].push(entry);
            });
        });
        return $1e6ef4fbf892be45$var$pe;
    };
    const $1e6ef4fbf892be45$export$768ccc3ab7bac3ea = ()=>{
        $1e6ef4fbf892be45$var$getObserver().observe({
            type: (0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift,
            buffered: true
        });
    };
    const $1e6ef4fbf892be45$export$54fb8b6aaf70ec9c = ()=>{
        $1e6ef4fbf892be45$var$getObserver().observe({
            type: (0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask,
            buffered: true
        });
    };
});
parcelRegister("37gc9", function(module, exports) {
    $parcel$export(module.exports, "setupHiddenTimingCapture", ()=>$9d4714fe1b0ac403$export$554cefe0f0373da4);
    $parcel$export(module.exports, "getPageVisibilityState", ()=>$9d4714fe1b0ac403$export$768b2008623433e1);
    var $cBeZP;
    const $9d4714fe1b0ac403$var$timings = [];
    let $9d4714fe1b0ac403$var$wasHiddenFlag;
    let $9d4714fe1b0ac403$var$setupFlag = false;
    function $9d4714fe1b0ac403$var$isPageHidden() {
        if ('visibilityState' in document) return document.visibilityState === 'hidden';
        else return document.hidden;
    }
    const $9d4714fe1b0ac403$var$SIZE = 50;
    let $9d4714fe1b0ac403$var$insertIndex = 0;
    function $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, time) {
        $9d4714fe1b0ac403$var$timings[$9d4714fe1b0ac403$var$insertIndex] = {
            time: time ?? performance.now(),
            hidden: isPageHiddenFlag
        };
        $9d4714fe1b0ac403$var$insertIndex = ($9d4714fe1b0ac403$var$insertIndex + 1) % $9d4714fe1b0ac403$var$SIZE;
        $9d4714fe1b0ac403$var$wasHiddenFlag = isPageHiddenFlag;
    }
    function $9d4714fe1b0ac403$var$handleChange() {
        const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
        if (isPageHiddenFlag) {
            if (!$9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
            $9d4714fe1b0ac403$var$wasHiddenFlag = true;
        } else {
            if ($9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
            $9d4714fe1b0ac403$var$wasHiddenFlag = false;
        }
    }
    function $9d4714fe1b0ac403$var$setup() {
        (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'pageshow',
            listener: $9d4714fe1b0ac403$var$handleChange
        });
        (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'pagehide',
            listener: $9d4714fe1b0ac403$var$handleChange
        });
        (0, (0, parcelRequire("cBeZP")).bind)(document, {
            type: 'visibilitychange',
            listener: $9d4714fe1b0ac403$var$handleChange
        });
    }
    function $9d4714fe1b0ac403$export$554cefe0f0373da4() {
        if (!$9d4714fe1b0ac403$var$setupFlag) {
            const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
            $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, 0);
            $9d4714fe1b0ac403$var$setup();
            $9d4714fe1b0ac403$var$setupFlag = true;
        }
    }
    function $9d4714fe1b0ac403$export$768b2008623433e1(start, end) {
        if ($9d4714fe1b0ac403$var$timings.length === 0) return 'visible';
        const currentSize = $9d4714fe1b0ac403$var$timings.length;
        let hiddenState = 'mixed';
        let startIdx = $9d4714fe1b0ac403$var$insertIndex;
        let endIdx = $9d4714fe1b0ac403$var$insertIndex;
        for(let i = 0; i < currentSize; i++){
            const tmpIdx = ($9d4714fe1b0ac403$var$insertIndex + i) % currentSize;
            if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= end) {
                endIdx = tmpIdx;
                if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
            }
        }
        if (endIdx - startIdx === 0) {
            if ($9d4714fe1b0ac403$var$timings[startIdx].hidden) hiddenState = 'hidden';
            else hiddenState = 'visible';
        }
        return hiddenState;
    }
});
parcelRegister("aFpFt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hjKrw").then(()=>parcelRequire('42zNJ'));
});
parcelRegister("aKux0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fvMNS").then(()=>parcelRequire('8OVem'));
});
parcelRegister("3vLAR", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$0b58edb89023fc57$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getConfig", ()=>$0b58edb89023fc57$export$44487a86467333c3);
    var $fe1wc;
    const $0b58edb89023fc57$var$defaultAllowedParams = [
        'operationName',
        'operation',
        'q'
    ];
    const $0b58edb89023fc57$var$getAllowedParams = ()=>{
        const config = (0, (0, parcelRequire("fe1wc")).getConfig)();
        return config?.allowedResourcesParams || $0b58edb89023fc57$var$defaultAllowedParams;
    };
    const $0b58edb89023fc57$var$handleQueryParams = (urlString)=>{
        try {
            if (typeof urlString !== 'string') return urlString;
            const url = new URL(urlString);
            const params = new URLSearchParams(url.search);
            const allowedParams = $0b58edb89023fc57$var$getAllowedParams();
            for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
            return url.toString();
        } catch (e) {
            return urlString;
        }
    };
    let $0b58edb89023fc57$var$config = {
        mapResources: (url)=>url,
        sanitiseEndpoints: (url)=>{
            return $0b58edb89023fc57$var$handleQueryParams(url);
        }
    };
    function $0b58edb89023fc57$export$8d21e34596265fa2(resourceTimingConfig) {
        const newConfig = {
            mapResources: resourceTimingConfig.mapResources,
            sanitiseEndpoints: (url)=>{
                const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
                if (sanitised) return $0b58edb89023fc57$var$handleQueryParams(sanitised);
                return sanitised;
            }
        };
        $0b58edb89023fc57$var$config = newConfig;
    }
    const $0b58edb89023fc57$export$44487a86467333c3 = ()=>$0b58edb89023fc57$var$config;
});
parcelRegister("ievYU", function(module, exports) {
    $parcel$export(module.exports, "startResourceTimingBuffer", ()=>$3ebfc8234e313f10$export$a311cb1baa7d2d62);
    var $8aEFN;
    function $3ebfc8234e313f10$export$a311cb1baa7d2d62() {
        (0, (0, parcelRequire("8aEFN")).resourceTimingBuffer).start();
    }
});
parcelRegister("8aEFN", function(module, exports) {
    $parcel$export(module.exports, "resourceTimingBuffer", ()=>$33f750350a029cdd$export$bea963256235a63e);
    $parcel$export(module.exports, "filterResourceTimings", ()=>$33f750350a029cdd$export$4138a729ef1db028);
    var $bdDDw;
    const $33f750350a029cdd$var$getPerformanceObject = ()=>(window ?? {}).performance;
    const $33f750350a029cdd$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
    const $33f750350a029cdd$export$bea963256235a63e = {
        timings: [],
        maxSize: 1000,
        observer: null,
        transformResource: (entry)=>{
            const duration = (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.duration);
            const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find((timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
            const serverTime = totalBackendTimeEntry ? (0, (0, parcelRequire("bdDDw")).roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
            const networkTime = serverTime ? duration - serverTime : undefined;
            return {
                name: entry.name,
                initiatorType: entry.initiatorType,
                transferSize: entry.transferSize,
                startTime: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.startTime),
                duration: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.duration),
                fetchStart: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.fetchStart || 0),
                workerStart: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.workerStart || 0),
                responseStart: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.responseStart || 0),
                requestStart: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.requestStart || 0),
                serverTime: serverTime,
                networkTime: networkTime,
                encodedSize: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.encodedBodySize),
                decodedSize: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.decodedBodySize)
            };
        },
        start: ()=>{
            const performance = $33f750350a029cdd$var$getPerformanceObject();
            const PerformanceObserver = $33f750350a029cdd$var$getPerformanceObserverObject();
            if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
            if ($33f750350a029cdd$export$bea963256235a63e.observer) return;
            const resources = performance.getEntriesByType?.('resource');
            if (resources) $33f750350a029cdd$export$bea963256235a63e.timings = resources.map((resource)=>$33f750350a029cdd$export$bea963256235a63e.transformResource(resource));
            $33f750350a029cdd$export$bea963256235a63e.observer = new PerformanceObserver($33f750350a029cdd$export$bea963256235a63e.addTimings);
            $33f750350a029cdd$export$bea963256235a63e.observer.observe({
                entryTypes: [
                    'resource'
                ]
            });
        },
        stop: ()=>{
            if ($33f750350a029cdd$export$bea963256235a63e.observer) {
                $33f750350a029cdd$export$bea963256235a63e.observer.disconnect();
                $33f750350a029cdd$export$bea963256235a63e.observer = null;
            }
            $33f750350a029cdd$export$bea963256235a63e.timings = [];
        },
        addTimings: (list)=>{
            const entries = list.getEntries().map((entry)=>$33f750350a029cdd$export$bea963256235a63e.transformResource(entry));
            const overflow = $33f750350a029cdd$export$bea963256235a63e.timings.length + entries.length;
            if (overflow > $33f750350a029cdd$export$bea963256235a63e.maxSize) {
                const fieldsToRemove = overflow - $33f750350a029cdd$export$bea963256235a63e.maxSize;
                $33f750350a029cdd$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
            }
            $33f750350a029cdd$export$bea963256235a63e.timings.push(...entries);
        }
    };
    const $33f750350a029cdd$var$isValidTiming = (timing, startTime, endTime)=>timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
    const $33f750350a029cdd$export$4138a729ef1db028 = (startTime, endTime)=>{
        const performance = $33f750350a029cdd$var$getPerformanceObject();
        const PerformanceObserver = $33f750350a029cdd$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !$33f750350a029cdd$export$bea963256235a63e.observer) {
            const resources = performance?.getEntriesByType('resource');
            if (resources) return resources.filter((timing)=>$33f750350a029cdd$var$isValidTiming(timing, startTime, endTime));
            return null;
        }
        return $33f750350a029cdd$export$bea963256235a63e.timings.filter((timing)=>$33f750350a029cdd$var$isValidTiming(timing, startTime, endTime));
    };
});
parcelRegister("cPbc1", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$b6a66b7de4cc2962$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getSSRTimings", ()=>$b6a66b7de4cc2962$export$bf7408e83532dcd0);
    $parcel$export(module.exports, "getSSRSuccess", ()=>$b6a66b7de4cc2962$export$c7ad864055e75537);
    $parcel$export(module.exports, "getSSRDoneTime", ()=>$b6a66b7de4cc2962$export$3def7672244bab0c);
    $parcel$export(module.exports, "getSSRFeatureFlags", ()=>$b6a66b7de4cc2962$export$1c4a9b5e6e22393d);
    const $b6a66b7de4cc2962$var$NESTED_METRIC_SEPARATOR = '/';
    const $b6a66b7de4cc2962$var$filterEntry = (entry)=>!(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
    const $b6a66b7de4cc2962$var$mapEntry = (entry)=>({
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration)
        });
    const $b6a66b7de4cc2962$var$SSR_PREFIX = 'ssr';
    const $b6a66b7de4cc2962$var$mapKey = (key)=>{
        if (key === 'total') return $b6a66b7de4cc2962$var$SSR_PREFIX;
        return `${$b6a66b7de4cc2962$var$SSR_PREFIX}${$b6a66b7de4cc2962$var$NESTED_METRIC_SEPARATOR}${key}`;
    };
    let $b6a66b7de4cc2962$var$config;
    function $b6a66b7de4cc2962$export$8d21e34596265fa2(ssrConfig) {
        $b6a66b7de4cc2962$var$config = ssrConfig;
    }
    function $b6a66b7de4cc2962$export$bf7408e83532dcd0() {
        if (!$b6a66b7de4cc2962$var$config?.getTimings) return {};
        const timings = $b6a66b7de4cc2962$var$config.getTimings();
        if (!timings) return {};
        const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
            if ($b6a66b7de4cc2962$var$filterEntry(entry[1])) acc[$b6a66b7de4cc2962$var$mapKey(entry[0])] = $b6a66b7de4cc2962$var$mapEntry(entry[1]);
            return acc;
        }, {});
        return ssrTimings;
    }
    function $b6a66b7de4cc2962$export$c7ad864055e75537() {
        return !!$b6a66b7de4cc2962$var$config?.getDoneMark();
    }
    function $b6a66b7de4cc2962$export$3def7672244bab0c() {
        return $b6a66b7de4cc2962$var$config?.getDoneMark() ?? undefined;
    }
    function $b6a66b7de4cc2962$export$1c4a9b5e6e22393d() {
        if (!$b6a66b7de4cc2962$var$config?.getFeatureFlags) return undefined;
        try {
            return $b6a66b7de4cc2962$var$config.getFeatureFlags() ?? undefined;
        } catch (e) {}
        return undefined;
    }
});
parcelRegister("aZWa4", function(module, exports) {
    $parcel$export(module.exports, "retrieveAndSetPageLoadTrace", ()=>$b515f2bc55199ff5$export$1a71d2bbe236de99);
    var $tcn7E;
    let $b515f2bc55199ff5$var$alreadySet = false;
    const $b515f2bc55199ff5$export$1a71d2bbe236de99 = (getMeta)=>{
        if (false || $b515f2bc55199ff5$var$alreadySet) return;
        const traceId = getMeta('X-B3-TraceId') || '';
        const spanId = traceId?.substring(traceId.length - 16) || '';
        $b515f2bc55199ff5$var$alreadySet = true;
        (0, (0, parcelRequire("tcn7E")).setActiveTrace)(traceId, spanId, 'page_load');
    };
});
parcelRegister("3dQJA", function(module, exports) {
    $parcel$export(module.exports, "getJiraCustomData", ()=>$f5569bfee184b069$export$abf5e20822fa925);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    var $3HwlS;
    var $sUexw;
    var $5YDBW;
    var $5uZVJ;
    var $eV38z;
    var $jgkaQ;
    var $9NJeU;
    var $3Itig;
    var $6R03U;
    var $bo7zb;
    var $ax2PR;
    var $4xsv9;
    function $f5569bfee184b069$export$abf5e20822fa925(interaction) {
        let customData = {};
        const shard = (0, (0, parcelRequire("j8DrX")).default)('ajs-shard');
        if (shard !== null && shard !== '') customData.shard = shard;
        customData['network:assetEncoding'] = (0, (0, parcelRequire("sUexw")).getAssetEncoding)();
        const buildVariant = window.BUILD_VARIANT;
        if (buildVariant) customData['app:buildVariant'] = buildVariant;
        const bundlerVersion = window.BUNDLER_VERSION;
        if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
        const useBifrostGateway = window.USE_BIFROST_GATEWAY;
        if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
        customData.navType = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? 'nav4' : 'nav3';
        customData.httpProtocol = performance.getEntriesByType('resource').find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
        const { start: start, end: end, apdex: apdex } = interaction;
        const stop = apdex?.[0]?.stopTime ?? end;
        customData.memory = (0, (0, parcelRequire("9NJeU")).getMemoryUsageReport)({
            start: start,
            stop: stop
        });
        const lightHouseMetrics = (0, (0, parcelRequire("eV38z")).getLighthouseMetrics)({
            start: start,
            stop: stop
        });
        customData = {
            ...customData,
            ...lightHouseMetrics
        };
        if (interaction.type === 'page_load') customData = {
            ...customData,
            ...(0, (0, parcelRequire("jgkaQ")).getMarks)({
                start: start
            }),
            ...(0, (0, parcelRequire("3Itig")).getPageSizeMetrics)(),
            ...(0, (0, parcelRequire("3Itig")).getExtraNavigationTimings)(),
            ...(0, (0, parcelRequire("bo7zb")).getServerDurationMetrics)(),
            ...(0, (0, parcelRequire("6R03U")).getRouterResourceMetrics)(),
            ...(0, (0, parcelRequire("4xsv9")).getWRMStats)(),
            ...(0, (0, parcelRequire("3Itig")).getPageSizeInfo)({
                start: start,
                stop: stop
            }),
            ...(0, (0, parcelRequire("5YDBW")).getCacheHitRatio)({
                start: start
            }),
            ...(0, (0, parcelRequire("5uZVJ")).getCHRInfo)({
                start: start
            }),
            ...(0, (0, parcelRequire("ax2PR")).getSSRStateInformation)(),
            'app:version:web': window.BUILD_KEY,
            'app:version:ssr': window.SSR_BUILD_KEY,
            'app:framework:name': 'react',
            'app:framework:version': (0, $5uXOq.version)
        };
        return customData;
    }
});
parcelRegister("sUexw", function(module, exports) {
    $parcel$export(module.exports, "getAssetEncoding", ()=>$7cf3b2ddfe1abab1$export$fd12d8f45e126585);
    function $7cf3b2ddfe1abab1$export$fd12d8f45e126585() {
        const assetEncodings = Array.prototype.map.call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')).reduce((acc, i)=>{
            acc[i] = true;
            return acc;
        }, {});
        const uniqueEncodings = Object.keys(assetEncodings).sort();
        let result = 'unknown';
        if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
        if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
        return result;
    }
});
parcelRegister("5YDBW", function(module, exports) {
    $parcel$export(module.exports, "getCacheHitRatio", ()=>$62c0824bd7614469$export$e8a9322c3d9da8a6);
    var $6RCeq;
    const $62c0824bd7614469$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $62c0824bd7614469$var$CACHE_NETWORK = 'network';
    const $62c0824bd7614469$var$CACHE_MEMORY = 'memory';
    const $62c0824bd7614469$var$CACHE_DISK = 'disk';
    const $62c0824bd7614469$var$calculateTransferType = (type, duration, size)=>{
        if (!$62c0824bd7614469$var$cacheableTypes.includes(type)) return $62c0824bd7614469$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $62c0824bd7614469$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $62c0824bd7614469$var$CACHE_DISK;
        if (size === undefined) return null;
        return $62c0824bd7614469$var$CACHE_NETWORK;
    };
    const $62c0824bd7614469$export$e8a9322c3d9da8a6 = ({ start: start })=>{
        let fromCache = 0;
        let preloadFromCache = 0;
        let total = 0;
        let totalPreload = 0;
        if (start !== 0) return {};
        try {
            for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource')){
                const transferType = $62c0824bd7614469$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
                const isPreload = entry.initiatorType === 'link';
                if (transferType === 'disk' || transferType === 'memory') {
                    fromCache += 1;
                    if (isPreload) preloadFromCache += 1;
                }
                if (transferType !== null) {
                    total += 1;
                    if (isPreload) totalPreload += 1;
                }
            }
            const result = {};
            if (total > 0) result.cacheHitRatio = fromCache / total;
            if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
            return result;
        } catch (e) {
            return {};
        }
    };
});
parcelRegister("5uZVJ", function(module, exports) {
    $parcel$export(module.exports, "getCHRInfo", ()=>$e76f22784dfe18ae$export$9e005e111be93521);
    var $x9xyg;
    var $6RCeq;
    var $d1SfZ;
    const $e76f22784dfe18ae$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
    const $e76f22784dfe18ae$export$1faf7d001841a41c = ()=>(0, (0, parcelRequire("x9xyg")).getMark)($e76f22784dfe18ae$var$SPA_SSR_RENDERED)?.startTime || null;
    const $e76f22784dfe18ae$export$9e005e111be93521 = ({ start: start })=>{
        if (start !== 0) return {};
        const ssrMark = $e76f22784dfe18ae$export$1faf7d001841a41c();
        const reporter = new (0, (0, parcelRequire("d1SfZ")).CHRReporter)(ssrMark);
        try {
            for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource'))reporter.add(entry);
            const chr = reporter.get();
            return chr === null ? {} : {
                chr: chr
            };
        } catch (e) {
            return {};
        }
    };
});
parcelRegister("d1SfZ", function(module, exports) {
    $parcel$export(module.exports, "CHRReporter", ()=>$850475b27a81c50e$export$7d0d4cfb6455ffa5);
    var $80WiQ;
    var $d1r8j;
    class $850475b27a81c50e$export$7d0d4cfb6455ffa5 {
        constructor(ssrMark){
            this.preloaded = new (0, (0, parcelRequire("d1r8j")).CHRSummary)();
            this.all = new (0, (0, parcelRequire("d1r8j")).CHRSummary)();
            this.ssrMark = null;
            this.ssrMark = ssrMark;
        }
        add(item) {
            if (item.encodedBodySize === 0) return;
            if (item.initiatorType === 'link' && (0, (0, parcelRequire("80WiQ")).cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
            this.all.add(item);
        }
        static round(n) {
            return Math.round(n * 10000) / 10000;
        }
        makePayload(summary) {
            const bundlesLoadType = {
                mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] / summary.bundlesCount),
                disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY] / summary.bundlesCount),
                net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).NETWORK_KEY] / summary.bundlesCount)
            };
            const bundlesRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] + summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY]) / summary.bundlesCount);
            const sizeLoadType = {
                mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] / summary.sizeTotal),
                disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY] / summary.sizeTotal),
                net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).NETWORK_KEY] / summary.sizeTotal)
            };
            const sizeRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] + summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY]) / summary.sizeTotal);
            return {
                bundles: {
                    ratio: bundlesRatio,
                    count: summary.bundlesCount,
                    loadType: bundlesLoadType
                },
                size: {
                    ratio: sizeRatio,
                    total: summary.sizeTotal,
                    loadType: sizeLoadType
                }
            };
        }
        get() {
            if (this.all.bundlesCount === 0) return null;
            return {
                preloaded: this.makePayload(this.preloaded),
                all: this.makePayload(this.all)
            };
        }
    }
});
parcelRegister("80WiQ", function(module, exports) {
    $parcel$export(module.exports, "cacheableTypes", ()=>$0b57baf495baebc5$export$5e1aa91d6932ddaa);
    const $0b57baf495baebc5$export$5e1aa91d6932ddaa = [
        'script',
        'link'
    ];
});
parcelRegister("d1r8j", function(module, exports) {
    $parcel$export(module.exports, "CHRSummary", ()=>$d000becd84478ee1$export$783d6618ee601ba);
    var $80WiQ;
    const $d000becd84478ee1$var$calculateTransferType = (type, duration, size)=>{
        if (!(0, (0, parcelRequire("80WiQ")).cacheableTypes).includes(type)) return null;
        if ((size === undefined || size === 0) && duration === 0) return $d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY;
        if (size === 0 && duration > 0) return $d000becd84478ee1$export$783d6618ee601ba.DISK_KEY;
        if (size === undefined) return null;
        return $d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY;
    };
    class $d000becd84478ee1$export$783d6618ee601ba {
        static{
            this.MEMORY_KEY = 'mem';
        }
        static{
            this.DISK_KEY = 'disk';
        }
        static{
            this.NETWORK_KEY = 'net';
        }
        add(item) {
            const type = $d000becd84478ee1$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
            if (type === null) return;
            this.bundles[type] += 1;
            this.bundlesCount += 1;
            this.size[type] += item.encodedBodySize;
            this.sizeTotal += item.encodedBodySize;
        }
        constructor(){
            this.bundles = {
                [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
            };
            this.bundlesCount = 0;
            this.size = {
                [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
            };
            this.sizeTotal = 0;
        }
    }
});
parcelRegister("eV38z", function(module, exports) {
    $parcel$export(module.exports, "getLighthouseMetrics", ()=>$45336243ca9d66b9$export$b46cecdf698e4bb5);
    var $akIBh;
    var $5HXkx;
    var $7hESW;
    var $aOwtG;
    var $8YqT3;
    function $45336243ca9d66b9$export$5ecf2aafafee3e0() {
        (0, (0, parcelRequire("8YqT3")).startLSObserver)();
        (0, (0, parcelRequire("8YqT3")).startLTObserver)();
    }
    const $45336243ca9d66b9$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
        const tbt = (0, (0, parcelRequire("7hESW")).getTBT)(start, stop, (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask]);
        const cls = (0, (0, parcelRequire("akIBh")).getCLS)(start, stop, (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift]);
        return {
            'metric:tbt': Math.round(tbt.total),
            'metric:tbt:observed': Math.round(tbt.observed),
            'metric:cls': cls
        };
    };
});
parcelRegister("akIBh", function(module, exports) {
    $parcel$export(module.exports, "getCLS", ()=>$b182c515ac203eb1$export$fc6227831ee7c7);
    const $b182c515ac203eb1$export$fc6227831ee7c7 = (start, stop, buffer)=>{
        const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
        const sessionWindows = [];
        let currentWindow = null;
        for (const shift of layoutShifts){
            const { startTime: startTime } = shift;
            const endTime = shift.startTime + shift.duration;
            const score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
        const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
        return Math.round(maxScore * 10000) / 10000;
    };
});
parcelRegister("5HXkx", function(module, exports) {
    $parcel$export(module.exports, "PerformanceObserverEntryTypes", ()=>$b2a196da23758bb0$export$a4def92db6fc8e17);
    const $b2a196da23758bb0$export$a4def92db6fc8e17 = {
        LayoutShift: 'layout-shift',
        LongTask: 'longtask'
    };
});
parcelRegister("7hESW", function(module, exports) {
    $parcel$export(module.exports, "getTBT", ()=>$e79996724decdf66$export$2d6e933b35bd3407);
    const $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
    const $e79996724decdf66$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
            const longTaskStop = entry.startTime + entry.duration;
            const intersectStart = Math.max(entry.startTime + $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION, start);
            const intersectStop = Math.min(longTaskStop, stop);
            const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
            tbt.observed += entry.duration - $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION;
            tbt.total += longTaskIncluded;
            return tbt;
        }, {
            total: 0,
            observed: 0
        });
});
parcelRegister("aOwtG", function(module, exports) {
    $parcel$export(module.exports, "EntriesBuffer", ()=>$14dd3fd4391f2796$export$f7dc16cbd16f7bbe);
    var $5HXkx;
    class $14dd3fd4391f2796$export$2c6e86519c9e8188 {
        constructor(maxLength = 1000){
            this.buffer = [];
            this.full = false;
            this.maxLength = maxLength;
        }
        push(item) {
            if (this.full || this.maxLength === this.buffer.length) {
                this.full = true;
                this.buffer.shift();
            }
            this.buffer.push(item);
        }
        getAll() {
            return this.buffer;
        }
    }
    const $14dd3fd4391f2796$export$f7dc16cbd16f7bbe = {
        [(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask]: new $14dd3fd4391f2796$export$2c6e86519c9e8188(),
        [(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift]: new $14dd3fd4391f2796$export$2c6e86519c9e8188()
    };
});
parcelRegister("8YqT3", function(module, exports) {
    $parcel$export(module.exports, "startLSObserver", ()=>$f3198686c7919898$export$768ccc3ab7bac3ea);
    $parcel$export(module.exports, "startLTObserver", ()=>$f3198686c7919898$export$54fb8b6aaf70ec9c);
    var $5HXkx;
    var $aOwtG;
    let $f3198686c7919898$var$pe = null;
    const $f3198686c7919898$var$getObserver = ()=>{
        if ($f3198686c7919898$var$pe !== null) return $f3198686c7919898$var$pe;
        $f3198686c7919898$var$pe = new PerformanceObserver((list)=>{
            list.getEntries().forEach((entry)=>{
                if (entry.entryType === (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift) (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift].push(entry);
                if (entry.entryType === (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask) (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask].push(entry);
            });
        });
        return $f3198686c7919898$var$pe;
    };
    const $f3198686c7919898$export$768ccc3ab7bac3ea = ()=>{
        $f3198686c7919898$var$getObserver().observe({
            type: (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift,
            buffered: true
        });
    };
    const $f3198686c7919898$export$54fb8b6aaf70ec9c = ()=>{
        $f3198686c7919898$var$getObserver().observe({
            type: (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask,
            buffered: true
        });
    };
});
parcelRegister("jgkaQ", function(module, exports) {
    $parcel$export(module.exports, "getMarks", ()=>$0fe8913ad7f2f853$export$9d952633c9c2237b);
    var $bobSR;
    var $fDtbf;
    const $0fe8913ad7f2f853$export$9d952633c9c2237b = (data)=>{
        const userTiming = (0, (0, parcelRequire("bobSR")).getUserTiming)();
        if (userTiming === null) return null;
        const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
        const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
            let candidateName = baseName;
            let counter = 2;
            let validName;
            while(!validName)if (candidateName in collection) {
                candidateName = `${baseName}_${counter}`;
                counter += 1;
            } else validName = candidateName;
            return validName;
        };
        const marks = {};
        userTiming.filter((item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START)) && !item.name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP)) && item.startTime >= data.start).forEach((item)=>{
            const name = getNextAvailableName({
                baseName: `mark__${sanitizeName(item.name)}`,
                collection: marks
            });
            marks[name] = Math.round(item.startTime - data.start);
        });
        return marks;
    };
});
parcelRegister("9NJeU", function(module, exports) {
    $parcel$export(module.exports, "getMemoryUsageReport", ()=>$8fa3790b95082ce5$export$e5bd2d61c7c80651);
    const $8fa3790b95082ce5$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
        if (typeof performance === 'undefined' || performance?.memory == null) return null;
        const sessionTime = Math.round(stop - start);
        const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
        return {
            sessionTime: sessionTime,
            performanceMemoryEntry: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        };
    };
});
parcelRegister("3Itig", function(module, exports) {
    $parcel$export(module.exports, "getPageSizeMetrics", ()=>$d593ead38e6ee650$export$84e3d676f1564c75);
    $parcel$export(module.exports, "getExtraNavigationTimings", ()=>$d593ead38e6ee650$export$b37a70af06e58097);
    $parcel$export(module.exports, "getPageSizeInfo", ()=>$d593ead38e6ee650$export$b72e035af6568be7);
    var $6RCeq;
    const $d593ead38e6ee650$export$84e3d676f1564c75 = ()=>{
        let maxDepth = -1;
        let maxWidth = -1;
        let numElements = 0;
        const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
            if (!el) return;
            if (depth > maxDepth) maxDepth = depth;
            if (el.children.length > maxWidth) maxWidth = el.children.length;
            let child = el.firstElementChild;
            while(child){
                calculateDOMsizeAndDepth(child, depth + 1);
                if (child.shadowRoot) calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
                child = child.nextElementSibling;
                numElements += 1;
            }
        };
        calculateDOMsizeAndDepth();
        return {
            totalBodyElements: numElements,
            maxNestedLevels: maxDepth,
            maxChildElements: maxWidth
        };
    };
    const $d593ead38e6ee650$export$b37a70af06e58097 = ()=>{
        if (!(0, (0, parcelRequire("6RCeq")).default)) return {};
        const navigation = (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('navigation')[0];
        if (!navigation) return {};
        return {
            decodedBodySize: navigation.decodedBodySize,
            encodedBodySize: navigation.encodedBodySize,
            transferSize: navigation.transferSize
        };
    };
    const $d593ead38e6ee650$var$assetsTypes = [
        'script',
        'link'
    ];
    const $d593ead38e6ee650$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
        const pageSize = $d593ead38e6ee650$export$b37a70af06e58097();
        if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
        const decoded = {
            total: pageSize.decodedBodySize,
            pageSize: pageSize.decodedBodySize,
            assets: 0,
            endpoints: 0
        };
        const encoded = {
            total: pageSize.encodedBodySize,
            pageSize: pageSize.encodedBodySize,
            assets: 0,
            endpoints: 0
        };
        const net = {
            total: pageSize.transferSize,
            assets: 0,
            endpoints: 0
        };
        for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource')){
            if (entry.startTime > stop) continue;
            if ($d593ead38e6ee650$var$assetsTypes.includes(entry.initiatorType)) {
                decoded.total += entry.decodedBodySize;
                decoded.assets += entry.decodedBodySize;
                encoded.total += entry.encodedBodySize;
                encoded.assets += entry.encodedBodySize;
                net.total += entry.transferSize;
                net.assets += entry.transferSize;
            } else {
                decoded.total += entry.decodedBodySize;
                decoded.endpoints += entry.decodedBodySize;
                encoded.total += entry.encodedBodySize;
                encoded.endpoints += entry.encodedBodySize;
                net.total += entry.transferSize;
                net.endpoints += entry.transferSize;
            }
        }
        const returnValue = {};
        Object.keys(decoded).forEach((key)=>{
            returnValue[`size:decoded:${key}`] = decoded[key];
        });
        Object.keys(encoded).forEach((key)=>{
            returnValue[`size:encoded:${key}`] = encoded[key];
        });
        Object.keys(net).forEach((key)=>{
            returnValue[`size:net:${key}`] = net[key];
        });
        return returnValue;
    };
});
parcelRegister("6R03U", function(module, exports) {
    $parcel$export(module.exports, "getRouterResourceMetrics", ()=>$7077665729c4125c$export$e703af446a67c7f4);
    const $7077665729c4125c$export$e703af446a67c7f4 = ()=>{
        const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
            if (key !== key.toUpperCase()) return false;
            const resource = window.SPA_STATE[key];
            if (typeof resource !== 'object') return false;
            const resourceResponse = resource[Object.keys(resource)[0]];
            return resourceResponse?.error?.name === 'TimeoutError';
        }) : [];
        return {
            ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
        };
    };
});
parcelRegister("bo7zb", function(module, exports) {
    $parcel$export(module.exports, "getServerDurationMetrics", ()=>$c797c35a7f1d14f1$export$efd8b60b870e5282);
    const $c797c35a7f1d14f1$export$efd8b60b870e5282 = ()=>{
        const metrics = {};
        try {
            const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
            if (serverDurationElem) {
                const serverDuration = Number(serverDurationElem.value);
                if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
            }
            const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
            if (serverTraceIdElem) {
                const serverRequestTraceId = serverTraceIdElem.value;
                metrics.serverRequestTraceId = serverRequestTraceId;
            }
            const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
            if (serverTraceSampledElem) {
                const serverRequestTraceSampled = serverTraceSampledElem.value;
                switch(serverRequestTraceSampled){
                    case 'true':
                        metrics.serverRequestTraceSampled = true;
                        break;
                    case 'false':
                        metrics.serverRequestTraceSampled = false;
                        break;
                    default:
                        metrics.serverRequestTraceSampled = null;
                        break;
                }
            }
            const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
            if (concurrentRequestsElem) {
                const concurrentRequests = concurrentRequestsElem.value;
                metrics.concurrentRequests = concurrentRequests;
            }
            const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
            if (serverRequestStartTimeElem) {
                const serverRequestStartTime = serverRequestStartTimeElem.value;
                metrics.serverRequestStartTime = serverRequestStartTime;
            }
            const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
            if (frontendFlushStartTimeElem) {
                const frontendFlushStartTime = frontendFlushStartTimeElem.value;
                metrics.frontendFlushStartTime = frontendFlushStartTime;
            }
        } catch (ignored) {}
        return metrics;
    };
});
parcelRegister("ax2PR", function(module, exports) {
    $parcel$export(module.exports, "getSSRStateInformation", ()=>$cefad605288b959d$export$9a46186893ad76bd);
    var $x9xyg;
    const $cefad605288b959d$var$getState = ()=>{
        if ((0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.state')?.startTime) return 'success';
        if ((0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
        return 'static-fallback';
    };
    const $cefad605288b959d$export$9a46186893ad76bd = ()=>{
        return {
            'ssr:state': $cefad605288b959d$var$getState()
        };
    };
});
parcelRegister("4xsv9", function(module, exports) {
    $parcel$export(module.exports, "getWRMStats", ()=>$a91d766509875677$export$d2d916ddd03b82bc);
    const $a91d766509875677$export$d2d916ddd03b82bc = ()=>{
        const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
        return {
            wrmStats: wrmStats
        };
    };
});
parcelRegister("fJbQ9", function(module, exports) {
    $parcel$export(module.exports, "jiraBundleEvalTimingsConfig", ()=>$f9b1cc066b55fe02$export$791b8c0cbd574ea9);
    var $fDtbf;
    const $f9b1cc066b55fe02$export$791b8c0cbd574ea9 = {
        mapPerformanceMark: (mark)=>{
            if (mark.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) return {
                name: mark.substring(0, mark.indexOf((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))),
                type: 'start'
            };
            if (mark.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP))) return {
                name: mark.substring(0, mark.indexOf((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP))),
                type: 'end'
            };
            return null;
        }
    };
});
parcelRegister("itoGf", function(module, exports) {
    $parcel$export(module.exports, "jiraResourceTimingsConfig", ()=>$be8f5f0d3efbf58f$export$8fa71550bcdc2104);
    var $aZsz6 = parcelRequire("aZsz6");
    var $6pIol;
    const $be8f5f0d3efbf58f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
    const $be8f5f0d3efbf58f$var$getWRMAssetName = (url)=>{
        const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
        const assetName = (0, (0, parcelRequire("6pIol")).sanitiseAssetName)(false)(url);
        if (!resources) return assetName;
        return `wrm/${resources}/${assetName}`;
    };
    const $be8f5f0d3efbf58f$var$getFileName = (url)=>$be8f5f0d3efbf58f$var$isWRMResource(url) ? $be8f5f0d3efbf58f$var$getWRMAssetName(url) : (0, (0, parcelRequire("6pIol")).sanitiseAssetName)(false)(url);
    const $be8f5f0d3efbf58f$var$sanitiseEndpoints = (url)=>{
        const parsedUrl = (0, ($parcel$interopDefault($aZsz6)))(url, true);
        const { operation: operation, operationName: operationName } = parsedUrl.query;
        const operationNameOverride = operation ?? operationName;
        if (operationNameOverride) return `/${operation}?operation=${operation}`;
        const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>').replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>').replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
        return fileName;
    };
    const $be8f5f0d3efbf58f$export$8fa71550bcdc2104 = {
        sanitiseEndpoints: $be8f5f0d3efbf58f$var$sanitiseEndpoints,
        mapResources: $be8f5f0d3efbf58f$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $be8f5f0d3efbf58f$var$isWRMResource(url),
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
});
parcelRegister("dQKfU", function(module, exports) {
    $parcel$export(module.exports, "jiraSsrConfig", ()=>$ba8cdb329bff9946$export$7bcf91e323db67dd);
    var $LpImS = parcelRequire("LpImS");
    var $x9xyg;
    var $6RCeq;
    var $4R6GH;
    var $j8DrX;
    function $ba8cdb329bff9946$var$insertTotalTiming(key, timings) {
        const timingValues = timings && Object.values(timings);
        if (!timingValues || !timingValues.length) return timings;
        const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
        const endTime = timingValues.reduce((max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
        const duration = endTime - startTime;
        timings[key] = {
            startTime: startTime,
            duration: duration
        };
        return timings;
    }
    function $ba8cdb329bff9946$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
        return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
            const startTime = value.startTime + startTimeOffsetMs;
            return [
                [
                    prefix,
                    key
                ].filter(Boolean).join('/'),
                {
                    ...value,
                    startTime: startTime
                }
            ];
        }));
    }
    function $ba8cdb329bff9946$var$getTesseractTimings() {
        if (!globalThis.SPA_STATE) return null;
        const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
        const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
        const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
        const timings = (0, ($parcel$interopDefault($LpImS)))(detailRenderTrace?.data?.traces) || {};
        if (highLevelMetrics?.data) {
            if ('ssrTotal' in highLevelMetrics.data) {
                const totalKey = (0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings') ? '' : 'total';
                timings[totalKey] = {
                    startTime: 0,
                    duration: highLevelMetrics.data.ssrTotal
                };
            }
            if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
                startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
                duration: highLevelMetrics.data.ssrGetStyle
            };
            if ('ssrPrefetch' in highLevelMetrics.data) {
                const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
                timings.prefetch = {
                    startTime: prefetchStartTime,
                    duration: highLevelMetrics.data.ssrPrefetch
                };
            }
        }
        if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
            timings[`prefetch/${key}`] = value;
        });
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings')) return timings;
        return $ba8cdb329bff9946$var$insertTotalTiming('', timings);
    }
    const $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys = new Set([
        'metatags',
        'feature-flags',
        'statsig',
        'inline-assets',
        'async-inline-assets',
        'css-assets',
        'priority-assets',
        'early-route-flush'
    ]);
    const $ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys = [
        'early-common-flush',
        'prerender-total',
        'resolve-assets'
    ];
    function $ba8cdb329bff9946$var$getJiraFeGatewayTimings() {
        const rawTimings = globalThis._JFGTimings;
        if (!rawTimings) return null;
        const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
                $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
                {
                    startTime: startTime,
                    duration: duration
                }
            ]));
        return $ba8cdb329bff9946$var$insertTotalTiming('', jiraFeGatewayTimings);
    }
    function $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration(timingMetricKey) {
        const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
        return Number(inputElementWithTimingValue?.value ?? 0);
    }
    function $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings() {
        const duration = $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.time');
        if (!duration) return null;
        const timings = {
            '': {
                startTime: 0,
                duration: duration
            },
            'flush-head': {
                startTime: 0,
                duration: $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
            }
        };
        return timings;
    }
    const $ba8cdb329bff9946$var$monolithTimerRenames = {
        'jira-request-server-time': ''
    };
    function $ba8cdb329bff9946$var$getJiraMonolithTimings() {
        if (!globalThis._monolithTimings) return $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings();
        return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
                $ba8cdb329bff9946$var$monolithTimerRenames[name] ?? name,
                {
                    startTime: startTime,
                    duration: duration
                }
            ]));
    }
    function $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
        if (jiraBeTimings || !tesseractTimings) return null;
        const timings = {
            '': {
                startTime: 0,
                duration: tesseractTimings['']?.duration
            }
        };
        return timings;
    }
    function $ba8cdb329bff9946$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
        if (!referenceTimer || !timerToShift) return null;
        if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
        else return referenceTimer.startTime - timerToShift.startTime;
    }
    function $ba8cdb329bff9946$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
        const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
        return $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
    }
    function $ba8cdb329bff9946$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
        const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
        const jiraBeTesseractOffest = $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
        const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
        const bifrostOffset = $ba8cdb329bff9946$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
        return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
    }
    function $ba8cdb329bff9946$var$getEdgeTime() {
        const navigatonPerfTimingEntry = (0, (0, parcelRequire("6RCeq")).default)?.getEntriesByType('navigation')?.[0];
        return navigatonPerfTimingEntry?.serverTiming?.find(({ name: name })=>name === 'atl-edge')?.duration ?? 0;
    }
    function $ba8cdb329bff9946$export$6d488733a547304() {
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings')) return $ba8cdb329bff9946$var$getTesseractTimings();
        const jiraBeTimings = $ba8cdb329bff9946$var$getJiraMonolithTimings();
        const jiraFeGatewayTimings = $ba8cdb329bff9946$var$getJiraFeGatewayTimings();
        const tesseractTimings = $ba8cdb329bff9946$var$getTesseractTimings();
        const bifrostGatewayTimings = $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
        const edgeTime = $ba8cdb329bff9946$var$getEdgeTime();
        const finalJiraBeTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraBeTimings, {
            startTimeOffsetMs: edgeTime,
            prefix: 'jira-monolith'
        });
        const finalBifrostGatewayTimings = $ba8cdb329bff9946$var$applyTimingOverrides(bifrostGatewayTimings, {
            startTimeOffsetMs: edgeTime,
            prefix: 'bifrost-gateway'
        });
        const jfgOffset = $ba8cdb329bff9946$var$getJfgOffset({
            jiraFeGatewayTimings: jiraFeGatewayTimings,
            jiraBeTimings: finalJiraBeTimings
        });
        const finalJfgTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraFeGatewayTimings, {
            startTimeOffsetMs: jfgOffset,
            prefix: 'jira-fe-gateway'
        });
        const tesseractOffset = $ba8cdb329bff9946$var$getTesseractOffset({
            tesseractTimings: tesseractTimings,
            jiraFeGatewayTimings: finalJfgTimings,
            bifrostGatewayTimings: finalBifrostGatewayTimings
        });
        const finalTesseractTimings = $ba8cdb329bff9946$var$applyTimingOverrides(tesseractTimings, {
            startTimeOffsetMs: tesseractOffset,
            prefix: 'tesseract'
        });
        const timings = {
            ...edgeTime && {
                edge: {
                    startTime: 0,
                    duration: edgeTime
                }
            },
            ...finalJiraBeTimings,
            ...finalJfgTimings,
            ...finalBifrostGatewayTimings,
            ...finalTesseractTimings
        };
        $ba8cdb329bff9946$var$insertTotalTiming('total', timings);
        return Object.keys(timings).length ? timings : null;
    }
    const $ba8cdb329bff9946$var$SSR_FF_META_TAG = 'spa-service-flags';
    let $ba8cdb329bff9946$var$ffCache;
    let $ba8cdb329bff9946$var$ffCacheInitialiser = ()=>{
        try {
            const metaTagValue = (0, (0, parcelRequire("j8DrX")).default)($ba8cdb329bff9946$var$SSR_FF_META_TAG);
            if (metaTagValue === null) return null;
            $ba8cdb329bff9946$var$ffCache = JSON.parse(metaTagValue) || null;
        } catch (e) {
            $ba8cdb329bff9946$var$ffCache = null;
        }
        $ba8cdb329bff9946$var$ffCacheInitialiser = null;
    };
    function $ba8cdb329bff9946$var$getFeatureFlags() {
        if ($ba8cdb329bff9946$var$ffCacheInitialiser != null) $ba8cdb329bff9946$var$ffCacheInitialiser();
        return $ba8cdb329bff9946$var$ffCache;
    }
    const $ba8cdb329bff9946$export$7bcf91e323db67dd = {
        getDoneMark: ()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('ssr_success_when_spa_success')) {
                const SPASSRRenderedMark = (0, (0, parcelRequire("x9xyg")).getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime;
                if (SPASSRRenderedMark && (0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.state')?.startTime) return SPASSRRenderedMark;
                return null;
            }
            return (0, (0, parcelRequire("x9xyg")).getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime || null;
        },
        getTimings: $ba8cdb329bff9946$export$6d488733a547304,
        getFeatureFlags: $ba8cdb329bff9946$var$getFeatureFlags
    };
});
parcelRegister("3qHVS", function(module, exports) {
    $parcel$export(module.exports, "visualRefreshResolverOverride", ()=>$56907fa85239d7b0$export$73a94df81a7c0f2c);
    var $dCm1o;
    const $56907fa85239d7b0$var$visualRefreshPlatformFlags = [
        'platform-component-visual-refresh',
        'platform-visual-refresh-icons-legacy-facade',
        'platform-visual-refresh-icons'
    ];
    const $56907fa85239d7b0$export$73a94df81a7c0f2c = [
        (flagKey)=>$56907fa85239d7b0$var$visualRefreshPlatformFlags.includes(flagKey),
        (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)
    ];
});
parcelRegister("2ChuC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe3490a17e762431$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $6YRTH;
    var $co1wz;
    var $j8DrX;
    var $7AZuS = parcelRequire("7AZuS");
    var $7o9iL = parcelRequire("7o9iL");
    const $fe3490a17e762431$var$isHeartbeatEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jfp.heartbeat_vfp2h', false);
    const $fe3490a17e762431$var$renderEngagementMessages = ()=>{
        (parcelRequire("1mY2B"));
    };
    const $fe3490a17e762431$var$renderProfileCardNextLegacy = ()=>{
        (parcelRequire("97qv7"));
    };
    const $fe3490a17e762431$var$renderHeartbeat = ()=>{
        (parcelRequire("5PCBy"));
    };
    const $fe3490a17e762431$var$loadUpFlowAPI = ()=>(parcelRequire("8UcTu"));
    const $fe3490a17e762431$var$installConnectModules = ()=>(parcelRequire("fO7QI"));
    const $fe3490a17e762431$var$markSafeForAnalytics = (str)=>str || null;
    const $fe3490a17e762431$var$renderSearchDwellTimeComponent = ()=>{
        const searchSessionId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-session-id');
        const containerId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-container-id');
        const objectId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-object-id');
        const objectType = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-content-type');
        (0, (0, parcelRequire("6YRTH")).default)([
            'searchSessionId',
            'searchObjectId',
            'searchContainerId',
            'searchContentType'
        ]);
        (0, $7o9iL.default)('search-dwell-time', $fe3490a17e762431$var$markSafeForAnalytics(searchSessionId), {
            containerId: $fe3490a17e762431$var$markSafeForAnalytics(containerId),
            objectId: $fe3490a17e762431$var$markSafeForAnalytics(objectId),
            objectType: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
            actionSubject: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
            source: $fe3490a17e762431$var$markSafeForAnalytics(objectType)
        });
    };
    const $fe3490a17e762431$var$installHighPriorityApps = (args)=>{
        const priorityApps = [];
        if (args.flags) priorityApps.push((0, $7AZuS.renderFlags)());
        if (args.navigation) priorityApps.push(args.renderNavigation());
        return priorityApps;
    };
    const $fe3490a17e762431$var$installLowPriorityApps = (args)=>{
        if (args.upflow) $fe3490a17e762431$var$loadUpFlowAPI();
        if (args.profileCardNextLegacy) $fe3490a17e762431$var$renderProfileCardNextLegacy();
        if (args.connectModules) $fe3490a17e762431$var$installConnectModules();
        if (args.engagementMessages) $fe3490a17e762431$var$renderEngagementMessages();
        if (args.heartbeat) $fe3490a17e762431$var$renderHeartbeat();
        if (args.searchDwellTimeComponent) $fe3490a17e762431$var$renderSearchDwellTimeComponent();
    };
    const $fe3490a17e762431$var$installAppsWithPriorityOrder = async (args)=>{
        await Promise.all($fe3490a17e762431$var$installHighPriorityApps({
            flags: args.flags,
            navigation: args.navigation,
            renderNavigation: args.renderNavigation
        }));
        $fe3490a17e762431$var$installLowPriorityApps((0, ($parcel$interopDefault($fr1K2)))(args, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
    };
    const $fe3490a17e762431$var$defaultArgs = {
        flags: true,
        navigation: true,
        upflow: true,
        profileCardNextLegacy: true,
        heartbeat: $fe3490a17e762431$var$isHeartbeatEnabled(),
        connectModules: true,
        engagementMessages: true,
        searchDwellTimeComponent: true,
        renderNavigation: ()=>null
    };
    var $fe3490a17e762431$export$2e2bcd8739ae039 = {
        install: (args)=>{
            const argsWithDefaults = {
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            };
            $fe3490a17e762431$var$installAppsWithPriorityOrder(argsWithDefaults);
        },
        installHighPriorityApps: (args)=>{
            const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            };
            $fe3490a17e762431$var$installHighPriorityApps({
                flags: flags,
                navigation: navigation,
                renderNavigation: renderNavigation
            });
        },
        installLowPriorityApps: (args)=>{
            const installArgs = (0, ($parcel$interopDefault($fr1K2)))({
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            }, [
                'flags',
                'navigation',
                'renderNavigation'
            ]);
            $fe3490a17e762431$var$installLowPriorityApps(installArgs);
        }
    };
});
parcelRegister("7AZuS", function(module, exports) {
    $parcel$export(module.exports, "renderFlags", ()=>$271711a34feab2aa$export$b6228dc14c5adf51);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $dJl1T;
    var $gG5I6;
    var $1eg3p;
    var $5eQ1m;
    var $kxZPA;
    const $271711a34feab2aa$var$throwError = (message)=>{
        const error = new Error(message);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('flags.entry', message, error);
        throw error;
    };
    const $271711a34feab2aa$var$getContainer = ()=>{
        let container = document.getElementById('flags');
        if (container == null) {
            container = document.createElement('div');
            container.id = 'flags';
            if (document.body) document.body.appendChild(container);
            else $271711a34feab2aa$var$throwError('document.body was not found whilst trying to create the flags container');
        }
        return container;
    };
    const $271711a34feab2aa$var$Flags = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aw7rz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $271711a34feab2aa$var$AfterPaintFlags = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("aw7rz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $271711a34feab2aa$export$b6228dc14c5adf51 = ()=>(0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gG5I6")).JiraContextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: "flags-entry"
        }, __SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$AfterPaintFlags, null) : (0, ($parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$Flags, null)))), $271711a34feab2aa$var$getContainer());
});
parcelRegister("gG5I6", function(module, exports) {
    $parcel$export(module.exports, "JiraContextContainer", ()=>$2e767f203a33f0d2$export$6f7845cc5e693f16);
    var $5uXOq = parcelRequire("5uXOq");
    var $lRFpu;
    var $lzeFL;
    var $5tsrJ;
    var $jb5yn;
    var $j8DrX;
    var $1nUas;
    var $2HbP2;
    var $8ApFP;
    var $iXVV6;
    var $fiv1r;
    var $14XJw;
    var $9OXo1;
    var $a83ud;
    const $2e767f203a33f0d2$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, children);
    const $2e767f203a33f0d2$export$6f7845cc5e693f16 = (props)=>{
        const state = {
            messages: (parcelRequire("hWnRN"))
        };
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2e767f203a33f0d2$var$ContextualAnalyticsDataFeatureFlagged, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1nUas")).IntlProvider), {
                messages: state.messages,
                locale: (0, (0, parcelRequire("lzeFL")).standardizeLocale)(tenantContext.locale)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRFpu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tsrJ")).default), {
                orgId: orgId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jb5yn")).ExperienceTrackerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiv1r")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2HbP2")).ModalContextProvider), null, props.children)))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a83ud")).LoadingPhaseManager), null));
    };
});
parcelRegister("a83ud", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $j7rCb;
    const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
        const { startNextPhase: startNextPhase } = (0, (0, parcelRequire("j7rCb")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            if (__SPA__) return;
            setTimeout(()=>{
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            }, 2000);
        }, [
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("hWnRN", function(module, exports) {
    module.exports = __LANG;
});
parcelRegister("1eg3p", function(module, exports) {
    $parcel$export(module.exports, "FlagsBoundary", ()=>$6fa78f2e53e42d4a$export$8b4a0fffcddd96f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    const $6fa78f2e53e42d4a$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "flags",
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "flags-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, children));
});
parcelRegister("aw7rz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("h46oV")
    ]).then(()=>parcelRequire('3jTq3'));
});
parcelRegister("7o9iL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87698987077682aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $5eQ1m;
    var $TtQEC;
    const $87698987077682aa$var$getPlaceholder = (placeholderId)=>{
        const existingPlaceholder = document.getElementById(placeholderId);
        if (existingPlaceholder) return existingPlaceholder;
        const div = document.createElement('div');
        div.id = placeholderId;
        if (document.body) document.body.appendChild(div);
        else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
        return div;
    };
    const $87698987077682aa$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
        if (placeholder && sessionId) (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TtQEC")).default), {
            sessionId: sessionId,
            data: data
        })), $87698987077682aa$var$getPlaceholder(placeholder));
    };
    var $87698987077682aa$export$2e2bcd8739ae039 = $87698987077682aa$var$renderDwellTimeComponent;
});
parcelRegister("1mY2B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ZtG1")
    ]).then(()=>parcelRequire('2Q8el'));
});
parcelRegister("97qv7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("54DPr")
    ]).then(()=>parcelRequire('forzB'));
});
parcelRegister("5PCBy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bERdS").then(()=>parcelRequire('8ymsB'));
});
parcelRegister("8UcTu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("kWrFZ"),
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("561Jq"),
        $6fhBS("1QYl5"),
        $6fhBS("2Lfdl"),
        $6fhBS("hPzOn"),
        $6fhBS("dsiAd"),
        $6fhBS("eNmuD"),
        $6fhBS("dzRix")
    ]).then(()=>parcelRequire('faPQm'));
});
parcelRegister("fO7QI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("Nlduf")
    ]).then(()=>parcelRequire('jEc6C'));
});
parcelRegister("5UHoB", function(module, exports) {
    $parcel$export(module.exports, "layoutWithCondition", ()=>$201222bac9c3aac5$export$c5db53e93ba35c0f);
    const $201222bac9c3aac5$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
            get isChromeless () {
                return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
            },
            get globalComponents () {
                return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
            },
            get rightSidebars () {
                return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
            }
        });
});
$parcel$global.rwr("jfj4N", ()=>{
    parcelRequire("lRSO6");
    parcelRequire("8oLfs");
    var $x9xyg;
    var $aIZdc;
    var $ffza4;
    var $co1wz;
    var $7XYc4;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $2d9c43db881ab996$export$12b9979f5c1ed5a4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME),
        path: '/jira/settings/system/migration/home'
    };
    const $2d9c43db881ab996$export$b48d38ab4363f197 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD),
        path: '/jira/settings/system/migration/dashboard'
    };
    const $2d9c43db881ab996$export$50ae42a441766ba5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE),
        path: '/jira/settings/system/migration/:step(how-it-works|plan-configuration|choose-projects|choose-group-membership|select-customer|check-for-errors|review|view-details)/:migrationId?'
    };
    var $5lsNZ;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $bc6cc6da8c11fd31$export$422086745f2d10c4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fpTnr"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-dashboard/src/index.tsx"
    });
    var $bc6cc6da8c11fd31$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bc6cc6da8c11fd31$export$422086745f2d10c4,
            pageId: "system-c2c-migrations-dashboard",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d155f242f0f0da60$export$e0c09a0ffb780ae2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4T776"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-focus-page/src/index.tsx"
    });
    var $d155f242f0f0da60$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d155f242f0f0da60$export$e0c09a0ffb780ae2,
            pageId: "system-c2c-migrations-focus-page",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $226e70f7f9e8baab$export$b78d99112db11162 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l0fbZ"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-home/src/index.tsx"
    });
    var $226e70f7f9e8baab$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $226e70f7f9e8baab$export$b78d99112db11162,
            pageId: "system-migrations-home",
            shouldShowSpinner: true
        });
    const $1b9e218c54e1d874$export$debd9f352e8a3e70 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2d9c43db881ab996$export$12b9979f5c1ed5a4), ()=>({
                ufoName: 'admin.c2c-migrations.home',
                canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration'),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $226e70f7f9e8baab$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $226e70f7f9e8baab$export$b78d99112db11162)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2d9c43db881ab996$export$b48d38ab4363f197), ()=>({
                ufoName: 'admin.c2c-migrations.dashboard',
                canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration'),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $bc6cc6da8c11fd31$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $bc6cc6da8c11fd31$export$422086745f2d10c4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2d9c43db881ab996$export$50ae42a441766ba5), ()=>({
                canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration'),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $d155f242f0f0da60$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d155f242f0f0da60$export$e0c09a0ffb780ae2)
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
    const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
    const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
    const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
    const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
    const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
    const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
    const $281cbd47ba46dd7d$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
    const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
    const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
    const $281cbd47ba46dd7d$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
    const $281cbd47ba46dd7d$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
    const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
    const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';
    var $87OsA;
    var $4R6GH;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $1XrjK;
    var $kxZPA;
    const $fa12faadb00e7e4f$export$b6292b5f7e5b5fad = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("BXMfg")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
    });
    const $fa12faadb00e7e4f$export$94e1d79bf65579e2 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            $fa12faadb00e7e4f$export$b6292b5f7e5b5fad
        ]
    });
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $lv9xW;
    var $3RJkv;
    var $9UjCT;
    var $7OYJs;
    var $is7uC;
    var $5j7Th;
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $c3WQb;
    var $7OYJs;
    var $5W2CW;
    var $dIdda = parcelRequire("dIdda");
    const $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS = [
        'search'
    ];
    const $3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
        const [{ query: query }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsScenarioIdResource));
        if (loading || data === null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
    const $3e6624904a2f18eb$export$c3e4fda2290a52bf = ()=>{
        const [{ query: query }] = (0, $dIdda.useRouter)();
        const { id: id, sid: sid } = query;
        if (Number.isNaN(Number.parseFloat(sid))) return (0, ($parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${id}/scenarios/${sid}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
    const $3e6624904a2f18eb$export$ff420400c9900835 = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const { planId: planId } = match.params;
        if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
        const { data: data, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource));
        if (loading || data === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (!data.success) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5W2CW")).ErrorScreen), {
            errorMessage: data.errorMessage
        });
        if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    var $135d7141d14abe41$export$2e2bcd8739ae039 = ()=>{
        const [{ query: query }] = (0, $dIdda.useRouter)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/reports/${query.r}`,
            persistSearchParams: false
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $87OsA;
    var $adY3A;
    const $6a0b20679c309df7$export$56ea489e9d4bfa04 = (page)=>({
            root: page.main.root,
            getPreloadProps: (entryPointParams)=>({
                    entryPoints: {
                        [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                            entryPoint: page.main,
                            entryPointParams: entryPointParams
                        }
                    }
                }),
            toString: ()=>'ChromelessEntryPoint'
        });
    const $6a0b20679c309df7$export$955a7619d2679b4c = (page)=>({
            root: page.main.root,
            getPreloadProps: (entryPointParams)=>({
                    entryPoints: {
                        [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                            entryPoint: page.main,
                            entryPointParams: entryPointParams
                        },
                        [(0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae)]: {
                            entryPoint: (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint),
                            entryPointParams: {
                                menuId: page.topNavigationMenuId
                            }
                        },
                        ...page.horizontalNavigation ? {
                            [(0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3)]: {
                                entryPoint: page.horizontalNavigation,
                                entryPointParams: {}
                            }
                        } : undefined,
                        ...page.rightSidebar ? {
                            [(0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb)]: {
                                entryPoint: page.rightSidebar,
                                entryPointParams: entryPointParams
                            }
                        } : undefined
                    }
                }),
            toString: ()=>'PageEntryPoint'
        });
    var $cSD7y;
    var $4R6GH;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $2Ql51;
    var $65Ltd;
    const $1aa060c96d3de1a5$export$a60c43befc130169 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
    };
    const $1aa060c96d3de1a5$export$aa2fcc70355c7d19 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
    };
    const $1aa060c96d3de1a5$export$df82cc5024b7f316 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
    };
    const $1aa060c96d3de1a5$export$2cee7cd37198b3fd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
    };
    const $1aa060c96d3de1a5$export$a6b708cae2ed7f0c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
    };
    var $5lsNZ;
    var $is7uC;
    var $4R6GH;
    const $122674b135b0c50b$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "d57c5aa2501709c84ebb2ccbb5bf076d32ad8256d3bf18aa358f54a70584cfb8",
            "metadata": {},
            "name": "ui_jiraCalendarQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $122674b135b0c50b$export$2e2bcd8739ae039 = $122674b135b0c50b$var$node;
    var $eufEc;
    var $fEDBv;
    const $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
    function $8623df52c8647276$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
        return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
    }
    function $8623df52c8647276$var$getStorageKeyFromScope(context) {
        const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
        const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
        return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
    }
    function $8623df52c8647276$var$getStorageValueFromScope(key) {
        const storedData = globalThis.localStorage?.getItem(key) || '';
        return storedData;
    }
    function $8623df52c8647276$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $8623df52c8647276$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $8623df52c8647276$var$createScope({ context: context, tenantContext: tenantContext }) {
        const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const planScenarioAri = $8623df52c8647276$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: String(planId),
            scenarioId: String(scenarioId)
        });
        return {
            type: 'plan',
            ids: [
                planScenarioAri
            ]
        };
    }
    function $8623df52c8647276$var$buildScopeInput(scope) {
        return {
            ids: scope.ids
        };
    }
    function $8623df52c8647276$var$buildViewId(scope) {
        return scope.ids?.[0] ?? '';
    }
    function $8623df52c8647276$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $8623df52c8647276$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $8623df52c8647276$var$toCalendarWeekStart(weekStart) {
        switch(weekStart){
            case 'sunday':
                return 'sunday';
            case 'saturday':
                return 'saturday';
            default:
                return 'monday';
        }
    }
    function $8623df52c8647276$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, viewId: viewId }) {
        return {
            date: $8623df52c8647276$var$toMidnightUTCString(selectedDate),
            mode: $8623df52c8647276$var$toViewMode(viewRange),
            weekStart: $8623df52c8647276$var$toWeekStart(weekStartsOn),
            viewId: viewId
        };
    }
    function $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) {
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return {
            additionalFilterQuery: isEmbed === true ? filter : filter || $8623df52c8647276$var$getStorageValueFromScope(storageKey)
        };
        return {
            additionalFilterQuery: $8623df52c8647276$var$getStorageValueFromScope(storageKey)
        };
    }
    function $8623df52c8647276$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $8623df52c8647276$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput() {
        return {
            statuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $8623df52c8647276$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    function $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam) {
        if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam) return {
            hideWeekends: hideWeekends === 'true' || undefined,
            hideSprints: hideSprints === 'true' || undefined,
            hideVersions: hideVersions === 'true' || undefined,
            hideIssues: hideIssues === 'true' || undefined,
            hideIssueKey: hideIssueKey === 'true' || undefined,
            weekStartsOn: $8623df52c8647276$var$toCalendarWeekStart(weekStartsOnQueryParam)
        };
        return undefined;
    }
    const $8623df52c8647276$export$19cf4b398f638dc6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("98rs3")), {
            moduleId: "53aec496"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $8623df52c8647276$var$createScope(entryPointRouteParams);
            const scopeInput = $8623df52c8647276$var$buildScopeInput(scope);
            const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam } = context.query;
            const selectedDate = $8623df52c8647276$var$toDate(date);
            const hasFilterQueryParam = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? Boolean(filter) : false;
            const routeName = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? context.route.name : '';
            const settingsQueryParams = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam) : {};
            const isEmbed = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? routeName === $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED : false;
            const viewRange = 'month';
            const weekStartsOn = 'monday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            const storageKey = $8623df52c8647276$var$getStorageKeyFromScope(context);
            const viewId = $8623df52c8647276$var$buildViewId(scope);
            const filterQuery = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) : $8623df52c8647276$var$buildIssuesSearchInput(storageKey);
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $122674b135b0c50b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: scopeInput,
                            configurationInput: $8623df52c8647276$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                viewId: viewId
                            }),
                            issuesSearchInput: filterQuery,
                            unscheduledIssuesSearchInput: $8623df52c8647276$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $8623df52c8647276$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $8623df52c8647276$var$buildSprintsSearchInput(),
                            crossProjectVersionsSearchInput: $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput(),
                            viewId: viewId,
                            skipSprintSearch: false,
                            skipVersionSearch: false,
                            skipPanelIssueSearch: true,
                            skipCrossProjectVersionSearch: false,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields,
                    storageKey: storageKey,
                    hasFilterQueryParam: hasFilterQueryParam,
                    routeName: routeName,
                    settingsQueryParams: settingsQueryParams,
                    filterQuery: (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? filterQuery.additionalFilterQuery : undefined
                }
            };
        }
    });
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $994fd41f214cf799$var$LazyPlanCalendarEmbed = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5wS2n"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-calendar/index.tsx"
    });
    const $994fd41f214cf799$var$PlanCalendarEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $994fd41f214cf799$var$LazyPlanCalendarEmbed,
            pageId: "plan-calendar-embed",
            shouldShowSpinner: true
        });
    const $994fd41f214cf799$var$planCalendarEmbedRouteEntry = (0, $6a0b20679c309df7$export$56ea489e9d4bfa04)({
        main: (0, $8623df52c8647276$export$19cf4b398f638dc6)
    });
    const $994fd41f214cf799$export$309ed92381819b04 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1aa060c96d3de1a5$export$df82cc5024b7f316), ()=>({
            ufoName: 'software-advanced-roadmaps-calendar-embed',
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $994fd41f214cf799$var$PlanCalendarEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: ()=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return (0, (0, parcelRequire("4R6GH")).fg)('platform_calendar_adoption_in_plans') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("is7uC")).CalendarSkeleton), null) : undefined;
                return undefined;
            },
            entryPoint () {
                (0, (0, parcelRequire("87OsA")).setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return (0, (0, parcelRequire("4R6GH")).fg)('platform_calendar_adoption_in_plans') ? $994fd41f214cf799$var$planCalendarEmbedRouteEntry : undefined;
                return undefined;
            },
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
            },
            forPaint: [
                $994fd41f214cf799$var$LazyPlanCalendarEmbed
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $2Ql51;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1ac1c43ff241df29$export$48681ab0b4246654 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fQisF"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index.tsx"
    });
    const $1ac1c43ff241df29$var$PlanDependenciesReportEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1ac1c43ff241df29$export$48681ab0b4246654,
            pageId: "plan-dependencies-report-embed",
            shouldShowSpinner: true
        });
    const $1ac1c43ff241df29$export$2506a377ba649c46 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1aa060c96d3de1a5$export$aa2fcc70355c7d19), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $1ac1c43ff241df29$var$PlanDependenciesReportEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $1ac1c43ff241df29$export$48681ab0b4246654
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $2Ql51;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7aefdf7bc9d09622$export$51f2083dff1ee684 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("35mct"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
    });
    const $7aefdf7bc9d09622$export$a2ae011b90c17927 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7aefdf7bc9d09622$export$51f2083dff1ee684,
            pageId: "plan-increment-embed",
            shouldShowSpinner: true
        });
    const $7aefdf7bc9d09622$export$3feed0b4da010c52 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1aa060c96d3de1a5$export$a6b708cae2ed7f0c), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $7aefdf7bc9d09622$export$a2ae011b90c17927, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $7aefdf7bc9d09622$export$51f2083dff1ee684
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    parcelRequire("cP24C");
    var $lv9xW;
    var $3RJkv;
    var $2Ql51;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2485c4cbac92f412$var$LazyPlanSummaryEmbed = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("63ju8"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
    });
    const $2485c4cbac92f412$var$PlanSummaryEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2485c4cbac92f412$var$LazyPlanSummaryEmbed,
            pageId: "plan-summary-embed",
            shouldShowSpinner: true
        });
    const $2485c4cbac92f412$export$bdc2c75e02c29d7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1aa060c96d3de1a5$export$2cee7cd37198b3fd), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $2485c4cbac92f412$var$PlanSummaryEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $2485c4cbac92f412$var$LazyPlanSummaryEmbed
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $2Ql51;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $08301ee8f84a61cf$var$LazyPlanTimelineEmbed = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("q7sYD"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
    });
    const $08301ee8f84a61cf$var$PlanTimelineEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $08301ee8f84a61cf$var$LazyPlanTimelineEmbed,
            pageId: "plan-timeline-embed",
            shouldShowSpinner: true
        });
    const $08301ee8f84a61cf$export$a977d398db1904ff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1aa060c96d3de1a5$export$a60c43befc130169), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $08301ee8f84a61cf$var$PlanTimelineEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $08301ee8f84a61cf$var$LazyPlanTimelineEmbed
            ]
        }));
    const $e4b20bcfc3d9d9f7$export$8535fa0728567020 = [
        (0, $994fd41f214cf799$export$309ed92381819b04),
        (0, $1ac1c43ff241df29$export$2506a377ba649c46),
        (0, $7aefdf7bc9d09622$export$3feed0b4da010c52),
        (0, $2485c4cbac92f412$export$bdc2c75e02c29d7),
        (0, $08301ee8f84a61cf$export$a977d398db1904ff)
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3DNgf;
    var $3RJkv;
    var $2r2vQ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    const $7016c06d4eae395e$export$9090339aecaa99f2 = (CurrentComponent, redirectUrl, redirectCondition)=>()=>{
            if (redirectCondition()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: redirectUrl
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(CurrentComponent, null);
        };
    const $7016c06d4eae395e$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: redirectUrl
            });
    const $a09bf317e4b8989f$export$4fcc3c0f6e792efc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ar2Tl"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
    });
    const $a09bf317e4b8989f$export$d6f045c7c1aaff50 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a09bf317e4b8989f$export$4fcc3c0f6e792efc,
            pageId: "arj-settings-dependencies",
            shouldShowSpinner: true
        });
    const $a09bf317e4b8989f$export$70386609aff5ba12 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsDependenciesRoute), ()=>({
            component: $a09bf317e4b8989f$export$d6f045c7c1aaff50,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("3DNgf")).issueLinkInformationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $a09bf317e4b8989f$export$4fcc3c0f6e792efc
            ]
        }));
    const $a09bf317e4b8989f$export$804f2d81dfbdd5c9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsDependenciesRedirectRoute), ()=>({
            component: (0, $7016c06d4eae395e$export$2d47ce6f15e624e5)('/jira/plans/settings/dependencies'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("3DNgf")).issueLinkInformationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $a09bf317e4b8989f$export$4fcc3c0f6e792efc
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $azWKH;
    var $3RJkv;
    var $2r2vQ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7f2d172c3e4cc656$export$64761ea1912fdcd9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fvcVN"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
    });
    const $7f2d172c3e4cc656$export$7bb4c0f22b467385 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7f2d172c3e4cc656$export$64761ea1912fdcd9,
            pageId: "arj-settings-loading-limits",
            shouldShowSpinner: true
        });
    const $7f2d172c3e4cc656$export$6786257309f86d8c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsLoadingLimitsRoute), ()=>({
            component: $7f2d172c3e4cc656$export$7bb4c0f22b467385,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("azWKH")).arjSettingsLoadingLimitsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f2d172c3e4cc656$export$64761ea1912fdcd9
            ]
        }));
    const $7f2d172c3e4cc656$export$9f80102c0f64ad9b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsLoadingLimitsRedirectRoute), ()=>({
            component: (0, $7016c06d4eae395e$export$2d47ce6f15e624e5)('/jira/plans/settings/loading-limits'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f2d172c3e4cc656$export$64761ea1912fdcd9
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $1aR84;
    var $3RJkv;
    var $2r2vQ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ea6e9e2621e05a7f$export$edb4ae7e85c7908d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("julIg"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
    });
    const $ea6e9e2621e05a7f$export$fa852ea42b98d3de = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ea6e9e2621e05a7f$export$edb4ae7e85c7908d,
            pageId: "arj-settings-permissions",
            shouldShowSpinner: true
        });
    const $ea6e9e2621e05a7f$export$4e97658a5cc15eaa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsPermissionsRoute), ()=>({
            component: $ea6e9e2621e05a7f$export$fa852ea42b98d3de,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("1aR84")).getGlobalPermissionPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ea6e9e2621e05a7f$export$edb4ae7e85c7908d
            ]
        }));
    const $ea6e9e2621e05a7f$export$949c8177281fcc39 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsPermissionsRedirectRoute), ()=>({
            component: (0, $7016c06d4eae395e$export$2d47ce6f15e624e5)('/jira/plans/settings/permissions'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("1aR84")).getGlobalPermissionPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ea6e9e2621e05a7f$export$edb4ae7e85c7908d
            ]
        }));
    const $532fcc0d9c71be9f$export$87af7d91a16be1cf = [
        (0, $a09bf317e4b8989f$export$70386609aff5ba12),
        (0, $a09bf317e4b8989f$export$804f2d81dfbdd5c9),
        (0, $7f2d172c3e4cc656$export$6786257309f86d8c),
        (0, $7f2d172c3e4cc656$export$9f80102c0f64ad9b),
        (0, $ea6e9e2621e05a7f$export$4e97658a5cc15eaa),
        (0, $ea6e9e2621e05a7f$export$949c8177281fcc39)
    ];
    var $ffza4;
    var $2BrOV;
    var $ibkIl;
    var $8iyFV;
    var $lmyls;
    var $2Fj5v;
    var $937TY;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $7j3uW;
    var $3RJkv;
    var $atU1t;
    var $4zCFt;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e7e5083407abf400$export$cf676f47aba10db8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3YFhg")).then((module)=>module.ArchivedPlans)), {
        moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
    });
    const $e7e5083407abf400$export$ed59bbc59461c00f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e7e5083407abf400$export$cf676f47aba10db8,
            pageId: "archived-plans",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4804ee23833a4e07$export$e7b9f83d442bac51 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("35mct"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
    });
    const $4804ee23833a4e07$export$5e1035d0876d64db = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4804ee23833a4e07$export$e7b9f83d442bac51,
            pageId: "plan-increment",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5ac0bb7d9b3f8806$export$9da4d4d5c4d7f749 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4JKpA"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index.tsx"
    });
    const $5ac0bb7d9b3f8806$export$fb30c2b19a4f5d59 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ac0bb7d9b3f8806$export$9da4d4d5c4d7f749,
            pageId: "plan-program",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $c48e9f8af231216f$export$6ac18b311b7e51a1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9LXXc")).then((module)=>module.TrashedPlans)), {
        moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
    });
    const $c48e9f8af231216f$export$b145fa65818ff157 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c48e9f8af231216f$export$6ac18b311b7e51a1,
            pageId: "trashed-plans",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $21915a74b5053cfc$export$dd67c2f01a58231e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hf3HX")).then((module)=>module.ArjSettingsFinancialYear)), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
    });
    const $21915a74b5053cfc$export$785180185eba7ed9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $21915a74b5053cfc$export$dd67c2f01a58231e,
            pageId: "arj-settings-financial-year",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $50323c608fe813f4$export$20a71ac28e6a3c8f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1VgiI"))), {
        moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
    });
    const $50323c608fe813f4$export$38f3a061bb1fceee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $50323c608fe813f4$export$20a71ac28e6a3c8f,
            pageId: "trashed-plan-direct-link",
            shouldShowSpinner: false
        });
    const $ed91b1902c212dd9$export$f7abc47036ff7dd9 = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).planIncrementsRoute),
        exact: true
    }, ()=>({
            component: (0, $5ac0bb7d9b3f8806$export$fb30c2b19a4f5d59),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $5ac0bb7d9b3f8806$export$9da4d4d5c4d7f749)
            ]
        }));
    const $ed91b1902c212dd9$export$a26fa5cabff8bc7c = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).planIncrementRoute),
        exact: true
    }, ()=>({
            component: (0, $4804ee23833a4e07$export$5e1035d0876d64db),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4804ee23833a4e07$export$e7b9f83d442bac51)
            ]
        }));
    const $ed91b1902c212dd9$export$b9921058a8a65710 = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).archivedPlansRoute),
        exact: true
    }, ()=>({
            component: (0, $e7e5083407abf400$export$ed59bbc59461c00f),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e7e5083407abf400$export$cf676f47aba10db8)
            ]
        }));
    const $ed91b1902c212dd9$export$eabcbe4dd6fc9f1f = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).trashedPlansRoute),
        exact: true
    }, ()=>({
            component: (0, $c48e9f8af231216f$export$b145fa65818ff157),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c48e9f8af231216f$export$6ac18b311b7e51a1)
            ]
        }));
    const $ed91b1902c212dd9$export$dbcd0bd16f12397d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4zCFt")).trashedPlanDirectLinkRoute), ()=>({
            component: (0, $50323c608fe813f4$export$38f3a061bb1fceee),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $50323c608fe813f4$export$20a71ac28e6a3c8f)
            ],
            ufoName: 'plan-trashed'
        }));
    const $ed91b1902c212dd9$export$3907721420f39680 = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).arjSettingsFinancialYearPageRoute),
        exact: true
    }, ()=>({
            component: (0, $21915a74b5053cfc$export$785180185eba7ed9),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("7j3uW")).arjSettingsFinancialYearResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $21915a74b5053cfc$export$dd67c2f01a58231e)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $lmyls;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1e2a2395fa471a5f$export$3b1de511e34cdb8f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5wS2n"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-calendar/index.tsx"
    });
    var $1e2a2395fa471a5f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1e2a2395fa471a5f$export$3b1de511e34cdb8f,
            pageId: "plan-calendar",
            shouldShowSpinner: true
        });
    const $1e2a2395fa471a5f$export$21806ebf23f23060 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $8623df52c8647276$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e16ddd24f9c31932$export$d4669c7a2f17c261 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fQisF"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index.tsx"
    });
    var $e16ddd24f9c31932$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e16ddd24f9c31932$export$d4669c7a2f17c261,
            pageId: "plan-dependencies-report",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $20c3b3923b6e567f$export$890fb5003e472449 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5WOuA"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
    });
    var $20c3b3923b6e567f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $20c3b3923b6e567f$export$890fb5003e472449,
            pageId: "advanced-roadmaps-plan",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5e5a763517beeba1$export$749f5d2513e04ec0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2n942"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index.tsx"
    });
    var $5e5a763517beeba1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5e5a763517beeba1$export$749f5d2513e04ec0,
            pageId: "plan-releases",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $14dca1083be77753$export$fe1fc08f511671db = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lBp9O"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
    });
    const $14dca1083be77753$var$PlanReport = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $14dca1083be77753$export$fe1fc08f511671db,
            pageId: "plan-report",
            shouldShowSpinner: true
        });
    var $14dca1083be77753$export$2e2bcd8739ae039 = $14dca1083be77753$var$PlanReport;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f06db73ae321846e$export$8bcf7155849993f5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2cXwo"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
    });
    var $f06db73ae321846e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f06db73ae321846e$export$8bcf7155849993f5,
            pageId: "plan-settings-auto-scheduler",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cdb52e9fe771d0f2$export$72bf44dbae2383e5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cVT1A"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
    });
    var $cdb52e9fe771d0f2$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cdb52e9fe771d0f2$export$72bf44dbae2383e5,
            pageId: "plan-settings-custom-fields",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $db26989c73cd561c$export$78f61b03c267e6d9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b5b81"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
    });
    var $db26989c73cd561c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $db26989c73cd561c$export$78f61b03c267e6d9,
            pageId: "plan-settings-exclusion-rules",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ff7a36b49c810ac0$export$731998664b7d5e72 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hy8Qs"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
    });
    var $ff7a36b49c810ac0$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff7a36b49c810ac0$export$731998664b7d5e72,
            pageId: "plan-settings-find-your-issue",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1d1d6be6d81acd4b$export$7ba4b487efcedeb3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4A9Do"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
    });
    var $1d1d6be6d81acd4b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1d1d6be6d81acd4b$export$7ba4b487efcedeb3,
            pageId: "plan-settings-issue-sources",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $abf4c3b40edd7499$export$49f5b76ad5c06a42 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("elgx3"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
    });
    var $abf4c3b40edd7499$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $abf4c3b40edd7499$export$49f5b76ad5c06a42,
            pageId: "plan-settings-permissions",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $bfaea286a7dfd22d$export$c1344fd7d24991b3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("El4ba"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
    });
    var $bfaea286a7dfd22d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bfaea286a7dfd22d$export$c1344fd7d24991b3,
            pageId: "plan-settings-plan-info",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4e98f7bb80f47578$export$ffdec728a47c437c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("i7FRg"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
    });
    var $4e98f7bb80f47578$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4e98f7bb80f47578$export$ffdec728a47c437c,
            pageId: "plan-settings-program-boards",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $231dc95095132627$export$759df6301ec72119 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3Wjz9"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
    });
    var $231dc95095132627$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $231dc95095132627$export$759df6301ec72119,
            pageId: "plan-settings-removed-issues",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $c9d9875bc1407d2f$export$a5398542699d356a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("vcVXi"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
    });
    var $c9d9875bc1407d2f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c9d9875bc1407d2f$export$a5398542699d356a,
            pageId: "plan-settings-saved-views",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $c099a15373f1563d$export$94104fcc1a6f460f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jxqka"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
    });
    var $c099a15373f1563d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c099a15373f1563d$export$94104fcc1a6f460f,
            pageId: "plan-settings-scenarios",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $185b06a78613502e$export$3bf11db1bbeae73e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1yuH3"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
    });
    var $185b06a78613502e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $185b06a78613502e$export$3bf11db1bbeae73e,
            pageId: "plan-settings-scheduling",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $46ebe5f117724405$export$c717f0d9d7f11b49 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("63ju8"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
    });
    var $46ebe5f117724405$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $46ebe5f117724405$export$c717f0d9d7f11b49,
            pageId: "plan-summary",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $25408c0bafe37967$export$f85952f98f28fed0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7z32m"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index.tsx"
    });
    var $25408c0bafe37967$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $25408c0bafe37967$export$f85952f98f28fed0,
            pageId: "plan-teams",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $041228e5ad03e333$export$bf48e5f1529ddaeb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("q7sYD"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
    });
    var $041228e5ad03e333$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $041228e5ad03e333$export$bf48e5f1529ddaeb,
            pageId: "plan-timeline",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3932c98213f58685$export$46bb3a1779d7815b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("38bH9"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
    });
    var $3932c98213f58685$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3932c98213f58685$export$46bb3a1779d7815b,
            pageId: "advanced-roadmaps-setup",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    function $229a43442b588705$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
        return ()=>{
            const [{ match: match }] = (0, $dIdda.useRouter)();
            if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: "/jira/plans"
            });
            if (!redirectCondition()) return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
            });
        };
    }
    const $ffe74f439a298da1$export$f43cc215b47dd576 = [
        (0, $ed91b1902c212dd9$export$b9921058a8a65710),
        (0, $ed91b1902c212dd9$export$eabcbe4dd6fc9f1f),
        (0, $ed91b1902c212dd9$export$dbcd0bd16f12397d),
        (0, $ed91b1902c212dd9$export$3907721420f39680),
        (0, $ed91b1902c212dd9$export$a26fa5cabff8bc7c),
        (0, $ed91b1902c212dd9$export$f7abc47036ff7dd9)
    ];
    const $ffe74f439a298da1$export$bca2008b514578a0 = (0, $229a43442b588705$export$2c9e4550ef8bdea9)((0, $041228e5ad03e333$export$2e2bcd8739ae039), {
        to: '/timeline',
        redirectCondition: ()=>true
    });
    const $ffe74f439a298da1$export$f85a75f1604118ff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsRoute), ()=>({
            ufoName: 'software-advanced-roadmaps-scenario',
            component: $ffe74f439a298da1$export$bca2008b514578a0,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $041228e5ad03e333$export$bf48e5f1529ddaeb)
            ]
        }));
    const $ffe74f439a298da1$export$189ae5546a081577 = [
        ...(0, $532fcc0d9c71be9f$export$87af7d91a16be1cf),
        ...(0, $e4b20bcfc3d9d9f7$export$8535fa0728567020),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanDependenciesRoute), ()=>({
                component: (0, $e16ddd24f9c31932$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e16ddd24f9c31932$export$d4669c7a2f17c261)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSummaryRoute), ()=>({
                ufoName: 'software-advanced-roadmaps-summary',
                component: (0, $46ebe5f117724405$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $46ebe5f117724405$export$c717f0d9d7f11b49)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanCalendarRoute), ()=>({
                ufoName: 'software-advanced-roadmaps-calendar',
                component: (0, $1e2a2395fa471a5f$export$2e2bcd8739ae039),
                skeleton: ()=>(0, (0, parcelRequire("4R6GH")).fg)('platform_calendar_adoption_in_plans') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("is7uC")).CalendarSkeleton), null) : undefined,
                entryPoint () {
                    (0, (0, parcelRequire("87OsA")).setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                    return (0, (0, parcelRequire("4R6GH")).fg)('platform_calendar_adoption_in_plans') ? (0, $1e2a2395fa471a5f$export$21806ebf23f23060) : undefined;
                },
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                meta: {
                    capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $1e2a2395fa471a5f$export$3b1de511e34cdb8f)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanReleasesRoute), ()=>({
                component: (0, $5e5a763517beeba1$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5e5a763517beeba1$export$749f5d2513e04ec0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanTimelineRoute), ()=>({
                component: (0, $041228e5ad03e333$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $041228e5ad03e333$export$bf48e5f1529ddaeb)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsPermissionsRoute), ()=>({
                component: (0, $abf4c3b40edd7499$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $abf4c3b40edd7499$export$49f5b76ad5c06a42)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsSavedViewsRoute), ()=>({
                component: (0, $c9d9875bc1407d2f$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c9d9875bc1407d2f$export$a5398542699d356a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsPlanInfoRoute), ()=>({
                component: (0, $bfaea286a7dfd22d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $bfaea286a7dfd22d$export$c1344fd7d24991b3)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsProgramBoardsRoute), ()=>({
                component: (0, $4e98f7bb80f47578$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4e98f7bb80f47578$export$ffdec728a47c437c)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsSchedulingRoute), ()=>({
                component: (0, $185b06a78613502e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $185b06a78613502e$export$3bf11db1bbeae73e)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsScenariosRoute), ()=>({
                component: (0, $c099a15373f1563d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c099a15373f1563d$export$94104fcc1a6f460f)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsAutoSchedulerRoute), ()=>({
                component: (0, $f06db73ae321846e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f06db73ae321846e$export$8bcf7155849993f5)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsCustomFieldsRoute), ()=>({
                component: (0, $cdb52e9fe771d0f2$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $cdb52e9fe771d0f2$export$72bf44dbae2383e5)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsExclusionRulesRoute), ()=>({
                component: (0, $db26989c73cd561c$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $db26989c73cd561c$export$78f61b03c267e6d9)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsIssueSourcesRoute), ()=>({
                component: (0, $1d1d6be6d81acd4b$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $1d1d6be6d81acd4b$export$7ba4b487efcedeb3)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsFindYourIssueRoute), ()=>({
                component: (0, $ff7a36b49c810ac0$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $ff7a36b49c810ac0$export$731998664b7d5e72)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsRemovedIssuesRoute), ()=>({
                component: (0, $231dc95095132627$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $231dc95095132627$export$759df6301ec72119)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanTeamsRoute), ()=>({
                component: (0, $25408c0bafe37967$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $25408c0bafe37967$export$f85952f98f28fed0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsGettingStartedRedirectRoute), ()=>({
                component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                        to: "/jira/plans?create-sample-plan=true"
                    }),
                isRedirect: true,
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $041228e5ad03e333$export$bf48e5f1529ddaeb)
                ]
            }))
    ];
    const $ffe74f439a298da1$export$9cbef73b51558ef = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmaps1Route), ()=>({
            ufoName: 'software-advanced-roadmaps-plan',
            component: (0, $3e6624904a2f18eb$export$ff420400c9900835),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $041228e5ad03e333$export$bf48e5f1529ddaeb)
            ]
        }));
    const $ffe74f439a298da1$export$e9cfdb950d40e917 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsRedirectRoute), ()=>({
            component: (0, $3e6624904a2f18eb$export$c3e4fda2290a52bf),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsScenarioIdResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $041228e5ad03e333$export$bf48e5f1529ddaeb)
            ]
        }));
    const $ffe74f439a298da1$export$e71031acce6d7e47 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmaps3Route), ()=>({
            ufoName: 'software-advanced-roadmaps-report',
            component: (0, $14dca1083be77753$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanReportPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $14dca1083be77753$export$fe1fc08f511671db)
            ]
        }));
    const $ffe74f439a298da1$export$c2a4c5c6576a704c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsRedirect1Route), ()=>({
            component: (0, $135d7141d14abe41$export$2e2bcd8739ae039),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $041228e5ad03e333$export$bf48e5f1529ddaeb)
            ]
        }));
    const $ffe74f439a298da1$var$ExportPageComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $20c3b3923b6e567f$export$890fb5003e472449), null);
    const $ffe74f439a298da1$var$ExportPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ffe74f439a298da1$var$ExportPageComponent,
            pageId: "advanced-roadmap",
            shouldShowSpinner: true
        });
    const $ffe74f439a298da1$export$d751e3552b21c604 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmaps5Route), ()=>({
            ufoName: 'software-advanced-roadmaps-scenario-export',
            component: $ffe74f439a298da1$var$ExportPage,
            layout: {
                isChromeless: true,
                globalComponents: [],
                rightSidebars: []
            },
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            forPaint: [
                (0, $041228e5ad03e333$export$bf48e5f1529ddaeb)
            ]
        }));
    const $ffe74f439a298da1$export$2a24acea4e628148 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsSetupRoute), ()=>({
            component: (0, $3932c98213f58685$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3932c98213f58685$export$46bb3a1779d7815b)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $8c21a6752554eb0c$export$cd3fc26cf9f696e6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK),
        path: '/jira/errors/project-archived',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5ed731e7678da2da$export$bcbb38b3c86dba1f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aKeDz"))), {
        moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
    });
    const $5ed731e7678da2da$export$2e0968e4c0408481 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ed731e7678da2da$export$bcbb38b3c86dba1f,
            pageId: "archived-project-direct-link",
            shouldShowSpinner: false
        });
    const $5ed731e7678da2da$export$45e68d450757a753 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8c21a6752554eb0c$export$cd3fc26cf9f696e6), ()=>({
            component: $5ed731e7678da2da$export$2e0968e4c0408481,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5ed731e7678da2da$export$bcbb38b3c86dba1f
            ],
            ufoName: 'project-archived'
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $8fcfc94cf4d76f81$export$b60634d0fa43f719 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY),
        path: '/jira/settings/projects/archive',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7076addc4fa02bdc$export$b220ffb582ee39aa = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eoLhh"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
    });
    var $7076addc4fa02bdc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7076addc4fa02bdc$export$b220ffb582ee39aa,
            pageId: "archived-projects",
            shouldShowSpinner: true
        });
    const $49dffa5818f3dec0$export$dc5f9e3c3931cc36 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8fcfc94cf4d76f81$export$b60634d0fa43f719), ()=>({
            component: (0, $7076addc4fa02bdc$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7076addc4fa02bdc$export$b220ffb582ee39aa)
            ],
            ufoName: 'admin.archived-projects'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $l71WK;
    var $9QpK7;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dmKXV;
    var $koWFd;
    var $h0bZU;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $c172348e4abef46c$export$1bfee70ca366d995 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/issues/archive',
        exact: true
    };
    const $c172348e4abef46c$export$15745ddd07707d60 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/software/projects/:projectKey/issues/archive',
        exact: true
    };
    const $c172348e4abef46c$export$cd10ef5fdf01245b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/software/c/projects/:projectKey/issues/archive',
        exact: true
    };
    const $c172348e4abef46c$export$1c7220e12a2118ce = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/servicedesk/projects/:projectKey/issues/archive',
        exact: true
    };
    const $c172348e4abef46c$export$4a6781d620bb402 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/core/projects/:projectKey/issues/archive',
        exact: true
    };
    var $5lsNZ;
    var $6Z2mh;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5e1b97c402b9e85a$export$5cb97f431a00807d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b39Ju")).then(({ JiraIssuesArchive: JiraIssuesArchive })=>JiraIssuesArchive)), {
        moduleId: "./src/packages/spa-apps/archives/src/index.tsx"
    });
    const $5e1b97c402b9e85a$export$b8f3c7276fe36123 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5e1b97c402b9e85a$export$5cb97f431a00807d,
            pageId: "spa-apps/archives",
            shouldShowSpinner: true
        });
    const $5e1b97c402b9e85a$export$f7d3667678a21360 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c172348e4abef46c$export$1bfee70ca366d995), ()=>({
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5e1b97c402b9e85a$export$5cb97f431a00807d
            ]
        }));
    const $5e1b97c402b9e85a$var$getCommonProjectLayout = ()=>(0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout));
    const $5e1b97c402b9e85a$export$fdccb6efc62198e6 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c172348e4abef46c$export$15745ddd07707d60), ()=>({
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding)),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5e1b97c402b9e85a$export$5cb97f431a00807d
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c172348e4abef46c$export$cd10ef5fdf01245b), ()=>({
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: $5e1b97c402b9e85a$var$getCommonProjectLayout(),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5e1b97c402b9e85a$export$5cb97f431a00807d
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c172348e4abef46c$export$1c7220e12a2118ce), ()=>({
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5e1b97c402b9e85a$export$5cb97f431a00807d
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c172348e4abef46c$export$4a6781d620bb402), ()=>({
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: $5e1b97c402b9e85a$var$getCommonProjectLayout(),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5e1b97c402b9e85a$export$5cb97f431a00807d
                ]
            }))
    ];
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $1WlLE;
    var $lsCQw;
    var $7MCPm;
    const $5fa74d2477541baa$export$f9891419b34ab305 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lsCQw")).browseProjectRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $ffza4;
    var $l71WK;
    var $2vSU6;
    var $1Du13;
    var $1XrjK;
    var $kxZPA;
    const $d0bc40d3dc70d875$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("XNjnS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
    });
    const $d0bc40d3dc70d875$var$withAnyBusinessProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            }
        });
    const $d0bc40d3dc70d875$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("2HD9l")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $d0bc40d3dc70d875$var$BusinessOnboarding = $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$Onboarding);
    const $d0bc40d3dc70d875$var$nonSettingsRightSidebars = [
        $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$RightSidebars)
    ];
    const $d0bc40d3dc70d875$var$sharedBusinessProjectLayout = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
    const $d0bc40d3dc70d875$export$dfb0c3e0348f4429 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($d0bc40d3dc70d875$var$sharedBusinessProjectLayout, {
        rightSidebars: $d0bc40d3dc70d875$var$nonSettingsRightSidebars,
        globalComponents: [
            $d0bc40d3dc70d875$var$BusinessOnboarding
        ]
    });
    var $1XrjK;
    const $c3106f352857c22e$export$17e73ed8c35891cb = (0, (0, parcelRequire("1XrjK")).createLayout)({
        isChromeless: true
    });
    var $6s1PB;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $d8VYe;
    var $lNicp;
    var $kqhaB;
    var $3zj3N;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $ffza4;
    var $l71WK;
    var $1XrjK;
    var $lGGIs;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $59d96d961d806fee$var$LazyIssuePage = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("3r24n"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
    });
    const $59d96d961d806fee$var$AsyncIssueAppComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("82uFl"))), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $59d96d961d806fee$var$imports = {
        fullPage: ()=>$59d96d961d806fee$var$LazyIssuePage.preload(),
        embedded: ()=>$59d96d961d806fee$var$AsyncIssueAppComponent.preload()
    };
    const $59d96d961d806fee$var$PrefetchCBBResourcesComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("4NxWn")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
    });
    let $59d96d961d806fee$var$serverIssuePreloadIdentifier = '';
    if (!false && window.SPA_STATE?.serverIssuePreload) {
        const importSupplier = $59d96d961d806fee$var$imports[window.SPA_STATE.serverIssuePreload];
        importSupplier && importSupplier();
    }
    const $59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
    const $59d96d961d806fee$var$useParamsSelector = (0, $dIdda.createRouterSelector)((state)=>({
            query: state.query,
            params: state.match.params
        }));
    const $59d96d961d806fee$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
            const { query: query, params: params } = $59d96d961d806fee$var$useParamsSelector();
            if (!preloadContract || preloadContract.some((preloadingMatch)=>(!preloadingMatch.query || (0, $dIdda.matchQuery)(preloadingMatch.query, query)) && (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
                if (!false) preloadSupplier();
                if (false) $59d96d961d806fee$var$serverIssuePreloadIdentifier = identifier;
                else performance.mark($59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK);
            }
            return null;
        };
    const $59d96d961d806fee$export$f55e6973062dc859 = ()=>$59d96d961d806fee$var$serverIssuePreloadIdentifier;
    const $59d96d961d806fee$var$FullPageIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('fullPage', $59d96d961d806fee$var$imports.fullPage);
    $59d96d961d806fee$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
    const $59d96d961d806fee$export$98e337c40eb151da = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            $59d96d961d806fee$var$FullPageIssuePreloadComponent,
            $59d96d961d806fee$var$PrefetchCBBResourcesComponent
        ]
    });
    const $59d96d961d806fee$export$7b113174a456921a = (preloadContract)=>{
        const EmbeddedIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('embedded', $59d96d961d806fee$var$imports.embedded, preloadContract);
        EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
        return (0, (0, parcelRequire("1XrjK")).createLayout)({
            globalComponents: [
                EmbeddedIssuePreloadComponent
            ]
        });
    };
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $1XrjK;
    var $d8VYe;
    var $lNicp;
    var $65Ltd;
    const $c28d2a33370e0bea$export$14a5cbbd7e1e2dc2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
        ufoName: 'jwm.jwm-board',
        exact: true,
        path: '/jira/core/projects/:projectKey/board',
        query: [
            'issue-key?'
        ]
    };
    var $kxZPA;
    const $181a8d0a7b0b72cc$export$8c70dcc4643464f8 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("82uFl")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $39c257a891cf9743$export$d663c6b2156921dd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c5wMB")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/business/board/src/index.tsx"
    });
    var $39c257a891cf9743$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $39c257a891cf9743$export$d663c6b2156921dd,
            pageId: "async-business-board",
            shouldShowSpinner: true
        });
    const $7bd4ff8b4781d2c1$export$c7fe0dd4417407a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c28d2a33370e0bea$export$14a5cbbd7e1e2dc2), ()=>({
            component: (0, $39c257a891cf9743$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'issue-key'
                    ]
                }
            ])),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                (0, (0, parcelRequire("d8VYe")).workflowIssuesResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $39c257a891cf9743$export$d663c6b2156921dd)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            preloadOptions: {
                earlyChunks: [
                    'business-board-early-entry'
                ]
            }
        }));
    var $ffza4;
    var $l71WK;
    var $lmyls;
    var $dmKXV;
    var $2G9Bk;
    var $lNicp;
    var $9v9ib;
    var $7MCPm;
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    const $31755126abaef7af$var$OverviewRedirect = ()=>{
        const [overviewId] = (0, $dIdda.usePathParam)('overviewId');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/core/overviews/${overviewId}/summary`
        });
    };
    var $31755126abaef7af$export$2e2bcd8739ae039 = $31755126abaef7af$var$OverviewRedirect;
    const $372ca2c4b5e66a38$export$766e305da4c78de5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9v9ib")).jiraBusinessProjectRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $372ca2c4b5e66a38$export$3aa9116f715693e1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9v9ib")).jiraBusinessOverviewRedirectRoute), ()=>({
            component: (0, $31755126abaef7af$export$2e2bcd8739ae039),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $65Ltd;
    const $c7f3c03fe7edf119$export$3008bdf5c6ced894 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
        path: '/jira/core/projects/:projectKey/summary',
        exact: true
    };
    const $c7f3c03fe7edf119$export$ba1373c12ea65b4c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
        path: '/jira/core/projects/:projectKey/calendar',
        exact: true
    };
    const $c7f3c03fe7edf119$export$2dd4e8a37d8ac978 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
        path: '/jira/core/projects/:projectKey/shortcuts',
        exact: true
    };
    const $c7f3c03fe7edf119$export$f1e14ce95022c93a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
        path: '/jira/core/projects/:projectKey/list',
        exact: true
    };
    const $c7f3c03fe7edf119$export$e98776bdf96c88ac = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
        path: '/jira/core/projects/:projectKey/form',
        exact: true
    };
    const $c7f3c03fe7edf119$export$3cd93ff55b29f07f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
        path: '/jira/core/projects/:projectKey/form/:formId',
        exact: true
    };
    const $c7f3c03fe7edf119$export$5f684808e671de5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
        path: '/jira/core/projects/:projectKey/form/:formId/builder',
        exact: true
    };
    const $c7f3c03fe7edf119$export$4301c67fd317894a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
        path: '/jira/core/projects/:projectKey/timeline',
        exact: true
    };
    const $c7f3c03fe7edf119$export$3109a183a442a02d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
        path: '/jira/core/projects/:projectKey/approvals',
        exact: true
    };
    const $c7f3c03fe7edf119$export$54a218ca6d1c056a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        path: '/jira/core/projects/:projectKey/pages'
    };
    const $c7f3c03fe7edf119$export$2d0c5d5ce5a00c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
        path: '/jira/core/projects/:projectKey/attachments'
    };
    const $c7f3c03fe7edf119$export$fb814f9911fc766e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED),
        path: '/jira/core/projects/:projectKey/timeline/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$e237859f2fc7cc7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED),
        path: '/jira/core/projects/:projectKey/calendar/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$f0d33cf104c15274 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED),
        path: '/jira/core/projects/:projectKey/list/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$7d6a91d85236417 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED),
        path: '/jira/core/projects/:projectKey/board/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$7e8fd15fdfa29385 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED),
        path: '/jira/core/projects/:projectKey/form/:formId/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$13164dbb379620e2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED),
        path: '/jira/core/projects/:projectKey/summary/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$cd9c218d7c968d2d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING),
        path: '/jira/core/sample/onboarding/:taskId',
        exact: true
    };
    const $c7f3c03fe7edf119$export$13f0c823ff3059c2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
        path: '/jira/core/overviews/:overviewId/timeline',
        exact: true
    };
    const $c7f3c03fe7edf119$export$61383e5418d2ffe3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        path: '/jira/core/overviews/:overviewId/calendar',
        exact: true
    };
    const $c7f3c03fe7edf119$export$4a86e6b12ce49af9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        path: '/jira/core/overviews/:overviewId/summary',
        exact: true
    };
    var $ffza4;
    var $l71WK;
    var $6s1PB;
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $lNicp;
    var $5uXOq = parcelRequire("5uXOq");
    var $lmyls;
    const $6fc143a99d34d8f4$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
            "metadata": {},
            "name": "formatRulesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6fc143a99d34d8f4$export$2e2bcd8739ae039 = $6fc143a99d34d8f4$var$node;
    var $eufEc;
    var $fEDBv;
    const $7b34153964734d60$var$FORMAT_RULES_FIRST = 20;
    const $7b34153964734d60$export$6be4f10150ff6073 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("3tPe4")), {
            moduleId: "b03343a1"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    formattingRulesQuery: {
                        parameters: $6fc143a99d34d8f4$export$2e2bcd8739ae039,
                        variables: {
                            projectKey: projectKey,
                            cloudId: tenantContext.cloudId,
                            first: $7b34153964734d60$var$FORMAT_RULES_FIRST
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
    var $5j7Th;
    var $kxZPA;
    const $f5609894035bdf64$export$4bfa19c758c39608 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3tPe4")), {
        moduleId: "./src/packages/spa-apps/business/list/src/index.tsx"
    });
    var $f5609894035bdf64$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f5609894035bdf64$export$4bfa19c758c39608,
            pageId: "async-business-list",
            shouldShowSpinner: true
        });
    const $f5609894035bdf64$export$c338b91a236e608a = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $7b34153964734d60$export$6be4f10150ff6073),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $51524c4dee2e7b63$export$fe7e91eb3254e090 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$f1e14ce95022c93a), ()=>({
            ufoName: 'jwm.list-view',
            component: (0, $f5609894035bdf64$export$2e2bcd8739ae039),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            entryPoint: ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $f5609894035bdf64$export$c338b91a236e608a) : undefined,
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f5609894035bdf64$export$4bfa19c758c39608)
            ]
        }));
    var $ffza4;
    var $l71WK;
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $lNicp;
    var $kqhaB;
    var $3zj3N;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $076358ef490f5e9c$export$68c09444cc6f2843 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hx3VP")), {
        moduleId: "./src/packages/spa-apps/business/summary/src/index.tsx"
    });
    var $076358ef490f5e9c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $076358ef490f5e9c$export$68c09444cc6f2843,
            pageId: "async-business-summary",
            shouldShowSpinner: true
        });
    const $a3e453621b7ee07b$export$deec07bcf556562e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$3008bdf5c6ced894), ()=>({
            ufoName: 'jwm.summary-view',
            component: (0, $076358ef490f5e9c$export$2e2bcd8739ae039),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                (0, (0, parcelRequire("3zj3N")).summaryDataResource),
                (0, (0, parcelRequire("kqhaB")).activityFeedResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $076358ef490f5e9c$export$68c09444cc6f2843)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $09fa0192771673de$export$70abf918dfb890e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("axkjN")), {
        moduleId: "./src/packages/spa-apps/business/approvals/src/index.tsx"
    });
    var $09fa0192771673de$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $09fa0192771673de$export$70abf918dfb890e,
            pageId: "async-business-approvals",
            shouldShowSpinner: true
        });
    var $lmyls;
    const $0688ceb8a3d584db$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "77efda0b857a2c013283d7a49b7393ff8f7e07bcad70eba5f1702dac7b6315f8",
            "metadata": {},
            "name": "uiJWMAttachmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $0688ceb8a3d584db$export$2e2bcd8739ae039 = $0688ceb8a3d584db$var$node;
    var $eufEc;
    var $fEDBv;
    const $5488b7c894698968$export$d94bafd9d893ec98 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("evIjU")), {
            moduleId: "26a1d436"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    jwmAttachmentsQuery: {
                        parameters: $0688ceb8a3d584db$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: [
                                projectKey
                            ],
                            filters: {
                                fileName: '',
                                authorIds: [],
                                mimeTypes: [],
                                dateRange: {
                                    before: undefined,
                                    after: undefined
                                }
                            },
                            durationInSeconds: 900,
                            maxTokenLength: 65534,
                            attachmentCount: 100
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
    const $8d9ee4e688aa8c8e$export$d2dbce06a31f0f47 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $5488b7c894698968$export$d94bafd9d893ec98),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $168a009788c7c0cc$export$a21a9228b9e68b40 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("32mSj")), {
        moduleId: "./src/packages/spa-apps/business/board-embed/src/index.tsx"
    });
    var $168a009788c7c0cc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $168a009788c7c0cc$export$a21a9228b9e68b40,
            pageId: "async-business-board-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $lmyls;
    var $4R6GH;
    var $eufEc;
    var $fEDBv;
    function $38193f9d05bd632a$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $38193f9d05bd632a$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $38193f9d05bd632a$var$createScope({ context: context }) {
        return {
            type: 'project',
            projectKeys: [
                String(context.match.params.projectKey)
            ]
        };
    }
    function $38193f9d05bd632a$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        return {
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
    }
    function $38193f9d05bd632a$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $38193f9d05bd632a$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $38193f9d05bd632a$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
        return {
            date: $38193f9d05bd632a$var$toMidnightUTCString(selectedDate),
            mode: $38193f9d05bd632a$var$toViewMode(viewRange),
            weekStart: $38193f9d05bd632a$var$toWeekStart(weekStartsOn),
            startDateField: startDateField,
            endDateField: endDateField
        };
    }
    function $38193f9d05bd632a$var$buildIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    const $38193f9d05bd632a$export$19cf4b398f638dc6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("8BtoG")), {
            moduleId: "70b39bf1"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $38193f9d05bd632a$var$createScope(entryPointRouteParams);
            const { date: date } = context.query;
            const selectedDate = $38193f9d05bd632a$var$toDate(date);
            const viewRange = 'month';
            const weekStartsOn = 'sunday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $122674b135b0c50b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $38193f9d05bd632a$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $38193f9d05bd632a$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                startDateField: startDateField,
                                endDateField: endDateField
                            }),
                            issuesSearchInput: $38193f9d05bd632a$var$buildIssuesSearchInput(),
                            unscheduledIssuesSearchInput: $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: {
                                versionStatuses: [
                                    'RELEASED',
                                    'UNRELEASED'
                                ],
                                includeSharedReleases: true
                            },
                            sprintsSearchInput: null,
                            skipSprintSearch: true,
                            skipVersionSearch: false,
                            viewId: null,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields
                }
            };
        }
    });
    var $5j7Th;
    var $kxZPA;
    const $623de1afef111eb1$export$a3db41da3fd3ff21 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $38193f9d05bd632a$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $623de1afef111eb1$export$ebca96bcc4698ee2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jPhO0")), {
        moduleId: "./src/packages/spa-apps/business/calendar/src/index.tsx"
    });
    var $623de1afef111eb1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $623de1afef111eb1$export$ebca96bcc4698ee2,
            pageId: "async-business-calendar",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $70a9a2194c74ba61$export$146b7e01aca9816a = (0, $6a0b20679c309df7$export$56ea489e9d4bfa04)({
        main: (0, $38193f9d05bd632a$export$19cf4b398f638dc6)
    });
    const $70a9a2194c74ba61$export$152b9e0029b084e8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ieQKQ")), {
        moduleId: "./src/packages/spa-apps/business/calendar-embed/src/index.tsx"
    });
    var $70a9a2194c74ba61$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $70a9a2194c74ba61$export$152b9e0029b084e8,
            pageId: "async-business-calendar-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $32842b78cbaba6f2$export$240a58749ebba091 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aWQgu")), {
        moduleId: "./src/packages/spa-apps/business/form/src/index.tsx"
    });
    var $32842b78cbaba6f2$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $32842b78cbaba6f2$export$240a58749ebba091,
            pageId: "async-business-form",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $69b26f1a607bfd2a$export$2076234d7fde1717 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9QELA")), {
        moduleId: "./src/packages/spa-apps/business/form-builder/src/index.tsx"
    });
    var $69b26f1a607bfd2a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $69b26f1a607bfd2a$export$2076234d7fde1717,
            pageId: "async-business-form-builder",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $86d107866af1a870$export$258fcd204933dd75 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eanHo")), {
        moduleId: "./src/packages/spa-apps/business/form-submit/src/index.tsx"
    });
    var $86d107866af1a870$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $86d107866af1a870$export$258fcd204933dd75,
            pageId: "async-business-form-submit",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7b75b9ef7f4c7083$export$4d2f42d18d020964 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ePboY")), {
        moduleId: "./src/packages/spa-apps/business/form-submit-embed/src/index.tsx"
    });
    var $7b75b9ef7f4c7083$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7b75b9ef7f4c7083$export$4d2f42d18d020964,
            pageId: "async-business-form-submit-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $5d8b9133c744d9c4$export$55704f3c7b8c3364 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3yT5r")), {
        moduleId: "./src/packages/spa-apps/business/list-embed/src/index.tsx"
    });
    var $5d8b9133c744d9c4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5d8b9133c744d9c4$export$55704f3c7b8c3364,
            pageId: "async-business-list-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d22af251819eb3be$export$5b8a69e38f82df6c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jyTiP")), {
        moduleId: "./src/packages/spa-apps/business/overview-calendar/src/index.tsx"
    });
    var $d22af251819eb3be$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d22af251819eb3be$export$5b8a69e38f82df6c,
            pageId: "async-business-overview-calendar",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2d4de63580afb00a$export$125428653f4abe07 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hchJ9")), {
        moduleId: "./src/packages/spa-apps/business/overview-summary/src/index.tsx"
    });
    var $2d4de63580afb00a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2d4de63580afb00a$export$125428653f4abe07,
            pageId: "async-business-overview-summary",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $e65cb4f5cee837b4$export$bfea8be13da0d217 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3THqq")), {
        moduleId: "./src/packages/spa-apps/business/overview-timeline/src/index.tsx"
    });
    var $e65cb4f5cee837b4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e65cb4f5cee837b4$export$bfea8be13da0d217,
            pageId: "async-business-overview-timeline",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $d0b7938065585b86$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $7e318392f3d5106d$export$c2115a649411f570 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9ZUr6"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/business/pages/src/index.tsx"
    });
    const $7e318392f3d5106d$export$7c3b1828ada63555 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $d0b7938065585b86$export$8a3df560509448b8), {
            page: "/pages"
        });
    var $7e318392f3d5106d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7e318392f3d5106d$export$c2115a649411f570,
            pageId: "async-business-pages",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d8c7c044abd4283c$export$e39375ab6521f3ef = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jvCkt")), {
        moduleId: "./src/packages/spa-apps/business/sample-onboarding/src/index.tsx"
    });
    var $d8c7c044abd4283c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d8c7c044abd4283c$export$e39375ab6521f3ef,
            pageId: "async-business-sample-onboarding",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $19b2198152d557fa$export$dfbcb99b55c05486 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hKI24")), {
        moduleId: "./src/packages/spa-apps/business/shortcut/src/index.tsx"
    });
    var $19b2198152d557fa$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $19b2198152d557fa$export$dfbcb99b55c05486,
            pageId: "async-business-shortcuts",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $555c2b2940c866b0$export$a860d403525d69a5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3k1Pf")), {
        moduleId: "./src/packages/spa-apps/business/summary-embed/src/index.tsx"
    });
    var $555c2b2940c866b0$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $555c2b2940c866b0$export$a860d403525d69a5,
            pageId: "async-business-summary-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6263e6dfd2780343$export$5ae50f261c16f52a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("30tb6")), {
        moduleId: "./src/packages/spa-apps/business/timeline/src/index.tsx"
    });
    var $6263e6dfd2780343$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6263e6dfd2780343$export$5ae50f261c16f52a,
            pageId: "async-business-timeline",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $daf37642b69bd70b$export$49e7774ce1be17a4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("iBRfX")), {
        moduleId: "./src/packages/spa-apps/business/timeline-embed/src/index.tsx"
    });
    var $daf37642b69bd70b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $daf37642b69bd70b$export$49e7774ce1be17a4,
            pageId: "async-business-timeline-embed",
            shouldShowSpinner: true
        });
    const $0e0d75857105a821$export$fb2091db9e7f9102 = [
        (0, $a3e453621b7ee07b$export$deec07bcf556562e),
        (0, $7bd4ff8b4781d2c1$export$c7fe0dd4417407a0),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$e237859f2fc7cc7), ()=>({
                ufoName: 'jwm.calendar-embed-view',
                component: (0, $70a9a2194c74ba61$export$2e2bcd8739ae039),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? (0, $70a9a2194c74ba61$export$146b7e01aca9816a) : undefined;
                },
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, $70a9a2194c74ba61$export$152b9e0029b084e8)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$ba1373c12ea65b4c), ()=>({
                ufoName: 'jwm.calendar-view',
                component: (0, $623de1afef111eb1$export$2e2bcd8739ae039),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? (0, $623de1afef111eb1$export$a3db41da3fd3ff21) : undefined;
                },
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $623de1afef111eb1$export$ebca96bcc4698ee2)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$2dd4e8a37d8ac978), ()=>({
                component: (0, $19b2198152d557fa$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $19b2198152d557fa$export$dfbcb99b55c05486)
                ]
            })),
        (0, $51524c4dee2e7b63$export$fe7e91eb3254e090),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$e98776bdf96c88ac), ()=>({
                ufoName: 'jwm.form-directory-view',
                component: (0, $32842b78cbaba6f2$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $32842b78cbaba6f2$export$240a58749ebba091)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$3cd93ff55b29f07f), ()=>({
                ufoName: 'jwm.form-submit-view',
                component: (0, $86d107866af1a870$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $86d107866af1a870$export$258fcd204933dd75)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$5f684808e671de5), ()=>({
                ufoName: 'jwm.form-view',
                component: (0, $69b26f1a607bfd2a$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $69b26f1a607bfd2a$export$2076234d7fde1717)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$4301c67fd317894a), ()=>({
                ufoName: 'jwm.timeline-view',
                component: (0, $6263e6dfd2780343$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6263e6dfd2780343$export$5ae50f261c16f52a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$3109a183a442a02d), ()=>({
                ufoName: 'jwm.approvals-view',
                component: (0, $09fa0192771673de$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $09fa0192771673de$export$70abf918dfb890e)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$54a218ca6d1c056a), ()=>({
                resources: [
                    ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, $7e318392f3d5106d$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7e318392f3d5106d$export$c2115a649411f570)
                ],
                ufoName: 'jwm.jwm-pages'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$2d0c5d5ce5a00c), ()=>({
                ufoName: 'jwm.attachments-view',
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                entryPoint: ()=>(0, $8d9ee4e688aa8c8e$export$d2dbce06a31f0f47),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)()
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$fb814f9911fc766e), ()=>({
                ufoName: 'jwm.timeline-embed-view',
                component: (0, $daf37642b69bd70b$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, $daf37642b69bd70b$export$49e7774ce1be17a4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$f0d33cf104c15274), ()=>({
                ufoName: 'jwm.list-embed-view',
                component: (0, $5d8b9133c744d9c4$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                entryPoint: ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $f5609894035bdf64$export$c338b91a236e608a) : undefined,
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, $5d8b9133c744d9c4$export$55704f3c7b8c3364)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$7d6a91d85236417), ()=>({
                ufoName: 'jwm.jwm-board-embed',
                component: (0, $168a009788c7c0cc$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: [
                    ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                    (0, (0, parcelRequire("d8VYe")).workflowIssuesResource)
                ],
                forPaint: [
                    (0, $168a009788c7c0cc$export$a21a9228b9e68b40)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$7e8fd15fdfa29385), ()=>({
                ufoName: 'jwm.form-submit-embed-view',
                component: (0, $7b75b9ef7f4c7083$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, $7b75b9ef7f4c7083$export$4d2f42d18d020964)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$13164dbb379620e2), ()=>({
                ufoName: 'jwm.summary-view-embed',
                component: (0, $555c2b2940c866b0$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: [
                    ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                    (0, (0, parcelRequire("3zj3N")).summaryDataResource),
                    (0, (0, parcelRequire("kqhaB")).activityFeedResource)
                ],
                forPaint: [
                    (0, $555c2b2940c866b0$export$a860d403525d69a5)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$cd9c218d7c968d2d), ()=>({
                component: (0, $d8c7c044abd4283c$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                forPaint: [
                    (0, $d8c7c044abd4283c$export$e39375ab6521f3ef)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$13f0c823ff3059c2), ()=>({
                component: (0, $e65cb4f5cee837b4$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e65cb4f5cee837b4$export$bfea8be13da0d217)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$61383e5418d2ffe3), ()=>({
                component: (0, $d22af251819eb3be$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d22af251819eb3be$export$5b8a69e38f82df6c)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7f3c03fe7edf119$export$4a86e6b12ce49af9), ()=>({
                component: (0, $2d4de63580afb00a$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2d4de63580afb00a$export$125428653f4abe07)
                ]
            })),
        (0, $372ca2c4b5e66a38$export$766e305da4c78de5),
        (0, $372ca2c4b5e66a38$export$3aa9116f715693e1)
    ];
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $1NY07;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b4450c735413409b$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2igd7"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $b4450c735413409b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b4450c735413409b$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    const $c035d1074a7f086e$export$5b0670f37204a43d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1NY07")).classicProjectSettingsDataClassificationsRoute), ()=>({
            component: (0, $b4450c735413409b$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b4450c735413409b$export$b8abcf8aa8f4df56)
            ]
        }));
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $1cead9ea53333f91$export$c593179674352d0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT),
        path: '/plugins/servlet/project-config/:projectKey/issuelayout',
        query: [
            'screenId'
        ],
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f7c23974aa64ecd2$export$36dcfb52d47cb93a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("61LFA"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $f7c23974aa64ecd2$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f7c23974aa64ecd2$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    const $793958c8c0cec75f$export$47b3bdf88a7d176b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1cead9ea53333f91$export$c593179674352d0), ()=>({
            ufoName: 'project-settings.issue-type.jsw-cmp',
            component: (0, $f7c23974aa64ecd2$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f7c23974aa64ecd2$export$36dcfb52d47cb93a)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $e2ctp;
    var $6s1PB;
    var $7XYc4;
    var $cSD7y;
    var $gyYxw;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $3HwlS;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $dAmbh;
    var $g4ZHz;
    var $iNzEe;
    var $1E3vT;
    var $l2N2a;
    var $9yEpR;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $2GkDw;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $hJAri;
    var $iZ82x;
    var $7GnDe;
    var $2Ql51;
    var $bMz5r;
    var $5lsNZ;
    var $7MCPm;
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    var $co1wz;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $8918f6db6c72ebfe$export$12e1ca6c7cfdfd49 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
        path: '/jira/software/projects/:projectKey/incidents'
    };
    const $8918f6db6c72ebfe$export$3356a7870a2717f4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/incidents'
    };
    var $drVya;
    var $5PD5h;
    const $58f54a3a0d651497$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670",
            "metadata": {
                "connection": [
                    {
                        "count": "servicePageSize",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "linkedOperationsComponentsByProject"
                        ]
                    }
                ]
            },
            "name": "srcIncidentsPageInternalQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $58f54a3a0d651497$export$2e2bcd8739ae039 = $58f54a3a0d651497$var$node;
    var $eufEc;
    var $fEDBv;
    const $b9fe885d02827a63$var$AriGraphSortOrderInput = {
        ASC: 'ASC',
        DESC: 'DESC'
    };
    const $b9fe885d02827a63$var$QUERY_PARAM_SEARCH = 'search';
    const $b9fe885d02827a63$var$QUERY_PARAM_PRIORITY = 'priority';
    const $b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
    const $b9fe885d02827a63$var$QUERY_PARAM_STATUS = 'status';
    const $b9fe885d02827a63$var$QUERY_PARAM_SORT_BY = 'sortBy';
    const $b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
    const $b9fe885d02827a63$var$STATUS_SORT_KEY = 'status';
    const $b9fe885d02827a63$var$CREATED_SORT_KEY = 'created';
    const $b9fe885d02827a63$var$PRIORITY_SORT_KEY = 'priority';
    const $b9fe885d02827a63$var$SUMMARY_SORT_KEY = 'key';
    const $b9fe885d02827a63$var$ASC_SORT_KEY = 'ASC';
    const $b9fe885d02827a63$var$DESC_SORT_KEY = 'DESC';
    function $b9fe885d02827a63$var$notEmpty(value) {
        return Boolean(value);
    }
    const $b9fe885d02827a63$var$isPriority = $b9fe885d02827a63$var$notEmpty;
    const $b9fe885d02827a63$var$isStatus = (val)=>val === 'resolved' || val === 'open';
    const $b9fe885d02827a63$var$isSortBy = (val)=>val === $b9fe885d02827a63$var$STATUS_SORT_KEY || val === $b9fe885d02827a63$var$CREATED_SORT_KEY || val === $b9fe885d02827a63$var$PRIORITY_SORT_KEY || val === $b9fe885d02827a63$var$SUMMARY_SORT_KEY;
    const $b9fe885d02827a63$var$isSortOrder = (val)=>val === $b9fe885d02827a63$var$ASC_SORT_KEY || val === $b9fe885d02827a63$var$DESC_SORT_KEY;
    const $b9fe885d02827a63$var$isAffectedService = $b9fe885d02827a63$var$notEmpty;
    function $b9fe885d02827a63$var$parseParameter(parameter, parameterValidationFn) {
        return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
    }
    const $b9fe885d02827a63$var$parseQueryParams = (paramsRaw)=>{
        const result = {
            [$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] && $b9fe885d02827a63$var$isSortBy(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] : $b9fe885d02827a63$var$CREATED_SORT_KEY,
            [$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] && $b9fe885d02827a63$var$isSortOrder(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] : $b9fe885d02827a63$var$DESC_SORT_KEY
        };
        result[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE], $b9fe885d02827a63$var$isAffectedService);
        result[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_STATUS], $b9fe885d02827a63$var$isStatus);
        result[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] = paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] ?? undefined;
        result[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY], $b9fe885d02827a63$var$isPriority);
        return result;
    };
    const $b9fe885d02827a63$var$getFilterValue = (values)=>({
            ...values.length > 0 ? {
                is: values
            } : {}
        });
    const $b9fe885d02827a63$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
            switch(stat){
                case 'open':
                    return [
                        'NEW',
                        'INDETERMINATE'
                    ];
                case 'resolved':
                    return [
                        'DONE'
                    ];
                default:
                    return [
                        'UNDEFINED'
                    ];
            }
        });
    const $b9fe885d02827a63$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
            and: [
                {
                    to_status: $b9fe885d02827a63$var$getFilterValue($b9fe885d02827a63$var$parseStatusToFilterValues(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] ?? [])),
                    to_priority: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] ?? []),
                    to_affectedServiceAris: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
                }
            ]
        });
    const $b9fe885d02827a63$var$parseSortDirection = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
            default:
                return defaultValue;
        }
    };
    const $b9fe885d02827a63$var$getSortValue = (sortOrder)=>({
            priority: 2,
            direction: $b9fe885d02827a63$var$parseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC)
        });
    const $b9fe885d02827a63$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
            default:
                return defaultValue;
        }
    };
    const $b9fe885d02827a63$var$getInverseSortValue = (sortOrder)=>({
            priority: 2,
            direction: $b9fe885d02827a63$var$parseInverseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC)
        });
    const $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
            lastModified: {
                priority: 1,
                direction: $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC
            },
            ...$b9fe885d02827a63$var$STATUS_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                to_status: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {},
            ...$b9fe885d02827a63$var$PRIORITY_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                to_priority: $b9fe885d02827a63$var$getInverseSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {},
            ...$b9fe885d02827a63$var$CREATED_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                createdAt: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {}
        });
    const $b9fe885d02827a63$export$a59477eea6e8cd7f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("6R6ro")).then((mod)=>mod.IncidentsPageWrapper), {
            moduleId: "5b8b4ff7"
        }),
        getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
                queries: {
                    incidentPageData: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: $58f54a3a0d651497$export$2e2bcd8739ae039,
                        variables: {
                            incidentPageSize: 30,
                            servicePageSize: 30,
                            cloudId: cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            filter: $b9fe885d02827a63$var$getGqlFiltersFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                            sort: $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                            siteAri: `ari:cloud:jira::site/${cloudId}`
                        }
                    }
                }
            })
    });
    const $d2978738121ef6b5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "associatedComponents"
                        ]
                    }
                ]
            },
            "name": "srcIncidentsLinkedServicesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $d2978738121ef6b5$export$2e2bcd8739ae039 = $d2978738121ef6b5$var$node;
    var $eufEc;
    var $fEDBv;
    const $b93c8ec26a3d236d$export$a59477eea6e8cd7f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("d6qce")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
            moduleId: "d6132459"
        }),
        getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
                queries: {
                    incidentPageData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $d2978738121ef6b5$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
    var $e7bC3;
    const $9e60de4e7ff199f0$var$entryPointDeprecated = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $b93c8ec26a3d236d$export$a59477eea6e8cd7f),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $9e60de4e7ff199f0$var$entryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $b9fe885d02827a63$export$a59477eea6e8cd7f),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $9e60de4e7ff199f0$export$fd29243dbe4103 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8918f6db6c72ebfe$export$12e1ca6c7cfdfd49), ()=>({
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('corex-operandi-incidents-page-in-jira_5ebja') ? $9e60de4e7ff199f0$var$entryPoint : $9e60de4e7ff199f0$var$entryPointDeprecated;
            },
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            skeleton: (0, (0, parcelRequire("drVya")).IncidentsPageSkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("7GnDe")).incidentsInitialPageChecksResource),
                (0, (0, parcelRequire("7GnDe")).incidentsCustomFieldIdResource)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS)),
                    teamName: 'operandi'
                }
            },
            ufoName: 'software-incidents'
        }));
    const $9e60de4e7ff199f0$export$c7d98bfe75274932 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8918f6db6c72ebfe$export$3356a7870a2717f4), ()=>({
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('corex-operandi-incidents-page-in-jira_5ebja') ? $9e60de4e7ff199f0$var$entryPoint : $9e60de4e7ff199f0$var$entryPointDeprecated;
            },
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            skeleton: (0, (0, parcelRequire("drVya")).IncidentsPageSkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("7GnDe")).incidentsInitialPageChecksResource),
                (0, (0, parcelRequire("7GnDe")).incidentsCustomFieldIdResource)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC)),
                    teamName: 'operandi'
                }
            },
            ufoName: 'software-incidents'
        }));
    var $aIZdc;
    var $ffza4;
    var $e2ctp;
    var $cSD7y;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $3RJkv;
    var $ipmBb;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $f7Y15;
    var $gNStA;
    var $5lsNZ;
    var $k7fxM;
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $co1wz;
    var $5j7Th;
    var $kxZPA;
    const $b34d0a459c6590c3$export$2164de18d39af313 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("evG1K")), {
        moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$bcc6315cf211edab = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1vlac")), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$a1c59527bd5131cc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("42ppS")).then((module)=>module.BoardConfigSwitcher), {
        moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/entries/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$4ceb6cf2934825b2 = (props)=>{
        const { route: route, query: query, match: match } = props;
        const basePageId = route && route.name || 'rapid-board';
        const chartParam = query.chart ? `-${query.chart}` : '';
        const boardId = query.rapidView ?? match.params.boardId;
        const pageId = `${basePageId}-${boardId}${chartParam}`;
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD)
        ].includes(route.name) && !query.config) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$2164de18d39af313,
            pageId: pageId,
            shouldShowSpinner: false
        });
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
        ].includes(route.name) && !query.config) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$bcc6315cf211edab,
            pageId: pageId,
            shouldShowSpinner: false
        });
        if ((0, (0, parcelRequire("co1wz")).ff)('simplified-boards-milestone-2_07hbk') && [
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
        ].includes(route.name) && query.config) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$a1c59527bd5131cc,
            pageId: pageId,
            shouldShowSpinner: false
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$9de09057ba255cc4,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    const $b34d0a459c6590c3$export$9de09057ba255cc4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5ERDu")), {
        moduleId: "./src/packages/spa-apps/rapid-board/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$bcb5bb6438a46dcb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8kiyc")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$d4640ceb9bdd4b4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bnQeN")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$c96c36c0cbfb2c16 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ifUKB")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$2ad64ed8eb98d9e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4ajRG")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$4a8825f3e310b97 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eFW1U")), {
        moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
    });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $04b859bd88088960$exports = {};
    $04b859bd88088960$exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();
    const $cff09f53ee9f2bb4$var$customCssStyles = null;
    const $cff09f53ee9f2bb4$export$631611c5fdf027d5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($04b859bd88088960$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        });
    var $5PD5h;
    const $e5e1c502f00851e8$var$classicBoardCapability = !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c);
    const $e5e1c502f00851e8$export$f2cd114cf8ab53aa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k7fxM")).classicSoftwareBoardRoute), ()=>({
            component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
            skeleton: (0, $cff09f53ee9f2bb4$export$631611c5fdf027d5),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources)() && !(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$2164de18d39af313)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: $e5e1c502f00851e8$var$classicBoardCapability
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
        }));
    const $e5e1c502f00851e8$export$b5558b683e9c45a4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k7fxM")).classicSoftwareBoardEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_board_smartlink_embed', (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources)() && !(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)(),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, $b34d0a459c6590c3$export$2164de18d39af313)
            ],
            meta: {
                capability: $e5e1c502f00851e8$var$classicBoardCapability
            }
        }));
    var $g87MG;
    var $ffza4;
    var $e2ctp;
    var $gyYxw;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lfnsv;
    var $f5kpo;
    var $3RJkv;
    var $65Ltd;
    const $3abe0786c84d74a5$export$9e1d275c8078512e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
        query: [
            'config=insightsConfig'
        ]
    };
    const $3abe0786c84d74a5$export$8163d70aae333a78 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId',
        query: [
            'config=insightsConfig'
        ]
    };
    var $aJzGl;
    var $5PD5h;
    var $ibA3M;
    var $dIdda = parcelRequire("dIdda");
    const $018a8accd0bb9a64$export$f7bc2c5799e41684 = ()=>{
        const { setSelectedConfigTab: setSelectedConfigTab } = (0, (0, parcelRequire("ibA3M")).useSelectedConfigTab)();
        const [, setConfigParam] = (0, $dIdda.useQueryParam)('config');
        setSelectedConfigTab('filter');
        setConfigParam('filter');
        return null;
    };
    const $213bc38e0eb732c2$export$afb310a61bc1979c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3abe0786c84d74a5$export$9e1d275c8078512e), ()=>({
            ufoName: 'rapidboard-backlog-insights',
            component: (0, $018a8accd0bb9a64$export$f7bc2c5799e41684),
            skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=planning'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                (0, $b34d0a459c6590c3$export$4a8825f3e310b97),
                (0, $b34d0a459c6590c3$export$d4640ceb9bdd4b4),
                (0, $b34d0a459c6590c3$export$c96c36c0cbfb2c16),
                (0, $b34d0a459c6590c3$export$bcb5bb6438a46dcb),
                (0, $b34d0a459c6590c3$export$2ad64ed8eb98d9e)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
        }));
    var $g87MG;
    var $ffza4;
    var $e2ctp;
    var $gyYxw;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lfnsv;
    var $f5kpo;
    var $3RJkv;
    var $5PD5h;
    const $4173ec798b4a3bc2$export$910bdb49ffbc1a01 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3abe0786c84d74a5$export$8163d70aae333a78), ()=>({
            ufoName: 'rapidboard-board-insights',
            component: (0, $018a8accd0bb9a64$export$f7bc2c5799e41684),
            skeleton: (0, $cff09f53ee9f2bb4$export$631611c5fdf027d5),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                (0, $b34d0a459c6590c3$export$4a8825f3e310b97),
                (0, $b34d0a459c6590c3$export$d4640ceb9bdd4b4),
                (0, $b34d0a459c6590c3$export$c96c36c0cbfb2c16),
                (0, $b34d0a459c6590c3$export$bcb5bb6438a46dcb),
                (0, $b34d0a459c6590c3$export$2ad64ed8eb98d9e)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
        }));
    const $f7a61037070d3efe$export$4bab4a9393eceb86 = [
        (0, $213bc38e0eb732c2$export$afb310a61bc1979c),
        (0, $4173ec798b4a3bc2$export$910bdb49ffbc1a01)
    ];
    var $ffza4;
    var $e2ctp;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $f5kpo;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $fd9da0460c22fa5a$export$8163d70aae333a78 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView'
        ]
    };
    var $5PD5h;
    const $5e98dd01700151f4$export$4a5b9e48e40676ad = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fd9da0460c22fa5a$export$8163d70aae333a78), ()=>({
            ufoName: 'classic-board',
            component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
            skeleton: (0, $cff09f53ee9f2bb4$export$631611c5fdf027d5),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $b4koY;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $75bfb8b57cb3016c$export$3ba8dd9a7886e7d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
        path: '/jira/software/projects/:projectKey/deployments'
    };
    const $75bfb8b57cb3016c$export$485e4a7b82f29d70 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/deployments'
    };
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2cdb997b770c0bb4$export$ed6d152d5551715c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8awia"))), {
        moduleId: "./src/packages/spa-apps/deployments/src/index.tsx"
    });
    const $2cdb997b770c0bb4$export$35822a21682c5ed8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2cdb997b770c0bb4$export$ed6d152d5551715c,
            pageId: "deploymentsNextGen",
            shouldShowSpinner: true
        });
    const $2cdb997b770c0bb4$export$7361c0feb3154afe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2cdb997b770c0bb4$export$ed6d152d5551715c,
            pageId: "deploymentsClassic",
            shouldShowSpinner: true
        });
    const $2cdb997b770c0bb4$export$7e5ccb20ad8e1612 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $75bfb8b57cb3016c$export$3ba8dd9a7886e7d), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $2cdb997b770c0bb4$export$35822a21682c5ed8),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("b4koY")).deploymentPreconditionRelayResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $2cdb997b770c0bb4$export$ed6d152d5551715c
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $2cdb997b770c0bb4$export$dcf1f9ba660dedf6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $75bfb8b57cb3016c$export$485e4a7b82f29d70), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("b4koY")).deploymentPreconditionRelayResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $2cdb997b770c0bb4$export$7361c0feb3154afe),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $2cdb997b770c0bb4$export$ed6d152d5551715c
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6bbae009e0a4162e$export$2076234d7fde1717 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lHhzD")), {
        moduleId: "./src/packages/spa-apps/software/form-builder/src/index.tsx"
    });
    const $6bbae009e0a4162e$export$a4c73b2a16981930 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6bbae009e0a4162e$export$2076234d7fde1717,
            pageId: "async-software-form-builder",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7513c2d92a0c1be5$export$240a58749ebba091 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9bKt5")), {
        moduleId: "./src/packages/spa-apps/software/form/src/index.tsx"
    });
    const $7513c2d92a0c1be5$export$7234abc5d81adb58 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7513c2d92a0c1be5$export$240a58749ebba091,
            pageId: "async-software-form",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $a96ac2d599fb8faa$export$258fcd204933dd75 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("g0oJP")), {
        moduleId: "./src/packages/spa-apps/software/form-submit/src/index.tsx"
    });
    const $a96ac2d599fb8faa$export$4258f48cc65dca00 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a96ac2d599fb8faa$export$258fcd204933dd75,
            pageId: "async-software-form-submit",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $aIZdc;
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $ajKFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $50b0eee0a3f432d7$export$7e7b18da5d3ceba0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
        path: '/jira/software/projects/:projectKey/development'
    };
    const $50b0eee0a3f432d7$export$cb5cec74f302b3c6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/development'
    };
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9db212062a348ac3$export$9c25b4571a88e1f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9w6V0"))), {
        moduleId: "./src/packages/spa-apps/periscope/src/index.tsx"
    });
    const $9db212062a348ac3$export$d86ed8d2756a4d4d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9db212062a348ac3$export$9c25b4571a88e1f,
            pageId: "softwarePeriscopeNextGen",
            shouldShowSpinner: true
        });
    const $9db212062a348ac3$export$fd5920cadc24919d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9db212062a348ac3$export$9c25b4571a88e1f,
            pageId: "softwarePeriscopeClassic",
            shouldShowSpinner: true
        });
    const $9db212062a348ac3$export$7db4d910357a4d89 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $50b0eee0a3f432d7$export$7e7b18da5d3ceba0), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $9db212062a348ac3$export$d86ed8d2756a4d4d),
            skeleton: (0, (0, parcelRequire("ajKFd")).Skeleton),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9db212062a348ac3$export$9c25b4571a88e1f
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE)),
                    teamName: 'nova'
                }
            }
        }));
    const $9db212062a348ac3$export$d7d49c1a51b3c0a9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $50b0eee0a3f432d7$export$cb5cec74f302b3c6), ()=>({
            skeleton: (0, (0, parcelRequire("ajKFd")).Skeleton),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $9db212062a348ac3$export$fd5920cadc24919d),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9db212062a348ac3$export$9c25b4571a88e1f
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC)),
                    teamName: 'nova'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $bwLf9;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $en8e6;
    var $5lsNZ;
    var $65Ltd;
    const $fff5c1eec5774fa9$export$3a4d4ecb82e1bfc8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
        path: '/jira/software/projects/:projectKey/security'
    };
    const $fff5c1eec5774fa9$export$b7285748f1151353 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/security'
    };
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1bbbe61aca30e3ab$var$isSecurityPageEnabled = ()=>!(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('isotopes-security-page-in-jira-enabled-v2');
    const $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("csz4l"))), {
        moduleId: "./src/packages/spa-apps/security/src/index.tsx"
    });
    const $1bbbe61aca30e3ab$export$c6cc344ea309349a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3,
            pageId: "securityNextGen",
            shouldShowSpinner: true
        });
    const $1bbbe61aca30e3ab$export$b4dc9ba40afbdd9f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3,
            pageId: "securityClassic",
            shouldShowSpinner: true
        });
    const $1bbbe61aca30e3ab$export$a8dcfae475505e7a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fff5c1eec5774fa9$export$3a4d4ecb82e1bfc8), ()=>({
            component: (0, (0, parcelRequire("bwLf9")).default)($1bbbe61aca30e3ab$var$isSecurityPageEnabled, $1bbbe61aca30e3ab$export$c6cc344ea309349a, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            ufoName: 'software-security-combined',
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("en8e6")).securityPageResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY)),
                    teamName: 'fusion-isotopes'
                }
            }
        }));
    const $1bbbe61aca30e3ab$export$8acfebad16c9d6f2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fff5c1eec5774fa9$export$b7285748f1151353), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("en8e6")).securityPageResource)
            ],
            ufoName: 'software-security-combined',
            component: (0, (0, parcelRequire("bwLf9")).default)($1bbbe61aca30e3ab$var$isSecurityPageEnabled, $1bbbe61aca30e3ab$export$b4dc9ba40afbdd9f, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC)),
                    teamName: 'fusion-isotopes'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d82700466a756427$export$68c09444cc6f2843 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5fsUP")), {
        moduleId: "./src/packages/spa-apps/software/summary/src/index.tsx"
    });
    const $d82700466a756427$export$893608e1a22999b9 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d82700466a756427$export$68c09444cc6f2843,
            pageId: "software-summary",
            shouldShowSpinner: true
        });
    };
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $f7Y15;
    var $gNStA;
    var $5mLQj;
    var $5PD5h;
    const $fd1485349b2df65b$export$cde4dacc737dc0f1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5mLQj")).userBoardRoute), ()=>({
            component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
            skeleton: (0, $cff09f53ee9f2bb4$export$631611c5fdf027d5),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                (0, $b34d0a459c6590c3$export$4a8825f3e310b97),
                (0, $b34d0a459c6590c3$export$d4640ceb9bdd4b4),
                (0, $b34d0a459c6590c3$export$c96c36c0cbfb2c16),
                (0, $b34d0a459c6590c3$export$bcb5bb6438a46dcb),
                (0, $b34d0a459c6590c3$export$2ad64ed8eb98d9e)
            ]
        }));
    var $7OYJs;
    var $is7uC;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $0d44d4fc842a7298$exports = {};
    $0d44d4fc842a7298$exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();
    const $ca7240f722f926b7$export$d7667341f4db3b8d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($0d44d4fc842a7298$exports)))
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $1d2d2f220593896f$exports = {};
    $1d2d2f220593896f$exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();
    var $c492ef1f477ffd28$exports = {};
    $c492ef1f477ffd28$exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();
    const $a38265b6f9242f57$export$cbc3335f7a517046 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($1d2d2f220593896f$exports)))
        });
    const $a38265b6f9242f57$export$2638f1c98fe91c13 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($c492ef1f477ffd28$exports)))
        });
    var $aJzGl;
    var $lm7AC;
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $02623e8fca40b314$export$c70b8d9ef0c891b2 = ()=>{
        const [{ query: query, match: match }] = (0, $dIdda.useRouter)();
        const queryParams = new URLSearchParams(query).toString();
        const { projectKey: projectKey, boardId: boardId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
                hash: '',
                search: queryParams
            }
        });
    };
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $c75fcd785e66868e$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $c75fcd785e66868e$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4a23aaa7a1201d94$export$cabb458181f7566e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Aupt"))), {
        moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
    });
    var $4a23aaa7a1201d94$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4a23aaa7a1201d94$export$cabb458181f7566e,
            pageId: `classic-atlas-goals-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $480a54898b863a19$export$a0f04dd35569e11 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9xG8v")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
    });
    var $480a54898b863a19$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $480a54898b863a19$export$a0f04dd35569e11,
            pageId: "proforma-issue-forms-direct",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $a96f990777917c84$export$22681210aaeb910f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jDCWS")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
    });
    var $a96f990777917c84$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a96f990777917c84$export$22681210aaeb910f,
            pageId: "proforma-issue-forms-direct-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $636a0aa010a33fb5$export$84165bb08bf42eef = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("i1VgZ"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index.tsx"
    });
    var $636a0aa010a33fb5$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { boardId: boardId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $636a0aa010a33fb5$export$84165bb08bf42eef,
            pageId: `classic-roadmap-${boardId || ''}`,
            shouldShowSpinner: false
        });
    };
    var $lmyls;
    var $4R6GH;
    var $eufEc;
    var $fEDBv;
    function $d8251bf369abb7ad$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
        return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
    }
    function $d8251bf369abb7ad$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $d8251bf369abb7ad$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR = 'software-calendar';
    const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
    const $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES = [
        $d8251bf369abb7ad$var$SOFTWARE_CALENDAR,
        $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED
    ];
    function $d8251bf369abb7ad$var$createScope({ context: context, tenantContext: tenantContext }) {
        const { cloudId: cloudId } = tenantContext;
        const isTMP = $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
        return {
            type: 'board',
            boardId: $d8251bf369abb7ad$var$toBoardAri({
                siteId: cloudId,
                boardId: String(context.match.params.boardId)
            }),
            projectKeys: isTMP ? [
                String(context.match.params.projectKey)
            ] : []
        };
    }
    function $d8251bf369abb7ad$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        const scopeInput = {
            ids: [
                scope.boardId
            ]
        };
        if (scope.projectKeys && scope.projectKeys.length > 0) return {
            ...scopeInput,
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
        return scopeInput;
    }
    function $d8251bf369abb7ad$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $d8251bf369abb7ad$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $d8251bf369abb7ad$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
        return {
            date: $d8251bf369abb7ad$var$toMidnightUTCString(selectedDate),
            mode: $d8251bf369abb7ad$var$toViewMode(viewRange),
            weekStart: $d8251bf369abb7ad$var$toWeekStart(weekStartsOn),
            startDateField: startDateField,
            endDateField: endDateField
        };
    }
    function $d8251bf369abb7ad$var$buildIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d8251bf369abb7ad$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $d8251bf369abb7ad$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    const $d8251bf369abb7ad$export$19cf4b398f638dc6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("fntlm")), {
            moduleId: "57ee20a5"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $d8251bf369abb7ad$var$createScope(entryPointRouteParams);
            const { date: date } = context.query;
            const selectedDate = $d8251bf369abb7ad$var$toDate(date);
            const boardId = String(context.match.params.boardId);
            const viewRange = 'month';
            const weekStartsOn = 'sunday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $122674b135b0c50b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $d8251bf369abb7ad$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $d8251bf369abb7ad$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                startDateField: startDateField,
                                endDateField: endDateField
                            }),
                            issuesSearchInput: $d8251bf369abb7ad$var$buildIssuesSearchInput(),
                            unscheduledIssuesSearchInput: $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $d8251bf369abb7ad$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $d8251bf369abb7ad$var$buildSprintsSearchInput(),
                            skipSprintSearch: false,
                            skipVersionSearch: false,
                            viewId: null,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields,
                    boardId: boardId
                }
            };
        }
    });
    const $24d3258934ab0fe5$export$83b1b9036cc7961a = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d8251bf369abb7ad$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $ebyGx = parcelRequire("ebyGx");
    const $12fea879e07c880e$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $6049b4a08957accb$export$4beafd9dbad29bff = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("492p0"))), {
        moduleId: "./src/packages/spa-apps/code/src/index.tsx"
    });
    const $6049b4a08957accb$export$faa081cb222383ac = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5AKg6")), {
        moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
    });
    const $6049b4a08957accb$export$ce40123d7c2e29e7 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5lA3L")), {
        moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
    });
    const $6049b4a08957accb$export$d9e8184332f86b53 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$4beafd9dbad29bff,
            pageId: `next-gen-code-${(0, $12fea879e07c880e$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $6049b4a08957accb$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$4beafd9dbad29bff,
            pageId: `classic-code-${(0, $12fea879e07c880e$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $6049b4a08957accb$export$422a3a028ae77ad3 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$faa081cb222383ac,
            pageId: `software-${(0, $12fea879e07c880e$export$557c2f222778cea6)({
                location: location,
                match: match
            })}-list`,
            shouldShowSpinner: true
        });
    const $6049b4a08957accb$export$4a0539d19a2e2694 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$ce40123d7c2e29e7,
            pageId: `software-${(0, $12fea879e07c880e$export$557c2f222778cea6)({
                location: location,
                match: match
            })}-list-embed`,
            shouldShowSpinner: true
        });
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $093e9fa498e2d713$var$FORMAT_RULES_FIRST = 20;
    const $093e9fa498e2d713$export$6be4f10150ff6073 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("5AKg6")), {
            moduleId: "a7ba8596"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    formattingRulesQuery: {
                        parameters: $6fc143a99d34d8f4$export$2e2bcd8739ae039,
                        variables: {
                            projectKey: projectKey,
                            cloudId: tenantContext.cloudId,
                            first: $093e9fa498e2d713$var$FORMAT_RULES_FIRST
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
    const $2190319388c8e440$export$f30a66efa682bf2d = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $093e9fa498e2d713$export$6be4f10150ff6073),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f19a24813079175a$export$956f830ed027f1fb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8ZMAu")), {
        moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
    });
    const $f19a24813079175a$export$e16ce0656a74a015 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f19a24813079175a$export$956f830ed027f1fb,
            pageId: "cycleTimeReportNextGen",
            shouldShowSpinner: true
        });
    const $f19a24813079175a$export$237924ba64065cc3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f19a24813079175a$export$956f830ed027f1fb,
            pageId: "cycleTimeReportClassic",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $edf6d9a26482ed8b$export$5113b2b19ec1fb53 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2yRGG")), {
        moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
    });
    const $edf6d9a26482ed8b$export$e2db9c7426cdb53 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $edf6d9a26482ed8b$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportNextGen",
            shouldShowSpinner: true
        });
    const $edf6d9a26482ed8b$export$655707e8ae1053d3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $edf6d9a26482ed8b$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportClassic",
            shouldShowSpinner: true
        });
    const $d1067266a88b60d4$export$edb4b8cf67d7d767 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1vlac"))), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $d1067266a88b60d4$var$ProjectsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/projects"
        });
    const $d1067266a88b60d4$var$classicBacklogCapability = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);
    const $d1067266a88b60d4$export$5b4e616b6b4b672a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareRoadmapClassicRoute), ()=>({
                component: (0, $02623e8fca40b314$export$c70b8d9ef0c891b2),
                skeleton: (0, (0, parcelRequire("lm7AC")).RoadmapSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("hJAri")).classicRoadmapResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'software-roadmap-early-entry'
                    ]
                },
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $636a0aa010a33fb5$export$84165bb08bf42eef)
                ],
                ufoName: 'classic-roadmap'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareTimelineClassicRoute), ()=>({
                component: (0, $636a0aa010a33fb5$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("lm7AC")).RoadmapSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("hJAri")).classicRoadmapResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'software-roadmap-early-entry'
                    ]
                },
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $636a0aa010a33fb5$export$84165bb08bf42eef)
                ],
                ufoName: 'classic-roadmap'
            })),
        ...(0, $f7a61037070d3efe$export$4bab4a9393eceb86),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardBacklogEmbedRoute), ()=>({
                ufoName: 'classic-backlog-embed',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_backlog_smartlink_route', (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)(),
                    (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardBacklogRoute), ()=>({
                ufoName: 'classic-backlog',
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue',
                            'view=planning'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareCalendarClassicEmbedRoute), ()=>({
                skeleton: (0, (0, parcelRequire("is7uC")).CalendarEmbedSkeleton),
                component: (0, (0, parcelRequire("is7uC")).CalendarEmbedSkeleton),
                entryPoint () {
                    if (false) return undefined;
                    return 0, $24d3258934ab0fe5$export$83b1b9036cc7961a;
                },
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
                ],
                ufoName: 'classic-calendar-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareCalendarClassicRoute), ()=>({
                skeleton: (0, (0, parcelRequire("is7uC")).CalendarSkeleton),
                component: (0, (0, parcelRequire("is7uC")).CalendarSkeleton),
                entryPoint () {
                    if (false) return undefined;
                    return 0, $24d3258934ab0fe5$export$83b1b9036cc7961a;
                },
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ],
                ufoName: 'classic-calendar'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareListEmbedClassicRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $6049b4a08957accb$export$4a0539d19a2e2694), (0, (0, parcelRequire("5lsNZ")).default)),
                skeleton: (0, $a38265b6f9242f57$export$2638f1c98fe91c13),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $2190319388c8e440$export$f30a66efa682bf2d) : undefined;
                },
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
                    (0, (0, parcelRequire("iNzEe")).navigationResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
                    (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
                    (0, (0, parcelRequire("1E3vT")).navigationItemsResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("dAmbh")).configurationResource),
                    (0, (0, parcelRequire("g4ZHz")).fieldsResource)
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, $6049b4a08957accb$export$ce40123d7c2e29e7)
                ],
                ufoName: 'classic-list-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareListClassicRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $6049b4a08957accb$export$422a3a028ae77ad3), (0, (0, parcelRequire("5lsNZ")).default)),
                skeleton: (0, $a38265b6f9242f57$export$cbc3335f7a517046),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $2190319388c8e440$export$f30a66efa682bf2d) : undefined;
                },
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
                    (0, (0, parcelRequire("iNzEe")).navigationResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
                    (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
                    (0, (0, parcelRequire("1E3vT")).navigationItemsResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("dAmbh")).configurationResource),
                    (0, (0, parcelRequire("g4ZHz")).fieldsResource)
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6049b4a08957accb$export$faa081cb222383ac)
                ],
                ufoName: 'classic-list'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardReportRoute), ()=>({
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, $ca7240f722f926b7$export$d7667341f4db3b8d),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                    (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY),
                ufoName: 'classic-report'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareReportsCycleTimeClassicRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $f19a24813079175a$export$237924ba64065cc3)),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                afterPaint: [
                    (0, $f19a24813079175a$export$956f830ed027f1fb)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f19a24813079175a$export$956f830ed027f1fb)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareFormBuilderClassicRoute), ()=>({
                ufoName: 'classic-form-builder',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $6bbae009e0a4162e$export$a4c73b2a16981930), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6bbae009e0a4162e$export$2076234d7fde1717)
                ],
                afterPaint: [
                    (0, $a96ac2d599fb8faa$export$258fcd204933dd75)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareFormSubmitClassicRoute), ()=>({
                ufoName: 'classic-form-submit',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $a96ac2d599fb8faa$export$4258f48cc65dca00), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $a96ac2d599fb8faa$export$258fcd204933dd75)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareFormClassicRoute), ()=>({
                ufoName: 'classic-form',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $7513c2d92a0c1be5$export$7234abc5d81adb58), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7513c2d92a0c1be5$export$240a58749ebba091)
                ],
                afterPaint: [
                    (0, $6bbae009e0a4162e$export$2076234d7fde1717)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareGoalsClassicRoute), ()=>({
                component: (0, $4a23aaa7a1201d94$export$2e2bcd8739ae039),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareSummaryClassicRoute), ()=>({
                ufoName: 'classic-summary',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_jsw_summary_page', (0, $d82700466a756427$export$893608e1a22999b9), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d82700466a756427$export$68c09444cc6f2843)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareClassicProformaIssueFormsDirectRoute), ()=>({
                component: (0, $480a54898b863a19$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $480a54898b863a19$export$a0f04dd35569e11)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareClassicProformaIssueFormsDirectEmbedRoute), ()=>({
                component: (0, $a96f990777917c84$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, $a96f990777917c84$export$22681210aaeb910f)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareReportsDeploymentFrequencyClassicRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $edf6d9a26482ed8b$export$655707e8ae1053d3)),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                afterPaint: [
                    (0, $edf6d9a26482ed8b$export$5113b2b19ec1fb53)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $edf6d9a26482ed8b$export$5113b2b19ec1fb53)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, $e5e1c502f00851e8$export$b5558b683e9c45a4),
        (0, $e5e1c502f00851e8$export$f2cd114cf8ab53aa),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardUserBacklogRoute), ()=>({
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardUserReportRoute), ()=>({
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, $ca7240f722f926b7$export$d7667341f4db3b8d),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                    (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, $fd1485349b2df65b$export$cde4dacc737dc0f1),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardBacklog1Route), ()=>({
                ufoName: 'classic-backlog',
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue',
                            'view=planning'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                    (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardReport1Route), ()=>({
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, $ca7240f722f926b7$export$d7667341f4db3b8d),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                    (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY),
                ufoName: 'classic-report'
            })),
        (0, $5e98dd01700151f4$export$4a5b9e48e40676ad),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareCodeClassicRoute), ()=>({
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("iZ82x")).codePageResource)
                ],
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $6049b4a08957accb$export$95e2389b7ca7ccf2)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6049b4a08957accb$export$4beafd9dbad29bff)
                ]
            })),
        (0, $1bbbe61aca30e3ab$export$8acfebad16c9d6f2),
        (0, $2cdb997b770c0bb4$export$dcf1f9ba660dedf6),
        (0, $9db212062a348ac3$export$d7d49c1a51b3c0a9),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardLastVisitedProjectRedirectRoute), ()=>({
                component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).projectDirectoryRedirectRoute), ()=>({
                component: $d1067266a88b60d4$var$ProjectsDirectoryRedirect,
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, $9e60de4e7ff199f0$export$c7d98bfe75274932)
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bTLzO;
    var $3RJkv;
    var $65Ltd;
    const $92114b096359537f$export$48d633ce1d0d2a0e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS),
        path: '/jira/settings/products/compass',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $83f9e73406def487$var$LazyCompassProductSettingsPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2nW1S"))), {
        moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
    });
    const $83f9e73406def487$export$cf9d12ec1710006a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $83f9e73406def487$var$LazyCompassProductSettingsPage,
            pageId: "async-compass-product-settings",
            shouldShowSpinner: true
        });
    const $83f9e73406def487$export$703b5090da478c9c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $92114b096359537f$export$48d633ce1d0d2a0e), ()=>({
            component: $83f9e73406def487$export$cf9d12ec1710006a,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("bTLzO")).compassProductSettingsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $83f9e73406def487$var$LazyCompassProductSettingsPage
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $c743cd13da139c69$export$7b2b015fe316fc5d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS),
        path: '/jira/settings/products/confluence',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $372b1d7617217f20$var$LazyConfluenceProductSettingsPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eGzdH"))), {
        moduleId: "./src/packages/spa-apps/confluence-product-settings/src/index.tsx"
    });
    const $372b1d7617217f20$export$a094475e0d3636f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $372b1d7617217f20$var$LazyConfluenceProductSettingsPage,
            pageId: "async-confluence-product-settings",
            shouldShowSpinner: true
        });
    const $372b1d7617217f20$export$415552b116808717 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c743cd13da139c69$export$7b2b015fe316fc5d), ()=>({
            component: $372b1d7617217f20$export$a094475e0d3636f,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $372b1d7617217f20$var$LazyConfluenceProductSettingsPage
            ]
        }));
    var $ffza4;
    const $0bf6b9f3f002a423$export$2fdb05fdbf78d595 = [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?'
    ];
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $hz6Yb;
    var $9UABi;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $e64562bb8c3fa371$export$9bb839aee83bf4d8 = [
        'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
    ];
    var $65Ltd;
    const $21bf0ffffba0953e$export$1fda4850b6314ff0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
        path: '/plugins/servlet/ac/:addonKey/:moduleKey',
        query: (0, $0bf6b9f3f002a423$export$2fdb05fdbf78d595)
    };
    const $21bf0ffffba0953e$export$486ffffd0a2797a5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
        path: '/plugins/servlet/ac/:addonKey//:moduleKey',
        query: (0, $0bf6b9f3f002a423$export$2fdb05fdbf78d595)
    };
    const $21bf0ffffba0953e$export$e8a58aee75961b55 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
        path: '/plugins/servlet/ac/:addonKey/:moduleKey',
        query: [
            'project.key',
            'servicedesk.serviceDeskId'
        ]
    };
    const $21bf0ffffba0953e$export$27e7531864dfb704 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT),
        path: '/projects/:projectKey',
        query: (0, $e64562bb8c3fa371$export$9bb839aee83bf4d8)
    };
    const $21bf0ffffba0953e$export$148fcbe26061b2c9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
        path: '/jira/servicedesk/projects/:projectKey',
        query: (0, $e64562bb8c3fa371$export$9bb839aee83bf4d8),
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $49a774cbbfe614f4$export$c33275abe6c1e577 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iGYap"))), {
        moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
    });
    var $49a774cbbfe614f4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $49a774cbbfe614f4$export$c33275abe6c1e577,
            pageId: "connect",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $c9a4402f23043c3c$export$3dadc93ff144628f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dwmMO"))), {
        moduleId: "./src/packages/spa-apps/jira-connect/project-pages/src/index.tsx"
    });
    var $c9a4402f23043c3c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c9a4402f23043c3c$export$3dadc93ff144628f,
            pageId: "connect-projects",
            shouldShowSpinner: true
        });
    const $4d90b5804d47f5f4$export$4c06110e7d14ab3c = ()=>[
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("9UABi")).connectProjectResources)
        ];
    const $4d90b5804d47f5f4$export$42d81a9df7aca3f8 = {
        component: (0, $c9a4402f23043c3c$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
            sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
            (0, $c9a4402f23043c3c$export$3dadc93ff144628f)
        ],
        layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
        ufoName: 'jira-connect'
    };
    const $4d90b5804d47f5f4$var$getGeneralConnectRouteResources = ()=>[
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("hz6Yb")).connectGeneralResources),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
        ];
    const $4d90b5804d47f5f4$var$generalConnectRouteEntry = {
        layout: (0, (0, parcelRequire("1XrjK")).createLayout)(),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
            sidebar: (0, (0, parcelRequire("hBv66")).genericConnectSidebars)
        },
        component: (0, $49a774cbbfe614f4$export$2e2bcd8739ae039),
        resources: $4d90b5804d47f5f4$var$getGeneralConnectRouteResources(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
            (0, $49a774cbbfe614f4$export$c33275abe6c1e577)
        ],
        ufoName: 'jira-connect'
    };
    const $4d90b5804d47f5f4$var$connectGeneralServiceDeskProjectRouteQuery = [
        ...(0, $0bf6b9f3f002a423$export$2fdb05fdbf78d595),
        ...(0, $21bf0ffffba0953e$export$e8a58aee75961b55).query
    ];
    const $4d90b5804d47f5f4$export$b069a1c4b0240172 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)({
            ...(0, $21bf0ffffba0953e$export$e8a58aee75961b55),
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
            query: $4d90b5804d47f5f4$var$connectGeneralServiceDeskProjectRouteQuery
        }, ()=>({
                ...$4d90b5804d47f5f4$var$generalConnectRouteEntry,
                resources: [
                    ...$4d90b5804d47f5f4$var$getGeneralConnectRouteResources(),
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationSingleResources)()
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $21bf0ffffba0953e$export$1fda4850b6314ff0), ()=>({
                ...$4d90b5804d47f5f4$var$generalConnectRouteEntry
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $21bf0ffffba0953e$export$486ffffd0a2797a5), ()=>({
                ...$4d90b5804d47f5f4$var$generalConnectRouteEntry
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $21bf0ffffba0953e$export$27e7531864dfb704), ()=>({
                ...$4d90b5804d47f5f4$export$42d81a9df7aca3f8,
                resources: [
                    ...$4d90b5804d47f5f4$export$4c06110e7d14ab3c(),
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSharedNavigationSingleResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ]
            }))
    ];
    const $4d90b5804d47f5f4$export$72138a83eeba68eb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $21bf0ffffba0953e$export$148fcbe26061b2c9), ()=>({
            ...$4d90b5804d47f5f4$export$42d81a9df7aca3f8,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...$4d90b5804d47f5f4$export$4c06110e7d14ab3c(),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $gyYxw;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $35bf16777764b53a$export$5ce9108542315ac8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CREATE_PROJECT),
        path: '/jira/create-project',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $654ebb131c30ba2a$export$5c005d1ab6cfe623 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1OvmD")), {
        moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
    });
    const $654ebb131c30ba2a$export$43b852e2e1a047e8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $654ebb131c30ba2a$export$5c005d1ab6cfe623,
            pageId: "spa-apps/create-project",
            shouldShowSpinner: true
        });
    const $654ebb131c30ba2a$export$28887e2da22c839a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $35bf16777764b53a$export$5ce9108542315ac8), ()=>({
            component: $654ebb131c30ba2a$export$43b852e2e1a047e8,
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $654ebb131c30ba2a$export$5c005d1ab6cfe623
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $1XrjK;
    var $kxZPA;
    const $f2fce09c535c3a19$export$d4768112536c9dc9 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8o619")), {
        ssr: false,
        moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
    });
    const $79510dabdd765f30$export$4095842bb2e8d712 = (0, $f2fce09c535c3a19$export$d4768112536c9dc9);
    $79510dabdd765f30$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';
    const $90a067693c09e346$export$f0a12e66953aa38a = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            (0, $79510dabdd765f30$export$4095842bb2e8d712)
        ]
    });
    var $e2ctp;
    var $2BrOV;
    var $ibkIl;
    var $co1wz;
    var $7XYc4;
    var $1XrjK;
    var $kxZPA;
    const $d1122e3218429f7d$export$cb38f5a820347580 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("3d3Of")).then((module)=>module.TransitionHomeRenderer), {
        ssr: false,
        moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
    }), ()=>null);
    $d1122e3218429f7d$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';
    const $d1122e3218429f7d$export$9cda67d6c86d7b98 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9lbpO")).then((module)=>module.WelcomeModalRenderer), {
        ssr: false,
        moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
    }), ()=>null);
    $d1122e3218429f7d$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';
    const $d1122e3218429f7d$export$b8fa7ac7019001bb = (0, (0, parcelRequire("1XrjK")).createLayout)({
        get globalComponents () {
            return [
                $d1122e3218429f7d$export$cb38f5a820347580,
                $d1122e3218429f7d$export$9cda67d6c86d7b98
            ];
        }
    });
    var $2BrOV;
    var $1XrjK;
    const $226ab3e64821f6b2$export$5b7fb151d60504c = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), {
        globalComponents: [
            (0, $d1122e3218429f7d$export$cb38f5a820347580),
            (0, $d1122e3218429f7d$export$9cda67d6c86d7b98)
        ]
    });
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $1XrjK;
    var $gh1hi;
    var $3RJkv;
    var $atU1t;
    var $2Ql51;
    var $94QFg;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $6jY6G;
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    const $55d04275d2bcfadf$export$da833ddcffcc38ba = ()=>{
        const [{ query: query, location: { hash: hash } }] = (0, $dIdda.useRouter)();
        const { path: path } = (0, (0, parcelRequire("6jY6G")).useRouteByName)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW)) ?? {};
        if (path == null) throw new Error('Dashboard view route not found');
        const { selectPageId: id } = query;
        const idParam = /^\d+$/.test(id) ? id : 'last-visited';
        const generatedPath = (0, $dIdda.generatePath)(path, {
            dashboardId: idParam
        });
        const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
        const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: pathWithQuery,
            persistSearchParams: false
        });
    };
    const $cf8020dd6e5d22c9$var$dashboardResources = [
        (0, (0, parcelRequire("gh1hi")).dashboardConfigAndWRMResource),
        (0, (0, parcelRequire("gh1hi")).dashboardAMDModulesResource),
        (0, (0, parcelRequire("gh1hi")).dashboardReactGadgetsResource),
        (0, (0, parcelRequire("gh1hi")).dashboardForgeResource)
    ];
    const $cf8020dd6e5d22c9$var$LazyDashboardView = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5lVAv"))), {
        moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$var$LazyDashboardViewEmbed = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dtemB"))), {
        moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$var$LazyDashboardWallboard = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2yGxE"))), {
        moduleId: "./src/packages/global-pages/dashboard/wallboard/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$var$LazyDashboardEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ixqoJ"))), {
        moduleId: "./src/packages/global-pages/dashboard/edit/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$export$c8d59d34c3e8f345 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("atP20"))), {
        moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$export$8d692f4ffba40a2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$var$LazyDashboardView,
            pageId: "dashboard",
            shouldShowSpinner: false
        });
    const $cf8020dd6e5d22c9$export$86d9f777f9d4e312 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$var$LazyDashboardViewEmbed,
            pageId: "dashboard",
            shouldShowSpinner: true
        });
    const $cf8020dd6e5d22c9$export$419b9eec5ed9880d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$var$LazyDashboardWallboard,
            pageId: "dashboard",
            shouldShowSpinner: true
        });
    const $cf8020dd6e5d22c9$export$fb2c0a1de056b738 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$var$LazyDashboardEdit,
            pageId: "dashboard",
            shouldShowSpinner: false
        });
    const $cf8020dd6e5d22c9$export$dcd19a888f8c85c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$export$c8d59d34c3e8f345,
            pageId: "system-dashboard-edit",
            shouldShowSpinner: false
        });
    const $cf8020dd6e5d22c9$export$9fbbaafb58999ac3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardRoute), ()=>({
            component: (0, $55d04275d2bcfadf$export$da833ddcffcc38ba),
            layout: (0, $226ab3e64821f6b2$export$5b7fb151d60504c),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$var$LazyDashboardView
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            isRedirect: true,
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$ac09a8d3ecbafc5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).selectedDashboardRoute), ()=>({
            component: (0, $55d04275d2bcfadf$export$da833ddcffcc38ba),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$var$LazyDashboardView
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            isRedirect: true,
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$9b0fdfd6a51a17de = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardEditRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$fb2c0a1de056b738,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $90a067693c09e346$export$f0a12e66953aa38a)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$cf8020dd6e5d22c9$var$dashboardResources,
                (0, (0, parcelRequire("gh1hi")).gadgetDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$var$LazyDashboardEdit
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$6009dd8e88f1a7de = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardWallboardRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$419b9eec5ed9880d,
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                globalComponents: [
                    (0, $79510dabdd765f30$export$4095842bb2e8d712)
                ],
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                $cf8020dd6e5d22c9$var$LazyDashboardWallboard
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$18226b6422149926 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardViewRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$8d692f4ffba40a2,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $90a067693c09e346$export$f0a12e66953aa38a)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$var$LazyDashboardView
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY),
            ufoName: 'dashboard'
        }));
    const $cf8020dd6e5d22c9$export$73a377380ff671af = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardViewEmbedRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$86d9f777f9d4e312,
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                globalComponents: [
                    (0, $79510dabdd765f30$export$4095842bb2e8d712)
                ],
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                $cf8020dd6e5d22c9$var$LazyDashboardViewEmbed
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$15f76f1b0d2d671 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).systemDashboardEditRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$dcd19a888f8c85c,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("ibkIl")).globalSettingsLayout), (0, $90a067693c09e346$export$f0a12e66953aa38a)),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...$cf8020dd6e5d22c9$var$dashboardResources,
                (0, (0, parcelRequire("gh1hi")).gadgetDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$export$c8d59d34c3e8f345
            ],
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    var $ffza4;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $778b5363f1896dba$export$91257312631802bc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DEVOPS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT),
        path: '/jira/devops/connected-project'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $31d281e7968db385$export$dcd3d20b0038b35c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3cUWj"))), {
        moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
    });
    var $31d281e7968db385$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $31d281e7968db385$export$dcd3d20b0038b35c,
            pageId: "devops-connected-project",
            shouldShowSpinner: true
        });
    const $1b01c2efc4945821$export$ae258fb8ec2c1f86 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $778b5363f1896dba$export$91257312631802bc), ()=>({
            ufoName: 'devops.connected-project',
            component: (0, $31d281e7968db385$export$2e2bcd8739ae039),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $31d281e7968db385$export$dcd3d20b0038b35c)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $bPjHb;
    var $3RJkv;
    var $4s7hB;
    var $7OYJs;
    var $3iOSp;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $63ac430661b12a63$var$BoardsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/boards"
        });
    const $63ac430661b12a63$var$LazyBoardsDirectory = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1Xk9t"))), {
        moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
    });
    const $63ac430661b12a63$export$3184a385d45edd0d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $63ac430661b12a63$var$LazyBoardsDirectory,
            pageId: "boards-directory",
            shouldShowSpinner: false
        });
    const $63ac430661b12a63$export$e78b34c999194638 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4s7hB")).boardsDirectoryRoute), ()=>({
            component: $63ac430661b12a63$export$3184a385d45edd0d,
            skeleton: (0, (0, parcelRequire("3iOSp")).BoardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bPjHb")).boardsDirectoryResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $63ac430661b12a63$var$LazyBoardsDirectory
            ]
        }));
    const $63ac430661b12a63$export$2a34d21ecf479c40 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4s7hB")).boardsDirectoryRedirectRoute), ()=>({
            component: $63ac430661b12a63$var$BoardsDirectoryRedirect,
            skeleton: (0, (0, parcelRequire("3iOSp")).BoardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bPjHb")).boardsDirectoryResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $63ac430661b12a63$var$LazyBoardsDirectory
            ],
            isRedirect: true
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $4yCf0;
    var $3RJkv;
    var $3zTeb;
    var $7OYJs;
    var $3iOSp;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cd7e3d13d091ccad$var$DashboardsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/dashboards"
        });
    const $cd7e3d13d091ccad$var$LazyDashboardsDirectory = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bEh2s"))), {
        moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
    });
    const $cd7e3d13d091ccad$export$1cc6cc01050e1215 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cd7e3d13d091ccad$var$LazyDashboardsDirectory,
            pageId: "dashboards-directory",
            shouldShowSpinner: false
        });
    const $cd7e3d13d091ccad$export$748e329bd0c282a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3zTeb")).dashboardsDirectoryRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("4yCf0")).dashboardsDirectoryResource)
            ],
            component: $cd7e3d13d091ccad$export$1cc6cc01050e1215,
            skeleton: (0, (0, parcelRequire("3iOSp")).DashboardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cd7e3d13d091ccad$var$LazyDashboardsDirectory
            ]
        }));
    const $cd7e3d13d091ccad$export$8dae8091f8e43b97 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3zTeb")).dashboardsDirectoryRedirectRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("4yCf0")).dashboardsDirectoryResource)
            ],
            component: !false ? $cd7e3d13d091ccad$var$DashboardsDirectoryRedirect : $cd7e3d13d091ccad$export$1cc6cc01050e1215,
            skeleton: (0, (0, parcelRequire("3iOSp")).DashboardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cd7e3d13d091ccad$var$LazyDashboardsDirectory
            ],
            isRedirect: true
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $dRl24;
    var $3RJkv;
    var $13DBR;
    var $7OYJs;
    var $3iOSp;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $37b0d6d8034450f5$export$c56e739d3bb1fe19 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/filters"
        });
    const $37b0d6d8034450f5$var$LazyFiltersDirectory = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4D5lh"))), {
        moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
    });
    const $37b0d6d8034450f5$export$e5d735e83dacb7c7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $37b0d6d8034450f5$var$LazyFiltersDirectory,
            pageId: "filters-directory",
            shouldShowSpinner: false
        });
    const $37b0d6d8034450f5$export$ca77bc660994f51f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("13DBR")).filtersDirectoryRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: $37b0d6d8034450f5$export$e5d735e83dacb7c7,
            skeleton: (0, (0, parcelRequire("3iOSp")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $37b0d6d8034450f5$var$LazyFiltersDirectory
            ]
        }));
    const $37b0d6d8034450f5$export$41fb3f2a3e68c7c3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("13DBR")).filtersDirectoryRedirectRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: !false ? $37b0d6d8034450f5$export$c56e739d3bb1fe19 : $37b0d6d8034450f5$export$e5d735e83dacb7c7,
            skeleton: (0, (0, parcelRequire("3iOSp")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $37b0d6d8034450f5$var$LazyFiltersDirectory
            ],
            isRedirect: true
        }));
    const $37b0d6d8034450f5$export$c2ec350ee9e78717 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("13DBR")).secureFiltersDirectoryRedirectRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: !false ? $37b0d6d8034450f5$export$c56e739d3bb1fe19 : $37b0d6d8034450f5$export$e5d735e83dacb7c7,
            skeleton: (0, (0, parcelRequire("3iOSp")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $37b0d6d8034450f5$var$LazyFiltersDirectory
            ],
            isRedirect: true
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $4TyVn;
    var $3iOSp;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9a93b77d562e7847$var$LazyPlansDirectory = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lBR19"))), {
        moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
    });
    const $9a93b77d562e7847$export$8f357abd0af482a2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9a93b77d562e7847$var$LazyPlansDirectory,
            pageId: "plans-directory",
            shouldShowSpinner: false
        });
    const $9a93b77d562e7847$export$4f9df77811fbdc1f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4TyVn")).plansDirectoryRoute), ()=>({
            component: $9a93b77d562e7847$export$8f357abd0af482a2,
            skeleton: (0, (0, parcelRequire("3iOSp")).PlansDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9a93b77d562e7847$var$LazyPlansDirectory
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $4R6GH;
    var $ibkIl;
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $hsmeR;
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $gwZ1O;
    var $koeKL;
    const $7f8ad29d8f27e2c5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "d53e974e431db3cd183eaaccc995cde2da6295abb2ca1d5c4510995a129bb82a",
            "metadata": {},
            "name": "ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $7f8ad29d8f27e2c5$export$2e2bcd8739ae039 = $7f8ad29d8f27e2c5$var$node;
    var $eufEc;
    var $fEDBv;
    const $b89f927130994d16$export$a9552895baaa7b3b = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("aOBfa")), {
            moduleId: "6a9110b2"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    templatesQueryRef: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: $7f8ad29d8f27e2c5$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
    const $2ea0e66ac4184052$var$runtimeProps = {};
    const $2ea0e66ac4184052$export$7ef72c7d51d7de1e = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, $b89f927130994d16$export$a9552895baaa7b3b), {
            cloudId: cloudId
        });
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "right-side-panel",
            packageName: "jiraGrowthRecommendationsInProjectList",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $2ea0e66ac4184052$var$runtimeProps,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gwZ1O")).ProjectListSidebarSkeleton), null)
        });
    };
    var $2ea0e66ac4184052$export$2e2bcd8739ae039 = $2ea0e66ac4184052$export$7ef72c7d51d7de1e;
    var $7Hq8b;
    const $d823a751937e7046$var$JiraProjectsTemplateListRightPanel = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const { closeRightSidebar: closeRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(undefined);
        const panelId = rightSidebarCurrentState?.panelId;
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, (0, parcelRequire("7Hq8b")).PANEL_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                closeRightSidebar((0, (0, parcelRequire("7Hq8b")).PANEL_ID));
            }, [
            closeRightSidebar
        ]);
        if (localPanelId !== (0, (0, parcelRequire("7Hq8b")).PANEL_ID)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2ea0e66ac4184052$export$7ef72c7d51d7de1e), null);
    };
    const $d823a751937e7046$export$521a9a721c9dad20 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-layout-component",
            packageName: "jiraGrowthRecommendationsInProjectList"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d823a751937e7046$var$JiraProjectsTemplateListRightPanel, null));
    const $c970ed461b0f69e3$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b229b054ed73f6325d6caffd55b233a3c29d86aac2d49a1351ee057ca0f53039",
            "metadata": {},
            "name": "ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $c970ed461b0f69e3$export$2e2bcd8739ae039 = $c970ed461b0f69e3$var$node;
    var $eufEc;
    var $fEDBv;
    const $3e90ecc71eaea66f$export$4707e15fd1e8e43a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("02QCV")), {
            moduleId: "795c4be8"
        }),
        getPreloadProps: ({ tenantContext: tenantContext })=>({
                queries: {
                    templatesQueryRef: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: $c970ed461b0f69e3$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            isAnonymous: tenantContext.isAnonymous
                        }
                    }
                }
            })
    });
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $atU1t;
    var $hW253;
    var $1xIol;
    var $7OYJs;
    var $3iOSp;
    var $4R6GH;
    var $dXq4S;
    const $a2863fb0305ba6a4$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "c5bf480cfcc7e1667e0f3ca7923ae0e7fb82b6dc49abd4df64797411cc629cfd",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $a2863fb0305ba6a4$export$2e2bcd8739ae039 = $a2863fb0305ba6a4$var$node;
    var $eIMrK;
    var $ce6VA;
    var $iyWSs;
    const $ca4f44207dc12143$var$cache = (0, (0, parcelRequire("eIMrK")).createCache)(new Map());
    function $ca4f44207dc12143$export$58f934f3d33a84b6(loader, opts) {
        return $ca4f44207dc12143$var$cache.get(opts.moduleId, ()=>(0, (0, parcelRequire("ce6VA")).PreloadableJSResource)(()=>(0, (0, parcelRequire("iyWSs")).postTask)(loader, {
                    priority: 'user-blocking'
                }), opts));
    }
    var $fEDBv;
    const $94d9041756c0d8ee$var$DEFAULT_LIMIT = 25;
    const $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
    const $94d9041756c0d8ee$var$DefaultFilterFields = {
        SortOrder: 'sortOrder',
        SortKey: 'sortKey',
        Page: 'page'
    };
    var $94d9041756c0d8ee$var$TableColumns;
    (function(TableColumns) {
        TableColumns["Favourites"] = "favourites";
        TableColumns["Key"] = "key";
        TableColumns["Name"] = "name";
        TableColumns["Type"] = "type";
        TableColumns["Lead"] = "lead";
        TableColumns["Category"] = "category";
        TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
        TableColumns["Url"] = "url";
        TableColumns["Action"] = "actions";
    })($94d9041756c0d8ee$var$TableColumns || ($94d9041756c0d8ee$var$TableColumns = {}));
    const $94d9041756c0d8ee$var$SortableColumns = [
        "key",
        "name",
        "lead",
        "category",
        "last_issue_updated_time"
    ];
    const $94d9041756c0d8ee$var$FilterFields = {
        Keyword: 'keyword',
        ProjectType: 'types',
        ProjectCategoryId: 'projectCategoryId',
        ...$94d9041756c0d8ee$var$DefaultFilterFields
    };
    const $94d9041756c0d8ee$var$filterAliasMap = {
        contains: $94d9041756c0d8ee$var$FilterFields.Keyword,
        selectedProjectType: $94d9041756c0d8ee$var$FilterFields.ProjectType,
        selectedCategory: $94d9041756c0d8ee$var$FilterFields.ProjectCategoryId
    };
    const $94d9041756c0d8ee$var$filterInitialState = {
        [$94d9041756c0d8ee$var$FilterFields.Keyword]: '',
        [$94d9041756c0d8ee$var$FilterFields.ProjectType]: '',
        [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: '',
        [$94d9041756c0d8ee$var$FilterFields.SortOrder]: 'ASC',
        [$94d9041756c0d8ee$var$FilterFields.SortKey]: "name",
        [$94d9041756c0d8ee$var$FilterFields.Page]: '1'
    };
    const $94d9041756c0d8ee$var$LEGACY_ALL_VALUE = 'all';
    const $94d9041756c0d8ee$var$sanitizeLegacyQuery = (query = {})=>({
            ...query,
            selectedProjectType: query.selectedProjectType === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectType] : query.selectedProjectType,
            selectedCategory: query.selectedCategory === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId] : query.selectedCategory
        });
    const $94d9041756c0d8ee$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
            const alias = aliases[key];
            const queryValue = query[key];
            const hasInitialValue = filter[key] !== undefined;
            if (hasInitialValue && queryValue) {
                filter[key] = queryValue;
                return filter;
            }
            if (!alias || !queryValue) return filter;
            filter[alias] = queryValue;
            return filter;
        }, {
            ...filterState
        });
    const $94d9041756c0d8ee$var$CORE_PROJECT = 'business';
    const $94d9041756c0d8ee$var$SOFTWARE_PROJECT = 'software';
    const $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT = 'service_desk';
    const $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
    const $94d9041756c0d8ee$var$PROJECT_TYPES = [
        $94d9041756c0d8ee$var$CORE_PROJECT,
        $94d9041756c0d8ee$var$SOFTWARE_PROJECT,
        $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT,
        $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT
    ];
    const $94d9041756c0d8ee$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
        const variables = {};
        const { [$94d9041756c0d8ee$var$FilterFields.Keyword]: keyword, [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$94d9041756c0d8ee$var$FilterFields.ProjectType]: types, [$94d9041756c0d8ee$var$FilterFields.SortOrder]: sortOrder, [$94d9041756c0d8ee$var$FilterFields.SortKey]: sortKey } = aliases && query ? $94d9041756c0d8ee$var$matchAliases(filter, query, aliases) : filter;
        if (keyword) variables.keyword = keyword;
        if (projectCategoryId) variables.projectCategoryId = (0, (0, parcelRequire("dXq4S")).isAri)(projectCategoryId) ? projectCategoryId : (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
        if (sortKey || sortOrder) {
            const sortByValue = sortKey && $94d9041756c0d8ee$var$SortableColumns.includes(sortKey) ? sortKey : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortKey];
            variables.sortBy = {
                order: [
                    'ASC',
                    'DESC'
                ].includes(sortOrder) ? sortOrder : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortOrder],
                sortBy: sortByValue.toUpperCase()
            };
        }
        if (types && typeof types === 'string') variables.types = types.split(',').filter((type)=>$94d9041756c0d8ee$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
        return variables;
    };
    const $94d9041756c0d8ee$export$80225215a10b2688 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, $ca4f44207dc12143$export$58f934f3d33a84b6)(()=>(parcelRequire("4nnZF")), {
            moduleId: "b77224b3"
        }),
        getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
            const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
            const extraProps = {
                isAdminProjectDirectoryRoute: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE
            };
            if (false && isAnonymous) return {
                extraProps: extraProps
            };
            return {
                queries: {
                    projectsDirectoryPage: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, $a2863fb0305ba6a4$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            filter: $94d9041756c0d8ee$var$mapQueryToFilter($94d9041756c0d8ee$var$filterInitialState, {
                                cloudId: cloudId,
                                query: $94d9041756c0d8ee$var$sanitizeLegacyQuery(query),
                                aliases: $94d9041756c0d8ee$var$filterAliasMap
                            }),
                            first: query?.page ? $94d9041756c0d8ee$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                            last: $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                            isAdminSettingsContext: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE,
                            isAnonymous: isAnonymous,
                            skipShouldShowRightSidebar: isAnonymous || (0, (0, parcelRequire("4R6GH")).fg)('server_render_projects_directory_sidebar'),
                            isImporterDiscoveryExperimentEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_importer_projects_directory_cta_gate')
                        }
                    }
                },
                extraProps: extraProps
            };
        }
    });
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $07a2f1e51a24c4ff$export$b68dd6112a931c10 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/projects"
        });
    const $07a2f1e51a24c4ff$export$74316a0a4963952b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/projects/manage"
        });
    const $07a2f1e51a24c4ff$var$LazyProjectsDirectory = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3C1eN"))), {
        moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
    });
    const $07a2f1e51a24c4ff$var$LazyAdminProjectsDirectory = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($07a2f1e51a24c4ff$var$LazyProjectsDirectory, {
            isAdminProjectDirectoryRoute: true
        });
    const $07a2f1e51a24c4ff$export$ba9ef00f25a4745e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $07a2f1e51a24c4ff$var$LazyAdminProjectsDirectory,
            pageId: "projects-directory-manage-v3",
            shouldShowSpinner: false
        });
    const $07a2f1e51a24c4ff$var$rightSidebars = ()=>{
        if (false) return [];
        return (0, (0, parcelRequire("4R6GH")).fg)('server_render_projects_directory_sidebar') ? [] : [
            (0, $d823a751937e7046$export$521a9a721c9dad20)
        ];
    };
    const $07a2f1e51a24c4ff$var$projectsDirectoryHomepageLayout = ()=>(0, (0, parcelRequire("1XrjK")).composeLayouts)((0, $226ab3e64821f6b2$export$5b7fb151d60504c), {
            rightSidebars: $07a2f1e51a24c4ff$var$rightSidebars()
        });
    const $07a2f1e51a24c4ff$var$projectsDirectorySettingsLayout = ()=>(0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("ibkIl")).globalSettingsLayout), {
            rightSidebars: $07a2f1e51a24c4ff$var$rightSidebars()
        });
    const $07a2f1e51a24c4ff$var$ffOffProjectsDirectoryPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $94d9041756c0d8ee$export$80225215a10b2688),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
        rightSidebar: undefined
    });
    const $07a2f1e51a24c4ff$var$ffOnProjectsDirectoryPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $94d9041756c0d8ee$export$80225215a10b2688),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
        rightSidebar: (0, $3e90ecc71eaea66f$export$4707e15fd1e8e43a)
    });
    const $07a2f1e51a24c4ff$export$79292a834772288c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryRoute), ()=>({
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('server_render_projects_directory_sidebar') ? $07a2f1e51a24c4ff$var$ffOnProjectsDirectoryPageEntryPoint : $07a2f1e51a24c4ff$var$ffOffProjectsDirectoryPageEntryPoint;
            },
            skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
            layout: $07a2f1e51a24c4ff$var$projectsDirectoryHomepageLayout(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            ufoName: 'projects-directory-v3'
        }));
    const $07a2f1e51a24c4ff$var$adminProjectDirectoryResources = [
        (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
        (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
    ];
    const $07a2f1e51a24c4ff$export$d5b1a46987369ee4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).manageProjectsDirectoryRoute), ()=>({
            component: $07a2f1e51a24c4ff$export$ba9ef00f25a4745e,
            skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
            layout: $07a2f1e51a24c4ff$var$projectsDirectorySettingsLayout(),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$07a2f1e51a24c4ff$var$adminProjectDirectoryResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $07a2f1e51a24c4ff$var$LazyProjectsDirectory
            ],
            ufoName: 'projects-directory-v3-manage',
            entryPoint () {
                if ((0, (0, parcelRequire("4R6GH")).fg)('manage_projects_directory_entrypoint_adoption')) return (0, (0, parcelRequire("4R6GH")).fg)('server_render_projects_directory_sidebar') ? $07a2f1e51a24c4ff$var$ffOnProjectsDirectoryPageEntryPoint : $07a2f1e51a24c4ff$var$ffOffProjectsDirectoryPageEntryPoint;
                return undefined;
            }
        }));
    const $07a2f1e51a24c4ff$export$445f7414e382a69c = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryRedirectRoute), ()=>({
                component: $07a2f1e51a24c4ff$export$b68dd6112a931c10,
                skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
                isRedirect: true,
                layout: $07a2f1e51a24c4ff$var$projectsDirectoryHomepageLayout(),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $07a2f1e51a24c4ff$var$LazyProjectsDirectory
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryLegacyPathRedirectRoute), ()=>({
                component: $07a2f1e51a24c4ff$export$b68dd6112a931c10,
                skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
                isRedirect: true,
                layout: $07a2f1e51a24c4ff$var$projectsDirectoryHomepageLayout(),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $07a2f1e51a24c4ff$var$LazyProjectsDirectory
                ]
            })),
        $07a2f1e51a24c4ff$export$79292a834772288c,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryManageRedirectRoute), ()=>({
                component: $07a2f1e51a24c4ff$export$74316a0a4963952b,
                skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
                isRedirect: true,
                layout: $07a2f1e51a24c4ff$var$projectsDirectorySettingsLayout(),
                navigation: {
                    sidebar: (0, (0, parcelRequire("4jMkc")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...$07a2f1e51a24c4ff$var$adminProjectDirectoryResources
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $07a2f1e51a24c4ff$var$LazyProjectsDirectory
                ]
            })),
        $07a2f1e51a24c4ff$export$d5b1a46987369ee4,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryManageRootRedirectRoute), ()=>({
                component: $07a2f1e51a24c4ff$export$74316a0a4963952b,
                skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
                isRedirect: true,
                layout: $07a2f1e51a24c4ff$var$projectsDirectorySettingsLayout(),
                navigation: {
                    sidebar: (0, (0, parcelRequire("4jMkc")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...$07a2f1e51a24c4ff$var$adminProjectDirectoryResources
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $07a2f1e51a24c4ff$var$LazyProjectsDirectory
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $6YWw1;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $d15151561c6a9349$export$a1b7c53ff39475a6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("gR2RM")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
    });
    const $d15151561c6a9349$var$TeamDashboardSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "eocTeamDashboard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d15151561c6a9349$export$a1b7c53ff39475a6, null));
    $d15151561c6a9349$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
    var $d15151561c6a9349$export$2e2bcd8739ae039 = $d15151561c6a9349$var$TeamDashboardSidebar;
    var $2Fj5v;
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $cd33ec0afa28f27a$export$aea682543f08e131 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hbBAJ")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations-configuration/src/ui/index.tsx"
    });
    const $cd33ec0afa28f27a$export$1f7a0efe3746ea0d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-operations-configurations-horizontal-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsConfigurationNav",
            packageName: "jiraOperationsConfigurationsHorizontalNav",
            fallback: "flag",
            teamName: "50cent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cd33ec0afa28f27a$export$aea682543f08e131, null)));
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $7836a14152b01d88$export$409c821653bbc63b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("atcAs")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations/src/ui/index.tsx"
    });
    const $7836a14152b01d88$export$82108adf6887e32e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("atcAs")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations/src/ui/index.tsx"
    });
    const $7836a14152b01d88$export$1eb785f071697cc5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsNav",
            packageName: "jiraOperationsHorizontalNav",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7836a14152b01d88$export$409c821653bbc63b, null)));
    const $7836a14152b01d88$export$27e50c09ebb514f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-overview-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsOverviewNav",
            packageName: "jiraOperationsHorizontalNav",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7836a14152b01d88$export$82108adf6887e32e, null)));
    var $1XrjK;
    var $kxZPA;
    const $687f5bad65d17575$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("cQXYd")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
    });
    const $687f5bad65d17575$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8cAy7")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
    });
    const $687f5bad65d17575$export$53dd27149810df73 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        get globalComponents () {
            return [
                $687f5bad65d17575$var$Onboarding
            ];
        },
        rightSidebars: [
            $687f5bad65d17575$var$RightSidebars
        ]
    });
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $afc98a59d9baec1c$export$73d6a0dc298aae15 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING),
        path: '/jira/settings/products/ops/syncs',
        exact: true
    };
    const $afc98a59d9baec1c$export$f271eef5f9ec6602 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE),
        path: '/jira/settings/products/ops/syncs/create',
        exact: true
    };
    const $afc98a59d9baec1c$export$f1b4093ef603b98d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL),
        path: '/jira/settings/products/ops/syncs/:syncId',
        exact: true
    };
    const $afc98a59d9baec1c$export$37ea7624561cbb89 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
        path: '/jira/ops/teams/:teamId/syncs',
        exact: true
    };
    const $afc98a59d9baec1c$export$915ef1948fe4650a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
        path: '/jira/ops/teams/:teamId/syncs/create',
        exact: true
    };
    const $afc98a59d9baec1c$export$e91535fc2137c3b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
        path: '/jira/ops/teams/:teamId/syncs/:syncId',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $9e8891c31cf06876$export$dbbcce89c7be1e71 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("agiQP")).then((module)=>module.AlertIssueSync), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
    const $9e8891c31cf06876$export$ff3e9ed7471eebce = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("agiQP")).then((module)=>module.AlertIssueSyncCreate), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
    const $9e8891c31cf06876$export$75137a2a583918e2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("agiQP")).then((module)=>module.AlertIssueSyncDetail), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
    const $7962a3c589e492de$export$5a4922ba79d730f4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $9e8891c31cf06876$export$dbbcce89c7be1e71),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    const $7962a3c589e492de$export$c21f2a7e1aa801a7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $9e8891c31cf06876$export$75137a2a583918e2),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    const $7962a3c589e492de$export$a26f24c49385cf3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $9e8891c31cf06876$export$ff3e9ed7471eebce),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    const $7962a3c589e492de$export$c63d0942ec0f93c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $afc98a59d9baec1c$export$73d6a0dc298aae15), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            slot: null,
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71)
            ]
        }));
    const $7962a3c589e492de$export$7e604b22ae6e7c1e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $afc98a59d9baec1c$export$f1b4093ef603b98d), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            slot: $7962a3c589e492de$export$c21f2a7e1aa801a7,
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71)
            ]
        }));
    const $7962a3c589e492de$export$92f4b6644eb6cb88 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $afc98a59d9baec1c$export$f271eef5f9ec6602), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            slot: $7962a3c589e492de$export$a26f24c49385cf3a,
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71)
            ]
        }));
    const $7962a3c589e492de$export$be342a3401146aae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $afc98a59d9baec1c$export$37ea7624561cbb89), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: null,
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $7962a3c589e492de$export$6298ff494c460e75 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $afc98a59d9baec1c$export$e91535fc2137c3b), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: $7962a3c589e492de$export$c21f2a7e1aa801a7,
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $7962a3c589e492de$export$8c07dc381591dc69 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $afc98a59d9baec1c$export$915ef1948fe4650a), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: $7962a3c589e492de$export$a26f24c49385cf3a,
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource,
                (0, (0, parcelRequire("6YWw1")).resources).getTeamResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $7962a3c589e492de$export$cf5b5978205b681 = [
        $7962a3c589e492de$export$be342a3401146aae,
        $7962a3c589e492de$export$8c07dc381591dc69,
        $7962a3c589e492de$export$6298ff494c460e75,
        $7962a3c589e492de$export$c63d0942ec0f93c,
        $7962a3c589e492de$export$92f4b6644eb6cb88,
        $7962a3c589e492de$export$7e604b22ae6e7c1e
    ];
    var $2T8SP;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $16f73de73692c402$export$84985159d5695f4d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_API_KEY_MANAGEMENT),
        path: '/jira/settings/products/ops/api-key-management',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $eddc6a8c98318a70$export$6ae4b26c31b1b0d2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ck880")), {
        moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
    });
    var $eddc6a8c98318a70$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $eddc6a8c98318a70$export$6ae4b26c31b1b0d2,
            pageId: "async-jira-eoc-api-key-management",
            shouldShowSpinner: false
        });
    const $d20ff3bf1728b112$export$e18a6be3d2ffad71 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $16f73de73692c402$export$84985159d5695f4d), ()=>({
            component: (0, $eddc6a8c98318a70$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("2T8SP")).resources)
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $eddc6a8c98318a70$export$6ae4b26c31b1b0d2)
            ]
        }));
    var $jqlWU;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $c2ffe74049ce966a$export$79c37191a61ac94b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES),
        path: '/jira/settings/products/ops/role-assignment',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $cbc95c821be59e53$export$fb6bafef9453a357 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("79kmP")), {
        moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
    });
    var $cbc95c821be59e53$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cbc95c821be59e53$export$fb6bafef9453a357,
            pageId: "async-eoc-assign-custom-roles",
            shouldShowSpinner: false
        });
    const $47346306c864179d$export$c51a4ee3e3f1b270 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c2ffe74049ce966a$export$79c37191a61ac94b), ()=>({
            component: (0, $cbc95c821be59e53$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("jqlWU")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cbc95c821be59e53$export$fb6bafef9453a357)
            ]
        }));
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $90433e9189dc0c80$export$4a84eb4d8d37c9d4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS),
        path: '/jira/ops/teams/:teamId/automations',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $1cf116b0539aa5be$export$903a0a44cc0933c5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("d6ThE")), {
        moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
    });
    var $1cf116b0539aa5be$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1cf116b0539aa5be$export$903a0a44cc0933c5,
            pageId: "ops-team-automation",
            shouldShowSpinner: true
        });
    const $9b4c7f67acf4fe32$export$6ff606556e19e12 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $90433e9189dc0c80$export$4a84eb4d8d37c9d4), ()=>({
            component: (0, $1cf116b0539aa5be$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1cf116b0539aa5be$export$903a0a44cc0933c5),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $7ygGB;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $7ef1808f7f01133d$export$3213a7325ca9911 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_CUSTOM_ROLES),
        path: '/jira/settings/products/ops/roles',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ae4b2d4dc59e70bc$export$78ed54710f55f948 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7yJdu")), {
        moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
    });
    var $ae4b2d4dc59e70bc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ae4b2d4dc59e70bc$export$78ed54710f55f948,
            pageId: "async-eoc-custom-roles",
            shouldShowSpinner: false
        });
    const $1513c92d12ac2a7f$export$9c9bab95d425eb6f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7ef1808f7f01133d$export$3213a7325ca9911), ()=>({
            component: (0, $ae4b2d4dc59e70bc$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("7ygGB")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ae4b2d4dc59e70bc$export$78ed54710f55f948)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $en1L8;
    var $jxRF2;
    var $6hGfG;
    var $gQ8M0;
    var $oacWJ;
    var $dqLIo;
    const $400eb496bca9e6a6$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("dqLIo")).uiPreferencesResource),
        (0, (0, parcelRequire("oacWJ")).savedSearchesResource),
        (0, (0, parcelRequire("gQ8M0")).compressionRatioResource),
        (0, (0, parcelRequire("6hGfG")).alertGroupingStateResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
    var $ffza4;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $kxZPA;
    const $423d186a1838bb07$export$674fd99c08c90491 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("E6d9p")).then((bundle)=>bundle), {
        moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
    });
    const $423d186a1838bb07$export$a1c034c1031e8711 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "eocGlobalAlerts"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($423d186a1838bb07$export$674fd99c08c90491, null));
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5CJ70;
    var $5j7Th;
    var $kxZPA;
    const $384a0ea22f315084$export$f4aafff31d950b6c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("d8hKi")), {
        moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
    });
    const $384a0ea22f315084$export$9333bfa567c9c31 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $384a0ea22f315084$export$f4aafff31d950b6c,
            pageId: "async-jira-eoc-alert-list",
            shouldShowSpinner: false
        });
    const $384a0ea22f315084$export$851a659e50436cff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5CJ70")).eocGlobalAlertListRoute), ()=>({
            component: $384a0ea22f315084$export$9333bfa567c9c31,
            layout: (0, $d1122e3218429f7d$export$b8fa7ac7019001bb),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, $423d186a1838bb07$export$a1c034c1031e8711)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $384a0ea22f315084$export$f4aafff31d950b6c,
                (0, $423d186a1838bb07$export$674fd99c08c90491)
            ]
        }));
    const $384a0ea22f315084$export$bcb93d8198d511b9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5CJ70")).eocGlobalAlertDetailRoute), ()=>({
            component: $384a0ea22f315084$export$9333bfa567c9c31,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7),
                ...(0, (0, parcelRequire("en1L8")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, $423d186a1838bb07$export$a1c034c1031e8711)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $384a0ea22f315084$export$f4aafff31d950b6c,
                (0, $423d186a1838bb07$export$674fd99c08c90491)
            ]
        }));
    const $384a0ea22f315084$export$283761ff41b53cba = [
        $384a0ea22f315084$export$851a659e50436cff,
        $384a0ea22f315084$export$bcb93d8198d511b9
    ];
    var $eYyoJ;
    var $2r8fH;
    var $ffza4;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $61dbc99cfecef4f3$export$e6569aff8dfd4c1d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
        path: '/jira/ops/group-detail/:id',
        exact: true
    };
    const $61dbc99cfecef4f3$export$aa8cf61e94739f21 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
        path: '/jira/ops/teams/:teamId/group-detail/:id',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $009be0886fa71d74$export$8d4b3992eb19d436 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("115sl")), {
        moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
    });
    var $009be0886fa71d74$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $009be0886fa71d74$export$8d4b3992eb19d436,
            pageId: "async-jira-eoc-group-detail",
            shouldShowSpinner: false
        });
    const $b412556f032cd6c3$export$66928ab349190059 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $61dbc99cfecef4f3$export$e6569aff8dfd4c1d), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.aiops-smart-view_yf5qp'), (0, $009be0886fa71d74$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("eYyoJ")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, $423d186a1838bb07$export$a1c034c1031e8711)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $009be0886fa71d74$export$8d4b3992eb19d436),
                (0, $423d186a1838bb07$export$674fd99c08c90491)
            ]
        }));
    const $b412556f032cd6c3$export$2b25520e20820251 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $61dbc99cfecef4f3$export$aa8cf61e94739f21), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.aiops-smart-view_yf5qp'), (0, $009be0886fa71d74$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, (0, parcelRequire("eYyoJ")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $009be0886fa71d74$export$8d4b3992eb19d436),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $90XDC;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $3d5192328e8485c6$export$e935ec688da4c447 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS),
        path: '/jira/ops/teams/:teamId/heartbeats',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $c885df6a6405ba26$var$LazyHeartbeats = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8074j")), {
        moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
    });
    const $c885df6a6405ba26$var$HeartbeatsComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c885df6a6405ba26$var$LazyHeartbeats,
            pageId: "async-jira-eoc-heartbeats",
            shouldShowSpinner: false
        });
    const $c885df6a6405ba26$export$2c2d6115c4280a08 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3d5192328e8485c6$export$e935ec688da4c447), ()=>({
            component: $c885df6a6405ba26$var$HeartbeatsComponent,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("90XDC")).resources),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $c885df6a6405ba26$var$LazyHeartbeats,
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffEPd;
    var $3zzQS;
    const $e9a4d4d3026c87cf$export$c83d9fd41123ab31 = [
        (0, (0, parcelRequire("3zzQS")).listResource)
    ];
    const $e9a4d4d3026c87cf$export$63630293105c0f4e = [
        (0, (0, parcelRequire("ffEPd")).detailResource)
    ];
    var $ffza4;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $0ecdac041b69c905$export$8dd2e8adca05d8a3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INCOMING_CALL),
        path: '/jira/settings/products/ops/incoming-call',
        exact: true
    };
    const $0ecdac041b69c905$export$10f19333da6ac52c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL),
        path: '/jira/settings/products/ops/incoming-call/:id',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $25997639b70bd430$export$d76e6607b7e88a7b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4DnHd")).then((module)=>module.IncomingCallPage), {
        moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
    });
    const $25997639b70bd430$export$1c56f2b1fdd5d724 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4DnHd")).then((module)=>module.IncomingCallDetailPage), {
        moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
    });
    const $0cb28d0cbf2b2b29$export$742ca8be503e0313 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $25997639b70bd430$export$d76e6607b7e88a7b),
            pageId: "async-jira-eoc-incoming-call",
            shouldShowSpinner: false
        });
    const $0cb28d0cbf2b2b29$export$6ec51edee1972588 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $25997639b70bd430$export$1c56f2b1fdd5d724),
            pageId: "async-jira-eoc-incoming-call-detail",
            shouldShowSpinner: false
        });
    const $0cb28d0cbf2b2b29$export$bf8ccc758901febd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0ecdac041b69c905$export$8dd2e8adca05d8a3), ()=>({
            component: $0cb28d0cbf2b2b29$export$742ca8be503e0313,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $e9a4d4d3026c87cf$export$c83d9fd41123ab31)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $25997639b70bd430$export$d76e6607b7e88a7b)
            ]
        }));
    const $0cb28d0cbf2b2b29$export$39f40714591c98c0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0ecdac041b69c905$export$10f19333da6ac52c), ()=>({
            component: $0cb28d0cbf2b2b29$export$6ec51edee1972588,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $e9a4d4d3026c87cf$export$63630293105c0f4e)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $25997639b70bd430$export$d76e6607b7e88a7b)
            ]
        }));
    const $0cb28d0cbf2b2b29$export$5d3c7bc3dee8745d = [
        $0cb28d0cbf2b2b29$export$bf8ccc758901febd,
        $0cb28d0cbf2b2b29$export$39f40714591c98c0
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $jxRF2;
    var $cekVR;
    var $k5TFj;
    var $8qZNT;
    var $lCbSp;
    const $6eed7288156ead59$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("lCbSp")).uiSettingsResource),
        (0, (0, parcelRequire("8qZNT")).logsResource),
        (0, (0, parcelRequire("cekVR")).byokInformationResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
    const $6eed7288156ead59$export$8571305c82629fe4 = [
        (0, (0, parcelRequire("k5TFj")).downloadAuditLogsResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
    var $g9g6m;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $71acb2a72131fd04$export$400ead354c81dee3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
        path: '/jira/ops/teams/:teamId/integrations',
        exact: true
    };
    const $71acb2a72131fd04$export$b8218f375778e6d7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
        path: '/jira/ops/teams/:teamId/integrations/list',
        exact: true
    };
    const $71acb2a72131fd04$export$a2ec7da6c43acbbf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
        path: '/jira/ops/teams/:teamId/integrations/create/:type',
        exact: true
    };
    const $71acb2a72131fd04$export$72169399df792b7c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
        path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
        exact: true
    };
    const $71acb2a72131fd04$export$ca02d7b2c7df3d60 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
        path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
        exact: true
    };
    const $71acb2a72131fd04$export$e196ff2390a1ec56 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATIONS),
        path: '/jira/settings/products/ops/integrations',
        exact: true
    };
    const $71acb2a72131fd04$export$270e16f240db883b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_LIST),
        path: '/jira/settings/products/ops/integrations/list',
        exact: true
    };
    const $71acb2a72131fd04$export$bb272d36e3c3b7c1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_CREATE),
        path: '/jira/settings/products/ops/integrations/create/:type',
        exact: true
    };
    const $71acb2a72131fd04$export$f826f15073eda98 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_DETAIL),
        path: '/jira/settings/products/ops/integrations/:type/:integrationId',
        exact: true
    };
    const $71acb2a72131fd04$export$71884dc820e415fc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_LOG),
        path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $3157621202ba1387$export$68c40afda0287b61 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationAutomation), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$fd7f60e3df94c902 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationDetail), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$aa9358ade7cb53ee = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationCreate), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$993132b847f26efa = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationList), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$b02ef932401d95fc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationLog), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $6b3ff6d01c7ec3bb$export$434c3e2269913ac0 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$68c40afda0287b61),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$8bb99f196e0be5b6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$fd7f60e3df94c902),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$5cb14595364f02c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$aa9358ade7cb53ee),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$955768269b79c203 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$993132b847f26efa),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$b545b4a4c4cee016 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$b02ef932401d95fc),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$ded9494f81dd2a4d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$400ead354c81dee3), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: null,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$52ee366e7b51f38d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$b8218f375778e6d7), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: $6b3ff6d01c7ec3bb$export$955768269b79c203,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).integrationListResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$83aea99d18750f08 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$a2ec7da6c43acbbf), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: $6b3ff6d01c7ec3bb$export$5cb14595364f02c,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).integrationListResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$7e0b6b79953422c1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$72169399df792b7c), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: $6b3ff6d01c7ec3bb$export$8bb99f196e0be5b6,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$d5e169223d2a5d1d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$ca02d7b2c7df3d60), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$b545b4a4c4cee016,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, $6eed7288156ead59$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$6e5cd6656076550f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$e196ff2390a1ec56), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: null,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$790602da39f8af00 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$270e16f240db883b), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$955768269b79c203,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).integrationListResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$62eef9a2917f041f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$bb272d36e3c3b7c1), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$5cb14595364f02c,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).integrationListResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$b66abbccbf93e9ad = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$f826f15073eda98), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$8bb99f196e0be5b6,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$d30f51d0f351bd8a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $71acb2a72131fd04$export$71884dc820e415fc), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$b545b4a4c4cee016,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $6eed7288156ead59$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$de0b5a5b87cf45f3 = [
        $6b3ff6d01c7ec3bb$export$ded9494f81dd2a4d,
        $6b3ff6d01c7ec3bb$export$52ee366e7b51f38d,
        $6b3ff6d01c7ec3bb$export$83aea99d18750f08,
        $6b3ff6d01c7ec3bb$export$7e0b6b79953422c1,
        $6b3ff6d01c7ec3bb$export$d5e169223d2a5d1d,
        $6b3ff6d01c7ec3bb$export$6e5cd6656076550f,
        $6b3ff6d01c7ec3bb$export$790602da39f8af00,
        $6b3ff6d01c7ec3bb$export$62eef9a2917f041f,
        $6b3ff6d01c7ec3bb$export$b66abbccbf93e9ad,
        $6b3ff6d01c7ec3bb$export$d30f51d0f351bd8a
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $iBsI0;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $b5650c0e42d18fd9$export$b997369a5c2dab54 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE),
        path: '/jira/ops/teams/:teamId/maintenance',
        exact: true
    };
    const $b5650c0e42d18fd9$export$9d65c6548c3b50e4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE),
        path: '/jira/settings/products/ops/maintenance',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $7ad94afcb3b299a0$var$LazyMaintenance = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("auNeJ")), {
        moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
    });
    const $7ad94afcb3b299a0$var$MaintenanceComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7ad94afcb3b299a0$var$LazyMaintenance,
            pageId: "async-jira-eoc-maintenance",
            shouldShowSpinner: false
        });
    const $7ad94afcb3b299a0$var$eocMaintenanceRouteEntry = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b5650c0e42d18fd9$export$b997369a5c2dab54), ()=>({
            component: $7ad94afcb3b299a0$var$MaintenanceComponent,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("iBsI0")).resources),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7ad94afcb3b299a0$var$LazyMaintenance,
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $7ad94afcb3b299a0$var$eocGlobalMaintenanceRouteEntry = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b5650c0e42d18fd9$export$9d65c6548c3b50e4), ()=>({
            component: $7ad94afcb3b299a0$var$MaintenanceComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("iBsI0")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7ad94afcb3b299a0$var$LazyMaintenance
            ]
        }));
    const $7ad94afcb3b299a0$export$ed40a3967b4f2617 = [
        $7ad94afcb3b299a0$var$eocMaintenanceRouteEntry,
        $7ad94afcb3b299a0$var$eocGlobalMaintenanceRouteEntry
    ];
    var $iufIe;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $5a3df92a84226c6a$export$18cec3860c46aaf2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
        path: '/jira/ops/teams/:teamId',
        exact: true
    };
    const $5a3df92a84226c6a$export$5eaa466ae8a4d7d3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL),
        path: '/jira/ops/teams/:teamId/on-call',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $da08681b2a2ed397$export$659b7ce11c160b32 = ()=>{
        const [routeContext] = (0, $dIdda.useRouter)();
        const redirectionUrl = `${routeContext.location.pathname}/on-call`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: redirectionUrl
        });
    };
    const $da08681b2a2ed397$export$772095aa22362f73 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4uLc4")), {
        moduleId: "./src/packages/eoc/on-call/src/index.tsx"
    });
    var $da08681b2a2ed397$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $da08681b2a2ed397$export$772095aa22362f73,
            pageId: "async-jira-eoc-on-call",
            shouldShowSpinner: false
        });
    const $cc7a94948fc6ee4a$export$ac245212b12db871 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5a3df92a84226c6a$export$18cec3860c46aaf2), ()=>({
            component: (0, $da08681b2a2ed397$export$659b7ce11c160b32),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ],
            isRedirect: true
        }));
    const $cc7a94948fc6ee4a$export$8657ca08ca5cbfc6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5a3df92a84226c6a$export$5eaa466ae8a4d7d3), ()=>({
            component: (0, $da08681b2a2ed397$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, (0, parcelRequire("iufIe")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $da08681b2a2ed397$export$772095aa22362f73),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lmyls;
    var $2G9Bk;
    var $5OcAv;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $963d9bbc50a3fbba$export$cb929d46451a5c12 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW),
        path: '/jira/ops/overview',
        exact: true
    };
    const $963d9bbc50a3fbba$export$dbe53627482b9f0f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
        path: '/jira/ops/overview/teams',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $0a523b5d7d04a7f3$var$LazyOverviewPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9oNUK")).then((m)=>m.OverviewPage), {
        moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
    });
    const $0a523b5d7d04a7f3$var$LazyOverviewAllTeamsPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8tAz8")).then((m)=>m.AllTeamsPage), {
        moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
    });
    const $0a523b5d7d04a7f3$var$EocOverviewComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0a523b5d7d04a7f3$var$LazyOverviewPage,
            pageId: "async-jira-eoc-overview",
            shouldShowSpinner: false
        });
    const $0a523b5d7d04a7f3$var$EocOverviewAllTeamsComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0a523b5d7d04a7f3$var$LazyOverviewAllTeamsPage,
            pageId: "async-jira-eoc-overview-all-teams",
            shouldShowSpinner: false
        });
    const $0a523b5d7d04a7f3$export$f1a859c727c30be4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $963d9bbc50a3fbba$export$cb929d46451a5c12), ()=>({
            component: $0a523b5d7d04a7f3$var$EocOverviewComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("5OcAv")).getTeamsResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                horizontal: (0, $7836a14152b01d88$export$27e50c09ebb514f),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7836a14152b01d88$export$82108adf6887e32e),
                $0a523b5d7d04a7f3$var$LazyOverviewPage
            ]
        }));
    const $0a523b5d7d04a7f3$export$842d7c81068bb64e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $963d9bbc50a3fbba$export$dbe53627482b9f0f), ()=>({
            component: $0a523b5d7d04a7f3$var$EocOverviewAllTeamsComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("5OcAv")).getTeamsResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                horizontal: (0, $7836a14152b01d88$export$27e50c09ebb514f),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7836a14152b01d88$export$82108adf6887e32e),
                $0a523b5d7d04a7f3$var$LazyOverviewAllTeamsPage
            ]
        }));
    var $j4Jjv;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $3b187ddb8aa38409$export$8e6afd724de3be6e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS),
        path: '/jira/ops/teams/:teamId/settings',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $54e18f7965bed61c$export$27b4fb95241ab47 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("90Y3w")), {
        moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
    });
    var $54e18f7965bed61c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $54e18f7965bed61c$export$27b4fb95241ab47,
            pageId: "async-jira-eoc-member-roles",
            shouldShowSpinner: false
        });
    const $35644870254acca5$export$c2ced436a30c60dc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3b187ddb8aa38409$export$8e6afd724de3be6e), ()=>({
            component: (0, $54e18f7965bed61c$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("j4Jjv")).pageAccessResource),
                ...(0, (0, parcelRequire("j4Jjv")).resources),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $54e18f7965bed61c$export$27b4fb95241ab47),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $f4VN0;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $a4216a36228c2696$export$eab7ea9e54b67f16 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES),
        path: '/jira/ops/teams/:teamId/policies',
        exact: true
    };
    const $a4216a36228c2696$export$4eb24a8e860a3df7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_POLICIES),
        path: '/jira/settings/products/ops/policies',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $784323cf5d6d6d47$var$LazyAlertPolicies = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9A51b")), {
        moduleId: "./src/packages/eoc/policies/src/index.tsx"
    });
    const $784323cf5d6d6d47$var$AlertPoliciesComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $784323cf5d6d6d47$var$LazyAlertPolicies,
            pageId: "async-jira-eoc-alert-policies",
            shouldShowSpinner: false
        });
    const $784323cf5d6d6d47$export$eb1e2324ca2031e2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a4216a36228c2696$export$eab7ea9e54b67f16), ()=>({
            component: $784323cf5d6d6d47$var$AlertPoliciesComponent,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("f4VN0")).resources),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $784323cf5d6d6d47$var$LazyAlertPolicies,
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $784323cf5d6d6d47$export$2ee2f43d380cc210 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a4216a36228c2696$export$4eb24a8e860a3df7), ()=>({
            component: $784323cf5d6d6d47$var$AlertPoliciesComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("f4VN0")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $784323cf5d6d6d47$var$LazyAlertPolicies
            ]
        }));
    const $784323cf5d6d6d47$export$3a28949e52d2d60f = [
        $784323cf5d6d6d47$export$eb1e2324ca2031e2,
        $784323cf5d6d6d47$export$2ee2f43d380cc210
    ];
    var $dY89w;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $99922e52e7ec0235$export$c71b9e52093cd3a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS),
        path: '/jira/ops/teams/:teamId/reports',
        exact: true
    };
    const $99922e52e7ec0235$export$4209bfa031a1bc9e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS),
        path: '/jira/ops/reports',
        exact: true
    };
    const $99922e52e7ec0235$export$72cde899ee974e6e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
        path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
        exact: true
    };
    const $99922e52e7ec0235$export$2344cc35fd2eff4e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
        path: '/jira/ops/reports/:dashboardId',
        exact: true
    };
    const $99922e52e7ec0235$export$c9e0796615c034f3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM),
        path: '/jira/ops/teams/:teamId/reports/:dashboardId',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $cba1f7031d59cee6$export$2404f0e35deca592 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jubOI")), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$d33ea1a773b744e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$66850ec5549adba6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$5fd77c3bbfb22cbd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$22253dbadb46d0cf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$d33ea1a773b744e,
            pageId: "async-jira-eoc-ops-reports-redirect",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$648ddf2d1f8b1c3f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$66850ec5549adba6,
            pageId: "async-jira-eoc-global-ops-reports",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$87e6a54b4f5dc91e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$2404f0e35deca592,
            pageId: "async-jira-eoc-ops-reports",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$7f366d77015c286f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$5fd77c3bbfb22cbd,
            pageId: "async-jira-eoc-ops-reports-unsubscribe",
            shouldShowSpinner: false
        });
    const $756c00e161e435ff$export$c5606e8eeca32c0f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $99922e52e7ec0235$export$c71b9e52093cd3a), ()=>({
            component: (0, $cba1f7031d59cee6$export$22253dbadb46d0cf),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("dY89w")).opsReportsPermissionResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$d33ea1a773b744e),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $756c00e161e435ff$export$be0522f298067d5d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $99922e52e7ec0235$export$4209bfa031a1bc9e), ()=>({
            component: (0, $cba1f7031d59cee6$export$22253dbadb46d0cf),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("dY89w")).opsReportsPermissionResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$d33ea1a773b744e),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $756c00e161e435ff$export$1016100af7c78cd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $99922e52e7ec0235$export$2344cc35fd2eff4e), ()=>({
            component: (0, $cba1f7031d59cee6$export$648ddf2d1f8b1c3f),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$66850ec5549adba6)
            ]
        }));
    const $756c00e161e435ff$export$df0202187c23a21d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $99922e52e7ec0235$export$72cde899ee974e6e), ()=>({
            component: (0, $cba1f7031d59cee6$export$7f366d77015c286f),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$5fd77c3bbfb22cbd)
            ]
        }));
    const $756c00e161e435ff$export$cd1c1a81e516fec5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $99922e52e7ec0235$export$c9e0796615c034f3), ()=>({
            component: (0, $cba1f7031d59cee6$export$87e6a54b4f5dc91e),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$2404f0e35deca592),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $756c00e161e435ff$export$1d5f1cc699ecefa3 = [
        $756c00e161e435ff$export$c5606e8eeca32c0f,
        $756c00e161e435ff$export$df0202187c23a21d,
        $756c00e161e435ff$export$be0522f298067d5d,
        $756c00e161e435ff$export$1016100af7c78cd,
        $756c00e161e435ff$export$cd1c1a81e516fec5
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $hZVks;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $6ac7f6b07af18790$export$5a10092825ee32e4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS),
        path: '/jira/settings/products/ops/role-based-notifications',
        exact: true
    };
    const $6ac7f6b07af18790$export$659aa6d7cd021e4b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL),
        path: '/jira/settings/products/ops/role-based-notifications/:id',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $02e4c36ee22bcb25$export$15a244aba8f3b406 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("e2wkZ")).then((module)=>module.RoleBasedNotificationsPage), {
        moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
    });
    const $02e4c36ee22bcb25$export$5211e5a7ed694f98 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("e2wkZ")).then((module)=>module.RoleBasedNotificationDetail), {
        moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
    });
    const $02e4c36ee22bcb25$export$8994be6f8ad6a04a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $02e4c36ee22bcb25$export$15a244aba8f3b406,
            pageId: "async-jira-eoc-role-based-notifications",
            shouldShowSpinner: false
        });
    const $02e4c36ee22bcb25$export$445112c3a1089cc5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $02e4c36ee22bcb25$export$5211e5a7ed694f98,
            pageId: "async-jira-eoc-role-based-notifications",
            shouldShowSpinner: false
        });
    const $02e4c36ee22bcb25$export$60de9875bb8ef1d6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6ac7f6b07af18790$export$5a10092825ee32e4), ()=>({
            component: $02e4c36ee22bcb25$export$8994be6f8ad6a04a,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("hZVks")).resources)[0],
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $02e4c36ee22bcb25$export$15a244aba8f3b406
            ]
        }));
    const $02e4c36ee22bcb25$export$565325825b04cec6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6ac7f6b07af18790$export$659aa6d7cd021e4b), ()=>({
            component: $02e4c36ee22bcb25$export$8994be6f8ad6a04a,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            slot: $02e4c36ee22bcb25$export$445112c3a1089cc5,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("hZVks")).resources)[0],
                (0, (0, parcelRequire("hZVks")).resources)[1],
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $02e4c36ee22bcb25$export$15a244aba8f3b406
            ]
        }));
    const $02e4c36ee22bcb25$export$80002c8e4483fef1 = [
        $02e4c36ee22bcb25$export$60de9875bb8ef1d6,
        $02e4c36ee22bcb25$export$565325825b04cec6
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $6cae6731b8f81714$export$10454dc485142eb6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES),
        path: '/jira/settings/products/ops/schedules',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $7f9b61c89fe6f1c9$var$LazyScheduleGlobalPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aSaEv")).then((m)=>m.ScheduleGlobalPage), {
        moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
    });
    const $7f9b61c89fe6f1c9$var$EocScheduleGlobalComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7f9b61c89fe6f1c9$var$LazyScheduleGlobalPage,
            pageId: "async-jira-eoc-schedule-global",
            shouldShowSpinner: false
        });
    const $7f9b61c89fe6f1c9$export$831e8756cdaae4ba = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6cae6731b8f81714$export$10454dc485142eb6), ()=>({
            component: $7f9b61c89fe6f1c9$var$EocScheduleGlobalComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f9b61c89fe6f1c9$var$LazyScheduleGlobalPage
            ]
        }));
    var $en1L8;
    var $2r8fH;
    var $ffza4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $e47e25e553b4e53f$export$94efd60f23d97aa5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS),
        path: '/jira/ops/teams/:teamId/alerts',
        exact: true
    };
    const $e47e25e553b4e53f$export$ac102dc13a0f4aff = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
        path: '/jira/ops/teams/:teamId/alerts/:id',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $c4eca2f6e4b2f333$export$f4aafff31d950b6c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("d8hKi")), {
        moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
    });
    var $c4eca2f6e4b2f333$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c4eca2f6e4b2f333$export$f4aafff31d950b6c,
            pageId: "async-jira-eoc-alert-list",
            shouldShowSpinner: false
        });
    const $58f11685dabb370d$export$de37dab3b3ed8e5c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e47e25e553b4e53f$export$94efd60f23d97aa5), ()=>({
            component: (0, $c4eca2f6e4b2f333$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c4eca2f6e4b2f333$export$f4aafff31d950b6c),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $58f11685dabb370d$export$94aaa7006da9d63a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e47e25e553b4e53f$export$ac102dc13a0f4aff), ()=>({
            component: (0, $c4eca2f6e4b2f333$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7),
                ...(0, (0, parcelRequire("en1L8")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c4eca2f6e4b2f333$export$f4aafff31d950b6c),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    const $58f11685dabb370d$export$a727cbd3cbcc2153 = [
        $58f11685dabb370d$export$de37dab3b3ed8e5c,
        $58f11685dabb370d$export$94aaa7006da9d63a
    ];
    var $ffza4;
    var $9QpK7;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $1e276f535e94effd$export$4b517044f5f7830d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS),
        path: '/jira/settings/products/ops/jira-service-management-audit-logs',
        exact: true
    };
    const $1e276f535e94effd$export$678856ccddc0bc05 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD),
        path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jSpQ7")), {
        moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
    });
    const $ff16a0c6b99cd2b6$export$898c7cb3b28a6104 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jSpQ7")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
        moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
    });
    var $ff16a0c6b99cd2b6$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce,
            pageId: "async-jira-eoc-customer-logs",
            shouldShowSpinner: false
        });
    const $ff16a0c6b99cd2b6$export$a5786cf859b7b457 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff16a0c6b99cd2b6$export$898c7cb3b28a6104,
            pageId: "async-jira-eoc-customer-logs-download",
            shouldShowSpinner: false
        });
    const $b1cb59fcc9012060$export$42ca979ec2919b23 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1e276f535e94effd$export$4b517044f5f7830d), ()=>({
            component: (0, $ff16a0c6b99cd2b6$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $6eed7288156ead59$export$bc99aaabaf7b70a7)
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce)
            ]
        }));
    const $b1cb59fcc9012060$export$d2ce6f09ef8aa840 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1e276f535e94effd$export$678856ccddc0bc05), ()=>({
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('platform.pun.audit-logs-export-log-release_dvp2f', (0, $ff16a0c6b99cd2b6$export$a5786cf859b7b457), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, $6eed7288156ead59$export$8571305c82629fe4)
            ],
            forPaint: [
                (0, $ff16a0c6b99cd2b6$export$898c7cb3b28a6104)
            ]
        }));
    var $ffza4;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $ieJ0b;
    const $05907c872dfc2fcc$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("ieJ0b")).transitioningDetailsResource)
    ];
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $c1d60f0c94994434$export$30306de7e00bc5a2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_UNLOCK_OPERATIONS),
        path: '/jira/settings/products/ops/unlock',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $c4c082612871271f$export$55e4754d556d072 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8Piip")), {
        moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
    });
    var $c4c082612871271f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c4c082612871271f$export$55e4754d556d072,
            pageId: "eoc-products-unlock-operations",
            shouldShowSpinner: false
        });
    const $82aec00f2e2dda3e$export$c058f4d1c0667ce1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c1d60f0c94994434$export$30306de7e00bc5a2), ()=>({
            layout: (0, $d1122e3218429f7d$export$b8fa7ac7019001bb),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, $c4c082612871271f$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $05907c872dfc2fcc$export$bc99aaabaf7b70a7)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c4c082612871271f$export$55e4754d556d072)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $vla3y;
    var $ffza4;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5Dlsd;
    var $5j7Th;
    var $kxZPA;
    const $0b947f3e1def635b$export$7b03e7437c5d4f77 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c2Cr1")), {
        moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
    });
    const $0b947f3e1def635b$export$51430a0cf6ef3c09 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0b947f3e1def635b$export$7b03e7437c5d4f77,
            pageId: "async-jira-eoc-who-is-on-call",
            shouldShowSpinner: false
        });
    const $0b947f3e1def635b$export$fee33ca9661e49dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Dlsd")).whoIsOnCallRoute), ()=>({
            layout: (0, $d1122e3218429f7d$export$b8fa7ac7019001bb),
            component: $0b947f3e1def635b$export$51430a0cf6ef3c09,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("vla3y")).resources)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $0b947f3e1def635b$export$7b03e7437c5d4f77
            ]
        }));
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $36fb274e5b4d9090$export$465fa01c0f3a0551 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ERRORS_NOT_FOUND),
        path: '/jira/:projectType(software|servicedesk|core)'
    };
    const $9dd385bec704f15e$export$c4c012a49b465e94 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $36fb274e5b4d9090$export$465fa01c0f3a0551), ()=>({
            component: (0, (0, parcelRequire("5lsNZ")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5lsNZ")).LazyNotFoundErrorPage)
            ]
        }));
    var $ffza4;
    var $gyYxw;
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $iFaFr;
    var $hBv66;
    var $iHiHz;
    var $78U7j;
    var $h0bZU;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $bHhiy;
    var $2YqLE;
    var $3RJkv;
    var $atU1t;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $65Ltd;
    const $9d69eef872039dea$export$392534a80a0b9b11 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_ADMIN_SETTINGS),
        path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
    };
    const $9d69eef872039dea$export$157f97e6454c2a9f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_ADMIN),
        path: '/jira/settings/apps/:appId/:envId/:route?'
    };
    const $9d69eef872039dea$export$998d01fc8f4c3224 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/apps/:appId/:envId/:route?'
    };
    const $9d69eef872039dea$export$b77275b989ab42a6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
    };
    const $9d69eef872039dea$export$2ee4468dd8e9636f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION),
        path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
    };
    const $9d69eef872039dea$export$4146dba061d1c72d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL),
        path: '/jira/apps/:appId/:envId/:route?'
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $bef31a55bb1643fb$export$66ee65dcd4a6458d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5bXwS")), {
        moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
    });
    const $bef31a55bb1643fb$export$c9e5f500ef472147 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bef31a55bb1643fb$export$66ee65dcd4a6458d,
            pageId: "forge-spa-admin",
            shouldShowSpinner: true
        });
    var $bef31a55bb1643fb$export$2e2bcd8739ae039 = $bef31a55bb1643fb$export$c9e5f500ef472147;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $b96b1546635e7c38$export$c53e206c7fd6fb76 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("32VdM")), {
        moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
    });
    const $b96b1546635e7c38$export$50bd0baee0b2f946 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b96b1546635e7c38$export$c53e206c7fd6fb76,
            pageId: "forge-spa-field-context-config",
            shouldShowSpinner: true
        });
    var $b96b1546635e7c38$export$2e2bcd8739ae039 = $b96b1546635e7c38$export$50bd0baee0b2f946;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $8f6029962fb4c5dc$export$332293feb5cffd72 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("98CQn")), {
        moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
    });
    const $8f6029962fb4c5dc$export$4c36a7b018e5e5cc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f6029962fb4c5dc$export$332293feb5cffd72,
            pageId: "forge-spa-global",
            shouldShowSpinner: true
        });
    var $8f6029962fb4c5dc$export$2e2bcd8739ae039 = $8f6029962fb4c5dc$export$4c36a7b018e5e5cc;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $495262f31d81d9db$export$27b0c9e982208d7e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9ORLZ")), {
        moduleId: "./src/packages/spa-apps/forge/project/src/index.tsx"
    });
    const $495262f31d81d9db$export$99737a64be9f5f1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $495262f31d81d9db$export$27b0c9e982208d7e,
            pageId: "forge-spa-project",
            shouldShowSpinner: true
        });
    var $495262f31d81d9db$export$2e2bcd8739ae039 = $495262f31d81d9db$export$99737a64be9f5f1;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ebb310d709581894$export$62e1bcb9c27c99b5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("74XPL")), {
        moduleId: "./src/packages/spa-apps/forge/servicedesk-queue/src/index.tsx"
    });
    const $ebb310d709581894$export$e83b7c5b466e791a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ebb310d709581894$export$62e1bcb9c27c99b5,
            pageId: "forge-spa-servicedesk-queue",
            shouldShowSpinner: true
        });
    var $ebb310d709581894$export$2e2bcd8739ae039 = $ebb310d709581894$export$e83b7c5b466e791a;
    const $a901f652fe0a27d8$export$fc82fa1ad8302441 = ()=>({
            component: (0, $bef31a55bb1643fb$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $bef31a55bb1643fb$export$66ee65dcd4a6458d)
            ]
        });
    const $a901f652fe0a27d8$export$1c55fbe0ae1da308 = ()=>({
            component: (0, $495262f31d81d9db$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSharedNavigationSingleResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $495262f31d81d9db$export$27b0c9e982208d7e)
            ]
        });
    const $a901f652fe0a27d8$export$95c93c3fcfde8901 = ()=>({
            component: (0, $b96b1546635e7c38$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("5bkvv")).forgeCustomFieldTypeResource),
                (0, (0, parcelRequire("2YqLE")).fieldContextConfigPageResource),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b96b1546635e7c38$export$c53e206c7fd6fb76)
            ]
        });
    const $a901f652fe0a27d8$export$a2f53aa48e785c7 = ()=>({
            component: (0, $ebb310d709581894$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ebb310d709581894$export$62e1bcb9c27c99b5)
            ]
        });
    const $a901f652fe0a27d8$export$dbdc27694c56b868 = ()=>({
            component: (0, $8f6029962fb4c5dc$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iFaFr")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationForgeGlobalPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8f6029962fb4c5dc$export$332293feb5cffd72)
            ]
        });
    const $a901f652fe0a27d8$export$b1d92ac5cda62e7e = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9d69eef872039dea$export$392534a80a0b9b11), ()=>$a901f652fe0a27d8$export$fc82fa1ad8302441()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9d69eef872039dea$export$157f97e6454c2a9f), ()=>$a901f652fe0a27d8$export$fc82fa1ad8302441()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9d69eef872039dea$export$998d01fc8f4c3224), ()=>$a901f652fe0a27d8$export$1c55fbe0ae1da308()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9d69eef872039dea$export$b77275b989ab42a6), ()=>$a901f652fe0a27d8$export$a2f53aa48e785c7()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9d69eef872039dea$export$2ee4468dd8e9636f), ()=>$a901f652fe0a27d8$export$95c93c3fcfde8901()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9d69eef872039dea$export$4146dba061d1c72d), ()=>$a901f652fe0a27d8$export$dbdc27694c56b868())
    ];
    var $ffza4;
    var $bwLf9;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $f9477dd155e645fe$export$e69b84daf70501b3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_MAIL_SETTINGS),
        path: '/secure/admin/global-mail-settings',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $dMnMc;
    var $dJl1T;
    var $34Vv8;
    var $j8DrX;
    var $8zOmE;
    var $dIdda = parcelRequire("dIdda");
    var $7VHMR;
    const $1d710f8117ed7a9a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "redirect.legacy-routing.flags.error.title",
            "defaultMessage": "We can't find the page you're looking for"
        },
        description: {
            "id": "redirect.legacy-routing.flags.error.description",
            "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
        },
        goHome: {
            "id": "redirect.legacy-routing.flags.error.go-home",
            "defaultMessage": "Go to the homepage"
        }
    });
    const $d8474afc40da2ee0$export$b9a7f1ebeaa76953 = ()=>({
            type: 'error',
            title: (0, $1d710f8117ed7a9a$export$defe85febe8b728c).title,
            description: (0, $1d710f8117ed7a9a$export$defe85febe8b728c).description,
            actions: [
                {
                    content: (0, $1d710f8117ed7a9a$export$defe85febe8b728c).goHome,
                    onClick: ()=>window.location.assign('/')
                }
            ]
        });
    const $1513009dd97e8af4$var$THRESHOLD = 30000;
    const $1513009dd97e8af4$var$getScopeType = (scope)=>{
        switch(scope.identifierType){
            case 'boardId':
                return 'board';
            case 'projectId':
            case 'projectKey':
                return scope.pageType === 'settings' ? 'projectSettings' : 'project';
            default:
                return '';
        }
    };
    class $1513009dd97e8af4$export$836fe1ef2cfde075 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
            const lastRedirectTime = Number(sessionStorage.getItem(redirectPathname));
            if (!lastRedirectTime) sessionStorage.setItem(redirectPathname, Date.now().toString());
            else if (Date.now() - lastRedirectTime < $1513009dd97e8af4$var$THRESHOLD) {
                const scopeData = (0, (0, parcelRequire("dMnMc")).default)(window.location.href, (0, (0, parcelRequire("j8DrX")).default));
                const scope = $1513009dd97e8af4$var$getScopeType(scopeData);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                    scope: scope
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'entered'
                }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                    scope: scope
                });
                flagService.showFlag((0, $d8474afc40da2ee0$export$b9a7f1ebeaa76953)());
                sessionStorage.removeItem(redirectPathname);
                return;
            } else sessionStorage.removeItem(redirectPathname);
            window.location.assign(redirectPathname + search);
        }
        render() {
            return null;
        }
    }
    var $1513009dd97e8af4$export$2e2bcd8739ae039 = (0, $dIdda.withRouter)((0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("cb25w")).default)()($1513009dd97e8af4$export$836fe1ef2cfde075)));
    var $1a0afe23818eb6ed$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $1513009dd97e8af4$export$2e2bcd8739ae039), null);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cc4123579e370fa7$export$a133d90b2004a90e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7OdtI"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
    });
    var $cc4123579e370fa7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cc4123579e370fa7$export$a133d90b2004a90e,
            pageId: "global-mail-settings",
            shouldShowSpinner: false
        });
    const $94bf6699a35b0833$export$5e1236665a530df4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f9477dd155e645fe$export$e69b84daf70501b3), ()=>({
            ufoName: 'admin.global-mail-settings',
            component: (0, (0, parcelRequire("bwLf9")).default)(()=>true, (0, $cc4123579e370fa7$export$2e2bcd8739ae039), (0, $1a0afe23818eb6ed$export$2e2bcd8739ae039)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cc4123579e370fa7$export$a133d90b2004a90e)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $cpdjw;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $48a2162c2bcbc13a$export$45e7d93edcc9507f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS),
        path: '/secure/admin/ViewCustomFields(!default)?.jspa'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0183f6c188d0635c$export$55a5c16f39a046af = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kI1WL"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
    });
    var $0183f6c188d0635c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0183f6c188d0635c$export$55a5c16f39a046af,
            pageId: "admin-pages-custom-fields-directory",
            shouldShowSpinner: true
        });
    const $13bdc7f7e2c68d21$export$d83c2e469d070766 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $48a2162c2bcbc13a$export$45e7d93edcc9507f), ()=>({
            ufoName: 'admin.custom-fields-directory',
            component: (0, $0183f6c188d0635c$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("cpdjw")).customFieldsDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $0183f6c188d0635c$export$55a5c16f39a046af)
            ]
        }));
    var $51f7x;
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $80e6677eddcef453$export$2eaffde3ad991b33 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HOME),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HOME_ONBOARDING_REDIRECT),
        path: '/jira/your-work-onboarding',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $dIdda = parcelRequire("dIdda");
    const $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect = ()=>{
        const { replace: replace } = (0, $dIdda.useRouterActions)();
        replace('/jira/your-work');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            eventName: "JiraHomeOnboardingRedirect loaded",
            componentName: "JiraHomeOnboardingRedirect",
            attributes: {
                isRedirectionEnabled: true
            }
        });
    };
    var $ff7a191a114ce3ba$export$2e2bcd8739ae039 = $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect;
    const $c38858cd7db392da$export$2740cfaa979353b9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $80e6677eddcef453$export$2eaffde3ad991b33), ()=>({
            component: (0, $ff7a191a114ce3ba$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            isRedirect: true,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $d0046bbda59507f3$export$f7a252c9d61f8f94 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HOME),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HOME_REDIRECT),
        path: '/jira',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $9vlEn;
    var $dIdda = parcelRequire("dIdda");
    const $2791311ae97b7f0a$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';
    const $e5a49877dbf7e167$var$JiraBaseRedirectWrapper = ()=>{
        const { data: data, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("9vlEn")).userHomepageResource));
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && data == null) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $2791311ae97b7f0a$export$25a759e49d5049db), 'userHomepage data is null');
        }, [
            loading,
            data
        ]);
        if (loading) return null;
        if (data == null) {
            window.location.replace('/jira');
            return null;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: data.homepagePreference
        });
    };
    var $e5a49877dbf7e167$export$2e2bcd8739ae039 = $e5a49877dbf7e167$var$JiraBaseRedirectWrapper;
    var $92d7d72ca8393409$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $e5a49877dbf7e167$export$2e2bcd8739ae039), null);
    const $de227c172beddad9$export$5379c026da4201e6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d0046bbda59507f3$export$f7a252c9d61f8f94), ()=>({
            component: (0, $92d7d72ca8393409$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            isRedirect: true,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $2G9Bk;
    var $2Ql51;
    var $65Ltd;
    const $2d82bbe7596c5321$export$c155f4de16b62110 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_CREATE_EMBED),
        path: '/jira/issues/create/embed'
    };
    var $9NiTW;
    var $5j7Th;
    var $kxZPA;
    const $5e1de5a76ddb2c35$var$handleEmbedLinkClick = (e)=>{
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') eventTarget.target = '_blank';
    };
    const $5e1de5a76ddb2c35$export$980ea815ec2d0180 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6QVTY")), {
        ssr: false,
        moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
    });
    const $5e1de5a76ddb2c35$export$87fa8eff34eb030a = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener('click', $5e1de5a76ddb2c35$var$handleEmbedLinkClick, true);
            return ()=>{
                window.removeEventListener('click', $5e1de5a76ddb2c35$var$handleEmbedLinkClick);
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5e1de5a76ddb2c35$export$980ea815ec2d0180,
            pageId: "spa-apps/issue-create-embed",
            shouldShowSpinner: true
        }));
    };
    const $5e1de5a76ddb2c35$export$abd0bbe95839baf7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2d82bbe7596c5321$export$c155f4de16b62110), ()=>({
            component: $5e1de5a76ddb2c35$export$87fa8eff34eb030a,
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            forPaint: [
                $5e1de5a76ddb2c35$export$980ea815ec2d0180
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2vSU6;
    var $co1wz;
    var $4R6GH;
    var $gyYxw;
    var $1FeCu;
    var $7DqiA;
    var $lmyls;
    var $hBv66;
    var $93Yeu;
    var $dAfqg;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $bHhiy;
    var $8ZUng;
    var $5CPDv;
    var $9XjL6;
    var $lCj8l;
    var $dIdda = parcelRequire("dIdda");
    var $5XgeZ;
    const $2368cab4ab12a1eb$export$3b5744f70b49a5c4 = (0, $dIdda.createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_READ_PERM',
        getKey: ({ match: match })=>match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : '',
        getData: ()=>null,
        isBrowserOnly: true
    }));
    var $2Yhep;
    var $dIdda = parcelRequire("dIdda");
    var $5XgeZ;
    const $018bbab5966993b0$export$80c2a5c658bd9e1e = (0, $dIdda.createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_UPLOAD_PERM',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: ()=>null,
        isBrowserOnly: true
    }));
    var $2Yhep;
    var $dIdda = parcelRequire("dIdda");
    var $5XgeZ;
    const $c6e148d80f21d036$export$48db4eb29e9be72c = (0, $dIdda.createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_USER_AUTH',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: ()=>null,
        isBrowserOnly: true
    }));
    var $3RJkv;
    var $1aAOt;
    var $1WlLE;
    var $2Ql51;
    var $gNStA;
    var $eTWbh;
    var $gRzZD;
    var $c65JB;
    var $lGGIs;
    var $5j7Th;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $6799e9dd8b372fc2$var$pageId = 'spa-issue';
    const $6799e9dd8b372fc2$var$conditionalIssueGiraNonCriticalDataResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w'), (0, (0, parcelRequire("lCj8l")).issueGiraNonCriticalDataResource));
    const $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('smart_replies_m1_jira_labs'), (0, (0, parcelRequire("1FeCu")).smartRepliesOptInStatusResources));
    const $6799e9dd8b372fc2$var$LazyIssuePage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("3r24n"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
    });
    const $6799e9dd8b372fc2$export$c1a868ace2f38803 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const [issueKey] = (0, $dIdda.usePathParam)('issueKey');
        const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
        let actualIssueKey = issueKey;
        if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
        if (!false && data?.projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6799e9dd8b372fc2$var$LazyIssuePage,
            pageId: $6799e9dd8b372fc2$var$pageId,
            shouldShowSpinner: false
        });
    };
    const $6799e9dd8b372fc2$export$ef02bcc0eb1d9ded = ()=>{
        const [issueKey] = (0, $dIdda.usePathParam)('issueKey');
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey || '');
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        const projectId = (0, (0, parcelRequire("93Yeu")).useProjectId)(projectKey);
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7DqiA")).EmbedModeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6799e9dd8b372fc2$export$c1a868ace2f38803, null));
    };
    const $6799e9dd8b372fc2$export$cef770e7c16cfcc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eTWbh")).browseIssueRoute), ()=>({
            component: $6799e9dd8b372fc2$export$c1a868ace2f38803,
            skeleton: (0, (0, parcelRequire("c65JB")).IssueViewSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$98e337c40eb151da)),
            navigation: {
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                ...(0, (0, parcelRequire("1aAOt")).getOfferingCatalogueFeaturesResource)(),
                (0, $2368cab4ab12a1eb$export$3b5744f70b49a5c4),
                (0, $c6e148d80f21d036$export$48db4eb29e9be72c),
                (0, (0, parcelRequire("9XjL6")).issueGiraDataResource),
                $6799e9dd8b372fc2$var$conditionalIssueGiraNonCriticalDataResource,
                (0, $018bbab5966993b0$export$80c2a5c658bd9e1e),
                (0, (0, parcelRequire("5CPDv")).issueForgeDataResource),
                (0, (0, parcelRequire("8ZUng")).issueViewRelayResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("gRzZD")).workspaceResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $6799e9dd8b372fc2$var$LazyIssuePage
            ],
            ufoName: 'issue-view',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
            },
            bifrost: {
                bundling: {
                    packageName: '@atlassian/jira-router-routes-issue-entries',
                    whichExportToUse: 'browseIssueRouteEntry'
                },
                enabled: true
            }
        }));
    const $6799e9dd8b372fc2$export$e275b3ca0c6ccb5e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eTWbh")).browseIssueEmbedRoute), ()=>({
            component: $6799e9dd8b372fc2$export$ef02bcc0eb1d9ded,
            skeleton: (0, (0, parcelRequire("c65JB")).IssueViewSkeleton),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getModernIssueTransitionResources)(),
                (0, $2368cab4ab12a1eb$export$3b5744f70b49a5c4),
                (0, $c6e148d80f21d036$export$48db4eb29e9be72c),
                (0, (0, parcelRequire("9XjL6")).issueGiraDataResource),
                $6799e9dd8b372fc2$var$conditionalIssueGiraNonCriticalDataResource,
                (0, $018bbab5966993b0$export$80c2a5c658bd9e1e),
                (0, (0, parcelRequire("5CPDv")).issueForgeDataResource),
                (0, (0, parcelRequire("8ZUng")).issueViewRelayResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("gRzZD")).workspaceResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources
            ],
            forPaint: [
                $6799e9dd8b372fc2$var$LazyIssuePage
            ],
            ufoName: 'issue-view-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
            },
            bifrost: {
                bundling: {
                    packageName: '@atlassian/jira-router-routes-issue-entries',
                    whichExportToUse: 'browseIssueEmbedRouteEntry'
                },
                enabled: true
            }
        }));
    var $ffza4;
    var $co1wz;
    var $gyYxw;
    var $2BrOV;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $bHhiy;
    var $kumTR;
    var $1gXMV;
    var $lHYIV;
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    const $906089a3c28fb671$export$919daad019702595 = {
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: {
                id: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
                packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR)),
                teamName: 'empanada'
            }
        }
    };
    var $4R6GH;
    var $lmyls;
    var $96w9D;
    var $8Wi6S;
    var $8CVvd;
    var $bATyw;
    var $89kiv;
    var $3RJkv;
    var $atU1t;
    var $gNStA;
    const $797f27ab9ceb3235$export$2f31f4f387017d83 = ()=>({
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
            sidebar: (0, (0, parcelRequire("8Wi6S")).AsyncSidebarFiltersGlobal)
        });
    const $797f27ab9ceb3235$export$343e92405307cf8d = ()=>[
            (0, (0, parcelRequire("89kiv")).issueNavigatorRelayResource),
            (0, (0, parcelRequire("89kiv")).issueNavigatorFilterRelayResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('nin_request_hydrate_query_earlier'), (0, (0, parcelRequire("89kiv")).issueNavigatorHydrationRelayResource)),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            (0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("8CVvd")).getWillShowNav3), (0, (0, parcelRequire("96w9D")).sidebarFiltersGlobalResource))
        ];
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $8uKLe;
    var $1b36n;
    var $a3OKn;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $bATyw;
    var $89kiv;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $gNStA;
    const $c7c9a307c1aca60f$export$6236a7417086ea8d = ()=>[
            (0, (0, parcelRequire("89kiv")).issueNavigatorRelayResource),
            (0, (0, parcelRequire("89kiv")).issueNavigatorFilterRelayResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('nin_request_hydrate_query_earlier'), (0, (0, parcelRequire("89kiv")).issueNavigatorHydrationRelayResource)),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), (0, (0, parcelRequire("a3OKn")).sidebarProjectIssuesResource)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), (0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource)),
            (0, (0, parcelRequire("1b36n")).staticSidebarDefaultPINFiltersResource)
        ];
    var $ffza4;
    var $co1wz;
    var $2BrOV;
    var $2G9Bk;
    var $kumTR;
    var $1gXMV;
    var $5uXOq = parcelRequire("5uXOq");
    var $1kQCU;
    var $VILOn;
    var $7SHTM;
    var $1gXMV;
    var $7yO8g;
    var $5j7Th;
    var $cZpsT;
    var $kxZPA;
    var $138ed00c0e48b315$export$2e2bcd8739ae039 = ({ params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
        const { projectKey: projectKey, issueKey: issueKey } = params;
        const pageIdPrefix = 'new-issue-navigator';
        let pageId = '';
        try {
            pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
        } catch  {
            pageId = pageIdPrefix;
        }
        return pageId;
    };
    const $b7591135658477a3$export$5fcc10c40c224fbc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1UnUc")).then((module)=>module.ProjectIssueNavigatorSPA)), {
        moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$2de79bdf33dbf27c = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$5fcc10c40c224fbc,
            pageId: (0, $138ed00c0e48b315$export$2e2bcd8739ae039)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$8570b543078b8f17 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1UnUc")).then((module)=>module.ServiceDeskProjectIssueNavigatorSPA)), {
        moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$5cc1791bbdb6f266 = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$8570b543078b8f17,
            pageId: (0, $138ed00c0e48b315$export$2e2bcd8739ae039)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$8ff267588532c2ce = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("90rvf")), {
        moduleId: "./src/packages/spa-apps/global-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$4bd5bc3fa8a52567 = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$8ff267588532c2ce,
            pageId: (0, $138ed00c0e48b315$export$2e2bcd8739ae039)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$3b4f172f4310bbc = (props)=>{
        const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, (0, parcelRequire("1kQCU")).useGlobalScopeEnrolmentEnable)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        (0, $5uXOq.useEffect)(()=>{
            if (resourceData !== null && resourceData !== undefined) (0, (0, parcelRequire("VILOn")).setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
        }, [
            resourceData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isNinGlobalScopeEnrolmentEnabled === false) window.location.reload();
        }, [
            isNinGlobalScopeEnrolmentEnabled
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isNinGlobalScopeEnrolmentEnabled) {
                const globalGINFlagDisabled = (0, (0, parcelRequire("VILOn")).getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
                if (globalGINFlagDisabled !== false) {
                    !isAnonymous && (0, (0, parcelRequire("7SHTM")).resetGlobalScopeForcedOptOutGinFlag)();
                    (0, (0, parcelRequire("VILOn")).setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
                }
            }
        }, [
            isAnonymous,
            isNinGlobalScopeEnrolmentEnabled
        ]);
        return isNinGlobalScopeEnrolmentEnabled === true ? (0, ($parcel$interopDefault($5uXOq))).createElement($b7591135658477a3$export$4bd5bc3fa8a52567, props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton), null);
    };
    const $a09e1f9770441a11$export$8925c79a030fdfe8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).globalIssueNavigator1Route), ()=>({
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$3b4f172f4310bbc),
            skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$8ff267588532c2ce)
            ],
            canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'),
            ufoName: 'global-issue-navigator-jfe',
            navigation: (0, $797f27ab9ceb3235$export$2f31f4f387017d83)(),
            resources: [
                ...(0, $797f27ab9ceb3235$export$343e92405307cf8d)()
            ],
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
    var $ffza4;
    var $co1wz;
    var $2BrOV;
    var $2G9Bk;
    var $kumTR;
    var $1gXMV;
    const $25e6f63d1902d36e$export$3e58fe44312b4093 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).globalIssueNavigatorRoute), ()=>({
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$3b4f172f4310bbc),
            skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$8ff267588532c2ce)
            ],
            canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'),
            ufoName: 'global-issue-navigator-jfe',
            navigation: (0, $797f27ab9ceb3235$export$2f31f4f387017d83)(),
            resources: [
                ...(0, $797f27ab9ceb3235$export$343e92405307cf8d)()
            ],
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
    var $ffza4;
    var $l71WK;
    var $gyYxw;
    var $lmyls;
    var $dmKXV;
    var $2G9Bk;
    var $1XrjK;
    var $kumTR;
    var $lHYIV;
    const $99398975b82221bf$export$ce258b07e4b7eb8c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).projectIssueNavigatorCoreRoute), ()=>({
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$2de79bdf33dbf27c),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$5fcc10c40c224fbc)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)()
            ],
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
        }));
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $kumTR;
    var $lHYIV;
    var $5PD5h;
    const $41789f7b84696902$export$88d5f4117ce3d0fb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).projectIssueNavigatorClassicRoute), ()=>({
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$2de79bdf33dbf27c),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$5fcc10c40c224fbc)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)()
            ],
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
        }));
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $1WlLE;
    var $kumTR;
    var $6Z2mh;
    var $lHYIV;
    const $20147c9440522c21$export$b779296ccb8ca1a8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).servicedeskIssuesRoute), ()=>({
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$5cc1791bbdb6f266),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$8570b543078b8f17)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)(),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout)
        }));
    var $ffza4;
    var $lmyls;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $kumTR;
    var $lHYIV;
    var $5PD5h;
    var $e7bC3;
    const $a82ae7782e05cd6a$export$2a50f64378877c9d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).softwareIssueNavigatorRoute), ()=>({
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$2de79bdf33dbf27c),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$5fcc10c40c224fbc)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)()
            ],
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding))
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    var $265d2c27687434ef$export$2e2bcd8739ae039 = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const issueKey = match.params.issueKey ?? '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/issues/${issueKey}`
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $jcw0u;
    var $iXVV6;
    var $5oFIy;
    var $dxCvy;
    var $dIdda = parcelRequire("dIdda");
    var $e5b5921263d4891a$export$2e2bcd8739ae039 = ()=>{
        const [{ match: match, query: query }] = (0, $dIdda.useRouter)();
        const { data: data, error: error, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        (0, $5uXOq.useEffect)(()=>{
            if (error) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'useResourceProjectContext',
                    packageName: 'jiraRouterRoutesIssueNavigatorEntries'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            error
        ]);
        if (!data && !loading || error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "pinRedirectFailed"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
        if (!data) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const issueKey = match.params.issueKey ?? '';
        const queryParams = new URLSearchParams(query).toString();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "pinRedirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/${type}/projects/${projectKey}/issues/${issueKey}?${queryParams}`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
    const $1f4483ba9d8ac23e$export$f9a1f59ec7d1f215 = [
        (0, $41789f7b84696902$export$88d5f4117ce3d0fb),
        (0, $a82ae7782e05cd6a$export$2a50f64378877c9d),
        (0, $20147c9440522c21$export$b779296ccb8ca1a8),
        (0, $99398975b82221bf$export$ce258b07e4b7eb8c),
        (0, $25e6f63d1902d36e$export$3e58fe44312b4093),
        (0, $a09e1f9770441a11$export$8925c79a030fdfe8),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).projectIssueNavigatorRoute), ()=>({
                ...(0, $906089a3c28fb671$export$919daad019702595),
                component: (0, $e5b5921263d4891a$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b7591135658477a3$export$5fcc10c40c224fbc)
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
                },
                resources: [
                    ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).globalIssueNavigatorBrowseIssueRedirectRoute), ()=>({
                ...(0, $906089a3c28fb671$export$919daad019702595),
                component: (0, $265d2c27687434ef$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b7591135658477a3$export$8ff267588532c2ce)
                ],
                canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'),
                ufoName: 'global-issue-navigator-jfe',
                navigation: (0, $797f27ab9ceb3235$export$2f31f4f387017d83)(),
                resources: [
                    ...(0, $797f27ab9ceb3235$export$343e92405307cf8d)()
                ],
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $vla3y;
    var $ffza4;
    var $3H5ry;
    var $l9RBL;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $aILzD;
    var $3RJkv;
    var $kbked;
    var $7sjxl;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f9946918a701eac6$var$LazyJiraHomePage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("pC8Oc"))), {
        moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
    });
    const $f9946918a701eac6$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
        const data = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734].promise;
        return (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(data);
    };
    const $f9946918a701eac6$export$fe7946d7dc386f9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f9946918a701eac6$var$LazyJiraHomePage,
            pageId: "jira-home",
            shouldShowSpinner: false
        });
    const $f9946918a701eac6$export$578dcb61ac3cb57a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kbked")).jiraHomeRoute), ()=>({
            ufoName: 'jira-home',
            component: $f9946918a701eac6$export$fe7946d7dc386f9c,
            skeleton: (0, (0, parcelRequire("7sjxl")).YourWorkSkeleton),
            layout: (0, $226ab3e64821f6b2$export$5b7fb151d60504c),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aILzD")).jiraHomeResourceWithCache),
                (0, (0, parcelRequire("l9RBL")).jiraHomePageRightSidePanelResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("vla3y")).widgetResources).map((resourceCreator)=>resourceCreator($f9946918a701eac6$var$checkConsolidationOnRouteDependency, [
                        (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                    ]))
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f9946918a701eac6$var$LazyJiraHomePage
            ]
        }));
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $00c74f90175a79ab$export$a3a93dcf611b611a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_JIRA_SEARCH),
        path: '/jira/search',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $c65JB;
    var $dIdda = parcelRequire("dIdda");
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $4R6GH;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $bATyw;
    var $dIdda = parcelRequire("dIdda");
    const $2bd6861b4d276506$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute), useQueryParam: useQueryParam = (0, $dIdda.useQueryParam) })=>{
        const route = useCurrentRoute();
        const [searchString] = useQueryParam('searchString');
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        let isNinEnabled;
        if ((0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field') || (0, (0, parcelRequire("co1wz")).ff)('nin_expose_text_option_jql_builder_4kwzo')) ({ data: isNinEnabled } = (0, $dIdda.useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource)));
        else isNinEnabled = true;
        (0, $5uXOq.useEffect)(()=>{
            if (!route) return;
            const screenEvent = createAnalyticsEvent({
                screenName: 'quickSearchRedirect',
                attributes: {
                    type: route.name
                }
            });
            fireScreenAnalytics(screenEvent);
        }, [
            createAnalyticsEvent,
            fireScreenAnalytics,
            route
        ]);
        let jql;
        if (isNinEnabled && (0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field')) jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
        else if (isNinEnabled && (0, (0, parcelRequire("co1wz")).ff)('nin_expose_text_option_jql_builder_4kwzo')) jql = searchString != null ? `summary ~ "${searchString}" OR description ~ "${searchString}" ORDER BY created DESC` : 'ORDER BY created DESC';
        else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
        const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: redirectUrl
        });
    };
    var $2bd6861b4d276506$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($2bd6861b4d276506$export$968c2900ae111000, null);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    const $c763bb61845622fe$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
    const $c763bb61845622fe$export$d23832be0ebf8a93 = (0, $dIdda.createResource)({
        type: $c763bb61845622fe$export$486bd66a4d919be7,
        getKey: ()=>'search',
        getData: ({ query: query }, { tenantContext: tenantContext })=>{
            const { atlassianAccountId: atlassianAccountId } = tenantContext;
            if (!atlassianAccountId || !query?.searchString) return null;
            const queryStr = (0, ($parcel$interopDefault($ebyGx))).stringify({
                searchString: query.searchString
            });
            return (0, (0, parcelRequire("7f4tk")).default)(`/rest/navigation/4/quicksearch?${queryStr}`);
        },
        isBrowserOnly: true
    });
    const $c1df58920245e964$export$ee180957879b33ac = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, $c763bb61845622fe$export$d23832be0ebf8a93));
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), null);
        if (error || !data?.url) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2bd6861b4d276506$export$968c2900ae111000), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: data.url,
            push: false
        });
    };
    const $a8fe8d7b4d12b7ef$export$76b74d5744e69817 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $00c74f90175a79ab$export$a3a93dcf611b611a), ()=>({
            component: (0, $c1df58920245e964$export$ee180957879b33ac),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, $c763bb61845622fe$export$d23832be0ebf8a93)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $65Ltd;
    const $1ba9f29920f74359$export$176ff76c3ba7c4ce = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REDIRECT)
    };
    const $958bcb60e3100693$var$RedirectComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $1513009dd97e8af4$export$2e2bcd8739ae039), null);
    const $958bcb60e3100693$export$27f123cb9320355 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1ba9f29920f74359$export$176ff76c3ba7c4ce), ()=>({
            component: $958bcb60e3100693$var$RedirectComponent,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [],
            isRedirect: true,
            canTransitionIn: ()=>false,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $2G9Bk;
    var $65Ltd;
    const $b818456f90aef923$export$9efae7a8e8e69866 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LOGIN_EMBED),
        path: '/jira-login/embed'
    };
    var $5j7Th;
    var $kxZPA;
    const $5ec52c3f3a973163$export$53d5d548e4e9b86 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("35DJb")), {
        moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
    });
    const $5ec52c3f3a973163$export$2a94dc6e96350c82 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ec52c3f3a973163$export$53d5d548e4e9b86,
            pageId: "spa-apps/login-embed",
            shouldShowSpinner: true
        });
    const $5ec52c3f3a973163$export$faa46f8c5e1f06d3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b818456f90aef923$export$9efae7a8e8e69866), ()=>({
            component: $5ec52c3f3a973163$export$2a94dc6e96350c82,
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb)
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $4zecE;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $671f611e278b4662$var$LazyMarketplace = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("azvSc"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
    });
    const $671f611e278b4662$var$MarketplaceComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $671f611e278b4662$var$LazyMarketplace,
            pageId: "marketplace",
            shouldShowSpinner: true
        });
    const $671f611e278b4662$var$findAppsRouteEntry = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4zecE")).findAppsRoute), ()=>({
            component: $671f611e278b4662$var$MarketplaceComponent,
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $671f611e278b4662$var$LazyMarketplace
            ],
            ufoName: 'embedded-marketplace'
        }));
    const $671f611e278b4662$export$423a1c80bb2f8b9a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4zecE")).appRequestRoute), ()=>({
            component: $671f611e278b4662$var$MarketplaceComponent,
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $671f611e278b4662$var$LazyMarketplace
            ]
        }));
    const $671f611e278b4662$export$875d88a44b1ff74c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4zecE")).promotionsRoute), ()=>({
            component: $671f611e278b4662$var$MarketplaceComponent,
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $671f611e278b4662$var$LazyMarketplace
            ]
        }));
    const $671f611e278b4662$export$fd3c71e3bfb4df9e = ()=>[
            $671f611e278b4662$var$findAppsRouteEntry,
            $671f611e278b4662$export$423a1c80bb2f8b9a,
            $671f611e278b4662$export$875d88a44b1ff74c
        ];
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ebyGx = parcelRequire("ebyGx");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $2GkDw;
    var $3RJkv;
    var $dxCvy;
    var $iZ82x;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $1126b5bd57f5ad9d$export$5b818a6914ca8376 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
    };
    const $1126b5bd57f5ad9d$export$cde83a6497756848 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
    };
    const $1126b5bd57f5ad9d$export$3c48ddd40d00b0d2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
    };
    const $1126b5bd57f5ad9d$export$e0d8c26cb1430ae4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
    };
    const $1126b5bd57f5ad9d$export$c777bb8f2591081 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
    };
    const $1126b5bd57f5ad9d$export$bbf45ab0423b990 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
    };
    const $1126b5bd57f5ad9d$export$8c91815cd4b1c078 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
    };
    const $1126b5bd57f5ad9d$export$5bf75a5d8c554930 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
    };
    const $1126b5bd57f5ad9d$export$6072946fe7f2d45a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT),
        path: '/secure/NextGen.jspa'
    };
    const $1126b5bd57f5ad9d$export$9d24fc75b0f1d9a0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE),
        path: '/jira/software/projects/:projectKey/code'
    };
    const $1126b5bd57f5ad9d$export$866215abd09c0f4d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT),
        path: '/secure/Roadmap.jspa'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $aN2bG;
    var $bAB30;
    var $9SRRO;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $5lsNZ;
    var $hziQo;
    var $aJzGl;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $ebyGx = parcelRequire("ebyGx");
    const $8f60ec15db3f7d28$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $d6d069823c19bbe2$export$edb4b8cf67d7d767 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1vlac"))), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $d6d069823c19bbe2$var$BacklogPage = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d6d069823c19bbe2$export$edb4b8cf67d7d767,
            pageId: `next-gen-backlog-${(0, $8f60ec15db3f7d28$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $d6d069823c19bbe2$export$a5f8ba02d2755510 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hziQo")).softwareBacklogRoute), ()=>({
            component: $d6d069823c19bbe2$var$BacklogPage,
            skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bAB30")).conditionalBacklogResource),
                (0, (0, parcelRequire("aN2bG")).conditionalBacklogRelayResource),
                (0, (0, parcelRequire("9SRRO")).customFiltersResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-backlog-early-entry'
                ]
            },
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $d6d069823c19bbe2$export$edb4b8cf67d7d767
            ],
            ufoName: 'next-gen-backlog',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
            }
        }));
    const $d6d069823c19bbe2$export$7cd14dee22609378 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hziQo")).softwareBacklogEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_backlog_smartlink_route', $d6d069823c19bbe2$var$BacklogPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bAB30")).conditionalBacklogResource),
                (0, (0, parcelRequire("aN2bG")).conditionalBacklogRelayResource),
                (0, (0, parcelRequire("9SRRO")).customFiltersResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                $d6d069823c19bbe2$export$edb4b8cf67d7d767
            ],
            ufoName: 'next-gen-backlog-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
            }
        }));
    var $d6d069823c19bbe2$export$2e2bcd8739ae039 = $d6d069823c19bbe2$var$BacklogPage;
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $aIZdc;
    var $ffza4;
    var $co1wz;
    var $cSD7y;
    var $lmyls;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $5qQ9I;
    var $3RJkv;
    var $ipmBb;
    var $2Ql51;
    var $gNStA;
    var $5lsNZ;
    var $2gnjX;
    var $6awMq;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ccb682e3f2b95fd8$export$bd9ede4ec384f41d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("evG1K"))), {
        moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
    });
    const $ccb682e3f2b95fd8$var$getBoardId = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $ccb682e3f2b95fd8$export$78e6ebf73d7f732b = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ccb682e3f2b95fd8$export$bd9ede4ec384f41d,
            pageId: `next-gen-board-${$ccb682e3f2b95fd8$var$getBoardId({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $ccb682e3f2b95fd8$var$conditionalBoardResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>!(0, (0, parcelRequire("co1wz")).ff)('jsw.perf.critical-board-with-relay'), (0, (0, parcelRequire("5qQ9I")).boardResource));
    const $ccb682e3f2b95fd8$var$conditionalBoardRelayResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.perf.critical-board-with-relay'), (0, (0, parcelRequire("5qQ9I")).boardRelayResource));
    const $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource));
    const $ccb682e3f2b95fd8$export$2964ea1cdd5afa39 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2gnjX")).softwareBoardRoute), ()=>({
            component: $ccb682e3f2b95fd8$export$78e6ebf73d7f732b,
            skeleton: (0, (0, parcelRequire("6awMq")).NextGenBoardSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                $ccb682e3f2b95fd8$var$conditionalBoardResource,
                (0, (0, parcelRequire("5qQ9I")).customFiltersResource),
                $ccb682e3f2b95fd8$var$conditionalBoardRelayResource,
                $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-board-early-entry'
                ]
            },
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ccb682e3f2b95fd8$export$bd9ede4ec384f41d
            ],
            ufoName: 'next-gen-board',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
            }
        }));
    const $ccb682e3f2b95fd8$export$ff8632c8a0f5d984 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2gnjX")).softwareBoardEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_board_smartlink_embed', $ccb682e3f2b95fd8$export$78e6ebf73d7f732b, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource,
                $ccb682e3f2b95fd8$var$conditionalBoardResource,
                $ccb682e3f2b95fd8$var$conditionalBoardRelayResource,
                (0, (0, parcelRequire("5qQ9I")).customFiltersResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                $ccb682e3f2b95fd8$export$bd9ede4ec384f41d
            ],
            ufoName: 'next-gen-board-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
            }
        }));
    var $ffza4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $65Ltd;
    const $c4f64c4eb4de5dcd$export$d6730f103a4ad844 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR),
        path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
        queries: [
            'date?'
        ]
    };
    const $c4f64c4eb4de5dcd$export$b55c4d4efb097c1c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED),
        path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
        queries: [
            'date?'
        ]
    };
    var $is7uC;
    var $5PD5h;
    var $e7bC3;
    const $2abc171a2b01be16$export$24fc07c22f0d06 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c4f64c4eb4de5dcd$export$b55c4d4efb097c1c), ()=>({
            skeleton: (0, (0, parcelRequire("is7uC")).CalendarEmbedSkeleton),
            component: (0, (0, parcelRequire("is7uC")).CalendarEmbedSkeleton),
            entryPoint () {
                if (false) return undefined;
                return $2abc171a2b01be16$export$d154630e8966be91;
            },
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            ufoName: 'next-gen-calendar-embed'
        }));
    const $2abc171a2b01be16$export$d154630e8966be91 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d8251bf369abb7ad$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $2abc171a2b01be16$export$83b1b9036cc7961a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c4f64c4eb4de5dcd$export$d6730f103a4ad844), ()=>({
            skeleton: (0, (0, parcelRequire("is7uC")).CalendarSkeleton),
            component: (0, (0, parcelRequire("is7uC")).CalendarSkeleton),
            entryPoint () {
                if (false) return undefined;
                return $2abc171a2b01be16$export$d154630e8966be91;
            },
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ],
            ufoName: 'next-gen-calendar'
        }));
    var $ffza4;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $koWFd;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $eae3d589575bf64f$export$c5589046ee2a390d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
        path: '/jira/software/projects/:projectKey/form/:formId/builder',
        exact: true
    };
    var $5PD5h;
    var $e7bC3;
    const $c07fcdd97b2971f3$export$e8dede7671fad23d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $eae3d589575bf64f$export$c5589046ee2a390d), ()=>({
            ufoName: 'next-gen-form-builder',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $6bbae009e0a4162e$export$a4c73b2a16981930), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $6bbae009e0a4162e$export$2076234d7fde1717)
            ],
            afterPaint: [
                (0, $a96ac2d599fb8faa$export$258fcd204933dd75)
            ]
        }));
    var $ffza4;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $koWFd;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $8a4fe24690c451f7$export$a46217d369231a5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM),
        path: '/jira/software/projects/:projectKey/form',
        exact: true
    };
    var $5PD5h;
    var $e7bC3;
    const $17db4816c5775fc6$export$563e3b39911993a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8a4fe24690c451f7$export$a46217d369231a5), ()=>({
            ufoName: 'next-gen-form',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $7513c2d92a0c1be5$export$7234abc5d81adb58), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7513c2d92a0c1be5$export$240a58749ebba091)
            ],
            afterPaint: [
                (0, $6bbae009e0a4162e$export$2076234d7fde1717)
            ]
        }));
    var $ffza4;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $aa997c99ae3f3555$export$75b28ee1c7f02f00 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
        path: '/jira/software/projects/:projectKey/form/:formId',
        exact: true
    };
    const $3e2bc0f3ee8b3d3b$export$752724866670c36 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $aa997c99ae3f3555$export$75b28ee1c7f02f00), ()=>({
            ufoName: 'next-gen-form-submit',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $a96ac2d599fb8faa$export$4258f48cc65dca00), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $a96ac2d599fb8faa$export$258fcd204933dd75)
            ]
        }));
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $bef6f7dee26f8872$export$2328fed7ebee3cce = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS),
        exact: true,
        path: '/jira/software/projects/:projectKey/goals'
    };
    var $5PD5h;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f4f250cf13a0bcf2$export$69b07a7049b7beab = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Aupt"))), {
        moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
    });
    var $f4f250cf13a0bcf2$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f4f250cf13a0bcf2$export$69b07a7049b7beab,
            pageId: `atlas-goals-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $b91813a6c321b4f0$export$d3fcc412edfa2068 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $bef6f7dee26f8872$export$2328fed7ebee3cce), ()=>({
            component: (0, $f4f250cf13a0bcf2$export$2e2bcd8739ae039),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ]
        }));
    var $ffza4;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $dAmbh;
    var $g4ZHz;
    var $iNzEe;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $8179d3d41cbbed07$export$f3a5b1b732315e13 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST),
        path: '/jira/software/projects/:projectKey/list'
    };
    const $8179d3d41cbbed07$export$70dd8df584442004 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_EMBED),
        path: '/jira/software/projects/:projectKey/list/embed'
    };
    var $5PD5h;
    var $e7bC3;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $435c36ebe30f5714$export$26b97a235767fc3c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5AKg6"))), {
        moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
    });
    const $435c36ebe30f5714$export$8c61f5f5c58f351f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5lA3L"))), {
        moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
    });
    const $435c36ebe30f5714$export$422a3a028ae77ad3 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $435c36ebe30f5714$export$26b97a235767fc3c,
            pageId: `next-gen-list-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $435c36ebe30f5714$export$4a0539d19a2e2694 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $435c36ebe30f5714$export$8c61f5f5c58f351f,
            pageId: `next-gen-list-${match.params.boardId || ''}-embed`,
            shouldShowSpinner: false
        });
    const $8c2860a002a4fb1b$var$getListProjectResources = ()=>[
            (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
            (0, (0, parcelRequire("iNzEe")).navigationResource),
            (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
    const $8c2860a002a4fb1b$export$4425668b2cd90292 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $093e9fa498e2d713$export$6be4f10150ff6073),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8c2860a002a4fb1b$export$f30a66efa682bf2d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8179d3d41cbbed07$export$f3a5b1b732315e13), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $435c36ebe30f5714$export$422a3a028ae77ad3), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, $a38265b6f9242f57$export$cbc3335f7a517046),
            entryPoint () {
                return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? $8c2860a002a4fb1b$export$4425668b2cd90292 : undefined;
            },
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...$8c2860a002a4fb1b$var$getListProjectResources()
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $435c36ebe30f5714$export$26b97a235767fc3c)
            ],
            ufoName: 'next-gen-list'
        }));
    const $8c2860a002a4fb1b$export$1099e0e49394fa9a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8179d3d41cbbed07$export$70dd8df584442004), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $435c36ebe30f5714$export$4a0539d19a2e2694), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, $a38265b6f9242f57$export$2638f1c98fe91c13),
            entryPoint () {
                return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? $8c2860a002a4fb1b$export$4425668b2cd90292 : undefined;
            },
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$8c2860a002a4fb1b$var$getListProjectResources()
            ],
            forPaint: [
                (0, $435c36ebe30f5714$export$8c61f5f5c58f351f)
            ],
            ufoName: 'next-gen-list-embed'
        }));
    var $ffza4;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $1b36n;
    var $a3OKn;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $bATyw;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $ifLyg;
    var $gNStA;
    var $5lsNZ;
    var $65Ltd;
    const $b3b6cc1efadfe03b$export$5a84dbc6e86abbed = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REQUESTS),
        path: '/jira/software/projects/:projectKey/requests'
    };
    const $b3b6cc1efadfe03b$export$e45e557c8c37bcea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/requests'
    };
    var $lHYIV;
    var $5PD5h;
    var $e7bC3;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $ab2f1a53fc8de961$export$2e2bcd8739ae039 = (pageIdPrefix, { params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
        const { projectKey: projectKey, issueKey: issueKey } = params;
        let pageId = '';
        try {
            pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
        } catch  {
            pageId = pageIdPrefix;
        }
        return pageId;
    };
    const $bc75567830629fd0$export$3b235a8105f91b2b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fuWlC"))), {
        moduleId: "./src/packages/software/requests/requests-page/src/index.tsx"
    });
    const $bc75567830629fd0$export$b357b5f614f36f9a = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bc75567830629fd0$export$3b235a8105f91b2b,
            pageId: (0, $ab2f1a53fc8de961$export$2e2bcd8739ae039)('next-gen-requests', match, query),
            shouldShowSpinner: false
        });
    const $bc75567830629fd0$export$f6b20eb362411299 = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bc75567830629fd0$export$3b235a8105f91b2b,
            pageId: (0, $ab2f1a53fc8de961$export$2e2bcd8739ae039)('classic-requests', match, query),
            shouldShowSpinner: false
        });
    const $494b6205f04c7d39$var$isRequestsTabEnabled = ()=>{
        const requestTabFFValue = (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('growth.discovery-of-jsm-requests-tab.experiment', 'control', [
            'sticky',
            'not-enrolled-sticky',
            'non-sticky',
            'not-enrolled-non-sticky',
            'control',
            'not-enrolled'
        ]);
        return requestTabFFValue === 'sticky' || requestTabFFValue === 'non-sticky';
    };
    const $494b6205f04c7d39$var$getCommonProjectResources = ()=>[
            (0, (0, parcelRequire("ifLyg")).issueNavigatorRelayResource),
            (0, (0, parcelRequire("ifLyg")).issueNavigatorFilterRelayResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), (0, (0, parcelRequire("a3OKn")).sidebarProjectIssuesResource)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), (0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource)),
            (0, (0, parcelRequire("1b36n")).staticSidebarDefaultPINFiltersResource)
        ];
    const $494b6205f04c7d39$var$getCommonProject = ()=>({
            apdexIgnoreParams: [
                'issueKey'
            ],
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            resources: [
                ...$494b6205f04c7d39$var$getCommonProjectResources()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $bc75567830629fd0$export$3b235a8105f91b2b)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ]
        });
    const $494b6205f04c7d39$export$fe880b76c2e8d7cf = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b3b6cc1efadfe03b$export$5a84dbc6e86abbed), ()=>({
            ...$494b6205f04c7d39$var$getCommonProject(),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)($494b6205f04c7d39$var$isRequestsTabEnabled, (0, $bc75567830629fd0$export$b357b5f614f36f9a), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            ufoName: 'next-gen-requests'
        }));
    const $494b6205f04c7d39$export$db399ba51c2e38a6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b3b6cc1efadfe03b$export$e45e557c8c37bcea), ()=>({
            ...$494b6205f04c7d39$var$getCommonProject(),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)($494b6205f04c7d39$var$isRequestsTabEnabled, (0, $bc75567830629fd0$export$f6b20eb362411299), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            ufoName: 'classic-requests'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lmyls;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $jsFU4;
    var $65Ltd;
    const $11f30805918c6c16$export$a4a573c36fc75b30 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP),
        path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
    };
    var $lm7AC;
    var $5PD5h;
    var $e7bC3;
    var $dIdda = parcelRequire("dIdda");
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $fba9adf99f1ad42b$export$1339c847cf4ab57 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gFf95"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $fba9adf99f1ad42b$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fba9adf99f1ad42b$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $f9f5d14d16dfafed$export$dd8650bb193f860b = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
        const queryParams = new URLSearchParams(query).toString();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
                hash: '',
                search: queryParams
            }
        });
    };
    const $f9f5d14d16dfafed$export$c1d875e34d537389 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $11f30805918c6c16$export$a4a573c36fc75b30), ()=>({
            component: $f9f5d14d16dfafed$export$dd8650bb193f860b,
            skeleton: (0, (0, parcelRequire("lm7AC")).RoadmapSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                (0, (0, parcelRequire("jsFU4")).nextGenRoadmapResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-roadmap-early-entry'
                ]
            },
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $fba9adf99f1ad42b$export$1339c847cf4ab57)
            ],
            ufoName: 'next-gen-roadmap'
        }));
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $63f9b7ea3e0b13b0$export$c6629202e90df62a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
        path: '/jira/software/projects/:projectKey/summary'
    };
    var $5PD5h;
    var $e7bC3;
    const $6558dfd987f061ce$export$a2560b0baf928c49 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $63f9b7ea3e0b13b0$export$c6629202e90df62a), ()=>({
            ufoName: 'next-gen-summary',
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_jsw_summary_page', (0, $d82700466a756427$export$893608e1a22999b9), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d82700466a756427$export$68c09444cc6f2843)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY)),
                    teamName: 'Helios - Reports'
                }
            }
        }));
    var $ffza4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $dxCvy;
    var $jsFU4;
    var $7GnDe;
    var $65Ltd;
    const $3f6f4b13cca02c21$export$d25dafcda96d5af9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
    };
    var $lm7AC;
    var $5PD5h;
    var $e7bC3;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $faefef5a329d510c$export$1339c847cf4ab57 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gFf95"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $faefef5a329d510c$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $faefef5a329d510c$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $31385a75e55d4e4a$export$ace6a996c7e99f3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3f6f4b13cca02c21$export$d25dafcda96d5af9), ()=>({
            component: (0, $faefef5a329d510c$export$2e2bcd8739ae039),
            skeleton: (0, (0, parcelRequire("lm7AC")).RoadmapSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("jsFU4")).nextGenRoadmapResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-roadmap-early-entry'
                ]
            },
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $faefef5a329d510c$export$1339c847cf4ab57)
            ],
            ufoName: 'next-gen-roadmap'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $kt0pG;
    var $5lsNZ;
    var $aE7PK;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $aadf76d7366fa419$exports = {};
    $aadf76d7366fa419$exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();
    const $eef94ee10d7cccdd$export$b3661a594ba34350 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aadf76d7366fa419$exports)))
        });
    var $5PD5h;
    var $e7bC3;
    var $dIdda = parcelRequire("dIdda");
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5cbf8f752618c8e3$export$2d31f5f47e6584e0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hvTZA"))), {
        moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
    });
    const $5cbf8f752618c8e3$export$231cc5186b991031 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5cbf8f752618c8e3$export$2d31f5f47e6584e0,
            pageId: "version-detail",
            shouldShowSpinner: false
        });
    const $9c57977169cc077f$var$VersionDetailPageLegacyRedirect = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
        if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
        });
    };
    const $9c57977169cc077f$export$c97dabcfe9d495fa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aE7PK")).softwareVersionDetailRoute), ()=>({
            component: (0, $5cbf8f752618c8e3$export$231cc5186b991031),
            skeleton: (0, $eef94ee10d7cccdd$export$b3661a594ba34350),
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("kt0pG")).versionDetailsRelayResourceCustom),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $5cbf8f752618c8e3$export$2d31f5f47e6584e0)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $9c57977169cc077f$export$83102a6097008c79 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aE7PK")).softwareVersionDetailRouteEmbed), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_release_smartlink_embed', (0, $5cbf8f752618c8e3$export$231cc5186b991031), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, $eef94ee10d7cccdd$export$b3661a594ba34350),
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            navigation: {
                sidebar: null,
                horizontal: undefined
            },
            resources: [
                (0, (0, parcelRequire("kt0pG")).versionDetailsRelayResourceCustom),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, $5cbf8f752618c8e3$export$2d31f5f47e6584e0)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $9c57977169cc077f$export$28d16aae32969765 = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        path: '/projects/:projectKey/versions/:versionId'
    }, ()=>({
            component: $9c57977169cc077f$var$VersionDetailPageLegacyRedirect,
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $5cbf8f752618c8e3$export$2d31f5f47e6584e0)
            ]
        }));
    const $9c57977169cc077f$export$f29aafdff734071c = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT),
        path: '/browse/:projectKey/fixforversion/:versionId'
    }, ()=>({
            component: $9c57977169cc077f$var$VersionDetailPageLegacyRedirect,
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $5cbf8f752618c8e3$export$2d31f5f47e6584e0)
            ]
        }));
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $dIdda = parcelRequire("dIdda");
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $e8677532a1aaea76$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $e8677532a1aaea76$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
    var $ebyGx = parcelRequire("ebyGx");
    const $4ad36038fa160dbe$var$PLAN = 'planning';
    const $4ad36038fa160dbe$var$REPORTING = 'reporting';
    const $4ad36038fa160dbe$var$REPORTS = 'reports';
    const $4ad36038fa160dbe$var$constructUrlForView = (url, view, searchResult)=>{
        if (view.startsWith($4ad36038fa160dbe$var$PLAN)) return `${url}/backlog`;
        if (view.startsWith($4ad36038fa160dbe$var$REPORTING) || view.startsWith($4ad36038fa160dbe$var$REPORTS)) {
            if (searchResult.report) return `${url}/reports/${searchResult.report}`;
            return `${url}/reports`;
        }
        return url;
    };
    const $4ad36038fa160dbe$var$KNOWN_KEYS = [
        'rapidView',
        'projectKey',
        'view',
        'report'
    ];
    const $4ad36038fa160dbe$var$forwardUnknownQueryParams = (url, queryParams)=>{
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify(Object.entries(queryParams).filter(([k])=>!$4ad36038fa160dbe$var$KNOWN_KEYS.includes(k)).reduce((result, [k, v])=>({
                [k]: v,
                ...result
            }), {}));
        if (query) return `${url}?${query}`;
        return url;
    };
    const $4ad36038fa160dbe$export$8c47088cd9b527ba = (location)=>{
        const searchResult = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
        if (searchResult.view) return $4ad36038fa160dbe$var$forwardUnknownQueryParams($4ad36038fa160dbe$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
        return $4ad36038fa160dbe$var$forwardUnknownQueryParams(url, searchResult);
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $fadca415ac9d888e$export$1339c847cf4ab57 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gFf95"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $fadca415ac9d888e$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fadca415ac9d888e$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $ebyGx = parcelRequire("ebyGx");
    const $8d5a6727ab17b6ba$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $e02d9e74ba3f4d5c$export$4beafd9dbad29bff = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("492p0"))), {
        moduleId: "./src/packages/spa-apps/code/src/index.tsx"
    });
    const $e02d9e74ba3f4d5c$export$d9e8184332f86b53 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e02d9e74ba3f4d5c$export$4beafd9dbad29bff,
            pageId: `next-gen-code-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $e02d9e74ba3f4d5c$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e02d9e74ba3f4d5c$export$4beafd9dbad29bff,
            pageId: `classic-code-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $51e496184ed5259a$export$10cd1e761434952 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2rEkP"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/burndown/src/index.tsx"
    });
    var $51e496184ed5259a$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $51e496184ed5259a$export$10cd1e761434952,
            pageId: `next-gen-reports-burndown-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2f0cf451fae61f8d$export$2ae7ab3b633c1d15 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4W8bb"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/burnup/src/index.tsx"
    });
    var $2f0cf451fae61f8d$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f0cf451fae61f8d$export$2ae7ab3b633c1d15,
            pageId: `next-gen-reports-burnup-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a8fc70484e9dc624$export$3b0b331107fce76 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fdH6B"))), {
        moduleId: "./src/packages/spa-apps/control-report/src/index.tsx"
    });
    const $a8fc70484e9dc624$export$90d0561918744b3b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a8fc70484e9dc624$export$3b0b331107fce76,
            pageId: "controlReportNextGen",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d11158d5657ed65b$export$c588973e5bd18a8d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fYO6O"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/cumulative/src/index.tsx"
    });
    var $d11158d5657ed65b$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d11158d5657ed65b$export$c588973e5bd18a8d,
            pageId: `next-gen-reports-cumulative-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $494bd3c8d60b6ff9$export$956f830ed027f1fb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8ZMAu")), {
        moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
    });
    const $494bd3c8d60b6ff9$export$e16ce0656a74a015 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $494bd3c8d60b6ff9$export$956f830ed027f1fb,
            pageId: "cycleTimeReportNextGen",
            shouldShowSpinner: true
        });
    const $494bd3c8d60b6ff9$export$237924ba64065cc3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $494bd3c8d60b6ff9$export$956f830ed027f1fb,
            pageId: "cycleTimeReportClassic",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2f62bb5293f966a6$export$5113b2b19ec1fb53 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2yRGG")), {
        moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
    });
    const $2f62bb5293f966a6$export$e2db9c7426cdb53 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f62bb5293f966a6$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportNextGen",
            shouldShowSpinner: true
        });
    const $2f62bb5293f966a6$export$655707e8ae1053d3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f62bb5293f966a6$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportClassic",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5b9a94bde6be5ad0$export$dbd12c5c20c26961 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eQoM0"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/overview/src/index.tsx"
    });
    var $5b9a94bde6be5ad0$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5b9a94bde6be5ad0$export$dbd12c5c20c26961,
            pageId: `next-gen-reports-overview-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $29d7a4515738ef63$export$a2ca519c668b2f72 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h3sjI"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index.tsx"
    });
    var $29d7a4515738ef63$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $29d7a4515738ef63$export$a2ca519c668b2f72,
            pageId: `next-gen-reports-velocity-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $1f4b902ae477a058$var$SoftwareNextgenRedirectComponent = ({ location: location })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: (0, $4ad36038fa160dbe$export$8c47088cd9b527ba)(location)
        });
    const $1f4b902ae477a058$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
        const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify(restQuery)
            }
        });
    };
    const $1f4b902ae477a058$export$688b56fcbc2637ac = [
        (0, $ccb682e3f2b95fd8$export$ff8632c8a0f5d984),
        (0, $ccb682e3f2b95fd8$export$2964ea1cdd5afa39),
        (0, $d6d069823c19bbe2$export$7cd14dee22609378),
        (0, $d6d069823c19bbe2$export$a5f8ba02d2755510),
        (0, $c07fcdd97b2971f3$export$e8dede7671fad23d),
        (0, $17db4816c5775fc6$export$563e3b39911993a0),
        (0, $3e2bc0f3ee8b3d3b$export$752724866670c36),
        (0, $b91813a6c321b4f0$export$d3fcc412edfa2068),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$5b818a6914ca8376), ()=>({
                ufoName: 'software-reports.burnup-chart',
                component: (0, $2f0cf451fae61f8d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2f0cf451fae61f8d$export$2ae7ab3b633c1d15)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$cde83a6497756848), ()=>({
                ufoName: 'software-reports.velocity-report',
                component: (0, $29d7a4515738ef63$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $29d7a4515738ef63$export$a2ca519c668b2f72)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$3c48ddd40d00b0d2), ()=>({
                ufoName: 'software-reports.cumulative-flow-diagram',
                component: (0, $d11158d5657ed65b$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d11158d5657ed65b$export$c588973e5bd18a8d)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$e0d8c26cb1430ae4), ()=>({
                ufoName: 'software-reports.burndown-chart',
                component: (0, $51e496184ed5259a$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $51e496184ed5259a$export$10cd1e761434952)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$c777bb8f2591081), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $494bd3c8d60b6ff9$export$e16ce0656a74a015)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $494bd3c8d60b6ff9$export$956f830ed027f1fb)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$bbf45ab0423b990), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $2f62bb5293f966a6$export$e2db9c7426cdb53)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2f62bb5293f966a6$export$5113b2b19ec1fb53)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$8c91815cd4b1c078), ()=>({
                ufoName: 'software-reports.control-chart',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_enable_avp_control_chart', (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $a8fc70484e9dc624$export$90d0561918744b3b)), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $a8fc70484e9dc624$export$3b0b331107fce76)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL)),
                        teamName: 'helios-reports'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$5bf75a5d8c554930), ()=>({
                component: (0, $5b9a94bde6be5ad0$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5b9a94bde6be5ad0$export$dbd12c5c20c26961)
                ],
                ufoName: 'software-reports.overview'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$6072946fe7f2d45a), ()=>({
                component: $1f4b902ae477a058$var$SoftwareNextgenRedirectComponent,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $ccb682e3f2b95fd8$export$bd9ede4ec384f41d)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$9d24fc75b0f1d9a0), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $e02d9e74ba3f4d5c$export$d9e8184332f86b53)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutCode),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("iZ82x")).codePageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e02d9e74ba3f4d5c$export$4beafd9dbad29bff)
                ],
                ufoName: 'next-gen-code'
            })),
        (0, $1bbbe61aca30e3ab$export$a8dcfae475505e7a),
        (0, $6558dfd987f061ce$export$a2560b0baf928c49),
        (0, $2cdb997b770c0bb4$export$7e5ccb20ad8e1612),
        (0, $9db212062a348ac3$export$7db4d910357a4d89),
        (0, $9c57977169cc077f$export$83102a6097008c79),
        (0, $9c57977169cc077f$export$c97dabcfe9d495fa),
        (0, $9c57977169cc077f$export$28d16aae32969765),
        (0, $9c57977169cc077f$export$f29aafdff734071c),
        (0, $494b6205f04c7d39$export$fe880b76c2e8d7cf),
        (0, $494b6205f04c7d39$export$db399ba51c2e38a6),
        (0, $31385a75e55d4e4a$export$ace6a996c7e99f3),
        (0, $f9f5d14d16dfafed$export$c1d875e34d537389),
        (0, $2abc171a2b01be16$export$24fc07c22f0d06),
        (0, $2abc171a2b01be16$export$83b1b9036cc7961a),
        (0, $8c2860a002a4fb1b$export$1099e0e49394fa9a),
        (0, $8c2860a002a4fb1b$export$f30a66efa682bf2d),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1126b5bd57f5ad9d$export$866215abd09c0f4d), ()=>({
                component: $1f4b902ae477a058$var$SoftwareTimelineLegacyRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $fadca415ac9d888e$export$1339c847cf4ab57)
                ]
            })),
        (0, $9e60de4e7ff199f0$export$fd29243dbe4103)
    ];
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $e2179af5de02be12$export$830cd0c207772936 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE)}-redirect`,
        path: '/projects/:projectKey',
        query: [
            'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
        ]
    };
    const $e2179af5de02be12$export$534a7ac096cb1da2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
        path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
    };
    var $kfztd;
    var $5PD5h;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $f4de23917d090f8e$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $aa55fbc557add2b7$export$3a9c3ff70731bdd6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8xFuS"))), {
        moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
    });
    const $aa55fbc557add2b7$export$6ffd640c3062d976 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $f4de23917d090f8e$export$8a3df560509448b8), {
            page: "/on-call-schedule"
        });
    var $aa55fbc557add2b7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $aa55fbc557add2b7$export$3a9c3ff70731bdd6,
            pageId: "opsgenie-schedule",
            shouldShowSpinner: true
        });
    const $d33ce51d8c4b9036$export$f128c1c4a1f0d631 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e2179af5de02be12$export$830cd0c207772936), ()=>({
            component: !false ? (0, $aa55fbc557add2b7$export$6ffd640c3062d976) : (0, $aa55fbc557add2b7$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $aa55fbc557add2b7$export$3a9c3ff70731bdd6)
            ],
            isRedirect: true
        }));
    const $d33ce51d8c4b9036$export$924db6cf10ba8696 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e2179af5de02be12$export$534a7ac096cb1da2), ()=>({
            ufoName: 'project-opsgenie-schedule',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $aa55fbc557add2b7$export$2e2bcd8739ae039)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $aa55fbc557add2b7$export$3a9c3ff70731bdd6)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $6s1PB;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $5UHoB;
    var $bHhiy;
    var $3RJkv;
    var $54b5G;
    var $6Z2mh;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7f2f7b5455866fc1$var$LazyPeopleProfiles = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2Qbtr"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/people-profiles/src/index.tsx"
    });
    const $7f2f7b5455866fc1$export$9e44232fa48ba2ee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7f2f7b5455866fc1$var$LazyPeopleProfiles,
            pageId: "people-profiles",
            shouldShowSpinner: true
        });
    const $7f2f7b5455866fc1$export$219b6cc00b2f91a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("54b5G")).peopleProfilesRoute), ()=>({
            component: $7f2f7b5455866fc1$export$9e44232fa48ba2ee,
            layout: (0, (0, parcelRequire("5UHoB")).layoutWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, (0, parcelRequire("6Z2mh")).rightSidebarsLayout), (0, (0, parcelRequire("2BrOV")).globalLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f2f7b5455866fc1$var$LazyPeopleProfiles
            ],
            ufoName: 'people-profiles'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $1Xcuw;
    parcelRequire("jxRF2");
    var $ldKOT;
    var $ffza4;
    var $3H5ry;
    var $co1wz;
    var $2BrOV;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("gzRSC")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
    });
    const $8fc6117fdc2ce1b9$var$PersonalSettingsSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "personalSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar, null));
    var $8fc6117fdc2ce1b9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($8fc6117fdc2ce1b9$var$PersonalSettingsSidebar);
    var $1C2yb;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $eOlBz;
    var $ipmBb;
    var $gNStA;
    var $cojyC;
    var $7OYJs;
    var $7P45F;
    var $eufEc;
    var $fEDBv;
    const $0e73b796ef7555dc$export$44d710abd316d1f1 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("fSgLp")), {
            moduleId: "fe0c927e"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    pageAndProject: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, parcelRequire("7P45F")).default,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId
                }
            })
    });
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5daf430235f9fc0a$var$LazyLegacyPersonalSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jwMPq"))), {
        moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$personalSettingsNotificationsEntryPointPage = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $0e73b796ef7555dc$export$44d710abd316d1f1),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).NOTIFICATIONS
    });
    const $5daf430235f9fc0a$var$LazyGeneralPersonalSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1QXuJ"))), {
        moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9Rv37"))), {
        moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$checkConsolidationOnRouteDependency = (dependencies)=>{
        const { data: data } = dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734];
        return (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(data);
    };
    const $5daf430235f9fc0a$export$31dadfd5bc64c9c9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyLegacyPersonalSettings,
            pageId: "personal-settings",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$export$81bedf006ef32751 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyGeneralPersonalSettings,
            pageId: "personal-settings-general",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$export$e30af76ba1def364 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings,
            pageId: "personal-settings-notifications",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$var$getLabsResources = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource))
        ];
    const $5daf430235f9fc0a$export$89646e32fa7698db = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cojyC")).legacyPersonalSettingsRoute), ()=>({
            component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                    to: (0, (0, parcelRequire("1C2yb")).GENERAL_PERSONAL_SETTINGS_PATH)
                }),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("1Xcuw")).createContactsResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("1Xcuw")).createNotificationPreferencesResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("ldKOT")).eocUserResource),
                (0, (0, parcelRequire("1Xcuw")).createMuteResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("1Xcuw")).createQuietHoursResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("1Xcuw")).createForwardingRulesResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                ...$5daf430235f9fc0a$var$getLabsResources()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5daf430235f9fc0a$var$LazyLegacyPersonalSettings
            ]
        }));
    const $5daf430235f9fc0a$export$e8b7e9281fc3db35 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cojyC")).generalPersonalSettingsRoute), ()=>({
            component: $5daf430235f9fc0a$export$81bedf006ef32751,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                sidebar: (0, $8fc6117fdc2ce1b9$export$2e2bcd8739ae039)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...$5daf430235f9fc0a$var$getLabsResources()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5daf430235f9fc0a$var$LazyGeneralPersonalSettings
            ]
        }));
    const $5daf430235f9fc0a$export$640c1b3b96c9032e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cojyC")).notificationsPersonalSettingsRoute), ()=>({
            component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                    to: (0, (0, parcelRequire("1C2yb")).getNotificationsPersonalSettingsPath)()
                }),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                sidebar: (0, $8fc6117fdc2ce1b9$export$2e2bcd8739ae039)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            pageId: 'personal-settings-notifications',
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('sea-1973-notifications-hub') ? $5daf430235f9fc0a$var$personalSettingsNotificationsEntryPointPage : undefined;
            }
        }));
    const $5daf430235f9fc0a$export$d604d3ad2662a845 = [
        $5daf430235f9fc0a$export$89646e32fa7698db,
        $5daf430235f9fc0a$export$e8b7e9281fc3db35,
        $5daf430235f9fc0a$export$640c1b3b96c9032e,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cojyC")).opsNotificationsPersonalSettingsRoute), ()=>({
                component: $5daf430235f9fc0a$export$e30af76ba1def364,
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                    sidebar: (0, $8fc6117fdc2ce1b9$export$2e2bcd8739ae039)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("1Xcuw")).createContactsResource)(),
                    (0, (0, parcelRequire("1Xcuw")).createNotificationPreferencesResource)(),
                    (0, (0, parcelRequire("ldKOT")).eocUserResource),
                    (0, (0, parcelRequire("1Xcuw")).createMuteResource)(),
                    (0, (0, parcelRequire("1Xcuw")).createQuietHoursResource)(),
                    (0, (0, parcelRequire("1Xcuw")).createForwardingRulesResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings
                ]
            }))
    ];
    var $ffza4;
    var $4R6GH;
    var $2BrOV;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $cf474476a77ac482$export$54c333cd4ed2d70e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS),
        path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
        exact: true
    };
    const $cf474476a77ac482$export$d415b74f78a5f159 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS),
        path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
        query: [
            'projects?',
            'owners?'
        ],
        exact: true
    };
    const $cf474476a77ac482$export$6696e9deb45fe980 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING),
        path: '/welcome/discovery',
        exact: true
    };
    const $cf474476a77ac482$export$bfdcdf76e802d67d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_SETTINGS_ACCESS),
        path: '/jira/settings/products/jira-product-discovery/access',
        exact: true
    };
    const $cf474476a77ac482$export$d1d77b6a84982ab8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS),
        path: '/jira/settings/products/jira-product-discovery/global-fields',
        exact: true
    };
    const $cf474476a77ac482$export$32b1bc71501d2751 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_UNLICENSED),
        path: '/jira/polaris/unlicensed',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $dWQF5;
    var $7yO8g;
    var $5j7Th;
    var $9OXo1;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $1bfc7c5d195e4066$export$f7960e7dbd7e5265 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bQinH"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
    });
    const $1bfc7c5d195e4066$var$useJpdLicensed = ()=>{
        const context = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return context.licensedProducts['jira-product-discovery'];
    };
    const $1bfc7c5d195e4066$export$3bba33442c4150b1 = ()=>{
        const jpdLicensed = $1bfc7c5d195e4066$var$useJpdLicensed();
        const crossProjectViewsEnabled = (0, (0, parcelRequire("dWQF5")).useIsCrossProjectViewsEnabled)();
        if (!jpdLicensed) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira/polaris/unlicensed"
        });
        if (!crossProjectViewsEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bfc7c5d195e4066$export$f7960e7dbd7e5265,
            pageId: "async-polaris-collections",
            shouldShowSpinner: false
        });
    };
    var $1bfc7c5d195e4066$export$2e2bcd8739ae039 = $1bfc7c5d195e4066$export$3bba33442c4150b1;
    const $4aedad13e1b8926d$export$a034dc25c21d1029 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cf474476a77ac482$export$d415b74f78a5f159), ()=>({
            ufoName: 'jpd.collections',
            component: (0, $1bfc7c5d195e4066$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: (current, next)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4')) {
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('jpd-nav-v4-disable-page-refresh-to-collection')) {
                        if ((0, (0, parcelRequire("4R6GH")).fg)('jpd-sidebar-v4-for-roadmaps-overview')) {
                            if (current?.match?.params?.collectionUUID && !next?.match?.params?.collectionUUID || !current?.match?.params?.collectionUUID && next?.match?.params?.collectionUUID) return false;
                            return true;
                        }
                        if (current.match.path !== next.match.path) return false;
                    }
                }
                return true;
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1bfc7c5d195e4066$export$f7960e7dbd7e5265)
            ]
        }));
    var $ffza4;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $1Du13;
    var $1XrjK;
    const $501e6cef37d28e94$export$d5273c1a2e2fe212 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $9OXo1;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $9c1678c5da04bd73$export$3fd7cf4494189548 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jecZ6"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/ideas/src/index.tsx"
    });
    const $9c1678c5da04bd73$var$useJpdLicensed = ()=>{
        const context = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return context.licensedProducts['jira-product-discovery'];
    };
    const $9c1678c5da04bd73$export$8e495e768b5bbae5 = ()=>{
        const jpdLicensed = $9c1678c5da04bd73$var$useJpdLicensed();
        if (!jpdLicensed) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira/polaris/unlicensed"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9c1678c5da04bd73$export$3fd7cf4494189548,
            pageId: "async-polaris-ideas",
            shouldShowSpinner: false
        });
    };
    var $9c1678c5da04bd73$export$2e2bcd8739ae039 = $9c1678c5da04bd73$export$8e495e768b5bbae5;
    const $a75ffafad7078936$export$26631f98f007b2d2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cf474476a77ac482$export$54c333cd4ed2d70e), ()=>({
            ufoName: 'jpd.project',
            component: (0, $9c1678c5da04bd73$export$2e2bcd8739ae039),
            layout: (0, $501e6cef37d28e94$export$d5273c1a2e2fe212),
            canTransitionIn: (current, next)=>{
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && !(0, (0, parcelRequire("4R6GH")).fg)('jpd-nav-v4-disable-page-refresh-between-projects') && current?.match?.params?.projectKey && next?.match?.params?.projectKey && current.match.params.projectKey !== next.match.params.projectKey) return false;
                return true;
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9c1678c5da04bd73$export$3fd7cf4494189548)
            ]
        }));
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $aFVvc;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ff87f692d7c58a17$export$13889cc3ce0d5a93 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lqC9u"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
    });
    var $ff87f692d7c58a17$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff87f692d7c58a17$export$13889cc3ce0d5a93,
            pageId: "async-polaris-onboarding",
            shouldShowSpinner: false
        });
    const $9a1e9d5292b9a0dc$export$a297a71cb150e2af = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cf474476a77ac482$export$6696e9deb45fe980), ()=>({
            component: (0, $ff87f692d7c58a17$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: ()=>true,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ff87f692d7c58a17$export$13889cc3ce0d5a93)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ff4634525ed299f8$export$b66ea0dcd38af7f0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3K3ey"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
    });
    const $ff4634525ed299f8$export$d46497fe68b0853c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff4634525ed299f8$export$b66ea0dcd38af7f0,
            pageId: "async-polaris-settings-access",
            shouldShowSpinner: false
        });
    const $23f05070dbae84f0$export$9c0f51630c25c3d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cf474476a77ac482$export$bfdcdf76e802d67d), ()=>({
            component: (0, $ff4634525ed299f8$export$d46497fe68b0853c),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ff4634525ed299f8$export$b66ea0dcd38af7f0)
            ]
        }));
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $7946c690dff6c696$export$f2f24531058bc251 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("2mQtY")), {
            moduleId: "fead11bc"
        }),
        getPreloadProps: ()=>({})
    });
    const $dd5db072b96b7a9a$export$c682ebcd2290352f = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $7946c690dff6c696$export$f2f24531058bc251),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS
    });
    const $8b674ae9037c6c90$export$e29465c661741392 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cf474476a77ac482$export$d1d77b6a84982ab8), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            entryPoint () {
                return 0, $dd5db072b96b7a9a$export$c682ebcd2290352f;
            }
        }));
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $aFVvc;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $14579de685a40428$export$394984ca86b38b8f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("i4r4O"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
    });
    var $14579de685a40428$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $14579de685a40428$export$394984ca86b38b8f,
            pageId: "async-polaris-unlicensed",
            shouldShowSpinner: false
        });
    const $ed78a6ddbb53401e$export$f975154b9b0ce777 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cf474476a77ac482$export$32b1bc71501d2751), ()=>({
            component: (0, $14579de685a40428$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: ()=>true,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $14579de685a40428$export$394984ca86b38b8f)
            ]
        }));
    const $a401463e87f56f84$export$44e0cb320cb148ed = [
        (0, $4aedad13e1b8926d$export$a034dc25c21d1029),
        (0, $a75ffafad7078936$export$26631f98f007b2d2),
        (0, $9a1e9d5292b9a0dc$export$a297a71cb150e2af),
        (0, $23f05070dbae84f0$export$9c0f51630c25c3d),
        (0, $8b674ae9037c6c90$export$e29465c661741392),
        (0, $ed78a6ddbb53401e$export$f975154b9b0ce777)
    ];
    var $aIZdc;
    var $ffza4;
    var $7XYc4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $fd7d06f493534a34$export$7c663ddc097df1e8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS),
        path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2b1085a0fa643a34$export$1b7f55251df02fe9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jrDYR"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
    });
    var $2b1085a0fa643a34$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2b1085a0fa643a34$export$1b7f55251df02fe9,
            pageId: "products-jsm-chatops-and-video-tools",
            shouldShowSpinner: false
        });
    const $070da13ff0ee1dfd$export$8b55e723205ec5f3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fd7d06f493534a34$export$7c663ddc097df1e8), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $2b1085a0fa643a34$export$2e2bcd8739ae039)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2b1085a0fa643a34$export$1b7f55251df02fe9)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $08e82cf7bae7e6bd$export$6196bf08f64419da = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE),
        path: '/jira/settings/products/jira-service-management-compliance',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $62ef4b19010ca280$export$159d8c0e1862cd2b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("rdcLu"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
    });
    var $62ef4b19010ca280$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $62ef4b19010ca280$export$159d8c0e1862cd2b,
            pageId: "products-jsm-compliance",
            shouldShowSpinner: false
        });
    const $174710657e8d90a3$export$9cc9423a3967333b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $08e82cf7bae7e6bd$export$6196bf08f64419da), ()=>({
            component: (0, $62ef4b19010ca280$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $62ef4b19010ca280$export$159d8c0e1862cd2b)
            ],
            ufoName: 'admin.jsm-compliance'
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $4c00404c905ea593$export$2ad48fbde4743a97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION),
        path: '/jira/settings/products/jira-service-management-configuration',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2e07bdac6faf88fe$export$aa3f3d5ca376f305 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jkggo"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
    });
    var $2e07bdac6faf88fe$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e07bdac6faf88fe$export$aa3f3d5ca376f305,
            pageId: "products-jsm-configuration",
            shouldShowSpinner: false
        });
    const $774aaf4ac519071a$export$461f2b06a7a914db = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4c00404c905ea593$export$2ad48fbde4743a97), ()=>({
            ufoName: 'admin.jsm-configuration',
            component: (0, $2e07bdac6faf88fe$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2e07bdac6faf88fe$export$aa3f3d5ca376f305)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $39e09a7f118d3e37$export$6288bb6ea42acf0c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS),
        path: '/jira/settings/products/jira-service-management-email-requests',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f8c99b7a302373fc$export$4c9d90d0caf04d67 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9yb6w"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
    });
    var $f8c99b7a302373fc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f8c99b7a302373fc$export$4c9d90d0caf04d67,
            pageId: "products-jsm-email-requests",
            shouldShowSpinner: false
        });
    const $b3d6f3f852ae8387$export$3f8d7424a47f4dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $39e09a7f118d3e37$export$6288bb6ea42acf0c), ()=>({
            ufoName: 'admin.jsm-email-requests',
            component: (0, $f8c99b7a302373fc$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f8c99b7a302373fc$export$4c9d90d0caf04d67)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $a10f73d8276a285a$export$f98dec539fffaa15 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE),
        path: '/jira/settings/products/servicedesk/feature-usage',
        exact: true
    };
    var $gRzZD;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $48028ef535c008c9$export$5ad1c1e822bd5d34 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("Sfb3W"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
    });
    var $48028ef535c008c9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $48028ef535c008c9$export$5ad1c1e822bd5d34,
            pageId: "products-jsm-feature-usage",
            shouldShowSpinner: false
        });
    const $ff94c4ea1a42404b$export$80a3e4dda2dcd1a4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a10f73d8276a285a$export$f98dec539fffaa15), ()=>({
            component: (0, $48028ef535c008c9$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $48028ef535c008c9$export$5ad1c1e822bd5d34)
            ]
        }));
    var $dY89w;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $65cc4cb0f286e501$export$d92d66762943b115 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS),
        path: '/jira/settings/products/ops/reports/:dashboardId',
        exact: true
    };
    const $65cc4cb0f286e501$export$6b3539e7e6bf13e8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS),
        path: '/jira/settings/products/ops/reports',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $59dec6d88aab4fac$export$2404f0e35deca592 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jubOI")), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$d33ea1a773b744e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$66850ec5549adba6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$22253dbadb46d0cf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$d33ea1a773b744e,
            pageId: "async-jira-eoc-ops-reports-redirect",
            shouldShowSpinner: false
        });
    const $59dec6d88aab4fac$export$648ddf2d1f8b1c3f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$66850ec5549adba6,
            pageId: "async-jira-eoc-global-ops-reports",
            shouldShowSpinner: false
        });
    const $59dec6d88aab4fac$export$87e6a54b4f5dc91e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$2404f0e35deca592,
            pageId: "async-jira-eoc-ops-reports",
            shouldShowSpinner: false
        });
    const $299013a509e9e419$export$6a7fc41fb2523290 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $65cc4cb0f286e501$export$d92d66762943b115), ()=>({
            component: (0, $59dec6d88aab4fac$export$648ddf2d1f8b1c3f),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("dY89w")).opsReportsPermissionResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $59dec6d88aab4fac$export$d33ea1a773b744e)
            ]
        }));
    const $299013a509e9e419$export$6d6efd297963f785 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $65cc4cb0f286e501$export$6b3539e7e6bf13e8), ()=>({
            component: (0, $59dec6d88aab4fac$export$22253dbadb46d0cf),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("dY89w")).opsReportsPermissionResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $59dec6d88aab4fac$export$66850ec5549adba6)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $8638548b7cc72441$export$da6d538ddabade32 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS),
        path: '/jira/settings/products/jira-service-management-incident-management-tools',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $63d70171d6cec69e$export$f541eb9b8f00bfaf = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ajzu3"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
    });
    var $63d70171d6cec69e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $63d70171d6cec69e$export$f541eb9b8f00bfaf,
            pageId: "products-jsm-incident-management-tools",
            shouldShowSpinner: false
        });
    const $a9989e069a7a91c8$export$773f8e3318be1dd5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8638548b7cc72441$export$da6d538ddabade32), ()=>({
            component: (0, $63d70171d6cec69e$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $63d70171d6cec69e$export$f541eb9b8f00bfaf)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $f2c102c6218d46df$export$339486410c7a783f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS),
        path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $724367026054fd0c$export$a3e7bdc5dbf2d47e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kWvsB"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
    });
    var $724367026054fd0c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $724367026054fd0c$export$a3e7bdc5dbf2d47e,
            pageId: "products-jsm-kb-permissions",
            shouldShowSpinner: false
        });
    const $3f056040ba7b93df$export$717e134eb971b450 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f2c102c6218d46df$export$339486410c7a783f), ()=>({
            component: (0, $724367026054fd0c$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $724367026054fd0c$export$a3e7bdc5dbf2d47e)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $38BXB;
    var $7CBZS;
    var $6nu63;
    var $esddG;
    var $3RJkv;
    var $65Ltd;
    const $330184d7ffd51616$export$512fa30726e0049d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS),
        path: '/jira/settings/products/servicedesk/organizations',
        exact: true
    };
    const $330184d7ffd51616$export$3ae664dd3f8b73dc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS),
        path: '/jira/settings/products/servicedesk/organizations/:organizationId',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2542e7a566ffd224$export$ff149ceefa65ab70 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h6rJc"))), {
        moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/ui/index.tsx"
    });
    var $2542e7a566ffd224$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2542e7a566ffd224$export$ff149ceefa65ab70,
            pageId: "products-jsm-organization-details",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $34fecedc618348fb$export$410bec6e06fd4723 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jSPp3"))), {
        moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/ui/index.tsx"
    });
    var $34fecedc618348fb$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $34fecedc618348fb$export$410bec6e06fd4723,
            pageId: "products-jsm-organizations-list",
            shouldShowSpinner: true
        });
    const $5b81a6ea47f38625$export$34d843946d3894aa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $330184d7ffd51616$export$512fa30726e0049d), ()=>({
            ufoName: 'admin.jsm-organization-page-list',
            isRedirect: false,
            component: (0, $34fecedc618348fb$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("esddG")).productsJsmOrganizationListResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $34fecedc618348fb$export$410bec6e06fd4723)
            ]
        }));
    const $5b81a6ea47f38625$export$6d18fd46547afb8e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $330184d7ffd51616$export$3ae664dd3f8b73dc), ()=>({
            ufoName: 'admin.jsm-organization-page-list',
            isRedirect: false,
            component: (0, $2542e7a566ffd224$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                (0, (0, parcelRequire("6nu63")).productsJsmOrganizationMembersResource),
                (0, (0, parcelRequire("esddG")).productsJsmOrganizationListResource),
                (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2542e7a566ffd224$export$ff149ceefa65ab70)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $hwXlc;
    var $1vQWT;
    var $6xaw5;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $90ae9e1263695143$export$f9a32397033f9ced = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fW9gA"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
    });
    var $90ae9e1263695143$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $90ae9e1263695143$export$f9a32397033f9ced,
            pageId: "products-jsw-configuration",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $bad793b8f28a1de3$export$a4f5e12ce817cbb8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9WQFp"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
    });
    var $bad793b8f28a1de3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bad793b8f28a1de3$export$a4f5e12ce817cbb8,
            pageId: "products-jsw-storage-management",
            shouldShowSpinner: true
        });
    const $7730befe0883f27a$export$2f65b1ec4ed05f91 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6xaw5")).productsJswConfigurationRoute), ()=>({
            ufoName: 'admin.jsw-configuration',
            component: (0, $90ae9e1263695143$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("hwXlc")).productsJswConfigurationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $90ae9e1263695143$export$f9a32397033f9ced)
            ]
        }));
    const $7730befe0883f27a$export$c62ca2d3fcc552a5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6xaw5")).productsJswConfigurationStorageManagementRoute), ()=>({
            ufoName: 'admin.jsw-configuration.storage-management',
            component: (0, $bad793b8f28a1de3$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("1vQWT")).productsJswStorageManagementResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $bad793b8f28a1de3$export$a4f5e12ce817cbb8)
            ]
        }));
    var $ffza4;
    var $18N1t;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $65Ltd;
    const $db696cd0fbc4b110$var$CORE_PRODUCT = 'core';
    const $db696cd0fbc4b110$var$SOFTWARE_PRODUCT = 'software';
    const $db696cd0fbc4b110$var$SERVICE_DESK_PRODUCT = 'servicedesk';
    const $db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?';
    const $db696cd0fbc4b110$var$EXPORT_URL = '/jira/forms/export';
    const $db696cd0fbc4b110$var$ISSUE_FORMS_GENERAL_URL = '/jira/forms/create';
    const $db696cd0fbc4b110$export$158441d4f5c68fb9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK),
        path: $db696cd0fbc4b110$var$EXPORT_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$416ac492f873673a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK),
        path: $db696cd0fbc4b110$var$ISSUE_FORMS_GENERAL_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$574435c4e2f6a27e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK),
        path: `/jira/${$db696cd0fbc4b110$var$SERVICE_DESK_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    const $db696cd0fbc4b110$export$d48be9e2caaca83d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK),
        path: `/jira/${$db696cd0fbc4b110$var$SERVICE_DESK_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
    const $db696cd0fbc4b110$export$fb73a18f932b2c15 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS),
        path: $db696cd0fbc4b110$var$EXPORT_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$ec7e58425379b5d0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS),
        path: $db696cd0fbc4b110$var$ISSUE_FORMS_GENERAL_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$76ab9f3014b2e370 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS),
        path: `/jira/${$db696cd0fbc4b110$var$CORE_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    const $db696cd0fbc4b110$export$55ce393dc053bec4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS),
        path: `/jira/${$db696cd0fbc4b110$var$CORE_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
    const $db696cd0fbc4b110$export$4c5d46fe4c460ef9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE),
        path: $db696cd0fbc4b110$var$EXPORT_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$7de22a6665b73706 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE),
        path: $db696cd0fbc4b110$var$ISSUE_FORMS_GENERAL_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$c02a5b8ecf73713e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE),
        path: `/jira/${$db696cd0fbc4b110$var$SOFTWARE_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    const $db696cd0fbc4b110$export$cd0e54104fd6e37c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE),
        path: `/jira/${$db696cd0fbc4b110$var$SOFTWARE_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
    var $6Z2mh;
    var $e7bC3;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f012061ea42d3cc1$export$5e0d802a5d865352 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("a8m8q")), {
        moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
    });
    var $f012061ea42d3cc1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f012061ea42d3cc1$export$5e0d802a5d865352,
            pageId: "proforma-export",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $33e9f81a484baab5$export$a0f04dd35569e11 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9xG8v")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
    });
    var $33e9f81a484baab5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $33e9f81a484baab5$export$a0f04dd35569e11,
            pageId: "proforma-issue-forms-direct",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $321227a7cf9935db$export$22681210aaeb910f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jDCWS")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
    });
    var $321227a7cf9935db$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $321227a7cf9935db$export$22681210aaeb910f,
            pageId: "proforma-issue-forms-direct-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $06427390ad9a129c$export$7c16b09eb95f1c5d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("k5RCi")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
    });
    var $06427390ad9a129c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $06427390ad9a129c$export$7c16b09eb95f1c5d,
            pageId: "proforma-issue-forms-general",
            shouldShowSpinner: true
        });
    const $0946abf0655b0a01$export$786e5a0c86be676a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$158441d4f5c68fb9), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, $f012061ea42d3cc1$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f012061ea42d3cc1$export$5e0d802a5d865352)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$416ac492f873673a), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, $06427390ad9a129c$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $06427390ad9a129c$export$7c16b09eb95f1c5d)
                ],
                perfMetricKey: 'issue-forms-general'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$574435c4e2f6a27e), ()=>({
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, $33e9f81a484baab5$export$2e2bcd8739ae039),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                forPaint: [
                    (0, $33e9f81a484baab5$export$a0f04dd35569e11)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$d48be9e2caaca83d), ()=>({
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, $321227a7cf9935db$export$2e2bcd8739ae039),
                forPaint: [
                    (0, $321227a7cf9935db$export$22681210aaeb910f)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            }))
    ];
    const $0946abf0655b0a01$export$c4313dd46c85e3d3 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$fb73a18f932b2c15), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, $f012061ea42d3cc1$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f012061ea42d3cc1$export$5e0d802a5d865352)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$ec7e58425379b5d0), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, $06427390ad9a129c$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $06427390ad9a129c$export$7c16b09eb95f1c5d)
                ],
                perfMetricKey: 'issue-forms-general'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$76ab9f3014b2e370), ()=>({
                layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, $33e9f81a484baab5$export$2e2bcd8739ae039),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                forPaint: [
                    (0, $33e9f81a484baab5$export$a0f04dd35569e11)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$55ce393dc053bec4), ()=>({
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, $321227a7cf9935db$export$2e2bcd8739ae039),
                forPaint: [
                    (0, $321227a7cf9935db$export$22681210aaeb910f)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            }))
    ];
    const $0946abf0655b0a01$export$2e672712b21297b8 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$4c5d46fe4c460ef9), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, $f012061ea42d3cc1$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f012061ea42d3cc1$export$5e0d802a5d865352)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$7de22a6665b73706), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, $06427390ad9a129c$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $06427390ad9a129c$export$7c16b09eb95f1c5d)
                ],
                perfMetricKey: 'issue-forms-general'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$c02a5b8ecf73713e), ()=>({
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, $33e9f81a484baab5$export$2e2bcd8739ae039),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                forPaint: [
                    (0, $33e9f81a484baab5$export$a0f04dd35569e11)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db696cd0fbc4b110$export$cd0e54104fd6e37c), ()=>({
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, $321227a7cf9935db$export$2e2bcd8739ae039),
                forPaint: [
                    (0, $321227a7cf9935db$export$22681210aaeb910f)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            }))
    ];
    const $0946abf0655b0a01$export$2763334cca1560d7 = [
        ...$0946abf0655b0a01$export$786e5a0c86be676a,
        ...$0946abf0655b0a01$export$c4313dd46c85e3d3,
        ...$0946abf0655b0a01$export$2e672712b21297b8
    ];
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $xNRJ9;
    var $dxCvy;
    var $7GnDe;
    const $650eb9307abab3e5$export$1d7a0c194c3e83f2 = [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
    ];
    var $65Ltd;
    const $a98d732e7459c7e9$export$d370abe25253fa1b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS)}-redirect`,
        path: '/projects/:projectKey',
        query: (0, $650eb9307abab3e5$export$1d7a0c194c3e83f2)
    };
    const $a98d732e7459c7e9$export$f76189bea494b0b8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $d19b3848ac7d27f0$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $15d396b2dbadf93f$export$f32c20cfbc84532c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8IENq"))), {
        moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
    });
    const $15d396b2dbadf93f$export$9cf9ae84482ff18e = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/components${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $d19b3848ac7d27f0$export$8a3df560509448b8), {
            page: page
        });
    };
    var $15d396b2dbadf93f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $15d396b2dbadf93f$export$f32c20cfbc84532c,
            pageId: "project-components",
            shouldShowSpinner: false
        });
    const $5a7f40c2fa85616b$export$e60f53ff5ae626cd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a98d732e7459c7e9$export$d370abe25253fa1b), ()=>({
            component: !false ? (0, $15d396b2dbadf93f$export$9cf9ae84482ff18e) : (0, $15d396b2dbadf93f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $15d396b2dbadf93f$export$f32c20cfbc84532c)
            ],
            isRedirect: true
        }));
    const $5a7f40c2fa85616b$export$25cf284456caeeef = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a98d732e7459c7e9$export$f76189bea494b0b8), ()=>({
            ufoName: 'project-components-view',
            component: (0, $15d396b2dbadf93f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $15d396b2dbadf93f$export$f32c20cfbc84532c)
            ]
        }));
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $e511c19c3ef6a85a$export$ad23ddca45852d02 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_NOT_FOUND),
        path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
        exact: true
    };
    var $eufEc;
    var $fEDBv;
    const $ad3635ddd4e67df5$export$6ffa2f426ba3b25a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("kI4TI")), {
            moduleId: "51ed29c5"
        }),
        getPreloadProps: ()=>({})
    });
    const $1a16a8f438816e9f$export$f5a338b3fe5182bb = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $ad3635ddd4e67df5$export$6ffa2f426ba3b25a),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $1a16a8f438816e9f$export$beae48175e3016b8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e511c19c3ef6a85a$export$ad23ddca45852d02), ()=>({
            entryPoint () {
                return $1a16a8f438816e9f$export$f5a338b3fe5182bb;
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            pageId: 'project-not-found-page-id'
        }));
    var $ffza4;
    var $7XYc4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $c33c3f26abfe30a3$export$2d09da22e737849e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES)}-legacy`,
        path: '/projects/:projectKey',
        query: [
            'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
        ]
    };
    const $c33c3f26abfe30a3$export$54a218ca6d1c056a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
    };
    var $kfztd;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $b1c3ef54235a025d$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $4be66c9d92628f7f$export$c2115a649411f570 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5mCC5"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
    });
    const $4be66c9d92628f7f$export$7c3b1828ada63555 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $b1c3ef54235a025d$export$8a3df560509448b8), {
            page: "/pages"
        });
    var $4be66c9d92628f7f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4be66c9d92628f7f$export$c2115a649411f570,
            pageId: "project-pages",
            shouldShowSpinner: false
        });
    const $b563891c809eb2df$export$babf32528ef518e9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c33c3f26abfe30a3$export$2d09da22e737849e), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: !false ? (0, $4be66c9d92628f7f$export$7c3b1828ada63555) : (0, $4be66c9d92628f7f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4be66c9d92628f7f$export$c2115a649411f570)
            ],
            isRedirect: true
        }));
    const $b563891c809eb2df$export$6e8865417e6a38c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c33c3f26abfe30a3$export$54a218ca6d1c056a), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $4be66c9d92628f7f$export$2e2bcd8739ae039)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4be66c9d92628f7f$export$c2115a649411f570)
            ]
        }));
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $xNRJ9;
    var $dxCvy;
    var $7GnDe;
    var $dQmaR;
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $55786e10b01ad2e7$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $2794979f407c5b17$export$bb69d8c36391123 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8IENq"))), {
        moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
    });
    const $2794979f407c5b17$export$60cfbcd781a48d01 = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/settings/components${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $55786e10b01ad2e7$export$8a3df560509448b8), {
            page: page
        });
    };
    var $2794979f407c5b17$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2794979f407c5b17$export$bb69d8c36391123,
            pageId: "project-settings-components",
            shouldShowSpinner: true
        });
    const $5874d8a4e3dac2e3$export$72497f4e39dd0df4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dQmaR")).projectSettingsComponentsRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, $2794979f407c5b17$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2794979f407c5b17$export$bb69d8c36391123)
            ]
        }));
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $bC7QJ;
    var $7GnDe;
    var $94kpz;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4b5729de9815f9dc$export$9036da4fa9f7a66f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7J051"))), {
        moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
    });
    const $4b5729de9815f9dc$export$9aff7dab80671d9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4b5729de9815f9dc$export$9036da4fa9f7a66f,
            pageId: "relay-project-versions",
            shouldShowSpinner: false
        });
    const $c850b44c9898a4f7$export$4791201b4877aa5d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94kpz")).projectSettingsVersionsRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bC7QJ")).projectVersionsRelayResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, $4b5729de9815f9dc$export$9aff7dab80671d9),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4b5729de9815f9dc$export$9036da4fa9f7a66f)
            ]
        }));
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $7MCPm;
    var $4HPds;
    const $4352c9150dc3830e$export$56f9921db324f30 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4HPds")).projectsRedirectRoute), ()=>({
            isRedirect: true,
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $bC7QJ;
    const $91224398be5e0171$export$ad46185437bb571a = [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
    ];
    var $65Ltd;
    const $2adcd26097a17fc3$export$fb5516756c3eba40 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        path: '/projects/:projectKey',
        query: (0, $91224398be5e0171$export$ad46185437bb571a)
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $57f6bcf0c0b40681$export$9036da4fa9f7a66f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7J051"))), {
        moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
    });
    const $57f6bcf0c0b40681$export$9aff7dab80671d9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $57f6bcf0c0b40681$export$9036da4fa9f7a66f,
            pageId: "relay-project-versions",
            shouldShowSpinner: false
        });
    const $57f6bcf0c0b40681$export$982bc443ef89cc3f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2adcd26097a17fc3$export$fb5516756c3eba40), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bC7QJ")).projectVersionsRelayResource)
            ],
            component: $57f6bcf0c0b40681$export$9aff7dab80671d9,
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $57f6bcf0c0b40681$export$9036da4fa9f7a66f
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $cSD7y;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $55f35adcbcfe2307$export$cb08569a5439c36a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ROVO_DEMAND_TESTS),
        path: '/jira/software/rovo/discover'
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ad2b1e4948a3529a$export$ad2594850aa1640c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4OVrg"))), {
        moduleId: "./src/packages/spa-apps/rovo-demand-tests/src/index.tsx"
    });
    const $ad2b1e4948a3529a$export$12d166f59b63486e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ad2b1e4948a3529a$export$ad2594850aa1640c,
            pageId: "rovo-demand-tests",
            shouldShowSpinner: false
        });
    const $ad2b1e4948a3529a$export$95ed5e2f774d3f79 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $55f35adcbcfe2307$export$cb08569a5439c36a), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_rovo_demand_tests_gate', $ad2b1e4948a3529a$export$12d166f59b63486e, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ad2b1e4948a3529a$export$ad2594850aa1640c
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $e4B7v;
    var $7fRd9;
    var $h4Vg7;
    var $6Z2mh;
    var $e9YVH;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $907c348c7aa50cd6$var$LazyServicedeskCustomerServiceEscalations = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dEz0W"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
    });
    const $907c348c7aa50cd6$export$1a08682f4847bb2f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $907c348c7aa50cd6$var$LazyServicedeskCustomerServiceEscalations,
            pageId: "spa-apps/servicedesk/customer-service-escalations",
            shouldShowSpinner: true
        });
    const $907c348c7aa50cd6$export$36a7c374f4474cc1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("h4Vg7")).escalationsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("e4B7v")).componentFilterResource),
                (0, (0, parcelRequire("7fRd9")).priorityFilterResource)
            ],
            component: $907c348c7aa50cd6$export$1a08682f4847bb2f,
            perfMetricKey: 'jsm-customer-service-escalations-component-load',
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $907c348c7aa50cd6$var$LazyServicedeskCustomerServiceEscalations
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                    teamName: 'boysenberry'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $c28aa1a42d481780$var$LazyDirectoryNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4P2oj")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
    });
    const $c28aa1a42d481780$export$a237f415539577a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-directory-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c28aa1a42d481780$var$LazyDirectoryNav, null));
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $7yABM;
    var $giJhw;
    var $6Z2mh;
    var $e9YVH;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $805e5a863a2a14d2$var$LazyServicedeskCustomerServiceProducts = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9N9XD"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
    });
    const $805e5a863a2a14d2$export$46ba99069f037d90 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $805e5a863a2a14d2$var$LazyServicedeskCustomerServiceProducts,
            pageId: "spa-apps/servicedesk/customer-service-products",
            shouldShowSpinner: true
        });
    const $805e5a863a2a14d2$export$8e015e39dbc90d0b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("giJhw")).productsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $c28aa1a42d481780$export$a237f415539577a5),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("7yABM")).customerServiceProductsQueryResource)
            ],
            component: $805e5a863a2a14d2$export$46ba99069f037d90,
            perfMetricKey: 'jsm-customer-service-products-component-load',
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $805e5a863a2a14d2$var$LazyServicedeskCustomerServiceProducts
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                    teamName: 'boysenberry'
                }
            }
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $eb1cb53bd08a56ff$export$b314ab31b2da625b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_AUTOMATION),
        path: '/jira/settings/automation',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $5f4113c49e08a927$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $e4cf560ebe587071$export$4189991a2992b828 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9P7lL"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
    });
    const $e4cf560ebe587071$export$7c85ddcd4f0a813f = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/automation${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5f4113c49e08a927$export$8a3df560509448b8), {
            page: page
        });
    };
    var $e4cf560ebe587071$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e4cf560ebe587071$export$4189991a2992b828,
            pageId: "global-automation",
            shouldShowSpinner: false
        });
    const $1257e9ea29a7eb00$export$4df9f9dcaf8565c9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $eb1cb53bd08a56ff$export$b314ab31b2da625b), ()=>({
            component: (0, $e4cf560ebe587071$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e4cf560ebe587071$export$4189991a2992b828)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $138051bf045948cb$export$5097bfaa68f86ca6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG),
        path: '/secure/admin/CmdbObjectFieldConfiguration'
    };
    var $gRzZD;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $03d0290def261ead$export$ccc6da5137e23637 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9F4l4"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
    });
    const $03d0290def261ead$export$8dfbe255f554ebab = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $03d0290def261ead$export$ccc6da5137e23637,
            pageId: "admin-pages-cmdb-field-config",
            shouldShowSpinner: true
        });
    const $02dde8a9c2dbcc64$export$c68a412f25295511 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $138051bf045948cb$export$5097bfaa68f86ca6), ()=>({
            ufoName: 'admin.cmdb-field-config',
            component: (0, $03d0290def261ead$export$8dfbe255f554ebab),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $03d0290def261ead$export$ccc6da5137e23637)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $ldGiq;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $e6898ce9887259a6$export$c0ee28def7ef8783 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS),
        path: '/secure/admin/oauth-credentials'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a25b27e0ebd790aa$export$101baa25055633e8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kmNep"))), {
        moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
    });
    var $a25b27e0ebd790aa$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a25b27e0ebd790aa$export$101baa25055633e8,
            pageId: "admin-oauth-credentials",
            shouldShowSpinner: true
        });
    const $1289356c16bfcb3d$export$d1c67ceb7c5e2d6a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e6898ce9887259a6$export$c0ee28def7ef8783), ()=>({
            component: (0, $a25b27e0ebd790aa$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("ldGiq")).adminOauthCredentialsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $a25b27e0ebd790aa$export$101baa25055633e8)
            ],
            ufoName: 'admin.oauth-credentials'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $7XYc4;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $c4yut;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $5lsNZ;
    var $65Ltd;
    const $e78715d128f3ead6$export$5e6c92d2f34c1e48 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING),
        path: '/welcome/software',
        exact: true
    };
    const $e78715d128f3ead6$export$c25273c48ccc0eb9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
        path: '/jira/software/projects/:projectKey/get-started',
        exact: true
    };
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $983d5942deafccf1$export$31e9f06d3389e445 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3aW4r"))), {
        moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
    });
    const $983d5942deafccf1$export$689f7402bb424709 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3YmAs"))), {
        moduleId: "./src/packages/spa-apps/onboarding/get-started/src/index.tsx"
    });
    const $983d5942deafccf1$export$ee768d69c6e3a8bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $983d5942deafccf1$export$31e9f06d3389e445,
            pageId: "software-onboarding",
            shouldShowSpinner: false
        });
    const $983d5942deafccf1$export$d11bafa06a0717e3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $983d5942deafccf1$export$689f7402bb424709,
            pageId: "onboarding-get-started",
            shouldShowSpinner: false
        });
    const $983d5942deafccf1$export$23e1ab8ae95bd3a8 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e78715d128f3ead6$export$5e6c92d2f34c1e48), ()=>({
                component: $983d5942deafccf1$export$ee768d69c6e3a8bd,
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("c4yut")).jswOnboardingResource),
                    (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
                ],
                forPaint: [
                    $983d5942deafccf1$export$31e9f06d3389e445
                ],
                canTransitionIn: ()=>false
            }))
    ];
    const $983d5942deafccf1$export$d06c2ab36705e562 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e78715d128f3ead6$export$c25273c48ccc0eb9), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_one_screen_onboarding_feature_gate'), $983d5942deafccf1$export$d11bafa06a0717e3, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $983d5942deafccf1$export$689f7402bb424709
                ],
                canTransitionIn: ()=>true,
                ufoName: 'software-onboarding-get-started'
            }))
    ];
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $1ff62763f0dba905$export$74ec9fecd42fa96e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
        path: '/secure/projects/trash',
        exact: true
    };
    const $1ff62763f0dba905$export$a788f0ca96b92194 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
        path: '/jira/settings/projects/trash',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $5oFIy;
    var $dIdda = parcelRequire("dIdda");
    var $70186afa73ef93b4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "projectsTrashRedirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira/settings/projects/trash"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $67a748fd05680154$export$dd65a8ee0a9ac24f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8xD9Z"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
    });
    var $67a748fd05680154$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $67a748fd05680154$export$dd65a8ee0a9ac24f,
            pageId: "trashed-projects",
            shouldShowSpinner: true
        });
    const $06c044741f640b75$export$27d1f352c2f7acae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1ff62763f0dba905$export$74ec9fecd42fa96e), ()=>({
            ufoName: 'admin.trashed-projects',
            component: (0, $70186afa73ef93b4$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $67a748fd05680154$export$dd65a8ee0a9ac24f)
            ],
            isRedirect: true
        }));
    const $06c044741f640b75$export$f52136d9a0848792 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1ff62763f0dba905$export$a788f0ca96b92194), ()=>({
            ufoName: 'admin.trashed-projects',
            component: (0, $67a748fd05680154$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $67a748fd05680154$export$dd65a8ee0a9ac24f)
            ]
        }));
    var $2G9Bk;
    var $65Ltd;
    const $1d680cf55b0c704c$export$b0b13170cadf6395 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_USER_SEGMENTATION),
        path: '/jira/get-started',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $16f27a0ded4f6683$export$bf9c9e0729c919f5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6SBG5"))), {
        moduleId: "./src/packages/user-segmentation/src/index.tsx"
    });
    const $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $16f27a0ded4f6683$export$bf9c9e0729c919f5,
            pageId: "user-segmentation",
            shouldShowSpinner: true
        });
    const $a13d3834c7078910$export$2af76482b576a135 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1d680cf55b0c704c$export$b0b13170cadf6395), ()=>({
            ufoName: 'user-segmentation',
            component: (0, $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            forPaint: [
                (0, $16f27a0ded4f6683$export$bf9c9e0729c919f5)
            ]
        }));
    var $anXSE;
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $e5fa341423bb8a9b$export$146910ddc36bf151 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR),
        path: '/jira/contact-administrator'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $817988e9accf1b9b$export$bf75747a931b9a2b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kClDI"))), {
        moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
    });
    var $817988e9accf1b9b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $817988e9accf1b9b$export$bf75747a931b9a2b,
            pageId: "jira-admin-pages-contact-administrator",
            shouldShowSpinner: true
        });
    const $b98b121482cf4795$export$1ca91576d82f7098 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e5fa341423bb8a9b$export$146910ddc36bf151), ()=>({
                ufoName: 'admin.contact-administrator',
                component: (0, $817988e9accf1b9b$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $817988e9accf1b9b$export$bf75747a931b9a2b)
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $co1wz;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $dmx0y;
    var $65Ltd;
    const $a565fcc59d27b628$export$aed294a4a292b909 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG),
        path: '/jira/settings/system/notification-logs',
        exact: true
    };
    const $25a34f05175c2102$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
            "metadata": {},
            "name": "uiNotificationLogsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $25a34f05175c2102$export$2e2bcd8739ae039 = $25a34f05175c2102$var$node;
    var $eufEc;
    var $fEDBv;
    const $e96cd1acff95af13$export$818d841e00bb3749 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("7Z4b7")), {
            moduleId: "d533cc53"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    notificationLogs: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $25a34f05175c2102$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectIds: context?.query?.projectId,
                            notificationType: 'INTERNAL_NOTIFICATION',
                            notificationActionType: 'USER_INVITE',
                            recipientId: ''
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId
                }
            })
    });
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $6fee6dc25a79db2c$var$emailNotificationsLogEntryPointPage = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $e96cd1acff95af13$export$818d841e00bb3749),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS
    });
    const $6fee6dc25a79db2c$export$b2f1a46be2e3ed3f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7Z4b7"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
    });
    const $6fee6dc25a79db2c$var$NotificationLogs = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6fee6dc25a79db2c$export$b2f1a46be2e3ed3f,
            pageId: "Notification Logs",
            shouldShowSpinner: false
        });
    const $6fee6dc25a79db2c$export$e3943daecc3985cb = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a565fcc59d27b628$export$aed294a4a292b909), ()=>({
                component: $6fee6dc25a79db2c$var$NotificationLogs,
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $6fee6dc25a79db2c$export$b2f1a46be2e3ed3f
                ],
                pageId: 'admin-settings-email-notifications-log',
                entryPoint () {
                    return (0, (0, parcelRequire("co1wz")).ff)('platform.jlove-pulsar.jlovep-423-jsw-notification-logs-ui') ? $6fee6dc25a79db2c$var$emailNotificationsLogEntryPointPage : undefined;
                }
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $241a7261277af7f6$export$17c79100fc4c65a1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EXTERNAL_IMPORT),
        path: '/jira/settings/system/external-import'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7b72a6c6c5d8947e$var$LazyExternalImport = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hPbJ3")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
    });
    var $7b72a6c6c5d8947e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7b72a6c6c5d8947e$var$LazyExternalImport,
            pageId: "external-import-general",
            shouldShowSpinner: false
        });
    const $19995aa55a23ac9a$export$c535ef4656da2cd9 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $241a7261277af7f6$export$17c79100fc4c65a1), ()=>({
                component: (0, $7b72a6c6c5d8947e$export$2e2bcd8739ae039),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $cSD7y;
    var $4R6GH;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $kiD5R;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $66a7722b5d13dfaf$export$236ce89eb737f752 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS),
        path: '/secure/admin/global-permissions'
    };
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2a846114d3db2310$export$a97b1349c011eb4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lvXmc"))), {
        moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
    });
    const $2a846114d3db2310$export$a8d149dea7df681c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2a846114d3db2310$export$a97b1349c011eb4,
            pageId: "jira-global-permissions",
            shouldShowSpinner: true
        });
    const $2a846114d3db2310$export$db45b991e5ee3460 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $66a7722b5d13dfaf$export$236ce89eb737f752), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('olympus-global-permissions-fe-modernisation', $2a846114d3db2310$export$a8d149dea7df681c, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("kiD5R")).globalPermissionsResource)
                ],
                canTransitionIn: ()=>(0, (0, parcelRequire("4R6GH")).fg)('olympus-global-permissions-fe-modernisation'),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $2a846114d3db2310$export$a97b1349c011eb4
                ],
                meta: {
                    reporting: {
                        id: 'GlobalPermissions',
                        packageName: 'jiraAdminPagesGlobalPermissions',
                        teamName: 'olympus'
                    }
                }
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $g87MG;
    var $6oOqs;
    var $hjmEZ;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $eAsaT;
    var $7OYJs;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l44QS"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
    });
    var $1c0ab549b6b1a06b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd,
            pageId: "jira-admin-pages-issue-hierarchy-directory",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $651db9488b9701c8$export$611728a54ba37830 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("j6iNi"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
    });
    var $651db9488b9701c8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $651db9488b9701c8$export$611728a54ba37830,
            pageId: "jira-admin-pages-issue-type-schemes-directory",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3e26a0063e6eb003$export$661e1bf38bb82270 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6pB0J"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
    });
    var $3e26a0063e6eb003$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3e26a0063e6eb003$export$661e1bf38bb82270,
            pageId: "jira-admin-pages-issue-types-directory",
            shouldShowSpinner: true
        });
    const $9d816d99a525ba0f$export$84bb32992a534053 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAsaT")).globalSettingsIssueHierarchyRoute), ()=>({
                ufoName: 'global-admin.issues.issue-hierarchy-config',
                component: (0, $1c0ab549b6b1a06b$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAsaT")).globalSettingsIssueHierarchyRedirectRoute), ()=>({
                component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                        to: "/jira/settings/issues/issue-hierarchy"
                    }),
                isRedirect: true,
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAsaT")).globalSettingsIssueTypesRoute), ()=>({
                ufoName: 'global-admin.issues.issue-types',
                component: (0, $3e26a0063e6eb003$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("hjmEZ")).issueTypesResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3e26a0063e6eb003$export$661e1bf38bb82270)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAsaT")).globalSettingsIssueTypesSchemesRoute), ()=>({
                ufoName: 'global-admin.issues.view-issue-type-schemes',
                component: (0, $651db9488b9701c8$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("6oOqs")).default)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $651db9488b9701c8$export$611728a54ba37830)
                ]
            }))
    ];
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $jKASa;
    var $3RJkv;
    var $65Ltd;
    const $f767c9cdabaf9069$export$6395086ce7e72e37 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS),
        path: '/jira/settings/products/servicedesk/authentication',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a330db909964048e$export$6cd59b0135f3fe86 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("k66vx"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
    });
    var $a330db909964048e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a330db909964048e$export$6cd59b0135f3fe86,
            pageId: "spa-apps/admin-pages/jsm-authentication-settings",
            shouldShowSpinner: false
        });
    const $b7091904c7d6d31b$export$f2cf147a5850af7e = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f767c9cdabaf9069$export$6395086ce7e72e37), ()=>({
                ufoName: 'admin.jsm-authentication-settings',
                component: (0, $a330db909964048e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("2Fj5v")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                    (0, (0, parcelRequire("jKASa")).jsmCustomerAuthenticationSettingsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $a330db909964048e$export$6cd59b0135f3fe86)
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $6IgbX;
    var $cuwqc;
    var $3RJkv;
    var $65Ltd;
    const $f9c60351ae5f8e90$export$b97e3b6231be8149 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS),
        path: '/jira/settings/products/servicedesk/customer-access',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ea4a7aec6cf36e8a$export$1ae94ce2cc225b3d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9y0dD"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
    });
    const $ea4a7aec6cf36e8a$export$fce5e73f94a6878 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ea4a7aec6cf36e8a$export$1ae94ce2cc225b3d,
            pageId: "spa-apps/admin-pages/customer-access",
            shouldShowSpinner: false
        });
    const $ea4a7aec6cf36e8a$export$15a1d95a862eb682 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f9c60351ae5f8e90$export$b97e3b6231be8149), ()=>({
                ufoName: 'admin.jsm-customer-access',
                component: $ea4a7aec6cf36e8a$export$fce5e73f94a6878,
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("2Fj5v")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                    (0, (0, parcelRequire("cuwqc")).jsmGlobalCustomerAccessSettingsResource),
                    (0, (0, parcelRequire("6IgbX")).jsmGlobalCustomerAccessAffectedProjectsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $ea4a7aec6cf36e8a$export$1ae94ce2cc225b3d
                ]
            }))
    ];
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $0b0fe41df29a2377$export$774dc60e785b8ae8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH),
        path: '/jira/settings/issues/new-issue-search-transition'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4f134f463ddf0416$export$aa5e318abd957ad = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("d7PBt"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
    });
    var $4f134f463ddf0416$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4f134f463ddf0416$export$aa5e318abd957ad,
            pageId: "jira-admin-pages-new-issue-search-transition",
            shouldShowSpinner: true
        });
    const $f11b5b6d5b73c87f$export$8f3854f8ef3c4116 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0b0fe41df29a2377$export$774dc60e785b8ae8), ()=>({
                ufoName: 'admin.new-issue-search-transition',
                component: (0, $4f134f463ddf0416$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4f134f463ddf0416$export$aa5e318abd957ad)
                ],
                canTransitionIn: ()=>true
            }))
    ];
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $d8FBC;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $1aAOt;
    var $65Ltd;
    const $0d9145f2b68b8850$export$2b269dcf51f5a4d3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL),
        path: '/jira/settings/system/send-email'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0240d4f2c2b35825$export$416f8039fbf50bea = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fg3s6"))), {
        moduleId: "./src/packages/admin-pages/bulk-email/src/index.tsx"
    });
    var $0240d4f2c2b35825$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0240d4f2c2b35825$export$416f8039fbf50bea,
            pageId: "jira-admin-pages-bulk-email",
            shouldShowSpinner: true
        });
    const $aae9f30dff1362f9$export$d16163932c3babaa = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0d9145f2b68b8850$export$2b269dcf51f5a4d3), ()=>({
                component: (0, $0240d4f2c2b35825$export$2e2bcd8739ae039),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("d8FBC")).SidebarGlobalSettingsSystem)
                },
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("1aAOt")).getOfferingCatalogueFeaturesResource)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0240d4f2c2b35825$export$416f8039fbf50bea)
                ]
            }))
    ];
    var $ffza4;
    var $cSD7y;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $clE6J;
    var $65Ltd;
    const $9aee66b3178a7753$export$677fc3a2086479d2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW),
        path: '/jira/settings/system/performance/overview'
    };
    const $9aee66b3178a7753$export$d4f7a24791f8b506 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL),
        path: '/jira/settings/system/performance/metric/:metricKey'
    };
    const $9aee66b3178a7753$export$198b0dea5bcb104d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD),
        path: '/jira/settings/system/performance/metrics/customfield'
    };
    const $9aee66b3178a7753$export$a615b79ae9fb06e5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE),
        path: '/jira/settings/system/performance/metrics/issue'
    };
    const $9aee66b3178a7753$export$c81695f590e65a42 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR),
        path: '/jira/settings/system/performance/metrics/projectroleactor'
    };
    const $9aee66b3178a7753$export$c0d3487a9dc79ff3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP),
        path: '/jira/settings/system/performance/metrics/projectCleanup'
    };
    var $5lsNZ;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $416b07e85e5902e2$export$d323aa888b5be0c2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6WmO9"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
    });
    const $416b07e85e5902e2$export$446bf9be075b3cb = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $416b07e85e5902e2$export$d323aa888b5be0c2,
            pageId: "system-performance-metric-detail-custom-field",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cc878f5a65037830$export$e44cbefb7c57e031 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h0LCj"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
    });
    const $cc878f5a65037830$export$30b22d5292fcd86f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cc878f5a65037830$export$e44cbefb7c57e031,
            pageId: "system-performance-metric-detail-issue",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a4333be24d8fdde0$export$a02cb3bfa11d0dc0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jaOdX"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
    });
    const $a4333be24d8fdde0$export$2adb5abd6651c182 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a4333be24d8fdde0$export$a02cb3bfa11d0dc0,
            pageId: "system-performance-metric-detail-project-cleanup",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e00517ee35b4ce44$export$41ecfa31d3d81e1c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8bORg"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
    });
    const $e00517ee35b4ce44$export$3c58376b89706313 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e00517ee35b4ce44$export$41ecfa31d3d81e1c,
            pageId: "system-performance-metric-detail-project-role-actor",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $8zOmE;
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    const $a9257ec476fbe8e1$export$dda90f06f8afe9ec = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (match?.params?.metricKey) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
                metricKey: match.params.metricKey
            });
        }, [
            match?.params?.metricKey,
            createAnalyticsEvent
        ]);
        if (match == null || match.params == null || match.params.metricKey == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/system/performance/overview"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $53afac4f83d10b4d$export$17b4d4eaede5f445 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4Vh5b"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
    });
    var $53afac4f83d10b4d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $53afac4f83d10b4d$export$17b4d4eaede5f445,
            pageId: "system-performance-overview",
            shouldShowSpinner: true
        });
    const $075838c1f3f096db$export$98e757ecbae3f469 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9aee66b3178a7753$export$677fc3a2086479d2), ()=>({
                component: (0, $53afac4f83d10b4d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("clE6J")).metricsOverviewPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $53afac4f83d10b4d$export$17b4d4eaede5f445)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9aee66b3178a7753$export$d4f7a24791f8b506), ()=>({
                component: (0, $a9257ec476fbe8e1$export$dda90f06f8afe9ec),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9aee66b3178a7753$export$c0d3487a9dc79ff3), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('site-optimizer-project-cleanup', (0, $a4333be24d8fdde0$export$2adb5abd6651c182), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $a4333be24d8fdde0$export$a02cb3bfa11d0dc0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9aee66b3178a7753$export$198b0dea5bcb104d), ()=>({
                component: (0, $416b07e85e5902e2$export$446bf9be075b3cb),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $416b07e85e5902e2$export$d323aa888b5be0c2)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9aee66b3178a7753$export$a615b79ae9fb06e5), ()=>({
                component: (0, $cc878f5a65037830$export$30b22d5292fcd86f),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $cc878f5a65037830$export$e44cbefb7c57e031)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9aee66b3178a7753$export$c81695f590e65a42), ()=>({
                component: (0, $e00517ee35b4ce44$export$3c58376b89706313),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e00517ee35b4ce44$export$41ecfa31d3d81e1c)
                ]
            }))
    ];
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $1Sn7L;
    var $bFrLw;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $f357bbf21d1afc21$export$d57f448badd0561f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES),
        path: '/jira/settings/issues/permission-schemes/:schemeId'
    };
    const $f357bbf21d1afc21$export$ceade8e040291782 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES),
        path: '/jira/settings/issues/permission-schemes-new/:schemeId'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9fc866887d4bbe6b$export$4549705b02900c32 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8PQYZ"))), {
        moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
    });
    var $9fc866887d4bbe6b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9fc866887d4bbe6b$export$4549705b02900c32,
            pageId: "jira-edit-permission-scheme",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d6d274858940e39c$export$f7fcf8304eb17dda = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iqkTm"))), {
        moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
    });
    var $d6d274858940e39c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d6d274858940e39c$export$f7fcf8304eb17dda,
            pageId: "jira-permission-scheme",
            shouldShowSpinner: true
        });
    const $fb84735b34e76986$export$ac0fc473d7d21da1 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f357bbf21d1afc21$export$d57f448badd0561f), ()=>({
                ufoName: 'global-admin.issues.configure-permission-scheme',
                component: (0, $9fc866887d4bbe6b$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("1Sn7L")).editPermissionSchemePageResource)
                ],
                canTransitionIn: ()=>true,
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $9fc866887d4bbe6b$export$4549705b02900c32)
                ],
                meta: {
                    reporting: {
                        id: 'EditPermissionScheme',
                        packageName: 'jiraAdminPagesEditPermissionScheme',
                        teamName: 'olympus'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f357bbf21d1afc21$export$ceade8e040291782), ()=>({
                ufoName: 'global-admin.issues.configure-permission-scheme',
                component: (0, $d6d274858940e39c$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("bFrLw")).permissionSchemePageResource)
                ],
                canTransitionIn: ()=>true,
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d6d274858940e39c$export$f7fcf8304eb17dda)
                ],
                meta: {
                    reporting: {
                        id: 'PermissionScheme',
                        packageName: 'jiraAdminPagesPermissionScheme',
                        teamName: 'olympus'
                    }
                }
            }))
    ];
    var $cSD7y;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $bV6im;
    var $5lsNZ;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $bf15af7ed924092e$export$2b5843205130631c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fhPlz"))), {
        moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
    });
    const $bf15af7ed924092e$var$PrioritiesPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bf15af7ed924092e$export$2b5843205130631c,
            pageId: "jira-admin-pages-priorities",
            shouldShowSpinner: true
        });
    var $bf15af7ed924092e$export$2e2bcd8739ae039 = $bf15af7ed924092e$var$PrioritiesPage;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a7002d7e57e81458$export$20bb8a3b40a3add4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fKkNZ"))), {
        moduleId: "./src/packages/admin-pages/priority-schemes/src/ui/index.tsx"
    });
    var $a7002d7e57e81458$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a7002d7e57e81458$export$20bb8a3b40a3add4,
            pageId: "jira-admin-pages-priority-schemes",
            shouldShowSpinner: true
        });
    const $8bce8d2114fb1250$export$cd38898806de0f08 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bV6im")).globalSettingsIssuesPrioritiesRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('priorities_page_frontend_statsig', (0, $bf15af7ed924092e$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, $bf15af7ed924092e$export$2b5843205130631c)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bV6im")).globalSettingsIssuesPrioritySchemesRoute), ()=>({
                component: (0, $a7002d7e57e81458$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, $a7002d7e57e81458$export$20bb8a3b40a3add4)
                ]
            }))
    ];
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $24bfebea6d97ebdb$export$6633247975d81f28 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS),
        path: '/jira/settings/forms/data-connections'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $013d0419ad26989f$export$a81885366284dc75 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hKhMf"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
    });
    var $013d0419ad26989f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $013d0419ad26989f$export$a81885366284dc75,
            pageId: "jira-admin-pages-forms-data-connections",
            shouldShowSpinner: true
        });
    const $23186b60c86516d6$export$2763334cca1560d7 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $24bfebea6d97ebdb$export$6633247975d81f28), ()=>({
                component: (0, $013d0419ad26989f$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $013d0419ad26989f$export$a81885366284dc75)
                ]
            }))
    ];
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $614d0e8c921291fb$export$197fd5d0ee709ca4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS),
        path: '/jira/settings/issues/screens'
    };
    const $614d0e8c921291fb$export$3c5a0cf6ecc1bdf1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES),
        path: '/jira/settings/issues/screen-schemes'
    };
    const $614d0e8c921291fb$export$df93a4addc359237 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES),
        path: '/jira/settings/issues/issue-type-screen-schemes'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $73b6b725092289e9$export$350edfb57b335a57 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3itkj"))), {
        moduleId: "./src/packages/admin-pages/screens/issue-type-screen-schemes-page/src/index.tsx"
    });
    var $73b6b725092289e9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $73b6b725092289e9$export$350edfb57b335a57,
            pageId: "jira-admin-pages-issue-type-screen-schemes-page",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3b08a72bf07c6137$export$342ae41503f611f1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("in6By"))), {
        moduleId: "./src/packages/admin-pages/screens/screen-schemes-page/src/index.tsx"
    });
    var $3b08a72bf07c6137$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3b08a72bf07c6137$export$342ae41503f611f1,
            pageId: "jira-admin-pages-screen-schemes-page",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $38a54f3b8a5e1e01$export$f4e6d546d7f2894c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3tVs3"))), {
        moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
    });
    var $38a54f3b8a5e1e01$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $38a54f3b8a5e1e01$export$f4e6d546d7f2894c,
            pageId: "jira-admin-pages-screens-page",
            shouldShowSpinner: true
        });
    const $d40f7f84137250be$export$75afafbdb2230f9 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $614d0e8c921291fb$export$197fd5d0ee709ca4), ()=>({
                ufoName: 'global-admin.issues.screens',
                component: (0, $38a54f3b8a5e1e01$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $38a54f3b8a5e1e01$export$f4e6d546d7f2894c)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $614d0e8c921291fb$export$3c5a0cf6ecc1bdf1), ()=>({
                ufoName: 'global-admin.issues.screen-schemes',
                component: (0, $3b08a72bf07c6137$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3b08a72bf07c6137$export$342ae41503f611f1)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $614d0e8c921291fb$export$df93a4addc359237), ()=>({
                ufoName: 'global-admin.issues.issue-type-screen-schemes',
                component: (0, $73b6b725092289e9$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $73b6b725092289e9$export$350edfb57b335a57)
                ]
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $dmx0y;
    var $1ZpQo;
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $71a705d1d999c26b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/system/general-configuration"
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ece5afb522908971$export$c452a8c622781ccd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gtlim"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
    });
    var $ece5afb522908971$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ece5afb522908971$export$c452a8c622781ccd,
            pageId: "system-configuration-general",
            shouldShowSpinner: false
        });
    const $6e549c8f8c5cff26$export$e8714add09855505 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1ZpQo")).systemConfigurationRoute), ()=>({
                component: (0, $ece5afb522908971$export$2e2bcd8739ae039),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $ece5afb522908971$export$c452a8c622781ccd)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1ZpQo")).routeNamesSystemConfigurationRedirectRoute), ()=>({
                component: (0, $71a705d1d999c26b$export$2e2bcd8739ae039),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $09d3b2ebb43c55a6$export$20631ff3b13dafc0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER),
        path: '/jira/settings/system/ui/announcement-banner'
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $452e8bb8e23e6c4f$export$3c41e9fc9ec0d170 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lD0Ke"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
    });
    const $452e8bb8e23e6c4f$export$eb84257d269db72c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $452e8bb8e23e6c4f$export$3c41e9fc9ec0d170,
            pageId: "admin-pages-system-ui-announcement-banner",
            shouldShowSpinner: true
        });
    const $452e8bb8e23e6c4f$export$7b7dd85536177527 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $09d3b2ebb43c55a6$export$20631ff3b13dafc0), ()=>({
                ufoName: 'global-admin.system.ui.announcement-banner',
                component: $452e8bb8e23e6c4f$export$eb84257d269db72c,
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $452e8bb8e23e6c4f$export$3c41e9fc9ec0d170
                ]
            }))
    ];
    var $3aIZg;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $65Ltd;
    const $129e81677ea4bebe$export$9d533f08a4447cc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT),
        path: '/jira/settings/issues/workflows/:workflowId'
    };
    const $129e81677ea4bebe$export$f8f2a617a2f4d53 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
        path: '/jira/settings/issues/workflows'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $793ac7f9af5a2945$export$cb79ebb337a95317 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("atF3J"))), {
        moduleId: "./src/packages/admin-pages/workflows/edit-workflow/src/index.tsx"
    });
    var $793ac7f9af5a2945$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $793ac7f9af5a2945$export$cb79ebb337a95317,
            pageId: "jira-admin-pages-edit-workflow",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $fe432a8ece476800$export$4c64b4f1ecf22fc8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9VrFM"))), {
        moduleId: "./src/packages/admin-pages/workflows/list-workflows/src/index.tsx"
    });
    var $fe432a8ece476800$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fe432a8ece476800$export$4c64b4f1ecf22fc8,
            pageId: "jira-admin-pages-list-workflows",
            shouldShowSpinner: true
        });
    const $5b21375522489812$export$401ea91784469e3a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $129e81677ea4bebe$export$9d533f08a4447cc), ()=>({
                ufoName: 'global-admin.issues.edit-workflow',
                component: (0, $793ac7f9af5a2945$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $793ac7f9af5a2945$export$cb79ebb337a95317)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $129e81677ea4bebe$export$f8f2a617a2f4d53), ()=>({
                ufoName: 'global-admin.issues.view-workflows',
                component: (0, $fe432a8ece476800$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("3aIZg")).default)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $fe432a8ece476800$export$4c64b4f1ecf22fc8)
                ]
            }))
    ];
    const $e8fc18994c4f5903$export$c9b96dd6f5a7b454 = [
        ...(0, $d40f7f84137250be$export$75afafbdb2230f9),
        ...(0, $5b21375522489812$export$401ea91784469e3a),
        ...(0, $9d816d99a525ba0f$export$84bb32992a534053),
        ...(0, $b98b121482cf4795$export$1ca91576d82f7098),
        ...(0, $452e8bb8e23e6c4f$export$7b7dd85536177527),
        ...(0, $ea4a7aec6cf36e8a$export$15a1d95a862eb682),
        ...(0, $b7091904c7d6d31b$export$f2cf147a5850af7e),
        ...(0, $aae9f30dff1362f9$export$d16163932c3babaa),
        ...(0, $fb84735b34e76986$export$ac0fc473d7d21da1),
        ...(0, $23186b60c86516d6$export$2763334cca1560d7),
        ...(0, $f11b5b6d5b73c87f$export$8f3854f8ef3c4116),
        ...(0, $075838c1f3f096db$export$98e757ecbae3f469),
        ...(0, $8bce8d2114fb1250$export$cd38898806de0f08),
        ...(0, $2a846114d3db2310$export$db45b991e5ee3460),
        ...(0, $6e549c8f8c5cff26$export$e8714add09855505),
        ...(0, $19995aa55a23ac9a$export$c535ef4656da2cd9),
        ...(0, $6fee6dc25a79db2c$export$e3943daecc3985cb)
    ];
    var $ffza4;
    var $cSD7y;
    var $4R6GH;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $43189553e9fc21a2$export$ea77f88c1b841127 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("dbmHR")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
    });
    const $43189553e9fc21a2$var$HelpCenterSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "servicedeskProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($43189553e9fc21a2$export$ea77f88c1b841127, null)));
    $43189553e9fc21a2$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
    var $43189553e9fc21a2$export$2e2bcd8739ae039 = $43189553e9fc21a2$var$HelpCenterSettingsSidebar;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $7D8h0;
    var $5lsNZ;
    var $65Ltd;
    const $2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $2937f4e9b4a14692$export$f544881b6385f520 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS),
        path: $2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL,
        exact: true
    };
    const $2937f4e9b4a14692$export$8a784299dc7faaff = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/kb`,
        exact: true
    };
    const $2937f4e9b4a14692$export$88fcb9acf40a0827 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/customer-notifications`
    };
    const $2937f4e9b4a14692$export$4515288a48c62087 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/email`,
        exact: true
    };
    const $2937f4e9b4a14692$export$45b14c3ed47b2b3a = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_FORMS),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/forms`
    };
    const $2937f4e9b4a14692$export$31bd3e10c42460dc = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_FORM_EDIT),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/forms/:formId`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ce252471da0db8c1$export$b2b6550dec008a98 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9czCW"))), {
        moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
    });
    const $ce252471da0db8c1$export$2f2f18f57014444a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ce252471da0db8c1$export$b2b6550dec008a98,
            pageId: "help-center-settings-customer-notifications",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6353b69d503ce9ba$export$e090cd3a62343249 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dB8mZ")), {
        moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
    });
    const $6353b69d503ce9ba$export$962f20e752738967 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6353b69d503ce9ba$export$e090cd3a62343249,
            pageId: "help-center-settings-email",
            shouldShowSpinner: true
        });
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $dcaafae9dc3cdb4f$export$262512d610e494f8 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("acxar")), {
            moduleId: "d82eb4d8"
        }),
        getPreloadProps: ()=>{
            return {};
        }
    });
    const $73a7c9331a7a621d$export$2792cba2387cbc5c = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: $dcaafae9dc3cdb4f$export$262512d610e494f8,
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS
    });
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $dbea87a49a7edd6e$export$ce8253ab16579f12 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("iB2rz")), {
            moduleId: "c7a4dbb9"
        }),
        getPreloadProps: ()=>{
            return {};
        }
    });
    const $cf39360ee106b7b5$export$b50d944f3be2457f = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: $dbea87a49a7edd6e$export$ce8253ab16579f12,
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d84b744908886ed8$export$92983043c677b1b1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4Ftk1"))), {
        moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
    });
    const $d84b744908886ed8$export$c1d58cf9dc0a2ed3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d84b744908886ed8$export$92983043c677b1b1,
            pageId: "help-center-settings-knowledge-base",
            shouldShowSpinner: true
        });
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $dd054b5fe69a76d6$export$b7262fe486f4b412 = 'core';
    const $dd054b5fe69a76d6$export$2954328f6207617a = 'software';
    const $dd054b5fe69a76d6$export$5575497f0592ee94 = 'servicedesk';
    const $dd054b5fe69a76d6$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $dd054b5fe69a76d6$export$586756e5c0542a50 = (product)=>{
        if (product === $dd054b5fe69a76d6$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $dd054b5fe69a76d6$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5lsNZ;
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    const $44cb5391898ae9e8$export$2d8d895a0a0f636e = ()=>{
        const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
        const helpCenterSettingsEmail = (0, $2937f4e9b4a14692$export$4515288a48c62087).path.replace(':projectKey', projectKey);
        return projectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: helpCenterSettingsEmail,
            persistSearchParams: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5lsNZ")).default), null);
    };
    const $58e6269847de16de$var$navigation = {
        sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).HELP_CENTER_SETTINGS,
        menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS,
        sidebar: (0, $43189553e9fc21a2$export$2e2bcd8739ae039)
    };
    const $58e6269847de16de$export$c4a6a8e840f7c6b1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2937f4e9b4a14692$export$f544881b6385f520), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, $44cb5391898ae9e8$export$2d8d895a0a0f636e),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ],
            resources: [
                ...(0, $dd054b5fe69a76d6$export$586756e5c0542a50)((0, $dd054b5fe69a76d6$export$5575497f0592ee94))
            ]
        }));
    const $58e6269847de16de$export$caf568619a621961 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2937f4e9b4a14692$export$8a784299dc7faaff), ()=>({
            perfMetricKey: 'help-center-settings.kb',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, $d84b744908886ed8$export$c1d58cf9dc0a2ed3), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d84b744908886ed8$export$92983043c677b1b1)
            ],
            resources: [
                ...(0, $dd054b5fe69a76d6$export$586756e5c0542a50)((0, $dd054b5fe69a76d6$export$5575497f0592ee94)),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $58e6269847de16de$export$4e4f38417d267cf6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2937f4e9b4a14692$export$88fcb9acf40a0827), ()=>({
            perfMetricKey: 'help-center-settings.customer-notifications',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, $ce252471da0db8c1$export$2f2f18f57014444a), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ce252471da0db8c1$export$b2b6550dec008a98)
            ],
            resources: [
                ...(0, $dd054b5fe69a76d6$export$586756e5c0542a50)((0, $dd054b5fe69a76d6$export$5575497f0592ee94))
            ]
        }));
    const $58e6269847de16de$export$f95717dac47e4db3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2937f4e9b4a14692$export$4515288a48c62087), ()=>({
            perfMetricKey: 'help-center-settings.email',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, $6353b69d503ce9ba$export$962f20e752738967), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $6353b69d503ce9ba$export$e090cd3a62343249)
            ],
            resources: [
                ...(0, $dd054b5fe69a76d6$export$586756e5c0542a50)((0, $dd054b5fe69a76d6$export$5575497f0592ee94))
            ]
        }));
    const $58e6269847de16de$export$9a67aaae787c9f40 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2937f4e9b4a14692$export$45b14c3ed47b2b3a), ()=>({
            perfMetricKey: 'help-center-settings.forms',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("5lsNZ")).default),
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? (0, $cf39360ee106b7b5$export$b50d944f3be2457f) : undefined;
            },
            resources: [
                ...(0, $dd054b5fe69a76d6$export$586756e5c0542a50)((0, $dd054b5fe69a76d6$export$5575497f0592ee94)),
                (0, (0, parcelRequire("7D8h0")).formsResource)
            ]
        }));
    const $58e6269847de16de$export$1750cfcab794a07d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2937f4e9b4a14692$export$31bd3e10c42460dc), ()=>({
            perfMetricKey: 'help-center-settings.form-edit',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("5lsNZ")).default),
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? (0, $73a7c9331a7a621d$export$2792cba2387cbc5c) : undefined;
            },
            resources: [
                ...(0, $dd054b5fe69a76d6$export$586756e5c0542a50)((0, $dd054b5fe69a76d6$export$5575497f0592ee94))
            ]
        }));
    const $39416b69d8da58fe$export$633933bacdaefead = [
        (0, $58e6269847de16de$export$c4a6a8e840f7c6b1),
        (0, $58e6269847de16de$export$caf568619a621961),
        (0, $58e6269847de16de$export$4e4f38417d267cf6),
        (0, $58e6269847de16de$export$f95717dac47e4db3),
        (0, $58e6269847de16de$export$9a67aaae787c9f40),
        (0, $58e6269847de16de$export$1750cfcab794a07d)
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $18N1t;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $loy04;
    var $ggg5j;
    var $iEUaw;
    var $8rIQt;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $kJQXA;
    var $eOlBz;
    var $dxCvy;
    var $e7C7O;
    var $5lsNZ;
    var $65Ltd;
    const $f4a2c58264a33355$export$322fe16ec991f12 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT),
        path: '/jira/core/projects/:projectKey/settings'
    };
    const $f4a2c58264a33355$export$c3a32433c580b9ff = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES),
        path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
        exact: true
    };
    const $f4a2c58264a33355$export$7c4ee74641923239 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS),
        path: '/jira/core/projects/:projectKey/settings/fields',
        exact: true
    };
    const $f4a2c58264a33355$export$9e79ee307216071b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW),
        path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
        exact: true
    };
    const $f4a2c58264a33355$export$c7ac65fb0bbe767f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS),
        path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
        exact: true
    };
    const $f4a2c58264a33355$export$1c7e75ffaa491922 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS),
        path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
        exact: true
    };
    const $f4a2c58264a33355$export$14535b40530c8690 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS),
        path: '/jira/core/projects/:projectKey/settings/details',
        exact: true
    };
    const $f4a2c58264a33355$export$fe93051d5b7385a1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS),
        path: '/jira/core/projects/:projectKey/settings/access',
        exact: true
    };
    const $f4a2c58264a33355$export$59e3323ba0cc224a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT),
        path: '/jira/core/projects/:projectKey/settings/people',
        exact: true
    };
    const $f4a2c58264a33355$export$57fe8c5107a9c0de = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS),
        path: '/jira/core/projects/:projectKey/settings/forms',
        exact: true
    };
    const $f4a2c58264a33355$export$4e7ce7e6ced0f291 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER),
        path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
        exact: true
    };
    const $f4a2c58264a33355$export$65a4d727336c49f4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION),
        path: '/jira/core/projects/:projectKey/settings/automation'
    };
    const $f4a2c58264a33355$export$5437af2650f645e0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION),
        path: '/jira/core/projects/:projectKey/settings/automate'
    };
    const $f4a2c58264a33355$export$7aae1006c82a79c0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS),
        path: '/jira/core/projects/:projectKey/settings/data-classifications',
        exact: true
    };
    const $f4a2c58264a33355$export$a1ee80066685b98d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS),
        path: '/jira/core/projects/:projectKey/settings/notifications',
        exact: true
    };
    const $f4a2c58264a33355$export$56a8a0b88329b044 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS),
        path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
        exact: true
    };
    const $f4a2c58264a33355$export$b546589f1b048dc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL),
        path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    const $f4a2c58264a33355$export$b34160f55b6104e9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS),
        path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    const $f4a2c58264a33355$export$ba11c8f378a2c121 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS),
        path: '/jira/core/projects/:projectKey/settings/approvals',
        exact: true
    };
    var $d0oNj;
    var $eufEc;
    var $fEDBv;
    const $d1b68aa40690ad89$export$1389a6ddf34f642e = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("kXKUX")), {
            moduleId: "83e2f2c2"
        }),
        getPreloadProps: ()=>({})
    });
    const $baebbc2289a2b843$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
            "metadata": {},
            "name": "uiIssueNotificationLogsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $baebbc2289a2b843$export$2e2bcd8739ae039 = $baebbc2289a2b843$var$node;
    var $eufEc;
    var $fEDBv;
    const $6adcc3494d7c3774$export$97bbdefcbe0571ac = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("1Nsfq")), {
            moduleId: "b2136a4d"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    notificationLogs: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $baebbc2289a2b843$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectId: Number(context?.query?.projectId ?? 0),
                            notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId,
                    cloudId: tenantContext.cloudId,
                    projectIds: context?.query?.projectId,
                    projectKey: context?.match.params.projectKey
                }
            })
    });
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    var $5uXOq = parcelRequire("5uXOq");
    var $9QpK7;
    var $1J3t1;
    var $dIdda = parcelRequire("dIdda");
    const $646d86edb6dba940$var$ProjectSettingsRedirectNew = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/core/projects/${String(projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
        });
    };
    const $646d86edb6dba940$var$ProjectSettingsRedirectOld = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
        });
    const $646d86edb6dba940$export$72130cf40a3c3778 = (0, (0, parcelRequire("9QpK7")).componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $646d86edb6dba940$var$ProjectSettingsRedirectNew, $646d86edb6dba940$var$ProjectSettingsRedirectOld);
    const $f037ab3fb0896e94$var$approvalsProjectSettingsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d1b68aa40690ad89$export$1389a6ddf34f642e),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $f037ab3fb0896e94$var$emailNotificationsLogEntryPointPage = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $6adcc3494d7c3774$export$97bbdefcbe0571ac),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $f037ab3fb0896e94$var$getNavigationSidebarProjectResource = ()=>[
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
        ];
    const $f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("kJQXA")).navigationSidebarAutomationLegacyEnabledResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource),
            (0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource)
        ];
    const $f037ab3fb0896e94$var$LazyIssueTypeSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("61LFA"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$b6450e98f3b2e500 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyIssueTypeSettings,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    const $f037ab3fb0896e94$var$LazyFieldsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("NWARb"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$642e36be5f0881cd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyFieldsSettings,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l00Ww"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$2fc344606596921e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyConnectAppsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$a9e7f90b84deda9f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyConnectAppsSettings,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyConnectAppControlsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9RXCH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$ceddc4fc7b9c0729 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyConnectAppControlsSettings,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyDetailsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kVevk"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$3e8048d3cf2ba3fd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyDetailsSettings,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyPeopleSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b3T21"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$3026e5a52c747d2c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyPeopleSettings,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2Js68")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$4963607e49ab309f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9Saqg")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$c32892afcc1da510 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$132a1e91790bf469 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyDataClassificationsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2igd7"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$a325b082c894541b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyDataClassificationsSettings,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyNotificationsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3oy92"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
    });
    const $f037ab3fb0896e94$var$LazyNotificationsIssueLogs = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1Nsfq"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$36ba2f559d49a8f6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyNotificationsSettings,
            pageId: "project-settings-software-notifications",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$export$361bca0a4a18e111 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyNotificationsIssueLogs,
            pageId: "project-settings-software-notifications-issue-logs",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bm5Zl"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$90c2f52b54888c20 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$export$df1c02c3f28b7a95 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$322fe16ec991f12), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: (0, $646d86edb6dba940$export$72130cf40a3c3778),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $f037ab3fb0896e94$export$95ecbacf0120fcfd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$c3a32433c580b9ff), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$b6450e98f3b2e500,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyIssueTypeSettings
            ]
        }));
    const $f037ab3fb0896e94$export$8d8dff75124dcebc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$7c4ee74641923239), ()=>({
            ufoName: 'project-settings.fields.jwm-tmp',
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
            ],
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', $f037ab3fb0896e94$export$642e36be5f0881cd, (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyFieldsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$1dfd4811b9065dd6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$9e79ee307216071b), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$2fc344606596921e,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings
            ]
        }));
    const $f037ab3fb0896e94$export$c038a2892f34f1a9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$c7ac65fb0bbe767f), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$a9e7f90b84deda9f,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyConnectAppsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$7870a0b1630a504e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$1c7e75ffaa491922), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$ceddc4fc7b9c0729,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyConnectAppControlsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$438a330ccc1e7a91 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$14535b40530c8690), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$3e8048d3cf2ba3fd,
            skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyDetailsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$8188648c76953df0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$fe93051d5b7385a1), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$3026e5a52c747d2c,
            skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsAccessSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyPeopleSettings
            ],
            ufoName: 'project-settings.access'
        }));
    const $f037ab3fb0896e94$export$36e1851c22975fc0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$59e3323ba0cc224a), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                    to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                    push: false
                }),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyPeopleSettings
            ]
        }));
    const $f037ab3fb0896e94$export$5e9e27f116094fdf = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$57fe8c5107a9c0de), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$4963607e49ab309f,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms
            ],
            perfMetricKey: 'forms-settings'
        }));
    const $f037ab3fb0896e94$export$46d6b55ebf21ccc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$4e7ce7e6ced0f291), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$c32892afcc1da510,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder
            ],
            perfMetricKey: 'form-builder'
        }));
    const $f037ab3fb0896e94$export$a244870e56f5c9a3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$65a4d727336c49f4), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$132a1e91790bf469,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation
            ],
            ufoName: 'project-settings-automation-core'
        }));
    const $f037ab3fb0896e94$export$a2c8a6767edeeaed = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$5437af2650f645e0), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$132a1e91790bf469,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation
            ]
        }));
    const $f037ab3fb0896e94$export$cf5194c476e8bcdb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$7aae1006c82a79c0), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$a325b082c894541b,
            skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $f037ab3fb0896e94$export$ed481b03aa858542 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$a1ee80066685b98d), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$36ba2f559d49a8f6,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyNotificationsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$e562140c482cb0c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$56a8a0b88329b044), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$361bca0a4a18e111,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyNotificationsIssueLogs
            ],
            entryPoint () {
                return $f037ab3fb0896e94$var$emailNotificationsLogEntryPointPage;
            }
        }));
    const $f037ab3fb0896e94$export$da36a1671d868927 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$b546589f1b048dc), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$90c2f52b54888c20,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail
            ]
        }));
    const $f037ab3fb0896e94$export$1006fd9f5f02b1c2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$b34160f55b6104e9), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$b943f48844c671a5,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage
            ]
        }));
    const $f037ab3fb0896e94$export$728033a86ab68014 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f4a2c58264a33355$export$ba11c8f378a2c121), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            entryPoint () {
                return $f037ab3fb0896e94$var$approvalsProjectSettingsPageEntryPoint;
            }
        }));
    const $f037ab3fb0896e94$export$4bad3905623f839b = [
        $f037ab3fb0896e94$export$95ecbacf0120fcfd,
        $f037ab3fb0896e94$export$8d8dff75124dcebc,
        $f037ab3fb0896e94$export$1dfd4811b9065dd6,
        $f037ab3fb0896e94$export$7870a0b1630a504e,
        $f037ab3fb0896e94$export$c038a2892f34f1a9,
        $f037ab3fb0896e94$export$438a330ccc1e7a91,
        $f037ab3fb0896e94$export$8188648c76953df0,
        $f037ab3fb0896e94$export$36e1851c22975fc0,
        $f037ab3fb0896e94$export$5e9e27f116094fdf,
        $f037ab3fb0896e94$export$46d6b55ebf21ccc,
        $f037ab3fb0896e94$export$a2c8a6767edeeaed,
        $f037ab3fb0896e94$export$cf5194c476e8bcdb,
        $f037ab3fb0896e94$export$a244870e56f5c9a3,
        $f037ab3fb0896e94$export$ed481b03aa858542,
        $f037ab3fb0896e94$export$e562140c482cb0c,
        $f037ab3fb0896e94$export$da36a1671d868927,
        $f037ab3fb0896e94$export$1006fd9f5f02b1c2,
        $f037ab3fb0896e94$export$728033a86ab68014,
        $f037ab3fb0896e94$export$df1c02c3f28b7a95
    ];
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $cSD7y;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $gmE3I;
    var $2pT4g;
    var $dxCvy;
    var $e7C7O;
    var $cAofY;
    var $10cgn;
    var $8CwPO;
    var $6sNnq;
    var $gNStA;
    var $5lsNZ;
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $5lsNZ;
    var $2WHzH;
    var $6Z2mh;
    var $eufEc;
    var $fEDBv;
    const $7c46caae51932151$var$playbookEditViewEntryPoint = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("hfX5a")), {
            moduleId: "15e5be42"
        }),
        getPreloadProps: ({ context: context })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                extraProps: {
                    playbookId: context?.match.params.id || '__new__',
                    projectKey: projectKey
                },
                queries: {}
            };
        }
    });
    var $7c46caae51932151$export$2e2bcd8739ae039 = $7c46caae51932151$var$playbookEditViewEntryPoint;
    var $8fDOc;
    var $6YEEX;
    var $eufEc;
    var $fEDBv;
    const $787278c10397c75e$var$playbookListViewEntryPoint = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("8RxBf")), {
            moduleId: "a498670b"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            const { tab: tab = 'list' } = context.query;
            if (!projectKey) throw new Error('projectKey is required');
            const entryPoints = tab === 'logs' ? {
                preloadedPlaybookLogsEntryPoint: {
                    entryPoint: (0, (0, parcelRequire("6YEEX")).playbookLogsEntryPoint),
                    entryPointParams: {
                        cloudId: tenantContext.cloudId
                    }
                }
            } : {
                preloadedPlaybookListEntryPoint: {
                    entryPoint: (0, (0, parcelRequire("8fDOc")).playbookListEntryPoint),
                    entryPointParams: {
                        cloudId: tenantContext.cloudId
                    }
                }
            };
            return {
                extraProps: {
                    accountId: tenantContext.atlassianAccountId,
                    cloudId: tenantContext.cloudId,
                    projectId: context.query.projectId,
                    projectKey: context.match.params.projectKey
                },
                entryPoints: entryPoints
            };
        }
    });
    var $787278c10397c75e$export$2e2bcd8739ae039 = $787278c10397c75e$var$playbookListViewEntryPoint;
    const $89f595ea28ec651e$var$listEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $787278c10397c75e$export$2e2bcd8739ae039),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $89f595ea28ec651e$var$editEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $7c46caae51932151$export$2e2bcd8739ae039),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $89f595ea28ec651e$var$getServiceDeskRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            }
        });
    const $89f595ea28ec651e$export$89ee08578c593726 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2WHzH")).servicedeskPlaybooksListRoute), ()=>({
                ...$89f595ea28ec651e$var$getServiceDeskRoutesCommon(),
                entryPoint () {
                    return (0, (0, parcelRequire("4R6GH")).fg)('playbooks-in-jsm') ? $89f595ea28ec651e$var$listEntryPoint : undefined;
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: 'project-settings.playbooks.admin-list-view',
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_LIST)),
                        teamName: 'ITOps Phantom'
                    }
                },
                component: (0, (0, parcelRequire("5lsNZ")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                ufoName: 'playbook-list'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2WHzH")).servicedeskPlaybooksEditRoute), ()=>({
                ...$89f595ea28ec651e$var$getServiceDeskRoutesCommon(),
                entryPoint () {
                    return (0, (0, parcelRequire("4R6GH")).fg)('playbooks-in-jsm') ? $89f595ea28ec651e$var$editEntryPoint : undefined;
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: 'project-settings.playbooks.admin-edit-view',
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_EDIT)),
                        teamName: 'ITOps Phantom'
                    }
                },
                component: (0, (0, parcelRequire("5lsNZ")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                ufoName: 'playbook-edit'
            }))
    ];
    var $2VkCP;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $65Ltd;
    const $f11e25be7747a3f0$export$5575497f0592ee94 = 'servicedesk';
    const $f11e25be7747a3f0$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $f11e25be7747a3f0$export$c581a12a4f58fa26 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-edit-rule`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation/ruleset/:ruleId`
    };
    const $f11e25be7747a3f0$export$5b3aca7bf312c9a3 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-copy-rule`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation/copy/:ruleId`
    };
    const $f11e25be7747a3f0$export$3b8691f4e10340a9 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-create`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation/blueprint/:blueprintKey`
    };
    const $f11e25be7747a3f0$export$e0ddfe5d87fb5601 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-view-log`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation/log/:ruleId`
    };
    const $f11e25be7747a3f0$export$3e9315c24fe609c3 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-summary`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation`
    };
    var $6Z2mh;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $799409f8e61f9f67$export$b7262fe486f4b412 = 'core';
    const $799409f8e61f9f67$export$2954328f6207617a = 'software';
    const $799409f8e61f9f67$export$5575497f0592ee94 = 'servicedesk';
    const $799409f8e61f9f67$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $799409f8e61f9f67$export$586756e5c0542a50 = (product)=>{
        if (product === $799409f8e61f9f67$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $799409f8e61f9f67$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $10ca54f4f21ea64a$export$4a3b5f6370555dbc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9oaeI")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
    });
    var $10ca54f4f21ea64a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $10ca54f4f21ea64a$export$4a3b5f6370555dbc,
            pageId: "project-settings-automation-copy-rule",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2a5fc816810cf307$export$5b197b51eb5ad982 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jN2C0")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
    });
    var $2a5fc816810cf307$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2a5fc816810cf307$export$5b197b51eb5ad982,
            pageId: "project-settings-automation-create-rule",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $0645e13982e9c11f$export$c1c9a68738a9ab36 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gZF9U")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
    });
    var $0645e13982e9c11f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0645e13982e9c11f$export$c1c9a68738a9ab36,
            pageId: "project-settings-automation-edit-rule",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $g5X3G;
    var $dIdda = parcelRequire("dIdda");
    const $69d1eaf61634b750$export$39684840f773be1e = (pageType)=>{
        switch(pageType){
            case 'edit':
                return 'ruleset/:ruleId';
            case 'copy':
                return 'copy/:ruleId';
            case 'create':
                return 'blueprint/:blueprintKey';
            case 'viewlog':
                return 'log/:ruleId';
            default:
                return '';
        }
    };
    const $69d1eaf61634b750$var$newAutomationUrl = (baseUrl, { match: match }, pageType)=>{
        const { projectKey: projectKey } = match.params;
        if (pageType === 'edit') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
        }
        if (pageType === 'copy') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
        }
        if (pageType === 'viewlog') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
        }
        if (pageType === 'create') {
            const { blueprintKey: blueprintKey } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
        }
        return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
    };
    const $69d1eaf61634b750$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
            const emptyBaseUrl = (0, (0, parcelRequire("g5X3G")).toBaseUrl)('');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: $69d1eaf61634b750$var$newAutomationUrl(emptyBaseUrl, routeContext, pageType),
                push: false
            });
        };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $8a03171b9122a104$export$2fc8c3fcbb365b89 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eer4p")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
    });
    var $8a03171b9122a104$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8a03171b9122a104$export$2fc8c3fcbb365b89,
            pageId: "project-settings-automation-summary",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6f8757b068912193$export$db6c5cdbc65b2b4a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7zSGd")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
    });
    var $6f8757b068912193$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6f8757b068912193$export$db6c5cdbc65b2b4a,
            pageId: "project-settings-automation-view-log",
            shouldShowSpinner: true
        });
    const $da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, $799409f8e61f9f67$export$586756e5c0542a50)((0, $799409f8e61f9f67$export$5575497f0592ee94)),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)
        });
    const $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute = (pageType)=>({
            ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
            name: `${0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK}-automation-redirect-${pageType}`,
            path: `/projects/:projectKey/settings/automation/${(0, $69d1eaf61634b750$export$39684840f773be1e)(pageType)}`,
            forPaint: [],
            component: (0, $69d1eaf61634b750$export$d6674bfa636b8090)(pageType)
        });
    const $da7bdd95981ae4d9$export$8521f0867b2d52e4 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f11e25be7747a3f0$export$c581a12a4f58fa26), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.edit-rule',
                component: (0, $0645e13982e9c11f$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0645e13982e9c11f$export$c1c9a68738a9ab36)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f11e25be7747a3f0$export$5b3aca7bf312c9a3), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.copy-rule',
                component: (0, $10ca54f4f21ea64a$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $10ca54f4f21ea64a$export$4a3b5f6370555dbc)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f11e25be7747a3f0$export$3b8691f4e10340a9), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.create-rule',
                component: (0, $2a5fc816810cf307$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2a5fc816810cf307$export$5b197b51eb5ad982)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f11e25be7747a3f0$export$e0ddfe5d87fb5601), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.log',
                component: (0, $6f8757b068912193$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6f8757b068912193$export$db6c5cdbc65b2b4a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f11e25be7747a3f0$export$3e9315c24fe609c3), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.summary',
                component: (0, $8a03171b9122a104$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8a03171b9122a104$export$2fc8c3fcbb365b89)
                ]
            })),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('summary'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('create'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('edit'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('copy'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('viewlog')
    ];
    var $ffza4;
    var $cSD7y;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $bOhA4;
    var $6Z2mh;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $b4e8a3bb22e234a5$export$b7262fe486f4b412 = 'core';
    const $b4e8a3bb22e234a5$export$2954328f6207617a = 'software';
    const $b4e8a3bb22e234a5$export$5575497f0592ee94 = 'servicedesk';
    const $b4e8a3bb22e234a5$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $b4e8a3bb22e234a5$export$586756e5c0542a50 = (product)=>{
        if (product === $b4e8a3bb22e234a5$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $b4e8a3bb22e234a5$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    var $8WSu7;
    var $aTz47;
    var $jEJ7g;
    const $ebd0dfae741c0d7b$export$c224e724e933fbea = (page, pathname)=>{
        if (page === 'customer-notifications') {
            const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
            if (customerNotificationsPage === '/template') return 'customer-notifications-template';
            if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
            if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
        }
        return page;
    };
    const $ebd0dfae741c0d7b$export$2d1034e371a567c6 = (page, pathname)=>{
        switch(page){
            case 'kb':
                return (0, (0, parcelRequire("8WSu7")).getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true);
            default:
                return (0, (0, parcelRequire("8WSu7")).getSettingsPath)(pathname, true);
        }
    };
    const $ebd0dfae741c0d7b$export$a24ec33acfeae48d = ({ page: page, children: children })=>{
        const [{ location: location }] = (0, $dIdda.useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isJCS = (0, (0, parcelRequire("jEJ7g")).useIsJCS)();
        (0, $5uXOq.useEffect)(()=>{
            if (isJCS && !(0, (0, parcelRequire("aTz47")).isHelpCenterSettingsPath)()) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
                page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
            });
        }, [
            createAnalyticsEvent,
            isJCS,
            location.pathname,
            page
        ]);
        if (isJCS && !(0, (0, parcelRequire("aTz47")).isHelpCenterSettingsPath)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: $ebd0dfae741c0d7b$export$2d1034e371a567c6(page, location.pathname),
            persistSearchParams: true
        });
        return children;
    };
    var $5j7Th;
    var $kxZPA;
    const $6081b8204512e323$export$c763ea321ade5f68 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4fGkE")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
    });
    var $6081b8204512e323$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "customer-notifications"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6081b8204512e323$export$c763ea321ade5f68,
            pageId: "project-settings-customer-notifications",
            shouldShowSpinner: true
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $aa137e884608085b$export$8249a46a710af6da = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
    const $6cda2c2384bf3147$export$d6bb339f4d05f5c5 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute), ()=>({
                component: (0, $6081b8204512e323$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $b4e8a3bb22e234a5$export$586756e5c0542a50)((0, $b4e8a3bb22e234a5$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6081b8204512e323$export$c763ea321ade5f68)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $aa137e884608085b$export$8249a46a710af6da), (0, $6081b8204512e323$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $b4e8a3bb22e234a5$export$586756e5c0542a50)((0, $b4e8a3bb22e234a5$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6081b8204512e323$export$c763ea321ade5f68)
                ]
            }))
    ];
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $3Yq3S;
    var $6Z2mh;
    var $lmyls;
    const $5c24657e8d4ddd13$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "fad9602cc939abe026957eedfb3768d995afeda6dc5cbfbcc894fd0a905f9013",
            "metadata": {},
            "name": "JourneyConfigurationPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $5c24657e8d4ddd13$export$2e2bcd8739ae039 = $5c24657e8d4ddd13$var$node;
    var $eufEc;
    var $fEDBv;
    const $1dfcd84f3f61c84b$export$26f82de7820f0c3 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("gw7Fm")), {
            moduleId: "6bffb775",
            moduleName: "JourneyConfigurationPage"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    jiraJourneyConfiguration: {
                        parameters: $5c24657e8d4ddd13$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            journeyId: context.match.params.journeyId ?? ''
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
    const $e2e16678033c3122$export$35537410b0bf07ea = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $1dfcd84f3f61c84b$export$26f82de7820f0c3),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $lmyls;
    const $0dab8bc029613fb5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "01d7368c8332fa867381fbc1eea031a9ef14755e419494004bebb62080c64710",
            "metadata": {},
            "name": "JourneysPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $0dab8bc029613fb5$export$2e2bcd8739ae039 = $0dab8bc029613fb5$var$node;
    var $eufEc;
    var $fEDBv;
    const $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("aUjwY")), {
            moduleId: "ab11e2ef",
            moduleName: "JourneysPage"
        }),
        getPreloadProps: ({ tenantContext: tenantContext })=>({
                queries: {
                    journeysPageQueryRef: {
                        parameters: $0dab8bc029613fb5$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId
                        },
                        options: {
                            fetchPolicy: 'store-and-network'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
    const $afecb2c38eb0ad75$export$3b90f0eb27bdd52f = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $6ffe646ddf6221b0$export$5dfc85c70e03c102 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3Yq3S")).routeGroupsProjectSettingsServicedeskJourneysRoute), ()=>({
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
                ],
                entryPoint: ()=>(0, $afecb2c38eb0ad75$export$3b90f0eb27bdd52f)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3Yq3S")).routeGroupsProjectSettingsServicedeskJourneyConfigurationRoute), ()=>({
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
                ],
                entryPoint: ()=>(0, $e2e16678033c3122$export$35537410b0bf07ea)
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $2nb5R;
    var $6Z2mh;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $2275cc324bd22d3c$export$b7262fe486f4b412 = 'core';
    const $2275cc324bd22d3c$export$2954328f6207617a = 'software';
    const $2275cc324bd22d3c$export$5575497f0592ee94 = 'servicedesk';
    const $2275cc324bd22d3c$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $2275cc324bd22d3c$export$586756e5c0542a50 = (product)=>{
        if (product === $2275cc324bd22d3c$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $2275cc324bd22d3c$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0bf88a8d63415148$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
    const $0bf88a8d63415148$export$1aa47348ef6dbdda = 'project/service-desk/settings';
    const $0bf88a8d63415148$export$583a442626bd3345 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8G8Xo")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
    });
    const $0bf88a8d63415148$export$7c7186fdd8c56428 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ippoi"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
    });
    const $0bf88a8d63415148$export$6d92735e249274bb = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "kb"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bf88a8d63415148$export$7c7186fdd8c56428,
            pageId: "project-settings-knowledge-base",
            shouldShowSpinner: true
        }));
    var $0bf88a8d63415148$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bf88a8d63415148$export$583a442626bd3345,
            pageId: "project-settings-knowledge-base",
            shouldShowSpinner: true
        });
    const $62c3d1c204167743$export$f90c0f16cffd8883 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2nb5R")).routeGroupsProjectSettingsServicedeskKbRoute), ()=>({
                perfMetricKey: 'service-management.kb-settings',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                component: (0, $0bf88a8d63415148$export$6d92735e249274bb),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0bf88a8d63415148$export$7c7186fdd8c56428)
                ],
                resources: [
                    ...(0, $2275cc324bd22d3c$export$586756e5c0542a50)((0, $2275cc324bd22d3c$export$5575497f0592ee94)),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ]
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $4wBwP;
    var $040pa;
    var $6Z2mh;
    var $e9YVH;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $43aedf68164f3e5b$export$b7262fe486f4b412 = 'core';
    const $43aedf68164f3e5b$export$2954328f6207617a = 'software';
    const $43aedf68164f3e5b$export$5575497f0592ee94 = 'servicedesk';
    const $43aedf68164f3e5b$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $43aedf68164f3e5b$export$586756e5c0542a50 = (product)=>{
        if (product === $43aedf68164f3e5b$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $43aedf68164f3e5b$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $l8ruj;
    var $kxZPA;
    const $45b508c287c9b763$export$a6694c07cb5be8c1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h3FVt"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
    });
    const $45b508c287c9b763$export$c56fde3803c5a1a3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "project-settings-service-desk-sla-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $45b508c287c9b763$export$a6694c07cb5be8c1,
            pageId: "project-settings-service-desk-sla-settings",
            shouldShowSpinner: true
        }));
    const $e00888b39cabebc3$export$fd1a58e6255623a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("040pa")).servicedeskSlaSettingsRoute), ()=>({
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).SLA_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).SLA_SETTINGS),
                        teamName: 'bumblebee'
                    }
                },
                perfMetricKey: 'jsm-sla-settings',
                component: (0, $45b508c287c9b763$export$c56fde3803c5a1a3),
                resources: [
                    ...(0, $43aedf68164f3e5b$export$586756e5c0542a50)((0, $43aedf68164f3e5b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("4wBwP")).slaMetricsDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $45b508c287c9b763$export$a6694c07cb5be8c1)
                ]
            }))
    ];
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $eUvlM;
    var $65Ltd;
    const $128fa6baf87c0ab7$export$5575497f0592ee94 = 'servicedesk';
    const $128fa6baf87c0ab7$export$eeb615fb989a6e4d = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-type-fields`,
        path: `/jira/${$128fa6baf87c0ab7$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?`
    };
    const $128fa6baf87c0ab7$export$50e6baca5c1f7a5b = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-type-fields`,
        path: `/jira/${$128fa6baf87c0ab7$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?`
    };
    const $128fa6baf87c0ab7$export$51c2cd63e9954ab7 = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-type-fields`,
        path: `/jira/${$128fa6baf87c0ab7$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?`
    };
    var $6Z2mh;
    var $e9YVH;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $94cdffc93223c5bd$export$b7262fe486f4b412 = 'core';
    const $94cdffc93223c5bd$export$2954328f6207617a = 'software';
    const $94cdffc93223c5bd$export$5575497f0592ee94 = 'servicedesk';
    const $94cdffc93223c5bd$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $94cdffc93223c5bd$export$586756e5c0542a50 = (product)=>{
        if (product === $94cdffc93223c5bd$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $94cdffc93223c5bd$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $e9f2572a89172526$export$471040ce01e559fc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9isaY")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
    });
    var $e9f2572a89172526$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "ticket-type-fields"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e9f2572a89172526$export$471040ce01e559fc,
            pageId: "project-settings-ticket-type-fields",
            shouldShowSpinner: true
        }));
    const $26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon = ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
            component: (0, $e9f2572a89172526$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, $94cdffc93223c5bd$export$586756e5c0542a50)((0, $94cdffc93223c5bd$export$5575497f0592ee94)),
                (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e9f2572a89172526$export$471040ce01e559fc)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPE_FIELDS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPE_FIELDS),
                    teamName: 'jsd-shield'
                }
            },
            ufoName: `${0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK}-ticket-type-fields`
        });
    const $26c11c644324b9a1$export$caa50198aadcf21c = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $128fa6baf87c0ab7$export$eeb615fb989a6e4d), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon(),
                component: (0, $e9f2572a89172526$export$2e2bcd8739ae039)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $128fa6baf87c0ab7$export$50e6baca5c1f7a5b), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon()
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $128fa6baf87c0ab7$export$51c2cd63e9954ab7), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon()
            }))
    ];
    var $ffza4;
    var $co1wz;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $2pT4g;
    var $dxCvy;
    var $k8jl5;
    var $1cpsA;
    var $eUvlM;
    var $gNStA;
    var $YXuQ6;
    var $6Z2mh;
    var $e9YVH;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $5f297064983232af$export$b7262fe486f4b412 = 'core';
    const $5f297064983232af$export$2954328f6207617a = 'software';
    const $5f297064983232af$export$5575497f0592ee94 = 'servicedesk';
    const $5f297064983232af$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $5f297064983232af$export$586756e5c0542a50 = (product)=>{
        if (product === $5f297064983232af$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $5f297064983232af$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("i88kG")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
    });
    var $d4145a6e3aeb3bbb$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "ticket-types-config"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c,
            pageId: "project-settings-ticket-types-config",
            shouldShowSpinner: true
        }));
    const $7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry = {
        component: (0, $d4145a6e3aeb3bbb$export$2e2bcd8739ae039),
        layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
            sidebar: (0, (0, parcelRequire("h0bZU")).default),
            sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5f297064983232af$export$586756e5c0542a50)((0, $5f297064983232af$export$5575497f0592ee94)),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
            (0, (0, parcelRequire("k8jl5")).servicedeskIssueTypesResource),
            (0, (0, parcelRequire("1cpsA")).servicedeskPortalGroupsResource),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
        ],
        forPaint: [
            (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
            (0, $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c)
        ],
        meta: {
            reporting: {
                id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    };
    const $7e5adb0871ecbbba$export$fa9d0db1668a0662 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry,
                component: (0, $d4145a6e3aeb3bbb$export$2e2bcd8739ae039)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskItsmTicketTypesConfigRoute), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry
            }))
    ];
    var $aIZdc;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $65Ltd;
    const $ee375367f69d39dc$export$5575497f0592ee94 = 'servicedesk';
    const $ee375367f69d39dc$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $ee375367f69d39dc$export$8c051c399fd812a5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagentonboarding`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent`
    };
    const $ee375367f69d39dc$export$3e227412713bc57f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-browse-intents`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/intents`
    };
    const $ee375367f69d39dc$export$bf8131fb060d0e73 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-view-intent`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/intents/:intentId/:tab(flow|training|settings)?`
    };
    const $ee375367f69d39dc$export$fd091ba8fa858397 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-standard-flows`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/standard-flows`
    };
    const $ee375367f69d39dc$export$c74dca8be49046ea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-view-standard-flow`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?`
    };
    const $ee375367f69d39dc$export$c8ff4cf64e5540ec = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-browseconversations`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/conversations`
    };
    const $ee375367f69d39dc$export$847a7c378c11c645 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-settings`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/settings/:tab(basic|channels)?`
    };
    var $6Z2mh;
    var $e9YVH;
    var $2vSU6;
    var $1XrjK;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XluA;
    var $4mO32;
    var $hsmeR;
    var $dAfqg;
    const $e2036dd19a3f68c8$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "125329b9d4e888d6fdabbfee72c3e68f14cb83b841b09ddce260b26dc8ea5dce",
            "metadata": {},
            "name": "uiVirtualAgentIntentTemplatesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $e2036dd19a3f68c8$export$2e2bcd8739ae039 = $e2036dd19a3f68c8$var$node;
    var $eufEc;
    var $fEDBv;
    const $6713c6429155461a$export$2b1d9dc27ee42f8f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("1kwFV")), {
            moduleId: "a4e9afeb"
        }),
        getPreloadProps: ({ cloudId: cloudId, key: key })=>({
                queries: {
                    intentTemplateQueryReference: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, $e2036dd19a3f68c8$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: cloudId,
                            key: key
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
    var $av9sZ;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $3fd9739904b8669a$exports = {};
    $3fd9739904b8669a$exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();
    const $637244f673c8e430$var$customCssStyles = null;
    const $637244f673c8e430$export$fa68b26760d5b66f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($3fd9739904b8669a$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $koeKL;
    const $cdb5ff159e084339$var$runtimeProps = {};
    const $cdb5ff159e084339$export$36ad24b9ac79bdc8 = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const panelId = rightSidebarCurrentState?.panelId ?? '';
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                key: projectContextData?.projectKey ?? ''
            }), [
            cloudId,
            projectContextData
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, $6713c6429155461a$export$2b1d9dc27ee42f8f), entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            if (panelId === 'intentTemplate') entryPointActions.load();
            else entryPointActions.unload();
        }, [
            entryPointActions,
            panelId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "createIntentTemplatesSidebar",
            packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $637244f673c8e430$export$fa68b26760d5b66f), null),
            errorFallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cdb5ff159e084339$var$SideBarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("av9sZ")).ErrorDisplay), {
                    refetch: ()=>window.location.reload()
                })),
            runtimeProps: $cdb5ff159e084339$var$runtimeProps
        });
    };
    const $cdb5ff159e084339$var$SideBarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _11q71bhr _1kl7wsm2 _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
                __cmplp.className
            ])
        });
    });
    var $cdb5ff159e084339$export$2e2bcd8739ae039 = $cdb5ff159e084339$export$36ad24b9ac79bdc8;
    const $3f16128d6d3a9eb8$var$withServiceProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)
            }
        });
    const $3f16128d6d3a9eb8$export$6659f41b213bad05 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), {
        rightSidebars: [
            $3f16128d6d3a9eb8$var$withServiceProjectContext((0, $cdb5ff159e084339$export$2e2bcd8739ae039))
        ]
    });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $ad27286735078899$exports = {};
    $ad27286735078899$exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();
    const $31e71d146f719961$var$customStyles = null;
    const $31e71d146f719961$export$4a6267fad85ca589 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($ad27286735078899$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $ewTwY;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $4f6f020c30624e97$exports = {};
    $4f6f020c30624e97$exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();
    const $cab5351b0cab7245$var$customCssStyles = null;
    const $cab5351b0cab7245$export$c2bd83dd149452bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4f6f020c30624e97$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $c4e5e973e166fec5$exports = {};
    $c4e5e973e166fec5$exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();
    const $b789e8c1efa50dd2$var$customStyles = null;
    const $b789e8c1efa50dd2$export$f4b71d7b732df8a7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($c4e5e973e166fec5$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $a3d2c3af3a16b398$exports = {};
    $a3d2c3af3a16b398$exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();
    const $ffc145e88af958a4$var$customCssStyles = null;
    const $ffc145e88af958a4$export$429c43ddcb09c14c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($a3d2c3af3a16b398$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $806ba01691200183$exports = {};
    $806ba01691200183$exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();
    const $2174f34b723f2aa4$var$customCssStyles = null;
    const $2174f34b723f2aa4$export$72b20c10a0f18a2f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($806ba01691200183$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $7c12655ddf830494$exports = {};
    $7c12655ddf830494$exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();
    const $68dba50d060b4784$var$customCssStyles = null;
    const $68dba50d060b4784$export$c6d3f04e6931e3f6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7c12655ddf830494$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $d4rfp;
    var $7oHmH;
    const $6a4522a333dd4135$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "9d72b5513735b93097e24be9918ee2d9d52369f5b250d43277ed25b5ec6cddbe",
            "metadata": {},
            "name": "srcVirtualAgentBrowseConversationsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, (0, parcelRequire("d4rfp")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $6a4522a333dd4135$export$2e2bcd8739ae039 = $6a4522a333dd4135$var$node;
    var $eufEc;
    var $fEDBv;
    const $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS = 14;
    const $d5456be03cb88be5$export$38549013d5d5a440 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("7HjzY")), {
            moduleId: "1bf85952"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const end = new Date();
            const start = new Date(end);
            start.setDate(start.getDate() - $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS);
            return {
                extraProps: {
                    initialDateRange: {
                        start: start,
                        end: end
                    }
                },
                queries: {
                    page: {
                        parameters: (0, $6a4522a333dd4135$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            startDate: start.toISOString(),
                            endDate: end.toISOString()
                        }
                    }
                }
            };
        }
    });
    var $7oHmH;
    const $84af76b2b1eda3ac$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b01f9fcabc3aee56bbd34937601e0f469fa19b8352f84444c4e984055d229188",
            "metadata": {},
            "name": "srcVirtualAgentBrowseIntentsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $84af76b2b1eda3ac$export$2e2bcd8739ae039 = $84af76b2b1eda3ac$var$node;
    const $d3c21345417f9f8e$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "88cc4583a28f5f918e666724a2636a3b4534c49a8641fe00c526853b754f57f5",
            "metadata": {},
            "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $d3c21345417f9f8e$export$2e2bcd8739ae039 = $d3c21345417f9f8e$var$node;
    var $eufEc;
    var $fEDBv;
    const $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS = 604800000;
    const $0c1a3d6ae6de7f87$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);
    const $0c1a3d6ae6de7f87$export$f19c213ae2d7940f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("b2GCz")), {
            moduleId: "85089c8d"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $84af76b2b1eda3ac$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    },
                    statistics: {
                        parameters: (0, $d3c21345417f9f8e$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            startDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date(Date.now() - $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS)),
                            endDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date())
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $4e33e127e8847987$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "2e51c3ce04647514550bfd30a24273f1ec78c1e9f29b4cc8e2d0ea31f4eb36b7",
            "metadata": {},
            "name": "srcVirtualAgentBrowseStandardFlowsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $4e33e127e8847987$export$2e2bcd8739ae039 = $4e33e127e8847987$var$node;
    var $eufEc;
    var $fEDBv;
    const $32e48f8946c41f01$export$f7de8593c7455f1 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("l7tra")), {
            moduleId: "c2d13204"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $4e33e127e8847987$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $588c29ffd4ee84e7$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a7f141f3b031fac8f81706fc45ecc08cdad9187b6897af87cfe378c09e62bbc4",
            "metadata": {},
            "name": "srcVirtualAgentLandingQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $588c29ffd4ee84e7$export$2e2bcd8739ae039 = $588c29ffd4ee84e7$var$node;
    var $eufEc;
    var $fEDBv;
    const $0f9dae747ed8bf8a$export$ad927ca7512a3a01 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("e1IHq")), {
            moduleId: "06d84010"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $588c29ffd4ee84e7$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $a14dfc5f3ce71c58$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "0af3d831d6845961020ffbd5836b5c31aee474f150bcc79c33eedce8c8f88fc4",
            "metadata": {},
            "name": "srcVirtualAgentSettingsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $a14dfc5f3ce71c58$export$2e2bcd8739ae039 = $a14dfc5f3ce71c58$var$node;
    var $eufEc;
    var $fEDBv;
    const $a9827913d0401124$export$d34e7816b7ac181a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("iEX30")), {
            moduleId: "ed4de71b"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $a14dfc5f3ce71c58$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $45ed8bfdfee83271$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "e7767aeff6aef92ebf766bcc5caf7c51a370d482f8b894d49e716f084cbc2e0d",
            "metadata": {},
            "name": "srcVirtualAgentViewIntentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $45ed8bfdfee83271$export$2e2bcd8739ae039 = $45ed8bfdfee83271$var$node;
    var $eufEc;
    var $fEDBv;
    const $ac6810a67c998d50$export$f51df662bd71ce39 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("83kJ4")), {
            moduleId: "bc04de30"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $45ed8bfdfee83271$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            intentId: context.match.params.intentId ?? ''
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $1bc956e6a804d466$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "e99c84d3af08be34f82c9f5371a5d21d166aa134a461ace14c61e3ec2151810c",
            "metadata": {},
            "name": "srcVirtualAgentViewStandardFlowQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $1bc956e6a804d466$export$2e2bcd8739ae039 = $1bc956e6a804d466$var$node;
    var $eufEc;
    var $fEDBv;
    const $8d05ca45dd1a7906$export$4fd7bf09308d4abd = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("e6BUU")), {
            moduleId: "8e1cdfbd"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $1bc956e6a804d466$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            flowId: context.match.params.flowId ?? ''
                        }
                    }
                }
            })
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $dIdda = parcelRequire("dIdda");
    const $a6392627f74f3006$export$b7262fe486f4b412 = 'core';
    const $a6392627f74f3006$export$2954328f6207617a = 'software';
    const $a6392627f74f3006$export$5575497f0592ee94 = 'servicedesk';
    const $a6392627f74f3006$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $a6392627f74f3006$export$586756e5c0542a50 = (product)=>{
        if (product === $a6392627f74f3006$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $a6392627f74f3006$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    const $a6392627f74f3006$export$c9b0516439c55d7a = (product)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
            });
    const $8b897edada5ca041$var$browseConversationsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d5456be03cb88be5$export$38549013d5d5a440),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$browseIntentsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $0c1a3d6ae6de7f87$export$f19c213ae2d7940f),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$browseStandardFlowsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $32e48f8946c41f01$export$f7de8593c7455f1),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$landingPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $0f9dae747ed8bf8a$export$ad927ca7512a3a01),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$settingsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $a9827913d0401124$export$d34e7816b7ac181a),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$viewStandardFlowPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $8d05ca45dd1a7906$export$4fd7bf09308d4abd),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$viewIntentPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $ac6810a67c998d50$export$f51df662bd71ce39),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$getVirtualAgentRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            }
        });
    const $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings = (0, $a6392627f74f3006$export$c9b0516439c55d7a)((0, $a6392627f74f3006$export$5575497f0592ee94));
    const $8b897edada5ca041$export$cf02bed1953597cb = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ee375367f69d39dc$export$8c051c399fd812a5), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$landingPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $b789e8c1efa50dd2$export$f4b71d7b732df8a7),
                resources: [
                    ...(0, $a6392627f74f3006$export$586756e5c0542a50)((0, $a6392627f74f3006$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ee375367f69d39dc$export$3e227412713bc57f), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseIntentsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                layout: (0, $3f16128d6d3a9eb8$export$6659f41b213bad05),
                skeleton: (0, (0, parcelRequire("ewTwY")).VirtualAgentBrowseIntentsSkeleton),
                resources: [
                    ...(0, $a6392627f74f3006$export$586756e5c0542a50)((0, $a6392627f74f3006$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ee375367f69d39dc$export$bf8131fb060d0e73), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$viewIntentPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $2174f34b723f2aa4$export$72b20c10a0f18a2f),
                resources: [
                    ...(0, $a6392627f74f3006$export$586756e5c0542a50)((0, $a6392627f74f3006$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ee375367f69d39dc$export$fd091ba8fa858397), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseStandardFlowsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $cab5351b0cab7245$export$c2bd83dd149452bd),
                resources: [
                    ...(0, $a6392627f74f3006$export$586756e5c0542a50)((0, $a6392627f74f3006$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ee375367f69d39dc$export$c74dca8be49046ea), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$viewStandardFlowPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $68dba50d060b4784$export$c6d3f04e6931e3f6),
                resources: [
                    ...(0, $a6392627f74f3006$export$586756e5c0542a50)((0, $a6392627f74f3006$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ee375367f69d39dc$export$c8ff4cf64e5540ec), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseConversationsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $31e71d146f719961$export$4a6267fad85ca589),
                resources: [
                    ...(0, $a6392627f74f3006$export$586756e5c0542a50)((0, $a6392627f74f3006$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ee375367f69d39dc$export$847a7c378c11c645), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$settingsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $ffc145e88af958a4$export$429c43ddcb09c14c),
                resources: [
                    ...(0, $a6392627f74f3006$export$586756e5c0542a50)((0, $a6392627f74f3006$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            }))
    ];
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $iQZ89;
    var $6Z2mh;
    var $eufEc;
    var $fEDBv;
    const $5e46ff6da5ce3455$export$12ccdf1d30de8ac = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("hQKui")), {
            moduleId: "6be3e66b"
        }),
        getPreloadProps: ()=>({})
    });
    const $0043ec7f595129fa$var$workflowSchemeConfigPageEntrypoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $5e46ff6da5ce3455$export$12ccdf1d30de8ac),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $0043ec7f595129fa$var$CORE_PRODUCT = 'core';
    const $0043ec7f595129fa$var$SERVICE_DESK_PRODUCT = 'servicedesk';
    const $0043ec7f595129fa$export$586756e5c0542a50 = (product)=>{
        if (product === $0043ec7f595129fa$var$SERVICE_DESK_PRODUCT) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        const resources = [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
        if (product === $0043ec7f595129fa$var$CORE_PRODUCT) return [
            ...resources,
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return resources;
    };
    const $0043ec7f595129fa$export$212f7f79630d5adc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iQZ89")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute), ()=>({
            entryPoint () {
                return $0043ec7f595129fa$var$workflowSchemeConfigPageEntrypoint;
            },
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...$0043ec7f595129fa$export$586756e5c0542a50($0043ec7f595129fa$var$SERVICE_DESK_PRODUCT),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            meta: {
                reporting: {
                    id: 'project-settings.workflow-scheme-config',
                    packageName: 'projectSettingsWorkflowSchemeConfig',
                    teamName: 'jsd-shield'
                }
            },
            ufoName: 'project-settings-workflow-scheme-config'
        }));
    var $6Z2mh;
    var $ejiWA;
    var $e9YVH;
    var $7Txnp;
    var $k7tsS;
    var $f8FqB;
    var $d0oNj;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $dAfqg;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d7e52a3e5f45b58f$export$fa3bc297af95f169 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ghg5c"))), {
        moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
    });
    var $d7e52a3e5f45b58f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d7e52a3e5f45b58f$export$fa3bc297af95f169,
            pageId: "project-settings-app-discovery-settings",
            shouldShowSpinner: false
        });
    const $3f52008d1cdfa258$export$246ec9cdadd2a163 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9RXCH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $3f52008d1cdfa258$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        return shouldRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
            push: false
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $d7e52a3e5f45b58f$export$2e2bcd8739ae039), null);
    };
    const $3f52008d1cdfa258$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3f52008d1cdfa258$var$ConnectAppsRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3f52008d1cdfa258$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3f52008d1cdfa258$export$246ec9cdadd2a163,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $841a04425f045e7e$export$3633e017e520a1c2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    var $841a04425f045e7e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $841a04425f045e7e$export$3633e017e520a1c2,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2igd7"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $953aed1c2ae3d2f5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3746e6592757d8dd$export$6f16b5efddd5c646 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kVevk"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    var $3746e6592757d8dd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3746e6592757d8dd$export$6f16b5efddd5c646,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $c77ac9be273e47d5$export$e309780f520d125a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("NWARb"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    var $c77ac9be273e47d5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c77ac9be273e47d5$export$e309780f520d125a,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $dxCvy;
    var $5j7Th;
    var $kxZPA;
    const $d4e28d950e086fee$export$ef66d3f49a9953d8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $d4e28d950e086fee$export$33d85a1b2211b38 = [
        (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
        (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource)
    ];
    const $d4e28d950e086fee$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d4e28d950e086fee$export$ef66d3f49a9953d8,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    var $d4e28d950e086fee$export$2e2bcd8739ae039 = $d4e28d950e086fee$export$b943f48844c671a5;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9d365377dbe2cbf1$export$36dcfb52d47cb93a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("61LFA"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $9d365377dbe2cbf1$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9d365377dbe2cbf1$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    var $f62e804ec9c6d7ed$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $6229d9dc67e508de$export$ea7d73c94d9369f4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bm5Zl"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    var $6229d9dc67e508de$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6229d9dc67e508de$export$ea7d73c94d9369f4,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $3a1472a535e1ea00$export$7eee4f97b7a1273 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b3T21"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $3a1472a535e1ea00$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
            push: false
        });
    const $3a1472a535e1ea00$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3a1472a535e1ea00$var$PeopleAccessRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3a1472a535e1ea00$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3a1472a535e1ea00$export$7eee4f97b7a1273,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $dIdda = parcelRequire("dIdda");
    const $a51e57eb3887507b$export$b7262fe486f4b412 = 'core';
    const $a51e57eb3887507b$export$2954328f6207617a = 'software';
    const $a51e57eb3887507b$export$5575497f0592ee94 = 'servicedesk';
    const $a51e57eb3887507b$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $a51e57eb3887507b$export$586756e5c0542a50 = (product)=>{
        if (product === $a51e57eb3887507b$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $a51e57eb3887507b$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    const $a51e57eb3887507b$export$c9b0516439c55d7a = (product)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
            });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $5cc0224f486155a9$export$a7d63246a10aedd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9Saqg")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    var $5cc0224f486155a9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5cc0224f486155a9$export$a7d63246a10aedd,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7c82c5f708d0cd7e$export$38414b624a749cec = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2Js68")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    var $7c82c5f708d0cd7e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7c82c5f708d0cd7e$export$38414b624a749cec,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8fbb06494113daae$export$e674d93688e620b3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4q0cm"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
    });
    var $8fbb06494113daae$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8fbb06494113daae$export$e674d93688e620b3,
            pageId: "project-settings-change-management",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $dIdda = parcelRequire("dIdda");
    const $73d598aaa606ce09$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            const url = `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: url,
                push: false
            });
        };
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $7c240e4106c097e5$export$22c86ddb04b1359a = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $955f7623ed5daf83$export$971347f9ac02f862 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kXpVf")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
    });
    var $955f7623ed5daf83$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $955f7623ed5daf83$export$971347f9ac02f862,
            pageId: "project-settings-widget-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2f67c1468e19aedd$export$eb662b618d6247be = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bixEU"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
    });
    var $2f67c1468e19aedd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f67c1468e19aedd$export$eb662b618d6247be,
            pageId: "project-settings-classic-portal-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8d9798e9d24a9632$export$5367e40a24f0bd54 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9J1LU"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
    });
    var $8d9798e9d24a9632$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8d9798e9d24a9632$export$5367e40a24f0bd54,
            pageId: "project-settings-customer-permissions",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $467404e10c7e501f$export$59eedcca37dbbafd = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $881ebeec1a2867ea$export$66d0c668045080de = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1iNvP")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
    });
    var $881ebeec1a2867ea$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "email"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $881ebeec1a2867ea$export$66d0c668045080de,
            pageId: "project-settings-email",
            shouldShowSpinner: true
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $f10a7d047f1802a3$export$86c8da903fb97c4f = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $15bcce9a01d18cfd$export$28482a53859ec466 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lsb3L"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
    });
    var $15bcce9a01d18cfd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $15bcce9a01d18cfd$export$28482a53859ec466,
            pageId: "project-settings-external-links",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4b8db06fa1ed7bd1$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
    const $4b8db06fa1ed7bd1$export$1aa47348ef6dbdda = 'project/service-desk/settings';
    const $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1824v")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
    });
    var $4b8db06fa1ed7bd1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47,
            pageId: "project-settings-feedback-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $74652d26314b4bbc$export$7796b6d080b8c187 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3z8Kq"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
    });
    var $74652d26314b4bbc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $74652d26314b4bbc$export$7796b6d080b8c187,
            pageId: "project-settings-incident-management",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1956b65a2446b925$export$9c9d293dc6de29d0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5WlEn"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
    });
    var $1956b65a2446b925$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1956b65a2446b925$export$9c9d293dc6de29d0,
            pageId: "project-settings-internal-notifications",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $68a880eb92a707c3$export$49625f83fe7ecc69 = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $402e11ff5e131d95$export$562be1021beb9882 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5EQvM"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
    });
    var $402e11ff5e131d95$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $402e11ff5e131d95$export$562be1021beb9882,
            pageId: "project-settings-itsm-features",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4c45ee4ab52677ce$export$213b8279037c9d98 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5UxQx"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
    });
    var $4c45ee4ab52677ce$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4c45ee4ab52677ce$export$213b8279037c9d98,
            pageId: "project-settings-language-support",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $818bcbaaddc8bfd3$export$c029d3f514c7b3e0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bmBIM")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
    });
    var $818bcbaaddc8bfd3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $818bcbaaddc8bfd3$export$c029d3f514c7b3e0,
            pageId: "project-settings-language-translations",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $060e0b1586db8e82$export$735e58642f560ddc = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $dIdda = parcelRequire("dIdda");
    const $d3615143cfedd2aa$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            const url = projectKey !== null && projectKey !== undefined ? `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: url,
                push: false
            });
        };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $9da321ff59a70829$export$fdbd4b1e5ae0e422 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("coLKx")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
    });
    var $9da321ff59a70829$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9da321ff59a70829$export$fdbd4b1e5ae0e422,
            pageId: "project-settings-portal-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $1ae3adbbf5c00734$export$8ba256148f9b998f = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $bf4d9e5ccdf213aa$export$216a049c4d917b0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ba8Ho")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
    });
    var $bf4d9e5ccdf213aa$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bf4d9e5ccdf213aa$export$216a049c4d917b0,
            pageId: "project-settings-widget-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $55da4849dbdf5d52$export$cb608e3696682e76 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l00Ww"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    var $55da4849dbdf5d52$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $55da4849dbdf5d52$export$cb608e3696682e76,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
    const $c40db1734fa3af79$var$ufoNamesMap = {
        'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
        'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
    };
    const $c40db1734fa3af79$var$getUFOName = (name)=>$c40db1734fa3af79$var$ufoNamesMap[name] || name;
    const $c40db1734fa3af79$var$commonRouteEntries = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIssuetypesRoute), ()=>({
                ufoName: $c40db1734fa3af79$var$getUFOName(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`),
                component: (0, $9d365377dbe2cbf1$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $9d365377dbe2cbf1$export$36dcfb52d47cb93a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute), ()=>({
                component: (0, $55da4849dbdf5d52$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $9d365377dbe2cbf1$export$36dcfb52d47cb93a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFieldsRoute), ()=>({
                ufoName: 'project-settings.fields.jsm-tmp',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', (0, $c77ac9be273e47d5$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c77ac9be273e47d5$export$e309780f520d125a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute), ()=>({
                component: (0, $3f52008d1cdfa258$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3f52008d1cdfa258$export$246ec9cdadd2a163)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskApps1Route), ()=>({
                component: (0, $841a04425f045e7e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $841a04425f045e7e$export$3633e017e520a1c2)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskDetailsRoute), ()=>({
                component: (0, $3746e6592757d8dd$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3746e6592757d8dd$export$6f16b5efddd5c646)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAccessRoute), ()=>({
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsAccessSkeleton),
                component: (0, $3a1472a535e1ea00$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3a1472a535e1ea00$export$7eee4f97b7a1273)
                ],
                ufoName: 'project-settings.access'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAccessRedirectRoute), ()=>({
                component: (0, $3a1472a535e1ea00$export$45346ed2aa24e3f3)(`/jira/${(0, $a51e57eb3887507b$export$5575497f0592ee94)}`),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3a1472a535e1ea00$export$7eee4f97b7a1273)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute), ()=>({
                component: (0, $7c82c5f708d0cd7e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7c82c5f708d0cd7e$export$38414b624a749cec)
                ],
                perfMetricKey: 'forms-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute), ()=>({
                component: (0, $5cc0224f486155a9$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5cc0224f486155a9$export$a7d63246a10aedd)
                ],
                perfMetricKey: 'form-builder'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskAutomationRoute), ()=>({
                ufoName: `project-settings-automation-${0, $a51e57eb3887507b$export$5575497f0592ee94}`,
                component: (0, $f62e804ec9c6d7ed$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskDataClassificationsRoute), ()=>({
                component: (0, $953aed1c2ae3d2f5$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56)
                ]
            }))
    ];
    const $c40db1734fa3af79$export$37a8204dc4094049 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskClassicAppsRoute), ()=>({
                ufoName: 'service-management.app-discovery',
                component: (0, $3f52008d1cdfa258$export$cc3414a2d9daf70d)(`/jira/${(0, $a51e57eb3887507b$export$5575497f0592ee94)}`),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                isRedirect: true,
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d7e52a3e5f45b58f$export$fa3bc297af95f169)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).APP_DISCOVERY,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).APP_DISCOVERY),
                        teamName: 'it-solutions-hermes'
                    }
                }
            })),
        ...$c40db1734fa3af79$var$commonRouteEntries,
        ...(0, $62c3d1c204167743$export$f90c0f16cffd8883),
        ...(0, $26c11c644324b9a1$export$caa50198aadcf21c),
        ...(0, $7e5adb0871ecbbba$export$fa9d0db1668a0662),
        ...(0, $da7bdd95981ae4d9$export$8521f0867b2d52e4),
        ...(0, $6cda2c2384bf3147$export$d6bb339f4d05f5c5),
        ...(0, $8b897edada5ca041$export$cf02bed1953597cb),
        ...(0, $89f595ea28ec651e$export$89ee08578c593726),
        ...(0, $6ffe646ddf6221b0$export$5dfc85c70e03c102),
        (0, $0043ec7f595129fa$export$212f7f79630d5adc),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskItsmFeaturesRoute), ()=>({
                ufoName: 'jsm-features-settings',
                component: (0, $402e11ff5e131d95$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $402e11ff5e131d95$export$562be1021beb9882)
                ],
                perfMetricKey: 'jsm-features-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
                ufoName: 'service-management.internal-notifications',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $68a880eb92a707c3$export$49625f83fe7ecc69), (0, $1956b65a2446b925$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $1956b65a2446b925$export$9c9d293dc6de29d0),
                    (0, (0, parcelRequire("f8FqB")).LazyInternalNotificationSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
                ufoName: 'service-management.internal-notifications',
                component: (0, $1956b65a2446b925$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $1956b65a2446b925$export$9c9d293dc6de29d0),
                    (0, (0, parcelRequire("f8FqB")).LazyInternalNotificationSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $060e0b1586db8e82$export$735e58642f560ddc), (0, $6229d9dc67e508de$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $6229d9dc67e508de$export$ea7d73c94d9369f4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsEmailRoute), ()=>({
                component: (0, $6229d9dc67e508de$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $6229d9dc67e508de$export$ea7d73c94d9369f4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotifications1Route), ()=>({
                component: (0, $d3615143cfedd2aa$export$59144dd4441639fa)('customer-notifications'),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskLanguageKeyRoute), ()=>({
                ufoName: 'service-management.translations',
                component: (0, $818bcbaaddc8bfd3$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("k7tsS")).languageTranslationsResource),
                    (0, (0, parcelRequire("k7tsS")).outgoingEmailStateModelResource)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).LANGUAGE_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).LANGUAGE_SETTINGS),
                        teamName: 'jsm-banana'
                    }
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $818bcbaaddc8bfd3$export$c029d3f514c7b3e0)
                ],
                perfMetricKey: 'jsm-language-translations'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskLanguage1Route), ()=>({
                ufoName: 'service-management.languages',
                component: (0, $4c45ee4ab52677ce$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $818bcbaaddc8bfd3$export$c029d3f514c7b3e0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $467404e10c7e501f$export$59eedcca37dbbafd), (0, $8d9798e9d24a9632$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("10cgn")).customerPermissionsPageDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8d9798e9d24a9632$export$5367e40a24f0bd54)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                },
                perfMetricKey: 'jsm-customer-permissions'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute), ()=>({
                component: (0, $8d9798e9d24a9632$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("10cgn")).customerPermissionsPageDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8d9798e9d24a9632$export$5367e40a24f0bd54)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                },
                perfMetricKey: 'jsm-customer-permissions'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $f10a7d047f1802a3$export$86c8da903fb97c4f), (0, $881ebeec1a2867ea$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $881ebeec1a2867ea$export$66d0c668045080de)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskEmailRoute), ()=>({
                ufoName: 'service-management.settings.email-channels',
                component: (0, $881ebeec1a2867ea$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $881ebeec1a2867ea$export$66d0c668045080de)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute), ()=>({
                component: (0, $2f67c1468e19aedd$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2f67c1468e19aedd$export$eb662b618d6247be)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).PORTAL_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).PORTAL_SETTINGS),
                        teamName: 'jsd-shield'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute), ()=>({
                component: (0, $9da321ff59a70829$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("8CwPO")).portalSettingsContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $9da321ff59a70829$export$fdbd4b1e5ae0e422)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskExternalLinksRoute), ()=>({
                component: (0, $15bcce9a01d18cfd$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $15bcce9a01d18cfd$export$28482a53859ec466)
                ],
                perfMetricKey: 'jsm-external-resources'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $1ae3adbbf5c00734$export$8ba256148f9b998f), (0, $bf4d9e5ccdf213aa$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $bf4d9e5ccdf213aa$export$216a049c4d917b0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskWidgetRoute), ()=>({
                component: (0, $bf4d9e5ccdf213aa$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $bf4d9e5ccdf213aa$export$216a049c4d917b0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChangeManagementRoute), ()=>({
                ufoName: 'service-management.change-management-settings',
                component: (0, $8fbb06494113daae$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
                    (0, (0, parcelRequire("ejiWA")).changeManagementSettingsProjectConfigurationResource),
                    (0, (0, parcelRequire("gmE3I")).jsmChangeManagementSettingsGitLabGatingResource),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8fbb06494113daae$export$e674d93688e620b3)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute), ()=>({
                component: (0, $74652d26314b4bbc$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $74652d26314b4bbc$export$7796b6d080b8c187)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsChatRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $7c240e4106c097e5$export$22c86ddb04b1359a), (0, $955f7623ed5daf83$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $955f7623ed5daf83$export$971347f9ac02f862)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChatRoute), ()=>({
                component: (0, $955f7623ed5daf83$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $955f7623ed5daf83$export$971347f9ac02f862)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannels5Route), ()=>({
                component: (0, $73d598aaa606ce09$export$c7e6c0ac0abe2336)('customer-permissions'),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        ...(0, $e00888b39cabebc3$export$fd1a58e6255623a),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFeedbackRoute), ()=>({
                component: (0, $4b8db06fa1ed7bd1$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47),
                    (0, (0, parcelRequire("7Txnp")).LazyCsatSettingsPage)
                ],
                perfMetricKey: 'jsm-feedback-settings',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CSAT_CONFIG,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CSAT_CONFIG),
                        teamName: 'jsm-request-intake'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskForgeAppsRoute), ()=>({
                component: (0, $d4e28d950e086fee$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    ...(0, $d4e28d950e086fee$export$33d85a1b2211b38),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d4e28d950e086fee$export$ef66d3f49a9953d8)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskRedirectRoute), ()=>({
                component: (0, $a51e57eb3887507b$export$c9b0516439c55d7a)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $a51e57eb3887507b$export$586756e5c0542a50)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $ffza4;
    var $1xZqw;
    var $65Ltd;
    var $bwLf9;
    var $co1wz;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $koWFd;
    var $9s3j1;
    var $cD3jo;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $jcw0u;
    var $dIdda = parcelRequire("dIdda");
    var $dxCvy;
    const $347c2a822ae60413$export$899fd1c46031ece8 = (teamName)=>{
        const { data: data, error: resourceError, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        if (resourceError && data == null) {
            const isErrorErrorType = resourceError instanceof Error;
            const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'useResourceProjectContext',
                    packageName: 'jiraRouterResourcesProjectContext',
                    teamName: teamName ?? 'magma'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                loading: false,
                error: error,
                projectKey: null
            };
        }
        if (loading) return {
            loading: true,
            error: null,
            projectKey: null
        };
        if (data == null) return {
            loading: false,
            error: new Error('projectContextResource returned data=null when loading false'),
            projectKey: null
        };
        return {
            loading: false,
            projectKey: data.projectKey,
            error: null
        };
    };
    var $e7C7O;
    var $35Wvp;
    var $2FXLN;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $70080ab689503b6b$var$SOFTWARE_PRODUCT = 'software';
    const $70080ab689503b6b$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $70080ab689503b6b$var$boardSettingsUrl = (product)=>`${$70080ab689503b6b$var$projectSettingsUrl(product)}/boards/:boardId`;
    const $70080ab689503b6b$export$dde867834e4a9f47 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/issuetypes/:issueTypeId?`,
        exact: true
    };
    const $70080ab689503b6b$export$955e8eef6e3bccfb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes-workflow`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/issuetypes/:issueTypeId/:initialSection(workflow)`,
        exact: true
    };
    const $70080ab689503b6b$export$8ddc76f4b4e66b2b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/apps/app-fields`,
        exact: true
    };
    const $70080ab689503b6b$export$d9dea7be10efa583 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-apps`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/apps/:appId?`,
        exact: true
    };
    const $70080ab689503b6b$export$18624b8612cb673d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-details`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/details`,
        exact: true
    };
    const $70080ab689503b6b$export$9d5b42fcb82012dd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-access`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/access`,
        exact: true
    };
    const $70080ab689503b6b$export$d782b5257932a66d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-access-redirect`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/people`,
        exact: true
    };
    const $70080ab689503b6b$export$396cdbbd6f2abcea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-proforma-project-forms`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/forms`,
        exact: true
    };
    const $70080ab689503b6b$export$394d8f4806a90d7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-proforma-jira-form-builder`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/forms/form/:templateFormId/edit`,
        exact: true
    };
    const $70080ab689503b6b$export$4d430aeb28b702f8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/automate`
    };
    const $70080ab689503b6b$export$61d54e538063bb07 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-data-classifications`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/data-classifications`,
        exact: true
    };
    const $70080ab689503b6b$export$a598c3fe8cbf0c6c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-next-gen-features`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/features`,
        exact: true
    };
    const $70080ab689503b6b$export$c1d1892d6c07135a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/notifications`,
        exact: true
    };
    const $70080ab689503b6b$export$c7039de5a4b78802 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/opsgenie`,
        exact: true
    };
    const $70080ab689503b6b$export$99b695c2b8299b5a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE)}-redirect`,
        path: `/jira/${$70080ab689503b6b$var$SOFTWARE_PRODUCT}/c/projects/:projectKey/settings`
    };
    const $70080ab689503b6b$export$37e0dbac44df25b9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS),
        path: '/jira/software/c/projects/:projectKey/settings/details',
        exact: true
    };
    const $70080ab689503b6b$export$4e4a4b8762b611 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE),
        path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
        exact: true
    };
    const $70080ab689503b6b$export$e3e3877ec9c5e840 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/toolchain`,
        exact: true
    };
    const $70080ab689503b6b$export$7dbc23deac9553d4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN),
        path: '/jira/software/c/projects/:projectKey/settings/toolchain',
        exact: true
    };
    const $70080ab689503b6b$export$d4bf23ba6f4199d7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES),
        path: '/jira/software/c/projects/:projectKey/settings/features',
        exact: true
    };
    const $70080ab689503b6b$export$d4ed083331cb6e00 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL),
        path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    const $70080ab689503b6b$export$b2e044c3dffeca69 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL),
        path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    const $70080ab689503b6b$export$6ef734887b6da0c8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE),
        path: '/jira/secure/ReleaseNote.jspa',
        query: [
            'projectId',
            'version'
        ]
    };
    const $70080ab689503b6b$export$a9509017cabb1e30 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG),
        path: '/secure/ConfigureReleaseNote.jspa',
        query: [
            'projectId',
            'version'
        ]
    };
    const $70080ab689503b6b$export$a0223091962262d4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_RELEASE_NOTES),
        path: '/secure/ReleaseNote.jspa',
        query: [
            'projectId'
        ]
    };
    const $70080ab689503b6b$export$46e979217c179afd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-automation`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/automation`,
        exact: true
    };
    const $70080ab689503b6b$export$ff4977f79c273b29 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/notifications/issue-logs`,
        exact: true
    };
    const $70080ab689503b6b$export$5e2e0a895d6a14bd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS),
        path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
        query: [
            'projectId'
        ]
    };
    const $70080ab689503b6b$export$2313ca001d58ab27 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS),
        path: '/jira/software/c/projects/:projectKey/settings/forms',
        exact: true
    };
    const $70080ab689503b6b$export$811ace4fee984f0e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS),
        path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
        exact: true
    };
    const $70080ab689503b6b$export$989ca67485551616 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}`,
        exact: true
    };
    const $70080ab689503b6b$export$88e68eb447e3db49 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/columns`,
        exact: true
    };
    const $70080ab689503b6b$export$9bc9b345958a301c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/custom-filters`,
        exact: true
    };
    const $70080ab689503b6b$export$d3f185a361401db7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/card`,
        exact: true
    };
    const $70080ab689503b6b$export$17ccdaa366ec26b8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/roadmap`,
        exact: true
    };
    const $70080ab689503b6b$export$e116d6b2a5f71426 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/timeline`,
        exact: true
    };
    const $70080ab689503b6b$export$ae89a2a3aaf095ef = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: '/jira/software/c/projects/:projectKey/settings/automate'
    };
    const $70080ab689503b6b$export$f74a0b1be9d5b9f6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS),
        path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    const $70080ab689503b6b$export$8559c4a0b692890e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN),
        path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    const $70080ab689503b6b$export$7ce9914683cb1572 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-redirect`,
        path: `/jira/${$70080ab689503b6b$var$SOFTWARE_PRODUCT}/projects/:projectKey/settings`
    };
    const $70080ab689503b6b$export$ad2c16468a73b68 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/fields`,
        exact: true
    };
    var $d0oNj;
    var $kfztd;
    var $e7bC3;
    var $dIdda = parcelRequire("dIdda");
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $dAfqg;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ab1da42a9104ecee$export$fa3bc297af95f169 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ghg5c"))), {
        moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
    });
    var $ab1da42a9104ecee$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ab1da42a9104ecee$export$fa3bc297af95f169,
            pageId: "project-settings-app-discovery-settings",
            shouldShowSpinner: false
        });
    const $c49a5a5e07aed0ac$export$246ec9cdadd2a163 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9RXCH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $c49a5a5e07aed0ac$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        return shouldRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
            push: false
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ab1da42a9104ecee$export$2e2bcd8739ae039), null);
    };
    const $c49a5a5e07aed0ac$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c49a5a5e07aed0ac$var$ConnectAppsRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $c49a5a5e07aed0ac$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c49a5a5e07aed0ac$export$246ec9cdadd2a163,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0d3ebe2f9030fc49$export$3633e017e520a1c2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    var $0d3ebe2f9030fc49$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0d3ebe2f9030fc49$export$3633e017e520a1c2,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $11c79a07a4ec83b8$export$9d468faf674a5201 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5Dbz7")), {
        moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
    });
    var $11c79a07a4ec83b8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11c79a07a4ec83b8$export$9d468faf674a5201,
            pageId: "devops-connections-settings",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f25068ef108ee62d$export$de293ea44d0410ca = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("haLpa"))), {
        moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
    });
    var $f25068ef108ee62d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f25068ef108ee62d$export$de293ea44d0410ca,
            pageId: "project-settings-csm",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $26928850e3bfb37f$export$7e21d36a9d4548e6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("d6oA5")), {
        moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
    });
    var $26928850e3bfb37f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $26928850e3bfb37f$export$7e21d36a9d4548e6,
            pageId: "project-settings-custom-filters",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $81cf21747f4c944d$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2igd7"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $81cf21747f4c944d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $81cf21747f4c944d$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5dcf6caa5da05571$export$6f16b5efddd5c646 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kVevk"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    var $5dcf6caa5da05571$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5dcf6caa5da05571$export$6f16b5efddd5c646,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $628b742891e4f718$export$e309780f520d125a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("NWARb"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    var $628b742891e4f718$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $628b742891e4f718$export$e309780f520d125a,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $dxCvy;
    var $5j7Th;
    var $kxZPA;
    const $fa6a5556191902b5$export$ef66d3f49a9953d8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $fa6a5556191902b5$export$33d85a1b2211b38 = [
        (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
        (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource)
    ];
    const $fa6a5556191902b5$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fa6a5556191902b5$export$ef66d3f49a9953d8,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    var $fa6a5556191902b5$export$2e2bcd8739ae039 = $fa6a5556191902b5$export$b943f48844c671a5;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8f1b2ea450c47b3b$export$36dcfb52d47cb93a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("61LFA"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $8f1b2ea450c47b3b$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f1b2ea450c47b3b$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4700cd79d99e02ea$export$dea5ad7e8eac12ae = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    var $4700cd79d99e02ea$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4700cd79d99e02ea$export$dea5ad7e8eac12ae,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $dab3ab2feb1de470$export$ca5dba69148b337 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7rq9z")), {
        moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
    });
    var $dab3ab2feb1de470$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $dab3ab2feb1de470$export$ca5dba69148b337,
            pageId: "link-opsgenie-page",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4e545f86ddd60f53$export$da4d608b99858bfc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8DLRI"))), {
        moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
    });
    var $4e545f86ddd60f53$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4e545f86ddd60f53$export$da4d608b99858bfc,
            pageId: "project-settings-next-gen-features",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $6e8f6f53c599ad60$export$ea7d73c94d9369f4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bm5Zl"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    var $6e8f6f53c599ad60$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6e8f6f53c599ad60$export$ea7d73c94d9369f4,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $3671536b80f548b9$export$7eee4f97b7a1273 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b3T21"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $3671536b80f548b9$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
            push: false
        });
    const $3671536b80f548b9$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3671536b80f548b9$var$PeopleAccessRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3671536b80f548b9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3671536b80f548b9$export$7eee4f97b7a1273,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $1J3t1;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $dIdda = parcelRequire("dIdda");
    const $3caec8e095a44ec5$export$b7262fe486f4b412 = 'core';
    const $3caec8e095a44ec5$export$2954328f6207617a = 'software';
    const $3caec8e095a44ec5$export$5575497f0592ee94 = 'servicedesk';
    const $3caec8e095a44ec5$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $3caec8e095a44ec5$export$586756e5c0542a50 = (product)=>{
        if (product === $3caec8e095a44ec5$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $3caec8e095a44ec5$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    const $3caec8e095a44ec5$export$fb15a6ba8980fdac = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
        });
    };
    const $3caec8e095a44ec5$export$f9befa0a4925b36d = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4bec2fc264f66dc5$export$40ff283c032abbc4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("juWe0")), {
        moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
    });
    var $4bec2fc264f66dc5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4bec2fc264f66dc5$export$40ff283c032abbc4,
            pageId: "board-settings-card",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $50cd29d3245ccefc$export$8eca5454e72ee961 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hR0vX")), {
        moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
    });
    var $50cd29d3245ccefc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $50cd29d3245ccefc$export$8eca5454e72ee961,
            pageId: "board-settings-roadmap",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $c3a9ed7dcac6be32$export$a7d63246a10aedd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9Saqg")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    var $c3a9ed7dcac6be32$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c3a9ed7dcac6be32$export$a7d63246a10aedd,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $97406b66ba2de080$export$38414b624a749cec = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2Js68")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    var $97406b66ba2de080$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $97406b66ba2de080$export$38414b624a749cec,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $576f902bdb908a77$export$69a64a29d67ca160 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3oy92"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
    });
    var $576f902bdb908a77$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $576f902bdb908a77$export$69a64a29d67ca160,
            pageId: "project-settings-software-notifications",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $lmyls;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e5cbde6b3cad4f8b$export$cd8964bea0e3c2 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $6adcc3494d7c3774$export$97bbdefcbe0571ac),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $e5cbde6b3cad4f8b$export$6960a46ebd209756 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1Nsfq"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
    });
    const $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e5cbde6b3cad4f8b$export$6960a46ebd209756,
            pageId: "project-settings-software-notifications-issue-logs",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $48f5bfd32d483aba$export$cb608e3696682e76 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l00Ww"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    var $48f5bfd32d483aba$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $48f5bfd32d483aba$export$cb608e3696682e76,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $70eea33e6c09b198$export$79fe16f960f3d89f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2tVe2"))), {
        moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
    });
    const $70eea33e6c09b198$export$8e6f565615e921dd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $70eea33e6c09b198$export$79fe16f960f3d89f,
            pageId: "classic-features",
            shouldShowSpinner: true
        });
    const $0acb8447d437de85$var$BoardSettingsRedirectToCSM = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
            push: false
        });
    const $0acb8447d437de85$var$RoadmapSettingsRedirectToTimelineSettings = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
            push: false
        });
    const $0acb8447d437de85$var$SpaReleaseNoteRedirectToVersionDetails = ({ query: query })=>{
        const { version: versionId } = query;
        const { loading: loading, error: error, projectKey: projectKey } = (0, $347c2a822ae60413$export$899fd1c46031ece8)();
        if (loading === false && error) return null;
        if (loading) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                    isReleaseNoteModalOpen: true
                })
            }
        });
    };
    const $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect = ({ query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: '/secure/ReleaseNote.jspa',
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                    ...query,
                    isRedirectedFromLegacy: true
                })
            }
        });
    const $0acb8447d437de85$var$ufoNamesMap = {
        'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
        'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
    };
    const $0acb8447d437de85$var$getUFOName = (name)=>$0acb8447d437de85$var$ufoNamesMap[name] || name;
    const $0acb8447d437de85$var$commonRouteEntries = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$dde867834e4a9f47), ()=>({
                ufoName: $0acb8447d437de85$var$getUFOName(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes`),
                component: (0, $8f1b2ea450c47b3b$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8f1b2ea450c47b3b$export$36dcfb52d47cb93a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$955e8eef6e3bccfb), ()=>({
                component: (0, $48f5bfd32d483aba$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8f1b2ea450c47b3b$export$36dcfb52d47cb93a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$8ddc76f4b4e66b2b), ()=>({
                component: (0, $c49a5a5e07aed0ac$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c49a5a5e07aed0ac$export$246ec9cdadd2a163)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$d9dea7be10efa583), ()=>({
                component: (0, $0d3ebe2f9030fc49$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0d3ebe2f9030fc49$export$3633e017e520a1c2)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$18624b8612cb673d), ()=>({
                component: (0, $5dcf6caa5da05571$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5dcf6caa5da05571$export$6f16b5efddd5c646)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$ad2c16468a73b68), ()=>({
                ufoName: 'project-settings.fields.jsw-tmp',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', (0, $628b742891e4f718$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a)),
                    (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $628b742891e4f718$export$e309780f520d125a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$9d5b42fcb82012dd), ()=>({
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsAccessSkeleton),
                component: (0, $3671536b80f548b9$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3671536b80f548b9$export$7eee4f97b7a1273)
                ],
                ufoName: 'project-settings.access'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$d782b5257932a66d), ()=>({
                component: (0, $3671536b80f548b9$export$45346ed2aa24e3f3)(`/jira/${(0, $3caec8e095a44ec5$export$2954328f6207617a)}`),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3671536b80f548b9$export$7eee4f97b7a1273)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$396cdbbd6f2abcea), ()=>({
                component: (0, $97406b66ba2de080$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $97406b66ba2de080$export$38414b624a749cec)
                ],
                perfMetricKey: 'forms-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$394d8f4806a90d7), ()=>({
                component: (0, $c3a9ed7dcac6be32$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c3a9ed7dcac6be32$export$a7d63246a10aedd)
                ],
                perfMetricKey: 'form-builder'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$4d430aeb28b702f8), ()=>({
                ufoName: `project-settings-automation-${0, $3caec8e095a44ec5$export$2954328f6207617a}`,
                component: (0, $4700cd79d99e02ea$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4700cd79d99e02ea$export$dea5ad7e8eac12ae)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$61d54e538063bb07), ()=>({
                component: (0, $81cf21747f4c944d$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $81cf21747f4c944d$export$b8abcf8aa8f4df56)
                ]
            }))
    ];
    const $0acb8447d437de85$export$792d387b9973c378 = [
        ...$0acb8447d437de85$var$commonRouteEntries,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$37e0dbac44df25b9), ()=>({
                component: (0, $5dcf6caa5da05571$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5dcf6caa5da05571$export$6f16b5efddd5c646)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$a598c3fe8cbf0c6c), ()=>({
                ufoName: 'project-settings.next-gen-features',
                component: (0, $4e545f86ddd60f53$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4e545f86ddd60f53$export$da4d608b99858bfc)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$c1d1892d6c07135a), ()=>({
                ufoName: 'project-settings.software.notifications',
                component: (0, $576f902bdb908a77$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $576f902bdb908a77$export$69a64a29d67ca160)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$ff4977f79c273b29), ()=>({
                ufoName: 'project-settings.software.notifications.issue-logs',
                component: (0, $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e5cbde6b3cad4f8b$export$6960a46ebd209756)
                ],
                entryPoint () {
                    return (0, (0, parcelRequire("co1wz")).ff)('jlovep-692-changes-to-project-settings-notifications-page_jqk18') ? (0, $e5cbde6b3cad4f8b$export$cd8964bea0e3c2) : undefined;
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$c7039de5a4b78802), ()=>({
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $dab3ab2feb1de470$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $dab3ab2feb1de470$export$ca5dba69148b337)
                ],
                ufoName: 'project-settings.link-opsgenie'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$4e4a4b8762b611), ()=>({
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $dab3ab2feb1de470$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $dab3ab2feb1de470$export$ca5dba69148b337)
                ],
                ufoName: 'project-settings.link-opsgenie'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$e3e3877ec9c5e840), ()=>({
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $11c79a07a4ec83b8$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a)),
                    (0, (0, parcelRequire("35Wvp")).projectSettingsToolchainResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $11c79a07a4ec83b8$export$9d468faf674a5201)
                ],
                ufoName: 'project-settings.devops-connections'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$7dbc23deac9553d4), ()=>({
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $11c79a07a4ec83b8$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("35Wvp")).projectSettingsToolchainResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $11c79a07a4ec83b8$export$9d468faf674a5201)
                ],
                ufoName: 'project-settings.devops-connections'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$d4bf23ba6f4199d7), ()=>({
                ufoName: 'classic-features-page',
                component: (0, $70eea33e6c09b198$export$8e6f565615e921dd),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $70eea33e6c09b198$export$79fe16f960f3d89f)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$5e2e0a895d6a14bd), ()=>({
                ufoName: 'project-settings.classic-issue-logs-page',
                component: (0, $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e5cbde6b3cad4f8b$export$6960a46ebd209756)
                ],
                entryPoint () {
                    return (0, (0, parcelRequire("co1wz")).ff)('jlovep-692-changes-to-project-settings-notifications-page_jqk18') ? (0, $e5cbde6b3cad4f8b$export$cd8964bea0e3c2) : undefined;
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$d4ed083331cb6e00), ()=>({
                component: (0, $6e8f6f53c599ad60$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $70eea33e6c09b198$export$79fe16f960f3d89f),
                    (0, $6e8f6f53c599ad60$export$ea7d73c94d9369f4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$b2e044c3dffeca69), ()=>({
                component: (0, $3caec8e095a44ec5$export$fb15a6ba8980fdac),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$6ef734887b6da0c8), ()=>({
                resources: [
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$a9509017cabb1e30), ()=>({
                resources: [
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$a0223091962262d4), ()=>({
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$SpaReleaseNoteRedirectToVersionDetails,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$46e979217c179afd), ()=>({
                component: (0, $4700cd79d99e02ea$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4700cd79d99e02ea$export$dea5ad7e8eac12ae)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$2313ca001d58ab27), ()=>({
                component: (0, $97406b66ba2de080$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $97406b66ba2de080$export$38414b624a749cec)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$811ace4fee984f0e), ()=>({
                component: (0, $c3a9ed7dcac6be32$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c3a9ed7dcac6be32$export$a7d63246a10aedd)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$989ca67485551616), ()=>({
                component: $0acb8447d437de85$var$BoardSettingsRedirectToCSM,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                isRedirect: true,
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$88e68eb447e3db49), ()=>({
                ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
                component: (0, $f25068ef108ee62d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f25068ef108ee62d$export$de293ea44d0410ca)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$9bc9b345958a301c), ()=>({
                ufoName: 'project-settings.custom-filters',
                component: (0, $26928850e3bfb37f$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a)),
                    (0, (0, parcelRequire("cD3jo")).customFiltersResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $26928850e3bfb37f$export$7e21d36a9d4548e6)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$d3f185a361401db7), ()=>({
                ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
                component: (0, $4bec2fc264f66dc5$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a)),
                    (0, (0, parcelRequire("1xZqw")).cardCoverImageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4bec2fc264f66dc5$export$40ff283c032abbc4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$17ccdaa366ec26b8), ()=>({
                component: $0acb8447d437de85$var$RoadmapSettingsRedirectToTimelineSettings,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a)),
                    (0, (0, parcelRequire("2FXLN")).roadmapSettingsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $50cd29d3245ccefc$export$8eca5454e72ee961)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$e116d6b2a5f71426), ()=>({
                ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
                component: (0, $50cd29d3245ccefc$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a)),
                    (0, (0, parcelRequire("2FXLN")).roadmapSettingsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $50cd29d3245ccefc$export$8eca5454e72ee961)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$ae89a2a3aaf095ef), ()=>({
                ufoName: 'project-settings-automation-c',
                component: (0, $4700cd79d99e02ea$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4700cd79d99e02ea$export$dea5ad7e8eac12ae)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$f74a0b1be9d5b9f6), ()=>({
                component: (0, $fa6a5556191902b5$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    ...(0, $fa6a5556191902b5$export$33d85a1b2211b38)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $fa6a5556191902b5$export$ef66d3f49a9953d8)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$8559c4a0b692890e), ()=>({
                component: (0, $fa6a5556191902b5$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a)),
                    ...(0, $fa6a5556191902b5$export$33d85a1b2211b38)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $fa6a5556191902b5$export$ef66d3f49a9953d8)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$7ce9914683cb1572), ()=>({
                component: (0, $3caec8e095a44ec5$export$fb15a6ba8980fdac),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $70080ab689503b6b$export$99b695c2b8299b5a), ()=>({
                component: (0, $3caec8e095a44ec5$export$f9befa0a4925b36d),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)((0, $3caec8e095a44ec5$export$2954328f6207617a))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            }))
    ];
    const $512b517449862f9e$export$fd0ef3739cde76c1 = [
        ...(0, $0acb8447d437de85$export$792d387b9973c378),
        ...(0, $c40db1734fa3af79$export$37a8204dc4094049),
        ...(0, $f037ab3fb0896e94$export$4bad3905623f839b)
    ];
    var $ffza4;
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $7a169ab056601f38$var$LazyViewsNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kSJIO")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
    });
    const $7a169ab056601f38$export$b43adc74b6a33bde = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-views-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7a169ab056601f38$var$LazyViewsNav, null));
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $f5kpo;
    var $bHhiy;
    var $dxCvy;
    var $fpjJX;
    var $f7Y15;
    var $gNStA;
    var $gAdgD;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $65Ltd;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $f5ee330ac2d6dd15$export$bb5ed4e7838cf30c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("40EFi"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
    });
    const $f5ee330ac2d6dd15$export$6828c4b2d0ff0d5d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gf8DN"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/legacy-board-settings/src/index.tsx"
    });
    const $f5ee330ac2d6dd15$export$f058c0d1561d67f3 = (props)=>{
        const { route: route, query: query } = props;
        if (route.name !== (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS)) return null;
        const allowedConfigurations = [
            'columns',
            'filter',
            'quickFilters',
            'swimlanes',
            'cardColors',
            'cardLayout',
            'dateFields'
        ];
        if (query.config && !allowedConfigurations.includes(query.config)) {
            const { config: config, ...restQuery } = query;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: {
                    pathname: props.location.pathname,
                    hash: '',
                    search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                        ...restQuery,
                        config: 'columns'
                    })
                }
            });
        }
        return query.config ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f5ee330ac2d6dd15$export$6828c4b2d0ff0d5d,
            pageId: "spa-apps/servicedesk/boards/legacy-board-settings",
            shouldShowSpinner: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f5ee330ac2d6dd15$export$bb5ed4e7838cf30c,
            pageId: "spa-apps/servicedesk/boards/board",
            shouldShowSpinner: true
        });
    };
    const $21abfb8c9573f56b$export$848a32cf0fcf8a61 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gAdgD")).jsmBoardRoute), ()=>({
            component: (0, $f5ee330ac2d6dd15$export$f058c0d1561d67f3),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            skeleton: (0, $cff09f53ee9f2bb4$export$631611c5fdf027d5),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f5ee330ac2d6dd15$export$bb5ed4e7838cf30c),
                (0, $f5ee330ac2d6dd15$export$6828c4b2d0ff0d5d)
            ],
            perfMetricKey: 'servicedesk-boards-load',
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $7a169ab056601f38$export$b43adc74b6a33bde),
                horizontalFeatureFlag: 'jsm_views_of_work_phase_1'
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!false, (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ]
        }));
    const $21abfb8c9573f56b$export$97cc5f4d7ce032e1 = [
        $21abfb8c9573f56b$export$848a32cf0fcf8a61
    ];
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $jYeNO;
    var $f7Y15;
    var $gNStA;
    var $65Ltd;
    const $27449eef2998018e$export$28a386a00670c893 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR),
        path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $7172661a469aabc5$exports = {};
    $7172661a469aabc5$exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();
    const $56d7fe900d1fd6dd$export$49d3670908a8d8fe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7172661a469aabc5$exports)))
        });
    var $lmyls;
    var $4R6GH;
    var $eufEc;
    var $fEDBv;
    const $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
    const $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
    const $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
    function $d491739a1b7483c1$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
        return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
    }
    function $d491739a1b7483c1$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $d491739a1b7483c1$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $d491739a1b7483c1$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
        const { cloudId: cloudId } = tenantContext;
        return {
            type: 'board',
            boardId: $d491739a1b7483c1$var$toBoardAri({
                siteId: cloudId,
                boardId: String(context.match.params.boardId)
            }),
            projectKeys: [
                String(context.match.params.projectKey)
            ],
            viewId: viewId
        };
    }
    function $d491739a1b7483c1$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        return {
            ids: [
                scope.boardId
            ],
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
    }
    function $d491739a1b7483c1$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $d491739a1b7483c1$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $d491739a1b7483c1$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, viewId: viewId }) {
        return {
            date: $d491739a1b7483c1$var$toMidnightUTCString(selectedDate),
            mode: $d491739a1b7483c1$var$toViewMode(viewRange),
            weekStart: $d491739a1b7483c1$var$toWeekStart(weekStartsOn),
            viewId: viewId
        };
    }
    function $d491739a1b7483c1$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
        const viewId = $d491739a1b7483c1$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
        return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
    }
    function $d491739a1b7483c1$var$getStorageValue(storageKey) {
        if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
        return '';
    }
    function $d491739a1b7483c1$var$buildIssuesSearchInput(storageKey) {
        return {
            additionalFilterQuery: $d491739a1b7483c1$var$getStorageValue(storageKey) || ''
        };
    }
    function $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d491739a1b7483c1$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $d491739a1b7483c1$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    function $d491739a1b7483c1$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
        return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
    }
    const $d491739a1b7483c1$export$19cf4b398f638dc6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("5H96Q")), {
            moduleId: "7a55ad65"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId, activationId: activationId } = tenantContext;
            const { date: date } = context.query;
            const selectedDate = $d491739a1b7483c1$var$toDate(date);
            const { boardId: boardId, projectKey: projectKey } = context.match.params;
            if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
            const viewId = $d491739a1b7483c1$var$buildViewId({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId
            });
            const scope = $d491739a1b7483c1$var$createScope(entryPointRouteParams, viewId || '');
            const storageKeyForIssueSearchInput = $d491739a1b7483c1$var$buildStorageKey({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId,
                featureKey: $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
            });
            const storageKeyForViewSettings = $d491739a1b7483c1$var$buildStorageKey({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId,
                featureKey: $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY
            });
            const defaultViewRange = 'month';
            const storedConfig = $d491739a1b7483c1$var$getStorageValue(storageKeyForViewSettings);
            const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
                viewRange: defaultViewRange,
                weekStartsOn: null,
                dayStartsAt: $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT,
                showWeekends: false,
                showIssueKey: true,
                showIn24HourClock: false,
                colorBy: 'status'
            };
            const viewRange = (0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_jsm_calendar_weekly_view') ? viewSettingsConfig.viewRange ?? 'month' : 'month';
            const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
            const colorBy = viewSettingsConfig.colorBy ?? 'status';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            const issuesSearchInput = $d491739a1b7483c1$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $122674b135b0c50b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $d491739a1b7483c1$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $d491739a1b7483c1$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                viewId: viewId
                            }),
                            issuesSearchInput: issuesSearchInput,
                            unscheduledIssuesSearchInput: $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $d491739a1b7483c1$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $d491739a1b7483c1$var$buildSprintsSearchInput(),
                            skipSprintSearch: false,
                            skipVersionSearch: false,
                            viewId: viewId,
                            ...(0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_jsm_calendar_weekly_view') && {
                                skipFieldConfig: false
                            },
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    dayStartsAt: viewSettingsConfig.dayStartsAt,
                    issueEventFields: issueEventFields,
                    projectKey: projectKey,
                    storageKeyForViewSettings: storageKeyForViewSettings,
                    storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                    showWeekends: viewSettingsConfig.showWeekends,
                    showIssueKey: viewSettingsConfig.showIssueKey,
                    showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                    colorBy: colorBy
                }
            };
        }
    });
    const $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d491739a1b7483c1$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $f8d239e17d56a4ee$export$6e125037f42a1f62 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $27449eef2998018e$export$28a386a00670c893), ()=>({
                ufoName: 'jsm-calendar',
                component: ()=>null,
                skeleton: (0, $56d7fe900d1fd6dd$export$49d3670908a8d8fe),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, $7a169ab056601f38$export$b43adc74b6a33bde),
                    horizontalFeatureFlag: 'jsm_views_of_work_phase_1'
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("jYeNO")).getCalendarFilterFieldsResource)(),
                    (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_weekly_view_fast_follow') && !false, (0, (0, parcelRequire("f7Y15")).uifBoardResource))
                ],
                entryPoint: ()=>(0, $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7),
                meta: {
                    reporting: {
                        id: 'calendar',
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CALENDAR),
                        teamName: 'jsd-shield'
                    }
                }
            }))
    ];
    var $ffza4;
    var $co1wz;
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $f4b0e9313c9342f0$export$d9802671a2b1aa20 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9SdDk")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
    });
    const $f4b0e9313c9342f0$export$d4493569f106c71 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsNav",
            packageName: "jiraHorizontalNavJsmOperations",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f4b0e9313c9342f0$export$d9802671a2b1aa20, null)));
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $2pT4g;
    var $fpjJX;
    var $gNStA;
    var $8obNZ;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4uj5r"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
    });
    var $f705f6e0ca7ffaf5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb,
            pageId: "spa-apps/servicedesk/change-calendar",
            shouldShowSpinner: true
        });
    const $788999c1ce4d32cc$export$38a3aa80b813d565 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8obNZ")).servicedeskChangeCalendarRoute), ()=>({
                ufoName: 'service-management.change-calendar',
                component: (0, $f705f6e0ca7ffaf5$export$2e2bcd8739ae039),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, $f4b0e9313c9342f0$export$d4493569f106c71),
                    onlyShowHorizontalOnNav4: true
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb),
                    (0, $f4b0e9313c9342f0$export$d9802671a2b1aa20)
                ],
                meta: {
                    reporting: {
                        id: 'changeCalendar',
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CHANGE_CALENDAR),
                        teamName: 'jenga'
                    }
                }
            }))
    ];
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $9QpK7;
    var $4R6GH;
    var $2BrOV;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $d99ccdcd3c9cebe4$export$2260a0528570f8da = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("8ym2X")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
    });
    const $d99ccdcd3c9cebe4$var$AssetsReportsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "assets-reports-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d99ccdcd3c9cebe4$export$2260a0528570f8da, null)));
    $d99ccdcd3c9cebe4$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
    var $d99ccdcd3c9cebe4$export$2e2bcd8739ae039 = $d99ccdcd3c9cebe4$var$AssetsReportsSidebar;
    var $3HwlS;
    var $2G9Bk;
    var $6j0IA;
    var $3RJkv;
    var $fpjJX;
    var $8naTI;
    var $gNStA;
    var $5lsNZ;
    var $65Ltd;
    const $344e7e7ebd923c11$export$152b5dead07808bc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets',
        exact: true
    };
    const $344e7e7ebd923c11$export$1efada07b7203f2d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight',
        exact: true
    };
    const $344e7e7ebd923c11$export$8629431cf690fe39 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/reports',
        exact: true
    };
    const $344e7e7ebd923c11$export$a075d8b7c4c55c41 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/reports/:templateId',
        exact: true
    };
    const $344e7e7ebd923c11$export$66ab60d374e8e458 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
        exact: true
    };
    const $344e7e7ebd923c11$export$246ae573df78317e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
    };
    const $344e7e7ebd923c11$export$fcde60ded71d4ae6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
    };
    const $344e7e7ebd923c11$export$73b901e16d5e5a02 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
    };
    const $344e7e7ebd923c11$export$12e89d5d79d59785 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
    };
    const $344e7e7ebd923c11$export$9f6d42997c66cc4b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/configure/global'
    };
    const $344e7e7ebd923c11$export$96e5da52356f214c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/configure/global'
    };
    const $344e7e7ebd923c11$export$b4a150d67181752 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
    };
    const $344e7e7ebd923c11$export$f6b688a8729943b3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
    };
    const $344e7e7ebd923c11$export$e960ab4fcd3e80b6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/configure'
    };
    const $344e7e7ebd923c11$export$620f0fb687461e6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/object/:objectId'
    };
    const $344e7e7ebd923c11$export$223f5bacfd3d39fd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/assets/:objectId'
    };
    var $e9YVH;
    var $gRzZD;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $9872d73b74d97014$export$8075d4042713bf6d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5Bl21")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
    });
    const $9872d73b74d97014$var$InsightConfigure = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9872d73b74d97014$export$8075d4042713bf6d,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure",
            shouldShowSpinner: true
        });
    var $9872d73b74d97014$export$2e2bcd8739ae039 = $9872d73b74d97014$var$InsightConfigure;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $14de2d11a3985015$export$926956539e1f72ba = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("YkbdD")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
    });
    const $14de2d11a3985015$var$InsightConfigureObjectType = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $14de2d11a3985015$export$926956539e1f72ba,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
            shouldShowSpinner: true
        });
    var $14de2d11a3985015$export$2e2bcd8739ae039 = $14de2d11a3985015$var$InsightConfigureObjectType;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $faa956883f49da96$export$b80bd807bad3fd0a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5A72l")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
    });
    const $faa956883f49da96$var$GlobalConfigure = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $faa956883f49da96$export$b80bd807bad3fd0a,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure",
            shouldShowSpinner: true
        });
    var $faa956883f49da96$export$2e2bcd8739ae039 = $faa956883f49da96$var$GlobalConfigure;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3371db153f9530b2$export$f6c79e6ff37913ee = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eOYiU")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
    });
    const $3371db153f9530b2$var$LandingPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3371db153f9530b2$export$f6c79e6ff37913ee,
            pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
            shouldShowSpinner: true
        });
    var $3371db153f9530b2$export$2e2bcd8739ae039 = $3371db153f9530b2$var$LandingPage;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3afd4c2d86bdef54$export$411c1981ced22249 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8oQUA")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
    });
    const $3afd4c2d86bdef54$export$3c208f927c6178ee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3afd4c2d86bdef54$export$411c1981ced22249,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
            shouldShowSpinner: true
        });
    var $3afd4c2d86bdef54$export$2e2bcd8739ae039 = $3afd4c2d86bdef54$export$3c208f927c6178ee;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ylQhQ")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
    });
    const $3c1950a2c10ba0ce$export$f90a4f33c79fd86e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
            shouldShowSpinner: true
        });
    var $3c1950a2c10ba0ce$export$2e2bcd8739ae039 = $3c1950a2c10ba0ce$export$f90a4f33c79fd86e;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $af13a504c251f159$export$8305a1bc1c5bee45 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c3dxs")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
    });
    const $af13a504c251f159$var$ObjectSchemaConfiguration = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $af13a504c251f159$export$8305a1bc1c5bee45,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
            shouldShowSpinner: true
        });
    var $af13a504c251f159$export$2e2bcd8739ae039 = $af13a504c251f159$var$ObjectSchemaConfiguration;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hpGQh")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$2534c3e9f8e70d0d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hpGQh")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$dec85f15dd805ac4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5tvXj")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$c56cfef9aa68df09 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hpGQh")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$d45b40d40442434 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$541b39e6d5be07df = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$dec85f15dd805ac4,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$4155da54bfeacf74 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$2534c3e9f8e70d0d,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$9d28551695f98cae = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$c56cfef9aa68df09,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
            shouldShowSpinner: true
        });
    const $e1936f201d69a18a$var$sharedRouteProps = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).INSIGHT
        }
    };
    function $e1936f201d69a18a$var$getCmdbResources() {
        const servicedeskPageContextResources = (0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)().map((resource)=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('add_service_desk_page_context_resources'), resource));
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            ...servicedeskPageContextResources,
            (0, (0, parcelRequire("gRzZD")).workspaceResource)
        ];
    }
    const $e1936f201d69a18a$export$5d38cb53852f589a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$152b5dead07808bc), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $3371db153f9530b2$export$2e2bcd8739ae039),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3371db153f9530b2$export$f6c79e6ff37913ee)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$1efada07b7203f2d), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $3371db153f9530b2$export$2e2bcd8739ae039),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3371db153f9530b2$export$f6c79e6ff37913ee)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$8629431cf690fe39), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, $2e02aa1a19501df5$export$9d28551695f98cae), (0, $2e02aa1a19501df5$export$4155da54bfeacf74)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("gRzZD")).workspaceResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2e02aa1a19501df5$export$2534c3e9f8e70d0d),
                    (0, $2e02aa1a19501df5$export$c56cfef9aa68df09)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                        teamName: 'ITSM SAGA'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$a075d8b7c4c55c41), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('jsm-assets-reporting_seqk0', (0, $2e02aa1a19501df5$export$d45b40d40442434), (0, (0, parcelRequire("5lsNZ")).default)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("gRzZD")).workspaceResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                    sidebar: (0, $d99ccdcd3c9cebe4$export$2e2bcd8739ae039)
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS),
                        teamName: 'ITSM SAGA'
                    }
                },
                perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$66ab60d374e8e458), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $2e02aa1a19501df5$export$541b39e6d5be07df),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("gRzZD")).workspaceResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2e02aa1a19501df5$export$dec85f15dd805ac4)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                        teamName: 'ITSM SAGA'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$246ae573df78317e), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $3c1950a2c10ba0ce$export$f90a4f33c79fd86e),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc)
                ],
                perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$fcde60ded71d4ae6), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $3c1950a2c10ba0ce$export$f90a4f33c79fd86e),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc)
                ],
                perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$73b901e16d5e5a02), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $14de2d11a3985015$export$2e2bcd8739ae039),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $14de2d11a3985015$export$926956539e1f72ba)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                        teamName: 'falcons'
                    }
                },
                ufoName: 'service-management.insight-cmdb-object-type-configuration'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$12e89d5d79d59785), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $14de2d11a3985015$export$2e2bcd8739ae039),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $14de2d11a3985015$export$926956539e1f72ba)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                        teamName: 'falcons'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$9f6d42997c66cc4b), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                ufoName: 'servicedesk-cmdb-assets-configure',
                component: (0, $faa956883f49da96$export$2e2bcd8739ae039),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $faa956883f49da96$export$b80bd807bad3fd0a)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                        teamName: 'falcons'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$96e5da52356f214c), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                ufoName: 'servicedesk-cmdb-insight-configure-global',
                component: (0, $faa956883f49da96$export$2e2bcd8739ae039),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $faa956883f49da96$export$b80bd807bad3fd0a)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                        teamName: 'falcons'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$b4a150d67181752), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $af13a504c251f159$export$2e2bcd8739ae039),
                resources: [
                    ...$e1936f201d69a18a$var$getCmdbResources(),
                    (0, (0, parcelRequire("6j0IA")).serviceDeskAssetsImportTypeForgeDataResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $af13a504c251f159$export$8305a1bc1c5bee45)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                        teamName: 'krispy-krew'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$f6b688a8729943b3), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $af13a504c251f159$export$2e2bcd8739ae039),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $af13a504c251f159$export$8305a1bc1c5bee45)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                        teamName: 'krispy-krew'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$e960ab4fcd3e80b6), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                ufoName: 'servicedesk-cmdb-insight-configure',
                component: (0, $9872d73b74d97014$export$2e2bcd8739ae039),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $9872d73b74d97014$export$8075d4042713bf6d)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$620f0fb687461e6), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $3afd4c2d86bdef54$export$3c208f927c6178ee),
                resources: [
                    ...$e1936f201d69a18a$var$getCmdbResources(),
                    (0, (0, parcelRequire("8naTI")).insightObjectResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3afd4c2d86bdef54$export$411c1981ced22249)
                ],
                perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
                ufoName: 'service-management.insight-cmdb.object-view-page-load'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $344e7e7ebd923c11$export$223f5bacfd3d39fd), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, $3afd4c2d86bdef54$export$3c208f927c6178ee),
                resources: [
                    ...$e1936f201d69a18a$var$getCmdbResources(),
                    (0, (0, parcelRequire("8naTI")).insightObjectResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3afd4c2d86bdef54$export$411c1981ced22249)
                ],
                perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
                ufoName: 'service-management.insight-cmdb.object-view-page-load'
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $8a9a109143c89aa7$export$1f409a894343952a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT),
        path: '/jira/servicedesk/create-project',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5j7Th;
    var $kxZPA;
    const $9e649f3a8eb5dbcb$export$5004e0d4f1e57790 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3pzt9")), {
        moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
    });
    const $9e649f3a8eb5dbcb$export$ffae8a2776195524 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9e649f3a8eb5dbcb$export$5004e0d4f1e57790,
            pageId: "spa-apps/servicedesk/create-project",
            shouldShowSpinner: true
        });
    const $9e649f3a8eb5dbcb$export$ac25abe07ac3f570 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8a9a109143c89aa7$export$1f409a894343952a), ()=>({
            isRedirect: true,
            component: $9e649f3a8eb5dbcb$export$ffae8a2776195524,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9e649f3a8eb5dbcb$export$5004e0d4f1e57790
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CREATE_PROJECT,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CREATE_PROJECT),
                    teamName: 'itops-mithril'
                }
            }
        }));
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $fcMlY;
    var $4lqmX;
    var $aqQrr;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $11e345ce4933debe$export$864b519a4059ac6b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("22OMj"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customers-v2/src/index.tsx"
    });
    const $11e345ce4933debe$export$ac54d7814cf71dd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11e345ce4933debe$export$864b519a4059ac6b,
            pageId: "spa-apps/servicedesk/customers-v2",
            shouldShowSpinner: true
        });
    const $11e345ce4933debe$export$6c5749ec31de847d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kEVl8"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
    });
    const $11e345ce4933debe$export$2412523c0e3657cc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11e345ce4933debe$export$6c5749ec31de847d,
            pageId: "spa-apps/servicedesk/customer-details",
            shouldShowSpinner: true
        });
    const $dfe6b7b99f3a840b$var$getCustomersRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        });
    const $dfe6b7b99f3a840b$export$6811a8ea7ba7651c = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aqQrr")).servicedeskCustomerDetailsRoute), ()=>({
                ...$dfe6b7b99f3a840b$var$getCustomersRoutesCommon(),
                component: (0, $11e345ce4933debe$export$2412523c0e3657cc),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $11e345ce4933debe$export$6c5749ec31de847d)
                ],
                perfMetricKey: 'jsm-customer-details-component-load',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_DETAILS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_DETAILS),
                        teamName: 'boysenberry'
                    }
                },
                resources: [
                    ...$dfe6b7b99f3a840b$var$getCustomersRoutesCommon().resources,
                    (0, (0, parcelRequire("fcMlY")).entitlementsCustomerQueryResource),
                    (0, (0, parcelRequire("4lqmX")).uiCustomerDetailsPageQueryResource)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aqQrr")).servicedeskCustomersV2Route), ()=>({
                ...$dfe6b7b99f3a840b$var$getCustomersRoutesCommon(),
                component: (0, $11e345ce4933debe$export$ac54d7814cf71dd),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $11e345ce4933debe$export$864b519a4059ac6b)
                ],
                perfMetricKey: 'jsm-customers-component-load',
                ufoName: 'jsm-customers-component-load',
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, $c28aa1a42d481780$export$a237f415539577a5),
                    onlyShowHorizontalOnNav4: true
                }
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $7MCPm;
    var $3e6VG;
    var $6Z2mh;
    const $0649b6fa57429fc5$export$8810bfd4f6a0eb22 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3e6VG")).projectServiceDeskRoute), ()=>({
            isRedirect: true,
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $co1wz;
    var $lmyls;
    var $ggg5j;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $k8jl5;
    var $5lsNZ;
    var $em9Nv;
    var $6Z2mh;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $980ce1cbc2c3fd94$exports = {};
    $980ce1cbc2c3fd94$exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();
    const $31c65c680f020453$var$customCssStyles = null;
    const $31c65c680f020453$export$525669daa9599ec = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($980ce1cbc2c3fd94$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
            ])
        });
    var $eufEc;
    var $fEDBv;
    const $7b51534336e501eb$export$a91a58d8bb93ad8e = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("kPaTc")), {
            moduleId: "99c912b0"
        }),
        getPreloadProps: ()=>({})
    });
    const $02546523c21c0f5a$var$gettingStartedPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $7b51534336e501eb$export$a91a58d8bb93ad8e),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $02546523c21c0f5a$export$9f5707c751b4b364 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("em9Nv")).gspPageRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            perfMetricKey: 'servicedesk-getting-started-page-load',
            skeleton: (0, $31c65c680f020453$export$525669daa9599ec),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("k8jl5")).servicedeskIssueTypesResource)
            ],
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('getting_started_page_production_rollout') ? $02546523c21c0f5a$var$gettingStartedPageEntryPoint : undefined;
            },
            component: (0, (0, parcelRequire("5lsNZ")).default)
        }));
    const $02546523c21c0f5a$export$abec122151c24b1b = [
        $02546523c21c0f5a$export$9f5707c751b4b364
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $b3a7b13fb49a20b0$export$5bc288fedb880892 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE),
        path: '/jira/servicedesk/itsm-sample-space',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5j7Th;
    var $kxZPA;
    const $ae7116290a20432f$export$c1a5da0c35411fc1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6xxAH")), {
        moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
    });
    const $ae7116290a20432f$export$389e7e12a5ae9f5a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ae7116290a20432f$export$c1a5da0c35411fc1,
            pageId: "spa-apps/servicedesk/itsm-sample-space",
            shouldShowSpinner: true
        });
    const $ae7116290a20432f$export$61ad481262acd4e6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b3a7b13fb49a20b0$export$5bc288fedb880892), ()=>({
            isRedirect: true,
            component: $ae7116290a20432f$export$389e7e12a5ae9f5a,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ae7116290a20432f$export$c1a5da0c35411fc1
            ],
            perfMetricKey: 'jsm-sample-space-landing-page',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ITSM_SAMPLE_SPACE,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ITSM_SAMPLE_SPACE),
                    teamName: 'itops-mithril'
                }
            }
        }));
    var $ffza4;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bjZiV;
    var $bHhiy;
    var $fpjJX;
    var $cp8Sv;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7877fae2c22be3a0$export$c73ba7e80a805fb2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iBHYJ"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
    });
    var $7877fae2c22be3a0$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7877fae2c22be3a0$export$c73ba7e80a805fb2,
            pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0ed31e41bd08d12a$export$a488cba75f18ade8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fziFe"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
    });
    var $0ed31e41bd08d12a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0ed31e41bd08d12a$export$a488cba75f18ade8,
            pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cbedf43cff0d751d$export$c01a896b8d33aa9c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dOIFm"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
    });
    var $cbedf43cff0d751d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cbedf43cff0d751d$export$c01a896b8d33aa9c,
            pageId: "spa-apps/servicedesk/knowledge-hub/category",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e2e95eba21898c94$export$53decb9d1eb60aed = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jyJvE"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
    });
    var $e2e95eba21898c94$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e2e95eba21898c94$export$53decb9d1eb60aed,
            pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $398a28a595927246$export$35c6d2a033ef4c42 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5mJ01"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
    });
    var $398a28a595927246$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $398a28a595927246$export$35c6d2a033ef4c42,
            pageId: "knowledge-article-embed-editor",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f59132c22330e6a8$export$f1266a588cfc310b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aMpsr")), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
    });
    var $f59132c22330e6a8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f59132c22330e6a8$export$f1266a588cfc310b,
            pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4cd10b3eae0d5ed2$export$6c08040d2dc71e43 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("b1HFH")), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
    });
    var $4cd10b3eae0d5ed2$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4cd10b3eae0d5ed2$export$6c08040d2dc71e43,
            pageId: "spa-apps/servicedesk/knowledge-hub/setup",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $70c4d3c688caba8c$export$aee7d96c2ee4c388 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dChOr"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
    });
    const $70c4d3c688caba8c$export$ee4623542ebd573e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $70c4d3c688caba8c$export$aee7d96c2ee4c388,
            pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8c5dbaffda117c43$export$efd0ec49853aa81 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1bWBT"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
    });
    var $8c5dbaffda117c43$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8c5dbaffda117c43$export$efd0ec49853aa81,
            pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
            shouldShowSpinner: true
        });
    const $3898d1cf01d349b6$var$getKnowledgeHubResources = ()=>[
            ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $3898d1cf01d349b6$export$f1453c3517242ca1 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubLandingRoute), ()=>({
                component: (0, $f59132c22330e6a8$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f59132c22330e6a8$export$f1266a588cfc310b)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_LANDING,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_LANDING),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubBrowseAllArticlesRoute), ()=>({
                component: (0, $7877fae2c22be3a0$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7877fae2c22be3a0$export$c73ba7e80a805fb2)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubDraftsRoute), ()=>({
                component: (0, $e2e95eba21898c94$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e2e95eba21898c94$export$53decb9d1eb60aed)
                ],
                perfMetricKey: 'service-management.kb-drafts',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_DRAFTS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_DRAFTS),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubBrowseAllCategoriesRoute), ()=>({
                component: (0, $0ed31e41bd08d12a$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0ed31e41bd08d12a$export$a488cba75f18ade8)
                ],
                perfMetricKey: 'service-management.kb-categories',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_CATEGORIES,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_CATEGORIES),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubSuggestedArticlesRoute), ()=>({
                component: (0, $70c4d3c688caba8c$export$ee4623542ebd573e),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $70c4d3c688caba8c$export$aee7d96c2ee4c388)
                ],
                perfMetricKey: 'service-management.kb-suggested-articles',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SUGGESTED_ARTICLES,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SUGGESTED_ARTICLES),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubBrowseViewArticleRoute), ()=>({
                perfMetricKey: 'service-management.knowledge.article',
                component: (0, $8c5dbaffda117c43$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8c5dbaffda117c43$export$efd0ec49853aa81)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubArticleEmbedEditorRoute), ()=>({
                component: (0, $398a28a595927246$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $398a28a595927246$export$35c6d2a033ef4c42)
                ],
                perfMetricKey: 'service-management.knowledge.ep-editor'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubAllArticlesRoute), ()=>({
                component: (0, $7877fae2c22be3a0$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7877fae2c22be3a0$export$c73ba7e80a805fb2)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubArticleInCategoryRoute), ()=>({
                perfMetricKey: 'service-management.knowledge.article',
                component: (0, $8c5dbaffda117c43$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8c5dbaffda117c43$export$efd0ec49853aa81)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubCategoryPageRoute), ()=>({
                component: (0, $cbedf43cff0d751d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $cbedf43cff0d751d$export$c01a896b8d33aa9c)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubCategoryRoute), ()=>({
                ufoName: 'service-management.knowledge.category',
                component: (0, $cbedf43cff0d751d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $cbedf43cff0d751d$export$c01a896b8d33aa9c)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubSearchRoute), ()=>({
                component: (0, $8c5dbaffda117c43$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8c5dbaffda117c43$export$efd0ec49853aa81)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubSetupRoute), ()=>({
                component: (0, $4cd10b3eae0d5ed2$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4cd10b3eae0d5ed2$export$6c08040d2dc71e43)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SETUP,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SETUP),
                        teamName: 'jsm-nebula'
                    }
                }
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $jdXuV;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ce165317fbb6ef87$export$69cba5247233f8bc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kdN12"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
    });
    const $ce165317fbb6ef87$export$1139895a5af7252e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ce165317fbb6ef87$export$69cba5247233f8bc,
            pageId: "spa-apps/servicedesk/notification-logs",
            shouldShowSpinner: true
        });
    const $9a0a57cbd9b1e94a$export$20ab3a955246df95 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jdXuV")).notificationLogsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, $ce165317fbb6ef87$export$1139895a5af7252e),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ce165317fbb6ef87$export$69cba5247233f8bc)
            ],
            perfMetricKey: 'jsm-notification-logs-component-load'
        }));
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $ehdxd;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $816d970487a82139$export$e8392650fdcd92d5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7v5JQ")), {
        moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
    });
    var $816d970487a82139$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $816d970487a82139$export$e8392650fdcd92d5,
            pageId: "spa-apps/servicedesk/opsgenie-schedule",
            shouldShowSpinner: true
        });
    const $2d418c3509154618$export$8e210af71fea11c9 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ehdxd")).servicedeskOncallScheduleRoute), ()=>({
                ufoName: 'service-management.on-call-schedule',
                component: (0, $816d970487a82139$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, $f4b0e9313c9342f0$export$d4493569f106c71),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $816d970487a82139$export$e8392650fdcd92d5),
                    (0, $f4b0e9313c9342f0$export$d9802671a2b1aa20)
                ]
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $38BXB;
    var $7CBZS;
    var $fpjJX;
    var $6x0wo;
    var $65Ltd;
    const $d9e085eda1fa5205$export$7f878f9aeac61f1e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
        path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f3c20d8fbb399193$export$1c7fcdb58f42db03 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jNSqy"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
    });
    const $f3c20d8fbb399193$export$5f69663d85db303d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f3c20d8fbb399193$export$1c7fcdb58f42db03,
            pageId: "spa-apps/servicedesk/organization-v2",
            shouldShowSpinner: true
        });
    const $aa95243ee0dbcb5f$export$f32a63b509fcdb4f = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d9e085eda1fa5205$export$7f878f9aeac61f1e), ()=>({
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("6x0wo")).serviceDeskOrganizationPanelForgeDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                    (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
                ],
                component: (0, $f3c20d8fbb399193$export$5f69663d85db303d),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f3c20d8fbb399193$export$1c7fcdb58f42db03)
                ],
                perfMetricKey: 'jsm-organizations-component-load'
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $38BXB;
    var $7CBZS;
    var $fpjJX;
    var $8XgXN;
    var $iTeMQ;
    var $9cIRM;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b9e14ed4e63c050e$export$b40b4bfa472057b9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bOoEj"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
    });
    const $b9e14ed4e63c050e$export$4abec67d7b34dda2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b9e14ed4e63c050e$export$b40b4bfa472057b9,
            pageId: "spa-apps/servicedesk/organizations",
            shouldShowSpinner: true
        });
    const $b9e14ed4e63c050e$export$4a01866152e4a375 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3bziv"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
    });
    const $b9e14ed4e63c050e$export$709be875ca0a7ead = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b9e14ed4e63c050e$export$4a01866152e4a375,
            pageId: "spa-apps/servicedesk/organization-details",
            shouldShowSpinner: true
        });
    const $dd0cd7c738b6ffe2$var$getOrganizationsRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        });
    const $dd0cd7c738b6ffe2$export$7dd191d527f3ef6f = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9cIRM")).servicedeskOrganizationDetailsRoute), ()=>({
                ...$dd0cd7c738b6ffe2$var$getOrganizationsRoutesCommon(),
                component: (0, $b9e14ed4e63c050e$export$709be875ca0a7ead),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b9e14ed4e63c050e$export$4a01866152e4a375)
                ],
                perfMetricKey: 'jsm-organization-details-component-load',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATION_DETAILS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATION_DETAILS),
                        teamName: 'boysenberry'
                    }
                },
                resources: [
                    ...$dd0cd7c738b6ffe2$var$getOrganizationsRoutesCommon().resources,
                    (0, (0, parcelRequire("8XgXN")).entitlementsOrganizationQueryResource),
                    (0, (0, parcelRequire("iTeMQ")).uiOrganizationDetailsPageQueryResource),
                    (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                    (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9cIRM")).servicedeskOrganizationsRoute), ()=>({
                ...$dd0cd7c738b6ffe2$var$getOrganizationsRoutesCommon(),
                component: (0, $b9e14ed4e63c050e$export$4abec67d7b34dda2),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b9e14ed4e63c050e$export$b40b4bfa472057b9)
                ],
                perfMetricKey: 'jsm-organizations-component-load',
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, $c28aa1a42d481780$export$a237f415539577a5),
                    onlyShowHorizontalOnNav4: true
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATIONS),
                        teamName: 'boysenberry'
                    }
                }
            }))
    ];
    var $7XYc4;
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $5lsNZ;
    var $2bP5L;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $e0304552cabc8d2c$exports = {};
    $e0304552cabc8d2c$exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();
    const $c888779b3c2a7055$export$93a223cf4712c63d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($e0304552cabc8d2c$exports)))
        });
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $15ffffad92965566$export$95a2fe4e495efca5 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("aObDz")), {
            moduleId: "ac794fd1"
        }),
        getPreloadProps: ()=>({})
    });
    const $cfa42f0318b6392e$export$ae7c241893e7dab9 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $15ffffad92965566$export$95a2fe4e495efca5),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $09da2704609fb0f6$export$cef6a6370e56c273 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2bP5L")).servicedeskProjectSummaryRoute), ()=>({
                ufoName: 'jsm.project-summary',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm-project-summary'), ()=>null, (0, (0, parcelRequire("5lsNZ")).default)),
                skeleton: (0, $c888779b3c2a7055$export$93a223cf4712c63d),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm-project-summary') ? (0, $cfa42f0318b6392e$export$ae7c241893e7dab9) : undefined,
                meta: {
                    reporting: {
                        id: 'project-summary',
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).PROJECT_SUMMARY),
                        teamName: 'jsd-shield'
                    }
                }
            }))
    ];
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $1XrjK;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $co1wz;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $1XrjK;
    var $jlOGG;
    var $bHhiy;
    var $2pT4g;
    var $fpjJX;
    var $aNLeB;
    var $gNStA;
    var $aIkD8;
    var $6Z2mh;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9ff5a714e8ce1079$var$LazyServicedeskQueuesAgentAndIssueView = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6SxPM"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
    });
    const $9ff5a714e8ce1079$export$59d555419fbaa611 = ({ match: match })=>{
        const queueId = match.params && match.params.queueId || '';
        const issueKey = match.params && match.params.issueKey || '';
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9ff5a714e8ce1079$var$LazyServicedeskQueuesAgentAndIssueView,
            pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    const $9ff5a714e8ce1079$export$54a295e04e6cea33 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aIkD8")).customQueueRoute), ()=>({
            component: $9ff5a714e8ce1079$export$59d555419fbaa611,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    params: [
                        {
                            key: 'issueKey'
                        }
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("aNLeB")).servicedeskIsItsmProjectResource)
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9ff5a714e8ce1079$var$LazyServicedeskQueuesAgentAndIssueView
            ]
        }));
    const $9ff5a714e8ce1079$export$b43128c9b5db2a5e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aIkD8")).customPracticeQueueRoute), ()=>({
            component: $9ff5a714e8ce1079$export$59d555419fbaa611,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    params: [
                        {
                            key: 'issueKey'
                        }
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
            ],
            afterPaint: [
                (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9ff5a714e8ce1079$var$LazyServicedeskQueuesAgentAndIssueView
            ]
        }));
    var $65Ltd;
    const $601c5f22bc0f8f6f$export$e146d4ae5415aa9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$52b4c044e4929ebc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$c1908994722d1e73 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
        query: [
            'parentId?'
        ],
        exact: true
    };
    const $601c5f22bc0f8f6f$export$f8fd3a1f8c33aff8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$52a24b9cf42d208b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $601c5f22bc0f8f6f$export$7f30d40b906894c5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
        path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$1465f05b88a63f13 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
        path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$3c859c71be33b36c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$8595a5452f93a1fd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
        query: [
            'parentId?'
        ],
        exact: true
    };
    const $601c5f22bc0f8f6f$export$125e0ab662806584 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$dfaa99f66db1aa2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$38a6ee0f22e74bf3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6cc059f7849819d9$export$451a7cce84b6b1e6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ajfQi")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
    });
    var $6cc059f7849819d9$export$2e2bcd8739ae039 = ({ match: match })=>{
        const addonKey = match.params && match.params.addonKey || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6cc059f7849819d9$export$451a7cce84b6b1e6,
            pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
            shouldShowSpinner: true
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $093d629913ef6b8e$export$c050b699bf9e3e40 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ifEQP"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
    });
    var $093d629913ef6b8e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $093d629913ef6b8e$export$c050b699bf9e3e40,
            pageId: "spa-apps/servicedesk/queues/create",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $deaadf08ad128234$export$5bb02347e0261e6a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fseMQ"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
    });
    var $deaadf08ad128234$export$2e2bcd8739ae039 = ({ match: match })=>{
        const queueId = match.params && match.params.queueId || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $deaadf08ad128234$export$5bb02347e0261e6a,
            pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
            shouldShowSpinner: true
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $e8099257b5d2aca0$export$164f2dfdd8dc056b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9gDVS")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
    });
    var $e8099257b5d2aca0$export$2e2bcd8739ae039 = ({ match: match })=>{
        const issueKey = `/${match.params && match.params.issueKey || ''}`;
        const queueId = `/${match.params && match.params.queueId || ''}`;
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e8099257b5d2aca0$export$164f2dfdd8dc056b,
            pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $33ab495a6069d0db$export$bdf522692228bb6f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6d9hm")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
    });
    var $33ab495a6069d0db$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $33ab495a6069d0db$export$bdf522692228bb6f,
            pageId: "spa-apps/servicedesk/queues/landing",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ad9d634f0cdcf391$export$9f1e189198f08c4a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("diKh2"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
    });
    var $ad9d634f0cdcf391$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ad9d634f0cdcf391$export$9f1e189198f08c4a,
            pageId: "spa-apps/servicedesk/queues/manage",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3e1702b77575d903$export$52593b5917c5e179 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gcllV")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
    });
    var $3e1702b77575d903$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3e1702b77575d903$export$52593b5917c5e179,
            pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
            shouldShowSpinner: true
        });
    const $9e240ff8903b873c$export$91a360c2f7f83db9 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$e146d4ae5415aa9), ()=>({
                component: (0, $3e1702b77575d903$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3e1702b77575d903$export$52593b5917c5e179)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$52b4c044e4929ebc), ()=>({
                isRedirect: true,
                component: (0, $33ab495a6069d0db$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $33ab495a6069d0db$export$bdf522692228bb6f)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$c1908994722d1e73), ()=>({
                component: (0, $093d629913ef6b8e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $093d629913ef6b8e$export$c050b699bf9e3e40)
                ],
                ufoName: 'service-management.queues.new'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$f8fd3a1f8c33aff8), ()=>({
                component: (0, $deaadf08ad128234$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $deaadf08ad128234$export$5bb02347e0261e6a)
                ],
                ufoName: 'service-management.queues.edit'
            })),
        (0, $9ff5a714e8ce1079$export$54a295e04e6cea33),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$52a24b9cf42d208b), ()=>({
                component: (0, $e8099257b5d2aca0$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        params: [
                            {
                                key: 'issueKey'
                            }
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e8099257b5d2aca0$export$164f2dfdd8dc056b)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$7f30d40b906894c5), ()=>({
                component: (0, $ad9d634f0cdcf391$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: (0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $ad9d634f0cdcf391$export$9f1e189198f08c4a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$1465f05b88a63f13), ()=>({
                component: (0, $6cc059f7849819d9$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6cc059f7849819d9$export$451a7cce84b6b1e6)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$3c859c71be33b36c), ()=>({
                isRedirect: true,
                component: (0, $33ab495a6069d0db$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $33ab495a6069d0db$export$bdf522692228bb6f)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$8595a5452f93a1fd), ()=>({
                component: (0, $093d629913ef6b8e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $093d629913ef6b8e$export$c050b699bf9e3e40)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$125e0ab662806584), ()=>({
                component: (0, $ad9d634f0cdcf391$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: (0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $ad9d634f0cdcf391$export$9f1e189198f08c4a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$dfaa99f66db1aa2), ()=>({
                component: (0, $deaadf08ad128234$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $deaadf08ad128234$export$5bb02347e0261e6a)
                ]
            })),
        (0, $9ff5a714e8ce1079$export$b43128c9b5db2a5e),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $601c5f22bc0f8f6f$export$38a6ee0f22e74bf3), ()=>({
                component: (0, $e8099257b5d2aca0$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)()),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e8099257b5d2aca0$export$164f2dfdd8dc056b)
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $7XYc4;
    var $lmyls;
    var $3HwlS;
    var $h0bZU;
    var $2G9Bk;
    var $1XrjK;
    var $jlOGG;
    var $bjZiV;
    var $bHhiy;
    var $hejqw;
    var $fpjJX;
    var $jaWUd;
    var $6Z2mh;
    var $e9YVH;
    var $dIdda = parcelRequire("dIdda");
    const $11b6f5430511c7a8$export$e4c007d05145b8c2 = '/reports/all-rating';
    const $11b6f5430511c7a8$export$5daa28d10e23592 = '/:issueKey';
    const $11b6f5430511c7a8$export$ddc580d759168f88 = '/reports/workload';
    const $11b6f5430511c7a8$export$13bdc187fca9c33e = '/reports';
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7131a1cafe24fb0a$export$75e043cf7a4e3661 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ldZL8")), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
    });
    var $7131a1cafe24fb0a$export$2e2bcd8739ae039 = ({ match: match })=>{
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7131a1cafe24fb0a$export$75e043cf7a4e3661,
            pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8afe4cbad132cc61$export$78ffe2f6530d45d1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gPETo"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
    });
    const $8afe4cbad132cc61$export$6d23a188bb96b7ab = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8afe4cbad132cc61$export$78ffe2f6530d45d1,
            pageId: "spa-apps/servicedesk/atlassian-analytics",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $940ea7d208fcfce4$export$3ec5c3d7729889b9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cRCTf"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
    });
    var $940ea7d208fcfce4$export$2e2bcd8739ae039 = ({ match: match })=>{
        const reportType = match.params.reportType || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $940ea7d208fcfce4$export$3ec5c3d7729889b9,
            pageId: `spa-apps/servicedesk/reports/${reportType}`,
            shouldShowSpinner: true
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0aaa6fdfa8d01159$export$821b8201b24f8b7d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4r62a"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
    });
    var $0aaa6fdfa8d01159$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0aaa6fdfa8d01159$export$821b8201b24f8b7d,
            pageId: "spa-apps/servicedesk/reports/custom/create",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $db3dd114755c3f65$export$53def03ace9a6c5b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2EqEW"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
    });
    var $db3dd114755c3f65$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { reportId: reportId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $db3dd114755c3f65$export$53def03ace9a6c5b,
            pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
            shouldShowSpinner: true
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2636e09e0764ad56$export$121b9cfb2b001a53 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7gVww"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
    });
    var $2636e09e0764ad56$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2636e09e0764ad56$export$121b9cfb2b001a53,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$13bdc187fca9c33e)}}`,
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7281c34e15a34d51$export$c2f0d3c59c9d3bf3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lNm0S")), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
    });
    var $7281c34e15a34d51$export$2e2bcd8739ae039 = ({ match: match })=>{
        const issueKey = `/${match.params && match.params.issueKey || ''}`;
        const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7281c34e15a34d51$export$c2f0d3c59c9d3bf3,
            pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $12e91a60aa9991e2$export$f86e12b111395ad = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("il0ku"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
    });
    var $12e91a60aa9991e2$export$2e2bcd8739ae039 = ({ match: match })=>{
        const reportType = match.params.reportType || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $12e91a60aa9991e2$export$f86e12b111395ad,
            pageId: `spa-apps/servicedesk/reports/${reportType}`,
            shouldShowSpinner: true
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $66f1c14673116eb8$export$8edc7b9d922cd22f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fLZPu"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
    });
    var $66f1c14673116eb8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $66f1c14673116eb8$export$8edc7b9d922cd22f,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$e4c007d05145b8c2)}}`,
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d985dd949edfaeac$export$e805fb47fdcd991 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("huJzT"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
    });
    var $d985dd949edfaeac$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d985dd949edfaeac$export$e805fb47fdcd991,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$ddc580d759168f88)}}`,
            shouldShowSpinner: true
        });
    const $78d2bc6933594b61$var$DefaultReportsRedirect = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $11b6f5430511c7a8$export$ddc580d759168f88)}`
        });
    const $78d2bc6933594b61$var$returnToSummary = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: String(match.params['0'])
        });
    const $78d2bc6933594b61$var$getReportsWithKbResources = ()=>[
            ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $78d2bc6933594b61$export$721a27be140cb34d = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsSummaryRoute), ()=>({
                component: $78d2bc6933594b61$var$returnToSummary,
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReports1Route), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, $2636e09e0764ad56$export$2e2bcd8739ae039), $78d2bc6933594b61$var$DefaultReportsRedirect),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$78d2bc6933594b61$var$getReportsWithKbResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2636e09e0764ad56$export$121b9cfb2b001a53)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskAtlassianAnalyticsRoute), ()=>({
                component: (0, $8afe4cbad132cc61$export$6d23a188bb96b7ab),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("hejqw")).servicedeskAtlassianAnalyticsResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8afe4cbad132cc61$export$78ffe2f6530d45d1)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ATLASSIAN_ANALYTICS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ATLASSIAN_ANALYTICS),
                        teamName: 'ITSM Saga'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsWorkloadRoute), ()=>({
                component: (0, $d985dd949edfaeac$export$2e2bcd8739ae039),
                perfMetricKey: 'service-management.reports.workload',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d985dd949edfaeac$export$e805fb47fdcd991)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsSatisfactionIssueRoute), ()=>({
                component: (0, $7281c34e15a34d51$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)()),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7281c34e15a34d51$export$c2f0d3c59c9d3bf3)
                ],
                ufoName: 'service-management.reports.issue'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsSatisfactionTimeScaleRoute), ()=>({
                perfMetricKey: 'service-management.reports.satisfaction',
                component: (0, $66f1c14673116eb8$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $66f1c14673116eb8$export$8edc7b9d922cd22f)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsSatisfaction2Route), ()=>({
                perfMetricKey: 'service-management.reports.satisfaction',
                component: (0, $66f1c14673116eb8$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $66f1c14673116eb8$export$8edc7b9d922cd22f)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskKbRequestsReportsIssueRoute), ()=>({
                component: (0, $7281c34e15a34d51$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)()),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7281c34e15a34d51$export$c2f0d3c59c9d3bf3)
                ],
                ufoName: 'service-management.reports.issue'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskKbRequestsReportsTimeScaleRoute), ()=>({
                perfMetricKey: 'service-management.reports.kb-requests',
                component: (0, $12e91a60aa9991e2$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $12e91a60aa9991e2$export$f86e12b111395ad)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskKbRequestsReports2Route), ()=>({
                perfMetricKey: 'service-management.reports.kb-requests',
                component: (0, $12e91a60aa9991e2$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $12e91a60aa9991e2$export$f86e12b111395ad)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustomEditRoute), ()=>({
                perfMetricKey: 'service-management.reports.custom-edit-view',
                component: (0, $db3dd114755c3f65$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $db3dd114755c3f65$export$53def03ace9a6c5b)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustomCreateRoute), ()=>({
                perfMetricKey: 'service-management.reports.custom-create',
                component: (0, $0aaa6fdfa8d01159$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0aaa6fdfa8d01159$export$821b8201b24f8b7d)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustomIssueRoute), ()=>({
                component: (0, $7281c34e15a34d51$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)()),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, $181a8d0a7b0b72cc$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7281c34e15a34d51$export$c2f0d3c59c9d3bf3)
                ],
                ufoName: 'service-management.reports.issue'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustomTimeScaleRoute), ()=>({
                component: (0, $940ea7d208fcfce4$export$2e2bcd8739ae039),
                perfMetricKey: 'service-management.reports.custom',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $940ea7d208fcfce4$export$3ec5c3d7729889b9)
                ],
                ufoName: 'service-management-custom-reports'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustom4Route), ()=>({
                component: (0, $940ea7d208fcfce4$export$2e2bcd8739ae039),
                perfMetricKey: 'service-management.reports.custom',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $940ea7d208fcfce4$export$3ec5c3d7729889b9)
                ],
                ufoName: 'service-management-custom-reports'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsTypeRoute), ()=>({
                component: (0, $7131a1cafe24fb0a$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        params: [
                            {
                                key: 'issueKey'
                            }
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$78d2bc6933594b61$var$getReportsWithKbResources(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7131a1cafe24fb0a$export$75e043cf7a4e3661)
                ]
            }))
    ];
    var $78d2bc6933594b61$export$2e2bcd8739ae039 = (0, $7131a1cafe24fb0a$export$2e2bcd8739ae039);
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $fpjJX;
    var $HWK76;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $cd397b20b9604e50$export$7f4092c8e7b7d3ec = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dPmqq")), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
    });
    var $cd397b20b9604e50$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cd397b20b9604e50$export$7f4092c8e7b7d3ec,
            pageId: "spa-apps/servicedesk/service-create-modal",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b6f27b3727e127d8$export$b154597f29589502 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4tHC0"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
    });
    var $b6f27b3727e127d8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b6f27b3727e127d8$export$b154597f29589502,
            pageId: "spa-apps/servicedesk/service-details",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0bd916f0e88ab362$export$ba1931edde0ce20c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("c3xXH"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
    });
    var $0bd916f0e88ab362$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bd916f0e88ab362$export$ba1931edde0ce20c,
            pageId: "spa-apps/servicedesk/service-details",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ca64a28173fa79b9$export$8984aadca7e15d1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3TJga")), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
    });
    var $ca64a28173fa79b9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ca64a28173fa79b9$export$8984aadca7e15d1,
            pageId: "spa-apps/servicedesk/service-update-modal",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6f003aeaf484cf06$export$4aa60213b3477cf6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eOZlH")), {
        moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
    });
    var $6f003aeaf484cf06$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6f003aeaf484cf06$export$4aa60213b3477cf6,
            pageId: "spa-apps/servicedesk/services",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $be661d3f8fec3b0f$export$fc385e1392a8e28 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("04A9b")), {
        moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
    });
    var $be661d3f8fec3b0f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $be661d3f8fec3b0f$export$fc385e1392a8e28,
            pageId: "spa-apps/servicedesk/services",
            shouldShowSpinner: true
        });
    const $7aec6a0c589216f2$export$837d7aa221731e74 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).servicedeskServicesRoute), ()=>({
                ufoName: 'service-management.services',
                component: (0, $6f003aeaf484cf06$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, $f4b0e9313c9342f0$export$d4493569f106c71),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f4b0e9313c9342f0$export$d9802671a2b1aa20),
                    (0, $6f003aeaf484cf06$export$4aa60213b3477cf6)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).servicedeskServiceDetailsRoute), ()=>({
                ufoName: 'service-management.service-details',
                component: (0, $b6f27b3727e127d8$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b6f27b3727e127d8$export$b154597f29589502)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).serviceDeskServicesWithoutProjectRoute), ()=>({
                ufoName: 'service-management.services-without-project',
                component: (0, $be661d3f8fec3b0f$export$2e2bcd8739ae039),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $be661d3f8fec3b0f$export$fc385e1392a8e28)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).serviceDeskServiceDetailsWithoutProjectRoute), ()=>({
                ufoName: 'service-management.service-details-without-project',
                component: (0, $0bd916f0e88ab362$export$2e2bcd8739ae039),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0bd916f0e88ab362$export$ba1931edde0ce20c)
                ]
            }))
    ];
    const $7aec6a0c589216f2$export$27385b29970830e7 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).servicedeskServiceModalNewRoute), ()=>({
                component: (0, $cd397b20b9604e50$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $cd397b20b9604e50$export$7f4092c8e7b7d3ec)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).servicedeskServiceModalEditRoute), ()=>({
                component: (0, $ca64a28173fa79b9$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $ca64a28173fa79b9$export$8984aadca7e15d1)
                ]
            }))
    ];
    const $7aec6a0c589216f2$export$57d6fec357eb220c = [
        ...$7aec6a0c589216f2$export$837d7aa221731e74,
        ...$7aec6a0c589216f2$export$27385b29970830e7
    ];
    const $6b03ae00f6427f42$export$b4944bd787708b82 = [
        ...(0, $3898d1cf01d349b6$export$f1453c3517242ca1),
        ...(0, $78d2bc6933594b61$export$721a27be140cb34d),
        ...(0, $9e240ff8903b873c$export$91a360c2f7f83db9),
        ...(0, $21abfb8c9573f56b$export$97cc5f4d7ce032e1),
        ...(0, $02546523c21c0f5a$export$abec122151c24b1b),
        ...(0, $7aec6a0c589216f2$export$57d6fec357eb220c),
        ...(0, $dfe6b7b99f3a840b$export$6811a8ea7ba7651c),
        ...(0, $dd0cd7c738b6ffe2$export$7dd191d527f3ef6f),
        ...(0, $aa95243ee0dbcb5f$export$f32a63b509fcdb4f),
        ...(0, $2d418c3509154618$export$8e210af71fea11c9),
        ...(0, $788999c1ce4d32cc$export$38a3aa80b813d565),
        ...(0, $f8d239e17d56a4ee$export$6e125037f42a1f62),
        ...(0, $09da2704609fb0f6$export$cef6a6370e56c273),
        ...(0, $e1936f201d69a18a$export$5d38cb53852f589a),
        (0, $9a0a57cbd9b1e94a$export$20ab3a955246df95),
        (0, $4d90b5804d47f5f4$export$72138a83eeba68eb),
        (0, $0649b6fa57429fc5$export$8810bfd4f6a0eb22),
        (0, $ae7116290a20432f$export$61ad481262acd4e6),
        (0, $9e649f3a8eb5dbcb$export$ac25abe07ac3f570)
    ];
    const $26bc22beafcfd5a4$export$d47aca795954578 = ()=>[
            ...(0, $4d90b5804d47f5f4$export$b069a1c4b0240172),
            ...(0, $a901f652fe0a27d8$export$b1d92ac5cda62e7e),
            ...(0, $1f4b902ae477a058$export$688b56fcbc2637ac),
            ...(0, $a401463e87f56f84$export$44e0cb320cb148ed),
            ...(0, $983d5942deafccf1$export$23e1ab8ae95bd3a8),
            ...(0, $983d5942deafccf1$export$d06c2ab36705e562),
            ...(0, $d1067266a88b60d4$export$5b4e616b6b4b672a),
            ...(0, $512b517449862f9e$export$fd0ef3739cde76c1),
            ...(0, $1b9e218c54e1d874$export$debd9f352e8a3e70),
            ...(0, $0e0d75857105a821$export$fb2091db9e7f9102),
            ...(0, $e8fc18994c4f5903$export$c9b96dd6f5a7b454),
            (0, $5e1b97c402b9e85a$export$f7d3667678a21360),
            ...(0, $5e1b97c402b9e85a$export$fdccb6efc62198e6),
            (0, $5e1de5a76ddb2c35$export$abd0bbe95839baf7),
            ...(0, $1f4483ba9d8ac23e$export$f9a1f59ec7d1f215),
            ...(0, $671f611e278b4662$export$fd3c71e3bfb4df9e)(),
            ...(0, $0946abf0655b0a01$export$2763334cca1560d7),
            (0, $6799e9dd8b372fc2$export$e275b3ca0c6ccb5e),
            (0, $6799e9dd8b372fc2$export$cef770e7c16cfcc),
            (0, $83f9e73406def487$export$703b5090da478c9c),
            (0, $372b1d7617217f20$export$415552b116808717),
            (0, $f9946918a701eac6$export$578dcb61ac3cb57a),
            (0, $a8fe8d7b4d12b7ef$export$76b74d5744e69817),
            (0, $de227c172beddad9$export$5379c026da4201e6),
            (0, $c38858cd7db392da$export$2740cfaa979353b9),
            (0, $1b01c2efc4945821$export$ae258fb8ec2c1f86),
            (0, $7f2f7b5455866fc1$export$219b6cc00b2f91a0),
            (0, $06c044741f640b75$export$27d1f352c2f7acae),
            (0, $1257e9ea29a7eb00$export$4df9f9dcaf8565c9),
            (0, $06c044741f640b75$export$f52136d9a0848792),
            (0, $49dffa5818f3dec0$export$dc5f9e3c3931cc36),
            ...(0, $07a2f1e51a24c4ff$export$445f7414e382a69c),
            (0, $793958c8c0cec75f$export$47b3bdf88a7d176b),
            (0, $c035d1074a7f086e$export$5b0670f37204a43d),
            (0, $5a7f40c2fa85616b$export$e60f53ff5ae626cd),
            (0, $5a7f40c2fa85616b$export$25cf284456caeeef),
            (0, $5874d8a4e3dac2e3$export$72497f4e39dd0df4),
            (0, $57f6bcf0c0b40681$export$982bc443ef89cc3f),
            (0, $654ebb131c30ba2a$export$28887e2da22c839a),
            (0, $c850b44c9898a4f7$export$4791201b4877aa5d),
            (0, $b563891c809eb2df$export$babf32528ef518e9),
            (0, $b563891c809eb2df$export$6e8865417e6a38c),
            (0, $ad2b1e4948a3529a$export$95ed5e2f774d3f79),
            (0, $d33ce51d8c4b9036$export$f128c1c4a1f0d631),
            (0, $d33ce51d8c4b9036$export$924db6cf10ba8696),
            (0, $cf8020dd6e5d22c9$export$9b0fdfd6a51a17de),
            (0, $cf8020dd6e5d22c9$export$6009dd8e88f1a7de),
            (0, $cf8020dd6e5d22c9$export$18226b6422149926),
            (0, $cf8020dd6e5d22c9$export$73a377380ff671af),
            (0, $cd7e3d13d091ccad$export$8dae8091f8e43b97),
            (0, $cd7e3d13d091ccad$export$748e329bd0c282a),
            (0, $63ac430661b12a63$export$2a34d21ecf479c40),
            (0, $63ac430661b12a63$export$e78b34c999194638),
            (0, $37b0d6d8034450f5$export$41fb3f2a3e68c7c3),
            (0, $37b0d6d8034450f5$export$ca77bc660994f51f),
            (0, $37b0d6d8034450f5$export$c2ec350ee9e78717),
            ...(0, $5daf430235f9fc0a$export$d604d3ad2662a845),
            (0, $907c348c7aa50cd6$export$36a7c374f4474cc1),
            (0, $805e5a863a2a14d2$export$8e015e39dbc90d0b),
            ...(0, $ffe74f439a298da1$export$f43cc215b47dd576),
            (0, $13bdc7f7e2c68d21$export$d83c2e469d070766),
            (0, (0, parcelRequire("51f7x")).globalSettingsIssuesExplicitFieldAssociationRouteEntry),
            (0, $02dde8a9c2dbcc64$export$c68a412f25295511),
            (0, $1289356c16bfcb3d$export$d1c67ceb7c5e2d6a),
            (0, $4352c9150dc3830e$export$56f9921db324f30),
            (0, $5fa74d2477541baa$export$f9891419b34ab305),
            (0, $7730befe0883f27a$export$2f65b1ec4ed05f91),
            (0, $7730befe0883f27a$export$c62ca2d3fcc552a5),
            (0, $5b81a6ea47f38625$export$34d843946d3894aa),
            (0, $5b81a6ea47f38625$export$6d18fd46547afb8e),
            (0, $774aaf4ac519071a$export$461f2b06a7a914db),
            (0, $174710657e8d90a3$export$9cc9423a3967333b),
            (0, $3f056040ba7b93df$export$717e134eb971b450),
            (0, $b3d6f3f852ae8387$export$3f8d7424a47f4dd),
            (0, $b1cb59fcc9012060$export$42ca979ec2919b23),
            (0, $b1cb59fcc9012060$export$d2ce6f09ef8aa840),
            (0, $d20ff3bf1728b112$export$e18a6be3d2ffad71),
            (0, $94bf6699a35b0833$export$5e1236665a530df4),
            (0, $a9989e069a7a91c8$export$773f8e3318be1dd5),
            (0, $ff94c4ea1a42404b$export$80a3e4dda2dcd1a4),
            ...(0, $6b03ae00f6427f42$export$b4944bd787708b82),
            (0, $5ed731e7678da2da$export$45e68d450757a753),
            (0, $cf8020dd6e5d22c9$export$ac09a8d3ecbafc5),
            (0, $cf8020dd6e5d22c9$export$9fbbaafb58999ac3),
            (0, $cf8020dd6e5d22c9$export$15f76f1b0d2d671),
            ...(0, $ffe74f439a298da1$export$189ae5546a081577),
            (0, $ffe74f439a298da1$export$2a24acea4e628148),
            (0, $ffe74f439a298da1$export$d751e3552b21c604),
            (0, $ffe74f439a298da1$export$f85a75f1604118ff),
            (0, $ffe74f439a298da1$export$9cbef73b51558ef),
            (0, $ffe74f439a298da1$export$e9cfdb950d40e917),
            (0, $ffe74f439a298da1$export$e71031acce6d7e47),
            (0, $ffe74f439a298da1$export$c2a4c5c6576a704c),
            (0, $9a93b77d562e7847$export$4f9df77811fbdc1f),
            (0, $7f9b61c89fe6f1c9$export$831e8756cdaae4ba),
            ...(0, $384a0ea22f315084$export$283761ff41b53cba),
            ...(0, $58f11685dabb370d$export$a727cbd3cbcc2153),
            (0, $b412556f032cd6c3$export$66928ab349190059),
            (0, $b412556f032cd6c3$export$2b25520e20820251),
            ...(0, $02e4c36ee22bcb25$export$80002c8e4483fef1),
            ...(0, $0cb28d0cbf2b2b29$export$5d3c7bc3dee8745d),
            (0, $82aec00f2e2dda3e$export$c058f4d1c0667ce1),
            ...(0, $6b3ff6d01c7ec3bb$export$de0b5a5b87cf45f3),
            ...(0, $784323cf5d6d6d47$export$3a28949e52d2d60f),
            (0, $0a523b5d7d04a7f3$export$f1a859c727c30be4),
            (0, $0a523b5d7d04a7f3$export$842d7c81068bb64e),
            (0, $c885df6a6405ba26$export$2c2d6115c4280a08),
            ...(0, $7ad94afcb3b299a0$export$ed40a3967b4f2617),
            (0, $cc7a94948fc6ee4a$export$ac245212b12db871),
            (0, $cc7a94948fc6ee4a$export$8657ca08ca5cbfc6),
            (0, $0b947f3e1def635b$export$fee33ca9661e49dd),
            (0, $35644870254acca5$export$c2ced436a30c60dc),
            (0, $9b4c7f67acf4fe32$export$6ff606556e19e12),
            ...(0, $7962a3c589e492de$export$cf5b5978205b681),
            ...(0, $756c00e161e435ff$export$1d5f1cc699ecefa3),
            (0, $1513c92d12ac2a7f$export$9c9bab95d425eb6f),
            (0, $47346306c864179d$export$c51a4ee3e3f1b270),
            (0, $299013a509e9e419$export$6a7fc41fb2523290),
            (0, $299013a509e9e419$export$6d6efd297963f785),
            (0, $070da13ff0ee1dfd$export$8b55e723205ec5f3),
            (0, $1a16a8f438816e9f$export$beae48175e3016b8),
            (0, $9dd385bec704f15e$export$c4c012a49b465e94),
            (0, $5ec52c3f3a973163$export$faa46f8c5e1f06d3),
            ...(0, $39416b69d8da58fe$export$633933bacdaefead),
            (0, $a13d3834c7078910$export$2af76482b576a135),
            (0, $958bcb60e3100693$export$27f123cb9320355)
        ];
    const $26bc22beafcfd5a4$var$rawRoutes = $26bc22beafcfd5a4$export$d47aca795954578();
    const $26bc22beafcfd5a4$export$2f7745f2f5ab3897 = ()=>{
        return $26bc22beafcfd5a4$var$rawRoutes;
    };
    function $26bc22beafcfd5a4$var$isPathBasedRoute(route) {
        return Boolean(route.path);
    }
    const $26bc22beafcfd5a4$export$6ca4f07048df7206 = ()=>$26bc22beafcfd5a4$export$d47aca795954578().filter($26bc22beafcfd5a4$var$isPathBasedRoute).map((0, (0, parcelRequire("anXSE")).default)).map(({ earlyAssets: earlyAssets, entryPoint: entryPoint, exact: exact, forPaint: forPaint, group: group, meta: meta, name: name, path: path, preloadOptions: preloadOptions, query: query, bifrost: bifrost })=>({
                earlyAssets: earlyAssets,
                entryPoint: entryPoint,
                exact: exact,
                forPaint: forPaint,
                group: group,
                meta: meta,
                name: name,
                path: path,
                preloadOptions: preloadOptions,
                query: query,
                bifrost: bifrost
            }));
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $fr1K2 = parcelRequire("fr1K2");
    var $3NMrl = parcelRequire("3NMrl");
    var $kUr4d = parcelRequire("kUr4d");
    function $96da41f3532a466b$export$2e2bcd8739ae039(route) {
        if (route.ufoName != null) return route.ufoName;
        return route.name;
    }
    var $0z6W8;
    var $1ciso;
    var $a0hd6;
    var $21pfT;
    var $kuiU5;
    var $hh0bW;
    var $jpY8v;
    var $4Pf62;
    var $jcw0u;
    var $8ApFP;
    const $6a69127f0604feb0$export$649804097de83b3b = [
        {
            browser: 'Chrome',
            browserVersion: '116.0.0',
            errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
        }
    ];
    const $6a69127f0604feb0$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, (0, parcelRequire("jpY8v")).getBrowser)().name === filterCriteria.browser : true;
    const $6a69127f0604feb0$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, (0, parcelRequire("jpY8v")).getBrowser)().version === filterCriteria.browserVersion : true;
    const $6a69127f0604feb0$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
    const $6a69127f0604feb0$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
        try {
            const conditionCheckers = [
                $6a69127f0604feb0$var$checkBrowserCondition,
                $6a69127f0604feb0$var$checkBrowserVersionCondition,
                $6a69127f0604feb0$var$checkErrorMessageCondition
            ];
            return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
        } catch (e) {
            return true;
        }
    };
    const $6a69127f0604feb0$export$a5c16644a2d3c205 = async (error)=>{
        const tenantContextData = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        (0, (0, parcelRequire("kuiU5")).default)(tenantContextData);
        if ($6a69127f0604feb0$export$a66ce4bea8340820(error, $6a69127f0604feb0$export$649804097de83b3b)) (0, (0, parcelRequire("hh0bW")).default)({
            analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
            experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
            wasExperienceSuccesful: false,
            location: (0, $9ccbd88c704da1ef$export$7dfef0177e883b05),
            application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
            edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
            additionalAttributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        });
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: 'jiraBootstrapSlaReporter',
                id: 'bootstrap-failure',
                teamName: 'magma'
            },
            error: error,
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        });
        throw error;
    };
    var $aTq2A;
    var $87OsA;
    parcelRequire("2YzDH");
    var $x9xyg;
    var $4Pf62;
    var $frBVt;
    var $39xOx;
    var $co1wz;
    var $7bkFJ;
    var $4R6GH;
    var $fz3fB;
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $2SVPM;
    var $erCTW;
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $7XYc4;
    var $5uXOq = parcelRequire("5uXOq");
    var $44v1T;
    const $0251eb7e80a5bbb6$export$2fcd4100c556a49e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)}) }`
            }
        });
    var $3HwlS;
    var $iqLcb;
    var $3Uek9;
    var $gk293;
    var $5M3R9;
    var $5uXOq = parcelRequire("5uXOq");
    var $jD5no;
    var $gAeCk;
    var $2SVPM;
    var $5uXOq = parcelRequire("5uXOq");
    var $fq71H;
    var $8Orxo = parcelRequire("8Orxo");
    var $1u4q7;
    var $bFU4G;
    var $9AgLs;
    function $11585d48f7363869$export$2e2bcd8739ae039(fromUfoName, nextUfoName, nextRouteName, time) {
        (0, (0, parcelRequire("9AgLs")).default).current = nextUfoName;
        const interactionId = (0, (0, parcelRequire("1u4q7")).DefaultInteractionID).current;
        if (interactionId) (0, (0, parcelRequire("bFU4G")).addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
    }
    var $x9xyg;
    var $dJl1T;
    var $39xOx;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $2SVPM;
    var $4oDnX;
    var $ajpes = parcelRequire("ajpes");
    var $65Ltd;
    var $vrkiK;
    const $f43999df472d4d05$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR);
    const $f43999df472d4d05$export$ffb8c03de895ae3 = ()=>{
        let rapidBoardPaths = [];
        return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
            let shouldReset = true;
            if ($f43999df472d4d05$var$isReplaceActionAndPIN(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
            else {
                const cleanMatch = (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(currentMatch, currentRoute);
                const cleanNextMatch = (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(nextMatch, nextRoute);
                shouldReset = !(0, ($parcel$interopDefault($ajpes)))(cleanMatch, cleanNextMatch) && shouldReset;
                if (shouldReset) {
                    const [paths, resetBoolean] = (0, (0, parcelRequire("vrkiK")).calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                    rapidBoardPaths = paths;
                    if ((0, (0, parcelRequire("vrkiK")).isValidRoute)(nextRoute) || nextRoute.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE)) shouldReset = !resetBoolean;
                }
            }
            return shouldReset;
        };
    };
    var $imS60;
    var $dIdda = parcelRequire("dIdda");
    var $gF0M5;
    var $5uXOq = parcelRequire("5uXOq");
    var $5dFS4;
    const $ff247fc2f5e84e0a$export$f2b2f5ef0b498d26 = 5000;
    const $ff247fc2f5e84e0a$export$f2c0b74311ada874 = 3;
    const $ff247fc2f5e84e0a$export$af2ff676951003fe = 60000;
    const $ff247fc2f5e84e0a$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';
    const $e970b58804722f10$export$50dbcb44bba3aa5c = 60;
    const $e970b58804722f10$export$b21f5a6e7051e2c2 = (actionMetas)=>{
        const now = Date.now();
        const timeDiff = now - actionMetas.lastPerformAttemptedAt;
        return timeDiff > $e970b58804722f10$export$50dbcb44bba3aa5c * 1000;
    };
    const $e970b58804722f10$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $ff247fc2f5e84e0a$export$f2c0b74311ada874);
    const $e970b58804722f10$export$6e0db227c9674096 = (action, metas)=>{
        const actionMetas = metas[action.id];
        if (!actionMetas) return true;
        if (!$e970b58804722f10$export$6c7cf2cb7d75fad3(actionMetas)) return false;
        if (!$e970b58804722f10$export$b21f5a6e7051e2c2(actionMetas)) return false;
        return true;
    };
    const $16f1e09eb0055102$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
        const metas = (0, (0, parcelRequire("5dFS4")).useMeta)();
        const remoteActions = (0, (0, parcelRequire("5dFS4")).useRemoteActionsData)();
        const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, (0, parcelRequire("5dFS4")).useRemoteActionsStoreActions)();
        const [actionToPerform, setActionToPerform] = (0, $5uXOq.useState)();
        const [shouldPerformAction, setShouldPerformAction] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const matchedAction = Object.values(remoteActions).find((action)=>{
                if (action.name !== actionName) return false;
                return true;
            });
            if (!matchedAction) return;
            setActionToPerform(matchedAction);
            setShouldPerformAction((0, $e970b58804722f10$export$6e0db227c9674096)(matchedAction, metas));
        }, [
            actionName,
            remoteActions,
            metas
        ]);
        const performAction = (onSuccess, onCancel)=>{
            if (!actionToPerform) return;
            const metaForAnalytics = {
                attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
                lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
            };
            if (shouldPerformAction) onSuccess(actionToPerform, metaForAnalytics);
            else onCancel(actionToPerform, metaForAnalytics);
            saveActionPerformedAttempt(actionToPerform.id);
            setShouldPerformAction(false);
        };
        return {
            shouldPerformAction: shouldPerformAction,
            performAction: performAction
        };
    };
    var $1AZST;
    var $ajpes = parcelRequire("ajpes");
    var $bCdIp;
    var $4R6GH;
    const $c27c60eec62bb2f2$var$transitionValidator = (currentMatch, nextMatch)=>{
        if (!currentMatch) return true;
        if (!nextMatch || (0, (0, parcelRequire("bCdIp")).default)() && !(0, (0, parcelRequire("4R6GH")).fg)('jira_mobile_web_infinite_redirect_fix_gate2')) return false;
        const isSameRoute = currentMatch.route === nextMatch.route;
        const isSameMatch = (0, ($parcel$interopDefault($ajpes)))(currentMatch.match, nextMatch.match);
        if (isSameRoute && isSameMatch) return true;
        const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
        if (canDoNext) return true;
        return false;
    };
    var $c27c60eec62bb2f2$export$2e2bcd8739ae039 = $c27c60eec62bb2f2$var$transitionValidator;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $dJl1T;
    var $2Ioew;
    var $frBVt;
    var $7LpuY;
    var $dZw8H;
    const $813341ccf863a0ac$var$LOCATION = 'route-entry-point-container';
    const $813341ccf863a0ac$export$fb85bbdbfb3e6869 = ()=>null;
    const $813341ccf863a0ac$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
        const entryPoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
            route
        ]);
        const entryPointReference = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48));
        const Skeleton = route.skeleton || $813341ccf863a0ac$export$fb85bbdbfb3e6869;
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData($813341ccf863a0ac$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
        }, [
            route.isRedirect,
            route.name
        ]);
        if (!entryPointReference || !entryPoint) return null;
        let pageId = route.name;
        if (route.pageId) {
            if (typeof route.pageId === 'function') pageId = route.pageId({
                route: route,
                action: action,
                location: location,
                match: match,
                query: query
            });
            else pageId = route.pageId;
        }
        return route.isRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            entryPoint: entryPoint,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
            name: "route_entry_point_redirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: {}
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LpuY")).default), {
            pageId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateContainer), {
            isGlobal: true,
            appId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateAppStartWithMatchCheck), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            entryPoint: entryPoint,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
            name: "route_entry_point"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: {}
        }))));
    };
    const $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF = 'OFF';
    const $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
    const $308f7fd68513e9ff$var$useRouterLocation = (0, $dIdda.createRouterSelector)((state)=>state.location);
    const $308f7fd68513e9ff$var$useRouterAction = (0, $dIdda.createRouterSelector)((state)=>state.action);
    const $308f7fd68513e9ff$var$useRouterQuery = (0, $dIdda.createRouterSelector)((state)=>state.query);
    const $308f7fd68513e9ff$var$useRouterRoute = (0, $dIdda.createRouterSelector)((state)=>state.route);
    const $308f7fd68513e9ff$var$useRouterMatch = (0, $dIdda.createRouterSelector)((state)=>state.match);
    const $308f7fd68513e9ff$var$useRouterRoutes = (0, $dIdda.createRouterSelector)((state)=>state.routes);
    let $308f7fd68513e9ff$var$hasPendingForceReloadAction = false;
    const $308f7fd68513e9ff$var$getRemoteActionsRolloutStage = ()=>(0, (0, parcelRequire("4R6GH")).fg)('remote_actions_-_killswitch_-_temporary') ? $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM : $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF;
    const $308f7fd68513e9ff$export$88fe66870dd8f843 = (value)=>{
        $308f7fd68513e9ff$var$hasPendingForceReloadAction = value;
    };
    const $308f7fd68513e9ff$export$39e8f9fc07dd3395 = ()=>$308f7fd68513e9ff$var$hasPendingForceReloadAction;
    const $308f7fd68513e9ff$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
            source: 'transitionBlocker',
            actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
            frontendVersion: window.BUILD_KEY,
            currentRouteName: currentRoute?.route.name || '',
            targetRouteName: targetRoute?.route.name || '',
            remoteActionsRolloutStage: $308f7fd68513e9ff$var$getRemoteActionsRolloutStage(),
            attempts: attempts,
            lastAttemptedAt: lastAttemptedAt
        });
    const $308f7fd68513e9ff$var$updateSentryBreadcrumb = (route, nextRoute)=>{
        const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
        const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
        (0, (0, parcelRequire("fq71H")).addBreadcrumb)({
            type: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
    const $308f7fd68513e9ff$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
        (0, $5uXOq.useMemo)(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/view.start');
        }, []);
        const checkShouldResetPage = (0, $5uXOq.useMemo)(()=>(0, $f43999df472d4d05$export$ffb8c03de895ae3)(), []);
        const currentMatchObjectRef = (0, $5uXOq.useRef)(initRoute);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
        }, []);
        const { registerBlock: registerBlock } = (0, $dIdda.useRouterActions)();
        const location = $308f7fd68513e9ff$var$useRouterLocation();
        const action = $308f7fd68513e9ff$var$useRouterAction();
        const query = $308f7fd68513e9ff$var$useRouterQuery();
        const route = $308f7fd68513e9ff$var$useRouterRoute();
        const match = $308f7fd68513e9ff$var$useRouterMatch();
        const routerRoutes = $308f7fd68513e9ff$var$useRouterRoutes();
        if ((0, (0, parcelRequire("gF0M5")).isLazyRouteMapExperimentEnabled)()) routes = routerRoutes;
        const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $16f1e09eb0055102$export$1bfa74483a8ca772)({
            actionName: 'forceReload'
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        if (route.isRedirect !== true) currentMatchObjectRef.current = {
            route: route,
            match: match
        };
        const [, { resetCurrentPage: resetCurrentPage }] = (0, (0, parcelRequire("4oDnX")).useSpaStateActions)();
        const transitionBlocker = (0, $5uXOq.useCallback)(async (nextLocation, nextAction)=>{
            const nextMatch = (0, $dIdda.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
            const canDo = (0, $c27c60eec62bb2f2$export$2e2bcd8739ae039)(currentMatchObjectRef.current, nextMatch);
            if ((0, (0, parcelRequire("gF0M5")).isLazyRouteMapExperimentEnabled)()) {
                if (!canDo && routes.length <= 3) await (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
                    route: nextMatch?.route.name
                });
            }
            if (!canDo) {
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
            }
            const remoteActionsRolloutStage = $308f7fd68513e9ff$var$getRemoteActionsRolloutStage();
            if (remoteActionsRolloutStage !== $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
                const currentMatch = currentMatchObjectRef.current;
                if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $308f7fd68513e9ff$var$hasPendingForceReloadAction === false) {
                    $308f7fd68513e9ff$var$hasPendingForceReloadAction = true;
                    const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                    performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                        $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                        window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
                    }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                        $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    });
                }
            }
            return canDo;
        }, [
            performAction,
            routes,
            shouldPerformAction,
            createAnalyticsEvent
        ]);
        const resetCurrentPageBeforeRouteChangeBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
            const nextMatchObject = (0, $dIdda.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
            if (nextMatchObject && match && route) {
                const { match: nextMatch, route: nextRoute } = nextMatchObject;
                const shouldReset = checkShouldResetPage({
                    nextMatch: nextMatch,
                    nextRoute: nextRoute,
                    currentMatch: match,
                    currentRoute: route,
                    action: nextAction
                });
                const nextRouteUfoName = (0, $96da41f3532a466b$export$2e2bcd8739ae039)(nextRoute);
                if (shouldReset) {
                    resetCurrentPage(nextRouteUfoName, nextRoute.name);
                    (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
                }
                const isCurrentRouteRedirecting = route.isRedirect === true;
                if (isCurrentRouteRedirecting) {
                    const currentRouteName = (0, $96da41f3532a466b$export$2e2bcd8739ae039)(route);
                    (0, $11585d48f7363869$export$2e2bcd8739ae039)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
                }
            }
            $308f7fd68513e9ff$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
            return true;
        }, [
            checkShouldResetPage,
            match,
            resetCurrentPage,
            route,
            routes
        ]);
        registerBlock(transitionBlocker);
        registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
        if (!(route && match)) return null;
        const { component: RouteComponent, meta: meta } = route;
        const entryPoint = route.entryPoint?.();
        const { reporting: reporting } = meta || {};
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "route-component"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: `routeApp.${String(route.name)}`,
            packageName: "jiraSpa",
            extraEventData: {
                routeGroup: route.group ?? '',
                isSSR: false
            },
            fallback: "page",
            sendToPrivacyUnsafeSplunk: Boolean(reporting),
            ...reporting
        }, entryPoint ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $813341ccf863a0ac$export$3e4cdfb894377bc9), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        }) : RouteComponent && (0, ($parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        })));
    };
    var $308f7fd68513e9ff$export$2e2bcd8739ae039 = $308f7fd68513e9ff$var$Spa;
    const $1f1817a083d388c8$var$onSpaShellReady = ()=>{
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
    };
    const $1f1817a083d388c8$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: "JIRA_SPA_SHELL_READY",
            onSet: $1f1817a083d388c8$var$onSpaShellReady
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $308f7fd68513e9ff$export$2e2bcd8739ae039), {
            initRoute: initRoute,
            routes: routes
        }));
    var $1f1817a083d388c8$export$2e2bcd8739ae039 = $1f1817a083d388c8$var$Spa;
    var $erBFB;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $571ff4fe4ca2a221$export$712225703044cda = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _2d3f16n6 _iu1g1fl4",
                __cmplp.className
            ])
        });
    });
    const $780b11bdb912365c$var$SPA_TRACE_KEY = 'spa';
    const $780b11bdb912365c$var$NewContent = (props)=>{
        const { isInset: isInset, hasTheming: hasTheming } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const renderContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "mainContentSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).MainContentSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "start"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1f1817a083d388c8$export$2e2bcd8739ae039), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "end"
        }));
        if (hasTheming) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gk293")).ThemedContentLayout), {
            appearance: isInset ? 'inset' : 'default'
        }, renderContent);
        return renderContent;
    };
    const $780b11bdb912365c$var$OldContent = (props)=>{
        const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const renderContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $0251eb7e80a5bbb6$export$2fcd4100c556a49e), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "mainContentSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).MainContentSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Main), {
            id: "ak-main-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "start"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1f1817a083d388c8$export$2e2bcd8739ae039), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "end"
        })));
        if (hasProjectViewNavigation) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gk293")).ProjectThemeWrapper), {
            withWhiteBackground: isInset
        }, renderContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $571ff4fe4ca2a221$export$712225703044cda), null, renderContent);
    };
    const $780b11bdb912365c$export$7c6e2c02157bb7d2 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $780b11bdb912365c$var$NewContent, $780b11bdb912365c$var$OldContent);
    const $454974e68bcf078d$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$21473105c510aacc), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), (0, $9ccbd88c704da1ef$export$7114284ca03133ee), true, true);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erCTW")).PageContainer), {
            baseUrl: baseUrl,
            id: false ? 'jira.entry.ssr' : 'spa',
            locale: locale,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$7114284ca03133ee),
            onSet: pageContainerPerformanceTiming
        }), isPrewarming !== true && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $780b11bdb912365c$export$7c6e2c02157bb7d2), {
            initRoute: initRoute,
            routes: routes
        }));
    };
    var $6jY6G;
    var $cfDZ3;
    var $5eQ1m;
    var $b7awD;
    var $81ezV;
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $6vAaw = parcelRequire("6vAaw");
    var $gccSB = parcelRequire("gccSB");
    var $6YRTH;
    var $j8DrX;
    var $dIdda = parcelRequire("dIdda");
    var $TtQEC;
    const $751334a79f9a31ee$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
    const $751334a79f9a31ee$var$getHead = ()=>document.head || document.querySelector('head');
    const $751334a79f9a31ee$export$c79fd820617d7f = (name, content)=>{
        if (!name || !content) return;
        const existingMeta = $751334a79f9a31ee$export$c9d44c736471c518(name);
        const meta = document.createElement('meta');
        meta.name = name;
        meta.content = content;
        if (existingMeta) existingMeta.parentNode?.replaceChild(existingMeta, meta);
        else {
            const head = $751334a79f9a31ee$var$getHead();
            if (head) head.appendChild(meta);
        }
    };
    const $751334a79f9a31ee$export$4267657a25105d9d = (name)=>{
        const meta = $751334a79f9a31ee$export$c9d44c736471c518(name);
        if (meta) meta.parentNode?.removeChild(meta);
    };
    var $5Jsi2;
    const $fffa056866f763fb$var$sessionQueryParams = [
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ];
    const $fffa056866f763fb$var$sessionMeta = [
        'ajs-search-session-id',
        'ajs-search-object-id',
        'ajs-search-container-id',
        'ajs-search-content-type'
    ];
    const $fffa056866f763fb$var$removeDwellComponent = (placeholderId)=>{
        if (placeholderId && document.getElementById(placeholderId)) (0, $7nsd3.unmountComponentAtNode)(document.getElementById(placeholderId));
    };
    const $fffa056866f763fb$var$removeSessionMeta = ()=>$fffa056866f763fb$var$sessionMeta.forEach((0, $751334a79f9a31ee$export$4267657a25105d9d));
    const $fffa056866f763fb$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
        const newMeta = {
            'ajs-search-session-id': sessionId,
            'ajs-search-object-id': objectId,
            'ajs-search-container-id': containerId,
            'ajs-search-content-type': objectType
        };
        Object.entries(newMeta).forEach(([name, content])=>(0, $751334a79f9a31ee$export$c79fd820617d7f)(name, content));
    };
    const $fffa056866f763fb$var$getPreviousSessionId = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-search-session-id');
    class $fffa056866f763fb$export$f1e582dddb502dd6 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.onClearSessionEvent = ()=>{
                if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                    shouldRemoveSessionBeIgnored: false
                });
            };
            this.onHistoryChange = (location)=>{
                $fffa056866f763fb$var$removeDwellComponent('search-dwell-time');
                const parsedUrl = (0, ($parcel$interopDefault($6vAaw))).parse(location.pathname + location.search, true);
                const queryString = parsedUrl.query || {};
                const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
                const { path: path } = parsedUrl;
                const previousSessionId = $fffa056866f763fb$var$getPreviousSessionId();
                const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
                if (!(0, ($parcel$interopDefault($gccSB)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $fffa056866f763fb$var$removeSessionMeta();
                if (searchSessionId) {
                    (0, (0, parcelRequire("6YRTH")).default)($fffa056866f763fb$var$sessionQueryParams);
                    const newState = {
                        sessionId: searchSessionId,
                        objectId: searchObjectId,
                        objectType: searchContentType,
                        containerId: searchContainerId,
                        previousSessionId: $fffa056866f763fb$var$getPreviousSessionId()
                    };
                    $fffa056866f763fb$var$addSessionMeta(newState);
                    const shouldRemoveSession = !!(0, (0, parcelRequire("5Jsi2")).skipClearSessionURLs).find((skipUrlRegex)=>!(0, ($parcel$interopDefault($gccSB)))(path) ? skipUrlRegex.test(path) : false);
                    this.setState({
                        ...newState,
                        shouldRemoveSessionBeIgnored: shouldRemoveSession
                    });
                }
            };
            this.props.history.listen(this.onHistoryChange);
            this.state = {
                shouldRemoveSessionBeIgnored: false,
                sessionId: ''
            };
        }
        componentDidMount() {
            window.addEventListener((0, (0, parcelRequire("5Jsi2")).CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
        }
        componentWillUnmount() {
            window.removeEventListener((0, (0, parcelRequire("5Jsi2")).CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
        }
        render() {
            if (this.state && this.state.sessionId) {
                const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
                const data = {
                    objectId: objectId,
                    containerId: containerId,
                    objectType: objectType,
                    source: objectType,
                    actionSubject: objectType,
                    attributes: {
                        previousSessionId: previousSessionId
                    }
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TtQEC")).default), {
                    sessionId: sessionId,
                    data: data
                });
            }
            return null;
        }
    }
    var $fffa056866f763fb$export$2e2bcd8739ae039 = (0, $dIdda.withRouter)($fffa056866f763fb$export$f1e582dddb502dd6);
    var $2SVPM;
    var $2SVPM;
    const $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed = ()=>{
        if (false) return;
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/common-preload', 'ssr.spa.early-common-flush:start', 'ssr.spa.metatags:start');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts', 'ssr.spa.feature-flags:end', 'ssr.spa.early-common-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    };
    var $bShz7;
    var $dJl1T;
    var $dIdda = parcelRequire("dIdda");
    const $ab2f047cd976509c$var$LOCATION = 'spa.create-spa-history';
    const $ab2f047cd976509c$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
            const matchedRoute = (0, $dIdda.matchRoute)(currentRoutes, history.location.pathname, history.location.search);
            if (!matchedRoute) return ()=>{};
            if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
            return ()=>{
                const idx = routeBlockFns.indexOf(blockFn);
                if (idx !== -1) routeBlockFns.splice(idx, 1);
            };
        };
    const $ab2f047cd976509c$var$createSpaHistory = (initialRoutes)=>{
        const routeBlockFns = [];
        let blockArgs = [];
        let nextMatchedRoute;
        const currentRoutes = initialRoutes;
        const history = (0, $dIdda.createBrowserHistory)({
            getUserConfirmation: async (__, done)=>{
                try {
                    const matchedRoute = (0, $dIdda.matchRoute)(currentRoutes, history.location.pathname, history.location.search);
                    if (!matchedRoute || !nextMatchedRoute) return done(true);
                    for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                        const result = await routeBlockFns[i](...blockArgs);
                        if (result === false) return done(false);
                    }
                    routeBlockFns.length = 0;
                    return done(true);
                } catch (err) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($ab2f047cd976509c$var$LOCATION, 'Error with getUserConfirmation', err);
                    return done(true);
                }
            }
        });
        history.refreshRoutes = (newRoutes)=>{
            currentRoutes.length = 0;
            currentRoutes.push(...newRoutes);
            routeBlockFns.length = 0;
        };
        history.block((location, action)=>{
            blockArgs = [
                location,
                action
            ];
            nextMatchedRoute = (0, $dIdda.matchRoute)(currentRoutes, location.pathname, location.search);
            return '';
        });
        history.block = $ab2f047cd976509c$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
        return history;
    };
    var $ab2f047cd976509c$export$2e2bcd8739ae039 = (routes)=>$ab2f047cd976509c$var$createSpaHistory(routes);
    var $5HG6S;
    var $kKlrY;
    var $l8ruj;
    var $3qHVS;
    var $lGgkA;
    var $ddkdN;
    var $dIdda = parcelRequire("dIdda");
    var $lODMY;
    var $1AZST;
    var $2ChuC = parcelRequire("2ChuC");
    const $2f70583cb46f9994$var$isPreprodSlow = ()=>(0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('uip.preprod.slow', 0);
    (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_LOADED');
    window.__SPA__ = true;
    (0, (0, parcelRequire("lGgkA")).LooselyLazy).init({
        mode: (0, (0, parcelRequire("ddkdN")).MODE).RENDER,
        crossOrigin: 'anonymous'
    });
    const $2f70583cb46f9994$var$tenantContext = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
    (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/language-pack.start');
    var $hWnRN = parcelRequire("hWnRN");
    (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/language-pack.end');
    const { locale: $2f70583cb46f9994$var$locale } = $2f70583cb46f9994$var$tenantContext;
    const $2f70583cb46f9994$var$superbatchInit = ()=>{
        window.DeferScripts = {
            deferState: 'done'
        };
        document.body && document.body.classList.remove('deferred');
    };
    const $2f70583cb46f9994$var$globalSettingsArgs = {
        navigation: false,
        upflow: false
    };
    const $2f70583cb46f9994$var$InstallGlobalComponentsOnce = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            (0, $2ChuC.default).installLowPriorityApps((0, ($parcel$interopDefault($fr1K2)))($2f70583cb46f9994$var$globalSettingsArgs, [
                'flags',
                'navigation',
                'renderNavigation'
            ]));
            (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
        }, []);
        return null;
    };
    const $2f70583cb46f9994$var$updateCapability = (capability)=>{
        (0, (0, parcelRequire("87OsA")).setCapability)(capability);
        if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $281cbd47ba46dd7d$export$9a80695e72849f84]) delete window.AJS.$.ajaxSettings.headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84];
        else window.AJS?.$?.ajaxSetup({
            headers: {
                [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: capability
            }
        });
    };
    const $2f70583cb46f9994$var$CapabilityTrackerConnector = ({ routes: routes })=>{
        const { registerBlock: registerBlock } = (0, $dIdda.useRouterActions)();
        registerBlock((nextLocation)=>{
            const nextMatchObject = (0, $dIdda.matchRoute)(routes, nextLocation.pathname, nextLocation.search, '');
            $2f70583cb46f9994$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
            return true;
        });
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        $2f70583cb46f9994$var$updateCapability(route.meta?.capability || null);
        return null;
    };
    const $2f70583cb46f9994$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
        (0, (0, parcelRequire("kKlrY")).default)();
        (0, (0, parcelRequire("aTq2A")).initBrowserMetrics3)();
        (0, (0, parcelRequire("7bkFJ")).initPlatformFeatureFlags)((0, (0, parcelRequire("3qHVS")).visualRefreshResolverOverride));
        (0, $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed)();
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
        (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/setup.start');
        const routes = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
        const history = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $ab2f047cd976509c$export$2e2bcd8739ae039)(routes));
        const initRoute = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
            const matchedRoute = (0, $dIdda.matchRoute)(routes, window.location.pathname, window.location.search);
            (0, (0, parcelRequire("cfDZ3")).setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
            return matchedRoute;
        });
        if (initRoute != null) {
            const ufoName = (0, $96da41f3532a466b$export$2e2bcd8739ae039)(initRoute.route);
            (0, (0, parcelRequire("0z6W8")).default)(ufoName, initRoute.route.name);
        }
        const BrowserMetricsConnector = ()=>{
            const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
            (0, (0, parcelRequire("21pfT")).browserMetrics).setRoute(route.name);
            (0, (0, parcelRequire("1ciso")).useUFOTransitionCompleter)();
            if ((0, (0, parcelRequire("co1wz")).ff)('uip.ufo')) (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
            return null;
        };
        if ((0, (0, parcelRequire("co1wz")).ff)('uip.ufo')) (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
        const routerProps = {
            history: history,
            routes: routes,
            basePath: '',
            initialRoute: initRoute?.route,
            resourceData: window.SPA_STATE,
            resourceContext: (0, (0, parcelRequire("5HG6S")).getSpaRouterContext)({
                tenantContext: $2f70583cb46f9994$var$tenantContext
            }),
            onPrefetch: ({ route: route, match: match })=>{
                (0, (0, parcelRequire("bShz7")).setPrefetchStartMark)(match);
                if (!route.forPaint) return;
                route.forPaint.map((component)=>component.preload && component.preload());
            }
        };
        let SpaClientRouter;
        if (typeof loadLazyRoutes === 'function') {
            const useRouterRoutes = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.routes);
            SpaClientRouter = ({ children: children })=>{
                const actions = (0, (0, parcelRequire("lODMY")).useRouterStoreActions)();
                const currentRoutes = useRouterRoutes();
                (0, $5uXOq.useEffect)(()=>{
                    let isCancelled = false;
                    const loadRoutes = async ()=>{
                        if (!isCancelled) {
                            const getLazyRoutes = await loadLazyRoutes();
                            await actions.setRoutes(getLazyRoutes());
                        }
                    };
                    loadRoutes();
                    return ()=>{
                        isCancelled = true;
                    };
                }, [
                    actions
                ]);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b7awD")).Router), routerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                    id: "spa-main.client-router",
                    packageName: "jiraEntry",
                    fallback: "unmount",
                    teamName: "delorean-spa"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
                    routes: currentRoutes
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fffa056866f763fb$export$2e2bcd8739ae039), null)), children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fz3fB")).NonCritical), {
                    id: "spa-main.client-router.non-critical",
                    teamName: "delorean-spa"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
            };
        } else SpaClientRouter = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b7awD")).Router), routerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
                routes: routes
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fffa056866f763fb$export$2e2bcd8739ae039), null)), children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fz3fB")).NonCritical), {
                id: "spa-main.client-router.non-critical",
                teamName: "delorean-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
        const App = ({ placeholders: placeholders })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
                name: "jira-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholderContext).Provider, {
                value: placeholders
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $454974e68bcf078d$export$6d4069f4b64f7492), {
                baseUrl: "",
                locale: $2f70583cb46f9994$var$locale,
                messages: $hWnRN,
                Router: SpaClientRouter,
                initRoute: initRoute,
                routes: routes,
                routerLinkComponent: (0, (0, parcelRequire("81ezV")).JiraRouterLinkConfiguration)
            }))));
        window.__NAV_VERSION__ = '3.0.0';
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
        (0, (0, parcelRequire("x9xyg")).setMark)('_jira-spa/spa-shell.start');
        const container = document.getElementById('jira-frontend');
        if (container) {
            if ((0, (0, parcelRequire("co1wz")).ff)('uip.vc.partial', false)) {
                (0, (0, parcelRequire("a0hd6")).getVCObserver)().setSSRElement(container);
                (0, (0, parcelRequire("a0hd6")).getVCObserver)().setReactRootRenderStart();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        (0, (0, parcelRequire("a0hd6")).getVCObserver)().setReactRootRenderStop();
                    });
                });
            }
            const placeholders = (0, (0, parcelRequire("frBVt")).getPlaceholdersFromHTML)();
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-concurrent-root-jira-spa') && true) (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement(App, {
                placeholders: placeholders
            }), container);
            if ((0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-concurrent-root-jira-spa')) {
                const root = (0, $kUr4d.createRoot)(container);
                root.render((0, ($parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }));
            }
        }
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
        (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
        setTimeout(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
        });
        if ($2f70583cb46f9994$var$isPreprodSlow() > 0) {
            (0, (0, parcelRequire("x9xyg")).setMark)('slow-start');
            const end = performance.now() + $2f70583cb46f9994$var$isPreprodSlow();
            while(performance.now() < end);
            (0, (0, parcelRequire("x9xyg")).setMark)('slow-stop');
        }
        (0, $2ChuC.default).installHighPriorityApps((0, ($parcel$interopDefault($3NMrl)))($2f70583cb46f9994$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        $2f70583cb46f9994$var$superbatchInit();
        return null;
    };
    const $2f70583cb46f9994$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
        return $2f70583cb46f9994$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>(0, $6a69127f0604feb0$export$a5c16644a2d3c205)(reason));
    };
    (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_LOADED');
    (0, $2f70583cb46f9994$export$f71867a5b2484020)((0, $26bc22beafcfd5a4$export$2f7745f2f5ab3897));
}, [
    "eNmuD",
    "dsiAd",
    "hPzOn",
    "2Lfdl",
    "1QYl5",
    "561Jq",
    "i5RRW",
    "92sUi",
    "kWrFZ",
    "bYT2S",
    "h2MrD",
    "fr9NE",
    "cM9em",
    "1WmWM"
]);
$parcel$global.rlb("jfj4N");
